
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6da0"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6da0"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9fhap", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $6bb2d4c7963fe6c1$export$ffb0004e005737fa; }, function (v) { return $6bb2d4c7963fe6c1$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $6bb2d4c7963fe6c1$export$34b9dba7ce09269b; }, function (v) { return $6bb2d4c7963fe6c1$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $6bb2d4c7963fe6c1$export$25062201e9e25d76; }, function (v) { return $6bb2d4c7963fe6c1$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6bb2d4c7963fe6c1$export$ffb0004e005737fa;
var $6bb2d4c7963fe6c1$export$34b9dba7ce09269b;
var $6bb2d4c7963fe6c1$export$25062201e9e25d76;
"use strict";
var $6bb2d4c7963fe6c1$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $6bb2d4c7963fe6c1$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $6bb2d4c7963fe6c1$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $6bb2d4c7963fe6c1$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$6bb2d4c7963fe6c1$export$ffb0004e005737fa = $6bb2d4c7963fe6c1$var$REACT_FRAGMENT_TYPE;
$6bb2d4c7963fe6c1$export$34b9dba7ce09269b = $6bb2d4c7963fe6c1$var$jsxProd;
$6bb2d4c7963fe6c1$export$25062201e9e25d76 = $6bb2d4c7963fe6c1$var$jsxProd;

});

parcelRegister("1zEgY", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $12584cae6930e094$export$882461b6382ed46c; }, function (v) { return $12584cae6930e094$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $12584cae6930e094$export$757ceba2d55c277e; }, function (v) { return $12584cae6930e094$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "version", function () { return $12584cae6930e094$export$83d89fbfd8236492; }, function (v) { return $12584cae6930e094$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $12584cae6930e094$export$882461b6382ed46c;
var $12584cae6930e094$export$757ceba2d55c277e;
var $12584cae6930e094$export$83d89fbfd8236492;
"use strict";

var $8IBEr = parcelRequire("8IBEr");

var $lCzvA = parcelRequire("lCzvA");

var $dAQd3 = parcelRequire("dAQd3");
function $12584cae6930e094$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $12584cae6930e094$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $12584cae6930e094$var$getNearestMountedFiber(fiber) {
    for(var node = fiber, nextNode = node; nextNode && !nextNode.alternate;)node = nextNode, 0 !== (node.flags & 4098) && (fiber = node.return), nextNode = node.return;
    for(; node.return;)node = node.return;
    return 3 === node.tag ? fiber : null;
}
function $12584cae6930e094$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $12584cae6930e094$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $12584cae6930e094$var$assertIsMounted(fiber) {
    if ($12584cae6930e094$var$getNearestMountedFiber(fiber) !== fiber) throw Error($12584cae6930e094$var$formatProdErrorMessage(188));
}
function $12584cae6930e094$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $12584cae6930e094$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($12584cae6930e094$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $12584cae6930e094$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $12584cae6930e094$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($12584cae6930e094$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($12584cae6930e094$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($12584cae6930e094$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($12584cae6930e094$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $12584cae6930e094$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $12584cae6930e094$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
function $12584cae6930e094$var$traverseVisibleInstancesAndTextInstances(child, searchWithinHosts, fn, a, b, c) {
    for(; null !== child;){
        if ((5 === child.tag || 27 === child.tag || 6 === child.tag) && fn(child, a, b, c) || (22 !== child.tag || null === child.memoizedState) && (searchWithinHosts || 5 !== child.tag && 27 !== child.tag) && $12584cae6930e094$var$traverseVisibleInstancesAndTextInstances(child.child, searchWithinHosts, fn, a, b, c)) return !0;
        child = child.sibling;
    }
    return !1;
}
function $12584cae6930e094$var$getFragmentParentInstanceOrContainerFiber(fiber) {
    for(fiber = fiber.return; null !== fiber;){
        if (3 === fiber.tag || 5 === fiber.tag || 27 === fiber.tag) return fiber;
        fiber = fiber.return;
    }
    return null;
}
function $12584cae6930e094$var$fiberIsPortaledIntoHost(fiber) {
    var foundPortalParent = !1;
    for(fiber = fiber.return; null !== fiber;){
        4 === fiber.tag && (foundPortalParent = !0);
        if (3 === fiber.tag || 5 === fiber.tag || 27 === fiber.tag) break;
        fiber = fiber.return;
    }
    return foundPortalParent;
}
function $12584cae6930e094$var$getFragmentInstanceOrTextInstanceSiblings(fiber) {
    var result = [
        null,
        null
    ], parentHostFiber = $12584cae6930e094$var$getFragmentParentInstanceOrContainerFiber(fiber);
    if (null === parentHostFiber) return result;
    $12584cae6930e094$var$findFragmentInstanceOrTextInstanceSiblings(result, fiber, parentHostFiber.child, {
        foundSelf: !1
    });
    return result;
}
function $12584cae6930e094$var$findFragmentInstanceOrTextInstanceSiblings(result, self, child, state) {
    for(; null !== child;){
        if (child === self) state.foundSelf = !0;
        else if (5 === child.tag || 27 === child.tag || 6 === child.tag) {
            if (state.foundSelf) return result[1] = child, !0;
            result[0] = child;
        } else if ((22 !== child.tag || null === child.memoizedState) && $12584cae6930e094$var$findFragmentInstanceOrTextInstanceSiblings(result, self, child.child, state)) return !0;
        child = child.sibling;
    }
    return !1;
}
function $12584cae6930e094$var$getInstanceFromHostFiber(fiber) {
    switch(fiber.tag){
        case 5:
        case 27:
        case 6:
            return fiber.stateNode;
        case 3:
            return fiber.stateNode.containerInfo;
        default:
            throw Error($12584cae6930e094$var$formatProdErrorMessage(559));
    }
}
var $12584cae6930e094$var$searchTarget = null, $12584cae6930e094$var$searchBoundary = null;
function $12584cae6930e094$var$isFiberPrecedingCheck(child, target, boundary) {
    return child === boundary ? !0 : child === target ? ($12584cae6930e094$var$searchTarget = child, !0) : !1;
}
function $12584cae6930e094$var$isFiberFollowingCheck(child, target, boundary) {
    return child === boundary ? ($12584cae6930e094$var$searchBoundary = child, !1) : child === target ? (null !== $12584cae6930e094$var$searchBoundary && ($12584cae6930e094$var$searchTarget = child), !0) : !1;
}
function $12584cae6930e094$var$getParentForFragmentAncestors(inst) {
    if (null === inst) return null;
    do inst = null === inst ? null : inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag && 3 !== inst.tag);
    return inst ? inst : null;
}
function $12584cae6930e094$var$getLowestCommonAncestor(instA, instB, getParent) {
    for(var depthA = 0, tempA = instA; tempA; tempA = getParent(tempA))depthA++;
    tempA = 0;
    for(var tempB = instB; tempB; tempB = getParent(tempB))tempA++;
    for(; 0 < depthA - tempA;)instA = getParent(instA), depthA--;
    for(; 0 < tempA - depthA;)instB = getParent(instB), tempA--;
    for(; depthA--;){
        if (instA === instB || null !== instB && instA === instB.alternate) return instA;
        instA = getParent(instA);
        instB = getParent(instB);
    }
    return null;
}
var $12584cae6930e094$var$assign = Object.assign, $12584cae6930e094$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $12584cae6930e094$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $12584cae6930e094$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $12584cae6930e094$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $12584cae6930e094$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $12584cae6930e094$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $12584cae6930e094$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $12584cae6930e094$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $12584cae6930e094$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $12584cae6930e094$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $12584cae6930e094$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $12584cae6930e094$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $12584cae6930e094$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $12584cae6930e094$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $12584cae6930e094$var$REACT_LEGACY_HIDDEN_TYPE = Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $12584cae6930e094$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel"), $12584cae6930e094$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $12584cae6930e094$var$REACT_RECOVERABLE_TYPE = Symbol.for("react.recoverable"), $12584cae6930e094$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $12584cae6930e094$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $12584cae6930e094$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$12584cae6930e094$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $12584cae6930e094$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $12584cae6930e094$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $12584cae6930e094$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $12584cae6930e094$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $12584cae6930e094$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $12584cae6930e094$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $12584cae6930e094$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $12584cae6930e094$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $12584cae6930e094$var$REACT_ACTIVITY_TYPE:
            return "Activity";
        case $12584cae6930e094$var$REACT_VIEW_TRANSITION_TYPE:
            return "ViewTransition";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $12584cae6930e094$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $12584cae6930e094$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $12584cae6930e094$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $12584cae6930e094$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $12584cae6930e094$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $12584cae6930e094$var$getComponentNameFromType(type.type) || "Memo";
        case $12584cae6930e094$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $12584cae6930e094$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $12584cae6930e094$var$isArrayImpl = Array.isArray, $12584cae6930e094$var$ReactSharedInternals = $lCzvA.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $12584cae6930e094$var$ReactDOMSharedInternals = $dAQd3.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $12584cae6930e094$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $12584cae6930e094$var$valueStack = [], $12584cae6930e094$var$index = -1;
function $12584cae6930e094$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $12584cae6930e094$var$pop(cursor) {
    0 > $12584cae6930e094$var$index || (cursor.current = $12584cae6930e094$var$valueStack[$12584cae6930e094$var$index], $12584cae6930e094$var$valueStack[$12584cae6930e094$var$index] = null, $12584cae6930e094$var$index--);
}
function $12584cae6930e094$var$push(cursor, value) {
    $12584cae6930e094$var$index++;
    $12584cae6930e094$var$valueStack[$12584cae6930e094$var$index] = cursor.current;
    cursor.current = value;
}
var $12584cae6930e094$var$contextStackCursor = $12584cae6930e094$var$createCursor(null), $12584cae6930e094$var$contextFiberStackCursor = $12584cae6930e094$var$createCursor(null), $12584cae6930e094$var$rootInstanceStackCursor = $12584cae6930e094$var$createCursor(null), $12584cae6930e094$var$hostTransitionProviderCursor = $12584cae6930e094$var$createCursor(null);
function $12584cae6930e094$var$pushHostContainer(fiber, nextRootInstance) {
    $12584cae6930e094$var$push($12584cae6930e094$var$rootInstanceStackCursor, nextRootInstance);
    $12584cae6930e094$var$push($12584cae6930e094$var$contextFiberStackCursor, fiber);
    $12584cae6930e094$var$push($12584cae6930e094$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $12584cae6930e094$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $12584cae6930e094$var$getOwnHostContext(nextRootInstance), fiber = $12584cae6930e094$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $12584cae6930e094$var$pop($12584cae6930e094$var$contextStackCursor);
    $12584cae6930e094$var$push($12584cae6930e094$var$contextStackCursor, fiber);
}
function $12584cae6930e094$var$popHostContainer() {
    $12584cae6930e094$var$pop($12584cae6930e094$var$contextStackCursor);
    $12584cae6930e094$var$pop($12584cae6930e094$var$contextFiberStackCursor);
    $12584cae6930e094$var$pop($12584cae6930e094$var$rootInstanceStackCursor);
}
function $12584cae6930e094$var$pushHostContext(fiber) {
    var stateHook = fiber.memoizedState;
    null !== stateHook && ($12584cae6930e094$var$HostTransitionContext._currentValue = stateHook.memoizedState, $12584cae6930e094$var$push($12584cae6930e094$var$hostTransitionProviderCursor, fiber));
    stateHook = $12584cae6930e094$var$contextStackCursor.current;
    var JSCompiler_inline_result = $12584cae6930e094$var$getChildHostContextProd(stateHook, fiber.type);
    stateHook !== JSCompiler_inline_result && ($12584cae6930e094$var$push($12584cae6930e094$var$contextFiberStackCursor, fiber), $12584cae6930e094$var$push($12584cae6930e094$var$contextStackCursor, JSCompiler_inline_result));
}
function $12584cae6930e094$var$popHostContext(fiber) {
    $12584cae6930e094$var$contextFiberStackCursor.current === fiber && ($12584cae6930e094$var$pop($12584cae6930e094$var$contextStackCursor), $12584cae6930e094$var$pop($12584cae6930e094$var$contextFiberStackCursor));
    $12584cae6930e094$var$hostTransitionProviderCursor.current === fiber && ($12584cae6930e094$var$pop($12584cae6930e094$var$hostTransitionProviderCursor), $12584cae6930e094$var$HostTransitionContext._currentValue = $12584cae6930e094$var$sharedNotPendingObject);
}
var $12584cae6930e094$var$prefix, $12584cae6930e094$var$suffix;
function $12584cae6930e094$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $12584cae6930e094$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $12584cae6930e094$var$prefix = match && match[1] || "";
        $12584cae6930e094$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $12584cae6930e094$var$prefix + name + $12584cae6930e094$var$suffix;
}
var $12584cae6930e094$var$reentry = !1;
function $12584cae6930e094$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $12584cae6930e094$var$reentry) return "";
    $12584cae6930e094$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            Fake = !1;
                            try {
                                var prevProps = Object.getOwnPropertyDescriptor(fn.prototype, "props");
                                Object.defineProperty(fn.prototype, "props", {
                                    configurable: !0,
                                    set: function() {
                                        throw Error();
                                    }
                                });
                                Fake = !0;
                                new fn();
                            } finally{
                                Fake && (void 0 !== prevProps ? Object.defineProperty(fn.prototype, "props", prevProps) : delete fn.prototype.props);
                            }
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $12584cae6930e094$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $12584cae6930e094$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $12584cae6930e094$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $12584cae6930e094$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $12584cae6930e094$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $12584cae6930e094$var$describeBuiltInComponentFrame("Suspense Fallback") : $12584cae6930e094$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $12584cae6930e094$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $12584cae6930e094$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $12584cae6930e094$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $12584cae6930e094$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $12584cae6930e094$var$describeBuiltInComponentFrame("Activity");
        case 30:
            return $12584cae6930e094$var$describeBuiltInComponentFrame("ViewTransition");
        default:
            return "";
    }
}
function $12584cae6930e094$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $12584cae6930e094$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $12584cae6930e094$var$hasOwnProperty = Object.prototype.hasOwnProperty, $12584cae6930e094$var$scheduleCallback$3 = $8IBEr.unstable_scheduleCallback, $12584cae6930e094$var$cancelCallback$1 = $8IBEr.unstable_cancelCallback, $12584cae6930e094$var$shouldYield = $8IBEr.unstable_shouldYield, $12584cae6930e094$var$requestPaint = $8IBEr.unstable_requestPaint, $12584cae6930e094$var$now = $8IBEr.unstable_now, $12584cae6930e094$var$getCurrentPriorityLevel = $8IBEr.unstable_getCurrentPriorityLevel, $12584cae6930e094$var$ImmediatePriority = $8IBEr.unstable_ImmediatePriority, $12584cae6930e094$var$UserBlockingPriority = $8IBEr.unstable_UserBlockingPriority, $12584cae6930e094$var$NormalPriority$1 = $8IBEr.unstable_NormalPriority, $12584cae6930e094$var$LowPriority = $8IBEr.unstable_LowPriority, $12584cae6930e094$var$IdlePriority = $8IBEr.unstable_IdlePriority, $12584cae6930e094$var$log$1 = $8IBEr.log, $12584cae6930e094$var$unstable_setDisableYieldValue = $8IBEr.unstable_setDisableYieldValue, $12584cae6930e094$var$rendererID = null, $12584cae6930e094$var$injectedHook = null;
function $12584cae6930e094$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $12584cae6930e094$var$log$1 && $12584cae6930e094$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($12584cae6930e094$var$injectedHook && "function" === typeof $12584cae6930e094$var$injectedHook.setStrictMode) try {
        $12584cae6930e094$var$injectedHook.setStrictMode($12584cae6930e094$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $12584cae6930e094$var$clz32 = Math.clz32 ? Math.clz32 : $12584cae6930e094$var$clz32Fallback, $12584cae6930e094$var$log = Math.log, $12584cae6930e094$var$LN2 = Math.LN2;
function $12584cae6930e094$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($12584cae6930e094$var$log(x) / $12584cae6930e094$var$LN2 | 0) | 0;
}
var $12584cae6930e094$var$nextTransitionUpdateLane = 256, $12584cae6930e094$var$nextTransitionDeferredLane = 262144, $12584cae6930e094$var$nextRetryLane = 4194304;
function $12584cae6930e094$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & -lanes;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $12584cae6930e094$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $12584cae6930e094$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $12584cae6930e094$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $12584cae6930e094$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $12584cae6930e094$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $12584cae6930e094$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $12584cae6930e094$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $12584cae6930e094$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $12584cae6930e094$var$getEntangledLanes(root, renderLanes) {
    0 !== (renderLanes & 8) && (renderLanes |= renderLanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= renderLanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $12584cae6930e094$var$clz32(allEntangledLanes), lane = 1 << index$4;
        renderLanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    return renderLanes;
}
function $12584cae6930e094$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $12584cae6930e094$var$claimNextRetryLane() {
    var lane = $12584cae6930e094$var$nextRetryLane;
    $12584cae6930e094$var$nextRetryLane <<= 1;
    0 === ($12584cae6930e094$var$nextRetryLane & 62914560) && ($12584cae6930e094$var$nextRetryLane = 4194304);
    return lane;
}
function $12584cae6930e094$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $12584cae6930e094$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $12584cae6930e094$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $12584cae6930e094$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $12584cae6930e094$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $12584cae6930e094$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $12584cae6930e094$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $12584cae6930e094$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $12584cae6930e094$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $12584cae6930e094$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $12584cae6930e094$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $12584cae6930e094$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $12584cae6930e094$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $12584cae6930e094$var$resolveUpdatePriority() {
    var updatePriority = $12584cae6930e094$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $12584cae6930e094$var$getEventPriority(updatePriority.type);
}
function $12584cae6930e094$var$runWithPriority(priority, fn) {
    var previousPriority = $12584cae6930e094$var$ReactDOMSharedInternals.p;
    try {
        return $12584cae6930e094$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $12584cae6930e094$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $12584cae6930e094$var$randomKey = Math.random().toString(36).slice(2), $12584cae6930e094$var$internalInstanceKey = "__reactFiber$" + $12584cae6930e094$var$randomKey, $12584cae6930e094$var$internalPropsKey = "__reactProps$" + $12584cae6930e094$var$randomKey, $12584cae6930e094$var$internalContainerInstanceKey = "__reactContainer$" + $12584cae6930e094$var$randomKey, $12584cae6930e094$var$internalEventHandlersKey = "__reactEvents$" + $12584cae6930e094$var$randomKey, $12584cae6930e094$var$internalEventHandlerListenersKey = "__reactListeners$" + $12584cae6930e094$var$randomKey, $12584cae6930e094$var$internalEventHandlesSetKey = "__reactHandles$" + $12584cae6930e094$var$randomKey, $12584cae6930e094$var$internalRootNodeResourcesKey = "__reactResources$" + $12584cae6930e094$var$randomKey, $12584cae6930e094$var$internalHoistableMarker = "__reactMarker$" + $12584cae6930e094$var$randomKey, $12584cae6930e094$var$internalLoadPendingKey = "__reactLoad$" + $12584cae6930e094$var$randomKey;
function $12584cae6930e094$var$detachDeletedInstance(node) {
    delete node[$12584cae6930e094$var$internalInstanceKey];
    delete node[$12584cae6930e094$var$internalPropsKey];
    delete node[$12584cae6930e094$var$internalEventHandlerListenersKey];
    delete node[$12584cae6930e094$var$internalEventHandlesSetKey];
}
function $12584cae6930e094$var$getClosestInstanceFromNode(targetNode) {
    var targetInst;
    if (targetInst = targetNode[$12584cae6930e094$var$internalInstanceKey]) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$12584cae6930e094$var$internalContainerInstanceKey] || parentNode[$12584cae6930e094$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $12584cae6930e094$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$12584cae6930e094$var$internalInstanceKey]) return parentNode;
                targetNode = $12584cae6930e094$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $12584cae6930e094$var$getInstanceFromNode(node) {
    if (node = node[$12584cae6930e094$var$internalInstanceKey] || node[$12584cae6930e094$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $12584cae6930e094$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($12584cae6930e094$var$formatProdErrorMessage(33));
}
function $12584cae6930e094$var$getResourcesFromRoot(root) {
    var resources = root[$12584cae6930e094$var$internalRootNodeResourcesKey];
    resources || (resources = root[$12584cae6930e094$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $12584cae6930e094$var$markNodeAsHoistable(node) {
    node[$12584cae6930e094$var$internalHoistableMarker] = !0;
}
function $12584cae6930e094$var$clearPendingLoadOnNode(node) {
    node[$12584cae6930e094$var$internalLoadPendingKey] = void 0;
}
var $12584cae6930e094$var$allNativeEvents = new Set(), $12584cae6930e094$var$registrationNameDependencies = {};
function $12584cae6930e094$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $12584cae6930e094$var$registerDirectEvent(registrationName, dependencies);
    $12584cae6930e094$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $12584cae6930e094$var$registerDirectEvent(registrationName, dependencies) {
    $12584cae6930e094$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$12584cae6930e094$var$allNativeEvents.add(dependencies[registrationName]);
}
var $12584cae6930e094$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $12584cae6930e094$var$illegalAttributeNameCache = {}, $12584cae6930e094$var$validatedAttributeNameCache = {};
function $12584cae6930e094$var$isAttributeNameSafe(attributeName) {
    if ($12584cae6930e094$var$hasOwnProperty.call($12584cae6930e094$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($12584cae6930e094$var$hasOwnProperty.call($12584cae6930e094$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($12584cae6930e094$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $12584cae6930e094$var$validatedAttributeNameCache[attributeName] = !0;
    $12584cae6930e094$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
var $12584cae6930e094$var$viewTransitionMutationContext = !1;
function $12584cae6930e094$var$pushMutationContext() {
    var prev = $12584cae6930e094$var$viewTransitionMutationContext;
    $12584cae6930e094$var$viewTransitionMutationContext = !1;
    return prev;
}
function $12584cae6930e094$var$setValueForAttribute(node, name, value) {
    if ($12584cae6930e094$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, value);
        }
    }
}
function $12584cae6930e094$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, value);
    }
}
function $12584cae6930e094$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, value);
    }
}
function $12584cae6930e094$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $12584cae6930e094$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $12584cae6930e094$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $12584cae6930e094$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $12584cae6930e094$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $12584cae6930e094$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $12584cae6930e094$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $12584cae6930e094$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
var $12584cae6930e094$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $12584cae6930e094$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($12584cae6930e094$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $12584cae6930e094$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $12584cae6930e094$var$getToStringValue(value);
        } else element.value !== "" + $12584cae6930e094$var$getToStringValue(value) && (element.value = "" + $12584cae6930e094$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? "number" === type && element.value == value ? $12584cae6930e094$var$setDefaultValue(element, $12584cae6930e094$var$getToStringValue(element.value)) : $12584cae6930e094$var$setDefaultValue(element, $12584cae6930e094$var$getToStringValue(value)) : null != defaultValue ? $12584cae6930e094$var$setDefaultValue(element, $12584cae6930e094$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $12584cae6930e094$var$getToStringValue(name) : element.removeAttribute("name");
}
function $12584cae6930e094$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $12584cae6930e094$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $12584cae6930e094$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $12584cae6930e094$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $12584cae6930e094$var$track(element);
}
function $12584cae6930e094$var$setDefaultValue(node, value) {
    node.defaultValue !== "" + value && (node.defaultValue = "" + value);
}
function $12584cae6930e094$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $12584cae6930e094$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $12584cae6930e094$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $12584cae6930e094$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $12584cae6930e094$var$getToStringValue(defaultValue) : "";
}
function $12584cae6930e094$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($12584cae6930e094$var$formatProdErrorMessage(92));
            if ($12584cae6930e094$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($12584cae6930e094$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $12584cae6930e094$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $12584cae6930e094$var$track(element);
}
function $12584cae6930e094$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $12584cae6930e094$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $12584cae6930e094$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $12584cae6930e094$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $12584cae6930e094$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($12584cae6930e094$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "", $12584cae6930e094$var$viewTransitionMutationContext = !0);
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && ($12584cae6930e094$var$setValueForStyle(node, styleName$16, styleName), $12584cae6930e094$var$viewTransitionMutationContext = !0);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $12584cae6930e094$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $12584cae6930e094$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $12584cae6930e094$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "maskType",
        "mask-type"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $12584cae6930e094$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $12584cae6930e094$var$sanitizeURL(url) {
    return $12584cae6930e094$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $12584cae6930e094$var$noop$1() {}
var $12584cae6930e094$var$currentReplayingEvent = null;
function $12584cae6930e094$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $12584cae6930e094$var$restoreTarget = null, $12584cae6930e094$var$restoreQueue = null;
function $12584cae6930e094$var$restoreStateOfTarget(target) {
    var internalInstance = $12584cae6930e094$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$12584cae6930e094$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $12584cae6930e094$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $12584cae6930e094$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$12584cae6930e094$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($12584cae6930e094$var$formatProdErrorMessage(90));
                            $12584cae6930e094$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $12584cae6930e094$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $12584cae6930e094$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $12584cae6930e094$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $12584cae6930e094$var$isInsideEventHandler = !1;
function $12584cae6930e094$var$batchedUpdates$1(fn, a, b) {
    if ($12584cae6930e094$var$isInsideEventHandler) return fn(a, b);
    $12584cae6930e094$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($12584cae6930e094$var$isInsideEventHandler = !1, null !== $12584cae6930e094$var$restoreTarget || null !== $12584cae6930e094$var$restoreQueue) {
            if ($12584cae6930e094$var$flushSyncWork$1(), $12584cae6930e094$var$restoreTarget && (a = $12584cae6930e094$var$restoreTarget, fn = $12584cae6930e094$var$restoreQueue, $12584cae6930e094$var$restoreQueue = $12584cae6930e094$var$restoreTarget = null, $12584cae6930e094$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$12584cae6930e094$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $12584cae6930e094$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$12584cae6930e094$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($12584cae6930e094$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $12584cae6930e094$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $12584cae6930e094$var$passiveBrowserEventsSupported = !1;
if ($12584cae6930e094$var$canUseDOM) try {
    var $12584cae6930e094$var$options = {};
    Object.defineProperty($12584cae6930e094$var$options, "passive", {
        get: function() {
            $12584cae6930e094$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $12584cae6930e094$var$options, $12584cae6930e094$var$options);
    window.removeEventListener("test", $12584cae6930e094$var$options, $12584cae6930e094$var$options);
} catch (e) {
    $12584cae6930e094$var$passiveBrowserEventsSupported = !1;
}
var $12584cae6930e094$var$root = null, $12584cae6930e094$var$startText = null, $12584cae6930e094$var$fallbackText = null;
function $12584cae6930e094$var$getData() {
    if ($12584cae6930e094$var$fallbackText) return $12584cae6930e094$var$fallbackText;
    var start, startValue = $12584cae6930e094$var$startText, startLength = startValue.length, end, endValue = "value" in $12584cae6930e094$var$root ? $12584cae6930e094$var$root.value : $12584cae6930e094$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $12584cae6930e094$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $12584cae6930e094$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $12584cae6930e094$var$functionThatReturnsTrue() {
    return !0;
}
function $12584cae6930e094$var$functionThatReturnsFalse() {
    return !1;
}
function $12584cae6930e094$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $12584cae6930e094$var$functionThatReturnsTrue : $12584cae6930e094$var$functionThatReturnsFalse;
        this.isPropagationStopped = $12584cae6930e094$var$functionThatReturnsFalse;
        return this;
    }
    $12584cae6930e094$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $12584cae6930e094$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $12584cae6930e094$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $12584cae6930e094$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $12584cae6930e094$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $12584cae6930e094$var$SyntheticEvent = $12584cae6930e094$var$createSyntheticEvent($12584cae6930e094$var$EventInterface), $12584cae6930e094$var$UIEventInterface = $12584cae6930e094$var$assign({}, $12584cae6930e094$var$EventInterface, {
    view: 0,
    detail: 0
}), $12584cae6930e094$var$SyntheticUIEvent = $12584cae6930e094$var$createSyntheticEvent($12584cae6930e094$var$UIEventInterface), $12584cae6930e094$var$lastMovementX, $12584cae6930e094$var$lastMovementY, $12584cae6930e094$var$lastMouseEvent, $12584cae6930e094$var$MouseEventInterface = $12584cae6930e094$var$assign({}, $12584cae6930e094$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $12584cae6930e094$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $12584cae6930e094$var$lastMouseEvent && ($12584cae6930e094$var$lastMouseEvent && "mousemove" === event.type ? ($12584cae6930e094$var$lastMovementX = event.screenX - $12584cae6930e094$var$lastMouseEvent.screenX, $12584cae6930e094$var$lastMovementY = event.screenY - $12584cae6930e094$var$lastMouseEvent.screenY) : $12584cae6930e094$var$lastMovementY = $12584cae6930e094$var$lastMovementX = 0, $12584cae6930e094$var$lastMouseEvent = event);
        return $12584cae6930e094$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $12584cae6930e094$var$lastMovementY;
    }
}), $12584cae6930e094$var$SyntheticMouseEvent = $12584cae6930e094$var$createSyntheticEvent($12584cae6930e094$var$MouseEventInterface), $12584cae6930e094$var$DragEventInterface = $12584cae6930e094$var$assign({}, $12584cae6930e094$var$MouseEventInterface, {
    dataTransfer: 0
}), $12584cae6930e094$var$SyntheticDragEvent = $12584cae6930e094$var$createSyntheticEvent($12584cae6930e094$var$DragEventInterface), $12584cae6930e094$var$FocusEventInterface = $12584cae6930e094$var$assign({}, $12584cae6930e094$var$UIEventInterface, {
    relatedTarget: 0
}), $12584cae6930e094$var$SyntheticFocusEvent = $12584cae6930e094$var$createSyntheticEvent($12584cae6930e094$var$FocusEventInterface), $12584cae6930e094$var$AnimationEventInterface = $12584cae6930e094$var$assign({}, $12584cae6930e094$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $12584cae6930e094$var$SyntheticAnimationEvent = $12584cae6930e094$var$createSyntheticEvent($12584cae6930e094$var$AnimationEventInterface), $12584cae6930e094$var$ClipboardEventInterface = $12584cae6930e094$var$assign({}, $12584cae6930e094$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $12584cae6930e094$var$SyntheticClipboardEvent = $12584cae6930e094$var$createSyntheticEvent($12584cae6930e094$var$ClipboardEventInterface), $12584cae6930e094$var$CompositionEventInterface = $12584cae6930e094$var$assign({}, $12584cae6930e094$var$EventInterface, {
    data: 0
}), $12584cae6930e094$var$SyntheticCompositionEvent = $12584cae6930e094$var$createSyntheticEvent($12584cae6930e094$var$CompositionEventInterface), $12584cae6930e094$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $12584cae6930e094$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $12584cae6930e094$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $12584cae6930e094$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $12584cae6930e094$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $12584cae6930e094$var$getEventModifierState() {
    return $12584cae6930e094$var$modifierStateGetter;
}
var $12584cae6930e094$var$KeyboardEventInterface = $12584cae6930e094$var$assign({}, $12584cae6930e094$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $12584cae6930e094$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $12584cae6930e094$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $12584cae6930e094$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $12584cae6930e094$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $12584cae6930e094$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $12584cae6930e094$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $12584cae6930e094$var$SyntheticKeyboardEvent = $12584cae6930e094$var$createSyntheticEvent($12584cae6930e094$var$KeyboardEventInterface), $12584cae6930e094$var$PointerEventInterface = $12584cae6930e094$var$assign({}, $12584cae6930e094$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $12584cae6930e094$var$SyntheticPointerEvent = $12584cae6930e094$var$createSyntheticEvent($12584cae6930e094$var$PointerEventInterface), $12584cae6930e094$var$SubmitEventInterface = $12584cae6930e094$var$assign({}, $12584cae6930e094$var$EventInterface, {
    submitter: 0
}), $12584cae6930e094$var$SyntheticSubmitEvent = $12584cae6930e094$var$createSyntheticEvent($12584cae6930e094$var$SubmitEventInterface), $12584cae6930e094$var$TouchEventInterface = $12584cae6930e094$var$assign({}, $12584cae6930e094$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $12584cae6930e094$var$getEventModifierState
}), $12584cae6930e094$var$SyntheticTouchEvent = $12584cae6930e094$var$createSyntheticEvent($12584cae6930e094$var$TouchEventInterface), $12584cae6930e094$var$TransitionEventInterface = $12584cae6930e094$var$assign({}, $12584cae6930e094$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $12584cae6930e094$var$SyntheticTransitionEvent = $12584cae6930e094$var$createSyntheticEvent($12584cae6930e094$var$TransitionEventInterface), $12584cae6930e094$var$WheelEventInterface = $12584cae6930e094$var$assign({}, $12584cae6930e094$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $12584cae6930e094$var$SyntheticWheelEvent = $12584cae6930e094$var$createSyntheticEvent($12584cae6930e094$var$WheelEventInterface), $12584cae6930e094$var$ToggleEventInterface = $12584cae6930e094$var$assign({}, $12584cae6930e094$var$EventInterface, {
    newState: 0,
    oldState: 0,
    source: 0
}), $12584cae6930e094$var$SyntheticToggleEvent = $12584cae6930e094$var$createSyntheticEvent($12584cae6930e094$var$ToggleEventInterface), $12584cae6930e094$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $12584cae6930e094$var$canUseCompositionEvent = $12584cae6930e094$var$canUseDOM && "CompositionEvent" in window, $12584cae6930e094$var$documentMode = null;
$12584cae6930e094$var$canUseDOM && "documentMode" in document && ($12584cae6930e094$var$documentMode = document.documentMode);
var $12584cae6930e094$var$canUseTextInputEvent = $12584cae6930e094$var$canUseDOM && "TextEvent" in window && !$12584cae6930e094$var$documentMode, $12584cae6930e094$var$useFallbackCompositionData = $12584cae6930e094$var$canUseDOM && (!$12584cae6930e094$var$canUseCompositionEvent || $12584cae6930e094$var$documentMode && 8 < $12584cae6930e094$var$documentMode && 11 >= $12584cae6930e094$var$documentMode), $12584cae6930e094$var$SPACEBAR_CHAR = String.fromCharCode(32), $12584cae6930e094$var$hasSpaceKeypress = !1;
function $12584cae6930e094$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $12584cae6930e094$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $12584cae6930e094$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $12584cae6930e094$var$isComposing = !1;
function $12584cae6930e094$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $12584cae6930e094$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $12584cae6930e094$var$hasSpaceKeypress = !0;
            return $12584cae6930e094$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $12584cae6930e094$var$SPACEBAR_CHAR && $12584cae6930e094$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $12584cae6930e094$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($12584cae6930e094$var$isComposing) return "compositionend" === domEventName || !$12584cae6930e094$var$canUseCompositionEvent && $12584cae6930e094$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $12584cae6930e094$var$getData(), $12584cae6930e094$var$fallbackText = $12584cae6930e094$var$startText = $12584cae6930e094$var$root = null, $12584cae6930e094$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $12584cae6930e094$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $12584cae6930e094$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $12584cae6930e094$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$12584cae6930e094$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $12584cae6930e094$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $12584cae6930e094$var$restoreTarget ? $12584cae6930e094$var$restoreQueue ? $12584cae6930e094$var$restoreQueue.push(target) : $12584cae6930e094$var$restoreQueue = [
        target
    ] : $12584cae6930e094$var$restoreTarget = target;
    inst = $12584cae6930e094$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $12584cae6930e094$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $12584cae6930e094$var$activeElement$1 = null, $12584cae6930e094$var$activeElementInst$1 = null;
function $12584cae6930e094$var$runEventInBatch(dispatchQueue) {
    $12584cae6930e094$var$processDispatchQueue(dispatchQueue, 0);
}
function $12584cae6930e094$var$getInstIfValueChanged(targetInst) {
    var targetNode = $12584cae6930e094$var$getNodeFromInstance(targetInst);
    if ($12584cae6930e094$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $12584cae6930e094$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $12584cae6930e094$var$isInputEventSupported = !1;
if ($12584cae6930e094$var$canUseDOM) {
    var $12584cae6930e094$var$JSCompiler_inline_result$jscomp$318;
    if ($12584cae6930e094$var$canUseDOM) {
        var $12584cae6930e094$var$isSupported$jscomp$inline_474 = "oninput" in document;
        if (!$12584cae6930e094$var$isSupported$jscomp$inline_474) {
            var $12584cae6930e094$var$element$jscomp$inline_475 = document.createElement("div");
            $12584cae6930e094$var$element$jscomp$inline_475.setAttribute("oninput", "return;");
            $12584cae6930e094$var$isSupported$jscomp$inline_474 = "function" === typeof $12584cae6930e094$var$element$jscomp$inline_475.oninput;
        }
        $12584cae6930e094$var$JSCompiler_inline_result$jscomp$318 = $12584cae6930e094$var$isSupported$jscomp$inline_474;
    } else $12584cae6930e094$var$JSCompiler_inline_result$jscomp$318 = !1;
    $12584cae6930e094$var$isInputEventSupported = $12584cae6930e094$var$JSCompiler_inline_result$jscomp$318 && (!document.documentMode || 9 < document.documentMode);
}
function $12584cae6930e094$var$stopWatchingForValueChange() {
    $12584cae6930e094$var$activeElement$1 && ($12584cae6930e094$var$activeElement$1.detachEvent("onpropertychange", $12584cae6930e094$var$handlePropertyChange), $12584cae6930e094$var$activeElementInst$1 = $12584cae6930e094$var$activeElement$1 = null);
}
function $12584cae6930e094$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $12584cae6930e094$var$getInstIfValueChanged($12584cae6930e094$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $12584cae6930e094$var$createAndAccumulateChangeEvent(dispatchQueue, $12584cae6930e094$var$activeElementInst$1, nativeEvent, $12584cae6930e094$var$getEventTarget(nativeEvent));
        $12584cae6930e094$var$batchedUpdates$1($12584cae6930e094$var$runEventInBatch, dispatchQueue);
    }
}
function $12584cae6930e094$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($12584cae6930e094$var$stopWatchingForValueChange(), $12584cae6930e094$var$activeElement$1 = target, $12584cae6930e094$var$activeElementInst$1 = targetInst, $12584cae6930e094$var$activeElement$1.attachEvent("onpropertychange", $12584cae6930e094$var$handlePropertyChange)) : "focusout" === domEventName && $12584cae6930e094$var$stopWatchingForValueChange();
}
function $12584cae6930e094$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $12584cae6930e094$var$getInstIfValueChanged($12584cae6930e094$var$activeElementInst$1);
}
function $12584cae6930e094$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $12584cae6930e094$var$getInstIfValueChanged(targetInst);
}
function $12584cae6930e094$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $12584cae6930e094$var$getInstIfValueChanged(targetInst);
}
function $12584cae6930e094$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $12584cae6930e094$var$objectIs = "function" === typeof Object.is ? Object.is : $12584cae6930e094$var$is;
function $12584cae6930e094$var$shallowEqual(objA, objB) {
    if ($12584cae6930e094$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$12584cae6930e094$var$hasOwnProperty.call(objB, currentKey) || !$12584cae6930e094$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $12584cae6930e094$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e$20) {
        return doc.body;
    }
}
function $12584cae6930e094$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $12584cae6930e094$var$getNodeForCharacterOffset(root, offset) {
    var node = $12584cae6930e094$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $12584cae6930e094$var$getLeafNode(node);
    }
}
function $12584cae6930e094$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $12584cae6930e094$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $12584cae6930e094$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $12584cae6930e094$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $12584cae6930e094$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $12584cae6930e094$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $12584cae6930e094$var$skipSelectionChangeEvent = $12584cae6930e094$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $12584cae6930e094$var$activeElement = null, $12584cae6930e094$var$activeElementInst = null, $12584cae6930e094$var$lastSelection = null, $12584cae6930e094$var$mouseDown = !1;
function $12584cae6930e094$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $12584cae6930e094$var$mouseDown || null == $12584cae6930e094$var$activeElement || $12584cae6930e094$var$activeElement !== $12584cae6930e094$var$getActiveElement(doc) || (doc = $12584cae6930e094$var$activeElement, "selectionStart" in doc && $12584cae6930e094$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $12584cae6930e094$var$lastSelection && $12584cae6930e094$var$shallowEqual($12584cae6930e094$var$lastSelection, doc) || ($12584cae6930e094$var$lastSelection = doc, doc = $12584cae6930e094$var$accumulateTwoPhaseListeners($12584cae6930e094$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $12584cae6930e094$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $12584cae6930e094$var$activeElement)));
}
function $12584cae6930e094$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $12584cae6930e094$var$vendorPrefixes = {
    animationend: $12584cae6930e094$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $12584cae6930e094$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $12584cae6930e094$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $12584cae6930e094$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $12584cae6930e094$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $12584cae6930e094$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $12584cae6930e094$var$makePrefixMap("Transition", "TransitionEnd")
}, $12584cae6930e094$var$prefixedEventNames = {}, $12584cae6930e094$var$style = {};
$12584cae6930e094$var$canUseDOM && ($12584cae6930e094$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $12584cae6930e094$var$vendorPrefixes.animationend.animation, delete $12584cae6930e094$var$vendorPrefixes.animationiteration.animation, delete $12584cae6930e094$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $12584cae6930e094$var$vendorPrefixes.transitionend.transition);
function $12584cae6930e094$var$getVendorPrefixedEventName(eventName) {
    if ($12584cae6930e094$var$prefixedEventNames[eventName]) return $12584cae6930e094$var$prefixedEventNames[eventName];
    if (!$12584cae6930e094$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $12584cae6930e094$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $12584cae6930e094$var$style) return $12584cae6930e094$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $12584cae6930e094$var$ANIMATION_END = $12584cae6930e094$var$getVendorPrefixedEventName("animationend"), $12584cae6930e094$var$ANIMATION_ITERATION = $12584cae6930e094$var$getVendorPrefixedEventName("animationiteration"), $12584cae6930e094$var$ANIMATION_START = $12584cae6930e094$var$getVendorPrefixedEventName("animationstart"), $12584cae6930e094$var$TRANSITION_RUN = $12584cae6930e094$var$getVendorPrefixedEventName("transitionrun"), $12584cae6930e094$var$TRANSITION_START = $12584cae6930e094$var$getVendorPrefixedEventName("transitionstart"), $12584cae6930e094$var$TRANSITION_CANCEL = $12584cae6930e094$var$getVendorPrefixedEventName("transitioncancel"), $12584cae6930e094$var$TRANSITION_END = $12584cae6930e094$var$getVendorPrefixedEventName("transitionend"), $12584cae6930e094$var$topLevelEventsToReactNames = new Map(), $12584cae6930e094$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error fullscreenChange fullscreenError gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$12584cae6930e094$var$simpleEventPluginEvents.push("scrollEnd");
function $12584cae6930e094$var$registerSimpleEvent(domEventName, reactName) {
    $12584cae6930e094$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $12584cae6930e094$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $12584cae6930e094$var$globalClientIdCounter$1 = 0;
function $12584cae6930e094$var$getViewTransitionName(props, instance) {
    if (null != props.name && "auto" !== props.name) return props.name;
    if (null !== instance.autoName) return instance.autoName;
    props = $12584cae6930e094$var$pendingEffectsRoot.identifierPrefix;
    var globalClientId = $12584cae6930e094$var$globalClientIdCounter$1++;
    props = "_" + props + "t_" + globalClientId.toString(32) + "_";
    return instance.autoName = props;
}
function $12584cae6930e094$var$getClassNameByType(classByType) {
    if (null == classByType || "string" === typeof classByType) return classByType;
    var className = null, activeTypes = $12584cae6930e094$var$pendingTransitionTypes;
    if (null !== activeTypes) for(var i = 0; i < activeTypes.length; i++){
        var match = classByType[activeTypes[i]];
        if (null != match) {
            if ("none" === match) return "none";
            className = null == className ? match : className + (" " + match);
        }
    }
    return null == className ? classByType.default : className;
}
function $12584cae6930e094$var$getViewTransitionClassName(defaultClass, eventClass) {
    defaultClass = $12584cae6930e094$var$getClassNameByType(defaultClass);
    eventClass = $12584cae6930e094$var$getClassNameByType(eventClass);
    return null == eventClass ? "auto" === defaultClass ? null : defaultClass : "auto" === eventClass ? null : eventClass;
}
var $12584cae6930e094$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $12584cae6930e094$var$concurrentQueues = [], $12584cae6930e094$var$concurrentQueuesIndex = 0, $12584cae6930e094$var$concurrentlyUpdatedLanes = 0;
function $12584cae6930e094$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $12584cae6930e094$var$concurrentQueuesIndex, i = $12584cae6930e094$var$concurrentlyUpdatedLanes = $12584cae6930e094$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $12584cae6930e094$var$concurrentQueues[i];
        $12584cae6930e094$var$concurrentQueues[i++] = null;
        var queue = $12584cae6930e094$var$concurrentQueues[i];
        $12584cae6930e094$var$concurrentQueues[i++] = null;
        var update = $12584cae6930e094$var$concurrentQueues[i];
        $12584cae6930e094$var$concurrentQueues[i++] = null;
        var lane = $12584cae6930e094$var$concurrentQueues[i];
        $12584cae6930e094$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $12584cae6930e094$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $12584cae6930e094$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $12584cae6930e094$var$concurrentQueues[$12584cae6930e094$var$concurrentQueuesIndex++] = fiber;
    $12584cae6930e094$var$concurrentQueues[$12584cae6930e094$var$concurrentQueuesIndex++] = queue;
    $12584cae6930e094$var$concurrentQueues[$12584cae6930e094$var$concurrentQueuesIndex++] = update;
    $12584cae6930e094$var$concurrentQueues[$12584cae6930e094$var$concurrentQueuesIndex++] = lane;
    $12584cae6930e094$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $12584cae6930e094$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $12584cae6930e094$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $12584cae6930e094$var$getRootForUpdatedFiber(fiber);
}
function $12584cae6930e094$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $12584cae6930e094$var$enqueueUpdate$1(fiber, null, null, lane);
    return $12584cae6930e094$var$getRootForUpdatedFiber(fiber);
}
function $12584cae6930e094$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $12584cae6930e094$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $12584cae6930e094$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $12584cae6930e094$var$nestedUpdateCount) throw $12584cae6930e094$var$nestedUpdateCount = 0, $12584cae6930e094$var$rootWithNestedUpdates = null, Error($12584cae6930e094$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $12584cae6930e094$var$emptyContextObject = {};
function $12584cae6930e094$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $12584cae6930e094$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $12584cae6930e094$var$FiberNode(tag, pendingProps, key, mode);
}
function $12584cae6930e094$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $12584cae6930e094$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $12584cae6930e094$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 1206910976;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $12584cae6930e094$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 1206910978;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $12584cae6930e094$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof owner) $12584cae6930e094$var$shouldConstruct(owner) && (fiberTag = 1);
    else if ("string" === typeof owner) fiberTag = $12584cae6930e094$var$isHostHoistableType(type, pendingProps, $12584cae6930e094$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(owner){
        case $12584cae6930e094$var$REACT_ACTIVITY_TYPE:
            return type = $12584cae6930e094$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $12584cae6930e094$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $12584cae6930e094$var$REACT_FRAGMENT_TYPE:
            return $12584cae6930e094$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $12584cae6930e094$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $12584cae6930e094$var$REACT_PROFILER_TYPE:
            return type = $12584cae6930e094$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $12584cae6930e094$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $12584cae6930e094$var$REACT_SUSPENSE_TYPE:
            return type = $12584cae6930e094$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $12584cae6930e094$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $12584cae6930e094$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $12584cae6930e094$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $12584cae6930e094$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        case $12584cae6930e094$var$REACT_LEGACY_HIDDEN_TYPE:
        case $12584cae6930e094$var$REACT_VIEW_TRANSITION_TYPE:
            return type = mode | 32, type = $12584cae6930e094$var$createFiberImplClass(30, pendingProps, key, type), type.elementType = $12584cae6930e094$var$REACT_VIEW_TRANSITION_TYPE, type.lanes = lanes, type.stateNode = {
                autoName: null,
                paired: null,
                clones: null,
                ref: null
            }, type;
        default:
            if ("object" === typeof owner && null !== owner) switch(owner.$$typeof){
                case $12584cae6930e094$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $12584cae6930e094$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $12584cae6930e094$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $12584cae6930e094$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $12584cae6930e094$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($12584cae6930e094$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $12584cae6930e094$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $12584cae6930e094$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $12584cae6930e094$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $12584cae6930e094$var$createFiberFromText(content, mode, lanes) {
    content = $12584cae6930e094$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $12584cae6930e094$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $12584cae6930e094$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $12584cae6930e094$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $12584cae6930e094$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $12584cae6930e094$var$CapturedStacks = new WeakMap();
function $12584cae6930e094$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $12584cae6930e094$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $12584cae6930e094$var$getStackByFiberInDevAndProd(source)
        };
        $12584cae6930e094$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $12584cae6930e094$var$getStackByFiberInDevAndProd(source)
    };
}
var $12584cae6930e094$var$forkStack = [], $12584cae6930e094$var$forkStackIndex = 0, $12584cae6930e094$var$treeForkProvider = null, $12584cae6930e094$var$treeForkCount = 0, $12584cae6930e094$var$idStack = [], $12584cae6930e094$var$idStackIndex = 0, $12584cae6930e094$var$treeContextProvider = null, $12584cae6930e094$var$treeContextId = 1, $12584cae6930e094$var$treeContextOverflow = "";
function $12584cae6930e094$var$pushTreeFork(workInProgress, totalChildren) {
    $12584cae6930e094$var$forkStack[$12584cae6930e094$var$forkStackIndex++] = $12584cae6930e094$var$treeForkCount;
    $12584cae6930e094$var$forkStack[$12584cae6930e094$var$forkStackIndex++] = $12584cae6930e094$var$treeForkProvider;
    $12584cae6930e094$var$treeForkProvider = workInProgress;
    $12584cae6930e094$var$treeForkCount = totalChildren;
}
function $12584cae6930e094$var$pushTreeId(workInProgress, totalChildren, index) {
    $12584cae6930e094$var$idStack[$12584cae6930e094$var$idStackIndex++] = $12584cae6930e094$var$treeContextId;
    $12584cae6930e094$var$idStack[$12584cae6930e094$var$idStackIndex++] = $12584cae6930e094$var$treeContextOverflow;
    $12584cae6930e094$var$idStack[$12584cae6930e094$var$idStackIndex++] = $12584cae6930e094$var$treeContextProvider;
    $12584cae6930e094$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $12584cae6930e094$var$treeContextId;
    workInProgress = $12584cae6930e094$var$treeContextOverflow;
    var baseLength = 32 - $12584cae6930e094$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $12584cae6930e094$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $12584cae6930e094$var$treeContextId = 1 << 32 - $12584cae6930e094$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $12584cae6930e094$var$treeContextOverflow = length + workInProgress;
    } else $12584cae6930e094$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $12584cae6930e094$var$treeContextOverflow = workInProgress;
}
function $12584cae6930e094$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($12584cae6930e094$var$pushTreeFork(workInProgress, 1), $12584cae6930e094$var$pushTreeId(workInProgress, 1, 0));
}
function $12584cae6930e094$var$popTreeContext(workInProgress) {
    for(; workInProgress === $12584cae6930e094$var$treeForkProvider;)$12584cae6930e094$var$treeForkProvider = $12584cae6930e094$var$forkStack[--$12584cae6930e094$var$forkStackIndex], $12584cae6930e094$var$forkStack[$12584cae6930e094$var$forkStackIndex] = null, $12584cae6930e094$var$treeForkCount = $12584cae6930e094$var$forkStack[--$12584cae6930e094$var$forkStackIndex], $12584cae6930e094$var$forkStack[$12584cae6930e094$var$forkStackIndex] = null;
    for(; workInProgress === $12584cae6930e094$var$treeContextProvider;)$12584cae6930e094$var$treeContextProvider = $12584cae6930e094$var$idStack[--$12584cae6930e094$var$idStackIndex], $12584cae6930e094$var$idStack[$12584cae6930e094$var$idStackIndex] = null, $12584cae6930e094$var$treeContextOverflow = $12584cae6930e094$var$idStack[--$12584cae6930e094$var$idStackIndex], $12584cae6930e094$var$idStack[$12584cae6930e094$var$idStackIndex] = null, $12584cae6930e094$var$treeContextId = $12584cae6930e094$var$idStack[--$12584cae6930e094$var$idStackIndex], $12584cae6930e094$var$idStack[$12584cae6930e094$var$idStackIndex] = null;
}
function $12584cae6930e094$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $12584cae6930e094$var$idStack[$12584cae6930e094$var$idStackIndex++] = $12584cae6930e094$var$treeContextId;
    $12584cae6930e094$var$idStack[$12584cae6930e094$var$idStackIndex++] = $12584cae6930e094$var$treeContextOverflow;
    $12584cae6930e094$var$idStack[$12584cae6930e094$var$idStackIndex++] = $12584cae6930e094$var$treeContextProvider;
    $12584cae6930e094$var$treeContextId = suspendedContext.id;
    $12584cae6930e094$var$treeContextOverflow = suspendedContext.overflow;
    $12584cae6930e094$var$treeContextProvider = workInProgress;
}
var $12584cae6930e094$var$hydrationParentFiber = null, $12584cae6930e094$var$nextHydratableInstance = null, $12584cae6930e094$var$isHydrating = !1, $12584cae6930e094$var$hydrationErrors = null, $12584cae6930e094$var$rootOrSingletonContext = !1, $12584cae6930e094$var$HydrationMismatchException = Error($12584cae6930e094$var$formatProdErrorMessage(519));
function $12584cae6930e094$var$throwOnHydrationMismatch(fiber) {
    var error = Error($12584cae6930e094$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $12584cae6930e094$var$queueHydrationError($12584cae6930e094$var$createCapturedValueAtFiber(error, fiber));
    throw $12584cae6930e094$var$HydrationMismatchException;
}
function $12584cae6930e094$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$12584cae6930e094$var$internalInstanceKey] = fiber;
    instance[$12584cae6930e094$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $12584cae6930e094$var$listenToNonDelegatedEvent("cancel", instance);
            $12584cae6930e094$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $12584cae6930e094$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $12584cae6930e094$var$mediaEventTypes.length; type++)$12584cae6930e094$var$listenToNonDelegatedEvent($12584cae6930e094$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $12584cae6930e094$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $12584cae6930e094$var$listenToNonDelegatedEvent("error", instance);
            $12584cae6930e094$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $12584cae6930e094$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $12584cae6930e094$var$listenToNonDelegatedEvent("invalid", instance);
            $12584cae6930e094$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $12584cae6930e094$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $12584cae6930e094$var$listenToNonDelegatedEvent("invalid", instance), $12584cae6930e094$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $12584cae6930e094$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($12584cae6930e094$var$listenToNonDelegatedEvent("beforetoggle", instance), $12584cae6930e094$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $12584cae6930e094$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $12584cae6930e094$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $12584cae6930e094$var$noop$1), instance = !0) : instance = !1;
    instance || $12584cae6930e094$var$throwOnHydrationMismatch(fiber, !0);
}
function $12584cae6930e094$var$popToNextHostParent(fiber) {
    for($12584cae6930e094$var$hydrationParentFiber = fiber.return; $12584cae6930e094$var$hydrationParentFiber;)switch($12584cae6930e094$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $12584cae6930e094$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $12584cae6930e094$var$rootOrSingletonContext = !0;
            return;
        default:
            $12584cae6930e094$var$hydrationParentFiber = $12584cae6930e094$var$hydrationParentFiber.return;
    }
}
function $12584cae6930e094$var$popHydrationState(fiber) {
    if (fiber !== $12584cae6930e094$var$hydrationParentFiber) return !1;
    if (!$12584cae6930e094$var$isHydrating) return $12584cae6930e094$var$popToNextHostParent(fiber), $12584cae6930e094$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $12584cae6930e094$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $12584cae6930e094$var$nextHydratableInstance && $12584cae6930e094$var$throwOnHydrationMismatch(fiber);
    $12584cae6930e094$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($12584cae6930e094$var$formatProdErrorMessage(317));
        $12584cae6930e094$var$nextHydratableInstance = $12584cae6930e094$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($12584cae6930e094$var$formatProdErrorMessage(317));
        $12584cae6930e094$var$nextHydratableInstance = $12584cae6930e094$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $12584cae6930e094$var$nextHydratableInstance, $12584cae6930e094$var$isSingletonScope(fiber.type) ? (fiber = $12584cae6930e094$var$previousHydratableOnEnteringScopedSingleton, $12584cae6930e094$var$previousHydratableOnEnteringScopedSingleton = null, $12584cae6930e094$var$nextHydratableInstance = fiber) : $12584cae6930e094$var$nextHydratableInstance = tag) : $12584cae6930e094$var$nextHydratableInstance = $12584cae6930e094$var$hydrationParentFiber ? $12584cae6930e094$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $12584cae6930e094$var$resetHydrationState() {
    $12584cae6930e094$var$nextHydratableInstance = $12584cae6930e094$var$hydrationParentFiber = null;
    $12584cae6930e094$var$isHydrating = !1;
}
function $12584cae6930e094$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $12584cae6930e094$var$hydrationErrors;
    null !== queuedErrors && (null === $12584cae6930e094$var$workInProgressRootRecoverableErrors ? $12584cae6930e094$var$workInProgressRootRecoverableErrors = queuedErrors : $12584cae6930e094$var$workInProgressRootRecoverableErrors.push.apply($12584cae6930e094$var$workInProgressRootRecoverableErrors, queuedErrors), $12584cae6930e094$var$hydrationErrors = null);
    return queuedErrors;
}
function $12584cae6930e094$var$queueHydrationError(error) {
    null === $12584cae6930e094$var$hydrationErrors ? $12584cae6930e094$var$hydrationErrors = [
        error
    ] : $12584cae6930e094$var$hydrationErrors.push(error);
}
var $12584cae6930e094$var$valueCursor = $12584cae6930e094$var$createCursor(null), $12584cae6930e094$var$currentlyRenderingFiber$1 = null, $12584cae6930e094$var$lastContextDependency = null;
function $12584cae6930e094$var$pushProvider(providerFiber, context, nextValue) {
    $12584cae6930e094$var$push($12584cae6930e094$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $12584cae6930e094$var$popProvider(context) {
    context._currentValue = $12584cae6930e094$var$valueCursor.current;
    $12584cae6930e094$var$pop($12584cae6930e094$var$valueCursor);
}
function $12584cae6930e094$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $12584cae6930e094$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $12584cae6930e094$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($12584cae6930e094$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $12584cae6930e094$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else 13 === fiber.tag && null !== fiber.memoizedState && null === fiber.memoizedState.dehydrated ? (fiber.lanes |= renderLanes, nextFiber = fiber.alternate, null !== nextFiber && (nextFiber.lanes |= renderLanes), $12584cae6930e094$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, workInProgress), nextFiber = fiber.child, nextFiber = null !== nextFiber ? nextFiber.sibling : null) : nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $12584cae6930e094$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($12584cae6930e094$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $12584cae6930e094$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $12584cae6930e094$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($12584cae6930e094$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($12584cae6930e094$var$HostTransitionContext) : current = [
                $12584cae6930e094$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $12584cae6930e094$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
    return null !== current;
}
function $12584cae6930e094$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$12584cae6930e094$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $12584cae6930e094$var$prepareToReadContext(workInProgress) {
    $12584cae6930e094$var$currentlyRenderingFiber$1 = workInProgress;
    $12584cae6930e094$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $12584cae6930e094$var$readContext(context) {
    return $12584cae6930e094$var$readContextForConsumer($12584cae6930e094$var$currentlyRenderingFiber$1, context);
}
function $12584cae6930e094$var$readContextDuringReconciliation(consumer, context) {
    null === $12584cae6930e094$var$currentlyRenderingFiber$1 && $12584cae6930e094$var$prepareToReadContext(consumer);
    return $12584cae6930e094$var$readContextForConsumer(consumer, context);
}
function $12584cae6930e094$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $12584cae6930e094$var$lastContextDependency) {
        if (null === consumer) throw Error($12584cae6930e094$var$formatProdErrorMessage(308));
        $12584cae6930e094$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $12584cae6930e094$var$lastContextDependency = $12584cae6930e094$var$lastContextDependency.next = context;
    return value;
}
var $12584cae6930e094$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $12584cae6930e094$var$scheduleCallback$2 = $8IBEr.unstable_scheduleCallback, $12584cae6930e094$var$NormalPriority = $8IBEr.unstable_NormalPriority, $12584cae6930e094$var$CacheContext = {
    $$typeof: $12584cae6930e094$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $12584cae6930e094$var$createCache() {
    return {
        controller: new $12584cae6930e094$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $12584cae6930e094$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $12584cae6930e094$var$scheduleCallback$2($12584cae6930e094$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
function $12584cae6930e094$var$queueTransitionTypes(root, transitionTypes) {
    if (0 !== (root.pendingLanes & 4194048)) {
        var queued = root.transitionTypes;
        null === queued && (queued = root.transitionTypes = []);
        for(root = 0; root < transitionTypes.length; root++){
            var transitionType = transitionTypes[root];
            -1 === queued.indexOf(transitionType) && queued.push(transitionType);
        }
    }
}
var $12584cae6930e094$var$entangledTransitionTypes = null;
function $12584cae6930e094$var$claimQueuedTransitionTypes(root) {
    var claimed = root.transitionTypes;
    root.transitionTypes = null;
    return claimed;
}
var $12584cae6930e094$var$currentEntangledListeners = null, $12584cae6930e094$var$currentEntangledPendingCount = 0, $12584cae6930e094$var$currentEntangledLane = 0, $12584cae6930e094$var$currentEntangledActionThenable = null;
function $12584cae6930e094$var$entangleAsyncAction(transition, thenable) {
    if (null === $12584cae6930e094$var$currentEntangledListeners) {
        var entangledListeners = $12584cae6930e094$var$currentEntangledListeners = [];
        $12584cae6930e094$var$currentEntangledPendingCount = 0;
        $12584cae6930e094$var$currentEntangledLane = $12584cae6930e094$var$requestTransitionLane();
        $12584cae6930e094$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $12584cae6930e094$var$currentEntangledPendingCount++;
    thenable.then($12584cae6930e094$var$pingEngtangledActionScope, $12584cae6930e094$var$pingEngtangledActionScope);
    return thenable;
}
function $12584cae6930e094$var$pingEngtangledActionScope() {
    if (0 === --$12584cae6930e094$var$currentEntangledPendingCount && ($12584cae6930e094$var$entangledTransitionTypes = null, null !== $12584cae6930e094$var$currentEntangledListeners)) {
        null !== $12584cae6930e094$var$currentEntangledActionThenable && ($12584cae6930e094$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $12584cae6930e094$var$currentEntangledListeners;
        $12584cae6930e094$var$currentEntangledListeners = null;
        $12584cae6930e094$var$currentEntangledLane = 0;
        $12584cae6930e094$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $12584cae6930e094$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $12584cae6930e094$var$prevOnStartTransitionFinish = $12584cae6930e094$var$ReactSharedInternals.S;
$12584cae6930e094$var$ReactSharedInternals.S = function(transition, returnValue) {
    $12584cae6930e094$var$globalMostRecentTransitionTime = $12584cae6930e094$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $12584cae6930e094$var$entangleAsyncAction(transition, returnValue);
    if (null !== $12584cae6930e094$var$entangledTransitionTypes) for(var root$28 = $12584cae6930e094$var$firstScheduledRoot; null !== root$28;)$12584cae6930e094$var$queueTransitionTypes(root$28, $12584cae6930e094$var$entangledTransitionTypes), root$28 = root$28.next;
    root$28 = transition.types;
    if (null !== root$28) {
        for(var root$29 = $12584cae6930e094$var$firstScheduledRoot; null !== root$29;)$12584cae6930e094$var$queueTransitionTypes(root$29, root$28), root$29 = root$29.next;
        if (0 !== $12584cae6930e094$var$currentEntangledLane) {
            root$29 = $12584cae6930e094$var$entangledTransitionTypes;
            null === root$29 && (root$29 = $12584cae6930e094$var$entangledTransitionTypes = []);
            for(var i = 0; i < root$28.length; i++){
                var transitionType = root$28[i];
                -1 === root$29.indexOf(transitionType) && root$29.push(transitionType);
            }
        }
    }
    null !== $12584cae6930e094$var$prevOnStartTransitionFinish && $12584cae6930e094$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $12584cae6930e094$var$resumedCache = $12584cae6930e094$var$createCursor(null);
function $12584cae6930e094$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $12584cae6930e094$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $12584cae6930e094$var$workInProgressRoot.pooledCache;
}
function $12584cae6930e094$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $12584cae6930e094$var$push($12584cae6930e094$var$resumedCache, $12584cae6930e094$var$resumedCache.current) : $12584cae6930e094$var$push($12584cae6930e094$var$resumedCache, prevCachePool.pool);
}
function $12584cae6930e094$var$getSuspendedCache() {
    var cacheFromPool = $12584cae6930e094$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $12584cae6930e094$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $12584cae6930e094$var$SuspenseException = Error($12584cae6930e094$var$formatProdErrorMessage(460)), $12584cae6930e094$var$SuspenseyCommitException = Error($12584cae6930e094$var$formatProdErrorMessage(474)), $12584cae6930e094$var$SuspenseActionException = Error($12584cae6930e094$var$formatProdErrorMessage(542)), $12584cae6930e094$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $12584cae6930e094$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $12584cae6930e094$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($12584cae6930e094$var$noop$1, $12584cae6930e094$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            thenableState = thenable.reason;
            $12584cae6930e094$var$checkIfUseWrappedInAsyncCatch(thenableState);
            if (void 0 === thenableState && !("reason" in thenable)) throw Error($12584cae6930e094$var$formatProdErrorMessage(600));
            throw thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($12584cae6930e094$var$noop$1, $12584cae6930e094$var$noop$1);
            else {
                thenableState = $12584cae6930e094$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($12584cae6930e094$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $12584cae6930e094$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $12584cae6930e094$var$suspendedThenable = thenable;
            throw $12584cae6930e094$var$SuspenseException;
    }
}
function $12584cae6930e094$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $12584cae6930e094$var$suspendedThenable = x, $12584cae6930e094$var$SuspenseException;
        throw x;
    }
}
var $12584cae6930e094$var$suspendedThenable = null;
function $12584cae6930e094$var$getSuspendedThenable() {
    if (null === $12584cae6930e094$var$suspendedThenable) throw Error($12584cae6930e094$var$formatProdErrorMessage(459));
    var thenable = $12584cae6930e094$var$suspendedThenable;
    $12584cae6930e094$var$suspendedThenable = null;
    return thenable;
}
function $12584cae6930e094$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $12584cae6930e094$var$SuspenseException || rejectedReason === $12584cae6930e094$var$SuspenseActionException) throw Error($12584cae6930e094$var$formatProdErrorMessage(483));
}
var $12584cae6930e094$var$thenableState$1 = null, $12584cae6930e094$var$thenableIndexCounter$1 = 0;
function $12584cae6930e094$var$unwrapThenable(thenable) {
    var index = $12584cae6930e094$var$thenableIndexCounter$1;
    $12584cae6930e094$var$thenableIndexCounter$1 += 1;
    null === $12584cae6930e094$var$thenableState$1 && ($12584cae6930e094$var$thenableState$1 = []);
    return $12584cae6930e094$var$trackUsedThenable($12584cae6930e094$var$thenableState$1, thenable, index);
}
function $12584cae6930e094$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $12584cae6930e094$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $12584cae6930e094$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($12584cae6930e094$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($12584cae6930e094$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $12584cae6930e094$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null === currentFirstChild.key ? existingChildren.set(currentFirstChild.index, currentFirstChild) : existingChildren.set(currentFirstChild.key, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $12584cae6930e094$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 2, lastPlacedIndex) : newIndex;
        newFiber.flags |= 134217730;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 134217730);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $12584cae6930e094$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $12584cae6930e094$var$REACT_FRAGMENT_TYPE) return returnFiber = updateFragment(returnFiber, current, element.props.children, lanes, element.key), $12584cae6930e094$var$coerceRef(returnFiber, element), returnFiber;
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $12584cae6930e094$var$REACT_LAZY_TYPE && $12584cae6930e094$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $12584cae6930e094$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $12584cae6930e094$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $12584cae6930e094$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $12584cae6930e094$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $12584cae6930e094$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $12584cae6930e094$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $12584cae6930e094$var$REACT_ELEMENT_TYPE:
                    return lanes = $12584cae6930e094$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $12584cae6930e094$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $12584cae6930e094$var$REACT_PORTAL_TYPE:
                    return newChild = $12584cae6930e094$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $12584cae6930e094$var$REACT_LAZY_TYPE:
                    return newChild = $12584cae6930e094$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($12584cae6930e094$var$isArrayImpl(newChild) || $12584cae6930e094$var$getIteratorFn(newChild)) return newChild = $12584cae6930e094$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $12584cae6930e094$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $12584cae6930e094$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $12584cae6930e094$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $12584cae6930e094$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $12584cae6930e094$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $12584cae6930e094$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $12584cae6930e094$var$REACT_LAZY_TYPE:
                    return newChild = $12584cae6930e094$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($12584cae6930e094$var$isArrayImpl(newChild) || $12584cae6930e094$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $12584cae6930e094$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $12584cae6930e094$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $12584cae6930e094$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $12584cae6930e094$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $12584cae6930e094$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $12584cae6930e094$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $12584cae6930e094$var$REACT_LAZY_TYPE:
                    return newChild = $12584cae6930e094$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($12584cae6930e094$var$isArrayImpl(newChild) || $12584cae6930e094$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $12584cae6930e094$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $12584cae6930e094$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $12584cae6930e094$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $12584cae6930e094$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $12584cae6930e094$var$isHydrating && $12584cae6930e094$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $12584cae6930e094$var$isHydrating && $12584cae6930e094$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && (newFiber = nextOldFiber.alternate, null !== newFiber && oldFiber.delete(null === newFiber.key ? newIdx : newFiber.key)), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $12584cae6930e094$var$isHydrating && $12584cae6930e094$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($12584cae6930e094$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $12584cae6930e094$var$isHydrating && $12584cae6930e094$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $12584cae6930e094$var$isHydrating && $12584cae6930e094$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && (nextOldFiber = step.alternate, null !== nextOldFiber && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key)), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $12584cae6930e094$var$isHydrating && $12584cae6930e094$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $12584cae6930e094$var$REACT_FRAGMENT_TYPE && null === newChild.key && void 0 === newChild.props.ref && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $12584cae6930e094$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $12584cae6930e094$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        $12584cae6930e094$var$coerceRef(lanes, newChild);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $12584cae6930e094$var$REACT_LAZY_TYPE && $12584cae6930e094$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $12584cae6930e094$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $12584cae6930e094$var$REACT_FRAGMENT_TYPE ? (lanes = $12584cae6930e094$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), $12584cae6930e094$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $12584cae6930e094$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $12584cae6930e094$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $12584cae6930e094$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $12584cae6930e094$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $12584cae6930e094$var$REACT_LAZY_TYPE:
                    return newChild = $12584cae6930e094$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($12584cae6930e094$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($12584cae6930e094$var$getIteratorFn(newChild)) {
                key = $12584cae6930e094$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($12584cae6930e094$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $12584cae6930e094$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $12584cae6930e094$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $12584cae6930e094$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $12584cae6930e094$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $12584cae6930e094$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $12584cae6930e094$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $12584cae6930e094$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $12584cae6930e094$var$SuspenseException || x === $12584cae6930e094$var$SuspenseActionException) throw x;
            var fiber = $12584cae6930e094$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $12584cae6930e094$var$reconcileChildFibers = $12584cae6930e094$var$createChildReconciler(!0), $12584cae6930e094$var$mountChildFibers = $12584cae6930e094$var$createChildReconciler(!1), $12584cae6930e094$var$hasForceUpdate = !1;
function $12584cae6930e094$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $12584cae6930e094$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $12584cae6930e094$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $12584cae6930e094$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($12584cae6930e094$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $12584cae6930e094$var$getRootForUpdatedFiber(fiber);
        $12584cae6930e094$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $12584cae6930e094$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $12584cae6930e094$var$getRootForUpdatedFiber(fiber);
}
function $12584cae6930e094$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $12584cae6930e094$var$markRootEntangled(root, lane);
    }
}
function $12584cae6930e094$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $12584cae6930e094$var$didReadFromEntangledAsyncAction = !1;
function $12584cae6930e094$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($12584cae6930e094$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $12584cae6930e094$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $12584cae6930e094$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $12584cae6930e094$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $12584cae6930e094$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($12584cae6930e094$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $12584cae6930e094$var$currentEntangledLane && ($12584cae6930e094$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $12584cae6930e094$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $12584cae6930e094$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $12584cae6930e094$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $12584cae6930e094$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($12584cae6930e094$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $12584cae6930e094$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$12584cae6930e094$var$callCallback(callbacks[updateQueue], context);
}
var $12584cae6930e094$var$currentTreeHiddenStackCursor = $12584cae6930e094$var$createCursor(null), $12584cae6930e094$var$prevEntangledRenderLanesCursor = $12584cae6930e094$var$createCursor(0);
function $12584cae6930e094$var$pushHiddenContext(fiber, context) {
    fiber = $12584cae6930e094$var$entangledRenderLanes;
    $12584cae6930e094$var$push($12584cae6930e094$var$prevEntangledRenderLanesCursor, fiber);
    $12584cae6930e094$var$push($12584cae6930e094$var$currentTreeHiddenStackCursor, context);
    $12584cae6930e094$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $12584cae6930e094$var$reuseHiddenContextOnStack() {
    $12584cae6930e094$var$push($12584cae6930e094$var$prevEntangledRenderLanesCursor, $12584cae6930e094$var$entangledRenderLanes);
    $12584cae6930e094$var$push($12584cae6930e094$var$currentTreeHiddenStackCursor, $12584cae6930e094$var$currentTreeHiddenStackCursor.current);
}
function $12584cae6930e094$var$popHiddenContext() {
    $12584cae6930e094$var$entangledRenderLanes = $12584cae6930e094$var$prevEntangledRenderLanesCursor.current;
    $12584cae6930e094$var$pop($12584cae6930e094$var$currentTreeHiddenStackCursor);
    $12584cae6930e094$var$pop($12584cae6930e094$var$prevEntangledRenderLanesCursor);
}
var $12584cae6930e094$var$suspenseHandlerStackCursor = $12584cae6930e094$var$createCursor(null), $12584cae6930e094$var$shellBoundary = null;
function $12584cae6930e094$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $12584cae6930e094$var$push($12584cae6930e094$var$suspenseStackCursor, $12584cae6930e094$var$suspenseStackCursor.current & 1);
    $12584cae6930e094$var$push($12584cae6930e094$var$suspenseHandlerStackCursor, handler);
    null === $12584cae6930e094$var$shellBoundary && (null === current || null !== $12584cae6930e094$var$currentTreeHiddenStackCursor.current ? $12584cae6930e094$var$shellBoundary = handler : null !== current.memoizedState && ($12584cae6930e094$var$shellBoundary = handler));
}
function $12584cae6930e094$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $12584cae6930e094$var$push($12584cae6930e094$var$suspenseStackCursor, $12584cae6930e094$var$suspenseStackCursor.current);
    $12584cae6930e094$var$push($12584cae6930e094$var$suspenseHandlerStackCursor, fiber);
    null === $12584cae6930e094$var$shellBoundary && ($12584cae6930e094$var$shellBoundary = fiber);
}
function $12584cae6930e094$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($12584cae6930e094$var$push($12584cae6930e094$var$suspenseStackCursor, $12584cae6930e094$var$suspenseStackCursor.current), $12584cae6930e094$var$push($12584cae6930e094$var$suspenseHandlerStackCursor, fiber), null === $12584cae6930e094$var$shellBoundary && ($12584cae6930e094$var$shellBoundary = fiber)) : $12584cae6930e094$var$reuseSuspenseHandlerOnStack();
}
function $12584cae6930e094$var$reuseSuspenseHandlerOnStack() {
    $12584cae6930e094$var$push($12584cae6930e094$var$suspenseStackCursor, $12584cae6930e094$var$suspenseStackCursor.current);
    $12584cae6930e094$var$push($12584cae6930e094$var$suspenseHandlerStackCursor, $12584cae6930e094$var$suspenseHandlerStackCursor.current);
}
function $12584cae6930e094$var$popSuspenseHandler(fiber) {
    $12584cae6930e094$var$pop($12584cae6930e094$var$suspenseHandlerStackCursor);
    $12584cae6930e094$var$shellBoundary === fiber && ($12584cae6930e094$var$shellBoundary = null);
    $12584cae6930e094$var$pop($12584cae6930e094$var$suspenseStackCursor);
}
var $12584cae6930e094$var$suspenseStackCursor = $12584cae6930e094$var$createCursor(0);
function $12584cae6930e094$var$pushSuspenseListContext(fiber, newContext) {
    $12584cae6930e094$var$push($12584cae6930e094$var$suspenseHandlerStackCursor, $12584cae6930e094$var$suspenseHandlerStackCursor.current);
    $12584cae6930e094$var$push($12584cae6930e094$var$suspenseStackCursor, newContext);
}
function $12584cae6930e094$var$popSuspenseListContext(fiber) {
    $12584cae6930e094$var$pop($12584cae6930e094$var$suspenseStackCursor);
    $12584cae6930e094$var$pop($12584cae6930e094$var$suspenseHandlerStackCursor);
    $12584cae6930e094$var$shellBoundary === fiber && ($12584cae6930e094$var$shellBoundary = null);
}
function $12584cae6930e094$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $12584cae6930e094$var$isSuspenseInstancePending(state) || $12584cae6930e094$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && "independent" !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $12584cae6930e094$var$renderLanes = 0, $12584cae6930e094$var$currentlyRenderingFiber = null, $12584cae6930e094$var$currentHook = null, $12584cae6930e094$var$workInProgressHook = null, $12584cae6930e094$var$didScheduleRenderPhaseUpdate = !1, $12584cae6930e094$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $12584cae6930e094$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $12584cae6930e094$var$localIdCounter = 0, $12584cae6930e094$var$thenableIndexCounter = 0, $12584cae6930e094$var$thenableState = null, $12584cae6930e094$var$globalClientIdCounter = 0;
function $12584cae6930e094$var$throwInvalidHookError() {
    throw Error($12584cae6930e094$var$formatProdErrorMessage(321));
}
function $12584cae6930e094$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$12584cae6930e094$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $12584cae6930e094$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $12584cae6930e094$var$renderLanes = nextRenderLanes;
    $12584cae6930e094$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $12584cae6930e094$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $12584cae6930e094$var$HooksDispatcherOnMount : $12584cae6930e094$var$HooksDispatcherOnUpdate;
    $12584cae6930e094$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $12584cae6930e094$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $12584cae6930e094$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $12584cae6930e094$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $12584cae6930e094$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $12584cae6930e094$var$finishRenderingHooks(current) {
    $12584cae6930e094$var$ReactSharedInternals.H = $12584cae6930e094$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $12584cae6930e094$var$currentHook && null !== $12584cae6930e094$var$currentHook.next;
    $12584cae6930e094$var$renderLanes = 0;
    $12584cae6930e094$var$workInProgressHook = $12584cae6930e094$var$currentHook = $12584cae6930e094$var$currentlyRenderingFiber = null;
    $12584cae6930e094$var$didScheduleRenderPhaseUpdate = !1;
    $12584cae6930e094$var$thenableIndexCounter = 0;
    $12584cae6930e094$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($12584cae6930e094$var$formatProdErrorMessage(300));
    null === current || $12584cae6930e094$var$didReceiveUpdate || (current = current.dependencies, null !== current && $12584cae6930e094$var$checkIfContextChanged(current) && ($12584cae6930e094$var$didReceiveUpdate = !0));
}
function $12584cae6930e094$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $12584cae6930e094$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $12584cae6930e094$var$didScheduleRenderPhaseUpdateDuringThisPass && ($12584cae6930e094$var$thenableState = null);
        $12584cae6930e094$var$thenableIndexCounter = 0;
        $12584cae6930e094$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($12584cae6930e094$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $12584cae6930e094$var$workInProgressHook = $12584cae6930e094$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $12584cae6930e094$var$ReactSharedInternals.H = $12584cae6930e094$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($12584cae6930e094$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $12584cae6930e094$var$TransitionAwareHostComponent() {
    var dispatcher = $12584cae6930e094$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $12584cae6930e094$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $12584cae6930e094$var$currentHook ? $12584cae6930e094$var$currentHook.memoizedState : null) !== dispatcher && ($12584cae6930e094$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $12584cae6930e094$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $12584cae6930e094$var$localIdCounter;
    $12584cae6930e094$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $12584cae6930e094$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $12584cae6930e094$var$resetHooksOnUnwind(workInProgress) {
    if ($12584cae6930e094$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $12584cae6930e094$var$didScheduleRenderPhaseUpdate = !1;
    }
    $12584cae6930e094$var$renderLanes = 0;
    $12584cae6930e094$var$workInProgressHook = $12584cae6930e094$var$currentHook = $12584cae6930e094$var$currentlyRenderingFiber = null;
    $12584cae6930e094$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $12584cae6930e094$var$thenableIndexCounter = $12584cae6930e094$var$localIdCounter = 0;
    $12584cae6930e094$var$thenableState = null;
}
function $12584cae6930e094$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $12584cae6930e094$var$workInProgressHook ? $12584cae6930e094$var$currentlyRenderingFiber.memoizedState = $12584cae6930e094$var$workInProgressHook = hook : $12584cae6930e094$var$workInProgressHook = $12584cae6930e094$var$workInProgressHook.next = hook;
    return $12584cae6930e094$var$workInProgressHook;
}
function $12584cae6930e094$var$updateWorkInProgressHook() {
    if (null === $12584cae6930e094$var$currentHook) {
        var nextCurrentHook = $12584cae6930e094$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $12584cae6930e094$var$currentHook.next;
    var nextWorkInProgressHook = null === $12584cae6930e094$var$workInProgressHook ? $12584cae6930e094$var$currentlyRenderingFiber.memoizedState : $12584cae6930e094$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $12584cae6930e094$var$workInProgressHook = nextWorkInProgressHook, $12584cae6930e094$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $12584cae6930e094$var$currentlyRenderingFiber.alternate) throw Error($12584cae6930e094$var$formatProdErrorMessage(467));
            throw Error($12584cae6930e094$var$formatProdErrorMessage(310));
        }
        $12584cae6930e094$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $12584cae6930e094$var$currentHook.memoizedState,
            baseState: $12584cae6930e094$var$currentHook.baseState,
            baseQueue: $12584cae6930e094$var$currentHook.baseQueue,
            queue: $12584cae6930e094$var$currentHook.queue,
            next: null
        };
        null === $12584cae6930e094$var$workInProgressHook ? $12584cae6930e094$var$currentlyRenderingFiber.memoizedState = $12584cae6930e094$var$workInProgressHook = nextCurrentHook : $12584cae6930e094$var$workInProgressHook = $12584cae6930e094$var$workInProgressHook.next = nextCurrentHook;
    }
    return $12584cae6930e094$var$workInProgressHook;
}
function $12584cae6930e094$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $12584cae6930e094$var$useThenable(thenable) {
    var index = $12584cae6930e094$var$thenableIndexCounter;
    $12584cae6930e094$var$thenableIndexCounter += 1;
    null === $12584cae6930e094$var$thenableState && ($12584cae6930e094$var$thenableState = []);
    thenable = $12584cae6930e094$var$trackUsedThenable($12584cae6930e094$var$thenableState, thenable, index);
    index = $12584cae6930e094$var$currentlyRenderingFiber;
    null === (null === $12584cae6930e094$var$workInProgressHook ? index.memoizedState : $12584cae6930e094$var$workInProgressHook.next) && (index = index.alternate, $12584cae6930e094$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $12584cae6930e094$var$HooksDispatcherOnMount : $12584cae6930e094$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $12584cae6930e094$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $12584cae6930e094$var$useThenable(usable);
        if (usable.$$typeof === $12584cae6930e094$var$REACT_RECOVERABLE_TYPE) return;
        if (usable.$$typeof === $12584cae6930e094$var$REACT_CONTEXT_TYPE) return $12584cae6930e094$var$readContext(usable);
    }
    throw Error($12584cae6930e094$var$formatProdErrorMessage(438, String(usable)));
}
function $12584cae6930e094$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $12584cae6930e094$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $12584cae6930e094$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $12584cae6930e094$var$createFunctionComponentUpdateQueue(), $12584cae6930e094$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $12584cae6930e094$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $12584cae6930e094$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $12584cae6930e094$var$updateReducer(reducer) {
    var hook = $12584cae6930e094$var$updateWorkInProgressHook();
    return $12584cae6930e094$var$updateReducerImpl(hook, $12584cae6930e094$var$currentHook, reducer);
}
function $12584cae6930e094$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($12584cae6930e094$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$64 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($12584cae6930e094$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($12584cae6930e094$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $12584cae6930e094$var$currentEntangledLane && (didReadFromEntangledAsyncAction$64 = !0);
                else if (($12584cae6930e094$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $12584cae6930e094$var$currentEntangledLane && (didReadFromEntangledAsyncAction$64 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $12584cae6930e094$var$currentlyRenderingFiber.lanes |= revertLane, $12584cae6930e094$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $12584cae6930e094$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $12584cae6930e094$var$currentlyRenderingFiber.lanes |= updateLane, $12584cae6930e094$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$12584cae6930e094$var$objectIs(pendingQueue, hook.memoizedState) && ($12584cae6930e094$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$64 && (reducer = $12584cae6930e094$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $12584cae6930e094$var$rerenderReducer(reducer) {
    var hook = $12584cae6930e094$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($12584cae6930e094$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $12584cae6930e094$var$objectIs(newState, hook.memoizedState) || ($12584cae6930e094$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $12584cae6930e094$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $12584cae6930e094$var$currentlyRenderingFiber, hook = $12584cae6930e094$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $12584cae6930e094$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($12584cae6930e094$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$12584cae6930e094$var$objectIs(($12584cae6930e094$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $12584cae6930e094$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $12584cae6930e094$var$updateEffect($12584cae6930e094$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    subscribe = hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $12584cae6930e094$var$workInProgressHook && 0 !== ($12584cae6930e094$var$workInProgressHook.memoizedState.tag & 1);
    $12584cae6930e094$var$pushSimpleEffect(subscribe ? 9 : 8, {
        destroy: void 0
    }, $12584cae6930e094$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
    if (subscribe) {
        fiber.flags |= 2048;
        if (null === $12584cae6930e094$var$workInProgressRoot) throw Error($12584cae6930e094$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($12584cae6930e094$var$renderLanes & 127) || $12584cae6930e094$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $12584cae6930e094$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $12584cae6930e094$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $12584cae6930e094$var$createFunctionComponentUpdateQueue(), $12584cae6930e094$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $12584cae6930e094$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $12584cae6930e094$var$checkIfSnapshotChanged(inst) && $12584cae6930e094$var$forceStoreRerender(fiber);
}
function $12584cae6930e094$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $12584cae6930e094$var$checkIfSnapshotChanged(inst) && $12584cae6930e094$var$forceStoreRerender(fiber);
    });
}
function $12584cae6930e094$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$12584cae6930e094$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $12584cae6930e094$var$forceStoreRerender(fiber) {
    var root = $12584cae6930e094$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $12584cae6930e094$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $12584cae6930e094$var$mountStateImpl(initialState) {
    var hook = $12584cae6930e094$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($12584cae6930e094$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $12584cae6930e094$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $12584cae6930e094$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $12584cae6930e094$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $12584cae6930e094$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $12584cae6930e094$var$updateReducerImpl(hook, $12584cae6930e094$var$currentHook, "function" === typeof reducer ? reducer : $12584cae6930e094$var$basicStateReducer);
}
function $12584cae6930e094$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($12584cae6930e094$var$isRenderPhaseUpdate(fiber)) throw Error($12584cae6930e094$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $12584cae6930e094$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $12584cae6930e094$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $12584cae6930e094$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $12584cae6930e094$var$ReactSharedInternals.T, currentTransition = {};
        currentTransition.types = null !== prevTransition ? prevTransition.types : null;
        $12584cae6930e094$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $12584cae6930e094$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $12584cae6930e094$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $12584cae6930e094$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $12584cae6930e094$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $12584cae6930e094$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$70) {
        $12584cae6930e094$var$onActionError(actionQueue, node, error$70);
    }
}
function $12584cae6930e094$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $12584cae6930e094$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $12584cae6930e094$var$onActionError(actionQueue, node, error);
    }) : $12584cae6930e094$var$onActionSuccess(actionQueue, node, returnValue);
}
function $12584cae6930e094$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $12584cae6930e094$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $12584cae6930e094$var$runActionStateAction(actionQueue, nextState)));
}
function $12584cae6930e094$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $12584cae6930e094$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $12584cae6930e094$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $12584cae6930e094$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $12584cae6930e094$var$mountActionState(action, initialStateProp) {
    if ($12584cae6930e094$var$isHydrating) {
        var ssrFormState = $12584cae6930e094$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $12584cae6930e094$var$currentlyRenderingFiber;
                if ($12584cae6930e094$var$isHydrating) {
                    if ($12584cae6930e094$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $12584cae6930e094$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $12584cae6930e094$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $12584cae6930e094$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $12584cae6930e094$var$nextHydratableInstance = $12584cae6930e094$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $12584cae6930e094$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $12584cae6930e094$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $12584cae6930e094$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $12584cae6930e094$var$dispatchSetState.bind(null, $12584cae6930e094$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $12584cae6930e094$var$mountStateImpl(!1);
    inRootOrSingleton = $12584cae6930e094$var$dispatchOptimisticSetState.bind(null, $12584cae6930e094$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $12584cae6930e094$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $12584cae6930e094$var$dispatchActionState.bind(null, $12584cae6930e094$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $12584cae6930e094$var$updateActionState(action) {
    var stateHook = $12584cae6930e094$var$updateWorkInProgressHook();
    return $12584cae6930e094$var$updateActionStateImpl(stateHook, $12584cae6930e094$var$currentHook, action);
}
function $12584cae6930e094$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $12584cae6930e094$var$updateReducerImpl(stateHook, currentStateHook, $12584cae6930e094$var$actionStateReducer)[0];
    stateHook = $12584cae6930e094$var$updateReducer($12584cae6930e094$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $12584cae6930e094$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $12584cae6930e094$var$SuspenseException) throw $12584cae6930e094$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $12584cae6930e094$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($12584cae6930e094$var$currentlyRenderingFiber.flags |= 2048, $12584cae6930e094$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $12584cae6930e094$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $12584cae6930e094$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $12584cae6930e094$var$rerenderActionState(action) {
    var stateHook = $12584cae6930e094$var$updateWorkInProgressHook(), currentStateHook = $12584cae6930e094$var$currentHook;
    if (null !== currentStateHook) return $12584cae6930e094$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $12584cae6930e094$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $12584cae6930e094$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $12584cae6930e094$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $12584cae6930e094$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $12584cae6930e094$var$createFunctionComponentUpdateQueue(), $12584cae6930e094$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $12584cae6930e094$var$updateRef() {
    return $12584cae6930e094$var$updateWorkInProgressHook().memoizedState;
}
function $12584cae6930e094$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $12584cae6930e094$var$mountWorkInProgressHook();
    $12584cae6930e094$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $12584cae6930e094$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $12584cae6930e094$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $12584cae6930e094$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $12584cae6930e094$var$currentHook && null !== deps && $12584cae6930e094$var$areHookInputsEqual(deps, $12584cae6930e094$var$currentHook.memoizedState.deps) ? hook.memoizedState = $12584cae6930e094$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($12584cae6930e094$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $12584cae6930e094$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $12584cae6930e094$var$mountEffect(create, deps) {
    $12584cae6930e094$var$mountEffectImpl(8390656, 8, create, deps);
}
function $12584cae6930e094$var$updateEffect(create, deps) {
    $12584cae6930e094$var$updateEffectImpl(2048, 8, create, deps);
}
function $12584cae6930e094$var$useEffectEventImpl(payload) {
    $12584cae6930e094$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $12584cae6930e094$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $12584cae6930e094$var$createFunctionComponentUpdateQueue(), $12584cae6930e094$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $12584cae6930e094$var$updateEvent(callback) {
    var ref = $12584cae6930e094$var$updateWorkInProgressHook().memoizedState;
    $12584cae6930e094$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($12584cae6930e094$var$executionContext & 2)) throw Error($12584cae6930e094$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $12584cae6930e094$var$updateInsertionEffect(create, deps) {
    return $12584cae6930e094$var$updateEffectImpl(4, 2, create, deps);
}
function $12584cae6930e094$var$updateLayoutEffect(create, deps) {
    return $12584cae6930e094$var$updateEffectImpl(4, 4, create, deps);
}
function $12584cae6930e094$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $12584cae6930e094$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $12584cae6930e094$var$updateEffectImpl(4, 4, $12584cae6930e094$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $12584cae6930e094$var$mountDebugValue() {}
function $12584cae6930e094$var$updateCallback(callback, deps) {
    var hook = $12584cae6930e094$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $12584cae6930e094$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $12584cae6930e094$var$updateMemo(nextCreate, deps) {
    var hook = $12584cae6930e094$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $12584cae6930e094$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($12584cae6930e094$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $12584cae6930e094$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $12584cae6930e094$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $12584cae6930e094$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($12584cae6930e094$var$renderLanes & 1073741824) && 0 === ($12584cae6930e094$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $12584cae6930e094$var$requestDeferredLane();
    $12584cae6930e094$var$currentlyRenderingFiber.lanes |= hook;
    $12584cae6930e094$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $12584cae6930e094$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($12584cae6930e094$var$objectIs(value, prevValue)) return value;
    if (null !== $12584cae6930e094$var$currentTreeHiddenStackCursor.current) return hook = $12584cae6930e094$var$mountDeferredValueImpl(hook, value, initialValue), $12584cae6930e094$var$objectIs(hook, prevValue) || ($12584cae6930e094$var$didReceiveUpdate = !0), hook;
    if (0 === ($12584cae6930e094$var$renderLanes & 106) || 0 !== ($12584cae6930e094$var$renderLanes & 1073741824) && 0 === ($12584cae6930e094$var$workInProgressRootRenderLanes & 261930)) return $12584cae6930e094$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $12584cae6930e094$var$requestDeferredLane();
    $12584cae6930e094$var$currentlyRenderingFiber.lanes |= hook;
    $12584cae6930e094$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $12584cae6930e094$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $12584cae6930e094$var$ReactDOMSharedInternals.p;
    $12584cae6930e094$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $12584cae6930e094$var$ReactSharedInternals.T, currentTransition = {};
    currentTransition.types = null !== prevTransition ? prevTransition.types : null;
    $12584cae6930e094$var$ReactSharedInternals.T = currentTransition;
    $12584cae6930e094$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $12584cae6930e094$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $12584cae6930e094$var$chainThenableValue(returnValue, finishedState);
            $12584cae6930e094$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $12584cae6930e094$var$requestUpdateLane(fiber));
        } else $12584cae6930e094$var$dispatchSetStateInternal(fiber, queue, finishedState, $12584cae6930e094$var$requestUpdateLane(fiber));
    } catch (error) {
        $12584cae6930e094$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $12584cae6930e094$var$requestUpdateLane());
    } finally{
        $12584cae6930e094$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $12584cae6930e094$var$ReactSharedInternals.T = prevTransition;
    }
}
function $12584cae6930e094$var$noop() {}
function $12584cae6930e094$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($12584cae6930e094$var$formatProdErrorMessage(476));
    var queue = $12584cae6930e094$var$ensureFormComponentIsStateful(formFiber).queue;
    $12584cae6930e094$var$startTransition(formFiber, queue, pendingState, $12584cae6930e094$var$sharedNotPendingObject, null === action ? $12584cae6930e094$var$noop : function() {
        $12584cae6930e094$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $12584cae6930e094$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $12584cae6930e094$var$sharedNotPendingObject,
        baseState: $12584cae6930e094$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $12584cae6930e094$var$basicStateReducer,
            lastRenderedState: $12584cae6930e094$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $12584cae6930e094$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $12584cae6930e094$var$requestFormReset$1(formFiber) {
    var stateHook = $12584cae6930e094$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $12584cae6930e094$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $12584cae6930e094$var$requestUpdateLane());
}
function $12584cae6930e094$var$useHostTransitionStatus() {
    return $12584cae6930e094$var$readContext($12584cae6930e094$var$HostTransitionContext);
}
function $12584cae6930e094$var$updateId() {
    return $12584cae6930e094$var$updateWorkInProgressHook().memoizedState;
}
function $12584cae6930e094$var$updateRefresh() {
    return $12584cae6930e094$var$updateWorkInProgressHook().memoizedState;
}
function $12584cae6930e094$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $12584cae6930e094$var$requestUpdateLane();
                fiber = $12584cae6930e094$var$createUpdate(lane);
                var root$73 = $12584cae6930e094$var$enqueueUpdate(provider, fiber, lane);
                null !== root$73 && ($12584cae6930e094$var$scheduleUpdateOnFiber(root$73, provider, lane), $12584cae6930e094$var$entangleTransitions(root$73, provider, lane));
                provider = {
                    cache: $12584cae6930e094$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $12584cae6930e094$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $12584cae6930e094$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $12584cae6930e094$var$isRenderPhaseUpdate(fiber) ? $12584cae6930e094$var$enqueueRenderPhaseUpdate(queue, action) : (action = $12584cae6930e094$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($12584cae6930e094$var$scheduleUpdateOnFiber(action, fiber, lane), $12584cae6930e094$var$entangleTransitionUpdate(action, queue, lane)));
}
function $12584cae6930e094$var$dispatchSetState(fiber, queue, action) {
    var lane = $12584cae6930e094$var$requestUpdateLane();
    $12584cae6930e094$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $12584cae6930e094$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($12584cae6930e094$var$isRenderPhaseUpdate(fiber)) $12584cae6930e094$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($12584cae6930e094$var$objectIs(eagerState, currentState)) return $12584cae6930e094$var$enqueueUpdate$1(fiber, queue, update, 0), null === $12584cae6930e094$var$workInProgressRoot && $12584cae6930e094$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $12584cae6930e094$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $12584cae6930e094$var$scheduleUpdateOnFiber(action, fiber, lane), $12584cae6930e094$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $12584cae6930e094$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $12584cae6930e094$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($12584cae6930e094$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($12584cae6930e094$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $12584cae6930e094$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $12584cae6930e094$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $12584cae6930e094$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $12584cae6930e094$var$currentlyRenderingFiber || null !== alternate && alternate === $12584cae6930e094$var$currentlyRenderingFiber;
}
function $12584cae6930e094$var$enqueueRenderPhaseUpdate(queue, update) {
    $12584cae6930e094$var$didScheduleRenderPhaseUpdateDuringThisPass = $12584cae6930e094$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $12584cae6930e094$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $12584cae6930e094$var$markRootEntangled(root, lane);
    }
}
var $12584cae6930e094$var$ContextOnlyDispatcher = {
    readContext: $12584cae6930e094$var$readContext,
    use: $12584cae6930e094$var$use,
    useCallback: $12584cae6930e094$var$throwInvalidHookError,
    useContext: $12584cae6930e094$var$throwInvalidHookError,
    useEffect: $12584cae6930e094$var$throwInvalidHookError,
    useImperativeHandle: $12584cae6930e094$var$throwInvalidHookError,
    useLayoutEffect: $12584cae6930e094$var$throwInvalidHookError,
    useInsertionEffect: $12584cae6930e094$var$throwInvalidHookError,
    useMemo: $12584cae6930e094$var$throwInvalidHookError,
    useReducer: $12584cae6930e094$var$throwInvalidHookError,
    useRef: $12584cae6930e094$var$throwInvalidHookError,
    useState: $12584cae6930e094$var$throwInvalidHookError,
    useDebugValue: $12584cae6930e094$var$throwInvalidHookError,
    useDeferredValue: $12584cae6930e094$var$throwInvalidHookError,
    useTransition: $12584cae6930e094$var$throwInvalidHookError,
    useSyncExternalStore: $12584cae6930e094$var$throwInvalidHookError,
    useId: $12584cae6930e094$var$throwInvalidHookError,
    useHostTransitionStatus: $12584cae6930e094$var$throwInvalidHookError,
    useFormState: $12584cae6930e094$var$throwInvalidHookError,
    useActionState: $12584cae6930e094$var$throwInvalidHookError,
    useOptimistic: $12584cae6930e094$var$throwInvalidHookError,
    useMemoCache: $12584cae6930e094$var$throwInvalidHookError,
    useCacheRefresh: $12584cae6930e094$var$throwInvalidHookError,
    useEffectEvent: $12584cae6930e094$var$throwInvalidHookError
}, $12584cae6930e094$var$HooksDispatcherOnMount = {
    readContext: $12584cae6930e094$var$readContext,
    use: $12584cae6930e094$var$use,
    useCallback: function(callback, deps) {
        $12584cae6930e094$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $12584cae6930e094$var$readContext,
    useEffect: $12584cae6930e094$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $12584cae6930e094$var$mountEffectImpl(4194308, 4, $12584cae6930e094$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $12584cae6930e094$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $12584cae6930e094$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $12584cae6930e094$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($12584cae6930e094$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $12584cae6930e094$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $12584cae6930e094$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $12584cae6930e094$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($12584cae6930e094$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $12584cae6930e094$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $12584cae6930e094$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $12584cae6930e094$var$dispatchReducerAction.bind(null, $12584cae6930e094$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $12584cae6930e094$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $12584cae6930e094$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $12584cae6930e094$var$dispatchSetState.bind(null, $12584cae6930e094$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $12584cae6930e094$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $12584cae6930e094$var$mountWorkInProgressHook();
        return $12584cae6930e094$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $12584cae6930e094$var$mountStateImpl(!1);
        stateHook = $12584cae6930e094$var$startTransition.bind(null, $12584cae6930e094$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $12584cae6930e094$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $12584cae6930e094$var$currentlyRenderingFiber, hook = $12584cae6930e094$var$mountWorkInProgressHook();
        if ($12584cae6930e094$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($12584cae6930e094$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $12584cae6930e094$var$workInProgressRoot) throw Error($12584cae6930e094$var$formatProdErrorMessage(349));
            0 !== ($12584cae6930e094$var$workInProgressRootRenderLanes & 127) || $12584cae6930e094$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $12584cae6930e094$var$mountEffect($12584cae6930e094$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $12584cae6930e094$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $12584cae6930e094$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $12584cae6930e094$var$mountWorkInProgressHook(), identifierPrefix = $12584cae6930e094$var$workInProgressRoot.identifierPrefix;
        if ($12584cae6930e094$var$isHydrating) {
            var JSCompiler_inline_result = $12584cae6930e094$var$treeContextOverflow;
            var idWithLeadingBit = $12584cae6930e094$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $12584cae6930e094$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $12584cae6930e094$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $12584cae6930e094$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $12584cae6930e094$var$useHostTransitionStatus,
    useFormState: $12584cae6930e094$var$mountActionState,
    useActionState: $12584cae6930e094$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $12584cae6930e094$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $12584cae6930e094$var$dispatchOptimisticSetState.bind(null, $12584cae6930e094$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $12584cae6930e094$var$useMemoCache,
    useCacheRefresh: function() {
        return $12584cae6930e094$var$mountWorkInProgressHook().memoizedState = $12584cae6930e094$var$refreshCache.bind(null, $12584cae6930e094$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $12584cae6930e094$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($12584cae6930e094$var$executionContext & 2)) throw Error($12584cae6930e094$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $12584cae6930e094$var$HooksDispatcherOnUpdate = {
    readContext: $12584cae6930e094$var$readContext,
    use: $12584cae6930e094$var$use,
    useCallback: $12584cae6930e094$var$updateCallback,
    useContext: $12584cae6930e094$var$readContext,
    useEffect: $12584cae6930e094$var$updateEffect,
    useImperativeHandle: $12584cae6930e094$var$updateImperativeHandle,
    useInsertionEffect: $12584cae6930e094$var$updateInsertionEffect,
    useLayoutEffect: $12584cae6930e094$var$updateLayoutEffect,
    useMemo: $12584cae6930e094$var$updateMemo,
    useReducer: $12584cae6930e094$var$updateReducer,
    useRef: $12584cae6930e094$var$updateRef,
    useState: function() {
        return $12584cae6930e094$var$updateReducer($12584cae6930e094$var$basicStateReducer);
    },
    useDebugValue: $12584cae6930e094$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $12584cae6930e094$var$updateWorkInProgressHook();
        return $12584cae6930e094$var$updateDeferredValueImpl(hook, $12584cae6930e094$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $12584cae6930e094$var$updateReducer($12584cae6930e094$var$basicStateReducer)[0], start = $12584cae6930e094$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $12584cae6930e094$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $12584cae6930e094$var$updateSyncExternalStore,
    useId: $12584cae6930e094$var$updateId,
    useHostTransitionStatus: $12584cae6930e094$var$useHostTransitionStatus,
    useFormState: $12584cae6930e094$var$updateActionState,
    useActionState: $12584cae6930e094$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $12584cae6930e094$var$updateWorkInProgressHook();
        return $12584cae6930e094$var$updateOptimisticImpl(hook, $12584cae6930e094$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $12584cae6930e094$var$useMemoCache,
    useCacheRefresh: $12584cae6930e094$var$updateRefresh,
    useEffectEvent: $12584cae6930e094$var$updateEvent
}, $12584cae6930e094$var$HooksDispatcherOnRerender = {
    readContext: $12584cae6930e094$var$readContext,
    use: $12584cae6930e094$var$use,
    useCallback: $12584cae6930e094$var$updateCallback,
    useContext: $12584cae6930e094$var$readContext,
    useEffect: $12584cae6930e094$var$updateEffect,
    useImperativeHandle: $12584cae6930e094$var$updateImperativeHandle,
    useInsertionEffect: $12584cae6930e094$var$updateInsertionEffect,
    useLayoutEffect: $12584cae6930e094$var$updateLayoutEffect,
    useMemo: $12584cae6930e094$var$updateMemo,
    useReducer: $12584cae6930e094$var$rerenderReducer,
    useRef: $12584cae6930e094$var$updateRef,
    useState: function() {
        return $12584cae6930e094$var$rerenderReducer($12584cae6930e094$var$basicStateReducer);
    },
    useDebugValue: $12584cae6930e094$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $12584cae6930e094$var$updateWorkInProgressHook();
        return null === $12584cae6930e094$var$currentHook ? $12584cae6930e094$var$mountDeferredValueImpl(hook, value, initialValue) : $12584cae6930e094$var$updateDeferredValueImpl(hook, $12584cae6930e094$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $12584cae6930e094$var$rerenderReducer($12584cae6930e094$var$basicStateReducer)[0], start = $12584cae6930e094$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $12584cae6930e094$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $12584cae6930e094$var$updateSyncExternalStore,
    useId: $12584cae6930e094$var$updateId,
    useHostTransitionStatus: $12584cae6930e094$var$useHostTransitionStatus,
    useFormState: $12584cae6930e094$var$rerenderActionState,
    useActionState: $12584cae6930e094$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $12584cae6930e094$var$updateWorkInProgressHook();
        if (null !== $12584cae6930e094$var$currentHook) return $12584cae6930e094$var$updateOptimisticImpl(hook, $12584cae6930e094$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $12584cae6930e094$var$useMemoCache,
    useCacheRefresh: $12584cae6930e094$var$updateRefresh,
    useEffectEvent: $12584cae6930e094$var$updateEvent
};
function $12584cae6930e094$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $12584cae6930e094$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $12584cae6930e094$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $12584cae6930e094$var$requestUpdateLane(), update = $12584cae6930e094$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $12584cae6930e094$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($12584cae6930e094$var$scheduleUpdateOnFiber(payload, inst, lane), $12584cae6930e094$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $12584cae6930e094$var$requestUpdateLane(), update = $12584cae6930e094$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $12584cae6930e094$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($12584cae6930e094$var$scheduleUpdateOnFiber(payload, inst, lane), $12584cae6930e094$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $12584cae6930e094$var$requestUpdateLane(), update = $12584cae6930e094$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $12584cae6930e094$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($12584cae6930e094$var$scheduleUpdateOnFiber(callback, inst, lane), $12584cae6930e094$var$entangleTransitions(callback, inst, lane));
    }
};
function $12584cae6930e094$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$12584cae6930e094$var$shallowEqual(oldProps, newProps) || !$12584cae6930e094$var$shallowEqual(oldState, newState) : !0;
}
function $12584cae6930e094$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $12584cae6930e094$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $12584cae6930e094$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $12584cae6930e094$var$assign({}, newProps));
        for(var propName$77 in Component)void 0 === newProps[propName$77] && (newProps[propName$77] = Component[propName$77]);
    }
    return newProps;
}
function $12584cae6930e094$var$defaultOnUncaughtError(error) {
    $12584cae6930e094$var$reportGlobalError(error);
}
function $12584cae6930e094$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $12584cae6930e094$var$defaultOnRecoverableError(error) {
    $12584cae6930e094$var$reportGlobalError(error);
}
function $12584cae6930e094$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$78) {
        setTimeout(function() {
            throw e$78;
        });
    }
}
function $12584cae6930e094$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$79) {
        setTimeout(function() {
            throw e$79;
        });
    }
}
function $12584cae6930e094$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $12584cae6930e094$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $12584cae6930e094$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $12584cae6930e094$var$createClassErrorUpdate(lane) {
    lane = $12584cae6930e094$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $12584cae6930e094$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $12584cae6930e094$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $12584cae6930e094$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $12584cae6930e094$var$legacyErrorBoundariesThatAlreadyFailed ? $12584cae6930e094$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $12584cae6930e094$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $12584cae6930e094$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $12584cae6930e094$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $12584cae6930e094$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                case 19:
                    return null === $12584cae6930e094$var$shellBoundary ? $12584cae6930e094$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $12584cae6930e094$var$workInProgressRootExitStatus && ($12584cae6930e094$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $12584cae6930e094$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $12584cae6930e094$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $12584cae6930e094$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $12584cae6930e094$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($12584cae6930e094$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $12584cae6930e094$var$attachPingListener(root, value, rootRenderLanes);
        $12584cae6930e094$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($12584cae6930e094$var$isHydrating) return returnFiber = $12584cae6930e094$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $12584cae6930e094$var$HydrationMismatchException && (root = Error($12584cae6930e094$var$formatProdErrorMessage(422), {
        cause: value
    }), $12584cae6930e094$var$queueHydrationError($12584cae6930e094$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $12584cae6930e094$var$HydrationMismatchException && (returnFiber = Error($12584cae6930e094$var$formatProdErrorMessage(423), {
        cause: value
    }), $12584cae6930e094$var$queueHydrationError($12584cae6930e094$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $12584cae6930e094$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $12584cae6930e094$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $12584cae6930e094$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $12584cae6930e094$var$workInProgressRootExitStatus && ($12584cae6930e094$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($12584cae6930e094$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $12584cae6930e094$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $12584cae6930e094$var$workInProgressRootConcurrentErrors ? $12584cae6930e094$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $12584cae6930e094$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $12584cae6930e094$var$workInProgressRootExitStatus && ($12584cae6930e094$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $12584cae6930e094$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $12584cae6930e094$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $12584cae6930e094$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                returnFiber = sourceFiber.type;
                wrapperError = sourceFiber.stateNode;
                if (0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $12584cae6930e094$var$legacyErrorBoundariesThatAlreadyFailed || !$12584cae6930e094$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $12584cae6930e094$var$createClassErrorUpdate(rootRenderLanes), $12584cae6930e094$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $12584cae6930e094$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
                break;
            case 22:
                if (null !== sourceFiber.memoizedState) return sourceFiber.flags |= 65536, !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $12584cae6930e094$var$SelectiveHydrationException = Error($12584cae6930e094$var$formatProdErrorMessage(461)), $12584cae6930e094$var$didReceiveUpdate = !1;
function $12584cae6930e094$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $12584cae6930e094$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $12584cae6930e094$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $12584cae6930e094$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $12584cae6930e094$var$prepareToReadContext(workInProgress);
    nextProps = $12584cae6930e094$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $12584cae6930e094$var$checkDidRenderIdHook();
    if (null !== current && !$12584cae6930e094$var$didReceiveUpdate) return $12584cae6930e094$var$bailoutHooks(current, workInProgress, renderLanes), $12584cae6930e094$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $12584cae6930e094$var$isHydrating && key && $12584cae6930e094$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $12584cae6930e094$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $12584cae6930e094$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$12584cae6930e094$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $12584cae6930e094$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $12584cae6930e094$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$12584cae6930e094$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $12584cae6930e094$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $12584cae6930e094$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $12584cae6930e094$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $12584cae6930e094$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($12584cae6930e094$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($12584cae6930e094$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $12584cae6930e094$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($12584cae6930e094$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $12584cae6930e094$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $12584cae6930e094$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $12584cae6930e094$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $12584cae6930e094$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $12584cae6930e094$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $12584cae6930e094$var$pushHiddenContext(workInProgress, prevState) : $12584cae6930e094$var$reuseHiddenContextOnStack(), $12584cae6930e094$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $12584cae6930e094$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($12584cae6930e094$var$pushTransition(workInProgress, prevState.cachePool), $12584cae6930e094$var$pushHiddenContext(workInProgress, prevState), $12584cae6930e094$var$reuseSuspenseHandlerOnStack(), workInProgress.memoizedState = null) : (null !== current && $12584cae6930e094$var$pushTransition(workInProgress, null), $12584cae6930e094$var$reuseHiddenContextOnStack(), $12584cae6930e094$var$reuseSuspenseHandlerOnStack());
    $12584cae6930e094$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $12584cae6930e094$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $12584cae6930e094$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $12584cae6930e094$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $12584cae6930e094$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $12584cae6930e094$var$pushTransition(workInProgress, null);
    $12584cae6930e094$var$reuseHiddenContextOnStack();
    $12584cae6930e094$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $12584cae6930e094$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $12584cae6930e094$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $12584cae6930e094$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $12584cae6930e094$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $12584cae6930e094$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $12584cae6930e094$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $12584cae6930e094$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $12584cae6930e094$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($12584cae6930e094$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $12584cae6930e094$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, current.memoizedState = {
                baseLanes: 0,
                cachePool: null
            }, $12584cae6930e094$var$bailoutOffscreenComponent(null, current);
            $12584cae6930e094$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $12584cae6930e094$var$nextHydratableInstance) ? (current = $12584cae6930e094$var$canHydrateHydrationBoundary(current, $12584cae6930e094$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $12584cae6930e094$var$treeContextProvider ? {
                    id: $12584cae6930e094$var$treeContextId,
                    overflow: $12584cae6930e094$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $12584cae6930e094$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $12584cae6930e094$var$hydrationParentFiber = workInProgress, $12584cae6930e094$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $12584cae6930e094$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $12584cae6930e094$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $12584cae6930e094$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $12584cae6930e094$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($12584cae6930e094$var$formatProdErrorMessage(558));
        } else if ($12584cae6930e094$var$didReceiveUpdate || $12584cae6930e094$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $12584cae6930e094$var$didReceiveUpdate || didSuspend) {
            if (null === $12584cae6930e094$var$currentTreeHiddenStackCursor.current) {
                nextProps = $12584cae6930e094$var$workInProgressRoot;
                if (null !== nextProps && (dehydrated = $12584cae6930e094$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $12584cae6930e094$var$enqueueConcurrentRenderForLane(current, dehydrated), $12584cae6930e094$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $12584cae6930e094$var$SelectiveHydrationException;
                $12584cae6930e094$var$renderDidSuspendDelayIfPossible();
            }
            workInProgress = $12584cae6930e094$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $12584cae6930e094$var$nextHydratableInstance = $12584cae6930e094$var$getNextHydratable(dehydrated.nextSibling), $12584cae6930e094$var$hydrationParentFiber = workInProgress, $12584cae6930e094$var$isHydrating = !0, $12584cae6930e094$var$hydrationErrors = null, $12584cae6930e094$var$rootOrSingletonContext = !1, null !== current && $12584cae6930e094$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $12584cae6930e094$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 134221824;
        return workInProgress;
    }
    current = $12584cae6930e094$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $12584cae6930e094$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($12584cae6930e094$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $12584cae6930e094$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $12584cae6930e094$var$prepareToReadContext(workInProgress);
    Component = $12584cae6930e094$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $12584cae6930e094$var$checkDidRenderIdHook();
    if (null !== current && !$12584cae6930e094$var$didReceiveUpdate) return $12584cae6930e094$var$bailoutHooks(current, workInProgress, renderLanes), $12584cae6930e094$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $12584cae6930e094$var$isHydrating && nextProps && $12584cae6930e094$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $12584cae6930e094$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $12584cae6930e094$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $12584cae6930e094$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $12584cae6930e094$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $12584cae6930e094$var$finishRenderingHooks(current);
    Component = $12584cae6930e094$var$checkDidRenderIdHook();
    if (null !== current && !$12584cae6930e094$var$didReceiveUpdate) return $12584cae6930e094$var$bailoutHooks(current, workInProgress, renderLanes), $12584cae6930e094$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $12584cae6930e094$var$isHydrating && Component && $12584cae6930e094$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $12584cae6930e094$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $12584cae6930e094$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $12584cae6930e094$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $12584cae6930e094$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $12584cae6930e094$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $12584cae6930e094$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $12584cae6930e094$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $12584cae6930e094$var$readContext(contextType) : $12584cae6930e094$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($12584cae6930e094$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $12584cae6930e094$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $12584cae6930e094$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $12584cae6930e094$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $12584cae6930e094$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $12584cae6930e094$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $12584cae6930e094$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $12584cae6930e094$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $12584cae6930e094$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $12584cae6930e094$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $12584cae6930e094$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $12584cae6930e094$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($12584cae6930e094$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $12584cae6930e094$var$hasForceUpdate || $12584cae6930e094$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $12584cae6930e094$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $12584cae6930e094$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $12584cae6930e094$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $12584cae6930e094$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $12584cae6930e094$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $12584cae6930e094$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $12584cae6930e094$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $12584cae6930e094$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $12584cae6930e094$var$hasForceUpdate || null !== current && null !== current.dependencies && $12584cae6930e094$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($12584cae6930e094$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $12584cae6930e094$var$hasForceUpdate || $12584cae6930e094$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $12584cae6930e094$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $12584cae6930e094$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $12584cae6930e094$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $12584cae6930e094$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $12584cae6930e094$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $12584cae6930e094$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $12584cae6930e094$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $12584cae6930e094$var$resetHydrationState();
    workInProgress.flags |= 256;
    $12584cae6930e094$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $12584cae6930e094$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $12584cae6930e094$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $12584cae6930e094$var$getSuspendedCache()
    };
}
function $12584cae6930e094$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $12584cae6930e094$var$workInProgressDeferredLane);
    return current;
}
function $12584cae6930e094$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($12584cae6930e094$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($12584cae6930e094$var$isHydrating) {
            showFallback ? $12584cae6930e094$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $12584cae6930e094$var$reuseSuspenseHandlerOnStack();
            (current = $12584cae6930e094$var$nextHydratableInstance) ? (current = $12584cae6930e094$var$canHydrateHydrationBoundary(current, $12584cae6930e094$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $12584cae6930e094$var$treeContextProvider ? {
                    id: $12584cae6930e094$var$treeContextId,
                    overflow: $12584cae6930e094$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $12584cae6930e094$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $12584cae6930e094$var$hydrationParentFiber = workInProgress, $12584cae6930e094$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $12584cae6930e094$var$throwOnHydrationMismatch(workInProgress);
            $12584cae6930e094$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        didSuspend = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $12584cae6930e094$var$reuseSuspenseHandlerOnStack(), showFallback = workInProgress.mode, didSuspend = $12584cae6930e094$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: didSuspend
        }, showFallback), nextProps = $12584cae6930e094$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), didSuspend.return = workInProgress, nextProps.return = workInProgress, didSuspend.sibling = nextProps, workInProgress.child = didSuspend, nextProps = workInProgress.child, nextProps.memoizedState = $12584cae6930e094$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $12584cae6930e094$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $12584cae6930e094$var$SUSPENDED_MARKER, $12584cae6930e094$var$bailoutOffscreenComponent(null, nextProps);
        $12584cae6930e094$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $12584cae6930e094$var$mountSuspensePrimaryChildren(workInProgress, didSuspend);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated$96 = prevState.dehydrated;
        if (null !== dehydrated$96) return $12584cae6930e094$var$updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, JSCompiler_temp, nextProps, dehydrated$96, prevState, renderLanes);
    }
    if (showFallback) return $12584cae6930e094$var$reuseSuspenseHandlerOnStack(), showFallback = nextProps.fallback, didSuspend = workInProgress.mode, prevState = current.child, dehydrated$96 = prevState.sibling, nextProps = $12584cae6930e094$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 1206910976, null !== dehydrated$96 ? showFallback = $12584cae6930e094$var$createWorkInProgress(dehydrated$96, showFallback) : (showFallback = $12584cae6930e094$var$createFiberFromFragment(showFallback, didSuspend, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $12584cae6930e094$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, showFallback = current.child.memoizedState, null === showFallback ? showFallback = $12584cae6930e094$var$mountSuspenseOffscreenState(renderLanes) : (didSuspend = showFallback.cachePool, null !== didSuspend ? (prevState = $12584cae6930e094$var$CacheContext._currentValue, didSuspend = didSuspend.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : didSuspend) : didSuspend = $12584cae6930e094$var$getSuspendedCache(), showFallback = {
        baseLanes: showFallback.baseLanes | renderLanes,
        cachePool: didSuspend
    }), nextProps.memoizedState = showFallback, nextProps.childLanes = $12584cae6930e094$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $12584cae6930e094$var$SUSPENDED_MARKER, $12584cae6930e094$var$bailoutOffscreenComponent(current.child, nextProps);
    $12584cae6930e094$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $12584cae6930e094$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $12584cae6930e094$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $12584cae6930e094$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $12584cae6930e094$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $12584cae6930e094$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $12584cae6930e094$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $12584cae6930e094$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $12584cae6930e094$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $12584cae6930e094$var$updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, didPrimaryChildrenDefer, nextProps, suspenseInstance, suspenseState, renderLanes) {
    if (didSuspend) {
        if (workInProgress.flags & 256) return $12584cae6930e094$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, $12584cae6930e094$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        if (null !== workInProgress.memoizedState) return $12584cae6930e094$var$reuseSuspenseHandlerOnStack(), workInProgress.child = current.child, workInProgress.flags |= 128, null;
        $12584cae6930e094$var$reuseSuspenseHandlerOnStack();
        suspenseInstance = nextProps.fallback;
        suspenseState = workInProgress.mode;
        nextProps = $12584cae6930e094$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, suspenseState);
        suspenseInstance = $12584cae6930e094$var$createFiberFromFragment(suspenseInstance, suspenseState, renderLanes, null);
        suspenseInstance.flags |= 2;
        nextProps.return = workInProgress;
        suspenseInstance.return = workInProgress;
        nextProps.sibling = suspenseInstance;
        workInProgress.child = nextProps;
        $12584cae6930e094$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
        nextProps = workInProgress.child;
        nextProps.memoizedState = $12584cae6930e094$var$mountSuspenseOffscreenState(renderLanes);
        nextProps.childLanes = $12584cae6930e094$var$getRemainingWorkInPrimaryTree(current, didPrimaryChildrenDefer, renderLanes);
        workInProgress.memoizedState = $12584cae6930e094$var$SUSPENDED_MARKER;
        return $12584cae6930e094$var$bailoutOffscreenComponent(null, nextProps);
    }
    $12584cae6930e094$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    if ($12584cae6930e094$var$isSuspenseInstanceFallback(suspenseInstance)) {
        didPrimaryChildrenDefer = suspenseInstance.nextSibling && suspenseInstance.nextSibling.dataset;
        if (didPrimaryChildrenDefer) var digest = didPrimaryChildrenDefer.dgst;
        didPrimaryChildrenDefer = digest;
        "" !== didPrimaryChildrenDefer && (nextProps = Error($12584cae6930e094$var$formatProdErrorMessage(419)), nextProps.stack = "", nextProps.digest = didPrimaryChildrenDefer, $12584cae6930e094$var$queueHydrationError({
            value: nextProps,
            source: null,
            stack: null
        }));
        return $12584cae6930e094$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
    }
    $12584cae6930e094$var$didReceiveUpdate || $12584cae6930e094$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1);
    didPrimaryChildrenDefer = 0 !== (renderLanes & current.childLanes);
    if ($12584cae6930e094$var$didReceiveUpdate || didPrimaryChildrenDefer) {
        if (null !== $12584cae6930e094$var$currentTreeHiddenStackCursor.current) return $12584cae6930e094$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        didPrimaryChildrenDefer = $12584cae6930e094$var$workInProgressRoot;
        if (null !== didPrimaryChildrenDefer && (nextProps = $12584cae6930e094$var$getBumpedLaneForHydration(didPrimaryChildrenDefer, renderLanes), 0 !== nextProps && nextProps !== suspenseState.retryLane)) throw suspenseState.retryLane = nextProps, $12584cae6930e094$var$enqueueConcurrentRenderForLane(current, nextProps), $12584cae6930e094$var$scheduleUpdateOnFiber(didPrimaryChildrenDefer, current, nextProps), $12584cae6930e094$var$SelectiveHydrationException;
        $12584cae6930e094$var$isSuspenseInstancePending(suspenseInstance) || $12584cae6930e094$var$renderDidSuspendDelayIfPossible();
        return $12584cae6930e094$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
    }
    if ($12584cae6930e094$var$isSuspenseInstancePending(suspenseInstance)) return workInProgress.flags |= 192, workInProgress.child = current.child, null;
    current = suspenseState.treeContext;
    $12584cae6930e094$var$nextHydratableInstance = $12584cae6930e094$var$getNextHydratable(suspenseInstance.nextSibling);
    $12584cae6930e094$var$hydrationParentFiber = workInProgress;
    $12584cae6930e094$var$isHydrating = !0;
    $12584cae6930e094$var$hydrationErrors = null;
    $12584cae6930e094$var$rootOrSingletonContext = !1;
    null !== current && $12584cae6930e094$var$restoreSuspendedTreeContext(workInProgress, current);
    workInProgress = $12584cae6930e094$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children);
    workInProgress.flags |= 134221824;
    return workInProgress;
}
function $12584cae6930e094$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $12584cae6930e094$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $12584cae6930e094$var$findLastContentRow(firstChild) {
    for(var lastContentRow = null; null !== firstChild;){
        var currentRow = firstChild.alternate;
        null !== currentRow && null === $12584cae6930e094$var$findFirstSuspended(currentRow) && (lastContentRow = firstChild);
        firstChild = firstChild.sibling;
    }
    return lastContentRow;
}
function $12584cae6930e094$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $12584cae6930e094$var$reverseChildren(fiber) {
    var row = fiber.child;
    for(fiber.child = null; null !== row;){
        var nextRow = row.sibling;
        row.sibling = fiber.child;
        fiber.child = row;
        row = nextRow;
    }
}
function $12584cae6930e094$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $12584cae6930e094$var$suspenseStackCursor.current;
    if (workInProgress.flags & 128) return $12584cae6930e094$var$pushSuspenseListContext(workInProgress, suspenseContext), null;
    var shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $12584cae6930e094$var$pushSuspenseListContext(workInProgress, suspenseContext);
    "backwards" === revealOrder && null !== current ? ($12584cae6930e094$var$reverseChildren(current), $12584cae6930e094$var$reconcileChildren(current, workInProgress, nextProps, renderLanes), $12584cae6930e094$var$reverseChildren(current)) : $12584cae6930e094$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $12584cae6930e094$var$isHydrating ? $12584cae6930e094$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $12584cae6930e094$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $12584cae6930e094$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "backwards":
            renderLanes = $12584cae6930e094$var$findLastContentRow(workInProgress.child);
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null, $12584cae6930e094$var$reverseChildren(workInProgress));
            $12584cae6930e094$var$initSuspenseListRenderState(workInProgress, !0, revealOrder, null, tailMode, nextProps);
            break;
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $12584cae6930e094$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $12584cae6930e094$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $12584cae6930e094$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        case "independent":
            workInProgress.memoizedState = null;
            break;
        default:
            renderLanes = $12584cae6930e094$var$findLastContentRow(workInProgress.child), null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null), $12584cae6930e094$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
    }
    return workInProgress.child;
}
function $12584cae6930e094$var$updateContextProvider(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $12584cae6930e094$var$pushProvider(workInProgress, workInProgress.type, newProps.value);
    $12584cae6930e094$var$reconcileChildren(current, workInProgress, newProps.children, renderLanes);
    return workInProgress.child;
}
function $12584cae6930e094$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $12584cae6930e094$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($12584cae6930e094$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($12584cae6930e094$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $12584cae6930e094$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $12584cae6930e094$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $12584cae6930e094$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $12584cae6930e094$var$checkIfContextChanged(current) ? !0 : !1;
}
function $12584cae6930e094$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $12584cae6930e094$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $12584cae6930e094$var$pushProvider(workInProgress, $12584cae6930e094$var$CacheContext, current.memoizedState.cache);
            $12584cae6930e094$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $12584cae6930e094$var$pushHostContext(workInProgress);
            break;
        case 4:
            $12584cae6930e094$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $12584cae6930e094$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $12584cae6930e094$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$108 = workInProgress.memoizedState;
            if (null !== state$108) {
                if (null !== state$108.dehydrated) return $12584cae6930e094$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                state$108 = $12584cae6930e094$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1);
                var primaryChildLanes = workInProgress.child.childLanes;
                if (state$108 || 0 !== (renderLanes & primaryChildLanes)) return $12584cae6930e094$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $12584cae6930e094$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $12584cae6930e094$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $12584cae6930e094$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            if (workInProgress.flags & 128) return $12584cae6930e094$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
            primaryChildLanes = 0 !== (current.flags & 128);
            state$108 = 0 !== (renderLanes & workInProgress.childLanes);
            state$108 || ($12584cae6930e094$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$108 = 0 !== (renderLanes & workInProgress.childLanes));
            if (primaryChildLanes) {
                if (state$108) return $12584cae6930e094$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            primaryChildLanes = workInProgress.memoizedState;
            null !== primaryChildLanes && (primaryChildLanes.rendering = null, primaryChildLanes.tail = null, primaryChildLanes.lastEffect = null);
            $12584cae6930e094$var$pushSuspenseListContext(workInProgress, $12584cae6930e094$var$suspenseStackCursor.current);
            if (state$108) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $12584cae6930e094$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $12584cae6930e094$var$pushProvider(workInProgress, $12584cae6930e094$var$CacheContext, current.memoizedState.cache);
    }
    return $12584cae6930e094$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $12584cae6930e094$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $12584cae6930e094$var$didReceiveUpdate = !0;
        else {
            if (!$12584cae6930e094$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $12584cae6930e094$var$didReceiveUpdate = !1, $12584cae6930e094$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $12584cae6930e094$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $12584cae6930e094$var$didReceiveUpdate = !1, $12584cae6930e094$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $12584cae6930e094$var$pushTreeId(workInProgress, $12584cae6930e094$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $12584cae6930e094$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $12584cae6930e094$var$shouldConstruct(current) ? (props = $12584cae6930e094$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $12584cae6930e094$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $12584cae6930e094$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $12584cae6930e094$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $12584cae6930e094$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $12584cae6930e094$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $12584cae6930e094$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $12584cae6930e094$var$REACT_CONTEXT_TYPE) {
                            workInProgress.tag = 10;
                            workInProgress.type = current;
                            workInProgress = $12584cae6930e094$var$updateContextProvider(null, workInProgress, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $12584cae6930e094$var$getComponentNameFromType(current) || current;
                    throw Error($12584cae6930e094$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $12584cae6930e094$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $12584cae6930e094$var$resolveClassComponentProps(props, workInProgress.pendingProps), $12584cae6930e094$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $12584cae6930e094$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($12584cae6930e094$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $12584cae6930e094$var$cloneUpdateQueue(current, workInProgress);
                $12584cae6930e094$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $12584cae6930e094$var$pushProvider(workInProgress, $12584cae6930e094$var$CacheContext, props);
                props !== prevState.cache && $12584cae6930e094$var$propagateContextChanges(workInProgress, [
                    $12584cae6930e094$var$CacheContext
                ], renderLanes, !0);
                $12584cae6930e094$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $12584cae6930e094$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $12584cae6930e094$var$createCapturedValueAtFiber(Error($12584cae6930e094$var$formatProdErrorMessage(424)), workInProgress);
                        $12584cae6930e094$var$queueHydrationError($$typeof);
                        workInProgress = $12584cae6930e094$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $12584cae6930e094$var$nextHydratableInstance = $12584cae6930e094$var$getNextHydratable(current.firstChild);
                        $12584cae6930e094$var$hydrationParentFiber = workInProgress;
                        $12584cae6930e094$var$isHydrating = !0;
                        $12584cae6930e094$var$hydrationErrors = null;
                        $12584cae6930e094$var$rootOrSingletonContext = !0;
                        renderLanes = $12584cae6930e094$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 134221824, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $12584cae6930e094$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $12584cae6930e094$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $12584cae6930e094$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $12584cae6930e094$var$markRef(current, workInProgress), null === current ? (renderLanes = $12584cae6930e094$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $12584cae6930e094$var$isHydrating || (workInProgress.stateNode = $12584cae6930e094$var$createHoistableInstance(workInProgress.type, workInProgress.pendingProps, $12584cae6930e094$var$rootInstanceStackCursor.current, workInProgress)) : workInProgress.memoizedState = $12584cae6930e094$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $12584cae6930e094$var$pushHostContext(workInProgress), null === current && $12584cae6930e094$var$isHydrating && (props = workInProgress.stateNode = $12584cae6930e094$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $12584cae6930e094$var$rootInstanceStackCursor.current), $12584cae6930e094$var$hydrationParentFiber = workInProgress, $12584cae6930e094$var$rootOrSingletonContext = !0, $$typeof = $12584cae6930e094$var$nextHydratableInstance, $12584cae6930e094$var$isSingletonScope(workInProgress.type) ? ($12584cae6930e094$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $12584cae6930e094$var$nextHydratableInstance = $12584cae6930e094$var$getNextHydratable(props.firstChild)) : $12584cae6930e094$var$nextHydratableInstance = $$typeof), $12584cae6930e094$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $12584cae6930e094$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $12584cae6930e094$var$isHydrating) {
                if ($$typeof = props = $12584cae6930e094$var$nextHydratableInstance) props = $12584cae6930e094$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $12584cae6930e094$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $12584cae6930e094$var$hydrationParentFiber = workInProgress, $12584cae6930e094$var$nextHydratableInstance = $12584cae6930e094$var$getNextHydratable(props.firstChild), $12584cae6930e094$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $12584cae6930e094$var$throwOnHydrationMismatch(workInProgress);
            }
            $12584cae6930e094$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $12584cae6930e094$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $12584cae6930e094$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $12584cae6930e094$var$renderWithHooks(current, workInProgress, $12584cae6930e094$var$TransitionAwareHostComponent, null, null, renderLanes), $12584cae6930e094$var$HostTransitionContext._currentValue = $$typeof);
            $12584cae6930e094$var$markRef(current, workInProgress);
            $12584cae6930e094$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $12584cae6930e094$var$isHydrating) {
                if (current = renderLanes = $12584cae6930e094$var$nextHydratableInstance) renderLanes = $12584cae6930e094$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $12584cae6930e094$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $12584cae6930e094$var$hydrationParentFiber = workInProgress, $12584cae6930e094$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $12584cae6930e094$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $12584cae6930e094$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $12584cae6930e094$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $12584cae6930e094$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $12584cae6930e094$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $12584cae6930e094$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return props = workInProgress.pendingProps, $12584cae6930e094$var$markRef(current, workInProgress), $12584cae6930e094$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 8:
            return $12584cae6930e094$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $12584cae6930e094$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return $12584cae6930e094$var$updateContextProvider(current, workInProgress, renderLanes);
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $12584cae6930e094$var$prepareToReadContext(workInProgress), $$typeof = $12584cae6930e094$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $12584cae6930e094$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $12584cae6930e094$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $12584cae6930e094$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $12584cae6930e094$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $12584cae6930e094$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $12584cae6930e094$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $12584cae6930e094$var$prepareToReadContext(workInProgress), props = $12584cae6930e094$var$readContext($12584cae6930e094$var$CacheContext), null === current ? ($$typeof = $12584cae6930e094$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $12584cae6930e094$var$workInProgressRoot, prevState = $12584cae6930e094$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $12584cae6930e094$var$initializeUpdateQueue(workInProgress), $12584cae6930e094$var$pushProvider(workInProgress, $12584cae6930e094$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($12584cae6930e094$var$cloneUpdateQueue(current, workInProgress), $12584cae6930e094$var$processUpdateQueue(workInProgress, null, null, renderLanes), $12584cae6930e094$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $12584cae6930e094$var$pushProvider(workInProgress, $12584cae6930e094$var$CacheContext, props)) : (props = prevState.cache, $12584cae6930e094$var$pushProvider(workInProgress, $12584cae6930e094$var$CacheContext, props), props !== $$typeof.cache && $12584cae6930e094$var$propagateContextChanges(workInProgress, [
                $12584cae6930e094$var$CacheContext
            ], renderLanes, !0))), $12584cae6930e094$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 30:
            return null === workInProgress.stateNode && (workInProgress.stateNode = {
                autoName: null,
                paired: null,
                clones: null,
                ref: null
            }), props = workInProgress.pendingProps, null != props.name && "auto" !== props.name ? workInProgress.flags |= null === current ? 18882560 : 18874368 : $12584cae6930e094$var$isHydrating && $12584cae6930e094$var$pushMaterializedTreeId(workInProgress), null !== current && current.memoizedProps.name !== props.name ? workInProgress.flags |= 4194816 : $12584cae6930e094$var$markRef(current, workInProgress), $12584cae6930e094$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($12584cae6930e094$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $12584cae6930e094$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $12584cae6930e094$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    var JSCompiler_temp;
    if (JSCompiler_temp = 0 !== (workInProgress.mode & 32)) JSCompiler_temp = null === oldProps ? $12584cae6930e094$var$maySuspendCommit(type, newProps) : $12584cae6930e094$var$maySuspendCommit(type, newProps) && (newProps.src !== oldProps.src || newProps.srcSet !== oldProps.srcSet);
    if (JSCompiler_temp) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($12584cae6930e094$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $12584cae6930e094$var$suspendedThenable = $12584cae6930e094$var$noopSuspenseyCommitThenable, $12584cae6930e094$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $12584cae6930e094$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$12584cae6930e094$var$preloadResource(resource)) {
        if ($12584cae6930e094$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $12584cae6930e094$var$suspendedThenable = $12584cae6930e094$var$noopSuspenseyCommitThenable, $12584cae6930e094$var$SuspenseyCommitException;
    }
}
function $12584cae6930e094$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $12584cae6930e094$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $12584cae6930e094$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $12584cae6930e094$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$12584cae6930e094$var$isHydrating) switch(renderState.tailMode){
        case "visible":
            break;
        case "collapsed":
            for(var tailNode = renderState.tail, lastTailNode = null; null !== tailNode;)null !== tailNode.alternate && (lastTailNode = tailNode), tailNode = tailNode.sibling;
            null === lastTailNode ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode.sibling = null;
            break;
        default:
            hasRenderedATailFallback = renderState.tail;
            for(tailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (tailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === tailNode ? renderState.tail = null : tailNode.sibling = null;
    }
}
function $12584cae6930e094$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$113 = completedWork.child; null !== child$113;)newChildLanes |= child$113.lanes | child$113.childLanes, subtreeFlags |= child$113.subtreeFlags & 1206910976, subtreeFlags |= child$113.flags & 1206910976, child$113.return = completedWork, child$113 = child$113.sibling;
    else for(child$113 = completedWork.child; null !== child$113;)newChildLanes |= child$113.lanes | child$113.childLanes, subtreeFlags |= child$113.subtreeFlags, subtreeFlags |= child$113.flags, child$113.return = completedWork, child$113 = child$113.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $12584cae6930e094$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $12584cae6930e094$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $12584cae6930e094$var$bubbleProperties(workInProgress), null;
        case 1:
            return $12584cae6930e094$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $12584cae6930e094$var$popProvider($12584cae6930e094$var$CacheContext);
            $12584cae6930e094$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $12584cae6930e094$var$popHydrationState(workInProgress) ? $12584cae6930e094$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $12584cae6930e094$var$upgradeHydrationErrorsToRecoverable());
            $12584cae6930e094$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($12584cae6930e094$var$markUpdate(workInProgress), null !== nextResource ? ($12584cae6930e094$var$bubbleProperties(workInProgress), $12584cae6930e094$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($12584cae6930e094$var$bubbleProperties(workInProgress), $12584cae6930e094$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($12584cae6930e094$var$markUpdate(workInProgress), $12584cae6930e094$var$bubbleProperties(workInProgress), $12584cae6930e094$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($12584cae6930e094$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $12584cae6930e094$var$markUpdate(workInProgress), $12584cae6930e094$var$bubbleProperties(workInProgress), $12584cae6930e094$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $12584cae6930e094$var$popHostContext(workInProgress);
            renderLanes = $12584cae6930e094$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $12584cae6930e094$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($12584cae6930e094$var$formatProdErrorMessage(166));
                    $12584cae6930e094$var$bubbleProperties(workInProgress);
                    workInProgress.subtreeFlags &= -33554433;
                    return null;
                }
                current = $12584cae6930e094$var$contextStackCursor.current;
                $12584cae6930e094$var$popHydrationState(workInProgress) ? $12584cae6930e094$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $12584cae6930e094$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $12584cae6930e094$var$markUpdate(workInProgress));
            }
            $12584cae6930e094$var$bubbleProperties(workInProgress);
            workInProgress.subtreeFlags &= -33554433;
            return null;
        case 5:
            $12584cae6930e094$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $12584cae6930e094$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($12584cae6930e094$var$formatProdErrorMessage(166));
                    $12584cae6930e094$var$bubbleProperties(workInProgress);
                    workInProgress.subtreeFlags &= -33554433;
                    return null;
                }
                nextResource = $12584cae6930e094$var$contextStackCursor.current;
                if ($12584cae6930e094$var$popHydrationState(workInProgress)) $12584cae6930e094$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $12584cae6930e094$var$getOwnerDocumentFromRootContainer($12584cae6930e094$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$12584cae6930e094$var$internalInstanceKey] = workInProgress;
                    nextResource[$12584cae6930e094$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($12584cae6930e094$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $12584cae6930e094$var$markUpdate(workInProgress);
                }
            }
            $12584cae6930e094$var$bubbleProperties(workInProgress);
            workInProgress.subtreeFlags &= -33554433;
            $12584cae6930e094$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $12584cae6930e094$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($12584cae6930e094$var$formatProdErrorMessage(166));
                current = $12584cae6930e094$var$rootInstanceStackCursor.current;
                if ($12584cae6930e094$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $12584cae6930e094$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$12584cae6930e094$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $12584cae6930e094$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $12584cae6930e094$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $12584cae6930e094$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$12584cae6930e094$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $12584cae6930e094$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $12584cae6930e094$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($12584cae6930e094$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($12584cae6930e094$var$formatProdErrorMessage(557));
                        current[$12584cae6930e094$var$internalInstanceKey] = workInProgress;
                    } else $12584cae6930e094$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $12584cae6930e094$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $12584cae6930e094$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $12584cae6930e094$var$popSuspenseHandler(workInProgress), workInProgress;
                    $12584cae6930e094$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($12584cae6930e094$var$formatProdErrorMessage(558));
            }
            $12584cae6930e094$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $12584cae6930e094$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($12584cae6930e094$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($12584cae6930e094$var$formatProdErrorMessage(317));
                        type[$12584cae6930e094$var$internalInstanceKey] = workInProgress;
                    } else $12584cae6930e094$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $12584cae6930e094$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $12584cae6930e094$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $12584cae6930e094$var$popSuspenseHandler(workInProgress), workInProgress;
                    $12584cae6930e094$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $12584cae6930e094$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $12584cae6930e094$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $12584cae6930e094$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $12584cae6930e094$var$popHostContainer(), null === current && $12584cae6930e094$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), workInProgress.flags |= 67108864, $12584cae6930e094$var$bubbleProperties(workInProgress), null;
        case 10:
            return $12584cae6930e094$var$popProvider(workInProgress.type), $12584cae6930e094$var$bubbleProperties(workInProgress), null;
        case 19:
            $12584cae6930e094$var$popSuspenseListContext(workInProgress);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $12584cae6930e094$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $12584cae6930e094$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $12584cae6930e094$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $12584cae6930e094$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $12584cae6930e094$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $12584cae6930e094$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$12584cae6930e094$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $12584cae6930e094$var$pushSuspenseListContext(workInProgress, $12584cae6930e094$var$suspenseStackCursor.current & 1 | 2);
                            $12584cae6930e094$var$isHydrating && $12584cae6930e094$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $12584cae6930e094$var$now() > $12584cae6930e094$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $12584cae6930e094$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $12584cae6930e094$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $12584cae6930e094$var$scheduleRetryEffect(workInProgress, current), $12584cae6930e094$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "collapsed" !== newProps.tailMode && "visible" !== newProps.tailMode && !nextResource.alternate && !$12584cae6930e094$var$isHydrating) return $12584cae6930e094$var$bubbleProperties(workInProgress), null;
                    } else 2 * $12584cae6930e094$var$now() - newProps.renderingStartTime > $12584cae6930e094$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $12584cae6930e094$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) {
                current = newProps.tail;
                a: {
                    for(renderLanes = current; null !== renderLanes;){
                        if (null !== renderLanes.alternate) {
                            renderLanes = !1;
                            break a;
                        }
                        renderLanes = renderLanes.sibling;
                    }
                    renderLanes = !0;
                }
                newProps.rendering = current;
                newProps.tail = current.sibling;
                newProps.renderingStartTime = $12584cae6930e094$var$now();
                current.sibling = null;
                nextResource = $12584cae6930e094$var$suspenseStackCursor.current;
                nextResource = type ? nextResource & 1 | 2 : nextResource & 1;
                "visible" === newProps.tailMode || "collapsed" === newProps.tailMode || !renderLanes || $12584cae6930e094$var$isHydrating ? $12584cae6930e094$var$pushSuspenseListContext(workInProgress, nextResource) : (renderLanes = nextResource, $12584cae6930e094$var$push($12584cae6930e094$var$suspenseHandlerStackCursor, workInProgress), $12584cae6930e094$var$push($12584cae6930e094$var$suspenseStackCursor, renderLanes), null === $12584cae6930e094$var$shellBoundary && ($12584cae6930e094$var$shellBoundary = workInProgress));
                $12584cae6930e094$var$isHydrating && $12584cae6930e094$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                return current;
            }
            $12584cae6930e094$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $12584cae6930e094$var$popSuspenseHandler(workInProgress), $12584cae6930e094$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($12584cae6930e094$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $12584cae6930e094$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $12584cae6930e094$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $12584cae6930e094$var$pop($12584cae6930e094$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $12584cae6930e094$var$popProvider($12584cae6930e094$var$CacheContext), $12584cae6930e094$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return workInProgress.flags |= 33554432, $12584cae6930e094$var$bubbleProperties(workInProgress), null;
    }
    throw Error($12584cae6930e094$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $12584cae6930e094$var$unwindWork(current, workInProgress) {
    $12584cae6930e094$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $12584cae6930e094$var$popProvider($12584cae6930e094$var$CacheContext), $12584cae6930e094$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $12584cae6930e094$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $12584cae6930e094$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($12584cae6930e094$var$formatProdErrorMessage(340));
                $12584cae6930e094$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $12584cae6930e094$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($12584cae6930e094$var$formatProdErrorMessage(340));
                $12584cae6930e094$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $12584cae6930e094$var$popSuspenseListContext(workInProgress), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, current = workInProgress.memoizedState, null !== current && (current.rendering = null, current.tail = null), workInProgress.flags |= 4, workInProgress) : null;
        case 4:
            return $12584cae6930e094$var$popHostContainer(), null;
        case 10:
            return $12584cae6930e094$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $12584cae6930e094$var$popSuspenseHandler(workInProgress), $12584cae6930e094$var$popHiddenContext(), null !== current && $12584cae6930e094$var$pop($12584cae6930e094$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $12584cae6930e094$var$popProvider($12584cae6930e094$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $12584cae6930e094$var$unwindInterruptedWork(current, interruptedWork) {
    $12584cae6930e094$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $12584cae6930e094$var$popProvider($12584cae6930e094$var$CacheContext);
            $12584cae6930e094$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $12584cae6930e094$var$popHostContext(interruptedWork);
            break;
        case 4:
            $12584cae6930e094$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $12584cae6930e094$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $12584cae6930e094$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $12584cae6930e094$var$popSuspenseListContext(interruptedWork);
            break;
        case 10:
            $12584cae6930e094$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $12584cae6930e094$var$popSuspenseHandler(interruptedWork);
            $12584cae6930e094$var$popHiddenContext();
            null !== current && $12584cae6930e094$var$pop($12584cae6930e094$var$resumedCache);
            break;
        case 24:
            $12584cae6930e094$var$popProvider($12584cae6930e094$var$CacheContext);
    }
}
function $12584cae6930e094$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $12584cae6930e094$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $12584cae6930e094$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $12584cae6930e094$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $12584cae6930e094$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $12584cae6930e094$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $12584cae6930e094$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $12584cae6930e094$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $12584cae6930e094$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $12584cae6930e094$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $12584cae6930e094$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $12584cae6930e094$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    var instance = current.stateNode, name = $12584cae6930e094$var$getViewTransitionName(current.memoizedProps, instance);
                    if (null === instance.ref || instance.ref.name !== name) instance.ref = $12584cae6930e094$var$createViewTransitionInstance(name);
                    instanceToUse = instance.ref;
                    break;
                case 7:
                    if (null === current.stateNode) {
                        var fragmentInstance = new $12584cae6930e094$var$FragmentInstance(current);
                        $12584cae6930e094$var$traverseVisibleInstancesAndTextInstances(current.child, !1, $12584cae6930e094$var$addFragmentHandleToFiber, fragmentInstance, void 0, void 0);
                        current.stateNode = fragmentInstance;
                    }
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $12584cae6930e094$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $12584cae6930e094$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $12584cae6930e094$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$148) {
            $12584cae6930e094$var$captureCommitPhaseError(current, nearestMountedAncestor, error$148);
        }
        else ref.current = null;
    }
}
function $12584cae6930e094$var$commitNewChildToFragmentInstances(fiber, parentFragmentInstances) {
    if ((5 === fiber.tag || 27 === fiber.tag || 6 === fiber.tag) && null === fiber.alternate && null !== parentFragmentInstances) for(var i = 0; i < parentFragmentInstances.length; i++)$12584cae6930e094$var$commitNewChildToFragmentInstance(fiber.stateNode, parentFragmentInstances[i]);
}
function $12584cae6930e094$var$commitFragmentInstanceInsertionEffects(fiber) {
    for(var parent = fiber.return; null !== parent;){
        $12584cae6930e094$var$isFragmentInstanceParent(parent) && $12584cae6930e094$var$commitNewChildToFragmentInstance(fiber.stateNode, parent.stateNode);
        if ($12584cae6930e094$var$isFragmentInstanceHostBoundary(parent)) break;
        parent = parent.return;
    }
}
function $12584cae6930e094$var$commitFragmentInstanceDeletionEffects(fiber) {
    for(var parent = fiber.return; null !== parent;){
        $12584cae6930e094$var$isFragmentInstanceParent(parent) && $12584cae6930e094$var$deleteChildFromFragmentInstance(fiber.stateNode, parent.stateNode);
        if ($12584cae6930e094$var$isFragmentInstanceHostBoundary(parent)) break;
        parent = parent.return;
    }
}
function $12584cae6930e094$var$isFragmentInstanceHostBoundary(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 27 === fiber.tag;
}
function $12584cae6930e094$var$isFragmentInstanceParent(fiber) {
    return fiber && 7 === fiber.tag && null !== fiber.stateNode;
}
function $12584cae6930e094$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $12584cae6930e094$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $12584cae6930e094$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $12584cae6930e094$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$12584cae6930e094$var$internalPropsKey] = newProps;
    } catch (error) {
        $12584cae6930e094$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $12584cae6930e094$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $12584cae6930e094$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $12584cae6930e094$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $12584cae6930e094$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $12584cae6930e094$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $12584cae6930e094$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) tag = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(tag, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(tag), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $12584cae6930e094$var$noop$1)), $12584cae6930e094$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), $12584cae6930e094$var$viewTransitionMutationContext = !0;
    else if (4 !== tag && (27 === tag && ($12584cae6930e094$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), parentFragmentInstances = null, $12584cae6930e094$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null)), node = node.child, null !== node)) for($12584cae6930e094$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances), node = node.sibling; null !== node;)$12584cae6930e094$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances), node = node.sibling;
}
function $12584cae6930e094$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) tag = node.stateNode, before ? parent.insertBefore(tag, before) : parent.appendChild(tag), $12584cae6930e094$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), $12584cae6930e094$var$viewTransitionMutationContext = !0;
    else if (4 !== tag && (27 === tag && ($12584cae6930e094$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), parentFragmentInstances = null, $12584cae6930e094$var$isSingletonScope(node.type) && (parent = node.stateNode)), node = node.child, null !== node)) for($12584cae6930e094$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances), node = node.sibling; null !== node;)$12584cae6930e094$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances), node = node.sibling;
}
function $12584cae6930e094$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $12584cae6930e094$var$setInitialProperties(singleton, type, props);
        singleton[$12584cae6930e094$var$internalInstanceKey] = finishedWork;
        singleton[$12584cae6930e094$var$internalPropsKey] = props;
    } catch (error) {
        $12584cae6930e094$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $12584cae6930e094$var$shouldStartViewTransition = !1, $12584cae6930e094$var$appearingViewTransitions = null;
function $12584cae6930e094$var$trackEnterViewTransitions(placement) {
    if (30 === placement.tag || 0 !== (placement.subtreeFlags & 33554432)) $12584cae6930e094$var$shouldStartViewTransition = !0;
}
var $12584cae6930e094$var$viewTransitionCancelableChildren = null;
function $12584cae6930e094$var$pushViewTransitionCancelableScope() {
    var prevChildren = $12584cae6930e094$var$viewTransitionCancelableChildren;
    $12584cae6930e094$var$viewTransitionCancelableChildren = null;
    return prevChildren;
}
var $12584cae6930e094$var$viewTransitionHostInstanceIdx = 0;
function $12584cae6930e094$var$applyViewTransitionToHostInstances(fiber, name, className, collectMeasurements, stopAtNestedViewTransitions) {
    $12584cae6930e094$var$viewTransitionHostInstanceIdx = 0;
    return $12584cae6930e094$var$applyViewTransitionToHostInstancesRecursive(fiber.child, name, className, collectMeasurements, stopAtNestedViewTransitions);
}
function $12584cae6930e094$var$applyViewTransitionToHostInstancesRecursive(child, name, className, collectMeasurements, stopAtNestedViewTransitions) {
    for(var inViewport = !1; null !== child;){
        if (5 === child.tag) {
            var instance = child.stateNode;
            if (null !== collectMeasurements) {
                var measurement = $12584cae6930e094$var$measureInstance(instance);
                collectMeasurements.push(measurement);
                measurement.view && (inViewport = !0);
            } else inViewport || $12584cae6930e094$var$measureInstance(instance).view && (inViewport = !0);
            $12584cae6930e094$var$shouldStartViewTransition = !0;
            $12584cae6930e094$var$applyViewTransitionName(instance, 0 === $12584cae6930e094$var$viewTransitionHostInstanceIdx ? name : name + "_" + $12584cae6930e094$var$viewTransitionHostInstanceIdx, className);
            $12584cae6930e094$var$viewTransitionHostInstanceIdx++;
        } else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions || $12584cae6930e094$var$applyViewTransitionToHostInstancesRecursive(child.child, name, className, collectMeasurements, stopAtNestedViewTransitions) && (inViewport = !0);
        child = child.sibling;
    }
    return inViewport;
}
function $12584cae6930e094$var$restoreViewTransitionOnHostInstances(child, stopAtNestedViewTransitions) {
    for(; null !== child;){
        if (5 === child.tag) $12584cae6930e094$var$restoreViewTransitionName(child.stateNode, child.memoizedProps);
        else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions || $12584cae6930e094$var$restoreViewTransitionOnHostInstances(child.child, stopAtNestedViewTransitions);
        child = child.sibling;
    }
}
function $12584cae6930e094$var$commitAppearingPairViewTransitions(placement) {
    if (0 !== (placement.subtreeFlags & 18874368)) for(placement = placement.child; null !== placement;){
        if (22 !== placement.tag || null === placement.memoizedState) {
            if ($12584cae6930e094$var$commitAppearingPairViewTransitions(placement), 30 === placement.tag && 0 !== (placement.flags & 18874368) && placement.stateNode.paired) {
                var props = placement.memoizedProps;
                if (null == props.name || "auto" === props.name) throw Error($12584cae6930e094$var$formatProdErrorMessage(544));
                var name = props.name;
                props = $12584cae6930e094$var$getViewTransitionClassName(props.default, props.share);
                "none" !== props && ($12584cae6930e094$var$applyViewTransitionToHostInstances(placement, name, props, null, !1) || $12584cae6930e094$var$restoreViewTransitionOnHostInstances(placement.child, !1));
            }
        }
        placement = placement.sibling;
    }
}
function $12584cae6930e094$var$commitEnterViewTransitions(placement, gesture) {
    if (30 === placement.tag) {
        var state = placement.stateNode, props = placement.memoizedProps, name = $12584cae6930e094$var$getViewTransitionName(props, state), className = $12584cae6930e094$var$getViewTransitionClassName(props.default, state.paired ? props.share : props.enter);
        "none" !== className ? $12584cae6930e094$var$applyViewTransitionToHostInstances(placement, name, className, null, !1) ? ($12584cae6930e094$var$commitAppearingPairViewTransitions(placement), state.paired || gesture || $12584cae6930e094$var$scheduleViewTransitionEvent(placement, props.onEnter)) : $12584cae6930e094$var$restoreViewTransitionOnHostInstances(placement.child, !1) : $12584cae6930e094$var$commitAppearingPairViewTransitions(placement);
    } else if (0 !== (placement.subtreeFlags & 33554432)) for(placement = placement.child; null !== placement;)$12584cae6930e094$var$commitEnterViewTransitions(placement, gesture), placement = placement.sibling;
    else $12584cae6930e094$var$commitAppearingPairViewTransitions(placement);
}
function $12584cae6930e094$var$commitDeletedPairViewTransitions(deletion) {
    if (null !== $12584cae6930e094$var$appearingViewTransitions && 0 !== $12584cae6930e094$var$appearingViewTransitions.size) {
        var pairs = $12584cae6930e094$var$appearingViewTransitions;
        if (0 !== (deletion.subtreeFlags & 18874368)) for(deletion = deletion.child; null !== deletion;){
            if (22 !== deletion.tag || null === deletion.memoizedState) {
                if (30 === deletion.tag && 0 !== (deletion.flags & 18874368)) {
                    var props = deletion.memoizedProps, name = props.name;
                    if (null != name && "auto" !== name) {
                        var pair = pairs.get(name);
                        if (void 0 !== pair) {
                            var className = $12584cae6930e094$var$getViewTransitionClassName(props.default, props.share);
                            "none" !== className && ($12584cae6930e094$var$applyViewTransitionToHostInstances(deletion, name, className, null, !1) ? (className = deletion.stateNode, pair.paired = className, className.paired = pair, $12584cae6930e094$var$scheduleViewTransitionEvent(deletion, props.onShare)) : $12584cae6930e094$var$restoreViewTransitionOnHostInstances(deletion.child, !1));
                            pairs.delete(name);
                            if (0 === pairs.size) break;
                        }
                    }
                }
                $12584cae6930e094$var$commitDeletedPairViewTransitions(deletion);
            }
            deletion = deletion.sibling;
        }
    }
}
function $12584cae6930e094$var$commitExitViewTransitions(deletion) {
    if (30 === deletion.tag) {
        var props = deletion.memoizedProps, name = $12584cae6930e094$var$getViewTransitionName(props, deletion.stateNode), pair = null !== $12584cae6930e094$var$appearingViewTransitions ? $12584cae6930e094$var$appearingViewTransitions.get(name) : void 0, className = $12584cae6930e094$var$getViewTransitionClassName(props.default, void 0 !== pair ? props.share : props.exit);
        "none" !== className && ($12584cae6930e094$var$applyViewTransitionToHostInstances(deletion, name, className, null, !1) ? void 0 !== pair ? (className = deletion.stateNode, pair.paired = className, className.paired = pair, $12584cae6930e094$var$appearingViewTransitions.delete(name), $12584cae6930e094$var$scheduleViewTransitionEvent(deletion, props.onShare)) : $12584cae6930e094$var$scheduleViewTransitionEvent(deletion, props.onExit) : $12584cae6930e094$var$restoreViewTransitionOnHostInstances(deletion.child, !1));
        null !== $12584cae6930e094$var$appearingViewTransitions && $12584cae6930e094$var$commitDeletedPairViewTransitions(deletion);
    } else if (0 !== (deletion.subtreeFlags & 33554432)) for(deletion = deletion.child; null !== deletion;)$12584cae6930e094$var$commitExitViewTransitions(deletion), deletion = deletion.sibling;
    else null !== $12584cae6930e094$var$appearingViewTransitions && $12584cae6930e094$var$commitDeletedPairViewTransitions(deletion);
}
function $12584cae6930e094$var$commitNestedViewTransitions(changedParent) {
    for(changedParent = changedParent.child; null !== changedParent;){
        if (30 === changedParent.tag) {
            var props = changedParent.memoizedProps, name = $12584cae6930e094$var$getViewTransitionName(props, changedParent.stateNode);
            props = $12584cae6930e094$var$getViewTransitionClassName(props.default, props.update);
            changedParent.flags &= -5;
            "none" !== props && $12584cae6930e094$var$applyViewTransitionToHostInstances(changedParent, name, props, changedParent.memoizedState = [], !1);
        } else 0 !== (changedParent.subtreeFlags & 33554432) && $12584cae6930e094$var$commitNestedViewTransitions(changedParent);
        changedParent = changedParent.sibling;
    }
}
function $12584cae6930e094$var$restorePairedViewTransitions(parent) {
    if (0 !== (parent.subtreeFlags & 18874368)) for(parent = parent.child; null !== parent;){
        if (22 !== parent.tag || null === parent.memoizedState) {
            if (30 === parent.tag && 0 !== (parent.flags & 18874368)) {
                var instance = parent.stateNode;
                null !== instance.paired && (instance.paired = null, $12584cae6930e094$var$restoreViewTransitionOnHostInstances(parent.child, !1));
            }
            $12584cae6930e094$var$restorePairedViewTransitions(parent);
        }
        parent = parent.sibling;
    }
}
function $12584cae6930e094$var$restoreEnterOrExitViewTransitions(fiber) {
    if (30 === fiber.tag) fiber.stateNode.paired = null, $12584cae6930e094$var$restoreViewTransitionOnHostInstances(fiber.child, !1), $12584cae6930e094$var$restorePairedViewTransitions(fiber);
    else if (0 !== (fiber.subtreeFlags & 33554432)) for(fiber = fiber.child; null !== fiber;)$12584cae6930e094$var$restoreEnterOrExitViewTransitions(fiber), fiber = fiber.sibling;
    else $12584cae6930e094$var$restorePairedViewTransitions(fiber);
}
function $12584cae6930e094$var$restoreNestedViewTransitions(changedParent) {
    for(changedParent = changedParent.child; null !== changedParent;)30 === changedParent.tag ? $12584cae6930e094$var$restoreViewTransitionOnHostInstances(changedParent.child, !1) : 0 !== (changedParent.subtreeFlags & 33554432) && $12584cae6930e094$var$restoreNestedViewTransitions(changedParent), changedParent = changedParent.sibling;
}
function $12584cae6930e094$var$measureViewTransitionHostInstancesRecursive(parentViewTransition, child, newName, oldName, className, previousMeasurements, stopAtNestedViewTransitions) {
    for(var inViewport = !1; null !== child;){
        if (5 === child.tag) {
            var instance = child.stateNode;
            if (null !== previousMeasurements && $12584cae6930e094$var$viewTransitionHostInstanceIdx < previousMeasurements.length) {
                var previousMeasurement = previousMeasurements[$12584cae6930e094$var$viewTransitionHostInstanceIdx], nextMeasurement = $12584cae6930e094$var$measureInstance(instance);
                if (previousMeasurement.view || nextMeasurement.view) inViewport = !0;
                var JSCompiler_temp;
                if (JSCompiler_temp = 0 === (parentViewTransition.flags & 4)) {
                    if (nextMeasurement.clip) JSCompiler_temp = !0;
                    else {
                        JSCompiler_temp = previousMeasurement.rect;
                        var newRect = nextMeasurement.rect;
                        JSCompiler_temp = JSCompiler_temp.y !== newRect.y || JSCompiler_temp.x !== newRect.x || JSCompiler_temp.height !== newRect.height || JSCompiler_temp.width !== newRect.width;
                    }
                }
                JSCompiler_temp && (parentViewTransition.flags |= 4);
                nextMeasurement.abs ? nextMeasurement = !previousMeasurement.abs : (previousMeasurement = previousMeasurement.rect, nextMeasurement = nextMeasurement.rect, nextMeasurement = previousMeasurement.height !== nextMeasurement.height || previousMeasurement.width !== nextMeasurement.width);
                nextMeasurement && (parentViewTransition.flags |= 32);
            } else parentViewTransition.flags |= 32;
            0 !== (parentViewTransition.flags & 4) && $12584cae6930e094$var$applyViewTransitionName(instance, 0 === $12584cae6930e094$var$viewTransitionHostInstanceIdx ? newName : newName + "_" + $12584cae6930e094$var$viewTransitionHostInstanceIdx, className);
            inViewport && 0 !== (parentViewTransition.flags & 4) || (null === $12584cae6930e094$var$viewTransitionCancelableChildren && ($12584cae6930e094$var$viewTransitionCancelableChildren = []), $12584cae6930e094$var$viewTransitionCancelableChildren.push(instance, 0 === $12584cae6930e094$var$viewTransitionHostInstanceIdx ? oldName : oldName + "_" + $12584cae6930e094$var$viewTransitionHostInstanceIdx, child.memoizedProps));
            $12584cae6930e094$var$viewTransitionHostInstanceIdx++;
        } else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions ? parentViewTransition.flags |= child.flags & 32 : $12584cae6930e094$var$measureViewTransitionHostInstancesRecursive(parentViewTransition, child.child, newName, oldName, className, previousMeasurements, stopAtNestedViewTransitions) && (inViewport = !0);
        child = child.sibling;
    }
    return inViewport;
}
function $12584cae6930e094$var$measureNestedViewTransitions(changedParent, gesture) {
    for(changedParent = changedParent.child; null !== changedParent;){
        if (30 === changedParent.tag) {
            var props = changedParent.memoizedProps, state = changedParent.stateNode, name = $12584cae6930e094$var$getViewTransitionName(props, state), className = $12584cae6930e094$var$getViewTransitionClassName(props.default, props.update);
            if (gesture) {
                state = state.clones;
                var previousMeasurements = null === state ? null : state.map($12584cae6930e094$var$measureClonedInstance);
            } else previousMeasurements = changedParent.memoizedState, changedParent.memoizedState = null;
            state = changedParent;
            var child = changedParent.child;
            $12584cae6930e094$var$viewTransitionHostInstanceIdx = 0;
            name = $12584cae6930e094$var$measureViewTransitionHostInstancesRecursive(state, child, name, name, className, previousMeasurements, !1);
            0 !== (changedParent.flags & 4) && name && (gesture || $12584cae6930e094$var$scheduleViewTransitionEvent(changedParent, props.onUpdate));
        } else 0 !== (changedParent.subtreeFlags & 33554432) && $12584cae6930e094$var$measureNestedViewTransitions(changedParent, gesture);
        changedParent = changedParent.sibling;
    }
}
var $12584cae6930e094$var$offscreenSubtreeIsHidden = !1, $12584cae6930e094$var$offscreenSubtreeWasHidden = !1, $12584cae6930e094$var$offscreenDirectParentIsHidden = !1, $12584cae6930e094$var$needsFormReset = !1, $12584cae6930e094$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $12584cae6930e094$var$nextEffect = null, $12584cae6930e094$var$viewTransitionContextChanged = !1, $12584cae6930e094$var$inUpdateViewTransition = !1, $12584cae6930e094$var$rootViewTransitionAffected = !1, $12584cae6930e094$var$rootViewTransitionNameCanceled = !1;
function $12584cae6930e094$var$commitBeforeMutationEffects(root, firstChild, committedLanes) {
    root = root.containerInfo;
    $12584cae6930e094$var$eventsEnabled = $12584cae6930e094$var$_enabled;
    root = $12584cae6930e094$var$getActiveElementDeep(root);
    if ($12584cae6930e094$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$21) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $12584cae6930e094$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $12584cae6930e094$var$_enabled = !1;
    committedLanes = (committedLanes & 335544064) === committedLanes;
    $12584cae6930e094$var$nextEffect = firstChild;
    for(firstChild = committedLanes ? 9270 : 1024; null !== $12584cae6930e094$var$nextEffect;){
        root = $12584cae6930e094$var$nextEffect;
        if (committedLanes && (JSCompiler_temp = root.deletions, null !== JSCompiler_temp)) for(anchorOffset = 0; anchorOffset < JSCompiler_temp.length; anchorOffset++)committedLanes && $12584cae6930e094$var$commitExitViewTransitions(JSCompiler_temp[anchorOffset]);
        if (null === root.alternate && 0 !== (root.flags & 2)) committedLanes && $12584cae6930e094$var$trackEnterViewTransitions(root), $12584cae6930e094$var$commitBeforeMutationEffects_complete(committedLanes);
        else {
            if (22 === root.tag) {
                if (JSCompiler_temp = root.alternate, null !== root.memoizedState) {
                    null !== JSCompiler_temp && null === JSCompiler_temp.memoizedState && committedLanes && $12584cae6930e094$var$commitExitViewTransitions(JSCompiler_temp);
                    $12584cae6930e094$var$commitBeforeMutationEffects_complete(committedLanes);
                    continue;
                } else if (null !== JSCompiler_temp && null !== JSCompiler_temp.memoizedState) {
                    committedLanes && $12584cae6930e094$var$trackEnterViewTransitions(root);
                    $12584cae6930e094$var$commitBeforeMutationEffects_complete(committedLanes);
                    continue;
                }
            }
            JSCompiler_temp = root.child;
            0 !== (root.subtreeFlags & firstChild) && null !== JSCompiler_temp ? (JSCompiler_temp.return = root, $12584cae6930e094$var$nextEffect = JSCompiler_temp) : (committedLanes && $12584cae6930e094$var$commitNestedViewTransitions(root), $12584cae6930e094$var$commitBeforeMutationEffects_complete(committedLanes));
        }
    }
    $12584cae6930e094$var$appearingViewTransitions = null;
}
function $12584cae6930e094$var$commitBeforeMutationEffects_complete(isViewTransitionEligible$jscomp$0) {
    for(; null !== $12584cae6930e094$var$nextEffect;){
        var fiber = $12584cae6930e094$var$nextEffect, isViewTransitionEligible = isViewTransitionEligible$jscomp$0, current = fiber.alternate, flags = fiber.flags;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (flags & 1024) && null !== current) {
                    isViewTransitionEligible = void 0;
                    flags = current.memoizedProps;
                    current = current.memoizedState;
                    var instance = fiber.stateNode;
                    try {
                        var resolvedPrevProps = $12584cae6930e094$var$resolveClassComponentProps(fiber.type, flags);
                        isViewTransitionEligible = instance.getSnapshotBeforeUpdate(resolvedPrevProps, current);
                        instance.__reactInternalSnapshotBeforeUpdate = isViewTransitionEligible;
                    } catch (error) {
                        $12584cae6930e094$var$captureCommitPhaseError(fiber, fiber.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (flags & 1024)) {
                    if (current = fiber.stateNode.containerInfo, isViewTransitionEligible = current.nodeType, 9 === isViewTransitionEligible) $12584cae6930e094$var$clearContainerSparingly(current);
                    else if (1 === isViewTransitionEligible) switch(current.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $12584cae6930e094$var$clearContainerSparingly(current);
                            break;
                        default:
                            current.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            case 30:
                isViewTransitionEligible && null !== current && (isViewTransitionEligible = $12584cae6930e094$var$getViewTransitionName(current.memoizedProps, current.stateNode), flags = fiber.memoizedProps, flags = $12584cae6930e094$var$getViewTransitionClassName(flags.default, flags.update), "none" !== flags && $12584cae6930e094$var$applyViewTransitionToHostInstances(current, isViewTransitionEligible, flags, current.memoizedState = [], !0));
                break;
            default:
                if (0 !== (flags & 1024)) throw Error($12584cae6930e094$var$formatProdErrorMessage(163));
        }
        current = fiber.sibling;
        if (null !== current) {
            current.return = fiber.return;
            $12584cae6930e094$var$nextEffect = current;
            break;
        }
        $12584cae6930e094$var$nextEffect = fiber.return;
    }
}
function $12584cae6930e094$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $12584cae6930e094$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $12584cae6930e094$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $12584cae6930e094$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $12584cae6930e094$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $12584cae6930e094$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$146) {
                        $12584cae6930e094$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$146);
                    }
                }
            }
            flags & 64 && $12584cae6930e094$var$commitClassCallbacks(finishedWork);
            flags & 512 && $12584cae6930e094$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $12584cae6930e094$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $12584cae6930e094$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $12584cae6930e094$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $12584cae6930e094$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $12584cae6930e094$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $12584cae6930e094$var$commitHostMount(finishedWork);
            flags & 512 && $12584cae6930e094$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $12584cae6930e094$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $12584cae6930e094$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $12584cae6930e094$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $12584cae6930e094$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $12584cae6930e094$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $12584cae6930e094$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $12584cae6930e094$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $12584cae6930e094$var$offscreenSubtreeIsHidden;
            if (!flags) {
                var newOffscreenSubtreeWasHidden = null !== current && null !== current.memoizedState || $12584cae6930e094$var$offscreenSubtreeWasHidden;
                current = $12584cae6930e094$var$offscreenSubtreeIsHidden;
                prevProps = $12584cae6930e094$var$offscreenSubtreeWasHidden;
                $12584cae6930e094$var$offscreenSubtreeIsHidden = flags;
                ($12584cae6930e094$var$offscreenSubtreeWasHidden = newOffscreenSubtreeWasHidden) && !prevProps ? (flags = 2, 0 !== (finishedWork.subtreeFlags & 8772) && (flags |= 1), $12584cae6930e094$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, flags)) : $12584cae6930e094$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $12584cae6930e094$var$offscreenSubtreeIsHidden = current;
                $12584cae6930e094$var$offscreenSubtreeWasHidden = prevProps;
            }
            break;
        case 30:
            $12584cae6930e094$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 512 && $12584cae6930e094$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 7:
            flags & 512 && $12584cae6930e094$var$safelyAttachRef(finishedWork, finishedWork.return);
        default:
            $12584cae6930e094$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $12584cae6930e094$var$hideOrUnhideAllChildren(parentFiber, isHidden) {
    for(parentFiber = parentFiber.child; null !== parentFiber;)$12584cae6930e094$var$hideOrUnhideAllChildrenOnFiber(parentFiber, isHidden), parentFiber = parentFiber.sibling;
}
function $12584cae6930e094$var$hideOrUnhideAllChildrenOnFiber(fiber, isHidden) {
    switch(fiber.tag){
        case 5:
        case 26:
            try {
                var instance = fiber.stateNode;
                if (isHidden) {
                    var style = instance.style;
                    "function" === typeof style.setProperty ? style.setProperty("display", "none", "important") : style.display = "none";
                } else {
                    var instance$jscomp$0 = fiber.stateNode, styleProp = fiber.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                    instance$jscomp$0.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                }
            } catch (error) {
                $12584cae6930e094$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            $12584cae6930e094$var$hideOrUnhideNearestPortals(fiber, isHidden);
            break;
        case 6:
            try {
                fiber.stateNode.nodeValue = isHidden ? "" : fiber.memoizedProps, $12584cae6930e094$var$viewTransitionMutationContext = !0;
            } catch (error) {
                $12584cae6930e094$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            break;
        case 18:
            try {
                var instance$jscomp$1 = fiber.stateNode;
                isHidden ? $12584cae6930e094$var$hideOrUnhideDehydratedBoundary(instance$jscomp$1, !0) : $12584cae6930e094$var$hideOrUnhideDehydratedBoundary(fiber.stateNode, !1);
            } catch (error) {
                $12584cae6930e094$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            break;
        case 22:
        case 23:
            null === fiber.memoizedState && $12584cae6930e094$var$hideOrUnhideAllChildren(fiber, isHidden);
            break;
        default:
            $12584cae6930e094$var$hideOrUnhideAllChildren(fiber, isHidden);
    }
}
function $12584cae6930e094$var$hideOrUnhideNearestPortals(parentFiber, isHidden$jscomp$0) {
    if (parentFiber.subtreeFlags & 67108864) for(parentFiber = parentFiber.child; null !== parentFiber;){
        a: {
            var fiber = parentFiber, isHidden = isHidden$jscomp$0;
            switch(fiber.tag){
                case 4:
                    $12584cae6930e094$var$hideOrUnhideAllChildrenOnFiber(fiber, isHidden);
                    break a;
                case 22:
                    null === fiber.memoizedState && $12584cae6930e094$var$hideOrUnhideNearestPortals(fiber, isHidden);
                    break a;
                default:
                    $12584cae6930e094$var$hideOrUnhideNearestPortals(fiber, isHidden);
            }
        }
        parentFiber = parentFiber.sibling;
    }
}
function $12584cae6930e094$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $12584cae6930e094$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $12584cae6930e094$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $12584cae6930e094$var$hostParent = null, $12584cae6930e094$var$hostParentIsContainer = !1;
function $12584cae6930e094$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$12584cae6930e094$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $12584cae6930e094$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($12584cae6930e094$var$injectedHook && "function" === typeof $12584cae6930e094$var$injectedHook.onCommitFiberUnmount) try {
        $12584cae6930e094$var$injectedHook.onCommitFiberUnmount($12584cae6930e094$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $12584cae6930e094$var$offscreenSubtreeWasHidden || $12584cae6930e094$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $12584cae6930e094$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && !$12584cae6930e094$var$offscreenSubtreeWasHidden && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $12584cae6930e094$var$offscreenSubtreeWasHidden || $12584cae6930e094$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $12584cae6930e094$var$commitFragmentInstanceDeletionEffects(deletedFiber);
            var prevHostParent = $12584cae6930e094$var$hostParent, prevHostParentIsContainer = $12584cae6930e094$var$hostParentIsContainer;
            $12584cae6930e094$var$isSingletonScope(deletedFiber.type) && ($12584cae6930e094$var$hostParent = deletedFiber.stateNode, $12584cae6930e094$var$hostParentIsContainer = !1);
            $12584cae6930e094$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $12584cae6930e094$var$releaseSingletonInstance(deletedFiber.stateNode, deletedFiber.type, deletedFiber.memoizedProps);
            $12584cae6930e094$var$hostParent = prevHostParent;
            $12584cae6930e094$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $12584cae6930e094$var$offscreenSubtreeWasHidden || $12584cae6930e094$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), $12584cae6930e094$var$commitFragmentInstanceDeletionEffects(deletedFiber);
        case 6:
            6 === deletedFiber.tag && $12584cae6930e094$var$commitFragmentInstanceDeletionEffects(deletedFiber);
            prevHostParent = $12584cae6930e094$var$hostParent;
            prevHostParentIsContainer = $12584cae6930e094$var$hostParentIsContainer;
            $12584cae6930e094$var$hostParent = null;
            $12584cae6930e094$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $12584cae6930e094$var$hostParent = prevHostParent;
            $12584cae6930e094$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $12584cae6930e094$var$hostParent) {
                if ($12584cae6930e094$var$hostParentIsContainer) try {
                    (9 === $12584cae6930e094$var$hostParent.nodeType ? $12584cae6930e094$var$hostParent.body : "HTML" === $12584cae6930e094$var$hostParent.nodeName ? $12584cae6930e094$var$hostParent.ownerDocument.body : $12584cae6930e094$var$hostParent).removeChild(deletedFiber.stateNode), $12584cae6930e094$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $12584cae6930e094$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $12584cae6930e094$var$hostParent.removeChild(deletedFiber.stateNode), $12584cae6930e094$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $12584cae6930e094$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $12584cae6930e094$var$hostParent && ($12584cae6930e094$var$hostParentIsContainer ? (finishedRoot = $12584cae6930e094$var$hostParent, $12584cae6930e094$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $12584cae6930e094$var$retryIfBlockedOn(finishedRoot)) : $12584cae6930e094$var$clearHydrationBoundary($12584cae6930e094$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $12584cae6930e094$var$hostParent;
            prevHostParentIsContainer = $12584cae6930e094$var$hostParentIsContainer;
            $12584cae6930e094$var$hostParent = deletedFiber.stateNode.containerInfo;
            $12584cae6930e094$var$hostParentIsContainer = !0;
            $12584cae6930e094$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $12584cae6930e094$var$hostParent = prevHostParent;
            $12584cae6930e094$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $12584cae6930e094$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $12584cae6930e094$var$offscreenSubtreeWasHidden || $12584cae6930e094$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $12584cae6930e094$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $12584cae6930e094$var$offscreenSubtreeWasHidden || ($12584cae6930e094$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $12584cae6930e094$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $12584cae6930e094$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $12584cae6930e094$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $12584cae6930e094$var$offscreenSubtreeWasHidden = (prevHostParent = $12584cae6930e094$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $12584cae6930e094$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $12584cae6930e094$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        case 30:
            $12584cae6930e094$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $12584cae6930e094$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 7:
            $12584cae6930e094$var$offscreenSubtreeWasHidden || $12584cae6930e094$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $12584cae6930e094$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        default:
            $12584cae6930e094$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $12584cae6930e094$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $12584cae6930e094$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $12584cae6930e094$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $12584cae6930e094$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $12584cae6930e094$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $12584cae6930e094$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $12584cae6930e094$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $12584cae6930e094$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $12584cae6930e094$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($12584cae6930e094$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $12584cae6930e094$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $12584cae6930e094$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $12584cae6930e094$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $12584cae6930e094$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber, lanes) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($12584cae6930e094$var$isSingletonScope(parent.type)) {
                        $12584cae6930e094$var$hostParent = parent.stateNode;
                        $12584cae6930e094$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $12584cae6930e094$var$hostParent = parent.stateNode;
                    $12584cae6930e094$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $12584cae6930e094$var$hostParent = parent.stateNode.containerInfo;
                    $12584cae6930e094$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $12584cae6930e094$var$hostParent) throw Error($12584cae6930e094$var$formatProdErrorMessage(160));
        $12584cae6930e094$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $12584cae6930e094$var$hostParent = null;
        $12584cae6930e094$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$12584cae6930e094$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0, lanes), parentFiber = parentFiber.sibling;
}
var $12584cae6930e094$var$currentHoistableRoot = null;
function $12584cae6930e094$var$commitMutationEffectsOnFiber(finishedWork, root, lanes) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            if (flags & 4 && (current = finishedWork.updateQueue, current = null !== current ? current.events : null, null !== current)) for(var ii = 0; ii < current.length; ii++){
                var _eventPayloads$ii2 = current[ii];
                _eventPayloads$ii2.ref.impl = _eventPayloads$ii2.nextImpl;
            }
            $12584cae6930e094$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $12584cae6930e094$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($12584cae6930e094$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $12584cae6930e094$var$commitHookEffectListMount(3, finishedWork), $12584cae6930e094$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $12584cae6930e094$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $12584cae6930e094$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($12584cae6930e094$var$offscreenSubtreeWasHidden || null === current || $12584cae6930e094$var$safelyDetachRef(current, current.return));
            flags & 64 && $12584cae6930e094$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (root = finishedWork.callbacks, null !== root && (lanes = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === lanes ? root : lanes.concat(root))));
            break;
        case 26:
            ii = $12584cae6930e094$var$currentHoistableRoot;
            $12584cae6930e094$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $12584cae6930e094$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($12584cae6930e094$var$offscreenSubtreeWasHidden || null === current || $12584cae6930e094$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                if (flags = null !== current ? current.memoizedState : null, lanes = finishedWork.memoizedState, null === current) {
                    if (null === lanes) {
                        if (null === finishedWork.stateNode) {
                            if ($12584cae6930e094$var$offscreenSubtreeIsHidden) finishedWork.stateNode = $12584cae6930e094$var$createHoistableInstance(finishedWork.type, finishedWork.memoizedProps, root.containerInfo, finishedWork);
                            else {
                                a: {
                                    root = finishedWork.type;
                                    lanes = finishedWork.memoizedProps;
                                    flags = ii.ownerDocument || ii;
                                    b: switch(root){
                                        case "title":
                                            current = flags.getElementsByTagName("title")[0];
                                            if (!current || current[$12584cae6930e094$var$internalHoistableMarker] || current[$12584cae6930e094$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === current.namespaceURI || current.hasAttribute("itemprop")) current = flags.createElement(root), flags.head.insertBefore(current, flags.querySelector("head > title"));
                                            $12584cae6930e094$var$setInitialProperties(current, root, lanes);
                                            current[$12584cae6930e094$var$internalInstanceKey] = finishedWork;
                                            $12584cae6930e094$var$markNodeAsHoistable(current);
                                            root = current;
                                            break a;
                                        case "link":
                                            if (ii = $12584cae6930e094$var$getHydratableHoistableCache("link", "href", flags).get(root + (lanes.href || ""))) {
                                                for(_eventPayloads$ii2 = 0; _eventPayloads$ii2 < ii.length; _eventPayloads$ii2++)if (current = ii[_eventPayloads$ii2], current.getAttribute("href") === (null == lanes.href || "" === lanes.href ? null : lanes.href) && current.getAttribute("rel") === (null == lanes.rel ? null : lanes.rel) && current.getAttribute("title") === (null == lanes.title ? null : lanes.title) && current.getAttribute("crossorigin") === (null == lanes.crossOrigin ? null : lanes.crossOrigin)) {
                                                    ii.splice(_eventPayloads$ii2, 1);
                                                    break b;
                                                }
                                            }
                                            current = flags.createElement(root);
                                            $12584cae6930e094$var$setInitialProperties(current, root, lanes);
                                            flags.head.appendChild(current);
                                            break;
                                        case "meta":
                                            if (ii = $12584cae6930e094$var$getHydratableHoistableCache("meta", "content", flags).get(root + (lanes.content || ""))) {
                                                for(_eventPayloads$ii2 = 0; _eventPayloads$ii2 < ii.length; _eventPayloads$ii2++)if (current = ii[_eventPayloads$ii2], current.getAttribute("content") === (null == lanes.content ? null : "" + lanes.content) && current.getAttribute("name") === (null == lanes.name ? null : lanes.name) && current.getAttribute("property") === (null == lanes.property ? null : lanes.property) && current.getAttribute("http-equiv") === (null == lanes.httpEquiv ? null : lanes.httpEquiv) && current.getAttribute("charset") === (null == lanes.charSet ? null : lanes.charSet)) {
                                                    ii.splice(_eventPayloads$ii2, 1);
                                                    break b;
                                                }
                                            }
                                            current = flags.createElement(root);
                                            $12584cae6930e094$var$setInitialProperties(current, root, lanes);
                                            flags.head.appendChild(current);
                                            break;
                                        default:
                                            throw Error($12584cae6930e094$var$formatProdErrorMessage(468, root));
                                    }
                                    current[$12584cae6930e094$var$internalInstanceKey] = finishedWork;
                                    $12584cae6930e094$var$markNodeAsHoistable(current);
                                    root = current;
                                }
                                finishedWork.stateNode = root;
                            }
                        } else $12584cae6930e094$var$offscreenSubtreeIsHidden || $12584cae6930e094$var$mountHoistable(ii, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $12584cae6930e094$var$acquireResource(ii, lanes, finishedWork.memoizedProps);
                } else flags !== lanes ? (null === flags ? (root = current.stateNode, null === root || $12584cae6930e094$var$offscreenSubtreeWasHidden || root.parentNode.removeChild(root)) : flags.count--, null === lanes ? $12584cae6930e094$var$offscreenSubtreeIsHidden || $12584cae6930e094$var$mountHoistable(ii, finishedWork.type, finishedWork.stateNode) : $12584cae6930e094$var$acquireResource(ii, lanes, finishedWork.memoizedProps)) : null === lanes && null !== finishedWork.stateNode && $12584cae6930e094$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $12584cae6930e094$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $12584cae6930e094$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($12584cae6930e094$var$offscreenSubtreeWasHidden || null === current || $12584cae6930e094$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $12584cae6930e094$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            ii = $12584cae6930e094$var$offscreenDirectParentIsHidden;
            $12584cae6930e094$var$offscreenDirectParentIsHidden = !1;
            $12584cae6930e094$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $12584cae6930e094$var$offscreenDirectParentIsHidden = ii;
            $12584cae6930e094$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($12584cae6930e094$var$offscreenSubtreeWasHidden || null === current || $12584cae6930e094$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                root = finishedWork.stateNode;
                try {
                    $12584cae6930e094$var$setTextContent(root, ""), $12584cae6930e094$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $12584cae6930e094$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (root = finishedWork.memoizedProps, $12584cae6930e094$var$commitHostUpdate(finishedWork, root, null !== current ? current.memoizedProps : root));
            flags & 1024 && ($12584cae6930e094$var$needsFormReset = !0);
            break;
        case 6:
            $12584cae6930e094$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $12584cae6930e094$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($12584cae6930e094$var$formatProdErrorMessage(162));
                root = finishedWork.memoizedProps;
                lanes = finishedWork.stateNode;
                try {
                    lanes.nodeValue = root, $12584cae6930e094$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $12584cae6930e094$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $12584cae6930e094$var$viewTransitionMutationContext = !1;
            $12584cae6930e094$var$tagCaches = null;
            ii = $12584cae6930e094$var$currentHoistableRoot;
            $12584cae6930e094$var$currentHoistableRoot = $12584cae6930e094$var$getHoistableRoot(root.containerInfo);
            $12584cae6930e094$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $12584cae6930e094$var$currentHoistableRoot = ii;
            $12584cae6930e094$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $12584cae6930e094$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $12584cae6930e094$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $12584cae6930e094$var$needsFormReset && ($12584cae6930e094$var$needsFormReset = !1, $12584cae6930e094$var$recursivelyResetForms(finishedWork));
            $12584cae6930e094$var$viewTransitionMutationContext = !1;
            break;
        case 4:
            flags = $12584cae6930e094$var$offscreenDirectParentIsHidden;
            $12584cae6930e094$var$offscreenDirectParentIsHidden = $12584cae6930e094$var$offscreenSubtreeIsHidden;
            current = $12584cae6930e094$var$pushMutationContext();
            ii = $12584cae6930e094$var$currentHoistableRoot;
            $12584cae6930e094$var$currentHoistableRoot = $12584cae6930e094$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $12584cae6930e094$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $12584cae6930e094$var$commitReconciliationEffects(finishedWork);
            $12584cae6930e094$var$currentHoistableRoot = ii;
            $12584cae6930e094$var$viewTransitionMutationContext && $12584cae6930e094$var$inUpdateViewTransition && ($12584cae6930e094$var$rootViewTransitionAffected = !0);
            $12584cae6930e094$var$viewTransitionMutationContext = current;
            $12584cae6930e094$var$offscreenDirectParentIsHidden = flags;
            break;
        case 12:
            $12584cae6930e094$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $12584cae6930e094$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $12584cae6930e094$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $12584cae6930e094$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $12584cae6930e094$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 13:
            $12584cae6930e094$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $12584cae6930e094$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($12584cae6930e094$var$globalMostRecentFallbackTime = $12584cae6930e094$var$now());
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $12584cae6930e094$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 22:
            ii = null !== finishedWork.memoizedState;
            _eventPayloads$ii2 = null !== current && null !== current.memoizedState;
            var prevOffscreenSubtreeIsHidden = $12584cae6930e094$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $12584cae6930e094$var$offscreenSubtreeWasHidden, prevOffscreenDirectParentIsHidden$166 = $12584cae6930e094$var$offscreenDirectParentIsHidden;
            $12584cae6930e094$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || ii;
            $12584cae6930e094$var$offscreenDirectParentIsHidden = prevOffscreenDirectParentIsHidden$166 || ii;
            $12584cae6930e094$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || _eventPayloads$ii2;
            $12584cae6930e094$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $12584cae6930e094$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $12584cae6930e094$var$offscreenDirectParentIsHidden = prevOffscreenDirectParentIsHidden$166;
            $12584cae6930e094$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $12584cae6930e094$var$commitReconciliationEffects(finishedWork);
            flags & 8192 && (root = finishedWork.stateNode, root._visibility = ii ? root._visibility & -2 : root._visibility | 1, !ii || null === current || _eventPayloads$ii2 || $12584cae6930e094$var$offscreenSubtreeIsHidden || $12584cae6930e094$var$offscreenSubtreeWasHidden || (root = _eventPayloads$ii2 || $12584cae6930e094$var$offscreenSubtreeWasHidden, lanes = $12584cae6930e094$var$offscreenSubtreeIsHidden, current = $12584cae6930e094$var$offscreenSubtreeWasHidden, $12584cae6930e094$var$offscreenSubtreeIsHidden = ii || $12584cae6930e094$var$offscreenSubtreeIsHidden, $12584cae6930e094$var$offscreenSubtreeWasHidden = root, $12584cae6930e094$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, 2), $12584cae6930e094$var$offscreenSubtreeIsHidden = lanes, $12584cae6930e094$var$offscreenSubtreeWasHidden = current), !ii && $12584cae6930e094$var$offscreenDirectParentIsHidden || $12584cae6930e094$var$hideOrUnhideAllChildren(finishedWork, ii));
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (lanes = root.retryQueue, null !== lanes && (root.retryQueue = null, $12584cae6930e094$var$attachSuspenseRetryListeners(finishedWork, lanes))));
            break;
        case 19:
            $12584cae6930e094$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $12584cae6930e094$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $12584cae6930e094$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 30:
            flags & 512 && ($12584cae6930e094$var$offscreenSubtreeWasHidden || null === current || $12584cae6930e094$var$safelyDetachRef(current, current.return));
            flags = $12584cae6930e094$var$pushMutationContext();
            ii = $12584cae6930e094$var$inUpdateViewTransition;
            _eventPayloads$ii2 = (lanes & 335544064) === lanes;
            prevOffscreenSubtreeIsHidden = finishedWork.memoizedProps;
            $12584cae6930e094$var$inUpdateViewTransition = _eventPayloads$ii2 && "none" !== $12584cae6930e094$var$getViewTransitionClassName(prevOffscreenSubtreeIsHidden.default, prevOffscreenSubtreeIsHidden.update);
            $12584cae6930e094$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $12584cae6930e094$var$commitReconciliationEffects(finishedWork);
            _eventPayloads$ii2 && null !== current && $12584cae6930e094$var$viewTransitionMutationContext && (finishedWork.flags |= 4);
            $12584cae6930e094$var$inUpdateViewTransition = ii;
            $12584cae6930e094$var$viewTransitionMutationContext = flags;
            break;
        case 21:
            break;
        case 7:
            flags & 512 && ($12584cae6930e094$var$offscreenSubtreeWasHidden || null === current || $12584cae6930e094$var$safelyDetachRef(current, current.return)), current && null !== current.stateNode && (current.stateNode._fragmentFiber = finishedWork);
        default:
            $12584cae6930e094$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes), $12584cae6930e094$var$commitReconciliationEffects(finishedWork);
    }
}
function $12584cae6930e094$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($12584cae6930e094$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            parentFiber = null;
            for(var parent = finishedWork.return; null !== parent;){
                if ($12584cae6930e094$var$isFragmentInstanceParent(parent)) {
                    var fragmentInstance = parent.stateNode;
                    null === parentFiber ? parentFiber = [
                        fragmentInstance
                    ] : parentFiber.push(fragmentInstance);
                }
                if ($12584cae6930e094$var$isFragmentInstanceHostBoundary(parent)) break;
                parent = parent.return;
            }
            var JSCompiler_inline_result = parentFiber;
            if (null == hostParentFiber) throw Error($12584cae6930e094$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent$jscomp$0 = hostParentFiber.stateNode, before = $12584cae6930e094$var$getHostSibling(finishedWork);
                    $12584cae6930e094$var$insertOrAppendPlacementNode(finishedWork, before, parent$jscomp$0, JSCompiler_inline_result);
                    break;
                case 5:
                    var parent$149 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($12584cae6930e094$var$setTextContent(parent$149, ""), hostParentFiber.flags &= -33);
                    var before$150 = $12584cae6930e094$var$getHostSibling(finishedWork);
                    $12584cae6930e094$var$insertOrAppendPlacementNode(finishedWork, before$150, parent$149, JSCompiler_inline_result);
                    break;
                case 3:
                case 4:
                    var parent$151 = hostParentFiber.stateNode.containerInfo, before$152 = $12584cae6930e094$var$getHostSibling(finishedWork);
                    $12584cae6930e094$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$152, parent$151, JSCompiler_inline_result);
                    break;
                default:
                    throw Error($12584cae6930e094$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $12584cae6930e094$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $12584cae6930e094$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $12584cae6930e094$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && (fiber = fiber.stateNode, $12584cae6930e094$var$_enabled = !0, fiber.reset(), $12584cae6930e094$var$_enabled = !1);
        parentFiber = parentFiber.sibling;
    }
}
function $12584cae6930e094$var$recursivelyTraverseAfterMutationEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 9270) for(parentFiber = parentFiber.child; null !== parentFiber;)$12584cae6930e094$var$commitAfterMutationEffectsOnFiber(parentFiber, root), parentFiber = parentFiber.sibling;
    else $12584cae6930e094$var$measureNestedViewTransitions(parentFiber, !1);
}
function $12584cae6930e094$var$commitAfterMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate;
    if (null === current) $12584cae6930e094$var$commitEnterViewTransitions(finishedWork, !1);
    else switch(finishedWork.tag){
        case 3:
            $12584cae6930e094$var$rootViewTransitionNameCanceled = $12584cae6930e094$var$viewTransitionContextChanged = !1;
            $12584cae6930e094$var$pushViewTransitionCancelableScope();
            $12584cae6930e094$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            if (!$12584cae6930e094$var$viewTransitionContextChanged && !$12584cae6930e094$var$rootViewTransitionAffected) {
                finishedWork = $12584cae6930e094$var$viewTransitionCancelableChildren;
                if (null !== finishedWork) for(var i = 0; i < finishedWork.length; i += 3){
                    current = finishedWork[i];
                    var oldName = finishedWork[i + 1];
                    $12584cae6930e094$var$restoreViewTransitionName(current, finishedWork[i + 2]);
                    current = current.ownerDocument.documentElement;
                    null !== current && current.animate({
                        opacity: [
                            0,
                            0
                        ],
                        pointerEvents: [
                            "none",
                            "none"
                        ]
                    }, {
                        duration: 0,
                        fill: "forwards",
                        pseudoElement: "::view-transition-group(" + oldName + ")"
                    });
                }
                finishedWork = root.containerInfo;
                finishedWork = 9 === finishedWork.nodeType ? finishedWork.documentElement : finishedWork.ownerDocument.documentElement;
                null !== finishedWork && "" === finishedWork.style.viewTransitionName && (finishedWork.style.viewTransitionName = "none", finishedWork.animate({
                    opacity: [
                        0,
                        0
                    ],
                    pointerEvents: [
                        "none",
                        "none"
                    ]
                }, {
                    duration: 0,
                    fill: "forwards",
                    pseudoElement: "::view-transition-group(root)"
                }), finishedWork.animate({
                    width: [
                        0,
                        0
                    ],
                    height: [
                        0,
                        0
                    ]
                }, {
                    duration: 0,
                    fill: "forwards",
                    pseudoElement: "::view-transition"
                }));
                $12584cae6930e094$var$rootViewTransitionNameCanceled = !0;
            }
            $12584cae6930e094$var$viewTransitionCancelableChildren = null;
            break;
        case 5:
            $12584cae6930e094$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            break;
        case 4:
            i = $12584cae6930e094$var$viewTransitionContextChanged;
            $12584cae6930e094$var$viewTransitionContextChanged = !1;
            $12584cae6930e094$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            $12584cae6930e094$var$viewTransitionContextChanged && ($12584cae6930e094$var$rootViewTransitionAffected = !0);
            $12584cae6930e094$var$viewTransitionContextChanged = i;
            break;
        case 22:
            null === finishedWork.memoizedState && (null !== current.memoizedState ? $12584cae6930e094$var$commitEnterViewTransitions(finishedWork, !1) : $12584cae6930e094$var$recursivelyTraverseAfterMutationEffects(root, finishedWork));
            break;
        case 30:
            i = $12584cae6930e094$var$viewTransitionContextChanged;
            oldName = $12584cae6930e094$var$pushViewTransitionCancelableScope();
            $12584cae6930e094$var$viewTransitionContextChanged = !1;
            $12584cae6930e094$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            $12584cae6930e094$var$viewTransitionContextChanged && (finishedWork.flags |= 4);
            var props = finishedWork.memoizedProps, state = finishedWork.stateNode;
            root = $12584cae6930e094$var$getViewTransitionName(props, state);
            state = $12584cae6930e094$var$getViewTransitionName(current.memoizedProps, state);
            var className = $12584cae6930e094$var$getViewTransitionClassName(props.default, props.update);
            "none" === className ? root = !1 : (props = current.memoizedState, current.memoizedState = null, current = finishedWork.child, $12584cae6930e094$var$viewTransitionHostInstanceIdx = 0, root = $12584cae6930e094$var$measureViewTransitionHostInstancesRecursive(finishedWork, current, root, state, className, props, !0), $12584cae6930e094$var$viewTransitionHostInstanceIdx !== (null === props ? 0 : props.length) && (finishedWork.flags |= 32));
            0 !== (finishedWork.flags & 4) && root ? ($12584cae6930e094$var$scheduleViewTransitionEvent(finishedWork, finishedWork.memoizedProps.onUpdate), $12584cae6930e094$var$viewTransitionCancelableChildren = oldName) : null !== oldName && (oldName.push.apply(oldName, $12584cae6930e094$var$viewTransitionCancelableChildren), $12584cae6930e094$var$viewTransitionCancelableChildren = oldName);
            $12584cae6930e094$var$viewTransitionContextChanged = 0 !== (finishedWork.flags & 32) ? !0 : i;
            break;
        default:
            $12584cae6930e094$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
    }
}
function $12584cae6930e094$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$12584cae6930e094$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $12584cae6930e094$var$recursivelyTraverseDisappearLayoutEffects(parentFiber, layoutEffectTraversalFlags$jscomp$0) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber, layoutEffectTraversalFlags = layoutEffectTraversalFlags$jscomp$0;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $12584cae6930e094$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $12584cae6930e094$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 1:
                $12584cae6930e094$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $12584cae6930e094$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $12584cae6930e094$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 27:
                0 !== (layoutEffectTraversalFlags & 2) && $12584cae6930e094$var$releaseSingletonInstance(finishedWork.stateNode, finishedWork.type, finishedWork.memoizedProps);
            case 5:
                $12584cae6930e094$var$safelyDetachRef(finishedWork, finishedWork.return);
                5 !== finishedWork.tag && 27 !== finishedWork.tag || $12584cae6930e094$var$commitFragmentInstanceDeletionEffects(finishedWork);
                $12584cae6930e094$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 6:
                $12584cae6930e094$var$commitFragmentInstanceDeletionEffects(finishedWork);
                break;
            case 26:
                $12584cae6930e094$var$safelyDetachRef(finishedWork, finishedWork.return);
                instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState || null === instance || $12584cae6930e094$var$offscreenSubtreeWasHidden || instance.parentNode.removeChild(instance);
                $12584cae6930e094$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 22:
                null === finishedWork.memoizedState && $12584cae6930e094$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 30:
                $12584cae6930e094$var$safelyDetachRef(finishedWork, finishedWork.return);
                $12584cae6930e094$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 7:
                $12584cae6930e094$var$safelyDetachRef(finishedWork, finishedWork.return);
            default:
                $12584cae6930e094$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $12584cae6930e094$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, layoutEffectTraversalFlags) {
    layoutEffectTraversalFlags = 0 !== (parentFiber.subtreeFlags & 8772) ? layoutEffectTraversalFlags : layoutEffectTraversalFlags & -2;
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags, includeWorkInProgressEffects = 0 !== (layoutEffectTraversalFlags & 1);
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $12584cae6930e094$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $12584cae6930e094$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $12584cae6930e094$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $12584cae6930e094$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$12584cae6930e094$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $12584cae6930e094$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $12584cae6930e094$var$commitClassCallbacks(finishedWork);
                $12584cae6930e094$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                0 !== (layoutEffectTraversalFlags & 2) && $12584cae6930e094$var$commitHostSingletonAcquisition(finishedWork);
            case 5:
                5 !== finishedWork.tag && 27 !== finishedWork.tag || $12584cae6930e094$var$commitFragmentInstanceInsertionEffects(finishedWork);
                $12584cae6930e094$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && null === current && flags & 4 && $12584cae6930e094$var$commitHostMount(finishedWork);
                $12584cae6930e094$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 6:
                $12584cae6930e094$var$commitFragmentInstanceInsertionEffects(finishedWork);
                break;
            case 26:
                instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState || null === instance || $12584cae6930e094$var$offscreenSubtreeIsHidden || $12584cae6930e094$var$mountHoistable($12584cae6930e094$var$getHoistableRoot(instance.ownerDocument), finishedWork.type, instance);
                $12584cae6930e094$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && null === current && flags & 4 && $12584cae6930e094$var$commitHostMount(finishedWork);
                $12584cae6930e094$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $12584cae6930e094$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                break;
            case 31:
                $12584cae6930e094$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && flags & 4 && $12584cae6930e094$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $12584cae6930e094$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && flags & 4 && $12584cae6930e094$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $12584cae6930e094$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $12584cae6930e094$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                $12584cae6930e094$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $12584cae6930e094$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 7:
                $12584cae6930e094$var$safelyAttachRef(finishedWork, finishedWork.return);
            default:
                $12584cae6930e094$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $12584cae6930e094$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $12584cae6930e094$var$releaseCache(previousCache));
}
function $12584cae6930e094$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $12584cae6930e094$var$releaseCache(current));
}
function $12584cae6930e094$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    var isViewTransitionEligible = (committedLanes & 335544064) === committedLanes;
    if (parentFiber.subtreeFlags & (isViewTransitionEligible ? 10262 : 10256)) for(parentFiber = parentFiber.child; null !== parentFiber;)$12584cae6930e094$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
    else isViewTransitionEligible && $12584cae6930e094$var$restoreNestedViewTransitions(parentFiber);
}
function $12584cae6930e094$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var isViewTransitionEligible = (committedLanes & 335544064) === committedLanes;
    isViewTransitionEligible && null === finishedWork.alternate && null !== finishedWork.return && null !== finishedWork.return.alternate && $12584cae6930e094$var$restoreEnterOrExitViewTransitions(finishedWork);
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $12584cae6930e094$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $12584cae6930e094$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $12584cae6930e094$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $12584cae6930e094$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            isViewTransitionEligible && $12584cae6930e094$var$rootViewTransitionNameCanceled && (finishedRoot = finishedRoot.containerInfo, finishedRoot = 9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, "root" === finishedRoot.style.viewTransitionName && (finishedRoot.style.viewTransitionName = ""), finishedRoot = finishedRoot.ownerDocument.documentElement, null !== finishedRoot && "none" === finishedRoot.style.viewTransitionName && (finishedRoot.style.viewTransitionName = ""));
            flags & 2048 && (flags = null, null !== finishedWork.alternate && (flags = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== flags && (finishedWork.refCount++, null != flags && $12584cae6930e094$var$releaseCache(flags)));
            break;
        case 12:
            if (flags & 2048) {
                $12584cae6930e094$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                flags = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", flags.passiveEffectDuration, -0);
                } catch (error) {
                    $12584cae6930e094$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $12584cae6930e094$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $12584cae6930e094$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $12584cae6930e094$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? (isViewTransitionEligible && null !== id && null === id.memoizedState && $12584cae6930e094$var$restoreEnterOrExitViewTransitions(id), _finishedWork$memoize2._visibility & 2 ? $12584cae6930e094$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $12584cae6930e094$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork)) : (isViewTransitionEligible && null !== id && null !== id.memoizedState && $12584cae6930e094$var$restoreEnterOrExitViewTransitions(finishedWork), _finishedWork$memoize2._visibility & 2 ? $12584cae6930e094$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $12584cae6930e094$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1)));
            flags & 2048 && $12584cae6930e094$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $12584cae6930e094$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $12584cae6930e094$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        case 30:
            isViewTransitionEligible && (flags = finishedWork.alternate, null !== flags && ($12584cae6930e094$var$restoreViewTransitionOnHostInstances(flags.child, !0), $12584cae6930e094$var$restoreViewTransitionOnHostInstances(finishedWork.child, !0)));
            $12584cae6930e094$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        default:
            $12584cae6930e094$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $12584cae6930e094$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $12584cae6930e094$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $12584cae6930e094$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $12584cae6930e094$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $12584cae6930e094$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $12584cae6930e094$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $12584cae6930e094$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $12584cae6930e094$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $12584cae6930e094$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $12584cae6930e094$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $12584cae6930e094$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $12584cae6930e094$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $12584cae6930e094$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $12584cae6930e094$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $12584cae6930e094$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $12584cae6930e094$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $12584cae6930e094$var$suspenseyCommitFlag = 8192;
function $12584cae6930e094$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $12584cae6930e094$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$12584cae6930e094$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $12584cae6930e094$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $12584cae6930e094$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $12584cae6930e094$var$suspenseyCommitFlag && (null !== fiber.memoizedState ? $12584cae6930e094$var$suspendResource(suspendedState, $12584cae6930e094$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps) : (fiber = fiber.stateNode, (committedLanes & 335544128) === committedLanes && $12584cae6930e094$var$suspendInstance(suspendedState, fiber)));
            break;
        case 5:
            $12584cae6930e094$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $12584cae6930e094$var$suspenseyCommitFlag && (fiber = fiber.stateNode, (committedLanes & 335544128) === committedLanes && $12584cae6930e094$var$suspendInstance(suspendedState, fiber));
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $12584cae6930e094$var$currentHoistableRoot;
            $12584cae6930e094$var$currentHoistableRoot = $12584cae6930e094$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $12584cae6930e094$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $12584cae6930e094$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $12584cae6930e094$var$suspenseyCommitFlag, $12584cae6930e094$var$suspenseyCommitFlag = 16777216, $12584cae6930e094$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $12584cae6930e094$var$suspenseyCommitFlag = previousHoistableRoot) : $12584cae6930e094$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        case 30:
            if (0 !== (fiber.flags & $12584cae6930e094$var$suspenseyCommitFlag) && (previousHoistableRoot = fiber.memoizedProps.name, null != previousHoistableRoot && "auto" !== previousHoistableRoot)) {
                var state = fiber.stateNode;
                state.paired = null;
                null === $12584cae6930e094$var$appearingViewTransitions && ($12584cae6930e094$var$appearingViewTransitions = new Map());
                $12584cae6930e094$var$appearingViewTransitions.set(previousHoistableRoot, state);
            }
            $12584cae6930e094$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        default:
            $12584cae6930e094$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $12584cae6930e094$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $12584cae6930e094$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $12584cae6930e094$var$nextEffect = childToDelete;
            $12584cae6930e094$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $12584cae6930e094$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$12584cae6930e094$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $12584cae6930e094$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $12584cae6930e094$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $12584cae6930e094$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $12584cae6930e094$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $12584cae6930e094$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $12584cae6930e094$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $12584cae6930e094$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $12584cae6930e094$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $12584cae6930e094$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $12584cae6930e094$var$nextEffect = childToDelete;
            $12584cae6930e094$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $12584cae6930e094$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $12584cae6930e094$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $12584cae6930e094$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $12584cae6930e094$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $12584cae6930e094$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $12584cae6930e094$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $12584cae6930e094$var$nextEffect;){
        var fiber = $12584cae6930e094$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $12584cae6930e094$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $12584cae6930e094$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $12584cae6930e094$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $12584cae6930e094$var$nextEffect;){
            cache = $12584cae6930e094$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $12584cae6930e094$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $12584cae6930e094$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $12584cae6930e094$var$nextEffect = sibling;
                break a;
            }
            $12584cae6930e094$var$nextEffect = returnFiber;
        }
    }
}
var $12584cae6930e094$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $12584cae6930e094$var$readContext($12584cae6930e094$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $12584cae6930e094$var$readContext($12584cae6930e094$var$CacheContext).controller.signal;
    }
}, $12584cae6930e094$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $12584cae6930e094$var$executionContext = 0, $12584cae6930e094$var$workInProgressRoot = null, $12584cae6930e094$var$workInProgress = null, $12584cae6930e094$var$workInProgressRootRenderLanes = 0, $12584cae6930e094$var$workInProgressSuspendedReason = 0, $12584cae6930e094$var$workInProgressThrownValue = null, $12584cae6930e094$var$workInProgressRootDidSkipSuspendedSiblings = !1, $12584cae6930e094$var$workInProgressRootIsPrerendering = !1, $12584cae6930e094$var$workInProgressRootDidAttachPingListener = !1, $12584cae6930e094$var$entangledRenderLanes = 0, $12584cae6930e094$var$workInProgressRootExitStatus = 0, $12584cae6930e094$var$workInProgressRootSkippedLanes = 0, $12584cae6930e094$var$workInProgressRootInterleavedUpdatedLanes = 0, $12584cae6930e094$var$workInProgressRootPingedLanes = 0, $12584cae6930e094$var$workInProgressDeferredLane = 0, $12584cae6930e094$var$workInProgressSuspendedRetryLanes = 0, $12584cae6930e094$var$workInProgressRootConcurrentErrors = null, $12584cae6930e094$var$workInProgressRootRecoverableErrors = null, $12584cae6930e094$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $12584cae6930e094$var$globalMostRecentFallbackTime = 0, $12584cae6930e094$var$globalMostRecentTransitionTime = 0, $12584cae6930e094$var$workInProgressRootRenderTargetTime = Infinity, $12584cae6930e094$var$workInProgressTransitions = null, $12584cae6930e094$var$legacyErrorBoundariesThatAlreadyFailed = null, $12584cae6930e094$var$pendingEffectsStatus = 0, $12584cae6930e094$var$pendingEffectsRoot = null, $12584cae6930e094$var$pendingFinishedWork = null, $12584cae6930e094$var$pendingEffectsLanes = 0, $12584cae6930e094$var$pendingEffectsRemainingLanes = 0, $12584cae6930e094$var$pendingPassiveTransitions = null, $12584cae6930e094$var$pendingRecoverableErrors = null, $12584cae6930e094$var$pendingViewTransition = null, $12584cae6930e094$var$pendingViewTransitionEvents = null, $12584cae6930e094$var$pendingTransitionTypes = null, $12584cae6930e094$var$nestedUpdateCount = 0, $12584cae6930e094$var$rootWithNestedUpdates = null;
function $12584cae6930e094$var$requestUpdateLane() {
    return 0 !== ($12584cae6930e094$var$executionContext & 2) && 0 !== $12584cae6930e094$var$workInProgressRootRenderLanes ? $12584cae6930e094$var$workInProgressRootRenderLanes & -$12584cae6930e094$var$workInProgressRootRenderLanes : null !== $12584cae6930e094$var$ReactSharedInternals.T ? $12584cae6930e094$var$requestTransitionLane() : $12584cae6930e094$var$resolveUpdatePriority();
}
function $12584cae6930e094$var$requestDeferredLane() {
    if (0 === $12584cae6930e094$var$workInProgressDeferredLane) {
        if (0 === ($12584cae6930e094$var$workInProgressRootRenderLanes & 536870912) || $12584cae6930e094$var$isHydrating) {
            var lane = $12584cae6930e094$var$nextTransitionDeferredLane;
            $12584cae6930e094$var$nextTransitionDeferredLane <<= 1;
            0 === ($12584cae6930e094$var$nextTransitionDeferredLane & 3932160) && ($12584cae6930e094$var$nextTransitionDeferredLane = 262144);
            $12584cae6930e094$var$workInProgressDeferredLane = lane;
        } else $12584cae6930e094$var$workInProgressDeferredLane = 536870912;
    }
    lane = $12584cae6930e094$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $12584cae6930e094$var$workInProgressDeferredLane;
}
function $12584cae6930e094$var$scheduleViewTransitionEvent(fiber, callback) {
    if (null != callback) {
        var state = fiber.stateNode, instance = state.ref;
        null === instance && (instance = state.ref = $12584cae6930e094$var$createViewTransitionInstance($12584cae6930e094$var$getViewTransitionName(fiber.memoizedProps, state)));
        null === $12584cae6930e094$var$pendingViewTransitionEvents && ($12584cae6930e094$var$pendingViewTransitionEvents = []);
        $12584cae6930e094$var$pendingViewTransitionEvents.push(callback.bind(null, instance));
    }
}
function $12584cae6930e094$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $12584cae6930e094$var$workInProgressRoot && (2 === $12584cae6930e094$var$workInProgressSuspendedReason || 9 === $12584cae6930e094$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $12584cae6930e094$var$prepareFreshStack(root, 0), $12584cae6930e094$var$markRootSuspended(root, $12584cae6930e094$var$workInProgressRootRenderLanes, $12584cae6930e094$var$workInProgressDeferredLane, !1);
    $12584cae6930e094$var$markRootUpdated$1(root, lane);
    if (0 === ($12584cae6930e094$var$executionContext & 2) || root !== $12584cae6930e094$var$workInProgressRoot) root === $12584cae6930e094$var$workInProgressRoot && (0 === ($12584cae6930e094$var$executionContext & 2) && ($12584cae6930e094$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $12584cae6930e094$var$workInProgressRootExitStatus && $12584cae6930e094$var$markRootSuspended(root, $12584cae6930e094$var$workInProgressRootRenderLanes, $12584cae6930e094$var$workInProgressDeferredLane, !1)), $12584cae6930e094$var$ensureRootIsScheduled(root);
}
function $12584cae6930e094$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($12584cae6930e094$var$executionContext & 6)) throw Error($12584cae6930e094$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $12584cae6930e094$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $12584cae6930e094$var$renderRootConcurrent(root$jscomp$0, lanes) : $12584cae6930e094$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $12584cae6930e094$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $12584cae6930e094$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$12584cae6930e094$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $12584cae6930e094$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $12584cae6930e094$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($12584cae6930e094$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $12584cae6930e094$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result && 6 !== JSCompiler_inline_result) {
                            if ($12584cae6930e094$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $12584cae6930e094$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $12584cae6930e094$var$workInProgressRootRecoverableErrors;
                            $12584cae6930e094$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $12584cae6930e094$var$workInProgressRootRecoverableErrors ? $12584cae6930e094$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $12584cae6930e094$var$workInProgressRootRecoverableErrors.push.apply($12584cae6930e094$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $12584cae6930e094$var$prepareFreshStack(root$jscomp$0, 0);
                $12584cae6930e094$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($12584cae6930e094$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes && (lanes & 62914560) !== lanes) break;
                    case 6:
                        $12584cae6930e094$var$markRootSuspended(shouldTimeSlice, lanes, $12584cae6930e094$var$workInProgressDeferredLane, !$12584cae6930e094$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $12584cae6930e094$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($12584cae6930e094$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $12584cae6930e094$var$globalMostRecentFallbackTime + 300 - $12584cae6930e094$var$now(), 10 < exitStatus)) {
                    $12584cae6930e094$var$markRootSuspended(shouldTimeSlice, lanes, $12584cae6930e094$var$workInProgressDeferredLane, !$12584cae6930e094$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $12584cae6930e094$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $12584cae6930e094$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $12584cae6930e094$var$scheduleTimeout($12584cae6930e094$var$completeRootWhenReady.bind(null, shouldTimeSlice, forceSync, $12584cae6930e094$var$workInProgressRootRecoverableErrors, $12584cae6930e094$var$workInProgressTransitions, $12584cae6930e094$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $12584cae6930e094$var$workInProgressDeferredLane, $12584cae6930e094$var$workInProgressRootInterleavedUpdatedLanes, $12584cae6930e094$var$workInProgressSuspendedRetryLanes, $12584cae6930e094$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $12584cae6930e094$var$completeRootWhenReady(shouldTimeSlice, forceSync, $12584cae6930e094$var$workInProgressRootRecoverableErrors, $12584cae6930e094$var$workInProgressTransitions, $12584cae6930e094$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $12584cae6930e094$var$workInProgressDeferredLane, $12584cae6930e094$var$workInProgressRootInterleavedUpdatedLanes, $12584cae6930e094$var$workInProgressSuspendedRetryLanes, $12584cae6930e094$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $12584cae6930e094$var$ensureRootIsScheduled(root$jscomp$0);
}
function $12584cae6930e094$var$completeRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    var subtreeFlags = finishedWork.subtreeFlags, isViewTransitionEligible = (lanes & 335544064) === lanes;
    suspendedCommitReason = null;
    if (isViewTransitionEligible || subtreeFlags & 8192 || 16785408 === (subtreeFlags & 16785408)) {
        if (suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $12584cae6930e094$var$noop$1
        }, $12584cae6930e094$var$appearingViewTransitions = null, $12584cae6930e094$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason), isViewTransitionEligible && (subtreeFlags = suspendedCommitReason, isViewTransitionEligible = root.containerInfo, isViewTransitionEligible = (9 === isViewTransitionEligible.nodeType ? isViewTransitionEligible : isViewTransitionEligible.ownerDocument).__reactViewTransition, null != isViewTransitionEligible && (subtreeFlags.count++, subtreeFlags.waitingForViewTransition = !0, subtreeFlags = $12584cae6930e094$var$onUnsuspend.bind(subtreeFlags), isViewTransitionEligible.finished.then(subtreeFlags, subtreeFlags))), subtreeFlags = (lanes & 62914560) === lanes ? $12584cae6930e094$var$globalMostRecentFallbackTime - $12584cae6930e094$var$now() : (lanes & 4194048) === lanes ? $12584cae6930e094$var$globalMostRecentTransitionTime - $12584cae6930e094$var$now() : 0, subtreeFlags = $12584cae6930e094$var$waitForCommitToBeReady(suspendedCommitReason, subtreeFlags), null !== subtreeFlags) {
            $12584cae6930e094$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = subtreeFlags($12584cae6930e094$var$completeRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $12584cae6930e094$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $12584cae6930e094$var$completeRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason);
}
function $12584cae6930e094$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$12584cae6930e094$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $12584cae6930e094$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes = $12584cae6930e094$var$getEntangledLanes(root, suspendedLanes);
    suspendedLanes &= ~$12584cae6930e094$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$12584cae6930e094$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $12584cae6930e094$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $12584cae6930e094$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $12584cae6930e094$var$flushSyncWork$1() {
    return 0 === ($12584cae6930e094$var$executionContext & 6) ? ($12584cae6930e094$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $12584cae6930e094$var$resetWorkInProgressStack() {
    if (null !== $12584cae6930e094$var$workInProgress) {
        if (0 === $12584cae6930e094$var$workInProgressSuspendedReason) var interruptedWork = $12584cae6930e094$var$workInProgress.return;
        else interruptedWork = $12584cae6930e094$var$workInProgress, $12584cae6930e094$var$lastContextDependency = $12584cae6930e094$var$currentlyRenderingFiber$1 = null, $12584cae6930e094$var$resetHooksOnUnwind(interruptedWork), $12584cae6930e094$var$thenableState$1 = null, $12584cae6930e094$var$thenableIndexCounter$1 = 0, interruptedWork = $12584cae6930e094$var$workInProgress;
        for(; null !== interruptedWork;)$12584cae6930e094$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $12584cae6930e094$var$workInProgress = null;
    }
}
function $12584cae6930e094$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $12584cae6930e094$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $12584cae6930e094$var$pendingEffectsLanes = 0;
    $12584cae6930e094$var$resetWorkInProgressStack();
    $12584cae6930e094$var$workInProgressRoot = root;
    $12584cae6930e094$var$workInProgress = timeoutHandle = $12584cae6930e094$var$createWorkInProgress(root.current, null);
    $12584cae6930e094$var$workInProgressRootRenderLanes = lanes;
    $12584cae6930e094$var$workInProgressSuspendedReason = 0;
    $12584cae6930e094$var$workInProgressThrownValue = null;
    $12584cae6930e094$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $12584cae6930e094$var$workInProgressRootIsPrerendering = $12584cae6930e094$var$checkIfRootIsPrerendering(root, lanes);
    $12584cae6930e094$var$workInProgressRootDidAttachPingListener = !1;
    $12584cae6930e094$var$workInProgressSuspendedRetryLanes = $12584cae6930e094$var$workInProgressDeferredLane = $12584cae6930e094$var$workInProgressRootPingedLanes = $12584cae6930e094$var$workInProgressRootInterleavedUpdatedLanes = $12584cae6930e094$var$workInProgressRootSkippedLanes = $12584cae6930e094$var$workInProgressRootExitStatus = 0;
    $12584cae6930e094$var$workInProgressRootRecoverableErrors = $12584cae6930e094$var$workInProgressRootConcurrentErrors = null;
    $12584cae6930e094$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    $12584cae6930e094$var$entangledRenderLanes = $12584cae6930e094$var$getEntangledLanes(root, lanes);
    $12584cae6930e094$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $12584cae6930e094$var$handleThrow(root, thrownValue) {
    $12584cae6930e094$var$currentlyRenderingFiber = null;
    $12584cae6930e094$var$ReactSharedInternals.H = $12584cae6930e094$var$ContextOnlyDispatcher;
    thrownValue === $12584cae6930e094$var$SuspenseException || thrownValue === $12584cae6930e094$var$SuspenseActionException ? (thrownValue = $12584cae6930e094$var$getSuspendedThenable(), $12584cae6930e094$var$workInProgressSuspendedReason = 3) : thrownValue === $12584cae6930e094$var$SuspenseyCommitException ? (thrownValue = $12584cae6930e094$var$getSuspendedThenable(), $12584cae6930e094$var$workInProgressSuspendedReason = 4) : $12584cae6930e094$var$workInProgressSuspendedReason = thrownValue === $12584cae6930e094$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $12584cae6930e094$var$workInProgressThrownValue = thrownValue;
    null === $12584cae6930e094$var$workInProgress && ($12584cae6930e094$var$workInProgressRootExitStatus = 1, $12584cae6930e094$var$logUncaughtError(root, $12584cae6930e094$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $12584cae6930e094$var$shouldRemainOnPreviousScreen() {
    var handler = $12584cae6930e094$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($12584cae6930e094$var$workInProgressRootRenderLanes & 4194048) === $12584cae6930e094$var$workInProgressRootRenderLanes ? null === $12584cae6930e094$var$shellBoundary ? !0 : !1 : ($12584cae6930e094$var$workInProgressRootRenderLanes & 62914560) === $12584cae6930e094$var$workInProgressRootRenderLanes || 0 !== ($12584cae6930e094$var$workInProgressRootRenderLanes & 536870912) ? handler === $12584cae6930e094$var$shellBoundary : !1;
}
function $12584cae6930e094$var$pushDispatcher() {
    var prevDispatcher = $12584cae6930e094$var$ReactSharedInternals.H;
    $12584cae6930e094$var$ReactSharedInternals.H = $12584cae6930e094$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $12584cae6930e094$var$ContextOnlyDispatcher : prevDispatcher;
}
function $12584cae6930e094$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $12584cae6930e094$var$ReactSharedInternals.A;
    $12584cae6930e094$var$ReactSharedInternals.A = $12584cae6930e094$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $12584cae6930e094$var$renderDidSuspendDelayIfPossible() {
    $12584cae6930e094$var$workInProgressRootExitStatus = 4;
    $12584cae6930e094$var$workInProgressRootDidSkipSuspendedSiblings || ($12584cae6930e094$var$workInProgressRootRenderLanes & 4194048) !== $12584cae6930e094$var$workInProgressRootRenderLanes && null !== $12584cae6930e094$var$suspenseHandlerStackCursor.current || ($12584cae6930e094$var$workInProgressRootIsPrerendering = !0);
    0 === ($12584cae6930e094$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($12584cae6930e094$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $12584cae6930e094$var$workInProgressRoot || $12584cae6930e094$var$markRootSuspended($12584cae6930e094$var$workInProgressRoot, $12584cae6930e094$var$workInProgressRootRenderLanes, $12584cae6930e094$var$workInProgressDeferredLane, !1);
}
function $12584cae6930e094$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $12584cae6930e094$var$executionContext;
    $12584cae6930e094$var$executionContext |= 2;
    var prevDispatcher = $12584cae6930e094$var$pushDispatcher(), prevAsyncDispatcher = $12584cae6930e094$var$pushAsyncDispatcher();
    if ($12584cae6930e094$var$workInProgressRoot !== root || $12584cae6930e094$var$workInProgressRootRenderLanes !== lanes) $12584cae6930e094$var$workInProgressTransitions = null, $12584cae6930e094$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $12584cae6930e094$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $12584cae6930e094$var$workInProgressSuspendedReason && null !== $12584cae6930e094$var$workInProgress) {
            var unitOfWork = $12584cae6930e094$var$workInProgress, thrownValue = $12584cae6930e094$var$workInProgressThrownValue;
            switch($12584cae6930e094$var$workInProgressSuspendedReason){
                case 8:
                    $12584cae6930e094$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $12584cae6930e094$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $12584cae6930e094$var$workInProgressSuspendedReason;
                    $12584cae6930e094$var$workInProgressSuspendedReason = 0;
                    $12584cae6930e094$var$workInProgressThrownValue = null;
                    $12584cae6930e094$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $12584cae6930e094$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $12584cae6930e094$var$workInProgressSuspendedReason, $12584cae6930e094$var$workInProgressSuspendedReason = 0, $12584cae6930e094$var$workInProgressThrownValue = null, $12584cae6930e094$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $12584cae6930e094$var$workLoopSync();
        exitStatus = $12584cae6930e094$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$184) {
        $12584cae6930e094$var$handleThrow(root, thrownValue$184);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $12584cae6930e094$var$lastContextDependency = $12584cae6930e094$var$currentlyRenderingFiber$1 = null;
    $12584cae6930e094$var$executionContext = prevExecutionContext;
    $12584cae6930e094$var$ReactSharedInternals.H = prevDispatcher;
    $12584cae6930e094$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $12584cae6930e094$var$workInProgress && ($12584cae6930e094$var$workInProgressRoot = null, $12584cae6930e094$var$workInProgressRootRenderLanes = 0, $12584cae6930e094$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $12584cae6930e094$var$workLoopSync() {
    for(; null !== $12584cae6930e094$var$workInProgress;)$12584cae6930e094$var$performUnitOfWork($12584cae6930e094$var$workInProgress);
}
function $12584cae6930e094$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $12584cae6930e094$var$executionContext;
    $12584cae6930e094$var$executionContext |= 2;
    var prevDispatcher = $12584cae6930e094$var$pushDispatcher(), prevAsyncDispatcher = $12584cae6930e094$var$pushAsyncDispatcher();
    $12584cae6930e094$var$workInProgressRoot !== root || $12584cae6930e094$var$workInProgressRootRenderLanes !== lanes ? ($12584cae6930e094$var$workInProgressTransitions = null, $12584cae6930e094$var$workInProgressRootRenderTargetTime = $12584cae6930e094$var$now() + 500, $12584cae6930e094$var$prepareFreshStack(root, lanes)) : $12584cae6930e094$var$workInProgressRootIsPrerendering = $12584cae6930e094$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $12584cae6930e094$var$workInProgressSuspendedReason && null !== $12584cae6930e094$var$workInProgress) {
            lanes = $12584cae6930e094$var$workInProgress;
            var thrownValue = $12584cae6930e094$var$workInProgressThrownValue;
            b: switch($12584cae6930e094$var$workInProgressSuspendedReason){
                case 1:
                    $12584cae6930e094$var$workInProgressSuspendedReason = 0;
                    $12584cae6930e094$var$workInProgressThrownValue = null;
                    $12584cae6930e094$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($12584cae6930e094$var$isThenableResolved(thrownValue)) {
                        $12584cae6930e094$var$workInProgressSuspendedReason = 0;
                        $12584cae6930e094$var$workInProgressThrownValue = null;
                        $12584cae6930e094$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $12584cae6930e094$var$workInProgressSuspendedReason && 9 !== $12584cae6930e094$var$workInProgressSuspendedReason || $12584cae6930e094$var$workInProgressRoot !== root || ($12584cae6930e094$var$workInProgressSuspendedReason = 7);
                        $12584cae6930e094$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $12584cae6930e094$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $12584cae6930e094$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $12584cae6930e094$var$isThenableResolved(thrownValue) ? ($12584cae6930e094$var$workInProgressSuspendedReason = 0, $12584cae6930e094$var$workInProgressThrownValue = null, $12584cae6930e094$var$replaySuspendedUnitOfWork(lanes)) : ($12584cae6930e094$var$workInProgressSuspendedReason = 0, $12584cae6930e094$var$workInProgressThrownValue = null, $12584cae6930e094$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($12584cae6930e094$var$workInProgress.tag){
                        case 26:
                            resource = $12584cae6930e094$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $12584cae6930e094$var$workInProgress;
                            if (resource ? $12584cae6930e094$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $12584cae6930e094$var$workInProgressSuspendedReason = 0;
                                $12584cae6930e094$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $12584cae6930e094$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($12584cae6930e094$var$workInProgress = returnFiber, $12584cae6930e094$var$completeUnitOfWork(returnFiber)) : $12584cae6930e094$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $12584cae6930e094$var$workInProgressSuspendedReason = 0;
                    $12584cae6930e094$var$workInProgressThrownValue = null;
                    $12584cae6930e094$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $12584cae6930e094$var$workInProgressSuspendedReason = 0;
                    $12584cae6930e094$var$workInProgressThrownValue = null;
                    $12584cae6930e094$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $12584cae6930e094$var$resetWorkInProgressStack();
                    $12584cae6930e094$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($12584cae6930e094$var$formatProdErrorMessage(462));
            }
        }
        $12584cae6930e094$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$186) {
        $12584cae6930e094$var$handleThrow(root, thrownValue$186);
    }
    while (1);
    $12584cae6930e094$var$lastContextDependency = $12584cae6930e094$var$currentlyRenderingFiber$1 = null;
    $12584cae6930e094$var$ReactSharedInternals.H = prevDispatcher;
    $12584cae6930e094$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $12584cae6930e094$var$executionContext = prevExecutionContext;
    if (null !== $12584cae6930e094$var$workInProgress) return 0;
    $12584cae6930e094$var$workInProgressRoot = null;
    $12584cae6930e094$var$workInProgressRootRenderLanes = 0;
    $12584cae6930e094$var$finishQueueingConcurrentUpdates();
    return $12584cae6930e094$var$workInProgressRootExitStatus;
}
function $12584cae6930e094$var$workLoopConcurrentByScheduler() {
    for(; null !== $12584cae6930e094$var$workInProgress && !$12584cae6930e094$var$shouldYield();)$12584cae6930e094$var$performUnitOfWork($12584cae6930e094$var$workInProgress);
}
function $12584cae6930e094$var$performUnitOfWork(unitOfWork) {
    var next = $12584cae6930e094$var$beginWork(unitOfWork.alternate, unitOfWork, $12584cae6930e094$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $12584cae6930e094$var$completeUnitOfWork(unitOfWork) : $12584cae6930e094$var$workInProgress = next;
}
function $12584cae6930e094$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $12584cae6930e094$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $12584cae6930e094$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $12584cae6930e094$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $12584cae6930e094$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $12584cae6930e094$var$resetHooksOnUnwind(next);
            var fiber = next;
            fiber === $12584cae6930e094$var$hydrationParentFiber && ($12584cae6930e094$var$isHydrating ? ($12584cae6930e094$var$popToNextHostParent(fiber), 5 === fiber.tag && null != fiber.stateNode && ($12584cae6930e094$var$nextHydratableInstance = fiber.stateNode)) : ($12584cae6930e094$var$popToNextHostParent(fiber), $12584cae6930e094$var$isHydrating = !0));
        default:
            $12584cae6930e094$var$unwindInterruptedWork(current, next), next = $12584cae6930e094$var$workInProgress = $12584cae6930e094$var$resetWorkInProgress(next, $12584cae6930e094$var$entangledRenderLanes), next = $12584cae6930e094$var$beginWork(current, next, $12584cae6930e094$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $12584cae6930e094$var$completeUnitOfWork(unitOfWork) : $12584cae6930e094$var$workInProgress = next;
}
function $12584cae6930e094$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $12584cae6930e094$var$lastContextDependency = $12584cae6930e094$var$currentlyRenderingFiber$1 = null;
    $12584cae6930e094$var$resetHooksOnUnwind(unitOfWork);
    $12584cae6930e094$var$thenableState$1 = null;
    $12584cae6930e094$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($12584cae6930e094$var$throwException(root, returnFiber, unitOfWork, thrownValue, $12584cae6930e094$var$workInProgressRootRenderLanes)) {
            $12584cae6930e094$var$workInProgressRootExitStatus = 1;
            $12584cae6930e094$var$logUncaughtError(root, $12584cae6930e094$var$createCapturedValueAtFiber(thrownValue, root.current));
            $12584cae6930e094$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $12584cae6930e094$var$workInProgress = returnFiber, error;
        $12584cae6930e094$var$workInProgressRootExitStatus = 1;
        $12584cae6930e094$var$logUncaughtError(root, $12584cae6930e094$var$createCapturedValueAtFiber(thrownValue, root.current));
        $12584cae6930e094$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($12584cae6930e094$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($12584cae6930e094$var$workInProgressRootIsPrerendering || 0 !== ($12584cae6930e094$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($12584cae6930e094$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $12584cae6930e094$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $12584cae6930e094$var$unwindUnitOfWork(unitOfWork, root);
    } else $12584cae6930e094$var$completeUnitOfWork(unitOfWork);
}
function $12584cae6930e094$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $12584cae6930e094$var$unwindUnitOfWork(completedWork, $12584cae6930e094$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $12584cae6930e094$var$completeWork(completedWork.alternate, completedWork, $12584cae6930e094$var$entangledRenderLanes);
        if (null !== next) {
            $12584cae6930e094$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $12584cae6930e094$var$workInProgress = completedWork;
            return;
        }
        $12584cae6930e094$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $12584cae6930e094$var$workInProgressRootExitStatus && ($12584cae6930e094$var$workInProgressRootExitStatus = 5);
}
function $12584cae6930e094$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $12584cae6930e094$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $12584cae6930e094$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $12584cae6930e094$var$workInProgress = unitOfWork;
            return;
        }
        $12584cae6930e094$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $12584cae6930e094$var$workInProgressRootExitStatus = 6;
    $12584cae6930e094$var$workInProgress = null;
}
function $12584cae6930e094$var$completeRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedState) {
    root.cancelPendingCommit = null;
    do $12584cae6930e094$var$flushPendingEffects();
    while (0 !== $12584cae6930e094$var$pendingEffectsStatus);
    if (0 !== ($12584cae6930e094$var$executionContext & 6)) throw Error($12584cae6930e094$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($12584cae6930e094$var$formatProdErrorMessage(177));
        root === $12584cae6930e094$var$workInProgressRoot && ($12584cae6930e094$var$workInProgress = $12584cae6930e094$var$workInProgressRoot = null, $12584cae6930e094$var$workInProgressRootRenderLanes = 0);
        $12584cae6930e094$var$pendingFinishedWork = finishedWork;
        $12584cae6930e094$var$pendingEffectsRoot = root;
        $12584cae6930e094$var$pendingEffectsLanes = lanes;
        $12584cae6930e094$var$pendingPassiveTransitions = transitions;
        $12584cae6930e094$var$pendingRecoverableErrors = recoverableErrors;
        $12584cae6930e094$var$commitRoot(root, finishedWork, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedState);
    }
}
function $12584cae6930e094$var$commitRoot(root, finishedWork, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedState) {
    var remainingLanes = finishedWork.lanes | finishedWork.childLanes;
    $12584cae6930e094$var$pendingEffectsRemainingLanes = remainingLanes;
    remainingLanes |= $12584cae6930e094$var$concurrentlyUpdatedLanes;
    $12584cae6930e094$var$markRootFinished(root, lanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes);
    $12584cae6930e094$var$pendingViewTransitionEvents = null;
    (lanes & 335544064) === lanes ? ($12584cae6930e094$var$pendingTransitionTypes = $12584cae6930e094$var$claimQueuedTransitionTypes(root), spawnedLane = 10262) : ($12584cae6930e094$var$pendingTransitionTypes = null, spawnedLane = 10256);
    0 !== (finishedWork.subtreeFlags & spawnedLane) || 0 !== (finishedWork.flags & spawnedLane) ? (root.callbackNode = null, root.callbackPriority = 0, $12584cae6930e094$var$scheduleCallback$1($12584cae6930e094$var$NormalPriority$1, function() {
        $12584cae6930e094$var$flushPassiveEffects();
        return null;
    })) : (root.callbackNode = null, root.callbackPriority = 0);
    $12584cae6930e094$var$shouldStartViewTransition = !1;
    spawnedLane = 0 !== (finishedWork.flags & 13878);
    if (0 !== (finishedWork.subtreeFlags & 13878) || spawnedLane) {
        spawnedLane = $12584cae6930e094$var$ReactSharedInternals.T;
        $12584cae6930e094$var$ReactSharedInternals.T = null;
        updatedLanes = $12584cae6930e094$var$ReactDOMSharedInternals.p;
        $12584cae6930e094$var$ReactDOMSharedInternals.p = 2;
        suspendedRetryLanes = $12584cae6930e094$var$executionContext;
        $12584cae6930e094$var$executionContext |= 4;
        try {
            $12584cae6930e094$var$commitBeforeMutationEffects(root, finishedWork, lanes);
        } finally{
            $12584cae6930e094$var$executionContext = suspendedRetryLanes, $12584cae6930e094$var$ReactDOMSharedInternals.p = updatedLanes, $12584cae6930e094$var$ReactSharedInternals.T = spawnedLane;
        }
    }
    $12584cae6930e094$var$pendingEffectsStatus = 1;
    $12584cae6930e094$var$shouldStartViewTransition ? $12584cae6930e094$var$pendingViewTransition = $12584cae6930e094$var$startViewTransition(suspendedState, root.containerInfo, $12584cae6930e094$var$pendingTransitionTypes, $12584cae6930e094$var$flushMutationEffects, $12584cae6930e094$var$flushLayoutEffects, $12584cae6930e094$var$flushAfterMutationEffects, $12584cae6930e094$var$flushSpawnedWork, $12584cae6930e094$var$flushPassiveEffects, $12584cae6930e094$var$reportViewTransitionError, null, null) : ($12584cae6930e094$var$flushMutationEffects(), $12584cae6930e094$var$flushLayoutEffects(), $12584cae6930e094$var$flushSpawnedWork());
}
function $12584cae6930e094$var$reportViewTransitionError(error) {
    if (0 !== $12584cae6930e094$var$pendingEffectsStatus) {
        var onRecoverableError = $12584cae6930e094$var$pendingEffectsRoot.onRecoverableError;
        onRecoverableError(error, {
            componentStack: null
        });
    }
}
function $12584cae6930e094$var$flushAfterMutationEffects() {
    3 === $12584cae6930e094$var$pendingEffectsStatus && ($12584cae6930e094$var$pendingEffectsStatus = 0, $12584cae6930e094$var$commitAfterMutationEffectsOnFiber($12584cae6930e094$var$pendingFinishedWork, $12584cae6930e094$var$pendingEffectsRoot), $12584cae6930e094$var$pendingEffectsStatus = 4);
}
function $12584cae6930e094$var$flushMutationEffects() {
    if (1 === $12584cae6930e094$var$pendingEffectsStatus) {
        $12584cae6930e094$var$pendingEffectsStatus = 0;
        var root = $12584cae6930e094$var$pendingEffectsRoot, finishedWork = $12584cae6930e094$var$pendingFinishedWork, lanes = $12584cae6930e094$var$pendingEffectsLanes, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $12584cae6930e094$var$ReactSharedInternals.T;
            $12584cae6930e094$var$ReactSharedInternals.T = null;
            var previousPriority = $12584cae6930e094$var$ReactDOMSharedInternals.p;
            $12584cae6930e094$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $12584cae6930e094$var$executionContext;
            $12584cae6930e094$var$executionContext |= 4;
            try {
                $12584cae6930e094$var$inUpdateViewTransition = $12584cae6930e094$var$rootViewTransitionAffected = !1;
                $12584cae6930e094$var$commitMutationEffectsOnFiber(finishedWork, root, lanes);
                lanes = $12584cae6930e094$var$selectionInformation;
                var curFocusedElem = $12584cae6930e094$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = lanes.focusedElem, priorSelectionRange = lanes.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $12584cae6930e094$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $12584cae6930e094$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $12584cae6930e094$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $12584cae6930e094$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $12584cae6930e094$var$_enabled = !!$12584cae6930e094$var$eventsEnabled;
                $12584cae6930e094$var$selectionInformation = $12584cae6930e094$var$eventsEnabled = null;
            } finally{
                $12584cae6930e094$var$executionContext = prevExecutionContext, $12584cae6930e094$var$ReactDOMSharedInternals.p = previousPriority, $12584cae6930e094$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $12584cae6930e094$var$pendingEffectsStatus = 2;
    }
}
function $12584cae6930e094$var$flushLayoutEffects() {
    if (2 === $12584cae6930e094$var$pendingEffectsStatus) {
        $12584cae6930e094$var$pendingEffectsStatus = 0;
        var root = $12584cae6930e094$var$pendingEffectsRoot, finishedWork = $12584cae6930e094$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $12584cae6930e094$var$ReactSharedInternals.T;
            $12584cae6930e094$var$ReactSharedInternals.T = null;
            var previousPriority = $12584cae6930e094$var$ReactDOMSharedInternals.p;
            $12584cae6930e094$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $12584cae6930e094$var$executionContext;
            $12584cae6930e094$var$executionContext |= 4;
            try {
                $12584cae6930e094$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $12584cae6930e094$var$executionContext = prevExecutionContext, $12584cae6930e094$var$ReactDOMSharedInternals.p = previousPriority, $12584cae6930e094$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $12584cae6930e094$var$pendingEffectsStatus = 3;
    }
}
function $12584cae6930e094$var$flushSpawnedWork() {
    if (4 === $12584cae6930e094$var$pendingEffectsStatus || 3 === $12584cae6930e094$var$pendingEffectsStatus) {
        $12584cae6930e094$var$pendingEffectsStatus = 0;
        var committedViewTransition = $12584cae6930e094$var$pendingViewTransition;
        $12584cae6930e094$var$pendingViewTransition = null;
        $12584cae6930e094$var$requestPaint();
        var root = $12584cae6930e094$var$pendingEffectsRoot, finishedWork = $12584cae6930e094$var$pendingFinishedWork, lanes = $12584cae6930e094$var$pendingEffectsLanes, recoverableErrors = $12584cae6930e094$var$pendingRecoverableErrors, passiveSubtreeMask = (lanes & 335544064) === lanes ? 10262 : 10256;
        0 !== (finishedWork.subtreeFlags & passiveSubtreeMask) || 0 !== (finishedWork.flags & passiveSubtreeMask) ? $12584cae6930e094$var$pendingEffectsStatus = 5 : ($12584cae6930e094$var$pendingEffectsStatus = 0, $12584cae6930e094$var$pendingFinishedWork = $12584cae6930e094$var$pendingEffectsRoot = null, $12584cae6930e094$var$releaseRootPooledCache(root, root.pendingLanes));
        passiveSubtreeMask = root.pendingLanes;
        0 === passiveSubtreeMask && ($12584cae6930e094$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $12584cae6930e094$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($12584cae6930e094$var$injectedHook && "function" === typeof $12584cae6930e094$var$injectedHook.onCommitFiberRoot) try {
            $12584cae6930e094$var$injectedHook.onCommitFiberRoot($12584cae6930e094$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $12584cae6930e094$var$ReactSharedInternals.T;
            passiveSubtreeMask = $12584cae6930e094$var$ReactDOMSharedInternals.p;
            $12584cae6930e094$var$ReactDOMSharedInternals.p = 2;
            $12584cae6930e094$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $12584cae6930e094$var$ReactSharedInternals.T = finishedWork, $12584cae6930e094$var$ReactDOMSharedInternals.p = passiveSubtreeMask;
            }
        }
        recoverableErrors = $12584cae6930e094$var$pendingViewTransitionEvents;
        onRecoverableError = $12584cae6930e094$var$pendingTransitionTypes;
        $12584cae6930e094$var$pendingTransitionTypes = null;
        if (null !== recoverableErrors && ($12584cae6930e094$var$pendingViewTransitionEvents = null, null === onRecoverableError && (onRecoverableError = []), null !== committedViewTransition)) for(recoverableError = 0; recoverableError < recoverableErrors.length; recoverableError++)finishedWork = (0, recoverableErrors[recoverableError])(onRecoverableError), void 0 !== finishedWork && committedViewTransition.finished.finally(finishedWork);
        0 !== ($12584cae6930e094$var$pendingEffectsLanes & 3) && $12584cae6930e094$var$flushPendingEffects();
        $12584cae6930e094$var$ensureRootIsScheduled(root);
        passiveSubtreeMask = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (passiveSubtreeMask & 42) ? root === $12584cae6930e094$var$rootWithNestedUpdates ? $12584cae6930e094$var$nestedUpdateCount++ : ($12584cae6930e094$var$nestedUpdateCount = 0, $12584cae6930e094$var$rootWithNestedUpdates = root) : ($12584cae6930e094$var$nestedUpdateCount = 0, $12584cae6930e094$var$rootWithNestedUpdates = null);
        $12584cae6930e094$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $12584cae6930e094$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $12584cae6930e094$var$releaseCache(remainingLanes)));
}
function $12584cae6930e094$var$flushPendingEffects() {
    null !== $12584cae6930e094$var$pendingViewTransition && ($12584cae6930e094$var$pendingViewTransition.skipTransition(), $12584cae6930e094$var$pendingViewTransition = null);
    $12584cae6930e094$var$flushMutationEffects();
    $12584cae6930e094$var$flushLayoutEffects();
    $12584cae6930e094$var$flushSpawnedWork();
    return $12584cae6930e094$var$flushPassiveEffects();
}
function $12584cae6930e094$var$flushPassiveEffects() {
    if (5 !== $12584cae6930e094$var$pendingEffectsStatus) return !1;
    var root = $12584cae6930e094$var$pendingEffectsRoot, remainingLanes = $12584cae6930e094$var$pendingEffectsRemainingLanes;
    $12584cae6930e094$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $12584cae6930e094$var$lanesToEventPriority($12584cae6930e094$var$pendingEffectsLanes), prevTransition = $12584cae6930e094$var$ReactSharedInternals.T, previousPriority = $12584cae6930e094$var$ReactDOMSharedInternals.p;
    try {
        $12584cae6930e094$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $12584cae6930e094$var$ReactSharedInternals.T = null;
        renderPriority = $12584cae6930e094$var$pendingPassiveTransitions;
        $12584cae6930e094$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $12584cae6930e094$var$pendingEffectsRoot, lanes = $12584cae6930e094$var$pendingEffectsLanes;
        $12584cae6930e094$var$pendingEffectsStatus = 0;
        $12584cae6930e094$var$pendingFinishedWork = $12584cae6930e094$var$pendingEffectsRoot = null;
        $12584cae6930e094$var$pendingEffectsLanes = 0;
        if (0 !== ($12584cae6930e094$var$executionContext & 6)) throw Error($12584cae6930e094$var$formatProdErrorMessage(331));
        var prevExecutionContext = $12584cae6930e094$var$executionContext;
        $12584cae6930e094$var$executionContext |= 4;
        $12584cae6930e094$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $12584cae6930e094$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $12584cae6930e094$var$executionContext = prevExecutionContext;
        $12584cae6930e094$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($12584cae6930e094$var$injectedHook && "function" === typeof $12584cae6930e094$var$injectedHook.onPostCommitFiberRoot) try {
            $12584cae6930e094$var$injectedHook.onPostCommitFiberRoot($12584cae6930e094$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $12584cae6930e094$var$ReactDOMSharedInternals.p = previousPriority, $12584cae6930e094$var$ReactSharedInternals.T = prevTransition, $12584cae6930e094$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $12584cae6930e094$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $12584cae6930e094$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $12584cae6930e094$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $12584cae6930e094$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($12584cae6930e094$var$markRootUpdated$1(rootFiber, 2), $12584cae6930e094$var$ensureRootIsScheduled(rootFiber));
}
function $12584cae6930e094$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $12584cae6930e094$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $12584cae6930e094$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $12584cae6930e094$var$legacyErrorBoundariesThatAlreadyFailed || !$12584cae6930e094$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $12584cae6930e094$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $12584cae6930e094$var$createClassErrorUpdate(2);
                instance = $12584cae6930e094$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($12584cae6930e094$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $12584cae6930e094$var$markRootUpdated$1(instance, 2), $12584cae6930e094$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $12584cae6930e094$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $12584cae6930e094$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($12584cae6930e094$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $12584cae6930e094$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $12584cae6930e094$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $12584cae6930e094$var$workInProgressRoot === root && ($12584cae6930e094$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $12584cae6930e094$var$workInProgressRootExitStatus || 3 === $12584cae6930e094$var$workInProgressRootExitStatus && ($12584cae6930e094$var$workInProgressRootRenderLanes & 62914560) === $12584cae6930e094$var$workInProgressRootRenderLanes && 300 > $12584cae6930e094$var$now() - $12584cae6930e094$var$globalMostRecentFallbackTime ? 0 === ($12584cae6930e094$var$executionContext & 2) ? $12584cae6930e094$var$prepareFreshStack(root, 0) : $12584cae6930e094$var$workInProgressRootPingedLanes |= pingedLanes : $12584cae6930e094$var$workInProgressRootPingedLanes |= pingedLanes, $12584cae6930e094$var$workInProgressSuspendedRetryLanes === $12584cae6930e094$var$workInProgressRootRenderLanes && ($12584cae6930e094$var$workInProgressSuspendedRetryLanes = 0));
    $12584cae6930e094$var$ensureRootIsScheduled(root);
}
function $12584cae6930e094$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $12584cae6930e094$var$claimNextRetryLane());
    boundaryFiber = $12584cae6930e094$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($12584cae6930e094$var$markRootUpdated$1(boundaryFiber, retryLane), $12584cae6930e094$var$ensureRootIsScheduled(boundaryFiber));
}
function $12584cae6930e094$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $12584cae6930e094$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $12584cae6930e094$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($12584cae6930e094$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $12584cae6930e094$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $12584cae6930e094$var$scheduleCallback$1(priorityLevel, callback) {
    return $12584cae6930e094$var$scheduleCallback$3(priorityLevel, callback);
}
var $12584cae6930e094$var$firstScheduledRoot = null, $12584cae6930e094$var$lastScheduledRoot = null, $12584cae6930e094$var$didScheduleMicrotask = !1, $12584cae6930e094$var$mightHavePendingSyncWork = !1, $12584cae6930e094$var$isFlushingWork = !1, $12584cae6930e094$var$currentEventTransitionLane = 0;
function $12584cae6930e094$var$ensureRootIsScheduled(root) {
    root !== $12584cae6930e094$var$lastScheduledRoot && null === root.next && (null === $12584cae6930e094$var$lastScheduledRoot ? $12584cae6930e094$var$firstScheduledRoot = $12584cae6930e094$var$lastScheduledRoot = root : $12584cae6930e094$var$lastScheduledRoot = $12584cae6930e094$var$lastScheduledRoot.next = root);
    $12584cae6930e094$var$mightHavePendingSyncWork = !0;
    $12584cae6930e094$var$didScheduleMicrotask || ($12584cae6930e094$var$didScheduleMicrotask = !0, $12584cae6930e094$var$scheduleImmediateRootScheduleTask());
}
function $12584cae6930e094$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$12584cae6930e094$var$isFlushingWork && $12584cae6930e094$var$mightHavePendingSyncWork) {
        $12584cae6930e094$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$190 = $12584cae6930e094$var$firstScheduledRoot; null !== root$190;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$190.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$190.suspendedLanes, pingedLanes = root$190.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $12584cae6930e094$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $12584cae6930e094$var$performSyncWorkOnRoot(root$190, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $12584cae6930e094$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $12584cae6930e094$var$getNextLanes(root$190, root$190 === $12584cae6930e094$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$190.cancelPendingCommit || -1 !== root$190.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $12584cae6930e094$var$checkIfRootIsPrerendering(root$190, JSCompiler_inline_result) || (didPerformSomeWork = !0, $12584cae6930e094$var$performSyncWorkOnRoot(root$190, JSCompiler_inline_result));
                }
                root$190 = root$190.next;
            }
        }while (didPerformSomeWork);
        $12584cae6930e094$var$isFlushingWork = !1;
    }
}
function $12584cae6930e094$var$processRootScheduleInImmediateTask() {
    $12584cae6930e094$var$processRootScheduleInMicrotask();
}
function $12584cae6930e094$var$processRootScheduleInMicrotask() {
    $12584cae6930e094$var$mightHavePendingSyncWork = $12584cae6930e094$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $12584cae6930e094$var$currentEventTransitionLane && $12584cae6930e094$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $12584cae6930e094$var$currentEventTransitionLane);
    for(var currentTime = $12584cae6930e094$var$now(), prev = null, root = $12584cae6930e094$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $12584cae6930e094$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $12584cae6930e094$var$firstScheduledRoot = next : prev.next = next, null === next && ($12584cae6930e094$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $12584cae6930e094$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $12584cae6930e094$var$pendingEffectsStatus && 5 !== $12584cae6930e094$var$pendingEffectsStatus || $12584cae6930e094$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $12584cae6930e094$var$currentEventTransitionLane && ($12584cae6930e094$var$currentEventTransitionLane = 0);
}
function $12584cae6930e094$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $12584cae6930e094$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $12584cae6930e094$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $12584cae6930e094$var$workInProgressRoot;
    suspendedLanes = $12584cae6930e094$var$workInProgressRootRenderLanes;
    suspendedLanes = $12584cae6930e094$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $12584cae6930e094$var$workInProgressSuspendedReason || 9 === $12584cae6930e094$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $12584cae6930e094$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $12584cae6930e094$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $12584cae6930e094$var$cancelCallback$1(pingedLanes);
        switch($12584cae6930e094$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $12584cae6930e094$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $12584cae6930e094$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $12584cae6930e094$var$IdlePriority;
                break;
            default:
                suspendedLanes = $12584cae6930e094$var$NormalPriority$1;
        }
        pingedLanes = $12584cae6930e094$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $12584cae6930e094$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $12584cae6930e094$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $12584cae6930e094$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $12584cae6930e094$var$pendingEffectsStatus && 5 !== $12584cae6930e094$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($12584cae6930e094$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $12584cae6930e094$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $12584cae6930e094$var$getNextLanes(root, root === $12584cae6930e094$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $12584cae6930e094$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $12584cae6930e094$var$scheduleTaskForRootDuringMicrotask(root, $12584cae6930e094$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $12584cae6930e094$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $12584cae6930e094$var$performSyncWorkOnRoot(root, lanes) {
    if ($12584cae6930e094$var$flushPendingEffects()) return null;
    $12584cae6930e094$var$performWorkOnRoot(root, lanes, !0);
}
function $12584cae6930e094$var$scheduleImmediateRootScheduleTask() {
    $12584cae6930e094$var$scheduleMicrotask(function() {
        0 !== ($12584cae6930e094$var$executionContext & 6) ? $12584cae6930e094$var$scheduleCallback$3($12584cae6930e094$var$ImmediatePriority, $12584cae6930e094$var$processRootScheduleInImmediateTask) : $12584cae6930e094$var$processRootScheduleInMicrotask();
    });
}
function $12584cae6930e094$var$requestTransitionLane() {
    if (0 === $12584cae6930e094$var$currentEventTransitionLane) {
        var actionScopeLane = $12584cae6930e094$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $12584cae6930e094$var$nextTransitionUpdateLane, $12584cae6930e094$var$nextTransitionUpdateLane <<= 1, 0 === ($12584cae6930e094$var$nextTransitionUpdateLane & 261888) && ($12584cae6930e094$var$nextTransitionUpdateLane = 256));
        $12584cae6930e094$var$currentEventTransitionLane = actionScopeLane;
    }
    return $12584cae6930e094$var$currentEventTransitionLane;
}
function $12584cae6930e094$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $12584cae6930e094$var$sanitizeURL(actionProp);
}
function $12584cae6930e094$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $12584cae6930e094$var$coerceFormActionProp((nativeEventTarget[$12584cae6930e094$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$12584cae6930e094$var$internalPropsKey] || null) ? $12584cae6930e094$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $12584cae6930e094$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $12584cae6930e094$var$currentEventTransitionLane) {
                                var formData = new FormData(nativeEventTarget, submitter);
                                $12584cae6930e094$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = new FormData(nativeEventTarget, submitter), $12584cae6930e094$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $12584cae6930e094$var$i$jscomp$inline_1667 = 0; $12584cae6930e094$var$i$jscomp$inline_1667 < $12584cae6930e094$var$simpleEventPluginEvents.length; $12584cae6930e094$var$i$jscomp$inline_1667++){
    var $12584cae6930e094$var$eventName$jscomp$inline_1668 = $12584cae6930e094$var$simpleEventPluginEvents[$12584cae6930e094$var$i$jscomp$inline_1667], $12584cae6930e094$var$domEventName$jscomp$inline_1669 = $12584cae6930e094$var$eventName$jscomp$inline_1668.toLowerCase(), $12584cae6930e094$var$capitalizedEvent$jscomp$inline_1670 = $12584cae6930e094$var$eventName$jscomp$inline_1668[0].toUpperCase() + $12584cae6930e094$var$eventName$jscomp$inline_1668.slice(1);
    $12584cae6930e094$var$registerSimpleEvent($12584cae6930e094$var$domEventName$jscomp$inline_1669, "on" + $12584cae6930e094$var$capitalizedEvent$jscomp$inline_1670);
}
$12584cae6930e094$var$registerSimpleEvent($12584cae6930e094$var$ANIMATION_END, "onAnimationEnd");
$12584cae6930e094$var$registerSimpleEvent($12584cae6930e094$var$ANIMATION_ITERATION, "onAnimationIteration");
$12584cae6930e094$var$registerSimpleEvent($12584cae6930e094$var$ANIMATION_START, "onAnimationStart");
$12584cae6930e094$var$registerSimpleEvent("dblclick", "onDoubleClick");
$12584cae6930e094$var$registerSimpleEvent("focusin", "onFocus");
$12584cae6930e094$var$registerSimpleEvent("focusout", "onBlur");
$12584cae6930e094$var$registerSimpleEvent($12584cae6930e094$var$TRANSITION_RUN, "onTransitionRun");
$12584cae6930e094$var$registerSimpleEvent($12584cae6930e094$var$TRANSITION_START, "onTransitionStart");
$12584cae6930e094$var$registerSimpleEvent($12584cae6930e094$var$TRANSITION_CANCEL, "onTransitionCancel");
$12584cae6930e094$var$registerSimpleEvent($12584cae6930e094$var$TRANSITION_END, "onTransitionEnd");
$12584cae6930e094$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$12584cae6930e094$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$12584cae6930e094$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$12584cae6930e094$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$12584cae6930e094$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$12584cae6930e094$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$12584cae6930e094$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$12584cae6930e094$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$12584cae6930e094$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$12584cae6930e094$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $12584cae6930e094$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $12584cae6930e094$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($12584cae6930e094$var$mediaEventTypes));
function $12584cae6930e094$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $12584cae6930e094$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $12584cae6930e094$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $12584cae6930e094$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$12584cae6930e094$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$12584cae6930e094$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($12584cae6930e094$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $12584cae6930e094$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $12584cae6930e094$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $12584cae6930e094$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $12584cae6930e094$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$12584cae6930e094$var$listeningMarker]) {
        rootContainerElement[$12584cae6930e094$var$listeningMarker] = !0;
        $12584cae6930e094$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($12584cae6930e094$var$nonDelegatedEvents.has(domEventName) || $12584cae6930e094$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $12584cae6930e094$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$12584cae6930e094$var$listeningMarker] || (ownerDocument[$12584cae6930e094$var$listeningMarker] = !0, $12584cae6930e094$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $12584cae6930e094$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($12584cae6930e094$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $12584cae6930e094$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $12584cae6930e094$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $12584cae6930e094$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$12584cae6930e094$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $12584cae6930e094$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $12584cae6930e094$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $12584cae6930e094$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $12584cae6930e094$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $12584cae6930e094$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $12584cae6930e094$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $12584cae6930e094$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $12584cae6930e094$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $12584cae6930e094$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $12584cae6930e094$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $12584cae6930e094$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $12584cae6930e094$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $12584cae6930e094$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $12584cae6930e094$var$SyntheticTouchEvent;
                        break;
                    case $12584cae6930e094$var$ANIMATION_END:
                    case $12584cae6930e094$var$ANIMATION_ITERATION:
                    case $12584cae6930e094$var$ANIMATION_START:
                        SyntheticEventCtor = $12584cae6930e094$var$SyntheticAnimationEvent;
                        break;
                    case $12584cae6930e094$var$TRANSITION_END:
                        SyntheticEventCtor = $12584cae6930e094$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $12584cae6930e094$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $12584cae6930e094$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $12584cae6930e094$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $12584cae6930e094$var$SyntheticPointerEvent;
                        break;
                    case "submit":
                        SyntheticEventCtor = $12584cae6930e094$var$SyntheticSubmitEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $12584cae6930e094$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $12584cae6930e094$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($12584cae6930e094$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                SyntheticEventCtor = "mouseover" === domEventName || "pointerover" === domEventName;
                reactName = "mouseout" === domEventName || "pointerout" === domEventName;
                if (SyntheticEventCtor && nativeEvent !== $12584cae6930e094$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($12584cae6930e094$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$12584cae6930e094$var$internalContainerInstanceKey])) break a;
                if (reactName || SyntheticEventCtor) {
                    reactEventType = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (SyntheticEventCtor = nativeEventTarget.ownerDocument) ? SyntheticEventCtor.defaultView || SyntheticEventCtor.parentWindow : window;
                    if (reactName) {
                        if (SyntheticEventCtor = nativeEvent.relatedTarget || nativeEvent.toElement, reactName = targetInst, SyntheticEventCtor = SyntheticEventCtor ? $12584cae6930e094$var$getClosestInstanceFromNode(SyntheticEventCtor) : null, null !== SyntheticEventCtor && (accumulateTargetOnly = $12584cae6930e094$var$getNearestMountedFiber(SyntheticEventCtor), inCapturePhase = SyntheticEventCtor.tag, SyntheticEventCtor !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) SyntheticEventCtor = null;
                    } else reactName = null, SyntheticEventCtor = targetInst;
                    if (reactName !== SyntheticEventCtor) {
                        inCapturePhase = $12584cae6930e094$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $12584cae6930e094$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == reactName ? reactEventType : $12584cae6930e094$var$getNodeFromInstance(reactName);
                        lastHostComponent = null == SyntheticEventCtor ? reactEventType : $12584cae6930e094$var$getNodeFromInstance(SyntheticEventCtor);
                        reactEventType = new inCapturePhase(_instance, instance + "leave", reactName, nativeEvent, nativeEventTarget);
                        reactEventType.target = accumulateTargetOnly;
                        reactEventType.relatedTarget = lastHostComponent;
                        _instance = null;
                        $12584cae6930e094$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", SyntheticEventCtor, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        inCapturePhase = reactName && SyntheticEventCtor ? $12584cae6930e094$var$getLowestCommonAncestor(reactName, SyntheticEventCtor, $12584cae6930e094$var$getParent) : null;
                        null !== reactName && $12584cae6930e094$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactEventType, reactName, inCapturePhase, !1);
                        null !== SyntheticEventCtor && null !== accumulateTargetOnly && $12584cae6930e094$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, SyntheticEventCtor, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $12584cae6930e094$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $12584cae6930e094$var$getTargetInstForChangeEvent;
                else if ($12584cae6930e094$var$isTextInputElement(reactName)) {
                    if ($12584cae6930e094$var$isInputEventSupported) getTargetInstFunc = $12584cae6930e094$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $12584cae6930e094$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $12584cae6930e094$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $12584cae6930e094$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $12584cae6930e094$var$getTargetInstForChangeEvent) : getTargetInstFunc = $12584cae6930e094$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $12584cae6930e094$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
            }
            handleEventFunc = targetInst ? $12584cae6930e094$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($12584cae6930e094$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $12584cae6930e094$var$activeElement = handleEventFunc, $12584cae6930e094$var$activeElementInst = targetInst, $12584cae6930e094$var$lastSelection = null;
                    break;
                case "focusout":
                    $12584cae6930e094$var$lastSelection = $12584cae6930e094$var$activeElementInst = $12584cae6930e094$var$activeElement = null;
                    break;
                case "mousedown":
                    $12584cae6930e094$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $12584cae6930e094$var$mouseDown = !1;
                    $12584cae6930e094$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($12584cae6930e094$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $12584cae6930e094$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($12584cae6930e094$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $12584cae6930e094$var$isComposing ? $12584cae6930e094$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($12584cae6930e094$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($12584cae6930e094$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $12584cae6930e094$var$isComposing && (fallbackData = $12584cae6930e094$var$getData()) : ($12584cae6930e094$var$root = nativeEventTarget, $12584cae6930e094$var$startText = "value" in $12584cae6930e094$var$root ? $12584cae6930e094$var$root.value : $12584cae6930e094$var$root.textContent, $12584cae6930e094$var$isComposing = !0)), handleEventFunc = $12584cae6930e094$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $12584cae6930e094$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $12584cae6930e094$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $12584cae6930e094$var$canUseTextInputEvent ? $12584cae6930e094$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $12584cae6930e094$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $12584cae6930e094$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $12584cae6930e094$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $12584cae6930e094$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $12584cae6930e094$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $12584cae6930e094$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $12584cae6930e094$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $12584cae6930e094$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($12584cae6930e094$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $12584cae6930e094$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($12584cae6930e094$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $12584cae6930e094$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $12584cae6930e094$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $12584cae6930e094$var$getListener(target, registrationName), null != stateNode && listeners.unshift($12584cae6930e094$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $12584cae6930e094$var$getListener(target, registrationName), null != stateNode && listeners.push($12584cae6930e094$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $12584cae6930e094$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $12584cae6930e094$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $12584cae6930e094$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($12584cae6930e094$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($12584cae6930e094$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $12584cae6930e094$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $12584cae6930e094$var$normalizeMarkupForTextOrAttribute(clientText);
    return $12584cae6930e094$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $12584cae6930e094$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            if ("string" === typeof value) "body" === tag || "textarea" === tag && "" === value || $12584cae6930e094$var$setTextContent(domElement, value);
            else if ("number" === typeof value || "bigint" === typeof value) "body" !== tag && $12584cae6930e094$var$setTextContent(domElement, "" + value);
            else return;
            break;
        case "className":
            $12584cae6930e094$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $12584cae6930e094$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $12584cae6930e094$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $12584cae6930e094$var$setValueForStyles(domElement, value, prevValue);
            return;
        case "data":
            if ("object" !== tag) {
                $12584cae6930e094$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $12584cae6930e094$var$sanitizeURL(value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $12584cae6930e094$var$setProp(domElement, tag, "name", props.name, props, null), $12584cae6930e094$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $12584cae6930e094$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $12584cae6930e094$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($12584cae6930e094$var$setProp(domElement, tag, "encType", props.encType, props, null), $12584cae6930e094$var$setProp(domElement, tag, "method", props.method, props, null), $12584cae6930e094$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $12584cae6930e094$var$sanitizeURL(value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $12584cae6930e094$var$noop$1);
            return;
        case "onScroll":
            null != value && $12584cae6930e094$var$listenToNonDelegatedEvent("scroll", domElement);
            return;
        case "onScrollEnd":
            null != value && $12584cae6930e094$var$listenToNonDelegatedEvent("scrollend", domElement);
            return;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($12584cae6930e094$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($12584cae6930e094$var$formatProdErrorMessage(60));
                    (null != prevValue ? prevValue.__html : void 0) !== key && (domElement.innerHTML = key);
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $12584cae6930e094$var$sanitizeURL(value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "credentialless":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $12584cae6930e094$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $12584cae6930e094$var$listenToNonDelegatedEvent("toggle", domElement);
            $12584cae6930e094$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $12584cae6930e094$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $12584cae6930e094$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $12584cae6930e094$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $12584cae6930e094$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $12584cae6930e094$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $12584cae6930e094$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $12584cae6930e094$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $12584cae6930e094$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $12584cae6930e094$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $12584cae6930e094$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            return;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $12584cae6930e094$var$aliases.get(key) || key, $12584cae6930e094$var$setValueForAttribute(domElement, key, value);
            else return;
    }
    $12584cae6930e094$var$viewTransitionMutationContext = !0;
}
function $12584cae6930e094$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $12584cae6930e094$var$setValueForStyles(domElement, value, prevValue);
            return;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($12584cae6930e094$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($12584cae6930e094$var$formatProdErrorMessage(60));
                    (null != prevValue ? prevValue.__html : void 0) !== key && (domElement.innerHTML = key);
                }
            }
            break;
        case "children":
            if ("string" === typeof value) $12584cae6930e094$var$setTextContent(domElement, value);
            else if ("number" === typeof value || "bigint" === typeof value) $12584cae6930e094$var$setTextContent(domElement, "" + value);
            else return;
            break;
        case "onScroll":
            null != value && $12584cae6930e094$var$listenToNonDelegatedEvent("scroll", domElement);
            return;
        case "onScrollEnd":
            null != value && $12584cae6930e094$var$listenToNonDelegatedEvent("scrollend", domElement);
            return;
        case "onClick":
            null != value && (domElement.onclick = $12584cae6930e094$var$noop$1);
            return;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            return;
        case "innerText":
        case "textContent":
            return;
        default:
            if (!$12584cae6930e094$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), prevValue = key.slice(2, props ? key.length - 7 : void 0), tag = domElement[$12584cae6930e094$var$internalPropsKey] || null, tag = null != tag ? tag[key] : null, "function" === typeof tag && domElement.removeEventListener(prevValue, tag, props), "function" === typeof value)) {
                    "function" !== typeof tag && null !== tag && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(prevValue, value, props);
                    break a;
                }
                $12584cae6930e094$var$viewTransitionMutationContext = !0;
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $12584cae6930e094$var$setValueForAttribute(domElement, key, value);
            }
            return;
    }
    $12584cae6930e094$var$viewTransitionMutationContext = !0;
}
function $12584cae6930e094$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $12584cae6930e094$var$listenToNonDelegatedEvent("error", domElement);
            $12584cae6930e094$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($12584cae6930e094$var$formatProdErrorMessage(137, tag));
                    default:
                        $12584cae6930e094$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $12584cae6930e094$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $12584cae6930e094$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $12584cae6930e094$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$204 = props[hasSrc];
                if (null != propValue$204) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$204;
                        break;
                    case "type":
                        propValue = propValue$204;
                        break;
                    case "checked":
                        checked = propValue$204;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$204;
                        break;
                    case "value":
                        propKey = propValue$204;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$204;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$204) throw Error($12584cae6930e094$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $12584cae6930e094$var$setProp(domElement, tag, hasSrc, propValue$204, props, null);
                }
            }
            $12584cae6930e094$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $12584cae6930e094$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $12584cae6930e094$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $12584cae6930e094$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $12584cae6930e094$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $12584cae6930e094$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($12584cae6930e094$var$formatProdErrorMessage(91));
                    break;
                default:
                    $12584cae6930e094$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $12584cae6930e094$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $12584cae6930e094$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $12584cae6930e094$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $12584cae6930e094$var$listenToNonDelegatedEvent("toggle", domElement);
            $12584cae6930e094$var$listenToNonDelegatedEvent("cancel", domElement);
            $12584cae6930e094$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $12584cae6930e094$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $12584cae6930e094$var$mediaEventTypes.length; hasSrc++)$12584cae6930e094$var$listenToNonDelegatedEvent($12584cae6930e094$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $12584cae6930e094$var$listenToNonDelegatedEvent("error", domElement);
            $12584cae6930e094$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $12584cae6930e094$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $12584cae6930e094$var$listenToNonDelegatedEvent("error", domElement), $12584cae6930e094$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($12584cae6930e094$var$formatProdErrorMessage(137, tag));
                default:
                    $12584cae6930e094$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($12584cae6930e094$var$isCustomElement(tag)) {
                for(propValue$204 in props)props.hasOwnProperty(propValue$204) && (hasSrc = props[propValue$204], void 0 !== hasSrc && $12584cae6930e094$var$setPropOnCustomElement(domElement, tag, propValue$204, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $12584cae6930e094$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
var $12584cae6930e094$var$emptyProps = {};
function $12584cae6930e094$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $12584cae6930e094$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$221 in nextProps){
                var propKey = nextProps[propKey$221];
                lastProp = lastProps[propKey$221];
                if (nextProps.hasOwnProperty(propKey$221) && (null != propKey || null != lastProp)) switch(propKey$221){
                    case "type":
                        propKey !== lastProp && ($12584cae6930e094$var$viewTransitionMutationContext = !0);
                        type = propKey;
                        break;
                    case "name":
                        propKey !== lastProp && ($12584cae6930e094$var$viewTransitionMutationContext = !0);
                        name = propKey;
                        break;
                    case "checked":
                        propKey !== lastProp && ($12584cae6930e094$var$viewTransitionMutationContext = !0);
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        propKey !== lastProp && ($12584cae6930e094$var$viewTransitionMutationContext = !0);
                        defaultChecked = propKey;
                        break;
                    case "value":
                        propKey !== lastProp && ($12584cae6930e094$var$viewTransitionMutationContext = !0);
                        value = propKey;
                        break;
                    case "defaultValue":
                        propKey !== lastProp && ($12584cae6930e094$var$viewTransitionMutationContext = !0);
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($12584cae6930e094$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $12584cae6930e094$var$setProp(domElement, tag, propKey$221, propKey, nextProps, lastProp);
                }
            }
            $12584cae6930e094$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$221 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $12584cae6930e094$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    type !== lastDefaultValue && ($12584cae6930e094$var$viewTransitionMutationContext = !0);
                    propKey$221 = type;
                    break;
                case "defaultValue":
                    type !== lastDefaultValue && ($12584cae6930e094$var$viewTransitionMutationContext = !0);
                    defaultValue = type;
                    break;
                case "multiple":
                    type !== lastDefaultValue && ($12584cae6930e094$var$viewTransitionMutationContext = !0), value = type;
                default:
                    type !== lastDefaultValue && $12584cae6930e094$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$221 ? $12584cae6930e094$var$updateOptions(domElement, !!lastProps, propKey$221, !1) : !!nextProps !== !!lastProps && (null != tag ? $12584cae6930e094$var$updateOptions(domElement, !!lastProps, tag, !0) : $12584cae6930e094$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$221 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $12584cae6930e094$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    name !== type && ($12584cae6930e094$var$viewTransitionMutationContext = !0);
                    propKey$221 = name;
                    break;
                case "defaultValue":
                    name !== type && ($12584cae6930e094$var$viewTransitionMutationContext = !0);
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($12584cae6930e094$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $12584cae6930e094$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $12584cae6930e094$var$updateTextarea(domElement, propKey$221, propKey);
            return;
        case "option":
            for(var propKey$237 in lastProps)if (propKey$221 = lastProps[propKey$237], lastProps.hasOwnProperty(propKey$237) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$237)) switch(propKey$237){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $12584cae6930e094$var$setProp(domElement, tag, propKey$237, null, nextProps, propKey$221);
            }
            for(lastDefaultValue in nextProps)if (propKey$221 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$221 !== propKey && (null != propKey$221 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    propKey$221 !== propKey && ($12584cae6930e094$var$viewTransitionMutationContext = !0);
                    domElement.selected = propKey$221 && "function" !== typeof propKey$221 && "symbol" !== typeof propKey$221;
                    break;
                default:
                    $12584cae6930e094$var$setProp(domElement, tag, lastDefaultValue, propKey$221, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$242 in lastProps)propKey$221 = lastProps[propKey$242], lastProps.hasOwnProperty(propKey$242) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$242) && $12584cae6930e094$var$setProp(domElement, tag, propKey$242, null, nextProps, propKey$221);
            for(checked in nextProps)if (propKey$221 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$221 !== propKey && (null != propKey$221 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$221) throw Error($12584cae6930e094$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $12584cae6930e094$var$setProp(domElement, tag, checked, propKey$221, nextProps, propKey);
            }
            return;
        default:
            if ($12584cae6930e094$var$isCustomElement(tag)) {
                for(var propKey$247 in lastProps)propKey$221 = lastProps[propKey$247], lastProps.hasOwnProperty(propKey$247) && void 0 !== propKey$221 && !nextProps.hasOwnProperty(propKey$247) && $12584cae6930e094$var$setPropOnCustomElement(domElement, tag, propKey$247, void 0, nextProps, propKey$221);
                for(defaultChecked in nextProps)propKey$221 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$221 === propKey || void 0 === propKey$221 && void 0 === propKey || $12584cae6930e094$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$221, nextProps, propKey);
                return;
            }
    }
    for(var propKey$252 in lastProps)propKey$221 = lastProps[propKey$252], lastProps.hasOwnProperty(propKey$252) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$252) && $12584cae6930e094$var$setProp(domElement, tag, propKey$252, null, nextProps, propKey$221);
    for(lastProp in nextProps)propKey$221 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$221 === propKey || null == propKey$221 && null == propKey || $12584cae6930e094$var$setProp(domElement, tag, lastProp, propKey$221, nextProps, propKey);
}
function $12584cae6930e094$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $12584cae6930e094$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $12584cae6930e094$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $12584cae6930e094$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $12584cae6930e094$var$eventsEnabled = null, $12584cae6930e094$var$selectionInformation = null;
function $12584cae6930e094$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $12584cae6930e094$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $12584cae6930e094$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $12584cae6930e094$var$createHoistableInstance(type, props, rootContainerInstance, internalInstanceHandle) {
    rootContainerInstance = $12584cae6930e094$var$getOwnerDocumentFromRootContainer(rootContainerInstance).createElement(type);
    rootContainerInstance[$12584cae6930e094$var$internalInstanceKey] = internalInstanceHandle;
    rootContainerInstance[$12584cae6930e094$var$internalPropsKey] = props;
    $12584cae6930e094$var$setInitialProperties(rootContainerInstance, type, props);
    $12584cae6930e094$var$markNodeAsHoistable(rootContainerInstance);
    return rootContainerInstance;
}
function $12584cae6930e094$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $12584cae6930e094$var$currentPopstateTransitionEvent = null;
function $12584cae6930e094$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $12584cae6930e094$var$currentPopstateTransitionEvent) return !1;
        $12584cae6930e094$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $12584cae6930e094$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $12584cae6930e094$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $12584cae6930e094$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $12584cae6930e094$var$localPromise = "function" === typeof Promise ? Promise : void 0, $12584cae6930e094$var$localRequestAnimationFrame = "function" === typeof requestAnimationFrame ? requestAnimationFrame : $12584cae6930e094$var$scheduleTimeout, $12584cae6930e094$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $12584cae6930e094$var$localPromise ? function(callback) {
    return $12584cae6930e094$var$localPromise.resolve(null).then(callback).catch($12584cae6930e094$var$handleErrorInNextTick);
} : $12584cae6930e094$var$scheduleTimeout;
function $12584cae6930e094$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $12584cae6930e094$var$isSingletonScope(type) {
    return "head" === type;
}
function $12584cae6930e094$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $12584cae6930e094$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $12584cae6930e094$var$clearSingletonPreambleContribution(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $12584cae6930e094$var$clearSingletonPreambleContribution(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$12584cae6930e094$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $12584cae6930e094$var$clearSingletonPreambleContribution(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $12584cae6930e094$var$retryIfBlockedOn(hydrationInstance);
}
function $12584cae6930e094$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $12584cae6930e094$var$applyViewTransitionName(instance, name, className) {
    name = CSS.escape(name) !== name ? "r-" + btoa(name).replace(/=/g, "") : name;
    instance.style.viewTransitionName = name;
    null != className && (instance.style.viewTransitionClass = className);
    className = getComputedStyle(instance);
    if ("inline" === className.display) {
        name = instance.getClientRects();
        if (1 === name.length) var JSCompiler_inline_result = 1;
        else for(var i = JSCompiler_inline_result = 0; i < name.length; i++){
            var rect = name[i];
            0 < rect.width && 0 < rect.height && JSCompiler_inline_result++;
        }
        1 === JSCompiler_inline_result && (instance = instance.style, instance.display = 1 === name.length ? "inline-block" : "block", instance.marginTop = "-" + className.paddingTop, instance.marginBottom = "-" + className.paddingBottom);
    }
}
function $12584cae6930e094$var$restoreViewTransitionName(instance, props) {
    instance = instance.style;
    props = props.style;
    var viewTransitionName = null != props ? props.hasOwnProperty("viewTransitionName") ? props.viewTransitionName : props.hasOwnProperty("view-transition-name") ? props["view-transition-name"] : null : null;
    instance.viewTransitionName = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : ("" + viewTransitionName).trim();
    viewTransitionName = null != props ? props.hasOwnProperty("viewTransitionClass") ? props.viewTransitionClass : props.hasOwnProperty("view-transition-class") ? props["view-transition-class"] : null : null;
    instance.viewTransitionClass = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : ("" + viewTransitionName).trim();
    "inline-block" === instance.display && (null == props ? instance.display = instance.margin = "" : (viewTransitionName = props.display, instance.display = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : viewTransitionName, viewTransitionName = props.margin, null != viewTransitionName ? instance.margin = viewTransitionName : (viewTransitionName = props.hasOwnProperty("marginTop") ? props.marginTop : props["margin-top"], instance.marginTop = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : viewTransitionName, props = props.hasOwnProperty("marginBottom") ? props.marginBottom : props["margin-bottom"], instance.marginBottom = null == props || "boolean" === typeof props ? "" : props)));
}
function $12584cae6930e094$var$createMeasurement(rect, computedStyle, element) {
    element = element.ownerDocument.defaultView;
    return {
        rect: rect,
        abs: "absolute" === computedStyle.position || "fixed" === computedStyle.position,
        clip: "none" !== computedStyle.clipPath || "visible" !== computedStyle.overflow || "none" !== computedStyle.filter || "none" !== computedStyle.mask || "none" !== computedStyle.mask || "0px" !== computedStyle.borderRadius,
        view: 0 <= rect.bottom && 0 <= rect.right && rect.top <= element.innerHeight && rect.left <= element.innerWidth
    };
}
function $12584cae6930e094$var$measureInstance(instance) {
    var rect = instance.getBoundingClientRect(), computedStyle = getComputedStyle(instance);
    return $12584cae6930e094$var$createMeasurement(rect, computedStyle, instance);
}
function $12584cae6930e094$var$measureClonedInstance(instance) {
    var measuredRect = instance.getBoundingClientRect();
    measuredRect = new DOMRect(measuredRect.x + 2e4, measuredRect.y + 2e4, measuredRect.width, measuredRect.height);
    var computedStyle = getComputedStyle(instance);
    return $12584cae6930e094$var$createMeasurement(measuredRect, computedStyle, instance);
}
function $12584cae6930e094$var$forceLayout(ownerDocument) {
    return ownerDocument.documentElement.clientHeight;
}
function $12584cae6930e094$var$waitForImageToLoad(resolve) {
    this.addEventListener("load", resolve);
    this.addEventListener("error", resolve);
}
function $12584cae6930e094$var$startViewTransition(suspendedState, rootContainer, transitionTypes, mutationCallback, layoutCallback, afterMutationCallback, spawnedWorkCallback, passiveCallback, errorCallback) {
    var ownerDocument = 9 === rootContainer.nodeType ? rootContainer : rootContainer.ownerDocument;
    try {
        var transition = ownerDocument.startViewTransition({
            update: function() {
                var ownerWindow = ownerDocument.defaultView, pendingNavigation = ownerWindow.navigation && ownerWindow.navigation.transition, previousFontLoadingStatus = ownerDocument.fonts.status;
                mutationCallback();
                var blockingPromises = [];
                "loaded" === previousFontLoadingStatus && ($12584cae6930e094$var$forceLayout(ownerDocument), "loading" === ownerDocument.fonts.status && blockingPromises.push(ownerDocument.fonts.ready));
                previousFontLoadingStatus = blockingPromises.length;
                if (null !== suspendedState) for(var suspenseyImages = suspendedState.suspenseyImages, imgBytes = 0, i = 0; i < suspenseyImages.length; i++){
                    var suspenseyImage = suspenseyImages[i];
                    if (!suspenseyImage.complete) {
                        var rect = suspenseyImage.getBoundingClientRect();
                        if (0 < rect.bottom && 0 < rect.right && rect.top < ownerWindow.innerHeight && rect.left < ownerWindow.innerWidth) {
                            imgBytes += $12584cae6930e094$var$estimateImageBytes(suspenseyImage);
                            if (imgBytes > $12584cae6930e094$var$estimatedBytesWithinLimit) {
                                blockingPromises.length = previousFontLoadingStatus;
                                break;
                            }
                            suspenseyImage = new Promise($12584cae6930e094$var$waitForImageToLoad.bind(suspenseyImage));
                            blockingPromises.push(suspenseyImage);
                        }
                    }
                }
                if (0 < blockingPromises.length) return ownerWindow = Promise.race([
                    Promise.all(blockingPromises),
                    new Promise(function(resolve) {
                        return setTimeout(resolve, 500);
                    })
                ]).then(layoutCallback, layoutCallback), (pendingNavigation ? Promise.allSettled([
                    pendingNavigation.finished,
                    ownerWindow
                ]) : ownerWindow).then(afterMutationCallback, afterMutationCallback);
                layoutCallback();
                if (pendingNavigation) return pendingNavigation.finished.then(afterMutationCallback, afterMutationCallback);
                afterMutationCallback();
            },
            types: transitionTypes
        });
        ownerDocument.__reactViewTransition = transition;
        var viewTransitionAnimations = [];
        transition.ready.then(function() {
            for(var animations = ownerDocument.documentElement.getAnimations({
                subtree: !0
            }), i = 0; i < animations.length; i++){
                var animation = animations[i], effect = animation.effect, pseudoElement = effect.pseudoElement;
                if (null != pseudoElement && pseudoElement.startsWith("::view-transition")) {
                    viewTransitionAnimations.push(animation);
                    animation = effect.getKeyframes();
                    for(var height = pseudoElement = void 0, unchangedDimensions = !0, j = 0; j < animation.length; j++){
                        var keyframe = animation[j], w = keyframe.width;
                        if (void 0 === pseudoElement) pseudoElement = w;
                        else if (pseudoElement !== w) {
                            unchangedDimensions = !1;
                            break;
                        }
                        w = keyframe.height;
                        if (void 0 === height) height = w;
                        else if (height !== w) {
                            unchangedDimensions = !1;
                            break;
                        }
                        delete keyframe.width;
                        delete keyframe.height;
                        "none" === keyframe.transform && delete keyframe.transform;
                    }
                    unchangedDimensions && void 0 !== pseudoElement && void 0 !== height && (effect.setKeyframes(animation), unchangedDimensions = getComputedStyle(effect.target, effect.pseudoElement), unchangedDimensions.width !== pseudoElement || unchangedDimensions.height !== height) && (unchangedDimensions = animation[0], unchangedDimensions.width = pseudoElement, unchangedDimensions.height = height, unchangedDimensions = animation[animation.length - 1], unchangedDimensions.width = pseudoElement, unchangedDimensions.height = height, effect.setKeyframes(animation));
                }
            }
            spawnedWorkCallback();
        }, function(error) {
            ownerDocument.__reactViewTransition === transition && (ownerDocument.__reactViewTransition = null);
            try {
                if ("object" === typeof error && null !== error) switch(error.name){
                    case "InvalidStateError":
                        if ("View transition was skipped because document visibility state is hidden." === error.message || "Skipping view transition because document visibility state has become hidden." === error.message || "Skipping view transition because viewport size changed." === error.message || "Transition was aborted because of invalid state" === error.message) error = null;
                }
                null !== error && errorCallback(error);
            } finally{
                mutationCallback(), layoutCallback(), spawnedWorkCallback();
            }
        });
        transition.finished.finally(function() {
            for(var i = 0; i < viewTransitionAnimations.length; i++)viewTransitionAnimations[i].cancel();
            ownerDocument.__reactViewTransition === transition && (ownerDocument.__reactViewTransition = null);
            passiveCallback();
        });
        return transition;
    } catch (x) {
        return mutationCallback(), layoutCallback(), spawnedWorkCallback(), null;
    }
}
function $12584cae6930e094$var$ViewTransitionPseudoElement(pseudo, name) {
    this._scope = document.documentElement;
    this._selector = "::view-transition-" + pseudo + "(" + name + ")";
}
$12584cae6930e094$var$ViewTransitionPseudoElement.prototype.animate = function(keyframes, options) {
    options = "number" === typeof options ? {
        duration: options
    } : $12584cae6930e094$var$assign({}, options);
    options.pseudoElement = this._selector;
    return this._scope.animate(keyframes, options);
};
$12584cae6930e094$var$ViewTransitionPseudoElement.prototype.getAnimations = function() {
    for(var scope = this._scope, selector = this._selector, animations = scope.getAnimations({
        subtree: !0
    }), result = [], i = 0; i < animations.length; i++){
        var effect = animations[i].effect;
        null !== effect && effect.target === scope && effect.pseudoElement === selector && result.push(animations[i]);
    }
    return result;
};
$12584cae6930e094$var$ViewTransitionPseudoElement.prototype.getComputedStyle = function() {
    return getComputedStyle(this._scope, this._selector);
};
function $12584cae6930e094$var$createViewTransitionInstance(name) {
    return {
        name: name,
        group: new $12584cae6930e094$var$ViewTransitionPseudoElement("group", name),
        imagePair: new $12584cae6930e094$var$ViewTransitionPseudoElement("image-pair", name),
        old: new $12584cae6930e094$var$ViewTransitionPseudoElement("old", name),
        new: new $12584cae6930e094$var$ViewTransitionPseudoElement("new", name)
    };
}
function $12584cae6930e094$var$FragmentInstance(fragmentFiber) {
    this._fragmentFiber = fragmentFiber;
    this._observers = this._eventListeners = null;
}
$12584cae6930e094$var$FragmentInstance.prototype.addEventListener = function(type, listener, optionsOrUseCapture) {
    var signal = null, cleanup = null;
    if (null != optionsOrUseCapture && "boolean" !== typeof optionsOrUseCapture && (signal = optionsOrUseCapture.signal || null, null !== signal && signal.aborted)) return;
    null === this._eventListeners && (this._eventListeners = []);
    var listeners = this._eventListeners;
    if (-1 === $12584cae6930e094$var$indexOfEventListener(listeners, type, listener, optionsOrUseCapture)) {
        var fragmentInstance = this, attachedListener = listener;
        null != optionsOrUseCapture && "boolean" !== typeof optionsOrUseCapture && !0 === optionsOrUseCapture.once && (attachedListener = function(event) {
            fragmentInstance.removeEventListener(type, listener, optionsOrUseCapture);
            "function" === typeof listener ? listener.call(this, event) : listener.handleEvent(event);
        });
        null !== signal && (cleanup = fragmentInstance.removeEventListener.bind(fragmentInstance, type, listener, optionsOrUseCapture), signal.addEventListener("abort", cleanup, {
            once: !0
        }), cleanup = signal.removeEventListener.bind(signal, "abort", cleanup));
        signal = $12584cae6930e094$var$getAttachOptions(optionsOrUseCapture);
        listeners.push({
            type: type,
            listener: listener,
            optionsOrUseCapture: optionsOrUseCapture,
            attachedListener: attachedListener,
            cleanup: cleanup
        });
        $12584cae6930e094$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $12584cae6930e094$var$addEventListenerToChild, type, attachedListener, signal);
    }
    this._eventListeners = listeners;
};
function $12584cae6930e094$var$addEventListenerToChild(child, type, listener, optionsOrUseCapture) {
    $12584cae6930e094$var$getInstanceFromHostFiber(child).addEventListener(type, listener, optionsOrUseCapture);
    return !1;
}
$12584cae6930e094$var$FragmentInstance.prototype.removeEventListener = function(type, listener, optionsOrUseCapture) {
    var listeners = this._eventListeners;
    if (null !== listeners && (listener = $12584cae6930e094$var$indexOfEventListener(listeners, type, listener, optionsOrUseCapture), -1 !== listener)) {
        var _listeners$index = listeners[listener];
        optionsOrUseCapture = _listeners$index.attachedListener;
        var cleanup = _listeners$index.cleanup;
        _listeners$index = $12584cae6930e094$var$getAttachOptions(_listeners$index.optionsOrUseCapture);
        $12584cae6930e094$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $12584cae6930e094$var$removeEventListenerFromChild, type, optionsOrUseCapture, _listeners$index);
        listeners.splice(listener, 1);
        null !== cleanup && cleanup();
    }
};
function $12584cae6930e094$var$removeEventListenerFromChild(child, type, listener, optionsOrUseCapture) {
    $12584cae6930e094$var$getInstanceFromHostFiber(child).removeEventListener(type, listener, optionsOrUseCapture);
    return !1;
}
function $12584cae6930e094$var$getAttachOptions(opts) {
    return null != opts && "boolean" !== typeof opts && (!0 === opts.once || opts.signal instanceof AbortSignal) ? {
        capture: opts.capture,
        passive: opts.passive
    } : opts;
}
function $12584cae6930e094$var$normalizeListenerOptions(opts) {
    return null == opts ? "c=0" : "boolean" === typeof opts ? "c=" + (opts ? "1" : "0") : "c=" + (opts.capture ? "1" : "0");
}
function $12584cae6930e094$var$indexOfEventListener(eventListeners, type, listener, optionsOrUseCapture) {
    if (0 === eventListeners.length) return -1;
    optionsOrUseCapture = $12584cae6930e094$var$normalizeListenerOptions(optionsOrUseCapture);
    for(var i = 0; i < eventListeners.length; i++){
        var item = eventListeners[i];
        if (item.type === type && item.listener === listener && $12584cae6930e094$var$normalizeListenerOptions(item.optionsOrUseCapture) === optionsOrUseCapture) return i;
    }
    return -1;
}
$12584cae6930e094$var$FragmentInstance.prototype.dispatchEvent = function(event) {
    var parentHostFiber = $12584cae6930e094$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    if (null === parentHostFiber) return !0;
    parentHostFiber = $12584cae6930e094$var$getInstanceFromHostFiber(parentHostFiber);
    var eventListeners = this._eventListeners;
    if (null !== eventListeners && 0 < eventListeners.length || !event.bubbles) {
        var temp = 9 === parentHostFiber.nodeType ? parentHostFiber.createComment("") : document.createTextNode("");
        if (eventListeners) for(var i = 0; i < eventListeners.length; i++){
            var _eventListeners$i = eventListeners[i];
            temp.addEventListener(_eventListeners$i.type, _eventListeners$i.attachedListener, $12584cae6930e094$var$getAttachOptions(_eventListeners$i.optionsOrUseCapture));
        }
        parentHostFiber.appendChild(temp);
        event = temp.dispatchEvent(event);
        if (eventListeners) for(i = 0; i < eventListeners.length; i++)_eventListeners$i = eventListeners[i], temp.removeEventListener(_eventListeners$i.type, _eventListeners$i.attachedListener, $12584cae6930e094$var$getAttachOptions(_eventListeners$i.optionsOrUseCapture));
        parentHostFiber.removeChild(temp);
        return event;
    }
    return parentHostFiber.dispatchEvent(event);
};
$12584cae6930e094$var$FragmentInstance.prototype.focus = function(focusOptions) {
    $12584cae6930e094$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !0, $12584cae6930e094$var$setFocusOnFiberIfFocusable, focusOptions, void 0, void 0);
};
function $12584cae6930e094$var$setFocusOnFiberIfFocusable(fiber, focusOptions) {
    if (6 === fiber.tag) return !1;
    fiber = $12584cae6930e094$var$getInstanceFromHostFiber(fiber);
    return $12584cae6930e094$var$setFocusIfFocusable(fiber, focusOptions);
}
$12584cae6930e094$var$FragmentInstance.prototype.focusLast = function(focusOptions) {
    var children = [];
    $12584cae6930e094$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !0, $12584cae6930e094$var$collectChildren, children, void 0, void 0);
    for(var i = children.length - 1; 0 <= i && !$12584cae6930e094$var$setFocusOnFiberIfFocusable(children[i], focusOptions); i--);
};
function $12584cae6930e094$var$collectChildren(child, collection) {
    collection.push(child);
    return !1;
}
$12584cae6930e094$var$FragmentInstance.prototype.blur = function() {
    var parentHostFiber = $12584cae6930e094$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    null !== parentHostFiber && (parentHostFiber = $12584cae6930e094$var$getInstanceFromHostFiber(parentHostFiber), parentHostFiber = $12584cae6930e094$var$getOwnerDocumentFromRootContainer(parentHostFiber).activeElement, null !== parentHostFiber && $12584cae6930e094$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $12584cae6930e094$var$blurActiveElementWithinFragment, parentHostFiber, void 0, void 0));
};
function $12584cae6930e094$var$blurActiveElementWithinFragment(child, activeElement) {
    if (6 === child.tag) return !1;
    child = $12584cae6930e094$var$getInstanceFromHostFiber(child);
    return child === activeElement || child.contains(activeElement) ? (activeElement.blur(), !0) : !1;
}
$12584cae6930e094$var$FragmentInstance.prototype.observeUsing = function(observer) {
    null === this._observers && (this._observers = new Set());
    this._observers.add(observer);
    $12584cae6930e094$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $12584cae6930e094$var$observeChild, observer, void 0, void 0);
};
function $12584cae6930e094$var$observeChild(child, observer) {
    if (6 === child.tag) return !1;
    child = $12584cae6930e094$var$getInstanceFromHostFiber(child);
    observer.observe(child);
    return !1;
}
$12584cae6930e094$var$FragmentInstance.prototype.unobserveUsing = function(observer) {
    var observers = this._observers;
    if (null !== observers && observers.has(observer)) {
        observers.delete(observer);
        $12584cae6930e094$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $12584cae6930e094$var$unobserveChild, observer, void 0, void 0);
        for(var i = observers = 0; i < $12584cae6930e094$var$pendingIntersectionUnobserves.length; i++){
            var pending = $12584cae6930e094$var$pendingIntersectionUnobserves[i];
            pending.fragmentInstance === this && pending.observer === observer ? observer.unobserve(pending.instance) : $12584cae6930e094$var$pendingIntersectionUnobserves[observers++] = pending;
        }
        $12584cae6930e094$var$pendingIntersectionUnobserves.length = observers;
    }
};
function $12584cae6930e094$var$unobserveChild(child, observer) {
    if (6 === child.tag) return !1;
    child = $12584cae6930e094$var$getInstanceFromHostFiber(child);
    observer.unobserve(child);
    return !1;
}
var $12584cae6930e094$var$pendingIntersectionUnobserves = [], $12584cae6930e094$var$intersectionUnobserveScheduled = !1;
function $12584cae6930e094$var$schedulePendingIntersectionUnobserve(fragmentInstance, observer, instance) {
    $12584cae6930e094$var$pendingIntersectionUnobserves.push({
        fragmentInstance: fragmentInstance,
        observer: observer,
        instance: instance
    });
    $12584cae6930e094$var$intersectionUnobserveScheduled || ($12584cae6930e094$var$intersectionUnobserveScheduled = !0, $12584cae6930e094$var$requestPostPaintCallback(function() {
        $12584cae6930e094$var$intersectionUnobserveScheduled = !1;
        var pending = $12584cae6930e094$var$pendingIntersectionUnobserves;
        $12584cae6930e094$var$pendingIntersectionUnobserves = [];
        for(var i = 0; i < pending.length; i++){
            var item = pending[i];
            item.observer.unobserve(item.instance);
        }
    }));
}
$12584cae6930e094$var$FragmentInstance.prototype.getClientRects = function() {
    var rects = [];
    $12584cae6930e094$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $12584cae6930e094$var$collectClientRects, rects, void 0, void 0);
    return rects;
};
function $12584cae6930e094$var$collectClientRects(child, rects) {
    if (6 === child.tag) {
        child = child.stateNode;
        var range = child.ownerDocument.createRange();
        range.selectNodeContents(child);
        rects.push.apply(rects, range.getClientRects());
    } else child = $12584cae6930e094$var$getInstanceFromHostFiber(child), rects.push.apply(rects, child.getClientRects());
    return !1;
}
$12584cae6930e094$var$FragmentInstance.prototype.getRootNode = function(getRootNodeOptions) {
    var parentHostFiber = $12584cae6930e094$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    return null === parentHostFiber ? this : $12584cae6930e094$var$getInstanceFromHostFiber(parentHostFiber).getRootNode(getRootNodeOptions);
};
$12584cae6930e094$var$FragmentInstance.prototype.compareDocumentPosition = function(otherNode) {
    var parentHostFiber = $12584cae6930e094$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    if (null === parentHostFiber) return Node.DOCUMENT_POSITION_DISCONNECTED;
    var children = [];
    $12584cae6930e094$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $12584cae6930e094$var$collectChildren, children, void 0, void 0);
    var parentHostInstance = $12584cae6930e094$var$getInstanceFromHostFiber(parentHostFiber);
    if (0 === children.length) {
        children = parentHostInstance;
        if ($12584cae6930e094$var$fiberIsPortaledIntoHost(this._fragmentFiber)) {
            a: {
                for(parentHostFiber = this._fragmentFiber.return; null !== parentHostFiber;){
                    if (4 === parentHostFiber.tag) {
                        parentHostFiber = parentHostFiber.stateNode.containerInfo;
                        break a;
                    }
                    if (3 === parentHostFiber.tag || 5 === parentHostFiber.tag || 27 === parentHostFiber.tag) break;
                    parentHostFiber = parentHostFiber.return;
                }
                parentHostFiber = null;
            }
            null != parentHostFiber && (children = parentHostFiber);
        }
        parentHostFiber = this._fragmentFiber;
        var result = parentHostInstance = children.compareDocumentPosition(otherNode);
        children === otherNode ? result = Node.DOCUMENT_POSITION_CONTAINS : parentHostInstance & Node.DOCUMENT_POSITION_CONTAINED_BY && (children = $12584cae6930e094$var$getFragmentInstanceOrTextInstanceSiblings(parentHostFiber)[1], null === children ? result = Node.DOCUMENT_POSITION_PRECEDING : (otherNode = $12584cae6930e094$var$getInstanceFromHostFiber(children).compareDocumentPosition(otherNode), result = 0 === otherNode || otherNode & Node.DOCUMENT_POSITION_FOLLOWING ? Node.DOCUMENT_POSITION_FOLLOWING : Node.DOCUMENT_POSITION_PRECEDING));
        return result |= Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC;
    }
    parentHostFiber = $12584cae6930e094$var$getInstanceFromHostFiber(children[0]);
    result = $12584cae6930e094$var$getInstanceFromHostFiber(children[children.length - 1]);
    var parentHostInstanceFromDOM = $12584cae6930e094$var$fiberIsPortaledIntoHost(this._fragmentFiber) ? parentHostFiber.parentElement : parentHostInstance;
    if (null == parentHostInstanceFromDOM) return Node.DOCUMENT_POSITION_DISCONNECTED;
    parentHostInstance = parentHostInstanceFromDOM.compareDocumentPosition(parentHostFiber) & Node.DOCUMENT_POSITION_CONTAINED_BY;
    parentHostInstanceFromDOM = parentHostInstanceFromDOM.compareDocumentPosition(result) & Node.DOCUMENT_POSITION_CONTAINED_BY;
    var firstResult = parentHostFiber.compareDocumentPosition(otherNode), lastResult = result.compareDocumentPosition(otherNode), otherNodeIsWithinFirstOrLastChild = firstResult & Node.DOCUMENT_POSITION_CONTAINED_BY || lastResult & Node.DOCUMENT_POSITION_CONTAINED_BY;
    lastResult = parentHostInstance && parentHostInstanceFromDOM && firstResult & Node.DOCUMENT_POSITION_FOLLOWING && lastResult & Node.DOCUMENT_POSITION_PRECEDING;
    parentHostFiber = parentHostInstance && parentHostFiber === otherNode || parentHostInstanceFromDOM && result === otherNode || otherNodeIsWithinFirstOrLastChild || lastResult ? Node.DOCUMENT_POSITION_CONTAINED_BY : !parentHostInstance && parentHostFiber === otherNode || !parentHostInstanceFromDOM && result === otherNode ? Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC : firstResult;
    return parentHostFiber & Node.DOCUMENT_POSITION_DISCONNECTED || parentHostFiber & Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC || $12584cae6930e094$var$validateDocumentPositionWithFiberTree(parentHostFiber, this._fragmentFiber, children[0], children[children.length - 1], otherNode) ? parentHostFiber : Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC;
};
function $12584cae6930e094$var$validateDocumentPositionWithFiberTree(documentPosition, fragmentFiber, precedingBoundaryFiber, followingBoundaryFiber, otherNode) {
    var otherFiber = $12584cae6930e094$var$getClosestInstanceFromNode(otherNode);
    if (documentPosition & Node.DOCUMENT_POSITION_CONTAINED_BY) {
        if (precedingBoundaryFiber = !!otherFiber) a: {
            for(; null !== otherFiber;){
                if (7 === otherFiber.tag && (otherFiber === fragmentFiber || otherFiber.alternate === fragmentFiber)) {
                    precedingBoundaryFiber = !0;
                    break a;
                }
                otherFiber = otherFiber.return;
            }
            precedingBoundaryFiber = !1;
        }
        return precedingBoundaryFiber;
    }
    if (documentPosition & Node.DOCUMENT_POSITION_CONTAINS) {
        if (null === otherFiber) return otherFiber = otherNode.ownerDocument, otherNode === otherFiber || otherNode === otherFiber.documentElement || otherNode === otherFiber.body;
        a: {
            otherFiber = fragmentFiber;
            for(fragmentFiber = $12584cae6930e094$var$getFragmentParentInstanceOrContainerFiber(fragmentFiber); null !== otherFiber;){
                if (!(5 !== otherFiber.tag && 3 !== otherFiber.tag && 27 !== otherFiber.tag || otherFiber !== fragmentFiber && otherFiber.alternate !== fragmentFiber)) {
                    otherFiber = !0;
                    break a;
                }
                otherFiber = otherFiber.return;
            }
            otherFiber = !1;
        }
        return otherFiber;
    }
    return documentPosition & Node.DOCUMENT_POSITION_PRECEDING ? ((fragmentFiber = !!otherFiber) && !(fragmentFiber = otherFiber === precedingBoundaryFiber) && (fragmentFiber = $12584cae6930e094$var$getLowestCommonAncestor(precedingBoundaryFiber, otherFiber, $12584cae6930e094$var$getParentForFragmentAncestors), null === fragmentFiber ? fragmentFiber = !1 : ($12584cae6930e094$var$traverseVisibleInstancesAndTextInstances(fragmentFiber, !0, $12584cae6930e094$var$isFiberPrecedingCheck, otherFiber, precedingBoundaryFiber), otherFiber = $12584cae6930e094$var$searchTarget, $12584cae6930e094$var$searchTarget = null, fragmentFiber = null !== otherFiber)), fragmentFiber) : documentPosition & Node.DOCUMENT_POSITION_FOLLOWING ? ((fragmentFiber = !!otherFiber) && !(fragmentFiber = otherFiber === followingBoundaryFiber) && (fragmentFiber = $12584cae6930e094$var$getLowestCommonAncestor(followingBoundaryFiber, otherFiber, $12584cae6930e094$var$getParentForFragmentAncestors), null === fragmentFiber ? fragmentFiber = !1 : ($12584cae6930e094$var$traverseVisibleInstancesAndTextInstances(fragmentFiber, !0, $12584cae6930e094$var$isFiberFollowingCheck, otherFiber, followingBoundaryFiber), otherFiber = $12584cae6930e094$var$searchTarget, $12584cae6930e094$var$searchBoundary = $12584cae6930e094$var$searchTarget = null, fragmentFiber = null !== otherFiber)), fragmentFiber) : !1;
}
function $12584cae6930e094$var$scrollTextNodeIntoView(textNode, resolvedAlignToTop) {
    var range = textNode.ownerDocument.createRange();
    range.selectNodeContents(textNode);
    textNode = range.getBoundingClientRect();
    window.scrollTo(window.scrollX + textNode.left, resolvedAlignToTop ? window.scrollY + textNode.top : window.scrollY + textNode.bottom - window.innerHeight);
}
$12584cae6930e094$var$FragmentInstance.prototype.scrollIntoView = function(alignToTop) {
    if ("object" === typeof alignToTop) throw Error($12584cae6930e094$var$formatProdErrorMessage(566));
    var children = [];
    $12584cae6930e094$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $12584cae6930e094$var$collectChildren, children, void 0, void 0);
    var resolvedAlignToTop = !1 !== alignToTop;
    if (0 === children.length) {
        var hostSiblings = $12584cae6930e094$var$getFragmentInstanceOrTextInstanceSiblings(this._fragmentFiber);
        hostSiblings = resolvedAlignToTop ? hostSiblings[1] || hostSiblings[0] || $12584cae6930e094$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber) : hostSiblings[0] || hostSiblings[1];
        if (null === hostSiblings) return;
        if (6 === hostSiblings.tag) {
            alignToTop = $12584cae6930e094$var$getInstanceFromHostFiber(hostSiblings);
            $12584cae6930e094$var$scrollTextNodeIntoView(alignToTop, resolvedAlignToTop);
            return;
        }
        hostSiblings = $12584cae6930e094$var$getInstanceFromHostFiber(hostSiblings);
        if (9 !== hostSiblings.nodeType) {
            if (11 === hostSiblings.nodeType) {
                resolvedAlignToTop = "host" in hostSiblings ? hostSiblings.host : null;
                null !== resolvedAlignToTop && resolvedAlignToTop.scrollIntoView(alignToTop);
                return;
            }
            hostSiblings.scrollIntoView(alignToTop);
        }
    }
    for(hostSiblings = resolvedAlignToTop ? children.length - 1 : 0; hostSiblings !== (resolvedAlignToTop ? -1 : children.length);){
        var child = children[hostSiblings];
        6 === child.tag ? (child = $12584cae6930e094$var$getInstanceFromHostFiber(child), $12584cae6930e094$var$scrollTextNodeIntoView(child, resolvedAlignToTop)) : $12584cae6930e094$var$getInstanceFromHostFiber(child).scrollIntoView(alignToTop);
        hostSiblings += resolvedAlignToTop ? -1 : 1;
    }
};
function $12584cae6930e094$var$addFragmentHandleToFiber(child, fragmentInstance) {
    child = $12584cae6930e094$var$getInstanceFromHostFiber(child);
    $12584cae6930e094$var$addFragmentHandleToInstance(child, fragmentInstance);
    return !1;
}
function $12584cae6930e094$var$addFragmentHandleToInstance(instance, fragmentInstance) {
    null == instance.reactFragments && (instance.reactFragments = new Set());
    instance.reactFragments.add(fragmentInstance);
}
function $12584cae6930e094$var$commitNewChildToFragmentInstance(childInstance, fragmentInstance) {
    var eventListeners = fragmentInstance._eventListeners;
    if (null !== eventListeners) for(var i$jscomp$0 = 0; i$jscomp$0 < eventListeners.length; i$jscomp$0++){
        var _eventListeners$i3 = eventListeners[i$jscomp$0];
        childInstance.addEventListener(_eventListeners$i3.type, _eventListeners$i3.attachedListener, $12584cae6930e094$var$getAttachOptions(_eventListeners$i3.optionsOrUseCapture));
    }
    3 !== childInstance.nodeType && (eventListeners = fragmentInstance._observers, null !== eventListeners && eventListeners.forEach(function(observer) {
        for(var writeIdx = 0, i = 0; i < $12584cae6930e094$var$pendingIntersectionUnobserves.length; i++){
            var pending = $12584cae6930e094$var$pendingIntersectionUnobserves[i];
            if (pending.fragmentInstance !== fragmentInstance || pending.observer !== observer || pending.instance !== childInstance) $12584cae6930e094$var$pendingIntersectionUnobserves[writeIdx++] = pending;
        }
        $12584cae6930e094$var$pendingIntersectionUnobserves.length = writeIdx;
        observer.observe(childInstance);
    }), $12584cae6930e094$var$addFragmentHandleToInstance(childInstance, fragmentInstance));
}
function $12584cae6930e094$var$deleteChildFromFragmentInstance(childInstance, fragmentInstance) {
    var eventListeners = fragmentInstance._eventListeners;
    if (null !== eventListeners) for(var i = 0; i < eventListeners.length; i++){
        var _eventListeners$i4 = eventListeners[i];
        childInstance.removeEventListener(_eventListeners$i4.type, _eventListeners$i4.attachedListener, $12584cae6930e094$var$getAttachOptions(_eventListeners$i4.optionsOrUseCapture));
    }
    3 !== childInstance.nodeType && (eventListeners = fragmentInstance._observers, null !== eventListeners && eventListeners.forEach(function(observer) {
        "string" === typeof observer.rootMargin ? $12584cae6930e094$var$schedulePendingIntersectionUnobserve(fragmentInstance, observer, childInstance) : observer.unobserve(childInstance);
    }), null != childInstance.reactFragments && childInstance.reactFragments.delete(fragmentInstance));
}
function $12584cae6930e094$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $12584cae6930e094$var$clearContainerSparingly(node);
                $12584cae6930e094$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $12584cae6930e094$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$12584cae6930e094$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $12584cae6930e094$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $12584cae6930e094$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $12584cae6930e094$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $12584cae6930e094$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $12584cae6930e094$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $12584cae6930e094$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $12584cae6930e094$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $12584cae6930e094$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $12584cae6930e094$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $12584cae6930e094$var$previousHydratableOnEnteringScopedSingleton = null;
function $12584cae6930e094$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $12584cae6930e094$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $12584cae6930e094$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $12584cae6930e094$var$setFocusIfFocusable(node, focusOptions) {
    function handleFocus() {
        didFocus = !0;
    }
    if (node.ownerDocument.activeElement === node) return !0;
    var didFocus = !1;
    try {
        node.ownerDocument.addEventListener("focus", handleFocus, !0), (node.focus || HTMLElement.prototype.focus).call(node, focusOptions);
    } finally{
        node.ownerDocument.removeEventListener("focus", handleFocus, !0);
    }
    return didFocus;
}
function $12584cae6930e094$var$requestPostPaintCallback(callback) {
    $12584cae6930e094$var$localRequestAnimationFrame(function() {
        $12584cae6930e094$var$localRequestAnimationFrame(function(time) {
            return callback(time);
        });
    });
}
function $12584cae6930e094$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $12584cae6930e094$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($12584cae6930e094$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($12584cae6930e094$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($12584cae6930e094$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($12584cae6930e094$var$formatProdErrorMessage(451));
    }
}
function $12584cae6930e094$var$releaseSingletonInstance(instance, type, props) {
    for(var propKey in props){
        var propValue = props[propKey];
        props.hasOwnProperty(propKey) && null != propValue && $12584cae6930e094$var$setProp(instance, type, propKey, null, $12584cae6930e094$var$emptyProps, propValue);
    }
    null != props.dangerouslySetInnerHTML && (instance.textContent = "");
    instance.onclick === $12584cae6930e094$var$noop$1 && (instance.onclick = null);
    $12584cae6930e094$var$detachDeletedInstance(instance);
}
function $12584cae6930e094$var$clearSingletonPreambleContribution(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $12584cae6930e094$var$detachDeletedInstance(instance);
}
var $12584cae6930e094$var$preloadPropsMap = new Map(), $12584cae6930e094$var$preconnectsSet = new Set();
function $12584cae6930e094$var$getHoistableRoot(container) {
    if ("function" === typeof container.getRootNode) {
        var rootNode = container.getRootNode();
        if (9 === rootNode.nodeType || 11 === rootNode.nodeType) return rootNode;
    }
    return 9 === container.nodeType ? container : container.ownerDocument;
}
var $12584cae6930e094$var$previousDispatcher = $12584cae6930e094$var$ReactDOMSharedInternals.d;
$12584cae6930e094$var$ReactDOMSharedInternals.d = {
    f: $12584cae6930e094$var$flushSyncWork,
    r: $12584cae6930e094$var$requestFormReset,
    D: $12584cae6930e094$var$prefetchDNS,
    C: $12584cae6930e094$var$preconnect,
    L: $12584cae6930e094$var$preload,
    m: $12584cae6930e094$var$preloadModule,
    X: $12584cae6930e094$var$preinitScript,
    S: $12584cae6930e094$var$preinitStyle,
    M: $12584cae6930e094$var$preinitModuleScript
};
function $12584cae6930e094$var$flushSyncWork() {
    var previousWasRendering = $12584cae6930e094$var$previousDispatcher.f(), wasRendering = $12584cae6930e094$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $12584cae6930e094$var$requestFormReset(form) {
    var formInst = $12584cae6930e094$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $12584cae6930e094$var$requestFormReset$1(formInst) : $12584cae6930e094$var$previousDispatcher.r(form);
}
var $12584cae6930e094$var$globalDocument = "undefined" === typeof document ? null : document;
function $12584cae6930e094$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $12584cae6930e094$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $12584cae6930e094$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $12584cae6930e094$var$preconnectsSet.has(limitedEscapedHref) || ($12584cae6930e094$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $12584cae6930e094$var$setInitialProperties(href, "link", rel), $12584cae6930e094$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $12584cae6930e094$var$prefetchDNS(href) {
    $12584cae6930e094$var$previousDispatcher.D(href);
    $12584cae6930e094$var$preconnectAs("dns-prefetch", href, null);
}
function $12584cae6930e094$var$preconnect(href, crossOrigin) {
    $12584cae6930e094$var$previousDispatcher.C(href, crossOrigin);
    $12584cae6930e094$var$preconnectAs("preconnect", href, crossOrigin);
}
function $12584cae6930e094$var$preload(href, as, options) {
    $12584cae6930e094$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $12584cae6930e094$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $12584cae6930e094$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $12584cae6930e094$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $12584cae6930e094$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $12584cae6930e094$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $12584cae6930e094$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $12584cae6930e094$var$getStyleKey(href);
                break;
            case "script":
                key = $12584cae6930e094$var$getScriptKey(href);
        }
        if (!($12584cae6930e094$var$preloadPropsMap.has(key) || (href = $12584cae6930e094$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $12584cae6930e094$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($12584cae6930e094$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($12584cae6930e094$var$getScriptSelectorFromKey(key))))) {
            var instance = ownerDocument.createElement("link");
            $12584cae6930e094$var$setInitialProperties(instance, "link", href);
            "style" === as && (instance[$12584cae6930e094$var$internalLoadPendingKey] = !0, instance.onload = instance.onerror = function() {
                $12584cae6930e094$var$clearPendingLoadOnNode(instance);
            });
            $12584cae6930e094$var$markNodeAsHoistable(instance);
            ownerDocument.head.appendChild(instance);
        }
    }
}
function $12584cae6930e094$var$preloadModule(href, options) {
    $12584cae6930e094$var$previousDispatcher.m(href, options);
    var ownerDocument = $12584cae6930e094$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $12584cae6930e094$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $12584cae6930e094$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $12584cae6930e094$var$getScriptKey(href);
        }
        if (!$12584cae6930e094$var$preloadPropsMap.has(key) && (href = $12584cae6930e094$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $12584cae6930e094$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($12584cae6930e094$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $12584cae6930e094$var$setInitialProperties(as, "link", href);
            $12584cae6930e094$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $12584cae6930e094$var$preinitStyle(href, precedence, options) {
    $12584cae6930e094$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $12584cae6930e094$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $12584cae6930e094$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $12584cae6930e094$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($12584cae6930e094$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $12584cae6930e094$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $12584cae6930e094$var$preloadPropsMap.get(key)) && $12584cae6930e094$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $12584cae6930e094$var$markNodeAsHoistable(link);
                $12584cae6930e094$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $12584cae6930e094$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $12584cae6930e094$var$preinitScript(src, options) {
    $12584cae6930e094$var$previousDispatcher.X(src, options);
    var ownerDocument = $12584cae6930e094$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $12584cae6930e094$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $12584cae6930e094$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($12584cae6930e094$var$getScriptSelectorFromKey(key)), resource || (src = $12584cae6930e094$var$assign({
            src: src,
            async: !0
        }, options), (options = $12584cae6930e094$var$preloadPropsMap.get(key)) && $12584cae6930e094$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $12584cae6930e094$var$markNodeAsHoistable(resource), $12584cae6930e094$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $12584cae6930e094$var$preinitModuleScript(src, options) {
    $12584cae6930e094$var$previousDispatcher.M(src, options);
    var ownerDocument = $12584cae6930e094$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $12584cae6930e094$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $12584cae6930e094$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($12584cae6930e094$var$getScriptSelectorFromKey(key)), resource || (src = $12584cae6930e094$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $12584cae6930e094$var$preloadPropsMap.get(key)) && $12584cae6930e094$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $12584cae6930e094$var$markNodeAsHoistable(resource), $12584cae6930e094$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $12584cae6930e094$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $12584cae6930e094$var$rootInstanceStackCursor.current) ? $12584cae6930e094$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($12584cae6930e094$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (pendingProps = $12584cae6930e094$var$getStyleKey(pendingProps.href), currentProps = $12584cae6930e094$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, currentProps.set(pendingProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $12584cae6930e094$var$getStyleKey(pendingProps.href);
                var styles$268 = $12584cae6930e094$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$269 = styles$268.get(type);
                resource$269 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$269 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$268.set(type, resource$269), (styles$268 = JSCompiler_inline_result.querySelector($12584cae6930e094$var$getStylesheetSelectorFromKey(type))) ? styles$268._p || (resource$269.instance = styles$268, resource$269.state.loading = 5) : (styles$268 = $12584cae6930e094$var$preloadPropsMap.get(type), styles$268 || (styles$268 = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $12584cae6930e094$var$preloadPropsMap.set(type, styles$268)), $12584cae6930e094$var$preloadStylesheet(JSCompiler_inline_result, type, styles$268, resource$269.state)));
                if (currentProps && null === currentResource) throw Error($12584cae6930e094$var$formatProdErrorMessage(528, ""));
                return resource$269;
            }
            if (currentProps && null !== currentResource) throw Error($12584cae6930e094$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (pendingProps = $12584cae6930e094$var$getScriptKey(pendingProps), currentProps = $12584cae6930e094$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, currentProps.set(pendingProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($12584cae6930e094$var$formatProdErrorMessage(444, type));
    }
}
function $12584cae6930e094$var$getStyleKey(href) {
    return 'href="' + $12584cae6930e094$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $12584cae6930e094$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $12584cae6930e094$var$stylesheetPropsFromRawProps(rawProps) {
    return $12584cae6930e094$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $12584cae6930e094$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    if (key = ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]")) {
        if (!0 !== key[$12584cae6930e094$var$internalLoadPendingKey]) {
            state.loading = 1;
            return;
        }
    } else key = ownerDocument.createElement("link"), key[$12584cae6930e094$var$internalLoadPendingKey] = !0, key.onload = key.onerror = $12584cae6930e094$var$clearPendingLoadOnNode.bind(null, key), $12584cae6930e094$var$setInitialProperties(key, "link", preloadProps), $12584cae6930e094$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key);
    state.preload = key;
    key.addEventListener("load", function() {
        return state.loading |= 1;
    });
    key.addEventListener("error", function() {
        return state.loading |= 2;
    });
}
function $12584cae6930e094$var$getScriptKey(src) {
    return '[src="' + $12584cae6930e094$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $12584cae6930e094$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $12584cae6930e094$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $12584cae6930e094$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $12584cae6930e094$var$markNodeAsHoistable(instance), instance;
            var styleProps = $12584cae6930e094$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $12584cae6930e094$var$markNodeAsHoistable(instance);
            $12584cae6930e094$var$setInitialProperties(instance, "style", styleProps);
            $12584cae6930e094$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $12584cae6930e094$var$getStyleKey(props.href);
            var instance$274 = hoistableRoot.querySelector($12584cae6930e094$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$274) return resource.state.loading |= 4, resource.instance = instance$274, $12584cae6930e094$var$markNodeAsHoistable(instance$274), instance$274;
            instance = $12584cae6930e094$var$stylesheetPropsFromRawProps(props);
            (styleProps = $12584cae6930e094$var$preloadPropsMap.get(styleProps)) && $12584cae6930e094$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$274 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $12584cae6930e094$var$markNodeAsHoistable(instance$274);
            var linkInstance = instance$274;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $12584cae6930e094$var$setInitialProperties(instance$274, "link", instance);
            resource.state.loading |= 4;
            $12584cae6930e094$var$insertStylesheet(instance$274, props.precedence, hoistableRoot);
            return resource.instance = instance$274;
        case "script":
            instance$274 = $12584cae6930e094$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($12584cae6930e094$var$getScriptSelectorFromKey(instance$274))) return resource.instance = styleProps, $12584cae6930e094$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $12584cae6930e094$var$preloadPropsMap.get(instance$274)) instance = $12584cae6930e094$var$assign({}, props), $12584cae6930e094$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $12584cae6930e094$var$markNodeAsHoistable(styleProps);
            $12584cae6930e094$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($12584cae6930e094$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $12584cae6930e094$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $12584cae6930e094$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $12584cae6930e094$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $12584cae6930e094$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $12584cae6930e094$var$tagCaches = null;
function $12584cae6930e094$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $12584cae6930e094$var$tagCaches) {
        var cache = new Map();
        var caches = $12584cae6930e094$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $12584cae6930e094$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$12584cae6930e094$var$internalHoistableMarker] || node[$12584cae6930e094$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $12584cae6930e094$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $12584cae6930e094$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $12584cae6930e094$var$maySuspendCommit(type, props) {
    return "img" === type && null != props.src && "" !== props.src && null == props.onLoad && "lazy" !== props.loading;
}
function $12584cae6930e094$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $12584cae6930e094$var$estimateImageBytes(instance) {
    return (instance.width || 100) * (instance.height || 100) * ("number" === typeof devicePixelRatio ? devicePixelRatio : 1) * 0.25;
}
function $12584cae6930e094$var$suspendInstance(state, instance) {
    "function" === typeof instance.decode && (state.imgCount++, instance.complete || (state.imgBytes += $12584cae6930e094$var$estimateImageBytes(instance), state.suspenseyImages.push(instance)), state = $12584cae6930e094$var$onUnsuspendImg.bind(state), instance.decode().then(state, state));
}
function $12584cae6930e094$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $12584cae6930e094$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($12584cae6930e094$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $12584cae6930e094$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $12584cae6930e094$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $12584cae6930e094$var$stylesheetPropsFromRawProps(props);
            (key = $12584cae6930e094$var$preloadPropsMap.get(key)) && $12584cae6930e094$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $12584cae6930e094$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $12584cae6930e094$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $12584cae6930e094$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $12584cae6930e094$var$estimatedBytesWithinLimit = 0;
function $12584cae6930e094$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $12584cae6930e094$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $12584cae6930e094$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $12584cae6930e094$var$estimatedBytesWithinLimit && ($12584cae6930e094$var$estimatedBytesWithinLimit = 62500 * $12584cae6930e094$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $12584cae6930e094$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $12584cae6930e094$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $12584cae6930e094$var$checkIfFullyUnsuspended(state) {
    if (0 === state.count && (0 === state.imgCount || !state.waitingForImages)) {
        if (state.stylesheets) $12584cae6930e094$var$insertSuspendedStylesheets(state, state.stylesheets);
        else if (state.unsuspend) {
            var unsuspend = state.unsuspend;
            state.unsuspend = null;
            unsuspend();
        }
    }
}
function $12584cae6930e094$var$onUnsuspend() {
    this.count--;
    $12584cae6930e094$var$checkIfFullyUnsuspended(this);
}
function $12584cae6930e094$var$onUnsuspendImg() {
    this.imgCount--;
    $12584cae6930e094$var$checkIfFullyUnsuspended(this);
}
var $12584cae6930e094$var$precedencesByRoot = null;
function $12584cae6930e094$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $12584cae6930e094$var$precedencesByRoot = new Map(), resources.forEach($12584cae6930e094$var$insertStylesheetIntoRoot, state), $12584cae6930e094$var$precedencesByRoot = null, $12584cae6930e094$var$onUnsuspend.call(state));
}
function $12584cae6930e094$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $12584cae6930e094$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $12584cae6930e094$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $12584cae6930e094$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $12584cae6930e094$var$HostTransitionContext = {
    $$typeof: $12584cae6930e094$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $12584cae6930e094$var$sharedNotPendingObject,
    _currentValue2: $12584cae6930e094$var$sharedNotPendingObject,
    _threadCount: 0
};
function $12584cae6930e094$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $12584cae6930e094$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $12584cae6930e094$var$createLaneMap(0);
    this.hiddenUpdates = $12584cae6930e094$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.transitionTypes = null;
    this.incompleteTransitions = new Map();
}
function $12584cae6930e094$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $12584cae6930e094$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $12584cae6930e094$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $12584cae6930e094$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $12584cae6930e094$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $12584cae6930e094$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $12584cae6930e094$var$emptyContextObject;
    parentComponent = $12584cae6930e094$var$emptyContextObject;
    return parentComponent;
}
function $12584cae6930e094$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $12584cae6930e094$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $12584cae6930e094$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $12584cae6930e094$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($12584cae6930e094$var$scheduleUpdateOnFiber(element, rootFiber, lane), $12584cae6930e094$var$entangleTransitions(element, rootFiber, lane));
}
function $12584cae6930e094$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $12584cae6930e094$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $12584cae6930e094$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $12584cae6930e094$var$markRetryLaneImpl(fiber, retryLane);
}
function $12584cae6930e094$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $12584cae6930e094$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $12584cae6930e094$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $12584cae6930e094$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $12584cae6930e094$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $12584cae6930e094$var$requestUpdateLane();
        lane = $12584cae6930e094$var$getBumpedLaneForHydrationByLane(lane);
        var root = $12584cae6930e094$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $12584cae6930e094$var$scheduleUpdateOnFiber(root, fiber, lane);
        $12584cae6930e094$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $12584cae6930e094$var$_enabled = !0;
function $12584cae6930e094$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $12584cae6930e094$var$ReactSharedInternals.T;
    $12584cae6930e094$var$ReactSharedInternals.T = null;
    var previousPriority = $12584cae6930e094$var$ReactDOMSharedInternals.p;
    try {
        $12584cae6930e094$var$ReactDOMSharedInternals.p = 2, $12584cae6930e094$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $12584cae6930e094$var$ReactDOMSharedInternals.p = previousPriority, $12584cae6930e094$var$ReactSharedInternals.T = prevTransition;
    }
}
function $12584cae6930e094$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $12584cae6930e094$var$ReactSharedInternals.T;
    $12584cae6930e094$var$ReactSharedInternals.T = null;
    var previousPriority = $12584cae6930e094$var$ReactDOMSharedInternals.p;
    try {
        $12584cae6930e094$var$ReactDOMSharedInternals.p = 8, $12584cae6930e094$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $12584cae6930e094$var$ReactDOMSharedInternals.p = previousPriority, $12584cae6930e094$var$ReactSharedInternals.T = prevTransition;
    }
}
function $12584cae6930e094$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($12584cae6930e094$var$_enabled) {
        var blockedOn = $12584cae6930e094$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $12584cae6930e094$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $12584cae6930e094$var$return_targetInst, targetContainer), $12584cae6930e094$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($12584cae6930e094$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($12584cae6930e094$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $12584cae6930e094$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $12584cae6930e094$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $12584cae6930e094$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $12584cae6930e094$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $12584cae6930e094$var$ensureRootIsScheduled(fiber);
                                0 === ($12584cae6930e094$var$executionContext & 6) && ($12584cae6930e094$var$workInProgressRootRenderTargetTime = $12584cae6930e094$var$now() + 500, $12584cae6930e094$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $12584cae6930e094$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $12584cae6930e094$var$scheduleUpdateOnFiber(root, fiber, 2), $12584cae6930e094$var$flushSyncWork$1(), $12584cae6930e094$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $12584cae6930e094$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $12584cae6930e094$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $12584cae6930e094$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $12584cae6930e094$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $12584cae6930e094$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $12584cae6930e094$var$getEventTarget(nativeEvent);
    return $12584cae6930e094$var$findInstanceBlockingTarget(nativeEvent);
}
var $12584cae6930e094$var$return_targetInst = null;
function $12584cae6930e094$var$findInstanceBlockingTarget(targetNode) {
    $12584cae6930e094$var$return_targetInst = null;
    targetNode = $12584cae6930e094$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $12584cae6930e094$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $12584cae6930e094$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $12584cae6930e094$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $12584cae6930e094$var$return_targetInst = targetNode;
    return null;
}
function $12584cae6930e094$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "fullscreenerror":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "resize":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($12584cae6930e094$var$getCurrentPriorityLevel()){
                case $12584cae6930e094$var$ImmediatePriority:
                    return 2;
                case $12584cae6930e094$var$UserBlockingPriority:
                    return 8;
                case $12584cae6930e094$var$NormalPriority$1:
                case $12584cae6930e094$var$LowPriority:
                    return 32;
                case $12584cae6930e094$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $12584cae6930e094$var$hasScheduledReplayAttempt = !1, $12584cae6930e094$var$queuedFocus = null, $12584cae6930e094$var$queuedDrag = null, $12584cae6930e094$var$queuedMouse = null, $12584cae6930e094$var$queuedPointers = new Map(), $12584cae6930e094$var$queuedPointerCaptures = new Map(), $12584cae6930e094$var$queuedExplicitHydrationTargets = [], $12584cae6930e094$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $12584cae6930e094$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $12584cae6930e094$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $12584cae6930e094$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $12584cae6930e094$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $12584cae6930e094$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $12584cae6930e094$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $12584cae6930e094$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $12584cae6930e094$var$getInstanceFromNode(blockedOn), null !== blockedOn && $12584cae6930e094$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $12584cae6930e094$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $12584cae6930e094$var$queuedFocus = $12584cae6930e094$var$accumulateOrCreateContinuousQueuedReplayableEvent($12584cae6930e094$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $12584cae6930e094$var$queuedDrag = $12584cae6930e094$var$accumulateOrCreateContinuousQueuedReplayableEvent($12584cae6930e094$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $12584cae6930e094$var$queuedMouse = $12584cae6930e094$var$accumulateOrCreateContinuousQueuedReplayableEvent($12584cae6930e094$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $12584cae6930e094$var$queuedPointers.set(pointerId, $12584cae6930e094$var$accumulateOrCreateContinuousQueuedReplayableEvent($12584cae6930e094$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $12584cae6930e094$var$queuedPointerCaptures.set(pointerId, $12584cae6930e094$var$accumulateOrCreateContinuousQueuedReplayableEvent($12584cae6930e094$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $12584cae6930e094$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $12584cae6930e094$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $12584cae6930e094$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $12584cae6930e094$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $12584cae6930e094$var$runWithPriority(queuedTarget.priority, function() {
                        $12584cae6930e094$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $12584cae6930e094$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $12584cae6930e094$var$runWithPriority(queuedTarget.priority, function() {
                        $12584cae6930e094$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $12584cae6930e094$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $12584cae6930e094$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $12584cae6930e094$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $12584cae6930e094$var$currentReplayingEvent = null;
        } else return targetContainers = $12584cae6930e094$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $12584cae6930e094$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $12584cae6930e094$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $12584cae6930e094$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $12584cae6930e094$var$replayUnblockedEvents() {
    $12584cae6930e094$var$hasScheduledReplayAttempt = !1;
    null !== $12584cae6930e094$var$queuedFocus && $12584cae6930e094$var$attemptReplayContinuousQueuedEvent($12584cae6930e094$var$queuedFocus) && ($12584cae6930e094$var$queuedFocus = null);
    null !== $12584cae6930e094$var$queuedDrag && $12584cae6930e094$var$attemptReplayContinuousQueuedEvent($12584cae6930e094$var$queuedDrag) && ($12584cae6930e094$var$queuedDrag = null);
    null !== $12584cae6930e094$var$queuedMouse && $12584cae6930e094$var$attemptReplayContinuousQueuedEvent($12584cae6930e094$var$queuedMouse) && ($12584cae6930e094$var$queuedMouse = null);
    $12584cae6930e094$var$queuedPointers.forEach($12584cae6930e094$var$attemptReplayContinuousQueuedEventInMap);
    $12584cae6930e094$var$queuedPointerCaptures.forEach($12584cae6930e094$var$attemptReplayContinuousQueuedEventInMap);
}
function $12584cae6930e094$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $12584cae6930e094$var$hasScheduledReplayAttempt || ($12584cae6930e094$var$hasScheduledReplayAttempt = !0, $8IBEr.unstable_scheduleCallback($8IBEr.unstable_NormalPriority, $12584cae6930e094$var$replayUnblockedEvents)));
}
var $12584cae6930e094$var$lastScheduledReplayQueue = null;
function $12584cae6930e094$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $12584cae6930e094$var$lastScheduledReplayQueue !== formReplayingQueue && ($12584cae6930e094$var$lastScheduledReplayQueue = formReplayingQueue, $8IBEr.unstable_scheduleCallback($8IBEr.unstable_NormalPriority, function() {
        $12584cae6930e094$var$lastScheduledReplayQueue === formReplayingQueue && ($12584cae6930e094$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $12584cae6930e094$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $12584cae6930e094$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $12584cae6930e094$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $12584cae6930e094$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $12584cae6930e094$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $12584cae6930e094$var$queuedFocus && $12584cae6930e094$var$scheduleCallbackIfUnblocked($12584cae6930e094$var$queuedFocus, unblocked);
    null !== $12584cae6930e094$var$queuedDrag && $12584cae6930e094$var$scheduleCallbackIfUnblocked($12584cae6930e094$var$queuedDrag, unblocked);
    null !== $12584cae6930e094$var$queuedMouse && $12584cae6930e094$var$scheduleCallbackIfUnblocked($12584cae6930e094$var$queuedMouse, unblocked);
    $12584cae6930e094$var$queuedPointers.forEach(unblock);
    $12584cae6930e094$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $12584cae6930e094$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $12584cae6930e094$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $12584cae6930e094$var$queuedExplicitHydrationTargets.length && (i = $12584cae6930e094$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$12584cae6930e094$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $12584cae6930e094$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$12584cae6930e094$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $12584cae6930e094$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$12584cae6930e094$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $12584cae6930e094$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $12584cae6930e094$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $12584cae6930e094$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $12584cae6930e094$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$12584cae6930e094$var$ReactDOMHydrationRoot.prototype.render = $12584cae6930e094$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($12584cae6930e094$var$formatProdErrorMessage(409));
    var current = root.current, lane = $12584cae6930e094$var$requestUpdateLane();
    $12584cae6930e094$var$updateContainerImpl(current, lane, children, root, null, null);
};
$12584cae6930e094$var$ReactDOMHydrationRoot.prototype.unmount = $12584cae6930e094$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $12584cae6930e094$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $12584cae6930e094$var$flushSyncWork$1();
        container[$12584cae6930e094$var$internalContainerInstanceKey] = null;
    }
};
function $12584cae6930e094$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$12584cae6930e094$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $12584cae6930e094$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $12584cae6930e094$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $12584cae6930e094$var$queuedExplicitHydrationTargets[i].priority; i++);
        $12584cae6930e094$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $12584cae6930e094$var$attemptExplicitHydrationTarget(target);
    }
};
var $12584cae6930e094$var$isomorphicReactPackageVersion$jscomp$inline_2043 = $lCzvA.version;
if ("19.3.1" !== $12584cae6930e094$var$isomorphicReactPackageVersion$jscomp$inline_2043) throw Error($12584cae6930e094$var$formatProdErrorMessage(527, $12584cae6930e094$var$isomorphicReactPackageVersion$jscomp$inline_2043, "19.3.1"));
$12584cae6930e094$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($12584cae6930e094$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($12584cae6930e094$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $12584cae6930e094$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $12584cae6930e094$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $12584cae6930e094$var$internals$jscomp$inline_2586 = {
    bundleType: 0,
    version: "19.3.1",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $12584cae6930e094$var$ReactSharedInternals,
    reconcilerVersion: "19.3.1"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $12584cae6930e094$var$hook$jscomp$inline_2587 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$12584cae6930e094$var$hook$jscomp$inline_2587.isDisabled && $12584cae6930e094$var$hook$jscomp$inline_2587.supportsFiber) try {
        $12584cae6930e094$var$rendererID = $12584cae6930e094$var$hook$jscomp$inline_2587.inject($12584cae6930e094$var$internals$jscomp$inline_2586), $12584cae6930e094$var$injectedHook = $12584cae6930e094$var$hook$jscomp$inline_2587;
    } catch (err) {}
}
$12584cae6930e094$export$882461b6382ed46c = function(container, options) {
    if (!$12584cae6930e094$var$isValidContainer(container)) throw Error($12584cae6930e094$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $12584cae6930e094$var$defaultOnUncaughtError, onCaughtError = $12584cae6930e094$var$defaultOnCaughtError, onRecoverableError = $12584cae6930e094$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $12584cae6930e094$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $12584cae6930e094$var$defaultOnDefaultTransitionIndicator);
    container[$12584cae6930e094$var$internalContainerInstanceKey] = options.current;
    $12584cae6930e094$var$listenToAllSupportedEvents(container);
    return new $12584cae6930e094$var$ReactDOMRoot(options);
};
$12584cae6930e094$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$12584cae6930e094$var$isValidContainer(container)) throw Error($12584cae6930e094$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $12584cae6930e094$var$defaultOnUncaughtError, onCaughtError = $12584cae6930e094$var$defaultOnCaughtError, onRecoverableError = $12584cae6930e094$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $12584cae6930e094$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $12584cae6930e094$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $12584cae6930e094$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $12584cae6930e094$var$requestUpdateLane();
    isStrictMode = $12584cae6930e094$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $12584cae6930e094$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $12584cae6930e094$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $12584cae6930e094$var$markRootUpdated$1(initialChildren, options);
    $12584cae6930e094$var$ensureRootIsScheduled(initialChildren);
    container[$12584cae6930e094$var$internalContainerInstanceKey] = initialChildren.current;
    $12584cae6930e094$var$listenToAllSupportedEvents(container);
    return new $12584cae6930e094$var$ReactDOMHydrationRoot(initialChildren);
};
$12584cae6930e094$export$83d89fbfd8236492 = "19.3.1";

});
parcelRegister("8IBEr", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9aKQb"));

});
parcelRegister("9aKQb", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $6ad961cdcd5ceea2$export$c4744153514ff05d; }, function (v) { return $6ad961cdcd5ceea2$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $6ad961cdcd5ceea2$export$3e506c1ccc9cc1a7; }, function (v) { return $6ad961cdcd5ceea2$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $6ad961cdcd5ceea2$export$e26fe2ed2fa76875; }, function (v) { return $6ad961cdcd5ceea2$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $6ad961cdcd5ceea2$export$502329bbf4b505b1; }, function (v) { return $6ad961cdcd5ceea2$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $6ad961cdcd5ceea2$export$6e3807111c4874c4; }, function (v) { return $6ad961cdcd5ceea2$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $6ad961cdcd5ceea2$export$c27134553091fb3a; }, function (v) { return $6ad961cdcd5ceea2$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $6ad961cdcd5ceea2$export$33ee1acdc04fd2a2; }, function (v) { return $6ad961cdcd5ceea2$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $6ad961cdcd5ceea2$export$b00a404bbd5edef2; }, function (v) { return $6ad961cdcd5ceea2$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $6ad961cdcd5ceea2$export$d66a1c1c77bd778b; }, function (v) { return $6ad961cdcd5ceea2$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $6ad961cdcd5ceea2$export$d3dfb8e4810cb555; }, function (v) { return $6ad961cdcd5ceea2$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $6ad961cdcd5ceea2$export$72fdf0e06517287b; }, function (v) { return $6ad961cdcd5ceea2$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $6ad961cdcd5ceea2$export$816d2913ae6b83b1; }, function (v) { return $6ad961cdcd5ceea2$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $6ad961cdcd5ceea2$export$61bcfe829111a1d0; }, function (v) { return $6ad961cdcd5ceea2$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $6ad961cdcd5ceea2$export$7ee8c9beb337bc3f; }, function (v) { return $6ad961cdcd5ceea2$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $6ad961cdcd5ceea2$export$b5836b71941fa3ed; }, function (v) { return $6ad961cdcd5ceea2$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $6ad961cdcd5ceea2$export$cf845f2c119da08a; }, function (v) { return $6ad961cdcd5ceea2$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6ad961cdcd5ceea2$export$c4744153514ff05d;
var $6ad961cdcd5ceea2$export$3e506c1ccc9cc1a7;
var $6ad961cdcd5ceea2$export$e26fe2ed2fa76875;
var $6ad961cdcd5ceea2$export$502329bbf4b505b1;
var $6ad961cdcd5ceea2$export$6e3807111c4874c4;
var $6ad961cdcd5ceea2$export$c27134553091fb3a;
var $6ad961cdcd5ceea2$export$33ee1acdc04fd2a2;
var $6ad961cdcd5ceea2$export$b00a404bbd5edef2;
var $6ad961cdcd5ceea2$export$d66a1c1c77bd778b;
var $6ad961cdcd5ceea2$export$d3dfb8e4810cb555;
var $6ad961cdcd5ceea2$export$72fdf0e06517287b;
var $6ad961cdcd5ceea2$export$816d2913ae6b83b1;
var $6ad961cdcd5ceea2$export$61bcfe829111a1d0;
var $6ad961cdcd5ceea2$export$7ee8c9beb337bc3f;
var $6ad961cdcd5ceea2$export$b5836b71941fa3ed;
var $6ad961cdcd5ceea2$export$cf845f2c119da08a;
"use strict";
function $6ad961cdcd5ceea2$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $6ad961cdcd5ceea2$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $6ad961cdcd5ceea2$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $6ad961cdcd5ceea2$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $6ad961cdcd5ceea2$var$compare(left, last)) rightIndex < length && 0 > $6ad961cdcd5ceea2$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $6ad961cdcd5ceea2$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $6ad961cdcd5ceea2$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$6ad961cdcd5ceea2$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $6ad961cdcd5ceea2$var$localPerformance = performance;
    $6ad961cdcd5ceea2$export$c4744153514ff05d = function() {
        return $6ad961cdcd5ceea2$var$localPerformance.now();
    };
} else {
    var $6ad961cdcd5ceea2$var$localDate = Date, $6ad961cdcd5ceea2$var$initialTime = $6ad961cdcd5ceea2$var$localDate.now();
    $6ad961cdcd5ceea2$export$c4744153514ff05d = function() {
        return $6ad961cdcd5ceea2$var$localDate.now() - $6ad961cdcd5ceea2$var$initialTime;
    };
}
var $6ad961cdcd5ceea2$var$taskQueue = [], $6ad961cdcd5ceea2$var$timerQueue = [], $6ad961cdcd5ceea2$var$taskIdCounter = 1, $6ad961cdcd5ceea2$var$currentTask = null, $6ad961cdcd5ceea2$var$currentPriorityLevel = 3, $6ad961cdcd5ceea2$var$isPerformingWork = !1, $6ad961cdcd5ceea2$var$isHostCallbackScheduled = !1, $6ad961cdcd5ceea2$var$isHostTimeoutScheduled = !1, $6ad961cdcd5ceea2$var$needsPaint = !1, $6ad961cdcd5ceea2$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $6ad961cdcd5ceea2$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $6ad961cdcd5ceea2$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $6ad961cdcd5ceea2$var$advanceTimers(currentTime) {
    for(var timer = $6ad961cdcd5ceea2$var$peek($6ad961cdcd5ceea2$var$timerQueue); null !== timer;){
        if (null === timer.callback) $6ad961cdcd5ceea2$var$pop($6ad961cdcd5ceea2$var$timerQueue);
        else if (timer.startTime <= currentTime) $6ad961cdcd5ceea2$var$pop($6ad961cdcd5ceea2$var$timerQueue), timer.sortIndex = timer.expirationTime, $6ad961cdcd5ceea2$var$push($6ad961cdcd5ceea2$var$taskQueue, timer);
        else break;
        timer = $6ad961cdcd5ceea2$var$peek($6ad961cdcd5ceea2$var$timerQueue);
    }
}
function $6ad961cdcd5ceea2$var$handleTimeout(currentTime) {
    $6ad961cdcd5ceea2$var$isHostTimeoutScheduled = !1;
    $6ad961cdcd5ceea2$var$advanceTimers(currentTime);
    if (!$6ad961cdcd5ceea2$var$isHostCallbackScheduled) {
        if (null !== $6ad961cdcd5ceea2$var$peek($6ad961cdcd5ceea2$var$taskQueue)) $6ad961cdcd5ceea2$var$isHostCallbackScheduled = !0, $6ad961cdcd5ceea2$var$isMessageLoopRunning || ($6ad961cdcd5ceea2$var$isMessageLoopRunning = !0, $6ad961cdcd5ceea2$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $6ad961cdcd5ceea2$var$peek($6ad961cdcd5ceea2$var$timerQueue);
            null !== firstTimer && $6ad961cdcd5ceea2$var$requestHostTimeout($6ad961cdcd5ceea2$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $6ad961cdcd5ceea2$var$isMessageLoopRunning = !1, $6ad961cdcd5ceea2$var$taskTimeoutID = -1, $6ad961cdcd5ceea2$var$frameInterval = 5, $6ad961cdcd5ceea2$var$startTime = -1;
function $6ad961cdcd5ceea2$var$shouldYieldToHost() {
    return $6ad961cdcd5ceea2$var$needsPaint ? !0 : $6ad961cdcd5ceea2$export$c4744153514ff05d() - $6ad961cdcd5ceea2$var$startTime < $6ad961cdcd5ceea2$var$frameInterval ? !1 : !0;
}
function $6ad961cdcd5ceea2$var$performWorkUntilDeadline() {
    $6ad961cdcd5ceea2$var$needsPaint = !1;
    if ($6ad961cdcd5ceea2$var$isMessageLoopRunning) {
        var currentTime = $6ad961cdcd5ceea2$export$c4744153514ff05d();
        $6ad961cdcd5ceea2$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $6ad961cdcd5ceea2$var$isHostCallbackScheduled = !1;
                $6ad961cdcd5ceea2$var$isHostTimeoutScheduled && ($6ad961cdcd5ceea2$var$isHostTimeoutScheduled = !1, $6ad961cdcd5ceea2$var$localClearTimeout($6ad961cdcd5ceea2$var$taskTimeoutID), $6ad961cdcd5ceea2$var$taskTimeoutID = -1);
                $6ad961cdcd5ceea2$var$isPerformingWork = !0;
                var previousPriorityLevel = $6ad961cdcd5ceea2$var$currentPriorityLevel;
                try {
                    b: {
                        $6ad961cdcd5ceea2$var$advanceTimers(currentTime);
                        for($6ad961cdcd5ceea2$var$currentTask = $6ad961cdcd5ceea2$var$peek($6ad961cdcd5ceea2$var$taskQueue); null !== $6ad961cdcd5ceea2$var$currentTask && !($6ad961cdcd5ceea2$var$currentTask.expirationTime > currentTime && $6ad961cdcd5ceea2$var$shouldYieldToHost());){
                            var callback = $6ad961cdcd5ceea2$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $6ad961cdcd5ceea2$var$currentTask.callback = null;
                                $6ad961cdcd5ceea2$var$currentPriorityLevel = $6ad961cdcd5ceea2$var$currentTask.priorityLevel;
                                var continuationCallback = callback($6ad961cdcd5ceea2$var$currentTask.expirationTime <= currentTime);
                                currentTime = $6ad961cdcd5ceea2$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $6ad961cdcd5ceea2$var$currentTask.callback = continuationCallback;
                                    $6ad961cdcd5ceea2$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $6ad961cdcd5ceea2$var$currentTask === $6ad961cdcd5ceea2$var$peek($6ad961cdcd5ceea2$var$taskQueue) && $6ad961cdcd5ceea2$var$pop($6ad961cdcd5ceea2$var$taskQueue);
                                $6ad961cdcd5ceea2$var$advanceTimers(currentTime);
                            } else $6ad961cdcd5ceea2$var$pop($6ad961cdcd5ceea2$var$taskQueue);
                            $6ad961cdcd5ceea2$var$currentTask = $6ad961cdcd5ceea2$var$peek($6ad961cdcd5ceea2$var$taskQueue);
                        }
                        if (null !== $6ad961cdcd5ceea2$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $6ad961cdcd5ceea2$var$peek($6ad961cdcd5ceea2$var$timerQueue);
                            null !== firstTimer && $6ad961cdcd5ceea2$var$requestHostTimeout($6ad961cdcd5ceea2$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $6ad961cdcd5ceea2$var$currentTask = null, $6ad961cdcd5ceea2$var$currentPriorityLevel = previousPriorityLevel, $6ad961cdcd5ceea2$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $6ad961cdcd5ceea2$var$schedulePerformWorkUntilDeadline() : $6ad961cdcd5ceea2$var$isMessageLoopRunning = !1;
        }
    }
}
var $6ad961cdcd5ceea2$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $6ad961cdcd5ceea2$var$localSetImmediate) $6ad961cdcd5ceea2$var$schedulePerformWorkUntilDeadline = function() {
    $6ad961cdcd5ceea2$var$localSetImmediate($6ad961cdcd5ceea2$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $6ad961cdcd5ceea2$var$channel = new MessageChannel(), $6ad961cdcd5ceea2$var$port = $6ad961cdcd5ceea2$var$channel.port2;
    $6ad961cdcd5ceea2$var$channel.port1.onmessage = $6ad961cdcd5ceea2$var$performWorkUntilDeadline;
    $6ad961cdcd5ceea2$var$schedulePerformWorkUntilDeadline = function() {
        $6ad961cdcd5ceea2$var$port.postMessage(null);
    };
} else $6ad961cdcd5ceea2$var$schedulePerformWorkUntilDeadline = function() {
    $6ad961cdcd5ceea2$var$localSetTimeout($6ad961cdcd5ceea2$var$performWorkUntilDeadline, 0);
};
function $6ad961cdcd5ceea2$var$requestHostTimeout(callback, ms) {
    $6ad961cdcd5ceea2$var$taskTimeoutID = $6ad961cdcd5ceea2$var$localSetTimeout(function() {
        callback($6ad961cdcd5ceea2$export$c4744153514ff05d());
    }, ms);
}
$6ad961cdcd5ceea2$export$3e506c1ccc9cc1a7 = 5;
$6ad961cdcd5ceea2$export$e26fe2ed2fa76875 = 1;
$6ad961cdcd5ceea2$export$502329bbf4b505b1 = 4;
$6ad961cdcd5ceea2$export$6e3807111c4874c4 = 3;
$6ad961cdcd5ceea2$export$c27134553091fb3a = null;
$6ad961cdcd5ceea2$export$33ee1acdc04fd2a2 = 2;
$6ad961cdcd5ceea2$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$6ad961cdcd5ceea2$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $6ad961cdcd5ceea2$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$6ad961cdcd5ceea2$export$d3dfb8e4810cb555 = function() {
    return $6ad961cdcd5ceea2$var$currentPriorityLevel;
};
$6ad961cdcd5ceea2$export$72fdf0e06517287b = function(eventHandler) {
    switch($6ad961cdcd5ceea2$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $6ad961cdcd5ceea2$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $6ad961cdcd5ceea2$var$currentPriorityLevel;
    $6ad961cdcd5ceea2$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $6ad961cdcd5ceea2$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$6ad961cdcd5ceea2$export$816d2913ae6b83b1 = function() {
    $6ad961cdcd5ceea2$var$needsPaint = !0;
};
$6ad961cdcd5ceea2$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $6ad961cdcd5ceea2$var$currentPriorityLevel;
    $6ad961cdcd5ceea2$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $6ad961cdcd5ceea2$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$6ad961cdcd5ceea2$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $6ad961cdcd5ceea2$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $6ad961cdcd5ceea2$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $6ad961cdcd5ceea2$var$push($6ad961cdcd5ceea2$var$timerQueue, priorityLevel), null === $6ad961cdcd5ceea2$var$peek($6ad961cdcd5ceea2$var$taskQueue) && priorityLevel === $6ad961cdcd5ceea2$var$peek($6ad961cdcd5ceea2$var$timerQueue) && ($6ad961cdcd5ceea2$var$isHostTimeoutScheduled ? ($6ad961cdcd5ceea2$var$localClearTimeout($6ad961cdcd5ceea2$var$taskTimeoutID), $6ad961cdcd5ceea2$var$taskTimeoutID = -1) : $6ad961cdcd5ceea2$var$isHostTimeoutScheduled = !0, $6ad961cdcd5ceea2$var$requestHostTimeout($6ad961cdcd5ceea2$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $6ad961cdcd5ceea2$var$push($6ad961cdcd5ceea2$var$taskQueue, priorityLevel), $6ad961cdcd5ceea2$var$isHostCallbackScheduled || $6ad961cdcd5ceea2$var$isPerformingWork || ($6ad961cdcd5ceea2$var$isHostCallbackScheduled = !0, $6ad961cdcd5ceea2$var$isMessageLoopRunning || ($6ad961cdcd5ceea2$var$isMessageLoopRunning = !0, $6ad961cdcd5ceea2$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$6ad961cdcd5ceea2$export$b5836b71941fa3ed = $6ad961cdcd5ceea2$var$shouldYieldToHost;
$6ad961cdcd5ceea2$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $6ad961cdcd5ceea2$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $6ad961cdcd5ceea2$var$currentPriorityLevel;
        $6ad961cdcd5ceea2$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $6ad961cdcd5ceea2$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("lCzvA", function(module, exports) {
'use strict';

module.exports = (parcelRequire("5D7th"));

});
parcelRegister("5D7th", function(module, exports) {

$parcel$export(module.exports, "Activity", function () { return $419663ed77570ca3$export$9c16c1426311996d; }, function (v) { return $419663ed77570ca3$export$9c16c1426311996d = v; });
$parcel$export(module.exports, "Children", function () { return $419663ed77570ca3$export$dca3b0875bd9a954; }, function (v) { return $419663ed77570ca3$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $419663ed77570ca3$export$16fa2f45be04daa8; }, function (v) { return $419663ed77570ca3$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $419663ed77570ca3$export$ffb0004e005737fa; }, function (v) { return $419663ed77570ca3$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $419663ed77570ca3$export$e2c29f18771995cb; }, function (v) { return $419663ed77570ca3$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $419663ed77570ca3$export$221d75b3f55bb0bd; }, function (v) { return $419663ed77570ca3$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $419663ed77570ca3$export$5f8d39834fd61797; }, function (v) { return $419663ed77570ca3$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $419663ed77570ca3$export$74bf444e3cd11ea5; }, function (v) { return $419663ed77570ca3$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "ViewTransition", function () { return $419663ed77570ca3$export$8cdaa4703948c5e9; }, function (v) { return $419663ed77570ca3$export$8cdaa4703948c5e9 = v; });
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $419663ed77570ca3$export$1ced07cd6b1985ce; }, function (v) { return $419663ed77570ca3$export$1ced07cd6b1985ce = v; });
$parcel$export(module.exports, "__COMPILER_RUNTIME", function () { return $419663ed77570ca3$export$abd8e32b826d7ea7; }, function (v) { return $419663ed77570ca3$export$abd8e32b826d7ea7 = v; });
$parcel$export(module.exports, "addTransitionType", function () { return $419663ed77570ca3$export$87c99536b1b8cdd8; }, function (v) { return $419663ed77570ca3$export$87c99536b1b8cdd8 = v; });
$parcel$export(module.exports, "cache", function () { return $419663ed77570ca3$export$69a3209f1a06c04d; }, function (v) { return $419663ed77570ca3$export$69a3209f1a06c04d = v; });
$parcel$export(module.exports, "cacheSignal", function () { return $419663ed77570ca3$export$8c538325882c7eec; }, function (v) { return $419663ed77570ca3$export$8c538325882c7eec = v; });
$parcel$export(module.exports, "cloneElement", function () { return $419663ed77570ca3$export$e530037191fcd5d7; }, function (v) { return $419663ed77570ca3$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $419663ed77570ca3$export$fd42f52fd3ae1109; }, function (v) { return $419663ed77570ca3$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $419663ed77570ca3$export$c8a8987d4410bf2d; }, function (v) { return $419663ed77570ca3$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createRef", function () { return $419663ed77570ca3$export$7d1e3a5e95ceca43; }, function (v) { return $419663ed77570ca3$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $419663ed77570ca3$export$257a8862b851cb5b; }, function (v) { return $419663ed77570ca3$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $419663ed77570ca3$export$a8257692ac88316c; }, function (v) { return $419663ed77570ca3$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $419663ed77570ca3$export$488013bae63b21da; }, function (v) { return $419663ed77570ca3$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $419663ed77570ca3$export$7c73462e0d25e514; }, function (v) { return $419663ed77570ca3$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $419663ed77570ca3$export$7568632d0d33d16d; }, function (v) { return $419663ed77570ca3$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_useCacheRefresh", function () { return $419663ed77570ca3$export$f93f40ac0ca7e3a8; }, function (v) { return $419663ed77570ca3$export$f93f40ac0ca7e3a8 = v; });
$parcel$export(module.exports, "use", function () { return $419663ed77570ca3$export$1f96ae73734a86cc; }, function (v) { return $419663ed77570ca3$export$1f96ae73734a86cc = v; });
$parcel$export(module.exports, "useActionState", function () { return $419663ed77570ca3$export$9a47ced3238df325; }, function (v) { return $419663ed77570ca3$export$9a47ced3238df325 = v; });
$parcel$export(module.exports, "useCallback", function () { return $419663ed77570ca3$export$35808ee640e87ca7; }, function (v) { return $419663ed77570ca3$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $419663ed77570ca3$export$fae74005e78b1a27; }, function (v) { return $419663ed77570ca3$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $419663ed77570ca3$export$dc8fbce3eb94dc1e; }, function (v) { return $419663ed77570ca3$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $419663ed77570ca3$export$6a7bc4e911dc01cf; }, function (v) { return $419663ed77570ca3$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $419663ed77570ca3$export$6d9c69b0de29b591; }, function (v) { return $419663ed77570ca3$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useEffectEvent", function () { return $419663ed77570ca3$export$7f54fc3180508a52; }, function (v) { return $419663ed77570ca3$export$7f54fc3180508a52 = v; });
$parcel$export(module.exports, "useId", function () { return $419663ed77570ca3$export$f680877a34711e37; }, function (v) { return $419663ed77570ca3$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $419663ed77570ca3$export$d5a552a76deda3c2; }, function (v) { return $419663ed77570ca3$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $419663ed77570ca3$export$aaabe4eda9ed9969; }, function (v) { return $419663ed77570ca3$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $419663ed77570ca3$export$e5c5a5f917a5871c; }, function (v) { return $419663ed77570ca3$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $419663ed77570ca3$export$1538c33de8887b59; }, function (v) { return $419663ed77570ca3$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useOptimistic", function () { return $419663ed77570ca3$export$fca7f784ae7a249a; }, function (v) { return $419663ed77570ca3$export$fca7f784ae7a249a = v; });
$parcel$export(module.exports, "useReducer", function () { return $419663ed77570ca3$export$13e3392192263954; }, function (v) { return $419663ed77570ca3$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $419663ed77570ca3$export$b8f5890fc79d6aca; }, function (v) { return $419663ed77570ca3$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $419663ed77570ca3$export$60241385465d0a34; }, function (v) { return $419663ed77570ca3$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $419663ed77570ca3$export$306c0aa65ff9ec16; }, function (v) { return $419663ed77570ca3$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $419663ed77570ca3$export$7b286972b8d8ccbf; }, function (v) { return $419663ed77570ca3$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $419663ed77570ca3$export$83d89fbfd8236492; }, function (v) { return $419663ed77570ca3$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $419663ed77570ca3$export$9c16c1426311996d;
var $419663ed77570ca3$export$dca3b0875bd9a954;
var $419663ed77570ca3$export$16fa2f45be04daa8;
var $419663ed77570ca3$export$ffb0004e005737fa;
var $419663ed77570ca3$export$e2c29f18771995cb;
var $419663ed77570ca3$export$221d75b3f55bb0bd;
var $419663ed77570ca3$export$5f8d39834fd61797;
var $419663ed77570ca3$export$74bf444e3cd11ea5;
var $419663ed77570ca3$export$8cdaa4703948c5e9;
var $419663ed77570ca3$export$1ced07cd6b1985ce;
var $419663ed77570ca3$export$abd8e32b826d7ea7;
var $419663ed77570ca3$export$87c99536b1b8cdd8;
var $419663ed77570ca3$export$69a3209f1a06c04d;
var $419663ed77570ca3$export$8c538325882c7eec;
var $419663ed77570ca3$export$e530037191fcd5d7;
var $419663ed77570ca3$export$fd42f52fd3ae1109;
var $419663ed77570ca3$export$c8a8987d4410bf2d;
var $419663ed77570ca3$export$7d1e3a5e95ceca43;
var $419663ed77570ca3$export$257a8862b851cb5b;
var $419663ed77570ca3$export$a8257692ac88316c;
var $419663ed77570ca3$export$488013bae63b21da;
var $419663ed77570ca3$export$7c73462e0d25e514;
var $419663ed77570ca3$export$7568632d0d33d16d;
var $419663ed77570ca3$export$f93f40ac0ca7e3a8;
var $419663ed77570ca3$export$1f96ae73734a86cc;
var $419663ed77570ca3$export$9a47ced3238df325;
var $419663ed77570ca3$export$35808ee640e87ca7;
var $419663ed77570ca3$export$fae74005e78b1a27;
var $419663ed77570ca3$export$dc8fbce3eb94dc1e;
var $419663ed77570ca3$export$6a7bc4e911dc01cf;
var $419663ed77570ca3$export$6d9c69b0de29b591;
var $419663ed77570ca3$export$7f54fc3180508a52;
var $419663ed77570ca3$export$f680877a34711e37;
var $419663ed77570ca3$export$d5a552a76deda3c2;
var $419663ed77570ca3$export$aaabe4eda9ed9969;
var $419663ed77570ca3$export$e5c5a5f917a5871c;
var $419663ed77570ca3$export$1538c33de8887b59;
var $419663ed77570ca3$export$fca7f784ae7a249a;
var $419663ed77570ca3$export$13e3392192263954;
var $419663ed77570ca3$export$b8f5890fc79d6aca;
var $419663ed77570ca3$export$60241385465d0a34;
var $419663ed77570ca3$export$306c0aa65ff9ec16;
var $419663ed77570ca3$export$7b286972b8d8ccbf;
var $419663ed77570ca3$export$83d89fbfd8236492;
"use strict";
var $419663ed77570ca3$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $419663ed77570ca3$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $419663ed77570ca3$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $419663ed77570ca3$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $419663ed77570ca3$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $419663ed77570ca3$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $419663ed77570ca3$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $419663ed77570ca3$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $419663ed77570ca3$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $419663ed77570ca3$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $419663ed77570ca3$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $419663ed77570ca3$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $419663ed77570ca3$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $419663ed77570ca3$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $419663ed77570ca3$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $419663ed77570ca3$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$419663ed77570ca3$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $419663ed77570ca3$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $419663ed77570ca3$var$assign = Object.assign, $419663ed77570ca3$var$emptyObject = {};
function $419663ed77570ca3$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $419663ed77570ca3$var$emptyObject;
    this.updater = updater || $419663ed77570ca3$var$ReactNoopUpdateQueue;
}
$419663ed77570ca3$var$Component.prototype.isReactComponent = {};
$419663ed77570ca3$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$419663ed77570ca3$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $419663ed77570ca3$var$ComponentDummy() {}
$419663ed77570ca3$var$ComponentDummy.prototype = $419663ed77570ca3$var$Component.prototype;
function $419663ed77570ca3$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $419663ed77570ca3$var$emptyObject;
    this.updater = updater || $419663ed77570ca3$var$ReactNoopUpdateQueue;
}
var $419663ed77570ca3$var$pureComponentPrototype = $419663ed77570ca3$var$PureComponent.prototype = new $419663ed77570ca3$var$ComponentDummy();
$419663ed77570ca3$var$pureComponentPrototype.constructor = $419663ed77570ca3$var$PureComponent;
$419663ed77570ca3$var$assign($419663ed77570ca3$var$pureComponentPrototype, $419663ed77570ca3$var$Component.prototype);
$419663ed77570ca3$var$pureComponentPrototype.isPureReactComponent = !0;
var $419663ed77570ca3$var$isArrayImpl = Array.isArray;
function $419663ed77570ca3$var$noop() {}
var $419663ed77570ca3$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $419663ed77570ca3$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $419663ed77570ca3$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $419663ed77570ca3$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $419663ed77570ca3$var$cloneAndReplaceKey(oldElement, newKey) {
    return $419663ed77570ca3$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $419663ed77570ca3$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $419663ed77570ca3$var$REACT_ELEMENT_TYPE;
}
function $419663ed77570ca3$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $419663ed77570ca3$var$userProvidedKeyEscapeRegex = /\/+/g;
function $419663ed77570ca3$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $419663ed77570ca3$var$escape("" + element.key) : index.toString(36);
}
function $419663ed77570ca3$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($419663ed77570ca3$var$noop, $419663ed77570ca3$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $419663ed77570ca3$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $419663ed77570ca3$var$REACT_ELEMENT_TYPE:
                case $419663ed77570ca3$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $419663ed77570ca3$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $419663ed77570ca3$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $419663ed77570ca3$var$getElementKey(children, 0) : nameSoFar, $419663ed77570ca3$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($419663ed77570ca3$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $419663ed77570ca3$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($419663ed77570ca3$var$isValidElement(callback) && (callback = $419663ed77570ca3$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($419663ed77570ca3$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($419663ed77570ca3$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $419663ed77570ca3$var$getElementKey(nameSoFar, i), invokeCallback += $419663ed77570ca3$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $419663ed77570ca3$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $419663ed77570ca3$var$getElementKey(nameSoFar, i++), invokeCallback += $419663ed77570ca3$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $419663ed77570ca3$var$mapIntoArray($419663ed77570ca3$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $419663ed77570ca3$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $419663ed77570ca3$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $419663ed77570ca3$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result, thenable = ctor();
        thenable.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject, void 0 === thenable.status && (thenable.status = "fulfilled", thenable.value = moduleObject);
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error, void 0 === thenable.status && (thenable.status = "rejected", thenable.reason = error);
        });
        -1 === payload._status && (payload._status = 0, payload._result = thenable);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $419663ed77570ca3$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $419663ed77570ca3$var$startTransition(scope) {
    var prevTransition = $419663ed77570ca3$var$ReactSharedInternals.T, currentTransition = {};
    currentTransition.types = null !== prevTransition ? prevTransition.types : null;
    $419663ed77570ca3$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $419663ed77570ca3$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($419663ed77570ca3$var$noop, $419663ed77570ca3$var$reportGlobalError);
    } catch (error) {
        $419663ed77570ca3$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $419663ed77570ca3$var$ReactSharedInternals.T = prevTransition;
    }
}
function $419663ed77570ca3$var$addTransitionType(type) {
    var transition = $419663ed77570ca3$var$ReactSharedInternals.T;
    if (null !== transition) {
        var transitionTypes = transition.types;
        null === transitionTypes ? transition.types = [
            type
        ] : -1 === transitionTypes.indexOf(type) && transitionTypes.push(type);
    } else $419663ed77570ca3$var$startTransition($419663ed77570ca3$var$addTransitionType.bind(null, type));
}
var $419663ed77570ca3$var$Children = {
    map: $419663ed77570ca3$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $419663ed77570ca3$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $419663ed77570ca3$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $419663ed77570ca3$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$419663ed77570ca3$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$419663ed77570ca3$export$9c16c1426311996d = $419663ed77570ca3$var$REACT_ACTIVITY_TYPE;
$419663ed77570ca3$export$dca3b0875bd9a954 = $419663ed77570ca3$var$Children;
$419663ed77570ca3$export$16fa2f45be04daa8 = $419663ed77570ca3$var$Component;
$419663ed77570ca3$export$ffb0004e005737fa = $419663ed77570ca3$var$REACT_FRAGMENT_TYPE;
$419663ed77570ca3$export$e2c29f18771995cb = $419663ed77570ca3$var$REACT_PROFILER_TYPE;
$419663ed77570ca3$export$221d75b3f55bb0bd = $419663ed77570ca3$var$PureComponent;
$419663ed77570ca3$export$5f8d39834fd61797 = $419663ed77570ca3$var$REACT_STRICT_MODE_TYPE;
$419663ed77570ca3$export$74bf444e3cd11ea5 = $419663ed77570ca3$var$REACT_SUSPENSE_TYPE;
$419663ed77570ca3$export$8cdaa4703948c5e9 = $419663ed77570ca3$var$REACT_VIEW_TRANSITION_TYPE;
$419663ed77570ca3$export$1ced07cd6b1985ce = $419663ed77570ca3$var$ReactSharedInternals;
$419663ed77570ca3$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $419663ed77570ca3$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$419663ed77570ca3$export$87c99536b1b8cdd8 = $419663ed77570ca3$var$addTransitionType;
$419663ed77570ca3$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$419663ed77570ca3$export$8c538325882c7eec = function() {
    return null;
};
$419663ed77570ca3$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $419663ed77570ca3$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$419663ed77570ca3$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $419663ed77570ca3$var$ReactElement(element.type, key, props);
};
$419663ed77570ca3$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $419663ed77570ca3$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $419663ed77570ca3$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$419663ed77570ca3$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$419663ed77570ca3$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $419663ed77570ca3$var$ReactElement(type, key, props);
};
$419663ed77570ca3$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$419663ed77570ca3$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $419663ed77570ca3$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$419663ed77570ca3$export$a8257692ac88316c = $419663ed77570ca3$var$isValidElement;
$419663ed77570ca3$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $419663ed77570ca3$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $419663ed77570ca3$var$lazyInitializer
    };
};
$419663ed77570ca3$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $419663ed77570ca3$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$419663ed77570ca3$export$7568632d0d33d16d = $419663ed77570ca3$var$startTransition;
$419663ed77570ca3$export$f93f40ac0ca7e3a8 = function() {
    return $419663ed77570ca3$var$ReactSharedInternals.H.useCacheRefresh();
};
$419663ed77570ca3$export$1f96ae73734a86cc = function(usable) {
    return $419663ed77570ca3$var$ReactSharedInternals.H.use(usable);
};
$419663ed77570ca3$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $419663ed77570ca3$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$419663ed77570ca3$export$35808ee640e87ca7 = function(callback, deps) {
    return $419663ed77570ca3$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$419663ed77570ca3$export$fae74005e78b1a27 = function(Context) {
    return $419663ed77570ca3$var$ReactSharedInternals.H.useContext(Context);
};
$419663ed77570ca3$export$dc8fbce3eb94dc1e = function() {};
$419663ed77570ca3$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $419663ed77570ca3$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$419663ed77570ca3$export$6d9c69b0de29b591 = function(create, deps) {
    return $419663ed77570ca3$var$ReactSharedInternals.H.useEffect(create, deps);
};
$419663ed77570ca3$export$7f54fc3180508a52 = function(callback) {
    return $419663ed77570ca3$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$419663ed77570ca3$export$f680877a34711e37 = function() {
    return $419663ed77570ca3$var$ReactSharedInternals.H.useId();
};
$419663ed77570ca3$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $419663ed77570ca3$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$419663ed77570ca3$export$aaabe4eda9ed9969 = function(create, deps) {
    return $419663ed77570ca3$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$419663ed77570ca3$export$e5c5a5f917a5871c = function(create, deps) {
    return $419663ed77570ca3$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$419663ed77570ca3$export$1538c33de8887b59 = function(create, deps) {
    return $419663ed77570ca3$var$ReactSharedInternals.H.useMemo(create, deps);
};
$419663ed77570ca3$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $419663ed77570ca3$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$419663ed77570ca3$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $419663ed77570ca3$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$419663ed77570ca3$export$b8f5890fc79d6aca = function(initialValue) {
    return $419663ed77570ca3$var$ReactSharedInternals.H.useRef(initialValue);
};
$419663ed77570ca3$export$60241385465d0a34 = function(initialState) {
    return $419663ed77570ca3$var$ReactSharedInternals.H.useState(initialState);
};
$419663ed77570ca3$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $419663ed77570ca3$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$419663ed77570ca3$export$7b286972b8d8ccbf = function() {
    return $419663ed77570ca3$var$ReactSharedInternals.H.useTransition();
};
$419663ed77570ca3$export$83d89fbfd8236492 = "19.3.1";

});


parcelRegister("dAQd3", function(module, exports) {
'use strict';
function $9e5722dfb1623841$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($9e5722dfb1623841$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$9e5722dfb1623841$var$checkDCE();

module.exports = (parcelRequire("f7UAs"));

});
parcelRegister("f7UAs", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $b033677176f3968b$export$69ce8ef3fe5cead0; }, function (v) { return $b033677176f3968b$export$69ce8ef3fe5cead0 = v; });
$parcel$export(module.exports, "browser", function () { return $b033677176f3968b$export$3f2684e5d7cb1006; }, function (v) { return $b033677176f3968b$export$3f2684e5d7cb1006 = v; });
$parcel$export(module.exports, "createPortal", function () { return $b033677176f3968b$export$d39a5bbd09211389; }, function (v) { return $b033677176f3968b$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "flushSync", function () { return $b033677176f3968b$export$cd75ccfd720a3cd4; }, function (v) { return $b033677176f3968b$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "preconnect", function () { return $b033677176f3968b$export$a0816fa17a9e79be; }, function (v) { return $b033677176f3968b$export$a0816fa17a9e79be = v; });
$parcel$export(module.exports, "prefetchDNS", function () { return $b033677176f3968b$export$7292efcadded39f3; }, function (v) { return $b033677176f3968b$export$7292efcadded39f3 = v; });
$parcel$export(module.exports, "preinit", function () { return $b033677176f3968b$export$da407abadb9b8f86; }, function (v) { return $b033677176f3968b$export$da407abadb9b8f86 = v; });
$parcel$export(module.exports, "preinitModule", function () { return $b033677176f3968b$export$314cfea32580671c; }, function (v) { return $b033677176f3968b$export$314cfea32580671c = v; });
$parcel$export(module.exports, "preload", function () { return $b033677176f3968b$export$513ccb98c53b8039; }, function (v) { return $b033677176f3968b$export$513ccb98c53b8039 = v; });
$parcel$export(module.exports, "preloadModule", function () { return $b033677176f3968b$export$dbca993bc2d264a; }, function (v) { return $b033677176f3968b$export$dbca993bc2d264a = v; });
$parcel$export(module.exports, "requestFormReset", function () { return $b033677176f3968b$export$4797a8006f0655d0; }, function (v) { return $b033677176f3968b$export$4797a8006f0655d0 = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $b033677176f3968b$export$c78a37762a8d58e1; }, function (v) { return $b033677176f3968b$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "useFormState", function () { return $b033677176f3968b$export$606f11b2eb45ecc6; }, function (v) { return $b033677176f3968b$export$606f11b2eb45ecc6 = v; });
$parcel$export(module.exports, "useFormStatus", function () { return $b033677176f3968b$export$f7e8a0bf92324b1e; }, function (v) { return $b033677176f3968b$export$f7e8a0bf92324b1e = v; });
$parcel$export(module.exports, "version", function () { return $b033677176f3968b$export$83d89fbfd8236492; }, function (v) { return $b033677176f3968b$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b033677176f3968b$export$69ce8ef3fe5cead0;
var $b033677176f3968b$export$3f2684e5d7cb1006;
var $b033677176f3968b$export$d39a5bbd09211389;
var $b033677176f3968b$export$cd75ccfd720a3cd4;
var $b033677176f3968b$export$a0816fa17a9e79be;
var $b033677176f3968b$export$7292efcadded39f3;
var $b033677176f3968b$export$da407abadb9b8f86;
var $b033677176f3968b$export$314cfea32580671c;
var $b033677176f3968b$export$513ccb98c53b8039;
var $b033677176f3968b$export$dbca993bc2d264a;
var $b033677176f3968b$export$4797a8006f0655d0;
var $b033677176f3968b$export$c78a37762a8d58e1;
var $b033677176f3968b$export$606f11b2eb45ecc6;
var $b033677176f3968b$export$f7e8a0bf92324b1e;
var $b033677176f3968b$export$83d89fbfd8236492;
"use strict";

var $lCzvA = parcelRequire("lCzvA");
function $b033677176f3968b$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $b033677176f3968b$var$noop() {}
var $b033677176f3968b$var$Internals = {
    d: {
        f: $b033677176f3968b$var$noop,
        r: function() {
            throw Error($b033677176f3968b$var$formatProdErrorMessage(522));
        },
        D: $b033677176f3968b$var$noop,
        C: $b033677176f3968b$var$noop,
        L: $b033677176f3968b$var$noop,
        m: $b033677176f3968b$var$noop,
        X: $b033677176f3968b$var$noop,
        S: $b033677176f3968b$var$noop,
        M: $b033677176f3968b$var$noop
    },
    p: 0,
    findDOMNode: null
}, $b033677176f3968b$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $b033677176f3968b$var$REACT_RECOVERABLE_TYPE = Symbol.for("react.recoverable"), $b033677176f3968b$var$REACT_OPTIMISTIC_KEY = Symbol.for("react.optimistic_key");
function $b033677176f3968b$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $b033677176f3968b$var$REACT_PORTAL_TYPE,
        key: null == key ? null : key === $b033677176f3968b$var$REACT_OPTIMISTIC_KEY ? $b033677176f3968b$var$REACT_OPTIMISTIC_KEY : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $b033677176f3968b$var$ReactSharedInternals = $lCzvA.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $b033677176f3968b$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$b033677176f3968b$export$69ce8ef3fe5cead0 = $b033677176f3968b$var$Internals;
$b033677176f3968b$export$3f2684e5d7cb1006 = function(reason) {
    return {
        $$typeof: $b033677176f3968b$var$REACT_RECOVERABLE_TYPE,
        _reason: reason
    };
};
$b033677176f3968b$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($b033677176f3968b$var$formatProdErrorMessage(299));
    return $b033677176f3968b$var$createPortal$1(children, container, null, key);
};
$b033677176f3968b$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $b033677176f3968b$var$ReactSharedInternals.T, previousUpdatePriority = $b033677176f3968b$var$Internals.p;
    try {
        if ($b033677176f3968b$var$ReactSharedInternals.T = null, $b033677176f3968b$var$Internals.p = 2, fn) return fn();
    } finally{
        $b033677176f3968b$var$ReactSharedInternals.T = previousTransition, $b033677176f3968b$var$Internals.p = previousUpdatePriority, $b033677176f3968b$var$Internals.d.f();
    }
};
$b033677176f3968b$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $b033677176f3968b$var$Internals.d.C(href, options));
};
$b033677176f3968b$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $b033677176f3968b$var$Internals.d.D(href);
};
$b033677176f3968b$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $b033677176f3968b$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $b033677176f3968b$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $b033677176f3968b$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$b033677176f3968b$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $b033677176f3968b$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $b033677176f3968b$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0,
                    fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0
                });
            }
        } else null == options && $b033677176f3968b$var$Internals.d.M(href);
    }
};
$b033677176f3968b$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $b033677176f3968b$var$getCrossOriginStringAs(as, options.crossOrigin);
        $b033677176f3968b$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$b033677176f3968b$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $b033677176f3968b$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $b033677176f3968b$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                nonce: "string" === typeof options.nonce ? options.nonce : void 0,
                fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0
            });
        } else $b033677176f3968b$var$Internals.d.m(href);
    }
};
$b033677176f3968b$export$4797a8006f0655d0 = function(form) {
    $b033677176f3968b$var$Internals.d.r(form);
};
$b033677176f3968b$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$b033677176f3968b$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $b033677176f3968b$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$b033677176f3968b$export$f7e8a0bf92324b1e = function() {
    return $b033677176f3968b$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$b033677176f3968b$export$83d89fbfd8236492 = "19.3.1";

});



parcelRegister("8XozM", function(module, exports) {

var $5mCTm = parcelRequire("5mCTm");

var $6ezXE = parcelRequire("6ezXE");

var $i3Cjc = parcelRequire("i3Cjc");

var $iHsN0 = parcelRequire("iHsN0");

var $boDuC = parcelRequire("boDuC");

var $bzzgL = parcelRequire("bzzgL");

var $k27Xk = parcelRequire("k27Xk");
function $6856e5be6308a5f6$var$_regeneratorRuntime() {
    "use strict";
    var r = $6ezXE(), e = r.m($6856e5be6308a5f6$var$_regeneratorRuntime), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
    function n(r) {
        var e = "function" == typeof r && r.constructor;
        return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
    }
    var o = {
        "throw": 1,
        "return": 2,
        "break": 3,
        "continue": 3
    };
    function a(r) {
        var e, t;
        return function(n) {
            e || (e = {
                stop: function stop() {
                    return t(n.a, 2);
                },
                "catch": function _catch() {
                    return n.v;
                },
                abrupt: function abrupt(r, e) {
                    return t(n.a, o[r], e);
                },
                delegateYield: function delegateYield(r, o, a) {
                    return e.resultName = o, t(n.d, $k27Xk(r), a);
                },
                finish: function finish(r) {
                    return t(n.f, r);
                }
            }, t = function t(r, _t, o) {
                n.p = e.prev, n.n = e.next;
                try {
                    return r(_t, o);
                } finally{
                    e.next = n.n;
                }
            }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
            try {
                return r.call(this, e);
            } finally{
                n.p = e.prev, n.n = e.next;
            }
        };
    }
    return (module.exports = $6856e5be6308a5f6$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return {
            wrap: function wrap(e, t, n, o) {
                return r.w(a(e), t, n, o && o.reverse());
            },
            isGeneratorFunction: n,
            mark: r.m,
            awrap: function awrap(r, e) {
                return new $5mCTm(r, e);
            },
            AsyncIterator: $boDuC,
            async: function async(r, e, t, o, u) {
                return (n(e) ? $iHsN0 : $i3Cjc)(a(r), e, t, o, u);
            },
            keys: $bzzgL,
            values: $k27Xk
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $6856e5be6308a5f6$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5mCTm", function(module, exports) {
function $3e7d2cf162d9f9ae$var$_OverloadYield(e, d) {
    this.v = e, this.k = d;
}
module.exports = $3e7d2cf162d9f9ae$var$_OverloadYield, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("6ezXE", function(module, exports) {

var $hjE1z = parcelRequire("hjE1z");
function $489ff2053b33302e$var$_regenerator() {
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
    function i(r, n, o, i) {
        var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype);
        return $hjE1z(u, "_invoke", function(r, n, o) {
            var i, c, u, f = 0, p = o || [], y = !1, G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function d(t, r) {
                    return i = t, c = 0, u = e, G.n = r, a;
                }
            };
            function d(r, n) {
                for(c = r, u = n, t = 0; !y && f && !o && t < p.length; t++){
                    var o, i = p[t], d = G.p, l = i[2];
                    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
                }
                if (o || r > 1) return a;
                throw y = !0, n;
            }
            return function(o, p, l) {
                if (f > 1) throw TypeError("Generator is already running");
                for(y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;){
                    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
                    try {
                        if (f = 2, i) {
                            if (c || (o = "next"), t = i[o]) {
                                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                u = t.value, c < 2 && (c = 0);
                            } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                            i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                    } catch (t) {
                        i = e, c = 1, u = t;
                    } finally{
                        f = 1;
                    }
                }
                return {
                    value: t,
                    done: y
                };
            };
        }(r, o, i), !0), u;
    }
    var a = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : ($hjE1z(t = {}, n, function() {
        return this;
    }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    function f(e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, $hjE1z(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, $hjE1z(u, "constructor", GeneratorFunctionPrototype), $hjE1z(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", $hjE1z(GeneratorFunctionPrototype, o, "GeneratorFunction"), $hjE1z(u), $hjE1z(u, o, "Generator"), $hjE1z(u, n, function() {
        return this;
    }), $hjE1z(u, "toString", function() {
        return "[object Generator]";
    }), (module.exports = $489ff2053b33302e$var$_regenerator = function _regenerator() {
        return {
            w: i,
            m: f
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $489ff2053b33302e$var$_regenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("hjE1z", function(module, exports) {
function $c9b34209c1065408$var$_regeneratorDefine(e, r, n, t) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e) {
        i = 0;
    }
    module.exports = $c9b34209c1065408$var$_regeneratorDefine = function regeneratorDefine(e, r, n, t) {
        function o(r, n) {
            $c9b34209c1065408$var$_regeneratorDefine(e, r, function(e) {
                return this._invoke(r, n, e);
            });
        }
        r ? i ? i(e, r, {
            value: n,
            enumerable: !t,
            configurable: !t,
            writable: !t
        }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $c9b34209c1065408$var$_regeneratorDefine(e, r, n, t);
}
module.exports = $c9b34209c1065408$var$_regeneratorDefine, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("i3Cjc", function(module, exports) {

var $iHsN0 = parcelRequire("iHsN0");
function $d256391e793aea22$var$_regeneratorAsync(n, e, r, t, o) {
    var a = $iHsN0(n, e, r, t, o);
    return a.next().then(function(n) {
        return n.done ? n.value : a.next();
    });
}
module.exports = $d256391e793aea22$var$_regeneratorAsync, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("iHsN0", function(module, exports) {

var $6ezXE = parcelRequire("6ezXE");

var $boDuC = parcelRequire("boDuC");
function $d9d2931a87432eac$var$_regeneratorAsyncGen(r, e, t, o, n) {
    return new $boDuC($6ezXE().w(r, e, t, o), n || Promise);
}
module.exports = $d9d2931a87432eac$var$_regeneratorAsyncGen, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("boDuC", function(module, exports) {

var $5mCTm = parcelRequire("5mCTm");

var $hjE1z = parcelRequire("hjE1z");
function $84c092104ab589d0$var$AsyncIterator(t, e) {
    function n(r, o, i, f) {
        try {
            var c = t[r](o), u = c.value;
            return u instanceof $5mCTm ? e.resolve(u.v).then(function(t) {
                n("next", t, i, f);
            }, function(t) {
                n("throw", t, i, f);
            }) : e.resolve(u).then(function(t) {
                c.value = t, i(c);
            }, function(t) {
                return n("throw", t, i, f);
            });
        } catch (t) {
            f(t);
        }
    }
    var r;
    this.next || ($hjE1z($84c092104ab589d0$var$AsyncIterator.prototype), $hjE1z($84c092104ab589d0$var$AsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function() {
        return this;
    })), $hjE1z(this, "_invoke", function(t, o, i) {
        function f() {
            return new e(function(e, r) {
                n(t, i, e, r);
            });
        }
        return r = r ? r.then(f, f) : f();
    }, !0);
}
module.exports = $84c092104ab589d0$var$AsyncIterator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("bzzgL", function(module, exports) {
function $86ce525afad2afe6$var$_regeneratorKeys(e) {
    var n = Object(e), r = [];
    for(var t in n)r.unshift(t);
    return function e() {
        for(; r.length;)if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
        return e.done = !0, e;
    };
}
module.exports = $86ce525afad2afe6$var$_regeneratorKeys, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("k27Xk", function(module, exports) {

var $8zDbG = parcelRequire("8zDbG");
var $e95a2a687c19b73a$var$_typeof = $8zDbG.default;
function $e95a2a687c19b73a$var$_regeneratorValues(e) {
    if (null != e) {
        var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0;
        if (t) return t.call(e);
        if ("function" == typeof e.next) return e;
        if (!isNaN(e.length)) return {
            next: function next() {
                return e && r >= e.length && (e = void 0), {
                    value: e && e[r++],
                    done: !e
                };
            }
        };
    }
    throw new TypeError($e95a2a687c19b73a$var$_typeof(e) + " is not iterable");
}
module.exports = $e95a2a687c19b73a$var$_regeneratorValues, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("8zDbG", function(module, exports) {
function $63dffd6b14b7fff5$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $63dffd6b14b7fff5$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $63dffd6b14b7fff5$var$_typeof(o);
}
module.exports = $63dffd6b14b7fff5$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("fYDAD", function(module, exports) {
/* UAParser.js v1.0.41
   Copyright © 2012-2025 Faisal Salman <f@faisalman.com>
   MIT License */ (function(window1, undefined) {
    "use strict";
    var LIBVERSION = "1.0.41", EMPTY = "", UNKNOWN = "?", FUNC_TYPE = "function", UNDEF_TYPE = "undefined", OBJ_TYPE = "object", STR_TYPE = "string", MAJOR = "major", MODEL = "model", NAME = "name", TYPE = "type", VENDOR = "vendor", VERSION = "version", ARCHITECTURE = "architecture", CONSOLE = "console", MOBILE = "mobile", TABLET = "tablet", SMARTTV = "smarttv", WEARABLE = "wearable", EMBEDDED = "embedded", UA_MAX_LENGTH = 500;
    var AMAZON = "Amazon", APPLE = "Apple", ASUS = "ASUS", BLACKBERRY = "BlackBerry", BROWSER = "Browser", CHROME = "Chrome", EDGE = "Edge", FIREFOX = "Firefox", GOOGLE = "Google", HONOR = "Honor", HUAWEI = "Huawei", LENOVO = "Lenovo", LG = "LG", MICROSOFT = "Microsoft", MOTOROLA = "Motorola", NVIDIA = "Nvidia", ONEPLUS = "OnePlus", OPERA = "Opera", OPPO = "OPPO", SAMSUNG = "Samsung", SHARP = "Sharp", SONY = "Sony", XIAOMI = "Xiaomi", ZEBRA = "Zebra", FACEBOOK = "Facebook", CHROMIUM_OS = "Chromium OS", MAC_OS = "Mac OS", SUFFIX_BROWSER = " Browser";
    var extend = function(regexes, extensions) {
        var mergedRegexes = {};
        for(var i in regexes)if (extensions[i] && extensions[i].length % 2 === 0) mergedRegexes[i] = extensions[i].concat(regexes[i]);
        else mergedRegexes[i] = regexes[i];
        return mergedRegexes;
    }, enumerize = function(arr) {
        var enums = {};
        for(var i = 0; i < arr.length; i++)enums[arr[i].toUpperCase()] = arr[i];
        return enums;
    }, has = function(str1, str2) {
        return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
    }, lowerize = function(str) {
        return str.toLowerCase();
    }, majorize = function(version) {
        return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split(".")[0] : undefined;
    }, trim = function(str, len) {
        if (typeof str === STR_TYPE) {
            str = str.replace(/^\s\s*/, EMPTY);
            return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
        }
    };
    var rgxMapper = function(ua, arrays) {
        var i = 0, j, k, p, q, matches, match;
        while(i < arrays.length && !matches){
            var regex = arrays[i], props = arrays[i + 1];
            j = k = 0;
            while(j < regex.length && !matches){
                if (!regex[j]) break;
                matches = regex[j++].exec(ua);
                if (!!matches) for(p = 0; p < props.length; p++){
                    match = matches[++k];
                    q = props[p];
                    if (typeof q === OBJ_TYPE && q.length > 0) {
                        if (q.length === 2) {
                            if (typeof q[1] == FUNC_TYPE) this[q[0]] = q[1].call(this, match);
                            else this[q[0]] = q[1];
                        } else if (q.length === 3) {
                            if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                            else this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                        } else if (q.length === 4) this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                    } else this[q] = match ? match : undefined;
                }
            }
            i += 2;
        }
    }, strMapper = function(str, map) {
        for(var i in map){
            if (typeof map[i] === OBJ_TYPE && map[i].length > 0) for(var j = 0; j < map[i].length; j++){
                if (has(map[i][j], str)) return i === UNKNOWN ? undefined : i;
            }
            else if (has(map[i], str)) return i === UNKNOWN ? undefined : i;
        }
        return map.hasOwnProperty("*") ? map["*"] : str;
    };
    var oldSafariMap = {
        "1.0": "/8",
        1.2: "/1",
        1.3: "/3",
        "2.0": "/412",
        "2.0.2": "/416",
        "2.0.3": "/417",
        "2.0.4": "/419",
        "?": "/"
    }, windowsVersionMap = {
        ME: "4.90",
        "NT 3.11": "NT3.51",
        "NT 4.0": "NT4.0",
        2e3: "NT 5.0",
        XP: [
            "NT 5.1",
            "NT 5.2"
        ],
        Vista: "NT 6.0",
        7: "NT 6.1",
        8: "NT 6.2",
        8.1: "NT 6.3",
        10: [
            "NT 6.4",
            "NT 10.0"
        ],
        RT: "ARM"
    };
    var regexes = {
        browser: [
            [
                /\b(?:crmo|crios)\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Chrome"
                ]
            ],
            [
                /edg(?:e|ios|a)?\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Edge"
                ]
            ],
            [
                /(opera mini)\/([-\w\.]+)/i,
                /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /opios[\/ ]+([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Mini"
                ]
            ],
            [
                /\bop(?:rg)?x\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " GX"
                ]
            ],
            [
                /\bopr\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA
                ]
            ],
            [
                /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Baidu"
                ]
            ],
            [
                /\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Maxthon"
                ]
            ],
            [
                /(kindle)\/([\w\.]+)/i,
                /(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,
                /(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i,
                /(?:ms|\()(ie) ([\w\.]+)/i,
                /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon)\/([-\w\.]+)/i,
                /(heytap|ovi|115)browser\/([\d\.]+)/i,
                /(weibo)__([\d\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /quark(?:pc)?\/([-\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Quark"
                ]
            ],
            [
                /\bddg\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "DuckDuckGo"
                ]
            ],
            [
                /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "UC" + BROWSER
                ]
            ],
            [
                /microm.+\bqbcore\/([\w\.]+)/i,
                /\bqbcore\/([\w\.]+).+microm/i,
                /micromessenger\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "WeChat"
                ]
            ],
            [
                /konqueror\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Konqueror"
                ]
            ],
            [
                /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "IE"
                ]
            ],
            [
                /ya(?:search)?browser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Yandex"
                ]
            ],
            [
                /slbrowser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Smart Lenovo " + BROWSER
                ]
            ],
            [
                /(avast|avg)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 Secure " + BROWSER
                ],
                VERSION
            ],
            [
                /\bfocus\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Focus"
                ]
            ],
            [
                /\bopt\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Touch"
                ]
            ],
            [
                /coc_coc\w+\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Coc Coc"
                ]
            ],
            [
                /dolfin\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Dolphin"
                ]
            ],
            [
                /coast\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Coast"
                ]
            ],
            [
                /miuibrowser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "MIUI" + SUFFIX_BROWSER
                ]
            ],
            [
                /fxios\/([\w\.-]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX
                ]
            ],
            [
                /\bqihoobrowser\/?([\w\.]*)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "360"
                ]
            ],
            [
                /\b(qq)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1Browser"
                ],
                VERSION
            ],
            [
                /(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1" + SUFFIX_BROWSER
                ],
                VERSION
            ],
            [
                /samsungbrowser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    SAMSUNG + " Internet"
                ]
            ],
            [
                /metasr[\/ ]?([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Sogou Explorer"
                ]
            ],
            [
                /(sogou)mo\w+\/([\d\.]+)/i
            ],
            [
                [
                    NAME,
                    "Sogou Mobile"
                ],
                VERSION
            ],
            [
                /(electron)\/([\w\.]+) safari/i,
                /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                /m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(lbbrowser|rekonq)/i,
                /\[(linkedin)app\]/i
            ],
            [
                NAME
            ],
            [
                /ome\/([\w\.]+) \w* ?(iron) saf/i,
                /ome\/([\w\.]+).+qihu (360)[es]e/i
            ],
            [
                VERSION,
                NAME
            ],
            [
                /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
            ],
            [
                [
                    NAME,
                    FACEBOOK
                ],
                VERSION
            ],
            [
                /(Klarna)\/([\w\.]+)/i,
                /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
                /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
                /(daum)apps[\/ ]([\w\.]+)/i,
                /safari (line)\/([\w\.]+)/i,
                /\b(line)\/([\w\.]+)\/iab/i,
                /(alipay)client\/([\w\.]+)/i,
                /(twitter)(?:and| f.+e\/([\w\.]+))/i,
                /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\bgsa\/([\w\.]+) .*safari\//i
            ],
            [
                VERSION,
                [
                    NAME,
                    "GSA"
                ]
            ],
            [
                /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "TikTok"
                ]
            ],
            [
                /headlesschrome(?:\/([\w\.]+)| )/i
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + " Headless"
                ]
            ],
            [
                / wv\).+(chrome)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    CHROME + " WebView"
                ],
                VERSION
            ],
            [
                /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Android " + BROWSER
                ]
            ],
            [
                /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Mobile Safari"
                ]
            ],
            [
                /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
            ],
            [
                VERSION,
                NAME
            ],
            [
                /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    oldSafariMap
                ]
            ],
            [
                /(webkit|khtml)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(navigator|netscape\d?)\/([-\w\.]+)/i
            ],
            [
                [
                    NAME,
                    "Netscape"
                ],
                VERSION
            ],
            [
                /(wolvic|librewolf)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /mobile vr; rv:([\w\.]+)\).+firefox/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Reality"
                ]
            ],
            [
                /ekiohf.+(flow)\/([\w\.]+)/i,
                /(swiftfox)/i,
                /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,
                /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                /(firefox)\/([\w\.]+)/i,
                /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                /(amaya|dillo|doris|icab|ladybird|lynx|mosaic|netsurf|obigo|polaris|w3m|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                /\b(links) \(([\w\.]+)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    /_/g,
                    "."
                ]
            ],
            [
                /(cobalt)\/([\w\.]+)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    /master.|lts./,
                    ""
                ]
            ]
        ],
        cpu: [
            [
                /\b((amd|x|x86[-_]?|wow|win)64)\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "amd64"
                ]
            ],
            [
                /(ia32(?=;))/i,
                /\b((i[346]|x)86)(pc)?\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "ia32"
                ]
            ],
            [
                /\b(aarch64|arm(v?[89]e?l?|_?64))\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "arm64"
                ]
            ],
            [
                /\b(arm(v[67])?ht?n?[fl]p?)\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "armhf"
                ]
            ],
            [
                /( (ce|mobile); ppc;|\/[\w\.]+arm\b)/i
            ],
            [
                [
                    ARCHITECTURE,
                    "arm"
                ]
            ],
            [
                /((ppc|powerpc)(64)?)( mac|;|\))/i
            ],
            [
                [
                    ARCHITECTURE,
                    /ower/,
                    EMPTY,
                    lowerize
                ]
            ],
            [
                / sun4\w[;\)]/i
            ],
            [
                [
                    ARCHITECTURE,
                    "sparc"
                ]
            ],
            [
                /\b(avr32|ia64(?=;)|68k(?=\))|\barm(?=v([1-7]|[5-7]1)l?|;|eabi)|(irix|mips|sparc)(64)?\b|pa-risc)/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ]
        ],
        device: [
            [
                /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
                /samsung[- ]((?!sm-[lr])[-\w]+)/i,
                /sec-(sgh\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\((ipad);[-\w\),; ]+apple/i,
                /applecoremedia\/[\w\.]+ \((ipad)/i,
                /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(macintosh);/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ]
            ],
            [
                /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b((?:brt|eln|hey2?|gdi|jdn)-a?[lnw]09|(?:ag[rm]3?|jdn2|kob2)-a?[lw]0[09]hn)(?: bui|\)|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HONOR
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /honor([-\w ]+)[;\)]/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HONOR
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b((?:ag[rs][2356]?k?|bah[234]?|bg[2o]|bt[kv]|cmr|cpn|db[ry]2?|jdn2|got|kob2?k?|mon|pce|scm|sht?|[tw]gr|vrd)-[ad]?[lw][0125][09]b?|605hw|bg2-u03|(?:gem|fdr|m2|ple|t1)-[7a]0[1-4][lu]|t1-a2[13][lw]|mediapad[\w\. ]*(?= bui|\)))\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:huawei)([-\w ]+)[;\)]/i,
                /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /oid[^\)]+; (2[\dbc]{4}(182|283|rp\w{2})[cgl]|m2105k81a?c)(?: bui|\))/i,
                /\b((?:red)?mi[-_ ]?pad[\w- ]*)(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
                /\b; (\w+) build\/hm\1/i,
                /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
                /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i,
                / ([\w ]+) miui\/v?\d/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /; (\w+) bui.+ oppo/i,
                /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    OPPO
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(opd2(\d{3}a?))(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    strMapper,
                    {
                        OnePlus: [
                            "304",
                            "403",
                            "203"
                        ],
                        "*": OPPO
                    }
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /vivo (\w+)(?: bui|\))/i,
                /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Vivo"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Realme"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                /\bmot(?:orola)?[- ](\w*)/i,
                /((?:moto(?! 360)[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                /\blg[-e;\/ ]+((?!browser|netcast|android tv|watch)\w+)/i,
                /\blg-?([\d\w]+) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(ideatab[-\w ]+|602lv|d-42a|a101lv|a2109a|a3500-hv|s[56]000|pb-6505[my]|tb-?x?\d{3,4}(?:f[cu]|xu|[av])|yt\d?-[jx]?\d+[lfmx])( bui|;|\)|\/)/i,
                /lenovo ?(b[68]0[08]0-?[hf]?|tab(?:[\w- ]+?)|tb[\w-]{6,7})( bui|;|\)|\/)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LENOVO
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(nokia) (t[12][01])/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:maemo|nokia).*(n900|lumia \d+|rm-\d+)/i,
                /nokia[-_ ]?(([-\w\. ]*))/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    TYPE,
                    MOBILE
                ],
                [
                    VENDOR,
                    "Nokia"
                ]
            ],
            [
                /(pixel (c|tablet))\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /sony tablet [ps]/i,
                /\b(?:sony)?sgp\w+(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    "Xperia Tablet"
                ],
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (kb2005|in20[12]5|be20[12][59])\b/i,
                /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ONEPLUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(alexa)webm/i,
                /(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,
                /(kf[a-z]+)( bui|\)).+silk\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
            ],
            [
                [
                    MODEL,
                    /(.+)/g,
                    "Fire Phone $1"
                ],
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(playbook);[-\w\),; ]+(rim)/i
            ],
            [
                MODEL,
                VENDOR,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:bb[a-f]|st[hv])100-\d)/i,
                /\(bb10; (\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    BLACKBERRY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(nexus 9)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "HTC"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
            ],
            [
                VENDOR,
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])\w*(\)| bui)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "TCL"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(itel) ((\w+))/i
            ],
            [
                [
                    VENDOR,
                    lowerize
                ],
                MODEL,
                [
                    TYPE,
                    strMapper,
                    {
                        tablet: [
                            "p10001l",
                            "w7001"
                        ],
                        "*": "mobile"
                    }
                ]
            ],
            [
                /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Acer"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (m[1-5] note) bui/i,
                /\bmz-([-\w]{2,})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Meizu"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Ulefone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /; (energy ?\w+)(?: bui|\))/i,
                /; energizer ([\w ]+)(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Energizer"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /; cat (b35);/i,
                /; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Cat"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /((?:new )?andromax[\w- ]+)(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Smartfren"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (a(?:015|06[35]|142p?))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nothing"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /; (x67 5g|tikeasy \w+|ac[1789]\d\w+)( b|\))/i,
                /archos ?(5|gamepad2?|([\w ]*[t1789]|hello) ?\d+[\w ]*)( b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Archos"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /archos ([\w ]+)( b|\))/i,
                /; (ac[3-6]\d\w{2,8})( b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Archos"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(imo) (tab \w+)/i,
                /(infinix) (x1101b?)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus(?! zenw)|dell|jolla|meizu|motorola|polytron|infinix|tecno|micromax|advan)[-_ ]?([-\w]*)/i,
                /; (hmd|imo) ([\w ]+?)(?: bui|\))/i,
                /(hp) ([\w ]+\w)/i,
                /(microsoft); (lumia[\w ]+)/i,
                /(lenovo)[-_ ]?([-\w ]+?)(?: bui|\)|\/)/i,
                /(oppo) ?([\w ]+) bui/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kobo)\s(ereader|touch)/i,
                /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                /(kindle)\/([\w\.]+)/i,
                /(nook)[\w ]+build\/(\w+)/i,
                /(dell) (strea[kpr\d ]*[\dko])/i,
                /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                /(trinity)[- ]*(t\d{3}) bui/i,
                /(gigaset)[- ]+(q\w{1,9}) bui/i,
                /(vodafone) ([\w ]+)(?:\)| bui)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(surface duo)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid [\d\.]+; (fp\du?)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Fairphone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(u304aa)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "AT&T"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\bsie-(\w*)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Siemens"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rct\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "RCA"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(venue[\d ]{2,7}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Dell"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(q(?:mv|ta)\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Verizon"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Barnes & Noble"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(tm\d{3}\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NuVision"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(k88) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(nx\d{3}j) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(gen\d{3}) b.+49h/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(zur\d{3}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((zeki)?tb.*\b) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Zeki"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b([yr]\d{2}) b/i,
                /\b(dragon[- ]+touch |dt)(\w{5}) b/i
            ],
            [
                [
                    VENDOR,
                    "Dragon Touch"
                ],
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(ns-?\w{0,9}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Insignia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((nxa|next)-?\w{0,9}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NextBook"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
            ],
            [
                [
                    VENDOR,
                    "Voice"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(lvtel\-)?(v1[12]) b/i
            ],
            [
                [
                    VENDOR,
                    "LvTel"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(ph-1) /i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Essential"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(v(100md|700na|7011|917g).*\b) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Envizen"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(trio[-\w\. ]+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "MachSpeed"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\btu_(1491) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Rotor"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:tegranote|shield t(?!.+d tv))[\w- ]*?)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    NVIDIA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(sprint) (\w+)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kin\.[onetw]{3})/i
            ],
            [
                [
                    MODEL,
                    /\./g,
                    " "
                ],
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /smart-tv.+(samsung)/i
            ],
            [
                VENDOR,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /hbbtv.+maple;(\d+)/i
            ],
            [
                [
                    MODEL,
                    /^/,
                    "SmartTV"
                ],
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
            ],
            [
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(apple) ?tv/i
            ],
            [
                VENDOR,
                [
                    MODEL,
                    APPLE + " TV"
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /crkey/i
            ],
            [
                [
                    MODEL,
                    CHROME + "cast"
                ],
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /droid.+aft(\w+)( bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(shield \w+ tv)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    NVIDIA
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\(dtv[\);].+(aquos)/i,
                /(aquos-tv[\w ]+)\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(bravia[\w ]+)( bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(mi(tv|box)-?\w+) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /Hbbtv.*(technisat) (.*);/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
            ],
            [
                [
                    VENDOR,
                    trim
                ],
                [
                    MODEL,
                    trim
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /droid.+; ([\w- ]+) (?:android tv|smart[- ]?tv)/i
            ],
            [
                MODEL,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
            ],
            [
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(ouya)/i,
                /(nintendo) ([wids3utch]+)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /droid.+; (shield)( bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    NVIDIA
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /(playstation \w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /\b(xbox(?: one)?(?!; xbox))[\); ]/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /\b(sm-[lr]\d\d[0156][fnuw]?s?|gear live)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /((pebble))app/i,
                /(asus|google|lg|oppo) ((pixel |zen)?watch[\w ]*)( bui|\))/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(ow(?:19|20)?we?[1-3]{1,3})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    OPPO
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(opwwe\d{3})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ONEPLUS
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(moto 360)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(smartwatch 3)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(g watch r)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (wt63?0{2,3})\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (glass) \d/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(pico) (4|neo3(?: link|pro)?)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /; (quest( \d| pro)?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    FACEBOOK
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
            ],
            [
                VENDOR,
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /(aeobc)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /(homepod).+mac os/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /windows iot/i
            ],
            [
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i
            ],
            [
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
            ],
            [
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
            ],
            [
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
            ],
            [
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([\w\. -]+)( bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Generic"
                ]
            ]
        ],
        engine: [
            [
                /windows.+ edge\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    EDGE + "HTML"
                ]
            ],
            [
                /(arkweb)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Blink"
                ]
            ],
            [
                /(presto)\/([\w\.]+)/i,
                /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i,
                /ekioh(flow)\/([\w\.]+)/i,
                /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                /(icab)[\/ ]([23]\.[\d\.]+)/i,
                /\b(libweb)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /ladybird\//i
            ],
            [
                [
                    NAME,
                    "LibWeb"
                ]
            ],
            [
                /rv\:([\w\.]{1,9})\b.+(gecko)/i
            ],
            [
                VERSION,
                NAME
            ]
        ],
        os: [
            [
                /microsoft (windows) (vista|xp)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(windows (?:phone(?: os)?|mobile|iot))[\/ ]?([\d\.\w ]*)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                /windows nt 6\.2; (arm)/i,
                /windows[\/ ]([ntce\d\. ]+\w)(?!.+xbox)/i,
                /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ],
            [
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ],
                [
                    NAME,
                    "Windows"
                ]
            ],
            [
                /[adehimnop]{4,7}\b(?:.*os ([\w]+) like mac|; opera)/i,
                /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
                /cfnetwork\/.+darwin/i
            ],
            [
                [
                    VERSION,
                    /_/g,
                    "."
                ],
                [
                    NAME,
                    "iOS"
                ]
            ],
            [
                /(mac os x) ?([\w\. ]*)/i,
                /(macintosh|mac_powerpc\b)(?!.+haiku)/i
            ],
            [
                [
                    NAME,
                    MAC_OS
                ],
                [
                    VERSION,
                    /_/g,
                    "."
                ]
            ],
            [
                /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
            ],
            [
                VERSION,
                NAME
            ],
            [
                /(ubuntu) ([\w\.]+) like android/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 Touch"
                ],
                VERSION
            ],
            [
                /(android|bada|blackberry|kaios|maemo|meego|openharmony|qnx|rim tablet os|sailfish|series40|symbian|tizen|webos)\w*[-\/; ]?([\d\.]*)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\(bb(10);/i
            ],
            [
                VERSION,
                [
                    NAME,
                    BLACKBERRY
                ]
            ],
            [
                /(?:symbian ?os|symbos|s60(?=;)|series ?60)[-\/ ]?([\w\.]*)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Symbian"
                ]
            ],
            [
                /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " OS"
                ]
            ],
            [
                /web0s;.+rt(tv)/i,
                /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "webOS"
                ]
            ],
            [
                /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "watchOS"
                ]
            ],
            [
                /crkey\/([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + "cast"
                ]
            ],
            [
                /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
            ],
            [
                [
                    NAME,
                    CHROMIUM_OS
                ],
                VERSION
            ],
            [
                /panasonic;(viera)/i,
                /(netrange)mmh/i,
                /(nettv)\/(\d+\.[\w\.]+)/i,
                /(nintendo|playstation) ([wids345portablevuch]+)/i,
                /(xbox); +xbox ([^\);]+)/i,
                /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                /(mint)[\/\(\) ]?(\w*)/i,
                /(mageia|vectorlinux)[; ]/i,
                /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                /(hurd|linux)(?: arm\w*| x86\w*| ?)([\w\.]*)/i,
                /(gnu) ?([\w\.]*)/i,
                /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                /(haiku) (\w+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(sunos) ?([\w\.\d]*)/i
            ],
            [
                [
                    NAME,
                    "Solaris"
                ],
                VERSION
            ],
            [
                /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
                /(unix) ?([\w\.]*)/i
            ],
            [
                NAME,
                VERSION
            ]
        ]
    };
    var UAParser = function(ua, extensions) {
        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined;
        }
        if (!(this instanceof UAParser)) return new UAParser(ua, extensions).getResult();
        var _navigator = typeof window1 !== UNDEF_TYPE && window1.navigator ? window1.navigator : undefined;
        var _ua = ua || (_navigator && _navigator.userAgent ? _navigator.userAgent : EMPTY);
        var _uach = _navigator && _navigator.userAgentData ? _navigator.userAgentData : undefined;
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        var _isSelfNav = _navigator && _navigator.userAgent == _ua;
        this.getBrowser = function() {
            var _browser = {};
            _browser[NAME] = undefined;
            _browser[VERSION] = undefined;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser[MAJOR] = majorize(_browser[VERSION]);
            if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) _browser[NAME] = "Brave";
            return _browser;
        };
        this.getCPU = function() {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function() {
            var _device = {};
            _device[VENDOR] = undefined;
            _device[MODEL] = undefined;
            _device[TYPE] = undefined;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) _device[TYPE] = MOBILE;
            if (_isSelfNav && _device[MODEL] == "Macintosh" && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
                _device[MODEL] = "iPad";
                _device[TYPE] = TABLET;
            }
            return _device;
        };
        this.getEngine = function() {
            var _engine = {};
            _engine[NAME] = undefined;
            _engine[VERSION] = undefined;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function() {
            var _os = {};
            _os[NAME] = undefined;
            _os[VERSION] = undefined;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            if (_isSelfNav && !_os[NAME] && _uach && _uach.platform && _uach.platform != "Unknown") _os[NAME] = _uach.platform.replace(/chrome os/i, CHROMIUM_OS).replace(/macos/i, MAC_OS);
            return _os;
        };
        this.getResult = function() {
            return {
                ua: this.getUA(),
                browser: this.getBrowser(),
                engine: this.getEngine(),
                os: this.getOS(),
                device: this.getDevice(),
                cpu: this.getCPU()
            };
        };
        this.getUA = function() {
            return _ua;
        };
        this.setUA = function(ua) {
            _ua = typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };
    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = enumerize([
        NAME,
        VERSION,
        MAJOR
    ]);
    UAParser.CPU = enumerize([
        ARCHITECTURE
    ]);
    UAParser.DEVICE = enumerize([
        MODEL,
        VENDOR,
        TYPE,
        CONSOLE,
        MOBILE,
        SMARTTV,
        TABLET,
        WEARABLE,
        EMBEDDED
    ]);
    UAParser.ENGINE = UAParser.OS = enumerize([
        NAME,
        VERSION
    ]);
    if ("object" !== UNDEF_TYPE) {
        if ("object" !== UNDEF_TYPE && module.exports) exports = module.exports = UAParser;
        exports.UAParser = UAParser;
    } else {
        if (typeof define === FUNC_TYPE && define.amd) define(function() {
            return UAParser;
        });
        else if (typeof window1 !== UNDEF_TYPE) window1.UAParser = UAParser;
    }
    var $ = typeof window1 !== UNDEF_TYPE && (window1.jQuery || window1.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser;
        $.ua = parser.getResult();
        $.ua.get = function() {
            return parser.getUA();
        };
        $.ua.set = function(ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for(var prop in result)$.ua[prop] = result[prop];
        };
    }
})(typeof window === "object" ? window : this);

});

parcelRegister("1AISF", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $1cUPA = parcelRequire("1cUPA");
function $128bf7979c1e77e7$var$emptyFunction() {}
function $128bf7979c1e77e7$var$emptyFunctionWithReset() {}
$128bf7979c1e77e7$var$emptyFunctionWithReset.resetWarningCache = $128bf7979c1e77e7$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $1cUPA) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $128bf7979c1e77e7$var$emptyFunctionWithReset,
        resetWarningCache: $128bf7979c1e77e7$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("1cUPA", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $0e12fede87db0066$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $0e12fede87db0066$var$ReactPropTypesSecret;

});


var $1e1ba35c5b9fc4c3$exports = {};
'use strict';

$1e1ba35c5b9fc4c3$exports = (parcelRequire("9fhap"));


var $2aa82faa573d5f31$exports = {};
'use strict';
function $2aa82faa573d5f31$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($2aa82faa573d5f31$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$2aa82faa573d5f31$var$checkDCE();

$2aa82faa573d5f31$exports = (parcelRequire("1zEgY"));



var $1200b3a22cd8f254$exports = {};

$1200b3a22cd8f254$exports["slideDown"] = `gPMrEW_slideDown`;
$1200b3a22cd8f254$exports["slideDown"];
$1200b3a22cd8f254$exports["slideLeft"] = `gPMrEW_slideLeft`;
$1200b3a22cd8f254$exports["slideLeft"];
$1200b3a22cd8f254$exports["slideRight"] = `gPMrEW_slideRight`;
$1200b3a22cd8f254$exports["slideRight"];
for(let key in {})if (key in $1200b3a22cd8f254$exports) $1200b3a22cd8f254$exports[key] += ' ' + {}[key];
else $1200b3a22cd8f254$exports[key] = {}[key];


/*!
 * Copyright (c) 2017-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ function $aa334e3d194e1887$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $aa334e3d194e1887$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $aa334e3d194e1887$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $aa334e3d194e1887$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}


function $77b22e4247016f88$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $3780c47504d52e8d$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}


function $a8ea0c9e86a1fa0b$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $0a515bde8794ea0d$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $a8ea0c9e86a1fa0b$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $a8ea0c9e86a1fa0b$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $64ee64484aba4103$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $d841112d45ccda4f$export$2e2bcd8739ae039(r, e) {
    return (0, $77b22e4247016f88$export$2e2bcd8739ae039)(r) || (0, $3780c47504d52e8d$export$2e2bcd8739ae039)(r, e) || (0, $0a515bde8794ea0d$export$2e2bcd8739ae039)(r, e) || (0, $64ee64484aba4103$export$2e2bcd8739ae039)();
}


var $a0061d920c204c4d$exports = {};
// TODO(Babel 8): Remove this file.

var $a0061d920c204c4d$var$runtime = (parcelRequire("8XozM"))();
$a0061d920c204c4d$exports = $a0061d920c204c4d$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $a0061d920c204c4d$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $a0061d920c204c4d$var$runtime;
    else Function("r", "regeneratorRuntime = r")($a0061d920c204c4d$var$runtime);
}



var $lCzvA = parcelRequire("lCzvA");
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ var $da481a8e31937f09$export$c96dcb52978c0932;
(function(IdxStatus) {
    IdxStatus["SUCCESS"] = "SUCCESS";
    IdxStatus["PENDING"] = "PENDING";
    IdxStatus["FAILURE"] = "FAILURE";
    IdxStatus["TERMINAL"] = "TERMINAL";
    IdxStatus["CANCELED"] = "CANCELED";
})($da481a8e31937f09$export$c96dcb52978c0932 || ($da481a8e31937f09$export$c96dcb52978c0932 = {}));
var $da481a8e31937f09$export$b420a84de7aa04bd;
(function(AuthenticatorKey) {
    AuthenticatorKey["OKTA_PASSWORD"] = "okta_password";
    AuthenticatorKey["OKTA_EMAIL"] = "okta_email";
    AuthenticatorKey["PHONE_NUMBER"] = "phone_number";
    AuthenticatorKey["GOOGLE_AUTHENTICATOR"] = "google_otp";
    AuthenticatorKey["SECURITY_QUESTION"] = "security_question";
    AuthenticatorKey["OKTA_VERIFY"] = "okta_verify";
    AuthenticatorKey["WEBAUTHN"] = "webauthn";
})($da481a8e31937f09$export$b420a84de7aa04bd || ($da481a8e31937f09$export$b420a84de7aa04bd = {}));
var $da481a8e31937f09$export$451922195d9391fb;
(function(IdxFeature) {
    IdxFeature["PASSWORD_RECOVERY"] = "recover-password";
    IdxFeature["REGISTRATION"] = "enroll-profile";
    IdxFeature["SOCIAL_IDP"] = "redirect-idp";
    IdxFeature["ACCOUNT_UNLOCK"] = "unlock-account";
})($da481a8e31937f09$export$451922195d9391fb || ($da481a8e31937f09$export$451922195d9391fb = {}));
function $da481a8e31937f09$export$361ab32a8474b3c4(obj) {
    return obj && (obj.key || obj.id);
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ function $26320b9c410af87d$export$1207c686809a84c1() {
    if (typeof window !== 'undefined') return window.console;
    else if (typeof console !== 'undefined') return console;
    else return undefined;
}
function $26320b9c410af87d$export$bbe488cec1edd401() {
    var nativeConsole = $26320b9c410af87d$export$1207c686809a84c1();
    if (nativeConsole && nativeConsole.log) return nativeConsole;
    return {
        log: function() {},
        warn: function() {},
        group: function() {},
        groupEnd: function() {}
    };
}
function $26320b9c410af87d$export$c106dd0671a0fc2d(text) {
    $26320b9c410af87d$export$bbe488cec1edd401().warn('[okta-auth-sdk] WARN: ' + text);
}
function $26320b9c410af87d$export$b680e6b2c82f8c2f(text) {
    $26320b9c410af87d$export$bbe488cec1edd401().warn('[okta-auth-sdk] DEPRECATION: ' + text);
}
function $26320b9c410af87d$export$1f4f33396f74ac7(text, fn) {
    return function() {
        $26320b9c410af87d$export$b680e6b2c82f8c2f(text);
        return fn.apply(null, arguments);
    };
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ function $27ec06d649eea38f$export$2385a24977818dd0(fn, ctx) {
    var additionalArgs = Array.prototype.slice.call(arguments, 2);
    return function() {
        var args = Array.prototype.slice.call(arguments);
        args = additionalArgs.concat(args);
        return fn.apply(ctx, args);
    };
}
function $27ec06d649eea38f$export$8b58be045bf06082() {
    var obj1 = arguments[0];
    var objArray = [].slice.call(arguments, 1);
    objArray.forEach(function(obj) {
        for(var prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop) && obj[prop] !== undefined) obj1[prop] = obj[prop];
    });
    return obj1;
}
function $27ec06d649eea38f$export$1ef1ad6eb7b897a2(obj) {
    var cleaned = {};
    for(var prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        var value = obj[prop];
        if (value !== null && value !== undefined) cleaned[prop] = value;
    }
    return cleaned;
}
function $27ec06d649eea38f$export$9cd59f9826255e47(obj) {
    if (obj) {
        var str = JSON.stringify(obj);
        if (str) return JSON.parse(str);
    }
    return obj;
}
function $27ec06d649eea38f$export$30a06c8d3562193f(obj, ...props) {
    var newobj = {};
    for(var p in obj)if (Object.prototype.hasOwnProperty.call(obj, p) && props.indexOf(p) == -1) newobj[p] = obj[p];
    return $27ec06d649eea38f$export$9cd59f9826255e47(newobj);
}
function $27ec06d649eea38f$export$71aa6c912b956294(collection, searchParams) {
    var c = collection.length;
    while(c--){
        var item = collection[c];
        var found = true;
        for(var prop in searchParams){
            if (!Object.prototype.hasOwnProperty.call(searchParams, prop)) continue;
            if (item[prop] !== searchParams[prop]) {
                found = false;
                break;
            }
        }
        if (found) return item;
    }
}
function $27ec06d649eea38f$export$67e8a86e59c99895(obj, linkName, altName) {
    if (!obj || !obj._links) return;
    var link = $27ec06d649eea38f$export$9cd59f9826255e47(obj._links[linkName]);
    if (link && link.name && altName) {
        if (link.name === altName) return link;
    } else return link;
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ class $9e9b1d88c1d52d57$export$2e2bcd8739ae039 extends Error {
    constructor(message){
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ function $53a4517fb157de9f$export$844ec244b1367d54(obj) {
    return Object.prototype.toString.call(obj) === '[object String]';
}
function $53a4517fb157de9f$export$a6cdc56e425d0d0a(obj) {
    return Object.prototype.toString.call(obj) === '[object Object]';
}
function $53a4517fb157de9f$export$7e4aa119212bc614(obj) {
    return Object.prototype.toString.call(obj) === '[object Number]';
}
function $53a4517fb157de9f$export$f6e2535fb5126e54(fn) {
    return !!fn && ({}).toString.call(fn) === '[object Function]';
}
function $53a4517fb157de9f$export$4369c812aac99591(obj) {
    return obj && obj.finally && typeof obj.finally === 'function';
}


class $7c31c4e6cdd411e2$export$2e2bcd8739ae039 extends (0, $9e9b1d88c1d52d57$export$2e2bcd8739ae039) {
    constructor(scheme, parameters, resp){
        var _a;
        super((_a = parameters.error) !== null && _a !== void 0 ? _a : $7c31c4e6cdd411e2$export$2e2bcd8739ae039.UNKNOWN_ERROR);
        this.name = 'WWWAuthError';
        this.resp = null;
        this.scheme = scheme;
        this.parameters = parameters;
        if (resp) this.resp = resp;
    }
    get error() {
        return this.parameters.error;
    }
    get errorCode() {
        return this.error;
    }
    get error_description() {
        return this.parameters.error_description;
    }
    get errorDescription() {
        return this.error_description;
    }
    get errorSummary() {
        return this.errorDescription;
    }
    get realm() {
        return this.parameters.realm;
    }
    static parseHeader(header) {
        var _a;
        if (!header) return null;
        const regex = /(?:,|, )?([a-zA-Z0-9!#$%&'*+\-.^_`|~]+)=(?:"([a-zA-Z0-9!#$%&'*+\-.,^_`|~ /:]+)"|([a-zA-Z0-9!#$%&'*+\-.^_`|~/:]+))/g;
        const firstSpace = header.indexOf(' ');
        const scheme = header.slice(0, firstSpace);
        const remaining = header.slice(firstSpace + 1);
        const params = {};
        let match;
        while((match = regex.exec(remaining)) !== null)params[match[1]] = (_a = match[2]) !== null && _a !== void 0 ? _a : match[3];
        return new $7c31c4e6cdd411e2$export$2e2bcd8739ae039(scheme, params);
    }
    static getWWWAuthenticateHeader(headers = {}) {
        var _a;
        if ((0, $53a4517fb157de9f$export$f6e2535fb5126e54)(headers === null || headers === void 0 ? void 0 : headers.get)) return headers.get('WWW-Authenticate');
        return (_a = headers['www-authenticate']) !== null && _a !== void 0 ? _a : headers['WWW-Authenticate'];
    }
}
$7c31c4e6cdd411e2$export$2e2bcd8739ae039.UNKNOWN_ERROR = 'UNKNOWN_WWW_AUTH_ERROR';


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ function $c8a11dd749b49091$export$b3fc7ea1bf63bc2b(str) {
    var parts = str.match(/\d+/g), isoTime = Date.UTC(parts[0], parts[1] - 1, parts[2], parts[3], parts[4], parts[5]), isoDate = new Date(isoTime);
    return isoDate.toUTCString();
}
function $c8a11dd749b49091$export$e3d3ee93624b0deb(length) {
    var randomCharset = 'abcdefghijklnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    var random = '';
    for(var c = 0, cl = randomCharset.length; c < length; ++c)random += randomCharset[Math.floor(Math.random() * cl)];
    return random;
}
function $c8a11dd749b49091$export$1391212d75b2ee65(ms) {
    return new Promise(function(resolve) {
        setTimeout(resolve, ms);
    });
}
function $c8a11dd749b49091$export$5f7ca8c53ac3b054(str, delim) {
    const parts = str.split(delim);
    return [
        parts[0],
        parts.splice(1, parts.length).join(delim)
    ];
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ function $47114d36cb1410d5$export$a1cbf2de32a9fd1(url) {
    return /^[a-z][a-z0-9+.-]*:/i.test(url);
}
function $47114d36cb1410d5$export$7895c48e9c019048(url = '', baseUrl) {
    if ($47114d36cb1410d5$export$a1cbf2de32a9fd1(url)) return url;
    baseUrl = $47114d36cb1410d5$export$b6d465111d914331(baseUrl);
    return url[0] === '/' ? `${baseUrl}${url}` : `${baseUrl}/${url}`;
}
function $47114d36cb1410d5$export$4ebdca5513a016fe(url = '', baseUrl) {
    if ($47114d36cb1410d5$export$a1cbf2de32a9fd1(url)) url = url.substring(baseUrl.length);
    return url[0] === '/' ? url : `/${url}`;
}
function $47114d36cb1410d5$export$249cc09c933c4d7a(obj) {
    var str = [];
    if (obj !== null) {
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key) && obj[key] !== undefined && obj[key] !== null) str.push(key + '=' + encodeURIComponent(obj[key]));
    }
    if (str.length) return '?' + str.join('&');
    else return '';
}
function $47114d36cb1410d5$export$b6d465111d914331(path) {
    if (!path) return;
    var trimmed = path.replace(/^\s+|\s+$/gm, '');
    trimmed = trimmed.replace(/\/+$/, '');
    return trimmed;
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
class $93cffcad0e5ff768$export$2e2bcd8739ae039 extends (0, $9e9b1d88c1d52d57$export$2e2bcd8739ae039) {
    constructor(msg, xhr){
        super(msg);
        this.name = 'AuthSdkError';
        this.errorCode = 'INTERNAL';
        this.errorSummary = msg;
        this.errorLink = 'INTERNAL';
        this.errorId = 'INTERNAL';
        this.errorCauses = [];
        if (xhr) this.xhr = xhr;
    }
}


function $49723b489f007b5d$export$9ccd2716e53a229b() {
    return (0, $c8a11dd749b49091$export$e3d3ee93624b0deb)(64);
}
function $49723b489f007b5d$export$3ff59198e2333fc6() {
    return (0, $c8a11dd749b49091$export$e3d3ee93624b0deb)(64);
}
function $49723b489f007b5d$var$getIssuer(sdk, options = {}) {
    const issuer = (0, $47114d36cb1410d5$export$b6d465111d914331)(options.issuer) || sdk.options.issuer;
    return issuer;
}
function $49723b489f007b5d$export$11243677e2baf764(sdk, options = {}) {
    const issuer = $49723b489f007b5d$var$getIssuer(sdk, options);
    const baseUrl = issuer.indexOf('/oauth2') > 0 ? issuer : issuer + '/oauth2';
    return baseUrl;
}
function $49723b489f007b5d$export$bf8eda7d9615a5f0(sdk, options = {}) {
    const issuer = $49723b489f007b5d$var$getIssuer(sdk, options);
    const domain = issuer.split('/oauth2')[0];
    return domain;
}
function $49723b489f007b5d$export$1a398a8b679ebb76(sdk, options) {
    if (arguments.length > 2) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('As of version 3.0, "getOAuthUrls" takes only a single set of options');
    options = options || {};
    var authorizeUrl = (0, $47114d36cb1410d5$export$b6d465111d914331)(options.authorizeUrl) || sdk.options.authorizeUrl;
    var issuer = $49723b489f007b5d$var$getIssuer(sdk, options);
    var userinfoUrl = (0, $47114d36cb1410d5$export$b6d465111d914331)(options.userinfoUrl) || sdk.options.userinfoUrl;
    var tokenUrl = (0, $47114d36cb1410d5$export$b6d465111d914331)(options.tokenUrl) || sdk.options.tokenUrl;
    var logoutUrl = (0, $47114d36cb1410d5$export$b6d465111d914331)(options.logoutUrl) || sdk.options.logoutUrl;
    var revokeUrl = (0, $47114d36cb1410d5$export$b6d465111d914331)(options.revokeUrl) || sdk.options.revokeUrl;
    var baseUrl = $49723b489f007b5d$export$11243677e2baf764(sdk, options);
    authorizeUrl = authorizeUrl || baseUrl + '/v1/authorize';
    userinfoUrl = userinfoUrl || baseUrl + '/v1/userinfo';
    tokenUrl = tokenUrl || baseUrl + '/v1/token';
    revokeUrl = revokeUrl || baseUrl + '/v1/revoke';
    logoutUrl = logoutUrl || baseUrl + '/v1/logout';
    return {
        issuer: issuer,
        authorizeUrl: authorizeUrl,
        userinfoUrl: userinfoUrl,
        tokenUrl: tokenUrl,
        revokeUrl: revokeUrl,
        logoutUrl: logoutUrl
    };
}


function $328526ed047f5aea$export$6fd737cbc709c406(sdk, tokenParams) {
    const issuer = sdk.options.issuer;
    const urls = (0, $49723b489f007b5d$export$1a398a8b679ebb76)(sdk, tokenParams);
    const oauthMeta = {
        issuer: issuer,
        urls: urls,
        clientId: tokenParams.clientId,
        redirectUri: tokenParams.redirectUri,
        responseType: tokenParams.responseType,
        responseMode: tokenParams.responseMode,
        scopes: tokenParams.scopes,
        state: tokenParams.state,
        nonce: tokenParams.nonce,
        ignoreSignature: tokenParams.ignoreSignature,
        acrValues: tokenParams.acrValues,
        extraParams: tokenParams.extraParams
    };
    if (tokenParams.pkce === false) return oauthMeta;
    const pkceMeta = Object.assign(Object.assign({}, oauthMeta), {
        codeVerifier: tokenParams.codeVerifier,
        codeChallengeMethod: tokenParams.codeChallengeMethod,
        codeChallenge: tokenParams.codeChallenge
    });
    return pkceMeta;
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 


var $a2c830cc0d95456a$exports = {};

$parcel$export($a2c830cc0d95456a$exports, "STATE_TOKEN_KEY_NAME", function () { return $a2c830cc0d95456a$export$511e8ed0baecd62c; });
$parcel$export($a2c830cc0d95456a$exports, "DEFAULT_POLLING_DELAY", function () { return $a2c830cc0d95456a$export$626063bdcc4f0775; });
$parcel$export($a2c830cc0d95456a$exports, "IOS_MAX_RETRY_COUNT", function () { return $a2c830cc0d95456a$export$5f5ecd9ae1a04492; });
$parcel$export($a2c830cc0d95456a$exports, "DEFAULT_MAX_CLOCK_SKEW", function () { return $a2c830cc0d95456a$export$a842e30d5ade6c4c; });
$parcel$export($a2c830cc0d95456a$exports, "DEFAULT_CACHE_DURATION", function () { return $a2c830cc0d95456a$export$adfe1f91858943cf; });
$parcel$export($a2c830cc0d95456a$exports, "TOKEN_STORAGE_NAME", function () { return $a2c830cc0d95456a$export$45d1f6fc12799d40; });
$parcel$export($a2c830cc0d95456a$exports, "CACHE_STORAGE_NAME", function () { return $a2c830cc0d95456a$export$e9f2fad0ae10585a; });
$parcel$export($a2c830cc0d95456a$exports, "PKCE_STORAGE_NAME", function () { return $a2c830cc0d95456a$export$48d827fe136140e7; });
$parcel$export($a2c830cc0d95456a$exports, "TRANSACTION_STORAGE_NAME", function () { return $a2c830cc0d95456a$export$8cc5d1fc2dba148d; });
$parcel$export($a2c830cc0d95456a$exports, "SHARED_TRANSACTION_STORAGE_NAME", function () { return $a2c830cc0d95456a$export$b9b27de9edfa5b8; });
$parcel$export($a2c830cc0d95456a$exports, "ORIGINAL_URI_STORAGE_NAME", function () { return $a2c830cc0d95456a$export$ad9943119a111be1; });
$parcel$export($a2c830cc0d95456a$exports, "IDX_RESPONSE_STORAGE_NAME", function () { return $a2c830cc0d95456a$export$48bfce2bad4674d4; });
$parcel$export($a2c830cc0d95456a$exports, "ACCESS_TOKEN_STORAGE_KEY", function () { return $a2c830cc0d95456a$export$c1b1ca3f8a992ce2; });
$parcel$export($a2c830cc0d95456a$exports, "ID_TOKEN_STORAGE_KEY", function () { return $a2c830cc0d95456a$export$b81e057a42e83180; });
$parcel$export($a2c830cc0d95456a$exports, "REFRESH_TOKEN_STORAGE_KEY", function () { return $a2c830cc0d95456a$export$b04ebc518c9597f0; });
$parcel$export($a2c830cc0d95456a$exports, "REFERRER_PATH_STORAGE_KEY", function () { return $a2c830cc0d95456a$export$dc0f85461823eff2; });
$parcel$export($a2c830cc0d95456a$exports, "MIN_VERIFIER_LENGTH", function () { return $a2c830cc0d95456a$export$3429266d17ae1515; });
$parcel$export($a2c830cc0d95456a$exports, "MAX_VERIFIER_LENGTH", function () { return $a2c830cc0d95456a$export$65dcf38d91740c9a; });
$parcel$export($a2c830cc0d95456a$exports, "DEFAULT_CODE_CHALLENGE_METHOD", function () { return $a2c830cc0d95456a$export$ed9a92f7e3f906d8; });
$parcel$export($a2c830cc0d95456a$exports, "IDX_API_VERSION", function () { return $a2c830cc0d95456a$export$3e8b495e17a161fe; });
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ const $a2c830cc0d95456a$export$511e8ed0baecd62c = 'oktaStateToken';
const $a2c830cc0d95456a$export$626063bdcc4f0775 = 500;
const $a2c830cc0d95456a$export$5f5ecd9ae1a04492 = 3;
const $a2c830cc0d95456a$export$a842e30d5ade6c4c = 300;
const $a2c830cc0d95456a$export$adfe1f91858943cf = 86400;
const $a2c830cc0d95456a$export$45d1f6fc12799d40 = 'okta-token-storage';
const $a2c830cc0d95456a$export$e9f2fad0ae10585a = 'okta-cache-storage';
const $a2c830cc0d95456a$export$48d827fe136140e7 = 'okta-pkce-storage';
const $a2c830cc0d95456a$export$8cc5d1fc2dba148d = 'okta-transaction-storage';
const $a2c830cc0d95456a$export$b9b27de9edfa5b8 = 'okta-shared-transaction-storage';
const $a2c830cc0d95456a$export$ad9943119a111be1 = 'okta-original-uri-storage';
const $a2c830cc0d95456a$export$48bfce2bad4674d4 = 'okta-idx-response-storage';
const $a2c830cc0d95456a$export$c1b1ca3f8a992ce2 = 'accessToken';
const $a2c830cc0d95456a$export$b81e057a42e83180 = 'idToken';
const $a2c830cc0d95456a$export$b04ebc518c9597f0 = 'refreshToken';
const $a2c830cc0d95456a$export$dc0f85461823eff2 = 'referrerPath';
const $a2c830cc0d95456a$export$3429266d17ae1515 = 43;
const $a2c830cc0d95456a$export$65dcf38d91740c9a = 128;
const $a2c830cc0d95456a$export$ed9a92f7e3f906d8 = 'S256';
const $a2c830cc0d95456a$export$3e8b495e17a161fe = '1.0.0';


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
class $59fa0e8f490d7132$export$2e2bcd8739ae039 extends (0, $9e9b1d88c1d52d57$export$2e2bcd8739ae039) {
    constructor(err, xhr, meta){
        const message = err.errorSummary;
        super(message);
        this.name = 'AuthApiError';
        this.errorSummary = err.errorSummary;
        this.errorCode = err.errorCode;
        this.errorLink = err.errorLink;
        this.errorId = err.errorId;
        this.errorCauses = err.errorCauses;
        if (xhr) this.xhr = xhr;
        if (meta) this.meta = meta;
    }
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
class $88b6c0f3835294c2$export$2e2bcd8739ae039 extends (0, $9e9b1d88c1d52d57$export$2e2bcd8739ae039) {
    constructor(errorCode, summary, resp){
        super(summary);
        this.resp = null;
        this.name = 'OAuthError';
        this.errorCode = errorCode;
        this.errorSummary = summary;
        this.error = errorCode;
        this.error_description = summary;
        if (resp) this.resp = resp;
    }
}



var $58f01731783bc4a6$exports = {};

$parcel$export($58f01731783bc4a6$exports, "isBrowser", function () { return $58f01731783bc4a6$export$4e09c449d6c407f7; });
$parcel$export($58f01731783bc4a6$exports, "isIE11OrLess", function () { return $58f01731783bc4a6$export$302f5f2c80ff991d; });
$parcel$export($58f01731783bc4a6$exports, "getUserAgent", function () { return $58f01731783bc4a6$export$7935961ef7719cb0; });
$parcel$export($58f01731783bc4a6$exports, "isFingerprintSupported", function () { return $58f01731783bc4a6$export$cfef6ce26ae59877; });
$parcel$export($58f01731783bc4a6$exports, "isPopupPostMessageSupported", function () { return $58f01731783bc4a6$export$11913a9ce5f0afc7; });
$parcel$export($58f01731783bc4a6$exports, "isTokenVerifySupported", function () { return $58f01731783bc4a6$export$9d89ee721af2fd32; });
$parcel$export($58f01731783bc4a6$exports, "hasTextEncoder", function () { return $58f01731783bc4a6$export$930ee512796875bb; });
$parcel$export($58f01731783bc4a6$exports, "isPKCESupported", function () { return $58f01731783bc4a6$export$29eda5462b5ce78d; });
$parcel$export($58f01731783bc4a6$exports, "isHTTPS", function () { return $58f01731783bc4a6$export$ab537f3fcabe7053; });
$parcel$export($58f01731783bc4a6$exports, "isLocalhost", function () { return $58f01731783bc4a6$export$ec8a6426516240fc; });
$parcel$export($58f01731783bc4a6$exports, "isDPoPSupported", function () { return $58f01731783bc4a6$export$ed5ee78d39fe76d7; });
$parcel$export($58f01731783bc4a6$exports, "isIOS", function () { return $58f01731783bc4a6$export$fedb369cb70207f1; });
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ const $58f01731783bc4a6$var$isWindowsPhone = /windows phone|iemobile|wpdesktop/i;
function $58f01731783bc4a6$export$4e09c449d6c407f7() {
    return typeof document !== 'undefined' && typeof window !== 'undefined';
}
function $58f01731783bc4a6$export$302f5f2c80ff991d() {
    if (!$58f01731783bc4a6$export$4e09c449d6c407f7()) return false;
    const documentMode = document.documentMode;
    return !!documentMode && documentMode <= 11;
}
function $58f01731783bc4a6$export$7935961ef7719cb0() {
    return navigator.userAgent;
}
function $58f01731783bc4a6$export$cfef6ce26ae59877() {
    const agent = $58f01731783bc4a6$export$7935961ef7719cb0();
    return agent && !$58f01731783bc4a6$var$isWindowsPhone.test(agent);
}
function $58f01731783bc4a6$export$11913a9ce5f0afc7() {
    if (!$58f01731783bc4a6$export$4e09c449d6c407f7()) return false;
    const documentMode = document.documentMode;
    var isIE8or9 = documentMode && documentMode < 10;
    if (typeof window.postMessage !== 'undefined' && !isIE8or9) return true;
    return false;
}
function $58f01731783bc4a6$var$isWebCryptoSubtleSupported() {
    return typeof crypto !== 'undefined' && crypto !== null && typeof crypto.subtle !== 'undefined' && typeof Uint8Array !== 'undefined';
}
function $58f01731783bc4a6$export$9d89ee721af2fd32() {
    return $58f01731783bc4a6$var$isWebCryptoSubtleSupported();
}
function $58f01731783bc4a6$export$930ee512796875bb() {
    return typeof TextEncoder !== 'undefined';
}
function $58f01731783bc4a6$export$29eda5462b5ce78d() {
    return $58f01731783bc4a6$export$9d89ee721af2fd32() && $58f01731783bc4a6$export$930ee512796875bb();
}
function $58f01731783bc4a6$export$ab537f3fcabe7053() {
    if (!$58f01731783bc4a6$export$4e09c449d6c407f7()) return false;
    return window.location.protocol === 'https:';
}
function $58f01731783bc4a6$export$ec8a6426516240fc() {
    return $58f01731783bc4a6$export$4e09c449d6c407f7() && window.location.hostname === 'localhost';
}
function $58f01731783bc4a6$export$ed5ee78d39fe76d7() {
    return !$58f01731783bc4a6$export$302f5f2c80ff991d() && typeof window.indexedDB !== 'undefined' && $58f01731783bc4a6$export$930ee512796875bb() && $58f01731783bc4a6$var$isWebCryptoSubtleSupported();
}
function $58f01731783bc4a6$export$fedb369cb70207f1() {
    return $58f01731783bc4a6$export$4e09c449d6c407f7() && typeof navigator !== 'undefined' && typeof navigator.userAgent !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}


let $0898b9c80798427c$var$dateDocumentBecameVisible = 0;
let $0898b9c80798427c$var$trackDateDocumentBecameVisible;
if ((0, $58f01731783bc4a6$export$4e09c449d6c407f7)()) {
    $0898b9c80798427c$var$dateDocumentBecameVisible = Date.now();
    $0898b9c80798427c$var$trackDateDocumentBecameVisible = ()=>{
        if (!document.hidden) $0898b9c80798427c$var$dateDocumentBecameVisible = Date.now();
    };
    document.addEventListener('visibilitychange', $0898b9c80798427c$var$trackDateDocumentBecameVisible);
}
const $0898b9c80798427c$var$formatError = (sdk, error)=>{
    var _a;
    if (error instanceof Error) return new (0, $59fa0e8f490d7132$export$2e2bcd8739ae039)({
        errorSummary: error.message
    });
    let resp = error;
    let err;
    let serverErr = {};
    if (resp.responseText && (0, $53a4517fb157de9f$export$844ec244b1367d54)(resp.responseText)) try {
        serverErr = JSON.parse(resp.responseText);
    } catch (e) {
        serverErr = {
            errorSummary: 'Unknown error'
        };
    }
    if (resp.status >= 500) serverErr.errorSummary = 'Unknown error';
    if (sdk.options.transformErrorXHR) resp = sdk.options.transformErrorXHR((0, $27ec06d649eea38f$export$9cd59f9826255e47)(resp));
    const wwwAuthHeader = (_a = (0, $7c31c4e6cdd411e2$export$2e2bcd8739ae039).getWWWAuthenticateHeader(resp === null || resp === void 0 ? void 0 : resp.headers)) !== null && _a !== void 0 ? _a : '';
    if (serverErr.error && serverErr.error_description) err = new (0, $88b6c0f3835294c2$export$2e2bcd8739ae039)(serverErr.error, serverErr.error_description, resp);
    else err = new (0, $59fa0e8f490d7132$export$2e2bcd8739ae039)(serverErr, resp, {
        wwwAuthHeader: wwwAuthHeader
    });
    if (wwwAuthHeader && (resp === null || resp === void 0 ? void 0 : resp.status) >= 400 && (resp === null || resp === void 0 ? void 0 : resp.status) < 500) {
        const wwwAuthErr = (0, $7c31c4e6cdd411e2$export$2e2bcd8739ae039).parseHeader(wwwAuthHeader);
        if (resp.status === 403 && (wwwAuthErr === null || wwwAuthErr === void 0 ? void 0 : wwwAuthErr.error) === 'insufficient_authentication_context') {
            const { max_age: max_age, acr_values: acr_values } = wwwAuthErr.parameters;
            err = new (0, $59fa0e8f490d7132$export$2e2bcd8739ae039)({
                errorSummary: wwwAuthErr.error,
                errorCauses: [
                    {
                        errorSummary: wwwAuthErr.errorDescription
                    }
                ]
            }, resp, Object.assign({
                max_age: +max_age
            }, acr_values && {
                acr_values: acr_values
            }));
        } else if ((wwwAuthErr === null || wwwAuthErr === void 0 ? void 0 : wwwAuthErr.scheme) === 'DPoP') err = wwwAuthErr;
    }
    return err;
};
function $0898b9c80798427c$export$46f383001bf60e04(sdk, options) {
    var _a;
    options = options || {};
    if (sdk.options.httpRequestInterceptors) for (const interceptor of sdk.options.httpRequestInterceptors)interceptor(options);
    var url = options.url, method = options.method, args = options.args, saveAuthnState = options.saveAuthnState, accessToken = options.accessToken, withCredentials = options.withCredentials === true, storageUtil = sdk.options.storageUtil, storage = storageUtil.storage, httpCache = sdk.storageManager.getHttpCache(sdk.options.cookies), pollingIntent = options.pollingIntent, pollDelay = (_a = sdk.options.pollDelay) !== null && _a !== void 0 ? _a : 0;
    if (options.cacheResponse) {
        var cacheContents = httpCache.getStorage();
        var cachedResponse = cacheContents[url];
        if (cachedResponse && Date.now() / 1000 < cachedResponse.expiresAt) return Promise.resolve(cachedResponse.response);
    }
    var oktaUserAgentHeader = sdk._oktaUserAgent.getHttpHeader();
    var headers = Object.assign({
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }, oktaUserAgentHeader);
    Object.assign(headers, sdk.options.headers, options.headers);
    headers = (0, $27ec06d649eea38f$export$1ef1ad6eb7b897a2)(headers);
    if (accessToken && (0, $53a4517fb157de9f$export$844ec244b1367d54)(accessToken)) headers['Authorization'] = 'Bearer ' + accessToken;
    var ajaxOptions = {
        headers: headers,
        data: args || undefined,
        withCredentials: withCredentials
    };
    var err, res, promise;
    if (pollingIntent && (0, $58f01731783bc4a6$export$4e09c449d6c407f7)() && pollDelay > 0) {
        let waitForVisibleAndAwakenDocument;
        let waitForAwakenDocument;
        let recursiveFetch;
        let retryCount = 0;
        waitForAwakenDocument = ()=>{
            const timeSinceDocumentIsVisible = Date.now() - $0898b9c80798427c$var$dateDocumentBecameVisible;
            if (timeSinceDocumentIsVisible < pollDelay) return new Promise((resolve)=>setTimeout(()=>{
                    if (!document.hidden) resolve();
                    else resolve(waitForVisibleAndAwakenDocument());
                }, pollDelay - timeSinceDocumentIsVisible));
            else return Promise.resolve();
        };
        waitForVisibleAndAwakenDocument = ()=>{
            if (document.hidden) {
                let pageVisibilityHandler;
                return new Promise((resolve)=>{
                    pageVisibilityHandler = ()=>{
                        if (!document.hidden) {
                            document.removeEventListener('visibilitychange', pageVisibilityHandler);
                            resolve(waitForAwakenDocument());
                        }
                    };
                    document.addEventListener('visibilitychange', pageVisibilityHandler);
                });
            } else return waitForAwakenDocument();
        };
        const retryableFetch = ()=>{
            return sdk.options.httpRequestClient(method, url, ajaxOptions).catch((err)=>{
                const isNetworkError = (err === null || err === void 0 ? void 0 : err.message) === 'Load failed';
                if (isNetworkError && retryCount < (0, $a2c830cc0d95456a$export$5f5ecd9ae1a04492)) {
                    retryCount++;
                    return recursiveFetch();
                }
                throw err;
            });
        };
        recursiveFetch = ()=>{
            return waitForVisibleAndAwakenDocument().then(retryableFetch);
        };
        promise = recursiveFetch();
    } else promise = sdk.options.httpRequestClient(method, url, ajaxOptions);
    return promise.then(function(resp) {
        res = resp.responseText;
        if (res && (0, $53a4517fb157de9f$export$844ec244b1367d54)(res)) {
            res = JSON.parse(res);
            if (res && typeof res === 'object' && !res.headers) {
                if (Array.isArray(res)) res.forEach((item)=>{
                    item.headers = resp.headers;
                });
                else res.headers = resp.headers;
            }
        }
        if (saveAuthnState) {
            if (!res.stateToken) storage.delete((0, $a2c830cc0d95456a$export$511e8ed0baecd62c));
        }
        if (res && res.stateToken && res.expiresAt) storage.set((0, $a2c830cc0d95456a$export$511e8ed0baecd62c), res.stateToken, res.expiresAt, sdk.options.cookies);
        if (res && options.cacheResponse) httpCache.updateStorage(url, {
            expiresAt: Math.floor(Date.now() / 1000) + (0, $a2c830cc0d95456a$export$adfe1f91858943cf),
            response: res
        });
        return res;
    }).catch(function(resp) {
        err = $0898b9c80798427c$var$formatError(sdk, resp);
        if (err.errorCode === 'E0000011') storage.delete((0, $a2c830cc0d95456a$export$511e8ed0baecd62c));
        throw err;
    });
}
function $0898b9c80798427c$export$3988ae62b71be9a3(sdk, url, options) {
    url = (0, $47114d36cb1410d5$export$a1cbf2de32a9fd1)(url) ? url : sdk.getIssuerOrigin() + url;
    var getOptions = {
        url: url,
        method: 'GET'
    };
    Object.assign(getOptions, options);
    return $0898b9c80798427c$export$46f383001bf60e04(sdk, getOptions);
}
function $0898b9c80798427c$export$299ba2dee77727e9(sdk, url, args, options) {
    url = (0, $47114d36cb1410d5$export$a1cbf2de32a9fd1)(url) ? url : sdk.getIssuerOrigin() + url;
    var postOptions = {
        url: url,
        method: 'POST',
        args: args,
        saveAuthnState: true
    };
    Object.assign(postOptions, options);
    return $0898b9c80798427c$export$46f383001bf60e04(sdk, postOptions);
}


var $a724fe58895ee880$exports = {};
function $a724fe58895ee880$var$E() {
// Keep this empty so it's easier to inherit from
// (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
}
$a724fe58895ee880$var$E.prototype = {
    on: function(name, callback, ctx) {
        var e = this.e || (this.e = {});
        (e[name] || (e[name] = [])).push({
            fn: callback,
            ctx: ctx
        });
        return this;
    },
    once: function(name, callback, ctx) {
        var self = this;
        function listener() {
            self.off(name, listener);
            callback.apply(ctx, arguments);
        }
        listener._ = callback;
        return this.on(name, listener, ctx);
    },
    emit: function(name) {
        var data = [].slice.call(arguments, 1);
        var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
        var i = 0;
        var len = evtArr.length;
        for(i; i < len; i++)evtArr[i].fn.apply(evtArr[i].ctx, data);
        return this;
    },
    off: function(name, callback) {
        var e = this.e || (this.e = {});
        var evts = e[name];
        var liveEvents = [];
        if (evts && callback) {
            for(var i = 0, len = evts.length; i < len; i++)if (evts[i].fn !== callback && evts[i].fn._ !== callback) liveEvents.push(evts[i]);
        }
        // Remove event from queue to prevent memory leak
        // Suggested by https://github.com/lazd
        // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910
        liveEvents.length ? e[name] = liveEvents : delete e[name];
        return this;
    }
};
$a724fe58895ee880$exports = $a724fe58895ee880$var$E;
$a724fe58895ee880$exports.TinyEmitter = $a724fe58895ee880$var$E;


/*! js-cookie v3.0.8 | MIT */ function $ec651a0685591698$var$assign(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source){
            if (key === '__proto__') continue;
            target[key] = source[key];
        }
    }
    return target;
}
var $ec651a0685591698$var$defaultConverter = {
    read: function(value) {
        if (value[0] === '"') value = value.slice(1, -1);
        return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
    },
    write: function(value) {
        return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
    }
};
function $ec651a0685591698$var$init(converter, defaultAttributes) {
    function set(name, value, attributes) {
        if (typeof document === 'undefined') return;
        attributes = $ec651a0685591698$var$assign({}, defaultAttributes, attributes);
        if (typeof attributes.expires === 'number') attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
        if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
        name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
        var stringifiedAttributes = '';
        for(var attributeName in attributes){
            if (!attributes[attributeName]) continue;
            stringifiedAttributes += '; ' + attributeName;
            if (attributes[attributeName] === true) continue;
            // Considers RFC 6265 section 5.2:
            // ...
            // 3.  If the remaining unparsed-attributes contains a %x3B (";")
            //     character:
            // Consume the characters of the unparsed-attributes up to,
            // not including, the first %x3B (";") character.
            // ...
            stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
        }
        return document.cookie = name + '=' + converter.write(value, name) + stringifiedAttributes;
    }
    function get(name) {
        if (typeof document === 'undefined' || arguments.length && !name) return;
        // To prevent the for loop in the first place assign an empty array
        // in case there are no cookies at all.
        var cookies = document.cookie ? document.cookie.split('; ') : [];
        var jar = {};
        for(var i = 0; i < cookies.length; i++){
            var parts = cookies[i].split('=');
            var value = parts.slice(1).join('=');
            try {
                var found = decodeURIComponent(parts[0]);
                if (!(found in jar)) jar[found] = converter.read(value, found);
                if (name === found) break;
            } catch (_e) {
            // Do nothing...
            }
        }
        return name ? jar[name] : jar;
    }
    return Object.create({
        set: set,
        get: get,
        remove: function(name, attributes) {
            set(name, '', $ec651a0685591698$var$assign({}, attributes, {
                expires: -1
            }));
        },
        withAttributes: function(attributes) {
            return $ec651a0685591698$var$init(this.converter, $ec651a0685591698$var$assign({}, this.attributes, attributes));
        },
        withConverter: function(converter) {
            return $ec651a0685591698$var$init($ec651a0685591698$var$assign({}, this.converter, converter), this.attributes);
        }
    }, {
        attributes: {
            value: Object.freeze(defaultAttributes)
        },
        converter: {
            value: Object.freeze(converter)
        }
    });
}
var $ec651a0685591698$export$2e2bcd8739ae039 = $ec651a0685591698$var$init($ec651a0685591698$var$defaultConverter, {
    path: '/'
});


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ var $169337ef2792d6db$export$8b9d26ab11394711;
(function(TokenKind) {
    TokenKind["ACCESS"] = "accessToken";
    TokenKind["ID"] = "idToken";
    TokenKind["REFRESH"] = "refreshToken";
})($169337ef2792d6db$export$8b9d26ab11394711 || ($169337ef2792d6db$export$8b9d26ab11394711 = {}));
function $169337ef2792d6db$export$7c699a821ea811bc(obj) {
    if (obj && (obj.accessToken || obj.idToken || obj.refreshToken) && Array.isArray(obj.scopes)) return true;
    return false;
}
function $169337ef2792d6db$export$3a59e0981c18db3c(obj) {
    return obj && obj.accessToken;
}
function $169337ef2792d6db$export$e183da9b0d22b235(obj) {
    return obj && obj.idToken;
}
function $169337ef2792d6db$export$178a2c036dbf8815(obj) {
    return obj && obj.refreshToken;
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $a8b9237c404681df$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $a8b9237c404681df$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $a8b9237c404681df$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
typeof SuppressedError === "function" && SuppressedError;


async function $e0bbf14d4839e4ff$export$88d345acadfc62dd(authClient, options = {}) {
    const tokenParams = await authClient.token.prepareTokenParams(options);
    const pkceMeta = (0, $328526ed047f5aea$export$6fd737cbc709c406)(authClient, tokenParams);
    let { flow: flow = 'default', withCredentials: withCredentials = true, activationToken: activationToken, recoveryToken: recoveryToken, maxAge: maxAge, acrValues: acrValues } = Object.assign(Object.assign({}, authClient.options), options);
    const meta = Object.assign(Object.assign({}, pkceMeta), {
        flow: flow,
        withCredentials: withCredentials,
        activationToken: activationToken,
        recoveryToken: recoveryToken,
        maxAge: maxAge,
        acrValues: acrValues
    });
    return meta;
}
function $e0bbf14d4839e4ff$export$ca280d73913750db(authClient, options) {
    const savedMeta = $e0bbf14d4839e4ff$export$ee78659ae5675f26(authClient, options);
    if (savedMeta === null || savedMeta === void 0 ? void 0 : savedMeta.interactionHandle) return true;
    return false;
}
function $e0bbf14d4839e4ff$export$ee78659ae5675f26(authClient, options) {
    options = (0, $27ec06d649eea38f$export$1ef1ad6eb7b897a2)(options);
    options = Object.assign(Object.assign({}, authClient.options), options);
    let savedMeta;
    try {
        savedMeta = authClient.transactionManager.load(options);
    } catch (e) {}
    if (!savedMeta) return;
    if ($e0bbf14d4839e4ff$export$e14be23af70c5fd(savedMeta, options)) return savedMeta;
    (0, $26320b9c410af87d$export$c106dd0671a0fc2d)("Saved transaction meta does not match the current configuration. This may indicate that two apps are sharing a storage key.");
}
async function $e0bbf14d4839e4ff$export$701cc743c44cf8ae(authClient, options) {
    options = (0, $27ec06d649eea38f$export$1ef1ad6eb7b897a2)(options);
    options = Object.assign(Object.assign({}, authClient.options), options);
    const validExistingMeta = $e0bbf14d4839e4ff$export$ee78659ae5675f26(authClient, options);
    if (validExistingMeta) return validExistingMeta;
    return $e0bbf14d4839e4ff$export$88d345acadfc62dd(authClient, options);
}
function $e0bbf14d4839e4ff$export$dc27696b235944d6(authClient, meta) {
    authClient.transactionManager.save(meta, {
        muteWarning: true
    });
}
function $e0bbf14d4839e4ff$export$750593bdfc027325(authClient) {
    authClient.transactionManager.clear();
}
function $e0bbf14d4839e4ff$export$e14be23af70c5fd(meta, options = {}) {
    const keys = [
        'issuer',
        'clientId',
        'redirectUri',
        'state',
        'codeChallenge',
        'codeChallengeMethod',
        'activationToken',
        'recoveryToken'
    ];
    if ($e0bbf14d4839e4ff$export$1b2885e9c397dca2(meta, options, keys) === false) return false;
    const { flow: flow } = options;
    if ($e0bbf14d4839e4ff$export$d422e962aa11e537(meta, flow) === false) return false;
    return true;
}
function $e0bbf14d4839e4ff$export$d422e962aa11e537(meta, flow) {
    const shouldValidateFlow = flow && flow !== 'default' && flow !== 'proceed';
    if (shouldValidateFlow) {
        if (flow !== meta.flow) return false;
    }
    return true;
}
function $e0bbf14d4839e4ff$export$1b2885e9c397dca2(meta, options, keys) {
    const mismatch = keys.some((key)=>{
        const value = options[key];
        if (value && value !== meta[key]) return true;
    });
    return !mismatch;
}










function $1ffb78727d57781d$var$getResponse(meta) {
    return {
        meta: meta,
        interactionHandle: meta.interactionHandle,
        state: meta.state
    };
}
async function $1ffb78727d57781d$export$20814a0f9b60f8cf(authClient, options = {}) {
    options = (0, $27ec06d649eea38f$export$1ef1ad6eb7b897a2)(options);
    let meta = (0, $e0bbf14d4839e4ff$export$ee78659ae5675f26)(authClient, options);
    if (meta === null || meta === void 0 ? void 0 : meta.interactionHandle) return $1ffb78727d57781d$var$getResponse(meta);
    meta = await (0, $e0bbf14d4839e4ff$export$88d345acadfc62dd)(authClient, Object.assign(Object.assign({}, meta), options));
    const baseUrl = (0, $49723b489f007b5d$export$11243677e2baf764)(authClient);
    let { clientId: clientId, redirectUri: redirectUri, state: state, scopes: scopes, withCredentials: withCredentials, codeChallenge: codeChallenge, codeChallengeMethod: codeChallengeMethod, activationToken: activationToken, recoveryToken: recoveryToken, maxAge: maxAge, acrValues: acrValues, nonce: nonce } = meta;
    const clientSecret = options.clientSecret || authClient.options.clientSecret;
    withCredentials = withCredentials !== null && withCredentials !== void 0 ? withCredentials : true;
    const url = `${baseUrl}/v1/interact`;
    const params = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
        client_id: clientId,
        scope: scopes.join(' '),
        redirect_uri: redirectUri,
        code_challenge: codeChallenge,
        code_challenge_method: codeChallengeMethod,
        state: state
    }, activationToken && {
        activation_token: activationToken
    }), recoveryToken && {
        recovery_token: recoveryToken
    }), clientSecret && {
        client_secret: clientSecret
    }), maxAge && {
        max_age: maxAge
    }), acrValues && {
        acr_values: acrValues
    }), nonce && {
        nonce: nonce
    });
    const headers = {
        'Content-Type': 'application/x-www-form-urlencoded'
    };
    const resp = await (0, $0898b9c80798427c$export$46f383001bf60e04)(authClient, {
        method: 'POST',
        url: url,
        headers: headers,
        withCredentials: withCredentials,
        args: params
    });
    const interactionHandle = resp.interaction_handle;
    const newMeta = Object.assign(Object.assign({}, meta), {
        interactionHandle: interactionHandle,
        withCredentials: withCredentials,
        state: state,
        scopes: scopes,
        recoveryToken: recoveryToken,
        activationToken: activationToken
    });
    (0, $e0bbf14d4839e4ff$export$dc27696b235944d6)(authClient, newMeta);
    return $1ffb78727d57781d$var$getResponse(newMeta);
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ const $ba8ac98eeeef9456$var$isFieldMutable = function isFieldMutable(field) {
    return field.mutable !== false;
};
const $ba8ac98eeeef9456$var$divideSingleActionParamsByMutability = function divideSingleActionParamsByMutability(action) {
    var _a, _b;
    const defaultParamsForAction = {};
    const neededParamsForAction = [];
    const immutableParamsForAction = {};
    if (!action.value) {
        neededParamsForAction.push(action);
        return {
            defaultParamsForAction: defaultParamsForAction,
            neededParamsForAction: neededParamsForAction,
            immutableParamsForAction: immutableParamsForAction
        };
    }
    for (let field of action.value)if ($ba8ac98eeeef9456$var$isFieldMutable(field)) {
        neededParamsForAction.push(field);
        if ((_a = field.value) !== null && _a !== void 0 ? _a : false) defaultParamsForAction[field.name] = field.value;
    } else immutableParamsForAction[field.name] = (_b = field.value) !== null && _b !== void 0 ? _b : '';
    return {
        defaultParamsForAction: defaultParamsForAction,
        neededParamsForAction: neededParamsForAction,
        immutableParamsForAction: immutableParamsForAction
    };
};
const $ba8ac98eeeef9456$export$4c3d503ea1c11b10 = function divideActionParamsByMutability(actionList) {
    actionList = Array.isArray(actionList) ? actionList : [
        actionList
    ];
    const neededParams = [];
    const defaultParams = {};
    const immutableParams = {};
    for (let action of actionList){
        const { defaultParamsForAction: defaultParamsForAction, neededParamsForAction: neededParamsForAction, immutableParamsForAction: immutableParamsForAction } = $ba8ac98eeeef9456$var$divideSingleActionParamsByMutability(action);
        neededParams.push(neededParamsForAction);
        defaultParams[action.name] = defaultParamsForAction;
        immutableParams[action.name] = immutableParamsForAction;
    }
    return {
        defaultParams: defaultParams,
        neededParams: neededParams,
        immutableParams: immutableParams
    };
};



const $70cd62b0e976c7db$var$generateDirectFetch = function generateDirectFetch(authClient, { actionDefinition: actionDefinition, defaultParamsForAction: defaultParamsForAction = {}, immutableParamsForAction: immutableParamsForAction = {}, toPersist: toPersist = {} }) {
    const target = actionDefinition.href;
    return async function(params = {}) {
        var _a, _b;
        const headers = {
            'Content-Type': 'application/json',
            'Accept': actionDefinition.accepts || 'application/ion+json'
        };
        const body = JSON.stringify(Object.assign(Object.assign(Object.assign({}, defaultParamsForAction), params), immutableParamsForAction));
        try {
            const options = {
                url: target,
                method: actionDefinition.method,
                headers: headers,
                args: body,
                withCredentials: (_a = toPersist === null || toPersist === void 0 ? void 0 : toPersist.withCredentials) !== null && _a !== void 0 ? _a : true
            };
            const isPolling = actionDefinition.name === 'poll' || ((_b = actionDefinition.name) === null || _b === void 0 ? void 0 : _b.endsWith('-poll'));
            if (isPolling) options.pollingIntent = true;
            const response = await (0, $0898b9c80798427c$export$46f383001bf60e04)(authClient, options);
            return authClient.idx.makeIdxResponse(Object.assign({}, response), toPersist, true);
        } catch (err) {
            if (!(err instanceof (0, $59fa0e8f490d7132$export$2e2bcd8739ae039)) || !(err === null || err === void 0 ? void 0 : err.xhr)) throw err;
            const response = err.xhr;
            const payload = response.responseJSON || JSON.parse(response.responseText);
            const wwwAuthHeader = response.headers['WWW-Authenticate'] || response.headers['www-authenticate'];
            const idxResponse = authClient.idx.makeIdxResponse(Object.assign({}, payload), toPersist, false);
            if (response.status === 401 && wwwAuthHeader === 'Oktadevicejwt realm="Okta Device"') idxResponse.stepUp = true;
            return idxResponse;
        }
    };
};
const $70cd62b0e976c7db$export$2e2bcd8739ae039 = function generateIdxAction(authClient, actionDefinition, toPersist) {
    const generator = $70cd62b0e976c7db$var$generateDirectFetch;
    const { defaultParams: defaultParams, neededParams: neededParams, immutableParams: immutableParams } = (0, $ba8ac98eeeef9456$export$4c3d503ea1c11b10)(actionDefinition);
    const action = generator(authClient, {
        actionDefinition: actionDefinition,
        defaultParamsForAction: defaultParams[actionDefinition.name],
        immutableParamsForAction: immutableParams[actionDefinition.name],
        toPersist: toPersist
    });
    action.neededParams = neededParams;
    return action;
};


const $90af8aae18b44d15$export$4238c1f37c3119f5 = function generateRemediationFunctions(authClient, remediationValue, toPersist = {}) {
    return remediationValue.reduce((obj, remediation)=>Object.assign(Object.assign({}, obj), {
            [remediation.name]: (0, $70cd62b0e976c7db$export$2e2bcd8739ae039)(authClient, remediation, toPersist)
        }), {});
};



/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ const $4f7cc53870dc74fb$var$jsonpathRegex = /\$?(?<step>\w+)|(?:\[(?<index>\d+)\])/g;
function $4f7cc53870dc74fb$export$2562421ccea4d9dd({ path: path, json: json }) {
    var _a, _b, _c;
    const steps = [];
    let match;
    while((match = $4f7cc53870dc74fb$var$jsonpathRegex.exec(path)) !== null){
        const step = (_b = (_a = match === null || match === void 0 ? void 0 : match.groups) === null || _a === void 0 ? void 0 : _a.step) !== null && _b !== void 0 ? _b : (_c = match === null || match === void 0 ? void 0 : match.groups) === null || _c === void 0 ? void 0 : _c.index;
        if (step) steps.push(step);
    }
    if (steps.length < 1) return undefined;
    const lastStep = steps.pop();
    let curr = json;
    for (const step of steps)if (Object.prototype.hasOwnProperty.call(curr, step)) {
        if (typeof curr[step] !== 'object') return undefined;
        curr = curr[step];
    }
    return curr[lastStep];
}




const $76764a9358a773a2$var$SKIP_FIELDS = {
    'remediation': true,
    'context': true
};
const $76764a9358a773a2$export$5737e7831fcbdfb8 = function parseNonRemediations(authClient, idxResponse, toPersist = {}) {
    const actions = {};
    const context = {};
    Object.keys(idxResponse).filter((field)=>!$76764a9358a773a2$var$SKIP_FIELDS[field]).forEach((field)=>{
        const fieldIsObject = typeof idxResponse[field] === 'object' && !!idxResponse[field];
        if (!fieldIsObject) {
            context[field] = idxResponse[field];
            return;
        }
        if (idxResponse[field].rel) {
            actions[idxResponse[field].name] = (0, $70cd62b0e976c7db$export$2e2bcd8739ae039)(authClient, idxResponse[field], toPersist);
            return;
        }
        const _a = idxResponse[field], { value: fieldValue, type: type } = _a, info = (0, $a8b9237c404681df$export$3c9a16f847548506)(_a, [
            "value",
            "type"
        ]);
        context[field] = Object.assign({
            type: type
        }, info);
        if (type !== 'object') {
            context[field].value = fieldValue;
            return;
        }
        context[field].value = {};
        Object.entries(fieldValue).forEach(([subField, value])=>{
            if (value.rel) actions[`${field}-${subField.name || subField}`] = (0, $70cd62b0e976c7db$export$2e2bcd8739ae039)(authClient, value, toPersist);
            else context[field].value[subField] = value;
        });
    });
    return {
        context: context,
        actions: actions
    };
};
const $76764a9358a773a2$var$expandRelatesTo = (idxResponse, value)=>{
    Object.keys(value).forEach((k)=>{
        if (k === 'relatesTo') {
            const query = Array.isArray(value[k]) ? value[k][0] : value[k];
            if (typeof query === 'string') {
                const result = (0, $4f7cc53870dc74fb$export$2562421ccea4d9dd)({
                    path: query,
                    json: idxResponse
                });
                if (result) {
                    value[k] = result;
                    return;
                } else throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)(`Cannot resolve relatesTo: ${query}`);
            }
        }
        if (Array.isArray(value[k])) value[k].forEach((innerValue)=>$76764a9358a773a2$var$expandRelatesTo(idxResponse, innerValue));
    });
};
const $76764a9358a773a2$var$convertRemediationAction = (authClient, remediation, toPersist)=>{
    if (remediation.rel) {
        const remediationActions = (0, $90af8aae18b44d15$export$4238c1f37c3119f5)(authClient, [
            remediation
        ], toPersist);
        const actionFn = remediationActions[remediation.name];
        return Object.assign(Object.assign({}, remediation), {
            action: actionFn
        });
    }
    return remediation;
};
const $76764a9358a773a2$export$7da4ffbe52143665 = function parseIdxResponse(authClient, idxResponse, toPersist = {}) {
    var _a;
    const remediationData = ((_a = idxResponse.remediation) === null || _a === void 0 ? void 0 : _a.value) || [];
    remediationData.forEach((remediation)=>{
        var _a;
        if (remediation.name === 'launch-authenticator' && ((_a = remediation === null || remediation === void 0 ? void 0 : remediation.relatesTo) === null || _a === void 0 ? void 0 : _a[0]) === 'authenticatorChallenge' && !(idxResponse === null || idxResponse === void 0 ? void 0 : idxResponse.authenticatorChallenge)) {
            delete remediation.relatesTo;
            return;
        }
        return $76764a9358a773a2$var$expandRelatesTo(idxResponse, remediation);
    });
    const remediations = remediationData.map((remediation)=>$76764a9358a773a2$var$convertRemediationAction(authClient, remediation, toPersist));
    const { context: context, actions: actions } = $76764a9358a773a2$export$5737e7831fcbdfb8(authClient, idxResponse, toPersist);
    return {
        remediations: remediations,
        context: context,
        actions: actions
    };
};


function $09d99a21527b7bc0$export$67f6ec95030789e9(authClient, idxResponse, toPersist, requestDidSucceed) {
    var _a, _b, _c;
    const rawIdxResponse = idxResponse;
    const { remediations: remediations, context: context, actions: actions } = (0, $76764a9358a773a2$export$7da4ffbe52143665)(authClient, idxResponse, toPersist);
    const neededToProceed = [
        ...remediations
    ];
    const proceed = async function(remediationChoice, paramsFromUser = {}) {
        const remediationChoiceObject = remediations.find((remediation)=>remediation.name === remediationChoice);
        if (!remediationChoiceObject) return Promise.reject(`Unknown remediation choice: [${remediationChoice}]`);
        const actionFn = remediationChoiceObject.action;
        if (typeof actionFn !== 'function') return Promise.reject(`Current remediation cannot make form submit action: [${remediationChoice}]`);
        return remediationChoiceObject.action(paramsFromUser);
    };
    const findCode = (item)=>item.name === 'interaction_code';
    const interactionCode = (_c = (_b = (_a = rawIdxResponse.successWithInteractionCode) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.find(findCode)) === null || _c === void 0 ? void 0 : _c.value;
    return {
        proceed: proceed,
        neededToProceed: neededToProceed,
        actions: actions,
        context: context,
        rawIdxState: rawIdxResponse,
        interactionCode: interactionCode,
        toPersist: toPersist,
        requestDidSucceed: requestDidSucceed
    };
}


var $a8aa2d002071e206$export$2e2bcd8739ae039 = {
    makeIdxState: $09d99a21527b7bc0$export$67f6ec95030789e9
};


const $baf0710ab57b8a95$export$7ba1824e1085df61 = function parsersForVersion(version) {
    switch(version){
        case '1.0.0':
            return 0, $a8aa2d002071e206$export$2e2bcd8739ae039;
        case undefined:
        case null:
            throw new Error('Api version is required');
        default:
            throw new Error(`Unknown api version: ${version}.  Use an exact semver version.`);
    }
};
function $baf0710ab57b8a95$export$dab03d97af55f77c(version) {
    if (!version) throw new Error('version is required');
    const cleanVersion = (version !== null && version !== void 0 ? version : '').replace(/[^0-9a-zA-Z._-]/, '');
    if (cleanVersion !== version || !version) throw new Error('invalid version supplied - version is required and uses semver syntax');
    $baf0710ab57b8a95$export$7ba1824e1085df61(version);
}
function $baf0710ab57b8a95$export$67f6ec95030789e9(authClient, rawIdxResponse, toPersist, requestDidSucceed) {
    var _a;
    const version = (_a = rawIdxResponse === null || rawIdxResponse === void 0 ? void 0 : rawIdxResponse.version) !== null && _a !== void 0 ? _a : (0, $a2c830cc0d95456a$export$3e8b495e17a161fe);
    $baf0710ab57b8a95$export$dab03d97af55f77c(version);
    const { makeIdxState: makeIdxState } = $baf0710ab57b8a95$export$7ba1824e1085df61(version);
    return makeIdxState(authClient, rawIdxResponse, toPersist, requestDidSucceed);
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ function $2a76e8c9476cb869$export$e440ed50f1b21dd3(obj) {
    return obj && obj.version;
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 


function $b748049c070ffea6$export$4fe744aeb810d543(obj) {
    return obj instanceof (0, $59fa0e8f490d7132$export$2e2bcd8739ae039);
}
function $b748049c070ffea6$export$65ac14d4981b453f(obj) {
    return obj instanceof (0, $88b6c0f3835294c2$export$2e2bcd8739ae039);
}
function $b748049c070ffea6$export$380e188e91bd13a1(obj) {
    return obj instanceof (0, $7c31c4e6cdd411e2$export$2e2bcd8739ae039);
}









async function $ed622bb52a9c4e67$export$3b41a86e379f8f15(authClient, options = {}) {
    var _a;
    let rawIdxResponse;
    let requestDidSucceed;
    const savedIdxResponse = authClient.transactionManager.loadIdxResponse(options);
    if (savedIdxResponse) {
        rawIdxResponse = savedIdxResponse.rawIdxResponse;
        requestDidSucceed = savedIdxResponse.requestDidSucceed;
    }
    if (!rawIdxResponse) {
        const version = options.version || (0, $a2c830cc0d95456a$export$3e8b495e17a161fe);
        const domain = (0, $49723b489f007b5d$export$bf8eda7d9615a5f0)(authClient);
        const { interactionHandle: interactionHandle, stateHandle: stateHandle } = options;
        const withCredentials = (_a = options.withCredentials) !== null && _a !== void 0 ? _a : true;
        try {
            requestDidSucceed = true;
            (0, $baf0710ab57b8a95$export$dab03d97af55f77c)(version);
            const url = `${domain}/idp/idx/introspect`;
            const body = stateHandle ? {
                stateToken: stateHandle
            } : {
                interactionHandle: interactionHandle
            };
            const headers = {
                'Content-Type': `application/ion+json; okta-version=${version}`,
                Accept: `application/ion+json; okta-version=${version}`
            };
            rawIdxResponse = await (0, $0898b9c80798427c$export$46f383001bf60e04)(authClient, {
                method: 'POST',
                url: url,
                headers: headers,
                withCredentials: withCredentials,
                args: body
            });
        } catch (err) {
            if ((0, $b748049c070ffea6$export$4fe744aeb810d543)(err) && err.xhr && (0, $2a76e8c9476cb869$export$e440ed50f1b21dd3)(err.xhr.responseJSON)) {
                rawIdxResponse = err.xhr.responseJSON;
                requestDidSucceed = false;
            } else throw err;
        }
    }
    const { withCredentials: withCredentials } = options;
    return (0, $baf0710ab57b8a95$export$67f6ec95030789e9)(authClient, rawIdxResponse, {
        withCredentials: withCredentials
    }, requestDidSucceed);
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ function $b54e34bc1d750716$export$b6327bf2935d9246(idxRemediation) {
    var _a;
    return (_a = idxRemediation.value) === null || _a === void 0 ? void 0 : _a.map((r)=>r.name);
}
function $b54e34bc1d750716$export$fa24fba53a75381b(idxRemediation) {
    var _a;
    return (_a = idxRemediation.value) === null || _a === void 0 ? void 0 : _a.reduce((required, cur)=>{
        if (cur.required) required.push(cur.name);
        return required;
    }, []);
}
function $b54e34bc1d750716$export$348afa8c9ff47183(str) {
    return str.charAt(0).toUpperCase() + str.substring(1);
}
function $b54e34bc1d750716$export$2c4be893a02ba700(remediation) {
    return remediation.value.find(({ name: name })=>name === 'authenticator');
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
function $100b48d821947e2f$export$a524de6c5d3a7a61(incoming) {
    let authenticator;
    if ((0, $da481a8e31937f09$export$361ab32a8474b3c4)(incoming)) authenticator = incoming;
    else if (typeof incoming === 'string') authenticator = {
        key: incoming
    };
    else throw new Error('Invalid format for authenticator');
    return authenticator;
}
function $100b48d821947e2f$export$36b7fa650feebb56(auth1, auth2) {
    if (!auth1 || !auth2) return false;
    if (auth1.id && auth2.id) return auth1.id === auth2.id;
    if (auth1.key && auth2.key) return auth1.key === auth2.key;
    return false;
}
function $100b48d821947e2f$export$fafdedfcbb7d2691(authenticators, options) {
    let option;
    for (let authenticator of authenticators){
        option = options.find(({ relatesTo: relatesTo })=>relatesTo.key && relatesTo.key === authenticator.key);
        if (option) break;
    }
    return option;
}


class $c5de53213e27f939$export$8ab7a5763733596 {
    constructor(remediation, values = {}, options = {}){
        this.values = Object.assign({}, values);
        this.options = Object.assign({}, options);
        this.formatAuthenticators();
        this.remediation = remediation;
    }
    formatAuthenticators() {
        this.values.authenticators = this.values.authenticators || [];
        this.values.authenticators = this.values.authenticators.map((authenticator)=>{
            return (0, $100b48d821947e2f$export$a524de6c5d3a7a61)(authenticator);
        });
        if (this.values.authenticator) {
            const authenticator = (0, $100b48d821947e2f$export$a524de6c5d3a7a61)(this.values.authenticator);
            const hasAuthenticatorInList = this.values.authenticators.some((existing)=>{
                return (0, $100b48d821947e2f$export$36b7fa650feebb56)(authenticator, existing);
            });
            if (!hasAuthenticatorInList) this.values.authenticators.push(authenticator);
        }
        this.values.authenticatorsData = this.values.authenticators.reduce((acc, authenticator)=>{
            if (typeof authenticator === 'object' && Object.keys(authenticator).length > 1) acc.push(authenticator);
            return acc;
        }, this.values.authenticatorsData || []);
    }
    getName() {
        return this.remediation.name;
    }
    canRemediate(context) {
        const required = (0, $b54e34bc1d750716$export$fa24fba53a75381b)(this.remediation);
        const needed = required.find((key)=>!this.hasData(key));
        if (needed) return false;
        return true;
    }
    getData(key) {
        if (!key) {
            let allValues = (0, $b54e34bc1d750716$export$b6327bf2935d9246)(this.remediation);
            let res = allValues.reduce((data, key)=>{
                data[key] = this.getData(key);
                return data;
            }, {});
            return res;
        }
        if (typeof this[`map${(0, $b54e34bc1d750716$export$348afa8c9ff47183)(key)}`] === 'function') {
            const val = this[`map${(0, $b54e34bc1d750716$export$348afa8c9ff47183)(key)}`](this.remediation.value.find(({ name: name })=>name === key));
            if (val) return val;
        }
        if (this.map && this.map[key]) {
            const entry = this.map[key];
            for(let i = 0; i < entry.length; i++){
                let val = this.values[entry[i]];
                if (val) return val;
            }
        }
        return this.values[key];
    }
    hasData(key) {
        return !!this.getData(key);
    }
    getNextStep(_authClient, _context) {
        const name = this.getName();
        const inputs = this.getInputs();
        const authenticator = this.getAuthenticator();
        const type = authenticator === null || authenticator === void 0 ? void 0 : authenticator.type;
        return Object.assign(Object.assign({
            name: name,
            inputs: inputs
        }, type && {
            type: type
        }), authenticator && {
            authenticator: authenticator
        });
    }
    getInputs() {
        const inputs = [];
        const inputsFromRemediation = this.remediation.value || [];
        inputsFromRemediation.forEach((inputFromRemediation)=>{
            let input;
            let { name: name, type: type, visible: visible, messages: messages } = inputFromRemediation;
            if (visible === false) return;
            if (typeof this[`getInput${(0, $b54e34bc1d750716$export$348afa8c9ff47183)(name)}`] === 'function') input = this[`getInput${(0, $b54e34bc1d750716$export$348afa8c9ff47183)(name)}`](inputFromRemediation);
            else if (type !== 'object') {
                let alias;
                const aliases = (this.map ? this.map[name] : null) || [];
                if (aliases.length === 1) alias = aliases[0];
                else alias = aliases.find((name)=>Object.keys(this.values).includes(name));
                if (alias) input = Object.assign(Object.assign({}, inputFromRemediation), {
                    name: alias
                });
            }
            if (!input) input = inputFromRemediation;
            if (Array.isArray(input)) input.forEach((i)=>inputs.push(i));
            else {
                if (messages) input.messages = messages;
                inputs.push(input);
            }
        });
        return inputs;
    }
    static getMessages(remediation) {
        var _a, _b;
        if (!remediation.value) return;
        return (_b = (_a = remediation.value[0]) === null || _a === void 0 ? void 0 : _a.form) === null || _b === void 0 ? void 0 : _b.value.reduce((messages, field)=>{
            if (field.messages) messages = [
                ...messages,
                ...field.messages.value
            ];
            return messages;
        }, []);
    }
    getValuesAfterProceed() {
        const inputsFromRemediation = this.remediation.value || [];
        const inputsFromRemediator = this.getInputs();
        const inputs = [
            ...inputsFromRemediation,
            ...inputsFromRemediator
        ];
        for (const input of inputs)delete this.values[input.name];
        return this.values;
    }
    getAuthenticator() {
        var _a, _b;
        const relatesTo = (_a = this.remediation.relatesTo) === null || _a === void 0 ? void 0 : _a.value;
        if (!relatesTo) return;
        const authenticatorFromRemediation = (0, $b54e34bc1d750716$export$2c4be893a02ba700)(this.remediation);
        if (!authenticatorFromRemediation) return relatesTo;
        const id = authenticatorFromRemediation.form.value.find(({ name: name })=>name === 'id').value;
        const enrollmentId = (_b = authenticatorFromRemediation.form.value.find(({ name: name })=>name === 'enrollmentId')) === null || _b === void 0 ? void 0 : _b.value;
        return Object.assign(Object.assign({}, relatesTo), {
            id: id,
            enrollmentId: enrollmentId
        });
    }
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ class $abd51fc7602efb5a$export$3d7a1e8452f884f3 {
    constructor(authenticator){
        this.meta = authenticator;
    }
}


class $12059218ce3eb666$export$c1fb04481f1165ad extends (0, $abd51fc7602efb5a$export$3d7a1e8452f884f3) {
    canVerify(values) {
        return !!(values.credentials || values.verificationCode || values.otp);
    }
    mapCredentials(values) {
        const { credentials: credentials, verificationCode: verificationCode, otp: otp } = values;
        if (!credentials && !verificationCode && !otp) return;
        return credentials || {
            passcode: verificationCode || otp
        };
    }
    getInputs(idxRemediationValue) {
        var _a;
        return Object.assign(Object.assign({}, (_a = idxRemediationValue.form) === null || _a === void 0 ? void 0 : _a.value[0]), {
            name: 'verificationCode',
            type: 'string',
            required: idxRemediationValue.required
        });
    }
}


class $e06ac1fcf91ce25e$export$47aa57e0362d0da8 extends (0, $12059218ce3eb666$export$c1fb04481f1165ad) {
    mapCredentials(values) {
        const { verificationCode: verificationCode } = values;
        if (!verificationCode) return;
        return {
            totp: verificationCode
        };
    }
}



/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
class $14302ac00b4f0bba$export$df19360b11c3a265 extends (0, $abd51fc7602efb5a$export$3d7a1e8452f884f3) {
    canVerify(values) {
        return !!(values.credentials || values.password || values.passcode);
    }
    mapCredentials(values) {
        const { credentials: credentials, password: password, passcode: passcode, revokeSessions: revokeSessions } = values;
        if (!credentials && !password && !passcode) return;
        return credentials || {
            passcode: passcode || password,
            revokeSessions: revokeSessions
        };
    }
    getInputs(idxRemediationValue) {
        var _a, _b;
        const inputs = [
            Object.assign(Object.assign({}, (_a = idxRemediationValue.form) === null || _a === void 0 ? void 0 : _a.value[0]), {
                name: 'password',
                type: 'string',
                required: idxRemediationValue.required
            })
        ];
        const revokeSessions = (_b = idxRemediationValue.form) === null || _b === void 0 ? void 0 : _b.value.find((input)=>input.name === 'revokeSessions');
        if (revokeSessions) inputs.push({
            name: 'revokeSessions',
            type: 'boolean',
            label: 'Sign me out of all other devices',
            required: false
        });
        return inputs;
    }
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
class $a87f07d463e4a907$export$11ad7007318599fd extends (0, $abd51fc7602efb5a$export$3d7a1e8452f884f3) {
    canVerify(values) {
        const { credentials: credentials } = values;
        if (credentials && credentials.questionKey && credentials.answer) return true;
        const { questionKey: questionKey, question: question, answer: answer } = values;
        return !!(questionKey && answer) || !!(question && answer);
    }
    mapCredentials(values) {
        const { questionKey: questionKey, question: question, answer: answer } = values;
        if (!answer || !questionKey && !question) return;
        return {
            questionKey: question ? 'custom' : questionKey,
            question: question,
            answer: answer
        };
    }
    getInputs() {
        return [
            {
                name: 'questionKey',
                type: 'string',
                required: true
            },
            {
                name: 'question',
                type: 'string',
                label: 'Create a security question'
            },
            {
                name: 'answer',
                type: 'string',
                label: 'Answer',
                required: true
            }
        ];
    }
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
class $134e589cbb9302ef$export$ada92dcbb68d964c extends (0, $abd51fc7602efb5a$export$3d7a1e8452f884f3) {
    canVerify(values) {
        const { credentials: credentials } = values;
        if (credentials && credentials.answer) return true;
        const { answer: answer } = values;
        return !!answer;
    }
    mapCredentials(values) {
        const { answer: answer } = values;
        if (!answer) return;
        return {
            questionKey: this.meta.contextualData.enrolledQuestion.questionKey,
            answer: answer
        };
    }
    getInputs() {
        return [
            {
                name: 'answer',
                type: 'string',
                label: 'Answer',
                required: true
            }
        ];
    }
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
class $c8123832fcb70827$export$780044389d0a529 extends (0, $abd51fc7602efb5a$export$3d7a1e8452f884f3) {
    canVerify(values) {
        const { credentials: credentials } = values;
        const obj = credentials || values;
        const { clientData: clientData, attestation: attestation } = obj;
        return !!(clientData && attestation);
    }
    mapCredentials(values) {
        const { credentials: credentials, clientData: clientData, attestation: attestation, transports: transports } = values;
        if (!credentials && !clientData && !attestation) return;
        return credentials || Object.assign({
            clientData: clientData,
            attestation: attestation
        }, transports && {
            transports: transports
        });
    }
    getInputs() {
        return [
            {
                name: 'clientData',
                type: 'string',
                required: true,
                visible: false,
                label: 'Client Data'
            },
            {
                name: 'attestation',
                type: 'string',
                required: true,
                visible: false,
                label: 'Attestation'
            }
        ];
    }
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
class $ec63b106178bc737$export$18c254bb3b1e28b8 extends (0, $abd51fc7602efb5a$export$3d7a1e8452f884f3) {
    canVerify(values) {
        const { credentials: credentials } = values;
        const obj = credentials || values;
        const { clientData: clientData, authenticatorData: authenticatorData, signatureData: signatureData } = obj;
        return !!(clientData && authenticatorData && signatureData);
    }
    mapCredentials(values) {
        const { credentials: credentials, authenticatorData: authenticatorData, clientData: clientData, signatureData: signatureData } = values;
        if (!credentials && !authenticatorData && !clientData && !signatureData) return;
        return credentials || {
            authenticatorData: authenticatorData,
            clientData: clientData,
            signatureData: signatureData
        };
    }
    getInputs() {
        return [
            {
                name: 'authenticatorData',
                type: 'string',
                label: 'Authenticator Data',
                required: true,
                visible: false
            },
            {
                name: 'clientData',
                type: 'string',
                label: 'Client Data',
                required: true,
                visible: false
            },
            {
                name: 'signatureData',
                type: 'string',
                label: 'Signature Data',
                required: true,
                visible: false
            }
        ];
    }
}



function $f16529c73f42824e$export$2611727d0d25c416(remediation) {
    var _a, _b;
    const relatesTo = remediation.relatesTo;
    const value = (relatesTo === null || relatesTo === void 0 ? void 0 : relatesTo.value) || {};
    switch(value.key){
        case (0, $da481a8e31937f09$export$b420a84de7aa04bd).OKTA_PASSWORD:
            return new (0, $14302ac00b4f0bba$export$df19360b11c3a265)(value);
        case (0, $da481a8e31937f09$export$b420a84de7aa04bd).SECURITY_QUESTION:
            if ((_a = value.contextualData) === null || _a === void 0 ? void 0 : _a.enrolledQuestion) return new (0, $134e589cbb9302ef$export$ada92dcbb68d964c)(value);
            else return new (0, $a87f07d463e4a907$export$11ad7007318599fd)(value);
        case (0, $da481a8e31937f09$export$b420a84de7aa04bd).OKTA_VERIFY:
            return new (0, $e06ac1fcf91ce25e$export$47aa57e0362d0da8)(value);
        case (0, $da481a8e31937f09$export$b420a84de7aa04bd).WEBAUTHN:
            if ((_b = value.contextualData) === null || _b === void 0 ? void 0 : _b.challengeData) return new (0, $ec63b106178bc737$export$18c254bb3b1e28b8)(value);
            else return new (0, $c8123832fcb70827$export$780044389d0a529)(value);
        default:
            return new (0, $12059218ce3eb666$export$c1fb04481f1165ad)(value);
    }
}


class $fffd8f7f491eaad6$export$e3100d946b350c5 extends (0, $c5de53213e27f939$export$8ab7a5763733596) {
    constructor(remediation, values = {}){
        super(remediation, values);
        this.authenticator = (0, $f16529c73f42824e$export$2611727d0d25c416)(remediation);
    }
    getNextStep(authClient, context) {
        var _a;
        const nextStep = super.getNextStep(authClient, context);
        const authenticatorEnrollments = (_a = context === null || context === void 0 ? void 0 : context.authenticatorEnrollments) === null || _a === void 0 ? void 0 : _a.value;
        return Object.assign(Object.assign({}, nextStep), {
            authenticatorEnrollments: authenticatorEnrollments
        });
    }
    canRemediate() {
        return this.authenticator.canVerify(this.values);
    }
    mapCredentials() {
        return this.authenticator.mapCredentials(this.values);
    }
    getInputCredentials(input) {
        return this.authenticator.getInputs(input);
    }
    getValuesAfterProceed() {
        this.values = super.getValuesAfterProceed();
        let trimmedValues = Object.keys(this.values).filter((valueKey)=>valueKey !== 'credentials');
        return trimmedValues.reduce((values, valueKey)=>Object.assign(Object.assign({}, values), {
                [valueKey]: this.values[valueKey]
            }), {});
    }
}


class $31a06cf5017088f6$export$f7157015cf11193f extends (0, $fffd8f7f491eaad6$export$e3100d946b350c5) {
}
$31a06cf5017088f6$export$f7157015cf11193f.remediationName = 'enroll-authenticator';


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
class $424154aafceb9352$export$2e21ed88eacb421f extends (0, $c5de53213e27f939$export$8ab7a5763733596) {
    canRemediate() {
        return !!this.values.startPolling || this.options.step === 'enroll-poll';
    }
    getNextStep(authClient, context) {
        const common = super.getNextStep(authClient, context);
        let authenticator = this.getAuthenticator();
        if (!authenticator && (context === null || context === void 0 ? void 0 : context.currentAuthenticator)) authenticator = context.currentAuthenticator.value;
        return Object.assign(Object.assign({}, common), {
            authenticator: authenticator,
            poll: {
                required: true,
                refresh: this.remediation.refresh
            }
        });
    }
    getValuesAfterProceed() {
        let trimmedValues = Object.keys(this.values).filter((valueKey)=>valueKey !== 'startPolling');
        return trimmedValues.reduce((values, valueKey)=>Object.assign(Object.assign({}, values), {
                [valueKey]: this.values[valueKey]
            }), {});
    }
}
$424154aafceb9352$export$2e21ed88eacb421f.remediationName = 'enroll-poll';


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
class $3072c8ad9c49584b$export$76e9de8555d9305a extends (0, $c5de53213e27f939$export$8ab7a5763733596) {
    canRemediate() {
        if (this.values.channel) return true;
        if (this.values.authenticator) {
            const { id: id, channel: channel } = this.values.authenticator;
            if (!!id && !!channel) return true;
        }
        return false;
    }
    getNextStep(authClient, context) {
        const common = super.getNextStep(authClient, context);
        const authenticator = context.currentAuthenticator.value;
        return Object.assign(Object.assign({}, common), {
            authenticator: authenticator
        });
    }
    getData() {
        var _a;
        const remediationValue = this.remediation.value[0].value;
        return {
            authenticator: {
                id: remediationValue.form.value[0].value,
                channel: ((_a = this.values.authenticator) === null || _a === void 0 ? void 0 : _a.channel) || this.values.channel
            },
            stateHandle: this.values.stateHandle
        };
    }
    getValuesAfterProceed() {
        this.values = super.getValuesAfterProceed();
        delete this.values.authenticators;
        const filterKey = this.values.channel ? 'channel' : 'authenticator';
        let trimmedValues = Object.keys(this.values).filter((valueKey)=>valueKey !== filterKey);
        return trimmedValues.reduce((values, valueKey)=>Object.assign(Object.assign({}, values), {
                [valueKey]: this.values[valueKey]
            }), {});
    }
}
$3072c8ad9c49584b$export$76e9de8555d9305a.remediationName = 'select-enrollment-channel';


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
class $864eaa981b4d8073$export$c1bb923bb31fb3c9 extends (0, $c5de53213e27f939$export$8ab7a5763733596) {
    getInputEmail() {
        return [
            {
                name: 'email',
                type: 'string',
                required: true,
                label: 'Email'
            }
        ];
    }
    getInputPhoneNumber() {
        return [
            {
                name: 'phoneNumber',
                type: 'string',
                required: true,
                label: 'Phone Number'
            }
        ];
    }
    canRemediate() {
        return Boolean(this.values.email || this.values.phoneNumber);
    }
    getNextStep(authClient, context) {
        const common = super.getNextStep(authClient, context);
        const authenticator = context.currentAuthenticator.value;
        return Object.assign(Object.assign({}, common), {
            authenticator: authenticator
        });
    }
    getData() {
        return {
            stateHandle: this.values.stateHandle,
            email: this.values.email,
            phoneNumber: this.values.phoneNumber
        };
    }
    getValuesAfterProceed() {
        let trimmedValues = Object.keys(this.values).filter((valueKey)=>![
                'email',
                'phoneNumber'
            ].includes(valueKey));
        return trimmedValues.reduce((values, valueKey)=>Object.assign(Object.assign({}, values), {
                [valueKey]: this.values[valueKey]
            }), {});
    }
}
$864eaa981b4d8073$export$c1bb923bb31fb3c9.remediationName = 'enrollment-channel-data';


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
class $22a0f5c8a9156d59$export$2a2afff13894112f extends (0, $fffd8f7f491eaad6$export$e3100d946b350c5) {
}
$22a0f5c8a9156d59$export$2a2afff13894112f.remediationName = 'challenge-authenticator';


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
class $904c7a51f07a766f$export$9da932f7758505ec extends (0, $424154aafceb9352$export$2e21ed88eacb421f) {
    canRemediate() {
        return !!this.values.startPolling || this.options.step === 'challenge-poll';
    }
}
$904c7a51f07a766f$export$9da932f7758505ec.remediationName = 'challenge-poll';


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
class $3f7f18c2ab0a9585$export$3848083ec2ba1822 extends (0, $fffd8f7f491eaad6$export$e3100d946b350c5) {
}
$3f7f18c2ab0a9585$export$3848083ec2ba1822.remediationName = 'reset-authenticator';


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 


class $d3be962163119444$export$528e7bbca764a356 extends (0, $c5de53213e27f939$export$8ab7a5763733596) {
    constructor(remediation, values = {}, options = {}){
        super(remediation, values, options);
        this.authenticator = null;
        const credentials = this.getCredentialsFromRemediation();
        if (credentials) this.authenticator = this.authenticator = new (0, $14302ac00b4f0bba$export$df19360b11c3a265)({});
    }
    canRemediate() {
        if (this.authenticator && !this.authenticator.canVerify(this.values)) return false;
        const userProfileFromValues = this.getData().userProfile;
        if (!userProfileFromValues) return false;
        const userProfileFromRemediation = this.remediation.value.find(({ name: name })=>name === 'userProfile');
        return userProfileFromRemediation.form.value.reduce((canRemediate, curr)=>{
            if (curr.required) canRemediate = canRemediate && !!userProfileFromValues[curr.name];
            return canRemediate;
        }, true);
    }
    getCredentialsFromRemediation() {
        return this.remediation.value.find(({ name: name })=>name === 'credentials');
    }
    mapUserProfile({ form: { value: profileAttributes } }) {
        const attributeNames = profileAttributes.map(({ name: name })=>name);
        const data = attributeNames.reduce((attributeValues, attributeName)=>this.values[attributeName] ? Object.assign(Object.assign({}, attributeValues), {
                [attributeName]: this.values[attributeName]
            }) : attributeValues, {});
        if (Object.keys(data).length === 0) return;
        return data;
    }
    mapCredentials() {
        const val = this.authenticator && this.authenticator.mapCredentials(this.values);
        if (!val) return;
        return val;
    }
    getInputUserProfile(input) {
        return [
            ...input.form.value
        ];
    }
    getInputCredentials(input) {
        return [
            ...input.form.value
        ];
    }
    getErrorMessages(errorRemediation) {
        return errorRemediation.value[0].form.value.reduce((errors, field)=>{
            if (field.messages) errors.push(field.messages.value[0].message);
            return errors;
        }, []);
    }
}
$d3be962163119444$export$528e7bbca764a356.remediationName = 'enroll-profile';


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
class $7cfc117d8867368b$export$e513146db6535bff extends (0, $c5de53213e27f939$export$8ab7a5763733596) {
    constructor(){
        super(...arguments);
        this.map = {
            'identifier': [
                'username'
            ]
        };
    }
    canRemediate() {
        const { identifier: identifier } = this.getData();
        return !!identifier;
    }
    mapCredentials() {
        const { credentials: credentials, password: password } = this.values;
        if (!credentials && !password) return;
        return credentials || {
            passcode: password
        };
    }
    getInputCredentials(input) {
        return Object.assign(Object.assign({}, input.form.value[0]), {
            name: 'password',
            required: input.required
        });
    }
}
$7cfc117d8867368b$export$e513146db6535bff.remediationName = 'identify';


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
class $01d7defe22e586cd$export$68450f7d95120a39 extends (0, $c5de53213e27f939$export$8ab7a5763733596) {
    mapCredentials() {
        const { newPassword: newPassword } = this.values;
        if (!newPassword) return;
        return {
            passcode: newPassword
        };
    }
    getInputCredentials(input) {
        const challengeType = this.getAuthenticator().type;
        const name = challengeType === 'password' ? 'newPassword' : 'verificationCode';
        return Object.assign(Object.assign({}, input.form.value[0]), {
            name: name
        });
    }
}
$01d7defe22e586cd$export$68450f7d95120a39.remediationName = 'reenroll-authenticator';


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
class $b8858a8d4e6b21f1$export$76c32f77c893cc76 extends (0, $01d7defe22e586cd$export$68450f7d95120a39) {
}
$b8858a8d4e6b21f1$export$76c32f77c893cc76.remediationName = 'reenroll-authenticator-warning';


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
class $3e3cf603f9c74434$export$772831dc8c7313c0 extends (0, $c5de53213e27f939$export$8ab7a5763733596) {
    canRemediate() {
        return false;
    }
    getNextStep() {
        const { name: name, type: type, idp: idp, href: href } = this.remediation;
        return {
            name: name,
            type: type,
            idp: idp,
            href: href
        };
    }
}
$3e3cf603f9c74434$export$772831dc8c7313c0.remediationName = 'redirect-idp';


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 



class $500f54fcad3a0a40$export$21ef500697ce1d95 extends (0, $c5de53213e27f939$export$8ab7a5763733596) {
    findMatchedOption(authenticators, options) {
        let option;
        for (let authenticator of authenticators){
            option = options.find(({ relatesTo: relatesTo })=>relatesTo.key && relatesTo.key === authenticator.key);
            if (option) break;
        }
        return option;
    }
    canRemediate(context) {
        var _a, _b;
        const { authenticators: authenticators, authenticator: authenticator } = this.values;
        const authenticatorFromRemediation = (0, $b54e34bc1d750716$export$2c4be893a02ba700)(this.remediation);
        const { options: options } = authenticatorFromRemediation;
        if (!authenticators || !authenticators.length) return false;
        if ((0, $da481a8e31937f09$export$361ab32a8474b3c4)(authenticator) && authenticator.id) return true;
        const matchedOption = this.findMatchedOption(authenticators, options);
        if (matchedOption) {
            const isCurrentAuthenticator = (context === null || context === void 0 ? void 0 : context.currentAuthenticator) && (context === null || context === void 0 ? void 0 : context.currentAuthenticator.value.id) === ((_a = matchedOption.relatesTo) === null || _a === void 0 ? void 0 : _a.id);
            const isCurrentAuthenticatorEnrollment = (context === null || context === void 0 ? void 0 : context.currentAuthenticatorEnrollment) && (context === null || context === void 0 ? void 0 : context.currentAuthenticatorEnrollment.value.id) === ((_b = matchedOption.relatesTo) === null || _b === void 0 ? void 0 : _b.id);
            return !isCurrentAuthenticator && !isCurrentAuthenticatorEnrollment;
        }
        return false;
    }
    mapAuthenticator(remediationValue) {
        const { authenticators: authenticators, authenticator: authenticator } = this.values;
        if ((0, $da481a8e31937f09$export$361ab32a8474b3c4)(authenticator) && authenticator.id) {
            this.selectedAuthenticator = authenticator;
            return authenticator;
        }
        const { options: options } = remediationValue;
        const selectedOption = (0, $100b48d821947e2f$export$fafdedfcbb7d2691)(authenticators, options);
        this.selectedAuthenticator = selectedOption.relatesTo;
        this.selectedOption = selectedOption;
        return {
            id: selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value.form.value.find(({ name: name })=>name === 'id').value
        };
    }
    getInputAuthenticator(remediation) {
        const options = remediation.options.map(({ label: label, relatesTo: relatesTo })=>{
            return {
                label: label,
                value: relatesTo.key
            };
        });
        return {
            name: 'authenticator',
            type: 'string',
            options: options
        };
    }
    getValuesAfterProceed() {
        this.values = super.getValuesAfterProceed();
        const authenticators = this.values.authenticators.filter((authenticator)=>{
            return (0, $100b48d821947e2f$export$36b7fa650feebb56)(authenticator, this.selectedAuthenticator) !== true;
        });
        return Object.assign(Object.assign({}, this.values), {
            authenticators: authenticators
        });
    }
}




class $35afee0b90a6802f$export$c6bd0968af0af8c2 extends (0, $500f54fcad3a0a40$export$21ef500697ce1d95) {
    constructor(remediation, values = {}, options = {}){
        var _a;
        super(remediation, values, options);
        const isRecoveryFlow = this.options.flow === 'recoverPassword';
        const hasPasswordInOptions = (_a = (0, $b54e34bc1d750716$export$2c4be893a02ba700)(remediation).options) === null || _a === void 0 ? void 0 : _a.some(({ relatesTo: relatesTo })=>(relatesTo === null || relatesTo === void 0 ? void 0 : relatesTo.key) === (0, $da481a8e31937f09$export$b420a84de7aa04bd).OKTA_PASSWORD);
        if (hasPasswordInOptions && (isRecoveryFlow || this.values.password)) this.values.authenticators = [
            ...this.values.authenticators || [],
            {
                key: (0, $da481a8e31937f09$export$b420a84de7aa04bd).OKTA_PASSWORD
            }
        ];
    }
}
$35afee0b90a6802f$export$c6bd0968af0af8c2.remediationName = 'select-authenticator-authenticate';


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
class $24f6ff18fdff9f7e$export$616f0495c05b2e5e extends (0, $500f54fcad3a0a40$export$21ef500697ce1d95) {
}
$24f6ff18fdff9f7e$export$616f0495c05b2e5e.remediationName = 'select-authenticator-enroll';


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
class $a6434eb5c788e82c$export$4171832ff6fa6156 extends (0, $500f54fcad3a0a40$export$21ef500697ce1d95) {
    constructor(){
        super(...arguments);
        this.map = {
            identifier: [
                'username'
            ]
        };
    }
    canRemediate() {
        const identifier = this.getData('identifier');
        return !!identifier && super.canRemediate();
    }
    mapAuthenticator(remediationValue) {
        var _a, _b, _c;
        const authenticatorMap = super.mapAuthenticator(remediationValue);
        const methodTypeOption = (_a = this.selectedOption) === null || _a === void 0 ? void 0 : _a.value.form.value.find(({ name: name })=>name === 'methodType');
        const methodTypeValue = this.values.methodType || (methodTypeOption === null || methodTypeOption === void 0 ? void 0 : methodTypeOption.value) || ((_c = (_b = methodTypeOption === null || methodTypeOption === void 0 ? void 0 : methodTypeOption.options) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.value);
        if (methodTypeValue) return Object.assign(Object.assign({}, authenticatorMap), {
            methodType: methodTypeValue
        });
        return authenticatorMap;
    }
    getInputUsername() {
        return {
            name: 'username',
            type: 'string'
        };
    }
}
$a6434eb5c788e82c$export$4171832ff6fa6156.remediationName = 'select-authenticator-unlock-account';


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
class $212ddcea3c24a56c$export$e96bca2a1d12839 extends (0, $c5de53213e27f939$export$8ab7a5763733596) {
    canRemediate() {
        return true;
    }
}
$212ddcea3c24a56c$export$e96bca2a1d12839.remediationName = 'select-enroll-profile';


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 


class $f9f3e4880df9d538$export$fe95ca2756091e61 extends (0, $c5de53213e27f939$export$8ab7a5763733596) {
    constructor(remediation, values = {}){
        super(remediation, values);
        this.authenticator = this.getAuthenticator();
        this.formatAuthenticatorData();
    }
    formatAuthenticatorData() {
        const authenticatorData = this.getAuthenticatorData();
        if (authenticatorData) this.values.authenticatorsData = this.values.authenticatorsData.map((data)=>{
            if ((0, $100b48d821947e2f$export$36b7fa650feebb56)(this.authenticator, data)) return this.mapAuthenticatorDataFromValues(data);
            return data;
        });
        else {
            const data = this.mapAuthenticatorDataFromValues();
            if (data) this.values.authenticatorsData.push(data);
        }
    }
    getAuthenticatorData() {
        return this.values.authenticatorsData.find((data)=>(0, $100b48d821947e2f$export$36b7fa650feebb56)(this.authenticator, data));
    }
    canRemediate() {
        return this.values.authenticatorsData.some((data)=>(0, $100b48d821947e2f$export$36b7fa650feebb56)(this.authenticator, data));
    }
    mapAuthenticatorDataFromValues(authenticatorData) {
        let { methodType: methodType, authenticator: authenticator } = this.values;
        if (!methodType && (0, $da481a8e31937f09$export$361ab32a8474b3c4)(authenticator)) methodType = authenticator === null || authenticator === void 0 ? void 0 : authenticator.methodType;
        const { id: id, enrollmentId: enrollmentId } = this.authenticator;
        const data = Object.assign(Object.assign({
            id: id,
            enrollmentId: enrollmentId
        }, authenticatorData && authenticatorData), methodType && {
            methodType: methodType
        });
        return data.methodType ? data : null;
    }
    getAuthenticatorFromRemediation() {
        const authenticator = this.remediation.value.find(({ name: name })=>name === 'authenticator');
        return authenticator;
    }
    getValuesAfterProceed() {
        this.values = super.getValuesAfterProceed();
        const authenticatorsData = this.values.authenticatorsData.filter((data)=>(0, $100b48d821947e2f$export$36b7fa650feebb56)(this.authenticator, data) !== true);
        return Object.assign(Object.assign({}, this.values), {
            authenticatorsData: authenticatorsData
        });
    }
}


class $c10b4ec5040a8f25$export$53b35b6113db0f85 extends (0, $f9f3e4880df9d538$export$fe95ca2756091e61) {
    mapAuthenticator() {
        return this.getAuthenticatorData();
    }
    getInputAuthenticator() {
        const authenticator = this.getAuthenticatorFromRemediation();
        const methodType = authenticator.form.value.find(({ name: name })=>name === 'methodType');
        if (methodType && methodType.options) return {
            name: 'methodType',
            type: 'string',
            required: true,
            options: methodType.options
        };
        const inputs = [
            ...authenticator.form.value
        ];
        return inputs;
    }
    getValuesAfterProceed() {
        this.values = super.getValuesAfterProceed();
        let trimmedValues = Object.keys(this.values).filter((valueKey)=>valueKey !== 'authenticator');
        return trimmedValues.reduce((values, valueKey)=>Object.assign(Object.assign({}, values), {
                [valueKey]: this.values[valueKey]
            }), {});
    }
}
$c10b4ec5040a8f25$export$53b35b6113db0f85.remediationName = 'authenticator-verification-data';


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 

class $0bc2eb90818238b0$export$8934d2d012992d26 extends (0, $f9f3e4880df9d538$export$fe95ca2756091e61) {
    mapAuthenticator() {
        const authenticatorData = this.getAuthenticatorData();
        const authenticatorFromRemediation = (0, $b54e34bc1d750716$export$2c4be893a02ba700)(this.remediation);
        return {
            id: authenticatorFromRemediation.form.value.find(({ name: name })=>name === 'id').value,
            methodType: authenticatorData.methodType,
            phoneNumber: authenticatorData.phoneNumber
        };
    }
    getInputAuthenticator(remediation) {
        return [
            {
                name: 'methodType',
                type: 'string'
            },
            {
                name: 'phoneNumber',
                label: 'Phone Number',
                type: 'string'
            }
        ].map((item)=>{
            const value = remediation.form.value.find((val)=>val.name === item.name);
            return Object.assign(Object.assign({}, value), item);
        });
    }
    mapAuthenticatorDataFromValues(data) {
        data = super.mapAuthenticatorDataFromValues(data);
        const { phoneNumber: phoneNumber } = this.values;
        if (!data && !phoneNumber) return;
        return Object.assign(Object.assign({}, data && data), phoneNumber && {
            phoneNumber: phoneNumber
        });
    }
}
$0bc2eb90818238b0$export$8934d2d012992d26.remediationName = 'authenticator-enrollment-data';


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
class $c2d0361b23182443$export$38d24f5c1eb0e4c0 extends (0, $c5de53213e27f939$export$8ab7a5763733596) {
    canRemediate() {
        return !!this.values.skip || this.options.step === 'skip';
    }
}
$c2d0361b23182443$export$38d24f5c1eb0e4c0.remediationName = 'skip';


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 

/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
function $687598d17340aa41$export$2ebaeb11fe49775c(remediation) {
    if (Array.isArray(remediation)) return remediation.map((item)=>{
        if (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean') return item;
        return $687598d17340aa41$export$2ebaeb11fe49775c(item);
    });
    const res = {};
    for (const [key, value] of Object.entries(remediation)){
        if (value === null || typeof value === 'undefined') continue;
        if (typeof value === 'object') {
            const formKeys = Object.keys(value);
            if ([
                'value',
                'form'
            ].includes(key) && formKeys.length === 1 && [
                'value',
                'form'
            ].includes(formKeys[0])) {
                const unwrappedForm = $687598d17340aa41$export$2ebaeb11fe49775c(value);
                Object.entries(unwrappedForm).forEach(([key, value])=>{
                    res[key] = value;
                });
            } else res[key] = $687598d17340aa41$export$2ebaeb11fe49775c(value);
        } else res[key] = value;
    }
    return res;
}


class $4d7e23bce239b9e3$export$9e487c92809f61cb extends (0, $c5de53213e27f939$export$8ab7a5763733596) {
    canRemediate() {
        if (typeof this.remediation.action !== 'function') return false;
        if (this.remediation.name === 'poll' || this.remediation.name.endsWith('-poll')) return true;
        if (this.options.step) return true;
        return false;
    }
    getData() {
        const data = this.getInputs().reduce((acc, { name: name })=>{
            acc[name] = this.values[name];
            return acc;
        }, {});
        return data;
    }
    getNextStep(authClient, _context) {
        const name = this.getName();
        const inputs = this.getInputs();
        const _a = this.remediation, { href: href, method: method, rel: rel, accepts: accepts, produces: produces, value: value, action: action } = _a, rest = (0, $a8b9237c404681df$export$3c9a16f847548506)(_a, [
            "href",
            "method",
            "rel",
            "accepts",
            "produces",
            "value",
            "action"
        ]);
        if (action) return Object.assign(Object.assign(Object.assign({}, rest), !!inputs.length && {
            inputs: inputs
        }), {
            action: async (params)=>{
                return authClient.idx.proceed(Object.assign({
                    step: name
                }, params));
            }
        });
        return Object.assign({}, this.remediation);
    }
    getInputs() {
        return (this.remediation.value || []).filter(({ name: name })=>name !== 'stateHandle').map((0, $687598d17340aa41$export$2ebaeb11fe49775c)).map((input)=>{
            input.type = input.type || 'string';
            return input;
        });
    }
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 




const $aea8b91481cf51cf$var$ctx = {
    remediators: {},
    getFlowSpecification: function(_oktaAuth, _flow = 'default') {
        return {
            remediators: {}
        };
    }
};
function $aea8b91481cf51cf$export$36c62655b1577e54(newCtx) {
    Object.assign($aea8b91481cf51cf$var$ctx, newCtx);
}
function $aea8b91481cf51cf$export$d54c0e1d8c74ec70(oktaAuth, flow = 'default') {
    return $aea8b91481cf51cf$var$ctx.getFlowSpecification(oktaAuth, flow);
}
function $aea8b91481cf51cf$export$948059f37913b971(idxResponse) {
    const { neededToProceed: neededToProceed, interactionCode: interactionCode } = idxResponse;
    return !neededToProceed.length && !interactionCode;
}
function $aea8b91481cf51cf$export$f9ebcddf31580672(idxResponse) {
    return idxResponse.neededToProceed.some(({ name: name })=>name === 'skip');
}
function $aea8b91481cf51cf$export$4bc8275b5603234(idxResponse) {
    return Object.keys(idxResponse.actions).some((actionName)=>actionName.includes('resend'));
}
function $aea8b91481cf51cf$export$28307694da5b8ca7(value) {
    if (!value || !Array.isArray(value)) return;
    return value.reduce((messages, value)=>{
        if (value.messages) messages = [
            ...messages,
            ...value.messages.value
        ];
        if (value.form) {
            const messagesFromForm = $aea8b91481cf51cf$export$28307694da5b8ca7(value.form.value) || [];
            messages = [
                ...messages,
                ...messagesFromForm
            ];
        }
        if (value.options) {
            let optionValues = [];
            value.options.forEach((option)=>{
                if (!option.value || typeof option.value === 'string') return;
                optionValues = [
                    ...optionValues,
                    option.value
                ];
            });
            const messagesFromOptions = $aea8b91481cf51cf$export$28307694da5b8ca7(optionValues) || [];
            messages = [
                ...messages,
                ...messagesFromOptions
            ];
        }
        return messages;
    }, []);
}
function $aea8b91481cf51cf$export$1130a40ad82f0152(idxResponse, options) {
    var _a;
    let messages = [];
    const { rawIdxState: rawIdxState, neededToProceed: neededToProceed } = idxResponse;
    const globalMessages = (_a = rawIdxState.messages) === null || _a === void 0 ? void 0 : _a.value.map((message)=>message);
    if (globalMessages) messages = [
        ...messages,
        ...globalMessages
    ];
    if (!options.useGenericRemediator) for (let remediation of neededToProceed){
        const fieldMessages = $aea8b91481cf51cf$export$28307694da5b8ca7(remediation.value);
        if (fieldMessages) messages = [
            ...messages,
            ...fieldMessages
        ];
    }
    const seen = {};
    messages = messages.reduce((filtered, message)=>{
        var _a;
        const key = (_a = message.i18n) === null || _a === void 0 ? void 0 : _a.key;
        if (key && seen[key] && message.message === seen[key].message) return filtered;
        seen[key] = message;
        filtered = [
            ...filtered,
            message
        ];
        return filtered;
    }, []);
    return messages;
}
function $aea8b91481cf51cf$export$b223b1e857b805e7(idxResponse) {
    const res = [];
    const { actions: actions, neededToProceed: neededToProceed } = idxResponse;
    if (actions['currentAuthenticator-recover']) res.push((0, $da481a8e31937f09$export$451922195d9391fb).PASSWORD_RECOVERY);
    if (neededToProceed.some(({ name: name })=>name === 'select-enroll-profile')) res.push((0, $da481a8e31937f09$export$451922195d9391fb).REGISTRATION);
    if (neededToProceed.some(({ name: name })=>name === 'redirect-idp')) res.push((0, $da481a8e31937f09$export$451922195d9391fb).SOCIAL_IDP);
    if (neededToProceed.some(({ name: name })=>name === 'unlock-account')) res.push((0, $da481a8e31937f09$export$451922195d9391fb).ACCOUNT_UNLOCK);
    return res;
}
function $aea8b91481cf51cf$export$ed702e2b388d7c0e(authClient, idxResponse, useGenericRemediator) {
    var _a;
    const res = [];
    const remediatorMap = Object.values($aea8b91481cf51cf$var$ctx.remediators).reduce((map, remediatorClass)=>{
        if (remediatorClass.remediationName) map[remediatorClass.remediationName] = remediatorClass;
        return map;
    }, {});
    for (let remediation of idxResponse.neededToProceed){
        const T = $aea8b91481cf51cf$var$getRemediatorClass(remediation, {
            useGenericRemediator: useGenericRemediator,
            remediators: remediatorMap
        });
        if (T) {
            const remediator = new T(remediation);
            res.push(remediator.getNextStep(authClient, idxResponse.context));
        }
    }
    for (const [name] of Object.entries(idxResponse.actions || {})){
        let stepObj = {
            name: name,
            action: async (params)=>{
                return authClient.idx.proceed({
                    actions: [
                        {
                            name: name,
                            params: params
                        }
                    ]
                });
            }
        };
        if (name.startsWith('currentAuthenticator')) {
            const [part1, part2] = (0, $c8a11dd749b49091$export$5f7ca8c53ac3b054)(name, '-');
            const actionObj = idxResponse.rawIdxState[part1].value[part2];
            const rest = (0, $a8b9237c404681df$export$3c9a16f847548506)(actionObj, [
                "href",
                "method",
                "rel",
                "accepts",
                "produces"
            ]);
            const value = (_a = actionObj.value) === null || _a === void 0 ? void 0 : _a.filter((item)=>item.name !== 'stateHandle');
            stepObj = Object.assign(Object.assign(Object.assign({}, rest), value && {
                value: value
            }), stepObj);
        }
        res.push(stepObj);
    }
    return res;
}
function $aea8b91481cf51cf$export$3045fb2be2298cb1(idxResponse, remediationName, values) {
    const remediations = idxResponse.neededToProceed || [];
    const remediation = remediations.find((r)=>r.name === remediationName);
    if (!remediation) {
        (0, $26320b9c410af87d$export$c106dd0671a0fc2d)(`filterValuesForRemediation: "${remediationName}" did not match any remediations`);
        return values;
    }
    const valuesForRemediation = remediation.value.reduce((res, entry)=>{
        const { name: name, value: value } = entry;
        if (name === 'stateHandle') res[name] = value;
        else res[name] = values[name];
        return res;
    }, {});
    return valuesForRemediation;
}
function $aea8b91481cf51cf$var$getRemediatorClass(remediation, options) {
    const { useGenericRemediator: useGenericRemediator, remediators: remediators } = options;
    if (!remediation) return undefined;
    if (useGenericRemediator) return 0, $4d7e23bce239b9e3$export$9e487c92809f61cb;
    return remediators[remediation.name];
}
function $aea8b91481cf51cf$export$8d84c5cc4d0bda80(idxResponse, values, options) {
    const remediators = options.remediators;
    const useGenericRemediator = options.useGenericRemediator;
    const { neededToProceed: idxRemediations, context: context } = idxResponse;
    let remediator;
    if (options.step) {
        const remediation = idxRemediations.find(({ name: name })=>name === options.step);
        if (remediation) {
            const T = $aea8b91481cf51cf$var$getRemediatorClass(remediation, options);
            return T ? new T(remediation, values, options) : undefined;
        } else {
            (0, $26320b9c410af87d$export$c106dd0671a0fc2d)(`step "${options.step}" did not match any remediations`);
            return;
        }
    }
    const remediatorCandidates = [];
    if (useGenericRemediator) remediatorCandidates.push(new (0, $4d7e23bce239b9e3$export$9e487c92809f61cb)(idxRemediations[0], values, options));
    else for (let remediation of idxRemediations){
        const isRemeditionInFlow = Object.keys(remediators).includes(remediation.name);
        if (!isRemeditionInFlow) continue;
        const T = $aea8b91481cf51cf$var$getRemediatorClass(remediation, options);
        remediator = new T(remediation, values, options);
        if (remediator.canRemediate(context)) return remediator;
        remediatorCandidates.push(remediator);
    }
    return remediatorCandidates[0];
}
function $aea8b91481cf51cf$export$b6b54d9bbb742a92(authClient, remediator, idxResponse) {
    const nextStep = remediator.getNextStep(authClient, idxResponse.context);
    const canSkip = $aea8b91481cf51cf$export$f9ebcddf31580672(idxResponse);
    const canResend = $aea8b91481cf51cf$export$4bc8275b5603234(idxResponse);
    return Object.assign(Object.assign(Object.assign({}, nextStep), canSkip && {
        canSkip: canSkip
    }), canResend && {
        canResend: canResend
    });
}
function $aea8b91481cf51cf$export$3d2cbb102ee7774e(authClient, idxResponse, options = {}) {
    const terminal = $aea8b91481cf51cf$export$948059f37913b971(idxResponse);
    const messages = $aea8b91481cf51cf$export$1130a40ad82f0152(idxResponse, options);
    if (terminal) return {
        idxResponse: idxResponse,
        terminal: terminal,
        messages: messages
    };
    else {
        const remediator = $aea8b91481cf51cf$export$8d84c5cc4d0bda80(idxResponse, {}, options);
        const nextStep = remediator && $aea8b91481cf51cf$export$b6b54d9bbb742a92(authClient, remediator, idxResponse);
        return Object.assign({
            idxResponse: idxResponse,
            messages: messages
        }, nextStep && {
            nextStep: nextStep
        });
    }
}


function $30bfe3bda541cdc7$var$getActionFromValues(values, idxResponse) {
    return Object.keys(idxResponse.actions).find((action)=>!!values.resend && action.includes('-resend'));
}
function $30bfe3bda541cdc7$var$removeActionFromValues(values) {
    return Object.assign(Object.assign({}, values), {
        resend: undefined
    });
}
function $30bfe3bda541cdc7$var$removeActionFromOptions(options, actionName) {
    let actions = options.actions || [];
    actions = actions.filter((entry)=>{
        if (typeof entry === 'string') return entry !== actionName;
        return entry.name !== actionName;
    });
    return Object.assign(Object.assign({}, options), {
        actions: actions
    });
}
function $30bfe3bda541cdc7$var$getGenericNextStep(authClient, idxResponse, options) {
    if (idxResponse.interactionCode) return {
        idxResponse: idxResponse
    };
    if (options.enableLegacyMode) return {
        idxResponse: idxResponse
    };
    const gr = new (0, $4d7e23bce239b9e3$export$9e487c92809f61cb)(idxResponse.neededToProceed[0], {}, options);
    const nextStep = (0, $aea8b91481cf51cf$export$b6b54d9bbb742a92)(authClient, gr, idxResponse);
    return {
        idxResponse: idxResponse,
        nextStep: nextStep
    };
}
async function $30bfe3bda541cdc7$export$f75734e1eff13481(authClient, idxResponse, values, options) {
    let { neededToProceed: neededToProceed, interactionCode: interactionCode } = idxResponse;
    const { flow: flow, useGenericRemediator: useGenericRemediator, enableLegacyMode: enableLegacyMode } = options;
    const isStepMode = enableLegacyMode !== true;
    if (interactionCode) return {
        idxResponse: idxResponse
    };
    if ((0, $aea8b91481cf51cf$export$948059f37913b971)(idxResponse)) return {
        idxResponse: idxResponse,
        terminal: true
    };
    const actionFromValues = $30bfe3bda541cdc7$var$getActionFromValues(values, idxResponse);
    const actionFromOptions = options.actions || [];
    const actions = [
        ...actionFromOptions,
        ...actionFromValues && [
            actionFromValues
        ] || []
    ];
    if (actions.length > 0) {
        for (let action of actions){
            let params = {};
            if (typeof action !== 'string') {
                params = action.params || {};
                action = action.name;
            }
            let valuesWithoutExecutedAction = $30bfe3bda541cdc7$var$removeActionFromValues(values);
            let optionsWithoutExecutedAction = $30bfe3bda541cdc7$var$removeActionFromOptions(options, action);
            if (typeof idxResponse.actions[action] === 'function') {
                idxResponse = await idxResponse.actions[action](params);
                if (idxResponse.requestDidSucceed === false) return (0, $aea8b91481cf51cf$export$3d2cbb102ee7774e)(authClient, idxResponse, options);
                if (action === 'cancel') return {
                    idxResponse: idxResponse,
                    canceled: true
                };
                if (isStepMode) return $30bfe3bda541cdc7$var$getGenericNextStep(authClient, idxResponse, options);
                return $30bfe3bda541cdc7$export$f75734e1eff13481(authClient, idxResponse, valuesWithoutExecutedAction, optionsWithoutExecutedAction);
            }
            const remediationAction = neededToProceed.find(({ name: name })=>name === action);
            if (remediationAction) {
                idxResponse = await idxResponse.proceed(action, params);
                if (idxResponse.requestDidSucceed === false) return (0, $aea8b91481cf51cf$export$3d2cbb102ee7774e)(authClient, idxResponse, options);
                if (isStepMode) return $30bfe3bda541cdc7$var$getGenericNextStep(authClient, idxResponse, options);
                return $30bfe3bda541cdc7$export$f75734e1eff13481(authClient, idxResponse, values, optionsWithoutExecutedAction);
            }
        }
        if (isStepMode && !options.step) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('Unable to proceed with provided actions');
    }
    if (!useGenericRemediator && isStepMode && !options.step) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('No `step` or `action` provided');
    const remediator = (0, $aea8b91481cf51cf$export$8d84c5cc4d0bda80)(idxResponse, values, options);
    if (!remediator) {
        if (options.step) {
            values = (0, $aea8b91481cf51cf$export$3045fb2be2298cb1)(idxResponse, options.step, values);
            idxResponse = await idxResponse.proceed(options.step, values);
            if (idxResponse.requestDidSucceed === false) return (0, $aea8b91481cf51cf$export$3d2cbb102ee7774e)(authClient, idxResponse, options);
            return $30bfe3bda541cdc7$var$getGenericNextStep(authClient, idxResponse, options);
        }
        if (flow === 'default') return {
            idxResponse: idxResponse
        };
        throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)(`
      No remediation can match current flow, check policy settings in your org.
      Remediations: [${neededToProceed.reduce((acc, curr)=>acc ? acc + ' ,' + curr.name : curr.name, '')}]
    `);
    }
    if (!remediator.canRemediate()) {
        const nextStep = (0, $aea8b91481cf51cf$export$b6b54d9bbb742a92)(authClient, remediator, idxResponse);
        return {
            idxResponse: idxResponse,
            nextStep: nextStep
        };
    }
    const name = remediator.getName();
    const data = remediator.getData();
    idxResponse = await idxResponse.proceed(name, data);
    if (idxResponse.requestDidSucceed === false) return (0, $aea8b91481cf51cf$export$3d2cbb102ee7774e)(authClient, idxResponse, options);
    if ((0, $aea8b91481cf51cf$export$948059f37913b971)(idxResponse)) return {
        idxResponse: idxResponse,
        terminal: true
    };
    if (useGenericRemediator || isStepMode) return $30bfe3bda541cdc7$var$getGenericNextStep(authClient, idxResponse, options);
    values = remediator.getValuesAfterProceed();
    options = Object.assign(Object.assign({}, options), {
        step: undefined
    });
    return $30bfe3bda541cdc7$export$f75734e1eff13481(authClient, idxResponse, values, options);
}





function $e1f4dfc5b7d7bf3c$var$initializeValues(options) {
    const knownOptions = [
        'flow',
        'remediators',
        'actions',
        'withCredentials',
        'step',
        'useGenericRemediator',
        'exchangeCodeForTokens',
        'enableLegacyMode'
    ];
    const values = Object.assign({}, options);
    knownOptions.forEach((option)=>{
        delete values[option];
    });
    return values;
}
function $e1f4dfc5b7d7bf3c$var$initializeData(authClient, data) {
    var _a, _b, _c, _d;
    let { options: options } = data;
    options = Object.assign(Object.assign({}, authClient.options.idx), options);
    let { flow: flow, withCredentials: withCredentials, remediators: remediators, actions: actions } = options;
    const status = (0, $da481a8e31937f09$export$c96dcb52978c0932).PENDING;
    flow = flow || ((_b = (_a = authClient.idx).getFlow) === null || _b === void 0 ? void 0 : _b.call(_a)) || 'default';
    if (flow) {
        (_d = (_c = authClient.idx).setFlow) === null || _d === void 0 || _d.call(_c, flow);
        const flowSpec = (0, $aea8b91481cf51cf$export$d54c0e1d8c74ec70)(authClient, flow);
        withCredentials = typeof withCredentials !== 'undefined' ? withCredentials : flowSpec.withCredentials;
        remediators = remediators || flowSpec.remediators;
        actions = actions || flowSpec.actions;
    }
    return Object.assign(Object.assign({}, data), {
        options: Object.assign(Object.assign({}, options), {
            flow: flow,
            withCredentials: withCredentials,
            remediators: remediators,
            actions: actions
        }),
        status: status
    });
}
async function $e1f4dfc5b7d7bf3c$var$getDataFromIntrospect(authClient, data) {
    const { options: options } = data;
    const { stateHandle: stateHandle, withCredentials: withCredentials, version: version, state: state, scopes: scopes, recoveryToken: recoveryToken, activationToken: activationToken, maxAge: maxAge, acrValues: acrValues, nonce: nonce, useGenericRemediator: useGenericRemediator } = options;
    let idxResponse;
    let meta = (0, $e0bbf14d4839e4ff$export$ee78659ae5675f26)(authClient, {
        state: state,
        recoveryToken: recoveryToken,
        activationToken: activationToken
    });
    if (stateHandle) idxResponse = await (0, $ed622bb52a9c4e67$export$3b41a86e379f8f15)(authClient, {
        withCredentials: withCredentials,
        version: version,
        stateHandle: stateHandle,
        useGenericRemediator: useGenericRemediator
    });
    else {
        let interactionHandle = meta === null || meta === void 0 ? void 0 : meta.interactionHandle;
        if (!interactionHandle) {
            authClient.transactionManager.clear();
            const interactResponse = await (0, $1ffb78727d57781d$export$20814a0f9b60f8cf)(authClient, {
                withCredentials: withCredentials,
                state: state,
                scopes: scopes,
                activationToken: activationToken,
                recoveryToken: recoveryToken,
                maxAge: maxAge,
                acrValues: acrValues,
                nonce: nonce
            });
            interactionHandle = interactResponse.interactionHandle;
            meta = interactResponse.meta;
        }
        idxResponse = await (0, $ed622bb52a9c4e67$export$3b41a86e379f8f15)(authClient, {
            withCredentials: withCredentials,
            version: version,
            interactionHandle: interactionHandle,
            useGenericRemediator: useGenericRemediator
        });
    }
    return Object.assign(Object.assign({}, data), {
        idxResponse: idxResponse,
        meta: meta
    });
}
async function $e1f4dfc5b7d7bf3c$var$getDataFromRemediate(authClient, data) {
    let { idxResponse: idxResponse, options: options, values: values } = data;
    const { autoRemediate: autoRemediate, remediators: remediators, actions: actions, flow: flow, step: step, useGenericRemediator: useGenericRemediator, enableLegacyMode: enableLegacyMode } = options;
    const shouldRemediate = autoRemediate !== false && (remediators || actions || step);
    if (!shouldRemediate) return data;
    values = Object.assign(Object.assign({}, values), {
        stateHandle: idxResponse.rawIdxState.stateHandle
    });
    const { idxResponse: idxResponseFromRemediation, nextStep: nextStep, canceled: canceled } = await (0, $30bfe3bda541cdc7$export$f75734e1eff13481)(authClient, idxResponse, values, {
        remediators: remediators,
        actions: actions,
        flow: flow,
        step: step,
        useGenericRemediator: useGenericRemediator,
        enableLegacyMode: enableLegacyMode
    });
    idxResponse = idxResponseFromRemediation;
    return Object.assign(Object.assign({}, data), {
        idxResponse: idxResponse,
        nextStep: nextStep,
        canceled: canceled
    });
}
async function $e1f4dfc5b7d7bf3c$var$getTokens(authClient, data) {
    let { meta: meta, idxResponse: idxResponse } = data;
    const { interactionCode: interactionCode } = idxResponse;
    const { clientId: clientId, codeVerifier: codeVerifier, ignoreSignature: ignoreSignature, redirectUri: redirectUri, urls: urls, scopes: scopes } = meta;
    const tokenResponse = await authClient.token.exchangeCodeForTokens({
        interactionCode: interactionCode,
        clientId: clientId,
        codeVerifier: codeVerifier,
        ignoreSignature: ignoreSignature,
        redirectUri: redirectUri,
        scopes: scopes
    }, urls);
    return tokenResponse.tokens;
}
async function $e1f4dfc5b7d7bf3c$var$finalizeData(authClient, data) {
    let { options: options, idxResponse: idxResponse, canceled: canceled, status: status } = data;
    const { exchangeCodeForTokens: exchangeCodeForTokens } = options;
    let shouldSaveResponse = false;
    let shouldClearTransaction = false;
    let clearSharedStorage = true;
    let interactionCode;
    let tokens;
    let enabledFeatures;
    let availableSteps;
    let messages;
    let terminal;
    if (idxResponse) {
        shouldSaveResponse = !!(idxResponse.requestDidSucceed || idxResponse.stepUp);
        enabledFeatures = (0, $aea8b91481cf51cf$export$b223b1e857b805e7)(idxResponse);
        availableSteps = (0, $aea8b91481cf51cf$export$ed702e2b388d7c0e)(authClient, idxResponse, options.useGenericRemediator);
        messages = (0, $aea8b91481cf51cf$export$1130a40ad82f0152)(idxResponse, options);
        terminal = (0, $aea8b91481cf51cf$export$948059f37913b971)(idxResponse);
    }
    if (terminal) {
        status = (0, $da481a8e31937f09$export$c96dcb52978c0932).TERMINAL;
        const hasActions = Object.keys(idxResponse.actions).length > 0;
        const hasErrors = !!messages.find((msg)=>msg.class === 'ERROR');
        const isTerminalSuccess = !hasActions && !hasErrors && idxResponse.requestDidSucceed === true;
        if (isTerminalSuccess) shouldClearTransaction = true;
        else shouldSaveResponse = !!hasActions;
        clearSharedStorage = false;
    } else if (canceled) {
        status = (0, $da481a8e31937f09$export$c96dcb52978c0932).CANCELED;
        shouldClearTransaction = true;
    } else if (idxResponse === null || idxResponse === void 0 ? void 0 : idxResponse.interactionCode) {
        interactionCode = idxResponse.interactionCode;
        if (exchangeCodeForTokens === false) {
            status = (0, $da481a8e31937f09$export$c96dcb52978c0932).SUCCESS;
            shouldClearTransaction = false;
        } else {
            tokens = await $e1f4dfc5b7d7bf3c$var$getTokens(authClient, data);
            status = (0, $da481a8e31937f09$export$c96dcb52978c0932).SUCCESS;
            shouldClearTransaction = true;
        }
    }
    return Object.assign(Object.assign({}, data), {
        status: status,
        interactionCode: interactionCode,
        tokens: tokens,
        shouldSaveResponse: shouldSaveResponse,
        shouldClearTransaction: shouldClearTransaction,
        clearSharedStorage: clearSharedStorage,
        enabledFeatures: enabledFeatures,
        availableSteps: availableSteps,
        messages: messages,
        terminal: terminal
    });
}
async function $e1f4dfc5b7d7bf3c$export$889ea624f2cb2c57(authClient, options = {}) {
    var _a;
    let data = {
        options: options,
        values: $e1f4dfc5b7d7bf3c$var$initializeValues(options)
    };
    data = $e1f4dfc5b7d7bf3c$var$initializeData(authClient, data);
    data = await $e1f4dfc5b7d7bf3c$var$getDataFromIntrospect(authClient, data);
    data = await $e1f4dfc5b7d7bf3c$var$getDataFromRemediate(authClient, data);
    data = await $e1f4dfc5b7d7bf3c$var$finalizeData(authClient, data);
    const { idxResponse: idxResponse, meta: meta, shouldSaveResponse: shouldSaveResponse, shouldClearTransaction: shouldClearTransaction, clearSharedStorage: clearSharedStorage, status: status, enabledFeatures: enabledFeatures, availableSteps: availableSteps, tokens: tokens, nextStep: nextStep, messages: messages, error: error, interactionCode: interactionCode } = data;
    if (shouldClearTransaction) authClient.transactionManager.clear({
        clearSharedStorage: clearSharedStorage
    });
    else {
        (0, $e0bbf14d4839e4ff$export$dc27696b235944d6)(authClient, Object.assign({}, meta));
        if (shouldSaveResponse) {
            const { rawIdxState: rawIdxResponse, requestDidSucceed: requestDidSucceed } = idxResponse;
            authClient.transactionManager.saveIdxResponse({
                rawIdxResponse: rawIdxResponse,
                requestDidSucceed: requestDidSucceed,
                stateHandle: (_a = idxResponse.context) === null || _a === void 0 ? void 0 : _a.stateHandle,
                interactionHandle: meta === null || meta === void 0 ? void 0 : meta.interactionHandle
            });
        }
    }
    const { actions: actions, context: context, neededToProceed: neededToProceed, proceed: proceed, rawIdxState: rawIdxState, requestDidSucceed: requestDidSucceed, stepUp: stepUp } = idxResponse || {};
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
        status: status
    }, meta && {
        meta: meta
    }), enabledFeatures && {
        enabledFeatures: enabledFeatures
    }), availableSteps && {
        availableSteps: availableSteps
    }), tokens && {
        tokens: tokens
    }), nextStep && {
        nextStep: nextStep
    }), messages && messages.length && {
        messages: messages
    }), error && {
        error: error
    }), stepUp && {
        stepUp: stepUp
    }), {
        interactionCode: interactionCode,
        actions: actions,
        context: context,
        neededToProceed: neededToProceed,
        proceed: proceed,
        rawIdxState: rawIdxState,
        requestDidSucceed: requestDidSucceed
    });
}


async function $54d6c7f881cde0a1$export$61bb00ddedae72e4(authClient, options = {}) {
    if (options.password && !options.authenticator) options.authenticator = (0, $da481a8e31937f09$export$b420a84de7aa04bd).OKTA_PASSWORD;
    return (0, $e1f4dfc5b7d7bf3c$export$889ea624f2cb2c57)(authClient, Object.assign(Object.assign({}, options), {
        flow: 'authenticate'
    }));
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 






















/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 





















const $6c5e4113413a2e41$export$d49108c385f05cb4 = {
    'identify': (0, $7cfc117d8867368b$export$e513146db6535bff),
    'select-authenticator-authenticate': (0, $35afee0b90a6802f$export$c6bd0968af0af8c2),
    'select-authenticator-enroll': (0, $24f6ff18fdff9f7e$export$616f0495c05b2e5e),
    'authenticator-enrollment-data': (0, $0bc2eb90818238b0$export$8934d2d012992d26),
    'authenticator-verification-data': (0, $c10b4ec5040a8f25$export$53b35b6113db0f85),
    'enroll-authenticator': (0, $31a06cf5017088f6$export$f7157015cf11193f),
    'challenge-authenticator': (0, $22a0f5c8a9156d59$export$2a2afff13894112f),
    'challenge-poll': (0, $904c7a51f07a766f$export$9da932f7758505ec),
    'reenroll-authenticator': (0, $01d7defe22e586cd$export$68450f7d95120a39),
    'reenroll-authenticator-warning': (0, $b8858a8d4e6b21f1$export$76c32f77c893cc76),
    'enroll-poll': (0, $424154aafceb9352$export$2e21ed88eacb421f),
    'select-enrollment-channel': (0, $3072c8ad9c49584b$export$76e9de8555d9305a),
    'enrollment-channel-data': (0, $864eaa981b4d8073$export$c1bb923bb31fb3c9),
    'redirect-idp': (0, $3e3cf603f9c74434$export$772831dc8c7313c0),
    'skip': (0, $c2d0361b23182443$export$38d24f5c1eb0e4c0)
};


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 





















const $1811f7c08e9cea2e$export$6e2e200e9a83635 = {
    'identify': (0, $7cfc117d8867368b$export$e513146db6535bff),
    'identify-recovery': (0, $7cfc117d8867368b$export$e513146db6535bff),
    'select-authenticator-authenticate': (0, $35afee0b90a6802f$export$c6bd0968af0af8c2),
    'select-authenticator-enroll': (0, $24f6ff18fdff9f7e$export$616f0495c05b2e5e),
    'challenge-authenticator': (0, $22a0f5c8a9156d59$export$2a2afff13894112f),
    'authenticator-verification-data': (0, $c10b4ec5040a8f25$export$53b35b6113db0f85),
    'authenticator-enrollment-data': (0, $0bc2eb90818238b0$export$8934d2d012992d26),
    'reset-authenticator': (0, $3f7f18c2ab0a9585$export$3848083ec2ba1822),
    'reenroll-authenticator': (0, $01d7defe22e586cd$export$68450f7d95120a39),
    'reenroll-authenticator-warning': (0, $b8858a8d4e6b21f1$export$76c32f77c893cc76),
    'enroll-poll': (0, $424154aafceb9352$export$2e21ed88eacb421f)
};


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 





















const $f3d1c6d77a2426ef$export$41f2a66c4e5194e4 = {
    'select-enroll-profile': (0, $212ddcea3c24a56c$export$e96bca2a1d12839),
    'enroll-profile': (0, $d3be962163119444$export$528e7bbca764a356),
    'authenticator-enrollment-data': (0, $0bc2eb90818238b0$export$8934d2d012992d26),
    'select-authenticator-enroll': (0, $24f6ff18fdff9f7e$export$616f0495c05b2e5e),
    'enroll-poll': (0, $424154aafceb9352$export$2e21ed88eacb421f),
    'select-enrollment-channel': (0, $3072c8ad9c49584b$export$76e9de8555d9305a),
    'enrollment-channel-data': (0, $864eaa981b4d8073$export$c1bb923bb31fb3c9),
    'enroll-authenticator': (0, $31a06cf5017088f6$export$f7157015cf11193f),
    'skip': (0, $c2d0361b23182443$export$38d24f5c1eb0e4c0)
};


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 





















const $051864e9ca515fbb$export$a45fe067b739cc28 = {
    'identify': (0, $7cfc117d8867368b$export$e513146db6535bff),
    'select-authenticator-unlock-account': (0, $a6434eb5c788e82c$export$4171832ff6fa6156),
    'select-authenticator-authenticate': (0, $35afee0b90a6802f$export$c6bd0968af0af8c2),
    'challenge-authenticator': (0, $22a0f5c8a9156d59$export$2a2afff13894112f),
    'challenge-poll': (0, $904c7a51f07a766f$export$9da932f7758505ec),
    'authenticator-verification-data': (0, $c10b4ec5040a8f25$export$53b35b6113db0f85),
    'reenroll-authenticator-warning': (0, $b8858a8d4e6b21f1$export$76c32f77c893cc76)
};


function $61745cf23928bd38$export$d54c0e1d8c74ec70(oktaAuth, flow = 'default') {
    let remediators, actions, withCredentials = true;
    switch(flow){
        case 'register':
        case 'signup':
        case 'enrollProfile':
            remediators = (0, $f3d1c6d77a2426ef$export$41f2a66c4e5194e4);
            withCredentials = false;
            break;
        case 'recoverPassword':
        case 'resetPassword':
            remediators = (0, $1811f7c08e9cea2e$export$6e2e200e9a83635);
            actions = [
                'currentAuthenticator-recover',
                'currentAuthenticatorEnrollment-recover'
            ];
            withCredentials = false;
            break;
        case 'unlockAccount':
            remediators = (0, $051864e9ca515fbb$export$a45fe067b739cc28);
            withCredentials = false;
            actions = [
                'unlock-account'
            ];
            break;
        case 'authenticate':
        case 'login':
        case 'signin':
            remediators = (0, $6c5e4113413a2e41$export$d49108c385f05cb4);
            break;
        default:
            remediators = (0, $6c5e4113413a2e41$export$d49108c385f05cb4);
            break;
    }
    return {
        flow: flow,
        remediators: remediators,
        actions: actions,
        withCredentials: withCredentials
    };
}


async function $c52d3be87f40dbf7$export$70b61ad426ddbe54(authClient, options) {
    const meta = authClient.transactionManager.load();
    const flowSpec = (0, $61745cf23928bd38$export$d54c0e1d8c74ec70)(authClient, meta.flow);
    return (0, $e1f4dfc5b7d7bf3c$export$889ea624f2cb2c57)(authClient, Object.assign(Object.assign(Object.assign({}, options), flowSpec), {
        actions: [
            'cancel'
        ]
    }));
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ function $6eb5ac510c985444$export$b4dca17ba2d0280(hashOrSearch) {
    var plus2space = /\+/g;
    var paramSplit = /([^&=]+)=?([^&]*)/g;
    var fragment = hashOrSearch || '';
    if (fragment.charAt(0) === '#' && fragment.charAt(1) === '/') fragment = fragment.substring(2);
    if (fragment.charAt(0) === '#' || fragment.charAt(0) === '?') fragment = fragment.substring(1);
    var obj = {};
    var param;
    while(true){
        param = paramSplit.exec(fragment);
        if (!param) break;
        var key = param[1];
        var value = param[2];
        if (key === 'id_token' || key === 'access_token' || key === 'code') obj[key] = value;
        else obj[key] = decodeURIComponent(value.replace(plus2space, ' '));
    }
    return obj;
}


class $b8f22b0613a0540a$export$7924a0f6ccf797c7 extends (0, $9e9b1d88c1d52d57$export$2e2bcd8739ae039) {
    constructor(state, otp){
        super(`Enter the OTP code in the originating client: ${otp}`);
        this.name = 'EmailVerifyCallbackError';
        this.state = state;
        this.otp = otp;
    }
}
function $b8f22b0613a0540a$export$40d2063037956ab3(error) {
    return error.name === 'EmailVerifyCallbackError';
}
function $b8f22b0613a0540a$export$4081f8a7c53c0f1b(urlPath) {
    return /(otp=)/i.test(urlPath) && /(state=)/i.test(urlPath);
}
function $b8f22b0613a0540a$export$ecbd7ac47d2433c0(urlPath) {
    return (0, $6eb5ac510c985444$export$b4dca17ba2d0280)(urlPath);
}
async function $b8f22b0613a0540a$export$7e5e1762b97d9db3(authClient, search) {
    if ($b8f22b0613a0540a$export$4081f8a7c53c0f1b(search)) {
        const { state: state, otp: otp } = $b8f22b0613a0540a$export$ecbd7ac47d2433c0(search);
        if (authClient.idx.canProceed({
            state: state
        })) return await authClient.idx.proceed({
            state: state,
            otp: otp
        });
        else throw new $b8f22b0613a0540a$export$7924a0f6ccf797c7(state, otp);
    }
}




/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 



function $a92debe5f6bc98a3$export$2b22a8feb63a44b6(authClient, options = {}) {
    const meta = (0, $e0bbf14d4839e4ff$export$ee78659ae5675f26)(authClient, options);
    return !!(meta || options.stateHandle);
}
async function $a92debe5f6bc98a3$export$2eb0bdfd23e39c86(authClient, options = {}) {
    if (!$a92debe5f6bc98a3$export$2b22a8feb63a44b6(authClient, options)) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('Unable to proceed: saved transaction could not be loaded');
    let { flow: flow, state: state } = options;
    if (!flow) {
        const meta = (0, $e0bbf14d4839e4ff$export$ee78659ae5675f26)(authClient, {
            state: state
        });
        flow = meta === null || meta === void 0 ? void 0 : meta.flow;
    }
    return (0, $e1f4dfc5b7d7bf3c$export$889ea624f2cb2c57)(authClient, Object.assign(Object.assign({}, options), {
        flow: flow
    }));
}




async function $ddf1dadf84e2fb7f$export$e0c10349b2c5e1d4(authClient, options = {}) {
    var _a;
    const { withCredentials: withCredentials, exchangeCodeForTokens: exchangeCodeForTokens } = options;
    let transaction = await (0, $a92debe5f6bc98a3$export$2eb0bdfd23e39c86)(authClient, {
        startPolling: true,
        withCredentials: withCredentials,
        exchangeCodeForTokens: exchangeCodeForTokens
    });
    const meta = (0, $e0bbf14d4839e4ff$export$ee78659ae5675f26)(authClient);
    let availablePollingRemeditaions = (_a = meta === null || meta === void 0 ? void 0 : meta.remediations) === null || _a === void 0 ? void 0 : _a.find((remediation)=>remediation.includes('poll'));
    if (!(availablePollingRemeditaions === null || availablePollingRemeditaions === void 0 ? void 0 : availablePollingRemeditaions.length)) (0, $26320b9c410af87d$export$c106dd0671a0fc2d)('No polling remediations available at the current IDX flow stage');
    if (Number.isInteger(options.refresh)) return new Promise(function(resolve, reject) {
        setTimeout(async function() {
            var _a, _b;
            try {
                const refresh = (_b = (_a = transaction.nextStep) === null || _a === void 0 ? void 0 : _a.poll) === null || _b === void 0 ? void 0 : _b.refresh;
                if (refresh) resolve($ddf1dadf84e2fb7f$export$e0c10349b2c5e1d4(authClient, {
                    refresh: refresh
                }));
                else resolve(transaction);
            } catch (err) {
                reject(err);
            }
        }, options.refresh);
    });
    return transaction;
}



/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 

/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
async function $e533ec8a98e87e3f$export$e262da7ae6480481(authClient, options = {}) {
    authClient.transactionManager.clear();
    if (!options.enableLegacyMode) options.autoRemediate = false;
    return (0, $e1f4dfc5b7d7bf3c$export$889ea624f2cb2c57)(authClient, Object.assign({
        exchangeCodeForTokens: false
    }, options));
}





async function $6b8879c743ee6d13$export$6503ec6e8aabbaf(authClient, options = {}) {
    if (!(0, $e0bbf14d4839e4ff$export$ca280d73913750db)(authClient)) {
        const { enabledFeatures: enabledFeatures } = await (0, $e533ec8a98e87e3f$export$e262da7ae6480481)(authClient, Object.assign(Object.assign({}, options), {
            flow: 'register',
            autoRemediate: false
        }));
        if (!options.activationToken && enabledFeatures && !enabledFeatures.includes((0, $da481a8e31937f09$export$451922195d9391fb).REGISTRATION)) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('Registration is not supported based on your current org configuration.');
    }
    return (0, $e1f4dfc5b7d7bf3c$export$889ea624f2cb2c57)(authClient, Object.assign(Object.assign({}, options), {
        flow: 'register'
    }));
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 























async function $81d931f1d610b197$export$1743464e5cd3b116(authClient, options = {}) {
    const flowSpec = (0, $61745cf23928bd38$export$d54c0e1d8c74ec70)(authClient, 'recoverPassword');
    return (0, $e1f4dfc5b7d7bf3c$export$889ea624f2cb2c57)(authClient, Object.assign(Object.assign({}, options), flowSpec));
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 


async function $c0a87a8efb14da59$export$47d3290ab3a41fe5(authClient, url) {
    const meta = authClient.transactionManager.load();
    if (!meta) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('No transaction data was found in storage');
    const { codeVerifier: codeVerifier, state: savedState } = meta;
    const { searchParams: searchParams } = new URL(url);
    const state = searchParams.get('state');
    const interactionCode = searchParams.get('interaction_code');
    const error = searchParams.get('error');
    if (error) throw new (0, $88b6c0f3835294c2$export$2e2bcd8739ae039)(error, searchParams.get('error_description'));
    if (state !== savedState) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('State in redirect uri does not match with transaction state');
    if (!interactionCode) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('Unable to parse interaction_code from the url');
    const { tokens: tokens } = await authClient.token.exchangeCodeForTokens({
        interactionCode: interactionCode,
        codeVerifier: codeVerifier
    });
    authClient.tokenManager.setTokens(tokens);
}



/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 





async function $0a52411c6db4de2b$export$5edfb7a6a5229faf(authClient, options = {}) {
    options.flow = 'unlockAccount';
    if (!(0, $e0bbf14d4839e4ff$export$ca280d73913750db)(authClient)) {
        const { enabledFeatures: enabledFeatures } = await (0, $e533ec8a98e87e3f$export$e262da7ae6480481)(authClient, Object.assign(Object.assign({}, options), {
            autoRemediate: false
        }));
        if (enabledFeatures && !enabledFeatures.includes((0, $da481a8e31937f09$export$451922195d9391fb).ACCOUNT_UNLOCK)) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('Self Service Account Unlock is not supported based on your current org configuration.');
    }
    return (0, $e1f4dfc5b7d7bf3c$export$889ea624f2cb2c57)(authClient, Object.assign({}, options));
}



/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
function $c28e71e085ab11b4$export$376c3c4c19cb933a(error) {
    if (error.name !== 'OAuthError') return false;
    const oauthError = error;
    return oauthError.errorCode === 'interaction_required';
}
function $c28e71e085ab11b4$export$802bd45553941f4b(sdk, error) {
    if (error.name !== 'AuthApiError') return false;
    const authApiError = error;
    const errorResponse = authApiError.xhr;
    const responseJSON = errorResponse === null || errorResponse === void 0 ? void 0 : errorResponse.responseJSON;
    return sdk.options.pkce && (responseJSON === null || responseJSON === void 0 ? void 0 : responseJSON.error) === 'invalid_grant';
}
function $c28e71e085ab11b4$export$759948024dbf620d(error) {
    return (0, $b748049c070ffea6$export$65ac14d4981b453f)(error) && error.errorCode === 'invalid_grant' && error.errorSummary === 'The refresh token is invalid or expired.';
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ function $30cbbe4b83336d5c$export$36a79c777d90162d(hash) {
    return /[?&#](id|access)_token=/.test(hash);
}
function $30cbbe4b83336d5c$export$269560c031e7bdd3(hashOrSearch) {
    return /[?&#]code=/.test(hashOrSearch);
}
function $30cbbe4b83336d5c$export$292844be853a0f0(hashOrSearch) {
    return /[?&#]interaction_code=/.test(hashOrSearch);
}
function $30cbbe4b83336d5c$export$da6c08b50b1641ee(hashOrSearch) {
    return /[?&#]error=/.test(hashOrSearch) || /[?&#]error_description/.test(hashOrSearch);
}
function $30cbbe4b83336d5c$export$6a4ca2e010e82262(uri, sdk) {
    var authParams = sdk.options;
    if (!uri || !authParams.redirectUri) return false;
    return uri.indexOf(authParams.redirectUri) === 0;
}
function $30cbbe4b83336d5c$export$8148c7f7e9a4b885(options) {
    return options.pkce || options.responseType === 'code' || options.responseMode === 'query';
}
function $30cbbe4b83336d5c$export$85f1abab17a58c57(responseType, options) {
    let hasResponseType = false;
    if (Array.isArray(options.responseType) && options.responseType.length) hasResponseType = options.responseType.indexOf(responseType) >= 0;
    else hasResponseType = options.responseType === responseType;
    return hasResponseType;
}
function $30cbbe4b83336d5c$export$a3b47430310a8cd8(options) {
    var codeFlow = $30cbbe4b83336d5c$export$8148c7f7e9a4b885(options);
    var useQuery = codeFlow && options.responseMode !== 'fragment';
    return useQuery ? window.location.search : window.location.hash;
}
function $30cbbe4b83336d5c$export$3488c667ccc91890(sdk) {
    if (!$30cbbe4b83336d5c$export$6a4ca2e010e82262(window.location.href, sdk)) return false;
    var codeFlow = $30cbbe4b83336d5c$export$8148c7f7e9a4b885(sdk.options);
    var hashOrSearch = $30cbbe4b83336d5c$export$a3b47430310a8cd8(sdk.options);
    if ($30cbbe4b83336d5c$export$da6c08b50b1641ee(hashOrSearch)) return true;
    if (codeFlow) {
        var hasCode = $30cbbe4b83336d5c$export$269560c031e7bdd3(hashOrSearch) || $30cbbe4b83336d5c$export$292844be853a0f0(hashOrSearch);
        return hasCode;
    }
    return $30cbbe4b83336d5c$export$36a79c777d90162d(window.location.hash);
}
function $30cbbe4b83336d5c$export$5d0b3676a90f01bf(sdk, hashOrSearch) {
    if (!hashOrSearch) {
        if (!$30cbbe4b83336d5c$export$3488c667ccc91890(sdk)) return false;
        hashOrSearch = $30cbbe4b83336d5c$export$a3b47430310a8cd8(sdk.options);
    }
    return /(error=interaction_required)/i.test(hashOrSearch);
}





















var $b1c0d5cb62de8e2c$exports = {};

$parcel$export($b1c0d5cb62de8e2c$exports, "Remediator", function () { return $c5de53213e27f939$export$8ab7a5763733596; });
$parcel$export($b1c0d5cb62de8e2c$exports, "EnrollAuthenticator", function () { return $31a06cf5017088f6$export$f7157015cf11193f; });
$parcel$export($b1c0d5cb62de8e2c$exports, "EnrollPoll", function () { return $424154aafceb9352$export$2e21ed88eacb421f; });
$parcel$export($b1c0d5cb62de8e2c$exports, "SelectEnrollmentChannel", function () { return $3072c8ad9c49584b$export$76e9de8555d9305a; });
$parcel$export($b1c0d5cb62de8e2c$exports, "EnrollmentChannelData", function () { return $864eaa981b4d8073$export$c1bb923bb31fb3c9; });
$parcel$export($b1c0d5cb62de8e2c$exports, "ChallengeAuthenticator", function () { return $22a0f5c8a9156d59$export$2a2afff13894112f; });
$parcel$export($b1c0d5cb62de8e2c$exports, "ChallengePoll", function () { return $904c7a51f07a766f$export$9da932f7758505ec; });
$parcel$export($b1c0d5cb62de8e2c$exports, "ResetAuthenticator", function () { return $3f7f18c2ab0a9585$export$3848083ec2ba1822; });
$parcel$export($b1c0d5cb62de8e2c$exports, "EnrollProfile", function () { return $d3be962163119444$export$528e7bbca764a356; });
$parcel$export($b1c0d5cb62de8e2c$exports, "Identify", function () { return $7cfc117d8867368b$export$e513146db6535bff; });
$parcel$export($b1c0d5cb62de8e2c$exports, "ReEnrollAuthenticator", function () { return $01d7defe22e586cd$export$68450f7d95120a39; });
$parcel$export($b1c0d5cb62de8e2c$exports, "ReEnrollAuthenticatorWarning", function () { return $b8858a8d4e6b21f1$export$76c32f77c893cc76; });
$parcel$export($b1c0d5cb62de8e2c$exports, "RedirectIdp", function () { return $3e3cf603f9c74434$export$772831dc8c7313c0; });
$parcel$export($b1c0d5cb62de8e2c$exports, "SelectAuthenticatorAuthenticate", function () { return $35afee0b90a6802f$export$c6bd0968af0af8c2; });
$parcel$export($b1c0d5cb62de8e2c$exports, "SelectAuthenticatorEnroll", function () { return $24f6ff18fdff9f7e$export$616f0495c05b2e5e; });
$parcel$export($b1c0d5cb62de8e2c$exports, "SelectAuthenticatorUnlockAccount", function () { return $a6434eb5c788e82c$export$4171832ff6fa6156; });
$parcel$export($b1c0d5cb62de8e2c$exports, "SelectEnrollProfile", function () { return $212ddcea3c24a56c$export$e96bca2a1d12839; });
$parcel$export($b1c0d5cb62de8e2c$exports, "AuthenticatorVerificationData", function () { return $c10b4ec5040a8f25$export$53b35b6113db0f85; });
$parcel$export($b1c0d5cb62de8e2c$exports, "AuthenticatorEnrollmentData", function () { return $0bc2eb90818238b0$export$8934d2d012992d26; });
$parcel$export($b1c0d5cb62de8e2c$exports, "Skip", function () { return $c2d0361b23182443$export$38d24f5c1eb0e4c0; });
$parcel$export($b1c0d5cb62de8e2c$exports, "GenericRemediator", function () { return $4d7e23bce239b9e3$export$9e487c92809f61cb; });
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
























function $e32da978cb24bf1e$export$8e517878c6a5f058(sdk) {
    (0, $aea8b91481cf51cf$export$36c62655b1577e54)({
        remediators: $b1c0d5cb62de8e2c$exports,
        getFlowSpecification: $61745cf23928bd38$export$d54c0e1d8c74ec70
    });
    const boundStartTransaction = (0, $e533ec8a98e87e3f$export$e262da7ae6480481).bind(null, sdk);
    const idx = {
        interact: (0, $1ffb78727d57781d$export$20814a0f9b60f8cf).bind(null, sdk),
        introspect: (0, $ed622bb52a9c4e67$export$3b41a86e379f8f15).bind(null, sdk),
        makeIdxResponse: (0, $baf0710ab57b8a95$export$67f6ec95030789e9).bind(null, sdk),
        authenticate: (0, $54d6c7f881cde0a1$export$61bb00ddedae72e4).bind(null, sdk),
        register: (0, $6b8879c743ee6d13$export$6503ec6e8aabbaf).bind(null, sdk),
        start: boundStartTransaction,
        startTransaction: boundStartTransaction,
        poll: (0, $ddf1dadf84e2fb7f$export$e0c10349b2c5e1d4).bind(null, sdk),
        proceed: (0, $a92debe5f6bc98a3$export$2eb0bdfd23e39c86).bind(null, sdk),
        cancel: (0, $c52d3be87f40dbf7$export$70b61ad426ddbe54).bind(null, sdk),
        recoverPassword: (0, $81d931f1d610b197$export$1743464e5cd3b116).bind(null, sdk),
        handleInteractionCodeRedirect: (0, $c0a87a8efb14da59$export$47d3290ab3a41fe5).bind(null, sdk),
        isInteractionRequired: (0, $30cbbe4b83336d5c$export$5d0b3676a90f01bf).bind(null, sdk),
        isInteractionRequiredError: $c28e71e085ab11b4$export$376c3c4c19cb933a,
        handleEmailVerifyCallback: (0, $b8f22b0613a0540a$export$7e5e1762b97d9db3).bind(null, sdk),
        isEmailVerifyCallback: $b8f22b0613a0540a$export$4081f8a7c53c0f1b,
        parseEmailVerifyCallback: $b8f22b0613a0540a$export$ecbd7ac47d2433c0,
        isEmailVerifyCallbackError: $b8f22b0613a0540a$export$40d2063037956ab3,
        getSavedTransactionMeta: (0, $e0bbf14d4839e4ff$export$ee78659ae5675f26).bind(null, sdk),
        createTransactionMeta: (0, $e0bbf14d4839e4ff$export$88d345acadfc62dd).bind(null, sdk),
        getTransactionMeta: (0, $e0bbf14d4839e4ff$export$701cc743c44cf8ae).bind(null, sdk),
        saveTransactionMeta: (0, $e0bbf14d4839e4ff$export$dc27696b235944d6).bind(null, sdk),
        clearTransactionMeta: (0, $e0bbf14d4839e4ff$export$750593bdfc027325).bind(null, sdk),
        isTransactionMetaValid: $e0bbf14d4839e4ff$export$e14be23af70c5fd,
        setFlow: (flow)=>{
            sdk.options.flow = flow;
        },
        getFlow: ()=>{
            return sdk.options.flow;
        },
        canProceed: (0, $a92debe5f6bc98a3$export$2b22a8feb63a44b6).bind(null, sdk),
        unlockAccount: (0, $0a52411c6db4de2b$export$5edfb7a6a5229faf).bind(null, sdk)
    };
    return idx;
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 



function $2f2331dacfdaa6d6$export$2bc41dfbf048bfdc(OptionsConstructor) {
    class OktaAuthBase {
        constructor(...args){
            const options = new OptionsConstructor(args.length ? args[0] || {} : {});
            this.options = (0, $27ec06d649eea38f$export$1ef1ad6eb7b897a2)(options);
            this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($a724fe58895ee880$exports)))();
            this.features = $58f01731783bc4a6$exports;
        }
    }
    OktaAuthBase.features = $58f01731783bc4a6$exports;
    OktaAuthBase.constants = $a2c830cc0d95456a$exports;
    OktaAuthBase.features = OktaAuthBase.prototype.features = $58f01731783bc4a6$exports;
    Object.assign(OktaAuthBase, {
        constants: $a2c830cc0d95456a$exports
    });
    return OktaAuthBase;
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ function $7b18006d527823f4$export$32ec6248008f35d1(Base, StorageManager) {
    return class OktaAuthStorage extends Base {
        constructor(...args){
            super(...args);
            const { storageManager: storageManager, cookies: cookies, storageUtil: storageUtil } = this.options;
            this.storageManager = new StorageManager(storageManager, cookies, storageUtil);
        }
        clearStorage() {}
    };
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
var $375d8335527bcde6$exports = {};
// shim for using process in browser
var $375d8335527bcde6$var$process = $375d8335527bcde6$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $375d8335527bcde6$var$cachedSetTimeout;
var $375d8335527bcde6$var$cachedClearTimeout;
function $375d8335527bcde6$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $375d8335527bcde6$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $375d8335527bcde6$var$cachedSetTimeout = setTimeout;
        else $375d8335527bcde6$var$cachedSetTimeout = $375d8335527bcde6$var$defaultSetTimout;
    } catch (e) {
        $375d8335527bcde6$var$cachedSetTimeout = $375d8335527bcde6$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $375d8335527bcde6$var$cachedClearTimeout = clearTimeout;
        else $375d8335527bcde6$var$cachedClearTimeout = $375d8335527bcde6$var$defaultClearTimeout;
    } catch (e) {
        $375d8335527bcde6$var$cachedClearTimeout = $375d8335527bcde6$var$defaultClearTimeout;
    }
})();
function $375d8335527bcde6$var$runTimeout(fun) {
    if ($375d8335527bcde6$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($375d8335527bcde6$var$cachedSetTimeout === $375d8335527bcde6$var$defaultSetTimout || !$375d8335527bcde6$var$cachedSetTimeout) && setTimeout) {
        $375d8335527bcde6$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $375d8335527bcde6$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $375d8335527bcde6$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $375d8335527bcde6$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $375d8335527bcde6$var$runClearTimeout(marker) {
    if ($375d8335527bcde6$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($375d8335527bcde6$var$cachedClearTimeout === $375d8335527bcde6$var$defaultClearTimeout || !$375d8335527bcde6$var$cachedClearTimeout) && clearTimeout) {
        $375d8335527bcde6$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $375d8335527bcde6$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $375d8335527bcde6$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $375d8335527bcde6$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $375d8335527bcde6$var$queue = [];
var $375d8335527bcde6$var$draining = false;
var $375d8335527bcde6$var$currentQueue;
var $375d8335527bcde6$var$queueIndex = -1;
function $375d8335527bcde6$var$cleanUpNextTick() {
    if (!$375d8335527bcde6$var$draining || !$375d8335527bcde6$var$currentQueue) return;
    $375d8335527bcde6$var$draining = false;
    if ($375d8335527bcde6$var$currentQueue.length) $375d8335527bcde6$var$queue = $375d8335527bcde6$var$currentQueue.concat($375d8335527bcde6$var$queue);
    else $375d8335527bcde6$var$queueIndex = -1;
    if ($375d8335527bcde6$var$queue.length) $375d8335527bcde6$var$drainQueue();
}
function $375d8335527bcde6$var$drainQueue() {
    if ($375d8335527bcde6$var$draining) return;
    var timeout = $375d8335527bcde6$var$runTimeout($375d8335527bcde6$var$cleanUpNextTick);
    $375d8335527bcde6$var$draining = true;
    var len = $375d8335527bcde6$var$queue.length;
    while(len){
        $375d8335527bcde6$var$currentQueue = $375d8335527bcde6$var$queue;
        $375d8335527bcde6$var$queue = [];
        while(++$375d8335527bcde6$var$queueIndex < len)if ($375d8335527bcde6$var$currentQueue) $375d8335527bcde6$var$currentQueue[$375d8335527bcde6$var$queueIndex].run();
        $375d8335527bcde6$var$queueIndex = -1;
        len = $375d8335527bcde6$var$queue.length;
    }
    $375d8335527bcde6$var$currentQueue = null;
    $375d8335527bcde6$var$draining = false;
    $375d8335527bcde6$var$runClearTimeout(timeout);
}
$375d8335527bcde6$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $375d8335527bcde6$var$queue.push(new $375d8335527bcde6$var$Item(fun, args));
    if ($375d8335527bcde6$var$queue.length === 1 && !$375d8335527bcde6$var$draining) $375d8335527bcde6$var$runTimeout($375d8335527bcde6$var$drainQueue);
};
// v8 likes predictible objects
function $375d8335527bcde6$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$375d8335527bcde6$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$375d8335527bcde6$var$process.title = 'browser';
$375d8335527bcde6$var$process.browser = true;
$375d8335527bcde6$var$process.env = {};
$375d8335527bcde6$var$process.argv = [];
$375d8335527bcde6$var$process.version = ''; // empty string to avoid regexp issues
$375d8335527bcde6$var$process.versions = {};
function $375d8335527bcde6$var$noop() {}
$375d8335527bcde6$var$process.on = $375d8335527bcde6$var$noop;
$375d8335527bcde6$var$process.addListener = $375d8335527bcde6$var$noop;
$375d8335527bcde6$var$process.once = $375d8335527bcde6$var$noop;
$375d8335527bcde6$var$process.off = $375d8335527bcde6$var$noop;
$375d8335527bcde6$var$process.removeListener = $375d8335527bcde6$var$noop;
$375d8335527bcde6$var$process.removeAllListeners = $375d8335527bcde6$var$noop;
$375d8335527bcde6$var$process.emit = $375d8335527bcde6$var$noop;
$375d8335527bcde6$var$process.prependListener = $375d8335527bcde6$var$noop;
$375d8335527bcde6$var$process.prependOnceListener = $375d8335527bcde6$var$noop;
$375d8335527bcde6$var$process.listeners = function(name) {
    return [];
};
$375d8335527bcde6$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$375d8335527bcde6$var$process.cwd = function() {
    return '/';
};
$375d8335527bcde6$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$375d8335527bcde6$var$process.umask = function() {
    return 0;
};


class $ac3c3e25b341d7ae$export$cddb8b47eb189756 {
    constructor(){
        this.environments = [
            `okta-auth-js/${"8.0.1"}`
        ];
        this.maybeAddNodeEnvironment();
    }
    addEnvironment(env) {
        this.environments.push(env);
    }
    getHttpHeader() {
        return {
            'X-Okta-User-Agent-Extended': this.environments.join(' ')
        };
    }
    getVersion() {
        return "8.0.1";
    }
    maybeAddNodeEnvironment() {
        if ((0, $58f01731783bc4a6$export$4e09c449d6c407f7)() || !$375d8335527bcde6$exports || !$375d8335527bcde6$exports.versions) return;
        const { node: version } = $375d8335527bcde6$exports.versions;
        this.environments.push(`nodejs/${version}`);
    }
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ function $a8c003005f1efc4a$export$4a0dedceb084213c(authClient, headerName, headerValue) {
    authClient.options.headers = authClient.options.headers || {};
    authClient.options.headers[headerName] = headerValue;
}




function $42dc341ca5ee8859$export$b21483dcd2900eca(Base) {
    return class OktaAuthHttp extends Base {
        constructor(...args){
            super(...args);
            this._oktaUserAgent = new (0, $ac3c3e25b341d7ae$export$cddb8b47eb189756)();
            this.http = {
                setRequestHeader: (0, $a8c003005f1efc4a$export$4a0dedceb084213c).bind(null, this)
            };
        }
        setHeaders(headers) {
            this.options.headers = Object.assign({}, this.options.headers, headers);
        }
        getIssuerOrigin() {
            return this.options.issuer.split('/oauth2/')[0];
        }
        webfinger(opts) {
            var url = '/.well-known/webfinger' + (0, $47114d36cb1410d5$export$249cc09c933c4d7a)(opts);
            var options = {
                headers: {
                    'Accept': 'application/jrd+json'
                }
            };
            return (0, $0898b9c80798427c$export$3988ae62b71be9a3)(this, url, options);
        }
    };
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 

/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 

class $ec66963041d4efbe$export$7ab95d2dbda3c98c {
    constructor(options = {
        quiet: false
    }){
        this.queue = [];
        this.running = false;
        this.options = options;
    }
    push(method, thisObject, ...args) {
        return new Promise((resolve, reject)=>{
            if (this.queue.length > 0) {
                if (this.options.quiet !== false) (0, $26320b9c410af87d$export$c106dd0671a0fc2d)("Async method is being called but another async method is already running. The new method will be delayed until the previous method completes.");
            }
            this.queue.push({
                method: method,
                thisObject: thisObject,
                args: args,
                resolve: resolve,
                reject: reject
            });
            this.run();
        });
    }
    run() {
        if (this.running) return;
        if (this.queue.length === 0) return;
        this.running = true;
        var queueItem = this.queue.shift();
        var res = queueItem.method.apply(queueItem.thisObject, queueItem.args);
        if ((0, $53a4517fb157de9f$export$4369c812aac99591)(res)) res.then(queueItem.resolve, queueItem.reject).finally(()=>{
            this.running = false;
            this.run();
        });
        else {
            queueItem.resolve(res);
            this.running = false;
            this.run();
        }
    }
}






var $3c4b7e63f7cc6a72$exports = {};

$parcel$export($3c4b7e63f7cc6a72$exports, "base64ToBase64Url", function () { return $70ef0a6a68a02baf$export$3b91e21dac1023c6; });
$parcel$export($3c4b7e63f7cc6a72$exports, "base64UrlDecode", function () { return $70ef0a6a68a02baf$export$ea8ee39e6b15f86f; });
$parcel$export($3c4b7e63f7cc6a72$exports, "base64UrlToBase64", function () { return $70ef0a6a68a02baf$export$47c5265a25535d02; });
$parcel$export($3c4b7e63f7cc6a72$exports, "base64UrlToBuffer", function () { return $70ef0a6a68a02baf$export$74669d1cb8191241; });
$parcel$export($3c4b7e63f7cc6a72$exports, "base64UrlToString", function () { return $70ef0a6a68a02baf$export$aaa8dbd819f78142; });
$parcel$export($3c4b7e63f7cc6a72$exports, "bufferToBase64Url", function () { return $70ef0a6a68a02baf$export$271320a6f6117eda; });
$parcel$export($3c4b7e63f7cc6a72$exports, "stringToBase64Url", function () { return $70ef0a6a68a02baf$export$1494c20bc10d07ca; });
$parcel$export($3c4b7e63f7cc6a72$exports, "stringToBuffer", function () { return $70ef0a6a68a02baf$export$1e95461c937e230d; });
$parcel$export($3c4b7e63f7cc6a72$exports, "getOidcHash", function () { return $ad8aa8635d6368b3$export$7186055aabeea565; });
$parcel$export($3c4b7e63f7cc6a72$exports, "verifyToken", function () { return $872b60e5888cc8b7$export$c807668e63e7354b; });
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 

function $70ef0a6a68a02baf$export$1494c20bc10d07ca(str) {
    var b64 = btoa(str);
    return $70ef0a6a68a02baf$export$3b91e21dac1023c6(b64);
}
function $70ef0a6a68a02baf$export$3b91e21dac1023c6(b64) {
    return b64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
function $70ef0a6a68a02baf$export$47c5265a25535d02(b64u) {
    return b64u.replace(/-/g, '+').replace(/_/g, '/');
}
function $70ef0a6a68a02baf$export$aaa8dbd819f78142(b64u) {
    var b64 = $70ef0a6a68a02baf$export$47c5265a25535d02(b64u);
    switch(b64.length % 4){
        case 0:
            break;
        case 2:
            b64 += '==';
            break;
        case 3:
            b64 += '=';
            break;
        default:
            throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('Not a valid Base64Url');
    }
    var utf8 = atob(b64);
    try {
        return decodeURIComponent(escape(utf8));
    } catch (e) {
        return utf8;
    }
}
function $70ef0a6a68a02baf$export$1e95461c937e230d(str) {
    var buffer = new Uint8Array(str.length);
    for(var i = 0; i < str.length; i++)buffer[i] = str.charCodeAt(i);
    return buffer;
}
function $70ef0a6a68a02baf$export$ea8ee39e6b15f86f(str) {
    return atob($70ef0a6a68a02baf$export$47c5265a25535d02(str));
}
function $70ef0a6a68a02baf$export$74669d1cb8191241(b64u) {
    return Uint8Array.from($70ef0a6a68a02baf$export$ea8ee39e6b15f86f(b64u), (c)=>c.charCodeAt(0));
}
function $70ef0a6a68a02baf$export$271320a6f6117eda(bin) {
    return btoa(new Uint8Array(bin).reduce((s, byte)=>s + String.fromCharCode(byte), ''));
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
function $ad8aa8635d6368b3$export$7186055aabeea565(str) {
    var buffer = new TextEncoder().encode(str);
    return crypto.subtle.digest('SHA-256', buffer).then(function(arrayBuffer) {
        var intBuffer = new Uint8Array(arrayBuffer);
        var firstHalf = intBuffer.slice(0, 16);
        var hash = String.fromCharCode.apply(null, firstHalf);
        var b64u = (0, $70ef0a6a68a02baf$export$1494c20bc10d07ca)(hash);
        return b64u;
    });
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 

function $872b60e5888cc8b7$export$c807668e63e7354b(idToken, key) {
    key = (0, $27ec06d649eea38f$export$9cd59f9826255e47)(key);
    var algo = {
        name: 'RSASSA-PKCS1-v1_5',
        hash: {
            name: 'SHA-256'
        }
    };
    delete key.use;
    return crypto.subtle.importKey('jwk', key, algo, true, [
        'verify'
    ]).then(function(cryptoKey) {
        var jwt = idToken.split('.');
        var payload = (0, $70ef0a6a68a02baf$export$1e95461c937e230d)(jwt[0] + '.' + jwt[1]);
        var b64Signature = (0, $70ef0a6a68a02baf$export$ea8ee39e6b15f86f)(jwt[2]);
        var signature = (0, $70ef0a6a68a02baf$export$1e95461c937e230d)(b64Signature);
        return crypto.subtle.verify(algo, cryptoKey, signature, payload);
    });
}




/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 

function $068e90f61d5ff37f$var$dec2hex(dec) {
    return ('0' + dec.toString(16)).substr(-2);
}
function $068e90f61d5ff37f$var$getRandomString(length) {
    var a = new Uint8Array(Math.ceil(length / 2));
    a = crypto.getRandomValues(a);
    var str = Array.from(a, $068e90f61d5ff37f$var$dec2hex).join('');
    return str.slice(0, length);
}
function $068e90f61d5ff37f$var$generateVerifier(prefix) {
    var verifier = prefix || '';
    if (verifier.length < (0, $a2c830cc0d95456a$export$3429266d17ae1515)) verifier = verifier + $068e90f61d5ff37f$var$getRandomString((0, $a2c830cc0d95456a$export$3429266d17ae1515) - verifier.length);
    return encodeURIComponent(verifier).slice(0, (0, $a2c830cc0d95456a$export$65dcf38d91740c9a));
}
function $068e90f61d5ff37f$var$computeChallenge(str) {
    var buffer = new TextEncoder().encode(str);
    return crypto.subtle.digest('SHA-256', buffer).then(function(arrayBuffer) {
        var hash = String.fromCharCode.apply(null, new Uint8Array(arrayBuffer));
        var b64u = (0, $70ef0a6a68a02baf$export$1494c20bc10d07ca)(hash);
        return b64u;
    });
}
var $068e90f61d5ff37f$export$2e2bcd8739ae039 = {
    DEFAULT_CODE_CHALLENGE_METHOD: $a2c830cc0d95456a$export$ed9a92f7e3f906d8,
    generateVerifier: $068e90f61d5ff37f$var$generateVerifier,
    computeChallenge: $068e90f61d5ff37f$var$computeChallenge
};


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 


function $15e2e50b214bda39$export$4b61618bdb99cb7e(token) {
    var jwt = token.split('.');
    var decodedToken;
    try {
        decodedToken = {
            header: JSON.parse((0, $70ef0a6a68a02baf$export$aaa8dbd819f78142)(jwt[0])),
            payload: JSON.parse((0, $70ef0a6a68a02baf$export$aaa8dbd819f78142)(jwt[1])),
            signature: jwt[2]
        };
    } catch (e) {
        throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('Malformed token');
    }
    return decodedToken;
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 


function $4abe0183ac7e6b8e$export$7b9316c0224bc208(sdk) {
    const { pkce: pkce, clientId: clientId, redirectUri: redirectUri, responseType: responseType, responseMode: responseMode, scopes: scopes, acrValues: acrValues, maxAge: maxAge, state: state, ignoreSignature: ignoreSignature, dpop: dpop } = sdk.options;
    const defaultRedirectUri = (0, $58f01731783bc4a6$export$4e09c449d6c407f7)() ? window.location.href : undefined;
    return (0, $27ec06d649eea38f$export$1ef1ad6eb7b897a2)({
        pkce: pkce,
        clientId: clientId,
        redirectUri: redirectUri || defaultRedirectUri,
        responseType: responseType || [
            'token',
            'id_token'
        ],
        responseMode: responseMode,
        state: state || (0, $49723b489f007b5d$export$9ccd2716e53a229b)(),
        nonce: (0, $49723b489f007b5d$export$3ff59198e2333fc6)(),
        scopes: scopes || [
            'openid',
            'email'
        ],
        acrValues: acrValues,
        maxAge: maxAge,
        ignoreSignature: ignoreSignature,
        dpop: dpop
    });
}








/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 







/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 


const $cb03936b1b96259e$var$INDEXEDDB_NAME = 'OktaAuthJs';
const $cb03936b1b96259e$var$DB_KEY = 'DPoPKeys';
function $cb03936b1b96259e$export$283c6a56651b6b3(obj) {
    return ((0, $b748049c070ffea6$export$65ac14d4981b453f)(obj) || (0, $b748049c070ffea6$export$380e188e91bd13a1)(obj)) && obj.errorCode === 'use_dpop_nonce';
}
async function $cb03936b1b96259e$export$ff09bb9c32934be3(header, claims, signingKey) {
    const head = (0, $70ef0a6a68a02baf$export$1494c20bc10d07ca)(JSON.stringify(header));
    const body = (0, $70ef0a6a68a02baf$export$1494c20bc10d07ca)(JSON.stringify(claims));
    const signature = await crypto.subtle.sign({
        name: signingKey.algorithm.name
    }, signingKey, (0, $70ef0a6a68a02baf$export$1e95461c937e230d)(`${head}.${body}`));
    return `${head}.${body}.${(0, $70ef0a6a68a02baf$export$3b91e21dac1023c6)((0, $70ef0a6a68a02baf$export$271320a6f6117eda)(signature))}`;
}
function $cb03936b1b96259e$export$2838168319feb846(byteLen = 32) {
    return [
        ...crypto.getRandomValues(new Uint8Array(byteLen))
    ].map((v)=>v.toString(16)).join('');
}
async function $cb03936b1b96259e$export$a949d36eab55b41f() {
    const algorithm = {
        name: 'RSASSA-PKCS1-v1_5',
        hash: 'SHA-256',
        modulusLength: 2048,
        publicExponent: new Uint8Array([
            0x01,
            0x00,
            0x01
        ])
    };
    return crypto.subtle.generateKey(algorithm, false, [
        'sign',
        'verify'
    ]);
}
async function $cb03936b1b96259e$var$hashAccessToken(accessToken) {
    const buffer = new TextEncoder().encode(accessToken);
    const hash = await crypto.subtle.digest('SHA-256', buffer);
    return btoa(String.fromCharCode.apply(null, new Uint8Array(hash))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
function $cb03936b1b96259e$var$keyStore() {
    return new Promise((resolve, reject)=>{
        try {
            const indexedDB = window.indexedDB;
            const req = indexedDB.open($cb03936b1b96259e$var$INDEXEDDB_NAME, 1);
            req.onerror = function() {
                reject(req.error);
            };
            req.onupgradeneeded = function() {
                const db = req.result;
                db.createObjectStore($cb03936b1b96259e$var$DB_KEY);
            };
            req.onsuccess = function() {
                const db = req.result;
                const tx = db.transaction($cb03936b1b96259e$var$DB_KEY, 'readwrite');
                tx.onerror = function() {
                    reject(tx.error);
                };
                const store = tx.objectStore($cb03936b1b96259e$var$DB_KEY);
                resolve(store);
                tx.oncomplete = function() {
                    db.close();
                };
            };
        } catch (err) {
            reject(err);
        }
    });
}
async function $cb03936b1b96259e$var$invokeStoreMethod(method, ...args) {
    const store = await $cb03936b1b96259e$var$keyStore();
    return new Promise((resolve, reject)=>{
        const req = store[method](...args);
        req.onsuccess = function() {
            resolve(req);
        };
        req.onerror = function() {
            reject(req.error);
        };
    });
}
async function $cb03936b1b96259e$var$storeKeyPair(pairId, keyPair) {
    await $cb03936b1b96259e$var$invokeStoreMethod('add', keyPair, pairId);
    return keyPair;
}
async function $cb03936b1b96259e$export$846293577e1b1366(pairId) {
    if (pairId) {
        const req = await $cb03936b1b96259e$var$invokeStoreMethod('get', pairId);
        if (req.result) return req.result;
    }
    throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)(`Unable to locate dpop key pair required for refresh${pairId ? ` (${pairId})` : ''}`);
}
async function $cb03936b1b96259e$export$f33690fea154ad2d(pairId) {
    await $cb03936b1b96259e$var$invokeStoreMethod('delete', pairId);
}
async function $cb03936b1b96259e$export$20156800d73a71cb() {
    await $cb03936b1b96259e$var$invokeStoreMethod('clear');
}
async function $cb03936b1b96259e$export$791e6660a495fff2() {
    const keyPairId = $cb03936b1b96259e$export$2838168319feb846(4);
    const keyPair = await $cb03936b1b96259e$export$a949d36eab55b41f();
    await $cb03936b1b96259e$var$storeKeyPair(keyPairId, keyPair);
    return {
        keyPair: keyPair,
        keyPairId: keyPairId
    };
}
async function $cb03936b1b96259e$export$6afe52fd44d25eaf(revokedToken, tokens) {
    var _a;
    let shouldClear = false;
    const { accessToken: accessToken, refreshToken: refreshToken } = tokens;
    if (revokedToken === 'access' && accessToken && accessToken.tokenType === 'DPoP' && !refreshToken) shouldClear = true;
    if (revokedToken === 'refresh' && refreshToken && !accessToken) shouldClear = true;
    const pairId = (_a = accessToken === null || accessToken === void 0 ? void 0 : accessToken.dpopPairId) !== null && _a !== void 0 ? _a : refreshToken === null || refreshToken === void 0 ? void 0 : refreshToken.dpopPairId;
    if (shouldClear && pairId) await $cb03936b1b96259e$export$f33690fea154ad2d(pairId);
}
async function $cb03936b1b96259e$export$ac18780f7e57da({ keyPair: keyPair, url: url, method: method, nonce: nonce, accessToken: accessToken }) {
    const { kty: kty, crv: crv, e: e, n: n, x: x, y: y } = await crypto.subtle.exportKey('jwk', keyPair.publicKey);
    const header = {
        alg: 'RS256',
        typ: 'dpop+jwt',
        jwk: {
            kty: kty,
            crv: crv,
            e: e,
            n: n,
            x: x,
            y: y
        }
    };
    const claims = {
        htm: method,
        htu: url,
        iat: Math.floor(Date.now() / 1000),
        jti: $cb03936b1b96259e$export$2838168319feb846()
    };
    if (nonce) claims.nonce = nonce;
    if (accessToken) claims.ath = await $cb03936b1b96259e$var$hashAccessToken(accessToken);
    return $cb03936b1b96259e$export$ff09bb9c32934be3(header, claims, keyPair.privateKey);
}
async function $cb03936b1b96259e$export$5c0f49fa17cf96e6({ keyPair: keyPair, url: url, method: method, nonce: nonce }) {
    const params = {
        keyPair: keyPair,
        url: url,
        method: method
    };
    if (nonce) params.nonce = nonce;
    return $cb03936b1b96259e$export$ac18780f7e57da(params);
}


function $efbb8f2ae98c3f7e$var$validateOptions(options) {
    if (!options.clientId) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('A clientId must be specified in the OktaAuth constructor to get a token');
    if (!options.redirectUri) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('The redirectUri passed to /authorize must also be passed to /token');
    if (!options.authorizationCode && !options.interactionCode) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('An authorization code (returned from /authorize) must be passed to /token');
    if (!options.codeVerifier) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('The "codeVerifier" (generated and saved by your app) must be passed to /token');
}
function $efbb8f2ae98c3f7e$var$getPostData(sdk, options) {
    var params = (0, $27ec06d649eea38f$export$1ef1ad6eb7b897a2)({
        'client_id': options.clientId,
        'redirect_uri': options.redirectUri,
        'grant_type': options.interactionCode ? 'interaction_code' : 'authorization_code',
        'code_verifier': options.codeVerifier
    });
    if (options.interactionCode) params['interaction_code'] = options.interactionCode;
    else if (options.authorizationCode) params.code = options.authorizationCode;
    const { clientSecret: clientSecret } = sdk.options;
    if (clientSecret) params['client_secret'] = clientSecret;
    return (0, $47114d36cb1410d5$export$249cc09c933c4d7a)(params).slice(1);
}
async function $efbb8f2ae98c3f7e$var$makeTokenRequest(sdk, { url: url, data: data, nonce: nonce, dpopKeyPair: dpopKeyPair }) {
    var _a, _b;
    const method = 'POST';
    const headers = {
        'Content-Type': 'application/x-www-form-urlencoded'
    };
    if (sdk.options.dpop) {
        if (!dpopKeyPair) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('DPoP is configured but no key pair was provided');
        const proof = await (0, $cb03936b1b96259e$export$5c0f49fa17cf96e6)({
            url: url,
            method: method,
            nonce: nonce,
            keyPair: dpopKeyPair
        });
        headers.DPoP = proof;
    }
    try {
        const resp = await (0, $0898b9c80798427c$export$46f383001bf60e04)(sdk, {
            url: url,
            method: method,
            args: data,
            headers: headers
        });
        return resp;
    } catch (err) {
        if ((0, $cb03936b1b96259e$export$283c6a56651b6b3)(err) && !nonce) {
            const dpopNonce = (_a = err.resp) === null || _a === void 0 ? void 0 : _a.headers['dpop-nonce'];
            if (!dpopNonce) throw new (0, $59fa0e8f490d7132$export$2e2bcd8739ae039)({
                errorSummary: 'No `dpop-nonce` header found when required'
            }, (_b = err.resp) !== null && _b !== void 0 ? _b : undefined);
            return $efbb8f2ae98c3f7e$var$makeTokenRequest(sdk, {
                url: url,
                data: data,
                dpopKeyPair: dpopKeyPair,
                nonce: dpopNonce
            });
        }
        throw err;
    }
}
async function $efbb8f2ae98c3f7e$export$8c39800e8683fe3(sdk, options, urls) {
    $efbb8f2ae98c3f7e$var$validateOptions(options);
    var data = $efbb8f2ae98c3f7e$var$getPostData(sdk, options);
    const params = {
        url: urls.tokenUrl,
        data: data,
        dpopKeyPair: options === null || options === void 0 ? void 0 : options.dpopKeyPair
    };
    return $efbb8f2ae98c3f7e$var$makeTokenRequest(sdk, params);
}
async function $efbb8f2ae98c3f7e$export$be1491fbe5a1fece(sdk, options, refreshToken) {
    const data = Object.entries({
        client_id: options.clientId,
        grant_type: 'refresh_token',
        scope: refreshToken.scopes.join(' '),
        refresh_token: refreshToken.refreshToken
    }).map(function([name, value]) {
        return name + '=' + encodeURIComponent(value);
    }).join('&');
    let url = refreshToken.tokenUrl;
    if (options.extraParams && Object.keys(options.extraParams).length >= 1) url += (0, $47114d36cb1410d5$export$249cc09c933c4d7a)(options.extraParams);
    const params = {
        url: url,
        data: data,
        dpopKeyPair: options === null || options === void 0 ? void 0 : options.dpopKeyPair
    };
    return $efbb8f2ae98c3f7e$var$makeTokenRequest(sdk, params);
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 




/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 




function $87b7382bf28df7f4$export$2d91ea80a5884e36(sdk, issuer) {
    var authServerUri = issuer || sdk.options.issuer;
    return (0, $0898b9c80798427c$export$3988ae62b71be9a3)(sdk, authServerUri + '/.well-known/openid-configuration', {
        cacheResponse: true
    });
}
function $87b7382bf28df7f4$export$a47fb462a08de82f(sdk, issuer, kid) {
    var httpCache = sdk.storageManager.getHttpCache(sdk.options.cookies);
    return $87b7382bf28df7f4$export$2d91ea80a5884e36(sdk, issuer).then(function(wellKnown) {
        var jwksUri = wellKnown['jwks_uri'];
        var cacheContents = httpCache.getStorage();
        var cachedResponse = cacheContents[jwksUri];
        if (cachedResponse && Date.now() / 1000 < cachedResponse.expiresAt) {
            var cachedKey = (0, $27ec06d649eea38f$export$71aa6c912b956294)(cachedResponse.response.keys, {
                kid: kid
            });
            if (cachedKey) return cachedKey;
        }
        httpCache.clearStorage(jwksUri);
        return (0, $0898b9c80798427c$export$3988ae62b71be9a3)(sdk, jwksUri, {
            cacheResponse: true
        }).then(function(res) {
            var key = (0, $27ec06d649eea38f$export$71aa6c912b956294)(res.keys, {
                kid: kid
            });
            if (key) return key;
            throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('The key id, ' + kid + ', was not found in the server\'s keys');
        });
    });
}






/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
function $5af11a528ac4dae5$export$d9ea6b8d907b5e9a(sdk, claims, validationParams) {
    const aud = validationParams.clientId;
    const iss = validationParams.issuer;
    const nonce = validationParams.nonce;
    const acr = validationParams.acrValues;
    if (!claims || !iss || !aud) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('The jwt, iss, and aud arguments are all required');
    if (nonce && claims.nonce !== nonce) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('OAuth flow response nonce doesn\'t match request nonce');
    const now = Math.floor(Date.now() / 1000);
    if (claims.iss !== iss) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('The issuer [' + claims.iss + '] ' + 'does not match [' + iss + ']');
    if (Array.isArray(claims.aud) && claims.aud.indexOf(aud) < 0 || !Array.isArray(claims.aud) && claims.aud !== aud) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('The audience [' + claims.aud + '] ' + 'does not match [' + aud + ']');
    if (acr && claims.acr !== acr) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('The acr [' + claims.acr + '] ' + 'does not match acr_values [' + acr + ']');
    if (claims.iat > claims.exp) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('The JWT expired before it was issued');
    if (!sdk.options.ignoreLifetime) {
        if (now - sdk.options.maxClockSkew > claims.exp) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('The JWT expired and is no longer valid');
        if (claims.iat > now + sdk.options.maxClockSkew) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('The JWT was issued in the future');
    }
}




async function $8648561f49557246$export$c807668e63e7354b(sdk, token, validationParams) {
    if (!token || !token.idToken) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('Only idTokens may be verified');
    const jwt = (0, $15e2e50b214bda39$export$4b61618bdb99cb7e)(token.idToken);
    const configuredIssuer = (validationParams === null || validationParams === void 0 ? void 0 : validationParams.issuer) || sdk.options.issuer;
    const { issuer: issuer } = await (0, $87b7382bf28df7f4$export$2d91ea80a5884e36)(sdk, configuredIssuer);
    const validationOptions = Object.assign({
        clientId: sdk.options.clientId,
        ignoreSignature: sdk.options.ignoreSignature
    }, validationParams, {
        issuer: issuer
    });
    (0, $5af11a528ac4dae5$export$d9ea6b8d907b5e9a)(sdk, jwt.payload, validationOptions);
    if (validationOptions.ignoreSignature == true || !sdk.features.isTokenVerifySupported()) return token;
    const key = await (0, $87b7382bf28df7f4$export$a47fb462a08de82f)(sdk, token.issuer, jwt.header.kid);
    const valid = await (0, $872b60e5888cc8b7$export$c807668e63e7354b)(token.idToken, key);
    if (!valid) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('The token signature is not valid');
    if (validationParams && validationParams.accessToken && token.claims.at_hash) {
        const hash = await (0, $ad8aa8635d6368b3$export$7186055aabeea565)(validationParams.accessToken);
        if (hash !== token.claims.at_hash) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('Token hash verification failed');
    }
    return token;
}







function $59b50982bf3b5050$var$validateResponse(res, oauthParams) {
    if (res['error'] && res['error_description']) throw new (0, $88b6c0f3835294c2$export$2e2bcd8739ae039)(res['error'], res['error_description']);
    if (res.state !== oauthParams.state) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('OAuth flow response state doesn\'t match request state');
}
async function $59b50982bf3b5050$export$8e4ec53b32974551(sdk, tokenParams, res, urls) {
    var _a, _b;
    const pkce = sdk.options.pkce !== false;
    tokenParams = tokenParams || (0, $4abe0183ac7e6b8e$export$7b9316c0224bc208)(sdk);
    $59b50982bf3b5050$var$validateResponse(res, tokenParams);
    if (pkce && (res.code || res.interaction_code)) return sdk.token.exchangeCodeForTokens(Object.assign({}, tokenParams, {
        authorizationCode: res.code,
        interactionCode: res.interaction_code
    }), urls);
    urls = urls || (0, $49723b489f007b5d$export$1a398a8b679ebb76)(sdk, tokenParams);
    let responseType = tokenParams.responseType || [];
    if (!Array.isArray(responseType) && responseType !== 'none') responseType = [
        responseType
    ];
    let scopes;
    if (res.scope) scopes = res.scope.split(' ');
    else scopes = (0, $27ec06d649eea38f$export$9cd59f9826255e47)(tokenParams.scopes);
    const clientId = tokenParams.clientId || sdk.options.clientId;
    if (tokenParams.dpop) {
        const { allowBearerTokens: allowBearerTokens } = (_b = (_a = sdk.options) === null || _a === void 0 ? void 0 : _a.dpopOptions) !== null && _b !== void 0 ? _b : {
            allowBearerTokens: false
        };
        if (!allowBearerTokens && res.token_type !== 'DPoP') throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('Unable to parse OAuth flow response: DPoP was configured but "token_type" was not DPoP');
    }
    const tokenDict = {};
    const expiresIn = res.expires_in;
    const tokenType = res.token_type;
    const accessToken = res.access_token;
    const idToken = res.id_token;
    const refreshToken = res.refresh_token;
    const now = Math.floor(Date.now() / 1000);
    if (accessToken) {
        tokenDict.accessToken = {
            accessToken: accessToken,
            expiresAt: Number(expiresIn) + now,
            tokenType: tokenType,
            scopes: scopes,
            authorizeUrl: urls.authorizeUrl,
            userinfoUrl: urls.userinfoUrl
        };
        if (sdk.options.decodeAccessTokens) {
            const accessJwt = sdk.token.decode(accessToken);
            tokenDict.accessToken.claims = accessJwt.payload;
        }
        if (tokenParams.dpopPairId) tokenDict.accessToken.dpopPairId = tokenParams.dpopPairId;
        if (tokenParams.extraParams) tokenDict.accessToken.extraParams = tokenParams.extraParams;
    }
    if (refreshToken) {
        tokenDict.refreshToken = {
            refreshToken: refreshToken,
            expiresAt: Number(expiresIn) + now,
            scopes: scopes,
            tokenUrl: urls.tokenUrl,
            authorizeUrl: urls.authorizeUrl,
            issuer: urls.issuer
        };
        if (tokenParams.dpopPairId) tokenDict.refreshToken.dpopPairId = tokenParams.dpopPairId;
        if (tokenParams.extraParams) tokenDict.refreshToken.extraParams = tokenParams.extraParams;
    }
    if (idToken) {
        const idJwt = sdk.token.decode(idToken);
        const idTokenObj = {
            idToken: idToken,
            claims: idJwt.payload,
            expiresAt: idJwt.payload.exp - idJwt.payload.iat + now,
            scopes: scopes,
            authorizeUrl: urls.authorizeUrl,
            issuer: urls.issuer,
            clientId: clientId
        };
        if (tokenParams.extraParams) idTokenObj.extraParams = tokenParams.extraParams;
        const validationParams = {
            clientId: clientId,
            issuer: urls.issuer,
            nonce: tokenParams.nonce,
            accessToken: accessToken,
            acrValues: tokenParams.acrValues
        };
        if (tokenParams.ignoreSignature !== undefined) validationParams.ignoreSignature = tokenParams.ignoreSignature;
        await (0, $8648561f49557246$export$c807668e63e7354b)(sdk, idTokenObj, validationParams);
        tokenDict.idToken = idTokenObj;
    }
    if (responseType.indexOf('token') !== -1 && !tokenDict.accessToken) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('Unable to parse OAuth flow response: response type "token" was requested but "access_token" was not returned.');
    if (responseType.indexOf('id_token') !== -1 && !tokenDict.idToken) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('Unable to parse OAuth flow response: response type "id_token" was requested but "id_token" was not returned.');
    return {
        tokens: tokenDict,
        state: res.state,
        code: res.code,
        responseType: responseType
    };
}



async function $af686b972b438d35$export$b0d0dc26369c3965(sdk, tokenParams, urls) {
    urls = urls || (0, $49723b489f007b5d$export$1a398a8b679ebb76)(sdk, tokenParams);
    tokenParams = Object.assign({}, (0, $4abe0183ac7e6b8e$export$7b9316c0224bc208)(sdk), (0, $27ec06d649eea38f$export$9cd59f9826255e47)(tokenParams));
    const { authorizationCode: authorizationCode, interactionCode: interactionCode, codeVerifier: codeVerifier, clientId: clientId, redirectUri: redirectUri, scopes: scopes, ignoreSignature: ignoreSignature, state: state, acrValues: acrValues, dpop: dpop, dpopPairId: dpopPairId, extraParams: extraParams } = tokenParams;
    const getTokenOptions = {
        clientId: clientId,
        redirectUri: redirectUri,
        authorizationCode: authorizationCode,
        interactionCode: interactionCode,
        codeVerifier: codeVerifier,
        dpop: dpop
    };
    const responseType = [
        'token'
    ];
    if (scopes.indexOf('openid') !== -1) responseType.push('id_token');
    const handleResponseOptions = {
        clientId: clientId,
        redirectUri: redirectUri,
        scopes: scopes,
        responseType: responseType,
        ignoreSignature: ignoreSignature,
        acrValues: acrValues,
        extraParams: extraParams
    };
    try {
        if (dpop) {
            if (dpopPairId) {
                const keyPair = await (0, $cb03936b1b96259e$export$846293577e1b1366)(dpopPairId);
                getTokenOptions.dpopKeyPair = keyPair;
                handleResponseOptions.dpop = dpop;
                handleResponseOptions.dpopPairId = dpopPairId;
            } else {
                const { keyPair: keyPair, keyPairId: keyPairId } = await (0, $cb03936b1b96259e$export$791e6660a495fff2)();
                getTokenOptions.dpopKeyPair = keyPair;
                handleResponseOptions.dpop = dpop;
                handleResponseOptions.dpopPairId = keyPairId;
            }
        }
        const oauthResponse = await (0, $efbb8f2ae98c3f7e$export$8c39800e8683fe3)(sdk, getTokenOptions, urls);
        const tokenResponse = await (0, $59b50982bf3b5050$export$8e4ec53b32974551)(sdk, handleResponseOptions, oauthResponse, urls);
        tokenResponse.code = authorizationCode;
        tokenResponse.state = state;
        return tokenResponse;
    } finally{
        sdk.transactionManager.clear();
    }
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 







async function $9f45372d34b84f21$export$801fe16824f675f7(sdk, accessTokenObject, idTokenObject) {
    if (!accessTokenObject) accessTokenObject = (await sdk.tokenManager.getTokens()).accessToken;
    if (!idTokenObject) idTokenObject = (await sdk.tokenManager.getTokens()).idToken;
    if (!accessTokenObject || !(0, $169337ef2792d6db$export$3a59e0981c18db3c)(accessTokenObject)) return Promise.reject(new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('getUserInfo requires an access token object'));
    if (!idTokenObject || !(0, $169337ef2792d6db$export$e183da9b0d22b235)(idTokenObject)) return Promise.reject(new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('getUserInfo requires an ID token object'));
    const options = {
        url: accessTokenObject.userinfoUrl,
        method: 'GET',
        accessToken: accessTokenObject.accessToken
    };
    if (sdk.options.dpop) {
        const headers = await sdk.getDPoPAuthorizationHeaders(Object.assign(Object.assign({}, options), {
            accessToken: accessTokenObject
        }));
        options.headers = headers;
        delete options.accessToken;
    }
    return (0, $0898b9c80798427c$export$46f383001bf60e04)(sdk, options).then((userInfo)=>{
        if (userInfo.sub === idTokenObject.claims.sub) return userInfo;
        return Promise.reject(new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('getUserInfo request was rejected due to token mismatch'));
    }).catch(function(err) {
        var _a;
        if (err instanceof (0, $7c31c4e6cdd411e2$export$2e2bcd8739ae039) && !sdk.options.dpop) {
            const { error: error, errorDescription: errorDescription } = err;
            throw new (0, $88b6c0f3835294c2$export$2e2bcd8739ae039)(error, errorDescription);
        }
        if (!sdk.options.dpop) {
            let e = err;
            if (err instanceof (0, $59fa0e8f490d7132$export$2e2bcd8739ae039) && ((_a = err === null || err === void 0 ? void 0 : err.meta) === null || _a === void 0 ? void 0 : _a.wwwAuthHeader)) e = (0, $7c31c4e6cdd411e2$export$2e2bcd8739ae039).parseHeader(err.meta.wwwAuthHeader);
            if (e instanceof (0, $7c31c4e6cdd411e2$export$2e2bcd8739ae039)) {
                const { error: error, errorDescription: errorDescription } = e;
                throw new (0, $88b6c0f3835294c2$export$2e2bcd8739ae039)(error, errorDescription);
            }
        }
        throw err;
    });
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 

const $e5c0cf9b5ba78c65$var$DEFAULT_TIMEOUT = 120000;
function $e5c0cf9b5ba78c65$export$f03a6b845d3fb58b(eventTarget, name, fn) {
    if (eventTarget.addEventListener) eventTarget.addEventListener(name, fn);
    else eventTarget.attachEvent('on' + name, fn);
}
function $e5c0cf9b5ba78c65$export$b03e9483f936dccb(eventTarget, name, fn) {
    if (eventTarget.removeEventListener) eventTarget.removeEventListener(name, fn);
    else eventTarget.detachEvent('on' + name, fn);
}
function $e5c0cf9b5ba78c65$export$ce24fe47d96d8eb0(src) {
    var iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = src;
    return document.body.appendChild(iframe);
}
function $e5c0cf9b5ba78c65$export$2e9eedb5256b66f6(src, options) {
    var title = options.popupTitle || 'External Identity Provider User Authentication';
    var appearance = "toolbar=no, scrollbars=yes, resizable=yes, top=100, left=500, width=600, height=600";
    return window.open(src, title, appearance);
}
function $e5c0cf9b5ba78c65$export$ecdcd46aa04cd83(sdk, timeout, state) {
    var responseHandler;
    var timeoutId;
    var msgReceivedOrTimeout = new Promise(function(resolve, reject) {
        responseHandler = function responseHandler(e) {
            if (!e.data || e.data.state !== state) return;
            if (e.origin !== sdk.getIssuerOrigin()) return reject(new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('The request does not match client configuration'));
            resolve(e.data);
        };
        $e5c0cf9b5ba78c65$export$f03a6b845d3fb58b(window, 'message', responseHandler);
        timeoutId = setTimeout(function() {
            reject(new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('OAuth flow timed out'));
        }, timeout || $e5c0cf9b5ba78c65$var$DEFAULT_TIMEOUT);
    });
    return msgReceivedOrTimeout.finally(function() {
        clearTimeout(timeoutId);
        $e5c0cf9b5ba78c65$export$b03e9483f936dccb(window, 'message', responseHandler);
    });
}
function $e5c0cf9b5ba78c65$export$ad7c836560b19da9(sdk, timeout, channel, state) {
    let timeoutId;
    const promise = new Promise((resolve, reject)=>{
        channel.onmessage = (event)=>{
            if (!event.isTrusted || !event.data) return;
            if (typeof event.data === 'object' && state === event.data.state) return resolve(Object.assign({}, event.data));
            reject(new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('Unable to complete auth code exchange'));
        };
        timeoutId = setTimeout(function() {
            reject(new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('OAuth flow timed out'));
        }, timeout || $e5c0cf9b5ba78c65$var$DEFAULT_TIMEOUT);
    });
    return promise.finally(()=>{
        clearTimeout(timeoutId);
        channel.close();
    });
}





/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 





function $2a423e05498af5f7$export$4026c5574adb7ca7(sdk) {
    if (!sdk.features.isPKCESupported()) {
        var errorMessage = 'PKCE requires a modern browser with encryption support running in a secure context.';
        if (!sdk.features.isHTTPS()) errorMessage += '\nThe current page is not being served with HTTPS protocol. PKCE requires secure HTTPS protocol.';
        if (!sdk.features.hasTextEncoder()) errorMessage += '\n"TextEncoder" is not defined. To use PKCE, you may need to include a polyfill/shim for this browser.';
        throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)(errorMessage);
    }
}
async function $2a423e05498af5f7$export$64f0d9bafa89e3eb(sdk, codeChallengeMethod) {
    codeChallengeMethod = codeChallengeMethod || sdk.options.codeChallengeMethod || (0, $a2c830cc0d95456a$export$ed9a92f7e3f906d8);
    const wellKnownResponse = await (0, $87b7382bf28df7f4$export$2d91ea80a5884e36)(sdk);
    var methods = wellKnownResponse['code_challenge_methods_supported'] || [];
    if (methods.indexOf(codeChallengeMethod) === -1) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('Invalid code_challenge_method');
    return codeChallengeMethod;
}
async function $2a423e05498af5f7$export$12649ebf497694d5(sdk, tokenParams) {
    let { codeVerifier: codeVerifier, codeChallenge: codeChallenge, codeChallengeMethod: codeChallengeMethod } = tokenParams;
    codeChallenge = codeChallenge || sdk.options.codeChallenge;
    if (!codeChallenge) {
        $2a423e05498af5f7$export$4026c5574adb7ca7(sdk);
        codeVerifier = codeVerifier || (0, $068e90f61d5ff37f$export$2e2bcd8739ae039).generateVerifier();
        codeChallenge = await (0, $068e90f61d5ff37f$export$2e2bcd8739ae039).computeChallenge(codeVerifier);
    }
    codeChallengeMethod = await $2a423e05498af5f7$export$64f0d9bafa89e3eb(sdk, codeChallengeMethod);
    tokenParams = Object.assign(Object.assign({}, tokenParams), {
        responseType: 'code',
        codeVerifier: codeVerifier,
        codeChallenge: codeChallenge,
        codeChallengeMethod: codeChallengeMethod
    });
    return tokenParams;
}
async function $2a423e05498af5f7$export$6aa55a8b4ad50d4b(sdk, tokenParams = {}) {
    const defaults = (0, $4abe0183ac7e6b8e$export$7b9316c0224bc208)(sdk);
    tokenParams = Object.assign(Object.assign({}, defaults), tokenParams);
    if (tokenParams.dpop && !sdk.features.isDPoPSupported()) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('DPoP has been configured, but is not supported by browser');
    if (tokenParams.pkce === false) return tokenParams;
    return $2a423e05498af5f7$export$12649ebf497694d5(sdk, tokenParams);
}



/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 




function $5cbb5d54eb34cb9e$export$8f846dfe2e3e1886(tokenParams) {
    if (!tokenParams.clientId) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('A clientId must be specified in the OktaAuth constructor to get a token');
    if ((0, $53a4517fb157de9f$export$844ec244b1367d54)(tokenParams.responseType) && tokenParams.responseType.indexOf(' ') !== -1) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('Multiple OAuth responseTypes must be defined as an array');
    var oauthParams = {
        'client_id': tokenParams.clientId,
        'code_challenge': tokenParams.codeChallenge,
        'code_challenge_method': tokenParams.codeChallengeMethod,
        'display': tokenParams.display,
        'idp': tokenParams.idp,
        'idp_scope': tokenParams.idpScope,
        'login_hint': tokenParams.loginHint,
        'max_age': tokenParams.maxAge,
        'nonce': tokenParams.nonce,
        'prompt': tokenParams.prompt,
        'redirect_uri': tokenParams.redirectUri,
        'response_mode': tokenParams.responseMode,
        'response_type': tokenParams.responseType,
        'sessionToken': tokenParams.sessionToken,
        'state': tokenParams.state,
        'acr_values': tokenParams.acrValues,
        'enroll_amr_values': tokenParams.enrollAmrValues
    };
    oauthParams = (0, $27ec06d649eea38f$export$1ef1ad6eb7b897a2)(oauthParams);
    [
        'idp_scope',
        'response_type',
        'enroll_amr_values'
    ].forEach(function(mayBeArray) {
        if (Array.isArray(oauthParams[mayBeArray])) oauthParams[mayBeArray] = oauthParams[mayBeArray].join(' ');
    });
    if (tokenParams.responseType.indexOf('id_token') !== -1 && tokenParams.scopes.indexOf('openid') === -1) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('openid scope must be specified in the scopes argument when requesting an id_token');
    else if (tokenParams.scopes) oauthParams.scope = tokenParams.scopes.join(' ');
    return oauthParams;
}
function $5cbb5d54eb34cb9e$export$bee25a1283797bf6(tokenParams) {
    var oauthQueryParams = $5cbb5d54eb34cb9e$export$8f846dfe2e3e1886(tokenParams);
    return (0, $47114d36cb1410d5$export$249cc09c933c4d7a)(Object.assign(Object.assign({}, oauthQueryParams), tokenParams.extraParams && Object.assign({}, tokenParams.extraParams)));
}



function $78da090902f62c5d$export$257b2d10b709d8ef(sdk, options) {
    if (arguments.length > 2) return Promise.reject(new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('As of version 3.0, "getToken" takes only a single set of options'));
    options = options || {};
    const popupWindow = options.popupWindow;
    options.popupWindow = undefined;
    return (0, $2a423e05498af5f7$export$6aa55a8b4ad50d4b)(sdk, options).then(function(tokenParams) {
        var sessionTokenOverrides = {
            prompt: 'none',
            responseMode: 'okta_post_message',
            display: null
        };
        var idpOverrides = {
            display: 'popup'
        };
        if (options.sessionToken) Object.assign(tokenParams, sessionTokenOverrides);
        else if (options.idp) Object.assign(tokenParams, idpOverrides);
        var requestUrl, endpoint, urls;
        urls = (0, $49723b489f007b5d$export$1a398a8b679ebb76)(sdk, tokenParams);
        endpoint = options.codeVerifier ? urls.tokenUrl : urls.authorizeUrl;
        requestUrl = endpoint + (0, $5cbb5d54eb34cb9e$export$bee25a1283797bf6)(tokenParams);
        var flowType = 'IMPLICIT';
        if (tokenParams.sessionToken || tokenParams.display === null) flowType = 'IFRAME';
        else if (tokenParams.display === 'popup') flowType = options.idpPopup ? 'IDP_POPUP' : 'POPUP';
        else flowType = 'IMPLICIT';
        switch(flowType){
            case 'IFRAME':
                var iframePromise = (0, $e5c0cf9b5ba78c65$export$ecdcd46aa04cd83)(sdk, options.timeout, tokenParams.state);
                var iframeEl = (0, $e5c0cf9b5ba78c65$export$ce24fe47d96d8eb0)(requestUrl);
                return iframePromise.then(function(res) {
                    return (0, $59b50982bf3b5050$export$8e4ec53b32974551)(sdk, tokenParams, res, urls);
                }).finally(function() {
                    var _a;
                    if (document.body.contains(iframeEl)) (_a = iframeEl.parentElement) === null || _a === void 0 || _a.removeChild(iframeEl);
                });
            case 'POPUP':
                var oauthPromise;
                if (tokenParams.responseMode === 'okta_post_message') {
                    if (!sdk.features.isPopupPostMessageSupported()) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('This browser doesn\'t have full postMessage support');
                    oauthPromise = (0, $e5c0cf9b5ba78c65$export$ecdcd46aa04cd83)(sdk, options.timeout, tokenParams.state);
                }
                if (popupWindow) popupWindow.location.assign(requestUrl);
                var popupPromise = new Promise(function(resolve, reject) {
                    var closePoller = setInterval(function() {
                        if (!popupWindow || popupWindow.closed) {
                            clearInterval(closePoller);
                            reject(new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('Unable to parse OAuth flow response'));
                        }
                    }, 100);
                    oauthPromise.then(function(res) {
                        clearInterval(closePoller);
                        resolve(res);
                    }).catch(function(err) {
                        clearInterval(closePoller);
                        reject(err);
                    });
                });
                return popupPromise.then(function(res) {
                    return (0, $59b50982bf3b5050$export$8e4ec53b32974551)(sdk, tokenParams, res, urls);
                }).finally(function() {
                    if (popupWindow && !popupWindow.closed) popupWindow.close();
                });
            case 'IDP_POPUP':
                var idpPromise = (0, $e5c0cf9b5ba78c65$export$ad7c836560b19da9)(sdk, options.timeout, options.channel, tokenParams.state);
                if (popupWindow) popupWindow.location.assign(requestUrl);
                else throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('Unable to open popup window');
                return idpPromise.then(function(res) {
                    return (0, $59b50982bf3b5050$export$8e4ec53b32974551)(sdk, tokenParams, res, urls);
                });
            default:
                throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('The full page redirect flow is not supported');
        }
    });
}


function $1650d4f04415148f$export$86fab758b5485bc6(sdk, options) {
    if (arguments.length > 2) return Promise.reject(new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('As of version 3.0, "getWithoutPrompt" takes only a single set of options'));
    options = (0, $27ec06d649eea38f$export$9cd59f9826255e47)(options) || {};
    Object.assign(options, {
        prompt: 'none',
        responseMode: 'okta_post_message',
        display: null
    });
    return (0, $78da090902f62c5d$export$257b2d10b709d8ef)(sdk, options);
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 










function $0a38b482d1793b9c$export$20ffac22eb7d93bb(sdk, options) {
    if (arguments.length > 2) return Promise.reject(new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('As of version 3.0, "getWithPopup" takes only a single set of options'));
    const { initialPath: initialPath } = options, params = (0, $a8b9237c404681df$export$3c9a16f847548506)(options, [
        "initialPath"
    ]);
    const popupWindow = (0, $e5c0cf9b5ba78c65$export$2e9eedb5256b66f6)(initialPath !== null && initialPath !== void 0 ? initialPath : '/', params);
    options = (0, $27ec06d649eea38f$export$9cd59f9826255e47)(params) || {};
    Object.assign(params, {
        display: 'popup',
        responseMode: 'okta_post_message',
        popupWindow: popupWindow
    });
    return (0, $78da090902f62c5d$export$257b2d10b709d8ef)(sdk, params);
}
function $0a38b482d1793b9c$export$cb67fa6698dae00e(sdk, options) {
    try {
        if (!BroadcastChannel) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('Modern browser with `BroadcastChannel` support is required to use this method');
        if (!options.redirectUri) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('`redirectUri` is a required param for `getWithIDPPopup`');
        if (!options.state) options.state = (0, $49723b489f007b5d$export$9ccd2716e53a229b)();
        const popupWindow = (0, $e5c0cf9b5ba78c65$export$2e9eedb5256b66f6)('/', options);
        const channel = new BroadcastChannel(`popup-callback:${options.state}`);
        options = (0, $27ec06d649eea38f$export$9cd59f9826255e47)(options) || {};
        Object.assign(options, {
            display: 'popup',
            responseMode: 'query',
            popupWindow: popupWindow,
            idpPopup: true,
            channel: channel
        });
        let cancelPromise;
        const promise = new Promise((resolve, reject)=>{
            cancelPromise = reject;
            return (0, $78da090902f62c5d$export$257b2d10b709d8ef)(sdk, options).then((res)=>resolve(res)).catch((err)=>reject(err));
        });
        const cancel = ()=>{
            channel.close();
            cancelPromise(new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('Popup flow canceled'));
        };
        return {
            promise: promise,
            cancel: cancel
        };
    } catch (err) {
        return {
            promise: Promise.reject(err),
            cancel: ()=>{}
        };
    }
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 






async function $fc83c33d9d1a9f5a$export$79d5ce5cae1648a2(sdk, options) {
    if (arguments.length > 2) return Promise.reject(new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('As of version 3.0, "getWithRedirect" takes only a single set of options'));
    options = (0, $27ec06d649eea38f$export$9cd59f9826255e47)(options) || {};
    const tokenParams = await (0, $2a423e05498af5f7$export$6aa55a8b4ad50d4b)(sdk, options);
    const meta = (0, $328526ed047f5aea$export$6fd737cbc709c406)(sdk, tokenParams);
    const requestUrl = meta.urls.authorizeUrl + (0, $5cbb5d54eb34cb9e$export$bee25a1283797bf6)(tokenParams);
    sdk.transactionManager.save(meta);
    if (sdk.options.setLocation) sdk.options.setLocation(requestUrl);
    else window.location.assign(requestUrl);
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 









function $5e42ca1549474cf0$var$removeHash(sdk) {
    var nativeHistory = sdk.token.parseFromUrl._getHistory();
    var nativeDoc = sdk.token.parseFromUrl._getDocument();
    var nativeLoc = sdk.token.parseFromUrl._getLocation();
    if (nativeHistory && nativeHistory.replaceState) nativeHistory.replaceState(null, nativeDoc.title, nativeLoc.pathname + nativeLoc.search);
    else nativeLoc.hash = '';
}
function $5e42ca1549474cf0$var$removeSearch(sdk) {
    var nativeHistory = sdk.token.parseFromUrl._getHistory();
    var nativeDoc = sdk.token.parseFromUrl._getDocument();
    var nativeLoc = sdk.token.parseFromUrl._getLocation();
    if (nativeHistory && nativeHistory.replaceState) nativeHistory.replaceState(null, nativeDoc.title, nativeLoc.pathname + nativeLoc.hash);
    else nativeLoc.search = '';
}
function $5e42ca1549474cf0$export$be434a300f162664(sdk) {
    var defaultResponseMode = sdk.options.pkce ? 'query' : 'fragment';
    var responseMode = sdk.options.responseMode || defaultResponseMode;
    return responseMode;
}
function $5e42ca1549474cf0$export$3cd68b6fe191e121(sdk, options) {
    options = options || {};
    if ((0, $53a4517fb157de9f$export$844ec244b1367d54)(options)) options = {
        url: options
    };
    else options;
    var url = options.url;
    var responseMode = options.responseMode || $5e42ca1549474cf0$export$be434a300f162664(sdk);
    var nativeLoc = sdk.token.parseFromUrl._getLocation();
    var paramStr;
    if (responseMode === 'query') paramStr = url ? url.substring(url.indexOf('?')) : nativeLoc.search;
    else paramStr = url ? url.substring(url.indexOf('#')) : nativeLoc.hash;
    if (!paramStr) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('Unable to parse a token from the url');
    return (0, $6eb5ac510c985444$export$b4dca17ba2d0280)(paramStr);
}
function $5e42ca1549474cf0$export$8d34907d21770eb0(sdk, options) {
    const responseMode = options.responseMode || $5e42ca1549474cf0$export$be434a300f162664(sdk);
    responseMode === 'query' ? $5e42ca1549474cf0$var$removeSearch(sdk) : $5e42ca1549474cf0$var$removeHash(sdk);
}
async function $5e42ca1549474cf0$export$519dd9458d58afc6(sdk, options) {
    options = options || {};
    if ((0, $53a4517fb157de9f$export$844ec244b1367d54)(options)) options = {
        url: options
    };
    else options;
    const res = $5e42ca1549474cf0$export$3cd68b6fe191e121(sdk, options);
    const state = res.state;
    const oauthParams = sdk.transactionManager.load({
        state: state
    });
    if (!oauthParams) {
        if (sdk.options.pkce) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('Could not load PKCE codeVerifier from storage. This may indicate the auth flow has already completed or multiple auth flows are executing concurrently.', undefined);
        throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('Unable to retrieve OAuth redirect params from storage');
    }
    const urls = oauthParams.urls;
    delete oauthParams.urls;
    if (!options.url) $5e42ca1549474cf0$export$8d34907d21770eb0(sdk, options);
    return (0, $59b50982bf3b5050$export$8e4ec53b32974551)(sdk, oauthParams, res, urls).catch((err)=>{
        if (!(0, $c28e71e085ab11b4$export$376c3c4c19cb933a)(err)) sdk.transactionManager.clear({
            state: state
        });
        throw err;
    }).then((res)=>{
        sdk.transactionManager.clear({
            state: state
        });
        return res;
    });
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 



/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
function $96cac7096dbfbfef$export$6b33887d89873bf(a, b) {
    return a.refreshToken === b.refreshToken;
}
function $96cac7096dbfbfef$export$d61273b9c30fe75d(err) {
    if (!(0, $b748049c070ffea6$export$4fe744aeb810d543)(err)) return false;
    if (!err.xhr || !err.xhr.responseJSON) return false;
    const { responseJSON: responseJSON } = err.xhr;
    if (responseJSON.error === 'invalid_grant') return true;
    return false;
}






async function $9229284e344fbb76$export$baff7bee392261c2(sdk, tokenParams, refreshTokenObject) {
    const { clientId: clientId, dpop: dpop } = sdk.options;
    if (!clientId) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('A clientId must be specified in the OktaAuth constructor to renew tokens');
    try {
        const renewTokenParams = Object.assign({}, tokenParams, {
            clientId: clientId
        });
        if (refreshTokenObject.extraParams) renewTokenParams.extraParams = refreshTokenObject.extraParams;
        const endpointParams = Object.assign({}, renewTokenParams);
        if (dpop) {
            const keyPair = await (0, $cb03936b1b96259e$export$846293577e1b1366)(refreshTokenObject === null || refreshTokenObject === void 0 ? void 0 : refreshTokenObject.dpopPairId);
            endpointParams.dpopKeyPair = keyPair;
            renewTokenParams.dpop = dpop;
            renewTokenParams.dpopPairId = refreshTokenObject.dpopPairId;
        }
        const tokenResponse = await (0, $efbb8f2ae98c3f7e$export$be1491fbe5a1fece)(sdk, endpointParams, refreshTokenObject);
        const urls = (0, $49723b489f007b5d$export$1a398a8b679ebb76)(sdk, tokenParams);
        const { tokens: tokens } = await (0, $59b50982bf3b5050$export$8e4ec53b32974551)(sdk, renewTokenParams, tokenResponse, urls);
        const { refreshToken: refreshToken } = tokens;
        if (refreshToken && !(0, $96cac7096dbfbfef$export$6b33887d89873bf)(refreshToken, refreshTokenObject)) sdk.tokenManager.updateRefreshToken(refreshToken);
        return tokens;
    } catch (err) {
        if ((0, $c28e71e085ab11b4$export$759948024dbf620d)(err)) sdk.tokenManager.removeRefreshToken();
        throw err;
    }
}


function $cf496d83135d1afb$var$throwInvalidTokenError() {
    throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('Renew must be passed a token with an array of scopes and an accessToken or idToken');
}
function $cf496d83135d1afb$var$getSingleToken(originalToken, tokens) {
    if ((0, $169337ef2792d6db$export$e183da9b0d22b235)(originalToken)) return tokens.idToken;
    if ((0, $169337ef2792d6db$export$3a59e0981c18db3c)(originalToken)) return tokens.accessToken;
    $cf496d83135d1afb$var$throwInvalidTokenError();
}
async function $cf496d83135d1afb$export$9eb5d800a6b02c7(sdk, token) {
    if (!(0, $169337ef2792d6db$export$e183da9b0d22b235)(token) && !(0, $169337ef2792d6db$export$3a59e0981c18db3c)(token)) $cf496d83135d1afb$var$throwInvalidTokenError();
    let tokens = sdk.tokenManager.getTokensSync();
    if (tokens.refreshToken) {
        tokens = await (0, $9229284e344fbb76$export$baff7bee392261c2)(sdk, {
            scopes: token.scopes
        }, tokens.refreshToken);
        return $cf496d83135d1afb$var$getSingleToken(token, tokens);
    }
    var responseType;
    if (sdk.options.pkce) responseType = 'code';
    else if ((0, $169337ef2792d6db$export$3a59e0981c18db3c)(token)) responseType = 'token';
    else responseType = 'id_token';
    const { scopes: scopes, authorizeUrl: authorizeUrl, userinfoUrl: userinfoUrl, issuer: issuer, dpopPairId: dpopPairId, extraParams: extraParams } = token;
    return (0, $1650d4f04415148f$export$86fab758b5485bc6)(sdk, {
        responseType: responseType,
        scopes: scopes,
        authorizeUrl: authorizeUrl,
        userinfoUrl: userinfoUrl,
        issuer: issuer,
        dpopPairId: dpopPairId,
        extraParams: extraParams
    }).then(function(res) {
        return $cf496d83135d1afb$var$getSingleToken(token, res.tokens);
    });
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 








async function $2bae0fac0b4aea2e$export$55c3ad1b2cc96723(sdk, options) {
    var _a;
    const tokens = (_a = options === null || options === void 0 ? void 0 : options.tokens) !== null && _a !== void 0 ? _a : sdk.tokenManager.getTokensSync();
    if (tokens.refreshToken) return (0, $9229284e344fbb76$export$baff7bee392261c2)(sdk, options || {}, tokens.refreshToken);
    if (!tokens.accessToken && !tokens.idToken) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('renewTokens() was called but there is no existing token');
    const accessToken = tokens.accessToken || {};
    const idToken = tokens.idToken || {};
    const scopes = accessToken.scopes || idToken.scopes;
    if (!scopes) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('renewTokens: invalid tokens: could not read scopes');
    const authorizeUrl = accessToken.authorizeUrl || idToken.authorizeUrl;
    if (!authorizeUrl) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('renewTokens: invalid tokens: could not read authorizeUrl');
    const userinfoUrl = accessToken.userinfoUrl || sdk.options.userinfoUrl;
    const issuer = idToken.issuer || sdk.options.issuer;
    const dpopPairId = accessToken === null || accessToken === void 0 ? void 0 : accessToken.dpopPairId;
    const extraParams = (accessToken === null || accessToken === void 0 ? void 0 : accessToken.extraParams) || (idToken === null || idToken === void 0 ? void 0 : idToken.extraParams);
    options = Object.assign({
        scopes: scopes,
        authorizeUrl: authorizeUrl,
        userinfoUrl: userinfoUrl,
        issuer: issuer,
        dpopPairId: dpopPairId,
        extraParams: extraParams
    }, options);
    if (sdk.options.pkce) options.responseType = 'code';
    else {
        const { responseType: responseType } = (0, $4abe0183ac7e6b8e$export$7b9316c0224bc208)(sdk);
        options.responseType = responseType;
    }
    return (0, $1650d4f04415148f$export$86fab758b5485bc6)(sdk, options).then((res)=>res.tokens);
}



/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 





async function $5671362762822e02$export$2428f6ba65615593(sdk, token) {
    let accessToken = '';
    let refreshToken = '';
    if (token) {
        accessToken = token.accessToken;
        refreshToken = token.refreshToken;
    }
    if (!accessToken && !refreshToken) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('A valid access or refresh token object is required');
    var clientId = sdk.options.clientId;
    var clientSecret = sdk.options.clientSecret;
    if (!clientId) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('A clientId must be specified in the OktaAuth constructor to revoke a token');
    var revokeUrl = (0, $49723b489f007b5d$export$1a398a8b679ebb76)(sdk).revokeUrl;
    var args = (0, $47114d36cb1410d5$export$249cc09c933c4d7a)({
        token_type_hint: refreshToken ? 'refresh_token' : 'access_token',
        token: refreshToken || accessToken
    }).slice(1);
    var creds = clientSecret ? btoa(`${clientId}:${clientSecret}`) : btoa(clientId);
    return (0, $0898b9c80798427c$export$299ba2dee77727e9)(sdk, revokeUrl, args, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': 'Basic ' + creds
        }
    });
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 







const $6da5e8ce5d62609b$var$hintMap = {
    accessToken: 'access_token',
    idToken: 'id_token',
    refreshToken: 'refresh_token'
};
async function $6da5e8ce5d62609b$export$bb69de165ef829cf(sdk, kind, token) {
    var _a;
    let issuer;
    let clientId = sdk.options.clientId;
    let clientSecret = sdk.options.clientSecret;
    if (!token) token = sdk.tokenManager.getTokens()[kind];
    if (!token) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)(`unable to find ${kind} in storage or fn params`);
    if (kind !== (0, $169337ef2792d6db$export$8b9d26ab11394711).ACCESS) issuer = token === null || token === void 0 ? void 0 : token.issuer;
    else issuer = (_a = token === null || token === void 0 ? void 0 : token.claims) === null || _a === void 0 ? void 0 : _a.iss;
    issuer = issuer || sdk.options.issuer;
    if (!clientId) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('A clientId must be specified in the OktaAuth constructor to introspect a token');
    if (!issuer) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('Unable to find issuer');
    const { introspection_endpoint: introspectUrl } = await (0, $87b7382bf28df7f4$export$2d91ea80a5884e36)(sdk, issuer);
    const authHeader = clientSecret ? btoa(`${clientId}:${clientSecret}`) : btoa(clientId);
    const args = (0, $47114d36cb1410d5$export$249cc09c933c4d7a)({
        token_type_hint: $6da5e8ce5d62609b$var$hintMap[kind],
        token: token[kind]
    }).slice(1);
    return (0, $0898b9c80798427c$export$299ba2dee77727e9)(sdk, introspectUrl, args, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': 'Basic ' + authHeader
        }
    });
}







/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 

/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
function $f0a92dbc11db74a7$export$a6906103e688e7c4(sdk, params) {
    const issuer = sdk.options.issuer;
    const urls = (0, $49723b489f007b5d$export$1a398a8b679ebb76)(sdk, params);
    const oauthMeta = {
        issuer: issuer,
        urls: urls,
        clientId: params.clientId,
        redirectUri: params.redirectUri,
        responseType: params.responseType,
        responseMode: params.responseMode,
        state: params.state,
        acrValues: params.acrValues,
        enrollAmrValues: params.enrollAmrValues
    };
    return oauthMeta;
}





/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 

/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 


function $162d197a473eca91$export$3925a584390f92ef(sdk) {
    const { clientId: clientId, redirectUri: redirectUri, responseMode: responseMode, state: state } = sdk.options;
    const defaultRedirectUri = (0, $58f01731783bc4a6$export$4e09c449d6c407f7)() ? window.location.href : undefined;
    return (0, $27ec06d649eea38f$export$1ef1ad6eb7b897a2)({
        clientId: clientId,
        redirectUri: redirectUri || defaultRedirectUri,
        responseMode: responseMode,
        state: state || (0, $49723b489f007b5d$export$9ccd2716e53a229b)(),
        responseType: 'none',
        prompt: 'enroll_authenticator'
    });
}


function $d686ba380379e900$var$prepareParams(params) {
    params = Object.assign(Object.assign({}, params), {
        responseType: 'none',
        prompt: 'enroll_authenticator',
        maxAge: 0
    });
    if (!params.enrollAmrValues) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('enroll_amr_values must be specified');
    if (!params.acrValues) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('acr_values must be specified');
    delete params.scopes;
    delete params.nonce;
    return params;
}
function $d686ba380379e900$export$a510a85512435dc5(sdk, options) {
    return $d686ba380379e900$var$prepareParams(Object.assign(Object.assign({}, (0, $162d197a473eca91$export$3925a584390f92ef)(sdk)), options));
}




function $b9d05f69a4102956$export$9f57def5b7ea6999(sdk, options) {
    options = (0, $27ec06d649eea38f$export$9cd59f9826255e47)(options) || {};
    const params = (0, $d686ba380379e900$export$a510a85512435dc5)(sdk, options);
    const meta = (0, $f0a92dbc11db74a7$export$a6906103e688e7c4)(sdk, params);
    const requestUrl = meta.urls.authorizeUrl + (0, $5cbb5d54eb34cb9e$export$bee25a1283797bf6)(params);
    sdk.transactionManager.save(meta);
    if (sdk.options.setLocation) sdk.options.setLocation(requestUrl);
    else window.location.assign(requestUrl);
}


function $04e26313d2a8666c$export$bd3db6d56a375929(sdk, queue) {
    const useQueue = (method)=>{
        return (0, $ec66963041d4efbe$export$7ab95d2dbda3c98c).prototype.push.bind(queue, method, null);
    };
    const getWithRedirectFn = useQueue((0, $fc83c33d9d1a9f5a$export$79d5ce5cae1648a2).bind(null, sdk));
    const parseFromUrlFn = useQueue((0, $5e42ca1549474cf0$export$519dd9458d58afc6).bind(null, sdk));
    const parseFromUrlApi = Object.assign(parseFromUrlFn, {
        _getHistory: function() {
            return window.history;
        },
        _getLocation: function() {
            return window.location;
        },
        _getDocument: function() {
            return window.document;
        }
    });
    const token = {
        prepareTokenParams: (0, $2a423e05498af5f7$export$6aa55a8b4ad50d4b).bind(null, sdk),
        exchangeCodeForTokens: (0, $af686b972b438d35$export$b0d0dc26369c3965).bind(null, sdk),
        getWithoutPrompt: (0, $1650d4f04415148f$export$86fab758b5485bc6).bind(null, sdk),
        getWithPopup: (0, $0a38b482d1793b9c$export$20ffac22eb7d93bb).bind(null, sdk),
        getWithIDPPopup: (0, $0a38b482d1793b9c$export$cb67fa6698dae00e).bind(null, sdk),
        getWithRedirect: getWithRedirectFn,
        parseFromUrl: parseFromUrlApi,
        decode: (0, $15e2e50b214bda39$export$4b61618bdb99cb7e),
        revoke: (0, $5671362762822e02$export$2428f6ba65615593).bind(null, sdk),
        renew: (0, $cf496d83135d1afb$export$9eb5d800a6b02c7).bind(null, sdk),
        renewTokensWithRefresh: (0, $9229284e344fbb76$export$baff7bee392261c2).bind(null, sdk),
        renewTokens: (0, $2bae0fac0b4aea2e$export$55c3ad1b2cc96723).bind(null, sdk),
        getUserInfo: (accessTokenObject, idTokenObject)=>{
            return (0, $9f45372d34b84f21$export$801fe16824f675f7)(sdk, accessTokenObject, idTokenObject);
        },
        verify: (0, $8648561f49557246$export$c807668e63e7354b).bind(null, sdk),
        isLoginRedirect: (0, $30cbbe4b83336d5c$export$3488c667ccc91890).bind(null, sdk),
        introspect: (0, $6da5e8ce5d62609b$export$bb69de165ef829cf).bind(null, sdk)
    };
    const toWrap = [
        'getWithoutPrompt',
        'getWithPopup',
        'revoke',
        'renew',
        'renewTokensWithRefresh',
        'renewTokens'
    ];
    toWrap.forEach((key)=>{
        token[key] = useQueue(token[key]);
    });
    return token;
}
function $04e26313d2a8666c$export$deedb2680d4aa92(sdk) {
    return {
        authorize: {
            enrollAuthenticator: (0, $b9d05f69a4102956$export$9f57def5b7ea6999).bind(null, sdk)
        }
    };
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 







/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 


function $c9f017fd53ed5840$export$56cd50188d1996d0(token, type) {
    if (!(0, $169337ef2792d6db$export$e183da9b0d22b235)(token) && !(0, $169337ef2792d6db$export$3a59e0981c18db3c)(token) && !(0, $169337ef2792d6db$export$178a2c036dbf8815)(token)) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('Token must be an Object with scopes, expiresAt, and one of: an idToken, accessToken, or refreshToken property');
    if (type === 'accessToken' && !(0, $169337ef2792d6db$export$3a59e0981c18db3c)(token)) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('invalid accessToken');
    if (type === 'idToken' && !(0, $169337ef2792d6db$export$e183da9b0d22b235)(token)) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('invalid idToken');
    if (type === 'refreshToken' && !(0, $169337ef2792d6db$export$178a2c036dbf8815)(token)) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('invalid refreshToken');
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ class $167cec4933b8ccd1$export$2e2bcd8739ae039 {
    constructor(localOffset){
        this.localOffset = parseInt(localOffset || 0);
    }
    static create() {
        var localOffset = 0;
        return new $167cec4933b8ccd1$export$2e2bcd8739ae039(localOffset);
    }
    now() {
        var now = (Date.now() + this.localOffset) / 1000;
        return now;
    }
}



/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ const $c2154470a1d6c1a5$export$c0d46e39554d86f6 = 'expired';
const $c2154470a1d6c1a5$export$421812244c1f12f0 = 'renewed';
const $c2154470a1d6c1a5$export$e9f9d3905a889e02 = 'added';
const $c2154470a1d6c1a5$export$9995ae835670bd28 = 'removed';
const $c2154470a1d6c1a5$export$abaffdbbab0f22ba = 'error';
const $c2154470a1d6c1a5$export$772c2bdc9dda0203 = 'set_storage';


const $03a630e742f1c53b$var$DEFAULT_OPTIONS = {
    autoRenew: true,
    autoRemove: true,
    syncStorage: true,
    clearPendingRemoveTokens: true,
    storage: undefined,
    expireEarlySeconds: 30,
    storageKey: (0, $a2c830cc0d95456a$export$45d1f6fc12799d40)
};
function $03a630e742f1c53b$var$defaultState() {
    return {
        expireTimeouts: {},
        renewPromise: null
    };
}
class $03a630e742f1c53b$export$aa9349e63a87bac1 {
    constructor(sdk, options = {}){
        this.sdk = sdk;
        this.emitter = sdk.emitter;
        if (!this.emitter) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('Emitter should be initialized before TokenManager');
        options = Object.assign({}, $03a630e742f1c53b$var$DEFAULT_OPTIONS, (0, $27ec06d649eea38f$export$1ef1ad6eb7b897a2)(options));
        if (!(0, $58f01731783bc4a6$export$ec8a6426516240fc)()) options.expireEarlySeconds = $03a630e742f1c53b$var$DEFAULT_OPTIONS.expireEarlySeconds;
        this.options = options;
        const storageOptions = (0, $27ec06d649eea38f$export$1ef1ad6eb7b897a2)({
            storageKey: options.storageKey,
            secure: options.secure
        });
        if (typeof options.storage === 'object') storageOptions.storageProvider = options.storage;
        else if (options.storage) storageOptions.storageType = options.storage;
        this.storage = sdk.storageManager.getTokenStorage(Object.assign(Object.assign({}, storageOptions), {
            useSeparateCookies: true
        }));
        this.clock = (0, $167cec4933b8ccd1$export$2e2bcd8739ae039).create();
        this.state = $03a630e742f1c53b$var$defaultState();
    }
    on(event, handler, context) {
        if (context) this.emitter.on(event, handler, context);
        else this.emitter.on(event, handler);
    }
    off(event, handler) {
        if (handler) this.emitter.off(event, handler);
        else this.emitter.off(event);
    }
    start() {
        if (this.options.clearPendingRemoveTokens) this.clearPendingRemoveTokens();
        this.setExpireEventTimeoutAll();
        this.state.started = true;
    }
    stop() {
        this.clearExpireEventTimeoutAll();
        this.state.started = false;
    }
    isStarted() {
        return !!this.state.started;
    }
    getOptions() {
        return (0, $27ec06d649eea38f$export$9cd59f9826255e47)(this.options);
    }
    getExpireTime(token) {
        const expireEarlySeconds = this.options.expireEarlySeconds || 0;
        var expireTime = token.expiresAt - expireEarlySeconds;
        return expireTime;
    }
    hasExpired(token) {
        var expireTime = this.getExpireTime(token);
        return expireTime <= this.clock.now();
    }
    emitExpired(key, token) {
        this.emitter.emit((0, $c2154470a1d6c1a5$export$c0d46e39554d86f6), key, token);
    }
    emitRenewed(key, freshToken, oldToken) {
        this.emitter.emit((0, $c2154470a1d6c1a5$export$421812244c1f12f0), key, freshToken, oldToken);
    }
    emitAdded(key, token) {
        this.emitter.emit((0, $c2154470a1d6c1a5$export$e9f9d3905a889e02), key, token);
    }
    emitRemoved(key, token) {
        this.emitter.emit((0, $c2154470a1d6c1a5$export$9995ae835670bd28), key, token);
    }
    emitError(error) {
        this.emitter.emit((0, $c2154470a1d6c1a5$export$abaffdbbab0f22ba), error);
    }
    clearExpireEventTimeout(key) {
        clearTimeout(this.state.expireTimeouts[key]);
        delete this.state.expireTimeouts[key];
        this.state.renewPromise = null;
    }
    clearExpireEventTimeoutAll() {
        var expireTimeouts = this.state.expireTimeouts;
        for(var key in expireTimeouts){
            if (!Object.prototype.hasOwnProperty.call(expireTimeouts, key)) continue;
            this.clearExpireEventTimeout(key);
        }
    }
    setExpireEventTimeout(key, token) {
        if ((0, $169337ef2792d6db$export$178a2c036dbf8815)(token)) return;
        var expireTime = this.getExpireTime(token);
        var expireEventWait = Math.max(expireTime - this.clock.now(), 0) * 1000;
        this.clearExpireEventTimeout(key);
        var expireEventTimeout = setTimeout(()=>{
            this.emitExpired(key, token);
        }, expireEventWait);
        this.state.expireTimeouts[key] = expireEventTimeout;
    }
    setExpireEventTimeoutAll() {
        var tokenStorage = this.storage.getStorage();
        for(var key in tokenStorage){
            if (!Object.prototype.hasOwnProperty.call(tokenStorage, key)) continue;
            var token = tokenStorage[key];
            this.setExpireEventTimeout(key, token);
        }
    }
    resetExpireEventTimeoutAll() {
        this.clearExpireEventTimeoutAll();
        this.setExpireEventTimeoutAll();
    }
    add(key, token) {
        var tokenStorage = this.storage.getStorage();
        (0, $c9f017fd53ed5840$export$56cd50188d1996d0)(token);
        tokenStorage[key] = token;
        this.storage.setStorage(tokenStorage);
        this.emitSetStorageEvent();
        this.emitAdded(key, token);
        this.setExpireEventTimeout(key, token);
    }
    getSync(key) {
        var tokenStorage = this.storage.getStorage();
        return tokenStorage[key];
    }
    async get(key) {
        return this.getSync(key);
    }
    getTokensSync() {
        const tokens = {};
        const tokenStorage = this.storage.getStorage();
        Object.keys(tokenStorage).forEach((key)=>{
            const token = tokenStorage[key];
            if ((0, $169337ef2792d6db$export$3a59e0981c18db3c)(token)) tokens.accessToken = token;
            else if ((0, $169337ef2792d6db$export$e183da9b0d22b235)(token)) tokens.idToken = token;
            else if ((0, $169337ef2792d6db$export$178a2c036dbf8815)(token)) tokens.refreshToken = token;
        });
        return tokens;
    }
    async getTokens() {
        return this.getTokensSync();
    }
    getStorageKeyByType(type) {
        const tokenStorage = this.storage.getStorage();
        const key = Object.keys(tokenStorage).filter((key)=>{
            const token = tokenStorage[key];
            return (0, $169337ef2792d6db$export$3a59e0981c18db3c)(token) && type === 'accessToken' || (0, $169337ef2792d6db$export$e183da9b0d22b235)(token) && type === 'idToken' || (0, $169337ef2792d6db$export$178a2c036dbf8815)(token) && type === 'refreshToken';
        })[0];
        return key;
    }
    getTokenType(token) {
        if ((0, $169337ef2792d6db$export$3a59e0981c18db3c)(token)) return 'accessToken';
        if ((0, $169337ef2792d6db$export$e183da9b0d22b235)(token)) return 'idToken';
        if ((0, $169337ef2792d6db$export$178a2c036dbf8815)(token)) return 'refreshToken';
        throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('Unknown token type');
    }
    emitSetStorageEvent() {
        if ((0, $58f01731783bc4a6$export$302f5f2c80ff991d)()) {
            const storage = this.storage.getStorage();
            this.emitter.emit((0, $c2154470a1d6c1a5$export$772c2bdc9dda0203), storage);
        }
    }
    getStorage() {
        return this.storage;
    }
    setTokens(tokens, accessTokenCb, idTokenCb, refreshTokenCb) {
        const handleTokenCallback = (key, token)=>{
            const type = this.getTokenType(token);
            if (type === 'accessToken') accessTokenCb && accessTokenCb(key, token);
            else if (type === 'idToken') idTokenCb && idTokenCb(key, token);
            else if (type === 'refreshToken') refreshTokenCb && refreshTokenCb(key, token);
        };
        const handleAdded = (key, token)=>{
            this.emitAdded(key, token);
            this.setExpireEventTimeout(key, token);
            handleTokenCallback(key, token);
        };
        const handleRenewed = (key, token, oldToken)=>{
            this.emitRenewed(key, token, oldToken);
            this.clearExpireEventTimeout(key);
            this.setExpireEventTimeout(key, token);
            handleTokenCallback(key, token);
        };
        const handleRemoved = (key, token)=>{
            this.clearExpireEventTimeout(key);
            this.emitRemoved(key, token);
            handleTokenCallback(key, token);
        };
        const types = [
            'idToken',
            'accessToken',
            'refreshToken'
        ];
        const existingTokens = this.getTokensSync();
        types.forEach((type)=>{
            const token = tokens[type];
            if (token) (0, $c9f017fd53ed5840$export$56cd50188d1996d0)(token, type);
        });
        const storage = types.reduce((storage, type)=>{
            const token = tokens[type];
            if (token) {
                const storageKey = this.getStorageKeyByType(type) || type;
                storage[storageKey] = token;
            }
            return storage;
        }, {});
        this.storage.setStorage(storage);
        this.emitSetStorageEvent();
        types.forEach((type)=>{
            const newToken = tokens[type];
            const existingToken = existingTokens[type];
            const storageKey = this.getStorageKeyByType(type) || type;
            if (newToken && existingToken) {
                handleRemoved(storageKey, existingToken);
                handleAdded(storageKey, newToken);
                handleRenewed(storageKey, newToken, existingToken);
            } else if (newToken) handleAdded(storageKey, newToken);
            else if (existingToken) handleRemoved(storageKey, existingToken);
        });
    }
    remove(key) {
        this.clearExpireEventTimeout(key);
        var tokenStorage = this.storage.getStorage();
        var removedToken = tokenStorage[key];
        delete tokenStorage[key];
        this.storage.setStorage(tokenStorage);
        this.emitSetStorageEvent();
        this.emitRemoved(key, removedToken);
    }
    async renewToken(token) {
        var _a;
        return (_a = this.sdk.token) === null || _a === void 0 ? void 0 : _a.renew(token);
    }
    validateToken(token) {
        return (0, $c9f017fd53ed5840$export$56cd50188d1996d0)(token);
    }
    renew(key) {
        if (this.state.renewPromise) return this.state.renewPromise;
        try {
            var token = this.getSync(key);
            let shouldRenew = token !== undefined;
            if (!token && key === 'accessToken') {
                const refreshKey = this.getStorageKeyByType('refreshToken');
                const refreshToken = this.getSync(refreshKey);
                shouldRenew = refreshToken !== undefined;
            }
            if (!shouldRenew) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('The tokenManager has no token for the key: ' + key);
        } catch (err) {
            this.emitError(err);
            return Promise.reject(err);
        }
        this.clearExpireEventTimeout(key);
        const renewPromise = this.state.renewPromise = this.sdk.token.renewTokens().then((tokens)=>{
            this.setTokens(tokens);
            if (!token && key === 'accessToken') {
                const accessToken = tokens['accessToken'];
                this.emitRenewed(key, accessToken, null);
                return accessToken;
            }
            const tokenType = this.getTokenType(token);
            return tokens[tokenType];
        }).catch((err)=>{
            this.remove(key);
            err.tokenKey = key;
            this.emitError(err);
            throw err;
        }).finally(()=>{
            this.state.renewPromise = null;
        });
        return renewPromise;
    }
    clear() {
        const tokens = this.getTokensSync();
        this.clearExpireEventTimeoutAll();
        this.storage.clearStorage();
        this.emitSetStorageEvent();
        Object.keys(tokens).forEach((key)=>{
            this.emitRemoved(key, tokens[key]);
        });
    }
    clearPendingRemoveTokens() {
        const tokenStorage = this.storage.getStorage();
        const removedTokens = {};
        Object.keys(tokenStorage).forEach((key)=>{
            if (tokenStorage[key].pendingRemove) {
                removedTokens[key] = tokenStorage[key];
                delete tokenStorage[key];
            }
        });
        this.storage.setStorage(tokenStorage);
        this.emitSetStorageEvent();
        Object.keys(removedTokens).forEach((key)=>{
            this.clearExpireEventTimeout(key);
            this.emitRemoved(key, removedTokens[key]);
        });
    }
    updateRefreshToken(token) {
        const key = this.getStorageKeyByType('refreshToken') || (0, $a2c830cc0d95456a$export$b04ebc518c9597f0);
        var tokenStorage = this.storage.getStorage();
        (0, $c9f017fd53ed5840$export$56cd50188d1996d0)(token);
        tokenStorage[key] = token;
        this.storage.setStorage(tokenStorage);
        this.emitSetStorageEvent();
    }
    removeRefreshToken() {
        const key = this.getStorageKeyByType('refreshToken') || (0, $a2c830cc0d95456a$export$b04ebc518c9597f0);
        this.remove(key);
    }
    addPendingRemoveFlags() {
        const tokens = this.getTokensSync();
        Object.keys(tokens).forEach((key)=>{
            tokens[key].pendingRemove = true;
        });
        this.setTokens(tokens);
    }
}







/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 



var $4f78310fe4774396$export$2e2bcd8739ae039 = {
    browserHasLocalStorage: function() {
        try {
            var storage = this.getLocalStorage();
            return this.testStorage(storage);
        } catch (e) {
            return false;
        }
    },
    browserHasSessionStorage: function() {
        try {
            var storage = this.getSessionStorage();
            return this.testStorage(storage);
        } catch (e) {
            return false;
        }
    },
    testStorageType: function(storageType) {
        var supported = false;
        switch(storageType){
            case 'sessionStorage':
                supported = this.browserHasSessionStorage();
                break;
            case 'localStorage':
                supported = this.browserHasLocalStorage();
                break;
            case 'cookie':
            case 'memory':
                supported = true;
                break;
            default:
                supported = false;
                break;
        }
        return supported;
    },
    getStorageByType: function(storageType, options) {
        let storageProvider;
        switch(storageType){
            case 'sessionStorage':
                storageProvider = this.getSessionStorage();
                break;
            case 'localStorage':
                storageProvider = this.getLocalStorage();
                break;
            case 'cookie':
                storageProvider = this.getCookieStorage(options);
                break;
            case 'memory':
                storageProvider = this.getInMemoryStorage();
                break;
            default:
                throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)(`Unrecognized storage option: ${storageType}`);
        }
        return storageProvider;
    },
    findStorageType: function(types) {
        let curType;
        let nextType;
        types = types.slice();
        curType = types.shift();
        nextType = types.length ? types[0] : null;
        if (!nextType) return curType;
        if (this.testStorageType(curType)) return curType;
        (0, $26320b9c410af87d$export$c106dd0671a0fc2d)(`This browser doesn't support ${curType}. Switching to ${nextType}.`);
        return this.findStorageType(types);
    },
    getLocalStorage: function() {
        if ((0, $58f01731783bc4a6$export$302f5f2c80ff991d)() && !window.onstorage) window.onstorage = function() {};
        return localStorage;
    },
    getSessionStorage: function() {
        return sessionStorage;
    },
    getCookieStorage: function(options) {
        const secure = options.secure;
        const sameSite = options.sameSite;
        const sessionCookie = options.sessionCookie;
        if (typeof secure === 'undefined' || typeof sameSite === 'undefined') throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('getCookieStorage: "secure" and "sameSite" options must be provided');
        const storage = {
            getItem: this.storage.get,
            setItem: (key, value, expiresAt = '2200-01-01T00:00:00.000Z')=>{
                expiresAt = sessionCookie ? null : expiresAt;
                this.storage.set(key, value, expiresAt, {
                    secure: secure,
                    sameSite: sameSite
                });
            },
            removeItem: (key)=>{
                this.storage.delete(key);
            }
        };
        if (!options.useSeparateCookies) return storage;
        return {
            getItem: function(key) {
                var data = storage.getItem();
                var value = {};
                Object.keys(data).forEach((k)=>{
                    if (k.indexOf(key) === 0) value[k.replace(`${key}_`, '')] = JSON.parse(data[k]);
                });
                return JSON.stringify(value);
            },
            setItem: function(key, value) {
                var existingValues = JSON.parse(this.getItem(key));
                value = JSON.parse(value);
                Object.keys(value).forEach((k)=>{
                    var storageKey = key + '_' + k;
                    var valueToStore = JSON.stringify(value[k]);
                    storage.setItem(storageKey, valueToStore);
                    delete existingValues[k];
                });
                Object.keys(existingValues).forEach((k)=>{
                    storage.removeItem(key + '_' + k);
                });
            },
            removeItem: function(key) {
                var existingValues = JSON.parse(this.getItem(key));
                Object.keys(existingValues).forEach((k)=>{
                    storage.removeItem(key + '_' + k);
                });
            }
        };
    },
    inMemoryStore: {},
    getInMemoryStorage: function() {
        return {
            getItem: (key)=>{
                return this.inMemoryStore[key];
            },
            setItem: (key, value)=>{
                this.inMemoryStore[key] = value;
            }
        };
    },
    testStorage: function(storage) {
        var key = 'okta-test-storage';
        try {
            storage.setItem(key, key);
            storage.removeItem(key);
            return true;
        } catch (e) {
            return false;
        }
    },
    storage: {
        set: function(name, value, expiresAt, options) {
            const { sameSite: sameSite, secure: secure } = options;
            if (typeof secure === 'undefined' || typeof sameSite === 'undefined') throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('storage.set: "secure" and "sameSite" options must be provided');
            var cookieOptions = {
                path: options.path || '/',
                secure: secure,
                sameSite: sameSite
            };
            if (!!Date.parse(expiresAt)) cookieOptions.expires = new Date(expiresAt);
            (0, $ec651a0685591698$export$2e2bcd8739ae039).set(name, value, cookieOptions);
            return this.get(name);
        },
        get: function(name) {
            if (!arguments.length) return (0, $ec651a0685591698$export$2e2bcd8739ae039).get();
            return (0, $ec651a0685591698$export$2e2bcd8739ae039).get(name);
        },
        delete: function(name) {
            return (0, $ec651a0685591698$export$2e2bcd8739ae039).remove(name, {
                path: '/'
            });
        }
    }
};


function $b3ab08ae08760dba$export$25690a1e8875419f(BaseClass) {
    return class WithOriginalUri extends BaseClass {
        setOriginalUri(originalUri, state) {
            const sessionStorage = (0, $4f78310fe4774396$export$2e2bcd8739ae039).getSessionStorage();
            sessionStorage.setItem((0, $a2c830cc0d95456a$export$dc0f85461823eff2), originalUri);
            state = state || this.options.state;
            if (state) {
                const sharedStorage = this.storageManager.getOriginalUriStorage();
                sharedStorage.setItem(state, originalUri);
            }
        }
        getOriginalUri(state) {
            state = state || this.options.state;
            if (state) {
                const sharedStorage = this.storageManager.getOriginalUriStorage();
                const originalUri = sharedStorage.getItem(state);
                if (originalUri) return originalUri;
            }
            const storage = (0, $4f78310fe4774396$export$2e2bcd8739ae039).getSessionStorage();
            return storage ? storage.getItem((0, $a2c830cc0d95456a$export$dc0f85461823eff2)) || undefined : undefined;
        }
        removeOriginalUri(state) {
            const storage = (0, $4f78310fe4774396$export$2e2bcd8739ae039).getSessionStorage();
            storage.removeItem((0, $a2c830cc0d95456a$export$dc0f85461823eff2));
            state = state || this.options.state;
            if (state) {
                const sharedStorage = this.storageManager.getOriginalUriStorage();
                sharedStorage.removeItem && sharedStorage.removeItem(state);
            }
        }
    };
}


function $81aceab9ba49f668$export$d2d79cf72153e095(Base, TransactionManagerConstructor) {
    var _a;
    const WithOriginalUri = (0, $b3ab08ae08760dba$export$25690a1e8875419f)(Base);
    return _a = class OktaAuthOAuth extends WithOriginalUri {
        constructor(...args){
            super(...args);
            this.transactionManager = new TransactionManagerConstructor(Object.assign({
                storageManager: this.storageManager
            }, this.options.transactionManager));
            this.pkce = {
                DEFAULT_CODE_CHALLENGE_METHOD: (0, $068e90f61d5ff37f$export$2e2bcd8739ae039).DEFAULT_CODE_CHALLENGE_METHOD,
                generateVerifier: (0, $068e90f61d5ff37f$export$2e2bcd8739ae039).generateVerifier,
                computeChallenge: (0, $068e90f61d5ff37f$export$2e2bcd8739ae039).computeChallenge
            };
            this._pending = {
                handleLogin: false
            };
            this._tokenQueue = new (0, $ec66963041d4efbe$export$7ab95d2dbda3c98c)();
            this.token = (0, $04e26313d2a8666c$export$bd3db6d56a375929)(this, this._tokenQueue);
            this.tokenManager = new (0, $03a630e742f1c53b$export$aa9349e63a87bac1)(this, this.options.tokenManager);
            this.endpoints = (0, $04e26313d2a8666c$export$deedb2680d4aa92)(this);
        }
        clearStorage() {
            super.clearStorage();
            this.tokenManager.clear();
        }
        async isAuthenticated(options = {}) {
            const { autoRenew: autoRenew, autoRemove: autoRemove } = this.tokenManager.getOptions();
            const shouldRenew = options.onExpiredToken ? options.onExpiredToken === 'renew' : autoRenew;
            const shouldRemove = options.onExpiredToken ? options.onExpiredToken === 'remove' : autoRemove;
            let { accessToken: accessToken } = this.tokenManager.getTokensSync();
            if (accessToken && this.tokenManager.hasExpired(accessToken)) {
                accessToken = undefined;
                if (shouldRenew) try {
                    accessToken = await this.tokenManager.renew('accessToken');
                } catch (_a) {}
                else if (shouldRemove) this.tokenManager.remove('accessToken');
            }
            let { idToken: idToken } = this.tokenManager.getTokensSync();
            if (idToken && this.tokenManager.hasExpired(idToken)) {
                idToken = undefined;
                if (shouldRenew) try {
                    idToken = await this.tokenManager.renew('idToken');
                } catch (_b) {}
                else if (shouldRemove) this.tokenManager.remove('idToken');
            }
            return !!(accessToken && idToken);
        }
        async signInWithRedirect(opts = {}) {
            const { originalUri: originalUri } = opts, additionalParams = (0, $a8b9237c404681df$export$3c9a16f847548506)(opts, [
                "originalUri"
            ]);
            if (this._pending.handleLogin) return;
            this._pending.handleLogin = true;
            try {
                if (originalUri) this.setOriginalUri(originalUri);
                const params = Object.assign({
                    scopes: this.options.scopes || [
                        'openid',
                        'email',
                        'profile'
                    ]
                }, additionalParams);
                await this.token.getWithRedirect(params);
            } finally{
                this._pending.handleLogin = false;
            }
        }
        async getUser() {
            const { idToken: idToken, accessToken: accessToken } = this.tokenManager.getTokensSync();
            return this.token.getUserInfo(accessToken, idToken);
        }
        getIdToken() {
            const { idToken: idToken } = this.tokenManager.getTokensSync();
            return idToken ? idToken.idToken : undefined;
        }
        getAccessToken() {
            const { accessToken: accessToken } = this.tokenManager.getTokensSync();
            return accessToken ? accessToken.accessToken : undefined;
        }
        getRefreshToken() {
            const { refreshToken: refreshToken } = this.tokenManager.getTokensSync();
            return refreshToken ? refreshToken.refreshToken : undefined;
        }
        async getOrRenewAccessToken() {
            var _a;
            const { accessToken: accessToken } = this.tokenManager.getTokensSync();
            if (accessToken && !this.tokenManager.hasExpired(accessToken)) return accessToken.accessToken;
            try {
                const key = this.tokenManager.getStorageKeyByType('accessToken');
                const token = await this.tokenManager.renew(key !== null && key !== void 0 ? key : 'accessToken');
                return (_a = token === null || token === void 0 ? void 0 : token.accessToken) !== null && _a !== void 0 ? _a : null;
            } catch (err) {
                this.emitter.emit('error', err);
                return null;
            }
        }
        async storeTokensFromRedirect() {
            const { tokens: tokens, responseType: responseType } = await this.token.parseFromUrl();
            if (responseType !== 'none') this.tokenManager.setTokens(tokens);
        }
        isLoginRedirect() {
            return (0, $30cbbe4b83336d5c$export$3488c667ccc91890)(this);
        }
        isPKCE() {
            return !!this.options.pkce;
        }
        hasResponseType(responseType) {
            return (0, $30cbbe4b83336d5c$export$85f1abab17a58c57)(responseType, this.options);
        }
        isAuthorizationCodeFlow() {
            return this.hasResponseType('code');
        }
        async invokeApiMethod(options) {
            if (!options.accessToken) {
                const accessToken = (await this.tokenManager.getTokens()).accessToken;
                options.accessToken = accessToken === null || accessToken === void 0 ? void 0 : accessToken.accessToken;
            }
            return (0, $0898b9c80798427c$export$46f383001bf60e04)(this, options);
        }
        async revokeAccessToken(accessToken) {
            if (!accessToken) {
                const tokens = await this.tokenManager.getTokens();
                accessToken = tokens.accessToken;
                const accessTokenKey = this.tokenManager.getStorageKeyByType('accessToken');
                this.tokenManager.remove(accessTokenKey);
                if (this.options.dpop) await (0, $cb03936b1b96259e$export$6afe52fd44d25eaf)('access', tokens);
            }
            if (!accessToken) return Promise.resolve(null);
            return this.token.revoke(accessToken);
        }
        async revokeRefreshToken(refreshToken) {
            if (!refreshToken) {
                const tokens = await this.tokenManager.getTokens();
                refreshToken = tokens.refreshToken;
                const refreshTokenKey = this.tokenManager.getStorageKeyByType('refreshToken');
                this.tokenManager.remove(refreshTokenKey);
                if (this.options.dpop) await (0, $cb03936b1b96259e$export$6afe52fd44d25eaf)('refresh', tokens);
            }
            if (!refreshToken) return Promise.resolve(null);
            return this.token.revoke(refreshToken);
        }
        getSignOutRedirectUrl(options = {}) {
            let { idToken: idToken, postLogoutRedirectUri: postLogoutRedirectUri, state: state } = options;
            if (!idToken) idToken = this.tokenManager.getTokensSync().idToken;
            if (!idToken) return '';
            if (postLogoutRedirectUri === undefined) postLogoutRedirectUri = this.options.postLogoutRedirectUri;
            const logoutUrl = (0, $49723b489f007b5d$export$1a398a8b679ebb76)(this).logoutUrl;
            const idTokenHint = idToken.idToken;
            let logoutUri = logoutUrl + '?id_token_hint=' + encodeURIComponent(idTokenHint);
            if (postLogoutRedirectUri) logoutUri += '&post_logout_redirect_uri=' + encodeURIComponent(postLogoutRedirectUri);
            if (state) logoutUri += '&state=' + encodeURIComponent(state);
            return logoutUri;
        }
        async signOut(options) {
            var _a;
            options = Object.assign({}, options);
            const defaultUri = window.location.origin;
            const currentUri = window.location.href;
            const postLogoutRedirectUri = options.postLogoutRedirectUri === null ? null : options.postLogoutRedirectUri || this.options.postLogoutRedirectUri || defaultUri;
            const state = options === null || options === void 0 ? void 0 : options.state;
            let accessToken = options.accessToken;
            let refreshToken = options.refreshToken;
            const revokeAccessToken = options.revokeAccessToken !== false;
            const revokeRefreshToken = options.revokeRefreshToken !== false;
            if (revokeRefreshToken && typeof refreshToken === 'undefined') refreshToken = this.tokenManager.getTokensSync().refreshToken;
            if (revokeAccessToken && typeof accessToken === 'undefined') accessToken = this.tokenManager.getTokensSync().accessToken;
            if (!options.idToken) options.idToken = this.tokenManager.getTokensSync().idToken;
            if (revokeRefreshToken && refreshToken) await this.revokeRefreshToken(refreshToken);
            if (revokeAccessToken && accessToken) await this.revokeAccessToken(accessToken);
            const dpopPairId = (_a = accessToken === null || accessToken === void 0 ? void 0 : accessToken.dpopPairId) !== null && _a !== void 0 ? _a : refreshToken === null || refreshToken === void 0 ? void 0 : refreshToken.dpopPairId;
            if (this.options.dpop && dpopPairId) await (0, $cb03936b1b96259e$export$f33690fea154ad2d)(dpopPairId);
            const logoutUri = this.getSignOutRedirectUrl(Object.assign(Object.assign({}, options), {
                postLogoutRedirectUri: postLogoutRedirectUri
            }));
            if (!logoutUri) {
                const sessionClosed = await this.closeSession();
                const redirectUri = new URL(postLogoutRedirectUri || defaultUri);
                if (state) redirectUri.searchParams.append('state', state);
                if (postLogoutRedirectUri === currentUri) window.location.href = redirectUri.href;
                else window.location.assign(redirectUri.href);
                return sessionClosed;
            } else {
                if (options.clearTokensBeforeRedirect) this.tokenManager.clear();
                else this.tokenManager.addPendingRemoveFlags();
                window.location.assign(logoutUri);
                return true;
            }
        }
        async getDPoPAuthorizationHeaders(params) {
            if (!this.options.dpop) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('DPoP is not configured for this client instance');
            let { accessToken: accessToken } = params;
            if (!accessToken) accessToken = this.tokenManager.getTokensSync().accessToken;
            if (!accessToken) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('AccessToken is required to generate a DPoP Proof');
            const keyPair = await (0, $cb03936b1b96259e$export$846293577e1b1366)(accessToken === null || accessToken === void 0 ? void 0 : accessToken.dpopPairId);
            const proof = await (0, $cb03936b1b96259e$export$ac18780f7e57da)(Object.assign(Object.assign({}, params), {
                keyPair: keyPair,
                accessToken: accessToken.accessToken
            }));
            return {
                Authorization: `DPoP ${accessToken.accessToken}`,
                Dpop: proof
            };
        }
        async clearDPoPStorage(clearAll = false) {
            var _a, _b;
            if (clearAll) return (0, $cb03936b1b96259e$export$20156800d73a71cb)();
            const tokens = await this.tokenManager.getTokens();
            const keyPair = ((_a = tokens.accessToken) === null || _a === void 0 ? void 0 : _a.dpopPairId) || ((_b = tokens.refreshToken) === null || _b === void 0 ? void 0 : _b.dpopPairId);
            if (keyPair) await (0, $cb03936b1b96259e$export$f33690fea154ad2d)(keyPair);
        }
        parseUseDPoPNonceError(headers) {
            var _a;
            const wwwAuth = (0, $7c31c4e6cdd411e2$export$2e2bcd8739ae039).getWWWAuthenticateHeader(headers);
            const wwwErr = (0, $7c31c4e6cdd411e2$export$2e2bcd8739ae039).parseHeader(wwwAuth !== null && wwwAuth !== void 0 ? wwwAuth : '');
            if ((0, $cb03936b1b96259e$export$283c6a56651b6b3)(wwwErr)) {
                let nonce = null;
                if ((0, $53a4517fb157de9f$export$f6e2535fb5126e54)(headers === null || headers === void 0 ? void 0 : headers.get)) nonce = headers.get('DPoP-Nonce');
                nonce = (_a = nonce !== null && nonce !== void 0 ? nonce : headers['dpop-nonce']) !== null && _a !== void 0 ? _a : headers['DPoP-Nonce'];
                return nonce;
            }
            return null;
        }
    }, _a.crypto = $3c4b7e63f7cc6a72$exports, _a;
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 









var $562587acf8513b13$var$_CancelablePromise_instances, $562587acf8513b13$var$_CancelablePromise__state, $562587acf8513b13$var$_CancelablePromise_promise, $562587acf8513b13$var$_CancelablePromise_cancelHandlers, $562587acf8513b13$var$_CancelablePromise_rejector, $562587acf8513b13$var$_CancelablePromise_state_get, $562587acf8513b13$var$_CancelablePromise_state_set;
const $562587acf8513b13$export$237dc0bae177ad41 = null;
const $562587acf8513b13$var$DEFAULT_PENDING = {
    updateAuthStatePromise: null,
    canceledTimes: 0
};
const $562587acf8513b13$var$EVENT_AUTH_STATE_CHANGE = 'authStateChange';
const $562587acf8513b13$var$MAX_PROMISE_CANCEL_TIMES = 10;
const $562587acf8513b13$var$isSameAuthState = (prevState, state)=>{
    if (!prevState) return false;
    return prevState.isAuthenticated === state.isAuthenticated && JSON.stringify(prevState.idToken) === JSON.stringify(state.idToken) && JSON.stringify(prevState.accessToken) === JSON.stringify(state.accessToken) && prevState.error === state.error;
};
class $562587acf8513b13$var$CancelablePromise {
    constructor(executor){
        $562587acf8513b13$var$_CancelablePromise_instances.add(this);
        $562587acf8513b13$var$_CancelablePromise__state.set(this, 'PENDING');
        $562587acf8513b13$var$_CancelablePromise_promise.set(this, void 0);
        $562587acf8513b13$var$_CancelablePromise_cancelHandlers.set(this, []);
        $562587acf8513b13$var$_CancelablePromise_rejector.set(this, ()=>{});
        (0, $a8b9237c404681df$export$d40a35129aaff81f)(this, $562587acf8513b13$var$_CancelablePromise_promise, new Promise((resolve, reject)=>{
            (0, $a8b9237c404681df$export$d40a35129aaff81f)(this, $562587acf8513b13$var$_CancelablePromise_rejector, reject, "f");
            const onResolve = (result)=>{
                resolve(result);
                (0, $a8b9237c404681df$export$d40a35129aaff81f)(this, $562587acf8513b13$var$_CancelablePromise_instances, 'SETTLED', "a", $562587acf8513b13$var$_CancelablePromise_state_set);
            };
            const onReject = (error)=>{
                reject(error);
                (0, $a8b9237c404681df$export$d40a35129aaff81f)(this, $562587acf8513b13$var$_CancelablePromise_instances, 'SETTLED', "a", $562587acf8513b13$var$_CancelablePromise_state_set);
            };
            const onCancel = (handler)=>{
                (0, $a8b9237c404681df$export$d5dcaf168c640c35)(this, $562587acf8513b13$var$_CancelablePromise_cancelHandlers, "f").push(handler);
            };
            executor(onResolve, onReject, onCancel);
        }), "f");
    }
    then(...args) {
        return (0, $a8b9237c404681df$export$d5dcaf168c640c35)(this, $562587acf8513b13$var$_CancelablePromise_promise, "f").then(...args);
    }
    catch(...args) {
        return (0, $a8b9237c404681df$export$d5dcaf168c640c35)(this, $562587acf8513b13$var$_CancelablePromise_promise, "f").catch(...args);
    }
    finally(...args) {
        return (0, $a8b9237c404681df$export$d5dcaf168c640c35)(this, $562587acf8513b13$var$_CancelablePromise_promise, "f").finally(...args);
    }
    cancel() {
        if ((0, $a8b9237c404681df$export$d5dcaf168c640c35)(this, $562587acf8513b13$var$_CancelablePromise_instances, "a", $562587acf8513b13$var$_CancelablePromise_state_get) !== 'PENDING') return;
        (0, $a8b9237c404681df$export$d40a35129aaff81f)(this, $562587acf8513b13$var$_CancelablePromise_instances, 'CANCELED', "a", $562587acf8513b13$var$_CancelablePromise_state_set);
        if ((0, $a8b9237c404681df$export$d5dcaf168c640c35)(this, $562587acf8513b13$var$_CancelablePromise_cancelHandlers, "f").length > 0) try {
            for (const handler of (0, $a8b9237c404681df$export$d5dcaf168c640c35)(this, $562587acf8513b13$var$_CancelablePromise_cancelHandlers, "f"))handler();
        } catch (error) {
            (0, $a8b9237c404681df$export$d5dcaf168c640c35)(this, $562587acf8513b13$var$_CancelablePromise_rejector, "f").call(this, error);
            return;
        }
    }
    get isCanceled() {
        return (0, $a8b9237c404681df$export$d5dcaf168c640c35)(this, $562587acf8513b13$var$_CancelablePromise_instances, "a", $562587acf8513b13$var$_CancelablePromise_state_get) === 'CANCELED';
    }
}
$562587acf8513b13$var$_CancelablePromise__state = new WeakMap(), $562587acf8513b13$var$_CancelablePromise_promise = new WeakMap(), $562587acf8513b13$var$_CancelablePromise_cancelHandlers = new WeakMap(), $562587acf8513b13$var$_CancelablePromise_rejector = new WeakMap(), $562587acf8513b13$var$_CancelablePromise_instances = new WeakSet(), $562587acf8513b13$var$_CancelablePromise_state_get = function _CancelablePromise_state_get() {
    return (0, $a8b9237c404681df$export$d5dcaf168c640c35)(this, $562587acf8513b13$var$_CancelablePromise__state, "f");
}, $562587acf8513b13$var$_CancelablePromise_state_set = function _CancelablePromise_state_set(state) {
    if ((0, $a8b9237c404681df$export$d5dcaf168c640c35)(this, $562587acf8513b13$var$_CancelablePromise_instances, "a", $562587acf8513b13$var$_CancelablePromise_state_get) === 'PENDING') (0, $a8b9237c404681df$export$d40a35129aaff81f)(this, $562587acf8513b13$var$_CancelablePromise__state, state, "f");
};
Object.setPrototypeOf($562587acf8513b13$var$CancelablePromise.prototype, Promise.prototype);
class $562587acf8513b13$export$98841555a7280e2b {
    constructor(sdk){
        if (!sdk.emitter) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('Emitter should be initialized before AuthStateManager');
        this._sdk = sdk;
        this._pending = Object.assign({}, $562587acf8513b13$var$DEFAULT_PENDING);
        this._authState = $562587acf8513b13$export$237dc0bae177ad41;
        this._logOptions = {};
        this._prevAuthState = null;
        this._transformQueue = new (0, $ec66963041d4efbe$export$7ab95d2dbda3c98c)({
            quiet: true
        });
        sdk.tokenManager.on((0, $c2154470a1d6c1a5$export$e9f9d3905a889e02), (key, token)=>{
            this._setLogOptions({
                event: (0, $c2154470a1d6c1a5$export$e9f9d3905a889e02),
                key: key,
                token: token
            });
            this.updateAuthState();
        });
        sdk.tokenManager.on((0, $c2154470a1d6c1a5$export$9995ae835670bd28), (key, token)=>{
            this._setLogOptions({
                event: (0, $c2154470a1d6c1a5$export$9995ae835670bd28),
                key: key,
                token: token
            });
            this.updateAuthState();
        });
    }
    _setLogOptions(options) {
        this._logOptions = options;
    }
    getAuthState() {
        return this._authState;
    }
    getPreviousAuthState() {
        return this._prevAuthState;
    }
    async updateAuthState() {
        const { transformAuthState: transformAuthState, devMode: devMode } = this._sdk.options;
        const log = (status)=>{
            const { event: event, key: key, token: token } = this._logOptions;
            (0, $26320b9c410af87d$export$bbe488cec1edd401)().group(`OKTA-AUTH-JS:updateAuthState: Event:${event} Status:${status}`);
            (0, $26320b9c410af87d$export$bbe488cec1edd401)().log(key, token);
            (0, $26320b9c410af87d$export$bbe488cec1edd401)().log('Current authState', this._authState);
            (0, $26320b9c410af87d$export$bbe488cec1edd401)().groupEnd();
            this._logOptions = {};
        };
        const emitAuthStateChange = (authState)=>{
            if ($562587acf8513b13$var$isSameAuthState(this._authState, authState)) {
                devMode && log('unchanged');
                return;
            }
            this._prevAuthState = this._authState;
            this._authState = authState;
            this._sdk.emitter.emit($562587acf8513b13$var$EVENT_AUTH_STATE_CHANGE, Object.assign({}, authState));
            devMode && log('emitted');
        };
        const finalPromise = (origPromise)=>{
            return this._pending.updateAuthStatePromise.then(()=>{
                const curPromise = this._pending.updateAuthStatePromise;
                if (curPromise && curPromise !== origPromise) return finalPromise(curPromise);
                return this.getAuthState();
            });
        };
        if (this._pending.updateAuthStatePromise) {
            if (this._pending.canceledTimes >= $562587acf8513b13$var$MAX_PROMISE_CANCEL_TIMES) {
                devMode && log('terminated');
                return finalPromise(this._pending.updateAuthStatePromise);
            } else this._pending.updateAuthStatePromise.cancel();
        }
        const cancelablePromise = new $562587acf8513b13$var$CancelablePromise((resolve, _, onCancel)=>{
            onCancel(()=>{
                this._pending.updateAuthStatePromise = null;
                this._pending.canceledTimes = this._pending.canceledTimes + 1;
                devMode && log('canceled');
            });
            const emitAndResolve = (authState)=>{
                if (cancelablePromise.isCanceled) {
                    resolve(undefined);
                    return;
                }
                emitAuthStateChange(authState);
                resolve(undefined);
                this._pending = Object.assign({}, $562587acf8513b13$var$DEFAULT_PENDING);
            };
            this._sdk.isAuthenticated().then((isAuthenticated)=>{
                if (cancelablePromise.isCanceled) {
                    resolve(undefined);
                    return;
                }
                const { accessToken: accessToken, idToken: idToken, refreshToken: refreshToken } = this._sdk.tokenManager.getTokensSync();
                const authState = {
                    accessToken: accessToken,
                    idToken: idToken,
                    refreshToken: refreshToken,
                    isAuthenticated: isAuthenticated
                };
                const promise = transformAuthState ? this._transformQueue.push(transformAuthState, null, this._sdk, authState) : Promise.resolve(authState);
                promise.then((authState)=>emitAndResolve(authState)).catch((error)=>emitAndResolve({
                        accessToken: accessToken,
                        idToken: idToken,
                        refreshToken: refreshToken,
                        isAuthenticated: false,
                        error: error
                    }));
            });
        });
        this._pending.updateAuthStatePromise = cancelablePromise;
        return finalPromise(cancelablePromise);
    }
    subscribe(handler) {
        this._sdk.emitter.on($562587acf8513b13$var$EVENT_AUTH_STATE_CHANGE, handler);
    }
    unsubscribe(handler) {
        this._sdk.emitter.off($562587acf8513b13$var$EVENT_AUTH_STATE_CHANGE, handler);
    }
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 




class $729de8568668874f$export$6493f06a8769bada {
    constructor(tokenManager, options = {}){
        this.started = false;
        this.tokenManager = tokenManager;
        this.options = options;
        this.renewTimeQueue = [];
        this.onTokenExpiredHandler = this.onTokenExpiredHandler.bind(this);
    }
    shouldThrottleRenew() {
        let res = false;
        this.renewTimeQueue.push(Date.now());
        if (this.renewTimeQueue.length >= 10) {
            const firstTime = this.renewTimeQueue.shift();
            const lastTime = this.renewTimeQueue[this.renewTimeQueue.length - 1];
            res = lastTime - firstTime < 30000;
        }
        return res;
    }
    requiresLeadership() {
        return !!this.options.syncStorage && (0, $58f01731783bc4a6$export$4e09c449d6c407f7)();
    }
    processExpiredTokens() {
        const tokenStorage = this.tokenManager.getStorage();
        const tokens = tokenStorage.getStorage();
        Object.keys(tokens).forEach((key)=>{
            const token = tokens[key];
            if (!(0, $169337ef2792d6db$export$178a2c036dbf8815)(token) && this.tokenManager.hasExpired(token)) this.onTokenExpiredHandler(key);
        });
    }
    onTokenExpiredHandler(key) {
        if (this.options.autoRenew) {
            if (this.shouldThrottleRenew()) {
                const error = new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('Too many token renew requests');
                this.tokenManager.emitError(error);
            } else this.tokenManager.renew(key).catch(()=>{});
        } else if (this.options.autoRemove) this.tokenManager.remove(key);
    }
    canStart() {
        return (!!this.options.autoRenew || !!this.options.autoRemove) && !this.started;
    }
    async start() {
        if (this.canStart()) {
            this.tokenManager.on((0, $c2154470a1d6c1a5$export$c0d46e39554d86f6), this.onTokenExpiredHandler);
            if (this.tokenManager.isStarted()) this.processExpiredTokens();
            this.started = true;
        }
    }
    async stop() {
        if (this.started) {
            this.tokenManager.off((0, $c2154470a1d6c1a5$export$c0d46e39554d86f6), this.onTokenExpiredHandler);
            this.renewTimeQueue = [];
            this.started = false;
        }
    }
    isStarted() {
        return this.started;
    }
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /**
 * returns true if the given object is a promise
 */ function $4be22ff3aeacd06a$export$4369c812aac99591(obj) {
    return obj && typeof obj.then === 'function';
}
var $4be22ff3aeacd06a$export$6332f88de91a4f29 = Promise.resolve(false);
var $4be22ff3aeacd06a$export$b5d9069fca1162b4 = Promise.resolve(true);
var $4be22ff3aeacd06a$export$5187ac309d2dbc09 = Promise.resolve();
function $4be22ff3aeacd06a$export$e772c8ff12451969(time, resolveWith) {
    if (!time) time = 0;
    return new Promise(function(res) {
        return setTimeout(function() {
            return res(resolveWith);
        }, time);
    });
}
function $4be22ff3aeacd06a$export$3c5f89dae98e900b(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
}
function $4be22ff3aeacd06a$export$4e61f672936bec77() {
    return Math.random().toString(36).substring(2);
}
var $4be22ff3aeacd06a$var$lastMs = 0;
function $4be22ff3aeacd06a$export$b3e55dfce5152d1d() {
    var ret = Date.now() * 1000; // milliseconds to microseconds
    if (ret <= $4be22ff3aeacd06a$var$lastMs) ret = $4be22ff3aeacd06a$var$lastMs + 1;
    $4be22ff3aeacd06a$var$lastMs = ret;
    return ret;
}
function $4be22ff3aeacd06a$export$9f0d99555d35e998() {
    if (typeof navigator !== 'undefined' && typeof navigator.locks !== 'undefined' && typeof navigator.locks.request === 'function') return true;
    else return false;
}



var $6e6dec193b4793b8$export$b3e55dfce5152d1d = (0, $4be22ff3aeacd06a$export$b3e55dfce5152d1d);
var $6e6dec193b4793b8$export$bf9fb029d174d554 = 'native';
function $6e6dec193b4793b8$export$185802fd694ee1f5(channelName) {
    var state = {
        time: (0, $4be22ff3aeacd06a$export$b3e55dfce5152d1d)(),
        messagesCallback: null,
        bc: new BroadcastChannel(channelName),
        subFns: [] // subscriberFunctions
    };
    state.bc.onmessage = function(msgEvent) {
        if (state.messagesCallback) state.messagesCallback(msgEvent.data);
    };
    return state;
}
function $6e6dec193b4793b8$export$8360e631d277ea4d(channelState) {
    channelState.bc.close();
    channelState.subFns = [];
}
function $6e6dec193b4793b8$export$6efe264be9505de7(channelState, messageJson) {
    try {
        channelState.bc.postMessage(messageJson, false);
        return 0, $4be22ff3aeacd06a$export$5187ac309d2dbc09;
    } catch (err) {
        return Promise.reject(err);
    }
}
function $6e6dec193b4793b8$export$7275a8dcb77dc20d(channelState, fn) {
    channelState.messagesCallback = fn;
}
function $6e6dec193b4793b8$export$edc1ec99af52c032() {
    // Deno runtime
    // eslint-disable-next-line
    if (typeof globalThis !== 'undefined' && globalThis.Deno && globalThis.Deno.args) return true;
    // Browser runtime
    if ((typeof window !== 'undefined' || typeof self !== 'undefined') && typeof BroadcastChannel === 'function') {
        if (BroadcastChannel._pubkey) throw new Error('BroadcastChannel: Do not overwrite window.BroadcastChannel with this module, this is not a polyfill');
        return true;
    } else return false;
}
function $6e6dec193b4793b8$export$378952ed8d3ebcd6() {
    return 150;
}
var $6e6dec193b4793b8$export$c2e5cf752d4e2634 = {
    create: $6e6dec193b4793b8$export$185802fd694ee1f5,
    close: $6e6dec193b4793b8$export$8360e631d277ea4d,
    onMessage: $6e6dec193b4793b8$export$7275a8dcb77dc20d,
    postMessage: $6e6dec193b4793b8$export$6efe264be9505de7,
    canBeUsed: $6e6dec193b4793b8$export$edc1ec99af52c032,
    type: $6e6dec193b4793b8$export$bf9fb029d174d554,
    averageResponseTime: $6e6dec193b4793b8$export$378952ed8d3ebcd6,
    microSeconds: $6e6dec193b4793b8$export$b3e55dfce5152d1d
};


/**
 * this method uses indexeddb to store the messages
 * There is currently no observerAPI for idb
 * @link https://github.com/w3c/IndexedDB/issues/51
 * 
 * When working on this, ensure to use these performance optimizations:
 * @link https://rxdb.info/slow-indexeddb.html
 */ 
/**
 * this is a set which automatically forgets
 * a given entry when a new entry is set and the ttl
 * of the old one is over
 */ class $f5dcc1e438a1228d$export$95f11f715943104f {
    ttl;
    map = new Map();
    /**
     * Creating calls to setTimeout() is expensive,
     * so we only do that if there is not timeout already open.
     */ _to = false;
    constructor(ttl){
        this.ttl = ttl;
    }
    has(value) {
        const valueTime = this.map.get(value);
        if (typeof valueTime === 'undefined') return false;
        if (valueTime < $f5dcc1e438a1228d$export$461939dd4422153() - this.ttl) {
            this.map.delete(value);
            return false;
        }
        return true;
    }
    add(value) {
        this.map.delete(value);
        this.map.set(value, $f5dcc1e438a1228d$export$461939dd4422153());
        /**
         * When a new value is added,
         * start the cleanup at the next tick
         * to not block the cpu for more important stuff
         * that might happen.
         */ if (!this._to) {
            this._to = true;
            setTimeout(()=>{
                this._to = false;
                $f5dcc1e438a1228d$export$bb2da5c3b0945a45(this);
            }, 0);
        }
    }
    clear() {
        this.map.clear();
    }
}
function $f5dcc1e438a1228d$export$bb2da5c3b0945a45(obliviousSet) {
    const olderThen = $f5dcc1e438a1228d$export$461939dd4422153() - obliviousSet.ttl;
    const iterator = obliviousSet.map[Symbol.iterator]();
    /**
     * Because we can assume the new values are added at the bottom,
     * we start from the top and stop as soon as we reach a non-too-old value.
     */ while(true){
        const next = iterator.next().value;
        if (!next) break; // no more elements
        const value = next[0];
        const time = next[1];
        if (time < olderThen) obliviousSet.map.delete(value);
        else break;
    }
}
function $f5dcc1e438a1228d$export$461939dd4422153() {
    return Date.now();
}


function $6aa5381df36fd806$export$7ee70d6123309e38() {
    var originalOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var options = JSON.parse(JSON.stringify(originalOptions));
    // main
    if (typeof options.webWorkerSupport === 'undefined') options.webWorkerSupport = true;
    // indexed-db
    if (!options.idb) options.idb = {};
    //  after this time the messages get deleted
    if (!options.idb.ttl) options.idb.ttl = 45000;
    if (!options.idb.fallbackInterval) options.idb.fallbackInterval = 150;
    //  handles abrupt db onclose events.
    if (originalOptions.idb && typeof originalOptions.idb.onclose === 'function') options.idb.onclose = originalOptions.idb.onclose;
    // localstorage
    if (!options.localstorage) options.localstorage = {};
    if (!options.localstorage.removeTimeout) options.localstorage.removeTimeout = 60000;
    // custom methods
    if (originalOptions.methods) options.methods = originalOptions.methods;
    // node
    if (!options.node) options.node = {};
    if (!options.node.ttl) options.node.ttl = 120000; // 2 minutes;
    /**
   * On linux use 'ulimit -Hn' to get the limit of open files.
   * On ubuntu this was 4096 for me, so we use half of that as maxParallelWrites default.
   */ if (!options.node.maxParallelWrites) options.node.maxParallelWrites = 2048;
    if (typeof options.node.useFastPath === 'undefined') options.node.useFastPath = true;
    return options;
}


var $173b20ec741d376d$export$b3e55dfce5152d1d = (0, $4be22ff3aeacd06a$export$b3e55dfce5152d1d);
var $173b20ec741d376d$var$DB_PREFIX = 'pubkey.broadcast-channel-0-';
var $173b20ec741d376d$var$OBJECT_STORE_ID = 'messages';
var $173b20ec741d376d$export$158bac47d00a5c4c = {
    durability: 'relaxed'
};
var $173b20ec741d376d$export$bf9fb029d174d554 = 'idb';
function $173b20ec741d376d$export$9bb0279d2d49cfa2() {
    if (typeof indexedDB !== 'undefined') return indexedDB;
    if (typeof window !== 'undefined') {
        if (typeof window.mozIndexedDB !== 'undefined') return window.mozIndexedDB;
        if (typeof window.webkitIndexedDB !== 'undefined') return window.webkitIndexedDB;
        if (typeof window.msIndexedDB !== 'undefined') return window.msIndexedDB;
    }
    return false;
}
function $173b20ec741d376d$export$17f2b65aeb68429e(tx) {
    if (tx.commit) tx.commit();
}
function $173b20ec741d376d$export$44470c96608c2d07(channelName) {
    var IndexedDB = $173b20ec741d376d$export$9bb0279d2d49cfa2();
    // create table
    var dbName = $173b20ec741d376d$var$DB_PREFIX + channelName;
    /**
   * All IndexedDB databases are opened without version
   * because it is a bit faster, especially on firefox
   * @link http://nparashuram.com/IndexedDB/perf/#Open%20Database%20with%20version
   */ var openRequest = IndexedDB.open(dbName);
    openRequest.onupgradeneeded = function(ev) {
        var db = ev.target.result;
        db.createObjectStore($173b20ec741d376d$var$OBJECT_STORE_ID, {
            keyPath: 'id',
            autoIncrement: true
        });
    };
    return new Promise(function(res, rej) {
        openRequest.onerror = function(ev) {
            return rej(ev);
        };
        openRequest.onsuccess = function() {
            res(openRequest.result);
        };
    });
}
function $173b20ec741d376d$export$c1667a36001fc792(db, readerUuid, messageJson) {
    var time = Date.now();
    var writeObject = {
        uuid: readerUuid,
        time: time,
        data: messageJson
    };
    var tx = db.transaction([
        $173b20ec741d376d$var$OBJECT_STORE_ID
    ], 'readwrite', $173b20ec741d376d$export$158bac47d00a5c4c);
    return new Promise(function(res, rej) {
        tx.oncomplete = function() {
            return res();
        };
        tx.onerror = function(ev) {
            return rej(ev);
        };
        var objectStore = tx.objectStore($173b20ec741d376d$var$OBJECT_STORE_ID);
        objectStore.add(writeObject);
        $173b20ec741d376d$export$17f2b65aeb68429e(tx);
    });
}
function $173b20ec741d376d$export$a5cd77f28ca54edc(db) {
    var tx = db.transaction($173b20ec741d376d$var$OBJECT_STORE_ID, 'readonly', $173b20ec741d376d$export$158bac47d00a5c4c);
    var objectStore = tx.objectStore($173b20ec741d376d$var$OBJECT_STORE_ID);
    var ret = [];
    return new Promise(function(res) {
        objectStore.openCursor().onsuccess = function(ev) {
            var cursor = ev.target.result;
            if (cursor) {
                ret.push(cursor.value);
                //alert("Name for SSN " + cursor.key + " is " + cursor.value.name);
                cursor["continue"]();
            } else {
                $173b20ec741d376d$export$17f2b65aeb68429e(tx);
                res(ret);
            }
        };
    });
}
function $173b20ec741d376d$export$e72d678308de85b5(db, lastCursorId) {
    var tx = db.transaction($173b20ec741d376d$var$OBJECT_STORE_ID, 'readonly', $173b20ec741d376d$export$158bac47d00a5c4c);
    var objectStore = tx.objectStore($173b20ec741d376d$var$OBJECT_STORE_ID);
    var ret = [];
    var keyRangeValue = IDBKeyRange.bound(lastCursorId + 1, Infinity);
    /**
   * Optimization shortcut,
   * if getAll() can be used, do not use a cursor.
   * @link https://rxdb.info/slow-indexeddb.html
   */ if (objectStore.getAll) {
        var getAllRequest = objectStore.getAll(keyRangeValue);
        return new Promise(function(res, rej) {
            getAllRequest.onerror = function(err) {
                return rej(err);
            };
            getAllRequest.onsuccess = function(e) {
                res(e.target.result);
            };
        });
    }
    function openCursor() {
        // Occasionally Safari will fail on IDBKeyRange.bound, this
        // catches that error, having it open the cursor to the first
        // item. When it gets data it will advance to the desired key.
        try {
            keyRangeValue = IDBKeyRange.bound(lastCursorId + 1, Infinity);
            return objectStore.openCursor(keyRangeValue);
        } catch (e) {
            return objectStore.openCursor();
        }
    }
    return new Promise(function(res, rej) {
        var openCursorRequest = openCursor();
        openCursorRequest.onerror = function(err) {
            return rej(err);
        };
        openCursorRequest.onsuccess = function(ev) {
            var cursor = ev.target.result;
            if (cursor) {
                if (cursor.value.id < lastCursorId + 1) cursor["continue"](lastCursorId + 1);
                else {
                    ret.push(cursor.value);
                    cursor["continue"]();
                }
            } else {
                $173b20ec741d376d$export$17f2b65aeb68429e(tx);
                res(ret);
            }
        };
    });
}
function $173b20ec741d376d$export$5dbe2125dcd25309(channelState, ids) {
    if (channelState.closed) return Promise.resolve([]);
    var tx = channelState.db.transaction($173b20ec741d376d$var$OBJECT_STORE_ID, 'readwrite', $173b20ec741d376d$export$158bac47d00a5c4c);
    var objectStore = tx.objectStore($173b20ec741d376d$var$OBJECT_STORE_ID);
    return Promise.all(ids.map(function(id) {
        var deleteRequest = objectStore["delete"](id);
        return new Promise(function(res) {
            deleteRequest.onsuccess = function() {
                return res();
            };
        });
    }));
}
function $173b20ec741d376d$export$1ad276d59b1ab4d4(db, ttl) {
    var olderThen = Date.now() - ttl;
    var tx = db.transaction($173b20ec741d376d$var$OBJECT_STORE_ID, 'readonly', $173b20ec741d376d$export$158bac47d00a5c4c);
    var objectStore = tx.objectStore($173b20ec741d376d$var$OBJECT_STORE_ID);
    var ret = [];
    return new Promise(function(res) {
        objectStore.openCursor().onsuccess = function(ev) {
            var cursor = ev.target.result;
            if (cursor) {
                var msgObk = cursor.value;
                if (msgObk.time < olderThen) {
                    ret.push(msgObk);
                    //alert("Name for SSN " + cursor.key + " is " + cursor.value.name);
                    cursor["continue"]();
                } else {
                    // no more old messages,
                    $173b20ec741d376d$export$17f2b65aeb68429e(tx);
                    res(ret);
                }
            } else res(ret);
        };
    });
}
function $173b20ec741d376d$export$8511d136ef71f411(channelState) {
    return $173b20ec741d376d$export$1ad276d59b1ab4d4(channelState.db, channelState.options.idb.ttl).then(function(tooOld) {
        return $173b20ec741d376d$export$5dbe2125dcd25309(channelState, tooOld.map(function(msg) {
            return msg.id;
        }));
    });
}
function $173b20ec741d376d$export$185802fd694ee1f5(channelName, options) {
    options = (0, $6aa5381df36fd806$export$7ee70d6123309e38)(options);
    return $173b20ec741d376d$export$44470c96608c2d07(channelName).then(function(db) {
        var state = {
            closed: false,
            lastCursorId: 0,
            channelName: channelName,
            options: options,
            uuid: (0, $4be22ff3aeacd06a$export$4e61f672936bec77)(),
            /**
       * emittedMessagesIds
       * contains all messages that have been emitted before
       * @type {ObliviousSet}
       */ eMIs: new (0, $f5dcc1e438a1228d$export$95f11f715943104f)(options.idb.ttl * 2),
            // ensures we do not read messages in parallel
            writeBlockPromise: (0, $4be22ff3aeacd06a$export$5187ac309d2dbc09),
            messagesCallback: null,
            readQueuePromises: [],
            db: db
        };
        /**
     * Handle abrupt closes that do not originate from db.close().
     * This could happen, for example, if the underlying storage is
     * removed or if the user clears the database in the browser's
     * history preferences.
     */ db.onclose = function() {
            state.closed = true;
            if (options.idb.onclose) options.idb.onclose();
        };
        /**
     * if service-workers are used,
     * we have no 'storage'-event if they post a message,
     * therefore we also have to set an interval
     */ $173b20ec741d376d$var$_readLoop(state);
        return state;
    });
}
function $173b20ec741d376d$var$_readLoop(state) {
    if (state.closed) return;
    $173b20ec741d376d$var$readNewMessages(state).then(function() {
        return (0, $4be22ff3aeacd06a$export$e772c8ff12451969)(state.options.idb.fallbackInterval);
    }).then(function() {
        return $173b20ec741d376d$var$_readLoop(state);
    });
}
function $173b20ec741d376d$var$_filterMessage(msgObj, state) {
    if (msgObj.uuid === state.uuid) return false; // send by own
    if (state.eMIs.has(msgObj.id)) return false; // already emitted
    if (msgObj.data.time < state.messagesCallbackTime) return false; // older then onMessageCallback
    return true;
}
/**
 * reads all new messages from the database and emits them
 */ function $173b20ec741d376d$var$readNewMessages(state) {
    // channel already closed
    if (state.closed) return 0, $4be22ff3aeacd06a$export$5187ac309d2dbc09;
    // if no one is listening, we do not need to scan for new messages
    if (!state.messagesCallback) return 0, $4be22ff3aeacd06a$export$5187ac309d2dbc09;
    return $173b20ec741d376d$export$e72d678308de85b5(state.db, state.lastCursorId).then(function(newerMessages) {
        var useMessages = newerMessages/**
     * there is a bug in iOS where the msgObj can be undefined sometimes
     * so we filter them out
     * @link https://github.com/pubkey/broadcast-channel/issues/19
     */ .filter(function(msgObj) {
            return !!msgObj;
        }).map(function(msgObj) {
            if (msgObj.id > state.lastCursorId) state.lastCursorId = msgObj.id;
            return msgObj;
        }).filter(function(msgObj) {
            return $173b20ec741d376d$var$_filterMessage(msgObj, state);
        }).sort(function(msgObjA, msgObjB) {
            return msgObjA.time - msgObjB.time;
        }); // sort by time
        useMessages.forEach(function(msgObj) {
            if (state.messagesCallback) {
                state.eMIs.add(msgObj.id);
                state.messagesCallback(msgObj.data);
            }
        });
        return 0, $4be22ff3aeacd06a$export$5187ac309d2dbc09;
    });
}
function $173b20ec741d376d$export$8360e631d277ea4d(channelState) {
    channelState.closed = true;
    channelState.db.close();
}
function $173b20ec741d376d$export$6efe264be9505de7(channelState, messageJson) {
    channelState.writeBlockPromise = channelState.writeBlockPromise.then(function() {
        return $173b20ec741d376d$export$c1667a36001fc792(channelState.db, channelState.uuid, messageJson);
    }).then(function() {
        if ((0, $4be22ff3aeacd06a$export$3c5f89dae98e900b)(0, 10) === 0) /* await (do not await) */ $173b20ec741d376d$export$8511d136ef71f411(channelState);
    });
    return channelState.writeBlockPromise;
}
function $173b20ec741d376d$export$7275a8dcb77dc20d(channelState, fn, time) {
    channelState.messagesCallbackTime = time;
    channelState.messagesCallback = fn;
    $173b20ec741d376d$var$readNewMessages(channelState);
}
function $173b20ec741d376d$export$edc1ec99af52c032() {
    return !!$173b20ec741d376d$export$9bb0279d2d49cfa2();
}
function $173b20ec741d376d$export$378952ed8d3ebcd6(options) {
    return options.idb.fallbackInterval * 2;
}
var $173b20ec741d376d$export$f9fb5084a1e99645 = {
    create: $173b20ec741d376d$export$185802fd694ee1f5,
    close: $173b20ec741d376d$export$8360e631d277ea4d,
    onMessage: $173b20ec741d376d$export$7275a8dcb77dc20d,
    postMessage: $173b20ec741d376d$export$6efe264be9505de7,
    canBeUsed: $173b20ec741d376d$export$edc1ec99af52c032,
    type: $173b20ec741d376d$export$bf9fb029d174d554,
    averageResponseTime: $173b20ec741d376d$export$378952ed8d3ebcd6,
    microSeconds: $173b20ec741d376d$export$b3e55dfce5152d1d
};


/**
 * A localStorage-only method which uses localstorage and its 'storage'-event
 * This does not work inside webworkers because they have no access to localstorage
 * This is basically implemented to support IE9 or your grandmother's toaster.
 * @link https://caniuse.com/#feat=namevalue-storage
 * @link https://caniuse.com/#feat=indexeddb
 */ 


var $004dd7bddde7d798$export$b3e55dfce5152d1d = (0, $4be22ff3aeacd06a$export$b3e55dfce5152d1d);
var $004dd7bddde7d798$var$KEY_PREFIX = 'pubkey.broadcastChannel-';
var $004dd7bddde7d798$export$bf9fb029d174d554 = 'localstorage';
function $004dd7bddde7d798$export$d3720feff416e85b() {
    var localStorage;
    if (typeof window === 'undefined') return null;
    try {
        localStorage = window.localStorage;
        localStorage = window['ie8-eventlistener/storage'] || window.localStorage;
    } catch (e) {
    // New versions of Firefox throw a Security exception
    // if cookies are disabled. See
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1028153
    }
    return localStorage;
}
function $004dd7bddde7d798$export$7367158f2f597ab1(channelName) {
    return $004dd7bddde7d798$var$KEY_PREFIX + channelName;
}
function $004dd7bddde7d798$export$6efe264be9505de7(channelState, messageJson) {
    return new Promise(function(res) {
        (0, $4be22ff3aeacd06a$export$e772c8ff12451969)().then(function() {
            var key = $004dd7bddde7d798$export$7367158f2f597ab1(channelState.channelName);
            var writeObj = {
                token: (0, $4be22ff3aeacd06a$export$4e61f672936bec77)(),
                time: Date.now(),
                data: messageJson,
                uuid: channelState.uuid
            };
            var value = JSON.stringify(writeObj);
            $004dd7bddde7d798$export$d3720feff416e85b().setItem(key, value);
            /**
       * StorageEvent does not fire the 'storage' event
       * in the window that changes the state of the local storage.
       * So we fire it manually
       */ var ev = document.createEvent('Event');
            ev.initEvent('storage', true, true);
            ev.key = key;
            ev.newValue = value;
            window.dispatchEvent(ev);
            res();
        });
    });
}
function $004dd7bddde7d798$export$e760364ddd2998eb(channelName, fn) {
    var key = $004dd7bddde7d798$export$7367158f2f597ab1(channelName);
    var listener = function listener(ev) {
        if (ev.key === key) fn(JSON.parse(ev.newValue));
    };
    window.addEventListener('storage', listener);
    return listener;
}
function $004dd7bddde7d798$export$cec52acdd19fc469(listener) {
    window.removeEventListener('storage', listener);
}
function $004dd7bddde7d798$export$185802fd694ee1f5(channelName, options) {
    options = (0, $6aa5381df36fd806$export$7ee70d6123309e38)(options);
    if (!$004dd7bddde7d798$export$edc1ec99af52c032()) throw new Error('BroadcastChannel: localstorage cannot be used');
    var uuid = (0, $4be22ff3aeacd06a$export$4e61f672936bec77)();
    /**
   * eMIs
   * contains all messages that have been emitted before
   * @type {ObliviousSet}
   */ var eMIs = new (0, $f5dcc1e438a1228d$export$95f11f715943104f)(options.localstorage.removeTimeout);
    var state = {
        channelName: channelName,
        uuid: uuid,
        eMIs: eMIs // emittedMessagesIds
    };
    state.listener = $004dd7bddde7d798$export$e760364ddd2998eb(channelName, function(msgObj) {
        if (!state.messagesCallback) return; // no listener
        if (msgObj.uuid === uuid) return; // own message
        if (!msgObj.token || eMIs.has(msgObj.token)) return; // already emitted
        if (msgObj.data.time && msgObj.data.time < state.messagesCallbackTime) return; // too old
        eMIs.add(msgObj.token);
        state.messagesCallback(msgObj.data);
    });
    return state;
}
function $004dd7bddde7d798$export$8360e631d277ea4d(channelState) {
    $004dd7bddde7d798$export$cec52acdd19fc469(channelState.listener);
}
function $004dd7bddde7d798$export$7275a8dcb77dc20d(channelState, fn, time) {
    channelState.messagesCallbackTime = time;
    channelState.messagesCallback = fn;
}
function $004dd7bddde7d798$export$edc1ec99af52c032() {
    var ls = $004dd7bddde7d798$export$d3720feff416e85b();
    if (!ls) return false;
    try {
        var key = '__broadcastchannel_check';
        ls.setItem(key, 'works');
        ls.removeItem(key);
    } catch (e) {
        // Safari 10 in private mode will not allow write access to local
        // storage and fail with a QuotaExceededError. See
        // https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API#Private_Browsing_Incognito_modes
        return false;
    }
    return true;
}
function $004dd7bddde7d798$export$378952ed8d3ebcd6() {
    var defaultTime = 120;
    var userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.includes('safari') && !userAgent.includes('chrome')) // safari is much slower so this time is higher
    return defaultTime * 2;
    return defaultTime;
}
var $004dd7bddde7d798$export$9b9bc32d3762ca15 = {
    create: $004dd7bddde7d798$export$185802fd694ee1f5,
    close: $004dd7bddde7d798$export$8360e631d277ea4d,
    onMessage: $004dd7bddde7d798$export$7275a8dcb77dc20d,
    postMessage: $004dd7bddde7d798$export$6efe264be9505de7,
    canBeUsed: $004dd7bddde7d798$export$edc1ec99af52c032,
    type: $004dd7bddde7d798$export$bf9fb029d174d554,
    averageResponseTime: $004dd7bddde7d798$export$378952ed8d3ebcd6,
    microSeconds: $004dd7bddde7d798$export$b3e55dfce5152d1d
};



var $94fb7f576c69cc49$export$b3e55dfce5152d1d = (0, $4be22ff3aeacd06a$export$b3e55dfce5152d1d);
var $94fb7f576c69cc49$export$bf9fb029d174d554 = 'simulate';
var $94fb7f576c69cc49$var$SIMULATE_CHANNELS = new Set();
function $94fb7f576c69cc49$export$185802fd694ee1f5(channelName) {
    var state = {
        time: $94fb7f576c69cc49$export$b3e55dfce5152d1d(),
        name: channelName,
        messagesCallback: null
    };
    $94fb7f576c69cc49$var$SIMULATE_CHANNELS.add(state);
    return state;
}
function $94fb7f576c69cc49$export$8360e631d277ea4d(channelState) {
    $94fb7f576c69cc49$var$SIMULATE_CHANNELS["delete"](channelState);
}
var $94fb7f576c69cc49$export$5097a33aa28f8342 = 5;
function $94fb7f576c69cc49$export$6efe264be9505de7(channelState, messageJson) {
    return new Promise(function(res) {
        return setTimeout(function() {
            var channelArray = Array.from($94fb7f576c69cc49$var$SIMULATE_CHANNELS);
            channelArray.forEach(function(channel) {
                if (channel.name === channelState.name && // has same name
                channel !== channelState && // not own channel
                !!channel.messagesCallback && // has subscribers
                channel.time < messageJson.time // channel not created after postMessage() call
                ) channel.messagesCallback(messageJson);
            });
            res();
        }, $94fb7f576c69cc49$export$5097a33aa28f8342);
    });
}
function $94fb7f576c69cc49$export$7275a8dcb77dc20d(channelState, fn) {
    channelState.messagesCallback = fn;
}
function $94fb7f576c69cc49$export$edc1ec99af52c032() {
    return true;
}
function $94fb7f576c69cc49$export$378952ed8d3ebcd6() {
    return $94fb7f576c69cc49$export$5097a33aa28f8342;
}
var $94fb7f576c69cc49$export$6cab4f14afd51a43 = {
    create: $94fb7f576c69cc49$export$185802fd694ee1f5,
    close: $94fb7f576c69cc49$export$8360e631d277ea4d,
    onMessage: $94fb7f576c69cc49$export$7275a8dcb77dc20d,
    postMessage: $94fb7f576c69cc49$export$6efe264be9505de7,
    canBeUsed: $94fb7f576c69cc49$export$edc1ec99af52c032,
    type: $94fb7f576c69cc49$export$bf9fb029d174d554,
    averageResponseTime: $94fb7f576c69cc49$export$378952ed8d3ebcd6,
    microSeconds: $94fb7f576c69cc49$export$b3e55dfce5152d1d
};


// the line below will be removed from es5/browser builds
// order is important
var $3ec96c3df7223ba3$var$METHODS = [
    (0, $6e6dec193b4793b8$export$c2e5cf752d4e2634),
    // fastest
    (0, $173b20ec741d376d$export$f9fb5084a1e99645),
    (0, $004dd7bddde7d798$export$9b9bc32d3762ca15)
];
function $3ec96c3df7223ba3$export$bc8f997dfd48bd57(options) {
    var chooseMethods = [].concat(options.methods, $3ec96c3df7223ba3$var$METHODS).filter(Boolean);
    // the line below will be removed from es5/browser builds
    // directly chosen
    if (options.type) {
        if (options.type === 'simulate') // only use simulate-method if directly chosen
        return 0, $94fb7f576c69cc49$export$6cab4f14afd51a43;
        var ret = chooseMethods.find(function(m) {
            return m.type === options.type;
        });
        if (!ret) throw new Error('method-type ' + options.type + ' not found');
        else return ret;
    }
    /**
   * if no webworker support is needed,
   * remove idb from the list so that localstorage will be chosen
   */ if (!options.webWorkerSupport) chooseMethods = chooseMethods.filter(function(m) {
        return m.type !== 'idb';
    });
    var useMethod = chooseMethods.find(function(method) {
        return method.canBeUsed();
    });
    if (!useMethod) throw new Error("No usable method found in " + JSON.stringify($3ec96c3df7223ba3$var$METHODS.map(function(m) {
        return m.type;
    })));
    else return useMethod;
}



var $b55a5bdd8b841170$export$a36c4a9e1adc527 = new Set();
var $b55a5bdd8b841170$var$lastId = 0;
var $b55a5bdd8b841170$export$f0e5058d63a378d5 = function BroadcastChannel(name, options) {
    // identifier of the channel to debug stuff
    this.id = $b55a5bdd8b841170$var$lastId++;
    $b55a5bdd8b841170$export$a36c4a9e1adc527.add(this);
    this.name = name;
    if ($b55a5bdd8b841170$var$ENFORCED_OPTIONS) options = $b55a5bdd8b841170$var$ENFORCED_OPTIONS;
    this.options = (0, $6aa5381df36fd806$export$7ee70d6123309e38)(options);
    this.method = (0, $3ec96c3df7223ba3$export$bc8f997dfd48bd57)(this.options);
    // isListening
    this._iL = false;
    /**
   * _onMessageListener
   * setting onmessage twice,
   * will overwrite the first listener
   */ this._onML = null;
    /**
   * _addEventListeners
   */ this._addEL = {
        message: [],
        internal: []
    };
    /**
   * Unsent message promises
   * where the sending is still in progress
   * @type {Set<Promise>}
   */ this._uMP = new Set();
    /**
   * _beforeClose
   * array of promises that will be awaited
   * before the channel is closed
   */ this._befC = [];
    /**
   * _preparePromise
   */ this._prepP = null;
    $b55a5bdd8b841170$var$_prepareChannel(this);
};
// STATICS
/**
 * used to identify if someone overwrites
 * window.BroadcastChannel with this
 * See methods/native.js
 */ $b55a5bdd8b841170$export$f0e5058d63a378d5._pubkey = true;
function $b55a5bdd8b841170$export$88418e3e0b88b3ce(options) {
    options = (0, $6aa5381df36fd806$export$7ee70d6123309e38)(options);
    var method = (0, $3ec96c3df7223ba3$export$bc8f997dfd48bd57)(options);
    if (method.type === 'node') return method.clearNodeFolder().then(function() {
        return true;
    });
    else return 0, $4be22ff3aeacd06a$export$6332f88de91a4f29;
}
/**
 * if set, this method is enforced,
 * no mather what the options are
 */ var $b55a5bdd8b841170$var$ENFORCED_OPTIONS;
function $b55a5bdd8b841170$export$62d57cbacc8722b4(options) {
    $b55a5bdd8b841170$var$ENFORCED_OPTIONS = options;
}
// PROTOTYPE
$b55a5bdd8b841170$export$f0e5058d63a378d5.prototype = {
    postMessage: function postMessage(msg) {
        if (this.closed) throw new Error("BroadcastChannel.postMessage(): Cannot post message after channel has closed " + /**
       * In the past when this error appeared, it was really hard to debug.
       * So now we log the msg together with the error so it at least
       * gives some clue about where in your application this happens.
       */ JSON.stringify(msg));
        return $b55a5bdd8b841170$var$_post(this, 'message', msg);
    },
    postInternal: function postInternal(msg) {
        return $b55a5bdd8b841170$var$_post(this, 'internal', msg);
    },
    set onmessage (fn){
        var time = this.method.microSeconds();
        var listenObj = {
            time: time,
            fn: fn
        };
        $b55a5bdd8b841170$var$_removeListenerObject(this, 'message', this._onML);
        if (fn && typeof fn === 'function') {
            this._onML = listenObj;
            $b55a5bdd8b841170$var$_addListenerObject(this, 'message', listenObj);
        } else this._onML = null;
    },
    addEventListener: function addEventListener(type, fn1) {
        var time = this.method.microSeconds();
        var listenObj = {
            time: time,
            fn: fn1
        };
        $b55a5bdd8b841170$var$_addListenerObject(this, type, listenObj);
    },
    removeEventListener: function removeEventListener(type, fn1) {
        var obj = this._addEL[type].find(function(obj) {
            return obj.fn === fn1;
        });
        $b55a5bdd8b841170$var$_removeListenerObject(this, type, obj);
    },
    close: function close() {
        var _this = this;
        if (this.closed) return;
        $b55a5bdd8b841170$export$a36c4a9e1adc527["delete"](this);
        this.closed = true;
        var awaitPrepare = this._prepP ? this._prepP : (0, $4be22ff3aeacd06a$export$5187ac309d2dbc09);
        this._onML = null;
        this._addEL.message = [];
        return awaitPrepare// wait until all current sending are processed
        .then(function() {
            return Promise.all(Array.from(_this._uMP));
        })// run before-close hooks
        .then(function() {
            return Promise.all(_this._befC.map(function(fn1) {
                return fn1();
            }));
        })// close the channel
        .then(function() {
            return _this.method.close(_this._state);
        });
    },
    get type () {
        return this.method.type;
    },
    get isClosed () {
        return this.closed;
    }
};
/**
 * Post a message over the channel
 * @returns {Promise} that resolved when the message sending is done
 */ function $b55a5bdd8b841170$var$_post(broadcastChannel, type, msg) {
    var time = broadcastChannel.method.microSeconds();
    var msgObj = {
        time: time,
        type: type,
        data: msg
    };
    var awaitPrepare = broadcastChannel._prepP ? broadcastChannel._prepP : (0, $4be22ff3aeacd06a$export$5187ac309d2dbc09);
    return awaitPrepare.then(function() {
        var sendPromise = broadcastChannel.method.postMessage(broadcastChannel._state, msgObj);
        // add/remove to unsent messages list
        broadcastChannel._uMP.add(sendPromise);
        sendPromise["catch"]().then(function() {
            return broadcastChannel._uMP["delete"](sendPromise);
        });
        return sendPromise;
    });
}
function $b55a5bdd8b841170$var$_prepareChannel(channel) {
    var maybePromise = channel.method.create(channel.name, channel.options);
    if ((0, $4be22ff3aeacd06a$export$4369c812aac99591)(maybePromise)) {
        channel._prepP = maybePromise;
        maybePromise.then(function(s) {
            // used in tests to simulate slow runtime
            /*if (channel.options.prepareDelay) {
           await new Promise(res => setTimeout(res, this.options.prepareDelay));
      }*/ channel._state = s;
        });
    } else channel._state = maybePromise;
}
function $b55a5bdd8b841170$var$_hasMessageListeners(channel) {
    if (channel._addEL.message.length > 0) return true;
    if (channel._addEL.internal.length > 0) return true;
    return false;
}
function $b55a5bdd8b841170$var$_addListenerObject(channel, type, obj) {
    channel._addEL[type].push(obj);
    $b55a5bdd8b841170$var$_startListening(channel);
}
function $b55a5bdd8b841170$var$_removeListenerObject(channel, type, obj) {
    channel._addEL[type] = channel._addEL[type].filter(function(o) {
        return o !== obj;
    });
    $b55a5bdd8b841170$var$_stopListening(channel);
}
function $b55a5bdd8b841170$var$_startListening(channel) {
    if (!channel._iL && $b55a5bdd8b841170$var$_hasMessageListeners(channel)) {
        // someone is listening, start subscribing
        var listenerFn = function listenerFn(msgObj) {
            channel._addEL[msgObj.type].forEach(function(listenerObject) {
                if (msgObj.time >= listenerObject.time) listenerObject.fn(msgObj.data);
            });
        };
        var time = channel.method.microSeconds();
        if (channel._prepP) channel._prepP.then(function() {
            channel._iL = true;
            channel.method.onMessage(channel._state, listenerFn, time);
        });
        else {
            channel._iL = true;
            channel.method.onMessage(channel._state, listenerFn, time);
        }
    }
}
function $b55a5bdd8b841170$var$_stopListening(channel) {
    if (channel._iL && !$b55a5bdd8b841170$var$_hasMessageListeners(channel)) {
        // no one is listening, stop subscribing
        channel._iL = false;
        var time = channel.method.microSeconds();
        channel.method.onMessage(channel._state, null, time);
    }
}







class $c04ed372cc11e5eb$export$3efe6bd3f56fa439 {
    constructor(tokenManager, options = {}){
        this.started = false;
        this.enablePostMessage = true;
        this.tokenManager = tokenManager;
        this.options = options;
        this.onTokenAddedHandler = this.onTokenAddedHandler.bind(this);
        this.onTokenRemovedHandler = this.onTokenRemovedHandler.bind(this);
        this.onTokenRenewedHandler = this.onTokenRenewedHandler.bind(this);
        this.onSetStorageHandler = this.onSetStorageHandler.bind(this);
        this.onSyncMessageHandler = this.onSyncMessageHandler.bind(this);
    }
    requiresLeadership() {
        return false;
    }
    isStarted() {
        return this.started;
    }
    canStart() {
        return !!this.options.syncStorage && (0, $58f01731783bc4a6$export$4e09c449d6c407f7)() && !this.started;
    }
    async start() {
        if (!this.canStart()) return;
        const { syncChannelName: syncChannelName } = this.options;
        try {
            this.channel = new (0, $b55a5bdd8b841170$export$f0e5058d63a378d5)(syncChannelName);
        } catch (err) {
            throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('SyncStorageService is not supported in current browser.');
        }
        this.tokenManager.on((0, $c2154470a1d6c1a5$export$e9f9d3905a889e02), this.onTokenAddedHandler);
        this.tokenManager.on((0, $c2154470a1d6c1a5$export$9995ae835670bd28), this.onTokenRemovedHandler);
        this.tokenManager.on((0, $c2154470a1d6c1a5$export$421812244c1f12f0), this.onTokenRenewedHandler);
        this.tokenManager.on((0, $c2154470a1d6c1a5$export$772c2bdc9dda0203), this.onSetStorageHandler);
        this.channel.addEventListener('message', this.onSyncMessageHandler);
        this.started = true;
    }
    async stop() {
        var _a, _b;
        if (this.started) {
            this.tokenManager.off((0, $c2154470a1d6c1a5$export$e9f9d3905a889e02), this.onTokenAddedHandler);
            this.tokenManager.off((0, $c2154470a1d6c1a5$export$9995ae835670bd28), this.onTokenRemovedHandler);
            this.tokenManager.off((0, $c2154470a1d6c1a5$export$421812244c1f12f0), this.onTokenRenewedHandler);
            this.tokenManager.off((0, $c2154470a1d6c1a5$export$772c2bdc9dda0203), this.onSetStorageHandler);
            (_a = this.channel) === null || _a === void 0 || _a.removeEventListener('message', this.onSyncMessageHandler);
            await ((_b = this.channel) === null || _b === void 0 ? void 0 : _b.close());
            this.channel = undefined;
            this.started = false;
        }
    }
    onTokenAddedHandler(key, token) {
        var _a;
        if (!this.enablePostMessage) return;
        (_a = this.channel) === null || _a === void 0 || _a.postMessage({
            type: (0, $c2154470a1d6c1a5$export$e9f9d3905a889e02),
            key: key,
            token: token
        });
    }
    onTokenRemovedHandler(key, token) {
        var _a;
        if (!this.enablePostMessage) return;
        (_a = this.channel) === null || _a === void 0 || _a.postMessage({
            type: (0, $c2154470a1d6c1a5$export$9995ae835670bd28),
            key: key,
            token: token
        });
    }
    onTokenRenewedHandler(key, token, oldToken) {
        var _a;
        if (!this.enablePostMessage) return;
        (_a = this.channel) === null || _a === void 0 || _a.postMessage({
            type: (0, $c2154470a1d6c1a5$export$421812244c1f12f0),
            key: key,
            token: token,
            oldToken: oldToken
        });
    }
    onSetStorageHandler(storage) {
        var _a;
        (_a = this.channel) === null || _a === void 0 || _a.postMessage({
            type: (0, $c2154470a1d6c1a5$export$772c2bdc9dda0203),
            storage: storage
        });
    }
    onSyncMessageHandler(msg) {
        this.enablePostMessage = false;
        switch(msg.type){
            case 0, $c2154470a1d6c1a5$export$772c2bdc9dda0203:
                this.tokenManager.getStorage().setStorage(msg.storage);
                break;
            case 0, $c2154470a1d6c1a5$export$e9f9d3905a889e02:
                this.tokenManager.emitAdded(msg.key, msg.token);
                this.tokenManager.setExpireEventTimeout(msg.key, msg.token);
                break;
            case 0, $c2154470a1d6c1a5$export$9995ae835670bd28:
                this.tokenManager.clearExpireEventTimeout(msg.key);
                this.tokenManager.emitRemoved(msg.key, msg.token);
                break;
            case 0, $c2154470a1d6c1a5$export$421812244c1f12f0:
                this.tokenManager.emitRenewed(msg.key, msg.token, msg.oldToken);
                break;
        }
        this.enablePostMessage = true;
    }
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
/* global WorkerGlobalScope */ function $2728fff8ada9f44e$export$ae93c1693bb96e6(fn) {
    if (typeof WorkerGlobalScope === 'function' && self instanceof WorkerGlobalScope) {
        /**
     * Because killing a worker does directly stop the excution
     * of the code, our only chance is to overwrite the close function
     * which could work some times.
     * @link https://stackoverflow.com/q/72903255/3443137
     */ var oldClose = self.close.bind(self);
        self.close = function() {
            fn();
            return oldClose();
        };
    } else {
        /**
     * if we are on react-native, there is no window.addEventListener
     * @link https://github.com/pubkey/unload/issues/6
     */ if (typeof window.addEventListener !== 'function') return;
        /**
     * for normal browser-windows, we use the beforeunload-event
     */ window.addEventListener('beforeunload', function() {
            fn();
        }, true);
        /**
     * for iframes, we have to use the unload-event
     * @link https://stackoverflow.com/q/47533670/3443137
     */ window.addEventListener('unload', function() {
            fn();
        }, true);
    }
/**
   * TODO add fallback for safari-mobile
   * @link https://stackoverflow.com/a/26193516/3443137
   */ }



function $be4492cb7bd8e90a$export$2fed3c3ffa8e7fdf(fn) {
    $375d8335527bcde6$exports.on('exit', function() {
        return fn();
    });
    /**
   * on the following events,
   * the process will not end if there are
   * event-handlers attached,
   * therefore we have to call process.exit()
   */ $375d8335527bcde6$exports.on('beforeExit', function() {
        return fn().then(function() {
            return $375d8335527bcde6$exports.exit();
        });
    });
    // catches ctrl+c event
    $375d8335527bcde6$exports.on('SIGINT', function() {
        return fn().then(function() {
            return $375d8335527bcde6$exports.exit();
        });
    });
    // catches uncaught exceptions
    $375d8335527bcde6$exports.on('uncaughtException', function(err) {
        return fn().then(function() {
            console.trace(err);
            $375d8335527bcde6$exports.exit(101);
        });
    });
}


/**
 * Use the code directly to prevent import problems
 * with the detect-node package.
 * @link https://github.com/iliakan/detect-node/blob/master/index.js
 */ var $ba461d87e682fb70$var$isNode = Object.prototype.toString.call(0) === '[object process]';
var $ba461d87e682fb70$var$USE_METHOD = $ba461d87e682fb70$var$isNode ? (0, $be4492cb7bd8e90a$export$2fed3c3ffa8e7fdf) : (0, $2728fff8ada9f44e$export$ae93c1693bb96e6);
var $ba461d87e682fb70$var$LISTENERS = new Set();
var $ba461d87e682fb70$var$startedListening = false;
function $ba461d87e682fb70$var$startListening() {
    if ($ba461d87e682fb70$var$startedListening) return;
    $ba461d87e682fb70$var$startedListening = true;
    $ba461d87e682fb70$var$USE_METHOD($ba461d87e682fb70$export$62f8a3b655d92f84);
}
function $ba461d87e682fb70$export$e16d8520af44a096(fn) {
    $ba461d87e682fb70$var$startListening();
    if (typeof fn !== 'function') throw new Error('Listener is no function');
    $ba461d87e682fb70$var$LISTENERS.add(fn);
    var addReturn = {
        remove: function remove() {
            return $ba461d87e682fb70$var$LISTENERS["delete"](fn);
        },
        run: function run() {
            $ba461d87e682fb70$var$LISTENERS["delete"](fn);
            return fn();
        }
    };
    return addReturn;
}
function $ba461d87e682fb70$export$62f8a3b655d92f84() {
    var promises = [];
    $ba461d87e682fb70$var$LISTENERS.forEach(function(fn) {
        promises.push(fn());
        $ba461d87e682fb70$var$LISTENERS["delete"](fn);
    });
    return Promise.all(promises);
}
function $ba461d87e682fb70$export$1cfc7aad5cb1833b() {
    $ba461d87e682fb70$var$LISTENERS.clear();
}
function $ba461d87e682fb70$export$31b21d0167753bb4() {
    return $ba461d87e682fb70$var$LISTENERS.size;
}


function $29fef0ff90dbe813$export$3dc3e712f47e19f(leaderElector, action) {
    var msgJson = {
        context: 'leader',
        action: action,
        token: leaderElector.token
    };
    return leaderElector.broadcastChannel.postInternal(msgJson);
}
function $29fef0ff90dbe813$export$7ef45c3373dd6bfa(leaderElector) {
    leaderElector.isLeader = true;
    leaderElector._hasLeader = true;
    var unloadFn = (0, $ba461d87e682fb70$export$e16d8520af44a096)(function() {
        return leaderElector.die();
    });
    leaderElector._unl.push(unloadFn);
    var isLeaderListener = function isLeaderListener(msg) {
        if (msg.context === 'leader' && msg.action === 'apply') $29fef0ff90dbe813$export$3dc3e712f47e19f(leaderElector, 'tell');
        if (msg.context === 'leader' && msg.action === 'tell' && !leaderElector._dpLC) {
            /**
       * another instance is also leader!
       * This can happen on rare events
       * like when the CPU is at 100% for long time
       * or the tabs are open very long and the browser throttles them.
       * @link https://github.com/pubkey/broadcast-channel/issues/414
       * @link https://github.com/pubkey/broadcast-channel/issues/385
       */ leaderElector._dpLC = true;
            leaderElector._dpL(); // message the lib user so the app can handle the problem
            $29fef0ff90dbe813$export$3dc3e712f47e19f(leaderElector, 'tell'); // ensure other leader also knows the problem
        }
    };
    leaderElector.broadcastChannel.addEventListener('internal', isLeaderListener);
    leaderElector._lstns.push(isLeaderListener);
    return $29fef0ff90dbe813$export$3dc3e712f47e19f(leaderElector, 'tell');
}




var $7da4d01862ac7591$export$ec7ac9ac703b19d5 = function LeaderElectionWebLock(broadcastChannel, options) {
    var _this = this;
    this.broadcastChannel = broadcastChannel;
    broadcastChannel._befC.push(function() {
        return _this.die();
    });
    this._options = options;
    this.isLeader = false;
    this.isDead = false;
    this.token = (0, $4be22ff3aeacd06a$export$4e61f672936bec77)();
    this._lstns = [];
    this._unl = [];
    this._dpL = function() {}; // onduplicate listener
    this._dpLC = false; // true when onduplicate called
    this._wKMC = {}; // stuff for cleanup
    // lock name
    this.lN = 'pubkey-bc||' + broadcastChannel.method.type + '||' + broadcastChannel.name;
};
var $7da4d01862ac7591$var$LEADER_DIE_ABORT_SIGNAL_MESSAGE = 'LeaderElectionWebLock.die() called';
$7da4d01862ac7591$export$ec7ac9ac703b19d5.prototype = {
    hasLeader: function hasLeader() {
        var _this2 = this;
        return navigator.locks.query().then(function(locks) {
            var relevantLocks = locks.held ? locks.held.filter(function(lock) {
                return lock.name === _this2.lN;
            }) : [];
            if (relevantLocks && relevantLocks.length > 0) return true;
            else return false;
        });
    },
    awaitLeadership: function awaitLeadership() {
        var _this3 = this;
        if (!this._wLMP) {
            this._wKMC.c = new AbortController();
            var returnPromise = new Promise(function(res, rej) {
                _this3._wKMC.res = res;
                _this3._wKMC.rej = rej;
            });
            this._wLMP = new Promise(function(res, reject) {
                navigator.locks.request(_this3.lN, {
                    signal: _this3._wKMC.c.signal
                }, function() {
                    // if the lock resolved, we can drop the abort controller
                    _this3._wKMC.c = undefined;
                    (0, $29fef0ff90dbe813$export$7ef45c3373dd6bfa)(_this3);
                    res();
                    return returnPromise;
                })["catch"](function(err) {
                    if (err.message && err.message === $7da4d01862ac7591$var$LEADER_DIE_ABORT_SIGNAL_MESSAGE) ;
                    else {
                        if (_this3._wKMC.rej) _this3._wKMC.rej(err);
                        reject(err);
                    }
                });
            });
        }
        return this._wLMP;
    },
    set onduplicate (_fn){
    // Do nothing because there are no duplicates in the WebLock version
    },
    die: function die() {
        var _this4 = this;
        this._lstns.forEach(function(listener) {
            return _this4.broadcastChannel.removeEventListener('internal', listener);
        });
        this._lstns = [];
        this._unl.forEach(function(uFn) {
            return uFn.remove();
        });
        this._unl = [];
        if (this.isLeader) this.isLeader = false;
        this.isDead = true;
        if (this._wKMC.res) this._wKMC.res();
        /**
     * We have to fire an abort signal
     * so that the navigator.locks.request stops.
     */ if (this._wKMC.c) this._wKMC.c.abort(new Error($7da4d01862ac7591$var$LEADER_DIE_ABORT_SIGNAL_MESSAGE));
        return (0, $29fef0ff90dbe813$export$3dc3e712f47e19f)(this, 'death');
    }
};


var $75d3959acd8bf32f$var$LeaderElection = function LeaderElection(broadcastChannel, options) {
    var _this = this;
    this.broadcastChannel = broadcastChannel;
    this._options = options;
    this.isLeader = false;
    this._hasLeader = false;
    this.isDead = false;
    this.token = (0, $4be22ff3aeacd06a$export$4e61f672936bec77)();
    /**
   * Apply Queue,
   * used to ensure we do not run applyOnce()
   * in parallel.
   */ this._aplQ = (0, $4be22ff3aeacd06a$export$5187ac309d2dbc09);
    // amount of unfinished applyOnce() calls
    this._aplQC = 0;
    // things to clean up
    this._unl = []; // _unloads
    this._lstns = []; // _listeners
    this._dpL = function() {}; // onduplicate listener
    this._dpLC = false; // true when onduplicate called
    /**
   * Even when the own instance is not applying,
   * we still listen to messages to ensure the hasLeader flag
   * is set correctly.
   */ var hasLeaderListener = function hasLeaderListener(msg) {
        if (msg.context === 'leader') {
            if (msg.action === 'death') _this._hasLeader = false;
            if (msg.action === 'tell') _this._hasLeader = true;
        }
    };
    this.broadcastChannel.addEventListener('internal', hasLeaderListener);
    this._lstns.push(hasLeaderListener);
};
$75d3959acd8bf32f$var$LeaderElection.prototype = {
    hasLeader: function hasLeader() {
        return Promise.resolve(this._hasLeader);
    },
    /**
   * Returns true if the instance is leader,
   * false if not.
   * @async
   */ applyOnce: function applyOnce(// true if the applyOnce() call came from the fallbackInterval cycle
    isFromFallbackInterval) {
        var _this2 = this;
        if (this.isLeader) return (0, $4be22ff3aeacd06a$export$e772c8ff12451969)(0, true);
        if (this.isDead) return (0, $4be22ff3aeacd06a$export$e772c8ff12451969)(0, false);
        /**
     * Already applying more than once,
     * -> wait for the apply queue to be finished.
     */ if (this._aplQC > 1) return this._aplQ;
        /**
     * Add a new apply-run
     */ var applyRun = function applyRun() {
            /**
       * Optimization shortcuts.
       * Directly return if a previous run
       * has already elected a leader.
       */ if (_this2.isLeader) return 0, $4be22ff3aeacd06a$export$b5d9069fca1162b4;
            var stopCriteria = false;
            var stopCriteriaPromiseResolve;
            /**
       * Resolves when a stop criteria is reached.
       * Uses as a performance shortcut so we do not
       * have to await the responseTime when it is already clear
       * that the election failed.
       */ var stopCriteriaPromise = new Promise(function(res) {
                stopCriteriaPromiseResolve = function stopCriteriaPromiseResolve() {
                    stopCriteria = true;
                    res();
                };
            });
            var handleMessage = function handleMessage(msg) {
                if (msg.context === 'leader' && msg.token != _this2.token) {
                    if (msg.action === 'apply') // other is applying
                    {
                        if (msg.token > _this2.token) /**
               * other has higher token
               * -> stop applying and let other become leader.
               */ stopCriteriaPromiseResolve();
                    }
                    if (msg.action === 'tell') {
                        // other is already leader
                        stopCriteriaPromiseResolve();
                        _this2._hasLeader = true;
                    }
                }
            };
            _this2.broadcastChannel.addEventListener('internal', handleMessage);
            /**
       * If the applyOnce() call came from the fallbackInterval,
       * we can assume that the election runs in the background and
       * not critical process is waiting for it.
       * When this is true, we give the other instances
       * more time to answer to messages in the election cycle.
       * This makes it less likely to elect duplicate leaders.
       * But also it takes longer which is not a problem because we anyway
       * run in the background.
       */ var waitForAnswerTime = isFromFallbackInterval ? _this2._options.responseTime * 4 : _this2._options.responseTime;
            return (0, $29fef0ff90dbe813$export$3dc3e712f47e19f)(_this2, 'apply') // send out that this one is applying
            .then(function() {
                return Promise.race([
                    (0, $4be22ff3aeacd06a$export$e772c8ff12451969)(waitForAnswerTime),
                    stopCriteriaPromise.then(function() {
                        return Promise.reject(new Error());
                    })
                ]);
            })// send again in case another instance was just created
            .then(function() {
                return (0, $29fef0ff90dbe813$export$3dc3e712f47e19f)(_this2, 'apply');
            })// let others time to respond
            .then(function() {
                return Promise.race([
                    (0, $4be22ff3aeacd06a$export$e772c8ff12451969)(waitForAnswerTime),
                    stopCriteriaPromise.then(function() {
                        return Promise.reject(new Error());
                    })
                ]);
            })["catch"](function() {}).then(function() {
                _this2.broadcastChannel.removeEventListener('internal', handleMessage);
                if (!stopCriteria) // no stop criteria -> own is leader
                return (0, $29fef0ff90dbe813$export$7ef45c3373dd6bfa)(_this2).then(function() {
                    return true;
                });
                else // other is leader
                return false;
            });
        };
        this._aplQC = this._aplQC + 1;
        this._aplQ = this._aplQ.then(function() {
            return applyRun();
        }).then(function() {
            _this2._aplQC = _this2._aplQC - 1;
        });
        return this._aplQ.then(function() {
            return _this2.isLeader;
        });
    },
    awaitLeadership: function awaitLeadership() {
        if (/* _awaitLeadershipPromise */ !this._aLP) this._aLP = $75d3959acd8bf32f$var$_awaitLeadershipOnce(this);
        return this._aLP;
    },
    set onduplicate (fn){
        this._dpL = fn;
    },
    die: function die() {
        var _this3 = this;
        this._lstns.forEach(function(listener) {
            return _this3.broadcastChannel.removeEventListener('internal', listener);
        });
        this._lstns = [];
        this._unl.forEach(function(uFn) {
            return uFn.remove();
        });
        this._unl = [];
        if (this.isLeader) {
            this._hasLeader = false;
            this.isLeader = false;
        }
        this.isDead = true;
        return (0, $29fef0ff90dbe813$export$3dc3e712f47e19f)(this, 'death');
    }
};
/**
 * @param leaderElector {LeaderElector}
 */ function $75d3959acd8bf32f$var$_awaitLeadershipOnce(leaderElector) {
    if (leaderElector.isLeader) return 0, $4be22ff3aeacd06a$export$5187ac309d2dbc09;
    return new Promise(function(res) {
        var resolved = false;
        function finish() {
            if (resolved) return;
            resolved = true;
            leaderElector.broadcastChannel.removeEventListener('internal', whenDeathListener);
            res(true);
        }
        // try once now
        leaderElector.applyOnce().then(function() {
            if (leaderElector.isLeader) finish();
        });
        /**
     * Try on fallbackInterval
     * @recursive
     */ var _tryOnFallBack = function tryOnFallBack() {
            return (0, $4be22ff3aeacd06a$export$e772c8ff12451969)(leaderElector._options.fallbackInterval).then(function() {
                if (leaderElector.isDead || resolved) return;
                if (leaderElector.isLeader) finish();
                else return leaderElector.applyOnce(true).then(function() {
                    if (leaderElector.isLeader) finish();
                    else _tryOnFallBack();
                });
            });
        };
        _tryOnFallBack();
        // try when other leader dies
        var whenDeathListener = function whenDeathListener(msg) {
            if (msg.context === 'leader' && msg.action === 'death') {
                leaderElector._hasLeader = false;
                leaderElector.applyOnce().then(function() {
                    if (leaderElector.isLeader) finish();
                });
            }
        };
        leaderElector.broadcastChannel.addEventListener('internal', whenDeathListener);
        leaderElector._lstns.push(whenDeathListener);
    });
}
function $75d3959acd8bf32f$var$fillOptionsWithDefaults(options, channel) {
    if (!options) options = {};
    options = JSON.parse(JSON.stringify(options));
    if (!options.fallbackInterval) options.fallbackInterval = 3000;
    if (!options.responseTime) options.responseTime = channel.method.averageResponseTime(channel.options);
    return options;
}
function $75d3959acd8bf32f$export$36340bbbe5bc42fa(channel, options) {
    if (channel._leaderElector) throw new Error('BroadcastChannel already has a leader-elector');
    options = $75d3959acd8bf32f$var$fillOptionsWithDefaults(options, channel);
    var elector = (0, $4be22ff3aeacd06a$export$9f0d99555d35e998)() ? new (0, $7da4d01862ac7591$export$ec7ac9ac703b19d5)(channel, options) : new $75d3959acd8bf32f$var$LeaderElection(channel, options);
    channel._befC.push(function() {
        return elector.die();
    });
    channel._leaderElector = elector;
    return elector;
}



class $541937416ea7452a$export$87fb4e9ce3c63b8d {
    constructor(options = {}){
        this.started = false;
        this.options = options;
        this.onLeaderDuplicate = this.onLeaderDuplicate.bind(this);
        this.onLeader = this.onLeader.bind(this);
    }
    onLeaderDuplicate() {}
    async onLeader() {
        var _a, _b;
        await ((_b = (_a = this.options).onLeader) === null || _b === void 0 ? void 0 : _b.call(_a));
    }
    isLeader() {
        var _a;
        return !!((_a = this.elector) === null || _a === void 0 ? void 0 : _a.isLeader);
    }
    hasLeader() {
        var _a;
        return !!((_a = this.elector) === null || _a === void 0 ? void 0 : _a.hasLeader);
    }
    async start() {
        if (this.canStart()) {
            const { electionChannelName: electionChannelName } = this.options;
            this.channel = new (0, $b55a5bdd8b841170$export$f0e5058d63a378d5)(electionChannelName);
            this.elector = (0, $75d3959acd8bf32f$export$36340bbbe5bc42fa)(this.channel);
            this.elector.onduplicate = this.onLeaderDuplicate;
            this.elector.awaitLeadership().then(this.onLeader);
            this.started = true;
        }
    }
    async stop() {
        if (this.started) {
            if (this.elector) {
                await this.elector.die();
                this.elector = undefined;
            }
            if (this.channel) {
                this.channel.postInternal = ()=>Promise.resolve();
                await this.channel.close();
                this.channel = undefined;
            }
            this.started = false;
        }
    }
    requiresLeadership() {
        return false;
    }
    isStarted() {
        return this.started;
    }
    canStart() {
        return (0, $58f01731783bc4a6$export$4e09c449d6c407f7)() && !this.started;
    }
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
const $4d7fc4c887bf52dc$var$getNow = ()=>Math.floor(Date.now() / 1000);
class $4d7fc4c887bf52dc$export$138c2d43c98b1c32 {
    constructor(tokenManager, options = {}){
        this.started = false;
        this.lastHidden = -1;
        this.tokenManager = tokenManager;
        this.options = options;
        this.onPageVisbilityChange = this._onPageVisbilityChange.bind(this);
    }
    _onPageVisbilityChange() {
        if (document.hidden) this.lastHidden = $4d7fc4c887bf52dc$var$getNow();
        else if (this.lastHidden > 0 && $4d7fc4c887bf52dc$var$getNow() - this.lastHidden >= this.options.tabInactivityDuration) {
            const { accessToken: accessToken, idToken: idToken } = this.tokenManager.getTokensSync();
            if (!!accessToken && this.tokenManager.hasExpired(accessToken)) {
                const key = this.tokenManager.getStorageKeyByType('accessToken');
                this.tokenManager.renew(key).catch(()=>{});
            } else if (!!idToken && this.tokenManager.hasExpired(idToken)) {
                const key = this.tokenManager.getStorageKeyByType('idToken');
                this.tokenManager.renew(key).catch(()=>{});
            }
        }
    }
    async start() {
        if (this.canStart() && !!document) {
            document.addEventListener('visibilitychange', this.onPageVisbilityChange);
            this.started = true;
        }
    }
    async stop() {
        if (document) {
            document.removeEventListener('visibilitychange', this.onPageVisbilityChange);
            this.started = false;
        }
    }
    canStart() {
        return (0, $58f01731783bc4a6$export$4e09c449d6c407f7)() && !!this.options.autoRenew && !!this.options.renewOnTabActivation && !this.started;
    }
    requiresLeadership() {
        return false;
    }
    isStarted() {
        return this.started;
    }
}



const $b8303f882762273d$var$AUTO_RENEW = 'autoRenew';
const $b8303f882762273d$var$SYNC_STORAGE = 'syncStorage';
const $b8303f882762273d$var$LEADER_ELECTION = 'leaderElection';
const $b8303f882762273d$var$RENEW_ON_TAB_ACTIVATION = 'renewOnTabActivation';
class $b8303f882762273d$export$9af02ac651b5d289 {
    constructor(sdk, options = {}){
        this.sdk = sdk;
        this.onLeader = this.onLeader.bind(this);
        const { autoRenew: autoRenew, autoRemove: autoRemove, syncStorage: syncStorage } = sdk.tokenManager.getOptions();
        options.electionChannelName = options.electionChannelName || options.broadcastChannelName;
        this.options = Object.assign({}, $b8303f882762273d$export$9af02ac651b5d289.defaultOptions, {
            autoRenew: autoRenew,
            autoRemove: autoRemove,
            syncStorage: syncStorage
        }, {
            electionChannelName: `${sdk.options.clientId}-election`,
            syncChannelName: `${sdk.options.clientId}-sync`
        }, (0, $27ec06d649eea38f$export$1ef1ad6eb7b897a2)(options));
        this.started = false;
        this.services = new Map();
        $b8303f882762273d$export$9af02ac651b5d289.knownServices.forEach((name)=>{
            const svc = this.createService(name);
            if (svc) this.services.set(name, svc);
        });
    }
    async onLeader() {
        if (this.started) await this.startServices();
    }
    isLeader() {
        var _a;
        return (_a = this.getService($b8303f882762273d$var$LEADER_ELECTION)) === null || _a === void 0 ? void 0 : _a.isLeader();
    }
    isLeaderRequired() {
        return [
            ...this.services.values()
        ].some((srv)=>srv.canStart() && srv.requiresLeadership());
    }
    async start() {
        if (this.started) return;
        await this.startServices();
        this.started = true;
    }
    async stop() {
        await this.stopServices();
        this.started = false;
    }
    getService(name) {
        return this.services.get(name);
    }
    async startServices() {
        for (const [name, srv] of this.services.entries())if (this.canStartService(name, srv)) await srv.start();
    }
    async stopServices() {
        for (const srv of this.services.values())await srv.stop();
    }
    canStartService(name, srv) {
        let canStart = srv.canStart() && !srv.isStarted();
        if (name === $b8303f882762273d$var$LEADER_ELECTION) canStart && (canStart = this.isLeaderRequired());
        else if (srv.requiresLeadership()) canStart && (canStart = this.isLeader());
        return canStart;
    }
    createService(name) {
        const tokenManager = this.sdk.tokenManager;
        let service;
        switch(name){
            case $b8303f882762273d$var$LEADER_ELECTION:
                service = new (0, $541937416ea7452a$export$87fb4e9ce3c63b8d)(Object.assign(Object.assign({}, this.options), {
                    onLeader: this.onLeader
                }));
                break;
            case $b8303f882762273d$var$AUTO_RENEW:
                service = new (0, $729de8568668874f$export$6493f06a8769bada)(tokenManager, Object.assign({}, this.options));
                break;
            case $b8303f882762273d$var$SYNC_STORAGE:
                service = new (0, $c04ed372cc11e5eb$export$3efe6bd3f56fa439)(tokenManager, Object.assign({}, this.options));
                break;
            case $b8303f882762273d$var$RENEW_ON_TAB_ACTIVATION:
                service = new (0, $4d7fc4c887bf52dc$export$138c2d43c98b1c32)(tokenManager, Object.assign({}, this.options));
                break;
            default:
                throw new Error(`Unknown service ${name}`);
        }
        return service;
    }
}
$b8303f882762273d$export$9af02ac651b5d289.knownServices = [
    $b8303f882762273d$var$AUTO_RENEW,
    $b8303f882762273d$var$SYNC_STORAGE,
    $b8303f882762273d$var$LEADER_ELECTION,
    $b8303f882762273d$var$RENEW_ON_TAB_ACTIVATION
];
$b8303f882762273d$export$9af02ac651b5d289.defaultOptions = {
    autoRenew: true,
    autoRemove: true,
    syncStorage: true,
    renewOnTabActivation: true,
    tabInactivityDuration: 1800
};




function $ed76c6d841355fe3$export$324af875a74d487c(Base) {
    return class OktaAuthCore extends Base {
        constructor(...args){
            super(...args);
            this.authStateManager = new (0, $562587acf8513b13$export$98841555a7280e2b)(this);
            this.serviceManager = new (0, $b8303f882762273d$export$9af02ac651b5d289)(this, this.options.services);
        }
        async start() {
            await this.serviceManager.start();
            this.tokenManager.start();
            if (!this.token.isLoginRedirect()) await this.authStateManager.updateAuthState();
        }
        async stop() {
            this.tokenManager.stop();
            await this.serviceManager.stop();
        }
        async handleRedirect(originalUri) {
            await this.handleLoginRedirect(undefined, originalUri);
        }
        async handleLoginRedirect(tokens, originalUri) {
            let state = this.options.state;
            if (tokens) {
                this.tokenManager.setTokens(tokens);
                originalUri = originalUri || this.getOriginalUri(this.options.state);
            } else if (this.isLoginRedirect()) try {
                const oAuthResponse = await (0, $5e42ca1549474cf0$export$3cd68b6fe191e121)(this, {});
                state = oAuthResponse.state;
                originalUri = originalUri || this.getOriginalUri(state);
                await this.storeTokensFromRedirect();
            } catch (e) {
                await this.authStateManager.updateAuthState();
                throw e;
            }
            else return;
            await this.authStateManager.updateAuthState();
            this.removeOriginalUri(state);
            const { restoreOriginalUri: restoreOriginalUri } = this.options;
            if (restoreOriginalUri) await restoreOriginalUri(this, originalUri);
            else if (originalUri) window.location.replace(originalUri);
        }
        handleIDPPopupRedirect(url = window.location.href) {
            const res = (0, $5e42ca1549474cf0$export$3cd68b6fe191e121)(this, {
                responseMode: 'query',
                url: url
            });
            if (res.state) {
                const channel = new BroadcastChannel(`popup-callback:${res.state}`);
                channel.postMessage(res);
                channel.close();
            } else throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('Unable to parse auth code params');
        }
    };
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 




function $c723e2453c8f7085$export$761080fe0a1126b6(sdk) {
    return sdk.session.get().then(function(res) {
        if (res.status === 'ACTIVE') return true;
        return false;
    }).catch(function() {
        return false;
    });
}
function $c723e2453c8f7085$export$12151e9ef3722552(sdk) {
    return (0, $0898b9c80798427c$export$3988ae62b71be9a3)(sdk, '/api/v1/sessions/me', {
        withCredentials: true
    }).then(function(session) {
        var res = (0, $27ec06d649eea38f$export$30a06c8d3562193f)(session, '_links');
        res.refresh = function() {
            return (0, $0898b9c80798427c$export$299ba2dee77727e9)(sdk, (0, $27ec06d649eea38f$export$67e8a86e59c99895)(session, 'refresh').href, {}, {
                withCredentials: true
            });
        };
        res.user = function() {
            return (0, $0898b9c80798427c$export$3988ae62b71be9a3)(sdk, (0, $27ec06d649eea38f$export$67e8a86e59c99895)(session, 'user').href, {
                withCredentials: true
            });
        };
        return res;
    }).catch(function() {
        return {
            status: 'INACTIVE'
        };
    });
}
function $c723e2453c8f7085$export$56521d9ba90f62ee(sdk) {
    return (0, $0898b9c80798427c$export$46f383001bf60e04)(sdk, {
        url: sdk.getIssuerOrigin() + '/api/v1/sessions/me',
        method: 'DELETE',
        withCredentials: true
    });
}
function $c723e2453c8f7085$export$296522b9b583854e(sdk) {
    return (0, $0898b9c80798427c$export$299ba2dee77727e9)(sdk, '/api/v1/sessions/me/lifecycle/refresh', {}, {
        withCredentials: true
    });
}
function $c723e2453c8f7085$export$8b02a6d59e051725(sdk, sessionToken, redirectUrl) {
    redirectUrl = redirectUrl || window.location.href;
    window.location.assign(sdk.getIssuerOrigin() + '/login/sessionCookieRedirect' + (0, $47114d36cb1410d5$export$249cc09c933c4d7a)({
        checkAccountSetupComplete: true,
        token: sessionToken,
        redirectUrl: redirectUrl
    }));
}


function $eaa5bd3c72ca8bff$export$26f57a39a58e7109(sdk) {
    const session = {
        close: (0, $c723e2453c8f7085$export$56521d9ba90f62ee).bind(null, sdk),
        exists: (0, $c723e2453c8f7085$export$761080fe0a1126b6).bind(null, sdk),
        get: (0, $c723e2453c8f7085$export$12151e9ef3722552).bind(null, sdk),
        refresh: (0, $c723e2453c8f7085$export$296522b9b583854e).bind(null, sdk),
        setCookieAndRedirect: (0, $c723e2453c8f7085$export$8b02a6d59e051725).bind(null, sdk)
    };
    return session;
}


function $3608d4223921823b$export$e29a1eee069c5053(Base) {
    return class OktaAuthSession extends Base {
        constructor(...args){
            super(...args);
            this.session = (0, $eaa5bd3c72ca8bff$export$26f57a39a58e7109)(this);
        }
        closeSession() {
            return this.session.close().then(async ()=>{
                this.clearStorage();
                return true;
            }).catch(function(e) {
                if (e.name === 'AuthApiError' && e.errorCode === 'E0000007') return false;
                throw e;
            });
        }
    };
}


function $89f6f29862b2ea5c$export$30ddaac95d0f4b52(StorageManagerConstructor, OptionsConstructor, TransactionManagerConstructor) {
    const Base = (0, $2f2331dacfdaa6d6$export$2bc41dfbf048bfdc)(OptionsConstructor);
    const WithStorage = (0, $7b18006d527823f4$export$32ec6248008f35d1)(Base, StorageManagerConstructor);
    const WithHttp = (0, $42dc341ca5ee8859$export$b21483dcd2900eca)(WithStorage);
    const WithSession = (0, $3608d4223921823b$export$e29a1eee069c5053)(WithHttp);
    const WithOAuth = (0, $81aceab9ba49f668$export$d2d79cf72153e095)(WithSession, TransactionManagerConstructor);
    const Core = (0, $ed76c6d841355fe3$export$324af875a74d487c)(WithOAuth);
    return Core;
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 








const $9648776745ae4879$var$isMessageFromCorrectSource = (iframe, event)=>event.source === iframe.contentWindow;
function $9648776745ae4879$export$2e2bcd8739ae039(sdk, options) {
    var _a;
    if (!(0, $58f01731783bc4a6$export$cfef6ce26ae59877)()) return Promise.reject(new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('Fingerprinting is not supported on this device'));
    const container = (_a = options === null || options === void 0 ? void 0 : options.container) !== null && _a !== void 0 ? _a : document.body;
    let timeout;
    let iframe;
    let listener;
    const promise = new Promise(function(resolve, reject) {
        iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        listener = function listener(e) {
            var _a;
            if (!$9648776745ae4879$var$isMessageFromCorrectSource(iframe, e)) return;
            if (!e || !e.data || e.origin !== sdk.getIssuerOrigin()) return;
            let msg;
            try {
                msg = JSON.parse(e.data);
            } catch (err) {
                return;
            }
            if (!msg) return;
            if (msg.type === 'FingerprintAvailable') return resolve(msg.fingerprint);
            else if (msg.type === 'FingerprintServiceReady') (_a = iframe === null || iframe === void 0 ? void 0 : iframe.contentWindow) === null || _a === void 0 || _a.postMessage(JSON.stringify({
                type: 'GetFingerprint'
            }), e.origin);
            else return reject(new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('No data'));
        };
        (0, $e5c0cf9b5ba78c65$export$f03a6b845d3fb58b)(window, 'message', listener);
        iframe.src = sdk.getIssuerOrigin() + '/auth/services/devicefingerprint';
        container.appendChild(iframe);
        timeout = setTimeout(function() {
            reject(new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('Fingerprinting timed out'));
        }, (options === null || options === void 0 ? void 0 : options.timeout) || 15000);
    });
    return promise.finally(function() {
        var _a;
        clearTimeout(timeout);
        (0, $e5c0cf9b5ba78c65$export$b03e9483f936dccb)(window, 'message', listener);
        if (container.contains(iframe)) (_a = iframe.parentElement) === null || _a === void 0 || _a.removeChild(iframe);
    });
}


var $b86e6e964f88de19$exports = {};

$parcel$export($b86e6e964f88de19$exports, "buildCredentialCreationOptions", function () { return $b86e6e964f88de19$export$8509032865b5aecb; });
$parcel$export($b86e6e964f88de19$exports, "buildCredentialRequestOptions", function () { return $b86e6e964f88de19$export$b6208251c25a1fb5; });
$parcel$export($b86e6e964f88de19$exports, "getAttestation", function () { return $b86e6e964f88de19$export$fbeebbd9ab90644e; });
$parcel$export($b86e6e964f88de19$exports, "getAssertion", function () { return $b86e6e964f88de19$export$191af95378f46deb; });
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
const $b86e6e964f88de19$var$getEnrolledCredentials = (authenticatorEnrollments = [])=>{
    const credentials = [];
    authenticatorEnrollments.forEach((enrollement)=>{
        var _a, _b;
        if (enrollement.key === 'webauthn') {
            const credential = {
                type: 'public-key',
                id: (0, $70ef0a6a68a02baf$export$74669d1cb8191241)(enrollement.credentialId)
            };
            const transports = (_a = enrollement.transports) !== null && _a !== void 0 ? _a : (_b = enrollement.profile) === null || _b === void 0 ? void 0 : _b.transports;
            if (Array.isArray(transports)) credential.transports = transports;
            credentials.push(credential);
        }
    });
    return credentials;
};
const $b86e6e964f88de19$export$8509032865b5aecb = (activationData, authenticatorEnrollments)=>{
    return {
        publicKey: Object.assign({
            rp: activationData.rp,
            user: {
                id: (0, $70ef0a6a68a02baf$export$74669d1cb8191241)(activationData.user.id),
                name: activationData.user.name,
                displayName: activationData.user.displayName
            },
            challenge: (0, $70ef0a6a68a02baf$export$74669d1cb8191241)(activationData.challenge),
            pubKeyCredParams: activationData.pubKeyCredParams,
            attestation: activationData.attestation,
            authenticatorSelection: activationData.authenticatorSelection,
            excludeCredentials: $b86e6e964f88de19$var$getEnrolledCredentials(authenticatorEnrollments)
        }, activationData.hints && {
            hints: activationData.hints
        })
    };
};
const $b86e6e964f88de19$export$b6208251c25a1fb5 = (challengeData, authenticatorEnrollments)=>{
    return {
        publicKey: Object.assign(Object.assign({
            challenge: (0, $70ef0a6a68a02baf$export$74669d1cb8191241)(challengeData.challenge),
            userVerification: challengeData.userVerification,
            allowCredentials: $b86e6e964f88de19$var$getEnrolledCredentials(authenticatorEnrollments)
        }, challengeData.rpId && {
            rpId: challengeData.rpId
        }), challengeData.hints && {
            hints: challengeData.hints
        })
    };
};
const $b86e6e964f88de19$export$fbeebbd9ab90644e = (credential)=>{
    const response = credential.response;
    const id = credential.id;
    const clientData = (0, $70ef0a6a68a02baf$export$271320a6f6117eda)(response.clientDataJSON);
    const attestation = (0, $70ef0a6a68a02baf$export$271320a6f6117eda)(response.attestationObject);
    const getTransportsFn = response.getTransports;
    const result = {
        id: id,
        clientData: clientData,
        attestation: attestation
    };
    if (typeof getTransportsFn === 'function') result.transports = JSON.stringify(getTransportsFn.call(response));
    return result;
};
const $b86e6e964f88de19$export$191af95378f46deb = (credential)=>{
    const response = credential.response;
    const id = credential.id;
    const clientData = (0, $70ef0a6a68a02baf$export$271320a6f6117eda)(response.clientDataJSON);
    const authenticatorData = (0, $70ef0a6a68a02baf$export$271320a6f6117eda)(response.authenticatorData);
    const signatureData = (0, $70ef0a6a68a02baf$export$271320a6f6117eda)(response.signature);
    return {
        id: id,
        clientData: clientData,
        authenticatorData: authenticatorData,
        signatureData: signatureData
    };
};


function $22704e2e4d096424$export$52c91c927fe5f302(Base) {
    var _a;
    return _a = class OktaAuthIdx extends Base {
        constructor(...args){
            super(...args);
            this.idx = (0, $e32da978cb24bf1e$export$8e517878c6a5f058)(this);
            this.fingerprint = (0, $9648776745ae4879$export$2e2bcd8739ae039).bind(null, this);
        }
    }, _a.webauthn = $b86e6e964f88de19$exports, _a;
}


function $fac99824551c1bb5$export$2f30fde9bc853c45(StorageManagerConstructor, OptionsConstructor, TransactionManagerConstructor) {
    const Core = (0, $89f6f29862b2ea5c$export$30ddaac95d0f4b52)(StorageManagerConstructor, OptionsConstructor, TransactionManagerConstructor);
    const WithIdx = (0, $22704e2e4d096424$export$52c91c927fe5f302)(Core);
    return WithIdx;
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 



function $d0feb06d2c5f9f32$export$114e54a1663ffe2b(minimalSdk) {
    const sdk = minimalSdk;
    const boundStartTransaction = (0, $e533ec8a98e87e3f$export$e262da7ae6480481).bind(null, sdk);
    const idx = {
        makeIdxResponse: (0, $baf0710ab57b8a95$export$67f6ec95030789e9).bind(null, sdk),
        start: boundStartTransaction,
        startTransaction: boundStartTransaction,
        proceed: (0, $a92debe5f6bc98a3$export$2eb0bdfd23e39c86).bind(null, sdk),
        canProceed: (0, $a92debe5f6bc98a3$export$2b22a8feb63a44b6).bind(null, sdk),
        getSavedTransactionMeta: (0, $e0bbf14d4839e4ff$export$ee78659ae5675f26).bind(null, sdk),
        createTransactionMeta: (0, $e0bbf14d4839e4ff$export$88d345acadfc62dd).bind(null, sdk),
        getTransactionMeta: (0, $e0bbf14d4839e4ff$export$701cc743c44cf8ae).bind(null, sdk),
        saveTransactionMeta: (0, $e0bbf14d4839e4ff$export$dc27696b235944d6).bind(null, sdk),
        clearTransactionMeta: (0, $e0bbf14d4839e4ff$export$750593bdfc027325).bind(null, sdk),
        isTransactionMetaValid: $e0bbf14d4839e4ff$export$e14be23af70c5fd
    };
    return idx;
}




function $9ac265d19643743f$export$48e102243775c07d(Base) {
    var _a;
    return _a = class OktaAuthIdx extends Base {
        constructor(...args){
            super(...args);
            this.idx = (0, $d0feb06d2c5f9f32$export$114e54a1663ffe2b)(this);
            this.fingerprint = (0, $9648776745ae4879$export$2e2bcd8739ae039).bind(null, this);
        }
    }, _a.webauthn = $b86e6e964f88de19$exports, _a;
}






/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 




function $068ec9d8fa7b1e57$export$e0734cedaf22f563(sdk) {
    const token = {
        prepareTokenParams: (0, $2a423e05498af5f7$export$6aa55a8b4ad50d4b).bind(null, sdk),
        exchangeCodeForTokens: (0, $af686b972b438d35$export$b0d0dc26369c3965).bind(null, sdk),
        decode: (0, $15e2e50b214bda39$export$4b61618bdb99cb7e)
    };
    return token;
}








function $a4f4152c661b77d4$export$d24a04a5726d348a(Base, TransactionManagerConstructor) {
    return class OktaAuthOAuth extends Base {
        constructor(...args){
            super(...args);
            this.transactionManager = new TransactionManagerConstructor(Object.assign({
                storageManager: this.storageManager
            }, this.options.transactionManager));
            this.token = (0, $068ec9d8fa7b1e57$export$e0734cedaf22f563)(this);
        }
        isLoginRedirect() {
            return (0, $30cbbe4b83336d5c$export$3488c667ccc91890)(this);
        }
        isPKCE() {
            return !!this.options.pkce;
        }
        hasResponseType(responseType) {
            return (0, $30cbbe4b83336d5c$export$85f1abab17a58c57)(responseType, this.options);
        }
        isAuthorizationCodeFlow() {
            return this.hasResponseType('code');
        }
    };
}


function $20648e6a91afbf1b$export$6b6296e34782c8ba(StorageManagerConstructor, OptionsConstructor, TransactionManagerConstructor) {
    const Base = (0, $2f2331dacfdaa6d6$export$2bc41dfbf048bfdc)(OptionsConstructor);
    const WithStorage = (0, $7b18006d527823f4$export$32ec6248008f35d1)(Base, StorageManagerConstructor);
    const WithHttp = (0, $42dc341ca5ee8859$export$b21483dcd2900eca)(WithStorage);
    const WithSession = (0, $3608d4223921823b$export$e29a1eee069c5053)(WithHttp);
    const WithOAuth = (0, $a4f4152c661b77d4$export$d24a04a5726d348a)(WithSession, TransactionManagerConstructor);
    const WithIdx = (0, $9ac265d19643743f$export$48e102243775c07d)(WithOAuth);
    return WithIdx;
}



/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 





/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 

/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ function $bc81df11f00c21c6$export$bca8fa66398c16c1() {
    return class BaseOptionsConstructor {
        constructor(args){
            this.devMode = !!args.devMode;
        }
    };
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 

function $365f6dcb281ecbf6$export$fbd9b57a66480737() {
    const storageUtil$1 = Object.assign({}, (0, $4f78310fe4774396$export$2e2bcd8739ae039), {
        inMemoryStore: {}
    });
    return storageUtil$1;
}
const $365f6dcb281ecbf6$export$e228d94b1bf0c1f = {
    token: {
        storageTypes: [
            'localStorage',
            'sessionStorage',
            'cookie'
        ]
    },
    cache: {
        storageTypes: [
            'localStorage',
            'sessionStorage',
            'cookie'
        ]
    },
    transaction: {
        storageTypes: [
            'sessionStorage',
            'localStorage',
            'cookie'
        ]
    },
    'shared-transaction': {
        storageTypes: [
            'localStorage'
        ]
    },
    'original-uri': {
        storageTypes: [
            'localStorage'
        ]
    }
};
function $365f6dcb281ecbf6$export$df8a26958a7f0c1a(args = {}, isHTTPS) {
    var cookieSettings = args.cookies || {};
    if (typeof cookieSettings.secure === 'undefined') cookieSettings.secure = isHTTPS;
    if (typeof cookieSettings.sameSite === 'undefined') cookieSettings.sameSite = cookieSettings.secure ? 'none' : 'lax';
    if (cookieSettings.secure && !isHTTPS) {
        (0, $26320b9c410af87d$export$c106dd0671a0fc2d)('The current page is not being served with the HTTPS protocol.\nFor security reasons, we strongly recommend using HTTPS.\nIf you cannot use HTTPS, set "cookies.secure" option to false.');
        cookieSettings.secure = false;
    }
    if (cookieSettings.sameSite === 'none' && !cookieSettings.secure) cookieSettings.sameSite = 'lax';
    return cookieSettings;
}


function $d62e30224c0c783f$export$51d1a53a62bacfd9() {
    const BaseOptionsConstructor = (0, $bc81df11f00c21c6$export$bca8fa66398c16c1)();
    return class StorageOptionsConstructor extends BaseOptionsConstructor {
        constructor(args){
            super(args);
            this.cookies = (0, $365f6dcb281ecbf6$export$df8a26958a7f0c1a)(args, (0, $58f01731783bc4a6$export$ab537f3fcabe7053)());
            this.storageUtil = args.storageUtil || (0, $365f6dcb281ecbf6$export$fbd9b57a66480737)();
            this.storageManager = Object.assign(Object.assign({}, (0, $365f6dcb281ecbf6$export$e228d94b1bf0c1f)), args.storageManager);
        }
    };
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ const $1b546e59b155b4de$var$appJsonContentTypeRegex = /application\/\w*\+?json/;
function $1b546e59b155b4de$var$readData(response) {
    if (response.headers.get('Content-Type') && response.headers.get('Content-Type').toLowerCase().indexOf('application/json') >= 0) return response.json().catch((e)=>{
        return {
            error: e,
            errorSummary: 'Could not parse server response'
        };
    });
    else return response.text();
}
function $1b546e59b155b4de$var$formatResult(status, data, response) {
    const isObject = typeof data === 'object';
    const headers = {};
    for (const pair of response.headers.entries())headers[pair[0]] = pair[1];
    const result = {
        responseText: isObject ? JSON.stringify(data) : data,
        status: status,
        headers: headers
    };
    if (isObject) {
        result.responseType = 'json';
        result.responseJSON = data;
    }
    return result;
}
function $1b546e59b155b4de$export$2e2bcd8739ae039(method, url, args) {
    var body = args.data;
    var headers = args.headers || {};
    var contentType = headers['Content-Type'] || headers['content-type'] || '';
    if (body && typeof body !== 'string') {
        if ($1b546e59b155b4de$var$appJsonContentTypeRegex.test(contentType)) body = JSON.stringify(body);
        else if (contentType === 'application/x-www-form-urlencoded') body = Object.entries(body).map(([param, value])=>`${param}=${encodeURIComponent(value)}`).join('&');
    }
    var fetch = window.fetch;
    var fetchPromise = fetch(url, {
        method: method,
        headers: args.headers,
        body: body,
        credentials: args.withCredentials ? 'include' : 'omit'
    });
    if (!fetchPromise.finally) fetchPromise = Promise.resolve(fetchPromise);
    return fetchPromise.then(function(response) {
        var error = !response.ok;
        var status = response.status;
        return $1b546e59b155b4de$var$readData(response).then((data)=>{
            return $1b546e59b155b4de$var$formatResult(status, data, response);
        }).then((result)=>{
            var _a;
            if (error || ((_a = result.responseJSON) === null || _a === void 0 ? void 0 : _a.error)) throw result;
            return result;
        });
    });
}


function $0c1f103858c4f81f$export$b53ab73ced457e7c() {
    const StorageOptionsConstructor = (0, $d62e30224c0c783f$export$51d1a53a62bacfd9)();
    return class HttpOptionsConstructor extends StorageOptionsConstructor {
        constructor(args){
            super(args);
            this.issuer = args.issuer;
            this.transformErrorXHR = args.transformErrorXHR;
            this.headers = args.headers;
            this.httpRequestClient = args.httpRequestClient || (0, $1b546e59b155b4de$export$2e2bcd8739ae039);
            this.httpRequestInterceptors = args.httpRequestInterceptors;
            this.pollDelay = args.pollDelay;
        }
    };
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ const $28638383ba3574c1$export$b5983bbbbf9d3e4b = true;



function $6db2fa6953dfa867$var$assertValidConfig(args) {
    args = args || {};
    var scopes = args.scopes;
    if (scopes && !Array.isArray(scopes)) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('scopes must be a array of strings. Required usage: new OktaAuth({scopes: ["openid", "email"]})');
    var issuer = args.issuer;
    if (!issuer) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('No issuer passed to constructor. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com/oauth2/{authServerId}"})');
    var isUrlRegex = new RegExp('^http?s?://.+');
    if (!isUrlRegex.test(issuer)) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('Issuer must be a valid URL. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com/oauth2/{authServerId}"})');
    if (issuer.indexOf('-admin.okta') !== -1) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('Issuer URL passed to constructor contains "-admin" in subdomain. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com})');
}
function $6db2fa6953dfa867$export$a8a46368b9c2e15c() {
    const HttpOptionsConstructor = (0, $0c1f103858c4f81f$export$b53ab73ced457e7c)();
    return class OAuthOptionsConstructor extends HttpOptionsConstructor {
        constructor(options){
            super(options);
            $6db2fa6953dfa867$var$assertValidConfig(options);
            this.issuer = (0, $47114d36cb1410d5$export$b6d465111d914331)(options.issuer);
            this.tokenUrl = (0, $47114d36cb1410d5$export$b6d465111d914331)(options.tokenUrl);
            this.authorizeUrl = (0, $47114d36cb1410d5$export$b6d465111d914331)(options.authorizeUrl);
            this.userinfoUrl = (0, $47114d36cb1410d5$export$b6d465111d914331)(options.userinfoUrl);
            this.revokeUrl = (0, $47114d36cb1410d5$export$b6d465111d914331)(options.revokeUrl);
            this.logoutUrl = (0, $47114d36cb1410d5$export$b6d465111d914331)(options.logoutUrl);
            this.pkce = options.pkce === false ? false : true;
            this.clientId = options.clientId;
            this.redirectUri = options.redirectUri;
            if ((0, $58f01731783bc4a6$export$4e09c449d6c407f7)()) this.redirectUri = (0, $47114d36cb1410d5$export$7895c48e9c019048)(options.redirectUri, window.location.origin);
            this.responseType = options.responseType;
            this.responseMode = options.responseMode;
            this.state = options.state;
            this.scopes = options.scopes;
            this.ignoreSignature = !!options.ignoreSignature;
            this.codeChallenge = options.codeChallenge;
            this.codeChallengeMethod = options.codeChallengeMethod;
            this.acrValues = options.acrValues;
            this.maxAge = options.maxAge;
            this.dpop = options.dpop === true;
            this.dpopOptions = Object.assign({
                allowBearerTokens: false
            }, options.dpopOptions);
            this.decodeAccessTokens = options.decodeAccessTokens === true;
            this.tokenManager = options.tokenManager;
            this.postLogoutRedirectUri = options.postLogoutRedirectUri;
            this.restoreOriginalUri = options.restoreOriginalUri;
            this.transactionManager = Object.assign({
                enableSharedStorage: $28638383ba3574c1$export$b5983bbbbf9d3e4b
            }, options.transactionManager);
            this.clientSecret = options.clientSecret;
            this.setLocation = options.setLocation;
            this.ignoreLifetime = !!options.ignoreLifetime;
            if (!options.maxClockSkew && options.maxClockSkew !== 0) this.maxClockSkew = (0, $a2c830cc0d95456a$export$a842e30d5ade6c4c);
            else this.maxClockSkew = options.maxClockSkew;
        }
    };
}


function $ffbea53b554e32cd$export$91562c406dfe69db() {
    const OAuthOptionsConstructor = (0, $6db2fa6953dfa867$export$a8a46368b9c2e15c)();
    return class CoreOptionsConstructor extends OAuthOptionsConstructor {
        constructor(options){
            super(options);
            this.services = options.services;
            this.transformAuthState = options.transformAuthState;
        }
    };
}


function $38ea4bcc7e79f8fb$export$2fa277826aad984c() {
    const CoreOptionsConstructor = (0, $ffbea53b554e32cd$export$91562c406dfe69db)();
    return class IdxOptionsConstructor extends CoreOptionsConstructor {
        constructor(options){
            super(options);
            this.flow = options.flow;
            this.activationToken = options.activationToken;
            this.recoveryToken = options.recoveryToken;
            this.idx = options.idx;
        }
    };
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 





/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
class $dc0d1b738fac06db$export$97309a63b39c07f4 {
    constructor(storage, storageName){
        if (!storage) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('"storage" is required');
        if (typeof storageName !== 'string' || !storageName.length) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('"storageName" is required');
        this.storageName = storageName;
        this.storageProvider = storage;
    }
    getItem(key) {
        return this.getStorage()[key];
    }
    setItem(key, value) {
        return this.updateStorage(key, value);
    }
    removeItem(key) {
        return this.clearStorage(key);
    }
    getStorage() {
        var storageString = this.storageProvider.getItem(this.storageName);
        storageString = storageString || '{}';
        try {
            return JSON.parse(storageString);
        } catch (e) {
            throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('Unable to parse storage string: ' + this.storageName);
        }
    }
    setStorage(obj) {
        try {
            var storageString = obj ? JSON.stringify(obj) : '{}';
            this.storageProvider.setItem(this.storageName, storageString);
        } catch (e) {
            throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('Unable to set storage: ' + this.storageName);
        }
    }
    clearStorage(key) {
        if (!key) {
            if (this.storageProvider.removeItem) this.storageProvider.removeItem(this.storageName);
            else this.setStorage();
            return;
        }
        var obj = this.getStorage();
        delete obj[key];
        this.setStorage(obj);
    }
    updateStorage(key, value) {
        var obj = this.getStorage();
        obj[key] = value;
        this.setStorage(obj);
    }
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 



function $c2543a02ee777151$export$42dacca56fe5cf27(options) {
    if (!(0, $58f01731783bc4a6$export$4e09c449d6c407f7)() && !options.storageProvider && !options.storageKey) (0, $26320b9c410af87d$export$c106dd0671a0fc2d)('Memory storage can only support simple single user use case on server side, please provide custom storageProvider or storageKey if advanced scenarios need to be supported.');
}
class $c2543a02ee777151$export$d35eaa92cfe799ab {
    constructor(storageManagerOptions, cookieOptions, storageUtil){
        this.storageManagerOptions = storageManagerOptions;
        this.cookieOptions = cookieOptions;
        this.storageUtil = storageUtil;
    }
    getOptionsForSection(sectionName, overrideOptions) {
        return Object.assign({}, this.storageManagerOptions[sectionName], overrideOptions);
    }
    getStorage(options) {
        options = Object.assign({}, this.cookieOptions, options);
        if (options.storageProvider) return options.storageProvider;
        let { storageType: storageType, storageTypes: storageTypes } = options;
        if (storageType === 'sessionStorage') options.sessionCookie = true;
        if (storageType && storageTypes) {
            const idx = storageTypes.indexOf(storageType);
            if (idx >= 0) {
                storageTypes = storageTypes.slice(idx);
                storageType = undefined;
            }
        }
        if (!storageType) storageType = this.storageUtil.findStorageType(storageTypes);
        return this.storageUtil.getStorageByType(storageType, options);
    }
    getTokenStorage(options) {
        options = this.getOptionsForSection('token', options);
        $c2543a02ee777151$export$42dacca56fe5cf27(options);
        const storage = this.getStorage(options);
        const storageKey = options.storageKey || (0, $a2c830cc0d95456a$export$45d1f6fc12799d40);
        return new (0, $dc0d1b738fac06db$export$97309a63b39c07f4)(storage, storageKey);
    }
    getHttpCache(options) {
        options = this.getOptionsForSection('cache', options);
        const storage = this.getStorage(options);
        const storageKey = options.storageKey || (0, $a2c830cc0d95456a$export$e9f2fad0ae10585a);
        return new (0, $dc0d1b738fac06db$export$97309a63b39c07f4)(storage, storageKey);
    }
}






function $d92fed0fcafc296f$export$b5a8c24775630d4() {
    return class OAuthStorageManager extends (0, $c2543a02ee777151$export$d35eaa92cfe799ab) {
        constructor(storageManagerOptions, cookieOptions, storageUtil){
            super(storageManagerOptions, cookieOptions, storageUtil);
        }
        getTransactionStorage(options) {
            options = this.getOptionsForSection('transaction', options);
            (0, $c2543a02ee777151$export$42dacca56fe5cf27)(options);
            const storage = this.getStorage(options);
            const storageKey = options.storageKey || (0, $a2c830cc0d95456a$export$8cc5d1fc2dba148d);
            return new (0, $dc0d1b738fac06db$export$97309a63b39c07f4)(storage, storageKey);
        }
        getSharedTansactionStorage(options) {
            options = this.getOptionsForSection('shared-transaction', options);
            (0, $c2543a02ee777151$export$42dacca56fe5cf27)(options);
            const storage = this.getStorage(options);
            const storageKey = options.storageKey || (0, $a2c830cc0d95456a$export$b9b27de9edfa5b8);
            return new (0, $dc0d1b738fac06db$export$97309a63b39c07f4)(storage, storageKey);
        }
        getOriginalUriStorage(options) {
            options = this.getOptionsForSection('original-uri', options);
            (0, $c2543a02ee777151$export$42dacca56fe5cf27)(options);
            const storage = this.getStorage(options);
            const storageKey = options.storageKey || (0, $a2c830cc0d95456a$export$ad9943119a111be1);
            return new (0, $dc0d1b738fac06db$export$97309a63b39c07f4)(storage, storageKey);
        }
    };
}


function $8564c737cd7021ae$export$369b2d2a586a4a97() {
    return (0, $d92fed0fcafc296f$export$b5a8c24775630d4)();
}


function $1e4b1fbe5e7a114d$export$247998cd7cb1a236() {
    const CoreStorageManager = (0, $8564c737cd7021ae$export$369b2d2a586a4a97)();
    return class IdxStorageManager extends CoreStorageManager {
        constructor(storageManagerOptions, cookieOptions, storageUtil){
            super(storageManagerOptions, cookieOptions, storageUtil);
        }
        getIdxResponseStorage(options) {
            let storage;
            if ((0, $58f01731783bc4a6$export$4e09c449d6c407f7)()) try {
                storage = this.storageUtil.getStorageByType('memory', options);
            } catch (e) {
                (0, $26320b9c410af87d$export$c106dd0671a0fc2d)('No response storage found, you may want to provide custom implementation for intermediate idx responses to optimize the network traffic');
            }
            else {
                const transactionStorage = this.getTransactionStorage(options);
                if (transactionStorage) storage = {
                    getItem: (key)=>{
                        const transaction = transactionStorage.getStorage();
                        if (transaction && transaction[key]) return transaction[key];
                        return null;
                    },
                    setItem: (key, val)=>{
                        const transaction = transactionStorage.getStorage();
                        if (!transaction) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('Transaction has been cleared, failed to save idxState');
                        transaction[key] = val;
                        transactionStorage.setStorage(transaction);
                    },
                    removeItem: (key)=>{
                        const transaction = transactionStorage.getStorage();
                        if (!transaction) return;
                        delete transaction[key];
                        transactionStorage.setStorage(transaction);
                    }
                };
            }
            if (!storage) return null;
            return new (0, $dc0d1b738fac06db$export$97309a63b39c07f4)(storage, (0, $a2c830cc0d95456a$export$48bfce2bad4674d4));
        }
    };
}



/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ function $52dba9c7a4541e5b$var$isObjectWithProperties(obj) {
    if (!obj || typeof obj !== 'object' || Object.values(obj).length === 0) return false;
    return true;
}
function $52dba9c7a4541e5b$export$2c31ab53ed7268d0(obj) {
    if (!$52dba9c7a4541e5b$var$isObjectWithProperties(obj)) return false;
    return !!obj.redirectUri || !!obj.responseType;
}
function $52dba9c7a4541e5b$export$9ff73b7b6b48b89b(obj) {
    if (!$52dba9c7a4541e5b$export$2c31ab53ed7268d0(obj)) return false;
    return !!obj.codeVerifier;
}
function $52dba9c7a4541e5b$export$12d8cd31b998c811(obj) {
    if (!$52dba9c7a4541e5b$export$9ff73b7b6b48b89b(obj)) return false;
    return !!obj.interactionHandle;
}
function $52dba9c7a4541e5b$export$af4ec149c0918e9e(obj) {
    if (!$52dba9c7a4541e5b$var$isObjectWithProperties(obj)) return false;
    const isAllStringValues = Object.values(obj).find((value)=>typeof value !== 'string') === undefined;
    return isAllStringValues;
}
function $52dba9c7a4541e5b$export$7534e1eab18cefa3(obj) {
    if ($52dba9c7a4541e5b$export$2c31ab53ed7268d0(obj) || $52dba9c7a4541e5b$export$af4ec149c0918e9e(obj)) return true;
    return false;
}



/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 

const $45202a38f47228ac$var$MAX_ENTRY_LIFETIME = 1800000;
function $45202a38f47228ac$export$3d13e64cc36d4572(storageManager) {
    const sharedStorage = storageManager.getSharedTansactionStorage();
    const entries = sharedStorage.getStorage();
    Object.keys(entries).forEach((state)=>{
        const entry = entries[state];
        const age = Date.now() - entry.dateCreated;
        if (age > $45202a38f47228ac$var$MAX_ENTRY_LIFETIME) delete entries[state];
    });
    sharedStorage.setStorage(entries);
}
function $45202a38f47228ac$export$3672cb2530753163(storageManager, state, meta) {
    const sharedStorage = storageManager.getSharedTansactionStorage();
    const entries = sharedStorage.getStorage();
    entries[state] = {
        dateCreated: Date.now(),
        transaction: meta
    };
    sharedStorage.setStorage(entries);
}
function $45202a38f47228ac$export$6620a91132e8e844(storageManager, state) {
    const sharedStorage = storageManager.getSharedTansactionStorage();
    const entries = sharedStorage.getStorage();
    const entry = entries[state];
    if (entry && entry.transaction && (0, $52dba9c7a4541e5b$export$7534e1eab18cefa3)(entry.transaction)) return entry.transaction;
    return null;
}
function $45202a38f47228ac$export$9ef4c193f57137d6(storageManager, state) {
    const sharedStorage = storageManager.getSharedTansactionStorage();
    const entries = sharedStorage.getStorage();
    delete entries[state];
    sharedStorage.setStorage(entries);
}


function $16b85a0e3198f52d$export$53d8870de99c17a6() {
    return class TransactionManager {
        constructor(options){
            this.storageManager = options.storageManager;
            this.enableSharedStorage = options.enableSharedStorage === false ? false : true;
            this.saveLastResponse = options.saveLastResponse === false ? false : true;
            this.options = options;
        }
        clear(options = {}) {
            const transactionStorage = this.storageManager.getTransactionStorage();
            const meta = transactionStorage.getStorage();
            transactionStorage.clearStorage();
            if (this.enableSharedStorage && options.clearSharedStorage !== false) {
                const state = options.state || (meta === null || meta === void 0 ? void 0 : meta.state);
                if (state) (0, $45202a38f47228ac$export$9ef4c193f57137d6)(this.storageManager, state);
            }
        }
        save(meta, options = {}) {
            let storage = this.storageManager.getTransactionStorage();
            const obj = storage.getStorage();
            if ((0, $52dba9c7a4541e5b$export$7534e1eab18cefa3)(obj) && !options.muteWarning) (0, $26320b9c410af87d$export$c106dd0671a0fc2d)('a saved auth transaction exists in storage. This may indicate another auth flow is already in progress.');
            storage.setStorage(meta);
            if (this.enableSharedStorage && meta.state) (0, $45202a38f47228ac$export$3672cb2530753163)(this.storageManager, meta.state, meta);
        }
        exists(options = {}) {
            try {
                const meta = this.load(options);
                return !!meta;
            } catch (_a) {
                return false;
            }
        }
        load(options = {}) {
            let meta;
            if (this.enableSharedStorage && options.state) {
                (0, $45202a38f47228ac$export$3d13e64cc36d4572)(this.storageManager);
                meta = (0, $45202a38f47228ac$export$6620a91132e8e844)(this.storageManager, options.state);
                if ((0, $52dba9c7a4541e5b$export$7534e1eab18cefa3)(meta)) return meta;
            }
            let storage = this.storageManager.getTransactionStorage();
            meta = storage.getStorage();
            if ((0, $52dba9c7a4541e5b$export$7534e1eab18cefa3)(meta)) return meta;
            return null;
        }
    };
}



function $b97e514e48abf5d5$export$b5a6d650030beee() {
    const TransactionManager = (0, $16b85a0e3198f52d$export$53d8870de99c17a6)();
    return class IdxTransactionManager extends TransactionManager {
        constructor(options){
            super(options);
        }
        clear(options = {}) {
            super.clear(options);
            if (options.clearIdxResponse !== false) this.clearIdxResponse();
        }
        saveIdxResponse(data) {
            if (!this.saveLastResponse) return;
            const storage = this.storageManager.getIdxResponseStorage();
            if (!storage) return;
            storage.setStorage(data);
        }
        loadIdxResponse(options) {
            if (!this.saveLastResponse) return null;
            const storage = this.storageManager.getIdxResponseStorage();
            if (!storage) return null;
            const storedValue = storage.getStorage();
            if (!storedValue || !(0, $2a76e8c9476cb869$export$e440ed50f1b21dd3)(storedValue.rawIdxResponse)) return null;
            if (options) {
                const { stateHandle: stateHandle, interactionHandle: interactionHandle } = options;
                if (!options.useGenericRemediator && stateHandle && storedValue.stateHandle !== stateHandle) return null;
                if (interactionHandle && storedValue.interactionHandle !== interactionHandle) return null;
            }
            return storedValue;
        }
        clearIdxResponse() {
            if (!this.saveLastResponse) return;
            const storage = this.storageManager.getIdxResponseStorage();
            storage === null || storage === void 0 || storage.clearStorage();
        }
    };
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
class $19391f33ae232c2c$export$2e2bcd8739ae039 {
    constructor(oktaAuth, options){
        const { res: res } = options;
        const { headers: headers } = res, rest = (0, $a8b9237c404681df$export$3c9a16f847548506)(res, [
            "headers"
        ]);
        if (headers) this.headers = headers;
        Object.keys(rest).forEach((key)=>{
            if (key === '_links') return;
            this[key] = rest[key];
        });
    }
}







async function $8f7d359675e21dd6$export$d5a1e65f8aa21b51(oktaAuth, options, TransactionClass = (0, $19391f33ae232c2c$export$2e2bcd8739ae039)) {
    const { accessToken: accessTokenObj } = oktaAuth.tokenManager.getTokensSync();
    const atToken = options.accessToken || accessTokenObj;
    const issuer = oktaAuth.getIssuerOrigin();
    const { url: url, method: method, payload: payload } = options;
    const requestUrl = url.startsWith(issuer) ? url : `${issuer}${url}`;
    if (!atToken) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('AccessToken is required to request MyAccount API endpoints.');
    let accessToken = atToken;
    const httpOptions = Object.assign({
        headers: {
            'Accept': '*/*;okta-version=1.0.0'
        },
        url: requestUrl,
        method: method
    }, payload && {
        args: payload
    });
    if (oktaAuth.options.dpop) {
        if (typeof accessToken === 'string') throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('AccessToken object must be provided when using dpop');
        const { Authorization: Authorization, Dpop: Dpop } = await oktaAuth.getDPoPAuthorizationHeaders({
            method: method,
            url: requestUrl,
            accessToken: accessToken
        });
        httpOptions.headers.Authorization = Authorization;
        httpOptions.headers.Dpop = Dpop;
    } else {
        accessToken = typeof accessToken === 'string' ? accessToken : accessToken.accessToken;
        httpOptions.accessToken = accessToken;
    }
    const res = await (0, $0898b9c80798427c$export$46f383001bf60e04)(oktaAuth, httpOptions);
    let ret;
    if (Array.isArray(res)) ret = res.map((item)=>new TransactionClass(oktaAuth, {
            res: item,
            accessToken: accessToken
        }));
    else ret = new TransactionClass(oktaAuth, {
        res: res,
        accessToken: accessToken
    });
    return ret;
}
function $8f7d359675e21dd6$export$cb8be9d51a72960a({ oktaAuth: oktaAuth, accessToken: accessToken, methodName: methodName, links: links }, TransactionClass = (0, $19391f33ae232c2c$export$2e2bcd8739ae039)) {
    for (const method of [
        'GET',
        'POST',
        'PUT',
        'DELETE'
    ])if (method.toLowerCase() === methodName) {
        const link = links.self;
        return async (payload)=>$8f7d359675e21dd6$export$d5a1e65f8aa21b51(oktaAuth, {
                accessToken: accessToken,
                url: link.href,
                method: method,
                payload: payload
            }, TransactionClass);
    }
    const link = links[methodName];
    if (!link) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)(`No link is found with methodName: ${methodName}`);
    return async (payload)=>$8f7d359675e21dd6$export$d5a1e65f8aa21b51(oktaAuth, {
            accessToken: accessToken,
            url: link.href,
            method: link.hints.allow[0],
            payload: payload
        }, TransactionClass);
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
class $85eef2684f922554$export$2e2bcd8739ae039 extends (0, $19391f33ae232c2c$export$2e2bcd8739ae039) {
    constructor(oktaAuth, options){
        super(oktaAuth, options);
        const { createdAt: createdAt, modifiedAt: modifiedAt, profile: profile } = options.res;
        this.createdAt = createdAt;
        this.modifiedAt = modifiedAt;
        this.profile = profile;
    }
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
class $3e75cae124ebcf41$export$2e2bcd8739ae039 extends (0, $19391f33ae232c2c$export$2e2bcd8739ae039) {
    constructor(oktaAuth, options){
        super(oktaAuth, options);
        this.properties = options.res.properties;
    }
}



/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ var $27935f7ffcbff824$export$764f5ac9df2299b9;
(function(EmailRole) {
    EmailRole["PRIMARY"] = "PRIMARY";
    EmailRole["SECONDARY"] = "SECONDARY";
})($27935f7ffcbff824$export$764f5ac9df2299b9 || ($27935f7ffcbff824$export$764f5ac9df2299b9 = {}));
var $27935f7ffcbff824$export$96e9906d6d93a972;
(function(Status) {
    Status["VERIFIED"] = "VERIFIED";
    Status["UNVERIFIED"] = "UNVERIFIED";
})($27935f7ffcbff824$export$96e9906d6d93a972 || ($27935f7ffcbff824$export$96e9906d6d93a972 = {}));
var $27935f7ffcbff824$export$51a8e1495775a8d0;
(function(PasswordStatus) {
    PasswordStatus["NOT_ENROLLED"] = "NOT_ENROLLED";
    PasswordStatus["ACTIVE"] = "ACTIVE";
})($27935f7ffcbff824$export$51a8e1495775a8d0 || ($27935f7ffcbff824$export$51a8e1495775a8d0 = {}));


const $bc859110e17a7cc5$export$85d699ca8330b9a9 = async (oktaAuth, options)=>{
    const transaction = await (0, $8f7d359675e21dd6$export$d5a1e65f8aa21b51)(oktaAuth, {
        url: '/idp/myaccount/profile',
        method: 'GET',
        accessToken: options === null || options === void 0 ? void 0 : options.accessToken
    }, (0, $85eef2684f922554$export$2e2bcd8739ae039));
    return transaction;
};
const $bc859110e17a7cc5$export$5880729c5d131040 = async (oktaAuth, options)=>{
    const { payload: payload, accessToken: accessToken } = options;
    const transaction = await (0, $8f7d359675e21dd6$export$d5a1e65f8aa21b51)(oktaAuth, {
        url: '/idp/myaccount/profile',
        method: 'PUT',
        payload: payload,
        accessToken: accessToken
    }, (0, $85eef2684f922554$export$2e2bcd8739ae039));
    return transaction;
};
const $bc859110e17a7cc5$export$f2a1e5d37613e054 = async (oktaAuth, options)=>{
    const transaction = await (0, $8f7d359675e21dd6$export$d5a1e65f8aa21b51)(oktaAuth, {
        url: '/idp/myaccount/profile/schema',
        method: 'GET',
        accessToken: options === null || options === void 0 ? void 0 : options.accessToken
    }, (0, $3e75cae124ebcf41$export$2e2bcd8739ae039));
    return transaction;
};


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 

/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
class $7a4f34312bb43b31$export$2e2bcd8739ae039 extends (0, $19391f33ae232c2c$export$2e2bcd8739ae039) {
    constructor(oktaAuth, options){
        super(oktaAuth, options);
        const { res: res } = options;
        const { id: id, profile: profile, expiresAt: expiresAt, status: status } = res;
        this.id = id;
        this.expiresAt = expiresAt;
        this.profile = profile;
        this.status = status;
    }
}




class $7a11b6f93978800e$export$2e2bcd8739ae039 extends (0, $19391f33ae232c2c$export$2e2bcd8739ae039) {
    constructor(oktaAuth, options){
        super(oktaAuth, options);
        const { accessToken: accessToken, res: res } = options;
        const { id: id, expiresAt: expiresAt, profile: profile, status: status, _links: _links } = res;
        this.id = id;
        this.expiresAt = expiresAt;
        this.profile = profile;
        this.status = status;
        this.poll = async ()=>{
            const fn = (0, $8f7d359675e21dd6$export$cb8be9d51a72960a)({
                oktaAuth: oktaAuth,
                accessToken: accessToken,
                methodName: 'poll',
                links: _links
            }, (0, $7a4f34312bb43b31$export$2e2bcd8739ae039));
            return await fn();
        };
        this.verify = async (payload)=>{
            const fn = (0, $8f7d359675e21dd6$export$cb8be9d51a72960a)({
                oktaAuth: oktaAuth,
                accessToken: accessToken,
                methodName: 'verify',
                links: _links
            }, $7a11b6f93978800e$export$2e2bcd8739ae039);
            return await fn(payload);
        };
    }
}





class $2eb1842106a735e0$export$2e2bcd8739ae039 extends (0, $19391f33ae232c2c$export$2e2bcd8739ae039) {
    constructor(oktaAuth, options){
        super(oktaAuth, options);
        const { accessToken: accessToken, res: res } = options;
        const { id: id, profile: profile, roles: roles, status: status, _links: _links } = res;
        this.id = id;
        this.profile = profile;
        this.roles = roles;
        this.status = status;
        this.get = async ()=>{
            const fn = (0, $8f7d359675e21dd6$export$cb8be9d51a72960a)({
                oktaAuth: oktaAuth,
                accessToken: accessToken,
                methodName: 'get',
                links: _links
            }, $2eb1842106a735e0$export$2e2bcd8739ae039);
            return await fn();
        };
        this.delete = async ()=>{
            const fn = (0, $8f7d359675e21dd6$export$cb8be9d51a72960a)({
                oktaAuth: oktaAuth,
                accessToken: accessToken,
                methodName: 'delete',
                links: _links
            });
            return await fn();
        };
        this.challenge = async ()=>{
            const fn = (0, $8f7d359675e21dd6$export$cb8be9d51a72960a)({
                oktaAuth: oktaAuth,
                accessToken: accessToken,
                methodName: 'challenge',
                links: _links
            }, (0, $7a11b6f93978800e$export$2e2bcd8739ae039));
            return await fn();
        };
        if (_links.poll) this.poll = async ()=>{
            const fn = (0, $8f7d359675e21dd6$export$cb8be9d51a72960a)({
                oktaAuth: oktaAuth,
                accessToken: accessToken,
                methodName: 'poll',
                links: _links
            }, (0, $7a4f34312bb43b31$export$2e2bcd8739ae039));
            return await fn();
        };
        if (_links.verify) this.verify = async (payload)=>{
            const fn = (0, $8f7d359675e21dd6$export$cb8be9d51a72960a)({
                oktaAuth: oktaAuth,
                accessToken: accessToken,
                methodName: 'verify',
                links: _links
            });
            return await fn(payload);
        };
    }
}




const $6569b1dad417d202$export$415923841378f20f = async (oktaAuth, options)=>{
    const transaction = await (0, $8f7d359675e21dd6$export$d5a1e65f8aa21b51)(oktaAuth, {
        url: '/idp/myaccount/emails',
        method: 'GET',
        accessToken: options === null || options === void 0 ? void 0 : options.accessToken
    }, (0, $2eb1842106a735e0$export$2e2bcd8739ae039));
    return transaction;
};
const $6569b1dad417d202$export$d29968a6889079e0 = async (oktaAuth, options)=>{
    const { id: id, accessToken: accessToken } = options;
    const transaction = await (0, $8f7d359675e21dd6$export$d5a1e65f8aa21b51)(oktaAuth, {
        url: `/idp/myaccount/emails/${id}`,
        method: 'GET',
        accessToken: accessToken
    }, (0, $2eb1842106a735e0$export$2e2bcd8739ae039));
    return transaction;
};
const $6569b1dad417d202$export$56c422d8d4a8ba98 = async (oktaAuth, options)=>{
    const { accessToken: accessToken, payload: payload } = options;
    const transaction = await (0, $8f7d359675e21dd6$export$d5a1e65f8aa21b51)(oktaAuth, {
        url: '/idp/myaccount/emails',
        method: 'POST',
        payload: payload,
        accessToken: accessToken
    }, (0, $2eb1842106a735e0$export$2e2bcd8739ae039));
    return transaction;
};
const $6569b1dad417d202$export$cd50a17c6197d29c = async (oktaAuth, options)=>{
    const { id: id, accessToken: accessToken } = options;
    const transaction = await (0, $8f7d359675e21dd6$export$d5a1e65f8aa21b51)(oktaAuth, {
        url: `/idp/myaccount/emails/${id}`,
        method: 'DELETE',
        accessToken: accessToken
    });
    return transaction;
};
const $6569b1dad417d202$export$33c6aa473fcadf96 = async (oktaAuth, options)=>{
    const { id: id, accessToken: accessToken } = options;
    const transaction = await (0, $8f7d359675e21dd6$export$d5a1e65f8aa21b51)(oktaAuth, {
        url: `/idp/myaccount/emails/${id}/challenge`,
        method: 'POST',
        accessToken: accessToken
    }, (0, $7a11b6f93978800e$export$2e2bcd8739ae039));
    return transaction;
};
const $6569b1dad417d202$export$422cd4806bab99c7 = async (oktaAuth, options)=>{
    const { emailId: emailId, challengeId: challengeId, accessToken: accessToken } = options;
    const transaction = await (0, $8f7d359675e21dd6$export$d5a1e65f8aa21b51)(oktaAuth, {
        url: `/idp/myaccount/emails/${emailId}/challenge/${challengeId}`,
        method: 'POST',
        accessToken: accessToken
    }, (0, $7a11b6f93978800e$export$2e2bcd8739ae039));
    return transaction;
};
const $6569b1dad417d202$export$deff038ef606a5c = async (oktaAuth, options)=>{
    const { emailId: emailId, challengeId: challengeId, payload: payload, accessToken: accessToken } = options;
    const transaction = await (0, $8f7d359675e21dd6$export$d5a1e65f8aa21b51)(oktaAuth, {
        url: `/idp/myaccount/emails/${emailId}/challenge/${challengeId}/verify`,
        method: 'POST',
        payload: payload,
        accessToken: accessToken
    });
    return transaction;
};


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 

/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 

class $e13c54983365b669$export$2e2bcd8739ae039 extends (0, $19391f33ae232c2c$export$2e2bcd8739ae039) {
    constructor(oktaAuth, options){
        super(oktaAuth, options);
        const { res: res, accessToken: accessToken } = options;
        const { id: id, profile: profile, status: status, _links: _links } = res;
        this.id = id;
        this.profile = profile;
        this.status = status;
        this.get = async ()=>{
            const fn = (0, $8f7d359675e21dd6$export$cb8be9d51a72960a)({
                oktaAuth: oktaAuth,
                accessToken: accessToken,
                methodName: 'get',
                links: _links
            }, $e13c54983365b669$export$2e2bcd8739ae039);
            return await fn();
        };
        this.delete = async ()=>{
            const fn = (0, $8f7d359675e21dd6$export$cb8be9d51a72960a)({
                oktaAuth: oktaAuth,
                accessToken: accessToken,
                methodName: 'delete',
                links: _links
            });
            return await fn();
        };
        this.challenge = async (payload)=>{
            const fn = (0, $8f7d359675e21dd6$export$cb8be9d51a72960a)({
                oktaAuth: oktaAuth,
                accessToken: accessToken,
                methodName: 'challenge',
                links: _links
            });
            return await fn(payload);
        };
        if (_links.verify) this.verify = async (payload)=>{
            const fn = (0, $8f7d359675e21dd6$export$cb8be9d51a72960a)({
                oktaAuth: oktaAuth,
                accessToken: accessToken,
                methodName: 'verify',
                links: _links
            });
            return await fn(payload);
        };
    }
}



const $cd041f7f92d06fdf$export$900cea1a440d5573 = async (oktaAuth, options)=>{
    const transaction = await (0, $8f7d359675e21dd6$export$d5a1e65f8aa21b51)(oktaAuth, {
        url: '/idp/myaccount/phones',
        method: 'GET',
        accessToken: options === null || options === void 0 ? void 0 : options.accessToken
    }, (0, $e13c54983365b669$export$2e2bcd8739ae039));
    return transaction;
};
const $cd041f7f92d06fdf$export$6bc97fd71a5fa8b7 = async (oktaAuth, options)=>{
    const { accessToken: accessToken, id: id } = options;
    const transaction = await (0, $8f7d359675e21dd6$export$d5a1e65f8aa21b51)(oktaAuth, {
        url: `/idp/myaccount/phones/${id}`,
        method: 'GET',
        accessToken: accessToken
    }, (0, $e13c54983365b669$export$2e2bcd8739ae039));
    return transaction;
};
const $cd041f7f92d06fdf$export$99d5f6f1957f912c = async (oktaAuth, options)=>{
    const { accessToken: accessToken, payload: payload } = options;
    const transaction = await (0, $8f7d359675e21dd6$export$d5a1e65f8aa21b51)(oktaAuth, {
        url: '/idp/myaccount/phones',
        method: 'POST',
        payload: payload,
        accessToken: accessToken
    }, (0, $e13c54983365b669$export$2e2bcd8739ae039));
    return transaction;
};
const $cd041f7f92d06fdf$export$fcffda62400b801e = async (oktaAuth, options)=>{
    const { id: id, accessToken: accessToken } = options;
    const transaction = await (0, $8f7d359675e21dd6$export$d5a1e65f8aa21b51)(oktaAuth, {
        url: `/idp/myaccount/phones/${id}`,
        method: 'DELETE',
        accessToken: accessToken
    });
    return transaction;
};
const $cd041f7f92d06fdf$export$e362ccb730b1664b = async (oktaAuth, options)=>{
    const { accessToken: accessToken, id: id, payload: payload } = options;
    const transaction = await (0, $8f7d359675e21dd6$export$d5a1e65f8aa21b51)(oktaAuth, {
        url: `/idp/myaccount/phones/${id}/challenge`,
        method: 'POST',
        payload: payload,
        accessToken: accessToken
    });
    return transaction;
};
const $cd041f7f92d06fdf$export$90d29807f6dbc0be = async (oktaAuth, options)=>{
    const { id: id, payload: payload, accessToken: accessToken } = options;
    const transaction = await (0, $8f7d359675e21dd6$export$d5a1e65f8aa21b51)(oktaAuth, {
        url: `/idp/myaccount/phones/${id}/verify`,
        method: 'POST',
        payload: payload,
        accessToken: accessToken
    });
    return transaction;
};


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 

/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 


class $856893fff545141a$export$2e2bcd8739ae039 extends (0, $19391f33ae232c2c$export$2e2bcd8739ae039) {
    constructor(oktaAuth, options){
        super(oktaAuth, options);
        const { res: res, accessToken: accessToken } = options;
        const { id: id, status: status, created: created, lastUpdated: lastUpdated, _links: _links } = res;
        this.id = id;
        this.status = status;
        this.created = created;
        this.lastUpdated = lastUpdated;
        if (this.status == (0, $27935f7ffcbff824$export$51a8e1495775a8d0).NOT_ENROLLED) this.enroll = async (payload)=>{
            const fn = (0, $8f7d359675e21dd6$export$cb8be9d51a72960a)({
                oktaAuth: oktaAuth,
                accessToken: accessToken,
                methodName: 'enroll',
                links: _links
            }, $856893fff545141a$export$2e2bcd8739ae039);
            return await fn(payload);
        };
        else {
            this.get = async ()=>{
                const fn = (0, $8f7d359675e21dd6$export$cb8be9d51a72960a)({
                    oktaAuth: oktaAuth,
                    accessToken: accessToken,
                    methodName: 'get',
                    links: _links
                }, $856893fff545141a$export$2e2bcd8739ae039);
                return await fn();
            };
            this.update = async (payload)=>{
                const fn = (0, $8f7d359675e21dd6$export$cb8be9d51a72960a)({
                    oktaAuth: oktaAuth,
                    accessToken: accessToken,
                    methodName: 'put',
                    links: _links
                }, $856893fff545141a$export$2e2bcd8739ae039);
                return await fn(payload);
            };
            this.delete = async ()=>{
                const fn = (0, $8f7d359675e21dd6$export$cb8be9d51a72960a)({
                    oktaAuth: oktaAuth,
                    accessToken: accessToken,
                    methodName: 'delete',
                    links: _links
                });
                return await fn();
            };
        }
    }
}


const $ed0a09493587ed59$export$350bd33120f7413e = async (oktaAuth, options)=>{
    const transaction = await (0, $8f7d359675e21dd6$export$d5a1e65f8aa21b51)(oktaAuth, {
        url: `/idp/myaccount/password`,
        method: 'GET',
        accessToken: options === null || options === void 0 ? void 0 : options.accessToken
    }, (0, $856893fff545141a$export$2e2bcd8739ae039));
    return transaction;
};
const $ed0a09493587ed59$export$73d5ec567681e4c5 = async (oktaAuth, options)=>{
    const { accessToken: accessToken, payload: payload } = options;
    const transaction = await (0, $8f7d359675e21dd6$export$d5a1e65f8aa21b51)(oktaAuth, {
        url: '/idp/myaccount/password',
        method: 'POST',
        payload: payload,
        accessToken: accessToken
    }, (0, $856893fff545141a$export$2e2bcd8739ae039));
    return transaction;
};
const $ed0a09493587ed59$export$e2853351e15b7895 = async (oktaAuth, options)=>{
    const { accessToken: accessToken, payload: payload } = options;
    const transaction = await (0, $8f7d359675e21dd6$export$d5a1e65f8aa21b51)(oktaAuth, {
        url: '/idp/myaccount/password',
        method: 'PUT',
        payload: payload,
        accessToken: accessToken
    }, (0, $856893fff545141a$export$2e2bcd8739ae039));
    return transaction;
};
const $ed0a09493587ed59$export$c9265b7aad3ac069 = async (oktaAuth, options)=>{
    const transaction = await (0, $8f7d359675e21dd6$export$d5a1e65f8aa21b51)(oktaAuth, {
        url: `/idp/myaccount/password`,
        method: 'DELETE',
        accessToken: options === null || options === void 0 ? void 0 : options.accessToken
    });
    return transaction;
};


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ var $6277c5fb43ebee66$exports = {};

$parcel$export($6277c5fb43ebee66$exports, "getProfile", function () { return $bc859110e17a7cc5$export$85d699ca8330b9a9; });
$parcel$export($6277c5fb43ebee66$exports, "getProfileSchema", function () { return $bc859110e17a7cc5$export$f2a1e5d37613e054; });
$parcel$export($6277c5fb43ebee66$exports, "updateProfile", function () { return $bc859110e17a7cc5$export$5880729c5d131040; });
$parcel$export($6277c5fb43ebee66$exports, "addEmail", function () { return $6569b1dad417d202$export$56c422d8d4a8ba98; });
$parcel$export($6277c5fb43ebee66$exports, "deleteEmail", function () { return $6569b1dad417d202$export$cd50a17c6197d29c; });
$parcel$export($6277c5fb43ebee66$exports, "getEmail", function () { return $6569b1dad417d202$export$d29968a6889079e0; });
$parcel$export($6277c5fb43ebee66$exports, "getEmailChallenge", function () { return $6569b1dad417d202$export$422cd4806bab99c7; });
$parcel$export($6277c5fb43ebee66$exports, "getEmails", function () { return $6569b1dad417d202$export$415923841378f20f; });
$parcel$export($6277c5fb43ebee66$exports, "sendEmailChallenge", function () { return $6569b1dad417d202$export$33c6aa473fcadf96; });
$parcel$export($6277c5fb43ebee66$exports, "verifyEmailChallenge", function () { return $6569b1dad417d202$export$deff038ef606a5c; });
$parcel$export($6277c5fb43ebee66$exports, "addPhone", function () { return $cd041f7f92d06fdf$export$99d5f6f1957f912c; });
$parcel$export($6277c5fb43ebee66$exports, "deletePhone", function () { return $cd041f7f92d06fdf$export$fcffda62400b801e; });
$parcel$export($6277c5fb43ebee66$exports, "getPhone", function () { return $cd041f7f92d06fdf$export$6bc97fd71a5fa8b7; });
$parcel$export($6277c5fb43ebee66$exports, "getPhones", function () { return $cd041f7f92d06fdf$export$900cea1a440d5573; });
$parcel$export($6277c5fb43ebee66$exports, "sendPhoneChallenge", function () { return $cd041f7f92d06fdf$export$e362ccb730b1664b; });
$parcel$export($6277c5fb43ebee66$exports, "verifyPhoneChallenge", function () { return $cd041f7f92d06fdf$export$90d29807f6dbc0be; });
$parcel$export($6277c5fb43ebee66$exports, "deletePassword", function () { return $ed0a09493587ed59$export$c9265b7aad3ac069; });
$parcel$export($6277c5fb43ebee66$exports, "enrollPassword", function () { return $ed0a09493587ed59$export$73d5ec567681e4c5; });
$parcel$export($6277c5fb43ebee66$exports, "getPassword", function () { return $ed0a09493587ed59$export$350bd33120f7413e; });
$parcel$export($6277c5fb43ebee66$exports, "updatePassword", function () { return $ed0a09493587ed59$export$e2853351e15b7895; });
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 





function $ac560357e6812fcb$export$59a1e98a4e72b9c4(Base) {
    return class OktaAuthMyAccount extends Base {
        constructor(...args){
            super(...args);
            this.myaccount = Object.entries($6277c5fb43ebee66$exports).filter(([name])=>name !== 'default').reduce((acc, [name, fn])=>{
                acc[name] = fn.bind(null, this);
                return acc;
            }, {});
        }
    };
}


function $60f7d061ca80961d$export$6053a1f78419757b(StorageManagerConstructor, OptionsConstructor, TransactionManager) {
    const Core = (0, $89f6f29862b2ea5c$export$30ddaac95d0f4b52)(StorageManagerConstructor, OptionsConstructor, TransactionManager);
    const WithMyAccount = (0, $ac560357e6812fcb$export$59a1e98a4e72b9c4)(Core);
    return WithMyAccount;
}




/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 




/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ function $87f013ee15834973$export$9299815b5f3154f3(res, options) {
    var builtArgs = {};
    Object.assign(builtArgs, options);
    if (!builtArgs.stateToken && res.stateToken) builtArgs.stateToken = res.stateToken;
    return builtArgs;
}
function $87f013ee15834973$export$2d4cfae4c1b81550(res) {
    return $87f013ee15834973$export$9299815b5f3154f3(res);
}


function $99e67d5aaa685d6b$export$51ada3ca5c05a344(sdk, args) {
    args = (0, $87f013ee15834973$export$9299815b5f3154f3)(sdk, args);
    return (0, $0898b9c80798427c$export$299ba2dee77727e9)(sdk, sdk.getIssuerOrigin() + '/api/v1/authn', args, {
        withCredentials: true
    });
}
function $99e67d5aaa685d6b$export$c77d5d5646490fda(sdk, tx, args) {
    if (!args || !args.stateToken) {
        var stateToken = $99e67d5aaa685d6b$export$70099e8baba5f61a(sdk);
        if (stateToken) args = {
            stateToken: stateToken
        };
        else return Promise.reject(new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('No transaction to resume'));
    }
    return $99e67d5aaa685d6b$export$51ada3ca5c05a344(sdk, args).then(function(res) {
        return tx.createTransaction(res);
    });
}
function $99e67d5aaa685d6b$export$d7a8811716990051(sdk, tx, args) {
    if (!args || !args.stateToken) {
        var stateToken = $99e67d5aaa685d6b$export$70099e8baba5f61a(sdk);
        if (stateToken) args = {
            stateToken: stateToken
        };
        else return Promise.reject(new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('No transaction to evaluate'));
    }
    return $99e67d5aaa685d6b$export$f87af8010ee2d4f0(sdk, args).then(function(res) {
        return tx.createTransaction(res);
    });
}
function $99e67d5aaa685d6b$export$f87af8010ee2d4f0(sdk, args) {
    args = (0, $87f013ee15834973$export$9299815b5f3154f3)(sdk, args);
    return (0, $0898b9c80798427c$export$299ba2dee77727e9)(sdk, sdk.getIssuerOrigin() + '/api/v1/authn/introspect', args, {
        withCredentials: true
    });
}
function $99e67d5aaa685d6b$export$ec24f82f0c14002b(sdk) {
    return !!$99e67d5aaa685d6b$export$70099e8baba5f61a(sdk);
}
function $99e67d5aaa685d6b$export$ff6c438e8dbccc40(sdk, tx, url, args, options) {
    options = Object.assign({
        withCredentials: true
    }, options);
    return (0, $0898b9c80798427c$export$299ba2dee77727e9)(sdk, url, args, options).then(function(res) {
        return tx.createTransaction(res);
    });
}
function $99e67d5aaa685d6b$export$70099e8baba5f61a(sdk) {
    const storage = sdk.options.storageUtil.storage;
    return storage.get((0, $a2c830cc0d95456a$export$511e8ed0baecd62c));
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 

/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 







function $cf76f7acfccfaa82$export$e4684f3957f59145(sdk, tx, res, obj, link, ref) {
    if (Array.isArray(link)) return function(name, opts) {
        if (!name) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('Must provide a link name');
        var lk = (0, $27ec06d649eea38f$export$71aa6c912b956294)(link, {
            name: name
        });
        if (!lk) throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('No link found for that name');
        return $cf76f7acfccfaa82$export$e4684f3957f59145(sdk, tx, res, obj, lk, ref)(opts);
    };
    else if (link.hints && link.hints.allow && link.hints.allow.length === 1) {
        var method = link.hints.allow[0];
        switch(method){
            case 'GET':
                return function() {
                    return (0, $0898b9c80798427c$export$3988ae62b71be9a3)(sdk, link.href, {
                        withCredentials: true
                    });
                };
            case 'POST':
                return function(opts) {
                    if (ref && ref.isPolling) ref.isPolling = false;
                    var data = (0, $87f013ee15834973$export$9299815b5f3154f3)(res, opts);
                    if (res.status === 'MFA_ENROLL' || res.status === 'FACTOR_ENROLL') Object.assign(data, {
                        factorType: obj.factorType,
                        provider: obj.provider
                    });
                    var params = {};
                    var autoPush = data.autoPush;
                    if (autoPush !== undefined) {
                        if (typeof autoPush === 'function') try {
                            params.autoPush = !!autoPush();
                        } catch (e) {
                            return Promise.reject(new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('AutoPush resulted in an error.'));
                        }
                        else if (autoPush !== null) params.autoPush = !!autoPush;
                        data = (0, $27ec06d649eea38f$export$30a06c8d3562193f)(data, 'autoPush');
                    }
                    var rememberDevice = data.rememberDevice;
                    if (rememberDevice !== undefined) {
                        if (typeof rememberDevice === 'function') try {
                            params.rememberDevice = !!rememberDevice();
                        } catch (e) {
                            return Promise.reject(new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('RememberDevice resulted in an error.'));
                        }
                        else if (rememberDevice !== null) params.rememberDevice = !!rememberDevice;
                        data = (0, $27ec06d649eea38f$export$30a06c8d3562193f)(data, 'rememberDevice');
                    } else if (data.profile && data.profile.updatePhone !== undefined) {
                        if (data.profile.updatePhone) params.updatePhone = true;
                        data.profile = (0, $27ec06d649eea38f$export$30a06c8d3562193f)(data.profile, 'updatePhone');
                    }
                    var href = link.href + (0, $47114d36cb1410d5$export$249cc09c933c4d7a)(params);
                    return (0, $99e67d5aaa685d6b$export$ff6c438e8dbccc40)(sdk, tx, href, data);
                };
        }
    }
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 








/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
class $bcbe77a24b3d1945$export$2e2bcd8739ae039 extends (0, $9e9b1d88c1d52d57$export$2e2bcd8739ae039) {
    constructor(){
        const message = 'The poll was stopped by the sdk';
        super(message);
    }
}



function $e5e684a8aea159b1$export$dbf3bc1a5591d22f(sdk, res, ref) {
    return function(options) {
        var delay$1;
        var rememberDevice;
        var autoPush;
        var transactionCallBack;
        if ((0, $53a4517fb157de9f$export$7e4aa119212bc614)(options)) delay$1 = options;
        else if ((0, $53a4517fb157de9f$export$a6cdc56e425d0d0a)(options)) {
            options;
            delay$1 = options.delay;
            rememberDevice = options.rememberDevice;
            autoPush = options.autoPush;
            transactionCallBack = options.transactionCallBack;
        }
        if (!delay$1 && delay$1 !== 0) delay$1 = (0, $a2c830cc0d95456a$export$626063bdcc4f0775);
        var pollLink = (0, $27ec06d649eea38f$export$67e8a86e59c99895)(res, 'next', 'poll');
        function pollFn() {
            var opts = {};
            if (typeof autoPush === 'function') try {
                opts.autoPush = !!autoPush();
            } catch (e) {
                return Promise.reject(new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('AutoPush resulted in an error.'));
            }
            else if (autoPush !== undefined && autoPush !== null) opts.autoPush = !!autoPush;
            if (typeof rememberDevice === 'function') try {
                opts.rememberDevice = !!rememberDevice();
            } catch (e) {
                return Promise.reject(new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('RememberDevice resulted in an error.'));
            }
            else if (rememberDevice !== undefined && rememberDevice !== null) opts.rememberDevice = !!rememberDevice;
            var href = pollLink.href + (0, $47114d36cb1410d5$export$249cc09c933c4d7a)(opts);
            return (0, $0898b9c80798427c$export$299ba2dee77727e9)(sdk, href, (0, $87f013ee15834973$export$2d4cfae4c1b81550)(res), {
                saveAuthnState: false,
                withCredentials: true,
                pollingIntent: true
            });
        }
        ref.isPolling = true;
        var retryCount = 0;
        var recursivePoll = function() {
            if (!ref.isPolling) return Promise.reject(new (0, $bcbe77a24b3d1945$export$2e2bcd8739ae039)());
            return pollFn().then(function(pollRes) {
                retryCount = 0;
                if (pollRes.factorResult && pollRes.factorResult === 'WAITING') {
                    if (!ref.isPolling) throw new (0, $bcbe77a24b3d1945$export$2e2bcd8739ae039)();
                    if (typeof transactionCallBack === 'function') transactionCallBack(pollRes);
                    return (0, $c8a11dd749b49091$export$1391212d75b2ee65)(delay$1).then(recursivePoll);
                } else {
                    ref.isPolling = false;
                    return sdk.tx.createTransaction(pollRes);
                }
            }).catch(function(err) {
                if (err.xhr && (err.xhr.status === 0 || err.xhr.status === 429) && retryCount <= 4) {
                    var delayLength = Math.pow(2, retryCount) * 1000;
                    retryCount++;
                    return (0, $c8a11dd749b49091$export$1391212d75b2ee65)(delayLength).then(recursivePoll);
                }
                throw err;
            });
        };
        return recursivePoll().catch(function(err) {
            ref.isPolling = false;
            throw err;
        });
    };
}


function $951f88a9bfad28f9$export$cfbf992c433a7257(sdk, tx, res, obj, ref) {
    var fns = {};
    for(var linkName in obj._links){
        if (!Object.prototype.hasOwnProperty.call(obj._links, linkName)) continue;
        var link = obj._links[linkName];
        if (linkName === 'next') linkName = link.name;
        if (link.type) {
            fns[linkName] = link;
            continue;
        }
        switch(linkName){
            case 'poll':
                fns.poll = (0, $e5e684a8aea159b1$export$dbf3bc1a5591d22f)(sdk, res, ref);
                break;
            default:
                var fn = (0, $cf76f7acfccfaa82$export$e4684f3957f59145)(sdk, tx, res, obj, link, ref);
                if (fn) fns[linkName] = fn;
        }
    }
    return fns;
}


function $a6b59b3a57d1300c$export$2a8afff7473d9fcc(sdk, tx, res, obj, ref) {
    obj = obj || res;
    obj = (0, $27ec06d649eea38f$export$9cd59f9826255e47)(obj);
    if (Array.isArray(obj)) {
        var objArr = [];
        for(var o = 0, ol = obj.length; o < ol; o++)objArr.push($a6b59b3a57d1300c$export$2a8afff7473d9fcc(sdk, tx, res, obj[o], ref));
        return objArr;
    }
    var embedded = obj._embedded || {};
    for(var key in embedded){
        if (!Object.prototype.hasOwnProperty.call(embedded, key)) continue;
        if ((0, $53a4517fb157de9f$export$a6cdc56e425d0d0a)(embedded[key]) || Array.isArray(embedded[key])) embedded[key] = $a6b59b3a57d1300c$export$2a8afff7473d9fcc(sdk, tx, res, embedded[key], ref);
    }
    var fns = (0, $951f88a9bfad28f9$export$cfbf992c433a7257)(sdk, tx, res, obj, ref);
    Object.assign(embedded, fns);
    obj = (0, $27ec06d649eea38f$export$30a06c8d3562193f)(obj, '_embedded', '_links');
    Object.assign(obj, embedded);
    return obj;
}


class $78b9265053fe7e16$export$f580db0c9d44ff91 {
    constructor(sdk, tx, res = null){
        this.data = undefined;
        this.status = undefined;
        if (res) {
            this.data = res;
            Object.assign(this, (0, $a6b59b3a57d1300c$export$2a8afff7473d9fcc)(sdk, tx, res, res, {}));
            delete this.stateToken;
            if (res.status === 'RECOVERY_CHALLENGE' && !res._links) this.cancel = function() {
                return Promise.resolve(tx.createTransaction());
            };
        }
    }
}


function $c4c71f273f2103aa$export$1d08820c24a6783a(sdk) {
    const tx = {
        status: (0, $99e67d5aaa685d6b$export$51ada3ca5c05a344).bind(null, sdk),
        resume (args) {
            return (0, $99e67d5aaa685d6b$export$c77d5d5646490fda)(sdk, tx, args);
        },
        exists: (0, $99e67d5aaa685d6b$export$ec24f82f0c14002b).bind(null, sdk),
        introspect (args) {
            return (0, $99e67d5aaa685d6b$export$d7a8811716990051)(sdk, tx, args);
        },
        createTransaction: (res)=>{
            return new (0, $78b9265053fe7e16$export$f580db0c9d44ff91)(sdk, tx, res);
        },
        postToTransaction: (url, args, options)=>{
            return (0, $99e67d5aaa685d6b$export$ff6c438e8dbccc40)(sdk, tx, url, args, options);
        }
    };
    return tx;
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 



function $a09f04e48b966f01$export$8bd4610dde10caeb(Base) {
    return class OktaAuthTx extends Base {
        constructor(...args){
            super(...args);
            this.authn = this.tx = (0, $c4c71f273f2103aa$export$1d08820c24a6783a)(this);
            this.fingerprint = (0, $9648776745ae4879$export$2e2bcd8739ae039).bind(null, this);
        }
        async signIn(opts) {
            opts = (0, $27ec06d649eea38f$export$9cd59f9826255e47)(opts || {});
            const _postToTransaction = (options)=>{
                delete opts.sendFingerprint;
                return this.tx.postToTransaction('/api/v1/authn', opts, options);
            };
            if (!opts.sendFingerprint) return _postToTransaction();
            return this.fingerprint().then(function(fingerprint) {
                return _postToTransaction({
                    headers: {
                        'X-Device-Fingerprint': fingerprint
                    }
                });
            });
        }
        async signInWithCredentials(opts) {
            return this.signIn(opts);
        }
        forgotPassword(opts) {
            return this.tx.postToTransaction('/api/v1/authn/recovery/password', opts);
        }
        unlockAccount(opts) {
            return this.tx.postToTransaction('/api/v1/authn/recovery/unlock', opts);
        }
        verifyRecoveryToken(opts) {
            const { multiOptionalFactorEnroll: multiOptionalFactorEnroll } = opts, args = (0, $a8b9237c404681df$export$3c9a16f847548506)(opts, [
                "multiOptionalFactorEnroll"
            ]);
            if (multiOptionalFactorEnroll) args.options = {
                multiOptionalFactorEnroll: multiOptionalFactorEnroll
            };
            return this.tx.postToTransaction('/api/v1/authn/recovery/token', args);
        }
    };
}



















/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 




function $ad224f15b6ffcc7f$export$ab6ec7127a621091(StorageManagerConstructor, OptionsConstructor, TransactionManagerConstructor) {
    const Base = (0, $2f2331dacfdaa6d6$export$2bc41dfbf048bfdc)(OptionsConstructor);
    const WithStorage = (0, $7b18006d527823f4$export$32ec6248008f35d1)(Base, StorageManagerConstructor);
    const WithHttp = (0, $42dc341ca5ee8859$export$b21483dcd2900eca)(WithStorage);
    const WithSession = (0, $3608d4223921823b$export$e29a1eee069c5053)(WithHttp);
    const WithOAuth = (0, $81aceab9ba49f668$export$d2d79cf72153e095)(WithSession, TransactionManagerConstructor);
    return WithOAuth;
}





























































const $3988db30acbcf384$var$OptionsConstructor = (0, $38ea4bcc7e79f8fb$export$2fa277826aad984c)();
const $3988db30acbcf384$var$StorageManager = (0, $1e4b1fbe5e7a114d$export$247998cd7cb1a236)();
const $3988db30acbcf384$var$TransactionManager = (0, $b97e514e48abf5d5$export$b5a6d650030beee)();
const $3988db30acbcf384$var$WithIdx = (0, $fac99824551c1bb5$export$2f30fde9bc853c45)($3988db30acbcf384$var$StorageManager, $3988db30acbcf384$var$OptionsConstructor, $3988db30acbcf384$var$TransactionManager);
const $3988db30acbcf384$var$WithMyAccount = (0, $ac560357e6812fcb$export$59a1e98a4e72b9c4)($3988db30acbcf384$var$WithIdx);
const $3988db30acbcf384$var$WithAuthn = (0, $a09f04e48b966f01$export$8bd4610dde10caeb)($3988db30acbcf384$var$WithMyAccount);
class $3988db30acbcf384$export$c998d4cdbfb7af8 extends $3988db30acbcf384$var$WithAuthn {
    constructor(options){
        super(options);
    }
}


function $36c46bc4813033e5$export$2e2bcd8739ae039(v1, v2) {
    // validate input and split into segments
    const n1 = $36c46bc4813033e5$var$validateAndParse(v1);
    const n2 = $36c46bc4813033e5$var$validateAndParse(v2);
    // pop off the patch
    const p1 = n1.pop();
    const p2 = n2.pop();
    // validate numbers
    const r = $36c46bc4813033e5$var$compareSegments(n1, n2);
    if (r !== 0) return r;
    // validate pre-release
    if (p1 && p2) return $36c46bc4813033e5$var$compareSegments(p1.split('.'), p2.split('.'));
    else if (p1 || p2) return p1 ? -1 : 1;
    return 0;
}
const $36c46bc4813033e5$export$a22775fa5e2eebd9 = (v)=>typeof v === 'string' && /^[v\d]/.test(v) && $36c46bc4813033e5$var$semver.test(v);
const $36c46bc4813033e5$export$398604a469f7de9a = (v1, v2, operator)=>{
    // validate input operator
    $36c46bc4813033e5$var$assertValidOperator(operator);
    // since result of compareVersions can only be -1 or 0 or 1
    // a simple map can be used to replace switch
    const res = $36c46bc4813033e5$export$2e2bcd8739ae039(v1, v2);
    return $36c46bc4813033e5$var$operatorResMap[operator].includes(res);
};
const $36c46bc4813033e5$export$b8fab89fe6d5d7da = (v, r)=>{
    // if no range operator then "="
    const m = r.match(/^([<>=~^]+)/);
    const op = m ? m[1] : '=';
    // if gt/lt/eq then operator compare
    if (op !== '^' && op !== '~') return $36c46bc4813033e5$export$398604a469f7de9a(v, r, op);
    // else range of either "~" or "^" is assumed
    const [v1, v2, v3] = $36c46bc4813033e5$var$validateAndParse(v);
    const [r1, r2, r3] = $36c46bc4813033e5$var$validateAndParse(r);
    if ($36c46bc4813033e5$var$compareStrings(v1, r1) !== 0) return false;
    if (op === '^') return $36c46bc4813033e5$var$compareSegments([
        v2,
        v3
    ], [
        r2,
        r3
    ]) >= 0;
    if ($36c46bc4813033e5$var$compareStrings(v2, r2) !== 0) return false;
    return $36c46bc4813033e5$var$compareStrings(v3, r3) >= 0;
};
// export CJS style for parity
$36c46bc4813033e5$export$2e2bcd8739ae039.validate = $36c46bc4813033e5$export$a22775fa5e2eebd9;
$36c46bc4813033e5$export$2e2bcd8739ae039.compare = $36c46bc4813033e5$export$398604a469f7de9a;
$36c46bc4813033e5$export$2e2bcd8739ae039.satisfies = $36c46bc4813033e5$export$b8fab89fe6d5d7da;
const $36c46bc4813033e5$var$semver = /^[v^~<>=]*?(\d+)(?:\.([x*]|\d+)(?:\.([x*]|\d+)(?:\.([x*]|\d+))?(?:-([\da-z\-]+(?:\.[\da-z\-]+)*))?(?:\+[\da-z\-]+(?:\.[\da-z\-]+)*)?)?)?$/i;
const $36c46bc4813033e5$var$validateAndParse = (v)=>{
    if (typeof v !== 'string') throw new TypeError('Invalid argument expected string');
    const match = v.match($36c46bc4813033e5$var$semver);
    if (!match) throw new Error(`Invalid argument not valid semver ('${v}' received)`);
    match.shift();
    return match;
};
const $36c46bc4813033e5$var$isWildcard = (s)=>s === '*' || s === 'x' || s === 'X';
const $36c46bc4813033e5$var$tryParse = (v)=>{
    const n = parseInt(v, 10);
    return isNaN(n) ? v : n;
};
const $36c46bc4813033e5$var$forceType = (a, b)=>typeof a !== typeof b ? [
        String(a),
        String(b)
    ] : [
        a,
        b
    ];
const $36c46bc4813033e5$var$compareStrings = (a, b)=>{
    if ($36c46bc4813033e5$var$isWildcard(a) || $36c46bc4813033e5$var$isWildcard(b)) return 0;
    const [ap, bp] = $36c46bc4813033e5$var$forceType($36c46bc4813033e5$var$tryParse(a), $36c46bc4813033e5$var$tryParse(b));
    if (ap > bp) return 1;
    if (ap < bp) return -1;
    return 0;
};
const $36c46bc4813033e5$var$compareSegments = (a, b)=>{
    for(let i = 0; i < Math.max(a.length, b.length); i++){
        const r = $36c46bc4813033e5$var$compareStrings(a[i] || 0, b[i] || 0);
        if (r !== 0) return r;
    }
    return 0;
};
const $36c46bc4813033e5$var$operatorResMap = {
    '>': [
        1
    ],
    '>=': [
        0,
        1
    ],
    '=': [
        0
    ],
    '<=': [
        -1,
        0
    ],
    '<': [
        -1
    ]
};
const $36c46bc4813033e5$var$allowedOperators = Object.keys($36c46bc4813033e5$var$operatorResMap);
const $36c46bc4813033e5$var$assertValidOperator = (op)=>{
    if (typeof op !== 'string') throw new TypeError(`Invalid operator type, expected string but got ${typeof op}`);
    if ($36c46bc4813033e5$var$allowedOperators.indexOf(op) === -1) throw new Error(`Invalid operator, expected one of ${$36c46bc4813033e5$var$allowedOperators.join('|')}`);
};


function $8410ced365fa20bf$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $8410ced365fa20bf$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8410ced365fa20bf$export$2e2bcd8739ae039(o);
}



function $792af9029e3bf7fe$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $8410ced365fa20bf$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $8410ced365fa20bf$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $bb90ae25267601e8$export$2e2bcd8739ae039(t) {
    var i = (0, $792af9029e3bf7fe$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $8410ced365fa20bf$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $b227c6eab5af31a1$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $bb90ae25267601e8$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


function $56fc265171b273f5$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $859292cc73aee303$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $56fc265171b273f5$export$2e2bcd8739ae039)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}


var $c3aca08c2a74646e$exports = {};

$parcel$export($c3aca08c2a74646e$exports, "createSearchParams", function () { return $c3aca08c2a74646e$export$a2e4e2dcc7b1f22f; });
$parcel$export($c3aca08c2a74646e$exports, "createBrowserRouter", function () { return $c3aca08c2a74646e$export$1f3f55432a00e06d; });
$parcel$export($c3aca08c2a74646e$exports, "createHashRouter", function () { return $c3aca08c2a74646e$export$1ba7ed8a3a7b3765; });
$parcel$export($c3aca08c2a74646e$exports, "UNSAFE_ViewTransitionContext", function () { return $c3aca08c2a74646e$export$7ad602f0e94e62d1; });
$parcel$export($c3aca08c2a74646e$exports, "UNSAFE_FetchersContext", function () { return $c3aca08c2a74646e$export$148fd98d095596d4; });
$parcel$export($c3aca08c2a74646e$exports, "RouterProvider", function () { return $c3aca08c2a74646e$export$323e4fc2fa4753fb; });
$parcel$export($c3aca08c2a74646e$exports, "BrowserRouter", function () { return $c3aca08c2a74646e$export$9ba4e89fdfa1fc54; });
$parcel$export($c3aca08c2a74646e$exports, "HashRouter", function () { return $c3aca08c2a74646e$export$7221d69dcfc8e36b; });
$parcel$export($c3aca08c2a74646e$exports, "unstable_HistoryRouter", function () { return $c3aca08c2a74646e$export$eefb0c834599897e; });
$parcel$export($c3aca08c2a74646e$exports, "Link", function () { return $c3aca08c2a74646e$export$a6c7ac8248d6e38a; });
$parcel$export($c3aca08c2a74646e$exports, "useLinkClickHandler", function () { return $c3aca08c2a74646e$export$67621102c14d847; });
$parcel$export($c3aca08c2a74646e$exports, "NavLink", function () { return $c3aca08c2a74646e$export$b0d92dbee9b5b60d; });
$parcel$export($c3aca08c2a74646e$exports, "useViewTransitionState", function () { return $c3aca08c2a74646e$export$e262bd1977bea848; });
$parcel$export($c3aca08c2a74646e$exports, "Form", function () { return $c3aca08c2a74646e$export$a7fed597f4b8afd8; });
$parcel$export($c3aca08c2a74646e$exports, "useSubmit", function () { return $c3aca08c2a74646e$export$47c85c6e3a081d3; });
$parcel$export($c3aca08c2a74646e$exports, "useFormAction", function () { return $c3aca08c2a74646e$export$89a6bd6db0d97c56; });
$parcel$export($c3aca08c2a74646e$exports, "ScrollRestoration", function () { return $c3aca08c2a74646e$export$11aac1aab828f1fa; });
$parcel$export($c3aca08c2a74646e$exports, "UNSAFE_useScrollRestoration", function () { return $c3aca08c2a74646e$export$25057cfe5591e3e9; });
$parcel$export($c3aca08c2a74646e$exports, "useSearchParams", function () { return $c3aca08c2a74646e$export$f1a78c17382fe22a; });
$parcel$export($c3aca08c2a74646e$exports, "useFetcher", function () { return $c3aca08c2a74646e$export$5b0d2d9a9921565a; });
$parcel$export($c3aca08c2a74646e$exports, "useFetchers", function () { return $c3aca08c2a74646e$export$fa996778a3a31087; });
$parcel$export($c3aca08c2a74646e$exports, "useBeforeUnload", function () { return $c3aca08c2a74646e$export$c0a586b329cae57d; });
$parcel$export($c3aca08c2a74646e$exports, "unstable_usePrompt", function () { return $c3aca08c2a74646e$export$39f4eb3dbd812741; });
$parcel$export($c3aca08c2a74646e$exports, "AbortedDeferredError", function () { return $a0511682ed8967d7$export$42a99a7a4bc0e76a; });
$parcel$export($c3aca08c2a74646e$exports, "Await", function () { return $ebc812b73151cba1$export$6ddabde395c8c576; });
$parcel$export($c3aca08c2a74646e$exports, "MemoryRouter", function () { return $ebc812b73151cba1$export$ae46f04cfaffe093; });
$parcel$export($c3aca08c2a74646e$exports, "Navigate", function () { return $ebc812b73151cba1$export$444b3ab0cb9aec40; });
$parcel$export($c3aca08c2a74646e$exports, "NavigationType", function () { return $a0511682ed8967d7$export$e19cd5f9376f8cee; });
$parcel$export($c3aca08c2a74646e$exports, "Outlet", function () { return $ebc812b73151cba1$export$910ae8079b2c2852; });
$parcel$export($c3aca08c2a74646e$exports, "Route", function () { return $ebc812b73151cba1$export$e7b0ac011bb776c6; });
$parcel$export($c3aca08c2a74646e$exports, "Router", function () { return $ebc812b73151cba1$export$55185c17a0fcbe46; });
$parcel$export($c3aca08c2a74646e$exports, "Routes", function () { return $ebc812b73151cba1$export$3565eb3d00ca5a74; });
$parcel$export($c3aca08c2a74646e$exports, "UNSAFE_DataRouterContext", function () { return $ebc812b73151cba1$export$3add0d5dce533e2e; });
$parcel$export($c3aca08c2a74646e$exports, "UNSAFE_DataRouterStateContext", function () { return $ebc812b73151cba1$export$145dfa71566a64dc; });
$parcel$export($c3aca08c2a74646e$exports, "UNSAFE_LocationContext", function () { return $ebc812b73151cba1$export$c7914228fb69b0f5; });
$parcel$export($c3aca08c2a74646e$exports, "UNSAFE_NavigationContext", function () { return $ebc812b73151cba1$export$26749e8557646306; });
$parcel$export($c3aca08c2a74646e$exports, "UNSAFE_RouteContext", function () { return $ebc812b73151cba1$export$9072aa6dd1f93057; });
$parcel$export($c3aca08c2a74646e$exports, "UNSAFE_useRouteId", function () { return $ebc812b73151cba1$export$5fc8298006ad9e58; });
$parcel$export($c3aca08c2a74646e$exports, "createMemoryRouter", function () { return $ebc812b73151cba1$export$f30f7e456d254e83; });
$parcel$export($c3aca08c2a74646e$exports, "createPath", function () { return $a0511682ed8967d7$export$fe53371bee54353d; });
$parcel$export($c3aca08c2a74646e$exports, "createRoutesFromChildren", function () { return $ebc812b73151cba1$export$16da398f5434bdec; });
$parcel$export($c3aca08c2a74646e$exports, "createRoutesFromElements", function () { return $ebc812b73151cba1$export$16da398f5434bdec; });
$parcel$export($c3aca08c2a74646e$exports, "defer", function () { return $a0511682ed8967d7$export$260e5c0943f31606; });
$parcel$export($c3aca08c2a74646e$exports, "generatePath", function () { return $a0511682ed8967d7$export$82476f982757e71e; });
$parcel$export($c3aca08c2a74646e$exports, "isRouteErrorResponse", function () { return $a0511682ed8967d7$export$972111febbeef05b; });
$parcel$export($c3aca08c2a74646e$exports, "json", function () { return $a0511682ed8967d7$export$7b419323e6ed4f31; });
$parcel$export($c3aca08c2a74646e$exports, "matchPath", function () { return $a0511682ed8967d7$export$81336c211d5ff295; });
$parcel$export($c3aca08c2a74646e$exports, "matchRoutes", function () { return $a0511682ed8967d7$export$2708184779ceb39d; });
$parcel$export($c3aca08c2a74646e$exports, "parsePath", function () { return $a0511682ed8967d7$export$8ccf933b0513f8d0; });
$parcel$export($c3aca08c2a74646e$exports, "redirect", function () { return $a0511682ed8967d7$export$89e12c5b50f7529d; });
$parcel$export($c3aca08c2a74646e$exports, "redirectDocument", function () { return $a0511682ed8967d7$export$a6cd19cd1951a23c; });
$parcel$export($c3aca08c2a74646e$exports, "renderMatches", function () { return $ebc812b73151cba1$export$daf73786167a7f72; });
$parcel$export($c3aca08c2a74646e$exports, "replace", function () { return $a0511682ed8967d7$export$77ad94ebf1c2b9ed; });
$parcel$export($c3aca08c2a74646e$exports, "resolvePath", function () { return $a0511682ed8967d7$export$b09f2ff0bbcb43c7; });
$parcel$export($c3aca08c2a74646e$exports, "useActionData", function () { return $ebc812b73151cba1$export$fdc00f3f26066d5e; });
$parcel$export($c3aca08c2a74646e$exports, "useAsyncError", function () { return $ebc812b73151cba1$export$17f53340677d5831; });
$parcel$export($c3aca08c2a74646e$exports, "useAsyncValue", function () { return $ebc812b73151cba1$export$78a72ddb39bdd145; });
$parcel$export($c3aca08c2a74646e$exports, "useBlocker", function () { return $ebc812b73151cba1$export$b273b3273281a049; });
$parcel$export($c3aca08c2a74646e$exports, "useHref", function () { return $ebc812b73151cba1$export$b66bb29c5006f12f; });
$parcel$export($c3aca08c2a74646e$exports, "useInRouterContext", function () { return $ebc812b73151cba1$export$9c954a9d03d32f4a; });
$parcel$export($c3aca08c2a74646e$exports, "useLoaderData", function () { return $ebc812b73151cba1$export$1448a5050d252c4d; });
$parcel$export($c3aca08c2a74646e$exports, "useLocation", function () { return $ebc812b73151cba1$export$45d76561a5302f2b; });
$parcel$export($c3aca08c2a74646e$exports, "useMatch", function () { return $ebc812b73151cba1$export$6c330e8992e8a295; });
$parcel$export($c3aca08c2a74646e$exports, "useMatches", function () { return $ebc812b73151cba1$export$2378eb7f5ff86053; });
$parcel$export($c3aca08c2a74646e$exports, "useNavigate", function () { return $ebc812b73151cba1$export$9770f232ac06a008; });
$parcel$export($c3aca08c2a74646e$exports, "useNavigation", function () { return $ebc812b73151cba1$export$d0fd4b7106de2769; });
$parcel$export($c3aca08c2a74646e$exports, "useNavigationType", function () { return $ebc812b73151cba1$export$1b3f31771c5d07c; });
$parcel$export($c3aca08c2a74646e$exports, "useOutlet", function () { return $ebc812b73151cba1$export$a3be3530d8e40d0b; });
$parcel$export($c3aca08c2a74646e$exports, "useOutletContext", function () { return $ebc812b73151cba1$export$4138103a3ae699cc; });
$parcel$export($c3aca08c2a74646e$exports, "useParams", function () { return $ebc812b73151cba1$export$99eaa27ddbbb95ef; });
$parcel$export($c3aca08c2a74646e$exports, "useResolvedPath", function () { return $ebc812b73151cba1$export$e75d2a2d1b3c245b; });
$parcel$export($c3aca08c2a74646e$exports, "useRevalidator", function () { return $ebc812b73151cba1$export$600dc272ed516c15; });
$parcel$export($c3aca08c2a74646e$exports, "useRouteError", function () { return $ebc812b73151cba1$export$ed527bf60f6e05f2; });
$parcel$export($c3aca08c2a74646e$exports, "useRouteLoaderData", function () { return $ebc812b73151cba1$export$fd5d37484eab868d; });
$parcel$export($c3aca08c2a74646e$exports, "useRoutes", function () { return $ebc812b73151cba1$export$5d3fca4a98652595; });
$parcel$export($c3aca08c2a74646e$exports, "UNSAFE_ErrorResponseImpl", function () { return $a0511682ed8967d7$export$6c6580e81da25755; });
/**
 * React Router DOM v6.30.6
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $lCzvA = parcelRequire("lCzvA");

var $dAQd3 = parcelRequire("dAQd3");
/**
 * React Router v6.30.6
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $lCzvA = parcelRequire("lCzvA");
/**
 * @remix-run/router v1.23.4
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $a0511682ed8967d7$var$_extends() {
    return $a0511682ed8967d7$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a0511682ed8967d7$var$_extends.apply(null, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $a0511682ed8967d7$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($a0511682ed8967d7$export$e19cd5f9376f8cee || ($a0511682ed8967d7$export$e19cd5f9376f8cee = {}));
const $a0511682ed8967d7$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $a0511682ed8967d7$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $a0511682ed8967d7$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $a0511682ed8967d7$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $a0511682ed8967d7$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $a0511682ed8967d7$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $a0511682ed8967d7$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $a0511682ed8967d7$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $a0511682ed8967d7$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $a0511682ed8967d7$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $a0511682ed8967d7$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $a0511682ed8967d7$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $a0511682ed8967d7$export$fe53371bee54353d(to);
    }
    return $a0511682ed8967d7$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $a0511682ed8967d7$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $a0511682ed8967d7$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $a0511682ed8967d7$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $a0511682ed8967d7$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $a0511682ed8967d7$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $a0511682ed8967d7$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $a0511682ed8967d7$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $a0511682ed8967d7$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $a0511682ed8967d7$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $a0511682ed8967d7$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $a0511682ed8967d7$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $a0511682ed8967d7$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $a0511682ed8967d7$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $a0511682ed8967d7$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $a0511682ed8967d7$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $a0511682ed8967d7$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $a0511682ed8967d7$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $a0511682ed8967d7$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($a0511682ed8967d7$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $a0511682ed8967d7$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $a0511682ed8967d7$export$e19cd5f9376f8cee.Push;
        let location = $a0511682ed8967d7$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $a0511682ed8967d7$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $a0511682ed8967d7$export$e19cd5f9376f8cee.Replace;
        let location = $a0511682ed8967d7$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $a0511682ed8967d7$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $a0511682ed8967d7$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $a0511682ed8967d7$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($a0511682ed8967d7$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($a0511682ed8967d7$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $a0511682ed8967d7$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($a0511682ed8967d7$var$ResultType || ($a0511682ed8967d7$var$ResultType = {}));
const $a0511682ed8967d7$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $a0511682ed8967d7$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $a0511682ed8967d7$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $a0511682ed8967d7$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $a0511682ed8967d7$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($a0511682ed8967d7$var$isIndexRoute(route)) {
            let indexRoute = $a0511682ed8967d7$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $a0511682ed8967d7$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $a0511682ed8967d7$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $a0511682ed8967d7$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $a0511682ed8967d7$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $a0511682ed8967d7$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $a0511682ed8967d7$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $a0511682ed8967d7$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $a0511682ed8967d7$var$flattenRoutes(routes);
    $a0511682ed8967d7$var$rankRouteBranches(branches);
    let matches = null;
    let decoded = $a0511682ed8967d7$export$30d21fd6d7295f52(pathname);
    for(let i = 0; matches == null && i < branches.length; ++i)// Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    matches = $a0511682ed8967d7$var$matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function $a0511682ed8967d7$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $a0511682ed8967d7$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $a0511682ed8967d7$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $a0511682ed8967d7$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $a0511682ed8967d7$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $a0511682ed8967d7$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $a0511682ed8967d7$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $a0511682ed8967d7$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $a0511682ed8967d7$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $a0511682ed8967d7$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $a0511682ed8967d7$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $a0511682ed8967d7$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $a0511682ed8967d7$var$paramRe = /^:[\w-]+$/;
const $a0511682ed8967d7$var$dynamicSegmentValue = 3;
const $a0511682ed8967d7$var$indexRouteValue = 2;
const $a0511682ed8967d7$var$emptySegmentValue = 1;
const $a0511682ed8967d7$var$staticSegmentValue = 10;
const $a0511682ed8967d7$var$splatPenalty = -2;
const $a0511682ed8967d7$var$isSplat = (s)=>s === "*";
function $a0511682ed8967d7$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($a0511682ed8967d7$var$isSplat)) initialScore += $a0511682ed8967d7$var$splatPenalty;
    if (index) initialScore += $a0511682ed8967d7$var$indexRouteValue;
    return segments.filter((s)=>!$a0511682ed8967d7$var$isSplat(s)).reduce((score, segment)=>score + ($a0511682ed8967d7$var$paramRe.test(segment) ? $a0511682ed8967d7$var$dynamicSegmentValue : segment === "" ? $a0511682ed8967d7$var$emptySegmentValue : $a0511682ed8967d7$var$staticSegmentValue), initialScore);
}
function $a0511682ed8967d7$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $a0511682ed8967d7$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $a0511682ed8967d7$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $a0511682ed8967d7$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $a0511682ed8967d7$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $a0511682ed8967d7$export$a5c6d149b50c1d86($a0511682ed8967d7$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $a0511682ed8967d7$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $a0511682ed8967d7$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $a0511682ed8967d7$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $a0511682ed8967d7$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $a0511682ed8967d7$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $a0511682ed8967d7$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $a0511682ed8967d7$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $a0511682ed8967d7$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $a0511682ed8967d7$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $a0511682ed8967d7$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $a0511682ed8967d7$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $a0511682ed8967d7$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $a0511682ed8967d7$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        toPathname = $a0511682ed8967d7$var$removeDoubleSlashes(toPathname);
        if (toPathname.startsWith("/")) pathname = $a0511682ed8967d7$var$resolvePathname(toPathname.substring(1), "/");
        else pathname = $a0511682ed8967d7$var$resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $a0511682ed8967d7$var$normalizeSearch(search),
        hash: $a0511682ed8967d7$var$normalizeHash(hash)
    };
}
function $a0511682ed8967d7$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $a0511682ed8967d7$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $a0511682ed8967d7$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $a0511682ed8967d7$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $a0511682ed8967d7$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $a0511682ed8967d7$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $a0511682ed8967d7$export$8ccf933b0513f8d0(toArg);
    else {
        to = $a0511682ed8967d7$var$_extends({}, toArg);
        $a0511682ed8967d7$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $a0511682ed8967d7$var$getInvalidPathError("?", "pathname", "search", to));
        $a0511682ed8967d7$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $a0511682ed8967d7$var$getInvalidPathError("#", "pathname", "hash", to));
        $a0511682ed8967d7$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $a0511682ed8967d7$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $a0511682ed8967d7$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $a0511682ed8967d7$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $a0511682ed8967d7$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
const $a0511682ed8967d7$var$removeDoubleSlashes = (path)=>path.replace(/\/\/+/g, "/");
/**
 * @private
 */ const $a0511682ed8967d7$export$86d9a7913e44197e = (paths)=>$a0511682ed8967d7$var$removeDoubleSlashes(paths.join("/"));
/**
 * @private
 */ const $a0511682ed8967d7$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $a0511682ed8967d7$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $a0511682ed8967d7$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $a0511682ed8967d7$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $a0511682ed8967d7$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $a0511682ed8967d7$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $a0511682ed8967d7$export$4051a07651545597(data, init) {
    return new $a0511682ed8967d7$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $a0511682ed8967d7$export$42a99a7a4bc0e76a extends Error {
}
class $a0511682ed8967d7$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $a0511682ed8967d7$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $a0511682ed8967d7$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $a0511682ed8967d7$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $a0511682ed8967d7$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $a0511682ed8967d7$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $a0511682ed8967d7$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $a0511682ed8967d7$var$unwrapTrackedPromise(value) {
    if (!$a0511682ed8967d7$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $a0511682ed8967d7$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $a0511682ed8967d7$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $a0511682ed8967d7$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $a0511682ed8967d7$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $a0511682ed8967d7$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $a0511682ed8967d7$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $a0511682ed8967d7$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $a0511682ed8967d7$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $a0511682ed8967d7$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $a0511682ed8967d7$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $a0511682ed8967d7$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $a0511682ed8967d7$var$validMutationMethods = new Set($a0511682ed8967d7$var$validMutationMethodsArr);
const $a0511682ed8967d7$var$validRequestMethodsArr = [
    "get",
    ...$a0511682ed8967d7$var$validMutationMethodsArr
];
const $a0511682ed8967d7$var$validRequestMethods = new Set($a0511682ed8967d7$var$validRequestMethodsArr);
const $a0511682ed8967d7$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $a0511682ed8967d7$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $a0511682ed8967d7$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $a0511682ed8967d7$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $a0511682ed8967d7$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $a0511682ed8967d7$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $a0511682ed8967d7$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $a0511682ed8967d7$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $a0511682ed8967d7$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $a0511682ed8967d7$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $a0511682ed8967d7$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $a0511682ed8967d7$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $a0511682ed8967d7$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $a0511682ed8967d7$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $a0511682ed8967d7$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $a0511682ed8967d7$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $a0511682ed8967d7$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$a0511682ed8967d7$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$a0511682ed8967d7$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $a0511682ed8967d7$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $a0511682ed8967d7$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $a0511682ed8967d7$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $a0511682ed8967d7$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $a0511682ed8967d7$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$a0511682ed8967d7$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($a0511682ed8967d7$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $a0511682ed8967d7$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $a0511682ed8967d7$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $a0511682ed8967d7$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $a0511682ed8967d7$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $a0511682ed8967d7$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $a0511682ed8967d7$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $a0511682ed8967d7$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $a0511682ed8967d7$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $a0511682ed8967d7$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($a0511682ed8967d7$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $a0511682ed8967d7$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $a0511682ed8967d7$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $a0511682ed8967d7$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $a0511682ed8967d7$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $a0511682ed8967d7$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $a0511682ed8967d7$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $a0511682ed8967d7$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $a0511682ed8967d7$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $a0511682ed8967d7$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $a0511682ed8967d7$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $a0511682ed8967d7$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $a0511682ed8967d7$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $a0511682ed8967d7$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $a0511682ed8967d7$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $a0511682ed8967d7$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $a0511682ed8967d7$var$findNearestBoundary(matches).route.id,
            {
                type: $a0511682ed8967d7$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $a0511682ed8967d7$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($a0511682ed8967d7$var$isErrorResult(result) && $a0511682ed8967d7$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $a0511682ed8967d7$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $a0511682ed8967d7$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $a0511682ed8967d7$var$_extends({
            matches: updatedMatches || matches
        }, $a0511682ed8967d7$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $a0511682ed8967d7$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $a0511682ed8967d7$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $a0511682ed8967d7$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $a0511682ed8967d7$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $a0511682ed8967d7$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $a0511682ed8967d7$var$ResultType.error,
            error: $a0511682ed8967d7$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($a0511682ed8967d7$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $a0511682ed8967d7$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($a0511682ed8967d7$var$isDeferredResult(result)) throw $a0511682ed8967d7$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($a0511682ed8967d7$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $a0511682ed8967d7$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $a0511682ed8967d7$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $a0511682ed8967d7$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $a0511682ed8967d7$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($a0511682ed8967d7$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $a0511682ed8967d7$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $a0511682ed8967d7$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $a0511682ed8967d7$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $a0511682ed8967d7$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $a0511682ed8967d7$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $a0511682ed8967d7$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $a0511682ed8967d7$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $a0511682ed8967d7$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $a0511682ed8967d7$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $a0511682ed8967d7$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$a0511682ed8967d7$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $a0511682ed8967d7$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $a0511682ed8967d7$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $a0511682ed8967d7$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $a0511682ed8967d7$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $a0511682ed8967d7$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $a0511682ed8967d7$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $a0511682ed8967d7$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $a0511682ed8967d7$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $a0511682ed8967d7$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $a0511682ed8967d7$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $a0511682ed8967d7$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $a0511682ed8967d7$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($a0511682ed8967d7$var$isRedirectResult(actionResult) || $a0511682ed8967d7$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $a0511682ed8967d7$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($a0511682ed8967d7$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $a0511682ed8967d7$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $a0511682ed8967d7$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($a0511682ed8967d7$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($a0511682ed8967d7$var$isDeferredResult(actionResult)) throw $a0511682ed8967d7$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $a0511682ed8967d7$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $a0511682ed8967d7$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $a0511682ed8967d7$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $a0511682ed8967d7$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $a0511682ed8967d7$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $a0511682ed8967d7$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $a0511682ed8967d7$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $a0511682ed8967d7$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $a0511682ed8967d7$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $a0511682ed8967d7$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $a0511682ed8967d7$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $a0511682ed8967d7$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $a0511682ed8967d7$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $a0511682ed8967d7$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $a0511682ed8967d7$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $a0511682ed8967d7$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($a0511682ed8967d7$var$isDeferredResult(result)) result = await $a0511682ed8967d7$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $a0511682ed8967d7$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($a0511682ed8967d7$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $a0511682ed8967d7$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($a0511682ed8967d7$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $a0511682ed8967d7$export$3e9cee6b33872309(!$a0511682ed8967d7$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $a0511682ed8967d7$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $a0511682ed8967d7$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $a0511682ed8967d7$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $a0511682ed8967d7$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($a0511682ed8967d7$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $a0511682ed8967d7$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $a0511682ed8967d7$export$e19cd5f9376f8cee.Replace : $a0511682ed8967d7$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $a0511682ed8967d7$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($a0511682ed8967d7$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $a0511682ed8967d7$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $a0511682ed8967d7$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $a0511682ed8967d7$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $a0511682ed8967d7$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $a0511682ed8967d7$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($a0511682ed8967d7$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $a0511682ed8967d7$var$ResultType.redirect,
                response: $a0511682ed8967d7$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $a0511682ed8967d7$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $a0511682ed8967d7$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $a0511682ed8967d7$var$ResultType.error,
                    error: $a0511682ed8967d7$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $a0511682ed8967d7$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $a0511682ed8967d7$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $a0511682ed8967d7$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $a0511682ed8967d7$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $a0511682ed8967d7$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $a0511682ed8967d7$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $a0511682ed8967d7$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $a0511682ed8967d7$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $a0511682ed8967d7$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $a0511682ed8967d7$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $a0511682ed8967d7$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $a0511682ed8967d7$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $a0511682ed8967d7$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $a0511682ed8967d7$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$a0511682ed8967d7$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $a0511682ed8967d7$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $a0511682ed8967d7$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $a0511682ed8967d7$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $a0511682ed8967d7$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $a0511682ed8967d7$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $a0511682ed8967d7$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $a0511682ed8967d7$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $a0511682ed8967d7$export$4d0306f8f6a4585b = Symbol("deferred");
function $a0511682ed8967d7$export$3336b097a6fbc59a(routes, opts) {
    $a0511682ed8967d7$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $a0511682ed8967d7$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $a0511682ed8967d7$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $a0511682ed8967d7$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $a0511682ed8967d7$var$createLocation("", $a0511682ed8967d7$export$fe53371bee54353d(url), null, "default");
        let matches = $a0511682ed8967d7$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$a0511682ed8967d7$var$isValidMethod(method) && method !== "HEAD") {
            let error = $a0511682ed8967d7$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $a0511682ed8967d7$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $a0511682ed8967d7$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $a0511682ed8967d7$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($a0511682ed8967d7$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $a0511682ed8967d7$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $a0511682ed8967d7$var$createLocation("", $a0511682ed8967d7$export$fe53371bee54353d(url), null, "default");
        let matches = $a0511682ed8967d7$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$a0511682ed8967d7$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $a0511682ed8967d7$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $a0511682ed8967d7$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $a0511682ed8967d7$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $a0511682ed8967d7$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $a0511682ed8967d7$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($a0511682ed8967d7$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$a0511682ed8967d7$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $a0511682ed8967d7$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($a0511682ed8967d7$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $a0511682ed8967d7$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $a0511682ed8967d7$var$isResponse(result) ? result : $a0511682ed8967d7$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($a0511682ed8967d7$var$isDataStrategyResult(e) && $a0511682ed8967d7$var$isResponse(e.result)) {
                if (e.type === $a0511682ed8967d7$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($a0511682ed8967d7$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $a0511682ed8967d7$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $a0511682ed8967d7$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $a0511682ed8967d7$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($a0511682ed8967d7$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($a0511682ed8967d7$var$isDeferredResult(result)) {
            let error = $a0511682ed8967d7$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $a0511682ed8967d7$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($a0511682ed8967d7$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($a0511682ed8967d7$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $a0511682ed8967d7$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $a0511682ed8967d7$var$_extends({}, context, {
                statusCode: $a0511682ed8967d7$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $a0511682ed8967d7$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $a0511682ed8967d7$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $a0511682ed8967d7$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $a0511682ed8967d7$var$isErrorResult(pendingActionResult[1]) ? $a0511682ed8967d7$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $a0511682ed8967d7$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $a0511682ed8967d7$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $a0511682ed8967d7$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $a0511682ed8967d7$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $a0511682ed8967d7$var$callDataStrategyImpl(dataStrategy || $a0511682ed8967d7$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($a0511682ed8967d7$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $a0511682ed8967d7$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($a0511682ed8967d7$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $a0511682ed8967d7$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $a0511682ed8967d7$export$fec11da027c70692(routes, context, error) {
    let newContext = $a0511682ed8967d7$var$_extends({}, context, {
        statusCode: $a0511682ed8967d7$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $a0511682ed8967d7$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $a0511682ed8967d7$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $a0511682ed8967d7$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $a0511682ed8967d7$export$cae722b0cc860f13(to ? to : ".", $a0511682ed8967d7$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $a0511682ed8967d7$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $a0511682ed8967d7$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $a0511682ed8967d7$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $a0511682ed8967d7$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $a0511682ed8967d7$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$a0511682ed8967d7$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$a0511682ed8967d7$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $a0511682ed8967d7$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $a0511682ed8967d7$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $a0511682ed8967d7$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$a0511682ed8967d7$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$a0511682ed8967d7$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $a0511682ed8967d7$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $a0511682ed8967d7$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $a0511682ed8967d7$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $a0511682ed8967d7$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $a0511682ed8967d7$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($a0511682ed8967d7$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $a0511682ed8967d7$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $a0511682ed8967d7$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $a0511682ed8967d7$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $a0511682ed8967d7$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $a0511682ed8967d7$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $a0511682ed8967d7$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $a0511682ed8967d7$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $a0511682ed8967d7$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $a0511682ed8967d7$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $a0511682ed8967d7$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($a0511682ed8967d7$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $a0511682ed8967d7$var$shouldRevalidateLoader(match, $a0511682ed8967d7$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $a0511682ed8967d7$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $a0511682ed8967d7$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $a0511682ed8967d7$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $a0511682ed8967d7$var$shouldRevalidateLoader(fetcherMatch, $a0511682ed8967d7$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $a0511682ed8967d7$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $a0511682ed8967d7$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $a0511682ed8967d7$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $a0511682ed8967d7$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $a0511682ed8967d7$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $a0511682ed8967d7$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$a0511682ed8967d7$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $a0511682ed8967d7$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $a0511682ed8967d7$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$a0511682ed8967d7$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $a0511682ed8967d7$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $a0511682ed8967d7$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $a0511682ed8967d7$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$a0511682ed8967d7$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $a0511682ed8967d7$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $a0511682ed8967d7$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $a0511682ed8967d7$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $a0511682ed8967d7$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $a0511682ed8967d7$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $a0511682ed8967d7$var$ResultType.data,
                result: undefined
            });
        };
        return $a0511682ed8967d7$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $a0511682ed8967d7$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $a0511682ed8967d7$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $a0511682ed8967d7$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $a0511682ed8967d7$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $a0511682ed8967d7$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $a0511682ed8967d7$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $a0511682ed8967d7$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($a0511682ed8967d7$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $a0511682ed8967d7$var$ResultType.error,
                error: e
            };
        }
        if (type === $a0511682ed8967d7$var$ResultType.error) return {
            type: $a0511682ed8967d7$var$ResultType.error,
            error: new $a0511682ed8967d7$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $a0511682ed8967d7$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $a0511682ed8967d7$var$ResultType.error) {
        if ($a0511682ed8967d7$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $a0511682ed8967d7$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $a0511682ed8967d7$var$ResultType.error,
                error: new $a0511682ed8967d7$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $a0511682ed8967d7$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $a0511682ed8967d7$var$ResultType.error,
            error: result,
            statusCode: $a0511682ed8967d7$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($a0511682ed8967d7$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $a0511682ed8967d7$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($a0511682ed8967d7$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $a0511682ed8967d7$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $a0511682ed8967d7$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $a0511682ed8967d7$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $a0511682ed8967d7$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$a0511682ed8967d7$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $a0511682ed8967d7$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $a0511682ed8967d7$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    // Match Chrome's behavior:
    // https://github.com/chromium/chromium/blob/216dbeb61db0c667e62082e5f5400a32d6983df3/content/public/common/url_utils.cc#L82
    let invalidProtocols = [
        "about:",
        "blob:",
        "chrome:",
        "chrome-untrusted:",
        "content:",
        "data:",
        "devtools:",
        "file:",
        "filesystem:",
        // eslint-disable-next-line no-script-url
        "javascript:"
    ];
    if ($a0511682ed8967d7$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $a0511682ed8967d7$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return $a0511682ed8967d7$var$removeDoubleSlashes(url.pathname) + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $a0511682ed8967d7$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($a0511682ed8967d7$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $a0511682ed8967d7$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $a0511682ed8967d7$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $a0511682ed8967d7$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $a0511682ed8967d7$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $a0511682ed8967d7$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $a0511682ed8967d7$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $a0511682ed8967d7$export$3e9cee6b33872309(!$a0511682ed8967d7$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($a0511682ed8967d7$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $a0511682ed8967d7$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $a0511682ed8967d7$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($a0511682ed8967d7$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $a0511682ed8967d7$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $a0511682ed8967d7$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $a0511682ed8967d7$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($a0511682ed8967d7$var$isErrorResult(result)) {
            let boundaryMatch = $a0511682ed8967d7$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $a0511682ed8967d7$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($a0511682ed8967d7$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $a0511682ed8967d7$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($a0511682ed8967d7$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $a0511682ed8967d7$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $a0511682ed8967d7$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $a0511682ed8967d7$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $a0511682ed8967d7$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $a0511682ed8967d7$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $a0511682ed8967d7$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $a0511682ed8967d7$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $a0511682ed8967d7$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $a0511682ed8967d7$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $a0511682ed8967d7$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $a0511682ed8967d7$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($a0511682ed8967d7$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $a0511682ed8967d7$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $a0511682ed8967d7$export$8ccf933b0513f8d0(path) : path;
    return $a0511682ed8967d7$export$fe53371bee54353d($a0511682ed8967d7$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $a0511682ed8967d7$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $a0511682ed8967d7$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $a0511682ed8967d7$var$ResultType.data || result.type === $a0511682ed8967d7$var$ResultType.error);
}
function $a0511682ed8967d7$var$isRedirectDataStrategyResultResult(result) {
    return $a0511682ed8967d7$var$isResponse(result.result) && $a0511682ed8967d7$var$redirectStatusCodes.has(result.result.status);
}
function $a0511682ed8967d7$var$isDeferredResult(result) {
    return result.type === $a0511682ed8967d7$var$ResultType.deferred;
}
function $a0511682ed8967d7$var$isErrorResult(result) {
    return result.type === $a0511682ed8967d7$var$ResultType.error;
}
function $a0511682ed8967d7$var$isRedirectResult(result) {
    return (result && result.type) === $a0511682ed8967d7$var$ResultType.redirect;
}
function $a0511682ed8967d7$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $a0511682ed8967d7$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $a0511682ed8967d7$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $a0511682ed8967d7$var$isRedirectResponse(result) {
    if (!$a0511682ed8967d7$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $a0511682ed8967d7$var$isValidMethod(method) {
    return $a0511682ed8967d7$var$validRequestMethods.has(method.toLowerCase());
}
function $a0511682ed8967d7$var$isMutationMethod(method) {
    return $a0511682ed8967d7$var$validMutationMethods.has(method.toLowerCase());
}
async function $a0511682ed8967d7$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$a0511682ed8967d7$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($a0511682ed8967d7$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $a0511682ed8967d7$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $a0511682ed8967d7$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($a0511682ed8967d7$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $a0511682ed8967d7$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $a0511682ed8967d7$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $a0511682ed8967d7$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $a0511682ed8967d7$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $a0511682ed8967d7$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $a0511682ed8967d7$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $a0511682ed8967d7$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $a0511682ed8967d7$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $a0511682ed8967d7$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $a0511682ed8967d7$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $a0511682ed8967d7$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $a0511682ed8967d7$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $a0511682ed8967d7$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $a0511682ed8967d7$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $a0511682ed8967d7$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $a0511682ed8967d7$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $a0511682ed8967d7$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $a0511682ed8967d7$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($a0511682ed8967d7$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $a0511682ed8967d7$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($a0511682ed8967d7$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $a0511682ed8967d7$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}


function $ebc812b73151cba1$var$_extends() {
    return $ebc812b73151cba1$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ebc812b73151cba1$var$_extends.apply(null, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $ebc812b73151cba1$export$3add0d5dce533e2e = /*#__PURE__*/ $lCzvA.createContext(null);
const $ebc812b73151cba1$export$145dfa71566a64dc = /*#__PURE__*/ $lCzvA.createContext(null);
const $ebc812b73151cba1$var$AwaitContext = /*#__PURE__*/ $lCzvA.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $ebc812b73151cba1$export$26749e8557646306 = /*#__PURE__*/ $lCzvA.createContext(null);
const $ebc812b73151cba1$export$c7914228fb69b0f5 = /*#__PURE__*/ $lCzvA.createContext(null);
const $ebc812b73151cba1$export$9072aa6dd1f93057 = /*#__PURE__*/ $lCzvA.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $ebc812b73151cba1$var$RouteErrorContext = /*#__PURE__*/ $lCzvA.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $ebc812b73151cba1$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$ebc812b73151cba1$export$9c954a9d03d32f4a() && (0, $a0511682ed8967d7$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $lCzvA.useContext($ebc812b73151cba1$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $ebc812b73151cba1$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $a0511682ed8967d7$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $ebc812b73151cba1$export$9c954a9d03d32f4a() {
    return $lCzvA.useContext($ebc812b73151cba1$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $ebc812b73151cba1$export$45d76561a5302f2b() {
    !$ebc812b73151cba1$export$9c954a9d03d32f4a() && (0, $a0511682ed8967d7$export$3e9cee6b33872309)(false);
    return $lCzvA.useContext($ebc812b73151cba1$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $ebc812b73151cba1$export$1b3f31771c5d07c() {
    return $lCzvA.useContext($ebc812b73151cba1$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $ebc812b73151cba1$export$6c330e8992e8a295(pattern) {
    !$ebc812b73151cba1$export$9c954a9d03d32f4a() && (0, $a0511682ed8967d7$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $ebc812b73151cba1$export$45d76561a5302f2b();
    return $lCzvA.useMemo(()=>(0, $a0511682ed8967d7$export$81336c211d5ff295)(pattern, (0, $a0511682ed8967d7$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $ebc812b73151cba1$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $ebc812b73151cba1$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $lCzvA.useContext($ebc812b73151cba1$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $lCzvA.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $ebc812b73151cba1$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $lCzvA.useContext($ebc812b73151cba1$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $ebc812b73151cba1$var$useNavigateStable() : $ebc812b73151cba1$var$useNavigateUnstable();
}
function $ebc812b73151cba1$var$useNavigateUnstable() {
    !$ebc812b73151cba1$export$9c954a9d03d32f4a() && (0, $a0511682ed8967d7$export$3e9cee6b33872309)(false);
    let dataRouterContext = $lCzvA.useContext($ebc812b73151cba1$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $lCzvA.useContext($ebc812b73151cba1$export$26749e8557646306);
    let { matches: matches } = $lCzvA.useContext($ebc812b73151cba1$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $ebc812b73151cba1$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $a0511682ed8967d7$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $lCzvA.useRef(false);
    $ebc812b73151cba1$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $lCzvA.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $a0511682ed8967d7$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $a0511682ed8967d7$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $ebc812b73151cba1$var$OutletContext = /*#__PURE__*/ $lCzvA.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $ebc812b73151cba1$export$4138103a3ae699cc() {
    return $lCzvA.useContext($ebc812b73151cba1$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $ebc812b73151cba1$export$a3be3530d8e40d0b(context) {
    let outlet = $lCzvA.useContext($ebc812b73151cba1$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $lCzvA.createElement($ebc812b73151cba1$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $ebc812b73151cba1$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $lCzvA.useContext($ebc812b73151cba1$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $ebc812b73151cba1$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $lCzvA.useContext($ebc812b73151cba1$export$26749e8557646306);
    let { matches: matches } = $lCzvA.useContext($ebc812b73151cba1$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $ebc812b73151cba1$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $a0511682ed8967d7$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $lCzvA.useMemo(()=>(0, $a0511682ed8967d7$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $ebc812b73151cba1$export$5d3fca4a98652595(routes, locationArg) {
    return $ebc812b73151cba1$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $ebc812b73151cba1$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$ebc812b73151cba1$export$9c954a9d03d32f4a() && (0, $a0511682ed8967d7$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $lCzvA.useContext($ebc812b73151cba1$export$26749e8557646306);
    let { matches: parentMatches } = $lCzvA.useContext($ebc812b73151cba1$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $ebc812b73151cba1$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $a0511682ed8967d7$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $a0511682ed8967d7$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $a0511682ed8967d7$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $ebc812b73151cba1$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $a0511682ed8967d7$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $a0511682ed8967d7$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $lCzvA.createElement($ebc812b73151cba1$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $ebc812b73151cba1$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $a0511682ed8967d7$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $ebc812b73151cba1$var$DefaultErrorComponent() {
    let error = $ebc812b73151cba1$export$ed527bf60f6e05f2();
    let message = (0, $a0511682ed8967d7$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $lCzvA.createElement($lCzvA.Fragment, null, /*#__PURE__*/ $lCzvA.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $lCzvA.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $lCzvA.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $ebc812b73151cba1$var$defaultErrorElement = /*#__PURE__*/ $lCzvA.createElement($ebc812b73151cba1$var$DefaultErrorComponent, null);
class $ebc812b73151cba1$var$RenderErrorBoundary extends $lCzvA.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $lCzvA.createElement($ebc812b73151cba1$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $lCzvA.createElement($ebc812b73151cba1$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $ebc812b73151cba1$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $lCzvA.useContext($ebc812b73151cba1$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $lCzvA.createElement($ebc812b73151cba1$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $ebc812b73151cba1$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $a0511682ed8967d7$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $ebc812b73151cba1$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $ebc812b73151cba1$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $lCzvA.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $lCzvA.createElement($ebc812b73151cba1$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $lCzvA.createElement($ebc812b73151cba1$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $ebc812b73151cba1$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($ebc812b73151cba1$var$DataRouterHook || {});
var $ebc812b73151cba1$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($ebc812b73151cba1$var$DataRouterStateHook || {});
function $ebc812b73151cba1$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $ebc812b73151cba1$var$useDataRouterContext(hookName) {
    let ctx = $lCzvA.useContext($ebc812b73151cba1$export$3add0d5dce533e2e);
    !ctx && (0, $a0511682ed8967d7$export$3e9cee6b33872309)(false);
    return ctx;
}
function $ebc812b73151cba1$var$useDataRouterState(hookName) {
    let state = $lCzvA.useContext($ebc812b73151cba1$export$145dfa71566a64dc);
    !state && (0, $a0511682ed8967d7$export$3e9cee6b33872309)(false);
    return state;
}
function $ebc812b73151cba1$var$useRouteContext(hookName) {
    let route = $lCzvA.useContext($ebc812b73151cba1$export$9072aa6dd1f93057);
    !route && (0, $a0511682ed8967d7$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $ebc812b73151cba1$var$useCurrentRouteId(hookName) {
    let route = $ebc812b73151cba1$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $a0511682ed8967d7$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $ebc812b73151cba1$export$5fc8298006ad9e58() {
    return $ebc812b73151cba1$var$useCurrentRouteId($ebc812b73151cba1$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $ebc812b73151cba1$export$d0fd4b7106de2769() {
    let state = $ebc812b73151cba1$var$useDataRouterState($ebc812b73151cba1$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $ebc812b73151cba1$export$600dc272ed516c15() {
    let dataRouterContext = $ebc812b73151cba1$var$useDataRouterContext($ebc812b73151cba1$var$DataRouterHook.UseRevalidator);
    let state = $ebc812b73151cba1$var$useDataRouterState($ebc812b73151cba1$var$DataRouterStateHook.UseRevalidator);
    return $lCzvA.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $ebc812b73151cba1$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $ebc812b73151cba1$var$useDataRouterState($ebc812b73151cba1$var$DataRouterStateHook.UseMatches);
    return $lCzvA.useMemo(()=>matches.map((m)=>(0, $a0511682ed8967d7$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $ebc812b73151cba1$export$1448a5050d252c4d() {
    let state = $ebc812b73151cba1$var$useDataRouterState($ebc812b73151cba1$var$DataRouterStateHook.UseLoaderData);
    let routeId = $ebc812b73151cba1$var$useCurrentRouteId($ebc812b73151cba1$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $ebc812b73151cba1$export$fd5d37484eab868d(routeId) {
    let state = $ebc812b73151cba1$var$useDataRouterState($ebc812b73151cba1$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $ebc812b73151cba1$export$fdc00f3f26066d5e() {
    let state = $ebc812b73151cba1$var$useDataRouterState($ebc812b73151cba1$var$DataRouterStateHook.UseActionData);
    let routeId = $ebc812b73151cba1$var$useCurrentRouteId($ebc812b73151cba1$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $ebc812b73151cba1$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $lCzvA.useContext($ebc812b73151cba1$var$RouteErrorContext);
    let state = $ebc812b73151cba1$var$useDataRouterState($ebc812b73151cba1$var$DataRouterStateHook.UseRouteError);
    let routeId = $ebc812b73151cba1$var$useCurrentRouteId($ebc812b73151cba1$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $ebc812b73151cba1$export$78a72ddb39bdd145() {
    let value = $lCzvA.useContext($ebc812b73151cba1$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $ebc812b73151cba1$export$17f53340677d5831() {
    let value = $lCzvA.useContext($ebc812b73151cba1$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $ebc812b73151cba1$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $ebc812b73151cba1$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $ebc812b73151cba1$var$useDataRouterContext($ebc812b73151cba1$var$DataRouterHook.UseBlocker);
    let state = $ebc812b73151cba1$var$useDataRouterState($ebc812b73151cba1$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $lCzvA.useState("");
    let blockerFunction = $lCzvA.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $ebc812b73151cba1$var$_extends({}, currentLocation, {
                pathname: (0, $a0511682ed8967d7$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $ebc812b73151cba1$var$_extends({}, nextLocation, {
                pathname: (0, $a0511682ed8967d7$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $lCzvA.useEffect(()=>{
        let key = String(++$ebc812b73151cba1$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $lCzvA.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $a0511682ed8967d7$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $ebc812b73151cba1$var$useNavigateStable() {
    let { router: router } = $ebc812b73151cba1$var$useDataRouterContext($ebc812b73151cba1$var$DataRouterHook.UseNavigateStable);
    let id = $ebc812b73151cba1$var$useCurrentRouteId($ebc812b73151cba1$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $lCzvA.useRef(false);
    $ebc812b73151cba1$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $lCzvA.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $ebc812b73151cba1$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $ebc812b73151cba1$var$alreadyWarned$1 = {};
function $ebc812b73151cba1$var$warningOnce(key, cond, message) {
    if (!cond && !$ebc812b73151cba1$var$alreadyWarned$1[key]) $ebc812b73151cba1$var$alreadyWarned$1[key] = true;
}
const $ebc812b73151cba1$var$alreadyWarned = {};
function $ebc812b73151cba1$var$warnOnce(key, message) {}
const $ebc812b73151cba1$var$logDeprecation = (flag, msg, link)=>$ebc812b73151cba1$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $ebc812b73151cba1$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $ebc812b73151cba1$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $ebc812b73151cba1$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $ebc812b73151cba1$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $ebc812b73151cba1$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $ebc812b73151cba1$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $ebc812b73151cba1$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $ebc812b73151cba1$var$START_TRANSITION = "startTransition";
const $ebc812b73151cba1$var$startTransitionImpl = $lCzvA[$ebc812b73151cba1$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $ebc812b73151cba1$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $lCzvA.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $lCzvA.useCallback((newState)=>{
        if (v7_startTransition && $ebc812b73151cba1$var$startTransitionImpl) $ebc812b73151cba1$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $lCzvA.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $lCzvA.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $lCzvA.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $lCzvA.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $lCzvA.useEffect(()=>$ebc812b73151cba1$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $lCzvA.createElement($lCzvA.Fragment, null, /*#__PURE__*/ $lCzvA.createElement($ebc812b73151cba1$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $lCzvA.createElement($ebc812b73151cba1$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $lCzvA.createElement($ebc812b73151cba1$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $lCzvA.createElement($ebc812b73151cba1$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $ebc812b73151cba1$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $ebc812b73151cba1$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $ebc812b73151cba1$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $lCzvA.useRef();
    if (historyRef.current == null) historyRef.current = (0, $a0511682ed8967d7$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $lCzvA.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $lCzvA.useCallback((newState)=>{
        v7_startTransition && $ebc812b73151cba1$var$startTransitionImpl ? $ebc812b73151cba1$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $lCzvA.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $lCzvA.useEffect(()=>$ebc812b73151cba1$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $lCzvA.createElement($ebc812b73151cba1$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $ebc812b73151cba1$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$ebc812b73151cba1$export$9c954a9d03d32f4a() && (0, $a0511682ed8967d7$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $lCzvA.useContext($ebc812b73151cba1$export$26749e8557646306);
    let { matches: matches } = $lCzvA.useContext($ebc812b73151cba1$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $ebc812b73151cba1$export$45d76561a5302f2b();
    let navigate = $ebc812b73151cba1$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $a0511682ed8967d7$export$cae722b0cc860f13)(to, (0, $a0511682ed8967d7$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $lCzvA.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $ebc812b73151cba1$export$910ae8079b2c2852(props) {
    return $ebc812b73151cba1$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $ebc812b73151cba1$export$e7b0ac011bb776c6(_props) {
    (0, $a0511682ed8967d7$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $ebc812b73151cba1$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $a0511682ed8967d7$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$ebc812b73151cba1$export$9c954a9d03d32f4a() && (0, $a0511682ed8967d7$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $lCzvA.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $ebc812b73151cba1$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $a0511682ed8967d7$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $lCzvA.useMemo(()=>{
        let trailingPathname = (0, $a0511682ed8967d7$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $lCzvA.createElement($ebc812b73151cba1$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $lCzvA.createElement($ebc812b73151cba1$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $ebc812b73151cba1$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $ebc812b73151cba1$export$5d3fca4a98652595($ebc812b73151cba1$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $ebc812b73151cba1$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $lCzvA.createElement($ebc812b73151cba1$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $lCzvA.createElement($ebc812b73151cba1$var$ResolveAwait, null, children));
}
var $ebc812b73151cba1$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($ebc812b73151cba1$var$AwaitRenderStatus || {});
const $ebc812b73151cba1$var$neverSettledPromise = new Promise(()=>{});
class $ebc812b73151cba1$var$AwaitErrorBoundary extends $lCzvA.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $ebc812b73151cba1$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $ebc812b73151cba1$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $ebc812b73151cba1$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $ebc812b73151cba1$var$AwaitRenderStatus.error : "_data" in promise ? $ebc812b73151cba1$var$AwaitRenderStatus.success : $ebc812b73151cba1$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $ebc812b73151cba1$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $ebc812b73151cba1$var$AwaitRenderStatus.error && promise._error instanceof (0, $a0511682ed8967d7$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $ebc812b73151cba1$var$neverSettledPromise;
        if (status === $ebc812b73151cba1$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $ebc812b73151cba1$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $lCzvA.createElement($ebc812b73151cba1$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $ebc812b73151cba1$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $lCzvA.createElement($ebc812b73151cba1$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $ebc812b73151cba1$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $ebc812b73151cba1$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $lCzvA.createElement($lCzvA.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $ebc812b73151cba1$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $lCzvA.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $lCzvA.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $lCzvA.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $ebc812b73151cba1$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $ebc812b73151cba1$export$e7b0ac011bb776c6) && (0, $a0511682ed8967d7$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $a0511682ed8967d7$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $ebc812b73151cba1$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $ebc812b73151cba1$export$daf73786167a7f72(matches) {
    return $ebc812b73151cba1$var$_renderMatches(matches);
}
function $ebc812b73151cba1$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $lCzvA.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $lCzvA.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $lCzvA.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $ebc812b73151cba1$export$f30f7e456d254e83(routes, opts) {
    return (0, $a0511682ed8967d7$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $ebc812b73151cba1$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $a0511682ed8967d7$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $ebc812b73151cba1$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $c3aca08c2a74646e$var$_extends() {
    return $c3aca08c2a74646e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c3aca08c2a74646e$var$_extends.apply(null, arguments);
}
function $c3aca08c2a74646e$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
const $c3aca08c2a74646e$var$defaultMethod = "get";
const $c3aca08c2a74646e$var$defaultEncType = "application/x-www-form-urlencoded";
function $c3aca08c2a74646e$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $c3aca08c2a74646e$var$isButtonElement(object) {
    return $c3aca08c2a74646e$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $c3aca08c2a74646e$var$isFormElement(object) {
    return $c3aca08c2a74646e$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $c3aca08c2a74646e$var$isInputElement(object) {
    return $c3aca08c2a74646e$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $c3aca08c2a74646e$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $c3aca08c2a74646e$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$c3aca08c2a74646e$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $c3aca08c2a74646e$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $c3aca08c2a74646e$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $c3aca08c2a74646e$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $c3aca08c2a74646e$var$_formDataSupportsSubmitter = null;
function $c3aca08c2a74646e$var$isFormDataSubmitterSupported() {
    if ($c3aca08c2a74646e$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $c3aca08c2a74646e$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $c3aca08c2a74646e$var$_formDataSupportsSubmitter = true;
    }
    return $c3aca08c2a74646e$var$_formDataSupportsSubmitter;
}
const $c3aca08c2a74646e$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $c3aca08c2a74646e$var$getFormEncType(encType) {
    if (encType != null && !$c3aca08c2a74646e$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $c3aca08c2a74646e$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($c3aca08c2a74646e$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $a0511682ed8967d7$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $c3aca08c2a74646e$var$defaultMethod;
        encType = $c3aca08c2a74646e$var$getFormEncType(target.getAttribute("enctype")) || $c3aca08c2a74646e$var$defaultEncType;
        formData = new FormData(target);
    } else if ($c3aca08c2a74646e$var$isButtonElement(target) || $c3aca08c2a74646e$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $a0511682ed8967d7$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $c3aca08c2a74646e$var$defaultMethod;
        encType = $c3aca08c2a74646e$var$getFormEncType(target.getAttribute("formenctype")) || $c3aca08c2a74646e$var$getFormEncType(form.getAttribute("enctype")) || $c3aca08c2a74646e$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$c3aca08c2a74646e$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($c3aca08c2a74646e$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $c3aca08c2a74646e$var$defaultMethod;
        action = null;
        encType = $c3aca08c2a74646e$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $c3aca08c2a74646e$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $c3aca08c2a74646e$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $c3aca08c2a74646e$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $c3aca08c2a74646e$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $c3aca08c2a74646e$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $c3aca08c2a74646e$export$1f3f55432a00e06d(routes, opts) {
    return (0, $a0511682ed8967d7$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $c3aca08c2a74646e$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $a0511682ed8967d7$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $c3aca08c2a74646e$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $ebc812b73151cba1$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $c3aca08c2a74646e$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $a0511682ed8967d7$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $c3aca08c2a74646e$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $a0511682ed8967d7$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $c3aca08c2a74646e$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $ebc812b73151cba1$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $c3aca08c2a74646e$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $c3aca08c2a74646e$var$_extends({}, state, {
        errors: $c3aca08c2a74646e$var$deserializeErrors(state.errors)
    });
    return state;
}
function $c3aca08c2a74646e$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $a0511682ed8967d7$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $c3aca08c2a74646e$export$7ad602f0e94e62d1 = /*#__PURE__*/ $lCzvA.createContext({
    isTransitioning: false
});
const $c3aca08c2a74646e$export$148fd98d095596d4 = /*#__PURE__*/ $lCzvA.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $c3aca08c2a74646e$var$START_TRANSITION = "startTransition";
const $c3aca08c2a74646e$var$startTransitionImpl = $lCzvA[$c3aca08c2a74646e$var$START_TRANSITION];
const $c3aca08c2a74646e$var$FLUSH_SYNC = "flushSync";
const $c3aca08c2a74646e$var$flushSyncImpl = $dAQd3[$c3aca08c2a74646e$var$FLUSH_SYNC];
const $c3aca08c2a74646e$var$USE_ID = "useId";
const $c3aca08c2a74646e$var$useIdImpl = $lCzvA[$c3aca08c2a74646e$var$USE_ID];
function $c3aca08c2a74646e$var$startTransitionSafe(cb) {
    if ($c3aca08c2a74646e$var$startTransitionImpl) $c3aca08c2a74646e$var$startTransitionImpl(cb);
    else cb();
}
function $c3aca08c2a74646e$var$flushSyncSafe(cb) {
    if ($c3aca08c2a74646e$var$flushSyncImpl) $c3aca08c2a74646e$var$flushSyncImpl(cb);
    else cb();
}
class $c3aca08c2a74646e$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $c3aca08c2a74646e$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $lCzvA.useState(router.state);
    let [pendingState, setPendingState] = $lCzvA.useState();
    let [vtContext, setVtContext] = $lCzvA.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $lCzvA.useState();
    let [transition, setTransition] = $lCzvA.useState();
    let [interruption, setInterruption] = $lCzvA.useState();
    let fetcherData = $lCzvA.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $lCzvA.useCallback((cb)=>{
        if (v7_startTransition) $c3aca08c2a74646e$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $lCzvA.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $c3aca08c2a74646e$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $c3aca08c2a74646e$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $c3aca08c2a74646e$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $c3aca08c2a74646e$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $c3aca08c2a74646e$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $lCzvA.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $lCzvA.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $c3aca08c2a74646e$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $lCzvA.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $lCzvA.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $lCzvA.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $lCzvA.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $lCzvA.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $lCzvA.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $lCzvA.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $lCzvA.useEffect(()=>(0, $ebc812b73151cba1$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $lCzvA.createElement($lCzvA.Fragment, null, /*#__PURE__*/ $lCzvA.createElement((0, $ebc812b73151cba1$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $lCzvA.createElement((0, $ebc812b73151cba1$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $lCzvA.createElement($c3aca08c2a74646e$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $lCzvA.createElement($c3aca08c2a74646e$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $lCzvA.createElement((0, $ebc812b73151cba1$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $lCzvA.createElement($c3aca08c2a74646e$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $c3aca08c2a74646e$var$MemoizedDataRoutes = /*#__PURE__*/ $lCzvA.memo($c3aca08c2a74646e$var$DataRoutes);
function $c3aca08c2a74646e$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $ebc812b73151cba1$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $c3aca08c2a74646e$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $lCzvA.useRef();
    if (historyRef.current == null) historyRef.current = (0, $a0511682ed8967d7$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $lCzvA.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $lCzvA.useCallback((newState)=>{
        v7_startTransition && $c3aca08c2a74646e$var$startTransitionImpl ? $c3aca08c2a74646e$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $lCzvA.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $lCzvA.useEffect(()=>(0, $ebc812b73151cba1$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $lCzvA.createElement((0, $ebc812b73151cba1$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $c3aca08c2a74646e$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $lCzvA.useRef();
    if (historyRef.current == null) historyRef.current = (0, $a0511682ed8967d7$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $lCzvA.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $lCzvA.useCallback((newState)=>{
        v7_startTransition && $c3aca08c2a74646e$var$startTransitionImpl ? $c3aca08c2a74646e$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $lCzvA.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $lCzvA.useEffect(()=>(0, $ebc812b73151cba1$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $lCzvA.createElement((0, $ebc812b73151cba1$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $c3aca08c2a74646e$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $lCzvA.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $lCzvA.useCallback((newState)=>{
        v7_startTransition && $c3aca08c2a74646e$var$startTransitionImpl ? $c3aca08c2a74646e$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $lCzvA.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $lCzvA.useEffect(()=>(0, $ebc812b73151cba1$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $lCzvA.createElement((0, $ebc812b73151cba1$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $c3aca08c2a74646e$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $c3aca08c2a74646e$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $c3aca08c2a74646e$export$a6c7ac8248d6e38a = /*#__PURE__*/ $lCzvA.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $c3aca08c2a74646e$var$_objectWithoutPropertiesLoose(_ref7, $c3aca08c2a74646e$var$_excluded);
    let { basename: basename } = $lCzvA.useContext((0, $ebc812b73151cba1$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $c3aca08c2a74646e$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($c3aca08c2a74646e$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $a0511682ed8967d7$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $ebc812b73151cba1$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $c3aca08c2a74646e$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $lCzvA.createElement("a", $c3aca08c2a74646e$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $c3aca08c2a74646e$export$b0d92dbee9b5b60d = /*#__PURE__*/ $lCzvA.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $c3aca08c2a74646e$var$_objectWithoutPropertiesLoose(_ref8, $c3aca08c2a74646e$var$_excluded2);
    let path = (0, $ebc812b73151cba1$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $ebc812b73151cba1$export$45d76561a5302f2b)();
    let routerState = $lCzvA.useContext((0, $ebc812b73151cba1$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $lCzvA.useContext((0, $ebc812b73151cba1$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $c3aca08c2a74646e$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $a0511682ed8967d7$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $lCzvA.createElement($c3aca08c2a74646e$export$a6c7ac8248d6e38a, $c3aca08c2a74646e$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $c3aca08c2a74646e$export$a7fed597f4b8afd8 = /*#__PURE__*/ $lCzvA.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $c3aca08c2a74646e$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $c3aca08c2a74646e$var$_objectWithoutPropertiesLoose(_ref9, $c3aca08c2a74646e$var$_excluded3);
    let submit = $c3aca08c2a74646e$export$47c85c6e3a081d3();
    let formAction = $c3aca08c2a74646e$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $lCzvA.createElement("form", $c3aca08c2a74646e$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $c3aca08c2a74646e$export$11aac1aab828f1fa(_ref0) {
    let { getKey: getKey, storageKey: storageKey } = _ref0;
    $c3aca08c2a74646e$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $c3aca08c2a74646e$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($c3aca08c2a74646e$var$DataRouterHook || ($c3aca08c2a74646e$var$DataRouterHook = {}));
var $c3aca08c2a74646e$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($c3aca08c2a74646e$var$DataRouterStateHook || ($c3aca08c2a74646e$var$DataRouterStateHook = {}));
// Internal hooks
function $c3aca08c2a74646e$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $c3aca08c2a74646e$var$useDataRouterContext(hookName) {
    let ctx = $lCzvA.useContext((0, $ebc812b73151cba1$export$3add0d5dce533e2e));
    !ctx && (0, $a0511682ed8967d7$export$3e9cee6b33872309)(false);
    return ctx;
}
function $c3aca08c2a74646e$var$useDataRouterState(hookName) {
    let state = $lCzvA.useContext((0, $ebc812b73151cba1$export$145dfa71566a64dc));
    !state && (0, $a0511682ed8967d7$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $c3aca08c2a74646e$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $ebc812b73151cba1$export$9770f232ac06a008)();
    let location = (0, $ebc812b73151cba1$export$45d76561a5302f2b)();
    let path = (0, $ebc812b73151cba1$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $lCzvA.useCallback((event)=>{
        if ($c3aca08c2a74646e$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $a0511682ed8967d7$export$fe53371bee54353d)(location) === (0, $a0511682ed8967d7$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $c3aca08c2a74646e$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $lCzvA.useRef($c3aca08c2a74646e$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $lCzvA.useRef(false);
    let location = (0, $ebc812b73151cba1$export$45d76561a5302f2b)();
    let searchParams = $lCzvA.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $c3aca08c2a74646e$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $ebc812b73151cba1$export$9770f232ac06a008)();
    let setSearchParams = $lCzvA.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $c3aca08c2a74646e$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $c3aca08c2a74646e$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $c3aca08c2a74646e$var$fetcherId = 0;
let $c3aca08c2a74646e$var$getUniqueFetcherId = ()=>"__" + String(++$c3aca08c2a74646e$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $c3aca08c2a74646e$export$47c85c6e3a081d3() {
    let { router: router } = $c3aca08c2a74646e$var$useDataRouterContext($c3aca08c2a74646e$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $lCzvA.useContext((0, $ebc812b73151cba1$export$26749e8557646306));
    let currentRouteId = (0, $ebc812b73151cba1$export$5fc8298006ad9e58)();
    return $lCzvA.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $c3aca08c2a74646e$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $c3aca08c2a74646e$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $c3aca08c2a74646e$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $c3aca08c2a74646e$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $lCzvA.useContext((0, $ebc812b73151cba1$export$26749e8557646306));
    let routeContext = $lCzvA.useContext((0, $ebc812b73151cba1$export$9072aa6dd1f93057));
    !routeContext && (0, $a0511682ed8967d7$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $c3aca08c2a74646e$var$_extends({}, (0, $ebc812b73151cba1$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $ebc812b73151cba1$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $a0511682ed8967d7$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $a0511682ed8967d7$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $c3aca08c2a74646e$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $c3aca08c2a74646e$var$useDataRouterContext($c3aca08c2a74646e$var$DataRouterHook.UseFetcher);
    let state = $c3aca08c2a74646e$var$useDataRouterState($c3aca08c2a74646e$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $lCzvA.useContext($c3aca08c2a74646e$export$148fd98d095596d4);
    let route = $lCzvA.useContext((0, $ebc812b73151cba1$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $a0511682ed8967d7$export$3e9cee6b33872309)(false);
    !route && (0, $a0511682ed8967d7$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $a0511682ed8967d7$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $c3aca08c2a74646e$var$useIdImpl ? $c3aca08c2a74646e$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $lCzvA.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($c3aca08c2a74646e$var$getUniqueFetcherId());
    // Registration/cleanup
    $lCzvA.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $lCzvA.useCallback((href, opts)=>{
        !routeId && (0, $a0511682ed8967d7$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $c3aca08c2a74646e$export$47c85c6e3a081d3();
    let submit = $lCzvA.useCallback((target, opts)=>{
        submitImpl(target, $c3aca08c2a74646e$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $lCzvA.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $lCzvA.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $lCzvA.createElement($c3aca08c2a74646e$export$a7fed597f4b8afd8, $c3aca08c2a74646e$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $a0511682ed8967d7$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $lCzvA.useMemo(()=>$c3aca08c2a74646e$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $c3aca08c2a74646e$export$fa996778a3a31087() {
    let state = $c3aca08c2a74646e$var$useDataRouterState($c3aca08c2a74646e$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref1)=>{
        let [key, fetcher] = _ref1;
        return $c3aca08c2a74646e$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $c3aca08c2a74646e$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $c3aca08c2a74646e$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $c3aca08c2a74646e$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $c3aca08c2a74646e$var$useDataRouterContext($c3aca08c2a74646e$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $c3aca08c2a74646e$var$useDataRouterState($c3aca08c2a74646e$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $lCzvA.useContext((0, $ebc812b73151cba1$export$26749e8557646306));
    let location = (0, $ebc812b73151cba1$export$45d76561a5302f2b)();
    let matches = (0, $ebc812b73151cba1$export$2378eb7f5ff86053)();
    let navigation = (0, $ebc812b73151cba1$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $lCzvA.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $c3aca08c2a74646e$var$usePageHide($lCzvA.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $c3aca08c2a74646e$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $c3aca08c2a74646e$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($c3aca08c2a74646e$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $lCzvA.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $c3aca08c2a74646e$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $c3aca08c2a74646e$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $lCzvA.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($c3aca08c2a74646e$var$_extends({}, location, {
                    pathname: (0, $a0511682ed8967d7$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($c3aca08c2a74646e$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $lCzvA.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $c3aca08c2a74646e$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $lCzvA.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $c3aca08c2a74646e$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $lCzvA.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $c3aca08c2a74646e$export$39f4eb3dbd812741(_ref10) {
    let { when: when, message: message } = _ref10;
    let blocker = (0, $ebc812b73151cba1$export$b273b3273281a049)(when);
    $lCzvA.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $lCzvA.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $c3aca08c2a74646e$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $lCzvA.useContext($c3aca08c2a74646e$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $a0511682ed8967d7$export$3e9cee6b33872309)(false);
    let { basename: basename } = $c3aca08c2a74646e$var$useDataRouterContext($c3aca08c2a74646e$var$DataRouterHook.useViewTransitionState);
    let path = (0, $ebc812b73151cba1$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $a0511682ed8967d7$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $a0511682ed8967d7$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $a0511682ed8967d7$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $a0511682ed8967d7$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}


var $954b04773eb0508c$export$df9a5fb346e7c0bb = /*#__PURE__*/ $lCzvA.createContext(null);
var $954b04773eb0508c$export$2ae4a19e09ca9a00 = function useOktaAuth() {
    return $lCzvA.useContext($954b04773eb0508c$export$df9a5fb346e7c0bb);
};
var $954b04773eb0508c$var$OktaError = function OktaError(_ref) {
    var error = _ref.error;
    if (error.name && error.message) return /*#__PURE__*/ $lCzvA.createElement("p", null, error.name, ": ", error.message);
    return /*#__PURE__*/ $lCzvA.createElement("p", null, "Error: ", error.toString());
};
var $954b04773eb0508c$export$9fb697de7778c436 = function Security(_ref) {
    var oktaAuth = _ref.oktaAuth, restoreOriginalUri = _ref.restoreOriginalUri, onAuthRequired = _ref.onAuthRequired, children = _ref.children;
    var _React$useState = $lCzvA.useState(function() {
        if (!oktaAuth) return null;
        return oktaAuth.authStateManager.getAuthState();
    }), _React$useState2 = (0, $d841112d45ccda4f$export$2e2bcd8739ae039)(_React$useState, 2), authState = _React$useState2[0], setAuthState = _React$useState2[1];
    $lCzvA.useEffect(function() {
        if (!oktaAuth || !restoreOriginalUri) return;
        if (oktaAuth.options.restoreOriginalUri) console.warn('Two custom restoreOriginalUri callbacks are detected. The one from the OktaAuth configuration will be overridden by the provided restoreOriginalUri prop from the Security component.');
        oktaAuth.options.restoreOriginalUri = /*#__PURE__*/ function() {
            var _ref2 = (0, $aa334e3d194e1887$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a0061d920c204c4d$exports))).mark(function _callee(oktaAuth, originalUri) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($a0061d920c204c4d$exports))).wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            return _context.abrupt("return", restoreOriginalUri(oktaAuth, originalUri));
                        case 1:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }));
            return function(_x, _x2) {
                return _ref2.apply(this, arguments);
            };
        }();
    }, []);
    $lCzvA.useEffect(function() {
        if (!oktaAuth) return;
        if (oktaAuth._oktaUserAgent) oktaAuth._oktaUserAgent.addEnvironment("@okta/okta-react".concat("/", "6.11.0"));
        else console.warn('_oktaUserAgent is not available on auth SDK instance. Please use okta-auth-js@^5.3.1 .');
        var currentAuthState = oktaAuth.authStateManager.getAuthState();
        if (currentAuthState !== authState) setAuthState(currentAuthState);
        var handler = function handler(authState) {
            setAuthState(authState);
        };
        oktaAuth.authStateManager.subscribe(handler);
        oktaAuth.start();
        return function() {
            oktaAuth.authStateManager.unsubscribe(handler);
        };
    }, [
        oktaAuth
    ]);
    var oktaContextValue = $lCzvA.useMemo(function() {
        return {
            oktaAuth: oktaAuth,
            authState: authState,
            _onAuthRequired: onAuthRequired
        };
    }, [
        oktaAuth,
        authState,
        onAuthRequired
    ]);
    if (!oktaAuth) {
        var err = new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('No oktaAuth instance passed to Security Component.');
        return /*#__PURE__*/ $lCzvA.createElement($954b04773eb0508c$var$OktaError, {
            error: err
        });
    }
    if (!restoreOriginalUri) {
        var _err = new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('No restoreOriginalUri callback passed to Security Component.');
        return /*#__PURE__*/ $lCzvA.createElement($954b04773eb0508c$var$OktaError, {
            error: _err
        });
    }
    if (!oktaAuth._oktaUserAgent) console.warn('_oktaUserAgent is not available on auth SDK instance. Please use okta-auth-js@^5.3.1 .');
    else {
        var isAuthJsSupported = (0, $36c46bc4813033e5$export$398604a469f7de9a)(oktaAuth._oktaUserAgent.getVersion(), "5.3.1", '>=');
        if (!isAuthJsSupported) {
            var _err2 = new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)("\n        Passed in oktaAuth is not compatible with the SDK,\n        minimum supported okta-auth-js version is ".concat("5.3.1", ".\n      "));
            return /*#__PURE__*/ $lCzvA.createElement($954b04773eb0508c$var$OktaError, {
                error: _err2
            });
        }
    }
    return /*#__PURE__*/ $lCzvA.createElement($954b04773eb0508c$export$df9a5fb346e7c0bb.Provider, {
        value: oktaContextValue
    }, children);
};
function $954b04773eb0508c$var$ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $954b04773eb0508c$var$_objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $954b04773eb0508c$var$ownKeys$1(Object(source), !0).forEach(function(key) {
            (0, $b227c6eab5af31a1$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $954b04773eb0508c$var$ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $954b04773eb0508c$export$683729e5315f529b = function withOktaAuth(ComponentToWrap) {
    var WrappedComponent = function WrappedComponent(props) {
        var oktaAuthProps = $954b04773eb0508c$export$2ae4a19e09ca9a00();
        return /*#__PURE__*/ $lCzvA.createElement(ComponentToWrap, $954b04773eb0508c$var$_objectSpread$1($954b04773eb0508c$var$_objectSpread$1({}, oktaAuthProps), props));
    };
    WrappedComponent.displayName = 'withOktaAuth_' + (ComponentToWrap.displayName || ComponentToWrap.name);
    return WrappedComponent;
};
var $954b04773eb0508c$var$handledRedirect = false;
var $954b04773eb0508c$export$8f938467209eea73 = function LoginCallback(_ref) {
    var errorComponent = _ref.errorComponent, _ref$loadingElement = _ref.loadingElement, loadingElement = _ref$loadingElement === void 0 ? null : _ref$loadingElement, onAuthResume = _ref.onAuthResume;
    var _useOktaAuth = $954b04773eb0508c$export$2ae4a19e09ca9a00(), oktaAuth = _useOktaAuth.oktaAuth, authState = _useOktaAuth.authState;
    var _React$useState = $lCzvA.useState(null), _React$useState2 = (0, $d841112d45ccda4f$export$2e2bcd8739ae039)(_React$useState, 2), callbackError = _React$useState2[0], setCallbackError = _React$useState2[1];
    var ErrorReporter = errorComponent || $954b04773eb0508c$var$OktaError;
    $lCzvA.useEffect(function() {
        var isInteractionRequired = oktaAuth.idx.isInteractionRequired || oktaAuth.isInteractionRequired.bind(oktaAuth);
        if (onAuthResume && isInteractionRequired()) {
            onAuthResume();
            return;
        }
        if (!$954b04773eb0508c$var$handledRedirect) {
            oktaAuth.handleLoginRedirect()["catch"](function(e) {
                setCallbackError(e);
            });
            $954b04773eb0508c$var$handledRedirect = true;
        }
    }, [
        oktaAuth
    ]);
    var authError = authState === null || authState === void 0 ? void 0 : authState.error;
    var displayError = callbackError || authError;
    if (displayError) return /*#__PURE__*/ $lCzvA.createElement(ErrorReporter, {
        error: displayError
    });
    return loadingElement;
};
var $954b04773eb0508c$var$_excluded = [
    "onAuthRequired",
    "errorComponent"
];
function $954b04773eb0508c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $954b04773eb0508c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $954b04773eb0508c$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $b227c6eab5af31a1$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $954b04773eb0508c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $954b04773eb0508c$var$useMatch;
if ('useRouteMatch' in $c3aca08c2a74646e$exports) $954b04773eb0508c$var$useMatch = $c3aca08c2a74646e$exports['useRouteMatch' in $c3aca08c2a74646e$exports ? 'useRouteMatch' : ''];
else $954b04773eb0508c$var$useMatch = function useMatch() {
    throw new (0, $93cffcad0e5ff768$export$2e2bcd8739ae039)('Unsupported: SecureRoute only works with react-router-dom v5 or any router library with compatible APIs. See examples under the "samples" folder for how to implement your own custom SecureRoute Component.');
};
var $954b04773eb0508c$export$d93cdd50e579241c = function SecureRoute(_ref) {
    var onAuthRequired = _ref.onAuthRequired, errorComponent = _ref.errorComponent, routeProps = (0, $859292cc73aee303$export$2e2bcd8739ae039)(_ref, $954b04773eb0508c$var$_excluded);
    var _useOktaAuth = $954b04773eb0508c$export$2ae4a19e09ca9a00(), oktaAuth = _useOktaAuth.oktaAuth, authState = _useOktaAuth.authState, _onAuthRequired = _useOktaAuth._onAuthRequired;
    var match = $954b04773eb0508c$var$useMatch(routeProps);
    var pendingLogin = $lCzvA.useRef(false);
    var _React$useState = $lCzvA.useState(null), _React$useState2 = (0, $d841112d45ccda4f$export$2e2bcd8739ae039)(_React$useState, 2), handleLoginError = _React$useState2[0], setHandleLoginError = _React$useState2[1];
    var ErrorReporter = errorComponent || $954b04773eb0508c$var$OktaError;
    $lCzvA.useEffect(function() {
        var handleLogin = /*#__PURE__*/ function() {
            var _ref2 = (0, $aa334e3d194e1887$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a0061d920c204c4d$exports))).mark(function _callee() {
                var originalUri, onAuthRequiredFn;
                return (0, (/*@__PURE__*/$parcel$interopDefault($a0061d920c204c4d$exports))).wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            if (!pendingLogin.current) {
                                _context.next = 2;
                                break;
                            }
                            return _context.abrupt("return");
                        case 2:
                            pendingLogin.current = true;
                            originalUri = (0, $47114d36cb1410d5$export$4ebdca5513a016fe)(window.location.href, window.location.origin);
                            oktaAuth.setOriginalUri(originalUri);
                            onAuthRequiredFn = onAuthRequired || _onAuthRequired;
                            if (!onAuthRequiredFn) {
                                _context.next = 11;
                                break;
                            }
                            _context.next = 9;
                            return onAuthRequiredFn(oktaAuth);
                        case 9:
                            _context.next = 13;
                            break;
                        case 11:
                            _context.next = 13;
                            return oktaAuth.signInWithRedirect();
                        case 13:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }));
            return function handleLogin() {
                return _ref2.apply(this, arguments);
            };
        }();
        if (!match) return;
        if (!authState) return;
        if (authState.isAuthenticated) {
            pendingLogin.current = false;
            return;
        }
        if (!authState.isAuthenticated) handleLogin()["catch"](function(err) {
            setHandleLoginError(err);
        });
    }, [
        authState,
        oktaAuth,
        match,
        onAuthRequired,
        _onAuthRequired
    ]);
    if (handleLoginError) return /*#__PURE__*/ $lCzvA.createElement(ErrorReporter, {
        error: handleLoginError
    });
    if (!authState || !authState.isAuthenticated) return null;
    return /*#__PURE__*/ $lCzvA.createElement($c3aca08c2a74646e$exports.Route, $954b04773eb0508c$var$_objectSpread({}, routeProps));
};




/**
 * Application constants.
 * @type {Local.AppConstants}
 */ const $69cb03e609be8e5e$export$a002182e51710d39 = {
    AppName: 'Production Request',
    PostLogoutRoute: '/'
};
const $69cb03e609be8e5e$export$2c9aa90e6f9262f3 = {
    issuer: window.REACT_APP_OKTA_ISSUER ?? undefined,
    clientId: window.REACT_APP_OKTA_CLIENTID ?? undefined,
    redirectUri: `${window.location.origin}/login/callback`,
    scopes: [
        'openid',
        'profile',
        'email',
        'offline_access',
        'ApiGw.teammembers',
        'ApiGw.appl-user',
        'ApiGw.app-analytics',
        'ApiGw.ebs-api',
        'ebs_customer_read',
        'ebs_customer_write',
        'ApiGw.production-request',
        'production_request_read',
        'production_request_write'
    ],
    pkce: true,
    disableHttpsCheck: window.OKTA_TESTING_DISABLEHTTPSCHECK || false,
    postLogoutRedirectUri: `${window.location.origin}/logout`
};
const $69cb03e609be8e5e$export$367ea9b952380ab7 = [
    {
        name: 'DEV',
        instanceID: 'EBSDEV'
    },
    {
        name: 'DEV2',
        instanceID: 'EBSDEV2'
    },
    {
        name: 'DEV3',
        instanceID: 'EBSDEV3'
    },
    {
        name: 'DEV4',
        instanceID: 'EBSDEV4'
    },
    {
        name: 'DEV5',
        instanceID: 'EBSDEV5'
    },
    {
        name: 'DEV6',
        instanceID: 'EBSDEV6'
    }
];
const $69cb03e609be8e5e$export$40edfb7eeb78c4e8 = window.REACT_APP_API_URL?.includes('apidev');


//#region src/timeoutManager.ts
const $0aef9398d65c5c0f$export$d235812f9125bf47 = {
    setTimeout: (callback, delay)=>setTimeout(callback, delay),
    clearTimeout: (timeoutId)=>clearTimeout(timeoutId),
    setInterval: (callback, delay)=>setInterval(callback, delay),
    clearInterval: (intervalId)=>clearInterval(intervalId)
};
/**
* Allows customization of how timeouts are created.
*
* `@tanstack/query-core` makes liberal use of timeouts to implement `staleTime`
* and `gcTime`. The default TimeoutManager provider uses the platform's global
* `setTimeout` implementation, which is known to have scalability issues with
* thousands of timeouts on the event loop.
*
* If you hit this limitation, consider providing a custom TimeoutProvider that
* coalesces timeouts.
*/ var $0aef9398d65c5c0f$export$6336d90323f0ab52 = class {
    #provider = $0aef9398d65c5c0f$export$d235812f9125bf47;
    #providerCalled = false;
    /**
	* `setTimeoutProvider` can be used to set a custom implementation of the
	* `setTimeout`, `clearTimeout`, `setInterval`, `clearInterval` functions,
	* called a `TimeoutProvider`.
	*
	* This may be useful if you notice event loop performance issues with
	* thousands of queries. A custom TimeoutProvider could also support timer
	* delays longer than the global `setTimeout` maximum delay value of about
	* 24 days.
	*
	* It is important to call `setTimeoutProvider` before creating a
	* QueryClient or queries, so that the same provider is used consistently
	* for all timers in the application, since different TimeoutProviders
	* cannot cancel each others' timers.
	* @param provider - The `TimeoutProvider` to use for all timers from now on.
	* @example
	* ```ts
	* import { timeoutManager, QueryClient } from '@tanstack/query-core'
	* import { CustomTimeoutProvider } from './CustomTimeoutProvider'
	*
	* timeoutManager.setTimeoutProvider(new CustomTimeoutProvider())
	*
	* export const queryClient = new QueryClient()
	* ```
	*/ setTimeoutProvider(provider) {
        this.#provider = provider;
    }
    /**
	* `setTimeout` schedules a callback to run after approximately `delay`
	* milliseconds, like the global `setTimeout` function. The callback can be
	* canceled with `clearTimeout`.
	*
	* It returns a timer ID, which may be a number or an object that can be
	* coerced to a number via `Symbol.toPrimitive`.
	* @param callback - The function to call when the timeout elapses.
	* @param delay - The time to wait before calling `callback`, in milliseconds.
	* @returns The timer ID, to pass to {@link TimeoutManager#clearTimeout}.
	* @example
	* ```ts
	* import { timeoutManager } from '@tanstack/query-core'
	*
	* const timeoutId = timeoutManager.setTimeout(
	*   () => console.log('ran at:', new Date()),
	*   1000,
	* )
	*
	* const timeoutIdNumber: number = Number(timeoutId)
	* ```
	*/ setTimeout(callback, delay) {
        return this.#provider.setTimeout(callback, delay);
    }
    /**
	* `clearTimeout` cancels a timeout callback scheduled with `setTimeout`,
	* like the global `clearTimeout` function. It should be called with a
	* timer ID returned by `setTimeout`.
	* @param timeoutId - The timer ID returned by `setTimeout`, or `undefined`.
	* @example
	* ```ts
	* import { timeoutManager } from '@tanstack/query-core'
	*
	* const timeoutId = timeoutManager.setTimeout(
	*   () => console.log('ran at:', new Date()),
	*   1000,
	* )
	*
	* timeoutManager.clearTimeout(timeoutId)
	* ```
	*/ clearTimeout(timeoutId) {
        this.#provider.clearTimeout(timeoutId);
    }
    /**
	* `setInterval` schedules a callback to be called approximately every
	* `delay` milliseconds, like the global `setInterval` function.
	*
	* Like `setTimeout`, it returns a timer ID, which may be a number or an
	* object that can be coerced to a number via `Symbol.toPrimitive`.
	* @param callback - The function to call on every interval.
	* @param delay - The time between calls, in milliseconds.
	* @returns The timer ID, to pass to {@link TimeoutManager#clearInterval}.
	* @example
	* ```ts
	* import { timeoutManager } from '@tanstack/query-core'
	*
	* const intervalId = timeoutManager.setInterval(
	*   () => console.log('ran at:', new Date()),
	*   1000,
	* )
	* ```
	*/ setInterval(callback, delay) {
        return this.#provider.setInterval(callback, delay);
    }
    /**
	* `clearInterval` can be used to cancel an interval, like the global
	* `clearInterval` function. It should be called with an interval ID
	* returned by `setInterval`.
	* @param intervalId - The timer ID returned by `setInterval`, or `undefined`.
	* @example
	* ```ts
	* import { timeoutManager } from '@tanstack/query-core'
	*
	* const intervalId = timeoutManager.setInterval(
	*   () => console.log('ran at:', new Date()),
	*   1000,
	* )
	*
	* timeoutManager.clearInterval(intervalId)
	* ```
	*/ clearInterval(intervalId) {
        this.#provider.clearInterval(intervalId);
    }
};
/**
* Singleton instance of {@link TimeoutManager}, used throughout TanStack Query to schedule and cancel timers.
*/ const $0aef9398d65c5c0f$export$94a2700736e69372 = new $0aef9398d65c5c0f$export$6336d90323f0ab52();
/**
* In many cases code wants to delay to the next event loop tick; this is not
* mediated by {@link timeoutManager}.
*
* This function is provided to make auditing the `tanstack/query-core` for
* incorrect use of system `setTimeout` easier.
* @param callback - The function to call on the next event loop tick.
*/ function $0aef9398d65c5c0f$export$5086591e51e32a18(callback) {
    setTimeout(callback, 0);
}


//#region src/utils.ts
/**
* @deprecated use `environmentManager.isServer()` instead.
*/ const $d14a518110a15ba8$export$6acf61af03e62db = typeof window === "undefined" || "Deno" in globalThis;
function $d14a518110a15ba8$export$8793edee2d425525() {}
/**
* Resolves an {@link Updater}: calls it with `input` if it is a function, otherwise returns it as
* is.
* @param updater - The new value, or a function that receives `input` and returns the new value.
* @param input - The current value, passed to `updater` if it is a function.
* @returns The new value.
*/ function $d14a518110a15ba8$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
/**
* Checks whether a value can be used as a timeout: a non-negative, finite number.
* @param value - The value to check.
* @returns `true` if `value` is a number that is `>= 0` and not `Infinity`.
*/ function $d14a518110a15ba8$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
/**
* Calculates how long until data updated at `updatedAt` becomes stale.
* @param updatedAt - The timestamp, in milliseconds, at which the data was last updated.
* @param staleTime - The time, in milliseconds, after which data is considered stale. Defaults to
* `0`.
* @returns The remaining time in milliseconds, or `0` if the data is already stale.
*/ function $d14a518110a15ba8$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
/**
* Resolves an option that can be given either as a value or as a function of the query, such as
* `staleTime`.
* @param value - The option value, or a function that receives `query` and returns the value.
* @param query - The query passed to `value` if it is a function.
* @returns The resolved value, or `undefined` if `value` is `undefined`.
*/ function $d14a518110a15ba8$export$e36731f6aa6a4362(value, query) {
    return typeof value === "function" ? value(query) : value;
}
/**
* Checks whether a query matches the given {@link QueryFilters}.
* Every filter that is specified must match; filters that are left unspecified are ignored.
* @param filters - The filters to check the query against.
* @param query - The query to check.
* @returns `true` if the query matches every specified filter.
* @example
* ```ts
* const queryCache = queryClient.getQueryCache()
*
* const matchingQueries = queryCache
*   .getAll()
*   .filter((query) => matchQuery({ queryKey: ['posts'] }, query))
* ```
*/ function $d14a518110a15ba8$export$c5d1efe363797780(filters, query) {
    const { type: type = "all", exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if (queryKey) {
        if (exact) {
            if (query.queryHash !== $d14a518110a15ba8$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$d14a518110a15ba8$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (fetchStatus && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
/**
* Checks whether a mutation matches the given {@link MutationFilters}.
* Every filter that is specified must match; filters that are left unspecified are ignored.
* If a `mutationKey` filter is provided but the mutation has no `mutationKey` of its own, it does not match.
* @param filters - The filters to check the mutation against.
* @param mutation - The mutation to check.
* @returns `true` if the mutation matches every specified filter.
* @example
* ```ts
* const mutationCache = queryClient.getMutationCache()
*
* const matchingMutations = mutationCache
*   .getAll()
*   .filter((mutation) => matchMutation({ mutationKey: ['addPost'] }, mutation))
* ```
*/ function $d14a518110a15ba8$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, status: status, predicate: predicate, mutationKey: mutationKey } = filters;
    if (mutationKey) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($d14a518110a15ba8$export$1e87d19d4aab5805(mutation.options.mutationKey) !== $d14a518110a15ba8$export$1e87d19d4aab5805(mutationKey)) return false;
        } else if (!$d14a518110a15ba8$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (status && mutation.state.status !== status) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
/**
* Hashes a query key with the query's `queryKeyHashFn` option, falling back to {@link hashKey}.
* @param queryKey - The query key to hash.
* @param options - The query options that may provide a custom `queryKeyHashFn`.
* @returns The query hash, a string that identifies the query in the cache.
*/ function $d14a518110a15ba8$export$cc90ca97bc0d73fd(queryKey, options) {
    return (options?.queryKeyHashFn || $d14a518110a15ba8$export$1e87d19d4aab5805)(queryKey);
}
/**
* Default query & mutation keys hash function.
* Hashes the value into a stable hash.
* @param queryKey - The query or mutation key to hash.
* @returns The stable hash of the key, as a JSON string.
* @example
* ```ts
* // Object keys are sorted, so key order doesn't affect the hash:
* hashKey(['todos', { page: 1, filter: 'done' }]) // === '["todos",{"filter":"done","page":1}]'
* ```
*/ function $d14a518110a15ba8$export$1e87d19d4aab5805(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$d14a518110a15ba8$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
function $d14a518110a15ba8$export$2f07189bb9fa26a7(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") {
        if (Array.isArray(a) && Array.isArray(b)) {
            if (b.length > a.length) return false;
            for(let i = 0; i < b.length; i++)if (!$d14a518110a15ba8$export$2f07189bb9fa26a7(a[i], b[i])) return false;
            return true;
        }
        const bKeys = Object.keys(b);
        for (const key of bKeys)if (!$d14a518110a15ba8$export$2f07189bb9fa26a7(a[key], b[key])) return false;
        return true;
    }
    return false;
}
const $d14a518110a15ba8$var$hasOwn = Object.prototype.hasOwnProperty;
function $d14a518110a15ba8$export$77a71fc411098696(a, b, depth = 0) {
    if (a === b) return a;
    if (depth > 500) return b;
    const array = $d14a518110a15ba8$export$7a8558113332b71e(a) && $d14a518110a15ba8$export$7a8558113332b71e(b);
    if (!array && !($d14a518110a15ba8$export$53b83ca8eaab0383(a) && $d14a518110a15ba8$export$53b83ca8eaab0383(b))) return b;
    const aSize = (array ? a : Object.keys(a)).length;
    const bItems = array ? b : Object.keys(b);
    const bSize = bItems.length;
    const copy = array ? new Array(bSize) : {};
    let equalItems = 0;
    for(let i = 0; i < bSize; i++){
        const key = array ? i : bItems[i];
        const aItem = a[key];
        const bItem = b[key];
        if (aItem === bItem) {
            copy[key] = aItem;
            if (array ? i < aSize : $d14a518110a15ba8$var$hasOwn.call(a, key)) equalItems++;
            continue;
        }
        if (aItem === null || bItem === null || typeof aItem !== "object" || typeof bItem !== "object") {
            copy[key] = bItem;
            continue;
        }
        const v = $d14a518110a15ba8$export$77a71fc411098696(aItem, bItem, depth + 1);
        copy[key] = v;
        if (v === aItem) equalItems++;
    }
    return aSize === bSize && equalItems === aSize ? a : copy;
}
/**
* Shallow compare objects.
* @param a - The first object.
* @param b - The second object, or `undefined`.
* @returns `true` if both objects have the same keys, with strictly equal values for each key.
*/ function $d14a518110a15ba8$export$3e67810a3f0e9f1c(a, b) {
    if (!b || Object.keys(a).length !== Object.keys(b).length) return false;
    for(const key in a)if (a[key] !== b[key]) return false;
    return true;
}
/**
* Checks whether a value is an array with no holes and no extra properties.
* @param value - The value to check.
* @returns `true` if `value` is an array whose number of own keys equals its `length`.
*/ function $d14a518110a15ba8$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
}
/**
* Checks whether a value is a plain object, e.g. created with an object literal or
* `Object.create(null)`.
* @param o - The value to check.
* @returns `true` if `o` is a plain object.
*/ function $d14a518110a15ba8$export$53b83ca8eaab0383(o) {
    if (!$d14a518110a15ba8$var$hasObjectPrototype(o)) return false;
    const objectPrototype = Object.getPrototypeOf(o);
    const ctor = objectPrototype?.constructor;
    if (ctor === void 0) return true;
    if (typeof ctor !== "function") return false;
    const prot = ctor.prototype;
    if (!$d14a518110a15ba8$var$hasObjectPrototype(prot)) return false;
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
    if (objectPrototype !== Object.prototype) return false;
    return true;
}
/**
* Checks whether a value's `Object.prototype.toString` tag is `[object Object]`.
* @param o - The value to check.
* @returns `true` if the tag is `[object Object]`.
*/ function $d14a518110a15ba8$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
/**
* Waits for the given time, using the configured {@link timeoutManager}.
* @param timeout - The time to wait, in milliseconds.
* @returns A promise that resolves after `timeout` milliseconds.
*/ function $d14a518110a15ba8$export$e772c8ff12451969(timeout) {
    return new Promise((resolve)=>{
        (0, $0aef9398d65c5c0f$export$94a2700736e69372).setTimeout(resolve, timeout);
    });
}
/**
* Applies a query's `structuralSharing` option when writing new data.
* @param prevData - The previously cached data.
* @param data - The new data.
* @param options - The query options, whose `structuralSharing` decides how the data is merged.
* @returns The result of a custom `structuralSharing` function, `data` with its unchanged parts
* replaced by those of `prevData` by default, or `data` as is if `structuralSharing` is `false`.
* @throws {Error} The error from the default structural sharing, e.g. when the data is not JSON serializable.
* Outside production, it is also logged to the console.
*/ function $d14a518110a15ba8$export$17619bac5b909b23(prevData, data, options) {
    if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) {
        var error;
        return $d14a518110a15ba8$export$77a71fc411098696(prevData, data);
    }
    return data;
}
/**
* Intended to be passed as a query's `placeholderData` option, for example
* `placeholderData: keepPreviousData`. Instead of resetting the query's data to `undefined` while a new
* query key is fetching, it keeps displaying the previously fetched data until the new data arrives.
* @param previousData - The data of the previous query key, passed by the observer.
* @returns The previous data, unchanged.
* @example
* ```ts
* new QueryObserver(queryClient, {
*   queryKey: ['posts', page],
*   queryFn: () => fetchPosts(page),
*   placeholderData: keepPreviousData,
* })
* ```
*/ function $d14a518110a15ba8$export$f537417e7e421eac(previousData) {
    return previousData;
}
/**
* Returns a new array with `item` added at the end. If that makes the array longer than `max`,
* the first item is dropped. Only one item is dropped, so the result can still exceed `max` if
* `items` already did.
* @param items - The current items.
* @param item - The value to append.
* @param max - The length above which an item is dropped. `0` (the default) means no limit.
* @returns A new array with `item` added.
*/ function $d14a518110a15ba8$export$ccce65a22a26f2bc(items, item, max = 0) {
    const newItems = [
        ...items,
        item
    ];
    return max && newItems.length > max ? newItems.slice(1) : newItems;
}
/**
* Returns a new array with `item` added at the start. If that makes the array longer than `max`,
* the last item is dropped. Only one item is dropped, so the result can still exceed `max` if
* `items` already did.
* @param items - The current items.
* @param item - The value to prepend.
* @param max - The length above which an item is dropped. `0` (the default) means no limit.
* @returns A new array with `item` added.
*/ function $d14a518110a15ba8$export$8c6246b73dd61f4a(items, item, max = 0) {
    const newItems = [
        item,
        ...items
    ];
    return max && newItems.length > max ? newItems.slice(0, -1) : newItems;
}
/**
* Sentinel value that can be passed as a query's `queryFn` to conditionally disable the query (equivalent
* to `enabled: false`) while preserving full type inference for the query's data. Unlike `enabled: false`,
* a query disabled via `skipToken` cannot be triggered with `refetch`.
* @example
* ```ts
* new QueryObserver(queryClient, {
*   queryKey: ['post', postId],
*   queryFn: postId != null ? () => fetchPost(postId) : skipToken,
* })
* ```
*/ const $d14a518110a15ba8$export$1aa5a89531b7670d = Symbol();
/**
* Returns the function to call for a fetch. If there is no `queryFn` but the fetch was started from
* an `initialPromise`, that promise is returned instead. If there is no usable `queryFn` (missing or
* {@link skipToken}), the returned function rejects with a `Missing queryFn` error.
* @param options - The query options with the `queryFn`, and the `queryHash` used in error messages.
* @param fetchOptions - The fetch options, which may carry an `initialPromise`.
* @returns The function to call for the fetch.
*/ function $d14a518110a15ba8$export$c71c44209368a3bc(options, fetchOptions) {
    if (!options.queryFn && fetchOptions?.initialPromise) return ()=>fetchOptions.initialPromise;
    if (!options.queryFn || options.queryFn === $d14a518110a15ba8$export$1aa5a89531b7670d) return ()=>Promise.reject(/* @__PURE__ */ new Error(`Missing queryFn: '${options.queryHash}'`));
    return options.queryFn;
}
/**
* Resolves a `throwOnError` option to a boolean.
* If `throwOnError` is a function, it is called with `params` (e.g. the error and, depending on the caller,
* additional context such as the query or mutation) and its result is returned, allowing the throwing
* behavior to be decided per error. Otherwise, `throwOnError` itself is coerced to a boolean (`undefined`
* resolves to `false`).
* @param throwOnError - The `throwOnError` option: a boolean, a function that decides per error, or
* `undefined`.
* @param params - The arguments passed to `throwOnError` if it is a function.
* @returns Whether the error should be thrown.
* @example
* ```ts
* const throwOnError =
*   query.state.error && typeof options.throwOnError === 'function'
*     ? shouldThrowError(options.throwOnError, [query.state.error, query])
*     : options.throwOnError
* ```
*/ function $d14a518110a15ba8$export$2072f68e6c3507cf(throwOnError, params) {
    if (typeof throwOnError === "function") return throwOnError(...params);
    return !!throwOnError;
}
/**
* Adds a lazy `signal` getter to an object, such as a query function context. The first time
* `signal` is read, `onCancelled` is registered for the signal's `abort` event (or called right
* away if it is already aborted), so cancellation is only tracked when the signal is actually used.
* @param object - The object to add the `signal` property to.
* @param getSignal - Returns the `AbortSignal`. Called once, when `signal` is first read.
* @param onCancelled - Called when the signal is aborted, if `signal` was read.
* @returns The same object, with the `signal` property added.
*/ function $d14a518110a15ba8$export$83f813cd1f8a4973(object, getSignal, onCancelled) {
    let consumed = false;
    let signal;
    Object.defineProperty(object, "signal", {
        enumerable: true,
        get: ()=>{
            signal ??= getSignal();
            if (consumed) return signal;
            consumed = true;
            if (signal.aborted) onCancelled();
            else signal.addEventListener("abort", onCancelled, {
                once: true
            });
            return signal;
        }
    });
    return object;
}


//#region src/subscribable.ts
/**
* The base class behind everything in Query that you can subscribe to: `QueryCache`, `MutationCache`,
* the observers, and the `FocusManager`/`OnlineManager` behind `focusManager` and `onlineManager`.
* Subclasses decide what a listener receives and when it is called.
*/ var $b384e87d93fd3677$export$d26086b469ecdbcc = class {
    constructor(){
        this.listeners = /* @__PURE__ */ new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    /**
	* Registers a listener to be called on every update this object notifies about. Returns a function
	* that removes the listener again — call it to stop listening. The base class never drops a listener
	* on its own, though some subclasses clear all of theirs in `destroy()`.
	* @param listener - Called on each update, with whatever the subclass passes to its subscribers.
	* @returns A function that removes the listener.
	* @example
	* ```ts
	* const unsubscribe = subscribable.subscribe(() => {
	*   // react to the update
	* })
	*
	* unsubscribe()
	* ```
	*/ subscribe(listener) {
        this.listeners.add(listener);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(listener);
            this.onUnsubscribe();
        };
    }
    /**
	* Returns `true` while at least one listener is registered, `false` once they have all unsubscribed.
	* @returns `true` if at least one listener is registered.
	*/ hasListeners() {
        return this.listeners.size > 0;
    }
    /**
	* Called after a listener is added. Does nothing here; subclasses override it, e.g. to start
	* tracking what they observe once the first listener subscribes.
	*/ onSubscribe() {}
    /**
	* Called after a listener is removed. Does nothing here; subclasses override it, e.g. to clean up
	* once the last listener unsubscribes.
	*/ onUnsubscribe() {}
};



//#region src/notifyManager.ts
/**
* Default scheduling function used by the notify manager.
* Schedules the callback with the system's `setTimeout(callback, 0)`.
*/ const $7214f1c3bd8e29e6$export$7c76da44185e6090 = (0, $0aef9398d65c5c0f$export$5086591e51e32a18);
/**
* Creates a notify manager, which schedules and batches notifications to subscribers. Query uses a
* single instance of it, exported as {@link notifyManager}.
* @returns A new notify manager.
*/ function $7214f1c3bd8e29e6$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    let scheduleFn = $7214f1c3bd8e29e6$export$7c76da44185e6090;
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else scheduleFn(()=>{
            notifyFn(callback);
        });
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) scheduleFn(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    return {
        /**
		* Batches all updates scheduled inside the passed callback.
		* This is mainly used internally to optimize query client updating.
		* Batches can be nested; the queue is only flushed once the outermost `batch` call finishes.
		* The return value of `callback` is passed through.
		* @param callback - The function to run in the batch.
		* @returns The return value of `callback`.
		*/ batch: (callback)=>{
            let result;
            transactions++;
            try {
                result = callback();
            } finally{
                transactions--;
                if (!transactions) flush();
            }
            return result;
        },
        /**
		* All calls to the wrapped function will be batched.
		* @param callback - The function to wrap.
		* @returns A function that schedules a call to `callback` with the given arguments.
		*/ batchCalls: (callback)=>{
            return (...args)=>{
                schedule(()=>{
                    callback(...args);
                });
            };
        },
        schedule: /**
		* Schedules a function to be run on the next batch.
		* By default, the batch is run with a `setTimeout`, but this can be configured via `setScheduler`.
		*/ schedule,
        /**
		* Use this method to set a custom notify function.
		* This can be used to for example wrap notifications with `React.act` while running tests.
		* @param fn - Receives each notification callback and must call it.
		*/ setNotifyFunction: (fn)=>{
            notifyFn = fn;
        },
        /**
		* Use this method to set a custom function to batch notifications together into a single tick.
		* Framework adapters use this to plug in their own batching primitive, so that a single query
		* update only triggers one re-render instead of one per subscriber.
		* @param fn - Receives a function that runs a batch of notifications and must call it.
		* @example
		* ```ts
		* import { notifyManager } from '@tanstack/query-core'
		* import { batch } from 'solid-js'
		*
		* notifyManager.setBatchNotifyFunction(batch)
		* ```
		*/ setBatchNotifyFunction: (fn)=>{
            batchNotifyFn = fn;
        },
        /**
		* Configures a custom callback that schedules when the next batch runs.
		* The default behavior is `setTimeout(callback, 0)`.
		* @param fn - Receives a callback that runs the next batch, and schedules it.
		* @example
		* ```ts
		* import { notifyManager } from '@tanstack/query-core'
		*
		* // Schedule batches in the next microtask
		* notifyManager.setScheduler(queueMicrotask)
		*
		* // Schedule batches before the next frame is rendered
		* notifyManager.setScheduler(requestAnimationFrame)
		*
		* // Schedule batches some time in the future
		* notifyManager.setScheduler((cb) => setTimeout(cb, 10))
		* ```
		*/ setScheduler: (fn)=>{
            scheduleFn = fn;
        }
    };
}
/**
* Handles scheduling and batching callbacks in TanStack Query.
*/ const $7214f1c3bd8e29e6$export$520687f44db6e1ab = $7214f1c3bd8e29e6$export$316a8efd03cd1458();





//#region src/environmentManager.ts
let $775258cc62ff40fe$var$isServerFn = ()=>(0, $d14a518110a15ba8$export$6acf61af03e62db);
/**
* Returns whether the current runtime should be treated as a server environment.
* @returns `true` if the runtime is treated as a server.
*/ const $775258cc62ff40fe$export$6acf61af03e62db = ()=>$775258cc62ff40fe$var$isServerFn();
/**
* Manages how TanStack Query detects whether the current runtime should be treated as
* server-side, which disables scheduling refetch timers and changes the default `retry` count
* and `gcTime`. By default, the detection treats a missing `window` (or the presence of a
* `Deno` global) as server.
*
* Override this for runtimes where that default detection would give the wrong answer — for
* example, a Service Worker, where `window` is undefined even though the environment should
* behave like a client.
* @example
* ```ts
* import { environmentManager } from '@tanstack/query-core'
*
* environmentManager.setIsServer(() => false)
* ```
*/ const $775258cc62ff40fe$export$2d935f1a9c9d3f3e = {
    isServer: $775258cc62ff40fe$export$6acf61af03e62db,
    /**
	* Overrides the server check globally.
	* @param isServerValue - A function that returns whether the runtime should be treated as a
	* server.
	*/ setIsServer (isServerValue) {
        $775258cc62ff40fe$var$isServerFn = isServerValue;
    }
};



//#region src/focusManager.ts
/**
* The `FocusManager` manages the focus state within TanStack Query.
*
* It can be used to change the default event listeners or to manually change the focus state.
*/ var $b2740e487a8e9702$export$86f1af424b2ca4de = class extends (0, $b384e87d93fd3677$export$d26086b469ecdbcc) {
    #focused;
    #cleanup;
    #setup;
    constructor(){
        super();
        this.#setup = (onFocus)=>{
            if (typeof window !== "undefined" && window.addEventListener) {
                const listener = ()=>onFocus();
                window.addEventListener("visibilitychange", listener, false);
                return ()=>{
                    window.removeEventListener("visibilitychange", listener);
                };
            }
        };
    }
    onSubscribe() {
        if (!this.#cleanup) this.setEventListener(this.#setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            this.#cleanup?.();
            this.#cleanup = void 0;
        }
    }
    /**
	* `setEventListener` can be used to set a custom event listener that will
	* be used to determine the focus state. The provided `setup` function
	* receives a `setFocused` callback: call it with a `boolean` to manually
	* set the focus state, or with no arguments to re-evaluate the current
	* focus state and notify subscribers.
	* @param setup - Receives the `setFocused` callback, registers the event listener, and may return
	* a cleanup function that is called when the listener is replaced or no longer needed.
	* @example
	* ```ts
	* import { focusManager } from '@tanstack/query-core'
	*
	* focusManager.setEventListener((handleFocus) => {
	*   const listener = () => handleFocus()
	*   // Listen to visibilitychange
	*   if (typeof window !== 'undefined' && window.addEventListener) {
	*     window.addEventListener('visibilitychange', listener, false)
	*   }
	*
	*   return () => {
	*     // Be sure to unsubscribe if a new handler is set
	*     window.removeEventListener('visibilitychange', listener)
	*   }
	* })
	* ```
	*/ setEventListener(setup) {
        this.#setup = setup;
        this.#cleanup?.();
        this.#cleanup = setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        });
    }
    /**
	* `setFocused` can be used to manually set the focus state. Set `undefined`
	* to fall back to the default focus check.
	* @param focused - The focus state, or `undefined` to use the default focus check.
	* @example
	* ```ts
	* import { focusManager } from '@tanstack/query-core'
	*
	* // Set focused
	* focusManager.setFocused(true)
	*
	* // Set unfocused
	* focusManager.setFocused(false)
	*
	* // Fallback to the default focus check
	* focusManager.setFocused(undefined)
	* ```
	*/ setFocused(focused) {
        if (this.#focused !== focused) {
            this.#focused = focused;
            this.onFocus();
        }
    }
    /**
	* `onFocus` notifies all subscribed listeners with the current focus state.
	*/ onFocus() {
        const isFocused = this.isFocused();
        this.listeners.forEach((listener)=>{
            listener(isFocused);
        });
    }
    /**
	* `isFocused` can be used to get the current focus state.
	* @returns The focus state set with `setFocused`, or otherwise whether the document is visible.
	*/ isFocused() {
        if (typeof this.#focused === "boolean") return this.#focused;
        return globalThis.document?.visibilityState !== "hidden";
    }
};
/**
* Singleton instance of {@link FocusManager}, used to manage and observe the focus state within TanStack Query.
*/ const $b2740e487a8e9702$export$6bf54661be5b02cf = new $b2740e487a8e9702$export$86f1af424b2ca4de();



//#region src/onlineManager.ts
/**
* The `OnlineManager` manages the online state within TanStack Query. It can
* be used to change the default event listeners or to manually change the
* online state.
*
* By default, the `onlineManager` assumes an active network connection, and
* listens to the `online` and `offline` events on the `window` object to
* detect changes.
*/ var $a89091f0de1b0486$export$58774fb55d5ff7fc = class extends (0, $b384e87d93fd3677$export$d26086b469ecdbcc) {
    #online = true;
    #cleanup;
    #setup;
    constructor(){
        super();
        this.#setup = (onOnline)=>{
            if (typeof window !== "undefined" && window.addEventListener) {
                const onlineListener = ()=>onOnline(true);
                const offlineListener = ()=>onOnline(false);
                window.addEventListener("online", onlineListener, false);
                window.addEventListener("offline", offlineListener, false);
                return ()=>{
                    window.removeEventListener("online", onlineListener);
                    window.removeEventListener("offline", offlineListener);
                };
            }
        };
    }
    onSubscribe() {
        if (!this.#cleanup) this.setEventListener(this.#setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            this.#cleanup?.();
            this.#cleanup = void 0;
        }
    }
    /**
	* `setEventListener` can be used to set a custom event listener that will
	* be used to determine the online state. The provided `setup` function
	* receives a `setOnline` callback that should be called with a `boolean`
	* whenever the online state changes.
	* @param setup - Receives the `setOnline` callback, registers the event listener, and may return
	* a cleanup function that is called when the listener is replaced or no longer needed.
	* @example
	* ```ts
	* import NetInfo from '@react-native-community/netinfo'
	* import { onlineManager } from '@tanstack/query-core'
	*
	* onlineManager.setEventListener((setOnline) => {
	*   return NetInfo.addEventListener((state) => {
	*     setOnline(!!state.isConnected)
	*   })
	* })
	* ```
	*/ setEventListener(setup) {
        this.#setup = setup;
        this.#cleanup?.();
        this.#cleanup = setup(this.setOnline.bind(this));
    }
    /**
	* `setOnline` can be used to manually set the online state.
	* @param online - The online state.
	* @example
	* ```ts
	* import { onlineManager } from '@tanstack/query-core'
	*
	* // Set to online
	* onlineManager.setOnline(true)
	*
	* // Set to offline
	* onlineManager.setOnline(false)
	* ```
	*/ setOnline(online) {
        if (this.#online !== online) {
            this.#online = online;
            this.listeners.forEach((listener)=>{
                listener(online);
            });
        }
    }
    /**
	* `isOnline` can be used to get the current online state.
	* @returns `true` if online.
	*/ isOnline() {
        return this.#online;
    }
};
/**
* Singleton instance of {@link OnlineManager}, used to manage and observe the online state within TanStack Query.
*/ const $a89091f0de1b0486$export$b113e788b2dd3fdc = new $a89091f0de1b0486$export$58774fb55d5ff7fc();


//#region src/retryer.ts
/**
* The default `retryDelay`: doubles with every failure, starting at 1 second, up to 30 seconds.
* @param failureCount - The number of failures so far.
* @returns The delay before the next retry, in milliseconds.
*/ function $8a2f0f3d36a83a8a$var$defaultRetryDelay(failureCount) {
    return Math.min(1e3 * 2 ** failureCount, 3e4);
}
/**
* Checks whether a fetch can run for the given network mode.
* @param networkMode - The `networkMode` option. Defaults to `'online'`.
* @returns `true` if the network mode is not `'online'`, or if it is and the client is online.
*/ function $8a2f0f3d36a83a8a$export$61b92f63f30245cf(networkMode) {
    return (networkMode ?? "online") === "online" ? (0, $a89091f0de1b0486$export$b113e788b2dd3fdc).isOnline() : true;
}
/**
* The error thrown by a `Retryer` (and surfaced to `query.promise`/`mutation`) when a fetch is cancelled, e.g. via
* `query.cancel()`. `revert`, if `true`, tells the caller to restore the state the query was in before the fetch
* started instead of surfacing the error. `silent`, if `true`, tells the caller to suppress this error and instead
* resolve with the promise of the fetch that triggered the cancellation.
* @example
* ```ts
* query.cancel()
*
* try {
*   await query.promise
* } catch (error) {
*   if (error instanceof CancelledError) {
*     // the fetch was cancelled, e.g. via `query.cancel()`
*   }
* }
* ```
*/ var $8a2f0f3d36a83a8a$export$a8430ed4188f35a9 = class extends Error {
    constructor(options){
        super("CancelledError");
        this.revert = options?.revert;
        this.silent = options?.silent;
    }
};
/**
* Checks whether a value is a `CancelledError`.
* @param value - The value to check.
* @returns `true` if `value` is a `CancelledError`.
* @deprecated Use instanceof `CancelledError` instead.
*/ function $8a2f0f3d36a83a8a$export$986cc6445c1d323(value) {
    return value instanceof $8a2f0f3d36a83a8a$export$a8430ed4188f35a9;
}
/**
* Creates a retryer, which runs a function and retries it on failure according to the `retry` and
* `retryDelay` options. It pauses while the network mode doesn't allow fetching or `canRun` returns
* `false`, and can be cancelled. Queries and mutations use it to run their `queryFn` and
* `mutationFn`.
* @param config - The function to run, the retry options, and the callbacks for failures, pausing,
* continuing, and cancellation.
* @returns The retryer, whose `promise` settles with the result of the function.
*/ function $8a2f0f3d36a83a8a$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let continueFn;
    let status = "pending";
    let promiseResolve;
    let promiseReject;
    const promise = new Promise((resolve, reject)=>{
        promiseResolve = resolve;
        promiseReject = reject;
    });
    promise.catch((0, $d14a518110a15ba8$export$8793edee2d425525));
    const isResolved = ()=>status !== "pending";
    const cancel = (cancelOptions)=>{
        if (!isResolved()) {
            const error = new $8a2f0f3d36a83a8a$export$a8430ed4188f35a9(cancelOptions);
            reject(error);
            config.onCancel?.(error);
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const canContinue = ()=>(0, $b2740e487a8e9702$export$6bf54661be5b02cf).isFocused() && (config.networkMode === "always" || (0, $a89091f0de1b0486$export$b113e788b2dd3fdc).isOnline()) && config.canRun();
    const canStart = ()=>$8a2f0f3d36a83a8a$export$61b92f63f30245cf(config.networkMode) && config.canRun();
    const resolve = (value)=>{
        if (!isResolved()) {
            continueFn?.();
            status = "resolved";
            promiseResolve(value);
        }
    };
    const reject = (value)=>{
        if (!isResolved()) {
            continueFn?.();
            status = "rejected";
            promiseReject(value);
        }
    };
    const pause = (canResume)=>{
        return new Promise((continueResolve)=>{
            continueFn = (value)=>{
                if (isResolved() || canResume()) continueResolve(value);
            };
            config.onPause?.();
        }).then(()=>{
            continueFn = void 0;
            if (!isResolved()) config.onContinue?.();
        });
    };
    const run = ()=>{
        if (isResolved()) return;
        let promiseOrValue;
        const initialPromise = failureCount === 0 ? config.initialPromise : void 0;
        try {
            promiseOrValue = initialPromise ?? config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            if (isResolved()) return;
            const retry = config.retry ?? ((0, $775258cc62ff40fe$export$6acf61af03e62db)() ? 0 : 3);
            const retryDelay = config.retryDelay ?? $8a2f0f3d36a83a8a$var$defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                reject(error);
                return;
            }
            failureCount++;
            config.onFail?.(failureCount, error);
            (0, $d14a518110a15ba8$export$e772c8ff12451969)(delay).then(()=>{
                return canContinue() ? void 0 : pause(canContinue);
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    };
    return {
        promise: promise,
        status: ()=>status,
        cancel: cancel,
        continue: ()=>{
            continueFn?.();
            return promise;
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry,
        canStart: canStart,
        start: ()=>{
            if (canStart()) run();
            else pause(canStart).then(run);
            return promise;
        }
    };
}





//#region src/removable.ts
/**
* The base class for cache entries that are garbage collected once nothing is using them —
* `Query` and `Mutation` both extend it. `gcTime` controls how long an unused entry is kept.
*/ var $06bd31a2d6a0d9e6$export$e09608847fcc8c59 = class {
    #gcTimeout;
    /**
	* Clears the pending garbage collection timeout, so the entry is no longer scheduled for removal.
	* A subclass may override this to release what it holds on to as well — `Query` also cancels any
	* in-flight fetch.
	*/ destroy() {
        this.clearGcTimeout();
    }
    /**
	* Schedules the entry to be removed from its cache after `gcTime`, replacing any timeout scheduled
	* before. Nothing is scheduled if `gcTime` is `Infinity`.
	*/ scheduleGc() {
        this.clearGcTimeout();
        if ((0, $d14a518110a15ba8$export$e539f754e934e270)(this.gcTime)) this.#gcTimeout = (0, $0aef9398d65c5c0f$export$94a2700736e69372).setTimeout(()=>{
            this.optionalRemove();
        }, this.gcTime);
    }
    /**
	* Updates `gcTime`, keeping the longest one seen so far. Without a value, it defaults to 5 minutes
	* on the client and `Infinity` on the server.
	* @param newGcTime - The `gcTime` from the latest options, if any.
	*/ updateGcTime(newGcTime) {
        this.gcTime = Math.max(this.gcTime || 0, newGcTime ?? ((0, $775258cc62ff40fe$export$6acf61af03e62db)() ? Infinity : 3e5));
    }
    /**
	* Cancels the scheduled removal, if there is one.
	*/ clearGcTimeout() {
        if (this.#gcTimeout !== void 0) {
            (0, $0aef9398d65c5c0f$export$94a2700736e69372).clearTimeout(this.#gcTimeout);
            this.#gcTimeout = void 0;
        }
    }
};


//#region src/mutation.ts
/**
* Represents a single mutation attempt. A `Mutation` holds the mutation's
* options, state (data/error/status), and the `MutationObserver`s currently
* subscribed to it.
*
* Instances are created and managed internally by `MutationCache`; application
* code typically interacts with mutations indirectly through `QueryClient` or
* a framework hook like `useMutation`. Direct access to a `Mutation` instance
* is possible via `mutationCache.find()`/`getAll()` for inspecting cache state.
* @example
* ```ts
* const mutationCache = queryClient.getMutationCache()
*
* const mutation = mutationCache.find({ mutationKey: ['addPost'] })
* ```
*/ var $d16c703e36c412d3$export$17b8b19c814bcf56 = class extends (0, $06bd31a2d6a0d9e6$export$e09608847fcc8c59) {
    #client;
    #observers;
    #mutationCache;
    #retryer;
    constructor(config){
        super();
        this.#client = config.client;
        this.mutationId = config.mutationId;
        this.#mutationCache = config.mutationCache;
        this.#observers = [];
        this.state = config.state || $d16c703e36c412d3$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
    /**
	* Replaces the mutation's options and applies their `gcTime`.
	* @internal
	* @param options - The new mutation options.
	*/ setOptions(options) {
        this.options = options;
        this.updateGcTime(this.options.gcTime);
    }
    /**
	* The `meta` object passed in the mutation's options, if any.
	* @returns The mutation's `meta`, or `undefined` if none was set.
	*/ get meta() {
        return this.options.meta;
    }
    /**
	* Subscribes an observer to the mutation and stops its garbage collection.
	* @internal
	* @param observer - The observer to add. Adding an observer that is already subscribed does
	* nothing.
	*/ addObserver(observer) {
        if (!this.#observers.includes(observer)) {
            this.#observers.push(observer);
            this.clearGcTimeout();
            this.#mutationCache.notify({
                type: "observerAdded",
                mutation: this,
                observer: observer
            });
        }
    }
    /**
	* Unsubscribes an observer from the mutation.
	* @internal
	* @param observer - The observer to remove. Garbage collection is scheduled afterwards.
	*/ removeObserver(observer) {
        this.#observers = this.#observers.filter((x)=>x !== observer);
        this.scheduleGc();
        this.#mutationCache.notify({
            type: "observerRemoved",
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!this.#observers.length) {
            if (this.state.status === "pending") this.scheduleGc();
            else this.#mutationCache.remove(this);
        }
    }
    /**
	* Resumes a mutation that is currently paused or was restored from a
	* dehydrated, still-`pending` state.
	*
	* - If this mutation has an active retryer (it paused mid-attempt, e.g. due
	*   to the network mode or scope-based queuing), its retryer is resumed.
	* - Otherwise, if the mutation's status is still `pending` (e.g. it was
	*   dehydrated while an attempt was in flight and never got a retryer in
	*   this instance), `execute` is called again with the last known variables.
	* - Otherwise the mutation has already settled and this resolves immediately
	*   without running anything again.
	* @returns A promise that settles with the resumed mutation: it rejects if the mutation fails.
	* It resolves immediately if the mutation has already settled.
	* @see {@link Mutation#execute}
	* @example
	* ```ts
	* // typically driven by reconnect handling, e.g. queryClient.resumePausedMutations()
	* const mutation = mutationCache.find({ mutationKey: ['addPost'] })
	* await mutation?.continue()
	* ```
	*/ continue() {
        return this.#retryer?.continue() ?? (this.state.status === "pending" ? this.execute(this.state.variables) : Promise.resolve());
    }
    /**
	* Runs the mutation function for the given variables through a retryer, and
	* drives the mutation's state and lifecycle callbacks through to settlement.
	*
	* If this mutation's state is already `pending` when `execute` is called
	* (i.e. it was restored, still in-flight, from a dehydrated state), the
	* `onMutate` step is skipped and a `continue` action is dispatched to
	* unpause it; otherwise a `pending` action is dispatched first, then the
	* mutation cache's `onMutate` and the mutation's own `onMutate` option are
	* awaited in that order, and the resulting context is stored.
	*
	* The mutation function is then run (subject to `retry`/`retryDelay`/
	* `networkMode`, and to the mutation cache's scope-based serialization).
	* On success, the cache's `onSuccess`/`onSettled` callbacks run before the
	* mutation's own `onSuccess`/`onSettled` options, a `success` action is
	* dispatched, and the resolved data is returned. On failure, the same
	* cache-then-option ordering is used for `onError`/`onSettled`, but each of
	* those four callbacks is individually caught so that a throwing callback
	* cannot mask the original error; an `error` action is then dispatched and
	* the original error is re-thrown.
	* @param variables - The variables passed to the `mutationFn`.
	* @returns A promise that resolves with the mutation's data, or rejects with its error.
	* @see {@link Mutation#continue}
	* @example
	* ```ts
	* // Called internally by `MutationObserver.mutate` and `Mutation.continue` —
	* // applications normally trigger mutations through those, not this method.
	* const data = await mutation.execute(variables)
	* ```
	*/ async execute(variables) {
        const onContinue = ()=>{
            this.#dispatch({
                type: "continue"
            });
        };
        const mutationFnContext = {
            client: this.#client,
            meta: this.options.meta,
            mutationKey: this.options.mutationKey
        };
        const retryer = this.#retryer = (0, $8a2f0f3d36a83a8a$export$2cbd00fe8a2c8d85)({
            fn: ()=>{
                if (!this.options.mutationFn) return Promise.reject(/* @__PURE__ */ new Error("No mutationFn found"));
                return this.options.mutationFn(variables, mutationFnContext);
            },
            onFail: (failureCount, error)=>{
                this.#dispatch({
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                this.#dispatch({
                    type: "pause"
                });
            },
            onContinue: onContinue,
            retry: this.options.retry ?? 0,
            retryDelay: this.options.retryDelay,
            networkMode: this.options.networkMode,
            canRun: ()=>this.#mutationCache.canRun(this)
        });
        const restored = this.state.status === "pending";
        const isPaused = !retryer.canStart();
        try {
            if (restored) onContinue();
            else {
                this.#dispatch({
                    type: "pending",
                    variables: variables,
                    isPaused: isPaused
                });
                if (this.#mutationCache.config.onMutate) await this.#mutationCache.config.onMutate(variables, this, mutationFnContext);
                const context = await this.options.onMutate?.(variables, mutationFnContext);
                if (context !== this.state.context) this.#dispatch({
                    type: "pending",
                    context: context,
                    variables: variables,
                    isPaused: isPaused
                });
            }
            const data = await retryer.start();
            await this.#mutationCache.config.onSuccess?.(data, variables, this.state.context, this, mutationFnContext);
            await this.options.onSuccess?.(data, variables, this.state.context, mutationFnContext);
            await this.#mutationCache.config.onSettled?.(data, null, this.state.variables, this.state.context, this, mutationFnContext);
            await this.options.onSettled?.(data, null, variables, this.state.context, mutationFnContext);
            this.#dispatch({
                type: "success",
                data: data
            });
            return data;
        } catch (error) {
            try {
                await this.#mutationCache.config.onError?.(error, variables, this.state.context, this, mutationFnContext);
            } catch (e) {
                Promise.reject(e);
            }
            try {
                await this.options.onError?.(error, variables, this.state.context, mutationFnContext);
            } catch (e) {
                Promise.reject(e);
            }
            try {
                await this.#mutationCache.config.onSettled?.(void 0, error, this.state.variables, this.state.context, this, mutationFnContext);
            } catch (e) {
                Promise.reject(e);
            }
            try {
                await this.options.onSettled?.(void 0, error, variables, this.state.context, mutationFnContext);
            } catch (e) {
                Promise.reject(e);
            }
            this.#dispatch({
                type: "error",
                error: error
            });
            throw error;
        } finally{
            if (this.#retryer === retryer) this.#retryer = void 0;
            this.#mutationCache.runNext(this);
        }
    }
    #dispatch(action) {
        const reducer = (state)=>{
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        failureCount: action.failureCount,
                        failureReason: action.error
                    };
                case "pause":
                    return {
                        ...state,
                        isPaused: true
                    };
                case "continue":
                    return {
                        ...state,
                        isPaused: false
                    };
                case "pending":
                    return {
                        ...state,
                        context: action.context,
                        data: void 0,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        isPaused: action.isPaused,
                        status: "pending",
                        variables: action.variables,
                        submittedAt: Date.now()
                    };
                case "success":
                    return {
                        ...state,
                        data: action.data,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        status: "success",
                        isPaused: false
                    };
                case "error":
                    return {
                        ...state,
                        data: void 0,
                        error: action.error,
                        failureCount: state.failureCount + 1,
                        failureReason: action.error,
                        isPaused: false,
                        status: "error"
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $7214f1c3bd8e29e6$export$520687f44db6e1ab).batch(()=>{
            this.#observers.forEach((observer)=>{
                observer.onMutationUpdate(action);
            });
            this.#mutationCache.notify({
                mutation: this,
                type: "updated",
                action: action
            });
        });
    }
};
/**
* Returns the initial state of a mutation: `'idle'`, with no data, error, or variables.
* @returns The initial mutation state.
*/ function $d16c703e36c412d3$export$a1659b54bac3252a() {
    return {
        context: void 0,
        data: void 0,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: void 0,
        submittedAt: 0
    };
}


//#region src/mutationCache.ts
/**
* The `MutationCache` is the storage for mutations.
*
* Normally, you will not interact with the `MutationCache` directly and instead use a
* `QueryClient`. You can subscribe to it (inherited from `Subscribable`) to be informed of
* safe/known updates to the cache, such as mutations being added, removed, or updated.
* @example
* ```ts
* const unsubscribe = mutationCache.subscribe((event) => {
*   console.log(event.type, event.mutation)
* })
* ```
*/ var $5daeb7cad5a82c4e$export$1fcfd9a244434844 = class extends (0, $b384e87d93fd3677$export$d26086b469ecdbcc) {
    #mutations;
    #scopes;
    #mutationId;
    constructor(config = {}){
        super();
        this.config = config;
        this.#mutations = /* @__PURE__ */ new Set();
        this.#scopes = /* @__PURE__ */ new Map();
        this.#mutationId = 0;
    }
    /**
	* Creates a mutation and adds it to the cache.
	* @internal
	* @param client - The client the mutation belongs to, used to default its options.
	* @param options - The mutation options. They are defaulted with {@link
	* QueryClient#defaultMutationOptions}.
	* @param state - The initial state of the mutation, e.g. when restoring a dehydrated mutation.
	* @returns The new mutation, already added to the cache.
	*/ build(client, options, state) {
        const mutation = new (0, $d16c703e36c412d3$export$17b8b19c814bcf56)({
            client: client,
            mutationCache: this,
            mutationId: ++this.#mutationId,
            options: client.defaultMutationOptions(options),
            state: state
        });
        this.add(mutation);
        return mutation;
    }
    /**
	* Adds a mutation to the cache.
	* @internal
	* @param mutation - The mutation to add. If it has a `scope`, it is queued in that scope.
	*/ add(mutation) {
        this.#mutations.add(mutation);
        const scope = $5daeb7cad5a82c4e$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const scopedMutations = this.#scopes.get(scope);
            if (scopedMutations) scopedMutations.push(mutation);
            else this.#scopes.set(scope, [
                mutation
            ]);
        }
        this.notify({
            type: "added",
            mutation: mutation
        });
    }
    /**
	* Removes a mutation from the cache.
	* @internal
	* @param mutation - The mutation to remove, also from its scope's queue.
	*/ remove(mutation) {
        if (this.#mutations.delete(mutation)) {
            const scope = $5daeb7cad5a82c4e$var$scopeFor(mutation);
            if (typeof scope === "string") {
                const scopedMutations = this.#scopes.get(scope);
                if (scopedMutations) {
                    if (scopedMutations.length > 1) {
                        const index = scopedMutations.indexOf(mutation);
                        if (index !== -1) scopedMutations.splice(index, 1);
                    } else if (scopedMutations[0] === mutation) this.#scopes.delete(scope);
                }
            }
        }
        this.notify({
            type: "removed",
            mutation: mutation
        });
    }
    /**
	* Checks whether a mutation can run now, given the other mutations in its `scope`.
	* @internal
	* @param mutation - The mutation to check.
	* @returns `true` if the mutation has no `scope`, or no other mutation in its scope is pending
	* ahead of it.
	*/ canRun(mutation) {
        const scope = $5daeb7cad5a82c4e$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const firstPendingMutation = this.#scopes.get(scope)?.find((m)=>m.state.status === "pending");
            return !firstPendingMutation || firstPendingMutation === mutation;
        } else return true;
    }
    /**
	* Continues the next paused mutation in the same `scope` after a mutation finishes.
	* @internal
	* @param mutation - The mutation that finished.
	* @returns A promise that resolves once the next paused mutation in the same scope has continued,
	* or immediately if there is none.
	*/ runNext(mutation) {
        const scope = $5daeb7cad5a82c4e$var$scopeFor(mutation);
        if (typeof scope === "string") return this.#scopes.get(scope)?.find((m)=>m !== mutation && m.state.isPaused)?.continue() ?? Promise.resolve();
        else return Promise.resolve();
    }
    /**
	* Removes all mutations from the cache.
	* @example
	* ```ts
	* const mutationCache = queryClient.getMutationCache()
	*
	* mutationCache.clear()
	* ```
	*/ clear() {
        (0, $7214f1c3bd8e29e6$export$520687f44db6e1ab).batch(()=>{
            const mutations = this.getAll();
            this.#mutations.clear();
            this.#scopes.clear();
            mutations.forEach((mutation)=>{
                this.notify({
                    type: "removed",
                    mutation: mutation
                });
            });
        });
    }
    /**
	* Returns all mutations within the cache.
	*
	* This is not typically needed for most applications, but can come in handy when needing more
	* information about a mutation in rare scenarios.
	* @returns Every mutation in the cache.
	* @example
	* ```ts
	* const mutationCache = queryClient.getMutationCache()
	*
	* const mutations = mutationCache.getAll()
	* ```
	*/ getAll() {
        return Array.from(this.#mutations);
    }
    /**
	* A slightly more advanced method that can be used to get an existing mutation instance from
	* the cache. If the mutation does not exist, `undefined` is returned.
	*
	* This is not typically needed for most applications, but can come in handy when needing more
	* information about a mutation in rare scenarios.
	* @param filters - The filters to match. `exact` defaults to `true`.
	* @returns The first matching mutation, or `undefined`.
	* @see {@link MutationCache#findAll}
	* @example
	* ```ts
	* const mutationCache = queryClient.getMutationCache()
	*
	* const mutation = mutationCache.find({ mutationKey: ['addPost'] })
	* ```
	*/ find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((mutation)=>(0, $d14a518110a15ba8$export$a1ea5fb559f63ae3)(defaultedFilters, mutation));
    }
    /**
	* An even more advanced method that can be used to get existing mutation instances from the
	* cache that match the given filters. If no mutations match, an empty array is returned.
	*
	* This is not typically needed for most applications, but can come in handy when needing more
	* information about mutations in rare scenarios.
	* @param filters - The filters to match. Without filters, every mutation is returned.
	* @returns The matching mutations.
	* @see {@link MutationCache#find}
	* @example
	* ```ts
	* const mutationCache = queryClient.getMutationCache()
	*
	* const mutations = mutationCache.findAll({ mutationKey: ['addPost'] })
	* ```
	*/ findAll(filters = {}) {
        return this.getAll().filter((mutation)=>(0, $d14a518110a15ba8$export$a1ea5fb559f63ae3)(filters, mutation));
    }
    /**
	* Notifies every cache listener of an event, in one batch.
	* @internal
	* @param event - The event passed to every listener.
	*/ notify(event) {
        (0, $7214f1c3bd8e29e6$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    /**
	* Continues every paused mutation, e.g. when the app comes back online.
	* @internal
	* @returns A promise that resolves once every paused mutation has continued and settled.
	*/ resumePausedMutations() {
        const pausedMutations = this.getAll().filter((x)=>x.state.isPaused);
        return (0, $7214f1c3bd8e29e6$export$520687f44db6e1ab).batch(()=>Promise.all(pausedMutations.map((mutation)=>mutation.continue().catch((0, $d14a518110a15ba8$export$8793edee2d425525)))));
    }
};
/**
* Returns the scope id of a mutation, used to run mutations with the same scope one after another.
* @param mutation - The mutation to read the scope of.
* @returns The mutation's `scope.id`, or `undefined` if it has no scope.
*/ function $5daeb7cad5a82c4e$var$scopeFor(mutation) {
    return mutation.options.scope?.id;
}









//#region src/infiniteQueryBehavior.ts
/**
* Creates the behavior that fetches the pages of an infinite query: the next or previous page for
* `fetchNextPage`/`fetchPreviousPage`, or all pages again from the start on a refetch.
* @param pages - The number of pages to fetch from the start when all pages are fetched again,
* e.g. from the `pages` option of `queryClient.infiniteQuery`. Defaults to the number of cached
* pages.
* @returns The query behavior to set on an infinite query.
*/ function $67268234a1c88ffa$export$84470d1367601e8d(pages) {
    return {
        onFetch: (context, query)=>{
            const options = context.options;
            const direction = context.fetchOptions?.meta?.fetchMore?.direction;
            const oldPages = context.state.data?.pages || [];
            const oldPageParams = context.state.data?.pageParams || [];
            let result = {
                pages: [],
                pageParams: []
            };
            let currentPage = 0;
            const fetchFn = async ()=>{
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    (0, $d14a518110a15ba8$export$83f813cd1f8a4973)(object, ()=>context.signal, ()=>cancelled = true);
                };
                const queryFn = (0, $d14a518110a15ba8$export$c71c44209368a3bc)(context.options, context.fetchOptions);
                const fetchPage = async (data, param, previous)=>{
                    if (cancelled) return Promise.reject(context.signal.reason);
                    if (param == null && data.pages.length) return Promise.resolve(data);
                    const createQueryFnContext = ()=>{
                        const queryFnContext = {
                            client: context.client,
                            queryKey: context.queryKey,
                            pageParam: param,
                            direction: previous ? "backward" : "forward",
                            meta: context.options.meta
                        };
                        addSignalProperty(queryFnContext);
                        return queryFnContext;
                    };
                    const queryFnContext = createQueryFnContext();
                    const page = await queryFn(queryFnContext);
                    const { maxPages: maxPages } = context.options;
                    const addTo = previous ? (0, $d14a518110a15ba8$export$8c6246b73dd61f4a) : (0, $d14a518110a15ba8$export$ccce65a22a26f2bc);
                    return {
                        pages: addTo(data.pages, page, maxPages),
                        pageParams: addTo(data.pageParams, param, maxPages)
                    };
                };
                if (direction && oldPages.length) {
                    const previous = direction === "backward";
                    const pageParamFn = previous ? $67268234a1c88ffa$var$getPreviousPageParam : $67268234a1c88ffa$var$getNextPageParam;
                    const oldData = {
                        pages: oldPages,
                        pageParams: oldPageParams
                    };
                    result = await fetchPage(oldData, pageParamFn(options, oldData), previous);
                } else {
                    const remainingPages = pages ?? oldPages.length;
                    do {
                        const param = currentPage === 0 ? oldPageParams[0] === void 0 ? options.initialPageParam : oldPageParams[0] : $67268234a1c88ffa$var$getNextPageParam(options, result);
                        if (currentPage > 0 && param == null) break;
                        result = await fetchPage(result, param);
                        currentPage++;
                    }while (currentPage < remainingPages);
                }
                return result;
            };
            if (context.options.persister) context.fetchFn = ()=>{
                return context.options.persister?.(fetchFn, {
                    client: context.client,
                    queryKey: context.queryKey,
                    meta: context.options.meta,
                    signal: context.signal
                }, query);
            };
            else context.fetchFn = fetchFn;
        }
    };
}
/**
* Computes the page param of the page after the last one, with the `getNextPageParam` option.
* @param options - The infinite query options.
* @param data - The current pages and page params.
* @returns The next page param, or `undefined` if there are no pages yet.
*/ function $67268234a1c88ffa$var$getNextPageParam(options, { pages: pages, pageParams: pageParams }) {
    const lastIndex = pages.length - 1;
    return pages.length > 0 ? options.getNextPageParam(pages[lastIndex], pages, pageParams[lastIndex], pageParams) : void 0;
}
/**
* Computes the page param of the page before the first one, with the `getPreviousPageParam`
* option.
* @param options - The infinite query options.
* @param data - The current pages and page params.
* @returns The previous page param, or `undefined` if there are no pages yet or no
* `getPreviousPageParam` option.
*/ function $67268234a1c88ffa$var$getPreviousPageParam(options, { pages: pages, pageParams: pageParams }) {
    return pages.length > 0 ? options.getPreviousPageParam?.(pages[0], pages, pageParams[0], pageParams) : void 0;
}
/**
* Checks if there is a next page.
* @param options - The infinite query options with `getNextPageParam`.
* @param data - The current pages and page params.
* @returns `true` if `getNextPageParam` returns a value other than `null` or `undefined`.
*/ function $67268234a1c88ffa$export$b9c88add8b8b5e6a(options, data) {
    if (!data) return false;
    return $67268234a1c88ffa$var$getNextPageParam(options, data) != null;
}
/**
* Checks if there is a previous page.
* @param options - The infinite query options with `getPreviousPageParam`.
* @param data - The current pages and page params.
* @returns `true` if `getPreviousPageParam` is set and returns a value other than `null` or
* `undefined`.
*/ function $67268234a1c88ffa$export$db1663b730a8e6e4(options, data) {
    if (!data || !options.getPreviousPageParam) return false;
    return $67268234a1c88ffa$var$getPreviousPageParam(options, data) != null;
}


//#region src/query.ts
/**
* Represents a single cached query. A `Query` holds the query's key, options,
* state (data/error/status), and the observers currently subscribed to it.
*
* Instances are created and managed internally by `QueryCache`; application
* code typically interacts with queries indirectly through `QueryClient` or
* a framework hook like `useQuery`. Direct access to a `Query` instance is
* possible via `queryCache.find()`/`findAll()` for inspecting cache state.
* @example
* ```ts
* const queryCache = queryClient.getQueryCache()
* const query = queryCache.find({ queryKey: ['posts'] })
*
* if (query) {
*   console.log(query.state.dataUpdatedAt)
* }
* ```
*/ var $c1ac73663b6431ea$export$62297b13309008b2 = class extends (0, $06bd31a2d6a0d9e6$export$e09608847fcc8c59) {
    #queryType;
    #initialState;
    #revertState;
    #cache;
    #client;
    #retryer;
    #defaultOptions;
    #abortSignalConsumed;
    constructor(config){
        super();
        this.#abortSignalConsumed = false;
        this.#defaultOptions = config.defaultOptions;
        this.setOptions(config.options);
        this.observers = [];
        this.#client = config.client;
        this.#cache = this.#client.getQueryCache();
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        this.#initialState = $c1ac73663b6431ea$var$getDefaultState(this.options);
        this.state = config.state ?? this.#initialState;
        this.scheduleGc();
    }
    /**
	* The `meta` object passed in the query's options, if any.
	* @returns The query's `meta`, or `undefined` if none was set.
	*/ get meta() {
        return this.options.meta;
    }
    /**
	* `'infinite'` for an infinite query, otherwise `undefined`.
	* @internal
	* @returns The type of the query, set from the `_type` option (e.g. `'infinite'`).
	*/ get queryType() {
        return this.#queryType;
    }
    /**
	* The promise for the currently in-flight fetch, if the query is fetching.
	* `undefined` when the query is not fetching.
	* @returns The promise of the in-flight fetch, or `undefined`.
	*/ get promise() {
        return this.#retryer?.promise;
    }
    /**
	* Replaces the query's options and applies their `gcTime`. If the query has no data yet, it gets
	* the `initialData` from the new options, if any.
	* @internal
	* @param options - The new query options, merged on top of the query's default options.
	*/ setOptions(options) {
        this.options = {
            ...this.#defaultOptions,
            ...options
        };
        if (options?._type) this.#queryType = options._type;
        this.updateGcTime(this.options.gcTime);
        if (this.state && this.state.data === void 0) {
            const defaultState = $c1ac73663b6431ea$var$getDefaultState(this.options);
            if (defaultState.data !== void 0) {
                this.setState($c1ac73663b6431ea$var$successState(defaultState.data, defaultState.dataUpdatedAt));
                this.#initialState = defaultState;
            }
        }
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === "idle") this.#cache.remove(this);
    }
    /**
	* Writes new data to the query and marks it as successfully fetched.
	* @internal
	* @param newData - The data to write. Structural sharing with the current data is applied.
	* @param options - Set `updatedAt` to override the timestamp, and `manual` to mark the write as
	* manual (e.g. from `queryClient.setQueryData`).
	* @returns The data that was written.
	*/ setData(newData, options) {
        const data = (0, $d14a518110a15ba8$export$17619bac5b909b23)(this.state.data, newData, this.options);
        this.#dispatch({
            data: data,
            type: "success",
            dataUpdatedAt: options?.updatedAt,
            manual: options?.manual
        });
        return data;
    }
    /**
	* Merges the given partial state directly into this query's state, notifying observers. Used
	* by persistence and broadcast plugins to restore a state snapshot, and by devtools to let a
	* user manually trigger a loading/error state or edit the cached data.
	* @param state - The partial state to merge into the query's state.
	*/ setState(state) {
        this.#dispatch({
            type: "setState",
            state: state
        });
    }
    /**
	* Cancels the query's currently in-flight fetch, if any.
	* - Returns a promise that resolves once the cancellation has settled.
	* - If no fetch is in progress, resolves immediately.
	* @param options - Set `revert` to restore the state from before the fetch started, and `silent`
	* to suppress the cancellation error when a new fetch replaces the cancelled one.
	* @returns A promise that resolves once the cancellation has settled.
	* @example
	* ```ts
	* await query.cancel()
	* ```
	*/ cancel(options) {
        const promise = this.#retryer?.promise;
        this.#retryer?.cancel(options);
        return promise ? promise.then((0, $d14a518110a15ba8$export$8793edee2d425525)).catch((0, $d14a518110a15ba8$export$8793edee2d425525)) : Promise.resolve();
    }
    /**
	* Clears the query's garbage collection timeout and silently cancels any
	* in-flight fetch. Called by `QueryCache` when the query is removed from
	* the cache.
	* @see {@link Query#cancel}
	*/ destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    /**
	* The state the query was created with.
	* @internal
	* @returns The state the query had when it was first created, used by {@link Query#reset}.
	*/ get resetState() {
        return this.#initialState;
    }
    /**
	* Resets the query back to its initial state (the state it had when it was
	* first created, e.g. any `initialData`), destroying it first to cancel any
	* in-flight fetch.
	*/ reset() {
        this.destroy();
        this.setState(this.resetState);
    }
    /**
	* Returns `true` if the query has at least one observer for which `enabled`
	* does not resolve to `false`.
	* @returns `true` if the query has an enabled observer.
	*/ isActive() {
        return this.observers.some((observer)=>(0, $d14a518110a15ba8$export$e36731f6aa6a4362)(observer.options.enabled, this) !== false);
    }
    /**
	* Returns `true` if the query is disabled, meaning it will not fetch
	* automatically.
	* - If the query has observers, it is disabled when none of them are active
	*   (see `isActive`).
	* - If the query has no observers, it is disabled when its `queryFn` is
	*   `skipToken` or it has never been fetched.
	* @returns `true` if the query is disabled.
	*/ isDisabled() {
        if (this.getObserversCount() > 0) return !this.isActive();
        return this.options.queryFn === (0, $d14a518110a15ba8$export$1aa5a89531b7670d) || !this.isFetched();
    }
    /**
	* Returns `true` if the query has been fetched, i.e. it has resolved with
	* either data or an error at least once.
	* @returns `true` if the query has been fetched.
	*/ isFetched() {
        return this.state.dataUpdateCount + this.state.errorUpdateCount > 0;
    }
    /**
	* Returns `true` if the query has at least one observer configured with
	* `staleTime: 'static'`, meaning it is treated as never stale.
	* @returns `true` if the query is static.
	*/ isStatic() {
        if (this.getObserversCount() > 0) return this.observers.some((observer)=>(0, $d14a518110a15ba8$export$e36731f6aa6a4362)(observer.options.staleTime, this) === "static");
        return false;
    }
    /**
	* Returns `true` if the query is stale.
	* - If the query has observers, defers to whether any observer's current
	*   result reports `isStale` (which accounts for each observer's own
	*   `staleTime` and `enabled` state).
	* - If the query has no observers, it is considered stale when it has no
	*   data or has been invalidated.
	* @returns `true` if the query is stale.
	* @see {@link Query#isStaleByTime}
	* @example
	* ```ts
	* if (query.isStale()) {
	*   // refetch or otherwise treat the cached data as outdated
	* }
	* ```
	*/ isStale() {
        if (this.getObserversCount() > 0) return this.observers.some((observer)=>observer.getCurrentResult().isStale);
        return this.state.data === void 0 || this.state.isInvalidated;
    }
    /**
	* Returns `true` if the query's data is stale relative to the given
	* `staleTime` (defaults to `0`).
	* - A query with no data is always stale.
	* - `staleTime: 'static'` is never stale.
	* - An invalidated query is always stale.
	* - Otherwise, staleness is based on elapsed time since `dataUpdatedAt`.
	* @param staleTime - The time, in milliseconds, after which data is considered stale, or
	* `'static'` to never treat existing data as stale. A query without data is stale either way.
	* @returns `true` if the query's data is stale.
	* @see {@link Query#isStale}
	* @example
	* ```ts
	* const isStale = query.isStaleByTime(1000 * 60)
	* ```
	*/ isStaleByTime(staleTime = 0) {
        if (this.state.data === void 0) return true;
        if (staleTime === "static") return false;
        if (this.state.isInvalidated) return true;
        return !(0, $d14a518110a15ba8$export$811b83d62bcf47f0)(this.state.dataUpdatedAt, staleTime);
    }
    /**
	* Refetches the query when the window regains focus, if an observer wants that, and continues a
	* paused fetch.
	* @internal
	*/ onFocus() {
        this.observers.find((x)=>x.shouldFetchOnWindowFocus())?.refetch({
            cancelRefetch: false
        });
        this.#retryer?.continue();
    }
    /**
	* Refetches the query when the app reconnects, if an observer wants that, and continues a paused
	* fetch.
	* @internal
	*/ onOnline() {
        this.observers.find((x)=>x.shouldFetchOnReconnect())?.refetch({
            cancelRefetch: false
        });
        this.#retryer?.continue();
    }
    /**
	* Subscribes an observer to the query and stops its garbage collection.
	* @internal
	* @param observer - The observer to add. Adding an observer that is already subscribed does
	* nothing.
	*/ addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer);
            this.clearGcTimeout();
            this.#cache.notify({
                type: "observerAdded",
                query: this,
                observer: observer
            });
        }
    }
    /**
	* Unsubscribes an observer from the query.
	* @internal
	* @param observer - The observer to remove. When the last observer is removed, the in-flight
	* fetch is cancelled if its abort signal was consumed (otherwise only its retries are stopped),
	* and garbage collection is scheduled.
	*/ removeObserver(observer) {
        const index = this.observers.indexOf(observer);
        if (index !== -1) {
            this.observers.splice(index, 1);
            if (!this.observers.length) {
                if (this.#retryer) {
                    if (this.#abortSignalConsumed || this.state.fetchStatus === "paused" && this.state.status === "pending") this.#retryer.cancel({
                        revert: true
                    });
                    else this.#retryer.cancelRetry();
                }
                this.scheduleGc();
            }
            this.#cache.notify({
                type: "observerRemoved",
                query: this,
                observer: observer
            });
        }
    }
    /**
	* Returns the number of observers currently subscribed to this query.
	* @returns The number of observers.
	* @example
	* ```ts
	* if (query.getObserversCount() === 0) {
	*   // no component is currently watching this query
	* }
	* ```
	*/ getObserversCount() {
        return this.observers.length;
    }
    /**
	* Marks the query as invalidated, unless it is already invalidated. This
	* updates `state.isInvalidated` and notifies observers, but does not by
	* itself trigger a refetch.
	* @example
	* ```ts
	* query.invalidate()
	* ```
	*/ invalidate() {
        if (!this.state.isInvalidated) this.#dispatch({
            type: "invalidate"
        });
    }
    /**
	* Fetches the query, i.e. runs its `queryFn` (through any configured
	* retryer/behavior) and updates the query's state with the result.
	* - If a fetch is already in flight, returns its promise instead of
	*   starting a new one, unless `fetchOptions.cancelRefetch` is set and the
	*   query already has data, in which case the current fetch is silently
	*   cancelled first.
	* - If `options` is passed, it replaces the query's current options
	*   before fetching.
	* @param options - Query options that replace the query's current options before fetching. They
	* are not applied when an in-flight fetch is reused.
	* @param fetchOptions - Set `cancelRefetch` to cancel an in-flight fetch first (only if the query
	* already has data), and `meta` to pass extra information to the query's behavior.
	* @returns A promise that resolves with the fetched data, or rejects with the fetch error. If the
	* fetch is cancelled with `revert` while the query has data, it resolves with the restored data
	* instead.
	*/ async fetch(options, fetchOptions) {
        if (this.state.fetchStatus !== "idle" && this.#retryer?.status() !== "rejected") {
            if (this.state.data !== void 0 && fetchOptions?.cancelRefetch) this.cancel({
                silent: true
            });
            else if (this.#retryer) {
                this.#retryer.continueRetry();
                return this.#retryer.promise;
            }
        }
        if (options) this.setOptions(options);
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        const abortController = new AbortController();
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    this.#abortSignalConsumed = true;
                    return abortController.signal;
                }
            });
        };
        const fetchFn = ()=>{
            const queryFn = (0, $d14a518110a15ba8$export$c71c44209368a3bc)(this.options, fetchOptions);
            const createQueryFnContext = ()=>{
                const queryFnContext = {
                    client: this.#client,
                    queryKey: this.queryKey,
                    meta: this.meta
                };
                addSignalProperty(queryFnContext);
                return queryFnContext;
            };
            const queryFnContext = createQueryFnContext();
            this.#abortSignalConsumed = false;
            if (this.options.persister) return this.options.persister(queryFn, queryFnContext, this);
            return queryFn(queryFnContext);
        };
        const createFetchContext = ()=>{
            const context = {
                fetchOptions: fetchOptions,
                options: this.options,
                queryKey: this.queryKey,
                client: this.#client,
                state: this.state,
                fetchFn: fetchFn
            };
            addSignalProperty(context);
            return context;
        };
        const context = createFetchContext();
        (this.#queryType === "infinite" ? (0, $67268234a1c88ffa$export$84470d1367601e8d)(this.options.pages) : this.options.behavior)?.onFetch(context, this);
        this.#revertState = this.state;
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== context.fetchOptions?.meta) this.#dispatch({
            type: "fetch",
            meta: context.fetchOptions?.meta
        });
        const retryer = this.#retryer = (0, $8a2f0f3d36a83a8a$export$2cbd00fe8a2c8d85)({
            initialPromise: fetchOptions?.initialPromise,
            fn: context.fetchFn,
            onCancel: (error)=>{
                if (error instanceof (0, $8a2f0f3d36a83a8a$export$a8430ed4188f35a9) && error.revert) this.setState({
                    ...this.#revertState,
                    fetchStatus: "idle"
                });
                abortController.abort();
            },
            onFail: (failureCount, error)=>{
                this.#dispatch({
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                this.#dispatch({
                    type: "pause"
                });
            },
            onContinue: ()=>{
                this.#dispatch({
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode,
            canRun: ()=>true
        });
        try {
            const data = await retryer.start();
            if (data === void 0) throw new Error(`${this.queryHash} data is undefined`);
            this.setData(data);
            this.#cache.config.onSuccess?.(data, this);
            this.#cache.config.onSettled?.(data, this.state.error, this);
            return data;
        } catch (error) {
            if (error instanceof (0, $8a2f0f3d36a83a8a$export$a8430ed4188f35a9)) {
                if (error.silent) return this.#retryer.promise;
                else if (error.revert) {
                    if (this.state.data === void 0) throw error;
                    return this.state.data;
                }
            }
            this.#dispatch({
                type: "error",
                error: error
            });
            this.#cache.config.onError?.(error, this);
            this.#cache.config.onSettled?.(this.state.data, error, this);
            throw error;
        } finally{
            if (this.#retryer === retryer) this.#retryer = void 0;
            this.scheduleGc();
        }
    }
    #dispatch(action) {
        const reducer = (state)=>{
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        fetchFailureCount: action.failureCount,
                        fetchFailureReason: action.error
                    };
                case "pause":
                    return {
                        ...state,
                        fetchStatus: "paused"
                    };
                case "continue":
                    return {
                        ...state,
                        fetchStatus: "fetching"
                    };
                case "fetch":
                    return {
                        ...state,
                        ...$c1ac73663b6431ea$export$f3df9013f2b58bce(state.data, this.options),
                        fetchMeta: action.meta ?? null
                    };
                case "success":
                    const newState = {
                        ...state,
                        ...$c1ac73663b6431ea$var$successState(action.data, action.dataUpdatedAt),
                        dataUpdateCount: state.dataUpdateCount + 1,
                        ...!action.manual && {
                            fetchStatus: "idle",
                            fetchFailureCount: 0,
                            fetchFailureReason: null
                        }
                    };
                    this.#revertState = action.manual ? newState : void 0;
                    return newState;
                case "error":
                    const error = action.error;
                    return {
                        ...state,
                        error: error,
                        errorUpdateCount: state.errorUpdateCount + 1,
                        errorUpdatedAt: Date.now(),
                        fetchFailureCount: state.fetchFailureCount + 1,
                        fetchFailureReason: error,
                        fetchStatus: "idle",
                        status: "error",
                        isInvalidated: true
                    };
                case "invalidate":
                    return {
                        ...state,
                        isInvalidated: true
                    };
                case "setState":
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $7214f1c3bd8e29e6$export$520687f44db6e1ab).batch(()=>{
            this.observers.slice().forEach((observer)=>{
                observer.onQueryUpdate();
            });
            this.#cache.notify({
                query: this,
                type: "updated",
                action: action
            });
        });
    }
};
/**
* Returns the state changes applied when a query starts fetching.
* @param data - The query's current data. If it is `undefined`, the query is also reset to
* `'pending'` with no error.
* @param options - The query options, whose `networkMode` decides whether the query is `'fetching'`
* or `'paused'`.
* @returns The partial query state for a starting fetch.
*/ function $c1ac73663b6431ea$export$f3df9013f2b58bce(data, options) {
    return {
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchStatus: (0, $8a2f0f3d36a83a8a$export$61b92f63f30245cf)(options.networkMode) ? "fetching" : "paused",
        ...data === void 0 && {
            error: null,
            status: "pending"
        }
    };
}
/**
* Returns the state changes applied when a query receives data.
* @param data - The new data.
* @param dataUpdatedAt - The timestamp the data is recorded with. Defaults to the current time.
* @returns The partial query state for a successful update.
*/ function $c1ac73663b6431ea$var$successState(data, dataUpdatedAt) {
    return {
        data: data,
        dataUpdatedAt: dataUpdatedAt ?? Date.now(),
        error: null,
        isInvalidated: false,
        status: "success"
    };
}
/**
* Returns the initial state of a query, based on its `initialData` and `initialDataUpdatedAt`
* options.
* @param options - The query options.
* @returns The initial query state: `'success'` if `initialData` is set, otherwise `'pending'`.
*/ function $c1ac73663b6431ea$var$getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasData = data !== void 0;
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt ?? Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "pending",
        fetchStatus: "idle"
    };
}


//#region src/queryCache.ts
/**
* The `QueryCache` is the storage mechanism for TanStack Query. It stores all the data, meta
* information, and state of the queries it contains.
*
* Normally, you will not interact with the `QueryCache` directly and instead use a `QueryClient`
* for a specific cache. You can subscribe to it (inherited from `Subscribable`) to be informed of
* safe/known updates to the cache, such as queries being added, removed, or updated — updates made
* outside of the cache's own tracked mechanisms (e.g. mutating a query's state object directly) do
* not notify subscribers.
* @example
* ```ts
* const unsubscribe = queryCache.subscribe((event) => {
*   console.log(event.type, event.query)
* })
* ```
*/ var $76ddc3f2cb4f4476$export$5dde0cd941da8468 = class extends (0, $b384e87d93fd3677$export$d26086b469ecdbcc) {
    #queries;
    constructor(config = {}){
        super();
        this.config = config;
        this.#queries = /* @__PURE__ */ new Map();
    }
    /**
	* Returns the existing `Query` instance for the given options' `queryKey`/`queryHash`, or
	* builds and adds a new one to the cache if none exists yet. Used by framework adapters and
	* plugins (e.g. broadcast/persistence) that need to get-or-create a `Query` directly, bypassing
	* the reactive `QueryObserver` machinery.
	* @param client - The client the query belongs to, used to default its options.
	* @param options - The query options, including the `queryKey`. A new query is created with the
	* options defaulted by {@link QueryClient#defaultQueryOptions}.
	* @param state - The initial state of a newly created query, e.g. when hydrating. Ignored if the
	* query already exists.
	* @returns The existing or newly created query.
	* @example
	* ```ts
	* const queryCache = queryClient.getQueryCache()
	*
	* const query = queryCache.build(queryClient, {
	*   queryKey: ['posts'],
	*   queryFn: fetchPosts,
	* })
	* ```
	*/ build(client, options, state) {
        const queryKey = options.queryKey;
        const queryHash = options.queryHash ?? (0, $d14a518110a15ba8$export$cc90ca97bc0d73fd)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $c1ac73663b6431ea$export$62297b13309008b2)({
                client: client,
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    /**
	* Adds a query to the cache.
	* @internal
	* @param query - The query to add. If a query with the same hash is already cached, nothing
	* happens.
	*/ add(query) {
        if (!this.#queries.has(query.queryHash)) {
            this.#queries.set(query.queryHash, query);
            this.notify({
                type: "added",
                query: query
            });
        }
    }
    /**
	* Destroys the given `Query` and removes it from the cache, notifying subscribers with a
	* `'removed'` event. A no-op if the query is no longer the one currently stored under its hash
	* (e.g. it was already replaced). Used by plugins (e.g. the broadcast client) that mirror
	* removals across `QueryCache` instances.
	* @param query - The query to remove.
	* @example
	* ```ts
	* const queryCache = queryClient.getQueryCache()
	* const query = queryCache.find({ queryKey: ['posts'] })
	*
	* if (query) {
	*   queryCache.remove(query)
	* }
	* ```
	*/ remove(query) {
        if (this.#queries.get(query.queryHash) === query) {
            query.destroy();
            this.#queries.delete(query.queryHash);
            this.notify({
                type: "removed",
                query: query
            });
        }
    }
    /**
	* Removes all queries from the cache.
	* @example
	* ```ts
	* const queryCache = queryClient.getQueryCache()
	*
	* queryCache.clear()
	* ```
	*/ clear() {
        (0, $7214f1c3bd8e29e6$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                this.remove(query);
            });
        });
    }
    /**
	* Returns the `Query` instance stored under the given `queryHash`, or `undefined` if none
	* exists. Unlike {@link QueryCache#find}, this looks up by the already-computed hash rather
	* than by `QueryFilters`. Used by plugins (e.g. broadcast/hydration) that already have a hash
	* to look up directly.
	* @param queryHash - The hash of the query to look up.
	* @returns The query stored under the hash, or `undefined`.
	* @example
	* ```ts
	* const queryCache = queryClient.getQueryCache()
	* const queryHash = hashKey(['posts'])
	*
	* const query = queryCache.get(queryHash)
	* ```
	*/ get(queryHash) {
        return this.#queries.get(queryHash);
    }
    /**
	* Returns all queries within the cache.
	* @returns Every query in the cache.
	* @example
	* ```ts
	* const queryCache = queryClient.getQueryCache()
	*
	* const queries = queryCache.getAll()
	* ```
	*/ getAll() {
        return [
            ...this.#queries.values()
        ];
    }
    /**
	* A slightly more advanced method that can be used to get an existing query instance from the
	* cache. This instance not only contains all the state for the query, but all of the instances,
	* and underlying guts of the query as well. If the query does not exist, `undefined` is
	* returned.
	*
	* This is not typically needed for most applications, but can come in handy when needing more
	* information about a query in rare scenarios (e.g. looking at `query.state.dataUpdatedAt` to
	* decide whether a query is fresh enough to be used as an initial value).
	* @param filters - The filters to match, including the required `queryKey`. `exact` defaults to
	* `true`.
	* @returns The first matching query, or `undefined`.
	* @see {@link QueryCache#findAll}
	* @example
	* ```ts
	* const queryCache = queryClient.getQueryCache()
	*
	* const query = queryCache.find({ queryKey: ['posts'] })
	* ```
	*/ find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((query)=>(0, $d14a518110a15ba8$export$c5d1efe363797780)(defaultedFilters, query));
    }
    /**
	* An even more advanced method that can be used to get existing query instances from the cache
	* that partially match a query key. If no queries match, an empty array is returned.
	*
	* This is not typically needed for most applications, but can come in handy when needing more
	* information about queries in rare scenarios.
	* @param filters - The filters to match. Without filters, every query is returned.
	* @returns The matching queries.
	* @see {@link QueryCache#find}
	* @example
	* ```ts
	* const queryCache = queryClient.getQueryCache()
	*
	* const queries = queryCache.findAll({ queryKey: ['posts'] })
	* ```
	*/ findAll(filters = {}) {
        const queries = this.getAll();
        return Object.keys(filters).length > 0 ? queries.filter((query)=>(0, $d14a518110a15ba8$export$c5d1efe363797780)(filters, query)) : queries;
    }
    /**
	* Notifies every cache listener of an event, in one batch.
	* @internal
	* @param event - The event passed to every listener.
	*/ notify(event) {
        (0, $7214f1c3bd8e29e6$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    /**
	* Calls {@link Query#onFocus} on every cached query, in one batch.
	* @internal
	*/ onFocus() {
        (0, $7214f1c3bd8e29e6$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onFocus();
            });
        });
    }
    /**
	* Calls {@link Query#onOnline} on every cached query, in one batch.
	* @internal
	*/ onOnline() {
        (0, $7214f1c3bd8e29e6$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onOnline();
            });
        });
    }
};







//#region src/queryClient.ts
/**
* `QueryClient` is used to interact with a cache of queries and mutations. It owns a
* `QueryCache` and a `MutationCache` (creating default ones if none are passed in) and holds
* the default options that are applied to queries and mutations created through it.
* @example
* ```ts
* const queryClient = new QueryClient({
*   defaultOptions: {
*     queries: {
*       staleTime: Infinity,
*     },
*   },
* })
*
* await queryClient.query({ queryKey: ['posts'], queryFn: fetchPosts })
* ```
*/ var $7d11ede21a81ec4e$export$405d0624ed55a03f = class {
    #queryCache;
    #mutationCache;
    #defaultOptions;
    #queryDefaults;
    #mutationDefaults;
    #mountCount;
    #unsubscribeFocus;
    #unsubscribeOnline;
    constructor(config = {}){
        this.#queryCache = config.queryCache || new (0, $76ddc3f2cb4f4476$export$5dde0cd941da8468)();
        this.#mutationCache = config.mutationCache || new (0, $5daeb7cad5a82c4e$export$1fcfd9a244434844)();
        this.#defaultOptions = config.defaultOptions || {};
        this.#queryDefaults = /* @__PURE__ */ new Map();
        this.#mutationDefaults = /* @__PURE__ */ new Map();
        this.#mountCount = 0;
    }
    /**
	* Called by a framework adapter's `QueryClientProvider`-equivalent when it mounts, to start
	* listening for focus/online events and resume paused mutations. Ref-counted via an internal
	* mount count, so nested or multiple providers sharing the same `QueryClient` don't tear down
	* the shared listeners until the last one unmounts.
	*/ mount() {
        this.#mountCount++;
        if (this.#mountCount !== 1) return;
        this.#unsubscribeFocus = (0, $b2740e487a8e9702$export$6bf54661be5b02cf).subscribe(async (focused)=>{
            if (focused) {
                await this.resumePausedMutations();
                this.#queryCache.onFocus();
            }
        });
        this.#unsubscribeOnline = (0, $a89091f0de1b0486$export$b113e788b2dd3fdc).subscribe(async (online)=>{
            if (online) {
                await this.resumePausedMutations();
                this.#queryCache.onOnline();
            }
        });
    }
    /**
	* The inverse of {@link QueryClient#mount} — called by a framework adapter's
	* `QueryClientProvider`-equivalent when it unmounts. Only tears down the focus/online
	* listeners once the mount count returns to `0`.
	*/ unmount() {
        this.#mountCount--;
        if (this.#mountCount !== 0) return;
        this.#unsubscribeFocus?.();
        this.#unsubscribeFocus = void 0;
        this.#unsubscribeOnline?.();
        this.#unsubscribeOnline = void 0;
    }
    /**
	* Returns the number of queries in the cache that are currently fetching, optionally
	* matching a set of filters. This includes background-fetching, loading new pages, and
	* loading more infinite query results.
	* @param filters - Narrows down which fetching queries are counted. Without filters, every
	* fetching query is counted.
	* @returns The number of matching queries whose `fetchStatus` is `'fetching'`.
	* @example
	* ```ts
	* if (queryClient.isFetching()) {
	*   console.log('At least one query is fetching!')
	* }
	* ```
	*/ isFetching(filters) {
        return this.#queryCache.findAll({
            ...filters,
            fetchStatus: "fetching"
        }).length;
    }
    /**
	* Returns the number of mutations in the cache that are currently pending, optionally
	* matching a set of filters.
	* @param filters - Narrows down which pending mutations are counted. Without filters, every
	* pending mutation is counted.
	* @returns The number of matching mutations whose `status` is `'pending'`.
	* @example
	* ```ts
	* if (queryClient.isMutating()) {
	*   console.log('At least one mutation is pending!')
	* }
	* ```
	*/ isMutating(filters) {
        return this.#mutationCache.findAll({
            ...filters,
            status: "pending"
        }).length;
    }
    /**
	* Imperative (non-reactive) way to retrieve data for a QueryKey.
	* Should only be used in callbacks or functions where reading the latest data is necessary, e.g. for optimistic updates.
	*
	* Hint: Do not use this function inside a component, because it won't receive updates.
	* Use `useQuery` to create a `QueryObserver` that subscribes to changes.
	* @param queryKey - The query key of the query to read.
	* @returns The cached data for the query, or `undefined` if no query with this key has been observed yet.
	* @see {@link QueryClient#getQueriesData}
	*/ getQueryData(queryKey) {
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return this.#queryCache.get(options.queryHash)?.state.data;
    }
    /**
	* Returns the cached data of a query, or fetches it if there is none. With `revalidateIfStale`,
	* stale cached data is also refetched in the background.
	* @param options - The query options. If the query has no cached data yet, it is fetched with
	* these options.
	* @returns A promise that resolves to the cached data, or to the fetched data if nothing was
	* cached yet.
	* @deprecated Use queryClient.query({ ...options, staleTime: 'static' }) instead. This method will be removed in the next major version.
	*/ ensureQueryData(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        const query = this.#queryCache.build(this, defaultedOptions);
        const cachedData = query.state.data;
        if (cachedData === void 0) return this.fetchQuery(options);
        if (options.revalidateIfStale && query.isStaleByTime((0, $d14a518110a15ba8$export$e36731f6aa6a4362)(defaultedOptions.staleTime, query))) this.prefetchQuery(defaultedOptions);
        return Promise.resolve(cachedData);
    }
    /**
	* Imperative (non-reactive) way to retrieve the cached data of multiple queries at once.
	* Only queries matching the given filters are returned; if none match, an empty array is
	* returned.
	*
	* Because the matched queries can hold data of different shapes (e.g. a broad filter can match
	* queries with unrelated data types), the `TQueryFnData` generic defaults to `unknown` rather
	* than being inferred. Passing a more specific type is a convenience for call sites that know
	* every matched query holds the same shape — it is not checked against the actual cache
	* contents.
	* @param filters - The filters that select which queries to read.
	* @returns An array of query key and data pairs. The data is `undefined` for a query with no cached data.
	* @see {@link QueryClient#getQueryData}
	* @example
	* ```ts
	* const data = queryClient.getQueriesData({ queryKey: ['posts'] })
	* ```
	*/ getQueriesData(filters) {
        return this.#queryCache.findAll(filters).map(({ queryKey: queryKey, state: state })=>{
            return [
                queryKey,
                state.data
            ];
        });
    }
    /**
	* Synchronous way to immediately update a query's cached data. If the updater (or the value
	* passed) resolves to `undefined`, the cache is left untouched and no query is created;
	* otherwise, if the query does not exist yet, it will be created. To update multiple queries
	* at once by partially matching query keys, use {@link QueryClient#setQueriesData} instead.
	*
	* Updates must be performed immutably: do not mutate `oldData`, or data previously retrieved
	* via {@link QueryClient#getQueryData}, in place.
	* @param queryKey - The query key to set data for.
	* @param updater - Either the new data, or a function that receives the current data (which
	* may be `undefined`) and returns the new data.
	* @param options - Set `updatedAt` to override the timestamp the written data is recorded with.
	* @returns The data that was written, or `undefined` if the updater returned `undefined` — in that case
	* the write is skipped and the cache is left unchanged.
	* @example
	* ```ts
	* queryClient.setQueryData(['posts'], newPosts)
	*
	* // Or, using an updater function that receives the current data:
	* queryClient.setQueryData(['posts'], (oldPosts) => [...oldPosts, newPost])
	* ```
	*/ setQueryData(queryKey, updater, options) {
        const defaultedOptions = this.defaultQueryOptions({
            queryKey: queryKey
        });
        const prevData = this.#queryCache.get(defaultedOptions.queryHash)?.state.data;
        const data = (0, $d14a518110a15ba8$export$7f095f455ad5af3f)(updater, prevData);
        if (data === void 0) return;
        return this.#queryCache.build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    /**
	* Synchronous way to immediately update the cached data of multiple queries at once, using
	* filters or partial query key matching. Only queries that already exist and match the given
	* filters are updated; no new cache entries are created. Internally this calls
	* {@link QueryClient#setQueryData} for each matching query.
	* @param filters - The filters that select which existing queries to update.
	* @param updater - Either the new data, or a function that receives each matched query's current
	* data (which may be `undefined`) and returns the new data.
	* @param options - Set `updatedAt` to override the timestamp the written data is recorded with.
	* @returns One `[queryKey, data]` tuple per matched query, in the same shape and with the same
	* `undefined` case as {@link QueryClient#setQueryData}.
	* @example
	* ```ts
	* queryClient.setQueriesData({ queryKey: ['posts'] }, (oldPosts) =>
	*   oldPosts ? oldPosts.filter((post) => post.id !== deletedId) : oldPosts,
	* )
	* ```
	*/ setQueriesData(filters, updater, options) {
        return (0, $7214f1c3bd8e29e6$export$520687f44db6e1ab).batch(()=>this.#queryCache.findAll(filters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    /**
	* Imperative (non-reactive) way to retrieve an existing query's state. If the query does not
	* exist, `undefined` is returned.
	* @param queryKey - The query key of the query to read.
	* @returns The query's state, or `undefined` if no query with this key exists.
	* @example
	* ```ts
	* const state = queryClient.getQueryState(['posts'])
	* console.log(state?.dataUpdatedAt)
	* ```
	*/ getQueryState(queryKey) {
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return this.#queryCache.get(options.queryHash)?.state;
    }
    /**
	* Removes queries from the cache that match the given filters. Unlike
	* {@link QueryClient#invalidateQueries} or {@link QueryClient#refetchQueries}, this removes
	* matching queries from the cache instead of refetching them. Without filters, every query in
	* the cache is removed.
	* @param filters - The filters that select which queries to remove. Without filters, every query
	* is removed.
	* @example
	* ```ts
	* queryClient.removeQueries({ queryKey: ['posts'], exact: true })
	* ```
	*/ removeQueries(filters) {
        const queryCache = this.#queryCache;
        (0, $7214f1c3bd8e29e6$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    /**
	* Resets queries matching the given filters back to their initial state (e.g. any
	* `initialData`), notifying subscribers rather than removing them. Active queries among the
	* matched set are then refetched, and the returned promise resolves once that refetch settles.
	* @param filters - The filters that select which queries to reset. Without filters, every query
	* is reset.
	* @param options - Passed to the refetch of the active matched queries, e.g. `cancelRefetch` and
	* `throwOnError`.
	* @returns A promise that resolves once the refetch of the active matched queries settles.
	* @example
	* ```ts
	* await queryClient.resetQueries({ queryKey: ['posts'], exact: true })
	* ```
	*/ resetQueries(filters, options) {
        const queryCache = this.#queryCache;
        return (0, $7214f1c3bd8e29e6$export$520687f44db6e1ab).batch(()=>{
            const matched = queryCache.findAll(filters);
            const queriesToRefetch = new Set(matched);
            matched.forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries({
                type: "active",
                predicate: (query)=>queriesToRefetch.has(query)
            }, options);
        });
    }
    /**
	* Cancels outgoing fetches for queries matching the given filters. Most useful when performing
	* optimistic updates, since any outgoing refetch that resolves afterwards would otherwise
	* overwrite the optimistic update. By default (`revert: true`), a cancelled query's data is
	* reverted to its state before the outgoing fetch started.
	*
	* The returned promise never rejects, even if individual cancellations fail.
	* @param filters - The filters that select which queries to cancel. Without filters, every query
	* is cancelled.
	* @param cancelOptions - Passed to each matched query's cancellation. `revert` defaults to
	* `true`.
	* @returns A promise that resolves once every cancellation has settled.
	* @example
	* ```ts
	* await queryClient.cancelQueries({ queryKey: ['posts'], exact: true })
	* ```
	*/ cancelQueries(filters, cancelOptions = {}) {
        const defaultedCancelOptions = {
            revert: true,
            ...cancelOptions
        };
        const promises = (0, $7214f1c3bd8e29e6$export$520687f44db6e1ab).batch(()=>this.#queryCache.findAll(filters).map((query)=>query.cancel(defaultedCancelOptions)));
        return Promise.all(promises).then((0, $d14a518110a15ba8$export$8793edee2d425525)).catch((0, $d14a518110a15ba8$export$8793edee2d425525));
    }
    /**
	* Marks queries matching the given filters as invalidated. Unlike
	* {@link QueryClient#removeQueries}, invalidated queries stay in the cache.
	*
	* Unless `filters.refetchType` is `'none'`, matching queries are then refetched via
	* {@link QueryClient#refetchQueries}, using `filters.refetchType` if set, otherwise
	* `filters.type`, otherwise `'active'`.
	* @param filters - The filters that select which queries to invalidate, plus `refetchType` to
	* control which of them to refetch afterwards. Without filters, every query is invalidated.
	* @param options - Passed to {@link QueryClient#refetchQueries}, e.g. `cancelRefetch` and
	* `throwOnError`.
	* @returns A promise that resolves once the refetch settles, or immediately if `refetchType` is
	* `'none'`.
	* @example
	* ```ts
	* await queryClient.invalidateQueries({ queryKey: ['posts'], refetchType: 'active' })
	* ```
	*/ invalidateQueries(filters, options = {}) {
        return (0, $7214f1c3bd8e29e6$export$520687f44db6e1ab).batch(()=>{
            this.#queryCache.findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if (filters?.refetchType === "none") return Promise.resolve();
            return this.refetchQueries({
                ...filters,
                type: filters?.refetchType ?? filters?.type ?? "active"
            }, options);
        });
    }
    /**
	* Refetches queries matching the given filters, regardless of whether they are stale. Without
	* filters, every query in the cache is refetched. Queries that are disabled, or static (only
	* have observers with a static `staleTime`), are never refetched.
	*
	* By default (`cancelRefetch: true`), a currently running fetch is cancelled before the new
	* one starts. The returned promise resolves once all matching queries have settled; it does
	* not reject on individual query failures unless `throwOnError` is set.
	* @param filters - The filters that select which queries to refetch. Without filters, every query
	* in the cache is included.
	* @param options - Set `cancelRefetch` to `false` to keep a running fetch instead of cancelling
	* it, and `throwOnError` to `true` to reject when a refetch fails.
	* @returns A promise that resolves once every matched query has settled.
	* @example
	* ```ts
	* // refetch all active queries partially matching a query key:
	* await queryClient.refetchQueries({ queryKey: ['posts'], type: 'active' })
	* ```
	*/ refetchQueries(filters, options = {}) {
        const fetchOptions = {
            ...options,
            cancelRefetch: options.cancelRefetch ?? true
        };
        const promises = (0, $7214f1c3bd8e29e6$export$520687f44db6e1ab).batch(()=>this.#queryCache.findAll(filters).filter((query)=>!query.isDisabled() && !query.isStatic()).map((query)=>{
                let promise = query.fetch(void 0, fetchOptions);
                if (!fetchOptions.throwOnError) promise = promise.catch((0, $d14a518110a15ba8$export$8793edee2d425525));
                return query.state.fetchStatus === "paused" ? Promise.resolve() : promise;
            }));
        return Promise.all(promises).then((0, $d14a518110a15ba8$export$8793edee2d425525));
    }
    /**
	* Asynchronous method to fetch and cache a query, resolving with the data or throwing with
	* the error.
	*
	* If the query already exists in the cache and its data is not stale (per the given
	* `staleTime`), the cached data is returned without fetching. Otherwise, the query is fetched
	* and the promise resolves once the fetch settles. If a `select` function is provided, it is
	* applied to the data in both cases (cached or freshly fetched) before it is returned.
	*
	* Unlike a reactive observer, retries are disabled by default here (`retry: false`) unless
	* explicitly configured, since there is no component to catch a thrown error and retry through
	* re-render.
	*
	* The accepted options are `QueryObserverOptions` minus the fields that only make sense for a
	* reactive observer — `enabled`, `refetchInterval`, `refetchIntervalInBackground`,
	* `refetchOnWindowFocus`, `refetchOnReconnect`, `refetchOnMount`, `retryOnMount`,
	* `notifyOnChangeProps`, `throwOnError`, `suspense`, and `placeholderData` are not part of this
	* method's options.
	*
	* This method replaces the deprecated `fetchQuery`, and — combined with
	* `{ staleTime: 'static' }` — the deprecated `ensureQueryData`.
	* @param options - The query options, including the `queryKey` and the `queryFn` used if the
	* query needs to fetch.
	* @returns A promise that resolves to the data, or to the result of `select` if provided. It
	* rejects with the error from the fetch or from `select`.
	* @example
	* ```ts
	* try {
	*   const data = await queryClient.query({ queryKey, queryFn, staleTime: 10000 })
	* } catch (error) {
	*   console.log(error)
	* }
	* ```
	*/ async query(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        if (defaultedOptions.retry === void 0) defaultedOptions.retry = false;
        const query = this.#queryCache.build(this, defaultedOptions);
        const queryData = query.isStaleByTime((0, $d14a518110a15ba8$export$e36731f6aa6a4362)(defaultedOptions.staleTime, query)) ? await query.fetch(defaultedOptions) : query.state.data;
        const select = defaultedOptions.select;
        if (select) return select(queryData);
        return queryData;
    }
    /**
	* Fetches and caches a query, or returns its cached data if it isn't stale. Unlike in observers,
	* the fetch isn't retried unless `retry` is set.
	* @param options - The query options, including the `queryKey` and the `queryFn` used if the
	* query needs to fetch.
	* @returns A promise that resolves to the cached or fetched data, or rejects with the fetch
	* error.
	* @deprecated Use queryClient.query(options) instead. This method will be removed in the next major version.
	*/ fetchQuery(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        if (defaultedOptions.retry === void 0) defaultedOptions.retry = false;
        const query = this.#queryCache.build(this, defaultedOptions);
        return query.isStaleByTime((0, $d14a518110a15ba8$export$e36731f6aa6a4362)(defaultedOptions.staleTime, query)) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    /**
	* Fetches and caches a query like {@link QueryClient#fetchQuery}, but ignores the result and any
	* error.
	* @param options - The query options, including the `queryKey` and the `queryFn` used if the
	* query needs to fetch.
	* @returns A promise that resolves once the fetch settles. It never rejects.
	* @deprecated Use queryClient.query(options) instead. You can swallow errors with `.catch(noop)`. This method will be removed in the next major version.
	*/ prefetchQuery(options) {
        return this.fetchQuery(options).then((0, $d14a518110a15ba8$export$8793edee2d425525)).catch((0, $d14a518110a15ba8$export$8793edee2d425525));
    }
    /**
	* Asynchronous method to fetch and cache an infinite query, resolving with an
	* {@link InfiniteData} object or throwing with the error.
	*
	* Behaves like {@link QueryClient#query}, accepting the same options (minus
	* `initialPageParam`), plus the required `initialPageParam`, and an optional `pages` /
	* `getNextPageParam` pair used to refetch a fixed number of pages from the start.
	*
	* This method replaces the deprecated `fetchInfiniteQuery`, and — combined with
	* `{ staleTime: 'static' }` — the deprecated `ensureInfiniteQueryData`.
	* @param options - The infinite query options, including the `queryKey`, the `queryFn`, and the
	* `initialPageParam`.
	* @returns A promise that resolves to the {@link InfiniteData}, or to the result of `select` if
	* provided. It rejects with the error from the fetch or from `select`.
	* @example
	* ```ts
	* try {
	*   const data = await queryClient.infiniteQuery({ queryKey, queryFn, initialPageParam: 0 })
	*   console.log(data.pages)
	* } catch (error) {
	*   console.log(error)
	* }
	* ```
	*/ infiniteQuery(options) {
        options._type = "infinite";
        return this.query(options);
    }
    /**
	* Fetches and caches an infinite query, or returns its cached data if it isn't stale.
	* @param options - The infinite query options, including the `queryKey`, the `queryFn`, and the
	* `initialPageParam`.
	* @returns A promise that resolves to the cached or fetched {@link InfiniteData}, or rejects with
	* the fetch error.
	* @deprecated Use queryClient.infiniteQuery(options) instead. This method will be removed in the next major version.
	*/ fetchInfiniteQuery(options) {
        options._type = "infinite";
        return this.fetchQuery(options);
    }
    /**
	* Fetches and caches an infinite query like {@link QueryClient#fetchInfiniteQuery}, but ignores
	* the result and any error.
	* @param options - The infinite query options, including the `queryKey`, the `queryFn`, and the
	* `initialPageParam`.
	* @returns A promise that resolves once the fetch settles. It never rejects.
	* @deprecated Use queryClient.infiniteQuery(options) instead. You can swallow errors with `.catch(noop)`. This method will be removed in the next major version.
	*/ prefetchInfiniteQuery(options) {
        return this.fetchInfiniteQuery(options).then((0, $d14a518110a15ba8$export$8793edee2d425525)).catch((0, $d14a518110a15ba8$export$8793edee2d425525));
    }
    /**
	* Returns the cached data of an infinite query, or fetches it if there is none. With
	* `revalidateIfStale`, stale cached data is also refetched in the background.
	* @param options - The infinite query options. If the query has no cached data yet, it is fetched
	* with these options.
	* @returns A promise that resolves to the cached {@link InfiniteData}, or to the fetched data if
	* nothing was cached yet.
	* @deprecated Use queryClient.infiniteQuery({ ...options, staleTime: 'static' }) instead. This method will be removed in the next major version.
	*/ ensureInfiniteQueryData(options) {
        options._type = "infinite";
        return this.ensureQueryData(options);
    }
    /**
	* Resumes mutations that were paused because there was no network connection. Does nothing
	* (resolving immediately) if the client is currently offline.
	* @returns A promise that resolves once the resumed mutations have settled.
	* @example
	* ```ts
	* import { QueryClient } from '@tanstack/query-core'
	*
	* const queryClient = new QueryClient()
	* await queryClient.resumePausedMutations()
	* ```
	*/ resumePausedMutations() {
        if ((0, $a89091f0de1b0486$export$b113e788b2dd3fdc).isOnline()) return this.#mutationCache.resumePausedMutations();
        return Promise.resolve();
    }
    /**
	* Returns the query cache this client is connected to.
	* @returns The {@link QueryCache} instance.
	* @example
	* ```ts
	* import { QueryClient } from '@tanstack/query-core'
	*
	* const queryClient = new QueryClient()
	* const queryCache = queryClient.getQueryCache()
	* const queries = queryCache.findAll({ queryKey: ['posts'] })
	* ```
	*/ getQueryCache() {
        return this.#queryCache;
    }
    /**
	* Returns the mutation cache this client is connected to.
	* @returns The {@link MutationCache} instance.
	* @example
	* ```ts
	* import { QueryClient } from '@tanstack/query-core'
	*
	* const queryClient = new QueryClient()
	* const mutationCache = queryClient.getMutationCache()
	* const mutations = mutationCache.findAll({ status: 'pending' })
	* ```
	*/ getMutationCache() {
        return this.#mutationCache;
    }
    /**
	* Returns the default options that were set when creating the client, or via
	* {@link QueryClient#setDefaultOptions}.
	* @returns The client's current default options.
	* @example
	* ```ts
	* import { QueryClient } from '@tanstack/query-core'
	*
	* const queryClient = new QueryClient()
	* const defaultOptions = queryClient.getDefaultOptions()
	* ```
	*/ getDefaultOptions() {
        return this.#defaultOptions;
    }
    /**
	* Dynamically sets the default options for this client, overwriting any previously defined
	* default options.
	* @param options - The new default options for queries and mutations.
	* @see {@link QueryClient#getDefaultOptions}
	* @example
	* ```ts
	* import { QueryClient } from '@tanstack/query-core'
	*
	* const queryClient = new QueryClient()
	* queryClient.setDefaultOptions({
	*   queries: {
	*     staleTime: Infinity,
	*   },
	* })
	* ```
	*/ setDefaultOptions(options) {
        this.#defaultOptions = options;
    }
    /**
	* Sets default options for queries whose query key partially matches the given `queryKey`.
	*
	* If several registered query defaults match a given query key, they are merged together in
	* registration order by {@link QueryClient#getQueryDefaults}, so register defaults from the
	* most generic key to the least generic one — more specific defaults should be registered
	* after more generic ones so they take precedence.
	* @param queryKey - The query key that query keys are partially matched against.
	* @param options - The default options applied to matching queries.
	* @example
	* ```ts
	* queryClient.setQueryDefaults(['posts'], { queryFn: fetchPosts })
	*
	* await queryClient.query({ queryKey: ['posts'] })
	* ```
	*/ setQueryDefaults(queryKey, options) {
        this.#queryDefaults.set((0, $d14a518110a15ba8$export$1e87d19d4aab5805)(queryKey), {
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    /**
	* Returns the default options registered for queries whose query key partially matches the
	* given `queryKey`, via {@link QueryClient#setQueryDefaults}. If multiple registered defaults
	* match, they are merged together in registration order.
	* @param queryKey - The query key to look up registered defaults for.
	* @returns The merged default options of every registration that matches, or an empty object if
	* none match.
	* @example
	* ```ts
	* const defaultOptions = queryClient.getQueryDefaults(['posts'])
	* ```
	*/ getQueryDefaults(queryKey) {
        const defaults = [
            ...this.#queryDefaults.values()
        ];
        const result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $d14a518110a15ba8$export$2f07189bb9fa26a7)(queryKey, queryDefault.queryKey)) Object.assign(result, queryDefault.defaultOptions);
        });
        return result;
    }
    /**
	* Sets default options for mutations whose mutation key partially matches the given
	* `mutationKey`. As with {@link QueryClient#setQueryDefaults}, the order of registration
	* matters when several registered defaults match the same mutation key.
	* @param mutationKey - The mutation key that mutation keys are partially matched against.
	* @param options - The default options applied to matching mutations.
	* @see {@link QueryClient#getMutationDefaults}
	* @example
	* ```ts
	* queryClient.setMutationDefaults(['addPost'], { mutationFn: addPost })
	* ```
	*/ setMutationDefaults(mutationKey, options) {
        this.#mutationDefaults.set((0, $d14a518110a15ba8$export$1e87d19d4aab5805)(mutationKey), {
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    /**
	* Returns the default options registered for mutations whose mutation key partially matches
	* the given `mutationKey`, via {@link QueryClient#setMutationDefaults}. If multiple registered
	* defaults match, they are merged together in registration order.
	* @param mutationKey - The mutation key to look up registered defaults for.
	* @returns The merged default options of every registration that matches, or an empty object if
	* none match.
	* @example
	* ```ts
	* const defaultOptions = queryClient.getMutationDefaults(['addPost'])
	* ```
	*/ getMutationDefaults(mutationKey) {
        const defaults = [
            ...this.#mutationDefaults.values()
        ];
        const result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $d14a518110a15ba8$export$2f07189bb9fa26a7)(mutationKey, queryDefault.mutationKey)) Object.assign(result, queryDefault.defaultOptions);
        });
        return result;
    }
    /**
	* Called by framework adapters (e.g. inside `useQuery`) to resolve the options passed by the
	* caller into their final, defaulted form: merging the client's own `defaultOptions.queries`,
	* then `queryClient.setQueryDefaults` for the given `queryKey`, then the caller's options on
	* top. A no-op if the options are already defaulted (`_defaulted: true`).
	* @param options - The query options passed by the caller.
	* @returns The defaulted options, with `queryHash` and dependent defaults (e.g.
	* `refetchOnReconnect`) filled in.
	*/ defaultQueryOptions(options) {
        if (options._defaulted) return options;
        const defaultedOptions = {
            ...this.#defaultOptions.queries,
            ...this.getQueryDefaults(options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash) defaultedOptions.queryHash = (0, $d14a518110a15ba8$export$cc90ca97bc0d73fd)(defaultedOptions.queryKey, defaultedOptions);
        if (defaultedOptions.refetchOnReconnect === void 0) defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
        if (defaultedOptions.throwOnError === void 0) defaultedOptions.throwOnError = !!defaultedOptions.suspense;
        if (!defaultedOptions.networkMode && defaultedOptions.persister) defaultedOptions.networkMode = "offlineFirst";
        if (defaultedOptions.queryFn === (0, $d14a518110a15ba8$export$1aa5a89531b7670d)) defaultedOptions.enabled = false;
        return defaultedOptions;
    }
    /**
	* The mutation counterpart of {@link QueryClient#defaultQueryOptions}. Called by framework
	* adapters (e.g. inside `useMutation`) to merge the client's `defaultOptions.mutations`, then
	* `queryClient.setMutationDefaults` for the given `mutationKey`, then the caller's options on
	* top. A no-op if the options are already defaulted (`_defaulted: true`).
	* @param options - The mutation options passed by the caller.
	* @returns The defaulted options.
	*/ defaultMutationOptions(options) {
        if (options?._defaulted) return options;
        return {
            ...this.#defaultOptions.mutations,
            ...options?.mutationKey && this.getMutationDefaults(options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    /**
	* Clears both the query cache and the mutation cache this client is connected to.
	* @example
	* ```ts
	* import { QueryClient } from '@tanstack/query-core'
	*
	* const queryClient = new QueryClient()
	* queryClient.clear()
	* ```
	*/ clear() {
        this.#queryCache.clear();
        this.#mutationCache.clear();
    }
};


var $lCzvA = parcelRequire("lCzvA");

"use client";
//#region src/QueryClientProvider.tsx
/**
* The context that `useQueryClient` reads from. `QueryClientProvider` is the normal way to set it.
*/ const $6547bc15d23e8c33$export$da112d31b0149f31 = $lCzvA.createContext(void 0);
/**
* The `useQueryClient` hook returns the current `QueryClient` instance.
* @param queryClient - Use this to use a custom `QueryClient`. Otherwise, the one from the nearest context will
* be used.
* @returns The current `QueryClient` instance.
* @throws {Error} If no `queryClient` argument is passed and no `QueryClientProvider` is found in the
* component tree.
*/ const $6547bc15d23e8c33$export$22e77b9572c4fded = (queryClient)=>{
    const client = $lCzvA.useContext($6547bc15d23e8c33$export$da112d31b0149f31);
    if (queryClient) return queryClient;
    if (!client) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return client;
};
/**
* Use the `QueryClientProvider` component to connect and provide a `QueryClient` to your application. Also
* calls `client.mount()`/`client.unmount()` as this component mounts/unmounts, which subscribes the client to
* focus/online events (resuming any paused mutations and refetching as needed when the app regains focus or
* comes back online).
* @param props - The `client` to provide, and the `children` that get access to it.
* @returns The provided `children`, wrapped so they can read the `QueryClient` via `useQueryClient`.
* @example
* ```tsx
* import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
*
* const queryClient = new QueryClient()
*
* function App() {
*   return <QueryClientProvider client={queryClient}>...</QueryClientProvider>
* }
* ```
*/ const $6547bc15d23e8c33$export$45604f0cc8ae667b = ({ client: client, children: children })=>{
    $lCzvA.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($6547bc15d23e8c33$export$da112d31b0149f31.Provider, {
        value: client,
        children: children
    });
};




"use client";
//#region src/index.ts
const $33603daf243409bc$export$fd1469cb3147d866 = function() {
    return null;
};
const $33603daf243409bc$export$6d64409a8b475869 = function() {
    return null;
};


var $7d0bdd92e4a5843a$var$t = {
    getItemSync: function(t) {
        try {
            return localStorage.getItem(t) || null;
        } catch (t) {
            return null;
        }
    },
    getItem: function(t, e) {
        var n = this;
        return new Promise(function(i, a) {
            try {
                var o = n.getItemSync(t);
                null == e || e(null, o), i(o);
            } catch (t) {
                e && e(t, null), a(t);
            }
        });
    },
    setItem: function(t, e, n) {
        return new Promise(function(i, a) {
            try {
                localStorage.setItem(t, e), n && n(null, e), i(e);
            } catch (t) {
                n && n(t, null), a(t);
            }
        });
    }
}, $7d0bdd92e4a5843a$var$e = function() {
    return $7d0bdd92e4a5843a$var$e = Object.assign || function(t) {
        for(var e, n = 1, i = arguments.length; n < i; n++)for(var a in e = arguments[n])Object.prototype.hasOwnProperty.call(e, a) && (t[a] = e[a]);
        return t;
    }, $7d0bdd92e4a5843a$var$e.apply(this, arguments);
};
function $7d0bdd92e4a5843a$var$n(t, e, n, i) {
    return new (n || (n = Promise))(function(a, o) {
        function r(t) {
            try {
                l(i.next(t));
            } catch (t) {
                o(t);
            }
        }
        function s(t) {
            try {
                l(i.throw(t));
            } catch (t) {
                o(t);
            }
        }
        function l(t) {
            var e;
            t.done ? a(t.value) : (e = t.value, e instanceof n ? e : new n(function(t) {
                t(e);
            })).then(r, s);
        }
        l((i = i.apply(t, e || [])).next());
    });
}
function $7d0bdd92e4a5843a$var$i(t, e) {
    var n, i, a, o, r = {
        label: 0,
        sent: function() {
            if (1 & a[0]) throw a[1];
            return a[1];
        },
        trys: [],
        ops: []
    };
    return o = {
        next: s(0),
        throw: s(1),
        return: s(2)
    }, "function" == typeof Symbol && (o[Symbol.iterator] = function() {
        return this;
    }), o;
    function s(o) {
        return function(s) {
            return function(o) {
                if (n) throw new TypeError("Generator is already executing.");
                for(; r;)try {
                    if (n = 1, i && (a = 2 & o[0] ? i.return : o[0] ? i.throw || ((a = i.return) && a.call(i), 0) : i.next) && !(a = a.call(i, o[1])).done) return a;
                    switch(i = 0, a && (o = [
                        2 & o[0],
                        a.value
                    ]), o[0]){
                        case 0:
                        case 1:
                            a = o;
                            break;
                        case 4:
                            return r.label++, {
                                value: o[1],
                                done: !1
                            };
                        case 5:
                            r.label++, i = o[1], o = [
                                0
                            ];
                            continue;
                        case 7:
                            o = r.ops.pop(), r.trys.pop();
                            continue;
                        default:
                            if (!(a = r.trys, (a = a.length > 0 && a[a.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                                r = 0;
                                continue;
                            }
                            if (3 === o[0] && (!a || o[1] > a[0] && o[1] < a[3])) {
                                r.label = o[1];
                                break;
                            }
                            if (6 === o[0] && r.label < a[1]) {
                                r.label = a[1], a = o;
                                break;
                            }
                            if (a && r.label < a[2]) {
                                r.label = a[2], r.ops.push(o);
                                break;
                            }
                            a[2] && r.ops.pop(), r.trys.pop();
                            continue;
                    }
                    o = e.call(t, r);
                } catch (t) {
                    o = [
                        6,
                        t
                    ], i = 0;
                } finally{
                    n = a = 0;
                }
                if (5 & o[0]) throw o[1];
                return {
                    value: o[0] ? o[1] : void 0,
                    done: !0
                };
            }([
                o,
                s
            ]);
        };
    }
}
function $7d0bdd92e4a5843a$var$a(t, e, n) {
    if (n || 2 === arguments.length) for(var i, a = 0, o = e.length; a < o; a++)!i && a in e || (i || (i = Array.prototype.slice.call(e, 0, a)), i[a] = e[a]);
    return t.concat(i || Array.prototype.slice.call(e));
}
var $7d0bdd92e4a5843a$var$o = function t(e, n) {
    if (e === n) return !0;
    if (e && n && "object" == typeof e && "object" == typeof n) {
        if (e.constructor !== n.constructor) return !1;
        var i, a, o;
        if (Array.isArray(e)) {
            if ((i = e.length) != n.length) return !1;
            for(a = i; 0 != a--;)if (!t(e[a], n[a])) return !1;
            return !0;
        }
        if (e.constructor === RegExp) return e.source === n.source && e.flags === n.flags;
        if (e.valueOf !== Object.prototype.valueOf) return e.valueOf() === n.valueOf();
        if (e.toString !== Object.prototype.toString) return e.toString() === n.toString();
        if ((i = (o = Object.keys(e)).length) !== Object.keys(n).length) return !1;
        for(a = i; 0 != a--;)if (!Object.prototype.hasOwnProperty.call(n, o[a])) return !1;
        for(a = i; 0 != a--;){
            var r = o[a];
            if (!t(e[r], n[r])) return !1;
        }
        return !0;
    }
    return e != e && n != n;
};
function $7d0bdd92e4a5843a$var$r(t, e) {
    var n = Object.keys(e || {}).filter(function(n) {
        var i = null == t ? void 0 : t[n], a = null == e ? void 0 : e[n];
        return !$7d0bdd92e4a5843a$var$o(i, a);
    });
    return Object.keys(t || {}).filter(function(t) {
        Object.keys(e || {}).includes(t) || n.push(t);
    }), Object.keys(n).length ? n : null;
}
function $7d0bdd92e4a5843a$var$s(t, e, n) {
    var i = "shortString", a = !0;
    "number" == typeof n && (i = "javaDouble", a = !1), t[i] = t[i] || {}, t[i][e] = a ? n + "" : n;
}
function $7d0bdd92e4a5843a$var$l(t) {
    return !!t && "object" == typeof t && void 0 !== t.value;
}
function $7d0bdd92e4a5843a$var$u(t) {
    return Object.fromEntries(Object.entries(t).map(function(t) {
        var e = t[0], n = t[1];
        return [
            e,
            $7d0bdd92e4a5843a$var$l(n) ? n : {
                value: n
            }
        ];
    }));
}
function $7d0bdd92e4a5843a$var$c(t) {
    return $7d0bdd92e4a5843a$var$e($7d0bdd92e4a5843a$var$e({}, t), {
        identity: t.identity ? $7d0bdd92e4a5843a$var$e($7d0bdd92e4a5843a$var$e({}, t.identity), {
            traits: $7d0bdd92e4a5843a$var$u(t.identity.traits || {})
        }) : void 0
    });
}
var $7d0bdd92e4a5843a$export$7ccaabac143a6ae7, $7d0bdd92e4a5843a$var$d;
!function(t) {
    t.NONE = "NONE", t.DEFAULT_FLAGS = "DEFAULT_FLAGS", t.CACHE = "CACHE", t.SERVER = "SERVER";
}($7d0bdd92e4a5843a$export$7ccaabac143a6ae7 || ($7d0bdd92e4a5843a$export$7ccaabac143a6ae7 = {}));
var $7d0bdd92e4a5843a$var$v, $7d0bdd92e4a5843a$var$g = null, $7d0bdd92e4a5843a$var$f = "FLAGSMITH_EVENT", $7d0bdd92e4a5843a$var$p = "https://edge.api.flagsmith.com/api/v1/", $7d0bdd92e4a5843a$var$y = function() {
    function t(t) {
        var n = this;
        this._trigger = null, this._triggerLoadingState = null, this.timestamp = null, this.isLoading = !1, this.eventSource = null, this.getFlags = function() {
            var t = n, i = t.api, a = t.evaluationContext;
            n.log("Get Flags"), n.isLoading = !0, n.loadingState.isFetching || n.setLoadingState($7d0bdd92e4a5843a$var$e($7d0bdd92e4a5843a$var$e({}, n.loadingState), {
                isFetching: !0
            }));
            var o = "".concat(n.getContext().identity), l = function(t) {
                var i, a, l, u;
                if (t && o === "".concat(n.getContext().identity)) {
                    var c = t.flags, d = t.traits, v = t.identifier;
                    n.isLoading = !1;
                    var g = {}, f = {};
                    d = d || [], (c = c || []).forEach(function(t) {
                        g[t.feature.name.toLowerCase().replace(/ /g, "_")] = {
                            id: t.feature.id,
                            enabled: t.enabled,
                            value: t.feature_state_value
                        };
                    }), d.forEach(function(t) {
                        f[t.trait_key.toLowerCase().replace(/ /g, "_")] = {
                            transient: t.transient,
                            value: t.trait_value
                        };
                    }), n.oldFlags = $7d0bdd92e4a5843a$var$e({}, n.flags);
                    var p = $7d0bdd92e4a5843a$var$r(n.oldFlags, g), y = $7d0bdd92e4a5843a$var$r(null === (i = n.evaluationContext.identity) || void 0 === i ? void 0 : i.traits, f);
                    if ((v || Object.keys(f).length) && (n.evaluationContext.identity = $7d0bdd92e4a5843a$var$e($7d0bdd92e4a5843a$var$e({}, n.evaluationContext.identity), {
                        traits: f
                    }), v && (n.evaluationContext.identity.identifier = v, n.identity = v)), n.flags = g, n.updateStorage(), n._onChange(n.oldFlags, {
                        isFromServer: !0,
                        flagsChanged: p,
                        traitsChanged: y
                    }, n._loadedState(null, $7d0bdd92e4a5843a$export$7ccaabac143a6ae7.SERVER)), n.datadogRum) try {
                        if (n.datadogRum.trackTraits) {
                            var m = {};
                            Object.keys((null === (a = n.evaluationContext.identity) || void 0 === a ? void 0 : a.traits) || {}).map(function(t) {
                                m["flagsmith_trait_" + t] = n.getTrait(t);
                            });
                            var S = $7d0bdd92e4a5843a$var$e($7d0bdd92e4a5843a$var$e($7d0bdd92e4a5843a$var$e({}, n.datadogRum.client.getUser()), {
                                id: n.datadogRum.client.getUser().id || (null === (l = n.evaluationContext.identity) || void 0 === l ? void 0 : l.identifier)
                            }), m);
                            n.log("Setting Datadog user", S), n.datadogRum.client.setUser(S);
                        }
                    } catch (t) {
                        console.error(t);
                    }
                    if (n.dtrum) try {
                        var C = {
                            javaDouble: {},
                            date: {},
                            shortString: {},
                            javaLongOrObject: {}
                        };
                        Object.keys(n.flags).map(function(t) {
                            $7d0bdd92e4a5843a$var$s(C, "flagsmith_value_" + t, n.getValue(t, {
                                skipAnalytics: !0
                            })), $7d0bdd92e4a5843a$var$s(C, "flagsmith_enabled_" + t, n.hasFeature(t, {
                                skipAnalytics: !0
                            }));
                        }), Object.keys((null === (u = n.evaluationContext.identity) || void 0 === u ? void 0 : u.traits) || {}).map(function(t) {
                            $7d0bdd92e4a5843a$var$s(C, "flagsmith_trait_" + t, n.getTrait(t));
                        }), n.log("Sending javaLongOrObject traits to dynatrace", C.javaLongOrObject), n.log("Sending date traits to dynatrace", C.date), n.log("Sending shortString traits to dynatrace", C.shortString), n.log("Sending javaDouble to dynatrace", C.javaDouble), n.dtrum.sendSessionProperties(C.javaLongOrObject, C.date, C.shortString, C.javaDouble);
                    } catch (t) {
                        console.error(t);
                    }
                }
            };
            return a.identity ? Promise.all([
                a.identity.traits && Object.keys(a.identity.traits).length || !a.identity.identifier ? n.getJSON(i + "identities/", "POST", JSON.stringify({
                    identifier: a.identity.identifier,
                    transient: a.identity.transient,
                    traits: Object.entries(a.identity.traits).map(function(t) {
                        var e = t[0], n = t[1];
                        return {
                            trait_key: e,
                            trait_value: null == n ? void 0 : n.value,
                            transient: null == n ? void 0 : n.transient
                        };
                    }).filter(function(t) {
                        return void 0 !== t.trait_value || (n.log("Warning - attempted to set an undefined trait value for key", t.trait_key), !1);
                    })
                })) : n.getJSON(i + "identities/?identifier=" + encodeURIComponent(a.identity.identifier) + (a.identity.transient ? "&transient=true" : ""))
            ]).then(function(t) {
                return n.evaluationContext.identity = $7d0bdd92e4a5843a$var$e($7d0bdd92e4a5843a$var$e({}, n.evaluationContext.identity), {
                    traits: {}
                }), l(null == t ? void 0 : t[0]);
            }).catch(function(t) {
                var e = t.message, n = new Error(e);
                return Promise.reject(n);
            }) : n.getJSON(i + "flags/").then(function(t) {
                return l({
                    flags: t,
                    traits: void 0
                });
            });
        }, this.analyticsFlags = function() {
            var t = n.api;
            if (n.evaluationEvent && n.evaluationContext.environment && n.evaluationEvent[n.evaluationContext.environment.apiKey]) return n.evaluationEvent && 0 !== Object.getOwnPropertyNames(n.evaluationEvent).length && 0 !== Object.getOwnPropertyNames(n.evaluationEvent[n.evaluationContext.environment.apiKey]).length ? n.getJSON(t + "analytics/flags/", "POST", JSON.stringify(n.evaluationEvent[n.evaluationContext.environment.apiKey])).then(function(t) {
                if (n.evaluationContext.environment) {
                    var i = n.getState();
                    n.evaluationEvent || (n.evaluationEvent = {}), n.evaluationEvent[n.evaluationContext.environment.apiKey] = {}, n.setState($7d0bdd92e4a5843a$var$e($7d0bdd92e4a5843a$var$e({}, i), {
                        evaluationEvent: n.evaluationEvent
                    })), n.updateEventStorage();
                }
            }).catch(function(t) {
                n.log("Exception fetching evaluationEvent", t);
            }) : void 0;
        }, this.datadogRum = null, this.loadingState = {
            isLoading: !0,
            isFetching: !0,
            error: null,
            source: $7d0bdd92e4a5843a$export$7ccaabac143a6ae7.NONE
        }, this.canUseStorage = !1, this.analyticsInterval = null, this.api = null, this.cacheFlags = !1, this.enableAnalytics = !1, this.enableLogs = !1, this.evaluationContext = {}, this.evaluationEvent = null, this.flags = null, this.getFlagInterval = null, this.headers = null, this.identity = null, this.initialised = !1, this.oldFlags = null, this.onChange = null, this.onError = null, this.ticks = null, this.timer = null, this.dtrum = null, this.sentryClient = null, this.withTraits = null, this.cacheOptions = {
            ttl: 0,
            skipAPI: !1,
            loadStale: !1,
            storageKey: void 0
        }, this.getValue = function(t, e, i) {
            var a = n.flags && n.flags[t.toLowerCase().replace(/ /g, "_")], o = null;
            if (a && (o = a.value), (null == e ? void 0 : e.skipAnalytics) || i || n.evaluateFlag(t, "VALUE"), null === o && void 0 !== (null == e ? void 0 : e.fallback)) return e.fallback;
            if (null == e ? void 0 : e.json) try {
                return null === o ? (n.log("Tried to parse null flag as JSON: " + t), null) : JSON.parse(o);
            } catch (t) {
                return e.fallback;
            }
            return o;
        }, this.getTrait = function(t) {
            var e, i;
            return (null === (e = n.evaluationContext.identity) || void 0 === e ? void 0 : e.traits) && (null === (i = n.evaluationContext.identity.traits[t.toLowerCase().replace(/ /g, "_")]) || void 0 === i ? void 0 : i.value);
        }, this.getAllTraits = function() {
            var t;
            return Object.fromEntries(Object.entries((null === (t = n.evaluationContext.identity) || void 0 === t ? void 0 : t.traits) || {}).map(function(t) {
                var e = t[0], n = t[1];
                return [
                    e,
                    null == n ? void 0 : n.value
                ];
            }));
        }, this.setContext = function(t) {
            var i, a, o = $7d0bdd92e4a5843a$var$c(t);
            return n.evaluationContext = $7d0bdd92e4a5843a$var$e($7d0bdd92e4a5843a$var$e({}, o), {
                environment: o.environment || n.evaluationContext.environment
            }), n.identity = null === (a = null === (i = n.getContext()) || void 0 === i ? void 0 : i.identity) || void 0 === a ? void 0 : a.identifier, n.initialised ? n.getFlags() : Promise.resolve();
        }, this.getContext = function() {
            return n.evaluationContext;
        }, this.updateContext = function(t) {
            return n.setContext($7d0bdd92e4a5843a$var$e($7d0bdd92e4a5843a$var$e({}, n.getContext()), t));
        }, this.setTrait = function(t, i) {
            var a;
            if (n.api) return n.setContext($7d0bdd92e4a5843a$var$e($7d0bdd92e4a5843a$var$e({}, n.evaluationContext), {
                identity: $7d0bdd92e4a5843a$var$e($7d0bdd92e4a5843a$var$e({}, n.evaluationContext.identity), {
                    traits: $7d0bdd92e4a5843a$var$e($7d0bdd92e4a5843a$var$e({}, null === (a = n.evaluationContext.identity) || void 0 === a ? void 0 : a.traits), $7d0bdd92e4a5843a$var$u(Object.fromEntries([
                        [
                            t,
                            i
                        ]
                    ])))
                })
            }));
        }, this.setTraits = function(t) {
            var i;
            if (n.api) return n.setContext($7d0bdd92e4a5843a$var$e($7d0bdd92e4a5843a$var$e({}, n.evaluationContext), {
                identity: $7d0bdd92e4a5843a$var$e($7d0bdd92e4a5843a$var$e({}, n.evaluationContext.identity), {
                    traits: $7d0bdd92e4a5843a$var$e($7d0bdd92e4a5843a$var$e({}, null === (i = n.evaluationContext.identity) || void 0 === i ? void 0 : i.traits), Object.fromEntries(Object.entries(t).map(function(t) {
                        var e = t[0], n = t[1];
                        return [
                            e,
                            $7d0bdd92e4a5843a$var$l(n) ? n : {
                                value: n
                            }
                        ];
                    })))
                })
            }));
            console.error("Attempted to setTraits a user before calling flagsmith.init. Call flagsmith.init first, if you wish to prevent it sending a request for flags, call init with preventFetch:true.");
        }, this.hasFeature = function(t, e) {
            var i, a, o = "object" == typeof e, r = n.flags && n.flags[t.toLowerCase().replace(/ /g, "_")], s = !1;
            if (!r && o && void 0 !== e.fallback ? s = null == e ? void 0 : e.fallback : r && r.enabled && (s = !0), (o && !e.skipAnalytics || !e) && n.evaluateFlag(t, "ENABLED"), n.sentryClient) try {
                null === (a = null === (i = n.sentryClient.getIntegrationByName("FeatureFlags")) || void 0 === i ? void 0 : i.addFeatureFlag) || void 0 === a || a.call(i, t, s);
            } catch (t) {
                console.error(t);
            }
            return s;
        }, this.getStorageKey = function() {
            var t, e;
            return (null === (t = n.cacheOptions) || void 0 === t ? void 0 : t.storageKey) || "FLAGSMITH_DB_" + (null === (e = n.evaluationContext.environment) || void 0 === e ? void 0 : e.apiKey);
        }, this.getJSON = function(t, e, i) {
            var a, o, r, s = n.headers, l = {
                method: e || "GET",
                body: i,
                cache: "no-cache",
                headers: {}
            };
            n.evaluationContext.environment && (l.headers["X-Environment-Key"] = n.evaluationContext.environment.apiKey), e && "GET" !== e && (l.headers["Content-Type"] = "application/json; charset=utf-8"), (null === (a = n.applicationMetadata) || void 0 === a ? void 0 : a.name) && (l.headers["Flagsmith-Application-Name"] = n.applicationMetadata.name), (null === (o = n.applicationMetadata) || void 0 === o ? void 0 : o.version) && (l.headers["Flagsmith-Application-Version"] = n.applicationMetadata.version), l.headers["Flagsmith-SDK-User-Agent"] = "flagsmith-js-sdk/".concat("10.0.0"), s && Object.assign(l.headers, s), $7d0bdd92e4a5843a$var$d || console.error("Flagsmith: fetch is undefined, please specify a fetch implementation into flagsmith.init to support SSR.");
            var u = "".concat(null === (r = n.evaluationContext.identity) || void 0 === r ? void 0 : r.identifier);
            return $7d0bdd92e4a5843a$var$d(t, l).then(function(i) {
                var a, o, r = "".concat(null === (a = n.evaluationContext.identity) || void 0 === a ? void 0 : a.identifier);
                if (u === r) {
                    var s = null === (o = i.headers) || void 0 === o ? void 0 : o.get("x-flagsmith-document-updated-at");
                    if (s) try {
                        var l = parseFloat(s);
                        if (isNaN(l)) return Promise.reject("Failed to parse x-flagsmith-document-updated-at");
                        n.timestamp = l;
                    } catch (t) {
                        n.log(t, "Failed to parse x-flagsmith-document-updated-at", s);
                    }
                    return n.log("Fetch response: " + i.status + " " + (e || "GET") + 0 + t), i.text().then(function(t) {
                        var e = t;
                        try {
                            e = JSON.parse(t);
                        } catch (t) {}
                        return !e && i.status && (e = "API Response: ".concat(i.status)), i.status && i.status >= 200 && i.status < 300 ? e : Promise.reject(new Error(e));
                    });
                }
                n.log("Received response with identity mismatch, ignoring response. Requested: ".concat(u, ", Current: ").concat(r));
            });
        }, this.evaluateFlag = function(t, e) {
            if (n.datadogRum && (n.datadogRum.client.addFeatureFlagEvaluation ? "VALUE" === e ? n.datadogRum.client.addFeatureFlagEvaluation("flagsmith_value_" + t, n.getValue(t, {}, !0)) : n.datadogRum.client.addFeatureFlagEvaluation("flagsmith_enabled_" + t, n.hasFeature(t, !0)) : console.error("Flagsmith: Your datadog RUM client does not support the function addFeatureFlagEvaluation, please update it.")), n.enableAnalytics) {
                if (!n.evaluationEvent || !n.evaluationContext.environment) return;
                n.evaluationEvent[n.evaluationContext.environment.apiKey] || (n.evaluationEvent[n.evaluationContext.environment.apiKey] = {}), void 0 === n.evaluationEvent[n.evaluationContext.environment.apiKey][t] && (n.evaluationEvent[n.evaluationContext.environment.apiKey][t] = 0), n.evaluationEvent[n.evaluationContext.environment.apiKey][t] += 1;
            }
            n.updateEventStorage();
        }, this._onChange = function(t, e, i) {
            var a, o;
            n.setLoadingState(i), null === (a = n.onChange) || void 0 === a || a.call(n, t, e, n.loadingState), null === (o = n._trigger) || void 0 === o || o.call(n);
        }, $7d0bdd92e4a5843a$var$d = t.fetch ? t.fetch : "undefined" != typeof fetch ? fetch : null === $parcel$global || void 0 === $parcel$global ? void 0 : $parcel$global.fetch, this.canUseStorage = "undefined" != typeof window || !!t.browserlessStorage, this.applicationMetadata = t.applicationMetadata, this.log("Constructing flagsmith instance " + t), t.eventSource && ($7d0bdd92e4a5843a$var$v = t.eventSource), t.AsyncStorage && ($7d0bdd92e4a5843a$var$g = t.AsyncStorage);
    }
    return t.prototype.init = function(t) {
        var a, o, s, l;
        return $7d0bdd92e4a5843a$var$n(this, void 0, void 0, function() {
            var u, v, y, m, S, C, _, b, E, x, O, F, w, I, L, A, j, k, T, N, P, R, K, D, U, G, J, M, H, V, q, B, W, X, Y, $ = this;
            return $7d0bdd92e4a5843a$var$i(this, function(z) {
                switch(z.label){
                    case 0:
                        u = $7d0bdd92e4a5843a$var$c(t.evaluationContext || this.evaluationContext), z.label = 1;
                    case 1:
                        if (z.trys.push([
                            1,
                            13,
                            ,
                            14
                        ]), v = t.AsyncStorage, y = t._trigger, m = t._triggerLoadingState, S = t.angularHttpClient, C = t.api, _ = void 0 === C ? $7d0bdd92e4a5843a$var$p : C, b = t.applicationMetadata, E = t.cacheFlags, x = t.cacheOptions, O = t.datadogRum, F = t.defaultFlags, w = t.enableAnalytics, I = t.enableDynatrace, L = t.enableLogs, A = t.environmentID, j = t.eventSourceUrl, k = void 0 === j ? "https://realtime.flagsmith.com/" : j, T = t.fetch, N = t.headers, P = t.identity, R = t.onChange, K = t.onError, D = t.preventFetch, U = t.realtime, G = t.sentryClient, J = t.state, M = t.traits, u.environment = A ? {
                            apiKey: A
                        } : u.environment, !u.environment || !u.environment.apiKey) throw new Error("Please provide `evaluationContext.environment` with non-empty `apiKey`");
                        if (u.identity = P || M ? {
                            identifier: P,
                            traits: M ? Object.fromEntries(Object.entries(M).map(function(t) {
                                return [
                                    t[0],
                                    {
                                        value: t[1]
                                    }
                                ];
                            })) : {}
                        } : u.identity, this.evaluationContext = u, this.api = (Q = _).endsWith("/") ? Q : Q + "/", this.headers = N, this.getFlagInterval = null, this.analyticsInterval = null, this.onChange = R, H = "Wrong Flagsmith Configuration: preventFetch is true and no defaulFlags provided", this._trigger = y || this._trigger, this._triggerLoadingState = m || this._triggerLoadingState, this.onError = function(t) {
                            $.setLoadingState($7d0bdd92e4a5843a$var$e($7d0bdd92e4a5843a$var$e({}, $.loadingState), {
                                isFetching: !1,
                                isLoading: !1,
                                error: t
                            })), null == K || K(t);
                        }, this.enableLogs = L || !1, this.cacheOptions = x ? {
                            skipAPI: !!x.skipAPI,
                            ttl: x.ttl || 0,
                            storageKey: x.storageKey,
                            loadStale: !!x.loadStale
                        } : this.cacheOptions, !this.cacheOptions.ttl && this.cacheOptions.skipAPI && console.warn("Flagsmith: you have set a cache ttl of 0 and are skipping API calls, this means the API will not be hit unless you clear local storage."), T && ($7d0bdd92e4a5843a$var$d = T), this.enableAnalytics = w || !1, this.flags = Object.assign({}, F) || {}, this.datadogRum = O || null, this.initialised = !0, this.ticks = 1e4, this.timer = this.enableLogs ? (new Date).valueOf() : null, this.cacheFlags = void 0 !== $7d0bdd92e4a5843a$var$g && !!E, this.applicationMetadata = b, $7d0bdd92e4a5843a$var$f = "FLAGSMITH_EVENT_" + u.environment.apiKey, v && ($7d0bdd92e4a5843a$var$g = v), U && "undefined" != typeof window && this.setupRealtime(k, u.environment.apiKey), Object.keys(this.flags).length && (this.loadingState = $7d0bdd92e4a5843a$var$e($7d0bdd92e4a5843a$var$e({}, this.loadingState), {
                            isLoading: !1,
                            source: $7d0bdd92e4a5843a$export$7ccaabac143a6ae7.DEFAULT_FLAGS
                        })), this.setState(J), this.log("Initialising with properties", t, this), I && ("undefined" == typeof dtrum ? console.error("You have attempted to enable dynatrace but dtrum is undefined, please check you have the Dynatrace RUM JavaScript API installed.") : this.dtrum = dtrum), G && (this.sentryClient = G), S && ($7d0bdd92e4a5843a$var$d = function(t) {
                            return function(e, n) {
                                var i = n.headers, a = n.method, o = n.body, r = {
                                    headers: i,
                                    observe: "response",
                                    responseType: "text"
                                }, s = function(t, e) {
                                    var n = t.status, i = t.headers, a = t.body, o = t.error, r = t.message;
                                    return {
                                        status: null != n ? n : e ? 200 : 500,
                                        ok: e,
                                        headers: {
                                            get: function(t) {
                                                var e, n;
                                                return null !== (n = null === (e = null == i ? void 0 : i.get) || void 0 === e ? void 0 : e.call(i, t)) && void 0 !== n ? n : null;
                                            }
                                        },
                                        text: function() {
                                            var t, e, n = null !== (e = null !== (t = null != a ? a : o) && void 0 !== t ? t : r) && void 0 !== e ? e : "";
                                            return Promise.resolve("string" != typeof n ? JSON.stringify(n) : n);
                                        }
                                    };
                                };
                                return new Promise(function(n) {
                                    var i = function(t) {
                                        return n(s(t, !t.status || t.status >= 200 && t.status < 300));
                                    }, l = function(t) {
                                        return n(s(t, !1));
                                    };
                                    switch(a){
                                        case "GET":
                                            return t.get(e, r).subscribe(i, l);
                                        case "POST":
                                        case "PUT":
                                            return t.post(e, null != o ? o : "", r).subscribe(i, l);
                                        default:
                                            return l({
                                                status: 405,
                                                message: "Unsupported method: ".concat(a)
                                            });
                                    }
                                });
                            };
                        }(S)), $7d0bdd92e4a5843a$var$g && this.canUseStorage && $7d0bdd92e4a5843a$var$g.getItem($7d0bdd92e4a5843a$var$f).then(function(t) {
                            try {
                                $.evaluationEvent = JSON.parse(t) || {};
                            } catch (t) {
                                $.evaluationEvent = {};
                            }
                            $.analyticsInterval = setInterval($.analyticsFlags, $.ticks);
                        }), this.enableAnalytics && (this.analyticsInterval && clearInterval(this.analyticsInterval), $7d0bdd92e4a5843a$var$g && this.canUseStorage && $7d0bdd92e4a5843a$var$g.getItem($7d0bdd92e4a5843a$var$f, function(t, n) {
                            if (n && $.evaluationContext.environment) {
                                var i = JSON.parse(n);
                                if (i[$.evaluationContext.environment.apiKey]) {
                                    var a = $.getState();
                                    $.log("Retrieved events from cache", n), $.setState($7d0bdd92e4a5843a$var$e($7d0bdd92e4a5843a$var$e({}, a), {
                                        evaluationEvent: i[$.evaluationContext.environment.apiKey]
                                    }));
                                }
                            }
                        })), !E) return [
                            3,
                            9
                        ];
                        if (!$7d0bdd92e4a5843a$var$g || !this.canUseStorage) return [
                            3,
                            8
                        ];
                        V = function(t, a) {
                            return $7d0bdd92e4a5843a$var$n($, void 0, void 0, function() {
                                var t, n, o, s, l, u, d, v, g, f, p, y, m, S, C, _, b, E, x, O = this;
                                return $7d0bdd92e4a5843a$var$i(this, function(i) {
                                    switch(i.label){
                                        case 0:
                                            if (!a) return [
                                                3,
                                                7
                                            ];
                                            t = null, n = null, i.label = 1;
                                        case 1:
                                            return i.trys.push([
                                                1,
                                                5,
                                                ,
                                                6
                                            ]), o = JSON.parse(a), s = !1, l = !1, o && o.api === this.api && (null === (f = null === (g = o.evaluationContext) || void 0 === g ? void 0 : g.environment) || void 0 === f ? void 0 : f.apiKey) === (null === (p = this.evaluationContext.environment) || void 0 === p ? void 0 : p.apiKey) && (u = !0, this.evaluationContext.identity && (null === (m = null === (y = o.evaluationContext) || void 0 === y ? void 0 : y.identity) || void 0 === m ? void 0 : m.identifier) !== this.evaluationContext.identity.identifier && (this.log("Ignoring cache, identity has changed from " + (null === (C = null === (S = o.evaluationContext) || void 0 === S ? void 0 : S.identity) || void 0 === C ? void 0 : C.identifier) + " to " + this.evaluationContext.identity.identifier), u = !1), this.cacheOptions.ttl && (!o.ts || (new Date).valueOf() - o.ts > this.cacheOptions.ttl) && (o.ts && !this.cacheOptions.loadStale ? (this.log("Ignoring cache, timestamp is too old ts:" + o.ts + " ttl: " + this.cacheOptions.ttl + " time elapsed since cache: " + ((new Date).valueOf() - o.ts) + "ms"), u = !1) : o.ts && this.cacheOptions.loadStale && (this.log("Loading stale cache, timestamp ts:" + o.ts + " ttl: " + this.cacheOptions.ttl + " time elapsed since cache: " + ((new Date).valueOf() - o.ts) + "ms"), l = !0, u = !0)), u && (s = !0, t = $7d0bdd92e4a5843a$var$r(this.flags, o.flags), this.setState($7d0bdd92e4a5843a$var$e($7d0bdd92e4a5843a$var$e({}, o), {
                                                evaluationContext: $7d0bdd92e4a5843a$var$c($7d0bdd92e4a5843a$var$e($7d0bdd92e4a5843a$var$e({}, o.evaluationContext), {
                                                    identity: (null === (_ = o.evaluationContext) || void 0 === _ ? void 0 : _.identity) ? $7d0bdd92e4a5843a$var$e($7d0bdd92e4a5843a$var$e({}, null === (b = o.evaluationContext) || void 0 === b ? void 0 : b.identity), {
                                                        traits: $7d0bdd92e4a5843a$var$e({}, M || {})
                                                    }) : void 0
                                                }))
                                            })), this.log("Retrieved flags from cache", o))), s ? (d = !D && (!this.cacheOptions.skipAPI || l), this._onChange(null, {
                                                isFromServer: !1,
                                                flagsChanged: t,
                                                traitsChanged: n
                                            }, this._loadedState(null, $7d0bdd92e4a5843a$export$7ccaabac143a6ae7.CACHE, d)), this.oldFlags = this.flags, this.cacheOptions.skipAPI && s && !l && this.log("Skipping API, using cache"), d && this.getFlags().catch(function(t) {
                                                var e;
                                                null === (e = O.onError) || void 0 === e || e.call(O, t);
                                            }), [
                                                3,
                                                4
                                            ]) : [
                                                3,
                                                2
                                            ];
                                        case 2:
                                            return D ? [
                                                3,
                                                4
                                            ] : [
                                                4,
                                                this.getFlags()
                                            ];
                                        case 3:
                                            i.sent(), i.label = 4;
                                        case 4:
                                            return [
                                                3,
                                                6
                                            ];
                                        case 5:
                                            throw v = i.sent(), this.log("Exception fetching cached logs", v), v;
                                        case 6:
                                            return [
                                                3,
                                                10
                                            ];
                                        case 7:
                                            return D ? [
                                                3,
                                                9
                                            ] : [
                                                4,
                                                this.getFlags()
                                            ];
                                        case 8:
                                            return i.sent(), [
                                                3,
                                                10
                                            ];
                                        case 9:
                                            if (F) this._onChange(null, {
                                                isFromServer: !1,
                                                flagsChanged: $7d0bdd92e4a5843a$var$r({}, this.flags),
                                                traitsChanged: $7d0bdd92e4a5843a$var$r({}, null === (E = this.evaluationContext.identity) || void 0 === E ? void 0 : E.traits)
                                            }, this._loadedState(null, $7d0bdd92e4a5843a$export$7ccaabac143a6ae7.DEFAULT_FLAGS));
                                            else {
                                                if (!this.flags) throw new Error(H);
                                                this._onChange(null, {
                                                    isFromServer: !1,
                                                    flagsChanged: $7d0bdd92e4a5843a$var$r({}, this.flags),
                                                    traitsChanged: $7d0bdd92e4a5843a$var$r({}, null === (x = this.evaluationContext.identity) || void 0 === x ? void 0 : x.traits)
                                                }, this._loadedState(null, $7d0bdd92e4a5843a$export$7ccaabac143a6ae7.DEFAULT_FLAGS));
                                            }
                                            i.label = 10;
                                        case 10:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                        }, z.label = 2;
                    case 2:
                        return z.trys.push([
                            2,
                            7,
                            ,
                            8
                        ]), $7d0bdd92e4a5843a$var$g.getItemSync ? (q = $7d0bdd92e4a5843a$var$g.getItemSync(this.getStorageKey()), [
                            3,
                            5
                        ]) : [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            4,
                            $7d0bdd92e4a5843a$var$g.getItem(this.getStorageKey())
                        ];
                    case 4:
                        q = z.sent(), z.label = 5;
                    case 5:
                        return [
                            4,
                            V(null, q)
                        ];
                    case 6:
                        return z.sent(), [
                            3,
                            8
                        ];
                    case 7:
                        if (B = z.sent(), !this.flags || 0 === Object.keys(this.flags).length) throw B;
                        return Y = B instanceof Error ? B : new Error("".concat(B)), null === (a = this.onError) || void 0 === a || a.call(this, Y), [
                            3,
                            8
                        ];
                    case 8:
                        return [
                            3,
                            12
                        ];
                    case 9:
                        return D ? [
                            3,
                            11
                        ] : [
                            4,
                            this.getFlags()
                        ];
                    case 10:
                        return z.sent(), [
                            3,
                            12
                        ];
                    case 11:
                        if (F) this._onChange(null, {
                            isFromServer: !1,
                            flagsChanged: $7d0bdd92e4a5843a$var$r({}, F),
                            traitsChanged: $7d0bdd92e4a5843a$var$r({}, null === (o = u.identity) || void 0 === o ? void 0 : o.traits)
                        }, this._loadedState(null, $7d0bdd92e4a5843a$export$7ccaabac143a6ae7.DEFAULT_FLAGS));
                        else if (this.flags && (W = null, 0 === Object.keys(this.flags).length && (W = H), this._onChange(null, {
                            isFromServer: !1,
                            flagsChanged: $7d0bdd92e4a5843a$var$r({}, this.flags),
                            traitsChanged: $7d0bdd92e4a5843a$var$r({}, null === (s = u.identity) || void 0 === s ? void 0 : s.traits)
                        }, this._loadedState(W, $7d0bdd92e4a5843a$export$7ccaabac143a6ae7.DEFAULT_FLAGS)), W)) throw new Error(W);
                        z.label = 12;
                    case 12:
                        return [
                            3,
                            14
                        ];
                    case 13:
                        throw X = z.sent(), this.log("Error during initialisation ", X), Y = X instanceof Error ? X : new Error("".concat(X)), null === (l = this.onError) || void 0 === l || l.call(this, Y), X;
                    case 14:
                        return [
                            2
                        ];
                }
                var Q;
            });
        });
    }, t.prototype.getAllFlags = function() {
        return this.flags;
    }, t.prototype.identify = function(t, e, n) {
        return this.identity = t, this.evaluationContext.identity = {
            identifier: t,
            transient: n,
            traits: this.evaluationContext.identity && this.evaluationContext.identity.identifier == t ? this.evaluationContext.identity.traits : {}
        }, this.evaluationContext.identity.identifier = t, this.log("Identify: " + this.evaluationContext.identity.identifier), e && (this.evaluationContext.identity.traits = Object.fromEntries(Object.entries(e).map(function(t) {
            var e = t[0], n = t[1];
            return [
                e,
                $7d0bdd92e4a5843a$var$l(n) ? n : {
                    value: n
                }
            ];
        }))), this.initialised ? this.getFlags() : Promise.resolve();
    }, t.prototype.getState = function() {
        return {
            api: this.api,
            flags: this.flags,
            ts: this.ts,
            evaluationContext: this.evaluationContext,
            identity: this.identity,
            evaluationEvent: this.evaluationEvent
        };
    }, t.prototype.setState = function(t) {
        var e, n;
        t && (this.initialised = !0, this.api = t.api || this.api || $7d0bdd92e4a5843a$var$p, this.flags = t.flags || this.flags, this.evaluationContext = t.evaluationContext || this.evaluationContext, this.evaluationEvent = t.evaluationEvent || this.evaluationEvent, this.identity = null === (n = null === (e = this.getContext()) || void 0 === e ? void 0 : e.identity) || void 0 === n ? void 0 : n.identifier, this.log("setState called", this));
    }, t.prototype.logout = function() {
        return this.identity = null, this.evaluationContext.identity = null, this.initialised ? this.getFlags() : Promise.resolve();
    }, t.prototype.startListening = function(t) {
        void 0 === t && (t = 1e3), this.getFlagInterval && clearInterval(this.getFlagInterval), this.getFlagInterval = setInterval(this.getFlags, t);
    }, t.prototype.stopListening = function() {
        this.getFlagInterval && (clearInterval(this.getFlagInterval), this.getFlagInterval = null);
    }, t.prototype._loadedState = function(t, e, n) {
        return void 0 === t && (t = null), void 0 === n && (n = !1), {
            error: t,
            isFetching: n,
            isLoading: !1,
            source: e
        };
    }, t.prototype.log = function() {
        for(var t = [], e = 0; e < arguments.length; e++)t[e] = arguments[e];
        this.enableLogs && console.log.apply(this, $7d0bdd92e4a5843a$var$a([
            "FLAGSMITH:",
            (new Date).valueOf() - (this.timer || 0),
            "ms"
        ], t, !0));
    }, t.prototype.updateStorage = function() {
        if (this.cacheFlags) {
            this.ts = (new Date).valueOf();
            var t = JSON.stringify(this.getState());
            this.log("Setting storage", t), $7d0bdd92e4a5843a$var$g.setItem(this.getStorageKey(), t);
        }
    }, t.prototype.updateEventStorage = function() {
        if (this.enableAnalytics) {
            var t = JSON.stringify(this.getState().evaluationEvent);
            $7d0bdd92e4a5843a$var$g.setItem($7d0bdd92e4a5843a$var$f, t).catch(function(t) {
                return console.error("Flagsmith: Error setting item in async storage", t);
            });
        }
    }, t.prototype.setLoadingState = function(t) {
        var n;
        $7d0bdd92e4a5843a$var$o(t, this.loadingState) || (this.loadingState = $7d0bdd92e4a5843a$var$e({}, t), this.log("Loading state changed", t), null === (n = this._triggerLoadingState) || void 0 === n || n.call(this));
    }, t.prototype.setupRealtime = function(t, e) {
        var n = this, i = t + "sse/environments/" + e + "/stream";
        $7d0bdd92e4a5843a$var$v ? this.eventSource || (this.log("Creating event source with url " + i), this.eventSource = new $7d0bdd92e4a5843a$var$v(i), this.eventSource.addEventListener("environment_updated", function(t) {
            var e;
            try {
                e = JSON.parse(t.data).updated_at;
            } catch (t) {
                n.log("Could not parse sse event", t);
            }
            e ? !n.timestamp || e > n.timestamp ? n.isLoading ? n.log("updated_at is new, but flags are loading", t.data, n.timestamp) : (n.log("updated_at is new, fetching flags", t.data, n.timestamp), n.getFlags()) : n.log("updated_at is outdated, skipping get flags", t.data, n.timestamp) : n.log("No updated_at received, fetching flags", t);
        })) : this.log("Error, EventSource is undefined");
    }, t;
}();
function $7d0bdd92e4a5843a$var$m(t) {
    var e = t.fetch, n = t.AsyncStorage, i = t.eventSource;
    return new $7d0bdd92e4a5843a$var$y({
        fetch: e,
        AsyncStorage: n,
        eventSource: i
    });
}
var $7d0bdd92e4a5843a$var$S, $7d0bdd92e4a5843a$var$C = ($7d0bdd92e4a5843a$var$S = function(t, e) {
    return $7d0bdd92e4a5843a$var$S = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(t, e) {
        t.__proto__ = e;
    } || function(t, e) {
        for(var n in e)Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
    }, $7d0bdd92e4a5843a$var$S(t, e);
}, function(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    function n() {
        this.constructor = t;
    }
    $7d0bdd92e4a5843a$var$S(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n);
}), $7d0bdd92e4a5843a$var$_ = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, n = e && t[e], i = 0;
    if (n) return n.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && i >= t.length && (t = void 0), {
                value: t && t[i++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $7d0bdd92e4a5843a$var$b = function(t, e) {
    var n = "function" == typeof Symbol && t[Symbol.iterator];
    if (!n) return t;
    var i, a, o = n.call(t), r = [];
    try {
        for(; (void 0 === e || e-- > 0) && !(i = o.next()).done;)r.push(i.value);
    } catch (t) {
        a = {
            error: t
        };
    } finally{
        try {
            i && !i.done && (n = o.return) && n.call(o);
        } finally{
            if (a) throw a.error;
        }
    }
    return r;
}, $7d0bdd92e4a5843a$var$E = function(t, e, n) {
    if (n || 2 === arguments.length) for(var i, a = 0, o = e.length; a < o; a++)!i && a in e || (i || (i = Array.prototype.slice.call(e, 0, a)), i[a] = e[a]);
    return t.concat(i || Array.prototype.slice.call(e));
}, $7d0bdd92e4a5843a$var$x = function(t) {
    function e() {
        return t.call(this, "EventSource not available.\nConsider loading an EventSource polyfill and making it available globally as EventSource, or passing one in as eventSourceClass to the ReconnectingEventSource constructor.") || this;
    }
    return $7d0bdd92e4a5843a$var$C(e, t), e;
}(Error), $7d0bdd92e4a5843a$var$O = function() {
    function t(t, e) {
        var n = this;
        if (this.CONNECTING = 0, this.OPEN = 1, this.CLOSED = 2, this._configuration = null != e ? Object.assign({}, e) : void 0, this.withCredentials = !1, this._eventSource = null, this._lastEventId = null, this._timer = null, this._listeners = {
            open: [],
            error: [],
            message: []
        }, this.url = t.toString(), this.readyState = this.CONNECTING, this.max_retry_time = 3e3, this.eventSourceClass = globalThis.FlagsmithEventSource, null != this._configuration && (this._configuration.lastEventId && (this._lastEventId = this._configuration.lastEventId, delete this._configuration.lastEventId), this._configuration.max_retry_time && (this.max_retry_time = this._configuration.max_retry_time, delete this._configuration.max_retry_time), this._configuration.eventSourceClass && (this.eventSourceClass = this._configuration.eventSourceClass, delete this._configuration.eventSourceClass)), null == this.eventSourceClass || "function" != typeof this.eventSourceClass) throw new $7d0bdd92e4a5843a$var$x;
        this._onevent_wrapped = function(t) {
            n._onevent(t);
        }, this._start();
    }
    return t.prototype.dispatchEvent = function(t) {
        throw new Error("Method not implemented.");
    }, t.prototype._start = function() {
        var t, e, n = this, i = this.url;
        this._lastEventId && (-1 === i.indexOf("?") ? i += "?" : i += "&", i += "lastEventId=" + encodeURIComponent(this._lastEventId)), this._eventSource = new this.eventSourceClass(i, this._configuration), this._eventSource.onopen = function(t) {
            n._onopen(t);
        }, this._eventSource.onerror = function(t) {
            n._onerror(t);
        }, this._eventSource.onmessage = function(t) {
            n.onmessage(t);
        };
        try {
            for(var a = $7d0bdd92e4a5843a$var$_(Object.keys(this._listeners)), o = a.next(); !o.done; o = a.next()){
                var r = o.value;
                this._eventSource.addEventListener(r, this._onevent_wrapped);
            }
        } catch (e) {
            t = {
                error: e
            };
        } finally{
            try {
                o && !o.done && (e = a.return) && e.call(a);
            } finally{
                if (t) throw t.error;
            }
        }
    }, t.prototype._onopen = function(t) {
        0 === this.readyState && (this.readyState = 1, this.onopen(t));
    }, t.prototype._onerror = function(t) {
        var e = this;
        if (1 === this.readyState && (this.readyState = 0, this.onerror(t)), this._eventSource) {
            this._eventSource.close(), this._eventSource = null;
            var n = Math.round(this.max_retry_time * Math.random());
            this._timer = setTimeout(function() {
                return e._start();
            }, n);
        }
    }, t.prototype._onevent = function(t) {
        var e, n;
        t && t.lastEventId && (this._lastEventId = t.lastEventId);
        var i = this._listeners[t.type];
        if (null != i) try {
            for(var a = $7d0bdd92e4a5843a$var$_($7d0bdd92e4a5843a$var$E([], $7d0bdd92e4a5843a$var$b(i), !1)), o = a.next(); !o.done; o = a.next())o.value.call(this, t);
        } catch (t) {
            e = {
                error: t
            };
        } finally{
            try {
                o && !o.done && (n = a.return) && n.call(a);
            } finally{
                if (e) throw e.error;
            }
        }
        "message" === t.type && this.onmessage(t);
    }, t.prototype.onopen = function(t) {}, t.prototype.onerror = function(t) {}, t.prototype.onmessage = function(t) {}, t.prototype.close = function() {
        this._timer && (clearTimeout(this._timer), this._timer = null), this._eventSource && (this._eventSource.close(), this._eventSource = null), this.readyState = 2;
    }, t.prototype.addEventListener = function(t, e, n) {
        null == this._listeners[t] && (this._listeners[t] = [], null != this._eventSource && this._eventSource.addEventListener(t, this._onevent_wrapped));
        var i = this._listeners[t];
        i.includes(e) || (this._listeners[t] = $7d0bdd92e4a5843a$var$E($7d0bdd92e4a5843a$var$E([], $7d0bdd92e4a5843a$var$b(i), !1), [
            e
        ], !1));
    }, t.prototype.removeEventListener = function(t, e, n) {
        var i = this._listeners[t];
        this._listeners[t] = i.filter(function(t) {
            return t !== e;
        });
    }, t;
}();
globalThis.FlagsmithEventSource = "undefined" != typeof EventSource ? EventSource : null;
var $7d0bdd92e4a5843a$var$F = function(t, e) {
    return e = e || {}, new Promise(function(n, i) {
        var a = new XMLHttpRequest, o = [], r = [], s = {}, l = function() {
            return {
                ok: 2 == (a.status / 100 | 0),
                statusText: a.statusText,
                status: a.status,
                url: a.responseURL,
                text: function() {
                    return Promise.resolve(a.responseText);
                },
                json: function() {
                    return Promise.resolve(a.responseText).then(JSON.parse);
                },
                blob: function() {
                    return Promise.resolve(new Blob([
                        a.response
                    ]));
                },
                clone: l,
                headers: {
                    keys: function() {
                        return o;
                    },
                    entries: function() {
                        return r;
                    },
                    get: function(t) {
                        return s[t.toLowerCase()];
                    },
                    has: function(t) {
                        return t.toLowerCase() in s;
                    }
                }
            };
        };
        for(var u in a.open(e.method || "get", t, !0), a.onload = function() {
            a.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function(t, e, n) {
                o.push(e = e.toLowerCase()), r.push([
                    e,
                    n
                ]), s[e] = s[e] ? s[e] + "," + n : n;
            }), n(l());
        }, a.onerror = i, a.withCredentials = "include" == e.credentials, e.headers)a.setRequestHeader(u, e.headers[u]);
        a.send(e.body || null);
    });
}, $7d0bdd92e4a5843a$export$2e2bcd8739ae039 = $7d0bdd92e4a5843a$var$m({
    AsyncStorage: $7d0bdd92e4a5843a$var$t,
    fetch: $7d0bdd92e4a5843a$var$F,
    eventSource: $7d0bdd92e4a5843a$var$O
});
"undefined" != typeof window && (window.flagsmith = $7d0bdd92e4a5843a$export$2e2bcd8739ae039);
var $7d0bdd92e4a5843a$export$b6fa0bdb0b660928 = function() {
    return $7d0bdd92e4a5843a$var$m({
        AsyncStorage: $7d0bdd92e4a5843a$var$t,
        fetch: $7d0bdd92e4a5843a$var$F,
        eventSource: $7d0bdd92e4a5843a$var$O
    });
};



var $lCzvA = parcelRequire("lCzvA");
var $fda7e4dd83174a6e$var$l = function() {
    return $fda7e4dd83174a6e$var$l = Object.assign || function(t) {
        for(var n, e = 1, r = arguments.length; e < r; e++)for(var i in n = arguments[e])Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
        return t;
    }, $fda7e4dd83174a6e$var$l.apply(this, arguments);
}, $fda7e4dd83174a6e$var$c = new (function() {
    function t() {
        this.e = {};
    }
    return t.prototype.generateCallbackId = function() {
        return Math.random().toString(36).substring(7);
    }, t.prototype.on = function(t, n, e) {
        var r = this, i = this.e || (this.e = {}), o = this.generateCallbackId(), a = {
            id: o,
            fn: n,
            ctx: e
        };
        (i[t] || (i[t] = [])).push(a);
        return (function() {
            r.off(t, o);
        }).bind(this);
    }, t.prototype.once = function(t, n, e) {
        var r = this, i = this.generateCallbackId();
        function o() {
            for(var o = [], a = 0; a < arguments.length; a++)o[a] = arguments[a];
            r.off(t, i), n.apply(e, o);
        }
        return o._ = n, this.on(t, o, e);
    }, t.prototype.emit = function(t) {
        for(var n = [], e = 1; e < arguments.length; e++)n[e - 1] = arguments[e];
        for(var r = ((this.e || (this.e = {}))[t] || []).slice(), i = r.length, o = 0; o < i; o++)r[o].fn.apply(r[o].ctx, n);
        return this;
    }, t.prototype.off = function(t, n, e) {
        var r = this.e || (this.e = {}), i = r[t], o = [];
        if (i && n) for(var a = 0, u = i.length; a < u; a++)("function" == typeof n && i[a].fn !== n || "string" == typeof n && i[a].id !== n) && o.push(i[a]);
        return o.length ? r[t] = o : delete r[t], this;
    }, t;
}()), $fda7e4dd83174a6e$export$d20ba6ba2e7f6098 = (0, $lCzvA.createContext)(null), $fda7e4dd83174a6e$export$248fcaff50e7b757 = function(n) {
    var r = n.flagsmith, i = n.options, o = n.serverState, a = n.children, u = (0, $lCzvA.useRef)(!0);
    return r && !(null == r ? void 0 : r._trigger) && (r._trigger = function() {
        null == r || r.log("React - trigger event received"), $fda7e4dd83174a6e$var$c.emit("event");
    }), r && !(null == r ? void 0 : r._triggerLoadingState) && (r._triggerLoadingState = function() {
        $fda7e4dd83174a6e$var$c.emit("loading_event");
    }), o && !r.initialised && r.setState(o), u.current && (u.current = !1, i && r.init($fda7e4dd83174a6e$var$l($fda7e4dd83174a6e$var$l({}, i), {
        state: i.state || o,
        onChange: function() {
            for(var t = [], n = 0; n < arguments.length; n++)t[n] = arguments[n];
            i.onChange && i.onChange.apply(i, t);
        }
    })).catch(function(t) {
        null == r || r.log("React - Failed to initialize flagsmith", t), $fda7e4dd83174a6e$var$c.emit("event");
    })), (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).createElement($fda7e4dd83174a6e$export$d20ba6ba2e7f6098.Provider, {
        value: r
    }, a);
}, $fda7e4dd83174a6e$var$g = function(t) {
    var n = (0, $lCzvA.useRef)(t);
    return n.current || (n.current = t), n.current;
}, $fda7e4dd83174a6e$var$h = function(t) {
    if ("string" == typeof t) return [
        t
    ];
    if ("object" == typeof t && t.hasOwnProperty("length")) return t;
    throw new Error("Flagsmith: please supply an array of strings or a single string of flag keys to useFlags");
}, $fda7e4dd83174a6e$var$v = function(t, n, e) {
    return void 0 === e && (e = []), n.map(function(n) {
        return "".concat(t.getValue(n)).concat(t.hasFeature(n));
    }).concat(e.map(function(n) {
        return "".concat(t.getTrait(n));
    })).join(",");
};
function $fda7e4dd83174a6e$export$c3c6a5389a9d7973() {
    var t = (0, $lCzvA.useContext)($fda7e4dd83174a6e$export$d20ba6ba2e7f6098), n = (0, $lCzvA.useState)(null == t ? void 0 : t.loadingState), u = n[0], l = n[1], s = (0, $lCzvA.useState)(!1), g = s[0], h = s[1], v = (0, $lCzvA.useRef)(g), p = (0, $lCzvA.useCallback)(function() {
        l(null == t ? void 0 : t.loadingState);
    }, [
        t
    ]);
    return v.current || ($fda7e4dd83174a6e$var$c.on("loading_event", p), v.current = !0), (0, $lCzvA.useEffect)(function() {
        return !g && (null == t ? void 0 : t.initialised) && ($fda7e4dd83174a6e$var$c.on("loading_event", p), h(!0)), function() {
            g && $fda7e4dd83174a6e$var$c.off("loading_event", p);
        };
    }, [
        t,
        g,
        p
    ]), u;
}
function $fda7e4dd83174a6e$export$2879604e6aec4ab(t, n) {
    void 0 === n && (n = []);
    var l = (0, $lCzvA.useRef)(!0), s = $fda7e4dd83174a6e$var$g($fda7e4dd83174a6e$var$h(t)), p = $fda7e4dd83174a6e$var$g($fda7e4dd83174a6e$var$h(n)), d = (0, $lCzvA.useContext)($fda7e4dd83174a6e$export$d20ba6ba2e7f6098), y = (0, $lCzvA.useState)($fda7e4dd83174a6e$var$v(d, s, p)), m = y[0], b = y[1], _ = (0, $lCzvA.useCallback)(function() {
        var t = $fda7e4dd83174a6e$var$v(d, s, p);
        t !== m && (null == d || d.log("React - useFlags flags and traits have changed"), b(t));
    }, [
        m
    ]), w = (0, $lCzvA.useRef)($fda7e4dd83174a6e$var$c.once("event", _));
    return l.current && (l.current = !1, null == d || d.log("React - Initialising event listeners")), (0, $lCzvA.useEffect)(function() {
        return function() {
            var t;
            null === (t = w.current) || void 0 === t || t.call(w);
        };
    }, []), (0, $lCzvA.useMemo)(function() {
        var t = {};
        return s.map(function(n) {
            t[n] = {
                enabled: d.hasFeature(n),
                value: d.getValue(n)
            };
        }).concat(null == p ? void 0 : p.map(function(n) {
            t[n] = d.getTrait(n);
        })), t;
    }, [
        m
    ]);
}
function $fda7e4dd83174a6e$export$b05eccb4cbfc7ed7() {
    var t = (0, $lCzvA.useContext)($fda7e4dd83174a6e$export$d20ba6ba2e7f6098);
    if (!t) throw new Error("useFlagsmith must be used with in a FlagsmithProvider");
    return t;
}



var $lCzvA = parcelRequire("lCzvA");

/**
 * Public API for `@pella/fetch-client`. Internal modules are reachable via
 * deep imports but are not part of the supported surface.
 */ /** @type {import('#types').TransportConfig} */ const $7435c17b2720a981$var$EMPTY_CONFIG = {
    tokenProvider: null,
    traceProvider: null,
    correlationProvider: null,
    onAuthFailed: null,
    extraHeadersProvider: null,
    debug: false
};
/** @type {import('#types').TransportConfig} */ let $7435c17b2720a981$var$state = {
    ...$7435c17b2720a981$var$EMPTY_CONFIG
};
/** @type {Set<() => void>} */ const $7435c17b2720a981$var$resetListeners = new Set();
const $7435c17b2720a981$export$d0ad0388550eddb = (config)=>{
    if (!config || !config.tokenProvider) throw new Error('configureFetchClient: tokenProvider is required');
    $7435c17b2720a981$var$state = {
        ...$7435c17b2720a981$var$EMPTY_CONFIG,
        ...config
    };
};
const $7435c17b2720a981$export$7e2908c95716c440 = ()=>$7435c17b2720a981$var$state;
const $7435c17b2720a981$export$1ca04d3e281f5af9 = (fn)=>{
    $7435c17b2720a981$var$resetListeners.add(fn);
    return ()=>$7435c17b2720a981$var$resetListeners.delete(fn);
};
const $7435c17b2720a981$export$a6e4c7ef547372e5 = ()=>{
    $7435c17b2720a981$var$state = {
        ...$7435c17b2720a981$var$EMPTY_CONFIG
    };
    // Isolate listeners so one throwing callback doesn't skip subsequent ones.
    // Rethrow async so failures still surface as uncaught errors.
    for (const fn of $7435c17b2720a981$var$resetListeners)try {
        fn();
    } catch (error) {
        queueMicrotask(()=>{
            throw error;
        });
    }
};


/**
 * Structured error thrown by `@pella/fetch-client` transport calls. Preserves
 * GraphQL extensions, HTTP status, and an `ApiErrorKind` so consumers can
 * route to the right UX channel without string-matching messages.
 *
 * Constructor accepts `{ message, code, extensions, details, cause, kind, status, body }`.
 * `kind`, `status` and `body` are the transport-specific additions; the rest mirror the
 * shape used by Pella's server-side `ClientError` so logs and dashboards can
 * correlate frontend and backend incidents.
 */ class $8d9fc989f52a968d$export$f2e832acab1bdd79 extends Error {
    /** @type {import('#types').ApiErrorKind} */ kind;
    /** @type {string | undefined} */ code;
    /** @type {Record<string, unknown> | undefined} */ extensions;
    /** @type {number | undefined} */ status;
    /** @type {unknown} */ body;
    /**
   * Build an ApiError from a structured init bag.
   * @param {import('#types').ApiErrorInit} init
   */ constructor({ message: message, kind: kind, code: code, extensions: extensions, details: details, status: status, cause: cause, body: body }){
        // Native ES2022 Error.cause via the options bag — do NOT assign this.cause
        // manually (that shadows the native behavior).
        super(message, cause !== undefined ? {
            cause: cause
        } : undefined);
        // Explicit literal (not this.constructor.name) — minifier-robust.
        this.name = 'ApiError';
        this.kind = kind;
        this.code = code;
        if (extensions !== undefined || details !== undefined) this.extensions = {
            ...details,
            ...extensions,
            ...code !== undefined ? {
                code: code
            } : {}
        };
        this.status = status;
        this.body = body;
    }
}
const $8d9fc989f52a968d$export$89d83cc97c52a37 = (err)=>err instanceof $8d9fc989f52a968d$export$f2e832acab1bdd79;



/**
 * HTTP statuses that should never be retried by the retry layer. 401 is
 * deliberately NOT in this set — auth errors reach `withRetry` via
 * `ApiError({ kind: 'auth' })` and bail by kind, not status.
 *
 * Typed as `ReadonlySet` to advertise that consumers must not mutate it
 * (it's shared across every retry attempt).
 * @type {ReadonlySet<number>}
 */ const $b7fc1bdf050cc7bc$export$caa2b9eec4a1b2a1 = new Set([
    400,
    403,
    404
]);
const $b7fc1bdf050cc7bc$export$188df5ecf8e7961a = async (fn, options = {})=>{
    const { retries: retries = 0, minTimeout: minTimeout = 100, shouldBail: shouldBail } = options;
    /** @type {Error | undefined} */ let lastError;
    // Looping with try/catch is more verbose than async-retry but lets us avoid dependencies and keep the retry logic in one place.
    for(let attempt = 0; attempt <= retries; attempt++)try {
        // eslint-disable-next-line no-await-in-loop
        return await fn();
    } catch (error) {
        // Short-circuit retries on terminal errors.
        if (shouldBail?.(/** @type {Error} */ error)) throw error;
        // Save the error for the final throw if we exhaust the retry budget.
        lastError = /** @type {Error} */ error;
        // Don't delay if we're out of retries.
        if (attempt < retries) {
            // Exponential back-off with jitter: random multiplier 1–2×, matching async-retry defaults.
            const timeout = Math.round((Math.random() + 1) * minTimeout * 2 ** attempt);
            // Awaiting a promise here lets us delay without blocking the event loop.
            // eslint-disable-next-line no-await-in-loop
            await new Promise((resolve)=>{
                setTimeout(resolve, timeout);
            });
        }
    }
    throw lastError;
};


const $d57e74862caceb85$export$a1a1cb04bb7c3f20 = (err)=>err.kind === 'auth' || err.status !== undefined && (0, $b7fc1bdf050cc7bc$export$caa2b9eec4a1b2a1).has(err.status);
const $d57e74862caceb85$export$e13630478a6ffd5e = (err)=>err.kind === 'auth';
const $d57e74862caceb85$export$56d37d07521e8edd = (signal, timeout)=>{
    if (timeout === undefined) return signal;
    const timeoutSignal = AbortSignal.timeout(timeout);
    return signal ? AbortSignal.any([
        signal,
        timeoutSignal
    ]) : timeoutSignal;
};
/**
 * Single-flight lock for token refresh. When a 401 arrives, all in-flight
 * requests that hit the same window wait on one refresh rather than firing
 * N parallel refreshes and racing on the store.
 * @type {Promise<void> | null}
 */ let $d57e74862caceb85$var$inflightRefresh = null;
// Ensure resetFetchClientConfig() clears runtime state so tests don't leak
// a pending refresh promise across cases.
(0, $7435c17b2720a981$export$1ca04d3e281f5af9)(()=>{
    $d57e74862caceb85$var$inflightRefresh = null;
});
const $d57e74862caceb85$export$7d6ed858a91629c3 = async (perCallHeaders)=>{
    const config = (0, $7435c17b2720a981$export$7e2908c95716c440)();
    if (!config.tokenProvider) throw new (0, $8d9fc989f52a968d$export$f2e832acab1bdd79)({
        kind: 'network',
        message: "Transport not configured \u2014 call configureFetchClient() before issuing requests."
    });
    // configureFetchClient() requires tokenProvider; the other providers are optional.
    const tokenProvider = /** @type {() => string | null | Promise<string | null>} */ config.tokenProvider;
    // Run async providers in parallel — they are independent of each other.
    const [token, traceparent, correlationId] = await Promise.all([
        tokenProvider(),
        config.traceProvider ? config.traceProvider() : undefined,
        config.correlationProvider ? config.correlationProvider() : undefined
    ]);
    const extra = config.extraHeadersProvider ? config.extraHeadersProvider() : {};
    const headers = {
        ...correlationId ? {
            'x-correlation-id': correlationId
        } : {},
        ...traceparent ? {
            traceparent: traceparent
        } : {},
        ...config.debug ? {
            'x-debug-mode': 'true'
        } : {},
        ...token ? {
            Authorization: `Bearer ${token}`
        } : {},
        ...extra,
        ...perCallHeaders
    };
    return {
        headers: headers,
        tokenUsed: token
    };
};
const $d57e74862caceb85$export$b7bb66807d332b55 = async (tokenSent)=>{
    const { onAuthFailed: onAuthFailed, tokenProvider: tokenProvider } = (0, $7435c17b2720a981$export$7e2908c95716c440)();
    if (!onAuthFailed) return null;
    if (!$d57e74862caceb85$var$inflightRefresh) $d57e74862caceb85$var$inflightRefresh = Promise.resolve().then(()=>onAuthFailed()).finally(()=>{
        $d57e74862caceb85$var$inflightRefresh = null;
    });
    try {
        await $d57e74862caceb85$var$inflightRefresh;
    } catch (error) {
        // Consumers rely on ApiError's discriminant — a raw rejection from
        // the auth provider would bypass isApiError() checks everywhere.
        throw new (0, $8d9fc989f52a968d$export$f2e832acab1bdd79)({
            kind: 'auth',
            status: 401,
            message: /** @type {Error} */ error?.message || 'Token refresh failed'
        });
    }
    // configureFetchClient() requires tokenProvider; if we got here, it's set.
    const tp = /** @type {() => string | null | Promise<string | null>} */ tokenProvider;
    const fresh = await tp();
    return fresh && fresh !== tokenSent ? fresh : null;
};
const $d57e74862caceb85$export$8e697650cb6f24d3 = async (send)=>{
    const { response: firstResponse, tokenUsed: tokenUsed } = await send();
    if (firstResponse.status !== 401) return firstResponse;
    const fresh = await $d57e74862caceb85$export$b7bb66807d332b55(tokenUsed);
    if (!fresh) throw new (0, $8d9fc989f52a968d$export$f2e832acab1bdd79)({
        kind: 'auth',
        status: 401,
        message: 'Unauthorized'
    });
    const { response: retryResponse } = await send();
    if (retryResponse.status === 401) throw new (0, $8d9fc989f52a968d$export$f2e832acab1bdd79)({
        kind: 'auth',
        status: 401,
        message: 'Unauthorized after refresh'
    });
    return retryResponse;
};
/**
 * Returns true when the response Content-Type header indicates JSON.
 * Case-insensitive to accommodate non-standard capitalisation (e.g. `Application/JSON`).
 * @param {{ headers: { get: (name: string) => string | null } }} response
 */ const $d57e74862caceb85$var$isJsonContentType = (response)=>(response.headers.get('Content-Type') || '').toLowerCase().includes('application/json');
const $d57e74862caceb85$export$759bcb35b0d1bf81 = async (response)=>{
    if (!$d57e74862caceb85$var$isJsonContentType(response)) {
        const text = await response.text().catch(()=>'');
        throw new (0, $8d9fc989f52a968d$export$f2e832acab1bdd79)({
            kind: 'network',
            message: `Response was not JSON: ${text.slice(0, 200)}`,
            status: response.status,
            body: text
        });
    }
    return response.json();
};
const $d57e74862caceb85$export$c3a9c7d60a1f4b23 = async (response)=>{
    if (!$d57e74862caceb85$var$isJsonContentType(response)) return null;
    try {
        return await response.json();
    } catch  {
        return null;
    }
};




const $dc52b8907b22717f$export$24835cb787452b46 = async (options)=>{
    const { url: url, method: method = 'GET', body: body, headers: perCallHeaders, throwOnError: throwOnError = false, validate: validate, retryOptions: retryOptions = {
        retries: 0
    }, signal: signal, timeout: timeout } = options;
    // Captured by the closure on every attempt so the outer catch can unwrap
    // the thrown ApiError back into the envelope when throwOnError: false.
    // Re-assigned on each attempt — the values reflect the LAST attempt run.
    /** @type {Response | null} */ let lastResponse = null;
    /** @type {T | null} */ let lastData = null;
    const send = async ()=>{
        const { headers: headers, tokenUsed: tokenUsed } = await (0, $d57e74862caceb85$export$7d6ed858a91629c3)(perCallHeaders);
        // REST endpoints (e.g. org-management) do not whitelist `traceparent` in
        // their CORS Access-Control-Allow-Headers — sending it causes the browser
        // preflight to fail with "Failed to fetch". Remove it for REST calls;
        // GraphQL requests add their own tracing headers via graphqlRequest.
        delete headers.traceparent;
        // Only include Content-Type when there's a body to send — prevents CORS
        // preflight on GET/DELETE requests to APIs that don't whitelist custom headers.
        // A caller-supplied content-type (any case) is kept so JSON variants such
        // as application/merge-patch+json survive.
        if (body !== undefined && !Object.keys(headers).some((name)=>name.toLowerCase() === 'content-type')) headers['Content-Type'] = 'application/json';
        const response = await fetch(url, {
            method: method,
            headers: headers,
            body: body !== undefined ? JSON.stringify(body) : undefined,
            signal: (0, $d57e74862caceb85$export$56d37d07521e8edd)(signal, timeout)
        });
        return {
            response: response,
            tokenUsed: tokenUsed
        };
    };
    const attempt = async ()=>{
        const response = await (0, $d57e74862caceb85$export$8e697650cb6f24d3)(send);
        const data = /** @type {T | null} */ await (0, $d57e74862caceb85$export$c3a9c7d60a1f4b23)(response);
        lastResponse = response;
        lastData = data;
        if (!response.ok) {
            // Always throw inside the retry-able attempt so withRetry can fire on
            // 5xx regardless of `throwOnError`. The outer wrapper unwraps the throw
            // back into the envelope using lastResponse/lastData when the caller
            // didn't opt in to throws.
            const errMessage = data && typeof data === 'object' && 'message' in data && typeof data.message === 'string' ? data.message : `HTTP ${response.status}`;
            throw new (0, $8d9fc989f52a968d$export$f2e832acab1bdd79)({
                kind: 'http',
                status: response.status,
                message: errMessage,
                body: data
            });
        }
        if (validate) validate(data, response);
        return {
            data: data,
            status: response.status,
            statusText: response.statusText,
            response: response
        };
    };
    try {
        return await (0, $b7fc1bdf050cc7bc$export$188df5ecf8e7961a)(attempt, {
            retries: retryOptions.retries,
            minTimeout: retryOptions.minTimeout,
            shouldBail: (0, $d57e74862caceb85$export$a1a1cb04bb7c3f20)
        });
    } catch (error) {
        if (!throwOnError && (0, $8d9fc989f52a968d$export$89d83cc97c52a37)(error) && error.kind === 'http' && lastResponse) {
            /** @type {Response} */ const response = lastResponse;
            return {
                data: lastData,
                status: response.status,
                statusText: response.statusText,
                response: response
            };
        }
        throw error;
    }
};
const $dc52b8907b22717f$export$cfe3ecf06fc6e90e = (method, url, body, options = {})=>$dc52b8907b22717f$export$24835cb787452b46({
        method: method,
        url: url,
        body: body,
        ...options
    });





const $9942448fd46231b7$export$362249ae47a4de0b = async (options)=>{
    const { url: url, query: query, variables: variables, headers: perCallHeaders, throwErrors: throwErrors = true, validate: validate, retryOptions: retryOptions = {
        retries: 0
    }, signal: signal, timeout: timeout } = options;
    // Captured by the closure on every attempt so the outer catch can unwrap
    // the thrown ApiError back into the envelope when throwErrors: false.
    // Re-assigned on each attempt — the values reflect the LAST attempt run.
    /** @type {import('#types').GraphqlResponseBody<T> | null} */ let lastBody = null;
    const send = async ()=>{
        const { headers: headers, tokenUsed: tokenUsed } = await (0, $d57e74862caceb85$export$7d6ed858a91629c3)(perCallHeaders);
        if (!headers['Content-Type']) headers['Content-Type'] = 'application/json';
        const response = await fetch(url, {
            method: 'POST',
            body: JSON.stringify({
                query: query,
                variables: variables
            }),
            headers: headers,
            signal: (0, $d57e74862caceb85$export$56d37d07521e8edd)(signal, timeout)
        });
        return {
            response: response,
            tokenUsed: tokenUsed
        };
    };
    const attempt = async ()=>{
        const response = await (0, $d57e74862caceb85$export$8e697650cb6f24d3)(send);
        const body = /** @type {import('#types').GraphqlResponseBody<T>} */ await (0, $d57e74862caceb85$export$759bcb35b0d1bf81)(response);
        lastBody = body;
        if (!response.ok) throw new (0, $8d9fc989f52a968d$export$f2e832acab1bdd79)({
            kind: 'http',
            status: response.status,
            message: body?.message || `HTTP ${response.status}`,
            body: body
        });
        if (Array.isArray(body.errors) && body.errors.length > 0) {
            // Always throw inside the retry-able attempt so withRetry can fire on
            // GraphQL errors regardless of `throwErrors`. The outer wrapper unwraps
            // the throw back into the envelope using lastBody when the caller
            // didn't opt in to throws.
            const primaryError = body.errors[0];
            throw new (0, $8d9fc989f52a968d$export$f2e832acab1bdd79)({
                kind: 'graphql',
                code: /** @type {string | undefined} */ primaryError.extensions?.code,
                extensions: primaryError.extensions,
                message: primaryError.message,
                status: response.status,
                body: body
            });
        }
        if (validate) validate(body, response);
        return {
            data: body.data,
            errors: body.errors
        };
    };
    try {
        return await (0, $b7fc1bdf050cc7bc$export$188df5ecf8e7961a)(attempt, {
            retries: retryOptions.retries,
            minTimeout: retryOptions.minTimeout,
            shouldBail: (0, $d57e74862caceb85$export$e13630478a6ffd5e)
        });
    } catch (error) {
        if (!throwErrors && (0, $8d9fc989f52a968d$export$89d83cc97c52a37)(error) && error.kind === 'graphql' && lastBody) {
            /** @type {import('#types').GraphqlEnvelope<T>} */ const envelope = lastBody;
            return {
                data: envelope.data,
                errors: envelope.errors
            };
        }
        throw error;
    }
};
const $9942448fd46231b7$export$71667b1866b7607e = (url, query, variables, options = {})=>$9942448fd46231b7$export$362249ae47a4de0b({
        url: url,
        query: query,
        variables: variables,
        ...options
    });






/**
 * @typedef {object} AuthState
 * @property {string | null} token
 */ /** @type {AuthState} */ const $a2c7fde35549f4e6$var$INITIAL = {
    token: null
};
/** @type {AuthState} */ let $a2c7fde35549f4e6$var$state = {
    ...$a2c7fde35549f4e6$var$INITIAL
};
/** @type {Set<(state: AuthState) => void>} */ const $a2c7fde35549f4e6$var$listeners = new Set();
/**
 * Notify all subscribers of the current state.
 * @returns {void}
 */ const $a2c7fde35549f4e6$var$notify = ()=>{
    for (const fn of $a2c7fde35549f4e6$var$listeners)fn($a2c7fde35549f4e6$var$state);
};
const $a2c7fde35549f4e6$export$36491da625b5403b = ()=>$a2c7fde35549f4e6$var$state;
const $a2c7fde35549f4e6$export$3c4602e16d9ace38 = (token)=>{
    $a2c7fde35549f4e6$var$state = {
        ...$a2c7fde35549f4e6$var$state,
        token: token
    };
    $a2c7fde35549f4e6$var$notify();
};
const $a2c7fde35549f4e6$export$ec068583843480e7 = (fn)=>{
    $a2c7fde35549f4e6$var$listeners.add(fn);
    return ()=>$a2c7fde35549f4e6$var$listeners.delete(fn);
};
const $a2c7fde35549f4e6$export$1d2dd50ed66aa09a = ()=>{
    $a2c7fde35549f4e6$var$state = {
        ...$a2c7fde35549f4e6$var$INITIAL
    };
    $a2c7fde35549f4e6$var$listeners.clear();
};


/**
 * Pull N cryptographically-random bytes and hex-encode them. Used to build
 * the trace-id / span-id segments of a W3C traceparent value.
 * @param {number} bytes
 * @returns {string}
 */ const $f436ab3fa8b3ddc0$var$randomHex = (bytes)=>{
    const arr = new Uint8Array(bytes);
    crypto.getRandomValues(arr);
    return Array.from(arr, (b)=>b.toString(16).padStart(2, '0')).join('');
};
const $f436ab3fa8b3ddc0$export$39db49a085f1ec11 = ()=>crypto.randomUUID();
const $f436ab3fa8b3ddc0$export$12a7eb2f839f5cb9 = ()=>`00-${$f436ab3fa8b3ddc0$var$randomHex(16)}-${$f436ab3fa8b3ddc0$var$randomHex(8)}-01`;


const $ef82ebc542d4c81b$export$c8b2ca003c6eb857 = ({ extraHeadersProvider: extraHeadersProvider })=>{
    const { authState: authState, oktaAuth: oktaAuth } = (0, $954b04773eb0508c$export$2ae4a19e09ca9a00)();
    const accessToken = authState?.accessToken?.accessToken ?? null;
    (0, $lCzvA.useEffect)(()=>{
        (0, $a2c7fde35549f4e6$export$3c4602e16d9ace38)(accessToken);
    }, [
        accessToken
    ]);
    (0, $lCzvA.useEffect)(()=>{
        (0, $7435c17b2720a981$export$d0ad0388550eddb)({
            tokenProvider: ()=>(0, $a2c7fde35549f4e6$export$36491da625b5403b)().token,
            correlationProvider: (0, $f436ab3fa8b3ddc0$export$39db49a085f1ec11),
            traceProvider: (0, $f436ab3fa8b3ddc0$export$12a7eb2f839f5cb9),
            extraHeadersProvider: extraHeadersProvider ?? null,
            onAuthFailed: async ()=>{
                const renewed = await oktaAuth.getOrRenewAccessToken();
                (0, $a2c7fde35549f4e6$export$3c4602e16d9ace38)(renewed || null);
            }
        });
    }, [
        oktaAuth,
        extraHeadersProvider
    ]);
    (0, $lCzvA.useEffect)(()=>{
        const handler = async ()=>{
            if (document.visibilityState !== 'visible') return;
            const renewed = await oktaAuth.getOrRenewAccessToken();
            if (renewed && renewed !== (0, $a2c7fde35549f4e6$export$36491da625b5403b)().token) (0, $a2c7fde35549f4e6$export$3c4602e16d9ace38)(renewed);
        };
        document.addEventListener('visibilitychange', handler);
        return ()=>document.removeEventListener('visibilitychange', handler);
    }, [
        oktaAuth
    ]);
    return null;
};






var $lCzvA = parcelRequire("lCzvA");
const $3b086af55ffdafb7$export$6200b0fc719be580 = 'SELECTED_PLANT';
const $3b086af55ffdafb7$export$172e4f9a1fb1ffbf = 'SELECTED_LOCATION';
const $3b086af55ffdafb7$export$b37f59cc4aa98af8 = 'SELECTED_RESOURCE';
const $3b086af55ffdafb7$export$57ef17f620781de2 = 'ACTIVE_TAB';
const $3b086af55ffdafb7$export$a6a3f8958140e326 = 'RESOURCE_QUEUE_SELECTED_ID';
const $3b086af55ffdafb7$export$ef84d9ae45b199a6 = 'SELECTION_LIST_SELECTED_ID';


const $c5217acfa686d888$export$d4c72bab9d6cc13a = {
    selectedPlant: localStorage.getItem($3b086af55ffdafb7$export$6200b0fc719be580) || '',
    selectedLocation: localStorage.getItem($3b086af55ffdafb7$export$172e4f9a1fb1ffbf) || '',
    selectedResource: localStorage.getItem($3b086af55ffdafb7$export$b37f59cc4aa98af8) || '',
    activeTab: '',
    resourceQueueSelectedId: '',
    selectionListSelectedId: ''
};
const $c5217acfa686d888$export$1650419e431d3ba3 = (state, action)=>{
    switch(action.type){
        case $3b086af55ffdafb7$export$6200b0fc719be580:
            return {
                ...state,
                selectedPlant: action.payload
            };
        case $3b086af55ffdafb7$export$172e4f9a1fb1ffbf:
            return {
                ...state,
                selectedLocation: action.payload
            };
        case $3b086af55ffdafb7$export$b37f59cc4aa98af8:
            return {
                ...state,
                selectedResource: action.payload
            };
        case $3b086af55ffdafb7$export$57ef17f620781de2:
            return {
                ...state,
                activeTab: action.payload
            };
        case $3b086af55ffdafb7$export$a6a3f8958140e326:
            return {
                ...state,
                resourceQueueSelectedId: action.payload
            };
        case $3b086af55ffdafb7$export$ef84d9ae45b199a6:
            return {
                ...state,
                selectionListSelectedId: action.payload
            };
        default:
            return state;
    }
};


const $4e4c6c71fc2aaac8$export$252e8fa9240322e8 = ({ type: type, payload: payload })=>{
    // eslint-disable-next-line no-console
    console.error(`Unhandled action type: ${type} with payload: ${payload}`);
};
const $4e4c6c71fc2aaac8$var$AppContext = /*#__PURE__*/ (0, $lCzvA.createContext)((0, $c5217acfa686d888$export$d4c72bab9d6cc13a));
const $4e4c6c71fc2aaac8$var$AppDispatchContext = /*#__PURE__*/ (0, $lCzvA.createContext)($4e4c6c71fc2aaac8$export$252e8fa9240322e8);
const $4e4c6c71fc2aaac8$export$c7dacf3845253dcf = ({ children: children, startingState: startingState = (0, $c5217acfa686d888$export$d4c72bab9d6cc13a) })=>{
    const [state, dispatch] = (0, $lCzvA.useReducer)((0, $c5217acfa686d888$export$1650419e431d3ba3), startingState);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($4e4c6c71fc2aaac8$var$AppContext.Provider, {
        value: state,
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)($4e4c6c71fc2aaac8$var$AppDispatchContext.Provider, {
            value: dispatch,
            children: children
        })
    });
};
const $4e4c6c71fc2aaac8$export$fdc397e486fa83e7 = ()=>(0, $lCzvA.useContext)($4e4c6c71fc2aaac8$var$AppContext);
const $4e4c6c71fc2aaac8$export$f51d452c10d5b956 = ()=>(0, $lCzvA.useContext)($4e4c6c71fc2aaac8$var$AppDispatchContext);




// Note: This file is used to export all components from the components folder
// Turn on the commented out lines once you have components to export



var $lCzvA = parcelRequire("lCzvA");

"use client";
//#region src/useIsFetching.ts
/**
* The `useIsFetching` hook returns the `number` of the queries that your application is loading or fetching in
* the background (useful for app-wide loading indicators).
* @param filters - The {@link QueryFilters} to narrow down the matched queries.
* @param queryClient - Use this to use a custom `QueryClient`. Otherwise, the one from the nearest context will
* be used.
* @returns Will be the `number` of the queries that your application is currently loading or fetching in the
* background.
* @example
* ```tsx
* import { useIsFetching } from '@tanstack/react-query'
*
* function PostsFetchingIndicator() {
*   // How many queries matching the posts prefix are fetching?
*   const isFetchingPosts = useIsFetching({ queryKey: ['posts'] })
*
*   return isFetchingPosts ? <span>Refreshing posts...</span> : null
* }
* ```
* @example
* A global loading indicator for any query fetching in the background, not just the ones on screen:
* ```tsx
* import { useIsFetching } from '@tanstack/react-query'
*
* function GlobalLoadingIndicator() {
*   const isFetching = useIsFetching()
*
*   return isFetching ? (
*     <div>Queries are fetching in the background...</div>
*   ) : null
* }
* ```
*/ function $ffefff3d830f108f$export$625b2ff71316bcd3(filters, queryClient) {
    const client = (0, $6547bc15d23e8c33$export$22e77b9572c4fded)(queryClient);
    const queryCache = client.getQueryCache();
    return $lCzvA.useSyncExternalStore($lCzvA.useCallback((onStoreChange)=>queryCache.subscribe((0, $7214f1c3bd8e29e6$export$520687f44db6e1ab).batchCalls(onStoreChange)), [
        queryCache
    ]), ()=>client.isFetching(filters), ()=>client.isFetching(filters));
}



var $lCzvA = parcelRequire("lCzvA");
//#region node_modules/tailwind-merge/dist/bundle-mjs.mjs
var $12b9f2ef36f8b3b2$var$e = (e, t)=>{
    let n = Array(e.length + t.length);
    for(let t = 0; t < e.length; t++)n[t] = e[t];
    for(let r = 0; r < t.length; r++)n[e.length + r] = t[r];
    return n;
}, $12b9f2ef36f8b3b2$var$t = (e, t)=>({
        classGroupId: e,
        validator: t
    }), $12b9f2ef36f8b3b2$var$n = (e = /* @__PURE__ */ new Map(), t = null, n)=>({
        nextPart: e,
        validators: t,
        classGroupId: n
    }), $12b9f2ef36f8b3b2$var$r = "-", $12b9f2ef36f8b3b2$var$i = [], $12b9f2ef36f8b3b2$var$a = "arbitrary..", $12b9f2ef36f8b3b2$var$o = (t)=>{
    let n = $12b9f2ef36f8b3b2$var$l(t), { conflictingClassGroups: a, conflictingClassGroupModifiers: o } = t;
    return {
        getClassGroupId: (e)=>{
            if (e.startsWith("[") && e.endsWith("]")) return $12b9f2ef36f8b3b2$var$c(e);
            let t = e.split($12b9f2ef36f8b3b2$var$r);
            return $12b9f2ef36f8b3b2$var$s(t, +(t[0] === "" && t.length > 1), n);
        },
        getConflictingClassGroupIds: (t, n)=>{
            if (n) {
                let n = o[t], r = a[t];
                return n ? r ? $12b9f2ef36f8b3b2$var$e(r, n) : n : r || $12b9f2ef36f8b3b2$var$i;
            }
            return a[t] || $12b9f2ef36f8b3b2$var$i;
        }
    };
}, $12b9f2ef36f8b3b2$var$s = (e, t, n)=>{
    if (e.length - t === 0) return n.classGroupId;
    let i = e[t], a = n.nextPart.get(i);
    if (a) {
        let n = $12b9f2ef36f8b3b2$var$s(e, t + 1, a);
        if (n) return n;
    }
    let o = n.validators;
    if (o === null) return;
    let c = t === 0 ? e.join($12b9f2ef36f8b3b2$var$r) : e.slice(t).join($12b9f2ef36f8b3b2$var$r), l = o.length;
    for(let e = 0; e < l; e++){
        let t = o[e];
        if (t.validator(c)) return t.classGroupId;
    }
}, $12b9f2ef36f8b3b2$var$c = (e)=>e.slice(1, -1).indexOf(":") === -1 ? void 0 : (()=>{
        let t = e.slice(1, -1), n = t.indexOf(":"), r = t.slice(0, n);
        return r ? $12b9f2ef36f8b3b2$var$a + r : void 0;
    })(), $12b9f2ef36f8b3b2$var$l = (e)=>{
    let { theme: t, classGroups: n } = e;
    return $12b9f2ef36f8b3b2$var$ee(n, t);
}, $12b9f2ef36f8b3b2$var$ee = (e, t)=>{
    let r = $12b9f2ef36f8b3b2$var$n();
    for(let n in e){
        let i = e[n];
        $12b9f2ef36f8b3b2$var$u(i, r, n, t);
    }
    return r;
}, $12b9f2ef36f8b3b2$var$u = (e, t, n, r)=>{
    let i = e.length;
    for(let a = 0; a < i; a++){
        let i = e[a];
        $12b9f2ef36f8b3b2$var$te(i, t, n, r);
    }
}, $12b9f2ef36f8b3b2$var$te = (e, t, n, r)=>{
    typeof e == "string" ? $12b9f2ef36f8b3b2$var$d(e, t, n) : typeof e == "function" ? $12b9f2ef36f8b3b2$var$f(e, t, n, r) : $12b9f2ef36f8b3b2$var$p(e, t, n, r);
}, $12b9f2ef36f8b3b2$var$d = (e, t, n)=>{
    let r = e === "" ? t : $12b9f2ef36f8b3b2$var$m(t, e);
    r.classGroupId = n;
}, $12b9f2ef36f8b3b2$var$f = (e, n, r, i)=>{
    $12b9f2ef36f8b3b2$var$h(e) ? $12b9f2ef36f8b3b2$var$u(e(i), n, r, i) : (n.validators === null && (n.validators = []), n.validators.push($12b9f2ef36f8b3b2$var$t(r, e)));
}, $12b9f2ef36f8b3b2$var$p = (e, t, n, r)=>{
    let i = Object.entries(e), a = i.length;
    for(let e = 0; e < a; e++){
        let [a, o] = i[e];
        $12b9f2ef36f8b3b2$var$u(o, $12b9f2ef36f8b3b2$var$m(t, a), n, r);
    }
}, $12b9f2ef36f8b3b2$var$m = (e, t)=>{
    let i = e, a = t.split($12b9f2ef36f8b3b2$var$r), o = a.length;
    for(let e = 0; e < o; e++){
        let t = a[e], r = i.nextPart.get(t);
        r || (r = $12b9f2ef36f8b3b2$var$n(), i.nextPart.set(t, r)), i = r;
    }
    return i;
}, $12b9f2ef36f8b3b2$var$h = (e)=>"isThemeGetter" in e && e.isThemeGetter === !0, $12b9f2ef36f8b3b2$var$ne = (e)=>{
    if (e < 1) return {
        get: ()=>void 0,
        set: ()=>{}
    };
    let t = 0, n = Object.create(null), r = Object.create(null), i = (i, a)=>{
        n[i] = a, t++, t > e && (t = 0, r = n, n = Object.create(null));
    };
    return {
        get (e) {
            let t = n[e];
            if (t !== void 0) return t;
            if ((t = r[e]) !== void 0) return i(e, t), t;
        },
        set (e, t) {
            e in n ? n[e] = t : i(e, t);
        }
    };
}, $12b9f2ef36f8b3b2$var$g = "!", $12b9f2ef36f8b3b2$var$_ = ":", $12b9f2ef36f8b3b2$var$v = [], $12b9f2ef36f8b3b2$var$y = (e, t, n, r, i)=>({
        modifiers: e,
        hasImportantModifier: t,
        baseClassName: n,
        maybePostfixModifierPosition: r,
        isExternal: i
    }), $12b9f2ef36f8b3b2$var$b = (e)=>{
    let { prefix: t, experimentalParseClassName: n } = e, r = (e)=>{
        let t = [], n = 0, r = 0, i = 0, a, o = e.length;
        for(let s = 0; s < o; s++){
            let o = e[s];
            if (n === 0 && r === 0) {
                if (o === $12b9f2ef36f8b3b2$var$_) {
                    t.push(e.slice(i, s)), i = s + 1;
                    continue;
                }
                if (o === "/") {
                    a = s;
                    continue;
                }
            }
            o === "[" ? n++ : o === "]" ? n-- : o === "(" ? r++ : o === ")" && r--;
        }
        let s = t.length === 0 ? e : e.slice(i), c = s, l = !1;
        s.endsWith($12b9f2ef36f8b3b2$var$g) ? (c = s.slice(0, -1), l = !0) : s.startsWith($12b9f2ef36f8b3b2$var$g) && (c = s.slice(1), l = !0);
        let ee = a && a > i ? a - i : void 0;
        return $12b9f2ef36f8b3b2$var$y(t, l, c, ee);
    };
    if (t) {
        let e = t + $12b9f2ef36f8b3b2$var$_, n = r;
        r = (t)=>t.startsWith(e) ? n(t.slice(e.length)) : $12b9f2ef36f8b3b2$var$y($12b9f2ef36f8b3b2$var$v, !1, t, void 0, !0);
    }
    if (n) {
        let e = r;
        r = (t)=>n({
                className: t,
                parseClassName: e
            });
    }
    return r;
}, $12b9f2ef36f8b3b2$var$x = (e)=>{
    let t = /* @__PURE__ */ new Map();
    return e.orderSensitiveModifiers.forEach((e, n)=>{
        t.set(e, 1e6 + n);
    }), (e)=>{
        let n = [], r = [];
        for(let i = 0; i < e.length; i++){
            let a = e[i], o = a[0] === "[", s = t.has(a);
            o || s ? (r.length > 0 && (r.sort(), n.push(...r), r = []), n.push(a)) : r.push(a);
        }
        return r.length > 0 && (r.sort(), n.push(...r)), n;
    };
}, $12b9f2ef36f8b3b2$var$S = (e)=>({
        cache: $12b9f2ef36f8b3b2$var$ne(e.cacheSize),
        parseClassName: $12b9f2ef36f8b3b2$var$b(e),
        sortModifiers: $12b9f2ef36f8b3b2$var$x(e),
        postfixLookupClassGroupIds: $12b9f2ef36f8b3b2$var$re(e),
        ...$12b9f2ef36f8b3b2$var$o(e)
    }), $12b9f2ef36f8b3b2$var$re = (e)=>{
    let t = Object.create(null), n = e.postfixLookupClassGroups;
    if (n) for(let e = 0; e < n.length; e++)t[n[e]] = !0;
    return t;
}, $12b9f2ef36f8b3b2$var$ie = /\s+/, $12b9f2ef36f8b3b2$var$C = (e, t)=>{
    let { parseClassName: n, getClassGroupId: r, getConflictingClassGroupIds: i, sortModifiers: a, postfixLookupClassGroupIds: o } = t, s = [], c = e.trim().split($12b9f2ef36f8b3b2$var$ie), l = "";
    for(let e = c.length - 1; e >= 0; --e){
        let t = c[e], { isExternal: ee, modifiers: u, hasImportantModifier: te, baseClassName: d, maybePostfixModifierPosition: f } = n(t);
        if (ee) {
            l = t + (l.length > 0 ? " " + l : l);
            continue;
        }
        let p = !!f, m;
        if (p) {
            m = r(d.substring(0, f));
            let e = m && o[m] ? r(d) : void 0;
            e && e !== m && (m = e, p = !1);
        } else m = r(d);
        if (!m) {
            if (!p || (m = r(d), !m)) {
                l = t + (l.length > 0 ? " " + l : l);
                continue;
            }
            p = !1;
        }
        let h = u.length === 0 ? "" : u.length === 1 ? u[0] : a(u).join(":"), ne = te ? h + $12b9f2ef36f8b3b2$var$g : h, _ = ne + m;
        if (s.indexOf(_) > -1) continue;
        s.push(_);
        let v = i(m, p);
        for(let e = 0; e < v.length; ++e){
            let t = v[e];
            s.push(ne + t);
        }
        l = t + (l.length > 0 ? " " + l : l);
    }
    return l;
}, $12b9f2ef36f8b3b2$export$a8bbfb445e1f163f = (...e)=>{
    let t = 0, n, r, i = "";
    for(; t < e.length;)(n = e[t++]) && (r = $12b9f2ef36f8b3b2$var$T(n)) && (i && (i += " "), i += r);
    return i;
}, $12b9f2ef36f8b3b2$var$T = (e)=>{
    if (typeof e == "string") return e;
    let t, n = "";
    for(let r = 0; r < e.length; r++)e[r] && (t = $12b9f2ef36f8b3b2$var$T(e[r])) && (n && (n += " "), n += t);
    return n;
}, $12b9f2ef36f8b3b2$export$ea2d4fba4d1bd27f = (e, ...t)=>{
    let n, r, i, a, o = (o)=>(n = $12b9f2ef36f8b3b2$var$S(t.reduce((e, t)=>t(e), e())), r = n.cache.get, i = n.cache.set, a = s, s(o)), s = (e)=>{
        let t = r(e);
        if (t) return t;
        let a = $12b9f2ef36f8b3b2$var$C(e, n);
        return i(e, a), a;
    };
    return a = o, (...e)=>a($12b9f2ef36f8b3b2$export$a8bbfb445e1f163f(...e));
}, $12b9f2ef36f8b3b2$var$D = [], $12b9f2ef36f8b3b2$export$e176af7b8eefe933 = (e)=>{
    let t = (t)=>t[e] || $12b9f2ef36f8b3b2$var$D;
    return t.isThemeGetter = !0, t.themeKey = e, t;
}, $12b9f2ef36f8b3b2$var$k = /^\[(?:(\w[\w-]*):)?(.+)\]$/i, $12b9f2ef36f8b3b2$var$A = /^\((?:(\w[\w-]*):)?(.+)\)$/i, $12b9f2ef36f8b3b2$var$j = /^\d+(?:\.\d+)?\/\d+(?:\.\d+)?$/, $12b9f2ef36f8b3b2$var$M = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, $12b9f2ef36f8b3b2$var$ae = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, $12b9f2ef36f8b3b2$var$oe = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix|color|light-dark)\(.+\)$/, $12b9f2ef36f8b3b2$var$se = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, $12b9f2ef36f8b3b2$var$N = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, $12b9f2ef36f8b3b2$var$P = (e)=>$12b9f2ef36f8b3b2$var$j.test(e), $12b9f2ef36f8b3b2$var$F = (e)=>!!e && !Number.isNaN(Number(e)), $12b9f2ef36f8b3b2$var$I = (e)=>!!e && Number.isInteger(Number(e)), $12b9f2ef36f8b3b2$var$ce = (e)=>e.endsWith("%") && $12b9f2ef36f8b3b2$var$F(e.slice(0, -1)), $12b9f2ef36f8b3b2$var$L = (e)=>$12b9f2ef36f8b3b2$var$M.test(e), $12b9f2ef36f8b3b2$var$le = ()=>!0, $12b9f2ef36f8b3b2$var$R = (e)=>$12b9f2ef36f8b3b2$var$ae.test(e) && !$12b9f2ef36f8b3b2$var$oe.test(e), $12b9f2ef36f8b3b2$var$z = ()=>!1, $12b9f2ef36f8b3b2$var$B = (e)=>$12b9f2ef36f8b3b2$var$se.test(e), $12b9f2ef36f8b3b2$var$ue = (e)=>$12b9f2ef36f8b3b2$var$N.test(e), $12b9f2ef36f8b3b2$var$de = (e)=>!$12b9f2ef36f8b3b2$var$V(e) && !$12b9f2ef36f8b3b2$var$W(e), $12b9f2ef36f8b3b2$var$fe = (e)=>e.startsWith("@container") && (e[10] === "/" && e[11] !== void 0 || e[11] === "s" && e[16] !== void 0 && e.startsWith("-size/", 10) || e[11] === "n" && e[18] !== void 0 && e.startsWith("-normal/", 10)), $12b9f2ef36f8b3b2$var$pe = (e)=>$12b9f2ef36f8b3b2$var$q(e, $12b9f2ef36f8b3b2$var$Z, $12b9f2ef36f8b3b2$var$z), $12b9f2ef36f8b3b2$var$V = (e)=>$12b9f2ef36f8b3b2$var$k.test(e), $12b9f2ef36f8b3b2$var$H = (e)=>$12b9f2ef36f8b3b2$var$q(e, $12b9f2ef36f8b3b2$var$Q, $12b9f2ef36f8b3b2$var$R), $12b9f2ef36f8b3b2$var$me = (e)=>$12b9f2ef36f8b3b2$var$q(e, $12b9f2ef36f8b3b2$var$we, $12b9f2ef36f8b3b2$var$F), $12b9f2ef36f8b3b2$var$he = (e)=>$12b9f2ef36f8b3b2$var$q(e, $12b9f2ef36f8b3b2$var$Ee, $12b9f2ef36f8b3b2$var$le), $12b9f2ef36f8b3b2$var$ge = (e)=>$12b9f2ef36f8b3b2$var$q(e, $12b9f2ef36f8b3b2$var$Te, $12b9f2ef36f8b3b2$var$z), $12b9f2ef36f8b3b2$var$_e = (e)=>$12b9f2ef36f8b3b2$var$q(e, $12b9f2ef36f8b3b2$var$Y, $12b9f2ef36f8b3b2$var$z), $12b9f2ef36f8b3b2$var$ve = (e)=>$12b9f2ef36f8b3b2$var$q(e, $12b9f2ef36f8b3b2$var$X, $12b9f2ef36f8b3b2$var$ue), $12b9f2ef36f8b3b2$var$U = (e)=>$12b9f2ef36f8b3b2$var$q(e, $12b9f2ef36f8b3b2$var$De, $12b9f2ef36f8b3b2$var$B), $12b9f2ef36f8b3b2$var$W = (e)=>$12b9f2ef36f8b3b2$var$A.test(e), $12b9f2ef36f8b3b2$var$G = (e)=>$12b9f2ef36f8b3b2$var$J(e, $12b9f2ef36f8b3b2$var$Q), $12b9f2ef36f8b3b2$var$ye = (e)=>$12b9f2ef36f8b3b2$var$J(e, $12b9f2ef36f8b3b2$var$Te), $12b9f2ef36f8b3b2$var$be = (e)=>$12b9f2ef36f8b3b2$var$J(e, $12b9f2ef36f8b3b2$var$Y), $12b9f2ef36f8b3b2$var$xe = (e)=>$12b9f2ef36f8b3b2$var$J(e, $12b9f2ef36f8b3b2$var$Z), $12b9f2ef36f8b3b2$var$Se = (e)=>$12b9f2ef36f8b3b2$var$J(e, $12b9f2ef36f8b3b2$var$X), $12b9f2ef36f8b3b2$var$K = (e)=>$12b9f2ef36f8b3b2$var$J(e, $12b9f2ef36f8b3b2$var$De, !0), $12b9f2ef36f8b3b2$var$Ce = (e)=>$12b9f2ef36f8b3b2$var$J(e, $12b9f2ef36f8b3b2$var$Ee, !0), $12b9f2ef36f8b3b2$var$q = (e, t, n)=>{
    let r = $12b9f2ef36f8b3b2$var$k.exec(e);
    return r ? r[1] ? t(r[1]) : n(r[2]) : !1;
}, $12b9f2ef36f8b3b2$var$J = (e, t, n = !1)=>{
    let r = $12b9f2ef36f8b3b2$var$A.exec(e);
    return r ? r[1] ? t(r[1]) : n : !1;
}, $12b9f2ef36f8b3b2$var$Y = (e)=>e === "position" || e === "percentage", $12b9f2ef36f8b3b2$var$X = (e)=>e === "image" || e === "url", $12b9f2ef36f8b3b2$var$Z = (e)=>e === "length" || e === "size" || e === "bg-size", $12b9f2ef36f8b3b2$var$Q = (e)=>e === "length", $12b9f2ef36f8b3b2$var$we = (e)=>e === "number", $12b9f2ef36f8b3b2$var$Te = (e)=>e === "family-name", $12b9f2ef36f8b3b2$var$Ee = (e)=>e === "number" || e === "weight", $12b9f2ef36f8b3b2$var$De = (e)=>e === "shadow", $12b9f2ef36f8b3b2$export$ed30944e0fe6ae5c = ()=>{
    let e = $12b9f2ef36f8b3b2$export$e176af7b8eefe933("color"), t = $12b9f2ef36f8b3b2$export$e176af7b8eefe933("font"), n = $12b9f2ef36f8b3b2$export$e176af7b8eefe933("text"), r = $12b9f2ef36f8b3b2$export$e176af7b8eefe933("font-weight"), i = $12b9f2ef36f8b3b2$export$e176af7b8eefe933("tracking"), a = $12b9f2ef36f8b3b2$export$e176af7b8eefe933("leading"), o = $12b9f2ef36f8b3b2$export$e176af7b8eefe933("breakpoint"), s = $12b9f2ef36f8b3b2$export$e176af7b8eefe933("container"), c = $12b9f2ef36f8b3b2$export$e176af7b8eefe933("spacing"), l = $12b9f2ef36f8b3b2$export$e176af7b8eefe933("radius"), ee = $12b9f2ef36f8b3b2$export$e176af7b8eefe933("shadow"), u = $12b9f2ef36f8b3b2$export$e176af7b8eefe933("inset-shadow"), te = $12b9f2ef36f8b3b2$export$e176af7b8eefe933("text-shadow"), d = $12b9f2ef36f8b3b2$export$e176af7b8eefe933("drop-shadow"), f = $12b9f2ef36f8b3b2$export$e176af7b8eefe933("blur"), p = $12b9f2ef36f8b3b2$export$e176af7b8eefe933("perspective"), m = $12b9f2ef36f8b3b2$export$e176af7b8eefe933("aspect"), h = $12b9f2ef36f8b3b2$export$e176af7b8eefe933("ease"), ne = $12b9f2ef36f8b3b2$export$e176af7b8eefe933("animate"), g = ()=>[
            "auto",
            "avoid",
            "all",
            "avoid-page",
            "page",
            "left",
            "right",
            "column"
        ], _ = ()=>[
            "center",
            "top",
            "bottom",
            "left",
            "right",
            "top-left",
            "left-top",
            "top-right",
            "right-top",
            "bottom-right",
            "right-bottom",
            "bottom-left",
            "left-bottom"
        ], v = ()=>[
            ..._(),
            $12b9f2ef36f8b3b2$var$W,
            $12b9f2ef36f8b3b2$var$V
        ], y = ()=>[
            "auto",
            "hidden",
            "clip",
            "visible",
            "scroll"
        ], b = ()=>[
            "auto",
            "contain",
            "none"
        ], x = ()=>[
            $12b9f2ef36f8b3b2$var$W,
            $12b9f2ef36f8b3b2$var$V,
            c
        ], S = ()=>[
            $12b9f2ef36f8b3b2$var$P,
            "full",
            "auto",
            ...x()
        ], re = ()=>[
            $12b9f2ef36f8b3b2$var$I,
            "none",
            "subgrid",
            $12b9f2ef36f8b3b2$var$W,
            $12b9f2ef36f8b3b2$var$V
        ], ie = ()=>[
            "auto",
            {
                span: [
                    "full",
                    $12b9f2ef36f8b3b2$var$I,
                    $12b9f2ef36f8b3b2$var$W,
                    $12b9f2ef36f8b3b2$var$V
                ]
            },
            $12b9f2ef36f8b3b2$var$I,
            $12b9f2ef36f8b3b2$var$W,
            $12b9f2ef36f8b3b2$var$V
        ], C = ()=>[
            $12b9f2ef36f8b3b2$var$I,
            "auto",
            $12b9f2ef36f8b3b2$var$W,
            $12b9f2ef36f8b3b2$var$V
        ], w = ()=>[
            "auto",
            "min",
            "max",
            "fr",
            $12b9f2ef36f8b3b2$var$W,
            $12b9f2ef36f8b3b2$var$V
        ], T = ()=>[
            "start",
            "end",
            "center",
            "between",
            "around",
            "evenly",
            "stretch",
            "baseline",
            "center-safe",
            "end-safe"
        ], E = ()=>[
            "start",
            "end",
            "center",
            "stretch",
            "center-safe",
            "end-safe"
        ], D = ()=>[
            "auto",
            ...x()
        ], k = ()=>[
            $12b9f2ef36f8b3b2$var$P,
            "auto",
            "full",
            "dvw",
            "dvh",
            "lvw",
            "lvh",
            "svw",
            "svh",
            "min",
            "max",
            "fit",
            ...x()
        ], A = ()=>[
            s,
            $12b9f2ef36f8b3b2$var$P,
            "screen",
            "full",
            "dvw",
            "lvw",
            "svw",
            "min",
            "max",
            "fit",
            ...x()
        ], j = ()=>[
            $12b9f2ef36f8b3b2$var$P,
            "screen",
            "full",
            "lh",
            "dvh",
            "lvh",
            "svh",
            "min",
            "max",
            "fit",
            ...x()
        ], M = ()=>[
            e,
            $12b9f2ef36f8b3b2$var$W,
            $12b9f2ef36f8b3b2$var$V
        ], ae = ()=>[
            ..._(),
            $12b9f2ef36f8b3b2$var$be,
            $12b9f2ef36f8b3b2$var$_e,
            {
                position: [
                    $12b9f2ef36f8b3b2$var$W,
                    $12b9f2ef36f8b3b2$var$V
                ]
            }
        ], oe = ()=>[
            "no-repeat",
            {
                repeat: [
                    "",
                    "x",
                    "y",
                    "space",
                    "round"
                ]
            }
        ], se = ()=>[
            "auto",
            "cover",
            "contain",
            $12b9f2ef36f8b3b2$var$xe,
            $12b9f2ef36f8b3b2$var$pe,
            {
                size: [
                    $12b9f2ef36f8b3b2$var$W,
                    $12b9f2ef36f8b3b2$var$V
                ]
            }
        ], N = ()=>[
            $12b9f2ef36f8b3b2$var$ce,
            $12b9f2ef36f8b3b2$var$G,
            $12b9f2ef36f8b3b2$var$H
        ], R = ()=>[
            "",
            "none",
            "full",
            l,
            $12b9f2ef36f8b3b2$var$W,
            $12b9f2ef36f8b3b2$var$V
        ], z = ()=>[
            "",
            $12b9f2ef36f8b3b2$var$F,
            $12b9f2ef36f8b3b2$var$G,
            $12b9f2ef36f8b3b2$var$H
        ], B = ()=>[
            "solid",
            "dashed",
            "dotted",
            "double"
        ], ue = ()=>[
            "normal",
            "multiply",
            "screen",
            "overlay",
            "darken",
            "lighten",
            "color-dodge",
            "color-burn",
            "hard-light",
            "soft-light",
            "difference",
            "exclusion",
            "hue",
            "saturation",
            "color",
            "luminosity"
        ], q = ()=>[
            $12b9f2ef36f8b3b2$var$F,
            $12b9f2ef36f8b3b2$var$ce,
            $12b9f2ef36f8b3b2$var$be,
            $12b9f2ef36f8b3b2$var$_e
        ], J = ()=>[
            "",
            "none",
            f,
            $12b9f2ef36f8b3b2$var$W,
            $12b9f2ef36f8b3b2$var$V
        ], Y = ()=>[
            "none",
            $12b9f2ef36f8b3b2$var$F,
            $12b9f2ef36f8b3b2$var$W,
            $12b9f2ef36f8b3b2$var$V
        ], X = ()=>[
            "none",
            $12b9f2ef36f8b3b2$var$F,
            $12b9f2ef36f8b3b2$var$W,
            $12b9f2ef36f8b3b2$var$V
        ], Z = ()=>[
            $12b9f2ef36f8b3b2$var$F,
            $12b9f2ef36f8b3b2$var$W,
            $12b9f2ef36f8b3b2$var$V
        ], Q = ()=>[
            $12b9f2ef36f8b3b2$var$P,
            "full",
            ...x()
        ];
    return {
        cacheSize: 500,
        theme: {
            animate: [
                "spin",
                "ping",
                "pulse",
                "bounce"
            ],
            aspect: [
                "video"
            ],
            blur: [
                $12b9f2ef36f8b3b2$var$L
            ],
            breakpoint: [
                $12b9f2ef36f8b3b2$var$L
            ],
            color: [
                $12b9f2ef36f8b3b2$var$le
            ],
            container: [
                $12b9f2ef36f8b3b2$var$L
            ],
            "drop-shadow": [
                $12b9f2ef36f8b3b2$var$L
            ],
            ease: [
                "in",
                "out",
                "in-out"
            ],
            font: [
                $12b9f2ef36f8b3b2$var$de
            ],
            "font-weight": [
                "thin",
                "extralight",
                "light",
                "normal",
                "medium",
                "semibold",
                "bold",
                "extrabold",
                "black"
            ],
            "inset-shadow": [
                $12b9f2ef36f8b3b2$var$L
            ],
            leading: [
                "none",
                "tight",
                "snug",
                "normal",
                "relaxed",
                "loose"
            ],
            perspective: [
                "dramatic",
                "near",
                "normal",
                "midrange",
                "distant",
                "none"
            ],
            radius: [
                $12b9f2ef36f8b3b2$var$L
            ],
            shadow: [
                $12b9f2ef36f8b3b2$var$L
            ],
            spacing: [
                "px",
                $12b9f2ef36f8b3b2$var$F
            ],
            text: [
                $12b9f2ef36f8b3b2$var$L
            ],
            "text-shadow": [
                $12b9f2ef36f8b3b2$var$L
            ],
            tracking: [
                "tighter",
                "tight",
                "normal",
                "wide",
                "wider",
                "widest"
            ]
        },
        classGroups: {
            aspect: [
                {
                    aspect: [
                        "auto",
                        "square",
                        $12b9f2ef36f8b3b2$var$P,
                        $12b9f2ef36f8b3b2$var$V,
                        $12b9f2ef36f8b3b2$var$W,
                        m
                    ]
                }
            ],
            container: [
                "container"
            ],
            "container-type": [
                {
                    "@container": [
                        "",
                        "normal",
                        "size",
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            "container-named": [
                $12b9f2ef36f8b3b2$var$fe
            ],
            columns: [
                {
                    columns: [
                        $12b9f2ef36f8b3b2$var$F,
                        "auto",
                        $12b9f2ef36f8b3b2$var$V,
                        $12b9f2ef36f8b3b2$var$W,
                        s
                    ]
                }
            ],
            "break-after": [
                {
                    "break-after": g()
                }
            ],
            "break-before": [
                {
                    "break-before": g()
                }
            ],
            "break-inside": [
                {
                    "break-inside": [
                        "auto",
                        "avoid",
                        "avoid-page",
                        "avoid-column"
                    ]
                }
            ],
            "box-decoration": [
                {
                    "box-decoration": [
                        "slice",
                        "clone"
                    ]
                }
            ],
            box: [
                {
                    box: [
                        "border",
                        "content"
                    ]
                }
            ],
            display: [
                "block",
                "inline-block",
                "inline",
                "flex",
                "inline-flex",
                "table",
                "inline-table",
                "table-caption",
                "table-cell",
                "table-column",
                "table-column-group",
                "table-footer-group",
                "table-header-group",
                "table-row-group",
                "table-row",
                "flow-root",
                "grid",
                "inline-grid",
                "contents",
                "list-item",
                "hidden"
            ],
            sr: [
                "sr-only",
                "not-sr-only"
            ],
            float: [
                {
                    float: [
                        "right",
                        "left",
                        "none",
                        "start",
                        "end"
                    ]
                }
            ],
            clear: [
                {
                    clear: [
                        "left",
                        "right",
                        "both",
                        "none",
                        "start",
                        "end"
                    ]
                }
            ],
            isolation: [
                "isolate",
                "isolation-auto"
            ],
            "object-fit": [
                {
                    object: [
                        "contain",
                        "cover",
                        "fill",
                        "none",
                        "scale-down"
                    ]
                }
            ],
            "object-position": [
                {
                    object: v()
                }
            ],
            overflow: [
                {
                    overflow: y()
                }
            ],
            "overflow-x": [
                {
                    "overflow-x": y()
                }
            ],
            "overflow-y": [
                {
                    "overflow-y": y()
                }
            ],
            overscroll: [
                {
                    overscroll: b()
                }
            ],
            "overscroll-x": [
                {
                    "overscroll-x": b()
                }
            ],
            "overscroll-y": [
                {
                    "overscroll-y": b()
                }
            ],
            position: [
                "static",
                "fixed",
                "absolute",
                "relative",
                "sticky"
            ],
            inset: [
                {
                    inset: S()
                }
            ],
            "inset-x": [
                {
                    "inset-x": S()
                }
            ],
            "inset-y": [
                {
                    "inset-y": S()
                }
            ],
            start: [
                {
                    "inset-s": S(),
                    start: S()
                }
            ],
            end: [
                {
                    "inset-e": S(),
                    end: S()
                }
            ],
            "inset-bs": [
                {
                    "inset-bs": S()
                }
            ],
            "inset-be": [
                {
                    "inset-be": S()
                }
            ],
            top: [
                {
                    top: S()
                }
            ],
            right: [
                {
                    right: S()
                }
            ],
            bottom: [
                {
                    bottom: S()
                }
            ],
            left: [
                {
                    left: S()
                }
            ],
            visibility: [
                "visible",
                "invisible",
                "collapse"
            ],
            z: [
                {
                    z: [
                        $12b9f2ef36f8b3b2$var$I,
                        "auto",
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            basis: [
                {
                    basis: [
                        $12b9f2ef36f8b3b2$var$P,
                        "full",
                        "auto",
                        s,
                        ...x()
                    ]
                }
            ],
            "flex-direction": [
                {
                    flex: [
                        "row",
                        "row-reverse",
                        "col",
                        "col-reverse"
                    ]
                }
            ],
            "flex-wrap": [
                {
                    flex: [
                        "nowrap",
                        "wrap",
                        "wrap-reverse"
                    ]
                }
            ],
            flex: [
                {
                    flex: [
                        $12b9f2ef36f8b3b2$var$F,
                        $12b9f2ef36f8b3b2$var$P,
                        "auto",
                        "initial",
                        "none",
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            grow: [
                {
                    grow: [
                        "",
                        $12b9f2ef36f8b3b2$var$F,
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            shrink: [
                {
                    shrink: [
                        "",
                        $12b9f2ef36f8b3b2$var$F,
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            order: [
                {
                    order: [
                        $12b9f2ef36f8b3b2$var$I,
                        "first",
                        "last",
                        "none",
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            "grid-cols": [
                {
                    "grid-cols": re()
                }
            ],
            "col-start-end": [
                {
                    col: ie()
                }
            ],
            "col-start": [
                {
                    "col-start": C()
                }
            ],
            "col-end": [
                {
                    "col-end": C()
                }
            ],
            "grid-rows": [
                {
                    "grid-rows": re()
                }
            ],
            "row-start-end": [
                {
                    row: ie()
                }
            ],
            "row-start": [
                {
                    "row-start": C()
                }
            ],
            "row-end": [
                {
                    "row-end": C()
                }
            ],
            "grid-flow": [
                {
                    "grid-flow": [
                        "row",
                        "col",
                        "dense",
                        "row-dense",
                        "col-dense"
                    ]
                }
            ],
            "auto-cols": [
                {
                    "auto-cols": w()
                }
            ],
            "auto-rows": [
                {
                    "auto-rows": w()
                }
            ],
            gap: [
                {
                    gap: x()
                }
            ],
            "gap-x": [
                {
                    "gap-x": x()
                }
            ],
            "gap-y": [
                {
                    "gap-y": x()
                }
            ],
            "justify-content": [
                {
                    justify: [
                        ...T(),
                        "normal"
                    ]
                }
            ],
            "justify-items": [
                {
                    "justify-items": [
                        ...E(),
                        "normal"
                    ]
                }
            ],
            "justify-self": [
                {
                    "justify-self": [
                        "auto",
                        ...E()
                    ]
                }
            ],
            "align-content": [
                {
                    content: [
                        "normal",
                        ...T()
                    ]
                }
            ],
            "align-items": [
                {
                    items: [
                        ...E(),
                        {
                            baseline: [
                                "",
                                "last"
                            ]
                        }
                    ]
                }
            ],
            "align-self": [
                {
                    self: [
                        "auto",
                        ...E(),
                        {
                            baseline: [
                                "",
                                "last"
                            ]
                        }
                    ]
                }
            ],
            "place-content": [
                {
                    "place-content": T()
                }
            ],
            "place-items": [
                {
                    "place-items": [
                        ...E(),
                        "baseline"
                    ]
                }
            ],
            "place-self": [
                {
                    "place-self": [
                        "auto",
                        ...E()
                    ]
                }
            ],
            p: [
                {
                    p: x()
                }
            ],
            px: [
                {
                    px: x()
                }
            ],
            py: [
                {
                    py: x()
                }
            ],
            ps: [
                {
                    ps: x()
                }
            ],
            pe: [
                {
                    pe: x()
                }
            ],
            pbs: [
                {
                    pbs: x()
                }
            ],
            pbe: [
                {
                    pbe: x()
                }
            ],
            pt: [
                {
                    pt: x()
                }
            ],
            pr: [
                {
                    pr: x()
                }
            ],
            pb: [
                {
                    pb: x()
                }
            ],
            pl: [
                {
                    pl: x()
                }
            ],
            m: [
                {
                    m: D()
                }
            ],
            mx: [
                {
                    mx: D()
                }
            ],
            my: [
                {
                    my: D()
                }
            ],
            ms: [
                {
                    ms: D()
                }
            ],
            me: [
                {
                    me: D()
                }
            ],
            mbs: [
                {
                    mbs: D()
                }
            ],
            mbe: [
                {
                    mbe: D()
                }
            ],
            mt: [
                {
                    mt: D()
                }
            ],
            mr: [
                {
                    mr: D()
                }
            ],
            mb: [
                {
                    mb: D()
                }
            ],
            ml: [
                {
                    ml: D()
                }
            ],
            "space-x": [
                {
                    "space-x": x()
                }
            ],
            "space-x-reverse": [
                "space-x-reverse"
            ],
            "space-y": [
                {
                    "space-y": x()
                }
            ],
            "space-y-reverse": [
                "space-y-reverse"
            ],
            size: [
                {
                    size: k()
                }
            ],
            "inline-size": [
                {
                    inline: [
                        "auto",
                        ...A()
                    ]
                }
            ],
            "min-inline-size": [
                {
                    "min-inline": [
                        "auto",
                        ...A()
                    ]
                }
            ],
            "max-inline-size": [
                {
                    "max-inline": [
                        "none",
                        ...A()
                    ]
                }
            ],
            "block-size": [
                {
                    block: [
                        "auto",
                        ...j()
                    ]
                }
            ],
            "min-block-size": [
                {
                    "min-block": [
                        "auto",
                        ...j()
                    ]
                }
            ],
            "max-block-size": [
                {
                    "max-block": [
                        "none",
                        ...j()
                    ]
                }
            ],
            w: [
                {
                    w: [
                        s,
                        "screen",
                        ...k()
                    ]
                }
            ],
            "min-w": [
                {
                    "min-w": [
                        s,
                        "screen",
                        "none",
                        ...k()
                    ]
                }
            ],
            "max-w": [
                {
                    "max-w": [
                        s,
                        "screen",
                        "none",
                        "prose",
                        {
                            screen: [
                                o
                            ]
                        },
                        ...k()
                    ]
                }
            ],
            h: [
                {
                    h: [
                        "screen",
                        "lh",
                        ...k()
                    ]
                }
            ],
            "min-h": [
                {
                    "min-h": [
                        "screen",
                        "lh",
                        "none",
                        ...k()
                    ]
                }
            ],
            "max-h": [
                {
                    "max-h": [
                        "screen",
                        "lh",
                        "none",
                        ...k()
                    ]
                }
            ],
            "font-size": [
                {
                    text: [
                        "base",
                        n,
                        $12b9f2ef36f8b3b2$var$G,
                        $12b9f2ef36f8b3b2$var$H
                    ]
                }
            ],
            "font-smoothing": [
                "antialiased",
                "subpixel-antialiased"
            ],
            "font-style": [
                "italic",
                "not-italic"
            ],
            "font-weight": [
                {
                    font: [
                        r,
                        $12b9f2ef36f8b3b2$var$Ce,
                        $12b9f2ef36f8b3b2$var$he
                    ]
                }
            ],
            "font-stretch": [
                {
                    "font-stretch": [
                        "ultra-condensed",
                        "extra-condensed",
                        "condensed",
                        "semi-condensed",
                        "normal",
                        "semi-expanded",
                        "expanded",
                        "extra-expanded",
                        "ultra-expanded",
                        $12b9f2ef36f8b3b2$var$ce,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            "font-family": [
                {
                    font: [
                        $12b9f2ef36f8b3b2$var$ye,
                        $12b9f2ef36f8b3b2$var$ge,
                        t
                    ]
                }
            ],
            "font-features": [
                {
                    "font-features": [
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            "fvn-normal": [
                "normal-nums"
            ],
            "fvn-ordinal": [
                "ordinal"
            ],
            "fvn-slashed-zero": [
                "slashed-zero"
            ],
            "fvn-figure": [
                "lining-nums",
                "oldstyle-nums"
            ],
            "fvn-spacing": [
                "proportional-nums",
                "tabular-nums"
            ],
            "fvn-fraction": [
                "diagonal-fractions",
                "stacked-fractions"
            ],
            tracking: [
                {
                    tracking: [
                        i,
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            "line-clamp": [
                {
                    "line-clamp": [
                        $12b9f2ef36f8b3b2$var$F,
                        "none",
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$me
                    ]
                }
            ],
            leading: [
                {
                    leading: [
                        "none",
                        a,
                        ...x()
                    ]
                }
            ],
            "list-image": [
                {
                    "list-image": [
                        "none",
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            "list-style-position": [
                {
                    list: [
                        "inside",
                        "outside"
                    ]
                }
            ],
            "list-style-type": [
                {
                    list: [
                        "disc",
                        "decimal",
                        "none",
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            "text-alignment": [
                {
                    text: [
                        "left",
                        "center",
                        "right",
                        "justify",
                        "start",
                        "end"
                    ]
                }
            ],
            "placeholder-color": [
                {
                    placeholder: M()
                }
            ],
            "text-color": [
                {
                    text: M()
                }
            ],
            "text-decoration": [
                "underline",
                "overline",
                "line-through",
                "no-underline"
            ],
            "text-decoration-style": [
                {
                    decoration: [
                        ...B(),
                        "wavy"
                    ]
                }
            ],
            "text-decoration-thickness": [
                {
                    decoration: [
                        $12b9f2ef36f8b3b2$var$F,
                        "from-font",
                        "auto",
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$H
                    ]
                }
            ],
            "text-decoration-color": [
                {
                    decoration: M()
                }
            ],
            "underline-offset": [
                {
                    "underline-offset": [
                        $12b9f2ef36f8b3b2$var$F,
                        "auto",
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            "text-transform": [
                "uppercase",
                "lowercase",
                "capitalize",
                "normal-case"
            ],
            "text-overflow": [
                "truncate",
                "text-ellipsis",
                "text-clip"
            ],
            "text-wrap": [
                {
                    text: [
                        "wrap",
                        "nowrap",
                        "balance",
                        "pretty"
                    ]
                }
            ],
            indent: [
                {
                    indent: x()
                }
            ],
            "tab-size": [
                {
                    tab: [
                        $12b9f2ef36f8b3b2$var$I,
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            "vertical-align": [
                {
                    align: [
                        "baseline",
                        "top",
                        "middle",
                        "bottom",
                        "text-top",
                        "text-bottom",
                        "sub",
                        "super",
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            whitespace: [
                {
                    whitespace: [
                        "normal",
                        "nowrap",
                        "pre",
                        "pre-line",
                        "pre-wrap",
                        "break-spaces"
                    ]
                }
            ],
            break: [
                {
                    break: [
                        "normal",
                        "words",
                        "all",
                        "keep"
                    ]
                }
            ],
            wrap: [
                {
                    wrap: [
                        "break-word",
                        "anywhere",
                        "normal"
                    ]
                }
            ],
            hyphens: [
                {
                    hyphens: [
                        "none",
                        "manual",
                        "auto"
                    ]
                }
            ],
            content: [
                {
                    content: [
                        "none",
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            "bg-attachment": [
                {
                    bg: [
                        "fixed",
                        "local",
                        "scroll"
                    ]
                }
            ],
            "bg-clip": [
                {
                    "bg-clip": [
                        "border",
                        "padding",
                        "content",
                        "text"
                    ]
                }
            ],
            "bg-origin": [
                {
                    "bg-origin": [
                        "border",
                        "padding",
                        "content"
                    ]
                }
            ],
            "bg-position": [
                {
                    bg: ae()
                }
            ],
            "bg-repeat": [
                {
                    bg: oe()
                }
            ],
            "bg-size": [
                {
                    bg: se()
                }
            ],
            "bg-image": [
                {
                    bg: [
                        "none",
                        {
                            linear: [
                                {
                                    to: [
                                        "t",
                                        "tr",
                                        "r",
                                        "br",
                                        "b",
                                        "bl",
                                        "l",
                                        "tl"
                                    ]
                                },
                                $12b9f2ef36f8b3b2$var$I,
                                $12b9f2ef36f8b3b2$var$W,
                                $12b9f2ef36f8b3b2$var$V
                            ],
                            radial: [
                                "",
                                $12b9f2ef36f8b3b2$var$W,
                                $12b9f2ef36f8b3b2$var$V
                            ],
                            conic: [
                                "",
                                $12b9f2ef36f8b3b2$var$I,
                                $12b9f2ef36f8b3b2$var$W,
                                $12b9f2ef36f8b3b2$var$V
                            ]
                        },
                        $12b9f2ef36f8b3b2$var$Se,
                        $12b9f2ef36f8b3b2$var$ve
                    ]
                }
            ],
            "bg-color": [
                {
                    bg: M()
                }
            ],
            "gradient-from-pos": [
                {
                    from: N()
                }
            ],
            "gradient-via-pos": [
                {
                    via: N()
                }
            ],
            "gradient-to-pos": [
                {
                    to: N()
                }
            ],
            "gradient-from": [
                {
                    from: M()
                }
            ],
            "gradient-via": [
                {
                    via: M()
                }
            ],
            "gradient-to": [
                {
                    to: M()
                }
            ],
            rounded: [
                {
                    rounded: R()
                }
            ],
            "rounded-s": [
                {
                    "rounded-s": R()
                }
            ],
            "rounded-e": [
                {
                    "rounded-e": R()
                }
            ],
            "rounded-t": [
                {
                    "rounded-t": R()
                }
            ],
            "rounded-r": [
                {
                    "rounded-r": R()
                }
            ],
            "rounded-b": [
                {
                    "rounded-b": R()
                }
            ],
            "rounded-l": [
                {
                    "rounded-l": R()
                }
            ],
            "rounded-ss": [
                {
                    "rounded-ss": R()
                }
            ],
            "rounded-se": [
                {
                    "rounded-se": R()
                }
            ],
            "rounded-ee": [
                {
                    "rounded-ee": R()
                }
            ],
            "rounded-es": [
                {
                    "rounded-es": R()
                }
            ],
            "rounded-tl": [
                {
                    "rounded-tl": R()
                }
            ],
            "rounded-tr": [
                {
                    "rounded-tr": R()
                }
            ],
            "rounded-br": [
                {
                    "rounded-br": R()
                }
            ],
            "rounded-bl": [
                {
                    "rounded-bl": R()
                }
            ],
            "border-w": [
                {
                    border: z()
                }
            ],
            "border-w-x": [
                {
                    "border-x": z()
                }
            ],
            "border-w-y": [
                {
                    "border-y": z()
                }
            ],
            "border-w-s": [
                {
                    "border-s": z()
                }
            ],
            "border-w-e": [
                {
                    "border-e": z()
                }
            ],
            "border-w-bs": [
                {
                    "border-bs": z()
                }
            ],
            "border-w-be": [
                {
                    "border-be": z()
                }
            ],
            "border-w-t": [
                {
                    "border-t": z()
                }
            ],
            "border-w-r": [
                {
                    "border-r": z()
                }
            ],
            "border-w-b": [
                {
                    "border-b": z()
                }
            ],
            "border-w-l": [
                {
                    "border-l": z()
                }
            ],
            "divide-x": [
                {
                    "divide-x": z()
                }
            ],
            "divide-x-reverse": [
                "divide-x-reverse"
            ],
            "divide-y": [
                {
                    "divide-y": z()
                }
            ],
            "divide-y-reverse": [
                "divide-y-reverse"
            ],
            "border-style": [
                {
                    border: [
                        ...B(),
                        "hidden",
                        "none"
                    ]
                }
            ],
            "divide-style": [
                {
                    divide: [
                        ...B(),
                        "hidden",
                        "none"
                    ]
                }
            ],
            "border-color": [
                {
                    border: M()
                }
            ],
            "border-color-x": [
                {
                    "border-x": M()
                }
            ],
            "border-color-y": [
                {
                    "border-y": M()
                }
            ],
            "border-color-s": [
                {
                    "border-s": M()
                }
            ],
            "border-color-e": [
                {
                    "border-e": M()
                }
            ],
            "border-color-bs": [
                {
                    "border-bs": M()
                }
            ],
            "border-color-be": [
                {
                    "border-be": M()
                }
            ],
            "border-color-t": [
                {
                    "border-t": M()
                }
            ],
            "border-color-r": [
                {
                    "border-r": M()
                }
            ],
            "border-color-b": [
                {
                    "border-b": M()
                }
            ],
            "border-color-l": [
                {
                    "border-l": M()
                }
            ],
            "divide-color": [
                {
                    divide: M()
                }
            ],
            "outline-style": [
                {
                    outline: [
                        ...B(),
                        "none",
                        "hidden"
                    ]
                }
            ],
            "outline-offset": [
                {
                    "outline-offset": [
                        $12b9f2ef36f8b3b2$var$F,
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            "outline-w": [
                {
                    outline: [
                        "",
                        $12b9f2ef36f8b3b2$var$F,
                        $12b9f2ef36f8b3b2$var$G,
                        $12b9f2ef36f8b3b2$var$H
                    ]
                }
            ],
            "outline-color": [
                {
                    outline: M()
                }
            ],
            shadow: [
                {
                    shadow: [
                        "",
                        "inner",
                        "none",
                        ee,
                        $12b9f2ef36f8b3b2$var$K,
                        $12b9f2ef36f8b3b2$var$U
                    ]
                }
            ],
            "shadow-color": [
                {
                    shadow: M()
                }
            ],
            "inset-shadow": [
                {
                    "inset-shadow": [
                        "none",
                        u,
                        $12b9f2ef36f8b3b2$var$K,
                        $12b9f2ef36f8b3b2$var$U
                    ]
                }
            ],
            "inset-shadow-color": [
                {
                    "inset-shadow": M()
                }
            ],
            "ring-w": [
                {
                    ring: z()
                }
            ],
            "ring-w-inset": [
                "ring-inset"
            ],
            "ring-color": [
                {
                    ring: M()
                }
            ],
            "ring-offset-w": [
                {
                    "ring-offset": [
                        $12b9f2ef36f8b3b2$var$F,
                        $12b9f2ef36f8b3b2$var$H
                    ]
                }
            ],
            "ring-offset-color": [
                {
                    "ring-offset": M()
                }
            ],
            "inset-ring-w": [
                {
                    "inset-ring": z()
                }
            ],
            "inset-ring-color": [
                {
                    "inset-ring": M()
                }
            ],
            "text-shadow": [
                {
                    "text-shadow": [
                        "none",
                        te,
                        $12b9f2ef36f8b3b2$var$K,
                        $12b9f2ef36f8b3b2$var$U
                    ]
                }
            ],
            "text-shadow-color": [
                {
                    "text-shadow": M()
                }
            ],
            opacity: [
                {
                    opacity: [
                        $12b9f2ef36f8b3b2$var$F,
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            "mix-blend": [
                {
                    "mix-blend": [
                        ...ue(),
                        "plus-darker",
                        "plus-lighter"
                    ]
                }
            ],
            "bg-blend": [
                {
                    "bg-blend": ue()
                }
            ],
            "mask-clip": [
                {
                    "mask-clip": [
                        "border",
                        "padding",
                        "content",
                        "fill",
                        "stroke",
                        "view"
                    ]
                },
                "mask-no-clip"
            ],
            "mask-composite": [
                {
                    mask: [
                        "add",
                        "subtract",
                        "intersect",
                        "exclude"
                    ]
                }
            ],
            "mask-image-linear-pos": [
                {
                    "mask-linear": [
                        $12b9f2ef36f8b3b2$var$F
                    ]
                }
            ],
            "mask-image-linear-from-pos": [
                {
                    "mask-linear-from": q()
                }
            ],
            "mask-image-linear-to-pos": [
                {
                    "mask-linear-to": q()
                }
            ],
            "mask-image-linear-from-color": [
                {
                    "mask-linear-from": M()
                }
            ],
            "mask-image-linear-to-color": [
                {
                    "mask-linear-to": M()
                }
            ],
            "mask-image-t-from-pos": [
                {
                    "mask-t-from": q()
                }
            ],
            "mask-image-t-to-pos": [
                {
                    "mask-t-to": q()
                }
            ],
            "mask-image-t-from-color": [
                {
                    "mask-t-from": M()
                }
            ],
            "mask-image-t-to-color": [
                {
                    "mask-t-to": M()
                }
            ],
            "mask-image-r-from-pos": [
                {
                    "mask-r-from": q()
                }
            ],
            "mask-image-r-to-pos": [
                {
                    "mask-r-to": q()
                }
            ],
            "mask-image-r-from-color": [
                {
                    "mask-r-from": M()
                }
            ],
            "mask-image-r-to-color": [
                {
                    "mask-r-to": M()
                }
            ],
            "mask-image-b-from-pos": [
                {
                    "mask-b-from": q()
                }
            ],
            "mask-image-b-to-pos": [
                {
                    "mask-b-to": q()
                }
            ],
            "mask-image-b-from-color": [
                {
                    "mask-b-from": M()
                }
            ],
            "mask-image-b-to-color": [
                {
                    "mask-b-to": M()
                }
            ],
            "mask-image-l-from-pos": [
                {
                    "mask-l-from": q()
                }
            ],
            "mask-image-l-to-pos": [
                {
                    "mask-l-to": q()
                }
            ],
            "mask-image-l-from-color": [
                {
                    "mask-l-from": M()
                }
            ],
            "mask-image-l-to-color": [
                {
                    "mask-l-to": M()
                }
            ],
            "mask-image-x-from-pos": [
                {
                    "mask-x-from": q()
                }
            ],
            "mask-image-x-to-pos": [
                {
                    "mask-x-to": q()
                }
            ],
            "mask-image-x-from-color": [
                {
                    "mask-x-from": M()
                }
            ],
            "mask-image-x-to-color": [
                {
                    "mask-x-to": M()
                }
            ],
            "mask-image-y-from-pos": [
                {
                    "mask-y-from": q()
                }
            ],
            "mask-image-y-to-pos": [
                {
                    "mask-y-to": q()
                }
            ],
            "mask-image-y-from-color": [
                {
                    "mask-y-from": M()
                }
            ],
            "mask-image-y-to-color": [
                {
                    "mask-y-to": M()
                }
            ],
            "mask-image-radial": [
                {
                    "mask-radial": [
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            "mask-image-radial-from-pos": [
                {
                    "mask-radial-from": q()
                }
            ],
            "mask-image-radial-to-pos": [
                {
                    "mask-radial-to": q()
                }
            ],
            "mask-image-radial-from-color": [
                {
                    "mask-radial-from": M()
                }
            ],
            "mask-image-radial-to-color": [
                {
                    "mask-radial-to": M()
                }
            ],
            "mask-image-radial-shape": [
                {
                    "mask-radial": [
                        "circle",
                        "ellipse"
                    ]
                }
            ],
            "mask-image-radial-size": [
                {
                    "mask-radial": [
                        {
                            closest: [
                                "side",
                                "corner"
                            ],
                            farthest: [
                                "side",
                                "corner"
                            ]
                        }
                    ]
                }
            ],
            "mask-image-radial-pos": [
                {
                    "mask-radial-at": _()
                }
            ],
            "mask-image-conic-pos": [
                {
                    "mask-conic": [
                        $12b9f2ef36f8b3b2$var$F
                    ]
                }
            ],
            "mask-image-conic-from-pos": [
                {
                    "mask-conic-from": q()
                }
            ],
            "mask-image-conic-to-pos": [
                {
                    "mask-conic-to": q()
                }
            ],
            "mask-image-conic-from-color": [
                {
                    "mask-conic-from": M()
                }
            ],
            "mask-image-conic-to-color": [
                {
                    "mask-conic-to": M()
                }
            ],
            "mask-mode": [
                {
                    mask: [
                        "alpha",
                        "luminance",
                        "match"
                    ]
                }
            ],
            "mask-origin": [
                {
                    "mask-origin": [
                        "border",
                        "padding",
                        "content",
                        "fill",
                        "stroke",
                        "view"
                    ]
                }
            ],
            "mask-position": [
                {
                    mask: ae()
                }
            ],
            "mask-repeat": [
                {
                    mask: oe()
                }
            ],
            "mask-size": [
                {
                    mask: se()
                }
            ],
            "mask-type": [
                {
                    "mask-type": [
                        "alpha",
                        "luminance"
                    ]
                }
            ],
            "mask-image": [
                {
                    mask: [
                        "none",
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            filter: [
                {
                    filter: [
                        "",
                        "none",
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            blur: [
                {
                    blur: J()
                }
            ],
            brightness: [
                {
                    brightness: [
                        $12b9f2ef36f8b3b2$var$F,
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            contrast: [
                {
                    contrast: [
                        $12b9f2ef36f8b3b2$var$F,
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            "drop-shadow": [
                {
                    "drop-shadow": [
                        "",
                        "none",
                        d,
                        $12b9f2ef36f8b3b2$var$K,
                        $12b9f2ef36f8b3b2$var$U
                    ]
                }
            ],
            "drop-shadow-color": [
                {
                    "drop-shadow": M()
                }
            ],
            grayscale: [
                {
                    grayscale: [
                        "",
                        $12b9f2ef36f8b3b2$var$F,
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            "hue-rotate": [
                {
                    "hue-rotate": [
                        $12b9f2ef36f8b3b2$var$F,
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            invert: [
                {
                    invert: [
                        "",
                        $12b9f2ef36f8b3b2$var$F,
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            saturate: [
                {
                    saturate: [
                        $12b9f2ef36f8b3b2$var$F,
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            sepia: [
                {
                    sepia: [
                        "",
                        $12b9f2ef36f8b3b2$var$F,
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            "backdrop-filter": [
                {
                    "backdrop-filter": [
                        "",
                        "none",
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            "backdrop-blur": [
                {
                    "backdrop-blur": J()
                }
            ],
            "backdrop-brightness": [
                {
                    "backdrop-brightness": [
                        $12b9f2ef36f8b3b2$var$F,
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            "backdrop-contrast": [
                {
                    "backdrop-contrast": [
                        $12b9f2ef36f8b3b2$var$F,
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            "backdrop-grayscale": [
                {
                    "backdrop-grayscale": [
                        "",
                        $12b9f2ef36f8b3b2$var$F,
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            "backdrop-hue-rotate": [
                {
                    "backdrop-hue-rotate": [
                        $12b9f2ef36f8b3b2$var$F,
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            "backdrop-invert": [
                {
                    "backdrop-invert": [
                        "",
                        $12b9f2ef36f8b3b2$var$F,
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            "backdrop-opacity": [
                {
                    "backdrop-opacity": [
                        $12b9f2ef36f8b3b2$var$F,
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            "backdrop-saturate": [
                {
                    "backdrop-saturate": [
                        $12b9f2ef36f8b3b2$var$F,
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            "backdrop-sepia": [
                {
                    "backdrop-sepia": [
                        "",
                        $12b9f2ef36f8b3b2$var$F,
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            "border-collapse": [
                {
                    border: [
                        "collapse",
                        "separate"
                    ]
                }
            ],
            "border-spacing": [
                {
                    "border-spacing": x()
                }
            ],
            "border-spacing-x": [
                {
                    "border-spacing-x": x()
                }
            ],
            "border-spacing-y": [
                {
                    "border-spacing-y": x()
                }
            ],
            "table-layout": [
                {
                    table: [
                        "auto",
                        "fixed"
                    ]
                }
            ],
            caption: [
                {
                    caption: [
                        "top",
                        "bottom"
                    ]
                }
            ],
            transition: [
                {
                    transition: [
                        "",
                        "all",
                        "colors",
                        "opacity",
                        "shadow",
                        "transform",
                        "none",
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            "transition-behavior": [
                {
                    transition: [
                        "normal",
                        "discrete"
                    ]
                }
            ],
            duration: [
                {
                    duration: [
                        $12b9f2ef36f8b3b2$var$F,
                        "initial",
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            ease: [
                {
                    ease: [
                        "linear",
                        "initial",
                        h,
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            delay: [
                {
                    delay: [
                        $12b9f2ef36f8b3b2$var$F,
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            animate: [
                {
                    animate: [
                        "none",
                        ne,
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            backface: [
                {
                    backface: [
                        "hidden",
                        "visible"
                    ]
                }
            ],
            perspective: [
                {
                    perspective: [
                        p,
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            "perspective-origin": [
                {
                    "perspective-origin": v()
                }
            ],
            rotate: [
                {
                    rotate: Y()
                }
            ],
            "rotate-x": [
                {
                    "rotate-x": Y()
                }
            ],
            "rotate-y": [
                {
                    "rotate-y": Y()
                }
            ],
            "rotate-z": [
                {
                    "rotate-z": Y()
                }
            ],
            scale: [
                {
                    scale: X()
                }
            ],
            "scale-x": [
                {
                    "scale-x": X()
                }
            ],
            "scale-y": [
                {
                    "scale-y": X()
                }
            ],
            "scale-z": [
                {
                    "scale-z": X()
                }
            ],
            "scale-3d": [
                "scale-3d"
            ],
            skew: [
                {
                    skew: Z()
                }
            ],
            "skew-x": [
                {
                    "skew-x": Z()
                }
            ],
            "skew-y": [
                {
                    "skew-y": Z()
                }
            ],
            transform: [
                {
                    transform: [
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V,
                        "",
                        "none",
                        "gpu",
                        "cpu"
                    ]
                }
            ],
            "transform-origin": [
                {
                    origin: v()
                }
            ],
            "transform-style": [
                {
                    transform: [
                        "3d",
                        "flat"
                    ]
                }
            ],
            translate: [
                {
                    translate: Q()
                }
            ],
            "translate-x": [
                {
                    "translate-x": Q()
                }
            ],
            "translate-y": [
                {
                    "translate-y": Q()
                }
            ],
            "translate-z": [
                {
                    "translate-z": Q()
                }
            ],
            "translate-none": [
                "translate-none"
            ],
            zoom: [
                {
                    zoom: [
                        $12b9f2ef36f8b3b2$var$I,
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            accent: [
                {
                    accent: M()
                }
            ],
            appearance: [
                {
                    appearance: [
                        "none",
                        "auto"
                    ]
                }
            ],
            "caret-color": [
                {
                    caret: M()
                }
            ],
            "color-scheme": [
                {
                    scheme: [
                        "normal",
                        "dark",
                        "light",
                        "light-dark",
                        "only-dark",
                        "only-light"
                    ]
                }
            ],
            cursor: [
                {
                    cursor: [
                        "auto",
                        "default",
                        "pointer",
                        "wait",
                        "text",
                        "move",
                        "help",
                        "not-allowed",
                        "none",
                        "context-menu",
                        "progress",
                        "cell",
                        "crosshair",
                        "vertical-text",
                        "alias",
                        "copy",
                        "no-drop",
                        "grab",
                        "grabbing",
                        "all-scroll",
                        "col-resize",
                        "row-resize",
                        "n-resize",
                        "e-resize",
                        "s-resize",
                        "w-resize",
                        "ne-resize",
                        "nw-resize",
                        "se-resize",
                        "sw-resize",
                        "ew-resize",
                        "ns-resize",
                        "nesw-resize",
                        "nwse-resize",
                        "zoom-in",
                        "zoom-out",
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            "field-sizing": [
                {
                    "field-sizing": [
                        "fixed",
                        "content"
                    ]
                }
            ],
            "pointer-events": [
                {
                    "pointer-events": [
                        "auto",
                        "none"
                    ]
                }
            ],
            resize: [
                {
                    resize: [
                        "none",
                        "",
                        "y",
                        "x"
                    ]
                }
            ],
            "scroll-behavior": [
                {
                    scroll: [
                        "auto",
                        "smooth"
                    ]
                }
            ],
            "scrollbar-thumb-color": [
                {
                    "scrollbar-thumb": M()
                }
            ],
            "scrollbar-track-color": [
                {
                    "scrollbar-track": M()
                }
            ],
            "scrollbar-gutter": [
                {
                    "scrollbar-gutter": [
                        "auto",
                        "stable",
                        "both"
                    ]
                }
            ],
            "scrollbar-w": [
                {
                    scrollbar: [
                        "auto",
                        "thin",
                        "none"
                    ]
                }
            ],
            "scroll-m": [
                {
                    "scroll-m": x()
                }
            ],
            "scroll-mx": [
                {
                    "scroll-mx": x()
                }
            ],
            "scroll-my": [
                {
                    "scroll-my": x()
                }
            ],
            "scroll-ms": [
                {
                    "scroll-ms": x()
                }
            ],
            "scroll-me": [
                {
                    "scroll-me": x()
                }
            ],
            "scroll-mbs": [
                {
                    "scroll-mbs": x()
                }
            ],
            "scroll-mbe": [
                {
                    "scroll-mbe": x()
                }
            ],
            "scroll-mt": [
                {
                    "scroll-mt": x()
                }
            ],
            "scroll-mr": [
                {
                    "scroll-mr": x()
                }
            ],
            "scroll-mb": [
                {
                    "scroll-mb": x()
                }
            ],
            "scroll-ml": [
                {
                    "scroll-ml": x()
                }
            ],
            "scroll-p": [
                {
                    "scroll-p": x()
                }
            ],
            "scroll-px": [
                {
                    "scroll-px": x()
                }
            ],
            "scroll-py": [
                {
                    "scroll-py": x()
                }
            ],
            "scroll-ps": [
                {
                    "scroll-ps": x()
                }
            ],
            "scroll-pe": [
                {
                    "scroll-pe": x()
                }
            ],
            "scroll-pbs": [
                {
                    "scroll-pbs": x()
                }
            ],
            "scroll-pbe": [
                {
                    "scroll-pbe": x()
                }
            ],
            "scroll-pt": [
                {
                    "scroll-pt": x()
                }
            ],
            "scroll-pr": [
                {
                    "scroll-pr": x()
                }
            ],
            "scroll-pb": [
                {
                    "scroll-pb": x()
                }
            ],
            "scroll-pl": [
                {
                    "scroll-pl": x()
                }
            ],
            "snap-align": [
                {
                    snap: [
                        "start",
                        "end",
                        "center",
                        "align-none"
                    ]
                }
            ],
            "snap-stop": [
                {
                    snap: [
                        "normal",
                        "always"
                    ]
                }
            ],
            "snap-type": [
                {
                    snap: [
                        "none",
                        "x",
                        "y",
                        "both"
                    ]
                }
            ],
            "snap-strictness": [
                {
                    snap: [
                        "mandatory",
                        "proximity"
                    ]
                }
            ],
            touch: [
                {
                    touch: [
                        "auto",
                        "none",
                        "manipulation"
                    ]
                }
            ],
            "touch-x": [
                {
                    "touch-pan": [
                        "x",
                        "left",
                        "right"
                    ]
                }
            ],
            "touch-y": [
                {
                    "touch-pan": [
                        "y",
                        "up",
                        "down"
                    ]
                }
            ],
            "touch-pz": [
                "touch-pinch-zoom"
            ],
            select: [
                {
                    select: [
                        "none",
                        "text",
                        "all",
                        "auto"
                    ]
                }
            ],
            "will-change": [
                {
                    "will-change": [
                        "auto",
                        "scroll",
                        "contents",
                        "transform",
                        $12b9f2ef36f8b3b2$var$W,
                        $12b9f2ef36f8b3b2$var$V
                    ]
                }
            ],
            fill: [
                {
                    fill: [
                        "none",
                        ...M()
                    ]
                }
            ],
            "stroke-w": [
                {
                    stroke: [
                        $12b9f2ef36f8b3b2$var$F,
                        $12b9f2ef36f8b3b2$var$G,
                        $12b9f2ef36f8b3b2$var$H,
                        $12b9f2ef36f8b3b2$var$me
                    ]
                }
            ],
            stroke: [
                {
                    stroke: [
                        "none",
                        ...M()
                    ]
                }
            ],
            "forced-color-adjust": [
                {
                    "forced-color-adjust": [
                        "auto",
                        "none"
                    ]
                }
            ]
        },
        conflictingClassGroups: {
            "container-named": [
                "container-type"
            ],
            overflow: [
                "overflow-x",
                "overflow-y"
            ],
            overscroll: [
                "overscroll-x",
                "overscroll-y"
            ],
            inset: [
                "inset-x",
                "inset-y",
                "inset-bs",
                "inset-be",
                "start",
                "end",
                "top",
                "right",
                "bottom",
                "left"
            ],
            "inset-x": [
                "start",
                "end",
                "right",
                "left"
            ],
            "inset-y": [
                "inset-bs",
                "inset-be",
                "top",
                "bottom"
            ],
            flex: [
                "basis",
                "grow",
                "shrink"
            ],
            gap: [
                "gap-x",
                "gap-y"
            ],
            p: [
                "px",
                "py",
                "ps",
                "pe",
                "pbs",
                "pbe",
                "pt",
                "pr",
                "pb",
                "pl"
            ],
            px: [
                "ps",
                "pe",
                "pr",
                "pl"
            ],
            py: [
                "pbs",
                "pbe",
                "pt",
                "pb"
            ],
            m: [
                "mx",
                "my",
                "ms",
                "me",
                "mbs",
                "mbe",
                "mt",
                "mr",
                "mb",
                "ml"
            ],
            mx: [
                "ms",
                "me",
                "mr",
                "ml"
            ],
            my: [
                "mbs",
                "mbe",
                "mt",
                "mb"
            ],
            size: [
                "w",
                "h"
            ],
            "font-size": [
                "leading"
            ],
            "fvn-normal": [
                "fvn-ordinal",
                "fvn-slashed-zero",
                "fvn-figure",
                "fvn-spacing",
                "fvn-fraction"
            ],
            "fvn-ordinal": [
                "fvn-normal"
            ],
            "fvn-slashed-zero": [
                "fvn-normal"
            ],
            "fvn-figure": [
                "fvn-normal"
            ],
            "fvn-spacing": [
                "fvn-normal"
            ],
            "fvn-fraction": [
                "fvn-normal"
            ],
            "line-clamp": [
                "display",
                "overflow"
            ],
            rounded: [
                "rounded-s",
                "rounded-e",
                "rounded-t",
                "rounded-r",
                "rounded-b",
                "rounded-l",
                "rounded-ss",
                "rounded-se",
                "rounded-ee",
                "rounded-es",
                "rounded-tl",
                "rounded-tr",
                "rounded-br",
                "rounded-bl"
            ],
            "rounded-s": [
                "rounded-ss",
                "rounded-es"
            ],
            "rounded-e": [
                "rounded-se",
                "rounded-ee"
            ],
            "rounded-t": [
                "rounded-tl",
                "rounded-tr"
            ],
            "rounded-r": [
                "rounded-tr",
                "rounded-br"
            ],
            "rounded-b": [
                "rounded-br",
                "rounded-bl"
            ],
            "rounded-l": [
                "rounded-tl",
                "rounded-bl"
            ],
            "border-spacing": [
                "border-spacing-x",
                "border-spacing-y"
            ],
            "border-w": [
                "border-w-x",
                "border-w-y",
                "border-w-s",
                "border-w-e",
                "border-w-bs",
                "border-w-be",
                "border-w-t",
                "border-w-r",
                "border-w-b",
                "border-w-l"
            ],
            "border-w-x": [
                "border-w-s",
                "border-w-e",
                "border-w-r",
                "border-w-l"
            ],
            "border-w-y": [
                "border-w-bs",
                "border-w-be",
                "border-w-t",
                "border-w-b"
            ],
            "border-color": [
                "border-color-x",
                "border-color-y",
                "border-color-s",
                "border-color-e",
                "border-color-bs",
                "border-color-be",
                "border-color-t",
                "border-color-r",
                "border-color-b",
                "border-color-l"
            ],
            "border-color-x": [
                "border-color-s",
                "border-color-e",
                "border-color-r",
                "border-color-l"
            ],
            "border-color-y": [
                "border-color-bs",
                "border-color-be",
                "border-color-t",
                "border-color-b"
            ],
            translate: [
                "translate-x",
                "translate-y",
                "translate-none"
            ],
            "translate-none": [
                "translate",
                "translate-x",
                "translate-y",
                "translate-z"
            ],
            "scroll-m": [
                "scroll-mx",
                "scroll-my",
                "scroll-ms",
                "scroll-me",
                "scroll-mbs",
                "scroll-mbe",
                "scroll-mt",
                "scroll-mr",
                "scroll-mb",
                "scroll-ml"
            ],
            "scroll-mx": [
                "scroll-ms",
                "scroll-me",
                "scroll-mr",
                "scroll-ml"
            ],
            "scroll-my": [
                "scroll-mbs",
                "scroll-mbe",
                "scroll-mt",
                "scroll-mb"
            ],
            "scroll-p": [
                "scroll-px",
                "scroll-py",
                "scroll-ps",
                "scroll-pe",
                "scroll-pbs",
                "scroll-pbe",
                "scroll-pt",
                "scroll-pr",
                "scroll-pb",
                "scroll-pl"
            ],
            "scroll-px": [
                "scroll-ps",
                "scroll-pe",
                "scroll-pr",
                "scroll-pl"
            ],
            "scroll-py": [
                "scroll-pbs",
                "scroll-pbe",
                "scroll-pt",
                "scroll-pb"
            ],
            touch: [
                "touch-x",
                "touch-y",
                "touch-pz"
            ],
            "touch-x": [
                "touch"
            ],
            "touch-y": [
                "touch"
            ],
            "touch-pz": [
                "touch"
            ]
        },
        conflictingClassGroupModifiers: {
            "font-size": [
                "leading"
            ]
        },
        postfixLookupClassGroups: [
            "container-type"
        ],
        orderSensitiveModifiers: [
            "*",
            "**",
            "after",
            "backdrop",
            "before",
            "details-content",
            "file",
            "first-letter",
            "first-line",
            "marker",
            "placeholder",
            "selection"
        ]
    };
}, $12b9f2ef36f8b3b2$export$5d86b86a654a7039 = (e, { cacheSize: t, prefix: n, experimentalParseClassName: r, extend: i = {}, override: a = {} })=>($12b9f2ef36f8b3b2$var$$(e, "cacheSize", t), $12b9f2ef36f8b3b2$var$$(e, "prefix", n), $12b9f2ef36f8b3b2$var$$(e, "experimentalParseClassName", r), $12b9f2ef36f8b3b2$var$Ae(e.theme, a.theme), $12b9f2ef36f8b3b2$var$Ae(e.classGroups, a.classGroups), $12b9f2ef36f8b3b2$var$Ae(e.conflictingClassGroups, a.conflictingClassGroups), $12b9f2ef36f8b3b2$var$Ae(e.conflictingClassGroupModifiers, a.conflictingClassGroupModifiers), $12b9f2ef36f8b3b2$var$$(e, "postfixLookupClassGroups", a.postfixLookupClassGroups), $12b9f2ef36f8b3b2$var$$(e, "orderSensitiveModifiers", a.orderSensitiveModifiers), $12b9f2ef36f8b3b2$var$je(e.theme, i.theme), $12b9f2ef36f8b3b2$var$je(e.classGroups, i.classGroups), $12b9f2ef36f8b3b2$var$je(e.conflictingClassGroups, i.conflictingClassGroups), $12b9f2ef36f8b3b2$var$je(e.conflictingClassGroupModifiers, i.conflictingClassGroupModifiers), $12b9f2ef36f8b3b2$var$Me(e, i, "postfixLookupClassGroups"), $12b9f2ef36f8b3b2$var$Me(e, i, "orderSensitiveModifiers"), e), $12b9f2ef36f8b3b2$var$$ = (e, t, n)=>{
    n !== void 0 && (e[t] = n);
}, $12b9f2ef36f8b3b2$var$Ae = (e, t)=>{
    if (t) for(let n in t)$12b9f2ef36f8b3b2$var$$(e, n, t[n]);
}, $12b9f2ef36f8b3b2$var$je = (e, t)=>{
    if (t) for(let n in t)$12b9f2ef36f8b3b2$var$Me(e, t, n);
}, $12b9f2ef36f8b3b2$var$Me = (e, t, n)=>{
    let r = t[n];
    r !== void 0 && (e[n] = e[n] ? e[n].concat(r) : r);
}, $12b9f2ef36f8b3b2$export$c8d8406b6cd2243e = (e, ...t)=>typeof e == "function" ? $12b9f2ef36f8b3b2$export$ea2d4fba4d1bd27f($12b9f2ef36f8b3b2$export$ed30944e0fe6ae5c, e, ...t) : $12b9f2ef36f8b3b2$export$ea2d4fba4d1bd27f(()=>$12b9f2ef36f8b3b2$export$5d86b86a654a7039($12b9f2ef36f8b3b2$export$ed30944e0fe6ae5c(), e), ...t);


//#region src/utilities/index.jsx
var $feeb2945a0885102$var$t = (0, $12b9f2ef36f8b3b2$export$c8d8406b6cd2243e)({
    extend: {
        classGroups: {
            "font-size": [
                {
                    text: [
                        "body-2",
                        "caption",
                        "detail",
                        "detail-tiny",
                        "detail-bold",
                        "button",
                        "h1",
                        "h2",
                        "h3",
                        "title",
                        "title-2",
                        "title-3",
                        "title-4",
                        "display",
                        "display-2",
                        "22px",
                        "26px",
                        "28px",
                        "32px",
                        "42px"
                    ]
                }
            ],
            tracking: [
                {
                    tracking: [
                        "0.25px",
                        "0.5px",
                        "1px",
                        "1.5px",
                        "2px",
                        "3px"
                    ]
                }
            ],
            "text-required": [
                "text-required"
            ]
        }
    }
}), $feeb2945a0885102$export$ce4ab0c55987d1ff = (e)=>$feeb2945a0885102$var$t(Object.entries(e).filter(([, e])=>e).map(([e])=>e).join(" ")), $feeb2945a0885102$export$c1e6bbdae3888da5 = ({ fontUrl: e } = {})=>{
    if (e && ![
        ...document.querySelectorAll("link[rel=\"stylesheet\"]")
    ].some((t)=>t.getAttribute("href") === e)) {
        let t = document.createElement("link");
        t.rel = "stylesheet", t.href = e, document.head.append(t);
    }
    let t = null, n = ()=>{
        t && clearInterval(t);
    };
    t = setInterval(()=>{
        let e;
        try {
            e = document.fonts.check("12px \"Material Symbols Outlined\"");
        } catch  {
            n();
            return;
        }
        e && (document.body.classList.remove("hide-icons"), n());
    }, 100);
}, $feeb2945a0885102$export$d27b4a339eee114a = (e)=>e.type.startsWith("image/") ? URL.createObjectURL(e) : null, $feeb2945a0885102$export$7bac07e43e879332 = (e)=>e ? e.replaceAll(/(<([^>]+)>)/giu, "").replaceAll("&amp;", "&").replaceAll("&lt;", "<").replaceAll("&gt;", ">").replaceAll("&nbsp;", " ").length : 0;




var $lCzvA = parcelRequire("lCzvA");

var $05a027417612e40b$export$2e2bcd8739ae039 = (0, $lCzvA.memo)(({ name: t, size: i = 24, fill: a = 0, weight: o = 300, className: s, ...c })=>{
    let l = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-Icon block! material-symbols-outlined": !0,
        [s]: s
    }), u = (0, $lCzvA.useMemo)(()=>({
            fontVariationSettings: `'FILL' ${a}, 'wght' ${o}, 'GRAD' 0, 'opsz' 48`,
            fontSize: i,
            width: i,
            height: i,
            lineHeight: 1,
            overflow: "hidden"
        }), [
        a,
        o,
        i
    ]);
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
        className: l,
        style: u,
        "aria-hidden": "true",
        "data-testid": "sash-icon",
        ...c,
        children: t
    });
});
$05a027417612e40b$export$2e2bcd8739ae039.displayName = "Icon";




//#region src/components/List/index.jsx
var $c169cb583646f905$export$2e2bcd8739ae039 = ({ type: n = "ul", bullets: r, inside: i, layout: a, children: o, className: s, ...c })=>{
    let l = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-List": !0,
        "m-0 p-0 list-none": r === "none",
        "list-disc": r === "disc" || !r && n === "ul",
        "list-decimal": r === "decimal" || !r && n === "ol",
        "list-inside": i,
        "flex flex-wrap *:flex-1": a === "fluid",
        "flex flex-wrap *:flex-initial": a === "inline",
        [s]: s
    });
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)(n, {
        className: l,
        ...c,
        children: o
    });
};



var $lCzvA = parcelRequire("lCzvA");

//#region src/components/Breadcrumbs/index.jsx
var $e7e807be55d7b93f$export$2e2bcd8739ae039 = ({ pages: c, current: l, homeIcon: u = "other_houses", divider: d = "/", renderLinksAs: f = "a", className: p, children: m, enableTo: h, ...g })=>{
    let _ = f, v = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-Breadcrumbs text-black whitespace-nowrap overflow-auto py-2": !0,
        [p]: p
    }), y = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "font-normal underline hover:no-underline": !0
    });
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
        className: v,
        "data-testid": "sash-breadcrumbs",
        ...g,
        children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $c169cb583646f905$export$2e2bcd8739ae039), {
            bullets: "none",
            layout: "inline",
            className: "flex-nowrap items-center overflow-x-auto overflow-y-hidden leading-none",
            children: [
                u && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("li", {
                    children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)(_, {
                        href: h ? null : "/",
                        to: h ? "/" : null,
                        className: "block no-underline",
                        children: [
                            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                                name: u,
                                className: "block leading-none!"
                            }),
                            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                                className: "sr-only",
                                children: "Home"
                            })
                        ]
                    })
                }),
                Array.isArray(c) && c.map((e, t)=>/* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $lCzvA.Fragment), {
                        children: [
                            (u || !u && t !== 0) && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("li", {
                                className: "mx-1.5",
                                children: d
                            }),
                            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("li", {
                                children: e.url ? /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)(_, {
                                    "data-testid": "breadcrumbs-link",
                                    href: h ? null : e.url,
                                    to: h ? e.url : null,
                                    className: y,
                                    children: e.title
                                }) : e.title
                            })
                        ]
                    }, t)),
                (0, $lCzvA.Children).toArray(m).map((e, t)=>/* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $lCzvA.Fragment), {
                        children: [
                            (u || !u && t !== 0) && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("li", {
                                className: "mx-1.5",
                                children: d
                            }),
                            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("li", {
                                children: e
                            })
                        ]
                    }, t)),
                l && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $1e1ba35c5b9fc4c3$exports.Fragment), {
                    children: [
                        /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("li", {
                            className: "mx-1.5",
                            children: d
                        }),
                        /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("li", {
                            children: l
                        })
                    ]
                })
            ]
        })
    });
};




var $lCzvA = parcelRequire("lCzvA");

"use client";
//#region src/components/Button/index.jsx
var $8f4a1c407cb4821b$export$2e2bcd8739ae039 = (0, $lCzvA.memo)((0, $lCzvA.forwardRef)(({ href: n, type: r = "button", color: s = "primary", wide: c = !1, renderAs: l = "a", className: u, iconLeft: d, iconRight: f, children: p, darkMode: m, loading: h = !1, ...g }, _)=>{
    let v = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-Button rounded-xs border gap-x-2 py-3 text-base inline-flex items-center justify-center w-full font-semibold tracking-xs text-center cursor-pointer no-underline disabled:pointer-events-none disabled:border-neutral": !0,
        "disabled:bg-neutral-50 disabled:text-neutral-600": !m,
        "focus-visible:shadow-[inset_0_0_0_2px_#fff] disabled:bg-neutral-700 disabled:text-neutral-200": m,
        "px-4": p,
        "px-3": !p,
        "sash-Button--primary bg-black text-white border-black active:bg-neutral-800 active:border-neutral-800 hover:bg-neutral-650 hover:border-neutral-650 focus-visible:bg-neutral-650 focus-visible:border-neutral-650": s === "primary" && !m,
        "sash-Button--primary-dark bg-white border-white text-neutral-750 active:bg-neutral-300 active:border-neutral-300 active:text-black hover:bg-neutral-100 hover:border-neutral-100 hover:text-black focus-visible:bg-neutral-100 focus-visible:border-neutral-100 focus-visible:text-black": s === "primary" && m,
        "sash-Button--secondary text-neutral-700 border-neutral-700 active:text-neutral-900 active:border-neutral-900 active:bg-transparent hover:bg-yellow-100 hover:border-black hover:text-black focus-visible:bg-yellow-100 focus-visible:border-black focus-visible:text-black": s === "secondary" && !m,
        "sash-Button--secondary-dark border-white text-white active:border-neutral-50 active:text-neutral-50 active:bg-transparent hover:bg-neutral-750 hover:border-neutral-200 hover:text-neutral-200 focus-visible:border-neutral-200 focus-visible:bg-neutral-750 focus-visible:text-neutral-200": s === "secondary" && m,
        "sash-Button--tertiary border-transparent text-neutral-850 active:bg-transparent active:text-neutral-750 active:border-neutral hover:bg-black-05 hover:border-transparent hover:text-black focus-visible:bg-black-05 focus-visible:border-transparent focus-visible:text-black": s === "tertiary" && !m,
        "sash-Button--tertiary-dark border-transparent text-neutral-100 active:border-neutral active:text-neutral-50 hover:bg-[rgba(255,255,255,0.06)] hover:text-white focus-visible:bg-[rgba(255,255,255,0.06)] focus-visible:text-white": s === "tertiary" && m,
        "sash-Button--conversion bg-conversion text-neutral-800 border-neutral-800 active:bg-conversion-active active:border-black active:text-black hover:bg-conversion-hover hover:border-black hover:text-black focus-visible:bg-conversion-hover focus-visible:border-black focus-visible:text-black": s === "conversion",
        "sm:w-auto": !c,
        [u]: u
    }), y = /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $1e1ba35c5b9fc4c3$exports.Fragment), {
        children: [
            h ? /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                name: "progress_activity",
                className: "animate-spin"
            }) : d && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                name: d
            }),
            p,
            !h && f && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                name: f
            })
        ]
    }), b = l;
    return n || g.to ? /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)(b, {
        href: n || void 0,
        to: g.to || void 0,
        className: v,
        "data-color": s,
        "data-mode": m ? "dark" : "light",
        disabled: h || g.disabled,
        "aria-busy": h || void 0,
        ref: _,
        ...g,
        children: y
    }) : /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("button", {
        type: r,
        className: v,
        "data-color": s,
        "data-mode": m ? "dark" : "light",
        disabled: h || g.disabled,
        "aria-busy": h || void 0,
        ref: _,
        ...g,
        children: y
    });
}));
$8f4a1c407cb4821b$export$2e2bcd8739ae039.displayName = "Button";



var $lCzvA = parcelRequire("lCzvA");


var $dAQd3 = parcelRequire("dAQd3");

var $lCzvA = parcelRequire("lCzvA");
// src/primitive.tsx
var $7c9f5a9a17eecc04$export$71594e8a50f746f4 = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $7c9f5a9a17eecc04$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true } = {}) {
    return function handleEvent(event) {
        originalEventHandler?.(event);
        if (checkForDefaultPrevented === false || !event || !event.defaultPrevented) return ourEventHandler?.(event);
    };
}
function $7c9f5a9a17eecc04$export$f21a1ffae260145a(element) {
    if (!$7c9f5a9a17eecc04$export$71594e8a50f746f4) throw new Error("Cannot access window outside of the DOM");
    return element?.ownerDocument?.defaultView ?? window;
}
function $7c9f5a9a17eecc04$export$b204af158042fbac(element) {
    if (!$7c9f5a9a17eecc04$export$71594e8a50f746f4) throw new Error("Cannot access document outside of the DOM");
    return element?.ownerDocument ?? document;
}
function $7c9f5a9a17eecc04$export$cd4e5573fbe2b576(node, activeDescendant = false) {
    const { activeElement: activeElement } = $7c9f5a9a17eecc04$export$b204af158042fbac(node);
    if (!activeElement?.nodeName) return null;
    if ($7c9f5a9a17eecc04$export$6a12f24039de8f3a(activeElement) && activeElement.contentDocument) return $7c9f5a9a17eecc04$export$cd4e5573fbe2b576(activeElement.contentDocument.body, activeDescendant);
    if (activeDescendant) {
        const id = activeElement.getAttribute("aria-activedescendant");
        if (id) {
            const element = $7c9f5a9a17eecc04$export$b204af158042fbac(activeElement).getElementById(id);
            if (element) return element;
        }
    }
    return activeElement;
}
function $7c9f5a9a17eecc04$export$6a12f24039de8f3a(element) {
    return element.tagName === "IFRAME";
}


// src/compose-refs.tsx

var $lCzvA = parcelRequire("lCzvA");
function $ca45e6a36e8d9db0$var$setRef(ref, value) {
    if (typeof ref === "function") return ref(value);
    else if (ref !== null && ref !== void 0) ref.current = value;
}
function $ca45e6a36e8d9db0$export$43e446d32b3d21af(...refs) {
    return (node)=>{
        let hasCleanup = false;
        const cleanups = refs.map((ref)=>{
            const cleanup = $ca45e6a36e8d9db0$var$setRef(ref, node);
            if (!hasCleanup && typeof cleanup == "function") hasCleanup = true;
            return cleanup;
        });
        if (hasCleanup) return ()=>{
            for(let i = 0; i < cleanups.length; i++){
                const cleanup = cleanups[i];
                if (typeof cleanup == "function") cleanup();
                else $ca45e6a36e8d9db0$var$setRef(refs[i], null);
            }
        };
    };
}
function $ca45e6a36e8d9db0$export$c7b2cbe3552a0d05(...refs) {
    return $lCzvA.useCallback($ca45e6a36e8d9db0$export$43e446d32b3d21af(...refs), refs);
}


// src/create-context.tsx

var $lCzvA = parcelRequire("lCzvA");

function $e4b0fa6903a3dc52$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = $lCzvA.createContext(defaultContext);
    Context.displayName = rootComponentName + "Context";
    const Provider = (props)=>{
        const { children: children, ...context } = props;
        const value = $lCzvA.useMemo(()=>context, Object.values(context));
        return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)(Context.Provider, {
            value: value,
            children: children
        });
    };
    Provider.displayName = rootComponentName + "Provider";
    function useContext2(consumerName, options = {}) {
        const { optional: optional = false } = options;
        const context = $lCzvA.useContext(Context);
        if (context) return context;
        if (defaultContext !== void 0) return defaultContext;
        if (optional) return void 0;
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    return [
        Provider,
        useContext2
    ];
}
function $e4b0fa6903a3dc52$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    function createContext3(rootComponentName, defaultContext) {
        const BaseContext = $lCzvA.createContext(defaultContext);
        BaseContext.displayName = rootComponentName + "Context";
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        const Provider = (props)=>{
            const { scope: scope, children: children, ...context } = props;
            const Context = scope?.[scopeName]?.[index] || BaseContext;
            const value = $lCzvA.useMemo(()=>context, Object.values(context));
            return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)(Context.Provider, {
                value: value,
                children: children
            });
        };
        Provider.displayName = rootComponentName + "Provider";
        function useContext2(consumerName, scope, options = {}) {
            const { optional: optional = false } = options;
            const Context = scope?.[scopeName]?.[index] || BaseContext;
            const context = $lCzvA.useContext(Context);
            if (context) return context;
            if (defaultContext !== void 0) return defaultContext;
            if (optional) return void 0;
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        return [
            Provider,
            useContext2
        ];
    }
    const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return $lCzvA.createContext(defaultContext);
        });
        return function useScope(scope) {
            const contexts = scope?.[scopeName] || scopeContexts;
            return $lCzvA.useMemo(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        createContext3,
        $e4b0fa6903a3dc52$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
function $e4b0fa6903a3dc52$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope = ()=>{
        const scopeHooks = scopes.map((createScope2)=>({
                useScope: createScope2(),
                scopeName: createScope2.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes = scopeHooks.reduce((nextScopes2, { useScope: useScope, scopeName: scopeName })=>{
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes2,
                    ...currentScope
                };
            }, {});
            return $lCzvA.useMemo(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes
                }), [
                nextScopes
            ]);
        };
    };
    createScope.scopeName = baseScope.scopeName;
    return createScope;
}



var $lCzvA = parcelRequire("lCzvA");

// src/primitive.tsx

var $lCzvA = parcelRequire("lCzvA");

var $dAQd3 = parcelRequire("dAQd3");
// src/slot.tsx

var $lCzvA = parcelRequire("lCzvA");

// @__NO_SIDE_EFFECTS__
function $0d6672ff6f6b6ba8$export$e88b45bda5c13eb9(ownerName) {
    const Slot2 = $lCzvA.forwardRef((props, forwardedRef)=>{
        let { children: children, ...slotProps } = props;
        let slottableElement = null;
        let hasSlottable = false;
        const newChildren = [];
        if ($0d6672ff6f6b6ba8$var$isLazyComponent(children) && typeof $0d6672ff6f6b6ba8$var$use === "function") children = $0d6672ff6f6b6ba8$var$use(children._payload);
        $lCzvA.Children.forEach(children, (maybeSlottable)=>{
            if ($0d6672ff6f6b6ba8$var$isSlottable(maybeSlottable)) {
                hasSlottable = true;
                const slottable = maybeSlottable;
                let child = "child" in slottable.props ? slottable.props.child : slottable.props.children;
                if ($0d6672ff6f6b6ba8$var$isLazyComponent(child) && typeof $0d6672ff6f6b6ba8$var$use === "function") child = $0d6672ff6f6b6ba8$var$use(child._payload);
                slottableElement = $0d6672ff6f6b6ba8$var$getSlottableElementFromSlottable(slottable, child);
                newChildren.push(slottableElement?.props?.children);
            } else newChildren.push(maybeSlottable);
        });
        if (slottableElement) slottableElement = $lCzvA.cloneElement(slottableElement, void 0, newChildren);
        else if (// A `Slottable` was found but it didn't resolve to a single element (e.g.
        // it wrapped multiple elements, text, or a render-prop `child` that
        // wasn't an element). Don't fall back to treating the `Slottable` wrapper
        // itself as the slot target — throw a descriptive error below instead.
        !hasSlottable && $lCzvA.Children.count(children) === 1 && $lCzvA.isValidElement(children)) slottableElement = children;
        const slottableElementRef = slottableElement ? $0d6672ff6f6b6ba8$var$getElementRef(slottableElement) : void 0;
        const composedRef = (0, $ca45e6a36e8d9db0$export$c7b2cbe3552a0d05)(forwardedRef, slottableElementRef);
        if (!slottableElement) {
            if (children || children === 0) throw new Error(hasSlottable ? $0d6672ff6f6b6ba8$var$createSlottableError(ownerName) : $0d6672ff6f6b6ba8$var$createSlotError(ownerName));
            return children;
        }
        const mergedProps = $0d6672ff6f6b6ba8$var$mergeProps(slotProps, slottableElement.props ?? {});
        if (slottableElement.type !== $lCzvA.Fragment) mergedProps.ref = forwardedRef ? composedRef : slottableElementRef;
        return $lCzvA.cloneElement(slottableElement, mergedProps);
    });
    Slot2.displayName = `${ownerName}.Slot`;
    return Slot2;
}
var $0d6672ff6f6b6ba8$export$be92b6f5f03c0fe9 = /* @__PURE__ */ $0d6672ff6f6b6ba8$export$e88b45bda5c13eb9("Slot");
var $0d6672ff6f6b6ba8$var$SLOTTABLE_IDENTIFIER = Symbol.for("radix.slottable");
// @__NO_SIDE_EFFECTS__
function $0d6672ff6f6b6ba8$export$bf68c29d8281d0f7(ownerName) {
    const Slottable2 = (props)=>"child" in props ? props.children(props.child) : props.children;
    Slottable2.displayName = `${ownerName}.Slottable`;
    Slottable2.__radixId = $0d6672ff6f6b6ba8$var$SLOTTABLE_IDENTIFIER;
    return Slottable2;
}
var $0d6672ff6f6b6ba8$export$d9f1ccf0bdb05d45 = /* @__PURE__ */ $0d6672ff6f6b6ba8$export$bf68c29d8281d0f7("Slottable");
var $0d6672ff6f6b6ba8$var$getSlottableElementFromSlottable = (slottable, child)=>{
    if ("child" in slottable.props) {
        const child2 = slottable.props.child;
        if (!$lCzvA.isValidElement(child2)) return null;
        return $lCzvA.cloneElement(child2, void 0, slottable.props.children(child2.props.children));
    }
    return $lCzvA.isValidElement(child) ? child : null;
};
function $0d6672ff6f6b6ba8$var$mergeProps(slotProps, childProps) {
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                const result = childPropValue(...args);
                slotPropValue(...args);
                return result;
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
function $0d6672ff6f6b6ba8$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}
function $0d6672ff6f6b6ba8$var$isSlottable(child) {
    return $lCzvA.isValidElement(child) && typeof child.type === "function" && "__radixId" in child.type && child.type.__radixId === $0d6672ff6f6b6ba8$var$SLOTTABLE_IDENTIFIER;
}
var $0d6672ff6f6b6ba8$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
function $0d6672ff6f6b6ba8$var$isLazyComponent(element) {
    return element != null && typeof element === "object" && "$$typeof" in element && element.$$typeof === $0d6672ff6f6b6ba8$var$REACT_LAZY_TYPE && "_payload" in element && $0d6672ff6f6b6ba8$var$isPromiseLike(element._payload);
}
function $0d6672ff6f6b6ba8$var$isPromiseLike(value) {
    return typeof value === "object" && value !== null && "then" in value;
}
var $0d6672ff6f6b6ba8$var$createSlotError = (ownerName)=>{
    return `${ownerName} failed to slot onto its children. Expected a single React element child or \`Slottable\`.`;
};
var $0d6672ff6f6b6ba8$var$createSlottableError = (ownerName)=>{
    return `${ownerName} failed to slot onto its \`Slottable\`. Expected \`Slottable\` to receive a single React element child.`;
};
var $0d6672ff6f6b6ba8$var$use = $lCzvA[" use ".trim().toString()];



var $ac36d1eadbf3b928$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "select",
    "span",
    "svg",
    "ul"
];
var $ac36d1eadbf3b928$export$250ffa63cdc0d034 = $ac36d1eadbf3b928$var$NODES.reduce((primitive, node)=>{
    const Slot = (0, $0d6672ff6f6b6ba8$export$e88b45bda5c13eb9)(`Primitive.${node}`);
    const Node = $lCzvA.forwardRef((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? Slot : node;
        if (typeof window !== "undefined") window[Symbol.for("radix-ui")] = true;
        return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)(Comp, {
            ...primitiveProps,
            ref: forwardedRef
        });
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
function $ac36d1eadbf3b928$export$6d1a0317bde7de7f(target, event) {
    if (target) $dAQd3.flushSync(()=>target.dispatchEvent(event));
}
var $ac36d1eadbf3b928$export$be92b6f5f03c0fe9 = $ac36d1eadbf3b928$export$250ffa63cdc0d034;



// src/use-callback-ref.tsx

var $lCzvA = parcelRequire("lCzvA");
function $d7e88b701ace0523$export$25bec8c6f54ee79a(callback) {
    const callbackRef = $lCzvA.useRef(callback);
    $lCzvA.useEffect(()=>{
        callbackRef.current = callback;
    });
    return $lCzvA.useMemo(()=>(...args)=>callbackRef.current?.(...args), []);
}



"use client";
var $98ca9e23110fdc94$var$DISMISSABLE_LAYER_NAME = "DismissableLayer";
var $98ca9e23110fdc94$var$CONTEXT_UPDATE = "dismissableLayer.update";
var $98ca9e23110fdc94$var$POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
var $98ca9e23110fdc94$var$FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
var $98ca9e23110fdc94$var$originalBodyPointerEvents;
var $98ca9e23110fdc94$var$DismissableLayerContext = $lCzvA.createContext({
    layers: /* @__PURE__ */ new Set(),
    layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
    branches: /* @__PURE__ */ new Set(),
    // Outside elements that belong to a layer's own dismiss affordance (eg, a
    // dialog overlay). Pressing them should dismiss the layer regardless of
    // whether or not they stop propagation.
    //
    // See https://github.com/radix-ui/primitives/issues/3346
    dismissableSurfaces: /* @__PURE__ */ new Set()
});
var $98ca9e23110fdc94$export$177fb62ff3ec1f22 = $lCzvA.forwardRef((props, forwardedRef)=>{
    const { disableOutsidePointerEvents: disableOutsidePointerEvents = false, deferPointerDownOutside: deferPointerDownOutside = false, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, onDismiss: onDismiss, ...layerProps } = props;
    const context = $lCzvA.useContext($98ca9e23110fdc94$var$DismissableLayerContext);
    const [node, setNode] = $lCzvA.useState(null);
    const ownerDocument = node?.ownerDocument ?? globalThis?.document;
    const [, force] = $lCzvA.useState({});
    const composedRefs = (0, $ca45e6a36e8d9db0$export$c7b2cbe3552a0d05)(forwardedRef, setNode);
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [
        ...context.layersWithOutsidePointerEventsDisabled
    ].slice(-1);
    const highestLayerWithOutsidePointerEventsDisabledIndex = highestLayerWithOutsidePointerEventsDisabled ? layers.indexOf(highestLayerWithOutsidePointerEventsDisabled) : -1;
    const index = node ? layers.indexOf(node) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const isDeferredPointerDownOutsideRef = $lCzvA.useRef(false);
    const pointerDownOutside = $98ca9e23110fdc94$var$usePointerDownOutside((event)=>{
        onPointerDownOutside?.(event);
        onInteractOutside?.(event);
        if (!event.defaultPrevented) onDismiss?.();
    }, {
        ownerDocument: ownerDocument,
        deferPointerDownOutside: deferPointerDownOutside,
        isDeferredPointerDownOutsideRef: isDeferredPointerDownOutsideRef,
        dismissableSurfaces: context.dismissableSurfaces,
        shouldHandlePointerDownOutside: $lCzvA.useCallback((target)=>{
            if (!(target instanceof Node)) return false;
            const isPointerDownOnBranch = [
                ...context.branches
            ].some((branch)=>branch.contains(target));
            return isPointerEventsEnabled && !isPointerDownOnBranch;
        }, [
            context.branches,
            isPointerEventsEnabled
        ])
    });
    const focusOutside = $98ca9e23110fdc94$var$useFocusOutside((event)=>{
        if (deferPointerDownOutside && isDeferredPointerDownOutsideRef.current) return;
        const target = event.target;
        const isFocusInBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (isFocusInBranch) return;
        onFocusOutside?.(event);
        onInteractOutside?.(event);
        if (!event.defaultPrevented) onDismiss?.();
    }, ownerDocument);
    const isHighestLayer = node ? index === layers.length - 1 : false;
    const handleKeyDown = (0, $d7e88b701ace0523$export$25bec8c6f54ee79a)((event)=>{
        if (event.key !== "Escape") return;
        onEscapeKeyDown?.(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    });
    $lCzvA.useEffect(()=>{
        if (!isHighestLayer) return;
        ownerDocument.addEventListener("keydown", handleKeyDown, {
            capture: true
        });
        return ()=>ownerDocument.removeEventListener("keydown", handleKeyDown, {
                capture: true
            });
    }, [
        ownerDocument,
        isHighestLayer,
        handleKeyDown
    ]);
    $lCzvA.useEffect(()=>{
        if (!node) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                $98ca9e23110fdc94$var$originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
                ownerDocument.body.style.pointerEvents = "none";
            }
            context.layersWithOutsidePointerEventsDisabled.add(node);
        }
        context.layers.add(node);
        $98ca9e23110fdc94$var$dispatchUpdate();
        return ()=>{
            if (disableOutsidePointerEvents) {
                context.layersWithOutsidePointerEventsDisabled.delete(node);
                if (context.layersWithOutsidePointerEventsDisabled.size === 0) ownerDocument.body.style.pointerEvents = $98ca9e23110fdc94$var$originalBodyPointerEvents;
            }
        };
    }, [
        node,
        ownerDocument,
        disableOutsidePointerEvents,
        context
    ]);
    $lCzvA.useEffect(()=>{
        return ()=>{
            if (!node) return;
            context.layers.delete(node);
            context.layersWithOutsidePointerEventsDisabled.delete(node);
            $98ca9e23110fdc94$var$dispatchUpdate();
        };
    }, [
        node,
        context
    ]);
    $lCzvA.useEffect(()=>{
        const handleUpdate = ()=>force({});
        document.addEventListener($98ca9e23110fdc94$var$CONTEXT_UPDATE, handleUpdate);
        return ()=>document.removeEventListener($98ca9e23110fdc94$var$CONTEXT_UPDATE, handleUpdate);
    }, []);
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $ac36d1eadbf3b928$export$250ffa63cdc0d034).div, {
        ...layerProps,
        ref: composedRefs,
        style: {
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : void 0,
            ...props.style
        },
        onFocusCapture: (0, $7c9f5a9a17eecc04$export$b9ecd428b558ff10)(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: (0, $7c9f5a9a17eecc04$export$b9ecd428b558ff10)(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: (0, $7c9f5a9a17eecc04$export$b9ecd428b558ff10)(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    });
});
$98ca9e23110fdc94$export$177fb62ff3ec1f22.displayName = $98ca9e23110fdc94$var$DISMISSABLE_LAYER_NAME;
var $98ca9e23110fdc94$var$BRANCH_NAME = "DismissableLayerBranch";
var $98ca9e23110fdc94$export$4d5eb2109db14228 = $lCzvA.forwardRef((props, forwardedRef)=>{
    const context = $lCzvA.useContext($98ca9e23110fdc94$var$DismissableLayerContext);
    const ref = $lCzvA.useRef(null);
    const composedRefs = (0, $ca45e6a36e8d9db0$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    $lCzvA.useEffect(()=>{
        const node = ref.current;
        if (node) {
            context.branches.add(node);
            return ()=>{
                context.branches.delete(node);
            };
        }
    }, [
        context.branches
    ]);
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $ac36d1eadbf3b928$export$250ffa63cdc0d034).div, {
        ...props,
        ref: composedRefs
    });
});
$98ca9e23110fdc94$export$4d5eb2109db14228.displayName = $98ca9e23110fdc94$var$BRANCH_NAME;
function $98ca9e23110fdc94$export$210785236bdfcb27() {
    const context = $lCzvA.useContext($98ca9e23110fdc94$var$DismissableLayerContext);
    const [node, setNode] = $lCzvA.useState(null);
    $lCzvA.useEffect(()=>{
        if (!node) return;
        context.dismissableSurfaces.add(node);
        return ()=>{
            context.dismissableSurfaces.delete(node);
        };
    }, [
        node,
        context.dismissableSurfaces
    ]);
    return setNode;
}
var $98ca9e23110fdc94$var$IS_TRUE = ()=>true;
function $98ca9e23110fdc94$var$usePointerDownOutside(onPointerDownOutside, args) {
    const { ownerDocument: ownerDocument = globalThis?.document, deferPointerDownOutside: deferPointerDownOutside = false, isDeferredPointerDownOutsideRef: isDeferredPointerDownOutsideRef, dismissableSurfaces: dismissableSurfaces, shouldHandlePointerDownOutside: shouldHandlePointerDownOutside = $98ca9e23110fdc94$var$IS_TRUE } = args;
    const handlePointerDownOutside = (0, $d7e88b701ace0523$export$25bec8c6f54ee79a)(onPointerDownOutside);
    const isPointerInsideReactTreeRef = $lCzvA.useRef(false);
    const isPointerDownOutsideRef = $lCzvA.useRef(false);
    const interceptedOutsideInteractionEventsRef = $lCzvA.useRef(/* @__PURE__ */ new Map());
    const handleClickRef = $lCzvA.useRef(()=>{});
    $lCzvA.useEffect(()=>{
        function resetOutsideInteraction() {
            isPointerDownOutsideRef.current = false;
            isDeferredPointerDownOutsideRef.current = false;
            interceptedOutsideInteractionEventsRef.current.clear();
        }
        function isOutsideInteractionIntercepted() {
            return Array.from(interceptedOutsideInteractionEventsRef.current.values()).some(Boolean);
        }
        function handleInteractionCapture(event) {
            if (!isPointerDownOutsideRef.current) return;
            const target = event.target;
            const isDismissableSurface = target instanceof Node && [
                ...dismissableSurfaces
            ].some((surface)=>surface.contains(target));
            if (!isDismissableSurface) interceptedOutsideInteractionEventsRef.current.set(event.type, true);
            if (event.type === "click") window.setTimeout(()=>{
                if (isPointerDownOutsideRef.current) handleClickRef.current();
            }, 0);
        }
        function handleInteractionBubble(event) {
            if (isPointerDownOutsideRef.current) interceptedOutsideInteractionEventsRef.current.set(event.type, false);
        }
        const handlePointerDown = (event)=>{
            if (event.target && !isPointerInsideReactTreeRef.current) {
                let handleAndDispatchPointerDownOutsideEvent2 = function() {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    const wasOutsideInteractionIntercepted = isOutsideInteractionIntercepted();
                    resetOutsideInteraction();
                    if (!wasOutsideInteractionIntercepted) $98ca9e23110fdc94$var$handleAndDispatchCustomEvent($98ca9e23110fdc94$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                };
                var handleAndDispatchPointerDownOutsideEvent = handleAndDispatchPointerDownOutsideEvent2;
                if (!shouldHandlePointerDownOutside(event.target)) {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    resetOutsideInteraction();
                    isPointerInsideReactTreeRef.current = false;
                    return;
                }
                const eventDetail = {
                    originalEvent: event
                };
                isPointerDownOutsideRef.current = true;
                isDeferredPointerDownOutsideRef.current = deferPointerDownOutside && event.button === 0;
                interceptedOutsideInteractionEventsRef.current.clear();
                if (!deferPointerDownOutside || event.button !== 0) handleAndDispatchPointerDownOutsideEvent2();
                else {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent2;
                    ownerDocument.addEventListener("click", handleClickRef.current, {
                        once: true
                    });
                }
            } else {
                ownerDocument.removeEventListener("click", handleClickRef.current);
                resetOutsideInteraction();
            }
            isPointerInsideReactTreeRef.current = false;
        };
        const outsideInteractionEvents = [
            "pointerup",
            "mousedown",
            "mouseup",
            "touchstart",
            "touchend",
            "click"
        ];
        for (const eventName of outsideInteractionEvents){
            ownerDocument.addEventListener(eventName, handleInteractionCapture, true);
            ownerDocument.addEventListener(eventName, handleInteractionBubble);
        }
        const timerId = window.setTimeout(()=>{
            ownerDocument.addEventListener("pointerdown", handlePointerDown);
        }, 0);
        return ()=>{
            window.clearTimeout(timerId);
            ownerDocument.removeEventListener("pointerdown", handlePointerDown);
            ownerDocument.removeEventListener("click", handleClickRef.current);
            for (const eventName of outsideInteractionEvents){
                ownerDocument.removeEventListener(eventName, handleInteractionCapture, true);
                ownerDocument.removeEventListener(eventName, handleInteractionBubble);
            }
        };
    }, [
        ownerDocument,
        handlePointerDownOutside,
        deferPointerDownOutside,
        isDeferredPointerDownOutsideRef,
        dismissableSurfaces,
        shouldHandlePointerDownOutside
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: ()=>isPointerInsideReactTreeRef.current = true
    };
}
function $98ca9e23110fdc94$var$useFocusOutside(onFocusOutside, ownerDocument = globalThis?.document) {
    const handleFocusOutside = (0, $d7e88b701ace0523$export$25bec8c6f54ee79a)(onFocusOutside);
    const isFocusInsideReactTreeRef = $lCzvA.useRef(false);
    $lCzvA.useEffect(()=>{
        const handleFocus = (event)=>{
            if (event.target && !isFocusInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                $98ca9e23110fdc94$var$handleAndDispatchCustomEvent($98ca9e23110fdc94$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        };
        ownerDocument.addEventListener("focusin", handleFocus);
        return ()=>ownerDocument.removeEventListener("focusin", handleFocus);
    }, [
        ownerDocument,
        handleFocusOutside
    ]);
    return {
        onFocusCapture: ()=>isFocusInsideReactTreeRef.current = true,
        onBlurCapture: ()=>isFocusInsideReactTreeRef.current = false
    };
}
function $98ca9e23110fdc94$var$dispatchUpdate() {
    const event = new CustomEvent($98ca9e23110fdc94$var$CONTEXT_UPDATE);
    document.dispatchEvent(event);
}
function $98ca9e23110fdc94$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete }) {
    const target = detail.originalEvent.target;
    const event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail: detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, $ac36d1eadbf3b928$export$6d1a0317bde7de7f)(target, event);
    else target.dispatchEvent(event);
}
var $98ca9e23110fdc94$export$be92b6f5f03c0fe9 = $98ca9e23110fdc94$export$177fb62ff3ec1f22;
var $98ca9e23110fdc94$export$aecb2ddcb55c95be = $98ca9e23110fdc94$export$4d5eb2109db14228;



var $lCzvA = parcelRequire("lCzvA");
"use client";
var $bc475c615686ffa1$var$count = 0;
var $bc475c615686ffa1$var$guards = null;
function $bc475c615686ffa1$export$ac5b58043b79449b(props) {
    $bc475c615686ffa1$export$b7ece24a22aeda8c();
    return props.children;
}
function $bc475c615686ffa1$export$b7ece24a22aeda8c() {
    $lCzvA.useEffect(()=>{
        if (!$bc475c615686ffa1$var$guards) $bc475c615686ffa1$var$guards = {
            start: $bc475c615686ffa1$var$createFocusGuard(),
            end: $bc475c615686ffa1$var$createFocusGuard()
        };
        const { start: start, end: end } = $bc475c615686ffa1$var$guards;
        if (document.body.firstElementChild !== start) document.body.insertAdjacentElement("afterbegin", start);
        if (document.body.lastElementChild !== end) document.body.insertAdjacentElement("beforeend", end);
        $bc475c615686ffa1$var$count++;
        return ()=>{
            if ($bc475c615686ffa1$var$count === 1) {
                $bc475c615686ffa1$var$guards?.start.remove();
                $bc475c615686ffa1$var$guards?.end.remove();
                $bc475c615686ffa1$var$guards = null;
            }
            $bc475c615686ffa1$var$count = Math.max(0, $bc475c615686ffa1$var$count - 1);
        };
    }, []);
}
function $bc475c615686ffa1$var$createFocusGuard() {
    const element = document.createElement("span");
    element.setAttribute("data-radix-focus-guard", "");
    element.tabIndex = 0;
    element.style.outline = "none";
    element.style.opacity = "0";
    element.style.position = "fixed";
    element.style.pointerEvents = "none";
    return element;
}



var $lCzvA = parcelRequire("lCzvA");




"use client";
var $0e536624ae1ddbbb$var$AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount";
var $0e536624ae1ddbbb$var$AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount";
var $0e536624ae1ddbbb$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
var $0e536624ae1ddbbb$var$FOCUS_SCOPE_NAME = "FocusScope";
var $0e536624ae1ddbbb$export$20e40289641fbbb6 = $lCzvA.forwardRef((props, forwardedRef)=>{
    const { loop: loop = false, trapped: trapped = false, onMountAutoFocus: onMountAutoFocusProp, onUnmountAutoFocus: onUnmountAutoFocusProp, ...scopeProps } = props;
    const [container, setContainer] = $lCzvA.useState(null);
    const onMountAutoFocus = (0, $d7e88b701ace0523$export$25bec8c6f54ee79a)(onMountAutoFocusProp);
    const onUnmountAutoFocus = (0, $d7e88b701ace0523$export$25bec8c6f54ee79a)(onUnmountAutoFocusProp);
    const lastFocusedElementRef = $lCzvA.useRef(null);
    const composedRefs = (0, $ca45e6a36e8d9db0$export$c7b2cbe3552a0d05)(forwardedRef, setContainer);
    const focusScope = $lCzvA.useRef({
        paused: false,
        pause () {
            this.paused = true;
        },
        resume () {
            this.paused = false;
        }
    }).current;
    $lCzvA.useEffect(()=>{
        if (trapped) {
            let handleFocusIn2 = function(event) {
                if (focusScope.paused || !container) return;
                const target = event.target;
                if (container.contains(target)) lastFocusedElementRef.current = target;
                else $0e536624ae1ddbbb$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }, handleFocusOut2 = function(event) {
                if (focusScope.paused || !container) return;
                const relatedTarget = event.relatedTarget;
                if (relatedTarget === null) return;
                if (!container.contains(relatedTarget)) $0e536624ae1ddbbb$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }, handleMutations2 = function(mutations) {
                const focusedElement = document.activeElement;
                if (focusedElement !== document.body) return;
                for (const mutation of mutations)if (mutation.removedNodes.length > 0) $0e536624ae1ddbbb$var$focus(container);
            };
            var handleFocusIn = handleFocusIn2, handleFocusOut = handleFocusOut2, handleMutations = handleMutations2;
            document.addEventListener("focusin", handleFocusIn2);
            document.addEventListener("focusout", handleFocusOut2);
            const mutationObserver = new MutationObserver(handleMutations2);
            if (container) mutationObserver.observe(container, {
                childList: true,
                subtree: true
            });
            return ()=>{
                document.removeEventListener("focusin", handleFocusIn2);
                document.removeEventListener("focusout", handleFocusOut2);
                mutationObserver.disconnect();
            };
        }
    }, [
        trapped,
        container,
        focusScope.paused
    ]);
    $lCzvA.useEffect(()=>{
        if (container) {
            $0e536624ae1ddbbb$var$focusScopesStack.add(focusScope);
            const previouslyFocusedElement = document.activeElement;
            const hasFocusedCandidate = container.contains(previouslyFocusedElement);
            if (!hasFocusedCandidate) {
                const mountEvent = new CustomEvent($0e536624ae1ddbbb$var$AUTOFOCUS_ON_MOUNT, $0e536624ae1ddbbb$var$EVENT_OPTIONS);
                container.addEventListener($0e536624ae1ddbbb$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                container.dispatchEvent(mountEvent);
                if (!mountEvent.defaultPrevented) {
                    $0e536624ae1ddbbb$var$focusFirst($0e536624ae1ddbbb$var$removeLinks($0e536624ae1ddbbb$var$getTabbableCandidates(container)), {
                        select: true
                    });
                    if (document.activeElement === previouslyFocusedElement) $0e536624ae1ddbbb$var$focus(container);
                }
            }
            return ()=>{
                container.removeEventListener($0e536624ae1ddbbb$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                setTimeout(()=>{
                    const unmountEvent = new CustomEvent($0e536624ae1ddbbb$var$AUTOFOCUS_ON_UNMOUNT, $0e536624ae1ddbbb$var$EVENT_OPTIONS);
                    container.addEventListener($0e536624ae1ddbbb$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    container.dispatchEvent(unmountEvent);
                    if (!unmountEvent.defaultPrevented) $0e536624ae1ddbbb$var$focus(previouslyFocusedElement ?? document.body, {
                        select: true
                    });
                    container.removeEventListener($0e536624ae1ddbbb$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    $0e536624ae1ddbbb$var$focusScopesStack.remove(focusScope);
                }, 0);
            };
        }
    }, [
        container,
        onMountAutoFocus,
        onUnmountAutoFocus,
        focusScope
    ]);
    const handleKeyDown = $lCzvA.useCallback((event)=>{
        if (!loop && !trapped) return;
        if (focusScope.paused) return;
        const isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
        const focusedElement = document.activeElement;
        if (isTabKey && focusedElement) {
            const container2 = event.currentTarget;
            const [first, last] = $0e536624ae1ddbbb$var$getTabbableEdges(container2);
            const hasTabbableElementsInside = first && last;
            if (!hasTabbableElementsInside) {
                if (focusedElement === container2) event.preventDefault();
            } else {
                if (!event.shiftKey && focusedElement === last) {
                    event.preventDefault();
                    if (loop) $0e536624ae1ddbbb$var$focus(first, {
                        select: true
                    });
                } else if (event.shiftKey && focusedElement === first) {
                    event.preventDefault();
                    if (loop) $0e536624ae1ddbbb$var$focus(last, {
                        select: true
                    });
                }
            }
        }
    }, [
        loop,
        trapped,
        focusScope.paused
    ]);
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $ac36d1eadbf3b928$export$250ffa63cdc0d034).div, {
        tabIndex: -1,
        ...scopeProps,
        ref: composedRefs,
        onKeyDown: handleKeyDown
    });
});
$0e536624ae1ddbbb$export$20e40289641fbbb6.displayName = $0e536624ae1ddbbb$var$FOCUS_SCOPE_NAME;
function $0e536624ae1ddbbb$var$focusFirst(candidates, { select: select = false } = {}) {
    const previouslyFocusedElement = document.activeElement;
    for (const candidate of candidates){
        $0e536624ae1ddbbb$var$focus(candidate, {
            select: select
        });
        if (document.activeElement !== previouslyFocusedElement) return;
    }
}
function $0e536624ae1ddbbb$var$getTabbableEdges(container) {
    const candidates = $0e536624ae1ddbbb$var$getTabbableCandidates(container);
    const first = $0e536624ae1ddbbb$var$findVisible(candidates, container);
    const last = $0e536624ae1ddbbb$var$findVisible(candidates.reverse(), container);
    return [
        first,
        last
    ];
}
function $0e536624ae1ddbbb$var$getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node)=>{
            const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP;
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode);
    return nodes;
}
function $0e536624ae1ddbbb$var$findVisible(elements, container) {
    const canUseCheckVisibility = typeof container.checkVisibility === "function" && container.checkVisibility({
        checkVisibilityCSS: true
    });
    for (const element of elements){
        const hidden = canUseCheckVisibility ? !element.checkVisibility({
            checkVisibilityCSS: true
        }) : $0e536624ae1ddbbb$var$isHidden(element, {
            upTo: container
        });
        if (!hidden) return element;
    }
}
function $0e536624ae1ddbbb$var$isHidden(node, { upTo: upTo }) {
    if (getComputedStyle(node).visibility === "hidden") return true;
    while(node){
        if (upTo !== void 0 && node === upTo) return false;
        if (getComputedStyle(node).display === "none") return true;
        node = node.parentElement;
    }
    return false;
}
function $0e536624ae1ddbbb$var$isSelectableInput(element) {
    return element instanceof HTMLInputElement && "select" in element;
}
function $0e536624ae1ddbbb$var$focus(element, { select: select = false } = {}) {
    if (element && element.focus) {
        const previouslyFocusedElement = document.activeElement;
        element.focus({
            preventScroll: true
        });
        if (element !== previouslyFocusedElement && $0e536624ae1ddbbb$var$isSelectableInput(element) && select) element.select();
    }
}
var $0e536624ae1ddbbb$var$focusScopesStack = $0e536624ae1ddbbb$var$createFocusScopesStack();
function $0e536624ae1ddbbb$var$createFocusScopesStack() {
    let stack = [];
    return {
        add (focusScope) {
            const activeFocusScope = stack[0];
            if (focusScope !== activeFocusScope) activeFocusScope?.pause();
            stack = $0e536624ae1ddbbb$var$arrayRemove(stack, focusScope);
            stack.unshift(focusScope);
        },
        remove (focusScope) {
            stack = $0e536624ae1ddbbb$var$arrayRemove(stack, focusScope);
            stack[0]?.resume();
        }
    };
}
function $0e536624ae1ddbbb$var$arrayRemove(array, item) {
    const updatedArray = [
        ...array
    ];
    const index = updatedArray.indexOf(item);
    if (index !== -1) updatedArray.splice(index, 1);
    return updatedArray;
}
function $0e536624ae1ddbbb$var$removeLinks(items) {
    return items.filter((item)=>item.tagName !== "A");
}
var $0e536624ae1ddbbb$export$be92b6f5f03c0fe9 = $0e536624ae1ddbbb$export$20e40289641fbbb6;


// src/id.tsx

var $lCzvA = parcelRequire("lCzvA");
// src/use-layout-effect.tsx

var $lCzvA = parcelRequire("lCzvA");
var $85fda695601ae591$export$e5c5a5f917a5871c = globalThis?.document ? $lCzvA.useLayoutEffect : ()=>{};


var $fca3487281b0b7d7$var$useReactId = $lCzvA[" useId ".trim().toString()] || (()=>void 0);
var $fca3487281b0b7d7$var$count = 0;
function $fca3487281b0b7d7$export$f680877a34711e37(deterministicId) {
    const [id, setId] = $lCzvA.useState($fca3487281b0b7d7$var$useReactId());
    (0, $85fda695601ae591$export$e5c5a5f917a5871c)(()=>{
        if (!deterministicId) setId((reactId)=>reactId ?? String($fca3487281b0b7d7$var$count++));
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : "");
}



var $lCzvA = parcelRequire("lCzvA");
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $fb26760234e0a027$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $fb26760234e0a027$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $fb26760234e0a027$export$803cd8101b6c182b = /*#__PURE__*/ $fb26760234e0a027$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $fb26760234e0a027$export$27b07d8a310ed8b5[0], side + "-" + $fb26760234e0a027$export$27b07d8a310ed8b5[1]), []);
const $fb26760234e0a027$export$96ec731ed4dcb222 = Math.min;
const $fb26760234e0a027$export$8960430cfd85939f = Math.max;
const $fb26760234e0a027$export$2077e0241d6afd3c = Math.round;
const $fb26760234e0a027$export$a3fe094919f356fd = Math.floor;
const $fb26760234e0a027$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $fb26760234e0a027$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $fb26760234e0a027$export$7d15b64cf5a3a4c4(start, value, end) {
    return $fb26760234e0a027$export$8960430cfd85939f(start, $fb26760234e0a027$export$96ec731ed4dcb222(value, end));
}
function $fb26760234e0a027$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $fb26760234e0a027$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $fb26760234e0a027$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $fb26760234e0a027$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $fb26760234e0a027$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $fb26760234e0a027$export$f28e8f882010718a(placement) {
    const firstChar = placement[0];
    return firstChar === 't' || firstChar === 'b' ? 'y' : 'x';
}
function $fb26760234e0a027$export$2b57e0052a6d6d4c(placement) {
    return $fb26760234e0a027$export$8a000a963141ac32($fb26760234e0a027$export$f28e8f882010718a(placement));
}
function $fb26760234e0a027$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $fb26760234e0a027$export$f0989780f32bfcda(placement);
    const alignmentAxis = $fb26760234e0a027$export$2b57e0052a6d6d4c(placement);
    const length = $fb26760234e0a027$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $fb26760234e0a027$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $fb26760234e0a027$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $fb26760234e0a027$export$496432a3699e50b1(placement) {
    const oppositePlacement = $fb26760234e0a027$export$9c5e28bad23365fa(placement);
    return [
        $fb26760234e0a027$export$2b182c584985588b(placement),
        oppositePlacement,
        $fb26760234e0a027$export$2b182c584985588b(oppositePlacement)
    ];
}
function $fb26760234e0a027$export$2b182c584985588b(placement) {
    return placement.includes('start') ? placement.replace('start', 'end') : placement.replace('end', 'start');
}
const $fb26760234e0a027$var$lrPlacement = [
    'left',
    'right'
];
const $fb26760234e0a027$var$rlPlacement = [
    'right',
    'left'
];
const $fb26760234e0a027$var$tbPlacement = [
    'top',
    'bottom'
];
const $fb26760234e0a027$var$btPlacement = [
    'bottom',
    'top'
];
function $fb26760234e0a027$var$getSideList(side, isStart, rtl) {
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? $fb26760234e0a027$var$rlPlacement : $fb26760234e0a027$var$lrPlacement;
            return isStart ? $fb26760234e0a027$var$lrPlacement : $fb26760234e0a027$var$rlPlacement;
        case 'left':
        case 'right':
            return isStart ? $fb26760234e0a027$var$tbPlacement : $fb26760234e0a027$var$btPlacement;
        default:
            return [];
    }
}
function $fb26760234e0a027$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $fb26760234e0a027$export$f0989780f32bfcda(placement);
    let list = $fb26760234e0a027$var$getSideList($fb26760234e0a027$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($fb26760234e0a027$export$2b182c584985588b));
    }
    return list;
}
function $fb26760234e0a027$export$9c5e28bad23365fa(placement) {
    const side = $fb26760234e0a027$export$3c915306cb7fc97a(placement);
    return $fb26760234e0a027$var$oppositeSideMap[side] + placement.slice(side.length);
}
function $fb26760234e0a027$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $fb26760234e0a027$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $fb26760234e0a027$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $fb26760234e0a027$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}


function $3832d2ec20157d98$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $fb26760234e0a027$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $fb26760234e0a027$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $fb26760234e0a027$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $fb26760234e0a027$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $fb26760234e0a027$export$f0989780f32bfcda)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $3832d2ec20157d98$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $fb26760234e0a027$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $fb26760234e0a027$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $fb26760234e0a027$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $fb26760234e0a027$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
// Maximum number of resets that can occur before bailing to avoid infinite reset loops.
const $3832d2ec20157d98$var$MAX_RESET_COUNT = 50;
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $3832d2ec20157d98$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const platformWithDetectOverflow = platform.detectOverflow ? platform : {
        ...platform,
        detectOverflow: $3832d2ec20157d98$export$37b6bde19b108ecc
    };
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $3832d2ec20157d98$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let resetCount = 0;
    const middlewareData = {};
    for(let i = 0; i < middleware.length; i++){
        const currentMiddleware = middleware[i];
        if (!currentMiddleware) continue;
        const { name: name, fn: fn } = currentMiddleware;
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platformWithDetectOverflow,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData[name] = {
            ...middlewareData[name],
            ...data
        };
        if (reset && resetCount < $3832d2ec20157d98$var$MAX_RESET_COUNT) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $3832d2ec20157d98$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $3832d2ec20157d98$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $fb26760234e0a027$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $fb26760234e0a027$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $fb26760234e0a027$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $fb26760234e0a027$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $fb26760234e0a027$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $fb26760234e0a027$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $fb26760234e0a027$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $fb26760234e0a027$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $3832d2ec20157d98$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $fb26760234e0a027$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $fb26760234e0a027$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $fb26760234e0a027$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $fb26760234e0a027$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $fb26760234e0a027$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $3832d2ec20157d98$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $fb26760234e0a027$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $fb26760234e0a027$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $fb26760234e0a027$export$803cd8101b6c182b) ? $3832d2ec20157d98$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $fb26760234e0a027$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $fb26760234e0a027$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $fb26760234e0a027$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $fb26760234e0a027$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $3832d2ec20157d98$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $fb26760234e0a027$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $fb26760234e0a027$export$3c915306cb7fc97a)(placement);
            const initialSideAxis = (0, $fb26760234e0a027$export$f28e8f882010718a)(initialPlacement);
            const isBasePlacement = (0, $fb26760234e0a027$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $fb26760234e0a027$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $fb26760234e0a027$export$496432a3699e50b1)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $fb26760234e0a027$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $fb26760234e0a027$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) {
                    const ignoreCrossAxisOverflow = checkCrossAxis === 'alignment' ? initialSideAxis !== (0, $fb26760234e0a027$export$f28e8f882010718a)(nextPlacement) : false;
                    if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
                    // overflows the main axis.
                    overflowsData.every((d)=>(0, $fb26760234e0a027$export$f28e8f882010718a)(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) // Try next placement and re-run the lifecycle.
                    return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                }
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $fb26760234e0a027$export$f28e8f882010718a)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $3832d2ec20157d98$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $3832d2ec20157d98$var$isAnySideFullyClipped(overflow) {
    return (0, $fb26760234e0a027$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $3832d2ec20157d98$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects, platform: platform } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $fb26760234e0a027$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $3832d2ec20157d98$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $3832d2ec20157d98$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $3832d2ec20157d98$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $3832d2ec20157d98$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $3832d2ec20157d98$var$getBoundingRect(rects) {
    const minX = (0, $fb26760234e0a027$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $fb26760234e0a027$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $fb26760234e0a027$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $fb26760234e0a027$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $3832d2ec20157d98$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $fb26760234e0a027$export$ee05aea0aeecbad4)($3832d2ec20157d98$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $3832d2ec20157d98$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $fb26760234e0a027$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $3832d2ec20157d98$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $fb26760234e0a027$export$ee05aea0aeecbad4)($3832d2ec20157d98$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $fb26760234e0a027$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $fb26760234e0a027$export$f28e8f882010718a)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $fb26760234e0a027$export$3c915306cb7fc97a)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $fb26760234e0a027$export$3c915306cb7fc97a)(placement) === 'left';
                    const maxRight = (0, $fb26760234e0a027$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $fb26760234e0a027$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
const $3832d2ec20157d98$var$originSides = /*#__PURE__*/ new Set([
    'left',
    'top'
]);
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $3832d2ec20157d98$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $fb26760234e0a027$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $fb26760234e0a027$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $fb26760234e0a027$export$f28e8f882010718a)(placement) === 'y';
    const mainAxisMulti = $3832d2ec20157d98$var$originSides.has(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $fb26760234e0a027$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $3832d2ec20157d98$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $3832d2ec20157d98$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $3832d2ec20157d98$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, platform: platform } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $fb26760234e0a027$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const crossAxis = (0, $fb26760234e0a027$export$f28e8f882010718a)((0, $fb26760234e0a027$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $fb26760234e0a027$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $fb26760234e0a027$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $fb26760234e0a027$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $3832d2ec20157d98$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $fb26760234e0a027$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $fb26760234e0a027$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $fb26760234e0a027$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $fb26760234e0a027$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = $3832d2ec20157d98$var$originSides.has((0, $fb26760234e0a027$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $3832d2ec20157d98$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $fb26760234e0a027$export$fef61f332f2c0afc)(options, state);
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const side = (0, $fb26760234e0a027$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $fb26760234e0a027$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $fb26760234e0a027$export$f28e8f882010718a)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $fb26760234e0a027$export$96ec731ed4dcb222)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $fb26760234e0a027$export$96ec731ed4dcb222)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $fb26760234e0a027$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $fb26760234e0a027$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $fb26760234e0a027$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $fb26760234e0a027$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $fb26760234e0a027$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $fb26760234e0a027$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $8ae9d98fd8d9c665$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $8ae9d98fd8d9c665$export$651544f548703224(node) {
    if ($8ae9d98fd8d9c665$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $8ae9d98fd8d9c665$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $8ae9d98fd8d9c665$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($8ae9d98fd8d9c665$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $8ae9d98fd8d9c665$export$8ee0fc9ee280b4ee(value) {
    if (!$8ae9d98fd8d9c665$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $8ae9d98fd8d9c665$export$38b2d434cce3ea22(value).Node;
}
function $8ae9d98fd8d9c665$export$45a5e7f76e0caa8d(value) {
    if (!$8ae9d98fd8d9c665$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $8ae9d98fd8d9c665$export$38b2d434cce3ea22(value).Element;
}
function $8ae9d98fd8d9c665$export$1b3bfaa9684536aa(value) {
    if (!$8ae9d98fd8d9c665$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $8ae9d98fd8d9c665$export$38b2d434cce3ea22(value).HTMLElement;
}
function $8ae9d98fd8d9c665$export$af51f0f06c0f328a(value) {
    if (!$8ae9d98fd8d9c665$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $8ae9d98fd8d9c665$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $8ae9d98fd8d9c665$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $8ae9d98fd8d9c665$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && display !== 'inline' && display !== 'contents';
}
function $8ae9d98fd8d9c665$export$71535ffaa902797f(element) {
    return /^(table|td|th)$/.test($8ae9d98fd8d9c665$export$651544f548703224(element));
}
function $8ae9d98fd8d9c665$export$89e651af02346cd4(element) {
    try {
        if (element.matches(':popover-open')) return true;
    } catch (_e) {
    // no-op
    }
    try {
        return element.matches(':modal');
    } catch (_e) {
        return false;
    }
}
const $8ae9d98fd8d9c665$var$willChangeRe = /transform|translate|scale|rotate|perspective|filter/;
const $8ae9d98fd8d9c665$var$containRe = /paint|layout|strict|content/;
const $8ae9d98fd8d9c665$var$isNotNone = (value)=>!!value && value !== 'none';
let $8ae9d98fd8d9c665$var$isWebKitValue;
function $8ae9d98fd8d9c665$export$d6c4e8150c35fed1(elementOrCss) {
    const css = $8ae9d98fd8d9c665$export$45a5e7f76e0caa8d(elementOrCss) ? $8ae9d98fd8d9c665$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return $8ae9d98fd8d9c665$var$isNotNone(css.transform) || $8ae9d98fd8d9c665$var$isNotNone(css.translate) || $8ae9d98fd8d9c665$var$isNotNone(css.scale) || $8ae9d98fd8d9c665$var$isNotNone(css.rotate) || $8ae9d98fd8d9c665$var$isNotNone(css.perspective) || !$8ae9d98fd8d9c665$export$78551043582a6a98() && ($8ae9d98fd8d9c665$var$isNotNone(css.backdropFilter) || $8ae9d98fd8d9c665$var$isNotNone(css.filter)) || $8ae9d98fd8d9c665$var$willChangeRe.test(css.willChange || '') || $8ae9d98fd8d9c665$var$containRe.test(css.contain || '');
}
function $8ae9d98fd8d9c665$export$940d8225183e1404(element) {
    let currentNode = $8ae9d98fd8d9c665$export$4e12058fc4d51d56(element);
    while($8ae9d98fd8d9c665$export$1b3bfaa9684536aa(currentNode) && !$8ae9d98fd8d9c665$export$d1162fb0b6d4cd51(currentNode)){
        if ($8ae9d98fd8d9c665$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($8ae9d98fd8d9c665$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $8ae9d98fd8d9c665$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $8ae9d98fd8d9c665$export$78551043582a6a98() {
    if ($8ae9d98fd8d9c665$var$isWebKitValue == null) $8ae9d98fd8d9c665$var$isWebKitValue = typeof CSS !== 'undefined' && CSS.supports && CSS.supports('-webkit-backdrop-filter', 'none');
    return $8ae9d98fd8d9c665$var$isWebKitValue;
}
function $8ae9d98fd8d9c665$export$d1162fb0b6d4cd51(node) {
    return /^(html|body|#document)$/.test($8ae9d98fd8d9c665$export$651544f548703224(node));
}
function $8ae9d98fd8d9c665$export$3735103072e4a80(element) {
    return $8ae9d98fd8d9c665$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $8ae9d98fd8d9c665$export$dc8fc79fa2800137(element) {
    if ($8ae9d98fd8d9c665$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $8ae9d98fd8d9c665$export$4e12058fc4d51d56(node) {
    if ($8ae9d98fd8d9c665$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $8ae9d98fd8d9c665$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $8ae9d98fd8d9c665$export$e495491855dc5418(node);
    return $8ae9d98fd8d9c665$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $8ae9d98fd8d9c665$export$7cd01a57c8ca906c(node) {
    const parentNode = $8ae9d98fd8d9c665$export$4e12058fc4d51d56(node);
    if ($8ae9d98fd8d9c665$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($8ae9d98fd8d9c665$export$1b3bfaa9684536aa(parentNode) && $8ae9d98fd8d9c665$export$989e911fa9af580a(parentNode)) return parentNode;
    return $8ae9d98fd8d9c665$export$7cd01a57c8ca906c(parentNode);
}
function $8ae9d98fd8d9c665$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $8ae9d98fd8d9c665$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $8ae9d98fd8d9c665$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $8ae9d98fd8d9c665$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $8ae9d98fd8d9c665$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $8ae9d98fd8d9c665$export$3b57c1601291186b(frameElement) : []);
    } else return list.concat(scrollableAncestor, $8ae9d98fd8d9c665$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $8ae9d98fd8d9c665$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}


function $3c68228f7800d7b7$var$getCssDimensions(element) {
    const css = (0, $8ae9d98fd8d9c665$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $8ae9d98fd8d9c665$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $fb26760234e0a027$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $fb26760234e0a027$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $3c68228f7800d7b7$var$unwrapElement(element) {
    return !(0, $8ae9d98fd8d9c665$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $3c68228f7800d7b7$var$getScale(element) {
    const domElement = $3c68228f7800d7b7$var$unwrapElement(element);
    if (!(0, $8ae9d98fd8d9c665$export$1b3bfaa9684536aa)(domElement)) return (0, $fb26760234e0a027$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $3c68228f7800d7b7$var$getCssDimensions(domElement);
    let x = ($ ? (0, $fb26760234e0a027$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $fb26760234e0a027$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $3c68228f7800d7b7$var$noOffsets = /*#__PURE__*/ (0, $fb26760234e0a027$export$a397704b5e280835)(0);
function $3c68228f7800d7b7$var$getVisualOffsets(element) {
    const win = (0, $8ae9d98fd8d9c665$export$38b2d434cce3ea22)(element);
    if (!(0, $8ae9d98fd8d9c665$export$78551043582a6a98)() || !win.visualViewport) return $3c68228f7800d7b7$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $3c68228f7800d7b7$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $8ae9d98fd8d9c665$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $3c68228f7800d7b7$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $3c68228f7800d7b7$var$unwrapElement(element);
    let scale = (0, $fb26760234e0a027$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $8ae9d98fd8d9c665$export$45a5e7f76e0caa8d)(offsetParent)) scale = $3c68228f7800d7b7$var$getScale(offsetParent);
        } else scale = $3c68228f7800d7b7$var$getScale(element);
    }
    const visualOffsets = $3c68228f7800d7b7$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $3c68228f7800d7b7$var$getVisualOffsets(domElement) : (0, $fb26760234e0a027$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $8ae9d98fd8d9c665$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $8ae9d98fd8d9c665$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $8ae9d98fd8d9c665$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $8ae9d98fd8d9c665$export$7bf1f8740e3e34af)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $3c68228f7800d7b7$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $8ae9d98fd8d9c665$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $8ae9d98fd8d9c665$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = (0, $8ae9d98fd8d9c665$export$7bf1f8740e3e34af)(currentWin);
        }
    }
    return (0, $fb26760234e0a027$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $3c68228f7800d7b7$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $8ae9d98fd8d9c665$export$dc8fc79fa2800137)(element).scrollLeft;
    if (!rect) return $3c68228f7800d7b7$var$getBoundingClientRect((0, $8ae9d98fd8d9c665$export$e495491855dc5418)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $3c68228f7800d7b7$var$getHTMLOffset(documentElement, scroll) {
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - $3c68228f7800d7b7$var$getWindowScrollBarX(documentElement, htmlRect);
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $3c68228f7800d7b7$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $8ae9d98fd8d9c665$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? (0, $8ae9d98fd8d9c665$export$89e651af02346cd4)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $fb26760234e0a027$export$a397704b5e280835)(1);
    const offsets = (0, $fb26760234e0a027$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $8ae9d98fd8d9c665$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $8ae9d98fd8d9c665$export$651544f548703224)(offsetParent) !== 'body' || (0, $8ae9d98fd8d9c665$export$989e911fa9af580a)(documentElement)) scroll = (0, $8ae9d98fd8d9c665$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $3c68228f7800d7b7$var$getBoundingClientRect(offsetParent);
            scale = $3c68228f7800d7b7$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $3c68228f7800d7b7$var$getHTMLOffset(documentElement, scroll) : (0, $fb26760234e0a027$export$a397704b5e280835)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $3c68228f7800d7b7$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $3c68228f7800d7b7$var$getDocumentRect(element) {
    const html = (0, $8ae9d98fd8d9c665$export$e495491855dc5418)(element);
    const scroll = (0, $8ae9d98fd8d9c665$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $fb26760234e0a027$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $fb26760234e0a027$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $3c68228f7800d7b7$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $8ae9d98fd8d9c665$export$3735103072e4a80)(body).direction === 'rtl') x += (0, $fb26760234e0a027$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Safety check: ensure the scrollbar space is reasonable in case this
// calculation is affected by unusual styles.
// Most scrollbars leave 15-18px of space.
const $3c68228f7800d7b7$var$SCROLLBAR_MAX = 25;
function $3c68228f7800d7b7$var$getViewportRect(element, strategy) {
    const win = (0, $8ae9d98fd8d9c665$export$38b2d434cce3ea22)(element);
    const html = (0, $8ae9d98fd8d9c665$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $8ae9d98fd8d9c665$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    const windowScrollbarX = $3c68228f7800d7b7$var$getWindowScrollBarX(html);
    // <html> `overflow: hidden` + `scrollbar-gutter: stable` reduces the
    // visual width of the <html> but this is not considered in the size
    // of `html.clientWidth`.
    if (windowScrollbarX <= 0) {
        const doc = html.ownerDocument;
        const body = doc.body;
        const bodyStyles = getComputedStyle(body);
        const bodyMarginInline = doc.compatMode === 'CSS1Compat' ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
        const clippingStableScrollbarWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
        if (clippingStableScrollbarWidth <= $3c68228f7800d7b7$var$SCROLLBAR_MAX) width -= clippingStableScrollbarWidth;
    } else if (windowScrollbarX <= $3c68228f7800d7b7$var$SCROLLBAR_MAX) // If the <body> scrollbar is on the left, the width needs to be extended
    // by the scrollbar amount so there isn't extra space on the right.
    width += windowScrollbarX;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $3c68228f7800d7b7$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $3c68228f7800d7b7$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $8ae9d98fd8d9c665$export$1b3bfaa9684536aa)(element) ? $3c68228f7800d7b7$var$getScale(element) : (0, $fb26760234e0a027$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $3c68228f7800d7b7$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $3c68228f7800d7b7$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $3c68228f7800d7b7$var$getDocumentRect((0, $8ae9d98fd8d9c665$export$e495491855dc5418)(element));
    else if ((0, $8ae9d98fd8d9c665$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $3c68228f7800d7b7$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $3c68228f7800d7b7$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $fb26760234e0a027$export$ee05aea0aeecbad4)(rect);
}
function $3c68228f7800d7b7$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $8ae9d98fd8d9c665$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $8ae9d98fd8d9c665$export$45a5e7f76e0caa8d)(parentNode) || (0, $8ae9d98fd8d9c665$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $8ae9d98fd8d9c665$export$3735103072e4a80)(parentNode).position === 'fixed' || $3c68228f7800d7b7$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $3c68228f7800d7b7$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $8ae9d98fd8d9c665$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $8ae9d98fd8d9c665$export$45a5e7f76e0caa8d)(el) && (0, $8ae9d98fd8d9c665$export$651544f548703224)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $8ae9d98fd8d9c665$export$3735103072e4a80)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $8ae9d98fd8d9c665$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $8ae9d98fd8d9c665$export$45a5e7f76e0caa8d)(currentNode) && !(0, $8ae9d98fd8d9c665$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $8ae9d98fd8d9c665$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $8ae9d98fd8d9c665$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && (currentContainingBlockComputedStyle.position === 'absolute' || currentContainingBlockComputedStyle.position === 'fixed') || (0, $8ae9d98fd8d9c665$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $3c68228f7800d7b7$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $8ae9d98fd8d9c665$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $3c68228f7800d7b7$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $8ae9d98fd8d9c665$export$89e651af02346cd4)(element) ? [] : $3c68228f7800d7b7$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstRect = $3c68228f7800d7b7$var$getClientRectFromClippingAncestor(element, clippingAncestors[0], strategy);
    let top = firstRect.top;
    let right = firstRect.right;
    let bottom = firstRect.bottom;
    let left = firstRect.left;
    for(let i = 1; i < clippingAncestors.length; i++){
        const rect = $3c68228f7800d7b7$var$getClientRectFromClippingAncestor(element, clippingAncestors[i], strategy);
        top = (0, $fb26760234e0a027$export$8960430cfd85939f)(rect.top, top);
        right = (0, $fb26760234e0a027$export$96ec731ed4dcb222)(rect.right, right);
        bottom = (0, $fb26760234e0a027$export$96ec731ed4dcb222)(rect.bottom, bottom);
        left = (0, $fb26760234e0a027$export$8960430cfd85939f)(rect.left, left);
    }
    return {
        width: right - left,
        height: bottom - top,
        x: left,
        y: top
    };
}
function $3c68228f7800d7b7$var$getDimensions(element) {
    const { width: width, height: height } = $3c68228f7800d7b7$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $3c68228f7800d7b7$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $8ae9d98fd8d9c665$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $8ae9d98fd8d9c665$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $3c68228f7800d7b7$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $fb26760234e0a027$export$a397704b5e280835)(0);
    // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
    // Firefox with layout.scrollbar.side = 3 in about:config to test this.
    function setLeftRTLScrollbarOffset() {
        offsets.x = $3c68228f7800d7b7$var$getWindowScrollBarX(documentElement);
    }
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $8ae9d98fd8d9c665$export$651544f548703224)(offsetParent) !== 'body' || (0, $8ae9d98fd8d9c665$export$989e911fa9af580a)(documentElement)) scroll = (0, $8ae9d98fd8d9c665$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $3c68228f7800d7b7$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) setLeftRTLScrollbarOffset();
    }
    if (isFixed && !isOffsetParentAnElement && documentElement) setLeftRTLScrollbarOffset();
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $3c68228f7800d7b7$var$getHTMLOffset(documentElement, scroll) : (0, $fb26760234e0a027$export$a397704b5e280835)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $3c68228f7800d7b7$var$isStaticPositioned(element) {
    return (0, $8ae9d98fd8d9c665$export$3735103072e4a80)(element).position === 'static';
}
function $3c68228f7800d7b7$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $8ae9d98fd8d9c665$export$1b3bfaa9684536aa)(element) || (0, $8ae9d98fd8d9c665$export$3735103072e4a80)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $8ae9d98fd8d9c665$export$e495491855dc5418)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $3c68228f7800d7b7$var$getOffsetParent(element, polyfill) {
    const win = (0, $8ae9d98fd8d9c665$export$38b2d434cce3ea22)(element);
    if ((0, $8ae9d98fd8d9c665$export$89e651af02346cd4)(element)) return win;
    if (!(0, $8ae9d98fd8d9c665$export$1b3bfaa9684536aa)(element)) {
        let svgOffsetParent = (0, $8ae9d98fd8d9c665$export$4e12058fc4d51d56)(element);
        while(svgOffsetParent && !(0, $8ae9d98fd8d9c665$export$d1162fb0b6d4cd51)(svgOffsetParent)){
            if ((0, $8ae9d98fd8d9c665$export$45a5e7f76e0caa8d)(svgOffsetParent) && !$3c68228f7800d7b7$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $8ae9d98fd8d9c665$export$4e12058fc4d51d56)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $3c68228f7800d7b7$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $8ae9d98fd8d9c665$export$71535ffaa902797f)(offsetParent) && $3c68228f7800d7b7$var$isStaticPositioned(offsetParent))offsetParent = $3c68228f7800d7b7$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $8ae9d98fd8d9c665$export$d1162fb0b6d4cd51)(offsetParent) && $3c68228f7800d7b7$var$isStaticPositioned(offsetParent) && !(0, $8ae9d98fd8d9c665$export$d6c4e8150c35fed1)(offsetParent)) return win;
    return offsetParent || (0, $8ae9d98fd8d9c665$export$940d8225183e1404)(element) || win;
}
const $3c68228f7800d7b7$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $3c68228f7800d7b7$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $3c68228f7800d7b7$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $3c68228f7800d7b7$var$isRTL(element) {
    return (0, $8ae9d98fd8d9c665$export$3735103072e4a80)(element).direction === 'rtl';
}
const $3c68228f7800d7b7$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $3c68228f7800d7b7$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $8ae9d98fd8d9c665$export$e495491855dc5418,
    getClippingRect: $3c68228f7800d7b7$var$getClippingRect,
    getOffsetParent: $3c68228f7800d7b7$var$getOffsetParent,
    getElementRects: $3c68228f7800d7b7$var$getElementRects,
    getClientRects: $3c68228f7800d7b7$var$getClientRects,
    getDimensions: $3c68228f7800d7b7$var$getDimensions,
    getScale: $3c68228f7800d7b7$var$getScale,
    isElement: $8ae9d98fd8d9c665$export$45a5e7f76e0caa8d,
    isRTL: $3c68228f7800d7b7$var$isRTL
};
function $3c68228f7800d7b7$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $3c68228f7800d7b7$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $8ae9d98fd8d9c665$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $fb26760234e0a027$export$a3fe094919f356fd)(top);
        const insetRight = (0, $fb26760234e0a027$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $fb26760234e0a027$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $fb26760234e0a027$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $fb26760234e0a027$export$8960430cfd85939f)(0, (0, $fb26760234e0a027$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            if (ratio === 1 && !$3c68228f7800d7b7$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) // It's possible that even though the ratio is reported as 1, the
            // element is not actually fully within the IntersectionObserver's root
            // area anymore. This can happen under performance constraints. This may
            // be a bug in the browser's IntersectionObserver implementation. To
            // work around this, we compare the element's bounding rect now with
            // what it was at the time we created the IntersectionObserver. If they
            // are not equal then the element moved, so we refresh.
            refresh();
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (_e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $3c68228f7800d7b7$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $3c68228f7800d7b7$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $8ae9d98fd8d9c665$export$3b57c1601291186b)(referenceEl) : [],
        ...floating ? (0, $8ae9d98fd8d9c665$export$3b57c1601291186b)(floating) : []
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $3c68228f7800d7b7$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver && floating) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        if (floating) resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $3c68228f7800d7b7$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $3c68228f7800d7b7$var$getBoundingClientRect(reference);
        if (prevRefRect && !$3c68228f7800d7b7$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $3c68228f7800d7b7$export$37b6bde19b108ecc = (0, $3832d2ec20157d98$export$37b6bde19b108ecc);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $3c68228f7800d7b7$export$cc800923e997bb8 = (0, $3832d2ec20157d98$export$cc800923e997bb8);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $3c68228f7800d7b7$export$91fb6ecbd551914 = (0, $3832d2ec20157d98$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $3c68228f7800d7b7$export$fba63a578e423eb = (0, $3832d2ec20157d98$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $3c68228f7800d7b7$export$8a83211c878a3f1f = (0, $3832d2ec20157d98$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $3c68228f7800d7b7$export$346677f925de839c = (0, $3832d2ec20157d98$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $3c68228f7800d7b7$export$fe8985bb6374093c = (0, $3832d2ec20157d98$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $3c68228f7800d7b7$export$f2120bbfa5450bd2 = (0, $3832d2ec20157d98$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $3c68228f7800d7b7$export$18c8ad048e32c7d5 = (0, $3832d2ec20157d98$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $3c68228f7800d7b7$export$7bf07e38f3dc4b69 = (0, $3832d2ec20157d98$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $3c68228f7800d7b7$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $3c68228f7800d7b7$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $3832d2ec20157d98$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



var $lCzvA = parcelRequire("lCzvA");

var $dAQd3 = parcelRequire("dAQd3");
var $0b7cff2f3ce5bd8b$var$isClient = typeof document !== 'undefined';
var $0b7cff2f3ce5bd8b$var$noop = function noop() {};
var $0b7cff2f3ce5bd8b$var$index = $0b7cff2f3ce5bd8b$var$isClient ? (0, $lCzvA.useLayoutEffect) : $0b7cff2f3ce5bd8b$var$noop;
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $0b7cff2f3ce5bd8b$var$deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === 'function' && a.toString() === b.toString()) return true;
    let length;
    let i;
    let keys;
    if (a && b && typeof a === 'object') {
        if (Array.isArray(a)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$0b7cff2f3ce5bd8b$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            if (!$0b7cff2f3ce5bd8b$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function $0b7cff2f3ce5bd8b$var$getDPR(element) {
    if (typeof window === 'undefined') return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function $0b7cff2f3ce5bd8b$var$roundByDPR(element, value) {
    const dpr = $0b7cff2f3ce5bd8b$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function $0b7cff2f3ce5bd8b$var$useLatestRef(value) {
    const ref = $lCzvA.useRef(value);
    $0b7cff2f3ce5bd8b$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */ function $0b7cff2f3ce5bd8b$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform, elements: { reference: externalReference, floating: externalFloating } = {}, transform: transform = true, whileElementsMounted: whileElementsMounted, open: open } = options;
    const [data, setData] = $lCzvA.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = $lCzvA.useState(middleware);
    if (!$0b7cff2f3ce5bd8b$var$deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = $lCzvA.useState(null);
    const [_floating, _setFloating] = $lCzvA.useState(null);
    const setReference = $lCzvA.useCallback((node)=>{
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    const setFloating = $lCzvA.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = $lCzvA.useRef(null);
    const floatingRef = $lCzvA.useRef(null);
    const dataRef = $lCzvA.useRef(data);
    const hasWhileElementsMounted = whileElementsMounted != null;
    const whileElementsMountedRef = $0b7cff2f3ce5bd8b$var$useLatestRef(whileElementsMounted);
    const platformRef = $0b7cff2f3ce5bd8b$var$useLatestRef(platform);
    const openRef = $0b7cff2f3ce5bd8b$var$useLatestRef(open);
    const update = $lCzvA.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, $3c68228f7800d7b7$export$48a53dcb22e581d0)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                // The floating element's position may be recomputed while it's closed
                // but still mounted (such as when transitioning out). To ensure
                // `isPositioned` will be `false` initially on the next open, avoid
                // setting it to `true` when `open === false` (must be specified).
                isPositioned: openRef.current !== false
            };
            if (isMountedRef.current && !$0b7cff2f3ce5bd8b$var$deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $dAQd3.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef,
        openRef
    ]);
    $0b7cff2f3ce5bd8b$var$index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = $lCzvA.useRef(false);
    $0b7cff2f3ce5bd8b$var$index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    $0b7cff2f3ce5bd8b$var$index(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef,
        hasWhileElementsMounted
    ]);
    const refs = $lCzvA.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = $lCzvA.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = $lCzvA.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x = $0b7cff2f3ce5bd8b$var$roundByDPR(elements.floating, data.x);
        const y = $0b7cff2f3ce5bd8b$var$roundByDPR(elements.floating, data.y);
        if (transform) return {
            ...initialStyles,
            transform: "translate(" + x + "px, " + y + "px)",
            ...$0b7cff2f3ce5bd8b$var$getDPR(elements.floating) >= 1.5 && {
                willChange: 'transform'
            }
        };
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return $lCzvA.useMemo(()=>({
            ...data,
            update: update,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        }), [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $0b7cff2f3ce5bd8b$var$arrow$1 = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, 'current');
    }
    return {
        name: 'arrow',
        options: options,
        fn (state) {
            const { element: element, padding: padding } = typeof options === 'function' ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) return (0, $3c68228f7800d7b7$export$f2120bbfa5450bd2)({
                    element: element.current,
                    padding: padding
                }).fn(state);
                return {};
            }
            if (element) return (0, $3c68228f7800d7b7$export$f2120bbfa5450bd2)({
                element: element,
                padding: padding
            }).fn(state);
            return {};
        }
    };
};
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $0b7cff2f3ce5bd8b$export$cc800923e997bb8 = (options, deps)=>{
    const result = (0, $3c68228f7800d7b7$export$cc800923e997bb8)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $0b7cff2f3ce5bd8b$export$fba63a578e423eb = (options, deps)=>{
    const result = (0, $3c68228f7800d7b7$export$fba63a578e423eb)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $0b7cff2f3ce5bd8b$export$7bf07e38f3dc4b69 = (options, deps)=>{
    const result = (0, $3c68228f7800d7b7$export$7bf07e38f3dc4b69)(options);
    return {
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $0b7cff2f3ce5bd8b$export$8a83211c878a3f1f = (options, deps)=>{
    const result = (0, $3c68228f7800d7b7$export$8a83211c878a3f1f)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $0b7cff2f3ce5bd8b$export$346677f925de839c = (options, deps)=>{
    const result = (0, $3c68228f7800d7b7$export$346677f925de839c)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $0b7cff2f3ce5bd8b$export$91fb6ecbd551914 = (options, deps)=>{
    const result = (0, $3c68228f7800d7b7$export$91fb6ecbd551914)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $0b7cff2f3ce5bd8b$export$fe8985bb6374093c = (options, deps)=>{
    const result = (0, $3c68228f7800d7b7$export$fe8985bb6374093c)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $0b7cff2f3ce5bd8b$export$18c8ad048e32c7d5 = (options, deps)=>{
    const result = (0, $3c68228f7800d7b7$export$18c8ad048e32c7d5)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $0b7cff2f3ce5bd8b$export$f2120bbfa5450bd2 = (options, deps)=>{
    const result = $0b7cff2f3ce5bd8b$var$arrow$1(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};


// src/arrow.tsx

var $lCzvA = parcelRequire("lCzvA");


var $733f02f237c3585d$var$NAME = "Arrow";
var $733f02f237c3585d$export$21b07c8f274aebd5 = $lCzvA.forwardRef((props, forwardedRef)=>{
    const { children: children, width: width = 10, height: height = 5, ...arrowProps } = props;
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $ac36d1eadbf3b928$export$250ffa63cdc0d034).svg, {
        ...arrowProps,
        ref: forwardedRef,
        width: width,
        height: height,
        viewBox: "0 0 30 10",
        preserveAspectRatio: "none",
        children: props.asChild ? children : /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("polygon", {
            points: "0,0 30,0 15,10"
        })
    });
});
$733f02f237c3585d$export$21b07c8f274aebd5.displayName = $733f02f237c3585d$var$NAME;
var $733f02f237c3585d$export$be92b6f5f03c0fe9 = $733f02f237c3585d$export$21b07c8f274aebd5;







// src/use-size.tsx

var $lCzvA = parcelRequire("lCzvA");

function $5c8e3ebce5d09d2e$export$1ab7ae714698c4b8(element) {
    const [size, setSize] = $lCzvA.useState(void 0);
    (0, $85fda695601ae591$export$e5c5a5f917a5871c)(()=>{
        if (element) {
            setSize({
                width: element.offsetWidth,
                height: element.offsetHeight
            });
            const resizeObserver = new ResizeObserver((entries)=>{
                if (!Array.isArray(entries)) return;
                if (!entries.length) return;
                const entry = entries[0];
                let width;
                let height;
                if ("borderBoxSize" in entry) {
                    const borderSizeEntry = entry["borderBoxSize"];
                    const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
                    width = borderSize["inlineSize"];
                    height = borderSize["blockSize"];
                } else {
                    width = element.offsetWidth;
                    height = element.offsetHeight;
                }
                setSize({
                    width: width,
                    height: height
                });
            });
            resizeObserver.observe(element, {
                box: "border-box"
            });
            return ()=>resizeObserver.unobserve(element);
        } else setSize(void 0);
    }, [
        element
    ]);
    return size;
}



"use client";
var $3bc57394c2afda2a$export$36f0086da09c4b9f = [
    "top",
    "right",
    "bottom",
    "left"
];
var $3bc57394c2afda2a$export$3671ffab7b302fc9 = [
    "start",
    "center",
    "end"
];
var $3bc57394c2afda2a$var$POPPER_NAME = "Popper";
var [$3bc57394c2afda2a$var$createPopperContext, $3bc57394c2afda2a$export$722aac194ae923] = (0, $e4b0fa6903a3dc52$export$50c7b4e9d9f19c1)($3bc57394c2afda2a$var$POPPER_NAME);
var [$3bc57394c2afda2a$var$PopperProvider, $3bc57394c2afda2a$var$usePopperContext] = $3bc57394c2afda2a$var$createPopperContext($3bc57394c2afda2a$var$POPPER_NAME);
var $3bc57394c2afda2a$export$badac9ada3a0bdf9 = (props)=>{
    const { __scopePopper: __scopePopper, children: children } = props;
    const [anchor, setAnchor] = $lCzvA.useState(null);
    const [placementState, setPlacementState] = $lCzvA.useState(void 0);
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($3bc57394c2afda2a$var$PopperProvider, {
        scope: __scopePopper,
        anchor: anchor,
        onAnchorChange: setAnchor,
        placementState: placementState,
        setPlacementState: setPlacementState,
        children: children
    });
};
$3bc57394c2afda2a$export$badac9ada3a0bdf9.displayName = $3bc57394c2afda2a$var$POPPER_NAME;
var $3bc57394c2afda2a$var$ANCHOR_NAME = "PopperAnchor";
var $3bc57394c2afda2a$export$ecd4e1ccab6ed6d = $lCzvA.forwardRef((props, forwardedRef)=>{
    const { __scopePopper: __scopePopper, virtualRef: virtualRef, ...anchorProps } = props;
    const context = $3bc57394c2afda2a$var$usePopperContext($3bc57394c2afda2a$var$ANCHOR_NAME, __scopePopper);
    const ref = $lCzvA.useRef(null);
    const onAnchorChange = context.onAnchorChange;
    const callbackRef = $lCzvA.useCallback((node)=>{
        ref.current = node;
        if (node) onAnchorChange(node);
    }, [
        onAnchorChange
    ]);
    const composedRefs = (0, $ca45e6a36e8d9db0$export$c7b2cbe3552a0d05)(forwardedRef, callbackRef);
    const anchorRef = $lCzvA.useRef(null);
    $lCzvA.useEffect(()=>{
        if (!virtualRef) return;
        const previousAnchor = anchorRef.current;
        anchorRef.current = virtualRef.current;
        if (previousAnchor !== anchorRef.current) onAnchorChange(anchorRef.current);
    });
    const sideAndAlign = context.placementState && $3bc57394c2afda2a$var$getSideAndAlignFromPlacement(context.placementState);
    const placedSide = sideAndAlign?.[0];
    const placedAlign = sideAndAlign?.[1];
    return virtualRef ? null : /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $ac36d1eadbf3b928$export$250ffa63cdc0d034).div, {
        "data-radix-popper-side": placedSide,
        "data-radix-popper-align": placedAlign,
        ...anchorProps,
        ref: composedRefs
    });
});
$3bc57394c2afda2a$export$ecd4e1ccab6ed6d.displayName = $3bc57394c2afda2a$var$ANCHOR_NAME;
var $3bc57394c2afda2a$var$CONTENT_NAME = "PopperContent";
var [$3bc57394c2afda2a$var$PopperContentProvider, $3bc57394c2afda2a$var$useContentContext] = $3bc57394c2afda2a$var$createPopperContext($3bc57394c2afda2a$var$CONTENT_NAME);
var $3bc57394c2afda2a$export$bc4ae5855d3c4fc = $lCzvA.forwardRef((props, forwardedRef)=>{
    const { __scopePopper: __scopePopper, side: side = "bottom", sideOffset: sideOffset = 0, align: align = "center", alignOffset: alignOffset = 0, arrowPadding: arrowPadding = 0, avoidCollisions: avoidCollisions = true, collisionBoundary: collisionBoundary = [], collisionPadding: collisionPaddingProp = 0, sticky: sticky = "partial", hideWhenDetached: hideWhenDetached = false, updatePositionStrategy: updatePositionStrategy = "optimized", onPlaced: onPlaced, ...contentProps } = props;
    const context = $3bc57394c2afda2a$var$usePopperContext($3bc57394c2afda2a$var$CONTENT_NAME, __scopePopper);
    const [content, setContent] = $lCzvA.useState(null);
    const composedRefs = (0, $ca45e6a36e8d9db0$export$c7b2cbe3552a0d05)(forwardedRef, setContent);
    const [arrow, setArrow] = $lCzvA.useState(null);
    const arrowSize = (0, $5c8e3ebce5d09d2e$export$1ab7ae714698c4b8)(arrow);
    const arrowWidth = arrowSize?.width ?? 0;
    const arrowHeight = arrowSize?.height ?? 0;
    const desiredPlacement = side + (align !== "center" ? "-" + align : "");
    const collisionPadding = typeof collisionPaddingProp === "number" ? collisionPaddingProp : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...collisionPaddingProp
    };
    const boundary = Array.isArray(collisionBoundary) ? collisionBoundary : [
        collisionBoundary
    ];
    const hasExplicitBoundaries = boundary.length > 0;
    const detectOverflowOptions = {
        padding: collisionPadding,
        boundary: boundary.filter($3bc57394c2afda2a$var$isNotNull),
        // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
        altBoundary: hasExplicitBoundaries
    };
    const { refs: refs, floatingStyles: floatingStyles, placement: placement, isPositioned: isPositioned, middlewareData: middlewareData } = (0, $0b7cff2f3ce5bd8b$export$4e02a5c1d08bac65)({
        // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
        strategy: "fixed",
        placement: desiredPlacement,
        whileElementsMounted: (...args)=>{
            const cleanup = (0, $3c68228f7800d7b7$export$deee3a793edee05f)(...args, {
                animationFrame: updatePositionStrategy === "always"
            });
            return cleanup;
        },
        elements: {
            reference: context.anchor
        },
        middleware: [
            (0, $0b7cff2f3ce5bd8b$export$cc800923e997bb8)({
                mainAxis: sideOffset + arrowHeight,
                alignmentAxis: alignOffset
            }),
            avoidCollisions && (0, $0b7cff2f3ce5bd8b$export$fba63a578e423eb)({
                mainAxis: true,
                crossAxis: false,
                limiter: sticky === "partial" ? (0, $0b7cff2f3ce5bd8b$export$7bf07e38f3dc4b69)() : void 0,
                ...detectOverflowOptions
            }),
            avoidCollisions && (0, $0b7cff2f3ce5bd8b$export$8a83211c878a3f1f)({
                ...detectOverflowOptions
            }),
            (0, $0b7cff2f3ce5bd8b$export$346677f925de839c)({
                ...detectOverflowOptions,
                apply: ({ elements: elements, rects: rects, availableWidth: availableWidth, availableHeight: availableHeight })=>{
                    const { width: anchorWidth, height: anchorHeight } = rects.reference;
                    const contentStyle = elements.floating.style;
                    contentStyle.setProperty("--radix-popper-available-width", `${availableWidth}px`);
                    contentStyle.setProperty("--radix-popper-available-height", `${availableHeight}px`);
                    contentStyle.setProperty("--radix-popper-anchor-width", `${anchorWidth}px`);
                    contentStyle.setProperty("--radix-popper-anchor-height", `${anchorHeight}px`);
                }
            }),
            arrow && (0, $0b7cff2f3ce5bd8b$export$f2120bbfa5450bd2)({
                element: arrow,
                padding: arrowPadding
            }),
            $3bc57394c2afda2a$var$transformOrigin({
                arrowWidth: arrowWidth,
                arrowHeight: arrowHeight
            }),
            hideWhenDetached && (0, $0b7cff2f3ce5bd8b$export$fe8985bb6374093c)({
                strategy: "referenceHidden",
                ...detectOverflowOptions,
                // `hide` detects whether the anchor (reference) is clipped, so when
                // no explicit `collisionBoundary` is set we fall back to Floating
                // UI's default clipping ancestors (e.g. a scrollable menu). This
                // lets an occluded submenu hide once its anchor scrolls out of view
                // (#3237). The collision/size middlewares deliberately keep the
                // viewport-based default to avoid clamping content rendered inside
                // transformed or overflow-clipping portal containers.
                boundary: hasExplicitBoundaries ? detectOverflowOptions.boundary : void 0
            })
        ]
    });
    const setPlacementState = context.setPlacementState;
    (0, $85fda695601ae591$export$e5c5a5f917a5871c)(()=>{
        setPlacementState(placement);
        return ()=>{
            setPlacementState(void 0);
        };
    }, [
        placement,
        setPlacementState
    ]);
    const [placedSide, placedAlign] = $3bc57394c2afda2a$var$getSideAndAlignFromPlacement(placement);
    const handlePlaced = (0, $d7e88b701ace0523$export$25bec8c6f54ee79a)(onPlaced);
    (0, $85fda695601ae591$export$e5c5a5f917a5871c)(()=>{
        if (isPositioned) handlePlaced?.();
    }, [
        isPositioned,
        handlePlaced
    ]);
    const arrowX = middlewareData.arrow?.x;
    const arrowY = middlewareData.arrow?.y;
    const cannotCenterArrow = middlewareData.arrow?.centerOffset !== 0;
    const [contentZIndex, setContentZIndex] = $lCzvA.useState();
    (0, $85fda695601ae591$export$e5c5a5f917a5871c)(()=>{
        if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [
        content
    ]);
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
        ref: refs.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
            ...floatingStyles,
            transform: isPositioned ? floatingStyles.transform : "translate(0, -200%)",
            // keep off the page when measuring
            minWidth: "max-content",
            zIndex: contentZIndex,
            "--radix-popper-transform-origin": [
                middlewareData.transformOrigin?.x,
                middlewareData.transformOrigin?.y
            ].join(" "),
            // hide the content if using the hide middleware and should be hidden
            // set visibility to hidden and disable pointer events so the UI behaves
            // as if the PopperContent isn't there at all
            ...middlewareData.hide?.referenceHidden && {
                visibility: "hidden",
                pointerEvents: "none"
            }
        },
        dir: props.dir,
        children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($3bc57394c2afda2a$var$PopperContentProvider, {
            scope: __scopePopper,
            placedSide: placedSide,
            placedAlign: placedAlign,
            onArrowChange: setArrow,
            arrowX: arrowX,
            arrowY: arrowY,
            shouldHideArrow: cannotCenterArrow,
            children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $ac36d1eadbf3b928$export$250ffa63cdc0d034).div, {
                "data-side": placedSide,
                "data-align": placedAlign,
                ...contentProps,
                ref: composedRefs,
                style: {
                    ...contentProps.style,
                    // if the PopperContent hasn't been placed yet (not all measurements done)
                    // we prevent animations so that users's animation don't kick in too early referring wrong sides
                    animation: !isPositioned ? "none" : void 0
                }
            })
        })
    });
});
$3bc57394c2afda2a$export$bc4ae5855d3c4fc.displayName = $3bc57394c2afda2a$var$CONTENT_NAME;
var $3bc57394c2afda2a$var$ARROW_NAME = "PopperArrow";
var $3bc57394c2afda2a$var$OPPOSITE_SIDE = {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right"
};
var $3bc57394c2afda2a$export$79d62cd4e10a3fd0 = $lCzvA.forwardRef(function PopperArrow2(props, forwardedRef) {
    const { __scopePopper: __scopePopper, ...arrowProps } = props;
    const contentContext = $3bc57394c2afda2a$var$useContentContext($3bc57394c2afda2a$var$ARROW_NAME, __scopePopper);
    const baseSide = $3bc57394c2afda2a$var$OPPOSITE_SIDE[contentContext.placedSide];
    return(// we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
        ref: contentContext.onArrowChange,
        style: {
            position: "absolute",
            left: contentContext.arrowX,
            top: contentContext.arrowY,
            [baseSide]: 0,
            transformOrigin: {
                top: "",
                right: "0 0",
                bottom: "center 0",
                left: "100% 0"
            }[contentContext.placedSide],
            transform: {
                top: "translateY(100%)",
                right: "translateY(50%) rotate(90deg) translateX(-50%)",
                bottom: `rotate(180deg)`,
                left: "translateY(50%) rotate(-90deg) translateX(50%)"
            }[contentContext.placedSide],
            visibility: contentContext.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($733f02f237c3585d$export$be92b6f5f03c0fe9, {
            ...arrowProps,
            ref: forwardedRef,
            style: {
                ...arrowProps.style,
                // ensures the element can be measured correctly (mostly for if SVG)
                display: "block"
            }
        })
    }));
});
$3bc57394c2afda2a$export$79d62cd4e10a3fd0.displayName = $3bc57394c2afda2a$var$ARROW_NAME;
function $3bc57394c2afda2a$var$isNotNull(value) {
    return value !== null;
}
var $3bc57394c2afda2a$var$transformOrigin = (options)=>({
        name: "transformOrigin",
        options: options,
        fn (data) {
            const { placement: placement, rects: rects, middlewareData: middlewareData } = data;
            const cannotCenterArrow = middlewareData.arrow?.centerOffset !== 0;
            const isArrowHidden = cannotCenterArrow;
            const arrowWidth = isArrowHidden ? 0 : options.arrowWidth;
            const arrowHeight = isArrowHidden ? 0 : options.arrowHeight;
            const [placedSide, placedAlign] = $3bc57394c2afda2a$var$getSideAndAlignFromPlacement(placement);
            const noArrowAlign = {
                start: "0%",
                center: "50%",
                end: "100%"
            }[placedAlign];
            const arrowXCenter = (middlewareData.arrow?.x ?? 0) + arrowWidth / 2;
            const arrowYCenter = (middlewareData.arrow?.y ?? 0) + arrowHeight / 2;
            let x = "";
            let y = "";
            if (placedSide === "bottom") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${-arrowHeight}px`;
            } else if (placedSide === "top") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${rects.floating.height + arrowHeight}px`;
            } else if (placedSide === "right") {
                x = `${-arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            } else if (placedSide === "left") {
                x = `${rects.floating.width + arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            }
            return {
                data: {
                    x: x,
                    y: y
                }
            };
        }
    });
function $3bc57394c2afda2a$var$getSideAndAlignFromPlacement(placement) {
    const [side, align = "center"] = placement.split("-");
    return [
        side,
        align
    ];
}
var $3bc57394c2afda2a$export$be92b6f5f03c0fe9 = $3bc57394c2afda2a$export$badac9ada3a0bdf9;
var $3bc57394c2afda2a$export$b688253958b8dfe7 = $3bc57394c2afda2a$export$ecd4e1ccab6ed6d;
var $3bc57394c2afda2a$export$7c6e2c02157bb7d2 = $3bc57394c2afda2a$export$bc4ae5855d3c4fc;
var $3bc57394c2afda2a$export$21b07c8f274aebd5 = $3bc57394c2afda2a$export$79d62cd4e10a3fd0;



var $lCzvA = parcelRequire("lCzvA");

var $dAQd3 = parcelRequire("dAQd3");



"use client";
var $71b14dad088b6acb$var$PORTAL_NAME = "Portal";
var $71b14dad088b6acb$export$602eac185826482c = $lCzvA.forwardRef((props, forwardedRef)=>{
    const { container: containerProp, ...portalProps } = props;
    const [mounted, setMounted] = $lCzvA.useState(false);
    (0, $85fda695601ae591$export$e5c5a5f917a5871c)(()=>setMounted(true), []);
    const container = containerProp || mounted && globalThis?.document?.body;
    return container ? $dAQd3.createPortal(/* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $ac36d1eadbf3b928$export$250ffa63cdc0d034).div, {
        ...portalProps,
        ref: forwardedRef
    }), container) : null;
});
$71b14dad088b6acb$export$602eac185826482c.displayName = $71b14dad088b6acb$var$PORTAL_NAME;
var $71b14dad088b6acb$export$be92b6f5f03c0fe9 = $71b14dad088b6acb$export$602eac185826482c;



var $lCzvA = parcelRequire("lCzvA");

"use client";
function $cbca32552b7e9adc$var$useStateMachine(initialState, machine) {
    return $lCzvA.useReducer((state, event)=>{
        const nextState = machine[state][event];
        return nextState ?? state;
    }, initialState);
}
// src/presence.tsx
var $cbca32552b7e9adc$export$99c2b779aa4e8b8b = (props)=>{
    const { present: present, children: children } = props;
    const presence = $cbca32552b7e9adc$var$usePresence(present);
    const child = typeof children === "function" ? children({
        present: presence.isPresent
    }) : $lCzvA.Children.only(children);
    const ref = $cbca32552b7e9adc$var$useStableComposedRefs(presence.ref, $cbca32552b7e9adc$var$getElementRef(child));
    const forceMount = typeof children === "function";
    return forceMount || presence.isPresent ? $lCzvA.cloneElement(child, {
        ref: ref
    }) : null;
};
$cbca32552b7e9adc$export$99c2b779aa4e8b8b.displayName = "Presence";
function $cbca32552b7e9adc$var$usePresence(present) {
    const [node, setNode] = $lCzvA.useState();
    const stylesRef = $lCzvA.useRef(null);
    const prevPresentRef = $lCzvA.useRef(present);
    const prevAnimationNameRef = $lCzvA.useRef("none");
    const mountAnimationNameRef = $lCzvA.useRef(void 0);
    const initialState = present ? "mounted" : "unmounted";
    const [state, send] = $cbca32552b7e9adc$var$useStateMachine(initialState, {
        mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
        },
        unmounted: {
            MOUNT: "mounted"
        }
    });
    $lCzvA.useEffect(()=>{
        if (state === "mounted") {
            prevAnimationNameRef.current = mountAnimationNameRef.current ?? $cbca32552b7e9adc$var$getAnimationName(stylesRef.current);
            mountAnimationNameRef.current = void 0;
        } else prevAnimationNameRef.current = "none";
    }, [
        state
    ]);
    (0, $85fda695601ae591$export$e5c5a5f917a5871c)(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = $cbca32552b7e9adc$var$getAnimationName(styles);
            if (present) {
                mountAnimationNameRef.current = currentAnimationName;
                send("MOUNT");
            } else if (currentAnimationName === "none" || styles?.display === "none") send("UNMOUNT");
            else {
                const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send("ANIMATION_OUT");
                else send("UNMOUNT");
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0, $85fda695601ae591$export$e5c5a5f917a5871c)(()=>{
        if (node) {
            let timeoutId;
            const ownerWindow = node.ownerDocument.defaultView ?? window;
            const handleAnimationEnd = (event)=>{
                const currentAnimationName = $cbca32552b7e9adc$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(CSS.escape(event.animationName));
                if (event.target === node && isCurrentAnimation) {
                    send("ANIMATION_END");
                    if (!prevPresentRef.current) {
                        const currentFillMode = node.style.animationFillMode;
                        node.style.animationFillMode = "forwards";
                        timeoutId = ownerWindow.setTimeout(()=>{
                            if (node.style.animationFillMode === "forwards") node.style.animationFillMode = currentFillMode;
                        });
                    }
                }
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node) prevAnimationNameRef.current = $cbca32552b7e9adc$var$getAnimationName(stylesRef.current);
            };
            node.addEventListener("animationstart", handleAnimationStart);
            node.addEventListener("animationcancel", handleAnimationEnd);
            node.addEventListener("animationend", handleAnimationEnd);
            return ()=>{
                ownerWindow.clearTimeout(timeoutId);
                node.removeEventListener("animationstart", handleAnimationStart);
                node.removeEventListener("animationcancel", handleAnimationEnd);
                node.removeEventListener("animationend", handleAnimationEnd);
            };
        } else send("ANIMATION_END");
    }, [
        node,
        send
    ]);
    return {
        isPresent: [
            "mounted",
            "unmountSuspended"
        ].includes(state),
        ref: $lCzvA.useCallback((node2)=>{
            if (node2) {
                const styles = getComputedStyle(node2);
                stylesRef.current = styles;
                mountAnimationNameRef.current = $cbca32552b7e9adc$var$getAnimationName(styles);
            } else stylesRef.current = null;
            setNode(node2);
        }, [])
    };
}
function $cbca32552b7e9adc$var$setRef(ref, value) {
    if (typeof ref === "function") return ref(value);
    else if (ref !== null && ref !== void 0) ref.current = value;
}
function $cbca32552b7e9adc$var$useStableComposedRefs(...refs) {
    const refsRef = $lCzvA.useRef(refs);
    refsRef.current = refs;
    return $lCzvA.useCallback((node)=>{
        const currentRefs = refsRef.current;
        let hasCleanup = false;
        const cleanups = currentRefs.map((ref)=>{
            const cleanup = $cbca32552b7e9adc$var$setRef(ref, node);
            if (!hasCleanup && typeof cleanup === "function") hasCleanup = true;
            return cleanup;
        });
        if (hasCleanup) return ()=>{
            for(let i = 0; i < cleanups.length; i++){
                const cleanup = cleanups[i];
                if (typeof cleanup === "function") cleanup();
                else $cbca32552b7e9adc$var$setRef(currentRefs[i], null);
            }
        };
    }, []);
}
function $cbca32552b7e9adc$var$getAnimationName(styles) {
    return styles?.animationName || "none";
}
function $cbca32552b7e9adc$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}
var $cbca32552b7e9adc$export$be92b6f5f03c0fe9 = $cbca32552b7e9adc$export$99c2b779aa4e8b8b;




// src/use-controllable-state.tsx

var $lCzvA = parcelRequire("lCzvA");

// src/use-effect-event.tsx


var $lCzvA = parcelRequire("lCzvA");
var $23d5b992c21a7612$var$useReactEffectEvent = $lCzvA[" useEffectEvent ".trim().toString()];
var $23d5b992c21a7612$var$useReactInsertionEffect = $lCzvA[" useInsertionEffect ".trim().toString()];
function $23d5b992c21a7612$export$7f54fc3180508a52(callback) {
    if (typeof $23d5b992c21a7612$var$useReactEffectEvent === "function") return $23d5b992c21a7612$var$useReactEffectEvent(callback);
    const ref = $lCzvA.useRef(()=>{
        throw new Error("Cannot call an event handler while rendering.");
    });
    if (typeof $23d5b992c21a7612$var$useReactInsertionEffect === "function") $23d5b992c21a7612$var$useReactInsertionEffect(()=>{
        ref.current = callback;
    });
    else (0, $85fda695601ae591$export$e5c5a5f917a5871c)(()=>{
        ref.current = callback;
    });
    return $lCzvA.useMemo(()=>(...args)=>ref.current?.(...args), []);
}


var $10b1f3c1fb191872$var$useInsertionEffect = $lCzvA[" useInsertionEffect ".trim().toString()] || (0, $85fda695601ae591$export$e5c5a5f917a5871c);
function $10b1f3c1fb191872$export$6f32135080cb4c3({ prop: prop, defaultProp: defaultProp, onChange: onChange = ()=>{}, caller: caller }) {
    const [uncontrolledProp, setUncontrolledProp, onChangeRef] = $10b1f3c1fb191872$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== void 0;
    const value = isControlled ? prop : uncontrolledProp;
    {
        const isControlledRef = $lCzvA.useRef(prop !== void 0);
        $lCzvA.useEffect(()=>{
            const wasControlled = isControlledRef.current;
            if (wasControlled !== isControlled) {
                const from = wasControlled ? "controlled" : "uncontrolled";
                const to = isControlled ? "controlled" : "uncontrolled";
                console.warn(`${caller} is changing from ${from} to ${to}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`);
            }
            isControlledRef.current = isControlled;
        }, [
            isControlled,
            caller
        ]);
    }
    const setValue = $lCzvA.useCallback((nextValue)=>{
        if (isControlled) {
            const value2 = $10b1f3c1fb191872$var$isFunction(nextValue) ? nextValue(prop) : nextValue;
            if (value2 !== prop) onChangeRef.current?.(value2);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        onChangeRef
    ]);
    return [
        value,
        setValue
    ];
}
function $10b1f3c1fb191872$var$useUncontrolledState({ defaultProp: defaultProp, onChange: onChange }) {
    const [value, setValue] = $lCzvA.useState(defaultProp);
    const prevValueRef = $lCzvA.useRef(value);
    const onChangeRef = $lCzvA.useRef(onChange);
    $10b1f3c1fb191872$var$useInsertionEffect(()=>{
        onChangeRef.current = onChange;
    }, [
        onChange
    ]);
    $lCzvA.useEffect(()=>{
        if (prevValueRef.current !== value) {
            onChangeRef.current?.(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef
    ]);
    return [
        value,
        setValue,
        onChangeRef
    ];
}
function $10b1f3c1fb191872$var$isFunction(value) {
    return typeof value === "function";
}
var $10b1f3c1fb191872$var$SYNC_STATE = Symbol("RADIX:SYNC_STATE");
function $10b1f3c1fb191872$export$bf6fc034f0c038af(reducer, userArgs, initialArg, init) {
    const { prop: controlledState, defaultProp: defaultProp, onChange: onChangeProp, caller: caller } = userArgs;
    const isControlled = controlledState !== void 0;
    const onChange = (0, $23d5b992c21a7612$export$7f54fc3180508a52)(onChangeProp);
    {
        const isControlledRef = $lCzvA.useRef(controlledState !== void 0);
        $lCzvA.useEffect(()=>{
            const wasControlled = isControlledRef.current;
            if (wasControlled !== isControlled) {
                const from = wasControlled ? "controlled" : "uncontrolled";
                const to = isControlled ? "controlled" : "uncontrolled";
                console.warn(`${caller} is changing from ${from} to ${to}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`);
            }
            isControlledRef.current = isControlled;
        }, [
            isControlled,
            caller
        ]);
    }
    const args = [
        {
            ...initialArg,
            state: defaultProp
        }
    ];
    if (init) args.push(init);
    const [internalState, dispatch] = $lCzvA.useReducer((state2, action)=>{
        if (action.type === $10b1f3c1fb191872$var$SYNC_STATE) return {
            ...state2,
            state: action.state
        };
        const next = reducer(state2, action);
        if (isControlled && !Object.is(next.state, state2.state)) onChange(next.state);
        return next;
    }, ...args);
    const uncontrolledState = internalState.state;
    const prevValueRef = $lCzvA.useRef(uncontrolledState);
    $lCzvA.useEffect(()=>{
        if (prevValueRef.current !== uncontrolledState) {
            prevValueRef.current = uncontrolledState;
            if (!isControlled) onChange(uncontrolledState);
        }
    }, [
        uncontrolledState,
        prevValueRef,
        isControlled
    ]);
    const state = $lCzvA.useMemo(()=>{
        const isControlled2 = controlledState !== void 0;
        if (isControlled2) return {
            ...internalState,
            state: controlledState
        };
        return internalState;
    }, [
        internalState,
        controlledState
    ]);
    $lCzvA.useEffect(()=>{
        if (isControlled && !Object.is(controlledState, internalState.state)) dispatch({
            type: $10b1f3c1fb191872$var$SYNC_STATE,
            state: controlledState
        });
    }, [
        controlledState,
        internalState.state,
        isControlled
    ]);
    return [
        state,
        dispatch
    ];
}


var $b830715829a44420$var$getDefaultParent = function(originalTarget) {
    if (typeof document === 'undefined') return null;
    var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return sampleTarget.ownerDocument.body;
};
var $b830715829a44420$var$counterMap = new WeakMap();
var $b830715829a44420$var$uncontrolledNodes = new WeakMap();
var $b830715829a44420$var$markerMap = {};
var $b830715829a44420$var$lockCount = 0;
var $b830715829a44420$var$unwrapHost = function(node) {
    return node && (node.host || $b830715829a44420$var$unwrapHost(node.parentNode));
};
var $b830715829a44420$var$correctTargets = function(parent, targets) {
    return targets.map(function(target) {
        if (parent.contains(target)) return target;
        var correctedTarget = $b830715829a44420$var$unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) return correctedTarget;
        console.error('aria-hidden', target, 'in not contained inside', parent, '. Doing nothing');
        return null;
    }).filter(function(x) {
        return Boolean(x);
    });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */ var $b830715829a44420$var$applyAttributeToOthers = function(originalTarget, parentNode, markerName, controlAttribute) {
    var targets = $b830715829a44420$var$correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    if (!$b830715829a44420$var$markerMap[markerName]) $b830715829a44420$var$markerMap[markerName] = new WeakMap();
    var markerCounter = $b830715829a44420$var$markerMap[markerName];
    var hiddenNodes = [];
    var elementsToKeep = new Set();
    var elementsToStop = new Set(targets);
    var keep = function(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    var deep = function(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        Array.prototype.forEach.call(parent.children, function(node) {
            if (elementsToKeep.has(node)) deep(node);
            else try {
                var attr = node.getAttribute(controlAttribute);
                var alreadyHidden = attr !== null && attr !== 'false';
                var counterValue = ($b830715829a44420$var$counterMap.get(node) || 0) + 1;
                var markerValue = (markerCounter.get(node) || 0) + 1;
                $b830715829a44420$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenNodes.push(node);
                if (counterValue === 1 && alreadyHidden) $b830715829a44420$var$uncontrolledNodes.set(node, true);
                if (markerValue === 1) node.setAttribute(markerName, 'true');
                if (!alreadyHidden) node.setAttribute(controlAttribute, 'true');
            } catch (e) {
                console.error('aria-hidden: cannot operate on ', node, e);
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    $b830715829a44420$var$lockCount++;
    return function() {
        hiddenNodes.forEach(function(node) {
            var counterValue = $b830715829a44420$var$counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            $b830715829a44420$var$counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!$b830715829a44420$var$uncontrolledNodes.has(node)) node.removeAttribute(controlAttribute);
                $b830715829a44420$var$uncontrolledNodes.delete(node);
            }
            if (!markerValue) node.removeAttribute(markerName);
        });
        $b830715829a44420$var$lockCount--;
        if (!$b830715829a44420$var$lockCount) {
            // clear
            $b830715829a44420$var$counterMap = new WeakMap();
            $b830715829a44420$var$counterMap = new WeakMap();
            $b830715829a44420$var$uncontrolledNodes = new WeakMap();
            $b830715829a44420$var$markerMap = {};
        }
    };
};
var $b830715829a44420$export$6e33d16126ed003c = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = 'data-aria-hidden';
    var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    var activeParentNode = parentNode || $b830715829a44420$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    // we should not hide aria-live elements - https://github.com/theKashey/aria-hidden/issues/10
    // and script elements, as they have no impact on accessibility.
    targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll('[aria-live], script')));
    return $b830715829a44420$var$applyAttributeToOthers(targets, activeParentNode, markerName, 'aria-hidden');
};
var $b830715829a44420$export$59151cc8db999a24 = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = 'data-inert-ed';
    var activeParentNode = parentNode || $b830715829a44420$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    return $b830715829a44420$var$applyAttributeToOthers(originalTarget, activeParentNode, markerName, 'inert');
};
var $b830715829a44420$export$cc95fea82d705fca = function() {
    return typeof HTMLElement !== 'undefined' && HTMLElement.prototype.hasOwnProperty('inert');
};
var $b830715829a44420$export$9845d4b6bdad192b = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = 'data-suppressed';
    return ($b830715829a44420$export$cc95fea82d705fca() ? $b830715829a44420$export$59151cc8db999a24 : $b830715829a44420$export$6e33d16126ed003c)(originalTarget, parentNode, markerName);
};


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $f029008346205447$var$extendStatics = function(d, b) {
    $f029008346205447$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $f029008346205447$var$extendStatics(d, b);
};
function $f029008346205447$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $f029008346205447$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $f029008346205447$export$18ce0697a983be9b = function() {
    $f029008346205447$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f029008346205447$export$18ce0697a983be9b.apply(this, arguments);
};
function $f029008346205447$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $f029008346205447$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $f029008346205447$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $f029008346205447$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $f029008346205447$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $f029008346205447$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $f029008346205447$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $f029008346205447$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $f029008346205447$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $f029008346205447$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $f029008346205447$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $f029008346205447$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $f029008346205447$export$45d3717a4c69092e(o, m, p);
}
function $f029008346205447$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $f029008346205447$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $f029008346205447$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($f029008346205447$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $f029008346205447$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $f029008346205447$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $f029008346205447$export$10c90e4f7922046c(v) {
    return this instanceof $f029008346205447$export$10c90e4f7922046c ? (this.v = v, this) : new $f029008346205447$export$10c90e4f7922046c(v);
}
function $f029008346205447$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $f029008346205447$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $f029008346205447$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $f029008346205447$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $f029008346205447$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $f029008346205447$export$19a8beecd37a4c45 === "function" ? $f029008346205447$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $f029008346205447$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $f029008346205447$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $f029008346205447$var$ownKeys = function(o) {
    $f029008346205447$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $f029008346205447$var$ownKeys(o);
};
function $f029008346205447$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $f029008346205447$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $f029008346205447$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $f029008346205447$var$__setModuleDefault(result, mod);
    return result;
}
function $f029008346205447$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $f029008346205447$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $f029008346205447$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $f029008346205447$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $f029008346205447$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $f029008346205447$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $f029008346205447$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $f029008346205447$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $f029008346205447$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $f029008346205447$export$2e2bcd8739ae039 = {
    __extends: $f029008346205447$export$a8ba968b8961cb8a,
    __assign: $f029008346205447$export$18ce0697a983be9b,
    __rest: $f029008346205447$export$3c9a16f847548506,
    __decorate: $f029008346205447$export$29e00dfd3077644b,
    __param: $f029008346205447$export$d5ad3fd78186038f,
    __esDecorate: $f029008346205447$export$3a84e1ae4e97e9b0,
    __runInitializers: $f029008346205447$export$d831c04e792af3d,
    __propKey: $f029008346205447$export$6a2a36740a146cb8,
    __setFunctionName: $f029008346205447$export$d1a06452d3489bc7,
    __metadata: $f029008346205447$export$f1db080c865becb9,
    __awaiter: $f029008346205447$export$1050f835b63b671e,
    __generator: $f029008346205447$export$67ebef60e6f28a6,
    __createBinding: $f029008346205447$export$45d3717a4c69092e,
    __exportStar: $f029008346205447$export$f33643c0debef087,
    __values: $f029008346205447$export$19a8beecd37a4c45,
    __read: $f029008346205447$export$8d051b38c9118094,
    __spread: $f029008346205447$export$afc72e2116322959,
    __spreadArrays: $f029008346205447$export$6388937ca91ccae8,
    __spreadArray: $f029008346205447$export$1216008129fb82ed,
    __await: $f029008346205447$export$10c90e4f7922046c,
    __asyncGenerator: $f029008346205447$export$e427f37a30a4de9b,
    __asyncDelegator: $f029008346205447$export$bbd80228419bb833,
    __asyncValues: $f029008346205447$export$e3b29a3d6162315f,
    __makeTemplateObject: $f029008346205447$export$4fb47efe1390b86f,
    __importStar: $f029008346205447$export$c21735bcef00d192,
    __importDefault: $f029008346205447$export$da59b14a69baef04,
    __classPrivateFieldGet: $f029008346205447$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $f029008346205447$export$d40a35129aaff81f,
    __classPrivateFieldIn: $f029008346205447$export$81fdc39f203e4e04,
    __addDisposableResource: $f029008346205447$export$88ac25d8e944e405,
    __disposeResources: $f029008346205447$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $f029008346205447$export$889dfb5d17574b0b
};



var $lCzvA = parcelRequire("lCzvA");


var $lCzvA = parcelRequire("lCzvA");
var $2a6dcead8a9dabc6$export$1da7500147d4bc3 = 'right-scroll-bar-position';
var $2a6dcead8a9dabc6$export$898e37bbd2a0ae4e = 'width-before-scroll-bar';
var $2a6dcead8a9dabc6$export$bb813dfbbc432abc = 'with-scroll-bars-hidden';
var $2a6dcead8a9dabc6$export$63d0edf80fea83b1 = '--removed-body-scroll-bar-size';



var $lCzvA = parcelRequire("lCzvA");
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $7e7b859be3025103$export$d734136a7b018efe(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
    return ref;
}



var $lCzvA = parcelRequire("lCzvA");
function $037445a21067a5fb$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $lCzvA.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}


var $59b245be811c8bd2$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' ? $lCzvA.useLayoutEffect : $lCzvA.useEffect;
var $59b245be811c8bd2$var$currentValues = new WeakMap();
function $59b245be811c8bd2$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $037445a21067a5fb$export$25bec8c6f54ee79a)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $7e7b859be3025103$export$d734136a7b018efe)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $59b245be811c8bd2$var$useIsomorphicLayoutEffect(function() {
        var oldValue = $59b245be811c8bd2$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $7e7b859be3025103$export$d734136a7b018efe)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $7e7b859be3025103$export$d734136a7b018efe)(ref, current_1);
            });
        }
        $59b245be811c8bd2$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}



function $46f1e39d2cc6f867$var$ItoI(a) {
    return a;
}
function $46f1e39d2cc6f867$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $46f1e39d2cc6f867$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $46f1e39d2cc6f867$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $46f1e39d2cc6f867$var$ItoI;
    return $46f1e39d2cc6f867$var$innerCreateMedium(defaults, middleware);
}
function $46f1e39d2cc6f867$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $46f1e39d2cc6f867$var$innerCreateMedium(null);
    medium.options = (0, $f029008346205447$export$18ce0697a983be9b)({
        async: true,
        ssr: false
    }, options);
    return medium;
}


var $a7b79fd6729700f9$export$e27363444bedfeac = (0, $46f1e39d2cc6f867$export$e13ec7dd7a14088d)();


var $8a68b7794982b682$var$nothing = function() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var $8a68b7794982b682$export$22940b497e769dee = $lCzvA.forwardRef(function(props, parentRef) {
    var ref = $lCzvA.useRef(null);
    var _a = $lCzvA.useState({
        onScrollCapture: $8a68b7794982b682$var$nothing,
        onWheelCapture: $8a68b7794982b682$var$nothing,
        onTouchMoveCapture: $8a68b7794982b682$var$nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noRelative = props.noRelative, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? 'div' : _b, gapMode = props.gapMode, rest = (0, $f029008346205447$export$3c9a16f847548506)(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noRelative",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as",
        "gapMode"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, $59b245be811c8bd2$export$74665b213cb5c4cf)([
        ref,
        parentRef
    ]);
    var containerProps = (0, $f029008346205447$export$18ce0697a983be9b)((0, $f029008346205447$export$18ce0697a983be9b)({}, rest), callbacks);
    return $lCzvA.createElement($lCzvA.Fragment, null, enabled && $lCzvA.createElement(SideCar, {
        sideCar: (0, $a7b79fd6729700f9$export$e27363444bedfeac),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noRelative: noRelative,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref,
        gapMode: gapMode
    }), forwardProps ? $lCzvA.cloneElement($lCzvA.Children.only(children), (0, $f029008346205447$export$18ce0697a983be9b)((0, $f029008346205447$export$18ce0697a983be9b)({}, containerProps), {
        ref: containerRef
    })) : $lCzvA.createElement(Container, (0, $f029008346205447$export$18ce0697a983be9b)({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
$8a68b7794982b682$export$22940b497e769dee.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
$8a68b7794982b682$export$22940b497e769dee.classNames = {
    fullWidth: (0, $2a6dcead8a9dabc6$export$898e37bbd2a0ae4e),
    zeroRight: (0, $2a6dcead8a9dabc6$export$1da7500147d4bc3)
};




var $lCzvA = parcelRequire("lCzvA");
var $22777d27d6b43ab0$var$SideCar = function(_a) {
    var sideCar = _a.sideCar, rest = (0, $f029008346205447$export$3c9a16f847548506)(_a, [
        "sideCar"
    ]);
    if (!sideCar) throw new Error('Sidecar: please provide `sideCar` property to import the right car');
    var Target = sideCar.read();
    if (!Target) throw new Error('Sidecar medium not found');
    return $lCzvA.createElement(Target, (0, $f029008346205447$export$18ce0697a983be9b)({}, rest));
};
$22777d27d6b43ab0$var$SideCar.isSideCarExport = true;
function $22777d27d6b43ab0$export$6cacc8fb0a9b94ce(medium, exported) {
    medium.useMedium(exported);
    return $22777d27d6b43ab0$var$SideCar;
}




var $lCzvA = parcelRequire("lCzvA");

var $lCzvA = parcelRequire("lCzvA");

var $lCzvA = parcelRequire("lCzvA");
var $376495ae25e8f516$var$currentNonce;
var $376495ae25e8f516$export$c5f670b24c0ae95a = function(nonce) {
    $376495ae25e8f516$var$currentNonce = nonce;
};
var $376495ae25e8f516$export$2b85b721e524d74b = function() {
    if ($376495ae25e8f516$var$currentNonce) return $376495ae25e8f516$var$currentNonce;
    if (typeof __webpack_nonce__ !== 'undefined') return __webpack_nonce__;
    return undefined;
};


function $dcdfb55f8287fd0f$var$makeStyleTag() {
    if (!document) return null;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    var nonce = (0, $376495ae25e8f516$export$2b85b721e524d74b)();
    if (nonce) tag.setAttribute('nonce', nonce);
    return tag;
}
function $dcdfb55f8287fd0f$var$injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) // @ts-ignore
    tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $dcdfb55f8287fd0f$var$insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}
var $dcdfb55f8287fd0f$export$7c74eec858d5d226 = function() {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function(style) {
            if (counter == 0) {
                if (stylesheet = $dcdfb55f8287fd0f$var$makeStyleTag()) {
                    $dcdfb55f8287fd0f$var$injectStyles(stylesheet, style);
                    $dcdfb55f8287fd0f$var$insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function() {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        }
    };
};


var $481b2bd35c604ebb$export$7d7b35c2d250e94c = function() {
    var sheet = (0, $dcdfb55f8287fd0f$export$7c74eec858d5d226)();
    return function(styles, isDynamic) {
        $lCzvA.useEffect(function() {
            sheet.add(styles);
            return function() {
                sheet.remove();
            };
        }, [
            styles && isDynamic
        ]);
    };
};


var $7e21be14d491a688$export$c1248ee86ba532c8 = function() {
    var useStyle = (0, $481b2bd35c604ebb$export$7d7b35c2d250e94c)();
    var Sheet = function(_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};







var $16b2221a4ac3e64d$export$efed13b5d0ca3386 = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
};
var $16b2221a4ac3e64d$var$parse = function(x) {
    return parseInt(x || '', 10) || 0;
};
var $16b2221a4ac3e64d$var$getOffset = function(gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === 'padding' ? 'paddingLeft' : 'marginLeft'];
    var top = cs[gapMode === 'padding' ? 'paddingTop' : 'marginTop'];
    var right = cs[gapMode === 'padding' ? 'paddingRight' : 'marginRight'];
    return [
        $16b2221a4ac3e64d$var$parse(left),
        $16b2221a4ac3e64d$var$parse(top),
        $16b2221a4ac3e64d$var$parse(right)
    ];
};
var $16b2221a4ac3e64d$export$75f2ca8f029c77f4 = function(gapMode) {
    if (gapMode === void 0) gapMode = 'margin';
    if (typeof window === 'undefined') return $16b2221a4ac3e64d$export$efed13b5d0ca3386;
    var offsets = $16b2221a4ac3e64d$var$getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
    };
};


var $141ffef5a193acee$var$Style = (0, $7e21be14d491a688$export$c1248ee86ba532c8)();
var $141ffef5a193acee$export$65254d5f26cb9564 = 'data-scroll-locked';
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var $141ffef5a193acee$var$getStyles = function(_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) gapMode = 'margin';
    return "\n  .".concat((0, $2a6dcead8a9dabc6$export$bb813dfbbc432abc), " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body[").concat($141ffef5a193acee$export$65254d5f26cb9564, "] {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === 'margin' && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === 'padding' && "padding-right: ".concat(gap, "px ").concat(important, ";")
    ].filter(Boolean).join(''), "\n  }\n  \n  .").concat((0, $2a6dcead8a9dabc6$export$1da7500147d4bc3), " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $2a6dcead8a9dabc6$export$898e37bbd2a0ae4e), " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $2a6dcead8a9dabc6$export$1da7500147d4bc3), " .").concat((0, $2a6dcead8a9dabc6$export$1da7500147d4bc3), " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat((0, $2a6dcead8a9dabc6$export$898e37bbd2a0ae4e), " .").concat((0, $2a6dcead8a9dabc6$export$898e37bbd2a0ae4e), " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body[").concat($141ffef5a193acee$export$65254d5f26cb9564, "] {\n    ").concat((0, $2a6dcead8a9dabc6$export$63d0edf80fea83b1), ": ").concat(gap, "px;\n  }\n");
};
var $141ffef5a193acee$var$getCurrentUseCounter = function() {
    var counter = parseInt(document.body.getAttribute($141ffef5a193acee$export$65254d5f26cb9564) || '0', 10);
    return isFinite(counter) ? counter : 0;
};
var $141ffef5a193acee$export$a1939b1f9f9b02dc = function() {
    $lCzvA.useEffect(function() {
        document.body.setAttribute($141ffef5a193acee$export$65254d5f26cb9564, ($141ffef5a193acee$var$getCurrentUseCounter() + 1).toString());
        return function() {
            var newCounter = $141ffef5a193acee$var$getCurrentUseCounter() - 1;
            if (newCounter <= 0) document.body.removeAttribute($141ffef5a193acee$export$65254d5f26cb9564);
            else document.body.setAttribute($141ffef5a193acee$export$65254d5f26cb9564, newCounter.toString());
        };
    }, []);
};
var $141ffef5a193acee$export$9aa43b459c5ae9b9 = function(_a) {
    var noRelative = _a.noRelative, noImportant = _a.noImportant, _b = _a.gapMode, gapMode = _b === void 0 ? 'margin' : _b;
    $141ffef5a193acee$export$a1939b1f9f9b02dc();
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */ var gap = $lCzvA.useMemo(function() {
        return (0, $16b2221a4ac3e64d$export$75f2ca8f029c77f4)(gapMode);
    }, [
        gapMode
    ]);
    return $lCzvA.createElement($141ffef5a193acee$var$Style, {
        styles: $141ffef5a193acee$var$getStyles(gap, !noRelative, gapMode, !noImportant ? '!important' : '')
    });
};







var $51472cc4f5679529$var$passiveSupported = false;
if (typeof window !== 'undefined') try {
    var $51472cc4f5679529$var$options = Object.defineProperty({}, 'passive', {
        get: function() {
            $51472cc4f5679529$var$passiveSupported = true;
            return true;
        }
    });
    // @ts-ignore
    window.addEventListener('test', $51472cc4f5679529$var$options, $51472cc4f5679529$var$options);
    // @ts-ignore
    window.removeEventListener('test', $51472cc4f5679529$var$options, $51472cc4f5679529$var$options);
} catch (err) {
    $51472cc4f5679529$var$passiveSupported = false;
}
var $51472cc4f5679529$export$10a6e88623fa9454 = $51472cc4f5679529$var$passiveSupported ? {
    passive: false
} : false;


var $398bb8e2ff44fadb$var$alwaysContainsScroll = function(node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === 'TEXTAREA';
};
var $398bb8e2ff44fadb$var$elementCanBeScrolled = function(node, overflow) {
    if (!(node instanceof Element)) return false;
    var styles = window.getComputedStyle(node);
    return(// not-not-scrollable
    styles[overflow] !== 'hidden' && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !$398bb8e2ff44fadb$var$alwaysContainsScroll(node) && styles[overflow] === 'visible'));
};
var $398bb8e2ff44fadb$var$elementCouldBeVScrolled = function(node) {
    return $398bb8e2ff44fadb$var$elementCanBeScrolled(node, 'overflowY');
};
var $398bb8e2ff44fadb$var$elementCouldBeHScrolled = function(node) {
    return $398bb8e2ff44fadb$var$elementCanBeScrolled(node, 'overflowX');
};
var $398bb8e2ff44fadb$export$9ec64480cae49817 = function(axis, node) {
    var ownerDocument = node.ownerDocument;
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== 'undefined' && current instanceof ShadowRoot) current = current.host;
        var isScrollable = $398bb8e2ff44fadb$var$elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = $398bb8e2ff44fadb$var$getScrollVariables(axis, current), scrollHeight = _a[1], clientHeight = _a[2];
            if (scrollHeight > clientHeight) return true;
        }
        current = current.parentNode;
    }while (current && current !== ownerDocument.body);
    return false;
};
var $398bb8e2ff44fadb$var$getVScrollVariables = function(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var $398bb8e2ff44fadb$var$getHScrollVariables = function(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var $398bb8e2ff44fadb$var$elementCouldBeScrolled = function(axis, node) {
    return axis === 'v' ? $398bb8e2ff44fadb$var$elementCouldBeVScrolled(node) : $398bb8e2ff44fadb$var$elementCouldBeHScrolled(node);
};
var $398bb8e2ff44fadb$var$getScrollVariables = function(axis, node) {
    return axis === 'v' ? $398bb8e2ff44fadb$var$getVScrollVariables(node) : $398bb8e2ff44fadb$var$getHScrollVariables(node);
};
var $398bb8e2ff44fadb$var$getDirectionFactor = function(axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */ return axis === 'h' && direction === 'rtl' ? -1 : 1;
};
var $398bb8e2ff44fadb$export$dde0441bd4a6ded8 = function(axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = $398bb8e2ff44fadb$var$getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        if (!target) break;
        var _a = $398bb8e2ff44fadb$var$getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if ($398bb8e2ff44fadb$var$elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        var parent_1 = target.parentNode;
        // we will "bubble" from ShadowDom in case we are, or just to the parent in normal case
        // this is the same logic used in focus-lock
        target = parent_1 && parent_1.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? parent_1.host : parent_1;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    // handle epsilon around 0 (non standard zoom levels)
    if (isDeltaPositive && (noOverscroll && Math.abs(availableScroll) < 1 || !noOverscroll && delta > availableScroll)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (noOverscroll && Math.abs(availableScrollTop) < 1 || !noOverscroll && -delta > availableScrollTop)) shouldCancelScroll = true;
    return shouldCancelScroll;
};


var $1bf7d0c43ebca60c$export$6e085704a79f4f56 = function(event) {
    return 'changedTouches' in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var $1bf7d0c43ebca60c$export$39efaa2ca254a28d = function(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var $1bf7d0c43ebca60c$var$extractRef = function(ref) {
    return ref && 'current' in ref ? ref.current : ref;
};
var $1bf7d0c43ebca60c$var$deltaCompare = function(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var $1bf7d0c43ebca60c$var$generateStyle = function(id) {
    return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var $1bf7d0c43ebca60c$var$idCounter = 0;
var $1bf7d0c43ebca60c$var$lockStack = [];
function $1bf7d0c43ebca60c$export$a09dbff87b5da2d(props) {
    var shouldPreventQueue = $lCzvA.useRef([]);
    var touchStartRef = $lCzvA.useRef([
        0,
        0
    ]);
    var activeAxis = $lCzvA.useRef();
    var id = $lCzvA.useState($1bf7d0c43ebca60c$var$idCounter++)[0];
    var Style = $lCzvA.useState((0, $7e21be14d491a688$export$c1248ee86ba532c8))[0];
    var lastProps = $lCzvA.useRef(props);
    $lCzvA.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    $lCzvA.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0, $f029008346205447$export$1216008129fb82ed)([
                props.lockRef.current
            ], (props.shards || []).map($1bf7d0c43ebca60c$var$extractRef), true).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-".concat(id));
            });
            return function() {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-".concat(id));
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = $lCzvA.useCallback(function(event, parent) {
        if ('touches' in event && event.touches.length === 2 || event.type === 'wheel' && event.ctrlKey) return !lastProps.current.allowPinchZoom;
        var touch = $1bf7d0c43ebca60c$export$6e085704a79f4f56(event);
        var touchStart = touchStartRef.current;
        var deltaX = 'deltaX' in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = 'deltaY' in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? 'h' : 'v';
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ('touches' in event && moveDirection === 'h' && target.type === 'range') return false;
        // allow drag selection (iOS); check if selection's anchorNode is the same as target or contains target
        var selection = window.getSelection();
        var anchorNode = selection && selection.anchorNode;
        var isTouchingSelection = anchorNode ? anchorNode === target || anchorNode.contains(target) : false;
        if (isTouchingSelection) return false;
        var canBeScrolledInMainDirection = (0, $398bb8e2ff44fadb$export$9ec64480cae49817)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === 'v' ? 'h' : 'v';
            canBeScrolledInMainDirection = (0, $398bb8e2ff44fadb$export$9ec64480cae49817)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && 'changedTouches' in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, $398bb8e2ff44fadb$export$dde0441bd4a6ded8)(cancelingAxis, parent, event, cancelingAxis === 'h' ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = $lCzvA.useCallback(function(_event) {
        var event = _event;
        if (!$1bf7d0c43ebca60c$var$lockStack.length || $1bf7d0c43ebca60c$var$lockStack[$1bf7d0c43ebca60c$var$lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = 'deltaY' in event ? $1bf7d0c43ebca60c$export$39efaa2ca254a28d(event) : $1bf7d0c43ebca60c$export$6e085704a79f4f56(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && (e.target === event.target || event.target === e.shadowParent) && $1bf7d0c43ebca60c$var$deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map($1bf7d0c43ebca60c$var$extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) event.preventDefault();
            }
        }
    }, []);
    var shouldCancel = $lCzvA.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should,
            shadowParent: $1bf7d0c43ebca60c$var$getOutermostShadowParent(target)
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = $lCzvA.useCallback(function(event) {
        touchStartRef.current = $1bf7d0c43ebca60c$export$6e085704a79f4f56(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = $lCzvA.useCallback(function(event) {
        shouldCancel(event.type, $1bf7d0c43ebca60c$export$39efaa2ca254a28d(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = $lCzvA.useCallback(function(event) {
        shouldCancel(event.type, $1bf7d0c43ebca60c$export$6e085704a79f4f56(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    $lCzvA.useEffect(function() {
        $1bf7d0c43ebca60c$var$lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener('wheel', shouldPrevent, (0, $51472cc4f5679529$export$10a6e88623fa9454));
        document.addEventListener('touchmove', shouldPrevent, (0, $51472cc4f5679529$export$10a6e88623fa9454));
        document.addEventListener('touchstart', scrollTouchStart, (0, $51472cc4f5679529$export$10a6e88623fa9454));
        return function() {
            $1bf7d0c43ebca60c$var$lockStack = $1bf7d0c43ebca60c$var$lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener('wheel', shouldPrevent, (0, $51472cc4f5679529$export$10a6e88623fa9454));
            document.removeEventListener('touchmove', shouldPrevent, (0, $51472cc4f5679529$export$10a6e88623fa9454));
            document.removeEventListener('touchstart', scrollTouchStart, (0, $51472cc4f5679529$export$10a6e88623fa9454));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return $lCzvA.createElement($lCzvA.Fragment, null, inert ? $lCzvA.createElement(Style, {
        styles: $1bf7d0c43ebca60c$var$generateStyle(id)
    }) : null, removeScrollBar ? $lCzvA.createElement((0, $141ffef5a193acee$export$9aa43b459c5ae9b9), {
        noRelative: props.noRelative,
        gapMode: props.gapMode
    }) : null);
}
function $1bf7d0c43ebca60c$var$getOutermostShadowParent(node) {
    var shadowParent = null;
    while(node !== null){
        if (node instanceof ShadowRoot) {
            shadowParent = node.host;
            node = node.host;
        }
        node = node.parentNode;
    }
    return shadowParent;
}



var $5a962cb74e49ff14$export$2e2bcd8739ae039 = (0, $22777d27d6b43ab0$export$6cacc8fb0a9b94ce)((0, $a7b79fd6729700f9$export$e27363444bedfeac), (0, $1bf7d0c43ebca60c$export$a09dbff87b5da2d));


var $64ab28914613351f$var$ReactRemoveScroll = $lCzvA.forwardRef(function(props, ref) {
    return $lCzvA.createElement((0, $8a68b7794982b682$export$22940b497e769dee), (0, $f029008346205447$export$18ce0697a983be9b)({}, props, {
        ref: ref,
        sideCar: (0, $5a962cb74e49ff14$export$2e2bcd8739ae039)
    }));
});
$64ab28914613351f$var$ReactRemoveScroll.classNames = (0, $8a68b7794982b682$export$22940b497e769dee).classNames;
var $64ab28914613351f$export$2e2bcd8739ae039 = $64ab28914613351f$var$ReactRemoveScroll;



"use client";
var $d52c39e93549d141$var$POPOVER_NAME = "Popover";
var [$d52c39e93549d141$var$createPopoverContext, $d52c39e93549d141$export$c8393c9e73286932] = (0, $e4b0fa6903a3dc52$export$50c7b4e9d9f19c1)($d52c39e93549d141$var$POPOVER_NAME, [
    (0, $3bc57394c2afda2a$export$722aac194ae923)
]);
var $d52c39e93549d141$var$usePopperScope = (0, $3bc57394c2afda2a$export$722aac194ae923)();
var [$d52c39e93549d141$var$PopoverProvider, $d52c39e93549d141$var$usePopoverContext] = $d52c39e93549d141$var$createPopoverContext($d52c39e93549d141$var$POPOVER_NAME);
var $d52c39e93549d141$export$5b6b19405a83ff9d = (props)=>{
    const { __scopePopover: __scopePopover, children: children, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, modal: modal = false } = props;
    const popperScope = $d52c39e93549d141$var$usePopperScope(__scopePopover);
    const triggerRef = $lCzvA.useRef(null);
    const [hasCustomAnchor, setHasCustomAnchor] = $lCzvA.useState(false);
    const [open, setOpen] = (0, $10b1f3c1fb191872$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen ?? false,
        onChange: onOpenChange,
        caller: $d52c39e93549d141$var$POPOVER_NAME
    });
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($3bc57394c2afda2a$export$be92b6f5f03c0fe9, {
        ...popperScope,
        children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($d52c39e93549d141$var$PopoverProvider, {
            scope: __scopePopover,
            contentId: (0, $fca3487281b0b7d7$export$f680877a34711e37)(),
            triggerRef: triggerRef,
            open: open,
            onOpenChange: setOpen,
            onOpenToggle: $lCzvA.useCallback(()=>setOpen((prevOpen)=>!prevOpen), [
                setOpen
            ]),
            hasCustomAnchor: hasCustomAnchor,
            onCustomAnchorAdd: $lCzvA.useCallback(()=>setHasCustomAnchor(true), []),
            onCustomAnchorRemove: $lCzvA.useCallback(()=>setHasCustomAnchor(false), []),
            modal: modal,
            children: children
        })
    });
};
$d52c39e93549d141$export$5b6b19405a83ff9d.displayName = $d52c39e93549d141$var$POPOVER_NAME;
var $d52c39e93549d141$var$ANCHOR_NAME = "PopoverAnchor";
var $d52c39e93549d141$export$96e5381f42521a79 = $lCzvA.forwardRef((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, ...anchorProps } = props;
    const context = $d52c39e93549d141$var$usePopoverContext($d52c39e93549d141$var$ANCHOR_NAME, __scopePopover);
    const popperScope = $d52c39e93549d141$var$usePopperScope(__scopePopover);
    const { onCustomAnchorAdd: onCustomAnchorAdd, onCustomAnchorRemove: onCustomAnchorRemove } = context;
    $lCzvA.useEffect(()=>{
        onCustomAnchorAdd();
        return ()=>onCustomAnchorRemove();
    }, [
        onCustomAnchorAdd,
        onCustomAnchorRemove
    ]);
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($3bc57394c2afda2a$export$b688253958b8dfe7, {
        ...popperScope,
        ...anchorProps,
        ref: forwardedRef
    });
});
$d52c39e93549d141$export$96e5381f42521a79.displayName = $d52c39e93549d141$var$ANCHOR_NAME;
var $d52c39e93549d141$var$TRIGGER_NAME = "PopoverTrigger";
var $d52c39e93549d141$export$7dacb05d26466c3 = $lCzvA.forwardRef((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, ...triggerProps } = props;
    const context = $d52c39e93549d141$var$usePopoverContext($d52c39e93549d141$var$TRIGGER_NAME, __scopePopover);
    const popperScope = $d52c39e93549d141$var$usePopperScope(__scopePopover);
    const composedTriggerRef = (0, $ca45e6a36e8d9db0$export$c7b2cbe3552a0d05)(forwardedRef, context.triggerRef);
    const trigger = /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $ac36d1eadbf3b928$export$250ffa63cdc0d034).button, {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.open ? context.contentId : void 0,
        "data-state": $d52c39e93549d141$var$getState(context.open),
        ...triggerProps,
        ref: composedTriggerRef,
        onClick: (0, $7c9f5a9a17eecc04$export$b9ecd428b558ff10)(props.onClick, context.onOpenToggle)
    });
    return context.hasCustomAnchor ? trigger : /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($3bc57394c2afda2a$export$b688253958b8dfe7, {
        asChild: true,
        ...popperScope,
        children: trigger
    });
});
$d52c39e93549d141$export$7dacb05d26466c3.displayName = $d52c39e93549d141$var$TRIGGER_NAME;
var $d52c39e93549d141$var$PORTAL_NAME = "PopoverPortal";
var [$d52c39e93549d141$var$PortalProvider, $d52c39e93549d141$var$usePortalContext] = $d52c39e93549d141$var$createPopoverContext($d52c39e93549d141$var$PORTAL_NAME, {
    forceMount: void 0
});
var $d52c39e93549d141$export$dd679ffb4362d2d4 = (props)=>{
    const { __scopePopover: __scopePopover, forceMount: forceMount, children: children, container: container } = props;
    const context = $d52c39e93549d141$var$usePopoverContext($d52c39e93549d141$var$PORTAL_NAME, __scopePopover);
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($d52c39e93549d141$var$PortalProvider, {
        scope: __scopePopover,
        forceMount: forceMount,
        children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $cbca32552b7e9adc$export$99c2b779aa4e8b8b), {
            present: forceMount || context.open,
            children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $71b14dad088b6acb$export$602eac185826482c), {
                asChild: true,
                container: container,
                children: children
            })
        })
    });
};
$d52c39e93549d141$export$dd679ffb4362d2d4.displayName = $d52c39e93549d141$var$PORTAL_NAME;
var $d52c39e93549d141$var$CONTENT_NAME = "PopoverContent";
var $d52c39e93549d141$export$d7e1f420b25549ff = $lCzvA.forwardRef((props, forwardedRef)=>{
    const portalContext = $d52c39e93549d141$var$usePortalContext($d52c39e93549d141$var$CONTENT_NAME, props.__scopePopover);
    const { forceMount: forceMount = portalContext.forceMount, ...contentProps } = props;
    const context = $d52c39e93549d141$var$usePopoverContext($d52c39e93549d141$var$CONTENT_NAME, props.__scopePopover);
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $cbca32552b7e9adc$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open,
        children: context.modal ? /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($d52c39e93549d141$var$PopoverContentModal, {
            ...contentProps,
            ref: forwardedRef
        }) : /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($d52c39e93549d141$var$PopoverContentNonModal, {
            ...contentProps,
            ref: forwardedRef
        })
    });
});
$d52c39e93549d141$export$d7e1f420b25549ff.displayName = $d52c39e93549d141$var$CONTENT_NAME;
var $d52c39e93549d141$var$Slot = (0, $0d6672ff6f6b6ba8$export$e88b45bda5c13eb9)("PopoverContent.RemoveScroll");
var $d52c39e93549d141$var$PopoverContentModal = $lCzvA.forwardRef((props, forwardedRef)=>{
    const context = $d52c39e93549d141$var$usePopoverContext($d52c39e93549d141$var$CONTENT_NAME, props.__scopePopover);
    const contentRef = $lCzvA.useRef(null);
    const composedRefs = (0, $ca45e6a36e8d9db0$export$c7b2cbe3552a0d05)(forwardedRef, contentRef);
    const isRightClickOutsideRef = $lCzvA.useRef(false);
    $lCzvA.useEffect(()=>{
        const content = contentRef.current;
        if (content) return (0, $b830715829a44420$export$6e33d16126ed003c)(content);
    }, []);
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $64ab28914613351f$export$2e2bcd8739ae039), {
        as: $d52c39e93549d141$var$Slot,
        allowPinchZoom: true,
        children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($d52c39e93549d141$var$PopoverContentImpl, {
            ...props,
            ref: composedRefs,
            trapFocus: context.open,
            disableOutsidePointerEvents: true,
            onCloseAutoFocus: (0, $7c9f5a9a17eecc04$export$b9ecd428b558ff10)(props.onCloseAutoFocus, (event)=>{
                event.preventDefault();
                if (!isRightClickOutsideRef.current) context.triggerRef.current?.focus();
            }),
            onPointerDownOutside: (0, $7c9f5a9a17eecc04$export$b9ecd428b558ff10)(props.onPointerDownOutside, (event)=>{
                const originalEvent = event.detail.originalEvent;
                const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
                const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
                isRightClickOutsideRef.current = isRightClick;
            }, {
                checkForDefaultPrevented: false
            }),
            onFocusOutside: (0, $7c9f5a9a17eecc04$export$b9ecd428b558ff10)(props.onFocusOutside, (event)=>event.preventDefault(), {
                checkForDefaultPrevented: false
            })
        })
    });
});
var $d52c39e93549d141$var$PopoverContentNonModal = $lCzvA.forwardRef((props, forwardedRef)=>{
    const context = $d52c39e93549d141$var$usePopoverContext($d52c39e93549d141$var$CONTENT_NAME, props.__scopePopover);
    const hasInteractedOutsideRef = $lCzvA.useRef(false);
    const hasPointerDownOutsideRef = $lCzvA.useRef(false);
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($d52c39e93549d141$var$PopoverContentImpl, {
        ...props,
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event)=>{
            props.onCloseAutoFocus?.(event);
            if (!event.defaultPrevented) {
                if (!hasInteractedOutsideRef.current) context.triggerRef.current?.focus();
                event.preventDefault();
            }
            hasInteractedOutsideRef.current = false;
            hasPointerDownOutsideRef.current = false;
        },
        onInteractOutside: (event)=>{
            props.onInteractOutside?.(event);
            if (!event.defaultPrevented) {
                hasInteractedOutsideRef.current = true;
                if (event.detail.originalEvent.type === "pointerdown") hasPointerDownOutsideRef.current = true;
            }
            const target = event.target;
            const targetIsTrigger = context.triggerRef.current?.contains(target);
            if (targetIsTrigger) event.preventDefault();
            if (event.detail.originalEvent.type === "focusin" && hasPointerDownOutsideRef.current) event.preventDefault();
        }
    });
});
var $d52c39e93549d141$var$PopoverContentImpl = $lCzvA.forwardRef((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, trapFocus: trapFocus, onOpenAutoFocus: onOpenAutoFocus, onCloseAutoFocus: onCloseAutoFocus, disableOutsidePointerEvents: disableOutsidePointerEvents, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, ...contentProps } = props;
    const context = $d52c39e93549d141$var$usePopoverContext($d52c39e93549d141$var$CONTENT_NAME, __scopePopover);
    const popperScope = $d52c39e93549d141$var$usePopperScope(__scopePopover);
    (0, $bc475c615686ffa1$export$b7ece24a22aeda8c)();
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $0e536624ae1ddbbb$export$20e40289641fbbb6), {
        asChild: true,
        loop: true,
        trapped: trapFocus,
        onMountAutoFocus: onOpenAutoFocus,
        onUnmountAutoFocus: onCloseAutoFocus,
        children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $98ca9e23110fdc94$export$177fb62ff3ec1f22), {
            asChild: true,
            disableOutsidePointerEvents: disableOutsidePointerEvents,
            onInteractOutside: onInteractOutside,
            onEscapeKeyDown: onEscapeKeyDown,
            onPointerDownOutside: onPointerDownOutside,
            onFocusOutside: onFocusOutside,
            onDismiss: ()=>context.onOpenChange(false),
            deferPointerDownOutside: true,
            children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($3bc57394c2afda2a$export$7c6e2c02157bb7d2, {
                "data-state": $d52c39e93549d141$var$getState(context.open),
                role: "dialog",
                id: context.contentId,
                ...popperScope,
                ...contentProps,
                ref: forwardedRef,
                style: {
                    ...contentProps.style,
                    "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                    "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                    "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                    "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                    "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
            })
        })
    });
});
var $d52c39e93549d141$var$CLOSE_NAME = "PopoverClose";
var $d52c39e93549d141$export$d6ac43ebaa40d53e = $lCzvA.forwardRef((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, ...closeProps } = props;
    const context = $d52c39e93549d141$var$usePopoverContext($d52c39e93549d141$var$CLOSE_NAME, __scopePopover);
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $ac36d1eadbf3b928$export$250ffa63cdc0d034).button, {
        type: "button",
        ...closeProps,
        ref: forwardedRef,
        onClick: (0, $7c9f5a9a17eecc04$export$b9ecd428b558ff10)(props.onClick, ()=>context.onOpenChange(false))
    });
});
$d52c39e93549d141$export$d6ac43ebaa40d53e.displayName = $d52c39e93549d141$var$CLOSE_NAME;
var $d52c39e93549d141$var$ARROW_NAME = "PopoverArrow";
var $d52c39e93549d141$export$3152841115e061b2 = $lCzvA.forwardRef((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, ...arrowProps } = props;
    const popperScope = $d52c39e93549d141$var$usePopperScope(__scopePopover);
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($3bc57394c2afda2a$export$21b07c8f274aebd5, {
        ...popperScope,
        ...arrowProps,
        ref: forwardedRef
    });
});
$d52c39e93549d141$export$3152841115e061b2.displayName = $d52c39e93549d141$var$ARROW_NAME;
function $d52c39e93549d141$var$getState(open) {
    return open ? "open" : "closed";
}
var $d52c39e93549d141$export$be92b6f5f03c0fe9 = $d52c39e93549d141$export$5b6b19405a83ff9d;
var $d52c39e93549d141$export$b688253958b8dfe7 = $d52c39e93549d141$export$96e5381f42521a79;
var $d52c39e93549d141$export$41fb9f06171c75f4 = $d52c39e93549d141$export$7dacb05d26466c3;
var $d52c39e93549d141$export$602eac185826482c = $d52c39e93549d141$export$dd679ffb4362d2d4;
var $d52c39e93549d141$export$7c6e2c02157bb7d2 = $d52c39e93549d141$export$d7e1f420b25549ff;
var $d52c39e93549d141$export$f39c2d165cd861fe = $d52c39e93549d141$export$d6ac43ebaa40d53e;
var $d52c39e93549d141$export$21b07c8f274aebd5 = $d52c39e93549d141$export$3152841115e061b2;


"use client";
//#region src/components/Dropdown/index.jsx
var $4894604720ca08c8$export$2e2bcd8739ae039 = ({ children: o, className: s, defaultOpen: c, onOpenChange: l, backdrop: u, backdropClass: d })=>{
    let [f, p] = (0, $lCzvA.useState)(c), m = typeof l == "function", h = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-Dropdown relative w-fit *:data-radix-popper-content-wrapper:absolute!": !0,
        "z-2": f,
        [s]: s
    }), g = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-DropdownBackdrop fixed left-0 top-0 bg-black/40 w-screen h-screen backdrop-blur-lg": !0,
        [d]: d
    });
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
        className: h,
        "data-testid": "sash-dropdown",
        children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)($d52c39e93549d141$export$be92b6f5f03c0fe9, {
            defaultOpen: m ? void 0 : c,
            open: m ? c : void 0,
            onOpenChange: (e)=>{
                m ? l(e) : p(e);
            },
            children: [
                o,
                f && u && (0, $dAQd3.createPortal)(/* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                    className: g,
                    "data-testid": "sash-dropdown-backdrop"
                }), document.body)
            ]
        })
    });
};




"use client";
//#region src/components/Dropdown/Content/index.jsx
var $833f5a446a1fbfcc$export$2e2bcd8739ae039 = ({ position: r = "bottom", align: i = "center", className: a, offset: o = 10, onOutsideClick: s, children: c, ...l })=>{
    let u = typeof s == "function", d = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-DropdownContent border border-neutral-200 bg-white p-3 w-max hidden data-[state=open]:block": !0,
        [a]: a
    });
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($d52c39e93549d141$export$7c6e2c02157bb7d2, {
        "data-testid": "sash-dropdown-content",
        className: d,
        align: i,
        side: r,
        sideOffset: o,
        onInteractOutside: u ? s : void 0,
        id: void 0,
        forceMount: !0,
        ...l,
        children: c
    });
};
$833f5a446a1fbfcc$export$2e2bcd8739ae039.displayName = "DropdownContent";




"use client";
//#region src/components/Dropdown/Item/index.jsx
var $e007c3baa5a03cf7$export$2e2bcd8739ae039 = ({ children: r, className: i })=>{
    let a = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-Dropdown-Item": !0,
        [i]: i
    });
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
        className: a,
        "data-testid": "sash-dropdown-item",
        children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($d52c39e93549d141$export$f39c2d165cd861fe, {
            asChild: !0,
            children: r
        })
    });
};
$e007c3baa5a03cf7$export$2e2bcd8739ae039.displayName = "DropdownItem";




"use client";
//#region src/components/Dropdown/Trigger/index.jsx
var $159cb66f654a3a1c$export$2e2bcd8739ae039 = ({ children: r, className: i, ...a })=>{
    let o = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-DropdownTrigger peer relative flex flex-wrap items-center cursor-pointer": !0,
        [i]: i
    });
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($d52c39e93549d141$export$41fb9f06171c75f4, {
        className: o,
        "aria-controls": void 0,
        ...a,
        children: r
    });
};
$159cb66f654a3a1c$export$2e2bcd8739ae039.displayName = "DropdownTrigger";




var $lCzvA = parcelRequire("lCzvA");




var $lCzvA = parcelRequire("lCzvA");
"use client";
//#region src/IsRestoringProvider.ts
const $f4fe34ff21b5efe3$var$IsRestoringContext = $lCzvA.createContext(false);
/**
* If you are using `PersistQueryClientProvider`, you can also use the `useIsRestoring` hook alongside it to
* check if a restore is currently in progress. `useQuery` and friends also check this internally to avoid
* race conditions between the restore and mounting queries.
* @returns `true` while a persisted client is being restored, `false` otherwise.
*/ const $f4fe34ff21b5efe3$export$4da0178d6b5f553 = ()=>$lCzvA.useContext($f4fe34ff21b5efe3$var$IsRestoringContext);
/**
* The Provider that `PersistQueryClientProvider` uses to signal whether a persisted client is currently
* being restored, read by `useIsRestoring`.
*/ const $f4fe34ff21b5efe3$export$593807d4e94f9621 = $f4fe34ff21b5efe3$var$IsRestoringContext.Provider;



var $lCzvA = parcelRequire("lCzvA");

"use client";
//#region src/QueryErrorResetBoundary.tsx
/**
* Creates the value shared through the boundary's context, which tracks whether a reset was
* requested.
* @returns The `clearReset`, `isReset`, and `reset` functions of the boundary.
*/ function $f1dae1b0f52bf3af$var$createValue() {
    let isReset = false;
    return {
        /**
		* Clears the reset state, so queries know not to try again until the boundary is reset again.
		*/ clearReset: ()=>{
            isReset = false;
        },
        /**
		* Resets any query errors within the boundary, so queries know they can try again.
		*/ reset: ()=>{
            isReset = true;
        },
        /**
		* Returns whether the boundary has been reset and not yet cleared.
		* @returns `true` if the boundary has been reset and not yet cleared.
		*/ isReset: ()=>{
            return isReset;
        }
    };
}
const $f1dae1b0f52bf3af$var$QueryErrorResetBoundaryContext = $lCzvA.createContext($f1dae1b0f52bf3af$var$createValue());
/**
* This hook will reset any query errors within the closest `QueryErrorResetBoundary`. If there is no boundary
* defined it will reset them globally.
* @returns The boundary's {@link QueryErrorResetBoundaryValue}.
* @example
* ```tsx
* import { ErrorBoundary } from 'react-error-boundary'
* import { useQueryErrorResetBoundary } from '@tanstack/react-query'
*
* function App({ children }: { children: React.ReactNode }) {
*   const { reset } = useQueryErrorResetBoundary()
*
*   return (
*     <ErrorBoundary
*       onReset={reset}
*       fallbackRender={({ resetErrorBoundary }) => (
*         <div>
*           There was an error!
*           <button onClick={() => resetErrorBoundary()}>Try again</button>
*         </div>
*       )}
*     >
*       {children}
*     </ErrorBoundary>
*   )
* }
* ```
*/ const $f1dae1b0f52bf3af$export$50dfac555130cafd = ()=>$lCzvA.useContext($f1dae1b0f52bf3af$var$QueryErrorResetBoundaryContext);
/**
* When using `suspense` or `throwOnError` in your queries, you need a way to let queries know that you want to
* try again when re-rendering after some error occurred. With the `QueryErrorResetBoundary` component you can
* reset any query errors within the boundaries of the component.
* @param props - The `children` to render.
* @returns The `children`, rendered as-is, or called with the boundary's {@link QueryErrorResetBoundaryValue}
* if `children` is a function.
* @example
* ```tsx
* import { ErrorBoundary } from 'react-error-boundary'
* import { QueryErrorResetBoundary } from '@tanstack/react-query'
*
* function App() {
*   return (
*     <QueryErrorResetBoundary>
*       {({ reset }) => (
*         <ErrorBoundary
*           onReset={reset}
*           fallbackRender={({ resetErrorBoundary }) => (
*             <div>
*               There was an error!
*               <button onClick={() => resetErrorBoundary()}>Try again</button>
*             </div>
*           )}
*         >
*           <Page />
*         </ErrorBoundary>
*       )}
*     </QueryErrorResetBoundary>
*   )
* }
* ```
*/ const $f1dae1b0f52bf3af$export$ddb9962d870f2330 = ({ children: children })=>{
    const [value] = $lCzvA.useState(()=>$f1dae1b0f52bf3af$var$createValue());
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($f1dae1b0f52bf3af$var$QueryErrorResetBoundaryContext.Provider, {
        value: value,
        children: typeof children === "function" ? children(value) : children
    });
};



var $lCzvA = parcelRequire("lCzvA");

"use client";
//#region src/errorBoundaryUtils.ts
/**
* Turns off `retryOnMount` for a query that throws its errors (with `suspense` or `throwOnError`),
* unless the error boundary has been reset, so a remount doesn't retry the failed query before the
* user resets the boundary. Mutates the options.
* @param options - The defaulted query options to adjust.
* @param errorResetBoundary - The value of the nearest `QueryErrorResetBoundary`.
* @param query - The query, used to evaluate a `throwOnError` function against its error.
*/ const $df219765307315d9$export$ae8adb3de3d77633 = (options, errorResetBoundary, query)=>{
    const throwOnError = query?.state.status === "error" && typeof options.throwOnError === "function" ? (0, $d14a518110a15ba8$export$2072f68e6c3507cf)(options.throwOnError, [
        query.state.error,
        query
    ]) : options.throwOnError;
    if (options.suspense || throwOnError) {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
/**
* Clears the reset state of the error boundary after the component mounts, so later errors are
* thrown to the boundary again.
* @param errorResetBoundary - The value of the nearest `QueryErrorResetBoundary`.
*/ const $df219765307315d9$export$b2b17ca3a1fb0229 = (errorResetBoundary)=>{
    $lCzvA.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
/**
* Checks whether the query error should be thrown to the nearest error boundary: the query errored
* and isn't fetching, the boundary hasn't been reset, and either `suspense` is enabled with no data
* or `throwOnError` says so.
* @param params - The observer `result`, the `errorResetBoundary`, the `throwOnError` option, the
* `query`, and the `suspense` option.
* @returns `true` if the error should be thrown.
*/ const $df219765307315d9$export$1fbcf724762d607 = ({ result: result, errorResetBoundary: errorResetBoundary, throwOnError: throwOnError, query: query, suspense: suspense })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && query && (suspense && result.data === void 0 || (0, $d14a518110a15ba8$export$2072f68e6c3507cf)(throwOnError, [
        result.error,
        query
    ]));
};


//#region src/suspense.ts
/**
* The default `throwOnError` of the suspense hooks: throws the error to the nearest error boundary
* only if the query has no data to show.
* @param _error - The error of the query. Unused.
* @param query - The query that errored.
* @returns `true` if the query has no data.
*/ const $6ce361a7fd4a0d4b$export$8bed2f8d02206063 = (_error, query)=>query.state.data === void 0;
/**
* Raises `staleTime` and a numeric `gcTime` to at least 1000ms when `suspense` is enabled, so a
* component that remounts after suspending doesn't refetch right away or find the query garbage
* collected. A `'static'` `staleTime` is kept as is. Mutates the options.
* @param defaultedOptions - The defaulted query options to adjust.
*/ const $6ce361a7fd4a0d4b$export$274d2a1db5a20c09 = (defaultedOptions)=>{
    if (defaultedOptions.suspense) {
        const MIN_SUSPENSE_TIME_MS = 1e3;
        const clamp = (value)=>value === "static" ? value : Math.max(value ?? MIN_SUSPENSE_TIME_MS, MIN_SUSPENSE_TIME_MS);
        const originalStaleTime = defaultedOptions.staleTime;
        defaultedOptions.staleTime = typeof originalStaleTime === "function" ? (...args)=>clamp(originalStaleTime(...args)) : clamp(originalStaleTime);
        if (typeof defaultedOptions.gcTime === "number") defaultedOptions.gcTime = Math.max(defaultedOptions.gcTime, MIN_SUSPENSE_TIME_MS);
    }
};
/**
* Checks whether a query should suspend: `suspense` is enabled and the result is still `pending`.
* @param defaultedOptions - The defaulted query options, if any.
* @param result - The current result of the observer.
* @returns `true` if the component should suspend.
*/ const $6ce361a7fd4a0d4b$export$88d3586dfed64df9 = (defaultedOptions, result)=>defaultedOptions?.suspense && result.isPending;
/**
* Fetches the query for a suspending component, without affecting the observer's own result. If
* the fetch fails, the reset state of the error boundary is cleared, so the error is thrown to it.
* @param defaultedOptions - The defaulted query options to fetch with.
* @param observer - The observer of the query.
* @param errorResetBoundary - The value of the nearest `QueryErrorResetBoundary`.
* @returns A promise that resolves once the fetch settles. It never rejects.
*/ const $6ce361a7fd4a0d4b$export$defdc11a9c9acfcf = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).catch(()=>{
        errorResetBoundary.clearReset();
    });



var $lCzvA = parcelRequire("lCzvA");

"use client";
//#region src/useBaseQuery.ts
/**
* Base implementation shared by `useQuery`, `useInfiniteQuery`, `useSuspenseQuery`, and
* `useSuspenseInfiniteQuery`.
* @param options - The options passed to the calling hook.
* @param Observer - The observer class from query-core (`QueryObserver` or
* `InfiniteQueryObserver`).
* @param queryClient - Use this to use a custom `QueryClient`. Otherwise, the one from the nearest
* context will be used.
* @returns The query result, tracking which properties are read unless `notifyOnChangeProps` is
* set.
* @throws {Error} If `options` is not an object (outside production), or the query error when it should be
* thrown to the nearest error boundary (see `throwOnError`). While suspending, it throws a promise instead.
*/ function $86febd964ff66927$export$fff0865807e996c5(options, Observer, queryClient) {
    const isRestoring = (0, $f4fe34ff21b5efe3$export$4da0178d6b5f553)();
    const errorResetBoundary = (0, $f1dae1b0f52bf3af$export$50dfac555130cafd)();
    const client = (0, $6547bc15d23e8c33$export$22e77b9572c4fded)(queryClient);
    const defaultedOptions = client.defaultQueryOptions(options);
    const query = client.getQueryCache().get(defaultedOptions.queryHash);
    const subscribed = options.subscribed !== false;
    defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : subscribed ? "optimistic" : void 0;
    (0, $6ce361a7fd4a0d4b$export$274d2a1db5a20c09)(defaultedOptions);
    (0, $df219765307315d9$export$ae8adb3de3d77633)(defaultedOptions, errorResetBoundary, query);
    (0, $df219765307315d9$export$b2b17ca3a1fb0229)(errorResetBoundary);
    const [observer] = $lCzvA.useState(()=>new Observer(client, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    const shouldSubscribe = !isRestoring && subscribed;
    $lCzvA.useSyncExternalStore($lCzvA.useCallback((onStoreChange)=>{
        const unsubscribe = shouldSubscribe ? observer.subscribe((0, $7214f1c3bd8e29e6$export$520687f44db6e1ab).batchCalls(onStoreChange)) : (0, $d14a518110a15ba8$export$8793edee2d425525);
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        shouldSubscribe
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $lCzvA.useEffect(()=>{
        observer.setOptions(defaultedOptions);
    }, [
        defaultedOptions,
        observer
    ]);
    if ((0, $6ce361a7fd4a0d4b$export$88d3586dfed64df9)(defaultedOptions, result)) throw (0, $6ce361a7fd4a0d4b$export$defdc11a9c9acfcf)(defaultedOptions, observer, errorResetBoundary);
    if ((0, $df219765307315d9$export$1fbcf724762d607)({
        result: result,
        errorResetBoundary: errorResetBoundary,
        throwOnError: defaultedOptions.throwOnError,
        query: query,
        suspense: defaultedOptions.suspense
    })) throw result.error;
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}









//#region src/queryObserver.ts
/**
* A `QueryObserver` watches a single query in the `QueryCache` and computes a
* `QueryObserverResult` from its state, recomputing and notifying subscribers
* whenever the underlying query (or the observer's options) changes. It is
* the primitive that framework adapters (e.g. `useQuery`) build their hooks
* on top of, but it can also be used directly to observe and switch between
* queries outside of any framework.
* @example
* ```ts
* const observer = new QueryObserver(queryClient, {
*   queryKey: ['posts'],
*   queryFn: fetchPosts,
* })
*
* const unsubscribe = observer.subscribe((result) => {
*   console.log(result.data)
* })
* ```
*/ var $a0cc437d7654e426$export$a06cf8c0066f0d4c = class extends (0, $b384e87d93fd3677$export$d26086b469ecdbcc) {
    #client;
    #currentQuery = void 0;
    #currentQueryInitialState = void 0;
    #currentResult = void 0;
    #currentResultState;
    #currentResultOptions;
    #selectError;
    #selectFn;
    #selectResult;
    #lastQueryWithDefinedData;
    #staleTimeoutId;
    #refetchIntervalId;
    #currentRefetchInterval;
    #trackedProps = /* @__PURE__ */ new Set();
    constructor(client, options){
        super();
        this.options = options;
        this.#client = client;
        this.#selectError = null;
        this.bindMethods();
        this.setOptions(options);
    }
    /**
	* Binds the methods of the result (`refetch`) to the observer, so they keep working when destructured
	* from it. Subclasses override it to bind their own result methods as well.
	*/ bindMethods() {
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            this.#currentQuery.addObserver(this);
            if ($a0cc437d7654e426$var$shouldFetchOnMount(this.#currentQuery, this.options)) this.#executeFetch();
            else this.updateResult();
            this.#updateTimers();
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    /**
	* Returns whether the observed query is currently stale and configured
	* (via the `refetchOnReconnect` option) to refetch when the network
	* reconnects.
	* @returns `true` if the observer should refetch the query on reconnect.
	*/ shouldFetchOnReconnect() {
        return $a0cc437d7654e426$var$shouldFetchOn(this.#currentQuery, this.options, this.options.refetchOnReconnect);
    }
    /**
	* Returns whether the observed query is currently stale and configured
	* (via the `refetchOnWindowFocus` option) to refetch when the window
	* regains focus.
	* @returns `true` if the observer should refetch the query on window focus.
	*/ shouldFetchOnWindowFocus() {
        return $a0cc437d7654e426$var$shouldFetchOn(this.#currentQuery, this.options, this.options.refetchOnWindowFocus);
    }
    /**
	* Stops observing the current query: clears all listeners, cancels the
	* stale and refetch-interval timers, and removes this observer from the
	* query it was observing.
	*/ destroy() {
        this.listeners = /* @__PURE__ */ new Set();
        this.#clearStaleTimeout();
        this.#clearRefetchInterval();
        this.#currentQuery.removeObserver(this);
    }
    /**
	* Updates the observer's options. This will re-resolve the query being
	* observed (switching to a different query if the `queryKey` changed),
	* trigger a fetch if the new options require one and the observer has
	* subscribers, recompute the current result, and reschedule the stale and
	* refetch-interval timers as needed.
	* @param options - The new observer options. They are defaulted with {@link
	* QueryClient#defaultQueryOptions} before being applied.
	* @throws {Error} If `enabled` is neither a boolean nor a function.
	* @example
	* ```ts
	* observer.setOptions({ queryKey: ['posts', 1], queryFn: () => fetchPost(1) })
	* // later: switch to a different query, reusing the same observer
	* observer.setOptions({ queryKey: ['posts', 2], queryFn: () => fetchPost(2) })
	* ```
	*/ setOptions(options) {
        const prevOptions = this.options;
        const prevQuery = this.#currentQuery;
        this.options = this.#client.defaultQueryOptions(options);
        if (this.options.enabled !== void 0 && typeof this.options.enabled !== "boolean" && typeof this.options.enabled !== "function" && typeof (0, $d14a518110a15ba8$export$e36731f6aa6a4362)(this.options.enabled, this.#currentQuery) !== "boolean") throw new Error("Expected enabled to be a boolean or a callback that returns a boolean");
        this.#updateQuery();
        this.#currentQuery.setOptions(this.options);
        if (prevOptions._defaulted && !(0, $d14a518110a15ba8$export$3e67810a3f0e9f1c)(this.options, prevOptions)) this.#client.getQueryCache().notify({
            type: "observerOptionsUpdated",
            query: this.#currentQuery,
            observer: this
        });
        const mounted = this.hasListeners();
        if (mounted && $a0cc437d7654e426$var$shouldFetchOptionally(this.#currentQuery, prevQuery, this.options, prevOptions)) this.#executeFetch();
        this.updateResult();
        if (mounted && (this.#currentQuery !== prevQuery || (0, $d14a518110a15ba8$export$e36731f6aa6a4362)(this.options.enabled, this.#currentQuery) !== (0, $d14a518110a15ba8$export$e36731f6aa6a4362)(prevOptions.enabled, this.#currentQuery) || (0, $d14a518110a15ba8$export$e36731f6aa6a4362)(this.options.staleTime, this.#currentQuery) !== (0, $d14a518110a15ba8$export$e36731f6aa6a4362)(prevOptions.staleTime, this.#currentQuery))) this.#updateStaleTimeout();
        const nextRefetchInterval = this.#computeRefetchInterval();
        if (mounted && (this.#currentQuery !== prevQuery || (0, $d14a518110a15ba8$export$e36731f6aa6a4362)(this.options.enabled, this.#currentQuery) !== (0, $d14a518110a15ba8$export$e36731f6aa6a4362)(prevOptions.enabled, this.#currentQuery) || nextRefetchInterval !== this.#currentRefetchInterval)) this.#updateRefetchInterval(nextRefetchInterval);
    }
    /**
	* Computes the result the observer would produce for the given (already-defaulted) options
	* right now, building the underlying `Query` if it doesn't exist yet, without waiting for a
	* subscription callback. Called by framework adapters on every render (e.g. `useQuery`) so the
	* returned value is available synchronously, ahead of `setOptions` triggering an actual fetch.
	* @param options - The defaulted observer options to compute the result for.
	* @returns The result for the given options.
	*/ getOptimisticResult(options) {
        const query = this.#client.getQueryCache().build(this.#client, options);
        const result = this.createResult(query, options);
        if (!(0, $d14a518110a15ba8$export$3e67810a3f0e9f1c)(this.getCurrentResult(), result)) {
            this.#currentResult = result;
            this.#currentResultOptions = this.options;
            this.#currentResultState = this.#currentQuery.state;
        }
        return result;
    }
    /**
	* Returns the most recently computed `QueryObserverResult` for the
	* observed query. This is a point-in-time read; to be notified of updates
	* as they happen, subscribe to the observer instead (its inherited
	* `subscribe` method).
	* @returns The observer's latest result.
	* @example
	* ```ts
	* const result = observer.getCurrentResult()
	* console.log(result.status, result.data)
	* ```
	*/ getCurrentResult() {
        return this.#currentResult;
    }
    /**
	* Wraps a `QueryObserverResult` in a `Proxy` that records which properties are read, via
	* {@link QueryObserver#trackProp} (and an optional `onPropTracked` callback). Used by framework
	* adapters when `notifyOnChangeProps` is not set, to implement its default "only re-render on
	* properties you actually read" behavior.
	* @param result - The result to wrap.
	* @param onPropTracked - Called with the name of each property that is read.
	* @returns A proxy of `result` that tracks property reads.
	*/ trackResult(result, onPropTracked) {
        return new Proxy(result, {
            get: (target, key)=>{
                this.trackProp(key);
                onPropTracked?.(key);
                return Reflect.get(target, key);
            }
        });
    }
    /**
	* Records that the given `QueryObserverResult` property was read, so a subsequent update only
	* notifies this observer if a tracked property actually changed. Normally called indirectly via
	* {@link QueryObserver#trackResult}'s proxy; exposed directly for adapters that track property
	* access themselves (e.g. through their own reactivity system) instead of via the proxy.
	* @param key - The name of the property that was read.
	*/ trackProp(key) {
        this.#trackedProps.add(key);
    }
    /**
	* Returns the `Query` instance this observer is currently observing.
	* @returns The observed query.
	*/ getCurrentQuery() {
        return this.#currentQuery;
    }
    /**
	* Refetches the observed query and returns a promise that resolves with
	* the resulting `QueryObserverResult`.
	* @param options - Set `cancelRefetch` to `false` to keep a running fetch instead of cancelling
	* it, and `throwOnError` to `true` to reject when the refetch fails.
	* @returns A promise that resolves with the result after the refetch.
	* @example
	* ```ts
	* const result = await observer.refetch({ cancelRefetch: false })
	* console.log(result.data)
	* ```
	*/ refetch({ ...options } = {}) {
        return this.fetch({
            ...options
        });
    }
    /**
	* Fetches a query defined by the given options without affecting this
	* observer's own tracked query or result, and returns a promise that
	* resolves with the `QueryObserverResult` for that fetch. This is useful
	* for prefetching data that another observer (e.g. a query about to be
	* navigated to) will need, ahead of time.
	* @param options - The observer options of the query to fetch.
	* @returns A promise that resolves with the result for the fetched query.
	* @example
	* ```ts
	* const result = await observer.fetchOptimistic({
	*   queryKey: ['posts', 2],
	*   queryFn: () => fetchPost(2),
	* })
	* console.log(result.data)
	* ```
	*/ fetchOptimistic(options) {
        const defaultedOptions = this.#client.defaultQueryOptions(options);
        const query = this.#client.getQueryCache().build(this.#client, defaultedOptions);
        let unsubscribe = ()=>{};
        let resolveEarly;
        const cachePromise = new Promise((resolve)=>{
            resolveEarly = resolve;
            unsubscribe = this.#client.getQueryCache().subscribe((event)=>{
                if (event.type === "updated" && event.query.queryHash === query.queryHash && query.state.data !== void 0) {
                    unsubscribe();
                    resolve(this.createResult(query, defaultedOptions));
                }
            });
        });
        return Promise.race([
            query.fetch(defaultedOptions).then(()=>{
                const result = this.createResult(query, defaultedOptions);
                resolveEarly?.(result);
                return result;
            }).finally(()=>{
                unsubscribe();
            }),
            cachePromise
        ]);
    }
    /**
	* Fetches the observed query and updates the result once the fetch settles. Used by `refetch` and,
	* in `InfiniteQueryObserver`, to fetch more pages.
	* @param fetchOptions - Options for this fetch. `cancelRefetch` defaults to `true`.
	* @returns A promise that resolves with the updated result.
	*/ fetch(fetchOptions) {
        return this.#executeFetch({
            ...fetchOptions,
            cancelRefetch: fetchOptions.cancelRefetch ?? true
        }).then(()=>{
            this.updateResult();
            return this.#currentResult;
        });
    }
    #executeFetch(fetchOptions) {
        this.#updateQuery();
        let promise = this.#currentQuery.fetch(this.options, fetchOptions);
        if (!fetchOptions?.throwOnError) promise = promise.catch((0, $d14a518110a15ba8$export$8793edee2d425525));
        return promise;
    }
    #shouldScheduleTimer(timeout) {
        return !(0, $775258cc62ff40fe$export$6acf61af03e62db)() && (0, $d14a518110a15ba8$export$e36731f6aa6a4362)(this.options.enabled, this.#currentQuery) !== false && (0, $d14a518110a15ba8$export$e539f754e934e270)(timeout);
    }
    #updateStaleTimeout() {
        this.#clearStaleTimeout();
        const staleTime = (0, $d14a518110a15ba8$export$e36731f6aa6a4362)(this.options.staleTime, this.#currentQuery);
        if (this.#currentResult.isStale || !this.#shouldScheduleTimer(staleTime)) return;
        const timeout = (0, $d14a518110a15ba8$export$811b83d62bcf47f0)(this.#currentResult.dataUpdatedAt, staleTime) + 1;
        this.#staleTimeoutId = (0, $0aef9398d65c5c0f$export$94a2700736e69372).setTimeout(()=>{
            if (!this.#currentResult.isStale) this.updateResult();
        }, timeout);
    }
    #computeRefetchInterval() {
        return (0, $d14a518110a15ba8$export$e36731f6aa6a4362)(this.options.refetchInterval, this.#currentQuery) ?? false;
    }
    #updateRefetchInterval(nextInterval) {
        this.#clearRefetchInterval();
        this.#currentRefetchInterval = nextInterval;
        if (this.#currentRefetchInterval === 0 || !this.#shouldScheduleTimer(this.#currentRefetchInterval)) return;
        this.#refetchIntervalId = (0, $0aef9398d65c5c0f$export$94a2700736e69372).setInterval(()=>{
            if (this.options.refetchIntervalInBackground || (0, $b2740e487a8e9702$export$6bf54661be5b02cf).isFocused()) this.#executeFetch();
        }, this.#currentRefetchInterval);
    }
    #updateTimers() {
        this.#updateStaleTimeout();
        this.#updateRefetchInterval(this.#computeRefetchInterval());
    }
    #clearStaleTimeout() {
        if (this.#staleTimeoutId !== void 0) {
            (0, $0aef9398d65c5c0f$export$94a2700736e69372).clearTimeout(this.#staleTimeoutId);
            this.#staleTimeoutId = void 0;
        }
    }
    #clearRefetchInterval() {
        if (this.#refetchIntervalId !== void 0) {
            (0, $0aef9398d65c5c0f$export$94a2700736e69372).clearInterval(this.#refetchIntervalId);
            this.#refetchIntervalId = void 0;
        }
    }
    /**
	* Computes the result for a query and options from the query's state, applying `select`,
	* `placeholderData`, and the derived flags. Subclasses override it to add their own fields.
	* @param query - The query to compute the result for.
	* @param options - The observer options to compute the result with.
	* @returns The computed result.
	*/ createResult(query, options) {
        const prevQuery = this.#currentQuery;
        const prevOptions = this.options;
        const prevResult = this.#currentResult;
        const prevResultState = this.#currentResultState;
        const prevResultOptions = this.#currentResultOptions;
        const queryInitialState = query !== prevQuery ? query.state : this.#currentQueryInitialState;
        const { state: state } = query;
        let newState = {
            ...state
        };
        let isPlaceholderData = false;
        let data;
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && $a0cc437d7654e426$var$shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && $a0cc437d7654e426$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) newState = {
                ...newState,
                ...(0, $c1ac73663b6431ea$export$f3df9013f2b58bce)(state.data, query.options)
            };
            if (options._optimisticResults === "isRestoring") newState.fetchStatus = "idle";
        }
        let { error: error, errorUpdatedAt: errorUpdatedAt, status: status } = newState;
        data = newState.data;
        let skipSelect = false;
        if (options.placeholderData !== void 0 && data === void 0 && status === "pending") {
            let placeholderData;
            if (prevResult?.isPlaceholderData && options.placeholderData === prevResultOptions?.placeholderData) {
                placeholderData = prevResult.data;
                skipSelect = true;
            } else placeholderData = typeof options.placeholderData === "function" ? options.placeholderData(this.#lastQueryWithDefinedData?.state.data, this.#lastQueryWithDefinedData) : options.placeholderData;
            if (placeholderData !== void 0) {
                status = "success";
                data = (0, $d14a518110a15ba8$export$17619bac5b909b23)(prevResult?.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if (options.select && data !== void 0 && !skipSelect) {
            if (prevResult && data === prevResultState?.data && options.select === this.#selectFn) data = this.#selectResult;
            else try {
                this.#selectFn = options.select;
                data = options.select(data);
                data = (0, $d14a518110a15ba8$export$17619bac5b909b23)(prevResult?.data, data, options);
                this.#selectResult = data;
                this.#selectError = null;
            } catch (selectError) {
                this.#selectError = selectError;
            }
        } else if (data === void 0) this.#selectError = null;
        if (this.#selectError) {
            error = this.#selectError;
            data = this.#selectResult;
            errorUpdatedAt = Date.now();
            status = "error";
            isPlaceholderData = false;
        }
        const isFetching = newState.fetchStatus === "fetching";
        const isPending = status === "pending";
        const isError = status === "error";
        const isLoading = isPending && isFetching;
        const hasData = data !== void 0;
        return {
            status: status,
            fetchStatus: newState.fetchStatus,
            isPending: isPending,
            isSuccess: status === "success",
            isError: isError,
            isInitialLoading: isLoading,
            isLoading: isLoading,
            data: data,
            dataUpdatedAt: newState.dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: newState.fetchFailureCount,
            failureReason: newState.fetchFailureReason,
            errorUpdateCount: newState.errorUpdateCount,
            isFetched: query.isFetched(),
            isFetchedAfterMount: newState.dataUpdateCount > queryInitialState.dataUpdateCount || newState.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && !isPending,
            isLoadingError: isError && !hasData,
            isPaused: newState.fetchStatus === "paused",
            isPlaceholderData: isPlaceholderData,
            isRefetchError: isError && hasData,
            isStale: $a0cc437d7654e426$var$isStale(query, options),
            refetch: this.refetch,
            isEnabled: (0, $d14a518110a15ba8$export$e36731f6aa6a4362)(options.enabled, query) !== false
        };
    }
    /**
	* Recomputes and stores the current result from the current query/options, notifying listeners
	* if it changed. Framework adapters call this right after subscribing to make sure no query
	* update was missed in the gap between creating the observer and subscribing to it.
	*/ updateResult() {
        const prevResult = this.#currentResult;
        const nextResult = this.createResult(this.#currentQuery, this.options);
        this.#currentResultState = this.#currentQuery.state;
        this.#currentResultOptions = this.options;
        if (this.#currentResultState.data !== void 0) this.#lastQueryWithDefinedData = this.#currentQuery;
        if ((0, $d14a518110a15ba8$export$3e67810a3f0e9f1c)(nextResult, prevResult)) return;
        this.#currentResult = nextResult;
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps: notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === "function" ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === "all" || !notifyOnChangePropsValue && !this.#trackedProps.size) return true;
            const includedProps = new Set(notifyOnChangePropsValue ?? this.#trackedProps);
            if (this.options.throwOnError) includedProps.add("error");
            return Object.keys(this.#currentResult).some((key)=>{
                const typedKey = key;
                return this.#currentResult[typedKey] !== prevResult[typedKey] && includedProps.has(typedKey);
            });
        };
        const notifyListeners = shouldNotifyListeners();
        (0, $7214f1c3bd8e29e6$export$520687f44db6e1ab).batch(()=>{
            if (notifyListeners) this.listeners.forEach((listener)=>{
                listener(this.#currentResult);
            });
            this.#client.getQueryCache().notify({
                query: this.#currentQuery,
                type: "observerResultsUpdated"
            });
        });
    }
    #updateQuery() {
        const query = this.#client.getQueryCache().build(this.#client, this.options);
        if (query === this.#currentQuery) return;
        const prevQuery = this.#currentQuery;
        this.#currentQuery = query;
        this.#currentQueryInitialState = query.state;
        if (this.hasListeners()) {
            prevQuery?.removeObserver(this);
            query.addObserver(this);
        }
    }
    /**
	* Updates the observer's result when the observed query changes, and reschedules its timers if it
	* has listeners.
	* @internal
	*/ onQueryUpdate() {
        this.updateResult();
        if (this.hasListeners()) this.#updateTimers();
    }
};
/**
* Checks whether a query has no data yet and should do its initial load when an observer mounts.
* @param query - The query to check.
* @param options - The observer options.
* @returns `true` if the query is enabled, has no data, and isn't in an error state with
* `retryOnMount: false`.
*/ function $a0cc437d7654e426$var$shouldLoadOnMount(query, options) {
    return (0, $d14a518110a15ba8$export$e36731f6aa6a4362)(options.enabled, query) !== false && query.state.data === void 0 && !(query.state.status === "error" && (0, $d14a518110a15ba8$export$e36731f6aa6a4362)(options.retryOnMount, query) === false);
}
/**
* Checks whether a query should fetch when an observer mounts: either for its initial load, or
* because it has data and `refetchOnMount` asks for a refetch.
* @param query - The query to check.
* @param options - The observer options.
* @returns `true` if the query should fetch on mount.
*/ function $a0cc437d7654e426$var$shouldFetchOnMount(query, options) {
    return $a0cc437d7654e426$var$shouldLoadOnMount(query, options) || query.state.data !== void 0 && $a0cc437d7654e426$var$shouldFetchOn(query, options, options.refetchOnMount);
}
/**
* Checks whether a query should fetch for a `refetchOnMount`, `refetchOnWindowFocus`, or
* `refetchOnReconnect` option.
* @param query - The query to check.
* @param options - The observer options.
* @param field - The value of the option to check.
* @returns `true` if the query is enabled, not static, and the option is `'always'`, or is not
* `false` and the query is stale.
*/ function $a0cc437d7654e426$var$shouldFetchOn(query, options, field) {
    if ((0, $d14a518110a15ba8$export$e36731f6aa6a4362)(options.enabled, query) !== false && (0, $d14a518110a15ba8$export$e36731f6aa6a4362)(options.staleTime, query) !== "static") {
        const value = (0, $d14a518110a15ba8$export$e36731f6aa6a4362)(field, query);
        return value === "always" || value !== false && $a0cc437d7654e426$var$isStale(query, options);
    }
    return false;
}
/**
* Checks whether a query should fetch after the observer's options change.
* @param query - The query observed with the new options.
* @param prevQuery - The query observed with the previous options.
* @param options - The new observer options.
* @param prevOptions - The previous observer options.
* @returns `true` if the query changed or was disabled before, it isn't a suspense query in an
* error state, and it is stale.
*/ function $a0cc437d7654e426$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return (query !== prevQuery || (0, $d14a518110a15ba8$export$e36731f6aa6a4362)(prevOptions.enabled, query) === false) && (!options.suspense || query.state.status !== "error") && $a0cc437d7654e426$var$isStale(query, options);
}
/**
* Checks whether a query is stale for the given observer options.
* @param query - The query to check.
* @param options - The observer options, whose `enabled` and `staleTime` are used.
* @returns `true` if the query is enabled and its data is stale for `staleTime`.
*/ function $a0cc437d7654e426$var$isStale(query, options) {
    return (0, $d14a518110a15ba8$export$e36731f6aa6a4362)(options.enabled, query) !== false && query.isStaleByTime((0, $d14a518110a15ba8$export$e36731f6aa6a4362)(options.staleTime, query));
}


"use client";
//#region src/useQuery.ts
function $5b47d34ec35eb825$export$dd0a697e1782aedd(options, queryClient) {
    return (0, $86febd964ff66927$export$fff0865807e996c5)(options, (0, $a0cc437d7654e426$export$a06cf8c0066f0d4c), queryClient);
}




var $lCzvA = parcelRequire("lCzvA");

const $10608212fc1ea215$export$a826e754a2b6b403 = ()=>{
    const s = (0, $lCzvA.useSyncExternalStore)((0, $a2c7fde35549f4e6$export$ec068583843480e7), (0, $a2c7fde35549f4e6$export$36491da625b5403b));
    return {
        apiReady: Boolean(s.token)
    };
};






var $3bd970bfc6bd9362$export$4a9712b21c0592db = (0, $lCzvA.createContext)({
    appName: "",
    baseUrl: void 0
}), $3bd970bfc6bd9362$var$l, $3bd970bfc6bd9362$export$9c999f676138fa5b = (e)=>{
    $3bd970bfc6bd9362$var$l = e;
}, $3bd970bfc6bd9362$export$f654b28f82155665 = ()=>$3bd970bfc6bd9362$var$l ?? window.REACT_APP_API_URL, $3bd970bfc6bd9362$export$6414ebbbfff99d4c = ({ appName: e, baseUrl: t, children: r })=>($3bd970bfc6bd9362$export$9c999f676138fa5b(t), /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($3bd970bfc6bd9362$export$4a9712b21c0592db.Provider, {
        value: {
            appName: e,
            baseUrl: t
        },
        children: r
    })), $3bd970bfc6bd9362$var$p = "teamMemberImage", $3bd970bfc6bd9362$var$m = "teamMemberApplicationRoles", $3bd970bfc6bd9362$var$h = "teamMemberAppPreferences", $3bd970bfc6bd9362$export$3cae5b3ff5c106cf = async (e)=>{
    let t = `${$3bd970bfc6bd9362$export$f654b28f82155665()}/teammembers/v2/members/member/${e}/image`, { response: n } = await (0, $dc52b8907b22717f$export$24835cb787452b46)({
        url: t,
        throwOnError: !0
    }), r = await n.arrayBuffer();
    if (r.byteLength < 5e3) return null;
    let i = new Uint8Array(r), a = "";
    for(let e = 0; e < i.length; e += 32768)a += String.fromCodePoint(...i.subarray(e, e + 32768));
    return `data:image/png;base64,${btoa(a)}`;
}, $3bd970bfc6bd9362$export$57690667ea6b189b = async (e, t)=>{
    let n = `${$3bd970bfc6bd9362$export$f654b28f82155665()}/appl-user/v2/appl/${e}/users/${t}/roles`, { data: r } = await (0, $dc52b8907b22717f$export$cfe3ecf06fc6e90e)("GET", n, void 0, {
        throwOnError: !0
    });
    return (r?.response ?? []).map((e)=>typeof e == "string" ? e : e.roleName);
}, $3bd970bfc6bd9362$export$1de6a888ae076ff8 = async (e, t)=>{
    let n = `${$3bd970bfc6bd9362$export$f654b28f82155665()}/appl-user/v2/appl/${e}/users/${t}/preferences`, { data: r } = await (0, $dc52b8907b22717f$export$cfe3ecf06fc6e90e)("GET", n, void 0, {
        throwOnError: !0
    });
    return r?.response ?? null;
}, $3bd970bfc6bd9362$var$y = {
    department: "",
    email: "",
    location_code: "",
    manager: "",
    manager_id: "",
    name: "User, Unknown",
    preferred_first_name: "",
    userid: "",
    title: ""
}, $3bd970bfc6bd9362$var$b = [], $3bd970bfc6bd9362$export$3901076af3749fa9 = ({ appName: e } = {})=>{
    let { authState: n } = (0, $954b04773eb0508c$export$2ae4a19e09ca9a00)(), { apiReady: o } = (0, $10608212fc1ea215$export$a826e754a2b6b403)(), { appName: s } = (0, $lCzvA.useContext)($3bd970bfc6bd9362$export$4a9712b21c0592db), l = e || s, { department: u, email: d, location_code: f, manager: x, manager_id: S, name: C, preferred_first_name: w, userid: T, title: E } = n?.idToken?.claims || $3bd970bfc6bd9362$var$y, D = !!(o && T), O = !!(D && l), { data: k } = (0, $5b47d34ec35eb825$export$dd0a697e1782aedd)({
        queryKey: [
            $3bd970bfc6bd9362$var$p,
            T
        ],
        queryFn: ()=>$3bd970bfc6bd9362$export$3cae5b3ff5c106cf(String(T)),
        enabled: D,
        staleTime: Infinity
    }), { data: A = $3bd970bfc6bd9362$var$b, isLoading: j } = (0, $5b47d34ec35eb825$export$dd0a697e1782aedd)({
        queryKey: [
            $3bd970bfc6bd9362$var$m,
            T,
            l
        ],
        queryFn: ()=>$3bd970bfc6bd9362$export$57690667ea6b189b(l, String(T)),
        enabled: O,
        staleTime: Infinity
    }), { data: M } = (0, $5b47d34ec35eb825$export$dd0a697e1782aedd)({
        queryKey: [
            $3bd970bfc6bd9362$var$h,
            T,
            l
        ],
        queryFn: ()=>$3bd970bfc6bd9362$export$1de6a888ae076ff8(l, String(T)),
        enabled: O,
        staleTime: 3e5
    });
    return {
        picture: k,
        department: String(u),
        email: String(d),
        locationCode: String(f),
        manager: String(x),
        managerId: String(S),
        name: String(C),
        preferredFirstName: String(w),
        userid: String(T),
        title: String(E),
        roles: A,
        rolesLoading: j,
        authStateLoaded: !!n,
        isAuthenticated: !!n?.isAuthenticated,
        appPreferences: M
    };
}, $3bd970bfc6bd9362$export$e3dcf1c4b6d27e54 = ()=>{
    let { authState: e, oktaAuth: t } = (0, $954b04773eb0508c$export$2ae4a19e09ca9a00)(), n = !!e?.isAuthenticated, i = n ? "logout" : "login", a = n ? "Log Out" : "Log In", o = ()=>t.signInWithRedirect(), s = ()=>t.signOut();
    return {
        authIcon: i,
        authText: a,
        handleLogin: o,
        handleLogout: s,
        authFunction: n ? s : o,
        isAuthenticated: n
    };
};






var $a18f172d3a7509e0$var$D = (0, $lCzvA.createContext)({
    sidenavOpen: !1,
    toggleSidenavOpen: ()=>{},
    activeDropdown: void 0,
    setActiveDropdown: (e)=>{},
    sidenavRoutes: []
}), $a18f172d3a7509e0$var$O = ()=>(0, $lCzvA.useContext)($a18f172d3a7509e0$var$D), $a18f172d3a7509e0$var$k = (e)=>{
    let t = e;
    return t.hidden ? null : (t.childRoutes && (t = {
        ...t,
        childRoutes: t.childRoutes.map((e)=>$a18f172d3a7509e0$var$k(e)).filter(Boolean)
    }), t);
}, $a18f172d3a7509e0$var$A = (e, t)=>{
    let n = e;
    return t.includes("ADMINISTRATOR") ? n : n.roles && !t.some((e)=>n.roles?.includes(e)) ? null : (n.childRoutes && (n = {
        ...n,
        childRoutes: n.childRoutes.map((e)=>$a18f172d3a7509e0$var$A(e, t)).filter(Boolean)
    }), n);
}, $a18f172d3a7509e0$var$oe = "_container_13rar_1", $a18f172d3a7509e0$var$se = "_containerNoRoutes_13rar_6", $a18f172d3a7509e0$var$j = (0, $lCzvA.createContext)({
    routes: [],
    appName: "",
    appDisplayName: ""
}), $a18f172d3a7509e0$var$M = ()=>(0, $lCzvA.useContext)($a18f172d3a7509e0$var$j), $a18f172d3a7509e0$var$N = (e, t = "")=>{
    let n = `${t}/${e.path}`;
    return e.childRoutes ? e.element ? [
        {
            ...e,
            path: n
        },
        ...e.childRoutes.flatMap((e)=>$a18f172d3a7509e0$var$N(e, n))
    ] : e.childRoutes.flatMap((e)=>$a18f172d3a7509e0$var$N(e, n)) : [
        {
            ...e,
            path: n
        }
    ];
}, $a18f172d3a7509e0$var$P = ()=>{
    let { routes: e } = $a18f172d3a7509e0$var$M(), { roles: t, rolesLoading: n } = (0, $3bd970bfc6bd9362$export$3901076af3749fa9)(), r = (0, $lCzvA.useMemo)(()=>e.map((e)=>$a18f172d3a7509e0$var$A(e, t)).filter(Boolean).flatMap((e)=>$a18f172d3a7509e0$var$N(e)).filter(Boolean).filter((e)=>e.element && !e.hidden), [
        e,
        t
    ]);
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
        children: [
            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                className: $a18f172d3a7509e0$var$oe,
                children: r.map((e)=>/* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($a18f172d3a7509e0$var$Xe, {
                        ...e
                    }, e.title))
            }),
            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                className: $a18f172d3a7509e0$var$se,
                children: !n && r.length === 0 && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                    children: [
                        /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("h3", {
                            children: "It appears you may not have a valid role to access this application"
                        }),
                        /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("h3", {
                            children: "Please validate that you have correct access"
                        })
                    ]
                })
            })
        ]
    });
}, $a18f172d3a7509e0$var$ce = ({ children: e })=>{
    let { pathname: t } = (0, $ebc812b73151cba1$export$45d76561a5302f2b)(), { roles: n } = (0, $3bd970bfc6bd9362$export$3901076af3749fa9)(), { routes: r } = $a18f172d3a7509e0$var$M(), [i, a] = (0, $lCzvA.useState)(!1), [o, l] = (0, $lCzvA.useState)(void 0), [u, d] = (0, $lCzvA.useState)(t);
    t !== u && (d(t), a(!1));
    let f = (0, $lCzvA.useMemo)(()=>r.map((e)=>$a18f172d3a7509e0$var$k(e)).filter(Boolean), [
        r
    ]), p = (0, $lCzvA.useMemo)(()=>{
        let e = f.map((e)=>$a18f172d3a7509e0$var$A(e, n)).filter(Boolean);
        return e.some((e)=>e.path === "/") ? e : [
            {
                path: "/",
                title: "Home",
                icon: "home",
                element: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($a18f172d3a7509e0$var$P, {})
            },
            ...e
        ];
    }, [
        f,
        n
    ]), m = (0, $lCzvA.useMemo)(()=>({
            sidenavOpen: i,
            toggleSidenavOpen: ()=>a((e)=>!e),
            activeDropdown: o,
            setActiveDropdown: (e)=>l(e),
            sidenavRoutes: p
        }), [
        i,
        o,
        p
    ]);
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($a18f172d3a7509e0$var$D.Provider, {
        value: m,
        children: e
    });
}, $a18f172d3a7509e0$var$le = "_container_2xge0_1", $a18f172d3a7509e0$var$ue = "_iconContainer_2xge0_8", $a18f172d3a7509e0$var$F = "_text_2xge0_16", $a18f172d3a7509e0$var$I = ({ iconName: e, iconSize: t = 16, children: n, ...r })=>/* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
        className: $a18f172d3a7509e0$var$le,
        ...r,
        children: [
            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                className: $a18f172d3a7509e0$var$ue,
                children: e && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                    name: e,
                    size: t
                })
            }),
            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("p", {
                className: $a18f172d3a7509e0$var$F,
                children: n
            })
        ]
    }), $a18f172d3a7509e0$var$L = "_container_1u4jo_1", $a18f172d3a7509e0$var$R = "_button_1u4jo_6", $a18f172d3a7509e0$var$z = "_dropdown_1u4jo_20", $a18f172d3a7509e0$var$B = "_dropdownOpen_1u4jo_28", $a18f172d3a7509e0$var$V = "_divider_1u4jo_38", $a18f172d3a7509e0$var$H = "_dropdownIcon_1u4jo_44", $a18f172d3a7509e0$var$U = "_dropdownIconOpen_1u4jo_48", $a18f172d3a7509e0$var$de = ({ text: e, iconName: t = "team_dashboard", routePath: n, children: r })=>{
    let { activeDropdown: i, setActiveDropdown: a } = $a18f172d3a7509e0$var$O(), o = i === n;
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
        className: $a18f172d3a7509e0$var$L,
        children: [
            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("button", {
                className: $a18f172d3a7509e0$var$R,
                type: "button",
                onClick: ()=>{
                    a(o ? void 0 : n);
                },
                children: [
                    /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($a18f172d3a7509e0$var$I, {
                        iconName: t,
                        children: e
                    }),
                    /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                        name: "expand_more",
                        size: 21,
                        className: o ? $a18f172d3a7509e0$var$U : $a18f172d3a7509e0$var$H
                    })
                ]
            }),
            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                "data-testid": o ? "dropdownOpen" : "dropdownClosed",
                className: `${$a18f172d3a7509e0$var$z} ${o ? $a18f172d3a7509e0$var$B : ""}`,
                children: [
                    r,
                    /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                        className: $a18f172d3a7509e0$var$V
                    })
                ]
            })
        ]
    });
}, $a18f172d3a7509e0$var$fe = "_container_1n9vc_1", $a18f172d3a7509e0$var$pe = "_containerOpen_1n9vc_6", $a18f172d3a7509e0$var$me = "_sidenavContainer_1n9vc_10", $a18f172d3a7509e0$var$he = "_sidenavOpen_1n9vc_23", $a18f172d3a7509e0$var$ge = "_sidenavBackdrop_1n9vc_27", $a18f172d3a7509e0$var$_e = "_sidenavBackdropOpen_1n9vc_38", $a18f172d3a7509e0$var$ve = "_logoSection_1n9vc_47", $a18f172d3a7509e0$var$ye = "_routesSection_1n9vc_56", $a18f172d3a7509e0$var$W = "_link_1n9vc_64", $a18f172d3a7509e0$var$be = "_activeLink_1n9vc_81", $a18f172d3a7509e0$var$xe = "_grandchildContainer_1n9vc_86", $a18f172d3a7509e0$var$Se = "_grandchildText_1n9vc_90", $a18f172d3a7509e0$var$Ce = "_column_1n9vc_101", $a18f172d3a7509e0$var$G = ({ element: e, link: t, childRoutes: n, path: r, title: i, icon: a, parentPath: o = "" })=>{
    let s = `${o}${r}`, c = i || r;
    return n ? /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
        "data-testid": "parentNode",
        children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($a18f172d3a7509e0$var$de, {
            text: c,
            iconName: a,
            routePath: r,
            children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                "data-testid": "collapse",
                className: $a18f172d3a7509e0$var$Ce,
                children: n.map((e)=>{
                    let t = e.childRoutes;
                    return t ? /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                        className: $a18f172d3a7509e0$var$xe,
                        children: [
                            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("p", {
                                className: $a18f172d3a7509e0$var$Se,
                                children: e.title
                            }),
                            t.map((t)=>/* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($a18f172d3a7509e0$var$G, {
                                    ...t,
                                    parentPath: `${s}/${e.path}/`
                                }, s + t.path))
                        ]
                    }, s + e.path) : /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($a18f172d3a7509e0$var$G, {
                        ...e,
                        parentPath: `${s}/`
                    }, s + e.path);
                })
            })
        })
    }) : e ? /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
        "data-testid": "childNode",
        children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $c3aca08c2a74646e$export$b0d92dbee9b5b60d), {
            to: s,
            className: ({ isActive: e })=>`${$a18f172d3a7509e0$var$W} ${e ? $a18f172d3a7509e0$var$be : ""}`,
            children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($a18f172d3a7509e0$var$I, {
                iconName: a,
                iconSize: 18,
                children: c
            })
        })
    }) : t ? /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
        "data-testid": "childNode",
        children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("a", {
            href: t,
            target: "_blank",
            rel: "noreferrer",
            className: $a18f172d3a7509e0$var$W,
            children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($a18f172d3a7509e0$var$I, {
                iconName: a,
                iconSize: 18,
                children: c
            })
        })
    }) : null;
}, $a18f172d3a7509e0$var$we = (0, $lCzvA.forwardRef)((e, t)=>/* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("svg", {
        width: 69,
        height: 40,
        viewBox: "0 0 69 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        ref: t,
        ...e,
        children: [
            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("rect", {
                width: 69,
                height: 40,
                fill: "url(#pattern0)"
            }),
            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("defs", {
                children: [
                    /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("pattern", {
                        id: "pattern0",
                        patternContentUnits: "objectBoundingBox",
                        width: 1,
                        height: 1,
                        children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("use", {
                            xlinkHref: "#image0_318_197",
                            transform: "matrix(0.0029577 0 0 0.00510204 -0.00280982 0)"
                        })
                    }),
                    /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("image", {
                        id: "image0_318_197",
                        width: 340,
                        height: 196,
                        xlinkHref: "data:image/png;base64,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"
                    })
                ]
            })
        ]
    })), $a18f172d3a7509e0$var$Te = ()=>{
    let { sidenavOpen: e, toggleSidenavOpen: t, sidenavRoutes: n } = $a18f172d3a7509e0$var$O();
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
        className: `${$a18f172d3a7509e0$var$fe} ${e ? $a18f172d3a7509e0$var$pe : ""}`,
        children: [
            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                "data-testid": e ? "sidenavOpen" : "sidenavClosed",
                className: `${$a18f172d3a7509e0$var$me} ${e ? $a18f172d3a7509e0$var$he : ""}`,
                children: [
                    /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                        className: $a18f172d3a7509e0$var$ve,
                        children: [
                            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($a18f172d3a7509e0$var$we, {}),
                            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("button", {
                                type: "button",
                                onClick: t,
                                children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                                    name: "close",
                                    size: 30
                                })
                            })
                        ]
                    }),
                    /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                        className: $a18f172d3a7509e0$var$ye,
                        children: n.map((e)=>/* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($a18f172d3a7509e0$var$G, {
                                ...e
                            }, e.title))
                    })
                ]
            }),
            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                "data-testid": "sidenavOverlay",
                className: `${$a18f172d3a7509e0$var$ge} ${e ? $a18f172d3a7509e0$var$_e : ""}`,
                onClick: t,
                onKeyDown: t,
                role: "button",
                tabIndex: 0
            })
        ]
    });
}, $a18f172d3a7509e0$var$Ee = "_container_14e0u_1", $a18f172d3a7509e0$var$De = "_route_14e0u_12", $a18f172d3a7509e0$var$Oe = "_message_14e0u_17", $a18f172d3a7509e0$var$ke = {
    routeName: "this page",
    message: "But it's all good"
}, $a18f172d3a7509e0$var$Ae = ({ authError: e = $a18f172d3a7509e0$var$ke })=>{
    let t = (0, $ebc812b73151cba1$export$9770f232ac06a008)();
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
        className: $a18f172d3a7509e0$var$Ee,
        children: [
            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("p", {
                className: $a18f172d3a7509e0$var$De,
                children: [
                    "It appears you do not have access to ",
                    e.routeName,
                    " "
                ]
            }),
            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("p", {
                className: $a18f172d3a7509e0$var$Oe,
                children: e.message
            }),
            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                children: [
                    /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                        onClick: ()=>t(-1),
                        children: "Go Back"
                    }),
                    /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                        onClick: ()=>t("/"),
                        children: "Go to Home Page"
                    })
                ]
            })
        ]
    });
}, $a18f172d3a7509e0$export$5e02738099599d87 = ()=>{
    let { pathname: e } = (0, $ebc812b73151cba1$export$45d76561a5302f2b)(), { routes: t } = $a18f172d3a7509e0$var$M(), n = (0, $lCzvA.useCallback)((e, n = t)=>n.find((t)=>t.path === e), [
        t
    ]), r = (0, $lCzvA.useCallback)(()=>{
        let t = e === "/" ? [
            "/"
        ] : e.split("/").filter(Boolean), r = [];
        for (let e of t){
            let t = r.at(-1), i = n(e, t?.childRoutes);
            if (i) {
                let e = t ? `${t.fullPath}/${i.path}` : i.path, n = {
                    ...i,
                    fullPath: e,
                    url: i.element ? e : ""
                };
                r.push(n);
            }
        }
        let i = r.map(({ url: e, path: t, isPublic: n, roles: r, title: i, hideLayout: a, hideSideNav: o })=>({
                title: i || t,
                url: e,
                isPublic: n,
                roles: r,
                hideLayout: a,
                hideSideNav: o
            }));
        return {
            pathRoutes: i,
            currentRoute: i.at(-1) || {
                title: "Home",
                url: "/",
                isPublic: !1,
                roles: [],
                hideLayout: !1,
                hideSideNav: !1
            },
            pathname: e
        };
    }, [
        e,
        n
    ]);
    return (0, $lCzvA.useMemo)(()=>r(), [
        r
    ]);
}, $a18f172d3a7509e0$var$je = "_container_mypbj_1", $a18f172d3a7509e0$var$Me = ()=>{
    let { pathRoutes: e } = $a18f172d3a7509e0$export$5e02738099599d87(), t = e.at(-1);
    if (t) {
        let { roles: e, title: n } = t;
        return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($a18f172d3a7509e0$var$Ae, {
            authError: {
                routeName: n,
                message: `Role missing: ${e?.join(", ")}`
            }
        });
    }
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
        className: $a18f172d3a7509e0$var$je,
        children: [
            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("p", {
                children: "404 - Not found"
            }),
            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("p", {
                children: "Couldn't find what you were looking for..."
            })
        ]
    });
}, $a18f172d3a7509e0$var$Ne = ()=>{
    let e = (0, $ebc812b73151cba1$export$9770f232ac06a008)();
    return (0, $lCzvA.useEffect)(()=>{
        e("/");
    }, [
        e
    ]), /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($a18f172d3a7509e0$export$669f6ea7d267feaf, {
        show: !0
    });
}, $a18f172d3a7509e0$var$q = ()=>{
    let { oktaAuth: e, authState: t } = (0, $954b04773eb0508c$export$2ae4a19e09ca9a00)();
    return (0, $lCzvA.useEffect)(()=>{
        if (t?.isAuthenticated === !1) {
            let t = (0, $47114d36cb1410d5$export$4ebdca5513a016fe)(window.location.href, window.location.origin);
            e.setOriginalUri(t), e.signInWithRedirect();
        }
    }, [
        e,
        t?.isAuthenticated
    ]), !t || !t?.isAuthenticated ? /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($a18f172d3a7509e0$export$669f6ea7d267feaf, {
        show: !0
    }) : /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $ebc812b73151cba1$export$910ae8079b2c2852), {});
}, $a18f172d3a7509e0$var$J = (e, t)=>{
    let n = e.isPublic ? (0, $ebc812b73151cba1$export$910ae8079b2c2852) : $a18f172d3a7509e0$var$q;
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $ebc812b73151cba1$export$e7b0ac011bb776c6), {
        path: e.path,
        element: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)(n, {}),
        children: [
            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $ebc812b73151cba1$export$e7b0ac011bb776c6), {
                ...e,
                path: ""
            }),
            e.childRoutes?.map((e)=>$a18f172d3a7509e0$var$J(e, `${t}/${e.path}`))
        ]
    }, t);
}, $a18f172d3a7509e0$var$Pe = ({ invalidRedirect: e })=>{
    let { roles: t } = (0, $3bd970bfc6bd9362$export$3901076af3749fa9)(), { routes: n } = $a18f172d3a7509e0$var$M(), r = (0, $lCzvA.useMemo)(()=>n.map((e)=>$a18f172d3a7509e0$var$A(e, t)).filter(Boolean).map((e)=>$a18f172d3a7509e0$var$J(e, e.path)), [
        t,
        n
    ]);
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $ebc812b73151cba1$export$3565eb3d00ca5a74), {
        children: [
            r,
            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $ebc812b73151cba1$export$e7b0ac011bb776c6), {
                path: "/",
                element: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($a18f172d3a7509e0$var$q, {}),
                children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $ebc812b73151cba1$export$e7b0ac011bb776c6), {
                    path: "",
                    element: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($a18f172d3a7509e0$var$P, {})
                })
            }),
            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $ebc812b73151cba1$export$e7b0ac011bb776c6), {
                path: "login/callback",
                element: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $954b04773eb0508c$export$8f938467209eea73), {
                    loadingElement: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($a18f172d3a7509e0$export$669f6ea7d267feaf, {})
                })
            }),
            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $ebc812b73151cba1$export$e7b0ac011bb776c6), {
                path: "logout",
                element: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($a18f172d3a7509e0$var$Ne, {})
            }),
            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $ebc812b73151cba1$export$e7b0ac011bb776c6), {
                path: "*",
                element: e ? /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $ebc812b73151cba1$export$444b3ab0cb9aec40), {
                    to: e,
                    replace: !0
                }) : /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($a18f172d3a7509e0$var$Me, {})
            })
        ]
    });
}, $a18f172d3a7509e0$var$Fe = "_nav_i52od_1", $a18f172d3a7509e0$var$Y = "_gappedRow_i52od_12", $a18f172d3a7509e0$var$Ie = "_title_i52od_18", $a18f172d3a7509e0$var$X = "_button_1gn7e_1", $a18f172d3a7509e0$var$Z = "_avatar_1gn7e_8", $a18f172d3a7509e0$var$Le = "_initials_1gn7e_15", $a18f172d3a7509e0$var$Re = "_item_1gn7e_24", $a18f172d3a7509e0$var$ze = "_accountDropdown_1gn7e_36", $a18f172d3a7509e0$var$Be = "_username_1gn7e_53", $a18f172d3a7509e0$var$Ve = ({ showUsername: e })=>{
    let { authState: t } = (0, $954b04773eb0508c$export$2ae4a19e09ca9a00)(), [n, r] = t?.idToken?.claims?.name?.split(", ") || [
        "User",
        "Unknown"
    ], i = t?.idToken?.claims?.preferred_username?.split("@")?.[0] || "Unknown";
    return e ? /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
        className: $a18f172d3a7509e0$var$Be,
        "data-testid": "avatar-username",
        children: i?.toUpperCase()
    }) : /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
        className: `${$a18f172d3a7509e0$var$Z} ${$a18f172d3a7509e0$var$Le}`,
        "data-testid": "avatar-initials",
        children: [
            r?.charAt(0),
            n?.charAt(0)
        ]
    });
}, $a18f172d3a7509e0$var$He = ({ avatarOptions: t = [], showUsername: n })=>{
    let { authText: r, authIcon: a, authFunction: o, isAuthenticated: c } = (0, $3bd970bfc6bd9362$export$e3dcf1c4b6d27e54)(), { picture: l } = (0, $3bd970bfc6bd9362$export$3901076af3749fa9)(), u = [
        ...t,
        {
            text: "Report Issue",
            icon: "report",
            href: "https://pellaprod.service-now.com/sp?id=sc_inc_manufacturing",
            isLink: !0
        },
        {
            text: "Suggest Enhancement",
            icon: "lightbulb",
            href: "https://pellaprod.service-now.com/sp?id=sc_cat_item&sys_id=053d45b1873ef550cbfda8e73cbb3545&sysparm_category=053d45b1873ef550cbfda8e73cbb3545",
            isLink: !0
        },
        {
            text: r,
            icon: a,
            onClick: o
        }
    ], g = (0, $lCzvA.useCallback)(()=>l && !n ? /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("img", {
            src: l,
            alt: "user-profile",
            className: $a18f172d3a7509e0$var$Z
        }) : c ? /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($a18f172d3a7509e0$var$Ve, {
            showUsername: n
        }) : /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
            name: "account_circle",
            size: 38,
            className: $a18f172d3a7509e0$var$X
        }), [
        c,
        l,
        n
    ]), _ = (0, $lCzvA.useMemo)(()=>g(), [
        g
    ]);
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $4894604720ca08c8$export$2e2bcd8739ae039), {
        children: [
            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $159cb66f654a3a1c$export$2e2bcd8739ae039), {
                children: _
            }),
            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $833f5a446a1fbfcc$export$2e2bcd8739ae039), {
                className: $a18f172d3a7509e0$var$ze,
                children: u.map(({ text: t, icon: n, onClick: r, isLink: i, href: a }, o)=>{
                    let s = o === u.length - 1, c = i ? "a" : "button", l = i ? {
                        href: a,
                        target: "_blank",
                        rel: "noreferrer"
                    } : {
                        onClick: r
                    };
                    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $lCzvA.Fragment), {
                        children: [
                            s && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("hr", {
                                className: "_divider_1gn7e_48"
                            }),
                            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $e007c3baa5a03cf7$export$2e2bcd8739ae039), {
                                children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)(c, {
                                    className: `${$a18f172d3a7509e0$var$X} ${$a18f172d3a7509e0$var$Re}`,
                                    type: "button",
                                    ...l,
                                    children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($a18f172d3a7509e0$var$I, {
                                        iconName: n,
                                        iconSize: 20,
                                        children: t
                                    })
                                })
                            })
                        ]
                    }, t + n);
                })
            })
        ]
    });
}, $a18f172d3a7509e0$var$Q = ({ appDisplayName: e, avatarOptions: t, navbarActions: n = [], hideSideNav: r, showUsername: i })=>{
    let { toggleSidenavOpen: a } = $a18f172d3a7509e0$var$O();
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("nav", {
        className: $a18f172d3a7509e0$var$Fe,
        "data-testid": "navbar",
        children: [
            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                className: $a18f172d3a7509e0$var$Y,
                children: [
                    !r && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("button", {
                        className: "_button_i52od_30",
                        type: "button",
                        onClick: a,
                        children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                            name: "menu",
                            size: 38
                        })
                    }),
                    /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $c3aca08c2a74646e$export$a6c7ac8248d6e38a), {
                        to: "/",
                        className: $a18f172d3a7509e0$var$Ie,
                        children: e
                    })
                ]
            }),
            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                className: $a18f172d3a7509e0$var$Y,
                children: [
                    n,
                    /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($a18f172d3a7509e0$var$He, {
                        avatarOptions: t,
                        showUsername: i
                    })
                ]
            })
        ]
    });
}, $a18f172d3a7509e0$var$Ue = "_container_1bsqv_1", $a18f172d3a7509e0$var$We = "_childContainer_1bsqv_9", $a18f172d3a7509e0$var$Ge = ({ appDisplayName: e, avatarOptions: t = [], navbarActions: n = [], hideBreadcrumbs: r, invalidRedirect: i, showUsername: a })=>{
    let { pathRoutes: s, currentRoute: c } = $a18f172d3a7509e0$export$5e02738099599d87();
    (0, $lCzvA.useEffect)(()=>{
        let t = c.url === "/" ? e : `${e} | ${c.title}`;
        document.title = t;
    }, [
        e,
        c
    ]);
    let u = [
        ...s
    ].slice(0, -1), d = c.title === "Home" ? void 0 : c.title;
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
        className: $a18f172d3a7509e0$var$Ue,
        children: [
            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($a18f172d3a7509e0$var$ce, {
                children: !c?.hideLayout && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $1e1ba35c5b9fc4c3$exports.Fragment), {
                    children: [
                        /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($a18f172d3a7509e0$var$Q, {
                            appDisplayName: e,
                            avatarOptions: t,
                            navbarActions: n,
                            hideSideNav: c?.hideSideNav,
                            showUsername: a
                        }),
                        !c?.hideSideNav && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($a18f172d3a7509e0$var$Te, {})
                    ]
                })
            }),
            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                id: "scrollable-area",
                className: $a18f172d3a7509e0$var$We,
                children: [
                    !r && !c?.hideLayout && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $e7e807be55d7b93f$export$2e2bcd8739ae039), {
                        renderLinksAs: (0, $c3aca08c2a74646e$export$a6c7ac8248d6e38a),
                        enableTo: !0,
                        pages: u,
                        current: d,
                        className: "_breadcrumbs_1bsqv_19",
                        "data-testid": "breadcrumbs"
                    }),
                    /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($a18f172d3a7509e0$var$Pe, {
                        invalidRedirect: i
                    })
                ]
            })
        ]
    });
}, $a18f172d3a7509e0$export$c84671f46d6a1ca = (0, $lCzvA.memo)(({ appName: e, appDisplayName: t, routes: n, baseUrl: r, ...i })=>{
    if (!e || typeof e != "string") throw Error("Layout requires a non-empty appName string prop");
    let a = t || e;
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($a18f172d3a7509e0$var$j.Provider, {
        value: {
            routes: n,
            appName: e,
            appDisplayName: a
        },
        children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $3bd970bfc6bd9362$export$6414ebbbfff99d4c), {
            appName: e,
            baseUrl: r,
            children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($a18f172d3a7509e0$var$Ge, {
                appDisplayName: a,
                ...i
            })
        })
    });
}), $a18f172d3a7509e0$var$qe = "_container_1fe30_1", $a18f172d3a7509e0$var$Je = "_dots_1fe30_19", $a18f172d3a7509e0$export$669f6ea7d267feaf = ({ show: e = !1, text: t = "LOADING..." })=>e ? /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
        className: $a18f172d3a7509e0$var$qe,
        role: "status",
        children: [
            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                className: $a18f172d3a7509e0$var$Je,
                "data-testid": "loading-indicator",
                "aria-label": "three-dots-loading",
                children: [
                    /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {}),
                    /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {}),
                    /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {})
                ]
            }),
            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("p", {
                children: t
            })
        ]
    }) : null, $a18f172d3a7509e0$var$Ye = "_container_15kd0_1", $a18f172d3a7509e0$var$Xe = ({ icon: e = "question_mark", title: t, path: n })=>/* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $c3aca08c2a74646e$export$a6c7ac8248d6e38a), {
        to: n,
        className: $a18f172d3a7509e0$var$Ye,
        children: [
            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                name: e,
                size: 50,
                weight: 400
            }),
            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("p", {
                children: t
            })
        ]
    });


/**
 * Enum for react-query query keys
 * @readonly
 * @enum {string}
 */ const $917e2c0c66b65db1$export$9a2c3bcaa912c766 = {
    TEAM_MEMBER_IMG: 'teamMemberImage',
    TEAM_MEMBER_APPLICATION_ROLES: 'teamMemberApplicationRoles',
    PLANT_DATA: 'plantData',
    RESOURCE_DATA: 'resourceData',
    LOCATION_DATA: 'locationData',
    ACTION_DATA: 'actionData',
    QUEUE_DATA: 'queueData',
    REQUESTS_BY_LOCATION: 'requestsByLocation',
    REQUESTS_BY_RESOURCE: 'requestsByResource',
    COMPLETED_REQUESTS_BY_LOCATION: 'completedRequestsByLocation',
    COMPLETED_REQUESTS_BY_RESOURCE: 'completedRequestsByResource',
    RESOURCE_QUEUES: 'resourceQueues',
    ORGANIZATION_DATA: 'organizationData',
    SELECTION_LISTS: 'selectionLists',
    TRANSACTION_TYPES: 'transactionTypes',
    DISPOSITIONS: 'dispositions',
    CARRIERS: 'carriers',
    INVENTORY_ITEM: 'inventoryItem',
    SUBINVENTORY: 'subinventory',
    SUBINVENTORY_INFO: 'subinventoryInfo',
    LOCATORS: 'locators',
    PART_DESCRIPTION_DATA: 'partDescriptionData',
    QOH_BY_ORG_AND_ITEM: 'qohByOrgAndItem',
    DIE_AND_DESCRIPTION: 'dieAndDescription',
    LUMBER_ITEM_INFO_BY_SCHEDULE: 'lumberItemInfoBySchedule',
    LUMBER_LOCATION_BY_ITEM: 'lumberLocationByItem',
    PUT_DOWN_MILL_BY_ITEM: 'putDownMillByItem'
};
const $917e2c0c66b65db1$export$9d68129191b78e9b = [
    $917e2c0c66b65db1$export$9a2c3bcaa912c766.TEAM_MEMBER_APPLICATION_ROLES
];
const $917e2c0c66b65db1$export$a417583fa5432967 = [
    'action.description',
    'action.message',
    'location.description',
    'comment',
    'requestorId',
    'acceptUserId',
    'onHoldUserId',
    'completionUserId'
];
const $917e2c0c66b65db1$export$b41c0f52c41112e3 = {
    ACCEPTED: 'Accepted',
    AVAILABLE: 'Available',
    ON_HOLD: 'On Hold',
    COMPLETED: 'Completed',
    RECALLED: 'Recalled'
};
const $917e2c0c66b65db1$export$9831c7e6e3463b6e = {
    TRAILER_TO_DOCK: 'TRAILER_TO_DOCK',
    SUB_INVENTORY_TRANSFER: 'SUB_INVENTORY_TRANSFER',
    DIRECT_ORG_TRANSFER: 'DIRECT_ORG_TRANSFER',
    ISSUE_TO_LINE: 'ISSUE_TO_LINE'
};
const $917e2c0c66b65db1$export$c7d449ce2d69117f = [
    {
        id: $917e2c0c66b65db1$export$9831c7e6e3463b6e.TRAILER_TO_DOCK,
        description: 'Trailer to Dock'
    },
    {
        id: $917e2c0c66b65db1$export$9831c7e6e3463b6e.SUB_INVENTORY_TRANSFER,
        description: 'Sub Inventory Transfer'
    },
    {
        id: $917e2c0c66b65db1$export$9831c7e6e3463b6e.DIRECT_ORG_TRANSFER,
        description: 'Direct Org Transfer'
    },
    {
        id: $917e2c0c66b65db1$export$9831c7e6e3463b6e.ISSUE_TO_LINE,
        description: 'Issue to Line'
    }
];
const $917e2c0c66b65db1$export$1eb689c2eb5e003a = new Set(Object.values($917e2c0c66b65db1$export$9831c7e6e3463b6e));
const $917e2c0c66b65db1$export$da90eef90bb88aff = [
    {
        id: 'PART_DESCRIPTION_LOOKUP',
        description: 'Part Description Lookup'
    },
    {
        id: 'PART_QOH_LOCATIONS_LOOKUP',
        description: 'Part QOH Locations Lookup'
    },
    {
        id: 'DIE_NUMBER_LOOKUP',
        description: 'Die Number Lookup'
    },
    {
        id: 'LUMBER_SCHEDULE_LOOKUP',
        description: 'Lumber Schedule Lookup'
    },
    {
        id: 'LUMBER_PART_LOOKUP',
        description: 'Lumber Part Lookup'
    },
    {
        id: 'P10_PUT_DOWN_MILL',
        description: 'P10 Put Down Mill'
    }
];
const $917e2c0c66b65db1$export$3b81987c7089d388 = 100;
const $917e2c0c66b65db1$export$707abb74bd20046 = {
    cartNotReady: 'Cart Not Ready',
    partNotReady: 'Part Not Ready',
    partOutage: 'Part Outage',
    routeBlockage: 'Route Blockage',
    qualityHold: 'Quality Hold',
    other: 'Other'
};
const $917e2c0c66b65db1$var$defaultOutput = `
    id
    createdBy
    creationDate
    lastUpdatedBy
    lastUpdatedDate
`;
const $917e2c0c66b65db1$export$2e91c99b8ae4619 = `
    description
    queueType
    active
    ${$917e2c0c66b65db1$var$defaultOutput}
`;
const $917e2c0c66b65db1$var$ACTION_FIELDS = `
    description
    message
    isDefault
    active
    sequence
    actionPrompt
    showComment
    showDynamicInput
    showQuantity
    showSelectionList
    selectionListId1
    selectionListId2
    actionQuery
    transactionId
    dockSelectionListId
    dispositionId
    completionId
    showOnHoldReason
    linkedActionId
    linkedAction {
        id
        description
        active
        location {
            id
            plant {
                id
            }
        }
    }
    ${$917e2c0c66b65db1$var$defaultOutput}
`;
const $917e2c0c66b65db1$export$7f56a3c99a9211d0 = `
    active
    description
    organizationId
    wmsOrgCode
    ${$917e2c0c66b65db1$var$defaultOutput}
`;
const $917e2c0c66b65db1$export$9523889e0a5da4ba = `
    ${$917e2c0c66b65db1$var$ACTION_FIELDS}
    queue {
        ${$917e2c0c66b65db1$export$2e91c99b8ae4619}
        }
`;
const $917e2c0c66b65db1$export$3b1595a0ea293e57 = `
    ${$917e2c0c66b65db1$var$ACTION_FIELDS}
    queue {
        ${$917e2c0c66b65db1$export$2e91c99b8ae4619}
        plant {
            ${$917e2c0c66b65db1$export$7f56a3c99a9211d0}
        }
    }
`;
const $917e2c0c66b65db1$export$9614b21cfc575fa7 = `
  communication
  userName
  timeStamp
  readBy
`;
const $917e2c0c66b65db1$export$2ad124feee625e51 = 'A new communication has been received';


const $88478e1cba2f5c35$export$645edbbcdf57f1a9 = ()=>{
    const isFetching = (0, $ffefff3d830f108f$export$625b2ff71316bcd3)({
        predicate: (query)=>(0, $917e2c0c66b65db1$export$9d68129191b78e9b).includes(String(query.queryKey[0]))
    });
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $a18f172d3a7509e0$export$669f6ea7d267feaf), {
        show: Boolean(isFetching)
    });
};





var $lCzvA = parcelRequire("lCzvA");
function $8269bd5b276bbb74$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


// eslint-disable-next-line no-undef
var $9d3b363be4fdb0ac$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $9d3b363be4fdb0ac$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $8269bd5b276bbb74$export$2e2bcd8739ae039)(function(prop) {
    return $9d3b363be4fdb0ac$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});



var $lCzvA = parcelRequire("lCzvA");
var $2f8d19f61bf0d402$export$71ad59f2e432cfe8 = '-ms-';
var $2f8d19f61bf0d402$export$2c0f367103c8d01c = '-moz-';
var $2f8d19f61bf0d402$export$39dfd62a25e0fe93 = '-webkit-';
var $2f8d19f61bf0d402$export$a29989082612d0d9 = 'comm';
var $2f8d19f61bf0d402$export$aa3a2e812ca8570d = 'rule';
var $2f8d19f61bf0d402$export$527d108ccf083c2b = 'decl';
var $2f8d19f61bf0d402$export$d3d35020fa5b54f0 = '@page';
var $2f8d19f61bf0d402$export$500415a86c544f73 = '@media';
var $2f8d19f61bf0d402$export$a763edbf796b780a = '@import';
var $2f8d19f61bf0d402$export$2790aeb8b4e5c826 = '@charset';
var $2f8d19f61bf0d402$export$1cc683e23b84b133 = '@viewport';
var $2f8d19f61bf0d402$export$9447a5efea57e862 = '@supports';
var $2f8d19f61bf0d402$export$ef011b4e114b1fba = '@document';
var $2f8d19f61bf0d402$export$6aad947bda0f3f46 = '@namespace';
var $2f8d19f61bf0d402$export$b44a8529a35fcb60 = '@keyframes';
var $2f8d19f61bf0d402$export$2c16de31893252e6 = '@font-face';
var $2f8d19f61bf0d402$export$3d846dd52e150c6f = '@counter-style';
var $2f8d19f61bf0d402$export$22314bfbb57653fe = '@font-feature-values';
var $2f8d19f61bf0d402$export$d773506282b3cfe6 = '@layer';
var $2f8d19f61bf0d402$export$1c5a554c78c0cd12 = '@scope';


/**
 * @param {number}
 * @return {number}
 */ var $c3d91ae5e8302903$export$2335f513bbd82c6d = Math.abs;
var $c3d91ae5e8302903$export$6788812c4e6611e6 = String.fromCharCode;
var $c3d91ae5e8302903$export$e6e34fd1f2686227 = Object.assign;
function $c3d91ae5e8302903$export$d6af199866bfb566(value, length) {
    return $c3d91ae5e8302903$export$a9db5e087081082d(value, 0) ^ 45 ? (((length << 2 ^ $c3d91ae5e8302903$export$a9db5e087081082d(value, 0)) << 2 ^ $c3d91ae5e8302903$export$a9db5e087081082d(value, 1)) << 2 ^ $c3d91ae5e8302903$export$a9db5e087081082d(value, 2)) << 2 ^ $c3d91ae5e8302903$export$a9db5e087081082d(value, 3) : 0;
}
function $c3d91ae5e8302903$export$87c2784dc9fc4ab(value) {
    return value.trim();
}
function $c3d91ae5e8302903$export$4659b591c19bdf3d(value, pattern) {
    return (value = pattern.exec(value)) ? value[0] : value;
}
function $c3d91ae5e8302903$export$77ad94ebf1c2b9ed(value, pattern, replacement) {
    return value.replace(pattern, replacement);
}
function $c3d91ae5e8302903$export$f8e21b1e77979a08(value, search, position) {
    return value.indexOf(search, position);
}
function $c3d91ae5e8302903$export$a9db5e087081082d(value, index) {
    return value.charCodeAt(index) | 0;
}
function $c3d91ae5e8302903$export$2f35ab04d2335697(value, begin, end) {
    return value.slice(begin, end);
}
function $c3d91ae5e8302903$export$36776f635604f274(value) {
    return value.length;
}
function $c3d91ae5e8302903$export$f9084667e487ed46(value) {
    return value.length;
}
function $c3d91ae5e8302903$export$10d8903dec122b9d(value, array) {
    return array.push(value), value;
}
function $c3d91ae5e8302903$export$1be1fc439b849fdf(array, callback) {
    return array.map(callback).join('');
}
function $c3d91ae5e8302903$export$3dea766d36a8935f(array, pattern) {
    return array.filter(function(value) {
        return !$c3d91ae5e8302903$export$4659b591c19bdf3d(value, pattern);
    });
}



var $484971fb34ffaf82$export$53f1d5ea8de3d7c = 1;
var $484971fb34ffaf82$export$4e0c71f277ca26b3 = 1;
var $484971fb34ffaf82$export$f24224f1c91d8156 = 0;
var $484971fb34ffaf82$export$5880b8b5730aff45 = 0;
var $484971fb34ffaf82$export$c0306caf338ac095 = 0;
var $484971fb34ffaf82$export$30a86d91af8ff6e6 = '';
function $484971fb34ffaf82$export$35059013cd4a06db(value, root, parent, type, props, children, length, siblings) {
    return {
        value: value,
        root: root,
        parent: parent,
        type: type,
        props: props,
        children: children,
        line: $484971fb34ffaf82$export$53f1d5ea8de3d7c,
        column: $484971fb34ffaf82$export$4e0c71f277ca26b3,
        length: length,
        return: '',
        siblings: siblings
    };
}
function $484971fb34ffaf82$export$784d13d8ee351f07(root, props) {
    return (0, $c3d91ae5e8302903$export$e6e34fd1f2686227)($484971fb34ffaf82$export$35059013cd4a06db('', null, null, '', null, null, 0, root.siblings), root, {
        length: -root.length
    }, props);
}
function $484971fb34ffaf82$export$590e8b2c435046d9(root) {
    while(root.root)root = $484971fb34ffaf82$export$784d13d8ee351f07(root.root, {
        children: [
            root
        ]
    });
    (0, $c3d91ae5e8302903$export$10d8903dec122b9d)(root, root.siblings);
}
function $484971fb34ffaf82$export$eba6f6f03b0a92e7() {
    return $484971fb34ffaf82$export$c0306caf338ac095;
}
function $484971fb34ffaf82$export$232faf9add678146() {
    $484971fb34ffaf82$export$c0306caf338ac095 = $484971fb34ffaf82$export$5880b8b5730aff45 > 0 ? (0, $c3d91ae5e8302903$export$a9db5e087081082d)($484971fb34ffaf82$export$30a86d91af8ff6e6, --$484971fb34ffaf82$export$5880b8b5730aff45) : 0;
    if ($484971fb34ffaf82$export$4e0c71f277ca26b3--, $484971fb34ffaf82$export$c0306caf338ac095 === 10) $484971fb34ffaf82$export$4e0c71f277ca26b3 = 1, $484971fb34ffaf82$export$53f1d5ea8de3d7c--;
    return $484971fb34ffaf82$export$c0306caf338ac095;
}
function $484971fb34ffaf82$export$48cfd1e771a65c4f() {
    $484971fb34ffaf82$export$c0306caf338ac095 = $484971fb34ffaf82$export$5880b8b5730aff45 < $484971fb34ffaf82$export$f24224f1c91d8156 ? (0, $c3d91ae5e8302903$export$a9db5e087081082d)($484971fb34ffaf82$export$30a86d91af8ff6e6, $484971fb34ffaf82$export$5880b8b5730aff45++) : 0;
    if ($484971fb34ffaf82$export$4e0c71f277ca26b3++, $484971fb34ffaf82$export$c0306caf338ac095 === 10) $484971fb34ffaf82$export$4e0c71f277ca26b3 = 1, $484971fb34ffaf82$export$53f1d5ea8de3d7c++;
    return $484971fb34ffaf82$export$c0306caf338ac095;
}
function $484971fb34ffaf82$export$4d3fb11e950abb9e() {
    return (0, $c3d91ae5e8302903$export$a9db5e087081082d)($484971fb34ffaf82$export$30a86d91af8ff6e6, $484971fb34ffaf82$export$5880b8b5730aff45);
}
function $484971fb34ffaf82$export$e88cb2efb12ae807() {
    return $484971fb34ffaf82$export$5880b8b5730aff45;
}
function $484971fb34ffaf82$export$58adb3bec8346d0f(begin, end) {
    return (0, $c3d91ae5e8302903$export$2f35ab04d2335697)($484971fb34ffaf82$export$30a86d91af8ff6e6, begin, end);
}
function $484971fb34ffaf82$export$9e1725a4cfeada27(type) {
    switch(type){
        // \0 \t \n \r \s whitespace token
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        // ! + , / > @ ~ isolate token
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        // ; { } breakpoint token
        case 59:
        case 123:
        case 125:
            return 4;
        // : accompanied token
        case 58:
            return 3;
        // " ' ( [ opening delimit token
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        // ) ] closing delimit token
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $484971fb34ffaf82$export$2de70f21292aac9e(value) {
    return $484971fb34ffaf82$export$53f1d5ea8de3d7c = $484971fb34ffaf82$export$4e0c71f277ca26b3 = 1, $484971fb34ffaf82$export$f24224f1c91d8156 = (0, $c3d91ae5e8302903$export$36776f635604f274)($484971fb34ffaf82$export$30a86d91af8ff6e6 = value), $484971fb34ffaf82$export$5880b8b5730aff45 = 0, [];
}
function $484971fb34ffaf82$export$45918ac1574455b1(value) {
    return $484971fb34ffaf82$export$30a86d91af8ff6e6 = '', value;
}
function $484971fb34ffaf82$export$410ac95b9ec204b8(type) {
    return (0, $c3d91ae5e8302903$export$87c2784dc9fc4ab)($484971fb34ffaf82$export$58adb3bec8346d0f($484971fb34ffaf82$export$5880b8b5730aff45 - 1, $484971fb34ffaf82$export$c889f2fcc19dbf12(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function $484971fb34ffaf82$export$660b2ee2d4fb4eff(value) {
    return $484971fb34ffaf82$export$45918ac1574455b1($484971fb34ffaf82$export$5f8c09e3ae6f64e1($484971fb34ffaf82$export$2de70f21292aac9e(value)));
}
function $484971fb34ffaf82$export$7af1228ff777d175(type) {
    while($484971fb34ffaf82$export$c0306caf338ac095 = $484971fb34ffaf82$export$4d3fb11e950abb9e())if ($484971fb34ffaf82$export$c0306caf338ac095 < 33) $484971fb34ffaf82$export$48cfd1e771a65c4f();
    else break;
    return $484971fb34ffaf82$export$9e1725a4cfeada27(type) > 2 || $484971fb34ffaf82$export$9e1725a4cfeada27($484971fb34ffaf82$export$c0306caf338ac095) > 3 ? '' : ' ';
}
function $484971fb34ffaf82$export$5f8c09e3ae6f64e1(children) {
    while($484971fb34ffaf82$export$48cfd1e771a65c4f())switch($484971fb34ffaf82$export$9e1725a4cfeada27($484971fb34ffaf82$export$c0306caf338ac095)){
        case 0:
            (0, $c3d91ae5e8302903$export$10d8903dec122b9d)($484971fb34ffaf82$export$c2ab62c7bf24634($484971fb34ffaf82$export$5880b8b5730aff45 - 1), children);
            break;
        case 2:
            (0, $c3d91ae5e8302903$export$10d8903dec122b9d)($484971fb34ffaf82$export$410ac95b9ec204b8($484971fb34ffaf82$export$c0306caf338ac095), children);
            break;
        default:
            (0, $c3d91ae5e8302903$export$10d8903dec122b9d)((0, $c3d91ae5e8302903$export$6788812c4e6611e6)($484971fb34ffaf82$export$c0306caf338ac095), children);
    }
    return children;
}
function $484971fb34ffaf82$export$955ba06d119e085e(index, count) {
    while(--count && $484971fb34ffaf82$export$48cfd1e771a65c4f())// not 0-9 A-F a-f
    if ($484971fb34ffaf82$export$c0306caf338ac095 < 48 || $484971fb34ffaf82$export$c0306caf338ac095 > 102 || $484971fb34ffaf82$export$c0306caf338ac095 > 57 && $484971fb34ffaf82$export$c0306caf338ac095 < 65 || $484971fb34ffaf82$export$c0306caf338ac095 > 70 && $484971fb34ffaf82$export$c0306caf338ac095 < 97) break;
    return $484971fb34ffaf82$export$58adb3bec8346d0f(index, $484971fb34ffaf82$export$e88cb2efb12ae807() + (count < 6 && $484971fb34ffaf82$export$4d3fb11e950abb9e() == 32 && $484971fb34ffaf82$export$48cfd1e771a65c4f() == 32));
}
function $484971fb34ffaf82$export$c889f2fcc19dbf12(type) {
    while($484971fb34ffaf82$export$48cfd1e771a65c4f())switch($484971fb34ffaf82$export$c0306caf338ac095){
        // ] ) " '
        case type:
            return $484971fb34ffaf82$export$5880b8b5730aff45;
        // " '
        case 34:
        case 39:
            if (type !== 34 && type !== 39) $484971fb34ffaf82$export$c889f2fcc19dbf12($484971fb34ffaf82$export$c0306caf338ac095);
            break;
        // (
        case 40:
            if (type === 41) $484971fb34ffaf82$export$c889f2fcc19dbf12(type);
            break;
        // \
        case 92:
            $484971fb34ffaf82$export$48cfd1e771a65c4f();
            break;
    }
    return $484971fb34ffaf82$export$5880b8b5730aff45;
}
function $484971fb34ffaf82$export$4254d4e2b3745c4c(type, index) {
    while($484971fb34ffaf82$export$48cfd1e771a65c4f())// //
    if (type + $484971fb34ffaf82$export$c0306caf338ac095 === 57) break;
    else if (type + $484971fb34ffaf82$export$c0306caf338ac095 === 84 && $484971fb34ffaf82$export$4d3fb11e950abb9e() === 47) break;
    return '/*' + $484971fb34ffaf82$export$58adb3bec8346d0f(index, $484971fb34ffaf82$export$5880b8b5730aff45 - 1) + '*' + (0, $c3d91ae5e8302903$export$6788812c4e6611e6)(type === 47 ? type : $484971fb34ffaf82$export$48cfd1e771a65c4f());
}
function $484971fb34ffaf82$export$c2ab62c7bf24634(index) {
    while(!$484971fb34ffaf82$export$9e1725a4cfeada27($484971fb34ffaf82$export$4d3fb11e950abb9e()))$484971fb34ffaf82$export$48cfd1e771a65c4f();
    return $484971fb34ffaf82$export$58adb3bec8346d0f(index, $484971fb34ffaf82$export$5880b8b5730aff45);
}


function $7b2d771130ddb761$export$ef7acd7185315e22(value) {
    return (0, $484971fb34ffaf82$export$45918ac1574455b1)($7b2d771130ddb761$export$98e6a39c04603d36('', null, null, null, [
        ''
    ], value = (0, $484971fb34ffaf82$export$2de70f21292aac9e)(value), 0, [
        0
    ], value));
}
function $7b2d771130ddb761$export$98e6a39c04603d36(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
    var index = 0;
    var offset = 0;
    var length = pseudo;
    var atrule = 0;
    var property = 0;
    var previous = 0;
    var variable = 1;
    var scanning = 1;
    var ampersand = 1;
    var character = 0;
    var type = '';
    var props = rules;
    var children = rulesets;
    var reference = rule;
    var characters = type;
    while(scanning)switch(previous = character, character = (0, $484971fb34ffaf82$export$48cfd1e771a65c4f)()){
        // (
        case 40:
            if (previous != 108 && (0, $c3d91ae5e8302903$export$a9db5e087081082d)(characters, length - 1) == 58) {
                if ((0, $c3d91ae5e8302903$export$f8e21b1e77979a08)(characters += (0, $c3d91ae5e8302903$export$77ad94ebf1c2b9ed)((0, $484971fb34ffaf82$export$410ac95b9ec204b8)(character), '&', '&\f'), '&\f', (0, $c3d91ae5e8302903$export$2335f513bbd82c6d)(index ? points[index - 1] : 0)) != -1) ampersand = -1;
                break;
            }
        // " ' [
        case 34:
        case 39:
        case 91:
            characters += (0, $484971fb34ffaf82$export$410ac95b9ec204b8)(character);
            break;
        // \t \n \r \s
        case 9:
        case 10:
        case 13:
        case 32:
            characters += (0, $484971fb34ffaf82$export$7af1228ff777d175)(previous);
            break;
        // \
        case 92:
            characters += (0, $484971fb34ffaf82$export$955ba06d119e085e)((0, $484971fb34ffaf82$export$e88cb2efb12ae807)() - 1, 7);
            continue;
        // /
        case 47:
            switch((0, $484971fb34ffaf82$export$4d3fb11e950abb9e)()){
                case 42:
                case 47:
                    (0, $c3d91ae5e8302903$export$10d8903dec122b9d)($7b2d771130ddb761$export$4a34f930e789283c((0, $484971fb34ffaf82$export$4254d4e2b3745c4c)((0, $484971fb34ffaf82$export$48cfd1e771a65c4f)(), (0, $484971fb34ffaf82$export$e88cb2efb12ae807)()), root, parent, declarations), declarations);
                    if (((0, $484971fb34ffaf82$export$9e1725a4cfeada27)(previous || 1) == 5 || (0, $484971fb34ffaf82$export$9e1725a4cfeada27)((0, $484971fb34ffaf82$export$4d3fb11e950abb9e)() || 1) == 5) && (0, $c3d91ae5e8302903$export$36776f635604f274)(characters) && (0, $c3d91ae5e8302903$export$2f35ab04d2335697)(characters, -1, void 0) !== ' ') characters += ' ';
                    break;
                default:
                    characters += '/';
            }
            break;
        // {
        case 123 * variable:
            points[index++] = (0, $c3d91ae5e8302903$export$36776f635604f274)(characters) * ampersand;
        // } ; \0
        case 125 * variable:
        case 59:
        case 0:
            switch(character){
                // \0 }
                case 0:
                case 125:
                    scanning = 0;
                // ;
                case 59 + offset:
                    if (ampersand == -1) characters = (0, $c3d91ae5e8302903$export$77ad94ebf1c2b9ed)(characters, /\f/g, '');
                    if (property > 0 && ((0, $c3d91ae5e8302903$export$36776f635604f274)(characters) - length || variable === 0 && previous === 47)) (0, $c3d91ae5e8302903$export$10d8903dec122b9d)(property > 32 ? $7b2d771130ddb761$export$f8483753829ec8f3(characters + ';', rule, parent, length - 1, declarations) : $7b2d771130ddb761$export$f8483753829ec8f3((0, $c3d91ae5e8302903$export$77ad94ebf1c2b9ed)(characters, ' ', '') + ';', rule, parent, length - 2, declarations), declarations);
                    break;
                // @ ;
                case 59:
                    characters += ';';
                // { rule/at-rule
                default:
                    (0, $c3d91ae5e8302903$export$10d8903dec122b9d)(reference = $7b2d771130ddb761$export$3307ffa7023ede1e(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length, rulesets), rulesets);
                    if (character === 123) {
                        if (offset === 0) $7b2d771130ddb761$export$98e6a39c04603d36(characters, root, reference, reference, props, rulesets, length, points, children);
                        else {
                            switch(atrule){
                                // c(ontainer)
                                case 99:
                                    if ((0, $c3d91ae5e8302903$export$a9db5e087081082d)(characters, 3) === 110) break;
                                // l(ayer)
                                case 108:
                                    if ((0, $c3d91ae5e8302903$export$a9db5e087081082d)(characters, 2) === 97) break;
                                default:
                                    offset = 0;
                                // d(ocument) m(edia) s(upports)
                                case 100:
                                case 109:
                                case 115:
                            }
                            if (offset) $7b2d771130ddb761$export$98e6a39c04603d36(value, reference, reference, rule && (0, $c3d91ae5e8302903$export$10d8903dec122b9d)($7b2d771130ddb761$export$3307ffa7023ede1e(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length, children), children), rules, children, length, points, rule ? props : children);
                            else $7b2d771130ddb761$export$98e6a39c04603d36(characters, reference, reference, reference, [
                                ''
                            ], children, 0, points, children);
                        }
                    }
            }
            index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
            break;
        // :
        case 58:
            length = 1 + (0, $c3d91ae5e8302903$export$36776f635604f274)(characters), property = previous;
        default:
            if (variable < 1) {
                if (character == 123) --variable;
                else if (character == 125 && variable++ == 0 && (0, $484971fb34ffaf82$export$232faf9add678146)() == 125) continue;
            }
            switch(characters += (0, $c3d91ae5e8302903$export$6788812c4e6611e6)(character), character * variable){
                // &
                case 38:
                    ampersand = offset > 0 ? 1 : (characters += '\f', -1);
                    break;
                // ,
                case 44:
                    points[index++] = ((0, $c3d91ae5e8302903$export$36776f635604f274)(characters) - 1) * ampersand, ampersand = 1;
                    break;
                // @
                case 64:
                    // -
                    if ((0, $484971fb34ffaf82$export$4d3fb11e950abb9e)() === 45) characters += (0, $484971fb34ffaf82$export$410ac95b9ec204b8)((0, $484971fb34ffaf82$export$48cfd1e771a65c4f)());
                    atrule = (0, $484971fb34ffaf82$export$4d3fb11e950abb9e)(), offset = length = (0, $c3d91ae5e8302903$export$36776f635604f274)(type = characters += (0, $484971fb34ffaf82$export$c2ab62c7bf24634)((0, $484971fb34ffaf82$export$e88cb2efb12ae807)())), character++;
                    break;
                // -
                case 45:
                    if (previous === 45 && (0, $c3d91ae5e8302903$export$36776f635604f274)(characters) == 2) variable = 0;
            }
    }
    return rulesets;
}
function $7b2d771130ddb761$export$3307ffa7023ede1e(value, root, parent, index, offset, rules, points, type, props, children, length, siblings) {
    var post = offset - 1;
    var rule = offset === 0 ? rules : [
        ''
    ];
    var size = (0, $c3d91ae5e8302903$export$f9084667e487ed46)(rule);
    for(var i = 0, j = 0, k = 0; i < index; ++i)for(var x = 0, y = (0, $c3d91ae5e8302903$export$2f35ab04d2335697)(value, post + 1, post = (0, $c3d91ae5e8302903$export$2335f513bbd82c6d)(j = points[i])), z = value; x < size; ++x)if (z = (0, $c3d91ae5e8302903$export$87c2784dc9fc4ab)(j > 0 ? rule[x] + ' ' + y : (0, $c3d91ae5e8302903$export$77ad94ebf1c2b9ed)(y, /&\f/g, rule[x]))) props[k++] = z;
    return (0, $484971fb34ffaf82$export$35059013cd4a06db)(value, root, parent, offset === 0 ? (0, $2f8d19f61bf0d402$export$aa3a2e812ca8570d) : type, props, children, length, siblings);
}
function $7b2d771130ddb761$export$4a34f930e789283c(value, root, parent, siblings) {
    return (0, $484971fb34ffaf82$export$35059013cd4a06db)(value, root, parent, (0, $2f8d19f61bf0d402$export$a29989082612d0d9), (0, $c3d91ae5e8302903$export$6788812c4e6611e6)((0, $484971fb34ffaf82$export$eba6f6f03b0a92e7)()), (0, $c3d91ae5e8302903$export$2f35ab04d2335697)(value, 2, -2), 0, siblings);
}
function $7b2d771130ddb761$export$f8483753829ec8f3(value, root, parent, length, siblings) {
    return (0, $484971fb34ffaf82$export$35059013cd4a06db)(value, root, parent, (0, $2f8d19f61bf0d402$export$527d108ccf083c2b), (0, $c3d91ae5e8302903$export$2f35ab04d2335697)(value, 0, length), (0, $c3d91ae5e8302903$export$2f35ab04d2335697)(value, length + 1, -1), length, siblings);
}






function $92467c9cba6cca55$export$dfdc1655ccc5b9cb(children, callback) {
    var output = '';
    for(var i = 0; i < children.length; i++)output += callback(children[i], i, children, callback) || '';
    return output;
}
function $92467c9cba6cca55$export$fac44ee5b035f737(element, index, children, callback) {
    switch(element.type){
        case 0, $2f8d19f61bf0d402$export$d773506282b3cfe6:
            if (element.children.length) break;
        case 0, $2f8d19f61bf0d402$export$a763edbf796b780a:
        case 0, $2f8d19f61bf0d402$export$6aad947bda0f3f46:
        case 0, $2f8d19f61bf0d402$export$527d108ccf083c2b:
            return element.return = element.return || element.value;
        case 0, $2f8d19f61bf0d402$export$a29989082612d0d9:
            return '';
        case 0, $2f8d19f61bf0d402$export$b44a8529a35fcb60:
            return element.return = element.value + '{' + $92467c9cba6cca55$export$dfdc1655ccc5b9cb(element.children, callback) + '}';
        case 0, $2f8d19f61bf0d402$export$aa3a2e812ca8570d:
            if (!(0, $c3d91ae5e8302903$export$36776f635604f274)(element.value = element.props.join(','))) return '';
    }
    return (0, $c3d91ae5e8302903$export$36776f635604f274)(children = $92467c9cba6cca55$export$dfdc1655ccc5b9cb(element.children, callback)) ? element.return = element.value + '{' + children + '}' : '';
}




function $b2ca244ce058f9c6$export$82e9f45cca5ba907(value, length, children) {
    switch((0, $c3d91ae5e8302903$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $2f8d19f61bf0d402$export$39dfd62a25e0fe93) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
        // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
            return (0, $2f8d19f61bf0d402$export$39dfd62a25e0fe93) + value + value;
        // mask-composite
        case 4855:
            return (0, $2f8d19f61bf0d402$export$39dfd62a25e0fe93) + value.replace('add', 'source-over').replace('substract', 'source-out').replace('intersect', 'source-in').replace('exclude', 'xor') + value;
        // tab-size
        case 4789:
            return (0, $2f8d19f61bf0d402$export$2c0f367103c8d01c) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $2f8d19f61bf0d402$export$39dfd62a25e0fe93) + value + (0, $2f8d19f61bf0d402$export$2c0f367103c8d01c) + value + (0, $2f8d19f61bf0d402$export$71ad59f2e432cfe8) + value + value;
        // writing-mode
        case 5936:
            switch((0, $c3d91ae5e8302903$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $2f8d19f61bf0d402$export$39dfd62a25e0fe93) + value + (0, $2f8d19f61bf0d402$export$71ad59f2e432cfe8) + (0, $c3d91ae5e8302903$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $2f8d19f61bf0d402$export$39dfd62a25e0fe93) + value + (0, $2f8d19f61bf0d402$export$71ad59f2e432cfe8) + (0, $c3d91ae5e8302903$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $2f8d19f61bf0d402$export$39dfd62a25e0fe93) + value + (0, $2f8d19f61bf0d402$export$71ad59f2e432cfe8) + (0, $c3d91ae5e8302903$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
        // flex, flex-direction, scroll-snap-type, writing-mode
        case 6828:
        case 4268:
        case 2903:
            return (0, $2f8d19f61bf0d402$export$39dfd62a25e0fe93) + value + (0, $2f8d19f61bf0d402$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $2f8d19f61bf0d402$export$39dfd62a25e0fe93) + value + (0, $2f8d19f61bf0d402$export$71ad59f2e432cfe8) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $2f8d19f61bf0d402$export$39dfd62a25e0fe93) + value + (0, $c3d91ae5e8302903$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $2f8d19f61bf0d402$export$39dfd62a25e0fe93) + 'box-$1$2' + (0, $2f8d19f61bf0d402$export$71ad59f2e432cfe8) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $2f8d19f61bf0d402$export$39dfd62a25e0fe93) + value + (0, $2f8d19f61bf0d402$export$71ad59f2e432cfe8) + 'flex-item-' + (0, $c3d91ae5e8302903$export$77ad94ebf1c2b9ed)(value, /flex-|-self/g, '') + (!(0, $c3d91ae5e8302903$export$4659b591c19bdf3d)(value, /flex-|baseline/) ? (0, $2f8d19f61bf0d402$export$71ad59f2e432cfe8) + 'grid-row-' + (0, $c3d91ae5e8302903$export$77ad94ebf1c2b9ed)(value, /flex-|-self/g, '') : '') + value;
        // align-content
        case 4675:
            return (0, $2f8d19f61bf0d402$export$39dfd62a25e0fe93) + value + (0, $2f8d19f61bf0d402$export$71ad59f2e432cfe8) + 'flex-line-pack' + (0, $c3d91ae5e8302903$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/g, '') + value;
        // flex-shrink
        case 5548:
            return (0, $2f8d19f61bf0d402$export$39dfd62a25e0fe93) + value + (0, $2f8d19f61bf0d402$export$71ad59f2e432cfe8) + (0, $c3d91ae5e8302903$export$77ad94ebf1c2b9ed)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $2f8d19f61bf0d402$export$39dfd62a25e0fe93) + value + (0, $2f8d19f61bf0d402$export$71ad59f2e432cfe8) + (0, $c3d91ae5e8302903$export$77ad94ebf1c2b9ed)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $2f8d19f61bf0d402$export$39dfd62a25e0fe93) + 'box-' + (0, $c3d91ae5e8302903$export$77ad94ebf1c2b9ed)(value, '-grow', '') + (0, $2f8d19f61bf0d402$export$39dfd62a25e0fe93) + value + (0, $2f8d19f61bf0d402$export$71ad59f2e432cfe8) + (0, $c3d91ae5e8302903$export$77ad94ebf1c2b9ed)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $2f8d19f61bf0d402$export$39dfd62a25e0fe93) + (0, $c3d91ae5e8302903$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, '$1' + (0, $2f8d19f61bf0d402$export$39dfd62a25e0fe93) + '$2') + value;
        // cursor
        case 6187:
            return (0, $c3d91ae5e8302903$export$77ad94ebf1c2b9ed)((0, $c3d91ae5e8302903$export$77ad94ebf1c2b9ed)((0, $c3d91ae5e8302903$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $2f8d19f61bf0d402$export$39dfd62a25e0fe93) + '$1'), /(image-set)/, (0, $2f8d19f61bf0d402$export$39dfd62a25e0fe93) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $c3d91ae5e8302903$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $2f8d19f61bf0d402$export$39dfd62a25e0fe93) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $c3d91ae5e8302903$export$77ad94ebf1c2b9ed)((0, $c3d91ae5e8302903$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $2f8d19f61bf0d402$export$39dfd62a25e0fe93) + 'box-pack:$3' + (0, $2f8d19f61bf0d402$export$71ad59f2e432cfe8) + 'flex-pack:$3'), /space-between/, 'justify') + (0, $2f8d19f61bf0d402$export$39dfd62a25e0fe93) + value + value;
        // justify-self
        case 4200:
            if (!(0, $c3d91ae5e8302903$export$4659b591c19bdf3d)(value, /flex-|baseline/)) return (0, $2f8d19f61bf0d402$export$71ad59f2e432cfe8) + 'grid-column-align' + (0, $c3d91ae5e8302903$export$2f35ab04d2335697)(value, length) + value;
            break;
        // grid-template-(columns|rows)
        case 2592:
        case 3360:
            return (0, $2f8d19f61bf0d402$export$71ad59f2e432cfe8) + (0, $c3d91ae5e8302903$export$77ad94ebf1c2b9ed)(value, 'template-', '') + value;
        // grid-(row|column)-start
        case 4384:
        case 3616:
            if (children && children.some(function(element, index) {
                return length = index, (0, $c3d91ae5e8302903$export$4659b591c19bdf3d)(element.props, /grid-\w+-end/);
            })) return ~(0, $c3d91ae5e8302903$export$f8e21b1e77979a08)(value + (children = children[length].value), 'span', 0) ? value : (0, $2f8d19f61bf0d402$export$71ad59f2e432cfe8) + (0, $c3d91ae5e8302903$export$77ad94ebf1c2b9ed)(value, '-start', '') + value + (0, $2f8d19f61bf0d402$export$71ad59f2e432cfe8) + 'grid-row-span:' + (~(0, $c3d91ae5e8302903$export$f8e21b1e77979a08)(children, 'span', 0) ? (0, $c3d91ae5e8302903$export$4659b591c19bdf3d)(children, /\d+/) : +(0, $c3d91ae5e8302903$export$4659b591c19bdf3d)(children, /\d+/) - +(0, $c3d91ae5e8302903$export$4659b591c19bdf3d)(value, /\d+/)) + ';';
            return (0, $2f8d19f61bf0d402$export$71ad59f2e432cfe8) + (0, $c3d91ae5e8302903$export$77ad94ebf1c2b9ed)(value, '-start', '') + value;
        // grid-(row|column)-end
        case 4896:
        case 4128:
            return children && children.some(function(element) {
                return (0, $c3d91ae5e8302903$export$4659b591c19bdf3d)(element.props, /grid-\w+-start/);
            }) ? value : (0, $2f8d19f61bf0d402$export$71ad59f2e432cfe8) + (0, $c3d91ae5e8302903$export$77ad94ebf1c2b9ed)((0, $c3d91ae5e8302903$export$77ad94ebf1c2b9ed)(value, '-end', '-span'), 'span ', '') + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $c3d91ae5e8302903$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $2f8d19f61bf0d402$export$39dfd62a25e0fe93) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $c3d91ae5e8302903$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $c3d91ae5e8302903$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $c3d91ae5e8302903$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $c3d91ae5e8302903$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $2f8d19f61bf0d402$export$39dfd62a25e0fe93) + '$2-$3' + '$1' + (0, $2f8d19f61bf0d402$export$2c0f367103c8d01c) + ((0, $c3d91ae5e8302903$export$a9db5e087081082d)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $c3d91ae5e8302903$export$f8e21b1e77979a08)(value, 'stretch', 0) ? $b2ca244ce058f9c6$export$82e9f45cca5ba907((0, $c3d91ae5e8302903$export$77ad94ebf1c2b9ed)(value, 'stretch', 'fill-available'), length, children) + value : value;
            }
            break;
        // grid-(column|row)
        case 5152:
        case 5920:
            return (0, $c3d91ae5e8302903$export$77ad94ebf1c2b9ed)(value, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(_, a, b, c, d, e, f) {
                return (0, $2f8d19f61bf0d402$export$71ad59f2e432cfe8) + a + ':' + b + f + (c ? (0, $2f8d19f61bf0d402$export$71ad59f2e432cfe8) + a + '-span:' + (d ? e : +e - +b) + f : '') + value;
            });
        // position: sticky
        case 4949:
            // stick(y)?
            if ((0, $c3d91ae5e8302903$export$a9db5e087081082d)(value, length + 6) === 121) return (0, $c3d91ae5e8302903$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $2f8d19f61bf0d402$export$39dfd62a25e0fe93)) + value;
            break;
        // display: (flex|inline-flex|grid|inline-grid)
        case 6444:
            switch((0, $c3d91ae5e8302903$export$a9db5e087081082d)(value, (0, $c3d91ae5e8302903$export$a9db5e087081082d)(value, 14) === 45 ? 18 : 11)){
                // (inline-)?fle(x)
                case 120:
                    return (0, $c3d91ae5e8302903$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, '$1' + (0, $2f8d19f61bf0d402$export$39dfd62a25e0fe93) + ((0, $c3d91ae5e8302903$export$a9db5e087081082d)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $2f8d19f61bf0d402$export$39dfd62a25e0fe93) + '$2$3' + '$1' + (0, $2f8d19f61bf0d402$export$71ad59f2e432cfe8) + '$2box$3') + value;
                // (inline-)?gri(d)
                case 100:
                    return (0, $c3d91ae5e8302903$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $2f8d19f61bf0d402$export$71ad59f2e432cfe8)) + value;
            }
            break;
        // scroll-margin, scroll-margin-(top|right|bottom|left)
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return (0, $c3d91ae5e8302903$export$77ad94ebf1c2b9ed)(value, 'scroll-', 'scroll-snap-') + value;
    }
    return value;
}


function $d465fef7d441fd5d$export$5a7767152ae0305f(collection) {
    var length = (0, $c3d91ae5e8302903$export$f9084667e487ed46)(collection);
    return function(element, index, children, callback) {
        var output = '';
        for(var i = 0; i < length; i++)output += collection[i](element, index, children, callback) || '';
        return output;
    };
}
function $d465fef7d441fd5d$export$38bcb760f1d4871c(callback) {
    return function(element) {
        if (!element.root) {
            if (element = element.return) callback(element);
        }
    };
}
function $d465fef7d441fd5d$export$e08c7d021b829b7a(element, index, children, callback) {
    if (element.length > -1) {
        if (!element.return) switch(element.type){
            case 0, $2f8d19f61bf0d402$export$527d108ccf083c2b:
                element.return = (0, $b2ca244ce058f9c6$export$82e9f45cca5ba907)(element.value, element.length, children);
                return;
            case 0, $2f8d19f61bf0d402$export$b44a8529a35fcb60:
                return (0, $92467c9cba6cca55$export$dfdc1655ccc5b9cb)([
                    (0, $484971fb34ffaf82$export$784d13d8ee351f07)(element, {
                        value: (0, $c3d91ae5e8302903$export$77ad94ebf1c2b9ed)(element.value, '@', '@' + (0, $2f8d19f61bf0d402$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $2f8d19f61bf0d402$export$aa3a2e812ca8570d:
                if (element.length) return (0, $c3d91ae5e8302903$export$1be1fc439b849fdf)(children = element.props, function(value) {
                    switch((0, $c3d91ae5e8302903$export$4659b591c19bdf3d)(value, callback = /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            (0, $484971fb34ffaf82$export$590e8b2c435046d9)((0, $484971fb34ffaf82$export$784d13d8ee351f07)(element, {
                                props: [
                                    (0, $c3d91ae5e8302903$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ':' + (0, $2f8d19f61bf0d402$export$2c0f367103c8d01c) + '$1')
                                ]
                            }));
                            (0, $484971fb34ffaf82$export$590e8b2c435046d9)((0, $484971fb34ffaf82$export$784d13d8ee351f07)(element, {
                                props: [
                                    value
                                ]
                            }));
                            (0, $c3d91ae5e8302903$export$e6e34fd1f2686227)(element, {
                                props: (0, $c3d91ae5e8302903$export$3dea766d36a8935f)(children, callback)
                            });
                            break;
                        // :placeholder
                        case '::placeholder':
                            (0, $484971fb34ffaf82$export$590e8b2c435046d9)((0, $484971fb34ffaf82$export$784d13d8ee351f07)(element, {
                                props: [
                                    (0, $c3d91ae5e8302903$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $2f8d19f61bf0d402$export$39dfd62a25e0fe93) + 'input-$1')
                                ]
                            }));
                            (0, $484971fb34ffaf82$export$590e8b2c435046d9)((0, $484971fb34ffaf82$export$784d13d8ee351f07)(element, {
                                props: [
                                    (0, $c3d91ae5e8302903$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $2f8d19f61bf0d402$export$2c0f367103c8d01c) + '$1')
                                ]
                            }));
                            (0, $484971fb34ffaf82$export$590e8b2c435046d9)((0, $484971fb34ffaf82$export$784d13d8ee351f07)(element, {
                                props: [
                                    (0, $c3d91ae5e8302903$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $2f8d19f61bf0d402$export$71ad59f2e432cfe8) + 'input-$1')
                                ]
                            }));
                            (0, $484971fb34ffaf82$export$590e8b2c435046d9)((0, $484971fb34ffaf82$export$784d13d8ee351f07)(element, {
                                props: [
                                    value
                                ]
                            }));
                            (0, $c3d91ae5e8302903$export$e6e34fd1f2686227)(element, {
                                props: (0, $c3d91ae5e8302903$export$3dea766d36a8935f)(children, callback)
                            });
                            break;
                    }
                    return '';
                });
        }
    }
}
function $d465fef7d441fd5d$export$76a88f7de6507443(element) {
    switch(element.type){
        case 0, $2f8d19f61bf0d402$export$aa3a2e812ca8570d:
            element.props = element.props.map(function(value) {
                return (0, $c3d91ae5e8302903$export$1be1fc439b849fdf)((0, $484971fb34ffaf82$export$660b2ee2d4fb4eff)(value), function(value, index, children) {
                    switch((0, $c3d91ae5e8302903$export$a9db5e087081082d)(value, 0)){
                        // \f
                        case 12:
                            return (0, $c3d91ae5e8302903$export$2f35ab04d2335697)(value, 1, (0, $c3d91ae5e8302903$export$36776f635604f274)(value));
                        // \0 ( + > ~
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return value;
                        // :
                        case 58:
                            if (children[++index] === 'global') children[index] = '', children[++index] = '\f' + (0, $c3d91ae5e8302903$export$2f35ab04d2335697)(children[index], index = 1, -1);
                        // \s
                        case 32:
                            return index === 1 ? '' : value;
                        default:
                            switch(index){
                                case 0:
                                    element = value;
                                    return (0, $c3d91ae5e8302903$export$f9084667e487ed46)(children) > 1 ? '' : value;
                                case index = (0, $c3d91ae5e8302903$export$f9084667e487ed46)(children) - 1:
                                case 2:
                                    return index === 2 ? value + element + element : value + element;
                                default:
                                    return value;
                            }
                    }
                });
            });
    }
}


var $f655ac91f53a7a3c$var$r, $f655ac91f53a7a3c$var$i;
const $f655ac91f53a7a3c$var$c = "data-styled", $f655ac91f53a7a3c$var$a = "active", $f655ac91f53a7a3c$var$l = "data-styled-version", $f655ac91f53a7a3c$export$83d89fbfd8236492 = "6.4.3", $f655ac91f53a7a3c$var$h = "/*!sc*/\n", $f655ac91f53a7a3c$var$d = "undefined" != typeof window && "undefined" != typeof document;
function $f655ac91f53a7a3c$var$p(e) {}
const $f655ac91f53a7a3c$var$f = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : null !== ($f655ac91f53a7a3c$var$i = null !== ($f655ac91f53a7a3c$var$r = $f655ac91f53a7a3c$var$p("REACT_APP_SC_DISABLE_SPEEDY")) && void 0 !== $f655ac91f53a7a3c$var$r ? $f655ac91f53a7a3c$var$r : $f655ac91f53a7a3c$var$p("SC_DISABLE_SPEEDY")) && void 0 !== $f655ac91f53a7a3c$var$i ? $f655ac91f53a7a3c$var$i : false), $f655ac91f53a7a3c$var$m = "sc-keyframes-", $f655ac91f53a7a3c$var$y = {}, $f655ac91f53a7a3c$var$g = {};
function $f655ac91f53a7a3c$var$v(e, ...t) {
    return new Error(`An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#${e} for more information.${t.length > 0 ? ` Args: ${t.join(", ")}` : ""}`);
}
const $f655ac91f53a7a3c$var$S = 1073741824;
let $f655ac91f53a7a3c$var$b = new Map, $f655ac91f53a7a3c$var$w = new Map, $f655ac91f53a7a3c$var$N = 1;
const $f655ac91f53a7a3c$var$C = (e)=>{
    if ($f655ac91f53a7a3c$var$b.has(e)) return $f655ac91f53a7a3c$var$b.get(e);
    for(; $f655ac91f53a7a3c$var$w.has($f655ac91f53a7a3c$var$N);)$f655ac91f53a7a3c$var$N++;
    const t = $f655ac91f53a7a3c$var$N++;
    return $f655ac91f53a7a3c$var$b.set(e, t), $f655ac91f53a7a3c$var$w.set(t, e), t;
}, $f655ac91f53a7a3c$var$O = (e)=>$f655ac91f53a7a3c$var$w.get(e), $f655ac91f53a7a3c$var$E = (e, t)=>{
    $f655ac91f53a7a3c$var$N = t + 1, $f655ac91f53a7a3c$var$b.set(e, t), $f655ac91f53a7a3c$var$w.set(t, e);
}, $f655ac91f53a7a3c$var$A = /invalid hook call/i, $f655ac91f53a7a3c$var$P = new Set, $f655ac91f53a7a3c$var$_ = (e, n)=>{
    var t, n1, e1;
}, $f655ac91f53a7a3c$var$I = Object.freeze([]), $f655ac91f53a7a3c$var$$ = Object.freeze({});
function $f655ac91f53a7a3c$var$R(e, t, n = $f655ac91f53a7a3c$var$$) {
    return e.theme !== n.theme && e.theme || t || n.theme;
}
const $f655ac91f53a7a3c$var$j = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $f655ac91f53a7a3c$var$x = /(^-|-$)/g;
function $f655ac91f53a7a3c$var$T(e) {
    return e.replace($f655ac91f53a7a3c$var$j, "-").replace($f655ac91f53a7a3c$var$x, "");
}
const $f655ac91f53a7a3c$var$k = /(a)(d)/gi, $f655ac91f53a7a3c$var$D = (e)=>String.fromCharCode(e + (e > 25 ? 39 : 97));
function $f655ac91f53a7a3c$var$V(e) {
    let t, n = "";
    for(t = Math.abs(e); t > 52; t = t / 52 | 0)n = $f655ac91f53a7a3c$var$D(t % 52) + n;
    return ($f655ac91f53a7a3c$var$D(t % 52) + n).replace($f655ac91f53a7a3c$var$k, "$1-$2");
}
const $f655ac91f53a7a3c$var$M = 5381, $f655ac91f53a7a3c$var$G = (e, t)=>{
    let n = t.length;
    for(; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $f655ac91f53a7a3c$var$F = (e)=>$f655ac91f53a7a3c$var$G($f655ac91f53a7a3c$var$M, e);
function $f655ac91f53a7a3c$var$z(e) {
    return $f655ac91f53a7a3c$var$V($f655ac91f53a7a3c$var$F(e) >>> 0);
}
function $f655ac91f53a7a3c$var$W(e) {
    return e.displayName || e.name || "Component";
}
function $f655ac91f53a7a3c$var$L(e) {
    return "string" == typeof e && true;
}
function $f655ac91f53a7a3c$var$B(e) {
    return $f655ac91f53a7a3c$var$L(e) ? `styled.${e}` : `Styled(${$f655ac91f53a7a3c$var$W(e)})`;
}
const $f655ac91f53a7a3c$var$q = Symbol.for("react.memo"), $f655ac91f53a7a3c$var$H = Symbol.for("react.forward_ref"), $f655ac91f53a7a3c$var$Y = {
    contextType: !0,
    defaultProps: !0,
    displayName: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    propTypes: !0,
    type: !0
}, $f655ac91f53a7a3c$var$U = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
}, $f655ac91f53a7a3c$var$J = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
}, $f655ac91f53a7a3c$var$X = {
    [$f655ac91f53a7a3c$var$H]: {
        $$typeof: !0,
        render: !0,
        defaultProps: !0,
        displayName: !0,
        propTypes: !0
    },
    [$f655ac91f53a7a3c$var$q]: $f655ac91f53a7a3c$var$J
};
function $f655ac91f53a7a3c$var$K(e) {
    var t;
    return ("type" in (t = e) && t.type.$$typeof) === $f655ac91f53a7a3c$var$q ? $f655ac91f53a7a3c$var$J : "$$typeof" in e ? $f655ac91f53a7a3c$var$X[e.$$typeof] : $f655ac91f53a7a3c$var$Y;
}
const $f655ac91f53a7a3c$var$Q = Object.defineProperty, $f655ac91f53a7a3c$var$Z = Object.getOwnPropertyNames, $f655ac91f53a7a3c$var$ee = Object.getOwnPropertySymbols, $f655ac91f53a7a3c$var$te = Object.getOwnPropertyDescriptor, $f655ac91f53a7a3c$var$ne = Object.getPrototypeOf, $f655ac91f53a7a3c$var$oe = Object.prototype;
function $f655ac91f53a7a3c$var$se(e, t, n) {
    if ("string" != typeof t) {
        const o = $f655ac91f53a7a3c$var$ne(t);
        o && o !== $f655ac91f53a7a3c$var$oe && $f655ac91f53a7a3c$var$se(e, o, n);
        const s = $f655ac91f53a7a3c$var$Z(t).concat($f655ac91f53a7a3c$var$ee(t)), r = $f655ac91f53a7a3c$var$K(e), i = $f655ac91f53a7a3c$var$K(t);
        for(let o = 0; o < s.length; ++o){
            const c = s[o];
            if (!(c in $f655ac91f53a7a3c$var$U || n && n[c] || i && c in i || r && c in r)) {
                const n = $f655ac91f53a7a3c$var$te(t, c);
                try {
                    $f655ac91f53a7a3c$var$Q(e, c, n);
                } catch (e) {}
            }
        }
    }
    return e;
}
function $f655ac91f53a7a3c$var$re(e) {
    return "function" == typeof e;
}
const $f655ac91f53a7a3c$var$ie = Symbol.for("react.forward_ref");
function $f655ac91f53a7a3c$export$7ba318d8d2f06c76(e) {
    return null != e && ("object" == typeof e || "function" == typeof e) && e.$$typeof === $f655ac91f53a7a3c$var$ie && "styledComponentId" in e;
}
function $f655ac91f53a7a3c$var$ae(e, t) {
    return e && t ? e + " " + t : e || t || "";
}
function $f655ac91f53a7a3c$var$le(e, t) {
    return e.join(t || "");
}
function $f655ac91f53a7a3c$var$ue(e) {
    return null !== e && "object" == typeof e && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function $f655ac91f53a7a3c$var$he(e, t, n = !1) {
    if (!n && !$f655ac91f53a7a3c$var$ue(e) && !Array.isArray(e)) return t;
    if (Array.isArray(t)) for(let n = 0; n < t.length; n++)e[n] = $f655ac91f53a7a3c$var$he(e[n], t[n]);
    else if ($f655ac91f53a7a3c$var$ue(t)) for(const n in t)e[n] = $f655ac91f53a7a3c$var$he(e[n], t[n]);
    return e;
}
function $f655ac91f53a7a3c$var$de(e, t) {
    Object.defineProperty(e, "toString", {
        value: t
    });
}
const $f655ac91f53a7a3c$var$pe = class {
    constructor(e){
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e, this._cGroup = 0, this._cIndex = 0;
    }
    indexOfGroup(e) {
        if (e === this._cGroup) return this._cIndex;
        let t = this._cIndex;
        if (e > this._cGroup) for(let n = this._cGroup; n < e; n++)t += this.groupSizes[n];
        else for(let n = this._cGroup - 1; n >= e; n--)t -= this.groupSizes[n];
        return this._cGroup = e, this._cIndex = t, t;
    }
    insertRules(e, t) {
        if (e >= this.groupSizes.length) {
            const t = this.groupSizes, n = t.length;
            let o = n;
            for(; e >= o;)if (o <<= 1, o < 0) throw $f655ac91f53a7a3c$var$v(16, `${e}`);
            this.groupSizes = new Uint32Array(o), this.groupSizes.set(t), this.length = o;
            for(let e = n; e < o; e++)this.groupSizes[e] = 0;
        }
        let n = this.indexOfGroup(e + 1), o = 0;
        for(let s = 0, r = t.length; s < r; s++)this.tag.insertRule(n, t[s]) && (this.groupSizes[e]++, n++, o++);
        o > 0 && this._cGroup > e && (this._cIndex += o);
    }
    clearGroup(e) {
        if (e < this.length) {
            const t = this.groupSizes[e], n = this.indexOfGroup(e), o = n + t;
            this.groupSizes[e] = 0;
            for(let e = n; e < o; e++)this.tag.deleteRule(n);
            t > 0 && this._cGroup > e && (this._cIndex -= t);
        }
    }
    getGroup(e) {
        let t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        const n = this.groupSizes[e], o = this.indexOfGroup(e), s = o + n;
        for(let e = o; e < s; e++)t += this.tag.getRule(e) + $f655ac91f53a7a3c$var$h;
        return t;
    }
}, $f655ac91f53a7a3c$var$fe = `style[${$f655ac91f53a7a3c$var$c}][${$f655ac91f53a7a3c$var$l}="${$f655ac91f53a7a3c$export$83d89fbfd8236492}"]`, $f655ac91f53a7a3c$var$me = new RegExp(`^${$f655ac91f53a7a3c$var$c}\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)`), $f655ac91f53a7a3c$var$ye = (e)=>"undefined" != typeof ShadowRoot && e instanceof ShadowRoot || "host" in e && 11 === e.nodeType, $f655ac91f53a7a3c$var$ge = (e)=>{
    if (!e) return document;
    if ($f655ac91f53a7a3c$var$ye(e)) return e;
    if ("getRootNode" in e) {
        const t = e.getRootNode();
        if ($f655ac91f53a7a3c$var$ye(t)) return t;
    }
    return document;
}, $f655ac91f53a7a3c$var$ve = (e, t, n)=>{
    const o = n.split(",");
    let s;
    for(let n = 0, r = o.length; n < r; n++)(s = o[n]) && e.registerName(t, s);
}, $f655ac91f53a7a3c$var$Se = (e, t)=>{
    var n;
    const o = (null !== (n = t.textContent) && void 0 !== n ? n : "").split($f655ac91f53a7a3c$var$h), s = [];
    for(let t = 0, n = o.length; t < n; t++){
        const n = o[t].trim();
        if (!n) continue;
        const r = n.match($f655ac91f53a7a3c$var$me);
        if (r) {
            const t = 0 | parseInt(r[1], 10), n = r[2];
            0 !== t && ($f655ac91f53a7a3c$var$E(n, t), $f655ac91f53a7a3c$var$ve(e, n, r[3]), e.getTag().insertRules(t, s)), s.length = 0;
        } else s.push(n);
    }
}, $f655ac91f53a7a3c$var$be = (e)=>{
    const t = $f655ac91f53a7a3c$var$ge(e.options.target).querySelectorAll($f655ac91f53a7a3c$var$fe);
    for(let n = 0, o = t.length; n < o; n++){
        const o = t[n];
        o && o.getAttribute($f655ac91f53a7a3c$var$c) !== $f655ac91f53a7a3c$var$a && ($f655ac91f53a7a3c$var$Se(e, o), o.parentNode && o.parentNode.removeChild(o));
    }
};
let $f655ac91f53a7a3c$var$we = !1;
function $f655ac91f53a7a3c$var$Ne() {
    if (!1 !== $f655ac91f53a7a3c$var$we) return $f655ac91f53a7a3c$var$we;
    if ("undefined" != typeof document) {
        const e = document.head.querySelector('meta[property="csp-nonce"]');
        if (e) return $f655ac91f53a7a3c$var$we = e.nonce || e.getAttribute("content") || void 0;
        const t = document.head.querySelector('meta[name="sc-nonce"]');
        if (t) return $f655ac91f53a7a3c$var$we = t.getAttribute("content") || void 0;
    }
    return $f655ac91f53a7a3c$var$we = "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : void 0;
}
const $f655ac91f53a7a3c$var$Ce = (e, t)=>{
    const n = document.head, o = e || n, s = document.createElement("style"), r = ((e)=>{
        const t = Array.from(e.querySelectorAll(`style[${$f655ac91f53a7a3c$var$c}]`));
        return t[t.length - 1];
    })(o), i = void 0 !== r ? r.nextSibling : null;
    s.setAttribute($f655ac91f53a7a3c$var$c, $f655ac91f53a7a3c$var$a), s.setAttribute($f655ac91f53a7a3c$var$l, $f655ac91f53a7a3c$export$83d89fbfd8236492);
    const h = t || $f655ac91f53a7a3c$var$Ne();
    return h && s.setAttribute("nonce", h), o.insertBefore(s, i), s;
}, $f655ac91f53a7a3c$var$Oe = class {
    constructor(e, t){
        this.element = $f655ac91f53a7a3c$var$Ce(e, t), this.element.appendChild(document.createTextNode("")), this.sheet = ((e)=>{
            var t;
            if (e.sheet) return e.sheet;
            const n = null !== (t = e.getRootNode().styleSheets) && void 0 !== t ? t : document.styleSheets;
            for(let t = 0, o = n.length; t < o; t++){
                const o = n[t];
                if (o.ownerNode === e) return o;
            }
            throw $f655ac91f53a7a3c$var$v(17);
        })(this.element), this.length = 0;
    }
    insertRule(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }
    deleteRule(e) {
        this.sheet.deleteRule(e), this.length--;
    }
    getRule(e) {
        const t = this.sheet.cssRules[e];
        return t && t.cssText ? t.cssText : "";
    }
}, $f655ac91f53a7a3c$var$Ee = class {
    constructor(e, t){
        this.element = $f655ac91f53a7a3c$var$Ce(e, t), this.nodes = this.element.childNodes, this.length = 0;
    }
    insertRule(e, t) {
        if (e <= this.length && e >= 0) {
            const n = document.createTextNode(t);
            return this.element.insertBefore(n, this.nodes[e] || null), this.length++, !0;
        }
        return !1;
    }
    deleteRule(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }
    getRule(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }
};
let $f655ac91f53a7a3c$var$Ae = $f655ac91f53a7a3c$var$d;
const $f655ac91f53a7a3c$var$Pe = {
    isServer: !$f655ac91f53a7a3c$var$d,
    useCSSOMInjection: !$f655ac91f53a7a3c$var$f
};
class $f655ac91f53a7a3c$var$_e {
    static registerId(e) {
        return $f655ac91f53a7a3c$var$C(e);
    }
    constructor(e = $f655ac91f53a7a3c$var$$, t = {}, n){
        this.options = Object.assign(Object.assign({}, $f655ac91f53a7a3c$var$Pe), e), this.gs = t, this.keyframeIds = new Set, this.names = new Map(n), this.server = !!e.isServer, !this.server && $f655ac91f53a7a3c$var$d && $f655ac91f53a7a3c$var$Ae && ($f655ac91f53a7a3c$var$Ae = !1, $f655ac91f53a7a3c$var$be(this)), $f655ac91f53a7a3c$var$de(this, ()=>((e)=>{
                const t = e.getTag(), { length: n } = t;
                let o = "";
                for(let s = 0; s < n; s++){
                    const n = $f655ac91f53a7a3c$var$O(s);
                    if (void 0 === n) continue;
                    const r = e.names.get(n);
                    if (void 0 === r || !r.size) continue;
                    const i = t.getGroup(s);
                    if (0 === i.length) continue;
                    const a = $f655ac91f53a7a3c$var$c + ".g" + s + '[id="' + n + '"]';
                    let l = "";
                    for (const e of r)e.length > 0 && (l += e + ",");
                    o += i + a + '{content:"' + l + '"}' + $f655ac91f53a7a3c$var$h;
                }
                return o;
            })(this));
    }
    rehydrate() {
        !this.server && $f655ac91f53a7a3c$var$d && $f655ac91f53a7a3c$var$be(this);
    }
    reconstructWithOptions(e, t = !0) {
        const n = new $f655ac91f53a7a3c$var$_e(Object.assign(Object.assign({}, this.options), e), this.gs, t && this.names || void 0);
        return n.keyframeIds = new Set(this.keyframeIds), !this.server && $f655ac91f53a7a3c$var$d && e.target !== this.options.target && $f655ac91f53a7a3c$var$ge(this.options.target) !== $f655ac91f53a7a3c$var$ge(e.target) && $f655ac91f53a7a3c$var$be(n), n;
    }
    allocateGSInstance(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }
    getTag() {
        var e;
        return this.tag || (this.tag = (e = (({ useCSSOMInjection: e, target: t, nonce: n })=>e ? new $f655ac91f53a7a3c$var$Oe(t, n) : new $f655ac91f53a7a3c$var$Ee(t, n))(this.options), new $f655ac91f53a7a3c$var$pe(e)));
    }
    hasNameForId(e, t) {
        var n, o;
        return null !== (o = null === (n = this.names.get(e)) || void 0 === n ? void 0 : n.has(t)) && void 0 !== o && o;
    }
    registerName(e, t) {
        $f655ac91f53a7a3c$var$C(e), e.startsWith($f655ac91f53a7a3c$var$m) && this.keyframeIds.add(e);
        const n = this.names.get(e);
        n ? n.add(t) : this.names.set(e, new Set([
            t
        ]));
    }
    insertRules(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($f655ac91f53a7a3c$var$C(e), n);
    }
    clearNames(e) {
        this.names.has(e) && this.names.get(e).clear();
    }
    clearRules(e) {
        this.getTag().clearGroup($f655ac91f53a7a3c$var$C(e)), this.clearNames(e);
    }
    clearTag() {
        this.tag = void 0;
    }
}
const $f655ac91f53a7a3c$var$Ie = new WeakSet, $f655ac91f53a7a3c$var$$e = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexShrink: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
function $f655ac91f53a7a3c$var$Re(e, t) {
    return null == t || "boolean" == typeof t || "" === t ? "" : "number" != typeof t || 0 === t || e in $f655ac91f53a7a3c$var$$e || e.startsWith("--") ? String(t).trim() : t + "px";
}
const $f655ac91f53a7a3c$var$je = 47;
function $f655ac91f53a7a3c$var$xe(e) {
    if (45 === e.charCodeAt(0) && 45 === e.charCodeAt(1)) return e;
    let t = "";
    for(let n = 0; n < e.length; n++){
        const o = e.charCodeAt(n);
        t += o >= 65 && o <= 90 ? "-" + String.fromCharCode(o + 32) : e[n];
    }
    return t.startsWith("ms-") ? "-" + t : t;
}
const $f655ac91f53a7a3c$var$Te = Symbol.for("sc-keyframes");
function $f655ac91f53a7a3c$var$ke(e) {
    return "object" == typeof e && null !== e && $f655ac91f53a7a3c$var$Te in e;
}
function $f655ac91f53a7a3c$var$De(e) {
    return $f655ac91f53a7a3c$var$re(e) && !(e.prototype && e.prototype.isReactComponent);
}
const $f655ac91f53a7a3c$var$Ve = (e)=>null == e || !1 === e || "" === e, $f655ac91f53a7a3c$var$Me = Symbol.for("react.client.reference");
function $f655ac91f53a7a3c$var$Ge(e) {
    return e.$$typeof === $f655ac91f53a7a3c$var$Me;
}
function $f655ac91f53a7a3c$var$Fe(e) {
    const t = e.$$id, n = (t && t.includes("#") ? t.split("#").pop() : t) || e.name || "unknown";
    console.warn(`Interpolating a client component (${n}) as a selector is not supported in server components. The component selector pattern requires access to the component's internal class name, which is not available across the server/client boundary. Use a plain CSS class selector instead.`);
}
function $f655ac91f53a7a3c$var$ze(e, t) {
    for(const n in e){
        const o = e[n];
        e.hasOwnProperty(n) && !$f655ac91f53a7a3c$var$Ve(o) && (Array.isArray(o) && $f655ac91f53a7a3c$var$Ie.has(o) || $f655ac91f53a7a3c$var$re(o) ? t.push($f655ac91f53a7a3c$var$xe(n) + ":", o, ";") : $f655ac91f53a7a3c$var$ue(o) ? (t.push(n + " {"), $f655ac91f53a7a3c$var$ze(o, t), t.push("}")) : t.push($f655ac91f53a7a3c$var$xe(n) + ": " + $f655ac91f53a7a3c$var$Re(n, o) + ";"));
    }
}
function $f655ac91f53a7a3c$var$We(e, t, n, o, s = []) {
    if ($f655ac91f53a7a3c$var$Ve(e)) return s;
    const r = typeof e;
    if ("string" === r) return s.push(e), s;
    if ("function" === r) {
        if ($f655ac91f53a7a3c$var$Ge(e)) return s;
        if ($f655ac91f53a7a3c$var$De(e) && t) {
            const r = e(t);
            return $f655ac91f53a7a3c$var$We(r, t, n, o, s);
        }
        return s.push(e), s;
    }
    if (Array.isArray(e)) {
        for(let r = 0; r < e.length; r++)$f655ac91f53a7a3c$var$We(e[r], t, n, o, s);
        return s;
    }
    return $f655ac91f53a7a3c$export$7ba318d8d2f06c76(e) ? (s.push(`.${e.styledComponentId}`), s) : $f655ac91f53a7a3c$var$ke(e) ? (n ? (e.inject(n, o), s.push(e.getName(o))) : s.push(e), s) : $f655ac91f53a7a3c$var$Ge(e) ? s : $f655ac91f53a7a3c$var$ue(e) ? e.toString !== Object.prototype.toString ? (s.push(e.toString()), s) : ($f655ac91f53a7a3c$var$ze(e, s), s) : (s.push(e.toString()), s);
}
const $f655ac91f53a7a3c$var$Le = $f655ac91f53a7a3c$var$F($f655ac91f53a7a3c$export$83d89fbfd8236492);
class $f655ac91f53a7a3c$var$Be {
    constructor(e, t, n){
        this.rules = e, this.componentId = t, this.baseHash = $f655ac91f53a7a3c$var$G($f655ac91f53a7a3c$var$Le, t), this.baseStyle = n, $f655ac91f53a7a3c$var$_e.registerId(t);
    }
    generateAndInjectStyles(e, t, n) {
        let o = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, t, n) : "";
        {
            let s = "";
            for(let o = 0; o < this.rules.length; o++){
                const r = this.rules[o];
                if ("string" == typeof r) s += r;
                else if (r) {
                    if ($f655ac91f53a7a3c$var$De(r)) {
                        const o = r(e);
                        "string" == typeof o ? s += o : null != o && !1 !== o && (s += $f655ac91f53a7a3c$var$le($f655ac91f53a7a3c$var$We(o, e, t, n)));
                    } else s += $f655ac91f53a7a3c$var$le($f655ac91f53a7a3c$var$We(r, e, t, n));
                }
            }
            if (s) {
                this.dynamicNameCache || (this.dynamicNameCache = new Map);
                const e = n.hash ? n.hash + s : s;
                let r = this.dynamicNameCache.get(e);
                if (!r) {
                    if (r = $f655ac91f53a7a3c$var$V($f655ac91f53a7a3c$var$G($f655ac91f53a7a3c$var$G(this.baseHash, n.hash), s) >>> 0), this.dynamicNameCache.size >= 200) {
                        const e = this.dynamicNameCache.keys().next().value;
                        void 0 !== e && this.dynamicNameCache.delete(e);
                    }
                    this.dynamicNameCache.set(e, r);
                }
                if (!t.hasNameForId(this.componentId, r)) {
                    const e = n(s, "." + r, void 0, this.componentId);
                    t.insertRules(this.componentId, r, e);
                }
                o = $f655ac91f53a7a3c$var$ae(o, r);
            }
        }
        return o;
    }
}
const $f655ac91f53a7a3c$var$qe = /&/g;
function $f655ac91f53a7a3c$var$He(e, t) {
    let n = 0;
    for(; --t >= 0 && 92 === e.charCodeAt(t);)n++;
    return !(1 & ~n);
}
function $f655ac91f53a7a3c$var$Ye(e) {
    const t = e.length;
    let n = "", o = 0, s = 0, r = 0, i = !1, c = !1;
    for(let a = 0; a < t; a++){
        const l = e.charCodeAt(a);
        if (0 !== r || i || l !== $f655ac91f53a7a3c$var$je || 42 !== e.charCodeAt(a + 1)) {
            if (i) 42 === l && e.charCodeAt(a + 1) === $f655ac91f53a7a3c$var$je && (i = !1, a++);
            else if (34 !== l && 39 !== l || $f655ac91f53a7a3c$var$He(e, a)) {
                if (0 === r) {
                    if (123 === l) s++;
                    else if (125 === l) {
                        if (s--, s < 0) {
                            c = !0;
                            let n = a + 1;
                            for(; n < t;){
                                const t = e.charCodeAt(n);
                                if (59 === t || 10 === t) break;
                                n++;
                            }
                            n < t && 59 === e.charCodeAt(n) && n++, s = 0, a = n - 1, o = n;
                            continue;
                        }
                        0 === s && (n += e.substring(o, a + 1), o = a + 1);
                    } else 59 === l && 0 === s && (n += e.substring(o, a + 1), o = a + 1);
                }
            } else 0 === r ? r = l : r === l && (r = 0);
        } else i = !0, a++;
    }
    return c || 0 !== s || 0 !== r ? (o < t && 0 === s && 0 === r && (n += e.substring(o)), n) : e;
}
function $f655ac91f53a7a3c$var$Ue(e, t) {
    const n = t + " ", o = "," + n;
    for(let s = 0; s < e.length; s++){
        const r = e[s];
        if ("rule" === r.type) {
            r.value = (n + r.value).replaceAll(",", o);
            const e = r.props, t = [];
            for(let o = 0; o < e.length; o++)t[o] = n + e[o];
            r.props = t;
        }
        Array.isArray(r.children) && "@keyframes" !== r.type && $f655ac91f53a7a3c$var$Ue(r.children, t);
    }
    return e;
}
function $f655ac91f53a7a3c$var$Je({ options: e = $f655ac91f53a7a3c$var$$, plugins: t = $f655ac91f53a7a3c$var$I } = $f655ac91f53a7a3c$var$$) {
    let n, s, r;
    const i = (e, t, o)=>o.startsWith(s) && o.endsWith(s) && o.replaceAll(s, "").length > 0 ? `.${n}` : e, c = t.slice();
    c.push((e)=>{
        e.type === $2f8d19f61bf0d402$export$aa3a2e812ca8570d && e.value.includes("&") && (r || (r = new RegExp(`\\${s}\\b`, "g")), e.props[0] = e.props[0].replace($f655ac91f53a7a3c$var$qe, s).replace(r, i));
    }), e.prefix && c.push($d465fef7d441fd5d$export$e08c7d021b829b7a), c.push($92467c9cba6cca55$export$fac44ee5b035f737);
    let a = [];
    const l = $d465fef7d441fd5d$export$5a7767152ae0305f(c.concat($d465fef7d441fd5d$export$38bcb760f1d4871c((e)=>a.push(e)))), u = (t, i = "", c = "", u = "&")=>{
        n = u, s = i, r = void 0;
        const h = function(e) {
            const t = -1 !== e.indexOf("//"), n = -1 !== e.indexOf("}");
            if (!t && !n) return e;
            if (!t) return $f655ac91f53a7a3c$var$Ye(e);
            const o = e.length;
            let s = "", r = 0, i = 0, c = 0, a = 0, l = 0, u = !1;
            for(; i < o;){
                const t = e.charCodeAt(i);
                if (34 !== t && 39 !== t || $f655ac91f53a7a3c$var$He(e, i)) {
                    if (0 === c) {
                        if (t === $f655ac91f53a7a3c$var$je && i + 1 < o && 42 === e.charCodeAt(i + 1)) {
                            for(i += 2; i + 1 < o && (42 !== e.charCodeAt(i) || e.charCodeAt(i + 1) !== $f655ac91f53a7a3c$var$je);)i++;
                            i += 2;
                        } else if (40 !== t) {
                            if (41 !== t) {
                                if (a > 0) i++;
                                else if (42 === t && i + 1 < o && e.charCodeAt(i + 1) === $f655ac91f53a7a3c$var$je) s += e.substring(r, i), i += 2, r = i, u = !0;
                                else if (t === $f655ac91f53a7a3c$var$je && i + 1 < o && e.charCodeAt(i + 1) === $f655ac91f53a7a3c$var$je) {
                                    for(s += e.substring(r, i); i < o && 10 !== e.charCodeAt(i);)i++;
                                    r = i, u = !0;
                                } else 123 === t ? l++ : 125 === t && l--, i++;
                            } else a > 0 && a--, i++;
                        } else a++, i++;
                    } else i++;
                } else 0 === c ? c = t : c === t && (c = 0), i++;
            }
            return u ? (r < o && (s += e.substring(r)), 0 === l ? s : $f655ac91f53a7a3c$var$Ye(s)) : 0 === l ? e : $f655ac91f53a7a3c$var$Ye(e);
        }(t);
        let d = $7b2d771130ddb761$export$ef7acd7185315e22(c || i ? c + " " + i + " { " + h + " }" : h);
        return e.namespace && (d = $f655ac91f53a7a3c$var$Ue(d, e.namespace)), a = [], $92467c9cba6cca55$export$dfdc1655ccc5b9cb(d, l), a;
    }, h = e;
    let d = $f655ac91f53a7a3c$var$M;
    for(let e = 0; e < t.length; e++)t[e].name || $f655ac91f53a7a3c$var$v(15), d = $f655ac91f53a7a3c$var$G(d, t[e].name);
    return (null == h ? void 0 : h.namespace) && (d = $f655ac91f53a7a3c$var$G(d, h.namespace)), (null == h ? void 0 : h.prefix) && (d = $f655ac91f53a7a3c$var$G(d, "p")), u.hash = d !== $f655ac91f53a7a3c$var$M ? d.toString() : "", u;
}
const $f655ac91f53a7a3c$var$Xe = new $f655ac91f53a7a3c$var$_e, $f655ac91f53a7a3c$var$Ke = $f655ac91f53a7a3c$var$Je(), $f655ac91f53a7a3c$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).createContext({
    shouldForwardProp: void 0,
    styleSheet: $f655ac91f53a7a3c$var$Xe,
    stylis: $f655ac91f53a7a3c$var$Ke,
    stylisPlugins: void 0
}), $f655ac91f53a7a3c$export$91317688fc694efa = $f655ac91f53a7a3c$export$8c190ef828af4c86.Consumer;
function $f655ac91f53a7a3c$var$et() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useContext($f655ac91f53a7a3c$export$8c190ef828af4c86);
}
function $f655ac91f53a7a3c$export$a473771da2f0ff7c(e) {
    var n;
    const o = $f655ac91f53a7a3c$var$et(), { styleSheet: s } = o, r = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useMemo(()=>{
        let t = s;
        return e.sheet ? t = e.sheet : e.target ? t = t.reconstructWithOptions(void 0 !== e.nonce ? {
            target: e.target,
            nonce: e.nonce
        } : {
            target: e.target
        }, !1) : void 0 !== e.nonce && (t = t.reconstructWithOptions({
            nonce: e.nonce
        })), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.nonce,
        e.sheet,
        e.target,
        s
    ]), i = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useMemo(()=>{
        var t;
        return void 0 === e.stylisPlugins && void 0 === e.namespace && void 0 === e.enableVendorPrefixes ? o.stylis : $f655ac91f53a7a3c$var$Je({
            options: {
                namespace: e.namespace,
                prefix: e.enableVendorPrefixes
            },
            plugins: null !== (t = e.stylisPlugins) && void 0 !== t ? t : o.stylisPlugins
        });
    }, [
        e.enableVendorPrefixes,
        e.namespace,
        e.stylisPlugins,
        o.stylis,
        o.stylisPlugins
    ]), c = "shouldForwardProp" in e ? e.shouldForwardProp : o.shouldForwardProp, a = null !== (n = e.stylisPlugins) && void 0 !== n ? n : o.stylisPlugins, l = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useMemo(()=>({
            shouldForwardProp: c,
            styleSheet: r,
            stylis: i,
            stylisPlugins: a
        }), [
        c,
        r,
        i,
        a
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).createElement($f655ac91f53a7a3c$export$8c190ef828af4c86.Provider, {
        value: l
    }, e.children);
}
const $f655ac91f53a7a3c$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).createContext(void 0), $f655ac91f53a7a3c$export$b631efc24e9d5e2f = $f655ac91f53a7a3c$export$2c657da244d00bd6.Consumer;
function $f655ac91f53a7a3c$export$93d4e7f90805808f() {
    const e = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useContext($f655ac91f53a7a3c$export$2c657da244d00bd6);
    if (!e) throw $f655ac91f53a7a3c$var$v(18);
    return e;
}
function $f655ac91f53a7a3c$export$d8964aec282183a3(e) {
    const n = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useContext($f655ac91f53a7a3c$export$2c657da244d00bd6), o = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useMemo(()=>(function(e, t) {
            if (!e) throw $f655ac91f53a7a3c$var$v(14);
            if ($f655ac91f53a7a3c$var$re(e)) {
                const n = e(t);
                return n;
            }
            if (Array.isArray(e) || "object" != typeof e) throw $f655ac91f53a7a3c$var$v(8);
            return t ? Object.assign(Object.assign({}, t), e) : e;
        })(e.theme, n), [
        e.theme,
        n
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).createElement($f655ac91f53a7a3c$export$2c657da244d00bd6.Provider, {
        value: o
    }, e.children) : null;
}
const $f655ac91f53a7a3c$var$it = Object.prototype.hasOwnProperty, $f655ac91f53a7a3c$var$ct = {};
function $f655ac91f53a7a3c$var$at(e, t) {
    const n = "string" != typeof e ? "sc" : $f655ac91f53a7a3c$var$T(e);
    $f655ac91f53a7a3c$var$ct[n] = ($f655ac91f53a7a3c$var$ct[n] || 0) + 1;
    const o = n + "-" + $f655ac91f53a7a3c$var$z($f655ac91f53a7a3c$export$83d89fbfd8236492 + n + $f655ac91f53a7a3c$var$ct[n]);
    return t ? t + "-" + o : o;
}
let $f655ac91f53a7a3c$var$lt;
function $f655ac91f53a7a3c$var$ut(o, s, r) {
    const i = $f655ac91f53a7a3c$export$7ba318d8d2f06c76(o), c = o, a = !$f655ac91f53a7a3c$var$L(o), { attrs: l = $f655ac91f53a7a3c$var$I, componentId: u = $f655ac91f53a7a3c$var$at(s.displayName, s.parentComponentId), displayName: h = $f655ac91f53a7a3c$var$B(o) } = s, d = s.displayName && s.componentId ? $f655ac91f53a7a3c$var$T(s.displayName) + "-" + s.componentId : s.componentId || u, p = i && c.attrs ? c.attrs.concat(l).filter(Boolean) : l;
    let { shouldForwardProp: f } = s;
    if (i && c.shouldForwardProp) {
        const e = c.shouldForwardProp;
        if (s.shouldForwardProp) {
            const t = s.shouldForwardProp;
            f = (n, o)=>e(n, o) && t(n, o);
        } else f = e;
    }
    const m = new $f655ac91f53a7a3c$var$Be(r, d, i ? c.componentStyle : void 0);
    function y(o, s) {
        return function(o, s, r) {
            const { attrs: i, componentStyle: c, defaultProps: a, foldedComponentIds: l, styledComponentId: u, target: h } = o, d = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useContext($f655ac91f53a7a3c$export$2c657da244d00bd6), p = $f655ac91f53a7a3c$var$et(), f = o.shouldForwardProp || p.shouldForwardProp;
            const m = $f655ac91f53a7a3c$var$R(s, d, a) || $f655ac91f53a7a3c$var$$;
            let y, g;
            {
                const e = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useRef(null), n = e.current;
                if (null !== n && n[1] === m && n[2] === p.styleSheet && n[3] === p.stylis && n[7] === c && function(e, t, n) {
                    const o = e, s = t;
                    let r = 0;
                    for(const e in s)if ($f655ac91f53a7a3c$var$it.call(s, e) && (r++, o[e] !== s[e])) return !1;
                    return r === n;
                }(n[0], s, n[4])) y = n[5], g = n[6];
                else {
                    y = function(e, t, n) {
                        const o = Object.assign(Object.assign({}, t), {
                            className: void 0,
                            theme: n
                        }), s = e.length > 1;
                        for(let n = 0; n < e.length; n++){
                            const r = e[n], i = $f655ac91f53a7a3c$var$re(r) ? r(s ? Object.assign({}, o) : o) : r;
                            for(const e in i)"className" === e ? o.className = $f655ac91f53a7a3c$var$ae(o.className, i[e]) : "style" === e ? o.style = Object.assign(Object.assign({}, o.style), i[e]) : e in t && void 0 === t[e] || (o[e] = i[e]);
                        }
                        return "className" in t && "string" == typeof t.className && (o.className = $f655ac91f53a7a3c$var$ae(o.className, t.className)), o;
                    }(i, s, m), g = function(e, n, o, s) {
                        const r = e.generateAndInjectStyles(n, o, s);
                        return r;
                    }(c, y, p.styleSheet, p.stylis);
                    let n = 0;
                    for(const e in s)$f655ac91f53a7a3c$var$it.call(s, e) && n++;
                    e.current = [
                        s,
                        m,
                        p.styleSheet,
                        p.stylis,
                        n,
                        y,
                        g,
                        c
                    ];
                }
            }
            const v = y.as || h, S = function(t, n, o, s) {
                const r = {};
                for(const i in t)void 0 === t[i] || "$" === i[0] || "as" === i || "theme" === i && t.theme === o || ("forwardedAs" === i ? r.as = t.forwardedAs : s && !s(i, n) || (r[i] = t[i], s));
                return r;
            }(y, v, m, f);
            let b = $f655ac91f53a7a3c$var$ae(l, u);
            return g && (b += " " + g), y.className && (b += " " + y.className), S[$f655ac91f53a7a3c$var$L(v) && v.includes("-") ? "class" : "className"] = b, r && (S.ref = r), (0, $lCzvA.createElement)(v, S);
        }(g, o, s);
    }
    y.displayName = h;
    let g = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).forwardRef(y);
    return g.attrs = p, g.componentStyle = m, g.displayName = h, g.shouldForwardProp = f, g.foldedComponentIds = i ? $f655ac91f53a7a3c$var$ae(c.foldedComponentIds, c.styledComponentId) : "", g.styledComponentId = d, g.target = i ? c.target : o, Object.defineProperty(g, "defaultProps", {
        get () {
            return this._foldedDefaultProps;
        },
        set (e) {
            this._foldedDefaultProps = i ? function(e, ...t) {
                for (const n of t)$f655ac91f53a7a3c$var$he(e, n, !0);
                return e;
            }({}, c.defaultProps, e) : e;
        }
    }), $f655ac91f53a7a3c$var$de(g, ()=>`.${g.styledComponentId}`), a && $f655ac91f53a7a3c$var$se(g, o, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0
    }), g;
}
var $f655ac91f53a7a3c$var$ht = new Set([
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "bdi",
    "bdo",
    "blockquote",
    "body",
    "button",
    "br",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "label",
    "legend",
    "li",
    "main",
    "map",
    "mark",
    "menu",
    "meter",
    "nav",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "search",
    "section",
    "select",
    "slot",
    "small",
    "span",
    "strong",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "template",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "filter",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "switch",
    "symbol",
    "text",
    "textPath",
    "tspan",
    "use"
]);
function $f655ac91f53a7a3c$var$dt(e, t) {
    const n = [
        e[0]
    ];
    for(let o = 0, s = t.length; o < s; o += 1)n.push(t[o], e[o + 1]);
    return n;
}
const $f655ac91f53a7a3c$var$pt = (e)=>($f655ac91f53a7a3c$var$Ie.add(e), e);
function $f655ac91f53a7a3c$export$dbf350e5966cf602(e, ...t) {
    if ($f655ac91f53a7a3c$var$re(e) || $f655ac91f53a7a3c$var$ue(e)) return $f655ac91f53a7a3c$var$pt($f655ac91f53a7a3c$var$We($f655ac91f53a7a3c$var$dt($f655ac91f53a7a3c$var$I, [
        e,
        ...t
    ])));
    const n = e;
    return 0 === t.length && 1 === n.length && "string" == typeof n[0] ? $f655ac91f53a7a3c$var$We(n) : $f655ac91f53a7a3c$var$pt($f655ac91f53a7a3c$var$We($f655ac91f53a7a3c$var$dt(n, t)));
}
function $f655ac91f53a7a3c$var$mt(e, t, n = $f655ac91f53a7a3c$var$$) {
    if (!t) throw $f655ac91f53a7a3c$var$v(1, t);
    const o = (o, ...s)=>e(t, n, $f655ac91f53a7a3c$export$dbf350e5966cf602(o, ...s));
    return o.attrs = (o)=>$f655ac91f53a7a3c$var$mt(e, t, Object.assign(Object.assign({}, n), {
            attrs: Array.prototype.concat(n.attrs, o).filter(Boolean)
        })), o.withConfig = (o)=>$f655ac91f53a7a3c$var$mt(e, t, Object.assign(Object.assign({}, n), o)), o;
}
const $f655ac91f53a7a3c$var$yt = (e)=>$f655ac91f53a7a3c$var$mt($f655ac91f53a7a3c$var$ut, e), $f655ac91f53a7a3c$export$2e2bcd8739ae039 = $f655ac91f53a7a3c$var$yt;
$f655ac91f53a7a3c$var$ht.forEach((e)=>{
    $f655ac91f53a7a3c$export$2e2bcd8739ae039[e] = $f655ac91f53a7a3c$var$yt(e);
});
class $f655ac91f53a7a3c$var$vt {
    constructor(e, t){
        this.instanceRules = new Map, this.rules = e, this.componentId = t, this.isStatic = function(e) {
            for(let t = 0; t < e.length; t += 1){
                const n = e[t];
                if ($f655ac91f53a7a3c$var$re(n) && !$f655ac91f53a7a3c$export$7ba318d8d2f06c76(n)) return !1;
            }
            return !0;
        }(e), $f655ac91f53a7a3c$var$_e.registerId(this.componentId);
    }
    removeStyles(e, t) {
        this.instanceRules.delete(e), this.rebuildGroup(t);
    }
    renderStyles(e, t, n, o) {
        const s = this.componentId;
        if (this.isStatic) {
            if (n.hasNameForId(s, s + e)) this.instanceRules.has(e) || this.computeRules(e, t, n, o);
            else {
                const r = this.computeRules(e, t, n, o);
                n.insertRules(s, r.name, r.rules);
            }
            return;
        }
        const r = this.instanceRules.get(e);
        if (this.computeRules(e, t, n, o), !n.server && r) {
            const t = r.rules, n = this.instanceRules.get(e).rules;
            if (t.length === n.length) {
                let e = !0;
                for(let o = 0; o < t.length; o++)if (t[o] !== n[o]) {
                    e = !1;
                    break;
                }
                if (e) return;
            }
        }
        this.rebuildGroup(n);
    }
    computeRules(e, t, n, o) {
        const s = $f655ac91f53a7a3c$var$le($f655ac91f53a7a3c$var$We(this.rules, t, n, o)), r = {
            name: this.componentId + e,
            rules: o(s, "")
        };
        return this.instanceRules.set(e, r), r;
    }
    rebuildGroup(e) {
        const t = this.componentId;
        e.clearRules(t);
        for (const n of this.instanceRules.values())e.insertRules(t, n.name, n.rules);
    }
}
function $f655ac91f53a7a3c$export$f0f03736edb61697(e, ...n) {
    const o = $f655ac91f53a7a3c$export$dbf350e5966cf602(e, ...n), s = `sc-global-${$f655ac91f53a7a3c$var$z(JSON.stringify(o))}`, r = new $f655ac91f53a7a3c$var$vt(o, s);
    const i = (e)=>{
        const n = $f655ac91f53a7a3c$var$et(), i = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useContext($f655ac91f53a7a3c$export$2c657da244d00bd6);
        let a;
        {
            const e = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useRef(null);
            null === e.current && (e.current = n.styleSheet.allocateGSInstance(s)), a = e.current;
        }
        n.styleSheet.server && c(a, e, n.styleSheet, i, n.stylis);
        {
            const o = r.isStatic ? [
                a,
                n.styleSheet,
                r
            ] : [
                a,
                e,
                n.styleSheet,
                i,
                n.stylis,
                r
            ], l = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useRef(r);
            (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useLayoutEffect(()=>{
                n.styleSheet.server || (l.current !== r && (n.styleSheet.clearRules(s), l.current = r), c(a, e, n.styleSheet, i, n.stylis));
            }, o), (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useLayoutEffect(()=>()=>{
                    n.styleSheet.server || r.removeStyles(a, n.styleSheet);
                }, [
                a,
                n.styleSheet,
                r
            ]);
        }
        return n.styleSheet.server && r.instanceRules.delete(a), null;
    };
    function c(e, t, n, o, s) {
        if (r.isStatic) r.renderStyles(e, $f655ac91f53a7a3c$var$y, n, s);
        else {
            const c = Object.assign(Object.assign({}, t), {
                theme: $f655ac91f53a7a3c$var$R(t, o, i.defaultProps)
            });
            r.renderStyles(e, c, n, s);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).memo(i);
}
function $f655ac91f53a7a3c$var$bt(e, t, n, o, s) {
    for(const r in e){
        const i = e[r], c = s ? s + "-" + r : r;
        if ("object" == typeof i && null !== i) {
            const e = {};
            $f655ac91f53a7a3c$var$bt(i, t, e, o, c), n[r] = e;
        } else n[r] = o(c, i, r);
    }
}
function $f655ac91f53a7a3c$var$wt(e, t, n, o) {
    let s = "";
    for(const r in e){
        const i = e[r], c = t[r], a = o ? o + "-" + r : r;
        "object" == typeof i && null !== i ? "object" == typeof c && null !== c && (s += $f655ac91f53a7a3c$var$wt(i, c, n, a)) : void 0 !== c && "function" != typeof c && (s += "--" + n + a + ":" + c + ";");
    }
    return s;
}
function $f655ac91f53a7a3c$export$25d302a5b900a763(e, t) {
    var n, o;
    const s = (null !== (n = null == t ? void 0 : t.prefix) && void 0 !== n ? n : "sc") + "-", r = null !== (o = null == t ? void 0 : t.selector) && void 0 !== o ? o : ":root", i = function(e, t) {
        const n = {};
        return $f655ac91f53a7a3c$var$bt(e, t, n, (e)=>"--" + t + e), n;
    }(e, s), c = function(e, t) {
        const n = {};
        return $f655ac91f53a7a3c$var$bt(e, t, n, (e, n)=>{
            return "var(--" + t + e + ", " + n + ")";
        }), n;
    }(e, s), a = $f655ac91f53a7a3c$export$f0f03736edb61697`
    ${r} {
      ${(t)=>$f655ac91f53a7a3c$var$wt(e, t.theme, s)}
    }
  `;
    return Object.assign(c, {
        GlobalStyle: a,
        raw: e,
        vars: i,
        resolve (t) {
            if (!$f655ac91f53a7a3c$var$d) throw new Error("createTheme.resolve() is client-only");
            const n = null != t ? t : document.documentElement;
            return function(e, t, n) {
                const o = {};
                return $f655ac91f53a7a3c$var$bt(e, t, o, (e, o)=>n.getPropertyValue("--" + t + e).trim() || o), o;
            }(e, s, getComputedStyle(n));
        }
    });
}
var $f655ac91f53a7a3c$var$Ct;
class $f655ac91f53a7a3c$var$Ot {
    constructor(e, t){
        this[$f655ac91f53a7a3c$var$Ct] = !0, this.inject = (e, t = $f655ac91f53a7a3c$var$Ke)=>{
            const n = this.getName(t);
            if (!e.hasNameForId(this.id, n)) {
                const o = t(this.rules, n, "@keyframes");
                e.insertRules(this.id, n, o);
            }
        }, this.name = e, this.id = $f655ac91f53a7a3c$var$m + e, this.rules = t, $f655ac91f53a7a3c$var$C(this.id), $f655ac91f53a7a3c$var$de(this, ()=>{
            throw $f655ac91f53a7a3c$var$v(12, String(this.name));
        });
    }
    getName(e = $f655ac91f53a7a3c$var$Ke) {
        return e.hash ? this.name + $f655ac91f53a7a3c$var$V(+e.hash >>> 0) : this.name;
    }
}
function $f655ac91f53a7a3c$export$d25ddfdf17c3ad3e(e, ...t) {
    const n = $f655ac91f53a7a3c$var$le($f655ac91f53a7a3c$export$dbf350e5966cf602(e, ...t)), o = $f655ac91f53a7a3c$var$z(n);
    return new $f655ac91f53a7a3c$var$Ot(o, n);
}
function $f655ac91f53a7a3c$export$e8748c6a27b910dc(e) {
    const n = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).forwardRef((n, o)=>{
        const s = $f655ac91f53a7a3c$var$R(n, (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useContext($f655ac91f53a7a3c$export$2c657da244d00bd6), e.defaultProps);
        return (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).createElement(e, Object.assign(Object.assign({}, n), {
            theme: s,
            ref: o
        }));
    });
    return n.displayName = `WithTheme(${$f655ac91f53a7a3c$var$W(e)})`, $f655ac91f53a7a3c$var$se(n, e);
}
$f655ac91f53a7a3c$var$Ct = $f655ac91f53a7a3c$var$Te;
class $f655ac91f53a7a3c$export$ae8c7d15c8b89a20 {
    constructor({ nonce: e } = {}){
        this._emitSheetCSS = ()=>{
            const e = this.instance.toString();
            if (!e) return "";
            const t = this.instance.options.nonce || $f655ac91f53a7a3c$var$Ne();
            return `<style ${$f655ac91f53a7a3c$var$le([
                t && `nonce="${t}"`,
                `${$f655ac91f53a7a3c$var$c}="true"`,
                `${$f655ac91f53a7a3c$var$l}="${$f655ac91f53a7a3c$export$83d89fbfd8236492}"`
            ].filter(Boolean), " ")}>${e}</style>`;
        }, this.getStyleTags = ()=>{
            if (this.sealed) throw $f655ac91f53a7a3c$var$v(2);
            return this._emitSheetCSS();
        }, this.getStyleElement = ()=>{
            if (this.sealed) throw $f655ac91f53a7a3c$var$v(2);
            const e = this.instance.toString();
            if (!e) return [];
            const n = {
                [$f655ac91f53a7a3c$var$c]: "",
                [$f655ac91f53a7a3c$var$l]: $f655ac91f53a7a3c$export$83d89fbfd8236492,
                dangerouslySetInnerHTML: {
                    __html: e
                }
            }, o = this.instance.options.nonce || $f655ac91f53a7a3c$var$Ne();
            return o && (n.nonce = o), [
                (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).createElement("style", Object.assign({}, n, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = ()=>{
            this.sealed = !0;
        }, this.instance = new $f655ac91f53a7a3c$var$_e({
            isServer: !0,
            nonce: e
        }), this.sealed = !1;
    }
    collectStyles(e) {
        if (this.sealed) throw $f655ac91f53a7a3c$var$v(2);
        return (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).createElement($f655ac91f53a7a3c$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }
    interleaveWithNodeStream(e) {
        throw $f655ac91f53a7a3c$var$v(3);
    }
}
const $f655ac91f53a7a3c$export$5c87cfe6c475f500 = {
    StyleSheet: $f655ac91f53a7a3c$var$_e,
    mainSheet: $f655ac91f53a7a3c$var$Xe
};
const $f655ac91f53a7a3c$var$It = `__sc-${$f655ac91f53a7a3c$var$c}__`;
const $f655ac91f53a7a3c$var$$t = /:(?:(first)-child|(last)-child|(only)-child|(nth-child)\(([^()]+)\)|(nth-last-child)\(([^()]+)\))/g, $f655ac91f53a7a3c$var$Rt = `:not(style[${$f655ac91f53a7a3c$var$c}])`, $f655ac91f53a7a3c$var$jt = `style[${$f655ac91f53a7a3c$var$c}]`;
function $f655ac91f53a7a3c$var$xt(e) {
    return -1 === e.indexOf("-child") ? e : ($f655ac91f53a7a3c$var$$t.lastIndex = 0, e.replace($f655ac91f53a7a3c$var$$t, (e, t, n, o, s, r, i, c)=>t ? `:nth-child(1 of ${$f655ac91f53a7a3c$var$Rt})` : n ? `:nth-last-child(1 of ${$f655ac91f53a7a3c$var$Rt})` : o ? `:nth-child(1 of ${$f655ac91f53a7a3c$var$Rt}):nth-last-child(1 of ${$f655ac91f53a7a3c$var$Rt})` : s ? -1 !== r.indexOf(" of ") ? e : `:nth-child(${r} of ${$f655ac91f53a7a3c$var$Rt})` : -1 !== c.indexOf(" of ") ? e : `:nth-last-child(${c} of ${$f655ac91f53a7a3c$var$Rt})`));
}
function $f655ac91f53a7a3c$var$Tt(e, t) {
    if (-1 === e.indexOf("+")) return;
    let n = 0, o = 0;
    for(let s = 0; s < e.length; s++){
        const r = e.charCodeAt(s);
        if (40 === r) n++;
        else if (41 === r) n--;
        else if (91 === r) o++;
        else if (93 === r) o--;
        else if (43 === r && 0 === n && 0 === o && !$f655ac91f53a7a3c$var$He(e, s)) {
            const n = e.substring(0, s), o = e.substring(s + 1);
            t.push(n + "+" + $f655ac91f53a7a3c$var$jt + "+" + o), t.push(n + "+" + $f655ac91f53a7a3c$var$jt + "+" + $f655ac91f53a7a3c$var$jt + "+" + o);
        }
    }
}
function $f655ac91f53a7a3c$export$337461d98bd2ad54(e) {
    if (e.type === (0, $2f8d19f61bf0d402$export$aa3a2e812ca8570d)) {
        const t = e.props, n = [];
        for(let e = 0; e < t.length; e++){
            const o = $f655ac91f53a7a3c$var$xt(t[e]);
            n.push(o), $f655ac91f53a7a3c$var$Tt(o, n);
        }
        e.props = n;
    }
}


// Such export is called Tree Shaking. It allows to import only the components
// that are needed while webpack will remove the rest of the code from the bundle.
const $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c = "#4fa94d";
const $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18 = {
    "aria-busy": true,
    role: "progressbar"
};
const $6bfaf8085a30c9b5$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56 = (0, $f655ac91f53a7a3c$export$2e2bcd8739ae039).div`
  display: ${(props)=>props.$visible ? "flex" : "none"};
`;
const $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c = "http://www.w3.org/2000/svg";
const $6bfaf8085a30c9b5$export$153755f98d9861de = ({ height: height = "100", width: width = "100", color: color = $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "audio-loading", wrapperStyle: wrapperStyle = {}, wrapperClass: wrapperClass, visible: visible = true })=>(0, $1e1ba35c5b9fc4c3$exports.jsx)($6bfaf8085a30c9b5$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        $visible: visible,
        style: {
            ...wrapperStyle
        },
        className: wrapperClass,
        "data-testid": "audio-loading",
        "aria-label": ariaLabel,
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("svg", {
            height: `${height}`,
            width: `${width}`,
            fill: color,
            viewBox: "0 0 55 80",
            xmlns: $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c,
            "data-testid": "audio-svg",
            children: [
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("title", {
                    children: "Audio Visualization"
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("desc", {
                    children: "Animated representation of audio data"
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsxs)("g", {
                    transform: "matrix(1 0 0 -1 0 80)",
                    children: [
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("rect", {
                            width: "10",
                            height: "20",
                            rx: "3",
                            children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                                attributeName: "height",
                                begin: "0s",
                                dur: "4.3s",
                                values: "20;45;57;80;64;32;66;45;64;23;66;13;64;56;34;34;2;23;76;79;20",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        }),
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("rect", {
                            x: "15",
                            width: "10",
                            height: "80",
                            rx: "3",
                            children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                                attributeName: "height",
                                begin: "0s",
                                dur: "2s",
                                values: "80;55;33;5;75;23;73;33;12;14;60;80",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        }),
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("rect", {
                            x: "30",
                            width: "10",
                            height: "50",
                            rx: "3",
                            children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                                attributeName: "height",
                                begin: "0s",
                                dur: "1.4s",
                                values: "50;34;78;23;56;23;34;76;80;54;21;50",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        }),
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("rect", {
                            x: "45",
                            width: "10",
                            height: "30",
                            rx: "3",
                            children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                                attributeName: "height",
                                begin: "0s",
                                dur: "2s",
                                values: "30;45;13;80;56;72;45;76;34;23;67;30",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        })
                    ]
                })
            ]
        })
    });
const $6bfaf8085a30c9b5$export$68949ad0373623af = ({ height: height = 100, width: width = 100, radius: radius = 5, color: color = $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "ball-triangle-loading", wrapperClass: wrapperClass, wrapperStyle: wrapperStyle, visible: visible = true })=>(0, $1e1ba35c5b9fc4c3$exports.jsx)($6bfaf8085a30c9b5$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: {
            ...wrapperStyle
        },
        $visible: visible,
        className: wrapperClass,
        "data-testid": "ball-triangle-loading",
        "aria-label": ariaLabel,
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("svg", {
            height: height,
            width: width,
            stroke: color,
            viewBox: "0 0 57 57",
            xmlns: $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c,
            "data-testid": "ball-triangle-svg",
            children: [
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("title", {
                    children: "Ball Triangle"
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("desc", {
                    children: "Animated representation of three balls"
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("g", {
                    fill: "none",
                    fillRule: "evenodd",
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("g", {
                        transform: "translate(1 1)",
                        strokeWidth: "2",
                        children: [
                            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                                cx: "5",
                                cy: "50",
                                r: radius,
                                children: [
                                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                                        attributeName: "cy",
                                        begin: "0s",
                                        dur: "2.2s",
                                        values: "50;5;50;50",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    }),
                                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                                        attributeName: "cx",
                                        begin: "0s",
                                        dur: "2.2s",
                                        values: "5;27;49;5",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    })
                                ]
                            }),
                            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                                cx: "27",
                                cy: "5",
                                r: radius,
                                children: [
                                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                                        attributeName: "cy",
                                        begin: "0s",
                                        dur: "2.2s",
                                        from: "5",
                                        to: "5",
                                        values: "5;50;50;5",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    }),
                                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                                        attributeName: "cx",
                                        begin: "0s",
                                        dur: "2.2s",
                                        from: "27",
                                        to: "27",
                                        values: "27;49;5;27",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    })
                                ]
                            }),
                            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                                cx: "49",
                                cy: "50",
                                r: radius,
                                children: [
                                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                                        attributeName: "cy",
                                        begin: "0s",
                                        dur: "2.2s",
                                        values: "50;50;5;50",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    }),
                                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                                        attributeName: "cx",
                                        from: "49",
                                        to: "49",
                                        begin: "0s",
                                        dur: "2.2s",
                                        values: "49;5;27;49",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
const $6bfaf8085a30c9b5$export$fbc7d6f7dd821b47 = ({ height: height = 80, width: width = 80, color: color = $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "bars-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $1e1ba35c5b9fc4c3$exports.jsx)($6bfaf8085a30c9b5$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        $visible: visible,
        style: {
            ...wrapperStyle
        },
        className: wrapperClass,
        "data-testid": "bars-loading",
        "aria-label": ariaLabel,
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("svg", {
            width: width,
            height: height,
            fill: color,
            viewBox: "0 0 135 140",
            xmlns: $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c,
            "data-testid": "bars-svg",
            children: [
                (0, $1e1ba35c5b9fc4c3$exports.jsxs)("rect", {
                    y: "10",
                    width: "15",
                    height: "120",
                    rx: "6",
                    children: [
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                            attributeName: "height",
                            begin: "0.5s",
                            dur: "1s",
                            values: "120;110;100;90;80;70;60;50;40;140;120",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                            attributeName: "y",
                            begin: "0.5s",
                            dur: "1s",
                            values: "10;15;20;25;30;35;40;45;50;0;10",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsxs)("rect", {
                    x: "30",
                    y: "10",
                    width: "15",
                    height: "120",
                    rx: "6",
                    children: [
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                            attributeName: "height",
                            begin: "0.25s",
                            dur: "1s",
                            values: "120;110;100;90;80;70;60;50;40;140;120",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                            attributeName: "y",
                            begin: "0.25s",
                            dur: "1s",
                            values: "10;15;20;25;30;35;40;45;50;0;10",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsxs)("rect", {
                    x: "60",
                    width: "15",
                    height: "140",
                    rx: "6",
                    children: [
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                            attributeName: "height",
                            begin: "0s",
                            dur: "1s",
                            values: "120;110;100;90;80;70;60;50;40;140;120",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                            attributeName: "y",
                            begin: "0s",
                            dur: "1s",
                            values: "10;15;20;25;30;35;40;45;50;0;10",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsxs)("rect", {
                    x: "90",
                    y: "10",
                    width: "15",
                    height: "120",
                    rx: "6",
                    children: [
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                            attributeName: "height",
                            begin: "0.25s",
                            dur: "1s",
                            values: "120;110;100;90;80;70;60;50;40;140;120",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                            attributeName: "y",
                            begin: "0.25s",
                            dur: "1s",
                            values: "10;15;20;25;30;35;40;45;50;0;10",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsxs)("rect", {
                    x: "120",
                    y: "10",
                    width: "15",
                    height: "120",
                    rx: "6",
                    children: [
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                            attributeName: "height",
                            begin: "0.5s",
                            dur: "1s",
                            values: "120;110;100;90;80;70;60;50;40;140;120",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                            attributeName: "y",
                            begin: "0.5s",
                            dur: "1s",
                            values: "10;15;20;25;30;35;40;45;50;0;10",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                })
            ]
        })
    });
const $6bfaf8085a30c9b5$export$765808835a2dc0a2 = ({ height: height = 80, width: width = 80, color: color = $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "circles-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $1e1ba35c5b9fc4c3$exports.jsx)($6bfaf8085a30c9b5$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "aria-label": ariaLabel,
        "data-testid": "circles-loading",
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 135 135",
            xmlns: $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c,
            fill: color,
            "data-testid": "circles-svg",
            children: [
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("title", {
                    children: "circles-loading"
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("desc", {
                    children: "Animated representation of circles"
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                    d: "M67.447 58c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10zm9.448 9.447c0 5.523 4.477 10 10 10 5.522 0 10-4.477 10-10s-4.478-10-10-10c-5.523 0-10 4.477-10 10zm-9.448 9.448c-5.523 0-10 4.477-10 10 0 5.522 4.477 10 10 10s10-4.478 10-10c0-5.523-4.477-10-10-10zM58 67.447c0-5.523-4.477-10-10-10s-10 4.477-10 10 4.477 10 10 10 10-4.477 10-10z",
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "rotate",
                        from: "0 67 67",
                        to: "-360 67 67",
                        dur: "2.5s",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                    d: "M28.19 40.31c6.627 0 12-5.374 12-12 0-6.628-5.373-12-12-12-6.628 0-12 5.372-12 12 0 6.626 5.372 12 12 12zm30.72-19.825c4.686 4.687 12.284 4.687 16.97 0 4.686-4.686 4.686-12.284 0-16.97-4.686-4.687-12.284-4.687-16.97 0-4.687 4.686-4.687 12.284 0 16.97zm35.74 7.705c0 6.627 5.37 12 12 12 6.626 0 12-5.373 12-12 0-6.628-5.374-12-12-12-6.63 0-12 5.372-12 12zm19.822 30.72c-4.686 4.686-4.686 12.284 0 16.97 4.687 4.686 12.285 4.686 16.97 0 4.687-4.686 4.687-12.284 0-16.97-4.685-4.687-12.283-4.687-16.97 0zm-7.704 35.74c-6.627 0-12 5.37-12 12 0 6.626 5.373 12 12 12s12-5.374 12-12c0-6.63-5.373-12-12-12zm-30.72 19.822c-4.686-4.686-12.284-4.686-16.97 0-4.686 4.687-4.686 12.285 0 16.97 4.686 4.687 12.284 4.687 16.97 0 4.687-4.685 4.687-12.283 0-16.97zm-35.74-7.704c0-6.627-5.372-12-12-12-6.626 0-12 5.373-12 12s5.374 12 12 12c6.628 0 12-5.373 12-12zm-19.823-30.72c4.687-4.686 4.687-12.284 0-16.97-4.686-4.686-12.284-4.686-16.97 0-4.687 4.686-4.687 12.284 0 16.97 4.686 4.687 12.284 4.687 16.97 0z",
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "rotate",
                        from: "0 67 67",
                        to: "360 67 67",
                        dur: "8s",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    });
const $6bfaf8085a30c9b5$export$17c11650828d97e = ({ wrapperStyle: wrapperStyle = {}, visible: visible = true, wrapperClass: wrapperClass = "", height: height = 100, width: width = 100, color: color = $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, outerCircleColor: outerCircleColor, innerCircleColor: innerCircleColor, barColor: barColor, ariaLabel: ariaLabel = "circles-with-bar-loading" })=>{
    return (0, $1e1ba35c5b9fc4c3$exports.jsx)($6bfaf8085a30c9b5$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "aria-label": ariaLabel,
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        "data-testid": "circles-with-bar-wrapper",
        children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("svg", {
            version: "1.1",
            id: "L1",
            xmlns: $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c,
            x: "0px",
            y: "0px",
            height: `${height}`,
            width: `${width}`,
            viewBox: "0 0 100 100",
            enableBackground: "new 0 0 100 100",
            xmlSpace: "preserve",
            "data-testid": "circles-with-bar-svg",
            children: [
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("title", {
                    children: "circles-with-bar-loading"
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("desc", {
                    children: "Animated representation of circles with bar"
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("circle", {
                    fill: "none",
                    stroke: `${outerCircleColor || color}`,
                    strokeWidth: "6",
                    strokeMiterlimit: "15",
                    strokeDasharray: "14.2472,14.2472",
                    cx: "50",
                    cy: "50",
                    r: "47",
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        attributeType: "XML",
                        type: "rotate",
                        dur: "5s",
                        from: "0 50 50",
                        to: "360 50 50",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("circle", {
                    fill: "none",
                    stroke: `${innerCircleColor || color}`,
                    strokeWidth: "1",
                    strokeMiterlimit: "10",
                    strokeDasharray: "10,10",
                    cx: "50",
                    cy: "50",
                    r: "39",
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        attributeType: "XML",
                        type: "rotate",
                        dur: "5s",
                        from: "0 50 50",
                        to: "-360 50 50",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsxs)("g", {
                    fill: `${barColor || color}`,
                    "data-testid": "circles-with-bar-svg-bar",
                    children: [
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("rect", {
                            x: "30",
                            y: "35",
                            width: "5",
                            height: "30",
                            children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.1"
                            })
                        }),
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("rect", {
                            x: "40",
                            y: "35",
                            width: "5",
                            height: "30",
                            children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.2"
                            })
                        }),
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("rect", {
                            x: "50",
                            y: "35",
                            width: "5",
                            height: "30",
                            children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.3"
                            })
                        }),
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("rect", {
                            x: "60",
                            y: "35",
                            width: "5",
                            height: "30",
                            children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.4"
                            })
                        }),
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("rect", {
                            x: "70",
                            y: "35",
                            width: "5",
                            height: "30",
                            children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.5"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
const $6bfaf8085a30c9b5$export$ef2184bd89960b14 = ({ height: height = 80, width: width = 80, radius: radius = 12.5, color: color = $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "grid-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $1e1ba35c5b9fc4c3$exports.jsx)($6bfaf8085a30c9b5$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "grid-loading",
        "aria-label": ariaLabel,
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 105 105",
            fill: color,
            "data-testid": "grid-svg",
            children: [
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("circle", {
                    cx: "12.5",
                    cy: "12.5",
                    r: `${radius}`,
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "0s",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("circle", {
                    cx: "12.5",
                    cy: "52.5",
                    r: `${radius}`,
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "100ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("circle", {
                    cx: "52.5",
                    cy: "12.5",
                    r: `${radius}`,
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "300ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("circle", {
                    cx: "52.5",
                    cy: "52.5",
                    r: `${radius}`,
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "600ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("circle", {
                    cx: "92.5",
                    cy: "12.5",
                    r: `${radius}`,
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "800ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("circle", {
                    cx: "92.5",
                    cy: "52.5",
                    r: `${radius}`,
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "400ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("circle", {
                    cx: "12.5",
                    cy: "92.5",
                    r: `${radius}`,
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "700ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("circle", {
                    cx: "52.5",
                    cy: "92.5",
                    r: `${radius}`,
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "500ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("circle", {
                    cx: "92.5",
                    cy: "92.5",
                    r: `${radius}`,
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "200ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    });
const $6bfaf8085a30c9b5$export$2da2f0c7403af3ce = ({ height: height = 80, width: width = 80, color: color = $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "hearts-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $1e1ba35c5b9fc4c3$exports.jsx)($6bfaf8085a30c9b5$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "hearts-loading",
        "aria-label": ariaLabel,
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 140 64",
            xmlns: "http://www.w3.org/2000/svg",
            fill: color,
            "data-testid": "hearts-svg",
            children: [
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                    d: "M30.262 57.02L7.195 40.723c-5.84-3.976-7.56-12.06-3.842-18.063 3.715-6 11.467-7.65 17.306-3.68l4.52 3.76 2.6-5.274c3.717-6.002 11.47-7.65 17.305-3.68 5.84 3.97 7.56 12.054 3.842 18.062L34.49 56.118c-.897 1.512-2.793 1.915-4.228.9z",
                    attributeName: "fill-opacity",
                    from: "0",
                    to: ".5",
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "0s",
                        dur: "1.4s",
                        values: "0.5;1;0.5",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                    d: "M105.512 56.12l-14.44-24.272c-3.716-6.008-1.996-14.093 3.843-18.062 5.835-3.97 13.588-2.322 17.306 3.68l2.6 5.274 4.52-3.76c5.84-3.97 13.592-2.32 17.307 3.68 3.718 6.003 1.998 14.088-3.842 18.064L109.74 57.02c-1.434 1.014-3.33.61-4.228-.9z",
                    attributeName: "fill-opacity",
                    from: "0",
                    to: ".5",
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "0.7s",
                        dur: "1.4s",
                        values: "0.5;1;0.5",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                    d: "M67.408 57.834l-23.01-24.98c-5.864-6.15-5.864-16.108 0-22.248 5.86-6.14 15.37-6.14 21.234 0L70 16.168l4.368-5.562c5.863-6.14 15.375-6.14 21.235 0 5.863 6.14 5.863 16.098 0 22.247l-23.007 24.98c-1.43 1.556-3.757 1.556-5.188 0z"
                })
            ]
        })
    });
const $6bfaf8085a30c9b5$var$$ad60b992c945fdb5$var$len = 242.776657104492;
const $6bfaf8085a30c9b5$var$$ad60b992c945fdb5$var$time = 1.6;
const $6bfaf8085a30c9b5$var$$ad60b992c945fdb5$var$anim = (0, $f655ac91f53a7a3c$export$d25ddfdf17c3ad3e)`
12.5% {
  stroke-dasharray: ${$6bfaf8085a30c9b5$var$$ad60b992c945fdb5$var$len * 0.14}px, ${$6bfaf8085a30c9b5$var$$ad60b992c945fdb5$var$len}px;
  stroke-dashoffset: -${$6bfaf8085a30c9b5$var$$ad60b992c945fdb5$var$len * 0.11}px;
}
43.75% {
  stroke-dasharray: ${$6bfaf8085a30c9b5$var$$ad60b992c945fdb5$var$len * 0.35}px, ${$6bfaf8085a30c9b5$var$$ad60b992c945fdb5$var$len}px;
  stroke-dashoffset: -${$6bfaf8085a30c9b5$var$$ad60b992c945fdb5$var$len * 0.35}px;
}
100% {
  stroke-dasharray: ${$6bfaf8085a30c9b5$var$$ad60b992c945fdb5$var$len * 0.01}px, ${$6bfaf8085a30c9b5$var$$ad60b992c945fdb5$var$len}px;
  stroke-dashoffset: -${$6bfaf8085a30c9b5$var$$ad60b992c945fdb5$var$len * 0.99}px;
}
`;
const $6bfaf8085a30c9b5$var$$ad60b992c945fdb5$var$Path = (0, $f655ac91f53a7a3c$export$2e2bcd8739ae039).path`
  stroke-dasharray: ${$6bfaf8085a30c9b5$var$$ad60b992c945fdb5$var$len * 0.01}px, ${$6bfaf8085a30c9b5$var$$ad60b992c945fdb5$var$len};
  stroke-dashoffset: 0;
  animation: ${$6bfaf8085a30c9b5$var$$ad60b992c945fdb5$var$anim} ${$6bfaf8085a30c9b5$var$$ad60b992c945fdb5$var$time}s linear infinite;
`;
const $6bfaf8085a30c9b5$export$8009d4483dfda42 = ({ color: color = $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, width: width = "200" })=>{
    return (0, $1e1ba35c5b9fc4c3$exports.jsxs)("svg", {
        xmlns: $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c,
        width: `${width}`,
        height: `${Number(width) * 0.5}`,
        viewBox: `0 0 ${width} ${Number(100)}`,
        "data-testid": "infinity-spin",
        children: [
            (0, $1e1ba35c5b9fc4c3$exports.jsx)($6bfaf8085a30c9b5$var$$ad60b992c945fdb5$var$Path, {
                "data-testid": "infinity-spin-path-1",
                stroke: color,
                fill: "none",
                strokeWidth: "4",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: "10",
                d: "M93.9,46.4c9.3,9.5,13.8,17.9,23.5,17.9s17.5-7.8,17.5-17.5s-7.8-17.6-17.5-17.5c-9.7,0.1-13.3,7.2-22.1,17.1 c-8.9,8.8-15.7,17.9-25.4,17.9s-17.5-7.8-17.5-17.5s7.8-17.5,17.5-17.5S86.2,38.6,93.9,46.4z"
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                "data-testid": "infinity-spin-path-2",
                opacity: "0.07",
                fill: "none",
                stroke: color,
                strokeWidth: "4",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: "10",
                d: "M93.9,46.4c9.3,9.5,13.8,17.9,23.5,17.9s17.5-7.8,17.5-17.5s-7.8-17.6-17.5-17.5c-9.7,0.1-13.3,7.2-22.1,17.1 c-8.9,8.8-15.7,17.9-25.4,17.9s-17.5-7.8-17.5-17.5s7.8-17.5,17.5-17.5S86.2,38.6,93.9,46.4z"
            })
        ]
    });
};
const $6bfaf8085a30c9b5$export$d2101d81f63866ab = ({ wrapperStyle: wrapperStyle = {}, visible: visible = true, wrapperClass: wrapperClass = "", height: height = 100, width: width = 100, color: color = $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "line-wave-loading", firstLineColor: firstLineColor, middleLineColor: middleLineColor, lastLineColor: lastLineColor })=>{
    return (0, $1e1ba35c5b9fc4c3$exports.jsx)($6bfaf8085a30c9b5$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "line-wave-wrapper",
        "aria-label": ariaLabel,
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("svg", {
            version: "1.1",
            height: `${height}`,
            width: `${width}`,
            xmlns: $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c,
            x: "0px",
            y: "0px",
            viewBox: "0 0 100 100",
            enableBackground: "new 0 0 0 0",
            xmlSpace: "preserve",
            "data-testid": "line-wave-svg",
            children: [
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("rect", {
                    x: "20",
                    y: "50",
                    width: "4",
                    height: "10",
                    fill: firstLineColor || color,
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                        attributeType: "xml",
                        attributeName: "transform",
                        type: "translate",
                        values: "0 0; 0 20; 0 0",
                        begin: "0",
                        dur: "0.6s",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("rect", {
                    x: "30",
                    y: "50",
                    width: "4",
                    height: "10",
                    fill: middleLineColor || color,
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                        attributeType: "xml",
                        attributeName: "transform",
                        type: "translate",
                        values: "0 0; 0 20; 0 0",
                        begin: "0.2s",
                        dur: "0.6s",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("rect", {
                    x: "40",
                    y: "50",
                    width: "4",
                    height: "10",
                    fill: lastLineColor || color,
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                        attributeType: "xml",
                        attributeName: "transform",
                        type: "translate",
                        values: "0 0; 0 20; 0 0",
                        begin: "0.4s",
                        dur: "0.6s",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    });
};
const $6bfaf8085a30c9b5$export$64ea884904791f4 = ({ height: height = 90, width: width = 80, radius: radius = 12.5, color: color = $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, secondaryColor: secondaryColor = $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "mutating-dots-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $1e1ba35c5b9fc4c3$exports.jsx)($6bfaf8085a30c9b5$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "mutating-dots-loading",
        "aria-label": ariaLabel,
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("svg", {
            id: "goo-loader",
            width: width,
            height: height,
            "data-testid": "mutating-dots-svg",
            children: [
                (0, $1e1ba35c5b9fc4c3$exports.jsxs)("filter", {
                    id: "fancy-goo",
                    children: [
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("feGaussianBlur", {
                            in: "SourceGraphic",
                            stdDeviation: "6",
                            result: "blur"
                        }),
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("feColorMatrix", {
                            in: "blur",
                            mode: "matrix",
                            values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9",
                            result: "goo"
                        }),
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("feComposite", {
                            in: "SourceGraphic",
                            in2: "goo",
                            operator: "atop"
                        })
                    ]
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsxs)("g", {
                    filter: "url(#fancy-goo)",
                    children: [
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                            id: "mainAnim",
                            attributeName: "transform",
                            attributeType: "XML",
                            type: "rotate",
                            from: "0 50 50",
                            to: "359 50 50",
                            dur: "1.2s",
                            repeatCount: "indefinite"
                        }),
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("circle", {
                            cx: "50%",
                            cy: "40",
                            r: radius,
                            fill: color,
                            children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                                id: "cAnim1",
                                attributeType: "XML",
                                attributeName: "cy",
                                dur: "0.6s",
                                begin: "0;cAnim1.end+0.2s",
                                calcMode: "spline",
                                values: "40;20;40",
                                keyTimes: "0;0.3;1",
                                keySplines: "0.09, 0.45, 0.16, 1;0.09, 0.45, 0.16, 1"
                            })
                        }),
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("circle", {
                            cx: "50%",
                            cy: "60",
                            r: radius,
                            fill: secondaryColor,
                            children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                                id: "cAnim2",
                                attributeType: "XML",
                                attributeName: "cy",
                                dur: "0.6s",
                                begin: "0.4s;cAnim2.end+0.2s",
                                calcMode: "spline",
                                values: "60;80;60",
                                keyTimes: "0;0.3;1",
                                keySplines: "0.09, 0.45, 0.16, 1;0.09, 0.45, 0.16, 1"
                            })
                        })
                    ]
                })
            ]
        })
    });
/**
 * The radius of the circle
 * The Loader size is set with the width and height of the SVG
 * @type {number}
 */ const $6bfaf8085a30c9b5$var$$a5fa864d4dd36deb$var$RADIUS = 20;
/**
 * Compute Path depending on circle radius
 * The structure with radius 20 is "M20 0c0-9.94-8.06-20-20-20"
 * @param radius of the circle radius default 20
 * @returns {string}
 */ const $6bfaf8085a30c9b5$var$$a5fa864d4dd36deb$var$getPath = (radius)=>{
    return [
        "M" + radius + " 0c0-9.94-8.06",
        radius,
        radius,
        radius
    ].join("-");
};
/**
 * Compute the size of the view box depending on the radius and Stroke-Width
 * @param strokeWidth Stroke-Width of the full circle
 * @param secondaryStrokeWidth Stroke-Width of the 1/4 circle
 * @param radius radius of the circle
 * @returns {string}
 */ const $6bfaf8085a30c9b5$var$$a5fa864d4dd36deb$var$getViewBoxSize = (strokeWidth, secondaryStrokeWidth, radius)=>{
    const maxStrokeWidth = Math.max(strokeWidth, secondaryStrokeWidth);
    const startingPoint = -radius - maxStrokeWidth / 2 + 1;
    const endpoint = radius * 2 + maxStrokeWidth;
    return [
        startingPoint,
        startingPoint,
        endpoint,
        endpoint
    ].join(" ");
};
const $6bfaf8085a30c9b5$export$67ad50c48ca3ede4 = ({ height: height = 80, width: width = 80, color: color = $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, secondaryColor: secondaryColor = $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "oval-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true, strokeWidth: strokeWidth = 2, strokeWidthSecondary: strokeWidthSecondary })=>(0, $1e1ba35c5b9fc4c3$exports.jsx)($6bfaf8085a30c9b5$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "oval-loading",
        "aria-label": ariaLabel,
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("svg", {
            width: width,
            height: height,
            viewBox: $6bfaf8085a30c9b5$var$$a5fa864d4dd36deb$var$getViewBoxSize(Number(strokeWidth), Number(strokeWidthSecondary || strokeWidth), $6bfaf8085a30c9b5$var$$a5fa864d4dd36deb$var$RADIUS),
            xmlns: "http://www.w3.org/2000/svg",
            stroke: color,
            "data-testid": "oval-svg",
            children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("g", {
                fill: "none",
                fillRule: "evenodd",
                children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("g", {
                    transform: "translate(1 1)",
                    strokeWidth: Number(strokeWidthSecondary || strokeWidth),
                    "data-testid": "oval-secondary-group",
                    children: [
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("circle", {
                            strokeOpacity: ".5",
                            cx: "0",
                            cy: "0",
                            r: $6bfaf8085a30c9b5$var$$a5fa864d4dd36deb$var$RADIUS,
                            stroke: secondaryColor,
                            strokeWidth: strokeWidth
                        }),
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                            d: $6bfaf8085a30c9b5$var$$a5fa864d4dd36deb$var$getPath($6bfaf8085a30c9b5$var$$a5fa864d4dd36deb$var$RADIUS),
                            children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "rotate",
                                from: "0 0 0",
                                to: "360 0 0",
                                dur: "1s",
                                repeatCount: "indefinite"
                            })
                        })
                    ]
                })
            })
        })
    });
const $6bfaf8085a30c9b5$export$83d2259ec538613b = ({ height: height = 80, width: width = 80, radius: radius = 1, color: color = $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "puff-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $1e1ba35c5b9fc4c3$exports.jsx)($6bfaf8085a30c9b5$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "puff-loading",
        "aria-label": ariaLabel,
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 44 44",
            xmlns: $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c,
            stroke: color,
            "data-testid": "puff-svg",
            children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                strokeWidth: "2",
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                        cx: "22",
                        cy: "22",
                        r: radius,
                        children: [
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                                attributeName: "r",
                                begin: "0s",
                                dur: "1.8s",
                                values: "1; 20",
                                calcMode: "spline",
                                keyTimes: "0; 1",
                                keySplines: "0.165, 0.84, 0.44, 1",
                                repeatCount: "indefinite"
                            }),
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                                attributeName: "strokeOpacity",
                                begin: "0s",
                                dur: "1.8s",
                                values: "1; 0",
                                calcMode: "spline",
                                keyTimes: "0; 1",
                                keySplines: "0.3, 0.61, 0.355, 1",
                                repeatCount: "indefinite"
                            })
                        ]
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                        cx: "22",
                        cy: "22",
                        r: radius,
                        children: [
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                                attributeName: "r",
                                begin: "-0.9s",
                                dur: "1.8s",
                                values: "1; 20",
                                calcMode: "spline",
                                keyTimes: "0; 1",
                                keySplines: "0.165, 0.84, 0.44, 1",
                                repeatCount: "indefinite"
                            }),
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                                attributeName: "strokeOpacity",
                                begin: "-0.9s",
                                dur: "1.8s",
                                values: "1; 0",
                                calcMode: "spline",
                                keyTimes: "0; 1",
                                keySplines: "0.3, 0.61, 0.355, 1",
                                repeatCount: "indefinite"
                            })
                        ]
                    })
                ]
            })
        })
    });
const $6bfaf8085a30c9b5$export$8e22e563e5362f75 = ({ radius: radius = 45, strokeWidth: strokeWidth = 5, color: color = $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, secondaryColor: secondaryColor, ariaLabel: ariaLabel = "revolving-dot-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $1e1ba35c5b9fc4c3$exports.jsx)($6bfaf8085a30c9b5$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "aria-label": ariaLabel,
        "data-testid": "revolving-dot-loading",
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("svg", {
            version: "1.1",
            width: `calc(${radius} * 2.5)`,
            height: `calc(${radius} * 2.5)`,
            xmlns: $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c,
            x: "0px",
            y: "0px",
            "data-testid": "revolving-dot-svg",
            children: [
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("circle", {
                    fill: "none",
                    stroke: secondaryColor || color,
                    strokeWidth: strokeWidth,
                    cx: `calc(${radius} * 1.28)`,
                    cy: `calc(${radius} * 1.28)`,
                    r: radius,
                    style: {
                        opacity: 0.5
                    }
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("circle", {
                    fill: color,
                    stroke: color,
                    strokeWidth: "3",
                    cx: `calc(${radius} * 1.28)`,
                    cy: `calc(${radius} / 3.5)`,
                    r: `calc(${radius} / 5)`,
                    style: {
                        transformOrigin: "50% 50%"
                    },
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        dur: "2s",
                        type: "rotate",
                        from: "0",
                        to: "360",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    });
const $6bfaf8085a30c9b5$export$fdd9e2f491a77de7 = ({ height: height = 80, width: width = 80, radius: radius = 6, color: color = $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "rings-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $1e1ba35c5b9fc4c3$exports.jsx)($6bfaf8085a30c9b5$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "rings-loading",
        "aria-label": ariaLabel,
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 45 45",
            xmlns: $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c,
            stroke: color,
            "data-testid": "rings-svg",
            children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                transform: "translate(1 1)",
                strokeWidth: "2",
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                        cx: "22",
                        cy: "22",
                        r: radius,
                        strokeOpacity: "0",
                        children: [
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                                attributeName: "r",
                                begin: "1.5s",
                                dur: "3s",
                                values: "6;22",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            }),
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                                attributeName: "stroke-opacity",
                                begin: "1.5s",
                                dur: "3s",
                                values: "1;0",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            }),
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                                attributeName: "stroke-width",
                                begin: "1.5s",
                                dur: "3s",
                                values: "2;0",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        ]
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                        cx: "22",
                        cy: "22",
                        r: radius,
                        strokeOpacity: "0",
                        children: [
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                                attributeName: "r",
                                begin: "3s",
                                dur: "3s",
                                values: "6;22",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            }),
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                                attributeName: "strokeOpacity",
                                begin: "3s",
                                dur: "3s",
                                values: "1;0",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            }),
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                                attributeName: "strokeWidth",
                                begin: "3s",
                                dur: "3s",
                                values: "2;0",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        ]
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("circle", {
                        cx: "22",
                        cy: "22",
                        r: Number(radius) + 2,
                        children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                            attributeName: "r",
                            begin: "0s",
                            dur: "1.5s",
                            values: "6;1;2;3;4;5;6",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    })
                ]
            })
        })
    });
const $6bfaf8085a30c9b5$export$bb511942ded86554 = ({ wrapperClass: wrapperClass = "", color: color = $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, height: height = 100, width: width = 100, strokeWidth: strokeWidth = 4, ariaLabel: ariaLabel = "rotating-square-loading", wrapperStyle: wrapperStyle = {}, visible: visible = true })=>{
    return (0, $1e1ba35c5b9fc4c3$exports.jsx)($6bfaf8085a30c9b5$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "rotating-square-wrapper",
        "aria-label": ariaLabel,
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("svg", {
            version: "1.1",
            xmlns: $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c,
            x: "0px",
            y: "0px",
            viewBox: "0 0 100 100",
            enableBackground: "new 0 0 100 100",
            height: `${height}`,
            width: `${width}`,
            "data-testid": "rotating-square-svg",
            xmlSpace: "preserve",
            children: [
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("rect", {
                    fill: "none",
                    stroke: color,
                    strokeWidth: strokeWidth,
                    x: "25",
                    y: "25",
                    width: "50",
                    height: "50",
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        dur: "0.5s",
                        from: "0 50 50",
                        to: "180 50 50",
                        type: "rotate",
                        id: "strokeBox",
                        attributeType: "XML",
                        begin: "rectBox.end"
                    })
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("rect", {
                    x: "27",
                    y: "27",
                    fill: color,
                    width: "46",
                    height: "50",
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "height",
                        dur: "1.3s",
                        attributeType: "XML",
                        from: "50",
                        to: "0",
                        id: "rectBox",
                        fill: "freeze",
                        begin: "0s;strokeBox.end"
                    })
                })
            ]
        })
    });
};
const $6bfaf8085a30c9b5$var$$5819da83a926266a$var$POINTS = [
    0,
    30,
    60,
    90,
    120,
    150,
    180,
    210,
    240,
    270,
    300,
    330
];
const $6bfaf8085a30c9b5$var$$5819da83a926266a$var$spin = (0, $f655ac91f53a7a3c$export$d25ddfdf17c3ad3e)`
to {
   transform: rotate(360deg);
 }
`;
const $6bfaf8085a30c9b5$var$$5819da83a926266a$var$Svg = (0, $f655ac91f53a7a3c$export$2e2bcd8739ae039).svg`
  animation: ${$6bfaf8085a30c9b5$var$$5819da83a926266a$var$spin} 0.75s steps(12, end) infinite;
  animation-duration: 0.75s;
`;
const $6bfaf8085a30c9b5$var$$5819da83a926266a$var$Polyline = (0, $f655ac91f53a7a3c$export$2e2bcd8739ae039).polyline`
  stroke-width: ${(props)=>props.width}px;
  stroke-linecap: round;

  &:nth-child(12n + 0) {
    stroke-opacity: 0.08;
  }

  &:nth-child(12n + 1) {
    stroke-opacity: 0.17;
  }

  &:nth-child(12n + 2) {
    stroke-opacity: 0.25;
  }

  &:nth-child(12n + 3) {
    stroke-opacity: 0.33;
  }

  &:nth-child(12n + 4) {
    stroke-opacity: 0.42;
  }

  &:nth-child(12n + 5) {
    stroke-opacity: 0.5;
  }

  &:nth-child(12n + 6) {
    stroke-opacity: 0.58;
  }

  &:nth-child(12n + 7) {
    stroke-opacity: 0.66;
  }

  &:nth-child(12n + 8) {
    stroke-opacity: 0.75;
  }

  &:nth-child(12n + 9) {
    stroke-opacity: 0.83;
  }

  &:nth-child(12n + 11) {
    stroke-opacity: 0.92;
  }
`;
const $6bfaf8085a30c9b5$export$d20df8773b6b77b5 = ({ strokeColor: strokeColor = $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, strokeWidth: strokeWidth = "5", animationDuration: animationDuration = "0.75", width: width = "96", visible: visible = true, ariaLabel: ariaLabel = "rotating-lines-loading" })=>{
    const lines = (0, $lCzvA.useCallback)(()=>$6bfaf8085a30c9b5$var$$5819da83a926266a$var$POINTS.map((point)=>(0, $1e1ba35c5b9fc4c3$exports.jsx)($6bfaf8085a30c9b5$var$$5819da83a926266a$var$Polyline, {
                points: "24,12 24,4",
                width: strokeWidth,
                transform: `rotate(${point}, 24, 24)`
            }, point)), [
        strokeWidth
    ]);
    return !visible ? null : (0, $1e1ba35c5b9fc4c3$exports.jsx)($6bfaf8085a30c9b5$var$$5819da83a926266a$var$Svg, {
        xmlns: $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 48 48",
        width: width,
        stroke: strokeColor,
        speed: animationDuration,
        "data-testid": "rotating-lines-svg",
        "aria-label": ariaLabel,
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: lines()
    });
};
const $6bfaf8085a30c9b5$export$f8e5ae7506d65b32 = ({ height: height = 80, width: width = 80, strokeWidth: strokeWidth = 2, radius: radius = 1, color: color = $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "tail-spin-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>{
    const strokeWidthNum = parseInt(String(strokeWidth));
    const viewBoxValue = strokeWidthNum + 36;
    const halfStrokeWidth = strokeWidthNum / 2;
    const processedRadius = halfStrokeWidth + parseInt(String(radius)) - 1;
    return (0, $1e1ba35c5b9fc4c3$exports.jsx)($6bfaf8085a30c9b5$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "tail-spin-loading",
        "aria-label": ariaLabel,
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("svg", {
            width: width,
            height: height,
            viewBox: `0 0 ${viewBoxValue} ${viewBoxValue}`,
            xmlns: $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c,
            "data-testid": "tail-spin-svg",
            children: [
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("defs", {
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("linearGradient", {
                        x1: "8.042%",
                        y1: "0%",
                        x2: "65.682%",
                        y2: "23.865%",
                        id: "a",
                        children: [
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("stop", {
                                stopColor: color,
                                stopOpacity: "0",
                                offset: "0%"
                            }),
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("stop", {
                                stopColor: color,
                                stopOpacity: ".631",
                                offset: "63.146%"
                            }),
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("stop", {
                                stopColor: color,
                                offset: "100%"
                            })
                        ]
                    })
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("g", {
                    fill: "none",
                    fillRule: "evenodd",
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("g", {
                        transform: `translate(${halfStrokeWidth} ${halfStrokeWidth})`,
                        children: [
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                                d: "M36 18c0-9.94-8.06-18-18-18",
                                id: "Oval-2",
                                stroke: color,
                                strokeWidth: strokeWidth,
                                children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                                    attributeName: "transform",
                                    type: "rotate",
                                    from: "0 18 18",
                                    to: "360 18 18",
                                    dur: "0.9s",
                                    repeatCount: "indefinite"
                                })
                            }),
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("circle", {
                                fill: "#fff",
                                cx: "36",
                                cy: "18",
                                r: processedRadius,
                                children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                                    attributeName: "transform",
                                    type: "rotate",
                                    from: "0 18 18",
                                    to: "360 18 18",
                                    dur: "0.9s",
                                    repeatCount: "indefinite"
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
const $6bfaf8085a30c9b5$export$e21573137ccb7f5d = ({ wrapperStyle: wrapperStyle = {}, visible: visible = true, wrapperClass: wrapperClass = "", height: height = 100, width: width = 100, color: color = $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "three-circles-loading", outerCircleColor: outerCircleColor, innerCircleColor: innerCircleColor, middleCircleColor: middleCircleColor })=>{
    return (0, $1e1ba35c5b9fc4c3$exports.jsx)($6bfaf8085a30c9b5$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "three-circles-wrapper",
        "aria-label": ariaLabel,
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("svg", {
            version: "1.1",
            height: `${height}`,
            width: `${width}`,
            xmlns: $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c,
            viewBox: "0 0 100 100",
            enableBackground: "new 0 0 100 100",
            xmlSpace: "preserve",
            "data-testid": "three-circles-svg",
            children: [
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                    fill: outerCircleColor || color,
                    d: "M31.6,3.5C5.9,13.6-6.6,42.7,3.5,68.4c10.1,25.7,39.2,38.3,64.9,28.1l-3.1-7.9c-21.3,8.4-45.4-2-53.8-23.3 c-8.4-21.3,2-45.4,23.3-53.8L31.6,3.5z",
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        attributeType: "XML",
                        type: "rotate",
                        dur: "2s",
                        from: "0 50 50",
                        to: "360 50 50",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                    fill: middleCircleColor || color,
                    d: "M42.3,39.6c5.7-4.3,13.9-3.1,18.1,2.7c4.3,5.7,3.1,13.9-2.7,18.1l4.1,5.5c8.8-6.5,10.6-19,4.1-27.7 c-6.5-8.8-19-10.6-27.7-4.1L42.3,39.6z",
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        attributeType: "XML",
                        type: "rotate",
                        dur: "1s",
                        from: "0 50 50",
                        to: "-360 50 50",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                    fill: innerCircleColor || color,
                    d: "M82,35.7C74.1,18,53.4,10.1,35.7,18S10.1,46.6,18,64.3l7.6-3.4c-6-13.5,0-29.3,13.5-35.3s29.3,0,35.3,13.5 L82,35.7z",
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        attributeType: "XML",
                        type: "rotate",
                        dur: "2s",
                        from: "0 50 50",
                        to: "360 50 50",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    });
};
const $6bfaf8085a30c9b5$export$4bf83b24a11cff0b = ({ height: height = 80, width: width = 80, radius: radius = 9, color: color = $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "three-dots-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $1e1ba35c5b9fc4c3$exports.jsx)($6bfaf8085a30c9b5$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "three-dots-loading",
        "aria-label": ariaLabel,
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 120 30",
            xmlns: $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c,
            fill: color,
            "data-testid": "three-dots-svg",
            children: [
                (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                    cx: "15",
                    cy: "15",
                    r: Number(radius) + 6,
                    children: [
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                            attributeName: "r",
                            from: "15",
                            to: "15",
                            begin: "0s",
                            dur: "0.8s",
                            values: "15;9;15",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                            attributeName: "fill-opacity",
                            from: "1",
                            to: "1",
                            begin: "0s",
                            dur: "0.8s",
                            values: "1;.5;1",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                    cx: "60",
                    cy: "15",
                    r: radius,
                    attributeName: "fill-opacity",
                    from: "1",
                    to: "0.3",
                    children: [
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                            attributeName: "r",
                            from: "9",
                            to: "9",
                            begin: "0s",
                            dur: "0.8s",
                            values: "9;15;9",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                            attributeName: "fill-opacity",
                            from: "0.5",
                            to: "0.5",
                            begin: "0s",
                            dur: "0.8s",
                            values: ".5;1;.5",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                    cx: "105",
                    cy: "15",
                    r: Number(radius) + 6,
                    children: [
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                            attributeName: "r",
                            from: "15",
                            to: "15",
                            begin: "0s",
                            dur: "0.8s",
                            values: "15;9;15",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                            attributeName: "fill-opacity",
                            from: "1",
                            to: "1",
                            begin: "0s",
                            dur: "0.8s",
                            values: "1;.5;1",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                })
            ]
        })
    });
const $6bfaf8085a30c9b5$var$$afa12dd3e98f740f$var$VIEW_BOX_VALUES = "-3 -4 39 39";
const $6bfaf8085a30c9b5$var$$afa12dd3e98f740f$var$POLYGON_POINTS = "16,0 32,32 0,32";
/** Styles */ const $6bfaf8085a30c9b5$var$$afa12dd3e98f740f$var$dash = (0, $f655ac91f53a7a3c$export$d25ddfdf17c3ad3e)`
to {
   stroke-dashoffset: 136;
 }
`;
const $6bfaf8085a30c9b5$var$$afa12dd3e98f740f$var$Polygon = (0, $f655ac91f53a7a3c$export$2e2bcd8739ae039).polygon`
  stroke-dasharray: 17;
  animation: ${$6bfaf8085a30c9b5$var$$afa12dd3e98f740f$var$dash} 2.5s cubic-bezier(0.35, 0.04, 0.63, 0.95) infinite;
`;
const $6bfaf8085a30c9b5$var$$afa12dd3e98f740f$var$SVG = (0, $f655ac91f53a7a3c$export$2e2bcd8739ae039).svg`
  transform-origin: 50% 65%;
`;
const $6bfaf8085a30c9b5$export$5a465592bfe74b48 = ({ height: height = 80, width: width = 80, color: color = $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "triangle-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>{
    return (0, $1e1ba35c5b9fc4c3$exports.jsx)($6bfaf8085a30c9b5$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: `${wrapperClass}`,
        "data-testid": "triangle-loading",
        "aria-label": ariaLabel,
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $1e1ba35c5b9fc4c3$exports.jsx)($6bfaf8085a30c9b5$var$$afa12dd3e98f740f$var$SVG, {
            id: "triangle",
            width: width,
            height: height,
            xmlns: $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c,
            viewBox: $6bfaf8085a30c9b5$var$$afa12dd3e98f740f$var$VIEW_BOX_VALUES,
            "data-testid": "triangle-svg",
            children: (0, $1e1ba35c5b9fc4c3$exports.jsx)($6bfaf8085a30c9b5$var$$afa12dd3e98f740f$var$Polygon, {
                fill: "transparent",
                stroke: color,
                strokeWidth: "1",
                points: $6bfaf8085a30c9b5$var$$afa12dd3e98f740f$var$POLYGON_POINTS
            })
        })
    });
};
const $6bfaf8085a30c9b5$export$4c68f1a79f88778c = ({ height: height = 80, width: width = 80, radius: radius = 48, color: color = $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "watch-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $1e1ba35c5b9fc4c3$exports.jsx)($6bfaf8085a30c9b5$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "watch-loading",
        "aria-label": ariaLabel,
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("svg", {
            width: width,
            height: height,
            version: "1.1",
            id: "L2",
            xmlns: $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c,
            x: "0px",
            y: "0px",
            viewBox: "0 0 100 100",
            enableBackground: "new 0 0 100 100",
            xmlSpace: "preserve",
            "data-testid": "watch-svg",
            children: [
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("circle", {
                    fill: "none",
                    stroke: color,
                    strokeWidth: "4",
                    strokeMiterlimit: "10",
                    cx: "50",
                    cy: "50",
                    r: radius
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("line", {
                    fill: "none",
                    strokeLinecap: "round",
                    stroke: color,
                    strokeWidth: "4",
                    strokeMiterlimit: "10",
                    x1: "50",
                    y1: "50",
                    x2: "85",
                    y2: "50.5",
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        dur: "2s",
                        type: "rotate",
                        from: "0 50 50",
                        to: "360 50 50",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("line", {
                    fill: "none",
                    strokeLinecap: "round",
                    stroke: color,
                    strokeWidth: "4",
                    strokeMiterlimit: "10",
                    x1: "50",
                    y1: "50",
                    x2: "49.5",
                    y2: "74",
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        dur: "15s",
                        type: "rotate",
                        from: "0 50 50",
                        to: "360 50 50",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    });
const $6bfaf8085a30c9b5$export$1ed1943372cc63a9 = ({ color: color = $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, width: width = "100", visible: visible = true })=>{
    return visible ? (0, $1e1ba35c5b9fc4c3$exports.jsxs)("svg", {
        xmlns: $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c,
        width: width,
        height: width,
        viewBox: "0 0 100 100",
        "data-testid": "falling-lines",
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("rect", {
                y: "25",
                width: "10",
                height: "50",
                rx: "4",
                ry: "4",
                fill: color,
                "data-testid": "falling-lines-rect-1",
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "x",
                        values: "10;100",
                        dur: "1.2s",
                        repeatCount: "indefinite"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "rotate",
                        from: "0 10 70",
                        to: "-60 100 70",
                        dur: "1.2s",
                        repeatCount: "indefinite"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "opacity",
                        values: "0;1;0",
                        dur: "1.2s",
                        repeatCount: "indefinite"
                    })
                ]
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("rect", {
                y: "25",
                width: "10",
                height: "50",
                rx: "4",
                ry: "4",
                fill: color,
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "x",
                        values: "10;100",
                        dur: "1.2s",
                        begin: "0.4s",
                        repeatCount: "indefinite"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "rotate",
                        from: "0 10 70",
                        to: "-60 100 70",
                        dur: "1.2s",
                        begin: "0.4s",
                        repeatCount: "indefinite"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "opacity",
                        values: "0;1;0",
                        dur: "1.2s",
                        begin: "0.4s",
                        repeatCount: "indefinite"
                    })
                ]
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("rect", {
                y: "25",
                width: "10",
                height: "50",
                rx: "4",
                ry: "4",
                fill: color,
                "data-testid": "falling-lines-rect-2",
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "x",
                        values: "10;100",
                        dur: "1.2s",
                        begin: "0.8s",
                        repeatCount: "indefinite"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "rotate",
                        from: "0 10 70",
                        to: "-60 100 70",
                        dur: "1.2s",
                        begin: "0.8s",
                        repeatCount: "indefinite"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "opacity",
                        values: "0;1;0",
                        dur: "1.2s",
                        begin: "0.8s",
                        repeatCount: "indefinite"
                    })
                ]
            })
        ]
    }) : null;
};
const $6bfaf8085a30c9b5$export$d25f4198d7ad6c78 = ({ visible: visible = true, height: height = "80", width: width = "80", ariaLabel: ariaLabel = "vortex-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, colors: colors = [
    "#1B5299",
    "#EF8354",
    "#DB5461",
    "#1B5299",
    "#EF8354",
    "#DB5461"
] })=>{
    return !visible ? null : (0, $1e1ba35c5b9fc4c3$exports.jsx)("svg", {
        height: height,
        width: width,
        xmlns: $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        "data-testid": "vortex-svg",
        "aria-label": ariaLabel,
        style: wrapperStyle,
        className: wrapperClass,
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("g", {
            transform: "translate(50,50)",
            children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("g", {
                transform: "scale(0.7)",
                children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("g", {
                    transform: "translate(-50,-50)",
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("g", {
                        transform: "rotate(137.831 50 50)",
                        children: [
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "rotate",
                                repeatCount: "indefinite",
                                values: "360 50 50;0 50 50",
                                keyTimes: "0;1",
                                dur: "1",
                                keySplines: "0.5 0.5 0.5 0.5",
                                calcMode: "spline"
                            }),
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                                fill: colors[0],
                                d: "M30.4,9.7c-7.4,10.9-11.8,23.8-12.3,37.9c0.2,1,0.5,1.9,0.7,2.8c1.4-5.2,3.4-10.3,6.2-15.1 c2.6-4.4,5.6-8.4,9-12c0.7-0.7,1.4-1.4,2.1-2.1c7.4-7,16.4-12,26-14.6C51.5,3.6,40.2,4.9,30.4,9.7z"
                            }),
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                                fill: colors[1],
                                d: "M24.8,64.2c-2.6-4.4-4.5-9.1-5.9-13.8c-0.3-0.9-0.5-1.9-0.7-2.8c-2.4-9.9-2.2-20.2,0.4-29.8 C10.6,25.5,6,36,5.3,46.8C11,58.6,20,68.9,31.9,76.3c0.9,0.3,1.9,0.5,2.8,0.8C31,73.3,27.6,69,24.8,64.2z"
                            }),
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                                fill: colors[2],
                                d: "M49.6,78.9c-5.1,0-10.1-0.6-14.9-1.8c-1-0.2-1.9-0.5-2.8-0.8c-9.8-2.9-18.5-8.2-25.6-15.2 c2.8,10.8,9.5,20,18.5,26c13.1,0.9,26.6-1.7,38.9-8.3c0.7-0.7,1.4-1.4,2.1-2.1C60.7,78.2,55.3,78.9,49.6,78.9z"
                            }),
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                                fill: colors[3],
                                d: "M81.1,49.6c-1.4,5.2-3.4,10.3-6.2,15.1c-2.6,4.4-5.6,8.4-9,12c-0.7,0.7-1.4,1.4-2.1,2.1 c-7.4,7-16.4,12-26,14.6c10.7,3,22.1,1.7,31.8-3.1c7.4-10.9,11.8-23.8,12.3-37.9C81.6,51.5,81.4,50.6,81.1,49.6z"
                            }),
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                                fill: colors[4],
                                d: "M75.2,12.9c-13.1-0.9-26.6,1.7-38.9,8.3c-0.7,0.7-1.4,1.4-2.1,2.1c5.2-1.4,10.6-2.2,16.2-2.2 c5.1,0,10.1,0.6,14.9,1.8c1,0.2,1.9,0.5,2.8,0.8c9.8,2.9,18.5,8.2,25.6,15.2C90.9,28.1,84.2,18.9,75.2,12.9z"
                            }),
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                                fill: colors[5],
                                d: "M94.7,53.2C89,41.4,80,31.1,68.1,23.7c-0.9-0.3-1.9-0.5-2.8-0.8c3.8,3.8,7.2,8.1,10,13 c2.6,4.4,4.5,9.1,5.9,13.8c0.3,0.9,0.5,1.9,0.7,2.8c2.4,9.9,2.2,20.2-0.4,29.8C89.4,74.5,94,64,94.7,53.2z"
                            })
                        ]
                    })
                })
            })
        })
    });
};
const $6bfaf8085a30c9b5$export$f64f16a115ce395d = ({ visible: visible = true, height: height = "80", width: width = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "rotating-triangle-loading", colors: colors = [
    "#1B5299",
    "#EF8354",
    "#DB5461"
] })=>{
    return !visible ? null : (0, $1e1ba35c5b9fc4c3$exports.jsx)("svg", {
        width: width,
        height: height,
        xmlns: $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "rotating-triangle-svg",
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("g", {
            transform: "translate(50,42)",
            children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("g", {
                transform: "scale(0.8)",
                children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("g", {
                    transform: "translate(-50,-50)",
                    children: [
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("polygon", {
                            points: "72.5,50 50,11 27.5,50 50,50",
                            fill: colors[0],
                            transform: "rotate(186 50 38.5)",
                            children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "rotate",
                                calcMode: "linear",
                                values: "0 50 38.5;360 50 38.5",
                                keyTimes: "0;1",
                                dur: "1s",
                                begin: "0s",
                                repeatCount: "indefinite"
                            })
                        }),
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("polygon", {
                            points: "5,89 50,89 27.5,50",
                            fill: colors[1],
                            transform: "rotate(186 27.5 77.5)",
                            children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "rotate",
                                calcMode: "linear",
                                values: "0 27.5 77.5;360 27.5 77.5",
                                keyTimes: "0;1",
                                dur: "1s",
                                begin: "0s",
                                repeatCount: "indefinite"
                            })
                        }),
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("polygon", {
                            points: "72.5,50 50,89 95,89",
                            fill: colors[2],
                            transform: "rotate(186 72.2417 77.5)",
                            children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "rotate",
                                calcMode: "linear",
                                values: "0 72.5 77.5;360 72 77.5",
                                keyTimes: "0;1",
                                dur: "1s",
                                begin: "0s",
                                repeatCount: "indefinite"
                            })
                        })
                    ]
                })
            })
        })
    });
};
const $6bfaf8085a30c9b5$export$d7b12c4107be0d61 = ({ visible: visible = true, height: height = "80", width: width = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "radio-loading", colors: colors = [
    $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c,
    $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c,
    $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c
] })=>{
    return !visible ? null : (0, $1e1ba35c5b9fc4c3$exports.jsxs)("svg", {
        width: width,
        height: height,
        xmlns: $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "radio-bar-svg",
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("circle", {
                cx: "28",
                cy: "75",
                r: "11",
                fill: colors[0],
                children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                    attributeName: "fill-opacity",
                    calcMode: "linear",
                    values: "0;1;1",
                    keyTimes: "0;0.2;1",
                    dur: "1",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                d: "M28 47A28 28 0 0 1 56 75",
                fill: "none",
                strokeWidth: "10",
                stroke: colors[1],
                children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                    attributeName: "stroke-opacity",
                    calcMode: "linear",
                    values: "0;1;1",
                    keyTimes: "0;0.2;1",
                    dur: "1",
                    begin: "0.1s",
                    repeatCount: "indefinite"
                })
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                d: "M28 25A50 50 0 0 1 78 75",
                fill: "none",
                strokeWidth: "10",
                stroke: colors[2],
                children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                    attributeName: "stroke-opacity",
                    calcMode: "linear",
                    values: "0;1;1",
                    keyTimes: "0;0.2;1",
                    dur: "1",
                    begin: "0.2s",
                    repeatCount: "indefinite"
                })
            })
        ]
    });
};
const $6bfaf8085a30c9b5$export$c17561cb55d4db30 = ({ visible: visible = true, height: height = "80", width: width = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "progress-bar-loading", borderColor: borderColor = "#F4442E", barColor: barColor = "#51E5FF" })=>{
    return !visible ? null : (0, $1e1ba35c5b9fc4c3$exports.jsxs)("svg", {
        width: width,
        height: height,
        xmlns: $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "progress-bar-svg",
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("defs", {
                children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("clipPath", {
                    x: "0",
                    y: "0",
                    width: "100",
                    height: "100",
                    id: "lds-progress-cpid-5009611b8a418",
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("rect", {
                        x: "0",
                        y: "0",
                        width: "66.6667",
                        height: "100",
                        children: [
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                                attributeName: "width",
                                calcMode: "linear",
                                values: "0;100;100",
                                keyTimes: "0;0.5;1",
                                dur: "1",
                                begin: "0s",
                                repeatCount: "indefinite"
                            }),
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                                attributeName: "x",
                                calcMode: "linear",
                                values: "0;0;100",
                                keyTimes: "0;0.5;1",
                                dur: "1",
                                begin: "0s",
                                repeatCount: "indefinite"
                            })
                        ]
                    })
                })
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                fill: "none",
                strokeWidth: "2.7928",
                d: "M82,63H18c-7.2,0-13-5.8-13-13v0c0-7.2,5.8-13,13-13h64c7.2,0,13,5.8,13,13v0C95,57.2,89.2,63,82,63z",
                stroke: borderColor
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                d: "M81.3,58.7H18.7c-4.8,0-8.7-3.9-8.7-8.7v0c0-4.8,3.9-8.7,8.7-8.7h62.7c4.8,0,8.7,3.9,8.7,8.7v0C90,54.8,86.1,58.7,81.3,58.7z",
                fill: barColor,
                clipPath: "url(#lds-progress-cpid-5009611b8a418)"
            })
        ]
    });
};
const $6bfaf8085a30c9b5$export$bdf537af43a20db5 = ({ visible: visible = true, height: height = "80", width: width = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "magnifying-glass-loading", glassColor: glassColor = "#c0efff", color: color = "#e15b64" })=>{
    return !visible ? null : (0, $1e1ba35c5b9fc4c3$exports.jsx)("svg", {
        width: width,
        height: height,
        xmlns: $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "magnifying-glass-svg",
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("g", {
            transform: "translate(50,50)",
            children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("g", {
                transform: "scale(0.82)",
                children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("g", {
                    transform: "translate(-50,-50)",
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("g", {
                        transform: "translate(16.3636 -20)",
                        children: [
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "translate",
                                calcMode: "linear",
                                values: "-20 -20;20 -20;0 20;-20 -20",
                                keyTimes: "0;0.33;0.66;1",
                                dur: "1s",
                                begin: "0s",
                                repeatCount: "indefinite"
                            }),
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                                d: "M44.19,26.158c-4.817,0-9.345,1.876-12.751,5.282c-3.406,3.406-5.282,7.934-5.282,12.751 c0,4.817,1.876,9.345,5.282,12.751c3.406,3.406,7.934,5.282,12.751,5.282s9.345-1.876,12.751-5.282 c3.406-3.406,5.282-7.934,5.282-12.751c0-4.817-1.876-9.345-5.282-12.751C53.536,28.033,49.007,26.158,44.19,26.158z",
                                fill: glassColor
                            }),
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                                d: "M78.712,72.492L67.593,61.373l-3.475-3.475c1.621-2.352,2.779-4.926,3.475-7.596c1.044-4.008,1.044-8.23,0-12.238 c-1.048-4.022-3.146-7.827-6.297-10.979C56.572,22.362,50.381,20,44.19,20C38,20,31.809,22.362,27.085,27.085 c-9.447,9.447-9.447,24.763,0,34.21C31.809,66.019,38,68.381,44.19,68.381c4.798,0,9.593-1.425,13.708-4.262l9.695,9.695 l4.899,4.899C73.351,79.571,74.476,80,75.602,80s2.251-0.429,3.11-1.288C80.429,76.994,80.429,74.209,78.712,72.492z M56.942,56.942 c-3.406,3.406-7.934,5.282-12.751,5.282s-9.345-1.876-12.751-5.282c-3.406-3.406-5.282-7.934-5.282-12.751 c0-4.817,1.876-9.345,5.282-12.751c3.406-3.406,7.934-5.282,12.751-5.282c4.817,0,9.345,1.876,12.751,5.282 c3.406,3.406,5.282,7.934,5.282,12.751C62.223,49.007,60.347,53.536,56.942,56.942z",
                                fill: color
                            })
                        ]
                    })
                })
            })
        })
    });
};
const $6bfaf8085a30c9b5$export$8e3fad5cade57efa = ({ width: width = "80", height: height = "80", backgroundColor: backgroundColor = $6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ballColors: ballColors = [
    "#fc636b",
    "#6a67ce",
    "#ffb900"
], wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "fidget-spinner-loader", visible: visible = true })=>{
    return !visible ? null : (0, $1e1ba35c5b9fc4c3$exports.jsx)("svg", {
        width: width,
        height: height,
        xmlns: $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "fidget-spinner-svg",
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("g", {
            transform: "rotate(6 50 50)",
            children: [
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("g", {
                    transform: "translate(50 50)",
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("g", {
                        transform: "scale(0.9)",
                        children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("g", {
                            transform: "translate(-50 -58)",
                            children: [
                                (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                                    d: "M27.1,79.4c-1.1,0.6-2.4,1-3.7,1c-2.6,0-5.1-1.4-6.4-3.7c-2-3.5-0.8-8,2.7-10.1c1.1-0.6,2.4-1,3.7-1c2.6,0,5.1,1.4,6.4,3.7 C31.8,72.9,30.6,77.4,27.1,79.4z",
                                    fill: ballColors[0]
                                }),
                                (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                                    d: "M72.9,79.4c1.1,0.6,2.4,1,3.7,1c2.6,0,5.1-1.4,6.4-3.7c2-3.5,0.8-8-2.7-10.1c-1.1-0.6-2.4-1-3.7-1c-2.6,0-5.1,1.4-6.4,3.7 C68.2,72.9,69.4,77.4,72.9,79.4z",
                                    fill: ballColors[1]
                                }),
                                (0, $1e1ba35c5b9fc4c3$exports.jsx)("circle", {
                                    cx: "50",
                                    cy: "27",
                                    r: "7.4",
                                    fill: ballColors[2]
                                }),
                                (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                                    d: "M86.5,57.5c-3.1-1.9-6.4-2.8-9.8-2.8c-0.5,0-0.9,0-1.4,0c-0.4,0-0.8,0-1.1,0c-2.1,0-4.2-0.4-6.2-1.2 c-0.8-3.6-2.8-6.9-5.4-9.3c0.4-2.5,1.3-4.8,2.7-6.9c2-2.9,3.2-6.5,3.2-10.4c0-10.2-8.2-18.4-18.4-18.4c-0.3,0-0.6,0-0.9,0 C39.7,9,32,16.8,31.6,26.2c-0.2,4.1,1,7.9,3.2,11c1.4,2.1,2.3,4.5,2.7,6.9c-2.6,2.5-4.6,5.7-5.4,9.3c-1.9,0.7-4,1.1-6.1,1.1 c-0.4,0-0.8,0-1.2,0c-0.5,0-0.9-0.1-1.4-0.1c-3.1,0-6.3,0.8-9.2,2.5c-9.1,5.2-12,17-6.3,25.9c3.5,5.4,9.5,8.4,15.6,8.4 c2.9,0,5.8-0.7,8.5-2.1c3.6-1.9,6.3-4.9,8-8.3c1.1-2.3,2.7-4.2,4.6-5.8c1.7,0.5,3.5,0.8,5.4,0.8c1.9,0,3.7-0.3,5.4-0.8 c1.9,1.6,3.5,3.5,4.6,5.7c1.5,3.2,4,6,7.4,8c2.9,1.7,6.1,2.5,9.2,2.5c6.6,0,13.1-3.6,16.4-10C97.3,73.1,94.4,62.5,86.5,57.5z M29.6,83.7c-1.9,1.1-4,1.6-6.1,1.6c-4.2,0-8.4-2.2-10.6-6.1c-3.4-5.9-1.4-13.4,4.5-16.8c1.9-1.1,4-1.6,6.1-1.6 c4.2,0,8.4,2.2,10.6,6.1C37.5,72.8,35.4,80.3,29.6,83.7z M50,39.3c-6.8,0-12.3-5.5-12.3-12.3S43.2,14.7,50,14.7 c6.8,0,12.3,5.5,12.3,12.3S56.8,39.3,50,39.3z M87.2,79.2c-2.3,3.9-6.4,6.1-10.6,6.1c-2.1,0-4.2-0.5-6.1-1.6 c-5.9-3.4-7.9-10.9-4.5-16.8c2.3-3.9,6.4-6.1,10.6-6.1c2.1,0,4.2,0.5,6.1,1.6C88.6,65.8,90.6,73.3,87.2,79.2z",
                                    fill: backgroundColor
                                })
                            ]
                        })
                    })
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                    attributeName: "transform",
                    type: "rotate",
                    calcMode: "linear",
                    values: "0 50 50;360 50 50",
                    keyTimes: "0;1",
                    dur: "1s",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            ]
        })
    });
};
const $6bfaf8085a30c9b5$export$bee07fdc425df572 = ({ visible: visible = true, width: width = "80", height: height = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "dna-loading" })=>{
    return !visible ? null : (0, $1e1ba35c5b9fc4c3$exports.jsxs)("svg", {
        xmlns: $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c,
        width: width,
        height: height,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "dna-svg",
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                cx: "6.451612903225806",
                cy: "60.6229",
                r: "3.41988",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.5s"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "0s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.5s"
                    })
                ]
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                cx: "6.451612903225806",
                cy: "39.3771",
                r: "2.58012",
                fill: "#46dff0",
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.5s"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.5s"
                    })
                ]
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                cx: "16.129032258064512",
                cy: "68.1552",
                r: "3.17988",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.7s"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.2s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.7s"
                    })
                ]
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                cx: "16.129032258064512",
                cy: "31.8448",
                r: "2.82012",
                fill: "#46dff0",
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.7s"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.2s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.7s"
                    })
                ]
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                cx: "25.806451612903224",
                cy: "69.3634",
                r: "2.93988",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.9s"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.4s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.9s"
                    })
                ]
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                cx: "25.806451612903224",
                cy: "30.6366",
                r: "3.06012",
                fill: "#46dff0",
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.9s"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.4s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.9s"
                    })
                ]
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                cx: "35.48387096774193",
                cy: "65.3666",
                r: "2.69988",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.1s"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.6s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.1s"
                    })
                ]
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                cx: "35.48387096774193",
                cy: "34.6334",
                r: "3.30012",
                fill: "#46dff0",
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.1s"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.6s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.1s"
                    })
                ]
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                cx: "45.16129032258064",
                cy: "53.8474",
                r: "2.45988",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.3s"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.8s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.3s"
                    })
                ]
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                cx: "45.16129032258064",
                cy: "46.1526",
                r: "3.54012",
                fill: "#46dff0",
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.3s"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.8s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.3s"
                    })
                ]
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                cx: "54.838709677419345",
                cy: "39.3771",
                r: "2.58012",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.5s"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.5s"
                    })
                ]
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                cx: "54.838709677419345",
                cy: "60.6229",
                r: "3.41988",
                fill: "#46dff0",
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.5s"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.5s"
                    })
                ]
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                cx: "64.51612903225805",
                cy: "31.8448",
                r: "2.82012",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.7s"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.2s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.7s"
                    })
                ]
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                cx: "64.51612903225805",
                cy: "68.1552",
                r: "3.17988",
                fill: "#46dff0",
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.7s"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.2s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.7s"
                    })
                ]
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                cx: "74.19354838709677",
                cy: "30.6366",
                r: "3.06012",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.9s"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.4s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.9s"
                    })
                ]
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                cx: "74.19354838709677",
                cy: "69.3634",
                r: "2.93988",
                fill: "#46dff0",
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.9s"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.4s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.9s"
                    })
                ]
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                cx: "83.87096774193547",
                cy: "34.6334",
                r: "3.30012",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.1s"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.6s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.1s"
                    })
                ]
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                cx: "83.87096774193547",
                cy: "65.3666",
                r: "2.69988",
                fill: "#46dff0",
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-3.1s"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.6s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.1s"
                    })
                ]
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                cx: "93.54838709677418",
                cy: "46.1526",
                r: "3.54012",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.3s"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.8s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.3s"
                    })
                ]
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("circle", {
                cx: "93.54838709677418",
                cy: "53.8474",
                r: "2.45988",
                fill: "#46dff0",
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-3.3s"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.8s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.3s"
                    })
                ]
            })
        ]
    });
};
const $6bfaf8085a30c9b5$export$f93420b62a5bdffa = ({ visible: visible = true, width: width = "80", height: height = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "discuss-loading", colors: colors = [
    "#ff727d",
    "#ff727d"
] })=>{
    return !visible ? null : (0, $1e1ba35c5b9fc4c3$exports.jsxs)("svg", {
        width: width,
        height: height,
        xmlns: $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "discuss-svg",
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                fill: "none",
                d: "M82 50A32 32 0 1 1 23.533421623214014 32.01333190873183 L21.71572875253809 21.7157287525381 L32.013331908731814 23.53342162321403 A32 32 0 0 1 82 50",
                strokeWidth: "5",
                stroke: colors[0]
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("circle", {
                cx: "50",
                cy: "50",
                fill: "none",
                strokeLinecap: "round",
                r: "20",
                strokeWidth: "5",
                stroke: colors[1],
                strokeDasharray: "31.41592653589793 31.41592653589793",
                transform: "rotate(96 50 50)",
                children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                    attributeName: "transform",
                    type: "rotate",
                    calcMode: "linear",
                    values: "0 50 50;360 50 50",
                    keyTimes: "0;1",
                    dur: "1s",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            })
        ]
    });
};
const $6bfaf8085a30c9b5$export$dc036a5afb9ca26f = ({ visible: visible = true, width: width = "80", height: height = "80", colors: colors = [
    "#e15b64",
    "#f47e60",
    "#f8b26a",
    "#abbd81",
    "#849b87"
], wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "color-ring-loading" })=>{
    return !visible ? null : (0, $1e1ba35c5b9fc4c3$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: width,
        height: height,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "color-ring-svg",
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("defs", {
                children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("mask", {
                    id: "ldio-4offds5dlws-mask",
                    children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("circle", {
                        cx: "50",
                        cy: "50",
                        r: "26",
                        stroke: "#fff",
                        strokeLinecap: "round",
                        strokeDasharray: "122.52211349000194 40.840704496667314",
                        strokeWidth: "9",
                        transform: "rotate(198.018 50 50)",
                        children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                            attributeName: "transform",
                            type: "rotate",
                            values: "0 50 50;360 50 50",
                            keyTimes: "0;1",
                            dur: "1s",
                            repeatCount: "indefinite"
                        })
                    })
                })
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("g", {
                mask: "url(#ldio-4offds5dlws-mask)",
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("rect", {
                        x: "14.5",
                        y: "0",
                        width: "15",
                        height: "100",
                        fill: colors[0],
                        children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                            attributeName: "fill",
                            values: colors.join(";").toString(),
                            keyTimes: "0;0.25;0.5;0.75;1",
                            dur: "1s",
                            repeatCount: "indefinite",
                            begin: "-0.8s"
                        })
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("rect", {
                        x: "28.5",
                        y: "0",
                        width: "15",
                        height: "100",
                        fill: colors[1],
                        children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                            attributeName: "fill",
                            values: colors.join(";").toString(),
                            keyTimes: "0;0.25;0.5;0.75;1",
                            dur: "1s",
                            repeatCount: "indefinite",
                            begin: "-0.6s"
                        })
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("rect", {
                        x: "42.5",
                        y: "0",
                        width: "15",
                        height: "100",
                        fill: colors[2],
                        children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                            attributeName: "fill",
                            values: colors.join(";").toString(),
                            keyTimes: "0;0.25;0.5;0.75;1",
                            dur: "1s",
                            repeatCount: "indefinite",
                            begin: "-0.4s"
                        })
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("rect", {
                        x: "56.5",
                        y: "0",
                        width: "15",
                        height: "100",
                        fill: colors[3],
                        children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                            attributeName: "fill",
                            values: colors.join(";").toString(),
                            keyTimes: "0;0.25;0.5;0.75;1",
                            dur: "1s",
                            repeatCount: "indefinite",
                            begin: "-0.2s"
                        })
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("rect", {
                        x: "70.5",
                        y: "0",
                        width: "15",
                        height: "100",
                        fill: colors[4],
                        children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                            attributeName: "fill",
                            values: colors.join(";").toString(),
                            keyTimes: "0;0.25;0.5;0.75;1",
                            dur: "1s",
                            repeatCount: "indefinite",
                            begin: "0s"
                        })
                    })
                ]
            })
        ]
    });
};
const $6bfaf8085a30c9b5$export$4d299b491347818a = ({ visible: visible = true, width: width = "80", height: height = "80", backgroundColor: backgroundColor = "#ff6d00", color: color = "#fff", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "comment-loading" })=>{
    return !visible ? null : (0, $1e1ba35c5b9fc4c3$exports.jsxs)("svg", {
        width: width,
        height: height,
        xmlns: $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "comment-svg",
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                d: "M78,19H22c-6.6,0-12,5.4-12,12v31c0,6.6,5.4,12,12,12h37.2c0.4,3,1.8,5.6,3.7,7.6c2.4,2.5,5.1,4.1,9.1,4 c-1.4-2.1-2-7.2-2-10.3c0-0.4,0-0.8,0-1.3h8c6.6,0,12-5.4,12-12V31C90,24.4,84.6,19,78,19z",
                fill: backgroundColor
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("circle", {
                cx: "30",
                cy: "47",
                r: "5",
                fill: color,
                children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                    attributeName: "opacity",
                    calcMode: "linear",
                    values: "0;1;1",
                    keyTimes: "0;0.2;1",
                    dur: "1",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("circle", {
                cx: "50",
                cy: "47",
                r: "5",
                fill: color,
                children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                    attributeName: "opacity",
                    calcMode: "linear",
                    values: "0;0;1;1",
                    keyTimes: "0;0.2;0.4;1",
                    dur: "1",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("circle", {
                cx: "70",
                cy: "47",
                r: "5",
                fill: color,
                children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                    attributeName: "opacity",
                    calcMode: "linear",
                    values: "0;0;1;1",
                    keyTimes: "0;0.4;0.6;1",
                    dur: "1",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            })
        ]
    });
};
const $6bfaf8085a30c9b5$export$2ba1b65b747a57aa = ({ visible: visible = true, width: width = "80", height: height = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "blocks-loading" })=>{
    return !visible ? null : (0, $1e1ba35c5b9fc4c3$exports.jsxs)("svg", {
        width: width,
        height: height,
        className: wrapperClass,
        style: wrapperStyle,
        xmlns: $6bfaf8085a30c9b5$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        "aria-label": ariaLabel,
        "data-testid": "blocks-svg",
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("title", {
                children: "Blocks"
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("desc", {
                children: "Animated representation of blocks"
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("rect", {
                x: "17",
                y: "17",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0s",
                    calcMode: "discrete"
                })
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("rect", {
                x: "40",
                y: "17",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.125s",
                    calcMode: "discrete"
                })
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("rect", {
                x: "63",
                y: "17",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.25s",
                    calcMode: "discrete"
                })
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("rect", {
                x: "17",
                y: "40",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.875s",
                    calcMode: "discrete"
                })
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("rect", {
                x: "63",
                y: "40",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.375s",
                    calcMode: "discrete"
                })
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("rect", {
                x: "17",
                y: "63",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.75s",
                    calcMode: "discrete"
                })
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("rect", {
                x: "40",
                y: "63",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.625s",
                    calcMode: "discrete"
                })
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("rect", {
                x: "63",
                y: "63",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.5s",
                    calcMode: "discrete"
                })
            })
        ]
    });
};
const $6bfaf8085a30c9b5$export$f3c41beb83007357 = ({ visible: visible = true, width: width = "80", height: height = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "hourglass-loading", colors: colors = [
    "#306cce",
    "#72a1ed"
] })=>{
    return !visible ? null : (0, $1e1ba35c5b9fc4c3$exports.jsxs)("svg", {
        width: width,
        height: height,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 350 350",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "hourglass-svg",
        ...$6bfaf8085a30c9b5$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("animateTransform", {
                attributeName: "transform",
                type: "rotate",
                values: "0; 0; -30; 360; 360",
                keyTimes: "0; 0.40; 0.55; 0.65; 1",
                dur: "3s",
                begin: "0s",
                calcMode: "linear",
                repeatCount: "indefinite"
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsxs)("g", {
                children: [
                    (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                        fill: colors[0],
                        stroke: colors[0],
                        d: "M324.658,20.572v-2.938C324.658,7.935,316.724,0,307.025,0H40.313c-9.699,0-17.635,7.935-17.635,17.634v2.938     c0,9.699,7.935,17.634,17.635,17.634h6.814c3.5,0,3.223,3.267,3.223,4.937c0,19.588,8.031,42.231,14.186,56.698     c12.344,29.012,40.447,52.813,63.516,69.619c4.211,3.068,3.201,5.916,0.756,7.875c-22.375,17.924-51.793,40.832-64.271,70.16     c-6.059,14.239-13.934,36.4-14.18,55.772c-0.025,1.987,0.771,5.862-3.979,5.862h-6.064c-9.699,0-17.635,7.936-17.635,17.634v2.94     c0,9.698,7.935,17.634,17.635,17.634h266.713c9.699,0,17.633-7.936,17.633-17.634v-2.94c0-9.698-7.934-17.634-17.633-17.634     h-3.816c-7,0-6.326-5.241-6.254-7.958c0.488-18.094-4.832-38.673-12.617-54.135c-17.318-34.389-44.629-56.261-61.449-68.915     c-3.65-2.745-4.018-6.143,0-8.906c17.342-11.929,44.131-34.526,61.449-68.916c8.289-16.464,13.785-38.732,12.447-57.621     c-0.105-1.514-0.211-4.472,3.758-4.472h6.482C316.725,38.206,324.658,30.272,324.658,20.572z M270.271,93.216     c-16.113,31.998-41.967,54.881-64.455,68.67c-1.354,0.831-3.936,2.881-3.936,8.602v6.838c0,6.066,2.752,7.397,4.199,8.286     c22.486,13.806,48.143,36.636,64.191,68.508c7.414,14.727,11.266,32.532,10.885,46.702c-0.078,2.947,1.053,8.308-6.613,8.308     H72.627c-6.75,0-6.475-3.37-6.459-5.213c0.117-12.895,4.563-30.757,12.859-50.255c14.404-33.854,44.629-54.988,64.75-67.577     c0.896-0.561,2.629-1.567,2.629-6.922v-10.236c0-5.534-2.656-7.688-4.057-8.57c-20.098-12.688-49.256-33.618-63.322-66.681     c-8.383-19.702-12.834-37.732-12.861-50.657c-0.002-1.694,0.211-4.812,3.961-4.812h206.582c4.168,0,4.127,3.15,4.264,4.829     C282.156,57.681,278.307,77.257,270.271,93.216z"
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsxs)("g", {
                        children: [
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                                fill: colors[1],
                                stroke: colors[1],
                                d: "M169.541,196.2l-68.748,86.03c-2.27,2.842-1.152,5.166,2.484,5.166h140.781c3.637,0,4.756-2.324,2.484-5.166     l-68.746-86.03C175.525,193.358,171.811,193.358,169.541,196.2z"
                            }),
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                                attributeName: "opacity",
                                values: "0; 0; 1; 1; 0; 0",
                                keyTimes: "0; 0.1; 0.4; 0.6; 0.61; 1",
                                dur: "3s",
                                repeatCount: "indefinite"
                            })
                        ]
                    }),
                    (0, $1e1ba35c5b9fc4c3$exports.jsxs)("g", {
                        children: [
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                                fill: colors[1],
                                stroke: colors[1],
                                d: "M168.986,156.219c2.576,2.568,6.789,2.568,9.363,0l34.576-34.489c2.574-2.568,1.707-4.67-1.932-4.67H136.34     c-3.637,0-4.506,2.102-1.932,4.67L168.986,156.219z"
                            }),
                            (0, $1e1ba35c5b9fc4c3$exports.jsx)("animate", {
                                attributeName: "opacity",
                                values: "1; 1; 0; 0; 1; 1",
                                keyTimes: "0; 0.1; 0.4; 0.65; 0.66; 1",
                                dur: "3s",
                                repeatCount: "indefinite"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};



var $9a803c79b027a02a$export$34e0f9847d4c02dd;
$9a803c79b027a02a$export$34e0f9847d4c02dd = `_5_yh7q_container`;


const $5932040b7bbca43c$export$a978c7391adfe78b = ()=>{
    const queryClient = (0, $6547bc15d23e8c33$export$22e77b9572c4fded)();
    const pausedQueries = queryClient.getQueryCache().getAll().filter((query)=>query.state.fetchStatus === 'paused');
    const pausedMutations = queryClient.getMutationCache().getAll().filter((query)=>query.state.isPaused);
    if (!pausedQueries.length && !pausedMutations.length) return null;
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
        className: $9a803c79b027a02a$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $6bfaf8085a30c9b5$export$d7b12c4107be0d61), {
                width: "100",
                colors: [
                    '#fff',
                    '#fff',
                    '#fff'
                ],
                visible: true
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("p", {
                children: "No connection, waiting to reconnect..."
            })
        ]
    });
};




var $lCzvA = parcelRequire("lCzvA");





var $lCzvA = parcelRequire("lCzvA");















"use client";
var $52782a2f2cff5382$var$DIALOG_NAME = "Dialog";
var [$52782a2f2cff5382$var$createDialogContext, $52782a2f2cff5382$export$cc702773b8ea3e41] = (0, $e4b0fa6903a3dc52$export$50c7b4e9d9f19c1)($52782a2f2cff5382$var$DIALOG_NAME);
var [$52782a2f2cff5382$var$DialogProvider, $52782a2f2cff5382$var$useDialogContext] = $52782a2f2cff5382$var$createDialogContext($52782a2f2cff5382$var$DIALOG_NAME);
var $52782a2f2cff5382$export$3ddf2d174ce01153 = (props)=>{
    const { __scopeDialog: __scopeDialog, children: children, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, modal: modal = true } = props;
    const triggerRef = $lCzvA.useRef(null);
    const contentRef = $lCzvA.useRef(null);
    const [open, setOpen] = (0, $10b1f3c1fb191872$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen ?? false,
        onChange: onOpenChange,
        caller: $52782a2f2cff5382$var$DIALOG_NAME
    });
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($52782a2f2cff5382$var$DialogProvider, {
        scope: __scopeDialog,
        triggerRef: triggerRef,
        contentRef: contentRef,
        contentId: (0, $fca3487281b0b7d7$export$f680877a34711e37)(),
        titleId: (0, $fca3487281b0b7d7$export$f680877a34711e37)(),
        descriptionId: (0, $fca3487281b0b7d7$export$f680877a34711e37)(),
        open: open,
        onOpenChange: setOpen,
        onOpenToggle: $lCzvA.useCallback(()=>setOpen((prevOpen)=>!prevOpen), [
            setOpen
        ]),
        modal: modal,
        children: children
    });
};
$52782a2f2cff5382$export$3ddf2d174ce01153.displayName = $52782a2f2cff5382$var$DIALOG_NAME;
var $52782a2f2cff5382$var$TRIGGER_NAME = "DialogTrigger";
var $52782a2f2cff5382$export$2e1e1122cf0cba88 = $lCzvA.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...triggerProps } = props;
    const context = $52782a2f2cff5382$var$useDialogContext($52782a2f2cff5382$var$TRIGGER_NAME, __scopeDialog);
    const composedTriggerRef = (0, $ca45e6a36e8d9db0$export$c7b2cbe3552a0d05)(forwardedRef, context.triggerRef);
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $ac36d1eadbf3b928$export$250ffa63cdc0d034).button, {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.open ? context.contentId : void 0,
        "data-state": $52782a2f2cff5382$var$getState(context.open),
        ...triggerProps,
        ref: composedTriggerRef,
        onClick: (0, $7c9f5a9a17eecc04$export$b9ecd428b558ff10)(props.onClick, context.onOpenToggle)
    });
});
$52782a2f2cff5382$export$2e1e1122cf0cba88.displayName = $52782a2f2cff5382$var$TRIGGER_NAME;
var $52782a2f2cff5382$var$PORTAL_NAME = "DialogPortal";
var [$52782a2f2cff5382$var$PortalProvider, $52782a2f2cff5382$var$usePortalContext] = $52782a2f2cff5382$var$createDialogContext($52782a2f2cff5382$var$PORTAL_NAME, {
    forceMount: void 0
});
var $52782a2f2cff5382$export$dad7c95542bacce0 = (props)=>{
    const { __scopeDialog: __scopeDialog, forceMount: forceMount, children: children, container: container } = props;
    const context = $52782a2f2cff5382$var$useDialogContext($52782a2f2cff5382$var$PORTAL_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($52782a2f2cff5382$var$PortalProvider, {
        scope: __scopeDialog,
        forceMount: forceMount,
        children: $lCzvA.Children.map(children, (child)=>/* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $cbca32552b7e9adc$export$99c2b779aa4e8b8b), {
                present: forceMount || context.open,
                children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $71b14dad088b6acb$export$602eac185826482c), {
                    asChild: true,
                    container: container,
                    children: child
                })
            }))
    });
};
$52782a2f2cff5382$export$dad7c95542bacce0.displayName = $52782a2f2cff5382$var$PORTAL_NAME;
var $52782a2f2cff5382$var$OVERLAY_NAME = "DialogOverlay";
var $52782a2f2cff5382$export$bd1d06c79be19e17 = $lCzvA.forwardRef((props, forwardedRef)=>{
    const portalContext = $52782a2f2cff5382$var$usePortalContext($52782a2f2cff5382$var$OVERLAY_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount, ...overlayProps } = props;
    const context = $52782a2f2cff5382$var$useDialogContext($52782a2f2cff5382$var$OVERLAY_NAME, props.__scopeDialog);
    return context.modal ? /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $cbca32552b7e9adc$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open,
        children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($52782a2f2cff5382$var$DialogOverlayImpl, {
            ...overlayProps,
            ref: forwardedRef
        })
    }) : null;
});
$52782a2f2cff5382$export$bd1d06c79be19e17.displayName = $52782a2f2cff5382$var$OVERLAY_NAME;
var $52782a2f2cff5382$var$Slot = (0, $0d6672ff6f6b6ba8$export$e88b45bda5c13eb9)("DialogOverlay.RemoveScroll");
var $52782a2f2cff5382$var$DialogOverlayImpl = $lCzvA.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...overlayProps } = props;
    const context = $52782a2f2cff5382$var$useDialogContext($52782a2f2cff5382$var$OVERLAY_NAME, __scopeDialog);
    const registerDismissableSurface = (0, $98ca9e23110fdc94$export$210785236bdfcb27)();
    const composedRefs = (0, $ca45e6a36e8d9db0$export$c7b2cbe3552a0d05)(forwardedRef, registerDismissableSurface);
    return(// Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
    // ie. when `Overlay` and `Content` are siblings
    /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $64ab28914613351f$export$2e2bcd8739ae039), {
        as: $52782a2f2cff5382$var$Slot,
        allowPinchZoom: true,
        shards: [
            context.contentRef
        ],
        children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $ac36d1eadbf3b928$export$250ffa63cdc0d034).div, {
            "data-state": $52782a2f2cff5382$var$getState(context.open),
            ...overlayProps,
            ref: composedRefs,
            style: {
                pointerEvents: "auto",
                ...overlayProps.style
            }
        })
    }));
});
var $52782a2f2cff5382$var$CONTENT_NAME = "DialogContent";
var $52782a2f2cff5382$export$7c6e2c02157bb7d2 = $lCzvA.forwardRef((props, forwardedRef)=>{
    const portalContext = $52782a2f2cff5382$var$usePortalContext($52782a2f2cff5382$var$CONTENT_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount, ...contentProps } = props;
    const context = $52782a2f2cff5382$var$useDialogContext($52782a2f2cff5382$var$CONTENT_NAME, props.__scopeDialog);
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $cbca32552b7e9adc$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open,
        children: context.modal ? /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($52782a2f2cff5382$var$DialogContentModal, {
            ...contentProps,
            ref: forwardedRef
        }) : /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($52782a2f2cff5382$var$DialogContentNonModal, {
            ...contentProps,
            ref: forwardedRef
        })
    });
});
$52782a2f2cff5382$export$7c6e2c02157bb7d2.displayName = $52782a2f2cff5382$var$CONTENT_NAME;
var $52782a2f2cff5382$var$DialogContentModal = $lCzvA.forwardRef((props, forwardedRef)=>{
    const context = $52782a2f2cff5382$var$useDialogContext($52782a2f2cff5382$var$CONTENT_NAME, props.__scopeDialog);
    const contentRef = $lCzvA.useRef(null);
    const composedRefs = (0, $ca45e6a36e8d9db0$export$c7b2cbe3552a0d05)(forwardedRef, context.contentRef, contentRef);
    $lCzvA.useEffect(()=>{
        const content = contentRef.current;
        if (content) return (0, $b830715829a44420$export$6e33d16126ed003c)(content);
    }, []);
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($52782a2f2cff5382$var$DialogContentImpl, {
        ...props,
        ref: composedRefs,
        trapFocus: context.open,
        disableOutsidePointerEvents: context.open,
        onCloseAutoFocus: (0, $7c9f5a9a17eecc04$export$b9ecd428b558ff10)(props.onCloseAutoFocus, (event)=>{
            event.preventDefault();
            context.triggerRef.current?.focus();
        }),
        onPointerDownOutside: (0, $7c9f5a9a17eecc04$export$b9ecd428b558ff10)(props.onPointerDownOutside, (event)=>{
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
            if (isRightClick) event.preventDefault();
        }),
        onFocusOutside: (0, $7c9f5a9a17eecc04$export$b9ecd428b558ff10)(props.onFocusOutside, (event)=>event.preventDefault())
    });
});
var $52782a2f2cff5382$var$DialogContentNonModal = $lCzvA.forwardRef((props, forwardedRef)=>{
    const context = $52782a2f2cff5382$var$useDialogContext($52782a2f2cff5382$var$CONTENT_NAME, props.__scopeDialog);
    const hasInteractedOutsideRef = $lCzvA.useRef(false);
    const hasPointerDownOutsideRef = $lCzvA.useRef(false);
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($52782a2f2cff5382$var$DialogContentImpl, {
        ...props,
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event)=>{
            props.onCloseAutoFocus?.(event);
            if (!event.defaultPrevented) {
                if (!hasInteractedOutsideRef.current) context.triggerRef.current?.focus();
                event.preventDefault();
            }
            hasInteractedOutsideRef.current = false;
            hasPointerDownOutsideRef.current = false;
        },
        onInteractOutside: (event)=>{
            props.onInteractOutside?.(event);
            if (!event.defaultPrevented) {
                hasInteractedOutsideRef.current = true;
                if (event.detail.originalEvent.type === "pointerdown") hasPointerDownOutsideRef.current = true;
            }
            const target = event.target;
            const targetIsTrigger = context.triggerRef.current?.contains(target);
            if (targetIsTrigger) event.preventDefault();
            if (event.detail.originalEvent.type === "focusin" && hasPointerDownOutsideRef.current) event.preventDefault();
        }
    });
});
var $52782a2f2cff5382$var$DialogContentImpl = $lCzvA.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, trapFocus: trapFocus, onOpenAutoFocus: onOpenAutoFocus, onCloseAutoFocus: onCloseAutoFocus, ...contentProps } = props;
    const context = $52782a2f2cff5382$var$useDialogContext($52782a2f2cff5382$var$CONTENT_NAME, __scopeDialog);
    (0, $bc475c615686ffa1$export$b7ece24a22aeda8c)();
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $1e1ba35c5b9fc4c3$exports.Fragment), {
        children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $0e536624ae1ddbbb$export$20e40289641fbbb6), {
            asChild: true,
            loop: true,
            trapped: trapFocus,
            onMountAutoFocus: onOpenAutoFocus,
            onUnmountAutoFocus: onCloseAutoFocus,
            children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $98ca9e23110fdc94$export$177fb62ff3ec1f22), {
                role: "dialog",
                id: context.contentId,
                "aria-describedby": context.descriptionId,
                "aria-labelledby": context.titleId,
                "data-state": $52782a2f2cff5382$var$getState(context.open),
                ...contentProps,
                ref: forwardedRef,
                deferPointerDownOutside: true,
                onDismiss: ()=>context.onOpenChange(false)
            })
        })
    });
});
var $52782a2f2cff5382$var$TITLE_NAME = "DialogTitle";
var $52782a2f2cff5382$export$16f7638e4a34b909 = $lCzvA.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...titleProps } = props;
    const context = $52782a2f2cff5382$var$useDialogContext($52782a2f2cff5382$var$TITLE_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $ac36d1eadbf3b928$export$250ffa63cdc0d034).h2, {
        id: context.titleId,
        ...titleProps,
        ref: forwardedRef
    });
});
$52782a2f2cff5382$export$16f7638e4a34b909.displayName = $52782a2f2cff5382$var$TITLE_NAME;
var $52782a2f2cff5382$var$DESCRIPTION_NAME = "DialogDescription";
var $52782a2f2cff5382$export$393edc798c47379d = $lCzvA.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...descriptionProps } = props;
    const context = $52782a2f2cff5382$var$useDialogContext($52782a2f2cff5382$var$DESCRIPTION_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $ac36d1eadbf3b928$export$250ffa63cdc0d034).p, {
        id: context.descriptionId,
        ...descriptionProps,
        ref: forwardedRef
    });
});
$52782a2f2cff5382$export$393edc798c47379d.displayName = $52782a2f2cff5382$var$DESCRIPTION_NAME;
var $52782a2f2cff5382$var$CLOSE_NAME = "DialogClose";
var $52782a2f2cff5382$export$f39c2d165cd861fe = $lCzvA.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...closeProps } = props;
    const context = $52782a2f2cff5382$var$useDialogContext($52782a2f2cff5382$var$CLOSE_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $ac36d1eadbf3b928$export$250ffa63cdc0d034).button, {
        type: "button",
        ...closeProps,
        ref: forwardedRef,
        onClick: (0, $7c9f5a9a17eecc04$export$b9ecd428b558ff10)(props.onClick, ()=>context.onOpenChange(false))
    });
});
$52782a2f2cff5382$export$f39c2d165cd861fe.displayName = $52782a2f2cff5382$var$CLOSE_NAME;
var $52782a2f2cff5382$export$69b62a49393917d6 = (props)=>{
    return props.children;
};
function $52782a2f2cff5382$var$getState(open) {
    return open ? "open" : "closed";
}


//#region src/components/Modal/Close/index.jsx
var $4ae9b029bb4151af$export$2e2bcd8739ae039 = ({ children: r, className: i, ...a })=>{
    let o = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-ModalClose": !0,
        [i]: i
    });
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($52782a2f2cff5382$export$f39c2d165cd861fe, {
        className: o,
        ...a,
        children: r
    });
};
$4ae9b029bb4151af$export$2e2bcd8739ae039.displayName = "ModalClose";




"use client";
//#region src/components/Modal/index.jsx
var $9dad852e7e98f87b$export$2e2bcd8739ae039 = ({ children: o, className: s, backdropClass: c, backdropOpacity: l = 80, closeButtonClass: u, showInDom: d = !1, showClose: f = !0, width: p = "600px", effect: m = "fade-in", fullScreen: h, description: g, onWheel: _, onTouchMove: v, ...y })=>{
    let b = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-Modal fixed bg-white z-40 grid grid-rows-[auto_1fr_auto] data-[state=closed]:hidden": !0,
        "data-[state=open]:animate-fade-in": m === "fade-in",
        "data-[state=open]:animate-slide-up": m === "slide-up",
        "data-[state=open]:animate-slide-down": m === "slide-down",
        "data-[state=open]:animate-scale-up": m === "scale-up",
        "data-[state=open]:animate-scale-down": m === "scale-down",
        "inset-0": h,
        "left-1/2 top-1/2 -translate-1/2 max-w-8/10 max-h-[80vh] rounded-sm": !h,
        [s]: s
    }), x = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-ModalOverlay [&:has(+[data-state=closed])]:hidden inset-0 fixed z-39": !0,
        [c]: c
    }), S = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "absolute right-2 top-2 flex h-12 w-12 items-center justify-center text-4xl/none font-light no-underline!": !0,
        [u]: u
    });
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)($52782a2f2cff5382$export$dad7c95542bacce0, {
        forceMount: d,
        children: [
            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                className: x,
                style: {
                    backgroundColor: `rgba(0,0,0,${l * .01})`
                }
            }),
            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)($52782a2f2cff5382$export$7c6e2c02157bb7d2, {
                ...!g && {
                    "aria-describedby": void 0
                },
                className: b,
                style: {
                    width: h ? void 0 : p
                },
                onWheel: (e)=>{
                    e.stopPropagation(), _?.(e);
                },
                onTouchMove: (e)=>{
                    e.stopPropagation(), v?.(e);
                },
                ...y,
                children: [
                    g && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($52782a2f2cff5382$export$393edc798c47379d, {
                        className: "sr-only",
                        children: g
                    }),
                    o,
                    f && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $4ae9b029bb4151af$export$2e2bcd8739ae039), {
                        className: S,
                        children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                            name: "close"
                        })
                    })
                ]
            })
        ]
    });
};



//#region src/components/Modal/Content/index.jsx
var $21eb14e493d0e28b$export$2e2bcd8739ae039 = ({ children: n, className: r, ...i })=>{
    let a = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-ModalContent flex-1 overflow-auto p-8": !0,
        [r]: r
    });
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
        className: a,
        "data-testid": "sash-modal-content",
        ...i,
        children: n
    });
};
$21eb14e493d0e28b$export$2e2bcd8739ae039.displayName = "ModalContent";



//#region src/components/Modal/Footer/index.jsx
var $861af07899c9769a$export$2e2bcd8739ae039 = ({ children: n, className: r, ...i })=>{
    let a = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-ModalFooter flex justify-end flex-none py-4 px-8 border-t border-t-neutral-100 shadow-[0_-2px_15px_rgba(0,0,0,0.05)]": !0,
        [r]: r
    });
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
        className: a,
        "data-testid": "sash-modal-footer",
        ...i,
        children: n
    });
};
$861af07899c9769a$export$2e2bcd8739ae039.displayName = "ModalFooter";




//#region src/components/Modal/Header/index.jsx
var $9761f0447406a76c$export$2e2bcd8739ae039 = ({ children: r, className: i, renderAs: a = "h3" })=>{
    let o = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-ModalHeader flex-none pl-8 py-4 border-b border-b-neutral-100 pr-10": !0,
        [i]: i
    }), s = a;
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($52782a2f2cff5382$export$16f7638e4a34b909, {
        className: o,
        asChild: !0,
        children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)(s, {
            className: "m-0 text-2xl font-semibold text-black",
            children: r
        })
    });
};
$9761f0447406a76c$export$2e2bcd8739ae039.displayName = "ModalHeader";



"use client";
//#region src/components/Modal/Root/index.jsx
var $4d41d17efc15da0f$export$2e2bcd8739ae039 = ({ children: n, defaultOpen: r, open: i, onOpenChange: a, ...o })=>/* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($52782a2f2cff5382$export$3ddf2d174ce01153, {
        modal: !1,
        open: i,
        defaultOpen: r,
        onOpenChange: a,
        ...o,
        children: n
    });
$4d41d17efc15da0f$export$2e2bcd8739ae039.displayName = "ModalRoot";





var $lCzvA = parcelRequire("lCzvA");
"use client";
//#region src/hooks/useToggle/index.jsx
var $49d3c8472e20c2b5$export$cbe85ee05b554577 = (n = !1)=>{
    let [r, i] = (0, $lCzvA.useState)(n);
    return [
        r,
        (0, $lCzvA.useCallback)(()=>i((e)=>!e), [])
    ];
};



"use client";
//#region src/components/Alert/index.jsx
var $71efe153e5175f41$var$a = {
    error: "emergency_home",
    default: "lightbulb",
    info: "info",
    warning: "warning",
    success: "check_circle"
}, $71efe153e5175f41$export$2e2bcd8739ae039 = ({ type: o = "success", message: s, className: c, showClose: l, children: u, onClose: d, iconClass: f, contentClass: p, messageClass: m, inline: h, customIcon: g, ..._ })=>{
    let [v, y] = (0, $49d3c8472e20c2b5$export$cbe85ee05b554577)(!0), b = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-Alert relative [&_a]:text-inherit [&_a]:underline [&_a]:hover:no-underline [&_a]:hover:text-inherit gap-x-2": !0,
        "flex py-3 px-4 rounded border border-l-4": !h,
        "inline-flex": h,
        "text-red-700": o === "error",
        "text-blue-800": o === "info",
        "text-amber-800": o === "warning",
        "text-green-800": o === "success",
        "text-black": o === "default",
        "border-red-700 bg-red-100": o === "error" && !h,
        "border-blue-700 bg-blue-100": o === "info" && !h,
        "border-amber-700 bg-amber-100": o === "warning" && !h,
        "border-green-700 bg-green-100": (!o || o === "success") && !h,
        "bg-white border-neutral-900": o === "default" && !h,
        [c]: c
    }), x = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "block leading-none!": !0,
        "text-red-700": o === "error",
        "text-blue-700": o === "info",
        "text-amber-700": o === "warning",
        "text-green-700": o === "success",
        "text-black": o === "default",
        [f]: f
    }), S = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-AlertContent flex-1 [&_p:last-child]:m-0": !0,
        "pt-px text-base": !h,
        "pt-0.5 text-sm": h,
        [p]: p
    }), C = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-AlertMessage font-semibold": !0,
        "mb-2.5": u,
        [m]: m
    }), w = ()=>{
        y(), typeof d == "function" && d();
    };
    return v ? /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
        className: b,
        role: "alert",
        "aria-atomic": "true",
        "aria-live": "assertive",
        ..._,
        children: [
            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                className: "sash-AlertIcon flex-none leading-none",
                children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                    name: g || $71efe153e5175f41$var$a[o],
                    className: x,
                    weight: 600
                })
            }),
            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                className: S,
                children: [
                    s && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                        className: C,
                        children: s
                    }),
                    u && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                        className: "text-inherit [&_ul]:m-0 [&_ul]:pl-5",
                        children: u
                    })
                ]
            }),
            l && !h && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("button", {
                type: "button",
                className: "flex cursor-pointer hover:text-black",
                "aria-label": "Close",
                onClick: w,
                children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                    name: "close",
                    className: "text-neutral-750",
                    weight: 600
                })
            })
        ]
    }) : null;
};









//#region src/components/Label/index.jsx
var $fbac12b06efda731$export$2e2bcd8739ae039 = ({ error: n, htmlFor: r, hide: i, children: a, className: o, renderAs: s = "label", ...c })=>{
    let l = s, u = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-Label block text-sm/tight font-semibold": !0,
        "text-black": !n,
        "text-red-700": n,
        "sr-only": i,
        [o]: o
    });
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)(l, {
        className: u,
        "data-testid": "sash-label",
        htmlFor: r,
        ...c,
        children: a
    });
};



"use client";
//#region src/components/@helpers/FormFieldTop/index.jsx
var $353df793a3a1d2b7$export$2e2bcd8739ae039 = ({ labelText: s, hideLabel: c, required: l, id: u, className: d, assistiveText: f, error: p, helpText: m, tooltipContent: h, tooltipPosition: g = "bottom", renderAs: _ = "label", ...v })=>{
    _ === "label" && !u && console.error("\"id\" prop is required for form fields to correctly attach to labels.");
    let y = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-FormFieldTop relative": !0,
        "mb-2": !c && !f,
        [d]: d
    });
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
        className: y,
        "data-testid": "sash-input-top",
        ...v,
        children: [
            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $fbac12b06efda731$export$2e2bcd8739ae039), {
                htmlFor: u,
                className: l ? "text-required" : "",
                hide: c,
                error: p,
                renderAs: _,
                children: s
            }),
            (f || m) && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                className: "sash-FormFieldTop-help mt-1 mb-2 space-x-0.5 leading-none",
                children: [
                    f && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("p", {
                        className: "inline text-xs text-neutral-600",
                        children: f
                    }),
                    m && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $4894604720ca08c8$export$2e2bcd8739ae039), {
                        className: "inline",
                        children: [
                            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $159cb66f654a3a1c$export$2e2bcd8739ae039), {
                                className: "text-blue inline-block text-xs/tight hover:underline",
                                children: m
                            }),
                            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $833f5a446a1fbfcc$export$2e2bcd8739ae039), {
                                position: g,
                                align: "start",
                                className: "text-caption z-2 max-w-[40ch] border border-black p-2 shadow-md",
                                children: h
                            })
                        ]
                    })
                ]
            })
        ]
    });
};



var $lCzvA = parcelRequire("lCzvA");
//#region node_modules/react-number-format/dist/react-number-format.es.js
function $4bbf7ba23c3835e3$var$o(e, t) {
    var n = {};
    for(var r in e)Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
    if (e != null && typeof Object.getOwnPropertySymbols == "function") for(var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
    return n;
}
var $4bbf7ba23c3835e3$var$s;
(function(e) {
    e.event = "event", e.props = "prop";
})($4bbf7ba23c3835e3$var$s ||= {});
function $4bbf7ba23c3835e3$var$c() {}
function $4bbf7ba23c3835e3$var$l(e) {
    var t, n = void 0;
    return function() {
        for(var r = [], i = arguments.length; i--;)r[i] = arguments[i];
        return t && r.length === t.length && r.every(function(e, n) {
            return e === t[n];
        }) || (t = r, n = e.apply(void 0, r)), n;
    };
}
function $4bbf7ba23c3835e3$var$u(e) {
    return !!(e || "").match(/\d/);
}
function $4bbf7ba23c3835e3$var$d(e) {
    return e == null;
}
function $4bbf7ba23c3835e3$var$f(e) {
    return typeof e == "number" && isNaN(e);
}
function $4bbf7ba23c3835e3$var$p(e) {
    return $4bbf7ba23c3835e3$var$d(e) || $4bbf7ba23c3835e3$var$f(e) || typeof e == "number" && !isFinite(e);
}
function $4bbf7ba23c3835e3$var$m(e) {
    var t = (0, $lCzvA.useRef)(e);
    return t.current = e, (0, $lCzvA.useRef)(function() {
        for(var e = [], n = arguments.length; n--;)e[n] = arguments[n];
        return t.current.apply(t, e);
    }).current;
}
function $4bbf7ba23c3835e3$var$h(e, t) {
    return Array(t + 1).join(e);
}
function $4bbf7ba23c3835e3$var$g(e) {
    var t = e + "", n = t[0] === "-" ? "-" : "";
    n && (t = t.substring(1));
    var r = t.split(/[eE]/g), i = r[0], a = r[1];
    if (a = Number(a), !a) return n + i;
    i = i.replace(".", "");
    var o = 1 + a, s = i.length;
    return o < 0 ? i = "0." + $4bbf7ba23c3835e3$var$h("0", Math.abs(o)) + i : o >= s ? i += $4bbf7ba23c3835e3$var$h("0", o - s) : i = (i.substring(0, o) || "0") + "." + i.substring(o), n + i;
}
function $4bbf7ba23c3835e3$var$_(e, t) {
    if (e.value = e.value, e !== null) {
        if (e.createTextRange) {
            var n = e.createTextRange();
            return n.move("character", t), n.select(), !0;
        }
        return e.selectionStart || e.selectionStart === 0 ? (e.focus(), e.setSelectionRange(t, t), !0) : (e.focus(), !1);
    }
}
var $4bbf7ba23c3835e3$var$v = $4bbf7ba23c3835e3$var$l(function(e, t) {
    for(var n = 0, r = 0, i = e.length, a = t.length; e[n] === t[n] && n < i;)n++;
    for(; e[i - 1 - r] === t[a - 1 - r] && a - r > n && i - r > n;)r++;
    return {
        from: {
            start: n,
            end: i - r
        },
        to: {
            start: n,
            end: a - r
        }
    };
}), $4bbf7ba23c3835e3$var$y = function(e, t) {
    var n = Math.min(e.selectionStart, t);
    return {
        from: {
            start: n,
            end: e.selectionEnd
        },
        to: {
            start: n,
            end: t
        }
    };
};
function $4bbf7ba23c3835e3$var$b(e, t, n) {
    return Math.min(Math.max(e, t), n);
}
function $4bbf7ba23c3835e3$var$x(e) {
    return Math.max(e.selectionStart, e.selectionEnd);
}
function $4bbf7ba23c3835e3$var$S() {
    return typeof navigator < "u" && !(navigator.platform && /iPhone|iPod/.test(navigator.platform));
}
function $4bbf7ba23c3835e3$var$C(e) {
    return {
        from: {
            start: 0,
            end: 0
        },
        to: {
            start: 0,
            end: e.length
        },
        lastValue: ""
    };
}
function $4bbf7ba23c3835e3$var$w(e, t) {
    return e === void 0 && (e = " "), typeof e == "string" ? e : e[t] || " ";
}
function $4bbf7ba23c3835e3$var$T(e) {
    var t = e.currentValue, n = e.formattedValue, r = e.currentValueIndex, i = e.formattedValueIndex;
    return t[r] === n[i];
}
function $4bbf7ba23c3835e3$var$ee(e, t, n, r, i, a, o) {
    o === void 0 && (o = $4bbf7ba23c3835e3$var$T);
    var s = i.findIndex(function(e) {
        return e;
    }), c = e.slice(0, s);
    !t && !n.startsWith(c) && (t = c, n = c + n, r += c.length);
    for(var l = n.length, u = e.length, d = {}, f = Array(l), p = 0; p < l; p++){
        f[p] = -1;
        for(var m = 0, h = u; m < h; m++)if (o({
            currentValue: n,
            lastValue: t,
            formattedValue: e,
            currentValueIndex: p,
            formattedValueIndex: m
        }) && d[m] !== !0) {
            f[p] = m, d[m] = !0;
            break;
        }
    }
    for(var g = r; g < l && (f[g] === -1 || !a(n[g]));)g++;
    var _ = g === l || f[g] === -1 ? u : f[g];
    for(g = r - 1; g > 0 && f[g] === -1;)g--;
    var v = g === -1 || f[g] === -1 ? 0 : f[g] + 1;
    return v > _ ? _ : r - v < _ - r ? v : _;
}
function $4bbf7ba23c3835e3$var$E(e, t, n, r) {
    var i = e.length;
    if (t = $4bbf7ba23c3835e3$var$b(t, 0, i), r === "left") {
        for(; t >= 0 && !n[t];)t--;
        t === -1 && (t = n.indexOf(!0));
    } else {
        for(; t <= i && !n[t];)t++;
        t > i && (t = n.lastIndexOf(!0));
    }
    return t === -1 && (t = i), t;
}
function $4bbf7ba23c3835e3$var$te(e) {
    for(var t = Array.from({
        length: e.length + 1
    }).map(function() {
        return !0;
    }), n = 0, r = t.length; n < r; n++)t[n] = !!($4bbf7ba23c3835e3$var$u(e[n]) || $4bbf7ba23c3835e3$var$u(e[n - 1]));
    return t;
}
function $4bbf7ba23c3835e3$var$ne(e, n, i, o, l, u) {
    u === void 0 && (u = $4bbf7ba23c3835e3$var$c);
    var f = $4bbf7ba23c3835e3$var$m(function(e, t) {
        var n, r;
        return $4bbf7ba23c3835e3$var$p(e) ? (r = "", n = "") : typeof e == "number" || t ? (r = typeof e == "number" ? $4bbf7ba23c3835e3$var$g(e) : e, n = o(r)) : (r = l(e, void 0), n = o(r)), {
            formattedValue: n,
            numAsString: r
        };
    }), h = (0, $lCzvA.useState)(function() {
        return f($4bbf7ba23c3835e3$var$d(e) ? n : e, i);
    }), _ = h[0], v = h[1], y = $4bbf7ba23c3835e3$var$m(function(e, t) {
        e.formattedValue !== _.formattedValue && v({
            formattedValue: e.formattedValue,
            numAsString: e.value
        }), u(e, t);
    }), b = e, x = i;
    $4bbf7ba23c3835e3$var$d(e) && (b = _.numAsString, x = !0);
    var S = f(b, x);
    return (0, $lCzvA.useMemo)(function() {
        v(S);
    }, [
        S.formattedValue
    ]), (0, $lCzvA.useEffect)(function() {
        if (!$4bbf7ba23c3835e3$var$d(n) && $4bbf7ba23c3835e3$var$d(e) && _.formattedValue !== "") {
            var t = parseFloat(_.numAsString);
            y({
                formattedValue: _.formattedValue,
                value: _.numAsString,
                floatValue: isNaN(t) ? void 0 : t
            }, {
                event: void 0,
                source: $4bbf7ba23c3835e3$var$s.props
            });
        }
    }, []), [
        _,
        y
    ];
}
function $4bbf7ba23c3835e3$var$D(e) {
    return e.replace(/[^0-9]/g, "");
}
function $4bbf7ba23c3835e3$var$re(e) {
    return e;
}
function $4bbf7ba23c3835e3$export$dd1caf9b8ccbc158(r) {
    var l = r.type;
    l === void 0 && (l = "text");
    var d = r.displayType;
    d === void 0 && (d = "input");
    var f = r.customInput, p = r.renderText, m = r.getInputRef, h = r.format;
    h === void 0 && (h = $4bbf7ba23c3835e3$var$re);
    var g = r.removeFormatting;
    g === void 0 && (g = $4bbf7ba23c3835e3$var$D);
    var b = r.defaultValue, C = r.valueIsNumericString, w = r.onValueChange, T = r.isAllowed, O = r.onChange;
    O === void 0 && (O = $4bbf7ba23c3835e3$var$c);
    var k = r.onKeyDown;
    k === void 0 && (k = $4bbf7ba23c3835e3$var$c);
    var A = r.onMouseUp;
    A === void 0 && (A = $4bbf7ba23c3835e3$var$c);
    var j = r.onFocus;
    j === void 0 && (j = $4bbf7ba23c3835e3$var$c);
    var M = r.onBlur;
    M === void 0 && (M = $4bbf7ba23c3835e3$var$c);
    var N = r.value, P = r.getCaretBoundary;
    P === void 0 && (P = $4bbf7ba23c3835e3$var$te);
    var F = r.isValidInputCharacter;
    F === void 0 && (F = $4bbf7ba23c3835e3$var$u);
    var ie = r.isCharacterSame, I = $4bbf7ba23c3835e3$var$o(r, [
        "type",
        "displayType",
        "customInput",
        "renderText",
        "getInputRef",
        "format",
        "removeFormatting",
        "defaultValue",
        "valueIsNumericString",
        "onValueChange",
        "isAllowed",
        "onChange",
        "onKeyDown",
        "onMouseUp",
        "onFocus",
        "onBlur",
        "value",
        "getCaretBoundary",
        "isValidInputCharacter",
        "isCharacterSame"
    ]), L = $4bbf7ba23c3835e3$var$ne(N, b, !!C, h, g, w), R = L[0], z = R.formattedValue, B = R.numAsString, V = L[1], H = (0, $lCzvA.useRef)(), U = (0, $lCzvA.useRef)({
        formattedValue: z,
        numAsString: B
    }), W = function(e, t) {
        U.current = {
            formattedValue: e.formattedValue,
            numAsString: e.value
        }, V(e, t);
    }, G = (0, $lCzvA.useState)(!1), ae = G[0], oe = G[1], K = (0, $lCzvA.useRef)(null), q = (0, $lCzvA.useRef)({
        setCaretTimeout: null,
        focusTimeout: null
    });
    (0, $lCzvA.useEffect)(function() {
        return oe(!0), function() {
            clearTimeout(q.current.setCaretTimeout), clearTimeout(q.current.focusTimeout);
        };
    }, []);
    var se = h, J = function(e, t) {
        var n = parseFloat(t);
        return {
            formattedValue: e,
            value: t,
            floatValue: isNaN(n) ? void 0 : n
        };
    }, Y = function(e, t, n) {
        (e.selectionStart !== 0 || e.selectionEnd !== e.value.length) && ($4bbf7ba23c3835e3$var$_(e, t), q.current.setCaretTimeout = setTimeout(function() {
            e.value === n && e.selectionStart !== t && $4bbf7ba23c3835e3$var$_(e, t);
        }, 0));
    }, X = function(e, t, n) {
        return $4bbf7ba23c3835e3$var$E(e, t, P(e), n);
    }, Z = function(e, t, n) {
        var r = P(t), i = $4bbf7ba23c3835e3$var$ee(t, z, e, n, r, F, ie);
        return i = $4bbf7ba23c3835e3$var$E(t, i, r), i;
    }, ce = function(e) {
        var t = e.formattedValue;
        t === void 0 && (t = "");
        var n = e.input, r = e.source, i = e.event, a = e.numAsString, o;
        if (n) {
            var s = e.inputValue || n.value, c = $4bbf7ba23c3835e3$var$x(n);
            n.value = t, o = Z(s, t, c), o !== void 0 && Y(n, o, t);
        }
        t !== z && W(J(t, a), {
            event: i,
            source: r
        });
    };
    (0, $lCzvA.useEffect)(function() {
        var e = U.current, t = e.formattedValue, n = e.numAsString;
        (z !== t || B !== n) && W(J(z, B), {
            event: void 0,
            source: $4bbf7ba23c3835e3$var$s.props
        });
    }, [
        z,
        B
    ]);
    var le = K.current ? $4bbf7ba23c3835e3$var$x(K.current) : void 0;
    (typeof window < "u" ? (0, $lCzvA.useLayoutEffect) : (0, $lCzvA.useEffect))(function() {
        var e = K.current;
        if (z !== U.current.formattedValue && e) {
            var t = Z(U.current.formattedValue, z, le);
            e.value = z, Y(e, t, z);
        }
    }, [
        z
    ]);
    var ue = function(e, t, n) {
        var r = t.target, i = H.current ? $4bbf7ba23c3835e3$var$y(H.current, r.selectionEnd) : $4bbf7ba23c3835e3$var$v(z, e), a = Object.assign(Object.assign({}, i), {
            lastValue: z
        }), o = g(e, a), s = se(o);
        if (o = g(s, void 0), T && !T(J(s, o))) {
            var c = t.target, l = Z(e, z, $4bbf7ba23c3835e3$var$x(c));
            return c.value = z, Y(c, l, z), !1;
        }
        return ce({
            formattedValue: s,
            numAsString: o,
            inputValue: e,
            event: t,
            source: n,
            input: t.target
        }), !0;
    }, Q = function(e, t) {
        t === void 0 && (t = 0), H.current = {
            selectionStart: e.selectionStart,
            selectionEnd: e.selectionEnd + t
        };
    }, de = function(e) {
        var t = e.target.value;
        ue(t, e, $4bbf7ba23c3835e3$var$s.event) && O(e), H.current = void 0;
    }, fe = function(e) {
        var t = e.target, n = e.key, r = t.selectionStart, i = t.selectionEnd, a = t.value;
        a === void 0 && (a = "");
        var o;
        n === "ArrowLeft" || n === "Backspace" ? o = Math.max(r - 1, 0) : n === "ArrowRight" ? o = Math.min(r + 1, a.length) : n === "Delete" && (o = r);
        var s = 0;
        n === "Delete" && r === i && (s = 1);
        var c = n === "ArrowLeft" || n === "ArrowRight";
        if (o === void 0 || r !== i && !c) k(e), Q(t, s);
        else {
            var l = o;
            c ? (l = X(a, o, n === "ArrowLeft" ? "left" : "right"), l !== o && e.preventDefault()) : n === "Delete" && !F(a[o]) ? l = X(a, o, "right") : n === "Backspace" && !F(a[o]) && (l = X(a, o, "left")), l !== o && Y(t, l, a), k(e), Q(t, s);
        }
    }, pe = function(e) {
        var t = e.target, n = function() {
            var e = t.selectionStart, n = t.selectionEnd, r = t.value;
            if (r === void 0 && (r = ""), e === n) {
                var i = X(r, e);
                i !== e && Y(t, i, r);
            }
        };
        n(), requestAnimationFrame(function() {
            n();
        }), A(e), Q(t);
    }, me = function(e) {
        e.persist && e.persist();
        var t = e.target, n = e.currentTarget;
        K.current = t, q.current.focusTimeout = setTimeout(function() {
            var r = t.selectionStart, i = t.selectionEnd, a = t.value;
            a === void 0 && (a = "");
            var o = X(a, r);
            o !== r && (r !== 0 || i !== a.length) && Y(t, o, a), j(Object.assign(Object.assign({}, e), {
                currentTarget: n
            }));
        }, 0);
    }, he = function(e) {
        K.current = null, clearTimeout(q.current.focusTimeout), clearTimeout(q.current.setCaretTimeout), M(e);
    }, ge = ae && $4bbf7ba23c3835e3$var$S() ? "numeric" : void 0, $ = Object.assign({
        inputMode: ge
    }, I, {
        type: l,
        value: z,
        onChange: de,
        onKeyDown: fe,
        onMouseUp: pe,
        onFocus: me,
        onBlur: he
    });
    if (d === "text") return p ? (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).Fragment, null, p(z, I) || null) : (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).createElement("span", Object.assign({}, I, {
        ref: m
    }), z);
    if (f) {
        var _e = f;
        return (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).createElement(_e, Object.assign({}, $, {
            ref: m
        }));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).createElement("input", Object.assign({}, $, {
        ref: m
    }));
}
function $4bbf7ba23c3835e3$export$4b8d05d749baae10(e, t) {
    var n = t.format, r = t.allowEmptyFormatting, i = t.mask, a = t.patternChar;
    if (a === void 0 && (a = "#"), e === "" && !r) return "";
    for(var o = 0, s = n.split(""), c = 0, l = n.length; c < l; c++)n[c] === a && (s[c] = e[o] || $4bbf7ba23c3835e3$var$w(i, o), o += 1);
    return s.join("");
}
function $4bbf7ba23c3835e3$export$63600a84c223a8ea(e, t, n) {
    t === void 0 && (t = $4bbf7ba23c3835e3$var$C(e));
    var r = n.format, i = n.patternChar;
    i === void 0 && (i = "#");
    var a = t.from, o = t.to, s = t.lastValue;
    s === void 0 && (s = "");
    var c = function(e) {
        return r[e] === i;
    }, l = function(e, t) {
        for(var n = "", r = 0; r < e.length; r++)c(t + r) && $4bbf7ba23c3835e3$var$u(e[r]) && (n += e[r]);
        return n;
    }, d = function(e) {
        return e.replace(/[^0-9]/g, "");
    };
    if (!r.match(/\d/)) return d(e);
    if ((s === "" || a.end - a.start === s.length) && e.length === r.length) {
        for(var f = "", p = 0; p < e.length; p++)if (c(p)) $4bbf7ba23c3835e3$var$u(e[p]) && (f += e[p]);
        else if (e[p] !== r[p]) return d(e);
        return f;
    }
    var m = s.substring(0, a.start), h = e.substring(o.start, o.end), g = s.substring(a.end);
    return "" + l(m, 0) + d(h) + l(g, a.end);
}
function $4bbf7ba23c3835e3$export$cbab503a3360c264(e, t) {
    var n = t.format, r = t.mask, i = t.patternChar;
    i === void 0 && (i = "#");
    var a = Array.from({
        length: e.length + 1
    }).map(function() {
        return !0;
    }), o = 0, s = -1, c = {};
    n.split("").forEach(function(t, n) {
        var a = void 0;
        t === i && (o++, a = $4bbf7ba23c3835e3$var$w(r, o - 1), s === -1 && e[n] === a && (s = n)), c[n] = a;
    });
    for(var l = function(t) {
        return n[t] === i && e[t] !== c[t];
    }, u = 0, d = a.length; u < d; u++)a[u] = u === s || l(u) || l(u - 1);
    return a[n.indexOf(i)] = !0, a;
}
function $4bbf7ba23c3835e3$var$M(e) {
    var t = e.mask;
    if (t && (t === "string" ? t : t.toString()).match(/\d/g)) throw Error("Mask " + t + " should not contain numeric character;");
}
function $4bbf7ba23c3835e3$var$N(e, t) {
    return e === "" || !t?.match(/\d/) && typeof e == "string" && (!!e.match(/^\d+$/) || e === "");
}
function $4bbf7ba23c3835e3$export$1290cfe2185b28c0(e) {
    e.mask, e.allowEmptyFormatting;
    var t = e.format, n = e.inputMode;
    n === void 0 && (n = "numeric");
    var r = e.onKeyDown;
    r === void 0 && (r = $4bbf7ba23c3835e3$var$c);
    var i = e.patternChar;
    i === void 0 && (i = "#");
    var a = e.value, s = e.defaultValue, l = e.valueIsNumericString, u = $4bbf7ba23c3835e3$var$o(e, [
        "mask",
        "allowEmptyFormatting",
        "format",
        "inputMode",
        "onKeyDown",
        "patternChar",
        "value",
        "defaultValue",
        "valueIsNumericString"
    ]);
    $4bbf7ba23c3835e3$var$M(e);
    var f = function(t) {
        return $4bbf7ba23c3835e3$export$cbab503a3360c264(t, e);
    }, p = function(e) {
        var n = e.key, a = e.target, o = a.selectionStart, s = a.selectionEnd, c = a.value;
        if (o !== s) r(e);
        else {
            var l = o;
            if (n === "Backspace" || n === "Delete") {
                var u = "right";
                if (n === "Backspace") {
                    for(; l > 0 && t[l - 1] !== i;)l--;
                    u = "left";
                } else {
                    for(var d = t.length; l < d && t[l] !== i;)l++;
                    u = "right";
                }
                l = $4bbf7ba23c3835e3$var$E(c, l, f(c), u);
            } else t[l] !== i && n !== "ArrowLeft" && n !== "ArrowRight" && (l = $4bbf7ba23c3835e3$var$E(c, l + 1, f(c), "right"));
            l !== o && $4bbf7ba23c3835e3$var$_(a, l), r(e);
        }
    }, m = $4bbf7ba23c3835e3$var$d(a) ? s : a, h = l ?? $4bbf7ba23c3835e3$var$N(m, t), g = Object.assign(Object.assign({}, e), {
        valueIsNumericString: h
    });
    return Object.assign(Object.assign({}, u), {
        value: a,
        defaultValue: s,
        valueIsNumericString: h,
        inputMode: n,
        format: function(e) {
            return $4bbf7ba23c3835e3$export$4b8d05d749baae10(e, g);
        },
        removeFormatting: function(e, t) {
            return $4bbf7ba23c3835e3$export$63600a84c223a8ea(e, t, g);
        },
        getCaretBoundary: f,
        onKeyDown: p
    });
}
function $4bbf7ba23c3835e3$export$9e8c774149e1782b(t) {
    var n = $4bbf7ba23c3835e3$export$1290cfe2185b28c0(t);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).createElement($4bbf7ba23c3835e3$export$dd1caf9b8ccbc158, Object.assign({}, n));
}




var $lCzvA = parcelRequire("lCzvA");

"use client";
//#region src/components/TextInput/index.jsx
var $67004894d25c93a4$export$2e2bcd8739ae039 = (0, $lCzvA.forwardRef)(function({ labelText: o, hideLabel: d, type: f = "text", id: p, className: m, containerClass: h, assistiveText: g, iconLeft: _, iconRight: v, error: y, helpText: b, tooltipContent: x, tooltipPosition: S = "bottom", ...C }, w) {
    let T = (0, $lCzvA.useRef)(null), [E, D] = (0, $49d3c8472e20c2b5$export$cbe85ee05b554577)(!0), O = {
        ...C
    }, k = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-FormGroup relative mb-4": !0,
        [h]: h
    }), A = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-TextInput sash-input": !0,
        "border-red-700": y,
        "pl-11": _,
        "pr-11": v,
        [m]: m
    }), j = (e)=>/* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("input", {
            type: e,
            id: p,
            name: p,
            className: A,
            ref: w,
            ...C
        });
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
        ref: T,
        className: k,
        "data-testid": "sash-input",
        children: [
            (o || b || g) && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $353df793a3a1d2b7$export$2e2bcd8739ae039), {
                id: p,
                labelText: o,
                hideLabel: d,
                required: O.required,
                error: !!y,
                assistiveText: g,
                helpText: b,
                tooltipContent: x,
                tooltipPosition: S
            }),
            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                className: "relative",
                children: [
                    f !== "password" && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $1e1ba35c5b9fc4c3$exports.Fragment), {
                        children: [
                            O.format ? ((e)=>/* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $4bbf7ba23c3835e3$export$9e8c774149e1782b), {
                                    type: e,
                                    id: p,
                                    name: p,
                                    className: A,
                                    getInputRef: w,
                                    ...C
                                }))(f) : j(f),
                            _ && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                                className: "absolute top-0 left-0 flex h-full items-center justify-center px-3 text-sm leading-none text-neutral-700",
                                children: _
                            }),
                            v && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                                className: "absolute top-0 right-0 flex h-full items-center justify-center px-3 text-sm leading-none text-neutral-700",
                                children: v
                            })
                        ]
                    }),
                    f === "password" && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $1e1ba35c5b9fc4c3$exports.Fragment), {
                        children: [
                            j(E ? "password" : "text"),
                            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("button", {
                                type: "button",
                                className: "absolute top-0 right-0 flex h-full cursor-pointer items-center justify-center px-3 leading-none",
                                onClick: D,
                                "aria-label": "Toggle password visibility",
                                children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                                    name: E ? "visibility_off" : "visibility"
                                })
                            })
                        ]
                    })
                ]
            }),
            typeof y == "string" && !!y && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $71efe153e5175f41$export$2e2bcd8739ae039), {
                type: "error",
                className: "mt-2",
                message: y,
                inline: !0
            })
        ]
    });
});


var $82c9009d43440100$export$34e0f9847d4c02dd;
var $82c9009d43440100$export$caf37b18e66e7c16;
var $82c9009d43440100$export$2736100362dfb395;
var $82c9009d43440100$export$491112666e282270;
$82c9009d43440100$export$34e0f9847d4c02dd = `D8lu2W_container`;
$82c9009d43440100$export$caf37b18e66e7c16 = `D8lu2W_modalFooter`;
$82c9009d43440100$export$2736100362dfb395 = `D8lu2W_strictInput`;
$82c9009d43440100$export$491112666e282270 = `D8lu2W_warning`;


const $cc8569db32917e4a$export$5cd181168bbef128 = ({ isOpen: isOpen, description: description, onConfirm: onConfirm, onCancel: onCancel, strictMessage: strictMessage })=>{
    const [confirmInput, setConfirmInput] = (0, $lCzvA.useState)('');
    const disableConfirm = strictMessage ? confirmInput !== description : false;
    /** Handle cancel action */ const handleCancel = ()=>{
        setConfirmInput('');
        onCancel();
    };
    /** Handle confirm action */ const handleConfirm = ()=>{
        setConfirmInput('');
        onConfirm();
    };
    /**
   * Handle changes to the confirm input field.
   * @param {React.ChangeEvent<HTMLInputElement>} e - The change event from the confirm input field
   */ const handleConfirmInputChange = (e)=>{
        setConfirmInput(e.target.value);
    };
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $4d41d17efc15da0f$export$2e2bcd8739ae039), {
        open: isOpen,
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $9dad852e7e98f87b$export$2e2bcd8739ae039), {
            className: $82c9009d43440100$export$34e0f9847d4c02dd,
            showClose: false,
            children: [
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $9761f0447406a76c$export$2e2bcd8739ae039), {
                    children: "Confirm Deletion"
                }),
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $21eb14e493d0e28b$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("p", {
                            children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("b", {
                                children: description
                            })
                        }),
                        "Are you sure you want to delete this item? This action cannot be undone.",
                        strictMessage && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                            className: $82c9009d43440100$export$2736100362dfb395,
                            children: [
                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                                    className: $82c9009d43440100$export$491112666e282270,
                                    children: "WARNING!"
                                }),
                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("p", {
                                    children: strictMessage
                                }),
                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("p", {
                                    children: "Ensure you understand the consequences before proceeding."
                                }),
                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $67004894d25c93a4$export$2e2bcd8739ae039), {
                                    id: "confirmDeleteInput",
                                    "data-testid": `confirmDeleteInput-${description}`,
                                    labelText: "",
                                    value: confirmInput,
                                    assistiveText: `Type "${description}" to confirm`,
                                    placeholder: "Type to confirm",
                                    onChange: handleConfirmInputChange
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $861af07899c9769a$export$2e2bcd8739ae039), {
                    className: $82c9009d43440100$export$caf37b18e66e7c16,
                    children: [
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                            color: "secondary",
                            onClick: handleCancel,
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                            color: "primary",
                            onClick: handleConfirm,
                            disabled: disableConfirm,
                            "data-testid": `confirmDeleteButton-${description}`,
                            children: "Confirm"
                        })
                    ]
                })
            ]
        })
    });
};





function $bd23e353f7395bd0$export$f85c16a6d62f7d63(url, baseUrl) {
    // url is absolute already
    if (url.match(/^[a-z]+:\/\//i)) return url;
    // url is absolute already, without protocol
    if (url.match(/^\/\//)) return window.location.protocol + url;
    // dataURI, mailto:, tel:, etc.
    if (url.match(/^[a-z]+:/i)) return url;
    const doc = document.implementation.createHTMLDocument();
    const base = doc.createElement('base');
    const a = doc.createElement('a');
    doc.head.appendChild(base);
    doc.body.appendChild(a);
    if (baseUrl) base.href = baseUrl;
    a.href = url;
    return a.href;
}
const $bd23e353f7395bd0$export$31b40729666a4ae0 = (()=>{
    // generate uuid for className of pseudo elements.
    // We should not use GUIDs, otherwise pseudo elements sometimes cannot be captured.
    let counter = 0;
    // ref: http://stackoverflow.com/a/6248722/2519373
    const random = ()=>// eslint-disable-next-line no-bitwise
        `0000${(Math.random() * 36 ** 4 << 0).toString(36)}`.slice(-4);
    return ()=>{
        counter += 1;
        return `u${random()}${counter}`;
    };
})();
function $bd23e353f7395bd0$export$1391212d75b2ee65(ms) {
    return (args)=>new Promise((resolve)=>{
            setTimeout(()=>resolve(args), ms);
        });
}
function $bd23e353f7395bd0$export$45b10814cc054894(arrayLike) {
    const arr = [];
    for(let i = 0, l = arrayLike.length; i < l; i++)arr.push(arrayLike[i]);
    return arr;
}
let $bd23e353f7395bd0$var$styleProps = null;
function $bd23e353f7395bd0$export$be6bf80faea8d5af(options = {}) {
    if ($bd23e353f7395bd0$var$styleProps) return $bd23e353f7395bd0$var$styleProps;
    if (options.includeStyleProperties) {
        $bd23e353f7395bd0$var$styleProps = options.includeStyleProperties;
        return $bd23e353f7395bd0$var$styleProps;
    }
    $bd23e353f7395bd0$var$styleProps = $bd23e353f7395bd0$export$45b10814cc054894(window.getComputedStyle(document.documentElement));
    return $bd23e353f7395bd0$var$styleProps;
}
function $bd23e353f7395bd0$var$px(node, styleProperty) {
    const win = node.ownerDocument.defaultView || window;
    const val = win.getComputedStyle(node).getPropertyValue(styleProperty);
    return val ? parseFloat(val.replace('px', '')) : 0;
}
function $bd23e353f7395bd0$var$getNodeWidth(node) {
    const leftBorder = $bd23e353f7395bd0$var$px(node, 'border-left-width');
    const rightBorder = $bd23e353f7395bd0$var$px(node, 'border-right-width');
    return node.clientWidth + leftBorder + rightBorder;
}
function $bd23e353f7395bd0$var$getNodeHeight(node) {
    const topBorder = $bd23e353f7395bd0$var$px(node, 'border-top-width');
    const bottomBorder = $bd23e353f7395bd0$var$px(node, 'border-bottom-width');
    return node.clientHeight + topBorder + bottomBorder;
}
function $bd23e353f7395bd0$export$ada5537b2c061996(targetNode, options = {}) {
    const width = options.width || $bd23e353f7395bd0$var$getNodeWidth(targetNode);
    const height = options.height || $bd23e353f7395bd0$var$getNodeHeight(targetNode);
    return {
        width: width,
        height: height
    };
}
function $bd23e353f7395bd0$export$d39ce20a37bba061() {
    let ratio;
    let FINAL_PROCESS;
    try {
        FINAL_PROCESS = $375d8335527bcde6$exports;
    } catch (e) {
    // pass
    }
    const val = FINAL_PROCESS && FINAL_PROCESS.env ? FINAL_PROCESS.env.devicePixelRatio : null;
    if (val) {
        ratio = parseInt(val, 10);
        if (Number.isNaN(ratio)) ratio = 1;
    }
    return ratio || window.devicePixelRatio || 1;
}
// @see https://developer.mozilla.org/en-US/docs/Web/HTML/Element/canvas#maximum_canvas_size
const $bd23e353f7395bd0$var$canvasDimensionLimit = 16384;
function $bd23e353f7395bd0$export$c2c809a2fe6b0f1a(canvas) {
    if (canvas.width > $bd23e353f7395bd0$var$canvasDimensionLimit || canvas.height > $bd23e353f7395bd0$var$canvasDimensionLimit) {
        if (canvas.width > $bd23e353f7395bd0$var$canvasDimensionLimit && canvas.height > $bd23e353f7395bd0$var$canvasDimensionLimit) {
            if (canvas.width > canvas.height) {
                canvas.height *= $bd23e353f7395bd0$var$canvasDimensionLimit / canvas.width;
                canvas.width = $bd23e353f7395bd0$var$canvasDimensionLimit;
            } else {
                canvas.width *= $bd23e353f7395bd0$var$canvasDimensionLimit / canvas.height;
                canvas.height = $bd23e353f7395bd0$var$canvasDimensionLimit;
            }
        } else if (canvas.width > $bd23e353f7395bd0$var$canvasDimensionLimit) {
            canvas.height *= $bd23e353f7395bd0$var$canvasDimensionLimit / canvas.width;
            canvas.width = $bd23e353f7395bd0$var$canvasDimensionLimit;
        } else {
            canvas.width *= $bd23e353f7395bd0$var$canvasDimensionLimit / canvas.height;
            canvas.height = $bd23e353f7395bd0$var$canvasDimensionLimit;
        }
    }
}
function $bd23e353f7395bd0$export$403d539f215df596(canvas, options = {}) {
    if (canvas.toBlob) return new Promise((resolve)=>{
        canvas.toBlob(resolve, options.type ? options.type : 'image/png', options.quality ? options.quality : 1);
    });
    return new Promise((resolve)=>{
        const binaryString = window.atob(canvas.toDataURL(options.type ? options.type : undefined, options.quality ? options.quality : undefined).split(',')[1]);
        const len = binaryString.length;
        const binaryArray = new Uint8Array(len);
        for(let i = 0; i < len; i += 1)binaryArray[i] = binaryString.charCodeAt(i);
        resolve(new Blob([
            binaryArray
        ], {
            type: options.type ? options.type : 'image/png'
        }));
    });
}
function $bd23e353f7395bd0$export$ec664d7487540b(url) {
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.onload = ()=>{
            img.decode().then(()=>{
                requestAnimationFrame(()=>resolve(img));
            });
        };
        img.onerror = reject;
        img.crossOrigin = 'anonymous';
        img.decoding = 'async';
        img.src = url;
    });
}
async function $bd23e353f7395bd0$export$fe77aa9c02de4599(svg) {
    return Promise.resolve().then(()=>new XMLSerializer().serializeToString(svg)).then(encodeURIComponent).then((html)=>`data:image/svg+xml;charset=utf-8,${html}`);
}
async function $bd23e353f7395bd0$export$b62810fb8ca515fa(node, width, height) {
    const xmlns = 'http://www.w3.org/2000/svg';
    const svg = document.createElementNS(xmlns, 'svg');
    const foreignObject = document.createElementNS(xmlns, 'foreignObject');
    svg.setAttribute('width', `${width}`);
    svg.setAttribute('height', `${height}`);
    svg.setAttribute('viewBox', `0 0 ${width} ${height}`);
    foreignObject.setAttribute('width', '100%');
    foreignObject.setAttribute('height', '100%');
    foreignObject.setAttribute('x', '0');
    foreignObject.setAttribute('y', '0');
    foreignObject.setAttribute('externalResourcesRequired', 'true');
    svg.appendChild(foreignObject);
    foreignObject.appendChild(node);
    return $bd23e353f7395bd0$export$fe77aa9c02de4599(svg);
}
const $bd23e353f7395bd0$export$3a92fc9ec83ef360 = (node, instance)=>{
    if (node instanceof instance) return true;
    const nodePrototype = Object.getPrototypeOf(node);
    if (nodePrototype === null) return false;
    return nodePrototype.constructor.name === instance.name || $bd23e353f7395bd0$export$3a92fc9ec83ef360(nodePrototype, instance);
};


function $22e6a6aa216bc9d6$var$formatCSSText(style) {
    const content = style.getPropertyValue('content');
    return `${style.cssText} content: '${content.replace(/'|"/g, '')}';`;
}
function $22e6a6aa216bc9d6$var$formatCSSProperties(style, options) {
    return (0, $bd23e353f7395bd0$export$be6bf80faea8d5af)(options).map((name)=>{
        const value = style.getPropertyValue(name);
        const priority = style.getPropertyPriority(name);
        return `${name}: ${value}${priority ? ' !important' : ''};`;
    }).join(' ');
}
function $22e6a6aa216bc9d6$var$getPseudoElementStyle(className, pseudo, style, options) {
    const selector = `.${className}:${pseudo}`;
    const cssText = style.cssText ? $22e6a6aa216bc9d6$var$formatCSSText(style) : $22e6a6aa216bc9d6$var$formatCSSProperties(style, options);
    return document.createTextNode(`${selector}{${cssText}}`);
}
function $22e6a6aa216bc9d6$var$clonePseudoElement(nativeNode, clonedNode, pseudo, options) {
    const style = window.getComputedStyle(nativeNode, pseudo);
    const content = style.getPropertyValue('content');
    if (content === '' || content === 'none') return;
    const className = (0, $bd23e353f7395bd0$export$31b40729666a4ae0)();
    try {
        clonedNode.className = `${clonedNode.className} ${className}`;
    } catch (err) {
        return;
    }
    const styleElement = document.createElement('style');
    styleElement.appendChild($22e6a6aa216bc9d6$var$getPseudoElementStyle(className, pseudo, style, options));
    clonedNode.appendChild(styleElement);
}
function $22e6a6aa216bc9d6$export$8df63687a708ed2e(nativeNode, clonedNode, options) {
    $22e6a6aa216bc9d6$var$clonePseudoElement(nativeNode, clonedNode, ':before', options);
    $22e6a6aa216bc9d6$var$clonePseudoElement(nativeNode, clonedNode, ':after', options);
}



const $cdfce33db59fbadb$var$WOFF = 'application/font-woff';
const $cdfce33db59fbadb$var$JPEG = 'image/jpeg';
const $cdfce33db59fbadb$var$mimes = {
    woff: $cdfce33db59fbadb$var$WOFF,
    woff2: $cdfce33db59fbadb$var$WOFF,
    ttf: 'application/font-truetype',
    eot: 'application/vnd.ms-fontobject',
    png: 'image/png',
    jpg: $cdfce33db59fbadb$var$JPEG,
    jpeg: $cdfce33db59fbadb$var$JPEG,
    gif: 'image/gif',
    tiff: 'image/tiff',
    svg: 'image/svg+xml',
    webp: 'image/webp'
};
function $cdfce33db59fbadb$var$getExtension(url) {
    const match = /\.([^./]*?)$/g.exec(url);
    return match ? match[1] : '';
}
function $cdfce33db59fbadb$export$200548c990602f61(url) {
    const extension = $cdfce33db59fbadb$var$getExtension(url).toLowerCase();
    return $cdfce33db59fbadb$var$mimes[extension] || '';
}


function $638f19f78257c840$var$getContentFromDataUrl(dataURL) {
    return dataURL.split(/,/)[1];
}
function $638f19f78257c840$export$f8a05efa20ffd5a(url) {
    return url.search(/^(data:)/) !== -1;
}
function $638f19f78257c840$export$68336ea1617fa80a(content, mimeType) {
    return `data:${mimeType};base64,${content}`;
}
async function $638f19f78257c840$export$c20a8b76c95b0d41(url, init, process) {
    const res = await fetch(url, init);
    if (res.status === 404) throw new Error(`Resource "${res.url}" not found`);
    const blob = await res.blob();
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onerror = reject;
        reader.onloadend = ()=>{
            try {
                resolve(process({
                    res: res,
                    result: reader.result
                }));
            } catch (error) {
                reject(error);
            }
        };
        reader.readAsDataURL(blob);
    });
}
const $638f19f78257c840$var$cache = {};
function $638f19f78257c840$var$getCacheKey(url, contentType, includeQueryParams) {
    let key = url.replace(/\?.*/, '');
    if (includeQueryParams) key = url;
    // font resource
    if (/ttf|otf|eot|woff2?/i.test(key)) key = key.replace(/.*\//, '');
    return contentType ? `[${contentType}]${key}` : key;
}
async function $638f19f78257c840$export$bdf0422c029b202a(resourceUrl, contentType, options) {
    const cacheKey = $638f19f78257c840$var$getCacheKey(resourceUrl, contentType, options.includeQueryParams);
    if ($638f19f78257c840$var$cache[cacheKey] != null) return $638f19f78257c840$var$cache[cacheKey];
    // ref: https://developer.mozilla.org/en/docs/Web/API/XMLHttpRequest/Using_XMLHttpRequest#Bypassing_the_cache
    if (options.cacheBust) // eslint-disable-next-line no-param-reassign
    resourceUrl += (/\?/.test(resourceUrl) ? '&' : '?') + new Date().getTime();
    let dataURL;
    try {
        const content = await $638f19f78257c840$export$c20a8b76c95b0d41(resourceUrl, options.fetchRequestInit, ({ res: res, result: result })=>{
            if (!contentType) // eslint-disable-next-line no-param-reassign
            contentType = res.headers.get('Content-Type') || '';
            return $638f19f78257c840$var$getContentFromDataUrl(result);
        });
        dataURL = $638f19f78257c840$export$68336ea1617fa80a(content, contentType);
    } catch (error) {
        dataURL = options.imagePlaceholder || '';
        let msg = `Failed to fetch resource: ${resourceUrl}`;
        if (error) msg = typeof error === 'string' ? error : error.message;
        if (msg) console.warn(msg);
    }
    $638f19f78257c840$var$cache[cacheKey] = dataURL;
    return dataURL;
}


async function $06b7371bd187f0a9$var$cloneCanvasElement(canvas) {
    const dataURL = canvas.toDataURL();
    if (dataURL === 'data:,') return canvas.cloneNode(false);
    return (0, $bd23e353f7395bd0$export$ec664d7487540b)(dataURL);
}
async function $06b7371bd187f0a9$var$cloneVideoElement(video, options) {
    if (video.currentSrc) {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = video.clientWidth;
        canvas.height = video.clientHeight;
        ctx === null || ctx === void 0 || ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        const dataURL = canvas.toDataURL();
        return (0, $bd23e353f7395bd0$export$ec664d7487540b)(dataURL);
    }
    const poster = video.poster;
    const contentType = (0, $cdfce33db59fbadb$export$200548c990602f61)(poster);
    const dataURL = await (0, $638f19f78257c840$export$bdf0422c029b202a)(poster, contentType, options);
    return (0, $bd23e353f7395bd0$export$ec664d7487540b)(dataURL);
}
async function $06b7371bd187f0a9$var$cloneIFrameElement(iframe, options) {
    var _a;
    try {
        if ((_a = iframe === null || iframe === void 0 ? void 0 : iframe.contentDocument) === null || _a === void 0 ? void 0 : _a.body) return await $06b7371bd187f0a9$export$ae8e35ea29ddac22(iframe.contentDocument.body, options, true);
    } catch (_b) {
    // Failed to clone iframe
    }
    return iframe.cloneNode(false);
}
async function $06b7371bd187f0a9$var$cloneSingleNode(node, options) {
    if ((0, $bd23e353f7395bd0$export$3a92fc9ec83ef360)(node, HTMLCanvasElement)) return $06b7371bd187f0a9$var$cloneCanvasElement(node);
    if ((0, $bd23e353f7395bd0$export$3a92fc9ec83ef360)(node, HTMLVideoElement)) return $06b7371bd187f0a9$var$cloneVideoElement(node, options);
    if ((0, $bd23e353f7395bd0$export$3a92fc9ec83ef360)(node, HTMLIFrameElement)) return $06b7371bd187f0a9$var$cloneIFrameElement(node, options);
    return node.cloneNode($06b7371bd187f0a9$var$isSVGElement(node));
}
const $06b7371bd187f0a9$var$isSlotElement = (node)=>node.tagName != null && node.tagName.toUpperCase() === 'SLOT';
const $06b7371bd187f0a9$var$isSVGElement = (node)=>node.tagName != null && node.tagName.toUpperCase() === 'SVG';
async function $06b7371bd187f0a9$var$cloneChildren(nativeNode, clonedNode, options) {
    var _a, _b;
    if ($06b7371bd187f0a9$var$isSVGElement(clonedNode)) return clonedNode;
    let children = [];
    if ($06b7371bd187f0a9$var$isSlotElement(nativeNode) && nativeNode.assignedNodes) children = (0, $bd23e353f7395bd0$export$45b10814cc054894)(nativeNode.assignedNodes());
    else if ((0, $bd23e353f7395bd0$export$3a92fc9ec83ef360)(nativeNode, HTMLIFrameElement) && ((_a = nativeNode.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) children = (0, $bd23e353f7395bd0$export$45b10814cc054894)(nativeNode.contentDocument.body.childNodes);
    else children = (0, $bd23e353f7395bd0$export$45b10814cc054894)(((_b = nativeNode.shadowRoot) !== null && _b !== void 0 ? _b : nativeNode).childNodes);
    if (children.length === 0 || (0, $bd23e353f7395bd0$export$3a92fc9ec83ef360)(nativeNode, HTMLVideoElement)) return clonedNode;
    await children.reduce((deferred, child)=>deferred.then(()=>$06b7371bd187f0a9$export$ae8e35ea29ddac22(child, options)).then((clonedChild)=>{
            if (clonedChild) clonedNode.appendChild(clonedChild);
        }), Promise.resolve());
    return clonedNode;
}
function $06b7371bd187f0a9$var$cloneCSSStyle(nativeNode, clonedNode, options) {
    const targetStyle = clonedNode.style;
    if (!targetStyle) return;
    const sourceStyle = window.getComputedStyle(nativeNode);
    if (sourceStyle.cssText) {
        targetStyle.cssText = sourceStyle.cssText;
        targetStyle.transformOrigin = sourceStyle.transformOrigin;
    } else (0, $bd23e353f7395bd0$export$be6bf80faea8d5af)(options).forEach((name)=>{
        let value = sourceStyle.getPropertyValue(name);
        if (name === 'font-size' && value.endsWith('px')) {
            const reducedFont = Math.floor(parseFloat(value.substring(0, value.length - 2))) - 0.1;
            value = `${reducedFont}px`;
        }
        if ((0, $bd23e353f7395bd0$export$3a92fc9ec83ef360)(nativeNode, HTMLIFrameElement) && name === 'display' && value === 'inline') value = 'block';
        if (name === 'd' && clonedNode.getAttribute('d')) value = `path(${clonedNode.getAttribute('d')})`;
        targetStyle.setProperty(name, value, sourceStyle.getPropertyPriority(name));
    });
}
function $06b7371bd187f0a9$var$cloneInputValue(nativeNode, clonedNode) {
    if ((0, $bd23e353f7395bd0$export$3a92fc9ec83ef360)(nativeNode, HTMLTextAreaElement)) clonedNode.innerHTML = nativeNode.value;
    if ((0, $bd23e353f7395bd0$export$3a92fc9ec83ef360)(nativeNode, HTMLInputElement)) clonedNode.setAttribute('value', nativeNode.value);
}
function $06b7371bd187f0a9$var$cloneSelectValue(nativeNode, clonedNode) {
    if ((0, $bd23e353f7395bd0$export$3a92fc9ec83ef360)(nativeNode, HTMLSelectElement)) {
        const clonedSelect = clonedNode;
        const selectedOption = Array.from(clonedSelect.children).find((child)=>nativeNode.value === child.getAttribute('value'));
        if (selectedOption) selectedOption.setAttribute('selected', '');
    }
}
function $06b7371bd187f0a9$var$decorate(nativeNode, clonedNode, options) {
    if ((0, $bd23e353f7395bd0$export$3a92fc9ec83ef360)(clonedNode, Element)) {
        $06b7371bd187f0a9$var$cloneCSSStyle(nativeNode, clonedNode, options);
        (0, $22e6a6aa216bc9d6$export$8df63687a708ed2e)(nativeNode, clonedNode, options);
        $06b7371bd187f0a9$var$cloneInputValue(nativeNode, clonedNode);
        $06b7371bd187f0a9$var$cloneSelectValue(nativeNode, clonedNode);
    }
    return clonedNode;
}
async function $06b7371bd187f0a9$var$ensureSVGSymbols(clone, options) {
    const uses = clone.querySelectorAll ? clone.querySelectorAll('use') : [];
    if (uses.length === 0) return clone;
    const processedDefs = {};
    for(let i = 0; i < uses.length; i++){
        const use = uses[i];
        const id = use.getAttribute('xlink:href');
        if (id) {
            const exist = clone.querySelector(id);
            const definition = document.querySelector(id);
            if (!exist && definition && !processedDefs[id]) // eslint-disable-next-line no-await-in-loop
            processedDefs[id] = await $06b7371bd187f0a9$export$ae8e35ea29ddac22(definition, options, true);
        }
    }
    const nodes = Object.values(processedDefs);
    if (nodes.length) {
        const ns = 'http://www.w3.org/1999/xhtml';
        const svg = document.createElementNS(ns, 'svg');
        svg.setAttribute('xmlns', ns);
        svg.style.position = 'absolute';
        svg.style.width = '0';
        svg.style.height = '0';
        svg.style.overflow = 'hidden';
        svg.style.display = 'none';
        const defs = document.createElementNS(ns, 'defs');
        svg.appendChild(defs);
        for(let i = 0; i < nodes.length; i++)defs.appendChild(nodes[i]);
        clone.appendChild(svg);
    }
    return clone;
}
async function $06b7371bd187f0a9$export$ae8e35ea29ddac22(node, options, isRoot) {
    if (!isRoot && options.filter && !options.filter(node)) return null;
    return Promise.resolve(node).then((clonedNode)=>$06b7371bd187f0a9$var$cloneSingleNode(clonedNode, options)).then((clonedNode)=>$06b7371bd187f0a9$var$cloneChildren(node, clonedNode, options)).then((clonedNode)=>$06b7371bd187f0a9$var$decorate(node, clonedNode, options)).then((clonedNode)=>$06b7371bd187f0a9$var$ensureSVGSymbols(clonedNode, options));
}





const $ba57dca4a3f095d3$var$URL_REGEX = /url\((['"]?)([^'"]+?)\1\)/g;
const $ba57dca4a3f095d3$var$URL_WITH_FORMAT_REGEX = /url\([^)]+\)\s*format\((["']?)([^"']+)\1\)/g;
const $ba57dca4a3f095d3$var$FONT_SRC_REGEX = /src:\s*(?:url\([^)]+\)\s*format\([^)]+\)[,;]\s*)+/g;
function $ba57dca4a3f095d3$var$toRegex(url) {
    // eslint-disable-next-line no-useless-escape
    const escaped = url.replace(/([.*+?^${}()|\[\]\/\\])/g, '\\$1');
    return new RegExp(`(url\\(['"]?)(${escaped})(['"]?\\))`, 'g');
}
function $ba57dca4a3f095d3$export$d04549d631b8762d(cssText) {
    const urls = [];
    cssText.replace($ba57dca4a3f095d3$var$URL_REGEX, (raw, quotation, url)=>{
        urls.push(url);
        return raw;
    });
    return urls.filter((url)=>!(0, $638f19f78257c840$export$f8a05efa20ffd5a)(url));
}
async function $ba57dca4a3f095d3$export$2be46bb7e96db87f(cssText, resourceURL, baseURL, options, getContentFromUrl) {
    try {
        const resolvedURL = baseURL ? (0, $bd23e353f7395bd0$export$f85c16a6d62f7d63)(resourceURL, baseURL) : resourceURL;
        const contentType = (0, $cdfce33db59fbadb$export$200548c990602f61)(resourceURL);
        let dataURL;
        if (getContentFromUrl) {
            const content = await getContentFromUrl(resolvedURL);
            dataURL = (0, $638f19f78257c840$export$68336ea1617fa80a)(content, contentType);
        } else dataURL = await (0, $638f19f78257c840$export$bdf0422c029b202a)(resolvedURL, contentType, options);
        return cssText.replace($ba57dca4a3f095d3$var$toRegex(resourceURL), `$1${dataURL}$3`);
    } catch (error) {
    // pass
    }
    return cssText;
}
function $ba57dca4a3f095d3$var$filterPreferredFontFormat(str, { preferredFontFormat: preferredFontFormat }) {
    return !preferredFontFormat ? str : str.replace($ba57dca4a3f095d3$var$FONT_SRC_REGEX, (match)=>{
        // eslint-disable-next-line no-constant-condition
        while(true){
            const [src, , format] = $ba57dca4a3f095d3$var$URL_WITH_FORMAT_REGEX.exec(match) || [];
            if (!format) return '';
            if (format === preferredFontFormat) return `src: ${src};`;
        }
    });
}
function $ba57dca4a3f095d3$export$7b668369e5eab853(url) {
    return url.search($ba57dca4a3f095d3$var$URL_REGEX) !== -1;
}
async function $ba57dca4a3f095d3$export$3d88803585cbbc21(cssText, baseUrl, options) {
    if (!$ba57dca4a3f095d3$export$7b668369e5eab853(cssText)) return cssText;
    const filteredCSSText = $ba57dca4a3f095d3$var$filterPreferredFontFormat(cssText, options);
    const urls = $ba57dca4a3f095d3$export$d04549d631b8762d(filteredCSSText);
    return urls.reduce((deferred, url)=>deferred.then((css)=>$ba57dca4a3f095d3$export$2be46bb7e96db87f(css, url, baseUrl, options)), Promise.resolve(filteredCSSText));
}





async function $48657e9b3543cebc$var$embedProp(propName, node, options) {
    var _a;
    const propValue = (_a = node.style) === null || _a === void 0 ? void 0 : _a.getPropertyValue(propName);
    if (propValue) {
        const cssString = await (0, $ba57dca4a3f095d3$export$3d88803585cbbc21)(propValue, null, options);
        node.style.setProperty(propName, cssString, node.style.getPropertyPriority(propName));
        return true;
    }
    return false;
}
async function $48657e9b3543cebc$var$embedBackground(clonedNode, options) {
    await $48657e9b3543cebc$var$embedProp('background', clonedNode, options) || await $48657e9b3543cebc$var$embedProp('background-image', clonedNode, options);
    await $48657e9b3543cebc$var$embedProp('mask', clonedNode, options) || await $48657e9b3543cebc$var$embedProp('-webkit-mask', clonedNode, options) || await $48657e9b3543cebc$var$embedProp('mask-image', clonedNode, options) || await $48657e9b3543cebc$var$embedProp('-webkit-mask-image', clonedNode, options);
}
async function $48657e9b3543cebc$var$embedImageNode(clonedNode, options) {
    const isImageElement = (0, $bd23e353f7395bd0$export$3a92fc9ec83ef360)(clonedNode, HTMLImageElement);
    if (!(isImageElement && !(0, $638f19f78257c840$export$f8a05efa20ffd5a)(clonedNode.src)) && !((0, $bd23e353f7395bd0$export$3a92fc9ec83ef360)(clonedNode, SVGImageElement) && !(0, $638f19f78257c840$export$f8a05efa20ffd5a)(clonedNode.href.baseVal))) return;
    const url = isImageElement ? clonedNode.src : clonedNode.href.baseVal;
    const dataURL = await (0, $638f19f78257c840$export$bdf0422c029b202a)(url, (0, $cdfce33db59fbadb$export$200548c990602f61)(url), options);
    await new Promise((resolve, reject)=>{
        clonedNode.onload = resolve;
        clonedNode.onerror = options.onImageErrorHandler ? (...attributes)=>{
            try {
                resolve(options.onImageErrorHandler(...attributes));
            } catch (error) {
                reject(error);
            }
        } : reject;
        const image = clonedNode;
        if (image.decode) image.decode = resolve;
        if (image.loading === 'lazy') image.loading = 'eager';
        if (isImageElement) {
            clonedNode.srcset = '';
            clonedNode.src = dataURL;
        } else clonedNode.href.baseVal = dataURL;
    });
}
async function $48657e9b3543cebc$var$embedChildren(clonedNode, options) {
    const children = (0, $bd23e353f7395bd0$export$45b10814cc054894)(clonedNode.childNodes);
    const deferreds = children.map((child)=>$48657e9b3543cebc$export$6660fa8dd20e53aa(child, options));
    await Promise.all(deferreds).then(()=>clonedNode);
}
async function $48657e9b3543cebc$export$6660fa8dd20e53aa(clonedNode, options) {
    if ((0, $bd23e353f7395bd0$export$3a92fc9ec83ef360)(clonedNode, Element)) {
        await $48657e9b3543cebc$var$embedBackground(clonedNode, options);
        await $48657e9b3543cebc$var$embedImageNode(clonedNode, options);
        await $48657e9b3543cebc$var$embedChildren(clonedNode, options);
    }
}


function $257879e9df0cae02$export$d63a6b7859608045(node, options) {
    const { style: style } = node;
    if (options.backgroundColor) style.backgroundColor = options.backgroundColor;
    if (options.width) style.width = `${options.width}px`;
    if (options.height) style.height = `${options.height}px`;
    const manual = options.style;
    if (manual != null) Object.keys(manual).forEach((key)=>{
        style[key] = manual[key];
    });
    return node;
}





const $d54a77ef44ff2297$var$cssFetchCache = {};
async function $d54a77ef44ff2297$var$fetchCSS(url) {
    let cache = $d54a77ef44ff2297$var$cssFetchCache[url];
    if (cache != null) return cache;
    const res = await fetch(url);
    const cssText = await res.text();
    cache = {
        url: url,
        cssText: cssText
    };
    $d54a77ef44ff2297$var$cssFetchCache[url] = cache;
    return cache;
}
async function $d54a77ef44ff2297$var$embedFonts(data, options) {
    let cssText = data.cssText;
    const regexUrl = /url\(["']?([^"')]+)["']?\)/g;
    const fontLocs = cssText.match(/url\([^)]+\)/g) || [];
    const loadFonts = fontLocs.map(async (loc)=>{
        let url = loc.replace(regexUrl, '$1');
        if (!url.startsWith('https://')) url = new URL(url, data.url).href;
        return (0, $638f19f78257c840$export$c20a8b76c95b0d41)(url, options.fetchRequestInit, ({ result: result })=>{
            cssText = cssText.replace(loc, `url(${result})`);
            return [
                loc,
                result
            ];
        });
    });
    return Promise.all(loadFonts).then(()=>cssText);
}
function $d54a77ef44ff2297$var$parseCSS(source) {
    if (source == null) return [];
    const result = [];
    const commentsRegex = /(\/\*[\s\S]*?\*\/)/gi;
    // strip out comments
    let cssText = source.replace(commentsRegex, '');
    // eslint-disable-next-line prefer-regex-literals
    const keyframesRegex = new RegExp('((@.*?keyframes [\\s\\S]*?){([\\s\\S]*?}\\s*?)})', 'gi');
    // eslint-disable-next-line no-constant-condition
    while(true){
        const matches = keyframesRegex.exec(cssText);
        if (matches === null) break;
        result.push(matches[0]);
    }
    cssText = cssText.replace(keyframesRegex, '');
    const importRegex = /@import[\s\S]*?url\([^)]*\)[\s\S]*?;/gi;
    // to match css & media queries together
    const combinedCSSRegex = "((\\s*?(?:\\/\\*[\\s\\S]*?\\*\\/)?\\s*?@media[\\s\\S]*?){([\\s\\S]*?)}\\s*?})|(([\\s\\S]*?){([\\s\\S]*?)})";
    // unified regex
    const unifiedRegex = new RegExp(combinedCSSRegex, 'gi');
    // eslint-disable-next-line no-constant-condition
    while(true){
        let matches = importRegex.exec(cssText);
        if (matches === null) {
            matches = unifiedRegex.exec(cssText);
            if (matches === null) break;
            else importRegex.lastIndex = unifiedRegex.lastIndex;
        } else unifiedRegex.lastIndex = importRegex.lastIndex;
        result.push(matches[0]);
    }
    return result;
}
async function $d54a77ef44ff2297$var$getCSSRules(styleSheets, options) {
    const ret = [];
    const deferreds = [];
    // First loop inlines imports
    styleSheets.forEach((sheet)=>{
        if ('cssRules' in sheet) try {
            (0, $bd23e353f7395bd0$export$45b10814cc054894)(sheet.cssRules || []).forEach((item, index)=>{
                if (item.type === CSSRule.IMPORT_RULE) {
                    let importIndex = index + 1;
                    const url = item.href;
                    const deferred = $d54a77ef44ff2297$var$fetchCSS(url).then((metadata)=>$d54a77ef44ff2297$var$embedFonts(metadata, options)).then((cssText)=>$d54a77ef44ff2297$var$parseCSS(cssText).forEach((rule)=>{
                            try {
                                sheet.insertRule(rule, rule.startsWith('@import') ? importIndex += 1 : sheet.cssRules.length);
                            } catch (error) {
                                console.error('Error inserting rule from remote css', {
                                    rule: rule,
                                    error: error
                                });
                            }
                        })).catch((e)=>{
                        console.error('Error loading remote css', e.toString());
                    });
                    deferreds.push(deferred);
                }
            });
        } catch (e) {
            const inline = styleSheets.find((a)=>a.href == null) || document.styleSheets[0];
            if (sheet.href != null) deferreds.push($d54a77ef44ff2297$var$fetchCSS(sheet.href).then((metadata)=>$d54a77ef44ff2297$var$embedFonts(metadata, options)).then((cssText)=>$d54a77ef44ff2297$var$parseCSS(cssText).forEach((rule)=>{
                    inline.insertRule(rule, inline.cssRules.length);
                })).catch((err)=>{
                console.error('Error loading remote stylesheet', err);
            }));
            console.error('Error inlining remote css file', e);
        }
    });
    return Promise.all(deferreds).then(()=>{
        // Second loop parses rules
        styleSheets.forEach((sheet)=>{
            if ('cssRules' in sheet) try {
                (0, $bd23e353f7395bd0$export$45b10814cc054894)(sheet.cssRules || []).forEach((item)=>{
                    ret.push(item);
                });
            } catch (e) {
                console.error(`Error while reading CSS rules from ${sheet.href}`, e);
            }
        });
        return ret;
    });
}
function $d54a77ef44ff2297$var$getWebFontRules(cssRules) {
    return cssRules.filter((rule)=>rule.type === CSSRule.FONT_FACE_RULE).filter((rule)=>(0, $ba57dca4a3f095d3$export$7b668369e5eab853)(rule.style.getPropertyValue('src')));
}
async function $d54a77ef44ff2297$var$parseWebFontRules(node, options) {
    if (node.ownerDocument == null) throw new Error('Provided element is not within a Document');
    const styleSheets = (0, $bd23e353f7395bd0$export$45b10814cc054894)(node.ownerDocument.styleSheets);
    const cssRules = await $d54a77ef44ff2297$var$getCSSRules(styleSheets, options);
    return $d54a77ef44ff2297$var$getWebFontRules(cssRules);
}
function $d54a77ef44ff2297$var$normalizeFontFamily(font) {
    return font.trim().replace(/["']/g, '');
}
function $d54a77ef44ff2297$var$getUsedFonts(node) {
    const fonts = new Set();
    function traverse(node) {
        const fontFamily = node.style.fontFamily || getComputedStyle(node).fontFamily;
        fontFamily.split(',').forEach((font)=>{
            fonts.add($d54a77ef44ff2297$var$normalizeFontFamily(font));
        });
        Array.from(node.children).forEach((child)=>{
            if (child instanceof HTMLElement) traverse(child);
        });
    }
    traverse(node);
    return fonts;
}
async function $d54a77ef44ff2297$export$253c9aa3d83a57b6(node, options) {
    const rules = await $d54a77ef44ff2297$var$parseWebFontRules(node, options);
    const usedFonts = $d54a77ef44ff2297$var$getUsedFonts(node);
    const cssTexts = await Promise.all(rules.filter((rule)=>usedFonts.has($d54a77ef44ff2297$var$normalizeFontFamily(rule.style.fontFamily))).map((rule)=>{
        const baseUrl = rule.parentStyleSheet ? rule.parentStyleSheet.href : null;
        return (0, $ba57dca4a3f095d3$export$3d88803585cbbc21)(rule.cssText, baseUrl, options);
    }));
    return cssTexts.join('\n');
}
async function $d54a77ef44ff2297$export$2c2c83b77c8cb421(clonedNode, options) {
    const cssText = options.fontEmbedCSS != null ? options.fontEmbedCSS : options.skipFonts ? null : await $d54a77ef44ff2297$export$253c9aa3d83a57b6(clonedNode, options);
    if (cssText) {
        const styleNode = document.createElement('style');
        const sytleContent = document.createTextNode(cssText);
        styleNode.appendChild(sytleContent);
        if (clonedNode.firstChild) clonedNode.insertBefore(styleNode, clonedNode.firstChild);
        else clonedNode.appendChild(styleNode);
    }
}



async function $dfd04280410fd300$export$20d300cb2d558b7(node, options = {}) {
    const { width: width, height: height } = (0, $bd23e353f7395bd0$export$ada5537b2c061996)(node, options);
    const clonedNode = await (0, $06b7371bd187f0a9$export$ae8e35ea29ddac22)(node, options, true);
    await (0, $d54a77ef44ff2297$export$2c2c83b77c8cb421)(clonedNode, options);
    await (0, $48657e9b3543cebc$export$6660fa8dd20e53aa)(clonedNode, options);
    (0, $257879e9df0cae02$export$d63a6b7859608045)(clonedNode, options);
    const datauri = await (0, $bd23e353f7395bd0$export$b62810fb8ca515fa)(clonedNode, width, height);
    return datauri;
}
async function $dfd04280410fd300$export$f87f6982d1fd4f81(node, options = {}) {
    const { width: width, height: height } = (0, $bd23e353f7395bd0$export$ada5537b2c061996)(node, options);
    const svg = await $dfd04280410fd300$export$20d300cb2d558b7(node, options);
    const img = await (0, $bd23e353f7395bd0$export$ec664d7487540b)(svg);
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    const ratio = options.pixelRatio || (0, $bd23e353f7395bd0$export$d39ce20a37bba061)();
    const canvasWidth = options.canvasWidth || width;
    const canvasHeight = options.canvasHeight || height;
    canvas.width = canvasWidth * ratio;
    canvas.height = canvasHeight * ratio;
    if (!options.skipAutoScale) (0, $bd23e353f7395bd0$export$c2c809a2fe6b0f1a)(canvas);
    canvas.style.width = `${canvasWidth}`;
    canvas.style.height = `${canvasHeight}`;
    if (options.backgroundColor) {
        context.fillStyle = options.backgroundColor;
        context.fillRect(0, 0, canvas.width, canvas.height);
    }
    context.drawImage(img, 0, 0, canvas.width, canvas.height);
    return canvas;
}
async function $dfd04280410fd300$export$6f9e32581c0cde11(node, options = {}) {
    const { width: width, height: height } = (0, $bd23e353f7395bd0$export$ada5537b2c061996)(node, options);
    const canvas = await $dfd04280410fd300$export$f87f6982d1fd4f81(node, options);
    const ctx = canvas.getContext('2d');
    return ctx.getImageData(0, 0, width, height).data;
}
async function $dfd04280410fd300$export$aba256f33615c92e(node, options = {}) {
    const canvas = await $dfd04280410fd300$export$f87f6982d1fd4f81(node, options);
    return canvas.toDataURL();
}
async function $dfd04280410fd300$export$ed218bd2440d33a5(node, options = {}) {
    const canvas = await $dfd04280410fd300$export$f87f6982d1fd4f81(node, options);
    return canvas.toDataURL('image/jpeg', options.quality || 1);
}
async function $dfd04280410fd300$export$b20f4ee19ffa0668(node, options = {}) {
    const canvas = await $dfd04280410fd300$export$f87f6982d1fd4f81(node, options);
    const blob = await (0, $bd23e353f7395bd0$export$403d539f215df596)(canvas);
    return blob;
}
async function $dfd04280410fd300$export$92678bad7eef403b(node, options = {}) {
    return (0, $d54a77ef44ff2297$export$253c9aa3d83a57b6)(node, options);
}







"use client";
//#region src/components/Toast/index.jsx
var $673b1c81cc441170$var$i = (e, t)=>{
    if (e) {
        let n = document.querySelector(`#${CSS.escape(e)}`);
        n && (n.classList.add("opacity-0", "transition-opacity", "duration-500"), setTimeout(()=>{
            let e = n.parentElement;
            n.remove(), t && t(), e && !e.children.length && e.remove();
        }, 400));
    } else for (let e of document.querySelectorAll("[id^=\"toast-\"]"))e.remove();
}, $673b1c81cc441170$var$a = ({ root: a, duration: o = 6, onDismiss: s, position: c = "bottom-center", ...l })=>{
    let u, d, f, p = `toast-${c}`, m = document.querySelector(`#${CSS.escape(p)}`);
    m ? d = m : (d = document.createElement("div"), d.id = p, document.body.append(d));
    let h = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-Toast fixed flex flex-col items-center justify-center max-w-(--breakpoint-sm) select-none z-9999 gap-2.5": !0,
        "top-5 left-5": c === "top-left",
        "top-5 left-1/2 -translate-x-1/2": c === "top-center",
        "top-5 right-5": c === "top-right",
        "bottom-5 left-5": c === "bottom-left",
        "bottom-5 left-1/2 -translate-x-1/2": c === "bottom-center",
        "bottom-5 right-5": c === "bottom-right"
    });
    if (d.className = h, a?.render) u = a;
    else {
        let e = `toast-item-${Math.random().toString().split(".")[1]}`;
        f = document.createElement("div"), f.id = e, d.append(f), u = (0, $2aa82faa573d5f31$exports.createRoot)(f), u.toastId = e;
    }
    let g = u.toastId;
    o && setTimeout(()=>$673b1c81cc441170$var$i(g, s), o * 1e3);
    let _ = ()=>$673b1c81cc441170$var$i(g, s);
    return u.render(/* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $71efe153e5175f41$export$2e2bcd8739ae039), {
        ...l,
        className: "rounded-xs",
        onClose: _,
        showClose: !0
    })), u;
}, $673b1c81cc441170$export$2e2bcd8739ae039 = {
    success: (e, t)=>$673b1c81cc441170$var$a({
            ...t,
            message: e,
            type: "success"
        }),
    error: (e, t)=>$673b1c81cc441170$var$a({
            ...t,
            message: e,
            type: "error"
        }),
    info: (e, t)=>$673b1c81cc441170$var$a({
            ...t,
            message: e,
            type: "info"
        }),
    warning: (e, t)=>$673b1c81cc441170$var$a({
            ...t,
            message: e,
            type: "warning"
        }),
    generic: (e, t)=>$673b1c81cc441170$var$a({
            ...t,
            message: e,
            type: "default"
        }),
    loading: (e = "Loading ...", t = {})=>$673b1c81cc441170$var$a({
            ...t,
            duration: 0,
            message: e,
            type: "default",
            customIcon: "progress_activity",
            iconClass: "animate-spin"
        }),
    dismiss: (e)=>$673b1c81cc441170$var$i(e?.toastId)
};


const $5f8e1c8d350f317e$export$7d91b78b47a2a176 = ()=>{
    const apiUrl = window.REACT_APP_API_URL;
    if (apiUrl.includes('apidev')) return 'EBSDEV3';
    else if (apiUrl.includes('apiqa')) return 'EBSQA';
    return 'EBSPROD';
};
const $5f8e1c8d350f317e$var$dateFormatter = new Intl.DateTimeFormat('en-US', {
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
});
const $5f8e1c8d350f317e$export$5ede9312e237b505 = (iso)=>$5f8e1c8d350f317e$var$dateFormatter.format(new Date(iso));
/**
 * Helper function to get nested property value from an object
 * @param {object} obj - The object to traverse
 * @param {string} path - The dot-separated path to the property
 * @returns {string} The value at the specified path
 */ const $5f8e1c8d350f317e$var$getNestedValue = (obj, path)=>{
    const parts = path.split('.');
    let current = obj;
    for (const part of parts){
        current = current?.[part];
        if (current === undefined || current === null) return '';
    }
    return String(current);
};
const $5f8e1c8d350f317e$export$f89d6faae6e6ac3e = (searchValue, data)=>{
    if (!searchValue || !data) return data;
    const lowerSearchValue = searchValue.toLowerCase();
    const filtered = data?.filter((item)=>(0, $917e2c0c66b65db1$export$a417583fa5432967).some((field)=>{
            const fieldValue = $5f8e1c8d350f317e$var$getNestedValue(item, field).toLowerCase();
            return fieldValue.includes(lowerSearchValue);
        }));
    return filtered.length ? filtered : undefined;
};
const $5f8e1c8d350f317e$export$1da0a8feefedd77d = (permanentQueues, temporaryQueues)=>[
        ...permanentQueues ?? [],
        ...temporaryQueues ?? []
    ].map((q)=>q.queueId);
const $5f8e1c8d350f317e$export$9af24aaf2ed70b0c = (oldData, id)=>{
    if (!oldData) return oldData;
    const { accepted: accepted, available: available, onhold: onhold } = oldData;
    const newData = {};
    if (accepted) newData.accepted = accepted.filter((req)=>req.id !== id);
    if (available) newData.available = available.filter((req)=>req.id !== id);
    if (onhold) newData.onhold = onhold.filter((req)=>req.id !== id);
    return newData;
};
const $5f8e1c8d350f317e$export$5508b873498ab146 = (oldData, id, communications)=>{
    if (!oldData) return oldData;
    const { accepted: accepted, available: available, onhold: onhold } = oldData;
    /**
   * Applies the new communication history to the matching request in one status group.
   * @param {Pella.ProductionRequestAPI.Request[]} requests - The requests in a status group
   * @returns {Pella.ProductionRequestAPI.Request[]} The group with the target request updated
   */ const applyToGroup = (requests)=>requests.map((req)=>req.id === id ? {
                ...req,
                communications: communications
            } : req);
    const newData = {};
    if (accepted) newData.accepted = applyToGroup(accepted);
    if (available) newData.available = applyToGroup(available);
    if (onhold) newData.onhold = applyToGroup(onhold);
    return newData;
};
const $5f8e1c8d350f317e$export$f3282d4aede5dc2b = (value)=>(value ?? '').trim().toLowerCase();
const $5f8e1c8d350f317e$export$6d608348c3a90609 = (request, userid)=>{
    const communications = request.communications ?? [];
    const normalizedUserid = $5f8e1c8d350f317e$export$f3282d4aede5dc2b(userid);
    if (!normalizedUserid) return {
        total: communications.length,
        unread: 0
    };
    let unread = 0;
    for (const entry of communications){
        const submittedByCurrentUser = $5f8e1c8d350f317e$export$f3282d4aede5dc2b(entry.userName) === normalizedUserid;
        if (submittedByCurrentUser) continue;
        const isRead = (entry.readBy ?? []).some((reader)=>$5f8e1c8d350f317e$export$f3282d4aede5dc2b(reader) === normalizedUserid);
        if (!isRead) unread += 1;
    }
    return {
        total: communications.length,
        unread: unread
    };
};
const $5f8e1c8d350f317e$export$8142721d7112d638 = (jsonString)=>{
    try {
        const parse = JSON.parse(jsonString);
        if (typeof parse !== 'object' || parse === null) return null;
        return parse;
    } catch  {
        return null;
    }
};
const $5f8e1c8d350f317e$export$c8b8645ec971eaf = async (ref)=>{
    if (!ref.current) return;
    try {
        const dataUrl = await $dfd04280410fd300$export$aba256f33615c92e(ref.current);
        const link = document.createElement('a');
        link.download = 'production-request-barcode.png';
        link.href = dataUrl;
        link.click();
        link.remove();
    } catch  {
        (0, $673b1c81cc441170$export$2e2bcd8739ae039).error('Failed to download image. Please try again.');
    }
};
const $5f8e1c8d350f317e$export$3a76b0f638b99fcf = (str)=>{
    let hash = 2166136261;
    const modulo = 4294967291;
    for (const char of str)hash = (hash * 16777619 + Number(char.codePointAt(0))) % modulo;
    return hash.toString(16);
};




var $a9dbf79be4355493$export$34e0f9847d4c02dd;
var $a9dbf79be4355493$export$38e42c68cf43b5d4;
var $a9dbf79be4355493$export$caf37b18e66e7c16;
var $a9dbf79be4355493$export$120ff0929b202a6d;
var $a9dbf79be4355493$export$cc74dcc53cfce4eb;
$a9dbf79be4355493$export$34e0f9847d4c02dd = `BzZDia_container`;
$a9dbf79be4355493$export$38e42c68cf43b5d4 = `BzZDia_header`;
$a9dbf79be4355493$export$caf37b18e66e7c16 = `BzZDia_modalFooter`;
$a9dbf79be4355493$export$120ff0929b202a6d = `BzZDia_row`;
$a9dbf79be4355493$export$cc74dcc53cfce4eb = `BzZDia_wrapper`;


const $3d5a10291cd1b995$var$NO_QUANTITY = 'N/A';
const $3d5a10291cd1b995$export$39006efc02100ca6 = ({ isOpen: isOpen, requests: requests, onCancel: onCancel, onProceed: onProceed })=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $4d41d17efc15da0f$export$2e2bcd8739ae039), {
        open: isOpen,
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $9dad852e7e98f87b$export$2e2bcd8739ae039), {
            className: $a9dbf79be4355493$export$34e0f9847d4c02dd,
            showClose: false,
            children: [
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $9761f0447406a76c$export$2e2bcd8739ae039), {
                    children: "Open Requests Found"
                }),
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $21eb14e493d0e28b$export$2e2bcd8739ae039), {
                    children: [
                        "This item has already been requested. Review the open requests below before proceeding.",
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                            className: $a9dbf79be4355493$export$cc74dcc53cfce4eb,
                            children: [
                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                    className: `${$a9dbf79be4355493$export$120ff0929b202a6d} ${$a9dbf79be4355493$export$38e42c68cf43b5d4}`,
                                    children: [
                                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                                            children: "Date"
                                        }),
                                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                                            children: "Username"
                                        }),
                                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                                            children: "Status"
                                        }),
                                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                                            children: "Qty"
                                        })
                                    ]
                                }),
                                requests.map((request)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                        className: $a9dbf79be4355493$export$120ff0929b202a6d,
                                        "data-testid": `duplicateRequest-${request.id}`,
                                        children: [
                                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                                                children: (0, $5f8e1c8d350f317e$export$5ede9312e237b505)(request.creationDate)
                                            }),
                                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                                                children: request.requestorId
                                            }),
                                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                                                children: request.status
                                            }),
                                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                                                children: request.requestQty || $3d5a10291cd1b995$var$NO_QUANTITY
                                            })
                                        ]
                                    }, request.id))
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $861af07899c9769a$export$2e2bcd8739ae039), {
                    className: $a9dbf79be4355493$export$caf37b18e66e7c16,
                    children: [
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                            color: "secondary",
                            onClick: onCancel,
                            children: "CANCEL"
                        }),
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                            color: "primary",
                            onClick: onProceed,
                            children: "PROCEED"
                        })
                    ]
                })
            ]
        })
    });




var $b71dd83bd216a714$export$34e0f9847d4c02dd;
var $b71dd83bd216a714$export$caf37b18e66e7c16;
$b71dd83bd216a714$export$34e0f9847d4c02dd = `_g2JvW_container`;
$b71dd83bd216a714$export$caf37b18e66e7c16 = `_g2JvW_modalFooter`;


const $b195b7406d2db366$export$f4686426a1b24a12 = ({ isOpen: isOpen, description: description, onDecline: onDecline, onConfirm: onConfirm })=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $4d41d17efc15da0f$export$2e2bcd8739ae039), {
        open: isOpen,
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $9dad852e7e98f87b$export$2e2bcd8739ae039), {
            className: $b71dd83bd216a714$export$34e0f9847d4c02dd,
            showClose: false,
            children: [
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $21eb14e493d0e28b$export$2e2bcd8739ae039), {
                    children: [
                        "This request is linked to ",
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("i", {
                            children: description
                        }),
                        ". Do you want to generate a request from this linked action?"
                    ]
                }),
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $861af07899c9769a$export$2e2bcd8739ae039), {
                    className: $b71dd83bd216a714$export$caf37b18e66e7c16,
                    children: [
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                            color: "secondary",
                            onClick: onDecline,
                            children: "NO"
                        }),
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                            color: "primary",
                            onClick: onConfirm,
                            children: "YES"
                        })
                    ]
                })
            ]
        })
    });







const $1e8fb63c31e3ee09$export$4be0675c521c5cd4 = `
    mutation ProductionRequestMutation($input: CreateInvMgmtTransactionInput!) {
        productionRequestMutation {
            createInvMgmtTransaction(input: $input) {
                itemId
                transactionHeaderId
                sourceLineId
                transactionUom
                TransactionQuantity
                transactionInterfaceId
                errorCode
            }
        }
    }
`;
const $1e8fb63c31e3ee09$export$e4d76daee3b34319 = `
    mutation ProductionRequestMutation($input: ActionInput!) {
        productionRequestMutation {
            createAction(input: $input) {
                ${(0, $917e2c0c66b65db1$export$9523889e0a5da4ba)}
            }
        }
    }
`;
const $1e8fb63c31e3ee09$export$82fa89b4a35ff41a = `
    mutation ProductionRequestMutation($id: String!, $input: ActionUpdateInput!) {
        productionRequestMutation {
            updateActionById(id: $id, input: $input) {
                ${(0, $917e2c0c66b65db1$export$9523889e0a5da4ba)}
            }
        }
    }
`;
const $1e8fb63c31e3ee09$export$7be47e3cb00986fc = `
query ProductionRequestQuery($id: String!) {
    productionRequestQuery {
        getActionById(id: $id) {
            ${(0, $917e2c0c66b65db1$export$9523889e0a5da4ba)}
        }
    }
}
`;
const $1e8fb63c31e3ee09$export$48673e45295c3dbd = `
query ProductionRequestQuery($actionId: String!, $dynamicInput: String!) {
    productionRequestQuery {
        getOpenRequestsByActionIdAndDynamicInput(actionId: $actionId, dynamicInput: $dynamicInput) {
            id
            creationDate
            requestorId
            status
            requestQty
        }
    }
}
`;
const $1e8fb63c31e3ee09$export$1993360ec5efc787 = `
    mutation ProductionRequestMutation($requestId: ID!, $communication: String!) {
        productionRequestMutation {
            createCommunication(input: {requestId: $requestId, communication: $communication}) {
                communications {
                    ${(0, $917e2c0c66b65db1$export$9614b21cfc575fa7)}
                }
            }
        }
    }
`;
const $1e8fb63c31e3ee09$export$4dee4c2144cbe866 = `
    mutation ProductionRequestMutation($requestId: ID!) {
        productionRequestMutation {
            markCommunicationRead(input: {requestId: $requestId}) {
                communications {
                    ${(0, $917e2c0c66b65db1$export$9614b21cfc575fa7)}
                }
            }
        }
    }
`;
const $1e8fb63c31e3ee09$var$DEFAULT_OUTPUT = `
    id
    createdBy
    creationDate
    lastUpdatedBy
    lastUpdatedDate
`;
const $1e8fb63c31e3ee09$var$LOCATION_OUTPUT = `
    active
    description
    issueToLine
    ${$1e8fb63c31e3ee09$var$DEFAULT_OUTPUT}
`;
const $1e8fb63c31e3ee09$var$RESOURCE_OUTPUT = `
    active
    description
    ${$1e8fb63c31e3ee09$var$DEFAULT_OUTPUT}
`;
const $1e8fb63c31e3ee09$var$RESOURCE_QUEUE_OUTPUT = `
    queueId
    resourceId
    queueStatus
    active
    createdBy
    creationDate
    lastUpdatedBy
    lastUpdatedDate
`;
const $1e8fb63c31e3ee09$var$SELECTION_LIST_OUTPUT = `
    description
    ${$1e8fb63c31e3ee09$var$DEFAULT_OUTPUT}
`;
const $1e8fb63c31e3ee09$var$DISPOSITION_OUTPUT = `
    dispositionId
    organizationId
    description
    distributionAccount
    segment1
`;
const $1e8fb63c31e3ee09$var$CARRIER_OUTPUT = `
    carrierId
    scacCode
    freightCode
    carrierName
`;
const $1e8fb63c31e3ee09$var$INVENTORY_ITEM_OUTPUT = `
    inventoryItemId
    item
    description
`;
const $1e8fb63c31e3ee09$var$SUBINVENTORY_CODE_OUTPUT = `
    ${$1e8fb63c31e3ee09$var$INVENTORY_ITEM_OUTPUT}
    subinventoryCode
    qoh
    primaryUomCode
    unitOfIssueCode
    unitOfIssueQoh
    lotNumber
    locatorId
    organizationId
    locator
    inventoryCreation
    fixedlotMultiplier
    transactionUomCode
    unitOfIssueFixedLot
    locatorTypeId
    locatorType
`;
const $1e8fb63c31e3ee09$var$SUBINVENTORY_INFO_OUTPUT = `
    ${$1e8fb63c31e3ee09$var$INVENTORY_ITEM_OUTPUT}
    lotNumber
    locatorId
    organizationId
    locator
    subinventoryCode
    qoh
    inventoryCreation
    fixedlotMultiplier
    primaryUomCode
    unitOfIssueCode
    transactionUomCode
    unitOfIssueQoh
    unitOfIssueFixedLot
`;
const $1e8fb63c31e3ee09$var$LOCATOR_OUTPUT = `
    subinventoryCode
    organizationId
    description
    locatorTypeId
    locatorType
    locator
    locatorId
`;
const $1e8fb63c31e3ee09$var$RESOURCE_NESTED_OUTPUT = `
    resourceQueues {
        ${$1e8fb63c31e3ee09$var$RESOURCE_QUEUE_OUTPUT}
        queue {${(0, $917e2c0c66b65db1$export$2e91c99b8ae4619)}}
    }
`;
const $1e8fb63c31e3ee09$var$QUEUE_NESTED_OUTPUT = `
    resourceQueues {
        ${$1e8fb63c31e3ee09$var$RESOURCE_QUEUE_OUTPUT}
        resource {${$1e8fb63c31e3ee09$var$RESOURCE_OUTPUT}}
    }
`;
const $1e8fb63c31e3ee09$var$query = (name, args, body)=>`
    query ProductionRequestQuery${args ? `(${args})` : ''} {
        productionRequestQuery {
            ${name}${body}
        }
    }
`;
const $1e8fb63c31e3ee09$var$mutation = (name, args, body)=>`
    mutation ProductionRequestMutation(${args}) {
        productionRequestMutation {
            ${name}${body}
        }
    }
`;
const $1e8fb63c31e3ee09$var$selection = (fields)=>` {
                ${fields}
            }`;
const $1e8fb63c31e3ee09$export$e154bfbb6ad5cf04 = $1e8fb63c31e3ee09$var$query('getPlants(input: $input)', '$input: PlantFilterInput', $1e8fb63c31e3ee09$var$selection((0, $917e2c0c66b65db1$export$7f56a3c99a9211d0)));
const $1e8fb63c31e3ee09$export$f4bba9a622c4dd9c = $1e8fb63c31e3ee09$var$mutation('createPlant(input: $input)', '$input: PlantInput!', $1e8fb63c31e3ee09$var$selection((0, $917e2c0c66b65db1$export$7f56a3c99a9211d0)));
const $1e8fb63c31e3ee09$export$e87815d0e1e9b9e6 = $1e8fb63c31e3ee09$var$mutation('updatePlantById(id: $id, input: $input)', '$id: String!, $input: PlantUpdateInput!', $1e8fb63c31e3ee09$var$selection((0, $917e2c0c66b65db1$export$7f56a3c99a9211d0)));
const $1e8fb63c31e3ee09$export$a518f15c10848ea1 = $1e8fb63c31e3ee09$var$mutation('deletePlantById(id: $id)', '$id: String!', $1e8fb63c31e3ee09$var$selection((0, $917e2c0c66b65db1$export$7f56a3c99a9211d0)));
const $1e8fb63c31e3ee09$export$4d827f8eda3a023e = $1e8fb63c31e3ee09$var$query('getLocationsByPlantId(id: $id, input: $input)', '$id: String!, $input: LocationFilterInput', $1e8fb63c31e3ee09$var$selection($1e8fb63c31e3ee09$var$LOCATION_OUTPUT));
const $1e8fb63c31e3ee09$export$d80ec8aacf18617a = $1e8fb63c31e3ee09$var$mutation('createLocation(input: $input)', '$input: LocationInput!', $1e8fb63c31e3ee09$var$selection($1e8fb63c31e3ee09$var$LOCATION_OUTPUT));
const $1e8fb63c31e3ee09$export$3447021a81fbd01c = $1e8fb63c31e3ee09$var$mutation('updateLocationById(id: $id, input: $input)', '$id: String!, $input: LocationUpdateInput!', $1e8fb63c31e3ee09$var$selection($1e8fb63c31e3ee09$var$LOCATION_OUTPUT));
const $1e8fb63c31e3ee09$export$855d0006e5a4b6a7 = $1e8fb63c31e3ee09$var$mutation('deleteLocationById(id: $id)', '$id: String!', $1e8fb63c31e3ee09$var$selection($1e8fb63c31e3ee09$var$LOCATION_OUTPUT));
const $1e8fb63c31e3ee09$export$ff2c0c7deeabb350 = $1e8fb63c31e3ee09$var$query('getActionsByLocationId(id: $id, input: $input)', '$id: String!, $input: ActionFilterInput', $1e8fb63c31e3ee09$var$selection((0, $917e2c0c66b65db1$export$3b1595a0ea293e57)));
const $1e8fb63c31e3ee09$export$61ac9c2e056c6cc1 = $1e8fb63c31e3ee09$var$mutation('deleteActionById(id: $id)', '$id: String!', $1e8fb63c31e3ee09$var$selection((0, $917e2c0c66b65db1$export$9523889e0a5da4ba)));
const $1e8fb63c31e3ee09$export$9efb16956bb63482 = $1e8fb63c31e3ee09$var$query('getResourceQueues(input: $input)', '$input: ResourceQueueFilterInput', $1e8fb63c31e3ee09$var$selection($1e8fb63c31e3ee09$var$RESOURCE_QUEUE_OUTPUT));
const $1e8fb63c31e3ee09$export$67f1197e9f2111e7 = $1e8fb63c31e3ee09$var$mutation('createResourceQueue(input: $input)', '$input: ResourceQueueInput!', $1e8fb63c31e3ee09$var$selection($1e8fb63c31e3ee09$var$RESOURCE_QUEUE_OUTPUT));
const $1e8fb63c31e3ee09$export$797f78767dd8a4cc = $1e8fb63c31e3ee09$var$mutation('updateResourceQueueById(queueId: $queueId, resourceId: $resourceId, input: $input)', '$queueId: String!, $resourceId: String!, $input: ResourceQueueUpdateInput!', $1e8fb63c31e3ee09$var$selection($1e8fb63c31e3ee09$var$RESOURCE_QUEUE_OUTPUT));
const $1e8fb63c31e3ee09$export$d9d9c61d2637408e = $1e8fb63c31e3ee09$var$mutation('deleteResourceQueueById(queueId: $queueId, resourceId: $resourceId)', '$queueId: String!, $resourceId: String!', $1e8fb63c31e3ee09$var$selection($1e8fb63c31e3ee09$var$RESOURCE_QUEUE_OUTPUT));
const $1e8fb63c31e3ee09$export$e5006adcc1104d38 = (resourceQueues)=>$1e8fb63c31e3ee09$var$query('getResourcesByPlantId(id: $id, input: $input)', '$id: String!, $input: ResourceFilterInput', $1e8fb63c31e3ee09$var$selection(`${$1e8fb63c31e3ee09$var$RESOURCE_OUTPUT}${resourceQueues ? $1e8fb63c31e3ee09$var$RESOURCE_NESTED_OUTPUT : ''}`));
const $1e8fb63c31e3ee09$export$8e9ab4c775719f53 = $1e8fb63c31e3ee09$var$mutation('createResource(input: $input)', '$input: ResourceInput!', $1e8fb63c31e3ee09$var$selection($1e8fb63c31e3ee09$var$RESOURCE_OUTPUT));
const $1e8fb63c31e3ee09$export$14d087c009633b99 = $1e8fb63c31e3ee09$var$mutation('updateResourceById(id: $id, input: $input)', '$id: String!, $input: ResourceUpdateInput!', $1e8fb63c31e3ee09$var$selection($1e8fb63c31e3ee09$var$RESOURCE_OUTPUT));
const $1e8fb63c31e3ee09$export$17b0b1a7bea95396 = $1e8fb63c31e3ee09$var$mutation('deleteResourceById(id: $id)', '$id: String!', $1e8fb63c31e3ee09$var$selection($1e8fb63c31e3ee09$var$RESOURCE_OUTPUT));
const $1e8fb63c31e3ee09$export$503f4170d488bde6 = (resourceQueues)=>$1e8fb63c31e3ee09$var$query('getQueuesByPlantId(id: $id, input: $input)', '$id: String!, $input: QueueFilterInput', $1e8fb63c31e3ee09$var$selection(`${(0, $917e2c0c66b65db1$export$2e91c99b8ae4619)}${resourceQueues ? $1e8fb63c31e3ee09$var$QUEUE_NESTED_OUTPUT : ''}`));
const $1e8fb63c31e3ee09$export$e6e836220679c86d = $1e8fb63c31e3ee09$var$mutation('createQueue(input: $input)', '$input: QueueInput!', $1e8fb63c31e3ee09$var$selection((0, $917e2c0c66b65db1$export$2e91c99b8ae4619)));
const $1e8fb63c31e3ee09$export$a912795cf44b791b = $1e8fb63c31e3ee09$var$mutation('updateQueueById(id: $id, input: $input)', '$id: String!, $input: QueueUpdateInput!', $1e8fb63c31e3ee09$var$selection((0, $917e2c0c66b65db1$export$2e91c99b8ae4619)));
const $1e8fb63c31e3ee09$export$5ab05b9e296b458f = $1e8fb63c31e3ee09$var$mutation('deleteQueueById(id: $id)', '$id: String!', $1e8fb63c31e3ee09$var$selection((0, $917e2c0c66b65db1$export$2e91c99b8ae4619)));
const $1e8fb63c31e3ee09$export$3be3ffc90c087880 = $1e8fb63c31e3ee09$var$query('getQueuesByResourceId(resourceId: $resourceId)', '$resourceId: String!', '');
const $1e8fb63c31e3ee09$export$fabd6011ddd9a45f = $1e8fb63c31e3ee09$var$query('getSelectionListsByPlantId(id: $id)', '$id: String!', $1e8fb63c31e3ee09$var$selection(`${$1e8fb63c31e3ee09$var$SELECTION_LIST_OUTPUT}
                values {
                    ${$1e8fb63c31e3ee09$var$SELECTION_LIST_OUTPUT}
                }`));
const $1e8fb63c31e3ee09$export$45be44e248e8e0db = $1e8fb63c31e3ee09$var$mutation('createSelectionList(input: $input)', '$input: SelectionListInput!', $1e8fb63c31e3ee09$var$selection($1e8fb63c31e3ee09$var$SELECTION_LIST_OUTPUT));
const $1e8fb63c31e3ee09$export$134c932bccff9b0b = $1e8fb63c31e3ee09$var$mutation('updateSelectionListById(id: $id, input: $input)', '$id: String!, $input: SelectionListUpdateInput!', $1e8fb63c31e3ee09$var$selection($1e8fb63c31e3ee09$var$SELECTION_LIST_OUTPUT));
const $1e8fb63c31e3ee09$export$d93b4bd3b13c94de = $1e8fb63c31e3ee09$var$mutation('deleteSelectionListById(id: $id)', '$id: String!', $1e8fb63c31e3ee09$var$selection($1e8fb63c31e3ee09$var$SELECTION_LIST_OUTPUT));
const $1e8fb63c31e3ee09$export$dc703cfb7bb0f209 = $1e8fb63c31e3ee09$var$mutation('createSelectionListValue(input: $input)', '$input: SelectionListValueInput!', $1e8fb63c31e3ee09$var$selection($1e8fb63c31e3ee09$var$SELECTION_LIST_OUTPUT));
const $1e8fb63c31e3ee09$export$f3bdd5c58a84d585 = $1e8fb63c31e3ee09$var$mutation('updateSelectionListValueById(id: $id, input: $input)', '$id: String!, $input: SelectionListValueUpdateInput!', $1e8fb63c31e3ee09$var$selection($1e8fb63c31e3ee09$var$SELECTION_LIST_OUTPUT));
const $1e8fb63c31e3ee09$export$8183d4492af7b852 = $1e8fb63c31e3ee09$var$mutation('deleteSelectionListValueById(id: $id)', '$id: String!', $1e8fb63c31e3ee09$var$selection($1e8fb63c31e3ee09$var$SELECTION_LIST_OUTPUT));
const $1e8fb63c31e3ee09$export$f407cac8ed1f39fa = $1e8fb63c31e3ee09$var$query('getRequestsByResourceId(resourceId: $resourceId, status: $status)', '$resourceId: String!, $status: String', '');
const $1e8fb63c31e3ee09$export$1a19e4b15e09b60c = $1e8fb63c31e3ee09$var$query('getCompletedRequestsByResourceId(resourceId: $resourceId)', '$resourceId: String!', '');
const $1e8fb63c31e3ee09$export$99173c7bcff6c3c5 = $1e8fb63c31e3ee09$var$query('getRequestsByLocationIdByStatus(locationId: $locationId)', '$locationId: String!', '');
const $1e8fb63c31e3ee09$export$804ed697b67b9cd5 = $1e8fb63c31e3ee09$var$query('getCompletedRequestsByLocationIdByStatus(locationId: $locationId)', '$locationId: String!', '');
const $1e8fb63c31e3ee09$export$ad5fb8b7cdde24d7 = $1e8fb63c31e3ee09$var$mutation('createRequest(input: $input)', '$input: RequestInput!', $1e8fb63c31e3ee09$var$selection(`comment
                requestQty
                dynamicInput
                dynamicInputResult
                requestorId
                status
                dropDownListVal1
                dropDownListVal2
                invTransactionId
                ${$1e8fb63c31e3ee09$var$DEFAULT_OUTPUT}`));
const $1e8fb63c31e3ee09$export$d083f9fbdb3d0263 = $1e8fb63c31e3ee09$var$mutation('updateRequestById(id: $id, input: $input)', '$id: String!, $input: RequestUpdateInput!', $1e8fb63c31e3ee09$var$selection('id\n                status'));
const $1e8fb63c31e3ee09$export$20a335504c5b6ada = $1e8fb63c31e3ee09$var$query('getDispositionsByPlantId(id: $id)', '$id: String!', $1e8fb63c31e3ee09$var$selection($1e8fb63c31e3ee09$var$DISPOSITION_OUTPUT));
const $1e8fb63c31e3ee09$export$475af00ba99d61cf = $1e8fb63c31e3ee09$var$query('getCarrierList', '', $1e8fb63c31e3ee09$var$selection($1e8fb63c31e3ee09$var$CARRIER_OUTPUT));
const $1e8fb63c31e3ee09$export$a3e666e5c2b7b356 = $1e8fb63c31e3ee09$var$mutation('createTrailerToDockTransaction(input: $input)', '$input: TrailerToDockTransactionInput!', '');
const $1e8fb63c31e3ee09$export$eeff4248505ccd8a = $1e8fb63c31e3ee09$var$query('getInventoryItemIdByPlant(organizationId: $organizationId, item: $item)', '$organizationId: Int!, $item: String!', $1e8fb63c31e3ee09$var$selection($1e8fb63c31e3ee09$var$INVENTORY_ITEM_OUTPUT));
const $1e8fb63c31e3ee09$export$96097c6757be0fb5 = $1e8fb63c31e3ee09$var$query('getSubinventoryCodesByPlant(organizationId: $organizationId, inventoryItemId: $inventoryItemId, qoh: $qoh)', '$organizationId: Int!, $inventoryItemId: Int!, $qoh: quantityOnHandFilter', $1e8fb63c31e3ee09$var$selection($1e8fb63c31e3ee09$var$SUBINVENTORY_CODE_OUTPUT));
const $1e8fb63c31e3ee09$export$790abd8d67f77fab = $1e8fb63c31e3ee09$var$query('getSubinventoryInfoByPlant(organizationId: $organizationId, inventoryItemId: $inventoryItemId, subinventoryCode: $subinventoryCode)', '$organizationId: Int!, $inventoryItemId: Int!, $subinventoryCode: String!', $1e8fb63c31e3ee09$var$selection($1e8fb63c31e3ee09$var$SUBINVENTORY_INFO_OUTPUT));
const $1e8fb63c31e3ee09$export$95da18d3c20a73b1 = $1e8fb63c31e3ee09$var$query('getLocators(organizationId: $organizationId, subinventoryCode: $subinventoryCode, inventoryItemId: $inventoryItemId)', '$organizationId: Int!, $subinventoryCode: String!, $inventoryItemId: Int!', $1e8fb63c31e3ee09$var$selection($1e8fb63c31e3ee09$var$LOCATOR_OUTPUT));


const $a071e4bc84b4df4e$var$GRAPHQL_URL = `${window.REACT_APP_API_URL}/production-request/graphql`;
const $a071e4bc84b4df4e$export$d8e10908befdaef1 = async (input)=>{
    const { data: data } = await (0, $9942448fd46231b7$export$71667b1866b7607e)($a071e4bc84b4df4e$var$GRAPHQL_URL, $1e8fb63c31e3ee09$export$4be0675c521c5cd4, {
        input: input
    });
    return data.productionRequestMutation.createInvMgmtTransaction;
};
const $a071e4bc84b4df4e$export$309c7a02b0b0bc62 = async (input)=>{
    const { data: data } = await (0, $9942448fd46231b7$export$71667b1866b7607e)($a071e4bc84b4df4e$var$GRAPHQL_URL, $1e8fb63c31e3ee09$export$e4d76daee3b34319, {
        input: input
    });
    return data.productionRequestMutation.createAction;
};
const $a071e4bc84b4df4e$export$82e451b5c0315ff3 = async (id, input)=>{
    const { data: data } = await (0, $9942448fd46231b7$export$71667b1866b7607e)($a071e4bc84b4df4e$var$GRAPHQL_URL, $1e8fb63c31e3ee09$export$82fa89b4a35ff41a, {
        id: id,
        input: input
    });
    return data.productionRequestMutation.updateActionById;
};
const $a071e4bc84b4df4e$export$2e52c604a323e3c7 = async (id)=>{
    const { data: data } = await (0, $9942448fd46231b7$export$71667b1866b7607e)($a071e4bc84b4df4e$var$GRAPHQL_URL, $1e8fb63c31e3ee09$export$7be47e3cb00986fc, {
        id: id
    });
    return data.productionRequestQuery.getActionById;
};
const $a071e4bc84b4df4e$export$8a669ea5c0b42af2 = async (actionId, dynamicInput)=>{
    const { data: data } = await (0, $9942448fd46231b7$export$71667b1866b7607e)($a071e4bc84b4df4e$var$GRAPHQL_URL, $1e8fb63c31e3ee09$export$48673e45295c3dbd, {
        actionId: actionId,
        dynamicInput: dynamicInput
    });
    return data.productionRequestQuery.getOpenRequestsByActionIdAndDynamicInput;
};
const $a071e4bc84b4df4e$export$ffc4e9ae351c37c2 = async (requestId, communication)=>{
    const { data: data } = await (0, $9942448fd46231b7$export$71667b1866b7607e)($a071e4bc84b4df4e$var$GRAPHQL_URL, $1e8fb63c31e3ee09$export$1993360ec5efc787, {
        requestId: requestId,
        communication: communication
    });
    return data.productionRequestMutation.createCommunication;
};
const $a071e4bc84b4df4e$export$f0d3460cccd3ae0f = async (requestId)=>{
    const { data: data } = await (0, $9942448fd46231b7$export$71667b1866b7607e)($a071e4bc84b4df4e$var$GRAPHQL_URL, $1e8fb63c31e3ee09$export$4dee4c2144cbe866, {
        requestId: requestId
    });
    return data.productionRequestMutation.markCommunicationRead;
};
const $a071e4bc84b4df4e$export$a2f92fa225fa0c42 = async (input)=>{
    const { data: data } = await (0, $9942448fd46231b7$export$71667b1866b7607e)($a071e4bc84b4df4e$var$GRAPHQL_URL, $1e8fb63c31e3ee09$export$e154bfbb6ad5cf04, {
        input: input
    });
    return data.productionRequestQuery.getPlants;
};
const $a071e4bc84b4df4e$export$9929d57eb760c823 = async (input)=>{
    const { data: data } = await (0, $9942448fd46231b7$export$71667b1866b7607e)($a071e4bc84b4df4e$var$GRAPHQL_URL, $1e8fb63c31e3ee09$export$f4bba9a622c4dd9c, {
        input: input
    });
    return data.productionRequestMutation.createPlant;
};
const $a071e4bc84b4df4e$export$ef8e371261fb04 = async (id, input)=>{
    const { data: data } = await (0, $9942448fd46231b7$export$71667b1866b7607e)($a071e4bc84b4df4e$var$GRAPHQL_URL, $1e8fb63c31e3ee09$export$e87815d0e1e9b9e6, {
        id: id,
        input: input
    });
    return data.productionRequestMutation.updatePlantById;
};
const $a071e4bc84b4df4e$export$2d3513b99190b65f = async (id)=>{
    const { data: data } = await (0, $9942448fd46231b7$export$71667b1866b7607e)($a071e4bc84b4df4e$var$GRAPHQL_URL, $1e8fb63c31e3ee09$export$a518f15c10848ea1, {
        id: id
    });
    return data.productionRequestMutation.deletePlantById;
};
const $a071e4bc84b4df4e$export$d2142cd47377abcf = async (id, input)=>{
    const { data: data } = await (0, $9942448fd46231b7$export$71667b1866b7607e)($a071e4bc84b4df4e$var$GRAPHQL_URL, $1e8fb63c31e3ee09$export$4d827f8eda3a023e, {
        id: id,
        input: input
    });
    return data.productionRequestQuery.getLocationsByPlantId;
};
const $a071e4bc84b4df4e$export$90c043f1c57770b8 = async (input)=>{
    const { data: data } = await (0, $9942448fd46231b7$export$71667b1866b7607e)($a071e4bc84b4df4e$var$GRAPHQL_URL, $1e8fb63c31e3ee09$export$d80ec8aacf18617a, {
        input: input
    });
    return data.productionRequestMutation.createLocation;
};
const $a071e4bc84b4df4e$export$735c4579e2cd6507 = async (id, input)=>{
    const { data: data } = await (0, $9942448fd46231b7$export$71667b1866b7607e)($a071e4bc84b4df4e$var$GRAPHQL_URL, $1e8fb63c31e3ee09$export$3447021a81fbd01c, {
        id: id,
        input: input
    });
    return data.productionRequestMutation.updateLocationById;
};
const $a071e4bc84b4df4e$export$37d55cdde99fe3d6 = async (id)=>{
    const { data: data } = await (0, $9942448fd46231b7$export$71667b1866b7607e)($a071e4bc84b4df4e$var$GRAPHQL_URL, $1e8fb63c31e3ee09$export$855d0006e5a4b6a7, {
        id: id
    });
    return data.productionRequestMutation.deleteLocationById;
};
const $a071e4bc84b4df4e$export$efa92ec39e7fe36d = async (id, input)=>{
    const { data: data } = await (0, $9942448fd46231b7$export$71667b1866b7607e)($a071e4bc84b4df4e$var$GRAPHQL_URL, $1e8fb63c31e3ee09$export$ff2c0c7deeabb350, {
        id: id,
        input: input
    });
    return data.productionRequestQuery.getActionsByLocationId;
};
const $a071e4bc84b4df4e$export$f95501856a4df8a9 = async (id)=>{
    const { data: data } = await (0, $9942448fd46231b7$export$71667b1866b7607e)($a071e4bc84b4df4e$var$GRAPHQL_URL, $1e8fb63c31e3ee09$export$61ac9c2e056c6cc1, {
        id: id
    });
    return data.productionRequestMutation.deleteActionById;
};
const $a071e4bc84b4df4e$export$e6686bbd6035e86f = async (id, resourceQueues = false, input = {})=>{
    const { data: data } = await (0, $9942448fd46231b7$export$71667b1866b7607e)($a071e4bc84b4df4e$var$GRAPHQL_URL, $1e8fb63c31e3ee09$export$e5006adcc1104d38(resourceQueues), {
        id: id,
        input: input
    });
    return data.productionRequestQuery.getResourcesByPlantId;
};
const $a071e4bc84b4df4e$export$edd172c6c83c39cc = async (input)=>{
    const { data: data } = await (0, $9942448fd46231b7$export$71667b1866b7607e)($a071e4bc84b4df4e$var$GRAPHQL_URL, $1e8fb63c31e3ee09$export$8e9ab4c775719f53, {
        input: input
    });
    return data.productionRequestMutation.createResource;
};
const $a071e4bc84b4df4e$export$1301c313b2890e2d = async (id, input)=>{
    const { data: data } = await (0, $9942448fd46231b7$export$71667b1866b7607e)($a071e4bc84b4df4e$var$GRAPHQL_URL, $1e8fb63c31e3ee09$export$14d087c009633b99, {
        id: id,
        input: input
    });
    return data.productionRequestMutation.updateResourceById;
};
const $a071e4bc84b4df4e$export$993f1a5671d392dd = async (id)=>{
    const { data: data } = await (0, $9942448fd46231b7$export$71667b1866b7607e)($a071e4bc84b4df4e$var$GRAPHQL_URL, $1e8fb63c31e3ee09$export$17b0b1a7bea95396, {
        id: id
    });
    return data.productionRequestMutation.deleteResourceById;
};
const $a071e4bc84b4df4e$export$c0c5def221fc7793 = async (id, resourceQueues = false, input = {})=>{
    const { data: data } = await (0, $9942448fd46231b7$export$71667b1866b7607e)($a071e4bc84b4df4e$var$GRAPHQL_URL, $1e8fb63c31e3ee09$export$503f4170d488bde6(resourceQueues), {
        id: id,
        input: input
    });
    return data.productionRequestQuery.getQueuesByPlantId;
};
const $a071e4bc84b4df4e$export$d16acf4b6e75743d = async (input)=>{
    const { data: data } = await (0, $9942448fd46231b7$export$71667b1866b7607e)($a071e4bc84b4df4e$var$GRAPHQL_URL, $1e8fb63c31e3ee09$export$e6e836220679c86d, {
        input: input
    });
    return data.productionRequestMutation.createQueue;
};
const $a071e4bc84b4df4e$export$5c45cd521309cc77 = async (id, input)=>{
    const { data: data } = await (0, $9942448fd46231b7$export$71667b1866b7607e)($a071e4bc84b4df4e$var$GRAPHQL_URL, $1e8fb63c31e3ee09$export$a912795cf44b791b, {
        id: id,
        input: input
    });
    return data.productionRequestMutation.updateQueueById;
};
const $a071e4bc84b4df4e$export$6bff37bb7ab08094 = async (id)=>{
    const { data: data } = await (0, $9942448fd46231b7$export$71667b1866b7607e)($a071e4bc84b4df4e$var$GRAPHQL_URL, $1e8fb63c31e3ee09$export$5ab05b9e296b458f, {
        id: id
    });
    return data.productionRequestMutation.deleteQueueById;
};
const $a071e4bc84b4df4e$export$77c7c7ff730bf4d0 = async (resourceId)=>{
    const { data: data } = await (0, $9942448fd46231b7$export$71667b1866b7607e)($a071e4bc84b4df4e$var$GRAPHQL_URL, $1e8fb63c31e3ee09$export$3be3ffc90c087880, {
        resourceId: resourceId
    });
    return data.productionRequestQuery.getQueuesByResourceId;
};
const $a071e4bc84b4df4e$export$181ef56982321e10 = async (input)=>{
    const { data: data } = await (0, $9942448fd46231b7$export$71667b1866b7607e)($a071e4bc84b4df4e$var$GRAPHQL_URL, $1e8fb63c31e3ee09$export$9efb16956bb63482, {
        input: input
    });
    return data.productionRequestQuery.getResourceQueues;
};
const $a071e4bc84b4df4e$export$5789ae15bc578a22 = async (input)=>{
    const { data: data } = await (0, $9942448fd46231b7$export$71667b1866b7607e)($a071e4bc84b4df4e$var$GRAPHQL_URL, $1e8fb63c31e3ee09$export$67f1197e9f2111e7, {
        input: input
    });
    return data.productionRequestMutation.createResourceQueue;
};
const $a071e4bc84b4df4e$export$f5132f0087ad7c66 = async (queueId, resourceId, input)=>{
    const { data: data } = await (0, $9942448fd46231b7$export$71667b1866b7607e)($a071e4bc84b4df4e$var$GRAPHQL_URL, $1e8fb63c31e3ee09$export$797f78767dd8a4cc, {
        queueId: queueId,
        resourceId: resourceId,
        input: input
    });
    return data.productionRequestMutation.updateResourceQueueById;
};
const $a071e4bc84b4df4e$export$fed3fc2161821fd7 = async (variables)=>{
    const { data: data } = await (0, $9942448fd46231b7$export$71667b1866b7607e)($a071e4bc84b4df4e$var$GRAPHQL_URL, $1e8fb63c31e3ee09$export$d9d9c61d2637408e, variables);
    return data.productionRequestMutation.deleteResourceQueueById;
};
const $a071e4bc84b4df4e$export$6d390088810038ce = async (resourceId, status)=>{
    const { data: data } = await (0, $9942448fd46231b7$export$71667b1866b7607e)($a071e4bc84b4df4e$var$GRAPHQL_URL, $1e8fb63c31e3ee09$export$f407cac8ed1f39fa, {
        resourceId: resourceId,
        status: status
    });
    return data.productionRequestQuery.getRequestsByResourceId;
};
const $a071e4bc84b4df4e$export$8a9ccc4bf4a5d5c6 = async (resourceId)=>{
    const { data: data } = await (0, $9942448fd46231b7$export$71667b1866b7607e)($a071e4bc84b4df4e$var$GRAPHQL_URL, $1e8fb63c31e3ee09$export$1a19e4b15e09b60c, {
        resourceId: resourceId
    });
    return data.productionRequestQuery.getCompletedRequestsByResourceId;
};
const $a071e4bc84b4df4e$export$9238c8204b02b160 = async (locationId)=>{
    const { data: data } = await (0, $9942448fd46231b7$export$71667b1866b7607e)($a071e4bc84b4df4e$var$GRAPHQL_URL, $1e8fb63c31e3ee09$export$99173c7bcff6c3c5, {
        locationId: locationId
    });
    return data.productionRequestQuery.getRequestsByLocationIdByStatus;
};
const $a071e4bc84b4df4e$export$9b1644f328a22a85 = async (locationId)=>{
    const { data: data } = await (0, $9942448fd46231b7$export$71667b1866b7607e)($a071e4bc84b4df4e$var$GRAPHQL_URL, $1e8fb63c31e3ee09$export$804ed697b67b9cd5, {
        locationId: locationId
    });
    return data.productionRequestQuery.getCompletedRequestsByLocationIdByStatus;
};
const $a071e4bc84b4df4e$export$72e3afa9ac8966be = async (input)=>{
    const { data: data } = await (0, $9942448fd46231b7$export$71667b1866b7607e)($a071e4bc84b4df4e$var$GRAPHQL_URL, $1e8fb63c31e3ee09$export$ad5fb8b7cdde24d7, {
        input: input
    });
    return data.productionRequestMutation.createRequest;
};
const $a071e4bc84b4df4e$export$2d9e9f326aa75fc3 = async (id, input)=>{
    const { data: data } = await (0, $9942448fd46231b7$export$71667b1866b7607e)($a071e4bc84b4df4e$var$GRAPHQL_URL, $1e8fb63c31e3ee09$export$d083f9fbdb3d0263, {
        id: id,
        input: input
    });
    return data.productionRequestMutation.updateRequestById;
};
const $a071e4bc84b4df4e$export$8451969e2bff5cfe = async (id)=>{
    const { data: data } = await (0, $9942448fd46231b7$export$71667b1866b7607e)($a071e4bc84b4df4e$var$GRAPHQL_URL, $1e8fb63c31e3ee09$export$fabd6011ddd9a45f, {
        id: id
    });
    return data.productionRequestQuery.getSelectionListsByPlantId;
};
const $a071e4bc84b4df4e$export$990bfd1484c54279 = async (input)=>{
    const { data: data } = await (0, $9942448fd46231b7$export$71667b1866b7607e)($a071e4bc84b4df4e$var$GRAPHQL_URL, $1e8fb63c31e3ee09$export$45be44e248e8e0db, {
        input: input
    });
    return data.productionRequestMutation.createSelectionList;
};
const $a071e4bc84b4df4e$export$f0555cd430f5d55a = async (id, input)=>{
    const { data: data } = await (0, $9942448fd46231b7$export$71667b1866b7607e)($a071e4bc84b4df4e$var$GRAPHQL_URL, $1e8fb63c31e3ee09$export$134c932bccff9b0b, {
        id: id,
        input: input
    });
    return data.productionRequestMutation.updateSelectionListById;
};
const $a071e4bc84b4df4e$export$ea53d545a92e34d5 = async (id)=>{
    const { data: data } = await (0, $9942448fd46231b7$export$71667b1866b7607e)($a071e4bc84b4df4e$var$GRAPHQL_URL, $1e8fb63c31e3ee09$export$d93b4bd3b13c94de, {
        id: id
    });
    return data.productionRequestMutation.deleteSelectionListById;
};
const $a071e4bc84b4df4e$export$629a8867a04fa611 = async (input)=>{
    const { data: data } = await (0, $9942448fd46231b7$export$71667b1866b7607e)($a071e4bc84b4df4e$var$GRAPHQL_URL, $1e8fb63c31e3ee09$export$dc703cfb7bb0f209, {
        input: input
    });
    return data.productionRequestMutation.createSelectionListValue;
};
const $a071e4bc84b4df4e$export$ac74f3f842eeeefa = async (id, input)=>{
    const { data: data } = await (0, $9942448fd46231b7$export$71667b1866b7607e)($a071e4bc84b4df4e$var$GRAPHQL_URL, $1e8fb63c31e3ee09$export$f3bdd5c58a84d585, {
        id: id,
        input: input
    });
    return data.productionRequestMutation.updateSelectionListValueById;
};
const $a071e4bc84b4df4e$export$843b87254ce4ea24 = async (id)=>{
    const { data: data } = await (0, $9942448fd46231b7$export$71667b1866b7607e)($a071e4bc84b4df4e$var$GRAPHQL_URL, $1e8fb63c31e3ee09$export$8183d4492af7b852, {
        id: id
    });
    return data.productionRequestMutation.deleteSelectionListValueById;
};
const $a071e4bc84b4df4e$export$971d4dbc201e12e0 = async (id)=>{
    const { data: data } = await (0, $9942448fd46231b7$export$71667b1866b7607e)($a071e4bc84b4df4e$var$GRAPHQL_URL, $1e8fb63c31e3ee09$export$20a335504c5b6ada, {
        id: id
    });
    return data.productionRequestQuery.getDispositionsByPlantId;
};
const $a071e4bc84b4df4e$export$de78b545984525e2 = async ()=>{
    const { data: data } = await (0, $9942448fd46231b7$export$71667b1866b7607e)($a071e4bc84b4df4e$var$GRAPHQL_URL, $1e8fb63c31e3ee09$export$475af00ba99d61cf);
    return data.productionRequestQuery.getCarrierList;
};
const $a071e4bc84b4df4e$export$1f34b46153724837 = async (input)=>{
    const { data: data } = await (0, $9942448fd46231b7$export$71667b1866b7607e)($a071e4bc84b4df4e$var$GRAPHQL_URL, $1e8fb63c31e3ee09$export$a3e666e5c2b7b356, {
        input: input
    });
    return data.productionRequestMutation.createTrailerToDockTransaction;
};
const $a071e4bc84b4df4e$export$ff7a0e8f43d7b3cb = async ({ organizationId: organizationId, item: item })=>{
    const { data: data } = await (0, $9942448fd46231b7$export$71667b1866b7607e)($a071e4bc84b4df4e$var$GRAPHQL_URL, $1e8fb63c31e3ee09$export$eeff4248505ccd8a, {
        organizationId: organizationId,
        item: item
    });
    return data.productionRequestQuery.getInventoryItemIdByPlant;
};
const $a071e4bc84b4df4e$export$10896e2c9d6eb5c2 = async (input)=>{
    const { data: data } = await (0, $9942448fd46231b7$export$71667b1866b7607e)($a071e4bc84b4df4e$var$GRAPHQL_URL, $1e8fb63c31e3ee09$export$96097c6757be0fb5, input);
    return data.productionRequestQuery.getSubinventoryCodesByPlant;
};
const $a071e4bc84b4df4e$export$13365513656e9f7a = async ({ organizationId: organizationId, inventoryItemId: inventoryItemId, subinventoryCode: subinventoryCode })=>{
    const { data: data } = await (0, $9942448fd46231b7$export$71667b1866b7607e)($a071e4bc84b4df4e$var$GRAPHQL_URL, $1e8fb63c31e3ee09$export$790abd8d67f77fab, {
        organizationId: organizationId,
        inventoryItemId: inventoryItemId,
        subinventoryCode: subinventoryCode
    });
    return data.productionRequestQuery.getSubinventoryInfoByPlant;
};
const $a071e4bc84b4df4e$export$d6fa77d10def9dfe = async ({ organizationId: organizationId, subinventoryCode: subinventoryCode, inventoryItemId: inventoryItemId })=>{
    const { data: data } = await (0, $9942448fd46231b7$export$71667b1866b7607e)($a071e4bc84b4df4e$var$GRAPHQL_URL, $1e8fb63c31e3ee09$export$95da18d3c20a73b1, {
        organizationId: organizationId,
        subinventoryCode: subinventoryCode,
        inventoryItemId: inventoryItemId
    });
    return data.productionRequestQuery.getLocators;
};







const $e733424c31ecfe53$export$b22ebc4820923ca5 = (active)=>{
    const { apiReady: apiReady } = (0, $10608212fc1ea215$export$a826e754a2b6b403)();
    const { selectedPlant: selectedPlant } = (0, $4e4c6c71fc2aaac8$export$fdc397e486fa83e7)();
    const { setSelectedPlant: setSelectedPlant } = (0, $1b0a542caa3229ca$export$b91a5355c3a5f338)();
    const { data: organizations } = (0, $b75393bd8a70fa20$export$5fc38fde58f5cf66)();
    return (0, $5b47d34ec35eb825$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).PLANT_DATA,
            {
                active: active
            },
            setSelectedPlant,
            selectedPlant
        ],
        queryFn: async ()=>{
            const plants = await (0, $a071e4bc84b4df4e$export$a2f92fa225fa0c42)(active ? {
                active: active
            } : undefined);
            // If no data is returned or the selected plant is not found, reset the selected plant
            if (!plants?.length || !plants?.find((plant)=>plant.id === selectedPlant)) setSelectedPlant('');
            return plants;
        },
        select: (plants)=>plants.map((plant)=>({
                    ...plant,
                    organizationName: organizations?.find((org)=>org.organizationId === plant.organizationId)?.description || ''
                })),
        staleTime: Infinity,
        enabled: Boolean(apiReady && organizations)
    });
};




var $lCzvA = parcelRequire("lCzvA");




//#region src/mutationObserver.ts
/**
* Observes a single mutation and derives a `MutationObserverResult` from it.
* A framework hook like `useMutation` creates one `MutationObserver` per hook
* call, keeps it stable across re-renders, calls `setOptions` when the options
* passed to the hook change, subscribes to it to re-render on updates, and
* reads `getCurrentResult()` for the value to return. Calling `mutate()`
* builds a new underlying `Mutation` in the `MutationCache` and executes it.
* @example
* ```ts
* const observer = new MutationObserver(queryClient, {
*   mutationFn: (variables: { title: string }) => addPost(variables),
* })
* ```
*/ var $90d8998e5ea18cd1$export$d3c1860ee66f291a = class extends (0, $b384e87d93fd3677$export$d26086b469ecdbcc) {
    #client;
    #currentResult = void 0;
    #currentMutation;
    #mutateOptions;
    constructor(client, options){
        super();
        this.#client = client;
        this.setOptions(options);
        this.bindMethods();
        this.#updateResult();
    }
    /**
	* Binds the methods of the result (`mutate` and `reset`) to the observer, so they keep working when
	* destructured from it.
	*/ bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    }
    /**
	* Updates the observer's options.
	*
	* If the new `mutationKey` differs from the previous one (and both were
	* defined), the observer is reset, detaching it from the mutation it was
	* observing. Otherwise, if the currently observed mutation is still
	* `pending`, its options are updated in place as well.
	* @param options - The new mutation observer options. They are defaulted with {@link
	* QueryClient#defaultMutationOptions} before being applied.
	* @example
	* ```ts
	* observer.setOptions({
	*   mutationFn: (variables: { title: string }) => addPost(variables),
	*   onSuccess: (data) => console.log(data),
	* })
	* ```
	*/ setOptions(options) {
        const prevOptions = this.options;
        this.options = this.#client.defaultMutationOptions(options);
        if (!(0, $d14a518110a15ba8$export$3e67810a3f0e9f1c)(this.options, prevOptions)) this.#client.getMutationCache().notify({
            type: "observerOptionsUpdated",
            mutation: this.#currentMutation,
            observer: this
        });
        if (prevOptions?.mutationKey && this.options.mutationKey && (0, $d14a518110a15ba8$export$1e87d19d4aab5805)(prevOptions.mutationKey) !== (0, $d14a518110a15ba8$export$1e87d19d4aab5805)(this.options.mutationKey)) this.reset();
        else if (this.#currentMutation?.state.status === "pending") this.#currentMutation.setOptions(this.options);
    }
    onSubscribe() {
        if (this.listeners.size === 1 && this.#currentMutation) {
            this.#currentMutation.addObserver(this);
            this.#updateResult();
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.#currentMutation?.removeObserver(this);
    }
    /**
	* Updates the observer's result when the observed mutation changes, and notifies its listeners.
	* @internal
	* @param action - The action that updated the observed mutation, passed on to the observer's
	* callbacks.
	*/ onMutationUpdate(action) {
        this.#updateResult();
        this.#notify(action);
    }
    /**
	* Returns the observer's current result, derived from the observed
	* mutation's state (or the default, `idle` state if no mutation has been
	* built yet, e.g. before the first `mutate()` call or after `reset()`).
	* @returns The observer's latest result.
	*/ getCurrentResult() {
        return this.#currentResult;
    }
    /**
	* Detaches the observer from the mutation it is currently observing (if
	* any) and resets the observed result back to its default, `idle` state.
	*
	* This does not cancel an in-flight mutation; the mutation itself keeps
	* running to completion and its own callbacks still fire, but this
	* observer stops reflecting its state and a subsequent `mutate()` call
	* will build a brand new mutation.
	* @see {@link MutationObserver#mutate}
	* @example
	* ```ts
	* observer.reset()
	* ```
	*/ reset() {
        this.#currentMutation?.removeObserver(this);
        this.#currentMutation = void 0;
        this.#updateResult();
        this.#notify();
    }
    /**
	* Builds a new `Mutation` in the `MutationCache` using the observer's
	* current options, detaches this observer from any previously observed
	* mutation, attaches it to the new one, and executes it with the given
	* variables.
	*
	* The optional per-call `options` (`onSuccess`/`onError`/`onSettled`) are
	* invoked once the mutation settles, in addition to any callbacks defined
	* on the observer's own options.
	* @param variables - The variables passed to the `mutationFn`.
	* @param options - Per-call `onSuccess`, `onError`, and `onSettled` callbacks.
	* @returns A promise that resolves with the mutation's data, or rejects with its error.
	* @example
	* ```ts
	* await observer.mutate(
	*   { title: 'New post' },
	*   { onSuccess: (data) => console.log(data) },
	* )
	* ```
	*/ mutate(variables, options) {
        this.#mutateOptions = options;
        this.#currentMutation?.removeObserver(this);
        this.#currentMutation = this.#client.getMutationCache().build(this.#client, this.options);
        this.#currentMutation.addObserver(this);
        return this.#currentMutation.execute(variables);
    }
    #updateResult() {
        const state = this.#currentMutation?.state ?? (0, $d16c703e36c412d3$export$a1659b54bac3252a)();
        this.#currentResult = {
            ...state,
            isPending: state.status === "pending",
            isSuccess: state.status === "success",
            isError: state.status === "error",
            isIdle: state.status === "idle",
            mutate: this.mutate,
            reset: this.reset
        };
    }
    #notify(action) {
        (0, $7214f1c3bd8e29e6$export$520687f44db6e1ab).batch(()=>{
            const mutateOptions = this.#mutateOptions;
            if (mutateOptions && this.hasListeners()) {
                const variables = this.#currentResult.variables;
                const onMutateResult = this.#currentResult.context;
                const context = {
                    client: this.#client,
                    meta: this.options.meta,
                    mutationKey: this.options.mutationKey
                };
                if (action?.type === "success") {
                    try {
                        mutateOptions.onSuccess?.(action.data, variables, onMutateResult, context);
                    } catch (e) {
                        Promise.reject(e);
                    }
                    try {
                        mutateOptions.onSettled?.(action.data, null, variables, onMutateResult, context);
                    } catch (e) {
                        Promise.reject(e);
                    }
                } else if (action?.type === "error") {
                    try {
                        mutateOptions.onError?.(action.error, variables, onMutateResult, context);
                    } catch (e) {
                        Promise.reject(e);
                    }
                    try {
                        mutateOptions.onSettled?.(void 0, action.error, variables, onMutateResult, context);
                    } catch (e) {
                        Promise.reject(e);
                    }
                }
            }
            this.listeners.forEach((listener)=>{
                listener(this.#currentResult);
            });
        });
    }
};


"use client";
//#region src/useMutation.ts
/**
* Unlike queries, mutations are typically used to create/update/delete data or perform server side-effects.
* `useMutation` is the hook for that.
* @param options - The {@link UseMutationOptions} to use — everything you can pass to `useMutation`.
* @param queryClient - Use this to use a custom `QueryClient`. Otherwise, the one from the nearest context will
* be used.
* @returns `mutate`/`mutateAsync` also accept per-call `onSuccess`/`onError`/`onSettled` callbacks as a second
* argument, useful for triggering call-site side effects (e.g. navigation) without coupling them to the shared
* mutation definition. Hook-level callbacks (passed to `options`) fire for every mutation; per-call callbacks
* fire only for the latest call you've made, and only while the component is still mounted — unmounting before
* the mutation settles removes the subscription and prevents them from firing.
* @throws {Error} The mutation error, when `throwOnError` is `true` or returns `true` for it, so that it is
* thrown to the nearest error boundary.
* @see {@link mutationOptions} to share these options across multiple `useMutation` call sites, or to look
* the mutation up elsewhere via its `mutationKey` (e.g. with `useMutationState`).
* @example
* ```tsx
* import { useMutation, useQueryClient } from '@tanstack/react-query'
*
* function AddTodo() {
*   const queryClient = useQueryClient()
*
*   const addMutation = useMutation({
*     mutationFn: addTodo,
*     onSuccess: () => queryClient.invalidateQueries({ queryKey: ['todos'] }),
*   })
*
*   return (
*     <button
*       onClick={() =>
*         addMutation.mutate('Item', {
*           onError: (error) => console.error('Failed to add item:', error),
*         })
*       }
*     >
*       Add
*     </button>
*   )
* }
* ```
* @example
* Rendering the mutation's own state, rather than just firing it off:
* ```tsx
* import { useMutation, useQueryClient } from '@tanstack/react-query'
*
* function AddTodo() {
*   const queryClient = useQueryClient()
*
*   const addMutation = useMutation({
*     mutationFn: addTodo,
*     onSuccess: () => queryClient.invalidateQueries({ queryKey: ['todos'] }),
*   })
*
*   return (
*     <div>
*       {addMutation.isPending ? (
*         'Adding todo...'
*       ) : (
*         <>
*           {addMutation.isError ? (
*             <div>An error occurred: {addMutation.error.message}</div>
*           ) : null}
*           <button onClick={() => addMutation.mutate('Item')}>Add</button>
*         </>
*       )}
*     </div>
*   )
* }
* ```
* @example
* Optimistic update via `onMutate`, rolling back on `onError`:
* ```tsx
* import { useMutation, useQueryClient } from '@tanstack/react-query'
*
* function AddTodo() {
*   const queryClient = useQueryClient()
*
*   const addMutation = useMutation({
*     mutationFn: addTodo,
*     onMutate: async (newTodo) => {
*       await queryClient.cancelQueries({ queryKey: ['todos'] })
*       const previousTodos = queryClient.getQueryData<Array<string>>(['todos'])
*
*       queryClient.setQueryData<Array<string>>(['todos'], (old) => [
*         ...(old ?? []),
*         newTodo,
*       ])
*
*       // Passed to `onError` as `onMutateResult` if the mutation fails.
*       return { previousTodos }
*     },
*     onError: (_err, _newTodo, onMutateResult) => {
*       queryClient.setQueryData(['todos'], onMutateResult?.previousTodos)
*     },
*     onSettled: () => {
*       queryClient.invalidateQueries({ queryKey: ['todos'] })
*     },
*   })
*
*   return (
*     <button onClick={() => addMutation.mutate('Item')}>Add</button>
*   )
* }
* ```
* @example
* Callbacks passed per call to `mutate` only fire for the last call — `mutateAsync` gives you a
* promise per call instead, so you can wait for all of them when they succeed:
* ```tsx
* import { useMutation, useQueryClient } from '@tanstack/react-query'
*
* function AddTodos() {
*   const queryClient = useQueryClient()
*
*   const addMutation = useMutation({
*     mutationFn: addTodo,
*     onSuccess: () => queryClient.invalidateQueries({ queryKey: ['todos'] }),
*   })
*
*   async function handleAddAll(todos: Array<string>) {
*     try {
*       await Promise.all(todos.map((todo) => addMutation.mutateAsync(todo)))
*     } catch (error) {
*       console.error('Failed to add todos:', error)
*     }
*   }
*
*   return (
*     <button onClick={() => handleAddAll(['Todo 1', 'Todo 2', 'Todo 3'])}>
*       Add all
*     </button>
*   )
* }
* ```
* @example
* If some of the mutations above can fail independently of the others, and you want to know which ones
* did — rather than losing that information the moment the first one rejects — swap `Promise.all` for
* `Promise.allSettled`:
* ```tsx
* import { useMutation, useQueryClient } from '@tanstack/react-query'
*
* function AddTodos() {
*   const queryClient = useQueryClient()
*
*   const addMutation = useMutation({
*     mutationFn: addTodo,
*     onSuccess: () => queryClient.invalidateQueries({ queryKey: ['todos'] }),
*   })
*
*   async function handleAddAll(todos: Array<string>) {
*     const addResults = await Promise.allSettled(
*       todos.map((todo) => addMutation.mutateAsync(todo)),
*     )
*
*     addResults.forEach((addResult, index) => {
*       if (addResult.status === 'rejected') {
*         console.error(`Failed to add "${todos[index]}":`, addResult.reason)
*       }
*     })
*   }
*
*   return (
*     <button onClick={() => handleAddAll(['Todo 1', 'Todo 2', 'Todo 3'])}>
*       Add all
*     </button>
*   )
* }
* ```
*/ function $506026961de7ab1a$export$609860bf8b0084c(options, queryClient) {
    const client = (0, $6547bc15d23e8c33$export$22e77b9572c4fded)(queryClient);
    const [observer] = $lCzvA.useState(()=>new (0, $90d8998e5ea18cd1$export$d3c1860ee66f291a)(client, options));
    $lCzvA.useEffect(()=>{
        observer.setOptions(options);
    }, [
        observer,
        options
    ]);
    const result = $lCzvA.useSyncExternalStore($lCzvA.useCallback((onStoreChange)=>observer.subscribe((0, $7214f1c3bd8e29e6$export$520687f44db6e1ab).batchCalls(onStoreChange)), [
        observer
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    const mutate = $lCzvA.useCallback((...args)=>{
        observer.mutate(args[0], args[1]).catch((0, $d14a518110a15ba8$export$8793edee2d425525));
    }, [
        observer
    ]);
    if (result.error && (0, $d14a518110a15ba8$export$2072f68e6c3507cf)(observer.options.throwOnError, [
        result.error
    ])) throw result.error;
    return {
        ...result,
        mutate: mutate,
        mutateAsync: result.mutate
    };
}





const $63e4bd9659ac6675$export$f45c95aff449d4a0 = ()=>{
    const queryClient = (0, $6547bc15d23e8c33$export$22e77b9572c4fded)();
    return (0, $506026961de7ab1a$export$609860bf8b0084c)({
        /**
     * mutateFn - Function to call createPlant.
     * @param {Pella.ProductionRequestAPI.CreatePlantInput} input - The inputs for creating the Plant.
     */ mutationFn: (input)=>(0, $a071e4bc84b4df4e$export$9929d57eb760c823)(input),
        onSuccess: ()=>{
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).success('Plant created successfully!');
            queryClient.invalidateQueries({
                queryKey: [
                    (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).PLANT_DATA
                ]
            });
        }
    });
};






const $b407499c949b079d$export$4a9ddee008a7c0ec = ()=>{
    const queryClient = (0, $6547bc15d23e8c33$export$22e77b9572c4fded)();
    return (0, $506026961de7ab1a$export$609860bf8b0084c)({
        /**
     * mutateFn - Function to call updatePlant.
     * @param {object} params
     * @param {Pella.ProductionRequestAPI.Plant['id']} params.id - The ID of the Plant to update.
     * @param {Pella.ProductionRequestAPI.UpdatePlantInput} params.input - The inputs for updating the Plant.
     */ mutationFn: ({ id: id, input: input })=>(0, $a071e4bc84b4df4e$export$ef8e371261fb04)(id, input),
        onSuccess: ()=>{
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).dismiss();
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).success('Plant updated successfully!');
            queryClient.invalidateQueries({
                queryKey: [
                    (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).PLANT_DATA
                ]
            });
        }
    });
};






const $c86bf138ad35f3bc$export$865ab547b393ab8c = ()=>{
    const queryClient = (0, $6547bc15d23e8c33$export$22e77b9572c4fded)();
    return (0, $506026961de7ab1a$export$609860bf8b0084c)({
        /**
     * mutateFn - Function to call deletePlant.
     * @param {Pella.ProductionRequestAPI.Plant['id']} id - The ID of the Plant to delete.
     */ mutationFn: (id)=>(0, $a071e4bc84b4df4e$export$2d3513b99190b65f)(id),
        onSuccess: ()=>{
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).success('Plant deleted successfully!');
            queryClient.invalidateQueries({
                queryKey: [
                    (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).PLANT_DATA
                ]
            });
        }
    });
};






const $1b0a542caa3229ca$export$b91a5355c3a5f338 = ()=>{
    const dispatch = (0, $4e4c6c71fc2aaac8$export$f51d452c10d5b956)();
    const { selectedPlant: selectedPlant } = (0, $4e4c6c71fc2aaac8$export$fdc397e486fa83e7)();
    const { setSelectedResource: setSelectedResource } = (0, $500bdbf4a0f447e9$export$250206752f624cd4)();
    const { setSelectedLocation: setSelectedLocation } = (0, $cfa58d15f42b8895$export$4ace3aee3488cfe3)();
    /**
   * Set the selected plant and persist it
   * @param {string} payload - The plant identifier to select
   */ const setSelectedPlant = (payload)=>{
        dispatch({
            type: $3b086af55ffdafb7$export$6200b0fc719be580,
            payload: payload
        });
        localStorage.setItem($3b086af55ffdafb7$export$6200b0fc719be580, payload);
        setSelectedResource(''); // reset selected resource when plant changes
        setSelectedLocation(''); // reset selected location when plant changes
    };
    return {
        selectedPlant: selectedPlant,
        setSelectedPlant: setSelectedPlant
    };
};





const $500bdbf4a0f447e9$export$250206752f624cd4 = ()=>{
    const dispatch = (0, $4e4c6c71fc2aaac8$export$f51d452c10d5b956)();
    const { selectedResource: selectedResource } = (0, $4e4c6c71fc2aaac8$export$fdc397e486fa83e7)();
    /**
   * Set the selected resource and persist it
   * @param {string} payload - The resource identifier to select
   */ const setSelectedResource = (payload)=>{
        dispatch({
            type: $3b086af55ffdafb7$export$b37f59cc4aa98af8,
            payload: payload
        });
        localStorage.setItem($3b086af55ffdafb7$export$b37f59cc4aa98af8, payload);
    };
    return {
        selectedResource: selectedResource,
        setSelectedResource: setSelectedResource
    };
};





const $cfa58d15f42b8895$export$4ace3aee3488cfe3 = ()=>{
    const dispatch = (0, $4e4c6c71fc2aaac8$export$f51d452c10d5b956)();
    const { selectedLocation: selectedLocation } = (0, $4e4c6c71fc2aaac8$export$fdc397e486fa83e7)();
    /**
   * Set the selected location and persist it
   * @param {string} payload - The location identifier to select
   */ const setSelectedLocation = (payload)=>{
        dispatch({
            type: $3b086af55ffdafb7$export$172e4f9a1fb1ffbf,
            payload: payload
        });
        localStorage.setItem($3b086af55ffdafb7$export$172e4f9a1fb1ffbf, payload);
    };
    return {
        selectedLocation: selectedLocation,
        setSelectedLocation: setSelectedLocation
    };
};







const $e092467f6f60ca40$export$8535247f55db5d21 = (active, plant)=>{
    const { apiReady: apiReady } = (0, $10608212fc1ea215$export$a826e754a2b6b403)();
    const { selectedPlant: selectedPlant } = (0, $4e4c6c71fc2aaac8$export$fdc397e486fa83e7)();
    const effectivePlant = plant || selectedPlant;
    return (0, $5b47d34ec35eb825$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).LOCATION_DATA,
            effectivePlant,
            {
                active: active
            }
        ],
        queryFn: async ()=>{
            const locations = await (0, $a071e4bc84b4df4e$export$d2142cd47377abcf)(effectivePlant, active ? {
                active: active
            } : undefined);
            return locations;
        },
        staleTime: Infinity,
        enabled: Boolean(apiReady && effectivePlant)
    });
};






const $d704b2ee256efc5a$export$8ae537f4e8345e78 = ()=>{
    const queryClient = (0, $6547bc15d23e8c33$export$22e77b9572c4fded)();
    return (0, $506026961de7ab1a$export$609860bf8b0084c)({
        /**
     * mutateFn - Function to call createLocation.
     * @param {Pella.ProductionRequestAPI.CreateLocationInput} input - The inputs for creating the Location.
     */ mutationFn: (input)=>(0, $a071e4bc84b4df4e$export$90c043f1c57770b8)(input),
        onSuccess: ()=>{
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).success('Location created successfully!');
            queryClient.invalidateQueries({
                queryKey: [
                    (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).LOCATION_DATA
                ]
            });
        }
    });
};






const $b7bcf9b08c831303$export$688166aaa79cd43b = ()=>{
    const queryClient = (0, $6547bc15d23e8c33$export$22e77b9572c4fded)();
    return (0, $506026961de7ab1a$export$609860bf8b0084c)({
        /**
     * mutateFn - Function to call updateLocation.
     * @param {object} params
     * @param {Pella.ProductionRequestAPI.Location['id']} params.id - The ID of the Location to update.
     * @param {Pella.ProductionRequestAPI.UpdateLocationInput} params.input - The inputs for updating the Location.
     */ mutationFn: ({ id: id, input: input })=>(0, $a071e4bc84b4df4e$export$735c4579e2cd6507)(id, input),
        onSuccess: ()=>{
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).dismiss();
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).success('Location updated successfully!');
            queryClient.invalidateQueries({
                queryKey: [
                    (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).LOCATION_DATA
                ]
            });
        }
    });
};






const $21bbbbd39c4f813f$export$9b88d04e330e1145 = ()=>{
    const queryClient = (0, $6547bc15d23e8c33$export$22e77b9572c4fded)();
    return (0, $506026961de7ab1a$export$609860bf8b0084c)({
        /**
     * mutateFn - Function to call deletePlant.
     * @param {Pella.ProductionRequestAPI.Location['id']} id - The ID of the Location to delete.
     */ mutationFn: (id)=>(0, $a071e4bc84b4df4e$export$37d55cdde99fe3d6)(id),
        onSuccess: ()=>{
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).success('Location deleted successfully!');
            queryClient.invalidateQueries({
                queryKey: [
                    (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).LOCATION_DATA
                ]
            });
        }
    });
};






const $ecb41dbe4a35b139$export$ff160b5aaceed0b9 = (selectedPlant, resourceQueues)=>{
    const { apiReady: apiReady } = (0, $10608212fc1ea215$export$a826e754a2b6b403)();
    return (0, $5b47d34ec35eb825$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).QUEUE_DATA,
            selectedPlant,
            {
                resourceQueues: resourceQueues
            }
        ],
        queryFn: ()=>(0, $a071e4bc84b4df4e$export$c0c5def221fc7793)(selectedPlant, resourceQueues),
        select: (data)=>{
            let newData = [];
            if (resourceQueues) newData = data.map((queue)=>{
                if (queue?.resourceQueues?.length) return {
                    ...queue,
                    resourceQueues: queue.resourceQueues.map((rq)=>({
                            ...rq,
                            id: rq.resourceId,
                            description: rq.resource.description
                        }))
                };
                return {
                    ...queue,
                    resourceQueues: []
                };
            });
            return newData.length ? newData : data;
        },
        staleTime: Infinity,
        enabled: Boolean(apiReady && selectedPlant)
    });
};






const $575b64f7cab074ca$export$b59e9c7b8e1f0c44 = ()=>{
    const queryClient = (0, $6547bc15d23e8c33$export$22e77b9572c4fded)();
    return (0, $506026961de7ab1a$export$609860bf8b0084c)({
        /**
     * mutateFn - Function to call createQueue.
     * @param {Pella.ProductionRequestAPI.CreateQueueInput} input - The inputs for creating the Queue.
     */ mutationFn: (input)=>(0, $a071e4bc84b4df4e$export$d16acf4b6e75743d)(input),
        onSuccess: ()=>{
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).success('Queue created successfully!');
            queryClient.invalidateQueries({
                queryKey: [
                    (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).QUEUE_DATA
                ]
            });
        }
    });
};







const $a47684000ca9987d$export$69834bcee82719ce = ()=>{
    const queryClient = (0, $6547bc15d23e8c33$export$22e77b9572c4fded)();
    const { selectedPlant: selectedPlant } = (0, $4e4c6c71fc2aaac8$export$fdc397e486fa83e7)();
    return (0, $506026961de7ab1a$export$609860bf8b0084c)({
        /**
     * mutateFn - Function to call updateQueue.
     * @param {object} params
     * @param {Pella.ProductionRequestAPI.Plant['id']} params.id - The ID of the Queue to update.
     * @param {Pella.ProductionRequestAPI.UpdateQueueInput} params.input - The inputs for updating the Queue.
     */ mutationFn: ({ id: id, input: input })=>(0, $a071e4bc84b4df4e$export$5c45cd521309cc77)(id, input),
        onSuccess: ()=>{
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).dismiss();
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).success('Queue updated successfully!');
            queryClient.invalidateQueries({
                queryKey: [
                    (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).QUEUE_DATA,
                    selectedPlant
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).RESOURCE_DATA,
                    selectedPlant
                ]
            });
        }
    });
};







const $9ee95f97085fb71e$export$357416935d68a29b = ()=>{
    const queryClient = (0, $6547bc15d23e8c33$export$22e77b9572c4fded)();
    const { selectedPlant: selectedPlant } = (0, $4e4c6c71fc2aaac8$export$fdc397e486fa83e7)();
    return (0, $506026961de7ab1a$export$609860bf8b0084c)({
        /**
     * mutateFn - Function to call deleteQueue.
     * @param {Pella.ProductionRequestAPI.Queue['id']} id - The ID of the Queue to delete.
     */ mutationFn: (id)=>(0, $a071e4bc84b4df4e$export$6bff37bb7ab08094)(id),
        onSuccess: ()=>{
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).success('Queue deleted successfully!');
            queryClient.invalidateQueries({
                queryKey: [
                    (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).QUEUE_DATA,
                    selectedPlant
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).RESOURCE_DATA,
                    selectedPlant
                ]
            });
        }
    });
};








const $28b80451f4b2a75b$export$4e85cc9b40c906e6 = (resourceQueues, active)=>{
    const { apiReady: apiReady } = (0, $10608212fc1ea215$export$a826e754a2b6b403)();
    const { selectedPlant: selectedPlant } = (0, $4e4c6c71fc2aaac8$export$fdc397e486fa83e7)();
    const { setSelectedResource: setSelectedResource } = (0, $500bdbf4a0f447e9$export$250206752f624cd4)();
    return (0, $5b47d34ec35eb825$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).RESOURCE_DATA,
            selectedPlant,
            {
                active: active,
                resourceQueues: resourceQueues
            },
            setSelectedResource
        ],
        queryFn: async ()=>{
            const resources = await (0, $a071e4bc84b4df4e$export$e6686bbd6035e86f)(selectedPlant, resourceQueues, {
                active: active
            });
            // If no data is returned, clear previous selection
            if (!resources.length) setSelectedResource('');
            return resources;
        },
        select: (data)=>{
            let newData = [];
            if (resourceQueues) newData = data.map((resource)=>{
                if (resource?.resourceQueues?.length) return {
                    ...resource,
                    resourceQueues: resource.resourceQueues.map((rq)=>({
                            ...rq,
                            id: rq.queueId,
                            description: rq.queue.description
                        }))
                };
                return {
                    ...resource,
                    resourceQueues: []
                };
            });
            return newData.length ? newData : data;
        },
        staleTime: Infinity,
        enabled: Boolean(apiReady && selectedPlant)
    });
};






const $3d379a1e3b14fb6f$export$ddb9c141656ef97b = ()=>{
    const queryClient = (0, $6547bc15d23e8c33$export$22e77b9572c4fded)();
    return (0, $506026961de7ab1a$export$609860bf8b0084c)({
        /**
     * mutateFn - Function to call createResource.
     * @param {Pella.ProductionRequestAPI.CreateResourceInput} input - The inputs for creating the Resource.
     */ mutationFn: (input)=>(0, $a071e4bc84b4df4e$export$edd172c6c83c39cc)(input),
        onSuccess: ()=>{
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).success('Resource created successfully!');
            queryClient.invalidateQueries({
                queryKey: [
                    (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).RESOURCE_DATA
                ]
            });
        }
    });
};







const $ef91388bb970737c$export$b66b501d3b531e82 = ()=>{
    const queryClient = (0, $6547bc15d23e8c33$export$22e77b9572c4fded)();
    const { selectedPlant: selectedPlant } = (0, $4e4c6c71fc2aaac8$export$fdc397e486fa83e7)();
    const queryKey = [
        (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).RESOURCE_DATA,
        selectedPlant,
        {
            resourceQueues: true
        }
    ];
    return (0, $506026961de7ab1a$export$609860bf8b0084c)({
        /**
     * mutateFn - Function to call updateResource.
     * @param {object} params
     * @param {Pella.ProductionRequestAPI.Plant['id']} params.id - The ID of the Resource to update.
     * @param {Pella.ProductionRequestAPI.UpdateResourceInput} params.input - The inputs for updating the Resource.
     */ mutationFn: ({ id: id, input: input })=>(0, $a071e4bc84b4df4e$export$1301c313b2890e2d)(id, input),
        onMutate: async ({ id: id, input: input })=>{
            // Cancel any outgoing refetches
            // (so they don't overwrite our optimistic update)
            await queryClient.cancelQueries({
                queryKey: queryKey
            });
            // Snapshot the previous value
            const previousResources = queryClient.getQueryData(queryKey);
            // Optimistically update the resource data in the cache
            queryClient.setQueryData(queryKey, (/** @type {Pella.ProductionRequestAPI.Resource[]} */ oldData)=>{
                // Guard against undefined data - if no data in cache, return empty array or previous data
                if (!oldData || !Array.isArray(oldData)) return previousResources || [];
                return oldData.map((resource)=>resource.id === id ? {
                        ...resource,
                        ...input
                    } : resource);
            });
            // Return a result with the snapshotted value
            return {
                previousResources: previousResources
            };
        },
        onError: (_err, _variables, onMutateResult)=>{
            // Rollback to the previous value on error
            queryClient.setQueryData(queryKey, onMutateResult?.previousResources);
        },
        onSuccess: ()=>{
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).dismiss();
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).success('Resource updated successfully!');
            // Invalidate queries to refetch the updated data
            queryClient.invalidateQueries({
                queryKey: [
                    (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).RESOURCE_DATA,
                    selectedPlant
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).QUEUE_DATA,
                    selectedPlant
                ]
            });
        }
    });
};







const $aedb968439152e04$export$4ea414df4222b929 = ()=>{
    const queryClient = (0, $6547bc15d23e8c33$export$22e77b9572c4fded)();
    const { selectedPlant: selectedPlant } = (0, $4e4c6c71fc2aaac8$export$fdc397e486fa83e7)();
    const queryKey = [
        (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).RESOURCE_DATA,
        selectedPlant,
        {
            resourceQueues: true
        }
    ];
    return (0, $506026961de7ab1a$export$609860bf8b0084c)({
        /**
     * mutateFn - Function to call deleteResource.
     * @param {Pella.ProductionRequestAPI.Resource['id']} id - The ID of the Resource to delete.
     */ mutationFn: (id)=>(0, $a071e4bc84b4df4e$export$993f1a5671d392dd)(id),
        onMutate: (id, context)=>{
            // Snapshot the previous value
            const previousResources = context.client.getQueryData(queryKey);
            // Optimistically update the resource data in the cache
            queryClient.setQueryData(queryKey, (/** @type {Pella.ProductionRequestAPI.Resource[]} */ oldData)=>{
                // Guard against undefined data - if no data in cache, return empty array or previous data
                if (!oldData || !Array.isArray(oldData)) return previousResources || [];
                return oldData.map((resource)=>resource.id === id);
            });
            // Return a result with the snapshotted value
            return {
                previousResources: previousResources
            };
        },
        onError: (_err, _variables, onMutateResult, context)=>{
            // Rollback to the previous value on error
            context.client.setQueryData(queryKey, onMutateResult?.previousResources);
        },
        onSuccess: ()=>{
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).success('Resource deleted successfully!');
            // Invalidate queries to refetch the updated data
            queryClient.invalidateQueries({
                queryKey: [
                    (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).RESOURCE_DATA,
                    selectedPlant
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).QUEUE_DATA,
                    selectedPlant
                ]
            });
        }
    });
};






const $ad776647e9c1d561$export$2c2d2f5bd2673 = (actionId)=>{
    const { apiReady: apiReady } = (0, $10608212fc1ea215$export$a826e754a2b6b403)();
    return (0, $5b47d34ec35eb825$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).ACTION_DATA,
            actionId
        ],
        queryFn: ()=>(0, $a071e4bc84b4df4e$export$2e52c604a323e3c7)(actionId),
        enabled: Boolean(apiReady && actionId)
    });
};






const $5adb370b1a355897$export$35954a68e93e2263 = ()=>{
    const queryClient = (0, $6547bc15d23e8c33$export$22e77b9572c4fded)();
    /**
   * Looks up the given action, rejecting (after a toast) on failure.
   * @param {string} actionId - The action to look up.
   */ return (actionId)=>queryClient.fetchQuery({
            queryKey: [
                (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).ACTION_DATA,
                actionId
            ],
            queryFn: ()=>(0, $a071e4bc84b4df4e$export$2e52c604a323e3c7)(actionId)
        }).catch((error)=>{
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).error('Error checking for linked action.');
            throw error;
        });
};






const $9b4f101bff843983$export$8b1589fe0122b5ad = ()=>{
    const queryClient = (0, $6547bc15d23e8c33$export$22e77b9572c4fded)();
    return (0, $506026961de7ab1a$export$609860bf8b0084c)({
        /**
     * mutateFn - Function to call createAction.
     * @param {Local.ActionMutationInput} input - The inputs for creating the Action.
     */ mutationFn: (input)=>(0, $a071e4bc84b4df4e$export$309c7a02b0b0bc62)(input),
        onSuccess: ()=>{
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).success('Action created successfully!');
            queryClient.invalidateQueries({
                queryKey: [
                    (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).ACTION_DATA
                ]
            });
        }
    });
};






const $b266a688ef487de8$export$e864c217d7414c75 = ()=>{
    const queryClient = (0, $6547bc15d23e8c33$export$22e77b9572c4fded)();
    return (0, $506026961de7ab1a$export$609860bf8b0084c)({
        /**
     * mutateFn - Function to call updateAction.
     * @param {object} params - The parameters for updating the Action.
     * @param {string} params.id - The ID of the Action to update.
     * @param {Local.ActionMutationInput} params.input - The inputs for updating the Action.
     */ mutationFn: (params)=>(0, $a071e4bc84b4df4e$export$82e451b5c0315ff3)(params.id, params.input),
        onSuccess: ()=>{
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).success('Action updated successfully!');
            queryClient.invalidateQueries({
                queryKey: [
                    (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).ACTION_DATA
                ]
            });
        }
    });
};






const $aa56f2c05453ddc1$export$cbfc8cc66826810d = ()=>{
    const queryClient = (0, $6547bc15d23e8c33$export$22e77b9572c4fded)();
    return (0, $506026961de7ab1a$export$609860bf8b0084c)({
        /**
     * mutateFn - Function to call deleteAction.
     * @param {Pella.ProductionRequestAPI.Action['id']} id - The ID of the Action to delete.
     */ mutationFn: (id)=>(0, $a071e4bc84b4df4e$export$f95501856a4df8a9)(id),
        onSuccess: ()=>{
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).success('Action deleted successfully!');
            queryClient.invalidateQueries({
                queryKey: [
                    (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).ACTION_DATA
                ]
            });
        }
    });
};







const $06f88e07f7e7fb66$export$bc923229a7fa61e7 = (options = {})=>{
    const { active: active } = options;
    const { apiReady: apiReady } = (0, $10608212fc1ea215$export$a826e754a2b6b403)();
    const { selectedLocation: selectedLocation } = (0, $4e4c6c71fc2aaac8$export$fdc397e486fa83e7)();
    const optionalArgs = typeof active === 'boolean' ? {
        active: active
    } : undefined;
    const effectiveLocation = options.location || selectedLocation;
    return (0, $5b47d34ec35eb825$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).ACTION_DATA,
            effectiveLocation,
            optionalArgs
        ],
        queryFn: ()=>(0, $a071e4bc84b4df4e$export$efa92ec39e7fe36d)(effectiveLocation, optionalArgs),
        enabled: Boolean(apiReady && effectiveLocation)
    });
};







const $41977b76b6bf14d0$export$5047aa1389069265 = (active)=>{
    const { apiReady: apiReady } = (0, $10608212fc1ea215$export$a826e754a2b6b403)();
    const { selectedResource: selectedResource } = (0, $4e4c6c71fc2aaac8$export$fdc397e486fa83e7)();
    return (0, $5b47d34ec35eb825$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).RESOURCE_QUEUES,
            selectedResource
        ],
        queryFn: ()=>(0, $a071e4bc84b4df4e$export$77c7c7ff730bf4d0)(selectedResource),
        enabled: Boolean(apiReady && selectedResource && active)
    });
};







const $2d0e270541012399$export$487a51f0f407c060 = ()=>{
    const { selectedResource: selectedResource } = (0, $4e4c6c71fc2aaac8$export$fdc397e486fa83e7)();
    const queryClient = (0, $6547bc15d23e8c33$export$22e77b9572c4fded)();
    return (0, $506026961de7ab1a$export$609860bf8b0084c)({
        /**
     * mutateFn - Function to call the createResourceQueue api.
     * @param {object} params - Parameters for creating a resource queue.
     * @param {Pella.ProductionRequestAPI.Queue['id']} params.queueId - ID of the queue to assign.
     * @param {Pella.ProductionRequestAPI.Resource['id']} [params.resourceId] - ID of the resource.
     * @param {Pella.ProductionRequestAPI.ResourceQueueByStatus['queueStatus']} params.queueStatus - Status of the queue.
     */ mutationFn: ({ queueId: queueId, resourceId: resourceId, queueStatus: queueStatus })=>(0, $a071e4bc84b4df4e$export$5789ae15bc578a22)({
                queueId: queueId,
                queueStatus: queueStatus,
                resourceId: resourceId ?? selectedResource,
                active: true
            }),
        onSuccess: (_data, { resourceId: resourceId })=>{
            queryClient.invalidateQueries({
                queryKey: [
                    (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).RESOURCE_QUEUES,
                    resourceId ?? selectedResource
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).RESOURCE_DATA
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).QUEUE_DATA
                ]
            });
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).success('Assignment Successful!');
        }
    });
};







const $20cf428f647ff455$export$1f437390c1ed2be2 = ()=>{
    const queryClient = (0, $6547bc15d23e8c33$export$22e77b9572c4fded)();
    const { selectedPlant: selectedPlant } = (0, $4e4c6c71fc2aaac8$export$fdc397e486fa83e7)();
    const resourcesKey = [
        (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).RESOURCE_DATA,
        selectedPlant,
        {
            resourceQueues: true
        }
    ];
    const queuesKey = [
        (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).QUEUE_DATA,
        selectedPlant,
        {
            resourceQueues: true
        }
    ];
    return (0, $506026961de7ab1a$export$609860bf8b0084c)({
        /**
     * mutateFn - Function to call the updateResourceQueue api.
     * @param {object} params - Parameters for updating a resource queue.
     * @param {Pella.ProductionRequestAPI.Queue['id']} params.queueId - ID of the queue to assign.
     * @param {Pella.ProductionRequestAPI.Resource['id']} params.resourceId - ID of the resource.
     * @param {Pella.ProductionRequestAPI.ResourceQueueByStatus['queueStatus']} [params.queueStatus] - Status of the queue.
     * @param {boolean} [params.active] - Whether the queue is active.
     */ mutationFn: ({ queueId: queueId, resourceId: resourceId, queueStatus: queueStatus, active: active })=>(0, $a071e4bc84b4df4e$export$f5132f0087ad7c66)(queueId, resourceId, {
                queueStatus: queueStatus,
                active: active
            }),
        onMutate: async ({ queueId: queueId, resourceId: resourceId, active: active }, context)=>{
            // Cancel any outgoing refetches
            // (so they don't overwrite our optimistic update)
            await context.client.cancelQueries({
                queryKey: resourcesKey
            });
            await context.client.cancelQueries({
                queryKey: queuesKey
            });
            // Snapshot the previous value for both resources and queues
            const previousResources = context.client.getQueryData(resourcesKey);
            const previousQueues = context.client.getQueryData(queuesKey);
            // Optimistically update the resource data in the cache
            context.client.setQueryData(resourcesKey, (/** @type {Pella.ProductionRequestAPI.ResourcesWithAssignments[]} */ oldData)=>{
                // Guard against undefined data - if no data in cache, return empty array or previous data
                if (!oldData || !Array.isArray(oldData)) return previousResources || [];
                return oldData.map((resource)=>resource.id === resourceId ? {
                        ...resource,
                        resourceQueues: resource?.resourceQueues?.map((rq)=>rq.queueId === queueId ? {
                                ...rq,
                                active: active
                            } : rq)
                    } : resource);
            });
            // Optimistically update the queue data in the cache
            context.client.setQueryData(queuesKey, (/** @type {Pella.ProductionRequestAPI.QueuesWithAssignments[]} */ oldData)=>{
                // Guard against undefined data - if no data in cache, return empty array or previous data
                if (!oldData || !Array.isArray(oldData)) return previousQueues || [];
                return oldData.map((queue)=>queue.id === queueId ? {
                        ...queue,
                        resourceQueues: queue?.resourceQueues?.map((rq)=>rq.resourceId === resourceId ? {
                                ...rq,
                                active: active
                            } : rq)
                    } : queue);
            });
            // Return a result with the snapshotted value
            return {
                previousResources: previousResources,
                previousQueues: previousQueues
            };
        },
        onError: (_err, _variables, onMutateResult, context)=>{
            // Rollback on error
            context.client.setQueryData(resourcesKey, onMutateResult?.previousResources);
            context.client.setQueryData(queuesKey, onMutateResult?.previousQueues);
        },
        onSuccess: (_data, { resourceId: resourceId })=>{
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).dismiss();
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).success('Assignment updated successfully!');
            queryClient.invalidateQueries({
                queryKey: [
                    (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).RESOURCE_QUEUES,
                    resourceId
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).RESOURCE_DATA
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).QUEUE_DATA
                ]
            });
        }
    });
};






const $cdb2ba9494631e7e$export$68b2ba9deca995b2 = ()=>{
    const { selectedResource: selectedResource } = (0, $4e4c6c71fc2aaac8$export$fdc397e486fa83e7)();
    const queryClient = (0, $6547bc15d23e8c33$export$22e77b9572c4fded)();
    return (0, $506026961de7ab1a$export$609860bf8b0084c)({
        /**
     * mutateFn - Function to call the deleteResourceQueue api.
     * @param {object} params - Parameters for deleting a resource queue.
     * @param {Pella.ProductionRequestAPI.Queue['id']} params.queueId - ID of the queue to unassign.
     * @param {Pella.ProductionRequestAPI.Resource['id']} [params.resourceId] - ID of the resource.
     */ mutationFn: ({ queueId: queueId, resourceId: resourceId })=>(0, $a071e4bc84b4df4e$export$fed3fc2161821fd7)({
                queueId: queueId,
                resourceId: resourceId ?? selectedResource
            }),
        onSuccess: (_data, { resourceId: resourceId })=>{
            queryClient.invalidateQueries({
                queryKey: [
                    (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).RESOURCE_QUEUES,
                    resourceId ?? selectedResource
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).RESOURCE_DATA
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).QUEUE_DATA
                ]
            });
        }
    });
};







const $d964298269979438$export$1d05d15546d51ccc = (fetchBy, active)=>{
    const { apiReady: apiReady } = (0, $10608212fc1ea215$export$a826e754a2b6b403)();
    const { selectedResource: selectedResource, selectedLocation: selectedLocation } = (0, $4e4c6c71fc2aaac8$export$fdc397e486fa83e7)();
    const queryKey = fetchBy === 'resource' ? [
        (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).REQUESTS_BY_RESOURCE,
        selectedResource
    ] : [
        (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).REQUESTS_BY_LOCATION,
        selectedLocation
    ];
    const queryFn = fetchBy === 'resource' ? ()=>(0, $a071e4bc84b4df4e$export$6d390088810038ce)(selectedResource) : ()=>(0, $a071e4bc84b4df4e$export$9238c8204b02b160)(selectedLocation);
    const enabled = fetchBy === 'resource' ? Boolean(apiReady && selectedResource && active) : Boolean(apiReady && selectedLocation && active);
    return (0, $5b47d34ec35eb825$export$dd0a697e1782aedd)({
        queryKey: queryKey,
        queryFn: queryFn,
        enabled: enabled
    });
};







const $67e137471d230f40$export$9ba35766fd1b2aff = (fetchBy, active)=>{
    const { apiReady: apiReady } = (0, $10608212fc1ea215$export$a826e754a2b6b403)();
    const { selectedResource: selectedResource, selectedLocation: selectedLocation } = (0, $4e4c6c71fc2aaac8$export$fdc397e486fa83e7)();
    const queryKey = fetchBy === 'resource' ? [
        (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).COMPLETED_REQUESTS_BY_RESOURCE,
        selectedResource
    ] : [
        (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).COMPLETED_REQUESTS_BY_LOCATION,
        selectedLocation
    ];
    const queryFn = fetchBy === 'resource' ? ()=>(0, $a071e4bc84b4df4e$export$8a9ccc4bf4a5d5c6)(selectedResource) : ()=>(0, $a071e4bc84b4df4e$export$9b1644f328a22a85)(selectedLocation);
    const enabled = fetchBy === 'resource' ? Boolean(apiReady && selectedResource && active) : Boolean(apiReady && selectedLocation && active);
    return (0, $5b47d34ec35eb825$export$dd0a697e1782aedd)({
        queryKey: queryKey,
        queryFn: queryFn,
        enabled: enabled
    });
};





const $25ab3bdc0bc8a5f6$export$d7d497d671a71166 = ()=>(0, $506026961de7ab1a$export$609860bf8b0084c)({
        /**
     * mutateFn - Function to call the createRequest api.
     * @param {Pella.ProductionRequestAPI.CreateRequestInput} input - The inputs for creating the Production Request.
     */ mutationFn: (input)=>(0, $a071e4bc84b4df4e$export$72e3afa9ac8966be)(input),
        onSuccess: ()=>(0, $673b1c81cc441170$export$2e2bcd8739ae039).success('Request submitted successfully!'),
        onError: ()=>(0, $673b1c81cc441170$export$2e2bcd8739ae039).error('Error creating request.')
    });







const $7a812fda41e7dd2d$export$f9e292527e05459d = ()=>{
    const { selectedResource: selectedResource, selectedLocation: selectedLocation } = (0, $4e4c6c71fc2aaac8$export$fdc397e486fa83e7)();
    const queryClient = (0, $6547bc15d23e8c33$export$22e77b9572c4fded)();
    return (0, $506026961de7ab1a$export$609860bf8b0084c)({
        /**
     * mutateFn - Function to call the updateRequest api.
     * @param {object} params
     * @param {Pella.ProductionRequestAPI.Request['id']} params.id - The ID of the Production Request to update.
     * @param {Pella.ProductionRequestAPI.Request['status']} params.status - The new status of the Production Request.
     * @param {string | null} [params.onHoldReason] - Hold reason label, only set when placing on hold via the reason modal.
     */ mutationFn: ({ id: id, status: status, onHoldReason: onHoldReason })=>{
            const input = /** @type {Local.RequestUpdateInput} */ {
                status: status,
                ...selectedResource && {
                    resourceId: selectedResource
                },
                ...onHoldReason !== null && {
                    onHoldReason: onHoldReason
                }
            };
            return (0, $a071e4bc84b4df4e$export$2d9e9f326aa75fc3)(id, input);
        },
        onSuccess: (_data, variables)=>{
            // Optimistically update the cached requests data for both resource and location queries
            if (selectedResource) queryClient.setQueryData([
                (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).REQUESTS_BY_RESOURCE,
                selectedResource
            ], (/** @type {Pella.ProductionRequestAPI.GetRequestsOutput} */ oldData)=>(0, $5f8e1c8d350f317e$export$9af24aaf2ed70b0c)(oldData, variables.id));
            if (selectedLocation) queryClient.setQueryData([
                (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).REQUESTS_BY_LOCATION,
                selectedLocation
            ], (/** @type {Pella.ProductionRequestAPI.GetRequestsOutput} */ oldData)=>(0, $5f8e1c8d350f317e$export$9af24aaf2ed70b0c)(oldData, variables.id));
            if (variables.status === (0, $917e2c0c66b65db1$export$b41c0f52c41112e3).COMPLETED) queryClient.invalidateQueries({
                queryKey: [
                    (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).COMPLETED_REQUESTS_BY_RESOURCE,
                    selectedResource
                ]
            });
        }
    });
};








const $3bf67ad161d7f6ff$export$64190e7a1f558fa0 = ()=>{
    const { selectedResource: selectedResource, selectedLocation: selectedLocation } = (0, $4e4c6c71fc2aaac8$export$fdc397e486fa83e7)();
    const queryClient = (0, $6547bc15d23e8c33$export$22e77b9572c4fded)();
    return (0, $506026961de7ab1a$export$609860bf8b0084c)({
        /**
     * mutateFn - Appends a communication entry to the request.
     * @param {object} params
     * @param {Local.RequestWithCommunication} params.request - The request being commented on.
     * @param {string} params.text - The communication text entered by the user.
     * @returns {Promise<Local.Communication[]>} The full communication history that was saved.
     */ mutationFn: async ({ request: request, text: text })=>{
            const saved = await (0, $a071e4bc84b4df4e$export$ffc4e9ae351c37c2)(request.id, text);
            return saved.communications ?? [];
        },
        onSuccess: (communication, variables)=>{
            if (selectedResource) queryClient.setQueryData([
                (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).REQUESTS_BY_RESOURCE,
                selectedResource
            ], (/** @type {Pella.ProductionRequestAPI.GetRequestsOutput} */ oldData)=>(0, $5f8e1c8d350f317e$export$5508b873498ab146)(oldData, variables.request.id, communication));
            if (selectedLocation) queryClient.setQueryData([
                (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).REQUESTS_BY_LOCATION,
                selectedLocation
            ], (/** @type {Pella.ProductionRequestAPI.GetRequestsOutput} */ oldData)=>(0, $5f8e1c8d350f317e$export$5508b873498ab146)(oldData, variables.request.id, communication));
        },
        onError: ()=>(0, $673b1c81cc441170$export$2e2bcd8739ae039).error('Error saving communication.')
    });
};








const $86776d4a0b45dc41$export$25c133294c88728d = ()=>{
    const { selectedResource: selectedResource, selectedLocation: selectedLocation } = (0, $4e4c6c71fc2aaac8$export$fdc397e486fa83e7)();
    const queryClient = (0, $6547bc15d23e8c33$export$22e77b9572c4fded)();
    return (0, $506026961de7ab1a$export$609860bf8b0084c)({
        /**
     * mutateFn - Marks every communication on the request as read.
     * @param {Local.RequestWithCommunication} request - The request whose communications were viewed.
     * @returns {Promise<Local.Communication[]>} The full communication history carrying the read receipt.
     */ mutationFn: async (request)=>{
            const read = await (0, $a071e4bc84b4df4e$export$f0d3460cccd3ae0f)(request.id);
            return read.communications ?? [];
        },
        onSuccess: (communication, request)=>{
            if (selectedResource) queryClient.setQueryData([
                (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).REQUESTS_BY_RESOURCE,
                selectedResource
            ], (/** @type {Pella.ProductionRequestAPI.GetRequestsOutput} */ oldData)=>(0, $5f8e1c8d350f317e$export$5508b873498ab146)(oldData, request.id, communication));
            if (selectedLocation) queryClient.setQueryData([
                (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).REQUESTS_BY_LOCATION,
                selectedLocation
            ], (/** @type {Pella.ProductionRequestAPI.GetRequestsOutput} */ oldData)=>(0, $5f8e1c8d350f317e$export$5508b873498ab146)(oldData, request.id, communication));
        },
        onError: ()=>(0, $673b1c81cc441170$export$2e2bcd8739ae039).error('Error marking communications as read.')
    });
};





const $fd6d0f1aae14f5a8$export$9d56560f09dccf5f = ()=>(0, $506026961de7ab1a$export$609860bf8b0084c)({
        /**
     * mutateFn - Function to call the getOpenRequestsByActionIdAndDynamicInput api.
     * @param {{actionId: string, dynamicInput: string}} variables - The action and dynamic input to match.
     */ mutationFn: ({ actionId: actionId, dynamicInput: dynamicInput })=>(0, $a071e4bc84b4df4e$export$8a669ea5c0b42af2)(actionId, dynamicInput),
        onError: ()=>(0, $673b1c81cc441170$export$2e2bcd8739ae039).error('Error checking for open requests.')
    });



var $lCzvA = parcelRequire("lCzvA");

const $e35bb462eab19ecf$export$811f96a41c724592 = (close)=>{
    const { mutate: checkOpenRequests, isPending: isChecking } = (0, $fd6d0f1aae14f5a8$export$9d56560f09dccf5f)();
    const [duplicateRequests, setDuplicateRequests] = (0, $lCzvA.useState)(/** @type {Local.OpenRequestSummary[]} */ []);
    // Held in an object so useState stores the callback rather than treating it as a state updater
    const [pendingSubmit, setPendingSubmit] = (0, $lCzvA.useState)(/** @type {{ submit: () => void } | null} */ null);
    /**
   * Check for open duplicates, then either submit the request or hold it pending confirmation.
   * @param {Pella.ProductionRequestAPI.CreateRequestInput} input - The request to submit
   * @param {(input: Pella.ProductionRequestAPI.CreateRequestInput) => void} submit - Submits the request
   */ const submitWithCheck = (input, submit)=>{
        const shouldCheckForDuplicates = Boolean(input.dynamicInput);
        if (!shouldCheckForDuplicates) {
            submit(input);
            return;
        }
        checkOpenRequests({
            actionId: input.actionId,
            dynamicInput: /** @type {string} */ input.dynamicInput
        }, {
            onSuccess: (openRequests)=>{
                if (!openRequests?.length) {
                    submit(input);
                    return;
                }
                setPendingSubmit({
                    submit: ()=>submit(input)
                });
                setDuplicateRequests(openRequests);
            }
        });
    };
    /** Discard the duplicates and the request that was waiting on them */ const clearDuplicates = ()=>{
        setDuplicateRequests([]);
        setPendingSubmit(null);
    };
    /** Abandon the request and return the user to where they came from */ const onCancel = ()=>{
        clearDuplicates();
        close();
    };
    /**
   * Submit the request the user was warned about. Closing is left to the submit callback, which
   * navigates once the mutation settles.
   */ const onProceed = ()=>{
        pendingSubmit?.submit();
        clearDuplicates();
    };
    return {
        duplicateRequests: duplicateRequests,
        submitWithCheck: submitWithCheck,
        onCancel: onCancel,
        onProceed: onProceed,
        isChecking: isChecking
    };
};



var $lCzvA = parcelRequire("lCzvA");



const $63b0984325adb4a7$var$LINKED_ACTION_DISABLED_MESSAGE = 'The Linked Action is disabled, so the corresponding request was not generated.';
const $63b0984325adb4a7$export$8ad014c5646c5871 = ()=>{
    const checkLinkedAction = (0, $5adb370b1a355897$export$35954a68e93e2263)();
    const { mutate: createLinkedRequest } = (0, $25ab3bdc0bc8a5f6$export$d7d497d671a71166)();
    // Held in an object so useState stores the callback rather than treating it as a state updater
    const [pending, setPending] = (0, $lCzvA.useState)(/** @type {{ request: Pella.ProductionRequestAPI.Request, onSettled: () => void, linkedAction: {id: string, description: string} } | null} */ null);
    /**
   * Check the request's action for an enabled linked action before completing it.
   * @param {Pella.ProductionRequestAPI.Request} request - The request being completed.
   * @param {() => void} onSettled - Performs the actual status update to Completed.
   */ const completeWithLinkedActionCheck = async (request, onSettled)=>{
        try {
            const action = await checkLinkedAction(request.actionId);
            const linkedAction = /** @type {unknown} */ action?.linkedAction;
            if (!linkedAction) {
                onSettled();
                return;
            }
            if (!linkedAction.active) {
                onSettled();
                (0, $673b1c81cc441170$export$2e2bcd8739ae039).error($63b0984325adb4a7$var$LINKED_ACTION_DISABLED_MESSAGE);
                return;
            }
            setPending({
                request: request,
                onSettled: onSettled,
                linkedAction: linkedAction
            });
        } catch  {
            // A failed lookup shouldn't block the user from completing their own request.
            onSettled();
        }
    };
    /** User clicked NO: complete without generating a linked request. */ const onDecline = ()=>{
        pending?.onSettled();
        setPending(null);
    };
    /** User clicked YES: create the linked request and complete, independently of each other. */ const onConfirm = ()=>{
        if (!pending) return;
        const { request: request, onSettled: onSettled, linkedAction: linkedAction } = pending;
        createLinkedRequest({
            actionId: linkedAction.id,
            dynamicInput: request.dynamicInput,
            dynamicInputResult: request.dynamicInputResult,
            requestQty: request.requestQty
        });
        onSettled();
        setPending(null);
    };
    return {
        isLinkedActionPromptOpen: Boolean(pending),
        linkedActionDescription: pending?.linkedAction.description,
        completeWithLinkedActionCheck: completeWithLinkedActionCheck,
        onDecline: onDecline,
        onConfirm: onConfirm
    };
};



var $lCzvA = parcelRequire("lCzvA");
const $5c547e463b0eaf3f$export$c169aefb7330cccb = Object.create(null); // no Map = no polyfill
$5c547e463b0eaf3f$export$c169aefb7330cccb["open"] = "0";
$5c547e463b0eaf3f$export$c169aefb7330cccb["close"] = "1";
$5c547e463b0eaf3f$export$c169aefb7330cccb["ping"] = "2";
$5c547e463b0eaf3f$export$c169aefb7330cccb["pong"] = "3";
$5c547e463b0eaf3f$export$c169aefb7330cccb["message"] = "4";
$5c547e463b0eaf3f$export$c169aefb7330cccb["upgrade"] = "5";
$5c547e463b0eaf3f$export$c169aefb7330cccb["noop"] = "6";
const $5c547e463b0eaf3f$export$47791e8004edd485 = Object.create(null);
Object.keys($5c547e463b0eaf3f$export$c169aefb7330cccb).forEach((key)=>{
    $5c547e463b0eaf3f$export$47791e8004edd485[$5c547e463b0eaf3f$export$c169aefb7330cccb[key]] = key;
});
const $5c547e463b0eaf3f$export$c718b5840781f8a7 = {
    type: "error",
    data: "parser error"
};


const $c4185107dd03fd6c$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && Object.prototype.toString.call(Blob) === "[object BlobConstructor]";
const $c4185107dd03fd6c$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
// ArrayBuffer.isView method is not defined in IE10
const $c4185107dd03fd6c$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj && obj.buffer instanceof ArrayBuffer;
};
const $c4185107dd03fd6c$export$57852049361a8e62 = ({ type: type, data: data }, supportsBinary, callback)=>{
    if ($c4185107dd03fd6c$var$withNativeBlob && data instanceof Blob) {
        if (supportsBinary) return callback(data);
        else return $c4185107dd03fd6c$var$encodeBlobAsBase64(data, callback);
    } else if ($c4185107dd03fd6c$var$withNativeArrayBuffer && (data instanceof ArrayBuffer || $c4185107dd03fd6c$var$isView(data))) {
        if (supportsBinary) return callback(data);
        else return $c4185107dd03fd6c$var$encodeBlobAsBase64(new Blob([
            data
        ]), callback);
    }
    // plain string
    return callback((0, $5c547e463b0eaf3f$export$c169aefb7330cccb)[type] + (data || ""));
};
const $c4185107dd03fd6c$var$encodeBlobAsBase64 = (data, callback)=>{
    const fileReader = new FileReader();
    fileReader.onload = function() {
        const content = fileReader.result.split(",")[1];
        callback("b" + (content || ""));
    };
    return fileReader.readAsDataURL(data);
};
function $c4185107dd03fd6c$var$toArray(data) {
    if (data instanceof Uint8Array) return data;
    else if (data instanceof ArrayBuffer) return new Uint8Array(data);
    else return new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
}
let $c4185107dd03fd6c$var$TEXT_ENCODER;
function $c4185107dd03fd6c$export$ec0c9b9013ee0ef5(packet, callback) {
    if ($c4185107dd03fd6c$var$withNativeBlob && packet.data instanceof Blob) return packet.data.arrayBuffer().then($c4185107dd03fd6c$var$toArray).then(callback);
    else if ($c4185107dd03fd6c$var$withNativeArrayBuffer && (packet.data instanceof ArrayBuffer || $c4185107dd03fd6c$var$isView(packet.data))) return callback($c4185107dd03fd6c$var$toArray(packet.data));
    $c4185107dd03fd6c$export$57852049361a8e62(packet, false, (encoded)=>{
        if (!$c4185107dd03fd6c$var$TEXT_ENCODER) $c4185107dd03fd6c$var$TEXT_ENCODER = new TextEncoder();
        callback($c4185107dd03fd6c$var$TEXT_ENCODER.encode(encoded));
    });
}



// imported from https://github.com/socketio/base64-arraybuffer
const $055abc405ec012c0$var$chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
// Use a lookup table to find the index.
const $055abc405ec012c0$var$lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
for(let i = 0; i < $055abc405ec012c0$var$chars.length; i++)$055abc405ec012c0$var$lookup[$055abc405ec012c0$var$chars.charCodeAt(i)] = i;
const $055abc405ec012c0$export$c564cdbbe6da493 = (arraybuffer)=>{
    let bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = '';
    for(i = 0; i < len; i += 3){
        base64 += $055abc405ec012c0$var$chars[bytes[i] >> 2];
        base64 += $055abc405ec012c0$var$chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += $055abc405ec012c0$var$chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += $055abc405ec012c0$var$chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + '=';
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + '==';
    return base64;
};
const $055abc405ec012c0$export$2f872c0f2117be69 = (base64)=>{
    let bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
    if (base64[base64.length - 1] === '=') {
        bufferLength--;
        if (base64[base64.length - 2] === '=') bufferLength--;
    }
    const arraybuffer = new ArrayBuffer(bufferLength), bytes = new Uint8Array(arraybuffer);
    for(i = 0; i < len; i += 4){
        encoded1 = $055abc405ec012c0$var$lookup[base64.charCodeAt(i)];
        encoded2 = $055abc405ec012c0$var$lookup[base64.charCodeAt(i + 1)];
        encoded3 = $055abc405ec012c0$var$lookup[base64.charCodeAt(i + 2)];
        encoded4 = $055abc405ec012c0$var$lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return arraybuffer;
};


const $a981052c378bb34e$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $a981052c378bb34e$export$4647901878f33f31 = (encodedPacket, binaryType)=>{
    if (typeof encodedPacket !== "string") return {
        type: "message",
        data: $a981052c378bb34e$var$mapBinary(encodedPacket, binaryType)
    };
    const type = encodedPacket.charAt(0);
    if (type === "b") return {
        type: "message",
        data: $a981052c378bb34e$var$decodeBase64Packet(encodedPacket.substring(1), binaryType)
    };
    const packetType = (0, $5c547e463b0eaf3f$export$47791e8004edd485)[type];
    if (!packetType) return 0, $5c547e463b0eaf3f$export$c718b5840781f8a7;
    return encodedPacket.length > 1 ? {
        type: (0, $5c547e463b0eaf3f$export$47791e8004edd485)[type],
        data: encodedPacket.substring(1)
    } : {
        type: (0, $5c547e463b0eaf3f$export$47791e8004edd485)[type]
    };
};
const $a981052c378bb34e$var$decodeBase64Packet = (data, binaryType)=>{
    if ($a981052c378bb34e$var$withNativeArrayBuffer) {
        const decoded = (0, $055abc405ec012c0$export$2f872c0f2117be69)(data);
        return $a981052c378bb34e$var$mapBinary(decoded, binaryType);
    } else return {
        base64: true,
        data: data
    }; // fallback for old browsers
};
const $a981052c378bb34e$var$mapBinary = (data, binaryType)=>{
    switch(binaryType){
        case "blob":
            if (data instanceof Blob) // from WebSocket + binaryType "blob"
            return data;
            else // from HTTP long-polling or WebTransport
            return new Blob([
                data
            ]);
        case "arraybuffer":
        default:
            if (data instanceof ArrayBuffer) // from HTTP long-polling (base64) or WebSocket + binaryType "arraybuffer"
            return data;
            else // from WebTransport (Uint8Array)
            return data.buffer;
    }
};



const $a98a630babe996ba$var$SEPARATOR = String.fromCharCode(30); // see https://en.wikipedia.org/wiki/Delimiter#ASCII_delimited_text
const $a98a630babe996ba$export$144d64fe58dad441 = (packets, callback)=>{
    // some packets may be added to the array while encoding, so the initial length must be saved
    const length = packets.length;
    const encodedPackets = new Array(length);
    let count = 0;
    packets.forEach((packet, i)=>{
        // force base64 encoding for binary packets
        (0, $c4185107dd03fd6c$export$57852049361a8e62)(packet, false, (encodedPacket)=>{
            encodedPackets[i] = encodedPacket;
            if (++count === length) callback(encodedPackets.join($a98a630babe996ba$var$SEPARATOR));
        });
    });
};
const $a98a630babe996ba$export$d10cc2e7f7566a2d = (encodedPayload, binaryType)=>{
    const encodedPackets = encodedPayload.split($a98a630babe996ba$var$SEPARATOR);
    const packets = [];
    for(let i = 0; i < encodedPackets.length; i++){
        const decodedPacket = (0, $a981052c378bb34e$export$4647901878f33f31)(encodedPackets[i], binaryType);
        packets.push(decodedPacket);
        if (decodedPacket.type === "error") break;
    }
    return packets;
};
function $a98a630babe996ba$export$a525fb718e9c623a() {
    return new TransformStream({
        transform (packet, controller) {
            (0, $c4185107dd03fd6c$export$ec0c9b9013ee0ef5)(packet, (encodedPacket)=>{
                const payloadLength = encodedPacket.length;
                let header;
                // inspired by the WebSocket format: https://developer.mozilla.org/en-US/docs/Web/API/WebSockets_API/Writing_WebSocket_servers#decoding_payload_length
                if (payloadLength < 126) {
                    header = new Uint8Array(1);
                    new DataView(header.buffer).setUint8(0, payloadLength);
                } else if (payloadLength < 65536) {
                    header = new Uint8Array(3);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 126);
                    view.setUint16(1, payloadLength);
                } else {
                    header = new Uint8Array(9);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 127);
                    view.setBigUint64(1, BigInt(payloadLength));
                }
                // first bit indicates whether the payload is plain text (0) or binary (1)
                if (packet.data && typeof packet.data !== "string") header[0] |= 0x80;
                controller.enqueue(header);
                controller.enqueue(encodedPacket);
            });
        }
    });
}
let $a98a630babe996ba$var$TEXT_DECODER;
function $a98a630babe996ba$var$totalLength(chunks) {
    return chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
}
function $a98a630babe996ba$var$concatChunks(chunks, size) {
    if (chunks[0].length === size) return chunks.shift();
    const buffer = new Uint8Array(size);
    let j = 0;
    for(let i = 0; i < size; i++){
        buffer[i] = chunks[0][j++];
        if (j === chunks[0].length) {
            chunks.shift();
            j = 0;
        }
    }
    if (chunks.length && j < chunks[0].length) chunks[0] = chunks[0].slice(j);
    return buffer;
}
function $a98a630babe996ba$export$552d20aac7500f47(maxPayload, binaryType) {
    if (!$a98a630babe996ba$var$TEXT_DECODER) $a98a630babe996ba$var$TEXT_DECODER = new TextDecoder();
    const chunks = [];
    let state = 0 /* State.READ_HEADER */ ;
    let expectedLength = -1;
    let isBinary = false;
    return new TransformStream({
        transform (chunk, controller) {
            chunks.push(chunk);
            while(true){
                if (state === 0 /* State.READ_HEADER */ ) {
                    if ($a98a630babe996ba$var$totalLength(chunks) < 1) break;
                    const header = $a98a630babe996ba$var$concatChunks(chunks, 1);
                    isBinary = (header[0] & 0x80) === 0x80;
                    expectedLength = header[0] & 0x7f;
                    if (expectedLength < 126) state = 3 /* State.READ_PAYLOAD */ ;
                    else if (expectedLength === 126) state = 1 /* State.READ_EXTENDED_LENGTH_16 */ ;
                    else state = 2 /* State.READ_EXTENDED_LENGTH_64 */ ;
                } else if (state === 1 /* State.READ_EXTENDED_LENGTH_16 */ ) {
                    if ($a98a630babe996ba$var$totalLength(chunks) < 2) break;
                    const headerArray = $a98a630babe996ba$var$concatChunks(chunks, 2);
                    expectedLength = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length).getUint16(0);
                    state = 3 /* State.READ_PAYLOAD */ ;
                } else if (state === 2 /* State.READ_EXTENDED_LENGTH_64 */ ) {
                    if ($a98a630babe996ba$var$totalLength(chunks) < 8) break;
                    const headerArray = $a98a630babe996ba$var$concatChunks(chunks, 8);
                    const view = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length);
                    const n = view.getUint32(0);
                    if (n > Math.pow(2, 21) - 1) {
                        // the maximum safe integer in JavaScript is 2^53 - 1
                        controller.enqueue((0, $5c547e463b0eaf3f$export$c718b5840781f8a7));
                        break;
                    }
                    expectedLength = n * Math.pow(2, 32) + view.getUint32(4);
                    state = 3 /* State.READ_PAYLOAD */ ;
                } else {
                    if ($a98a630babe996ba$var$totalLength(chunks) < expectedLength) break;
                    const data = $a98a630babe996ba$var$concatChunks(chunks, expectedLength);
                    controller.enqueue((0, $a981052c378bb34e$export$4647901878f33f31)(isBinary ? data : $a98a630babe996ba$var$TEXT_DECODER.decode(data), binaryType));
                    state = 0 /* State.READ_HEADER */ ;
                }
                if (expectedLength === 0 || expectedLength > maxPayload) {
                    controller.enqueue((0, $5c547e463b0eaf3f$export$c718b5840781f8a7));
                    break;
                }
            }
        }
    });
}
const $a98a630babe996ba$export$a51d6b395ff4c65a = 4;


/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */ function $b1d057b86753ac91$export$4293555f241ae35a(obj) {
    if (obj) return $b1d057b86753ac91$var$mixin(obj);
}
/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */ function $b1d057b86753ac91$var$mixin(obj) {
    for(var key in $b1d057b86753ac91$export$4293555f241ae35a.prototype)obj[key] = $b1d057b86753ac91$export$4293555f241ae35a.prototype[key];
    return obj;
}
/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $b1d057b86753ac91$export$4293555f241ae35a.prototype.on = $b1d057b86753ac91$export$4293555f241ae35a.prototype.addEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    (this._callbacks['$' + event] = this._callbacks['$' + event] || []).push(fn);
    return this;
};
/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $b1d057b86753ac91$export$4293555f241ae35a.prototype.once = function(event, fn) {
    function on() {
        this.off(event, on);
        fn.apply(this, arguments);
    }
    on.fn = fn;
    this.on(event, on);
    return this;
};
/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $b1d057b86753ac91$export$4293555f241ae35a.prototype.off = $b1d057b86753ac91$export$4293555f241ae35a.prototype.removeListener = $b1d057b86753ac91$export$4293555f241ae35a.prototype.removeAllListeners = $b1d057b86753ac91$export$4293555f241ae35a.prototype.removeEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    // all
    if (0 == arguments.length) {
        this._callbacks = {};
        return this;
    }
    // specific event
    var callbacks = this._callbacks['$' + event];
    if (!callbacks) return this;
    // remove all handlers
    if (1 == arguments.length) {
        delete this._callbacks['$' + event];
        return this;
    }
    // remove specific handler
    var cb;
    for(var i = 0; i < callbacks.length; i++){
        cb = callbacks[i];
        if (cb === fn || cb.fn === fn) {
            callbacks.splice(i, 1);
            break;
        }
    }
    // Remove event specific arrays for event types that no
    // one is subscribed for to avoid memory leak.
    if (callbacks.length === 0) delete this._callbacks['$' + event];
    return this;
};
/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */ $b1d057b86753ac91$export$4293555f241ae35a.prototype.emit = function(event) {
    this._callbacks = this._callbacks || {};
    var args = new Array(arguments.length - 1), callbacks = this._callbacks['$' + event];
    for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    if (callbacks) {
        callbacks = callbacks.slice(0);
        for(var i = 0, len = callbacks.length; i < len; ++i)callbacks[i].apply(this, args);
    }
    return this;
};
// alias used for reserved events (protected method)
$b1d057b86753ac91$export$4293555f241ae35a.prototype.emitReserved = $b1d057b86753ac91$export$4293555f241ae35a.prototype.emit;
/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */ $b1d057b86753ac91$export$4293555f241ae35a.prototype.listeners = function(event) {
    this._callbacks = this._callbacks || {};
    return this._callbacks['$' + event] || [];
};
/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */ $b1d057b86753ac91$export$4293555f241ae35a.prototype.hasListeners = function(event) {
    return !!this.listeners(event).length;
};


const $78dda435b49a09da$export$bdd553fddd433dcb = (()=>{
    const isPromiseAvailable = typeof Promise === "function" && typeof Promise.resolve === "function";
    if (isPromiseAvailable) return (cb)=>Promise.resolve().then(cb);
    else return (cb, setTimeoutFn)=>setTimeoutFn(cb, 0);
})();
const $78dda435b49a09da$export$394f9358f6231289 = (()=>{
    if (typeof self !== "undefined") return self;
    else if (typeof window !== "undefined") return window;
    else return Function("return this")();
})();
const $78dda435b49a09da$export$790dcbc41e2d75d5 = "arraybuffer";
function $78dda435b49a09da$export$19413efcf2fac759() {}


function $6ef350ea0a0dd88d$export$357523c63a2253b9(obj, ...attr) {
    return attr.reduce((acc, k)=>{
        if (obj.hasOwnProperty(k)) acc[k] = obj[k];
        return acc;
    }, {});
}
// Keep a reference to the real timeout functions so they can be used when overridden
const $6ef350ea0a0dd88d$var$NATIVE_SET_TIMEOUT = (0, $78dda435b49a09da$export$394f9358f6231289).setTimeout;
const $6ef350ea0a0dd88d$var$NATIVE_CLEAR_TIMEOUT = (0, $78dda435b49a09da$export$394f9358f6231289).clearTimeout;
function $6ef350ea0a0dd88d$export$2f67576668b97183(obj, opts) {
    if (opts.useNativeTimers) {
        obj.setTimeoutFn = $6ef350ea0a0dd88d$var$NATIVE_SET_TIMEOUT.bind((0, $78dda435b49a09da$export$394f9358f6231289));
        obj.clearTimeoutFn = $6ef350ea0a0dd88d$var$NATIVE_CLEAR_TIMEOUT.bind((0, $78dda435b49a09da$export$394f9358f6231289));
    } else {
        obj.setTimeoutFn = (0, $78dda435b49a09da$export$394f9358f6231289).setTimeout.bind((0, $78dda435b49a09da$export$394f9358f6231289));
        obj.clearTimeoutFn = (0, $78dda435b49a09da$export$394f9358f6231289).clearTimeout.bind((0, $78dda435b49a09da$export$394f9358f6231289));
    }
}
// base64 encoded buffers are about 33% bigger (https://en.wikipedia.org/wiki/Base64)
const $6ef350ea0a0dd88d$var$BASE64_OVERHEAD = 1.33;
function $6ef350ea0a0dd88d$export$a48f0734ac7c2329(obj) {
    if (typeof obj === "string") return $6ef350ea0a0dd88d$var$utf8Length(obj);
    // arraybuffer or blob
    return Math.ceil((obj.byteLength || obj.size) * $6ef350ea0a0dd88d$var$BASE64_OVERHEAD);
}
function $6ef350ea0a0dd88d$var$utf8Length(str) {
    let c = 0, length = 0;
    for(let i = 0, l = str.length; i < l; i++){
        c = str.charCodeAt(i);
        if (c < 0x80) length += 1;
        else if (c < 0x800) length += 2;
        else if (c < 0xd800 || c >= 0xe000) length += 3;
        else {
            i++;
            length += 4;
        }
    }
    return length;
}
function $6ef350ea0a0dd88d$export$7fa8378418b4411e() {
    return Date.now().toString(36).substring(3) + Math.random().toString(36).substring(2, 5);
}


// imported from https://github.com/galkn/querystring
/**
 * Compiles a querystring
 * Returns string representation of the object
 *
 * @param {Object}
 * @api private
 */ function $7913ae70c2a27fe9$export$c564cdbbe6da493(obj) {
    let str = '';
    for(let i in obj)if (obj.hasOwnProperty(i)) {
        if (str.length) str += '&';
        str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
    }
    return str;
}
function $7913ae70c2a27fe9$export$2f872c0f2117be69(qs) {
    let qry = {};
    let pairs = qs.split('&');
    for(let i = 0, l = pairs.length; i < l; i++){
        let pair = pairs[i].split('=');
        qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }
    return qry;
}


class $3503e5787a975d0b$export$8e68de6fb26f2236 extends Error {
    constructor(reason, description, context){
        super(reason);
        this.description = description;
        this.context = context;
        this.type = "TransportError";
    }
}
class $3503e5787a975d0b$export$86495b081fef8e52 extends (0, $b1d057b86753ac91$export$4293555f241ae35a) {
    /**
     * Transport abstract constructor.
     *
     * @param {Object} opts - options
     * @protected
     */ constructor(opts){
        super();
        this.writable = false;
        (0, $6ef350ea0a0dd88d$export$2f67576668b97183)(this, opts);
        this.opts = opts;
        this.query = opts.query;
        this.socket = opts.socket;
        this.supportsBinary = !opts.forceBase64;
    }
    /**
     * Emits an error.
     *
     * @param {String} reason
     * @param description
     * @param context - the error context
     * @return {Transport} for chaining
     * @protected
     */ onError(reason, description, context) {
        super.emitReserved("error", new $3503e5787a975d0b$export$8e68de6fb26f2236(reason, description, context));
        return this;
    }
    /**
     * Opens the transport.
     */ open() {
        this.readyState = "opening";
        this.doOpen();
        return this;
    }
    /**
     * Closes the transport.
     */ close() {
        if (this.readyState === "opening" || this.readyState === "open") {
            this.doClose();
            this.onClose();
        }
        return this;
    }
    /**
     * Sends multiple packets.
     *
     * @param {Array} packets
     */ send(packets) {
        if (this.readyState === "open") this.write(packets);
    }
    /**
     * Called upon open
     *
     * @protected
     */ onOpen() {
        this.readyState = "open";
        this.writable = true;
        super.emitReserved("open");
    }
    /**
     * Called with data.
     *
     * @param {String} data
     * @protected
     */ onData(data) {
        const packet = (0, $a981052c378bb34e$export$4647901878f33f31)(data, this.socket.binaryType);
        this.onPacket(packet);
    }
    /**
     * Called with a decoded packet.
     *
     * @protected
     */ onPacket(packet) {
        super.emitReserved("packet", packet);
    }
    /**
     * Called upon close.
     *
     * @protected
     */ onClose(details) {
        this.readyState = "closed";
        super.emitReserved("close", details);
    }
    /**
     * Pauses the transport, in order not to lose packets during an upgrade.
     *
     * @param onPause
     */ pause(onPause) {}
    createUri(schema, query = {}) {
        return schema + "://" + this._hostname() + this._port() + this.opts.path + this._query(query);
    }
    _hostname() {
        const hostname = this.opts.hostname;
        return hostname.indexOf(":") === -1 ? hostname : "[" + hostname + "]";
    }
    _port() {
        if (this.opts.port && (this.opts.secure && Number(this.opts.port) !== 443 || !this.opts.secure && Number(this.opts.port) !== 80)) return ":" + this.opts.port;
        else return "";
    }
    _query(query) {
        const encodedQuery = (0, $7913ae70c2a27fe9$export$c564cdbbe6da493)(query);
        return encodedQuery.length ? "?" + encodedQuery : "";
    }
}




class $0b63fa11be6fda61$export$265ee5eefd4c309b extends (0, $3503e5787a975d0b$export$86495b081fef8e52) {
    constructor(){
        super(...arguments);
        this._polling = false;
    }
    get name() {
        return "polling";
    }
    /**
     * Opens the socket (triggers polling). We write a PING message to determine
     * when the transport is open.
     *
     * @protected
     */ doOpen() {
        this._poll();
    }
    /**
     * Pauses polling.
     *
     * @param {Function} onPause - callback upon buffers are flushed and transport is paused
     * @package
     */ pause(onPause) {
        this.readyState = "pausing";
        const pause = ()=>{
            this.readyState = "paused";
            onPause();
        };
        if (this._polling || !this.writable) {
            let total = 0;
            if (this._polling) {
                total++;
                this.once("pollComplete", function() {
                    --total || pause();
                });
            }
            if (!this.writable) {
                total++;
                this.once("drain", function() {
                    --total || pause();
                });
            }
        } else pause();
    }
    /**
     * Starts polling cycle.
     *
     * @private
     */ _poll() {
        this._polling = true;
        this.doPoll();
        this.emitReserved("poll");
    }
    /**
     * Overloads onData to detect payloads.
     *
     * @protected
     */ onData(data) {
        const callback = (packet)=>{
            // if its the first message we consider the transport open
            if ("opening" === this.readyState && packet.type === "open") this.onOpen();
            // if its a close packet, we close the ongoing requests
            if ("close" === packet.type) {
                this.onClose({
                    description: "transport closed by the server"
                });
                return false;
            }
            // otherwise bypass onData and handle the message
            this.onPacket(packet);
        };
        // decode payload
        (0, $a98a630babe996ba$export$d10cc2e7f7566a2d)(data, this.socket.binaryType).forEach(callback);
        // if an event did not trigger closing
        if ("closed" !== this.readyState) {
            // if we got data we're not polling
            this._polling = false;
            this.emitReserved("pollComplete");
            if ("open" === this.readyState) this._poll();
        }
    }
    /**
     * For polling, send a close packet.
     *
     * @protected
     */ doClose() {
        const close = ()=>{
            this.write([
                {
                    type: "close"
                }
            ]);
        };
        if ("open" === this.readyState) close();
        else // in case we're trying to close while
        // handshaking is in progress (GH-164)
        this.once("open", close);
    }
    /**
     * Writes a packets payload.
     *
     * @param {Array} packets - data packets
     * @protected
     */ write(packets) {
        this.writable = false;
        (0, $a98a630babe996ba$export$144d64fe58dad441)(packets, (data)=>{
            this.doWrite(data, ()=>{
                this.writable = true;
                this.emitReserved("drain");
            });
        });
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "https" : "http";
        const query = this.query || {};
        // cache busting is forced
        if (false !== this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $6ef350ea0a0dd88d$export$7fa8378418b4411e)();
        if (!this.supportsBinary && !query.sid) query.b64 = 1;
        return this.createUri(schema, query);
    }
}





// imported from https://github.com/component/has-cors
let $d9c50c7ee579c975$var$value = false;
try {
    $d9c50c7ee579c975$var$value = typeof XMLHttpRequest !== 'undefined' && 'withCredentials' in new XMLHttpRequest();
} catch (err) {
// if XMLHttp support is disabled in IE then it will throw
// when trying to create
}
const $d9c50c7ee579c975$export$5235bbd4a1ef06e = $d9c50c7ee579c975$var$value;


function $b2c670152e349ccd$var$empty() {}
class $b2c670152e349ccd$export$c959f2344155d309 extends (0, $0b63fa11be6fda61$export$265ee5eefd4c309b) {
    /**
     * XHR Polling constructor.
     *
     * @param {Object} opts
     * @package
     */ constructor(opts){
        super(opts);
        if (typeof location !== "undefined") {
            const isSSL = "https:" === location.protocol;
            let port = location.port;
            // some user agents have empty `location.port`
            if (!port) port = isSSL ? "443" : "80";
            this.xd = typeof location !== "undefined" && opts.hostname !== location.hostname || port !== opts.port;
        }
    }
    /**
     * Sends data.
     *
     * @param {String} data - data to send.
     * @param {Function} fn - called upon flush.
     * @private
     */ doWrite(data, fn) {
        const req = this.request({
            method: "POST",
            data: data
        });
        req.on("success", fn);
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr post error", xhrStatus, context);
        });
    }
    /**
     * Starts a poll cycle.
     *
     * @private
     */ doPoll() {
        const req = this.request();
        req.on("data", this.onData.bind(this));
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr poll error", xhrStatus, context);
        });
        this.pollXhr = req;
    }
}
class $b2c670152e349ccd$export$7fa6c5b6f8193917 extends (0, $b1d057b86753ac91$export$4293555f241ae35a) {
    /**
     * Request constructor
     *
     * @param {Object} options
     * @package
     */ constructor(createRequest, uri, opts){
        super();
        this.createRequest = createRequest;
        (0, $6ef350ea0a0dd88d$export$2f67576668b97183)(this, opts);
        this._opts = opts;
        this._method = opts.method || "GET";
        this._uri = uri;
        this._data = undefined !== opts.data ? opts.data : null;
        this._create();
    }
    /**
     * Creates the XHR object and sends the request.
     *
     * @private
     */ _create() {
        var _a;
        const opts = (0, $6ef350ea0a0dd88d$export$357523c63a2253b9)(this._opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
        opts.xdomain = !!this._opts.xd;
        const xhr = this._xhr = this.createRequest(opts);
        try {
            xhr.open(this._method, this._uri, true);
            try {
                if (this._opts.extraHeaders) {
                    // @ts-ignore
                    xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);
                    for(let i in this._opts.extraHeaders)if (this._opts.extraHeaders.hasOwnProperty(i)) xhr.setRequestHeader(i, this._opts.extraHeaders[i]);
                }
            } catch (e) {}
            if ("POST" === this._method) try {
                xhr.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
            } catch (e) {}
            try {
                xhr.setRequestHeader("Accept", "*/*");
            } catch (e) {}
            (_a = this._opts.cookieJar) === null || _a === void 0 || _a.addCookies(xhr);
            // ie6 check
            if ("withCredentials" in xhr) xhr.withCredentials = this._opts.withCredentials;
            if (this._opts.requestTimeout) xhr.timeout = this._opts.requestTimeout;
            xhr.onreadystatechange = ()=>{
                var _a;
                if (xhr.readyState === 3) (_a = this._opts.cookieJar) === null || _a === void 0 || _a.parseCookies(// @ts-ignore
                xhr.getResponseHeader("set-cookie"));
                if (4 !== xhr.readyState) return;
                if (200 === xhr.status || 1223 === xhr.status) this._onLoad();
                else // make sure the `error` event handler that's user-set
                // does not throw in the same tick and gets caught here
                this.setTimeoutFn(()=>{
                    this._onError(typeof xhr.status === "number" ? xhr.status : 0);
                }, 0);
            };
            xhr.send(this._data);
        } catch (e) {
            // Need to defer since .create() is called directly from the constructor
            // and thus the 'error' event can only be only bound *after* this exception
            // occurs.  Therefore, also, we cannot throw here at all.
            this.setTimeoutFn(()=>{
                this._onError(e);
            }, 0);
            return;
        }
        if (typeof document !== "undefined") {
            this._index = $b2c670152e349ccd$export$7fa6c5b6f8193917.requestsCount++;
            $b2c670152e349ccd$export$7fa6c5b6f8193917.requests[this._index] = this;
        }
    }
    /**
     * Called upon error.
     *
     * @private
     */ _onError(err) {
        this.emitReserved("error", err, this._xhr);
        this._cleanup(true);
    }
    /**
     * Cleans up house.
     *
     * @private
     */ _cleanup(fromError) {
        if ("undefined" === typeof this._xhr || null === this._xhr) return;
        this._xhr.onreadystatechange = $b2c670152e349ccd$var$empty;
        if (fromError) try {
            this._xhr.abort();
        } catch (e) {}
        if (typeof document !== "undefined") delete $b2c670152e349ccd$export$7fa6c5b6f8193917.requests[this._index];
        this._xhr = null;
    }
    /**
     * Called upon load.
     *
     * @private
     */ _onLoad() {
        const data = this._xhr.responseText;
        if (data !== null) {
            this.emitReserved("data", data);
            this.emitReserved("success");
            this._cleanup();
        }
    }
    /**
     * Aborts the request.
     *
     * @package
     */ abort() {
        this._cleanup();
    }
}
$b2c670152e349ccd$export$7fa6c5b6f8193917.requestsCount = 0;
$b2c670152e349ccd$export$7fa6c5b6f8193917.requests = {};
/**
 * Aborts pending requests when unloading the window. This is needed to prevent
 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
 * emitted.
 */ if (typeof document !== "undefined") {
    // @ts-ignore
    if (typeof attachEvent === "function") // @ts-ignore
    attachEvent("onunload", $b2c670152e349ccd$var$unloadHandler);
    else if (typeof addEventListener === "function") {
        const terminationEvent = "onpagehide" in (0, $78dda435b49a09da$export$394f9358f6231289) ? "pagehide" : "unload";
        addEventListener(terminationEvent, $b2c670152e349ccd$var$unloadHandler, false);
    }
}
function $b2c670152e349ccd$var$unloadHandler() {
    for(let i in $b2c670152e349ccd$export$7fa6c5b6f8193917.requests)if ($b2c670152e349ccd$export$7fa6c5b6f8193917.requests.hasOwnProperty(i)) $b2c670152e349ccd$export$7fa6c5b6f8193917.requests[i].abort();
}
const $b2c670152e349ccd$var$hasXHR2 = function() {
    const xhr = $b2c670152e349ccd$var$newRequest({
        xdomain: false
    });
    return xhr && xhr.responseType !== null;
}();
class $b2c670152e349ccd$export$a2d42eb087c10497 extends $b2c670152e349ccd$export$c959f2344155d309 {
    constructor(opts){
        super(opts);
        const forceBase64 = opts && opts.forceBase64;
        this.supportsBinary = $b2c670152e349ccd$var$hasXHR2 && !forceBase64;
    }
    request(opts = {}) {
        Object.assign(opts, {
            xd: this.xd
        }, this.opts);
        return new $b2c670152e349ccd$export$7fa6c5b6f8193917($b2c670152e349ccd$var$newRequest, this.uri(), opts);
    }
}
function $b2c670152e349ccd$var$newRequest(opts) {
    const xdomain = opts.xdomain;
    // XMLHttpRequest can be disabled on IE
    try {
        if ("undefined" !== typeof XMLHttpRequest && (!xdomain || (0, $d9c50c7ee579c975$export$5235bbd4a1ef06e))) return new XMLHttpRequest();
    } catch (e) {}
    if (!xdomain) try {
        return new (0, $78dda435b49a09da$export$394f9358f6231289)[[
            "Active"
        ].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch (e) {}
}






// detect ReactNative environment
const $b532a5eecc323955$var$isReactNative = typeof navigator !== "undefined" && typeof navigator.product === "string" && navigator.product.toLowerCase() === "reactnative";
class $b532a5eecc323955$export$570bf71d2367e261 extends (0, $3503e5787a975d0b$export$86495b081fef8e52) {
    get name() {
        return "websocket";
    }
    doOpen() {
        const uri = this.uri();
        const protocols = this.opts.protocols;
        // React Native only supports the 'headers' option, and will print a warning if anything else is passed
        const opts = $b532a5eecc323955$var$isReactNative ? {} : (0, $6ef350ea0a0dd88d$export$357523c63a2253b9)(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
        if (this.opts.extraHeaders) opts.headers = this.opts.extraHeaders;
        try {
            this.ws = this.createSocket(uri, protocols, opts);
        } catch (err) {
            return this.emitReserved("error", err);
        }
        this.ws.binaryType = this.socket.binaryType;
        this.addEventListeners();
    }
    /**
     * Adds event listeners to the socket
     *
     * @private
     */ addEventListeners() {
        this.ws.onopen = ()=>{
            if (this.opts.autoUnref) this.ws._socket.unref();
            this.onOpen();
        };
        this.ws.onclose = (closeEvent)=>this.onClose({
                description: "websocket connection closed",
                context: closeEvent
            });
        this.ws.onmessage = (ev)=>this.onData(ev.data);
        this.ws.onerror = (e)=>this.onError("websocket error", e);
    }
    write(packets) {
        this.writable = false;
        // encodePacket efficient as it uses WS framing
        // no need for encodePayload
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            (0, $c4185107dd03fd6c$export$57852049361a8e62)(packet, this.supportsBinary, (data)=>{
                // Sometimes the websocket has already been closed but the browser didn't
                // have a chance of informing us about it yet, in that case send will
                // throw an error
                try {
                    this.doWrite(packet, data);
                } catch (e) {}
                if (lastPacket) // fake drain
                // defer to next tick to allow Socket to clear writeBuffer
                (0, $78dda435b49a09da$export$bdd553fddd433dcb)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        if (typeof this.ws !== "undefined") {
            this.ws.onerror = ()=>{};
            this.ws.close();
            this.ws = null;
        }
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "wss" : "ws";
        const query = this.query || {};
        // append timestamp to URI
        if (this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $6ef350ea0a0dd88d$export$7fa8378418b4411e)();
        // communicate binary support capabilities
        if (!this.supportsBinary) query.b64 = 1;
        return this.createUri(schema, query);
    }
}
const $b532a5eecc323955$var$WebSocketCtor = (0, $78dda435b49a09da$export$394f9358f6231289).WebSocket || (0, $78dda435b49a09da$export$394f9358f6231289).MozWebSocket;
class $b532a5eecc323955$export$911baa0677ac404c extends $b532a5eecc323955$export$570bf71d2367e261 {
    createSocket(uri, protocols, opts) {
        return !$b532a5eecc323955$var$isReactNative ? protocols ? new $b532a5eecc323955$var$WebSocketCtor(uri, protocols) : new $b532a5eecc323955$var$WebSocketCtor(uri) : new $b532a5eecc323955$var$WebSocketCtor(uri, protocols, opts);
    }
    doWrite(_packet, data) {
        this.ws.send(data);
    }
}





class $9d7e081a924f8047$export$961c930859384407 extends (0, $3503e5787a975d0b$export$86495b081fef8e52) {
    get name() {
        return "webtransport";
    }
    doOpen() {
        try {
            // @ts-ignore
            this._transport = new WebTransport(this.createUri("https"), this.opts.transportOptions[this.name]);
        } catch (err) {
            return this.emitReserved("error", err);
        }
        this._transport.closed.then(()=>{
            this.onClose();
        }).catch((err)=>{
            this.onError("webtransport error", err);
        });
        // note: we could have used async/await, but that would require some additional polyfills
        this._transport.ready.then(()=>{
            this._transport.createBidirectionalStream().then((stream)=>{
                const decoderStream = (0, $a98a630babe996ba$export$552d20aac7500f47)(Number.MAX_SAFE_INTEGER, this.socket.binaryType);
                const reader = stream.readable.pipeThrough(decoderStream).getReader();
                const encoderStream = (0, $a98a630babe996ba$export$a525fb718e9c623a)();
                encoderStream.readable.pipeTo(stream.writable);
                this._writer = encoderStream.writable.getWriter();
                const read = ()=>{
                    reader.read().then(({ done: done, value: value })=>{
                        if (done) return;
                        this.onPacket(value);
                        read();
                    }).catch((err)=>{});
                };
                read();
                const packet = {
                    type: "open"
                };
                if (this.query.sid) packet.data = `{"sid":"${this.query.sid}"}`;
                this._writer.write(packet).then(()=>this.onOpen());
            });
        });
    }
    write(packets) {
        this.writable = false;
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            this._writer.write(packet).then(()=>{
                if (lastPacket) (0, $78dda435b49a09da$export$bdd553fddd433dcb)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        var _a;
        (_a = this._transport) === null || _a === void 0 || _a.close();
    }
}


const $035b186fd9c2fe37$export$46dec00755c1153b = {
    websocket: (0, $b532a5eecc323955$export$911baa0677ac404c),
    webtransport: (0, $9d7e081a924f8047$export$961c930859384407),
    polling: (0, $b2c670152e349ccd$export$a2d42eb087c10497)
};




// imported from https://github.com/galkn/parseuri
/**
 * Parses a URI
 *
 * Note: we could also have used the built-in URL object, but it isn't supported on all platforms.
 *
 * See:
 * - https://developer.mozilla.org/en-US/docs/Web/API/URL
 * - https://caniuse.com/url
 * - https://www.rfc-editor.org/rfc/rfc3986#appendix-B
 *
 * History of the parse() method:
 * - first commit: https://github.com/socketio/socket.io-client/commit/4ee1d5d94b3906a9c052b459f1a818b15f38f91c
 * - export into its own module: https://github.com/socketio/engine.io-client/commit/de2c561e4564efeb78f1bdb1ba39ef81b2822cb3
 * - reimport: https://github.com/socketio/engine.io-client/commit/df32277c3f6d622eec5ed09f493cae3f3391d242
 *
 * @author Steven Levithan <stevenlevithan.com> (MIT license)
 * @api private
 */ const $b73383f3220dcbef$var$re = /^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
const $b73383f3220dcbef$var$parts = [
    'source',
    'protocol',
    'authority',
    'userInfo',
    'user',
    'password',
    'host',
    'port',
    'relative',
    'path',
    'directory',
    'file',
    'query',
    'anchor'
];
function $b73383f3220dcbef$export$98e6a39c04603d36(str) {
    if (str.length > 8000) throw "URI too long";
    const src = str, b = str.indexOf('['), e = str.indexOf(']');
    if (b != -1 && e != -1) str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
    let m = $b73383f3220dcbef$var$re.exec(str || ''), uri = {}, i = 14;
    while(i--)uri[$b73383f3220dcbef$var$parts[i]] = m[i] || '';
    if (b != -1 && e != -1) {
        uri.source = src;
        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
        uri.ipv6uri = true;
    }
    uri.pathNames = $b73383f3220dcbef$var$pathNames(uri, uri['path']);
    uri.queryKey = $b73383f3220dcbef$var$queryKey(uri, uri['query']);
    return uri;
}
function $b73383f3220dcbef$var$pathNames(obj, path) {
    const regx = /\/{2,9}/g, names = path.replace(regx, "/").split("/");
    if (path.slice(0, 1) == '/' || path.length === 0) names.splice(0, 1);
    if (path.slice(-1) == '/') names.splice(names.length - 1, 1);
    return names;
}
function $b73383f3220dcbef$var$queryKey(uri, query) {
    const data = {};
    query.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function($0, $1, $2) {
        if ($1) data[$1] = $2;
    });
    return data;
}





const $5579d473e93c2027$var$withEventListeners = typeof addEventListener === "function" && typeof removeEventListener === "function";
const $5579d473e93c2027$var$OFFLINE_EVENT_LISTENERS = [];
if ($5579d473e93c2027$var$withEventListeners) // within a ServiceWorker, any event handler for the 'offline' event must be added on the initial evaluation of the
// script, so we create one single event listener here which will forward the event to the socket instances
addEventListener("offline", ()=>{
    $5579d473e93c2027$var$OFFLINE_EVENT_LISTENERS.forEach((listener)=>listener());
}, false);
class $5579d473e93c2027$export$3874118029a0ee0d extends (0, $b1d057b86753ac91$export$4293555f241ae35a) {
    /**
     * Socket constructor.
     *
     * @param {String|Object} uri - uri or options
     * @param {Object} opts - options
     */ constructor(uri, opts){
        super();
        this.binaryType = (0, $78dda435b49a09da$export$790dcbc41e2d75d5);
        this.writeBuffer = [];
        this._prevBufferLen = 0;
        this._pingInterval = -1;
        this._pingTimeout = -1;
        this._maxPayload = -1;
        /**
         * The expiration timestamp of the {@link _pingTimeoutTimer} object is tracked, in case the timer is throttled and the
         * callback is not fired on time. This can happen for example when a laptop is suspended or when a phone is locked.
         */ this._pingTimeoutTime = Infinity;
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = null;
        }
        if (uri) {
            const parsedUri = (0, $b73383f3220dcbef$export$98e6a39c04603d36)(uri);
            opts.hostname = parsedUri.host;
            opts.secure = parsedUri.protocol === "https" || parsedUri.protocol === "wss";
            opts.port = parsedUri.port;
            if (parsedUri.query) opts.query = parsedUri.query;
        } else if (opts.host) opts.hostname = (0, $b73383f3220dcbef$export$98e6a39c04603d36)(opts.host).host;
        (0, $6ef350ea0a0dd88d$export$2f67576668b97183)(this, opts);
        this.secure = null != opts.secure ? opts.secure : typeof location !== "undefined" && "https:" === location.protocol;
        if (opts.hostname && !opts.port) // if no port is specified manually, use the protocol default
        opts.port = this.secure ? "443" : "80";
        this.hostname = opts.hostname || (typeof location !== "undefined" ? location.hostname : "localhost");
        this.port = opts.port || (typeof location !== "undefined" && location.port ? location.port : this.secure ? "443" : "80");
        this.transports = [];
        this._transportsByName = {};
        opts.transports.forEach((t)=>{
            const transportName = t.prototype.name;
            this.transports.push(transportName);
            this._transportsByName[transportName] = t;
        });
        this.opts = Object.assign({
            path: "/engine.io",
            agent: false,
            withCredentials: false,
            upgrade: true,
            timestampParam: "t",
            rememberUpgrade: false,
            addTrailingSlash: true,
            rejectUnauthorized: true,
            perMessageDeflate: {
                threshold: 1024
            },
            transportOptions: {},
            closeOnBeforeunload: false
        }, opts);
        this.opts.path = this.opts.path.replace(/\/$/, "") + (this.opts.addTrailingSlash ? "/" : "");
        if (typeof this.opts.query === "string") this.opts.query = (0, $7913ae70c2a27fe9$export$2f872c0f2117be69)(this.opts.query);
        if ($5579d473e93c2027$var$withEventListeners) {
            if (this.opts.closeOnBeforeunload) {
                // Firefox closes the connection when the "beforeunload" event is emitted but not Chrome. This event listener
                // ensures every browser behaves the same (no "disconnect" event at the Socket.IO level when the page is
                // closed/reloaded)
                this._beforeunloadEventListener = ()=>{
                    if (this.transport) {
                        // silently close the transport
                        this.transport.removeAllListeners();
                        this.transport.close();
                    }
                };
                addEventListener("beforeunload", this._beforeunloadEventListener, false);
            }
            if (this.hostname !== "localhost") {
                this._offlineEventListener = ()=>{
                    this._onClose("transport close", {
                        description: "network connection lost"
                    });
                };
                $5579d473e93c2027$var$OFFLINE_EVENT_LISTENERS.push(this._offlineEventListener);
            }
        }
        if (this.opts.withCredentials) this._cookieJar = (0, $78dda435b49a09da$export$19413efcf2fac759)();
        this._open();
    }
    /**
     * Creates transport of the given type.
     *
     * @param {String} name - transport name
     * @return {Transport}
     * @private
     */ createTransport(name) {
        const query = Object.assign({}, this.opts.query);
        // append engine.io protocol identifier
        query.EIO = (0, $a98a630babe996ba$export$a51d6b395ff4c65a);
        // transport name
        query.transport = name;
        // session id if we already have one
        if (this.id) query.sid = this.id;
        const opts = Object.assign({}, this.opts, {
            query: query,
            socket: this,
            hostname: this.hostname,
            secure: this.secure,
            port: this.port
        }, this.opts.transportOptions[name]);
        return new this._transportsByName[name](opts);
    }
    /**
     * Initializes transport to use and starts probe.
     *
     * @private
     */ _open() {
        if (this.transports.length === 0) {
            // Emit error on next tick so it can be listened to
            this.setTimeoutFn(()=>{
                this.emitReserved("error", "No transports available");
            }, 0);
            return;
        }
        const transportName = this.opts.rememberUpgrade && $5579d473e93c2027$export$3874118029a0ee0d.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1 ? "websocket" : this.transports[0];
        this.readyState = "opening";
        const transport = this.createTransport(transportName);
        transport.open();
        this.setTransport(transport);
    }
    /**
     * Sets the current transport. Disables the existing one (if any).
     *
     * @private
     */ setTransport(transport) {
        if (this.transport) this.transport.removeAllListeners();
        // set up transport
        this.transport = transport;
        // set up transport listeners
        transport.on("drain", this._onDrain.bind(this)).on("packet", this._onPacket.bind(this)).on("error", this._onError.bind(this)).on("close", (reason)=>this._onClose("transport close", reason));
    }
    /**
     * Called when connection is deemed open.
     *
     * @private
     */ onOpen() {
        this.readyState = "open";
        $5579d473e93c2027$export$3874118029a0ee0d.priorWebsocketSuccess = "websocket" === this.transport.name;
        this.emitReserved("open");
        this.flush();
    }
    /**
     * Handles a packet.
     *
     * @private
     */ _onPacket(packet) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            this.emitReserved("packet", packet);
            // Socket is live - any packet counts
            this.emitReserved("heartbeat");
            switch(packet.type){
                case "open":
                    this.onHandshake(JSON.parse(packet.data));
                    break;
                case "ping":
                    this._sendPacket("pong");
                    this.emitReserved("ping");
                    this.emitReserved("pong");
                    this._resetPingTimeout();
                    break;
                case "error":
                    const err = new Error("server error");
                    // @ts-ignore
                    err.code = packet.data;
                    this._onError(err);
                    break;
                case "message":
                    this.emitReserved("data", packet.data);
                    this.emitReserved("message", packet.data);
                    break;
            }
        }
    }
    /**
     * Called upon handshake completion.
     *
     * @param {Object} data - handshake obj
     * @private
     */ onHandshake(data) {
        this.emitReserved("handshake", data);
        this.id = data.sid;
        this.transport.query.sid = data.sid;
        this._pingInterval = data.pingInterval;
        this._pingTimeout = data.pingTimeout;
        this._maxPayload = data.maxPayload;
        this.onOpen();
        // In case open handler closes socket
        if ("closed" === this.readyState) return;
        this._resetPingTimeout();
    }
    /**
     * Sets and resets ping timeout timer based on server pings.
     *
     * @private
     */ _resetPingTimeout() {
        this.clearTimeoutFn(this._pingTimeoutTimer);
        const delay = this._pingInterval + this._pingTimeout;
        this._pingTimeoutTime = Date.now() + delay;
        this._pingTimeoutTimer = this.setTimeoutFn(()=>{
            this._onClose("ping timeout");
        }, delay);
        if (this.opts.autoUnref) this._pingTimeoutTimer.unref();
    }
    /**
     * Called on `drain` event
     *
     * @private
     */ _onDrain() {
        this.writeBuffer.splice(0, this._prevBufferLen);
        // setting prevBufferLen = 0 is very important
        // for example, when upgrading, upgrade packet is sent over,
        // and a nonzero prevBufferLen could cause problems on `drain`
        this._prevBufferLen = 0;
        if (0 === this.writeBuffer.length) this.emitReserved("drain");
        else this.flush();
    }
    /**
     * Flush write buffers.
     *
     * @private
     */ flush() {
        if ("closed" !== this.readyState && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
            const packets = this._getWritablePackets();
            this.transport.send(packets);
            // keep track of current length of writeBuffer
            // splice writeBuffer and callbackBuffer on `drain`
            this._prevBufferLen = packets.length;
            this.emitReserved("flush");
        }
    }
    /**
     * Ensure the encoded size of the writeBuffer is below the maxPayload value sent by the server (only for HTTP
     * long-polling)
     *
     * @private
     */ _getWritablePackets() {
        const shouldCheckPayloadSize = this._maxPayload && this.transport.name === "polling" && this.writeBuffer.length > 1;
        if (!shouldCheckPayloadSize) return this.writeBuffer;
        let payloadSize = 1; // first packet type
        for(let i = 0; i < this.writeBuffer.length; i++){
            const data = this.writeBuffer[i].data;
            if (data) payloadSize += (0, $6ef350ea0a0dd88d$export$a48f0734ac7c2329)(data);
            if (i > 0 && payloadSize > this._maxPayload) return this.writeBuffer.slice(0, i);
            payloadSize += 2; // separator + packet type
        }
        return this.writeBuffer;
    }
    /**
     * Checks whether the heartbeat timer has expired but the socket has not yet been notified.
     *
     * Note: this method is private for now because it does not really fit the WebSocket API, but if we put it in the
     * `write()` method then the message would not be buffered by the Socket.IO client.
     *
     * @return {boolean}
     * @private
     */ /* private */ _hasPingExpired() {
        if (!this._pingTimeoutTime) return true;
        const hasExpired = Date.now() > this._pingTimeoutTime;
        if (hasExpired) {
            this._pingTimeoutTime = 0;
            (0, $78dda435b49a09da$export$bdd553fddd433dcb)(()=>{
                this._onClose("ping timeout");
            }, this.setTimeoutFn);
        }
        return hasExpired;
    }
    /**
     * Sends a message.
     *
     * @param {String} msg - message.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @return {Socket} for chaining.
     */ write(msg, options, fn) {
        this._sendPacket("message", msg, options, fn);
        return this;
    }
    /**
     * Sends a message. Alias of {@link Socket#write}.
     *
     * @param {String} msg - message.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @return {Socket} for chaining.
     */ send(msg, options, fn) {
        this._sendPacket("message", msg, options, fn);
        return this;
    }
    /**
     * Sends a packet.
     *
     * @param {String} type - packet type.
     * @param {String} data.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @private
     */ _sendPacket(type, data, options, fn) {
        if ("function" === typeof data) {
            fn = data;
            data = undefined;
        }
        if ("function" === typeof options) {
            fn = options;
            options = null;
        }
        if ("closing" === this.readyState || "closed" === this.readyState) return;
        options = options || {};
        options.compress = false !== options.compress;
        const packet = {
            type: type,
            data: data,
            options: options
        };
        this.emitReserved("packetCreate", packet);
        this.writeBuffer.push(packet);
        if (fn) this.once("flush", fn);
        this.flush();
    }
    /**
     * Closes the connection.
     */ close() {
        const close = ()=>{
            this._onClose("forced close");
            this.transport.close();
        };
        const cleanupAndClose = ()=>{
            this.off("upgrade", cleanupAndClose);
            this.off("upgradeError", cleanupAndClose);
            close();
        };
        const waitForUpgrade = ()=>{
            // wait for upgrade to finish since we can't send packets while pausing a transport
            this.once("upgrade", cleanupAndClose);
            this.once("upgradeError", cleanupAndClose);
        };
        if ("opening" === this.readyState || "open" === this.readyState) {
            this.readyState = "closing";
            if (this.writeBuffer.length) this.once("drain", ()=>{
                if (this.upgrading) waitForUpgrade();
                else close();
            });
            else if (this.upgrading) waitForUpgrade();
            else close();
        }
        return this;
    }
    /**
     * Called upon transport error
     *
     * @private
     */ _onError(err) {
        $5579d473e93c2027$export$3874118029a0ee0d.priorWebsocketSuccess = false;
        if (this.opts.tryAllTransports && this.transports.length > 1 && this.readyState === "opening") {
            this.transports.shift();
            return this._open();
        }
        this.emitReserved("error", err);
        this._onClose("transport error", err);
    }
    /**
     * Called upon transport close.
     *
     * @private
     */ _onClose(reason, description) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            // clear timers
            this.clearTimeoutFn(this._pingTimeoutTimer);
            // stop event from firing again for transport
            this.transport.removeAllListeners("close");
            // ensure transport won't stay open
            this.transport.close();
            // ignore further transport communication
            this.transport.removeAllListeners();
            if ($5579d473e93c2027$var$withEventListeners) {
                if (this._beforeunloadEventListener) removeEventListener("beforeunload", this._beforeunloadEventListener, false);
                if (this._offlineEventListener) {
                    const i = $5579d473e93c2027$var$OFFLINE_EVENT_LISTENERS.indexOf(this._offlineEventListener);
                    if (i !== -1) $5579d473e93c2027$var$OFFLINE_EVENT_LISTENERS.splice(i, 1);
                }
            }
            // set ready state
            this.readyState = "closed";
            // clear session id
            this.id = null;
            // emit close event
            this.emitReserved("close", reason, description);
            // clean buffers after, so users can still
            // grab the buffers on `close` event
            this.writeBuffer = [];
            this._prevBufferLen = 0;
        }
    }
}
$5579d473e93c2027$export$3874118029a0ee0d.protocol = (0, $a98a630babe996ba$export$a51d6b395ff4c65a);
class $5579d473e93c2027$export$cc521fcb1004e85c extends $5579d473e93c2027$export$3874118029a0ee0d {
    constructor(){
        super(...arguments);
        this._upgrades = [];
    }
    onOpen() {
        super.onOpen();
        if ("open" === this.readyState && this.opts.upgrade) for(let i = 0; i < this._upgrades.length; i++)this._probe(this._upgrades[i]);
    }
    /**
     * Probes a transport.
     *
     * @param {String} name - transport name
     * @private
     */ _probe(name) {
        let transport = this.createTransport(name);
        let failed = false;
        $5579d473e93c2027$export$3874118029a0ee0d.priorWebsocketSuccess = false;
        const onTransportOpen = ()=>{
            if (failed) return;
            transport.send([
                {
                    type: "ping",
                    data: "probe"
                }
            ]);
            transport.once("packet", (msg)=>{
                if (failed) return;
                if ("pong" === msg.type && "probe" === msg.data) {
                    this.upgrading = true;
                    this.emitReserved("upgrading", transport);
                    if (!transport) return;
                    $5579d473e93c2027$export$3874118029a0ee0d.priorWebsocketSuccess = "websocket" === transport.name;
                    this.transport.pause(()=>{
                        if (failed) return;
                        if ("closed" === this.readyState) return;
                        cleanup();
                        this.setTransport(transport);
                        transport.send([
                            {
                                type: "upgrade"
                            }
                        ]);
                        this.emitReserved("upgrade", transport);
                        transport = null;
                        this.upgrading = false;
                        this.flush();
                    });
                } else {
                    const err = new Error("probe error");
                    // @ts-ignore
                    err.transport = transport.name;
                    this.emitReserved("upgradeError", err);
                }
            });
        };
        function freezeTransport() {
            if (failed) return;
            // Any callback called by transport should be ignored since now
            failed = true;
            cleanup();
            transport.close();
            transport = null;
        }
        // Handle any error that happens while probing
        const onerror = (err)=>{
            const error = new Error("probe error: " + err);
            // @ts-ignore
            error.transport = transport.name;
            freezeTransport();
            this.emitReserved("upgradeError", error);
        };
        function onTransportClose() {
            onerror("transport closed");
        }
        // When the socket is closed while we're probing
        function onclose() {
            onerror("socket closed");
        }
        // When the socket is upgraded while we're probing
        function onupgrade(to) {
            if (transport && to.name !== transport.name) freezeTransport();
        }
        // Remove all listeners on the transport and on self
        const cleanup = ()=>{
            transport.removeListener("open", onTransportOpen);
            transport.removeListener("error", onerror);
            transport.removeListener("close", onTransportClose);
            this.off("close", onclose);
            this.off("upgrading", onupgrade);
        };
        transport.once("open", onTransportOpen);
        transport.once("error", onerror);
        transport.once("close", onTransportClose);
        this.once("close", onclose);
        this.once("upgrading", onupgrade);
        if (this._upgrades.indexOf("webtransport") !== -1 && name !== "webtransport") // favor WebTransport
        this.setTimeoutFn(()=>{
            if (!failed) transport.open();
        }, 200);
        else transport.open();
    }
    onHandshake(data) {
        this._upgrades = this._filterUpgrades(data.upgrades);
        super.onHandshake(data);
    }
    /**
     * Filters upgrades, returning only those matching client transports.
     *
     * @param {Array} upgrades - server upgrades
     * @private
     */ _filterUpgrades(upgrades) {
        const filteredUpgrades = [];
        for(let i = 0; i < upgrades.length; i++)if (~this.transports.indexOf(upgrades[i])) filteredUpgrades.push(upgrades[i]);
        return filteredUpgrades;
    }
}
class $5579d473e93c2027$export$4798917dbf149b79 extends $5579d473e93c2027$export$cc521fcb1004e85c {
    constructor(uri, opts = {}){
        const isOptionsOnly = typeof uri === "object";
        const o = isOptionsOnly ? {
            ...uri
        } : {
            ...opts
        };
        if (!o.transports || o.transports && typeof o.transports[0] === "string") o.transports = (o.transports || [
            "polling",
            "websocket",
            "webtransport"
        ]).map((transportName)=>(0, $035b186fd9c2fe37$export$46dec00755c1153b)[transportName]).filter((t)=>!!t);
        super(isOptionsOnly ? o : uri, o);
    }
}








class $b0af27e4230a6249$export$1e7deca84b429035 extends (0, $0b63fa11be6fda61$export$265ee5eefd4c309b) {
    doPoll() {
        this._fetch().then((res)=>{
            if (!res.ok) return this.onError("fetch read error", res.status, res);
            res.text().then((data)=>this.onData(data));
        }).catch((err)=>{
            this.onError("fetch read error", err);
        });
    }
    doWrite(data, callback) {
        this._fetch(data).then((res)=>{
            if (!res.ok) return this.onError("fetch write error", res.status, res);
            callback();
        }).catch((err)=>{
            this.onError("fetch write error", err);
        });
    }
    _fetch(data) {
        var _a;
        const isPost = data !== undefined;
        const headers = new Headers(this.opts.extraHeaders);
        if (isPost) headers.set("content-type", "text/plain;charset=UTF-8");
        (_a = this.socket._cookieJar) === null || _a === void 0 || _a.appendCookies(headers);
        return fetch(this.uri(), {
            method: isPost ? "POST" : "GET",
            body: isPost ? data : null,
            headers: headers,
            credentials: this.opts.withCredentials ? "include" : "omit"
        }).then((res)=>{
            var _a;
            // @ts-ignore getSetCookie() was added in Node.js v19.7.0
            (_a = this.socket._cookieJar) === null || _a === void 0 || _a.parseCookies(res.headers.getSetCookie());
            return res;
        });
    }
}







const $796b9ddb5a14eb25$export$a51d6b395ff4c65a = (0, $5579d473e93c2027$export$4798917dbf149b79).protocol;


function $3c201f22ef1fa1a0$export$128fa18b7194ef(uri, path = "", loc) {
    let obj = uri;
    // default to window.location
    loc = loc || typeof location !== "undefined" && location;
    if (null == uri) uri = loc.protocol + "//" + loc.host;
    // relative path support
    if (typeof uri === "string") {
        if ("/" === uri.charAt(0)) {
            if ("/" === uri.charAt(1)) uri = loc.protocol + uri;
            else uri = loc.host + uri;
        }
        if (!/^(https?|wss?):\/\//.test(uri)) {
            if ("undefined" !== typeof loc) uri = loc.protocol + "//" + uri;
            else uri = "https://" + uri;
        }
        // parse
        obj = (0, $b73383f3220dcbef$export$98e6a39c04603d36)(uri);
    }
    // make sure we treat `localhost:80` and `localhost` equally
    if (!obj.port) {
        if (/^(http|ws)$/.test(obj.protocol)) obj.port = "80";
        else if (/^(http|ws)s$/.test(obj.protocol)) obj.port = "443";
    }
    obj.path = obj.path || "/";
    const ipv6 = obj.host.indexOf(":") !== -1;
    const host = ipv6 ? "[" + obj.host + "]" : obj.host;
    // define unique id
    obj.id = obj.protocol + "://" + host + ":" + obj.port + path;
    // define href
    obj.href = obj.protocol + "://" + host + (loc && loc.port === obj.port ? "" : ":" + obj.port);
    return obj;
}



var $f35899b1336bcd3d$exports = {};

$parcel$export($f35899b1336bcd3d$exports, "protocol", function () { return $f35899b1336bcd3d$export$a51d6b395ff4c65a; });
$parcel$export($f35899b1336bcd3d$exports, "PacketType", function () { return $f35899b1336bcd3d$export$84d4095e16c6fc19; });
$parcel$export($f35899b1336bcd3d$exports, "Encoder", function () { return $f35899b1336bcd3d$export$a50aceb0e02a00aa; });
$parcel$export($f35899b1336bcd3d$exports, "Decoder", function () { return $f35899b1336bcd3d$export$f9de6ca0bc043724; });
$parcel$export($f35899b1336bcd3d$exports, "isPacketValid", function () { return $f35899b1336bcd3d$export$1a38ed17dcb5458e; });

const $4ae21e6667dc763d$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $4ae21e6667dc763d$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj.buffer instanceof ArrayBuffer;
};
const $4ae21e6667dc763d$var$toString = Object.prototype.toString;
const $4ae21e6667dc763d$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && $4ae21e6667dc763d$var$toString.call(Blob) === "[object BlobConstructor]";
const $4ae21e6667dc763d$var$withNativeFile = typeof File === "function" || typeof File !== "undefined" && $4ae21e6667dc763d$var$toString.call(File) === "[object FileConstructor]";
function $4ae21e6667dc763d$export$37488ff1135b1696(obj) {
    return $4ae21e6667dc763d$var$withNativeArrayBuffer && (obj instanceof ArrayBuffer || $4ae21e6667dc763d$var$isView(obj)) || $4ae21e6667dc763d$var$withNativeBlob && obj instanceof Blob || $4ae21e6667dc763d$var$withNativeFile && obj instanceof File;
}
function $4ae21e6667dc763d$export$5234c529abdb5610(obj, toJSON) {
    if (!obj || typeof obj !== "object") return false;
    if (Array.isArray(obj)) {
        for(let i = 0, l = obj.length; i < l; i++){
            if ($4ae21e6667dc763d$export$5234c529abdb5610(obj[i])) return true;
        }
        return false;
    }
    if ($4ae21e6667dc763d$export$37488ff1135b1696(obj)) return true;
    if (obj.toJSON && typeof obj.toJSON === "function" && arguments.length === 1) return $4ae21e6667dc763d$export$5234c529abdb5610(obj.toJSON(), true);
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key) && $4ae21e6667dc763d$export$5234c529abdb5610(obj[key])) return true;
    }
    return false;
}


function $9fcc2125db60224f$export$ac2edb9eb7af56f6(packet) {
    const buffers = [];
    const packetData = packet.data;
    const pack = packet;
    pack.data = $9fcc2125db60224f$var$_deconstructPacket(packetData, buffers);
    pack.attachments = buffers.length; // number of binary 'attachments'
    return {
        packet: pack,
        buffers: buffers
    };
}
function $9fcc2125db60224f$var$_deconstructPacket(data, buffers, toJSON) {
    if (!data) return data;
    if ((0, $4ae21e6667dc763d$export$37488ff1135b1696)(data)) {
        const placeholder = {
            _placeholder: true,
            num: buffers.length
        };
        buffers.push(data);
        return placeholder;
    } else if (Array.isArray(data)) {
        const newData = new Array(data.length);
        for(let i = 0; i < data.length; i++)newData[i] = $9fcc2125db60224f$var$_deconstructPacket(data[i], buffers);
        return newData;
    } else if (typeof data === "object" && !(data instanceof Date)) {
        if (data.toJSON && typeof data.toJSON === "function" && !toJSON) return $9fcc2125db60224f$var$_deconstructPacket(data.toJSON(), buffers, true);
        const newData = {};
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) newData[key] = $9fcc2125db60224f$var$_deconstructPacket(data[key], buffers);
        return newData;
    }
    return data;
}
function $9fcc2125db60224f$export$a00da3b1ec037a04(packet, buffers) {
    packet.data = $9fcc2125db60224f$var$_reconstructPacket(packet.data, buffers);
    delete packet.attachments; // no longer useful
    return packet;
}
function $9fcc2125db60224f$var$_reconstructPacket(data, buffers) {
    if (!data) return data;
    if (data && data._placeholder === true) {
        const isIndexValid = typeof data.num === "number" && data.num >= 0 && data.num < buffers.length;
        if (isIndexValid) return buffers[data.num]; // appropriate buffer (should be natural order anyway)
        else throw new Error("illegal attachments");
    } else if (Array.isArray(data)) for(let i = 0; i < data.length; i++)data[i] = $9fcc2125db60224f$var$_reconstructPacket(data[i], buffers);
    else if (typeof data === "object") {
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) data[key] = $9fcc2125db60224f$var$_reconstructPacket(data[key], buffers);
    }
    return data;
}



/**
 * These strings must not be used as event names, as they have a special meaning.
 */ const $f35899b1336bcd3d$var$RESERVED_EVENTS = [
    "connect",
    "connect_error",
    "disconnect",
    "disconnecting",
    "newListener",
    "removeListener"
];
const $f35899b1336bcd3d$export$a51d6b395ff4c65a = 5;
var $f35899b1336bcd3d$export$84d4095e16c6fc19;
(function(PacketType) {
    PacketType[PacketType["CONNECT"] = 0] = "CONNECT";
    PacketType[PacketType["DISCONNECT"] = 1] = "DISCONNECT";
    PacketType[PacketType["EVENT"] = 2] = "EVENT";
    PacketType[PacketType["ACK"] = 3] = "ACK";
    PacketType[PacketType["CONNECT_ERROR"] = 4] = "CONNECT_ERROR";
    PacketType[PacketType["BINARY_EVENT"] = 5] = "BINARY_EVENT";
    PacketType[PacketType["BINARY_ACK"] = 6] = "BINARY_ACK";
})($f35899b1336bcd3d$export$84d4095e16c6fc19 || ($f35899b1336bcd3d$export$84d4095e16c6fc19 = {}));
class $f35899b1336bcd3d$export$a50aceb0e02a00aa {
    /**
     * Encoder constructor
     *
     * @param {function} replacer - custom replacer to pass down to JSON.parse
     */ constructor(replacer){
        this.replacer = replacer;
    }
    /**
     * Encode a packet as a single string if non-binary, or as a
     * buffer sequence, depending on packet type.
     *
     * @param {Object} obj - packet object
     */ encode(obj) {
        if (obj.type === $f35899b1336bcd3d$export$84d4095e16c6fc19.EVENT || obj.type === $f35899b1336bcd3d$export$84d4095e16c6fc19.ACK) {
            if ((0, $4ae21e6667dc763d$export$5234c529abdb5610)(obj)) return this.encodeAsBinary({
                type: obj.type === $f35899b1336bcd3d$export$84d4095e16c6fc19.EVENT ? $f35899b1336bcd3d$export$84d4095e16c6fc19.BINARY_EVENT : $f35899b1336bcd3d$export$84d4095e16c6fc19.BINARY_ACK,
                nsp: obj.nsp,
                data: obj.data,
                id: obj.id
            });
        }
        return [
            this.encodeAsString(obj)
        ];
    }
    /**
     * Encode packet as string.
     */ encodeAsString(obj) {
        // first is type
        let str = "" + obj.type;
        // attachments if we have them
        if (obj.type === $f35899b1336bcd3d$export$84d4095e16c6fc19.BINARY_EVENT || obj.type === $f35899b1336bcd3d$export$84d4095e16c6fc19.BINARY_ACK) str += obj.attachments + "-";
        // if we have a namespace other than `/`
        // we append it followed by a comma `,`
        if (obj.nsp && "/" !== obj.nsp) str += obj.nsp + ",";
        // immediately followed by the id
        if (null != obj.id) str += obj.id;
        // json data
        if (null != obj.data) str += JSON.stringify(obj.data, this.replacer);
        return str;
    }
    /**
     * Encode packet as 'buffer sequence' by removing blobs, and
     * deconstructing packet into object with placeholders and
     * a list of buffers.
     */ encodeAsBinary(obj) {
        const deconstruction = (0, $9fcc2125db60224f$export$ac2edb9eb7af56f6)(obj);
        const pack = this.encodeAsString(deconstruction.packet);
        const buffers = deconstruction.buffers;
        buffers.unshift(pack); // add packet info to beginning of data list
        return buffers; // write all the buffers
    }
}
class $f35899b1336bcd3d$export$f9de6ca0bc043724 extends (0, $b1d057b86753ac91$export$4293555f241ae35a) {
    /**
     * Decoder constructor
     */ constructor(opts){
        super();
        this.opts = Object.assign({
            reviver: undefined,
            maxAttachments: 10
        }, typeof opts === "function" ? {
            reviver: opts
        } : opts);
    }
    /**
     * Decodes an encoded packet string into packet JSON.
     *
     * @param {String} obj - encoded packet
     */ add(obj) {
        let packet;
        if (typeof obj === "string") {
            if (this.reconstructor) throw new Error("got plaintext data when reconstructing a packet");
            packet = this.decodeString(obj);
            const isBinaryEvent = packet.type === $f35899b1336bcd3d$export$84d4095e16c6fc19.BINARY_EVENT;
            if (isBinaryEvent || packet.type === $f35899b1336bcd3d$export$84d4095e16c6fc19.BINARY_ACK) {
                packet.type = isBinaryEvent ? $f35899b1336bcd3d$export$84d4095e16c6fc19.EVENT : $f35899b1336bcd3d$export$84d4095e16c6fc19.ACK;
                // binary packet's json
                this.reconstructor = new $f35899b1336bcd3d$var$BinaryReconstructor(packet);
            } else // non-binary full packet
            super.emitReserved("decoded", packet);
        } else if ((0, $4ae21e6667dc763d$export$37488ff1135b1696)(obj) || obj.base64) {
            // raw binary data
            if (!this.reconstructor) throw new Error("got binary data when not reconstructing a packet");
            else {
                packet = this.reconstructor.takeBinaryData(obj);
                if (packet) {
                    // received final buffer
                    this.reconstructor = null;
                    super.emitReserved("decoded", packet);
                }
            }
        } else throw new Error("Unknown type: " + obj);
    }
    /**
     * Decode a packet String (JSON data)
     *
     * @param {String} str
     * @return {Object} packet
     */ decodeString(str) {
        let i = 0;
        // look up type
        const p = {
            type: Number(str.charAt(0))
        };
        if ($f35899b1336bcd3d$export$84d4095e16c6fc19[p.type] === undefined) throw new Error("unknown packet type " + p.type);
        // look up attachments if type binary
        if (p.type === $f35899b1336bcd3d$export$84d4095e16c6fc19.BINARY_EVENT || p.type === $f35899b1336bcd3d$export$84d4095e16c6fc19.BINARY_ACK) {
            const start = i + 1;
            while(str.charAt(++i) !== "-" && i != str.length);
            const buf = str.substring(start, i);
            if (buf != Number(buf) || str.charAt(i) !== "-") throw new Error("Illegal attachments");
            const n = Number(buf);
            if (!$f35899b1336bcd3d$var$isInteger(n) || n < 1) throw new Error("Illegal attachments");
            else if (n > this.opts.maxAttachments) throw new Error("too many attachments");
            p.attachments = n;
        }
        // look up namespace (if any)
        if ("/" === str.charAt(i + 1)) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if ("," === c) break;
                if (i === str.length) break;
            }
            p.nsp = str.substring(start, i);
        } else p.nsp = "/";
        // look up id
        const next = str.charAt(i + 1);
        if ("" !== next && Number(next) == next) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if (null == c || Number(c) != c) {
                    --i;
                    break;
                }
                if (i === str.length) break;
            }
            p.id = Number(str.substring(start, i + 1));
        }
        // look up json data
        if (str.charAt(++i)) {
            const payload = this.tryParse(str.substr(i));
            if ($f35899b1336bcd3d$export$f9de6ca0bc043724.isPayloadValid(p.type, payload)) p.data = payload;
            else throw new Error("invalid payload");
        }
        return p;
    }
    tryParse(str) {
        try {
            return JSON.parse(str, this.opts.reviver);
        } catch (e) {
            return false;
        }
    }
    static isPayloadValid(type, payload) {
        switch(type){
            case $f35899b1336bcd3d$export$84d4095e16c6fc19.CONNECT:
                return $f35899b1336bcd3d$var$isObject(payload);
            case $f35899b1336bcd3d$export$84d4095e16c6fc19.DISCONNECT:
                return payload === undefined;
            case $f35899b1336bcd3d$export$84d4095e16c6fc19.CONNECT_ERROR:
                return typeof payload === "string" || $f35899b1336bcd3d$var$isObject(payload);
            case $f35899b1336bcd3d$export$84d4095e16c6fc19.EVENT:
            case $f35899b1336bcd3d$export$84d4095e16c6fc19.BINARY_EVENT:
                return Array.isArray(payload) && (typeof payload[0] === "number" || typeof payload[0] === "string" && $f35899b1336bcd3d$var$RESERVED_EVENTS.indexOf(payload[0]) === -1);
            case $f35899b1336bcd3d$export$84d4095e16c6fc19.ACK:
            case $f35899b1336bcd3d$export$84d4095e16c6fc19.BINARY_ACK:
                return Array.isArray(payload);
        }
    }
    /**
     * Deallocates a parser's resources
     */ destroy() {
        if (this.reconstructor) {
            this.reconstructor.finishedReconstruction();
            this.reconstructor = null;
        }
    }
}
/**
 * A manager of a binary event's 'buffer sequence'. Should
 * be constructed whenever a packet of type BINARY_EVENT is
 * decoded.
 *
 * @param {Object} packet
 * @return {BinaryReconstructor} initialized reconstructor
 */ class $f35899b1336bcd3d$var$BinaryReconstructor {
    constructor(packet){
        this.packet = packet;
        this.buffers = [];
        this.reconPack = packet;
    }
    /**
     * Method to be called when binary data received from connection
     * after a BINARY_EVENT packet.
     *
     * @param {Buffer | ArrayBuffer} binData - the raw binary data received
     * @return {null | Object} returns null if more binary data is expected or
     *   a reconstructed packet object if all buffers have been received.
     */ takeBinaryData(binData) {
        this.buffers.push(binData);
        if (this.buffers.length === this.reconPack.attachments) {
            // done with buffer list
            const packet = (0, $9fcc2125db60224f$export$a00da3b1ec037a04)(this.reconPack, this.buffers);
            this.finishedReconstruction();
            return packet;
        }
        return null;
    }
    /**
     * Cleans up binary packet reconstruction variables.
     */ finishedReconstruction() {
        this.reconPack = null;
        this.buffers = [];
    }
}
function $f35899b1336bcd3d$var$isNamespaceValid(nsp) {
    return typeof nsp === "string";
}
// see https://caniuse.com/mdn-javascript_builtins_number_isinteger
const $f35899b1336bcd3d$var$isInteger = Number.isInteger || function(value) {
    return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
};
function $f35899b1336bcd3d$var$isAckIdValid(id) {
    return id === undefined || $f35899b1336bcd3d$var$isInteger(id);
}
// see https://stackoverflow.com/questions/8511281/check-if-a-value-is-an-object-in-javascript
function $f35899b1336bcd3d$var$isObject(value) {
    return Object.prototype.toString.call(value) === "[object Object]";
}
function $f35899b1336bcd3d$var$isDataValid(type, payload) {
    switch(type){
        case $f35899b1336bcd3d$export$84d4095e16c6fc19.CONNECT:
            return payload === undefined || $f35899b1336bcd3d$var$isObject(payload);
        case $f35899b1336bcd3d$export$84d4095e16c6fc19.DISCONNECT:
            return payload === undefined;
        case $f35899b1336bcd3d$export$84d4095e16c6fc19.EVENT:
            return Array.isArray(payload) && (typeof payload[0] === "number" || typeof payload[0] === "string" && $f35899b1336bcd3d$var$RESERVED_EVENTS.indexOf(payload[0]) === -1);
        case $f35899b1336bcd3d$export$84d4095e16c6fc19.ACK:
            return Array.isArray(payload);
        case $f35899b1336bcd3d$export$84d4095e16c6fc19.CONNECT_ERROR:
            return typeof payload === "string" || $f35899b1336bcd3d$var$isObject(payload);
        default:
            return false;
    }
}
function $f35899b1336bcd3d$export$1a38ed17dcb5458e(packet) {
    return $f35899b1336bcd3d$var$isNamespaceValid(packet.nsp) && $f35899b1336bcd3d$var$isAckIdValid(packet.id) && $f35899b1336bcd3d$var$isDataValid(packet.type, packet.data);
}


function $7ef62b04f1ea5e9b$export$af631764ddc44097(obj, ev, fn) {
    obj.on(ev, fn);
    return function subDestroy() {
        obj.off(ev, fn);
    };
}



/**
 * Internal events.
 * These events can't be emitted by the user.
 */ const $9063e16d38b294db$var$RESERVED_EVENTS = Object.freeze({
    connect: 1,
    connect_error: 1,
    disconnect: 1,
    disconnecting: 1,
    // EventEmitter reserved events: https://nodejs.org/api/events.html#events_event_newlistener
    newListener: 1,
    removeListener: 1
});
class $9063e16d38b294db$export$4798917dbf149b79 extends (0, $b1d057b86753ac91$export$4293555f241ae35a) {
    /**
     * `Socket` constructor.
     */ constructor(io, nsp, opts){
        super();
        /**
         * Whether the socket is currently connected to the server.
         *
         * @example
         * const socket = io();
         *
         * socket.on("connect", () => {
         *   console.log(socket.connected); // true
         * });
         *
         * socket.on("disconnect", () => {
         *   console.log(socket.connected); // false
         * });
         */ this.connected = false;
        /**
         * Whether the connection state was recovered after a temporary disconnection. In that case, any missed packets will
         * be transmitted by the server.
         */ this.recovered = false;
        /**
         * Buffer for packets received before the CONNECT packet
         */ this.receiveBuffer = [];
        /**
         * Buffer for packets that will be sent once the socket is connected
         */ this.sendBuffer = [];
        /**
         * The queue of packets to be sent with retry in case of failure.
         *
         * Packets are sent one by one, each waiting for the server acknowledgement, in order to guarantee the delivery order.
         * @private
         */ this._queue = [];
        /**
         * A sequence to generate the ID of the {@link QueuedPacket}.
         * @private
         */ this._queueSeq = 0;
        this.ids = 0;
        /**
         * A map containing acknowledgement handlers.
         *
         * The `withError` attribute is used to differentiate handlers that accept an error as first argument:
         *
         * - `socket.emit("test", (err, value) => { ... })` with `ackTimeout` option
         * - `socket.timeout(5000).emit("test", (err, value) => { ... })`
         * - `const value = await socket.emitWithAck("test")`
         *
         * From those that don't:
         *
         * - `socket.emit("test", (value) => { ... });`
         *
         * In the first case, the handlers will be called with an error when:
         *
         * - the timeout is reached
         * - the socket gets disconnected
         *
         * In the second case, the handlers will be simply discarded upon disconnection, since the client will never receive
         * an acknowledgement from the server.
         *
         * @private
         */ this.acks = {};
        this.flags = {};
        this.io = io;
        this.nsp = nsp;
        if (opts && opts.auth) this.auth = opts.auth;
        this._opts = Object.assign({}, opts);
        if (this.io._autoConnect) this.open();
    }
    /**
     * Whether the socket is currently disconnected
     *
     * @example
     * const socket = io();
     *
     * socket.on("connect", () => {
     *   console.log(socket.disconnected); // false
     * });
     *
     * socket.on("disconnect", () => {
     *   console.log(socket.disconnected); // true
     * });
     */ get disconnected() {
        return !this.connected;
    }
    /**
     * Subscribe to open, close and packet events
     *
     * @private
     */ subEvents() {
        if (this.subs) return;
        const io = this.io;
        this.subs = [
            (0, $7ef62b04f1ea5e9b$export$af631764ddc44097)(io, "open", this.onopen.bind(this)),
            (0, $7ef62b04f1ea5e9b$export$af631764ddc44097)(io, "packet", this.onpacket.bind(this)),
            (0, $7ef62b04f1ea5e9b$export$af631764ddc44097)(io, "error", this.onerror.bind(this)),
            (0, $7ef62b04f1ea5e9b$export$af631764ddc44097)(io, "close", this.onclose.bind(this))
        ];
    }
    /**
     * Whether the Socket will try to reconnect when its Manager connects or reconnects.
     *
     * @example
     * const socket = io();
     *
     * console.log(socket.active); // true
     *
     * socket.on("disconnect", (reason) => {
     *   if (reason === "io server disconnect") {
     *     // the disconnection was initiated by the server, you need to manually reconnect
     *     console.log(socket.active); // false
     *   }
     *   // else the socket will automatically try to reconnect
     *   console.log(socket.active); // true
     * });
     */ get active() {
        return !!this.subs;
    }
    /**
     * "Opens" the socket.
     *
     * @example
     * const socket = io({
     *   autoConnect: false
     * });
     *
     * socket.connect();
     */ connect() {
        if (this.connected) return this;
        this.subEvents();
        if (!this.io["_reconnecting"]) this.io.open(); // ensure open
        if ("open" === this.io._readyState) this.onopen();
        return this;
    }
    /**
     * Alias for {@link connect()}.
     */ open() {
        return this.connect();
    }
    /**
     * Sends a `message` event.
     *
     * This method mimics the WebSocket.send() method.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/send
     *
     * @example
     * socket.send("hello");
     *
     * // this is equivalent to
     * socket.emit("message", "hello");
     *
     * @return self
     */ send(...args) {
        args.unshift("message");
        this.emit.apply(this, args);
        return this;
    }
    /**
     * Override `emit`.
     * If the event is in `events`, it's emitted normally.
     *
     * @example
     * socket.emit("hello", "world");
     *
     * // all serializable datastructures are supported (no need to call JSON.stringify)
     * socket.emit("hello", 1, "2", { 3: ["4"], 5: Uint8Array.from([6]) });
     *
     * // with an acknowledgement from the server
     * socket.emit("hello", "world", (val) => {
     *   // ...
     * });
     *
     * @return self
     */ emit(ev, ...args) {
        var _a, _b, _c;
        if ($9063e16d38b294db$var$RESERVED_EVENTS.hasOwnProperty(ev)) throw new Error('"' + ev.toString() + '" is a reserved event name');
        args.unshift(ev);
        if (this._opts.retries && !this.flags.fromQueue && !this.flags.volatile) {
            this._addToQueue(args);
            return this;
        }
        const packet = {
            type: (0, $f35899b1336bcd3d$export$84d4095e16c6fc19).EVENT,
            data: args
        };
        packet.options = {};
        packet.options.compress = this.flags.compress !== false;
        // event ack callback
        if ("function" === typeof args[args.length - 1]) {
            const id = this.ids++;
            const ack = args.pop();
            this._registerAckCallback(id, ack);
            packet.id = id;
        }
        const isTransportWritable = (_b = (_a = this.io.engine) === null || _a === void 0 ? void 0 : _a.transport) === null || _b === void 0 ? void 0 : _b.writable;
        const isConnected = this.connected && !((_c = this.io.engine) === null || _c === void 0 ? void 0 : _c._hasPingExpired());
        const discardPacket = this.flags.volatile && !isTransportWritable;
        if (discardPacket) ;
        else if (isConnected) {
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        } else this.sendBuffer.push(packet);
        this.flags = {};
        return this;
    }
    /**
     * @private
     */ _registerAckCallback(id, ack) {
        var _a;
        const timeout = (_a = this.flags.timeout) !== null && _a !== void 0 ? _a : this._opts.ackTimeout;
        if (timeout === undefined) {
            this.acks[id] = ack;
            return;
        }
        // @ts-ignore
        const timer = this.io.setTimeoutFn(()=>{
            delete this.acks[id];
            for(let i = 0; i < this.sendBuffer.length; i++)if (this.sendBuffer[i].id === id) this.sendBuffer.splice(i, 1);
            ack.call(this, new Error("operation has timed out"));
        }, timeout);
        const fn = (...args)=>{
            // @ts-ignore
            this.io.clearTimeoutFn(timer);
            ack.apply(this, args);
        };
        fn.withError = true;
        this.acks[id] = fn;
    }
    /**
     * Emits an event and waits for an acknowledgement
     *
     * @example
     * // without timeout
     * const response = await socket.emitWithAck("hello", "world");
     *
     * // with a specific timeout
     * try {
     *   const response = await socket.timeout(1000).emitWithAck("hello", "world");
     * } catch (err) {
     *   // the server did not acknowledge the event in the given delay
     * }
     *
     * @return a Promise that will be fulfilled when the server acknowledges the event
     */ emitWithAck(ev, ...args) {
        return new Promise((resolve, reject)=>{
            const fn = (arg1, arg2)=>{
                return arg1 ? reject(arg1) : resolve(arg2);
            };
            fn.withError = true;
            args.push(fn);
            this.emit(ev, ...args);
        });
    }
    /**
     * Add the packet to the queue.
     * @param args
     * @private
     */ _addToQueue(args) {
        let ack;
        if (typeof args[args.length - 1] === "function") ack = args.pop();
        const packet = {
            id: this._queueSeq++,
            tryCount: 0,
            pending: false,
            args: args,
            flags: Object.assign({
                fromQueue: true
            }, this.flags)
        };
        args.push((err, ...responseArgs)=>{
            this._queue[0];
            const hasError = err !== null;
            if (hasError) {
                if (packet.tryCount > this._opts.retries) {
                    this._queue.shift();
                    if (ack) ack(err);
                }
            } else {
                this._queue.shift();
                if (ack) ack(null, ...responseArgs);
            }
            packet.pending = false;
            return this._drainQueue();
        });
        this._queue.push(packet);
        this._drainQueue();
    }
    /**
     * Send the first packet of the queue, and wait for an acknowledgement from the server.
     * @param force - whether to resend a packet that has not been acknowledged yet
     *
     * @private
     */ _drainQueue(force = false) {
        if (!this.connected || this._queue.length === 0) return;
        const packet = this._queue[0];
        if (packet.pending && !force) return;
        packet.pending = true;
        packet.tryCount++;
        this.flags = packet.flags;
        this.emit.apply(this, packet.args);
    }
    /**
     * Sends a packet.
     *
     * @param packet
     * @private
     */ packet(packet) {
        packet.nsp = this.nsp;
        this.io._packet(packet);
    }
    /**
     * Called upon engine `open`.
     *
     * @private
     */ onopen() {
        if (typeof this.auth == "function") this.auth((data)=>{
            this._sendConnectPacket(data);
        });
        else this._sendConnectPacket(this.auth);
    }
    /**
     * Sends a CONNECT packet to initiate the Socket.IO session.
     *
     * @param data
     * @private
     */ _sendConnectPacket(data) {
        this.packet({
            type: (0, $f35899b1336bcd3d$export$84d4095e16c6fc19).CONNECT,
            data: this._pid ? Object.assign({
                pid: this._pid,
                offset: this._lastOffset
            }, data) : data
        });
    }
    /**
     * Called upon engine or manager `error`.
     *
     * @param err
     * @private
     */ onerror(err) {
        if (!this.connected) this.emitReserved("connect_error", err);
    }
    /**
     * Called upon engine `close`.
     *
     * @param reason
     * @param description
     * @private
     */ onclose(reason, description) {
        this.connected = false;
        delete this.id;
        this.emitReserved("disconnect", reason, description);
        this._clearAcks();
    }
    /**
     * Clears the acknowledgement handlers upon disconnection, since the client will never receive an acknowledgement from
     * the server.
     *
     * @private
     */ _clearAcks() {
        Object.keys(this.acks).forEach((id)=>{
            const isBuffered = this.sendBuffer.some((packet)=>String(packet.id) === id);
            if (!isBuffered) {
                // note: handlers that do not accept an error as first argument are ignored here
                const ack = this.acks[id];
                delete this.acks[id];
                if (ack.withError) ack.call(this, new Error("socket has been disconnected"));
            }
        });
    }
    /**
     * Called with socket packet.
     *
     * @param packet
     * @private
     */ onpacket(packet) {
        const sameNamespace = packet.nsp === this.nsp;
        if (!sameNamespace) return;
        switch(packet.type){
            case (0, $f35899b1336bcd3d$export$84d4095e16c6fc19).CONNECT:
                if (packet.data && packet.data.sid) this.onconnect(packet.data.sid, packet.data.pid);
                else this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
                break;
            case (0, $f35899b1336bcd3d$export$84d4095e16c6fc19).EVENT:
            case (0, $f35899b1336bcd3d$export$84d4095e16c6fc19).BINARY_EVENT:
                this.onevent(packet);
                break;
            case (0, $f35899b1336bcd3d$export$84d4095e16c6fc19).ACK:
            case (0, $f35899b1336bcd3d$export$84d4095e16c6fc19).BINARY_ACK:
                this.onack(packet);
                break;
            case (0, $f35899b1336bcd3d$export$84d4095e16c6fc19).DISCONNECT:
                this.ondisconnect();
                break;
            case (0, $f35899b1336bcd3d$export$84d4095e16c6fc19).CONNECT_ERROR:
                this.destroy();
                const err = new Error(packet.data.message);
                err.data = packet.data.data;
                this.emitReserved("connect_error", err);
                break;
        }
    }
    /**
     * Called upon a server event.
     *
     * @param packet
     * @private
     */ onevent(packet) {
        const args = packet.data || [];
        if (null != packet.id) args.push(this.ack(packet.id));
        if (this.connected) this.emitEvent(args);
        else this.receiveBuffer.push(Object.freeze(args));
    }
    emitEvent(args) {
        if (this._anyListeners && this._anyListeners.length) {
            const listeners = this._anyListeners.slice();
            for (const listener of listeners)listener.apply(this, args);
        }
        super.emit.apply(this, args);
        if (this._pid && args.length && typeof args[args.length - 1] === "string") this._lastOffset = args[args.length - 1];
    }
    /**
     * Produces an ack callback to emit with an event.
     *
     * @private
     */ ack(id) {
        const self = this;
        let sent = false;
        return function(...args) {
            // prevent double callbacks
            if (sent) return;
            sent = true;
            self.packet({
                type: (0, $f35899b1336bcd3d$export$84d4095e16c6fc19).ACK,
                id: id,
                data: args
            });
        };
    }
    /**
     * Called upon a server acknowledgement.
     *
     * @param packet
     * @private
     */ onack(packet) {
        const ack = this.acks[packet.id];
        if (typeof ack !== "function") return;
        delete this.acks[packet.id];
        // @ts-ignore FIXME ack is incorrectly inferred as 'never'
        if (ack.withError) packet.data.unshift(null);
        // @ts-ignore
        ack.apply(this, packet.data);
    }
    /**
     * Called upon server connect.
     *
     * @private
     */ onconnect(id, pid) {
        this.id = id;
        this.recovered = pid && this._pid === pid;
        this._pid = pid; // defined only if connection state recovery is enabled
        this.connected = true;
        this.emitBuffered();
        this._drainQueue(true);
        this.emitReserved("connect");
    }
    /**
     * Emit buffered events (received and emitted).
     *
     * @private
     */ emitBuffered() {
        this.receiveBuffer.forEach((args)=>this.emitEvent(args));
        this.receiveBuffer = [];
        this.sendBuffer.forEach((packet)=>{
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        });
        this.sendBuffer = [];
    }
    /**
     * Called upon server disconnect.
     *
     * @private
     */ ondisconnect() {
        this.destroy();
        this.onclose("io server disconnect");
    }
    /**
     * Called upon forced client/server side disconnections,
     * this method ensures the manager stops tracking us and
     * that reconnections don't get triggered for this.
     *
     * @private
     */ destroy() {
        if (this.subs) {
            // clean subscriptions to avoid reconnections
            this.subs.forEach((subDestroy)=>subDestroy());
            this.subs = undefined;
        }
        this.io["_destroy"](this);
    }
    /**
     * Disconnects the socket manually. In that case, the socket will not try to reconnect.
     *
     * If this is the last active Socket instance of the {@link Manager}, the low-level connection will be closed.
     *
     * @example
     * const socket = io();
     *
     * socket.on("disconnect", (reason) => {
     *   // console.log(reason); prints "io client disconnect"
     * });
     *
     * socket.disconnect();
     *
     * @return self
     */ disconnect() {
        if (this.connected) this.packet({
            type: (0, $f35899b1336bcd3d$export$84d4095e16c6fc19).DISCONNECT
        });
        // remove socket from pool
        this.destroy();
        if (this.connected) // fire events
        this.onclose("io client disconnect");
        return this;
    }
    /**
     * Alias for {@link disconnect()}.
     *
     * @return self
     */ close() {
        return this.disconnect();
    }
    /**
     * Sets the compress flag.
     *
     * @example
     * socket.compress(false).emit("hello");
     *
     * @param compress - if `true`, compresses the sending data
     * @return self
     */ compress(compress) {
        this.flags.compress = compress;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the event message will be dropped when this socket is not
     * ready to send messages.
     *
     * @example
     * socket.volatile.emit("hello"); // the server may or may not receive it
     *
     * @returns self
     */ get volatile() {
        this.flags.volatile = true;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the callback will be called with an error when the
     * given number of milliseconds have elapsed without an acknowledgement from the server:
     *
     * @example
     * socket.timeout(5000).emit("my-event", (err) => {
     *   if (err) {
     *     // the server did not acknowledge the event in the given delay
     *   }
     * });
     *
     * @returns self
     */ timeout(timeout) {
        this.flags.timeout = timeout;
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * @example
     * socket.onAny((event, ...args) => {
     *   console.log(`got ${event}`);
     * });
     *
     * @param listener
     */ onAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * @example
     * socket.prependAny((event, ...args) => {
     *   console.log(`got event ${event}`);
     * });
     *
     * @param listener
     */ prependAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`got event ${event}`);
     * }
     *
     * socket.onAny(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAny(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAny();
     *
     * @param listener
     */ offAny(listener) {
        if (!this._anyListeners) return this;
        if (listener) {
            const listeners = this._anyListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAny() {
        return this._anyListeners || [];
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.onAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ onAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.prependAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ prependAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`sent event ${event}`);
     * }
     *
     * socket.onAnyOutgoing(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAnyOutgoing(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAnyOutgoing();
     *
     * @param [listener] - the catch-all listener (optional)
     */ offAnyOutgoing(listener) {
        if (!this._anyOutgoingListeners) return this;
        if (listener) {
            const listeners = this._anyOutgoingListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyOutgoingListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAnyOutgoing() {
        return this._anyOutgoingListeners || [];
    }
    /**
     * Notify the listeners for each packet sent
     *
     * @param packet
     *
     * @private
     */ notifyOutgoingListeners(packet) {
        if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
            const listeners = this._anyOutgoingListeners.slice();
            for (const listener of listeners)listener.apply(this, packet.data);
        }
    }
}




/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */ function $4d06434d3f654aec$export$2d38012449449c89(opts) {
    opts = opts || {};
    this.ms = opts.min || 100;
    this.max = opts.max || 10000;
    this.factor = opts.factor || 2;
    this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
    this.attempts = 0;
}
/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */ $4d06434d3f654aec$export$2d38012449449c89.prototype.duration = function() {
    var ms = this.ms * Math.pow(this.factor, this.attempts++);
    if (this.jitter) {
        var rand = Math.random();
        var deviation = Math.floor(rand * this.jitter * ms);
        ms = (Math.floor(rand * 10) & 1) == 0 ? ms - deviation : ms + deviation;
    }
    return Math.min(ms, this.max) | 0;
};
/**
 * Reset the number of attempts.
 *
 * @api public
 */ $4d06434d3f654aec$export$2d38012449449c89.prototype.reset = function() {
    this.attempts = 0;
};
/**
 * Set the minimum duration
 *
 * @api public
 */ $4d06434d3f654aec$export$2d38012449449c89.prototype.setMin = function(min) {
    this.ms = min;
};
/**
 * Set the maximum duration
 *
 * @api public
 */ $4d06434d3f654aec$export$2d38012449449c89.prototype.setMax = function(max) {
    this.max = max;
};
/**
 * Set the jitter
 *
 * @api public
 */ $4d06434d3f654aec$export$2d38012449449c89.prototype.setJitter = function(jitter) {
    this.jitter = jitter;
};



class $37c89cd8a39fabd4$export$d0d38e7dec7a1a61 extends (0, $b1d057b86753ac91$export$4293555f241ae35a) {
    constructor(uri, opts){
        var _a;
        super();
        this.nsps = {};
        this.subs = [];
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = undefined;
        }
        opts = opts || {};
        opts.path = opts.path || "/socket.io";
        this.opts = opts;
        (0, $6ef350ea0a0dd88d$export$2f67576668b97183)(this, opts);
        this.reconnection(opts.reconnection !== false);
        this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
        this.reconnectionDelay(opts.reconnectionDelay || 1000);
        this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
        this.randomizationFactor((_a = opts.randomizationFactor) !== null && _a !== void 0 ? _a : 0.5);
        this.backoff = new (0, $4d06434d3f654aec$export$2d38012449449c89)({
            min: this.reconnectionDelay(),
            max: this.reconnectionDelayMax(),
            jitter: this.randomizationFactor()
        });
        this.timeout(null == opts.timeout ? 20000 : opts.timeout);
        this._readyState = "closed";
        this.uri = uri;
        const _parser = opts.parser || $f35899b1336bcd3d$exports;
        this.encoder = new _parser.Encoder();
        this.decoder = new _parser.Decoder();
        this._autoConnect = opts.autoConnect !== false;
        if (this._autoConnect) this.open();
    }
    reconnection(v) {
        if (!arguments.length) return this._reconnection;
        this._reconnection = !!v;
        if (!v) this.skipReconnect = true;
        return this;
    }
    reconnectionAttempts(v) {
        if (v === undefined) return this._reconnectionAttempts;
        this._reconnectionAttempts = v;
        return this;
    }
    reconnectionDelay(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelay;
        this._reconnectionDelay = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMin(v);
        return this;
    }
    randomizationFactor(v) {
        var _a;
        if (v === undefined) return this._randomizationFactor;
        this._randomizationFactor = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setJitter(v);
        return this;
    }
    reconnectionDelayMax(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelayMax;
        this._reconnectionDelayMax = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMax(v);
        return this;
    }
    timeout(v) {
        if (!arguments.length) return this._timeout;
        this._timeout = v;
        return this;
    }
    /**
     * Starts trying to reconnect if reconnection is enabled and we have not
     * started reconnecting yet
     *
     * @private
     */ maybeReconnectOnOpen() {
        // Only try to reconnect if it's the first time we're connecting
        if (!this._reconnecting && this._reconnection && this.backoff.attempts === 0) // keeps reconnection from firing twice for the same reconnection loop
        this.reconnect();
    }
    /**
     * Sets the current transport `socket`.
     *
     * @param {Function} fn - optional, callback
     * @return self
     * @public
     */ open(fn) {
        if (~this._readyState.indexOf("open")) return this;
        this.engine = new (0, $5579d473e93c2027$export$4798917dbf149b79)(this.uri, this.opts);
        const socket = this.engine;
        const self = this;
        this._readyState = "opening";
        this.skipReconnect = false;
        // emit `open`
        const openSubDestroy = (0, $7ef62b04f1ea5e9b$export$af631764ddc44097)(socket, "open", function() {
            self.onopen();
            fn && fn();
        });
        const onError = (err)=>{
            this.cleanup();
            this._readyState = "closed";
            this.emitReserved("error", err);
            if (fn) fn(err);
            else // Only do this if there is no fn to handle the error
            this.maybeReconnectOnOpen();
        };
        // emit `error`
        const errorSub = (0, $7ef62b04f1ea5e9b$export$af631764ddc44097)(socket, "error", onError);
        if (false !== this._timeout) {
            const timeout = this._timeout;
            // set timer
            const timer = this.setTimeoutFn(()=>{
                openSubDestroy();
                onError(new Error("timeout"));
                socket.close();
            }, timeout);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
        this.subs.push(openSubDestroy);
        this.subs.push(errorSub);
        return this;
    }
    /**
     * Alias for open()
     *
     * @return self
     * @public
     */ connect(fn) {
        return this.open(fn);
    }
    /**
     * Called upon transport open.
     *
     * @private
     */ onopen() {
        // clear old subs
        this.cleanup();
        // mark as open
        this._readyState = "open";
        this.emitReserved("open");
        // add new subs
        const socket = this.engine;
        this.subs.push((0, $7ef62b04f1ea5e9b$export$af631764ddc44097)(socket, "ping", this.onping.bind(this)), (0, $7ef62b04f1ea5e9b$export$af631764ddc44097)(socket, "data", this.ondata.bind(this)), (0, $7ef62b04f1ea5e9b$export$af631764ddc44097)(socket, "error", this.onerror.bind(this)), (0, $7ef62b04f1ea5e9b$export$af631764ddc44097)(socket, "close", this.onclose.bind(this)), // @ts-ignore
        (0, $7ef62b04f1ea5e9b$export$af631764ddc44097)(this.decoder, "decoded", this.ondecoded.bind(this)));
    }
    /**
     * Called upon a ping.
     *
     * @private
     */ onping() {
        this.emitReserved("ping");
    }
    /**
     * Called with data.
     *
     * @private
     */ ondata(data) {
        try {
            this.decoder.add(data);
        } catch (e) {
            this.onclose("parse error", e);
        }
    }
    /**
     * Called when parser fully decodes a packet.
     *
     * @private
     */ ondecoded(packet) {
        // the nextTick call prevents an exception in a user-provided event listener from triggering a disconnection due to a "parse error"
        (0, $78dda435b49a09da$export$bdd553fddd433dcb)(()=>{
            this.emitReserved("packet", packet);
        }, this.setTimeoutFn);
    }
    /**
     * Called upon socket error.
     *
     * @private
     */ onerror(err) {
        this.emitReserved("error", err);
    }
    /**
     * Creates a new socket for the given `nsp`.
     *
     * @return {Socket}
     * @public
     */ socket(nsp, opts) {
        let socket = this.nsps[nsp];
        if (!socket) {
            socket = new (0, $9063e16d38b294db$export$4798917dbf149b79)(this, nsp, opts);
            this.nsps[nsp] = socket;
        } else if (this._autoConnect && !socket.active) socket.connect();
        return socket;
    }
    /**
     * Called upon a socket close.
     *
     * @param socket
     * @private
     */ _destroy(socket) {
        const nsps = Object.keys(this.nsps);
        for (const nsp of nsps){
            const socket = this.nsps[nsp];
            if (socket.active) return;
        }
        this._close();
    }
    /**
     * Writes a packet.
     *
     * @param packet
     * @private
     */ _packet(packet) {
        const encodedPackets = this.encoder.encode(packet);
        for(let i = 0; i < encodedPackets.length; i++)this.engine.write(encodedPackets[i], packet.options);
    }
    /**
     * Clean up transport subscriptions and packet buffer.
     *
     * @private
     */ cleanup() {
        this.subs.forEach((subDestroy)=>subDestroy());
        this.subs.length = 0;
        this.decoder.destroy();
    }
    /**
     * Close the current socket.
     *
     * @private
     */ _close() {
        this.skipReconnect = true;
        this._reconnecting = false;
        this.onclose("forced close");
    }
    /**
     * Alias for close()
     *
     * @private
     */ disconnect() {
        return this._close();
    }
    /**
     * Called when:
     *
     * - the low-level engine is closed
     * - the parser encountered a badly formatted packet
     * - all sockets are disconnected
     *
     * @private
     */ onclose(reason, description) {
        var _a;
        this.cleanup();
        (_a = this.engine) === null || _a === void 0 || _a.close();
        this.backoff.reset();
        this._readyState = "closed";
        this.emitReserved("close", reason, description);
        if (this._reconnection && !this.skipReconnect) this.reconnect();
    }
    /**
     * Attempt a reconnection.
     *
     * @private
     */ reconnect() {
        if (this._reconnecting || this.skipReconnect) return this;
        const self = this;
        if (this.backoff.attempts >= this._reconnectionAttempts) {
            this.backoff.reset();
            this.emitReserved("reconnect_failed");
            this._reconnecting = false;
        } else {
            const delay = this.backoff.duration();
            this._reconnecting = true;
            const timer = this.setTimeoutFn(()=>{
                if (self.skipReconnect) return;
                this.emitReserved("reconnect_attempt", self.backoff.attempts);
                // check again for the case socket closed in above events
                if (self.skipReconnect) return;
                self.open((err)=>{
                    if (err) {
                        self._reconnecting = false;
                        self.reconnect();
                        this.emitReserved("reconnect_error", err);
                    } else self.onreconnect();
                });
            }, delay);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
    }
    /**
     * Called upon successful reconnect.
     *
     * @private
     */ onreconnect() {
        const attempt = this.backoff.attempts;
        this._reconnecting = false;
        this.backoff.reset();
        this.emitReserved("reconnect", attempt);
    }
}





/**
 * Managers cache.
 */ const $b2faa63fcd6137f7$var$cache = {};
function $b2faa63fcd6137f7$export$841407ceb083bd74(uri, opts) {
    if (typeof uri === "object") {
        opts = uri;
        uri = undefined;
    }
    opts = opts || {};
    const parsed = (0, $3c201f22ef1fa1a0$export$128fa18b7194ef)(uri, opts.path || "/socket.io");
    const source = parsed.source;
    const id = parsed.id;
    const path = parsed.path;
    const sameNamespace = $b2faa63fcd6137f7$var$cache[id] && path in $b2faa63fcd6137f7$var$cache[id]["nsps"];
    const newConnection = opts.forceNew || opts["force new connection"] || false === opts.multiplex || sameNamespace;
    let io;
    if (newConnection) io = new (0, $37c89cd8a39fabd4$export$d0d38e7dec7a1a61)(source, opts);
    else {
        if (!$b2faa63fcd6137f7$var$cache[id]) $b2faa63fcd6137f7$var$cache[id] = new (0, $37c89cd8a39fabd4$export$d0d38e7dec7a1a61)(source, opts);
        io = $b2faa63fcd6137f7$var$cache[id];
    }
    if (parsed.query && !opts.query) opts.query = parsed.queryKey;
    return io.socket(parsed.path, opts);
}
// so that "lookup" can be used both as a function (e.g. `io(...)`) and as a
// namespace (e.g. `io.connect(...)`), for backward compatibility
Object.assign($b2faa63fcd6137f7$export$841407ceb083bd74, {
    Manager: $37c89cd8a39fabd4$export$d0d38e7dec7a1a61,
    Socket: $9063e16d38b294db$export$4798917dbf149b79,
    io: $b2faa63fcd6137f7$export$841407ceb083bd74,
    connect: $b2faa63fcd6137f7$export$841407ceb083bd74
});


const $2d759a6e462ab64e$var$SOCKET_PATH = '/kf-mfg-socket/public/v1/socket';
const $2d759a6e462ab64e$export$cb4e378d7d3467ee = ({ namespace: namespace = 'production-request', event: event, enabled: enabled = true })=>{
    const socketRef = (0, $lCzvA.useRef)(/** @type {import('socket.io-client').Socket | null}*/ null);
    const [socketMessage, setSocketMessage] = (0, $lCzvA.useState)(/** @type {Local.SocketMessage | null} */ null);
    // Manage the socket connection lifecycle based on enabled/namespace only
    (0, $lCzvA.useEffect)(()=>{
        if (!enabled) return ()=>null;
        const server = `${window.REACT_APP_API_URL}/${namespace}`;
        const newSocket = (0, $b2faa63fcd6137f7$export$841407ceb083bd74)(server, {
            path: $2d759a6e462ab64e$var$SOCKET_PATH,
            secure: true,
            rejectUnauthorized: false
        });
        socketRef.current = newSocket;
        return ()=>{
            newSocket.close();
            socketRef.current = null;
        };
    }, [
        enabled,
        namespace
    ]);
    // Manage event subscriptions separately to avoid unnecessary reconnects
    (0, $lCzvA.useEffect)(()=>{
        const socket = socketRef.current;
        if (!enabled || !socket || !event) return ()=>null;
        const handleEvent = (value)=>{
            setSocketMessage(value);
        };
        socket.on(event, handleEvent);
        return ()=>{
            socket.off(event, handleEvent);
            setSocketMessage(null);
        };
    }, [
        enabled,
        event
    ]);
    return {
        socketMessage: socketMessage,
        setSocketMessage: setSocketMessage
    };
};





const $21663d1b22ff0fef$export$2740d75ffe72fab8 = `
    query GetEbsOrganizations {
        getEbsOrganizations {
            organizationId
            organizationCode
            description
        }
    }
`;


const $e0dad85f1562aeea$var$GRAPHQL_URL = `${window.REACT_APP_API_URL}/ebs-api/graphql`;
const $e0dad85f1562aeea$export$935536f6e4c62d5e = async ()=>{
    const { data: data } = await (0, $9942448fd46231b7$export$71667b1866b7607e)($e0dad85f1562aeea$var$GRAPHQL_URL, (0, $21663d1b22ff0fef$export$2740d75ffe72fab8));
    return data.getEbsOrganizations;
};





const $b75393bd8a70fa20$export$5fc38fde58f5cf66 = ()=>{
    const { apiReady: apiReady } = (0, $10608212fc1ea215$export$a826e754a2b6b403)();
    return (0, $5b47d34ec35eb825$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).ORGANIZATION_DATA
        ],
        queryFn: ()=>(0, $e0dad85f1562aeea$export$935536f6e4c62d5e)(),
        staleTime: Infinity,
        enabled: apiReady
    });
};



const $df29add223039cb6$var$CAN_DELETE_SETUPS = new Set([
    'ADMINISTRATOR',
    'IT_ADMIN_V2',
    'SETUPS_V2'
]);
const $df29add223039cb6$export$1d39dc5b47e56ff0 = ()=>{
    const { roles: roles } = (0, $3bd970bfc6bd9362$export$3901076af3749fa9)();
    const canDeleteSetups = roles.some((role)=>$df29add223039cb6$var$CAN_DELETE_SETUPS.has(role));
    return {
        canDeleteSetups: canDeleteSetups
    };
};







const $66aaaebf25667a49$export$5d27c0f97561cc97 = (plant)=>{
    const { apiReady: apiReady } = (0, $10608212fc1ea215$export$a826e754a2b6b403)();
    const { selectedPlant: selectedPlant } = (0, $4e4c6c71fc2aaac8$export$fdc397e486fa83e7)();
    const effectivePlant = plant || selectedPlant;
    return (0, $5b47d34ec35eb825$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).SELECTION_LISTS,
            effectivePlant
        ],
        queryFn: ()=>(0, $a071e4bc84b4df4e$export$8451969e2bff5cfe)(effectivePlant),
        enabled: Boolean(apiReady && effectivePlant)
    });
};






const $7412b7161e90bcc9$export$1e0cdeee34c5891 = ()=>{
    const queryClient = (0, $6547bc15d23e8c33$export$22e77b9572c4fded)();
    return (0, $506026961de7ab1a$export$609860bf8b0084c)({
        /**
     * mutateFn - Function to call createSelectionList.
     * @param {Pella.ProductionRequestAPI.CreateSelectionListInput} input - The inputs for creating the Selection List.
     */ mutationFn: (input)=>(0, $a071e4bc84b4df4e$export$990bfd1484c54279)(input),
        onSuccess: ()=>{
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).success('Selection List created successfully!');
            queryClient.invalidateQueries({
                queryKey: [
                    (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).SELECTION_LISTS
                ]
            });
        }
    });
};






const $fd854974fdc9e908$export$c285f387187f5d1b = ()=>{
    const queryClient = (0, $6547bc15d23e8c33$export$22e77b9572c4fded)();
    return (0, $506026961de7ab1a$export$609860bf8b0084c)({
        /**
     * mutationFn - Function to call updateSelectionList.
     * @param {object} params
     * @param {Pella.ProductionRequestAPI.SelectionList['id']} params.id - The ID of the Selection List to update.
     * @param {Pella.ProductionRequestAPI.UpdateSelectionListInput} params.input - The inputs for updating the Selection List.
     */ mutationFn: ({ id: id, input: input })=>(0, $a071e4bc84b4df4e$export$f0555cd430f5d55a)(id, input),
        onSuccess: ()=>{
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).dismiss();
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).success('Selection List updated successfully!');
            queryClient.invalidateQueries({
                queryKey: [
                    (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).SELECTION_LISTS
                ]
            });
        }
    });
};






const $642bba98fe48777b$export$26017900558ac750 = ()=>{
    const queryClient = (0, $6547bc15d23e8c33$export$22e77b9572c4fded)();
    return (0, $506026961de7ab1a$export$609860bf8b0084c)({
        /**
     * mutateFn - Function to call deleteSelectionList.
     * @param {Pella.ProductionRequestAPI.SelectionList['id']} id - The ID of the Selection List to delete.
     */ mutationFn: (id)=>(0, $a071e4bc84b4df4e$export$ea53d545a92e34d5)(id),
        onSuccess: ()=>{
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).dismiss();
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).success('Selection List deleted successfully!');
            queryClient.invalidateQueries({
                queryKey: [
                    (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).SELECTION_LISTS
                ]
            });
        }
    });
};






const $9139ffa89529dce6$export$741daf16331cb4d6 = ()=>{
    const queryClient = (0, $6547bc15d23e8c33$export$22e77b9572c4fded)();
    return (0, $506026961de7ab1a$export$609860bf8b0084c)({
        /**
     * mutateFn - Function to call createSelectionListValue.
     * @param {Pella.ProductionRequestAPI.CreateSelectionListValueInput} input - The inputs for creating the Selection List Value.
     */ mutationFn: (input)=>(0, $a071e4bc84b4df4e$export$629a8867a04fa611)(input),
        onSuccess: ()=>{
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).success('Selection List Value created successfully!');
            queryClient.invalidateQueries({
                queryKey: [
                    (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).SELECTION_LISTS
                ]
            });
        }
    });
};






const $4ee9563f5ddb2fe1$export$9aa3f57adcd789b2 = ()=>{
    const queryClient = (0, $6547bc15d23e8c33$export$22e77b9572c4fded)();
    return (0, $506026961de7ab1a$export$609860bf8b0084c)({
        /**
     * mutateFn - Function to call updateSelectionListValue.
     * @param {object} params
     * @param {Pella.ProductionRequestAPI.SelectionList['id']} params.id Selection List ID
     * @param {Pella.ProductionRequestAPI.UpdateSelectionListInput} params.input
     */ mutationFn: ({ id: id, input: input })=>(0, $a071e4bc84b4df4e$export$ac74f3f842eeeefa)(id, input),
        onSuccess: ()=>{
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).success('Selection List Value updated successfully!');
            queryClient.invalidateQueries({
                queryKey: [
                    (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).SELECTION_LISTS
                ]
            });
        }
    });
};






const $72d0e12ef7dd63ef$export$2deaa254a1893d57 = ()=>{
    const queryClient = (0, $6547bc15d23e8c33$export$22e77b9572c4fded)();
    return (0, $506026961de7ab1a$export$609860bf8b0084c)({
        /**
     * mutateFn - Function to call deleteSelectionListValue.
     * @param {Pella.ProductionRequestAPI.SelectionList['id']} id Selection List ID
     */ mutationFn: (id)=>(0, $a071e4bc84b4df4e$export$843b87254ce4ea24)(id),
        onSuccess: ()=>{
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).success('Selection List Value deleted successfully!');
            queryClient.invalidateQueries({
                queryKey: [
                    (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).SELECTION_LISTS
                ]
            });
        }
    });
};




const $7d486c73597e1de8$export$4127a74fddb92b6f = ()=>(0, $5b47d34ec35eb825$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).TRANSACTION_TYPES
        ],
        queryFn: ()=>(0, $917e2c0c66b65db1$export$c7d449ce2d69117f),
        staleTime: Infinity
    });







const $c2668b8994f2b566$export$d48a51e4dd067ed2 = ()=>{
    const { apiReady: apiReady } = (0, $10608212fc1ea215$export$a826e754a2b6b403)();
    const { selectedPlant: selectedPlant } = (0, $4e4c6c71fc2aaac8$export$fdc397e486fa83e7)();
    return (0, $5b47d34ec35eb825$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).DISPOSITIONS,
            selectedPlant
        ],
        queryFn: ()=>(0, $a071e4bc84b4df4e$export$971d4dbc201e12e0)(selectedPlant),
        enabled: Boolean(apiReady && selectedPlant)
    });
};






const $004d4894213cab40$export$6b066c5e566b5491 = ()=>{
    const { apiReady: apiReady } = (0, $10608212fc1ea215$export$a826e754a2b6b403)();
    return (0, $5b47d34ec35eb825$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).CARRIERS
        ],
        queryFn: ()=>(0, $a071e4bc84b4df4e$export$de78b545984525e2)(),
        enabled: apiReady
    });
};




const $ae628eefadf6a456$export$a0464a6f0ca2cc72 = ()=>(0, $506026961de7ab1a$export$609860bf8b0084c)({
        /**
     * mutateFn - Function to call the createTrailerToDockTransaction api.
     * @param {TrailerToDockInput} input - The inputs for the Trailer To Dock transaction.
     */ mutationFn: (input)=>(0, $a071e4bc84b4df4e$export$1f34b46153724837)(input)
    });






const $372ad8923d5d8867$export$876560882acfdee8 = (input)=>{
    const { apiReady: apiReady } = (0, $10608212fc1ea215$export$a826e754a2b6b403)();
    return (0, $5b47d34ec35eb825$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).INVENTORY_ITEM,
            input
        ],
        queryFn: ()=>(0, $a071e4bc84b4df4e$export$ff7a0e8f43d7b3cb)(input),
        enabled: Boolean(apiReady && input?.item && input?.organizationId)
    });
};






const $ffe511494037ae80$export$4482a79532cd20f8 = (input)=>{
    const { apiReady: apiReady } = (0, $10608212fc1ea215$export$a826e754a2b6b403)();
    return (0, $5b47d34ec35eb825$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).SUBINVENTORY,
            input
        ],
        queryFn: ()=>(0, $a071e4bc84b4df4e$export$10896e2c9d6eb5c2)(input),
        enabled: Boolean(apiReady && input?.inventoryItemId && input?.organizationId)
    });
};






const $2736244b396f7fe0$export$444d1ee1178b9ea0 = (input)=>{
    const { apiReady: apiReady } = (0, $10608212fc1ea215$export$a826e754a2b6b403)();
    return (0, $5b47d34ec35eb825$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).SUBINVENTORY_INFO,
            input
        ],
        queryFn: ()=>(0, $a071e4bc84b4df4e$export$13365513656e9f7a)(input),
        enabled: Boolean(apiReady && input?.inventoryItemId && input?.organizationId && input?.subinventoryCode)
    });
};



var $lCzvA = parcelRequire("lCzvA");

/**
 * Gets transaction type details based on transaction type
 * @param {string} transactionType
 * @returns {{ sourceTypeId: 6 | 13, typeId: 2 | 3 | 120 }} Object containing transaction source type ID and transaction type ID
 */ const $3e76ed2cba8afd6c$var$getTransactionTypeDetails = (transactionType)=>{
    switch(transactionType){
        case (0, $917e2c0c66b65db1$export$9831c7e6e3463b6e).ISSUE_TO_LINE:
            return {
                sourceTypeId: 6,
                typeId: 120
            };
        case (0, $917e2c0c66b65db1$export$9831c7e6e3463b6e).DIRECT_ORG_TRANSFER:
            return {
                sourceTypeId: 13,
                typeId: 3
            };
        case (0, $917e2c0c66b65db1$export$9831c7e6e3463b6e).SUB_INVENTORY_TRANSFER:
            return {
                sourceTypeId: 13,
                typeId: 2
            };
        default:
            throw new Error(`Unknown transaction type: ${transactionType}`);
    }
};
const $3e76ed2cba8afd6c$export$e5c8a4886a3773bb = ()=>{
    const [transactionItems, setTransactionItems] = (0, $lCzvA.useState)(/** @type {Local.TransactionItem[]} */ []);
    /**
   * Adds a specified quantity of an item to the transaction items.
   * @param {Pella.ProductionRequestAPI.GetSubinventoryInfoByPlantOutput} item
   * @param {number} qty
   * @param {number} index
   * @param {string} transactionType
   * @param {number} orgId
   * @param {number} [dispositionId]
   * @param {string | null} [transferSubinventory]
   * @param {number | null} [transferLocatorId]
   */ const addQuantity = (item, qty, index, transactionType, orgId, dispositionId, transferSubinventory = null, transferLocatorId = null)=>{
        const { sourceTypeId: transactionSourceTypeId, typeId: transactionTypeId } = $3e76ed2cba8afd6c$var$getTransactionTypeDetails(transactionType);
        setTransactionItems((prev)=>[
                ...prev,
                {
                    id: crypto.randomUUID(),
                    item: item.item,
                    transactionQuantity: qty * -1,
                    inventoryItemId: item.inventoryItemId,
                    organizationId: orgId,
                    sourceHeaderId: index + 1,
                    sourceLineId: index + 1,
                    transactionSourceTypeId: transactionSourceTypeId,
                    transactionTypeId: transactionTypeId,
                    transactionUom: item.unitOfIssueCode,
                    unitOfIssueCode: item.unitOfIssueCode,
                    subinventoryCode: item.subinventoryCode,
                    transferOrganization: orgId,
                    locatorId: item.locatorId ?? null,
                    sourceRowIndex: index,
                    transactionSourceId: dispositionId,
                    transferLocatorId: transferLocatorId,
                    transferSubinventory: transferSubinventory,
                    lotNumber: item.lotNumber,
                    reasonId: null,
                    shipToLocationId: null,
                    distributionAccountId: null
                }
            ]);
    };
    /**
   * Adds a full lot of the specified item to the transaction items.
   * @param {Pella.ProductionRequestAPI.GetSubinventoryInfoByPlantOutput} item
   * @param {number} qty
   * @param {number} index
   * @param {string} transactionType
   * @param {number} orgId
   * @param {number} [dispositionId]
   * @param {string | null} [transferSubinventory]
   * @param {number | null} [transferLocatorId]
   */ const addFullLot = (item, qty, index, transactionType, orgId, dispositionId, transferSubinventory = null, transferLocatorId = null)=>{
        const { sourceTypeId: transactionSourceTypeId, typeId: transactionTypeId } = $3e76ed2cba8afd6c$var$getTransactionTypeDetails(transactionType);
        setTransactionItems((prev)=>[
                ...prev,
                {
                    id: crypto.randomUUID(),
                    item: item.item,
                    transactionQuantity: qty * -1,
                    inventoryItemId: item.inventoryItemId,
                    organizationId: orgId,
                    sourceHeaderId: prev?.length ? prev.length + 1 : 1,
                    sourceLineId: prev?.length ? prev.length + 1 : 1,
                    transactionSourceTypeId: transactionSourceTypeId,
                    transactionTypeId: transactionTypeId,
                    transactionUom: item.unitOfIssueCode,
                    unitOfIssueCode: item.unitOfIssueCode,
                    subinventoryCode: item.subinventoryCode,
                    transferOrganization: orgId,
                    locatorId: item.locatorId,
                    sourceRowIndex: index,
                    transactionSourceId: dispositionId,
                    transferLocatorId: transferLocatorId,
                    transferSubinventory: transferSubinventory,
                    lotNumber: item.lotNumber,
                    reasonId: null,
                    shipToLocationId: null,
                    distributionAccountId: null
                }
            ]);
    };
    /**
   * handles the removal of an item from the transaction array
   * @param {string} id
   */ const deleteItem = (id)=>setTransactionItems((prev)=>prev.filter((i)=>i.id !== id));
    const reset = ()=>setTransactionItems([]);
    return {
        transactionItems: transactionItems,
        addQuantity: addQuantity,
        addFullLot: addFullLot,
        deleteItem: deleteItem,
        reset: reset
    };
};




const $7152ad4b111d204a$export$f5fab7a78e2dc582 = ()=>(0, $506026961de7ab1a$export$609860bf8b0084c)({
        /**
     * mutateFn - Function to call the createInvMgmtTransaction api.
     * Wraps the call so only `input` is forwarded; react-query passes a second
     * mutation-context argument to mutationFn that the API layer must not receive.
     * @param {Local.CreateInvMgmtTransactionInput} input - The inputs for the Inventory Management transaction.
     */ mutationFn: (input)=>(0, $a071e4bc84b4df4e$export$d8e10908befdaef1)(input)
    });






const $893f6ef570e45856$export$d6b31c2d61f4cc8a = (input)=>{
    const { apiReady: apiReady } = (0, $10608212fc1ea215$export$a826e754a2b6b403)();
    return (0, $5b47d34ec35eb825$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).LOCATORS,
            input
        ],
        queryFn: ()=>(0, $a071e4bc84b4df4e$export$d6fa77d10def9dfe)(input),
        enabled: Boolean(apiReady && input?.organizationId && input?.subinventoryCode && input?.inventoryItemId)
    });
};







const $451e9768044d7dd3$export$7283d55617f55ee9 = `query GetInventoryItemIdWithQtyOnHand($input: InventoryItemWithQuantityInput!) {
    getInventoryItemIdWithQtyOnHand(input: $input) {
        inventoryItemId
    }
}`;
const $451e9768044d7dd3$export$c1d3107eef436c0c = `
    query GetPartsDescription($partNumber: String!) {
        getPartsDescription(input: { partNumber: $partNumber }) {
            description
        }
    }
`;
const $451e9768044d7dd3$export$b1801f63141c3976 = `
    query GetLumberLocationByItem($itemNumber: String!) {
        getLumberLocationByItem(input: { itemNumber: $itemNumber }) {
            item
            location
        }
    }
`;
const $451e9768044d7dd3$export$4831529ce9c00b84 = `
    query GetDieAndDescription($organizationId: Int!, $item: String!) {
        getDieAndDescription(input: { organizationId: $organizationId, item: $item }) {
            item
            die
            description
        }
    }
`;
const $451e9768044d7dd3$export$5b7b8d482773d8b8 = `
    query GetLumberItemInfoBySchedule($scheduleNumber: String!) {
        getLumberItemInfoBySchedule(input: { scheduleNumber: $scheduleNumber }) {
            aQty
            aItem
            location
            finalFamily
            panSize
            scheduleNumber
        }
    }
`;
const $451e9768044d7dd3$export$a1b1a3f241aa198b = `
    query GetPutDownMillLookupByItem($item: String!) {
        getPutDownMillLookupByItem(input: { item: $item }) {
            lotNumber
            lotDate
            qOH
        }
    }
`;


const $0dbf2986ec4dfc17$var$GRAPHQL_URL = `${window.REACT_APP_API_URL}/ebs-mfg/graphql`;
const $0dbf2986ec4dfc17$export$2934bc160892c6d2 = async (organizationId)=>{
    const { data: data } = await (0, $9942448fd46231b7$export$71667b1866b7607e)($0dbf2986ec4dfc17$var$GRAPHQL_URL, $451e9768044d7dd3$export$7283d55617f55ee9, {
        input: {
            organizationId: organizationId
        }
    });
    return data.getInventoryItemIdWithQtyOnHand.inventoryItemId;
};
const $0dbf2986ec4dfc17$export$1136e3babc72cc33 = async ({ partNumber: partNumber })=>{
    const { data: data } = await (0, $9942448fd46231b7$export$71667b1866b7607e)($0dbf2986ec4dfc17$var$GRAPHQL_URL, $451e9768044d7dd3$export$c1d3107eef436c0c, {
        partNumber: partNumber
    });
    return data.getPartsDescription;
};
const $0dbf2986ec4dfc17$export$826323e4f603f5bd = async ({ itemNumber: itemNumber })=>{
    const { data: data } = await (0, $9942448fd46231b7$export$71667b1866b7607e)($0dbf2986ec4dfc17$var$GRAPHQL_URL, $451e9768044d7dd3$export$b1801f63141c3976, {
        itemNumber: itemNumber
    });
    return data.getLumberLocationByItem;
};
const $0dbf2986ec4dfc17$export$57b8e3bf161a91ff = async ({ organizationId: organizationId, item: item })=>{
    const { data: data } = await (0, $9942448fd46231b7$export$71667b1866b7607e)($0dbf2986ec4dfc17$var$GRAPHQL_URL, $451e9768044d7dd3$export$4831529ce9c00b84, {
        organizationId: organizationId,
        item: item
    });
    return data.getDieAndDescription;
};
const $0dbf2986ec4dfc17$export$94ac2d95797640fa = async ({ scheduleNumber: scheduleNumber })=>{
    const { data: data } = await (0, $9942448fd46231b7$export$71667b1866b7607e)($0dbf2986ec4dfc17$var$GRAPHQL_URL, $451e9768044d7dd3$export$5b7b8d482773d8b8, {
        scheduleNumber: scheduleNumber
    });
    return data.getLumberItemInfoBySchedule;
};
const $0dbf2986ec4dfc17$export$df5529421eaa4c9c = async ({ item: item })=>{
    const { data: data } = await (0, $9942448fd46231b7$export$71667b1866b7607e)($0dbf2986ec4dfc17$var$GRAPHQL_URL, $451e9768044d7dd3$export$a1b1a3f241aa198b, {
        item: item
    });
    return data.getPutDownMillLookupByItem;
};





/**
 * Hook to fetch die number and item description from ebs-mfg given a valid item and orgID.
 * Returns a normalized shape: { data, isPending, error } where error is
 * a human-readable message string covering both API failures and soft
 * not-found cases (no die or description on the response).
 * @param {object} input
 * @param {number | undefined} input.organizationId
 * @param {string | undefined} input.item
 * @param {boolean} [input.enabled] - Optional override; when false the query is disabled regardless of other params
 */ const $25db7801fee5bbae$export$aeff16b3b2d57561 = ({ organizationId: organizationId, item: item, enabled: enabledOverride = true })=>{
    const { apiReady: apiReady } = (0, $10608212fc1ea215$export$a826e754a2b6b403)();
    const query = (0, $5b47d34ec35eb825$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).DIE_AND_DESCRIPTION,
            organizationId,
            item
        ],
        queryFn: ()=>(0, $0dbf2986ec4dfc17$export$57b8e3bf161a91ff)({
                organizationId: /** @type {number} */ organizationId,
                item: /** @type {string} */ item
            }),
        enabled: Boolean(enabledOverride && apiReady && organizationId && item)
    });
    const error = query.error?.message || (query.isSuccess && (!query.data?.die || !query.data?.description) ? 'Invalid item. No die number or description found for the entered item number.' : null) || null;
    return {
        data: query.data,
        isPending: query.isPending,
        error: error
    };
};






/**
 * Hook to fetch lumber item info from ebs-mfg given a valid schedule number.
 * Returns a normalized shape: { data, isPending, error } where error is
 * a human-readable message string covering both API failures and soft
 * not-found cases (no schedule match on the response).
 * @param {object} input
 * @param {string | undefined} input.scheduleNumber
 * @param {boolean} [input.enabled] - Optional override; when false the query is disabled regardless of other params
 */ const $10060fd23dc31dba$export$f4c97c6aa2c25670 = ({ scheduleNumber: scheduleNumber, enabled: enabledOverride = true })=>{
    const { apiReady: apiReady } = (0, $10608212fc1ea215$export$a826e754a2b6b403)();
    const query = (0, $5b47d34ec35eb825$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).LUMBER_ITEM_INFO_BY_SCHEDULE,
            scheduleNumber
        ],
        queryFn: ()=>(0, $0dbf2986ec4dfc17$export$94ac2d95797640fa)({
                scheduleNumber: /** @type {string} */ scheduleNumber
            }),
        enabled: Boolean(enabledOverride && apiReady && scheduleNumber)
    });
    const error = query.error?.message || (query.isSuccess && !query.data?.scheduleNumber ? 'Invalid schedule number. No details found for the entered schedule number.' : null) || null;
    return {
        data: query.data,
        isPending: query.isPending,
        error: error
    };
};






/**
 * Hook to fetch the lumber location from ebs-mfg given a valid item number.
 * Returns a normalized shape: { data, isPending, error } where error is
 * a human-readable message string covering both API failures and soft
 * not-found cases (no item match on the response).
 * @param {object} input
 * @param {string | undefined} input.item
 * @param {boolean} [input.enabled] - Optional override; when false the query is disabled regardless of other params
 */ const $c53860994cc50e8c$export$7c22349c61a20b42 = ({ item: item, enabled: enabledOverride = true })=>{
    const { apiReady: apiReady } = (0, $10608212fc1ea215$export$a826e754a2b6b403)();
    const query = (0, $5b47d34ec35eb825$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).LUMBER_LOCATION_BY_ITEM,
            item
        ],
        queryFn: ()=>(0, $0dbf2986ec4dfc17$export$826323e4f603f5bd)({
                itemNumber: /** @type {string} */ item
            }),
        enabled: Boolean(enabledOverride && apiReady && item)
    });
    const error = query.error?.message || (query.isSuccess && !query.data?.item ? 'Invalid item. No location found for the entered item number.' : null) || null;
    return {
        data: query.data,
        isPending: query.isPending,
        error: error
    };
};






const $bde753a61e21ad69$var$defaultParams = {
    input: undefined,
    enabled: false
};
const $bde753a61e21ad69$export$90190e35e88610b7 = (params = $bde753a61e21ad69$var$defaultParams)=>{
    const { input: input, enabled: enabled } = params;
    const { apiReady: apiReady } = (0, $10608212fc1ea215$export$a826e754a2b6b403)();
    const partNumber = input?.partNumber;
    return (0, $5b47d34ec35eb825$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).PART_DESCRIPTION_DATA,
            partNumber
        ],
        queryFn: async ()=>{
            const partDescriptions = await (0, $0dbf2986ec4dfc17$export$1136e3babc72cc33)({
                partNumber: String(partNumber)
            });
            return partDescriptions;
        },
        staleTime: Infinity,
        enabled: Boolean(apiReady && partNumber && partNumber.length > 5 && enabled)
    });
};






/**
 * Hook to fetch QOH Location Details given a valid item and orgID.
 * Returns a normalized shape: { data, isPending, error } where error is
 * a human-readable message string covering both API failures and soft
 * not-found cases (invalid item, no QOH locations).
 * @param {object} input
 * @param {number | undefined} input.organizationId
 * @param {string | undefined} input.item
 * @param {boolean} [input.enabled] - Optional override; when false the query is disabled regardless of other params
 */ const $e4026b26985ffdd2$export$9046fe8dc50fecbf = ({ organizationId: organizationId, item: item, enabled: enabledOverride = true })=>{
    const { apiReady: apiReady } = (0, $10608212fc1ea215$export$a826e754a2b6b403)();
    const inventoryQuery = (0, $5b47d34ec35eb825$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).INVENTORY_ITEM,
            organizationId,
            item
        ],
        queryFn: ()=>(0, $a071e4bc84b4df4e$export$ff7a0e8f43d7b3cb)({
                organizationId: /** @type {number} */ organizationId,
                item: /** @type {string} */ item
            }),
        enabled: Boolean(enabledOverride && apiReady && organizationId && item)
    });
    const inventoryItemId = inventoryQuery.data?.[0]?.inventoryItemId;
    const qohQuery = (0, $5b47d34ec35eb825$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).QOH_BY_ORG_AND_ITEM,
            organizationId,
            inventoryItemId
        ],
        queryFn: ()=>(0, $a071e4bc84b4df4e$export$10896e2c9d6eb5c2)({
                organizationId: /** @type {number} */ organizationId,
                inventoryItemId: /** @type {number} */ inventoryItemId
            }),
        enabled: Boolean(organizationId && inventoryItemId)
    });
    const error = (inventoryQuery.isError || inventoryQuery.isSuccess && !inventoryQuery.data?.[0] ? 'Invalid item. No inventory record found for the entered item number.' : null) || (qohQuery.isError || qohQuery.isSuccess && !qohQuery.data?.length ? 'No QOH locations found for the entered item number.' : null) || null;
    return {
        data: qohQuery.data,
        isPending: inventoryQuery.isPending || qohQuery.isPending,
        error: error
    };
};






/**
 * Hook to fetch the put down mill lot data from ebs-mfg given an item number.
 * Returns a normalized shape: { data, isPending, error }. Unlike the other
 * action-query lookups, a no-lots response ([{ lotNumber: null, ... }]) is a
 * valid success and must NOT set an error — only a true API failure does, so
 * the request is still created and the empty result persisted.
 * The endpoint hard codes Org 63 (Metal Plant) server-side; no org is passed.
 * @param {object} input
 * @param {string | undefined} input.item
 * @param {boolean} [input.enabled] - Optional override; when false the query is disabled regardless of other params
 */ const $14fb39e6bc050901$export$8097011fa1a91c01 = ({ item: item, enabled: enabledOverride = true })=>{
    const { apiReady: apiReady } = (0, $10608212fc1ea215$export$a826e754a2b6b403)();
    const query = (0, $5b47d34ec35eb825$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).PUT_DOWN_MILL_BY_ITEM,
            item
        ],
        queryFn: ()=>(0, $0dbf2986ec4dfc17$export$df5529421eaa4c9c)({
                item: /** @type {string} */ item
            }),
        enabled: Boolean(enabledOverride && apiReady && item)
    });
    const error = query.isError ? 'Unable to retrieve lot data for the entered item number. Please try again.' : null;
    return {
        data: query.data,
        isPending: query.isPending,
        error: error
    };
};


const $ed9a8e47842fcce7$var$QUERY_IDS = {
    DIE_NUMBER_LOOKUP: 'DIE_NUMBER_LOOKUP',
    PART_QOH_LOCATIONS_LOOKUP: 'PART_QOH_LOCATIONS_LOOKUP',
    PART_DESCRIPTION_LOOKUP: 'PART_DESCRIPTION_LOOKUP',
    LUMBER_SCHEDULE_LOOKUP: 'LUMBER_SCHEDULE_LOOKUP',
    LUMBER_PART_LOOKUP: 'LUMBER_PART_LOOKUP',
    P10_PUT_DOWN_MILL: 'P10_PUT_DOWN_MILL'
};
const $ed9a8e47842fcce7$export$11d67fb595afb0ff = ({ id: id }, input)=>{
    const isEnabled = Object.values($ed9a8e47842fcce7$var$QUERY_IDS).includes(id);
    const { selectedPlant: selectedPlant } = (0, $4e4c6c71fc2aaac8$export$fdc397e486fa83e7)();
    const { data: plants } = (0, $e733424c31ecfe53$export$b22ebc4820923ca5)();
    const currentPlant = plants?.find((p)=>p.id === selectedPlant);
    const organizationId = currentPlant?.organizationId;
    // Call all hooks unconditionally (React requirement)
    // Each hook gates its own execution via the `enabled` flag
    const dieNumber = (0, $25db7801fee5bbae$export$aeff16b3b2d57561)({
        organizationId: organizationId,
        item: input,
        enabled: id === $ed9a8e47842fcce7$var$QUERY_IDS.DIE_NUMBER_LOOKUP
    });
    const partQohLocations = (0, $e4026b26985ffdd2$export$9046fe8dc50fecbf)({
        organizationId: organizationId,
        item: input,
        enabled: id === $ed9a8e47842fcce7$var$QUERY_IDS.PART_QOH_LOCATIONS_LOOKUP
    });
    const partDescription = (0, $bde753a61e21ad69$export$90190e35e88610b7)({
        input: {
            partNumber: input
        },
        enabled: id === $ed9a8e47842fcce7$var$QUERY_IDS.PART_DESCRIPTION_LOOKUP
    });
    const lumberSchedule = (0, $10060fd23dc31dba$export$f4c97c6aa2c25670)({
        scheduleNumber: input,
        enabled: id === $ed9a8e47842fcce7$var$QUERY_IDS.LUMBER_SCHEDULE_LOOKUP
    });
    const lumberPart = (0, $c53860994cc50e8c$export$7c22349c61a20b42)({
        item: input,
        enabled: id === $ed9a8e47842fcce7$var$QUERY_IDS.LUMBER_PART_LOOKUP
    });
    const putDownMill = (0, $14fb39e6bc050901$export$8097011fa1a91c01)({
        item: input,
        enabled: id === $ed9a8e47842fcce7$var$QUERY_IDS.P10_PUT_DOWN_MILL
    });
    // Query registry: map query IDs to their corresponding hook results
    // To add a new query type: (1) add the hook call above, (2) add entry here
    const queryRegistry = {
        [$ed9a8e47842fcce7$var$QUERY_IDS.DIE_NUMBER_LOOKUP]: dieNumber,
        [$ed9a8e47842fcce7$var$QUERY_IDS.PART_QOH_LOCATIONS_LOOKUP]: partQohLocations,
        [$ed9a8e47842fcce7$var$QUERY_IDS.PART_DESCRIPTION_LOOKUP]: partDescription,
        [$ed9a8e47842fcce7$var$QUERY_IDS.LUMBER_SCHEDULE_LOOKUP]: lumberSchedule,
        [$ed9a8e47842fcce7$var$QUERY_IDS.LUMBER_PART_LOOKUP]: lumberPart,
        [$ed9a8e47842fcce7$var$QUERY_IDS.P10_PUT_DOWN_MILL]: putDownMill
    };
    // Look up the active query result (no nested ternaries needed)
    const activeQuery = queryRegistry[id];
    return {
        data: activeQuery?.data,
        isPending: isEnabled && activeQuery?.isPending,
        error: isEnabled ? activeQuery?.error : null
    };
};












var $lCzvA = parcelRequire("lCzvA");

"use client";
//#region src/components/Select/index.jsx
var $c7e1b2c0ded2c83a$export$2e2bcd8739ae039 = (0, $lCzvA.forwardRef)(({ labelText: i, id: c, hideLabel: l, children: u, className: d, containerClass: f, assistiveText: p, required: m, error: h, helpText: g, tooltipContent: _, tooltipPosition: v = "bottom", ...y }, b)=>{
    let x = (0, $lCzvA.Children)?.toArray(u)?.length === 1, S = (0, $lCzvA.useRef)(null), C = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-FormGroup sash-FormGroupSelect relative mb-4": !0,
        [f]: f
    }), w = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-Select sash-input appearance-none pr-10": !0,
        "pointer-events-none bg-transparent": x,
        "border-red-700": h,
        [d]: d
    });
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
        ref: S,
        className: C,
        "data-testid": "sash-select",
        children: [
            (i || g || p) && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $353df793a3a1d2b7$export$2e2bcd8739ae039), {
                id: c,
                labelText: i,
                hideLabel: l,
                required: m,
                error: !!h,
                assistiveText: p,
                helpText: g,
                tooltipContent: _,
                tooltipPosition: v
            }),
            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                className: "sash-SelectWrapper relative",
                "data-testid": "sash-select-wrapper",
                children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("select", {
                    id: c,
                    name: c,
                    className: w,
                    required: m,
                    ref: b,
                    ...y,
                    children: u
                })
            }),
            typeof h == "string" && !!h && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $71efe153e5175f41$export$2e2bcd8739ae039), {
                type: "error",
                className: "mt-2",
                message: h,
                inline: !0
            })
        ]
    });
});
$c7e1b2c0ded2c83a$export$2e2bcd8739ae039.displayName = "Select";


const $a2263260374089e7$export$bf3335ea33e394c5 = ({ id: id = 'plant-selection' })=>{
    const { data: plants } = (0, $e733424c31ecfe53$export$b22ebc4820923ca5)(true);
    const { selectedPlant: selectedPlant, setSelectedPlant: setSelectedPlant } = (0, $1b0a542caa3229ca$export$b91a5355c3a5f338)();
    /**
   * Handles changes to the selected plant.
   * @param {React.ChangeEvent<HTMLSelectElement>} event - The change event object.
   * @returns {void}
   */ const handlePlantChange = ({ target: { value: value } })=>{
        if (value) setSelectedPlant(value);
    };
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $c7e1b2c0ded2c83a$export$2e2bcd8739ae039), {
        id: id,
        "data-testid": id,
        labelText: "Select Plant",
        onChange: handlePlantChange,
        value: selectedPlant,
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                value: "",
                children: "--- Select an Option ---"
            }),
            plants?.map((plant)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                    value: plant.id,
                    children: plant.description
                }, plant.id))
        ]
    });
};





const $a3940119e067251f$export$29209a8d303291ca = ({ id: id = 'location-selection', hideInactive: hideInactive = true })=>{
    const { data: locations } = (0, $e092467f6f60ca40$export$8535247f55db5d21)(hideInactive);
    const { selectedLocation: selectedLocation, setSelectedLocation: setSelectedLocation } = (0, $cfa58d15f42b8895$export$4ace3aee3488cfe3)();
    /**
   * Handles changes to the selected location.
   * @param {React.ChangeEvent<HTMLSelectElement>} event - The change event object.
   * @returns {void}
   */ const handleLocationChange = ({ target: { value: value } })=>{
        if (value) setSelectedLocation(value);
    };
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $c7e1b2c0ded2c83a$export$2e2bcd8739ae039), {
        id: id,
        "data-testid": id,
        labelText: "Select Location",
        onChange: handleLocationChange,
        value: selectedLocation,
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                value: "",
                children: "--- Select an Option ---"
            }),
            locations?.map((location)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                    value: location.id,
                    children: location.description
                }, location.id))
        ]
    });
};




var $ef04b780641e1980$export$de39a1795fbdd05e;
$ef04b780641e1980$export$de39a1795fbdd05e = `i_iNVW_clearIcon`;


const $1ef686a537f3280d$export$55d7609a8f1eccd2 = ({ searchValue: searchValue, onChange: onChange, id: id = 'searchInput', placeholder: placeholder = 'Search ...', hideLabel: hideLabel = false })=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $67004894d25c93a4$export$2e2bcd8739ae039), {
        id: id,
        "data-testid": id,
        labelText: "",
        hideLabel: hideLabel,
        placeholder: placeholder,
        value: searchValue,
        onChange: ({ target: { value: value } })=>onChange(value),
        iconLeft: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
            name: "search"
        }),
        iconRight: searchValue && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
            "data-testid": "clear-search",
            className: $ef04b780641e1980$export$de39a1795fbdd05e,
            name: "close",
            onClick: ()=>onChange('')
        })
    });



var $ec4affac0c13709c$exports = {};
'use strict';
Object.defineProperty($ec4affac0c13709c$exports, '__esModule', {
    value: true
});
function $ec4affac0c13709c$var$_interopDefault(ex) {
    return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $lCzvA = parcelRequire("lCzvA");
var $ec4affac0c13709c$var$React__default = $ec4affac0c13709c$var$_interopDefault($lCzvA);

var $fYDAD = parcelRequire("fYDAD");
var $ec4affac0c13709c$var$ClientUAInstance = new $fYDAD();
var $ec4affac0c13709c$var$browser = $ec4affac0c13709c$var$ClientUAInstance.getBrowser();
var $ec4affac0c13709c$var$cpu = $ec4affac0c13709c$var$ClientUAInstance.getCPU();
var $ec4affac0c13709c$var$device = $ec4affac0c13709c$var$ClientUAInstance.getDevice();
var $ec4affac0c13709c$var$engine = $ec4affac0c13709c$var$ClientUAInstance.getEngine();
var $ec4affac0c13709c$var$os = $ec4affac0c13709c$var$ClientUAInstance.getOS();
var $ec4affac0c13709c$var$ua = $ec4affac0c13709c$var$ClientUAInstance.getUA();
var $ec4affac0c13709c$var$setUa = function setUa(userAgentString) {
    return $ec4affac0c13709c$var$ClientUAInstance.setUA(userAgentString);
};
var $ec4affac0c13709c$var$parseUserAgent = function parseUserAgent(userAgent) {
    if (!userAgent) {
        console.error('No userAgent string was provided');
        return;
    }
    var UserAgentInstance = new $fYDAD(userAgent);
    return {
        UA: UserAgentInstance,
        browser: UserAgentInstance.getBrowser(),
        cpu: UserAgentInstance.getCPU(),
        device: UserAgentInstance.getDevice(),
        engine: UserAgentInstance.getEngine(),
        os: UserAgentInstance.getOS(),
        ua: UserAgentInstance.getUA(),
        setUserAgent: function setUserAgent(userAgentString) {
            return UserAgentInstance.setUA(userAgentString);
        }
    };
};
var $ec4affac0c13709c$var$UAHelper = /*#__PURE__*/ Object.freeze({
    ClientUAInstance: $ec4affac0c13709c$var$ClientUAInstance,
    browser: $ec4affac0c13709c$var$browser,
    cpu: $ec4affac0c13709c$var$cpu,
    device: $ec4affac0c13709c$var$device,
    engine: $ec4affac0c13709c$var$engine,
    os: $ec4affac0c13709c$var$os,
    ua: $ec4affac0c13709c$var$ua,
    setUa: $ec4affac0c13709c$var$setUa,
    parseUserAgent: $ec4affac0c13709c$var$parseUserAgent
});
function $ec4affac0c13709c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ec4affac0c13709c$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $ec4affac0c13709c$var$ownKeys(Object(source), true).forEach(function(key) {
            $ec4affac0c13709c$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $ec4affac0c13709c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ec4affac0c13709c$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $ec4affac0c13709c$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $ec4affac0c13709c$var$_typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $ec4affac0c13709c$var$_typeof(obj);
}
function $ec4affac0c13709c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ec4affac0c13709c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $ec4affac0c13709c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ec4affac0c13709c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ec4affac0c13709c$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $ec4affac0c13709c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ec4affac0c13709c$var$_extends() {
    $ec4affac0c13709c$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ec4affac0c13709c$var$_extends.apply(this, arguments);
}
function $ec4affac0c13709c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $ec4affac0c13709c$var$_setPrototypeOf(subClass, superClass);
}
function $ec4affac0c13709c$var$_getPrototypeOf(o) {
    $ec4affac0c13709c$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $ec4affac0c13709c$var$_getPrototypeOf(o);
}
function $ec4affac0c13709c$var$_setPrototypeOf(o, p) {
    $ec4affac0c13709c$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ec4affac0c13709c$var$_setPrototypeOf(o, p);
}
function $ec4affac0c13709c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $ec4affac0c13709c$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $ec4affac0c13709c$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $ec4affac0c13709c$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $ec4affac0c13709c$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $ec4affac0c13709c$var$_assertThisInitialized(self);
}
function $ec4affac0c13709c$var$_slicedToArray(arr, i) {
    return $ec4affac0c13709c$var$_arrayWithHoles(arr) || $ec4affac0c13709c$var$_iterableToArrayLimit(arr, i) || $ec4affac0c13709c$var$_unsupportedIterableToArray(arr, i) || $ec4affac0c13709c$var$_nonIterableRest();
}
function $ec4affac0c13709c$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $ec4affac0c13709c$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $ec4affac0c13709c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ec4affac0c13709c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ec4affac0c13709c$var$_arrayLikeToArray(o, minLen);
}
function $ec4affac0c13709c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $ec4affac0c13709c$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $ec4affac0c13709c$var$DeviceTypes = {
    Mobile: 'mobile',
    Tablet: 'tablet',
    SmartTv: 'smarttv',
    Console: 'console',
    Wearable: 'wearable',
    Embedded: 'embedded',
    Browser: undefined
};
var $ec4affac0c13709c$var$BrowserTypes = {
    Chrome: 'Chrome',
    Firefox: 'Firefox',
    Opera: 'Opera',
    Yandex: 'Yandex',
    Safari: 'Safari',
    InternetExplorer: 'Internet Explorer',
    Edge: 'Edge',
    Chromium: 'Chromium',
    Ie: 'IE',
    MobileSafari: 'Mobile Safari',
    EdgeChromium: 'Edge Chromium',
    MIUI: 'MIUI Browser',
    SamsungBrowser: 'Samsung Browser'
};
var $ec4affac0c13709c$var$OsTypes = {
    IOS: 'iOS',
    Android: 'Android',
    WindowsPhone: 'Windows Phone',
    Windows: 'Windows',
    MAC_OS: 'Mac OS'
};
var $ec4affac0c13709c$var$InitialDeviceTypes = {
    isMobile: false,
    isTablet: false,
    isBrowser: false,
    isSmartTV: false,
    isConsole: false,
    isWearable: false
};
var $ec4affac0c13709c$var$checkDeviceType = function checkDeviceType(type) {
    switch(type){
        case $ec4affac0c13709c$var$DeviceTypes.Mobile:
            return {
                isMobile: true
            };
        case $ec4affac0c13709c$var$DeviceTypes.Tablet:
            return {
                isTablet: true
            };
        case $ec4affac0c13709c$var$DeviceTypes.SmartTv:
            return {
                isSmartTV: true
            };
        case $ec4affac0c13709c$var$DeviceTypes.Console:
            return {
                isConsole: true
            };
        case $ec4affac0c13709c$var$DeviceTypes.Wearable:
            return {
                isWearable: true
            };
        case $ec4affac0c13709c$var$DeviceTypes.Browser:
            return {
                isBrowser: true
            };
        case $ec4affac0c13709c$var$DeviceTypes.Embedded:
            return {
                isEmbedded: true
            };
        default:
            return $ec4affac0c13709c$var$InitialDeviceTypes;
    }
};
var $ec4affac0c13709c$var$setUserAgent = function setUserAgent(userAgent) {
    return $ec4affac0c13709c$var$setUa(userAgent);
};
var $ec4affac0c13709c$var$setDefaults = function setDefaults(p) {
    var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';
    return p ? p : d;
};
var $ec4affac0c13709c$var$getNavigatorInstance = function getNavigatorInstance() {
    if (typeof window !== 'undefined') {
        if (window.navigator || navigator) return window.navigator || navigator;
    }
    return false;
};
var $ec4affac0c13709c$var$isIOS13Check = function isIOS13Check(type) {
    var nav = $ec4affac0c13709c$var$getNavigatorInstance();
    return nav && nav.platform && (nav.platform.indexOf(type) !== -1 || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1 && !window.MSStream);
};
var $ec4affac0c13709c$var$browserPayload = function browserPayload(isBrowser, browser, engine, os, ua) {
    return {
        isBrowser: isBrowser,
        browserMajorVersion: $ec4affac0c13709c$var$setDefaults(browser.major),
        browserFullVersion: $ec4affac0c13709c$var$setDefaults(browser.version),
        browserName: $ec4affac0c13709c$var$setDefaults(browser.name),
        engineName: $ec4affac0c13709c$var$setDefaults(engine.name),
        engineVersion: $ec4affac0c13709c$var$setDefaults(engine.version),
        osName: $ec4affac0c13709c$var$setDefaults(os.name),
        osVersion: $ec4affac0c13709c$var$setDefaults(os.version),
        userAgent: $ec4affac0c13709c$var$setDefaults(ua)
    };
};
var $ec4affac0c13709c$var$mobilePayload = function mobilePayload(type, device, os, ua) {
    return $ec4affac0c13709c$var$_objectSpread2({}, type, {
        vendor: $ec4affac0c13709c$var$setDefaults(device.vendor),
        model: $ec4affac0c13709c$var$setDefaults(device.model),
        os: $ec4affac0c13709c$var$setDefaults(os.name),
        osVersion: $ec4affac0c13709c$var$setDefaults(os.version),
        ua: $ec4affac0c13709c$var$setDefaults(ua)
    });
};
var $ec4affac0c13709c$var$smartTvPayload = function smartTvPayload(isSmartTV, engine, os, ua) {
    return {
        isSmartTV: isSmartTV,
        engineName: $ec4affac0c13709c$var$setDefaults(engine.name),
        engineVersion: $ec4affac0c13709c$var$setDefaults(engine.version),
        osName: $ec4affac0c13709c$var$setDefaults(os.name),
        osVersion: $ec4affac0c13709c$var$setDefaults(os.version),
        userAgent: $ec4affac0c13709c$var$setDefaults(ua)
    };
};
var $ec4affac0c13709c$var$consolePayload = function consolePayload(isConsole, engine, os, ua) {
    return {
        isConsole: isConsole,
        engineName: $ec4affac0c13709c$var$setDefaults(engine.name),
        engineVersion: $ec4affac0c13709c$var$setDefaults(engine.version),
        osName: $ec4affac0c13709c$var$setDefaults(os.name),
        osVersion: $ec4affac0c13709c$var$setDefaults(os.version),
        userAgent: $ec4affac0c13709c$var$setDefaults(ua)
    };
};
var $ec4affac0c13709c$var$wearablePayload = function wearablePayload(isWearable, engine, os, ua) {
    return {
        isWearable: isWearable,
        engineName: $ec4affac0c13709c$var$setDefaults(engine.name),
        engineVersion: $ec4affac0c13709c$var$setDefaults(engine.version),
        osName: $ec4affac0c13709c$var$setDefaults(os.name),
        osVersion: $ec4affac0c13709c$var$setDefaults(os.version),
        userAgent: $ec4affac0c13709c$var$setDefaults(ua)
    };
};
var $ec4affac0c13709c$var$embeddedPayload = function embeddedPayload(isEmbedded, device, engine, os, ua) {
    return {
        isEmbedded: isEmbedded,
        vendor: $ec4affac0c13709c$var$setDefaults(device.vendor),
        model: $ec4affac0c13709c$var$setDefaults(device.model),
        engineName: $ec4affac0c13709c$var$setDefaults(engine.name),
        engineVersion: $ec4affac0c13709c$var$setDefaults(engine.version),
        osName: $ec4affac0c13709c$var$setDefaults(os.name),
        osVersion: $ec4affac0c13709c$var$setDefaults(os.version),
        userAgent: $ec4affac0c13709c$var$setDefaults(ua)
    };
};
function $ec4affac0c13709c$var$deviceDetect(userAgent) {
    var _ref = userAgent ? $ec4affac0c13709c$var$parseUserAgent(userAgent) : $ec4affac0c13709c$var$UAHelper, device = _ref.device, browser = _ref.browser, engine = _ref.engine, os = _ref.os, ua = _ref.ua;
    var type = $ec4affac0c13709c$var$checkDeviceType(device.type);
    var isBrowser = type.isBrowser, isMobile = type.isMobile, isTablet = type.isTablet, isSmartTV = type.isSmartTV, isConsole = type.isConsole, isWearable = type.isWearable, isEmbedded = type.isEmbedded;
    if (isBrowser) return $ec4affac0c13709c$var$browserPayload(isBrowser, browser, engine, os, ua);
    if (isSmartTV) return $ec4affac0c13709c$var$smartTvPayload(isSmartTV, engine, os, ua);
    if (isConsole) return $ec4affac0c13709c$var$consolePayload(isConsole, engine, os, ua);
    if (isMobile) return $ec4affac0c13709c$var$mobilePayload(type, device, os, ua);
    if (isTablet) return $ec4affac0c13709c$var$mobilePayload(type, device, os, ua);
    if (isWearable) return $ec4affac0c13709c$var$wearablePayload(isWearable, engine, os, ua);
    if (isEmbedded) return $ec4affac0c13709c$var$embeddedPayload(isEmbedded, device, engine, os, ua);
}
var $ec4affac0c13709c$var$isMobileType = function isMobileType(_ref) {
    var type = _ref.type;
    return type === $ec4affac0c13709c$var$DeviceTypes.Mobile;
};
var $ec4affac0c13709c$var$isTabletType = function isTabletType(_ref2) {
    var type = _ref2.type;
    return type === $ec4affac0c13709c$var$DeviceTypes.Tablet;
};
var $ec4affac0c13709c$var$isMobileAndTabletType = function isMobileAndTabletType(_ref3) {
    var type = _ref3.type;
    return type === $ec4affac0c13709c$var$DeviceTypes.Mobile || type === $ec4affac0c13709c$var$DeviceTypes.Tablet;
};
var $ec4affac0c13709c$var$isSmartTVType = function isSmartTVType(_ref4) {
    var type = _ref4.type;
    return type === $ec4affac0c13709c$var$DeviceTypes.SmartTv;
};
var $ec4affac0c13709c$var$isBrowserType = function isBrowserType(_ref5) {
    var type = _ref5.type;
    return type === $ec4affac0c13709c$var$DeviceTypes.Browser;
};
var $ec4affac0c13709c$var$isWearableType = function isWearableType(_ref6) {
    var type = _ref6.type;
    return type === $ec4affac0c13709c$var$DeviceTypes.Wearable;
};
var $ec4affac0c13709c$var$isConsoleType = function isConsoleType(_ref7) {
    var type = _ref7.type;
    return type === $ec4affac0c13709c$var$DeviceTypes.Console;
};
var $ec4affac0c13709c$var$isEmbeddedType = function isEmbeddedType(_ref8) {
    var type = _ref8.type;
    return type === $ec4affac0c13709c$var$DeviceTypes.Embedded;
};
var $ec4affac0c13709c$var$getMobileVendor = function getMobileVendor(_ref9) {
    var vendor = _ref9.vendor;
    return $ec4affac0c13709c$var$setDefaults(vendor);
};
var $ec4affac0c13709c$var$getMobileModel = function getMobileModel(_ref10) {
    var model = _ref10.model;
    return $ec4affac0c13709c$var$setDefaults(model);
};
var $ec4affac0c13709c$var$getDeviceType = function getDeviceType(_ref11) {
    var type = _ref11.type;
    return $ec4affac0c13709c$var$setDefaults(type, 'browser');
}; // os types
var $ec4affac0c13709c$var$isAndroidType = function isAndroidType(_ref12) {
    var name = _ref12.name;
    return name === $ec4affac0c13709c$var$OsTypes.Android;
};
var $ec4affac0c13709c$var$isWindowsType = function isWindowsType(_ref13) {
    var name = _ref13.name;
    return name === $ec4affac0c13709c$var$OsTypes.Windows;
};
var $ec4affac0c13709c$var$isMacOsType = function isMacOsType(_ref14) {
    var name = _ref14.name;
    return name === $ec4affac0c13709c$var$OsTypes.MAC_OS;
};
var $ec4affac0c13709c$var$isWinPhoneType = function isWinPhoneType(_ref15) {
    var name = _ref15.name;
    return name === $ec4affac0c13709c$var$OsTypes.WindowsPhone;
};
var $ec4affac0c13709c$var$isIOSType = function isIOSType(_ref16) {
    var name = _ref16.name;
    return name === $ec4affac0c13709c$var$OsTypes.IOS;
};
var $ec4affac0c13709c$var$getOsVersion = function getOsVersion(_ref17) {
    var version = _ref17.version;
    return $ec4affac0c13709c$var$setDefaults(version);
};
var $ec4affac0c13709c$var$getOsName = function getOsName(_ref18) {
    var name = _ref18.name;
    return $ec4affac0c13709c$var$setDefaults(name);
}; // browser types
var $ec4affac0c13709c$var$isChromeType = function isChromeType(_ref19) {
    var name = _ref19.name;
    return name === $ec4affac0c13709c$var$BrowserTypes.Chrome;
};
var $ec4affac0c13709c$var$isFirefoxType = function isFirefoxType(_ref20) {
    var name = _ref20.name;
    return name === $ec4affac0c13709c$var$BrowserTypes.Firefox;
};
var $ec4affac0c13709c$var$isChromiumType = function isChromiumType(_ref21) {
    var name = _ref21.name;
    return name === $ec4affac0c13709c$var$BrowserTypes.Chromium;
};
var $ec4affac0c13709c$var$isEdgeType = function isEdgeType(_ref22) {
    var name = _ref22.name;
    return name === $ec4affac0c13709c$var$BrowserTypes.Edge;
};
var $ec4affac0c13709c$var$isYandexType = function isYandexType(_ref23) {
    var name = _ref23.name;
    return name === $ec4affac0c13709c$var$BrowserTypes.Yandex;
};
var $ec4affac0c13709c$var$isSafariType = function isSafariType(_ref24) {
    var name = _ref24.name;
    return name === $ec4affac0c13709c$var$BrowserTypes.Safari || name === $ec4affac0c13709c$var$BrowserTypes.MobileSafari;
};
var $ec4affac0c13709c$var$isMobileSafariType = function isMobileSafariType(_ref25) {
    var name = _ref25.name;
    return name === $ec4affac0c13709c$var$BrowserTypes.MobileSafari;
};
var $ec4affac0c13709c$var$isOperaType = function isOperaType(_ref26) {
    var name = _ref26.name;
    return name === $ec4affac0c13709c$var$BrowserTypes.Opera;
};
var $ec4affac0c13709c$var$isIEType = function isIEType(_ref27) {
    var name = _ref27.name;
    return name === $ec4affac0c13709c$var$BrowserTypes.InternetExplorer || name === $ec4affac0c13709c$var$BrowserTypes.Ie;
};
var $ec4affac0c13709c$var$isMIUIType = function isMIUIType(_ref28) {
    var name = _ref28.name;
    return name === $ec4affac0c13709c$var$BrowserTypes.MIUI;
};
var $ec4affac0c13709c$var$isSamsungBrowserType = function isSamsungBrowserType(_ref29) {
    var name = _ref29.name;
    return name === $ec4affac0c13709c$var$BrowserTypes.SamsungBrowser;
};
var $ec4affac0c13709c$var$getBrowserFullVersion = function getBrowserFullVersion(_ref30) {
    var version = _ref30.version;
    return $ec4affac0c13709c$var$setDefaults(version);
};
var $ec4affac0c13709c$var$getBrowserVersion = function getBrowserVersion(_ref31) {
    var major = _ref31.major;
    return $ec4affac0c13709c$var$setDefaults(major);
};
var $ec4affac0c13709c$var$getBrowserName = function getBrowserName(_ref32) {
    var name = _ref32.name;
    return $ec4affac0c13709c$var$setDefaults(name);
}; // engine types
var $ec4affac0c13709c$var$getEngineName = function getEngineName(_ref33) {
    var name = _ref33.name;
    return $ec4affac0c13709c$var$setDefaults(name);
};
var $ec4affac0c13709c$var$getEngineVersion = function getEngineVersion(_ref34) {
    var version = _ref34.version;
    return $ec4affac0c13709c$var$setDefaults(version);
};
var $ec4affac0c13709c$var$isElectronType = function isElectronType() {
    var nav = $ec4affac0c13709c$var$getNavigatorInstance();
    var ua = nav && nav.userAgent && nav.userAgent.toLowerCase();
    return typeof ua === 'string' ? /electron/.test(ua) : false;
};
var $ec4affac0c13709c$var$isEdgeChromiumType = function isEdgeChromiumType(ua) {
    return typeof ua === 'string' && ua.indexOf('Edg/') !== -1;
};
var $ec4affac0c13709c$var$getIOS13 = function getIOS13() {
    var nav = $ec4affac0c13709c$var$getNavigatorInstance();
    return nav && (/iPad|iPhone|iPod/.test(nav.platform) || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1) && !window.MSStream;
};
var $ec4affac0c13709c$var$getIPad13 = function getIPad13() {
    return $ec4affac0c13709c$var$isIOS13Check('iPad');
};
var $ec4affac0c13709c$var$getIphone13 = function getIphone13() {
    return $ec4affac0c13709c$var$isIOS13Check('iPhone');
};
var $ec4affac0c13709c$var$getIPod13 = function getIPod13() {
    return $ec4affac0c13709c$var$isIOS13Check('iPod');
};
var $ec4affac0c13709c$var$getUseragent = function getUseragent(userAg) {
    return $ec4affac0c13709c$var$setDefaults(userAg);
};
function $ec4affac0c13709c$var$buildSelectorsObject(options) {
    var _ref = options ? options : $ec4affac0c13709c$var$UAHelper, device = _ref.device, browser = _ref.browser, os = _ref.os, engine = _ref.engine, ua = _ref.ua;
    return {
        isSmartTV: $ec4affac0c13709c$var$isSmartTVType(device),
        isConsole: $ec4affac0c13709c$var$isConsoleType(device),
        isWearable: $ec4affac0c13709c$var$isWearableType(device),
        isEmbedded: $ec4affac0c13709c$var$isEmbeddedType(device),
        isMobileSafari: $ec4affac0c13709c$var$isMobileSafariType(browser) || $ec4affac0c13709c$var$getIPad13(),
        isChromium: $ec4affac0c13709c$var$isChromiumType(browser),
        isMobile: $ec4affac0c13709c$var$isMobileAndTabletType(device) || $ec4affac0c13709c$var$getIPad13(),
        isMobileOnly: $ec4affac0c13709c$var$isMobileType(device),
        isTablet: $ec4affac0c13709c$var$isTabletType(device) || $ec4affac0c13709c$var$getIPad13(),
        isBrowser: $ec4affac0c13709c$var$isBrowserType(device),
        isDesktop: $ec4affac0c13709c$var$isBrowserType(device),
        isAndroid: $ec4affac0c13709c$var$isAndroidType(os),
        isWinPhone: $ec4affac0c13709c$var$isWinPhoneType(os),
        isIOS: $ec4affac0c13709c$var$isIOSType(os) || $ec4affac0c13709c$var$getIPad13(),
        isChrome: $ec4affac0c13709c$var$isChromeType(browser),
        isFirefox: $ec4affac0c13709c$var$isFirefoxType(browser),
        isSafari: $ec4affac0c13709c$var$isSafariType(browser),
        isOpera: $ec4affac0c13709c$var$isOperaType(browser),
        isIE: $ec4affac0c13709c$var$isIEType(browser),
        osVersion: $ec4affac0c13709c$var$getOsVersion(os),
        osName: $ec4affac0c13709c$var$getOsName(os),
        fullBrowserVersion: $ec4affac0c13709c$var$getBrowserFullVersion(browser),
        browserVersion: $ec4affac0c13709c$var$getBrowserVersion(browser),
        browserName: $ec4affac0c13709c$var$getBrowserName(browser),
        mobileVendor: $ec4affac0c13709c$var$getMobileVendor(device),
        mobileModel: $ec4affac0c13709c$var$getMobileModel(device),
        engineName: $ec4affac0c13709c$var$getEngineName(engine),
        engineVersion: $ec4affac0c13709c$var$getEngineVersion(engine),
        getUA: $ec4affac0c13709c$var$getUseragent(ua),
        isEdge: $ec4affac0c13709c$var$isEdgeType(browser) || $ec4affac0c13709c$var$isEdgeChromiumType(ua),
        isYandex: $ec4affac0c13709c$var$isYandexType(browser),
        deviceType: $ec4affac0c13709c$var$getDeviceType(device),
        isIOS13: $ec4affac0c13709c$var$getIOS13(),
        isIPad13: $ec4affac0c13709c$var$getIPad13(),
        isIPhone13: $ec4affac0c13709c$var$getIphone13(),
        isIPod13: $ec4affac0c13709c$var$getIPod13(),
        isElectron: $ec4affac0c13709c$var$isElectronType(),
        isEdgeChromium: $ec4affac0c13709c$var$isEdgeChromiumType(ua),
        isLegacyEdge: $ec4affac0c13709c$var$isEdgeType(browser) && !$ec4affac0c13709c$var$isEdgeChromiumType(ua),
        isWindows: $ec4affac0c13709c$var$isWindowsType(os),
        isMacOs: $ec4affac0c13709c$var$isMacOsType(os),
        isMIUI: $ec4affac0c13709c$var$isMIUIType(browser),
        isSamsungBrowser: $ec4affac0c13709c$var$isSamsungBrowserType(browser)
    };
}
var $ec4affac0c13709c$var$isSmartTV = $ec4affac0c13709c$var$isSmartTVType($ec4affac0c13709c$var$device);
var $ec4affac0c13709c$var$isConsole = $ec4affac0c13709c$var$isConsoleType($ec4affac0c13709c$var$device);
var $ec4affac0c13709c$var$isWearable = $ec4affac0c13709c$var$isWearableType($ec4affac0c13709c$var$device);
var $ec4affac0c13709c$var$isEmbedded = $ec4affac0c13709c$var$isEmbeddedType($ec4affac0c13709c$var$device);
var $ec4affac0c13709c$var$isMobileSafari = $ec4affac0c13709c$var$isMobileSafariType($ec4affac0c13709c$var$browser) || $ec4affac0c13709c$var$getIPad13();
var $ec4affac0c13709c$var$isChromium = $ec4affac0c13709c$var$isChromiumType($ec4affac0c13709c$var$browser);
var $ec4affac0c13709c$var$isMobile = $ec4affac0c13709c$var$isMobileAndTabletType($ec4affac0c13709c$var$device) || $ec4affac0c13709c$var$getIPad13();
var $ec4affac0c13709c$var$isMobileOnly = $ec4affac0c13709c$var$isMobileType($ec4affac0c13709c$var$device);
var $ec4affac0c13709c$var$isTablet = $ec4affac0c13709c$var$isTabletType($ec4affac0c13709c$var$device) || $ec4affac0c13709c$var$getIPad13();
var $ec4affac0c13709c$var$isBrowser = $ec4affac0c13709c$var$isBrowserType($ec4affac0c13709c$var$device);
var $ec4affac0c13709c$var$isDesktop = $ec4affac0c13709c$var$isBrowserType($ec4affac0c13709c$var$device);
var $ec4affac0c13709c$var$isAndroid = $ec4affac0c13709c$var$isAndroidType($ec4affac0c13709c$var$os);
var $ec4affac0c13709c$var$isWinPhone = $ec4affac0c13709c$var$isWinPhoneType($ec4affac0c13709c$var$os);
var $ec4affac0c13709c$var$isIOS = $ec4affac0c13709c$var$isIOSType($ec4affac0c13709c$var$os) || $ec4affac0c13709c$var$getIPad13();
var $ec4affac0c13709c$var$isChrome = $ec4affac0c13709c$var$isChromeType($ec4affac0c13709c$var$browser);
var $ec4affac0c13709c$var$isFirefox = $ec4affac0c13709c$var$isFirefoxType($ec4affac0c13709c$var$browser);
var $ec4affac0c13709c$var$isSafari = $ec4affac0c13709c$var$isSafariType($ec4affac0c13709c$var$browser);
var $ec4affac0c13709c$var$isOpera = $ec4affac0c13709c$var$isOperaType($ec4affac0c13709c$var$browser);
var $ec4affac0c13709c$var$isIE = $ec4affac0c13709c$var$isIEType($ec4affac0c13709c$var$browser);
var $ec4affac0c13709c$var$osVersion = $ec4affac0c13709c$var$getOsVersion($ec4affac0c13709c$var$os);
var $ec4affac0c13709c$var$osName = $ec4affac0c13709c$var$getOsName($ec4affac0c13709c$var$os);
var $ec4affac0c13709c$var$fullBrowserVersion = $ec4affac0c13709c$var$getBrowserFullVersion($ec4affac0c13709c$var$browser);
var $ec4affac0c13709c$var$browserVersion = $ec4affac0c13709c$var$getBrowserVersion($ec4affac0c13709c$var$browser);
var $ec4affac0c13709c$var$browserName = $ec4affac0c13709c$var$getBrowserName($ec4affac0c13709c$var$browser);
var $ec4affac0c13709c$var$mobileVendor = $ec4affac0c13709c$var$getMobileVendor($ec4affac0c13709c$var$device);
var $ec4affac0c13709c$var$mobileModel = $ec4affac0c13709c$var$getMobileModel($ec4affac0c13709c$var$device);
var $ec4affac0c13709c$var$engineName = $ec4affac0c13709c$var$getEngineName($ec4affac0c13709c$var$engine);
var $ec4affac0c13709c$var$engineVersion = $ec4affac0c13709c$var$getEngineVersion($ec4affac0c13709c$var$engine);
var $ec4affac0c13709c$var$getUA = $ec4affac0c13709c$var$getUseragent($ec4affac0c13709c$var$ua);
var $ec4affac0c13709c$var$isEdge = $ec4affac0c13709c$var$isEdgeType($ec4affac0c13709c$var$browser) || $ec4affac0c13709c$var$isEdgeChromiumType($ec4affac0c13709c$var$ua);
var $ec4affac0c13709c$var$isYandex = $ec4affac0c13709c$var$isYandexType($ec4affac0c13709c$var$browser);
var $ec4affac0c13709c$var$deviceType = $ec4affac0c13709c$var$getDeviceType($ec4affac0c13709c$var$device);
var $ec4affac0c13709c$var$isIOS13 = $ec4affac0c13709c$var$getIOS13();
var $ec4affac0c13709c$var$isIPad13 = $ec4affac0c13709c$var$getIPad13();
var $ec4affac0c13709c$var$isIPhone13 = $ec4affac0c13709c$var$getIphone13();
var $ec4affac0c13709c$var$isIPod13 = $ec4affac0c13709c$var$getIPod13();
var $ec4affac0c13709c$var$isElectron = $ec4affac0c13709c$var$isElectronType();
var $ec4affac0c13709c$var$isEdgeChromium = $ec4affac0c13709c$var$isEdgeChromiumType($ec4affac0c13709c$var$ua);
var $ec4affac0c13709c$var$isLegacyEdge = $ec4affac0c13709c$var$isEdgeType($ec4affac0c13709c$var$browser) && !$ec4affac0c13709c$var$isEdgeChromiumType($ec4affac0c13709c$var$ua);
var $ec4affac0c13709c$var$isWindows = $ec4affac0c13709c$var$isWindowsType($ec4affac0c13709c$var$os);
var $ec4affac0c13709c$var$isMacOs = $ec4affac0c13709c$var$isMacOsType($ec4affac0c13709c$var$os);
var $ec4affac0c13709c$var$isMIUI = $ec4affac0c13709c$var$isMIUIType($ec4affac0c13709c$var$browser);
var $ec4affac0c13709c$var$isSamsungBrowser = $ec4affac0c13709c$var$isSamsungBrowserType($ec4affac0c13709c$var$browser);
var $ec4affac0c13709c$var$getSelectorsByUserAgent = function getSelectorsByUserAgent(userAgent) {
    if (!userAgent || typeof userAgent !== 'string') {
        console.error('No valid user agent string was provided');
        return;
    }
    var _UAHelper$parseUserAg = $ec4affac0c13709c$var$parseUserAgent(userAgent), device = _UAHelper$parseUserAg.device, browser = _UAHelper$parseUserAg.browser, os = _UAHelper$parseUserAg.os, engine = _UAHelper$parseUserAg.engine, ua = _UAHelper$parseUserAg.ua;
    return $ec4affac0c13709c$var$buildSelectorsObject({
        device: device,
        browser: browser,
        os: os,
        engine: engine,
        ua: ua
    });
};
var $ec4affac0c13709c$var$AndroidView = function AndroidView(_ref) {
    var renderWithFragment = _ref.renderWithFragment, children = _ref.children, props = $ec4affac0c13709c$var$_objectWithoutProperties(_ref, [
        "renderWithFragment",
        "children"
    ]);
    return $ec4affac0c13709c$var$isAndroid ? renderWithFragment ? $ec4affac0c13709c$var$React__default.createElement($lCzvA.Fragment, null, children) : $ec4affac0c13709c$var$React__default.createElement("div", props, children) : null;
};
var $ec4affac0c13709c$var$BrowserView = function BrowserView(_ref2) {
    var renderWithFragment = _ref2.renderWithFragment, children = _ref2.children, props = $ec4affac0c13709c$var$_objectWithoutProperties(_ref2, [
        "renderWithFragment",
        "children"
    ]);
    return $ec4affac0c13709c$var$isBrowser ? renderWithFragment ? $ec4affac0c13709c$var$React__default.createElement($lCzvA.Fragment, null, children) : $ec4affac0c13709c$var$React__default.createElement("div", props, children) : null;
};
var $ec4affac0c13709c$var$IEView = function IEView(_ref3) {
    var renderWithFragment = _ref3.renderWithFragment, children = _ref3.children, props = $ec4affac0c13709c$var$_objectWithoutProperties(_ref3, [
        "renderWithFragment",
        "children"
    ]);
    return $ec4affac0c13709c$var$isIE ? renderWithFragment ? $ec4affac0c13709c$var$React__default.createElement($lCzvA.Fragment, null, children) : $ec4affac0c13709c$var$React__default.createElement("div", props, children) : null;
};
var $ec4affac0c13709c$var$IOSView = function IOSView(_ref4) {
    var renderWithFragment = _ref4.renderWithFragment, children = _ref4.children, props = $ec4affac0c13709c$var$_objectWithoutProperties(_ref4, [
        "renderWithFragment",
        "children"
    ]);
    return $ec4affac0c13709c$var$isIOS ? renderWithFragment ? $ec4affac0c13709c$var$React__default.createElement($lCzvA.Fragment, null, children) : $ec4affac0c13709c$var$React__default.createElement("div", props, children) : null;
};
var $ec4affac0c13709c$var$MobileView = function MobileView(_ref5) {
    var renderWithFragment = _ref5.renderWithFragment, children = _ref5.children, props = $ec4affac0c13709c$var$_objectWithoutProperties(_ref5, [
        "renderWithFragment",
        "children"
    ]);
    return $ec4affac0c13709c$var$isMobile ? renderWithFragment ? $ec4affac0c13709c$var$React__default.createElement($lCzvA.Fragment, null, children) : $ec4affac0c13709c$var$React__default.createElement("div", props, children) : null;
};
var $ec4affac0c13709c$var$TabletView = function TabletView(_ref6) {
    var renderWithFragment = _ref6.renderWithFragment, children = _ref6.children, props = $ec4affac0c13709c$var$_objectWithoutProperties(_ref6, [
        "renderWithFragment",
        "children"
    ]);
    return $ec4affac0c13709c$var$isTablet ? renderWithFragment ? $ec4affac0c13709c$var$React__default.createElement($lCzvA.Fragment, null, children) : $ec4affac0c13709c$var$React__default.createElement("div", props, children) : null;
};
var $ec4affac0c13709c$var$WinPhoneView = function WinPhoneView(_ref7) {
    var renderWithFragment = _ref7.renderWithFragment, children = _ref7.children, props = $ec4affac0c13709c$var$_objectWithoutProperties(_ref7, [
        "renderWithFragment",
        "children"
    ]);
    return $ec4affac0c13709c$var$isWinPhone ? renderWithFragment ? $ec4affac0c13709c$var$React__default.createElement($lCzvA.Fragment, null, children) : $ec4affac0c13709c$var$React__default.createElement("div", props, children) : null;
};
var $ec4affac0c13709c$var$MobileOnlyView = function MobileOnlyView(_ref8) {
    var renderWithFragment = _ref8.renderWithFragment, children = _ref8.children, viewClassName = _ref8.viewClassName, style = _ref8.style, props = $ec4affac0c13709c$var$_objectWithoutProperties(_ref8, [
        "renderWithFragment",
        "children",
        "viewClassName",
        "style"
    ]);
    return $ec4affac0c13709c$var$isMobileOnly ? renderWithFragment ? $ec4affac0c13709c$var$React__default.createElement($lCzvA.Fragment, null, children) : $ec4affac0c13709c$var$React__default.createElement("div", props, children) : null;
};
var $ec4affac0c13709c$var$SmartTVView = function SmartTVView(_ref9) {
    var renderWithFragment = _ref9.renderWithFragment, children = _ref9.children, props = $ec4affac0c13709c$var$_objectWithoutProperties(_ref9, [
        "renderWithFragment",
        "children"
    ]);
    return $ec4affac0c13709c$var$isSmartTV ? renderWithFragment ? $ec4affac0c13709c$var$React__default.createElement($lCzvA.Fragment, null, children) : $ec4affac0c13709c$var$React__default.createElement("div", props, children) : null;
};
var $ec4affac0c13709c$var$ConsoleView = function ConsoleView(_ref10) {
    var renderWithFragment = _ref10.renderWithFragment, children = _ref10.children, props = $ec4affac0c13709c$var$_objectWithoutProperties(_ref10, [
        "renderWithFragment",
        "children"
    ]);
    return $ec4affac0c13709c$var$isConsole ? renderWithFragment ? $ec4affac0c13709c$var$React__default.createElement($lCzvA.Fragment, null, children) : $ec4affac0c13709c$var$React__default.createElement("div", props, children) : null;
};
var $ec4affac0c13709c$var$WearableView = function WearableView(_ref11) {
    var renderWithFragment = _ref11.renderWithFragment, children = _ref11.children, props = $ec4affac0c13709c$var$_objectWithoutProperties(_ref11, [
        "renderWithFragment",
        "children"
    ]);
    return $ec4affac0c13709c$var$isWearable ? renderWithFragment ? $ec4affac0c13709c$var$React__default.createElement($lCzvA.Fragment, null, children) : $ec4affac0c13709c$var$React__default.createElement("div", props, children) : null;
};
var $ec4affac0c13709c$var$CustomView = function CustomView(_ref12) {
    var renderWithFragment = _ref12.renderWithFragment, children = _ref12.children, viewClassName = _ref12.viewClassName, style = _ref12.style, condition = _ref12.condition, props = $ec4affac0c13709c$var$_objectWithoutProperties(_ref12, [
        "renderWithFragment",
        "children",
        "viewClassName",
        "style",
        "condition"
    ]);
    return condition ? renderWithFragment ? $ec4affac0c13709c$var$React__default.createElement($lCzvA.Fragment, null, children) : $ec4affac0c13709c$var$React__default.createElement("div", props, children) : null;
};
function $ec4affac0c13709c$var$withOrientationChange(WrappedComponent) {
    return /*#__PURE__*/ function(_React$Component) {
        $ec4affac0c13709c$var$_inherits(_class, _React$Component);
        function _class(props) {
            var _this;
            $ec4affac0c13709c$var$_classCallCheck(this, _class);
            _this = $ec4affac0c13709c$var$_possibleConstructorReturn(this, $ec4affac0c13709c$var$_getPrototypeOf(_class).call(this, props));
            _this.isEventListenerAdded = false;
            _this.handleOrientationChange = _this.handleOrientationChange.bind($ec4affac0c13709c$var$_assertThisInitialized(_this));
            _this.onOrientationChange = _this.onOrientationChange.bind($ec4affac0c13709c$var$_assertThisInitialized(_this));
            _this.onPageLoad = _this.onPageLoad.bind($ec4affac0c13709c$var$_assertThisInitialized(_this));
            _this.state = {
                isLandscape: false,
                isPortrait: false
            };
            return _this;
        }
        $ec4affac0c13709c$var$_createClass(_class, [
            {
                key: "handleOrientationChange",
                value: function handleOrientationChange() {
                    if (!this.isEventListenerAdded) this.isEventListenerAdded = true;
                    var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
                    this.setState({
                        isPortrait: orientation === 0,
                        isLandscape: orientation === 90
                    });
                }
            },
            {
                key: "onOrientationChange",
                value: function onOrientationChange() {
                    this.handleOrientationChange();
                }
            },
            {
                key: "onPageLoad",
                value: function onPageLoad() {
                    this.handleOrientationChange();
                }
            },
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    if ((typeof window === "undefined" ? "undefined" : $ec4affac0c13709c$var$_typeof(window)) !== undefined && $ec4affac0c13709c$var$isMobile) {
                        if (!this.isEventListenerAdded) {
                            this.handleOrientationChange();
                            window.addEventListener("load", this.onPageLoad, false);
                        } else window.removeEventListener("load", this.onPageLoad, false);
                        window.addEventListener("resize", this.onOrientationChange, false);
                    }
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    window.removeEventListener("resize", this.onOrientationChange, false);
                }
            },
            {
                key: "render",
                value: function render() {
                    return $ec4affac0c13709c$var$React__default.createElement(WrappedComponent, $ec4affac0c13709c$var$_extends({}, this.props, {
                        isLandscape: this.state.isLandscape,
                        isPortrait: this.state.isPortrait
                    }));
                }
            }
        ]);
        return _class;
    }($ec4affac0c13709c$var$React__default.Component);
}
function $ec4affac0c13709c$var$useMobileOrientation() {
    var _useState = $lCzvA.useState(function() {
        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
        return {
            isPortrait: orientation === 0,
            isLandscape: orientation === 90,
            orientation: orientation === 0 ? 'portrait' : 'landscape'
        };
    }), _useState2 = $ec4affac0c13709c$var$_slicedToArray(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var handleOrientationChange = $lCzvA.useCallback(function() {
        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
        var next = {
            isPortrait: orientation === 0,
            isLandscape: orientation === 90,
            orientation: orientation === 0 ? 'portrait' : 'landscape'
        };
        state.orientation !== next.orientation && setState(next);
    }, [
        state.orientation
    ]);
    $lCzvA.useEffect(function() {
        if ((typeof window === "undefined" ? "undefined" : $ec4affac0c13709c$var$_typeof(window)) !== undefined && $ec4affac0c13709c$var$isMobile) {
            handleOrientationChange();
            window.addEventListener("load", handleOrientationChange, false);
            window.addEventListener("resize", handleOrientationChange, false);
        }
        return function() {
            window.removeEventListener("resize", handleOrientationChange, false);
            window.removeEventListener("load", handleOrientationChange, false);
        };
    }, [
        handleOrientationChange
    ]);
    return state;
}
function $ec4affac0c13709c$var$useDeviceData(userAgent) {
    var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
    return $ec4affac0c13709c$var$parseUserAgent(hookUserAgent);
}
function $ec4affac0c13709c$var$useDeviceSelectors(userAgent) {
    var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
    var deviceData = $ec4affac0c13709c$var$useDeviceData(hookUserAgent);
    var selectors = $ec4affac0c13709c$var$buildSelectorsObject(deviceData);
    return [
        selectors,
        deviceData
    ];
}
$ec4affac0c13709c$exports.AndroidView = $ec4affac0c13709c$var$AndroidView;
$ec4affac0c13709c$exports.BrowserTypes = $ec4affac0c13709c$var$BrowserTypes;
$ec4affac0c13709c$exports.BrowserView = $ec4affac0c13709c$var$BrowserView;
$ec4affac0c13709c$exports.ConsoleView = $ec4affac0c13709c$var$ConsoleView;
$ec4affac0c13709c$exports.CustomView = $ec4affac0c13709c$var$CustomView;
$ec4affac0c13709c$exports.IEView = $ec4affac0c13709c$var$IEView;
$ec4affac0c13709c$exports.IOSView = $ec4affac0c13709c$var$IOSView;
$ec4affac0c13709c$exports.MobileOnlyView = $ec4affac0c13709c$var$MobileOnlyView;
$ec4affac0c13709c$exports.MobileView = $ec4affac0c13709c$var$MobileView;
$ec4affac0c13709c$exports.OsTypes = $ec4affac0c13709c$var$OsTypes;
$ec4affac0c13709c$exports.SmartTVView = $ec4affac0c13709c$var$SmartTVView;
$ec4affac0c13709c$exports.TabletView = $ec4affac0c13709c$var$TabletView;
$ec4affac0c13709c$exports.WearableView = $ec4affac0c13709c$var$WearableView;
$ec4affac0c13709c$exports.WinPhoneView = $ec4affac0c13709c$var$WinPhoneView;
$ec4affac0c13709c$exports.browserName = $ec4affac0c13709c$var$browserName;
$ec4affac0c13709c$exports.browserVersion = $ec4affac0c13709c$var$browserVersion;
$ec4affac0c13709c$exports.deviceDetect = $ec4affac0c13709c$var$deviceDetect;
$ec4affac0c13709c$exports.deviceType = $ec4affac0c13709c$var$deviceType;
$ec4affac0c13709c$exports.engineName = $ec4affac0c13709c$var$engineName;
$ec4affac0c13709c$exports.engineVersion = $ec4affac0c13709c$var$engineVersion;
$ec4affac0c13709c$exports.fullBrowserVersion = $ec4affac0c13709c$var$fullBrowserVersion;
$ec4affac0c13709c$exports.getSelectorsByUserAgent = $ec4affac0c13709c$var$getSelectorsByUserAgent;
$ec4affac0c13709c$exports.getUA = $ec4affac0c13709c$var$getUA;
$ec4affac0c13709c$exports.isAndroid = $ec4affac0c13709c$var$isAndroid;
$ec4affac0c13709c$exports.isBrowser = $ec4affac0c13709c$var$isBrowser;
$ec4affac0c13709c$exports.isChrome = $ec4affac0c13709c$var$isChrome;
$ec4affac0c13709c$exports.isChromium = $ec4affac0c13709c$var$isChromium;
$ec4affac0c13709c$exports.isConsole = $ec4affac0c13709c$var$isConsole;
$ec4affac0c13709c$exports.isDesktop = $ec4affac0c13709c$var$isDesktop;
$ec4affac0c13709c$exports.isEdge = $ec4affac0c13709c$var$isEdge;
$ec4affac0c13709c$exports.isEdgeChromium = $ec4affac0c13709c$var$isEdgeChromium;
$ec4affac0c13709c$exports.isElectron = $ec4affac0c13709c$var$isElectron;
$ec4affac0c13709c$exports.isEmbedded = $ec4affac0c13709c$var$isEmbedded;
$ec4affac0c13709c$exports.isFirefox = $ec4affac0c13709c$var$isFirefox;
$ec4affac0c13709c$exports.isIE = $ec4affac0c13709c$var$isIE;
$ec4affac0c13709c$exports.isIOS = $ec4affac0c13709c$var$isIOS;
$ec4affac0c13709c$exports.isIOS13 = $ec4affac0c13709c$var$isIOS13;
$ec4affac0c13709c$exports.isIPad13 = $ec4affac0c13709c$var$isIPad13;
$ec4affac0c13709c$exports.isIPhone13 = $ec4affac0c13709c$var$isIPhone13;
$ec4affac0c13709c$exports.isIPod13 = $ec4affac0c13709c$var$isIPod13;
$ec4affac0c13709c$exports.isLegacyEdge = $ec4affac0c13709c$var$isLegacyEdge;
$ec4affac0c13709c$exports.isMIUI = $ec4affac0c13709c$var$isMIUI;
$ec4affac0c13709c$exports.isMacOs = $ec4affac0c13709c$var$isMacOs;
$ec4affac0c13709c$exports.isMobile = $ec4affac0c13709c$var$isMobile;
$ec4affac0c13709c$exports.isMobileOnly = $ec4affac0c13709c$var$isMobileOnly;
$ec4affac0c13709c$exports.isMobileSafari = $ec4affac0c13709c$var$isMobileSafari;
$ec4affac0c13709c$exports.isOpera = $ec4affac0c13709c$var$isOpera;
$ec4affac0c13709c$exports.isSafari = $ec4affac0c13709c$var$isSafari;
$ec4affac0c13709c$exports.isSamsungBrowser = $ec4affac0c13709c$var$isSamsungBrowser;
$ec4affac0c13709c$exports.isSmartTV = $ec4affac0c13709c$var$isSmartTV;
$ec4affac0c13709c$exports.isTablet = $ec4affac0c13709c$var$isTablet;
$ec4affac0c13709c$exports.isWearable = $ec4affac0c13709c$var$isWearable;
$ec4affac0c13709c$exports.isWinPhone = $ec4affac0c13709c$var$isWinPhone;
$ec4affac0c13709c$exports.isWindows = $ec4affac0c13709c$var$isWindows;
$ec4affac0c13709c$exports.isYandex = $ec4affac0c13709c$var$isYandex;
$ec4affac0c13709c$exports.mobileModel = $ec4affac0c13709c$var$mobileModel;
$ec4affac0c13709c$exports.mobileVendor = $ec4affac0c13709c$var$mobileVendor;
$ec4affac0c13709c$exports.osName = $ec4affac0c13709c$var$osName;
$ec4affac0c13709c$exports.osVersion = $ec4affac0c13709c$var$osVersion;
$ec4affac0c13709c$exports.parseUserAgent = $ec4affac0c13709c$var$parseUserAgent;
$ec4affac0c13709c$exports.setUserAgent = $ec4affac0c13709c$var$setUserAgent;
$ec4affac0c13709c$exports.useDeviceData = $ec4affac0c13709c$var$useDeviceData;
$ec4affac0c13709c$exports.useDeviceSelectors = $ec4affac0c13709c$var$useDeviceSelectors;
$ec4affac0c13709c$exports.useMobileOrientation = $ec4affac0c13709c$var$useMobileOrientation;
$ec4affac0c13709c$exports.withOrientationChange = $ec4affac0c13709c$var$withOrientationChange;





var $lCzvA = parcelRequire("lCzvA");
'use client';
function $fbffbe73b87b07ce$var$__insertCSS(code) {
    if (!code || typeof document == 'undefined') return;
    let head = document.head || document.getElementsByTagName('head')[0];
    let style = document.createElement('style');
    style.type = 'text/css';
    head.appendChild(style);
    style.styleSheet ? style.styleSheet.cssText = code : style.appendChild(document.createTextNode(code));
}
const $fbffbe73b87b07ce$var$DrawerContext = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).createContext({
    drawerRef: {
        current: null
    },
    overlayRef: {
        current: null
    },
    onPress: ()=>{},
    onRelease: ()=>{},
    onDrag: ()=>{},
    onNestedDrag: ()=>{},
    onNestedOpenChange: ()=>{},
    onNestedRelease: ()=>{},
    openProp: undefined,
    dismissible: false,
    isOpen: false,
    isDragging: false,
    keyboardIsOpen: {
        current: false
    },
    snapPointsOffset: null,
    snapPoints: null,
    handleOnly: false,
    modal: false,
    shouldFade: false,
    activeSnapPoint: null,
    onOpenChange: ()=>{},
    setActiveSnapPoint: ()=>{},
    closeDrawer: ()=>{},
    direction: 'bottom',
    shouldAnimate: {
        current: true
    },
    shouldScaleBackground: false,
    setBackgroundColorOnScale: true,
    noBodyStyles: false,
    container: null,
    autoFocus: false
});
const $fbffbe73b87b07ce$var$useDrawerContext = ()=>{
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useContext($fbffbe73b87b07ce$var$DrawerContext);
    if (!context) throw new Error('useDrawerContext must be used within a Drawer.Root');
    return context;
};
$fbffbe73b87b07ce$var$__insertCSS("[data-vaul-drawer]{touch-action:none;will-change:transform;transition:transform .5s cubic-bezier(.32, .72, 0, 1);animation-duration:.5s;animation-timing-function:cubic-bezier(0.32,0.72,0,1)}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=bottom][data-state=open]{animation-name:slideFromBottom}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=bottom][data-state=closed]{animation-name:slideToBottom}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=top][data-state=open]{animation-name:slideFromTop}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=top][data-state=closed]{animation-name:slideToTop}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=left][data-state=open]{animation-name:slideFromLeft}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=left][data-state=closed]{animation-name:slideToLeft}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=right][data-state=open]{animation-name:slideFromRight}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=right][data-state=closed]{animation-name:slideToRight}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=bottom]{transform:translate3d(0,var(--initial-transform,100%),0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=top]{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=left]{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=right]{transform:translate3d(var(--initial-transform,100%),0,0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=top]{transform:translate3d(0,var(--snap-point-height,0),0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=bottom]{transform:translate3d(0,var(--snap-point-height,0),0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=left]{transform:translate3d(var(--snap-point-height,0),0,0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=right]{transform:translate3d(var(--snap-point-height,0),0,0)}[data-vaul-overlay][data-vaul-snap-points=false]{animation-duration:.5s;animation-timing-function:cubic-bezier(0.32,0.72,0,1)}[data-vaul-overlay][data-vaul-snap-points=false][data-state=open]{animation-name:fadeIn}[data-vaul-overlay][data-state=closed]{animation-name:fadeOut}[data-vaul-animate=false]{animation:none!important}[data-vaul-overlay][data-vaul-snap-points=true]{opacity:0;transition:opacity .5s cubic-bezier(.32, .72, 0, 1)}[data-vaul-overlay][data-vaul-snap-points=true]{opacity:1}[data-vaul-drawer]:not([data-vaul-custom-container=true])::after{content:'';position:absolute;background:inherit;background-color:inherit}[data-vaul-drawer][data-vaul-drawer-direction=top]::after{top:initial;bottom:100%;left:0;right:0;height:200%}[data-vaul-drawer][data-vaul-drawer-direction=bottom]::after{top:100%;bottom:initial;left:0;right:0;height:200%}[data-vaul-drawer][data-vaul-drawer-direction=left]::after{left:initial;right:100%;top:0;bottom:0;width:200%}[data-vaul-drawer][data-vaul-drawer-direction=right]::after{left:100%;right:initial;top:0;bottom:0;width:200%}[data-vaul-overlay][data-vaul-snap-points=true]:not([data-vaul-snap-points-overlay=true]):not(\n[data-state=closed]\n){opacity:0}[data-vaul-overlay][data-vaul-snap-points-overlay=true]{opacity:1}[data-vaul-handle]{display:block;position:relative;opacity:.7;background:#e2e2e4;margin-left:auto;margin-right:auto;height:5px;width:32px;border-radius:1rem;touch-action:pan-y}[data-vaul-handle]:active,[data-vaul-handle]:hover{opacity:1}[data-vaul-handle-hitarea]{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:max(100%,2.75rem);height:max(100%,2.75rem);touch-action:inherit}@media (hover:hover) and (pointer:fine){[data-vaul-drawer]{user-select:none}}@media (pointer:fine){[data-vaul-handle-hitarea]:{width:100%;height:100%}}@keyframes fadeIn{from{opacity:0}to{opacity:1}}@keyframes fadeOut{to{opacity:0}}@keyframes slideFromBottom{from{transform:translate3d(0,var(--initial-transform,100%),0)}to{transform:translate3d(0,0,0)}}@keyframes slideToBottom{to{transform:translate3d(0,var(--initial-transform,100%),0)}}@keyframes slideFromTop{from{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}to{transform:translate3d(0,0,0)}}@keyframes slideToTop{to{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}}@keyframes slideFromLeft{from{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToLeft{to{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}}@keyframes slideFromRight{from{transform:translate3d(var(--initial-transform,100%),0,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToRight{to{transform:translate3d(var(--initial-transform,100%),0,0)}}");
function $fbffbe73b87b07ce$var$isMobileFirefox() {
    const userAgent = navigator.userAgent;
    return typeof window !== 'undefined' && (/Firefox/.test(userAgent) && /Mobile/.test(userAgent) || // Android Firefox
    /FxiOS/.test(userAgent) // iOS Firefox
    );
}
function $fbffbe73b87b07ce$var$isMac() {
    return $fbffbe73b87b07ce$var$testPlatform(/^Mac/);
}
function $fbffbe73b87b07ce$var$isIPhone() {
    return $fbffbe73b87b07ce$var$testPlatform(/^iPhone/);
}
function $fbffbe73b87b07ce$var$isSafari() {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}
function $fbffbe73b87b07ce$var$isIPad() {
    return $fbffbe73b87b07ce$var$testPlatform(/^iPad/) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $fbffbe73b87b07ce$var$isMac() && navigator.maxTouchPoints > 1;
}
function $fbffbe73b87b07ce$var$isIOS() {
    return $fbffbe73b87b07ce$var$isIPhone() || $fbffbe73b87b07ce$var$isIPad();
}
function $fbffbe73b87b07ce$var$testPlatform(re) {
    return typeof window !== 'undefined' && window.navigator != null ? re.test(window.navigator.platform) : undefined;
}
// This code comes from https://github.com/adobe/react-spectrum/blob/main/packages/%40react-aria/overlays/src/usePreventScroll.ts
const $fbffbe73b87b07ce$var$KEYBOARD_BUFFER = 24;
const $fbffbe73b87b07ce$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' ? (0, $lCzvA.useLayoutEffect) : (0, $lCzvA.useEffect);
function $fbffbe73b87b07ce$var$chain$1(...callbacks) {
    return (...args)=>{
        for (let callback of callbacks)if (typeof callback === 'function') callback(...args);
    };
}
// @ts-ignore
const $fbffbe73b87b07ce$var$visualViewport = typeof document !== 'undefined' && window.visualViewport;
function $fbffbe73b87b07ce$var$isScrollable(node) {
    let style = window.getComputedStyle(node);
    return /(auto|scroll)/.test(style.overflow + style.overflowX + style.overflowY);
}
function $fbffbe73b87b07ce$var$getScrollParent(node) {
    if ($fbffbe73b87b07ce$var$isScrollable(node)) node = node.parentElement;
    while(node && !$fbffbe73b87b07ce$var$isScrollable(node))node = node.parentElement;
    return node || document.scrollingElement || document.documentElement;
}
// HTML input types that do not cause the software keyboard to appear.
const $fbffbe73b87b07ce$var$nonTextInputTypes = new Set([
    'checkbox',
    'radio',
    'range',
    'color',
    'file',
    'image',
    'button',
    'submit',
    'reset'
]);
// The number of active usePreventScroll calls. Used to determine whether to revert back to the original page style/scroll position
let $fbffbe73b87b07ce$var$preventScrollCount = 0;
let $fbffbe73b87b07ce$var$restore;
/**
 * Prevents scrolling on the document body on mount, and
 * restores it on unmount. Also ensures that content does not
 * shift due to the scrollbars disappearing.
 */ function $fbffbe73b87b07ce$var$usePreventScroll(options = {}) {
    let { isDisabled: isDisabled } = options;
    $fbffbe73b87b07ce$var$useIsomorphicLayoutEffect(()=>{
        if (isDisabled) return;
        $fbffbe73b87b07ce$var$preventScrollCount++;
        if ($fbffbe73b87b07ce$var$preventScrollCount === 1) {
            if ($fbffbe73b87b07ce$var$isIOS()) $fbffbe73b87b07ce$var$restore = $fbffbe73b87b07ce$var$preventScrollMobileSafari();
        }
        return ()=>{
            $fbffbe73b87b07ce$var$preventScrollCount--;
            if ($fbffbe73b87b07ce$var$preventScrollCount === 0) $fbffbe73b87b07ce$var$restore == null || $fbffbe73b87b07ce$var$restore();
        };
    }, [
        isDisabled
    ]);
}
// Mobile Safari is a whole different beast. Even with overflow: hidden,
// it still scrolls the page in many situations:
//
// 1. When the bottom toolbar and address bar are collapsed, page scrolling is always allowed.
// 2. When the keyboard is visible, the viewport does not resize. Instead, the keyboard covers part of
//    it, so it becomes scrollable.
// 3. When tapping on an input, the page always scrolls so that the input is centered in the visual viewport.
//    This may cause even fixed position elements to scroll off the screen.
// 4. When using the next/previous buttons in the keyboard to navigate between inputs, the whole page always
//    scrolls, even if the input is inside a nested scrollable element that could be scrolled instead.
//
// In order to work around these cases, and prevent scrolling without jankiness, we do a few things:
//
// 1. Prevent default on `touchmove` events that are not in a scrollable element. This prevents touch scrolling
//    on the window.
// 2. Prevent default on `touchmove` events inside a scrollable element when the scroll position is at the
//    top or bottom. This avoids the whole page scrolling instead, but does prevent overscrolling.
// 3. Prevent default on `touchend` events on input elements and handle focusing the element ourselves.
// 4. When focusing an input, apply a transform to trick Safari into thinking the input is at the top
//    of the page, which prevents it from scrolling the page. After the input is focused, scroll the element
//    into view ourselves, without scrolling the whole page.
// 5. Offset the body by the scroll position using a negative margin and scroll to the top. This should appear the
//    same visually, but makes the actual scroll position always zero. This is required to make all of the
//    above work or Safari will still try to scroll the page when focusing an input.
// 6. As a last resort, handle window scroll events, and scroll back to the top. This can happen when attempting
//    to navigate to an input with the next/previous buttons that's outside a modal.
function $fbffbe73b87b07ce$var$preventScrollMobileSafari() {
    let scrollable;
    let lastY = 0;
    let onTouchStart = (e)=>{
        // Store the nearest scrollable parent element from the element that the user touched.
        scrollable = $fbffbe73b87b07ce$var$getScrollParent(e.target);
        if (scrollable === document.documentElement && scrollable === document.body) return;
        lastY = e.changedTouches[0].pageY;
    };
    let onTouchMove = (e)=>{
        // Prevent scrolling the window.
        if (!scrollable || scrollable === document.documentElement || scrollable === document.body) {
            e.preventDefault();
            return;
        }
        // Prevent scrolling up when at the top and scrolling down when at the bottom
        // of a nested scrollable area, otherwise mobile Safari will start scrolling
        // the window instead. Unfortunately, this disables bounce scrolling when at
        // the top but it's the best we can do.
        let y = e.changedTouches[0].pageY;
        let scrollTop = scrollable.scrollTop;
        let bottom = scrollable.scrollHeight - scrollable.clientHeight;
        if (bottom === 0) return;
        if (scrollTop <= 0 && y > lastY || scrollTop >= bottom && y < lastY) e.preventDefault();
        lastY = y;
    };
    let onTouchEnd = (e)=>{
        let target = e.target;
        // Apply this change if we're not already focused on the target element
        if ($fbffbe73b87b07ce$var$isInput(target) && target !== document.activeElement) {
            e.preventDefault();
            // Apply a transform to trick Safari into thinking the input is at the top of the page
            // so it doesn't try to scroll it into view. When tapping on an input, this needs to
            // be done before the "focus" event, so we have to focus the element ourselves.
            target.style.transform = 'translateY(-2000px)';
            target.focus();
            requestAnimationFrame(()=>{
                target.style.transform = '';
            });
        }
    };
    let onFocus = (e)=>{
        let target = e.target;
        if ($fbffbe73b87b07ce$var$isInput(target)) {
            // Transform also needs to be applied in the focus event in cases where focus moves
            // other than tapping on an input directly, e.g. the next/previous buttons in the
            // software keyboard. In these cases, it seems applying the transform in the focus event
            // is good enough, whereas when tapping an input, it must be done before the focus event. 🤷‍♂️
            target.style.transform = 'translateY(-2000px)';
            requestAnimationFrame(()=>{
                target.style.transform = '';
                // This will have prevented the browser from scrolling the focused element into view,
                // so we need to do this ourselves in a way that doesn't cause the whole page to scroll.
                if ($fbffbe73b87b07ce$var$visualViewport) {
                    if ($fbffbe73b87b07ce$var$visualViewport.height < window.innerHeight) // If the keyboard is already visible, do this after one additional frame
                    // to wait for the transform to be removed.
                    requestAnimationFrame(()=>{
                        $fbffbe73b87b07ce$var$scrollIntoView(target);
                    });
                    else // Otherwise, wait for the visual viewport to resize before scrolling so we can
                    // measure the correct position to scroll to.
                    $fbffbe73b87b07ce$var$visualViewport.addEventListener('resize', ()=>$fbffbe73b87b07ce$var$scrollIntoView(target), {
                        once: true
                    });
                }
            });
        }
    };
    let onWindowScroll = ()=>{
        // Last resort. If the window scrolled, scroll it back to the top.
        // It should always be at the top because the body will have a negative margin (see below).
        window.scrollTo(0, 0);
    };
    // Record the original scroll position so we can restore it.
    // Then apply a negative margin to the body to offset it by the scroll position. This will
    // enable us to scroll the window to the top, which is required for the rest of this to work.
    let scrollX = window.pageXOffset;
    let scrollY = window.pageYOffset;
    let restoreStyles = $fbffbe73b87b07ce$var$chain$1($fbffbe73b87b07ce$var$setStyle(document.documentElement, 'paddingRight', `${window.innerWidth - document.documentElement.clientWidth}px`));
    // Scroll to the top. The negative margin on the body will make this appear the same.
    window.scrollTo(0, 0);
    let removeEvents = $fbffbe73b87b07ce$var$chain$1($fbffbe73b87b07ce$var$addEvent(document, 'touchstart', onTouchStart, {
        passive: false,
        capture: true
    }), $fbffbe73b87b07ce$var$addEvent(document, 'touchmove', onTouchMove, {
        passive: false,
        capture: true
    }), $fbffbe73b87b07ce$var$addEvent(document, 'touchend', onTouchEnd, {
        passive: false,
        capture: true
    }), $fbffbe73b87b07ce$var$addEvent(document, 'focus', onFocus, true), $fbffbe73b87b07ce$var$addEvent(window, 'scroll', onWindowScroll));
    return ()=>{
        // Restore styles and scroll the page back to where it was.
        restoreStyles();
        removeEvents();
        window.scrollTo(scrollX, scrollY);
    };
}
// Sets a CSS property on an element, and returns a function to revert it to the previous value.
function $fbffbe73b87b07ce$var$setStyle(element, style, value) {
    // https://github.com/microsoft/TypeScript/issues/17827#issuecomment-391663310
    // @ts-ignore
    let cur = element.style[style];
    // @ts-ignore
    element.style[style] = value;
    return ()=>{
        // @ts-ignore
        element.style[style] = cur;
    };
}
// Adds an event listener to an element, and returns a function to remove it.
function $fbffbe73b87b07ce$var$addEvent(target, event, handler, options) {
    // @ts-ignore
    target.addEventListener(event, handler, options);
    return ()=>{
        // @ts-ignore
        target.removeEventListener(event, handler, options);
    };
}
function $fbffbe73b87b07ce$var$scrollIntoView(target) {
    let root = document.scrollingElement || document.documentElement;
    while(target && target !== root){
        // Find the parent scrollable element and adjust the scroll position if the target is not already in view.
        let scrollable = $fbffbe73b87b07ce$var$getScrollParent(target);
        if (scrollable !== document.documentElement && scrollable !== document.body && scrollable !== target) {
            let scrollableTop = scrollable.getBoundingClientRect().top;
            let targetTop = target.getBoundingClientRect().top;
            let targetBottom = target.getBoundingClientRect().bottom;
            // Buffer is needed for some edge cases
            const keyboardHeight = scrollable.getBoundingClientRect().bottom + $fbffbe73b87b07ce$var$KEYBOARD_BUFFER;
            if (targetBottom > keyboardHeight) scrollable.scrollTop += targetTop - scrollableTop;
        }
        // @ts-ignore
        target = scrollable.parentElement;
    }
}
function $fbffbe73b87b07ce$var$isInput(target) {
    return target instanceof HTMLInputElement && !$fbffbe73b87b07ce$var$nonTextInputTypes.has(target.type) || target instanceof HTMLTextAreaElement || target instanceof HTMLElement && target.isContentEditable;
}
// This code comes from https://github.com/radix-ui/primitives/tree/main/packages/react/compose-refs
/**
 * Set a given ref to a given value
 * This utility takes care of different types of refs: callback refs and RefObject(s)
 */ function $fbffbe73b87b07ce$var$setRef(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref !== null && ref !== undefined) ref.current = value;
}
/**
 * A utility to compose multiple refs together
 * Accepts callback refs and RefObject(s)
 */ function $fbffbe73b87b07ce$var$composeRefs(...refs) {
    return (node)=>refs.forEach((ref)=>$fbffbe73b87b07ce$var$setRef(ref, node));
}
/**
 * A custom hook that composes multiple refs
 * Accepts callback refs and RefObject(s)
 */ function $fbffbe73b87b07ce$var$useComposedRefs(...refs) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return $lCzvA.useCallback($fbffbe73b87b07ce$var$composeRefs(...refs), refs);
}
const $fbffbe73b87b07ce$var$cache = new WeakMap();
function $fbffbe73b87b07ce$var$set(el, styles, ignoreCache = false) {
    if (!el || !(el instanceof HTMLElement)) return;
    let originalStyles = {};
    Object.entries(styles).forEach(([key, value])=>{
        if (key.startsWith('--')) {
            el.style.setProperty(key, value);
            return;
        }
        originalStyles[key] = el.style[key];
        el.style[key] = value;
    });
    if (ignoreCache) return;
    $fbffbe73b87b07ce$var$cache.set(el, originalStyles);
}
function $fbffbe73b87b07ce$var$reset(el, prop) {
    if (!el || !(el instanceof HTMLElement)) return;
    let originalStyles = $fbffbe73b87b07ce$var$cache.get(el);
    if (!originalStyles) return;
    el.style[prop] = originalStyles[prop];
}
const $fbffbe73b87b07ce$var$isVertical = (direction)=>{
    switch(direction){
        case 'top':
        case 'bottom':
            return true;
        case 'left':
        case 'right':
            return false;
        default:
            return direction;
    }
};
function $fbffbe73b87b07ce$var$getTranslate(element, direction) {
    if (!element) return null;
    const style = window.getComputedStyle(element);
    const transform = style.transform || style.webkitTransform || style.mozTransform;
    let mat = transform.match(/^matrix3d\((.+)\)$/);
    if (mat) // https://developer.mozilla.org/en-US/docs/Web/CSS/transform-function/matrix3d
    return parseFloat(mat[1].split(', ')[$fbffbe73b87b07ce$var$isVertical(direction) ? 13 : 12]);
    // https://developer.mozilla.org/en-US/docs/Web/CSS/transform-function/matrix
    mat = transform.match(/^matrix\((.+)\)$/);
    return mat ? parseFloat(mat[1].split(', ')[$fbffbe73b87b07ce$var$isVertical(direction) ? 5 : 4]) : null;
}
function $fbffbe73b87b07ce$var$dampenValue(v) {
    return 8 * (Math.log(v + 1) - 2);
}
function $fbffbe73b87b07ce$var$assignStyle(element, style) {
    if (!element) return ()=>{};
    const prevStyle = element.style.cssText;
    Object.assign(element.style, style);
    return ()=>{
        element.style.cssText = prevStyle;
    };
}
/**
 * Receives functions as arguments and returns a new function that calls all.
 */ function $fbffbe73b87b07ce$var$chain(...fns) {
    return (...args)=>{
        for (const fn of fns)if (typeof fn === 'function') // @ts-ignore
        fn(...args);
    };
}
const $fbffbe73b87b07ce$var$TRANSITIONS = {
    DURATION: 0.5,
    EASE: [
        0.32,
        0.72,
        0,
        1
    ]
};
const $fbffbe73b87b07ce$var$VELOCITY_THRESHOLD = 0.4;
const $fbffbe73b87b07ce$var$CLOSE_THRESHOLD = 0.25;
const $fbffbe73b87b07ce$var$SCROLL_LOCK_TIMEOUT = 100;
const $fbffbe73b87b07ce$var$BORDER_RADIUS = 8;
const $fbffbe73b87b07ce$var$NESTED_DISPLACEMENT = 16;
const $fbffbe73b87b07ce$var$WINDOW_TOP_OFFSET = 26;
const $fbffbe73b87b07ce$var$DRAG_CLASS = 'vaul-dragging';
// This code comes from https://github.com/radix-ui/primitives/blob/main/packages/react/use-controllable-state/src/useControllableState.tsx
function $fbffbe73b87b07ce$var$useCallbackRef(callback) {
    const callbackRef = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useRef(callback);
    (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useEffect(()=>{
        callbackRef.current = callback;
    });
    // https://github.com/facebook/react/issues/19240
    return (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useMemo(()=>(...args)=>callbackRef.current == null ? void 0 : callbackRef.current.call(callbackRef, ...args), []);
}
function $fbffbe73b87b07ce$var$useUncontrolledState({ defaultProp: defaultProp, onChange: onChange }) {
    const uncontrolledState = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useState(defaultProp);
    const [value] = uncontrolledState;
    const prevValueRef = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useRef(value);
    const handleChange = $fbffbe73b87b07ce$var$useCallbackRef(onChange);
    (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useEffect(()=>{
        if (prevValueRef.current !== value) {
            handleChange(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef,
        handleChange
    ]);
    return uncontrolledState;
}
function $fbffbe73b87b07ce$var$useControllableState({ prop: prop, defaultProp: defaultProp, onChange: onChange = ()=>{} }) {
    const [uncontrolledProp, setUncontrolledProp] = $fbffbe73b87b07ce$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== undefined;
    const value = isControlled ? prop : uncontrolledProp;
    const handleChange = $fbffbe73b87b07ce$var$useCallbackRef(onChange);
    const setValue = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useCallback((nextValue)=>{
        if (isControlled) {
            const setter = nextValue;
            const value = typeof nextValue === 'function' ? setter(prop) : nextValue;
            if (value !== prop) handleChange(value);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        handleChange
    ]);
    return [
        value,
        setValue
    ];
}
function $fbffbe73b87b07ce$var$useSnapPoints({ activeSnapPointProp: activeSnapPointProp, setActiveSnapPointProp: setActiveSnapPointProp, snapPoints: snapPoints, drawerRef: drawerRef, overlayRef: overlayRef, fadeFromIndex: fadeFromIndex, onSnapPointChange: onSnapPointChange, direction: direction = 'bottom', container: container, snapToSequentialPoint: snapToSequentialPoint }) {
    const [activeSnapPoint, setActiveSnapPoint] = $fbffbe73b87b07ce$var$useControllableState({
        prop: activeSnapPointProp,
        defaultProp: snapPoints == null ? void 0 : snapPoints[0],
        onChange: setActiveSnapPointProp
    });
    const [windowDimensions, setWindowDimensions] = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useState(typeof window !== 'undefined' ? {
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight
    } : undefined);
    (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useEffect(()=>{
        function onResize() {
            setWindowDimensions({
                innerWidth: window.innerWidth,
                innerHeight: window.innerHeight
            });
        }
        window.addEventListener('resize', onResize);
        return ()=>window.removeEventListener('resize', onResize);
    }, []);
    const isLastSnapPoint = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useMemo(()=>activeSnapPoint === (snapPoints == null ? void 0 : snapPoints[snapPoints.length - 1]) || null, [
        snapPoints,
        activeSnapPoint
    ]);
    const activeSnapPointIndex = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useMemo(()=>{
        var _snapPoints_findIndex;
        return (_snapPoints_findIndex = snapPoints == null ? void 0 : snapPoints.findIndex((snapPoint)=>snapPoint === activeSnapPoint)) != null ? _snapPoints_findIndex : null;
    }, [
        snapPoints,
        activeSnapPoint
    ]);
    const shouldFade = snapPoints && snapPoints.length > 0 && (fadeFromIndex || fadeFromIndex === 0) && !Number.isNaN(fadeFromIndex) && snapPoints[fadeFromIndex] === activeSnapPoint || !snapPoints;
    const snapPointsOffset = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useMemo(()=>{
        const containerSize = container ? {
            width: container.getBoundingClientRect().width,
            height: container.getBoundingClientRect().height
        } : typeof window !== 'undefined' ? {
            width: window.innerWidth,
            height: window.innerHeight
        } : {
            width: 0,
            height: 0
        };
        var _snapPoints_map;
        return (_snapPoints_map = snapPoints == null ? void 0 : snapPoints.map((snapPoint)=>{
            const isPx = typeof snapPoint === 'string';
            let snapPointAsNumber = 0;
            if (isPx) snapPointAsNumber = parseInt(snapPoint, 10);
            if ($fbffbe73b87b07ce$var$isVertical(direction)) {
                const height = isPx ? snapPointAsNumber : windowDimensions ? snapPoint * containerSize.height : 0;
                if (windowDimensions) return direction === 'bottom' ? containerSize.height - height : -containerSize.height + height;
                return height;
            }
            const width = isPx ? snapPointAsNumber : windowDimensions ? snapPoint * containerSize.width : 0;
            if (windowDimensions) return direction === 'right' ? containerSize.width - width : -containerSize.width + width;
            return width;
        })) != null ? _snapPoints_map : [];
    }, [
        snapPoints,
        windowDimensions,
        container
    ]);
    const activeSnapPointOffset = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useMemo(()=>activeSnapPointIndex !== null ? snapPointsOffset == null ? void 0 : snapPointsOffset[activeSnapPointIndex] : null, [
        snapPointsOffset,
        activeSnapPointIndex
    ]);
    const snapToPoint = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useCallback((dimension)=>{
        var _snapPointsOffset_findIndex;
        const newSnapPointIndex = (_snapPointsOffset_findIndex = snapPointsOffset == null ? void 0 : snapPointsOffset.findIndex((snapPointDim)=>snapPointDim === dimension)) != null ? _snapPointsOffset_findIndex : null;
        onSnapPointChange(newSnapPointIndex);
        $fbffbe73b87b07ce$var$set(drawerRef.current, {
            transition: `transform ${$fbffbe73b87b07ce$var$TRANSITIONS.DURATION}s cubic-bezier(${$fbffbe73b87b07ce$var$TRANSITIONS.EASE.join(',')})`,
            transform: $fbffbe73b87b07ce$var$isVertical(direction) ? `translate3d(0, ${dimension}px, 0)` : `translate3d(${dimension}px, 0, 0)`
        });
        if (snapPointsOffset && newSnapPointIndex !== snapPointsOffset.length - 1 && fadeFromIndex !== undefined && newSnapPointIndex !== fadeFromIndex && newSnapPointIndex < fadeFromIndex) $fbffbe73b87b07ce$var$set(overlayRef.current, {
            transition: `opacity ${$fbffbe73b87b07ce$var$TRANSITIONS.DURATION}s cubic-bezier(${$fbffbe73b87b07ce$var$TRANSITIONS.EASE.join(',')})`,
            opacity: '0'
        });
        else $fbffbe73b87b07ce$var$set(overlayRef.current, {
            transition: `opacity ${$fbffbe73b87b07ce$var$TRANSITIONS.DURATION}s cubic-bezier(${$fbffbe73b87b07ce$var$TRANSITIONS.EASE.join(',')})`,
            opacity: '1'
        });
        setActiveSnapPoint(snapPoints == null ? void 0 : snapPoints[Math.max(newSnapPointIndex, 0)]);
    }, [
        drawerRef.current,
        snapPoints,
        snapPointsOffset,
        fadeFromIndex,
        overlayRef,
        setActiveSnapPoint
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useEffect(()=>{
        if (activeSnapPoint || activeSnapPointProp) {
            var _snapPoints_findIndex;
            const newIndex = (_snapPoints_findIndex = snapPoints == null ? void 0 : snapPoints.findIndex((snapPoint)=>snapPoint === activeSnapPointProp || snapPoint === activeSnapPoint)) != null ? _snapPoints_findIndex : -1;
            if (snapPointsOffset && newIndex !== -1 && typeof snapPointsOffset[newIndex] === 'number') snapToPoint(snapPointsOffset[newIndex]);
        }
    }, [
        activeSnapPoint,
        activeSnapPointProp,
        snapPoints,
        snapPointsOffset,
        snapToPoint
    ]);
    function onRelease({ draggedDistance: draggedDistance, closeDrawer: closeDrawer, velocity: velocity, dismissible: dismissible }) {
        if (fadeFromIndex === undefined) return;
        const currentPosition = direction === 'bottom' || direction === 'right' ? (activeSnapPointOffset != null ? activeSnapPointOffset : 0) - draggedDistance : (activeSnapPointOffset != null ? activeSnapPointOffset : 0) + draggedDistance;
        const isOverlaySnapPoint = activeSnapPointIndex === fadeFromIndex - 1;
        const isFirst = activeSnapPointIndex === 0;
        const hasDraggedUp = draggedDistance > 0;
        if (isOverlaySnapPoint) $fbffbe73b87b07ce$var$set(overlayRef.current, {
            transition: `opacity ${$fbffbe73b87b07ce$var$TRANSITIONS.DURATION}s cubic-bezier(${$fbffbe73b87b07ce$var$TRANSITIONS.EASE.join(',')})`
        });
        if (!snapToSequentialPoint && velocity > 2 && !hasDraggedUp) {
            if (dismissible) closeDrawer();
            else snapToPoint(snapPointsOffset[0]); // snap to initial point
            return;
        }
        if (!snapToSequentialPoint && velocity > 2 && hasDraggedUp && snapPointsOffset && snapPoints) {
            snapToPoint(snapPointsOffset[snapPoints.length - 1]);
            return;
        }
        // Find the closest snap point to the current position
        const closestSnapPoint = snapPointsOffset == null ? void 0 : snapPointsOffset.reduce((prev, curr)=>{
            if (typeof prev !== 'number' || typeof curr !== 'number') return prev;
            return Math.abs(curr - currentPosition) < Math.abs(prev - currentPosition) ? curr : prev;
        });
        const dim = $fbffbe73b87b07ce$var$isVertical(direction) ? window.innerHeight : window.innerWidth;
        if (velocity > $fbffbe73b87b07ce$var$VELOCITY_THRESHOLD && Math.abs(draggedDistance) < dim * 0.4) {
            const dragDirection = hasDraggedUp ? 1 : -1; // 1 = up, -1 = down
            // Don't do anything if we swipe upwards while being on the last snap point
            if (dragDirection > 0 && isLastSnapPoint && snapPoints) {
                snapToPoint(snapPointsOffset[snapPoints.length - 1]);
                return;
            }
            if (isFirst && dragDirection < 0 && dismissible) closeDrawer();
            if (activeSnapPointIndex === null) return;
            snapToPoint(snapPointsOffset[activeSnapPointIndex + dragDirection]);
            return;
        }
        snapToPoint(closestSnapPoint);
    }
    function onDrag({ draggedDistance: draggedDistance }) {
        if (activeSnapPointOffset === null) return;
        const newValue = direction === 'bottom' || direction === 'right' ? activeSnapPointOffset - draggedDistance : activeSnapPointOffset + draggedDistance;
        // Don't do anything if we exceed the last(biggest) snap point
        if ((direction === 'bottom' || direction === 'right') && newValue < snapPointsOffset[snapPointsOffset.length - 1]) return;
        if ((direction === 'top' || direction === 'left') && newValue > snapPointsOffset[snapPointsOffset.length - 1]) return;
        $fbffbe73b87b07ce$var$set(drawerRef.current, {
            transform: $fbffbe73b87b07ce$var$isVertical(direction) ? `translate3d(0, ${newValue}px, 0)` : `translate3d(${newValue}px, 0, 0)`
        });
    }
    function getPercentageDragged(absDraggedDistance, isDraggingDown) {
        if (!snapPoints || typeof activeSnapPointIndex !== 'number' || !snapPointsOffset || fadeFromIndex === undefined) return null;
        // If this is true we are dragging to a snap point that is supposed to have an overlay
        const isOverlaySnapPoint = activeSnapPointIndex === fadeFromIndex - 1;
        const isOverlaySnapPointOrHigher = activeSnapPointIndex >= fadeFromIndex;
        if (isOverlaySnapPointOrHigher && isDraggingDown) return 0;
        // Don't animate, but still use this one if we are dragging away from the overlaySnapPoint
        if (isOverlaySnapPoint && !isDraggingDown) return 1;
        if (!shouldFade && !isOverlaySnapPoint) return null;
        // Either fadeFrom index or the one before
        const targetSnapPointIndex = isOverlaySnapPoint ? activeSnapPointIndex + 1 : activeSnapPointIndex - 1;
        // Get the distance from overlaySnapPoint to the one before or vice-versa to calculate the opacity percentage accordingly
        const snapPointDistance = isOverlaySnapPoint ? snapPointsOffset[targetSnapPointIndex] - snapPointsOffset[targetSnapPointIndex - 1] : snapPointsOffset[targetSnapPointIndex + 1] - snapPointsOffset[targetSnapPointIndex];
        const percentageDragged = absDraggedDistance / Math.abs(snapPointDistance);
        if (isOverlaySnapPoint) return 1 - percentageDragged;
        else return percentageDragged;
    }
    return {
        isLastSnapPoint: isLastSnapPoint,
        activeSnapPoint: activeSnapPoint,
        shouldFade: shouldFade,
        getPercentageDragged: getPercentageDragged,
        setActiveSnapPoint: setActiveSnapPoint,
        activeSnapPointIndex: activeSnapPointIndex,
        onRelease: onRelease,
        onDrag: onDrag,
        snapPointsOffset: snapPointsOffset
    };
}
const $fbffbe73b87b07ce$var$noop = ()=>()=>{};
function $fbffbe73b87b07ce$var$useScaleBackground() {
    const { direction: direction, isOpen: isOpen, shouldScaleBackground: shouldScaleBackground, setBackgroundColorOnScale: setBackgroundColorOnScale, noBodyStyles: noBodyStyles } = $fbffbe73b87b07ce$var$useDrawerContext();
    const timeoutIdRef = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useRef(null);
    const initialBackgroundColor = (0, $lCzvA.useMemo)(()=>document.body.style.backgroundColor, []);
    function getScale() {
        return (window.innerWidth - $fbffbe73b87b07ce$var$WINDOW_TOP_OFFSET) / window.innerWidth;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useEffect(()=>{
        if (isOpen && shouldScaleBackground) {
            if (timeoutIdRef.current) clearTimeout(timeoutIdRef.current);
            const wrapper = document.querySelector('[data-vaul-drawer-wrapper]') || document.querySelector('[vaul-drawer-wrapper]');
            if (!wrapper) return;
            $fbffbe73b87b07ce$var$chain(setBackgroundColorOnScale && !noBodyStyles ? $fbffbe73b87b07ce$var$assignStyle(document.body, {
                background: 'black'
            }) : $fbffbe73b87b07ce$var$noop, $fbffbe73b87b07ce$var$assignStyle(wrapper, {
                transformOrigin: $fbffbe73b87b07ce$var$isVertical(direction) ? 'top' : 'left',
                transitionProperty: 'transform, border-radius',
                transitionDuration: `${$fbffbe73b87b07ce$var$TRANSITIONS.DURATION}s`,
                transitionTimingFunction: `cubic-bezier(${$fbffbe73b87b07ce$var$TRANSITIONS.EASE.join(',')})`
            }));
            const wrapperStylesCleanup = $fbffbe73b87b07ce$var$assignStyle(wrapper, {
                borderRadius: `${$fbffbe73b87b07ce$var$BORDER_RADIUS}px`,
                overflow: 'hidden',
                ...$fbffbe73b87b07ce$var$isVertical(direction) ? {
                    transform: `scale(${getScale()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`
                } : {
                    transform: `scale(${getScale()}) translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)`
                }
            });
            return ()=>{
                wrapperStylesCleanup();
                timeoutIdRef.current = window.setTimeout(()=>{
                    if (initialBackgroundColor) document.body.style.background = initialBackgroundColor;
                    else document.body.style.removeProperty('background');
                }, $fbffbe73b87b07ce$var$TRANSITIONS.DURATION * 1000);
            };
        }
    }, [
        isOpen,
        shouldScaleBackground,
        initialBackgroundColor
    ]);
}
let $fbffbe73b87b07ce$var$previousBodyPosition = null;
/**
 * This hook is necessary to prevent buggy behavior on iOS devices (need to test on Android).
 * I won't get into too much detail about what bugs it solves, but so far I've found that setting the body to `position: fixed` is the most reliable way to prevent those bugs.
 * Issues that this hook solves:
 * https://github.com/emilkowalski/vaul/issues/435
 * https://github.com/emilkowalski/vaul/issues/433
 * And more that I discovered, but were just not reported.
 */ function $fbffbe73b87b07ce$var$usePositionFixed({ isOpen: isOpen, modal: modal, nested: nested, hasBeenOpened: hasBeenOpened, preventScrollRestoration: preventScrollRestoration, noBodyStyles: noBodyStyles }) {
    const [activeUrl, setActiveUrl] = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useState(()=>typeof window !== 'undefined' ? window.location.href : '');
    const scrollPos = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useRef(0);
    const setPositionFixed = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useCallback(()=>{
        // All browsers on iOS will return true here.
        if (!$fbffbe73b87b07ce$var$isSafari()) return;
        // If previousBodyPosition is already set, don't set it again.
        if ($fbffbe73b87b07ce$var$previousBodyPosition === null && isOpen && !noBodyStyles) {
            $fbffbe73b87b07ce$var$previousBodyPosition = {
                position: document.body.style.position,
                top: document.body.style.top,
                left: document.body.style.left,
                height: document.body.style.height,
                right: 'unset'
            };
            // Update the dom inside an animation frame
            const { scrollX: scrollX, innerHeight: innerHeight } = window;
            document.body.style.setProperty('position', 'fixed', 'important');
            Object.assign(document.body.style, {
                top: `${-scrollPos.current}px`,
                left: `${-scrollX}px`,
                right: '0px',
                height: 'auto'
            });
            window.setTimeout(()=>window.requestAnimationFrame(()=>{
                    // Attempt to check if the bottom bar appeared due to the position change
                    const bottomBarHeight = innerHeight - window.innerHeight;
                    if (bottomBarHeight && scrollPos.current >= innerHeight) // Move the content further up so that the bottom bar doesn't hide it
                    document.body.style.top = `${-(scrollPos.current + bottomBarHeight)}px`;
                }), 300);
        }
    }, [
        isOpen
    ]);
    const restorePositionSetting = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useCallback(()=>{
        // All browsers on iOS will return true here.
        if (!$fbffbe73b87b07ce$var$isSafari()) return;
        if ($fbffbe73b87b07ce$var$previousBodyPosition !== null && !noBodyStyles) {
            // Convert the position from "px" to Int
            const y = -parseInt(document.body.style.top, 10);
            const x = -parseInt(document.body.style.left, 10);
            // Restore styles
            Object.assign(document.body.style, $fbffbe73b87b07ce$var$previousBodyPosition);
            window.requestAnimationFrame(()=>{
                if (preventScrollRestoration && activeUrl !== window.location.href) {
                    setActiveUrl(window.location.href);
                    return;
                }
                window.scrollTo(x, y);
            });
            $fbffbe73b87b07ce$var$previousBodyPosition = null;
        }
    }, [
        activeUrl
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useEffect(()=>{
        function onScroll() {
            scrollPos.current = window.scrollY;
        }
        onScroll();
        window.addEventListener('scroll', onScroll);
        return ()=>{
            window.removeEventListener('scroll', onScroll);
        };
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useEffect(()=>{
        if (!modal) return;
        return ()=>{
            if (typeof document === 'undefined') return;
            // Another drawer is opened, safe to ignore the execution
            const hasDrawerOpened = !!document.querySelector('[data-vaul-drawer]');
            if (hasDrawerOpened) return;
            restorePositionSetting();
        };
    }, [
        modal,
        restorePositionSetting
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useEffect(()=>{
        if (nested || !hasBeenOpened) return;
        // This is needed to force Safari toolbar to show **before** the drawer starts animating to prevent a gnarly shift from happening
        if (isOpen) {
            // avoid for standalone mode (PWA)
            const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
            !isStandalone && setPositionFixed();
            if (!modal) window.setTimeout(()=>{
                restorePositionSetting();
            }, 500);
        } else restorePositionSetting();
    }, [
        isOpen,
        hasBeenOpened,
        activeUrl,
        modal,
        nested,
        setPositionFixed,
        restorePositionSetting
    ]);
    return {
        restorePositionSetting: restorePositionSetting
    };
}
function $fbffbe73b87b07ce$export$be92b6f5f03c0fe9({ open: openProp, onOpenChange: onOpenChange, children: children, onDrag: onDragProp, onRelease: onReleaseProp, snapPoints: snapPoints, shouldScaleBackground: shouldScaleBackground = false, setBackgroundColorOnScale: setBackgroundColorOnScale = true, closeThreshold: closeThreshold = $fbffbe73b87b07ce$var$CLOSE_THRESHOLD, scrollLockTimeout: scrollLockTimeout = $fbffbe73b87b07ce$var$SCROLL_LOCK_TIMEOUT, dismissible: dismissible = true, handleOnly: handleOnly = false, fadeFromIndex: fadeFromIndex = snapPoints && snapPoints.length - 1, activeSnapPoint: activeSnapPointProp, setActiveSnapPoint: setActiveSnapPointProp, fixed: fixed, modal: modal = true, onClose: onClose, nested: nested, noBodyStyles: noBodyStyles = false, direction: direction = 'bottom', defaultOpen: defaultOpen = false, disablePreventScroll: disablePreventScroll = true, snapToSequentialPoint: snapToSequentialPoint = false, preventScrollRestoration: preventScrollRestoration = false, repositionInputs: repositionInputs = true, onAnimationEnd: onAnimationEnd, container: container, autoFocus: autoFocus = false }) {
    var _drawerRef_current, _drawerRef_current1;
    const [isOpen = false, setIsOpen] = $fbffbe73b87b07ce$var$useControllableState({
        defaultProp: defaultOpen,
        prop: openProp,
        onChange: (o)=>{
            onOpenChange == null || onOpenChange(o);
            if (!o && !nested) restorePositionSetting();
            setTimeout(()=>{
                onAnimationEnd == null || onAnimationEnd(o);
            }, $fbffbe73b87b07ce$var$TRANSITIONS.DURATION * 1000);
            if (o && !modal) {
                if (typeof window !== 'undefined') window.requestAnimationFrame(()=>{
                    document.body.style.pointerEvents = 'auto';
                });
            }
            if (!o) // This will be removed when the exit animation ends (`500ms`)
            document.body.style.pointerEvents = 'auto';
        }
    });
    const [hasBeenOpened, setHasBeenOpened] = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useState(false);
    const [isDragging, setIsDragging] = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useState(false);
    const [justReleased, setJustReleased] = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useState(false);
    const overlayRef = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useRef(null);
    const openTime = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useRef(null);
    const dragStartTime = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useRef(null);
    const dragEndTime = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useRef(null);
    const lastTimeDragPrevented = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useRef(null);
    const isAllowedToDrag = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useRef(false);
    const nestedOpenChangeTimer = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useRef(null);
    const pointerStart = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useRef(0);
    const keyboardIsOpen = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useRef(false);
    const shouldAnimate = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useRef(!defaultOpen);
    const previousDiffFromInitial = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useRef(0);
    const drawerRef = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useRef(null);
    const drawerHeightRef = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useRef(((_drawerRef_current = drawerRef.current) == null ? void 0 : _drawerRef_current.getBoundingClientRect().height) || 0);
    const drawerWidthRef = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useRef(((_drawerRef_current1 = drawerRef.current) == null ? void 0 : _drawerRef_current1.getBoundingClientRect().width) || 0);
    const initialDrawerHeight = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useRef(0);
    const onSnapPointChange = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useCallback((activeSnapPointIndex)=>{
        // Change openTime ref when we reach the last snap point to prevent dragging for 500ms incase it's scrollable.
        if (snapPoints && activeSnapPointIndex === snapPointsOffset.length - 1) openTime.current = new Date();
    }, []);
    const { activeSnapPoint: activeSnapPoint, activeSnapPointIndex: activeSnapPointIndex, setActiveSnapPoint: setActiveSnapPoint, onRelease: onReleaseSnapPoints, snapPointsOffset: snapPointsOffset, onDrag: onDragSnapPoints, shouldFade: shouldFade, getPercentageDragged: getSnapPointsPercentageDragged } = $fbffbe73b87b07ce$var$useSnapPoints({
        snapPoints: snapPoints,
        activeSnapPointProp: activeSnapPointProp,
        setActiveSnapPointProp: setActiveSnapPointProp,
        drawerRef: drawerRef,
        fadeFromIndex: fadeFromIndex,
        overlayRef: overlayRef,
        onSnapPointChange: onSnapPointChange,
        direction: direction,
        container: container,
        snapToSequentialPoint: snapToSequentialPoint
    });
    $fbffbe73b87b07ce$var$usePreventScroll({
        isDisabled: !isOpen || isDragging || !modal || justReleased || !hasBeenOpened || !repositionInputs || !disablePreventScroll
    });
    const { restorePositionSetting: restorePositionSetting } = $fbffbe73b87b07ce$var$usePositionFixed({
        isOpen: isOpen,
        modal: modal,
        nested: nested != null ? nested : false,
        hasBeenOpened: hasBeenOpened,
        preventScrollRestoration: preventScrollRestoration,
        noBodyStyles: noBodyStyles
    });
    function getScale() {
        return (window.innerWidth - $fbffbe73b87b07ce$var$WINDOW_TOP_OFFSET) / window.innerWidth;
    }
    function onPress(event) {
        var _drawerRef_current, _drawerRef_current1;
        if (!dismissible && !snapPoints) return;
        if (drawerRef.current && !drawerRef.current.contains(event.target)) return;
        drawerHeightRef.current = ((_drawerRef_current = drawerRef.current) == null ? void 0 : _drawerRef_current.getBoundingClientRect().height) || 0;
        drawerWidthRef.current = ((_drawerRef_current1 = drawerRef.current) == null ? void 0 : _drawerRef_current1.getBoundingClientRect().width) || 0;
        setIsDragging(true);
        dragStartTime.current = new Date();
        // iOS doesn't trigger mouseUp after scrolling so we need to listen to touched in order to disallow dragging
        if ($fbffbe73b87b07ce$var$isIOS()) window.addEventListener('touchend', ()=>isAllowedToDrag.current = false, {
            once: true
        });
        // Ensure we maintain correct pointer capture even when going outside of the drawer
        event.target.setPointerCapture(event.pointerId);
        pointerStart.current = $fbffbe73b87b07ce$var$isVertical(direction) ? event.pageY : event.pageX;
    }
    function shouldDrag(el, isDraggingInDirection) {
        var _window_getSelection;
        let element = el;
        const highlightedText = (_window_getSelection = window.getSelection()) == null ? void 0 : _window_getSelection.toString();
        const swipeAmount = drawerRef.current ? $fbffbe73b87b07ce$var$getTranslate(drawerRef.current, direction) : null;
        const date = new Date();
        // Fixes https://github.com/emilkowalski/vaul/issues/483
        if (element.tagName === 'SELECT') return false;
        if (element.hasAttribute('data-vaul-no-drag') || element.closest('[data-vaul-no-drag]')) return false;
        if (direction === 'right' || direction === 'left') return true;
        // Allow scrolling when animating
        if (openTime.current && date.getTime() - openTime.current.getTime() < 500) return false;
        if (swipeAmount !== null) {
            if (direction === 'bottom' ? swipeAmount > 0 : swipeAmount < 0) return true;
        }
        // Don't drag if there's highlighted text
        if (highlightedText && highlightedText.length > 0) return false;
        // Disallow dragging if drawer was scrolled within `scrollLockTimeout`
        if (lastTimeDragPrevented.current && date.getTime() - lastTimeDragPrevented.current.getTime() < scrollLockTimeout && swipeAmount === 0) {
            lastTimeDragPrevented.current = date;
            return false;
        }
        if (isDraggingInDirection) {
            lastTimeDragPrevented.current = date;
            // We are dragging down so we should allow scrolling
            return false;
        }
        // Keep climbing up the DOM tree as long as there's a parent
        while(element){
            // Check if the element is scrollable
            if (element.scrollHeight > element.clientHeight) {
                if (element.scrollTop !== 0) {
                    lastTimeDragPrevented.current = new Date();
                    // The element is scrollable and not scrolled to the top, so don't drag
                    return false;
                }
                if (element.getAttribute('role') === 'dialog') return true;
            }
            // Move up to the parent element
            element = element.parentNode;
        }
        // No scrollable parents not scrolled to the top found, so drag
        return true;
    }
    function onDrag(event) {
        if (!drawerRef.current) return;
        // We need to know how much of the drawer has been dragged in percentages so that we can transform background accordingly
        if (isDragging) {
            const directionMultiplier = direction === 'bottom' || direction === 'right' ? 1 : -1;
            const draggedDistance = (pointerStart.current - ($fbffbe73b87b07ce$var$isVertical(direction) ? event.pageY : event.pageX)) * directionMultiplier;
            const isDraggingInDirection = draggedDistance > 0;
            // Pre condition for disallowing dragging in the close direction.
            const noCloseSnapPointsPreCondition = snapPoints && !dismissible && !isDraggingInDirection;
            // Disallow dragging down to close when first snap point is the active one and dismissible prop is set to false.
            if (noCloseSnapPointsPreCondition && activeSnapPointIndex === 0) return;
            // We need to capture last time when drag with scroll was triggered and have a timeout between
            const absDraggedDistance = Math.abs(draggedDistance);
            const wrapper = document.querySelector('[data-vaul-drawer-wrapper]');
            const drawerDimension = direction === 'bottom' || direction === 'top' ? drawerHeightRef.current : drawerWidthRef.current;
            // Calculate the percentage dragged, where 1 is the closed position
            let percentageDragged = absDraggedDistance / drawerDimension;
            const snapPointPercentageDragged = getSnapPointsPercentageDragged(absDraggedDistance, isDraggingInDirection);
            if (snapPointPercentageDragged !== null) percentageDragged = snapPointPercentageDragged;
            // Disallow close dragging beyond the smallest snap point.
            if (noCloseSnapPointsPreCondition && percentageDragged >= 1) return;
            if (!isAllowedToDrag.current && !shouldDrag(event.target, isDraggingInDirection)) return;
            drawerRef.current.classList.add($fbffbe73b87b07ce$var$DRAG_CLASS);
            // If shouldDrag gave true once after pressing down on the drawer, we set isAllowedToDrag to true and it will remain true until we let go, there's no reason to disable dragging mid way, ever, and that's the solution to it
            isAllowedToDrag.current = true;
            $fbffbe73b87b07ce$var$set(drawerRef.current, {
                transition: 'none'
            });
            $fbffbe73b87b07ce$var$set(overlayRef.current, {
                transition: 'none'
            });
            if (snapPoints) onDragSnapPoints({
                draggedDistance: draggedDistance
            });
            // Run this only if snapPoints are not defined or if we are at the last snap point (highest one)
            if (isDraggingInDirection && !snapPoints) {
                const dampenedDraggedDistance = $fbffbe73b87b07ce$var$dampenValue(draggedDistance);
                const translateValue = Math.min(dampenedDraggedDistance * -1, 0) * directionMultiplier;
                $fbffbe73b87b07ce$var$set(drawerRef.current, {
                    transform: $fbffbe73b87b07ce$var$isVertical(direction) ? `translate3d(0, ${translateValue}px, 0)` : `translate3d(${translateValue}px, 0, 0)`
                });
                return;
            }
            const opacityValue = 1 - percentageDragged;
            if (shouldFade || fadeFromIndex && activeSnapPointIndex === fadeFromIndex - 1) {
                onDragProp == null || onDragProp(event, percentageDragged);
                $fbffbe73b87b07ce$var$set(overlayRef.current, {
                    opacity: `${opacityValue}`,
                    transition: 'none'
                }, true);
            }
            if (wrapper && overlayRef.current && shouldScaleBackground) {
                // Calculate percentageDragged as a fraction (0 to 1)
                const scaleValue = Math.min(getScale() + percentageDragged * (1 - getScale()), 1);
                const borderRadiusValue = 8 - percentageDragged * 8;
                const translateValue = Math.max(0, 14 - percentageDragged * 14);
                $fbffbe73b87b07ce$var$set(wrapper, {
                    borderRadius: `${borderRadiusValue}px`,
                    transform: $fbffbe73b87b07ce$var$isVertical(direction) ? `scale(${scaleValue}) translate3d(0, ${translateValue}px, 0)` : `scale(${scaleValue}) translate3d(${translateValue}px, 0, 0)`,
                    transition: 'none'
                }, true);
            }
            if (!snapPoints) {
                const translateValue = absDraggedDistance * directionMultiplier;
                $fbffbe73b87b07ce$var$set(drawerRef.current, {
                    transform: $fbffbe73b87b07ce$var$isVertical(direction) ? `translate3d(0, ${translateValue}px, 0)` : `translate3d(${translateValue}px, 0, 0)`
                });
            }
        }
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useEffect(()=>{
        window.requestAnimationFrame(()=>{
            shouldAnimate.current = true;
        });
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useEffect(()=>{
        var _window_visualViewport;
        function onVisualViewportChange() {
            if (!drawerRef.current || !repositionInputs) return;
            const focusedElement = document.activeElement;
            if ($fbffbe73b87b07ce$var$isInput(focusedElement) || keyboardIsOpen.current) {
                var _window_visualViewport;
                const visualViewportHeight = ((_window_visualViewport = window.visualViewport) == null ? void 0 : _window_visualViewport.height) || 0;
                const totalHeight = window.innerHeight;
                // This is the height of the keyboard
                let diffFromInitial = totalHeight - visualViewportHeight;
                const drawerHeight = drawerRef.current.getBoundingClientRect().height || 0;
                // Adjust drawer height only if it's tall enough
                const isTallEnough = drawerHeight > totalHeight * 0.8;
                if (!initialDrawerHeight.current) initialDrawerHeight.current = drawerHeight;
                const offsetFromTop = drawerRef.current.getBoundingClientRect().top;
                // visualViewport height may change due to somq e subtle changes to the keyboard. Checking if the height changed by 60 or more will make sure that they keyboard really changed its open state.
                if (Math.abs(previousDiffFromInitial.current - diffFromInitial) > 60) keyboardIsOpen.current = !keyboardIsOpen.current;
                if (snapPoints && snapPoints.length > 0 && snapPointsOffset && activeSnapPointIndex) {
                    const activeSnapPointHeight = snapPointsOffset[activeSnapPointIndex] || 0;
                    diffFromInitial += activeSnapPointHeight;
                }
                previousDiffFromInitial.current = diffFromInitial;
                // We don't have to change the height if the input is in view, when we are here we are in the opened keyboard state so we can correctly check if the input is in view
                if (drawerHeight > visualViewportHeight || keyboardIsOpen.current) {
                    const height = drawerRef.current.getBoundingClientRect().height;
                    let newDrawerHeight = height;
                    if (height > visualViewportHeight) newDrawerHeight = visualViewportHeight - (isTallEnough ? offsetFromTop : $fbffbe73b87b07ce$var$WINDOW_TOP_OFFSET);
                    // When fixed, don't move the drawer upwards if there's space, but rather only change it's height so it's fully scrollable when the keyboard is open
                    if (fixed) drawerRef.current.style.height = `${height - Math.max(diffFromInitial, 0)}px`;
                    else drawerRef.current.style.height = `${Math.max(newDrawerHeight, visualViewportHeight - offsetFromTop)}px`;
                } else if (!$fbffbe73b87b07ce$var$isMobileFirefox()) drawerRef.current.style.height = `${initialDrawerHeight.current}px`;
                if (snapPoints && snapPoints.length > 0 && !keyboardIsOpen.current) drawerRef.current.style.bottom = `0px`;
                else // Negative bottom value would never make sense
                drawerRef.current.style.bottom = `${Math.max(diffFromInitial, 0)}px`;
            }
        }
        (_window_visualViewport = window.visualViewport) == null || _window_visualViewport.addEventListener('resize', onVisualViewportChange);
        return ()=>{
            var _window_visualViewport;
            return (_window_visualViewport = window.visualViewport) == null ? void 0 : _window_visualViewport.removeEventListener('resize', onVisualViewportChange);
        };
    }, [
        activeSnapPointIndex,
        snapPoints,
        snapPointsOffset
    ]);
    function closeDrawer(fromWithin) {
        cancelDrag();
        onClose == null || onClose();
        if (!fromWithin) setIsOpen(false);
        setTimeout(()=>{
            if (snapPoints) setActiveSnapPoint(snapPoints[0]);
        }, $fbffbe73b87b07ce$var$TRANSITIONS.DURATION * 1000); // seconds to ms
    }
    function resetDrawer() {
        if (!drawerRef.current) return;
        const wrapper = document.querySelector('[data-vaul-drawer-wrapper]');
        const currentSwipeAmount = $fbffbe73b87b07ce$var$getTranslate(drawerRef.current, direction);
        $fbffbe73b87b07ce$var$set(drawerRef.current, {
            transform: 'translate3d(0, 0, 0)',
            transition: `transform ${$fbffbe73b87b07ce$var$TRANSITIONS.DURATION}s cubic-bezier(${$fbffbe73b87b07ce$var$TRANSITIONS.EASE.join(',')})`
        });
        $fbffbe73b87b07ce$var$set(overlayRef.current, {
            transition: `opacity ${$fbffbe73b87b07ce$var$TRANSITIONS.DURATION}s cubic-bezier(${$fbffbe73b87b07ce$var$TRANSITIONS.EASE.join(',')})`,
            opacity: '1'
        });
        // Don't reset background if swiped upwards
        if (shouldScaleBackground && currentSwipeAmount && currentSwipeAmount > 0 && isOpen) $fbffbe73b87b07ce$var$set(wrapper, {
            borderRadius: `${$fbffbe73b87b07ce$var$BORDER_RADIUS}px`,
            overflow: 'hidden',
            ...$fbffbe73b87b07ce$var$isVertical(direction) ? {
                transform: `scale(${getScale()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`,
                transformOrigin: 'top'
            } : {
                transform: `scale(${getScale()}) translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)`,
                transformOrigin: 'left'
            },
            transitionProperty: 'transform, border-radius',
            transitionDuration: `${$fbffbe73b87b07ce$var$TRANSITIONS.DURATION}s`,
            transitionTimingFunction: `cubic-bezier(${$fbffbe73b87b07ce$var$TRANSITIONS.EASE.join(',')})`
        }, true);
    }
    function cancelDrag() {
        if (!isDragging || !drawerRef.current) return;
        drawerRef.current.classList.remove($fbffbe73b87b07ce$var$DRAG_CLASS);
        isAllowedToDrag.current = false;
        setIsDragging(false);
        dragEndTime.current = new Date();
    }
    function onRelease(event) {
        if (!isDragging || !drawerRef.current) return;
        drawerRef.current.classList.remove($fbffbe73b87b07ce$var$DRAG_CLASS);
        isAllowedToDrag.current = false;
        setIsDragging(false);
        dragEndTime.current = new Date();
        const swipeAmount = $fbffbe73b87b07ce$var$getTranslate(drawerRef.current, direction);
        if (!event || !shouldDrag(event.target, false) || !swipeAmount || Number.isNaN(swipeAmount)) return;
        if (dragStartTime.current === null) return;
        const timeTaken = dragEndTime.current.getTime() - dragStartTime.current.getTime();
        const distMoved = pointerStart.current - ($fbffbe73b87b07ce$var$isVertical(direction) ? event.pageY : event.pageX);
        const velocity = Math.abs(distMoved) / timeTaken;
        if (velocity > 0.05) {
            // `justReleased` is needed to prevent the drawer from focusing on an input when the drag ends, as it's not the intent most of the time.
            setJustReleased(true);
            setTimeout(()=>{
                setJustReleased(false);
            }, 200);
        }
        if (snapPoints) {
            const directionMultiplier = direction === 'bottom' || direction === 'right' ? 1 : -1;
            onReleaseSnapPoints({
                draggedDistance: distMoved * directionMultiplier,
                closeDrawer: closeDrawer,
                velocity: velocity,
                dismissible: dismissible
            });
            onReleaseProp == null || onReleaseProp(event, true);
            return;
        }
        // Moved upwards, don't do anything
        if (direction === 'bottom' || direction === 'right' ? distMoved > 0 : distMoved < 0) {
            resetDrawer();
            onReleaseProp == null || onReleaseProp(event, true);
            return;
        }
        if (velocity > $fbffbe73b87b07ce$var$VELOCITY_THRESHOLD) {
            closeDrawer();
            onReleaseProp == null || onReleaseProp(event, false);
            return;
        }
        var _drawerRef_current_getBoundingClientRect_height;
        const visibleDrawerHeight = Math.min((_drawerRef_current_getBoundingClientRect_height = drawerRef.current.getBoundingClientRect().height) != null ? _drawerRef_current_getBoundingClientRect_height : 0, window.innerHeight);
        var _drawerRef_current_getBoundingClientRect_width;
        const visibleDrawerWidth = Math.min((_drawerRef_current_getBoundingClientRect_width = drawerRef.current.getBoundingClientRect().width) != null ? _drawerRef_current_getBoundingClientRect_width : 0, window.innerWidth);
        const isHorizontalSwipe = direction === 'left' || direction === 'right';
        if (Math.abs(swipeAmount) >= (isHorizontalSwipe ? visibleDrawerWidth : visibleDrawerHeight) * closeThreshold) {
            closeDrawer();
            onReleaseProp == null || onReleaseProp(event, false);
            return;
        }
        onReleaseProp == null || onReleaseProp(event, true);
        resetDrawer();
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useEffect(()=>{
        // Trigger enter animation without using CSS animation
        if (isOpen) {
            $fbffbe73b87b07ce$var$set(document.documentElement, {
                scrollBehavior: 'auto'
            });
            openTime.current = new Date();
        }
        return ()=>{
            $fbffbe73b87b07ce$var$reset(document.documentElement, 'scrollBehavior');
        };
    }, [
        isOpen
    ]);
    function onNestedOpenChange(o) {
        const scale = o ? (window.innerWidth - $fbffbe73b87b07ce$var$NESTED_DISPLACEMENT) / window.innerWidth : 1;
        const initialTranslate = o ? -$fbffbe73b87b07ce$var$NESTED_DISPLACEMENT : 0;
        if (nestedOpenChangeTimer.current) window.clearTimeout(nestedOpenChangeTimer.current);
        $fbffbe73b87b07ce$var$set(drawerRef.current, {
            transition: `transform ${$fbffbe73b87b07ce$var$TRANSITIONS.DURATION}s cubic-bezier(${$fbffbe73b87b07ce$var$TRANSITIONS.EASE.join(',')})`,
            transform: $fbffbe73b87b07ce$var$isVertical(direction) ? `scale(${scale}) translate3d(0, ${initialTranslate}px, 0)` : `scale(${scale}) translate3d(${initialTranslate}px, 0, 0)`
        });
        if (!o && drawerRef.current) nestedOpenChangeTimer.current = setTimeout(()=>{
            const translateValue = $fbffbe73b87b07ce$var$getTranslate(drawerRef.current, direction);
            $fbffbe73b87b07ce$var$set(drawerRef.current, {
                transition: 'none',
                transform: $fbffbe73b87b07ce$var$isVertical(direction) ? `translate3d(0, ${translateValue}px, 0)` : `translate3d(${translateValue}px, 0, 0)`
            });
        }, 500);
    }
    function onNestedDrag(_event, percentageDragged) {
        if (percentageDragged < 0) return;
        const initialScale = (window.innerWidth - $fbffbe73b87b07ce$var$NESTED_DISPLACEMENT) / window.innerWidth;
        const newScale = initialScale + percentageDragged * (1 - initialScale);
        const newTranslate = -$fbffbe73b87b07ce$var$NESTED_DISPLACEMENT + percentageDragged * $fbffbe73b87b07ce$var$NESTED_DISPLACEMENT;
        $fbffbe73b87b07ce$var$set(drawerRef.current, {
            transform: $fbffbe73b87b07ce$var$isVertical(direction) ? `scale(${newScale}) translate3d(0, ${newTranslate}px, 0)` : `scale(${newScale}) translate3d(${newTranslate}px, 0, 0)`,
            transition: 'none'
        });
    }
    function onNestedRelease(_event, o) {
        const dim = $fbffbe73b87b07ce$var$isVertical(direction) ? window.innerHeight : window.innerWidth;
        const scale = o ? (dim - $fbffbe73b87b07ce$var$NESTED_DISPLACEMENT) / dim : 1;
        const translate = o ? -$fbffbe73b87b07ce$var$NESTED_DISPLACEMENT : 0;
        if (o) $fbffbe73b87b07ce$var$set(drawerRef.current, {
            transition: `transform ${$fbffbe73b87b07ce$var$TRANSITIONS.DURATION}s cubic-bezier(${$fbffbe73b87b07ce$var$TRANSITIONS.EASE.join(',')})`,
            transform: $fbffbe73b87b07ce$var$isVertical(direction) ? `scale(${scale}) translate3d(0, ${translate}px, 0)` : `scale(${scale}) translate3d(${translate}px, 0, 0)`
        });
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useEffect(()=>{
        if (!modal) // Need to do this manually unfortunately
        window.requestAnimationFrame(()=>{
            document.body.style.pointerEvents = 'auto';
        });
    }, [
        modal
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).createElement($52782a2f2cff5382$export$3ddf2d174ce01153, {
        defaultOpen: defaultOpen,
        onOpenChange: (open)=>{
            if (!dismissible && !open) return;
            if (open) setHasBeenOpened(true);
            else closeDrawer(true);
            setIsOpen(open);
        },
        open: isOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).createElement($fbffbe73b87b07ce$var$DrawerContext.Provider, {
        value: {
            activeSnapPoint: activeSnapPoint,
            snapPoints: snapPoints,
            setActiveSnapPoint: setActiveSnapPoint,
            drawerRef: drawerRef,
            overlayRef: overlayRef,
            onOpenChange: onOpenChange,
            onPress: onPress,
            onRelease: onRelease,
            onDrag: onDrag,
            dismissible: dismissible,
            shouldAnimate: shouldAnimate,
            handleOnly: handleOnly,
            isOpen: isOpen,
            isDragging: isDragging,
            shouldFade: shouldFade,
            closeDrawer: closeDrawer,
            onNestedDrag: onNestedDrag,
            onNestedOpenChange: onNestedOpenChange,
            onNestedRelease: onNestedRelease,
            keyboardIsOpen: keyboardIsOpen,
            modal: modal,
            snapPointsOffset: snapPointsOffset,
            activeSnapPointIndex: activeSnapPointIndex,
            direction: direction,
            shouldScaleBackground: shouldScaleBackground,
            setBackgroundColorOnScale: setBackgroundColorOnScale,
            noBodyStyles: noBodyStyles,
            container: container,
            autoFocus: autoFocus
        }
    }, children));
}
const $fbffbe73b87b07ce$export$c6fdb837b070b4ff = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).forwardRef(function({ ...rest }, ref) {
    const { overlayRef: overlayRef, snapPoints: snapPoints, onRelease: onRelease, shouldFade: shouldFade, isOpen: isOpen, modal: modal, shouldAnimate: shouldAnimate } = $fbffbe73b87b07ce$var$useDrawerContext();
    const composedRef = $fbffbe73b87b07ce$var$useComposedRefs(ref, overlayRef);
    const hasSnapPoints = snapPoints && snapPoints.length > 0;
    // Overlay is the component that is locking scroll, removing it will unlock the scroll without having to dig into Radix's Dialog library
    if (!modal) return null;
    const onMouseUp = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useCallback((event)=>onRelease(event), [
        onRelease
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).createElement($52782a2f2cff5382$export$bd1d06c79be19e17, {
        onMouseUp: onMouseUp,
        ref: composedRef,
        "data-vaul-overlay": "",
        "data-vaul-snap-points": isOpen && hasSnapPoints ? 'true' : 'false',
        "data-vaul-snap-points-overlay": isOpen && shouldFade ? 'true' : 'false',
        "data-vaul-animate": (shouldAnimate == null ? void 0 : shouldAnimate.current) ? 'true' : 'false',
        ...rest
    });
});
$fbffbe73b87b07ce$export$c6fdb837b070b4ff.displayName = 'Drawer.Overlay';
const $fbffbe73b87b07ce$export$7c6e2c02157bb7d2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).forwardRef(function({ onPointerDownOutside: onPointerDownOutside, style: style, onOpenAutoFocus: onOpenAutoFocus, ...rest }, ref) {
    const { drawerRef: drawerRef, onPress: onPress, onRelease: onRelease, onDrag: onDrag, keyboardIsOpen: keyboardIsOpen, snapPointsOffset: snapPointsOffset, activeSnapPointIndex: activeSnapPointIndex, modal: modal, isOpen: isOpen, direction: direction, snapPoints: snapPoints, container: container, handleOnly: handleOnly, shouldAnimate: shouldAnimate, autoFocus: autoFocus } = $fbffbe73b87b07ce$var$useDrawerContext();
    // Needed to use transition instead of animations
    const [delayedSnapPoints, setDelayedSnapPoints] = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useState(false);
    const composedRef = $fbffbe73b87b07ce$var$useComposedRefs(ref, drawerRef);
    const pointerStartRef = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useRef(null);
    const lastKnownPointerEventRef = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useRef(null);
    const wasBeyondThePointRef = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useRef(false);
    const hasSnapPoints = snapPoints && snapPoints.length > 0;
    $fbffbe73b87b07ce$var$useScaleBackground();
    const isDeltaInDirection = (delta, direction, threshold = 0)=>{
        if (wasBeyondThePointRef.current) return true;
        const deltaY = Math.abs(delta.y);
        const deltaX = Math.abs(delta.x);
        const isDeltaX = deltaX > deltaY;
        const dFactor = [
            'bottom',
            'right'
        ].includes(direction) ? 1 : -1;
        if (direction === 'left' || direction === 'right') {
            const isReverseDirection = delta.x * dFactor < 0;
            if (!isReverseDirection && deltaX >= 0 && deltaX <= threshold) return isDeltaX;
        } else {
            const isReverseDirection = delta.y * dFactor < 0;
            if (!isReverseDirection && deltaY >= 0 && deltaY <= threshold) return !isDeltaX;
        }
        wasBeyondThePointRef.current = true;
        return true;
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useEffect(()=>{
        if (hasSnapPoints) window.requestAnimationFrame(()=>{
            setDelayedSnapPoints(true);
        });
    }, []);
    function handleOnPointerUp(event) {
        pointerStartRef.current = null;
        wasBeyondThePointRef.current = false;
        onRelease(event);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).createElement($52782a2f2cff5382$export$7c6e2c02157bb7d2, {
        "data-vaul-drawer-direction": direction,
        "data-vaul-drawer": "",
        "data-vaul-delayed-snap-points": delayedSnapPoints ? 'true' : 'false',
        "data-vaul-snap-points": isOpen && hasSnapPoints ? 'true' : 'false',
        "data-vaul-custom-container": container ? 'true' : 'false',
        "data-vaul-animate": (shouldAnimate == null ? void 0 : shouldAnimate.current) ? 'true' : 'false',
        ...rest,
        ref: composedRef,
        style: snapPointsOffset && snapPointsOffset.length > 0 ? {
            '--snap-point-height': `${snapPointsOffset[activeSnapPointIndex != null ? activeSnapPointIndex : 0]}px`,
            ...style
        } : style,
        onPointerDown: (event)=>{
            if (handleOnly) return;
            rest.onPointerDown == null || rest.onPointerDown.call(rest, event);
            pointerStartRef.current = {
                x: event.pageX,
                y: event.pageY
            };
            onPress(event);
        },
        onOpenAutoFocus: (e)=>{
            onOpenAutoFocus == null || onOpenAutoFocus(e);
            if (!autoFocus) e.preventDefault();
        },
        onPointerDownOutside: (e)=>{
            onPointerDownOutside == null || onPointerDownOutside(e);
            if (!modal || e.defaultPrevented) {
                e.preventDefault();
                return;
            }
            if (keyboardIsOpen.current) keyboardIsOpen.current = false;
        },
        onFocusOutside: (e)=>{
            if (!modal) {
                e.preventDefault();
                return;
            }
        },
        onPointerMove: (event)=>{
            lastKnownPointerEventRef.current = event;
            if (handleOnly) return;
            rest.onPointerMove == null || rest.onPointerMove.call(rest, event);
            if (!pointerStartRef.current) return;
            const yPosition = event.pageY - pointerStartRef.current.y;
            const xPosition = event.pageX - pointerStartRef.current.x;
            const swipeStartThreshold = event.pointerType === 'touch' ? 10 : 2;
            const delta = {
                x: xPosition,
                y: yPosition
            };
            const isAllowedToSwipe = isDeltaInDirection(delta, direction, swipeStartThreshold);
            if (isAllowedToSwipe) onDrag(event);
            else if (Math.abs(xPosition) > swipeStartThreshold || Math.abs(yPosition) > swipeStartThreshold) pointerStartRef.current = null;
        },
        onPointerUp: (event)=>{
            rest.onPointerUp == null || rest.onPointerUp.call(rest, event);
            pointerStartRef.current = null;
            wasBeyondThePointRef.current = false;
            onRelease(event);
        },
        onPointerOut: (event)=>{
            rest.onPointerOut == null || rest.onPointerOut.call(rest, event);
            handleOnPointerUp(lastKnownPointerEventRef.current);
        },
        onContextMenu: (event)=>{
            rest.onContextMenu == null || rest.onContextMenu.call(rest, event);
            if (lastKnownPointerEventRef.current) handleOnPointerUp(lastKnownPointerEventRef.current);
        }
    });
});
$fbffbe73b87b07ce$export$7c6e2c02157bb7d2.displayName = 'Drawer.Content';
const $fbffbe73b87b07ce$var$LONG_HANDLE_PRESS_TIMEOUT = 250;
const $fbffbe73b87b07ce$var$DOUBLE_TAP_TIMEOUT = 120;
const $fbffbe73b87b07ce$export$94890c79f4cae6d6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).forwardRef(function({ preventCycle: preventCycle = false, children: children, ...rest }, ref) {
    const { closeDrawer: closeDrawer, isDragging: isDragging, snapPoints: snapPoints, activeSnapPoint: activeSnapPoint, setActiveSnapPoint: setActiveSnapPoint, dismissible: dismissible, handleOnly: handleOnly, isOpen: isOpen, onPress: onPress, onDrag: onDrag } = $fbffbe73b87b07ce$var$useDrawerContext();
    const closeTimeoutIdRef = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useRef(null);
    const shouldCancelInteractionRef = (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).useRef(false);
    function handleStartCycle() {
        // Stop if this is the second click of a double click
        if (shouldCancelInteractionRef.current) {
            handleCancelInteraction();
            return;
        }
        window.setTimeout(()=>{
            handleCycleSnapPoints();
        }, $fbffbe73b87b07ce$var$DOUBLE_TAP_TIMEOUT);
    }
    function handleCycleSnapPoints() {
        // Prevent accidental taps while resizing drawer
        if (isDragging || preventCycle || shouldCancelInteractionRef.current) {
            handleCancelInteraction();
            return;
        }
        // Make sure to clear the timeout id if the user releases the handle before the cancel timeout
        handleCancelInteraction();
        if (!snapPoints || snapPoints.length === 0) {
            if (!dismissible) closeDrawer();
            return;
        }
        const isLastSnapPoint = activeSnapPoint === snapPoints[snapPoints.length - 1];
        if (isLastSnapPoint && dismissible) {
            closeDrawer();
            return;
        }
        const currentSnapIndex = snapPoints.findIndex((point)=>point === activeSnapPoint);
        if (currentSnapIndex === -1) return; // activeSnapPoint not found in snapPoints
        const nextSnapPoint = snapPoints[currentSnapIndex + 1];
        setActiveSnapPoint(nextSnapPoint);
    }
    function handleStartInteraction() {
        closeTimeoutIdRef.current = window.setTimeout(()=>{
            // Cancel click interaction on a long press
            shouldCancelInteractionRef.current = true;
        }, $fbffbe73b87b07ce$var$LONG_HANDLE_PRESS_TIMEOUT);
    }
    function handleCancelInteraction() {
        if (closeTimeoutIdRef.current) window.clearTimeout(closeTimeoutIdRef.current);
        shouldCancelInteractionRef.current = false;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).createElement("div", {
        onClick: handleStartCycle,
        onPointerCancel: handleCancelInteraction,
        onPointerDown: (e)=>{
            if (handleOnly) onPress(e);
            handleStartInteraction();
        },
        onPointerMove: (e)=>{
            if (handleOnly) onDrag(e);
        },
        // onPointerUp is already handled by the content component
        ref: ref,
        "data-vaul-drawer-visible": isOpen ? 'true' : 'false',
        "data-vaul-handle": "",
        "aria-hidden": "true",
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).createElement("span", {
        "data-vaul-handle-hitarea": "",
        "aria-hidden": "true"
    }, children));
});
$fbffbe73b87b07ce$export$94890c79f4cae6d6.displayName = 'Drawer.Handle';
function $fbffbe73b87b07ce$export$a70aab124b3d51be({ onDrag: onDrag, onOpenChange: onOpenChange, open: nestedIsOpen, ...rest }) {
    const { onNestedDrag: onNestedDrag, onNestedOpenChange: onNestedOpenChange, onNestedRelease: onNestedRelease } = $fbffbe73b87b07ce$var$useDrawerContext();
    if (!onNestedDrag) throw new Error('Drawer.NestedRoot must be placed in another drawer');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).createElement($fbffbe73b87b07ce$export$be92b6f5f03c0fe9, {
        nested: true,
        open: nestedIsOpen,
        onClose: ()=>{
            onNestedOpenChange(false);
        },
        onDrag: (e, p)=>{
            onNestedDrag(e, p);
            onDrag == null || onDrag(e, p);
        },
        onOpenChange: (o)=>{
            if (o) onNestedOpenChange(o);
            onOpenChange == null || onOpenChange(o);
        },
        onRelease: onNestedRelease,
        ...rest
    });
}
function $fbffbe73b87b07ce$export$602eac185826482c(props) {
    const context = $fbffbe73b87b07ce$var$useDrawerContext();
    const { container: container = context.container, ...portalProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).createElement($52782a2f2cff5382$export$dad7c95542bacce0, {
        container: container,
        ...portalProps
    });
}
const $fbffbe73b87b07ce$export$4071300121a182f5 = {
    Root: $fbffbe73b87b07ce$export$be92b6f5f03c0fe9,
    NestedRoot: $fbffbe73b87b07ce$export$a70aab124b3d51be,
    Content: $fbffbe73b87b07ce$export$7c6e2c02157bb7d2,
    Overlay: $fbffbe73b87b07ce$export$c6fdb837b070b4ff,
    Trigger: $52782a2f2cff5382$export$2e1e1122cf0cba88,
    Portal: $fbffbe73b87b07ce$export$602eac185826482c,
    Handle: $fbffbe73b87b07ce$export$94890c79f4cae6d6,
    Close: $52782a2f2cff5382$export$f39c2d165cd861fe,
    Title: $52782a2f2cff5382$export$16f7638e4a34b909,
    Description: $52782a2f2cff5382$export$393edc798c47379d
};


"use client";
//#region src/components/Drawer/index.jsx
var $667a2883fca669f9$export$2e2bcd8739ae039 = ({ children: n, direction: r = "right", ...i })=>/* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $fbffbe73b87b07ce$export$4071300121a182f5).Root, {
        direction: r,
        ...i,
        children: n
    });
$667a2883fca669f9$export$2e2bcd8739ae039.displayName = "Drawer";





//#region src/components/Drawer/Footer/index.jsx
var $399e6d5328a56350$export$2e2bcd8739ae039 = ({ className: n, children: r, ...i })=>{
    let a = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-DrawerFooter absolute bottom-0 left-0 flex w-full gap-x-2 border-t border-t-neutral-200 bg-white px-6 py-4": !0,
        [n]: !!n
    });
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
        className: a,
        ...i,
        children: r
    });
};
$399e6d5328a56350$export$2e2bcd8739ae039.displayName = "DrawerFooter";



var $lCzvA = parcelRequire("lCzvA");


//#region src/components/Drawer/Content/index.jsx
var $41db6ce8ffe5ef63$export$2e2bcd8739ae039 = ({ className: s, children: c, backdrop: l = !0, backdropClass: u, titleClass: d, titleText: f = "", contentClass: p, showHandle: m = !1, handleClass: h, showClose: g = !0, closeClass: _, ...v })=>{
    let y = (0, $lCzvA.Children).toArray(c).some((e)=>e?.type === (0, $399e6d5328a56350$export$2e2bcd8739ae039)), b = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-Drawer z-21 bg-white fixed outline-none flex flex-col": !0,
        "pb-20": y,
        [s]: s
    }), x = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-DrawerBackdrop z-20 bg-black/40 fixed inset-0": !0,
        [u]: u
    }), S = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-DrawerHeader flex-initial items-center gap-x-2 px-2.5 pb-2 pt-3 md:py-2.5": !0,
        hidden: !g && !f,
        flex: g || f,
        [d]: d
    }), C = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-DrawerContent flex-1 overflow-y-auto px-6 pb-6 md:pt-6 select-text": !0,
        [p]: p
    }), w = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-DrawerHandle absolute bg-neutral-200 flex-none rounded-full": !0,
        [h]: h
    }), T = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "size-6 flex-initial leading-none cursor-pointer": !0,
        [_]: _
    });
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $fbffbe73b87b07ce$export$4071300121a182f5).Portal, {
        children: [
            l && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $fbffbe73b87b07ce$export$4071300121a182f5).Overlay, {
                className: x
            }),
            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $fbffbe73b87b07ce$export$4071300121a182f5).Content, {
                className: b,
                "aria-describedby": void 0,
                ...v,
                children: [
                    m && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                        "aria-hidden": "true",
                        className: w,
                        "data-testid": "sash-drawer-handle"
                    }),
                    /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                        className: S,
                        "data-testid": "sash-drawer-header",
                        children: [
                            g && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $fbffbe73b87b07ce$export$4071300121a182f5).Close, {
                                className: T,
                                children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                                    name: "close",
                                    weight: 700
                                })
                            }),
                            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $fbffbe73b87b07ce$export$4071300121a182f5).Title, {
                                className: "text-detail-bold m-0 flex-1 text-center",
                                children: f
                            })
                        ]
                    }),
                    /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                        className: C,
                        "data-testid": "drawer-content-area",
                        children: c
                    })
                ]
            })
        ]
    });
};
$41db6ce8ffe5ef63$export$2e2bcd8739ae039.displayName = "DrawerContent";





var $lCzvA = parcelRequire("lCzvA");


var $lCzvA = parcelRequire("lCzvA");




// src/use-previous.tsx

var $lCzvA = parcelRequire("lCzvA");
function $294d88907adb4ed0$export$5cae361ad82dce8b(value) {
    const ref = $lCzvA.useRef({
        value: value,
        previous: value
    });
    return $lCzvA.useMemo(()=>{
        if (ref.current.value !== value) {
            ref.current.previous = ref.current.value;
            ref.current.value = value;
        }
        return ref.current.previous;
    }, [
        value
    ]);
}





"use client";
var $57e8e5c519f33c67$var$SWITCH_NAME = "Switch";
var [$57e8e5c519f33c67$var$createSwitchContext, $57e8e5c519f33c67$export$cf7f5f17f69cbd43] = (0, $e4b0fa6903a3dc52$export$50c7b4e9d9f19c1)($57e8e5c519f33c67$var$SWITCH_NAME);
var [$57e8e5c519f33c67$var$SwitchProviderImpl, $57e8e5c519f33c67$var$useSwitchContext] = $57e8e5c519f33c67$var$createSwitchContext($57e8e5c519f33c67$var$SWITCH_NAME);
function $57e8e5c519f33c67$export$53dd0e869fa29944(props) {
    const { __scopeSwitch: __scopeSwitch, checked: checkedProp, children: children, defaultChecked: defaultChecked, disabled: disabled, form: form, name: name, onCheckedChange: onCheckedChange, required: required, value: value = "on", internal_do_not_use_render: // @ts-expect-error
    internal_do_not_use_render } = props;
    const [checked, setChecked] = (0, $10b1f3c1fb191872$export$6f32135080cb4c3)({
        prop: checkedProp,
        defaultProp: defaultChecked ?? false,
        onChange: onCheckedChange,
        caller: $57e8e5c519f33c67$var$SWITCH_NAME
    });
    const [control, setControl] = $lCzvA.useState(null);
    const [bubbleInput, setBubbleInput] = $lCzvA.useState(null);
    const hasConsumerStoppedPropagationRef = $lCzvA.useRef(false);
    const isFormControl = control ? !!form || !!control.closest("form") : // We set this to true by default so that events bubble to forms without JS (SSR)
    true;
    const context = {
        checked: checked,
        setChecked: setChecked,
        disabled: disabled,
        control: control,
        setControl: setControl,
        name: name,
        form: form,
        value: value,
        hasConsumerStoppedPropagationRef: hasConsumerStoppedPropagationRef,
        required: required,
        defaultChecked: defaultChecked,
        isFormControl: isFormControl,
        bubbleInput: bubbleInput,
        setBubbleInput: setBubbleInput
    };
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($57e8e5c519f33c67$var$SwitchProviderImpl, {
        scope: __scopeSwitch,
        ...context,
        children: $57e8e5c519f33c67$var$isFunction(internal_do_not_use_render) ? internal_do_not_use_render(context) : children
    });
}
var $57e8e5c519f33c67$var$TRIGGER_NAME = "SwitchTrigger";
var $57e8e5c519f33c67$export$83e7e208fc5318b6 = $lCzvA.forwardRef(({ __scopeSwitch: __scopeSwitch, onClick: onClick, ...switchProps }, forwardedRef)=>{
    const { control: control, form: form, value: value, disabled: disabled, checked: checked, required: required, setControl: setControl, setChecked: setChecked, hasConsumerStoppedPropagationRef: hasConsumerStoppedPropagationRef, isFormControl: isFormControl, bubbleInput: bubbleInput } = $57e8e5c519f33c67$var$useSwitchContext($57e8e5c519f33c67$var$TRIGGER_NAME, __scopeSwitch);
    const composedRefs = (0, $ca45e6a36e8d9db0$export$c7b2cbe3552a0d05)(forwardedRef, setControl);
    const initialCheckedStateRef = $lCzvA.useRef(checked);
    $lCzvA.useEffect(()=>{
        const associatedForm = form ? control?.ownerDocument.getElementById(form) : control?.form;
        if (associatedForm instanceof HTMLFormElement) {
            const reset = ()=>setChecked(initialCheckedStateRef.current);
            associatedForm.addEventListener("reset", reset);
            return ()=>associatedForm.removeEventListener("reset", reset);
        }
    }, [
        control,
        form,
        setChecked
    ]);
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $ac36d1eadbf3b928$export$250ffa63cdc0d034).button, {
        type: "button",
        role: "switch",
        "aria-checked": checked,
        "aria-required": required,
        "data-state": $57e8e5c519f33c67$var$getState(checked),
        "data-disabled": disabled ? "" : void 0,
        disabled: disabled,
        value: value,
        ...switchProps,
        ref: composedRefs,
        onClick: (0, $7c9f5a9a17eecc04$export$b9ecd428b558ff10)(onClick, (event)=>{
            setChecked((prevChecked)=>!prevChecked);
            if (bubbleInput && isFormControl) {
                hasConsumerStoppedPropagationRef.current = event.isPropagationStopped();
                if (!hasConsumerStoppedPropagationRef.current) event.stopPropagation();
            }
        })
    });
});
$57e8e5c519f33c67$export$83e7e208fc5318b6.displayName = $57e8e5c519f33c67$var$TRIGGER_NAME;
var $57e8e5c519f33c67$export$be92b6f5f03c0fe9 = $lCzvA.forwardRef((props, forwardedRef)=>{
    const { __scopeSwitch: __scopeSwitch, name: name, checked: checked, defaultChecked: defaultChecked, required: required, disabled: disabled, value: value, onCheckedChange: onCheckedChange, form: form, ...switchProps } = props;
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($57e8e5c519f33c67$export$53dd0e869fa29944, {
        __scopeSwitch: __scopeSwitch,
        checked: checked,
        defaultChecked: defaultChecked,
        disabled: disabled,
        required: required,
        onCheckedChange: onCheckedChange,
        name: name,
        form: form,
        value: value,
        internal_do_not_use_render: ({ isFormControl: isFormControl })=>/* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $1e1ba35c5b9fc4c3$exports.Fragment), {
                children: [
                    /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($57e8e5c519f33c67$export$83e7e208fc5318b6, {
                        ...switchProps,
                        ref: forwardedRef,
                        __scopeSwitch: __scopeSwitch
                    }),
                    isFormControl && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($57e8e5c519f33c67$export$493083511fc9f964, {
                        __scopeSwitch: __scopeSwitch
                    })
                ]
            })
    });
});
$57e8e5c519f33c67$export$be92b6f5f03c0fe9.displayName = $57e8e5c519f33c67$var$SWITCH_NAME;
var $57e8e5c519f33c67$var$THUMB_NAME = "SwitchThumb";
var $57e8e5c519f33c67$export$4d07bf653ea69106 = $lCzvA.forwardRef((props, forwardedRef)=>{
    const { __scopeSwitch: __scopeSwitch, ...thumbProps } = props;
    const context = $57e8e5c519f33c67$var$useSwitchContext($57e8e5c519f33c67$var$THUMB_NAME, __scopeSwitch);
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $ac36d1eadbf3b928$export$250ffa63cdc0d034).span, {
        "data-state": $57e8e5c519f33c67$var$getState(context.checked),
        "data-disabled": context.disabled ? "" : void 0,
        ...thumbProps,
        ref: forwardedRef
    });
});
$57e8e5c519f33c67$export$4d07bf653ea69106.displayName = $57e8e5c519f33c67$var$THUMB_NAME;
var $57e8e5c519f33c67$var$BUBBLE_INPUT_NAME = "SwitchBubbleInput";
var $57e8e5c519f33c67$export$493083511fc9f964 = $lCzvA.forwardRef(({ __scopeSwitch: __scopeSwitch, ...props }, forwardedRef)=>{
    const { control: control, hasConsumerStoppedPropagationRef: hasConsumerStoppedPropagationRef, checked: checked, defaultChecked: defaultChecked, required: required, disabled: disabled, name: name, value: value, form: form, bubbleInput: bubbleInput, setBubbleInput: setBubbleInput } = $57e8e5c519f33c67$var$useSwitchContext($57e8e5c519f33c67$var$BUBBLE_INPUT_NAME, __scopeSwitch);
    const composedRefs = (0, $ca45e6a36e8d9db0$export$c7b2cbe3552a0d05)(forwardedRef, setBubbleInput);
    const prevChecked = (0, $294d88907adb4ed0$export$5cae361ad82dce8b)(checked);
    const controlSize = (0, $5c8e3ebce5d09d2e$export$1ab7ae714698c4b8)(control);
    $lCzvA.useEffect(()=>{
        const input = bubbleInput;
        if (!input) return;
        const inputProto = window.HTMLInputElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(inputProto, "checked");
        const setChecked = descriptor.set;
        const bubbles = !hasConsumerStoppedPropagationRef.current;
        if (prevChecked !== checked && setChecked) {
            const event = new Event("click", {
                bubbles: bubbles
            });
            setChecked.call(input, checked);
            input.dispatchEvent(event);
        }
    }, [
        bubbleInput,
        prevChecked,
        checked,
        hasConsumerStoppedPropagationRef
    ]);
    const defaultCheckedRef = $lCzvA.useRef(checked);
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $ac36d1eadbf3b928$export$250ffa63cdc0d034).input, {
        type: "checkbox",
        "aria-hidden": true,
        defaultChecked: defaultChecked ?? defaultCheckedRef.current,
        required: required,
        disabled: disabled,
        name: name,
        value: value,
        form: form,
        ...props,
        tabIndex: -1,
        ref: composedRefs,
        style: {
            ...props.style,
            ...controlSize,
            position: "absolute",
            pointerEvents: "none",
            opacity: 0,
            margin: 0,
            // We transform because the input is absolutely positioned but we have
            // rendered it **after** the button. This pulls it back to sit on top
            // of the button.
            transform: "translateX(-100%)"
        }
    });
});
$57e8e5c519f33c67$export$493083511fc9f964.displayName = $57e8e5c519f33c67$var$BUBBLE_INPUT_NAME;
function $57e8e5c519f33c67$var$isFunction(value) {
    return typeof value === "function";
}
function $57e8e5c519f33c67$var$getState(checked) {
    return checked ? "checked" : "unchecked";
}


"use client";
//#region src/components/Switch/index.jsx
var $14c7f9d4c848135d$export$2e2bcd8739ae039 = ({ labelText: s, labelPosition: c = "left", onChange: l, className: u, disabled: d, ...f })=>{
    let p = (0, $lCzvA.useId)(), m = {
        ...f
    }, h = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "group/switch sash-Switch inline-flex items-center gap-x-3": !0,
        "flex-row-reverse": c === "right",
        [u]: u
    }), g = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "relative rounded-full w-10 h-6 border px-0.5 transition-[padding] duration-200": !0,
        "border-neutral bg-neutral data-[state=\"checked\"]:bg-black data-[state=\"checked\"]:border-black": !d,
        "bg-neutral-50 pointer-events-none": d
    }), _ = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "flex items-center justify-center leading-none size-4.5 rounded-full data-[state=\"unchecked\"]:*:invisible transition-transform data-[state=\"checked\"]:translate-x-[calc(100%-2px)]": !0,
        "bg-white text-black shadow-[1px_0_1px_rgba(0,0,0,0.15)] group-hover/switch:translate-x-0.5 group-hover/switch:data-[state=\"checked\"]:translate-x-[calc(100%-4px)]": !d,
        "bg-neutral-600 text-white": d
    });
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
        className: h,
        children: [
            s && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $fbac12b06efda731$export$2e2bcd8739ae039), {
                htmlFor: p,
                className: `font-normal ${m.required ? "text-required" : ""}`,
                children: s
            }),
            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($57e8e5c519f33c67$export$be92b6f5f03c0fe9, {
                id: p,
                onCheckedChange: l,
                className: g,
                disabled: d,
                ...f,
                children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($57e8e5c519f33c67$export$4d07bf653ea69106, {
                    className: _,
                    children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                        name: "check",
                        size: 16
                    })
                })
            })
        ]
    });
};


var $4190fa1221353870$export$e324594224ef24da;
var $4190fa1221353870$export$2ba01fb71ed41cb6;
var $4190fa1221353870$export$a7db06668cad9adb;
var $4190fa1221353870$export$4df8d4373bc60300;
var $4190fa1221353870$export$c2947f539ebf7d9e;
var $4190fa1221353870$export$471f7ae5c4103ae1;
$4190fa1221353870$export$e324594224ef24da = `I58H2q_actions`;
$4190fa1221353870$export$2ba01fb71ed41cb6 = `I58H2q_button`;
$4190fa1221353870$export$a7db06668cad9adb = `I58H2q_content`;
$4190fa1221353870$export$4df8d4373bc60300 = `I58H2q_drawer`;
$4190fa1221353870$export$c2947f539ebf7d9e = `I58H2q_drawerFooter`;
$4190fa1221353870$export$471f7ae5c4103ae1 = `I58H2q_status`;


const $3f0ece51815fa43b$export$e7814354e1c15999 = ({ open: open, close: close, title: title, isEdit: isEdit, isCopy: isCopy, active: active, onActiveChange: onActiveChange, onSubmit: onSubmit, disableSubmit: disableSubmit, children: children })=>{
    const handleTitles = ()=>{
        if (isCopy) return `Copy ${title}`;
        if (isEdit) return `Modify ${title}`;
        return `New ${title}`;
    };
    const handleButtonText = ()=>{
        if (isCopy) return `COPY ${title.toUpperCase()}`;
        if (isEdit) return `UPDATE ${title.toUpperCase()}`;
        return `CREATE ${title.toUpperCase()}`;
    };
    const lowerCaseTitle = title.toLowerCase();
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $667a2883fca669f9$export$2e2bcd8739ae039), {
        direction: (0, $ec4affac0c13709c$exports.isMobile) ? 'bottom' : 'right',
        open: open,
        onOpenChange: close,
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $41db6ce8ffe5ef63$export$2e2bcd8739ae039), {
            className: $4190fa1221353870$export$4df8d4373bc60300,
            titleText: handleTitles(),
            showClose: false,
            children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                className: $4190fa1221353870$export$a7db06668cad9adb,
                children: [
                    lowerCaseTitle !== 'selection list' && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                        className: $4190fa1221353870$export$471f7ae5c4103ae1,
                        children: [
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("b", {
                                        children: "Status"
                                    }),
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                        children: [
                                            "Enable or disable the ",
                                            lowerCaseTitle
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $14c7f9d4c848135d$export$2e2bcd8739ae039), {
                                    "data-testid": `${lowerCaseTitle}StatusSwitch`,
                                    checked: active,
                                    onChange: onActiveChange
                                })
                            })
                        ]
                    }),
                    children,
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                        className: $4190fa1221353870$export$c2947f539ebf7d9e,
                        children: [
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                                "data-testid": `cancel${title}`,
                                className: $4190fa1221353870$export$2ba01fb71ed41cb6,
                                color: "secondary",
                                onClick: close,
                                children: "CANCEL"
                            }),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                                "data-testid": `submit${title}`,
                                className: $4190fa1221353870$export$2ba01fb71ed41cb6,
                                color: "primary",
                                onClick: onSubmit,
                                disabled: disableSubmit,
                                children: handleButtonText()
                            })
                        ]
                    })
                ]
            })
        })
    });
};




var $97cddd3a85cbf2e7$export$a75c7ea49564edd7;
var $97cddd3a85cbf2e7$export$fd76f551a81abadc;
var $97cddd3a85cbf2e7$export$9c686a975407e95c;
var $97cddd3a85cbf2e7$export$34e0f9847d4c02dd;
var $97cddd3a85cbf2e7$export$fe1f090daaa782aa;
var $97cddd3a85cbf2e7$export$995e14ef61d916e6;
var $97cddd3a85cbf2e7$export$e2aec4f476da5951;
var $97cddd3a85cbf2e7$export$e6d3dbed1b4eb6ad;
var $97cddd3a85cbf2e7$export$1237798dc640739a;
var $97cddd3a85cbf2e7$export$ae91b53a46022815;
var $97cddd3a85cbf2e7$export$410fed1e7dbc89d8;
var $97cddd3a85cbf2e7$export$2ab9a8f9f1186f14;
$97cddd3a85cbf2e7$export$a75c7ea49564edd7 = `ffh7qG_actionButton`;
$97cddd3a85cbf2e7$export$fd76f551a81abadc = `ffh7qG_additionalQty`;
$97cddd3a85cbf2e7$export$9c686a975407e95c = `ffh7qG_buttonGroup`;
$97cddd3a85cbf2e7$export$34e0f9847d4c02dd = `ffh7qG_container`;
$97cddd3a85cbf2e7$export$fe1f090daaa782aa = `ffh7qG_gridItem`;
$97cddd3a85cbf2e7$export$995e14ef61d916e6 = `ffh7qG_inputGroup`;
$97cddd3a85cbf2e7$export$e2aec4f476da5951 = `ffh7qG_itemBox`;
$97cddd3a85cbf2e7$export$e6d3dbed1b4eb6ad = `ffh7qG_itemGrid`;
$97cddd3a85cbf2e7$export$1237798dc640739a = `ffh7qG_label`;
$97cddd3a85cbf2e7$export$ae91b53a46022815 = `ffh7qG_transactInput`;
$97cddd3a85cbf2e7$export$410fed1e7dbc89d8 = `ffh7qG_transactionControls`;
$97cddd3a85cbf2e7$export$2ab9a8f9f1186f14 = `ffh7qG_value`;



var $lCzvA = parcelRequire("lCzvA");
const $17e58a04366b2100$export$a15adb8b4ec3e8f7 = ({ subinventoryQtyInfo: subinventoryQtyInfo, onAddQuantity: onAddQuantity, onAddFullLot: onAddFullLot, transactionType: transactionType, orgId: orgId, disableAddQuantity: disableAddQuantity = false, disableAddFullLot: disableAddFullLot = false })=>{
    /** @type {[Record<number, string>, React.Dispatch<React.SetStateAction<Record<number, string>>>]} */ const [quantities, setQuantities] = (0, $lCzvA.useState)({});
    if (!subinventoryQtyInfo || subinventoryQtyInfo.length === 0) return null;
    /**
   * handle validation of adding quantity and calls onAddQuantity if valid
   * @param {Pella.ProductionRequestAPI.GetSubinventoryInfoByPlantOutput} item
   * @param {number} index
   */ const handleAddQuantity = (item, index)=>{
        if (!quantities[index] || Number(quantities[index]) <= 0 || Number(quantities[index]) > item.unitOfIssueQoh) {
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).error('The entered quantity is greater than the available quantity. Please adjust the quantity');
            return;
        }
        onAddQuantity(item, Number(quantities[index]), index, transactionType, orgId);
        setQuantities((q)=>({
                ...q,
                [index]: ''
            }));
    };
    /**
   * handle validation of adding full lot quantity and calls onAddFullLot if valid
   * @param {Pella.ProductionRequestAPI.GetSubinventoryInfoByPlantOutput} item
   * @param {number} qty
   * @param {number} index
   */ const handleAddFullLot = (item, qty, index)=>{
        if (!qty || qty > item.unitOfIssueQoh) {
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).error('The entered quantity is greater than the available quantity. Please adjust the quantity');
            return;
        }
        onAddFullLot(item, qty, index, transactionType, orgId);
        setQuantities((q)=>({
                ...q,
                [index]: ''
            }));
    };
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
        className: $97cddd3a85cbf2e7$export$34e0f9847d4c02dd,
        children: subinventoryQtyInfo.map((item, index)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                className: $97cddd3a85cbf2e7$export$e2aec4f476da5951,
                "data-testid": `subinventory-item-${index}`,
                children: [
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                        className: $97cddd3a85cbf2e7$export$e6d3dbed1b4eb6ad,
                        children: [
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                className: $97cddd3a85cbf2e7$export$fe1f090daaa782aa,
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                                        className: $97cddd3a85cbf2e7$export$1237798dc640739a,
                                        children: "Item"
                                    }),
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                                        className: $97cddd3a85cbf2e7$export$2ab9a8f9f1186f14,
                                        "data-testid": `item-${index}`,
                                        children: item.item || 'N/A'
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                className: $97cddd3a85cbf2e7$export$fe1f090daaa782aa,
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                                        className: $97cddd3a85cbf2e7$export$1237798dc640739a,
                                        children: "Location"
                                    }),
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                                        className: $97cddd3a85cbf2e7$export$2ab9a8f9f1186f14,
                                        "data-testid": `location-${index}`,
                                        children: item.locator || 'N/A'
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                className: $97cddd3a85cbf2e7$export$fe1f090daaa782aa,
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                                        className: $97cddd3a85cbf2e7$export$1237798dc640739a,
                                        children: "Available QTY"
                                    }),
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                                        className: $97cddd3a85cbf2e7$export$2ab9a8f9f1186f14,
                                        "data-testid": `available-qty-${index}`,
                                        children: item.unitOfIssueQoh || 0
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                className: $97cddd3a85cbf2e7$export$fe1f090daaa782aa,
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                                        className: $97cddd3a85cbf2e7$export$1237798dc640739a,
                                        children: "UOM"
                                    }),
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                                        className: $97cddd3a85cbf2e7$export$2ab9a8f9f1186f14,
                                        "data-testid": `uom-${index}`,
                                        children: item.unitOfIssueCode || 'N/A'
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                className: $97cddd3a85cbf2e7$export$fe1f090daaa782aa,
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                                        className: $97cddd3a85cbf2e7$export$1237798dc640739a,
                                        children: "Lot"
                                    }),
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                                        className: $97cddd3a85cbf2e7$export$2ab9a8f9f1186f14,
                                        "data-testid": `lot-${index}`,
                                        children: item.lotNumber || 'N/A'
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                className: $97cddd3a85cbf2e7$export$fe1f090daaa782aa,
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                                        className: $97cddd3a85cbf2e7$export$1237798dc640739a,
                                        children: "Lot Qty"
                                    }),
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                                        className: $97cddd3a85cbf2e7$export$2ab9a8f9f1186f14,
                                        "data-testid": `lot-qty-${index}`,
                                        children: item.unitOfIssueFixedLot || 0
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                        className: $97cddd3a85cbf2e7$export$410fed1e7dbc89d8,
                        children: [
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                className: $97cddd3a85cbf2e7$export$995e14ef61d916e6,
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("label", {
                                        htmlFor: `transact-qty-${index}`,
                                        className: $97cddd3a85cbf2e7$export$1237798dc640739a,
                                        children: "Transact QTY"
                                    }),
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("input", {
                                        type: "number",
                                        id: `transact-qty-${index}`,
                                        className: $97cddd3a85cbf2e7$export$ae91b53a46022815,
                                        placeholder: "",
                                        "data-testid": `transact-qty-${index}`,
                                        value: quantities[index] ?? '',
                                        onChange: (e)=>setQuantities((q)=>({
                                                    ...q,
                                                    [index]: e.target.value
                                                }))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                className: $97cddd3a85cbf2e7$export$9c686a975407e95c,
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                                        color: "primary",
                                        className: $97cddd3a85cbf2e7$export$a75c7ea49564edd7,
                                        value: quantities[index] ?? '',
                                        disabled: disableAddQuantity || !quantities[index] || Number(quantities[index]) <= 0,
                                        onClick: ()=>handleAddQuantity(item, index),
                                        "data-testid": `add-quantity-btn-${index}`,
                                        children: "Add Quantity"
                                    }),
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                                        color: "secondary",
                                        className: $97cddd3a85cbf2e7$export$a75c7ea49564edd7,
                                        disabled: disableAddFullLot || !item.unitOfIssueFixedLot,
                                        onClick: ()=>handleAddFullLot(item, item.unitOfIssueFixedLot, index),
                                        "data-testid": `add-full-lot-btn-${index}`,
                                        children: "Add Full Lot"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }, `${item.inventoryItemId}-${item.subinventoryCode}-${item.locator}-${item.lotNumber}-${index}`))
    });
};







var $ed6596368bc589bf$export$e324594224ef24da;
var $ed6596368bc589bf$export$2ba01fb71ed41cb6;
var $ed6596368bc589bf$export$a7db06668cad9adb;
var $ed6596368bc589bf$export$4df8d4373bc60300;
var $ed6596368bc589bf$export$c2947f539ebf7d9e;
var $ed6596368bc589bf$export$471f7ae5c4103ae1;
$ed6596368bc589bf$export$e324594224ef24da = `_1dM8za_actions`;
$ed6596368bc589bf$export$2ba01fb71ed41cb6 = `_1dM8za_button`;
$ed6596368bc589bf$export$a7db06668cad9adb = `_1dM8za_content`;
$ed6596368bc589bf$export$4df8d4373bc60300 = `_1dM8za_drawer`;
$ed6596368bc589bf$export$c2947f539ebf7d9e = `_1dM8za_drawerFooter`;
$ed6596368bc589bf$export$471f7ae5c4103ae1 = `_1dM8za_status`;


/**
 * Converts SCREAMING_SNAKE_CASE to PascalCase
 * @param {string} str - The string to convert
 * @returns {string} The PascalCase version
 */ const $ee78c66814494e53$var$toPascalCase = (str)=>{
    if (!str) return '';
    return str.toLowerCase().split('_').map((word)=>word.charAt(0).toUpperCase() + word.slice(1)).join('');
};
const $ee78c66814494e53$export$e8b1372a1b1babd1 = ({ open: open, close: close, onComplete: onComplete, disableSubmit: disableSubmit, request: request, children: children })=>{
    const { mutate: updateRequest } = (0, $7a812fda41e7dd2d$export$f9e292527e05459d)();
    const { completeWithLinkedActionCheck: completeWithLinkedActionCheck, isLinkedActionPromptOpen: isLinkedActionPromptOpen, linkedActionDescription: linkedActionDescription, onDecline: onDecline, onConfirm: onConfirm } = (0, $63b0984325adb4a7$export$8ad014c5646c5871)();
    const transactionId = $ee78c66814494e53$var$toPascalCase(request?.action?.transactionId || '');
    const handleTitle = ()=>{
        switch(request?.action?.transactionId){
            case (0, $917e2c0c66b65db1$export$9831c7e6e3463b6e).TRAILER_TO_DOCK:
                return 'Trailer to Dock';
            case (0, $917e2c0c66b65db1$export$9831c7e6e3463b6e).SUB_INVENTORY_TRANSFER:
                return 'Sub Inventory Transfer';
            case (0, $917e2c0c66b65db1$export$9831c7e6e3463b6e).DIRECT_ORG_TRANSFER:
                return 'Direct Organization Transfer';
            case (0, $917e2c0c66b65db1$export$9831c7e6e3463b6e).ISSUE_TO_LINE:
                return 'Issue to Line';
            default:
                return 'Transaction';
        }
    };
    /**
   * Updates the request to Completed status and closes the drawer.
   * @param {string} errorMessage - Toast message shown if the status update fails.
   */ const handleCompleteRequest = (errorMessage)=>{
        if (!request?.id) {
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).error('Request ID is missing. Cannot update status.');
            return;
        }
        completeWithLinkedActionCheck(request, ()=>updateRequest({
                id: request.id,
                status: (0, $917e2c0c66b65db1$export$b41c0f52c41112e3).COMPLETED
            }, {
                onSuccess: ()=>{
                    (0, $673b1c81cc441170$export$2e2bcd8739ae039).success('Request completed successfully!');
                    close();
                },
                onError: ()=>{
                    (0, $673b1c81cc441170$export$2e2bcd8739ae039).error(errorMessage);
                }
            }));
    };
    const handleBypass = ()=>{
        handleCompleteRequest('Error bypassing transaction. Status may not be updated. Please refresh.');
    };
    const handleSubmit = ()=>onComplete(completeWithLinkedActionCheck);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $667a2883fca669f9$export$2e2bcd8739ae039), {
        direction: "bottom",
        open: open,
        onOpenChange: close,
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $41db6ce8ffe5ef63$export$2e2bcd8739ae039), {
                className: $ed6596368bc589bf$export$4df8d4373bc60300,
                showClose: false,
                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                    className: $ed6596368bc589bf$export$a7db06668cad9adb,
                    children: [
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("b", {
                            children: handleTitle()
                        }),
                        children,
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                            className: $ed6596368bc589bf$export$c2947f539ebf7d9e,
                            children: [
                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                                    "data-testid": `bypass${transactionId}`,
                                    className: $ed6596368bc589bf$export$2ba01fb71ed41cb6,
                                    color: "tertiary",
                                    onClick: handleBypass,
                                    children: "Bypass"
                                }),
                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                                    "data-testid": `cancel${transactionId}`,
                                    className: $ed6596368bc589bf$export$2ba01fb71ed41cb6,
                                    color: "secondary",
                                    onClick: close,
                                    children: "CANCEL"
                                }),
                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                                    "data-testid": `submit${transactionId}`,
                                    className: $ed6596368bc589bf$export$2ba01fb71ed41cb6,
                                    color: "primary",
                                    onClick: handleSubmit,
                                    disabled: disableSubmit,
                                    children: "COMPLETE"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $b195b7406d2db366$export$f4686426a1b24a12), {
                isOpen: isLinkedActionPromptOpen,
                description: linkedActionDescription,
                onDecline: onDecline,
                onConfirm: onConfirm
            })
        ]
    });
};




var $f15f038405f8444a$export$38e42c68cf43b5d4;
var $f15f038405f8444a$export$120ff0929b202a6d;
var $f15f038405f8444a$export$fb184b623420d9be;
var $f15f038405f8444a$export$2a2a4f3d7ce9d087;
var $f15f038405f8444a$export$cc74dcc53cfce4eb;
$f15f038405f8444a$export$38e42c68cf43b5d4 = `sLKlza_header`;
$f15f038405f8444a$export$120ff0929b202a6d = `sLKlza_row`;
$f15f038405f8444a$export$fb184b623420d9be = `sLKlza_title`;
$f15f038405f8444a$export$2a2a4f3d7ce9d087 = `sLKlza_transferRow`;
$f15f038405f8444a$export$cc74dcc53cfce4eb = `sLKlza_wrapper`;


const $886cdf6d2d94b94b$export$bfe088fef0a88dc9 = ({ items: items, onDelete: onDelete })=>{
    if (!items?.length) return null;
    const showTransferColumn = items.some((item)=>item.transferSubinventory);
    const rowClass = showTransferColumn ? `${$f15f038405f8444a$export$120ff0929b202a6d} ${$f15f038405f8444a$export$2a2a4f3d7ce9d087}` : $f15f038405f8444a$export$120ff0929b202a6d;
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
        className: $f15f038405f8444a$export$cc74dcc53cfce4eb,
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("h3", {
                className: $f15f038405f8444a$export$fb184b623420d9be,
                children: "Transaction Items"
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                className: `${rowClass} ${$f15f038405f8444a$export$38e42c68cf43b5d4}`,
                children: [
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                        children: "Item"
                    }),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                        children: "Quantity"
                    }),
                    showTransferColumn ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $1e1ba35c5b9fc4c3$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                                children: "Sub Inv To"
                            }),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                                children: "Sub Inv From"
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                        children: "Sub Inventory"
                    }),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                        children: "UOM"
                    }),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {})
                ]
            }),
            items.map((item)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                    className: rowClass,
                    children: [
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                            children: item.item
                        }),
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                            children: item.transactionQuantity * -1
                        }),
                        showTransferColumn ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $1e1ba35c5b9fc4c3$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                                    children: item.transferSubinventory
                                }),
                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                                    children: item.subinventoryCode
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                            children: item.subinventoryCode
                        }),
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                            children: item.unitOfIssueCode
                        }),
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                            children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                                "aria-label": `Delete transaction item ${item.item}`,
                                "data-testid": `delete-transaction-item-${item.id}`,
                                color: "tertiary",
                                iconLeft: "delete",
                                onClick: ()=>onDelete(item.id)
                            })
                        })
                    ]
                }, item.id))
        ]
    });
};






var $lCzvA = parcelRequire("lCzvA");



var $32961a3a7435113f$export$34e0f9847d4c02dd;
$32961a3a7435113f$export$34e0f9847d4c02dd = `fa72jG_container slideRight`;


const $32d06f7638239599$export$25e48ac541203d4a = ()=>{
    const navigate = (0, $ebc812b73151cba1$export$9770f232ac06a008)();
    const { selectedPlant: selectedPlant } = (0, $1b0a542caa3229ca$export$b91a5355c3a5f338)();
    const { data: plants } = (0, $e733424c31ecfe53$export$b22ebc4820923ca5)(true);
    const plant = plants?.find((p)=>p.id === selectedPlant);
    const handleBack = ()=>navigate('/');
    // In the event a user navigates directly to a page without a plant selected, redirect to home
    (0, $lCzvA.useEffect)(()=>{
        if (!selectedPlant) navigate('/');
    }, [
        selectedPlant,
        navigate
    ]);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
        "data-testid": "back-button-container",
        className: $32961a3a7435113f$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                "data-testid": "back-button",
                color: "secondary",
                onClick: handleBack,
                children: [
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                        name: "arrow_back"
                    }),
                    "Back"
                ]
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("p", {
                "data-testid": "plant-description",
                children: plant?.description
            })
        ]
    });
};





var $f7f3229788c0c699$export$89da14300d534261;
var $f7f3229788c0c699$export$34e0f9847d4c02dd;
var $f7f3229788c0c699$export$62d58b1c91e8e902;
$f7f3229788c0c699$export$89da14300d534261 = `_3zn8oq_active`;
$f7f3229788c0c699$export$34e0f9847d4c02dd = `_3zn8oq_container`;
$f7f3229788c0c699$export$62d58b1c91e8e902 = `_3zn8oq_tab`;


const $fa5b7443f387842b$export$b2539bed5023c21c = ({ tabs: tabs })=>{
    const dispatch = (0, $4e4c6c71fc2aaac8$export$f51d452c10d5b956)();
    const { activeTab: activeTab } = (0, $4e4c6c71fc2aaac8$export$fdc397e486fa83e7)();
    /**
   * Handles changes to the active tab.
   * @param {React.MouseEvent<HTMLButtonElement> & { currentTarget: { dataset: {tab: string} } }} event - The change event object.
   * @returns {void}
   */ const handleTabChange = ({ currentTarget: { dataset: dataset } })=>{
        const { tab: tab } = dataset;
        dispatch({
            type: (0, $3b086af55ffdafb7$export$57ef17f620781de2),
            payload: tab
        });
    };
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
        "data-testid": "tabs-container",
        className: $f7f3229788c0c699$export$34e0f9847d4c02dd,
        children: tabs.map((tab)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("button", {
                "data-testid": `tab-${tab}`,
                className: `${$f7f3229788c0c699$export$62d58b1c91e8e902} ${activeTab === tab ? $f7f3229788c0c699$export$89da14300d534261 : ''}`,
                type: "button",
                "data-tab": tab,
                onClick: handleTabChange,
                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("p", {
                    children: tab
                })
            }, tab))
    });
};




var $lCzvA = parcelRequire("lCzvA");





var $lCzvA = parcelRequire("lCzvA");

"use client";
//#region src/components/Accordion/index.jsx
var $8fedcf22c00c4cdd$export$2e2bcd8739ae039 = ({ allowMultiple: a = !0, className: o, variant: s = "list", enableAnimation: c = !0, children: l, ...u })=>{
    let d = (0, $lCzvA.useId)(), f = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-Accordion my-6 block": !0,
        "sash-Accordion--list": s === "list",
        "sash-Accordion--box": s === "box",
        "sash-Accordion--animated": c,
        [o]: o
    });
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
        className: f,
        "data-testid": "sash-accordion",
        ...u,
        children: (0, $lCzvA.Children)?.toArray(l)?.map((e)=>(0, $lCzvA.cloneElement)(e, {
                allowMultiple: a,
                id: `${d}sash-accordion`
            }))
    });
};



//#region src/components/Accordion/AccordionContent/index.jsx
var $d9ac194a6f540d5b$export$2e2bcd8739ae039 = ({ className: n, children: r, ...i })=>{
    let a = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-AccordionContent px-2 pt-2 pb-4": !0,
        [n]: n
    });
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
        className: a,
        "data-testid": "sash-accordion-content",
        ...i,
        children: r
    });
};
$d9ac194a6f540d5b$export$2e2bcd8739ae039.displayName = "AccordionContent";



"use client";
//#region src/components/Accordion/AccordionItem/index.jsx
var $9e4c7ade3285342d$export$2e2bcd8739ae039 = ({ className: n, defaultOpen: r, allowMultiple: i, id: a, children: o, ...s })=>{
    let c = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-AccordionItem block": !0,
        [n]: n
    });
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("details", {
        name: i ? void 0 : a,
        className: c,
        "data-testid": "sash-accordion-item",
        open: r,
        ...s,
        children: o
    });
};
$9e4c7ade3285342d$export$2e2bcd8739ae039.displayName = "AccordionItem";



//#region src/components/Accordion/AccordionTrigger/index.jsx
var $dffdfe16b69939eb$export$2e2bcd8739ae039 = ({ className: r, activeIcon: i = "remove", inactiveIcon: a = "add", renderAs: o = "span", children: s, textClass: c, ...l })=>{
    let u = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-AccordionTrigger gap-x-4 relative flex w-full items-center py-4 px-2 text-left cursor-pointer": !0,
        [r]: r
    }), d = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "text-neutral-750 m-0! flex-1 text-base/tight font-semibold": !0,
        [c]: c
    }), f = o;
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("summary", {
        className: u,
        "data-testid": "sash-accordion-trigger",
        ...l,
        children: [
            i && a && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                className: "sash-AccordionTrigger-icon flex items-center justify-center text-center leading-none",
                "data-testid": "sash-accordion-icon",
                "data-active-icon": i,
                "data-inactive-icon": a
            }),
            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)(f, {
                "data-testid": "sash-accordion-trigger-text",
                className: d,
                children: s
            })
        ]
    });
};
$dffdfe16b69939eb$export$2e2bcd8739ae039.displayName = "AccordionTrigger";




//#region src/components/Badge/index.jsx
var $906889f993373872$export$2e2bcd8739ae039 = ({ color: i = "conversion", variant: a = "rounded", size: o = "sm", className: s, renderAs: c = "span", iconRight: l, iconLeft: u, children: d, darkMode: f, ...p })=>{
    let m = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-Badge inline-flex items-center gap-x-1 text-sm font-semibold": !0,
        "py-1 px-2": o,
        "bg-conversion text-black": i === "conversion",
        "bg-red-200 text-red-800": i === "error" && !f,
        "bg-amber-200 text-amber-800": i === "warning" && !f,
        "bg-blue-200 text-blue-800": i === "info" && !f,
        "bg-green-200 text-green-700": i === "success" && !f,
        "bg-neutral-100 text-black": i === "neutral" && !f,
        "bg-black text-conversion": i === "conversion" && f,
        "bg-red-800 text-neutral-25": i === "error" && f,
        "bg-amber-800 text-neutral-25": i === "warning" && f,
        "bg-blue-600 text-white": i === "info" && f,
        "bg-green-600 text-white": i === "success" && f,
        "bg-neutral-800 text-white": i === "neutral" && f,
        "bg-neutral-50": i === "light-gray",
        "bg-neutral-100 text-neutral-700": i === "gray",
        "bg-neutral-700 text-white": i === "dark-gray",
        "bg-black text-white": i === "black",
        "bg-white text-neutral-900": i === "white",
        "rounded-sm": a === "rounded",
        "rounded-full": a === "pill",
        [s]: s
    });
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)(c, {
        className: m,
        "data-color": i,
        "data-mode": f ? "dark" : "light",
        ...p,
        children: [
            u && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                name: u,
                className: "text-current",
                size: 20
            }),
            d,
            l && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                name: l,
                className: "text-current",
                size: 20
            })
        ]
    });
};






//#region src/components/Card/index.jsx
var $482f79dfdc83e24d$export$2e2bcd8739ae039 = ({ variant: n = "default", muted: r, children: i, className: a, renderAs: o, ...s })=>{
    let c = s.onClick || s.href || s.to || o === "label", l = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-Card border border-neutral-100 rounded-xs w-full overflow-hidden": !0,
        "bg-white": !r,
        "bg-neutral-50": r,
        "p-6": n === "default",
        "p-4": n === "compact",
        "p-8": n === "comfortable",
        "block hover:shadow-hover hover:border-neutral-300 active:border-black active:shadow-default focus-visible:shadow-none focus-visible:border-neutral-200 no-underline font-normal": c,
        [a]: a
    }), u = "div";
    return o ? u = o : s.href ? u = "a" : s.onClick && (u = "button"), /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)(u, {
        className: l,
        "data-testid": "sash-card",
        "data-variant": n,
        "data-muted": r,
        ...s,
        children: i
    });
};





var $3203cdd472db240e$export$a80b3bd66acc52ff;
var $3203cdd472db240e$export$fb184b623420d9be;
var $3203cdd472db240e$export$ddb906a32562356c;
$3203cdd472db240e$export$a80b3bd66acc52ff = `_1nIUya_info`;
$3203cdd472db240e$export$fb184b623420d9be = `_1nIUya_title`;
$3203cdd472db240e$export$ddb906a32562356c = `_1nIUya_user`;


const $51a8ce9faa2e0a0d$export$53e86a51580efa14 = ({ title: title, user: user, date: date, holdReason: holdReason })=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                className: $3203cdd472db240e$export$fb184b623420d9be,
                children: title
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                className: $3203cdd472db240e$export$a80b3bd66acc52ff,
                children: [
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                        name: "account_circle",
                        size: 16,
                        weight: 700
                    }),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                        className: $3203cdd472db240e$export$ddb906a32562356c,
                        children: user
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                className: $3203cdd472db240e$export$a80b3bd66acc52ff,
                children: [
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                        name: "schedule",
                        size: 16,
                        weight: 700
                    }),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                        children: (0, $5f8e1c8d350f317e$export$5ede9312e237b505)(date)
                    })
                ]
            }),
            Boolean(holdReason) && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                className: $3203cdd472db240e$export$a80b3bd66acc52ff,
                children: [
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                        name: "info",
                        size: 16,
                        weight: 700
                    }),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                        className: $3203cdd472db240e$export$a80b3bd66acc52ff,
                        children: holdReason
                    })
                ]
            })
        ]
    });




var $lCzvA = parcelRequire("lCzvA");







var $lCzvA = parcelRequire("lCzvA");



var $786c72f7beae893e$export$e324594224ef24da;
var $786c72f7beae893e$export$2ba01fb71ed41cb6;
var $786c72f7beae893e$export$a7db06668cad9adb;
var $786c72f7beae893e$export$4df8d4373bc60300;
var $786c72f7beae893e$export$2daf5cbeed728edf;
var $786c72f7beae893e$export$471f7ae5c4103ae1;
var $786c72f7beae893e$export$9818ce47c5f6dfe9;
$786c72f7beae893e$export$e324594224ef24da = `_27BjLG_actions`;
$786c72f7beae893e$export$2ba01fb71ed41cb6 = `_27BjLG_button`;
$786c72f7beae893e$export$a7db06668cad9adb = `_27BjLG_content`;
$786c72f7beae893e$export$4df8d4373bc60300 = `_27BjLG_drawer`;
$786c72f7beae893e$export$2daf5cbeed728edf = `_27BjLG_inputFields`;
$786c72f7beae893e$export$471f7ae5c4103ae1 = `_27BjLG_status`;
$786c72f7beae893e$export$9818ce47c5f6dfe9 = `_27BjLG_wmsOrgCodeInput`;


const $2406d5298f2fb2bf$var$WMS_CODE_LENGTH = 3;
const $2406d5298f2fb2bf$export$273ae68aaa66133a = ({ open: open, close: close, data: data, selectedId: selectedId })=>{
    const { mutate: createPlant, isPending: isCreating } = (0, $63e4bd9659ac6675$export$f45c95aff449d4a0)();
    const { mutate: updatePlant, isPending: isUpdating } = (0, $b407499c949b079d$export$4a9ddee008a7c0ec)();
    const { data: organizations } = (0, $b75393bd8a70fa20$export$5fc38fde58f5cf66)();
    const [formChanges, setFormChanges] = (0, $lCzvA.useState)(/** @type {Partial<Pella.ProductionRequestAPI.CreatePlantInput>} */ {});
    const currentForm = selectedId ? data?.find((record)=>record.id === selectedId) : {
        active: true
    };
    // Combine initial data with form changes to get the current plant state
    const plant = {
        ...currentForm,
        ...formChanges
    };
    const isEdit = Boolean(selectedId);
    /** Handler to reset form and close drawer */ const handleClose = ()=>{
        setFormChanges({});
        close();
    };
    /** handler for form submission */ const handleSubmit = ()=>{
        // Ensure all required fields are defined before mutation
        if (!isEdit) {
            const input = {
                /* v8 ignore start */ active: plant.active ?? true,
                description: plant.description || '',
                organizationId: plant.organizationId || 0,
                /* v8 ignore stop */ wmsOrgCode: plant.wmsOrgCode || undefined
            };
            createPlant(input, {
                onSuccess: handleClose
            });
        } else {
            const id = selectedId;
            const input = {
                description: plant.description,
                organizationId: plant.organizationId,
                wmsOrgCode: plant.wmsOrgCode || null,
                active: plant.active
            };
            updatePlant({
                id: id,
                input: input
            }, {
                onSuccess: handleClose
            });
        }
    };
    const hasRequiredFields = Boolean(plant.description?.trim() && plant.organizationId);
    const hasValidWmsCode = !plant.wmsOrgCode || plant.wmsOrgCode.length === $2406d5298f2fb2bf$var$WMS_CODE_LENGTH;
    const isLoading = isCreating || isUpdating;
    const disableSubmit = !hasRequiredFields || !hasValidWmsCode || isLoading;
    const disableForms = !plant.active;
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $3f0ece51815fa43b$export$e7814354e1c15999), {
        open: open,
        close: handleClose,
        title: "Plant",
        isEdit: isEdit,
        isCopy: false,
        active: Boolean(plant.active),
        onActiveChange: ()=>setFormChanges((prev)=>({
                    ...prev,
                    active: !plant.active
                })),
        onSubmit: handleSubmit,
        disableSubmit: disableSubmit,
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $67004894d25c93a4$export$2e2bcd8739ae039), {
                id: "plantNameInput",
                labelText: "Plant Name",
                disabled: disableForms,
                maxLength: 50,
                required: Boolean(!plant.description),
                value: plant.description || '',
                onChange: (e)=>setFormChanges((prev)=>({
                            ...prev,
                            description: e.target.value
                        }))
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                className: $786c72f7beae893e$export$2daf5cbeed728edf,
                children: [
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $c7e1b2c0ded2c83a$export$2e2bcd8739ae039), {
                        id: "organizationSelect",
                        labelText: "Organization",
                        disabled: disableForms,
                        required: Boolean(!plant.organizationId),
                        value: plant.organizationId || '',
                        onChange: (e)=>setFormChanges((prev)=>({
                                    ...prev,
                                    organizationId: Number(e.target.value)
                                })),
                        children: [
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                value: "",
                                disabled: true,
                                children: "Select an organization"
                            }),
                            organizations?.map((org)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                    value: org.organizationId,
                                    children: org.description
                                }, org.organizationId))
                        ]
                    }),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $67004894d25c93a4$export$2e2bcd8739ae039), {
                        className: $786c72f7beae893e$export$9818ce47c5f6dfe9,
                        id: "wmsOrgCodeInput",
                        labelText: "WMS Org Code",
                        disabled: disableForms,
                        required: !hasValidWmsCode,
                        maxLength: 3,
                        value: plant.wmsOrgCode || '',
                        onChange: (e)=>setFormChanges((prev)=>({
                                    ...prev,
                                    wmsOrgCode: e.target.value
                                }))
                    })
                ]
            })
        ]
    });
};




var $lCzvA = parcelRequire("lCzvA");



const $e5ef1a18bf9e9d92$export$7aef46c40747de48 = ({ open: open, close: close, data: data, selectedId: selectedId })=>{
    const { selectedPlant: selectedPlant } = (0, $1b0a542caa3229ca$export$b91a5355c3a5f338)();
    const { mutate: createLocation, isPending: isCreating } = (0, $d704b2ee256efc5a$export$8ae537f4e8345e78)();
    const { mutate: updateLocation, isPending: isUpdating } = (0, $b7bcf9b08c831303$export$688166aaa79cd43b)();
    const [formChanges, setFormChanges] = (0, $lCzvA.useState)(/** @type {Partial<Pella.ProductionRequestAPI.CreateLocationInput>} */ {});
    const currentForm = selectedId ? data?.find((record)=>record.id === selectedId) : {
        active: true
    };
    // Combine initial data with form changes to get the current location state
    const location = {
        ...currentForm,
        ...formChanges
    };
    const isEdit = Boolean(selectedId);
    /** Handler to reset form and close drawer */ const handleClose = ()=>{
        setFormChanges({});
        close();
    };
    /** handler for form submission */ const handleSubmit = ()=>{
        // Ensure all required fields are defined before mutation
        if (!isEdit) {
            const input = {
                plantId: selectedPlant,
                /* v8 ignore start */ active: location.active ?? true,
                description: location.description || ''
            };
            createLocation(input, {
                onSuccess: handleClose
            });
        } else {
            const id = selectedId;
            const input = {
                description: location.description,
                active: location.active
            };
            updateLocation({
                id: id,
                input: input
            }, {
                onSuccess: handleClose
            });
        }
    };
    const hasRequiredFields = Boolean(location.description?.trim());
    const isLoading = isCreating || isUpdating;
    const disableSubmit = !hasRequiredFields || isLoading;
    const disableForms = !location.active;
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $3f0ece51815fa43b$export$e7814354e1c15999), {
        open: open,
        close: handleClose,
        title: "Location",
        isEdit: isEdit,
        isCopy: false,
        active: Boolean(location.active),
        onActiveChange: ()=>setFormChanges((prev)=>({
                    ...prev,
                    active: !location.active
                })),
        onSubmit: handleSubmit,
        disableSubmit: disableSubmit,
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $67004894d25c93a4$export$2e2bcd8739ae039), {
            id: "locationNameInput",
            labelText: "Location Name",
            disabled: disableForms,
            maxLength: 50,
            required: Boolean(!location.description),
            value: location.description || '',
            onChange: (e)=>setFormChanges((prev)=>({
                        ...prev,
                        description: e.target.value
                    }))
        })
    });
};




var $lCzvA = parcelRequire("lCzvA");



const $81e5fc1e33e3a056$export$839655553b540415 = ({ open: open, close: close, data: data, selectedId: selectedId })=>{
    const { selectedPlant: selectedPlant } = (0, $1b0a542caa3229ca$export$b91a5355c3a5f338)();
    const { mutate: createResource, isPending: isCreating } = (0, $3d379a1e3b14fb6f$export$ddb9c141656ef97b)();
    const { mutate: updateResource, isPending: isUpdating } = (0, $ef91388bb970737c$export$b66b501d3b531e82)();
    const [formChanges, setFormChanges] = (0, $lCzvA.useState)(/** @type {Partial<Pella.ProductionRequestAPI.CreateResourceInput>} */ {});
    const currentForm = selectedId ? data?.find((record)=>record.id === selectedId) : {
        active: true
    };
    // Combine initial data with form changes to get the current resource state
    const resource = {
        ...currentForm,
        ...formChanges
    };
    const isEdit = Boolean(selectedId);
    /** Handler to reset form and close drawer */ const handleClose = ()=>{
        setFormChanges({});
        close();
    };
    /** handler for form submission */ const handleSubmit = ()=>{
        // Ensure all required fields are defined before mutation
        if (!isEdit) {
            const input = {
                plantId: selectedPlant,
                /* v8 ignore start */ active: resource.active ?? true,
                description: resource.description || ''
            };
            createResource(input, {
                onSuccess: handleClose
            });
        } else {
            const id = selectedId;
            const input = {
                description: resource.description,
                active: resource.active
            };
            updateResource({
                id: id,
                input: input
            }, {
                onSuccess: handleClose
            });
        }
    };
    const hasRequiredFields = Boolean(resource.description?.trim());
    const isLoading = isCreating || isUpdating;
    const disableSubmit = !hasRequiredFields || isLoading;
    const disableForms = !resource.active;
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $3f0ece51815fa43b$export$e7814354e1c15999), {
        open: open,
        close: handleClose,
        title: "Resource",
        isEdit: isEdit,
        isCopy: false,
        active: Boolean(resource.active),
        onActiveChange: ()=>setFormChanges((prev)=>({
                    ...prev,
                    active: !resource.active
                })),
        onSubmit: handleSubmit,
        disableSubmit: disableSubmit,
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $67004894d25c93a4$export$2e2bcd8739ae039), {
            id: "resourceNameInput",
            labelText: "Resource Name",
            disabled: disableForms,
            maxLength: 50,
            required: Boolean(!resource.description),
            value: resource.description || '',
            onChange: (e)=>setFormChanges((prev)=>({
                        ...prev,
                        description: e.target.value
                    }))
        })
    });
};




var $lCzvA = parcelRequire("lCzvA");



const $e233fd305a6c6026$export$c8a117a0d0cb6291 = ({ open: open, close: close, data: data, selectedId: selectedId })=>{
    const { selectedPlant: selectedPlant } = (0, $1b0a542caa3229ca$export$b91a5355c3a5f338)();
    const { mutate: createQueue, isPending: isCreating } = (0, $575b64f7cab074ca$export$b59e9c7b8e1f0c44)();
    const { mutate: updateQueue, isPending: isUpdating } = (0, $a47684000ca9987d$export$69834bcee82719ce)();
    const [formChanges, setFormChanges] = (0, $lCzvA.useState)(/** @type {Partial<Pella.ProductionRequestAPI.CreateQueueInput>} */ {});
    const currentForm = selectedId ? data?.find((record)=>record.id === selectedId) : {
        active: true
    };
    // Combine initial data with form changes to get the current queue state
    const queue = {
        ...currentForm,
        ...formChanges
    };
    const isEdit = Boolean(selectedId);
    /** Handler to reset form and close drawer */ const handleClose = ()=>{
        setFormChanges({});
        close();
    };
    /** handler for form submission */ const handleSubmit = ()=>{
        // Ensure all required fields are defined before mutation
        if (!isEdit) {
            const input = {
                plantId: selectedPlant,
                /* v8 ignore start */ active: queue.active ?? true,
                description: queue.description || ''
            };
            createQueue(input, {
                onSuccess: handleClose
            });
        } else {
            const id = selectedId;
            const input = {
                description: queue.description,
                active: queue.active
            };
            updateQueue({
                id: id,
                input: input
            }, {
                onSuccess: handleClose
            });
        }
    };
    const hasRequiredFields = Boolean(queue.description?.trim());
    const isLoading = isCreating || isUpdating;
    const disableSubmit = !hasRequiredFields || isLoading;
    const disableForms = !queue.active;
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $3f0ece51815fa43b$export$e7814354e1c15999), {
        open: open,
        close: handleClose,
        title: "Queue",
        isEdit: isEdit,
        isCopy: false,
        active: Boolean(queue.active),
        onActiveChange: ()=>setFormChanges((prev)=>({
                    ...prev,
                    active: !queue.active
                })),
        onSubmit: handleSubmit,
        disableSubmit: disableSubmit,
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $67004894d25c93a4$export$2e2bcd8739ae039), {
            id: "queueNameInput",
            labelText: "Queue Name",
            disabled: disableForms,
            maxLength: 50,
            required: Boolean(!queue.description),
            value: queue.description || '',
            onChange: (e)=>setFormChanges((prev)=>({
                        ...prev,
                        description: e.target.value
                    }))
        })
    });
};





var $lCzvA = parcelRequire("lCzvA");






var $lCzvA = parcelRequire("lCzvA");


var $lCzvA = parcelRequire("lCzvA");

"use client";
//#region src/useMutationState.ts
/**
* The `useIsMutating` hook returns the `number` of mutations that your application currently has `pending`
* (useful for app-wide loading indicators).
* @param filters - The {@link MutationFilters} to narrow down the matched mutations.
* @param queryClient - Use this to use a custom `QueryClient`. Otherwise, the one from the nearest context will
* be used.
* @returns Will be the `number` of the mutations that your application currently has `pending`.
* @example
* ```tsx
* import { useIsMutating } from '@tanstack/react-query'
*
* function PostsMutatingIndicator() {
*   // How many mutations matching the posts prefix are in progress?
*   const isMutatingPosts = useIsMutating({ mutationKey: ['posts'] })
*
*   return isMutatingPosts ? <span>Saving posts...</span> : null
* }
* ```
*/ function $7ac1884223ee487e$export$32cc39cf62abf4fc(filters, queryClient) {
    const client = (0, $6547bc15d23e8c33$export$22e77b9572c4fded)(queryClient);
    return $7ac1884223ee487e$export$29ea95f3fea1dc1c({
        filters: {
            ...filters,
            status: "pending"
        }
    }, client).length;
}
/**
* Creates snapshot getters that share equal selected results across renders.
* A new getter is created on each render. Each getter caches its snapshot until the matching mutations
* or their states change.
* @returns A factory for snapshot getters with a shared result cache.
*/ function $7ac1884223ee487e$var$createSnapshotFactory() {
    let previousResult;
    return (mutationCache, options)=>{
        let inputs = [];
        let snapshot;
        return ()=>{
            const mutations = mutationCache.findAll(options.filters);
            const nextInputs = mutations.flatMap((mutation)=>[
                    mutation,
                    mutation.state
                ]);
            if (!snapshot || nextInputs.length !== inputs.length || nextInputs.some((input, index)=>!Object.is(input, inputs[index]))) {
                inputs = nextInputs;
                snapshot = (0, $d14a518110a15ba8$export$77a71fc411098696)(previousResult, mutations.map((mutation)=>options.select ? options.select(mutation) : mutation.state));
                previousResult = snapshot;
            }
            return snapshot;
        };
    };
}
/**
* `useMutationState` is a hook that gives you access to all mutations in the `MutationCache`. You can pass
* `filters` ({@link MutationFilters}) to narrow down your mutations, and `select` to transform the mutation
* state.
* @param options - The `filters` to narrow down matched mutations, and an optional `select` to transform the
* mutation state.
* @param queryClient - Use this to use a custom `QueryClient`. Otherwise, the one from the nearest context will
* be used.
* @returns Will be an Array of whatever `select` returns for each matching mutation.
* @example
* Get all variables of all running mutations:
* ```tsx
* import { useMutationState } from '@tanstack/react-query'
*
* function PendingPosts() {
*   const pendingVariables = useMutationState({
*     filters: { status: 'pending' },
*     select: (mutation) => mutation.state.variables,
*   })
*
*   return <>{pendingVariables.length} posts saving...</>
* }
* ```
* @example
* Get all data for specific mutations via the `mutationKey`:
* ```tsx
* import { useMutation, useMutationState } from '@tanstack/react-query'
*
* const mutationKey = ['posts']
*
* function Posts() {
*   // Some mutation that we want to get the state for
*   const mutation = useMutation({
*     mutationKey,
*     mutationFn: createPosts,
*   })
*
*   const savedPosts = useMutationState({
*     // this mutation key needs to match the mutation key of the given mutation (see above)
*     filters: { mutationKey, status: 'success' },
*     select: (mutation) => mutation.state.data,
*   })
*
*   return (
*     <button onClick={() => mutation.mutate(['New Post'])}>
*       Create post ({savedPosts.length} saved so far)
*     </button>
*   )
* }
* ```
* @example
* Access the latest successful mutation data via the `mutationKey`. Each invocation of `mutate` adds a new
* entry to the mutation cache for `gcTime` milliseconds — with the `status: 'success'` filter below, check the
* last item that `useMutationState` returns to get the latest successful invocation:
* ```tsx
* import { useMutationState } from '@tanstack/react-query'
*
* function LatestPost() {
*   const savedPosts = useMutationState({
*     filters: { mutationKey: ['posts'], status: 'success' },
*     select: (mutation) => mutation.state.data,
*   })
*
*   const latestSavedPost = savedPosts[savedPosts.length - 1]
*
*   return <>{latestSavedPost ? 'Saved' : 'Nothing saved yet'}</>
* }
* ```
*/ function $7ac1884223ee487e$export$29ea95f3fea1dc1c(options = {}, queryClient) {
    const mutationCache = (0, $6547bc15d23e8c33$export$22e77b9572c4fded)(queryClient).getMutationCache();
    const [createSnapshot] = $lCzvA.useState(()=>$7ac1884223ee487e$var$createSnapshotFactory());
    const getSnapshot = createSnapshot(mutationCache, options);
    return $lCzvA.useSyncExternalStore($lCzvA.useCallback((onStoreChange)=>mutationCache.subscribe((0, $7214f1c3bd8e29e6$export$520687f44db6e1ab).batchCalls(onStoreChange)), [
        mutationCache
    ]), getSnapshot, getSnapshot);
}






var $lCzvA = parcelRequire("lCzvA");
//#region src/hooks/useMediaQuery/index.jsx
var $557e5a825ed1446b$export$32d5543ab307c01 = (n)=>{
    let [r, i] = (0, $lCzvA.useState)(!1);
    return (0, $lCzvA.useEffect)(()=>{
        let e = window.matchMedia(n);
        i(e.matches);
        let t = (e)=>i(e.matches);
        return e.addEventListener("change", t), ()=>e.removeEventListener("change", t);
    }, [
        n
    ]), r;
};





"use client";
//#region src/components/Pagination/Link/index.jsx
var $64f8e63bddc72ee5$export$2e2bcd8739ae039 = ({ isActive: n, children: r, className: i, onClick: a, renderAs: o = "button", ...s })=>{
    let c = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-PaginationLink rounded-sm flex items-center justify-center size-9 no-underline text-sm font-semibold disabled:text-neutral-200 disabled:pointer-events-none": !0,
        "text-neutral-900 hover:bg-neutral-25": !n,
        "bg-neutral-750 text-white": n,
        [i]: i
    });
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)(o, {
        className: c,
        onClick: a,
        "aria-current": n ? "page" : void 0,
        "data-testid": "sash-pagination-link",
        ...s,
        children: r
    });
};
$64f8e63bddc72ee5$export$2e2bcd8739ae039.displayName = "PaginationLink";





var $lCzvA = parcelRequire("lCzvA");


"use client";
//#region src/components/Pagination/Ellipsis/index.jsx
var $fa37b8b1387bf6c2$export$2e2bcd8739ae039 = ({ className: o, children: s })=>{
    let c = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-PaginationEllipsis flex items-center justify-center size-9 hover:bg-neutral-25 focus-within:bg-neutral-25 rounded-sm text-sm font-semibold text-neutral-900 tracking-md": !0,
        [o]: o
    });
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)($d52c39e93549d141$export$be92b6f5f03c0fe9, {
        children: [
            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($d52c39e93549d141$export$41fb9f06171c75f4, {
                className: c,
                "data-testid": "sash-pagination-ellipsis",
                children: "..."
            }),
            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)($d52c39e93549d141$export$7c6e2c02157bb7d2, {
                className: "shadow-pella max-h-50 overflow-auto rounded-sm border border-neutral-200 bg-white p-1.5",
                children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $c169cb583646f905$export$2e2bcd8739ae039), {
                    bullets: "none",
                    children: (0, $lCzvA.Children).toArray(s).map((e, t)=>/* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("li", {
                            children: e
                        }, `pagination-ellipsis-child-${t}`))
                })
            })
        ]
    });
};
$fa37b8b1387bf6c2$export$2e2bcd8739ae039.displayName = "PaginationEllipsis";


//#region src/components/Pagination/helpers.js
var $d1143a57fb93aeb0$var$e = (e)=>Array.from({
        length: e
    }, (e, t)=>t + 1), $d1143a57fb93aeb0$var$t = (e, t, n)=>{
    if (n) {
        let n = e < t - 3 ? e - 3 : t - 6;
        return {
            startCutoff: Math.max(1, n),
            endCutoff: 5,
            visiblePages: 7
        };
    }
    let r = e < t - 2 ? e - 2 : t - 4;
    return {
        startCutoff: Math.max(1, r),
        endCutoff: 3,
        visiblePages: 5
    };
}, $d1143a57fb93aeb0$export$f0a3fcf252cf33f3 = (n, r, i)=>{
    let a = i ? r > 4 : r > 3, o = i ? r < n - 3 : r < n - 2;
    if (n <= (i ? 7 : 5)) return {
        pagesArray: $d1143a57fb93aeb0$var$e(n),
        firstEllipsisArray: [],
        lastEllipsisArray: []
    };
    let s = $d1143a57fb93aeb0$var$e(n), { startCutoff: c, endCutoff: l } = $d1143a57fb93aeb0$var$t(r, n, i), u = [
        ...s
    ], d = [], f = [];
    return a && (d = s.slice(1, c + 1), u = [
        s[0],
        "first-ellipsis",
        ...s.slice(c + 1)
    ]), o && (f = u.filter((e)=>typeof e == "number").slice(l, -1), u = [
        ...u.slice(0, l),
        "last-ellipsis",
        n
    ]), {
        pagesArray: u,
        firstEllipsisArray: d,
        lastEllipsisArray: f
    };
};



var $lCzvA = parcelRequire("lCzvA");

"use client";
//#region src/components/Pagination/index.jsx
var $8511f9b574a7211c$export$2e2bcd8739ae039 = ({ totalPages: u, currentPage: d, onPageChange: f, className: p, ...m })=>{
    let h = (0, $557e5a825ed1446b$export$32d5543ab307c01)("(min-width: 768px)"), { pagesArray: g, firstEllipsisArray: _, lastEllipsisArray: v } = (0, $lCzvA.useMemo)(()=>(0, $d1143a57fb93aeb0$export$f0a3fcf252cf33f3)(u, d, h), [
        u,
        d,
        h
    ]), y = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-Pagination relative flex flex-row items-center w-fit mx-auto justify-center bg-white rounded-sm gap-x-2 md:gap-x-3 border border-neutral-100 p-1.5 z-2": !0,
        [p]: p
    });
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("nav", {
        "aria-label": "Pagination",
        "data-testid": "sash-pagination",
        children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $c169cb583646f905$export$2e2bcd8739ae039), {
            bullets: "none",
            className: y,
            ...m,
            children: [
                /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("li", {
                    children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $64f8e63bddc72ee5$export$2e2bcd8739ae039), {
                        onClick: ()=>f(d - 1),
                        "aria-label": "Go to Previous Page",
                        disabled: d === 1,
                        children: [
                            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                                name: "keyboard_arrow_left"
                            }),
                            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                                className: "sr-only",
                                children: "Previous Page"
                            })
                        ]
                    })
                }),
                g.map((e)=>e === "first-ellipsis" ? /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("li", {
                        children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $fa37b8b1387bf6c2$export$2e2bcd8739ae039), {
                            children: _.map((e, t)=>/* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $64f8e63bddc72ee5$export$2e2bcd8739ae039), {
                                    onClick: ()=>f(e),
                                    children: e
                                }, `first-ellipsis-page-${t}`))
                        })
                    }, "pagination-ellipsis-first") : e === "last-ellipsis" ? /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("li", {
                        children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $fa37b8b1387bf6c2$export$2e2bcd8739ae039), {
                            children: v.map((e, t)=>/* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $64f8e63bddc72ee5$export$2e2bcd8739ae039), {
                                    onClick: ()=>f(e),
                                    children: e
                                }, `last-ellipsis-page-${t}`))
                        })
                    }, "pagination-ellipsis-last") : /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("li", {
                        children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $64f8e63bddc72ee5$export$2e2bcd8739ae039), {
                            onClick: ()=>f(e),
                            "aria-label": `Go to Page ${e}`,
                            "aria-current": d === e ? "page" : void 0,
                            isActive: d === e,
                            children: e
                        })
                    }, `pagination-item-${e}`)),
                /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("li", {
                    children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $64f8e63bddc72ee5$export$2e2bcd8739ae039), {
                        onClick: ()=>f(d + 1),
                        "aria-label": "Go to Next Page",
                        disabled: d >= u,
                        children: [
                            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                                name: "keyboard_arrow_right"
                            }),
                            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                                className: "sr-only",
                                children: "Next Page"
                            })
                        ]
                    })
                })
            ]
        })
    });
};







const $53016adf27947fee$export$db057d47bbb7479 = {
    cardWidth: 290,
    gapSize: 5,
    badgeHPadding: 16,
    plusBadgeWidth: 50,
    charWidth: 8
};


var $2addfe3a21b563c0$export$89da14300d534261;
var $2addfe3a21b563c0$export$4aebd143f31d0c0d;
var $2addfe3a21b563c0$export$34e0f9847d4c02dd;
var $2addfe3a21b563c0$export$60bb6c1f29b8a8cc;
var $2addfe3a21b563c0$export$3cd3724d2f91e9d3;
var $2addfe3a21b563c0$export$7061c75fc5af8b7e;
var $2addfe3a21b563c0$export$23f0e7c6834ceacd;
var $2addfe3a21b563c0$export$1237798dc640739a;
var $2addfe3a21b563c0$export$88a2d81d0c8e82d6;
$2addfe3a21b563c0$export$89da14300d534261 = `G-9BjG_active`;
$2addfe3a21b563c0$export$4aebd143f31d0c0d = `G-9BjG_badge`;
$2addfe3a21b563c0$export$34e0f9847d4c02dd = `G-9BjG_container`;
$2addfe3a21b563c0$export$60bb6c1f29b8a8cc = `G-9BjG_iconButton`;
$2addfe3a21b563c0$export$3cd3724d2f91e9d3 = `G-9BjG_inactive`;
$2addfe3a21b563c0$export$7061c75fc5af8b7e = `G-9BjG_item`;
$2addfe3a21b563c0$export$23f0e7c6834ceacd = `G-9BjG_itemContainer`;
$2addfe3a21b563c0$export$1237798dc640739a = `G-9BjG_label`;
$2addfe3a21b563c0$export$88a2d81d0c8e82d6 = `G-9BjG_valueItemContainer`;


const $3e0e4b81017c9d43$var$CONFIG = {
    'resources-setup-cards': {
        label: 'Queues',
        objectKey: 'queue'
    },
    'queues-setup-cards': {
        label: 'Resources',
        objectKey: 'resource'
    },
    'selectionLists-setup-cards': {
        label: 'Values',
        objectKey: 'values'
    },
    'actions-setup-cards': {
        label: 'Queue',
        objectKey: 'actionQueue'
    }
};
const $3e0e4b81017c9d43$export$8ad590f055f986be = ({ id: id, data: data, manageChildren: manageChildren })=>{
    const { resourceQueues: resourceQueues, values: values, queue: queue } = data;
    const dispatch = (0, $4e4c6c71fc2aaac8$export$f51d452c10d5b956)();
    const { label: label, objectKey: objectKey } = $3e0e4b81017c9d43$var$CONFIG[id] || {};
    const calculateVisibleTags = (maxRows = 4)=>{
        const CARD_WIDTH = (0, $53016adf27947fee$export$db057d47bbb7479).cardWidth;
        const GAP_SIZE = (0, $53016adf27947fee$export$db057d47bbb7479).gapSize;
        const BADGE_H_PADDING = (0, $53016adf27947fee$export$db057d47bbb7479).badgeHPadding;
        const PLUS_BADGE_WIDTH = (0, $53016adf27947fee$export$db057d47bbb7479).plusBadgeWidth;
        const CHAR_WIDTH = (0, $53016adf27947fee$export$db057d47bbb7479).charWidth;
        const tags = values || [];
        if (!tags.length) return tags.length;
        let currentWidth = 0;
        let currentRow = 1;
        let visibleCount = 0;
        for(let i = 0; i < tags.length; i++){
            // Calculate tag width (truncate at 25 chars to match rendering)
            const displayText = tags[i].description.length > 25 ? `${tags[i].description.slice(0, 25)}...` : tags[i].description;
            const tagWidth = Math.ceil(displayText.length * CHAR_WIDTH + BADGE_H_PADDING);
            // Add gap width if not first item in row
            const gapWidth = currentWidth > 0 ? GAP_SIZE : 0;
            const totalNeeded = currentWidth + gapWidth + tagWidth;
            // Check if we need to wrap to next row
            if (totalNeeded > CARD_WIDTH && currentWidth > 0) {
                currentRow++;
                currentWidth = tagWidth;
                // Stop if we've exceeded max rows
                if (currentRow > maxRows) break;
            } else currentWidth = totalNeeded;
            // On the last row, reserve space for "+N" badge if more items remain
            if (currentRow === maxRows && i < tags.length - 1) {
                const spaceNeededForBadge = currentWidth + GAP_SIZE + PLUS_BADGE_WIDTH;
                if (spaceNeededForBadge > CARD_WIDTH) break;
            }
            visibleCount++;
        }
        return visibleCount;
    };
    const visibleCount = calculateVisibleTags();
    const visibleTags = values?.slice(0, visibleCount);
    const hiddenCount = values?.length ? values.length - visibleCount : 0;
    if (!label || !objectKey) return null;
    /**
   * handles dynamic selection for resources and queues and then also selection list values
   */ const handleExtraButtonClick = ()=>{
        if (label === 'Resources' || label === 'Queues') dispatch({
            type: (0, $3b086af55ffdafb7$export$a6a3f8958140e326),
            payload: data.id
        });
        else if (label === 'Values') dispatch({
            type: (0, $3b086af55ffdafb7$export$ef84d9ae45b199a6),
            payload: data.id
        });
    };
    // check to see if we should render actions based on the values passed into this component
    const willRenderActions = resourceQueues || values || queue;
    return willRenderActions && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
        className: $2addfe3a21b563c0$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                className: $2addfe3a21b563c0$export$1237798dc640739a,
                children: [
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                        children: label
                    }),
                    manageChildren && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                            className: $2addfe3a21b563c0$export$60bb6c1f29b8a8cc,
                            color: "tertiary",
                            iconLeft: "assignment",
                            onClick: handleExtraButtonClick,
                            "aria-label": `Manage ${label}`
                        })
                    }),
                    queue && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                        className: $2addfe3a21b563c0$export$23f0e7c6834ceacd,
                        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                            className: `${$2addfe3a21b563c0$export$7061c75fc5af8b7e} ${$2addfe3a21b563c0$export$89da14300d534261}`,
                            children: queue.description
                        }, queue.id)
                    })
                ]
            }),
            resourceQueues && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                className: $2addfe3a21b563c0$export$23f0e7c6834ceacd,
                children: resourceQueues?.map((assignment)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                        className: `${$2addfe3a21b563c0$export$7061c75fc5af8b7e} ${assignment.active ? $2addfe3a21b563c0$export$89da14300d534261 : $2addfe3a21b563c0$export$3cd3724d2f91e9d3}`,
                        children: assignment[objectKey].description
                    }, assignment[objectKey].id))
            }),
            values && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                className: $2addfe3a21b563c0$export$23f0e7c6834ceacd,
                children: [
                    visibleTags?.map((assignment)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                            className: `${$2addfe3a21b563c0$export$7061c75fc5af8b7e} ${$2addfe3a21b563c0$export$89da14300d534261}`,
                            children: assignment.description.length > 25 ? `${assignment.description.slice(0, 25)}...` : assignment.description
                        }, assignment.id)),
                    hiddenCount > 0 && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                        className: `${$2addfe3a21b563c0$export$7061c75fc5af8b7e} ${$2addfe3a21b563c0$export$4aebd143f31d0c0d}`,
                        "aria-label": `${hiddenCount} more values`,
                        children: [
                            "+",
                            hiddenCount
                        ]
                    })
                ]
            })
        ]
    });
};


var $25895085ba7f3350$export$bbea856fdb3e3c5f;
var $25895085ba7f3350$export$aa3e815946b80764;
var $25895085ba7f3350$export$54df52f2b9f10b68;
var $25895085ba7f3350$export$b8bf98e4d70f4134;
var $25895085ba7f3350$export$f9417f756858637d;
var $25895085ba7f3350$export$34e0f9847d4c02dd;
var $25895085ba7f3350$export$6d59db4903f20f7d;
var $25895085ba7f3350$export$683472f6198a076e;
var $25895085ba7f3350$export$48db87e3f4768880;
var $25895085ba7f3350$export$9339cd5df48347a9;
var $25895085ba7f3350$export$3a3c5c2f733d37e3;
var $25895085ba7f3350$export$adb608be33961c98;
var $25895085ba7f3350$export$60bb6c1f29b8a8cc;
var $25895085ba7f3350$export$9635aeac4dcc4021;
var $25895085ba7f3350$export$fba0edcf8d30bc48;
var $25895085ba7f3350$export$b7e07c81ee4bc421;
var $25895085ba7f3350$export$a8ecead220dd38a6;
var $25895085ba7f3350$export$4765883fd82fa203;
var $25895085ba7f3350$export$75dd9d864eb27da7;
var $25895085ba7f3350$export$22fa394f3ba39578;
var $25895085ba7f3350$export$c69f739c940da70d;
var $25895085ba7f3350$export$65886d02a4001097;
var $25895085ba7f3350$export$80dab7518620b6bc;
var $25895085ba7f3350$export$5d43e637bbcd79;
var $25895085ba7f3350$export$b1b4a0f4541b40f0;
$25895085ba7f3350$export$bbea856fdb3e3c5f = `UYGNkq_buttons`;
$25895085ba7f3350$export$aa3e815946b80764 = `UYGNkq_card`;
$25895085ba7f3350$export$54df52f2b9f10b68 = `UYGNkq_cardContent`;
$25895085ba7f3350$export$b8bf98e4d70f4134 = `UYGNkq_cardHeader`;
$25895085ba7f3350$export$f9417f756858637d = `UYGNkq_cards`;
$25895085ba7f3350$export$34e0f9847d4c02dd = `UYGNkq_container slideRight`;
$25895085ba7f3350$export$6d59db4903f20f7d = `UYGNkq_description`;
$25895085ba7f3350$export$683472f6198a076e = `UYGNkq_disabled`;
$25895085ba7f3350$export$48db87e3f4768880 = `UYGNkq_fieldLabel`;
$25895085ba7f3350$export$9339cd5df48347a9 = `UYGNkq_fieldRow`;
$25895085ba7f3350$export$3a3c5c2f733d37e3 = `UYGNkq_fieldValue`;
$25895085ba7f3350$export$adb608be33961c98 = `UYGNkq_footer`;
$25895085ba7f3350$export$60bb6c1f29b8a8cc = `UYGNkq_iconButton`;
$25895085ba7f3350$export$9635aeac4dcc4021 = `UYGNkq_itemsPerPage`;
$25895085ba7f3350$export$fba0edcf8d30bc48 = `UYGNkq_itemsPerPageSelect`;
$25895085ba7f3350$export$b7e07c81ee4bc421 = `UYGNkq_itemsPerPageSelectContainer`;
$25895085ba7f3350$export$a8ecead220dd38a6 = `UYGNkq_message`;
$25895085ba7f3350$export$4765883fd82fa203 = `UYGNkq_nextPage slideLeft`;
$25895085ba7f3350$export$75dd9d864eb27da7 = `UYGNkq_pageInfo`;
$25895085ba7f3350$export$22fa394f3ba39578 = `UYGNkq_pagination`;
$25895085ba7f3350$export$c69f739c940da70d = `UYGNkq_prevPage slideRight`;
$25895085ba7f3350$export$65886d02a4001097 = `UYGNkq_secondaryHeader`;
$25895085ba7f3350$export$80dab7518620b6bc = `UYGNkq_sequenceContainer`;
$25895085ba7f3350$export$5d43e637bbcd79 = `UYGNkq_sequenceInput`;
$25895085ba7f3350$export$b1b4a0f4541b40f0 = `UYGNkq_statusSwitch`;


const $9778d67a2b14a7fd$var$PAGE_SIZES = [
    10,
    25,
    50
];
const $9778d67a2b14a7fd$export$c26f2fe42488a2a5 = ({ data: data, config: config })=>{
    const { id: id, pagination: pagination, fields: fields, childSetups: childSetups, strictConfirmDelete: strictConfirmDelete, manageChildren: manageChildren, onCopy: onCopy, onEdit: onEdit, onDelete: onDelete, onStatus: onStatus } = config;
    const { canDeleteSetups: canDeleteSetups } = (0, $df29add223039cb6$export$1d39dc5b47e56ff0)();
    const isMutating = (0, $7ac1884223ee487e$export$32cc39cf62abf4fc)();
    const [itemsPerPage, setItemsPerPage] = (0, $lCzvA.useState)(10);
    const [page, setPage] = (0, $lCzvA.useState)(1);
    const [pageTransition, setPageTransition] = (0, $lCzvA.useState)('');
    const [confirmData, setConfirmData] = (0, $lCzvA.useState)(/** @type {Local.SetupCardRecord | undefined} */ undefined);
    const totalItems = data?.length ?? 0;
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    // Clamp page to valid range during render - no useEffect needed!
    const validPage = pagination ? Math.min(Math.max(1, page), totalPages || 1) : 1;
    const startItemIndex = (page - 1) * itemsPerPage + 1;
    const endItemIndex = Math.min(page * itemsPerPage, totalItems);
    const paginatedData = pagination ? data?.slice((validPage - 1) * itemsPerPage, validPage * itemsPerPage) : data;
    /**
   * Handle delete action
   * @param {Local.SetupCardRecord} record - The record being deleted
   */ const handleOnDelete = (record)=>setConfirmData(record);
    /** Handle confirm delete action */ const handleConfirmDelete = ()=>{
        /* v8 ignore next */ if (onDelete && confirmData) onDelete(confirmData.id);
        setConfirmData(undefined);
    };
    /**
   * Handle page change with transition
   * @param {number} newPage - The new page number
   */ const handlePageChange = (newPage)=>{
        setPageTransition(newPage > page ? $25895085ba7f3350$export$4765883fd82fa203 : $25895085ba7f3350$export$c69f739c940da70d);
        setPage(newPage);
    };
    return paginatedData && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
        "data-testid": id,
        className: $25895085ba7f3350$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                className: `${$25895085ba7f3350$export$f9417f756858637d} ${pageTransition}`,
                children: paginatedData.map((record)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $482f79dfdc83e24d$export$2e2bcd8739ae039), {
                        "data-testid": `setup-card-${record.description}`,
                        className: `${$25895085ba7f3350$export$aa3e815946b80764} ${record.active === false ? $25895085ba7f3350$export$683472f6198a076e : ''}`,
                        children: [
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                className: ` ${$25895085ba7f3350$export$b8bf98e4d70f4134} ${record.values ? $25895085ba7f3350$export$65886d02a4001097 : ''}`,
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                                        className: $25895085ba7f3350$export$6d59db4903f20f7d,
                                        children: record.description
                                    }),
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                        className: $25895085ba7f3350$export$bbea856fdb3e3c5f,
                                        children: [
                                            onCopy && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                                                "data-testid": `setup-card-copy-${record.description}`,
                                                className: $25895085ba7f3350$export$60bb6c1f29b8a8cc,
                                                color: "tertiary",
                                                iconLeft: "content_copy",
                                                "aria-label": `Copy ${record.description}`,
                                                onClick: ()=>onCopy(record)
                                            }),
                                            onEdit && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                                                "data-testid": `setup-card-edit-${record.description}`,
                                                className: $25895085ba7f3350$export$60bb6c1f29b8a8cc,
                                                color: "tertiary",
                                                iconLeft: "edit_square",
                                                onClick: ()=>onEdit(record)
                                            }),
                                            onDelete && (!strictConfirmDelete || canDeleteSetups) && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                                                "data-testid": `setup-card-delete-${record.description}`,
                                                className: $25895085ba7f3350$export$60bb6c1f29b8a8cc,
                                                color: "tertiary",
                                                iconLeft: "delete",
                                                onClick: ()=>handleOnDelete(record)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            record?.message && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                                className: $25895085ba7f3350$export$a8ecead220dd38a6,
                                role: "note",
                                title: record.message,
                                "aria-label": "Setup message",
                                children: record.message
                            }),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                className: $25895085ba7f3350$export$54df52f2b9f10b68,
                                children: [
                                    onStatus && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                        className: $25895085ba7f3350$export$9339cd5df48347a9,
                                        children: [
                                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                                                className: $25895085ba7f3350$export$48db87e3f4768880,
                                                children: "Status"
                                            }),
                                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                                                className: $25895085ba7f3350$export$3a3c5c2f733d37e3,
                                                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $14c7f9d4c848135d$export$2e2bcd8739ae039), {
                                                    "data-testid": `status-switch-${record.description}`,
                                                    className: $25895085ba7f3350$export$b1b4a0f4541b40f0,
                                                    disabled: isMutating > 0,
                                                    onChange: ()=>onStatus(record),
                                                    checked: record.active
                                                })
                                            })
                                        ]
                                    }),
                                    fields.map(({ name: name, label: label })=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                            className: $25895085ba7f3350$export$9339cd5df48347a9,
                                            children: [
                                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                                                    className: $25895085ba7f3350$export$48db87e3f4768880,
                                                    children: label
                                                }),
                                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                                                    className: $25895085ba7f3350$export$3a3c5c2f733d37e3,
                                                    children: record[name]
                                                })
                                            ]
                                        }, name)),
                                    Boolean(childSetups) && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $3e0e4b81017c9d43$export$8ad590f055f986be), {
                                        id: id,
                                        data: record,
                                        manageChildren: manageChildren
                                    }),
                                    record?.sequence && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                        className: $25895085ba7f3350$export$80dab7518620b6bc,
                                        children: [
                                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                                                className: $25895085ba7f3350$export$48db87e3f4768880,
                                                children: "Sequence"
                                            }),
                                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                                                className: $25895085ba7f3350$export$3a3c5c2f733d37e3,
                                                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $67004894d25c93a4$export$2e2bcd8739ae039), {
                                                    className: $25895085ba7f3350$export$5d43e637bbcd79,
                                                    labelText: "",
                                                    id: `sequence-${record.id}`,
                                                    value: record.sequence,
                                                    disabled: true
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, `setup-card-${record.description}-${record.id}`))
            }, page),
            pagination && totalItems > 0 && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                "data-testid": `${id}-pagination`,
                className: $25895085ba7f3350$export$adb608be33961c98,
                children: [
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                        className: $25895085ba7f3350$export$9635aeac4dcc4021,
                        children: [
                            "Cards per page:",
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                                className: $25895085ba7f3350$export$b7e07c81ee4bc421,
                                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $c7e1b2c0ded2c83a$export$2e2bcd8739ae039), {
                                    className: $25895085ba7f3350$export$fba0edcf8d30bc48,
                                    id: "items-per-page-select",
                                    labelText: "",
                                    value: itemsPerPage,
                                    onChange: (e)=>setItemsPerPage(Number(e.target.value)),
                                    children: $9778d67a2b14a7fd$var$PAGE_SIZES.map((size)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                            value: size,
                                            children: size
                                        }, size))
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8511f9b574a7211c$export$2e2bcd8739ae039), {
                        className: $25895085ba7f3350$export$22fa394f3ba39578,
                        currentPage: page,
                        onPageChange: handlePageChange,
                        totalPages: totalPages
                    }),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                        className: $25895085ba7f3350$export$75dd9d864eb27da7,
                        children: [
                            "Displaying ",
                            startItemIndex,
                            "-",
                            endItemIndex,
                            " of ",
                            totalItems,
                            " items"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $cc8569db32917e4a$export$5cd181168bbef128), {
                isOpen: Boolean(confirmData),
                description: confirmData?.description,
                onConfirm: handleConfirmDelete,
                onCancel: ()=>setConfirmData(undefined),
                strictMessage: strictConfirmDelete
            })
        ]
    });
};


var $32beb564d9f5ee23$export$db2694f41e635e56;
var $32beb564d9f5ee23$export$a7db06668cad9adb;
var $32beb564d9f5ee23$export$fdb6003f772ae856;
var $32beb564d9f5ee23$export$4df8d4373bc60300;
var $32beb564d9f5ee23$export$c2947f539ebf7d9e;
var $32beb564d9f5ee23$export$2e6c959c16ff56b8;
var $32beb564d9f5ee23$export$3db7218f5d99c5f1;
$32beb564d9f5ee23$export$db2694f41e635e56 = `rs3CiW_assignButton`;
$32beb564d9f5ee23$export$a7db06668cad9adb = `rs3CiW_content`;
$32beb564d9f5ee23$export$fdb6003f772ae856 = `rs3CiW_doneButton`;
$32beb564d9f5ee23$export$4df8d4373bc60300 = `rs3CiW_drawer`;
$32beb564d9f5ee23$export$c2947f539ebf7d9e = `rs3CiW_drawerFooter`;
$32beb564d9f5ee23$export$2e6c959c16ff56b8 = `rs3CiW_select`;
$32beb564d9f5ee23$export$3db7218f5d99c5f1 = `rs3CiW_selectContainer`;


const $42e272e1492fd57b$export$43a53250b45693d6 = ({ data: data, type: type })=>{
    const dispatch = (0, $4e4c6c71fc2aaac8$export$f51d452c10d5b956)();
    const { selectedPlant: selectedPlant } = (0, $4e4c6c71fc2aaac8$export$fdc397e486fa83e7)();
    const { data: queues } = (0, $ecb41dbe4a35b139$export$ff160b5aaceed0b9)(selectedPlant, false);
    const { data: resources } = (0, $28b80451f4b2a75b$export$4e85cc9b40c906e6)(false);
    const { mutate: updateResourceQueue } = (0, $20cf428f647ff455$export$1f437390c1ed2be2)();
    const { mutate: createResourceQueue } = (0, $2d0e270541012399$export$487a51f0f407c060)();
    const { mutate: deleteResourceQueue } = (0, $cdb2ba9494631e7e$export$68b2ba9deca995b2)();
    const [selection, setSelection] = (0, $lCzvA.useState)('');
    const selectData = type === 'queue' ? queues : resources;
    const assignedIds = new Set(data?.resourceQueues?.map(({ id: id })=>id));
    const availableOptions = (selectData ?? []).filter((item)=>!assignedIds.has(item.id));
    const cardConfig = {
        id: 'resource-queue-drawer-setup-cards',
        onDelete: (id)=>deleteResourceQueue({
                queueId: type === 'queue' ? id : data?.id,
                resourceId: type === 'resource' ? id : data?.id
            }),
        onStatus: (record)=>{
            updateResourceQueue({
                queueId: record.queueId,
                resourceId: record.resourceId,
                active: !record.active
            });
        },
        fields: [
            {
                name: 'queueStatus',
                label: 'Assignment'
            }
        ]
    };
    /**
   * Handles changes to the selected queue or resource.
   * @param {React.ChangeEvent<HTMLSelectElement>} event - The change event object.
   * @returns {void}
   */ const handleSelectionChange = ({ target: { value: value } })=>{
        if (value) setSelection(value);
    };
    /** * Handles the drawer close action. */ const handleClose = ()=>{
        setSelection('');
        dispatch({
            type: (0, $3b086af55ffdafb7$export$a6a3f8958140e326),
            payload: ''
        });
    };
    /** * Handles the assign action. */ const handleAssign = ()=>{
        setSelection('');
        /* v8 ignore next */ if (data?.id) createResourceQueue({
            queueId: type === 'queue' ? selection : data.id,
            resourceId: type === 'resource' ? selection : data.id,
            queueStatus: 'PERMANENT'
        });
    };
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $667a2883fca669f9$export$2e2bcd8739ae039), {
        direction: (0, $ec4affac0c13709c$exports.isMobile) ? 'bottom' : 'right',
        open: Boolean(data?.id),
        onOpenChange: handleClose,
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $41db6ce8ffe5ef63$export$2e2bcd8739ae039), {
            titleText: `${type.toUpperCase()} ASSIGNMENTS`,
            showClose: false,
            children: [
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                    className: $32beb564d9f5ee23$export$a7db06668cad9adb,
                    children: [
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                            children: data?.description
                        }),
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                            className: $32beb564d9f5ee23$export$3db7218f5d99c5f1,
                            children: [
                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $c7e1b2c0ded2c83a$export$2e2bcd8739ae039), {
                                    className: $32beb564d9f5ee23$export$2e6c959c16ff56b8,
                                    id: "resource-queue-drawer-select",
                                    "data-testid": "resource-queue-drawer-select",
                                    labelText: `Select ${type}`,
                                    onChange: handleSelectionChange,
                                    value: selection,
                                    required: true,
                                    children: [
                                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                            value: "",
                                            children: "--- Select an Option ---"
                                        }),
                                        availableOptions.map((item)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                                value: item.id,
                                                children: item.description
                                            }, item.id))
                                    ]
                                }),
                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                                    "data-testid": `resource-queue-drawer-assign-${data?.id}`,
                                    className: $32beb564d9f5ee23$export$db2694f41e635e56,
                                    color: "primary",
                                    disabled: !selection,
                                    onClick: handleAssign,
                                    children: "ASSIGN"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $9778d67a2b14a7fd$export$c26f2fe42488a2a5), {
                            data: data?.resourceQueues,
                            config: cardConfig
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                    className: $32beb564d9f5ee23$export$c2947f539ebf7d9e,
                    children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                        "data-testid": `resource-queue-drawer-done-${data?.id}`,
                        className: $32beb564d9f5ee23$export$fdb6003f772ae856,
                        color: "primary",
                        onClick: handleClose,
                        children: "DONE"
                    })
                })
            ]
        })
    });
};




var $lCzvA = parcelRequire("lCzvA");



const $32860535e1e4a3d3$export$8d31ff5462fb38c = ({ open: open, close: close, data: data, selectedId: selectedId })=>{
    const { selectedPlant: selectedPlant } = (0, $1b0a542caa3229ca$export$b91a5355c3a5f338)();
    const { mutate: createSelectionList, isPending: isCreating } = (0, $7412b7161e90bcc9$export$1e0cdeee34c5891)();
    const { mutate: updateSelectionList, isPending: isUpdating } = (0, $fd854974fdc9e908$export$c285f387187f5d1b)();
    const [formChanges, setFormChanges] = (0, $lCzvA.useState)(/** @type {Partial<Pella.ProductionRequestAPI.CreateSelectionListInput>} */ {});
    const currentForm = selectedId ? data?.find((record)=>record.id === selectedId) : {
        active: true
    };
    // Combine initial data with form changes to get the current selection list state
    const selectionList = {
        ...currentForm,
        ...formChanges
    };
    const isEdit = Boolean(selectedId);
    /** Handler to reset form and close drawer */ const handleClose = ()=>{
        setFormChanges({});
        close();
    };
    /** handler for form submission */ const handleSubmit = ()=>{
        // Ensure all required fields are defined before mutation
        if (!isEdit) {
            const input = {
                plantId: selectedPlant,
                /* v8 ignore start */ description: selectionList.description || ''
            };
            createSelectionList(input, {
                onSuccess: handleClose
            });
        } else {
            const id = selectedId;
            const input = {
                description: selectionList.description
            };
            updateSelectionList({
                id: id,
                input: input
            }, {
                onSuccess: handleClose
            });
        }
    };
    const hasRequiredFields = Boolean(selectionList.description?.trim());
    const isLoading = isCreating || isUpdating;
    const disableSubmit = !hasRequiredFields || isLoading;
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $3f0ece51815fa43b$export$e7814354e1c15999), {
        open: open,
        close: handleClose,
        title: "Selection List",
        isEdit: isEdit,
        isCopy: false,
        onSubmit: handleSubmit,
        disableSubmit: disableSubmit,
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $67004894d25c93a4$export$2e2bcd8739ae039), {
            id: "selectionListNameInput",
            labelText: "Selection List Name",
            maxLength: 50,
            required: Boolean(!selectionList.description),
            value: selectionList.description || '',
            onChange: (e)=>setFormChanges((prev)=>({
                        ...prev,
                        description: e.target.value
                    }))
        })
    });
};





var $lCzvA = parcelRequire("lCzvA");



var $a34fced8f80caf3c$export$db2694f41e635e56;
var $a34fced8f80caf3c$export$a7db06668cad9adb;
var $a34fced8f80caf3c$export$fdb6003f772ae856;
var $a34fced8f80caf3c$export$c2947f539ebf7d9e;
var $a34fced8f80caf3c$export$caf37b18e66e7c16;
var $a34fced8f80caf3c$export$2e6c959c16ff56b8;
var $a34fced8f80caf3c$export$3db7218f5d99c5f1;
var $a34fced8f80caf3c$export$e58afdf725fe60f4;
$a34fced8f80caf3c$export$db2694f41e635e56 = `NWjhQG_assignButton`;
$a34fced8f80caf3c$export$a7db06668cad9adb = `NWjhQG_content`;
$a34fced8f80caf3c$export$fdb6003f772ae856 = `NWjhQG_doneButton`;
$a34fced8f80caf3c$export$c2947f539ebf7d9e = `NWjhQG_drawerFooter`;
$a34fced8f80caf3c$export$caf37b18e66e7c16 = `NWjhQG_modalFooter`;
$a34fced8f80caf3c$export$2e6c959c16ff56b8 = `NWjhQG_select`;
$a34fced8f80caf3c$export$3db7218f5d99c5f1 = `NWjhQG_selectContainer`;
$a34fced8f80caf3c$export$e58afdf725fe60f4 = `NWjhQG_valueItem`;




const $bc1b748342a2a1d8$export$baf2ecf24dade4f5 = (props)=>{
    const { data: data } = props;
    const dispatch = (0, $4e4c6c71fc2aaac8$export$f51d452c10d5b956)();
    const { mutate: createSelectionListValue } = (0, $9139ffa89529dce6$export$741daf16331cb4d6)();
    const [input, setInput] = (0, $lCzvA.useState)('');
    const [searchValue, setSearchValue] = (0, $lCzvA.useState)('');
    // Create a local copy of values to avoid mutating props
    const [localValues, setLocalValues] = (0, $lCzvA.useState)({});
    const updateSelectionListValue = (0, $4ee9563f5ddb2fe1$export$9aa3f57adcd789b2)();
    const deleteSelectionListValue = (0, $72d0e12ef7dd63ef$export$2deaa254a1893d57)();
    const [confirmData, setConfirmData] = (0, $lCzvA.useState)(/** @type {Local.SelectionListValue | undefined} */ undefined);
    const [handleUnsavedChangesOpen, setHandleUnsavedChangesOpen] = (0, $lCzvA.useState)(false);
    const filteredData = data?.values?.filter((item)=>item.description.toLowerCase().includes(searchValue.toLowerCase())) || [];
    /** * Handles the drawer close action. */ const handleClose = ()=>{
        if (localValues && Object.keys(localValues).length > 0) setHandleUnsavedChangesOpen(true);
        else {
            setInput('');
            dispatch({
                type: (0, $3b086af55ffdafb7$export$ef84d9ae45b199a6),
                payload: ''
            });
        }
    };
    const handleDiscardChanges = ()=>{
        setHandleUnsavedChangesOpen(false);
        setLocalValues({});
        setInput('');
        dispatch({
            type: (0, $3b086af55ffdafb7$export$ef84d9ae45b199a6),
            payload: ''
        });
    };
    /**
   * handles edit click and save
   * @param {string} valueId
   */ const handleEditClick = (valueId)=>{
        const editingValue = filteredData.find((v)=>v.id === valueId); // Ensure the value exists before allowing edit
        /* v8 ignore next */ if (editingValue) {
            // Use local value if it exists, otherwise fall back to original value
            const currentValue = localValues[valueId] ?? filteredData.find((v)=>v.id === valueId)?.description;
            updateSelectionListValue.mutate({
                id: valueId,
                input: {
                    description: currentValue
                }
            }, {
                onSuccess: ()=>{
                    // Remove the valueId from localValues once the update is complete
                    setLocalValues((prev)=>{
                        const updated = {
                            ...prev
                        };
                        delete updated[valueId];
                        return updated;
                    });
                }
            });
        }
    };
    /**
   * updates the value in the text input
   * @param {string} valueId
   * @param {string} newValue
   */ const handleEditInput = (valueId, newValue)=>{
        // Update local state instead of mutating props
        setLocalValues((prev)=>({
                ...prev,
                [valueId]: newValue
            }));
    };
    /**
   * Handle delete action
   * @param {Local.SelectionListValue} value - The value being deleted
   */ const handleOnDelete = (value)=>setConfirmData(value);
    /** Handle confirm delete action */ const handleConfirmDelete = ()=>{
        // I want to ts-ignore this. It will never happen that confirmData is undefined here, you cannot trigger this on a value that does not exist
        /* v8 ignore next */ if (confirmData?.id) {
            const valueId = confirmData.id;
            deleteSelectionListValue.mutate(confirmData.id, {
                onSuccess: ()=>{
                    // Remove the valueId from localValues once the update is complete
                    setLocalValues((prev)=>{
                        const updated = {
                            ...prev
                        };
                        delete updated[valueId];
                        return updated;
                    });
                }
            });
        }
        setConfirmData(undefined);
    };
    const handleCreateSelectionListValue = ()=>{
        /* v8 ignore next */ if (data?.id) createSelectionListValue({
            listId: data.id,
            description: input
        }, {
            onSuccess: ()=>{
                setInput('');
            }
        });
    };
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $667a2883fca669f9$export$2e2bcd8739ae039), {
        direction: (0, $ec4affac0c13709c$exports.isMobile) ? 'bottom' : 'right',
        open: Boolean(data?.id),
        onOpenChange: handleClose,
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $41db6ce8ffe5ef63$export$2e2bcd8739ae039), {
            titleText: "Selection List Value Assignment",
            showClose: false,
            children: [
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                    className: $a34fced8f80caf3c$export$a7db06668cad9adb,
                    children: [
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                            children: data?.description
                        }),
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                            className: $a34fced8f80caf3c$export$3db7218f5d99c5f1,
                            children: [
                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $67004894d25c93a4$export$2e2bcd8739ae039), {
                                    className: $a34fced8f80caf3c$export$2e6c959c16ff56b8,
                                    id: "selection-list-value-input",
                                    "data-testid": "selection-list-value-input",
                                    labelText: "Enter Value",
                                    onChange: (e)=>setInput(e.target.value),
                                    value: input,
                                    maxLength: 50,
                                    required: true
                                }),
                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                                    "data-testid": `selection-list-value-assign-${data?.id}`,
                                    className: $a34fced8f80caf3c$export$db2694f41e635e56,
                                    color: "primary",
                                    disabled: !input.trim(),
                                    onClick: handleCreateSelectionListValue,
                                    children: "Add Value"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $1ef686a537f3280d$export$55d7609a8f1eccd2), {
                    id: "selection-list-values-search-input",
                    searchValue: searchValue,
                    onChange: setSearchValue
                }),
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                    children: [
                        Boolean(filteredData?.length) && filteredData.map((value)=>{
                            // Use local value if it exists, otherwise use the original prop value
                            const displayValue = localValues[value.id] ?? value.description;
                            return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                className: $a34fced8f80caf3c$export$e58afdf725fe60f4,
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $67004894d25c93a4$export$2e2bcd8739ae039), {
                                        id: `selection-list-value-${value.description}`,
                                        labelText: "",
                                        value: displayValue,
                                        maxLength: 50,
                                        onChange: (e)=>handleEditInput(value.id, e.target.value),
                                        onKeyDown: (e)=>{
                                            if (e.key === 'Enter') handleEditClick(value.id);
                                        },
                                        iconRight: displayValue !== value.description && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                                            color: "tertiary",
                                            "aria-label": `Save ${displayValue}`,
                                            onClick: ()=>handleEditClick(value.id),
                                            "data-testid": `setup-card-edit-${value.description}`,
                                            children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                                                name: "check"
                                            })
                                        }),
                                        "aria-label": `Value ${displayValue}`
                                    }),
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                                        "data-testid": `setup-card-delete-${value.description}`,
                                        color: "tertiary",
                                        iconLeft: "delete",
                                        "aria-label": `Delete ${displayValue}`,
                                        onClick: ()=>handleOnDelete(value)
                                    })
                                ]
                            }, value.id);
                        }),
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $cc8569db32917e4a$export$5cd181168bbef128), {
                            isOpen: Boolean(confirmData),
                            description: confirmData?.description,
                            onConfirm: handleConfirmDelete,
                            onCancel: ()=>setConfirmData(undefined)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                    className: $a34fced8f80caf3c$export$c2947f539ebf7d9e,
                    children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                        "data-testid": `selection-list-value-done-${data?.id}`,
                        className: $a34fced8f80caf3c$export$fdb6003f772ae856,
                        color: "primary",
                        onClick: handleClose,
                        children: "CLOSE"
                    })
                }),
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $4d41d17efc15da0f$export$2e2bcd8739ae039), {
                    open: handleUnsavedChangesOpen,
                    children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $9dad852e7e98f87b$export$2e2bcd8739ae039), {
                        showClose: false,
                        children: [
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $9761f0447406a76c$export$2e2bcd8739ae039), {
                                children: "Unsaved Changes"
                            }),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $21eb14e493d0e28b$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("p", {
                                    children: "You have unsaved changes. Are you sure you want to close?"
                                })
                            }),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $861af07899c9769a$export$2e2bcd8739ae039), {
                                className: $a34fced8f80caf3c$export$caf37b18e66e7c16,
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                                        color: "secondary",
                                        onClick: ()=>setHandleUnsavedChangesOpen(false),
                                        children: "Cancel"
                                    }),
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                                        color: "primary",
                                        onClick: handleDiscardChanges,
                                        children: "Discard Changes"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};




var $lCzvA = parcelRequire("lCzvA");




var $8c54f4c624efda67$exports = {};

$parcel$export($8c54f4c624efda67$exports, "drawerHeader", function () { return $8c54f4c624efda67$export$f1896a92259c8c3; }, function (v) { return $8c54f4c624efda67$export$f1896a92259c8c3 = v; });
$parcel$export($8c54f4c624efda67$exports, "fieldGrid", function () { return $8c54f4c624efda67$export$f2b23536bd3f2969; }, function (v) { return $8c54f4c624efda67$export$f2b23536bd3f2969 = v; });
$parcel$export($8c54f4c624efda67$exports, "fullWidth", function () { return $8c54f4c624efda67$export$f59aa6be2711b90; }, function (v) { return $8c54f4c624efda67$export$f59aa6be2711b90 = v; });
$parcel$export($8c54f4c624efda67$exports, "inputPromptItem", function () { return $8c54f4c624efda67$export$cce309b063146d73; }, function (v) { return $8c54f4c624efda67$export$cce309b063146d73 = v; });
$parcel$export($8c54f4c624efda67$exports, "inputToggleItem", function () { return $8c54f4c624efda67$export$72102c5df8c3c86c; }, function (v) { return $8c54f4c624efda67$export$72102c5df8c3c86c = v; });
$parcel$export($8c54f4c624efda67$exports, "section", function () { return $8c54f4c624efda67$export$fe2e36411d703b3d; }, function (v) { return $8c54f4c624efda67$export$fe2e36411d703b3d = v; });
$parcel$export($8c54f4c624efda67$exports, "sectionTitle", function () { return $8c54f4c624efda67$export$1a952fe22cdce89e; }, function (v) { return $8c54f4c624efda67$export$1a952fe22cdce89e = v; });
$parcel$export($8c54f4c624efda67$exports, "selectItem", function () { return $8c54f4c624efda67$export$f26c97331adc89d5; }, function (v) { return $8c54f4c624efda67$export$f26c97331adc89d5 = v; });
$parcel$export($8c54f4c624efda67$exports, "toggleGrid", function () { return $8c54f4c624efda67$export$a90b4fb5d4905cdb; }, function (v) { return $8c54f4c624efda67$export$a90b4fb5d4905cdb = v; });
$parcel$export($8c54f4c624efda67$exports, "toggleItem", function () { return $8c54f4c624efda67$export$6e17316d08505db8; }, function (v) { return $8c54f4c624efda67$export$6e17316d08505db8 = v; });
var $8c54f4c624efda67$export$f1896a92259c8c3;
var $8c54f4c624efda67$export$f2b23536bd3f2969;
var $8c54f4c624efda67$export$f59aa6be2711b90;
var $8c54f4c624efda67$export$cce309b063146d73;
var $8c54f4c624efda67$export$72102c5df8c3c86c;
var $8c54f4c624efda67$export$fe2e36411d703b3d;
var $8c54f4c624efda67$export$1a952fe22cdce89e;
var $8c54f4c624efda67$export$f26c97331adc89d5;
var $8c54f4c624efda67$export$a90b4fb5d4905cdb;
var $8c54f4c624efda67$export$6e17316d08505db8;
$8c54f4c624efda67$export$f1896a92259c8c3 = `_8MzOwq_drawerHeader`;
$8c54f4c624efda67$export$f2b23536bd3f2969 = `_8MzOwq_fieldGrid`;
$8c54f4c624efda67$export$f59aa6be2711b90 = `_8MzOwq_fullWidth`;
$8c54f4c624efda67$export$cce309b063146d73 = `_8MzOwq_inputPromptItem`;
$8c54f4c624efda67$export$72102c5df8c3c86c = `_8MzOwq_inputToggleItem`;
$8c54f4c624efda67$export$fe2e36411d703b3d = `_8MzOwq_section`;
$8c54f4c624efda67$export$1a952fe22cdce89e = `_8MzOwq_sectionTitle`;
$8c54f4c624efda67$export$f26c97331adc89d5 = `_8MzOwq_selectItem`;
$8c54f4c624efda67$export$a90b4fb5d4905cdb = `_8MzOwq_toggleGrid`;
$8c54f4c624efda67$export$6e17316d08505db8 = `_8MzOwq_toggleItem`;


const $19f16bd966a0efe3$var$baseTenForSequence = 10;
/**
 * Validates the sequence input.
 * @param {string} value - The value to validate.
 * @returns {boolean} - True if there's an error, false otherwise.
 */ const $19f16bd966a0efe3$var$errorCheckSequence = (value)=>{
    const num = Number(value);
    return Number.isNaN(num) || num < 1 || num > 1000;
};
/**
 * Initial form error state for region location validation.
 * @type {{
 *   sequence: boolean,
 * }}
 */ const $19f16bd966a0efe3$var$initialFormErrors = {
    sequence: false
};
const $19f16bd966a0efe3$var$TRANSACTIONS_REQUIRING_INPUT = new Set([
    'DIRECT_ORG_TRANSFER',
    'SUB_INVENTORY_TRANSFER',
    'ISSUE_TO_LINE'
]);
/**
 * Validates the action form and returns an error message if invalid.
 * @param {Local.ActionFormData} form - The action form to validate.
 * @returns {string | null} - Error message if invalid, null if valid.
 */ const $19f16bd966a0efe3$var$validateActionForm = (form)=>{
    if (form.sequence < 1) return 'Sequence must be greater than 0';
    if (form.sequence > 1000) return 'Sequence must be less than or equal to 1000';
    const hasRequiredTransaction = form.transactionId ? $19f16bd966a0efe3$var$TRANSACTIONS_REQUIRING_INPUT.has(form.transactionId) : false;
    const hasInputOrList = form.selectionListId1 || form.showDynamicInput;
    // A query (with or without a transaction) requires input/selection list
    if (form.actionQuery && !hasInputOrList) return 'The selected transaction and or query type requires Input or Selection List to be enabled. Please enable one of these options or remove the transaction type to add this Action.';
    // A required transaction requires input/selection list
    if (hasRequiredTransaction && !hasInputOrList) return 'The selected transaction type requires Input or Selection List to be enabled. Please enable one of these options or remove the transaction type to add this Action.';
    return null; // Valid
};
/**
 * Validates that this Action has Input or Selection List enabled whenever the selected
 * Linked Action does, mirroring the server-side rule in actionValidation.js.
 * @param {Local.ActionFormData} form - The action form to validate.
 * @param {Pella.ProductionRequestAPI.Action | null | undefined} selectedLinkedAction - The resolved Linked Action, if one is selected.
 * @returns {string | null} - Error message if invalid, null if valid.
 */ const $19f16bd966a0efe3$var$validateLinkedAction = (form, selectedLinkedAction)=>{
    if (!selectedLinkedAction) return null;
    const linkedHasInputOrList = selectedLinkedAction.showDynamicInput || selectedLinkedAction.showSelectionList;
    const formHasInputOrList = form.showDynamicInput || form.showSelectionList;
    if (linkedHasInputOrList && !formHasInputOrList) return 'The Linked Action has Input or Selection List enabled. Input or Selection List must be enabled on this Action to assign the Linked Action.';
    return null; // Valid
};
const $19f16bd966a0efe3$export$887a481179b1e6e3 = ({ open: open, close: close, data: data, selectedId: selectedId, isCopyMode: isCopyMode })=>{
    const { data: actionData } = (0, $ad776647e9c1d561$export$2c2d2f5bd2673)(selectedId);
    const action = /** @type {Local.ActionWithLinkedAction | undefined} */ actionData;
    const { data: transactions } = (0, $7d486c73597e1de8$export$4127a74fddb92b6f)();
    const { data: dispositions } = (0, $c2668b8994f2b566$export$d48a51e4dd067ed2)();
    // State for user-modified form fields
    const [selectedQueuePlant, setSelectedQueuePlant] = (0, $lCzvA.useState)(/** @type {string | null} */ null);
    const [selectedQueuePlantQueue, setSelectedQueuePlantQueue] = (0, $lCzvA.useState)('');
    const [formChanges, setFormChanges] = (0, $lCzvA.useState)(/** @type {Partial<Local.ActionFormData>} */ {});
    const [formErrors, setFormErrors] = (0, $lCzvA.useState)($19f16bd966a0efe3$var$initialFormErrors);
    // The location-based record (from `data`, via getActionsByLocation) carries queueWithPlant.
    // getActionById (`action`) does not include the plant, so the plant must come from here.
    const editedRecord = selectedId ? data?.find((record)=>record.id === selectedId) : undefined;
    // Compute the effective queue plant ID for the queues hook
    const effectiveQueuePlantId = selectedQueuePlant !== null ? selectedQueuePlant : editedRecord?.queue?.plant?.id || '';
    const { data: queues } = (0, $ecb41dbe4a35b139$export$ff160b5aaceed0b9)(effectiveQueuePlantId, false);
    const isEdit = Boolean(selectedId && !isCopyMode);
    const { mutate: createAction, isPending: isCreating } = (0, $9b4f101bff843983$export$8b1589fe0122b5ad)();
    const { mutate: updateAction, isPending: isUpdating } = (0, $b266a688ef487de8$export$e864c217d7414c75)();
    const { selectedPlant: selectedPlant } = (0, $1b0a542caa3229ca$export$b91a5355c3a5f338)();
    const { selectedLocation: selectedLocation } = (0, $cfa58d15f42b8895$export$4ace3aee3488cfe3)();
    const [localSelectedPlant, setLocalSelectedPlant] = (0, $lCzvA.useState)(selectedPlant);
    const [localSelectedLocation, setLocalSelectedLocation] = (0, $lCzvA.useState)('');
    // Cascading selection for the action this action links to. Kept separate from the routing
    // selection above so linking can reach an action in any plant, not just the one being edited.
    // Sentinels start `null` (not '') so the effective values below can fall back to the loaded
    // action's own linked action until the user actually touches one of these selects.
    const [linkedActionPlant, setLinkedActionPlant] = (0, $lCzvA.useState)(/** @type {string | null} */ null);
    const [linkedActionLocation, setLinkedActionLocation] = (0, $lCzvA.useState)(/** @type {string | null} */ null);
    const [linkedActionId, setLinkedActionId] = (0, $lCzvA.useState)(/** @type {string | null} */ null);
    // Same pattern as effectiveQueuePlantId above: prefer the user's explicit selection, otherwise
    // fall back to the linked action already saved on the record being edited or copied.
    const effectiveLinkedActionPlant = linkedActionPlant !== null ? linkedActionPlant : action?.linkedAction?.location?.plant?.id || '';
    const effectiveLinkedActionLocation = linkedActionLocation !== null ? linkedActionLocation : action?.linkedAction?.location?.id || '';
    const effectiveLinkedActionId = linkedActionId !== null ? linkedActionId : action?.linkedActionId || '';
    const { data: plants } = (0, $e733424c31ecfe53$export$b22ebc4820923ca5)(true);
    const { data: locations } = (0, $e092467f6f60ca40$export$8535247f55db5d21)(true, localSelectedPlant);
    const { data: actions } = (0, $06f88e07f7e7fb66$export$bc923229a7fa61e7)({
        location: localSelectedLocation
    });
    const { data: selectionLists } = (0, $66aaaebf25667a49$export$5d27c0f97561cc97)(localSelectedPlant);
    const { data: linkedLocations } = (0, $e092467f6f60ca40$export$8535247f55db5d21)(true, effectiveLinkedActionPlant);
    // Deliberately unfiltered so that, until a linked location is picked, this shares a query with
    // the call above rather than fetching the same actions a second time. Active is filtered below.
    const { data: linkedActions } = (0, $06f88e07f7e7fb66$export$bc923229a7fa61e7)({
        location: effectiveLinkedActionLocation
    });
    // Both hooks fall back to the context plant/location when none is passed, so gate each list on
    // its own selection. An action cannot call itself, so drop the record being edited or copied.
    const linkedLocationOptions = effectiveLinkedActionPlant ? linkedLocations : [];
    const linkedActionOptions = effectiveLinkedActionLocation ? linkedActions?.filter((linked)=>linked.active && linked.id !== selectedId) : [];
    /**
   *  Reset state during render when switching between different actions or reopening
   */ const resetFormState = ()=>{
        setFormChanges({});
        setSelectedQueuePlant(null);
        setSelectedQueuePlantQueue('');
        setLocalSelectedPlant(selectedPlant);
        setLocalSelectedLocation('');
        setLinkedActionPlant(null);
        setLinkedActionLocation(null);
        setLinkedActionId(null);
    };
    /**
   * Calculate the default sequence based on current context.
   * In copy mode, starts empty until a location is selected, then uses the actions from that location.
   * Otherwise, uses the data prop.
   */ const defaultSequence = (()=>{
        if (isCopyMode) {
            // In copy mode, start with empty string until a location is selected
            if (!localSelectedLocation) return '';
            return actions ? actions.length * $19f16bd966a0efe3$var$baseTenForSequence + $19f16bd966a0efe3$var$baseTenForSequence : $19f16bd966a0efe3$var$baseTenForSequence;
        }
        return data ? data.length * $19f16bd966a0efe3$var$baseTenForSequence + $19f16bd966a0efe3$var$baseTenForSequence : $19f16bd966a0efe3$var$baseTenForSequence;
    })();
    // Spread `action` (getActionById) first so its showOnHoldReason and other dynamic fields
    // survive, then overlay `editedRecord` (getActionsByLocation) whose queue carries the plant.
    const currentForm = selectedId ? {
        ...action,
        ...editedRecord,
        ...isCopyMode && {
            sequence: defaultSequence
        }
    } : {
        active: true,
        // sequence always gets preset to length of data + 10. 5 actions means the next one is defaulted to 60
        sequence: defaultSequence,
        queueId: '',
        description: '',
        message: '',
        id: ''
    };
    // Combine initial data with form changes to get the current selection list state
    // Prioritize explicitly set queue changes, then fall back to state and existing data.
    // `editedRecord` is the last fallback so the Queue still displays when the direct
    // getActionById call is slow or unavailable — only the location record is guaranteed here.
    const queueId = 'queue' in formChanges ? formChanges.queue?.id : selectedQueuePlantQueue || action?.queue?.id || editedRecord?.queue?.id || '';
    // ActionFormData type - combines base form, changes, and queue state
    const actionForm = /** @type {Local.ActionFormData} */ {
        ...currentForm,
        ...formChanges,
        queue: {
            ...action?.queue,
            ...editedRecord?.queue,
            id: queueId
        }
    };
    /**
   * Handles input change events for the form.
   * @param {string} field - The name of the field being updated.
   * @param {string | number | boolean | object | null} value - The new value for the field. this type feels unhelpful due to the dynamic nature of the input
   */ const handleInputChange = (field, value)=>{
        setFormChanges((prev)=>({
                ...prev,
                [field]: value
            }));
    };
    /** Handler to reset form and close drawer */ const handleClose = ()=>{
        setFormErrors($19f16bd966a0efe3$var$initialFormErrors);
        resetFormState();
        close();
    };
    const hasRequiredFields = Boolean(actionForm.queue?.id && actionForm.message && actionForm.description && actionForm.sequence && (actionForm.showDynamicInput ? actionForm.actionPrompt : true) && (actionForm.showSelectionList ? actionForm.selectionListId1 : true) && (actionForm.transactionId === 'TRAILER_TO_DOCK' ? actionForm.dockSelectionListId : true) && (actionForm.transactionId === 'ISSUE_TO_LINE' ? actionForm.dispositionId : true) && (isCopyMode ? localSelectedLocation : true));
    const isLoading = isCreating || isUpdating;
    const disableSubmit = !hasRequiredFields || isLoading;
    /** handler for form submission */ const handleSubmit = ()=>{
        const selectedLinkedAction = effectiveLinkedActionId ? linkedActions?.find((linked)=>linked.id === effectiveLinkedActionId) : null;
        const validationError = $19f16bd966a0efe3$var$validateActionForm(actionForm) || $19f16bd966a0efe3$var$validateLinkedAction(actionForm, selectedLinkedAction);
        if (validationError) {
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).error(validationError);
            return;
        }
        const selectionList1 = actionForm?.selectionListId1?.length ? actionForm.selectionListId1 : null;
        const selectionList2 = actionForm?.selectionListId2?.length ? actionForm.selectionListId2 : null;
        const input = {
            active: actionForm.active,
            queueId: String(actionForm.queue?.id),
            message: actionForm.message,
            description: actionForm.description,
            locationId: isCopyMode ? localSelectedLocation : selectedLocation,
            sequence: Number(actionForm.sequence),
            showComment: actionForm.showComment ?? false,
            showQuantity: actionForm.showQuantity ?? false,
            showSelectionList: actionForm.showSelectionList ?? false,
            showDynamicInput: actionForm.showDynamicInput ?? false,
            isDefault: actionForm.isDefault ?? false,
            actionPrompt: actionForm.actionPrompt || null,
            selectionListId1: selectionList1,
            selectionListId2: selectionList2,
            transactionId: actionForm.transactionId || null,
            dockSelectionListId: actionForm.dockSelectionListId || null,
            dispositionId: actionForm.dispositionId ? Number(actionForm.dispositionId) : null,
            actionQuery: actionForm.actionQuery || null,
            showOnHoldReason: actionForm.showOnHoldReason ?? false,
            linkedActionId: effectiveLinkedActionId || null
        };
        if (!isEdit) createAction(input, {
            onSuccess: handleClose
        });
        else updateAction({
            id: selectedId,
            input: input
        }, {
            onSuccess: handleClose
        });
    };
    /**
   * Handles queue change event.
   * @param {React.ChangeEvent<HTMLInputElement | HTMLSelectElement>} e - The change event from the queue select input.
   */ const handleQueueChange = (e)=>{
        setSelectedQueuePlantQueue(e.target.value);
        handleInputChange('queue', {
            id: e.target.value
        });
    };
    /**
   * Updates the action form data state when an input changes.
   * @param {React.ChangeEvent<HTMLInputElement | HTMLSelectElement>} e - The change event from the input.
   */ const updateActionForm = (e)=>{
        const { name: name, value: value } = e.target;
        setFormChanges((prev)=>({
                ...prev,
                [name]: value
            }));
        /** @type {Record<string, (value: string) => boolean>} */ const errorFnMap = {
            sequence: $19f16bd966a0efe3$var$errorCheckSequence
        };
        setFormErrors((prev)=>({
                ...prev,
                [name]: errorFnMap[name](value)
            }));
    };
    /**
   * handles local plant change
   * @param {React.ChangeEvent<HTMLInputElement | HTMLSelectElement>} e
   */ const handlePlantChange = (e)=>{
        setLocalSelectedPlant(e.target.value);
        setLocalSelectedLocation(''); // Reset location when plant changes
    };
    /**
   * Handles location change and resets sequence to default for the new location
   * @param {React.ChangeEvent<HTMLInputElement | HTMLSelectElement>} e
   */ const handleLocationChange = (e)=>{
        setFormErrors($19f16bd966a0efe3$var$initialFormErrors);
        setLocalSelectedLocation(e.target.value);
        // Clear any manually set sequence so it recalculates from defaultSequence
        setFormChanges((prev)=>{
            const { sequence: sequence, ...rest } = prev;
            return rest;
        });
    };
    /**
   * Handles queue plant change to control queue values
   * @param {React.ChangeEvent<HTMLInputElement | HTMLSelectElement>} e - the change event from the queue plant select input
   */ const handleSelectedQueuePlantChange = (e)=>{
        setSelectedQueuePlant(e.target.value);
        setSelectedQueuePlantQueue('');
        handleInputChange('queue', {
            id: undefined
        });
    };
    /**
   * Handles the linked action plant change, clearing the location and action below it
   * @param {React.ChangeEvent<HTMLInputElement | HTMLSelectElement>} e - the change event from the linked action plant select input
   */ const handleLinkedActionPlantChange = (e)=>{
        setLinkedActionPlant(e.target.value);
        setLinkedActionLocation('');
        setLinkedActionId('');
    };
    /**
   * Handles the linked action location change, clearing the action below it
   * @param {React.ChangeEvent<HTMLInputElement | HTMLSelectElement>} e - the change event from the linked action location select input
   */ const handleLinkedActionLocationChange = (e)=>{
        setLinkedActionLocation(e.target.value);
        setLinkedActionId('');
    };
    /**
   * Handles dynamic input toggle, resetting the input prompt if disabling
   */ const handleDynamicInput = ()=>{
        if (actionForm.showDynamicInput) handleInputChange('actionPrompt', '');
        handleInputChange('showDynamicInput', !actionForm.showDynamicInput);
    };
    /**
   * handles selected selection lists when enabled/disabled
   */ const handleSelectionListActive = ()=>{
        handleInputChange('showSelectionList', !actionForm.showSelectionList);
        handleInputChange('selectionListId1', '');
        handleInputChange('selectionListId2', '');
    };
    /**
   * handles selection list change
   * @param {React.ChangeEvent<HTMLInputElement | HTMLSelectElement>} e
   * @param {number} listNumber
   */ const handleSelectionListChange = (e, listNumber)=>{
        if (listNumber === 1 && e.target.value === '') {
            handleInputChange('selectionListId1', '');
            handleInputChange('selectionListId2', '');
        } else handleInputChange(`selectionListId${listNumber}`, e.target.value);
    };
    /**
   * handles transaction change
   * @param {React.ChangeEvent<HTMLInputElement | HTMLSelectElement>} e
   */ const handleTransactionChange = (e)=>{
        setFormChanges((prev)=>({
                ...prev,
                transactionId: e.target.value,
                dockSelectionListId: '',
                dispositionId: ''
            }));
    };
    const handleOnHoldToggleChange = ()=>{
        handleInputChange('showOnHoldReason', !actionForm.showOnHoldReason);
    };
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $3f0ece51815fa43b$export$e7814354e1c15999), {
        open: open,
        close: handleClose,
        title: "Action",
        isEdit: isEdit,
        isCopy: isCopyMode,
        active: actionForm.active,
        onActiveChange: ()=>handleInputChange('active', !actionForm.active),
        onSubmit: handleSubmit,
        disableSubmit: disableSubmit,
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8c54f4c624efda67$exports))).section,
                children: [
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("h3", {
                        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($8c54f4c624efda67$exports))).sectionTitle} ${(0, (/*@__PURE__*/$parcel$interopDefault($8c54f4c624efda67$exports))).drawerHeader}`,
                        children: "Routing"
                    }),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8c54f4c624efda67$exports))).fieldGrid,
                        children: [
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $c7e1b2c0ded2c83a$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($8c54f4c624efda67$exports))).selectItem,
                                labelText: "Plant",
                                id: "PlantSelect",
                                "data-testid": "plantSelect",
                                value: isCopyMode ? localSelectedPlant : selectedPlant,
                                disabled: !isCopyMode,
                                onChange: handlePlantChange,
                                required: isCopyMode,
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                        value: "",
                                        children: "--- Select an Option ---"
                                    }),
                                    plants?.map((plant)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                            value: plant.id,
                                            children: plant.description
                                        }, plant.id))
                                ]
                            }),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $c7e1b2c0ded2c83a$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($8c54f4c624efda67$exports))).selectItem,
                                labelText: "Location",
                                id: "LocationSelect",
                                "data-testid": "locationSelect",
                                value: isCopyMode ? localSelectedLocation : selectedLocation,
                                disabled: !isCopyMode,
                                onChange: handleLocationChange,
                                required: isCopyMode,
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                        value: "",
                                        children: "--- Select an Option ---"
                                    }),
                                    locations?.map((location)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                            value: location.id,
                                            children: location.description
                                        }, location.id))
                                ]
                            }),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $c7e1b2c0ded2c83a$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($8c54f4c624efda67$exports))).selectItem,
                                labelText: "Queue Plant",
                                id: "QueuePlantSelect",
                                required: true,
                                value: effectiveQueuePlantId,
                                onChange: handleSelectedQueuePlantChange,
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                        value: "",
                                        children: "--- Select an Option ---"
                                    }),
                                    plants?.map((plant)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                            value: plant.id,
                                            children: plant.description
                                        }, plant.id))
                                ]
                            }),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $c7e1b2c0ded2c83a$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($8c54f4c624efda67$exports))).selectItem,
                                labelText: "Queue",
                                id: "QueueSelect",
                                required: true,
                                value: actionForm.queue?.id || '',
                                onChange: handleQueueChange,
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                        value: "",
                                        children: "--- Select an Option ---"
                                    }),
                                    queues?.map((queue)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                            value: queue.id,
                                            children: queue.description
                                        }, queue.id))
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8c54f4c624efda67$exports))).section,
                children: [
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("h3", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8c54f4c624efda67$exports))).sectionTitle,
                        children: "Display"
                    }),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8c54f4c624efda67$exports))).fieldGrid,
                        children: [
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $67004894d25c93a4$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($8c54f4c624efda67$exports))).selectItem,
                                labelText: "Name",
                                id: "NameInput",
                                required: true,
                                value: actionForm.description,
                                maxLength: 75,
                                onChange: (/** @type {React.ChangeEvent<HTMLInputElement>} */ e)=>setFormChanges((prev)=>({
                                            ...prev,
                                            description: e.target.value
                                        }))
                            }),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $67004894d25c93a4$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($8c54f4c624efda67$exports))).selectItem,
                                labelText: "Description",
                                id: "MessageInput",
                                required: true,
                                value: actionForm.message,
                                maxLength: 100,
                                onChange: (/** @type {React.ChangeEvent<HTMLInputElement>} */ e)=>setFormChanges((prev)=>({
                                            ...prev,
                                            message: e.target.value
                                        }))
                            }),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $67004894d25c93a4$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($8c54f4c624efda67$exports))).selectItem,
                                labelText: "Sequence",
                                id: "SequenceSelect",
                                name: "sequence",
                                value: actionForm.sequence,
                                type: "number",
                                onChange: updateActionForm,
                                error: formErrors.sequence ? 'Sequence must be greater than 0 and less than 1000' : undefined,
                                max: 1000
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8c54f4c624efda67$exports))).section,
                children: [
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("h3", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8c54f4c624efda67$exports))).sectionTitle,
                        children: "Inputs"
                    }),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8c54f4c624efda67$exports))).toggleGrid,
                        children: [
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($8c54f4c624efda67$exports))).toggleItem,
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                                        id: "commentToggleLabel",
                                        children: "Comment"
                                    }),
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $14c7f9d4c848135d$export$2e2bcd8739ae039), {
                                        "data-testid": "commentToggle",
                                        checked: actionForm.showComment,
                                        onChange: ()=>handleInputChange('showComment', !actionForm.showComment),
                                        "aria-labelledby": "commentToggleLabel"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($8c54f4c624efda67$exports))).toggleItem,
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                                        id: "onHoldToggleLabel",
                                        children: "On Hold Reason"
                                    }),
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $14c7f9d4c848135d$export$2e2bcd8739ae039), {
                                        "data-testid": "showOnHoldToggle",
                                        checked: Boolean(actionForm.showOnHoldReason),
                                        onChange: handleOnHoldToggleChange,
                                        "aria-labelledby": "onHoldToggleLabel"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($8c54f4c624efda67$exports))).toggleItem,
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                                        id: "selectionListToggleLabel",
                                        children: "Selection List"
                                    }),
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $14c7f9d4c848135d$export$2e2bcd8739ae039), {
                                        "data-testid": "selectionListToggle",
                                        checked: actionForm.showSelectionList,
                                        onChange: handleSelectionListActive,
                                        "aria-labelledby": "selectionListToggleLabel"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($8c54f4c624efda67$exports))).toggleItem,
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                                        id: "quantityToggleLabel",
                                        children: "Quantity"
                                    }),
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $14c7f9d4c848135d$export$2e2bcd8739ae039), {
                                        "data-testid": "quantityToggle",
                                        checked: actionForm.showQuantity,
                                        onChange: ()=>handleInputChange('showQuantity', !actionForm.showQuantity),
                                        "aria-labelledby": "quantityToggleLabel"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8c54f4c624efda67$exports))).fieldGrid,
                        children: [
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($8c54f4c624efda67$exports))).inputToggleItem,
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                                        id: "inputToggleLabel",
                                        children: "Input"
                                    }),
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $14c7f9d4c848135d$export$2e2bcd8739ae039), {
                                        "data-testid": "inputToggle",
                                        checked: actionForm.showDynamicInput,
                                        onChange: handleDynamicInput,
                                        "aria-labelledby": "inputToggleLabel"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $67004894d25c93a4$export$2e2bcd8739ae039), {
                                labelText: "Input Prompt",
                                id: "InputPromptInput",
                                required: actionForm.showDynamicInput,
                                value: actionForm?.actionPrompt || '',
                                maxLength: 25,
                                onChange: (/** @type {React.ChangeEvent<HTMLInputElement>} */ e)=>handleInputChange('actionPrompt', e.target.value),
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($8c54f4c624efda67$exports))).inputPromptItem,
                                disabled: !actionForm.showDynamicInput,
                                "data-testid": "inputPrompt"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8c54f4c624efda67$exports))).fieldGrid,
                        children: [
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $c7e1b2c0ded2c83a$export$2e2bcd8739ae039), {
                                labelText: "List 1",
                                id: "ListSelect1",
                                value: actionForm.selectionListId1 || '',
                                onChange: (e)=>handleSelectionListChange(e, 1),
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($8c54f4c624efda67$exports))).selectItem,
                                disabled: !actionForm.showSelectionList,
                                "aria-labelledby": "selectionListToggleLabel",
                                "data-testid": "listSelect1",
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                        value: "",
                                        children: "--- Select List 1 ---"
                                    }),
                                    selectionLists?.map((list)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                            value: list.id,
                                            children: list.description
                                        }, list.id))
                                ]
                            }),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $c7e1b2c0ded2c83a$export$2e2bcd8739ae039), {
                                labelText: "List 2",
                                id: "ListSelect2",
                                value: actionForm.selectionListId2 || '',
                                onChange: (e)=>handleSelectionListChange(e, 2),
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($8c54f4c624efda67$exports))).selectItem,
                                disabled: !actionForm.showSelectionList || actionForm.selectionListId1 === '',
                                "aria-labelledby": "selectionListToggleLabel",
                                "data-testid": "listSelect2",
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                        value: "",
                                        children: "--- None ---"
                                    }),
                                    selectionLists?.map((list)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                            value: list.id,
                                            children: list.description
                                        }, list.id))
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8c54f4c624efda67$exports))).section,
                children: [
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("h3", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8c54f4c624efda67$exports))).sectionTitle,
                        children: "Other"
                    }),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8c54f4c624efda67$exports))).fieldGrid,
                        children: [
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $c7e1b2c0ded2c83a$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($8c54f4c624efda67$exports))).selectItem,
                                labelText: "Transaction",
                                id: "TransactionSelect",
                                value: actionForm.transactionId || '',
                                onChange: handleTransactionChange,
                                "data-testid": "transactionSelect",
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                        value: "",
                                        children: "--- Select a Transaction ---"
                                    }),
                                    transactions?.map((transaction)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                            value: transaction.id,
                                            children: transaction.description
                                        }, transaction.id))
                                ]
                            }),
                            actionForm.transactionId === 'TRAILER_TO_DOCK' && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $c7e1b2c0ded2c83a$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($8c54f4c624efda67$exports))).selectItem,
                                labelText: "Dock Selection List",
                                id: "DockSelectionListSelect",
                                value: actionForm.dockSelectionListId || '',
                                onChange: (e)=>handleInputChange('dockSelectionListId', e.target.value),
                                "data-testid": "dockSelectionListSelect",
                                required: true,
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                        value: "",
                                        children: "Dock Selection List"
                                    }),
                                    selectionLists?.map((list)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                            value: list.id,
                                            children: list.description
                                        }, list.id))
                                ]
                            }),
                            actionForm.transactionId === 'ISSUE_TO_LINE' && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $c7e1b2c0ded2c83a$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($8c54f4c624efda67$exports))).selectItem,
                                labelText: "Issue To",
                                id: "IssueToSelect",
                                value: actionForm.dispositionId || '',
                                onChange: (e)=>handleInputChange('dispositionId', e.target.value),
                                "data-testid": "issueToSelect",
                                required: true,
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                        value: "",
                                        children: "Issue To"
                                    }),
                                    dispositions?.map((disposition)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                            value: disposition.dispositionId,
                                            children: disposition.description
                                        }, disposition.dispositionId))
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8c54f4c624efda67$exports))).fieldGrid,
                        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $c7e1b2c0ded2c83a$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($8c54f4c624efda67$exports))).selectItem,
                            labelText: "Query",
                            id: "QuerySelect",
                            "data-testid": "querySelect",
                            value: actionForm.actionQuery || '',
                            onChange: (e)=>handleInputChange('actionQuery', e.target.value),
                            children: [
                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                    value: "",
                                    children: "--- Query ---"
                                }),
                                (0, $917e2c0c66b65db1$export$da90eef90bb88aff)?.map((list)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                        value: list.id,
                                        children: list.description
                                    }, list.id))
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8c54f4c624efda67$exports))).section,
                children: [
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("h3", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8c54f4c624efda67$exports))).sectionTitle,
                        children: "Linked Action"
                    }),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8c54f4c624efda67$exports))).fieldGrid,
                        children: [
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $c7e1b2c0ded2c83a$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($8c54f4c624efda67$exports))).selectItem,
                                labelText: "Plant",
                                id: "LinkedActionPlantSelect",
                                "data-testid": "linkedActionPlantSelect",
                                value: effectiveLinkedActionPlant,
                                onChange: handleLinkedActionPlantChange,
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                        value: "",
                                        children: "--- Select an Option ---"
                                    }),
                                    plants?.map((plant)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                            value: plant.id,
                                            children: plant.description
                                        }, plant.id))
                                ]
                            }),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $c7e1b2c0ded2c83a$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($8c54f4c624efda67$exports))).selectItem,
                                labelText: "Location",
                                id: "LinkedActionLocationSelect",
                                "data-testid": "linkedActionLocationSelect",
                                value: effectiveLinkedActionLocation,
                                onChange: handleLinkedActionLocationChange,
                                disabled: !effectiveLinkedActionPlant,
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                        value: "",
                                        children: "--- Select an Option ---"
                                    }),
                                    linkedLocationOptions?.map((location)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                            value: location.id,
                                            children: location.description
                                        }, location.id))
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8c54f4c624efda67$exports))).fieldGrid,
                        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $c7e1b2c0ded2c83a$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($8c54f4c624efda67$exports))).selectItem,
                            labelText: "Action",
                            id: "LinkedActionSelect",
                            "data-testid": "linkedActionSelect",
                            value: effectiveLinkedActionId,
                            onChange: (e)=>setLinkedActionId(e.target.value),
                            disabled: !effectiveLinkedActionLocation,
                            children: [
                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                    value: "",
                                    children: "--- Select an Option ---"
                                }),
                                linkedActionOptions?.map((linked)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                        value: linked.id,
                                        children: linked.description
                                    }, linked.id))
                            ]
                        })
                    })
                ]
            })
        ]
    });
};




var $lCzvA = parcelRequire("lCzvA");





var $lCzvA = parcelRequire("lCzvA");

"use client";
//#region src/components/TextArea/index.jsx
var $27cc10959d191d67$export$2e2bcd8739ae039 = (0, $lCzvA.forwardRef)(function({ id: r, labelText: s, hideLabel: c, required: l, className: u, containerClass: d, assistiveText: f, error: p, helpText: m, tooltipContent: h, tooltipPosition: g = "bottom", rows: _ = 4, ...v }, y) {
    let b = (0, $lCzvA.useRef)(null), x = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-FormGroup relative mb-4": !0,
        [d]: d
    }), S = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-TextArea sash-input": !0,
        "border-red-700": p,
        [u]: u
    });
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
        ref: b,
        className: x,
        "data-testid": "sash-textarea",
        children: [
            (s || m || f) && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $353df793a3a1d2b7$export$2e2bcd8739ae039), {
                id: r,
                labelText: s,
                hideLabel: c,
                required: l,
                error: !!p,
                assistiveText: f,
                helpText: m,
                tooltipContent: h,
                tooltipPosition: g
            }),
            /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("textarea", {
                id: r,
                name: r,
                className: S,
                required: l,
                rows: _,
                ref: y,
                ...v
            }),
            typeof p == "string" && !!p && /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $71efe153e5175f41$export$2e2bcd8739ae039), {
                type: "error",
                className: "mt-2",
                message: p,
                inline: !0
            })
        ]
    });
});





var $598becb3ebbb3ade$export$31eb53bd5b582a97;
var $598becb3ebbb3ade$export$2ba01fb71ed41cb6;
var $598becb3ebbb3ade$export$36cc835d2490c0fc;
var $598becb3ebbb3ade$export$8360e631d277ea4d;
var $598becb3ebbb3ade$export$a7db06668cad9adb;
var $598becb3ebbb3ade$export$e8c9778bf415dd08;
var $598becb3ebbb3ade$export$4df8d4373bc60300;
var $598becb3ebbb3ade$export$c2947f539ebf7d9e;
var $598becb3ebbb3ade$export$c407db72103fecfa;
var $598becb3ebbb3ade$export$dd2a5bbc314d0fdd;
var $598becb3ebbb3ade$export$38e42c68cf43b5d4;
var $598becb3ebbb3ade$export$55abd4691b317664;
var $598becb3ebbb3ade$export$a80b3bd66acc52ff;
var $598becb3ebbb3ade$export$248a47518f3a0001;
var $598becb3ebbb3ade$export$af23384641a8ce52;
var $598becb3ebbb3ade$export$ddb906a32562356c;
$598becb3ebbb3ade$export$31eb53bd5b582a97 = `mVOQya_action`;
$598becb3ebbb3ade$export$2ba01fb71ed41cb6 = `mVOQya_button`;
$598becb3ebbb3ade$export$36cc835d2490c0fc = `mVOQya_charCount`;
$598becb3ebbb3ade$export$8360e631d277ea4d = `mVOQya_close`;
$598becb3ebbb3ade$export$a7db06668cad9adb = `mVOQya_content`;
$598becb3ebbb3ade$export$e8c9778bf415dd08 = `mVOQya_divider`;
$598becb3ebbb3ade$export$4df8d4373bc60300 = `mVOQya_drawer`;
$598becb3ebbb3ade$export$c2947f539ebf7d9e = `mVOQya_drawerFooter`;
$598becb3ebbb3ade$export$c407db72103fecfa = `mVOQya_entry`;
$598becb3ebbb3ade$export$dd2a5bbc314d0fdd = `mVOQya_entryText`;
$598becb3ebbb3ade$export$38e42c68cf43b5d4 = `mVOQya_header`;
$598becb3ebbb3ade$export$55abd4691b317664 = `mVOQya_history`;
$598becb3ebbb3ade$export$a80b3bd66acc52ff = `mVOQya_info`;
$598becb3ebbb3ade$export$248a47518f3a0001 = `mVOQya_inputWrapper`;
$598becb3ebbb3ade$export$af23384641a8ce52 = `mVOQya_requestor`;
$598becb3ebbb3ade$export$ddb906a32562356c = `mVOQya_user`;


/**
 * Orders a communication history newest-first. The stored array is append-ordered, so
 * entries sharing a timestamp fall back to reverse insertion order.
 * @param {Local.Communication[]} history - The stored communication history.
 * @returns {Local.Communication[]} The history ordered newest to oldest.
 */ const $391e9eeea212a43c$var$orderNewestFirst = (history)=>history.map((entry, index)=>({
            entry: entry,
            index: index
        })).toSorted((a, b)=>{
        const byTimestamp = new Date(b.entry.timeStamp).getTime() - new Date(a.entry.timeStamp).getTime();
        return byTimestamp || b.index - a.index;
    }).map(({ entry: entry })=>entry);
const $391e9eeea212a43c$export$68d442f0fd4a9251 = ({ open: open, close: close, request: request })=>{
    const [draft, setDraft] = (0, $lCzvA.useState)('');
    const { mutate: addCommunication, isPending: isPending, data: savedHistory } = (0, $3bf67ad161d7f6ff$export$64190e7a1f558fa0)();
    const communications = (0, $lCzvA.useMemo)(()=>{
        const stored = request.communications ?? [];
        // The mutation returns the full saved history, so a just-saved entry shows immediately
        // without waiting for the parent's cached request to flow back down.
        return $391e9eeea212a43c$var$orderNewestFirst(savedHistory ?? stored);
    }, [
        request,
        savedHistory
    ]);
    /** Closes the drawer, discarding any unsaved input. */ const handleClose = ()=>{
        setDraft('');
        close();
    };
    /** Saves the draft as a new communication and clears the input. */ const handleSave = ()=>{
        addCommunication({
            request: request,
            text: draft
        }, {
            onSuccess: ()=>setDraft('')
        });
    };
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $667a2883fca669f9$export$2e2bcd8739ae039), {
        direction: (0, $ec4affac0c13709c$exports.isMobile) ? 'bottom' : 'right',
        open: open,
        onOpenChange: handleClose,
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $41db6ce8ffe5ef63$export$2e2bcd8739ae039), {
            className: $598becb3ebbb3ade$export$4df8d4373bc60300,
            "data-testid": "communication-drawer",
            showClose: false,
            children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                className: $598becb3ebbb3ade$export$a7db06668cad9adb,
                children: [
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                        className: $598becb3ebbb3ade$export$38e42c68cf43b5d4,
                        children: [
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                className: $598becb3ebbb3ade$export$31eb53bd5b582a97,
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("b", {
                                        children: request.action.description
                                    }),
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                                        children: request.action.message
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("button", {
                                type: "button",
                                className: $598becb3ebbb3ade$export$8360e631d277ea4d,
                                "aria-label": "Close",
                                onClick: handleClose,
                                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                                    name: "close"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                        className: $598becb3ebbb3ade$export$af23384641a8ce52,
                        children: [
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                className: $598becb3ebbb3ade$export$a80b3bd66acc52ff,
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                                        name: "account_circle",
                                        size: 16,
                                        weight: 700
                                    }),
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                                        "data-testid": "communication-requestor",
                                        children: request.requestorId
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                className: $598becb3ebbb3ade$export$a80b3bd66acc52ff,
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                                        name: "schedule",
                                        size: 16,
                                        weight: 700
                                    }),
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                                        "data-testid": "communication-created",
                                        children: (0, $5f8e1c8d350f317e$export$5ede9312e237b505)(request.creationDate)
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                        className: $598becb3ebbb3ade$export$e8c9778bf415dd08
                    }),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                        className: $598becb3ebbb3ade$export$248a47518f3a0001,
                        children: [
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                className: $598becb3ebbb3ade$export$36cc835d2490c0fc,
                                "data-testid": "communication-char-count",
                                children: [
                                    draft.length,
                                    " / ",
                                    (0, $917e2c0c66b65db1$export$3b81987c7089d388)
                                ]
                            }),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $27cc10959d191d67$export$2e2bcd8739ae039), {
                                id: "communication-input",
                                "data-testid": "communication-input",
                                labelText: "Communication",
                                placeholder: "Add a communication here",
                                rows: 3,
                                value: draft,
                                maxLength: (0, $917e2c0c66b65db1$export$3b81987c7089d388),
                                onChange: (/** @type {React.ChangeEvent<HTMLTextAreaElement>} */ e)=>setDraft(e.target.value)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                        className: $598becb3ebbb3ade$export$c2947f539ebf7d9e,
                        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                            "data-testid": "saveCommunication",
                            className: $598becb3ebbb3ade$export$2ba01fb71ed41cb6,
                            color: "primary",
                            onClick: handleSave,
                            disabled: !draft.trim() || isPending,
                            children: "SAVE"
                        })
                    }),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                        className: $598becb3ebbb3ade$export$55abd4691b317664,
                        "data-testid": "communication-history",
                        children: communications.map((entry)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                className: $598becb3ebbb3ade$export$c407db72103fecfa,
                                "data-testid": "communication-entry",
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                                        className: $598becb3ebbb3ade$export$dd2a5bbc314d0fdd,
                                        children: entry.communication
                                    }),
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                        className: $598becb3ebbb3ade$export$a80b3bd66acc52ff,
                                        children: [
                                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                                                name: "account_circle",
                                                size: 16,
                                                weight: 700
                                            }),
                                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                                                className: $598becb3ebbb3ade$export$ddb906a32562356c,
                                                children: entry.userName
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                        className: $598becb3ebbb3ade$export$a80b3bd66acc52ff,
                                        children: [
                                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                                                name: "schedule",
                                                size: 16,
                                                weight: 700
                                            }),
                                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                                                children: (0, $5f8e1c8d350f317e$export$5ede9312e237b505)(entry.timeStamp)
                                            })
                                        ]
                                    })
                                ]
                            }, `${entry.timeStamp}-${entry.userName}-${entry.communication}`))
                    })
                ]
            })
        })
    });
};




var $lCzvA = parcelRequire("lCzvA");





var $3166eff862d209e6$export$2ba01fb71ed41cb6;
var $3166eff862d209e6$export$a7db06668cad9adb;
var $3166eff862d209e6$export$4df8d4373bc60300;
var $3166eff862d209e6$export$c2947f539ebf7d9e;
var $3166eff862d209e6$export$f2b23536bd3f2969;
var $3166eff862d209e6$export$f26c97331adc89d5;
$3166eff862d209e6$export$2ba01fb71ed41cb6 = `MBTlKa_button`;
$3166eff862d209e6$export$a7db06668cad9adb = `MBTlKa_content`;
$3166eff862d209e6$export$4df8d4373bc60300 = `MBTlKa_drawer`;
$3166eff862d209e6$export$c2947f539ebf7d9e = `MBTlKa_drawerFooter`;
$3166eff862d209e6$export$f2b23536bd3f2969 = `MBTlKa_fieldGrid`;
$3166eff862d209e6$export$f26c97331adc89d5 = `MBTlKa_selectItem`;


const $cc3900e0b33eaa8d$export$8fdf6417c0e7f3a4 = ({ open: open, close: close, request: request })=>{
    const [dock, setDock] = (0, $lCzvA.useState)('');
    const [carrierName, setCarrierName] = (0, $lCzvA.useState)('');
    const [trailerNumber, setTrailerNumber] = (0, $lCzvA.useState)('');
    const { selectedPlant: selectedPlant } = (0, $4e4c6c71fc2aaac8$export$fdc397e486fa83e7)();
    const { data: plants } = (0, $e733424c31ecfe53$export$b22ebc4820923ca5)(true);
    const { data: selectionLists } = (0, $66aaaebf25667a49$export$5d27c0f97561cc97)();
    const { data: carriers } = (0, $004d4894213cab40$export$6b066c5e566b5491)();
    const { mutate: updateRequest } = (0, $7a812fda41e7dd2d$export$f9e292527e05459d)();
    const { mutate: createTransaction, isPending: isPending } = (0, $ae628eefadf6a456$export$a0464a6f0ca2cc72)();
    const dockList = /** @type {Local.SelectionListWithValues | undefined} */ selectionLists?.find((list)=>list.id === request.action?.dockSelectionListId);
    const dockValues = dockList?.values ?? [];
    const plant = plants?.find((p)=>p.id === selectedPlant);
    const organizationCode = plant?.wmsOrgCode ?? '';
    const hasRequiredFields = Boolean(dock && carrierName && trailerNumber);
    const disableSubmit = !hasRequiredFields || isPending;
    /** Resets form state and closes the drawer */ const handleClose = ()=>{
        setDock('');
        setCarrierName('');
        setTrailerNumber('');
        close();
    };
    /**
   * Updates the request to Completed status and closes the drawer.
   * @param {(request: Pella.ProductionRequestAPI.Request, onSettled: () => void) => void} completeWithLinkedActionCheck
   * @param {string} errorMessage - Toast message shown if the status update fails.
   */ const handleCompleteRequest = (completeWithLinkedActionCheck, errorMessage)=>{
        completeWithLinkedActionCheck(request, ()=>updateRequest({
                id: request.id,
                status: (0, $917e2c0c66b65db1$export$b41c0f52c41112e3).COMPLETED
            }, {
                onSuccess: ()=>{
                    (0, $673b1c81cc441170$export$2e2bcd8739ae039).success('Request completed successfully!');
                    handleClose();
                },
                onError: ()=>{
                    (0, $673b1c81cc441170$export$2e2bcd8739ae039).error(errorMessage);
                }
            }));
    };
    /**
   * Posts the transaction to WMS then marks the request complete
   * @param {(request: Pella.ProductionRequestAPI.Request, onSettled: () => void) => void} completeWithLinkedActionCheck
   */ const handleSubmit = (completeWithLinkedActionCheck)=>{
        if (!organizationCode) {
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).error('Cannot submit: the selected plant does not have a WMS Org Code configured.');
            return;
        }
        createTransaction({
            dock: dock,
            organizationCode: organizationCode,
            trailerNumber: trailerNumber,
            carrierName: carrierName
        }, {
            onSuccess: ()=>handleCompleteRequest(completeWithLinkedActionCheck, 'Request completed in WMS but failed to update status. Please refresh.'),
            onError: ()=>{
                (0, $673b1c81cc441170$export$2e2bcd8739ae039).error('Error submitting Trailer To Dock transaction. Please try again.');
            }
        });
    };
    /**
   * Handles changes to the trailer number input field.
   * @param {React.ChangeEvent<HTMLInputElement>} e - The change event from the trailer number input field
   */ const handleTrailerNumberChange = (e)=>{
        setTrailerNumber(e.target.value);
    };
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $ee78c66814494e53$export$e8b1372a1b1babd1), {
        open: open,
        close: handleClose,
        request: request,
        disableSubmit: disableSubmit,
        onComplete: handleSubmit,
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
            className: $3166eff862d209e6$export$f2b23536bd3f2969,
            children: [
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $c7e1b2c0ded2c83a$export$2e2bcd8739ae039), {
                    className: $3166eff862d209e6$export$f26c97331adc89d5,
                    labelText: "Dock",
                    id: "DockSelect",
                    required: true,
                    value: dock,
                    onChange: (e)=>setDock(e.target.value),
                    "data-testid": "dock-select",
                    children: [
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                            value: "",
                            children: "--- Select a Dock ---"
                        }),
                        dockValues.map((value)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                value: value.description,
                                children: value.description
                            }, value.id))
                    ]
                }),
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $c7e1b2c0ded2c83a$export$2e2bcd8739ae039), {
                    className: $3166eff862d209e6$export$f26c97331adc89d5,
                    labelText: "Carrier",
                    id: "CarrierSelect",
                    required: true,
                    value: carrierName,
                    onChange: (e)=>setCarrierName(e.target.value),
                    "data-testid": "carrier-select",
                    children: [
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                            value: "",
                            children: "--- Select a Carrier ---"
                        }),
                        carriers?.map((carrier)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                value: carrier.carrierName,
                                children: carrier.carrierName
                            }, carrier.carrierId))
                    ]
                }),
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $67004894d25c93a4$export$2e2bcd8739ae039), {
                    labelText: "Trailer Number",
                    id: "TrailerNumberInput",
                    required: true,
                    value: trailerNumber,
                    maxLength: 25,
                    onChange: handleTrailerNumberChange,
                    "data-testid": "trailer-number-input"
                })
            ]
        })
    });
};








var $lCzvA = parcelRequire("lCzvA");
var $012d1223a241f244$export$f2b23536bd3f2969;
var $012d1223a241f244$export$f26c97331adc89d5;
$012d1223a241f244$export$f2b23536bd3f2969 = `BJ11kW_fieldGrid`;
$012d1223a241f244$export$f26c97331adc89d5 = `BJ11kW_selectItem`;



/**
 * Adjusts the subinventory information based on the transaction items.
 * Matches each transaction line to its source row by subinventory + row index rather than
 * item/lot/locator: the API can return multiple distinct rows with an identical item/lot/locator
 * triple (lot and locator are often null), so a data-field match would decrement every identical
 * row instead of only the one the user acted on.
 * @param {Pella.ProductionRequestAPI.GetSubinventoryInfoByPlantOutput[]} subinventoryInfo - The subinventory information
 * @param {Local.TransactionItem[]} transactionItems - The transaction items
 */ const $01196634a8a63789$export$d93a68bbb2b22bb = (subinventoryInfo, transactionItems)=>subinventoryInfo?.map((item, index)=>{
        const allocatedQuantity = transactionItems.filter((t)=>t.item === item.item && t.subinventoryCode === item.subinventoryCode && t.sourceRowIndex === index).reduce((sum, t)=>sum + t.transactionQuantity * -1, 0);
        return {
            ...item,
            unitOfIssueQoh: (item.unitOfIssueQoh || 0) - allocatedQuantity
        };
    }) ?? [];
const $01196634a8a63789$export$82f4e395113b7be8 = (items)=>items.map((item)=>({
            item: item.item,
            inventoryItemId: item.inventoryItemId,
            organizationId: item.organizationId,
            sourceHeaderId: item.sourceHeaderId,
            sourceLineId: item.sourceLineId,
            transactionSourceTypeId: item.transactionSourceTypeId,
            transactionQuantity: item.transactionQuantity,
            transactionTypeId: item.transactionTypeId,
            transactionUom: item.transactionUom,
            subinventoryCode: item.subinventoryCode,
            transferSubinventory: item.transferSubinventory,
            transferOrganization: item.transferOrganization,
            locatorId: item.locatorId,
            lotNumber: item.lotNumber,
            reasonId: item.reasonId,
            shipToLocationId: item.shipToLocationId,
            distributionAccountId: item.distributionAccountId,
            transactionSourceId: item.transactionSourceId,
            transferLocatorId: item.transferLocatorId
        }));


const $37e9db2a8d1862f9$export$45f0c1c7a7c62d48 = ({ open: open, close: close, request: request })=>{
    const { selectedPlant: selectedPlant } = (0, $4e4c6c71fc2aaac8$export$fdc397e486fa83e7)();
    const { mutate: createInvMgmtTransaction, isPending: isPending } = (0, $7152ad4b111d204a$export$f5fab7a78e2dc582)();
    const [selectedSubinventory, setSelectedSubinventory] = (0, $lCzvA.useState)('');
    const { mutate: updateRequest } = (0, $7a812fda41e7dd2d$export$f9e292527e05459d)();
    const { transactionItems: transactionItems, addQuantity: addQuantity, addFullLot: addFullLot, deleteItem: deleteItem } = (0, $3e76ed2cba8afd6c$export$e5c8a4886a3773bb)();
    const { data: plants } = (0, $e733424c31ecfe53$export$b22ebc4820923ca5)();
    const plant = plants?.find((p)=>p.id === selectedPlant);
    const organizationId = plant?.organizationId ?? 0;
    const inputValue = request?.dynamicInput ?? request?.dropDownListVal1 ?? request?.dropDownListVal2 ?? '';
    const { data: inventoryItem } = (0, $372ad8923d5d8867$export$876560882acfdee8)({
        item: inputValue,
        organizationId: organizationId
    });
    const inventoryItemId = inventoryItem?.[0]?.inventoryItemId;
    const { data: subinventoryCodes } = (0, $ffe511494037ae80$export$4482a79532cd20f8)({
        organizationId: organizationId,
        inventoryItemId: inventoryItemId ?? 0
    });
    const { data: subinventoryInfo } = (0, $2736244b396f7fe0$export$444d1ee1178b9ea0)({
        organizationId: organizationId,
        inventoryItemId: inventoryItemId ?? 0,
        subinventoryCode: selectedSubinventory
    });
    const uniqueSubinventoryCodes = [
        ...new Set(subinventoryCodes?.map((c)=>c.subinventoryCode))
    ];
    const adjustedSubinventoryInfo = (0, $01196634a8a63789$export$d93a68bbb2b22bb)(subinventoryInfo || [], transactionItems);
    /** Resets form state and closes the drawer */ const handleClose = ()=>{
        close();
    };
    /**
   * Updates the request to Completed status and closes the drawer.
   * @param {(request: Pella.ProductionRequestAPI.Request, onSettled: () => void) => void} completeWithLinkedActionCheck
   * @param {string} errorMessage - Toast message shown if the status update fails.
   */ const handleCompleteRequest = (completeWithLinkedActionCheck, errorMessage)=>{
        completeWithLinkedActionCheck(request, ()=>updateRequest({
                id: request.id,
                status: (0, $917e2c0c66b65db1$export$b41c0f52c41112e3).COMPLETED
            }, {
                onSuccess: ()=>{
                    (0, $673b1c81cc441170$export$2e2bcd8739ae039).success('Request completed successfully!');
                    handleClose();
                },
                onError: ()=>{
                    (0, $673b1c81cc441170$export$2e2bcd8739ae039).error(errorMessage);
                }
            }));
    };
    /**
   * Handles form submission
   * @param {(request: Pella.ProductionRequestAPI.Request, onSettled: () => void) => void} completeWithLinkedActionCheck
   */ const handleSubmit = (completeWithLinkedActionCheck)=>{
        const formattedTransactions = (0, $01196634a8a63789$export$82f4e395113b7be8)(transactionItems);
        createInvMgmtTransaction({
            orgId: organizationId,
            transactions: formattedTransactions
        }, {
            onSuccess: ()=>handleCompleteRequest(completeWithLinkedActionCheck, 'Request completed in WMS but failed to update status. Please refresh.'),
            onError: ()=>(0, $673b1c81cc441170$export$2e2bcd8739ae039).error('Failed to create inventory management transaction. Please try again.')
        });
    };
    const disableComplete = transactionItems.length === 0 || isPending;
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $ee78c66814494e53$export$e8b1372a1b1babd1), {
        disableSubmit: disableComplete,
        open: open,
        close: handleClose,
        onComplete: handleSubmit,
        request: request,
        children: [
            inventoryItem && inventoryItem.length > 0 && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                children: [
                    "Selected Org: ",
                    organizationId,
                    " ",
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("br", {}),
                    "Inventory Item ID: ",
                    inventoryItem[0]?.inventoryItemId,
                    " ",
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("br", {}),
                    "Requested Item: ",
                    inventoryItem[0]?.item,
                    " ",
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("br", {}),
                    "Description: ",
                    inventoryItem[0]?.description
                ]
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $c7e1b2c0ded2c83a$export$2e2bcd8739ae039), {
                    className: $012d1223a241f244$export$f26c97331adc89d5,
                    labelText: "Sub Inventory",
                    id: "SubinventorySelect",
                    required: true,
                    value: selectedSubinventory,
                    onChange: (e)=>setSelectedSubinventory(e.target.value),
                    "data-testid": "subinventory-select",
                    children: [
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                            value: "",
                            children: "Select a Subinventory"
                        }, ""),
                        uniqueSubinventoryCodes.map((code)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                value: code,
                                children: code
                            }, code))
                    ]
                })
            }),
            subinventoryInfo && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $17e58a04366b2100$export$a15adb8b4ec3e8f7), {
                subinventoryQtyInfo: adjustedSubinventoryInfo,
                onAddQuantity: (item, qty, index)=>addQuantity(item, qty, index, (0, $917e2c0c66b65db1$export$9831c7e6e3463b6e).ISSUE_TO_LINE, organizationId, request?.action?.dispositionId),
                onAddFullLot: (item, qty, index)=>addFullLot(item, qty, index, (0, $917e2c0c66b65db1$export$9831c7e6e3463b6e).ISSUE_TO_LINE, organizationId, request?.action?.dispositionId),
                transactionType: (0, $917e2c0c66b65db1$export$9831c7e6e3463b6e).ISSUE_TO_LINE,
                orgId: organizationId
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $886cdf6d2d94b94b$export$bfe088fef0a88dc9), {
                items: transactionItems,
                onDelete: deleteItem
            })
        ]
    });
};










var $lCzvA = parcelRequire("lCzvA");
var $8448d25c9b643217$export$f2b23536bd3f2969;
var $8448d25c9b643217$export$f26c97331adc89d5;
var $8448d25c9b643217$export$9fb37dd3c0ee904e;
$8448d25c9b643217$export$f2b23536bd3f2969 = `pCqguW_fieldGrid`;
$8448d25c9b643217$export$f26c97331adc89d5 = `pCqguW_selectItem`;
$8448d25c9b643217$export$9fb37dd3c0ee904e = `pCqguW_selectWrapper`;




const $adc77028baec7183$export$594b105c67e010a4 = ({ open: open, close: close, request: request })=>{
    const { selectedPlant: selectedPlant } = (0, $4e4c6c71fc2aaac8$export$fdc397e486fa83e7)();
    const { mutate: createInvMgmtTransaction, isPending: isPending } = (0, $7152ad4b111d204a$export$f5fab7a78e2dc582)();
    const { mutate: updateRequest } = (0, $7a812fda41e7dd2d$export$f9e292527e05459d)();
    const { transactionItems: transactionItems, addQuantity: addQuantity, addFullLot: addFullLot, deleteItem: deleteItem, reset: reset } = (0, $3e76ed2cba8afd6c$export$e5c8a4886a3773bb)();
    const [selectedSubinventoryFrom, setSelectedSubinventoryFrom] = (0, $lCzvA.useState)('');
    const [selectedSubinventoryTo, setSelectedSubinventoryTo] = (0, $lCzvA.useState)('');
    const [selectedLocator, setSelectedLocator] = (0, $lCzvA.useState)('');
    const { data: plants } = (0, $e733424c31ecfe53$export$b22ebc4820923ca5)();
    const plant = plants?.find((p)=>p.id === selectedPlant);
    const organizationId = plant?.organizationId ?? 0;
    const inputValue = request?.dynamicInput ?? request?.dropDownListVal1 ?? request?.dropDownListVal2 ?? '';
    const { data: inventoryItems } = (0, $372ad8923d5d8867$export$876560882acfdee8)({
        item: inputValue,
        organizationId: organizationId
    });
    const inventoryItemId = inventoryItems?.[0]?.inventoryItemId;
    const { data: fromSubinventoryCodes } = (0, $ffe511494037ae80$export$4482a79532cd20f8)({
        organizationId: organizationId,
        inventoryItemId: inventoryItemId ?? 0,
        qoh: 'Y'
    });
    const { data: toSubinventoryCodes } = (0, $ffe511494037ae80$export$4482a79532cd20f8)({
        organizationId: organizationId,
        inventoryItemId: inventoryItemId ?? 0,
        qoh: 'N'
    });
    const { data: locators, isSuccess: locatorsResolved } = (0, $893f6ef570e45856$export$d6b31c2d61f4cc8a)({
        organizationId: organizationId,
        inventoryItemId: inventoryItemId ?? 0,
        subinventoryCode: selectedSubinventoryTo
    });
    const { data: subinventoryInfo } = (0, $2736244b396f7fe0$export$444d1ee1178b9ea0)({
        organizationId: organizationId,
        inventoryItemId: inventoryItemId ?? 0,
        subinventoryCode: selectedSubinventoryFrom
    });
    const uniqueFromSubinventoryCodes = [
        ...new Set(fromSubinventoryCodes?.map((c)=>c.subinventoryCode))
    ];
    const uniqueToSubinventoryCodes = [
        ...new Set(toSubinventoryCodes?.map((c)=>c.subinventoryCode))
    ];
    const adjustedSubinventoryInfo = (0, $01196634a8a63789$export$d93a68bbb2b22bb)(subinventoryInfo || [], transactionItems);
    const selectedLocatorId = locators?.find((l)=>l.locator === selectedLocator)?.locatorId ?? null;
    const hasLocators = Array.isArray(locators) && locators.length > 0;
    const noDestinationSelected = !selectedSubinventoryTo || !locatorsResolved || hasLocators && !selectedLocator;
    const disableComplete = transactionItems.length === 0 || isPending;
    /** Resets form state and closes the drawer */ const handleClose = ()=>{
        setSelectedSubinventoryFrom('');
        setSelectedSubinventoryTo('');
        setSelectedLocator('');
        reset();
        close();
    };
    /**
   * Updates the request to Completed status and closes the drawer.
   * @param {(request: Pella.ProductionRequestAPI.Request, onSettled: () => void) => void} completeWithLinkedActionCheck
   * @param {string} errorMessage - Toast message shown if the status update fails.
   */ const handleCompleteRequest = (completeWithLinkedActionCheck, errorMessage)=>{
        completeWithLinkedActionCheck(request, ()=>updateRequest({
                id: request.id,
                status: (0, $917e2c0c66b65db1$export$b41c0f52c41112e3).COMPLETED
            }, {
                onSuccess: ()=>{
                    (0, $673b1c81cc441170$export$2e2bcd8739ae039).success('Request completed successfully!');
                    handleClose();
                },
                onError: ()=>{
                    (0, $673b1c81cc441170$export$2e2bcd8739ae039).error(errorMessage);
                }
            }));
    };
    /**
   * Handles form submission
   * @param {(request: Pella.ProductionRequestAPI.Request, onSettled: () => void) => void} completeWithLinkedActionCheck
   */ const handleSubmit = (completeWithLinkedActionCheck)=>{
        const formattedTransactions = (0, $01196634a8a63789$export$82f4e395113b7be8)(transactionItems.map((item)=>({
                ...item,
                transactionQuantity: Math.abs(item.transactionQuantity)
            })));
        createInvMgmtTransaction({
            orgId: organizationId,
            transactions: formattedTransactions
        }, {
            onSuccess: ()=>handleCompleteRequest(completeWithLinkedActionCheck, 'Request completed in WMS but failed to update status. Please refresh.'),
            onError: ()=>(0, $673b1c81cc441170$export$2e2bcd8739ae039).error('Failed to create inventory management transaction. Please try again.')
        });
    };
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $ee78c66814494e53$export$e8b1372a1b1babd1), {
        disableSubmit: disableComplete,
        open: open,
        close: handleClose,
        onComplete: handleSubmit,
        request: request,
        children: [
            inventoryItems && inventoryItems.length > 0 && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                children: [
                    "Selected Org: ",
                    organizationId,
                    " ",
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("br", {}),
                    "Inventory Item ID: ",
                    inventoryItems[0]?.inventoryItemId,
                    " ",
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("br", {}),
                    "Requested Item: ",
                    inventoryItems[0]?.item,
                    " ",
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("br", {}),
                    "Description: ",
                    inventoryItems[0]?.description
                ]
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                className: $8448d25c9b643217$export$f2b23536bd3f2969,
                children: [
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                        className: $8448d25c9b643217$export$9fb37dd3c0ee904e,
                        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $c7e1b2c0ded2c83a$export$2e2bcd8739ae039), {
                            className: $8448d25c9b643217$export$f26c97331adc89d5,
                            labelText: "Sub Inventory From",
                            id: "SubinventoryFromSelect",
                            required: true,
                            value: selectedSubinventoryFrom,
                            onChange: (e)=>setSelectedSubinventoryFrom(e.target.value),
                            "data-testid": "subinventory-from-select",
                            children: [
                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                    value: "",
                                    children: "Select a Subinventory"
                                }, ""),
                                uniqueFromSubinventoryCodes.map((code)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                        value: code,
                                        children: code
                                    }, code))
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                        className: $8448d25c9b643217$export$9fb37dd3c0ee904e,
                        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $c7e1b2c0ded2c83a$export$2e2bcd8739ae039), {
                            className: $8448d25c9b643217$export$f26c97331adc89d5,
                            labelText: "Sub Inventory To",
                            id: "SubinventoryToSelect",
                            required: true,
                            value: selectedSubinventoryTo,
                            onChange: (e)=>{
                                setSelectedSubinventoryTo(e.target.value);
                                setSelectedLocator('');
                            },
                            "data-testid": "subinventory-to-select",
                            children: [
                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                    value: "",
                                    children: "Select a Subinventory"
                                }, ""),
                                uniqueToSubinventoryCodes.map((code)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                        value: code,
                                        children: code
                                    }, code))
                            ]
                        })
                    }),
                    hasLocators && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                        className: $8448d25c9b643217$export$9fb37dd3c0ee904e,
                        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $c7e1b2c0ded2c83a$export$2e2bcd8739ae039), {
                            className: $8448d25c9b643217$export$f26c97331adc89d5,
                            labelText: "Location To",
                            id: "LocatorToSelect",
                            required: true,
                            value: selectedLocator,
                            onChange: (e)=>setSelectedLocator(e.target.value),
                            "data-testid": "locator-to-select",
                            children: [
                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                    value: "",
                                    children: "Select a Location"
                                }, ""),
                                locators?.map((value)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                        value: value.locator,
                                        children: value.locator
                                    }, value.locatorId))
                            ]
                        })
                    })
                ]
            }),
            subinventoryInfo && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $17e58a04366b2100$export$a15adb8b4ec3e8f7), {
                subinventoryQtyInfo: adjustedSubinventoryInfo,
                onAddQuantity: (item, qty, index)=>addQuantity(item, qty, index, (0, $917e2c0c66b65db1$export$9831c7e6e3463b6e).SUB_INVENTORY_TRANSFER, organizationId, undefined, selectedSubinventoryTo, selectedLocatorId),
                onAddFullLot: (item, qty, index)=>addFullLot(item, qty, index, (0, $917e2c0c66b65db1$export$9831c7e6e3463b6e).SUB_INVENTORY_TRANSFER, organizationId, undefined, selectedSubinventoryTo, selectedLocatorId),
                transactionType: (0, $917e2c0c66b65db1$export$9831c7e6e3463b6e).SUB_INVENTORY_TRANSFER,
                orgId: organizationId,
                disableAddQuantity: noDestinationSelected,
                disableAddFullLot: noDestinationSelected
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $886cdf6d2d94b94b$export$bfe088fef0a88dc9), {
                items: transactionItems,
                onDelete: deleteItem
            })
        ]
    });
};







var $lCzvA = parcelRequire("lCzvA");
var $d5350859b44cff42$export$f2b23536bd3f2969;
var $d5350859b44cff42$export$f26c97331adc89d5;
var $d5350859b44cff42$export$9fb37dd3c0ee904e;
$d5350859b44cff42$export$f2b23536bd3f2969 = `_948pEW_fieldGrid`;
$d5350859b44cff42$export$f26c97331adc89d5 = `_948pEW_selectItem`;
$d5350859b44cff42$export$9fb37dd3c0ee904e = `_948pEW_selectWrapper`;




const $fabf01b454a00596$export$281e033cb54aad33 = ({ open: open, close: close, request: request })=>{
    const [fromSubinventory, setFromSubinventory] = (0, $lCzvA.useState)('');
    const [toSubinventory, setToSubinventory] = (0, $lCzvA.useState)('');
    const [selectedLocator, setSelectedLocator] = (0, $lCzvA.useState)('');
    const { mutate: createInvMgmtTransaction, isPending: isPending } = (0, $7152ad4b111d204a$export$f5fab7a78e2dc582)();
    const { mutate: updateRequest } = (0, $7a812fda41e7dd2d$export$f9e292527e05459d)();
    const { data: plants } = (0, $e733424c31ecfe53$export$b22ebc4820923ca5)();
    const queuePlant = plants?.find((p)=>p.id === request?.action?.queue?.plantId);
    const queueOrgId = queuePlant?.organizationId ?? 0;
    const actionPlant = plants?.find((p)=>p.id === request?.action?.location?.plantId);
    const actionOrgId = actionPlant?.organizationId ?? 0;
    const inputValue = request?.dynamicInput ?? request?.dropDownListVal1 ?? request?.dropDownListVal2 ?? '';
    const { data: inventoryItem } = (0, $372ad8923d5d8867$export$876560882acfdee8)({
        item: inputValue,
        organizationId: queueOrgId
    });
    const { transactionItems: transactionItems, addQuantity: addQuantity, addFullLot: addFullLot, deleteItem: deleteItem } = (0, $3e76ed2cba8afd6c$export$e5c8a4886a3773bb)();
    const inventoryItemId = inventoryItem?.[0]?.inventoryItemId;
    const { data: queueSubinventoryCodes } = (0, $ffe511494037ae80$export$4482a79532cd20f8)({
        organizationId: queueOrgId,
        inventoryItemId: inventoryItemId ?? 0,
        qoh: 'Y'
    });
    const uniqueFromSubinventoryCodes = [
        ...new Set(queueSubinventoryCodes?.map((c)=>c.subinventoryCode))
    ];
    const { data: actionSubinventoryCodes } = (0, $ffe511494037ae80$export$4482a79532cd20f8)({
        organizationId: actionOrgId,
        inventoryItemId: inventoryItemId ?? 0,
        qoh: 'N'
    });
    const uniqueToSubinventoryCodes = [
        ...new Set(actionSubinventoryCodes?.map((c)=>c.subinventoryCode))
    ];
    const { data: subinventoryInfo } = (0, $2736244b396f7fe0$export$444d1ee1178b9ea0)({
        organizationId: queueOrgId,
        inventoryItemId: inventoryItemId ?? 0,
        subinventoryCode: fromSubinventory
    });
    const { data: locators } = (0, $893f6ef570e45856$export$d6b31c2d61f4cc8a)({
        organizationId: actionOrgId,
        inventoryItemId: inventoryItemId ?? 0,
        subinventoryCode: toSubinventory
    });
    const adjustedSubinventoryInfo = (0, $01196634a8a63789$export$d93a68bbb2b22bb)(subinventoryInfo || [], transactionItems);
    /** Resets form state and closes the drawer */ const handleClose = ()=>{
        close();
    };
    /**
   * Updates the request to Completed status and closes the drawer.
   * @param {(request: Pella.ProductionRequestAPI.Request, onSettled: () => void) => void} completeWithLinkedActionCheck
   * @param {string} errorMessage - Toast message shown if the status update fails.
   */ const handleCompleteRequest = (completeWithLinkedActionCheck, errorMessage)=>{
        completeWithLinkedActionCheck(request, ()=>updateRequest({
                id: request.id,
                status: (0, $917e2c0c66b65db1$export$b41c0f52c41112e3).COMPLETED
            }, {
                onSuccess: ()=>{
                    (0, $673b1c81cc441170$export$2e2bcd8739ae039).success('Request completed successfully!');
                    handleClose();
                },
                onError: ()=>{
                    (0, $673b1c81cc441170$export$2e2bcd8739ae039).error(errorMessage);
                }
            }));
    };
    /**
   * Handles form submission
   * @param {(request: Pella.ProductionRequestAPI.Request, onSettled: () => void) => void} completeWithLinkedActionCheck
   */ const handleSubmit = (completeWithLinkedActionCheck)=>{
        const formattedTransactions = (0, $01196634a8a63789$export$82f4e395113b7be8)(transactionItems.map((item)=>({
                ...item,
                transferSubinventory: toSubinventory,
                transferOrganization: actionOrgId,
                transferLocatorId: selectedLocator === '' ? null : Number(selectedLocator)
            })));
        createInvMgmtTransaction({
            orgId: queueOrgId,
            transactions: formattedTransactions
        }, {
            onSuccess: ()=>handleCompleteRequest(completeWithLinkedActionCheck, 'Request completed in WMS but failed to update status. Please refresh.'),
            onError: ()=>(0, $673b1c81cc441170$export$2e2bcd8739ae039).error('Failed to create inventory management transaction. Please try again.')
        });
    };
    const disableComplete = transactionItems.length === 0 || isPending;
    const disableAddQuantity = !fromSubinventory || !toSubinventory || (!locators?.length ? false : !selectedLocator);
    const disableAddFullLot = !fromSubinventory || !toSubinventory || (!locators?.length ? false : !selectedLocator);
    /**
   * Handles changes to the "To Subinventory" select input.
   * @param {React.ChangeEvent<HTMLSelectElement>} e - The change event.
   */ const handleToSubinventoryChange = (e)=>{
        setToSubinventory(e.target.value);
        setSelectedLocator('');
    };
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $ee78c66814494e53$export$e8b1372a1b1babd1), {
        disableSubmit: disableComplete,
        open: open,
        close: handleClose,
        request: request,
        onComplete: handleSubmit,
        children: [
            inventoryItem && inventoryItem.length > 0 && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                children: [
                    "Selected Org: ",
                    actionOrgId,
                    " ",
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("br", {}),
                    "Inventory Item ID: ",
                    inventoryItem[0]?.inventoryItemId,
                    " ",
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("br", {}),
                    "Requested Item: ",
                    inventoryItem[0]?.item,
                    " ",
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("br", {}),
                    "Description: ",
                    inventoryItem[0]?.description
                ]
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                className: $d5350859b44cff42$export$f2b23536bd3f2969,
                children: [
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                        className: $d5350859b44cff42$export$9fb37dd3c0ee904e,
                        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $c7e1b2c0ded2c83a$export$2e2bcd8739ae039), {
                            className: $d5350859b44cff42$export$f26c97331adc89d5,
                            labelText: "From Sub Inventory",
                            id: "FromSubinventorySelect",
                            required: true,
                            value: fromSubinventory,
                            onChange: (e)=>setFromSubinventory(e.target.value),
                            "data-testid": "from-subinventory-select",
                            children: [
                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                    value: "",
                                    children: "Select a Subinventory"
                                }, ""),
                                uniqueFromSubinventoryCodes?.map((code)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                        value: code,
                                        children: code
                                    }, code))
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                        className: $d5350859b44cff42$export$9fb37dd3c0ee904e,
                        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $c7e1b2c0ded2c83a$export$2e2bcd8739ae039), {
                            className: $d5350859b44cff42$export$f26c97331adc89d5,
                            labelText: "To Sub Inventory",
                            id: "ToSubinventorySelect",
                            required: true,
                            value: toSubinventory,
                            onChange: handleToSubinventoryChange,
                            "data-testid": "to-subinventory-select",
                            children: [
                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                    value: "",
                                    children: "Select a Subinventory"
                                }, ""),
                                uniqueToSubinventoryCodes?.map((code)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                        value: code,
                                        children: code
                                    }, code))
                            ]
                        })
                    }),
                    locators && locators.length > 0 && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                        className: $d5350859b44cff42$export$9fb37dd3c0ee904e,
                        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $c7e1b2c0ded2c83a$export$2e2bcd8739ae039), {
                            className: $d5350859b44cff42$export$f26c97331adc89d5,
                            labelText: "Location To",
                            id: "LocatorToSelect",
                            required: true,
                            value: selectedLocator,
                            onChange: (e)=>setSelectedLocator(e.target.value),
                            "data-testid": "locator-to-select",
                            children: [
                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                    value: "",
                                    children: "Select a Location"
                                }, ""),
                                locators.map((value)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                        value: value.locatorId,
                                        children: value.locator
                                    }, value.locatorId))
                            ]
                        })
                    })
                ]
            }),
            subinventoryInfo && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $17e58a04366b2100$export$a15adb8b4ec3e8f7), {
                subinventoryQtyInfo: adjustedSubinventoryInfo,
                onAddQuantity: addQuantity,
                onAddFullLot: addFullLot,
                transactionType: (0, $917e2c0c66b65db1$export$9831c7e6e3463b6e).DIRECT_ORG_TRANSFER,
                orgId: queueOrgId,
                disableAddFullLot: disableAddFullLot,
                disableAddQuantity: disableAddQuantity
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $886cdf6d2d94b94b$export$bfe088fef0a88dc9), {
                items: transactionItems,
                onDelete: deleteItem
            })
        ]
    });
};








var $e1963ce1c39096aa$export$8360e631d277ea4d;
var $e1963ce1c39096aa$export$38e42c68cf43b5d4;
var $e1963ce1c39096aa$export$96e4b36520c26a2c;
var $e1963ce1c39096aa$export$e7d29f2667095d20;
var $e1963ce1c39096aa$export$653523807df144ac;
var $e1963ce1c39096aa$export$fb184b623420d9be;
$e1963ce1c39096aa$export$8360e631d277ea4d = `DO0_Qq_close`;
$e1963ce1c39096aa$export$38e42c68cf43b5d4 = `DO0_Qq_header`;
$e1963ce1c39096aa$export$96e4b36520c26a2c = `DO0_Qq_modal`;
$e1963ce1c39096aa$export$e7d29f2667095d20 = `DO0_Qq_reasonButton`;
$e1963ce1c39096aa$export$653523807df144ac = `DO0_Qq_reasons`;
$e1963ce1c39096aa$export$fb184b623420d9be = `DO0_Qq_title`;


const $9d34422acf608041$export$ce2e9a3a523cbee8 = ({ open: open, close: close, onSelectReason: onSelectReason })=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $4d41d17efc15da0f$export$2e2bcd8739ae039), {
        open: open,
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $9dad852e7e98f87b$export$2e2bcd8739ae039), {
            "data-testid": "on-hold-reason-modal",
            effect: "scale-up",
            showClose: false,
            fullScreen: (0, $ec4affac0c13709c$exports.isMobile),
            className: $e1963ce1c39096aa$export$96e4b36520c26a2c,
            children: [
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $9761f0447406a76c$export$2e2bcd8739ae039), {
                    className: $e1963ce1c39096aa$export$38e42c68cf43b5d4,
                    children: [
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                            className: $e1963ce1c39096aa$export$fb184b623420d9be,
                            children: "On Hold Reason"
                        }),
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("button", {
                            type: "button",
                            className: $e1963ce1c39096aa$export$8360e631d277ea4d,
                            "aria-label": "Close",
                            onClick: close,
                            children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                                name: "close"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $21eb14e493d0e28b$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                        className: $e1963ce1c39096aa$export$653523807df144ac,
                        children: Object.values((0, $917e2c0c66b65db1$export$707abb74bd20046)).map((reason)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                                color: "secondary",
                                className: $e1963ce1c39096aa$export$e7d29f2667095d20,
                                onClick: ()=>onSelectReason(reason),
                                children: reason
                            }, reason))
                    })
                })
            ]
        })
    });





var $f0da3fc2fb8416e0$export$2ba01fb71ed41cb6;
var $f0da3fc2fb8416e0$export$55707c0a378c7842;
var $f0da3fc2fb8416e0$export$e3f249883af4c8de;
var $f0da3fc2fb8416e0$export$2f2e370840b7c52f;
var $f0da3fc2fb8416e0$export$69d29e136ee29908;
var $f0da3fc2fb8416e0$export$8a8dcba53dc3c44e;
$f0da3fc2fb8416e0$export$2ba01fb71ed41cb6 = `GhiIfG_button`;
$f0da3fc2fb8416e0$export$55707c0a378c7842 = `GhiIfG_communicationButton`;
$f0da3fc2fb8416e0$export$e3f249883af4c8de = `GhiIfG_communicationButtonContent`;
$f0da3fc2fb8416e0$export$2f2e370840b7c52f = `GhiIfG_totalBadgeCorner`;
$f0da3fc2fb8416e0$export$69d29e136ee29908 = `GhiIfG_totalBadgeNeutral`;
$f0da3fc2fb8416e0$export$8a8dcba53dc3c44e = `GhiIfG_totalBadgeUnread`;


const $60c0fb95698f3b88$export$8fda2956f7bfe17 = ({ request: request })=>{
    const { pathname: pathname } = (0, $ebc812b73151cba1$export$45d76561a5302f2b)();
    const { userid: userid } = (0, $3bd970bfc6bd9362$export$3901076af3749fa9)();
    const isWorklist = pathname === '/worklist';
    const isRequest = pathname === '/request';
    const [openTransactionDrawer, setOpenTransactionDrawer] = (0, $lCzvA.useState)(false);
    const [openHoldModal, setOpenHoldModal] = (0, $lCzvA.useState)(false);
    const [openCommunicationDrawer, setOpenCommunicationDrawer] = (0, $lCzvA.useState)(false);
    const { mutate: mutate } = (0, $7a812fda41e7dd2d$export$f9e292527e05459d)();
    const { mutateAsync: markAsRead } = (0, $86776d4a0b45dc41$export$25c133294c88728d)();
    const { completeWithLinkedActionCheck: completeWithLinkedActionCheck, isLinkedActionPromptOpen: isLinkedActionPromptOpen, linkedActionDescription: linkedActionDescription, onDecline: onDecline, onConfirm: onConfirm } = (0, $63b0984325adb4a7$export$8ad014c5646c5871)();
    const { 'communication-button': communicationButton } = (0, $fda7e4dd83174a6e$export$2879604e6aec4ab)([
        'communication-button'
    ]);
    const communicationButtonEnabled = communicationButton.enabled;
    const { total: total, unread: unread } = (0, $5f8e1c8d350f317e$export$6d608348c3a90609)(request, userid);
    const hasUnread = unread > 0;
    const totalBadgeLabel = hasUnread ? `Total communications: ${total}. Unread communications: ${unread}` : `Total communications: ${total}. No unread communications`;
    const totalBadgeStateClass = hasUnread ? $f0da3fc2fb8416e0$export$8a8dcba53dc3c44e : $f0da3fc2fb8416e0$export$69d29e136ee29908;
    const communicationButtonLabel = /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("span", {
        className: $f0da3fc2fb8416e0$export$e3f249883af4c8de,
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                children: "Communication"
            }),
            total > 0 && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                className: `${$f0da3fc2fb8416e0$export$2f2e370840b7c52f} ${totalBadgeStateClass}`,
                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $906889f993373872$export$2e2bcd8739ae039), {
                    color: "neutral",
                    variant: "pill",
                    "data-testid": "total-communications-badge",
                    "aria-label": totalBadgeLabel,
                    children: total
                })
            })
        ]
    });
    /**
   * Handles the update request mutation.
   * @param {Pella.ProductionRequestAPI.Request['id']} id - The ID of the request to update.
   * @param {Pella.ProductionRequestAPI.Request['status']} status - The new status of the request.
   * @param {string | null} [onHoldReason] - Hold reason label, only set when placing on hold via the reason modal.
   */ const handleUpdateRequest = (id, status, onHoldReason)=>mutate({
            id: id,
            status: status,
            onHoldReason: onHoldReason
        });
    /**
   * Handles the "Put on Hold" action. When the request's action requires a hold reason,
   * open the reason modal instead of placing the request on hold directly.
   */ const handlePutOnHold = ()=>{
        // showOnHoldReason is not declared on the shared Action type, so read it through a narrow cast.
        const requiresHoldReason = /** @type {{ showOnHoldReason?: boolean }} */ request.action?.showOnHoldReason;
        if (requiresHoldReason) setOpenHoldModal(true);
        else handleUpdateRequest(request.id, (0, $917e2c0c66b65db1$export$b41c0f52c41112e3).ON_HOLD);
    };
    /**
   * Places the request on hold with the reason selected from the modal.
   * @param {string} reason - The selected hold reason label.
   */ const handleSelectHoldReason = (reason)=>{
        handleUpdateRequest(request.id, (0, $917e2c0c66b65db1$export$b41c0f52c41112e3).ON_HOLD, reason);
        setOpenHoldModal(false);
    };
    /**
   * handles completion of a request
   * @param {Pella.ProductionRequestAPI.Request} acceptedRequest
   * @param {Pella.ProductionRequestAPI.Request['status']} status
   */ const handleComplete = (acceptedRequest, status)=>{
        if ((0, $917e2c0c66b65db1$export$1eb689c2eb5e003a).has(acceptedRequest?.action?.transactionId)) setOpenTransactionDrawer(true);
        else completeWithLinkedActionCheck(acceptedRequest, ()=>mutate({
                id: acceptedRequest.id,
                status: status
            }, {
                onSuccess: ()=>(0, $673b1c81cc441170$export$2e2bcd8739ae039).success('Request completed successfully!')
            }));
    };
    /**
   * Opens the Communication drawer and marks the request's communications as read.
   * Communications are available on every request regardless of transaction type.
   * @param {Pella.ProductionRequestAPI.Request} messageRequest - The request to add a communication to.
   */ const handleAddCommunication = async (messageRequest)=>{
        // Awaited on purpose: nothing renders readBy yet, but unread counts are coming, and settling
        // the receipt before the drawer opens keeps a count from flickering read after it paints.
        // Do not swap this for a fire-and-forget mutate.
        try {
            await markAsRead(messageRequest);
        } catch  {
        // mutateAsync rejects as well as invoking the hook's onError, so the rejection has to be
        // swallowed here or it surfaces as an unhandled promise rejection. The hook has already
        // toasted; the drawer opens either way so the history stays reachable.
        }
        setOpenCommunicationDrawer(true);
    };
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $1e1ba35c5b9fc4c3$exports.Fragment), {
        children: [
            request.status === (0, $917e2c0c66b65db1$export$b41c0f52c41112e3).AVAILABLE && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $1e1ba35c5b9fc4c3$exports.Fragment), {
                children: [
                    communicationButtonEnabled && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                        className: `${$f0da3fc2fb8416e0$export$2ba01fb71ed41cb6} ${$f0da3fc2fb8416e0$export$55707c0a378c7842}`,
                        color: "secondary",
                        "data-testid": "addCommunication",
                        onClick: ()=>handleAddCommunication(request),
                        children: communicationButtonLabel
                    }),
                    isRequest && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                        className: $f0da3fc2fb8416e0$export$2ba01fb71ed41cb6,
                        color: "primary",
                        onClick: ()=>handleUpdateRequest(request.id, (0, $917e2c0c66b65db1$export$b41c0f52c41112e3).RECALLED),
                        children: "Recall"
                    }),
                    isWorklist && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $1e1ba35c5b9fc4c3$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                                className: $f0da3fc2fb8416e0$export$2ba01fb71ed41cb6,
                                color: "secondary",
                                onClick: handlePutOnHold,
                                children: "Put on Hold"
                            }),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                                className: $f0da3fc2fb8416e0$export$2ba01fb71ed41cb6,
                                color: "primary",
                                onClick: ()=>handleUpdateRequest(request.id, (0, $917e2c0c66b65db1$export$b41c0f52c41112e3).ACCEPTED),
                                children: "Accept"
                            })
                        ]
                    })
                ]
            }),
            request.status === (0, $917e2c0c66b65db1$export$b41c0f52c41112e3).ACCEPTED && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $1e1ba35c5b9fc4c3$exports.Fragment), {
                children: [
                    communicationButtonEnabled && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                        className: `${$f0da3fc2fb8416e0$export$2ba01fb71ed41cb6} ${$f0da3fc2fb8416e0$export$55707c0a378c7842}`,
                        color: "secondary",
                        "data-testid": "addCommunication",
                        onClick: ()=>handleAddCommunication(request),
                        children: communicationButtonLabel
                    }),
                    isWorklist && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $1e1ba35c5b9fc4c3$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                                className: $f0da3fc2fb8416e0$export$2ba01fb71ed41cb6,
                                color: "secondary",
                                onClick: ()=>handleUpdateRequest(request.id, (0, $917e2c0c66b65db1$export$b41c0f52c41112e3).AVAILABLE),
                                children: "Remove"
                            }),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                                className: $f0da3fc2fb8416e0$export$2ba01fb71ed41cb6,
                                color: "primary",
                                onClick: ()=>handleComplete(request, (0, $917e2c0c66b65db1$export$b41c0f52c41112e3).COMPLETED),
                                children: "Complete"
                            })
                        ]
                    })
                ]
            }),
            request.status === (0, $917e2c0c66b65db1$export$b41c0f52c41112e3).ON_HOLD && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $1e1ba35c5b9fc4c3$exports.Fragment), {
                children: [
                    communicationButtonEnabled && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                        className: `${$f0da3fc2fb8416e0$export$2ba01fb71ed41cb6} ${$f0da3fc2fb8416e0$export$55707c0a378c7842}`,
                        color: "secondary",
                        "data-testid": "addCommunication",
                        onClick: ()=>handleAddCommunication(request),
                        children: communicationButtonLabel
                    }),
                    isWorklist && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                        className: $f0da3fc2fb8416e0$export$2ba01fb71ed41cb6,
                        color: "primary",
                        onClick: ()=>handleUpdateRequest(request.id, (0, $917e2c0c66b65db1$export$b41c0f52c41112e3).AVAILABLE),
                        children: "Move to Available"
                    })
                ]
            }),
            request?.action?.transactionId === 'TRAILER_TO_DOCK' && openTransactionDrawer && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $cc3900e0b33eaa8d$export$8fdf6417c0e7f3a4), {
                open: openTransactionDrawer,
                close: ()=>setOpenTransactionDrawer(false),
                request: request
            }),
            request?.action?.transactionId === 'ISSUE_TO_LINE' && openTransactionDrawer && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $37e9db2a8d1862f9$export$45f0c1c7a7c62d48), {
                open: openTransactionDrawer,
                close: ()=>setOpenTransactionDrawer(false),
                request: request
            }),
            request?.action?.transactionId === 'SUB_INVENTORY_TRANSFER' && openTransactionDrawer && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $adc77028baec7183$export$594b105c67e010a4), {
                open: openTransactionDrawer,
                close: ()=>setOpenTransactionDrawer(false),
                request: request
            }),
            request?.action?.transactionId === 'DIRECT_ORG_TRANSFER' && openTransactionDrawer && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $fabf01b454a00596$export$281e033cb54aad33), {
                open: openTransactionDrawer,
                close: ()=>setOpenTransactionDrawer(false),
                request: request
            }),
            communicationButtonEnabled && openCommunicationDrawer && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $391e9eeea212a43c$export$68d442f0fd4a9251), {
                open: openCommunicationDrawer,
                close: ()=>setOpenCommunicationDrawer(false),
                request: request
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $9d34422acf608041$export$ce2e9a3a523cbee8), {
                open: openHoldModal,
                close: ()=>setOpenHoldModal(false),
                onSelectReason: handleSelectHoldReason
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $b195b7406d2db366$export$f4686426a1b24a12), {
                isOpen: isLinkedActionPromptOpen,
                description: linkedActionDescription,
                onDecline: onDecline,
                onConfirm: onConfirm
            })
        ]
    });
};


var $c0903a24e812540a$export$31eb53bd5b582a97;
var $c0903a24e812540a$export$32180ef41b15b513;
var $c0903a24e812540a$export$aa3e815946b80764;
var $c0903a24e812540a$export$34e0f9847d4c02dd;
var $c0903a24e812540a$export$e8c9778bf415dd08;
var $c0903a24e812540a$export$adb608be33961c98;
var $c0903a24e812540a$export$38e42c68cf43b5d4;
var $c0903a24e812540a$export$55abd4691b317664;
$c0903a24e812540a$export$31eb53bd5b582a97 = `C9s_Ga_action`;
$c0903a24e812540a$export$32180ef41b15b513 = `C9s_Ga_body`;
$c0903a24e812540a$export$aa3e815946b80764 = `C9s_Ga_card slideLeft`;
$c0903a24e812540a$export$34e0f9847d4c02dd = `C9s_Ga_container`;
$c0903a24e812540a$export$e8c9778bf415dd08 = `C9s_Ga_divider`;
$c0903a24e812540a$export$adb608be33961c98 = `C9s_Ga_footer`;
$c0903a24e812540a$export$38e42c68cf43b5d4 = `C9s_Ga_header`;
$c0903a24e812540a$export$55abd4691b317664 = `C9s_Ga_history`;



/**
 * Display the results of the PartQohLocationsLookup query that is stored in
 * dynamicInputResult field of the request
 * @param {Local.PartQohLocationsLookupProps} props
 */ 
const $d8c857490d786544$export$eafe6fb388ef3f65 = ({ results: results })=>{
    if (!results?.length || !results[0].description) return null;
    const [description] = results[0].description.split(',');
    const locatorInfo = results.map((result)=>`*** ${result.locator} (${result.qoh})`);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
        "data-testid": "dynamic-input-result",
        children: `${description} ${locatorInfo.join(' ')}`
    });
};


/**
 * Display the die number and description returned by the Die Number Lookup
 * query that is stored in dynamicInputResult field of the request
 * @param {Local.DieNumberLookupProps} props
 */ 
const $78092c8fd34ed86c$export$a2df1829cea4cceb = ({ result: result })=>{
    if (!result?.die && !result?.description) return null;
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
        "data-testid": "dynamic-input-result",
        children: `Description: ${result.description} DIE: ${result.die}`
    });
};


/**
 * Display the lumber schedule details returned by the Lumber Schedule Lookup
 * query that is stored in dynamicInputResult field of the request
 * @param {Local.LumberScheduleLookupProps} props
 */ 
const $7f5ea9b5a8a85b2a$export$75d1b3da6763eedf = ({ result: result })=>{
    if (!result?.scheduleNumber) return null;
    const { scheduleNumber: scheduleNumber, aQty: aQty, aItem: aItem, location: location, finalFamily: finalFamily, panSize: panSize } = result;
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
        "data-testid": "dynamic-input-result",
        children: `<${scheduleNumber}> ${aQty} pcs of ${aItem} at ${location} -- Final Family: ${finalFamily} -- Full Pan = ${panSize}`
    });
};


/**
 * Display the lumber location details returned by the Lumber Part Lookup
 * query that is stored in dynamicInputResult field of the request
 * @param {Local.LumberPartLookupProps} props
 */ 
const $0c5bf65cbda69824$export$b03f94510a790c6 = ({ result: result })=>{
    if (!result?.item) return null;
    const { location: location } = result;
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
        "data-testid": "dynamic-input-result",
        children: `Description: Location ${location}`
    });
};


/**
 * Display the lot data returned by the P10 Put Down Mill query that is
 * stored in the dynamicInputResult field of the request. A no-lots response
 * ([{ lotNumber: null, ... }]) renders nothing.
 * @param {Local.PutDownMillLookupProps} props
 */ 
const $5e79078a12919ee0$export$ec14e2760906b0f0 = ({ result: result })=>{
    const lots = (result || []).filter((lot)=>lot?.lotNumber);
    if (!lots.length) return null;
    const display = lots.map((lot)=>`${lot.lotNumber} (${lot.qOH}) ${lot.lotDate}`).join(' <> ');
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
        "data-testid": "dynamic-input-result",
        children: `Description: ${display}`
    });
};


const $85fdff2ff3764620$export$ae6ecd52f170223b = ({ request: request })=>{
    switch(request.action.actionQuery){
        case 'PART_QOH_LOCATIONS_LOOKUP':
            {
                const partQohRequest = /** @type {Local.PartQohLookupRequest} */ request;
                return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $d8c857490d786544$export$eafe6fb388ef3f65), {
                    results: partQohRequest.dynamicInputResult
                });
            }
        case 'DIE_NUMBER_LOOKUP':
            {
                const dieNumberRequest = /** @type {Local.DieNumberLookupRequest} */ request;
                return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $78092c8fd34ed86c$export$a2df1829cea4cceb), {
                    result: dieNumberRequest.dynamicInputResult
                });
            }
        case 'LUMBER_SCHEDULE_LOOKUP':
            {
                const lumberScheduleRequest = /** @type {Local.LumberScheduleLookupRequest} */ request;
                return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $7f5ea9b5a8a85b2a$export$75d1b3da6763eedf), {
                    result: lumberScheduleRequest.dynamicInputResult
                });
            }
        case 'LUMBER_PART_LOOKUP':
            {
                const lumberPartRequest = /** @type {Local.LumberPartLookupRequest} */ request;
                return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $0c5bf65cbda69824$export$b03f94510a790c6), {
                    result: lumberPartRequest.dynamicInputResult
                });
            }
        case 'P10_PUT_DOWN_MILL':
            {
                const putDownMillRequest = /** @type {Local.PutDownMillLookupRequest} */ request;
                return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $5e79078a12919ee0$export$ec14e2760906b0f0), {
                    result: putDownMillRequest.dynamicInputResult
                });
            }
        case 'PART_DESCRIPTION_LOOKUP':
            {
                const partDescriptionRequest = /** @type {Local.PartDescriptionLookupRequest} */ request;
                return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                    "data-testid": "dynamic-input-result",
                    children: partDescriptionRequest.dynamicInputResult?.description || 'No description found'
                });
            }
        default:
            return null;
    }
};


const $b8078ecab9940da8$var$ACCEPTED_HISTORY_STATUS = new Set([
    (0, $917e2c0c66b65db1$export$b41c0f52c41112e3).ACCEPTED,
    (0, $917e2c0c66b65db1$export$b41c0f52c41112e3).COMPLETED
]);
const $b8078ecab9940da8$export$cd7d38bc6611de98 = ({ data: data })=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
        className: $c0903a24e812540a$export$34e0f9847d4c02dd,
        children: data?.map((req)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $482f79dfdc83e24d$export$2e2bcd8739ae039), {
                "data-testid": "request-card",
                className: $c0903a24e812540a$export$aa3e815946b80764,
                children: [
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                        className: $c0903a24e812540a$export$38e42c68cf43b5d4,
                        children: [
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                className: $c0903a24e812540a$export$31eb53bd5b582a97,
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                                        children: req.action.description
                                    }),
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                                        children: req.action.message
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $906889f993373872$export$2e2bcd8739ae039), {
                                color: "neutral",
                                variant: "pill",
                                children: req.action.location.description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                        className: $c0903a24e812540a$export$e8c9778bf415dd08
                    }),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                        className: $c0903a24e812540a$export$32180ef41b15b513,
                        children: [
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                                children: req.comment
                            }),
                            Boolean(req.dropDownListVal1) && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("b", {
                                        children: "List 1: "
                                    }),
                                    req.dropDownListVal1
                                ]
                            }),
                            Boolean(req.dropDownListVal2) && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("b", {
                                        children: "List 2: "
                                    }),
                                    req.dropDownListVal2
                                ]
                            }),
                            Boolean(req.dynamicInput) && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("b", {
                                        children: "Input: "
                                    }),
                                    req.dynamicInput
                                ]
                            }),
                            req.dynamicInputResult && Object.keys(req.dynamicInputResult) && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $85fdff2ff3764620$export$ae6ecd52f170223b), {
                                    request: req
                                })
                            }),
                            Boolean(req.requestQty) && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("b", {
                                        children: "Quantity: "
                                    }),
                                    req.requestQty
                                ]
                            }),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                className: $c0903a24e812540a$export$55abd4691b317664,
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $51a8ce9faa2e0a0d$export$53e86a51580efa14), {
                                        title: "Requested",
                                        user: req.requestorId,
                                        date: req.creationDate
                                    }),
                                    $b8078ecab9940da8$var$ACCEPTED_HISTORY_STATUS.has(req.status) && req.acceptTime && req.acceptUserId && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $51a8ce9faa2e0a0d$export$53e86a51580efa14), {
                                        title: "Accepted",
                                        user: req.acceptUserId,
                                        date: req.acceptTime
                                    }),
                                    req.status === (0, $917e2c0c66b65db1$export$b41c0f52c41112e3).ON_HOLD && req.onHoldTime && req.onHoldUserId && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $51a8ce9faa2e0a0d$export$53e86a51580efa14), {
                                        title: "Put on Hold",
                                        user: req.onHoldUserId,
                                        date: req.onHoldTime,
                                        holdReason: req.onHoldReason ?? ''
                                    }),
                                    req.status === (0, $917e2c0c66b65db1$export$b41c0f52c41112e3).COMPLETED && req.completionTime && req.completionUserId && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $51a8ce9faa2e0a0d$export$53e86a51580efa14), {
                                        title: "Completed",
                                        user: req.completionUserId,
                                        date: req.completionTime
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                        className: $c0903a24e812540a$export$adb608be33961c98,
                        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $60c0fb95698f3b88$export$8fda2956f7bfe17), {
                            request: req
                        })
                    })
                ]
            }, req.id))
    });





var $87cf696c1ea429b9$export$2ba01fb71ed41cb6;
var $87cf696c1ea429b9$export$aa3e815946b80764;
var $87cf696c1ea429b9$export$34e0f9847d4c02dd;
var $87cf696c1ea429b9$export$fb184b623420d9be;
$87cf696c1ea429b9$export$2ba01fb71ed41cb6 = `IgfgBW_button`;
$87cf696c1ea429b9$export$aa3e815946b80764 = `IgfgBW_card slideLeft`;
$87cf696c1ea429b9$export$34e0f9847d4c02dd = `IgfgBW_container`;
$87cf696c1ea429b9$export$fb184b623420d9be = `IgfgBW_title`;


/**
 * @type {Record<string, Pella.ProductionRequestAPI.ResourceQueueByStatus['queueStatus']>}
 */ const $41374f874aeac426$var$STATUS = {
    AVAILABLE: 'AVAILABLE',
    TEMPORARY: 'TEMPORARY'
};
const $41374f874aeac426$export$17b5566cd394687f = ({ data: data })=>{
    const { mutate: createResourceQueue } = (0, $2d0e270541012399$export$487a51f0f407c060)();
    const { mutate: deleteResourceQueue } = (0, $cdb2ba9494631e7e$export$68b2ba9deca995b2)();
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
        className: $87cf696c1ea429b9$export$34e0f9847d4c02dd,
        children: data?.map(({ queueId: queueId, description: description, queueStatus: queueStatus })=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $482f79dfdc83e24d$export$2e2bcd8739ae039), {
                "data-testid": "queue-card",
                className: $87cf696c1ea429b9$export$aa3e815946b80764,
                children: [
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                        className: $87cf696c1ea429b9$export$fb184b623420d9be,
                        children: description
                    }),
                    queueStatus === $41374f874aeac426$var$STATUS.AVAILABLE && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                        className: $87cf696c1ea429b9$export$2ba01fb71ed41cb6,
                        onClick: ()=>createResourceQueue({
                                queueId: queueId,
                                queueStatus: $41374f874aeac426$var$STATUS.TEMPORARY
                            }),
                        children: "Assign as Temporary"
                    }),
                    queueStatus === $41374f874aeac426$var$STATUS.TEMPORARY && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                        className: $87cf696c1ea429b9$export$2ba01fb71ed41cb6,
                        onClick: ()=>deleteResourceQueue({
                                queueId: queueId
                            }),
                        children: "Remove Assignment"
                    })
                ]
            }, queueId))
    });
};



var $01a9edb4d9bd1147$exports = {};

$parcel$export($01a9edb4d9bd1147$exports, "accordionBlue", function () { return $01a9edb4d9bd1147$export$655ae41a89b4ac14; }, function (v) { return $01a9edb4d9bd1147$export$655ae41a89b4ac14 = v; });
$parcel$export($01a9edb4d9bd1147$exports, "accordionGreen", function () { return $01a9edb4d9bd1147$export$48c802e8cf0c8e55; }, function (v) { return $01a9edb4d9bd1147$export$48c802e8cf0c8e55 = v; });
$parcel$export($01a9edb4d9bd1147$exports, "accordionGrey", function () { return $01a9edb4d9bd1147$export$f014b3bfb5472c3; }, function (v) { return $01a9edb4d9bd1147$export$f014b3bfb5472c3 = v; });
$parcel$export($01a9edb4d9bd1147$exports, "accordionRed", function () { return $01a9edb4d9bd1147$export$8fd25f50b21c8336; }, function (v) { return $01a9edb4d9bd1147$export$8fd25f50b21c8336 = v; });
$parcel$export($01a9edb4d9bd1147$exports, "accordionWhite", function () { return $01a9edb4d9bd1147$export$6babc64382f67de0; }, function (v) { return $01a9edb4d9bd1147$export$6babc64382f67de0 = v; });
$parcel$export($01a9edb4d9bd1147$exports, "badgeBlack", function () { return $01a9edb4d9bd1147$export$30ebb4e0a904b39; }, function (v) { return $01a9edb4d9bd1147$export$30ebb4e0a904b39 = v; });
$parcel$export($01a9edb4d9bd1147$exports, "badgeBlue", function () { return $01a9edb4d9bd1147$export$c2d49462e08e357d; }, function (v) { return $01a9edb4d9bd1147$export$c2d49462e08e357d = v; });
$parcel$export($01a9edb4d9bd1147$exports, "badgeGreen", function () { return $01a9edb4d9bd1147$export$ccc4f674b3f4e36; }, function (v) { return $01a9edb4d9bd1147$export$ccc4f674b3f4e36 = v; });
$parcel$export($01a9edb4d9bd1147$exports, "badgeRed", function () { return $01a9edb4d9bd1147$export$ed127ec851b83551; }, function (v) { return $01a9edb4d9bd1147$export$ed127ec851b83551 = v; });
$parcel$export($01a9edb4d9bd1147$exports, "header", function () { return $01a9edb4d9bd1147$export$38e42c68cf43b5d4; }, function (v) { return $01a9edb4d9bd1147$export$38e42c68cf43b5d4 = v; });
$parcel$export($01a9edb4d9bd1147$exports, "loading", function () { return $01a9edb4d9bd1147$export$46c1c92549715335; }, function (v) { return $01a9edb4d9bd1147$export$46c1c92549715335 = v; });
$parcel$export($01a9edb4d9bd1147$exports, "noHistory", function () { return $01a9edb4d9bd1147$export$ba56a8b67fde8587; }, function (v) { return $01a9edb4d9bd1147$export$ba56a8b67fde8587 = v; });
$parcel$export($01a9edb4d9bd1147$exports, "slideLeft", function () { return $01a9edb4d9bd1147$export$1e947a1dfc5a5548; }, function (v) { return $01a9edb4d9bd1147$export$1e947a1dfc5a5548 = v; });
$parcel$export($01a9edb4d9bd1147$exports, "slideRight", function () { return $01a9edb4d9bd1147$export$19b9a771608c4321; }, function (v) { return $01a9edb4d9bd1147$export$19b9a771608c4321 = v; });
var $01a9edb4d9bd1147$export$655ae41a89b4ac14;
var $01a9edb4d9bd1147$export$48c802e8cf0c8e55;
var $01a9edb4d9bd1147$export$f014b3bfb5472c3;
var $01a9edb4d9bd1147$export$8fd25f50b21c8336;
var $01a9edb4d9bd1147$export$6babc64382f67de0;
var $01a9edb4d9bd1147$export$30ebb4e0a904b39;
var $01a9edb4d9bd1147$export$c2d49462e08e357d;
var $01a9edb4d9bd1147$export$ccc4f674b3f4e36;
var $01a9edb4d9bd1147$export$ed127ec851b83551;
var $01a9edb4d9bd1147$export$38e42c68cf43b5d4;
var $01a9edb4d9bd1147$export$46c1c92549715335;
var $01a9edb4d9bd1147$export$ba56a8b67fde8587;
var $01a9edb4d9bd1147$export$1e947a1dfc5a5548;
var $01a9edb4d9bd1147$export$19b9a771608c4321;
$01a9edb4d9bd1147$export$655ae41a89b4ac14 = `_5LTF2W_accordionBlue`;
$01a9edb4d9bd1147$export$48c802e8cf0c8e55 = `_5LTF2W_accordionGreen`;
$01a9edb4d9bd1147$export$f014b3bfb5472c3 = `_5LTF2W_accordionGrey`;
$01a9edb4d9bd1147$export$8fd25f50b21c8336 = `_5LTF2W_accordionRed`;
$01a9edb4d9bd1147$export$6babc64382f67de0 = `_5LTF2W_accordionWhite`;
$01a9edb4d9bd1147$export$30ebb4e0a904b39 = `_5LTF2W_badgeBlack`;
$01a9edb4d9bd1147$export$c2d49462e08e357d = `_5LTF2W_badgeBlue`;
$01a9edb4d9bd1147$export$ccc4f674b3f4e36 = `_5LTF2W_badgeGreen`;
$01a9edb4d9bd1147$export$ed127ec851b83551 = `_5LTF2W_badgeRed`;
$01a9edb4d9bd1147$export$38e42c68cf43b5d4 = `_5LTF2W_header`;
$01a9edb4d9bd1147$export$46c1c92549715335 = `_5LTF2W_loading`;
$01a9edb4d9bd1147$export$ba56a8b67fde8587 = `_5LTF2W_noHistory`;
$01a9edb4d9bd1147$export$1e947a1dfc5a5548 = `_5LTF2W_slideLeft slideLeft`;
$01a9edb4d9bd1147$export$19b9a771608c4321 = `_5LTF2W_slideRight slideRight`;


const $ff985eb5a8f8b1d7$export$9cd41b243d92cce2 = ({ requests: requests = [], queues: queues = [], searchValue: searchValue = '', id: id, label: label, className: className, badgeClass: badgeClass, animation: animation })=>{
    const { pathname: pathname } = (0, $ebc812b73151cba1$export$45d76561a5302f2b)();
    const [completedAccordionOpen, setCompletedAccordionOpen] = (0, $lCzvA.useState)(false);
    const { data: completedRequests, isLoading: isLoading } = (0, $67e137471d230f40$export$9ba35766fd1b2aff)(pathname === '/worklist' ? 'resource' : 'location', completedAccordionOpen);
    /**
   * Handles accordion toggle event for completed requests
   */ const handleToggle = ()=>{
        if (id === 'wl-completed') setCompletedAccordionOpen((prev)=>!prev);
    };
    const requestData = id === 'wl-completed' ? (0, $5f8e1c8d350f317e$export$f89d6faae6e6ac3e)(searchValue, completedRequests?.completed) || [] : requests;
    const showNoHistory = id === 'wl-completed' && !isLoading && !requestData.length;
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8fedcf22c00c4cdd$export$2e2bcd8739ae039), {
        "data-testid": `status-accordion-${id}`,
        className: $01a9edb4d9bd1147$exports[animation],
        variant: "box",
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $9e4c7ade3285342d$export$2e2bcd8739ae039), {
            className: $01a9edb4d9bd1147$exports[className],
            children: [
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $dffdfe16b69939eb$export$2e2bcd8739ae039), {
                    onClick: handleToggle,
                    children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                        className: $01a9edb4d9bd1147$exports.header,
                        children: [
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("p", {
                                children: label
                            }),
                            badgeClass && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $906889f993373872$export$2e2bcd8739ae039), {
                                className: $01a9edb4d9bd1147$exports[badgeClass],
                                children: requestData.length || queues.length
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $d9ac194a6f540d5b$export$2e2bcd8739ae039), {
                    children: [
                        id === 'wl-completed' && isLoading && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                            "data-testid": "loading",
                            className: $01a9edb4d9bd1147$exports.loading,
                            children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $6bfaf8085a30c9b5$export$4bf83b24a11cff0b), {
                                color: "black",
                                width: "50"
                            })
                        }),
                        requestData.length > 0 && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $b8078ecab9940da8$export$cd7d38bc6611de98), {
                            data: requestData
                        }),
                        showNoHistory && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                            className: $01a9edb4d9bd1147$exports.noHistory,
                            children: "No History Available."
                        }),
                        queues.length > 0 && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $41374f874aeac426$export$17b5566cd394687f), {
                            data: queues
                        })
                    ]
                })
            ]
        })
    });
};




var $lCzvA = parcelRequire("lCzvA");



var $8f74e0bb3e29c10c$export$aa3e815946b80764;
var $8f74e0bb3e29c10c$export$34e0f9847d4c02dd;
$8f74e0bb3e29c10c$export$aa3e815946b80764 = `XVSTfq_card slideLeft`;
$8f74e0bb3e29c10c$export$34e0f9847d4c02dd = `XVSTfq_container`;


const $da579b4358e3331b$export$a9450676c67df36b = ()=>{
    const { data: actions } = (0, $06f88e07f7e7fb66$export$bc923229a7fa61e7)({
        active: true
    });
    const [selectedAction, setSelectedAction] = (0, $lCzvA.useState)(/**@type {Pella.ProductionRequestAPI.Action|undefined} */ undefined);
    /** Close request modal */ const closeRequestModal = ()=>setSelectedAction(undefined);
    /**
   * Handle action card click
   * @param {Pella.ProductionRequestAPI.Action} action
   */ const actionClick = (action)=>{
        setSelectedAction(action);
    };
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
        className: $8f74e0bb3e29c10c$export$34e0f9847d4c02dd,
        children: [
            actions?.map((action)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("button", {
                    type: "button",
                    "data-testid": `action-card-${action.id}`,
                    onClick: ()=>actionClick(action),
                    children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $482f79dfdc83e24d$export$2e2bcd8739ae039), {
                        className: $8f74e0bb3e29c10c$export$aa3e815946b80764,
                        children: [
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("p", {
                                children: action.description
                            }),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("p", {
                                children: action.message
                            })
                        ]
                    })
                }, action.id)),
            selectedAction && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $0c73e720f7589254$export$6727f58776bb6617), {
                open: Boolean(selectedAction),
                close: closeRequestModal,
                action: selectedAction
            })
        ]
    });
};





var $lCzvA = parcelRequire("lCzvA");



var $lCzvA = parcelRequire("lCzvA");
var $c9d6d3563c261b0e$export$74c1f679d38d82e5;
(function(Html5QrcodeSupportedFormats) {
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["QR_CODE"] = 0] = "QR_CODE";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["AZTEC"] = 1] = "AZTEC";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["CODABAR"] = 2] = "CODABAR";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["CODE_39"] = 3] = "CODE_39";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["CODE_93"] = 4] = "CODE_93";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["CODE_128"] = 5] = "CODE_128";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["DATA_MATRIX"] = 6] = "DATA_MATRIX";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["MAXICODE"] = 7] = "MAXICODE";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["ITF"] = 8] = "ITF";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["EAN_13"] = 9] = "EAN_13";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["EAN_8"] = 10] = "EAN_8";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["PDF_417"] = 11] = "PDF_417";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["RSS_14"] = 12] = "RSS_14";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["RSS_EXPANDED"] = 13] = "RSS_EXPANDED";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["UPC_A"] = 14] = "UPC_A";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["UPC_E"] = 15] = "UPC_E";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["UPC_EAN_EXTENSION"] = 16] = "UPC_EAN_EXTENSION";
})($c9d6d3563c261b0e$export$74c1f679d38d82e5 || ($c9d6d3563c261b0e$export$74c1f679d38d82e5 = {}));
var $c9d6d3563c261b0e$var$html5QrcodeSupportedFormatsTextMap = new Map([
    [
        $c9d6d3563c261b0e$export$74c1f679d38d82e5.QR_CODE,
        "QR_CODE"
    ],
    [
        $c9d6d3563c261b0e$export$74c1f679d38d82e5.AZTEC,
        "AZTEC"
    ],
    [
        $c9d6d3563c261b0e$export$74c1f679d38d82e5.CODABAR,
        "CODABAR"
    ],
    [
        $c9d6d3563c261b0e$export$74c1f679d38d82e5.CODE_39,
        "CODE_39"
    ],
    [
        $c9d6d3563c261b0e$export$74c1f679d38d82e5.CODE_93,
        "CODE_93"
    ],
    [
        $c9d6d3563c261b0e$export$74c1f679d38d82e5.CODE_128,
        "CODE_128"
    ],
    [
        $c9d6d3563c261b0e$export$74c1f679d38d82e5.DATA_MATRIX,
        "DATA_MATRIX"
    ],
    [
        $c9d6d3563c261b0e$export$74c1f679d38d82e5.MAXICODE,
        "MAXICODE"
    ],
    [
        $c9d6d3563c261b0e$export$74c1f679d38d82e5.ITF,
        "ITF"
    ],
    [
        $c9d6d3563c261b0e$export$74c1f679d38d82e5.EAN_13,
        "EAN_13"
    ],
    [
        $c9d6d3563c261b0e$export$74c1f679d38d82e5.EAN_8,
        "EAN_8"
    ],
    [
        $c9d6d3563c261b0e$export$74c1f679d38d82e5.PDF_417,
        "PDF_417"
    ],
    [
        $c9d6d3563c261b0e$export$74c1f679d38d82e5.RSS_14,
        "RSS_14"
    ],
    [
        $c9d6d3563c261b0e$export$74c1f679d38d82e5.RSS_EXPANDED,
        "RSS_EXPANDED"
    ],
    [
        $c9d6d3563c261b0e$export$74c1f679d38d82e5.UPC_A,
        "UPC_A"
    ],
    [
        $c9d6d3563c261b0e$export$74c1f679d38d82e5.UPC_E,
        "UPC_E"
    ],
    [
        $c9d6d3563c261b0e$export$74c1f679d38d82e5.UPC_EAN_EXTENSION,
        "UPC_EAN_EXTENSION"
    ]
]);
var $c9d6d3563c261b0e$export$ca79648743730e34;
(function(DecodedTextType) {
    DecodedTextType[DecodedTextType["UNKNOWN"] = 0] = "UNKNOWN";
    DecodedTextType[DecodedTextType["URL"] = 1] = "URL";
})($c9d6d3563c261b0e$export$ca79648743730e34 || ($c9d6d3563c261b0e$export$ca79648743730e34 = {}));
function $c9d6d3563c261b0e$export$f672fe1751f545ca(format) {
    return Object.values($c9d6d3563c261b0e$export$74c1f679d38d82e5).includes(format);
}
var $c9d6d3563c261b0e$export$13ed3042ed099f6a;
(function(Html5QrcodeScanType) {
    Html5QrcodeScanType[Html5QrcodeScanType["SCAN_TYPE_CAMERA"] = 0] = "SCAN_TYPE_CAMERA";
    Html5QrcodeScanType[Html5QrcodeScanType["SCAN_TYPE_FILE"] = 1] = "SCAN_TYPE_FILE";
})($c9d6d3563c261b0e$export$13ed3042ed099f6a || ($c9d6d3563c261b0e$export$13ed3042ed099f6a = {}));
var $c9d6d3563c261b0e$export$a4dae9b55d173e6d = function() {
    function Html5QrcodeConstants() {}
    Html5QrcodeConstants.GITHUB_PROJECT_URL = "https://github.com/mebjas/html5-qrcode";
    Html5QrcodeConstants.SCAN_DEFAULT_FPS = 2;
    Html5QrcodeConstants.DEFAULT_DISABLE_FLIP = false;
    Html5QrcodeConstants.DEFAULT_REMEMBER_LAST_CAMERA_USED = true;
    Html5QrcodeConstants.DEFAULT_SUPPORTED_SCAN_TYPE = [
        $c9d6d3563c261b0e$export$13ed3042ed099f6a.SCAN_TYPE_CAMERA,
        $c9d6d3563c261b0e$export$13ed3042ed099f6a.SCAN_TYPE_FILE
    ];
    return Html5QrcodeConstants;
}();
var $c9d6d3563c261b0e$export$96706046d68ee585 = function() {
    function QrcodeResultFormat(format, formatName) {
        this.format = format;
        this.formatName = formatName;
    }
    QrcodeResultFormat.prototype.toString = function() {
        return this.formatName;
    };
    QrcodeResultFormat.create = function(format) {
        if (!$c9d6d3563c261b0e$var$html5QrcodeSupportedFormatsTextMap.has(format)) throw "".concat(format, " not in html5QrcodeSupportedFormatsTextMap");
        return new QrcodeResultFormat(format, $c9d6d3563c261b0e$var$html5QrcodeSupportedFormatsTextMap.get(format));
    };
    return QrcodeResultFormat;
}();
var $c9d6d3563c261b0e$export$ca258a9dba899828 = function() {
    function Html5QrcodeResultFactory() {}
    Html5QrcodeResultFactory.createFromText = function(decodedText) {
        var qrcodeResult = {
            text: decodedText
        };
        return {
            decodedText: decodedText,
            result: qrcodeResult
        };
    };
    Html5QrcodeResultFactory.createFromQrcodeResult = function(qrcodeResult) {
        return {
            decodedText: qrcodeResult.text,
            result: qrcodeResult
        };
    };
    return Html5QrcodeResultFactory;
}();
var $c9d6d3563c261b0e$export$ce0f3ff7a292bc54;
(function(Html5QrcodeErrorTypes) {
    Html5QrcodeErrorTypes[Html5QrcodeErrorTypes["UNKWOWN_ERROR"] = 0] = "UNKWOWN_ERROR";
    Html5QrcodeErrorTypes[Html5QrcodeErrorTypes["IMPLEMENTATION_ERROR"] = 1] = "IMPLEMENTATION_ERROR";
    Html5QrcodeErrorTypes[Html5QrcodeErrorTypes["NO_CODE_FOUND_ERROR"] = 2] = "NO_CODE_FOUND_ERROR";
})($c9d6d3563c261b0e$export$ce0f3ff7a292bc54 || ($c9d6d3563c261b0e$export$ce0f3ff7a292bc54 = {}));
var $c9d6d3563c261b0e$export$dac571266bd01cf5 = function() {
    function Html5QrcodeErrorFactory() {}
    Html5QrcodeErrorFactory.createFrom = function(error) {
        return {
            errorMessage: error,
            type: $c9d6d3563c261b0e$export$ce0f3ff7a292bc54.UNKWOWN_ERROR
        };
    };
    return Html5QrcodeErrorFactory;
}();
var $c9d6d3563c261b0e$export$1952c0907ffae0f2 = function() {
    function BaseLoggger(verbose) {
        this.verbose = verbose;
    }
    BaseLoggger.prototype.log = function(message) {
        if (this.verbose) console.log(message);
    };
    BaseLoggger.prototype.warn = function(message) {
        if (this.verbose) console.warn(message);
    };
    BaseLoggger.prototype.logError = function(message, isExperimental) {
        if (this.verbose || isExperimental === true) console.error(message);
    };
    BaseLoggger.prototype.logErrors = function(errors) {
        if (errors.length === 0) throw "Logger#logError called without arguments";
        if (this.verbose) console.error(errors);
    };
    return BaseLoggger;
}();
function $c9d6d3563c261b0e$export$bedb7023a7733221(obj) {
    return typeof obj === "undefined" || obj === null;
}
function $c9d6d3563c261b0e$export$e0b576e7a74416cd(value, minValue, maxValue) {
    if (value > maxValue) return maxValue;
    if (value < minValue) return minValue;
    return value;
}


var $ff5e69b322275082$export$b5652ef085dee87f = function() {
    function Html5QrcodeStrings() {}
    Html5QrcodeStrings.codeParseError = function(exception) {
        return "QR code parse error, error = ".concat(exception);
    };
    Html5QrcodeStrings.errorGettingUserMedia = function(error) {
        return "Error getting userMedia, error = ".concat(error);
    };
    Html5QrcodeStrings.onlyDeviceSupportedError = function() {
        return "The device doesn't support navigator.mediaDevices , only supported cameraIdOrConfig in this case is deviceId parameter (string).";
    };
    Html5QrcodeStrings.cameraStreamingNotSupported = function() {
        return "Camera streaming not supported by the browser.";
    };
    Html5QrcodeStrings.unableToQuerySupportedDevices = function() {
        return "Unable to query supported devices, unknown error.";
    };
    Html5QrcodeStrings.insecureContextCameraQueryError = function() {
        return "Camera access is only supported in secure context like https or localhost.";
    };
    Html5QrcodeStrings.scannerPaused = function() {
        return "Scanner paused";
    };
    return Html5QrcodeStrings;
}();
var $ff5e69b322275082$export$b9cab5abdb16545c = function() {
    function Html5QrcodeScannerStrings() {}
    Html5QrcodeScannerStrings.scanningStatus = function() {
        return "Scanning";
    };
    Html5QrcodeScannerStrings.idleStatus = function() {
        return "Idle";
    };
    Html5QrcodeScannerStrings.errorStatus = function() {
        return "Error";
    };
    Html5QrcodeScannerStrings.permissionStatus = function() {
        return "Permission";
    };
    Html5QrcodeScannerStrings.noCameraFoundErrorStatus = function() {
        return "No Cameras";
    };
    Html5QrcodeScannerStrings.lastMatch = function(decodedText) {
        return "Last Match: ".concat(decodedText);
    };
    Html5QrcodeScannerStrings.codeScannerTitle = function() {
        return "Code Scanner";
    };
    Html5QrcodeScannerStrings.cameraPermissionTitle = function() {
        return "Request Camera Permissions";
    };
    Html5QrcodeScannerStrings.cameraPermissionRequesting = function() {
        return "Requesting camera permissions...";
    };
    Html5QrcodeScannerStrings.noCameraFound = function() {
        return "No camera found";
    };
    Html5QrcodeScannerStrings.scanButtonStopScanningText = function() {
        return "Stop Scanning";
    };
    Html5QrcodeScannerStrings.scanButtonStartScanningText = function() {
        return "Start Scanning";
    };
    Html5QrcodeScannerStrings.torchOnButton = function() {
        return "Switch On Torch";
    };
    Html5QrcodeScannerStrings.torchOffButton = function() {
        return "Switch Off Torch";
    };
    Html5QrcodeScannerStrings.torchOnFailedMessage = function() {
        return "Failed to turn on torch";
    };
    Html5QrcodeScannerStrings.torchOffFailedMessage = function() {
        return "Failed to turn off torch";
    };
    Html5QrcodeScannerStrings.scanButtonScanningStarting = function() {
        return "Launching Camera...";
    };
    Html5QrcodeScannerStrings.textIfCameraScanSelected = function() {
        return "Scan an Image File";
    };
    Html5QrcodeScannerStrings.textIfFileScanSelected = function() {
        return "Scan using camera directly";
    };
    Html5QrcodeScannerStrings.selectCamera = function() {
        return "Select Camera";
    };
    Html5QrcodeScannerStrings.fileSelectionChooseImage = function() {
        return "Choose Image";
    };
    Html5QrcodeScannerStrings.fileSelectionChooseAnother = function() {
        return "Choose Another";
    };
    Html5QrcodeScannerStrings.fileSelectionNoImageSelected = function() {
        return "No image choosen";
    };
    Html5QrcodeScannerStrings.anonymousCameraPrefix = function() {
        return "Anonymous Camera";
    };
    Html5QrcodeScannerStrings.dragAndDropMessage = function() {
        return "Or drop an image to scan";
    };
    Html5QrcodeScannerStrings.dragAndDropMessageOnlyImages = function() {
        return "Or drop an image to scan (other files not supported)";
    };
    Html5QrcodeScannerStrings.zoom = function() {
        return "zoom";
    };
    Html5QrcodeScannerStrings.loadingImage = function() {
        return "Loading image...";
    };
    Html5QrcodeScannerStrings.cameraScanAltText = function() {
        return "Camera based scan";
    };
    Html5QrcodeScannerStrings.fileScanAltText = function() {
        return "Fule based scan";
    };
    return Html5QrcodeScannerStrings;
}();
var $ff5e69b322275082$export$ef6635d54d6a0486 = function() {
    function LibraryInfoStrings() {}
    LibraryInfoStrings.poweredBy = function() {
        return "Powered by ";
    };
    LibraryInfoStrings.reportIssues = function() {
        return "Report issues";
    };
    return LibraryInfoStrings;
}();


var $307853ab41d6a77a$export$62a0507decb17869 = function() {
    function VideoConstraintsUtil() {}
    VideoConstraintsUtil.isMediaStreamConstraintsValid = function(videoConstraints, logger) {
        if (typeof videoConstraints !== "object") {
            var typeofVideoConstraints = typeof videoConstraints;
            logger.logError("videoConstraints should be of type object, the " + "object passed is of type ".concat(typeofVideoConstraints, "."), true);
            return false;
        }
        var bannedKeys = [
            "autoGainControl",
            "channelCount",
            "echoCancellation",
            "latency",
            "noiseSuppression",
            "sampleRate",
            "sampleSize",
            "volume"
        ];
        var bannedkeysSet = new Set(bannedKeys);
        var keysInVideoConstraints = Object.keys(videoConstraints);
        for(var _i = 0, keysInVideoConstraints_1 = keysInVideoConstraints; _i < keysInVideoConstraints_1.length; _i++){
            var key = keysInVideoConstraints_1[_i];
            if (bannedkeysSet.has(key)) {
                logger.logError("".concat(key, " is not supported videoConstaints."), true);
                return false;
            }
        }
        return true;
    };
    return VideoConstraintsUtil;
}();


var $56054c647abd5197$exports = {};
(function(global1, factory) {
    factory($56054c647abd5197$exports);
})($56054c647abd5197$exports, function(exports1) {
    'use strict';
    function isNullOrUndefined(obj) {
        return obj === null || obj === undefined;
    }
    /*
     * Copyright 2008 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /* global Reflect, Promise */ var extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    function __extends(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }
    function fixProto(target, prototype) {
        var setPrototypeOf = Object.setPrototypeOf;
        setPrototypeOf ? setPrototypeOf(target, prototype) : target.__proto__ = prototype;
    }
    function fixStack(target, fn) {
        if (fn === void 0) fn = target.constructor;
        var captureStackTrace = Error.captureStackTrace;
        captureStackTrace && captureStackTrace(target, fn);
    }
    var CustomError = function(_super) {
        __extends(CustomError, _super);
        function CustomError(message) {
            var _newTarget = this.constructor;
            var _this = _super.call(this, message) || this;
            Object.defineProperty(_this, 'name', {
                value: _newTarget.name,
                enumerable: false
            });
            fixProto(_this, _newTarget.prototype);
            fixStack(_this);
            return _this;
        }
        return CustomError;
    }(Error);
    /**
     * Custom Error class of type Exception.
     */ class Exception extends CustomError {
        /**
         * Allows Exception to be constructed directly
         * with some message and prototype definition.
         */ constructor(message){
            super(message);
            this.message = message;
        }
        getKind() {
            const ex = this.constructor;
            return ex.kind;
        }
    }
    /**
     * It's typed as string so it can be extended and overriden.
     */ Exception.kind = 'Exception';
    /**
     * Custom Error class of type Exception.
     */ class ArgumentException extends Exception {
    }
    ArgumentException.kind = 'ArgumentException';
    /**
     * Custom Error class of type Exception.
     */ class IllegalArgumentException extends Exception {
    }
    IllegalArgumentException.kind = 'IllegalArgumentException';
    /*
     * Copyright 2009 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ class BinaryBitmap {
        constructor(binarizer){
            this.binarizer = binarizer;
            if (binarizer === null) throw new IllegalArgumentException('Binarizer must be non-null.');
        }
        /**
         * @return The width of the bitmap.
         */ getWidth() {
            return this.binarizer.getWidth();
        }
        /**
         * @return The height of the bitmap.
         */ getHeight() {
            return this.binarizer.getHeight();
        }
        /**
         * Converts one row of luminance data to 1 bit data. May actually do the conversion, or return
         * cached data. Callers should assume this method is expensive and call it as seldom as possible.
         * This method is intended for decoding 1D barcodes and may choose to apply sharpening.
         *
         * @param y The row to fetch, which must be in [0, bitmap height)
         * @param row An optional preallocated array. If null or too small, it will be ignored.
         *            If used, the Binarizer will call BitArray.clear(). Always use the returned object.
         * @return The array of bits for this row (true means black).
         * @throws NotFoundException if row can't be binarized
         */ getBlackRow(y /*int*/ , row) {
            return this.binarizer.getBlackRow(y, row);
        }
        /**
         * Converts a 2D array of luminance data to 1 bit. As above, assume this method is expensive
         * and do not call it repeatedly. This method is intended for decoding 2D barcodes and may or
         * may not apply sharpening. Therefore, a row from this matrix may not be identical to one
         * fetched using getBlackRow(), so don't mix and match between them.
         *
         * @return The 2D array of bits for the image (true means black).
         * @throws NotFoundException if image can't be binarized to make a matrix
         */ getBlackMatrix() {
            // The matrix is created on demand the first time it is requested, then cached. There are two
            // reasons for this:
            // 1. This work will never be done if the caller only installs 1D Reader objects, or if a
            //    1D Reader finds a barcode before the 2D Readers run.
            // 2. This work will only be done once even if the caller installs multiple 2D Readers.
            if (this.matrix === null || this.matrix === undefined) this.matrix = this.binarizer.getBlackMatrix();
            return this.matrix;
        }
        /**
         * @return Whether this bitmap can be cropped.
         */ isCropSupported() {
            return this.binarizer.getLuminanceSource().isCropSupported();
        }
        /**
         * Returns a new object with cropped image data. Implementations may keep a reference to the
         * original data rather than a copy. Only callable if isCropSupported() is true.
         *
         * @param left The left coordinate, which must be in [0,getWidth())
         * @param top The top coordinate, which must be in [0,getHeight())
         * @param width The width of the rectangle to crop.
         * @param height The height of the rectangle to crop.
         * @return A cropped version of this object.
         */ crop(left /*int*/ , top /*int*/ , width /*int*/ , height /*int*/ ) {
            const newSource = this.binarizer.getLuminanceSource().crop(left, top, width, height);
            return new BinaryBitmap(this.binarizer.createBinarizer(newSource));
        }
        /**
         * @return Whether this bitmap supports counter-clockwise rotation.
         */ isRotateSupported() {
            return this.binarizer.getLuminanceSource().isRotateSupported();
        }
        /**
         * Returns a new object with rotated image data by 90 degrees counterclockwise.
         * Only callable if {@link #isRotateSupported()} is true.
         *
         * @return A rotated version of this object.
         */ rotateCounterClockwise() {
            const newSource = this.binarizer.getLuminanceSource().rotateCounterClockwise();
            return new BinaryBitmap(this.binarizer.createBinarizer(newSource));
        }
        /**
         * Returns a new object with rotated image data by 45 degrees counterclockwise.
         * Only callable if {@link #isRotateSupported()} is true.
         *
         * @return A rotated version of this object.
         */ rotateCounterClockwise45() {
            const newSource = this.binarizer.getLuminanceSource().rotateCounterClockwise45();
            return new BinaryBitmap(this.binarizer.createBinarizer(newSource));
        }
        /*@Override*/ toString() {
            try {
                return this.getBlackMatrix().toString();
            } catch (e /*: NotFoundException*/ ) {
                return '';
            }
        }
    }
    /**
     * Custom Error class of type Exception.
     */ class ChecksumException extends Exception {
        static getChecksumInstance() {
            return new ChecksumException();
        }
    }
    ChecksumException.kind = 'ChecksumException';
    /*
     * Copyright 2009 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * This class hierarchy provides a set of methods to convert luminance data to 1 bit data.
     * It allows the algorithm to vary polymorphically, for example allowing a very expensive
     * thresholding technique for servers and a fast one for mobile. It also permits the implementation
     * to vary, e.g. a JNI version for Android and a Java fallback version for other platforms.
     *
     * @author dswitkin@google.com (Daniel Switkin)
     */ class Binarizer {
        constructor(source){
            this.source = source;
        }
        getLuminanceSource() {
            return this.source;
        }
        getWidth() {
            return this.source.getWidth();
        }
        getHeight() {
            return this.source.getHeight();
        }
    }
    class System {
        // public static void arraycopy(Object src, int srcPos, Object dest, int destPos, int length)
        /**
         * Makes a copy of a array.
         */ static arraycopy(src, srcPos, dest, destPos, length) {
            // TODO: better use split or set?
            while(length--)dest[destPos++] = src[srcPos++];
        }
        /**
         * Returns the current time in milliseconds.
         */ static currentTimeMillis() {
            return Date.now();
        }
    }
    /**
     * Custom Error class of type Exception.
     */ class IndexOutOfBoundsException extends Exception {
    }
    IndexOutOfBoundsException.kind = 'IndexOutOfBoundsException';
    /**
     * Custom Error class of type Exception.
     */ class ArrayIndexOutOfBoundsException extends IndexOutOfBoundsException {
        constructor(index, message){
            super(message);
            this.index = index;
            this.message = message;
        }
    }
    ArrayIndexOutOfBoundsException.kind = 'ArrayIndexOutOfBoundsException';
    class Arrays {
        /**
         * Assigns the specified int value to each element of the specified array
         * of ints.
         *
         * @param a the array to be filled
         * @param val the value to be stored in all elements of the array
         */ static fill(a, val) {
            for(let i = 0, len = a.length; i < len; i++)a[i] = val;
        }
        /**
         * Assigns the specified int value to each element of the specified
         * range of the specified array of ints.  The range to be filled
         * extends from index {@code fromIndex}, inclusive, to index
         * {@code toIndex}, exclusive.  (If {@code fromIndex==toIndex}, the
         * range to be filled is empty.)
         *
         * @param a the array to be filled
         * @param fromIndex the index of the first element (inclusive) to be
         *        filled with the specified value
         * @param toIndex the index of the last element (exclusive) to be
         *        filled with the specified value
         * @param val the value to be stored in all elements of the array
         * @throws IllegalArgumentException if {@code fromIndex > toIndex}
         * @throws ArrayIndexOutOfBoundsException if {@code fromIndex < 0} or
         *         {@code toIndex > a.length}
         */ static fillWithin(a, fromIndex, toIndex, val) {
            Arrays.rangeCheck(a.length, fromIndex, toIndex);
            for(let i = fromIndex; i < toIndex; i++)a[i] = val;
        }
        /**
         * Checks that {@code fromIndex} and {@code toIndex} are in
         * the range and throws an exception if they aren't.
         */ static rangeCheck(arrayLength, fromIndex, toIndex) {
            if (fromIndex > toIndex) throw new IllegalArgumentException('fromIndex(' + fromIndex + ') > toIndex(' + toIndex + ')');
            if (fromIndex < 0) throw new ArrayIndexOutOfBoundsException(fromIndex);
            if (toIndex > arrayLength) throw new ArrayIndexOutOfBoundsException(toIndex);
        }
        static asList(...args) {
            return args;
        }
        static create(rows, cols, value) {
            let arr = Array.from({
                length: rows
            });
            return arr.map((x)=>Array.from({
                    length: cols
                }).fill(value));
        }
        static createInt32Array(rows, cols, value) {
            let arr = Array.from({
                length: rows
            });
            return arr.map((x)=>Int32Array.from({
                    length: cols
                }).fill(value));
        }
        static equals(first, second) {
            if (!first) return false;
            if (!second) return false;
            if (!first.length) return false;
            if (!second.length) return false;
            if (first.length !== second.length) return false;
            for(let i = 0, length = first.length; i < length; i++){
                if (first[i] !== second[i]) return false;
            }
            return true;
        }
        static hashCode(a) {
            if (a === null) return 0;
            let result = 1;
            for (const element of a)result = 31 * result + element;
            return result;
        }
        static fillUint8Array(a, value) {
            for(let i = 0; i !== a.length; i++)a[i] = value;
        }
        static copyOf(original, newLength) {
            return original.slice(0, newLength);
        }
        static copyOfUint8Array(original, newLength) {
            if (original.length <= newLength) {
                const newArray = new Uint8Array(newLength);
                newArray.set(original);
                return newArray;
            }
            return original.slice(0, newLength);
        }
        static copyOfRange(original, from, to) {
            const newLength = to - from;
            const copy = new Int32Array(newLength);
            System.arraycopy(original, from, copy, 0, newLength);
            return copy;
        }
        /*
        * Returns the index of of the element in a sorted array or (-n-1) where n is the insertion point
        * for the new element.
        * Parameters:
        *     ar - A sorted array
        *     el - An element to search for
        *     comparator - A comparator function. The function takes two arguments: (a, b) and returns:
        *        a negative number  if a is less than b;
        *        0 if a is equal to b;
        *        a positive number of a is greater than b.
        * The array may contain duplicate elements. If there are more than one equal elements in the array,
        * the returned value can be the index of any one of the equal elements.
        *
        * http://jsfiddle.net/aryzhov/pkfst550/
        */ static binarySearch(ar, el, comparator) {
            if (undefined === comparator) comparator = Arrays.numberComparator;
            let m = 0;
            let n = ar.length - 1;
            while(m <= n){
                const k = n + m >> 1;
                const cmp = comparator(el, ar[k]);
                if (cmp > 0) m = k + 1;
                else if (cmp < 0) n = k - 1;
                else return k;
            }
            return -m - 1;
        }
        static numberComparator(a, b) {
            return a - b;
        }
    }
    /**
     * Ponyfill for Java's Integer class.
     */ class Integer {
        static numberOfTrailingZeros(i) {
            let y;
            if (i === 0) return 32;
            let n = 31;
            y = i << 16;
            if (y !== 0) {
                n -= 16;
                i = y;
            }
            y = i << 8;
            if (y !== 0) {
                n -= 8;
                i = y;
            }
            y = i << 4;
            if (y !== 0) {
                n -= 4;
                i = y;
            }
            y = i << 2;
            if (y !== 0) {
                n -= 2;
                i = y;
            }
            return n - (i << 1 >>> 31);
        }
        static numberOfLeadingZeros(i) {
            // HD, Figure 5-6
            if (i === 0) return 32;
            let n = 1;
            if (i >>> 16 === 0) {
                n += 16;
                i <<= 16;
            }
            if (i >>> 24 === 0) {
                n += 8;
                i <<= 8;
            }
            if (i >>> 28 === 0) {
                n += 4;
                i <<= 4;
            }
            if (i >>> 30 === 0) {
                n += 2;
                i <<= 2;
            }
            n -= i >>> 31;
            return n;
        }
        static toHexString(i) {
            return i.toString(16);
        }
        static toBinaryString(intNumber) {
            return String(parseInt(String(intNumber), 2));
        }
        // Returns the number of one-bits in the two's complement binary representation of the specified int value. This function is sometimes referred to as the population count.
        // Returns:
        // the number of one-bits in the two's complement binary representation of the specified int value.
        static bitCount(i) {
            // HD, Figure 5-2
            i = i - (i >>> 1 & 0x55555555);
            i = (i & 0x33333333) + (i >>> 2 & 0x33333333);
            i = i + (i >>> 4) & 0x0f0f0f0f;
            i = i + (i >>> 8);
            i = i + (i >>> 16);
            return i & 0x3f;
        }
        static truncDivision(dividend, divisor) {
            return Math.trunc(dividend / divisor);
        }
        /**
         * Converts A string to an integer.
         * @param s A string to convert into a number.
         * @param radix A value between 2 and 36 that specifies the base of the number in numString. If this argument is not supplied, strings with a prefix of '0x' are considered hexadecimal. All other strings are considered decimal.
         */ static parseInt(num, radix) {
            return parseInt(num, radix);
        }
    }
    Integer.MIN_VALUE_32_BITS = -2147483648;
    Integer.MAX_VALUE = Number.MAX_SAFE_INTEGER;
    /**
     * <p>A simple, fast array of bits, represented compactly by an array of ints internally.</p>
     *
     * @author Sean Owen
     */ class BitArray {
        // For testing only
        constructor(size /*int*/ , bits){
            if (undefined === size) {
                this.size = 0;
                this.bits = new Int32Array(1);
            } else {
                this.size = size;
                if (undefined === bits || null === bits) this.bits = BitArray.makeArray(size);
                else this.bits = bits;
            }
        }
        getSize() {
            return this.size;
        }
        getSizeInBytes() {
            return Math.floor((this.size + 7) / 8);
        }
        ensureCapacity(size /*int*/ ) {
            if (size > this.bits.length * 32) {
                const newBits = BitArray.makeArray(size);
                System.arraycopy(this.bits, 0, newBits, 0, this.bits.length);
                this.bits = newBits;
            }
        }
        /**
         * @param i bit to get
         * @return true iff bit i is set
         */ get(i /*int*/ ) {
            return (this.bits[Math.floor(i / 32)] & 1 << (i & 0x1F)) !== 0;
        }
        /**
         * Sets bit i.
         *
         * @param i bit to set
         */ set(i /*int*/ ) {
            this.bits[Math.floor(i / 32)] |= 1 << (i & 0x1F);
        }
        /**
         * Flips bit i.
         *
         * @param i bit to set
         */ flip(i /*int*/ ) {
            this.bits[Math.floor(i / 32)] ^= 1 << (i & 0x1F);
        }
        /**
         * @param from first bit to check
         * @return index of first bit that is set, starting from the given index, or size if none are set
         *  at or beyond this given index
         * @see #getNextUnset(int)
         */ getNextSet(from /*int*/ ) {
            const size = this.size;
            if (from >= size) return size;
            const bits = this.bits;
            let bitsOffset = Math.floor(from / 32);
            let currentBits = bits[bitsOffset];
            // mask off lesser bits first
            currentBits &= ~((1 << (from & 0x1F)) - 1);
            const length = bits.length;
            while(currentBits === 0){
                if (++bitsOffset === length) return size;
                currentBits = bits[bitsOffset];
            }
            const result = bitsOffset * 32 + Integer.numberOfTrailingZeros(currentBits);
            return result > size ? size : result;
        }
        /**
         * @param from index to start looking for unset bit
         * @return index of next unset bit, or {@code size} if none are unset until the end
         * @see #getNextSet(int)
         */ getNextUnset(from /*int*/ ) {
            const size = this.size;
            if (from >= size) return size;
            const bits = this.bits;
            let bitsOffset = Math.floor(from / 32);
            let currentBits = ~bits[bitsOffset];
            // mask off lesser bits first
            currentBits &= ~((1 << (from & 0x1F)) - 1);
            const length = bits.length;
            while(currentBits === 0){
                if (++bitsOffset === length) return size;
                currentBits = ~bits[bitsOffset];
            }
            const result = bitsOffset * 32 + Integer.numberOfTrailingZeros(currentBits);
            return result > size ? size : result;
        }
        /**
         * Sets a block of 32 bits, starting at bit i.
         *
         * @param i first bit to set
         * @param newBits the new value of the next 32 bits. Note again that the least-significant bit
         * corresponds to bit i, the next-least-significant to i+1, and so on.
         */ setBulk(i /*int*/ , newBits /*int*/ ) {
            this.bits[Math.floor(i / 32)] = newBits;
        }
        /**
         * Sets a range of bits.
         *
         * @param start start of range, inclusive.
         * @param end end of range, exclusive
         */ setRange(start /*int*/ , end /*int*/ ) {
            if (end < start || start < 0 || end > this.size) throw new IllegalArgumentException();
            if (end === start) return;
            end--; // will be easier to treat this as the last actually set bit -- inclusive
            const firstInt = Math.floor(start / 32);
            const lastInt = Math.floor(end / 32);
            const bits = this.bits;
            for(let i = firstInt; i <= lastInt; i++){
                const firstBit = i > firstInt ? 0 : start & 0x1F;
                const lastBit = i < lastInt ? 31 : end & 0x1F;
                // Ones from firstBit to lastBit, inclusive
                const mask = (2 << lastBit) - (1 << firstBit);
                bits[i] |= mask;
            }
        }
        /**
         * Clears all bits (sets to false).
         */ clear() {
            const max = this.bits.length;
            const bits = this.bits;
            for(let i = 0; i < max; i++)bits[i] = 0;
        }
        /**
         * Efficient method to check if a range of bits is set, or not set.
         *
         * @param start start of range, inclusive.
         * @param end end of range, exclusive
         * @param value if true, checks that bits in range are set, otherwise checks that they are not set
         * 
         * @return true iff all bits are set or not set in range, according to value argument
         * @throws IllegalArgumentException if end is less than start or the range is not contained in the array
         */ isRange(start /*int*/ , end /*int*/ , value) {
            if (end < start || start < 0 || end > this.size) throw new IllegalArgumentException();
            if (end === start) return true; // empty range matches
            end--; // will be easier to treat this as the last actually set bit -- inclusive
            const firstInt = Math.floor(start / 32);
            const lastInt = Math.floor(end / 32);
            const bits = this.bits;
            for(let i = firstInt; i <= lastInt; i++){
                const firstBit = i > firstInt ? 0 : start & 0x1F;
                const lastBit = i < lastInt ? 31 : end & 0x1F;
                // Ones from firstBit to lastBit, inclusive
                const mask = (2 << lastBit) - (1 << firstBit) & 0xFFFFFFFF;
                // TYPESCRIPTPORT: & 0xFFFFFFFF added to discard anything after 32 bits, as ES has 53 bits
                // Return false if we're looking for 1s and the masked bits[i] isn't all 1s (is: that,
                // equals the mask, or we're looking for 0s and the masked portion is not all 0s
                if ((bits[i] & mask) !== (value ? mask : 0)) return false;
            }
            return true;
        }
        appendBit(bit) {
            this.ensureCapacity(this.size + 1);
            if (bit) this.bits[Math.floor(this.size / 32)] |= 1 << (this.size & 0x1F);
            this.size++;
        }
        /**
         * Appends the least-significant bits, from value, in order from most-significant to
         * least-significant. For example, appending 6 bits from 0x000001E will append the bits
         * 0, 1, 1, 1, 1, 0 in that order.
         *
         * @param value {@code int} containing bits to append
         * @param numBits bits from value to append
         */ appendBits(value /*int*/ , numBits /*int*/ ) {
            if (numBits < 0 || numBits > 32) throw new IllegalArgumentException('Num bits must be between 0 and 32');
            this.ensureCapacity(this.size + numBits);
            // const appendBit = this.appendBit;
            for(let numBitsLeft = numBits; numBitsLeft > 0; numBitsLeft--)this.appendBit((value >> numBitsLeft - 1 & 0x01) === 1);
        }
        appendBitArray(other) {
            const otherSize = other.size;
            this.ensureCapacity(this.size + otherSize);
            // const appendBit = this.appendBit;
            for(let i = 0; i < otherSize; i++)this.appendBit(other.get(i));
        }
        xor(other) {
            if (this.size !== other.size) throw new IllegalArgumentException('Sizes don\'t match');
            const bits = this.bits;
            for(let i = 0, length = bits.length; i < length; i++)// The last int could be incomplete (i.e. not have 32 bits in
            // it) but there is no problem since 0 XOR 0 == 0.
            bits[i] ^= other.bits[i];
        }
        /**
         *
         * @param bitOffset first bit to start writing
         * @param array array to write into. Bytes are written most-significant byte first. This is the opposite
         *  of the internal representation, which is exposed by {@link #getBitArray()}
         * @param offset position in array to start writing
         * @param numBytes how many bytes to write
         */ toBytes(bitOffset /*int*/ , array, offset /*int*/ , numBytes /*int*/ ) {
            for(let i = 0; i < numBytes; i++){
                let theByte = 0;
                for(let j = 0; j < 8; j++){
                    if (this.get(bitOffset)) theByte |= 1 << 7 - j;
                    bitOffset++;
                }
                array[offset + i] = /*(byte)*/ theByte;
            }
        }
        /**
         * @return underlying array of ints. The first element holds the first 32 bits, and the least
         *         significant bit is bit 0.
         */ getBitArray() {
            return this.bits;
        }
        /**
         * Reverses all bits in the array.
         */ reverse() {
            const newBits = new Int32Array(this.bits.length);
            // reverse all int's first
            const len = Math.floor((this.size - 1) / 32);
            const oldBitsLen = len + 1;
            const bits = this.bits;
            for(let i = 0; i < oldBitsLen; i++){
                let x = bits[i];
                x = x >> 1 & 0x55555555 | (x & 0x55555555) << 1;
                x = x >> 2 & 0x33333333 | (x & 0x33333333) << 2;
                x = x >> 4 & 0x0f0f0f0f | (x & 0x0f0f0f0f) << 4;
                x = x >> 8 & 0x00ff00ff | (x & 0x00ff00ff) << 8;
                x = x >> 16 & 0x0000ffff | (x & 0x0000ffff) << 16;
                newBits[len - i] = /*(int)*/ x;
            }
            // now correct the int's if the bit size isn't a multiple of 32
            if (this.size !== oldBitsLen * 32) {
                const leftOffset = oldBitsLen * 32 - this.size;
                let currentInt = newBits[0] >>> leftOffset;
                for(let i = 1; i < oldBitsLen; i++){
                    const nextInt = newBits[i];
                    currentInt |= nextInt << 32 - leftOffset;
                    newBits[i - 1] = currentInt;
                    currentInt = nextInt >>> leftOffset;
                }
                newBits[oldBitsLen - 1] = currentInt;
            }
            this.bits = newBits;
        }
        static makeArray(size /*int*/ ) {
            return new Int32Array(Math.floor((size + 31) / 32));
        }
        /*@Override*/ equals(o) {
            if (!(o instanceof BitArray)) return false;
            const other = o;
            return this.size === other.size && Arrays.equals(this.bits, other.bits);
        }
        /*@Override*/ hashCode() {
            return 31 * this.size + Arrays.hashCode(this.bits);
        }
        /*@Override*/ toString() {
            let result = '';
            for(let i = 0, size = this.size; i < size; i++){
                if ((i & 0x07) === 0) result += ' ';
                result += this.get(i) ? 'X' : '.';
            }
            return result;
        }
        /*@Override*/ clone() {
            return new BitArray(this.size, this.bits.slice());
        }
    }
    /*
     * Copyright 2009 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /*namespace com.google.zxing {*/ /**
     * Encapsulates a type of hint that a caller may pass to a barcode reader to help it
     * more quickly or accurately decode it. It is up to implementations to decide what,
     * if anything, to do with the information that is supplied.
     *
     * @author Sean Owen
     * @author dswitkin@google.com (Daniel Switkin)
     * @see Reader#decode(BinaryBitmap,java.util.Map)
     */ var DecodeHintType;
    (function(DecodeHintType) {
        /**
         * Unspecified, application-specific hint. Maps to an unspecified {@link Object}.
         */ DecodeHintType[DecodeHintType["OTHER"] = 0] = "OTHER"; /*(Object.class)*/ 
        /**
         * Image is a pure monochrome image of a barcode. Doesn't matter what it maps to;
         * use {@link Boolean#TRUE}.
         */ DecodeHintType[DecodeHintType["PURE_BARCODE"] = 1] = "PURE_BARCODE"; /*(Void.class)*/ 
        /**
         * Image is known to be of one of a few possible formats.
         * Maps to a {@link List} of {@link BarcodeFormat}s.
         */ DecodeHintType[DecodeHintType["POSSIBLE_FORMATS"] = 2] = "POSSIBLE_FORMATS"; /*(List.class)*/ 
        /**
         * Spend more time to try to find a barcode; optimize for accuracy, not speed.
         * Doesn't matter what it maps to; use {@link Boolean#TRUE}.
         */ DecodeHintType[DecodeHintType["TRY_HARDER"] = 3] = "TRY_HARDER"; /*(Void.class)*/ 
        /**
         * Specifies what character encoding to use when decoding, where applicable (type String)
         */ DecodeHintType[DecodeHintType["CHARACTER_SET"] = 4] = "CHARACTER_SET"; /*(String.class)*/ 
        /**
         * Allowed lengths of encoded data -- reject anything else. Maps to an {@code Int32Array}.
         */ DecodeHintType[DecodeHintType["ALLOWED_LENGTHS"] = 5] = "ALLOWED_LENGTHS"; /*(Int32Array.class)*/ 
        /**
         * Assume Code 39 codes employ a check digit. Doesn't matter what it maps to;
         * use {@link Boolean#TRUE}.
         */ DecodeHintType[DecodeHintType["ASSUME_CODE_39_CHECK_DIGIT"] = 6] = "ASSUME_CODE_39_CHECK_DIGIT"; /*(Void.class)*/ 
        /**
         * Assume the barcode is being processed as a GS1 barcode, and modify behavior as needed.
         * For example this affects FNC1 handling for Code 128 (aka GS1-128). Doesn't matter what it maps to;
         * use {@link Boolean#TRUE}.
         */ DecodeHintType[DecodeHintType["ASSUME_GS1"] = 7] = "ASSUME_GS1"; /*(Void.class)*/ 
        /**
         * If true, return the start and end digits in a Codabar barcode instead of stripping them. They
         * are alpha, whereas the rest are numeric. By default, they are stripped, but this causes them
         * to not be. Doesn't matter what it maps to; use {@link Boolean#TRUE}.
         */ DecodeHintType[DecodeHintType["RETURN_CODABAR_START_END"] = 8] = "RETURN_CODABAR_START_END"; /*(Void.class)*/ 
        /**
         * The caller needs to be notified via callback when a possible {@link ResultPoint}
         * is found. Maps to a {@link ResultPointCallback}.
         */ DecodeHintType[DecodeHintType["NEED_RESULT_POINT_CALLBACK"] = 9] = "NEED_RESULT_POINT_CALLBACK"; /*(ResultPointCallback.class)*/ 
        /**
         * Allowed extension lengths for EAN or UPC barcodes. Other formats will ignore this.
         * Maps to an {@code Int32Array} of the allowed extension lengths, for example [2], [5], or [2, 5].
         * If it is optional to have an extension, do not set this hint. If this is set,
         * and a UPC or EAN barcode is found but an extension is not, then no result will be returned
         * at all.
         */ DecodeHintType[DecodeHintType["ALLOWED_EAN_EXTENSIONS"] = 10] = "ALLOWED_EAN_EXTENSIONS"; /*(Int32Array.class)*/ 
    // End of enumeration values.
    /**
         * Data type the hint is expecting.
         * Among the possible values the {@link Void} stands out as being used for
         * hints that do not expect a value to be supplied (flag hints). Such hints
         * will possibly have their value ignored, or replaced by a
         * {@link Boolean#TRUE}. Hint suppliers should probably use
         * {@link Boolean#TRUE} as directed by the actual hint documentation.
         */ // private valueType: Class<?>
    // DecodeHintType(valueType: Class<?>) {
    //   this.valueType = valueType
    // }
    // public getValueType(): Class<?> {
    //   return valueType
    // }
    })(DecodeHintType || (DecodeHintType = {}));
    var DecodeHintType$1 = DecodeHintType;
    /**
     * Custom Error class of type Exception.
     */ class FormatException extends Exception {
        static getFormatInstance() {
            return new FormatException();
        }
    }
    FormatException.kind = 'FormatException';
    /*import java.util.HashMap;*/ /*import java.util.Map;*/ var CharacterSetValueIdentifiers;
    (function(CharacterSetValueIdentifiers) {
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["Cp437"] = 0] = "Cp437";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_1"] = 1] = "ISO8859_1";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_2"] = 2] = "ISO8859_2";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_3"] = 3] = "ISO8859_3";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_4"] = 4] = "ISO8859_4";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_5"] = 5] = "ISO8859_5";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_6"] = 6] = "ISO8859_6";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_7"] = 7] = "ISO8859_7";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_8"] = 8] = "ISO8859_8";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_9"] = 9] = "ISO8859_9";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_10"] = 10] = "ISO8859_10";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_11"] = 11] = "ISO8859_11";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_13"] = 12] = "ISO8859_13";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_14"] = 13] = "ISO8859_14";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_15"] = 14] = "ISO8859_15";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_16"] = 15] = "ISO8859_16";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["SJIS"] = 16] = "SJIS";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["Cp1250"] = 17] = "Cp1250";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["Cp1251"] = 18] = "Cp1251";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["Cp1252"] = 19] = "Cp1252";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["Cp1256"] = 20] = "Cp1256";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["UnicodeBigUnmarked"] = 21] = "UnicodeBigUnmarked";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["UTF8"] = 22] = "UTF8";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ASCII"] = 23] = "ASCII";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["Big5"] = 24] = "Big5";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["GB18030"] = 25] = "GB18030";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["EUC_KR"] = 26] = "EUC_KR";
    })(CharacterSetValueIdentifiers || (CharacterSetValueIdentifiers = {}));
    /**
     * Encapsulates a Character Set ECI, according to "Extended Channel Interpretations" 5.3.1.1
     * of ISO 18004.
     *
     * @author Sean Owen
     */ class CharacterSetECI {
        constructor(valueIdentifier, valuesParam, name, ...otherEncodingNames){
            this.valueIdentifier = valueIdentifier;
            this.name = name;
            if (typeof valuesParam === 'number') this.values = Int32Array.from([
                valuesParam
            ]);
            else this.values = valuesParam;
            this.otherEncodingNames = otherEncodingNames;
            CharacterSetECI.VALUE_IDENTIFIER_TO_ECI.set(valueIdentifier, this);
            CharacterSetECI.NAME_TO_ECI.set(name, this);
            const values = this.values;
            for(let i = 0, length = values.length; i !== length; i++){
                const v = values[i];
                CharacterSetECI.VALUES_TO_ECI.set(v, this);
            }
            for (const otherName of otherEncodingNames)CharacterSetECI.NAME_TO_ECI.set(otherName, this);
        }
        // CharacterSetECI(value: number /*int*/) {
        //   this(new Int32Array {value})
        // }
        // CharacterSetECI(value: number /*int*/, String... otherEncodingNames) {
        //   this.values = new Int32Array {value}
        //   this.otherEncodingNames = otherEncodingNames
        // }
        // CharacterSetECI(values: Int32Array, String... otherEncodingNames) {
        //   this.values = values
        //   this.otherEncodingNames = otherEncodingNames
        // }
        getValueIdentifier() {
            return this.valueIdentifier;
        }
        getName() {
            return this.name;
        }
        getValue() {
            return this.values[0];
        }
        /**
         * @param value character set ECI value
         * @return {@code CharacterSetECI} representing ECI of given value, or null if it is legal but
         *   unsupported
         * @throws FormatException if ECI value is invalid
         */ static getCharacterSetECIByValue(value /*int*/ ) {
            if (value < 0 || value >= 900) throw new FormatException('incorect value');
            const characterSet = CharacterSetECI.VALUES_TO_ECI.get(value);
            if (undefined === characterSet) throw new FormatException('incorect value');
            return characterSet;
        }
        /**
         * @param name character set ECI encoding name
         * @return CharacterSetECI representing ECI for character encoding, or null if it is legal
         *   but unsupported
         */ static getCharacterSetECIByName(name) {
            const characterSet = CharacterSetECI.NAME_TO_ECI.get(name);
            if (undefined === characterSet) throw new FormatException('incorect value');
            return characterSet;
        }
        equals(o) {
            if (!(o instanceof CharacterSetECI)) return false;
            const other = o;
            return this.getName() === other.getName();
        }
    }
    CharacterSetECI.VALUE_IDENTIFIER_TO_ECI = new Map();
    CharacterSetECI.VALUES_TO_ECI = new Map();
    CharacterSetECI.NAME_TO_ECI = new Map();
    // Enum name is a Java encoding valid for java.lang and java.io
    // TYPESCRIPTPORT: changed the main label for ISO as the TextEncoder did not recognized them in the form from java
    // (eg ISO8859_1 must be ISO88591 or ISO8859-1 or ISO-8859-1)
    // later on: well, except 16 wich does not work with ISO885916 so used ISO-8859-1 form for default
    CharacterSetECI.Cp437 = new CharacterSetECI(CharacterSetValueIdentifiers.Cp437, Int32Array.from([
        0,
        2
    ]), 'Cp437');
    CharacterSetECI.ISO8859_1 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_1, Int32Array.from([
        1,
        3
    ]), 'ISO-8859-1', 'ISO88591', 'ISO8859_1');
    CharacterSetECI.ISO8859_2 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_2, 4, 'ISO-8859-2', 'ISO88592', 'ISO8859_2');
    CharacterSetECI.ISO8859_3 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_3, 5, 'ISO-8859-3', 'ISO88593', 'ISO8859_3');
    CharacterSetECI.ISO8859_4 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_4, 6, 'ISO-8859-4', 'ISO88594', 'ISO8859_4');
    CharacterSetECI.ISO8859_5 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_5, 7, 'ISO-8859-5', 'ISO88595', 'ISO8859_5');
    CharacterSetECI.ISO8859_6 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_6, 8, 'ISO-8859-6', 'ISO88596', 'ISO8859_6');
    CharacterSetECI.ISO8859_7 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_7, 9, 'ISO-8859-7', 'ISO88597', 'ISO8859_7');
    CharacterSetECI.ISO8859_8 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_8, 10, 'ISO-8859-8', 'ISO88598', 'ISO8859_8');
    CharacterSetECI.ISO8859_9 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_9, 11, 'ISO-8859-9', 'ISO88599', 'ISO8859_9');
    CharacterSetECI.ISO8859_10 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_10, 12, 'ISO-8859-10', 'ISO885910', 'ISO8859_10');
    CharacterSetECI.ISO8859_11 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_11, 13, 'ISO-8859-11', 'ISO885911', 'ISO8859_11');
    CharacterSetECI.ISO8859_13 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_13, 15, 'ISO-8859-13', 'ISO885913', 'ISO8859_13');
    CharacterSetECI.ISO8859_14 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_14, 16, 'ISO-8859-14', 'ISO885914', 'ISO8859_14');
    CharacterSetECI.ISO8859_15 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_15, 17, 'ISO-8859-15', 'ISO885915', 'ISO8859_15');
    CharacterSetECI.ISO8859_16 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_16, 18, 'ISO-8859-16', 'ISO885916', 'ISO8859_16');
    CharacterSetECI.SJIS = new CharacterSetECI(CharacterSetValueIdentifiers.SJIS, 20, 'SJIS', 'Shift_JIS');
    CharacterSetECI.Cp1250 = new CharacterSetECI(CharacterSetValueIdentifiers.Cp1250, 21, 'Cp1250', 'windows-1250');
    CharacterSetECI.Cp1251 = new CharacterSetECI(CharacterSetValueIdentifiers.Cp1251, 22, 'Cp1251', 'windows-1251');
    CharacterSetECI.Cp1252 = new CharacterSetECI(CharacterSetValueIdentifiers.Cp1252, 23, 'Cp1252', 'windows-1252');
    CharacterSetECI.Cp1256 = new CharacterSetECI(CharacterSetValueIdentifiers.Cp1256, 24, 'Cp1256', 'windows-1256');
    CharacterSetECI.UnicodeBigUnmarked = new CharacterSetECI(CharacterSetValueIdentifiers.UnicodeBigUnmarked, 25, 'UnicodeBigUnmarked', 'UTF-16BE', 'UnicodeBig');
    CharacterSetECI.UTF8 = new CharacterSetECI(CharacterSetValueIdentifiers.UTF8, 26, 'UTF8', 'UTF-8');
    CharacterSetECI.ASCII = new CharacterSetECI(CharacterSetValueIdentifiers.ASCII, Int32Array.from([
        27,
        170
    ]), 'ASCII', 'US-ASCII');
    CharacterSetECI.Big5 = new CharacterSetECI(CharacterSetValueIdentifiers.Big5, 28, 'Big5');
    CharacterSetECI.GB18030 = new CharacterSetECI(CharacterSetValueIdentifiers.GB18030, 29, 'GB18030', 'GB2312', 'EUC_CN', 'GBK');
    CharacterSetECI.EUC_KR = new CharacterSetECI(CharacterSetValueIdentifiers.EUC_KR, 30, 'EUC_KR', 'EUC-KR');
    /**
     * Custom Error class of type Exception.
     */ class UnsupportedOperationException extends Exception {
    }
    UnsupportedOperationException.kind = 'UnsupportedOperationException';
    /**
     * Responsible for en/decoding strings.
     */ class StringEncoding {
        /**
         * Decodes some Uint8Array to a string format.
         */ static decode(bytes, encoding) {
            const encodingName = this.encodingName(encoding);
            if (this.customDecoder) return this.customDecoder(bytes, encodingName);
            // Increases browser support.
            if (typeof TextDecoder === 'undefined' || this.shouldDecodeOnFallback(encodingName)) return this.decodeFallback(bytes, encodingName);
            return new TextDecoder(encodingName).decode(bytes);
        }
        /**
         * Checks if the decoding method should use the fallback for decoding
         * once Node TextDecoder doesn't support all encoding formats.
         *
         * @param encodingName
         */ static shouldDecodeOnFallback(encodingName) {
            return !StringEncoding.isBrowser() && encodingName === 'ISO-8859-1';
        }
        /**
         * Encodes some string into a Uint8Array.
         */ static encode(s, encoding) {
            const encodingName = this.encodingName(encoding);
            if (this.customEncoder) return this.customEncoder(s, encodingName);
            // Increases browser support.
            if (typeof TextEncoder === 'undefined') return this.encodeFallback(s);
            // TextEncoder only encodes to UTF8 by default as specified by encoding.spec.whatwg.org
            return new TextEncoder().encode(s);
        }
        static isBrowser() {
            return typeof window !== 'undefined' && ({}).toString.call(window) === '[object Window]';
        }
        /**
         * Returns the string value from some encoding character set.
         */ static encodingName(encoding) {
            return typeof encoding === 'string' ? encoding : encoding.getName();
        }
        /**
         * Returns character set from some encoding character set.
         */ static encodingCharacterSet(encoding) {
            if (encoding instanceof CharacterSetECI) return encoding;
            return CharacterSetECI.getCharacterSetECIByName(encoding);
        }
        /**
         * Runs a fallback for the native decoding funcion.
         */ static decodeFallback(bytes, encoding) {
            const characterSet = this.encodingCharacterSet(encoding);
            if (StringEncoding.isDecodeFallbackSupported(characterSet)) {
                let s = '';
                for(let i = 0, length = bytes.length; i < length; i++){
                    let h = bytes[i].toString(16);
                    if (h.length < 2) h = '0' + h;
                    s += '%' + h;
                }
                return decodeURIComponent(s);
            }
            if (characterSet.equals(CharacterSetECI.UnicodeBigUnmarked)) return String.fromCharCode.apply(null, new Uint16Array(bytes.buffer));
            throw new UnsupportedOperationException(`Encoding ${this.encodingName(encoding)} not supported by fallback.`);
        }
        static isDecodeFallbackSupported(characterSet) {
            return characterSet.equals(CharacterSetECI.UTF8) || characterSet.equals(CharacterSetECI.ISO8859_1) || characterSet.equals(CharacterSetECI.ASCII);
        }
        /**
         * Runs a fallback for the native encoding funcion.
         *
         * @see https://stackoverflow.com/a/17192845/4367683
         */ static encodeFallback(s) {
            const encodedURIstring = btoa(unescape(encodeURIComponent(s)));
            const charList = encodedURIstring.split('');
            const uintArray = [];
            for(let i = 0; i < charList.length; i++)uintArray.push(charList[i].charCodeAt(0));
            return new Uint8Array(uintArray);
        }
    }
    /*
     * Copyright (C) 2010 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * Common string-related functions.
     *
     * @author Sean Owen
     * @author Alex Dupre
     */ class StringUtils {
        // SHIFT_JIS.equalsIgnoreCase(PLATFORM_DEFAULT_ENCODING) ||
        // EUC_JP.equalsIgnoreCase(PLATFORM_DEFAULT_ENCODING);
        static castAsNonUtf8Char(code, encoding = null) {
            // ISO 8859-1 is the Java default as UTF-8 is JavaScripts
            // you can see this method as a Java version of String.fromCharCode
            const e = encoding ? encoding.getName() : this.ISO88591;
            // use passed format (fromCharCode will return UTF8 encoding)
            return StringEncoding.decode(new Uint8Array([
                code
            ]), e);
        }
        /**
         * @param bytes bytes encoding a string, whose encoding should be guessed
         * @param hints decode hints if applicable
         * @return name of guessed encoding; at the moment will only guess one of:
         *  {@link #SHIFT_JIS}, {@link #UTF8}, {@link #ISO88591}, or the platform
         *  default encoding if none of these can possibly be correct
         */ static guessEncoding(bytes, hints) {
            if (hints !== null && hints !== undefined && undefined !== hints.get(DecodeHintType$1.CHARACTER_SET)) return hints.get(DecodeHintType$1.CHARACTER_SET).toString();
            // For now, merely tries to distinguish ISO-8859-1, UTF-8 and Shift_JIS,
            // which should be by far the most common encodings.
            const length = bytes.length;
            let canBeISO88591 = true;
            let canBeShiftJIS = true;
            let canBeUTF8 = true;
            let utf8BytesLeft = 0;
            // int utf8LowChars = 0
            let utf2BytesChars = 0;
            let utf3BytesChars = 0;
            let utf4BytesChars = 0;
            let sjisBytesLeft = 0;
            // int sjisLowChars = 0
            let sjisKatakanaChars = 0;
            // int sjisDoubleBytesChars = 0
            let sjisCurKatakanaWordLength = 0;
            let sjisCurDoubleBytesWordLength = 0;
            let sjisMaxKatakanaWordLength = 0;
            let sjisMaxDoubleBytesWordLength = 0;
            // int isoLowChars = 0
            // int isoHighChars = 0
            let isoHighOther = 0;
            const utf8bom = bytes.length > 3 && bytes[0] === /*(byte) */ 0xEF && bytes[1] === /*(byte) */ 0xBB && bytes[2] === /*(byte) */ 0xBF;
            for(let i = 0; i < length && (canBeISO88591 || canBeShiftJIS || canBeUTF8); i++){
                const value = bytes[i] & 0xFF;
                // UTF-8 stuff
                if (canBeUTF8) {
                    if (utf8BytesLeft > 0) {
                        if ((value & 0x80) === 0) canBeUTF8 = false;
                        else utf8BytesLeft--;
                    } else if ((value & 0x80) !== 0) {
                        if ((value & 0x40) === 0) canBeUTF8 = false;
                        else {
                            utf8BytesLeft++;
                            if ((value & 0x20) === 0) utf2BytesChars++;
                            else {
                                utf8BytesLeft++;
                                if ((value & 0x10) === 0) utf3BytesChars++;
                                else {
                                    utf8BytesLeft++;
                                    if ((value & 0x08) === 0) utf4BytesChars++;
                                    else canBeUTF8 = false;
                                }
                            }
                        }
                    } // else {
                // utf8LowChars++
                // }
                }
                // ISO-8859-1 stuff
                if (canBeISO88591) {
                    if (value > 0x7F && value < 0xA0) canBeISO88591 = false;
                    else if (value > 0x9F) {
                        if (value < 0xC0 || value === 0xD7 || value === 0xF7) isoHighOther++;
                         // else {
                    } // else {
                // isoLowChars++
                // }
                }
                // Shift_JIS stuff
                if (canBeShiftJIS) {
                    if (sjisBytesLeft > 0) {
                        if (value < 0x40 || value === 0x7F || value > 0xFC) canBeShiftJIS = false;
                        else sjisBytesLeft--;
                    } else if (value === 0x80 || value === 0xA0 || value > 0xEF) canBeShiftJIS = false;
                    else if (value > 0xA0 && value < 0xE0) {
                        sjisKatakanaChars++;
                        sjisCurDoubleBytesWordLength = 0;
                        sjisCurKatakanaWordLength++;
                        if (sjisCurKatakanaWordLength > sjisMaxKatakanaWordLength) sjisMaxKatakanaWordLength = sjisCurKatakanaWordLength;
                    } else if (value > 0x7F) {
                        sjisBytesLeft++;
                        // sjisDoubleBytesChars++
                        sjisCurKatakanaWordLength = 0;
                        sjisCurDoubleBytesWordLength++;
                        if (sjisCurDoubleBytesWordLength > sjisMaxDoubleBytesWordLength) sjisMaxDoubleBytesWordLength = sjisCurDoubleBytesWordLength;
                    } else {
                        // sjisLowChars++
                        sjisCurKatakanaWordLength = 0;
                        sjisCurDoubleBytesWordLength = 0;
                    }
                }
            }
            if (canBeUTF8 && utf8BytesLeft > 0) canBeUTF8 = false;
            if (canBeShiftJIS && sjisBytesLeft > 0) canBeShiftJIS = false;
            // Easy -- if there is BOM or at least 1 valid not-single byte character (and no evidence it can't be UTF-8), done
            if (canBeUTF8 && (utf8bom || utf2BytesChars + utf3BytesChars + utf4BytesChars > 0)) return StringUtils.UTF8;
            // Easy -- if assuming Shift_JIS or at least 3 valid consecutive not-ascii characters (and no evidence it can't be), done
            if (canBeShiftJIS && (StringUtils.ASSUME_SHIFT_JIS || sjisMaxKatakanaWordLength >= 3 || sjisMaxDoubleBytesWordLength >= 3)) return StringUtils.SHIFT_JIS;
            // Distinguishing Shift_JIS and ISO-8859-1 can be a little tough for short words. The crude heuristic is:
            // - If we saw
            //   - only two consecutive katakana chars in the whole text, or
            //   - at least 10% of bytes that could be "upper" not-alphanumeric Latin1,
            // - then we conclude Shift_JIS, else ISO-8859-1
            if (canBeISO88591 && canBeShiftJIS) return sjisMaxKatakanaWordLength === 2 && sjisKatakanaChars === 2 || isoHighOther * 10 >= length ? StringUtils.SHIFT_JIS : StringUtils.ISO88591;
            // Otherwise, try in order ISO-8859-1, Shift JIS, UTF-8 and fall back to default platform encoding
            if (canBeISO88591) return StringUtils.ISO88591;
            if (canBeShiftJIS) return StringUtils.SHIFT_JIS;
            if (canBeUTF8) return StringUtils.UTF8;
            // Otherwise, we take a wild guess with platform encoding
            return StringUtils.PLATFORM_DEFAULT_ENCODING;
        }
        /**
         *
         * @see https://stackoverflow.com/a/13439711/4367683
         *
         * @param append The new string to append.
         * @param args Argumets values to be formated.
         */ static format(append, ...args) {
            let i = -1;
            function callback(exp, p0, p1, p2, p3, p4) {
                if (exp === '%%') return '%';
                if (args[++i] === undefined) return undefined;
                exp = p2 ? parseInt(p2.substr(1)) : undefined;
                let base = p3 ? parseInt(p3.substr(1)) : undefined;
                let val;
                switch(p4){
                    case 's':
                        val = args[i];
                        break;
                    case 'c':
                        val = args[i][0];
                        break;
                    case 'f':
                        val = parseFloat(args[i]).toFixed(exp);
                        break;
                    case 'p':
                        val = parseFloat(args[i]).toPrecision(exp);
                        break;
                    case 'e':
                        val = parseFloat(args[i]).toExponential(exp);
                        break;
                    case 'x':
                        val = parseInt(args[i]).toString(base ? base : 16);
                        break;
                    case 'd':
                        val = parseFloat(parseInt(args[i], base ? base : 10).toPrecision(exp)).toFixed(0);
                        break;
                }
                val = typeof val === 'object' ? JSON.stringify(val) : (+val).toString(base);
                let size = parseInt(p1); /* padding size */ 
                let ch = p1 && p1[0] + '' === '0' ? '0' : ' '; /* isnull? */ 
                while(val.length < size)val = p0 !== undefined ? val + ch : ch + val; /* isminus? */ 
                return val;
            }
            let regex = /%(-)?(0?[0-9]+)?([.][0-9]+)?([#][0-9]+)?([scfpexd%])/g;
            return append.replace(regex, callback);
        }
        /**
         *
         */ static getBytes(str, encoding) {
            return StringEncoding.encode(str, encoding);
        }
        /**
         * Returns the charcode at the specified index or at index zero.
         */ static getCharCode(str, index = 0) {
            return str.charCodeAt(index);
        }
        /**
         * Returns char for given charcode
         */ static getCharAt(charCode) {
            return String.fromCharCode(charCode);
        }
    }
    StringUtils.SHIFT_JIS = CharacterSetECI.SJIS.getName(); // "SJIS"
    StringUtils.GB2312 = 'GB2312';
    StringUtils.ISO88591 = CharacterSetECI.ISO8859_1.getName(); // "ISO8859_1"
    StringUtils.EUC_JP = 'EUC_JP';
    StringUtils.UTF8 = CharacterSetECI.UTF8.getName(); // "UTF8"
    StringUtils.PLATFORM_DEFAULT_ENCODING = StringUtils.UTF8; // "UTF8"//Charset.defaultCharset().name()
    StringUtils.ASSUME_SHIFT_JIS = false;
    class StringBuilder {
        constructor(value = ''){
            this.value = value;
        }
        enableDecoding(encoding) {
            this.encoding = encoding;
            return this;
        }
        append(s) {
            if (typeof s === 'string') this.value += s.toString();
            else if (this.encoding) // use passed format (fromCharCode will return UTF8 encoding)
            this.value += StringUtils.castAsNonUtf8Char(s, this.encoding);
            else // correctly converts from UTF-8, but not other encodings
            this.value += String.fromCharCode(s);
            return this;
        }
        appendChars(str, offset, len) {
            for(let i = offset; offset < offset + len; i++)this.append(str[i]);
            return this;
        }
        length() {
            return this.value.length;
        }
        charAt(n) {
            return this.value.charAt(n);
        }
        deleteCharAt(n) {
            this.value = this.value.substr(0, n) + this.value.substring(n + 1);
        }
        setCharAt(n, c) {
            this.value = this.value.substr(0, n) + c + this.value.substr(n + 1);
        }
        substring(start, end) {
            return this.value.substring(start, end);
        }
        /**
         * @note helper method for RSS Expanded
         */ setLengthToZero() {
            this.value = '';
        }
        toString() {
            return this.value;
        }
        insert(n, c) {
            this.value = this.value.substr(0, n) + c + this.value.substr(n + c.length);
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * <p>Represents a 2D matrix of bits. In function arguments below, and throughout the common
     * module, x is the column position, and y is the row position. The ordering is always x, y.
     * The origin is at the top-left.</p>
     *
     * <p>Internally the bits are represented in a 1-D array of 32-bit ints. However, each row begins
     * with a new int. This is done intentionally so that we can copy out a row into a BitArray very
     * efficiently.</p>
     *
     * <p>The ordering of bits is row-major. Within each int, the least significant bits are used first,
     * meaning they represent lower x values. This is compatible with BitArray's implementation.</p>
     *
     * @author Sean Owen
     * @author dswitkin@google.com (Daniel Switkin)
     */ class BitMatrix {
        /**
         * Creates an empty square {@link BitMatrix}.
         *
         * @param dimension height and width
         */ // public constructor(dimension: number /*int*/) {
        //   this(dimension, dimension)
        // }
        /**
         * Creates an empty {@link BitMatrix}.
         *
         * @param width bit matrix width
         * @param height bit matrix height
         */ // public constructor(width: number /*int*/, height: number /*int*/) {
        //   if (width < 1 || height < 1) {
        //     throw new IllegalArgumentException("Both dimensions must be greater than 0")
        //   }
        //   this.width = width
        //   this.height = height
        //   this.rowSize = (width + 31) / 32
        //   bits = new int[rowSize * height];
        // }
        constructor(width /*int*/ , height /*int*/ , rowSize /*int*/ , bits){
            this.width = width;
            this.height = height;
            this.rowSize = rowSize;
            this.bits = bits;
            if (undefined === height || null === height) height = width;
            this.height = height;
            if (width < 1 || height < 1) throw new IllegalArgumentException('Both dimensions must be greater than 0');
            if (undefined === rowSize || null === rowSize) rowSize = Math.floor((width + 31) / 32);
            this.rowSize = rowSize;
            if (undefined === bits || null === bits) this.bits = new Int32Array(this.rowSize * this.height);
        }
        /**
         * Interprets a 2D array of booleans as a {@link BitMatrix}, where "true" means an "on" bit.
         *
         * @function parse
         * @param image bits of the image, as a row-major 2D array. Elements are arrays representing rows
         * @return {@link BitMatrix} representation of image
         */ static parseFromBooleanArray(image) {
            const height = image.length;
            const width = image[0].length;
            const bits = new BitMatrix(width, height);
            for(let i = 0; i < height; i++){
                const imageI = image[i];
                for(let j = 0; j < width; j++)if (imageI[j]) bits.set(j, i);
            }
            return bits;
        }
        /**
         *
         * @function parse
         * @param stringRepresentation
         * @param setString
         * @param unsetString
         */ static parseFromString(stringRepresentation, setString, unsetString) {
            if (stringRepresentation === null) throw new IllegalArgumentException('stringRepresentation cannot be null');
            const bits = new Array(stringRepresentation.length);
            let bitsPos = 0;
            let rowStartPos = 0;
            let rowLength = -1;
            let nRows = 0;
            let pos = 0;
            while(pos < stringRepresentation.length){
                if (stringRepresentation.charAt(pos) === '\n' || stringRepresentation.charAt(pos) === '\r') {
                    if (bitsPos > rowStartPos) {
                        if (rowLength === -1) rowLength = bitsPos - rowStartPos;
                        else if (bitsPos - rowStartPos !== rowLength) throw new IllegalArgumentException('row lengths do not match');
                        rowStartPos = bitsPos;
                        nRows++;
                    }
                    pos++;
                } else if (stringRepresentation.substring(pos, pos + setString.length) === setString) {
                    pos += setString.length;
                    bits[bitsPos] = true;
                    bitsPos++;
                } else if (stringRepresentation.substring(pos, pos + unsetString.length) === unsetString) {
                    pos += unsetString.length;
                    bits[bitsPos] = false;
                    bitsPos++;
                } else throw new IllegalArgumentException('illegal character encountered: ' + stringRepresentation.substring(pos));
            }
            // no EOL at end?
            if (bitsPos > rowStartPos) {
                if (rowLength === -1) rowLength = bitsPos - rowStartPos;
                else if (bitsPos - rowStartPos !== rowLength) throw new IllegalArgumentException('row lengths do not match');
                nRows++;
            }
            const matrix = new BitMatrix(rowLength, nRows);
            for(let i = 0; i < bitsPos; i++)if (bits[i]) matrix.set(Math.floor(i % rowLength), Math.floor(i / rowLength));
            return matrix;
        }
        /**
         * <p>Gets the requested bit, where true means black.</p>
         *
         * @param x The horizontal component (i.e. which column)
         * @param y The vertical component (i.e. which row)
         * @return value of given bit in matrix
         */ get(x /*int*/ , y /*int*/ ) {
            const offset = y * this.rowSize + Math.floor(x / 32);
            return (this.bits[offset] >>> (x & 0x1f) & 1) !== 0;
        }
        /**
         * <p>Sets the given bit to true.</p>
         *
         * @param x The horizontal component (i.e. which column)
         * @param y The vertical component (i.e. which row)
         */ set(x /*int*/ , y /*int*/ ) {
            const offset = y * this.rowSize + Math.floor(x / 32);
            this.bits[offset] |= 1 << (x & 0x1f) & 0xFFFFFFFF;
        }
        unset(x /*int*/ , y /*int*/ ) {
            const offset = y * this.rowSize + Math.floor(x / 32);
            this.bits[offset] &= ~(1 << (x & 0x1f) & 0xFFFFFFFF);
        }
        /**
         * <p>Flips the given bit.</p>
         *
         * @param x The horizontal component (i.e. which column)
         * @param y The vertical component (i.e. which row)
         */ flip(x /*int*/ , y /*int*/ ) {
            const offset = y * this.rowSize + Math.floor(x / 32);
            this.bits[offset] ^= 1 << (x & 0x1f) & 0xFFFFFFFF;
        }
        /**
         * Exclusive-or (XOR): Flip the bit in this {@code BitMatrix} if the corresponding
         * mask bit is set.
         *
         * @param mask XOR mask
         */ xor(mask) {
            if (this.width !== mask.getWidth() || this.height !== mask.getHeight() || this.rowSize !== mask.getRowSize()) throw new IllegalArgumentException('input matrix dimensions do not match');
            const rowArray = new BitArray(Math.floor(this.width / 32) + 1);
            const rowSize = this.rowSize;
            const bits = this.bits;
            for(let y = 0, height = this.height; y < height; y++){
                const offset = y * rowSize;
                const row = mask.getRow(y, rowArray).getBitArray();
                for(let x = 0; x < rowSize; x++)bits[offset + x] ^= row[x];
            }
        }
        /**
         * Clears all bits (sets to false).
         */ clear() {
            const bits = this.bits;
            const max = bits.length;
            for(let i = 0; i < max; i++)bits[i] = 0;
        }
        /**
         * <p>Sets a square region of the bit matrix to true.</p>
         *
         * @param left The horizontal position to begin at (inclusive)
         * @param top The vertical position to begin at (inclusive)
         * @param width The width of the region
         * @param height The height of the region
         */ setRegion(left /*int*/ , top /*int*/ , width /*int*/ , height /*int*/ ) {
            if (top < 0 || left < 0) throw new IllegalArgumentException('Left and top must be nonnegative');
            if (height < 1 || width < 1) throw new IllegalArgumentException('Height and width must be at least 1');
            const right = left + width;
            const bottom = top + height;
            if (bottom > this.height || right > this.width) throw new IllegalArgumentException('The region must fit inside the matrix');
            const rowSize = this.rowSize;
            const bits = this.bits;
            for(let y = top; y < bottom; y++){
                const offset = y * rowSize;
                for(let x = left; x < right; x++)bits[offset + Math.floor(x / 32)] |= 1 << (x & 0x1f) & 0xFFFFFFFF;
            }
        }
        /**
         * A fast method to retrieve one row of data from the matrix as a BitArray.
         *
         * @param y The row to retrieve
         * @param row An optional caller-allocated BitArray, will be allocated if null or too small
         * @return The resulting BitArray - this reference should always be used even when passing
         *         your own row
         */ getRow(y /*int*/ , row) {
            if (row === null || row === undefined || row.getSize() < this.width) row = new BitArray(this.width);
            else row.clear();
            const rowSize = this.rowSize;
            const bits = this.bits;
            const offset = y * rowSize;
            for(let x = 0; x < rowSize; x++)row.setBulk(x * 32, bits[offset + x]);
            return row;
        }
        /**
         * @param y row to set
         * @param row {@link BitArray} to copy from
         */ setRow(y /*int*/ , row) {
            System.arraycopy(row.getBitArray(), 0, this.bits, y * this.rowSize, this.rowSize);
        }
        /**
         * Modifies this {@code BitMatrix} to represent the same but rotated 180 degrees
         */ rotate180() {
            const width = this.getWidth();
            const height = this.getHeight();
            let topRow = new BitArray(width);
            let bottomRow = new BitArray(width);
            for(let i = 0, length = Math.floor((height + 1) / 2); i < length; i++){
                topRow = this.getRow(i, topRow);
                bottomRow = this.getRow(height - 1 - i, bottomRow);
                topRow.reverse();
                bottomRow.reverse();
                this.setRow(i, bottomRow);
                this.setRow(height - 1 - i, topRow);
            }
        }
        /**
         * This is useful in detecting the enclosing rectangle of a 'pure' barcode.
         *
         * @return {@code left,top,width,height} enclosing rectangle of all 1 bits, or null if it is all white
         */ getEnclosingRectangle() {
            const width = this.width;
            const height = this.height;
            const rowSize = this.rowSize;
            const bits = this.bits;
            let left = width;
            let top = height;
            let right = -1;
            let bottom = -1;
            for(let y = 0; y < height; y++)for(let x32 = 0; x32 < rowSize; x32++){
                const theBits = bits[y * rowSize + x32];
                if (theBits !== 0) {
                    if (y < top) top = y;
                    if (y > bottom) bottom = y;
                    if (x32 * 32 < left) {
                        let bit = 0;
                        while((theBits << 31 - bit & 0xFFFFFFFF) === 0)bit++;
                        if (x32 * 32 + bit < left) left = x32 * 32 + bit;
                    }
                    if (x32 * 32 + 31 > right) {
                        let bit = 31;
                        while(theBits >>> bit === 0)bit--;
                        if (x32 * 32 + bit > right) right = x32 * 32 + bit;
                    }
                }
            }
            if (right < left || bottom < top) return null;
            return Int32Array.from([
                left,
                top,
                right - left + 1,
                bottom - top + 1
            ]);
        }
        /**
         * This is useful in detecting a corner of a 'pure' barcode.
         *
         * @return {@code x,y} coordinate of top-left-most 1 bit, or null if it is all white
         */ getTopLeftOnBit() {
            const rowSize = this.rowSize;
            const bits = this.bits;
            let bitsOffset = 0;
            while(bitsOffset < bits.length && bits[bitsOffset] === 0)bitsOffset++;
            if (bitsOffset === bits.length) return null;
            const y = bitsOffset / rowSize;
            let x = bitsOffset % rowSize * 32;
            const theBits = bits[bitsOffset];
            let bit = 0;
            while((theBits << 31 - bit & 0xFFFFFFFF) === 0)bit++;
            x += bit;
            return Int32Array.from([
                x,
                y
            ]);
        }
        getBottomRightOnBit() {
            const rowSize = this.rowSize;
            const bits = this.bits;
            let bitsOffset = bits.length - 1;
            while(bitsOffset >= 0 && bits[bitsOffset] === 0)bitsOffset--;
            if (bitsOffset < 0) return null;
            const y = Math.floor(bitsOffset / rowSize);
            let x = Math.floor(bitsOffset % rowSize) * 32;
            const theBits = bits[bitsOffset];
            let bit = 31;
            while(theBits >>> bit === 0)bit--;
            x += bit;
            return Int32Array.from([
                x,
                y
            ]);
        }
        /**
         * @return The width of the matrix
         */ getWidth() {
            return this.width;
        }
        /**
         * @return The height of the matrix
         */ getHeight() {
            return this.height;
        }
        /**
         * @return The row size of the matrix
         */ getRowSize() {
            return this.rowSize;
        }
        /*@Override*/ equals(o) {
            if (!(o instanceof BitMatrix)) return false;
            const other = o;
            return this.width === other.width && this.height === other.height && this.rowSize === other.rowSize && Arrays.equals(this.bits, other.bits);
        }
        /*@Override*/ hashCode() {
            let hash = this.width;
            hash = 31 * hash + this.width;
            hash = 31 * hash + this.height;
            hash = 31 * hash + this.rowSize;
            hash = 31 * hash + Arrays.hashCode(this.bits);
            return hash;
        }
        /**
         * @return string representation using "X" for set and " " for unset bits
         */ /*@Override*/ // public toString(): string {
        //   return toString(": "X, "  ")
        // }
        /**
         * @param setString representation of a set bit
         * @param unsetString representation of an unset bit
         * @return string representation of entire matrix utilizing given strings
         */ // public toString(setString: string = "X ", unsetString: string = "  "): string {
        //   return this.buildToString(setString, unsetString, "\n")
        // }
        /**
         * @param setString representation of a set bit
         * @param unsetString representation of an unset bit
         * @param lineSeparator newline character in string representation
         * @return string representation of entire matrix utilizing given strings and line separator
         * @deprecated call {@link #toString(String,String)} only, which uses \n line separator always
         */ // @Deprecated
        toString(setString = 'X ', unsetString = '  ', lineSeparator = '\n') {
            return this.buildToString(setString, unsetString, lineSeparator);
        }
        buildToString(setString, unsetString, lineSeparator) {
            let result = new StringBuilder();
            // result.append(lineSeparator);
            for(let y = 0, height = this.height; y < height; y++){
                for(let x = 0, width = this.width; x < width; x++)result.append(this.get(x, y) ? setString : unsetString);
                result.append(lineSeparator);
            }
            return result.toString();
        }
        /*@Override*/ clone() {
            return new BitMatrix(this.width, this.height, this.rowSize, this.bits.slice());
        }
    }
    /**
     * Custom Error class of type Exception.
     */ class NotFoundException extends Exception {
        static getNotFoundInstance() {
            return new NotFoundException();
        }
    }
    NotFoundException.kind = 'NotFoundException';
    /*
     * Copyright 2009 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * This Binarizer implementation uses the old ZXing global histogram approach. It is suitable
     * for low-end mobile devices which don't have enough CPU or memory to use a local thresholding
     * algorithm. However, because it picks a global black point, it cannot handle difficult shadows
     * and gradients.
     *
     * Faster mobile devices and all desktop applications should probably use HybridBinarizer instead.
     *
     * @author dswitkin@google.com (Daniel Switkin)
     * @author Sean Owen
     */ class GlobalHistogramBinarizer extends Binarizer {
        constructor(source){
            super(source);
            this.luminances = GlobalHistogramBinarizer.EMPTY;
            this.buckets = new Int32Array(GlobalHistogramBinarizer.LUMINANCE_BUCKETS);
        }
        // Applies simple sharpening to the row data to improve performance of the 1D Readers.
        /*@Override*/ getBlackRow(y /*int*/ , row) {
            const source = this.getLuminanceSource();
            const width = source.getWidth();
            if (row === undefined || row === null || row.getSize() < width) row = new BitArray(width);
            else row.clear();
            this.initArrays(width);
            const localLuminances = source.getRow(y, this.luminances);
            const localBuckets = this.buckets;
            for(let x = 0; x < width; x++)localBuckets[(localLuminances[x] & 0xff) >> GlobalHistogramBinarizer.LUMINANCE_SHIFT]++;
            const blackPoint = GlobalHistogramBinarizer.estimateBlackPoint(localBuckets);
            if (width < 3) {
                // Special case for very small images
                for(let x = 0; x < width; x++)if ((localLuminances[x] & 0xff) < blackPoint) row.set(x);
            } else {
                let left = localLuminances[0] & 0xff;
                let center = localLuminances[1] & 0xff;
                for(let x = 1; x < width - 1; x++){
                    const right = localLuminances[x + 1] & 0xff;
                    // A simple -1 4 -1 box filter with a weight of 2.
                    if ((center * 4 - left - right) / 2 < blackPoint) row.set(x);
                    left = center;
                    center = right;
                }
            }
            return row;
        }
        // Does not sharpen the data, as this call is intended to only be used by 2D Readers.
        /*@Override*/ getBlackMatrix() {
            const source = this.getLuminanceSource();
            const width = source.getWidth();
            const height = source.getHeight();
            const matrix = new BitMatrix(width, height);
            // Quickly calculates the histogram by sampling four rows from the image. This proved to be
            // more robust on the blackbox tests than sampling a diagonal as we used to do.
            this.initArrays(width);
            const localBuckets = this.buckets;
            for(let y = 1; y < 5; y++){
                const row = Math.floor(height * y / 5);
                const localLuminances = source.getRow(row, this.luminances);
                const right = Math.floor(width * 4 / 5);
                for(let x = Math.floor(width / 5); x < right; x++){
                    const pixel = localLuminances[x] & 0xff;
                    localBuckets[pixel >> GlobalHistogramBinarizer.LUMINANCE_SHIFT]++;
                }
            }
            const blackPoint = GlobalHistogramBinarizer.estimateBlackPoint(localBuckets);
            // We delay reading the entire image luminance until the black point estimation succeeds.
            // Although we end up reading four rows twice, it is consistent with our motto of
            // "fail quickly" which is necessary for continuous scanning.
            const localLuminances = source.getMatrix();
            for(let y = 0; y < height; y++){
                const offset = y * width;
                for(let x = 0; x < width; x++){
                    const pixel = localLuminances[offset + x] & 0xff;
                    if (pixel < blackPoint) matrix.set(x, y);
                }
            }
            return matrix;
        }
        /*@Override*/ createBinarizer(source) {
            return new GlobalHistogramBinarizer(source);
        }
        initArrays(luminanceSize /*int*/ ) {
            if (this.luminances.length < luminanceSize) this.luminances = new Uint8ClampedArray(luminanceSize);
            const buckets = this.buckets;
            for(let x = 0; x < GlobalHistogramBinarizer.LUMINANCE_BUCKETS; x++)buckets[x] = 0;
        }
        static estimateBlackPoint(buckets) {
            // Find the tallest peak in the histogram.
            const numBuckets = buckets.length;
            let maxBucketCount = 0;
            let firstPeak = 0;
            let firstPeakSize = 0;
            for(let x = 0; x < numBuckets; x++){
                if (buckets[x] > firstPeakSize) {
                    firstPeak = x;
                    firstPeakSize = buckets[x];
                }
                if (buckets[x] > maxBucketCount) maxBucketCount = buckets[x];
            }
            // Find the second-tallest peak which is somewhat far from the tallest peak.
            let secondPeak = 0;
            let secondPeakScore = 0;
            for(let x = 0; x < numBuckets; x++){
                const distanceToBiggest = x - firstPeak;
                // Encourage more distant second peaks by multiplying by square of distance.
                const score = buckets[x] * distanceToBiggest * distanceToBiggest;
                if (score > secondPeakScore) {
                    secondPeak = x;
                    secondPeakScore = score;
                }
            }
            // Make sure firstPeak corresponds to the black peak.
            if (firstPeak > secondPeak) {
                const temp = firstPeak;
                firstPeak = secondPeak;
                secondPeak = temp;
            }
            // If there is too little contrast in the image to pick a meaningful black point, throw rather
            // than waste time trying to decode the image, and risk false positives.
            if (secondPeak - firstPeak <= numBuckets / 16) throw new NotFoundException();
            // Find a valley between them that is low and closer to the white peak.
            let bestValley = secondPeak - 1;
            let bestValleyScore = -1;
            for(let x = secondPeak - 1; x > firstPeak; x--){
                const fromFirst = x - firstPeak;
                const score = fromFirst * fromFirst * (secondPeak - x) * (maxBucketCount - buckets[x]);
                if (score > bestValleyScore) {
                    bestValley = x;
                    bestValleyScore = score;
                }
            }
            return bestValley << GlobalHistogramBinarizer.LUMINANCE_SHIFT;
        }
    }
    GlobalHistogramBinarizer.LUMINANCE_BITS = 5;
    GlobalHistogramBinarizer.LUMINANCE_SHIFT = 8 - GlobalHistogramBinarizer.LUMINANCE_BITS;
    GlobalHistogramBinarizer.LUMINANCE_BUCKETS = 1 << GlobalHistogramBinarizer.LUMINANCE_BITS;
    GlobalHistogramBinarizer.EMPTY = Uint8ClampedArray.from([
        0
    ]);
    /*
     * Copyright 2009 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * This class implements a local thresholding algorithm, which while slower than the
     * GlobalHistogramBinarizer, is fairly efficient for what it does. It is designed for
     * high frequency images of barcodes with black data on white backgrounds. For this application,
     * it does a much better job than a global blackpoint with severe shadows and gradients.
     * However it tends to produce artifacts on lower frequency images and is therefore not
     * a good general purpose binarizer for uses outside ZXing.
     *
     * This class extends GlobalHistogramBinarizer, using the older histogram approach for 1D readers,
     * and the newer local approach for 2D readers. 1D decoding using a per-row histogram is already
     * inherently local, and only fails for horizontal gradients. We can revisit that problem later,
     * but for now it was not a win to use local blocks for 1D.
     *
     * This Binarizer is the default for the unit tests and the recommended class for library users.
     *
     * @author dswitkin@google.com (Daniel Switkin)
     */ class HybridBinarizer extends GlobalHistogramBinarizer {
        constructor(source){
            super(source);
            this.matrix = null;
        }
        /**
         * Calculates the final BitMatrix once for all requests. This could be called once from the
         * constructor instead, but there are some advantages to doing it lazily, such as making
         * profiling easier, and not doing heavy lifting when callers don't expect it.
         */ /*@Override*/ getBlackMatrix() {
            if (this.matrix !== null) return this.matrix;
            const source = this.getLuminanceSource();
            const width = source.getWidth();
            const height = source.getHeight();
            if (width >= HybridBinarizer.MINIMUM_DIMENSION && height >= HybridBinarizer.MINIMUM_DIMENSION) {
                const luminances = source.getMatrix();
                let subWidth = width >> HybridBinarizer.BLOCK_SIZE_POWER;
                if ((width & HybridBinarizer.BLOCK_SIZE_MASK) !== 0) subWidth++;
                let subHeight = height >> HybridBinarizer.BLOCK_SIZE_POWER;
                if ((height & HybridBinarizer.BLOCK_SIZE_MASK) !== 0) subHeight++;
                const blackPoints = HybridBinarizer.calculateBlackPoints(luminances, subWidth, subHeight, width, height);
                const newMatrix = new BitMatrix(width, height);
                HybridBinarizer.calculateThresholdForBlock(luminances, subWidth, subHeight, width, height, blackPoints, newMatrix);
                this.matrix = newMatrix;
            } else // If the image is too small, fall back to the global histogram approach.
            this.matrix = super.getBlackMatrix();
            return this.matrix;
        }
        /*@Override*/ createBinarizer(source) {
            return new HybridBinarizer(source);
        }
        /**
         * For each block in the image, calculate the average black point using a 5x5 grid
         * of the blocks around it. Also handles the corner cases (fractional blocks are computed based
         * on the last pixels in the row/column which are also used in the previous block).
         */ static calculateThresholdForBlock(luminances, subWidth /*int*/ , subHeight /*int*/ , width /*int*/ , height /*int*/ , blackPoints, matrix) {
            const maxYOffset = height - HybridBinarizer.BLOCK_SIZE;
            const maxXOffset = width - HybridBinarizer.BLOCK_SIZE;
            for(let y = 0; y < subHeight; y++){
                let yoffset = y << HybridBinarizer.BLOCK_SIZE_POWER;
                if (yoffset > maxYOffset) yoffset = maxYOffset;
                const top = HybridBinarizer.cap(y, 2, subHeight - 3);
                for(let x = 0; x < subWidth; x++){
                    let xoffset = x << HybridBinarizer.BLOCK_SIZE_POWER;
                    if (xoffset > maxXOffset) xoffset = maxXOffset;
                    const left = HybridBinarizer.cap(x, 2, subWidth - 3);
                    let sum = 0;
                    for(let z = -2; z <= 2; z++){
                        const blackRow = blackPoints[top + z];
                        sum += blackRow[left - 2] + blackRow[left - 1] + blackRow[left] + blackRow[left + 1] + blackRow[left + 2];
                    }
                    const average = sum / 25;
                    HybridBinarizer.thresholdBlock(luminances, xoffset, yoffset, average, width, matrix);
                }
            }
        }
        static cap(value /*int*/ , min /*int*/ , max /*int*/ ) {
            return value < min ? min : value > max ? max : value;
        }
        /**
         * Applies a single threshold to a block of pixels.
         */ static thresholdBlock(luminances, xoffset /*int*/ , yoffset /*int*/ , threshold /*int*/ , stride /*int*/ , matrix) {
            for(let y = 0, offset = yoffset * stride + xoffset; y < HybridBinarizer.BLOCK_SIZE; y++, offset += stride){
                for(let x = 0; x < HybridBinarizer.BLOCK_SIZE; x++)// Comparison needs to be <= so that black == 0 pixels are black even if the threshold is 0.
                if ((luminances[offset + x] & 0xFF) <= threshold) matrix.set(xoffset + x, yoffset + y);
            }
        }
        /**
         * Calculates a single black point for each block of pixels and saves it away.
         * See the following thread for a discussion of this algorithm:
         *  http://groups.google.com/group/zxing/browse_thread/thread/d06efa2c35a7ddc0
         */ static calculateBlackPoints(luminances, subWidth /*int*/ , subHeight /*int*/ , width /*int*/ , height /*int*/ ) {
            const maxYOffset = height - HybridBinarizer.BLOCK_SIZE;
            const maxXOffset = width - HybridBinarizer.BLOCK_SIZE;
            // tslint:disable-next-line:whitespace
            const blackPoints = new Array(subHeight); // subWidth
            for(let y = 0; y < subHeight; y++){
                blackPoints[y] = new Int32Array(subWidth);
                let yoffset = y << HybridBinarizer.BLOCK_SIZE_POWER;
                if (yoffset > maxYOffset) yoffset = maxYOffset;
                for(let x = 0; x < subWidth; x++){
                    let xoffset = x << HybridBinarizer.BLOCK_SIZE_POWER;
                    if (xoffset > maxXOffset) xoffset = maxXOffset;
                    let sum = 0;
                    let min = 0xFF;
                    let max = 0;
                    for(let yy = 0, offset = yoffset * width + xoffset; yy < HybridBinarizer.BLOCK_SIZE; yy++, offset += width){
                        for(let xx = 0; xx < HybridBinarizer.BLOCK_SIZE; xx++){
                            const pixel = luminances[offset + xx] & 0xFF;
                            sum += pixel;
                            // still looking for good contrast
                            if (pixel < min) min = pixel;
                            if (pixel > max) max = pixel;
                        }
                        // short-circuit min/max tests once dynamic range is met
                        if (max - min > HybridBinarizer.MIN_DYNAMIC_RANGE) {
                            // finish the rest of the rows quickly
                            for(yy++, offset += width; yy < HybridBinarizer.BLOCK_SIZE; yy++, offset += width)for(let xx = 0; xx < HybridBinarizer.BLOCK_SIZE; xx++)sum += luminances[offset + xx] & 0xFF;
                        }
                    }
                    // The default estimate is the average of the values in the block.
                    let average = sum >> HybridBinarizer.BLOCK_SIZE_POWER * 2;
                    if (max - min <= HybridBinarizer.MIN_DYNAMIC_RANGE) {
                        // If variation within the block is low, assume this is a block with only light or only
                        // dark pixels. In that case we do not want to use the average, as it would divide this
                        // low contrast area into black and white pixels, essentially creating data out of noise.
                        //
                        // The default assumption is that the block is light/background. Since no estimate for
                        // the level of dark pixels exists locally, use half the min for the block.
                        average = min / 2;
                        if (y > 0 && x > 0) {
                            // Correct the "white background" assumption for blocks that have neighbors by comparing
                            // the pixels in this block to the previously calculated black points. This is based on
                            // the fact that dark barcode symbology is always surrounded by some amount of light
                            // background for which reasonable black point estimates were made. The bp estimated at
                            // the boundaries is used for the interior.
                            // The (min < bp) is arbitrary but works better than other heuristics that were tried.
                            const averageNeighborBlackPoint = (blackPoints[y - 1][x] + 2 * blackPoints[y][x - 1] + blackPoints[y - 1][x - 1]) / 4;
                            if (min < averageNeighborBlackPoint) average = averageNeighborBlackPoint;
                        }
                    }
                    blackPoints[y][x] = average;
                }
            }
            return blackPoints;
        }
    }
    // This class uses 5x5 blocks to compute local luminance, where each block is 8x8 pixels.
    // So this is the smallest dimension in each axis we can accept.
    HybridBinarizer.BLOCK_SIZE_POWER = 3;
    HybridBinarizer.BLOCK_SIZE = 1 << HybridBinarizer.BLOCK_SIZE_POWER; // ...0100...00
    HybridBinarizer.BLOCK_SIZE_MASK = HybridBinarizer.BLOCK_SIZE - 1; // ...0011...11
    HybridBinarizer.MINIMUM_DIMENSION = HybridBinarizer.BLOCK_SIZE * 5;
    HybridBinarizer.MIN_DYNAMIC_RANGE = 24;
    /*
     * Copyright 2009 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /*namespace com.google.zxing {*/ /**
     * The purpose of this class hierarchy is to abstract different bitmap implementations across
     * platforms into a standard interface for requesting greyscale luminance values. The interface
     * only provides immutable methods; therefore crop and rotation create copies. This is to ensure
     * that one Reader does not modify the original luminance source and leave it in an unknown state
     * for other Readers in the chain.
     *
     * @author dswitkin@google.com (Daniel Switkin)
     */ class LuminanceSource {
        constructor(width /*int*/ , height /*int*/ ){
            this.width = width;
            this.height = height;
        }
        /**
         * @return The width of the bitmap.
         */ getWidth() {
            return this.width;
        }
        /**
         * @return The height of the bitmap.
         */ getHeight() {
            return this.height;
        }
        /**
         * @return Whether this subclass supports cropping.
         */ isCropSupported() {
            return false;
        }
        /**
         * Returns a new object with cropped image data. Implementations may keep a reference to the
         * original data rather than a copy. Only callable if isCropSupported() is true.
         *
         * @param left The left coordinate, which must be in [0,getWidth())
         * @param top The top coordinate, which must be in [0,getHeight())
         * @param width The width of the rectangle to crop.
         * @param height The height of the rectangle to crop.
         * @return A cropped version of this object.
         */ crop(left /*int*/ , top /*int*/ , width /*int*/ , height /*int*/ ) {
            throw new UnsupportedOperationException('This luminance source does not support cropping.');
        }
        /**
         * @return Whether this subclass supports counter-clockwise rotation.
         */ isRotateSupported() {
            return false;
        }
        /**
         * Returns a new object with rotated image data by 90 degrees counterclockwise.
         * Only callable if {@link #isRotateSupported()} is true.
         *
         * @return A rotated version of this object.
         */ rotateCounterClockwise() {
            throw new UnsupportedOperationException('This luminance source does not support rotation by 90 degrees.');
        }
        /**
         * Returns a new object with rotated image data by 45 degrees counterclockwise.
         * Only callable if {@link #isRotateSupported()} is true.
         *
         * @return A rotated version of this object.
         */ rotateCounterClockwise45() {
            throw new UnsupportedOperationException('This luminance source does not support rotation by 45 degrees.');
        }
        /*@Override*/ toString() {
            const row = new Uint8ClampedArray(this.width);
            let result = new StringBuilder();
            for(let y = 0; y < this.height; y++){
                const sourceRow = this.getRow(y, row);
                for(let x = 0; x < this.width; x++){
                    const luminance = sourceRow[x] & 0xFF;
                    let c;
                    if (luminance < 0x40) c = '#';
                    else if (luminance < 0x80) c = '+';
                    else if (luminance < 0xC0) c = '.';
                    else c = ' ';
                    result.append(c);
                }
                result.append('\n');
            }
            return result.toString();
        }
    }
    /*
     * Copyright 2009 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /*namespace com.google.zxing {*/ /**
     * A wrapper implementation of {@link LuminanceSource} which inverts the luminances it returns -- black becomes
     * white and vice versa, and each value becomes (255-value).
     *
     * @author Sean Owen
     */ class InvertedLuminanceSource extends LuminanceSource {
        constructor(delegate){
            super(delegate.getWidth(), delegate.getHeight());
            this.delegate = delegate;
        }
        /*@Override*/ getRow(y /*int*/ , row) {
            const sourceRow = this.delegate.getRow(y, row);
            const width = this.getWidth();
            for(let i = 0; i < width; i++)sourceRow[i] = /*(byte)*/ 255 - (sourceRow[i] & 0xFF);
            return sourceRow;
        }
        /*@Override*/ getMatrix() {
            const matrix = this.delegate.getMatrix();
            const length = this.getWidth() * this.getHeight();
            const invertedMatrix = new Uint8ClampedArray(length);
            for(let i = 0; i < length; i++)invertedMatrix[i] = /*(byte)*/ 255 - (matrix[i] & 0xFF);
            return invertedMatrix;
        }
        /*@Override*/ isCropSupported() {
            return this.delegate.isCropSupported();
        }
        /*@Override*/ crop(left /*int*/ , top /*int*/ , width /*int*/ , height /*int*/ ) {
            return new InvertedLuminanceSource(this.delegate.crop(left, top, width, height));
        }
        /*@Override*/ isRotateSupported() {
            return this.delegate.isRotateSupported();
        }
        /**
         * @return original delegate {@link LuminanceSource} since invert undoes itself
         */ /*@Override*/ invert() {
            return this.delegate;
        }
        /*@Override*/ rotateCounterClockwise() {
            return new InvertedLuminanceSource(this.delegate.rotateCounterClockwise());
        }
        /*@Override*/ rotateCounterClockwise45() {
            return new InvertedLuminanceSource(this.delegate.rotateCounterClockwise45());
        }
    }
    /**
     * @deprecated Moving to @zxing/browser
     */ class HTMLCanvasElementLuminanceSource extends LuminanceSource {
        constructor(canvas){
            super(canvas.width, canvas.height);
            this.canvas = canvas;
            this.tempCanvasElement = null;
            this.buffer = HTMLCanvasElementLuminanceSource.makeBufferFromCanvasImageData(canvas);
        }
        static makeBufferFromCanvasImageData(canvas) {
            const imageData = canvas.getContext('2d').getImageData(0, 0, canvas.width, canvas.height);
            return HTMLCanvasElementLuminanceSource.toGrayscaleBuffer(imageData.data, canvas.width, canvas.height);
        }
        static toGrayscaleBuffer(imageBuffer, width, height) {
            const grayscaleBuffer = new Uint8ClampedArray(width * height);
            for(let i = 0, j = 0, length = imageBuffer.length; i < length; i += 4, j++){
                let gray;
                const alpha = imageBuffer[i + 3];
                // The color of fully-transparent pixels is irrelevant. They are often, technically, fully-transparent
                // black (0 alpha, and then 0 RGB). They are often used, of course as the "white" area in a
                // barcode image. Force any such pixel to be white:
                if (alpha === 0) gray = 0xFF;
                else {
                    const pixelR = imageBuffer[i];
                    const pixelG = imageBuffer[i + 1];
                    const pixelB = imageBuffer[i + 2];
                    // .299R + 0.587G + 0.114B (YUV/YIQ for PAL and NTSC),
                    // (306*R) >> 10 is approximately equal to R*0.299, and so on.
                    // 0x200 >> 10 is 0.5, it implements rounding.
                    gray = 306 * pixelR + 601 * pixelG + 117 * pixelB + 0x200 >> 10;
                }
                grayscaleBuffer[j] = gray;
            }
            return grayscaleBuffer;
        }
        getRow(y /*int*/ , row) {
            if (y < 0 || y >= this.getHeight()) throw new IllegalArgumentException('Requested row is outside the image: ' + y);
            const width = this.getWidth();
            const start = y * width;
            if (row === null) row = this.buffer.slice(start, start + width);
            else {
                if (row.length < width) row = new Uint8ClampedArray(width);
                // The underlying raster of image consists of bytes with the luminance values
                // TODO: can avoid set/slice?
                row.set(this.buffer.slice(start, start + width));
            }
            return row;
        }
        getMatrix() {
            return this.buffer;
        }
        isCropSupported() {
            return true;
        }
        crop(left /*int*/ , top /*int*/ , width /*int*/ , height /*int*/ ) {
            super.crop(left, top, width, height);
            return this;
        }
        /**
         * This is always true, since the image is a gray-scale image.
         *
         * @return true
         */ isRotateSupported() {
            return true;
        }
        rotateCounterClockwise() {
            this.rotate(-90);
            return this;
        }
        rotateCounterClockwise45() {
            this.rotate(-45);
            return this;
        }
        getTempCanvasElement() {
            if (null === this.tempCanvasElement) {
                const tempCanvasElement = this.canvas.ownerDocument.createElement('canvas');
                tempCanvasElement.width = this.canvas.width;
                tempCanvasElement.height = this.canvas.height;
                this.tempCanvasElement = tempCanvasElement;
            }
            return this.tempCanvasElement;
        }
        rotate(angle) {
            const tempCanvasElement = this.getTempCanvasElement();
            const tempContext = tempCanvasElement.getContext('2d');
            const angleRadians = angle * HTMLCanvasElementLuminanceSource.DEGREE_TO_RADIANS;
            // Calculate and set new dimensions for temp canvas
            const width = this.canvas.width;
            const height = this.canvas.height;
            const newWidth = Math.ceil(Math.abs(Math.cos(angleRadians)) * width + Math.abs(Math.sin(angleRadians)) * height);
            const newHeight = Math.ceil(Math.abs(Math.sin(angleRadians)) * width + Math.abs(Math.cos(angleRadians)) * height);
            tempCanvasElement.width = newWidth;
            tempCanvasElement.height = newHeight;
            // Draw at center of temp canvas to prevent clipping of image data
            tempContext.translate(newWidth / 2, newHeight / 2);
            tempContext.rotate(angleRadians);
            tempContext.drawImage(this.canvas, width / -2, height / -2);
            this.buffer = HTMLCanvasElementLuminanceSource.makeBufferFromCanvasImageData(tempCanvasElement);
            return this;
        }
        invert() {
            return new InvertedLuminanceSource(this);
        }
    }
    HTMLCanvasElementLuminanceSource.DEGREE_TO_RADIANS = Math.PI / 180;
    /**
     * @deprecated Moving to @zxing/browser
     *
     * Video input device metadata containing the id and label of the device if available.
     */ class VideoInputDevice {
        /**
         * Creates an instance of VideoInputDevice.
         *
         * @param {string} deviceId the video input device id
         * @param {string} label the label of the device if available
         */ constructor(deviceId, label, groupId){
            this.deviceId = deviceId;
            this.label = label;
            /** @inheritdoc */ this.kind = 'videoinput';
            this.groupId = groupId || undefined;
        }
        /** @inheritdoc */ toJSON() {
            return {
                kind: this.kind,
                groupId: this.groupId,
                deviceId: this.deviceId,
                label: this.label
            };
        }
    }
    var __awaiter = (globalThis || $parcel$global || self || window || undefined) && (globalThis || $parcel$global || self || window || undefined).__awaiter || function(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    };
    /**
     * @deprecated Moving to @zxing/browser
     *
     * Base class for browser code reader.
     */ class BrowserCodeReader {
        /**
         * Creates an instance of BrowserCodeReader.
         * @param {Reader} reader The reader instance to decode the barcode
         * @param {number} [timeBetweenScansMillis=500] the time delay between subsequent successful decode tries
         *
         * @memberOf BrowserCodeReader
         */ constructor(reader, timeBetweenScansMillis = 500, _hints){
            this.reader = reader;
            this.timeBetweenScansMillis = timeBetweenScansMillis;
            this._hints = _hints;
            /**
             * This will break the loop.
             */ this._stopContinuousDecode = false;
            /**
             * This will break the loop.
             */ this._stopAsyncDecode = false;
            /**
             * Delay time between decode attempts made by the scanner.
             */ this._timeBetweenDecodingAttempts = 0;
        }
        /**
         * If navigator is present.
         */ get hasNavigator() {
            return typeof navigator !== 'undefined';
        }
        /**
         * If mediaDevices under navigator is supported.
         */ get isMediaDevicesSuported() {
            return this.hasNavigator && !!navigator.mediaDevices;
        }
        /**
         * If enumerateDevices under navigator is supported.
         */ get canEnumerateDevices() {
            return !!(this.isMediaDevicesSuported && navigator.mediaDevices.enumerateDevices);
        }
        /** Time between two decoding tries in milli seconds. */ get timeBetweenDecodingAttempts() {
            return this._timeBetweenDecodingAttempts;
        }
        /**
         * Change the time span the decoder waits between two decoding tries.
         *
         * @param {number} millis Time between two decoding tries in milli seconds.
         */ set timeBetweenDecodingAttempts(millis) {
            this._timeBetweenDecodingAttempts = millis < 0 ? 0 : millis;
        }
        /**
         * Sets the hints.
         */ set hints(hints) {
            this._hints = hints || null;
        }
        /**
         * Sets the hints.
         */ get hints() {
            return this._hints;
        }
        /**
         * Lists all the available video input devices.
         */ listVideoInputDevices() {
            return __awaiter(this, void 0, void 0, function*() {
                if (!this.hasNavigator) throw new Error('Can\'t enumerate devices, navigator is not present.');
                if (!this.canEnumerateDevices) throw new Error('Can\'t enumerate devices, method not supported.');
                const devices = yield navigator.mediaDevices.enumerateDevices();
                const videoDevices = [];
                for (const device of devices){
                    const kind = device.kind === 'video' ? 'videoinput' : device.kind;
                    if (kind !== 'videoinput') continue;
                    const deviceId = device.deviceId || device.id;
                    const label = device.label || `Video device ${videoDevices.length + 1}`;
                    const groupId = device.groupId;
                    const videoDevice = {
                        deviceId: deviceId,
                        label: label,
                        kind: kind,
                        groupId: groupId
                    };
                    videoDevices.push(videoDevice);
                }
                return videoDevices;
            });
        }
        /**
         * Obtain the list of available devices with type 'videoinput'.
         *
         * @returns {Promise<VideoInputDevice[]>} an array of available video input devices
         *
         * @memberOf BrowserCodeReader
         *
         * @deprecated Use `listVideoInputDevices` instead.
         */ getVideoInputDevices() {
            return __awaiter(this, void 0, void 0, function*() {
                const devices = yield this.listVideoInputDevices();
                return devices.map((d)=>new VideoInputDevice(d.deviceId, d.label));
            });
        }
        /**
         * Let's you find a device using it's Id.
         */ findDeviceById(deviceId) {
            return __awaiter(this, void 0, void 0, function*() {
                const devices = yield this.listVideoInputDevices();
                if (!devices) return null;
                return devices.find((x)=>x.deviceId === deviceId);
            });
        }
        /**
         * Decodes the barcode from the device specified by deviceId while showing the video in the specified video element.
         *
         * @param deviceId the id of one of the devices obtained after calling getVideoInputDevices. Can be undefined, in this case it will decode from one of the available devices, preffering the main camera (environment facing) if available.
         * @param video the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
         * @returns The decoding result.
         *
         * @memberOf BrowserCodeReader
         *
         * @deprecated Use `decodeOnceFromVideoDevice` instead.
         */ decodeFromInputVideoDevice(deviceId, videoSource) {
            return __awaiter(this, void 0, void 0, function*() {
                return yield this.decodeOnceFromVideoDevice(deviceId, videoSource);
            });
        }
        /**
         * In one attempt, tries to decode the barcode from the device specified by deviceId while showing the video in the specified video element.
         *
         * @param deviceId the id of one of the devices obtained after calling getVideoInputDevices. Can be undefined, in this case it will decode from one of the available devices, preffering the main camera (environment facing) if available.
         * @param video the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
         * @returns The decoding result.
         *
         * @memberOf BrowserCodeReader
         */ decodeOnceFromVideoDevice(deviceId, videoSource) {
            return __awaiter(this, void 0, void 0, function*() {
                this.reset();
                let videoConstraints;
                if (!deviceId) videoConstraints = {
                    facingMode: 'environment'
                };
                else videoConstraints = {
                    deviceId: {
                        exact: deviceId
                    }
                };
                const constraints = {
                    video: videoConstraints
                };
                return yield this.decodeOnceFromConstraints(constraints, videoSource);
            });
        }
        /**
         * In one attempt, tries to decode the barcode from a stream obtained from the given constraints while showing the video in the specified video element.
         *
         * @param constraints the media stream constraints to get s valid media stream to decode from
         * @param video the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
         * @returns The decoding result.
         *
         * @memberOf BrowserCodeReader
         */ decodeOnceFromConstraints(constraints, videoSource) {
            return __awaiter(this, void 0, void 0, function*() {
                const stream = yield navigator.mediaDevices.getUserMedia(constraints);
                return yield this.decodeOnceFromStream(stream, videoSource);
            });
        }
        /**
         * In one attempt, tries to decode the barcode from a stream obtained from the given constraints while showing the video in the specified video element.
         *
         * @param {MediaStream} [constraints] the media stream constraints to get s valid media stream to decode from
         * @param {string|HTMLVideoElement} [video] the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
         * @returns {Promise<Result>} The decoding result.
         *
         * @memberOf BrowserCodeReader
         */ decodeOnceFromStream(stream, videoSource) {
            return __awaiter(this, void 0, void 0, function*() {
                this.reset();
                const video = yield this.attachStreamToVideo(stream, videoSource);
                const result = yield this.decodeOnce(video);
                return result;
            });
        }
        /**
         * Continuously decodes the barcode from the device specified by device while showing the video in the specified video element.
         *
         * @param {string|null} [deviceId] the id of one of the devices obtained after calling getVideoInputDevices. Can be undefined, in this case it will decode from one of the available devices, preffering the main camera (environment facing) if available.
         * @param {string|HTMLVideoElement|null} [video] the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
         * @returns {Promise<void>}
         *
         * @memberOf BrowserCodeReader
         *
         * @deprecated Use `decodeFromVideoDevice` instead.
         */ decodeFromInputVideoDeviceContinuously(deviceId, videoSource, callbackFn) {
            return __awaiter(this, void 0, void 0, function*() {
                return yield this.decodeFromVideoDevice(deviceId, videoSource, callbackFn);
            });
        }
        /**
         * Continuously tries to decode the barcode from the device specified by device while showing the video in the specified video element.
         *
         * @param {string|null} [deviceId] the id of one of the devices obtained after calling getVideoInputDevices. Can be undefined, in this case it will decode from one of the available devices, preffering the main camera (environment facing) if available.
         * @param {string|HTMLVideoElement|null} [video] the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
         * @returns {Promise<void>}
         *
         * @memberOf BrowserCodeReader
         */ decodeFromVideoDevice(deviceId, videoSource, callbackFn) {
            return __awaiter(this, void 0, void 0, function*() {
                let videoConstraints;
                if (!deviceId) videoConstraints = {
                    facingMode: 'environment'
                };
                else videoConstraints = {
                    deviceId: {
                        exact: deviceId
                    }
                };
                const constraints = {
                    video: videoConstraints
                };
                return yield this.decodeFromConstraints(constraints, videoSource, callbackFn);
            });
        }
        /**
         * Continuously tries to decode the barcode from a stream obtained from the given constraints while showing the video in the specified video element.
         *
         * @param {MediaStream} [constraints] the media stream constraints to get s valid media stream to decode from
         * @param {string|HTMLVideoElement} [video] the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
         * @returns {Promise<Result>} The decoding result.
         *
         * @memberOf BrowserCodeReader
         */ decodeFromConstraints(constraints, videoSource, callbackFn) {
            return __awaiter(this, void 0, void 0, function*() {
                const stream = yield navigator.mediaDevices.getUserMedia(constraints);
                return yield this.decodeFromStream(stream, videoSource, callbackFn);
            });
        }
        /**
         * In one attempt, tries to decode the barcode from a stream obtained from the given constraints while showing the video in the specified video element.
         *
         * @param {MediaStream} [constraints] the media stream constraints to get s valid media stream to decode from
         * @param {string|HTMLVideoElement} [video] the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
         * @returns {Promise<Result>} The decoding result.
         *
         * @memberOf BrowserCodeReader
         */ decodeFromStream(stream, videoSource, callbackFn) {
            return __awaiter(this, void 0, void 0, function*() {
                this.reset();
                const video = yield this.attachStreamToVideo(stream, videoSource);
                return yield this.decodeContinuously(video, callbackFn);
            });
        }
        /**
         * Breaks the decoding loop.
         */ stopAsyncDecode() {
            this._stopAsyncDecode = true;
        }
        /**
         * Breaks the decoding loop.
         */ stopContinuousDecode() {
            this._stopContinuousDecode = true;
        }
        /**
         * Sets the new stream and request a new decoding-with-delay.
         *
         * @param stream The stream to be shown in the video element.
         * @param decodeFn A callback for the decode method.
         */ attachStreamToVideo(stream, videoSource) {
            return __awaiter(this, void 0, void 0, function*() {
                const videoElement = this.prepareVideoElement(videoSource);
                this.addVideoSource(videoElement, stream);
                this.videoElement = videoElement;
                this.stream = stream;
                yield this.playVideoOnLoadAsync(videoElement);
                return videoElement;
            });
        }
        /**
         *
         * @param videoElement
         */ playVideoOnLoadAsync(videoElement) {
            return new Promise((resolve, reject)=>this.playVideoOnLoad(videoElement, ()=>resolve()));
        }
        /**
         * Binds listeners and callbacks to the videoElement.
         *
         * @param element
         * @param callbackFn
         */ playVideoOnLoad(element, callbackFn) {
            this.videoEndedListener = ()=>this.stopStreams();
            this.videoCanPlayListener = ()=>this.tryPlayVideo(element);
            element.addEventListener('ended', this.videoEndedListener);
            element.addEventListener('canplay', this.videoCanPlayListener);
            element.addEventListener('playing', callbackFn);
            // if canplay was already fired, we won't know when to play, so just give it a try
            this.tryPlayVideo(element);
        }
        /**
         * Checks if the given video element is currently playing.
         */ isVideoPlaying(video) {
            return video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2;
        }
        /**
         * Just tries to play the video and logs any errors.
         * The play call is only made is the video is not already playing.
         */ tryPlayVideo(videoElement) {
            return __awaiter(this, void 0, void 0, function*() {
                if (this.isVideoPlaying(videoElement)) {
                    console.warn('Trying to play video that is already playing.');
                    return;
                }
                try {
                    yield videoElement.play();
                } catch (_a) {
                    console.warn('It was not possible to play the video.');
                }
            });
        }
        /**
         * Searches and validates a media element.
         */ getMediaElement(mediaElementId, type) {
            const mediaElement = document.getElementById(mediaElementId);
            if (!mediaElement) throw new ArgumentException(`element with id '${mediaElementId}' not found`);
            if (mediaElement.nodeName.toLowerCase() !== type.toLowerCase()) throw new ArgumentException(`element with id '${mediaElementId}' must be an ${type} element`);
            return mediaElement;
        }
        /**
         * Decodes the barcode from an image.
         *
         * @param {(string|HTMLImageElement)} [source] The image element that can be either an element id or the element itself. Can be undefined in which case the decoding will be done from the imageUrl parameter.
         * @param {string} [url]
         * @returns {Promise<Result>} The decoding result.
         *
         * @memberOf BrowserCodeReader
         */ decodeFromImage(source, url) {
            if (!source && !url) throw new ArgumentException('either imageElement with a src set or an url must be provided');
            if (url && !source) return this.decodeFromImageUrl(url);
            return this.decodeFromImageElement(source);
        }
        /**
         * Decodes the barcode from a video.
         *
         * @param {(string|HTMLImageElement)} [source] The image element that can be either an element id or the element itself. Can be undefined in which case the decoding will be done from the imageUrl parameter.
         * @param {string} [url]
         * @returns {Promise<Result>} The decoding result.
         *
         * @memberOf BrowserCodeReader
         */ decodeFromVideo(source, url) {
            if (!source && !url) throw new ArgumentException('Either an element with a src set or an URL must be provided');
            if (url && !source) return this.decodeFromVideoUrl(url);
            return this.decodeFromVideoElement(source);
        }
        /**
         * Decodes continuously the barcode from a video.
         *
         * @param {(string|HTMLImageElement)} [source] The image element that can be either an element id or the element itself. Can be undefined in which case the decoding will be done from the imageUrl parameter.
         * @param {string} [url]
         * @returns {Promise<Result>} The decoding result.
         *
         * @memberOf BrowserCodeReader
         *
         * @experimental
         */ decodeFromVideoContinuously(source, url, callbackFn) {
            if (undefined === source && undefined === url) throw new ArgumentException('Either an element with a src set or an URL must be provided');
            if (url && !source) return this.decodeFromVideoUrlContinuously(url, callbackFn);
            return this.decodeFromVideoElementContinuously(source, callbackFn);
        }
        /**
         * Decodes something from an image HTML element.
         */ decodeFromImageElement(source) {
            if (!source) throw new ArgumentException('An image element must be provided.');
            this.reset();
            const element = this.prepareImageElement(source);
            this.imageElement = element;
            let task;
            if (this.isImageLoaded(element)) task = this.decodeOnce(element, false, true);
            else task = this._decodeOnLoadImage(element);
            return task;
        }
        /**
         * Decodes something from an image HTML element.
         */ decodeFromVideoElement(source) {
            const element = this._decodeFromVideoElementSetup(source);
            return this._decodeOnLoadVideo(element);
        }
        /**
         * Decodes something from an image HTML element.
         */ decodeFromVideoElementContinuously(source, callbackFn) {
            const element = this._decodeFromVideoElementSetup(source);
            return this._decodeOnLoadVideoContinuously(element, callbackFn);
        }
        /**
         * Sets up the video source so it can be decoded when loaded.
         *
         * @param source The video source element.
         */ _decodeFromVideoElementSetup(source) {
            if (!source) throw new ArgumentException('A video element must be provided.');
            this.reset();
            const element = this.prepareVideoElement(source);
            // defines the video element before starts decoding
            this.videoElement = element;
            return element;
        }
        /**
         * Decodes an image from a URL.
         */ decodeFromImageUrl(url) {
            if (!url) throw new ArgumentException('An URL must be provided.');
            this.reset();
            const element = this.prepareImageElement();
            this.imageElement = element;
            const decodeTask = this._decodeOnLoadImage(element);
            element.src = url;
            return decodeTask;
        }
        /**
         * Decodes an image from a URL.
         */ decodeFromVideoUrl(url) {
            if (!url) throw new ArgumentException('An URL must be provided.');
            this.reset();
            // creates a new element
            const element = this.prepareVideoElement();
            const decodeTask = this.decodeFromVideoElement(element);
            element.src = url;
            return decodeTask;
        }
        /**
         * Decodes an image from a URL.
         *
         * @experimental
         */ decodeFromVideoUrlContinuously(url, callbackFn) {
            if (!url) throw new ArgumentException('An URL must be provided.');
            this.reset();
            // creates a new element
            const element = this.prepareVideoElement();
            const decodeTask = this.decodeFromVideoElementContinuously(element, callbackFn);
            element.src = url;
            return decodeTask;
        }
        _decodeOnLoadImage(element) {
            return new Promise((resolve, reject)=>{
                this.imageLoadedListener = ()=>this.decodeOnce(element, false, true).then(resolve, reject);
                element.addEventListener('load', this.imageLoadedListener);
            });
        }
        _decodeOnLoadVideo(videoElement) {
            return __awaiter(this, void 0, void 0, function*() {
                // plays the video
                yield this.playVideoOnLoadAsync(videoElement);
                // starts decoding after played the video
                return yield this.decodeOnce(videoElement);
            });
        }
        _decodeOnLoadVideoContinuously(videoElement, callbackFn) {
            return __awaiter(this, void 0, void 0, function*() {
                // plays the video
                yield this.playVideoOnLoadAsync(videoElement);
                // starts decoding after played the video
                this.decodeContinuously(videoElement, callbackFn);
            });
        }
        isImageLoaded(img) {
            // During the onload event, IE correctly identifies any images that
            // weren’t downloaded as not complete. Others should too. Gecko-based
            // browsers act like NS4 in that they report this incorrectly.
            if (!img.complete) return false;
            // However, they do have two very useful properties: naturalWidth and
            // naturalHeight. These give the true size of the image. If it failed
            // to load, either of these should be zero.
            if (img.naturalWidth === 0) return false;
            // No other way of checking: assume it’s ok.
            return true;
        }
        prepareImageElement(imageSource) {
            let imageElement;
            if (typeof imageSource === 'undefined') {
                imageElement = document.createElement('img');
                imageElement.width = 200;
                imageElement.height = 200;
            }
            if (typeof imageSource === 'string') imageElement = this.getMediaElement(imageSource, 'img');
            if (imageSource instanceof HTMLImageElement) imageElement = imageSource;
            return imageElement;
        }
        /**
         * Sets a HTMLVideoElement for scanning or creates a new one.
         *
         * @param videoSource The HTMLVideoElement to be set.
         */ prepareVideoElement(videoSource) {
            let videoElement;
            if (!videoSource && typeof document !== 'undefined') {
                videoElement = document.createElement('video');
                videoElement.width = 200;
                videoElement.height = 200;
            }
            if (typeof videoSource === 'string') videoElement = this.getMediaElement(videoSource, 'video');
            if (videoSource instanceof HTMLVideoElement) videoElement = videoSource;
            // Needed for iOS 11
            videoElement.setAttribute('autoplay', 'true');
            videoElement.setAttribute('muted', 'true');
            videoElement.setAttribute('playsinline', 'true');
            return videoElement;
        }
        /**
         * Tries to decode from the video input until it finds some value.
         */ decodeOnce(element, retryIfNotFound = true, retryIfChecksumOrFormatError = true) {
            this._stopAsyncDecode = false;
            const loop = (resolve, reject)=>{
                if (this._stopAsyncDecode) {
                    reject(new NotFoundException('Video stream has ended before any code could be detected.'));
                    this._stopAsyncDecode = undefined;
                    return;
                }
                try {
                    const result = this.decode(element);
                    resolve(result);
                } catch (e) {
                    const ifNotFound = retryIfNotFound && e instanceof NotFoundException;
                    const isChecksumOrFormatError = e instanceof ChecksumException || e instanceof FormatException;
                    const ifChecksumOrFormat = isChecksumOrFormatError && retryIfChecksumOrFormatError;
                    if (ifNotFound || ifChecksumOrFormat) // trying again
                    return setTimeout(loop, this._timeBetweenDecodingAttempts, resolve, reject);
                    reject(e);
                }
            };
            return new Promise((resolve, reject)=>loop(resolve, reject));
        }
        /**
         * Continuously decodes from video input.
         */ decodeContinuously(element, callbackFn) {
            this._stopContinuousDecode = false;
            const loop = ()=>{
                if (this._stopContinuousDecode) {
                    this._stopContinuousDecode = undefined;
                    return;
                }
                try {
                    const result = this.decode(element);
                    callbackFn(result, null);
                    setTimeout(loop, this.timeBetweenScansMillis);
                } catch (e) {
                    callbackFn(null, e);
                    const isChecksumOrFormatError = e instanceof ChecksumException || e instanceof FormatException;
                    const isNotFound = e instanceof NotFoundException;
                    if (isChecksumOrFormatError || isNotFound) // trying again
                    setTimeout(loop, this._timeBetweenDecodingAttempts);
                }
            };
            loop();
        }
        /**
         * Gets the BinaryBitmap for ya! (and decodes it)
         */ decode(element) {
            // get binary bitmap for decode function
            const binaryBitmap = this.createBinaryBitmap(element);
            return this.decodeBitmap(binaryBitmap);
        }
        /**
         * Returns true if media element is indeed a {@link HtmlVideoElement}.
         */ _isHTMLVideoElement(mediaElement) {
            const potentialVideo = mediaElement;
            return potentialVideo.videoWidth !== 0;
        }
        /**
         * Overwriting this allows you to manipulate the next frame in anyway
         * you want before decode.
         */ drawFrameOnCanvas(srcElement, dimensions, canvasElementContext) {
            if (!dimensions) dimensions = {
                sx: 0,
                sy: 0,
                sWidth: srcElement.videoWidth,
                sHeight: srcElement.videoHeight,
                dx: 0,
                dy: 0,
                dWidth: srcElement.videoWidth,
                dHeight: srcElement.videoHeight
            };
            if (!canvasElementContext) canvasElementContext = this.captureCanvasContext;
            canvasElementContext.drawImage(srcElement, dimensions.sx, dimensions.sy, dimensions.sWidth, dimensions.sHeight, dimensions.dx, dimensions.dy, dimensions.dWidth, dimensions.dHeight);
        }
        /**
         * Ovewriting this allows you to manipulate the snapshot image in anyway
         *  you want before decode.
         */ drawImageOnCanvas(srcElement, dimensions, canvasElementContext = this.captureCanvasContext) {
            if (!dimensions) dimensions = {
                sx: 0,
                sy: 0,
                sWidth: srcElement.naturalWidth,
                sHeight: srcElement.naturalHeight,
                dx: 0,
                dy: 0,
                dWidth: srcElement.naturalWidth,
                dHeight: srcElement.naturalHeight
            };
            if (!canvasElementContext) canvasElementContext = this.captureCanvasContext;
            canvasElementContext.drawImage(srcElement, dimensions.sx, dimensions.sy, dimensions.sWidth, dimensions.sHeight, dimensions.dx, dimensions.dy, dimensions.dWidth, dimensions.dHeight);
        }
        /**
         * Creates a binaryBitmap based in some image source.
         *
         * @param mediaElement HTML element containing drawable image source.
         */ createBinaryBitmap(mediaElement) {
            const ctx = this.getCaptureCanvasContext(mediaElement);
            if (this._isHTMLVideoElement(mediaElement)) this.drawFrameOnCanvas(mediaElement);
            else this.drawImageOnCanvas(mediaElement);
            const canvas = this.getCaptureCanvas(mediaElement);
            const luminanceSource = new HTMLCanvasElementLuminanceSource(canvas);
            const hybridBinarizer = new HybridBinarizer(luminanceSource);
            return new BinaryBitmap(hybridBinarizer);
        }
        getCaptureCanvasContext(mediaElement) {
            if (!this.captureCanvasContext) {
                const elem = this.getCaptureCanvas(mediaElement);
                const ctx = elem.getContext('2d');
                this.captureCanvasContext = ctx;
            }
            return this.captureCanvasContext;
        }
        getCaptureCanvas(mediaElement) {
            if (!this.captureCanvas) {
                const elem = this.createCaptureCanvas(mediaElement);
                this.captureCanvas = elem;
            }
            return this.captureCanvas;
        }
        /**
         * Call the encapsulated readers decode
         */ decodeBitmap(binaryBitmap) {
            return this.reader.decode(binaryBitmap, this._hints);
        }
        /**
         * 🖌 Prepares the canvas for capture and scan frames.
         */ createCaptureCanvas(mediaElement) {
            if (typeof document === 'undefined') {
                this._destroyCaptureCanvas();
                return null;
            }
            const canvasElement = document.createElement('canvas');
            let width;
            let height;
            if (typeof mediaElement !== 'undefined') {
                if (mediaElement instanceof HTMLVideoElement) {
                    width = mediaElement.videoWidth;
                    height = mediaElement.videoHeight;
                } else if (mediaElement instanceof HTMLImageElement) {
                    width = mediaElement.naturalWidth || mediaElement.width;
                    height = mediaElement.naturalHeight || mediaElement.height;
                }
            }
            canvasElement.style.width = width + 'px';
            canvasElement.style.height = height + 'px';
            canvasElement.width = width;
            canvasElement.height = height;
            return canvasElement;
        }
        /**
         * Stops the continuous scan and cleans the stream.
         */ stopStreams() {
            if (this.stream) {
                this.stream.getVideoTracks().forEach((t)=>t.stop());
                this.stream = undefined;
            }
            if (this._stopAsyncDecode === false) this.stopAsyncDecode();
            if (this._stopContinuousDecode === false) this.stopContinuousDecode();
        }
        /**
         * Resets the code reader to the initial state. Cancels any ongoing barcode scanning from video or camera.
         *
         * @memberOf BrowserCodeReader
         */ reset() {
            // stops the camera, preview and scan 🔴
            this.stopStreams();
            // clean and forget about HTML elements
            this._destroyVideoElement();
            this._destroyImageElement();
            this._destroyCaptureCanvas();
        }
        _destroyVideoElement() {
            if (!this.videoElement) return;
            // first gives freedon to the element 🕊
            if (typeof this.videoEndedListener !== 'undefined') this.videoElement.removeEventListener('ended', this.videoEndedListener);
            if (typeof this.videoPlayingEventListener !== 'undefined') this.videoElement.removeEventListener('playing', this.videoPlayingEventListener);
            if (typeof this.videoCanPlayListener !== 'undefined') this.videoElement.removeEventListener('loadedmetadata', this.videoCanPlayListener);
            // then forgets about that element 😢
            this.cleanVideoSource(this.videoElement);
            this.videoElement = undefined;
        }
        _destroyImageElement() {
            if (!this.imageElement) return;
            // first gives freedon to the element 🕊
            if (undefined !== this.imageLoadedListener) this.imageElement.removeEventListener('load', this.imageLoadedListener);
            // then forget about that element 😢
            this.imageElement.src = undefined;
            this.imageElement.removeAttribute('src');
            this.imageElement = undefined;
        }
        /**
         * Cleans canvas references 🖌
         */ _destroyCaptureCanvas() {
            // then forget about that element 😢
            this.captureCanvasContext = undefined;
            this.captureCanvas = undefined;
        }
        /**
         * Defines what the videoElement src will be.
         *
         * @param videoElement
         * @param stream
         */ addVideoSource(videoElement, stream) {
            // Older browsers may not have `srcObject`
            try {
                // @note Throws Exception if interrupted by a new loaded request
                videoElement.srcObject = stream;
            } catch (err) {
                // @note Avoid using this in new browsers, as it is going away.
                videoElement.src = URL.createObjectURL(stream);
            }
        }
        /**
         * Unbinds a HTML video src property.
         *
         * @param videoElement
         */ cleanVideoSource(videoElement) {
            try {
                videoElement.srcObject = null;
            } catch (err) {
                videoElement.src = '';
            }
            this.videoElement.removeAttribute('src');
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * <p>Encapsulates the result of decoding a barcode within an image.</p>
     *
     * @author Sean Owen
     */ class Result {
        // public constructor(private text: string,
        //               Uint8Array rawBytes,
        //               ResultPoconst resultPoints: Int32Array,
        //               BarcodeFormat format) {
        //   this(text, rawBytes, resultPoints, format, System.currentTimeMillis())
        // }
        // public constructor(text: string,
        //               Uint8Array rawBytes,
        //               ResultPoconst resultPoints: Int32Array,
        //               BarcodeFormat format,
        //               long timestamp) {
        //   this(text, rawBytes, rawBytes == null ? 0 : 8 * rawBytes.length,
        //        resultPoints, format, timestamp)
        // }
        constructor(text, rawBytes, numBits = rawBytes == null ? 0 : 8 * rawBytes.length, resultPoints, format, timestamp = System.currentTimeMillis()){
            this.text = text;
            this.rawBytes = rawBytes;
            this.numBits = numBits;
            this.resultPoints = resultPoints;
            this.format = format;
            this.timestamp = timestamp;
            this.text = text;
            this.rawBytes = rawBytes;
            if (undefined === numBits || null === numBits) this.numBits = rawBytes === null || rawBytes === undefined ? 0 : 8 * rawBytes.length;
            else this.numBits = numBits;
            this.resultPoints = resultPoints;
            this.format = format;
            this.resultMetadata = null;
            if (undefined === timestamp || null === timestamp) this.timestamp = System.currentTimeMillis();
            else this.timestamp = timestamp;
        }
        /**
         * @return raw text encoded by the barcode
         */ getText() {
            return this.text;
        }
        /**
         * @return raw bytes encoded by the barcode, if applicable, otherwise {@code null}
         */ getRawBytes() {
            return this.rawBytes;
        }
        /**
         * @return how many bits of {@link #getRawBytes()} are valid; typically 8 times its length
         * @since 3.3.0
         */ getNumBits() {
            return this.numBits;
        }
        /**
         * @return points related to the barcode in the image. These are typically points
         *         identifying finder patterns or the corners of the barcode. The exact meaning is
         *         specific to the type of barcode that was decoded.
         */ getResultPoints() {
            return this.resultPoints;
        }
        /**
         * @return {@link BarcodeFormat} representing the format of the barcode that was decoded
         */ getBarcodeFormat() {
            return this.format;
        }
        /**
         * @return {@link Map} mapping {@link ResultMetadataType} keys to values. May be
         *   {@code null}. This contains optional metadata about what was detected about the barcode,
         *   like orientation.
         */ getResultMetadata() {
            return this.resultMetadata;
        }
        putMetadata(type, value) {
            if (this.resultMetadata === null) this.resultMetadata = new Map();
            this.resultMetadata.set(type, value);
        }
        putAllMetadata(metadata) {
            if (metadata !== null) {
                if (this.resultMetadata === null) this.resultMetadata = metadata;
                else this.resultMetadata = new Map(metadata);
            }
        }
        addResultPoints(newPoints) {
            const oldPoints = this.resultPoints;
            if (oldPoints === null) this.resultPoints = newPoints;
            else if (newPoints !== null && newPoints.length > 0) {
                const allPoints = new Array(oldPoints.length + newPoints.length);
                System.arraycopy(oldPoints, 0, allPoints, 0, oldPoints.length);
                System.arraycopy(newPoints, 0, allPoints, oldPoints.length, newPoints.length);
                this.resultPoints = allPoints;
            }
        }
        getTimestamp() {
            return this.timestamp;
        }
        /*@Override*/ toString() {
            return this.text;
        }
    }
    /*
     * Direct port to TypeScript of ZXing by Adrian Toșcă
     */ /*
     * Copyright 2009 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /*namespace com.google.zxing {*/ /**
     * Enumerates barcode formats known to this package. Please keep alphabetized.
     *
     * @author Sean Owen
     */ var BarcodeFormat;
    (function(BarcodeFormat) {
        /** Aztec 2D barcode format. */ BarcodeFormat[BarcodeFormat["AZTEC"] = 0] = "AZTEC";
        /** CODABAR 1D format. */ BarcodeFormat[BarcodeFormat["CODABAR"] = 1] = "CODABAR";
        /** Code 39 1D format. */ BarcodeFormat[BarcodeFormat["CODE_39"] = 2] = "CODE_39";
        /** Code 93 1D format. */ BarcodeFormat[BarcodeFormat["CODE_93"] = 3] = "CODE_93";
        /** Code 128 1D format. */ BarcodeFormat[BarcodeFormat["CODE_128"] = 4] = "CODE_128";
        /** Data Matrix 2D barcode format. */ BarcodeFormat[BarcodeFormat["DATA_MATRIX"] = 5] = "DATA_MATRIX";
        /** EAN-8 1D format. */ BarcodeFormat[BarcodeFormat["EAN_8"] = 6] = "EAN_8";
        /** EAN-13 1D format. */ BarcodeFormat[BarcodeFormat["EAN_13"] = 7] = "EAN_13";
        /** ITF (Interleaved Two of Five) 1D format. */ BarcodeFormat[BarcodeFormat["ITF"] = 8] = "ITF";
        /** MaxiCode 2D barcode format. */ BarcodeFormat[BarcodeFormat["MAXICODE"] = 9] = "MAXICODE";
        /** PDF417 format. */ BarcodeFormat[BarcodeFormat["PDF_417"] = 10] = "PDF_417";
        /** QR Code 2D barcode format. */ BarcodeFormat[BarcodeFormat["QR_CODE"] = 11] = "QR_CODE";
        /** RSS 14 */ BarcodeFormat[BarcodeFormat["RSS_14"] = 12] = "RSS_14";
        /** RSS EXPANDED */ BarcodeFormat[BarcodeFormat["RSS_EXPANDED"] = 13] = "RSS_EXPANDED";
        /** UPC-A 1D format. */ BarcodeFormat[BarcodeFormat["UPC_A"] = 14] = "UPC_A";
        /** UPC-E 1D format. */ BarcodeFormat[BarcodeFormat["UPC_E"] = 15] = "UPC_E";
        /** UPC/EAN extension format. Not a stand-alone format. */ BarcodeFormat[BarcodeFormat["UPC_EAN_EXTENSION"] = 16] = "UPC_EAN_EXTENSION";
    })(BarcodeFormat || (BarcodeFormat = {}));
    var BarcodeFormat$1 = BarcodeFormat;
    /*namespace com.google.zxing {*/ /**
     * Represents some type of metadata about the result of the decoding that the decoder
     * wishes to communicate back to the caller.
     *
     * @author Sean Owen
     */ var ResultMetadataType;
    (function(ResultMetadataType) {
        /**
         * Unspecified, application-specific metadata. Maps to an unspecified {@link Object}.
         */ ResultMetadataType[ResultMetadataType["OTHER"] = 0] = "OTHER";
        /**
         * Denotes the likely approximate orientation of the barcode in the image. This value
         * is given as degrees rotated clockwise from the normal, upright orientation.
         * For example a 1D barcode which was found by reading top-to-bottom would be
         * said to have orientation "90". This key maps to an {@link Integer} whose
         * value is in the range [0,360).
         */ ResultMetadataType[ResultMetadataType["ORIENTATION"] = 1] = "ORIENTATION";
        /**
         * <p>2D barcode formats typically encode text, but allow for a sort of 'byte mode'
         * which is sometimes used to encode binary data. While {@link Result} makes available
         * the complete raw bytes in the barcode for these formats, it does not offer the bytes
         * from the byte segments alone.</p>
         *
         * <p>This maps to a {@link java.util.List} of byte arrays corresponding to the
         * raw bytes in the byte segments in the barcode, in order.</p>
         */ ResultMetadataType[ResultMetadataType["BYTE_SEGMENTS"] = 2] = "BYTE_SEGMENTS";
        /**
         * Error correction level used, if applicable. The value type depends on the
         * format, but is typically a String.
         */ ResultMetadataType[ResultMetadataType["ERROR_CORRECTION_LEVEL"] = 3] = "ERROR_CORRECTION_LEVEL";
        /**
         * For some periodicals, indicates the issue number as an {@link Integer}.
         */ ResultMetadataType[ResultMetadataType["ISSUE_NUMBER"] = 4] = "ISSUE_NUMBER";
        /**
         * For some products, indicates the suggested retail price in the barcode as a
         * formatted {@link String}.
         */ ResultMetadataType[ResultMetadataType["SUGGESTED_PRICE"] = 5] = "SUGGESTED_PRICE";
        /**
         * For some products, the possible country of manufacture as a {@link String} denoting the
         * ISO country code. Some map to multiple possible countries, like "US/CA".
         */ ResultMetadataType[ResultMetadataType["POSSIBLE_COUNTRY"] = 6] = "POSSIBLE_COUNTRY";
        /**
         * For some products, the extension text
         */ ResultMetadataType[ResultMetadataType["UPC_EAN_EXTENSION"] = 7] = "UPC_EAN_EXTENSION";
        /**
         * PDF417-specific metadata
         */ ResultMetadataType[ResultMetadataType["PDF417_EXTRA_METADATA"] = 8] = "PDF417_EXTRA_METADATA";
        /**
         * If the code format supports structured append and the current scanned code is part of one then the
         * sequence number is given with it.
         */ ResultMetadataType[ResultMetadataType["STRUCTURED_APPEND_SEQUENCE"] = 9] = "STRUCTURED_APPEND_SEQUENCE";
        /**
         * If the code format supports structured append and the current scanned code is part of one then the
         * parity is given with it.
         */ ResultMetadataType[ResultMetadataType["STRUCTURED_APPEND_PARITY"] = 10] = "STRUCTURED_APPEND_PARITY";
    })(ResultMetadataType || (ResultMetadataType = {}));
    var ResultMetadataType$1 = ResultMetadataType;
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /*namespace com.google.zxing.common {*/ /*import java.util.List;*/ /**
     * <p>Encapsulates the result of decoding a matrix of bits. This typically
     * applies to 2D barcode formats. For now it contains the raw bytes obtained,
     * as well as a String interpretation of those bytes, if applicable.</p>
     *
     * @author Sean Owen
     */ class DecoderResult {
        // public constructor(rawBytes: Uint8Array,
        //                      text: string,
        //                      List<Uint8Array> byteSegments,
        //                      String ecLevel) {
        //   this(rawBytes, text, byteSegments, ecLevel, -1, -1)
        // }
        constructor(rawBytes, text, byteSegments, ecLevel, structuredAppendSequenceNumber = -1, structuredAppendParity = -1){
            this.rawBytes = rawBytes;
            this.text = text;
            this.byteSegments = byteSegments;
            this.ecLevel = ecLevel;
            this.structuredAppendSequenceNumber = structuredAppendSequenceNumber;
            this.structuredAppendParity = structuredAppendParity;
            this.numBits = rawBytes === undefined || rawBytes === null ? 0 : 8 * rawBytes.length;
        }
        /**
         * @return raw bytes representing the result, or {@code null} if not applicable
         */ getRawBytes() {
            return this.rawBytes;
        }
        /**
         * @return how many bits of {@link #getRawBytes()} are valid; typically 8 times its length
         * @since 3.3.0
         */ getNumBits() {
            return this.numBits;
        }
        /**
         * @param numBits overrides the number of bits that are valid in {@link #getRawBytes()}
         * @since 3.3.0
         */ setNumBits(numBits /*int*/ ) {
            this.numBits = numBits;
        }
        /**
         * @return text representation of the result
         */ getText() {
            return this.text;
        }
        /**
         * @return list of byte segments in the result, or {@code null} if not applicable
         */ getByteSegments() {
            return this.byteSegments;
        }
        /**
         * @return name of error correction level used, or {@code null} if not applicable
         */ getECLevel() {
            return this.ecLevel;
        }
        /**
         * @return number of errors corrected, or {@code null} if not applicable
         */ getErrorsCorrected() {
            return this.errorsCorrected;
        }
        setErrorsCorrected(errorsCorrected /*Integer*/ ) {
            this.errorsCorrected = errorsCorrected;
        }
        /**
         * @return number of erasures corrected, or {@code null} if not applicable
         */ getErasures() {
            return this.erasures;
        }
        setErasures(erasures /*Integer*/ ) {
            this.erasures = erasures;
        }
        /**
         * @return arbitrary additional metadata
         */ getOther() {
            return this.other;
        }
        setOther(other) {
            this.other = other;
        }
        hasStructuredAppend() {
            return this.structuredAppendParity >= 0 && this.structuredAppendSequenceNumber >= 0;
        }
        getStructuredAppendParity() {
            return this.structuredAppendParity;
        }
        getStructuredAppendSequenceNumber() {
            return this.structuredAppendSequenceNumber;
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * <p>This class contains utility methods for performing mathematical operations over
     * the Galois Fields. Operations use a given primitive polynomial in calculations.</p>
     *
     * <p>Throughout this package, elements of the GF are represented as an {@code int}
     * for convenience and speed (but at the cost of memory).
     * </p>
     *
     * @author Sean Owen
     * @author David Olivier
     */ class AbstractGenericGF {
        /**
         * @return 2 to the power of a in GF(size)
         */ exp(a) {
            return this.expTable[a];
        }
        /**
         * @return base 2 log of a in GF(size)
         */ log(a /*int*/ ) {
            if (a === 0) throw new IllegalArgumentException();
            return this.logTable[a];
        }
        /**
         * Implements both addition and subtraction -- they are the same in GF(size).
         *
         * @return sum/difference of a and b
         */ static addOrSubtract(a /*int*/ , b /*int*/ ) {
            return a ^ b;
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * <p>Represents a polynomial whose coefficients are elements of a GF.
     * Instances of this class are immutable.</p>
     *
     * <p>Much credit is due to William Rucklidge since portions of this code are an indirect
     * port of his C++ Reed-Solomon implementation.</p>
     *
     * @author Sean Owen
     */ class GenericGFPoly {
        /**
         * @param field the {@link GenericGF} instance representing the field to use
         * to perform computations
         * @param coefficients coefficients as ints representing elements of GF(size), arranged
         * from most significant (highest-power term) coefficient to least significant
         * @throws IllegalArgumentException if argument is null or empty,
         * or if leading coefficient is 0 and this is not a
         * constant polynomial (that is, it is not the monomial "0")
         */ constructor(field, coefficients){
            if (coefficients.length === 0) throw new IllegalArgumentException();
            this.field = field;
            const coefficientsLength = coefficients.length;
            if (coefficientsLength > 1 && coefficients[0] === 0) {
                // Leading term must be non-zero for anything except the constant polynomial "0"
                let firstNonZero = 1;
                while(firstNonZero < coefficientsLength && coefficients[firstNonZero] === 0)firstNonZero++;
                if (firstNonZero === coefficientsLength) this.coefficients = Int32Array.from([
                    0
                ]);
                else {
                    this.coefficients = new Int32Array(coefficientsLength - firstNonZero);
                    System.arraycopy(coefficients, firstNonZero, this.coefficients, 0, this.coefficients.length);
                }
            } else this.coefficients = coefficients;
        }
        getCoefficients() {
            return this.coefficients;
        }
        /**
         * @return degree of this polynomial
         */ getDegree() {
            return this.coefficients.length - 1;
        }
        /**
         * @return true iff this polynomial is the monomial "0"
         */ isZero() {
            return this.coefficients[0] === 0;
        }
        /**
         * @return coefficient of x^degree term in this polynomial
         */ getCoefficient(degree /*int*/ ) {
            return this.coefficients[this.coefficients.length - 1 - degree];
        }
        /**
         * @return evaluation of this polynomial at a given point
         */ evaluateAt(a /*int*/ ) {
            if (a === 0) // Just return the x^0 coefficient
            return this.getCoefficient(0);
            const coefficients = this.coefficients;
            let result;
            if (a === 1) {
                // Just the sum of the coefficients
                result = 0;
                for(let i = 0, length = coefficients.length; i !== length; i++){
                    const coefficient = coefficients[i];
                    result = AbstractGenericGF.addOrSubtract(result, coefficient);
                }
                return result;
            }
            result = coefficients[0];
            const size = coefficients.length;
            const field = this.field;
            for(let i = 1; i < size; i++)result = AbstractGenericGF.addOrSubtract(field.multiply(a, result), coefficients[i]);
            return result;
        }
        addOrSubtract(other) {
            if (!this.field.equals(other.field)) throw new IllegalArgumentException('GenericGFPolys do not have same GenericGF field');
            if (this.isZero()) return other;
            if (other.isZero()) return this;
            let smallerCoefficients = this.coefficients;
            let largerCoefficients = other.coefficients;
            if (smallerCoefficients.length > largerCoefficients.length) {
                const temp = smallerCoefficients;
                smallerCoefficients = largerCoefficients;
                largerCoefficients = temp;
            }
            let sumDiff = new Int32Array(largerCoefficients.length);
            const lengthDiff = largerCoefficients.length - smallerCoefficients.length;
            // Copy high-order terms only found in higher-degree polynomial's coefficients
            System.arraycopy(largerCoefficients, 0, sumDiff, 0, lengthDiff);
            for(let i = lengthDiff; i < largerCoefficients.length; i++)sumDiff[i] = AbstractGenericGF.addOrSubtract(smallerCoefficients[i - lengthDiff], largerCoefficients[i]);
            return new GenericGFPoly(this.field, sumDiff);
        }
        multiply(other) {
            if (!this.field.equals(other.field)) throw new IllegalArgumentException('GenericGFPolys do not have same GenericGF field');
            if (this.isZero() || other.isZero()) return this.field.getZero();
            const aCoefficients = this.coefficients;
            const aLength = aCoefficients.length;
            const bCoefficients = other.coefficients;
            const bLength = bCoefficients.length;
            const product = new Int32Array(aLength + bLength - 1);
            const field = this.field;
            for(let i = 0; i < aLength; i++){
                const aCoeff = aCoefficients[i];
                for(let j = 0; j < bLength; j++)product[i + j] = AbstractGenericGF.addOrSubtract(product[i + j], field.multiply(aCoeff, bCoefficients[j]));
            }
            return new GenericGFPoly(field, product);
        }
        multiplyScalar(scalar /*int*/ ) {
            if (scalar === 0) return this.field.getZero();
            if (scalar === 1) return this;
            const size = this.coefficients.length;
            const field = this.field;
            const product = new Int32Array(size);
            const coefficients = this.coefficients;
            for(let i = 0; i < size; i++)product[i] = field.multiply(coefficients[i], scalar);
            return new GenericGFPoly(field, product);
        }
        multiplyByMonomial(degree /*int*/ , coefficient /*int*/ ) {
            if (degree < 0) throw new IllegalArgumentException();
            if (coefficient === 0) return this.field.getZero();
            const coefficients = this.coefficients;
            const size = coefficients.length;
            const product = new Int32Array(size + degree);
            const field = this.field;
            for(let i = 0; i < size; i++)product[i] = field.multiply(coefficients[i], coefficient);
            return new GenericGFPoly(field, product);
        }
        divide(other) {
            if (!this.field.equals(other.field)) throw new IllegalArgumentException('GenericGFPolys do not have same GenericGF field');
            if (other.isZero()) throw new IllegalArgumentException('Divide by 0');
            const field = this.field;
            let quotient = field.getZero();
            let remainder = this;
            const denominatorLeadingTerm = other.getCoefficient(other.getDegree());
            const inverseDenominatorLeadingTerm = field.inverse(denominatorLeadingTerm);
            while(remainder.getDegree() >= other.getDegree() && !remainder.isZero()){
                const degreeDifference = remainder.getDegree() - other.getDegree();
                const scale = field.multiply(remainder.getCoefficient(remainder.getDegree()), inverseDenominatorLeadingTerm);
                const term = other.multiplyByMonomial(degreeDifference, scale);
                const iterationQuotient = field.buildMonomial(degreeDifference, scale);
                quotient = quotient.addOrSubtract(iterationQuotient);
                remainder = remainder.addOrSubtract(term);
            }
            return [
                quotient,
                remainder
            ];
        }
        /*@Override*/ toString() {
            let result = '';
            for(let degree = this.getDegree(); degree >= 0; degree--){
                let coefficient = this.getCoefficient(degree);
                if (coefficient !== 0) {
                    if (coefficient < 0) {
                        result += ' - ';
                        coefficient = -coefficient;
                    } else if (result.length > 0) result += ' + ';
                    if (degree === 0 || coefficient !== 1) {
                        const alphaPower = this.field.log(coefficient);
                        if (alphaPower === 0) result += '1';
                        else if (alphaPower === 1) result += 'a';
                        else {
                            result += 'a^';
                            result += alphaPower;
                        }
                    }
                    if (degree !== 0) {
                        if (degree === 1) result += 'x';
                        else {
                            result += 'x^';
                            result += degree;
                        }
                    }
                }
            }
            return result;
        }
    }
    /**
     * Custom Error class of type Exception.
     */ class ArithmeticException extends Exception {
    }
    ArithmeticException.kind = 'ArithmeticException';
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * <p>This class contains utility methods for performing mathematical operations over
     * the Galois Fields. Operations use a given primitive polynomial in calculations.</p>
     *
     * <p>Throughout this package, elements of the GF are represented as an {@code int}
     * for convenience and speed (but at the cost of memory).
     * </p>
     *
     * @author Sean Owen
     * @author David Olivier
     */ class GenericGF extends AbstractGenericGF {
        /**
         * Create a representation of GF(size) using the given primitive polynomial.
         *
         * @param primitive irreducible polynomial whose coefficients are represented by
         *  the bits of an int, where the least-significant bit represents the constant
         *  coefficient
         * @param size the size of the field
         * @param b the factor b in the generator polynomial can be 0- or 1-based
         *  (g(x) = (x+a^b)(x+a^(b+1))...(x+a^(b+2t-1))).
         *  In most cases it should be 1, but for QR code it is 0.
         */ constructor(primitive /*int*/ , size /*int*/ , generatorBase /*int*/ ){
            super();
            this.primitive = primitive;
            this.size = size;
            this.generatorBase = generatorBase;
            const expTable = new Int32Array(size);
            let x = 1;
            for(let i = 0; i < size; i++){
                expTable[i] = x;
                x *= 2; // we're assuming the generator alpha is 2
                if (x >= size) {
                    x ^= primitive;
                    x &= size - 1;
                }
            }
            this.expTable = expTable;
            const logTable = new Int32Array(size);
            for(let i = 0; i < size - 1; i++)logTable[expTable[i]] = i;
            this.logTable = logTable;
            // logTable[0] == 0 but this should never be used
            this.zero = new GenericGFPoly(this, Int32Array.from([
                0
            ]));
            this.one = new GenericGFPoly(this, Int32Array.from([
                1
            ]));
        }
        getZero() {
            return this.zero;
        }
        getOne() {
            return this.one;
        }
        /**
         * @return the monomial representing coefficient * x^degree
         */ buildMonomial(degree /*int*/ , coefficient /*int*/ ) {
            if (degree < 0) throw new IllegalArgumentException();
            if (coefficient === 0) return this.zero;
            const coefficients = new Int32Array(degree + 1);
            coefficients[0] = coefficient;
            return new GenericGFPoly(this, coefficients);
        }
        /**
         * @return multiplicative inverse of a
         */ inverse(a /*int*/ ) {
            if (a === 0) throw new ArithmeticException();
            return this.expTable[this.size - this.logTable[a] - 1];
        }
        /**
         * @return product of a and b in GF(size)
         */ multiply(a /*int*/ , b /*int*/ ) {
            if (a === 0 || b === 0) return 0;
            return this.expTable[(this.logTable[a] + this.logTable[b]) % (this.size - 1)];
        }
        getSize() {
            return this.size;
        }
        getGeneratorBase() {
            return this.generatorBase;
        }
        /*@Override*/ toString() {
            return 'GF(0x' + Integer.toHexString(this.primitive) + ',' + this.size + ')';
        }
        equals(o) {
            return o === this;
        }
    }
    GenericGF.AZTEC_DATA_12 = new GenericGF(0x1069, 4096, 1); // x^12 + x^6 + x^5 + x^3 + 1
    GenericGF.AZTEC_DATA_10 = new GenericGF(0x409, 1024, 1); // x^10 + x^3 + 1
    GenericGF.AZTEC_DATA_6 = new GenericGF(0x43, 64, 1); // x^6 + x + 1
    GenericGF.AZTEC_PARAM = new GenericGF(0x13, 16, 1); // x^4 + x + 1
    GenericGF.QR_CODE_FIELD_256 = new GenericGF(0x011d, 256, 0); // x^8 + x^4 + x^3 + x^2 + 1
    GenericGF.DATA_MATRIX_FIELD_256 = new GenericGF(0x012d, 256, 1); // x^8 + x^5 + x^3 + x^2 + 1
    GenericGF.AZTEC_DATA_8 = GenericGF.DATA_MATRIX_FIELD_256;
    GenericGF.MAXICODE_FIELD_64 = GenericGF.AZTEC_DATA_6;
    /**
     * Custom Error class of type Exception.
     */ class ReedSolomonException extends Exception {
    }
    ReedSolomonException.kind = 'ReedSolomonException';
    /**
     * Custom Error class of type Exception.
     */ class IllegalStateException extends Exception {
    }
    IllegalStateException.kind = 'IllegalStateException';
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * <p>Implements Reed-Solomon decoding, as the name implies.</p>
     *
     * <p>The algorithm will not be explained here, but the following references were helpful
     * in creating this implementation:</p>
     *
     * <ul>
     * <li>Bruce Maggs.
     * <a href="http://www.cs.cmu.edu/afs/cs.cmu.edu/project/pscico-guyb/realworld/www/rs_decode.ps">
     * "Decoding Reed-Solomon Codes"</a> (see discussion of Forney's Formula)</li>
     * <li>J.I. Hall. <a href="www.mth.msu.edu/~jhall/classes/codenotes/GRS.pdf">
     * "Chapter 5. Generalized Reed-Solomon Codes"</a>
     * (see discussion of Euclidean algorithm)</li>
     * </ul>
     *
     * <p>Much credit is due to William Rucklidge since portions of this code are an indirect
     * port of his C++ Reed-Solomon implementation.</p>
     *
     * @author Sean Owen
     * @author William Rucklidge
     * @author sanfordsquires
     */ class ReedSolomonDecoder {
        constructor(field){
            this.field = field;
        }
        /**
         * <p>Decodes given set of received codewords, which include both data and error-correction
         * codewords. Really, this means it uses Reed-Solomon to detect and correct errors, in-place,
         * in the input.</p>
         *
         * @param received data and error-correction codewords
         * @param twoS number of error-correction codewords available
         * @throws ReedSolomonException if decoding fails for any reason
         */ decode(received, twoS /*int*/ ) {
            const field = this.field;
            const poly = new GenericGFPoly(field, received);
            const syndromeCoefficients = new Int32Array(twoS);
            let noError = true;
            for(let i = 0; i < twoS; i++){
                const evalResult = poly.evaluateAt(field.exp(i + field.getGeneratorBase()));
                syndromeCoefficients[syndromeCoefficients.length - 1 - i] = evalResult;
                if (evalResult !== 0) noError = false;
            }
            if (noError) return;
            const syndrome = new GenericGFPoly(field, syndromeCoefficients);
            const sigmaOmega = this.runEuclideanAlgorithm(field.buildMonomial(twoS, 1), syndrome, twoS);
            const sigma = sigmaOmega[0];
            const omega = sigmaOmega[1];
            const errorLocations = this.findErrorLocations(sigma);
            const errorMagnitudes = this.findErrorMagnitudes(omega, errorLocations);
            for(let i = 0; i < errorLocations.length; i++){
                const position = received.length - 1 - field.log(errorLocations[i]);
                if (position < 0) throw new ReedSolomonException('Bad error location');
                received[position] = GenericGF.addOrSubtract(received[position], errorMagnitudes[i]);
            }
        }
        runEuclideanAlgorithm(a, b, R /*int*/ ) {
            // Assume a's degree is >= b's
            if (a.getDegree() < b.getDegree()) {
                const temp = a;
                a = b;
                b = temp;
            }
            const field = this.field;
            let rLast = a;
            let r = b;
            let tLast = field.getZero();
            let t = field.getOne();
            // Run Euclidean algorithm until r's degree is less than R/2
            while(r.getDegree() >= (R / 2 | 0)){
                let rLastLast = rLast;
                let tLastLast = tLast;
                rLast = r;
                tLast = t;
                // Divide rLastLast by rLast, with quotient in q and remainder in r
                if (rLast.isZero()) // Oops, Euclidean algorithm already terminated?
                throw new ReedSolomonException('r_{i-1} was zero');
                r = rLastLast;
                let q = field.getZero();
                const denominatorLeadingTerm = rLast.getCoefficient(rLast.getDegree());
                const dltInverse = field.inverse(denominatorLeadingTerm);
                while(r.getDegree() >= rLast.getDegree() && !r.isZero()){
                    const degreeDiff = r.getDegree() - rLast.getDegree();
                    const scale = field.multiply(r.getCoefficient(r.getDegree()), dltInverse);
                    q = q.addOrSubtract(field.buildMonomial(degreeDiff, scale));
                    r = r.addOrSubtract(rLast.multiplyByMonomial(degreeDiff, scale));
                }
                t = q.multiply(tLast).addOrSubtract(tLastLast);
                if (r.getDegree() >= rLast.getDegree()) throw new IllegalStateException('Division algorithm failed to reduce polynomial?');
            }
            const sigmaTildeAtZero = t.getCoefficient(0);
            if (sigmaTildeAtZero === 0) throw new ReedSolomonException('sigmaTilde(0) was zero');
            const inverse = field.inverse(sigmaTildeAtZero);
            const sigma = t.multiplyScalar(inverse);
            const omega = r.multiplyScalar(inverse);
            return [
                sigma,
                omega
            ];
        }
        findErrorLocations(errorLocator) {
            // This is a direct application of Chien's search
            const numErrors = errorLocator.getDegree();
            if (numErrors === 1) return Int32Array.from([
                errorLocator.getCoefficient(1)
            ]);
            const result = new Int32Array(numErrors);
            let e = 0;
            const field = this.field;
            for(let i = 1; i < field.getSize() && e < numErrors; i++)if (errorLocator.evaluateAt(i) === 0) {
                result[e] = field.inverse(i);
                e++;
            }
            if (e !== numErrors) throw new ReedSolomonException('Error locator degree does not match number of roots');
            return result;
        }
        findErrorMagnitudes(errorEvaluator, errorLocations) {
            // This is directly applying Forney's Formula
            const s = errorLocations.length;
            const result = new Int32Array(s);
            const field = this.field;
            for(let i = 0; i < s; i++){
                const xiInverse = field.inverse(errorLocations[i]);
                let denominator = 1;
                for(let j = 0; j < s; j++)if (i !== j) {
                    // denominator = field.multiply(denominator,
                    //    GenericGF.addOrSubtract(1, field.multiply(errorLocations[j], xiInverse)))
                    // Above should work but fails on some Apple and Linux JDKs due to a Hotspot bug.
                    // Below is a funny-looking workaround from Steven Parkes
                    const term = field.multiply(errorLocations[j], xiInverse);
                    const termPlus1 = (term & 0x1) === 0 ? term | 1 : term & -2;
                    denominator = field.multiply(denominator, termPlus1);
                }
                result[i] = field.multiply(errorEvaluator.evaluateAt(xiInverse), field.inverse(denominator));
                if (field.getGeneratorBase() !== 0) result[i] = field.multiply(result[i], xiInverse);
            }
            return result;
        }
    }
    /*
     * Copyright 2010 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ // import java.util.Arrays;
    var Table;
    (function(Table) {
        Table[Table["UPPER"] = 0] = "UPPER";
        Table[Table["LOWER"] = 1] = "LOWER";
        Table[Table["MIXED"] = 2] = "MIXED";
        Table[Table["DIGIT"] = 3] = "DIGIT";
        Table[Table["PUNCT"] = 4] = "PUNCT";
        Table[Table["BINARY"] = 5] = "BINARY";
    })(Table || (Table = {}));
    /**
     * <p>The main class which implements Aztec Code decoding -- as opposed to locating and extracting
     * the Aztec Code from an image.</p>
     *
     * @author David Olivier
     */ class Decoder {
        decode(detectorResult) {
            this.ddata = detectorResult;
            let matrix = detectorResult.getBits();
            let rawbits = this.extractBits(matrix);
            let correctedBits = this.correctBits(rawbits);
            let rawBytes = Decoder.convertBoolArrayToByteArray(correctedBits);
            let result = Decoder.getEncodedData(correctedBits);
            let decoderResult = new DecoderResult(rawBytes, result, null, null);
            decoderResult.setNumBits(correctedBits.length);
            return decoderResult;
        }
        // This method is used for testing the high-level encoder
        static highLevelDecode(correctedBits) {
            return this.getEncodedData(correctedBits);
        }
        /**
         * Gets the string encoded in the aztec code bits
         *
         * @return the decoded string
         */ static getEncodedData(correctedBits) {
            let endIndex = correctedBits.length;
            let latchTable = Table.UPPER; // table most recently latched to
            let shiftTable = Table.UPPER; // table to use for the next read
            let result = '';
            let index = 0;
            while(index < endIndex)if (shiftTable === Table.BINARY) {
                if (endIndex - index < 5) break;
                let length = Decoder.readCode(correctedBits, index, 5);
                index += 5;
                if (length === 0) {
                    if (endIndex - index < 11) break;
                    length = Decoder.readCode(correctedBits, index, 11) + 31;
                    index += 11;
                }
                for(let charCount = 0; charCount < length; charCount++){
                    if (endIndex - index < 8) {
                        index = endIndex; // Force outer loop to exit
                        break;
                    }
                    const code = Decoder.readCode(correctedBits, index, 8);
                    result += /*(char)*/ StringUtils.castAsNonUtf8Char(code);
                    index += 8;
                }
                // Go back to whatever mode we had been in
                shiftTable = latchTable;
            } else {
                let size = shiftTable === Table.DIGIT ? 4 : 5;
                if (endIndex - index < size) break;
                let code = Decoder.readCode(correctedBits, index, size);
                index += size;
                let str = Decoder.getCharacter(shiftTable, code);
                if (str.startsWith('CTRL_')) {
                    // Table changes
                    // ISO/IEC 24778:2008 prescribes ending a shift sequence in the mode from which it was invoked.
                    // That's including when that mode is a shift.
                    // Our test case dlusbs.png for issue #642 exercises that.
                    latchTable = shiftTable; // Latch the current mode, so as to return to Upper after U/S B/S
                    shiftTable = Decoder.getTable(str.charAt(5));
                    if (str.charAt(6) === 'L') latchTable = shiftTable;
                } else {
                    result += str;
                    // Go back to whatever mode we had been in
                    shiftTable = latchTable;
                }
            }
            return result;
        }
        /**
         * gets the table corresponding to the char passed
         */ static getTable(t) {
            switch(t){
                case 'L':
                    return Table.LOWER;
                case 'P':
                    return Table.PUNCT;
                case 'M':
                    return Table.MIXED;
                case 'D':
                    return Table.DIGIT;
                case 'B':
                    return Table.BINARY;
                case 'U':
                default:
                    return Table.UPPER;
            }
        }
        /**
         * Gets the character (or string) corresponding to the passed code in the given table
         *
         * @param table the table used
         * @param code the code of the character
         */ static getCharacter(table, code) {
            switch(table){
                case Table.UPPER:
                    return Decoder.UPPER_TABLE[code];
                case Table.LOWER:
                    return Decoder.LOWER_TABLE[code];
                case Table.MIXED:
                    return Decoder.MIXED_TABLE[code];
                case Table.PUNCT:
                    return Decoder.PUNCT_TABLE[code];
                case Table.DIGIT:
                    return Decoder.DIGIT_TABLE[code];
                default:
                    // Should not reach here.
                    throw new IllegalStateException('Bad table');
            }
        }
        /**
         * <p>Performs RS error correction on an array of bits.</p>
         *
         * @return the corrected array
         * @throws FormatException if the input contains too many errors
         */ correctBits(rawbits) {
            let gf;
            let codewordSize;
            if (this.ddata.getNbLayers() <= 2) {
                codewordSize = 6;
                gf = GenericGF.AZTEC_DATA_6;
            } else if (this.ddata.getNbLayers() <= 8) {
                codewordSize = 8;
                gf = GenericGF.AZTEC_DATA_8;
            } else if (this.ddata.getNbLayers() <= 22) {
                codewordSize = 10;
                gf = GenericGF.AZTEC_DATA_10;
            } else {
                codewordSize = 12;
                gf = GenericGF.AZTEC_DATA_12;
            }
            let numDataCodewords = this.ddata.getNbDatablocks();
            let numCodewords = rawbits.length / codewordSize;
            if (numCodewords < numDataCodewords) throw new FormatException();
            let offset = rawbits.length % codewordSize;
            let dataWords = new Int32Array(numCodewords);
            for(let i = 0; i < numCodewords; i++, offset += codewordSize)dataWords[i] = Decoder.readCode(rawbits, offset, codewordSize);
            try {
                let rsDecoder = new ReedSolomonDecoder(gf);
                rsDecoder.decode(dataWords, numCodewords - numDataCodewords);
            } catch (ex) {
                throw new FormatException(ex);
            }
            // Now perform the unstuffing operation.
            // First, count how many bits are going to be thrown out as stuffing
            let mask = (1 << codewordSize) - 1;
            let stuffedBits = 0;
            for(let i = 0; i < numDataCodewords; i++){
                let dataWord = dataWords[i];
                if (dataWord === 0 || dataWord === mask) throw new FormatException();
                else if (dataWord === 1 || dataWord === mask - 1) stuffedBits++;
            }
            // Now, actually unpack the bits and remove the stuffing
            let correctedBits = new Array(numDataCodewords * codewordSize - stuffedBits);
            let index = 0;
            for(let i = 0; i < numDataCodewords; i++){
                let dataWord = dataWords[i];
                if (dataWord === 1 || dataWord === mask - 1) {
                    // next codewordSize-1 bits are all zeros or all ones
                    correctedBits.fill(dataWord > 1, index, index + codewordSize - 1);
                    // Arrays.fill(correctedBits, index, index + codewordSize - 1, dataWord > 1);
                    index += codewordSize - 1;
                } else for(let bit = codewordSize - 1; bit >= 0; --bit)correctedBits[index++] = (dataWord & 1 << bit) !== 0;
            }
            return correctedBits;
        }
        /**
         * Gets the array of bits from an Aztec Code matrix
         *
         * @return the array of bits
         */ extractBits(matrix) {
            let compact = this.ddata.isCompact();
            let layers = this.ddata.getNbLayers();
            let baseMatrixSize = (compact ? 11 : 14) + layers * 4; // not including alignment lines
            let alignmentMap = new Int32Array(baseMatrixSize);
            let rawbits = new Array(this.totalBitsInLayer(layers, compact));
            if (compact) for(let i = 0; i < alignmentMap.length; i++)alignmentMap[i] = i;
            else {
                let matrixSize = baseMatrixSize + 1 + 2 * Integer.truncDivision(Integer.truncDivision(baseMatrixSize, 2) - 1, 15);
                let origCenter = baseMatrixSize / 2;
                let center = Integer.truncDivision(matrixSize, 2);
                for(let i = 0; i < origCenter; i++){
                    let newOffset = i + Integer.truncDivision(i, 15);
                    alignmentMap[origCenter - i - 1] = center - newOffset - 1;
                    alignmentMap[origCenter + i] = center + newOffset + 1;
                }
            }
            for(let i = 0, rowOffset = 0; i < layers; i++){
                let rowSize = (layers - i) * 4 + (compact ? 9 : 12);
                // The top-left most point of this layer is <low, low> (not including alignment lines)
                let low = i * 2;
                // The bottom-right most point of this layer is <high, high> (not including alignment lines)
                let high = baseMatrixSize - 1 - low;
                // We pull bits from the two 2 x rowSize columns and two rowSize x 2 rows
                for(let j = 0; j < rowSize; j++){
                    let columnOffset = j * 2;
                    for(let k = 0; k < 2; k++){
                        // left column
                        rawbits[rowOffset + columnOffset + k] = matrix.get(alignmentMap[low + k], alignmentMap[low + j]);
                        // bottom row
                        rawbits[rowOffset + 2 * rowSize + columnOffset + k] = matrix.get(alignmentMap[low + j], alignmentMap[high - k]);
                        // right column
                        rawbits[rowOffset + 4 * rowSize + columnOffset + k] = matrix.get(alignmentMap[high - k], alignmentMap[high - j]);
                        // top row
                        rawbits[rowOffset + 6 * rowSize + columnOffset + k] = matrix.get(alignmentMap[high - j], alignmentMap[low + k]);
                    }
                }
                rowOffset += rowSize * 8;
            }
            return rawbits;
        }
        /**
         * Reads a code of given length and at given index in an array of bits
         */ static readCode(rawbits, startIndex, length) {
            let res = 0;
            for(let i = startIndex; i < startIndex + length; i++){
                res <<= 1;
                if (rawbits[i]) res |= 0x01;
            }
            return res;
        }
        /**
         * Reads a code of length 8 in an array of bits, padding with zeros
         */ static readByte(rawbits, startIndex) {
            let n = rawbits.length - startIndex;
            if (n >= 8) return Decoder.readCode(rawbits, startIndex, 8);
            return Decoder.readCode(rawbits, startIndex, n) << 8 - n;
        }
        /**
         * Packs a bit array into bytes, most significant bit first
         */ static convertBoolArrayToByteArray(boolArr) {
            let byteArr = new Uint8Array((boolArr.length + 7) / 8);
            for(let i = 0; i < byteArr.length; i++)byteArr[i] = Decoder.readByte(boolArr, 8 * i);
            return byteArr;
        }
        totalBitsInLayer(layers, compact) {
            return ((compact ? 88 : 112) + 16 * layers) * layers;
        }
    }
    Decoder.UPPER_TABLE = [
        'CTRL_PS',
        ' ',
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z',
        'CTRL_LL',
        'CTRL_ML',
        'CTRL_DL',
        'CTRL_BS'
    ];
    Decoder.LOWER_TABLE = [
        'CTRL_PS',
        ' ',
        'a',
        'b',
        'c',
        'd',
        'e',
        'f',
        'g',
        'h',
        'i',
        'j',
        'k',
        'l',
        'm',
        'n',
        'o',
        'p',
        'q',
        'r',
        's',
        't',
        'u',
        'v',
        'w',
        'x',
        'y',
        'z',
        'CTRL_US',
        'CTRL_ML',
        'CTRL_DL',
        'CTRL_BS'
    ];
    Decoder.MIXED_TABLE = [
        // Module parse failed: Octal literal in strict mode (50:29)
        // so number string were scaped
        'CTRL_PS',
        ' ',
        '\\1',
        '\\2',
        '\\3',
        '\\4',
        '\\5',
        '\\6',
        '\\7',
        '\b',
        '\t',
        '\n',
        '\\13',
        '\f',
        '\r',
        '\\33',
        '\\34',
        '\\35',
        '\\36',
        '\\37',
        '@',
        '\\',
        '^',
        '_',
        '`',
        '|',
        '~',
        '\\177',
        'CTRL_LL',
        'CTRL_UL',
        'CTRL_PL',
        'CTRL_BS'
    ];
    Decoder.PUNCT_TABLE = [
        '',
        '\r',
        '\r\n',
        '. ',
        ', ',
        ': ',
        '!',
        '"',
        '#',
        '$',
        '%',
        '&',
        '\'',
        '(',
        ')',
        '*',
        '+',
        ',',
        '-',
        '.',
        '/',
        ':',
        ';',
        '<',
        '=',
        '>',
        '?',
        '[',
        ']',
        '{',
        '}',
        'CTRL_UL'
    ];
    Decoder.DIGIT_TABLE = [
        'CTRL_PS',
        ' ',
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        ',',
        '.',
        'CTRL_UL',
        'CTRL_US'
    ];
    /*
     * Copyright 2012 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /*namespace com.google.zxing.common.detector {*/ /**
     * General math-related and numeric utility functions.
     */ class MathUtils {
        constructor(){}
        /**
         * Ends up being a bit faster than {@link Math#round(float)}. This merely rounds its
         * argument to the nearest int, where x.5 rounds up to x+1. Semantics of this shortcut
         * differ slightly from {@link Math#round(float)} in that half rounds down for negative
         * values. -2.5 rounds to -3, not -2. For purposes here it makes no difference.
         *
         * @param d real value to round
         * @return nearest {@code int}
         */ static round(d /*float*/ ) {
            if (d <= Number.MIN_SAFE_INTEGER) return Number.MIN_SAFE_INTEGER;
            if (d >= Number.MAX_SAFE_INTEGER) return Number.MAX_SAFE_INTEGER;
            return /*(int) */ d + (d < 0.0 ? -0.5 : 0.5) | 0;
        }
        // TYPESCRIPTPORT: maybe remove round method and call directly Math.round, it looks like it doesn't make sense for js
        /**
         * @param aX point A x coordinate
         * @param aY point A y coordinate
         * @param bX point B x coordinate
         * @param bY point B y coordinate
         * @return Euclidean distance between points A and B
         */ static distance(aX /*float|int*/ , aY /*float|int*/ , bX /*float|int*/ , bY /*float|int*/ ) {
            const xDiff = aX - bX;
            const yDiff = aY - bY;
            return /*(float) */ Math.sqrt(xDiff * xDiff + yDiff * yDiff);
        }
        /**
         * @param aX point A x coordinate
         * @param aY point A y coordinate
         * @param bX point B x coordinate
         * @param bY point B y coordinate
         * @return Euclidean distance between points A and B
         */ // public static distance(aX: number /*int*/, aY: number /*int*/, bX: number /*int*/, bY: number /*int*/): float {
        //   const xDiff = aX - bX
        //   const yDiff = aY - bY
        //   return (float) Math.sqrt(xDiff * xDiff + yDiff * yDiff);
        // }
        /**
         * @param array values to sum
         * @return sum of values in array
         */ static sum(array) {
            let count = 0;
            for(let i = 0, length = array.length; i !== length; i++){
                const a = array[i];
                count += a;
            }
            return count;
        }
    }
    /**
     * Ponyfill for Java's Float class.
     */ class Float {
        /**
         * SincTS has no difference between int and float, there's all numbers,
         * this is used only to polyfill Java code.
         */ static floatToIntBits(f) {
            return f;
        }
    }
    /**
     * The float max value in JS is the number max value.
     */ Float.MAX_VALUE = Number.MAX_SAFE_INTEGER;
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * <p>Encapsulates a point of interest in an image containing a barcode. Typically, this
     * would be the location of a finder pattern or the corner of the barcode, for example.</p>
     *
     * @author Sean Owen
     */ class ResultPoint {
        constructor(x, y){
            this.x = x;
            this.y = y;
        }
        getX() {
            return this.x;
        }
        getY() {
            return this.y;
        }
        /*@Override*/ equals(other) {
            if (other instanceof ResultPoint) {
                const otherPoint = other;
                return this.x === otherPoint.x && this.y === otherPoint.y;
            }
            return false;
        }
        /*@Override*/ hashCode() {
            return 31 * Float.floatToIntBits(this.x) + Float.floatToIntBits(this.y);
        }
        /*@Override*/ toString() {
            return '(' + this.x + ',' + this.y + ')';
        }
        /**
         * Orders an array of three ResultPoints in an order [A,B,C] such that AB is less than AC
         * and BC is less than AC, and the angle between BC and BA is less than 180 degrees.
         *
         * @param patterns array of three {@code ResultPoint} to order
         */ static orderBestPatterns(patterns) {
            // Find distances between pattern centers
            const zeroOneDistance = this.distance(patterns[0], patterns[1]);
            const oneTwoDistance = this.distance(patterns[1], patterns[2]);
            const zeroTwoDistance = this.distance(patterns[0], patterns[2]);
            let pointA;
            let pointB;
            let pointC;
            // Assume one closest to other two is B; A and C will just be guesses at first
            if (oneTwoDistance >= zeroOneDistance && oneTwoDistance >= zeroTwoDistance) {
                pointB = patterns[0];
                pointA = patterns[1];
                pointC = patterns[2];
            } else if (zeroTwoDistance >= oneTwoDistance && zeroTwoDistance >= zeroOneDistance) {
                pointB = patterns[1];
                pointA = patterns[0];
                pointC = patterns[2];
            } else {
                pointB = patterns[2];
                pointA = patterns[0];
                pointC = patterns[1];
            }
            // Use cross product to figure out whether A and C are correct or flipped.
            // This asks whether BC x BA has a positive z component, which is the arrangement
            // we want for A, B, C. If it's negative, then we've got it flipped around and
            // should swap A and C.
            if (this.crossProductZ(pointA, pointB, pointC) < 0.0) {
                const temp = pointA;
                pointA = pointC;
                pointC = temp;
            }
            patterns[0] = pointA;
            patterns[1] = pointB;
            patterns[2] = pointC;
        }
        /**
         * @param pattern1 first pattern
         * @param pattern2 second pattern
         * @return distance between two points
         */ static distance(pattern1, pattern2) {
            return MathUtils.distance(pattern1.x, pattern1.y, pattern2.x, pattern2.y);
        }
        /**
         * Returns the z component of the cross product between vectors BC and BA.
         */ static crossProductZ(pointA, pointB, pointC) {
            const bX = pointB.x;
            const bY = pointB.y;
            return (pointC.x - bX) * (pointA.y - bY) - (pointC.y - bY) * (pointA.x - bX);
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * <p>Encapsulates the result of detecting a barcode in an image. This includes the raw
     * matrix of black/white pixels corresponding to the barcode, and possibly points of interest
     * in the image, like the location of finder patterns or corners of the barcode in the image.</p>
     *
     * @author Sean Owen
     */ class DetectorResult {
        constructor(bits, points){
            this.bits = bits;
            this.points = points;
        }
        getBits() {
            return this.bits;
        }
        getPoints() {
            return this.points;
        }
    }
    /*
     * Copyright 2010 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * <p>Extends {@link DetectorResult} with more information specific to the Aztec format,
     * like the number of layers and whether it's compact.</p>
     *
     * @author Sean Owen
     */ class AztecDetectorResult extends DetectorResult {
        constructor(bits, points, compact, nbDatablocks, nbLayers){
            super(bits, points);
            this.compact = compact;
            this.nbDatablocks = nbDatablocks;
            this.nbLayers = nbLayers;
        }
        getNbLayers() {
            return this.nbLayers;
        }
        getNbDatablocks() {
            return this.nbDatablocks;
        }
        isCompact() {
            return this.compact;
        }
    }
    /*
     * Copyright 2010 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * <p>
     * Detects a candidate barcode-like rectangular region within an image. It
     * starts around the center of the image, increases the size of the candidate
     * region until it finds a white rectangular region. By keeping track of the
     * last black points it encountered, it determines the corners of the barcode.
     * </p>
     *
     * @author David Olivier
     */ class WhiteRectangleDetector {
        // public constructor(private image: BitMatrix) /*throws NotFoundException*/ {
        //   this(image, INIT_SIZE, image.getWidth() / 2, image.getHeight() / 2)
        // }
        /**
         * @param image barcode image to find a rectangle in
         * @param initSize initial size of search area around center
         * @param x x position of search center
         * @param y y position of search center
         * @throws NotFoundException if image is too small to accommodate {@code initSize}
         */ constructor(image, initSize /*int*/ , x /*int*/ , y /*int*/ ){
            this.image = image;
            this.height = image.getHeight();
            this.width = image.getWidth();
            if (undefined === initSize || null === initSize) initSize = WhiteRectangleDetector.INIT_SIZE;
            if (undefined === x || null === x) x = image.getWidth() / 2 | 0;
            if (undefined === y || null === y) y = image.getHeight() / 2 | 0;
            const halfsize = initSize / 2 | 0;
            this.leftInit = x - halfsize;
            this.rightInit = x + halfsize;
            this.upInit = y - halfsize;
            this.downInit = y + halfsize;
            if (this.upInit < 0 || this.leftInit < 0 || this.downInit >= this.height || this.rightInit >= this.width) throw new NotFoundException();
        }
        /**
         * <p>
         * Detects a candidate barcode-like rectangular region within an image. It
         * starts around the center of the image, increases the size of the candidate
         * region until it finds a white rectangular region.
         * </p>
         *
         * @return {@link ResultPoint}[] describing the corners of the rectangular
         *         region. The first and last points are opposed on the diagonal, as
         *         are the second and third. The first point will be the topmost
         *         point and the last, the bottommost. The second point will be
         *         leftmost and the third, the rightmost
         * @throws NotFoundException if no Data Matrix Code can be found
         */ detect() {
            let left = this.leftInit;
            let right = this.rightInit;
            let up = this.upInit;
            let down = this.downInit;
            let sizeExceeded = false;
            let aBlackPointFoundOnBorder = true;
            let atLeastOneBlackPointFoundOnBorder = false;
            let atLeastOneBlackPointFoundOnRight = false;
            let atLeastOneBlackPointFoundOnBottom = false;
            let atLeastOneBlackPointFoundOnLeft = false;
            let atLeastOneBlackPointFoundOnTop = false;
            const width = this.width;
            const height = this.height;
            while(aBlackPointFoundOnBorder){
                aBlackPointFoundOnBorder = false;
                // .....
                // .   |
                // .....
                let rightBorderNotWhite = true;
                while((rightBorderNotWhite || !atLeastOneBlackPointFoundOnRight) && right < width){
                    rightBorderNotWhite = this.containsBlackPoint(up, down, right, false);
                    if (rightBorderNotWhite) {
                        right++;
                        aBlackPointFoundOnBorder = true;
                        atLeastOneBlackPointFoundOnRight = true;
                    } else if (!atLeastOneBlackPointFoundOnRight) right++;
                }
                if (right >= width) {
                    sizeExceeded = true;
                    break;
                }
                // .....
                // .   .
                // .___.
                let bottomBorderNotWhite = true;
                while((bottomBorderNotWhite || !atLeastOneBlackPointFoundOnBottom) && down < height){
                    bottomBorderNotWhite = this.containsBlackPoint(left, right, down, true);
                    if (bottomBorderNotWhite) {
                        down++;
                        aBlackPointFoundOnBorder = true;
                        atLeastOneBlackPointFoundOnBottom = true;
                    } else if (!atLeastOneBlackPointFoundOnBottom) down++;
                }
                if (down >= height) {
                    sizeExceeded = true;
                    break;
                }
                // .....
                // |   .
                // .....
                let leftBorderNotWhite = true;
                while((leftBorderNotWhite || !atLeastOneBlackPointFoundOnLeft) && left >= 0){
                    leftBorderNotWhite = this.containsBlackPoint(up, down, left, false);
                    if (leftBorderNotWhite) {
                        left--;
                        aBlackPointFoundOnBorder = true;
                        atLeastOneBlackPointFoundOnLeft = true;
                    } else if (!atLeastOneBlackPointFoundOnLeft) left--;
                }
                if (left < 0) {
                    sizeExceeded = true;
                    break;
                }
                // .___.
                // .   .
                // .....
                let topBorderNotWhite = true;
                while((topBorderNotWhite || !atLeastOneBlackPointFoundOnTop) && up >= 0){
                    topBorderNotWhite = this.containsBlackPoint(left, right, up, true);
                    if (topBorderNotWhite) {
                        up--;
                        aBlackPointFoundOnBorder = true;
                        atLeastOneBlackPointFoundOnTop = true;
                    } else if (!atLeastOneBlackPointFoundOnTop) up--;
                }
                if (up < 0) {
                    sizeExceeded = true;
                    break;
                }
                if (aBlackPointFoundOnBorder) atLeastOneBlackPointFoundOnBorder = true;
            }
            if (!sizeExceeded && atLeastOneBlackPointFoundOnBorder) {
                const maxSize = right - left;
                let z = null;
                for(let i = 1; z === null && i < maxSize; i++)z = this.getBlackPointOnSegment(left, down - i, left + i, down);
                if (z == null) throw new NotFoundException();
                let t = null;
                // go down right
                for(let i = 1; t === null && i < maxSize; i++)t = this.getBlackPointOnSegment(left, up + i, left + i, up);
                if (t == null) throw new NotFoundException();
                let x = null;
                // go down left
                for(let i = 1; x === null && i < maxSize; i++)x = this.getBlackPointOnSegment(right, up + i, right - i, up);
                if (x == null) throw new NotFoundException();
                let y = null;
                // go up left
                for(let i = 1; y === null && i < maxSize; i++)y = this.getBlackPointOnSegment(right, down - i, right - i, down);
                if (y == null) throw new NotFoundException();
                return this.centerEdges(y, z, x, t);
            } else throw new NotFoundException();
        }
        getBlackPointOnSegment(aX /*float*/ , aY /*float*/ , bX /*float*/ , bY /*float*/ ) {
            const dist = MathUtils.round(MathUtils.distance(aX, aY, bX, bY));
            const xStep = (bX - aX) / dist;
            const yStep = (bY - aY) / dist;
            const image = this.image;
            for(let i = 0; i < dist; i++){
                const x = MathUtils.round(aX + i * xStep);
                const y = MathUtils.round(aY + i * yStep);
                if (image.get(x, y)) return new ResultPoint(x, y);
            }
            return null;
        }
        /**
         * recenters the points of a constant distance towards the center
         *
         * @param y bottom most point
         * @param z left most point
         * @param x right most point
         * @param t top most point
         * @return {@link ResultPoint}[] describing the corners of the rectangular
         *         region. The first and last points are opposed on the diagonal, as
         *         are the second and third. The first point will be the topmost
         *         point and the last, the bottommost. The second point will be
         *         leftmost and the third, the rightmost
         */ centerEdges(y, z, x, t) {
            //
            //       t            t
            //  z                      x
            //        x    OR    z
            //   y                    y
            //
            const yi = y.getX();
            const yj = y.getY();
            const zi = z.getX();
            const zj = z.getY();
            const xi = x.getX();
            const xj = x.getY();
            const ti = t.getX();
            const tj = t.getY();
            const CORR = WhiteRectangleDetector.CORR;
            if (yi < this.width / 2.0) return [
                new ResultPoint(ti - CORR, tj + CORR),
                new ResultPoint(zi + CORR, zj + CORR),
                new ResultPoint(xi - CORR, xj - CORR),
                new ResultPoint(yi + CORR, yj - CORR)
            ];
            else return [
                new ResultPoint(ti + CORR, tj + CORR),
                new ResultPoint(zi + CORR, zj - CORR),
                new ResultPoint(xi - CORR, xj + CORR),
                new ResultPoint(yi - CORR, yj - CORR)
            ];
        }
        /**
         * Determines whether a segment contains a black point
         *
         * @param a          min value of the scanned coordinate
         * @param b          max value of the scanned coordinate
         * @param fixed      value of fixed coordinate
         * @param horizontal set to true if scan must be horizontal, false if vertical
         * @return true if a black point has been found, else false.
         */ containsBlackPoint(a /*int*/ , b /*int*/ , fixed /*int*/ , horizontal) {
            const image = this.image;
            if (horizontal) for(let x = a; x <= b; x++){
                if (image.get(x, fixed)) return true;
            }
            else for(let y = a; y <= b; y++){
                if (image.get(fixed, y)) return true;
            }
            return false;
        }
    }
    WhiteRectangleDetector.INIT_SIZE = 10;
    WhiteRectangleDetector.CORR = 1;
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * Implementations of this class can, given locations of finder patterns for a QR code in an
     * image, sample the right points in the image to reconstruct the QR code, accounting for
     * perspective distortion. It is abstracted since it is relatively expensive and should be allowed
     * to take advantage of platform-specific optimized implementations, like Sun's Java Advanced
     * Imaging library, but which may not be available in other environments such as J2ME, and vice
     * versa.
     *
     * The implementation used can be controlled by calling {@link #setGridSampler(GridSampler)}
     * with an instance of a class which implements this interface.
     *
     * @author Sean Owen
     */ class GridSampler {
        /**
         * <p>Checks a set of points that have been transformed to sample points on an image against
         * the image's dimensions to see if the point are even within the image.</p>
         *
         * <p>This method will actually "nudge" the endpoints back onto the image if they are found to be
         * barely (less than 1 pixel) off the image. This accounts for imperfect detection of finder
         * patterns in an image where the QR Code runs all the way to the image border.</p>
         *
         * <p>For efficiency, the method will check points from either end of the line until one is found
         * to be within the image. Because the set of points are assumed to be linear, this is valid.</p>
         *
         * @param image image into which the points should map
         * @param points actual points in x1,y1,...,xn,yn form
         * @throws NotFoundException if an endpoint is lies outside the image boundaries
         */ static checkAndNudgePoints(image, points) {
            const width = image.getWidth();
            const height = image.getHeight();
            // Check and nudge points from start until we see some that are OK:
            let nudged = true;
            for(let offset = 0; offset < points.length && nudged; offset += 2){
                const x = Math.floor(points[offset]);
                const y = Math.floor(points[offset + 1]);
                if (x < -1 || x > width || y < -1 || y > height) throw new NotFoundException();
                nudged = false;
                if (x === -1) {
                    points[offset] = 0.0;
                    nudged = true;
                } else if (x === width) {
                    points[offset] = width - 1;
                    nudged = true;
                }
                if (y === -1) {
                    points[offset + 1] = 0.0;
                    nudged = true;
                } else if (y === height) {
                    points[offset + 1] = height - 1;
                    nudged = true;
                }
            }
            // Check and nudge points from end:
            nudged = true;
            for(let offset = points.length - 2; offset >= 0 && nudged; offset -= 2){
                const x = Math.floor(points[offset]);
                const y = Math.floor(points[offset + 1]);
                if (x < -1 || x > width || y < -1 || y > height) throw new NotFoundException();
                nudged = false;
                if (x === -1) {
                    points[offset] = 0.0;
                    nudged = true;
                } else if (x === width) {
                    points[offset] = width - 1;
                    nudged = true;
                }
                if (y === -1) {
                    points[offset + 1] = 0.0;
                    nudged = true;
                } else if (y === height) {
                    points[offset + 1] = height - 1;
                    nudged = true;
                }
            }
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /*namespace com.google.zxing.common {*/ /**
     * <p>This class implements a perspective transform in two dimensions. Given four source and four
     * destination points, it will compute the transformation implied between them. The code is based
     * directly upon section 3.4.2 of George Wolberg's "Digital Image Warping"; see pages 54-56.</p>
     *
     * @author Sean Owen
     */ class PerspectiveTransform {
        constructor(a11 /*float*/ , a21 /*float*/ , a31 /*float*/ , a12 /*float*/ , a22 /*float*/ , a32 /*float*/ , a13 /*float*/ , a23 /*float*/ , a33 /*float*/ ){
            this.a11 = a11;
            this.a21 = a21;
            this.a31 = a31;
            this.a12 = a12;
            this.a22 = a22;
            this.a32 = a32;
            this.a13 = a13;
            this.a23 = a23;
            this.a33 = a33;
        }
        static quadrilateralToQuadrilateral(x0 /*float*/ , y0 /*float*/ , x1 /*float*/ , y1 /*float*/ , x2 /*float*/ , y2 /*float*/ , x3 /*float*/ , y3 /*float*/ , x0p /*float*/ , y0p /*float*/ , x1p /*float*/ , y1p /*float*/ , x2p /*float*/ , y2p /*float*/ , x3p /*float*/ , y3p /*float*/ ) {
            const qToS = PerspectiveTransform.quadrilateralToSquare(x0, y0, x1, y1, x2, y2, x3, y3);
            const sToQ = PerspectiveTransform.squareToQuadrilateral(x0p, y0p, x1p, y1p, x2p, y2p, x3p, y3p);
            return sToQ.times(qToS);
        }
        transformPoints(points) {
            const max = points.length;
            const a11 = this.a11;
            const a12 = this.a12;
            const a13 = this.a13;
            const a21 = this.a21;
            const a22 = this.a22;
            const a23 = this.a23;
            const a31 = this.a31;
            const a32 = this.a32;
            const a33 = this.a33;
            for(let i = 0; i < max; i += 2){
                const x = points[i];
                const y = points[i + 1];
                const denominator = a13 * x + a23 * y + a33;
                points[i] = (a11 * x + a21 * y + a31) / denominator;
                points[i + 1] = (a12 * x + a22 * y + a32) / denominator;
            }
        }
        transformPointsWithValues(xValues, yValues) {
            const a11 = this.a11;
            const a12 = this.a12;
            const a13 = this.a13;
            const a21 = this.a21;
            const a22 = this.a22;
            const a23 = this.a23;
            const a31 = this.a31;
            const a32 = this.a32;
            const a33 = this.a33;
            const n = xValues.length;
            for(let i = 0; i < n; i++){
                const x = xValues[i];
                const y = yValues[i];
                const denominator = a13 * x + a23 * y + a33;
                xValues[i] = (a11 * x + a21 * y + a31) / denominator;
                yValues[i] = (a12 * x + a22 * y + a32) / denominator;
            }
        }
        static squareToQuadrilateral(x0 /*float*/ , y0 /*float*/ , x1 /*float*/ , y1 /*float*/ , x2 /*float*/ , y2 /*float*/ , x3 /*float*/ , y3 /*float*/ ) {
            const dx3 = x0 - x1 + x2 - x3;
            const dy3 = y0 - y1 + y2 - y3;
            if (dx3 === 0.0 && dy3 === 0.0) // Affine
            return new PerspectiveTransform(x1 - x0, x2 - x1, x0, y1 - y0, y2 - y1, y0, 0.0, 0.0, 1.0);
            else {
                const dx1 = x1 - x2;
                const dx2 = x3 - x2;
                const dy1 = y1 - y2;
                const dy2 = y3 - y2;
                const denominator = dx1 * dy2 - dx2 * dy1;
                const a13 = (dx3 * dy2 - dx2 * dy3) / denominator;
                const a23 = (dx1 * dy3 - dx3 * dy1) / denominator;
                return new PerspectiveTransform(x1 - x0 + a13 * x1, x3 - x0 + a23 * x3, x0, y1 - y0 + a13 * y1, y3 - y0 + a23 * y3, y0, a13, a23, 1.0);
            }
        }
        static quadrilateralToSquare(x0 /*float*/ , y0 /*float*/ , x1 /*float*/ , y1 /*float*/ , x2 /*float*/ , y2 /*float*/ , x3 /*float*/ , y3 /*float*/ ) {
            // Here, the adjoint serves as the inverse:
            return PerspectiveTransform.squareToQuadrilateral(x0, y0, x1, y1, x2, y2, x3, y3).buildAdjoint();
        }
        buildAdjoint() {
            // Adjoint is the transpose of the cofactor matrix:
            return new PerspectiveTransform(this.a22 * this.a33 - this.a23 * this.a32, this.a23 * this.a31 - this.a21 * this.a33, this.a21 * this.a32 - this.a22 * this.a31, this.a13 * this.a32 - this.a12 * this.a33, this.a11 * this.a33 - this.a13 * this.a31, this.a12 * this.a31 - this.a11 * this.a32, this.a12 * this.a23 - this.a13 * this.a22, this.a13 * this.a21 - this.a11 * this.a23, this.a11 * this.a22 - this.a12 * this.a21);
        }
        times(other) {
            return new PerspectiveTransform(this.a11 * other.a11 + this.a21 * other.a12 + this.a31 * other.a13, this.a11 * other.a21 + this.a21 * other.a22 + this.a31 * other.a23, this.a11 * other.a31 + this.a21 * other.a32 + this.a31 * other.a33, this.a12 * other.a11 + this.a22 * other.a12 + this.a32 * other.a13, this.a12 * other.a21 + this.a22 * other.a22 + this.a32 * other.a23, this.a12 * other.a31 + this.a22 * other.a32 + this.a32 * other.a33, this.a13 * other.a11 + this.a23 * other.a12 + this.a33 * other.a13, this.a13 * other.a21 + this.a23 * other.a22 + this.a33 * other.a23, this.a13 * other.a31 + this.a23 * other.a32 + this.a33 * other.a33);
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * @author Sean Owen
     */ class DefaultGridSampler extends GridSampler {
        /*@Override*/ sampleGrid(image, dimensionX /*int*/ , dimensionY /*int*/ , p1ToX /*float*/ , p1ToY /*float*/ , p2ToX /*float*/ , p2ToY /*float*/ , p3ToX /*float*/ , p3ToY /*float*/ , p4ToX /*float*/ , p4ToY /*float*/ , p1FromX /*float*/ , p1FromY /*float*/ , p2FromX /*float*/ , p2FromY /*float*/ , p3FromX /*float*/ , p3FromY /*float*/ , p4FromX /*float*/ , p4FromY /*float*/ ) {
            const transform = PerspectiveTransform.quadrilateralToQuadrilateral(p1ToX, p1ToY, p2ToX, p2ToY, p3ToX, p3ToY, p4ToX, p4ToY, p1FromX, p1FromY, p2FromX, p2FromY, p3FromX, p3FromY, p4FromX, p4FromY);
            return this.sampleGridWithTransform(image, dimensionX, dimensionY, transform);
        }
        /*@Override*/ sampleGridWithTransform(image, dimensionX /*int*/ , dimensionY /*int*/ , transform) {
            if (dimensionX <= 0 || dimensionY <= 0) throw new NotFoundException();
            const bits = new BitMatrix(dimensionX, dimensionY);
            const points = new Float32Array(2 * dimensionX);
            for(let y = 0; y < dimensionY; y++){
                const max = points.length;
                const iValue = y + 0.5;
                for(let x = 0; x < max; x += 2){
                    points[x] = x / 2 + 0.5;
                    points[x + 1] = iValue;
                }
                transform.transformPoints(points);
                // Quick check to see if points transformed to something inside the image
                // sufficient to check the endpoints
                GridSampler.checkAndNudgePoints(image, points);
                try {
                    for(let x = 0; x < max; x += 2)if (image.get(Math.floor(points[x]), Math.floor(points[x + 1]))) // Black(-ish) pixel
                    bits.set(x / 2, y);
                } catch (aioobe /*: ArrayIndexOutOfBoundsException*/ ) {
                    // This feels wrong, but, sometimes if the finder patterns are misidentified, the resulting
                    // transform gets "twisted" such that it maps a straight line of points to a set of points
                    // whose endpoints are in bounds, but others are not. There is probably some mathematical
                    // way to detect this about the transformation that I don't know yet.
                    // This results in an ugly runtime exception despite our clever checks above -- can't have
                    // that. We could check each point's coordinates but that feels duplicative. We settle for
                    // catching and wrapping ArrayIndexOutOfBoundsException.
                    throw new NotFoundException();
                }
            }
            return bits;
        }
    }
    class GridSamplerInstance {
        /**
         * Sets the implementation of GridSampler used by the library. One global
         * instance is stored, which may sound problematic. But, the implementation provided
         * ought to be appropriate for the entire platform, and all uses of this library
         * in the whole lifetime of the JVM. For instance, an Android activity can swap in
         * an implementation that takes advantage of native platform libraries.
         *
         * @param newGridSampler The platform-specific object to install.
         */ static setGridSampler(newGridSampler) {
            GridSamplerInstance.gridSampler = newGridSampler;
        }
        /**
         * @return the current implementation of GridSampler
         */ static getInstance() {
            return GridSamplerInstance.gridSampler;
        }
    }
    GridSamplerInstance.gridSampler = new DefaultGridSampler();
    /*
     * Copyright 2010 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ class Point {
        constructor(x, y){
            this.x = x;
            this.y = y;
        }
        toResultPoint() {
            return new ResultPoint(this.getX(), this.getY());
        }
        getX() {
            return this.x;
        }
        getY() {
            return this.y;
        }
    }
    /**
     * Encapsulates logic that can detect an Aztec Code in an image, even if the Aztec Code
     * is rotated or skewed, or partially obscured.
     *
     * @author David Olivier
     * @author Frank Yellin
     */ class Detector {
        constructor(image){
            this.EXPECTED_CORNER_BITS = new Int32Array([
                0xee0,
                0x1dc,
                0x83b,
                0x707
            ]);
            this.image = image;
        }
        detect() {
            return this.detectMirror(false);
        }
        /**
         * Detects an Aztec Code in an image.
         *
         * @param isMirror if true, image is a mirror-image of original
         * @return {@link AztecDetectorResult} encapsulating results of detecting an Aztec Code
         * @throws NotFoundException if no Aztec Code can be found
         */ detectMirror(isMirror) {
            // 1. Get the center of the aztec matrix
            let pCenter = this.getMatrixCenter();
            // 2. Get the center points of the four diagonal points just outside the bull's eye
            //  [topRight, bottomRight, bottomLeft, topLeft]
            let bullsEyeCorners = this.getBullsEyeCorners(pCenter);
            if (isMirror) {
                let temp = bullsEyeCorners[0];
                bullsEyeCorners[0] = bullsEyeCorners[2];
                bullsEyeCorners[2] = temp;
            }
            // 3. Get the size of the matrix and other parameters from the bull's eye
            this.extractParameters(bullsEyeCorners);
            // 4. Sample the grid
            let bits = this.sampleGrid(this.image, bullsEyeCorners[this.shift % 4], bullsEyeCorners[(this.shift + 1) % 4], bullsEyeCorners[(this.shift + 2) % 4], bullsEyeCorners[(this.shift + 3) % 4]);
            // 5. Get the corners of the matrix.
            let corners = this.getMatrixCornerPoints(bullsEyeCorners);
            return new AztecDetectorResult(bits, corners, this.compact, this.nbDataBlocks, this.nbLayers);
        }
        /**
         * Extracts the number of data layers and data blocks from the layer around the bull's eye.
         *
         * @param bullsEyeCorners the array of bull's eye corners
         * @throws NotFoundException in case of too many errors or invalid parameters
         */ extractParameters(bullsEyeCorners) {
            if (!this.isValidPoint(bullsEyeCorners[0]) || !this.isValidPoint(bullsEyeCorners[1]) || !this.isValidPoint(bullsEyeCorners[2]) || !this.isValidPoint(bullsEyeCorners[3])) throw new NotFoundException();
            let length = 2 * this.nbCenterLayers;
            // Get the bits around the bull's eye
            let sides = new Int32Array([
                this.sampleLine(bullsEyeCorners[0], bullsEyeCorners[1], length),
                this.sampleLine(bullsEyeCorners[1], bullsEyeCorners[2], length),
                this.sampleLine(bullsEyeCorners[2], bullsEyeCorners[3], length),
                this.sampleLine(bullsEyeCorners[3], bullsEyeCorners[0], length) // Top
            ]);
            // bullsEyeCorners[shift] is the corner of the bulls'eye that has three
            // orientation marks.
            // sides[shift] is the row/column that goes from the corner with three
            // orientation marks to the corner with two.
            this.shift = this.getRotation(sides, length);
            // Flatten the parameter bits into a single 28- or 40-bit long
            let parameterData = 0;
            for(let i = 0; i < 4; i++){
                let side = sides[(this.shift + i) % 4];
                if (this.compact) {
                    // Each side of the form ..XXXXXXX. where Xs are parameter data
                    parameterData <<= 7;
                    parameterData += side >> 1 & 0x7F;
                } else {
                    // Each side of the form ..XXXXX.XXXXX. where Xs are parameter data
                    parameterData <<= 10;
                    parameterData += (side >> 2 & 992) + (side >> 1 & 0x1F);
                }
            }
            // Corrects parameter data using RS.  Returns just the data portion
            // without the error correction.
            let correctedData = this.getCorrectedParameterData(parameterData, this.compact);
            if (this.compact) {
                // 8 bits:  2 bits layers and 6 bits data blocks
                this.nbLayers = (correctedData >> 6) + 1;
                this.nbDataBlocks = (correctedData & 0x3F) + 1;
            } else {
                // 16 bits:  5 bits layers and 11 bits data blocks
                this.nbLayers = (correctedData >> 11) + 1;
                this.nbDataBlocks = (correctedData & 0x7FF) + 1;
            }
        }
        getRotation(sides, length) {
            // In a normal pattern, we expect to See
            //   **    .*             D       A
            //   *      *
            //
            //   .      *
            //   ..    ..             C       B
            //
            // Grab the 3 bits from each of the sides the form the locator pattern and concatenate
            // into a 12-bit integer.  Start with the bit at A
            let cornerBits = 0;
            sides.forEach((side, idx, arr)=>{
                // XX......X where X's are orientation marks
                let t = (side >> length - 2 << 1) + (side & 1);
                cornerBits = (cornerBits << 3) + t;
            });
            // for (var side in sides) {
            //     // XX......X where X's are orientation marks
            //     var t = ((side >> (length - 2)) << 1) + (side & 1);
            //     cornerBits = (cornerBits << 3) + t;
            // }
            // Mov the bottom bit to the top, so that the three bits of the locator pattern at A are
            // together.  cornerBits is now:
            //  3 orientation bits at A || 3 orientation bits at B || ... || 3 orientation bits at D
            cornerBits = ((cornerBits & 1) << 11) + (cornerBits >> 1);
            // The result shift indicates which element of BullsEyeCorners[] goes into the top-left
            // corner. Since the four rotation values have a Hamming distance of 8, we
            // can easily tolerate two errors.
            for(let shift = 0; shift < 4; shift++){
                if (Integer.bitCount(cornerBits ^ this.EXPECTED_CORNER_BITS[shift]) <= 2) return shift;
            }
            throw new NotFoundException();
        }
        /**
         * Corrects the parameter bits using Reed-Solomon algorithm.
         *
         * @param parameterData parameter bits
         * @param compact true if this is a compact Aztec code
         * @throws NotFoundException if the array contains too many errors
         */ getCorrectedParameterData(parameterData, compact) {
            let numCodewords;
            let numDataCodewords;
            if (compact) {
                numCodewords = 7;
                numDataCodewords = 2;
            } else {
                numCodewords = 10;
                numDataCodewords = 4;
            }
            let numECCodewords = numCodewords - numDataCodewords;
            let parameterWords = new Int32Array(numCodewords);
            for(let i = numCodewords - 1; i >= 0; --i){
                parameterWords[i] = parameterData & 0xF;
                parameterData >>= 4;
            }
            try {
                let rsDecoder = new ReedSolomonDecoder(GenericGF.AZTEC_PARAM);
                rsDecoder.decode(parameterWords, numECCodewords);
            } catch (ignored) {
                throw new NotFoundException();
            }
            // Toss the error correction.  Just return the data as an integer
            let result = 0;
            for(let i = 0; i < numDataCodewords; i++)result = (result << 4) + parameterWords[i];
            return result;
        }
        /**
         * Finds the corners of a bull-eye centered on the passed point.
         * This returns the centers of the diagonal points just outside the bull's eye
         * Returns [topRight, bottomRight, bottomLeft, topLeft]
         *
         * @param pCenter Center point
         * @return The corners of the bull-eye
         * @throws NotFoundException If no valid bull-eye can be found
         */ getBullsEyeCorners(pCenter) {
            let pina = pCenter;
            let pinb = pCenter;
            let pinc = pCenter;
            let pind = pCenter;
            let color = true;
            for(this.nbCenterLayers = 1; this.nbCenterLayers < 9; this.nbCenterLayers++){
                let pouta = this.getFirstDifferent(pina, color, 1, -1);
                let poutb = this.getFirstDifferent(pinb, color, 1, 1);
                let poutc = this.getFirstDifferent(pinc, color, -1, 1);
                let poutd = this.getFirstDifferent(pind, color, -1, -1);
                // d      a
                //
                // c      b
                if (this.nbCenterLayers > 2) {
                    let q = this.distancePoint(poutd, pouta) * this.nbCenterLayers / (this.distancePoint(pind, pina) * (this.nbCenterLayers + 2));
                    if (q < 0.75 || q > 1.25 || !this.isWhiteOrBlackRectangle(pouta, poutb, poutc, poutd)) break;
                }
                pina = pouta;
                pinb = poutb;
                pinc = poutc;
                pind = poutd;
                color = !color;
            }
            if (this.nbCenterLayers !== 5 && this.nbCenterLayers !== 7) throw new NotFoundException();
            this.compact = this.nbCenterLayers === 5;
            // Expand the square by .5 pixel in each direction so that we're on the border
            // between the white square and the black square
            let pinax = new ResultPoint(pina.getX() + 0.5, pina.getY() - 0.5);
            let pinbx = new ResultPoint(pinb.getX() + 0.5, pinb.getY() + 0.5);
            let pincx = new ResultPoint(pinc.getX() - 0.5, pinc.getY() + 0.5);
            let pindx = new ResultPoint(pind.getX() - 0.5, pind.getY() - 0.5);
            // Expand the square so that its corners are the centers of the points
            // just outside the bull's eye.
            return this.expandSquare([
                pinax,
                pinbx,
                pincx,
                pindx
            ], 2 * this.nbCenterLayers - 3, 2 * this.nbCenterLayers);
        }
        /**
         * Finds a candidate center point of an Aztec code from an image
         *
         * @return the center point
         */ getMatrixCenter() {
            let pointA;
            let pointB;
            let pointC;
            let pointD;
            // Get a white rectangle that can be the border of the matrix in center bull's eye or
            try {
                let cornerPoints = new WhiteRectangleDetector(this.image).detect();
                pointA = cornerPoints[0];
                pointB = cornerPoints[1];
                pointC = cornerPoints[2];
                pointD = cornerPoints[3];
            } catch (e) {
                // This exception can be in case the initial rectangle is white
                // In that case, surely in the bull's eye, we try to expand the rectangle.
                let cx = this.image.getWidth() / 2;
                let cy = this.image.getHeight() / 2;
                pointA = this.getFirstDifferent(new Point(cx + 7, cy - 7), false, 1, -1).toResultPoint();
                pointB = this.getFirstDifferent(new Point(cx + 7, cy + 7), false, 1, 1).toResultPoint();
                pointC = this.getFirstDifferent(new Point(cx - 7, cy + 7), false, -1, 1).toResultPoint();
                pointD = this.getFirstDifferent(new Point(cx - 7, cy - 7), false, -1, -1).toResultPoint();
            }
            // Compute the center of the rectangle
            let cx = MathUtils.round((pointA.getX() + pointD.getX() + pointB.getX() + pointC.getX()) / 4.0);
            let cy = MathUtils.round((pointA.getY() + pointD.getY() + pointB.getY() + pointC.getY()) / 4.0);
            // Redetermine the white rectangle starting from previously computed center.
            // This will ensure that we end up with a white rectangle in center bull's eye
            // in order to compute a more accurate center.
            try {
                let cornerPoints = new WhiteRectangleDetector(this.image, 15, cx, cy).detect();
                pointA = cornerPoints[0];
                pointB = cornerPoints[1];
                pointC = cornerPoints[2];
                pointD = cornerPoints[3];
            } catch (e) {
                // This exception can be in case the initial rectangle is white
                // In that case we try to expand the rectangle.
                pointA = this.getFirstDifferent(new Point(cx + 7, cy - 7), false, 1, -1).toResultPoint();
                pointB = this.getFirstDifferent(new Point(cx + 7, cy + 7), false, 1, 1).toResultPoint();
                pointC = this.getFirstDifferent(new Point(cx - 7, cy + 7), false, -1, 1).toResultPoint();
                pointD = this.getFirstDifferent(new Point(cx - 7, cy - 7), false, -1, -1).toResultPoint();
            }
            // Recompute the center of the rectangle
            cx = MathUtils.round((pointA.getX() + pointD.getX() + pointB.getX() + pointC.getX()) / 4.0);
            cy = MathUtils.round((pointA.getY() + pointD.getY() + pointB.getY() + pointC.getY()) / 4.0);
            return new Point(cx, cy);
        }
        /**
         * Gets the Aztec code corners from the bull's eye corners and the parameters.
         *
         * @param bullsEyeCorners the array of bull's eye corners
         * @return the array of aztec code corners
         */ getMatrixCornerPoints(bullsEyeCorners) {
            return this.expandSquare(bullsEyeCorners, 2 * this.nbCenterLayers, this.getDimension());
        }
        /**
         * Creates a BitMatrix by sampling the provided image.
         * topLeft, topRight, bottomRight, and bottomLeft are the centers of the squares on the
         * diagonal just outside the bull's eye.
         */ sampleGrid(image, topLeft, topRight, bottomRight, bottomLeft) {
            let sampler = GridSamplerInstance.getInstance();
            let dimension = this.getDimension();
            let low = dimension / 2 - this.nbCenterLayers;
            let high = dimension / 2 + this.nbCenterLayers;
            return sampler.sampleGrid(image, dimension, dimension, low, low, high, low, high, high, low, high, topLeft.getX(), topLeft.getY(), topRight.getX(), topRight.getY(), bottomRight.getX(), bottomRight.getY(), bottomLeft.getX(), bottomLeft.getY());
        }
        /**
         * Samples a line.
         *
         * @param p1   start point (inclusive)
         * @param p2   end point (exclusive)
         * @param size number of bits
         * @return the array of bits as an int (first bit is high-order bit of result)
         */ sampleLine(p1, p2, size) {
            let result = 0;
            let d = this.distanceResultPoint(p1, p2);
            let moduleSize = d / size;
            let px = p1.getX();
            let py = p1.getY();
            let dx = moduleSize * (p2.getX() - p1.getX()) / d;
            let dy = moduleSize * (p2.getY() - p1.getY()) / d;
            for(let i = 0; i < size; i++)if (this.image.get(MathUtils.round(px + i * dx), MathUtils.round(py + i * dy))) result |= 1 << size - i - 1;
            return result;
        }
        /**
         * @return true if the border of the rectangle passed in parameter is compound of white points only
         *         or black points only
         */ isWhiteOrBlackRectangle(p1, p2, p3, p4) {
            let corr = 3;
            p1 = new Point(p1.getX() - corr, p1.getY() + corr);
            p2 = new Point(p2.getX() - corr, p2.getY() - corr);
            p3 = new Point(p3.getX() + corr, p3.getY() - corr);
            p4 = new Point(p4.getX() + corr, p4.getY() + corr);
            let cInit = this.getColor(p4, p1);
            if (cInit === 0) return false;
            let c = this.getColor(p1, p2);
            if (c !== cInit) return false;
            c = this.getColor(p2, p3);
            if (c !== cInit) return false;
            c = this.getColor(p3, p4);
            return c === cInit;
        }
        /**
         * Gets the color of a segment
         *
         * @return 1 if segment more than 90% black, -1 if segment is more than 90% white, 0 else
         */ getColor(p1, p2) {
            let d = this.distancePoint(p1, p2);
            let dx = (p2.getX() - p1.getX()) / d;
            let dy = (p2.getY() - p1.getY()) / d;
            let error = 0;
            let px = p1.getX();
            let py = p1.getY();
            let colorModel = this.image.get(p1.getX(), p1.getY());
            let iMax = Math.ceil(d);
            for(let i = 0; i < iMax; i++){
                px += dx;
                py += dy;
                if (this.image.get(MathUtils.round(px), MathUtils.round(py)) !== colorModel) error++;
            }
            let errRatio = error / d;
            if (errRatio > 0.1 && errRatio < 0.9) return 0;
            return errRatio <= 0.1 === colorModel ? 1 : -1;
        }
        /**
         * Gets the coordinate of the first point with a different color in the given direction
         */ getFirstDifferent(init, color, dx, dy) {
            let x = init.getX() + dx;
            let y = init.getY() + dy;
            while(this.isValid(x, y) && this.image.get(x, y) === color){
                x += dx;
                y += dy;
            }
            x -= dx;
            y -= dy;
            while(this.isValid(x, y) && this.image.get(x, y) === color)x += dx;
            x -= dx;
            while(this.isValid(x, y) && this.image.get(x, y) === color)y += dy;
            y -= dy;
            return new Point(x, y);
        }
        /**
         * Expand the square represented by the corner points by pushing out equally in all directions
         *
         * @param cornerPoints the corners of the square, which has the bull's eye at its center
         * @param oldSide the original length of the side of the square in the target bit matrix
         * @param newSide the new length of the size of the square in the target bit matrix
         * @return the corners of the expanded square
         */ expandSquare(cornerPoints, oldSide, newSide) {
            let ratio = newSide / (2.0 * oldSide);
            let dx = cornerPoints[0].getX() - cornerPoints[2].getX();
            let dy = cornerPoints[0].getY() - cornerPoints[2].getY();
            let centerx = (cornerPoints[0].getX() + cornerPoints[2].getX()) / 2.0;
            let centery = (cornerPoints[0].getY() + cornerPoints[2].getY()) / 2.0;
            let result0 = new ResultPoint(centerx + ratio * dx, centery + ratio * dy);
            let result2 = new ResultPoint(centerx - ratio * dx, centery - ratio * dy);
            dx = cornerPoints[1].getX() - cornerPoints[3].getX();
            dy = cornerPoints[1].getY() - cornerPoints[3].getY();
            centerx = (cornerPoints[1].getX() + cornerPoints[3].getX()) / 2.0;
            centery = (cornerPoints[1].getY() + cornerPoints[3].getY()) / 2.0;
            let result1 = new ResultPoint(centerx + ratio * dx, centery + ratio * dy);
            let result3 = new ResultPoint(centerx - ratio * dx, centery - ratio * dy);
            let results = [
                result0,
                result1,
                result2,
                result3
            ];
            return results;
        }
        isValid(x, y) {
            return x >= 0 && x < this.image.getWidth() && y > 0 && y < this.image.getHeight();
        }
        isValidPoint(point) {
            let x = MathUtils.round(point.getX());
            let y = MathUtils.round(point.getY());
            return this.isValid(x, y);
        }
        distancePoint(a, b) {
            return MathUtils.distance(a.getX(), a.getY(), b.getX(), b.getY());
        }
        distanceResultPoint(a, b) {
            return MathUtils.distance(a.getX(), a.getY(), b.getX(), b.getY());
        }
        getDimension() {
            if (this.compact) return 4 * this.nbLayers + 11;
            if (this.nbLayers <= 4) return 4 * this.nbLayers + 15;
            return 4 * this.nbLayers + 2 * (Integer.truncDivision(this.nbLayers - 4, 8) + 1) + 15;
        }
    }
    /*
     * Copyright 2010 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ // import java.util.List;
    // import java.util.Map;
    /**
     * This implementation can detect and decode Aztec codes in an image.
     *
     * @author David Olivier
     */ class AztecReader {
        /**
         * Locates and decodes a Data Matrix code in an image.
         *
         * @return a String representing the content encoded by the Data Matrix code
         * @throws NotFoundException if a Data Matrix code cannot be found
         * @throws FormatException if a Data Matrix code cannot be decoded
         */ decode(image, hints = null) {
            let exception = null;
            let detector = new Detector(image.getBlackMatrix());
            let points = null;
            let decoderResult = null;
            try {
                let detectorResult = detector.detectMirror(false);
                points = detectorResult.getPoints();
                this.reportFoundResultPoints(hints, points);
                decoderResult = new Decoder().decode(detectorResult);
            } catch (e) {
                exception = e;
            }
            if (decoderResult == null) try {
                let detectorResult = detector.detectMirror(true);
                points = detectorResult.getPoints();
                this.reportFoundResultPoints(hints, points);
                decoderResult = new Decoder().decode(detectorResult);
            } catch (e) {
                if (exception != null) throw exception;
                throw e;
            }
            let result = new Result(decoderResult.getText(), decoderResult.getRawBytes(), decoderResult.getNumBits(), points, BarcodeFormat$1.AZTEC, System.currentTimeMillis());
            let byteSegments = decoderResult.getByteSegments();
            if (byteSegments != null) result.putMetadata(ResultMetadataType$1.BYTE_SEGMENTS, byteSegments);
            let ecLevel = decoderResult.getECLevel();
            if (ecLevel != null) result.putMetadata(ResultMetadataType$1.ERROR_CORRECTION_LEVEL, ecLevel);
            return result;
        }
        reportFoundResultPoints(hints, points) {
            if (hints != null) {
                let rpcb = hints.get(DecodeHintType$1.NEED_RESULT_POINT_CALLBACK);
                if (rpcb != null) points.forEach((point, idx, arr)=>{
                    rpcb.foundPossibleResultPoint(point);
                });
            }
        }
        // @Override
        reset() {
        // do nothing
        }
    }
    /**
     * Aztec Code reader to use from browser.
     *
     * @class BrowserAztecCodeReader
     * @extends {BrowserCodeReader}
     */ class BrowserAztecCodeReader extends BrowserCodeReader {
        /**
         * Creates an instance of BrowserAztecCodeReader.
         * @param {number} [timeBetweenScansMillis=500] the time delay between subsequent decode tries
         *
         * @memberOf BrowserAztecCodeReader
         */ constructor(timeBetweenScansMillis = 500){
            super(new AztecReader(), timeBetweenScansMillis);
        }
    }
    /**
     * Encapsulates functionality and implementation that is common to all families
     * of one-dimensional barcodes.
     *
     * @author dswitkin@google.com (Daniel Switkin)
     * @author Sean Owen
     */ class OneDReader {
        /*
        @Override
        public Result decode(BinaryBitmap image) throws NotFoundException, FormatException {
          return decode(image, null);
        }
        */ // Note that we don't try rotation without the try harder flag, even if rotation was supported.
        // @Override
        decode(image, hints) {
            try {
                return this.doDecode(image, hints);
            } catch (nfe) {
                const tryHarder = hints && hints.get(DecodeHintType$1.TRY_HARDER) === true;
                if (tryHarder && image.isRotateSupported()) {
                    const rotatedImage = image.rotateCounterClockwise();
                    const result = this.doDecode(rotatedImage, hints);
                    // Record that we found it rotated 90 degrees CCW / 270 degrees CW
                    const metadata = result.getResultMetadata();
                    let orientation = 270;
                    if (metadata !== null && metadata.get(ResultMetadataType$1.ORIENTATION) === true) // But if we found it reversed in doDecode(), add in that result here:
                    orientation = orientation + metadata.get(ResultMetadataType$1.ORIENTATION) % 360;
                    result.putMetadata(ResultMetadataType$1.ORIENTATION, orientation);
                    // Update result points
                    const points = result.getResultPoints();
                    if (points !== null) {
                        const height = rotatedImage.getHeight();
                        for(let i = 0; i < points.length; i++)points[i] = new ResultPoint(height - points[i].getY() - 1, points[i].getX());
                    }
                    return result;
                } else throw new NotFoundException();
            }
        }
        // @Override
        reset() {
        // do nothing
        }
        /**
         * We're going to examine rows from the middle outward, searching alternately above and below the
         * middle, and farther out each time. rowStep is the number of rows between each successive
         * attempt above and below the middle. So we'd scan row middle, then middle - rowStep, then
         * middle + rowStep, then middle - (2 * rowStep), etc.
         * rowStep is bigger as the image is taller, but is always at least 1. We've somewhat arbitrarily
         * decided that moving up and down by about 1/16 of the image is pretty good; we try more of the
         * image if "trying harder".
         *
         * @param image The image to decode
         * @param hints Any hints that were requested
         * @return The contents of the decoded barcode
         * @throws NotFoundException Any spontaneous errors which occur
         */ doDecode(image, hints) {
            const width = image.getWidth();
            const height = image.getHeight();
            let row = new BitArray(width);
            const tryHarder = hints && hints.get(DecodeHintType$1.TRY_HARDER) === true;
            const rowStep = Math.max(1, height >> (tryHarder ? 8 : 5));
            let maxLines;
            if (tryHarder) maxLines = height; // Look at the whole image, not just the center
            else maxLines = 15; // 15 rows spaced 1/32 apart is roughly the middle half of the image
            const middle = Math.trunc(height / 2);
            for(let x = 0; x < maxLines; x++){
                // Scanning from the middle out. Determine which row we're looking at next:
                const rowStepsAboveOrBelow = Math.trunc((x + 1) / 2);
                const isAbove = (x & 0x01) === 0; // i.e. is x even?
                const rowNumber = middle + rowStep * (isAbove ? rowStepsAboveOrBelow : -rowStepsAboveOrBelow);
                if (rowNumber < 0 || rowNumber >= height) break;
                // Estimate black point for this row and load it:
                try {
                    row = image.getBlackRow(rowNumber, row);
                } catch (ignored) {
                    continue;
                }
                // While we have the image data in a BitArray, it's fairly cheap to reverse it in place to
                // handle decoding upside down barcodes.
                for(let attempt = 0; attempt < 2; attempt++){
                    if (attempt === 1) {
                        row.reverse(); // reverse the row and continue
                        // This means we will only ever draw result points *once* in the life of this method
                        // since we want to avoid drawing the wrong points after flipping the row, and,
                        // don't want to clutter with noise from every single row scan -- just the scans
                        // that start on the center line.
                        if (hints && hints.get(DecodeHintType$1.NEED_RESULT_POINT_CALLBACK) === true) {
                            const newHints = new Map();
                            hints.forEach((hint, key)=>newHints.set(key, hint));
                            newHints.delete(DecodeHintType$1.NEED_RESULT_POINT_CALLBACK);
                            hints = newHints;
                        }
                    }
                    try {
                        // Look for a barcode
                        const result = this.decodeRow(rowNumber, row, hints);
                        // We found our barcode
                        if (attempt === 1) {
                            // But it was upside down, so note that
                            result.putMetadata(ResultMetadataType$1.ORIENTATION, 180);
                            // And remember to flip the result points horizontally.
                            const points = result.getResultPoints();
                            if (points !== null) {
                                points[0] = new ResultPoint(width - points[0].getX() - 1, points[0].getY());
                                points[1] = new ResultPoint(width - points[1].getX() - 1, points[1].getY());
                            }
                        }
                        return result;
                    } catch (re) {
                    // continue -- just couldn't decode this row
                    }
                }
            }
            throw new NotFoundException();
        }
        /**
         * Records the size of successive runs of white and black pixels in a row, starting at a given point.
         * The values are recorded in the given array, and the number of runs recorded is equal to the size
         * of the array. If the row starts on a white pixel at the given start point, then the first count
         * recorded is the run of white pixels starting from that point; likewise it is the count of a run
         * of black pixels if the row begin on a black pixels at that point.
         *
         * @param row row to count from
         * @param start offset into row to start at
         * @param counters array into which to record counts
         * @throws NotFoundException if counters cannot be filled entirely from row before running out
         *  of pixels
         */ static recordPattern(row, start, counters) {
            const numCounters = counters.length;
            for(let index = 0; index < numCounters; index++)counters[index] = 0;
            const end = row.getSize();
            if (start >= end) throw new NotFoundException();
            let isWhite = !row.get(start);
            let counterPosition = 0;
            let i = start;
            while(i < end){
                if (row.get(i) !== isWhite) counters[counterPosition]++;
                else {
                    if (++counterPosition === numCounters) break;
                    else {
                        counters[counterPosition] = 1;
                        isWhite = !isWhite;
                    }
                }
                i++;
            }
            // If we read fully the last section of pixels and filled up our counters -- or filled
            // the last counter but ran off the side of the image, OK. Otherwise, a problem.
            if (!(counterPosition === numCounters || counterPosition === numCounters - 1 && i === end)) throw new NotFoundException();
        }
        static recordPatternInReverse(row, start, counters) {
            // This could be more efficient I guess
            let numTransitionsLeft = counters.length;
            let last = row.get(start);
            while(start > 0 && numTransitionsLeft >= 0)if (row.get(--start) !== last) {
                numTransitionsLeft--;
                last = !last;
            }
            if (numTransitionsLeft >= 0) throw new NotFoundException();
            OneDReader.recordPattern(row, start + 1, counters);
        }
        /**
         * Determines how closely a set of observed counts of runs of black/white values matches a given
         * target pattern. This is reported as the ratio of the total variance from the expected pattern
         * proportions across all pattern elements, to the length of the pattern.
         *
         * @param counters observed counters
         * @param pattern expected pattern
         * @param maxIndividualVariance The most any counter can differ before we give up
         * @return ratio of total variance between counters and pattern compared to total pattern size
         */ static patternMatchVariance(counters, pattern, maxIndividualVariance) {
            const numCounters = counters.length;
            let total = 0;
            let patternLength = 0;
            for(let i = 0; i < numCounters; i++){
                total += counters[i];
                patternLength += pattern[i];
            }
            if (total < patternLength) // If we don't even have one pixel per unit of bar width, assume this is too small
            // to reliably match, so fail:
            return Number.POSITIVE_INFINITY;
            const unitBarWidth = total / patternLength;
            maxIndividualVariance *= unitBarWidth;
            let totalVariance = 0.0;
            for(let x = 0; x < numCounters; x++){
                const counter = counters[x];
                const scaledPattern = pattern[x] * unitBarWidth;
                const variance = counter > scaledPattern ? counter - scaledPattern : scaledPattern - counter;
                if (variance > maxIndividualVariance) return Number.POSITIVE_INFINITY;
                totalVariance += variance;
            }
            return totalVariance / total;
        }
    }
    /**
     * <p>Decodes Code 128 barcodes.</p>
     *
     * @author Sean Owen
     */ class Code128Reader extends OneDReader {
        static findStartPattern(row) {
            const width = row.getSize();
            const rowOffset = row.getNextSet(0);
            let counterPosition = 0;
            let counters = Int32Array.from([
                0,
                0,
                0,
                0,
                0,
                0
            ]);
            let patternStart = rowOffset;
            let isWhite = false;
            const patternLength = 6;
            for(let i = rowOffset; i < width; i++)if (row.get(i) !== isWhite) counters[counterPosition]++;
            else {
                if (counterPosition === patternLength - 1) {
                    let bestVariance = Code128Reader.MAX_AVG_VARIANCE;
                    let bestMatch = -1;
                    for(let startCode = Code128Reader.CODE_START_A; startCode <= Code128Reader.CODE_START_C; startCode++){
                        const variance = OneDReader.patternMatchVariance(counters, Code128Reader.CODE_PATTERNS[startCode], Code128Reader.MAX_INDIVIDUAL_VARIANCE);
                        if (variance < bestVariance) {
                            bestVariance = variance;
                            bestMatch = startCode;
                        }
                    }
                    // Look for whitespace before start pattern, >= 50% of width of start pattern
                    if (bestMatch >= 0 && row.isRange(Math.max(0, patternStart - (i - patternStart) / 2), patternStart, false)) return Int32Array.from([
                        patternStart,
                        i,
                        bestMatch
                    ]);
                    patternStart += counters[0] + counters[1];
                    counters = counters.slice(2, counters.length - 1);
                    counters[counterPosition - 1] = 0;
                    counters[counterPosition] = 0;
                    counterPosition--;
                } else counterPosition++;
                counters[counterPosition] = 1;
                isWhite = !isWhite;
            }
            throw new NotFoundException();
        }
        static decodeCode(row, counters, rowOffset) {
            OneDReader.recordPattern(row, rowOffset, counters);
            let bestVariance = Code128Reader.MAX_AVG_VARIANCE; // worst variance we'll accept
            let bestMatch = -1;
            for(let d = 0; d < Code128Reader.CODE_PATTERNS.length; d++){
                const pattern = Code128Reader.CODE_PATTERNS[d];
                const variance = this.patternMatchVariance(counters, pattern, Code128Reader.MAX_INDIVIDUAL_VARIANCE);
                if (variance < bestVariance) {
                    bestVariance = variance;
                    bestMatch = d;
                }
            }
            // TODO We're overlooking the fact that the STOP pattern has 7 values, not 6.
            if (bestMatch >= 0) return bestMatch;
            else throw new NotFoundException();
        }
        decodeRow(rowNumber, row, hints) {
            const convertFNC1 = hints && hints.get(DecodeHintType$1.ASSUME_GS1) === true;
            const startPatternInfo = Code128Reader.findStartPattern(row);
            const startCode = startPatternInfo[2];
            let currentRawCodesIndex = 0;
            const rawCodes = new Uint8Array(20);
            rawCodes[currentRawCodesIndex++] = startCode;
            let codeSet;
            switch(startCode){
                case Code128Reader.CODE_START_A:
                    codeSet = Code128Reader.CODE_CODE_A;
                    break;
                case Code128Reader.CODE_START_B:
                    codeSet = Code128Reader.CODE_CODE_B;
                    break;
                case Code128Reader.CODE_START_C:
                    codeSet = Code128Reader.CODE_CODE_C;
                    break;
                default:
                    throw new FormatException();
            }
            let done = false;
            let isNextShifted = false;
            let result = '';
            let lastStart = startPatternInfo[0];
            let nextStart = startPatternInfo[1];
            const counters = Int32Array.from([
                0,
                0,
                0,
                0,
                0,
                0
            ]);
            let lastCode = 0;
            let code = 0;
            let checksumTotal = startCode;
            let multiplier = 0;
            let lastCharacterWasPrintable = true;
            let upperMode = false;
            let shiftUpperMode = false;
            while(!done){
                const unshift = isNextShifted;
                isNextShifted = false;
                // Save off last code
                lastCode = code;
                // Decode another code from image
                code = Code128Reader.decodeCode(row, counters, nextStart);
                rawCodes[currentRawCodesIndex++] = code;
                // Remember whether the last code was printable or not (excluding CODE_STOP)
                if (code !== Code128Reader.CODE_STOP) lastCharacterWasPrintable = true;
                // Add to checksum computation (if not CODE_STOP of course)
                if (code !== Code128Reader.CODE_STOP) {
                    multiplier++;
                    checksumTotal += multiplier * code;
                }
                // Advance to where the next code will to start
                lastStart = nextStart;
                nextStart += counters.reduce((previous, current)=>previous + current, 0);
                // Take care of illegal start codes
                switch(code){
                    case Code128Reader.CODE_START_A:
                    case Code128Reader.CODE_START_B:
                    case Code128Reader.CODE_START_C:
                        throw new FormatException();
                }
                switch(codeSet){
                    case Code128Reader.CODE_CODE_A:
                        if (code < 64) {
                            if (shiftUpperMode === upperMode) result += String.fromCharCode(' '.charCodeAt(0) + code);
                            else result += String.fromCharCode(' '.charCodeAt(0) + code + 128);
                            shiftUpperMode = false;
                        } else if (code < 96) {
                            if (shiftUpperMode === upperMode) result += String.fromCharCode(code - 64);
                            else result += String.fromCharCode(code + 64);
                            shiftUpperMode = false;
                        } else {
                            // Don't let CODE_STOP, which always appears, affect whether whether we think the last
                            // code was printable or not.
                            if (code !== Code128Reader.CODE_STOP) lastCharacterWasPrintable = false;
                            switch(code){
                                case Code128Reader.CODE_FNC_1:
                                    if (convertFNC1) {
                                        if (result.length === 0) // GS1 specification 5.4.3.7. and 5.4.6.4. If the first char after the start code
                                        // is FNC1 then this is GS1-128. We add the symbology identifier.
                                        result += ']C1';
                                        else // GS1 specification 5.4.7.5. Every subsequent FNC1 is returned as ASCII 29 (GS)
                                        result += String.fromCharCode(29);
                                    }
                                    break;
                                case Code128Reader.CODE_FNC_2:
                                case Code128Reader.CODE_FNC_3:
                                    break;
                                case Code128Reader.CODE_FNC_4_A:
                                    if (!upperMode && shiftUpperMode) {
                                        upperMode = true;
                                        shiftUpperMode = false;
                                    } else if (upperMode && shiftUpperMode) {
                                        upperMode = false;
                                        shiftUpperMode = false;
                                    } else shiftUpperMode = true;
                                    break;
                                case Code128Reader.CODE_SHIFT:
                                    isNextShifted = true;
                                    codeSet = Code128Reader.CODE_CODE_B;
                                    break;
                                case Code128Reader.CODE_CODE_B:
                                    codeSet = Code128Reader.CODE_CODE_B;
                                    break;
                                case Code128Reader.CODE_CODE_C:
                                    codeSet = Code128Reader.CODE_CODE_C;
                                    break;
                                case Code128Reader.CODE_STOP:
                                    done = true;
                                    break;
                            }
                        }
                        break;
                    case Code128Reader.CODE_CODE_B:
                        if (code < 96) {
                            if (shiftUpperMode === upperMode) result += String.fromCharCode(' '.charCodeAt(0) + code);
                            else result += String.fromCharCode(' '.charCodeAt(0) + code + 128);
                            shiftUpperMode = false;
                        } else {
                            if (code !== Code128Reader.CODE_STOP) lastCharacterWasPrintable = false;
                            switch(code){
                                case Code128Reader.CODE_FNC_1:
                                    if (convertFNC1) {
                                        if (result.length === 0) // GS1 specification 5.4.3.7. and 5.4.6.4. If the first char after the start code
                                        // is FNC1 then this is GS1-128. We add the symbology identifier.
                                        result += ']C1';
                                        else // GS1 specification 5.4.7.5. Every subsequent FNC1 is returned as ASCII 29 (GS)
                                        result += String.fromCharCode(29);
                                    }
                                    break;
                                case Code128Reader.CODE_FNC_2:
                                case Code128Reader.CODE_FNC_3:
                                    break;
                                case Code128Reader.CODE_FNC_4_B:
                                    if (!upperMode && shiftUpperMode) {
                                        upperMode = true;
                                        shiftUpperMode = false;
                                    } else if (upperMode && shiftUpperMode) {
                                        upperMode = false;
                                        shiftUpperMode = false;
                                    } else shiftUpperMode = true;
                                    break;
                                case Code128Reader.CODE_SHIFT:
                                    isNextShifted = true;
                                    codeSet = Code128Reader.CODE_CODE_A;
                                    break;
                                case Code128Reader.CODE_CODE_A:
                                    codeSet = Code128Reader.CODE_CODE_A;
                                    break;
                                case Code128Reader.CODE_CODE_C:
                                    codeSet = Code128Reader.CODE_CODE_C;
                                    break;
                                case Code128Reader.CODE_STOP:
                                    done = true;
                                    break;
                            }
                        }
                        break;
                    case Code128Reader.CODE_CODE_C:
                        if (code < 100) {
                            if (code < 10) result += '0';
                            result += code;
                        } else {
                            if (code !== Code128Reader.CODE_STOP) lastCharacterWasPrintable = false;
                            switch(code){
                                case Code128Reader.CODE_FNC_1:
                                    if (convertFNC1) {
                                        if (result.length === 0) // GS1 specification 5.4.3.7. and 5.4.6.4. If the first char after the start code
                                        // is FNC1 then this is GS1-128. We add the symbology identifier.
                                        result += ']C1';
                                        else // GS1 specification 5.4.7.5. Every subsequent FNC1 is returned as ASCII 29 (GS)
                                        result += String.fromCharCode(29);
                                    }
                                    break;
                                case Code128Reader.CODE_CODE_A:
                                    codeSet = Code128Reader.CODE_CODE_A;
                                    break;
                                case Code128Reader.CODE_CODE_B:
                                    codeSet = Code128Reader.CODE_CODE_B;
                                    break;
                                case Code128Reader.CODE_STOP:
                                    done = true;
                                    break;
                            }
                        }
                        break;
                }
                // Unshift back to another code set if we were shifted
                if (unshift) codeSet = codeSet === Code128Reader.CODE_CODE_A ? Code128Reader.CODE_CODE_B : Code128Reader.CODE_CODE_A;
            }
            const lastPatternSize = nextStart - lastStart;
            // Check for ample whitespace following pattern, but, to do this we first need to remember that
            // we fudged decoding CODE_STOP since it actually has 7 bars, not 6. There is a black bar left
            // to read off. Would be slightly better to properly read. Here we just skip it:
            nextStart = row.getNextUnset(nextStart);
            if (!row.isRange(nextStart, Math.min(row.getSize(), nextStart + (nextStart - lastStart) / 2), false)) throw new NotFoundException();
            // Pull out from sum the value of the penultimate check code
            checksumTotal -= multiplier * lastCode;
            // lastCode is the checksum then:
            if (checksumTotal % 103 !== lastCode) throw new ChecksumException();
            // Need to pull out the check digits from string
            const resultLength = result.length;
            if (resultLength === 0) // false positive
            throw new NotFoundException();
            // Only bother if the result had at least one character, and if the checksum digit happened to
            // be a printable character. If it was just interpreted as a control code, nothing to remove.
            if (resultLength > 0 && lastCharacterWasPrintable) {
                if (codeSet === Code128Reader.CODE_CODE_C) result = result.substring(0, resultLength - 2);
                else result = result.substring(0, resultLength - 1);
            }
            const left = (startPatternInfo[1] + startPatternInfo[0]) / 2.0;
            const right = lastStart + lastPatternSize / 2.0;
            const rawCodesSize = rawCodes.length;
            const rawBytes = new Uint8Array(rawCodesSize);
            for(let i = 0; i < rawCodesSize; i++)rawBytes[i] = rawCodes[i];
            const points = [
                new ResultPoint(left, rowNumber),
                new ResultPoint(right, rowNumber)
            ];
            return new Result(result, rawBytes, 0, points, BarcodeFormat$1.CODE_128, new Date().getTime());
        }
    }
    Code128Reader.CODE_PATTERNS = [
        Int32Array.from([
            2,
            1,
            2,
            2,
            2,
            2
        ]),
        Int32Array.from([
            2,
            2,
            2,
            1,
            2,
            2
        ]),
        Int32Array.from([
            2,
            2,
            2,
            2,
            2,
            1
        ]),
        Int32Array.from([
            1,
            2,
            1,
            2,
            2,
            3
        ]),
        Int32Array.from([
            1,
            2,
            1,
            3,
            2,
            2
        ]),
        Int32Array.from([
            1,
            3,
            1,
            2,
            2,
            2
        ]),
        Int32Array.from([
            1,
            2,
            2,
            2,
            1,
            3
        ]),
        Int32Array.from([
            1,
            2,
            2,
            3,
            1,
            2
        ]),
        Int32Array.from([
            1,
            3,
            2,
            2,
            1,
            2
        ]),
        Int32Array.from([
            2,
            2,
            1,
            2,
            1,
            3
        ]),
        Int32Array.from([
            2,
            2,
            1,
            3,
            1,
            2
        ]),
        Int32Array.from([
            2,
            3,
            1,
            2,
            1,
            2
        ]),
        Int32Array.from([
            1,
            1,
            2,
            2,
            3,
            2
        ]),
        Int32Array.from([
            1,
            2,
            2,
            1,
            3,
            2
        ]),
        Int32Array.from([
            1,
            2,
            2,
            2,
            3,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            2,
            2,
            2
        ]),
        Int32Array.from([
            1,
            2,
            3,
            1,
            2,
            2
        ]),
        Int32Array.from([
            1,
            2,
            3,
            2,
            2,
            1
        ]),
        Int32Array.from([
            2,
            2,
            3,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            2,
            1,
            1,
            3,
            2
        ]),
        Int32Array.from([
            2,
            2,
            1,
            2,
            3,
            1
        ]),
        Int32Array.from([
            2,
            1,
            3,
            2,
            1,
            2
        ]),
        Int32Array.from([
            2,
            2,
            3,
            1,
            1,
            2
        ]),
        Int32Array.from([
            3,
            1,
            2,
            1,
            3,
            1
        ]),
        Int32Array.from([
            3,
            1,
            1,
            2,
            2,
            2
        ]),
        Int32Array.from([
            3,
            2,
            1,
            1,
            2,
            2
        ]),
        Int32Array.from([
            3,
            2,
            1,
            2,
            2,
            1
        ]),
        Int32Array.from([
            3,
            1,
            2,
            2,
            1,
            2
        ]),
        Int32Array.from([
            3,
            2,
            2,
            1,
            1,
            2
        ]),
        Int32Array.from([
            3,
            2,
            2,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            1,
            2,
            1,
            2,
            3
        ]),
        Int32Array.from([
            2,
            1,
            2,
            3,
            2,
            1
        ]),
        Int32Array.from([
            2,
            3,
            2,
            1,
            2,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            3,
            2,
            3
        ]),
        Int32Array.from([
            1,
            3,
            1,
            1,
            2,
            3
        ]),
        Int32Array.from([
            1,
            3,
            1,
            3,
            2,
            1
        ]),
        Int32Array.from([
            1,
            1,
            2,
            3,
            1,
            3
        ]),
        Int32Array.from([
            1,
            3,
            2,
            1,
            1,
            3
        ]),
        Int32Array.from([
            1,
            3,
            2,
            3,
            1,
            1
        ]),
        Int32Array.from([
            2,
            1,
            1,
            3,
            1,
            3
        ]),
        Int32Array.from([
            2,
            3,
            1,
            1,
            1,
            3
        ]),
        Int32Array.from([
            2,
            3,
            1,
            3,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            2,
            1,
            3,
            3
        ]),
        Int32Array.from([
            1,
            1,
            2,
            3,
            3,
            1
        ]),
        Int32Array.from([
            1,
            3,
            2,
            1,
            3,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            1,
            2,
            3
        ]),
        Int32Array.from([
            1,
            1,
            3,
            3,
            2,
            1
        ]),
        Int32Array.from([
            1,
            3,
            3,
            1,
            2,
            1
        ]),
        Int32Array.from([
            3,
            1,
            3,
            1,
            2,
            1
        ]),
        Int32Array.from([
            2,
            1,
            1,
            3,
            3,
            1
        ]),
        Int32Array.from([
            2,
            3,
            1,
            1,
            3,
            1
        ]),
        Int32Array.from([
            2,
            1,
            3,
            1,
            1,
            3
        ]),
        Int32Array.from([
            2,
            1,
            3,
            3,
            1,
            1
        ]),
        Int32Array.from([
            2,
            1,
            3,
            1,
            3,
            1
        ]),
        Int32Array.from([
            3,
            1,
            1,
            1,
            2,
            3
        ]),
        Int32Array.from([
            3,
            1,
            1,
            3,
            2,
            1
        ]),
        Int32Array.from([
            3,
            3,
            1,
            1,
            2,
            1
        ]),
        Int32Array.from([
            3,
            1,
            2,
            1,
            1,
            3
        ]),
        Int32Array.from([
            3,
            1,
            2,
            3,
            1,
            1
        ]),
        Int32Array.from([
            3,
            3,
            2,
            1,
            1,
            1
        ]),
        Int32Array.from([
            3,
            1,
            4,
            1,
            1,
            1
        ]),
        Int32Array.from([
            2,
            2,
            1,
            4,
            1,
            1
        ]),
        Int32Array.from([
            4,
            3,
            1,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            2,
            2,
            4
        ]),
        Int32Array.from([
            1,
            1,
            1,
            4,
            2,
            2
        ]),
        Int32Array.from([
            1,
            2,
            1,
            1,
            2,
            4
        ]),
        Int32Array.from([
            1,
            2,
            1,
            4,
            2,
            1
        ]),
        Int32Array.from([
            1,
            4,
            1,
            1,
            2,
            2
        ]),
        Int32Array.from([
            1,
            4,
            1,
            2,
            2,
            1
        ]),
        Int32Array.from([
            1,
            1,
            2,
            2,
            1,
            4
        ]),
        Int32Array.from([
            1,
            1,
            2,
            4,
            1,
            2
        ]),
        Int32Array.from([
            1,
            2,
            2,
            1,
            1,
            4
        ]),
        Int32Array.from([
            1,
            2,
            2,
            4,
            1,
            1
        ]),
        Int32Array.from([
            1,
            4,
            2,
            1,
            1,
            2
        ]),
        Int32Array.from([
            1,
            4,
            2,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            4,
            1,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            2,
            1,
            1,
            1,
            4
        ]),
        Int32Array.from([
            4,
            1,
            3,
            1,
            1,
            1
        ]),
        Int32Array.from([
            2,
            4,
            1,
            1,
            1,
            2
        ]),
        Int32Array.from([
            1,
            3,
            4,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            2,
            4,
            2
        ]),
        Int32Array.from([
            1,
            2,
            1,
            1,
            4,
            2
        ]),
        Int32Array.from([
            1,
            2,
            1,
            2,
            4,
            1
        ]),
        Int32Array.from([
            1,
            1,
            4,
            2,
            1,
            2
        ]),
        Int32Array.from([
            1,
            2,
            4,
            1,
            1,
            2
        ]),
        Int32Array.from([
            1,
            2,
            4,
            2,
            1,
            1
        ]),
        Int32Array.from([
            4,
            1,
            1,
            2,
            1,
            2
        ]),
        Int32Array.from([
            4,
            2,
            1,
            1,
            1,
            2
        ]),
        Int32Array.from([
            4,
            2,
            1,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            1,
            2,
            1,
            4,
            1
        ]),
        Int32Array.from([
            2,
            1,
            4,
            1,
            2,
            1
        ]),
        Int32Array.from([
            4,
            1,
            2,
            1,
            2,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            1,
            4,
            3
        ]),
        Int32Array.from([
            1,
            1,
            1,
            3,
            4,
            1
        ]),
        Int32Array.from([
            1,
            3,
            1,
            1,
            4,
            1
        ]),
        Int32Array.from([
            1,
            1,
            4,
            1,
            1,
            3
        ]),
        Int32Array.from([
            1,
            1,
            4,
            3,
            1,
            1
        ]),
        Int32Array.from([
            4,
            1,
            1,
            1,
            1,
            3
        ]),
        Int32Array.from([
            4,
            1,
            1,
            3,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            1,
            4,
            1
        ]),
        Int32Array.from([
            1,
            1,
            4,
            1,
            3,
            1
        ]),
        Int32Array.from([
            3,
            1,
            1,
            1,
            4,
            1
        ]),
        Int32Array.from([
            4,
            1,
            1,
            1,
            3,
            1
        ]),
        Int32Array.from([
            2,
            1,
            1,
            4,
            1,
            2
        ]),
        Int32Array.from([
            2,
            1,
            1,
            2,
            1,
            4
        ]),
        Int32Array.from([
            2,
            1,
            1,
            2,
            3,
            2
        ]),
        Int32Array.from([
            2,
            3,
            3,
            1,
            1,
            1,
            2
        ])
    ];
    Code128Reader.MAX_AVG_VARIANCE = 0.25;
    Code128Reader.MAX_INDIVIDUAL_VARIANCE = 0.7;
    Code128Reader.CODE_SHIFT = 98;
    Code128Reader.CODE_CODE_C = 99;
    Code128Reader.CODE_CODE_B = 100;
    Code128Reader.CODE_CODE_A = 101;
    Code128Reader.CODE_FNC_1 = 102;
    Code128Reader.CODE_FNC_2 = 97;
    Code128Reader.CODE_FNC_3 = 96;
    Code128Reader.CODE_FNC_4_A = 101;
    Code128Reader.CODE_FNC_4_B = 100;
    Code128Reader.CODE_START_A = 103;
    Code128Reader.CODE_START_B = 104;
    Code128Reader.CODE_START_C = 105;
    Code128Reader.CODE_STOP = 106;
    /**
     * <p>Decodes Code 39 barcodes. Supports "Full ASCII Code 39" if USE_CODE_39_EXTENDED_MODE is set.</p>
     *
     * @author Sean Owen
     * @see Code93Reader
     */ class Code39Reader extends OneDReader {
        /**
         * Creates a reader that assumes all encoded data is data, and does not treat the final
         * character as a check digit. It will not decoded "extended Code 39" sequences.
         */ // public Code39Reader() {
        //   this(false);
        // }
        /**
         * Creates a reader that can be configured to check the last character as a check digit.
         * It will not decoded "extended Code 39" sequences.
         *
         * @param usingCheckDigit if true, treat the last data character as a check digit, not
         * data, and verify that the checksum passes.
         */ // public Code39Reader(boolean usingCheckDigit) {
        //   this(usingCheckDigit, false);
        // }
        /**
         * Creates a reader that can be configured to check the last character as a check digit,
         * or optionally attempt to decode "extended Code 39" sequences that are used to encode
         * the full ASCII character set.
         *
         * @param usingCheckDigit if true, treat the last data character as a check digit, not
         * data, and verify that the checksum passes.
         * @param extendedMode if true, will attempt to decode extended Code 39 sequences in the
         * text.
         */ constructor(usingCheckDigit = false, extendedMode = false){
            super();
            this.usingCheckDigit = usingCheckDigit;
            this.extendedMode = extendedMode;
            this.decodeRowResult = '';
            this.counters = new Int32Array(9);
        }
        decodeRow(rowNumber, row, hints) {
            let theCounters = this.counters;
            theCounters.fill(0);
            this.decodeRowResult = '';
            let start = Code39Reader.findAsteriskPattern(row, theCounters);
            // Read off white space
            let nextStart = row.getNextSet(start[1]);
            let end = row.getSize();
            let decodedChar;
            let lastStart;
            do {
                Code39Reader.recordPattern(row, nextStart, theCounters);
                let pattern = Code39Reader.toNarrowWidePattern(theCounters);
                if (pattern < 0) throw new NotFoundException();
                decodedChar = Code39Reader.patternToChar(pattern);
                this.decodeRowResult += decodedChar;
                lastStart = nextStart;
                for (let counter of theCounters)nextStart += counter;
                // Read off white space
                nextStart = row.getNextSet(nextStart);
            }while (decodedChar !== '*');
            this.decodeRowResult = this.decodeRowResult.substring(0, this.decodeRowResult.length - 1); // remove asterisk
            // Look for whitespace after pattern:
            let lastPatternSize = 0;
            for (let counter of theCounters)lastPatternSize += counter;
            let whiteSpaceAfterEnd = nextStart - lastStart - lastPatternSize;
            // If 50% of last pattern size, following last pattern, is not whitespace, fail
            // (but if it's whitespace to the very end of the image, that's OK)
            if (nextStart !== end && whiteSpaceAfterEnd * 2 < lastPatternSize) throw new NotFoundException();
            if (this.usingCheckDigit) {
                let max = this.decodeRowResult.length - 1;
                let total = 0;
                for(let i = 0; i < max; i++)total += Code39Reader.ALPHABET_STRING.indexOf(this.decodeRowResult.charAt(i));
                if (this.decodeRowResult.charAt(max) !== Code39Reader.ALPHABET_STRING.charAt(total % 43)) throw new ChecksumException();
                this.decodeRowResult = this.decodeRowResult.substring(0, max);
            }
            if (this.decodeRowResult.length === 0) // false positive
            throw new NotFoundException();
            let resultString;
            if (this.extendedMode) resultString = Code39Reader.decodeExtended(this.decodeRowResult);
            else resultString = this.decodeRowResult;
            let left = (start[1] + start[0]) / 2.0;
            let right = lastStart + lastPatternSize / 2.0;
            return new Result(resultString, null, 0, [
                new ResultPoint(left, rowNumber),
                new ResultPoint(right, rowNumber)
            ], BarcodeFormat$1.CODE_39, new Date().getTime());
        }
        static findAsteriskPattern(row, counters) {
            let width = row.getSize();
            let rowOffset = row.getNextSet(0);
            let counterPosition = 0;
            let patternStart = rowOffset;
            let isWhite = false;
            let patternLength = counters.length;
            for(let i = rowOffset; i < width; i++)if (row.get(i) !== isWhite) counters[counterPosition]++;
            else {
                if (counterPosition === patternLength - 1) {
                    // Look for whitespace before start pattern, >= 50% of width of start pattern
                    if (this.toNarrowWidePattern(counters) === Code39Reader.ASTERISK_ENCODING && row.isRange(Math.max(0, patternStart - Math.floor((i - patternStart) / 2)), patternStart, false)) return [
                        patternStart,
                        i
                    ];
                    patternStart += counters[0] + counters[1];
                    counters.copyWithin(0, 2, 2 + counterPosition - 1);
                    counters[counterPosition - 1] = 0;
                    counters[counterPosition] = 0;
                    counterPosition--;
                } else counterPosition++;
                counters[counterPosition] = 1;
                isWhite = !isWhite;
            }
            throw new NotFoundException();
        }
        // For efficiency, returns -1 on failure. Not throwing here saved as many as 700 exceptions
        // per image when using some of our blackbox images.
        static toNarrowWidePattern(counters) {
            let numCounters = counters.length;
            let maxNarrowCounter = 0;
            let wideCounters;
            do {
                let minCounter = 0x7fffffff;
                for (let counter of counters)if (counter < minCounter && counter > maxNarrowCounter) minCounter = counter;
                maxNarrowCounter = minCounter;
                wideCounters = 0;
                let totalWideCountersWidth = 0;
                let pattern = 0;
                for(let i = 0; i < numCounters; i++){
                    let counter = counters[i];
                    if (counter > maxNarrowCounter) {
                        pattern |= 1 << numCounters - 1 - i;
                        wideCounters++;
                        totalWideCountersWidth += counter;
                    }
                }
                if (wideCounters === 3) {
                    // Found 3 wide counters, but are they close enough in width?
                    // We can perform a cheap, conservative check to see if any individual
                    // counter is more than 1.5 times the average:
                    for(let i = 0; i < numCounters && wideCounters > 0; i++){
                        let counter = counters[i];
                        if (counter > maxNarrowCounter) {
                            wideCounters--;
                            // totalWideCountersWidth = 3 * average, so this checks if counter >= 3/2 * average
                            if (counter * 2 >= totalWideCountersWidth) return -1;
                        }
                    }
                    return pattern;
                }
            }while (wideCounters > 3);
            return -1;
        }
        static patternToChar(pattern) {
            for(let i = 0; i < Code39Reader.CHARACTER_ENCODINGS.length; i++){
                if (Code39Reader.CHARACTER_ENCODINGS[i] === pattern) return Code39Reader.ALPHABET_STRING.charAt(i);
            }
            if (pattern === Code39Reader.ASTERISK_ENCODING) return '*';
            throw new NotFoundException();
        }
        static decodeExtended(encoded) {
            let length = encoded.length;
            let decoded = '';
            for(let i = 0; i < length; i++){
                let c = encoded.charAt(i);
                if (c === '+' || c === '$' || c === '%' || c === '/') {
                    let next = encoded.charAt(i + 1);
                    let decodedChar = '\0';
                    switch(c){
                        case '+':
                            // +A to +Z map to a to z
                            if (next >= 'A' && next <= 'Z') decodedChar = String.fromCharCode(next.charCodeAt(0) + 32);
                            else throw new FormatException();
                            break;
                        case '$':
                            // $A to $Z map to control codes SH to SB
                            if (next >= 'A' && next <= 'Z') decodedChar = String.fromCharCode(next.charCodeAt(0) - 64);
                            else throw new FormatException();
                            break;
                        case '%':
                            // %A to %E map to control codes ESC to US
                            if (next >= 'A' && next <= 'E') decodedChar = String.fromCharCode(next.charCodeAt(0) - 38);
                            else if (next >= 'F' && next <= 'J') decodedChar = String.fromCharCode(next.charCodeAt(0) - 11);
                            else if (next >= 'K' && next <= 'O') decodedChar = String.fromCharCode(next.charCodeAt(0) + 16);
                            else if (next >= 'P' && next <= 'T') decodedChar = String.fromCharCode(next.charCodeAt(0) + 43);
                            else if (next === 'U') decodedChar = '\0';
                            else if (next === 'V') decodedChar = '@';
                            else if (next === 'W') decodedChar = '`';
                            else if (next === 'X' || next === 'Y' || next === 'Z') decodedChar = '\x7f';
                            else throw new FormatException();
                            break;
                        case '/':
                            // /A to /O map to ! to , and /Z maps to :
                            if (next >= 'A' && next <= 'O') decodedChar = String.fromCharCode(next.charCodeAt(0) - 32);
                            else if (next === 'Z') decodedChar = ':';
                            else throw new FormatException();
                            break;
                    }
                    decoded += decodedChar;
                    // bump up i again since we read two characters
                    i++;
                } else decoded += c;
            }
            return decoded;
        }
    }
    Code39Reader.ALPHABET_STRING = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%';
    /**
     * These represent the encodings of characters, as patterns of wide and narrow bars.
     * The 9 least-significant bits of each int correspond to the pattern of wide and narrow,
     * with 1s representing "wide" and 0s representing narrow.
     */ Code39Reader.CHARACTER_ENCODINGS = [
        0x034,
        0x121,
        0x061,
        0x160,
        0x031,
        0x130,
        0x070,
        0x025,
        0x124,
        0x064,
        0x109,
        0x049,
        0x148,
        0x019,
        0x118,
        0x058,
        0x00D,
        0x10C,
        0x04C,
        0x01C,
        0x103,
        0x043,
        0x142,
        0x013,
        0x112,
        0x052,
        0x007,
        0x106,
        0x046,
        0x016,
        0x181,
        0x0C1,
        0x1C0,
        0x091,
        0x190,
        0x0D0,
        0x085,
        0x184,
        0x0C4,
        0x0A8,
        0x0A2,
        0x08A,
        0x02A // /-%
    ];
    Code39Reader.ASTERISK_ENCODING = 0x094;
    /**
     * <p>Decodes ITF barcodes.</p>
     *
     * @author Tjieco
     */ class ITFReader extends OneDReader {
        constructor(){
            // private static W = 3; // Pixel width of a 3x wide line
            // private static w = 2; // Pixel width of a 2x wide line
            // private static N = 1; // Pixed width of a narrow line
            super(...arguments);
            // Stores the actual narrow line width of the image being decoded.
            this.narrowLineWidth = -1;
        }
        // See ITFWriter.PATTERNS
        /*
      
        /!**
         * Patterns of Wide / Narrow lines to indicate each digit
         *!/
        */ decodeRow(rowNumber, row, hints) {
            // Find out where the Middle section (payload) starts & ends
            let startRange = this.decodeStart(row);
            let endRange = this.decodeEnd(row);
            let result = new StringBuilder();
            ITFReader.decodeMiddle(row, startRange[1], endRange[0], result);
            let resultString = result.toString();
            let allowedLengths = null;
            if (hints != null) allowedLengths = hints.get(DecodeHintType$1.ALLOWED_LENGTHS);
            if (allowedLengths == null) allowedLengths = ITFReader.DEFAULT_ALLOWED_LENGTHS;
            // To avoid false positives with 2D barcodes (and other patterns), make
            // an assumption that the decoded string must be a 'standard' length if it's short
            let length = resultString.length;
            let lengthOK = false;
            let maxAllowedLength = 0;
            for (let value of allowedLengths){
                if (length === value) {
                    lengthOK = true;
                    break;
                }
                if (value > maxAllowedLength) maxAllowedLength = value;
            }
            if (!lengthOK && length > maxAllowedLength) lengthOK = true;
            if (!lengthOK) throw new FormatException();
            const points = [
                new ResultPoint(startRange[1], rowNumber),
                new ResultPoint(endRange[0], rowNumber)
            ];
            let resultReturn = new Result(resultString, null, 0, points, BarcodeFormat$1.ITF, new Date().getTime());
            return resultReturn;
        }
        /*
        /!**
         * @param row          row of black/white values to search
         * @param payloadStart offset of start pattern
         * @param resultString {@link StringBuilder} to append decoded chars to
         * @throws NotFoundException if decoding could not complete successfully
         *!/*/ static decodeMiddle(row, payloadStart, payloadEnd, resultString) {
            // Digits are interleaved in pairs - 5 black lines for one digit, and the
            // 5
            // interleaved white lines for the second digit.
            // Therefore, need to scan 10 lines and then
            // split these into two arrays
            let counterDigitPair = new Int32Array(10); // 10
            let counterBlack = new Int32Array(5); // 5
            let counterWhite = new Int32Array(5); // 5
            counterDigitPair.fill(0);
            counterBlack.fill(0);
            counterWhite.fill(0);
            while(payloadStart < payloadEnd){
                // Get 10 runs of black/white.
                OneDReader.recordPattern(row, payloadStart, counterDigitPair);
                // Split them into each array
                for(let k = 0; k < 5; k++){
                    let twoK = 2 * k;
                    counterBlack[k] = counterDigitPair[twoK];
                    counterWhite[k] = counterDigitPair[twoK + 1];
                }
                let bestMatch = ITFReader.decodeDigit(counterBlack);
                resultString.append(bestMatch.toString());
                bestMatch = this.decodeDigit(counterWhite);
                resultString.append(bestMatch.toString());
                counterDigitPair.forEach(function(counterDigit) {
                    payloadStart += counterDigit;
                });
            }
        }
        /*/!**
         * Identify where the start of the middle / payload section starts.
         *
         * @param row row of black/white values to search
         * @return Array, containing index of start of 'start block' and end of
         *         'start block'
         *!/*/ decodeStart(row) {
            let endStart = ITFReader.skipWhiteSpace(row);
            let startPattern = ITFReader.findGuardPattern(row, endStart, ITFReader.START_PATTERN);
            // Determine the width of a narrow line in pixels. We can do this by
            // getting the width of the start pattern and dividing by 4 because its
            // made up of 4 narrow lines.
            this.narrowLineWidth = (startPattern[1] - startPattern[0]) / 4;
            this.validateQuietZone(row, startPattern[0]);
            return startPattern;
        }
        /*/!**
         * The start & end patterns must be pre/post fixed by a quiet zone. This
         * zone must be at least 10 times the width of a narrow line.  Scan back until
         * we either get to the start of the barcode or match the necessary number of
         * quiet zone pixels.
         *
         * Note: Its assumed the row is reversed when using this method to find
         * quiet zone after the end pattern.
         *
         * ref: http://www.barcode-1.net/i25code.html
         *
         * @param row bit array representing the scanned barcode.
         * @param startPattern index into row of the start or end pattern.
         * @throws NotFoundException if the quiet zone cannot be found
         *!/*/ validateQuietZone(row, startPattern) {
            let quietCount = this.narrowLineWidth * 10; // expect to find this many pixels of quiet zone
            // if there are not so many pixel at all let's try as many as possible
            quietCount = quietCount < startPattern ? quietCount : startPattern;
            for(let i = startPattern - 1; quietCount > 0 && i >= 0; i--){
                if (row.get(i)) break;
                quietCount--;
            }
            if (quietCount !== 0) // Unable to find the necessary number of quiet zone pixels.
            throw new NotFoundException();
        }
        /*
        /!**
         * Skip all whitespace until we get to the first black line.
         *
         * @param row row of black/white values to search
         * @return index of the first black line.
         * @throws NotFoundException Throws exception if no black lines are found in the row
         *!/*/ static skipWhiteSpace(row) {
            const width = row.getSize();
            const endStart = row.getNextSet(0);
            if (endStart === width) throw new NotFoundException();
            return endStart;
        }
        /*/!**
         * Identify where the end of the middle / payload section ends.
         *
         * @param row row of black/white values to search
         * @return Array, containing index of start of 'end block' and end of 'end
         *         block'
         *!/*/ decodeEnd(row) {
            // For convenience, reverse the row and then
            // search from 'the start' for the end block
            row.reverse();
            try {
                let endStart = ITFReader.skipWhiteSpace(row);
                let endPattern;
                try {
                    endPattern = ITFReader.findGuardPattern(row, endStart, ITFReader.END_PATTERN_REVERSED[0]);
                } catch (error) {
                    if (error instanceof NotFoundException) endPattern = ITFReader.findGuardPattern(row, endStart, ITFReader.END_PATTERN_REVERSED[1]);
                }
                // The start & end patterns must be pre/post fixed by a quiet zone. This
                // zone must be at least 10 times the width of a narrow line.
                // ref: http://www.barcode-1.net/i25code.html
                this.validateQuietZone(row, endPattern[0]);
                // Now recalculate the indices of where the 'endblock' starts & stops to
                // accommodate
                // the reversed nature of the search
                let temp = endPattern[0];
                endPattern[0] = row.getSize() - endPattern[1];
                endPattern[1] = row.getSize() - temp;
                return endPattern;
            } finally{
                // Put the row back the right way.
                row.reverse();
            }
        }
        /*
        /!**
         * @param row       row of black/white values to search
         * @param rowOffset position to start search
         * @param pattern   pattern of counts of number of black and white pixels that are
         *                  being searched for as a pattern
         * @return start/end horizontal offset of guard pattern, as an array of two
         *         ints
         * @throws NotFoundException if pattern is not found
         *!/*/ static findGuardPattern(row, rowOffset, pattern) {
            let patternLength = pattern.length;
            let counters = new Int32Array(patternLength);
            let width = row.getSize();
            let isWhite = false;
            let counterPosition = 0;
            let patternStart = rowOffset;
            counters.fill(0);
            for(let x = rowOffset; x < width; x++)if (row.get(x) !== isWhite) counters[counterPosition]++;
            else {
                if (counterPosition === patternLength - 1) {
                    if (OneDReader.patternMatchVariance(counters, pattern, ITFReader.MAX_INDIVIDUAL_VARIANCE) < ITFReader.MAX_AVG_VARIANCE) return [
                        patternStart,
                        x
                    ];
                    patternStart += counters[0] + counters[1];
                    System.arraycopy(counters, 2, counters, 0, counterPosition - 1);
                    counters[counterPosition - 1] = 0;
                    counters[counterPosition] = 0;
                    counterPosition--;
                } else counterPosition++;
                counters[counterPosition] = 1;
                isWhite = !isWhite;
            }
            throw new NotFoundException();
        }
        /*/!**
         * Attempts to decode a sequence of ITF black/white lines into single
         * digit.
         *
         * @param counters the counts of runs of observed black/white/black/... values
         * @return The decoded digit
         * @throws NotFoundException if digit cannot be decoded
         *!/*/ static decodeDigit(counters) {
            let bestVariance = ITFReader.MAX_AVG_VARIANCE; // worst variance we'll accept
            let bestMatch = -1;
            let max = ITFReader.PATTERNS.length;
            for(let i = 0; i < max; i++){
                let pattern = ITFReader.PATTERNS[i];
                let variance = OneDReader.patternMatchVariance(counters, pattern, ITFReader.MAX_INDIVIDUAL_VARIANCE);
                if (variance < bestVariance) {
                    bestVariance = variance;
                    bestMatch = i;
                } else if (variance === bestVariance) // if we find a second 'best match' with the same variance, we can not reliably report to have a suitable match
                bestMatch = -1;
            }
            if (bestMatch >= 0) return bestMatch % 10;
            else throw new NotFoundException();
        }
    }
    ITFReader.PATTERNS = [
        Int32Array.from([
            1,
            1,
            2,
            2,
            1
        ]),
        Int32Array.from([
            2,
            1,
            1,
            1,
            2
        ]),
        Int32Array.from([
            1,
            2,
            1,
            1,
            2
        ]),
        Int32Array.from([
            2,
            2,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            2,
            1,
            2
        ]),
        Int32Array.from([
            2,
            1,
            2,
            1,
            1
        ]),
        Int32Array.from([
            1,
            2,
            2,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            2,
            2
        ]),
        Int32Array.from([
            2,
            1,
            1,
            2,
            1
        ]),
        Int32Array.from([
            1,
            2,
            1,
            2,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            3,
            1
        ]),
        Int32Array.from([
            3,
            1,
            1,
            1,
            3
        ]),
        Int32Array.from([
            1,
            3,
            1,
            1,
            3
        ]),
        Int32Array.from([
            3,
            3,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            1,
            3
        ]),
        Int32Array.from([
            3,
            1,
            3,
            1,
            1
        ]),
        Int32Array.from([
            1,
            3,
            3,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            3,
            3
        ]),
        Int32Array.from([
            3,
            1,
            1,
            3,
            1
        ]),
        Int32Array.from([
            1,
            3,
            1,
            3,
            1
        ]) // 9
    ];
    ITFReader.MAX_AVG_VARIANCE = 0.38;
    ITFReader.MAX_INDIVIDUAL_VARIANCE = 0.5;
    /* /!** Valid ITF lengths. Anything longer than the largest value is also allowed. *!/*/ ITFReader.DEFAULT_ALLOWED_LENGTHS = [
        6,
        8,
        10,
        12,
        14
    ];
    /*/!**
     * Start/end guard pattern.
     *
     * Note: The end pattern is reversed because the row is reversed before
     * searching for the END_PATTERN
     *!/*/ ITFReader.START_PATTERN = Int32Array.from([
        1,
        1,
        1,
        1
    ]);
    ITFReader.END_PATTERN_REVERSED = [
        Int32Array.from([
            1,
            1,
            2
        ]),
        Int32Array.from([
            1,
            1,
            3
        ]) // 3x
    ];
    /**
     * <p>Encapsulates functionality and implementation that is common to UPC and EAN families
     * of one-dimensional barcodes.</p>
     *
     * @author dswitkin@google.com (Daniel Switkin)
     * @author Sean Owen
     * @author alasdair@google.com (Alasdair Mackintosh)
     */ class AbstractUPCEANReader extends OneDReader {
        constructor(){
            super(...arguments);
            this.decodeRowStringBuffer = '';
        }
        static findStartGuardPattern(row) {
            let foundStart = false;
            let startRange;
            let nextStart = 0;
            let counters = Int32Array.from([
                0,
                0,
                0
            ]);
            while(!foundStart){
                counters = Int32Array.from([
                    0,
                    0,
                    0
                ]);
                startRange = AbstractUPCEANReader.findGuardPattern(row, nextStart, false, this.START_END_PATTERN, counters);
                let start = startRange[0];
                nextStart = startRange[1];
                let quietStart = start - (nextStart - start);
                if (quietStart >= 0) foundStart = row.isRange(quietStart, start, false);
            }
            return startRange;
        }
        static checkChecksum(s) {
            return AbstractUPCEANReader.checkStandardUPCEANChecksum(s);
        }
        static checkStandardUPCEANChecksum(s) {
            let length = s.length;
            if (length === 0) return false;
            let check = parseInt(s.charAt(length - 1), 10);
            return AbstractUPCEANReader.getStandardUPCEANChecksum(s.substring(0, length - 1)) === check;
        }
        static getStandardUPCEANChecksum(s) {
            let length = s.length;
            let sum = 0;
            for(let i = length - 1; i >= 0; i -= 2){
                let digit = s.charAt(i).charCodeAt(0) - '0'.charCodeAt(0);
                if (digit < 0 || digit > 9) throw new FormatException();
                sum += digit;
            }
            sum *= 3;
            for(let i = length - 2; i >= 0; i -= 2){
                let digit = s.charAt(i).charCodeAt(0) - '0'.charCodeAt(0);
                if (digit < 0 || digit > 9) throw new FormatException();
                sum += digit;
            }
            return (1000 - sum) % 10;
        }
        static decodeEnd(row, endStart) {
            return AbstractUPCEANReader.findGuardPattern(row, endStart, false, AbstractUPCEANReader.START_END_PATTERN, new Int32Array(AbstractUPCEANReader.START_END_PATTERN.length).fill(0));
        }
        /**
         * @throws NotFoundException
         */ static findGuardPatternWithoutCounters(row, rowOffset, whiteFirst, pattern) {
            return this.findGuardPattern(row, rowOffset, whiteFirst, pattern, new Int32Array(pattern.length));
        }
        /**
         * @param row row of black/white values to search
         * @param rowOffset position to start search
         * @param whiteFirst if true, indicates that the pattern specifies white/black/white/...
         * pixel counts, otherwise, it is interpreted as black/white/black/...
         * @param pattern pattern of counts of number of black and white pixels that are being
         * searched for as a pattern
         * @param counters array of counters, as long as pattern, to re-use
         * @return start/end horizontal offset of guard pattern, as an array of two ints
         * @throws NotFoundException if pattern is not found
         */ static findGuardPattern(row, rowOffset, whiteFirst, pattern, counters) {
            let width = row.getSize();
            rowOffset = whiteFirst ? row.getNextUnset(rowOffset) : row.getNextSet(rowOffset);
            let counterPosition = 0;
            let patternStart = rowOffset;
            let patternLength = pattern.length;
            let isWhite = whiteFirst;
            for(let x = rowOffset; x < width; x++)if (row.get(x) !== isWhite) counters[counterPosition]++;
            else {
                if (counterPosition === patternLength - 1) {
                    if (OneDReader.patternMatchVariance(counters, pattern, AbstractUPCEANReader.MAX_INDIVIDUAL_VARIANCE) < AbstractUPCEANReader.MAX_AVG_VARIANCE) return Int32Array.from([
                        patternStart,
                        x
                    ]);
                    patternStart += counters[0] + counters[1];
                    let slice = counters.slice(2, counters.length - 1);
                    for(let i = 0; i < counterPosition - 1; i++)counters[i] = slice[i];
                    counters[counterPosition - 1] = 0;
                    counters[counterPosition] = 0;
                    counterPosition--;
                } else counterPosition++;
                counters[counterPosition] = 1;
                isWhite = !isWhite;
            }
            throw new NotFoundException();
        }
        static decodeDigit(row, counters, rowOffset, patterns) {
            this.recordPattern(row, rowOffset, counters);
            let bestVariance = this.MAX_AVG_VARIANCE;
            let bestMatch = -1;
            let max = patterns.length;
            for(let i = 0; i < max; i++){
                let pattern = patterns[i];
                let variance = OneDReader.patternMatchVariance(counters, pattern, AbstractUPCEANReader.MAX_INDIVIDUAL_VARIANCE);
                if (variance < bestVariance) {
                    bestVariance = variance;
                    bestMatch = i;
                }
            }
            if (bestMatch >= 0) return bestMatch;
            else throw new NotFoundException();
        }
    }
    // These two values are critical for determining how permissive the decoding will be.
    // We've arrived at these values through a lot of trial and error. Setting them any higher
    // lets false positives creep in quickly.
    AbstractUPCEANReader.MAX_AVG_VARIANCE = 0.48;
    AbstractUPCEANReader.MAX_INDIVIDUAL_VARIANCE = 0.7;
    /**
     * Start/end guard pattern.
     */ AbstractUPCEANReader.START_END_PATTERN = Int32Array.from([
        1,
        1,
        1
    ]);
    /**
     * Pattern marking the middle of a UPC/EAN pattern, separating the two halves.
     */ AbstractUPCEANReader.MIDDLE_PATTERN = Int32Array.from([
        1,
        1,
        1,
        1,
        1
    ]);
    /**
     * end guard pattern.
     */ AbstractUPCEANReader.END_PATTERN = Int32Array.from([
        1,
        1,
        1,
        1,
        1,
        1
    ]);
    /**
     * "Odd", or "L" patterns used to encode UPC/EAN digits.
     */ AbstractUPCEANReader.L_PATTERNS = [
        Int32Array.from([
            3,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            2,
            2,
            1
        ]),
        Int32Array.from([
            2,
            1,
            2,
            2
        ]),
        Int32Array.from([
            1,
            4,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            2
        ]),
        Int32Array.from([
            1,
            2,
            3,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            4
        ]),
        Int32Array.from([
            1,
            3,
            1,
            2
        ]),
        Int32Array.from([
            1,
            2,
            1,
            3
        ]),
        Int32Array.from([
            3,
            1,
            1,
            2
        ])
    ];
    /**
     * @see UPCEANExtension2Support
     */ class UPCEANExtension5Support {
        constructor(){
            this.CHECK_DIGIT_ENCODINGS = [
                0x18,
                0x14,
                0x12,
                0x11,
                0x0C,
                0x06,
                0x03,
                0x0A,
                0x09,
                0x05
            ];
            this.decodeMiddleCounters = Int32Array.from([
                0,
                0,
                0,
                0
            ]);
            this.decodeRowStringBuffer = '';
        }
        decodeRow(rowNumber, row, extensionStartRange) {
            let result = this.decodeRowStringBuffer;
            let end = this.decodeMiddle(row, extensionStartRange, result);
            let resultString = result.toString();
            let extensionData = UPCEANExtension5Support.parseExtensionString(resultString);
            let resultPoints = [
                new ResultPoint((extensionStartRange[0] + extensionStartRange[1]) / 2.0, rowNumber),
                new ResultPoint(end, rowNumber)
            ];
            let extensionResult = new Result(resultString, null, 0, resultPoints, BarcodeFormat$1.UPC_EAN_EXTENSION, new Date().getTime());
            if (extensionData != null) extensionResult.putAllMetadata(extensionData);
            return extensionResult;
        }
        decodeMiddle(row, startRange, resultString) {
            let counters = this.decodeMiddleCounters;
            counters[0] = 0;
            counters[1] = 0;
            counters[2] = 0;
            counters[3] = 0;
            let end = row.getSize();
            let rowOffset = startRange[1];
            let lgPatternFound = 0;
            for(let x = 0; x < 5 && rowOffset < end; x++){
                let bestMatch = AbstractUPCEANReader.decodeDigit(row, counters, rowOffset, AbstractUPCEANReader.L_AND_G_PATTERNS);
                resultString += String.fromCharCode('0'.charCodeAt(0) + bestMatch % 10);
                for (let counter of counters)rowOffset += counter;
                if (bestMatch >= 10) lgPatternFound |= 1 << 4 - x;
                if (x !== 4) {
                    // Read off separator if not last
                    rowOffset = row.getNextSet(rowOffset);
                    rowOffset = row.getNextUnset(rowOffset);
                }
            }
            if (resultString.length !== 5) throw new NotFoundException();
            let checkDigit = this.determineCheckDigit(lgPatternFound);
            if (UPCEANExtension5Support.extensionChecksum(resultString.toString()) !== checkDigit) throw new NotFoundException();
            return rowOffset;
        }
        static extensionChecksum(s) {
            let length = s.length;
            let sum = 0;
            for(let i = length - 2; i >= 0; i -= 2)sum += s.charAt(i).charCodeAt(0) - '0'.charCodeAt(0);
            sum *= 3;
            for(let i = length - 1; i >= 0; i -= 2)sum += s.charAt(i).charCodeAt(0) - '0'.charCodeAt(0);
            sum *= 3;
            return sum % 10;
        }
        determineCheckDigit(lgPatternFound) {
            for(let d = 0; d < 10; d++){
                if (lgPatternFound === this.CHECK_DIGIT_ENCODINGS[d]) return d;
            }
            throw new NotFoundException();
        }
        static parseExtensionString(raw) {
            if (raw.length !== 5) return null;
            let value = UPCEANExtension5Support.parseExtension5String(raw);
            if (value == null) return null;
            return new Map([
                [
                    ResultMetadataType$1.SUGGESTED_PRICE,
                    value
                ]
            ]);
        }
        static parseExtension5String(raw) {
            let currency;
            switch(raw.charAt(0)){
                case '0':
                    currency = "\xa3";
                    break;
                case '5':
                    currency = '$';
                    break;
                case '9':
                    // Reference: http://www.jollytech.com
                    switch(raw){
                        case '90000':
                            // No suggested retail price
                            return null;
                        case '99991':
                            // Complementary
                            return '0.00';
                        case '99990':
                            return 'Used';
                    }
                    // Otherwise... unknown currency?
                    currency = '';
                    break;
                default:
                    currency = '';
                    break;
            }
            let rawAmount = parseInt(raw.substring(1));
            let unitsString = (rawAmount / 100).toString();
            let hundredths = rawAmount % 100;
            let hundredthsString = hundredths < 10 ? '0' + hundredths : hundredths.toString(); // fixme
            return currency + unitsString + '.' + hundredthsString;
        }
    }
    /**
     * @see UPCEANExtension5Support
     */ class UPCEANExtension2Support {
        constructor(){
            this.decodeMiddleCounters = Int32Array.from([
                0,
                0,
                0,
                0
            ]);
            this.decodeRowStringBuffer = '';
        }
        decodeRow(rowNumber, row, extensionStartRange) {
            let result = this.decodeRowStringBuffer;
            let end = this.decodeMiddle(row, extensionStartRange, result);
            let resultString = result.toString();
            let extensionData = UPCEANExtension2Support.parseExtensionString(resultString);
            let resultPoints = [
                new ResultPoint((extensionStartRange[0] + extensionStartRange[1]) / 2.0, rowNumber),
                new ResultPoint(end, rowNumber)
            ];
            let extensionResult = new Result(resultString, null, 0, resultPoints, BarcodeFormat$1.UPC_EAN_EXTENSION, new Date().getTime());
            if (extensionData != null) extensionResult.putAllMetadata(extensionData);
            return extensionResult;
        }
        decodeMiddle(row, startRange, resultString) {
            let counters = this.decodeMiddleCounters;
            counters[0] = 0;
            counters[1] = 0;
            counters[2] = 0;
            counters[3] = 0;
            let end = row.getSize();
            let rowOffset = startRange[1];
            let checkParity = 0;
            for(let x = 0; x < 2 && rowOffset < end; x++){
                let bestMatch = AbstractUPCEANReader.decodeDigit(row, counters, rowOffset, AbstractUPCEANReader.L_AND_G_PATTERNS);
                resultString += String.fromCharCode('0'.charCodeAt(0) + bestMatch % 10);
                for (let counter of counters)rowOffset += counter;
                if (bestMatch >= 10) checkParity |= 1 << 1 - x;
                if (x !== 1) {
                    // Read off separator if not last
                    rowOffset = row.getNextSet(rowOffset);
                    rowOffset = row.getNextUnset(rowOffset);
                }
            }
            if (resultString.length !== 2) throw new NotFoundException();
            if (parseInt(resultString.toString()) % 4 !== checkParity) throw new NotFoundException();
            return rowOffset;
        }
        static parseExtensionString(raw) {
            if (raw.length !== 2) return null;
            return new Map([
                [
                    ResultMetadataType$1.ISSUE_NUMBER,
                    parseInt(raw)
                ]
            ]);
        }
    }
    class UPCEANExtensionSupport {
        static decodeRow(rowNumber, row, rowOffset) {
            let extensionStartRange = AbstractUPCEANReader.findGuardPattern(row, rowOffset, false, this.EXTENSION_START_PATTERN, new Int32Array(this.EXTENSION_START_PATTERN.length).fill(0));
            try {
                // return null;
                let fiveSupport = new UPCEANExtension5Support();
                return fiveSupport.decodeRow(rowNumber, row, extensionStartRange);
            } catch (err) {
                // return null;
                let twoSupport = new UPCEANExtension2Support();
                return twoSupport.decodeRow(rowNumber, row, extensionStartRange);
            }
        }
    }
    UPCEANExtensionSupport.EXTENSION_START_PATTERN = Int32Array.from([
        1,
        1,
        2
    ]);
    /**
     * <p>Encapsulates functionality and implementation that is common to UPC and EAN families
     * of one-dimensional barcodes.</p>
     *
     * @author dswitkin@google.com (Daniel Switkin)
     * @author Sean Owen
     * @author alasdair@google.com (Alasdair Mackintosh)
     */ class UPCEANReader extends AbstractUPCEANReader {
        constructor(){
            super();
            this.decodeRowStringBuffer = '';
            UPCEANReader.L_AND_G_PATTERNS = UPCEANReader.L_PATTERNS.map((arr)=>Int32Array.from(arr));
            for(let i = 10; i < 20; i++){
                let widths = UPCEANReader.L_PATTERNS[i - 10];
                let reversedWidths = new Int32Array(widths.length);
                for(let j = 0; j < widths.length; j++)reversedWidths[j] = widths[widths.length - j - 1];
                UPCEANReader.L_AND_G_PATTERNS[i] = reversedWidths;
            }
        }
        decodeRow(rowNumber, row, hints) {
            let startGuardRange = UPCEANReader.findStartGuardPattern(row);
            let resultPointCallback = hints == null ? null : hints.get(DecodeHintType$1.NEED_RESULT_POINT_CALLBACK);
            if (resultPointCallback != null) {
                const resultPoint = new ResultPoint((startGuardRange[0] + startGuardRange[1]) / 2.0, rowNumber);
                resultPointCallback.foundPossibleResultPoint(resultPoint);
            }
            let budello = this.decodeMiddle(row, startGuardRange, this.decodeRowStringBuffer);
            let endStart = budello.rowOffset;
            let result = budello.resultString;
            if (resultPointCallback != null) {
                const resultPoint = new ResultPoint(endStart, rowNumber);
                resultPointCallback.foundPossibleResultPoint(resultPoint);
            }
            let endRange = this.decodeEnd(row, endStart);
            if (resultPointCallback != null) {
                const resultPoint = new ResultPoint((endRange[0] + endRange[1]) / 2.0, rowNumber);
                resultPointCallback.foundPossibleResultPoint(resultPoint);
            }
            // Make sure there is a quiet zone at least as big as the end pattern after the barcode. The
            // spec might want more whitespace, but in practice this is the maximum we can count on.
            let end = endRange[1];
            let quietEnd = end + (end - endRange[0]);
            if (quietEnd >= row.getSize() || !row.isRange(end, quietEnd, false)) throw new NotFoundException();
            let resultString = result.toString();
            // UPC/EAN should never be less than 8 chars anyway
            if (resultString.length < 8) throw new FormatException();
            if (!UPCEANReader.checkChecksum(resultString)) throw new ChecksumException();
            let left = (startGuardRange[1] + startGuardRange[0]) / 2.0;
            let right = (endRange[1] + endRange[0]) / 2.0;
            let format = this.getBarcodeFormat();
            let resultPoint = [
                new ResultPoint(left, rowNumber),
                new ResultPoint(right, rowNumber)
            ];
            let decodeResult = new Result(resultString, null, 0, resultPoint, format, new Date().getTime());
            let extensionLength = 0;
            try {
                let extensionResult = UPCEANExtensionSupport.decodeRow(rowNumber, row, endRange[1]);
                decodeResult.putMetadata(ResultMetadataType$1.UPC_EAN_EXTENSION, extensionResult.getText());
                decodeResult.putAllMetadata(extensionResult.getResultMetadata());
                decodeResult.addResultPoints(extensionResult.getResultPoints());
                extensionLength = extensionResult.getText().length;
            } catch (ignoreError) {}
            let allowedExtensions = hints == null ? null : hints.get(DecodeHintType$1.ALLOWED_EAN_EXTENSIONS);
            if (allowedExtensions != null) {
                let valid = false;
                for(let length in allowedExtensions)if (extensionLength.toString() === length) {
                    valid = true;
                    break;
                }
                if (!valid) throw new NotFoundException();
            }
            return decodeResult;
        }
        decodeEnd(row, endStart) {
            return UPCEANReader.findGuardPattern(row, endStart, false, UPCEANReader.START_END_PATTERN, new Int32Array(UPCEANReader.START_END_PATTERN.length).fill(0));
        }
        static checkChecksum(s) {
            return UPCEANReader.checkStandardUPCEANChecksum(s);
        }
        static checkStandardUPCEANChecksum(s) {
            let length = s.length;
            if (length === 0) return false;
            let check = parseInt(s.charAt(length - 1), 10);
            return UPCEANReader.getStandardUPCEANChecksum(s.substring(0, length - 1)) === check;
        }
        static getStandardUPCEANChecksum(s) {
            let length = s.length;
            let sum = 0;
            for(let i = length - 1; i >= 0; i -= 2){
                let digit = s.charAt(i).charCodeAt(0) - '0'.charCodeAt(0);
                if (digit < 0 || digit > 9) throw new FormatException();
                sum += digit;
            }
            sum *= 3;
            for(let i = length - 2; i >= 0; i -= 2){
                let digit = s.charAt(i).charCodeAt(0) - '0'.charCodeAt(0);
                if (digit < 0 || digit > 9) throw new FormatException();
                sum += digit;
            }
            return (1000 - sum) % 10;
        }
    }
    /**
     * <p>Implements decoding of the EAN-13 format.</p>
     *
     * @author dswitkin@google.com (Daniel Switkin)
     * @author Sean Owen
     * @author alasdair@google.com (Alasdair Mackintosh)
     */ class EAN13Reader extends UPCEANReader {
        constructor(){
            super();
            this.decodeMiddleCounters = Int32Array.from([
                0,
                0,
                0,
                0
            ]);
        }
        decodeMiddle(row, startRange, resultString) {
            let counters = this.decodeMiddleCounters;
            counters[0] = 0;
            counters[1] = 0;
            counters[2] = 0;
            counters[3] = 0;
            let end = row.getSize();
            let rowOffset = startRange[1];
            let lgPatternFound = 0;
            for(let x = 0; x < 6 && rowOffset < end; x++){
                let bestMatch = UPCEANReader.decodeDigit(row, counters, rowOffset, UPCEANReader.L_AND_G_PATTERNS);
                resultString += String.fromCharCode('0'.charCodeAt(0) + bestMatch % 10);
                for (let counter of counters)rowOffset += counter;
                if (bestMatch >= 10) lgPatternFound |= 1 << 5 - x;
            }
            resultString = EAN13Reader.determineFirstDigit(resultString, lgPatternFound);
            let middleRange = UPCEANReader.findGuardPattern(row, rowOffset, true, UPCEANReader.MIDDLE_PATTERN, new Int32Array(UPCEANReader.MIDDLE_PATTERN.length).fill(0));
            rowOffset = middleRange[1];
            for(let x = 0; x < 6 && rowOffset < end; x++){
                let bestMatch = UPCEANReader.decodeDigit(row, counters, rowOffset, UPCEANReader.L_PATTERNS);
                resultString += String.fromCharCode('0'.charCodeAt(0) + bestMatch);
                for (let counter of counters)rowOffset += counter;
            }
            return {
                rowOffset: rowOffset,
                resultString: resultString
            };
        }
        getBarcodeFormat() {
            return BarcodeFormat$1.EAN_13;
        }
        static determineFirstDigit(resultString, lgPatternFound) {
            for(let d = 0; d < 10; d++)if (lgPatternFound === this.FIRST_DIGIT_ENCODINGS[d]) {
                resultString = String.fromCharCode('0'.charCodeAt(0) + d) + resultString;
                return resultString;
            }
            throw new NotFoundException();
        }
    }
    EAN13Reader.FIRST_DIGIT_ENCODINGS = [
        0x00,
        0x0B,
        0x0D,
        0xE,
        0x13,
        0x19,
        0x1C,
        0x15,
        0x16,
        0x1A
    ];
    /**
     * <p>Implements decoding of the EAN-8 format.</p>
     *
     * @author Sean Owen
     */ class EAN8Reader extends UPCEANReader {
        constructor(){
            super();
            this.decodeMiddleCounters = Int32Array.from([
                0,
                0,
                0,
                0
            ]);
        }
        decodeMiddle(row, startRange, resultString) {
            const counters = this.decodeMiddleCounters;
            counters[0] = 0;
            counters[1] = 0;
            counters[2] = 0;
            counters[3] = 0;
            let end = row.getSize();
            let rowOffset = startRange[1];
            for(let x = 0; x < 4 && rowOffset < end; x++){
                let bestMatch = UPCEANReader.decodeDigit(row, counters, rowOffset, UPCEANReader.L_PATTERNS);
                resultString += String.fromCharCode('0'.charCodeAt(0) + bestMatch);
                for (let counter of counters)rowOffset += counter;
            }
            let middleRange = UPCEANReader.findGuardPattern(row, rowOffset, true, UPCEANReader.MIDDLE_PATTERN, new Int32Array(UPCEANReader.MIDDLE_PATTERN.length).fill(0));
            rowOffset = middleRange[1];
            for(let x = 0; x < 4 && rowOffset < end; x++){
                let bestMatch = UPCEANReader.decodeDigit(row, counters, rowOffset, UPCEANReader.L_PATTERNS);
                resultString += String.fromCharCode('0'.charCodeAt(0) + bestMatch);
                for (let counter of counters)rowOffset += counter;
            }
            return {
                rowOffset: rowOffset,
                resultString: resultString
            };
        }
        getBarcodeFormat() {
            return BarcodeFormat$1.EAN_8;
        }
    }
    /**
     * Encapsulates functionality and implementation that is common to all families
     * of one-dimensional barcodes.
     *
     * @author dswitkin@google.com (Daniel Switkin)
     * @author Sean Owen
     * @author sam2332 (Sam Rudloff)
     *
     * @source https://github.com/zxing/zxing/blob/3c96923276dd5785d58eb970b6ba3f80d36a9505/core/src/main/java/com/google/zxing/oned/UPCAReader.java
     *
     * @experimental
     */ class UPCAReader extends UPCEANReader {
        constructor(){
            super(...arguments);
            this.ean13Reader = new EAN13Reader();
        }
        // @Override
        getBarcodeFormat() {
            return BarcodeFormat$1.UPC_A;
        }
        // Note that we don't try rotation without the try harder flag, even if rotation was supported.
        // @Override
        decode(image, hints) {
            return this.maybeReturnResult(this.ean13Reader.decode(image));
        }
        // @Override
        decodeRow(rowNumber, row, hints) {
            return this.maybeReturnResult(this.ean13Reader.decodeRow(rowNumber, row, hints));
        }
        // @Override
        decodeMiddle(row, startRange, resultString) {
            return this.ean13Reader.decodeMiddle(row, startRange, resultString);
        }
        maybeReturnResult(result) {
            let text = result.getText();
            if (text.charAt(0) === '0') {
                let upcaResult = new Result(text.substring(1), null, null, result.getResultPoints(), BarcodeFormat$1.UPC_A);
                if (result.getResultMetadata() != null) upcaResult.putAllMetadata(result.getResultMetadata());
                return upcaResult;
            } else throw new NotFoundException();
        }
        reset() {
            this.ean13Reader.reset();
        }
    }
    /**
     * <p>Implements decoding of the UPC-E format.</p>
     * <p><a href="http://www.barcodeisland.com/upce.phtml">This</a> is a great reference for
     * UPC-E information.</p>
     *
     * @author Sean Owen
     *
     * @source https://github.com/zxing/zxing/blob/3c96923276dd5785d58eb970b6ba3f80d36a9505/core/src/main/java/com/google/zxing/oned/UPCEReader.java
     *
     * @experimental
     */ /* final */ class UPCEReader extends UPCEANReader {
        constructor(){
            super();
            this.decodeMiddleCounters = new Int32Array(4);
        }
        /**
         * @throws NotFoundException
         */ // @Override
        decodeMiddle(row, startRange, result) {
            const counters = this.decodeMiddleCounters.map((x)=>x);
            counters[0] = 0;
            counters[1] = 0;
            counters[2] = 0;
            counters[3] = 0;
            const end = row.getSize();
            let rowOffset = startRange[1];
            let lgPatternFound = 0;
            for(let x = 0; x < 6 && rowOffset < end; x++){
                const bestMatch = UPCEReader.decodeDigit(row, counters, rowOffset, UPCEReader.L_AND_G_PATTERNS);
                result += String.fromCharCode('0'.charCodeAt(0) + bestMatch % 10);
                for (let counter of counters)rowOffset += counter;
                if (bestMatch >= 10) lgPatternFound |= 1 << 5 - x;
            }
            let resultString = UPCEReader.determineNumSysAndCheckDigit(result, lgPatternFound);
            return {
                rowOffset: rowOffset,
                resultString: resultString
            };
        }
        /**
         * @throws NotFoundException
         */ // @Override
        decodeEnd(row, endStart) {
            return UPCEReader.findGuardPatternWithoutCounters(row, endStart, true, UPCEReader.MIDDLE_END_PATTERN);
        }
        /**
         * @throws FormatException
         */ // @Override
        checkChecksum(s) {
            return UPCEANReader.checkChecksum(UPCEReader.convertUPCEtoUPCA(s));
        }
        /**
         * @throws NotFoundException
         */ static determineNumSysAndCheckDigit(resultString, lgPatternFound) {
            for(let numSys = 0; numSys <= 1; numSys++){
                for(let d = 0; d < 10; d++)if (lgPatternFound === this.NUMSYS_AND_CHECK_DIGIT_PATTERNS[numSys][d]) {
                    let prefix = String.fromCharCode('0'.charCodeAt(0) + numSys);
                    let suffix = String.fromCharCode('0'.charCodeAt(0) + d);
                    return prefix + resultString + suffix;
                }
            }
            throw NotFoundException.getNotFoundInstance();
        }
        // @Override
        getBarcodeFormat() {
            return BarcodeFormat$1.UPC_E;
        }
        /**
         * Expands a UPC-E value back into its full, equivalent UPC-A code value.
         *
         * @param upce UPC-E code as string of digits
         * @return equivalent UPC-A code as string of digits
         */ static convertUPCEtoUPCA(upce) {
            // the following line is equivalent to upce.getChars(1, 7, upceChars, 0);
            const upceChars = upce.slice(1, 7).split('').map((x)=>x.charCodeAt(0));
            const result = new StringBuilder();
            result.append(upce.charAt(0));
            let lastChar = upceChars[5];
            switch(lastChar){
                case 0:
                case 1:
                case 2:
                    result.appendChars(upceChars, 0, 2);
                    result.append(lastChar);
                    result.append('0000');
                    result.appendChars(upceChars, 2, 3);
                    break;
                case 3:
                    result.appendChars(upceChars, 0, 3);
                    result.append('00000');
                    result.appendChars(upceChars, 3, 2);
                    break;
                case 4:
                    result.appendChars(upceChars, 0, 4);
                    result.append('00000');
                    result.append(upceChars[4]);
                    break;
                default:
                    result.appendChars(upceChars, 0, 5);
                    result.append('0000');
                    result.append(lastChar);
                    break;
            }
            // Only append check digit in conversion if supplied
            if (upce.length >= 8) result.append(upce.charAt(7));
            return result.toString();
        }
    }
    /**
     * The pattern that marks the middle, and end, of a UPC-E pattern.
     * There is no "second half" to a UPC-E barcode.
     */ UPCEReader.MIDDLE_END_PATTERN = Int32Array.from([
        1,
        1,
        1,
        1,
        1,
        1
    ]);
    // For an UPC-E barcode, the final digit is represented by the parities used
    // to encode the middle six digits, according to the table below.
    //
    //                Parity of next 6 digits
    //    Digit   0     1     2     3     4     5
    //       0    Even   Even  Even Odd  Odd   Odd
    //       1    Even   Even  Odd  Even Odd   Odd
    //       2    Even   Even  Odd  Odd  Even  Odd
    //       3    Even   Even  Odd  Odd  Odd   Even
    //       4    Even   Odd   Even Even Odd   Odd
    //       5    Even   Odd   Odd  Even Even  Odd
    //       6    Even   Odd   Odd  Odd  Even  Even
    //       7    Even   Odd   Even Odd  Even  Odd
    //       8    Even   Odd   Even Odd  Odd   Even
    //       9    Even   Odd   Odd  Even Odd   Even
    //
    // The encoding is represented by the following array, which is a bit pattern
    // using Odd = 0 and Even = 1. For example, 5 is represented by:
    //
    //              Odd Even Even Odd Odd Even
    // in binary:
    //                0    1    1   0   0    1   == 0x19
    //
    /**
     * See {@link #L_AND_G_PATTERNS}; these values similarly represent patterns of
     * even-odd parity encodings of digits that imply both the number system (0 or 1)
     * used, and the check digit.
     */ UPCEReader.NUMSYS_AND_CHECK_DIGIT_PATTERNS = [
        Int32Array.from([
            0x38,
            0x34,
            0x32,
            0x31,
            0x2C,
            0x26,
            0x23,
            0x2A,
            0x29,
            0x25
        ]),
        Int32Array.from([
            0x07,
            0x0B,
            0x0D,
            0x0E,
            0x13,
            0x19,
            0x1C,
            0x15,
            0x16,
            0x1A
        ])
    ];
    /**
     * <p>A reader that can read all available UPC/EAN formats. If a caller wants to try to
     * read all such formats, it is most efficient to use this implementation rather than invoke
     * individual readers.</p>
     *
     * @author Sean Owen
     */ class MultiFormatUPCEANReader extends OneDReader {
        constructor(hints){
            super();
            let possibleFormats = hints == null ? null : hints.get(DecodeHintType$1.POSSIBLE_FORMATS);
            let readers = [];
            if (!isNullOrUndefined(possibleFormats)) {
                if (possibleFormats.indexOf(BarcodeFormat$1.EAN_13) > -1) readers.push(new EAN13Reader());
                if (possibleFormats.indexOf(BarcodeFormat$1.UPC_A) > -1) readers.push(new UPCAReader());
                if (possibleFormats.indexOf(BarcodeFormat$1.EAN_8) > -1) readers.push(new EAN8Reader());
                if (possibleFormats.indexOf(BarcodeFormat$1.UPC_E) > -1) readers.push(new UPCEReader());
            } else {
                // No hints provided.
                readers.push(new EAN13Reader());
                readers.push(new UPCAReader());
                readers.push(new EAN8Reader());
                readers.push(new UPCEReader());
            }
            this.readers = readers;
        }
        decodeRow(rowNumber, row, hints) {
            for (let reader of this.readers)try {
                // const result: Result = reader.decodeRow(rowNumber, row, startGuardPattern, hints);
                const result = reader.decodeRow(rowNumber, row, hints);
                // Special case: a 12-digit code encoded in UPC-A is identical to a "0"
                // followed by those 12 digits encoded as EAN-13. Each will recognize such a code,
                // UPC-A as a 12-digit string and EAN-13 as a 13-digit string starting with "0".
                // Individually these are correct and their readers will both read such a code
                // and correctly call it EAN-13, or UPC-A, respectively.
                //
                // In this case, if we've been looking for both types, we'd like to call it
                // a UPC-A code. But for efficiency we only run the EAN-13 decoder to also read
                // UPC-A. So we special case it here, and convert an EAN-13 result to a UPC-A
                // result if appropriate.
                //
                // But, don't return UPC-A if UPC-A was not a requested format!
                const ean13MayBeUPCA = result.getBarcodeFormat() === BarcodeFormat$1.EAN_13 && result.getText().charAt(0) === '0';
                // @SuppressWarnings("unchecked")
                const possibleFormats = hints == null ? null : hints.get(DecodeHintType$1.POSSIBLE_FORMATS);
                const canReturnUPCA = possibleFormats == null || possibleFormats.includes(BarcodeFormat$1.UPC_A);
                if (ean13MayBeUPCA && canReturnUPCA) {
                    const rawBytes = result.getRawBytes();
                    // Transfer the metadata across
                    const resultUPCA = new Result(result.getText().substring(1), rawBytes, rawBytes ? rawBytes.length : null, result.getResultPoints(), BarcodeFormat$1.UPC_A);
                    resultUPCA.putAllMetadata(result.getResultMetadata());
                    return resultUPCA;
                }
                return result;
            } catch (err) {
            // continue;
            }
            throw new NotFoundException();
        }
        reset() {
            for (let reader of this.readers)reader.reset();
        }
    }
    // import Integer from '../../util/Integer';
    // import Float from '../../util/Float';
    class AbstractRSSReader extends OneDReader {
        constructor(){
            super();
            this.decodeFinderCounters = new Int32Array(4);
            this.dataCharacterCounters = new Int32Array(8);
            this.oddRoundingErrors = new Array(4);
            this.evenRoundingErrors = new Array(4);
            this.oddCounts = new Array(this.dataCharacterCounters.length / 2);
            this.evenCounts = new Array(this.dataCharacterCounters.length / 2);
        }
        getDecodeFinderCounters() {
            return this.decodeFinderCounters;
        }
        getDataCharacterCounters() {
            return this.dataCharacterCounters;
        }
        getOddRoundingErrors() {
            return this.oddRoundingErrors;
        }
        getEvenRoundingErrors() {
            return this.evenRoundingErrors;
        }
        getOddCounts() {
            return this.oddCounts;
        }
        getEvenCounts() {
            return this.evenCounts;
        }
        parseFinderValue(counters, finderPatterns) {
            for(let value = 0; value < finderPatterns.length; value++){
                if (OneDReader.patternMatchVariance(counters, finderPatterns[value], AbstractRSSReader.MAX_INDIVIDUAL_VARIANCE) < AbstractRSSReader.MAX_AVG_VARIANCE) return value;
            }
            throw new NotFoundException();
        }
        /**
         * @param array values to sum
         * @return sum of values
         * @deprecated call {@link MathUtils#sum(int[])}
         */ static count(array) {
            return MathUtils.sum(new Int32Array(array));
        }
        static increment(array, errors) {
            let index = 0;
            let biggestError = errors[0];
            for(let i = 1; i < array.length; i++)if (errors[i] > biggestError) {
                biggestError = errors[i];
                index = i;
            }
            array[index]++;
        }
        static decrement(array, errors) {
            let index = 0;
            let biggestError = errors[0];
            for(let i = 1; i < array.length; i++)if (errors[i] < biggestError) {
                biggestError = errors[i];
                index = i;
            }
            array[index]--;
        }
        static isFinderPattern(counters) {
            let firstTwoSum = counters[0] + counters[1];
            let sum = firstTwoSum + counters[2] + counters[3];
            let ratio = firstTwoSum / sum;
            if (ratio >= AbstractRSSReader.MIN_FINDER_PATTERN_RATIO && ratio <= AbstractRSSReader.MAX_FINDER_PATTERN_RATIO) {
                // passes ratio test in spec, but see if the counts are unreasonable
                let minCounter = Number.MAX_SAFE_INTEGER;
                let maxCounter = Number.MIN_SAFE_INTEGER;
                for (let counter of counters){
                    if (counter > maxCounter) maxCounter = counter;
                    if (counter < minCounter) minCounter = counter;
                }
                return maxCounter < 10 * minCounter;
            }
            return false;
        }
    }
    AbstractRSSReader.MAX_AVG_VARIANCE = 0.2;
    AbstractRSSReader.MAX_INDIVIDUAL_VARIANCE = 0.45;
    AbstractRSSReader.MIN_FINDER_PATTERN_RATIO = 9.5 / 12.0;
    AbstractRSSReader.MAX_FINDER_PATTERN_RATIO = 12.5 / 14.0;
    class DataCharacter {
        constructor(value, checksumPortion){
            this.value = value;
            this.checksumPortion = checksumPortion;
        }
        getValue() {
            return this.value;
        }
        getChecksumPortion() {
            return this.checksumPortion;
        }
        toString() {
            return this.value + '(' + this.checksumPortion + ')';
        }
        equals(o) {
            if (!(o instanceof DataCharacter)) return false;
            const that = o;
            return this.value === that.value && this.checksumPortion === that.checksumPortion;
        }
        hashCode() {
            return this.value ^ this.checksumPortion;
        }
    }
    class FinderPattern {
        constructor(value, startEnd, start, end, rowNumber){
            this.value = value;
            this.startEnd = startEnd;
            this.value = value;
            this.startEnd = startEnd;
            this.resultPoints = new Array();
            this.resultPoints.push(new ResultPoint(start, rowNumber));
            this.resultPoints.push(new ResultPoint(end, rowNumber));
        }
        getValue() {
            return this.value;
        }
        getStartEnd() {
            return this.startEnd;
        }
        getResultPoints() {
            return this.resultPoints;
        }
        equals(o) {
            if (!(o instanceof FinderPattern)) return false;
            const that = o;
            return this.value === that.value;
        }
        hashCode() {
            return this.value;
        }
    }
    /**
     * RSS util functions.
     */ class RSSUtils {
        constructor(){}
        static getRSSvalue(widths, maxWidth, noNarrow) {
            let n = 0;
            for (let width of widths)n += width;
            let val = 0;
            let narrowMask = 0;
            let elements = widths.length;
            for(let bar = 0; bar < elements - 1; bar++){
                let elmWidth;
                for(elmWidth = 1, narrowMask |= 1 << bar; elmWidth < widths[bar]; elmWidth++, narrowMask &= ~(1 << bar)){
                    let subVal = RSSUtils.combins(n - elmWidth - 1, elements - bar - 2);
                    if (noNarrow && narrowMask === 0 && n - elmWidth - (elements - bar - 1) >= elements - bar - 1) subVal -= RSSUtils.combins(n - elmWidth - (elements - bar), elements - bar - 2);
                    if (elements - bar - 1 > 1) {
                        let lessVal = 0;
                        for(let mxwElement = n - elmWidth - (elements - bar - 2); mxwElement > maxWidth; mxwElement--)lessVal += RSSUtils.combins(n - elmWidth - mxwElement - 1, elements - bar - 3);
                        subVal -= lessVal * (elements - 1 - bar);
                    } else if (n - elmWidth > maxWidth) subVal--;
                    val += subVal;
                }
                n -= elmWidth;
            }
            return val;
        }
        static combins(n, r) {
            let maxDenom;
            let minDenom;
            if (n - r > r) {
                minDenom = r;
                maxDenom = n - r;
            } else {
                minDenom = n - r;
                maxDenom = r;
            }
            let val = 1;
            let j = 1;
            for(let i = n; i > maxDenom; i--){
                val *= i;
                if (j <= minDenom) {
                    val /= j;
                    j++;
                }
            }
            while(j <= minDenom){
                val /= j;
                j++;
            }
            return val;
        }
    }
    class BitArrayBuilder {
        static buildBitArray(pairs) {
            let charNumber = pairs.length * 2 - 1;
            if (pairs[pairs.length - 1].getRightChar() == null) charNumber -= 1;
            let size = 12 * charNumber;
            let binary = new BitArray(size);
            let accPos = 0;
            let firstPair = pairs[0];
            let firstValue = firstPair.getRightChar().getValue();
            for(let i = 11; i >= 0; --i){
                if ((firstValue & 1 << i) != 0) binary.set(accPos);
                accPos++;
            }
            for(let i = 1; i < pairs.length; ++i){
                let currentPair = pairs[i];
                let leftValue = currentPair.getLeftChar().getValue();
                for(let j = 11; j >= 0; --j){
                    if ((leftValue & 1 << j) != 0) binary.set(accPos);
                    accPos++;
                }
                if (currentPair.getRightChar() != null) {
                    let rightValue = currentPair.getRightChar().getValue();
                    for(let j = 11; j >= 0; --j){
                        if ((rightValue & 1 << j) != 0) binary.set(accPos);
                        accPos++;
                    }
                }
            }
            return binary;
        }
    }
    class BlockParsedResult {
        constructor(finished, decodedInformation){
            if (decodedInformation) this.decodedInformation = null;
            else {
                this.finished = finished;
                this.decodedInformation = decodedInformation;
            }
        }
        getDecodedInformation() {
            return this.decodedInformation;
        }
        isFinished() {
            return this.finished;
        }
    }
    class DecodedObject {
        constructor(newPosition){
            this.newPosition = newPosition;
        }
        getNewPosition() {
            return this.newPosition;
        }
    }
    class DecodedChar extends DecodedObject {
        constructor(newPosition, value){
            super(newPosition);
            this.value = value;
        }
        getValue() {
            return this.value;
        }
        isFNC1() {
            return this.value === DecodedChar.FNC1;
        }
    }
    DecodedChar.FNC1 = '$';
    class DecodedInformation extends DecodedObject {
        constructor(newPosition, newString, remainingValue){
            super(newPosition);
            if (remainingValue) {
                this.remaining = true;
                this.remainingValue = this.remainingValue;
            } else {
                this.remaining = false;
                this.remainingValue = 0;
            }
            this.newString = newString;
        }
        getNewString() {
            return this.newString;
        }
        isRemaining() {
            return this.remaining;
        }
        getRemainingValue() {
            return this.remainingValue;
        }
    }
    class DecodedNumeric extends DecodedObject {
        constructor(newPosition, firstDigit, secondDigit){
            super(newPosition);
            if (firstDigit < 0 || firstDigit > 10 || secondDigit < 0 || secondDigit > 10) throw new FormatException();
            this.firstDigit = firstDigit;
            this.secondDigit = secondDigit;
        }
        getFirstDigit() {
            return this.firstDigit;
        }
        getSecondDigit() {
            return this.secondDigit;
        }
        getValue() {
            return this.firstDigit * 10 + this.secondDigit;
        }
        isFirstDigitFNC1() {
            return this.firstDigit === DecodedNumeric.FNC1;
        }
        isSecondDigitFNC1() {
            return this.secondDigit === DecodedNumeric.FNC1;
        }
        isAnyFNC1() {
            return this.firstDigit === DecodedNumeric.FNC1 || this.secondDigit === DecodedNumeric.FNC1;
        }
    }
    DecodedNumeric.FNC1 = 10;
    class FieldParser {
        constructor(){}
        static parseFieldsInGeneralPurpose(rawInformation) {
            if (!rawInformation) return null;
            // Processing 2-digit AIs
            if (rawInformation.length < 2) throw new NotFoundException();
            let firstTwoDigits = rawInformation.substring(0, 2);
            for (let dataLength of FieldParser.TWO_DIGIT_DATA_LENGTH)if (dataLength[0] === firstTwoDigits) {
                if (dataLength[1] === FieldParser.VARIABLE_LENGTH) return FieldParser.processVariableAI(2, dataLength[2], rawInformation);
                return FieldParser.processFixedAI(2, dataLength[1], rawInformation);
            }
            if (rawInformation.length < 3) throw new NotFoundException();
            let firstThreeDigits = rawInformation.substring(0, 3);
            for (let dataLength of FieldParser.THREE_DIGIT_DATA_LENGTH)if (dataLength[0] === firstThreeDigits) {
                if (dataLength[1] === FieldParser.VARIABLE_LENGTH) return FieldParser.processVariableAI(3, dataLength[2], rawInformation);
                return FieldParser.processFixedAI(3, dataLength[1], rawInformation);
            }
            for (let dataLength of FieldParser.THREE_DIGIT_PLUS_DIGIT_DATA_LENGTH)if (dataLength[0] === firstThreeDigits) {
                if (dataLength[1] === FieldParser.VARIABLE_LENGTH) return FieldParser.processVariableAI(4, dataLength[2], rawInformation);
                return FieldParser.processFixedAI(4, dataLength[1], rawInformation);
            }
            if (rawInformation.length < 4) throw new NotFoundException();
            let firstFourDigits = rawInformation.substring(0, 4);
            for (let dataLength of FieldParser.FOUR_DIGIT_DATA_LENGTH)if (dataLength[0] === firstFourDigits) {
                if (dataLength[1] === FieldParser.VARIABLE_LENGTH) return FieldParser.processVariableAI(4, dataLength[2], rawInformation);
                return FieldParser.processFixedAI(4, dataLength[1], rawInformation);
            }
            throw new NotFoundException();
        }
        static processFixedAI(aiSize, fieldSize, rawInformation) {
            if (rawInformation.length < aiSize) throw new NotFoundException();
            let ai = rawInformation.substring(0, aiSize);
            if (rawInformation.length < aiSize + fieldSize) throw new NotFoundException();
            let field = rawInformation.substring(aiSize, aiSize + fieldSize);
            let remaining = rawInformation.substring(aiSize + fieldSize);
            let result = '(' + ai + ')' + field;
            let parsedAI = FieldParser.parseFieldsInGeneralPurpose(remaining);
            return parsedAI == null ? result : result + parsedAI;
        }
        static processVariableAI(aiSize, variableFieldSize, rawInformation) {
            let ai = rawInformation.substring(0, aiSize);
            let maxSize;
            if (rawInformation.length < aiSize + variableFieldSize) maxSize = rawInformation.length;
            else maxSize = aiSize + variableFieldSize;
            let field = rawInformation.substring(aiSize, maxSize);
            let remaining = rawInformation.substring(maxSize);
            let result = '(' + ai + ')' + field;
            let parsedAI = FieldParser.parseFieldsInGeneralPurpose(remaining);
            return parsedAI == null ? result : result + parsedAI;
        }
    }
    FieldParser.VARIABLE_LENGTH = [];
    FieldParser.TWO_DIGIT_DATA_LENGTH = [
        [
            '00',
            18
        ],
        [
            '01',
            14
        ],
        [
            '02',
            14
        ],
        [
            '10',
            FieldParser.VARIABLE_LENGTH,
            20
        ],
        [
            '11',
            6
        ],
        [
            '12',
            6
        ],
        [
            '13',
            6
        ],
        [
            '15',
            6
        ],
        [
            '17',
            6
        ],
        [
            '20',
            2
        ],
        [
            '21',
            FieldParser.VARIABLE_LENGTH,
            20
        ],
        [
            '22',
            FieldParser.VARIABLE_LENGTH,
            29
        ],
        [
            '30',
            FieldParser.VARIABLE_LENGTH,
            8
        ],
        [
            '37',
            FieldParser.VARIABLE_LENGTH,
            8
        ],
        // internal company codes
        [
            '90',
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            '91',
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            '92',
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            '93',
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            '94',
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            '95',
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            '96',
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            '97',
            FieldParser.VARIABLE_LENGTH,
            3
        ],
        [
            '98',
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            '99',
            FieldParser.VARIABLE_LENGTH,
            30
        ]
    ];
    FieldParser.THREE_DIGIT_DATA_LENGTH = [
        // Same format as above
        [
            '240',
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            '241',
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            '242',
            FieldParser.VARIABLE_LENGTH,
            6
        ],
        [
            '250',
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            '251',
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            '253',
            FieldParser.VARIABLE_LENGTH,
            17
        ],
        [
            '254',
            FieldParser.VARIABLE_LENGTH,
            20
        ],
        [
            '400',
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            '401',
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            '402',
            17
        ],
        [
            '403',
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            '410',
            13
        ],
        [
            '411',
            13
        ],
        [
            '412',
            13
        ],
        [
            '413',
            13
        ],
        [
            '414',
            13
        ],
        [
            '420',
            FieldParser.VARIABLE_LENGTH,
            20
        ],
        [
            '421',
            FieldParser.VARIABLE_LENGTH,
            15
        ],
        [
            '422',
            3
        ],
        [
            '423',
            FieldParser.VARIABLE_LENGTH,
            15
        ],
        [
            '424',
            3
        ],
        [
            '425',
            3
        ],
        [
            '426',
            3
        ]
    ];
    FieldParser.THREE_DIGIT_PLUS_DIGIT_DATA_LENGTH = [
        // Same format as above
        [
            '310',
            6
        ],
        [
            '311',
            6
        ],
        [
            '312',
            6
        ],
        [
            '313',
            6
        ],
        [
            '314',
            6
        ],
        [
            '315',
            6
        ],
        [
            '316',
            6
        ],
        [
            '320',
            6
        ],
        [
            '321',
            6
        ],
        [
            '322',
            6
        ],
        [
            '323',
            6
        ],
        [
            '324',
            6
        ],
        [
            '325',
            6
        ],
        [
            '326',
            6
        ],
        [
            '327',
            6
        ],
        [
            '328',
            6
        ],
        [
            '329',
            6
        ],
        [
            '330',
            6
        ],
        [
            '331',
            6
        ],
        [
            '332',
            6
        ],
        [
            '333',
            6
        ],
        [
            '334',
            6
        ],
        [
            '335',
            6
        ],
        [
            '336',
            6
        ],
        [
            '340',
            6
        ],
        [
            '341',
            6
        ],
        [
            '342',
            6
        ],
        [
            '343',
            6
        ],
        [
            '344',
            6
        ],
        [
            '345',
            6
        ],
        [
            '346',
            6
        ],
        [
            '347',
            6
        ],
        [
            '348',
            6
        ],
        [
            '349',
            6
        ],
        [
            '350',
            6
        ],
        [
            '351',
            6
        ],
        [
            '352',
            6
        ],
        [
            '353',
            6
        ],
        [
            '354',
            6
        ],
        [
            '355',
            6
        ],
        [
            '356',
            6
        ],
        [
            '357',
            6
        ],
        [
            '360',
            6
        ],
        [
            '361',
            6
        ],
        [
            '362',
            6
        ],
        [
            '363',
            6
        ],
        [
            '364',
            6
        ],
        [
            '365',
            6
        ],
        [
            '366',
            6
        ],
        [
            '367',
            6
        ],
        [
            '368',
            6
        ],
        [
            '369',
            6
        ],
        [
            '390',
            FieldParser.VARIABLE_LENGTH,
            15
        ],
        [
            '391',
            FieldParser.VARIABLE_LENGTH,
            18
        ],
        [
            '392',
            FieldParser.VARIABLE_LENGTH,
            15
        ],
        [
            '393',
            FieldParser.VARIABLE_LENGTH,
            18
        ],
        [
            '703',
            FieldParser.VARIABLE_LENGTH,
            30
        ]
    ];
    FieldParser.FOUR_DIGIT_DATA_LENGTH = [
        // Same format as above
        [
            '7001',
            13
        ],
        [
            '7002',
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            '7003',
            10
        ],
        [
            '8001',
            14
        ],
        [
            '8002',
            FieldParser.VARIABLE_LENGTH,
            20
        ],
        [
            '8003',
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            '8004',
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            '8005',
            6
        ],
        [
            '8006',
            18
        ],
        [
            '8007',
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            '8008',
            FieldParser.VARIABLE_LENGTH,
            12
        ],
        [
            '8018',
            18
        ],
        [
            '8020',
            FieldParser.VARIABLE_LENGTH,
            25
        ],
        [
            '8100',
            6
        ],
        [
            '8101',
            10
        ],
        [
            '8102',
            2
        ],
        [
            '8110',
            FieldParser.VARIABLE_LENGTH,
            70
        ],
        [
            '8200',
            FieldParser.VARIABLE_LENGTH,
            70
        ]
    ];
    class GeneralAppIdDecoder {
        constructor(information){
            this.buffer = new StringBuilder();
            this.information = information;
        }
        decodeAllCodes(buff, initialPosition) {
            let currentPosition = initialPosition;
            let remaining = null;
            do {
                let info = this.decodeGeneralPurposeField(currentPosition, remaining);
                let parsedFields = FieldParser.parseFieldsInGeneralPurpose(info.getNewString());
                if (parsedFields != null) buff.append(parsedFields);
                if (info.isRemaining()) remaining = '' + info.getRemainingValue();
                else remaining = null;
                if (currentPosition === info.getNewPosition()) break;
                currentPosition = info.getNewPosition();
            }while (true);
            return buff.toString();
        }
        isStillNumeric(pos) {
            // It's numeric if it still has 7 positions
            // and one of the first 4 bits is "1".
            if (pos + 7 > this.information.getSize()) return pos + 4 <= this.information.getSize();
            for(let i = pos; i < pos + 3; ++i){
                if (this.information.get(i)) return true;
            }
            return this.information.get(pos + 3);
        }
        decodeNumeric(pos) {
            if (pos + 7 > this.information.getSize()) {
                let numeric = this.extractNumericValueFromBitArray(pos, 4);
                if (numeric === 0) return new DecodedNumeric(this.information.getSize(), DecodedNumeric.FNC1, DecodedNumeric.FNC1);
                return new DecodedNumeric(this.information.getSize(), numeric - 1, DecodedNumeric.FNC1);
            }
            let numeric = this.extractNumericValueFromBitArray(pos, 7);
            let digit1 = (numeric - 8) / 11;
            let digit2 = (numeric - 8) % 11;
            return new DecodedNumeric(pos + 7, digit1, digit2);
        }
        extractNumericValueFromBitArray(pos, bits) {
            return GeneralAppIdDecoder.extractNumericValueFromBitArray(this.information, pos, bits);
        }
        static extractNumericValueFromBitArray(information, pos, bits) {
            let value = 0;
            for(let i = 0; i < bits; ++i)if (information.get(pos + i)) value |= 1 << bits - i - 1;
            return value;
        }
        decodeGeneralPurposeField(pos, remaining) {
            // this.buffer.setLength(0);
            this.buffer.setLengthToZero();
            if (remaining != null) this.buffer.append(remaining);
            this.current.setPosition(pos);
            let lastDecoded = this.parseBlocks();
            if (lastDecoded != null && lastDecoded.isRemaining()) return new DecodedInformation(this.current.getPosition(), this.buffer.toString(), lastDecoded.getRemainingValue());
            return new DecodedInformation(this.current.getPosition(), this.buffer.toString());
        }
        parseBlocks() {
            let isFinished;
            let result;
            do {
                let initialPosition = this.current.getPosition();
                if (this.current.isAlpha()) {
                    result = this.parseAlphaBlock();
                    isFinished = result.isFinished();
                } else if (this.current.isIsoIec646()) {
                    result = this.parseIsoIec646Block();
                    isFinished = result.isFinished();
                } else {
                    result = this.parseNumericBlock();
                    isFinished = result.isFinished();
                }
                let positionChanged = initialPosition !== this.current.getPosition();
                if (!positionChanged && !isFinished) break;
            }while (!isFinished);
            return result.getDecodedInformation();
        }
        parseNumericBlock() {
            while(this.isStillNumeric(this.current.getPosition())){
                let numeric = this.decodeNumeric(this.current.getPosition());
                this.current.setPosition(numeric.getNewPosition());
                if (numeric.isFirstDigitFNC1()) {
                    let information;
                    if (numeric.isSecondDigitFNC1()) information = new DecodedInformation(this.current.getPosition(), this.buffer.toString());
                    else information = new DecodedInformation(this.current.getPosition(), this.buffer.toString(), numeric.getSecondDigit());
                    return new BlockParsedResult(true, information);
                }
                this.buffer.append(numeric.getFirstDigit());
                if (numeric.isSecondDigitFNC1()) {
                    let information = new DecodedInformation(this.current.getPosition(), this.buffer.toString());
                    return new BlockParsedResult(true, information);
                }
                this.buffer.append(numeric.getSecondDigit());
            }
            if (this.isNumericToAlphaNumericLatch(this.current.getPosition())) {
                this.current.setAlpha();
                this.current.incrementPosition(4);
            }
            return new BlockParsedResult(false);
        }
        parseIsoIec646Block() {
            while(this.isStillIsoIec646(this.current.getPosition())){
                let iso = this.decodeIsoIec646(this.current.getPosition());
                this.current.setPosition(iso.getNewPosition());
                if (iso.isFNC1()) {
                    let information = new DecodedInformation(this.current.getPosition(), this.buffer.toString());
                    return new BlockParsedResult(true, information);
                }
                this.buffer.append(iso.getValue());
            }
            if (this.isAlphaOr646ToNumericLatch(this.current.getPosition())) {
                this.current.incrementPosition(3);
                this.current.setNumeric();
            } else if (this.isAlphaTo646ToAlphaLatch(this.current.getPosition())) {
                if (this.current.getPosition() + 5 < this.information.getSize()) this.current.incrementPosition(5);
                else this.current.setPosition(this.information.getSize());
                this.current.setAlpha();
            }
            return new BlockParsedResult(false);
        }
        parseAlphaBlock() {
            while(this.isStillAlpha(this.current.getPosition())){
                let alpha = this.decodeAlphanumeric(this.current.getPosition());
                this.current.setPosition(alpha.getNewPosition());
                if (alpha.isFNC1()) {
                    let information = new DecodedInformation(this.current.getPosition(), this.buffer.toString());
                    return new BlockParsedResult(true, information); // end of the char block
                }
                this.buffer.append(alpha.getValue());
            }
            if (this.isAlphaOr646ToNumericLatch(this.current.getPosition())) {
                this.current.incrementPosition(3);
                this.current.setNumeric();
            } else if (this.isAlphaTo646ToAlphaLatch(this.current.getPosition())) {
                if (this.current.getPosition() + 5 < this.information.getSize()) this.current.incrementPosition(5);
                else this.current.setPosition(this.information.getSize());
                this.current.setIsoIec646();
            }
            return new BlockParsedResult(false);
        }
        isStillIsoIec646(pos) {
            if (pos + 5 > this.information.getSize()) return false;
            let fiveBitValue = this.extractNumericValueFromBitArray(pos, 5);
            if (fiveBitValue >= 5 && fiveBitValue < 16) return true;
            if (pos + 7 > this.information.getSize()) return false;
            let sevenBitValue = this.extractNumericValueFromBitArray(pos, 7);
            if (sevenBitValue >= 64 && sevenBitValue < 116) return true;
            if (pos + 8 > this.information.getSize()) return false;
            let eightBitValue = this.extractNumericValueFromBitArray(pos, 8);
            return eightBitValue >= 232 && eightBitValue < 253;
        }
        decodeIsoIec646(pos) {
            let fiveBitValue = this.extractNumericValueFromBitArray(pos, 5);
            if (fiveBitValue === 15) return new DecodedChar(pos + 5, DecodedChar.FNC1);
            if (fiveBitValue >= 5 && fiveBitValue < 15) return new DecodedChar(pos + 5, '0' + (fiveBitValue - 5));
            let sevenBitValue = this.extractNumericValueFromBitArray(pos, 7);
            if (sevenBitValue >= 64 && sevenBitValue < 90) return new DecodedChar(pos + 7, '' + (sevenBitValue + 1));
            if (sevenBitValue >= 90 && sevenBitValue < 116) return new DecodedChar(pos + 7, '' + (sevenBitValue + 7));
            let eightBitValue = this.extractNumericValueFromBitArray(pos, 8);
            let c;
            switch(eightBitValue){
                case 232:
                    c = '!';
                    break;
                case 233:
                    c = '"';
                    break;
                case 234:
                    c = '%';
                    break;
                case 235:
                    c = '&';
                    break;
                case 236:
                    c = '\'';
                    break;
                case 237:
                    c = '(';
                    break;
                case 238:
                    c = ')';
                    break;
                case 239:
                    c = '*';
                    break;
                case 240:
                    c = '+';
                    break;
                case 241:
                    c = ',';
                    break;
                case 242:
                    c = '-';
                    break;
                case 243:
                    c = '.';
                    break;
                case 244:
                    c = '/';
                    break;
                case 245:
                    c = ':';
                    break;
                case 246:
                    c = ';';
                    break;
                case 247:
                    c = '<';
                    break;
                case 248:
                    c = '=';
                    break;
                case 249:
                    c = '>';
                    break;
                case 250:
                    c = '?';
                    break;
                case 251:
                    c = '_';
                    break;
                case 252:
                    c = ' ';
                    break;
                default:
                    throw new FormatException();
            }
            return new DecodedChar(pos + 8, c);
        }
        isStillAlpha(pos) {
            if (pos + 5 > this.information.getSize()) return false;
            // We now check if it's a valid 5-bit value (0..9 and FNC1)
            let fiveBitValue = this.extractNumericValueFromBitArray(pos, 5);
            if (fiveBitValue >= 5 && fiveBitValue < 16) return true;
            if (pos + 6 > this.information.getSize()) return false;
            let sixBitValue = this.extractNumericValueFromBitArray(pos, 6);
            return sixBitValue >= 16 && sixBitValue < 63; // 63 not included
        }
        decodeAlphanumeric(pos) {
            let fiveBitValue = this.extractNumericValueFromBitArray(pos, 5);
            if (fiveBitValue === 15) return new DecodedChar(pos + 5, DecodedChar.FNC1);
            if (fiveBitValue >= 5 && fiveBitValue < 15) return new DecodedChar(pos + 5, '0' + (fiveBitValue - 5));
            let sixBitValue = this.extractNumericValueFromBitArray(pos, 6);
            if (sixBitValue >= 32 && sixBitValue < 58) return new DecodedChar(pos + 6, '' + (sixBitValue + 33));
            let c;
            switch(sixBitValue){
                case 58:
                    c = '*';
                    break;
                case 59:
                    c = ',';
                    break;
                case 60:
                    c = '-';
                    break;
                case 61:
                    c = '.';
                    break;
                case 62:
                    c = '/';
                    break;
                default:
                    throw new IllegalStateException('Decoding invalid alphanumeric value: ' + sixBitValue);
            }
            return new DecodedChar(pos + 6, c);
        }
        isAlphaTo646ToAlphaLatch(pos) {
            if (pos + 1 > this.information.getSize()) return false;
            for(let i = 0; i < 5 && i + pos < this.information.getSize(); ++i){
                if (i === 2) {
                    if (!this.information.get(pos + 2)) return false;
                } else if (this.information.get(pos + i)) return false;
            }
            return true;
        }
        isAlphaOr646ToNumericLatch(pos) {
            // Next is alphanumeric if there are 3 positions and they are all zeros
            if (pos + 3 > this.information.getSize()) return false;
            for(let i = pos; i < pos + 3; ++i){
                if (this.information.get(i)) return false;
            }
            return true;
        }
        isNumericToAlphaNumericLatch(pos) {
            // Next is alphanumeric if there are 4 positions and they are all zeros, or
            // if there is a subset of this just before the end of the symbol
            if (pos + 1 > this.information.getSize()) return false;
            for(let i = 0; i < 4 && i + pos < this.information.getSize(); ++i){
                if (this.information.get(pos + i)) return false;
            }
            return true;
        }
    }
    class AbstractExpandedDecoder {
        constructor(information){
            this.information = information;
            this.generalDecoder = new GeneralAppIdDecoder(information);
        }
        getInformation() {
            return this.information;
        }
        getGeneralDecoder() {
            return this.generalDecoder;
        }
    }
    class AI01decoder extends AbstractExpandedDecoder {
        constructor(information){
            super(information);
        }
        encodeCompressedGtin(buf, currentPos) {
            buf.append('(01)');
            let initialPosition = buf.length();
            buf.append('9');
            this.encodeCompressedGtinWithoutAI(buf, currentPos, initialPosition);
        }
        encodeCompressedGtinWithoutAI(buf, currentPos, initialBufferPosition) {
            for(let i = 0; i < 4; ++i){
                let currentBlock = this.getGeneralDecoder().extractNumericValueFromBitArray(currentPos + 10 * i, 10);
                if (currentBlock / 100 === 0) buf.append('0');
                if (currentBlock / 10 === 0) buf.append('0');
                buf.append(currentBlock);
            }
            AI01decoder.appendCheckDigit(buf, initialBufferPosition);
        }
        static appendCheckDigit(buf, currentPos) {
            let checkDigit = 0;
            for(let i = 0; i < 13; i++){
                // let digit = buf.charAt(i + currentPos) - '0';
                // To be checked
                let digit = buf.charAt(i + currentPos).charCodeAt(0) - '0'.charCodeAt(0);
                checkDigit += (i & 0x01) === 0 ? 3 * digit : digit;
            }
            checkDigit = 10 - checkDigit % 10;
            if (checkDigit === 10) checkDigit = 0;
            buf.append(checkDigit);
        }
    }
    AI01decoder.GTIN_SIZE = 40;
    class AI01AndOtherAIs extends AI01decoder {
        // the second one is the encodation method, and the other two are for the variable length
        constructor(information){
            super(information);
        }
        parseInformation() {
            let buff = new StringBuilder();
            buff.append('(01)');
            let initialGtinPosition = buff.length();
            let firstGtinDigit = this.getGeneralDecoder().extractNumericValueFromBitArray(AI01AndOtherAIs.HEADER_SIZE, 4);
            buff.append(firstGtinDigit);
            this.encodeCompressedGtinWithoutAI(buff, AI01AndOtherAIs.HEADER_SIZE + 4, initialGtinPosition);
            return this.getGeneralDecoder().decodeAllCodes(buff, AI01AndOtherAIs.HEADER_SIZE + 44);
        }
    }
    AI01AndOtherAIs.HEADER_SIZE = 4; // first bit encodes the linkage flag,
    class AnyAIDecoder extends AbstractExpandedDecoder {
        constructor(information){
            super(information);
        }
        parseInformation() {
            let buf = new StringBuilder();
            return this.getGeneralDecoder().decodeAllCodes(buf, AnyAIDecoder.HEADER_SIZE);
        }
    }
    AnyAIDecoder.HEADER_SIZE = 5;
    class AI01weightDecoder extends AI01decoder {
        constructor(information){
            super(information);
        }
        encodeCompressedWeight(buf, currentPos, weightSize) {
            let originalWeightNumeric = this.getGeneralDecoder().extractNumericValueFromBitArray(currentPos, weightSize);
            this.addWeightCode(buf, originalWeightNumeric);
            let weightNumeric = this.checkWeight(originalWeightNumeric);
            let currentDivisor = 100000;
            for(let i = 0; i < 5; ++i){
                if (weightNumeric / currentDivisor === 0) buf.append('0');
                currentDivisor /= 10;
            }
            buf.append(weightNumeric);
        }
    }
    class AI013x0xDecoder extends AI01weightDecoder {
        constructor(information){
            super(information);
        }
        parseInformation() {
            if (this.getInformation().getSize() != AI013x0xDecoder.HEADER_SIZE + AI01weightDecoder.GTIN_SIZE + AI013x0xDecoder.WEIGHT_SIZE) throw new NotFoundException();
            let buf = new StringBuilder();
            this.encodeCompressedGtin(buf, AI013x0xDecoder.HEADER_SIZE);
            this.encodeCompressedWeight(buf, AI013x0xDecoder.HEADER_SIZE + AI01weightDecoder.GTIN_SIZE, AI013x0xDecoder.WEIGHT_SIZE);
            return buf.toString();
        }
    }
    AI013x0xDecoder.HEADER_SIZE = 5;
    AI013x0xDecoder.WEIGHT_SIZE = 15;
    class AI013103decoder extends AI013x0xDecoder {
        constructor(information){
            super(information);
        }
        addWeightCode(buf, weight) {
            buf.append('(3103)');
        }
        checkWeight(weight) {
            return weight;
        }
    }
    class AI01320xDecoder extends AI013x0xDecoder {
        constructor(information){
            super(information);
        }
        addWeightCode(buf, weight) {
            if (weight < 10000) buf.append('(3202)');
            else buf.append('(3203)');
        }
        checkWeight(weight) {
            if (weight < 10000) return weight;
            return weight - 10000;
        }
    }
    class AI01392xDecoder extends AI01decoder {
        constructor(information){
            super(information);
        }
        parseInformation() {
            if (this.getInformation().getSize() < AI01392xDecoder.HEADER_SIZE + AI01decoder.GTIN_SIZE) throw new NotFoundException();
            let buf = new StringBuilder();
            this.encodeCompressedGtin(buf, AI01392xDecoder.HEADER_SIZE);
            let lastAIdigit = this.getGeneralDecoder().extractNumericValueFromBitArray(AI01392xDecoder.HEADER_SIZE + AI01decoder.GTIN_SIZE, AI01392xDecoder.LAST_DIGIT_SIZE);
            buf.append('(392');
            buf.append(lastAIdigit);
            buf.append(')');
            let decodedInformation = this.getGeneralDecoder().decodeGeneralPurposeField(AI01392xDecoder.HEADER_SIZE + AI01decoder.GTIN_SIZE + AI01392xDecoder.LAST_DIGIT_SIZE, null);
            buf.append(decodedInformation.getNewString());
            return buf.toString();
        }
    }
    AI01392xDecoder.HEADER_SIZE = 8;
    AI01392xDecoder.LAST_DIGIT_SIZE = 2;
    class AI01393xDecoder extends AI01decoder {
        constructor(information){
            super(information);
        }
        parseInformation() {
            if (this.getInformation().getSize() < AI01393xDecoder.HEADER_SIZE + AI01decoder.GTIN_SIZE) throw new NotFoundException();
            let buf = new StringBuilder();
            this.encodeCompressedGtin(buf, AI01393xDecoder.HEADER_SIZE);
            let lastAIdigit = this.getGeneralDecoder().extractNumericValueFromBitArray(AI01393xDecoder.HEADER_SIZE + AI01decoder.GTIN_SIZE, AI01393xDecoder.LAST_DIGIT_SIZE);
            buf.append('(393');
            buf.append(lastAIdigit);
            buf.append(')');
            let firstThreeDigits = this.getGeneralDecoder().extractNumericValueFromBitArray(AI01393xDecoder.HEADER_SIZE + AI01decoder.GTIN_SIZE + AI01393xDecoder.LAST_DIGIT_SIZE, AI01393xDecoder.FIRST_THREE_DIGITS_SIZE);
            if (firstThreeDigits / 100 == 0) buf.append('0');
            if (firstThreeDigits / 10 == 0) buf.append('0');
            buf.append(firstThreeDigits);
            let generalInformation = this.getGeneralDecoder().decodeGeneralPurposeField(AI01393xDecoder.HEADER_SIZE + AI01decoder.GTIN_SIZE + AI01393xDecoder.LAST_DIGIT_SIZE + AI01393xDecoder.FIRST_THREE_DIGITS_SIZE, null);
            buf.append(generalInformation.getNewString());
            return buf.toString();
        }
    }
    AI01393xDecoder.HEADER_SIZE = 8;
    AI01393xDecoder.LAST_DIGIT_SIZE = 2;
    AI01393xDecoder.FIRST_THREE_DIGITS_SIZE = 10;
    class AI013x0x1xDecoder extends AI01weightDecoder {
        constructor(information, firstAIdigits, dateCode){
            super(information);
            this.dateCode = dateCode;
            this.firstAIdigits = firstAIdigits;
        }
        parseInformation() {
            if (this.getInformation().getSize() != AI013x0x1xDecoder.HEADER_SIZE + AI013x0x1xDecoder.GTIN_SIZE + AI013x0x1xDecoder.WEIGHT_SIZE + AI013x0x1xDecoder.DATE_SIZE) throw new NotFoundException();
            let buf = new StringBuilder();
            this.encodeCompressedGtin(buf, AI013x0x1xDecoder.HEADER_SIZE);
            this.encodeCompressedWeight(buf, AI013x0x1xDecoder.HEADER_SIZE + AI013x0x1xDecoder.GTIN_SIZE, AI013x0x1xDecoder.WEIGHT_SIZE);
            this.encodeCompressedDate(buf, AI013x0x1xDecoder.HEADER_SIZE + AI013x0x1xDecoder.GTIN_SIZE + AI013x0x1xDecoder.WEIGHT_SIZE);
            return buf.toString();
        }
        encodeCompressedDate(buf, currentPos) {
            let numericDate = this.getGeneralDecoder().extractNumericValueFromBitArray(currentPos, AI013x0x1xDecoder.DATE_SIZE);
            if (numericDate == 38400) return;
            buf.append('(');
            buf.append(this.dateCode);
            buf.append(')');
            let day = numericDate % 32;
            numericDate /= 32;
            let month = numericDate % 12 + 1;
            numericDate /= 12;
            let year = numericDate;
            if (year / 10 == 0) buf.append('0');
            buf.append(year);
            if (month / 10 == 0) buf.append('0');
            buf.append(month);
            if (day / 10 == 0) buf.append('0');
            buf.append(day);
        }
        addWeightCode(buf, weight) {
            buf.append('(');
            buf.append(this.firstAIdigits);
            buf.append(weight / 100000);
            buf.append(')');
        }
        checkWeight(weight) {
            return weight % 100000;
        }
    }
    AI013x0x1xDecoder.HEADER_SIZE = 8;
    AI013x0x1xDecoder.WEIGHT_SIZE = 20;
    AI013x0x1xDecoder.DATE_SIZE = 16;
    function createDecoder(information) {
        try {
            if (information.get(1)) return new AI01AndOtherAIs(information);
            if (!information.get(2)) return new AnyAIDecoder(information);
            let fourBitEncodationMethod = GeneralAppIdDecoder.extractNumericValueFromBitArray(information, 1, 4);
            switch(fourBitEncodationMethod){
                case 4:
                    return new AI013103decoder(information);
                case 5:
                    return new AI01320xDecoder(information);
            }
            let fiveBitEncodationMethod = GeneralAppIdDecoder.extractNumericValueFromBitArray(information, 1, 5);
            switch(fiveBitEncodationMethod){
                case 12:
                    return new AI01392xDecoder(information);
                case 13:
                    return new AI01393xDecoder(information);
            }
            let sevenBitEncodationMethod = GeneralAppIdDecoder.extractNumericValueFromBitArray(information, 1, 7);
            switch(sevenBitEncodationMethod){
                case 56:
                    return new AI013x0x1xDecoder(information, '310', '11');
                case 57:
                    return new AI013x0x1xDecoder(information, '320', '11');
                case 58:
                    return new AI013x0x1xDecoder(information, '310', '13');
                case 59:
                    return new AI013x0x1xDecoder(information, '320', '13');
                case 60:
                    return new AI013x0x1xDecoder(information, '310', '15');
                case 61:
                    return new AI013x0x1xDecoder(information, '320', '15');
                case 62:
                    return new AI013x0x1xDecoder(information, '310', '17');
                case 63:
                    return new AI013x0x1xDecoder(information, '320', '17');
            }
        } catch (e) {
            console.log(e);
            throw new IllegalStateException('unknown decoder: ' + information);
        }
    }
    class ExpandedPair {
        constructor(leftChar, rightChar, finderPatter, mayBeLast){
            this.leftchar = leftChar;
            this.rightchar = rightChar;
            this.finderpattern = finderPatter;
            this.maybeLast = mayBeLast;
        }
        mayBeLast() {
            return this.maybeLast;
        }
        getLeftChar() {
            return this.leftchar;
        }
        getRightChar() {
            return this.rightchar;
        }
        getFinderPattern() {
            return this.finderpattern;
        }
        mustBeLast() {
            return this.rightchar == null;
        }
        toString() {
            return '[ ' + this.leftchar + ', ' + this.rightchar + ' : ' + (this.finderpattern == null ? 'null' : this.finderpattern.getValue()) + ' ]';
        }
        static equals(o1, o2) {
            if (!(o1 instanceof ExpandedPair)) return false;
            return ExpandedPair.equalsOrNull(o1.leftchar, o2.leftchar) && ExpandedPair.equalsOrNull(o1.rightchar, o2.rightchar) && ExpandedPair.equalsOrNull(o1.finderpattern, o2.finderpattern);
        }
        static equalsOrNull(o1, o2) {
            return o1 === null ? o2 === null : ExpandedPair.equals(o1, o2);
        }
        hashCode() {
            // return ExpandedPair.hashNotNull(leftChar) ^ hashNotNull(rightChar) ^ hashNotNull(finderPattern);
            let value = this.leftchar.getValue() ^ this.rightchar.getValue() ^ this.finderpattern.getValue();
            return value;
        }
    }
    class ExpandedRow {
        constructor(pairs, rowNumber, wasReversed){
            this.pairs = pairs;
            this.rowNumber = rowNumber;
            this.wasReversed = wasReversed;
        }
        getPairs() {
            return this.pairs;
        }
        getRowNumber() {
            return this.rowNumber;
        }
        isReversed() {
            return this.wasReversed;
        }
        // check implementation
        isEquivalent(otherPairs) {
            return this.checkEqualitity(this, otherPairs);
        }
        // @Override
        toString() {
            return '{ ' + this.pairs + ' }';
        }
        /**
         * Two rows are equal if they contain the same pairs in the same order.
         */ // @Override
        // check implementation
        equals(o1, o2) {
            if (!(o1 instanceof ExpandedRow)) return false;
            return this.checkEqualitity(o1, o2) && o1.wasReversed === o2.wasReversed;
        }
        checkEqualitity(pair1, pair2) {
            if (!pair1 || !pair2) return;
            let result;
            pair1.forEach((e1, i)=>{
                pair2.forEach((e2)=>{
                    if (e1.getLeftChar().getValue() === e2.getLeftChar().getValue() && e1.getRightChar().getValue() === e2.getRightChar().getValue() && e1.getFinderPatter().getValue() === e2.getFinderPatter().getValue()) result = true;
                });
            });
            return result;
        }
    }
    // import java.util.ArrayList;
    // import java.util.Iterator;
    // import java.util.List;
    // import java.util.Map;
    // import java.util.Collections;
    class RSSExpandedReader extends AbstractRSSReader {
        constructor(verbose){
            super(...arguments);
            this.pairs = new Array(RSSExpandedReader.MAX_PAIRS);
            this.rows = new Array();
            this.startEnd = [
                2
            ];
            this.verbose = verbose === true;
        }
        decodeRow(rowNumber, row, hints) {
            // Rows can start with even pattern in case in prev rows there where odd number of patters.
            // So lets try twice
            // this.pairs.clear();
            this.pairs.length = 0;
            this.startFromEven = false;
            try {
                return RSSExpandedReader.constructResult(this.decodeRow2pairs(rowNumber, row));
            } catch (e) {
                // OK
                if (this.verbose) console.log(e);
            }
            this.pairs.length = 0;
            this.startFromEven = true;
            return RSSExpandedReader.constructResult(this.decodeRow2pairs(rowNumber, row));
        }
        reset() {
            this.pairs.length = 0;
            this.rows.length = 0;
        }
        // Not private for testing
        decodeRow2pairs(rowNumber, row) {
            let done = false;
            while(!done)try {
                this.pairs.push(this.retrieveNextPair(row, this.pairs, rowNumber));
            } catch (error) {
                if (error instanceof NotFoundException) {
                    if (!this.pairs.length) throw new NotFoundException();
                    // exit this loop when retrieveNextPair() fails and throws
                    done = true;
                }
            }
            // TODO: verify sequence of finder patterns as in checkPairSequence()
            if (this.checkChecksum()) return this.pairs;
            let tryStackedDecode;
            if (this.rows.length) tryStackedDecode = true;
            else tryStackedDecode = false;
            // let tryStackedDecode = !this.rows.isEmpty();
            this.storeRow(rowNumber, false); // TODO: deal with reversed rows
            if (tryStackedDecode) {
                // When the image is 180-rotated, then rows are sorted in wrong direction.
                // Try twice with both the directions.
                let ps = this.checkRowsBoolean(false);
                if (ps != null) return ps;
                ps = this.checkRowsBoolean(true);
                if (ps != null) return ps;
            }
            throw new NotFoundException();
        }
        // Need to Verify
        checkRowsBoolean(reverse) {
            // Limit number of rows we are checking
            // We use recursive algorithm with pure complexity and don't want it to take forever
            // Stacked barcode can have up to 11 rows, so 25 seems reasonable enough
            if (this.rows.length > 25) {
                this.rows.length = 0; // We will never have a chance to get result, so clear it
                return null;
            }
            this.pairs.length = 0;
            if (reverse) this.rows = this.rows.reverse();
            let ps = null;
            try {
                ps = this.checkRows(new Array(), 0);
            } catch (e) {
                // OK
                if (this.verbose) console.log(e);
            }
            if (reverse) this.rows = this.rows.reverse();
            return ps;
        }
        // Try to construct a valid rows sequence
        // Recursion is used to implement backtracking
        checkRows(collectedRows, currentRow) {
            for(let i = currentRow; i < this.rows.length; i++){
                let row = this.rows[i];
                this.pairs.length = 0;
                for (let collectedRow of collectedRows)this.pairs.push(collectedRow.getPairs());
                this.pairs.push(row.getPairs());
                if (!RSSExpandedReader.isValidSequence(this.pairs)) continue;
                if (this.checkChecksum()) return this.pairs;
                let rs = new Array(collectedRows);
                rs.push(row);
                try {
                    // Recursion: try to add more rows
                    return this.checkRows(rs, i + 1);
                } catch (e) {
                    // We failed, try the next candidate
                    if (this.verbose) console.log(e);
                }
            }
            throw new NotFoundException();
        }
        // Whether the pairs form a valid find pattern sequence,
        // either complete or a prefix
        static isValidSequence(pairs) {
            for (let sequence of RSSExpandedReader.FINDER_PATTERN_SEQUENCES){
                if (pairs.length > sequence.length) continue;
                let stop = true;
                for(let j = 0; j < pairs.length; j++)if (pairs[j].getFinderPattern().getValue() != sequence[j]) {
                    stop = false;
                    break;
                }
                if (stop) return true;
            }
            return false;
        }
        storeRow(rowNumber, wasReversed) {
            // Discard if duplicate above or below; otherwise insert in order by row number.
            let insertPos = 0;
            let prevIsSame = false;
            let nextIsSame = false;
            while(insertPos < this.rows.length){
                let erow = this.rows[insertPos];
                if (erow.getRowNumber() > rowNumber) {
                    nextIsSame = erow.isEquivalent(this.pairs);
                    break;
                }
                prevIsSame = erow.isEquivalent(this.pairs);
                insertPos++;
            }
            if (nextIsSame || prevIsSame) return;
            // When the row was partially decoded (e.g. 2 pairs found instead of 3),
            // it will prevent us from detecting the barcode.
            // Try to merge partial rows
            // Check whether the row is part of an allready detected row
            if (RSSExpandedReader.isPartialRow(this.pairs, this.rows)) return;
            this.rows.push(insertPos, new ExpandedRow(this.pairs, rowNumber, wasReversed));
            this.removePartialRows(this.pairs, this.rows);
        }
        // Remove all the rows that contains only specified pairs
        removePartialRows(pairs, rows) {
            // for (Iterator<ExpandedRow> iterator = rows.iterator(); iterator.hasNext();) {
            //   ExpandedRow r = iterator.next();
            //   if (r.getPairs().size() == pairs.size()) {
            //     continue;
            //   }
            //   boolean allFound = true;
            //   for (ExpandedPair p : r.getPairs()) {
            //     boolean found = false;
            //     for (ExpandedPair pp : pairs) {
            //       if (p.equals(pp)) {
            //         found = true;
            //         break;
            //       }
            //     }
            //     if (!found) {
            //       allFound = false;
            //       break;
            //     }
            //   }
            //   if (allFound) {
            //     // 'pairs' contains all the pairs from the row 'r'
            //     iterator.remove();
            //   }
            // }
            for (let row of rows){
                if (row.getPairs().length === pairs.length) continue;
                for (let p of row.getPairs())for (let pp of pairs){
                    if (ExpandedPair.equals(p, pp)) break;
                }
            }
        }
        // Returns true when one of the rows already contains all the pairs
        static isPartialRow(pairs, rows) {
            for (let r of rows){
                let allFound = true;
                for (let p of pairs){
                    let found = false;
                    for (let pp of r.getPairs())if (p.equals(pp)) {
                        found = true;
                        break;
                    }
                    if (!found) {
                        allFound = false;
                        break;
                    }
                }
                if (allFound) // the row 'r' contain all the pairs from 'pairs'
                return true;
            }
            return false;
        }
        // Only used for unit testing
        getRows() {
            return this.rows;
        }
        // Not private for unit testing
        static constructResult(pairs) {
            let binary = BitArrayBuilder.buildBitArray(pairs);
            let decoder = createDecoder(binary);
            let resultingString = decoder.parseInformation();
            let firstPoints = pairs[0].getFinderPattern().getResultPoints();
            let lastPoints = pairs[pairs.length - 1].getFinderPattern().getResultPoints();
            let points = [
                firstPoints[0],
                firstPoints[1],
                lastPoints[0],
                lastPoints[1]
            ];
            return new Result(resultingString, null, null, points, BarcodeFormat$1.RSS_EXPANDED, null);
        }
        checkChecksum() {
            let firstPair = this.pairs.get(0);
            let checkCharacter = firstPair.getLeftChar();
            let firstCharacter = firstPair.getRightChar();
            if (firstCharacter == null) return false;
            let checksum = firstCharacter.getChecksumPortion();
            let s = 2;
            for(let i = 1; i < this.pairs.size(); ++i){
                let currentPair = this.pairs.get(i);
                checksum += currentPair.getLeftChar().getChecksumPortion();
                s++;
                let currentRightChar = currentPair.getRightChar();
                if (currentRightChar != null) {
                    checksum += currentRightChar.getChecksumPortion();
                    s++;
                }
            }
            checksum %= 211;
            let checkCharacterValue = 211 * (s - 4) + checksum;
            return checkCharacterValue == checkCharacter.getValue();
        }
        static getNextSecondBar(row, initialPos) {
            let currentPos;
            if (row.get(initialPos)) {
                currentPos = row.getNextUnset(initialPos);
                currentPos = row.getNextSet(currentPos);
            } else {
                currentPos = row.getNextSet(initialPos);
                currentPos = row.getNextUnset(currentPos);
            }
            return currentPos;
        }
        // not private for testing
        retrieveNextPair(row, previousPairs, rowNumber) {
            let isOddPattern = previousPairs.length % 2 == 0;
            if (this.startFromEven) isOddPattern = !isOddPattern;
            let pattern;
            let keepFinding = true;
            let forcedOffset = -1;
            do {
                this.findNextPair(row, previousPairs, forcedOffset);
                pattern = this.parseFoundFinderPattern(row, rowNumber, isOddPattern);
                if (pattern == null) forcedOffset = RSSExpandedReader.getNextSecondBar(row, this.startEnd[0]);
                else keepFinding = false;
            }while (keepFinding);
            // When stacked symbol is split over multiple rows, there's no way to guess if this pair can be last or not.
            // boolean mayBeLast = checkPairSequence(previousPairs, pattern);
            let leftChar = this.decodeDataCharacter(row, pattern, isOddPattern, true);
            if (!this.isEmptyPair(previousPairs) && previousPairs[previousPairs.length - 1].mustBeLast()) throw new NotFoundException();
            let rightChar;
            try {
                rightChar = this.decodeDataCharacter(row, pattern, isOddPattern, false);
            } catch (e) {
                rightChar = null;
                if (this.verbose) console.log(e);
            }
            return new ExpandedPair(leftChar, rightChar, pattern, true);
        }
        isEmptyPair(pairs) {
            if (pairs.length === 0) return true;
            return false;
        }
        findNextPair(row, previousPairs, forcedOffset) {
            let counters = this.getDecodeFinderCounters();
            counters[0] = 0;
            counters[1] = 0;
            counters[2] = 0;
            counters[3] = 0;
            let width = row.getSize();
            let rowOffset;
            if (forcedOffset >= 0) rowOffset = forcedOffset;
            else if (this.isEmptyPair(previousPairs)) rowOffset = 0;
            else {
                let lastPair = previousPairs[previousPairs.length - 1];
                rowOffset = lastPair.getFinderPattern().getStartEnd()[1];
            }
            let searchingEvenPair = previousPairs.length % 2 != 0;
            if (this.startFromEven) searchingEvenPair = !searchingEvenPair;
            let isWhite = false;
            while(rowOffset < width){
                isWhite = !row.get(rowOffset);
                if (!isWhite) break;
                rowOffset++;
            }
            let counterPosition = 0;
            let patternStart = rowOffset;
            for(let x = rowOffset; x < width; x++)if (row.get(x) != isWhite) counters[counterPosition]++;
            else {
                if (counterPosition == 3) {
                    if (searchingEvenPair) RSSExpandedReader.reverseCounters(counters);
                    if (RSSExpandedReader.isFinderPattern(counters)) {
                        this.startEnd[0] = patternStart;
                        this.startEnd[1] = x;
                        return;
                    }
                    if (searchingEvenPair) RSSExpandedReader.reverseCounters(counters);
                    patternStart += counters[0] + counters[1];
                    counters[0] = counters[2];
                    counters[1] = counters[3];
                    counters[2] = 0;
                    counters[3] = 0;
                    counterPosition--;
                } else counterPosition++;
                counters[counterPosition] = 1;
                isWhite = !isWhite;
            }
            throw new NotFoundException();
        }
        static reverseCounters(counters) {
            let length = counters.length;
            for(let i = 0; i < length / 2; ++i){
                let tmp = counters[i];
                counters[i] = counters[length - i - 1];
                counters[length - i - 1] = tmp;
            }
        }
        parseFoundFinderPattern(row, rowNumber, oddPattern) {
            // Actually we found elements 2-5.
            let firstCounter;
            let start;
            let end;
            if (oddPattern) {
                // If pattern number is odd, we need to locate element 1 *before* the current block.
                let firstElementStart = this.startEnd[0] - 1;
                // Locate element 1
                while(firstElementStart >= 0 && !row.get(firstElementStart))firstElementStart--;
                firstElementStart++;
                firstCounter = this.startEnd[0] - firstElementStart;
                start = firstElementStart;
                end = this.startEnd[1];
            } else {
                // If pattern number is even, the pattern is reversed, so we need to locate element 1 *after* the current block.
                start = this.startEnd[0];
                end = row.getNextUnset(this.startEnd[1] + 1);
                firstCounter = end - this.startEnd[1];
            }
            // Make 'counters' hold 1-4
            let counters = this.getDecodeFinderCounters();
            System.arraycopy(counters, 0, counters, 1, counters.length - 1);
            counters[0] = firstCounter;
            let value;
            try {
                value = this.parseFinderValue(counters, RSSExpandedReader.FINDER_PATTERNS);
            } catch (e) {
                return null;
            }
            // return new FinderPattern(value, new int[] { start, end }, start, end, rowNumber});
            return new FinderPattern(value, [
                start,
                end
            ], start, end, rowNumber);
        }
        decodeDataCharacter(row, pattern, isOddPattern, leftChar) {
            let counters = this.getDataCharacterCounters();
            for(let x = 0; x < counters.length; x++)counters[x] = 0;
            if (leftChar) RSSExpandedReader.recordPatternInReverse(row, pattern.getStartEnd()[0], counters);
            else {
                RSSExpandedReader.recordPattern(row, pattern.getStartEnd()[1], counters);
                // reverse it
                for(let i = 0, j = counters.length - 1; i < j; i++, j--){
                    let temp = counters[i];
                    counters[i] = counters[j];
                    counters[j] = temp;
                }
            } // counters[] has the pixels of the module
            let numModules = 17; // left and right data characters have all the same length
            let elementWidth = MathUtils.sum(new Int32Array(counters)) / numModules;
            // Sanity check: element width for pattern and the character should match
            let expectedElementWidth = (pattern.getStartEnd()[1] - pattern.getStartEnd()[0]) / 15.0;
            if (Math.abs(elementWidth - expectedElementWidth) / expectedElementWidth > 0.3) throw new NotFoundException();
            let oddCounts = this.getOddCounts();
            let evenCounts = this.getEvenCounts();
            let oddRoundingErrors = this.getOddRoundingErrors();
            let evenRoundingErrors = this.getEvenRoundingErrors();
            for(let i = 0; i < counters.length; i++){
                let value = 1.0 * counters[i] / elementWidth;
                let count = value + 0.5; // Round
                if (count < 1) {
                    if (value < 0.3) throw new NotFoundException();
                    count = 1;
                } else if (count > 8) {
                    if (value > 8.7) throw new NotFoundException();
                    count = 8;
                }
                let offset = i / 2;
                if ((i & 0x01) == 0) {
                    oddCounts[offset] = count;
                    oddRoundingErrors[offset] = value - count;
                } else {
                    evenCounts[offset] = count;
                    evenRoundingErrors[offset] = value - count;
                }
            }
            this.adjustOddEvenCounts(numModules);
            let weightRowNumber = 4 * pattern.getValue() + (isOddPattern ? 0 : 2) + (leftChar ? 0 : 1) - 1;
            let oddSum = 0;
            let oddChecksumPortion = 0;
            for(let i = oddCounts.length - 1; i >= 0; i--){
                if (RSSExpandedReader.isNotA1left(pattern, isOddPattern, leftChar)) {
                    let weight = RSSExpandedReader.WEIGHTS[weightRowNumber][2 * i];
                    oddChecksumPortion += oddCounts[i] * weight;
                }
                oddSum += oddCounts[i];
            }
            let evenChecksumPortion = 0;
            // int evenSum = 0;
            for(let i = evenCounts.length - 1; i >= 0; i--)if (RSSExpandedReader.isNotA1left(pattern, isOddPattern, leftChar)) {
                let weight = RSSExpandedReader.WEIGHTS[weightRowNumber][2 * i + 1];
                evenChecksumPortion += evenCounts[i] * weight;
            }
            let checksumPortion = oddChecksumPortion + evenChecksumPortion;
            if ((oddSum & 0x01) != 0 || oddSum > 13 || oddSum < 4) throw new NotFoundException();
            let group = (13 - oddSum) / 2;
            let oddWidest = RSSExpandedReader.SYMBOL_WIDEST[group];
            let evenWidest = 9 - oddWidest;
            let vOdd = RSSUtils.getRSSvalue(oddCounts, oddWidest, true);
            let vEven = RSSUtils.getRSSvalue(evenCounts, evenWidest, false);
            let tEven = RSSExpandedReader.EVEN_TOTAL_SUBSET[group];
            let gSum = RSSExpandedReader.GSUM[group];
            let value = vOdd * tEven + vEven + gSum;
            return new DataCharacter(value, checksumPortion);
        }
        static isNotA1left(pattern, isOddPattern, leftChar) {
            // A1: pattern.getValue is 0 (A), and it's an oddPattern, and it is a left char
            return !(pattern.getValue() == 0 && isOddPattern && leftChar);
        }
        adjustOddEvenCounts(numModules) {
            let oddSum = MathUtils.sum(new Int32Array(this.getOddCounts()));
            let evenSum = MathUtils.sum(new Int32Array(this.getEvenCounts()));
            let incrementOdd = false;
            let decrementOdd = false;
            if (oddSum > 13) decrementOdd = true;
            else if (oddSum < 4) incrementOdd = true;
            let incrementEven = false;
            let decrementEven = false;
            if (evenSum > 13) decrementEven = true;
            else if (evenSum < 4) incrementEven = true;
            let mismatch = oddSum + evenSum - numModules;
            let oddParityBad = (oddSum & 0x01) == 1;
            let evenParityBad = (evenSum & 0x01) == 0;
            if (mismatch == 1) {
                if (oddParityBad) {
                    if (evenParityBad) throw new NotFoundException();
                    decrementOdd = true;
                } else {
                    if (!evenParityBad) throw new NotFoundException();
                    decrementEven = true;
                }
            } else if (mismatch == -1) {
                if (oddParityBad) {
                    if (evenParityBad) throw new NotFoundException();
                    incrementOdd = true;
                } else {
                    if (!evenParityBad) throw new NotFoundException();
                    incrementEven = true;
                }
            } else if (mismatch == 0) {
                if (oddParityBad) {
                    if (!evenParityBad) throw new NotFoundException();
                    // Both bad
                    if (oddSum < evenSum) {
                        incrementOdd = true;
                        decrementEven = true;
                    } else {
                        decrementOdd = true;
                        incrementEven = true;
                    }
                } else {
                    if (evenParityBad) throw new NotFoundException();
                // Nothing to do!
                }
            } else throw new NotFoundException();
            if (incrementOdd) {
                if (decrementOdd) throw new NotFoundException();
                RSSExpandedReader.increment(this.getOddCounts(), this.getOddRoundingErrors());
            }
            if (decrementOdd) RSSExpandedReader.decrement(this.getOddCounts(), this.getOddRoundingErrors());
            if (incrementEven) {
                if (decrementEven) throw new NotFoundException();
                RSSExpandedReader.increment(this.getEvenCounts(), this.getOddRoundingErrors());
            }
            if (decrementEven) RSSExpandedReader.decrement(this.getEvenCounts(), this.getEvenRoundingErrors());
        }
    }
    RSSExpandedReader.SYMBOL_WIDEST = [
        7,
        5,
        4,
        3,
        1
    ];
    RSSExpandedReader.EVEN_TOTAL_SUBSET = [
        4,
        20,
        52,
        104,
        204
    ];
    RSSExpandedReader.GSUM = [
        0,
        348,
        1388,
        2948,
        3988
    ];
    RSSExpandedReader.FINDER_PATTERNS = [
        Int32Array.from([
            1,
            8,
            4,
            1
        ]),
        Int32Array.from([
            3,
            6,
            4,
            1
        ]),
        Int32Array.from([
            3,
            4,
            6,
            1
        ]),
        Int32Array.from([
            3,
            2,
            8,
            1
        ]),
        Int32Array.from([
            2,
            6,
            5,
            1
        ]),
        Int32Array.from([
            2,
            2,
            9,
            1
        ]) // F
    ];
    RSSExpandedReader.WEIGHTS = [
        [
            1,
            3,
            9,
            27,
            81,
            32,
            96,
            77
        ],
        [
            20,
            60,
            180,
            118,
            143,
            7,
            21,
            63
        ],
        [
            189,
            145,
            13,
            39,
            117,
            140,
            209,
            205
        ],
        [
            193,
            157,
            49,
            147,
            19,
            57,
            171,
            91
        ],
        [
            62,
            186,
            136,
            197,
            169,
            85,
            44,
            132
        ],
        [
            185,
            133,
            188,
            142,
            4,
            12,
            36,
            108
        ],
        [
            113,
            128,
            173,
            97,
            80,
            29,
            87,
            50
        ],
        [
            150,
            28,
            84,
            41,
            123,
            158,
            52,
            156
        ],
        [
            46,
            138,
            203,
            187,
            139,
            206,
            196,
            166
        ],
        [
            76,
            17,
            51,
            153,
            37,
            111,
            122,
            155
        ],
        [
            43,
            129,
            176,
            106,
            107,
            110,
            119,
            146
        ],
        [
            16,
            48,
            144,
            10,
            30,
            90,
            59,
            177
        ],
        [
            109,
            116,
            137,
            200,
            178,
            112,
            125,
            164
        ],
        [
            70,
            210,
            208,
            202,
            184,
            130,
            179,
            115
        ],
        [
            134,
            191,
            151,
            31,
            93,
            68,
            204,
            190
        ],
        [
            148,
            22,
            66,
            198,
            172,
            94,
            71,
            2
        ],
        [
            6,
            18,
            54,
            162,
            64,
            192,
            154,
            40
        ],
        [
            120,
            149,
            25,
            75,
            14,
            42,
            126,
            167
        ],
        [
            79,
            26,
            78,
            23,
            69,
            207,
            199,
            175
        ],
        [
            103,
            98,
            83,
            38,
            114,
            131,
            182,
            124
        ],
        [
            161,
            61,
            183,
            127,
            170,
            88,
            53,
            159
        ],
        [
            55,
            165,
            73,
            8,
            24,
            72,
            5,
            15
        ],
        [
            45,
            135,
            194,
            160,
            58,
            174,
            100,
            89
        ]
    ];
    RSSExpandedReader.FINDER_PAT_A = 0;
    RSSExpandedReader.FINDER_PAT_B = 1;
    RSSExpandedReader.FINDER_PAT_C = 2;
    RSSExpandedReader.FINDER_PAT_D = 3;
    RSSExpandedReader.FINDER_PAT_E = 4;
    RSSExpandedReader.FINDER_PAT_F = 5;
    RSSExpandedReader.FINDER_PATTERN_SEQUENCES = [
        [
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_A
        ],
        [
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_B
        ],
        [
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_C,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_D
        ],
        [
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_E,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_D,
            RSSExpandedReader.FINDER_PAT_C
        ],
        [
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_E,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_D,
            RSSExpandedReader.FINDER_PAT_D,
            RSSExpandedReader.FINDER_PAT_F
        ],
        [
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_E,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_D,
            RSSExpandedReader.FINDER_PAT_E,
            RSSExpandedReader.FINDER_PAT_F,
            RSSExpandedReader.FINDER_PAT_F
        ],
        [
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_C,
            RSSExpandedReader.FINDER_PAT_C,
            RSSExpandedReader.FINDER_PAT_D,
            RSSExpandedReader.FINDER_PAT_D
        ],
        [
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_C,
            RSSExpandedReader.FINDER_PAT_C,
            RSSExpandedReader.FINDER_PAT_D,
            RSSExpandedReader.FINDER_PAT_E,
            RSSExpandedReader.FINDER_PAT_E
        ],
        [
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_C,
            RSSExpandedReader.FINDER_PAT_C,
            RSSExpandedReader.FINDER_PAT_D,
            RSSExpandedReader.FINDER_PAT_E,
            RSSExpandedReader.FINDER_PAT_F,
            RSSExpandedReader.FINDER_PAT_F
        ],
        [
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_C,
            RSSExpandedReader.FINDER_PAT_D,
            RSSExpandedReader.FINDER_PAT_D,
            RSSExpandedReader.FINDER_PAT_E,
            RSSExpandedReader.FINDER_PAT_E,
            RSSExpandedReader.FINDER_PAT_F,
            RSSExpandedReader.FINDER_PAT_F
        ]
    ];
    RSSExpandedReader.MAX_PAIRS = 11;
    class Pair extends DataCharacter {
        constructor(value, checksumPortion, finderPattern){
            super(value, checksumPortion);
            this.count = 0;
            this.finderPattern = finderPattern;
        }
        getFinderPattern() {
            return this.finderPattern;
        }
        getCount() {
            return this.count;
        }
        incrementCount() {
            this.count++;
        }
    }
    class RSS14Reader extends AbstractRSSReader {
        constructor(){
            super(...arguments);
            this.possibleLeftPairs = [];
            this.possibleRightPairs = [];
        }
        decodeRow(rowNumber, row, hints) {
            const leftPair = this.decodePair(row, false, rowNumber, hints);
            RSS14Reader.addOrTally(this.possibleLeftPairs, leftPair);
            row.reverse();
            let rightPair = this.decodePair(row, true, rowNumber, hints);
            RSS14Reader.addOrTally(this.possibleRightPairs, rightPair);
            row.reverse();
            for (let left of this.possibleLeftPairs){
                if (left.getCount() > 1) for (let right of this.possibleRightPairs){
                    if (right.getCount() > 1 && RSS14Reader.checkChecksum(left, right)) return RSS14Reader.constructResult(left, right);
                }
            }
            throw new NotFoundException();
        }
        static addOrTally(possiblePairs, pair) {
            if (pair == null) return;
            let found = false;
            for (let other of possiblePairs)if (other.getValue() === pair.getValue()) {
                other.incrementCount();
                found = true;
                break;
            }
            if (!found) possiblePairs.push(pair);
        }
        reset() {
            this.possibleLeftPairs.length = 0;
            this.possibleRightPairs.length = 0;
        }
        static constructResult(leftPair, rightPair) {
            let symbolValue = 4537077 * leftPair.getValue() + rightPair.getValue();
            let text = new String(symbolValue).toString();
            let buffer = new StringBuilder();
            for(let i = 13 - text.length; i > 0; i--)buffer.append('0');
            buffer.append(text);
            let checkDigit = 0;
            for(let i = 0; i < 13; i++){
                let digit = buffer.charAt(i).charCodeAt(0) - '0'.charCodeAt(0);
                checkDigit += (i & 0x01) === 0 ? 3 * digit : digit;
            }
            checkDigit = 10 - checkDigit % 10;
            if (checkDigit === 10) checkDigit = 0;
            buffer.append(checkDigit.toString());
            let leftPoints = leftPair.getFinderPattern().getResultPoints();
            let rightPoints = rightPair.getFinderPattern().getResultPoints();
            return new Result(buffer.toString(), null, 0, [
                leftPoints[0],
                leftPoints[1],
                rightPoints[0],
                rightPoints[1]
            ], BarcodeFormat$1.RSS_14, new Date().getTime());
        }
        static checkChecksum(leftPair, rightPair) {
            let checkValue = (leftPair.getChecksumPortion() + 16 * rightPair.getChecksumPortion()) % 79;
            let targetCheckValue = 9 * leftPair.getFinderPattern().getValue() + rightPair.getFinderPattern().getValue();
            if (targetCheckValue > 72) targetCheckValue--;
            if (targetCheckValue > 8) targetCheckValue--;
            return checkValue === targetCheckValue;
        }
        decodePair(row, right, rowNumber, hints) {
            try {
                let startEnd = this.findFinderPattern(row, right);
                let pattern = this.parseFoundFinderPattern(row, rowNumber, right, startEnd);
                let resultPointCallback = hints == null ? null : hints.get(DecodeHintType$1.NEED_RESULT_POINT_CALLBACK);
                if (resultPointCallback != null) {
                    let center = (startEnd[0] + startEnd[1]) / 2.0;
                    if (right) // row is actually reversed
                    center = row.getSize() - 1 - center;
                    resultPointCallback.foundPossibleResultPoint(new ResultPoint(center, rowNumber));
                }
                let outside = this.decodeDataCharacter(row, pattern, true);
                let inside = this.decodeDataCharacter(row, pattern, false);
                return new Pair(1597 * outside.getValue() + inside.getValue(), outside.getChecksumPortion() + 4 * inside.getChecksumPortion(), pattern);
            } catch (err) {
                return null;
            }
        }
        decodeDataCharacter(row, pattern, outsideChar) {
            let counters = this.getDataCharacterCounters();
            for(let x = 0; x < counters.length; x++)counters[x] = 0;
            if (outsideChar) OneDReader.recordPatternInReverse(row, pattern.getStartEnd()[0], counters);
            else {
                OneDReader.recordPattern(row, pattern.getStartEnd()[1] + 1, counters);
                // reverse it
                for(let i = 0, j = counters.length - 1; i < j; i++, j--){
                    let temp = counters[i];
                    counters[i] = counters[j];
                    counters[j] = temp;
                }
            }
            let numModules = outsideChar ? 16 : 15;
            let elementWidth = MathUtils.sum(new Int32Array(counters)) / numModules;
            let oddCounts = this.getOddCounts();
            let evenCounts = this.getEvenCounts();
            let oddRoundingErrors = this.getOddRoundingErrors();
            let evenRoundingErrors = this.getEvenRoundingErrors();
            for(let i = 0; i < counters.length; i++){
                let value = counters[i] / elementWidth;
                let count = Math.floor(value + 0.5);
                if (count < 1) count = 1;
                else if (count > 8) count = 8;
                let offset = Math.floor(i / 2);
                if ((i & 0x01) === 0) {
                    oddCounts[offset] = count;
                    oddRoundingErrors[offset] = value - count;
                } else {
                    evenCounts[offset] = count;
                    evenRoundingErrors[offset] = value - count;
                }
            }
            this.adjustOddEvenCounts(outsideChar, numModules);
            let oddSum = 0;
            let oddChecksumPortion = 0;
            for(let i = oddCounts.length - 1; i >= 0; i--){
                oddChecksumPortion *= 9;
                oddChecksumPortion += oddCounts[i];
                oddSum += oddCounts[i];
            }
            let evenChecksumPortion = 0;
            let evenSum = 0;
            for(let i = evenCounts.length - 1; i >= 0; i--){
                evenChecksumPortion *= 9;
                evenChecksumPortion += evenCounts[i];
                evenSum += evenCounts[i];
            }
            let checksumPortion = oddChecksumPortion + 3 * evenChecksumPortion;
            if (outsideChar) {
                if ((oddSum & 0x01) !== 0 || oddSum > 12 || oddSum < 4) throw new NotFoundException();
                let group = (12 - oddSum) / 2;
                let oddWidest = RSS14Reader.OUTSIDE_ODD_WIDEST[group];
                let evenWidest = 9 - oddWidest;
                let vOdd = RSSUtils.getRSSvalue(oddCounts, oddWidest, false);
                let vEven = RSSUtils.getRSSvalue(evenCounts, evenWidest, true);
                let tEven = RSS14Reader.OUTSIDE_EVEN_TOTAL_SUBSET[group];
                let gSum = RSS14Reader.OUTSIDE_GSUM[group];
                return new DataCharacter(vOdd * tEven + vEven + gSum, checksumPortion);
            } else {
                if ((evenSum & 0x01) !== 0 || evenSum > 10 || evenSum < 4) throw new NotFoundException();
                let group = (10 - evenSum) / 2;
                let oddWidest = RSS14Reader.INSIDE_ODD_WIDEST[group];
                let evenWidest = 9 - oddWidest;
                let vOdd = RSSUtils.getRSSvalue(oddCounts, oddWidest, true);
                let vEven = RSSUtils.getRSSvalue(evenCounts, evenWidest, false);
                let tOdd = RSS14Reader.INSIDE_ODD_TOTAL_SUBSET[group];
                let gSum = RSS14Reader.INSIDE_GSUM[group];
                return new DataCharacter(vEven * tOdd + vOdd + gSum, checksumPortion);
            }
        }
        findFinderPattern(row, rightFinderPattern) {
            let counters = this.getDecodeFinderCounters();
            counters[0] = 0;
            counters[1] = 0;
            counters[2] = 0;
            counters[3] = 0;
            let width = row.getSize();
            let isWhite = false;
            let rowOffset = 0;
            while(rowOffset < width){
                isWhite = !row.get(rowOffset);
                if (rightFinderPattern === isWhite) break;
                rowOffset++;
            }
            let counterPosition = 0;
            let patternStart = rowOffset;
            for(let x = rowOffset; x < width; x++)if (row.get(x) !== isWhite) counters[counterPosition]++;
            else {
                if (counterPosition === 3) {
                    if (AbstractRSSReader.isFinderPattern(counters)) return [
                        patternStart,
                        x
                    ];
                    patternStart += counters[0] + counters[1];
                    counters[0] = counters[2];
                    counters[1] = counters[3];
                    counters[2] = 0;
                    counters[3] = 0;
                    counterPosition--;
                } else counterPosition++;
                counters[counterPosition] = 1;
                isWhite = !isWhite;
            }
            throw new NotFoundException();
        }
        parseFoundFinderPattern(row, rowNumber, right, startEnd) {
            // Actually we found elements 2-5
            let firstIsBlack = row.get(startEnd[0]);
            let firstElementStart = startEnd[0] - 1;
            // Locate element 1
            while(firstElementStart >= 0 && firstIsBlack !== row.get(firstElementStart))firstElementStart--;
            firstElementStart++;
            const firstCounter = startEnd[0] - firstElementStart;
            // Make 'counters' hold 1-4
            const counters = this.getDecodeFinderCounters();
            const copy = new Int32Array(counters.length);
            System.arraycopy(counters, 0, copy, 1, counters.length - 1);
            copy[0] = firstCounter;
            const value = this.parseFinderValue(copy, RSS14Reader.FINDER_PATTERNS);
            let start = firstElementStart;
            let end = startEnd[1];
            if (right) {
                // row is actually reversed
                start = row.getSize() - 1 - start;
                end = row.getSize() - 1 - end;
            }
            return new FinderPattern(value, [
                firstElementStart,
                startEnd[1]
            ], start, end, rowNumber);
        }
        adjustOddEvenCounts(outsideChar, numModules) {
            let oddSum = MathUtils.sum(new Int32Array(this.getOddCounts()));
            let evenSum = MathUtils.sum(new Int32Array(this.getEvenCounts()));
            let incrementOdd = false;
            let decrementOdd = false;
            let incrementEven = false;
            let decrementEven = false;
            if (outsideChar) {
                if (oddSum > 12) decrementOdd = true;
                else if (oddSum < 4) incrementOdd = true;
                if (evenSum > 12) decrementEven = true;
                else if (evenSum < 4) incrementEven = true;
            } else {
                if (oddSum > 11) decrementOdd = true;
                else if (oddSum < 5) incrementOdd = true;
                if (evenSum > 10) decrementEven = true;
                else if (evenSum < 4) incrementEven = true;
            }
            let mismatch = oddSum + evenSum - numModules;
            let oddParityBad = (oddSum & 0x01) === (outsideChar ? 1 : 0);
            let evenParityBad = (evenSum & 0x01) === 1;
            if (mismatch === 1) {
                if (oddParityBad) {
                    if (evenParityBad) throw new NotFoundException();
                    decrementOdd = true;
                } else {
                    if (!evenParityBad) throw new NotFoundException();
                    decrementEven = true;
                }
            } else if (mismatch === -1) {
                if (oddParityBad) {
                    if (evenParityBad) throw new NotFoundException();
                    incrementOdd = true;
                } else {
                    if (!evenParityBad) throw new NotFoundException();
                    incrementEven = true;
                }
            } else if (mismatch === 0) {
                if (oddParityBad) {
                    if (!evenParityBad) throw new NotFoundException();
                    // Both bad
                    if (oddSum < evenSum) {
                        incrementOdd = true;
                        decrementEven = true;
                    } else {
                        decrementOdd = true;
                        incrementEven = true;
                    }
                } else {
                    if (evenParityBad) throw new NotFoundException();
                // Nothing to do!
                }
            } else throw new NotFoundException();
            if (incrementOdd) {
                if (decrementOdd) throw new NotFoundException();
                AbstractRSSReader.increment(this.getOddCounts(), this.getOddRoundingErrors());
            }
            if (decrementOdd) AbstractRSSReader.decrement(this.getOddCounts(), this.getOddRoundingErrors());
            if (incrementEven) {
                if (decrementEven) throw new NotFoundException();
                AbstractRSSReader.increment(this.getEvenCounts(), this.getOddRoundingErrors());
            }
            if (decrementEven) AbstractRSSReader.decrement(this.getEvenCounts(), this.getEvenRoundingErrors());
        }
    }
    RSS14Reader.OUTSIDE_EVEN_TOTAL_SUBSET = [
        1,
        10,
        34,
        70,
        126
    ];
    RSS14Reader.INSIDE_ODD_TOTAL_SUBSET = [
        4,
        20,
        48,
        81
    ];
    RSS14Reader.OUTSIDE_GSUM = [
        0,
        161,
        961,
        2015,
        2715
    ];
    RSS14Reader.INSIDE_GSUM = [
        0,
        336,
        1036,
        1516
    ];
    RSS14Reader.OUTSIDE_ODD_WIDEST = [
        8,
        6,
        4,
        3,
        1
    ];
    RSS14Reader.INSIDE_ODD_WIDEST = [
        2,
        4,
        6,
        8
    ];
    RSS14Reader.FINDER_PATTERNS = [
        Int32Array.from([
            3,
            8,
            2,
            1
        ]),
        Int32Array.from([
            3,
            5,
            5,
            1
        ]),
        Int32Array.from([
            3,
            3,
            7,
            1
        ]),
        Int32Array.from([
            3,
            1,
            9,
            1
        ]),
        Int32Array.from([
            2,
            7,
            4,
            1
        ]),
        Int32Array.from([
            2,
            5,
            6,
            1
        ]),
        Int32Array.from([
            2,
            3,
            8,
            1
        ]),
        Int32Array.from([
            1,
            5,
            7,
            1
        ]),
        Int32Array.from([
            1,
            3,
            9,
            1
        ])
    ];
    /**
     * @author Daniel Switkin <dswitkin@google.com>
     * @author Sean Owen
     */ class MultiFormatOneDReader extends OneDReader {
        constructor(hints, verbose){
            super();
            this.readers = [];
            this.verbose = verbose === true;
            const possibleFormats = !hints ? null : hints.get(DecodeHintType$1.POSSIBLE_FORMATS);
            const useCode39CheckDigit = hints && hints.get(DecodeHintType$1.ASSUME_CODE_39_CHECK_DIGIT) !== undefined;
            if (possibleFormats) {
                if (possibleFormats.includes(BarcodeFormat$1.EAN_13) || possibleFormats.includes(BarcodeFormat$1.UPC_A) || possibleFormats.includes(BarcodeFormat$1.EAN_8) || possibleFormats.includes(BarcodeFormat$1.UPC_E)) this.readers.push(new MultiFormatUPCEANReader(hints));
                if (possibleFormats.includes(BarcodeFormat$1.CODE_39)) this.readers.push(new Code39Reader(useCode39CheckDigit));
                // if (possibleFormats.includes(BarcodeFormat.CODE_93)) {
                //    this.readers.push(new Code93Reader());
                // }
                if (possibleFormats.includes(BarcodeFormat$1.CODE_128)) this.readers.push(new Code128Reader());
                if (possibleFormats.includes(BarcodeFormat$1.ITF)) this.readers.push(new ITFReader());
                // if (possibleFormats.includes(BarcodeFormat.CODABAR)) {
                //    this.readers.push(new CodaBarReader());
                // }
                if (possibleFormats.includes(BarcodeFormat$1.RSS_14)) this.readers.push(new RSS14Reader());
                if (possibleFormats.includes(BarcodeFormat$1.RSS_EXPANDED)) this.readers.push(new RSSExpandedReader(this.verbose));
            } else {
                // Case when no hints were provided -> add all.
                this.readers.push(new MultiFormatUPCEANReader(hints));
                this.readers.push(new Code39Reader());
                // this.readers.push(new CodaBarReader());
                // this.readers.push(new Code93Reader());
                this.readers.push(new MultiFormatUPCEANReader(hints));
                this.readers.push(new Code128Reader());
                this.readers.push(new ITFReader());
                this.readers.push(new RSS14Reader());
                this.readers.push(new RSSExpandedReader(this.verbose));
            }
        }
        // @Override
        decodeRow(rowNumber, row, hints) {
            for(let i = 0; i < this.readers.length; i++)try {
                return this.readers[i].decodeRow(rowNumber, row, hints);
            } catch (re) {
            // continue
            }
            throw new NotFoundException();
        }
        // @Override
        reset() {
            this.readers.forEach((reader)=>reader.reset());
        }
    }
    /**
     * @deprecated Moving to @zxing/browser
     *
     * Barcode reader reader to use from browser.
     */ class BrowserBarcodeReader extends BrowserCodeReader {
        /**
         * Creates an instance of BrowserBarcodeReader.
         * @param {number} [timeBetweenScansMillis=500] the time delay between subsequent decode tries
         * @param {Map<DecodeHintType, any>} hints
         */ constructor(timeBetweenScansMillis = 500, hints){
            super(new MultiFormatOneDReader(hints), timeBetweenScansMillis, hints);
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * <p>Encapsulates a set of error-correction blocks in one symbol version. Most versions will
     * use blocks of differing sizes within one version, so, this encapsulates the parameters for
     * each set of blocks. It also holds the number of error-correction codewords per block since it
     * will be the same across all blocks within one version.</p>
     */ class ECBlocks {
        constructor(ecCodewords, ecBlocks1, ecBlocks2){
            this.ecCodewords = ecCodewords;
            this.ecBlocks = [
                ecBlocks1
            ];
            ecBlocks2 && this.ecBlocks.push(ecBlocks2);
        }
        getECCodewords() {
            return this.ecCodewords;
        }
        getECBlocks() {
            return this.ecBlocks;
        }
    }
    /**
     * <p>Encapsulates the parameters for one error-correction block in one symbol version.
     * This includes the number of data codewords, and the number of times a block with these
     * parameters is used consecutively in the Data Matrix code version's format.</p>
     */ class ECB {
        constructor(count, dataCodewords){
            this.count = count;
            this.dataCodewords = dataCodewords;
        }
        getCount() {
            return this.count;
        }
        getDataCodewords() {
            return this.dataCodewords;
        }
    }
    /**
     * The Version object encapsulates attributes about a particular
     * size Data Matrix Code.
     *
     * @author bbrown@google.com (Brian Brown)
     */ class Version {
        constructor(versionNumber, symbolSizeRows, symbolSizeColumns, dataRegionSizeRows, dataRegionSizeColumns, ecBlocks){
            this.versionNumber = versionNumber;
            this.symbolSizeRows = symbolSizeRows;
            this.symbolSizeColumns = symbolSizeColumns;
            this.dataRegionSizeRows = dataRegionSizeRows;
            this.dataRegionSizeColumns = dataRegionSizeColumns;
            this.ecBlocks = ecBlocks;
            // Calculate the total number of codewords
            let total = 0;
            const ecCodewords = ecBlocks.getECCodewords();
            const ecbArray = ecBlocks.getECBlocks();
            for (let ecBlock of ecbArray)total += ecBlock.getCount() * (ecBlock.getDataCodewords() + ecCodewords);
            this.totalCodewords = total;
        }
        getVersionNumber() {
            return this.versionNumber;
        }
        getSymbolSizeRows() {
            return this.symbolSizeRows;
        }
        getSymbolSizeColumns() {
            return this.symbolSizeColumns;
        }
        getDataRegionSizeRows() {
            return this.dataRegionSizeRows;
        }
        getDataRegionSizeColumns() {
            return this.dataRegionSizeColumns;
        }
        getTotalCodewords() {
            return this.totalCodewords;
        }
        getECBlocks() {
            return this.ecBlocks;
        }
        /**
         * <p>Deduces version information from Data Matrix dimensions.</p>
         *
         * @param numRows Number of rows in modules
         * @param numColumns Number of columns in modules
         * @return Version for a Data Matrix Code of those dimensions
         * @throws FormatException if dimensions do correspond to a valid Data Matrix size
         */ static getVersionForDimensions(numRows, numColumns) {
            if ((numRows & 0x01) !== 0 || (numColumns & 0x01) !== 0) throw new FormatException();
            for (let version of Version.VERSIONS){
                if (version.symbolSizeRows === numRows && version.symbolSizeColumns === numColumns) return version;
            }
            throw new FormatException();
        }
        //  @Override
        toString() {
            return '' + this.versionNumber;
        }
        /**
         * See ISO 16022:2006 5.5.1 Table 7
         */ static buildVersions() {
            return [
                new Version(1, 10, 10, 8, 8, new ECBlocks(5, new ECB(1, 3))),
                new Version(2, 12, 12, 10, 10, new ECBlocks(7, new ECB(1, 5))),
                new Version(3, 14, 14, 12, 12, new ECBlocks(10, new ECB(1, 8))),
                new Version(4, 16, 16, 14, 14, new ECBlocks(12, new ECB(1, 12))),
                new Version(5, 18, 18, 16, 16, new ECBlocks(14, new ECB(1, 18))),
                new Version(6, 20, 20, 18, 18, new ECBlocks(18, new ECB(1, 22))),
                new Version(7, 22, 22, 20, 20, new ECBlocks(20, new ECB(1, 30))),
                new Version(8, 24, 24, 22, 22, new ECBlocks(24, new ECB(1, 36))),
                new Version(9, 26, 26, 24, 24, new ECBlocks(28, new ECB(1, 44))),
                new Version(10, 32, 32, 14, 14, new ECBlocks(36, new ECB(1, 62))),
                new Version(11, 36, 36, 16, 16, new ECBlocks(42, new ECB(1, 86))),
                new Version(12, 40, 40, 18, 18, new ECBlocks(48, new ECB(1, 114))),
                new Version(13, 44, 44, 20, 20, new ECBlocks(56, new ECB(1, 144))),
                new Version(14, 48, 48, 22, 22, new ECBlocks(68, new ECB(1, 174))),
                new Version(15, 52, 52, 24, 24, new ECBlocks(42, new ECB(2, 102))),
                new Version(16, 64, 64, 14, 14, new ECBlocks(56, new ECB(2, 140))),
                new Version(17, 72, 72, 16, 16, new ECBlocks(36, new ECB(4, 92))),
                new Version(18, 80, 80, 18, 18, new ECBlocks(48, new ECB(4, 114))),
                new Version(19, 88, 88, 20, 20, new ECBlocks(56, new ECB(4, 144))),
                new Version(20, 96, 96, 22, 22, new ECBlocks(68, new ECB(4, 174))),
                new Version(21, 104, 104, 24, 24, new ECBlocks(56, new ECB(6, 136))),
                new Version(22, 120, 120, 18, 18, new ECBlocks(68, new ECB(6, 175))),
                new Version(23, 132, 132, 20, 20, new ECBlocks(62, new ECB(8, 163))),
                new Version(24, 144, 144, 22, 22, new ECBlocks(62, new ECB(8, 156), new ECB(2, 155))),
                new Version(25, 8, 18, 6, 16, new ECBlocks(7, new ECB(1, 5))),
                new Version(26, 8, 32, 6, 14, new ECBlocks(11, new ECB(1, 10))),
                new Version(27, 12, 26, 10, 24, new ECBlocks(14, new ECB(1, 16))),
                new Version(28, 12, 36, 10, 16, new ECBlocks(18, new ECB(1, 22))),
                new Version(29, 16, 36, 14, 16, new ECBlocks(24, new ECB(1, 32))),
                new Version(30, 16, 48, 14, 22, new ECBlocks(28, new ECB(1, 49)))
            ];
        }
    }
    Version.VERSIONS = Version.buildVersions();
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * @author bbrown@google.com (Brian Brown)
     */ class BitMatrixParser {
        /**
         * @param bitMatrix {@link BitMatrix} to parse
         * @throws FormatException if dimension is < 8 or > 144 or not 0 mod 2
         */ constructor(bitMatrix){
            const dimension = bitMatrix.getHeight();
            if (dimension < 8 || dimension > 144 || (dimension & 0x01) !== 0) throw new FormatException();
            this.version = BitMatrixParser.readVersion(bitMatrix);
            this.mappingBitMatrix = this.extractDataRegion(bitMatrix);
            this.readMappingMatrix = new BitMatrix(this.mappingBitMatrix.getWidth(), this.mappingBitMatrix.getHeight());
        }
        getVersion() {
            return this.version;
        }
        /**
         * <p>Creates the version object based on the dimension of the original bit matrix from
         * the datamatrix code.</p>
         *
         * <p>See ISO 16022:2006 Table 7 - ECC 200 symbol attributes</p>
         *
         * @param bitMatrix Original {@link BitMatrix} including alignment patterns
         * @return {@link Version} encapsulating the Data Matrix Code's "version"
         * @throws FormatException if the dimensions of the mapping matrix are not valid
         * Data Matrix dimensions.
         */ static readVersion(bitMatrix) {
            const numRows = bitMatrix.getHeight();
            const numColumns = bitMatrix.getWidth();
            return Version.getVersionForDimensions(numRows, numColumns);
        }
        /**
         * <p>Reads the bits in the {@link BitMatrix} representing the mapping matrix (No alignment patterns)
         * in the correct order in order to reconstitute the codewords bytes contained within the
         * Data Matrix Code.</p>
         *
         * @return bytes encoded within the Data Matrix Code
         * @throws FormatException if the exact number of bytes expected is not read
         */ readCodewords() {
            const result = new Int8Array(this.version.getTotalCodewords());
            let resultOffset = 0;
            let row = 4;
            let column = 0;
            const numRows = this.mappingBitMatrix.getHeight();
            const numColumns = this.mappingBitMatrix.getWidth();
            let corner1Read = false;
            let corner2Read = false;
            let corner3Read = false;
            let corner4Read = false;
            // Read all of the codewords
            do {
                // Check the four corner cases
                if (row === numRows && column === 0 && !corner1Read) {
                    result[resultOffset++] = this.readCorner1(numRows, numColumns) & 0xff;
                    row -= 2;
                    column += 2;
                    corner1Read = true;
                } else if (row === numRows - 2 && column === 0 && (numColumns & 0x03) !== 0 && !corner2Read) {
                    result[resultOffset++] = this.readCorner2(numRows, numColumns) & 0xff;
                    row -= 2;
                    column += 2;
                    corner2Read = true;
                } else if (row === numRows + 4 && column === 2 && (numColumns & 0x07) === 0 && !corner3Read) {
                    result[resultOffset++] = this.readCorner3(numRows, numColumns) & 0xff;
                    row -= 2;
                    column += 2;
                    corner3Read = true;
                } else if (row === numRows - 2 && column === 0 && (numColumns & 0x07) === 4 && !corner4Read) {
                    result[resultOffset++] = this.readCorner4(numRows, numColumns) & 0xff;
                    row -= 2;
                    column += 2;
                    corner4Read = true;
                } else {
                    // Sweep upward diagonally to the right
                    do {
                        if (row < numRows && column >= 0 && !this.readMappingMatrix.get(column, row)) result[resultOffset++] = this.readUtah(row, column, numRows, numColumns) & 0xff;
                        row -= 2;
                        column += 2;
                    }while (row >= 0 && column < numColumns);
                    row += 1;
                    column += 3;
                    // Sweep downward diagonally to the left
                    do {
                        if (row >= 0 && column < numColumns && !this.readMappingMatrix.get(column, row)) result[resultOffset++] = this.readUtah(row, column, numRows, numColumns) & 0xff;
                        row += 2;
                        column -= 2;
                    }while (row < numRows && column >= 0);
                    row += 3;
                    column += 1;
                }
            }while (row < numRows || column < numColumns);
            if (resultOffset !== this.version.getTotalCodewords()) throw new FormatException();
            return result;
        }
        /**
         * <p>Reads a bit of the mapping matrix accounting for boundary wrapping.</p>
         *
         * @param row Row to read in the mapping matrix
         * @param column Column to read in the mapping matrix
         * @param numRows Number of rows in the mapping matrix
         * @param numColumns Number of columns in the mapping matrix
         * @return value of the given bit in the mapping matrix
         */ readModule(row, column, numRows, numColumns) {
            // Adjust the row and column indices based on boundary wrapping
            if (row < 0) {
                row += numRows;
                column += 4 - (numRows + 4 & 0x07);
            }
            if (column < 0) {
                column += numColumns;
                row += 4 - (numColumns + 4 & 0x07);
            }
            this.readMappingMatrix.set(column, row);
            return this.mappingBitMatrix.get(column, row);
        }
        /**
         * <p>Reads the 8 bits of the standard Utah-shaped pattern.</p>
         *
         * <p>See ISO 16022:2006, 5.8.1 Figure 6</p>
         *
         * @param row Current row in the mapping matrix, anchored at the 8th bit (LSB) of the pattern
         * @param column Current column in the mapping matrix, anchored at the 8th bit (LSB) of the pattern
         * @param numRows Number of rows in the mapping matrix
         * @param numColumns Number of columns in the mapping matrix
         * @return byte from the utah shape
         */ readUtah(row, column, numRows, numColumns) {
            let currentByte = 0;
            if (this.readModule(row - 2, column - 2, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(row - 2, column - 1, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(row - 1, column - 2, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(row - 1, column - 1, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(row - 1, column, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(row, column - 2, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(row, column - 1, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(row, column, numRows, numColumns)) currentByte |= 1;
            return currentByte;
        }
        /**
         * <p>Reads the 8 bits of the special corner condition 1.</p>
         *
         * <p>See ISO 16022:2006, Figure F.3</p>
         *
         * @param numRows Number of rows in the mapping matrix
         * @param numColumns Number of columns in the mapping matrix
         * @return byte from the Corner condition 1
         */ readCorner1(numRows, numColumns) {
            let currentByte = 0;
            if (this.readModule(numRows - 1, 0, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(numRows - 1, 1, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(numRows - 1, 2, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(0, numColumns - 2, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(0, numColumns - 1, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(1, numColumns - 1, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(2, numColumns - 1, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(3, numColumns - 1, numRows, numColumns)) currentByte |= 1;
            return currentByte;
        }
        /**
         * <p>Reads the 8 bits of the special corner condition 2.</p>
         *
         * <p>See ISO 16022:2006, Figure F.4</p>
         *
         * @param numRows Number of rows in the mapping matrix
         * @param numColumns Number of columns in the mapping matrix
         * @return byte from the Corner condition 2
         */ readCorner2(numRows, numColumns) {
            let currentByte = 0;
            if (this.readModule(numRows - 3, 0, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(numRows - 2, 0, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(numRows - 1, 0, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(0, numColumns - 4, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(0, numColumns - 3, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(0, numColumns - 2, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(0, numColumns - 1, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(1, numColumns - 1, numRows, numColumns)) currentByte |= 1;
            return currentByte;
        }
        /**
         * <p>Reads the 8 bits of the special corner condition 3.</p>
         *
         * <p>See ISO 16022:2006, Figure F.5</p>
         *
         * @param numRows Number of rows in the mapping matrix
         * @param numColumns Number of columns in the mapping matrix
         * @return byte from the Corner condition 3
         */ readCorner3(numRows, numColumns) {
            let currentByte = 0;
            if (this.readModule(numRows - 1, 0, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(numRows - 1, numColumns - 1, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(0, numColumns - 3, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(0, numColumns - 2, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(0, numColumns - 1, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(1, numColumns - 3, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(1, numColumns - 2, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(1, numColumns - 1, numRows, numColumns)) currentByte |= 1;
            return currentByte;
        }
        /**
         * <p>Reads the 8 bits of the special corner condition 4.</p>
         *
         * <p>See ISO 16022:2006, Figure F.6</p>
         *
         * @param numRows Number of rows in the mapping matrix
         * @param numColumns Number of columns in the mapping matrix
         * @return byte from the Corner condition 4
         */ readCorner4(numRows, numColumns) {
            let currentByte = 0;
            if (this.readModule(numRows - 3, 0, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(numRows - 2, 0, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(numRows - 1, 0, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(0, numColumns - 2, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(0, numColumns - 1, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(1, numColumns - 1, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(2, numColumns - 1, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(3, numColumns - 1, numRows, numColumns)) currentByte |= 1;
            return currentByte;
        }
        /**
         * <p>Extracts the data region from a {@link BitMatrix} that contains
         * alignment patterns.</p>
         *
         * @param bitMatrix Original {@link BitMatrix} with alignment patterns
         * @return BitMatrix that has the alignment patterns removed
         */ extractDataRegion(bitMatrix) {
            const symbolSizeRows = this.version.getSymbolSizeRows();
            const symbolSizeColumns = this.version.getSymbolSizeColumns();
            if (bitMatrix.getHeight() !== symbolSizeRows) throw new IllegalArgumentException('Dimension of bitMatrix must match the version size');
            const dataRegionSizeRows = this.version.getDataRegionSizeRows();
            const dataRegionSizeColumns = this.version.getDataRegionSizeColumns();
            const numDataRegionsRow = symbolSizeRows / dataRegionSizeRows | 0;
            const numDataRegionsColumn = symbolSizeColumns / dataRegionSizeColumns | 0;
            const sizeDataRegionRow = numDataRegionsRow * dataRegionSizeRows;
            const sizeDataRegionColumn = numDataRegionsColumn * dataRegionSizeColumns;
            const bitMatrixWithoutAlignment = new BitMatrix(sizeDataRegionColumn, sizeDataRegionRow);
            for(let dataRegionRow = 0; dataRegionRow < numDataRegionsRow; ++dataRegionRow){
                const dataRegionRowOffset = dataRegionRow * dataRegionSizeRows;
                for(let dataRegionColumn = 0; dataRegionColumn < numDataRegionsColumn; ++dataRegionColumn){
                    const dataRegionColumnOffset = dataRegionColumn * dataRegionSizeColumns;
                    for(let i = 0; i < dataRegionSizeRows; ++i){
                        const readRowOffset = dataRegionRow * (dataRegionSizeRows + 2) + 1 + i;
                        const writeRowOffset = dataRegionRowOffset + i;
                        for(let j = 0; j < dataRegionSizeColumns; ++j){
                            const readColumnOffset = dataRegionColumn * (dataRegionSizeColumns + 2) + 1 + j;
                            if (bitMatrix.get(readColumnOffset, readRowOffset)) {
                                const writeColumnOffset = dataRegionColumnOffset + j;
                                bitMatrixWithoutAlignment.set(writeColumnOffset, writeRowOffset);
                            }
                        }
                    }
                }
            }
            return bitMatrixWithoutAlignment;
        }
    }
    /**
     * <p>Encapsulates a block of data within a Data Matrix Code. Data Matrix Codes may split their data into
     * multiple blocks, each of which is a unit of data and error-correction codewords. Each
     * is represented by an instance of this class.</p>
     *
     * @author bbrown@google.com (Brian Brown)
     */ class DataBlock {
        constructor(numDataCodewords, codewords){
            this.numDataCodewords = numDataCodewords;
            this.codewords = codewords;
        }
        /**
         * <p>When Data Matrix Codes use multiple data blocks, they actually interleave the bytes of each of them.
         * That is, the first byte of data block 1 to n is written, then the second bytes, and so on. This
         * method will separate the data into original blocks.</p>
         *
         * @param rawCodewords bytes as read directly from the Data Matrix Code
         * @param version version of the Data Matrix Code
         * @return DataBlocks containing original bytes, "de-interleaved" from representation in the
         *         Data Matrix Code
         */ static getDataBlocks(rawCodewords, version) {
            // Figure out the number and size of data blocks used by this version
            const ecBlocks = version.getECBlocks();
            // First count the total number of data blocks
            let totalBlocks = 0;
            const ecBlockArray = ecBlocks.getECBlocks();
            for (let ecBlock of ecBlockArray)totalBlocks += ecBlock.getCount();
            // Now establish DataBlocks of the appropriate size and number of data codewords
            const result = new Array(totalBlocks);
            let numResultBlocks = 0;
            for (let ecBlock of ecBlockArray)for(let i = 0; i < ecBlock.getCount(); i++){
                const numDataCodewords = ecBlock.getDataCodewords();
                const numBlockCodewords = ecBlocks.getECCodewords() + numDataCodewords;
                result[numResultBlocks++] = new DataBlock(numDataCodewords, new Uint8Array(numBlockCodewords));
            }
            // All blocks have the same amount of data, except that the last n
            // (where n may be 0) have 1 less byte. Figure out where these start.
            // TODO(bbrown): There is only one case where there is a difference for Data Matrix for size 144
            const longerBlocksTotalCodewords = result[0].codewords.length;
            // int shorterBlocksTotalCodewords = longerBlocksTotalCodewords - 1;
            const longerBlocksNumDataCodewords = longerBlocksTotalCodewords - ecBlocks.getECCodewords();
            const shorterBlocksNumDataCodewords = longerBlocksNumDataCodewords - 1;
            // The last elements of result may be 1 element shorter for 144 matrix
            // first fill out as many elements as all of them have minus 1
            let rawCodewordsOffset = 0;
            for(let i = 0; i < shorterBlocksNumDataCodewords; i++)for(let j = 0; j < numResultBlocks; j++)result[j].codewords[i] = rawCodewords[rawCodewordsOffset++];
            // Fill out the last data block in the longer ones
            const specialVersion = version.getVersionNumber() === 24;
            const numLongerBlocks = specialVersion ? 8 : numResultBlocks;
            for(let j = 0; j < numLongerBlocks; j++)result[j].codewords[longerBlocksNumDataCodewords - 1] = rawCodewords[rawCodewordsOffset++];
            // Now add in error correction blocks
            const max = result[0].codewords.length;
            for(let i = longerBlocksNumDataCodewords; i < max; i++)for(let j = 0; j < numResultBlocks; j++){
                const jOffset = specialVersion ? (j + 8) % numResultBlocks : j;
                const iOffset = specialVersion && jOffset > 7 ? i - 1 : i;
                result[jOffset].codewords[iOffset] = rawCodewords[rawCodewordsOffset++];
            }
            if (rawCodewordsOffset !== rawCodewords.length) throw new IllegalArgumentException();
            return result;
        }
        getNumDataCodewords() {
            return this.numDataCodewords;
        }
        getCodewords() {
            return this.codewords;
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * <p>This provides an easy abstraction to read bits at a time from a sequence of bytes, where the
     * number of bits read is not often a multiple of 8.</p>
     *
     * <p>This class is thread-safe but not reentrant -- unless the caller modifies the bytes array
     * it passed in, in which case all bets are off.</p>
     *
     * @author Sean Owen
     */ class BitSource {
        /**
         * @param bytes bytes from which this will read bits. Bits will be read from the first byte first.
         * Bits are read within a byte from most-significant to least-significant bit.
         */ constructor(bytes){
            this.bytes = bytes;
            this.byteOffset = 0;
            this.bitOffset = 0;
        }
        /**
         * @return index of next bit in current byte which would be read by the next call to {@link #readBits(int)}.
         */ getBitOffset() {
            return this.bitOffset;
        }
        /**
         * @return index of next byte in input byte array which would be read by the next call to {@link #readBits(int)}.
         */ getByteOffset() {
            return this.byteOffset;
        }
        /**
         * @param numBits number of bits to read
         * @return int representing the bits read. The bits will appear as the least-significant
         *         bits of the int
         * @throws IllegalArgumentException if numBits isn't in [1,32] or more than is available
         */ readBits(numBits /*int*/ ) {
            if (numBits < 1 || numBits > 32 || numBits > this.available()) throw new IllegalArgumentException('' + numBits);
            let result = 0;
            let bitOffset = this.bitOffset;
            let byteOffset = this.byteOffset;
            const bytes = this.bytes;
            // First, read remainder from current byte
            if (bitOffset > 0) {
                const bitsLeft = 8 - bitOffset;
                const toRead = numBits < bitsLeft ? numBits : bitsLeft;
                const bitsToNotRead = bitsLeft - toRead;
                const mask = 0xFF >> 8 - toRead << bitsToNotRead;
                result = (bytes[byteOffset] & mask) >> bitsToNotRead;
                numBits -= toRead;
                bitOffset += toRead;
                if (bitOffset === 8) {
                    bitOffset = 0;
                    byteOffset++;
                }
            }
            // Next read whole bytes
            if (numBits > 0) {
                while(numBits >= 8){
                    result = result << 8 | bytes[byteOffset] & 0xFF;
                    byteOffset++;
                    numBits -= 8;
                }
                // Finally read a partial byte
                if (numBits > 0) {
                    const bitsToNotRead = 8 - numBits;
                    const mask = 0xFF >> bitsToNotRead << bitsToNotRead;
                    result = result << numBits | (bytes[byteOffset] & mask) >> bitsToNotRead;
                    bitOffset += numBits;
                }
            }
            this.bitOffset = bitOffset;
            this.byteOffset = byteOffset;
            return result;
        }
        /**
         * @return number of bits that can be read successfully
         */ available() {
            return 8 * (this.bytes.length - this.byteOffset) - this.bitOffset;
        }
    }
    var Mode;
    (function(Mode) {
        Mode[Mode["PAD_ENCODE"] = 0] = "PAD_ENCODE";
        Mode[Mode["ASCII_ENCODE"] = 1] = "ASCII_ENCODE";
        Mode[Mode["C40_ENCODE"] = 2] = "C40_ENCODE";
        Mode[Mode["TEXT_ENCODE"] = 3] = "TEXT_ENCODE";
        Mode[Mode["ANSIX12_ENCODE"] = 4] = "ANSIX12_ENCODE";
        Mode[Mode["EDIFACT_ENCODE"] = 5] = "EDIFACT_ENCODE";
        Mode[Mode["BASE256_ENCODE"] = 6] = "BASE256_ENCODE";
    })(Mode || (Mode = {}));
    /**
     * <p>Data Matrix Codes can encode text as bits in one of several modes, and can use multiple modes
     * in one Data Matrix Code. This class decodes the bits back into text.</p>
     *
     * <p>See ISO 16022:2006, 5.2.1 - 5.2.9.2</p>
     *
     * @author bbrown@google.com (Brian Brown)
     * @author Sean Owen
     */ class DecodedBitStreamParser {
        static decode(bytes) {
            const bits = new BitSource(bytes);
            const result = new StringBuilder();
            const resultTrailer = new StringBuilder();
            const byteSegments = new Array();
            let mode = Mode.ASCII_ENCODE;
            do if (mode === Mode.ASCII_ENCODE) mode = this.decodeAsciiSegment(bits, result, resultTrailer);
            else {
                switch(mode){
                    case Mode.C40_ENCODE:
                        this.decodeC40Segment(bits, result);
                        break;
                    case Mode.TEXT_ENCODE:
                        this.decodeTextSegment(bits, result);
                        break;
                    case Mode.ANSIX12_ENCODE:
                        this.decodeAnsiX12Segment(bits, result);
                        break;
                    case Mode.EDIFACT_ENCODE:
                        this.decodeEdifactSegment(bits, result);
                        break;
                    case Mode.BASE256_ENCODE:
                        this.decodeBase256Segment(bits, result, byteSegments);
                        break;
                    default:
                        throw new FormatException();
                }
                mode = Mode.ASCII_ENCODE;
            }
            while (mode !== Mode.PAD_ENCODE && bits.available() > 0);
            if (resultTrailer.length() > 0) result.append(resultTrailer.toString());
            return new DecoderResult(bytes, result.toString(), byteSegments.length === 0 ? null : byteSegments, null);
        }
        /**
         * See ISO 16022:2006, 5.2.3 and Annex C, Table C.2
         */ static decodeAsciiSegment(bits, result, resultTrailer) {
            let upperShift = false;
            do {
                let oneByte = bits.readBits(8);
                if (oneByte === 0) throw new FormatException();
                else if (oneByte <= 128) {
                    if (upperShift) oneByte += 128;
                    result.append(String.fromCharCode(oneByte - 1));
                    return Mode.ASCII_ENCODE;
                } else if (oneByte === 129) return Mode.PAD_ENCODE;
                else if (oneByte <= 229) {
                    const value = oneByte - 130;
                    if (value < 10) result.append('0');
                    result.append('' + value);
                } else switch(oneByte){
                    case 230:
                        return Mode.C40_ENCODE;
                    case 231:
                        return Mode.BASE256_ENCODE;
                    case 232:
                        result.append(String.fromCharCode(29)); // translate as ASCII 29
                        break;
                    case 233:
                    case 234:
                        break;
                    case 235:
                        upperShift = true;
                        break;
                    case 236:
                        result.append('[)>\u001E05\u001D');
                        resultTrailer.insert(0, '\u001E\u0004');
                        break;
                    case 237:
                        result.append('[)>\u001E06\u001D');
                        resultTrailer.insert(0, '\u001E\u0004');
                        break;
                    case 238:
                        return Mode.ANSIX12_ENCODE;
                    case 239:
                        return Mode.TEXT_ENCODE;
                    case 240:
                        return Mode.EDIFACT_ENCODE;
                    case 241:
                        break;
                    default:
                        // Not to be used in ASCII encodation
                        // but work around encoders that end with 254, latch back to ASCII
                        if (oneByte !== 254 || bits.available() !== 0) throw new FormatException();
                        break;
                }
            }while (bits.available() > 0);
            return Mode.ASCII_ENCODE;
        }
        /**
         * See ISO 16022:2006, 5.2.5 and Annex C, Table C.1
         */ static decodeC40Segment(bits, result) {
            // Three C40 values are encoded in a 16-bit value as
            // (1600 * C1) + (40 * C2) + C3 + 1
            // TODO(bbrown): The Upper Shift with C40 doesn't work in the 4 value scenario all the time
            let upperShift = false;
            const cValues = [];
            let shift = 0;
            do {
                // If there is only one byte left then it will be encoded as ASCII
                if (bits.available() === 8) return;
                const firstByte = bits.readBits(8);
                if (firstByte === 254) return;
                this.parseTwoBytes(firstByte, bits.readBits(8), cValues);
                for(let i = 0; i < 3; i++){
                    const cValue = cValues[i];
                    switch(shift){
                        case 0:
                            if (cValue < 3) shift = cValue + 1;
                            else if (cValue < this.C40_BASIC_SET_CHARS.length) {
                                const c40char = this.C40_BASIC_SET_CHARS[cValue];
                                if (upperShift) {
                                    result.append(String.fromCharCode(c40char.charCodeAt(0) + 128));
                                    upperShift = false;
                                } else result.append(c40char);
                            } else throw new FormatException();
                            break;
                        case 1:
                            if (upperShift) {
                                result.append(String.fromCharCode(cValue + 128));
                                upperShift = false;
                            } else result.append(String.fromCharCode(cValue));
                            shift = 0;
                            break;
                        case 2:
                            if (cValue < this.C40_SHIFT2_SET_CHARS.length) {
                                const c40char = this.C40_SHIFT2_SET_CHARS[cValue];
                                if (upperShift) {
                                    result.append(String.fromCharCode(c40char.charCodeAt(0) + 128));
                                    upperShift = false;
                                } else result.append(c40char);
                            } else switch(cValue){
                                case 27:
                                    result.append(String.fromCharCode(29)); // translate as ASCII 29
                                    break;
                                case 30:
                                    upperShift = true;
                                    break;
                                default:
                                    throw new FormatException();
                            }
                            shift = 0;
                            break;
                        case 3:
                            if (upperShift) {
                                result.append(String.fromCharCode(cValue + 224));
                                upperShift = false;
                            } else result.append(String.fromCharCode(cValue + 96));
                            shift = 0;
                            break;
                        default:
                            throw new FormatException();
                    }
                }
            }while (bits.available() > 0);
        }
        /**
         * See ISO 16022:2006, 5.2.6 and Annex C, Table C.2
         */ static decodeTextSegment(bits, result) {
            // Three Text values are encoded in a 16-bit value as
            // (1600 * C1) + (40 * C2) + C3 + 1
            // TODO(bbrown): The Upper Shift with Text doesn't work in the 4 value scenario all the time
            let upperShift = false;
            let cValues = [];
            let shift = 0;
            do {
                // If there is only one byte left then it will be encoded as ASCII
                if (bits.available() === 8) return;
                const firstByte = bits.readBits(8);
                if (firstByte === 254) return;
                this.parseTwoBytes(firstByte, bits.readBits(8), cValues);
                for(let i = 0; i < 3; i++){
                    const cValue = cValues[i];
                    switch(shift){
                        case 0:
                            if (cValue < 3) shift = cValue + 1;
                            else if (cValue < this.TEXT_BASIC_SET_CHARS.length) {
                                const textChar = this.TEXT_BASIC_SET_CHARS[cValue];
                                if (upperShift) {
                                    result.append(String.fromCharCode(textChar.charCodeAt(0) + 128));
                                    upperShift = false;
                                } else result.append(textChar);
                            } else throw new FormatException();
                            break;
                        case 1:
                            if (upperShift) {
                                result.append(String.fromCharCode(cValue + 128));
                                upperShift = false;
                            } else result.append(String.fromCharCode(cValue));
                            shift = 0;
                            break;
                        case 2:
                            // Shift 2 for Text is the same encoding as C40
                            if (cValue < this.TEXT_SHIFT2_SET_CHARS.length) {
                                const textChar = this.TEXT_SHIFT2_SET_CHARS[cValue];
                                if (upperShift) {
                                    result.append(String.fromCharCode(textChar.charCodeAt(0) + 128));
                                    upperShift = false;
                                } else result.append(textChar);
                            } else switch(cValue){
                                case 27:
                                    result.append(String.fromCharCode(29)); // translate as ASCII 29
                                    break;
                                case 30:
                                    upperShift = true;
                                    break;
                                default:
                                    throw new FormatException();
                            }
                            shift = 0;
                            break;
                        case 3:
                            if (cValue < this.TEXT_SHIFT3_SET_CHARS.length) {
                                const textChar = this.TEXT_SHIFT3_SET_CHARS[cValue];
                                if (upperShift) {
                                    result.append(String.fromCharCode(textChar.charCodeAt(0) + 128));
                                    upperShift = false;
                                } else result.append(textChar);
                                shift = 0;
                            } else throw new FormatException();
                            break;
                        default:
                            throw new FormatException();
                    }
                }
            }while (bits.available() > 0);
        }
        /**
         * See ISO 16022:2006, 5.2.7
         */ static decodeAnsiX12Segment(bits, result) {
            // Three ANSI X12 values are encoded in a 16-bit value as
            // (1600 * C1) + (40 * C2) + C3 + 1
            const cValues = [];
            do {
                // If there is only one byte left then it will be encoded as ASCII
                if (bits.available() === 8) return;
                const firstByte = bits.readBits(8);
                if (firstByte === 254) return;
                this.parseTwoBytes(firstByte, bits.readBits(8), cValues);
                for(let i = 0; i < 3; i++){
                    const cValue = cValues[i];
                    switch(cValue){
                        case 0:
                            result.append('\r');
                            break;
                        case 1:
                            result.append('*');
                            break;
                        case 2:
                            result.append('>');
                            break;
                        case 3:
                            result.append(' ');
                            break;
                        default:
                            if (cValue < 14) result.append(String.fromCharCode(cValue + 44));
                            else if (cValue < 40) result.append(String.fromCharCode(cValue + 51));
                            else throw new FormatException();
                            break;
                    }
                }
            }while (bits.available() > 0);
        }
        static parseTwoBytes(firstByte, secondByte, result) {
            let fullBitValue = (firstByte << 8) + secondByte - 1;
            let temp = Math.floor(fullBitValue / 1600);
            result[0] = temp;
            fullBitValue -= temp * 1600;
            temp = Math.floor(fullBitValue / 40);
            result[1] = temp;
            result[2] = fullBitValue - temp * 40;
        }
        /**
         * See ISO 16022:2006, 5.2.8 and Annex C Table C.3
         */ static decodeEdifactSegment(bits, result) {
            do {
                // If there is only two or less bytes left then it will be encoded as ASCII
                if (bits.available() <= 16) return;
                for(let i = 0; i < 4; i++){
                    let edifactValue = bits.readBits(6);
                    // Check for the unlatch character
                    if (edifactValue === 0x1F) {
                        // Read rest of byte, which should be 0, and stop
                        const bitsLeft = 8 - bits.getBitOffset();
                        if (bitsLeft !== 8) bits.readBits(bitsLeft);
                        return;
                    }
                    if ((edifactValue & 0x20) === 0) edifactValue |= 0x40; // Add a leading 01 to the 6 bit binary value
                    result.append(String.fromCharCode(edifactValue));
                }
            }while (bits.available() > 0);
        }
        /**
         * See ISO 16022:2006, 5.2.9 and Annex B, B.2
         */ static decodeBase256Segment(bits, result, byteSegments) {
            // Figure out how long the Base 256 Segment is.
            let codewordPosition = 1 + bits.getByteOffset(); // position is 1-indexed
            const d1 = this.unrandomize255State(bits.readBits(8), codewordPosition++);
            let count;
            if (d1 === 0) count = bits.available() / 8 | 0;
            else if (d1 < 250) count = d1;
            else count = 250 * (d1 - 249) + this.unrandomize255State(bits.readBits(8), codewordPosition++);
            // We're seeing NegativeArraySizeException errors from users.
            if (count < 0) throw new FormatException();
            const bytes = new Uint8Array(count);
            for(let i = 0; i < count; i++){
                // Have seen this particular error in the wild, such as at
                // http://www.bcgen.com/demo/IDAutomationStreamingDataMatrix.aspx?MODE=3&D=Fred&PFMT=3&PT=F&X=0.3&O=0&LM=0.2
                if (bits.available() < 8) throw new FormatException();
                bytes[i] = this.unrandomize255State(bits.readBits(8), codewordPosition++);
            }
            byteSegments.push(bytes);
            try {
                result.append(StringEncoding.decode(bytes, StringUtils.ISO88591));
            } catch (uee) {
                throw new IllegalStateException('Platform does not support required encoding: ' + uee.message);
            }
        }
        /**
         * See ISO 16022:2006, Annex B, B.2
         */ static unrandomize255State(randomizedBase256Codeword, base256CodewordPosition) {
            const pseudoRandomNumber = 149 * base256CodewordPosition % 255 + 1;
            const tempVariable = randomizedBase256Codeword - pseudoRandomNumber;
            return tempVariable >= 0 ? tempVariable : tempVariable + 256;
        }
    }
    /**
     * See ISO 16022:2006, Annex C Table C.1
     * The C40 Basic Character Set (*'s used for placeholders for the shift values)
     */ DecodedBitStreamParser.C40_BASIC_SET_CHARS = [
        '*',
        '*',
        '*',
        ' ',
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z'
    ];
    DecodedBitStreamParser.C40_SHIFT2_SET_CHARS = [
        '!',
        '"',
        '#',
        '$',
        '%',
        '&',
        '\'',
        '(',
        ')',
        '*',
        '+',
        ',',
        '-',
        '.',
        '/',
        ':',
        ';',
        '<',
        '=',
        '>',
        '?',
        '@',
        '[',
        '\\',
        ']',
        '^',
        '_'
    ];
    /**
     * See ISO 16022:2006, Annex C Table C.2
     * The Text Basic Character Set (*'s used for placeholders for the shift values)
     */ DecodedBitStreamParser.TEXT_BASIC_SET_CHARS = [
        '*',
        '*',
        '*',
        ' ',
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        'a',
        'b',
        'c',
        'd',
        'e',
        'f',
        'g',
        'h',
        'i',
        'j',
        'k',
        'l',
        'm',
        'n',
        'o',
        'p',
        'q',
        'r',
        's',
        't',
        'u',
        'v',
        'w',
        'x',
        'y',
        'z'
    ];
    // Shift 2 for Text is the same encoding as C40
    DecodedBitStreamParser.TEXT_SHIFT2_SET_CHARS = DecodedBitStreamParser.C40_SHIFT2_SET_CHARS;
    DecodedBitStreamParser.TEXT_SHIFT3_SET_CHARS = [
        '`',
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z',
        '{',
        '|',
        '}',
        '~',
        String.fromCharCode(127)
    ];
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * <p>The main class which implements Data Matrix Code decoding -- as opposed to locating and extracting
     * the Data Matrix Code from an image.</p>
     *
     * @author bbrown@google.com (Brian Brown)
     */ class Decoder$1 {
        constructor(){
            this.rsDecoder = new ReedSolomonDecoder(GenericGF.DATA_MATRIX_FIELD_256);
        }
        /**
         * <p>Decodes a Data Matrix Code represented as a {@link BitMatrix}. A 1 or "true" is taken
         * to mean a black module.</p>
         *
         * @param bits booleans representing white/black Data Matrix Code modules
         * @return text and bytes encoded within the Data Matrix Code
         * @throws FormatException if the Data Matrix Code cannot be decoded
         * @throws ChecksumException if error correction fails
         */ decode(bits) {
            // Construct a parser and read version, error-correction level
            const parser = new BitMatrixParser(bits);
            const version = parser.getVersion();
            // Read codewords
            const codewords = parser.readCodewords();
            // Separate into data blocks
            const dataBlocks = DataBlock.getDataBlocks(codewords, version);
            // Count total number of data bytes
            let totalBytes = 0;
            for (let db of dataBlocks)totalBytes += db.getNumDataCodewords();
            const resultBytes = new Uint8Array(totalBytes);
            const dataBlocksCount = dataBlocks.length;
            // Error-correct and copy data blocks together into a stream of bytes
            for(let j = 0; j < dataBlocksCount; j++){
                const dataBlock = dataBlocks[j];
                const codewordBytes = dataBlock.getCodewords();
                const numDataCodewords = dataBlock.getNumDataCodewords();
                this.correctErrors(codewordBytes, numDataCodewords);
                for(let i = 0; i < numDataCodewords; i++)// De-interlace data blocks.
                resultBytes[i * dataBlocksCount + j] = codewordBytes[i];
            }
            // Decode the contents of that stream of bytes
            return DecodedBitStreamParser.decode(resultBytes);
        }
        /**
         * <p>Given data and error-correction codewords received, possibly corrupted by errors, attempts to
         * correct the errors in-place using Reed-Solomon error correction.</p>
         *
         * @param codewordBytes data and error correction codewords
         * @param numDataCodewords number of codewords that are data bytes
         * @throws ChecksumException if error correction fails
         */ correctErrors(codewordBytes, numDataCodewords) {
            // const numCodewords = codewordBytes.length;
            // First read into an array of ints
            const codewordsInts = new Int32Array(codewordBytes);
            // for (let i = 0; i < numCodewords; i++) {
            //   codewordsInts[i] = codewordBytes[i] & 0xFF;
            // }
            try {
                this.rsDecoder.decode(codewordsInts, codewordBytes.length - numDataCodewords);
            } catch (ignored /* ReedSolomonException */ ) {
                throw new ChecksumException();
            }
            // Copy back into array of bytes -- only need to worry about the bytes that were data
            // We don't care about errors in the error-correction codewords
            for(let i = 0; i < numDataCodewords; i++)codewordBytes[i] = codewordsInts[i];
        }
    }
    /**
     * <p>Encapsulates logic that can detect a Data Matrix Code in an image, even if the Data Matrix Code
     * is rotated or skewed, or partially obscured.</p>
     *
     * @author Sean Owen
     */ class Detector$1 {
        constructor(image){
            this.image = image;
            this.rectangleDetector = new WhiteRectangleDetector(this.image);
        }
        /**
         * <p>Detects a Data Matrix Code in an image.</p>
         *
         * @return {@link DetectorResult} encapsulating results of detecting a Data Matrix Code
         * @throws NotFoundException if no Data Matrix Code can be found
         */ detect() {
            const cornerPoints = this.rectangleDetector.detect();
            let points = this.detectSolid1(cornerPoints);
            points = this.detectSolid2(points);
            points[3] = this.correctTopRight(points);
            if (!points[3]) throw new NotFoundException();
            points = this.shiftToModuleCenter(points);
            const topLeft = points[0];
            const bottomLeft = points[1];
            const bottomRight = points[2];
            const topRight = points[3];
            let dimensionTop = this.transitionsBetween(topLeft, topRight) + 1;
            let dimensionRight = this.transitionsBetween(bottomRight, topRight) + 1;
            if ((dimensionTop & 0x01) === 1) dimensionTop += 1;
            if ((dimensionRight & 0x01) === 1) dimensionRight += 1;
            if (4 * dimensionTop < 7 * dimensionRight && 4 * dimensionRight < 7 * dimensionTop) // The matrix is square
            dimensionTop = dimensionRight = Math.max(dimensionTop, dimensionRight);
            let bits = Detector$1.sampleGrid(this.image, topLeft, bottomLeft, bottomRight, topRight, dimensionTop, dimensionRight);
            return new DetectorResult(bits, [
                topLeft,
                bottomLeft,
                bottomRight,
                topRight
            ]);
        }
        static shiftPoint(point, to, div) {
            let x = (to.getX() - point.getX()) / (div + 1);
            let y = (to.getY() - point.getY()) / (div + 1);
            return new ResultPoint(point.getX() + x, point.getY() + y);
        }
        static moveAway(point, fromX, fromY) {
            let x = point.getX();
            let y = point.getY();
            if (x < fromX) x -= 1;
            else x += 1;
            if (y < fromY) y -= 1;
            else y += 1;
            return new ResultPoint(x, y);
        }
        /**
         * Detect a solid side which has minimum transition.
         */ detectSolid1(cornerPoints) {
            // 0  2
            // 1  3
            let pointA = cornerPoints[0];
            let pointB = cornerPoints[1];
            let pointC = cornerPoints[3];
            let pointD = cornerPoints[2];
            let trAB = this.transitionsBetween(pointA, pointB);
            let trBC = this.transitionsBetween(pointB, pointC);
            let trCD = this.transitionsBetween(pointC, pointD);
            let trDA = this.transitionsBetween(pointD, pointA);
            // 0..3
            // :  :
            // 1--2
            let min = trAB;
            let points = [
                pointD,
                pointA,
                pointB,
                pointC
            ];
            if (min > trBC) {
                min = trBC;
                points[0] = pointA;
                points[1] = pointB;
                points[2] = pointC;
                points[3] = pointD;
            }
            if (min > trCD) {
                min = trCD;
                points[0] = pointB;
                points[1] = pointC;
                points[2] = pointD;
                points[3] = pointA;
            }
            if (min > trDA) {
                points[0] = pointC;
                points[1] = pointD;
                points[2] = pointA;
                points[3] = pointB;
            }
            return points;
        }
        /**
         * Detect a second solid side next to first solid side.
         */ detectSolid2(points) {
            // A..D
            // :  :
            // B--C
            let pointA = points[0];
            let pointB = points[1];
            let pointC = points[2];
            let pointD = points[3];
            // Transition detection on the edge is not stable.
            // To safely detect, shift the points to the module center.
            let tr = this.transitionsBetween(pointA, pointD);
            let pointBs = Detector$1.shiftPoint(pointB, pointC, (tr + 1) * 4);
            let pointCs = Detector$1.shiftPoint(pointC, pointB, (tr + 1) * 4);
            let trBA = this.transitionsBetween(pointBs, pointA);
            let trCD = this.transitionsBetween(pointCs, pointD);
            // 0..3
            // |  :
            // 1--2
            if (trBA < trCD) {
                // solid sides: A-B-C
                points[0] = pointA;
                points[1] = pointB;
                points[2] = pointC;
                points[3] = pointD;
            } else {
                // solid sides: B-C-D
                points[0] = pointB;
                points[1] = pointC;
                points[2] = pointD;
                points[3] = pointA;
            }
            return points;
        }
        /**
         * Calculates the corner position of the white top right module.
         */ correctTopRight(points) {
            // A..D
            // |  :
            // B--C
            let pointA = points[0];
            let pointB = points[1];
            let pointC = points[2];
            let pointD = points[3];
            // shift points for safe transition detection.
            let trTop = this.transitionsBetween(pointA, pointD);
            let trRight = this.transitionsBetween(pointB, pointD);
            let pointAs = Detector$1.shiftPoint(pointA, pointB, (trRight + 1) * 4);
            let pointCs = Detector$1.shiftPoint(pointC, pointB, (trTop + 1) * 4);
            trTop = this.transitionsBetween(pointAs, pointD);
            trRight = this.transitionsBetween(pointCs, pointD);
            let candidate1 = new ResultPoint(pointD.getX() + (pointC.getX() - pointB.getX()) / (trTop + 1), pointD.getY() + (pointC.getY() - pointB.getY()) / (trTop + 1));
            let candidate2 = new ResultPoint(pointD.getX() + (pointA.getX() - pointB.getX()) / (trRight + 1), pointD.getY() + (pointA.getY() - pointB.getY()) / (trRight + 1));
            if (!this.isValid(candidate1)) {
                if (this.isValid(candidate2)) return candidate2;
                return null;
            }
            if (!this.isValid(candidate2)) return candidate1;
            let sumc1 = this.transitionsBetween(pointAs, candidate1) + this.transitionsBetween(pointCs, candidate1);
            let sumc2 = this.transitionsBetween(pointAs, candidate2) + this.transitionsBetween(pointCs, candidate2);
            if (sumc1 > sumc2) return candidate1;
            else return candidate2;
        }
        /**
         * Shift the edge points to the module center.
         */ shiftToModuleCenter(points) {
            // A..D
            // |  :
            // B--C
            let pointA = points[0];
            let pointB = points[1];
            let pointC = points[2];
            let pointD = points[3];
            // calculate pseudo dimensions
            let dimH = this.transitionsBetween(pointA, pointD) + 1;
            let dimV = this.transitionsBetween(pointC, pointD) + 1;
            // shift points for safe dimension detection
            let pointAs = Detector$1.shiftPoint(pointA, pointB, dimV * 4);
            let pointCs = Detector$1.shiftPoint(pointC, pointB, dimH * 4);
            //  calculate more precise dimensions
            dimH = this.transitionsBetween(pointAs, pointD) + 1;
            dimV = this.transitionsBetween(pointCs, pointD) + 1;
            if ((dimH & 0x01) === 1) dimH += 1;
            if ((dimV & 0x01) === 1) dimV += 1;
            // WhiteRectangleDetector returns points inside of the rectangle.
            // I want points on the edges.
            let centerX = (pointA.getX() + pointB.getX() + pointC.getX() + pointD.getX()) / 4;
            let centerY = (pointA.getY() + pointB.getY() + pointC.getY() + pointD.getY()) / 4;
            pointA = Detector$1.moveAway(pointA, centerX, centerY);
            pointB = Detector$1.moveAway(pointB, centerX, centerY);
            pointC = Detector$1.moveAway(pointC, centerX, centerY);
            pointD = Detector$1.moveAway(pointD, centerX, centerY);
            let pointBs;
            let pointDs;
            // shift points to the center of each modules
            pointAs = Detector$1.shiftPoint(pointA, pointB, dimV * 4);
            pointAs = Detector$1.shiftPoint(pointAs, pointD, dimH * 4);
            pointBs = Detector$1.shiftPoint(pointB, pointA, dimV * 4);
            pointBs = Detector$1.shiftPoint(pointBs, pointC, dimH * 4);
            pointCs = Detector$1.shiftPoint(pointC, pointD, dimV * 4);
            pointCs = Detector$1.shiftPoint(pointCs, pointB, dimH * 4);
            pointDs = Detector$1.shiftPoint(pointD, pointC, dimV * 4);
            pointDs = Detector$1.shiftPoint(pointDs, pointA, dimH * 4);
            return [
                pointAs,
                pointBs,
                pointCs,
                pointDs
            ];
        }
        isValid(p) {
            return p.getX() >= 0 && p.getX() < this.image.getWidth() && p.getY() > 0 && p.getY() < this.image.getHeight();
        }
        static sampleGrid(image, topLeft, bottomLeft, bottomRight, topRight, dimensionX, dimensionY) {
            const sampler = GridSamplerInstance.getInstance();
            return sampler.sampleGrid(image, dimensionX, dimensionY, 0.5, 0.5, dimensionX - 0.5, 0.5, dimensionX - 0.5, dimensionY - 0.5, 0.5, dimensionY - 0.5, topLeft.getX(), topLeft.getY(), topRight.getX(), topRight.getY(), bottomRight.getX(), bottomRight.getY(), bottomLeft.getX(), bottomLeft.getY());
        }
        /**
         * Counts the number of black/white transitions between two points, using something like Bresenham's algorithm.
         */ transitionsBetween(from, to) {
            // See QR Code Detector, sizeOfBlackWhiteBlackRun()
            let fromX = Math.trunc(from.getX());
            let fromY = Math.trunc(from.getY());
            let toX = Math.trunc(to.getX());
            let toY = Math.trunc(to.getY());
            let steep = Math.abs(toY - fromY) > Math.abs(toX - fromX);
            if (steep) {
                let temp = fromX;
                fromX = fromY;
                fromY = temp;
                temp = toX;
                toX = toY;
                toY = temp;
            }
            let dx = Math.abs(toX - fromX);
            let dy = Math.abs(toY - fromY);
            let error = -dx / 2;
            let ystep = fromY < toY ? 1 : -1;
            let xstep = fromX < toX ? 1 : -1;
            let transitions = 0;
            let inBlack = this.image.get(steep ? fromY : fromX, steep ? fromX : fromY);
            for(let x = fromX, y = fromY; x !== toX; x += xstep){
                let isBlack = this.image.get(steep ? y : x, steep ? x : y);
                if (isBlack !== inBlack) {
                    transitions++;
                    inBlack = isBlack;
                }
                error += dy;
                if (error > 0) {
                    if (y === toY) break;
                    y += ystep;
                    error -= dx;
                }
            }
            return transitions;
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * This implementation can detect and decode Data Matrix codes in an image.
     *
     * @author bbrown@google.com (Brian Brown)
     */ class DataMatrixReader {
        constructor(){
            this.decoder = new Decoder$1();
        }
        /**
         * Locates and decodes a Data Matrix code in an image.
         *
         * @return a String representing the content encoded by the Data Matrix code
         * @throws NotFoundException if a Data Matrix code cannot be found
         * @throws FormatException if a Data Matrix code cannot be decoded
         * @throws ChecksumException if error correction fails
         */ // @Override
        // public Result decode(BinaryBitmap image) throws NotFoundException, ChecksumException, FormatException {
        //   return decode(image, null);
        // }
        // @Override
        decode(image, hints = null) {
            let decoderResult;
            let points;
            if (hints != null && hints.has(DecodeHintType$1.PURE_BARCODE)) {
                const bits = DataMatrixReader.extractPureBits(image.getBlackMatrix());
                decoderResult = this.decoder.decode(bits);
                points = DataMatrixReader.NO_POINTS;
            } else {
                const detectorResult = new Detector$1(image.getBlackMatrix()).detect();
                decoderResult = this.decoder.decode(detectorResult.getBits());
                points = detectorResult.getPoints();
            }
            const rawBytes = decoderResult.getRawBytes();
            const result = new Result(decoderResult.getText(), rawBytes, 8 * rawBytes.length, points, BarcodeFormat$1.DATA_MATRIX, System.currentTimeMillis());
            const byteSegments = decoderResult.getByteSegments();
            if (byteSegments != null) result.putMetadata(ResultMetadataType$1.BYTE_SEGMENTS, byteSegments);
            const ecLevel = decoderResult.getECLevel();
            if (ecLevel != null) result.putMetadata(ResultMetadataType$1.ERROR_CORRECTION_LEVEL, ecLevel);
            return result;
        }
        // @Override
        reset() {
        // do nothing
        }
        /**
         * This method detects a code in a "pure" image -- that is, pure monochrome image
         * which contains only an unrotated, unskewed, image of a code, with some white border
         * around it. This is a specialized method that works exceptionally fast in this special
         * case.
         *
         * @see com.google.zxing.qrcode.QRCodeReader#extractPureBits(BitMatrix)
         */ static extractPureBits(image) {
            const leftTopBlack = image.getTopLeftOnBit();
            const rightBottomBlack = image.getBottomRightOnBit();
            if (leftTopBlack == null || rightBottomBlack == null) throw new NotFoundException();
            const moduleSize = this.moduleSize(leftTopBlack, image);
            let top = leftTopBlack[1];
            const bottom = rightBottomBlack[1];
            let left = leftTopBlack[0];
            const right = rightBottomBlack[0];
            const matrixWidth = (right - left + 1) / moduleSize;
            const matrixHeight = (bottom - top + 1) / moduleSize;
            if (matrixWidth <= 0 || matrixHeight <= 0) throw new NotFoundException();
            // Push in the "border" by half the module width so that we start
            // sampling in the middle of the module. Just in case the image is a
            // little off, this will help recover.
            const nudge = moduleSize / 2;
            top += nudge;
            left += nudge;
            // Now just read off the bits
            const bits = new BitMatrix(matrixWidth, matrixHeight);
            for(let y = 0; y < matrixHeight; y++){
                const iOffset = top + y * moduleSize;
                for(let x = 0; x < matrixWidth; x++)if (image.get(left + x * moduleSize, iOffset)) bits.set(x, y);
            }
            return bits;
        }
        static moduleSize(leftTopBlack, image) {
            const width = image.getWidth();
            let x = leftTopBlack[0];
            const y = leftTopBlack[1];
            while(x < width && image.get(x, y))x++;
            if (x === width) throw new NotFoundException();
            const moduleSize = x - leftTopBlack[0];
            if (moduleSize === 0) throw new NotFoundException();
            return moduleSize;
        }
    }
    DataMatrixReader.NO_POINTS = [];
    /**
     * @deprecated Moving to @zxing/browser
     *
     * QR Code reader to use from browser.
     */ class BrowserDatamatrixCodeReader extends BrowserCodeReader {
        /**
         * Creates an instance of BrowserQRCodeReader.
         * @param {number} [timeBetweenScansMillis=500] the time delay between subsequent decode tries
         */ constructor(timeBetweenScansMillis = 500){
            super(new DataMatrixReader(), timeBetweenScansMillis);
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ var ErrorCorrectionLevelValues;
    (function(ErrorCorrectionLevelValues) {
        ErrorCorrectionLevelValues[ErrorCorrectionLevelValues["L"] = 0] = "L";
        ErrorCorrectionLevelValues[ErrorCorrectionLevelValues["M"] = 1] = "M";
        ErrorCorrectionLevelValues[ErrorCorrectionLevelValues["Q"] = 2] = "Q";
        ErrorCorrectionLevelValues[ErrorCorrectionLevelValues["H"] = 3] = "H";
    })(ErrorCorrectionLevelValues || (ErrorCorrectionLevelValues = {}));
    /**
     * <p>See ISO 18004:2006, 6.5.1. This enum encapsulates the four error correction levels
     * defined by the QR code standard.</p>
     *
     * @author Sean Owen
     */ class ErrorCorrectionLevel {
        constructor(value, stringValue, bits /*int*/ ){
            this.value = value;
            this.stringValue = stringValue;
            this.bits = bits;
            ErrorCorrectionLevel.FOR_BITS.set(bits, this);
            ErrorCorrectionLevel.FOR_VALUE.set(value, this);
        }
        getValue() {
            return this.value;
        }
        getBits() {
            return this.bits;
        }
        static fromString(s) {
            switch(s){
                case 'L':
                    return ErrorCorrectionLevel.L;
                case 'M':
                    return ErrorCorrectionLevel.M;
                case 'Q':
                    return ErrorCorrectionLevel.Q;
                case 'H':
                    return ErrorCorrectionLevel.H;
                default:
                    throw new ArgumentException(s + 'not available');
            }
        }
        toString() {
            return this.stringValue;
        }
        equals(o) {
            if (!(o instanceof ErrorCorrectionLevel)) return false;
            const other = o;
            return this.value === other.value;
        }
        /**
         * @param bits int containing the two bits encoding a QR Code's error correction level
         * @return ErrorCorrectionLevel representing the encoded error correction level
         */ static forBits(bits /*int*/ ) {
            if (bits < 0 || bits >= ErrorCorrectionLevel.FOR_BITS.size) throw new IllegalArgumentException();
            return ErrorCorrectionLevel.FOR_BITS.get(bits);
        }
    }
    ErrorCorrectionLevel.FOR_BITS = new Map();
    ErrorCorrectionLevel.FOR_VALUE = new Map();
    /** L = ~7% correction */ ErrorCorrectionLevel.L = new ErrorCorrectionLevel(ErrorCorrectionLevelValues.L, 'L', 0x01);
    /** M = ~15% correction */ ErrorCorrectionLevel.M = new ErrorCorrectionLevel(ErrorCorrectionLevelValues.M, 'M', 0x00);
    /** Q = ~25% correction */ ErrorCorrectionLevel.Q = new ErrorCorrectionLevel(ErrorCorrectionLevelValues.Q, 'Q', 0x03);
    /** H = ~30% correction */ ErrorCorrectionLevel.H = new ErrorCorrectionLevel(ErrorCorrectionLevelValues.H, 'H', 0x02);
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * <p>Encapsulates a QR Code's format information, including the data mask used and
     * error correction level.</p>
     *
     * @author Sean Owen
     * @see DataMask
     * @see ErrorCorrectionLevel
     */ class FormatInformation {
        constructor(formatInfo /*int*/ ){
            // Bits 3,4
            this.errorCorrectionLevel = ErrorCorrectionLevel.forBits(formatInfo >> 3 & 0x03);
            // Bottom 3 bits
            this.dataMask = /*(byte) */ formatInfo & 0x07;
        }
        static numBitsDiffering(a /*int*/ , b /*int*/ ) {
            return Integer.bitCount(a ^ b);
        }
        /**
         * @param maskedFormatInfo1 format info indicator, with mask still applied
         * @param maskedFormatInfo2 second copy of same info; both are checked at the same time
         *  to establish best match
         * @return information about the format it specifies, or {@code null}
         *  if doesn't seem to match any known pattern
         */ static decodeFormatInformation(maskedFormatInfo1 /*int*/ , maskedFormatInfo2 /*int*/ ) {
            const formatInfo = FormatInformation.doDecodeFormatInformation(maskedFormatInfo1, maskedFormatInfo2);
            if (formatInfo !== null) return formatInfo;
            // Should return null, but, some QR codes apparently
            // do not mask this info. Try again by actually masking the pattern
            // first
            return FormatInformation.doDecodeFormatInformation(maskedFormatInfo1 ^ FormatInformation.FORMAT_INFO_MASK_QR, maskedFormatInfo2 ^ FormatInformation.FORMAT_INFO_MASK_QR);
        }
        static doDecodeFormatInformation(maskedFormatInfo1 /*int*/ , maskedFormatInfo2 /*int*/ ) {
            // Find the int in FORMAT_INFO_DECODE_LOOKUP with fewest bits differing
            let bestDifference = Number.MAX_SAFE_INTEGER;
            let bestFormatInfo = 0;
            for (const decodeInfo of FormatInformation.FORMAT_INFO_DECODE_LOOKUP){
                const targetInfo = decodeInfo[0];
                if (targetInfo === maskedFormatInfo1 || targetInfo === maskedFormatInfo2) // Found an exact match
                return new FormatInformation(decodeInfo[1]);
                let bitsDifference = FormatInformation.numBitsDiffering(maskedFormatInfo1, targetInfo);
                if (bitsDifference < bestDifference) {
                    bestFormatInfo = decodeInfo[1];
                    bestDifference = bitsDifference;
                }
                if (maskedFormatInfo1 !== maskedFormatInfo2) {
                    // also try the other option
                    bitsDifference = FormatInformation.numBitsDiffering(maskedFormatInfo2, targetInfo);
                    if (bitsDifference < bestDifference) {
                        bestFormatInfo = decodeInfo[1];
                        bestDifference = bitsDifference;
                    }
                }
            }
            // Hamming distance of the 32 masked codes is 7, by construction, so <= 3 bits
            // differing means we found a match
            if (bestDifference <= 3) return new FormatInformation(bestFormatInfo);
            return null;
        }
        getErrorCorrectionLevel() {
            return this.errorCorrectionLevel;
        }
        getDataMask() {
            return this.dataMask;
        }
        /*@Override*/ hashCode() {
            return this.errorCorrectionLevel.getBits() << 3 | this.dataMask;
        }
        /*@Override*/ equals(o) {
            if (!(o instanceof FormatInformation)) return false;
            const other = o;
            return this.errorCorrectionLevel === other.errorCorrectionLevel && this.dataMask === other.dataMask;
        }
    }
    FormatInformation.FORMAT_INFO_MASK_QR = 0x5412;
    /**
     * See ISO 18004:2006, Annex C, Table C.1
     */ FormatInformation.FORMAT_INFO_DECODE_LOOKUP = [
        Int32Array.from([
            0x5412,
            0x00
        ]),
        Int32Array.from([
            0x5125,
            0x01
        ]),
        Int32Array.from([
            0x5E7C,
            0x02
        ]),
        Int32Array.from([
            0x5B4B,
            0x03
        ]),
        Int32Array.from([
            0x45F9,
            0x04
        ]),
        Int32Array.from([
            0x40CE,
            0x05
        ]),
        Int32Array.from([
            0x4F97,
            0x06
        ]),
        Int32Array.from([
            0x4AA0,
            0x07
        ]),
        Int32Array.from([
            0x77C4,
            0x08
        ]),
        Int32Array.from([
            0x72F3,
            0x09
        ]),
        Int32Array.from([
            0x7DAA,
            0x0A
        ]),
        Int32Array.from([
            0x789D,
            0x0B
        ]),
        Int32Array.from([
            0x662F,
            0x0C
        ]),
        Int32Array.from([
            0x6318,
            0x0D
        ]),
        Int32Array.from([
            0x6C41,
            0x0E
        ]),
        Int32Array.from([
            0x6976,
            0x0F
        ]),
        Int32Array.from([
            0x1689,
            0x10
        ]),
        Int32Array.from([
            0x13BE,
            0x11
        ]),
        Int32Array.from([
            0x1CE7,
            0x12
        ]),
        Int32Array.from([
            0x19D0,
            0x13
        ]),
        Int32Array.from([
            0x0762,
            0x14
        ]),
        Int32Array.from([
            0x0255,
            0x15
        ]),
        Int32Array.from([
            0x0D0C,
            0x16
        ]),
        Int32Array.from([
            0x083B,
            0x17
        ]),
        Int32Array.from([
            0x355F,
            0x18
        ]),
        Int32Array.from([
            0x3068,
            0x19
        ]),
        Int32Array.from([
            0x3F31,
            0x1A
        ]),
        Int32Array.from([
            0x3A06,
            0x1B
        ]),
        Int32Array.from([
            0x24B4,
            0x1C
        ]),
        Int32Array.from([
            0x2183,
            0x1D
        ]),
        Int32Array.from([
            0x2EDA,
            0x1E
        ]),
        Int32Array.from([
            0x2BED,
            0x1F
        ])
    ];
    /**
     * <p>Encapsulates a set of error-correction blocks in one symbol version. Most versions will
     * use blocks of differing sizes within one version, so, this encapsulates the parameters for
     * each set of blocks. It also holds the number of error-correction codewords per block since it
     * will be the same across all blocks within one version.</p>
     */ class ECBlocks$1 {
        constructor(ecCodewordsPerBlock /*int*/ , ...ecBlocks){
            this.ecCodewordsPerBlock = ecCodewordsPerBlock;
            this.ecBlocks = ecBlocks;
        }
        getECCodewordsPerBlock() {
            return this.ecCodewordsPerBlock;
        }
        getNumBlocks() {
            let total = 0;
            const ecBlocks = this.ecBlocks;
            for (const ecBlock of ecBlocks)total += ecBlock.getCount();
            return total;
        }
        getTotalECCodewords() {
            return this.ecCodewordsPerBlock * this.getNumBlocks();
        }
        getECBlocks() {
            return this.ecBlocks;
        }
    }
    /**
     * <p>Encapsulates the parameters for one error-correction block in one symbol version.
     * This includes the number of data codewords, and the number of times a block with these
     * parameters is used consecutively in the QR code version's format.</p>
     */ class ECB$1 {
        constructor(count /*int*/ , dataCodewords /*int*/ ){
            this.count = count;
            this.dataCodewords = dataCodewords;
        }
        getCount() {
            return this.count;
        }
        getDataCodewords() {
            return this.dataCodewords;
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * See ISO 18004:2006 Annex D
     *
     * @author Sean Owen
     */ class Version$1 {
        constructor(versionNumber /*int*/ , alignmentPatternCenters, ...ecBlocks){
            this.versionNumber = versionNumber;
            this.alignmentPatternCenters = alignmentPatternCenters;
            this.ecBlocks = ecBlocks;
            let total = 0;
            const ecCodewords = ecBlocks[0].getECCodewordsPerBlock();
            const ecbArray = ecBlocks[0].getECBlocks();
            for (const ecBlock of ecbArray)total += ecBlock.getCount() * (ecBlock.getDataCodewords() + ecCodewords);
            this.totalCodewords = total;
        }
        getVersionNumber() {
            return this.versionNumber;
        }
        getAlignmentPatternCenters() {
            return this.alignmentPatternCenters;
        }
        getTotalCodewords() {
            return this.totalCodewords;
        }
        getDimensionForVersion() {
            return 17 + 4 * this.versionNumber;
        }
        getECBlocksForLevel(ecLevel) {
            return this.ecBlocks[ecLevel.getValue()];
        // TYPESCRIPTPORT: original was using ordinal, and using the order of levels as defined in ErrorCorrectionLevel enum (LMQH)
        // I will use the direct value from ErrorCorrectionLevelValues enum which in typescript goes to a number
        }
        /**
         * <p>Deduces version information purely from QR Code dimensions.</p>
         *
         * @param dimension dimension in modules
         * @return Version for a QR Code of that dimension
         * @throws FormatException if dimension is not 1 mod 4
         */ static getProvisionalVersionForDimension(dimension /*int*/ ) {
            if (dimension % 4 !== 1) throw new FormatException();
            try {
                return this.getVersionForNumber((dimension - 17) / 4);
            } catch (ignored /*: IllegalArgumentException*/ ) {
                throw new FormatException();
            }
        }
        static getVersionForNumber(versionNumber /*int*/ ) {
            if (versionNumber < 1 || versionNumber > 40) throw new IllegalArgumentException();
            return Version$1.VERSIONS[versionNumber - 1];
        }
        static decodeVersionInformation(versionBits /*int*/ ) {
            let bestDifference = Number.MAX_SAFE_INTEGER;
            let bestVersion = 0;
            for(let i = 0; i < Version$1.VERSION_DECODE_INFO.length; i++){
                const targetVersion = Version$1.VERSION_DECODE_INFO[i];
                // Do the version info bits match exactly? done.
                if (targetVersion === versionBits) return Version$1.getVersionForNumber(i + 7);
                // Otherwise see if this is the closest to a real version info bit string
                // we have seen so far
                const bitsDifference = FormatInformation.numBitsDiffering(versionBits, targetVersion);
                if (bitsDifference < bestDifference) {
                    bestVersion = i + 7;
                    bestDifference = bitsDifference;
                }
            }
            // We can tolerate up to 3 bits of error since no two version info codewords will
            // differ in less than 8 bits.
            if (bestDifference <= 3) return Version$1.getVersionForNumber(bestVersion);
            // If we didn't find a close enough match, fail
            return null;
        }
        /**
         * See ISO 18004:2006 Annex E
         */ buildFunctionPattern() {
            const dimension = this.getDimensionForVersion();
            const bitMatrix = new BitMatrix(dimension);
            // Top left finder pattern + separator + format
            bitMatrix.setRegion(0, 0, 9, 9);
            // Top right finder pattern + separator + format
            bitMatrix.setRegion(dimension - 8, 0, 8, 9);
            // Bottom left finder pattern + separator + format
            bitMatrix.setRegion(0, dimension - 8, 9, 8);
            // Alignment patterns
            const max = this.alignmentPatternCenters.length;
            for(let x = 0; x < max; x++){
                const i = this.alignmentPatternCenters[x] - 2;
                for(let y = 0; y < max; y++){
                    if (x === 0 && (y === 0 || y === max - 1) || x === max - 1 && y === 0) continue;
                    bitMatrix.setRegion(this.alignmentPatternCenters[y] - 2, i, 5, 5);
                }
            }
            // Vertical timing pattern
            bitMatrix.setRegion(6, 9, 1, dimension - 17);
            // Horizontal timing pattern
            bitMatrix.setRegion(9, 6, dimension - 17, 1);
            if (this.versionNumber > 6) {
                // Version info, top right
                bitMatrix.setRegion(dimension - 11, 0, 3, 6);
                // Version info, bottom left
                bitMatrix.setRegion(0, dimension - 11, 6, 3);
            }
            return bitMatrix;
        }
        /*@Override*/ toString() {
            return '' + this.versionNumber;
        }
    }
    /**
       * See ISO 18004:2006 Annex D.
       * Element i represents the raw version bits that specify version i + 7
       */ Version$1.VERSION_DECODE_INFO = Int32Array.from([
        0x07C94,
        0x085BC,
        0x09A99,
        0x0A4D3,
        0x0BBF6,
        0x0C762,
        0x0D847,
        0x0E60D,
        0x0F928,
        0x10B78,
        0x1145D,
        0x12A17,
        0x13532,
        0x149A6,
        0x15683,
        0x168C9,
        0x177EC,
        0x18EC4,
        0x191E1,
        0x1AFAB,
        0x1B08E,
        0x1CC1A,
        0x1D33F,
        0x1ED75,
        0x1F250,
        0x209D5,
        0x216F0,
        0x228BA,
        0x2379F,
        0x24B0B,
        0x2542E,
        0x26A64,
        0x27541,
        0x28C69
    ]);
    /**
       * See ISO 18004:2006 6.5.1 Table 9
       */ Version$1.VERSIONS = [
        new Version$1(1, new Int32Array(0), new ECBlocks$1(7, new ECB$1(1, 19)), new ECBlocks$1(10, new ECB$1(1, 16)), new ECBlocks$1(13, new ECB$1(1, 13)), new ECBlocks$1(17, new ECB$1(1, 9))),
        new Version$1(2, Int32Array.from([
            6,
            18
        ]), new ECBlocks$1(10, new ECB$1(1, 34)), new ECBlocks$1(16, new ECB$1(1, 28)), new ECBlocks$1(22, new ECB$1(1, 22)), new ECBlocks$1(28, new ECB$1(1, 16))),
        new Version$1(3, Int32Array.from([
            6,
            22
        ]), new ECBlocks$1(15, new ECB$1(1, 55)), new ECBlocks$1(26, new ECB$1(1, 44)), new ECBlocks$1(18, new ECB$1(2, 17)), new ECBlocks$1(22, new ECB$1(2, 13))),
        new Version$1(4, Int32Array.from([
            6,
            26
        ]), new ECBlocks$1(20, new ECB$1(1, 80)), new ECBlocks$1(18, new ECB$1(2, 32)), new ECBlocks$1(26, new ECB$1(2, 24)), new ECBlocks$1(16, new ECB$1(4, 9))),
        new Version$1(5, Int32Array.from([
            6,
            30
        ]), new ECBlocks$1(26, new ECB$1(1, 108)), new ECBlocks$1(24, new ECB$1(2, 43)), new ECBlocks$1(18, new ECB$1(2, 15), new ECB$1(2, 16)), new ECBlocks$1(22, new ECB$1(2, 11), new ECB$1(2, 12))),
        new Version$1(6, Int32Array.from([
            6,
            34
        ]), new ECBlocks$1(18, new ECB$1(2, 68)), new ECBlocks$1(16, new ECB$1(4, 27)), new ECBlocks$1(24, new ECB$1(4, 19)), new ECBlocks$1(28, new ECB$1(4, 15))),
        new Version$1(7, Int32Array.from([
            6,
            22,
            38
        ]), new ECBlocks$1(20, new ECB$1(2, 78)), new ECBlocks$1(18, new ECB$1(4, 31)), new ECBlocks$1(18, new ECB$1(2, 14), new ECB$1(4, 15)), new ECBlocks$1(26, new ECB$1(4, 13), new ECB$1(1, 14))),
        new Version$1(8, Int32Array.from([
            6,
            24,
            42
        ]), new ECBlocks$1(24, new ECB$1(2, 97)), new ECBlocks$1(22, new ECB$1(2, 38), new ECB$1(2, 39)), new ECBlocks$1(22, new ECB$1(4, 18), new ECB$1(2, 19)), new ECBlocks$1(26, new ECB$1(4, 14), new ECB$1(2, 15))),
        new Version$1(9, Int32Array.from([
            6,
            26,
            46
        ]), new ECBlocks$1(30, new ECB$1(2, 116)), new ECBlocks$1(22, new ECB$1(3, 36), new ECB$1(2, 37)), new ECBlocks$1(20, new ECB$1(4, 16), new ECB$1(4, 17)), new ECBlocks$1(24, new ECB$1(4, 12), new ECB$1(4, 13))),
        new Version$1(10, Int32Array.from([
            6,
            28,
            50
        ]), new ECBlocks$1(18, new ECB$1(2, 68), new ECB$1(2, 69)), new ECBlocks$1(26, new ECB$1(4, 43), new ECB$1(1, 44)), new ECBlocks$1(24, new ECB$1(6, 19), new ECB$1(2, 20)), new ECBlocks$1(28, new ECB$1(6, 15), new ECB$1(2, 16))),
        new Version$1(11, Int32Array.from([
            6,
            30,
            54
        ]), new ECBlocks$1(20, new ECB$1(4, 81)), new ECBlocks$1(30, new ECB$1(1, 50), new ECB$1(4, 51)), new ECBlocks$1(28, new ECB$1(4, 22), new ECB$1(4, 23)), new ECBlocks$1(24, new ECB$1(3, 12), new ECB$1(8, 13))),
        new Version$1(12, Int32Array.from([
            6,
            32,
            58
        ]), new ECBlocks$1(24, new ECB$1(2, 92), new ECB$1(2, 93)), new ECBlocks$1(22, new ECB$1(6, 36), new ECB$1(2, 37)), new ECBlocks$1(26, new ECB$1(4, 20), new ECB$1(6, 21)), new ECBlocks$1(28, new ECB$1(7, 14), new ECB$1(4, 15))),
        new Version$1(13, Int32Array.from([
            6,
            34,
            62
        ]), new ECBlocks$1(26, new ECB$1(4, 107)), new ECBlocks$1(22, new ECB$1(8, 37), new ECB$1(1, 38)), new ECBlocks$1(24, new ECB$1(8, 20), new ECB$1(4, 21)), new ECBlocks$1(22, new ECB$1(12, 11), new ECB$1(4, 12))),
        new Version$1(14, Int32Array.from([
            6,
            26,
            46,
            66
        ]), new ECBlocks$1(30, new ECB$1(3, 115), new ECB$1(1, 116)), new ECBlocks$1(24, new ECB$1(4, 40), new ECB$1(5, 41)), new ECBlocks$1(20, new ECB$1(11, 16), new ECB$1(5, 17)), new ECBlocks$1(24, new ECB$1(11, 12), new ECB$1(5, 13))),
        new Version$1(15, Int32Array.from([
            6,
            26,
            48,
            70
        ]), new ECBlocks$1(22, new ECB$1(5, 87), new ECB$1(1, 88)), new ECBlocks$1(24, new ECB$1(5, 41), new ECB$1(5, 42)), new ECBlocks$1(30, new ECB$1(5, 24), new ECB$1(7, 25)), new ECBlocks$1(24, new ECB$1(11, 12), new ECB$1(7, 13))),
        new Version$1(16, Int32Array.from([
            6,
            26,
            50,
            74
        ]), new ECBlocks$1(24, new ECB$1(5, 98), new ECB$1(1, 99)), new ECBlocks$1(28, new ECB$1(7, 45), new ECB$1(3, 46)), new ECBlocks$1(24, new ECB$1(15, 19), new ECB$1(2, 20)), new ECBlocks$1(30, new ECB$1(3, 15), new ECB$1(13, 16))),
        new Version$1(17, Int32Array.from([
            6,
            30,
            54,
            78
        ]), new ECBlocks$1(28, new ECB$1(1, 107), new ECB$1(5, 108)), new ECBlocks$1(28, new ECB$1(10, 46), new ECB$1(1, 47)), new ECBlocks$1(28, new ECB$1(1, 22), new ECB$1(15, 23)), new ECBlocks$1(28, new ECB$1(2, 14), new ECB$1(17, 15))),
        new Version$1(18, Int32Array.from([
            6,
            30,
            56,
            82
        ]), new ECBlocks$1(30, new ECB$1(5, 120), new ECB$1(1, 121)), new ECBlocks$1(26, new ECB$1(9, 43), new ECB$1(4, 44)), new ECBlocks$1(28, new ECB$1(17, 22), new ECB$1(1, 23)), new ECBlocks$1(28, new ECB$1(2, 14), new ECB$1(19, 15))),
        new Version$1(19, Int32Array.from([
            6,
            30,
            58,
            86
        ]), new ECBlocks$1(28, new ECB$1(3, 113), new ECB$1(4, 114)), new ECBlocks$1(26, new ECB$1(3, 44), new ECB$1(11, 45)), new ECBlocks$1(26, new ECB$1(17, 21), new ECB$1(4, 22)), new ECBlocks$1(26, new ECB$1(9, 13), new ECB$1(16, 14))),
        new Version$1(20, Int32Array.from([
            6,
            34,
            62,
            90
        ]), new ECBlocks$1(28, new ECB$1(3, 107), new ECB$1(5, 108)), new ECBlocks$1(26, new ECB$1(3, 41), new ECB$1(13, 42)), new ECBlocks$1(30, new ECB$1(15, 24), new ECB$1(5, 25)), new ECBlocks$1(28, new ECB$1(15, 15), new ECB$1(10, 16))),
        new Version$1(21, Int32Array.from([
            6,
            28,
            50,
            72,
            94
        ]), new ECBlocks$1(28, new ECB$1(4, 116), new ECB$1(4, 117)), new ECBlocks$1(26, new ECB$1(17, 42)), new ECBlocks$1(28, new ECB$1(17, 22), new ECB$1(6, 23)), new ECBlocks$1(30, new ECB$1(19, 16), new ECB$1(6, 17))),
        new Version$1(22, Int32Array.from([
            6,
            26,
            50,
            74,
            98
        ]), new ECBlocks$1(28, new ECB$1(2, 111), new ECB$1(7, 112)), new ECBlocks$1(28, new ECB$1(17, 46)), new ECBlocks$1(30, new ECB$1(7, 24), new ECB$1(16, 25)), new ECBlocks$1(24, new ECB$1(34, 13))),
        new Version$1(23, Int32Array.from([
            6,
            30,
            54,
            78,
            102
        ]), new ECBlocks$1(30, new ECB$1(4, 121), new ECB$1(5, 122)), new ECBlocks$1(28, new ECB$1(4, 47), new ECB$1(14, 48)), new ECBlocks$1(30, new ECB$1(11, 24), new ECB$1(14, 25)), new ECBlocks$1(30, new ECB$1(16, 15), new ECB$1(14, 16))),
        new Version$1(24, Int32Array.from([
            6,
            28,
            54,
            80,
            106
        ]), new ECBlocks$1(30, new ECB$1(6, 117), new ECB$1(4, 118)), new ECBlocks$1(28, new ECB$1(6, 45), new ECB$1(14, 46)), new ECBlocks$1(30, new ECB$1(11, 24), new ECB$1(16, 25)), new ECBlocks$1(30, new ECB$1(30, 16), new ECB$1(2, 17))),
        new Version$1(25, Int32Array.from([
            6,
            32,
            58,
            84,
            110
        ]), new ECBlocks$1(26, new ECB$1(8, 106), new ECB$1(4, 107)), new ECBlocks$1(28, new ECB$1(8, 47), new ECB$1(13, 48)), new ECBlocks$1(30, new ECB$1(7, 24), new ECB$1(22, 25)), new ECBlocks$1(30, new ECB$1(22, 15), new ECB$1(13, 16))),
        new Version$1(26, Int32Array.from([
            6,
            30,
            58,
            86,
            114
        ]), new ECBlocks$1(28, new ECB$1(10, 114), new ECB$1(2, 115)), new ECBlocks$1(28, new ECB$1(19, 46), new ECB$1(4, 47)), new ECBlocks$1(28, new ECB$1(28, 22), new ECB$1(6, 23)), new ECBlocks$1(30, new ECB$1(33, 16), new ECB$1(4, 17))),
        new Version$1(27, Int32Array.from([
            6,
            34,
            62,
            90,
            118
        ]), new ECBlocks$1(30, new ECB$1(8, 122), new ECB$1(4, 123)), new ECBlocks$1(28, new ECB$1(22, 45), new ECB$1(3, 46)), new ECBlocks$1(30, new ECB$1(8, 23), new ECB$1(26, 24)), new ECBlocks$1(30, new ECB$1(12, 15), new ECB$1(28, 16))),
        new Version$1(28, Int32Array.from([
            6,
            26,
            50,
            74,
            98,
            122
        ]), new ECBlocks$1(30, new ECB$1(3, 117), new ECB$1(10, 118)), new ECBlocks$1(28, new ECB$1(3, 45), new ECB$1(23, 46)), new ECBlocks$1(30, new ECB$1(4, 24), new ECB$1(31, 25)), new ECBlocks$1(30, new ECB$1(11, 15), new ECB$1(31, 16))),
        new Version$1(29, Int32Array.from([
            6,
            30,
            54,
            78,
            102,
            126
        ]), new ECBlocks$1(30, new ECB$1(7, 116), new ECB$1(7, 117)), new ECBlocks$1(28, new ECB$1(21, 45), new ECB$1(7, 46)), new ECBlocks$1(30, new ECB$1(1, 23), new ECB$1(37, 24)), new ECBlocks$1(30, new ECB$1(19, 15), new ECB$1(26, 16))),
        new Version$1(30, Int32Array.from([
            6,
            26,
            52,
            78,
            104,
            130
        ]), new ECBlocks$1(30, new ECB$1(5, 115), new ECB$1(10, 116)), new ECBlocks$1(28, new ECB$1(19, 47), new ECB$1(10, 48)), new ECBlocks$1(30, new ECB$1(15, 24), new ECB$1(25, 25)), new ECBlocks$1(30, new ECB$1(23, 15), new ECB$1(25, 16))),
        new Version$1(31, Int32Array.from([
            6,
            30,
            56,
            82,
            108,
            134
        ]), new ECBlocks$1(30, new ECB$1(13, 115), new ECB$1(3, 116)), new ECBlocks$1(28, new ECB$1(2, 46), new ECB$1(29, 47)), new ECBlocks$1(30, new ECB$1(42, 24), new ECB$1(1, 25)), new ECBlocks$1(30, new ECB$1(23, 15), new ECB$1(28, 16))),
        new Version$1(32, Int32Array.from([
            6,
            34,
            60,
            86,
            112,
            138
        ]), new ECBlocks$1(30, new ECB$1(17, 115)), new ECBlocks$1(28, new ECB$1(10, 46), new ECB$1(23, 47)), new ECBlocks$1(30, new ECB$1(10, 24), new ECB$1(35, 25)), new ECBlocks$1(30, new ECB$1(19, 15), new ECB$1(35, 16))),
        new Version$1(33, Int32Array.from([
            6,
            30,
            58,
            86,
            114,
            142
        ]), new ECBlocks$1(30, new ECB$1(17, 115), new ECB$1(1, 116)), new ECBlocks$1(28, new ECB$1(14, 46), new ECB$1(21, 47)), new ECBlocks$1(30, new ECB$1(29, 24), new ECB$1(19, 25)), new ECBlocks$1(30, new ECB$1(11, 15), new ECB$1(46, 16))),
        new Version$1(34, Int32Array.from([
            6,
            34,
            62,
            90,
            118,
            146
        ]), new ECBlocks$1(30, new ECB$1(13, 115), new ECB$1(6, 116)), new ECBlocks$1(28, new ECB$1(14, 46), new ECB$1(23, 47)), new ECBlocks$1(30, new ECB$1(44, 24), new ECB$1(7, 25)), new ECBlocks$1(30, new ECB$1(59, 16), new ECB$1(1, 17))),
        new Version$1(35, Int32Array.from([
            6,
            30,
            54,
            78,
            102,
            126,
            150
        ]), new ECBlocks$1(30, new ECB$1(12, 121), new ECB$1(7, 122)), new ECBlocks$1(28, new ECB$1(12, 47), new ECB$1(26, 48)), new ECBlocks$1(30, new ECB$1(39, 24), new ECB$1(14, 25)), new ECBlocks$1(30, new ECB$1(22, 15), new ECB$1(41, 16))),
        new Version$1(36, Int32Array.from([
            6,
            24,
            50,
            76,
            102,
            128,
            154
        ]), new ECBlocks$1(30, new ECB$1(6, 121), new ECB$1(14, 122)), new ECBlocks$1(28, new ECB$1(6, 47), new ECB$1(34, 48)), new ECBlocks$1(30, new ECB$1(46, 24), new ECB$1(10, 25)), new ECBlocks$1(30, new ECB$1(2, 15), new ECB$1(64, 16))),
        new Version$1(37, Int32Array.from([
            6,
            28,
            54,
            80,
            106,
            132,
            158
        ]), new ECBlocks$1(30, new ECB$1(17, 122), new ECB$1(4, 123)), new ECBlocks$1(28, new ECB$1(29, 46), new ECB$1(14, 47)), new ECBlocks$1(30, new ECB$1(49, 24), new ECB$1(10, 25)), new ECBlocks$1(30, new ECB$1(24, 15), new ECB$1(46, 16))),
        new Version$1(38, Int32Array.from([
            6,
            32,
            58,
            84,
            110,
            136,
            162
        ]), new ECBlocks$1(30, new ECB$1(4, 122), new ECB$1(18, 123)), new ECBlocks$1(28, new ECB$1(13, 46), new ECB$1(32, 47)), new ECBlocks$1(30, new ECB$1(48, 24), new ECB$1(14, 25)), new ECBlocks$1(30, new ECB$1(42, 15), new ECB$1(32, 16))),
        new Version$1(39, Int32Array.from([
            6,
            26,
            54,
            82,
            110,
            138,
            166
        ]), new ECBlocks$1(30, new ECB$1(20, 117), new ECB$1(4, 118)), new ECBlocks$1(28, new ECB$1(40, 47), new ECB$1(7, 48)), new ECBlocks$1(30, new ECB$1(43, 24), new ECB$1(22, 25)), new ECBlocks$1(30, new ECB$1(10, 15), new ECB$1(67, 16))),
        new Version$1(40, Int32Array.from([
            6,
            30,
            58,
            86,
            114,
            142,
            170
        ]), new ECBlocks$1(30, new ECB$1(19, 118), new ECB$1(6, 119)), new ECBlocks$1(28, new ECB$1(18, 47), new ECB$1(31, 48)), new ECBlocks$1(30, new ECB$1(34, 24), new ECB$1(34, 25)), new ECBlocks$1(30, new ECB$1(20, 15), new ECB$1(61, 16)))
    ];
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ var DataMaskValues;
    (function(DataMaskValues) {
        DataMaskValues[DataMaskValues["DATA_MASK_000"] = 0] = "DATA_MASK_000";
        DataMaskValues[DataMaskValues["DATA_MASK_001"] = 1] = "DATA_MASK_001";
        DataMaskValues[DataMaskValues["DATA_MASK_010"] = 2] = "DATA_MASK_010";
        DataMaskValues[DataMaskValues["DATA_MASK_011"] = 3] = "DATA_MASK_011";
        DataMaskValues[DataMaskValues["DATA_MASK_100"] = 4] = "DATA_MASK_100";
        DataMaskValues[DataMaskValues["DATA_MASK_101"] = 5] = "DATA_MASK_101";
        DataMaskValues[DataMaskValues["DATA_MASK_110"] = 6] = "DATA_MASK_110";
        DataMaskValues[DataMaskValues["DATA_MASK_111"] = 7] = "DATA_MASK_111";
    })(DataMaskValues || (DataMaskValues = {}));
    /**
     * <p>Encapsulates data masks for the data bits in a QR code, per ISO 18004:2006 6.8. Implementations
     * of this class can un-mask a raw BitMatrix. For simplicity, they will unmask the entire BitMatrix,
     * including areas used for finder patterns, timing patterns, etc. These areas should be unused
     * after the point they are unmasked anyway.</p>
     *
     * <p>Note that the diagram in section 6.8.1 is misleading since it indicates that i is column position
     * and j is row position. In fact, as the text says, i is row position and j is column position.</p>
     *
     * @author Sean Owen
     */ class DataMask {
        // See ISO 18004:2006 6.8.1
        constructor(value, isMasked){
            this.value = value;
            this.isMasked = isMasked;
        }
        // End of enum constants.
        /**
         * <p>Implementations of this method reverse the data masking process applied to a QR Code and
         * make its bits ready to read.</p>
         *
         * @param bits representation of QR Code bits
         * @param dimension dimension of QR Code, represented by bits, being unmasked
         */ unmaskBitMatrix(bits, dimension /*int*/ ) {
            for(let i = 0; i < dimension; i++){
                for(let j = 0; j < dimension; j++)if (this.isMasked(i, j)) bits.flip(j, i);
            }
        }
    }
    DataMask.values = new Map([
        /**
         * 000: mask bits for which (x + y) mod 2 == 0
         */ [
            DataMaskValues.DATA_MASK_000,
            new DataMask(DataMaskValues.DATA_MASK_000, (i /*int*/ , j /*int*/ )=>{
                return (i + j & 0x01) === 0;
            })
        ],
        /**
         * 001: mask bits for which x mod 2 == 0
         */ [
            DataMaskValues.DATA_MASK_001,
            new DataMask(DataMaskValues.DATA_MASK_001, (i /*int*/ , j /*int*/ )=>{
                return (i & 0x01) === 0;
            })
        ],
        /**
         * 010: mask bits for which y mod 3 == 0
         */ [
            DataMaskValues.DATA_MASK_010,
            new DataMask(DataMaskValues.DATA_MASK_010, (i /*int*/ , j /*int*/ )=>{
                return j % 3 === 0;
            })
        ],
        /**
         * 011: mask bits for which (x + y) mod 3 == 0
         */ [
            DataMaskValues.DATA_MASK_011,
            new DataMask(DataMaskValues.DATA_MASK_011, (i /*int*/ , j /*int*/ )=>{
                return (i + j) % 3 === 0;
            })
        ],
        /**
         * 100: mask bits for which (x/2 + y/3) mod 2 == 0
         */ [
            DataMaskValues.DATA_MASK_100,
            new DataMask(DataMaskValues.DATA_MASK_100, (i /*int*/ , j /*int*/ )=>{
                return (Math.floor(i / 2) + Math.floor(j / 3) & 0x01) === 0;
            })
        ],
        /**
         * 101: mask bits for which xy mod 2 + xy mod 3 == 0
         * equivalently, such that xy mod 6 == 0
         */ [
            DataMaskValues.DATA_MASK_101,
            new DataMask(DataMaskValues.DATA_MASK_101, (i /*int*/ , j /*int*/ )=>{
                return i * j % 6 === 0;
            })
        ],
        /**
         * 110: mask bits for which (xy mod 2 + xy mod 3) mod 2 == 0
         * equivalently, such that xy mod 6 < 3
         */ [
            DataMaskValues.DATA_MASK_110,
            new DataMask(DataMaskValues.DATA_MASK_110, (i /*int*/ , j /*int*/ )=>{
                return i * j % 6 < 3;
            })
        ],
        /**
         * 111: mask bits for which ((x+y)mod 2 + xy mod 3) mod 2 == 0
         * equivalently, such that (x + y + xy mod 3) mod 2 == 0
         */ [
            DataMaskValues.DATA_MASK_111,
            new DataMask(DataMaskValues.DATA_MASK_111, (i /*int*/ , j /*int*/ )=>{
                return (i + j + i * j % 3 & 0x01) === 0;
            })
        ]
    ]);
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * @author Sean Owen
     */ class BitMatrixParser$1 {
        /**
         * @param bitMatrix {@link BitMatrix} to parse
         * @throws FormatException if dimension is not >= 21 and 1 mod 4
         */ constructor(bitMatrix){
            const dimension = bitMatrix.getHeight();
            if (dimension < 21 || (dimension & 0x03) !== 1) throw new FormatException();
            this.bitMatrix = bitMatrix;
        }
        /**
         * <p>Reads format information from one of its two locations within the QR Code.</p>
         *
         * @return {@link FormatInformation} encapsulating the QR Code's format info
         * @throws FormatException if both format information locations cannot be parsed as
         * the valid encoding of format information
         */ readFormatInformation() {
            if (this.parsedFormatInfo !== null && this.parsedFormatInfo !== undefined) return this.parsedFormatInfo;
            // Read top-left format info bits
            let formatInfoBits1 = 0;
            for(let i = 0; i < 6; i++)formatInfoBits1 = this.copyBit(i, 8, formatInfoBits1);
            // .. and skip a bit in the timing pattern ...
            formatInfoBits1 = this.copyBit(7, 8, formatInfoBits1);
            formatInfoBits1 = this.copyBit(8, 8, formatInfoBits1);
            formatInfoBits1 = this.copyBit(8, 7, formatInfoBits1);
            // .. and skip a bit in the timing pattern ...
            for(let j = 5; j >= 0; j--)formatInfoBits1 = this.copyBit(8, j, formatInfoBits1);
            // Read the top-right/bottom-left pattern too
            const dimension = this.bitMatrix.getHeight();
            let formatInfoBits2 = 0;
            const jMin = dimension - 7;
            for(let j = dimension - 1; j >= jMin; j--)formatInfoBits2 = this.copyBit(8, j, formatInfoBits2);
            for(let i = dimension - 8; i < dimension; i++)formatInfoBits2 = this.copyBit(i, 8, formatInfoBits2);
            this.parsedFormatInfo = FormatInformation.decodeFormatInformation(formatInfoBits1, formatInfoBits2);
            if (this.parsedFormatInfo !== null) return this.parsedFormatInfo;
            throw new FormatException();
        }
        /**
         * <p>Reads version information from one of its two locations within the QR Code.</p>
         *
         * @return {@link Version} encapsulating the QR Code's version
         * @throws FormatException if both version information locations cannot be parsed as
         * the valid encoding of version information
         */ readVersion() {
            if (this.parsedVersion !== null && this.parsedVersion !== undefined) return this.parsedVersion;
            const dimension = this.bitMatrix.getHeight();
            const provisionalVersion = Math.floor((dimension - 17) / 4);
            if (provisionalVersion <= 6) return Version$1.getVersionForNumber(provisionalVersion);
            // Read top-right version info: 3 wide by 6 tall
            let versionBits = 0;
            const ijMin = dimension - 11;
            for(let j = 5; j >= 0; j--)for(let i = dimension - 9; i >= ijMin; i--)versionBits = this.copyBit(i, j, versionBits);
            let theParsedVersion = Version$1.decodeVersionInformation(versionBits);
            if (theParsedVersion !== null && theParsedVersion.getDimensionForVersion() === dimension) {
                this.parsedVersion = theParsedVersion;
                return theParsedVersion;
            }
            // Hmm, failed. Try bottom left: 6 wide by 3 tall
            versionBits = 0;
            for(let i = 5; i >= 0; i--)for(let j = dimension - 9; j >= ijMin; j--)versionBits = this.copyBit(i, j, versionBits);
            theParsedVersion = Version$1.decodeVersionInformation(versionBits);
            if (theParsedVersion !== null && theParsedVersion.getDimensionForVersion() === dimension) {
                this.parsedVersion = theParsedVersion;
                return theParsedVersion;
            }
            throw new FormatException();
        }
        copyBit(i /*int*/ , j /*int*/ , versionBits /*int*/ ) {
            const bit = this.isMirror ? this.bitMatrix.get(j, i) : this.bitMatrix.get(i, j);
            return bit ? versionBits << 1 | 0x1 : versionBits << 1;
        }
        /**
         * <p>Reads the bits in the {@link BitMatrix} representing the finder pattern in the
         * correct order in order to reconstruct the codewords bytes contained within the
         * QR Code.</p>
         *
         * @return bytes encoded within the QR Code
         * @throws FormatException if the exact number of bytes expected is not read
         */ readCodewords() {
            const formatInfo = this.readFormatInformation();
            const version = this.readVersion();
            // Get the data mask for the format used in this QR Code. This will exclude
            // some bits from reading as we wind through the bit matrix.
            const dataMask = DataMask.values.get(formatInfo.getDataMask());
            const dimension = this.bitMatrix.getHeight();
            dataMask.unmaskBitMatrix(this.bitMatrix, dimension);
            const functionPattern = version.buildFunctionPattern();
            let readingUp = true;
            const result = new Uint8Array(version.getTotalCodewords());
            let resultOffset = 0;
            let currentByte = 0;
            let bitsRead = 0;
            // Read columns in pairs, from right to left
            for(let j = dimension - 1; j > 0; j -= 2){
                if (j === 6) // Skip whole column with vertical alignment pattern
                // saves time and makes the other code proceed more cleanly
                j--;
                // Read alternatingly from bottom to top then top to bottom
                for(let count = 0; count < dimension; count++){
                    const i = readingUp ? dimension - 1 - count : count;
                    for(let col = 0; col < 2; col++)// Ignore bits covered by the function pattern
                    if (!functionPattern.get(j - col, i)) {
                        // Read a bit
                        bitsRead++;
                        currentByte <<= 1;
                        if (this.bitMatrix.get(j - col, i)) currentByte |= 1;
                        // If we've made a whole byte, save it off
                        if (bitsRead === 8) {
                            result[resultOffset++] = /*(byte) */ currentByte;
                            bitsRead = 0;
                            currentByte = 0;
                        }
                    }
                }
                readingUp = !readingUp; // readingUp ^= true; // readingUp = !readingUp; // switch directions
            }
            if (resultOffset !== version.getTotalCodewords()) throw new FormatException();
            return result;
        }
        /**
         * Revert the mask removal done while reading the code words. The bit matrix should revert to its original state.
         */ remask() {
            if (this.parsedFormatInfo === null) return; // We have no format information, and have no data mask
            const dataMask = DataMask.values[this.parsedFormatInfo.getDataMask()];
            const dimension = this.bitMatrix.getHeight();
            dataMask.unmaskBitMatrix(this.bitMatrix, dimension);
        }
        /**
         * Prepare the parser for a mirrored operation.
         * This flag has effect only on the {@link #readFormatInformation()} and the
         * {@link #readVersion()}. Before proceeding with {@link #readCodewords()} the
         * {@link #mirror()} method should be called.
         *
         * @param mirror Whether to read version and format information mirrored.
         */ setMirror(isMirror) {
            this.parsedVersion = null;
            this.parsedFormatInfo = null;
            this.isMirror = isMirror;
        }
        /** Mirror the bit matrix in order to attempt a second reading. */ mirror() {
            const bitMatrix = this.bitMatrix;
            for(let x = 0, width = bitMatrix.getWidth(); x < width; x++){
                for(let y = x + 1, height = bitMatrix.getHeight(); y < height; y++)if (bitMatrix.get(x, y) !== bitMatrix.get(y, x)) {
                    bitMatrix.flip(y, x);
                    bitMatrix.flip(x, y);
                }
            }
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * <p>Encapsulates a block of data within a QR Code. QR Codes may split their data into
     * multiple blocks, each of which is a unit of data and error-correction codewords. Each
     * is represented by an instance of this class.</p>
     *
     * @author Sean Owen
     */ class DataBlock$1 {
        constructor(numDataCodewords /*int*/ , codewords){
            this.numDataCodewords = numDataCodewords;
            this.codewords = codewords;
        }
        /**
         * <p>When QR Codes use multiple data blocks, they are actually interleaved.
         * That is, the first byte of data block 1 to n is written, then the second bytes, and so on. This
         * method will separate the data into original blocks.</p>
         *
         * @param rawCodewords bytes as read directly from the QR Code
         * @param version version of the QR Code
         * @param ecLevel error-correction level of the QR Code
         * @return DataBlocks containing original bytes, "de-interleaved" from representation in the
         *         QR Code
         */ static getDataBlocks(rawCodewords, version, ecLevel) {
            if (rawCodewords.length !== version.getTotalCodewords()) throw new IllegalArgumentException();
            // Figure out the number and size of data blocks used by this version and
            // error correction level
            const ecBlocks = version.getECBlocksForLevel(ecLevel);
            // First count the total number of data blocks
            let totalBlocks = 0;
            const ecBlockArray = ecBlocks.getECBlocks();
            for (const ecBlock of ecBlockArray)totalBlocks += ecBlock.getCount();
            // Now establish DataBlocks of the appropriate size and number of data codewords
            const result = new Array(totalBlocks);
            let numResultBlocks = 0;
            for (const ecBlock of ecBlockArray)for(let i = 0; i < ecBlock.getCount(); i++){
                const numDataCodewords = ecBlock.getDataCodewords();
                const numBlockCodewords = ecBlocks.getECCodewordsPerBlock() + numDataCodewords;
                result[numResultBlocks++] = new DataBlock$1(numDataCodewords, new Uint8Array(numBlockCodewords));
            }
            // All blocks have the same amount of data, except that the last n
            // (where n may be 0) have 1 more byte. Figure out where these start.
            const shorterBlocksTotalCodewords = result[0].codewords.length;
            let longerBlocksStartAt = result.length - 1;
            // TYPESCRIPTPORT: check length is correct here
            while(longerBlocksStartAt >= 0){
                const numCodewords = result[longerBlocksStartAt].codewords.length;
                if (numCodewords === shorterBlocksTotalCodewords) break;
                longerBlocksStartAt--;
            }
            longerBlocksStartAt++;
            const shorterBlocksNumDataCodewords = shorterBlocksTotalCodewords - ecBlocks.getECCodewordsPerBlock();
            // The last elements of result may be 1 element longer
            // first fill out as many elements as all of them have
            let rawCodewordsOffset = 0;
            for(let i = 0; i < shorterBlocksNumDataCodewords; i++)for(let j = 0; j < numResultBlocks; j++)result[j].codewords[i] = rawCodewords[rawCodewordsOffset++];
            // Fill out the last data block in the longer ones
            for(let j = longerBlocksStartAt; j < numResultBlocks; j++)result[j].codewords[shorterBlocksNumDataCodewords] = rawCodewords[rawCodewordsOffset++];
            // Now add in error correction blocks
            const max = result[0].codewords.length;
            for(let i = shorterBlocksNumDataCodewords; i < max; i++)for(let j = 0; j < numResultBlocks; j++){
                const iOffset = j < longerBlocksStartAt ? i : i + 1;
                result[j].codewords[iOffset] = rawCodewords[rawCodewordsOffset++];
            }
            return result;
        }
        getNumDataCodewords() {
            return this.numDataCodewords;
        }
        getCodewords() {
            return this.codewords;
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ var ModeValues;
    (function(ModeValues) {
        ModeValues[ModeValues["TERMINATOR"] = 0] = "TERMINATOR";
        ModeValues[ModeValues["NUMERIC"] = 1] = "NUMERIC";
        ModeValues[ModeValues["ALPHANUMERIC"] = 2] = "ALPHANUMERIC";
        ModeValues[ModeValues["STRUCTURED_APPEND"] = 3] = "STRUCTURED_APPEND";
        ModeValues[ModeValues["BYTE"] = 4] = "BYTE";
        ModeValues[ModeValues["ECI"] = 5] = "ECI";
        ModeValues[ModeValues["KANJI"] = 6] = "KANJI";
        ModeValues[ModeValues["FNC1_FIRST_POSITION"] = 7] = "FNC1_FIRST_POSITION";
        ModeValues[ModeValues["FNC1_SECOND_POSITION"] = 8] = "FNC1_SECOND_POSITION";
        /** See GBT 18284-2000; "Hanzi" is a transliteration of this mode name. */ ModeValues[ModeValues["HANZI"] = 9] = "HANZI";
    })(ModeValues || (ModeValues = {}));
    /**
     * <p>See ISO 18004:2006, 6.4.1, Tables 2 and 3. This enum encapsulates the various modes in which
     * data can be encoded to bits in the QR code standard.</p>
     *
     * @author Sean Owen
     */ class Mode$1 {
        constructor(value, stringValue, characterCountBitsForVersions, bits /*int*/ ){
            this.value = value;
            this.stringValue = stringValue;
            this.characterCountBitsForVersions = characterCountBitsForVersions;
            this.bits = bits;
            Mode$1.FOR_BITS.set(bits, this);
            Mode$1.FOR_VALUE.set(value, this);
        }
        /**
         * @param bits four bits encoding a QR Code data mode
         * @return Mode encoded by these bits
         * @throws IllegalArgumentException if bits do not correspond to a known mode
         */ static forBits(bits /*int*/ ) {
            const mode = Mode$1.FOR_BITS.get(bits);
            if (undefined === mode) throw new IllegalArgumentException();
            return mode;
        }
        /**
         * @param version version in question
         * @return number of bits used, in this QR Code symbol {@link Version}, to encode the
         *         count of characters that will follow encoded in this Mode
         */ getCharacterCountBits(version) {
            const versionNumber = version.getVersionNumber();
            let offset;
            if (versionNumber <= 9) offset = 0;
            else if (versionNumber <= 26) offset = 1;
            else offset = 2;
            return this.characterCountBitsForVersions[offset];
        }
        getValue() {
            return this.value;
        }
        getBits() {
            return this.bits;
        }
        equals(o) {
            if (!(o instanceof Mode$1)) return false;
            const other = o;
            return this.value === other.value;
        }
        toString() {
            return this.stringValue;
        }
    }
    Mode$1.FOR_BITS = new Map();
    Mode$1.FOR_VALUE = new Map();
    Mode$1.TERMINATOR = new Mode$1(ModeValues.TERMINATOR, 'TERMINATOR', Int32Array.from([
        0,
        0,
        0
    ]), 0x00); // Not really a mode...
    Mode$1.NUMERIC = new Mode$1(ModeValues.NUMERIC, 'NUMERIC', Int32Array.from([
        10,
        12,
        14
    ]), 0x01);
    Mode$1.ALPHANUMERIC = new Mode$1(ModeValues.ALPHANUMERIC, 'ALPHANUMERIC', Int32Array.from([
        9,
        11,
        13
    ]), 0x02);
    Mode$1.STRUCTURED_APPEND = new Mode$1(ModeValues.STRUCTURED_APPEND, 'STRUCTURED_APPEND', Int32Array.from([
        0,
        0,
        0
    ]), 0x03); // Not supported
    Mode$1.BYTE = new Mode$1(ModeValues.BYTE, 'BYTE', Int32Array.from([
        8,
        16,
        16
    ]), 0x04);
    Mode$1.ECI = new Mode$1(ModeValues.ECI, 'ECI', Int32Array.from([
        0,
        0,
        0
    ]), 0x07); // character counts don't apply
    Mode$1.KANJI = new Mode$1(ModeValues.KANJI, 'KANJI', Int32Array.from([
        8,
        10,
        12
    ]), 0x08);
    Mode$1.FNC1_FIRST_POSITION = new Mode$1(ModeValues.FNC1_FIRST_POSITION, 'FNC1_FIRST_POSITION', Int32Array.from([
        0,
        0,
        0
    ]), 0x05);
    Mode$1.FNC1_SECOND_POSITION = new Mode$1(ModeValues.FNC1_SECOND_POSITION, 'FNC1_SECOND_POSITION', Int32Array.from([
        0,
        0,
        0
    ]), 0x09);
    /** See GBT 18284-2000; "Hanzi" is a transliteration of this mode name. */ Mode$1.HANZI = new Mode$1(ModeValues.HANZI, 'HANZI', Int32Array.from([
        8,
        10,
        12
    ]), 0x0D);
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /*import java.io.UnsupportedEncodingException;*/ /*import java.util.ArrayList;*/ /*import java.util.Collection;*/ /*import java.util.List;*/ /*import java.util.Map;*/ /**
     * <p>QR Codes can encode text as bits in one of several modes, and can use multiple modes
     * in one QR Code. This class decodes the bits back into text.</p>
     *
     * <p>See ISO 18004:2006, 6.4.3 - 6.4.7</p>
     *
     * @author Sean Owen
     */ class DecodedBitStreamParser$1 {
        static decode(bytes, version, ecLevel, hints) {
            const bits = new BitSource(bytes);
            let result = new StringBuilder();
            const byteSegments = new Array(); // 1
            // TYPESCRIPTPORT: I do not use constructor with size 1 as in original Java means capacity and the array length is checked below
            let symbolSequence = -1;
            let parityData = -1;
            try {
                let currentCharacterSetECI = null;
                let fc1InEffect = false;
                let mode;
                do {
                    // While still another segment to read...
                    if (bits.available() < 4) // OK, assume we're done. Really, a TERMINATOR mode should have been recorded here
                    mode = Mode$1.TERMINATOR;
                    else {
                        const modeBits = bits.readBits(4);
                        mode = Mode$1.forBits(modeBits); // mode is encoded by 4 bits
                    }
                    switch(mode){
                        case Mode$1.TERMINATOR:
                            break;
                        case Mode$1.FNC1_FIRST_POSITION:
                        case Mode$1.FNC1_SECOND_POSITION:
                            // We do little with FNC1 except alter the parsed result a bit according to the spec
                            fc1InEffect = true;
                            break;
                        case Mode$1.STRUCTURED_APPEND:
                            if (bits.available() < 16) throw new FormatException();
                            // sequence number and parity is added later to the result metadata
                            // Read next 8 bits (symbol sequence #) and 8 bits (data: parity), then continue
                            symbolSequence = bits.readBits(8);
                            parityData = bits.readBits(8);
                            break;
                        case Mode$1.ECI:
                            // Count doesn't apply to ECI
                            const value = DecodedBitStreamParser$1.parseECIValue(bits);
                            currentCharacterSetECI = CharacterSetECI.getCharacterSetECIByValue(value);
                            if (currentCharacterSetECI === null) throw new FormatException();
                            break;
                        case Mode$1.HANZI:
                            // First handle Hanzi mode which does not start with character count
                            // Chinese mode contains a sub set indicator right after mode indicator
                            const subset = bits.readBits(4);
                            const countHanzi = bits.readBits(mode.getCharacterCountBits(version));
                            if (subset === DecodedBitStreamParser$1.GB2312_SUBSET) DecodedBitStreamParser$1.decodeHanziSegment(bits, result, countHanzi);
                            break;
                        default:
                            // "Normal" QR code modes:
                            // How many characters will follow, encoded in this mode?
                            const count = bits.readBits(mode.getCharacterCountBits(version));
                            switch(mode){
                                case Mode$1.NUMERIC:
                                    DecodedBitStreamParser$1.decodeNumericSegment(bits, result, count);
                                    break;
                                case Mode$1.ALPHANUMERIC:
                                    DecodedBitStreamParser$1.decodeAlphanumericSegment(bits, result, count, fc1InEffect);
                                    break;
                                case Mode$1.BYTE:
                                    DecodedBitStreamParser$1.decodeByteSegment(bits, result, count, currentCharacterSetECI, byteSegments, hints);
                                    break;
                                case Mode$1.KANJI:
                                    DecodedBitStreamParser$1.decodeKanjiSegment(bits, result, count);
                                    break;
                                default:
                                    throw new FormatException();
                            }
                            break;
                    }
                }while (mode !== Mode$1.TERMINATOR);
            } catch (iae /*: IllegalArgumentException*/ ) {
                // from readBits() calls
                throw new FormatException();
            }
            return new DecoderResult(bytes, result.toString(), byteSegments.length === 0 ? null : byteSegments, ecLevel === null ? null : ecLevel.toString(), symbolSequence, parityData);
        }
        /**
         * See specification GBT 18284-2000
         */ static decodeHanziSegment(bits, result, count /*int*/ ) {
            // Don't crash trying to read more bits than we have available.
            if (count * 13 > bits.available()) throw new FormatException();
            // Each character will require 2 bytes. Read the characters as 2-byte pairs
            // and decode as GB2312 afterwards
            const buffer = new Uint8Array(2 * count);
            let offset = 0;
            while(count > 0){
                // Each 13 bits encodes a 2-byte character
                const twoBytes = bits.readBits(13);
                let assembledTwoBytes = twoBytes / 0x060 << 8 & 0xFFFFFFFF | twoBytes % 0x060;
                if (assembledTwoBytes < 0x003BF) // In the 0xA1A1 to 0xAAFE range
                assembledTwoBytes += 0x0A1A1;
                else // In the 0xB0A1 to 0xFAFE range
                assembledTwoBytes += 0x0A6A1;
                buffer[offset] = /*(byte) */ assembledTwoBytes >> 8 & 0xFF;
                buffer[offset + 1] = /*(byte) */ assembledTwoBytes & 0xFF;
                offset += 2;
                count--;
            }
            try {
                result.append(StringEncoding.decode(buffer, StringUtils.GB2312));
            // TYPESCRIPTPORT: TODO: implement GB2312 decode. StringView from MDN could be a starting point
            } catch (ignored /*: UnsupportedEncodingException*/ ) {
                throw new FormatException(ignored);
            }
        }
        static decodeKanjiSegment(bits, result, count /*int*/ ) {
            // Don't crash trying to read more bits than we have available.
            if (count * 13 > bits.available()) throw new FormatException();
            // Each character will require 2 bytes. Read the characters as 2-byte pairs
            // and decode as Shift_JIS afterwards
            const buffer = new Uint8Array(2 * count);
            let offset = 0;
            while(count > 0){
                // Each 13 bits encodes a 2-byte character
                const twoBytes = bits.readBits(13);
                let assembledTwoBytes = twoBytes / 0x0C0 << 8 & 0xFFFFFFFF | twoBytes % 0x0C0;
                if (assembledTwoBytes < 0x01F00) // In the 0x8140 to 0x9FFC range
                assembledTwoBytes += 0x08140;
                else // In the 0xE040 to 0xEBBF range
                assembledTwoBytes += 0x0C140;
                buffer[offset] = /*(byte) */ assembledTwoBytes >> 8;
                buffer[offset + 1] = /*(byte) */ assembledTwoBytes;
                offset += 2;
                count--;
            }
            // Shift_JIS may not be supported in some environments:
            try {
                result.append(StringEncoding.decode(buffer, StringUtils.SHIFT_JIS));
            // TYPESCRIPTPORT: TODO: implement SHIFT_JIS decode. StringView from MDN could be a starting point
            } catch (ignored /*: UnsupportedEncodingException*/ ) {
                throw new FormatException(ignored);
            }
        }
        static decodeByteSegment(bits, result, count /*int*/ , currentCharacterSetECI, byteSegments, hints) {
            // Don't crash trying to read more bits than we have available.
            if (8 * count > bits.available()) throw new FormatException();
            const readBytes = new Uint8Array(count);
            for(let i = 0; i < count; i++)readBytes[i] = /*(byte) */ bits.readBits(8);
            let encoding;
            if (currentCharacterSetECI === null) // The spec isn't clear on this mode; see
            // section 6.4.5: t does not say which encoding to assuming
            // upon decoding. I have seen ISO-8859-1 used as well as
            // Shift_JIS -- without anything like an ECI designator to
            // give a hint.
            encoding = StringUtils.guessEncoding(readBytes, hints);
            else encoding = currentCharacterSetECI.getName();
            try {
                result.append(StringEncoding.decode(readBytes, encoding));
            } catch (ignored /*: UnsupportedEncodingException*/ ) {
                throw new FormatException(ignored);
            }
            byteSegments.push(readBytes);
        }
        static toAlphaNumericChar(value /*int*/ ) {
            if (value >= DecodedBitStreamParser$1.ALPHANUMERIC_CHARS.length) throw new FormatException();
            return DecodedBitStreamParser$1.ALPHANUMERIC_CHARS[value];
        }
        static decodeAlphanumericSegment(bits, result, count /*int*/ , fc1InEffect) {
            // Read two characters at a time
            const start = result.length();
            while(count > 1){
                if (bits.available() < 11) throw new FormatException();
                const nextTwoCharsBits = bits.readBits(11);
                result.append(DecodedBitStreamParser$1.toAlphaNumericChar(Math.floor(nextTwoCharsBits / 45)));
                result.append(DecodedBitStreamParser$1.toAlphaNumericChar(nextTwoCharsBits % 45));
                count -= 2;
            }
            if (count === 1) {
                // special case: one character left
                if (bits.available() < 6) throw new FormatException();
                result.append(DecodedBitStreamParser$1.toAlphaNumericChar(bits.readBits(6)));
            }
            // See section 6.4.8.1, 6.4.8.2
            if (fc1InEffect) {
                // We need to massage the result a bit if in an FNC1 mode:
                for(let i = start; i < result.length(); i++)if (result.charAt(i) === '%') {
                    if (i < result.length() - 1 && result.charAt(i + 1) === '%') // %% is rendered as %
                    result.deleteCharAt(i + 1);
                    else // In alpha mode, % should be converted to FNC1 separator 0x1D
                    result.setCharAt(i, String.fromCharCode(0x1D));
                }
            }
        }
        static decodeNumericSegment(bits, result, count /*int*/ ) {
            // Read three digits at a time
            while(count >= 3){
                // Each 10 bits encodes three digits
                if (bits.available() < 10) throw new FormatException();
                const threeDigitsBits = bits.readBits(10);
                if (threeDigitsBits >= 1000) throw new FormatException();
                result.append(DecodedBitStreamParser$1.toAlphaNumericChar(Math.floor(threeDigitsBits / 100)));
                result.append(DecodedBitStreamParser$1.toAlphaNumericChar(Math.floor(threeDigitsBits / 10) % 10));
                result.append(DecodedBitStreamParser$1.toAlphaNumericChar(threeDigitsBits % 10));
                count -= 3;
            }
            if (count === 2) {
                // Two digits left over to read, encoded in 7 bits
                if (bits.available() < 7) throw new FormatException();
                const twoDigitsBits = bits.readBits(7);
                if (twoDigitsBits >= 100) throw new FormatException();
                result.append(DecodedBitStreamParser$1.toAlphaNumericChar(Math.floor(twoDigitsBits / 10)));
                result.append(DecodedBitStreamParser$1.toAlphaNumericChar(twoDigitsBits % 10));
            } else if (count === 1) {
                // One digit left over to read
                if (bits.available() < 4) throw new FormatException();
                const digitBits = bits.readBits(4);
                if (digitBits >= 10) throw new FormatException();
                result.append(DecodedBitStreamParser$1.toAlphaNumericChar(digitBits));
            }
        }
        static parseECIValue(bits) {
            const firstByte = bits.readBits(8);
            if ((firstByte & 0x80) === 0) // just one byte
            return firstByte & 0x7F;
            if ((firstByte & 0xC0) === 0x80) {
                // two bytes
                const secondByte = bits.readBits(8);
                return (firstByte & 0x3F) << 8 & 0xFFFFFFFF | secondByte;
            }
            if ((firstByte & 0xE0) === 0xC0) {
                // three bytes
                const secondThirdBytes = bits.readBits(16);
                return (firstByte & 0x1F) << 16 & 0xFFFFFFFF | secondThirdBytes;
            }
            throw new FormatException();
        }
    }
    /**
     * See ISO 18004:2006, 6.4.4 Table 5
     */ DecodedBitStreamParser$1.ALPHANUMERIC_CHARS = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:';
    DecodedBitStreamParser$1.GB2312_SUBSET = 1;
    // function Uint8ArrayToString(a: Uint8Array): string {
    //     const CHUNK_SZ = 0x8000;
    //     const c = new StringBuilder();
    //     for (let i = 0, length = a.length; i < length; i += CHUNK_SZ) {
    //         c.append(String.fromCharCode.apply(null, a.subarray(i, i + CHUNK_SZ)));
    //     }
    //     return c.toString();
    // }
    /*
     * Copyright 2013 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * Meta-data container for QR Code decoding. Instances of this class may be used to convey information back to the
     * decoding caller. Callers are expected to process this.
     *
     * @see com.google.zxing.common.DecoderResult#getOther()
     */ class QRCodeDecoderMetaData {
        constructor(mirrored){
            this.mirrored = mirrored;
        }
        /**
         * @return true if the QR Code was mirrored.
         */ isMirrored() {
            return this.mirrored;
        }
        /**
         * Apply the result points' order correction due to mirroring.
         *
         * @param points Array of points to apply mirror correction to.
         */ applyMirroredCorrection(points) {
            if (!this.mirrored || points === null || points.length < 3) return;
            const bottomLeft = points[0];
            points[0] = points[2];
            points[2] = bottomLeft;
        // No need to 'fix' top-left and alignment pattern.
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /*import java.util.Map;*/ /**
     * <p>The main class which implements QR Code decoding -- as opposed to locating and extracting
     * the QR Code from an image.</p>
     *
     * @author Sean Owen
     */ class Decoder$2 {
        constructor(){
            this.rsDecoder = new ReedSolomonDecoder(GenericGF.QR_CODE_FIELD_256);
        }
        // public decode(image: boolean[][]): DecoderResult /*throws ChecksumException, FormatException*/ {
        //   return decode(image, null)
        // }
        /**
         * <p>Convenience method that can decode a QR Code represented as a 2D array of booleans.
         * "true" is taken to mean a black module.</p>
         *
         * @param image booleans representing white/black QR Code modules
         * @param hints decoding hints that should be used to influence decoding
         * @return text and bytes encoded within the QR Code
         * @throws FormatException if the QR Code cannot be decoded
         * @throws ChecksumException if error correction fails
         */ decodeBooleanArray(image, hints) {
            return this.decodeBitMatrix(BitMatrix.parseFromBooleanArray(image), hints);
        }
        // public decodeBitMatrix(bits: BitMatrix): DecoderResult /*throws ChecksumException, FormatException*/ {
        //   return decode(bits, null)
        // }
        /**
         * <p>Decodes a QR Code represented as a {@link BitMatrix}. A 1 or "true" is taken to mean a black module.</p>
         *
         * @param bits booleans representing white/black QR Code modules
         * @param hints decoding hints that should be used to influence decoding
         * @return text and bytes encoded within the QR Code
         * @throws FormatException if the QR Code cannot be decoded
         * @throws ChecksumException if error correction fails
         */ decodeBitMatrix(bits, hints) {
            // Construct a parser and read version, error-correction level
            const parser = new BitMatrixParser$1(bits);
            let ex = null;
            try {
                return this.decodeBitMatrixParser(parser, hints);
            } catch (e /*: FormatException, ChecksumException*/ ) {
                ex = e;
            }
            try {
                // Revert the bit matrix
                parser.remask();
                // Will be attempting a mirrored reading of the version and format info.
                parser.setMirror(true);
                // Preemptively read the version.
                parser.readVersion();
                // Preemptively read the format information.
                parser.readFormatInformation();
                /*
                 * Since we're here, this means we have successfully detected some kind
                 * of version and format information when mirrored. This is a good sign,
                 * that the QR code may be mirrored, and we should try once more with a
                 * mirrored content.
                 */ // Prepare for a mirrored reading.
                parser.mirror();
                const result = this.decodeBitMatrixParser(parser, hints);
                // Success! Notify the caller that the code was mirrored.
                result.setOther(new QRCodeDecoderMetaData(true));
                return result;
            } catch (e /*FormatException | ChecksumException*/ ) {
                // Throw the exception from the original reading
                if (ex !== null) throw ex;
                throw e;
            }
        }
        decodeBitMatrixParser(parser, hints) {
            const version = parser.readVersion();
            const ecLevel = parser.readFormatInformation().getErrorCorrectionLevel();
            // Read codewords
            const codewords = parser.readCodewords();
            // Separate into data blocks
            const dataBlocks = DataBlock$1.getDataBlocks(codewords, version, ecLevel);
            // Count total number of data bytes
            let totalBytes = 0;
            for (const dataBlock of dataBlocks)totalBytes += dataBlock.getNumDataCodewords();
            const resultBytes = new Uint8Array(totalBytes);
            let resultOffset = 0;
            // Error-correct and copy data blocks together into a stream of bytes
            for (const dataBlock of dataBlocks){
                const codewordBytes = dataBlock.getCodewords();
                const numDataCodewords = dataBlock.getNumDataCodewords();
                this.correctErrors(codewordBytes, numDataCodewords);
                for(let i = 0; i < numDataCodewords; i++)resultBytes[resultOffset++] = codewordBytes[i];
            }
            // Decode the contents of that stream of bytes
            return DecodedBitStreamParser$1.decode(resultBytes, version, ecLevel, hints);
        }
        /**
         * <p>Given data and error-correction codewords received, possibly corrupted by errors, attempts to
         * correct the errors in-place using Reed-Solomon error correction.</p>
         *
         * @param codewordBytes data and error correction codewords
         * @param numDataCodewords number of codewords that are data bytes
         * @throws ChecksumException if error correction fails
         */ correctErrors(codewordBytes, numDataCodewords /*int*/ ) {
            // const numCodewords = codewordBytes.length;
            // First read into an array of ints
            const codewordsInts = new Int32Array(codewordBytes);
            // TYPESCRIPTPORT: not realy necessary to transform to ints? could redesign everything to work with unsigned bytes?
            // const codewordsInts = new Int32Array(numCodewords)
            // for (let i = 0; i < numCodewords; i++) {
            //   codewordsInts[i] = codewordBytes[i] & 0xFF
            // }
            try {
                this.rsDecoder.decode(codewordsInts, codewordBytes.length - numDataCodewords);
            } catch (ignored /*: ReedSolomonException*/ ) {
                throw new ChecksumException();
            }
            // Copy back into array of bytes -- only need to worry about the bytes that were data
            // We don't care about errors in the error-correction codewords
            for(let i = 0; i < numDataCodewords; i++)codewordBytes[i] = /*(byte) */ codewordsInts[i];
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * <p>Encapsulates an alignment pattern, which are the smaller square patterns found in
     * all but the simplest QR Codes.</p>
     *
     * @author Sean Owen
     */ class AlignmentPattern extends ResultPoint {
        constructor(posX /*float*/ , posY /*float*/ , estimatedModuleSize /*float*/ ){
            super(posX, posY);
            this.estimatedModuleSize = estimatedModuleSize;
        }
        /**
         * <p>Determines if this alignment pattern "about equals" an alignment pattern at the stated
         * position and size -- meaning, it is at nearly the same center with nearly the same size.</p>
         */ aboutEquals(moduleSize /*float*/ , i /*float*/ , j /*float*/ ) {
            if (Math.abs(i - this.getY()) <= moduleSize && Math.abs(j - this.getX()) <= moduleSize) {
                const moduleSizeDiff = Math.abs(moduleSize - this.estimatedModuleSize);
                return moduleSizeDiff <= 1.0 || moduleSizeDiff <= this.estimatedModuleSize;
            }
            return false;
        }
        /**
         * Combines this object's current estimate of a finder pattern position and module size
         * with a new estimate. It returns a new {@code FinderPattern} containing an average of the two.
         */ combineEstimate(i /*float*/ , j /*float*/ , newModuleSize /*float*/ ) {
            const combinedX = (this.getX() + j) / 2.0;
            const combinedY = (this.getY() + i) / 2.0;
            const combinedModuleSize = (this.estimatedModuleSize + newModuleSize) / 2.0;
            return new AlignmentPattern(combinedX, combinedY, combinedModuleSize);
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /*import java.util.ArrayList;*/ /*import java.util.List;*/ /**
     * <p>This class attempts to find alignment patterns in a QR Code. Alignment patterns look like finder
     * patterns but are smaller and appear at regular intervals throughout the image.</p>
     *
     * <p>At the moment this only looks for the bottom-right alignment pattern.</p>
     *
     * <p>This is mostly a simplified copy of {@link FinderPatternFinder}. It is copied,
     * pasted and stripped down here for maximum performance but does unfortunately duplicate
     * some code.</p>
     *
     * <p>This class is thread-safe but not reentrant. Each thread must allocate its own object.</p>
     *
     * @author Sean Owen
     */ class AlignmentPatternFinder {
        /**
         * <p>Creates a finder that will look in a portion of the whole image.</p>
         *
         * @param image image to search
         * @param startX left column from which to start searching
         * @param startY top row from which to start searching
         * @param width width of region to search
         * @param height height of region to search
         * @param moduleSize estimated module size so far
         */ constructor(image, startX /*int*/ , startY /*int*/ , width /*int*/ , height /*int*/ , moduleSize /*float*/ , resultPointCallback){
            this.image = image;
            this.startX = startX;
            this.startY = startY;
            this.width = width;
            this.height = height;
            this.moduleSize = moduleSize;
            this.resultPointCallback = resultPointCallback;
            this.possibleCenters = []; // new Array<any>(5))
            // TYPESCRIPTPORT: array initialization without size as the length is checked below
            this.crossCheckStateCount = new Int32Array(3);
        }
        /**
         * <p>This method attempts to find the bottom-right alignment pattern in the image. It is a bit messy since
         * it's pretty performance-critical and so is written to be fast foremost.</p>
         *
         * @return {@link AlignmentPattern} if found
         * @throws NotFoundException if not found
         */ find() {
            const startX = this.startX;
            const height = this.height;
            const width = this.width;
            const maxJ = startX + width;
            const middleI = this.startY + height / 2;
            // We are looking for black/white/black modules in 1:1:1 ratio
            // this tracks the number of black/white/black modules seen so far
            const stateCount = new Int32Array(3);
            const image = this.image;
            for(let iGen = 0; iGen < height; iGen++){
                // Search from middle outwards
                const i = middleI + ((iGen & 0x01) === 0 ? Math.floor((iGen + 1) / 2) : -Math.floor((iGen + 1) / 2));
                stateCount[0] = 0;
                stateCount[1] = 0;
                stateCount[2] = 0;
                let j = startX;
                // Burn off leading white pixels before anything else; if we start in the middle of
                // a white run, it doesn't make sense to count its length, since we don't know if the
                // white run continued to the left of the start point
                while(j < maxJ && !image.get(j, i))j++;
                let currentState = 0;
                while(j < maxJ){
                    if (image.get(j, i)) {
                        // Black pixel
                        if (currentState === 1) stateCount[1]++;
                        else if (currentState === 2) {
                            if (this.foundPatternCross(stateCount)) {
                                const confirmed = this.handlePossibleCenter(stateCount, i, j);
                                if (confirmed !== null) return confirmed;
                            }
                            stateCount[0] = stateCount[2];
                            stateCount[1] = 1;
                            stateCount[2] = 0;
                            currentState = 1;
                        } else stateCount[++currentState]++;
                    } else {
                        if (currentState === 1) currentState++;
                        stateCount[currentState]++;
                    }
                    j++;
                }
                if (this.foundPatternCross(stateCount)) {
                    const confirmed = this.handlePossibleCenter(stateCount, i, maxJ);
                    if (confirmed !== null) return confirmed;
                }
            }
            // Hmm, nothing we saw was observed and confirmed twice. If we had
            // any guess at all, return it.
            if (this.possibleCenters.length !== 0) return this.possibleCenters[0];
            throw new NotFoundException();
        }
        /**
         * Given a count of black/white/black pixels just seen and an end position,
         * figures the location of the center of this black/white/black run.
         */ static centerFromEnd(stateCount, end /*int*/ ) {
            return end - stateCount[2] - stateCount[1] / 2.0;
        }
        /**
         * @param stateCount count of black/white/black pixels just read
         * @return true iff the proportions of the counts is close enough to the 1/1/1 ratios
         *         used by alignment patterns to be considered a match
         */ foundPatternCross(stateCount) {
            const moduleSize = this.moduleSize;
            const maxVariance = moduleSize / 2.0;
            for(let i = 0; i < 3; i++){
                if (Math.abs(moduleSize - stateCount[i]) >= maxVariance) return false;
            }
            return true;
        }
        /**
         * <p>After a horizontal scan finds a potential alignment pattern, this method
         * "cross-checks" by scanning down vertically through the center of the possible
         * alignment pattern to see if the same proportion is detected.</p>
         *
         * @param startI row where an alignment pattern was detected
         * @param centerJ center of the section that appears to cross an alignment pattern
         * @param maxCount maximum reasonable number of modules that should be
         * observed in any reading state, based on the results of the horizontal scan
         * @return vertical center of alignment pattern, or {@link Float#NaN} if not found
         */ crossCheckVertical(startI /*int*/ , centerJ /*int*/ , maxCount /*int*/ , originalStateCountTotal /*int*/ ) {
            const image = this.image;
            const maxI = image.getHeight();
            const stateCount = this.crossCheckStateCount;
            stateCount[0] = 0;
            stateCount[1] = 0;
            stateCount[2] = 0;
            // Start counting up from center
            let i = startI;
            while(i >= 0 && image.get(centerJ, i) && stateCount[1] <= maxCount){
                stateCount[1]++;
                i--;
            }
            // If already too many modules in this state or ran off the edge:
            if (i < 0 || stateCount[1] > maxCount) return NaN;
            while(i >= 0 && !image.get(centerJ, i) && stateCount[0] <= maxCount){
                stateCount[0]++;
                i--;
            }
            if (stateCount[0] > maxCount) return NaN;
            // Now also count down from center
            i = startI + 1;
            while(i < maxI && image.get(centerJ, i) && stateCount[1] <= maxCount){
                stateCount[1]++;
                i++;
            }
            if (i === maxI || stateCount[1] > maxCount) return NaN;
            while(i < maxI && !image.get(centerJ, i) && stateCount[2] <= maxCount){
                stateCount[2]++;
                i++;
            }
            if (stateCount[2] > maxCount) return NaN;
            const stateCountTotal = stateCount[0] + stateCount[1] + stateCount[2];
            if (5 * Math.abs(stateCountTotal - originalStateCountTotal) >= 2 * originalStateCountTotal) return NaN;
            return this.foundPatternCross(stateCount) ? AlignmentPatternFinder.centerFromEnd(stateCount, i) : NaN;
        }
        /**
         * <p>This is called when a horizontal scan finds a possible alignment pattern. It will
         * cross check with a vertical scan, and if successful, will see if this pattern had been
         * found on a previous horizontal scan. If so, we consider it confirmed and conclude we have
         * found the alignment pattern.</p>
         *
         * @param stateCount reading state module counts from horizontal scan
         * @param i row where alignment pattern may be found
         * @param j end of possible alignment pattern in row
         * @return {@link AlignmentPattern} if we have found the same pattern twice, or null if not
         */ handlePossibleCenter(stateCount, i /*int*/ , j /*int*/ ) {
            const stateCountTotal = stateCount[0] + stateCount[1] + stateCount[2];
            const centerJ = AlignmentPatternFinder.centerFromEnd(stateCount, j);
            const centerI = this.crossCheckVertical(i, /*(int) */ centerJ, 2 * stateCount[1], stateCountTotal);
            if (!isNaN(centerI)) {
                const estimatedModuleSize = (stateCount[0] + stateCount[1] + stateCount[2]) / 3.0;
                for (const center of this.possibleCenters){
                    // Look for about the same center and module size:
                    if (center.aboutEquals(estimatedModuleSize, centerI, centerJ)) return center.combineEstimate(centerI, centerJ, estimatedModuleSize);
                }
                // Hadn't found this before; save it
                const point = new AlignmentPattern(centerJ, centerI, estimatedModuleSize);
                this.possibleCenters.push(point);
                if (this.resultPointCallback !== null && this.resultPointCallback !== undefined) this.resultPointCallback.foundPossibleResultPoint(point);
            }
            return null;
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * <p>Encapsulates a finder pattern, which are the three square patterns found in
     * the corners of QR Codes. It also encapsulates a count of similar finder patterns,
     * as a convenience to the finder's bookkeeping.</p>
     *
     * @author Sean Owen
     */ class FinderPattern$1 extends ResultPoint {
        // FinderPattern(posX: number/*float*/, posY: number/*float*/, estimatedModuleSize: number/*float*/) {
        //   this(posX, posY, estimatedModuleSize, 1)
        // }
        constructor(posX /*float*/ , posY /*float*/ , estimatedModuleSize /*float*/ , count /*int*/ ){
            super(posX, posY);
            this.estimatedModuleSize = estimatedModuleSize;
            this.count = count;
            if (undefined === count) this.count = 1;
        }
        getEstimatedModuleSize() {
            return this.estimatedModuleSize;
        }
        getCount() {
            return this.count;
        }
        /*
        void incrementCount() {
          this.count++
        }
         */ /**
         * <p>Determines if this finder pattern "about equals" a finder pattern at the stated
         * position and size -- meaning, it is at nearly the same center with nearly the same size.</p>
         */ aboutEquals(moduleSize /*float*/ , i /*float*/ , j /*float*/ ) {
            if (Math.abs(i - this.getY()) <= moduleSize && Math.abs(j - this.getX()) <= moduleSize) {
                const moduleSizeDiff = Math.abs(moduleSize - this.estimatedModuleSize);
                return moduleSizeDiff <= 1.0 || moduleSizeDiff <= this.estimatedModuleSize;
            }
            return false;
        }
        /**
         * Combines this object's current estimate of a finder pattern position and module size
         * with a new estimate. It returns a new {@code FinderPattern} containing a weighted average
         * based on count.
         */ combineEstimate(i /*float*/ , j /*float*/ , newModuleSize /*float*/ ) {
            const combinedCount = this.count + 1;
            const combinedX = (this.count * this.getX() + j) / combinedCount;
            const combinedY = (this.count * this.getY() + i) / combinedCount;
            const combinedModuleSize = (this.count * this.estimatedModuleSize + newModuleSize) / combinedCount;
            return new FinderPattern$1(combinedX, combinedY, combinedModuleSize, combinedCount);
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * <p>Encapsulates information about finder patterns in an image, including the location of
     * the three finder patterns, and their estimated module size.</p>
     *
     * @author Sean Owen
     */ class FinderPatternInfo {
        constructor(patternCenters){
            this.bottomLeft = patternCenters[0];
            this.topLeft = patternCenters[1];
            this.topRight = patternCenters[2];
        }
        getBottomLeft() {
            return this.bottomLeft;
        }
        getTopLeft() {
            return this.topLeft;
        }
        getTopRight() {
            return this.topRight;
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /*import java.io.Serializable;*/ /*import java.util.ArrayList;*/ /*import java.util.Collections;*/ /*import java.util.Comparator;*/ /*import java.util.List;*/ /*import java.util.Map;*/ /**
     * <p>This class attempts to find finder patterns in a QR Code. Finder patterns are the square
     * markers at three corners of a QR Code.</p>
     *
     * <p>This class is thread-safe but not reentrant. Each thread must allocate its own object.
     *
     * @author Sean Owen
     */ class FinderPatternFinder {
        /**
         * <p>Creates a finder that will search the image for three finder patterns.</p>
         *
         * @param image image to search
         */ // public constructor(image: BitMatrix) {
        //   this(image, null)
        // }
        constructor(image, resultPointCallback){
            this.image = image;
            this.resultPointCallback = resultPointCallback;
            this.possibleCenters = [];
            this.crossCheckStateCount = new Int32Array(5);
            this.resultPointCallback = resultPointCallback;
        }
        getImage() {
            return this.image;
        }
        getPossibleCenters() {
            return this.possibleCenters;
        }
        find(hints) {
            const tryHarder = hints !== null && hints !== undefined && undefined !== hints.get(DecodeHintType$1.TRY_HARDER);
            const pureBarcode = hints !== null && hints !== undefined && undefined !== hints.get(DecodeHintType$1.PURE_BARCODE);
            const image = this.image;
            const maxI = image.getHeight();
            const maxJ = image.getWidth();
            // We are looking for black/white/black/white/black modules in
            // 1:1:3:1:1 ratio; this tracks the number of such modules seen so far
            // Let's assume that the maximum version QR Code we support takes up 1/4 the height of the
            // image, and then account for the center being 3 modules in size. This gives the smallest
            // number of pixels the center could be, so skip this often. When trying harder, look for all
            // QR versions regardless of how dense they are.
            let iSkip = Math.floor(3 * maxI / (4 * FinderPatternFinder.MAX_MODULES));
            if (iSkip < FinderPatternFinder.MIN_SKIP || tryHarder) iSkip = FinderPatternFinder.MIN_SKIP;
            let done = false;
            const stateCount = new Int32Array(5);
            for(let i = iSkip - 1; i < maxI && !done; i += iSkip){
                // Get a row of black/white values
                stateCount[0] = 0;
                stateCount[1] = 0;
                stateCount[2] = 0;
                stateCount[3] = 0;
                stateCount[4] = 0;
                let currentState = 0;
                for(let j = 0; j < maxJ; j++){
                    if (image.get(j, i)) {
                        // Black pixel
                        if ((currentState & 1) === 1) currentState++;
                        stateCount[currentState]++;
                    } else if ((currentState & 1) === 0) {
                        if (currentState === 4) {
                            if (FinderPatternFinder.foundPatternCross(stateCount)) {
                                const confirmed = this.handlePossibleCenter(stateCount, i, j, pureBarcode);
                                if (confirmed === true) {
                                    // Start examining every other line. Checking each line turned out to be too
                                    // expensive and didn't improve performance.
                                    iSkip = 2;
                                    if (this.hasSkipped === true) done = this.haveMultiplyConfirmedCenters();
                                    else {
                                        const rowSkip = this.findRowSkip();
                                        if (rowSkip > stateCount[2]) {
                                            // Skip rows between row of lower confirmed center
                                            // and top of presumed third confirmed center
                                            // but back up a bit to get a full chance of detecting
                                            // it, entire width of center of finder pattern
                                            // Skip by rowSkip, but back off by stateCount[2] (size of last center
                                            // of pattern we saw) to be conservative, and also back off by iSkip which
                                            // is about to be re-added
                                            i += rowSkip - stateCount[2] - iSkip;
                                            j = maxJ - 1;
                                        }
                                    }
                                } else {
                                    stateCount[0] = stateCount[2];
                                    stateCount[1] = stateCount[3];
                                    stateCount[2] = stateCount[4];
                                    stateCount[3] = 1;
                                    stateCount[4] = 0;
                                    currentState = 3;
                                    continue;
                                }
                                // Clear state to start looking again
                                currentState = 0;
                                stateCount[0] = 0;
                                stateCount[1] = 0;
                                stateCount[2] = 0;
                                stateCount[3] = 0;
                                stateCount[4] = 0;
                            } else {
                                stateCount[0] = stateCount[2];
                                stateCount[1] = stateCount[3];
                                stateCount[2] = stateCount[4];
                                stateCount[3] = 1;
                                stateCount[4] = 0;
                                currentState = 3;
                            }
                        } else stateCount[++currentState]++;
                    } else stateCount[currentState]++;
                }
                if (FinderPatternFinder.foundPatternCross(stateCount)) {
                    const confirmed = this.handlePossibleCenter(stateCount, i, maxJ, pureBarcode);
                    if (confirmed === true) {
                        iSkip = stateCount[0];
                        if (this.hasSkipped) // Found a third one
                        done = this.haveMultiplyConfirmedCenters();
                    }
                }
            }
            const patternInfo = this.selectBestPatterns();
            ResultPoint.orderBestPatterns(patternInfo);
            return new FinderPatternInfo(patternInfo);
        }
        /**
         * Given a count of black/white/black/white/black pixels just seen and an end position,
         * figures the location of the center of this run.
         */ static centerFromEnd(stateCount, end /*int*/ ) {
            return end - stateCount[4] - stateCount[3] - stateCount[2] / 2.0;
        }
        /**
         * @param stateCount count of black/white/black/white/black pixels just read
         * @return true iff the proportions of the counts is close enough to the 1/1/3/1/1 ratios
         *         used by finder patterns to be considered a match
         */ static foundPatternCross(stateCount) {
            let totalModuleSize = 0;
            for(let i = 0; i < 5; i++){
                const count = stateCount[i];
                if (count === 0) return false;
                totalModuleSize += count;
            }
            if (totalModuleSize < 7) return false;
            const moduleSize = totalModuleSize / 7.0;
            const maxVariance = moduleSize / 2.0;
            // Allow less than 50% variance from 1-1-3-1-1 proportions
            return Math.abs(moduleSize - stateCount[0]) < maxVariance && Math.abs(moduleSize - stateCount[1]) < maxVariance && Math.abs(3.0 * moduleSize - stateCount[2]) < 3 * maxVariance && Math.abs(moduleSize - stateCount[3]) < maxVariance && Math.abs(moduleSize - stateCount[4]) < maxVariance;
        }
        getCrossCheckStateCount() {
            const crossCheckStateCount = this.crossCheckStateCount;
            crossCheckStateCount[0] = 0;
            crossCheckStateCount[1] = 0;
            crossCheckStateCount[2] = 0;
            crossCheckStateCount[3] = 0;
            crossCheckStateCount[4] = 0;
            return crossCheckStateCount;
        }
        /**
         * After a vertical and horizontal scan finds a potential finder pattern, this method
         * "cross-cross-cross-checks" by scanning down diagonally through the center of the possible
         * finder pattern to see if the same proportion is detected.
         *
         * @param startI row where a finder pattern was detected
         * @param centerJ center of the section that appears to cross a finder pattern
         * @param maxCount maximum reasonable number of modules that should be
         *  observed in any reading state, based on the results of the horizontal scan
         * @param originalStateCountTotal The original state count total.
         * @return true if proportions are withing expected limits
         */ crossCheckDiagonal(startI /*int*/ , centerJ /*int*/ , maxCount /*int*/ , originalStateCountTotal /*int*/ ) {
            const stateCount = this.getCrossCheckStateCount();
            // Start counting up, left from center finding black center mass
            let i = 0;
            const image = this.image;
            while(startI >= i && centerJ >= i && image.get(centerJ - i, startI - i)){
                stateCount[2]++;
                i++;
            }
            if (startI < i || centerJ < i) return false;
            // Continue up, left finding white space
            while(startI >= i && centerJ >= i && !image.get(centerJ - i, startI - i) && stateCount[1] <= maxCount){
                stateCount[1]++;
                i++;
            }
            // If already too many modules in this state or ran off the edge:
            if (startI < i || centerJ < i || stateCount[1] > maxCount) return false;
            // Continue up, left finding black border
            while(startI >= i && centerJ >= i && image.get(centerJ - i, startI - i) && stateCount[0] <= maxCount){
                stateCount[0]++;
                i++;
            }
            if (stateCount[0] > maxCount) return false;
            const maxI = image.getHeight();
            const maxJ = image.getWidth();
            // Now also count down, right from center
            i = 1;
            while(startI + i < maxI && centerJ + i < maxJ && image.get(centerJ + i, startI + i)){
                stateCount[2]++;
                i++;
            }
            // Ran off the edge?
            if (startI + i >= maxI || centerJ + i >= maxJ) return false;
            while(startI + i < maxI && centerJ + i < maxJ && !image.get(centerJ + i, startI + i) && stateCount[3] < maxCount){
                stateCount[3]++;
                i++;
            }
            if (startI + i >= maxI || centerJ + i >= maxJ || stateCount[3] >= maxCount) return false;
            while(startI + i < maxI && centerJ + i < maxJ && image.get(centerJ + i, startI + i) && stateCount[4] < maxCount){
                stateCount[4]++;
                i++;
            }
            if (stateCount[4] >= maxCount) return false;
            // If we found a finder-pattern-like section, but its size is more than 100% different than
            // the original, assume it's a false positive
            const stateCountTotal = stateCount[0] + stateCount[1] + stateCount[2] + stateCount[3] + stateCount[4];
            return Math.abs(stateCountTotal - originalStateCountTotal) < 2 * originalStateCountTotal && FinderPatternFinder.foundPatternCross(stateCount);
        }
        /**
         * <p>After a horizontal scan finds a potential finder pattern, this method
         * "cross-checks" by scanning down vertically through the center of the possible
         * finder pattern to see if the same proportion is detected.</p>
         *
         * @param startI row where a finder pattern was detected
         * @param centerJ center of the section that appears to cross a finder pattern
         * @param maxCount maximum reasonable number of modules that should be
         * observed in any reading state, based on the results of the horizontal scan
         * @return vertical center of finder pattern, or {@link Float#NaN} if not found
         */ crossCheckVertical(startI /*int*/ , centerJ /*int*/ , maxCount /*int*/ , originalStateCountTotal /*int*/ ) {
            const image = this.image;
            const maxI = image.getHeight();
            const stateCount = this.getCrossCheckStateCount();
            // Start counting up from center
            let i = startI;
            while(i >= 0 && image.get(centerJ, i)){
                stateCount[2]++;
                i--;
            }
            if (i < 0) return NaN;
            while(i >= 0 && !image.get(centerJ, i) && stateCount[1] <= maxCount){
                stateCount[1]++;
                i--;
            }
            // If already too many modules in this state or ran off the edge:
            if (i < 0 || stateCount[1] > maxCount) return NaN;
            while(i >= 0 && image.get(centerJ, i) && stateCount[0] <= maxCount){
                stateCount[0]++;
                i--;
            }
            if (stateCount[0] > maxCount) return NaN;
            // Now also count down from center
            i = startI + 1;
            while(i < maxI && image.get(centerJ, i)){
                stateCount[2]++;
                i++;
            }
            if (i === maxI) return NaN;
            while(i < maxI && !image.get(centerJ, i) && stateCount[3] < maxCount){
                stateCount[3]++;
                i++;
            }
            if (i === maxI || stateCount[3] >= maxCount) return NaN;
            while(i < maxI && image.get(centerJ, i) && stateCount[4] < maxCount){
                stateCount[4]++;
                i++;
            }
            if (stateCount[4] >= maxCount) return NaN;
            // If we found a finder-pattern-like section, but its size is more than 40% different than
            // the original, assume it's a false positive
            const stateCountTotal = stateCount[0] + stateCount[1] + stateCount[2] + stateCount[3] + stateCount[4];
            if (5 * Math.abs(stateCountTotal - originalStateCountTotal) >= 2 * originalStateCountTotal) return NaN;
            return FinderPatternFinder.foundPatternCross(stateCount) ? FinderPatternFinder.centerFromEnd(stateCount, i) : NaN;
        }
        /**
         * <p>Like {@link #crossCheckVertical(int, int, int, int)}, and in fact is basically identical,
         * except it reads horizontally instead of vertically. This is used to cross-cross
         * check a vertical cross check and locate the real center of the alignment pattern.</p>
         */ crossCheckHorizontal(startJ /*int*/ , centerI /*int*/ , maxCount /*int*/ , originalStateCountTotal /*int*/ ) {
            const image = this.image;
            const maxJ = image.getWidth();
            const stateCount = this.getCrossCheckStateCount();
            let j = startJ;
            while(j >= 0 && image.get(j, centerI)){
                stateCount[2]++;
                j--;
            }
            if (j < 0) return NaN;
            while(j >= 0 && !image.get(j, centerI) && stateCount[1] <= maxCount){
                stateCount[1]++;
                j--;
            }
            if (j < 0 || stateCount[1] > maxCount) return NaN;
            while(j >= 0 && image.get(j, centerI) && stateCount[0] <= maxCount){
                stateCount[0]++;
                j--;
            }
            if (stateCount[0] > maxCount) return NaN;
            j = startJ + 1;
            while(j < maxJ && image.get(j, centerI)){
                stateCount[2]++;
                j++;
            }
            if (j === maxJ) return NaN;
            while(j < maxJ && !image.get(j, centerI) && stateCount[3] < maxCount){
                stateCount[3]++;
                j++;
            }
            if (j === maxJ || stateCount[3] >= maxCount) return NaN;
            while(j < maxJ && image.get(j, centerI) && stateCount[4] < maxCount){
                stateCount[4]++;
                j++;
            }
            if (stateCount[4] >= maxCount) return NaN;
            // If we found a finder-pattern-like section, but its size is significantly different than
            // the original, assume it's a false positive
            const stateCountTotal = stateCount[0] + stateCount[1] + stateCount[2] + stateCount[3] + stateCount[4];
            if (5 * Math.abs(stateCountTotal - originalStateCountTotal) >= originalStateCountTotal) return NaN;
            return FinderPatternFinder.foundPatternCross(stateCount) ? FinderPatternFinder.centerFromEnd(stateCount, j) : NaN;
        }
        /**
         * <p>This is called when a horizontal scan finds a possible alignment pattern. It will
         * cross check with a vertical scan, and if successful, will, ah, cross-cross-check
         * with another horizontal scan. This is needed primarily to locate the real horizontal
         * center of the pattern in cases of extreme skew.
         * And then we cross-cross-cross check with another diagonal scan.</p>
         *
         * <p>If that succeeds the finder pattern location is added to a list that tracks
         * the number of times each location has been nearly-matched as a finder pattern.
         * Each additional find is more evidence that the location is in fact a finder
         * pattern center
         *
         * @param stateCount reading state module counts from horizontal scan
         * @param i row where finder pattern may be found
         * @param j end of possible finder pattern in row
         * @param pureBarcode true if in "pure barcode" mode
         * @return true if a finder pattern candidate was found this time
         */ handlePossibleCenter(stateCount, i /*int*/ , j /*int*/ , pureBarcode) {
            const stateCountTotal = stateCount[0] + stateCount[1] + stateCount[2] + stateCount[3] + stateCount[4];
            let centerJ = FinderPatternFinder.centerFromEnd(stateCount, j);
            let centerI = this.crossCheckVertical(i, /*(int) */ Math.floor(centerJ), stateCount[2], stateCountTotal);
            if (!isNaN(centerI)) {
                // Re-cross check
                centerJ = this.crossCheckHorizontal(/*(int) */ Math.floor(centerJ), /*(int) */ Math.floor(centerI), stateCount[2], stateCountTotal);
                if (!isNaN(centerJ) && (!pureBarcode || this.crossCheckDiagonal(/*(int) */ Math.floor(centerI), /*(int) */ Math.floor(centerJ), stateCount[2], stateCountTotal))) {
                    const estimatedModuleSize = stateCountTotal / 7.0;
                    let found = false;
                    const possibleCenters = this.possibleCenters;
                    for(let index = 0, length = possibleCenters.length; index < length; index++){
                        const center = possibleCenters[index];
                        // Look for about the same center and module size:
                        if (center.aboutEquals(estimatedModuleSize, centerI, centerJ)) {
                            possibleCenters[index] = center.combineEstimate(centerI, centerJ, estimatedModuleSize);
                            found = true;
                            break;
                        }
                    }
                    if (!found) {
                        const point = new FinderPattern$1(centerJ, centerI, estimatedModuleSize);
                        possibleCenters.push(point);
                        if (this.resultPointCallback !== null && this.resultPointCallback !== undefined) this.resultPointCallback.foundPossibleResultPoint(point);
                    }
                    return true;
                }
            }
            return false;
        }
        /**
         * @return number of rows we could safely skip during scanning, based on the first
         *         two finder patterns that have been located. In some cases their position will
         *         allow us to infer that the third pattern must lie below a certain point farther
         *         down in the image.
         */ findRowSkip() {
            const max = this.possibleCenters.length;
            if (max <= 1) return 0;
            let firstConfirmedCenter = null;
            for (const center of this.possibleCenters)if (center.getCount() >= FinderPatternFinder.CENTER_QUORUM) {
                if (firstConfirmedCenter == null) firstConfirmedCenter = center;
                else {
                    // We have two confirmed centers
                    // How far down can we skip before resuming looking for the next
                    // pattern? In the worst case, only the difference between the
                    // difference in the x / y coordinates of the two centers.
                    // This is the case where you find top left last.
                    this.hasSkipped = true;
                    return /*(int) */ Math.floor((Math.abs(firstConfirmedCenter.getX() - center.getX()) - Math.abs(firstConfirmedCenter.getY() - center.getY())) / 2);
                }
            }
            return 0;
        }
        /**
         * @return true iff we have found at least 3 finder patterns that have been detected
         *         at least {@link #CENTER_QUORUM} times each, and, the estimated module size of the
         *         candidates is "pretty similar"
         */ haveMultiplyConfirmedCenters() {
            let confirmedCount = 0;
            let totalModuleSize = 0.0;
            const max = this.possibleCenters.length;
            for (const pattern of this.possibleCenters)if (pattern.getCount() >= FinderPatternFinder.CENTER_QUORUM) {
                confirmedCount++;
                totalModuleSize += pattern.getEstimatedModuleSize();
            }
            if (confirmedCount < 3) return false;
            // OK, we have at least 3 confirmed centers, but, it's possible that one is a "false positive"
            // and that we need to keep looking. We detect this by asking if the estimated module sizes
            // vary too much. We arbitrarily say that when the total deviation from average exceeds
            // 5% of the total module size estimates, it's too much.
            const average = totalModuleSize / max;
            let totalDeviation = 0.0;
            for (const pattern of this.possibleCenters)totalDeviation += Math.abs(pattern.getEstimatedModuleSize() - average);
            return totalDeviation <= 0.05 * totalModuleSize;
        }
        /**
         * @return the 3 best {@link FinderPattern}s from our list of candidates. The "best" are
         *         those that have been detected at least {@link #CENTER_QUORUM} times, and whose module
         *         size differs from the average among those patterns the least
         * @throws NotFoundException if 3 such finder patterns do not exist
         */ selectBestPatterns() {
            const startSize = this.possibleCenters.length;
            if (startSize < 3) // Couldn't find enough finder patterns
            throw new NotFoundException();
            const possibleCenters = this.possibleCenters;
            let average;
            // Filter outlier possibilities whose module size is too different
            if (startSize > 3) {
                // But we can only afford to do so if we have at least 4 possibilities to choose from
                let totalModuleSize = 0.0;
                let square = 0.0;
                for (const center of this.possibleCenters){
                    const size = center.getEstimatedModuleSize();
                    totalModuleSize += size;
                    square += size * size;
                }
                average = totalModuleSize / startSize;
                let stdDev = Math.sqrt(square / startSize - average * average);
                possibleCenters.sort(/**
                 * <p>Orders by furthest from average</p>
                 */ // FurthestFromAverageComparator implements Comparator<FinderPattern>
                (center1, center2)=>{
                    const dA = Math.abs(center2.getEstimatedModuleSize() - average);
                    const dB = Math.abs(center1.getEstimatedModuleSize() - average);
                    return dA < dB ? -1 : dA > dB ? 1 : 0;
                });
                const limit = Math.max(0.2 * average, stdDev);
                for(let i = 0; i < possibleCenters.length && possibleCenters.length > 3; i++){
                    const pattern = possibleCenters[i];
                    if (Math.abs(pattern.getEstimatedModuleSize() - average) > limit) {
                        possibleCenters.splice(i, 1);
                        i--;
                    }
                }
            }
            if (possibleCenters.length > 3) {
                // Throw away all but those first size candidate points we found.
                let totalModuleSize = 0.0;
                for (const possibleCenter of possibleCenters)totalModuleSize += possibleCenter.getEstimatedModuleSize();
                average = totalModuleSize / possibleCenters.length;
                possibleCenters.sort(/**
                 * <p>Orders by {@link FinderPattern#getCount()}, descending.</p>
                 */ // CenterComparator implements Comparator<FinderPattern>
                (center1, center2)=>{
                    if (center2.getCount() === center1.getCount()) {
                        const dA = Math.abs(center2.getEstimatedModuleSize() - average);
                        const dB = Math.abs(center1.getEstimatedModuleSize() - average);
                        return dA < dB ? 1 : dA > dB ? -1 : 0;
                    } else return center2.getCount() - center1.getCount();
                });
                possibleCenters.splice(3); // this is not realy necessary as we only return first 3 anyway
            }
            return [
                possibleCenters[0],
                possibleCenters[1],
                possibleCenters[2]
            ];
        }
    }
    FinderPatternFinder.CENTER_QUORUM = 2;
    FinderPatternFinder.MIN_SKIP = 3; // 1 pixel/module times 3 modules/center
    FinderPatternFinder.MAX_MODULES = 57; // support up to version 10 for mobile clients
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /*import java.util.Map;*/ /**
     * <p>Encapsulates logic that can detect a QR Code in an image, even if the QR Code
     * is rotated or skewed, or partially obscured.</p>
     *
     * @author Sean Owen
     */ class Detector$2 {
        constructor(image){
            this.image = image;
        }
        getImage() {
            return this.image;
        }
        getResultPointCallback() {
            return this.resultPointCallback;
        }
        /**
         * <p>Detects a QR Code in an image.</p>
         *
         * @return {@link DetectorResult} encapsulating results of detecting a QR Code
         * @throws NotFoundException if QR Code cannot be found
         * @throws FormatException if a QR Code cannot be decoded
         */ // public detect(): DetectorResult /*throws NotFoundException, FormatException*/ {
        //   return detect(null)
        // }
        /**
         * <p>Detects a QR Code in an image.</p>
         *
         * @param hints optional hints to detector
         * @return {@link DetectorResult} encapsulating results of detecting a QR Code
         * @throws NotFoundException if QR Code cannot be found
         * @throws FormatException if a QR Code cannot be decoded
         */ detect(hints) {
            this.resultPointCallback = hints === null || hints === undefined ? null : /*(ResultPointCallback) */ hints.get(DecodeHintType$1.NEED_RESULT_POINT_CALLBACK);
            const finder = new FinderPatternFinder(this.image, this.resultPointCallback);
            const info = finder.find(hints);
            return this.processFinderPatternInfo(info);
        }
        processFinderPatternInfo(info) {
            const topLeft = info.getTopLeft();
            const topRight = info.getTopRight();
            const bottomLeft = info.getBottomLeft();
            const moduleSize = this.calculateModuleSize(topLeft, topRight, bottomLeft);
            if (moduleSize < 1.0) throw new NotFoundException('No pattern found in proccess finder.');
            const dimension = Detector$2.computeDimension(topLeft, topRight, bottomLeft, moduleSize);
            const provisionalVersion = Version$1.getProvisionalVersionForDimension(dimension);
            const modulesBetweenFPCenters = provisionalVersion.getDimensionForVersion() - 7;
            let alignmentPattern = null;
            // Anything above version 1 has an alignment pattern
            if (provisionalVersion.getAlignmentPatternCenters().length > 0) {
                // Guess where a "bottom right" finder pattern would have been
                const bottomRightX = topRight.getX() - topLeft.getX() + bottomLeft.getX();
                const bottomRightY = topRight.getY() - topLeft.getY() + bottomLeft.getY();
                // Estimate that alignment pattern is closer by 3 modules
                // from "bottom right" to known top left location
                const correctionToTopLeft = 1.0 - 3.0 / modulesBetweenFPCenters;
                const estAlignmentX = /*(int) */ Math.floor(topLeft.getX() + correctionToTopLeft * (bottomRightX - topLeft.getX()));
                const estAlignmentY = /*(int) */ Math.floor(topLeft.getY() + correctionToTopLeft * (bottomRightY - topLeft.getY()));
                // Kind of arbitrary -- expand search radius before giving up
                for(let i = 4; i <= 16; i <<= 1)try {
                    alignmentPattern = this.findAlignmentInRegion(moduleSize, estAlignmentX, estAlignmentY, i);
                    break;
                } catch (re /*NotFoundException*/ ) {
                    if (!(re instanceof NotFoundException)) throw re;
                // try next round
                }
            // If we didn't find alignment pattern... well try anyway without it
            }
            const transform = Detector$2.createTransform(topLeft, topRight, bottomLeft, alignmentPattern, dimension);
            const bits = Detector$2.sampleGrid(this.image, transform, dimension);
            let points;
            if (alignmentPattern === null) points = [
                bottomLeft,
                topLeft,
                topRight
            ];
            else points = [
                bottomLeft,
                topLeft,
                topRight,
                alignmentPattern
            ];
            return new DetectorResult(bits, points);
        }
        static createTransform(topLeft, topRight, bottomLeft, alignmentPattern, dimension /*int*/ ) {
            const dimMinusThree = dimension - 3.5;
            let bottomRightX; /*float*/ 
            let bottomRightY; /*float*/ 
            let sourceBottomRightX; /*float*/ 
            let sourceBottomRightY; /*float*/ 
            if (alignmentPattern !== null) {
                bottomRightX = alignmentPattern.getX();
                bottomRightY = alignmentPattern.getY();
                sourceBottomRightX = dimMinusThree - 3.0;
                sourceBottomRightY = sourceBottomRightX;
            } else {
                // Don't have an alignment pattern, just make up the bottom-right point
                bottomRightX = topRight.getX() - topLeft.getX() + bottomLeft.getX();
                bottomRightY = topRight.getY() - topLeft.getY() + bottomLeft.getY();
                sourceBottomRightX = dimMinusThree;
                sourceBottomRightY = dimMinusThree;
            }
            return PerspectiveTransform.quadrilateralToQuadrilateral(3.5, 3.5, dimMinusThree, 3.5, sourceBottomRightX, sourceBottomRightY, 3.5, dimMinusThree, topLeft.getX(), topLeft.getY(), topRight.getX(), topRight.getY(), bottomRightX, bottomRightY, bottomLeft.getX(), bottomLeft.getY());
        }
        static sampleGrid(image, transform, dimension /*int*/ ) {
            const sampler = GridSamplerInstance.getInstance();
            return sampler.sampleGridWithTransform(image, dimension, dimension, transform);
        }
        /**
         * <p>Computes the dimension (number of modules on a size) of the QR Code based on the position
         * of the finder patterns and estimated module size.</p>
         */ static computeDimension(topLeft, topRight, bottomLeft, moduleSize /*float*/ ) {
            const tltrCentersDimension = MathUtils.round(ResultPoint.distance(topLeft, topRight) / moduleSize);
            const tlblCentersDimension = MathUtils.round(ResultPoint.distance(topLeft, bottomLeft) / moduleSize);
            let dimension = Math.floor((tltrCentersDimension + tlblCentersDimension) / 2) + 7;
            switch(dimension & 0x03){
                case 0:
                    dimension++;
                    break;
                // 1? do nothing
                case 2:
                    dimension--;
                    break;
                case 3:
                    throw new NotFoundException('Dimensions could be not found.');
            }
            return dimension;
        }
        /**
         * <p>Computes an average estimated module size based on estimated derived from the positions
         * of the three finder patterns.</p>
         *
         * @param topLeft detected top-left finder pattern center
         * @param topRight detected top-right finder pattern center
         * @param bottomLeft detected bottom-left finder pattern center
         * @return estimated module size
         */ calculateModuleSize(topLeft, topRight, bottomLeft) {
            // Take the average
            return (this.calculateModuleSizeOneWay(topLeft, topRight) + this.calculateModuleSizeOneWay(topLeft, bottomLeft)) / 2.0;
        }
        /**
         * <p>Estimates module size based on two finder patterns -- it uses
         * {@link #sizeOfBlackWhiteBlackRunBothWays(int, int, int, int)} to figure the
         * width of each, measuring along the axis between their centers.</p>
         */ calculateModuleSizeOneWay(pattern, otherPattern) {
            const moduleSizeEst1 = this.sizeOfBlackWhiteBlackRunBothWays(/*(int) */ Math.floor(pattern.getX()), /*(int) */ Math.floor(pattern.getY()), /*(int) */ Math.floor(otherPattern.getX()), /*(int) */ Math.floor(otherPattern.getY()));
            const moduleSizeEst2 = this.sizeOfBlackWhiteBlackRunBothWays(/*(int) */ Math.floor(otherPattern.getX()), /*(int) */ Math.floor(otherPattern.getY()), /*(int) */ Math.floor(pattern.getX()), /*(int) */ Math.floor(pattern.getY()));
            if (isNaN(moduleSizeEst1)) return moduleSizeEst2 / 7.0;
            if (isNaN(moduleSizeEst2)) return moduleSizeEst1 / 7.0;
            // Average them, and divide by 7 since we've counted the width of 3 black modules,
            // and 1 white and 1 black module on either side. Ergo, divide sum by 14.
            return (moduleSizeEst1 + moduleSizeEst2) / 14.0;
        }
        /**
         * See {@link #sizeOfBlackWhiteBlackRun(int, int, int, int)}; computes the total width of
         * a finder pattern by looking for a black-white-black run from the center in the direction
         * of another point (another finder pattern center), and in the opposite direction too.
         */ sizeOfBlackWhiteBlackRunBothWays(fromX /*int*/ , fromY /*int*/ , toX /*int*/ , toY /*int*/ ) {
            let result = this.sizeOfBlackWhiteBlackRun(fromX, fromY, toX, toY);
            // Now count other way -- don't run off image though of course
            let scale = 1.0;
            let otherToX = fromX - (toX - fromX);
            if (otherToX < 0) {
                scale = fromX / /*(float) */ (fromX - otherToX);
                otherToX = 0;
            } else if (otherToX >= this.image.getWidth()) {
                scale = (this.image.getWidth() - 1 - fromX) / /*(float) */ (otherToX - fromX);
                otherToX = this.image.getWidth() - 1;
            }
            let otherToY = /*(int) */ Math.floor(fromY - (toY - fromY) * scale);
            scale = 1.0;
            if (otherToY < 0) {
                scale = fromY / /*(float) */ (fromY - otherToY);
                otherToY = 0;
            } else if (otherToY >= this.image.getHeight()) {
                scale = (this.image.getHeight() - 1 - fromY) / /*(float) */ (otherToY - fromY);
                otherToY = this.image.getHeight() - 1;
            }
            otherToX = /*(int) */ Math.floor(fromX + (otherToX - fromX) * scale);
            result += this.sizeOfBlackWhiteBlackRun(fromX, fromY, otherToX, otherToY);
            // Middle pixel is double-counted this way; subtract 1
            return result - 1.0;
        }
        /**
         * <p>This method traces a line from a point in the image, in the direction towards another point.
         * It begins in a black region, and keeps going until it finds white, then black, then white again.
         * It reports the distance from the start to this point.</p>
         *
         * <p>This is used when figuring out how wide a finder pattern is, when the finder pattern
         * may be skewed or rotated.</p>
         */ sizeOfBlackWhiteBlackRun(fromX /*int*/ , fromY /*int*/ , toX /*int*/ , toY /*int*/ ) {
            // Mild variant of Bresenham's algorithm
            // see http://en.wikipedia.org/wiki/Bresenham's_line_algorithm
            const steep = Math.abs(toY - fromY) > Math.abs(toX - fromX);
            if (steep) {
                let temp = fromX;
                fromX = fromY;
                fromY = temp;
                temp = toX;
                toX = toY;
                toY = temp;
            }
            const dx = Math.abs(toX - fromX);
            const dy = Math.abs(toY - fromY);
            let error = -dx / 2;
            const xstep = fromX < toX ? 1 : -1;
            const ystep = fromY < toY ? 1 : -1;
            // In black pixels, looking for white, first or second time.
            let state = 0;
            // Loop up until x == toX, but not beyond
            const xLimit = toX + xstep;
            for(let x = fromX, y = fromY; x !== xLimit; x += xstep){
                const realX = steep ? y : x;
                const realY = steep ? x : y;
                // Does current pixel mean we have moved white to black or vice versa?
                // Scanning black in state 0,2 and white in state 1, so if we find the wrong
                // color, advance to next state or end if we are in state 2 already
                if (state === 1 === this.image.get(realX, realY)) {
                    if (state === 2) return MathUtils.distance(x, y, fromX, fromY);
                    state++;
                }
                error += dy;
                if (error > 0) {
                    if (y === toY) break;
                    y += ystep;
                    error -= dx;
                }
            }
            // Found black-white-black; give the benefit of the doubt that the next pixel outside the image
            // is "white" so this last point at (toX+xStep,toY) is the right ending. This is really a
            // small approximation; (toX+xStep,toY+yStep) might be really correct. Ignore this.
            if (state === 2) return MathUtils.distance(toX + xstep, toY, fromX, fromY);
            // else we didn't find even black-white-black; no estimate is really possible
            return NaN;
        }
        /**
         * <p>Attempts to locate an alignment pattern in a limited region of the image, which is
         * guessed to contain it. This method uses {@link AlignmentPattern}.</p>
         *
         * @param overallEstModuleSize estimated module size so far
         * @param estAlignmentX x coordinate of center of area probably containing alignment pattern
         * @param estAlignmentY y coordinate of above
         * @param allowanceFactor number of pixels in all directions to search from the center
         * @return {@link AlignmentPattern} if found, or null otherwise
         * @throws NotFoundException if an unexpected error occurs during detection
         */ findAlignmentInRegion(overallEstModuleSize /*float*/ , estAlignmentX /*int*/ , estAlignmentY /*int*/ , allowanceFactor /*float*/ ) {
            // Look for an alignment pattern (3 modules in size) around where it
            // should be
            const allowance = /*(int) */ Math.floor(allowanceFactor * overallEstModuleSize);
            const alignmentAreaLeftX = Math.max(0, estAlignmentX - allowance);
            const alignmentAreaRightX = Math.min(this.image.getWidth() - 1, estAlignmentX + allowance);
            if (alignmentAreaRightX - alignmentAreaLeftX < overallEstModuleSize * 3) throw new NotFoundException('Alignment top exceeds estimated module size.');
            const alignmentAreaTopY = Math.max(0, estAlignmentY - allowance);
            const alignmentAreaBottomY = Math.min(this.image.getHeight() - 1, estAlignmentY + allowance);
            if (alignmentAreaBottomY - alignmentAreaTopY < overallEstModuleSize * 3) throw new NotFoundException('Alignment bottom exceeds estimated module size.');
            const alignmentFinder = new AlignmentPatternFinder(this.image, alignmentAreaLeftX, alignmentAreaTopY, alignmentAreaRightX - alignmentAreaLeftX, alignmentAreaBottomY - alignmentAreaTopY, overallEstModuleSize, this.resultPointCallback);
            return alignmentFinder.find();
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /*import java.util.List;*/ /*import java.util.Map;*/ /**
     * This implementation can detect and decode QR Codes in an image.
     *
     * @author Sean Owen
     */ class QRCodeReader {
        constructor(){
            this.decoder = new Decoder$2();
        }
        getDecoder() {
            return this.decoder;
        }
        /**
         * Locates and decodes a QR code in an image.
         *
         * @return a representing: string the content encoded by the QR code
         * @throws NotFoundException if a QR code cannot be found
         * @throws FormatException if a QR code cannot be decoded
         * @throws ChecksumException if error correction fails
         */ /*@Override*/ // public decode(image: BinaryBitmap): Result /*throws NotFoundException, ChecksumException, FormatException */ {
        //   return this.decode(image, null)
        // }
        /*@Override*/ decode(image, hints) {
            let decoderResult;
            let points;
            if (hints !== undefined && hints !== null && undefined !== hints.get(DecodeHintType$1.PURE_BARCODE)) {
                const bits = QRCodeReader.extractPureBits(image.getBlackMatrix());
                decoderResult = this.decoder.decodeBitMatrix(bits, hints);
                points = QRCodeReader.NO_POINTS;
            } else {
                const detectorResult = new Detector$2(image.getBlackMatrix()).detect(hints);
                decoderResult = this.decoder.decodeBitMatrix(detectorResult.getBits(), hints);
                points = detectorResult.getPoints();
            }
            // If the code was mirrored: swap the bottom-left and the top-right points.
            if (decoderResult.getOther() instanceof QRCodeDecoderMetaData) decoderResult.getOther().applyMirroredCorrection(points);
            const result = new Result(decoderResult.getText(), decoderResult.getRawBytes(), undefined, points, BarcodeFormat$1.QR_CODE, undefined);
            const byteSegments = decoderResult.getByteSegments();
            if (byteSegments !== null) result.putMetadata(ResultMetadataType$1.BYTE_SEGMENTS, byteSegments);
            const ecLevel = decoderResult.getECLevel();
            if (ecLevel !== null) result.putMetadata(ResultMetadataType$1.ERROR_CORRECTION_LEVEL, ecLevel);
            if (decoderResult.hasStructuredAppend()) {
                result.putMetadata(ResultMetadataType$1.STRUCTURED_APPEND_SEQUENCE, decoderResult.getStructuredAppendSequenceNumber());
                result.putMetadata(ResultMetadataType$1.STRUCTURED_APPEND_PARITY, decoderResult.getStructuredAppendParity());
            }
            return result;
        }
        /*@Override*/ reset() {
        // do nothing
        }
        /**
         * This method detects a code in a "pure" image -- that is, pure monochrome image
         * which contains only an unrotated, unskewed, image of a code, with some white border
         * around it. This is a specialized method that works exceptionally fast in this special
         * case.
         *
         * @see com.google.zxing.datamatrix.DataMatrixReader#extractPureBits(BitMatrix)
         */ static extractPureBits(image) {
            const leftTopBlack = image.getTopLeftOnBit();
            const rightBottomBlack = image.getBottomRightOnBit();
            if (leftTopBlack === null || rightBottomBlack === null) throw new NotFoundException();
            const moduleSize = this.moduleSize(leftTopBlack, image);
            let top = leftTopBlack[1];
            let bottom = rightBottomBlack[1];
            let left = leftTopBlack[0];
            let right = rightBottomBlack[0];
            // Sanity check!
            if (left >= right || top >= bottom) throw new NotFoundException();
            if (bottom - top !== right - left) {
                // Special case, where bottom-right module wasn't black so we found something else in the last row
                // Assume it's a square, so use height as the width
                right = left + (bottom - top);
                if (right >= image.getWidth()) // Abort if that would not make sense -- off image
                throw new NotFoundException();
            }
            const matrixWidth = Math.round((right - left + 1) / moduleSize);
            const matrixHeight = Math.round((bottom - top + 1) / moduleSize);
            if (matrixWidth <= 0 || matrixHeight <= 0) throw new NotFoundException();
            if (matrixHeight !== matrixWidth) // Only possibly decode square regions
            throw new NotFoundException();
            // Push in the "border" by half the module width so that we start
            // sampling in the middle of the module. Just in case the image is a
            // little off, this will help recover.
            const nudge = /*(int) */ Math.floor(moduleSize / 2.0);
            top += nudge;
            left += nudge;
            // But careful that this does not sample off the edge
            // "right" is the farthest-right valid pixel location -- right+1 is not necessarily
            // This is positive by how much the inner x loop below would be too large
            const nudgedTooFarRight = left + /*(int) */ Math.floor((matrixWidth - 1) * moduleSize) - right;
            if (nudgedTooFarRight > 0) {
                if (nudgedTooFarRight > nudge) // Neither way fits; abort
                throw new NotFoundException();
                left -= nudgedTooFarRight;
            }
            // See logic above
            const nudgedTooFarDown = top + /*(int) */ Math.floor((matrixHeight - 1) * moduleSize) - bottom;
            if (nudgedTooFarDown > 0) {
                if (nudgedTooFarDown > nudge) // Neither way fits; abort
                throw new NotFoundException();
                top -= nudgedTooFarDown;
            }
            // Now just read off the bits
            const bits = new BitMatrix(matrixWidth, matrixHeight);
            for(let y = 0; y < matrixHeight; y++){
                const iOffset = top + /*(int) */ Math.floor(y * moduleSize);
                for(let x = 0; x < matrixWidth; x++)if (image.get(left + /*(int) */ Math.floor(x * moduleSize), iOffset)) bits.set(x, y);
            }
            return bits;
        }
        static moduleSize(leftTopBlack, image) {
            const height = image.getHeight();
            const width = image.getWidth();
            let x = leftTopBlack[0];
            let y = leftTopBlack[1];
            let inBlack = true;
            let transitions = 0;
            while(x < width && y < height){
                if (inBlack !== image.get(x, y)) {
                    if (++transitions === 5) break;
                    inBlack = !inBlack;
                }
                x++;
                y++;
            }
            if (x === width || y === height) throw new NotFoundException();
            return (x - leftTopBlack[0]) / 7.0;
        }
    }
    QRCodeReader.NO_POINTS = new Array();
    /*
    * Copyright 2009 ZXing authors
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    *      http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    */ /**
     * @author SITA Lab (kevin.osullivan@sita.aero)
     * @author Guenther Grau
     */ /*public final*/ class PDF417Common {
        PDF417Common() {}
        /**
         * @param moduleBitCount values to sum
         * @return sum of values
         * @deprecated call {@link MathUtils#sum(int[])}
         */ // @Deprecated
        static getBitCountSum(moduleBitCount) {
            return MathUtils.sum(moduleBitCount);
        }
        static toIntArray(list) {
            if (list == null || !list.length) return PDF417Common.EMPTY_INT_ARRAY;
            const result = new Int32Array(list.length);
            let i = 0;
            for (const integer of list)result[i++] = integer;
            return result;
        }
        /**
         * @param symbol encoded symbol to translate to a codeword
         * @return the codeword corresponding to the symbol.
         */ static getCodeword(symbol /*int*/ ) {
            const i = Arrays.binarySearch(PDF417Common.SYMBOL_TABLE, symbol & 0x3FFFF);
            if (i < 0) return -1;
            return (PDF417Common.CODEWORD_TABLE[i] - 1) % PDF417Common.NUMBER_OF_CODEWORDS;
        }
    }
    PDF417Common.NUMBER_OF_CODEWORDS = 929;
    // Maximum Codewords (Data + Error).
    PDF417Common.MAX_CODEWORDS_IN_BARCODE = PDF417Common.NUMBER_OF_CODEWORDS - 1;
    PDF417Common.MIN_ROWS_IN_BARCODE = 3;
    PDF417Common.MAX_ROWS_IN_BARCODE = 90;
    // One left row indication column + max 30 data columns + one right row indicator column
    // public static /*final*/ MAX_CODEWORDS_IN_ROW: /*int*/ number = 32;
    PDF417Common.MODULES_IN_CODEWORD = 17;
    PDF417Common.MODULES_IN_STOP_PATTERN = 18;
    PDF417Common.BARS_IN_MODULE = 8;
    PDF417Common.EMPTY_INT_ARRAY = new Int32Array([]);
    /**
     * The sorted table of all possible symbols. Extracted from the PDF417
     * specification. The index of a symbol in this table corresponds to the
     * index into the codeword table.
     */ PDF417Common.SYMBOL_TABLE = Int32Array.from([
        0x1025e,
        0x1027a,
        0x1029e,
        0x102bc,
        0x102f2,
        0x102f4,
        0x1032e,
        0x1034e,
        0x1035c,
        0x10396,
        0x103a6,
        0x103ac,
        0x10422,
        0x10428,
        0x10436,
        0x10442,
        0x10444,
        0x10448,
        0x10450,
        0x1045e,
        0x10466,
        0x1046c,
        0x1047a,
        0x10482,
        0x1049e,
        0x104a0,
        0x104bc,
        0x104c6,
        0x104d8,
        0x104ee,
        0x104f2,
        0x104f4,
        0x10504,
        0x10508,
        0x10510,
        0x1051e,
        0x10520,
        0x1053c,
        0x10540,
        0x10578,
        0x10586,
        0x1058c,
        0x10598,
        0x105b0,
        0x105be,
        0x105ce,
        0x105dc,
        0x105e2,
        0x105e4,
        0x105e8,
        0x105f6,
        0x1062e,
        0x1064e,
        0x1065c,
        0x1068e,
        0x1069c,
        0x106b8,
        0x106de,
        0x106fa,
        0x10716,
        0x10726,
        0x1072c,
        0x10746,
        0x1074c,
        0x10758,
        0x1076e,
        0x10792,
        0x10794,
        0x107a2,
        0x107a4,
        0x107a8,
        0x107b6,
        0x10822,
        0x10828,
        0x10842,
        0x10848,
        0x10850,
        0x1085e,
        0x10866,
        0x1086c,
        0x1087a,
        0x10882,
        0x10884,
        0x10890,
        0x1089e,
        0x108a0,
        0x108bc,
        0x108c6,
        0x108cc,
        0x108d8,
        0x108ee,
        0x108f2,
        0x108f4,
        0x10902,
        0x10908,
        0x1091e,
        0x10920,
        0x1093c,
        0x10940,
        0x10978,
        0x10986,
        0x10998,
        0x109b0,
        0x109be,
        0x109ce,
        0x109dc,
        0x109e2,
        0x109e4,
        0x109e8,
        0x109f6,
        0x10a08,
        0x10a10,
        0x10a1e,
        0x10a20,
        0x10a3c,
        0x10a40,
        0x10a78,
        0x10af0,
        0x10b06,
        0x10b0c,
        0x10b18,
        0x10b30,
        0x10b3e,
        0x10b60,
        0x10b7c,
        0x10b8e,
        0x10b9c,
        0x10bb8,
        0x10bc2,
        0x10bc4,
        0x10bc8,
        0x10bd0,
        0x10bde,
        0x10be6,
        0x10bec,
        0x10c2e,
        0x10c4e,
        0x10c5c,
        0x10c62,
        0x10c64,
        0x10c68,
        0x10c76,
        0x10c8e,
        0x10c9c,
        0x10cb8,
        0x10cc2,
        0x10cc4,
        0x10cc8,
        0x10cd0,
        0x10cde,
        0x10ce6,
        0x10cec,
        0x10cfa,
        0x10d0e,
        0x10d1c,
        0x10d38,
        0x10d70,
        0x10d7e,
        0x10d82,
        0x10d84,
        0x10d88,
        0x10d90,
        0x10d9e,
        0x10da0,
        0x10dbc,
        0x10dc6,
        0x10dcc,
        0x10dd8,
        0x10dee,
        0x10df2,
        0x10df4,
        0x10e16,
        0x10e26,
        0x10e2c,
        0x10e46,
        0x10e58,
        0x10e6e,
        0x10e86,
        0x10e8c,
        0x10e98,
        0x10eb0,
        0x10ebe,
        0x10ece,
        0x10edc,
        0x10f0a,
        0x10f12,
        0x10f14,
        0x10f22,
        0x10f28,
        0x10f36,
        0x10f42,
        0x10f44,
        0x10f48,
        0x10f50,
        0x10f5e,
        0x10f66,
        0x10f6c,
        0x10fb2,
        0x10fb4,
        0x11022,
        0x11028,
        0x11042,
        0x11048,
        0x11050,
        0x1105e,
        0x1107a,
        0x11082,
        0x11084,
        0x11090,
        0x1109e,
        0x110a0,
        0x110bc,
        0x110c6,
        0x110cc,
        0x110d8,
        0x110ee,
        0x110f2,
        0x110f4,
        0x11102,
        0x1111e,
        0x11120,
        0x1113c,
        0x11140,
        0x11178,
        0x11186,
        0x11198,
        0x111b0,
        0x111be,
        0x111ce,
        0x111dc,
        0x111e2,
        0x111e4,
        0x111e8,
        0x111f6,
        0x11208,
        0x1121e,
        0x11220,
        0x11278,
        0x112f0,
        0x1130c,
        0x11330,
        0x1133e,
        0x11360,
        0x1137c,
        0x1138e,
        0x1139c,
        0x113b8,
        0x113c2,
        0x113c8,
        0x113d0,
        0x113de,
        0x113e6,
        0x113ec,
        0x11408,
        0x11410,
        0x1141e,
        0x11420,
        0x1143c,
        0x11440,
        0x11478,
        0x114f0,
        0x115e0,
        0x1160c,
        0x11618,
        0x11630,
        0x1163e,
        0x11660,
        0x1167c,
        0x116c0,
        0x116f8,
        0x1171c,
        0x11738,
        0x11770,
        0x1177e,
        0x11782,
        0x11784,
        0x11788,
        0x11790,
        0x1179e,
        0x117a0,
        0x117bc,
        0x117c6,
        0x117cc,
        0x117d8,
        0x117ee,
        0x1182e,
        0x11834,
        0x1184e,
        0x1185c,
        0x11862,
        0x11864,
        0x11868,
        0x11876,
        0x1188e,
        0x1189c,
        0x118b8,
        0x118c2,
        0x118c8,
        0x118d0,
        0x118de,
        0x118e6,
        0x118ec,
        0x118fa,
        0x1190e,
        0x1191c,
        0x11938,
        0x11970,
        0x1197e,
        0x11982,
        0x11984,
        0x11990,
        0x1199e,
        0x119a0,
        0x119bc,
        0x119c6,
        0x119cc,
        0x119d8,
        0x119ee,
        0x119f2,
        0x119f4,
        0x11a0e,
        0x11a1c,
        0x11a38,
        0x11a70,
        0x11a7e,
        0x11ae0,
        0x11afc,
        0x11b08,
        0x11b10,
        0x11b1e,
        0x11b20,
        0x11b3c,
        0x11b40,
        0x11b78,
        0x11b8c,
        0x11b98,
        0x11bb0,
        0x11bbe,
        0x11bce,
        0x11bdc,
        0x11be2,
        0x11be4,
        0x11be8,
        0x11bf6,
        0x11c16,
        0x11c26,
        0x11c2c,
        0x11c46,
        0x11c4c,
        0x11c58,
        0x11c6e,
        0x11c86,
        0x11c98,
        0x11cb0,
        0x11cbe,
        0x11cce,
        0x11cdc,
        0x11ce2,
        0x11ce4,
        0x11ce8,
        0x11cf6,
        0x11d06,
        0x11d0c,
        0x11d18,
        0x11d30,
        0x11d3e,
        0x11d60,
        0x11d7c,
        0x11d8e,
        0x11d9c,
        0x11db8,
        0x11dc4,
        0x11dc8,
        0x11dd0,
        0x11dde,
        0x11de6,
        0x11dec,
        0x11dfa,
        0x11e0a,
        0x11e12,
        0x11e14,
        0x11e22,
        0x11e24,
        0x11e28,
        0x11e36,
        0x11e42,
        0x11e44,
        0x11e50,
        0x11e5e,
        0x11e66,
        0x11e6c,
        0x11e82,
        0x11e84,
        0x11e88,
        0x11e90,
        0x11e9e,
        0x11ea0,
        0x11ebc,
        0x11ec6,
        0x11ecc,
        0x11ed8,
        0x11eee,
        0x11f1a,
        0x11f2e,
        0x11f32,
        0x11f34,
        0x11f4e,
        0x11f5c,
        0x11f62,
        0x11f64,
        0x11f68,
        0x11f76,
        0x12048,
        0x1205e,
        0x12082,
        0x12084,
        0x12090,
        0x1209e,
        0x120a0,
        0x120bc,
        0x120d8,
        0x120f2,
        0x120f4,
        0x12108,
        0x1211e,
        0x12120,
        0x1213c,
        0x12140,
        0x12178,
        0x12186,
        0x12198,
        0x121b0,
        0x121be,
        0x121e2,
        0x121e4,
        0x121e8,
        0x121f6,
        0x12204,
        0x12210,
        0x1221e,
        0x12220,
        0x12278,
        0x122f0,
        0x12306,
        0x1230c,
        0x12330,
        0x1233e,
        0x12360,
        0x1237c,
        0x1238e,
        0x1239c,
        0x123b8,
        0x123c2,
        0x123c8,
        0x123d0,
        0x123e6,
        0x123ec,
        0x1241e,
        0x12420,
        0x1243c,
        0x124f0,
        0x125e0,
        0x12618,
        0x1263e,
        0x12660,
        0x1267c,
        0x126c0,
        0x126f8,
        0x12738,
        0x12770,
        0x1277e,
        0x12782,
        0x12784,
        0x12790,
        0x1279e,
        0x127a0,
        0x127bc,
        0x127c6,
        0x127cc,
        0x127d8,
        0x127ee,
        0x12820,
        0x1283c,
        0x12840,
        0x12878,
        0x128f0,
        0x129e0,
        0x12bc0,
        0x12c18,
        0x12c30,
        0x12c3e,
        0x12c60,
        0x12c7c,
        0x12cc0,
        0x12cf8,
        0x12df0,
        0x12e1c,
        0x12e38,
        0x12e70,
        0x12e7e,
        0x12ee0,
        0x12efc,
        0x12f04,
        0x12f08,
        0x12f10,
        0x12f20,
        0x12f3c,
        0x12f40,
        0x12f78,
        0x12f86,
        0x12f8c,
        0x12f98,
        0x12fb0,
        0x12fbe,
        0x12fce,
        0x12fdc,
        0x1302e,
        0x1304e,
        0x1305c,
        0x13062,
        0x13068,
        0x1308e,
        0x1309c,
        0x130b8,
        0x130c2,
        0x130c8,
        0x130d0,
        0x130de,
        0x130ec,
        0x130fa,
        0x1310e,
        0x13138,
        0x13170,
        0x1317e,
        0x13182,
        0x13184,
        0x13190,
        0x1319e,
        0x131a0,
        0x131bc,
        0x131c6,
        0x131cc,
        0x131d8,
        0x131f2,
        0x131f4,
        0x1320e,
        0x1321c,
        0x13270,
        0x1327e,
        0x132e0,
        0x132fc,
        0x13308,
        0x1331e,
        0x13320,
        0x1333c,
        0x13340,
        0x13378,
        0x13386,
        0x13398,
        0x133b0,
        0x133be,
        0x133ce,
        0x133dc,
        0x133e2,
        0x133e4,
        0x133e8,
        0x133f6,
        0x1340e,
        0x1341c,
        0x13438,
        0x13470,
        0x1347e,
        0x134e0,
        0x134fc,
        0x135c0,
        0x135f8,
        0x13608,
        0x13610,
        0x1361e,
        0x13620,
        0x1363c,
        0x13640,
        0x13678,
        0x136f0,
        0x1370c,
        0x13718,
        0x13730,
        0x1373e,
        0x13760,
        0x1377c,
        0x1379c,
        0x137b8,
        0x137c2,
        0x137c4,
        0x137c8,
        0x137d0,
        0x137de,
        0x137e6,
        0x137ec,
        0x13816,
        0x13826,
        0x1382c,
        0x13846,
        0x1384c,
        0x13858,
        0x1386e,
        0x13874,
        0x13886,
        0x13898,
        0x138b0,
        0x138be,
        0x138ce,
        0x138dc,
        0x138e2,
        0x138e4,
        0x138e8,
        0x13906,
        0x1390c,
        0x13930,
        0x1393e,
        0x13960,
        0x1397c,
        0x1398e,
        0x1399c,
        0x139b8,
        0x139c8,
        0x139d0,
        0x139de,
        0x139e6,
        0x139ec,
        0x139fa,
        0x13a06,
        0x13a0c,
        0x13a18,
        0x13a30,
        0x13a3e,
        0x13a60,
        0x13a7c,
        0x13ac0,
        0x13af8,
        0x13b0e,
        0x13b1c,
        0x13b38,
        0x13b70,
        0x13b7e,
        0x13b88,
        0x13b90,
        0x13b9e,
        0x13ba0,
        0x13bbc,
        0x13bcc,
        0x13bd8,
        0x13bee,
        0x13bf2,
        0x13bf4,
        0x13c12,
        0x13c14,
        0x13c22,
        0x13c24,
        0x13c28,
        0x13c36,
        0x13c42,
        0x13c48,
        0x13c50,
        0x13c5e,
        0x13c66,
        0x13c6c,
        0x13c82,
        0x13c84,
        0x13c90,
        0x13c9e,
        0x13ca0,
        0x13cbc,
        0x13cc6,
        0x13ccc,
        0x13cd8,
        0x13cee,
        0x13d02,
        0x13d04,
        0x13d08,
        0x13d10,
        0x13d1e,
        0x13d20,
        0x13d3c,
        0x13d40,
        0x13d78,
        0x13d86,
        0x13d8c,
        0x13d98,
        0x13db0,
        0x13dbe,
        0x13dce,
        0x13ddc,
        0x13de4,
        0x13de8,
        0x13df6,
        0x13e1a,
        0x13e2e,
        0x13e32,
        0x13e34,
        0x13e4e,
        0x13e5c,
        0x13e62,
        0x13e64,
        0x13e68,
        0x13e76,
        0x13e8e,
        0x13e9c,
        0x13eb8,
        0x13ec2,
        0x13ec4,
        0x13ec8,
        0x13ed0,
        0x13ede,
        0x13ee6,
        0x13eec,
        0x13f26,
        0x13f2c,
        0x13f3a,
        0x13f46,
        0x13f4c,
        0x13f58,
        0x13f6e,
        0x13f72,
        0x13f74,
        0x14082,
        0x1409e,
        0x140a0,
        0x140bc,
        0x14104,
        0x14108,
        0x14110,
        0x1411e,
        0x14120,
        0x1413c,
        0x14140,
        0x14178,
        0x1418c,
        0x14198,
        0x141b0,
        0x141be,
        0x141e2,
        0x141e4,
        0x141e8,
        0x14208,
        0x14210,
        0x1421e,
        0x14220,
        0x1423c,
        0x14240,
        0x14278,
        0x142f0,
        0x14306,
        0x1430c,
        0x14318,
        0x14330,
        0x1433e,
        0x14360,
        0x1437c,
        0x1438e,
        0x143c2,
        0x143c4,
        0x143c8,
        0x143d0,
        0x143e6,
        0x143ec,
        0x14408,
        0x14410,
        0x1441e,
        0x14420,
        0x1443c,
        0x14440,
        0x14478,
        0x144f0,
        0x145e0,
        0x1460c,
        0x14618,
        0x14630,
        0x1463e,
        0x14660,
        0x1467c,
        0x146c0,
        0x146f8,
        0x1471c,
        0x14738,
        0x14770,
        0x1477e,
        0x14782,
        0x14784,
        0x14788,
        0x14790,
        0x147a0,
        0x147bc,
        0x147c6,
        0x147cc,
        0x147d8,
        0x147ee,
        0x14810,
        0x14820,
        0x1483c,
        0x14840,
        0x14878,
        0x148f0,
        0x149e0,
        0x14bc0,
        0x14c30,
        0x14c3e,
        0x14c60,
        0x14c7c,
        0x14cc0,
        0x14cf8,
        0x14df0,
        0x14e38,
        0x14e70,
        0x14e7e,
        0x14ee0,
        0x14efc,
        0x14f04,
        0x14f08,
        0x14f10,
        0x14f1e,
        0x14f20,
        0x14f3c,
        0x14f40,
        0x14f78,
        0x14f86,
        0x14f8c,
        0x14f98,
        0x14fb0,
        0x14fce,
        0x14fdc,
        0x15020,
        0x15040,
        0x15078,
        0x150f0,
        0x151e0,
        0x153c0,
        0x15860,
        0x1587c,
        0x158c0,
        0x158f8,
        0x159f0,
        0x15be0,
        0x15c70,
        0x15c7e,
        0x15ce0,
        0x15cfc,
        0x15dc0,
        0x15df8,
        0x15e08,
        0x15e10,
        0x15e20,
        0x15e40,
        0x15e78,
        0x15ef0,
        0x15f0c,
        0x15f18,
        0x15f30,
        0x15f60,
        0x15f7c,
        0x15f8e,
        0x15f9c,
        0x15fb8,
        0x1604e,
        0x1605c,
        0x1608e,
        0x1609c,
        0x160b8,
        0x160c2,
        0x160c4,
        0x160c8,
        0x160de,
        0x1610e,
        0x1611c,
        0x16138,
        0x16170,
        0x1617e,
        0x16184,
        0x16188,
        0x16190,
        0x1619e,
        0x161a0,
        0x161bc,
        0x161c6,
        0x161cc,
        0x161d8,
        0x161f2,
        0x161f4,
        0x1620e,
        0x1621c,
        0x16238,
        0x16270,
        0x1627e,
        0x162e0,
        0x162fc,
        0x16304,
        0x16308,
        0x16310,
        0x1631e,
        0x16320,
        0x1633c,
        0x16340,
        0x16378,
        0x16386,
        0x1638c,
        0x16398,
        0x163b0,
        0x163be,
        0x163ce,
        0x163dc,
        0x163e2,
        0x163e4,
        0x163e8,
        0x163f6,
        0x1640e,
        0x1641c,
        0x16438,
        0x16470,
        0x1647e,
        0x164e0,
        0x164fc,
        0x165c0,
        0x165f8,
        0x16610,
        0x1661e,
        0x16620,
        0x1663c,
        0x16640,
        0x16678,
        0x166f0,
        0x16718,
        0x16730,
        0x1673e,
        0x16760,
        0x1677c,
        0x1678e,
        0x1679c,
        0x167b8,
        0x167c2,
        0x167c4,
        0x167c8,
        0x167d0,
        0x167de,
        0x167e6,
        0x167ec,
        0x1681c,
        0x16838,
        0x16870,
        0x168e0,
        0x168fc,
        0x169c0,
        0x169f8,
        0x16bf0,
        0x16c10,
        0x16c1e,
        0x16c20,
        0x16c3c,
        0x16c40,
        0x16c78,
        0x16cf0,
        0x16de0,
        0x16e18,
        0x16e30,
        0x16e3e,
        0x16e60,
        0x16e7c,
        0x16ec0,
        0x16ef8,
        0x16f1c,
        0x16f38,
        0x16f70,
        0x16f7e,
        0x16f84,
        0x16f88,
        0x16f90,
        0x16f9e,
        0x16fa0,
        0x16fbc,
        0x16fc6,
        0x16fcc,
        0x16fd8,
        0x17026,
        0x1702c,
        0x17046,
        0x1704c,
        0x17058,
        0x1706e,
        0x17086,
        0x1708c,
        0x17098,
        0x170b0,
        0x170be,
        0x170ce,
        0x170dc,
        0x170e8,
        0x17106,
        0x1710c,
        0x17118,
        0x17130,
        0x1713e,
        0x17160,
        0x1717c,
        0x1718e,
        0x1719c,
        0x171b8,
        0x171c2,
        0x171c4,
        0x171c8,
        0x171d0,
        0x171de,
        0x171e6,
        0x171ec,
        0x171fa,
        0x17206,
        0x1720c,
        0x17218,
        0x17230,
        0x1723e,
        0x17260,
        0x1727c,
        0x172c0,
        0x172f8,
        0x1730e,
        0x1731c,
        0x17338,
        0x17370,
        0x1737e,
        0x17388,
        0x17390,
        0x1739e,
        0x173a0,
        0x173bc,
        0x173cc,
        0x173d8,
        0x173ee,
        0x173f2,
        0x173f4,
        0x1740c,
        0x17418,
        0x17430,
        0x1743e,
        0x17460,
        0x1747c,
        0x174c0,
        0x174f8,
        0x175f0,
        0x1760e,
        0x1761c,
        0x17638,
        0x17670,
        0x1767e,
        0x176e0,
        0x176fc,
        0x17708,
        0x17710,
        0x1771e,
        0x17720,
        0x1773c,
        0x17740,
        0x17778,
        0x17798,
        0x177b0,
        0x177be,
        0x177dc,
        0x177e2,
        0x177e4,
        0x177e8,
        0x17822,
        0x17824,
        0x17828,
        0x17836,
        0x17842,
        0x17844,
        0x17848,
        0x17850,
        0x1785e,
        0x17866,
        0x1786c,
        0x17882,
        0x17884,
        0x17888,
        0x17890,
        0x1789e,
        0x178a0,
        0x178bc,
        0x178c6,
        0x178cc,
        0x178d8,
        0x178ee,
        0x178f2,
        0x178f4,
        0x17902,
        0x17904,
        0x17908,
        0x17910,
        0x1791e,
        0x17920,
        0x1793c,
        0x17940,
        0x17978,
        0x17986,
        0x1798c,
        0x17998,
        0x179b0,
        0x179be,
        0x179ce,
        0x179dc,
        0x179e2,
        0x179e4,
        0x179e8,
        0x179f6,
        0x17a04,
        0x17a08,
        0x17a10,
        0x17a1e,
        0x17a20,
        0x17a3c,
        0x17a40,
        0x17a78,
        0x17af0,
        0x17b06,
        0x17b0c,
        0x17b18,
        0x17b30,
        0x17b3e,
        0x17b60,
        0x17b7c,
        0x17b8e,
        0x17b9c,
        0x17bb8,
        0x17bc4,
        0x17bc8,
        0x17bd0,
        0x17bde,
        0x17be6,
        0x17bec,
        0x17c2e,
        0x17c32,
        0x17c34,
        0x17c4e,
        0x17c5c,
        0x17c62,
        0x17c64,
        0x17c68,
        0x17c76,
        0x17c8e,
        0x17c9c,
        0x17cb8,
        0x17cc2,
        0x17cc4,
        0x17cc8,
        0x17cd0,
        0x17cde,
        0x17ce6,
        0x17cec,
        0x17d0e,
        0x17d1c,
        0x17d38,
        0x17d70,
        0x17d82,
        0x17d84,
        0x17d88,
        0x17d90,
        0x17d9e,
        0x17da0,
        0x17dbc,
        0x17dc6,
        0x17dcc,
        0x17dd8,
        0x17dee,
        0x17e26,
        0x17e2c,
        0x17e3a,
        0x17e46,
        0x17e4c,
        0x17e58,
        0x17e6e,
        0x17e72,
        0x17e74,
        0x17e86,
        0x17e8c,
        0x17e98,
        0x17eb0,
        0x17ece,
        0x17edc,
        0x17ee2,
        0x17ee4,
        0x17ee8,
        0x17ef6,
        0x1813a,
        0x18172,
        0x18174,
        0x18216,
        0x18226,
        0x1823a,
        0x1824c,
        0x18258,
        0x1826e,
        0x18272,
        0x18274,
        0x18298,
        0x182be,
        0x182e2,
        0x182e4,
        0x182e8,
        0x182f6,
        0x1835e,
        0x1837a,
        0x183ae,
        0x183d6,
        0x18416,
        0x18426,
        0x1842c,
        0x1843a,
        0x18446,
        0x18458,
        0x1846e,
        0x18472,
        0x18474,
        0x18486,
        0x184b0,
        0x184be,
        0x184ce,
        0x184dc,
        0x184e2,
        0x184e4,
        0x184e8,
        0x184f6,
        0x18506,
        0x1850c,
        0x18518,
        0x18530,
        0x1853e,
        0x18560,
        0x1857c,
        0x1858e,
        0x1859c,
        0x185b8,
        0x185c2,
        0x185c4,
        0x185c8,
        0x185d0,
        0x185de,
        0x185e6,
        0x185ec,
        0x185fa,
        0x18612,
        0x18614,
        0x18622,
        0x18628,
        0x18636,
        0x18642,
        0x18650,
        0x1865e,
        0x1867a,
        0x18682,
        0x18684,
        0x18688,
        0x18690,
        0x1869e,
        0x186a0,
        0x186bc,
        0x186c6,
        0x186cc,
        0x186d8,
        0x186ee,
        0x186f2,
        0x186f4,
        0x1872e,
        0x1874e,
        0x1875c,
        0x18796,
        0x187a6,
        0x187ac,
        0x187d2,
        0x187d4,
        0x18826,
        0x1882c,
        0x1883a,
        0x18846,
        0x1884c,
        0x18858,
        0x1886e,
        0x18872,
        0x18874,
        0x18886,
        0x18898,
        0x188b0,
        0x188be,
        0x188ce,
        0x188dc,
        0x188e2,
        0x188e4,
        0x188e8,
        0x188f6,
        0x1890c,
        0x18930,
        0x1893e,
        0x18960,
        0x1897c,
        0x1898e,
        0x189b8,
        0x189c2,
        0x189c8,
        0x189d0,
        0x189de,
        0x189e6,
        0x189ec,
        0x189fa,
        0x18a18,
        0x18a30,
        0x18a3e,
        0x18a60,
        0x18a7c,
        0x18ac0,
        0x18af8,
        0x18b1c,
        0x18b38,
        0x18b70,
        0x18b7e,
        0x18b82,
        0x18b84,
        0x18b88,
        0x18b90,
        0x18b9e,
        0x18ba0,
        0x18bbc,
        0x18bc6,
        0x18bcc,
        0x18bd8,
        0x18bee,
        0x18bf2,
        0x18bf4,
        0x18c22,
        0x18c24,
        0x18c28,
        0x18c36,
        0x18c42,
        0x18c48,
        0x18c50,
        0x18c5e,
        0x18c66,
        0x18c7a,
        0x18c82,
        0x18c84,
        0x18c90,
        0x18c9e,
        0x18ca0,
        0x18cbc,
        0x18ccc,
        0x18cf2,
        0x18cf4,
        0x18d04,
        0x18d08,
        0x18d10,
        0x18d1e,
        0x18d20,
        0x18d3c,
        0x18d40,
        0x18d78,
        0x18d86,
        0x18d98,
        0x18dce,
        0x18de2,
        0x18de4,
        0x18de8,
        0x18e2e,
        0x18e32,
        0x18e34,
        0x18e4e,
        0x18e5c,
        0x18e62,
        0x18e64,
        0x18e68,
        0x18e8e,
        0x18e9c,
        0x18eb8,
        0x18ec2,
        0x18ec4,
        0x18ec8,
        0x18ed0,
        0x18efa,
        0x18f16,
        0x18f26,
        0x18f2c,
        0x18f46,
        0x18f4c,
        0x18f58,
        0x18f6e,
        0x18f8a,
        0x18f92,
        0x18f94,
        0x18fa2,
        0x18fa4,
        0x18fa8,
        0x18fb6,
        0x1902c,
        0x1903a,
        0x19046,
        0x1904c,
        0x19058,
        0x19072,
        0x19074,
        0x19086,
        0x19098,
        0x190b0,
        0x190be,
        0x190ce,
        0x190dc,
        0x190e2,
        0x190e8,
        0x190f6,
        0x19106,
        0x1910c,
        0x19130,
        0x1913e,
        0x19160,
        0x1917c,
        0x1918e,
        0x1919c,
        0x191b8,
        0x191c2,
        0x191c8,
        0x191d0,
        0x191de,
        0x191e6,
        0x191ec,
        0x191fa,
        0x19218,
        0x1923e,
        0x19260,
        0x1927c,
        0x192c0,
        0x192f8,
        0x19338,
        0x19370,
        0x1937e,
        0x19382,
        0x19384,
        0x19390,
        0x1939e,
        0x193a0,
        0x193bc,
        0x193c6,
        0x193cc,
        0x193d8,
        0x193ee,
        0x193f2,
        0x193f4,
        0x19430,
        0x1943e,
        0x19460,
        0x1947c,
        0x194c0,
        0x194f8,
        0x195f0,
        0x19638,
        0x19670,
        0x1967e,
        0x196e0,
        0x196fc,
        0x19702,
        0x19704,
        0x19708,
        0x19710,
        0x19720,
        0x1973c,
        0x19740,
        0x19778,
        0x19786,
        0x1978c,
        0x19798,
        0x197b0,
        0x197be,
        0x197ce,
        0x197dc,
        0x197e2,
        0x197e4,
        0x197e8,
        0x19822,
        0x19824,
        0x19842,
        0x19848,
        0x19850,
        0x1985e,
        0x19866,
        0x1987a,
        0x19882,
        0x19884,
        0x19890,
        0x1989e,
        0x198a0,
        0x198bc,
        0x198cc,
        0x198f2,
        0x198f4,
        0x19902,
        0x19908,
        0x1991e,
        0x19920,
        0x1993c,
        0x19940,
        0x19978,
        0x19986,
        0x19998,
        0x199ce,
        0x199e2,
        0x199e4,
        0x199e8,
        0x19a08,
        0x19a10,
        0x19a1e,
        0x19a20,
        0x19a3c,
        0x19a40,
        0x19a78,
        0x19af0,
        0x19b18,
        0x19b3e,
        0x19b60,
        0x19b9c,
        0x19bc2,
        0x19bc4,
        0x19bc8,
        0x19bd0,
        0x19be6,
        0x19c2e,
        0x19c34,
        0x19c4e,
        0x19c5c,
        0x19c62,
        0x19c64,
        0x19c68,
        0x19c8e,
        0x19c9c,
        0x19cb8,
        0x19cc2,
        0x19cc8,
        0x19cd0,
        0x19ce6,
        0x19cfa,
        0x19d0e,
        0x19d1c,
        0x19d38,
        0x19d70,
        0x19d7e,
        0x19d82,
        0x19d84,
        0x19d88,
        0x19d90,
        0x19da0,
        0x19dcc,
        0x19df2,
        0x19df4,
        0x19e16,
        0x19e26,
        0x19e2c,
        0x19e46,
        0x19e4c,
        0x19e58,
        0x19e74,
        0x19e86,
        0x19e8c,
        0x19e98,
        0x19eb0,
        0x19ebe,
        0x19ece,
        0x19ee2,
        0x19ee4,
        0x19ee8,
        0x19f0a,
        0x19f12,
        0x19f14,
        0x19f22,
        0x19f24,
        0x19f28,
        0x19f42,
        0x19f44,
        0x19f48,
        0x19f50,
        0x19f5e,
        0x19f6c,
        0x19f9a,
        0x19fae,
        0x19fb2,
        0x19fb4,
        0x1a046,
        0x1a04c,
        0x1a072,
        0x1a074,
        0x1a086,
        0x1a08c,
        0x1a098,
        0x1a0b0,
        0x1a0be,
        0x1a0e2,
        0x1a0e4,
        0x1a0e8,
        0x1a0f6,
        0x1a106,
        0x1a10c,
        0x1a118,
        0x1a130,
        0x1a13e,
        0x1a160,
        0x1a17c,
        0x1a18e,
        0x1a19c,
        0x1a1b8,
        0x1a1c2,
        0x1a1c4,
        0x1a1c8,
        0x1a1d0,
        0x1a1de,
        0x1a1e6,
        0x1a1ec,
        0x1a218,
        0x1a230,
        0x1a23e,
        0x1a260,
        0x1a27c,
        0x1a2c0,
        0x1a2f8,
        0x1a31c,
        0x1a338,
        0x1a370,
        0x1a37e,
        0x1a382,
        0x1a384,
        0x1a388,
        0x1a390,
        0x1a39e,
        0x1a3a0,
        0x1a3bc,
        0x1a3c6,
        0x1a3cc,
        0x1a3d8,
        0x1a3ee,
        0x1a3f2,
        0x1a3f4,
        0x1a418,
        0x1a430,
        0x1a43e,
        0x1a460,
        0x1a47c,
        0x1a4c0,
        0x1a4f8,
        0x1a5f0,
        0x1a61c,
        0x1a638,
        0x1a670,
        0x1a67e,
        0x1a6e0,
        0x1a6fc,
        0x1a702,
        0x1a704,
        0x1a708,
        0x1a710,
        0x1a71e,
        0x1a720,
        0x1a73c,
        0x1a740,
        0x1a778,
        0x1a786,
        0x1a78c,
        0x1a798,
        0x1a7b0,
        0x1a7be,
        0x1a7ce,
        0x1a7dc,
        0x1a7e2,
        0x1a7e4,
        0x1a7e8,
        0x1a830,
        0x1a860,
        0x1a87c,
        0x1a8c0,
        0x1a8f8,
        0x1a9f0,
        0x1abe0,
        0x1ac70,
        0x1ac7e,
        0x1ace0,
        0x1acfc,
        0x1adc0,
        0x1adf8,
        0x1ae04,
        0x1ae08,
        0x1ae10,
        0x1ae20,
        0x1ae3c,
        0x1ae40,
        0x1ae78,
        0x1aef0,
        0x1af06,
        0x1af0c,
        0x1af18,
        0x1af30,
        0x1af3e,
        0x1af60,
        0x1af7c,
        0x1af8e,
        0x1af9c,
        0x1afb8,
        0x1afc4,
        0x1afc8,
        0x1afd0,
        0x1afde,
        0x1b042,
        0x1b05e,
        0x1b07a,
        0x1b082,
        0x1b084,
        0x1b088,
        0x1b090,
        0x1b09e,
        0x1b0a0,
        0x1b0bc,
        0x1b0cc,
        0x1b0f2,
        0x1b0f4,
        0x1b102,
        0x1b104,
        0x1b108,
        0x1b110,
        0x1b11e,
        0x1b120,
        0x1b13c,
        0x1b140,
        0x1b178,
        0x1b186,
        0x1b198,
        0x1b1ce,
        0x1b1e2,
        0x1b1e4,
        0x1b1e8,
        0x1b204,
        0x1b208,
        0x1b210,
        0x1b21e,
        0x1b220,
        0x1b23c,
        0x1b240,
        0x1b278,
        0x1b2f0,
        0x1b30c,
        0x1b33e,
        0x1b360,
        0x1b39c,
        0x1b3c2,
        0x1b3c4,
        0x1b3c8,
        0x1b3d0,
        0x1b3e6,
        0x1b410,
        0x1b41e,
        0x1b420,
        0x1b43c,
        0x1b440,
        0x1b478,
        0x1b4f0,
        0x1b5e0,
        0x1b618,
        0x1b660,
        0x1b67c,
        0x1b6c0,
        0x1b738,
        0x1b782,
        0x1b784,
        0x1b788,
        0x1b790,
        0x1b79e,
        0x1b7a0,
        0x1b7cc,
        0x1b82e,
        0x1b84e,
        0x1b85c,
        0x1b88e,
        0x1b89c,
        0x1b8b8,
        0x1b8c2,
        0x1b8c4,
        0x1b8c8,
        0x1b8d0,
        0x1b8e6,
        0x1b8fa,
        0x1b90e,
        0x1b91c,
        0x1b938,
        0x1b970,
        0x1b97e,
        0x1b982,
        0x1b984,
        0x1b988,
        0x1b990,
        0x1b99e,
        0x1b9a0,
        0x1b9cc,
        0x1b9f2,
        0x1b9f4,
        0x1ba0e,
        0x1ba1c,
        0x1ba38,
        0x1ba70,
        0x1ba7e,
        0x1bae0,
        0x1bafc,
        0x1bb08,
        0x1bb10,
        0x1bb20,
        0x1bb3c,
        0x1bb40,
        0x1bb98,
        0x1bbce,
        0x1bbe2,
        0x1bbe4,
        0x1bbe8,
        0x1bc16,
        0x1bc26,
        0x1bc2c,
        0x1bc46,
        0x1bc4c,
        0x1bc58,
        0x1bc72,
        0x1bc74,
        0x1bc86,
        0x1bc8c,
        0x1bc98,
        0x1bcb0,
        0x1bcbe,
        0x1bcce,
        0x1bce2,
        0x1bce4,
        0x1bce8,
        0x1bd06,
        0x1bd0c,
        0x1bd18,
        0x1bd30,
        0x1bd3e,
        0x1bd60,
        0x1bd7c,
        0x1bd9c,
        0x1bdc2,
        0x1bdc4,
        0x1bdc8,
        0x1bdd0,
        0x1bde6,
        0x1bdfa,
        0x1be12,
        0x1be14,
        0x1be22,
        0x1be24,
        0x1be28,
        0x1be42,
        0x1be44,
        0x1be48,
        0x1be50,
        0x1be5e,
        0x1be66,
        0x1be82,
        0x1be84,
        0x1be88,
        0x1be90,
        0x1be9e,
        0x1bea0,
        0x1bebc,
        0x1becc,
        0x1bef4,
        0x1bf1a,
        0x1bf2e,
        0x1bf32,
        0x1bf34,
        0x1bf4e,
        0x1bf5c,
        0x1bf62,
        0x1bf64,
        0x1bf68,
        0x1c09a,
        0x1c0b2,
        0x1c0b4,
        0x1c11a,
        0x1c132,
        0x1c134,
        0x1c162,
        0x1c164,
        0x1c168,
        0x1c176,
        0x1c1ba,
        0x1c21a,
        0x1c232,
        0x1c234,
        0x1c24e,
        0x1c25c,
        0x1c262,
        0x1c264,
        0x1c268,
        0x1c276,
        0x1c28e,
        0x1c2c2,
        0x1c2c4,
        0x1c2c8,
        0x1c2d0,
        0x1c2de,
        0x1c2e6,
        0x1c2ec,
        0x1c2fa,
        0x1c316,
        0x1c326,
        0x1c33a,
        0x1c346,
        0x1c34c,
        0x1c372,
        0x1c374,
        0x1c41a,
        0x1c42e,
        0x1c432,
        0x1c434,
        0x1c44e,
        0x1c45c,
        0x1c462,
        0x1c464,
        0x1c468,
        0x1c476,
        0x1c48e,
        0x1c49c,
        0x1c4b8,
        0x1c4c2,
        0x1c4c8,
        0x1c4d0,
        0x1c4de,
        0x1c4e6,
        0x1c4ec,
        0x1c4fa,
        0x1c51c,
        0x1c538,
        0x1c570,
        0x1c57e,
        0x1c582,
        0x1c584,
        0x1c588,
        0x1c590,
        0x1c59e,
        0x1c5a0,
        0x1c5bc,
        0x1c5c6,
        0x1c5cc,
        0x1c5d8,
        0x1c5ee,
        0x1c5f2,
        0x1c5f4,
        0x1c616,
        0x1c626,
        0x1c62c,
        0x1c63a,
        0x1c646,
        0x1c64c,
        0x1c658,
        0x1c66e,
        0x1c672,
        0x1c674,
        0x1c686,
        0x1c68c,
        0x1c698,
        0x1c6b0,
        0x1c6be,
        0x1c6ce,
        0x1c6dc,
        0x1c6e2,
        0x1c6e4,
        0x1c6e8,
        0x1c712,
        0x1c714,
        0x1c722,
        0x1c728,
        0x1c736,
        0x1c742,
        0x1c744,
        0x1c748,
        0x1c750,
        0x1c75e,
        0x1c766,
        0x1c76c,
        0x1c77a,
        0x1c7ae,
        0x1c7d6,
        0x1c7ea,
        0x1c81a,
        0x1c82e,
        0x1c832,
        0x1c834,
        0x1c84e,
        0x1c85c,
        0x1c862,
        0x1c864,
        0x1c868,
        0x1c876,
        0x1c88e,
        0x1c89c,
        0x1c8b8,
        0x1c8c2,
        0x1c8c8,
        0x1c8d0,
        0x1c8de,
        0x1c8e6,
        0x1c8ec,
        0x1c8fa,
        0x1c90e,
        0x1c938,
        0x1c970,
        0x1c97e,
        0x1c982,
        0x1c984,
        0x1c990,
        0x1c99e,
        0x1c9a0,
        0x1c9bc,
        0x1c9c6,
        0x1c9cc,
        0x1c9d8,
        0x1c9ee,
        0x1c9f2,
        0x1c9f4,
        0x1ca38,
        0x1ca70,
        0x1ca7e,
        0x1cae0,
        0x1cafc,
        0x1cb02,
        0x1cb04,
        0x1cb08,
        0x1cb10,
        0x1cb20,
        0x1cb3c,
        0x1cb40,
        0x1cb78,
        0x1cb86,
        0x1cb8c,
        0x1cb98,
        0x1cbb0,
        0x1cbbe,
        0x1cbce,
        0x1cbdc,
        0x1cbe2,
        0x1cbe4,
        0x1cbe8,
        0x1cbf6,
        0x1cc16,
        0x1cc26,
        0x1cc2c,
        0x1cc3a,
        0x1cc46,
        0x1cc58,
        0x1cc72,
        0x1cc74,
        0x1cc86,
        0x1ccb0,
        0x1ccbe,
        0x1ccce,
        0x1cce2,
        0x1cce4,
        0x1cce8,
        0x1cd06,
        0x1cd0c,
        0x1cd18,
        0x1cd30,
        0x1cd3e,
        0x1cd60,
        0x1cd7c,
        0x1cd9c,
        0x1cdc2,
        0x1cdc4,
        0x1cdc8,
        0x1cdd0,
        0x1cdde,
        0x1cde6,
        0x1cdfa,
        0x1ce22,
        0x1ce28,
        0x1ce42,
        0x1ce50,
        0x1ce5e,
        0x1ce66,
        0x1ce7a,
        0x1ce82,
        0x1ce84,
        0x1ce88,
        0x1ce90,
        0x1ce9e,
        0x1cea0,
        0x1cebc,
        0x1cecc,
        0x1cef2,
        0x1cef4,
        0x1cf2e,
        0x1cf32,
        0x1cf34,
        0x1cf4e,
        0x1cf5c,
        0x1cf62,
        0x1cf64,
        0x1cf68,
        0x1cf96,
        0x1cfa6,
        0x1cfac,
        0x1cfca,
        0x1cfd2,
        0x1cfd4,
        0x1d02e,
        0x1d032,
        0x1d034,
        0x1d04e,
        0x1d05c,
        0x1d062,
        0x1d064,
        0x1d068,
        0x1d076,
        0x1d08e,
        0x1d09c,
        0x1d0b8,
        0x1d0c2,
        0x1d0c4,
        0x1d0c8,
        0x1d0d0,
        0x1d0de,
        0x1d0e6,
        0x1d0ec,
        0x1d0fa,
        0x1d11c,
        0x1d138,
        0x1d170,
        0x1d17e,
        0x1d182,
        0x1d184,
        0x1d188,
        0x1d190,
        0x1d19e,
        0x1d1a0,
        0x1d1bc,
        0x1d1c6,
        0x1d1cc,
        0x1d1d8,
        0x1d1ee,
        0x1d1f2,
        0x1d1f4,
        0x1d21c,
        0x1d238,
        0x1d270,
        0x1d27e,
        0x1d2e0,
        0x1d2fc,
        0x1d302,
        0x1d304,
        0x1d308,
        0x1d310,
        0x1d31e,
        0x1d320,
        0x1d33c,
        0x1d340,
        0x1d378,
        0x1d386,
        0x1d38c,
        0x1d398,
        0x1d3b0,
        0x1d3be,
        0x1d3ce,
        0x1d3dc,
        0x1d3e2,
        0x1d3e4,
        0x1d3e8,
        0x1d3f6,
        0x1d470,
        0x1d47e,
        0x1d4e0,
        0x1d4fc,
        0x1d5c0,
        0x1d5f8,
        0x1d604,
        0x1d608,
        0x1d610,
        0x1d620,
        0x1d640,
        0x1d678,
        0x1d6f0,
        0x1d706,
        0x1d70c,
        0x1d718,
        0x1d730,
        0x1d73e,
        0x1d760,
        0x1d77c,
        0x1d78e,
        0x1d79c,
        0x1d7b8,
        0x1d7c2,
        0x1d7c4,
        0x1d7c8,
        0x1d7d0,
        0x1d7de,
        0x1d7e6,
        0x1d7ec,
        0x1d826,
        0x1d82c,
        0x1d83a,
        0x1d846,
        0x1d84c,
        0x1d858,
        0x1d872,
        0x1d874,
        0x1d886,
        0x1d88c,
        0x1d898,
        0x1d8b0,
        0x1d8be,
        0x1d8ce,
        0x1d8e2,
        0x1d8e4,
        0x1d8e8,
        0x1d8f6,
        0x1d90c,
        0x1d918,
        0x1d930,
        0x1d93e,
        0x1d960,
        0x1d97c,
        0x1d99c,
        0x1d9c2,
        0x1d9c4,
        0x1d9c8,
        0x1d9d0,
        0x1d9e6,
        0x1d9fa,
        0x1da0c,
        0x1da18,
        0x1da30,
        0x1da3e,
        0x1da60,
        0x1da7c,
        0x1dac0,
        0x1daf8,
        0x1db38,
        0x1db82,
        0x1db84,
        0x1db88,
        0x1db90,
        0x1db9e,
        0x1dba0,
        0x1dbcc,
        0x1dbf2,
        0x1dbf4,
        0x1dc22,
        0x1dc42,
        0x1dc44,
        0x1dc48,
        0x1dc50,
        0x1dc5e,
        0x1dc66,
        0x1dc7a,
        0x1dc82,
        0x1dc84,
        0x1dc88,
        0x1dc90,
        0x1dc9e,
        0x1dca0,
        0x1dcbc,
        0x1dccc,
        0x1dcf2,
        0x1dcf4,
        0x1dd04,
        0x1dd08,
        0x1dd10,
        0x1dd1e,
        0x1dd20,
        0x1dd3c,
        0x1dd40,
        0x1dd78,
        0x1dd86,
        0x1dd98,
        0x1ddce,
        0x1dde2,
        0x1dde4,
        0x1dde8,
        0x1de2e,
        0x1de32,
        0x1de34,
        0x1de4e,
        0x1de5c,
        0x1de62,
        0x1de64,
        0x1de68,
        0x1de8e,
        0x1de9c,
        0x1deb8,
        0x1dec2,
        0x1dec4,
        0x1dec8,
        0x1ded0,
        0x1dee6,
        0x1defa,
        0x1df16,
        0x1df26,
        0x1df2c,
        0x1df46,
        0x1df4c,
        0x1df58,
        0x1df72,
        0x1df74,
        0x1df8a,
        0x1df92,
        0x1df94,
        0x1dfa2,
        0x1dfa4,
        0x1dfa8,
        0x1e08a,
        0x1e092,
        0x1e094,
        0x1e0a2,
        0x1e0a4,
        0x1e0a8,
        0x1e0b6,
        0x1e0da,
        0x1e10a,
        0x1e112,
        0x1e114,
        0x1e122,
        0x1e124,
        0x1e128,
        0x1e136,
        0x1e142,
        0x1e144,
        0x1e148,
        0x1e150,
        0x1e166,
        0x1e16c,
        0x1e17a,
        0x1e19a,
        0x1e1b2,
        0x1e1b4,
        0x1e20a,
        0x1e212,
        0x1e214,
        0x1e222,
        0x1e224,
        0x1e228,
        0x1e236,
        0x1e242,
        0x1e248,
        0x1e250,
        0x1e25e,
        0x1e266,
        0x1e26c,
        0x1e27a,
        0x1e282,
        0x1e284,
        0x1e288,
        0x1e290,
        0x1e2a0,
        0x1e2bc,
        0x1e2c6,
        0x1e2cc,
        0x1e2d8,
        0x1e2ee,
        0x1e2f2,
        0x1e2f4,
        0x1e31a,
        0x1e332,
        0x1e334,
        0x1e35c,
        0x1e362,
        0x1e364,
        0x1e368,
        0x1e3ba,
        0x1e40a,
        0x1e412,
        0x1e414,
        0x1e422,
        0x1e428,
        0x1e436,
        0x1e442,
        0x1e448,
        0x1e450,
        0x1e45e,
        0x1e466,
        0x1e46c,
        0x1e47a,
        0x1e482,
        0x1e484,
        0x1e490,
        0x1e49e,
        0x1e4a0,
        0x1e4bc,
        0x1e4c6,
        0x1e4cc,
        0x1e4d8,
        0x1e4ee,
        0x1e4f2,
        0x1e4f4,
        0x1e502,
        0x1e504,
        0x1e508,
        0x1e510,
        0x1e51e,
        0x1e520,
        0x1e53c,
        0x1e540,
        0x1e578,
        0x1e586,
        0x1e58c,
        0x1e598,
        0x1e5b0,
        0x1e5be,
        0x1e5ce,
        0x1e5dc,
        0x1e5e2,
        0x1e5e4,
        0x1e5e8,
        0x1e5f6,
        0x1e61a,
        0x1e62e,
        0x1e632,
        0x1e634,
        0x1e64e,
        0x1e65c,
        0x1e662,
        0x1e668,
        0x1e68e,
        0x1e69c,
        0x1e6b8,
        0x1e6c2,
        0x1e6c4,
        0x1e6c8,
        0x1e6d0,
        0x1e6e6,
        0x1e6fa,
        0x1e716,
        0x1e726,
        0x1e72c,
        0x1e73a,
        0x1e746,
        0x1e74c,
        0x1e758,
        0x1e772,
        0x1e774,
        0x1e792,
        0x1e794,
        0x1e7a2,
        0x1e7a4,
        0x1e7a8,
        0x1e7b6,
        0x1e812,
        0x1e814,
        0x1e822,
        0x1e824,
        0x1e828,
        0x1e836,
        0x1e842,
        0x1e844,
        0x1e848,
        0x1e850,
        0x1e85e,
        0x1e866,
        0x1e86c,
        0x1e87a,
        0x1e882,
        0x1e884,
        0x1e888,
        0x1e890,
        0x1e89e,
        0x1e8a0,
        0x1e8bc,
        0x1e8c6,
        0x1e8cc,
        0x1e8d8,
        0x1e8ee,
        0x1e8f2,
        0x1e8f4,
        0x1e902,
        0x1e904,
        0x1e908,
        0x1e910,
        0x1e920,
        0x1e93c,
        0x1e940,
        0x1e978,
        0x1e986,
        0x1e98c,
        0x1e998,
        0x1e9b0,
        0x1e9be,
        0x1e9ce,
        0x1e9dc,
        0x1e9e2,
        0x1e9e4,
        0x1e9e8,
        0x1e9f6,
        0x1ea04,
        0x1ea08,
        0x1ea10,
        0x1ea20,
        0x1ea40,
        0x1ea78,
        0x1eaf0,
        0x1eb06,
        0x1eb0c,
        0x1eb18,
        0x1eb30,
        0x1eb3e,
        0x1eb60,
        0x1eb7c,
        0x1eb8e,
        0x1eb9c,
        0x1ebb8,
        0x1ebc2,
        0x1ebc4,
        0x1ebc8,
        0x1ebd0,
        0x1ebde,
        0x1ebe6,
        0x1ebec,
        0x1ec1a,
        0x1ec2e,
        0x1ec32,
        0x1ec34,
        0x1ec4e,
        0x1ec5c,
        0x1ec62,
        0x1ec64,
        0x1ec68,
        0x1ec8e,
        0x1ec9c,
        0x1ecb8,
        0x1ecc2,
        0x1ecc4,
        0x1ecc8,
        0x1ecd0,
        0x1ece6,
        0x1ecfa,
        0x1ed0e,
        0x1ed1c,
        0x1ed38,
        0x1ed70,
        0x1ed7e,
        0x1ed82,
        0x1ed84,
        0x1ed88,
        0x1ed90,
        0x1ed9e,
        0x1eda0,
        0x1edcc,
        0x1edf2,
        0x1edf4,
        0x1ee16,
        0x1ee26,
        0x1ee2c,
        0x1ee3a,
        0x1ee46,
        0x1ee4c,
        0x1ee58,
        0x1ee6e,
        0x1ee72,
        0x1ee74,
        0x1ee86,
        0x1ee8c,
        0x1ee98,
        0x1eeb0,
        0x1eebe,
        0x1eece,
        0x1eedc,
        0x1eee2,
        0x1eee4,
        0x1eee8,
        0x1ef12,
        0x1ef22,
        0x1ef24,
        0x1ef28,
        0x1ef36,
        0x1ef42,
        0x1ef44,
        0x1ef48,
        0x1ef50,
        0x1ef5e,
        0x1ef66,
        0x1ef6c,
        0x1ef7a,
        0x1efae,
        0x1efb2,
        0x1efb4,
        0x1efd6,
        0x1f096,
        0x1f0a6,
        0x1f0ac,
        0x1f0ba,
        0x1f0ca,
        0x1f0d2,
        0x1f0d4,
        0x1f116,
        0x1f126,
        0x1f12c,
        0x1f13a,
        0x1f146,
        0x1f14c,
        0x1f158,
        0x1f16e,
        0x1f172,
        0x1f174,
        0x1f18a,
        0x1f192,
        0x1f194,
        0x1f1a2,
        0x1f1a4,
        0x1f1a8,
        0x1f1da,
        0x1f216,
        0x1f226,
        0x1f22c,
        0x1f23a,
        0x1f246,
        0x1f258,
        0x1f26e,
        0x1f272,
        0x1f274,
        0x1f286,
        0x1f28c,
        0x1f298,
        0x1f2b0,
        0x1f2be,
        0x1f2ce,
        0x1f2dc,
        0x1f2e2,
        0x1f2e4,
        0x1f2e8,
        0x1f2f6,
        0x1f30a,
        0x1f312,
        0x1f314,
        0x1f322,
        0x1f328,
        0x1f342,
        0x1f344,
        0x1f348,
        0x1f350,
        0x1f35e,
        0x1f366,
        0x1f37a,
        0x1f39a,
        0x1f3ae,
        0x1f3b2,
        0x1f3b4,
        0x1f416,
        0x1f426,
        0x1f42c,
        0x1f43a,
        0x1f446,
        0x1f44c,
        0x1f458,
        0x1f46e,
        0x1f472,
        0x1f474,
        0x1f486,
        0x1f48c,
        0x1f498,
        0x1f4b0,
        0x1f4be,
        0x1f4ce,
        0x1f4dc,
        0x1f4e2,
        0x1f4e4,
        0x1f4e8,
        0x1f4f6,
        0x1f506,
        0x1f50c,
        0x1f518,
        0x1f530,
        0x1f53e,
        0x1f560,
        0x1f57c,
        0x1f58e,
        0x1f59c,
        0x1f5b8,
        0x1f5c2,
        0x1f5c4,
        0x1f5c8,
        0x1f5d0,
        0x1f5de,
        0x1f5e6,
        0x1f5ec,
        0x1f5fa,
        0x1f60a,
        0x1f612,
        0x1f614,
        0x1f622,
        0x1f624,
        0x1f628,
        0x1f636,
        0x1f642,
        0x1f644,
        0x1f648,
        0x1f650,
        0x1f65e,
        0x1f666,
        0x1f67a,
        0x1f682,
        0x1f684,
        0x1f688,
        0x1f690,
        0x1f69e,
        0x1f6a0,
        0x1f6bc,
        0x1f6cc,
        0x1f6f2,
        0x1f6f4,
        0x1f71a,
        0x1f72e,
        0x1f732,
        0x1f734,
        0x1f74e,
        0x1f75c,
        0x1f762,
        0x1f764,
        0x1f768,
        0x1f776,
        0x1f796,
        0x1f7a6,
        0x1f7ac,
        0x1f7ba,
        0x1f7d2,
        0x1f7d4,
        0x1f89a,
        0x1f8ae,
        0x1f8b2,
        0x1f8b4,
        0x1f8d6,
        0x1f8ea,
        0x1f91a,
        0x1f92e,
        0x1f932,
        0x1f934,
        0x1f94e,
        0x1f95c,
        0x1f962,
        0x1f964,
        0x1f968,
        0x1f976,
        0x1f996,
        0x1f9a6,
        0x1f9ac,
        0x1f9ba,
        0x1f9ca,
        0x1f9d2,
        0x1f9d4,
        0x1fa1a,
        0x1fa2e,
        0x1fa32,
        0x1fa34,
        0x1fa4e,
        0x1fa5c,
        0x1fa62,
        0x1fa64,
        0x1fa68,
        0x1fa76,
        0x1fa8e,
        0x1fa9c,
        0x1fab8,
        0x1fac2,
        0x1fac4,
        0x1fac8,
        0x1fad0,
        0x1fade,
        0x1fae6,
        0x1faec,
        0x1fb16,
        0x1fb26,
        0x1fb2c,
        0x1fb3a,
        0x1fb46,
        0x1fb4c,
        0x1fb58,
        0x1fb6e,
        0x1fb72,
        0x1fb74,
        0x1fb8a,
        0x1fb92,
        0x1fb94,
        0x1fba2,
        0x1fba4,
        0x1fba8,
        0x1fbb6,
        0x1fbda
    ]);
    /**
     * This table contains to codewords for all symbols.
     */ PDF417Common.CODEWORD_TABLE = Int32Array.from([
        2627,
        1819,
        2622,
        2621,
        1813,
        1812,
        2729,
        2724,
        2723,
        2779,
        2774,
        2773,
        902,
        896,
        908,
        868,
        865,
        861,
        859,
        2511,
        873,
        871,
        1780,
        835,
        2493,
        825,
        2491,
        842,
        837,
        844,
        1764,
        1762,
        811,
        810,
        809,
        2483,
        807,
        2482,
        806,
        2480,
        815,
        814,
        813,
        812,
        2484,
        817,
        816,
        1745,
        1744,
        1742,
        1746,
        2655,
        2637,
        2635,
        2626,
        2625,
        2623,
        2628,
        1820,
        2752,
        2739,
        2737,
        2728,
        2727,
        2725,
        2730,
        2785,
        2783,
        2778,
        2777,
        2775,
        2780,
        787,
        781,
        747,
        739,
        736,
        2413,
        754,
        752,
        1719,
        692,
        689,
        681,
        2371,
        678,
        2369,
        700,
        697,
        694,
        703,
        1688,
        1686,
        642,
        638,
        2343,
        631,
        2341,
        627,
        2338,
        651,
        646,
        643,
        2345,
        654,
        652,
        1652,
        1650,
        1647,
        1654,
        601,
        599,
        2322,
        596,
        2321,
        594,
        2319,
        2317,
        611,
        610,
        608,
        606,
        2324,
        603,
        2323,
        615,
        614,
        612,
        1617,
        1616,
        1614,
        1612,
        616,
        1619,
        1618,
        2575,
        2538,
        2536,
        905,
        901,
        898,
        909,
        2509,
        2507,
        2504,
        870,
        867,
        864,
        860,
        2512,
        875,
        872,
        1781,
        2490,
        2489,
        2487,
        2485,
        1748,
        836,
        834,
        832,
        830,
        2494,
        827,
        2492,
        843,
        841,
        839,
        845,
        1765,
        1763,
        2701,
        2676,
        2674,
        2653,
        2648,
        2656,
        2634,
        2633,
        2631,
        2629,
        1821,
        2638,
        2636,
        2770,
        2763,
        2761,
        2750,
        2745,
        2753,
        2736,
        2735,
        2733,
        2731,
        1848,
        2740,
        2738,
        2786,
        2784,
        591,
        588,
        576,
        569,
        566,
        2296,
        1590,
        537,
        534,
        526,
        2276,
        522,
        2274,
        545,
        542,
        539,
        548,
        1572,
        1570,
        481,
        2245,
        466,
        2242,
        462,
        2239,
        492,
        485,
        482,
        2249,
        496,
        494,
        1534,
        1531,
        1528,
        1538,
        413,
        2196,
        406,
        2191,
        2188,
        425,
        419,
        2202,
        415,
        2199,
        432,
        430,
        427,
        1472,
        1467,
        1464,
        433,
        1476,
        1474,
        368,
        367,
        2160,
        365,
        2159,
        362,
        2157,
        2155,
        2152,
        378,
        377,
        375,
        2166,
        372,
        2165,
        369,
        2162,
        383,
        381,
        379,
        2168,
        1419,
        1418,
        1416,
        1414,
        385,
        1411,
        384,
        1423,
        1422,
        1420,
        1424,
        2461,
        802,
        2441,
        2439,
        790,
        786,
        783,
        794,
        2409,
        2406,
        2403,
        750,
        742,
        738,
        2414,
        756,
        753,
        1720,
        2367,
        2365,
        2362,
        2359,
        1663,
        693,
        691,
        684,
        2373,
        680,
        2370,
        702,
        699,
        696,
        704,
        1690,
        1687,
        2337,
        2336,
        2334,
        2332,
        1624,
        2329,
        1622,
        640,
        637,
        2344,
        634,
        2342,
        630,
        2340,
        650,
        648,
        645,
        2346,
        655,
        653,
        1653,
        1651,
        1649,
        1655,
        2612,
        2597,
        2595,
        2571,
        2568,
        2565,
        2576,
        2534,
        2529,
        2526,
        1787,
        2540,
        2537,
        907,
        904,
        900,
        910,
        2503,
        2502,
        2500,
        2498,
        1768,
        2495,
        1767,
        2510,
        2508,
        2506,
        869,
        866,
        863,
        2513,
        876,
        874,
        1782,
        2720,
        2713,
        2711,
        2697,
        2694,
        2691,
        2702,
        2672,
        2670,
        2664,
        1828,
        2678,
        2675,
        2647,
        2646,
        2644,
        2642,
        1823,
        2639,
        1822,
        2654,
        2652,
        2650,
        2657,
        2771,
        1855,
        2765,
        2762,
        1850,
        1849,
        2751,
        2749,
        2747,
        2754,
        353,
        2148,
        344,
        342,
        336,
        2142,
        332,
        2140,
        345,
        1375,
        1373,
        306,
        2130,
        299,
        2128,
        295,
        2125,
        319,
        314,
        311,
        2132,
        1354,
        1352,
        1349,
        1356,
        262,
        257,
        2101,
        253,
        2096,
        2093,
        274,
        273,
        267,
        2107,
        263,
        2104,
        280,
        278,
        275,
        1316,
        1311,
        1308,
        1320,
        1318,
        2052,
        202,
        2050,
        2044,
        2040,
        219,
        2063,
        212,
        2060,
        208,
        2055,
        224,
        221,
        2066,
        1260,
        1258,
        1252,
        231,
        1248,
        229,
        1266,
        1264,
        1261,
        1268,
        155,
        1998,
        153,
        1996,
        1994,
        1991,
        1988,
        165,
        164,
        2007,
        162,
        2006,
        159,
        2003,
        2000,
        172,
        171,
        169,
        2012,
        166,
        2010,
        1186,
        1184,
        1182,
        1179,
        175,
        1176,
        173,
        1192,
        1191,
        1189,
        1187,
        176,
        1194,
        1193,
        2313,
        2307,
        2305,
        592,
        589,
        2294,
        2292,
        2289,
        578,
        572,
        568,
        2297,
        580,
        1591,
        2272,
        2267,
        2264,
        1547,
        538,
        536,
        529,
        2278,
        525,
        2275,
        547,
        544,
        541,
        1574,
        1571,
        2237,
        2235,
        2229,
        1493,
        2225,
        1489,
        478,
        2247,
        470,
        2244,
        465,
        2241,
        493,
        488,
        484,
        2250,
        498,
        495,
        1536,
        1533,
        1530,
        1539,
        2187,
        2186,
        2184,
        2182,
        1432,
        2179,
        1430,
        2176,
        1427,
        414,
        412,
        2197,
        409,
        2195,
        405,
        2193,
        2190,
        426,
        424,
        421,
        2203,
        418,
        2201,
        431,
        429,
        1473,
        1471,
        1469,
        1466,
        434,
        1477,
        1475,
        2478,
        2472,
        2470,
        2459,
        2457,
        2454,
        2462,
        803,
        2437,
        2432,
        2429,
        1726,
        2443,
        2440,
        792,
        789,
        785,
        2401,
        2399,
        2393,
        1702,
        2389,
        1699,
        2411,
        2408,
        2405,
        745,
        741,
        2415,
        758,
        755,
        1721,
        2358,
        2357,
        2355,
        2353,
        1661,
        2350,
        1660,
        2347,
        1657,
        2368,
        2366,
        2364,
        2361,
        1666,
        690,
        687,
        2374,
        683,
        2372,
        701,
        698,
        705,
        1691,
        1689,
        2619,
        2617,
        2610,
        2608,
        2605,
        2613,
        2593,
        2588,
        2585,
        1803,
        2599,
        2596,
        2563,
        2561,
        2555,
        1797,
        2551,
        1795,
        2573,
        2570,
        2567,
        2577,
        2525,
        2524,
        2522,
        2520,
        1786,
        2517,
        1785,
        2514,
        1783,
        2535,
        2533,
        2531,
        2528,
        1788,
        2541,
        2539,
        906,
        903,
        911,
        2721,
        1844,
        2715,
        2712,
        1838,
        1836,
        2699,
        2696,
        2693,
        2703,
        1827,
        1826,
        1824,
        2673,
        2671,
        2669,
        2666,
        1829,
        2679,
        2677,
        1858,
        1857,
        2772,
        1854,
        1853,
        1851,
        1856,
        2766,
        2764,
        143,
        1987,
        139,
        1986,
        135,
        133,
        131,
        1984,
        128,
        1983,
        125,
        1981,
        138,
        137,
        136,
        1985,
        1133,
        1132,
        1130,
        112,
        110,
        1974,
        107,
        1973,
        104,
        1971,
        1969,
        122,
        121,
        119,
        117,
        1977,
        114,
        1976,
        124,
        1115,
        1114,
        1112,
        1110,
        1117,
        1116,
        84,
        83,
        1953,
        81,
        1952,
        78,
        1950,
        1948,
        1945,
        94,
        93,
        91,
        1959,
        88,
        1958,
        85,
        1955,
        99,
        97,
        95,
        1961,
        1086,
        1085,
        1083,
        1081,
        1078,
        100,
        1090,
        1089,
        1087,
        1091,
        49,
        47,
        1917,
        44,
        1915,
        1913,
        1910,
        1907,
        59,
        1926,
        56,
        1925,
        53,
        1922,
        1919,
        66,
        64,
        1931,
        61,
        1929,
        1042,
        1040,
        1038,
        71,
        1035,
        70,
        1032,
        68,
        1048,
        1047,
        1045,
        1043,
        1050,
        1049,
        12,
        10,
        1869,
        1867,
        1864,
        1861,
        21,
        1880,
        19,
        1877,
        1874,
        1871,
        28,
        1888,
        25,
        1886,
        22,
        1883,
        982,
        980,
        977,
        974,
        32,
        30,
        991,
        989,
        987,
        984,
        34,
        995,
        994,
        992,
        2151,
        2150,
        2147,
        2146,
        2144,
        356,
        355,
        354,
        2149,
        2139,
        2138,
        2136,
        2134,
        1359,
        343,
        341,
        338,
        2143,
        335,
        2141,
        348,
        347,
        346,
        1376,
        1374,
        2124,
        2123,
        2121,
        2119,
        1326,
        2116,
        1324,
        310,
        308,
        305,
        2131,
        302,
        2129,
        298,
        2127,
        320,
        318,
        316,
        313,
        2133,
        322,
        321,
        1355,
        1353,
        1351,
        1357,
        2092,
        2091,
        2089,
        2087,
        1276,
        2084,
        1274,
        2081,
        1271,
        259,
        2102,
        256,
        2100,
        252,
        2098,
        2095,
        272,
        269,
        2108,
        266,
        2106,
        281,
        279,
        277,
        1317,
        1315,
        1313,
        1310,
        282,
        1321,
        1319,
        2039,
        2037,
        2035,
        2032,
        1203,
        2029,
        1200,
        1197,
        207,
        2053,
        205,
        2051,
        201,
        2049,
        2046,
        2043,
        220,
        218,
        2064,
        215,
        2062,
        211,
        2059,
        228,
        226,
        223,
        2069,
        1259,
        1257,
        1254,
        232,
        1251,
        230,
        1267,
        1265,
        1263,
        2316,
        2315,
        2312,
        2311,
        2309,
        2314,
        2304,
        2303,
        2301,
        2299,
        1593,
        2308,
        2306,
        590,
        2288,
        2287,
        2285,
        2283,
        1578,
        2280,
        1577,
        2295,
        2293,
        2291,
        579,
        577,
        574,
        571,
        2298,
        582,
        581,
        1592,
        2263,
        2262,
        2260,
        2258,
        1545,
        2255,
        1544,
        2252,
        1541,
        2273,
        2271,
        2269,
        2266,
        1550,
        535,
        532,
        2279,
        528,
        2277,
        546,
        543,
        549,
        1575,
        1573,
        2224,
        2222,
        2220,
        1486,
        2217,
        1485,
        2214,
        1482,
        1479,
        2238,
        2236,
        2234,
        2231,
        1496,
        2228,
        1492,
        480,
        477,
        2248,
        473,
        2246,
        469,
        2243,
        490,
        487,
        2251,
        497,
        1537,
        1535,
        1532,
        2477,
        2476,
        2474,
        2479,
        2469,
        2468,
        2466,
        2464,
        1730,
        2473,
        2471,
        2453,
        2452,
        2450,
        2448,
        1729,
        2445,
        1728,
        2460,
        2458,
        2456,
        2463,
        805,
        804,
        2428,
        2427,
        2425,
        2423,
        1725,
        2420,
        1724,
        2417,
        1722,
        2438,
        2436,
        2434,
        2431,
        1727,
        2444,
        2442,
        793,
        791,
        788,
        795,
        2388,
        2386,
        2384,
        1697,
        2381,
        1696,
        2378,
        1694,
        1692,
        2402,
        2400,
        2398,
        2395,
        1703,
        2392,
        1701,
        2412,
        2410,
        2407,
        751,
        748,
        744,
        2416,
        759,
        757,
        1807,
        2620,
        2618,
        1806,
        1805,
        2611,
        2609,
        2607,
        2614,
        1802,
        1801,
        1799,
        2594,
        2592,
        2590,
        2587,
        1804,
        2600,
        2598,
        1794,
        1793,
        1791,
        1789,
        2564,
        2562,
        2560,
        2557,
        1798,
        2554,
        1796,
        2574,
        2572,
        2569,
        2578,
        1847,
        1846,
        2722,
        1843,
        1842,
        1840,
        1845,
        2716,
        2714,
        1835,
        1834,
        1832,
        1830,
        1839,
        1837,
        2700,
        2698,
        2695,
        2704,
        1817,
        1811,
        1810,
        897,
        862,
        1777,
        829,
        826,
        838,
        1760,
        1758,
        808,
        2481,
        1741,
        1740,
        1738,
        1743,
        2624,
        1818,
        2726,
        2776,
        782,
        740,
        737,
        1715,
        686,
        679,
        695,
        1682,
        1680,
        639,
        628,
        2339,
        647,
        644,
        1645,
        1643,
        1640,
        1648,
        602,
        600,
        597,
        595,
        2320,
        593,
        2318,
        609,
        607,
        604,
        1611,
        1610,
        1608,
        1606,
        613,
        1615,
        1613,
        2328,
        926,
        924,
        892,
        886,
        899,
        857,
        850,
        2505,
        1778,
        824,
        823,
        821,
        819,
        2488,
        818,
        2486,
        833,
        831,
        828,
        840,
        1761,
        1759,
        2649,
        2632,
        2630,
        2746,
        2734,
        2732,
        2782,
        2781,
        570,
        567,
        1587,
        531,
        527,
        523,
        540,
        1566,
        1564,
        476,
        467,
        463,
        2240,
        486,
        483,
        1524,
        1521,
        1518,
        1529,
        411,
        403,
        2192,
        399,
        2189,
        423,
        416,
        1462,
        1457,
        1454,
        428,
        1468,
        1465,
        2210,
        366,
        363,
        2158,
        360,
        2156,
        357,
        2153,
        376,
        373,
        370,
        2163,
        1410,
        1409,
        1407,
        1405,
        382,
        1402,
        380,
        1417,
        1415,
        1412,
        1421,
        2175,
        2174,
        777,
        774,
        771,
        784,
        732,
        725,
        722,
        2404,
        743,
        1716,
        676,
        674,
        668,
        2363,
        665,
        2360,
        685,
        1684,
        1681,
        626,
        624,
        622,
        2335,
        620,
        2333,
        617,
        2330,
        641,
        635,
        649,
        1646,
        1644,
        1642,
        2566,
        928,
        925,
        2530,
        2527,
        894,
        891,
        888,
        2501,
        2499,
        2496,
        858,
        856,
        854,
        851,
        1779,
        2692,
        2668,
        2665,
        2645,
        2643,
        2640,
        2651,
        2768,
        2759,
        2757,
        2744,
        2743,
        2741,
        2748,
        352,
        1382,
        340,
        337,
        333,
        1371,
        1369,
        307,
        300,
        296,
        2126,
        315,
        312,
        1347,
        1342,
        1350,
        261,
        258,
        250,
        2097,
        246,
        2094,
        271,
        268,
        264,
        1306,
        1301,
        1298,
        276,
        1312,
        1309,
        2115,
        203,
        2048,
        195,
        2045,
        191,
        2041,
        213,
        209,
        2056,
        1246,
        1244,
        1238,
        225,
        1234,
        222,
        1256,
        1253,
        1249,
        1262,
        2080,
        2079,
        154,
        1997,
        150,
        1995,
        147,
        1992,
        1989,
        163,
        160,
        2004,
        156,
        2001,
        1175,
        1174,
        1172,
        1170,
        1167,
        170,
        1164,
        167,
        1185,
        1183,
        1180,
        1177,
        174,
        1190,
        1188,
        2025,
        2024,
        2022,
        587,
        586,
        564,
        559,
        556,
        2290,
        573,
        1588,
        520,
        518,
        512,
        2268,
        508,
        2265,
        530,
        1568,
        1565,
        461,
        457,
        2233,
        450,
        2230,
        446,
        2226,
        479,
        471,
        489,
        1526,
        1523,
        1520,
        397,
        395,
        2185,
        392,
        2183,
        389,
        2180,
        2177,
        410,
        2194,
        402,
        422,
        1463,
        1461,
        1459,
        1456,
        1470,
        2455,
        799,
        2433,
        2430,
        779,
        776,
        773,
        2397,
        2394,
        2390,
        734,
        728,
        724,
        746,
        1717,
        2356,
        2354,
        2351,
        2348,
        1658,
        677,
        675,
        673,
        670,
        667,
        688,
        1685,
        1683,
        2606,
        2589,
        2586,
        2559,
        2556,
        2552,
        927,
        2523,
        2521,
        2518,
        2515,
        1784,
        2532,
        895,
        893,
        890,
        2718,
        2709,
        2707,
        2689,
        2687,
        2684,
        2663,
        2662,
        2660,
        2658,
        1825,
        2667,
        2769,
        1852,
        2760,
        2758,
        142,
        141,
        1139,
        1138,
        134,
        132,
        129,
        126,
        1982,
        1129,
        1128,
        1126,
        1131,
        113,
        111,
        108,
        105,
        1972,
        101,
        1970,
        120,
        118,
        115,
        1109,
        1108,
        1106,
        1104,
        123,
        1113,
        1111,
        82,
        79,
        1951,
        75,
        1949,
        72,
        1946,
        92,
        89,
        86,
        1956,
        1077,
        1076,
        1074,
        1072,
        98,
        1069,
        96,
        1084,
        1082,
        1079,
        1088,
        1968,
        1967,
        48,
        45,
        1916,
        42,
        1914,
        39,
        1911,
        1908,
        60,
        57,
        54,
        1923,
        50,
        1920,
        1031,
        1030,
        1028,
        1026,
        67,
        1023,
        65,
        1020,
        62,
        1041,
        1039,
        1036,
        1033,
        69,
        1046,
        1044,
        1944,
        1943,
        1941,
        11,
        9,
        1868,
        7,
        1865,
        1862,
        1859,
        20,
        1878,
        16,
        1875,
        13,
        1872,
        970,
        968,
        966,
        963,
        29,
        960,
        26,
        23,
        983,
        981,
        978,
        975,
        33,
        971,
        31,
        990,
        988,
        985,
        1906,
        1904,
        1902,
        993,
        351,
        2145,
        1383,
        331,
        330,
        328,
        326,
        2137,
        323,
        2135,
        339,
        1372,
        1370,
        294,
        293,
        291,
        289,
        2122,
        286,
        2120,
        283,
        2117,
        309,
        303,
        317,
        1348,
        1346,
        1344,
        245,
        244,
        242,
        2090,
        239,
        2088,
        236,
        2085,
        2082,
        260,
        2099,
        249,
        270,
        1307,
        1305,
        1303,
        1300,
        1314,
        189,
        2038,
        186,
        2036,
        183,
        2033,
        2030,
        2026,
        206,
        198,
        2047,
        194,
        216,
        1247,
        1245,
        1243,
        1240,
        227,
        1237,
        1255,
        2310,
        2302,
        2300,
        2286,
        2284,
        2281,
        565,
        563,
        561,
        558,
        575,
        1589,
        2261,
        2259,
        2256,
        2253,
        1542,
        521,
        519,
        517,
        514,
        2270,
        511,
        533,
        1569,
        1567,
        2223,
        2221,
        2218,
        2215,
        1483,
        2211,
        1480,
        459,
        456,
        453,
        2232,
        449,
        474,
        491,
        1527,
        1525,
        1522,
        2475,
        2467,
        2465,
        2451,
        2449,
        2446,
        801,
        800,
        2426,
        2424,
        2421,
        2418,
        1723,
        2435,
        780,
        778,
        775,
        2387,
        2385,
        2382,
        2379,
        1695,
        2375,
        1693,
        2396,
        735,
        733,
        730,
        727,
        749,
        1718,
        2616,
        2615,
        2604,
        2603,
        2601,
        2584,
        2583,
        2581,
        2579,
        1800,
        2591,
        2550,
        2549,
        2547,
        2545,
        1792,
        2542,
        1790,
        2558,
        929,
        2719,
        1841,
        2710,
        2708,
        1833,
        1831,
        2690,
        2688,
        2686,
        1815,
        1809,
        1808,
        1774,
        1756,
        1754,
        1737,
        1736,
        1734,
        1739,
        1816,
        1711,
        1676,
        1674,
        633,
        629,
        1638,
        1636,
        1633,
        1641,
        598,
        1605,
        1604,
        1602,
        1600,
        605,
        1609,
        1607,
        2327,
        887,
        853,
        1775,
        822,
        820,
        1757,
        1755,
        1584,
        524,
        1560,
        1558,
        468,
        464,
        1514,
        1511,
        1508,
        1519,
        408,
        404,
        400,
        1452,
        1447,
        1444,
        417,
        1458,
        1455,
        2208,
        364,
        361,
        358,
        2154,
        1401,
        1400,
        1398,
        1396,
        374,
        1393,
        371,
        1408,
        1406,
        1403,
        1413,
        2173,
        2172,
        772,
        726,
        723,
        1712,
        672,
        669,
        666,
        682,
        1678,
        1675,
        625,
        623,
        621,
        618,
        2331,
        636,
        632,
        1639,
        1637,
        1635,
        920,
        918,
        884,
        880,
        889,
        849,
        848,
        847,
        846,
        2497,
        855,
        852,
        1776,
        2641,
        2742,
        2787,
        1380,
        334,
        1367,
        1365,
        301,
        297,
        1340,
        1338,
        1335,
        1343,
        255,
        251,
        247,
        1296,
        1291,
        1288,
        265,
        1302,
        1299,
        2113,
        204,
        196,
        192,
        2042,
        1232,
        1230,
        1224,
        214,
        1220,
        210,
        1242,
        1239,
        1235,
        1250,
        2077,
        2075,
        151,
        148,
        1993,
        144,
        1990,
        1163,
        1162,
        1160,
        1158,
        1155,
        161,
        1152,
        157,
        1173,
        1171,
        1168,
        1165,
        168,
        1181,
        1178,
        2021,
        2020,
        2018,
        2023,
        585,
        560,
        557,
        1585,
        516,
        509,
        1562,
        1559,
        458,
        447,
        2227,
        472,
        1516,
        1513,
        1510,
        398,
        396,
        393,
        390,
        2181,
        386,
        2178,
        407,
        1453,
        1451,
        1449,
        1446,
        420,
        1460,
        2209,
        769,
        764,
        720,
        712,
        2391,
        729,
        1713,
        664,
        663,
        661,
        659,
        2352,
        656,
        2349,
        671,
        1679,
        1677,
        2553,
        922,
        919,
        2519,
        2516,
        885,
        883,
        881,
        2685,
        2661,
        2659,
        2767,
        2756,
        2755,
        140,
        1137,
        1136,
        130,
        127,
        1125,
        1124,
        1122,
        1127,
        109,
        106,
        102,
        1103,
        1102,
        1100,
        1098,
        116,
        1107,
        1105,
        1980,
        80,
        76,
        73,
        1947,
        1068,
        1067,
        1065,
        1063,
        90,
        1060,
        87,
        1075,
        1073,
        1070,
        1080,
        1966,
        1965,
        46,
        43,
        40,
        1912,
        36,
        1909,
        1019,
        1018,
        1016,
        1014,
        58,
        1011,
        55,
        1008,
        51,
        1029,
        1027,
        1024,
        1021,
        63,
        1037,
        1034,
        1940,
        1939,
        1937,
        1942,
        8,
        1866,
        4,
        1863,
        1,
        1860,
        956,
        954,
        952,
        949,
        946,
        17,
        14,
        969,
        967,
        964,
        961,
        27,
        957,
        24,
        979,
        976,
        972,
        1901,
        1900,
        1898,
        1896,
        986,
        1905,
        1903,
        350,
        349,
        1381,
        329,
        327,
        324,
        1368,
        1366,
        292,
        290,
        287,
        284,
        2118,
        304,
        1341,
        1339,
        1337,
        1345,
        243,
        240,
        237,
        2086,
        233,
        2083,
        254,
        1297,
        1295,
        1293,
        1290,
        1304,
        2114,
        190,
        187,
        184,
        2034,
        180,
        2031,
        177,
        2027,
        199,
        1233,
        1231,
        1229,
        1226,
        217,
        1223,
        1241,
        2078,
        2076,
        584,
        555,
        554,
        552,
        550,
        2282,
        562,
        1586,
        507,
        506,
        504,
        502,
        2257,
        499,
        2254,
        515,
        1563,
        1561,
        445,
        443,
        441,
        2219,
        438,
        2216,
        435,
        2212,
        460,
        454,
        475,
        1517,
        1515,
        1512,
        2447,
        798,
        797,
        2422,
        2419,
        770,
        768,
        766,
        2383,
        2380,
        2376,
        721,
        719,
        717,
        714,
        731,
        1714,
        2602,
        2582,
        2580,
        2548,
        2546,
        2543,
        923,
        921,
        2717,
        2706,
        2705,
        2683,
        2682,
        2680,
        1771,
        1752,
        1750,
        1733,
        1732,
        1731,
        1735,
        1814,
        1707,
        1670,
        1668,
        1631,
        1629,
        1626,
        1634,
        1599,
        1598,
        1596,
        1594,
        1603,
        1601,
        2326,
        1772,
        1753,
        1751,
        1581,
        1554,
        1552,
        1504,
        1501,
        1498,
        1509,
        1442,
        1437,
        1434,
        401,
        1448,
        1445,
        2206,
        1392,
        1391,
        1389,
        1387,
        1384,
        359,
        1399,
        1397,
        1394,
        1404,
        2171,
        2170,
        1708,
        1672,
        1669,
        619,
        1632,
        1630,
        1628,
        1773,
        1378,
        1363,
        1361,
        1333,
        1328,
        1336,
        1286,
        1281,
        1278,
        248,
        1292,
        1289,
        2111,
        1218,
        1216,
        1210,
        197,
        1206,
        193,
        1228,
        1225,
        1221,
        1236,
        2073,
        2071,
        1151,
        1150,
        1148,
        1146,
        152,
        1143,
        149,
        1140,
        145,
        1161,
        1159,
        1156,
        1153,
        158,
        1169,
        1166,
        2017,
        2016,
        2014,
        2019,
        1582,
        510,
        1556,
        1553,
        452,
        448,
        1506,
        1500,
        394,
        391,
        387,
        1443,
        1441,
        1439,
        1436,
        1450,
        2207,
        765,
        716,
        713,
        1709,
        662,
        660,
        657,
        1673,
        1671,
        916,
        914,
        879,
        878,
        877,
        882,
        1135,
        1134,
        1121,
        1120,
        1118,
        1123,
        1097,
        1096,
        1094,
        1092,
        103,
        1101,
        1099,
        1979,
        1059,
        1058,
        1056,
        1054,
        77,
        1051,
        74,
        1066,
        1064,
        1061,
        1071,
        1964,
        1963,
        1007,
        1006,
        1004,
        1002,
        999,
        41,
        996,
        37,
        1017,
        1015,
        1012,
        1009,
        52,
        1025,
        1022,
        1936,
        1935,
        1933,
        1938,
        942,
        940,
        938,
        935,
        932,
        5,
        2,
        955,
        953,
        950,
        947,
        18,
        943,
        15,
        965,
        962,
        958,
        1895,
        1894,
        1892,
        1890,
        973,
        1899,
        1897,
        1379,
        325,
        1364,
        1362,
        288,
        285,
        1334,
        1332,
        1330,
        241,
        238,
        234,
        1287,
        1285,
        1283,
        1280,
        1294,
        2112,
        188,
        185,
        181,
        178,
        2028,
        1219,
        1217,
        1215,
        1212,
        200,
        1209,
        1227,
        2074,
        2072,
        583,
        553,
        551,
        1583,
        505,
        503,
        500,
        513,
        1557,
        1555,
        444,
        442,
        439,
        436,
        2213,
        455,
        451,
        1507,
        1505,
        1502,
        796,
        763,
        762,
        760,
        767,
        711,
        710,
        708,
        706,
        2377,
        718,
        715,
        1710,
        2544,
        917,
        915,
        2681,
        1627,
        1597,
        1595,
        2325,
        1769,
        1749,
        1747,
        1499,
        1438,
        1435,
        2204,
        1390,
        1388,
        1385,
        1395,
        2169,
        2167,
        1704,
        1665,
        1662,
        1625,
        1623,
        1620,
        1770,
        1329,
        1282,
        1279,
        2109,
        1214,
        1207,
        1222,
        2068,
        2065,
        1149,
        1147,
        1144,
        1141,
        146,
        1157,
        1154,
        2013,
        2011,
        2008,
        2015,
        1579,
        1549,
        1546,
        1495,
        1487,
        1433,
        1431,
        1428,
        1425,
        388,
        1440,
        2205,
        1705,
        658,
        1667,
        1664,
        1119,
        1095,
        1093,
        1978,
        1057,
        1055,
        1052,
        1062,
        1962,
        1960,
        1005,
        1003,
        1000,
        997,
        38,
        1013,
        1010,
        1932,
        1930,
        1927,
        1934,
        941,
        939,
        936,
        933,
        6,
        930,
        3,
        951,
        948,
        944,
        1889,
        1887,
        1884,
        1881,
        959,
        1893,
        1891,
        35,
        1377,
        1360,
        1358,
        1327,
        1325,
        1322,
        1331,
        1277,
        1275,
        1272,
        1269,
        235,
        1284,
        2110,
        1205,
        1204,
        1201,
        1198,
        182,
        1195,
        179,
        1213,
        2070,
        2067,
        1580,
        501,
        1551,
        1548,
        440,
        437,
        1497,
        1494,
        1490,
        1503,
        761,
        709,
        707,
        1706,
        913,
        912,
        2198,
        1386,
        2164,
        2161,
        1621,
        1766,
        2103,
        1208,
        2058,
        2054,
        1145,
        1142,
        2005,
        2002,
        1999,
        2009,
        1488,
        1429,
        1426,
        2200,
        1698,
        1659,
        1656,
        1975,
        1053,
        1957,
        1954,
        1001,
        998,
        1924,
        1921,
        1918,
        1928,
        937,
        934,
        931,
        1879,
        1876,
        1873,
        1870,
        945,
        1885,
        1882,
        1323,
        1273,
        1270,
        2105,
        1202,
        1199,
        1196,
        1211,
        2061,
        2057,
        1576,
        1543,
        1540,
        1484,
        1481,
        1478,
        1491,
        1700
    ]);
    /*
    * Copyright 2007 ZXing authors
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    *      http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    */ // import java.util.List;
    /**
     * @author Guenther Grau
     */ /*public final*/ class PDF417DetectorResult {
        constructor(bits, points){
            this.bits = bits;
            this.points = points;
        }
        getBits() {
            return this.bits;
        }
        getPoints() {
            return this.points;
        }
    }
    /*
    * Copyright 2009 ZXing authors
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    *      http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    */ // import java.util.ArrayList;
    // import java.util.Arrays;
    // import java.util.List;
    // import java.util.Map;
    /**
     * <p>Encapsulates logic that can detect a PDF417 Code in an image, even if the
     * PDF417 Code is rotated or skewed, or partially obscured.</p>
     *
     * @author SITA Lab (kevin.osullivan@sita.aero)
     * @author dswitkin@google.com (Daniel Switkin)
     * @author Guenther Grau
     */ /*public*/ /*final*/ class Detector$3 {
        /**
         * <p>Detects a PDF417 Code in an image. Only checks 0 and 180 degree rotations.</p>
         *
         * @param image barcode image to decode
         * @param hints optional hints to detector
         * @param multiple if true, then the image is searched for multiple codes. If false, then at most one code will
         * be found and returned
         * @return {@link PDF417DetectorResult} encapsulating results of detecting a PDF417 code
         * @throws NotFoundException if no PDF417 Code can be found
         */ static detectMultiple(image, hints, multiple) {
            // TODO detection improvement, tryHarder could try several different luminance thresholds/blackpoints or even
            // different binarizers
            // boolean tryHarder = hints != null && hints.containsKey(DecodeHintType.TRY_HARDER);
            let bitMatrix = image.getBlackMatrix();
            let barcodeCoordinates = Detector$3.detect(multiple, bitMatrix);
            if (!barcodeCoordinates.length) {
                bitMatrix = bitMatrix.clone();
                bitMatrix.rotate180();
                barcodeCoordinates = Detector$3.detect(multiple, bitMatrix);
            }
            return new PDF417DetectorResult(bitMatrix, barcodeCoordinates);
        }
        /**
         * Detects PDF417 codes in an image. Only checks 0 degree rotation
         * @param multiple if true, then the image is searched for multiple codes. If false, then at most one code will
         * be found and returned
         * @param bitMatrix bit matrix to detect barcodes in
         * @return List of ResultPoint arrays containing the coordinates of found barcodes
         */ static detect(multiple, bitMatrix) {
            const barcodeCoordinates = new Array();
            let row = 0;
            let column = 0;
            let foundBarcodeInRow = false;
            while(row < bitMatrix.getHeight()){
                const vertices = Detector$3.findVertices(bitMatrix, row, column);
                if (vertices[0] == null && vertices[3] == null) {
                    if (!foundBarcodeInRow) break;
                    // we didn't find a barcode starting at the given column and row. Try again from the first column and slightly
                    // below the lowest barcode we found so far.
                    foundBarcodeInRow = false;
                    column = 0;
                    for (const barcodeCoordinate of barcodeCoordinates){
                        if (barcodeCoordinate[1] != null) row = Math.trunc(Math.max(row, barcodeCoordinate[1].getY()));
                        if (barcodeCoordinate[3] != null) row = Math.max(row, Math.trunc(barcodeCoordinate[3].getY()));
                    }
                    row += Detector$3.ROW_STEP;
                    continue;
                }
                foundBarcodeInRow = true;
                barcodeCoordinates.push(vertices);
                if (!multiple) break;
                // if we didn't find a right row indicator column, then continue the search for the next barcode after the
                // start pattern of the barcode just found.
                if (vertices[2] != null) {
                    column = Math.trunc(vertices[2].getX());
                    row = Math.trunc(vertices[2].getY());
                } else {
                    column = Math.trunc(vertices[4].getX());
                    row = Math.trunc(vertices[4].getY());
                }
            }
            return barcodeCoordinates;
        }
        /**
         * Locate the vertices and the codewords area of a black blob using the Start
         * and Stop patterns as locators.
         *
         * @param matrix the scanned barcode image.
         * @return an array containing the vertices:
         *           vertices[0] x, y top left barcode
         *           vertices[1] x, y bottom left barcode
         *           vertices[2] x, y top right barcode
         *           vertices[3] x, y bottom right barcode
         *           vertices[4] x, y top left codeword area
         *           vertices[5] x, y bottom left codeword area
         *           vertices[6] x, y top right codeword area
         *           vertices[7] x, y bottom right codeword area
         */ static findVertices(matrix, startRow, startColumn) {
            const height = matrix.getHeight();
            const width = matrix.getWidth();
            // const result = new ResultPoint[8];
            const result = new Array(8);
            Detector$3.copyToResult(result, Detector$3.findRowsWithPattern(matrix, height, width, startRow, startColumn, Detector$3.START_PATTERN), Detector$3.INDEXES_START_PATTERN);
            if (result[4] != null) {
                startColumn = Math.trunc(result[4].getX());
                startRow = Math.trunc(result[4].getY());
            }
            Detector$3.copyToResult(result, Detector$3.findRowsWithPattern(matrix, height, width, startRow, startColumn, Detector$3.STOP_PATTERN), Detector$3.INDEXES_STOP_PATTERN);
            return result;
        }
        static copyToResult(result, tmpResult, destinationIndexes) {
            for(let i = 0; i < destinationIndexes.length; i++)result[destinationIndexes[i]] = tmpResult[i];
        }
        static findRowsWithPattern(matrix, height, width, startRow, startColumn, pattern) {
            // const result = new ResultPoint[4];
            const result = new Array(4);
            let found = false;
            const counters = new Int32Array(pattern.length);
            for(; startRow < height; startRow += Detector$3.ROW_STEP){
                let loc = Detector$3.findGuardPattern(matrix, startColumn, startRow, width, false, pattern, counters);
                if (loc != null) {
                    while(startRow > 0){
                        const previousRowLoc = Detector$3.findGuardPattern(matrix, startColumn, --startRow, width, false, pattern, counters);
                        if (previousRowLoc != null) loc = previousRowLoc;
                        else {
                            startRow++;
                            break;
                        }
                    }
                    result[0] = new ResultPoint(loc[0], startRow);
                    result[1] = new ResultPoint(loc[1], startRow);
                    found = true;
                    break;
                }
            }
            let stopRow = startRow + 1;
            // Last row of the current symbol that contains pattern
            if (found) {
                let skippedRowCount = 0;
                let previousRowLoc = Int32Array.from([
                    Math.trunc(result[0].getX()),
                    Math.trunc(result[1].getX())
                ]);
                for(; stopRow < height; stopRow++){
                    const loc = Detector$3.findGuardPattern(matrix, previousRowLoc[0], stopRow, width, false, pattern, counters);
                    // a found pattern is only considered to belong to the same barcode if the start and end positions
                    // don't differ too much. Pattern drift should be not bigger than two for consecutive rows. With
                    // a higher number of skipped rows drift could be larger. To keep it simple for now, we allow a slightly
                    // larger drift and don't check for skipped rows.
                    if (loc != null && Math.abs(previousRowLoc[0] - loc[0]) < Detector$3.MAX_PATTERN_DRIFT && Math.abs(previousRowLoc[1] - loc[1]) < Detector$3.MAX_PATTERN_DRIFT) {
                        previousRowLoc = loc;
                        skippedRowCount = 0;
                    } else {
                        if (skippedRowCount > Detector$3.SKIPPED_ROW_COUNT_MAX) break;
                        else skippedRowCount++;
                    }
                }
                stopRow -= skippedRowCount + 1;
                result[2] = new ResultPoint(previousRowLoc[0], stopRow);
                result[3] = new ResultPoint(previousRowLoc[1], stopRow);
            }
            if (stopRow - startRow < Detector$3.BARCODE_MIN_HEIGHT) Arrays.fill(result, null);
            return result;
        }
        /**
         * @param matrix row of black/white values to search
         * @param column x position to start search
         * @param row y position to start search
         * @param width the number of pixels to search on this row
         * @param pattern pattern of counts of number of black and white pixels that are
         *                 being searched for as a pattern
         * @param counters array of counters, as long as pattern, to re-use
         * @return start/end horizontal offset of guard pattern, as an array of two ints.
         */ static findGuardPattern(matrix, column, row, width, whiteFirst, pattern, counters) {
            Arrays.fillWithin(counters, 0, counters.length, 0);
            let patternStart = column;
            let pixelDrift = 0;
            // if there are black pixels left of the current pixel shift to the left, but only for MAX_PIXEL_DRIFT pixels
            while(matrix.get(patternStart, row) && patternStart > 0 && pixelDrift++ < Detector$3.MAX_PIXEL_DRIFT)patternStart--;
            let x = patternStart;
            let counterPosition = 0;
            let patternLength = pattern.length;
            for(let isWhite = whiteFirst; x < width; x++){
                let pixel = matrix.get(x, row);
                if (pixel !== isWhite) counters[counterPosition]++;
                else {
                    if (counterPosition === patternLength - 1) {
                        if (Detector$3.patternMatchVariance(counters, pattern, Detector$3.MAX_INDIVIDUAL_VARIANCE) < Detector$3.MAX_AVG_VARIANCE) return new Int32Array([
                            patternStart,
                            x
                        ]);
                        patternStart += counters[0] + counters[1];
                        System.arraycopy(counters, 2, counters, 0, counterPosition - 1);
                        counters[counterPosition - 1] = 0;
                        counters[counterPosition] = 0;
                        counterPosition--;
                    } else counterPosition++;
                    counters[counterPosition] = 1;
                    isWhite = !isWhite;
                }
            }
            if (counterPosition === patternLength - 1 && Detector$3.patternMatchVariance(counters, pattern, Detector$3.MAX_INDIVIDUAL_VARIANCE) < Detector$3.MAX_AVG_VARIANCE) return new Int32Array([
                patternStart,
                x - 1
            ]);
            return null;
        }
        /**
         * Determines how closely a set of observed counts of runs of black/white
         * values matches a given target pattern. This is reported as the ratio of
         * the total variance from the expected pattern proportions across all
         * pattern elements, to the length of the pattern.
         *
         * @param counters observed counters
         * @param pattern expected pattern
         * @param maxIndividualVariance The most any counter can differ before we give up
         * @return ratio of total variance between counters and pattern compared to total pattern size
         */ static patternMatchVariance(counters, pattern, maxIndividualVariance) {
            let numCounters = counters.length;
            let total = 0;
            let patternLength = 0;
            for(let i = 0; i < numCounters; i++){
                total += counters[i];
                patternLength += pattern[i];
            }
            if (total < patternLength) // If we don't even have one pixel per unit of bar width, assume this
            // is too small to reliably match, so fail:
            return /*Float.POSITIVE_INFINITY*/ Infinity;
            // We're going to fake floating-point math in integers. We just need to use more bits.
            // Scale up patternLength so that intermediate values below like scaledCounter will have
            // more "significant digits".
            let unitBarWidth = total / patternLength;
            maxIndividualVariance *= unitBarWidth;
            let totalVariance = 0.0;
            for(let x = 0; x < numCounters; x++){
                let counter = counters[x];
                let scaledPattern = pattern[x] * unitBarWidth;
                let variance = counter > scaledPattern ? counter - scaledPattern : scaledPattern - counter;
                if (variance > maxIndividualVariance) return /*Float.POSITIVE_INFINITY*/ Infinity;
                totalVariance += variance;
            }
            return totalVariance / total;
        }
    }
    Detector$3.INDEXES_START_PATTERN = Int32Array.from([
        0,
        4,
        1,
        5
    ]);
    Detector$3.INDEXES_STOP_PATTERN = Int32Array.from([
        6,
        2,
        7,
        3
    ]);
    Detector$3.MAX_AVG_VARIANCE = 0.42;
    Detector$3.MAX_INDIVIDUAL_VARIANCE = 0.8;
    // B S B S B S B S Bar/Space pattern
    // 11111111 0 1 0 1 0 1 000
    Detector$3.START_PATTERN = Int32Array.from([
        8,
        1,
        1,
        1,
        1,
        1,
        1,
        3
    ]);
    // 1111111 0 1 000 1 0 1 00 1
    Detector$3.STOP_PATTERN = Int32Array.from([
        7,
        1,
        1,
        3,
        1,
        1,
        1,
        2,
        1
    ]);
    Detector$3.MAX_PIXEL_DRIFT = 3;
    Detector$3.MAX_PATTERN_DRIFT = 5;
    // if we set the value too low, then we don't detect the correct height of the bar if the start patterns are damaged.
    // if we set the value too high, then we might detect the start pattern from a neighbor barcode.
    Detector$3.SKIPPED_ROW_COUNT_MAX = 25;
    // A PDF471 barcode should have at least 3 rows, with each row being >= 3 times the module width. Therefore it should be at least
    // 9 pixels tall. To be conservative, we use about half the size to ensure we don't miss it.
    Detector$3.ROW_STEP = 5;
    Detector$3.BARCODE_MIN_HEIGHT = 10;
    /*
    * Copyright 2012 ZXing authors
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    *      http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    */ /**
     * @author Sean Owen
     * @see com.google.zxing.common.reedsolomon.GenericGFPoly
     */ /*final*/ class ModulusPoly {
        constructor(field, coefficients){
            if (coefficients.length === 0) throw new IllegalArgumentException();
            this.field = field;
            let coefficientsLength = /*int*/ coefficients.length;
            if (coefficientsLength > 1 && coefficients[0] === 0) {
                // Leading term must be non-zero for anything except the constant polynomial "0"
                let firstNonZero = /*int*/ 1;
                while(firstNonZero < coefficientsLength && coefficients[firstNonZero] === 0)firstNonZero++;
                if (firstNonZero === coefficientsLength) this.coefficients = new Int32Array([
                    0
                ]);
                else {
                    this.coefficients = new Int32Array(coefficientsLength - firstNonZero);
                    System.arraycopy(coefficients, firstNonZero, this.coefficients, 0, this.coefficients.length);
                }
            } else this.coefficients = coefficients;
        }
        getCoefficients() {
            return this.coefficients;
        }
        /**
         * @return degree of this polynomial
         */ getDegree() {
            return this.coefficients.length - 1;
        }
        /**
         * @return true iff this polynomial is the monomial "0"
         */ isZero() {
            return this.coefficients[0] === 0;
        }
        /**
         * @return coefficient of x^degree term in this polynomial
         */ getCoefficient(degree) {
            return this.coefficients[this.coefficients.length - 1 - degree];
        }
        /**
         * @return evaluation of this polynomial at a given point
         */ evaluateAt(a) {
            if (a === 0) // Just return the x^0 coefficient
            return this.getCoefficient(0);
            if (a === 1) {
                // Just the sum of the coefficients
                let sum = /*int*/ 0;
                for (let coefficient /*int*/  of this.coefficients)sum = this.field.add(sum, coefficient);
                return sum;
            }
            let result = /*int*/ this.coefficients[0];
            let size = /*int*/ this.coefficients.length;
            for(let i /*int*/  = 1; i < size; i++)result = this.field.add(this.field.multiply(a, result), this.coefficients[i]);
            return result;
        }
        add(other) {
            if (!this.field.equals(other.field)) throw new IllegalArgumentException('ModulusPolys do not have same ModulusGF field');
            if (this.isZero()) return other;
            if (other.isZero()) return this;
            let smallerCoefficients = this.coefficients;
            let largerCoefficients = other.coefficients;
            if (smallerCoefficients.length > largerCoefficients.length) {
                let temp = smallerCoefficients;
                smallerCoefficients = largerCoefficients;
                largerCoefficients = temp;
            }
            let sumDiff = new Int32Array(largerCoefficients.length);
            let lengthDiff = /*int*/ largerCoefficients.length - smallerCoefficients.length;
            // Copy high-order terms only found in higher-degree polynomial's coefficients
            System.arraycopy(largerCoefficients, 0, sumDiff, 0, lengthDiff);
            for(let i /*int*/  = lengthDiff; i < largerCoefficients.length; i++)sumDiff[i] = this.field.add(smallerCoefficients[i - lengthDiff], largerCoefficients[i]);
            return new ModulusPoly(this.field, sumDiff);
        }
        subtract(other) {
            if (!this.field.equals(other.field)) throw new IllegalArgumentException('ModulusPolys do not have same ModulusGF field');
            if (other.isZero()) return this;
            return this.add(other.negative());
        }
        multiply(other) {
            if (other instanceof ModulusPoly) return this.multiplyOther(other);
            return this.multiplyScalar(other);
        }
        multiplyOther(other) {
            if (!this.field.equals(other.field)) throw new IllegalArgumentException('ModulusPolys do not have same ModulusGF field');
            if (this.isZero() || other.isZero()) // return this.field.getZero();
            return new ModulusPoly(this.field, new Int32Array([
                0
            ]));
            let aCoefficients = this.coefficients;
            let aLength = /*int*/ aCoefficients.length;
            let bCoefficients = other.coefficients;
            let bLength = /*int*/ bCoefficients.length;
            let product = new Int32Array(aLength + bLength - 1);
            for(let i /*int*/  = 0; i < aLength; i++){
                let aCoeff = /*int*/ aCoefficients[i];
                for(let j /*int*/  = 0; j < bLength; j++)product[i + j] = this.field.add(product[i + j], this.field.multiply(aCoeff, bCoefficients[j]));
            }
            return new ModulusPoly(this.field, product);
        }
        negative() {
            let size = /*int*/ this.coefficients.length;
            let negativeCoefficients = new Int32Array(size);
            for(let i /*int*/  = 0; i < size; i++)negativeCoefficients[i] = this.field.subtract(0, this.coefficients[i]);
            return new ModulusPoly(this.field, negativeCoefficients);
        }
        multiplyScalar(scalar) {
            if (scalar === 0) return new ModulusPoly(this.field, new Int32Array([
                0
            ]));
            if (scalar === 1) return this;
            let size = /*int*/ this.coefficients.length;
            let product = new Int32Array(size);
            for(let i /*int*/  = 0; i < size; i++)product[i] = this.field.multiply(this.coefficients[i], scalar);
            return new ModulusPoly(this.field, product);
        }
        multiplyByMonomial(degree, coefficient) {
            if (degree < 0) throw new IllegalArgumentException();
            if (coefficient === 0) return new ModulusPoly(this.field, new Int32Array([
                0
            ]));
            let size = /*int*/ this.coefficients.length;
            let product = new Int32Array(size + degree);
            for(let i /*int*/  = 0; i < size; i++)product[i] = this.field.multiply(this.coefficients[i], coefficient);
            return new ModulusPoly(this.field, product);
        }
        /*
        ModulusPoly[] divide(other: ModulusPoly) {
          if (!field.equals(other.field)) {
            throw new IllegalArgumentException("ModulusPolys do not have same ModulusGF field");
          }
          if (other.isZero()) {
            throw new IllegalArgumentException("Divide by 0");
          }
      
          let quotient: ModulusPoly = field.getZero();
          let remainder: ModulusPoly = this;
      
          let denominatorLeadingTerm: /*int/ number = other.getCoefficient(other.getDegree());
          let inverseDenominatorLeadingTerm: /*int/ number = field.inverse(denominatorLeadingTerm);
      
          while (remainder.getDegree() >= other.getDegree() && !remainder.isZero()) {
            let degreeDifference: /*int/ number = remainder.getDegree() - other.getDegree();
            let scale: /*int/ number = field.multiply(remainder.getCoefficient(remainder.getDegree()), inverseDenominatorLeadingTerm);
            let term: ModulusPoly = other.multiplyByMonomial(degreeDifference, scale);
            let iterationQuotient: ModulusPoly = field.buildMonomial(degreeDifference, scale);
            quotient = quotient.add(iterationQuotient);
            remainder = remainder.subtract(term);
          }
      
          return new ModulusPoly[] { quotient, remainder };
        }
        */ // @Override
        toString() {
            let result = new StringBuilder(); // dynamic string size in JS
            for(let degree /*int*/  = this.getDegree(); degree >= 0; degree--){
                let coefficient = /*int*/ this.getCoefficient(degree);
                if (coefficient !== 0) {
                    if (coefficient < 0) {
                        result.append(' - ');
                        coefficient = -coefficient;
                    } else if (result.length() > 0) result.append(' + ');
                    if (degree === 0 || coefficient !== 1) result.append(coefficient);
                    if (degree !== 0) {
                        if (degree === 1) result.append('x');
                        else {
                            result.append('x^');
                            result.append(degree);
                        }
                    }
                }
            }
            return result.toString();
        }
    }
    class ModulusBase {
        add(a, b) {
            return (a + b) % this.modulus;
        }
        subtract(a, b) {
            return (this.modulus + a - b) % this.modulus;
        }
        exp(a) {
            return this.expTable[a];
        }
        log(a) {
            if (a === 0) throw new IllegalArgumentException();
            return this.logTable[a];
        }
        inverse(a) {
            if (a === 0) throw new ArithmeticException();
            return this.expTable[this.modulus - this.logTable[a] - 1];
        }
        multiply(a, b) {
            if (a === 0 || b === 0) return 0;
            return this.expTable[(this.logTable[a] + this.logTable[b]) % (this.modulus - 1)];
        }
        getSize() {
            return this.modulus;
        }
        equals(o) {
            return o === this;
        }
    }
    /*
     * Copyright 2012 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * <p>A field based on powers of a generator integer, modulo some modulus.</p>
     *
     * @author Sean Owen
     * @see com.google.zxing.common.reedsolomon.GenericGF
     */ /*public final*/ class ModulusGF extends ModulusBase {
        // private /*final*/ modulus: /*int*/ number;
        constructor(modulus, generator){
            super();
            this.modulus = modulus;
            this.expTable = new Int32Array(modulus);
            this.logTable = new Int32Array(modulus);
            let x = /*int*/ 1;
            for(let i /*int*/  = 0; i < modulus; i++){
                this.expTable[i] = x;
                x = x * generator % modulus;
            }
            for(let i /*int*/  = 0; i < modulus - 1; i++)this.logTable[this.expTable[i]] = i;
            // logTable[0] == 0 but this should never be used
            this.zero = new ModulusPoly(this, new Int32Array([
                0
            ]));
            this.one = new ModulusPoly(this, new Int32Array([
                1
            ]));
        }
        getZero() {
            return this.zero;
        }
        getOne() {
            return this.one;
        }
        buildMonomial(degree, coefficient) {
            if (degree < 0) throw new IllegalArgumentException();
            if (coefficient === 0) return this.zero;
            let coefficients = new Int32Array(degree + 1);
            coefficients[0] = coefficient;
            return new ModulusPoly(this, coefficients);
        }
    }
    ModulusGF.PDF417_GF = new ModulusGF(PDF417Common.NUMBER_OF_CODEWORDS, 3);
    /*
    * Copyright 2012 ZXing authors
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    *      http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    */ /**
     * <p>PDF417 error correction implementation.</p>
     *
     * <p>This <a href="http://en.wikipedia.org/wiki/Reed%E2%80%93Solomon_error_correction#Example">example</a>
     * is quite useful in understanding the algorithm.</p>
     *
     * @author Sean Owen
     * @see com.google.zxing.common.reedsolomon.ReedSolomonDecoder
     */ /*public final*/ class ErrorCorrection {
        constructor(){
            this.field = ModulusGF.PDF417_GF;
        }
        /**
         * @param received received codewords
         * @param numECCodewords number of those codewords used for EC
         * @param erasures location of erasures
         * @return number of errors
         * @throws ChecksumException if errors cannot be corrected, maybe because of too many errors
         */ decode(received, numECCodewords, erasures) {
            let poly = new ModulusPoly(this.field, received);
            let S = new Int32Array(numECCodewords);
            let error = false;
            for(let i /*int*/  = numECCodewords; i > 0; i--){
                let evaluation = poly.evaluateAt(this.field.exp(i));
                S[numECCodewords - i] = evaluation;
                if (evaluation !== 0) error = true;
            }
            if (!error) return 0;
            let knownErrors = this.field.getOne();
            if (erasures != null) for (const erasure of erasures){
                let b = this.field.exp(received.length - 1 - erasure);
                // Add (1 - bx) term:
                let term = new ModulusPoly(this.field, new Int32Array([
                    this.field.subtract(0, b),
                    1
                ]));
                knownErrors = knownErrors.multiply(term);
            }
            let syndrome = new ModulusPoly(this.field, S);
            // syndrome = syndrome.multiply(knownErrors);
            let sigmaOmega = this.runEuclideanAlgorithm(this.field.buildMonomial(numECCodewords, 1), syndrome, numECCodewords);
            let sigma = sigmaOmega[0];
            let omega = sigmaOmega[1];
            // sigma = sigma.multiply(knownErrors);
            let errorLocations = this.findErrorLocations(sigma);
            let errorMagnitudes = this.findErrorMagnitudes(omega, sigma, errorLocations);
            for(let i /*int*/  = 0; i < errorLocations.length; i++){
                let position = received.length - 1 - this.field.log(errorLocations[i]);
                if (position < 0) throw ChecksumException.getChecksumInstance();
                received[position] = this.field.subtract(received[position], errorMagnitudes[i]);
            }
            return errorLocations.length;
        }
        /**
         *
         * @param ModulusPoly
         * @param a
         * @param ModulusPoly
         * @param b
         * @param int
         * @param R
         * @throws ChecksumException
         */ runEuclideanAlgorithm(a, b, R) {
            // Assume a's degree is >= b's
            if (a.getDegree() < b.getDegree()) {
                let temp = a;
                a = b;
                b = temp;
            }
            let rLast = a;
            let r = b;
            let tLast = this.field.getZero();
            let t = this.field.getOne();
            // Run Euclidean algorithm until r's degree is less than R/2
            while(r.getDegree() >= Math.round(R / 2)){
                let rLastLast = rLast;
                let tLastLast = tLast;
                rLast = r;
                tLast = t;
                // Divide rLastLast by rLast, with quotient in q and remainder in r
                if (rLast.isZero()) // Oops, Euclidean algorithm already terminated?
                throw ChecksumException.getChecksumInstance();
                r = rLastLast;
                let q = this.field.getZero();
                let denominatorLeadingTerm = rLast.getCoefficient(rLast.getDegree());
                let dltInverse = this.field.inverse(denominatorLeadingTerm);
                while(r.getDegree() >= rLast.getDegree() && !r.isZero()){
                    let degreeDiff = r.getDegree() - rLast.getDegree();
                    let scale = this.field.multiply(r.getCoefficient(r.getDegree()), dltInverse);
                    q = q.add(this.field.buildMonomial(degreeDiff, scale));
                    r = r.subtract(rLast.multiplyByMonomial(degreeDiff, scale));
                }
                t = q.multiply(tLast).subtract(tLastLast).negative();
            }
            let sigmaTildeAtZero = t.getCoefficient(0);
            if (sigmaTildeAtZero === 0) throw ChecksumException.getChecksumInstance();
            let inverse = this.field.inverse(sigmaTildeAtZero);
            let sigma = t.multiply(inverse);
            let omega = r.multiply(inverse);
            return [
                sigma,
                omega
            ];
        }
        /**
         *
         * @param errorLocator
         * @throws ChecksumException
         */ findErrorLocations(errorLocator) {
            // This is a direct application of Chien's search
            let numErrors = errorLocator.getDegree();
            let result = new Int32Array(numErrors);
            let e = 0;
            for(let i /*int*/  = 1; i < this.field.getSize() && e < numErrors; i++)if (errorLocator.evaluateAt(i) === 0) {
                result[e] = this.field.inverse(i);
                e++;
            }
            if (e !== numErrors) throw ChecksumException.getChecksumInstance();
            return result;
        }
        findErrorMagnitudes(errorEvaluator, errorLocator, errorLocations) {
            let errorLocatorDegree = errorLocator.getDegree();
            let formalDerivativeCoefficients = new Int32Array(errorLocatorDegree);
            for(let i /*int*/  = 1; i <= errorLocatorDegree; i++)formalDerivativeCoefficients[errorLocatorDegree - i] = this.field.multiply(i, errorLocator.getCoefficient(i));
            let formalDerivative = new ModulusPoly(this.field, formalDerivativeCoefficients);
            // This is directly applying Forney's Formula
            let s = errorLocations.length;
            let result = new Int32Array(s);
            for(let i /*int*/  = 0; i < s; i++){
                let xiInverse = this.field.inverse(errorLocations[i]);
                let numerator = this.field.subtract(0, errorEvaluator.evaluateAt(xiInverse));
                let denominator = this.field.inverse(formalDerivative.evaluateAt(xiInverse));
                result[i] = this.field.multiply(numerator, denominator);
            }
            return result;
        }
    }
    /*
    * Copyright 2013 ZXing authors
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    *      http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    */ /**
     * @author Guenther Grau
     */ /*final*/ class BoundingBox {
        constructor(image, topLeft, bottomLeft, topRight, bottomRight){
            if (image instanceof BoundingBox) this.constructor_2(image);
            else this.constructor_1(image, topLeft, bottomLeft, topRight, bottomRight);
        }
        /**
         *
         * @param image
         * @param topLeft
         * @param bottomLeft
         * @param topRight
         * @param bottomRight
         *
         * @throws NotFoundException
         */ constructor_1(image, topLeft, bottomLeft, topRight, bottomRight) {
            const leftUnspecified = topLeft == null || bottomLeft == null;
            const rightUnspecified = topRight == null || bottomRight == null;
            if (leftUnspecified && rightUnspecified) throw new NotFoundException();
            if (leftUnspecified) {
                topLeft = new ResultPoint(0, topRight.getY());
                bottomLeft = new ResultPoint(0, bottomRight.getY());
            } else if (rightUnspecified) {
                topRight = new ResultPoint(image.getWidth() - 1, topLeft.getY());
                bottomRight = new ResultPoint(image.getWidth() - 1, bottomLeft.getY());
            }
            this.image = image;
            this.topLeft = topLeft;
            this.bottomLeft = bottomLeft;
            this.topRight = topRight;
            this.bottomRight = bottomRight;
            this.minX = Math.trunc(Math.min(topLeft.getX(), bottomLeft.getX()));
            this.maxX = Math.trunc(Math.max(topRight.getX(), bottomRight.getX()));
            this.minY = Math.trunc(Math.min(topLeft.getY(), topRight.getY()));
            this.maxY = Math.trunc(Math.max(bottomLeft.getY(), bottomRight.getY()));
        }
        constructor_2(boundingBox) {
            this.image = boundingBox.image;
            this.topLeft = boundingBox.getTopLeft();
            this.bottomLeft = boundingBox.getBottomLeft();
            this.topRight = boundingBox.getTopRight();
            this.bottomRight = boundingBox.getBottomRight();
            this.minX = boundingBox.getMinX();
            this.maxX = boundingBox.getMaxX();
            this.minY = boundingBox.getMinY();
            this.maxY = boundingBox.getMaxY();
        }
        /**
         * @throws NotFoundException
         */ static merge(leftBox, rightBox) {
            if (leftBox == null) return rightBox;
            if (rightBox == null) return leftBox;
            return new BoundingBox(leftBox.image, leftBox.topLeft, leftBox.bottomLeft, rightBox.topRight, rightBox.bottomRight);
        }
        /**
         * @throws NotFoundException
         */ addMissingRows(missingStartRows, missingEndRows, isLeft) {
            let newTopLeft = this.topLeft;
            let newBottomLeft = this.bottomLeft;
            let newTopRight = this.topRight;
            let newBottomRight = this.bottomRight;
            if (missingStartRows > 0) {
                let top = isLeft ? this.topLeft : this.topRight;
                let newMinY = Math.trunc(top.getY() - missingStartRows);
                if (newMinY < 0) newMinY = 0;
                let newTop = new ResultPoint(top.getX(), newMinY);
                if (isLeft) newTopLeft = newTop;
                else newTopRight = newTop;
            }
            if (missingEndRows > 0) {
                let bottom = isLeft ? this.bottomLeft : this.bottomRight;
                let newMaxY = Math.trunc(bottom.getY() + missingEndRows);
                if (newMaxY >= this.image.getHeight()) newMaxY = this.image.getHeight() - 1;
                let newBottom = new ResultPoint(bottom.getX(), newMaxY);
                if (isLeft) newBottomLeft = newBottom;
                else newBottomRight = newBottom;
            }
            return new BoundingBox(this.image, newTopLeft, newBottomLeft, newTopRight, newBottomRight);
        }
        getMinX() {
            return this.minX;
        }
        getMaxX() {
            return this.maxX;
        }
        getMinY() {
            return this.minY;
        }
        getMaxY() {
            return this.maxY;
        }
        getTopLeft() {
            return this.topLeft;
        }
        getTopRight() {
            return this.topRight;
        }
        getBottomLeft() {
            return this.bottomLeft;
        }
        getBottomRight() {
            return this.bottomRight;
        }
    }
    /*
     * Copyright 2013 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ // package com.google.zxing.pdf417.decoder;
    /**
     * @author Guenther Grau
     */ /*final*/ class BarcodeMetadata {
        constructor(columnCount, rowCountUpperPart, rowCountLowerPart, errorCorrectionLevel){
            this.columnCount = columnCount;
            this.errorCorrectionLevel = errorCorrectionLevel;
            this.rowCountUpperPart = rowCountUpperPart;
            this.rowCountLowerPart = rowCountLowerPart;
            this.rowCount = rowCountUpperPart + rowCountLowerPart;
        }
        getColumnCount() {
            return this.columnCount;
        }
        getErrorCorrectionLevel() {
            return this.errorCorrectionLevel;
        }
        getRowCount() {
            return this.rowCount;
        }
        getRowCountUpperPart() {
            return this.rowCountUpperPart;
        }
        getRowCountLowerPart() {
            return this.rowCountLowerPart;
        }
    }
    /**
     * Java Formatter class polyfill that works in the JS way.
     */ class Formatter {
        constructor(){
            this.buffer = '';
        }
        /**
         *
         * @see https://stackoverflow.com/a/13439711/4367683
         *
         * @param str
         * @param arr
         */ static form(str, arr) {
            let i = -1;
            function callback(exp, p0, p1, p2, p3, p4) {
                if (exp === '%%') return '%';
                if (arr[++i] === undefined) return undefined;
                exp = p2 ? parseInt(p2.substr(1)) : undefined;
                let base = p3 ? parseInt(p3.substr(1)) : undefined;
                let val;
                switch(p4){
                    case 's':
                        val = arr[i];
                        break;
                    case 'c':
                        val = arr[i][0];
                        break;
                    case 'f':
                        val = parseFloat(arr[i]).toFixed(exp);
                        break;
                    case 'p':
                        val = parseFloat(arr[i]).toPrecision(exp);
                        break;
                    case 'e':
                        val = parseFloat(arr[i]).toExponential(exp);
                        break;
                    case 'x':
                        val = parseInt(arr[i]).toString(base ? base : 16);
                        break;
                    case 'd':
                        val = parseFloat(parseInt(arr[i], base ? base : 10).toPrecision(exp)).toFixed(0);
                        break;
                }
                val = typeof val === 'object' ? JSON.stringify(val) : (+val).toString(base);
                let size = parseInt(p1); /* padding size */ 
                let ch = p1 && p1[0] + '' === '0' ? '0' : ' '; /* isnull? */ 
                while(val.length < size)val = p0 !== undefined ? val + ch : ch + val; /* isminus? */ 
                return val;
            }
            let regex = /%(-)?(0?[0-9]+)?([.][0-9]+)?([#][0-9]+)?([scfpexd%])/g;
            return str.replace(regex, callback);
        }
        /**
         *
         * @param append The new string to append.
         * @param args Argumets values to be formated.
         */ format(append, ...args) {
            this.buffer += Formatter.form(append, args);
        }
        /**
         * Returns the Formatter string value.
         */ toString() {
            return this.buffer;
        }
    }
    /*
     * Copyright 2013 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * @author Guenther Grau
     */ class DetectionResultColumn {
        constructor(boundingBox){
            this.boundingBox = new BoundingBox(boundingBox);
            // this.codewords = new Codeword[boundingBox.getMaxY() - boundingBox.getMinY() + 1];
            this.codewords = new Array(boundingBox.getMaxY() - boundingBox.getMinY() + 1);
        }
        /*final*/ getCodewordNearby(imageRow) {
            let codeword = this.getCodeword(imageRow);
            if (codeword != null) return codeword;
            for(let i = 1; i < DetectionResultColumn.MAX_NEARBY_DISTANCE; i++){
                let nearImageRow = this.imageRowToCodewordIndex(imageRow) - i;
                if (nearImageRow >= 0) {
                    codeword = this.codewords[nearImageRow];
                    if (codeword != null) return codeword;
                }
                nearImageRow = this.imageRowToCodewordIndex(imageRow) + i;
                if (nearImageRow < this.codewords.length) {
                    codeword = this.codewords[nearImageRow];
                    if (codeword != null) return codeword;
                }
            }
            return null;
        }
        /*final int*/ imageRowToCodewordIndex(imageRow) {
            return imageRow - this.boundingBox.getMinY();
        }
        /*final void*/ setCodeword(imageRow, codeword) {
            this.codewords[this.imageRowToCodewordIndex(imageRow)] = codeword;
        }
        /*final*/ getCodeword(imageRow) {
            return this.codewords[this.imageRowToCodewordIndex(imageRow)];
        }
        /*final*/ getBoundingBox() {
            return this.boundingBox;
        }
        /*final*/ getCodewords() {
            return this.codewords;
        }
        // @Override
        toString() {
            const formatter = new Formatter();
            let row = 0;
            for (const codeword of this.codewords){
                if (codeword == null) {
                    formatter.format('%3d:    |   %n', row++);
                    continue;
                }
                formatter.format('%3d: %3d|%3d%n', row++, codeword.getRowNumber(), codeword.getValue());
            }
            return formatter.toString();
        }
    }
    DetectionResultColumn.MAX_NEARBY_DISTANCE = 5;
    /*
     * Copyright 2013 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ // import java.util.ArrayList;
    // import java.util.Collection;
    // import java.util.HashMap;
    // import java.util.Map;
    // import java.util.Map.Entry;
    /**
     * @author Guenther Grau
     */ /*final*/ class BarcodeValue {
        constructor(){
            this.values = new Map();
        }
        /**
         * Add an occurrence of a value
         */ setValue(value) {
            value = Math.trunc(value);
            let confidence = this.values.get(value);
            if (confidence == null) confidence = 0;
            confidence++;
            this.values.set(value, confidence);
        }
        /**
         * Determines the maximum occurrence of a set value and returns all values which were set with this occurrence.
         * @return an array of int, containing the values with the highest occurrence, or null, if no value was set
         */ getValue() {
            let maxConfidence = -1;
            let result = new Array();
            for (const [key, value] of this.values.entries()){
                const entry = {
                    getKey: ()=>key,
                    getValue: ()=>value
                };
                if (entry.getValue() > maxConfidence) {
                    maxConfidence = entry.getValue();
                    result = [];
                    result.push(entry.getKey());
                } else if (entry.getValue() === maxConfidence) result.push(entry.getKey());
            }
            return PDF417Common.toIntArray(result);
        }
        getConfidence(value) {
            return this.values.get(value);
        }
    }
    /*
     * Copyright 2013 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * @author Guenther Grau
     */ /*final*/ class DetectionResultRowIndicatorColumn extends DetectionResultColumn {
        constructor(boundingBox, isLeft){
            super(boundingBox);
            this._isLeft = isLeft;
        }
        setRowNumbers() {
            for (let codeword /*Codeword*/  of this.getCodewords())if (codeword != null) codeword.setRowNumberAsRowIndicatorColumn();
        }
        // TODO implement properly
        // TODO maybe we should add missing codewords to store the correct row number to make
        // finding row numbers for other columns easier
        // use row height count to make detection of invalid row numbers more reliable
        adjustCompleteIndicatorColumnRowNumbers(barcodeMetadata) {
            let codewords = this.getCodewords();
            this.setRowNumbers();
            this.removeIncorrectCodewords(codewords, barcodeMetadata);
            let boundingBox = this.getBoundingBox();
            let top = this._isLeft ? boundingBox.getTopLeft() : boundingBox.getTopRight();
            let bottom = this._isLeft ? boundingBox.getBottomLeft() : boundingBox.getBottomRight();
            let firstRow = this.imageRowToCodewordIndex(Math.trunc(top.getY()));
            let lastRow = this.imageRowToCodewordIndex(Math.trunc(bottom.getY()));
            // We need to be careful using the average row height. Barcode could be skewed so that we have smaller and
            // taller rows
            // float averageRowHeight = (lastRow - firstRow) / /*(float)*/ barcodeMetadata.getRowCount();
            let barcodeRow = -1;
            let maxRowHeight = 1;
            let currentRowHeight = 0;
            for(let codewordsRow /*int*/  = firstRow; codewordsRow < lastRow; codewordsRow++){
                if (codewords[codewordsRow] == null) continue;
                let codeword = codewords[codewordsRow];
                //      float expectedRowNumber = (codewordsRow - firstRow) / averageRowHeight;
                //      if (Math.abs(codeword.getRowNumber() - expectedRowNumber) > 2) {
                //        SimpleLog.log(LEVEL.WARNING,
                //            "Removing codeword, rowNumberSkew too high, codeword[" + codewordsRow + "]: Expected Row: " +
                //                expectedRowNumber + ", RealRow: " + codeword.getRowNumber() + ", value: " + codeword.getValue());
                //        codewords[codewordsRow] = null;
                //      }
                let rowDifference = codeword.getRowNumber() - barcodeRow;
                // TODO improve handling with case where first row indicator doesn't start with 0
                if (rowDifference === 0) currentRowHeight++;
                else if (rowDifference === 1) {
                    maxRowHeight = Math.max(maxRowHeight, currentRowHeight);
                    currentRowHeight = 1;
                    barcodeRow = codeword.getRowNumber();
                } else if (rowDifference < 0 || codeword.getRowNumber() >= barcodeMetadata.getRowCount() || rowDifference > codewordsRow) codewords[codewordsRow] = null;
                else {
                    let checkedRows;
                    if (maxRowHeight > 2) checkedRows = (maxRowHeight - 2) * rowDifference;
                    else checkedRows = rowDifference;
                    let closePreviousCodewordFound = checkedRows >= codewordsRow;
                    for(let i /*int*/  = 1; i <= checkedRows && !closePreviousCodewordFound; i++)// there must be (height * rowDifference) number of codewords missing. For now we assume height = 1.
                    // This should hopefully get rid of most problems already.
                    closePreviousCodewordFound = codewords[codewordsRow - i] != null;
                    if (closePreviousCodewordFound) codewords[codewordsRow] = null;
                    else {
                        barcodeRow = codeword.getRowNumber();
                        currentRowHeight = 1;
                    }
                }
            }
        // return (int) (averageRowHeight + 0.5);
        }
        getRowHeights() {
            let barcodeMetadata = this.getBarcodeMetadata();
            if (barcodeMetadata == null) return null;
            this.adjustIncompleteIndicatorColumnRowNumbers(barcodeMetadata);
            let result = new Int32Array(barcodeMetadata.getRowCount());
            for (let codeword /*Codeword*/  of this.getCodewords())if (codeword != null) {
                let rowNumber = codeword.getRowNumber();
                if (rowNumber >= result.length) continue;
                result[rowNumber]++;
            } // else throw exception?
            return result;
        }
        // TODO maybe we should add missing codewords to store the correct row number to make
        // finding row numbers for other columns easier
        // use row height count to make detection of invalid row numbers more reliable
        adjustIncompleteIndicatorColumnRowNumbers(barcodeMetadata) {
            let boundingBox = this.getBoundingBox();
            let top = this._isLeft ? boundingBox.getTopLeft() : boundingBox.getTopRight();
            let bottom = this._isLeft ? boundingBox.getBottomLeft() : boundingBox.getBottomRight();
            let firstRow = this.imageRowToCodewordIndex(Math.trunc(top.getY()));
            let lastRow = this.imageRowToCodewordIndex(Math.trunc(bottom.getY()));
            // float averageRowHeight = (lastRow - firstRow) / /*(float)*/ barcodeMetadata.getRowCount();
            let codewords = this.getCodewords();
            let barcodeRow = -1;
            for(let codewordsRow /*int*/  = firstRow; codewordsRow < lastRow; codewordsRow++){
                if (codewords[codewordsRow] == null) continue;
                let codeword = codewords[codewordsRow];
                codeword.setRowNumberAsRowIndicatorColumn();
                let rowDifference = codeword.getRowNumber() - barcodeRow;
                // TODO improve handling with case where first row indicator doesn't start with 0
                if (rowDifference === 0) ;
                else if (rowDifference === 1) barcodeRow = codeword.getRowNumber();
                else if (codeword.getRowNumber() >= barcodeMetadata.getRowCount()) codewords[codewordsRow] = null;
                else barcodeRow = codeword.getRowNumber();
            }
        // return (int) (averageRowHeight + 0.5);
        }
        getBarcodeMetadata() {
            let codewords = this.getCodewords();
            let barcodeColumnCount = new BarcodeValue();
            let barcodeRowCountUpperPart = new BarcodeValue();
            let barcodeRowCountLowerPart = new BarcodeValue();
            let barcodeECLevel = new BarcodeValue();
            for (let codeword /*Codeword*/  of codewords){
                if (codeword == null) continue;
                codeword.setRowNumberAsRowIndicatorColumn();
                let rowIndicatorValue = codeword.getValue() % 30;
                let codewordRowNumber = codeword.getRowNumber();
                if (!this._isLeft) codewordRowNumber += 2;
                switch(codewordRowNumber % 3){
                    case 0:
                        barcodeRowCountUpperPart.setValue(rowIndicatorValue * 3 + 1);
                        break;
                    case 1:
                        barcodeECLevel.setValue(rowIndicatorValue / 3);
                        barcodeRowCountLowerPart.setValue(rowIndicatorValue % 3);
                        break;
                    case 2:
                        barcodeColumnCount.setValue(rowIndicatorValue + 1);
                        break;
                }
            }
            // Maybe we should check if we have ambiguous values?
            if (barcodeColumnCount.getValue().length === 0 || barcodeRowCountUpperPart.getValue().length === 0 || barcodeRowCountLowerPart.getValue().length === 0 || barcodeECLevel.getValue().length === 0 || barcodeColumnCount.getValue()[0] < 1 || barcodeRowCountUpperPart.getValue()[0] + barcodeRowCountLowerPart.getValue()[0] < PDF417Common.MIN_ROWS_IN_BARCODE || barcodeRowCountUpperPart.getValue()[0] + barcodeRowCountLowerPart.getValue()[0] > PDF417Common.MAX_ROWS_IN_BARCODE) return null;
            let barcodeMetadata = new BarcodeMetadata(barcodeColumnCount.getValue()[0], barcodeRowCountUpperPart.getValue()[0], barcodeRowCountLowerPart.getValue()[0], barcodeECLevel.getValue()[0]);
            this.removeIncorrectCodewords(codewords, barcodeMetadata);
            return barcodeMetadata;
        }
        removeIncorrectCodewords(codewords, barcodeMetadata) {
            // Remove codewords which do not match the metadata
            // TODO Maybe we should keep the incorrect codewords for the start and end positions?
            for(let codewordRow /*int*/  = 0; codewordRow < codewords.length; codewordRow++){
                let codeword = codewords[codewordRow];
                if (codewords[codewordRow] == null) continue;
                let rowIndicatorValue = codeword.getValue() % 30;
                let codewordRowNumber = codeword.getRowNumber();
                if (codewordRowNumber > barcodeMetadata.getRowCount()) {
                    codewords[codewordRow] = null;
                    continue;
                }
                if (!this._isLeft) codewordRowNumber += 2;
                switch(codewordRowNumber % 3){
                    case 0:
                        if (rowIndicatorValue * 3 + 1 !== barcodeMetadata.getRowCountUpperPart()) codewords[codewordRow] = null;
                        break;
                    case 1:
                        if (Math.trunc(rowIndicatorValue / 3) !== barcodeMetadata.getErrorCorrectionLevel() || rowIndicatorValue % 3 !== barcodeMetadata.getRowCountLowerPart()) codewords[codewordRow] = null;
                        break;
                    case 2:
                        if (rowIndicatorValue + 1 !== barcodeMetadata.getColumnCount()) codewords[codewordRow] = null;
                        break;
                }
            }
        }
        isLeft() {
            return this._isLeft;
        }
        // @Override
        toString() {
            return 'IsLeft: ' + this._isLeft + '\n' + super.toString();
        }
    }
    /*
     * Copyright 2013 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * @author Guenther Grau
     */ /*final*/ class DetectionResult {
        constructor(barcodeMetadata, boundingBox){
            /*final*/ this.ADJUST_ROW_NUMBER_SKIP = 2;
            this.barcodeMetadata = barcodeMetadata;
            this.barcodeColumnCount = barcodeMetadata.getColumnCount();
            this.boundingBox = boundingBox;
            // this.detectionResultColumns = new DetectionResultColumn[this.barcodeColumnCount + 2];
            this.detectionResultColumns = new Array(this.barcodeColumnCount + 2);
        }
        getDetectionResultColumns() {
            this.adjustIndicatorColumnRowNumbers(this.detectionResultColumns[0]);
            this.adjustIndicatorColumnRowNumbers(this.detectionResultColumns[this.barcodeColumnCount + 1]);
            let unadjustedCodewordCount = PDF417Common.MAX_CODEWORDS_IN_BARCODE;
            let previousUnadjustedCount;
            do {
                previousUnadjustedCount = unadjustedCodewordCount;
                unadjustedCodewordCount = this.adjustRowNumbersAndGetCount();
            }while (unadjustedCodewordCount > 0 && unadjustedCodewordCount < previousUnadjustedCount);
            return this.detectionResultColumns;
        }
        adjustIndicatorColumnRowNumbers(detectionResultColumn) {
            if (detectionResultColumn != null) detectionResultColumn.adjustCompleteIndicatorColumnRowNumbers(this.barcodeMetadata);
        }
        // TODO ensure that no detected codewords with unknown row number are left
        // we should be able to estimate the row height and use it as a hint for the row number
        // we should also fill the rows top to bottom and bottom to top
        /**
         * @return number of codewords which don't have a valid row number. Note that the count is not accurate as codewords
         * will be counted several times. It just serves as an indicator to see when we can stop adjusting row numbers
         */ adjustRowNumbersAndGetCount() {
            let unadjustedCount = this.adjustRowNumbersByRow();
            if (unadjustedCount === 0) return 0;
            for(let barcodeColumn /*int*/  = 1; barcodeColumn < this.barcodeColumnCount + 1; barcodeColumn++){
                let codewords = this.detectionResultColumns[barcodeColumn].getCodewords();
                for(let codewordsRow /*int*/  = 0; codewordsRow < codewords.length; codewordsRow++){
                    if (codewords[codewordsRow] == null) continue;
                    if (!codewords[codewordsRow].hasValidRowNumber()) this.adjustRowNumbers(barcodeColumn, codewordsRow, codewords);
                }
            }
            return unadjustedCount;
        }
        adjustRowNumbersByRow() {
            this.adjustRowNumbersFromBothRI();
            // TODO we should only do full row adjustments if row numbers of left and right row indicator column match.
            // Maybe it's even better to calculated the height (rows: d) and divide it by the number of barcode
            // rows. This, together with the LRI and RRI row numbers should allow us to get a good estimate where a row
            // number starts and ends.
            let unadjustedCount = this.adjustRowNumbersFromLRI();
            return unadjustedCount + this.adjustRowNumbersFromRRI();
        }
        adjustRowNumbersFromBothRI() {
            if (this.detectionResultColumns[0] == null || this.detectionResultColumns[this.barcodeColumnCount + 1] == null) return;
            let LRIcodewords = this.detectionResultColumns[0].getCodewords();
            let RRIcodewords = this.detectionResultColumns[this.barcodeColumnCount + 1].getCodewords();
            for(let codewordsRow /*int*/  = 0; codewordsRow < LRIcodewords.length; codewordsRow++){
                if (LRIcodewords[codewordsRow] != null && RRIcodewords[codewordsRow] != null && LRIcodewords[codewordsRow].getRowNumber() === RRIcodewords[codewordsRow].getRowNumber()) for(let barcodeColumn /*int*/  = 1; barcodeColumn <= this.barcodeColumnCount; barcodeColumn++){
                    let codeword = this.detectionResultColumns[barcodeColumn].getCodewords()[codewordsRow];
                    if (codeword == null) continue;
                    codeword.setRowNumber(LRIcodewords[codewordsRow].getRowNumber());
                    if (!codeword.hasValidRowNumber()) this.detectionResultColumns[barcodeColumn].getCodewords()[codewordsRow] = null;
                }
            }
        }
        adjustRowNumbersFromRRI() {
            if (this.detectionResultColumns[this.barcodeColumnCount + 1] == null) return 0;
            let unadjustedCount = 0;
            let codewords = this.detectionResultColumns[this.barcodeColumnCount + 1].getCodewords();
            for(let codewordsRow /*int*/  = 0; codewordsRow < codewords.length; codewordsRow++){
                if (codewords[codewordsRow] == null) continue;
                let rowIndicatorRowNumber = codewords[codewordsRow].getRowNumber();
                let invalidRowCounts = 0;
                for(let barcodeColumn /*int*/  = this.barcodeColumnCount + 1; barcodeColumn > 0 && invalidRowCounts < this.ADJUST_ROW_NUMBER_SKIP; barcodeColumn--){
                    let codeword = this.detectionResultColumns[barcodeColumn].getCodewords()[codewordsRow];
                    if (codeword != null) {
                        invalidRowCounts = DetectionResult.adjustRowNumberIfValid(rowIndicatorRowNumber, invalidRowCounts, codeword);
                        if (!codeword.hasValidRowNumber()) unadjustedCount++;
                    }
                }
            }
            return unadjustedCount;
        }
        adjustRowNumbersFromLRI() {
            if (this.detectionResultColumns[0] == null) return 0;
            let unadjustedCount = 0;
            let codewords = this.detectionResultColumns[0].getCodewords();
            for(let codewordsRow /*int*/  = 0; codewordsRow < codewords.length; codewordsRow++){
                if (codewords[codewordsRow] == null) continue;
                let rowIndicatorRowNumber = codewords[codewordsRow].getRowNumber();
                let invalidRowCounts = 0;
                for(let barcodeColumn /*int*/  = 1; barcodeColumn < this.barcodeColumnCount + 1 && invalidRowCounts < this.ADJUST_ROW_NUMBER_SKIP; barcodeColumn++){
                    let codeword = this.detectionResultColumns[barcodeColumn].getCodewords()[codewordsRow];
                    if (codeword != null) {
                        invalidRowCounts = DetectionResult.adjustRowNumberIfValid(rowIndicatorRowNumber, invalidRowCounts, codeword);
                        if (!codeword.hasValidRowNumber()) unadjustedCount++;
                    }
                }
            }
            return unadjustedCount;
        }
        static adjustRowNumberIfValid(rowIndicatorRowNumber, invalidRowCounts, codeword) {
            if (codeword == null) return invalidRowCounts;
            if (!codeword.hasValidRowNumber()) {
                if (codeword.isValidRowNumber(rowIndicatorRowNumber)) {
                    codeword.setRowNumber(rowIndicatorRowNumber);
                    invalidRowCounts = 0;
                } else ++invalidRowCounts;
            }
            return invalidRowCounts;
        }
        adjustRowNumbers(barcodeColumn, codewordsRow, codewords) {
            if (!this.detectionResultColumns[barcodeColumn - 1]) return;
            let codeword = codewords[codewordsRow];
            let previousColumnCodewords = this.detectionResultColumns[barcodeColumn - 1].getCodewords();
            let nextColumnCodewords = previousColumnCodewords;
            if (this.detectionResultColumns[barcodeColumn + 1] != null) nextColumnCodewords = this.detectionResultColumns[barcodeColumn + 1].getCodewords();
            // let otherCodewords: Codeword[] = new Codeword[14];
            let otherCodewords = new Array(14);
            otherCodewords[2] = previousColumnCodewords[codewordsRow];
            otherCodewords[3] = nextColumnCodewords[codewordsRow];
            if (codewordsRow > 0) {
                otherCodewords[0] = codewords[codewordsRow - 1];
                otherCodewords[4] = previousColumnCodewords[codewordsRow - 1];
                otherCodewords[5] = nextColumnCodewords[codewordsRow - 1];
            }
            if (codewordsRow > 1) {
                otherCodewords[8] = codewords[codewordsRow - 2];
                otherCodewords[10] = previousColumnCodewords[codewordsRow - 2];
                otherCodewords[11] = nextColumnCodewords[codewordsRow - 2];
            }
            if (codewordsRow < codewords.length - 1) {
                otherCodewords[1] = codewords[codewordsRow + 1];
                otherCodewords[6] = previousColumnCodewords[codewordsRow + 1];
                otherCodewords[7] = nextColumnCodewords[codewordsRow + 1];
            }
            if (codewordsRow < codewords.length - 2) {
                otherCodewords[9] = codewords[codewordsRow + 2];
                otherCodewords[12] = previousColumnCodewords[codewordsRow + 2];
                otherCodewords[13] = nextColumnCodewords[codewordsRow + 2];
            }
            for (let otherCodeword of otherCodewords){
                if (DetectionResult.adjustRowNumber(codeword, otherCodeword)) return;
            }
        }
        /**
         * @return true, if row number was adjusted, false otherwise
         */ static adjustRowNumber(codeword, otherCodeword) {
            if (otherCodeword == null) return false;
            if (otherCodeword.hasValidRowNumber() && otherCodeword.getBucket() === codeword.getBucket()) {
                codeword.setRowNumber(otherCodeword.getRowNumber());
                return true;
            }
            return false;
        }
        getBarcodeColumnCount() {
            return this.barcodeColumnCount;
        }
        getBarcodeRowCount() {
            return this.barcodeMetadata.getRowCount();
        }
        getBarcodeECLevel() {
            return this.barcodeMetadata.getErrorCorrectionLevel();
        }
        setBoundingBox(boundingBox) {
            this.boundingBox = boundingBox;
        }
        getBoundingBox() {
            return this.boundingBox;
        }
        setDetectionResultColumn(barcodeColumn, detectionResultColumn) {
            this.detectionResultColumns[barcodeColumn] = detectionResultColumn;
        }
        getDetectionResultColumn(barcodeColumn) {
            return this.detectionResultColumns[barcodeColumn];
        }
        // @Override
        toString() {
            let rowIndicatorColumn = this.detectionResultColumns[0];
            if (rowIndicatorColumn == null) rowIndicatorColumn = this.detectionResultColumns[this.barcodeColumnCount + 1];
            // try (
            let formatter = new Formatter();
            // ) {
            for(let codewordsRow /*int*/  = 0; codewordsRow < rowIndicatorColumn.getCodewords().length; codewordsRow++){
                formatter.format('CW %3d:', codewordsRow);
                for(let barcodeColumn /*int*/  = 0; barcodeColumn < this.barcodeColumnCount + 2; barcodeColumn++){
                    if (this.detectionResultColumns[barcodeColumn] == null) {
                        formatter.format('    |   ');
                        continue;
                    }
                    let codeword = this.detectionResultColumns[barcodeColumn].getCodewords()[codewordsRow];
                    if (codeword == null) {
                        formatter.format('    |   ');
                        continue;
                    }
                    formatter.format(' %3d|%3d', codeword.getRowNumber(), codeword.getValue());
                }
                formatter.format('%n');
            }
            return formatter.toString();
        // }
        }
    }
    /*
     * Copyright 2013 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ // package com.google.zxing.pdf417.decoder;
    /**
     * @author Guenther Grau
     */ /*final*/ class Codeword {
        constructor(startX, endX, bucket, value){
            this.rowNumber = Codeword.BARCODE_ROW_UNKNOWN;
            this.startX = Math.trunc(startX);
            this.endX = Math.trunc(endX);
            this.bucket = Math.trunc(bucket);
            this.value = Math.trunc(value);
        }
        hasValidRowNumber() {
            return this.isValidRowNumber(this.rowNumber);
        }
        isValidRowNumber(rowNumber) {
            return rowNumber !== Codeword.BARCODE_ROW_UNKNOWN && this.bucket === rowNumber % 3 * 3;
        }
        setRowNumberAsRowIndicatorColumn() {
            this.rowNumber = Math.trunc(Math.trunc(this.value / 30) * 3 + Math.trunc(this.bucket / 3));
        }
        getWidth() {
            return this.endX - this.startX;
        }
        getStartX() {
            return this.startX;
        }
        getEndX() {
            return this.endX;
        }
        getBucket() {
            return this.bucket;
        }
        getValue() {
            return this.value;
        }
        getRowNumber() {
            return this.rowNumber;
        }
        setRowNumber(rowNumber) {
            this.rowNumber = rowNumber;
        }
        //   @Override
        toString() {
            return this.rowNumber + '|' + this.value;
        }
    }
    Codeword.BARCODE_ROW_UNKNOWN = -1;
    /*
    * Copyright 2013 ZXing authors
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    *      http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    */ /**
     * @author Guenther Grau
     * @author creatale GmbH (christoph.schulz@creatale.de)
     */ /*final*/ class PDF417CodewordDecoder {
        /* @note
         * this action have to be performed before first use of class
         * - static constructor
         * working with 32bit float (based from Java logic)
        */ static initialize() {
            // Pre-computes the symbol ratio table.
            for(/*int*/ let i = 0; i < PDF417Common.SYMBOL_TABLE.length; i++){
                let currentSymbol = PDF417Common.SYMBOL_TABLE[i];
                let currentBit = currentSymbol & 0x1;
                for(/*int*/ let j = 0; j < PDF417Common.BARS_IN_MODULE; j++){
                    let size = 0.0;
                    while((currentSymbol & 0x1) === currentBit){
                        size += 1.0;
                        currentSymbol >>= 1;
                    }
                    currentBit = currentSymbol & 0x1;
                    if (!PDF417CodewordDecoder.RATIOS_TABLE[i]) PDF417CodewordDecoder.RATIOS_TABLE[i] = new Array(PDF417Common.BARS_IN_MODULE);
                    PDF417CodewordDecoder.RATIOS_TABLE[i][PDF417Common.BARS_IN_MODULE - j - 1] = Math.fround(size / PDF417Common.MODULES_IN_CODEWORD);
                }
            }
            this.bSymbolTableReady = true;
        }
        static getDecodedValue(moduleBitCount) {
            let decodedValue = PDF417CodewordDecoder.getDecodedCodewordValue(PDF417CodewordDecoder.sampleBitCounts(moduleBitCount));
            if (decodedValue !== -1) return decodedValue;
            return PDF417CodewordDecoder.getClosestDecodedValue(moduleBitCount);
        }
        static sampleBitCounts(moduleBitCount) {
            let bitCountSum = MathUtils.sum(moduleBitCount);
            let result = new Int32Array(PDF417Common.BARS_IN_MODULE);
            let bitCountIndex = 0;
            let sumPreviousBits = 0;
            for(/*int*/ let i = 0; i < PDF417Common.MODULES_IN_CODEWORD; i++){
                let sampleIndex = bitCountSum / (2 * PDF417Common.MODULES_IN_CODEWORD) + i * bitCountSum / PDF417Common.MODULES_IN_CODEWORD;
                if (sumPreviousBits + moduleBitCount[bitCountIndex] <= sampleIndex) {
                    sumPreviousBits += moduleBitCount[bitCountIndex];
                    bitCountIndex++;
                }
                result[bitCountIndex]++;
            }
            return result;
        }
        static getDecodedCodewordValue(moduleBitCount) {
            let decodedValue = PDF417CodewordDecoder.getBitValue(moduleBitCount);
            return PDF417Common.getCodeword(decodedValue) === -1 ? -1 : decodedValue;
        }
        static getBitValue(moduleBitCount) {
            let result = /*long*/ 0;
            for(let /*int*/ i = 0; i < moduleBitCount.length; i++)for(/*int*/ let bit = 0; bit < moduleBitCount[i]; bit++)result = result << 1 | (i % 2 === 0 ? 1 : 0);
            return Math.trunc(result);
        }
        // working with 32bit float (as in Java)
        static getClosestDecodedValue(moduleBitCount) {
            let bitCountSum = MathUtils.sum(moduleBitCount);
            let bitCountRatios = new Array(PDF417Common.BARS_IN_MODULE);
            if (bitCountSum > 1) for(let /*int*/ i = 0; i < bitCountRatios.length; i++)bitCountRatios[i] = Math.fround(moduleBitCount[i] / bitCountSum);
            let bestMatchError = Float.MAX_VALUE;
            let bestMatch = -1;
            if (!this.bSymbolTableReady) PDF417CodewordDecoder.initialize();
            for(/*int*/ let j = 0; j < PDF417CodewordDecoder.RATIOS_TABLE.length; j++){
                let error = 0.0;
                let ratioTableRow = PDF417CodewordDecoder.RATIOS_TABLE[j];
                for(/*int*/ let k = 0; k < PDF417Common.BARS_IN_MODULE; k++){
                    let diff = Math.fround(ratioTableRow[k] - bitCountRatios[k]);
                    error += Math.fround(diff * diff);
                    if (error >= bestMatchError) break;
                }
                if (error < bestMatchError) {
                    bestMatchError = error;
                    bestMatch = PDF417Common.SYMBOL_TABLE[j];
                }
            }
            return bestMatch;
        }
    }
    // flag that the table is ready for use
    PDF417CodewordDecoder.bSymbolTableReady = false;
    PDF417CodewordDecoder.RATIOS_TABLE = new Array(PDF417Common.SYMBOL_TABLE.length).map((x)=>x = new Array(PDF417Common.BARS_IN_MODULE));
    /*
     * Copyright 2013 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ // package com.google.zxing.pdf417;
    /**
     * @author Guenther Grau
     */ /*public final*/ class PDF417ResultMetadata {
        constructor(){
            this.segmentCount = -1;
            this.fileSize = -1;
            this.timestamp = -1;
            this.checksum = -1;
        }
        /**
         * The Segment ID represents the segment of the whole file distributed over different symbols.
         *
         * @return File segment index
         */ getSegmentIndex() {
            return this.segmentIndex;
        }
        setSegmentIndex(segmentIndex) {
            this.segmentIndex = segmentIndex;
        }
        /**
         * Is the same for each related PDF417 symbol
         *
         * @return File ID
         */ getFileId() {
            return this.fileId;
        }
        setFileId(fileId) {
            this.fileId = fileId;
        }
        /**
         * @return always null
         * @deprecated use dedicated already parsed fields
         */ //   @Deprecated
        getOptionalData() {
            return this.optionalData;
        }
        /**
         * @param optionalData old optional data format as int array
         * @deprecated parse and use new fields
         */ //   @Deprecated
        setOptionalData(optionalData) {
            this.optionalData = optionalData;
        }
        /**
         * @return true if it is the last segment
         */ isLastSegment() {
            return this.lastSegment;
        }
        setLastSegment(lastSegment) {
            this.lastSegment = lastSegment;
        }
        /**
         * @return count of segments, -1 if not set
         */ getSegmentCount() {
            return this.segmentCount;
        }
        setSegmentCount(segmentCount /*int*/ ) {
            this.segmentCount = segmentCount;
        }
        getSender() {
            return this.sender || null;
        }
        setSender(sender) {
            this.sender = sender;
        }
        getAddressee() {
            return this.addressee || null;
        }
        setAddressee(addressee) {
            this.addressee = addressee;
        }
        /**
         * Filename of the encoded file
         *
         * @return filename
         */ getFileName() {
            return this.fileName;
        }
        setFileName(fileName) {
            this.fileName = fileName;
        }
        /**
         * filesize in bytes of the encoded file
         *
         * @return filesize in bytes, -1 if not set
         */ getFileSize() {
            return this.fileSize;
        }
        setFileSize(fileSize /*long*/ ) {
            this.fileSize = fileSize;
        }
        /**
         * 16-bit CRC checksum using CCITT-16
         *
         * @return crc checksum, -1 if not set
         */ getChecksum() {
            return this.checksum;
        }
        setChecksum(checksum /*int*/ ) {
            this.checksum = checksum;
        }
        /**
         * unix epock timestamp, elapsed seconds since 1970-01-01
         *
         * @return elapsed seconds, -1 if not set
         */ getTimestamp() {
            return this.timestamp;
        }
        setTimestamp(timestamp /*long*/ ) {
            this.timestamp = timestamp;
        }
    }
    /**
     * Ponyfill for Java's Long class.
     */ class Long {
        /**
         * Parses a string to a number, since JS has no really Int64.
         *
         * @param num Numeric string.
         * @param radix Destination radix.
         */ static parseLong(num, radix) {
            return parseInt(num, radix);
        }
    }
    /**
     * Custom Error class of type Exception.
     */ class NullPointerException extends Exception {
    }
    NullPointerException.kind = 'NullPointerException';
    /*
     * Copyright (c) 1994, 2004, Oracle and/or its affiliates. All rights reserved.
     * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
     *
     * This code is free software; you can redistribute it and/or modify it
     * under the terms of the GNU General Public License version 2 only, as
     * published by the Free Software Foundation.  Oracle designates this
     * particular file as subject to the "Classpath" exception as provided
     * by Oracle in the LICENSE file that accompanied this code.
     *
     * This code is distributed in the hope that it will be useful, but WITHOUT
     * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or
     * FITNESS FOR A PARTICULAR PURPOSE.  See the GNU General Public License
     * version 2 for more details (a copy is included in the LICENSE file that
     * accompanied this code).
     *
     * You should have received a copy of the GNU General Public License version
     * 2 along with this work; if not, write to the Free Software Foundation,
     * Inc., 51 Franklin St, Fifth Floor, Boston, MA 02110-1301 USA.
     *
     * Please contact Oracle, 500 Oracle Parkway, Redwood Shores, CA 94065 USA
     * or visit www.oracle.com if you need additional information or have any
     * questions.
     */ // package java.io;
    /**
     * This abstract class is the superclass of all classes representing
     * an output stream of bytes. An output stream accepts output bytes
     * and sends them to some sink.
     * <p>
     * Applications that need to define a subclass of
     * <code>OutputStream</code> must always provide at least a method
     * that writes one byte of output.
     *
     * @author  Arthur van Hoff
     * @see     java.io.BufferedOutputStream
     * @see     java.io.ByteArrayOutputStream
     * @see     java.io.DataOutputStream
     * @see     java.io.FilterOutputStream
     * @see     java.io.InputStream
     * @see     java.io.OutputStream#write(int)
     * @since   JDK1.0
     */ /*public*/ class OutputStream {
        /**
         * Writes <code>b.length</code> bytes from the specified byte array
         * to this output stream. The general contract for <code>write(b)</code>
         * is that it should have exactly the same effect as the call
         * <code>write(b, 0, b.length)</code>.
         *
         * @param      b   the data.
         * @exception  IOException  if an I/O error occurs.
         * @see        java.io.OutputStream#write(byte[], int, int)
         */ writeBytes(b) {
            this.writeBytesOffset(b, 0, b.length);
        }
        /**
         * Writes <code>len</code> bytes from the specified byte array
         * starting at offset <code>off</code> to this output stream.
         * The general contract for <code>write(b, off, len)</code> is that
         * some of the bytes in the array <code>b</code> are written to the
         * output stream in order; element <code>b[off]</code> is the first
         * byte written and <code>b[off+len-1]</code> is the last byte written
         * by this operation.
         * <p>
         * The <code>write</code> method of <code>OutputStream</code> calls
         * the write method of one argument on each of the bytes to be
         * written out. Subclasses are encouraged to override this method and
         * provide a more efficient implementation.
         * <p>
         * If <code>b</code> is <code>null</code>, a
         * <code>NullPointerException</code> is thrown.
         * <p>
         * If <code>off</code> is negative, or <code>len</code> is negative, or
         * <code>off+len</code> is greater than the length of the array
         * <code>b</code>, then an <tt>IndexOutOfBoundsException</tt> is thrown.
         *
         * @param      b     the data.
         * @param      off   the start offset in the data.
         * @param      len   the number of bytes to write.
         * @exception  IOException  if an I/O error occurs. In particular,
         *             an <code>IOException</code> is thrown if the output
         *             stream is closed.
         */ writeBytesOffset(b, off, len) {
            if (b == null) throw new NullPointerException();
            else if (off < 0 || off > b.length || len < 0 || off + len > b.length || off + len < 0) throw new IndexOutOfBoundsException();
            else if (len === 0) return;
            for(let i = 0; i < len; i++)this.write(b[off + i]);
        }
        /**
         * Flushes this output stream and forces any buffered output bytes
         * to be written out. The general contract of <code>flush</code> is
         * that calling it is an indication that, if any bytes previously
         * written have been buffered by the implementation of the output
         * stream, such bytes should immediately be written to their
         * intended destination.
         * <p>
         * If the intended destination of this stream is an abstraction provided by
         * the underlying operating system, for example a file, then flushing the
         * stream guarantees only that bytes previously written to the stream are
         * passed to the operating system for writing; it does not guarantee that
         * they are actually written to a physical device such as a disk drive.
         * <p>
         * The <code>flush</code> method of <code>OutputStream</code> does nothing.
         *
         * @exception  IOException  if an I/O error occurs.
         */ flush() {}
        /**
         * Closes this output stream and releases any system resources
         * associated with this stream. The general contract of <code>close</code>
         * is that it closes the output stream. A closed stream cannot perform
         * output operations and cannot be reopened.
         * <p>
         * The <code>close</code> method of <code>OutputStream</code> does nothing.
         *
         * @exception  IOException  if an I/O error occurs.
         */ close() {}
    }
    /**
     * Custom Error class of type Exception.
     */ class OutOfMemoryError extends Exception {
    }
    /*
     * Copyright (c) 1994, 2010, Oracle and/or its affiliates. All rights reserved.
     * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
     *
     * This code is free software; you can redistribute it and/or modify it
     * under the terms of the GNU General Public License version 2 only, as
     * published by the Free Software Foundation.  Oracle designates this
     * particular file as subject to the "Classpath" exception as provided
     * by Oracle in the LICENSE file that accompanied this code.
     *
     * This code is distributed in the hope that it will be useful, but WITHOUT
     * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or
     * FITNESS FOR A PARTICULAR PURPOSE.  See the GNU General Public License
     * version 2 for more details (a copy is included in the LICENSE file that
     * accompanied this code).
     *
     * You should have received a copy of the GNU General Public License version
     * 2 along with this work; if not, write to the Free Software Foundation,
     * Inc., 51 Franklin St, Fifth Floor, Boston, MA 02110-1301 USA.
     *
     * Please contact Oracle, 500 Oracle Parkway, Redwood Shores, CA 94065 USA
     * or visit www.oracle.com if you need additional information or have any
     * questions.
     */ /**
     * This class implements an output stream in which the data is
     * written into a byte array. The buffer automatically grows as data
     * is written to it.
     * The data can be retrieved using <code>toByteArray()</code> and
     * <code>toString()</code>.
     * <p>
     * Closing a <tt>ByteArrayOutputStream</tt> has no effect. The methods in
     * this class can be called after the stream has been closed without
     * generating an <tt>IOException</tt>.
     *
     * @author  Arthur van Hoff
     * @since   JDK1.0
     */ /*public*/ class ByteArrayOutputStream extends OutputStream {
        /**
         * Creates a new byte array output stream. The buffer capacity is
         * initially 32 bytes, though its size increases if necessary.
         */ // public constructor() {
        //     this(32);
        // }
        /**
         * Creates a new byte array output stream, with a buffer capacity of
         * the specified size, in bytes.
         *
         * @param   size   the initial size.
         * @exception  IllegalArgumentException if size is negative.
         */ constructor(size = 32){
            super();
            /**
             * The number of valid bytes in the buffer.
             */ this.count = 0;
            if (size < 0) throw new IllegalArgumentException('Negative initial size: ' + size);
            this.buf = new Uint8Array(size);
        }
        /**
         * Increases the capacity if necessary to ensure that it can hold
         * at least the number of elements specified by the minimum
         * capacity argument.
         *
         * @param minCapacity the desired minimum capacity
         * @throws OutOfMemoryError if {@code minCapacity < 0}.  This is
         * interpreted as a request for the unsatisfiably large capacity
         * {@code (long) Integer.MAX_VALUE + (minCapacity - Integer.MAX_VALUE)}.
         */ ensureCapacity(minCapacity) {
            // overflow-conscious code
            if (minCapacity - this.buf.length > 0) this.grow(minCapacity);
        }
        /**
         * Increases the capacity to ensure that it can hold at least the
         * number of elements specified by the minimum capacity argument.
         *
         * @param minCapacity the desired minimum capacity
         */ grow(minCapacity) {
            // overflow-conscious code
            let oldCapacity = this.buf.length;
            let newCapacity = oldCapacity << 1;
            if (newCapacity - minCapacity < 0) newCapacity = minCapacity;
            if (newCapacity < 0) {
                if (minCapacity < 0) throw new OutOfMemoryError();
                newCapacity = Integer.MAX_VALUE;
            }
            this.buf = Arrays.copyOfUint8Array(this.buf, newCapacity);
        }
        /**
         * Writes the specified byte to this byte array output stream.
         *
         * @param   b   the byte to be written.
         */ write(b) {
            this.ensureCapacity(this.count + 1);
            this.buf[this.count] = /*(byte)*/ b;
            this.count += 1;
        }
        /**
         * Writes <code>len</code> bytes from the specified byte array
         * starting at offset <code>off</code> to this byte array output stream.
         *
         * @param   b     the data.
         * @param   off   the start offset in the data.
         * @param   len   the number of bytes to write.
         */ writeBytesOffset(b, off, len) {
            if (off < 0 || off > b.length || len < 0 || off + len - b.length > 0) throw new IndexOutOfBoundsException();
            this.ensureCapacity(this.count + len);
            System.arraycopy(b, off, this.buf, this.count, len);
            this.count += len;
        }
        /**
         * Writes the complete contents of this byte array output stream to
         * the specified output stream argument, as if by calling the output
         * stream's write method using <code>out.write(buf, 0, count)</code>.
         *
         * @param      out   the output stream to which to write the data.
         * @exception  IOException  if an I/O error occurs.
         */ writeTo(out) {
            out.writeBytesOffset(this.buf, 0, this.count);
        }
        /**
         * Resets the <code>count</code> field of this byte array output
         * stream to zero, so that all currently accumulated output in the
         * output stream is discarded. The output stream can be used again,
         * reusing the already allocated buffer space.
         *
         * @see     java.io.ByteArrayInputStream#count
         */ reset() {
            this.count = 0;
        }
        /**
         * Creates a newly allocated byte array. Its size is the current
         * size of this output stream and the valid contents of the buffer
         * have been copied into it.
         *
         * @return  the current contents of this output stream, as a byte array.
         * @see     java.io.ByteArrayOutputStream#size()
         */ toByteArray() {
            return Arrays.copyOfUint8Array(this.buf, this.count);
        }
        /**
         * Returns the current size of the buffer.
         *
         * @return  the value of the <code>count</code> field, which is the number
         *          of valid bytes in this output stream.
         * @see     java.io.ByteArrayOutputStream#count
         */ size() {
            return this.count;
        }
        toString(param) {
            if (!param) return this.toString_void();
            if (typeof param === 'string') return this.toString_string(param);
            return this.toString_number(param);
        }
        /**
         * Converts the buffer's contents into a string decoding bytes using the
         * platform's default character set. The length of the new <tt>String</tt>
         * is a function of the character set, and hence may not be equal to the
         * size of the buffer.
         *
         * <p> This method always replaces malformed-input and unmappable-character
         * sequences with the default replacement string for the platform's
         * default character set. The {@linkplain java.nio.charset.CharsetDecoder}
         * class should be used when more control over the decoding process is
         * required.
         *
         * @return String decoded from the buffer's contents.
         * @since  JDK1.1
         */ toString_void() {
            return new String(this.buf /*, 0, this.count*/ ).toString();
        }
        /**
         * Converts the buffer's contents into a string by decoding the bytes using
         * the specified {@link java.nio.charset.Charset charsetName}. The length of
         * the new <tt>String</tt> is a function of the charset, and hence may not be
         * equal to the length of the byte array.
         *
         * <p> This method always replaces malformed-input and unmappable-character
         * sequences with this charset's default replacement string. The {@link
         * java.nio.charset.CharsetDecoder} class should be used when more control
         * over the decoding process is required.
         *
         * @param  charsetName  the name of a supported
         *              {@linkplain java.nio.charset.Charset </code>charset<code>}
         * @return String decoded from the buffer's contents.
         * @exception  UnsupportedEncodingException
         *             If the named charset is not supported
         * @since   JDK1.1
         */ toString_string(charsetName) {
            return new String(this.buf /*, 0, this.count, charsetName*/ ).toString();
        }
        /**
         * Creates a newly allocated string. Its size is the current size of
         * the output stream and the valid contents of the buffer have been
         * copied into it. Each character <i>c</i> in the resulting string is
         * constructed from the corresponding element <i>b</i> in the byte
         * array such that:
         * <blockquote><pre>
         *     c == (char)(((hibyte &amp; 0xff) &lt;&lt; 8) | (b &amp; 0xff))
         * </pre></blockquote>
         *
         * @deprecated This method does not properly convert bytes into characters.
         * As of JDK&nbsp;1.1, the preferred way to do this is via the
         * <code>toString(String enc)</code> method, which takes an encoding-name
         * argument, or the <code>toString()</code> method, which uses the
         * platform's default character encoding.
         *
         * @param      hibyte    the high byte of each resulting Unicode character.
         * @return     the current contents of the output stream, as a string.
         * @see        java.io.ByteArrayOutputStream#size()
         * @see        java.io.ByteArrayOutputStream#toString(String)
         * @see        java.io.ByteArrayOutputStream#toString()
         */ // @Deprecated
        toString_number(hibyte) {
            return new String(this.buf /*, hibyte, 0, this.count*/ ).toString();
        }
        /**
         * Closing a <tt>ByteArrayOutputStream</tt> has no effect. The methods in
         * this class can be called after the stream has been closed without
         * generating an <tt>IOException</tt>.
         * <p>
         *
         * @throws IOException
         */ close() {}
    }
    /*
     * Copyright 2009 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /*private*/ var Mode$2;
    (function(Mode) {
        Mode[Mode["ALPHA"] = 0] = "ALPHA";
        Mode[Mode["LOWER"] = 1] = "LOWER";
        Mode[Mode["MIXED"] = 2] = "MIXED";
        Mode[Mode["PUNCT"] = 3] = "PUNCT";
        Mode[Mode["ALPHA_SHIFT"] = 4] = "ALPHA_SHIFT";
        Mode[Mode["PUNCT_SHIFT"] = 5] = "PUNCT_SHIFT";
    })(Mode$2 || (Mode$2 = {}));
    /**
     * Indirectly access the global BigInt constructor, it
     * allows browsers that doesn't support BigInt to run
     * the library without breaking due to "undefined BigInt"
     * errors.
     */ function getBigIntConstructor() {
        if (typeof window !== 'undefined') return window['BigInt'] || null;
        if (typeof $parcel$global !== 'undefined') return $parcel$global['BigInt'] || null;
        if (typeof self !== 'undefined') return self['BigInt'] || null;
        throw new Error('Can\'t search globals for BigInt!');
    }
    /**
     * Used to store the BigInt constructor.
     */ let BigInteger;
    /**
     * This function creates a bigint value. It allows browsers
     * that doesn't support BigInt to run the rest of the library
     * by not directly accessing the BigInt constructor.
     */ function createBigInt(num) {
        if (typeof BigInteger === 'undefined') BigInteger = getBigIntConstructor();
        if (BigInteger === null) throw new Error('BigInt is not supported!');
        return BigInteger(num);
    }
    function getEXP900() {
        // in Java - array with length = 16
        let EXP900 = [];
        EXP900[0] = createBigInt(1);
        let nineHundred = createBigInt(900);
        EXP900[1] = nineHundred;
        // in Java - array with length = 16
        for(let i /*int*/  = 2; i < 16; i++)EXP900[i] = EXP900[i - 1] * nineHundred;
        return EXP900;
    }
    /**
     * <p>This class contains the methods for decoding the PDF417 codewords.</p>
     *
     * @author SITA Lab (kevin.osullivan@sita.aero)
     * @author Guenther Grau
     */ /*final*/ class DecodedBitStreamParser$2 {
        //   private DecodedBitStreamParser() {
        // }
        /**
         *
         * @param codewords
         * @param ecLevel
         *
         * @throws FormatException
         */ static decode(codewords, ecLevel) {
            // pass encoding to result (will be used for decode symbols in byte mode)
            let result = new StringBuilder('');
            // let encoding: Charset = StandardCharsets.ISO_8859_1;
            let encoding = CharacterSetECI.ISO8859_1;
            /**
             * @note the next command is specific from this TypeScript library
             * because TS can't properly cast some values to char and
             * convert it to string later correctly due to encoding
             * differences from Java version. As reported here:
             * https://github.com/zxing-js/library/pull/264/files#r382831593
             */ result.enableDecoding(encoding);
            // Get compaction mode
            let codeIndex = 1;
            let code = codewords[codeIndex++];
            let resultMetadata = new PDF417ResultMetadata();
            while(codeIndex < codewords[0]){
                switch(code){
                    case DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH:
                        codeIndex = DecodedBitStreamParser$2.textCompaction(codewords, codeIndex, result);
                        break;
                    case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH:
                    case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH_6:
                        codeIndex = DecodedBitStreamParser$2.byteCompaction(code, codewords, encoding, codeIndex, result);
                        break;
                    case DecodedBitStreamParser$2.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                        result.append(/*(char)*/ codewords[codeIndex++]);
                        break;
                    case DecodedBitStreamParser$2.NUMERIC_COMPACTION_MODE_LATCH:
                        codeIndex = DecodedBitStreamParser$2.numericCompaction(codewords, codeIndex, result);
                        break;
                    case DecodedBitStreamParser$2.ECI_CHARSET:
                        let charsetECI = CharacterSetECI.getCharacterSetECIByValue(codewords[codeIndex++]);
                        break;
                    case DecodedBitStreamParser$2.ECI_GENERAL_PURPOSE:
                        // Can't do anything with generic ECI; skip its 2 characters
                        codeIndex += 2;
                        break;
                    case DecodedBitStreamParser$2.ECI_USER_DEFINED:
                        // Can't do anything with user ECI; skip its 1 character
                        codeIndex++;
                        break;
                    case DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                        codeIndex = DecodedBitStreamParser$2.decodeMacroBlock(codewords, codeIndex, resultMetadata);
                        break;
                    case DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                    case DecodedBitStreamParser$2.MACRO_PDF417_TERMINATOR:
                        // Should not see these outside a macro block
                        throw new FormatException();
                    default:
                        // Default to text compaction. During testing numerous barcodes
                        // appeared to be missing the starting mode. In these cases defaulting
                        // to text compaction seems to work.
                        codeIndex--;
                        codeIndex = DecodedBitStreamParser$2.textCompaction(codewords, codeIndex, result);
                        break;
                }
                if (codeIndex < codewords.length) code = codewords[codeIndex++];
                else throw FormatException.getFormatInstance();
            }
            if (result.length() === 0) throw FormatException.getFormatInstance();
            let decoderResult = new DecoderResult(null, result.toString(), null, ecLevel);
            decoderResult.setOther(resultMetadata);
            return decoderResult;
        }
        /**
         *
         * @param int
         * @param param1
         * @param codewords
         * @param int
         * @param codeIndex
         * @param PDF417ResultMetadata
         * @param resultMetadata
         *
         * @throws FormatException
         */ // @SuppressWarnings("deprecation")
        static decodeMacroBlock(codewords, codeIndex, resultMetadata) {
            if (codeIndex + DecodedBitStreamParser$2.NUMBER_OF_SEQUENCE_CODEWORDS > codewords[0]) // we must have at least two bytes left for the segment index
            throw FormatException.getFormatInstance();
            let segmentIndexArray = new Int32Array(DecodedBitStreamParser$2.NUMBER_OF_SEQUENCE_CODEWORDS);
            for(let i /*int*/  = 0; i < DecodedBitStreamParser$2.NUMBER_OF_SEQUENCE_CODEWORDS; i++, codeIndex++)segmentIndexArray[i] = codewords[codeIndex];
            resultMetadata.setSegmentIndex(Integer.parseInt(DecodedBitStreamParser$2.decodeBase900toBase10(segmentIndexArray, DecodedBitStreamParser$2.NUMBER_OF_SEQUENCE_CODEWORDS)));
            let fileId = new StringBuilder();
            codeIndex = DecodedBitStreamParser$2.textCompaction(codewords, codeIndex, fileId);
            resultMetadata.setFileId(fileId.toString());
            let optionalFieldsStart = -1;
            if (codewords[codeIndex] === DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_OPTIONAL_FIELD) optionalFieldsStart = codeIndex + 1;
            while(codeIndex < codewords[0])switch(codewords[codeIndex]){
                case DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                    codeIndex++;
                    switch(codewords[codeIndex]){
                        case DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_FILE_NAME:
                            let fileName = new StringBuilder();
                            codeIndex = DecodedBitStreamParser$2.textCompaction(codewords, codeIndex + 1, fileName);
                            resultMetadata.setFileName(fileName.toString());
                            break;
                        case DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_SENDER:
                            let sender = new StringBuilder();
                            codeIndex = DecodedBitStreamParser$2.textCompaction(codewords, codeIndex + 1, sender);
                            resultMetadata.setSender(sender.toString());
                            break;
                        case DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_ADDRESSEE:
                            let addressee = new StringBuilder();
                            codeIndex = DecodedBitStreamParser$2.textCompaction(codewords, codeIndex + 1, addressee);
                            resultMetadata.setAddressee(addressee.toString());
                            break;
                        case DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_SEGMENT_COUNT:
                            let segmentCount = new StringBuilder();
                            codeIndex = DecodedBitStreamParser$2.numericCompaction(codewords, codeIndex + 1, segmentCount);
                            resultMetadata.setSegmentCount(Integer.parseInt(segmentCount.toString()));
                            break;
                        case DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_TIME_STAMP:
                            let timestamp = new StringBuilder();
                            codeIndex = DecodedBitStreamParser$2.numericCompaction(codewords, codeIndex + 1, timestamp);
                            resultMetadata.setTimestamp(Long.parseLong(timestamp.toString()));
                            break;
                        case DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_CHECKSUM:
                            let checksum = new StringBuilder();
                            codeIndex = DecodedBitStreamParser$2.numericCompaction(codewords, codeIndex + 1, checksum);
                            resultMetadata.setChecksum(Integer.parseInt(checksum.toString()));
                            break;
                        case DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_FILE_SIZE:
                            let fileSize = new StringBuilder();
                            codeIndex = DecodedBitStreamParser$2.numericCompaction(codewords, codeIndex + 1, fileSize);
                            resultMetadata.setFileSize(Long.parseLong(fileSize.toString()));
                            break;
                        default:
                            throw FormatException.getFormatInstance();
                    }
                    break;
                case DecodedBitStreamParser$2.MACRO_PDF417_TERMINATOR:
                    codeIndex++;
                    resultMetadata.setLastSegment(true);
                    break;
                default:
                    throw FormatException.getFormatInstance();
            }
            // copy optional fields to additional options
            if (optionalFieldsStart !== -1) {
                let optionalFieldsLength = codeIndex - optionalFieldsStart;
                if (resultMetadata.isLastSegment()) // do not include terminator
                optionalFieldsLength--;
                resultMetadata.setOptionalData(Arrays.copyOfRange(codewords, optionalFieldsStart, optionalFieldsStart + optionalFieldsLength));
            }
            return codeIndex;
        }
        /**
         * Text Compaction mode (see 5.4.1.5) permits all printable ASCII characters to be
         * encoded, i.e. values 32 - 126 inclusive in accordance with ISO/IEC 646 (IRV), as
         * well as selected control characters.
         *
         * @param codewords The array of codewords (data + error)
         * @param codeIndex The current index into the codeword array.
         * @param result    The decoded data is appended to the result.
         * @return The next index into the codeword array.
         */ static textCompaction(codewords, codeIndex, result) {
            // 2 character per codeword
            let textCompactionData = new Int32Array((codewords[0] - codeIndex) * 2);
            // Used to hold the byte compaction value if there is a mode shift
            let byteCompactionData = new Int32Array((codewords[0] - codeIndex) * 2);
            let index = 0;
            let end = false;
            while(codeIndex < codewords[0] && !end){
                let code = codewords[codeIndex++];
                if (code < DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH) {
                    textCompactionData[index] = code / 30;
                    textCompactionData[index + 1] = code % 30;
                    index += 2;
                } else switch(code){
                    case DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH:
                        // reinitialize text compaction mode to alpha sub mode
                        textCompactionData[index++] = DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH;
                        break;
                    case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH:
                    case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH_6:
                    case DecodedBitStreamParser$2.NUMERIC_COMPACTION_MODE_LATCH:
                    case DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                    case DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                    case DecodedBitStreamParser$2.MACRO_PDF417_TERMINATOR:
                        codeIndex--;
                        end = true;
                        break;
                    case DecodedBitStreamParser$2.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                        // The Mode Shift codeword 913 shall cause a temporary
                        // switch from Text Compaction mode to Byte Compaction mode.
                        // This switch shall be in effect for only the next codeword,
                        // after which the mode shall revert to the prevailing sub-mode
                        // of the Text Compaction mode. Codeword 913 is only available
                        // in Text Compaction mode; its use is described in 5.4.2.4.
                        textCompactionData[index] = DecodedBitStreamParser$2.MODE_SHIFT_TO_BYTE_COMPACTION_MODE;
                        code = codewords[codeIndex++];
                        byteCompactionData[index] = code;
                        index++;
                        break;
                }
            }
            DecodedBitStreamParser$2.decodeTextCompaction(textCompactionData, byteCompactionData, index, result);
            return codeIndex;
        }
        /**
         * The Text Compaction mode includes all the printable ASCII characters
         * (i.e. values from 32 to 126) and three ASCII control characters: HT or tab
         * (9: e), LF or line feed (10: e), and CR or carriage
         * return (13: e). The Text Compaction mode also includes various latch
         * and shift characters which are used exclusively within the mode. The Text
         * Compaction mode encodes up to 2 characters per codeword. The compaction rules
         * for converting data into PDF417 codewords are defined in 5.4.2.2. The sub-mode
         * switches are defined in 5.4.2.3.
         *
         * @param textCompactionData The text compaction data.
         * @param byteCompactionData The byte compaction data if there
         *                           was a mode shift.
         * @param length             The size of the text compaction and byte compaction data.
         * @param result             The decoded data is appended to the result.
         */ static decodeTextCompaction(textCompactionData, byteCompactionData, length, result) {
            // Beginning from an initial state of the Alpha sub-mode
            // The default compaction mode for PDF417 in effect at the start of each symbol shall always be Text
            // Compaction mode Alpha sub-mode (alphabetic: uppercase). A latch codeword from another mode to the Text
            // Compaction mode shall always switch to the Text Compaction Alpha sub-mode.
            let subMode = Mode$2.ALPHA;
            let priorToShiftMode = Mode$2.ALPHA;
            let i = 0;
            while(i < length){
                let subModeCh = textCompactionData[i];
                let ch = /*char*/ '';
                switch(subMode){
                    case Mode$2.ALPHA:
                        // Alpha (alphabetic: uppercase)
                        if (subModeCh < 26) // Upper case Alpha Character
                        // Note: 65 = 'A' ASCII -> there is byte code of symbol
                        ch = /*(char)('A' + subModeCh) */ String.fromCharCode(65 + subModeCh);
                        else switch(subModeCh){
                            case 26:
                                ch = ' ';
                                break;
                            case DecodedBitStreamParser$2.LL:
                                subMode = Mode$2.LOWER;
                                break;
                            case DecodedBitStreamParser$2.ML:
                                subMode = Mode$2.MIXED;
                                break;
                            case DecodedBitStreamParser$2.PS:
                                // Shift to punctuation
                                priorToShiftMode = subMode;
                                subMode = Mode$2.PUNCT_SHIFT;
                                break;
                            case DecodedBitStreamParser$2.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                                result.append(/*(char)*/ byteCompactionData[i]);
                                break;
                            case DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH:
                                subMode = Mode$2.ALPHA;
                                break;
                        }
                        break;
                    case Mode$2.LOWER:
                        // Lower (alphabetic: lowercase)
                        if (subModeCh < 26) ch = /*(char)('a' + subModeCh)*/ String.fromCharCode(97 + subModeCh);
                        else switch(subModeCh){
                            case 26:
                                ch = ' ';
                                break;
                            case DecodedBitStreamParser$2.AS:
                                // Shift to alpha
                                priorToShiftMode = subMode;
                                subMode = Mode$2.ALPHA_SHIFT;
                                break;
                            case DecodedBitStreamParser$2.ML:
                                subMode = Mode$2.MIXED;
                                break;
                            case DecodedBitStreamParser$2.PS:
                                // Shift to punctuation
                                priorToShiftMode = subMode;
                                subMode = Mode$2.PUNCT_SHIFT;
                                break;
                            case DecodedBitStreamParser$2.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                                // TODO Does this need to use the current character encoding? See other occurrences below
                                result.append(/*(char)*/ byteCompactionData[i]);
                                break;
                            case DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH:
                                subMode = Mode$2.ALPHA;
                                break;
                        }
                        break;
                    case Mode$2.MIXED:
                        // Mixed (punctuation: e)
                        if (subModeCh < DecodedBitStreamParser$2.PL) ch = DecodedBitStreamParser$2.MIXED_CHARS[subModeCh];
                        else switch(subModeCh){
                            case DecodedBitStreamParser$2.PL:
                                subMode = Mode$2.PUNCT;
                                break;
                            case 26:
                                ch = ' ';
                                break;
                            case DecodedBitStreamParser$2.LL:
                                subMode = Mode$2.LOWER;
                                break;
                            case DecodedBitStreamParser$2.AL:
                                subMode = Mode$2.ALPHA;
                                break;
                            case DecodedBitStreamParser$2.PS:
                                // Shift to punctuation
                                priorToShiftMode = subMode;
                                subMode = Mode$2.PUNCT_SHIFT;
                                break;
                            case DecodedBitStreamParser$2.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                                result.append(/*(char)*/ byteCompactionData[i]);
                                break;
                            case DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH:
                                subMode = Mode$2.ALPHA;
                                break;
                        }
                        break;
                    case Mode$2.PUNCT:
                        // Punctuation
                        if (subModeCh < DecodedBitStreamParser$2.PAL) ch = DecodedBitStreamParser$2.PUNCT_CHARS[subModeCh];
                        else switch(subModeCh){
                            case DecodedBitStreamParser$2.PAL:
                                subMode = Mode$2.ALPHA;
                                break;
                            case DecodedBitStreamParser$2.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                                result.append(/*(char)*/ byteCompactionData[i]);
                                break;
                            case DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH:
                                subMode = Mode$2.ALPHA;
                                break;
                        }
                        break;
                    case Mode$2.ALPHA_SHIFT:
                        // Restore sub-mode
                        subMode = priorToShiftMode;
                        if (subModeCh < 26) ch = /*(char)('A' + subModeCh)*/ String.fromCharCode(65 + subModeCh);
                        else switch(subModeCh){
                            case 26:
                                ch = ' ';
                                break;
                            case DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH:
                                subMode = Mode$2.ALPHA;
                                break;
                        }
                        break;
                    case Mode$2.PUNCT_SHIFT:
                        // Restore sub-mode
                        subMode = priorToShiftMode;
                        if (subModeCh < DecodedBitStreamParser$2.PAL) ch = DecodedBitStreamParser$2.PUNCT_CHARS[subModeCh];
                        else switch(subModeCh){
                            case DecodedBitStreamParser$2.PAL:
                                subMode = Mode$2.ALPHA;
                                break;
                            case DecodedBitStreamParser$2.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                                // PS before Shift-to-Byte is used as a padding character,
                                // see 5.4.2.4 of the specification
                                result.append(/*(char)*/ byteCompactionData[i]);
                                break;
                            case DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH:
                                subMode = Mode$2.ALPHA;
                                break;
                        }
                        break;
                }
                // if (ch !== 0) {
                if (ch !== '') // Append decoded character to result
                result.append(ch);
                i++;
            }
        }
        /**
         * Byte Compaction mode (see 5.4.3) permits all 256 possible 8-bit byte values to be encoded.
         * This includes all ASCII characters value 0 to 127 inclusive and provides for international
         * character set support.
         *
         * @param mode      The byte compaction mode i.e. 901 or 924
         * @param codewords The array of codewords (data + error)
         * @param encoding  Currently active character encoding
         * @param codeIndex The current index into the codeword array.
         * @param result    The decoded data is appended to the result.
         * @return The next index into the codeword array.
         */ static byteCompaction(mode, codewords, encoding, codeIndex, result) {
            let decodedBytes = new ByteArrayOutputStream();
            let count = 0;
            let value = /*long*/ 0;
            let end = false;
            switch(mode){
                case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH:
                    // Total number of Byte Compaction characters to be encoded
                    // is not a multiple of 6
                    let byteCompactedCodewords = new Int32Array(6);
                    let nextCode = codewords[codeIndex++];
                    while(codeIndex < codewords[0] && !end){
                        byteCompactedCodewords[count++] = nextCode;
                        // Base 900
                        value = 900 * value + nextCode;
                        nextCode = codewords[codeIndex++];
                        // perhaps it should be ok to check only nextCode >= TEXT_COMPACTION_MODE_LATCH
                        switch(nextCode){
                            case DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH:
                            case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH:
                            case DecodedBitStreamParser$2.NUMERIC_COMPACTION_MODE_LATCH:
                            case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH_6:
                            case DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                            case DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                            case DecodedBitStreamParser$2.MACRO_PDF417_TERMINATOR:
                                codeIndex--;
                                end = true;
                                break;
                            default:
                                if (count % 5 === 0 && count > 0) {
                                    // Decode every 5 codewords
                                    // Convert to Base 256
                                    for(let j /*int*/  = 0; j < 6; ++j)/* @note
                                         * JavaScript stores numbers as 64 bits floating point numbers, but all bitwise operations are performed on 32 bits binary numbers.
                                         * So the next bitwise operation could not be done with simple numbers
                                         */ decodedBytes.write(/*(byte)*/ Number(createBigInt(value) >> createBigInt(8 * (5 - j))));
                                    value = 0;
                                    count = 0;
                                }
                                break;
                        }
                    }
                    // if the end of all codewords is reached the last codeword needs to be added
                    if (codeIndex === codewords[0] && nextCode < DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH) byteCompactedCodewords[count++] = nextCode;
                    // If Byte Compaction mode is invoked with codeword 901,
                    // the last group of codewords is interpreted directly
                    // as one byte per codeword, without compaction.
                    for(let i /*int*/  = 0; i < count; i++)decodedBytes.write(/*(byte)*/ byteCompactedCodewords[i]);
                    break;
                case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH_6:
                    // Total number of Byte Compaction characters to be encoded
                    // is an integer multiple of 6
                    while(codeIndex < codewords[0] && !end){
                        let code = codewords[codeIndex++];
                        if (code < DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH) {
                            count++;
                            // Base 900
                            value = 900 * value + code;
                        } else switch(code){
                            case DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH:
                            case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH:
                            case DecodedBitStreamParser$2.NUMERIC_COMPACTION_MODE_LATCH:
                            case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH_6:
                            case DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                            case DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                            case DecodedBitStreamParser$2.MACRO_PDF417_TERMINATOR:
                                codeIndex--;
                                end = true;
                                break;
                        }
                        if (count % 5 === 0 && count > 0) {
                            // Decode every 5 codewords
                            // Convert to Base 256
                            /* @note
                             * JavaScript stores numbers as 64 bits floating point numbers, but all bitwise operations are performed on 32 bits binary numbers.
                             * So the next bitwise operation could not be done with simple numbers
                            */ for(let j /*int*/  = 0; j < 6; ++j)decodedBytes.write(/*(byte)*/ Number(createBigInt(value) >> createBigInt(8 * (5 - j))));
                            value = 0;
                            count = 0;
                        }
                    }
                    break;
            }
            result.append(StringEncoding.decode(decodedBytes.toByteArray(), encoding));
            return codeIndex;
        }
        /**
         * Numeric Compaction mode (see 5.4.4) permits efficient encoding of numeric data strings.
         *
         * @param codewords The array of codewords (data + error)
         * @param codeIndex The current index into the codeword array.
         * @param result    The decoded data is appended to the result.
         * @return The next index into the codeword array.
         *
         * @throws FormatException
         */ static numericCompaction(codewords, codeIndex /*int*/ , result) {
            let count = 0;
            let end = false;
            let numericCodewords = new Int32Array(DecodedBitStreamParser$2.MAX_NUMERIC_CODEWORDS);
            while(codeIndex < codewords[0] && !end){
                let code = codewords[codeIndex++];
                if (codeIndex === codewords[0]) end = true;
                if (code < DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH) {
                    numericCodewords[count] = code;
                    count++;
                } else switch(code){
                    case DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH:
                    case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH:
                    case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH_6:
                    case DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                    case DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                    case DecodedBitStreamParser$2.MACRO_PDF417_TERMINATOR:
                        codeIndex--;
                        end = true;
                        break;
                }
                if ((count % DecodedBitStreamParser$2.MAX_NUMERIC_CODEWORDS === 0 || code === DecodedBitStreamParser$2.NUMERIC_COMPACTION_MODE_LATCH || end) && count > 0) {
                    // Re-invoking Numeric Compaction mode (by using codeword 902
                    // while in Numeric Compaction mode) serves  to terminate the
                    // current Numeric Compaction mode grouping as described in 5.4.4.2,
                    // and then to start a new one grouping.
                    result.append(DecodedBitStreamParser$2.decodeBase900toBase10(numericCodewords, count));
                    count = 0;
                }
            }
            return codeIndex;
        }
        /**
         * Convert a list of Numeric Compacted codewords from Base 900 to Base 10.
         *
         * @param codewords The array of codewords
         * @param count     The number of codewords
         * @return The decoded string representing the Numeric data.
         *
         * EXAMPLE
         * Encode the fifteen digit numeric string 000213298174000
         * Prefix the numeric string with a 1 and set the initial value of
         * t = 1 000 213 298 174 000
         * Calculate codeword 0
         * d0 = 1 000 213 298 174 000 mod 900 = 200
         *
         * t = 1 000 213 298 174 000 div 900 = 1 111 348 109 082
         * Calculate codeword 1
         * d1 = 1 111 348 109 082 mod 900 = 282
         *
         * t = 1 111 348 109 082 div 900 = 1 234 831 232
         * Calculate codeword 2
         * d2 = 1 234 831 232 mod 900 = 632
         *
         * t = 1 234 831 232 div 900 = 1 372 034
         * Calculate codeword 3
         * d3 = 1 372 034 mod 900 = 434
         *
         * t = 1 372 034 div 900 = 1 524
         * Calculate codeword 4
         * d4 = 1 524 mod 900 = 624
         *
         * t = 1 524 div 900 = 1
         * Calculate codeword 5
         * d5 = 1 mod 900 = 1
         * t = 1 div 900 = 0
         * Codeword sequence is: 1, 624, 434, 632, 282, 200
         *
         * Decode the above codewords involves
         *   1 x 900 power of 5 + 624 x 900 power of 4 + 434 x 900 power of 3 +
         * 632 x 900 power of 2 + 282 x 900 power of 1 + 200 x 900 power of 0 = 1000213298174000
         *
         * Remove leading 1 =>  Result is 000213298174000
         *
         * @throws FormatException
         */ static decodeBase900toBase10(codewords, count) {
            let result = createBigInt(0);
            for(let i /*int*/  = 0; i < count; i++)result += DecodedBitStreamParser$2.EXP900[count - i - 1] * createBigInt(codewords[i]);
            let resultString = result.toString();
            if (resultString.charAt(0) !== '1') throw new FormatException();
            return resultString.substring(1);
        }
    }
    DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH = 900;
    DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH = 901;
    DecodedBitStreamParser$2.NUMERIC_COMPACTION_MODE_LATCH = 902;
    DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH_6 = 924;
    DecodedBitStreamParser$2.ECI_USER_DEFINED = 925;
    DecodedBitStreamParser$2.ECI_GENERAL_PURPOSE = 926;
    DecodedBitStreamParser$2.ECI_CHARSET = 927;
    DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_CONTROL_BLOCK = 928;
    DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_OPTIONAL_FIELD = 923;
    DecodedBitStreamParser$2.MACRO_PDF417_TERMINATOR = 922;
    DecodedBitStreamParser$2.MODE_SHIFT_TO_BYTE_COMPACTION_MODE = 913;
    DecodedBitStreamParser$2.MAX_NUMERIC_CODEWORDS = 15;
    DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_FILE_NAME = 0;
    DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_SEGMENT_COUNT = 1;
    DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_TIME_STAMP = 2;
    DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_SENDER = 3;
    DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_ADDRESSEE = 4;
    DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_FILE_SIZE = 5;
    DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_CHECKSUM = 6;
    DecodedBitStreamParser$2.PL = 25;
    DecodedBitStreamParser$2.LL = 27;
    DecodedBitStreamParser$2.AS = 27;
    DecodedBitStreamParser$2.ML = 28;
    DecodedBitStreamParser$2.AL = 28;
    DecodedBitStreamParser$2.PS = 29;
    DecodedBitStreamParser$2.PAL = 29;
    DecodedBitStreamParser$2.PUNCT_CHARS = ';<>@[\\]_`~!\r\t,:\n-.$/"|*()?{}\'';
    DecodedBitStreamParser$2.MIXED_CHARS = '0123456789&\r\t,:#-.$/+%*=^';
    /**
     * Table containing values for the exponent of 900.
     * This is used in the numeric compaction decode algorithm.
     */ DecodedBitStreamParser$2.EXP900 = getBigIntConstructor() ? getEXP900() : [];
    DecodedBitStreamParser$2.NUMBER_OF_SEQUENCE_CODEWORDS = 2;
    /*
    * Copyright 2013 ZXing authors
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    *      http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    */ // import java.util.ArrayList;
    // import java.util.Collection;
    // import java.util.Formatter;
    // import java.util.List;
    /**
     * @author Guenther Grau
     */ /*public final*/ class PDF417ScanningDecoder {
        constructor(){}
        /**
         * @TODO don't pass in minCodewordWidth and maxCodewordWidth, pass in barcode columns for start and stop pattern
         *
         * columns. That way width can be deducted from the pattern column.
         * This approach also allows to detect more details about the barcode, e.g. if a bar type (white or black) is wider
         * than it should be. This can happen if the scanner used a bad blackpoint.
         *
         * @param BitMatrix
         * @param image
         * @param ResultPoint
         * @param imageTopLeft
         * @param ResultPoint
         * @param imageBottomLeft
         * @param ResultPoint
         * @param imageTopRight
         * @param ResultPoint
         * @param imageBottomRight
         * @param int
         * @param minCodewordWidth
         * @param int
         * @param maxCodewordWidth
         *
         * @throws NotFoundException
         * @throws FormatException
         * @throws ChecksumException
         */ static decode(image, imageTopLeft, imageBottomLeft, imageTopRight, imageBottomRight, minCodewordWidth, maxCodewordWidth) {
            let boundingBox = new BoundingBox(image, imageTopLeft, imageBottomLeft, imageTopRight, imageBottomRight);
            let leftRowIndicatorColumn = null;
            let rightRowIndicatorColumn = null;
            let detectionResult;
            for(let firstPass /*boolean*/  = true;; firstPass = false){
                if (imageTopLeft != null) leftRowIndicatorColumn = PDF417ScanningDecoder.getRowIndicatorColumn(image, boundingBox, imageTopLeft, true, minCodewordWidth, maxCodewordWidth);
                if (imageTopRight != null) rightRowIndicatorColumn = PDF417ScanningDecoder.getRowIndicatorColumn(image, boundingBox, imageTopRight, false, minCodewordWidth, maxCodewordWidth);
                detectionResult = PDF417ScanningDecoder.merge(leftRowIndicatorColumn, rightRowIndicatorColumn);
                if (detectionResult == null) throw NotFoundException.getNotFoundInstance();
                let resultBox = detectionResult.getBoundingBox();
                if (firstPass && resultBox != null && (resultBox.getMinY() < boundingBox.getMinY() || resultBox.getMaxY() > boundingBox.getMaxY())) boundingBox = resultBox;
                else break;
            }
            detectionResult.setBoundingBox(boundingBox);
            let maxBarcodeColumn = detectionResult.getBarcodeColumnCount() + 1;
            detectionResult.setDetectionResultColumn(0, leftRowIndicatorColumn);
            detectionResult.setDetectionResultColumn(maxBarcodeColumn, rightRowIndicatorColumn);
            let leftToRight = leftRowIndicatorColumn != null;
            for(let barcodeColumnCount /*int*/  = 1; barcodeColumnCount <= maxBarcodeColumn; barcodeColumnCount++){
                let barcodeColumn = leftToRight ? barcodeColumnCount : maxBarcodeColumn - barcodeColumnCount;
                if (detectionResult.getDetectionResultColumn(barcodeColumn) !== /* null */ undefined) continue;
                let detectionResultColumn;
                if (barcodeColumn === 0 || barcodeColumn === maxBarcodeColumn) detectionResultColumn = new DetectionResultRowIndicatorColumn(boundingBox, barcodeColumn === 0);
                else detectionResultColumn = new DetectionResultColumn(boundingBox);
                detectionResult.setDetectionResultColumn(barcodeColumn, detectionResultColumn);
                let startColumn = -1;
                let previousStartColumn = startColumn;
                // TODO start at a row for which we know the start position, then detect upwards and downwards from there.
                for(let imageRow /*int*/  = boundingBox.getMinY(); imageRow <= boundingBox.getMaxY(); imageRow++){
                    startColumn = PDF417ScanningDecoder.getStartColumn(detectionResult, barcodeColumn, imageRow, leftToRight);
                    if (startColumn < 0 || startColumn > boundingBox.getMaxX()) {
                        if (previousStartColumn === -1) continue;
                        startColumn = previousStartColumn;
                    }
                    let codeword = PDF417ScanningDecoder.detectCodeword(image, boundingBox.getMinX(), boundingBox.getMaxX(), leftToRight, startColumn, imageRow, minCodewordWidth, maxCodewordWidth);
                    if (codeword != null) {
                        detectionResultColumn.setCodeword(imageRow, codeword);
                        previousStartColumn = startColumn;
                        minCodewordWidth = Math.min(minCodewordWidth, codeword.getWidth());
                        maxCodewordWidth = Math.max(maxCodewordWidth, codeword.getWidth());
                    }
                }
            }
            return PDF417ScanningDecoder.createDecoderResult(detectionResult);
        }
        /**
         *
         * @param leftRowIndicatorColumn
         * @param rightRowIndicatorColumn
         *
         * @throws NotFoundException
         */ static merge(leftRowIndicatorColumn, rightRowIndicatorColumn) {
            if (leftRowIndicatorColumn == null && rightRowIndicatorColumn == null) return null;
            let barcodeMetadata = PDF417ScanningDecoder.getBarcodeMetadata(leftRowIndicatorColumn, rightRowIndicatorColumn);
            if (barcodeMetadata == null) return null;
            let boundingBox = BoundingBox.merge(PDF417ScanningDecoder.adjustBoundingBox(leftRowIndicatorColumn), PDF417ScanningDecoder.adjustBoundingBox(rightRowIndicatorColumn));
            return new DetectionResult(barcodeMetadata, boundingBox);
        }
        /**
         *
         * @param rowIndicatorColumn
         *
         * @throws NotFoundException
         */ static adjustBoundingBox(rowIndicatorColumn) {
            if (rowIndicatorColumn == null) return null;
            let rowHeights = rowIndicatorColumn.getRowHeights();
            if (rowHeights == null) return null;
            let maxRowHeight = PDF417ScanningDecoder.getMax(rowHeights);
            let missingStartRows = 0;
            for (let rowHeight /*int*/  of rowHeights){
                missingStartRows += maxRowHeight - rowHeight;
                if (rowHeight > 0) break;
            }
            let codewords = rowIndicatorColumn.getCodewords();
            for(let row /*int*/  = 0; missingStartRows > 0 && codewords[row] == null; row++)missingStartRows--;
            let missingEndRows = 0;
            for(let row /*int*/  = rowHeights.length - 1; row >= 0; row--){
                missingEndRows += maxRowHeight - rowHeights[row];
                if (rowHeights[row] > 0) break;
            }
            for(let row /*int*/  = codewords.length - 1; missingEndRows > 0 && codewords[row] == null; row--)missingEndRows--;
            return rowIndicatorColumn.getBoundingBox().addMissingRows(missingStartRows, missingEndRows, rowIndicatorColumn.isLeft());
        }
        static getMax(values) {
            let maxValue = -1;
            for (let value /*int*/  of values)maxValue = Math.max(maxValue, value);
            return maxValue;
        }
        static getBarcodeMetadata(leftRowIndicatorColumn, rightRowIndicatorColumn) {
            let leftBarcodeMetadata;
            if (leftRowIndicatorColumn == null || (leftBarcodeMetadata = leftRowIndicatorColumn.getBarcodeMetadata()) == null) return rightRowIndicatorColumn == null ? null : rightRowIndicatorColumn.getBarcodeMetadata();
            let rightBarcodeMetadata;
            if (rightRowIndicatorColumn == null || (rightBarcodeMetadata = rightRowIndicatorColumn.getBarcodeMetadata()) == null) return leftBarcodeMetadata;
            if (leftBarcodeMetadata.getColumnCount() !== rightBarcodeMetadata.getColumnCount() && leftBarcodeMetadata.getErrorCorrectionLevel() !== rightBarcodeMetadata.getErrorCorrectionLevel() && leftBarcodeMetadata.getRowCount() !== rightBarcodeMetadata.getRowCount()) return null;
            return leftBarcodeMetadata;
        }
        static getRowIndicatorColumn(image, boundingBox, startPoint, leftToRight, minCodewordWidth, maxCodewordWidth) {
            let rowIndicatorColumn = new DetectionResultRowIndicatorColumn(boundingBox, leftToRight);
            for(let i /*int*/  = 0; i < 2; i++){
                let increment = i === 0 ? 1 : -1;
                let startColumn = Math.trunc(Math.trunc(startPoint.getX()));
                for(let imageRow /*int*/  = Math.trunc(Math.trunc(startPoint.getY())); imageRow <= boundingBox.getMaxY() && imageRow >= boundingBox.getMinY(); imageRow += increment){
                    let codeword = PDF417ScanningDecoder.detectCodeword(image, 0, image.getWidth(), leftToRight, startColumn, imageRow, minCodewordWidth, maxCodewordWidth);
                    if (codeword != null) {
                        rowIndicatorColumn.setCodeword(imageRow, codeword);
                        if (leftToRight) startColumn = codeword.getStartX();
                        else startColumn = codeword.getEndX();
                    }
                }
            }
            return rowIndicatorColumn;
        }
        /**
         *
         * @param detectionResult
         * @param BarcodeValue
         * @param param2
         * @param param3
         * @param barcodeMatrix
         *
         * @throws NotFoundException
         */ static adjustCodewordCount(detectionResult, barcodeMatrix) {
            let barcodeMatrix01 = barcodeMatrix[0][1];
            let numberOfCodewords = barcodeMatrix01.getValue();
            let calculatedNumberOfCodewords = detectionResult.getBarcodeColumnCount() * detectionResult.getBarcodeRowCount() - PDF417ScanningDecoder.getNumberOfECCodeWords(detectionResult.getBarcodeECLevel());
            if (numberOfCodewords.length === 0) {
                if (calculatedNumberOfCodewords < 1 || calculatedNumberOfCodewords > PDF417Common.MAX_CODEWORDS_IN_BARCODE) throw NotFoundException.getNotFoundInstance();
                barcodeMatrix01.setValue(calculatedNumberOfCodewords);
            } else if (numberOfCodewords[0] !== calculatedNumberOfCodewords) // The calculated one is more reliable as it is derived from the row indicator columns
            barcodeMatrix01.setValue(calculatedNumberOfCodewords);
        }
        /**
         *
         * @param detectionResult
         *
         * @throws FormatException
         * @throws ChecksumException
         * @throws NotFoundException
         */ static createDecoderResult(detectionResult) {
            let barcodeMatrix = PDF417ScanningDecoder.createBarcodeMatrix(detectionResult);
            PDF417ScanningDecoder.adjustCodewordCount(detectionResult, barcodeMatrix);
            let erasures /*Collection<Integer>*/  = new Array();
            let codewords = new Int32Array(detectionResult.getBarcodeRowCount() * detectionResult.getBarcodeColumnCount());
            let ambiguousIndexValuesList = /*List<int[]>*/ [];
            let ambiguousIndexesList = /*Collection<Integer>*/ new Array();
            for(let row /*int*/  = 0; row < detectionResult.getBarcodeRowCount(); row++)for(let column /*int*/  = 0; column < detectionResult.getBarcodeColumnCount(); column++){
                let values = barcodeMatrix[row][column + 1].getValue();
                let codewordIndex = row * detectionResult.getBarcodeColumnCount() + column;
                if (values.length === 0) erasures.push(codewordIndex);
                else if (values.length === 1) codewords[codewordIndex] = values[0];
                else {
                    ambiguousIndexesList.push(codewordIndex);
                    ambiguousIndexValuesList.push(values);
                }
            }
            let ambiguousIndexValues = new Array(ambiguousIndexValuesList.length);
            for(let i /*int*/  = 0; i < ambiguousIndexValues.length; i++)ambiguousIndexValues[i] = ambiguousIndexValuesList[i];
            return PDF417ScanningDecoder.createDecoderResultFromAmbiguousValues(detectionResult.getBarcodeECLevel(), codewords, PDF417Common.toIntArray(erasures), PDF417Common.toIntArray(ambiguousIndexesList), ambiguousIndexValues);
        }
        /**
         * This method deals with the fact, that the decoding process doesn't always yield a single most likely value. The
         * current error correction implementation doesn't deal with erasures very well, so it's better to provide a value
         * for these ambiguous codewords instead of treating it as an erasure. The problem is that we don't know which of
         * the ambiguous values to choose. We try decode using the first value, and if that fails, we use another of the
         * ambiguous values and try to decode again. This usually only happens on very hard to read and decode barcodes,
         * so decoding the normal barcodes is not affected by this.
         *
         * @param erasureArray contains the indexes of erasures
         * @param ambiguousIndexes array with the indexes that have more than one most likely value
         * @param ambiguousIndexValues two dimensional array that contains the ambiguous values. The first dimension must
         * be the same length as the ambiguousIndexes array
         *
         * @throws FormatException
         * @throws ChecksumException
         */ static createDecoderResultFromAmbiguousValues(ecLevel, codewords, erasureArray, ambiguousIndexes, ambiguousIndexValues) {
            let ambiguousIndexCount = new Int32Array(ambiguousIndexes.length);
            let tries = 100;
            while(tries-- > 0){
                for(let i /*int*/  = 0; i < ambiguousIndexCount.length; i++)codewords[ambiguousIndexes[i]] = ambiguousIndexValues[i][ambiguousIndexCount[i]];
                try {
                    return PDF417ScanningDecoder.decodeCodewords(codewords, ecLevel, erasureArray);
                } catch (err) {
                    let ignored = err instanceof ChecksumException;
                    if (!ignored) throw err;
                }
                if (ambiguousIndexCount.length === 0) throw ChecksumException.getChecksumInstance();
                for(let i /*int*/  = 0; i < ambiguousIndexCount.length; i++)if (ambiguousIndexCount[i] < ambiguousIndexValues[i].length - 1) {
                    ambiguousIndexCount[i]++;
                    break;
                } else {
                    ambiguousIndexCount[i] = 0;
                    if (i === ambiguousIndexCount.length - 1) throw ChecksumException.getChecksumInstance();
                }
            }
            throw ChecksumException.getChecksumInstance();
        }
        static createBarcodeMatrix(detectionResult) {
            // let barcodeMatrix: BarcodeValue[][] =
            // new BarcodeValue[detectionResult.getBarcodeRowCount()][detectionResult.getBarcodeColumnCount() + 2];
            let barcodeMatrix = Array.from({
                length: detectionResult.getBarcodeRowCount()
            }, ()=>new Array(detectionResult.getBarcodeColumnCount() + 2));
            for(let row /*int*/  = 0; row < barcodeMatrix.length; row++)for(let column /*int*/  = 0; column < barcodeMatrix[row].length; column++)barcodeMatrix[row][column] = new BarcodeValue();
            let column = 0;
            for (let detectionResultColumn /*DetectionResultColumn*/  of detectionResult.getDetectionResultColumns()){
                if (detectionResultColumn != null) {
                    for (let codeword /*Codeword*/  of detectionResultColumn.getCodewords())if (codeword != null) {
                        let rowNumber = codeword.getRowNumber();
                        if (rowNumber >= 0) {
                            if (rowNumber >= barcodeMatrix.length) continue;
                            barcodeMatrix[rowNumber][column].setValue(codeword.getValue());
                        }
                    }
                }
                column++;
            }
            return barcodeMatrix;
        }
        static isValidBarcodeColumn(detectionResult, barcodeColumn) {
            return barcodeColumn >= 0 && barcodeColumn <= detectionResult.getBarcodeColumnCount() + 1;
        }
        static getStartColumn(detectionResult, barcodeColumn, imageRow, leftToRight) {
            let offset = leftToRight ? 1 : -1;
            let codeword = null;
            if (PDF417ScanningDecoder.isValidBarcodeColumn(detectionResult, barcodeColumn - offset)) codeword = detectionResult.getDetectionResultColumn(barcodeColumn - offset).getCodeword(imageRow);
            if (codeword != null) return leftToRight ? codeword.getEndX() : codeword.getStartX();
            codeword = detectionResult.getDetectionResultColumn(barcodeColumn).getCodewordNearby(imageRow);
            if (codeword != null) return leftToRight ? codeword.getStartX() : codeword.getEndX();
            if (PDF417ScanningDecoder.isValidBarcodeColumn(detectionResult, barcodeColumn - offset)) codeword = detectionResult.getDetectionResultColumn(barcodeColumn - offset).getCodewordNearby(imageRow);
            if (codeword != null) return leftToRight ? codeword.getEndX() : codeword.getStartX();
            let skippedColumns = 0;
            while(PDF417ScanningDecoder.isValidBarcodeColumn(detectionResult, barcodeColumn - offset)){
                barcodeColumn -= offset;
                for (let previousRowCodeword /*Codeword*/  of detectionResult.getDetectionResultColumn(barcodeColumn).getCodewords()){
                    if (previousRowCodeword != null) return (leftToRight ? previousRowCodeword.getEndX() : previousRowCodeword.getStartX()) + offset * skippedColumns * (previousRowCodeword.getEndX() - previousRowCodeword.getStartX());
                }
                skippedColumns++;
            }
            return leftToRight ? detectionResult.getBoundingBox().getMinX() : detectionResult.getBoundingBox().getMaxX();
        }
        static detectCodeword(image, minColumn, maxColumn, leftToRight, startColumn, imageRow, minCodewordWidth, maxCodewordWidth) {
            startColumn = PDF417ScanningDecoder.adjustCodewordStartColumn(image, minColumn, maxColumn, leftToRight, startColumn, imageRow);
            // we usually know fairly exact now how long a codeword is. We should provide minimum and maximum expected length
            // and try to adjust the read pixels, e.g. remove single pixel errors or try to cut off exceeding pixels.
            // min and maxCodewordWidth should not be used as they are calculated for the whole barcode an can be inaccurate
            // for the current position
            let moduleBitCount = PDF417ScanningDecoder.getModuleBitCount(image, minColumn, maxColumn, leftToRight, startColumn, imageRow);
            if (moduleBitCount == null) return null;
            let endColumn;
            let codewordBitCount = MathUtils.sum(moduleBitCount);
            if (leftToRight) endColumn = startColumn + codewordBitCount;
            else {
                for(let i /*int*/  = 0; i < moduleBitCount.length / 2; i++){
                    let tmpCount = moduleBitCount[i];
                    moduleBitCount[i] = moduleBitCount[moduleBitCount.length - 1 - i];
                    moduleBitCount[moduleBitCount.length - 1 - i] = tmpCount;
                }
                endColumn = startColumn;
                startColumn = endColumn - codewordBitCount;
            }
            // TODO implement check for width and correction of black and white bars
            // use start (and maybe stop pattern) to determine if black bars are wider than white bars. If so, adjust.
            // should probably done only for codewords with a lot more than 17 bits.
            // The following fixes 10-1.png, which has wide black bars and small white bars
            //    for (let i /*int*/ = 0; i < moduleBitCount.length; i++) {
            //      if (i % 2 === 0) {
            //        moduleBitCount[i]--;
            //      } else {
            //        moduleBitCount[i]++;
            //      }
            //    }
            // We could also use the width of surrounding codewords for more accurate results, but this seems
            // sufficient for now
            if (!PDF417ScanningDecoder.checkCodewordSkew(codewordBitCount, minCodewordWidth, maxCodewordWidth)) // We could try to use the startX and endX position of the codeword in the same column in the previous row,
            // create the bit count from it and normalize it to 8. This would help with single pixel errors.
            return null;
            let decodedValue = PDF417CodewordDecoder.getDecodedValue(moduleBitCount);
            let codeword = PDF417Common.getCodeword(decodedValue);
            if (codeword === -1) return null;
            return new Codeword(startColumn, endColumn, PDF417ScanningDecoder.getCodewordBucketNumber(decodedValue), codeword);
        }
        static getModuleBitCount(image, minColumn, maxColumn, leftToRight, startColumn, imageRow) {
            let imageColumn = startColumn;
            let moduleBitCount = new Int32Array(8);
            let moduleNumber = 0;
            let increment = leftToRight ? 1 : -1;
            let previousPixelValue = leftToRight;
            while((leftToRight ? imageColumn < maxColumn : imageColumn >= minColumn) && moduleNumber < moduleBitCount.length)if (image.get(imageColumn, imageRow) === previousPixelValue) {
                moduleBitCount[moduleNumber]++;
                imageColumn += increment;
            } else {
                moduleNumber++;
                previousPixelValue = !previousPixelValue;
            }
            if (moduleNumber === moduleBitCount.length || imageColumn === (leftToRight ? maxColumn : minColumn) && moduleNumber === moduleBitCount.length - 1) return moduleBitCount;
            return null;
        }
        static getNumberOfECCodeWords(barcodeECLevel) {
            return 2 << barcodeECLevel;
        }
        static adjustCodewordStartColumn(image, minColumn, maxColumn, leftToRight, codewordStartColumn, imageRow) {
            let correctedStartColumn = codewordStartColumn;
            let increment = leftToRight ? -1 : 1;
            // there should be no black pixels before the start column. If there are, then we need to start earlier.
            for(let i /*int*/  = 0; i < 2; i++){
                while((leftToRight ? correctedStartColumn >= minColumn : correctedStartColumn < maxColumn) && leftToRight === image.get(correctedStartColumn, imageRow)){
                    if (Math.abs(codewordStartColumn - correctedStartColumn) > PDF417ScanningDecoder.CODEWORD_SKEW_SIZE) return codewordStartColumn;
                    correctedStartColumn += increment;
                }
                increment = -increment;
                leftToRight = !leftToRight;
            }
            return correctedStartColumn;
        }
        static checkCodewordSkew(codewordSize, minCodewordWidth, maxCodewordWidth) {
            return minCodewordWidth - PDF417ScanningDecoder.CODEWORD_SKEW_SIZE <= codewordSize && codewordSize <= maxCodewordWidth + PDF417ScanningDecoder.CODEWORD_SKEW_SIZE;
        }
        /**
         * @throws FormatException,
         * @throws ChecksumException
         */ static decodeCodewords(codewords, ecLevel, erasures) {
            if (codewords.length === 0) throw FormatException.getFormatInstance();
            let numECCodewords = 1 << ecLevel + 1;
            let correctedErrorsCount = PDF417ScanningDecoder.correctErrors(codewords, erasures, numECCodewords);
            PDF417ScanningDecoder.verifyCodewordCount(codewords, numECCodewords);
            // Decode the codewords
            let decoderResult = DecodedBitStreamParser$2.decode(codewords, '' + ecLevel);
            decoderResult.setErrorsCorrected(correctedErrorsCount);
            decoderResult.setErasures(erasures.length);
            return decoderResult;
        }
        /**
         * <p>Given data and error-correction codewords received, possibly corrupted by errors, attempts to
         * correct the errors in-place.</p>
         *
         * @param codewords   data and error correction codewords
         * @param erasures positions of any known erasures
         * @param numECCodewords number of error correction codewords that are available in codewords
         * @throws ChecksumException if error correction fails
         */ static correctErrors(codewords, erasures, numECCodewords) {
            if (erasures != null && erasures.length > numECCodewords / 2 + PDF417ScanningDecoder.MAX_ERRORS || numECCodewords < 0 || numECCodewords > PDF417ScanningDecoder.MAX_EC_CODEWORDS) // Too many errors or EC Codewords is corrupted
            throw ChecksumException.getChecksumInstance();
            return PDF417ScanningDecoder.errorCorrection.decode(codewords, numECCodewords, erasures);
        }
        /**
         * Verify that all is OK with the codeword array.
         * @throws FormatException
         */ static verifyCodewordCount(codewords, numECCodewords) {
            if (codewords.length < 4) // Codeword array size should be at least 4 allowing for
            // Count CW, At least one Data CW, Error Correction CW, Error Correction CW
            throw FormatException.getFormatInstance();
            // The first codeword, the Symbol Length Descriptor, shall always encode the total number of data
            // codewords in the symbol, including the Symbol Length Descriptor itself, data codewords and pad
            // codewords, but excluding the number of error correction codewords.
            let numberOfCodewords = codewords[0];
            if (numberOfCodewords > codewords.length) throw FormatException.getFormatInstance();
            if (numberOfCodewords === 0) {
                // Reset to the length of the array - 8 (Allow for at least level 3 Error Correction (8 Error Codewords)
                if (numECCodewords < codewords.length) codewords[0] = codewords.length - numECCodewords;
                else throw FormatException.getFormatInstance();
            }
        }
        static getBitCountForCodeword(codeword) {
            let result = new Int32Array(8);
            let previousValue = 0;
            let i = result.length - 1;
            while(true){
                if ((codeword & 0x1) !== previousValue) {
                    previousValue = codeword & 0x1;
                    i--;
                    if (i < 0) break;
                }
                result[i]++;
                codeword >>= 1;
            }
            return result;
        }
        static getCodewordBucketNumber(codeword) {
            if (codeword instanceof Int32Array) return this.getCodewordBucketNumber_Int32Array(codeword);
            return this.getCodewordBucketNumber_number(codeword);
        }
        static getCodewordBucketNumber_number(codeword) {
            return PDF417ScanningDecoder.getCodewordBucketNumber(PDF417ScanningDecoder.getBitCountForCodeword(codeword));
        }
        static getCodewordBucketNumber_Int32Array(moduleBitCount) {
            return (moduleBitCount[0] - moduleBitCount[2] + moduleBitCount[4] - moduleBitCount[6] + 9) % 9;
        }
        static toString(barcodeMatrix) {
            let formatter = new Formatter();
            // try (let formatter = new Formatter()) {
            for(let row /*int*/  = 0; row < barcodeMatrix.length; row++){
                formatter.format('Row %2d: ', row);
                for(let column /*int*/  = 0; column < barcodeMatrix[row].length; column++){
                    let barcodeValue = barcodeMatrix[row][column];
                    if (barcodeValue.getValue().length === 0) formatter.format('        ', null);
                    else formatter.format('%4d(%2d)', barcodeValue.getValue()[0], barcodeValue.getConfidence(barcodeValue.getValue()[0]));
                }
                formatter.format('%n');
            }
            return formatter.toString();
        // }
        }
    }
    /*final*/ PDF417ScanningDecoder.CODEWORD_SKEW_SIZE = 2;
    /*final*/ PDF417ScanningDecoder.MAX_ERRORS = 3;
    /*final*/ PDF417ScanningDecoder.MAX_EC_CODEWORDS = 512;
    /*final*/ PDF417ScanningDecoder.errorCorrection = new ErrorCorrection();
    /*
     * Copyright 2009 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ // import java.util.ArrayList;
    // import java.util.List;
    // import java.util.Map;
    /**
     * This implementation can detect and decode PDF417 codes in an image.
     *
     * @author Guenther Grau
     */ /*public final*/ class PDF417Reader {
        // private static /*final Result[]*/ EMPTY_RESULT_ARRAY: Result[] = new Result([0]);
        /**
         * Locates and decodes a PDF417 code in an image.
         *
         * @return a String representing the content encoded by the PDF417 code
         * @throws NotFoundException if a PDF417 code cannot be found,
         * @throws FormatException if a PDF417 cannot be decoded
         * @throws ChecksumException
         */ // @Override
        decode(image, hints = null) {
            let result = PDF417Reader.decode(image, hints, false);
            if (result == null || result.length === 0 || result[0] == null) throw NotFoundException.getNotFoundInstance();
            return result[0];
        }
        /**
         *
         * @param BinaryBitmap
         * @param image
         * @throws NotFoundException
         */ //   @Override
        decodeMultiple(image, hints = null) {
            try {
                return PDF417Reader.decode(image, hints, true);
            } catch (ignored) {
                if (ignored instanceof FormatException || ignored instanceof ChecksumException) throw NotFoundException.getNotFoundInstance();
                throw ignored;
            }
        }
        /**
         *
         * @param image
         * @param hints
         * @param multiple
         *
         * @throws NotFoundException
         * @throws FormatExceptionß
         * @throws ChecksumException
         */ static decode(image, hints, multiple) {
            const results = new Array();
            const detectorResult = Detector$3.detectMultiple(image, hints, multiple);
            for (const points of detectorResult.getPoints()){
                const decoderResult = PDF417ScanningDecoder.decode(detectorResult.getBits(), points[4], points[5], points[6], points[7], PDF417Reader.getMinCodewordWidth(points), PDF417Reader.getMaxCodewordWidth(points));
                const result = new Result(decoderResult.getText(), decoderResult.getRawBytes(), undefined, points, BarcodeFormat$1.PDF_417);
                result.putMetadata(ResultMetadataType$1.ERROR_CORRECTION_LEVEL, decoderResult.getECLevel());
                const pdf417ResultMetadata = decoderResult.getOther();
                if (pdf417ResultMetadata != null) result.putMetadata(ResultMetadataType$1.PDF417_EXTRA_METADATA, pdf417ResultMetadata);
                results.push(result);
            }
            return results.map((x)=>x);
        }
        static getMaxWidth(p1, p2) {
            if (p1 == null || p2 == null) return 0;
            return Math.trunc(Math.abs(p1.getX() - p2.getX()));
        }
        static getMinWidth(p1, p2) {
            if (p1 == null || p2 == null) return Integer.MAX_VALUE;
            return Math.trunc(Math.abs(p1.getX() - p2.getX()));
        }
        static getMaxCodewordWidth(p) {
            return Math.floor(Math.max(Math.max(PDF417Reader.getMaxWidth(p[0], p[4]), PDF417Reader.getMaxWidth(p[6], p[2]) * PDF417Common.MODULES_IN_CODEWORD / PDF417Common.MODULES_IN_STOP_PATTERN), Math.max(PDF417Reader.getMaxWidth(p[1], p[5]), PDF417Reader.getMaxWidth(p[7], p[3]) * PDF417Common.MODULES_IN_CODEWORD / PDF417Common.MODULES_IN_STOP_PATTERN)));
        }
        static getMinCodewordWidth(p) {
            return Math.floor(Math.min(Math.min(PDF417Reader.getMinWidth(p[0], p[4]), PDF417Reader.getMinWidth(p[6], p[2]) * PDF417Common.MODULES_IN_CODEWORD / PDF417Common.MODULES_IN_STOP_PATTERN), Math.min(PDF417Reader.getMinWidth(p[1], p[5]), PDF417Reader.getMinWidth(p[7], p[3]) * PDF417Common.MODULES_IN_CODEWORD / PDF417Common.MODULES_IN_STOP_PATTERN)));
        }
        // @Override
        reset() {
        // nothing needs to be reset
        }
    }
    /**
     * Custom Error class of type Exception.
     */ class ReaderException extends Exception {
    }
    ReaderException.kind = 'ReaderException';
    /*
     * Copyright 2009 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /*namespace com.google.zxing {*/ /**
     * MultiFormatReader is a convenience class and the main entry point into the library for most uses.
     * By default it attempts to decode all barcode formats that the library supports. Optionally, you
     * can provide a hints object to request different behavior, for example only decoding QR codes.
     *
     * @author Sean Owen
     * @author dswitkin@google.com (Daniel Switkin)
     */ class MultiFormatReader {
        /**
         * Creates an instance of this class
         * 
         * @param {Boolean} verbose if 'true' logs will be dumped to console, otherwise hidden.
         * @param hints The hints to use, clearing the previous state.
         */ constructor(verbose, hints){
            this.verbose = verbose === true;
            if (hints) this.setHints(hints);
        }
        /**
         * This version of decode honors the intent of Reader.decode(BinaryBitmap) in that it
         * passes null as a hint to the decoders. However, that makes it inefficient to call repeatedly.
         * Use setHints() followed by decodeWithState() for continuous scan applications.
         *
         * @param image The pixel data to decode
         * @return The contents of the image
         *
         * @throws NotFoundException Any errors which occurred
         */ /*@Override*/ // public decode(image: BinaryBitmap): Result {
        //   setHints(null)
        //   return decodeInternal(image)
        // }
        /**
         * Decode an image using the hints provided. Does not honor existing state.
         *
         * @param image The pixel data to decode
         * @param hints The hints to use, clearing the previous state.
         * @return The contents of the image
         *
         * @throws NotFoundException Any errors which occurred
         */ /*@Override*/ decode(image, hints) {
            if (hints) this.setHints(hints);
            return this.decodeInternal(image);
        }
        /**
         * Decode an image using the state set up by calling setHints() previously. Continuous scan
         * clients will get a <b>large</b> speed increase by using this instead of decode().
         *
         * @param image The pixel data to decode
         * @return The contents of the image
         *
         * @throws NotFoundException Any errors which occurred
         */ decodeWithState(image) {
            // Make sure to set up the default state so we don't crash
            if (this.readers === null || this.readers === undefined) this.setHints(null);
            return this.decodeInternal(image);
        }
        /**
         * This method adds state to the MultiFormatReader. By setting the hints once, subsequent calls
         * to decodeWithState(image) can reuse the same set of readers without reallocating memory. This
         * is important for performance in continuous scan clients.
         *
         * @param hints The set of hints to use for subsequent calls to decode(image)
         */ setHints(hints) {
            this.hints = hints;
            const tryHarder = !isNullOrUndefined(hints) && hints.get(DecodeHintType$1.TRY_HARDER) === true;
            const formats = isNullOrUndefined(hints) ? null : hints.get(DecodeHintType$1.POSSIBLE_FORMATS);
            const readers = new Array();
            if (!isNullOrUndefined(formats)) {
                const addOneDReader = formats.some((f)=>{
                    return f === BarcodeFormat$1.UPC_A || f === BarcodeFormat$1.UPC_E || f === BarcodeFormat$1.EAN_13 || f === BarcodeFormat$1.EAN_8 || f === BarcodeFormat$1.CODABAR || f === BarcodeFormat$1.CODE_39 || f === BarcodeFormat$1.CODE_93 || f === BarcodeFormat$1.CODE_128 || f === BarcodeFormat$1.ITF || f === BarcodeFormat$1.RSS_14 || f === BarcodeFormat$1.RSS_EXPANDED;
                });
                // Put 1D readers upfront in "normal" mode
                if (addOneDReader && !tryHarder) readers.push(new MultiFormatOneDReader(hints, this.verbose));
                if (formats.includes(BarcodeFormat$1.QR_CODE)) readers.push(new QRCodeReader());
                if (formats.includes(BarcodeFormat$1.DATA_MATRIX)) readers.push(new DataMatrixReader());
                if (formats.includes(BarcodeFormat$1.AZTEC)) readers.push(new AztecReader());
                if (formats.includes(BarcodeFormat$1.PDF_417)) readers.push(new PDF417Reader());
                // if (formats.includes(BarcodeFormat.MAXICODE)) {
                //    readers.push(new MaxiCodeReader())
                // }
                // At end in "try harder" mode
                if (addOneDReader && tryHarder) readers.push(new MultiFormatOneDReader(hints, this.verbose));
            }
            if (readers.length === 0) {
                if (!tryHarder) readers.push(new MultiFormatOneDReader(hints, this.verbose));
                readers.push(new QRCodeReader());
                readers.push(new DataMatrixReader());
                readers.push(new AztecReader());
                readers.push(new PDF417Reader());
                // readers.push(new MaxiCodeReader())
                if (tryHarder) readers.push(new MultiFormatOneDReader(hints, this.verbose));
            }
            this.readers = readers; // .toArray(new Reader[readers.size()])
        }
        /*@Override*/ reset() {
            if (this.readers !== null) for (const reader of this.readers)reader.reset();
        }
        /**
         * @throws NotFoundException
         */ decodeInternal(image) {
            if (this.readers === null) throw new ReaderException('No readers where selected, nothing can be read.');
            for (const reader of this.readers)// Trying to decode with ${reader} reader.
            try {
                return reader.decode(image, this.hints);
            } catch (ex) {
                if (ex instanceof ReaderException) continue;
            // Bad Exception.
            }
            throw new NotFoundException('No MultiFormat Readers were able to detect the code.');
        }
    }
    class BrowserMultiFormatReader extends BrowserCodeReader {
        constructor(hints = null, timeBetweenScansMillis = 500){
            const reader = new MultiFormatReader();
            reader.setHints(hints);
            super(reader, timeBetweenScansMillis);
        }
        /**
         * Overwrite decodeBitmap to call decodeWithState, which will pay
         * attention to the hints set in the constructor function
         */ decodeBitmap(binaryBitmap) {
            return this.reader.decodeWithState(binaryBitmap);
        }
    }
    /**
     * @deprecated Moving to @zxing/browser
     *
     * QR Code reader to use from browser.
     */ class BrowserPDF417Reader extends BrowserCodeReader {
        /**
         * Creates an instance of BrowserPDF417Reader.
         * @param {number} [timeBetweenScansMillis=500] the time delay between subsequent decode tries
         */ constructor(timeBetweenScansMillis = 500){
            super(new PDF417Reader(), timeBetweenScansMillis);
        }
    }
    /**
     * @deprecated Moving to @zxing/browser
     *
     * QR Code reader to use from browser.
     */ class BrowserQRCodeReader extends BrowserCodeReader {
        /**
         * Creates an instance of BrowserQRCodeReader.
         * @param {number} [timeBetweenScansMillis=500] the time delay between subsequent decode tries
         */ constructor(timeBetweenScansMillis = 500){
            super(new QRCodeReader(), timeBetweenScansMillis);
        }
    }
    /*
     * Copyright 2009 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /*namespace com.google.zxing {*/ /**
     * These are a set of hints that you may pass to Writers to specify their behavior.
     *
     * @author dswitkin@google.com (Daniel Switkin)
     */ var EncodeHintType;
    (function(EncodeHintType) {
        /**
         * Specifies what degree of error correction to use, for example in QR Codes.
         * Type depends on the encoder. For example for QR codes it's type
         * {@link com.google.zxing.qrcode.decoder.ErrorCorrectionLevel ErrorCorrectionLevel}.
         * For Aztec it is of type {@link Integer}, representing the minimal percentage of error correction words.
         * For PDF417 it is of type {@link Integer}, valid values being 0 to 8.
         * In all cases, it can also be a {@link String} representation of the desired value as well.
         * Note: an Aztec symbol should have a minimum of 25% EC words.
         */ EncodeHintType[EncodeHintType["ERROR_CORRECTION"] = 0] = "ERROR_CORRECTION";
        /**
         * Specifies what character encoding to use where applicable (type {@link String})
         */ EncodeHintType[EncodeHintType["CHARACTER_SET"] = 1] = "CHARACTER_SET";
        /**
         * Specifies the matrix shape for Data Matrix (type {@link com.google.zxing.datamatrix.encoder.SymbolShapeHint})
         */ EncodeHintType[EncodeHintType["DATA_MATRIX_SHAPE"] = 2] = "DATA_MATRIX_SHAPE";
        /**
         * Specifies a minimum barcode size (type {@link Dimension}). Only applicable to Data Matrix now.
         *
         * @deprecated use width/height params in
         * {@link com.google.zxing.datamatrix.DataMatrixWriter#encode(String, BarcodeFormat, int, int)}
         */ /*@Deprecated*/ EncodeHintType[EncodeHintType["MIN_SIZE"] = 3] = "MIN_SIZE";
        /**
         * Specifies a maximum barcode size (type {@link Dimension}). Only applicable to Data Matrix now.
         *
         * @deprecated without replacement
         */ /*@Deprecated*/ EncodeHintType[EncodeHintType["MAX_SIZE"] = 4] = "MAX_SIZE";
        /**
         * Specifies margin, in pixels, to use when generating the barcode. The meaning can vary
         * by format; for example it controls margin before and after the barcode horizontally for
         * most 1D formats. (Type {@link Integer}, or {@link String} representation of the integer value).
         */ EncodeHintType[EncodeHintType["MARGIN"] = 5] = "MARGIN";
        /**
         * Specifies whether to use compact mode for PDF417 (type {@link Boolean}, or "true" or "false"
         * {@link String} value).
         */ EncodeHintType[EncodeHintType["PDF417_COMPACT"] = 6] = "PDF417_COMPACT";
        /**
         * Specifies what compaction mode to use for PDF417 (type
         * {@link com.google.zxing.pdf417.encoder.Compaction Compaction} or {@link String} value of one of its
         * enum values).
         */ EncodeHintType[EncodeHintType["PDF417_COMPACTION"] = 7] = "PDF417_COMPACTION";
        /**
         * Specifies the minimum and maximum number of rows and columns for PDF417 (type
         * {@link com.google.zxing.pdf417.encoder.Dimensions Dimensions}).
         */ EncodeHintType[EncodeHintType["PDF417_DIMENSIONS"] = 8] = "PDF417_DIMENSIONS";
        /**
         * Specifies the required number of layers for an Aztec code.
         * A negative number (-1, -2, -3, -4) specifies a compact Aztec code.
         * 0 indicates to use the minimum number of layers (the default).
         * A positive number (1, 2, .. 32) specifies a normal (non-compact) Aztec code.
         * (Type {@link Integer}, or {@link String} representation of the integer value).
         */ EncodeHintType[EncodeHintType["AZTEC_LAYERS"] = 9] = "AZTEC_LAYERS";
        /**
         * Specifies the exact version of QR code to be encoded.
         * (Type {@link Integer}, or {@link String} representation of the integer value).
         */ EncodeHintType[EncodeHintType["QR_VERSION"] = 10] = "QR_VERSION";
    })(EncodeHintType || (EncodeHintType = {}));
    var EncodeHintType$1 = EncodeHintType;
    /**
     * <p>Implements Reed-Solomon encoding, as the name implies.</p>
     *
     * @author Sean Owen
     * @author William Rucklidge
     */ class ReedSolomonEncoder {
        /**
         * A reed solomon error-correcting encoding constructor is created by
         * passing as Galois Field with of size equal to the number of code
         * words (symbols) in the alphabet (the number of values in each
         * element of arrays that are encoded/decoded).
         * @param field A galois field with a number of elements equal to the size
         * of the alphabet of symbols to encode.
         */ constructor(field){
            this.field = field;
            this.cachedGenerators = [];
            this.cachedGenerators.push(new GenericGFPoly(field, Int32Array.from([
                1
            ])));
        }
        buildGenerator(degree /*int*/ ) {
            const cachedGenerators = this.cachedGenerators;
            if (degree >= cachedGenerators.length) {
                let lastGenerator = cachedGenerators[cachedGenerators.length - 1];
                const field = this.field;
                for(let d = cachedGenerators.length; d <= degree; d++){
                    const nextGenerator = lastGenerator.multiply(new GenericGFPoly(field, Int32Array.from([
                        1,
                        field.exp(d - 1 + field.getGeneratorBase())
                    ])));
                    cachedGenerators.push(nextGenerator);
                    lastGenerator = nextGenerator;
                }
            }
            return cachedGenerators[degree];
        }
        /**
         * <p>Encode a sequence of code words (symbols) using Reed-Solomon to allow decoders
         * to detect and correct errors that may have been introduced when the resulting
         * data is stored or transmitted.</p>
         *
         * @param toEncode array used for both and output. Caller initializes the array with
         * the code words (symbols) to be encoded followed by empty elements allocated to make
         * space for error-correction code words in the encoded output. The array contains
         * the encdoded output when encode returns. Code words are encoded as numbers from
         * 0 to n-1, where n is the number of possible code words (symbols), as determined
         * by the size of the Galois Field passed in the constructor of this object.
         * @param ecBytes the number of elements reserved in the array (first parameter)
         * to store error-correction code words. Thus, the number of code words (symbols)
         * to encode in the first parameter is thus toEncode.length - ecBytes.
         * Note, the use of "bytes" in the name of this parameter is misleading, as there may
         * be more or fewer than 256 symbols being encoded, as determined by the number of
         * elements in the Galois Field passed as a constructor to this object.
         * @throws IllegalArgumentException thrown in response to validation errros.
         */ encode(toEncode, ecBytes /*int*/ ) {
            if (ecBytes === 0) throw new IllegalArgumentException('No error correction bytes');
            const dataBytes = toEncode.length - ecBytes;
            if (dataBytes <= 0) throw new IllegalArgumentException('No data bytes provided');
            const generator = this.buildGenerator(ecBytes);
            const infoCoefficients = new Int32Array(dataBytes);
            System.arraycopy(toEncode, 0, infoCoefficients, 0, dataBytes);
            let info = new GenericGFPoly(this.field, infoCoefficients);
            info = info.multiplyByMonomial(ecBytes, 1);
            const remainder = info.divide(generator)[1];
            const coefficients = remainder.getCoefficients();
            const numZeroCoefficients = ecBytes - coefficients.length;
            for(let i = 0; i < numZeroCoefficients; i++)toEncode[dataBytes + i] = 0;
            System.arraycopy(coefficients, 0, toEncode, dataBytes + numZeroCoefficients, coefficients.length);
        }
    }
    /**
     * @author Satoru Takabayashi
     * @author Daniel Switkin
     * @author Sean Owen
     */ class MaskUtil {
        constructor(){
        // do nothing
        }
        /**
         * Apply mask penalty rule 1 and return the penalty. Find repetitive cells with the same color and
         * give penalty to them. Example: 00000 or 11111.
         */ static applyMaskPenaltyRule1(matrix) {
            return MaskUtil.applyMaskPenaltyRule1Internal(matrix, true) + MaskUtil.applyMaskPenaltyRule1Internal(matrix, false);
        }
        /**
         * Apply mask penalty rule 2 and return the penalty. Find 2x2 blocks with the same color and give
         * penalty to them. This is actually equivalent to the spec's rule, which is to find MxN blocks and give a
         * penalty proportional to (M-1)x(N-1), because this is the number of 2x2 blocks inside such a block.
         */ static applyMaskPenaltyRule2(matrix) {
            let penalty = 0;
            const array = matrix.getArray();
            const width = matrix.getWidth();
            const height = matrix.getHeight();
            for(let y = 0; y < height - 1; y++){
                const arrayY = array[y];
                for(let x = 0; x < width - 1; x++){
                    const value = arrayY[x];
                    if (value === arrayY[x + 1] && value === array[y + 1][x] && value === array[y + 1][x + 1]) penalty++;
                }
            }
            return MaskUtil.N2 * penalty;
        }
        /**
         * Apply mask penalty rule 3 and return the penalty. Find consecutive runs of 1:1:3:1:1:4
         * starting with black, or 4:1:1:3:1:1 starting with white, and give penalty to them.  If we
         * find patterns like 000010111010000, we give penalty once.
         */ static applyMaskPenaltyRule3(matrix) {
            let numPenalties = 0;
            const array = matrix.getArray();
            const width = matrix.getWidth();
            const height = matrix.getHeight();
            for(let y = 0; y < height; y++)for(let x = 0; x < width; x++){
                const arrayY = array[y]; // We can at least optimize this access
                if (x + 6 < width && arrayY[x] === 1 && arrayY[x + 1] === 0 && arrayY[x + 2] === 1 && arrayY[x + 3] === 1 && arrayY[x + 4] === 1 && arrayY[x + 5] === 0 && arrayY[x + 6] === 1 && (MaskUtil.isWhiteHorizontal(arrayY, x - 4, x) || MaskUtil.isWhiteHorizontal(arrayY, x + 7, x + 11))) numPenalties++;
                if (y + 6 < height && array[y][x] === 1 && array[y + 1][x] === 0 && array[y + 2][x] === 1 && array[y + 3][x] === 1 && array[y + 4][x] === 1 && array[y + 5][x] === 0 && array[y + 6][x] === 1 && (MaskUtil.isWhiteVertical(array, x, y - 4, y) || MaskUtil.isWhiteVertical(array, x, y + 7, y + 11))) numPenalties++;
            }
            return numPenalties * MaskUtil.N3;
        }
        static isWhiteHorizontal(rowArray, from /*int*/ , to /*int*/ ) {
            from = Math.max(from, 0);
            to = Math.min(to, rowArray.length);
            for(let i = from; i < to; i++){
                if (rowArray[i] === 1) return false;
            }
            return true;
        }
        static isWhiteVertical(array, col /*int*/ , from /*int*/ , to /*int*/ ) {
            from = Math.max(from, 0);
            to = Math.min(to, array.length);
            for(let i = from; i < to; i++){
                if (array[i][col] === 1) return false;
            }
            return true;
        }
        /**
         * Apply mask penalty rule 4 and return the penalty. Calculate the ratio of dark cells and give
         * penalty if the ratio is far from 50%. It gives 10 penalty for 5% distance.
         */ static applyMaskPenaltyRule4(matrix) {
            let numDarkCells = 0;
            const array = matrix.getArray();
            const width = matrix.getWidth();
            const height = matrix.getHeight();
            for(let y = 0; y < height; y++){
                const arrayY = array[y];
                for(let x = 0; x < width; x++)if (arrayY[x] === 1) numDarkCells++;
            }
            const numTotalCells = matrix.getHeight() * matrix.getWidth();
            const fivePercentVariances = Math.floor(Math.abs(numDarkCells * 2 - numTotalCells) * 10 / numTotalCells);
            return fivePercentVariances * MaskUtil.N4;
        }
        /**
         * Return the mask bit for "getMaskPattern" at "x" and "y". See 8.8 of JISX0510:2004 for mask
         * pattern conditions.
         */ static getDataMaskBit(maskPattern /*int*/ , x /*int*/ , y /*int*/ ) {
            let intermediate; /*int*/ 
            let temp; /*int*/ 
            switch(maskPattern){
                case 0:
                    intermediate = y + x & 0x1;
                    break;
                case 1:
                    intermediate = y & 0x1;
                    break;
                case 2:
                    intermediate = x % 3;
                    break;
                case 3:
                    intermediate = (y + x) % 3;
                    break;
                case 4:
                    intermediate = Math.floor(y / 2) + Math.floor(x / 3) & 0x1;
                    break;
                case 5:
                    temp = y * x;
                    intermediate = (temp & 0x1) + temp % 3;
                    break;
                case 6:
                    temp = y * x;
                    intermediate = (temp & 0x1) + temp % 3 & 0x1;
                    break;
                case 7:
                    temp = y * x;
                    intermediate = temp % 3 + (y + x & 0x1) & 0x1;
                    break;
                default:
                    throw new IllegalArgumentException('Invalid mask pattern: ' + maskPattern);
            }
            return intermediate === 0;
        }
        /**
         * Helper function for applyMaskPenaltyRule1. We need this for doing this calculation in both
         * vertical and horizontal orders respectively.
         */ static applyMaskPenaltyRule1Internal(matrix, isHorizontal) {
            let penalty = 0;
            const iLimit = isHorizontal ? matrix.getHeight() : matrix.getWidth();
            const jLimit = isHorizontal ? matrix.getWidth() : matrix.getHeight();
            const array = matrix.getArray();
            for(let i = 0; i < iLimit; i++){
                let numSameBitCells = 0;
                let prevBit = -1;
                for(let j = 0; j < jLimit; j++){
                    const bit = isHorizontal ? array[i][j] : array[j][i];
                    if (bit === prevBit) numSameBitCells++;
                    else {
                        if (numSameBitCells >= 5) penalty += MaskUtil.N1 + (numSameBitCells - 5);
                        numSameBitCells = 1; // Include the cell itself.
                        prevBit = bit;
                    }
                }
                if (numSameBitCells >= 5) penalty += MaskUtil.N1 + (numSameBitCells - 5);
            }
            return penalty;
        }
    }
    // Penalty weights from section 6.8.2.1
    MaskUtil.N1 = 3;
    MaskUtil.N2 = 3;
    MaskUtil.N3 = 40;
    MaskUtil.N4 = 10;
    /**
     * JAVAPORT: The original code was a 2D array of ints, but since it only ever gets assigned
     * -1, 0, and 1, I'm going to use less memory and go with bytes.
     *
     * @author dswitkin@google.com (Daniel Switkin)
     */ class ByteMatrix {
        constructor(width /*int*/ , height /*int*/ ){
            this.width = width;
            this.height = height;
            const bytes = new Array(height); // [height][width]
            for(let i = 0; i !== height; i++)bytes[i] = new Uint8Array(width);
            this.bytes = bytes;
        }
        getHeight() {
            return this.height;
        }
        getWidth() {
            return this.width;
        }
        get(x /*int*/ , y /*int*/ ) {
            return this.bytes[y][x];
        }
        /**
         * @return an internal representation as bytes, in row-major order. array[y][x] represents point (x,y)
         */ getArray() {
            return this.bytes;
        }
        // TYPESCRIPTPORT: preffer to let two methods instead of override to avoid type comparison inside
        setNumber(x /*int*/ , y /*int*/ , value /*byte|int*/ ) {
            this.bytes[y][x] = value;
        }
        // public set(x: number /*int*/, y: number /*int*/, value: number /*int*/): void {
        //   bytes[y][x] = (byte) value
        // }
        setBoolean(x /*int*/ , y /*int*/ , value) {
            this.bytes[y][x] = /*(byte) */ value ? 1 : 0;
        }
        clear(value /*byte*/ ) {
            for (const aByte of this.bytes)Arrays.fill(aByte, value);
        }
        equals(o) {
            if (!(o instanceof ByteMatrix)) return false;
            const other = o;
            if (this.width !== other.width) return false;
            if (this.height !== other.height) return false;
            for(let y = 0, height = this.height; y < height; ++y){
                const bytesY = this.bytes[y];
                const otherBytesY = other.bytes[y];
                for(let x = 0, width = this.width; x < width; ++x){
                    if (bytesY[x] !== otherBytesY[x]) return false;
                }
            }
            return true;
        }
        /*@Override*/ toString() {
            const result = new StringBuilder(); // (2 * width * height + 2)
            for(let y = 0, height = this.height; y < height; ++y){
                const bytesY = this.bytes[y];
                for(let x = 0, width = this.width; x < width; ++x)switch(bytesY[x]){
                    case 0:
                        result.append(' 0');
                        break;
                    case 1:
                        result.append(' 1');
                        break;
                    default:
                        result.append('  ');
                        break;
                }
                result.append('\n');
            }
            return result.toString();
        }
    }
    /**
     * @author satorux@google.com (Satoru Takabayashi) - creator
     * @author dswitkin@google.com (Daniel Switkin) - ported from C++
     */ class QRCode {
        constructor(){
            this.maskPattern = -1;
        }
        getMode() {
            return this.mode;
        }
        getECLevel() {
            return this.ecLevel;
        }
        getVersion() {
            return this.version;
        }
        getMaskPattern() {
            return this.maskPattern;
        }
        getMatrix() {
            return this.matrix;
        }
        /*@Override*/ toString() {
            const result = new StringBuilder(); // (200)
            result.append('<<\n');
            result.append(' mode: ');
            result.append(this.mode ? this.mode.toString() : 'null');
            result.append('\n ecLevel: ');
            result.append(this.ecLevel ? this.ecLevel.toString() : 'null');
            result.append('\n version: ');
            result.append(this.version ? this.version.toString() : 'null');
            result.append('\n maskPattern: ');
            result.append(this.maskPattern.toString());
            if (this.matrix) {
                result.append('\n matrix:\n');
                result.append(this.matrix.toString());
            } else result.append('\n matrix: null\n');
            result.append('>>\n');
            return result.toString();
        }
        setMode(value) {
            this.mode = value;
        }
        setECLevel(value) {
            this.ecLevel = value;
        }
        setVersion(version) {
            this.version = version;
        }
        setMaskPattern(value /*int*/ ) {
            this.maskPattern = value;
        }
        setMatrix(value) {
            this.matrix = value;
        }
        // Check if "mask_pattern" is valid.
        static isValidMaskPattern(maskPattern /*int*/ ) {
            return maskPattern >= 0 && maskPattern < QRCode.NUM_MASK_PATTERNS;
        }
    }
    QRCode.NUM_MASK_PATTERNS = 8;
    /**
     * Custom Error class of type Exception.
     */ class WriterException extends Exception {
    }
    WriterException.kind = 'WriterException';
    /**
     * @author satorux@google.com (Satoru Takabayashi) - creator
     * @author dswitkin@google.com (Daniel Switkin) - ported from C++
     */ class MatrixUtil {
        constructor(){
        // do nothing
        }
        // Set all cells to -1 (TYPESCRIPTPORT: 255).  -1 (TYPESCRIPTPORT: 255) means that the cell is empty (not set yet).
        //
        // JAVAPORT: We shouldn't need to do this at all. The code should be rewritten to begin encoding
        // with the ByteMatrix initialized all to zero.
        static clearMatrix(matrix) {
            // TYPESCRIPTPORT: we use UintArray se changed here from -1 to 255
            matrix.clear(/*(byte) */ /*-1*/ 255);
        }
        // Build 2D matrix of QR Code from "dataBits" with "ecLevel", "version" and "getMaskPattern". On
        // success, store the result in "matrix" and return true.
        static buildMatrix(dataBits, ecLevel, version, maskPattern /*int*/ , matrix) {
            MatrixUtil.clearMatrix(matrix);
            MatrixUtil.embedBasicPatterns(version, matrix);
            // Type information appear with any version.
            MatrixUtil.embedTypeInfo(ecLevel, maskPattern, matrix);
            // Version info appear if version >= 7.
            MatrixUtil.maybeEmbedVersionInfo(version, matrix);
            // Data should be embedded at end.
            MatrixUtil.embedDataBits(dataBits, maskPattern, matrix);
        }
        // Embed basic patterns. On success, modify the matrix and return true.
        // The basic patterns are:
        // - Position detection patterns
        // - Timing patterns
        // - Dark dot at the left bottom corner
        // - Position adjustment patterns, if need be
        static embedBasicPatterns(version, matrix) {
            // Let's get started with embedding big squares at corners.
            MatrixUtil.embedPositionDetectionPatternsAndSeparators(matrix);
            // Then, embed the dark dot at the left bottom corner.
            MatrixUtil.embedDarkDotAtLeftBottomCorner(matrix);
            // Position adjustment patterns appear if version >= 2.
            MatrixUtil.maybeEmbedPositionAdjustmentPatterns(version, matrix);
            // Timing patterns should be embedded after position adj. patterns.
            MatrixUtil.embedTimingPatterns(matrix);
        }
        // Embed type information. On success, modify the matrix.
        static embedTypeInfo(ecLevel, maskPattern /*int*/ , matrix) {
            const typeInfoBits = new BitArray();
            MatrixUtil.makeTypeInfoBits(ecLevel, maskPattern, typeInfoBits);
            for(let i = 0, size = typeInfoBits.getSize(); i < size; ++i){
                // Place bits in LSB to MSB order.  LSB (least significant bit) is the last value in
                // "typeInfoBits".
                const bit = typeInfoBits.get(typeInfoBits.getSize() - 1 - i);
                // Type info bits at the left top corner. See 8.9 of JISX0510:2004 (p.46).
                const coordinates = MatrixUtil.TYPE_INFO_COORDINATES[i];
                const x1 = coordinates[0];
                const y1 = coordinates[1];
                matrix.setBoolean(x1, y1, bit);
                if (i < 8) {
                    // Right top corner.
                    const x2 = matrix.getWidth() - i - 1;
                    const y2 = 8;
                    matrix.setBoolean(x2, y2, bit);
                } else {
                    // Left bottom corner.
                    const x2 = 8;
                    const y2 = matrix.getHeight() - 7 + (i - 8);
                    matrix.setBoolean(x2, y2, bit);
                }
            }
        }
        // Embed version information if need be. On success, modify the matrix and return true.
        // See 8.10 of JISX0510:2004 (p.47) for how to embed version information.
        static maybeEmbedVersionInfo(version, matrix) {
            if (version.getVersionNumber() < 7) return; // Don't need version info.
            const versionInfoBits = new BitArray();
            MatrixUtil.makeVersionInfoBits(version, versionInfoBits);
            let bitIndex = 17; // It will decrease from 17 to 0.
            for(let i = 0; i < 6; ++i)for(let j = 0; j < 3; ++j){
                // Place bits in LSB (least significant bit) to MSB order.
                const bit = versionInfoBits.get(bitIndex);
                bitIndex--;
                // Left bottom corner.
                matrix.setBoolean(i, matrix.getHeight() - 11 + j, bit);
                // Right bottom corner.
                matrix.setBoolean(matrix.getHeight() - 11 + j, i, bit);
            }
        }
        // Embed "dataBits" using "getMaskPattern". On success, modify the matrix and return true.
        // For debugging purposes, it skips masking process if "getMaskPattern" is -1(TYPESCRIPTPORT: 255).
        // See 8.7 of JISX0510:2004 (p.38) for how to embed data bits.
        static embedDataBits(dataBits, maskPattern /*int*/ , matrix) {
            let bitIndex = 0;
            let direction = -1;
            // Start from the right bottom cell.
            let x = matrix.getWidth() - 1;
            let y = matrix.getHeight() - 1;
            while(x > 0){
                // Skip the vertical timing pattern.
                if (x === 6) x -= 1;
                while(y >= 0 && y < matrix.getHeight()){
                    for(let i = 0; i < 2; ++i){
                        const xx = x - i;
                        // Skip the cell if it's not empty.
                        if (!MatrixUtil.isEmpty(matrix.get(xx, y))) continue;
                        let bit;
                        if (bitIndex < dataBits.getSize()) {
                            bit = dataBits.get(bitIndex);
                            ++bitIndex;
                        } else // Padding bit. If there is no bit left, we'll fill the left cells with 0, as described
                        // in 8.4.9 of JISX0510:2004 (p. 24).
                        bit = false;
                        // Skip masking if mask_pattern is -1 (TYPESCRIPTPORT: 255).
                        if (maskPattern !== 255 && MaskUtil.getDataMaskBit(maskPattern, xx, y)) bit = !bit;
                        matrix.setBoolean(xx, y, bit);
                    }
                    y += direction;
                }
                direction = -direction; // Reverse the direction.
                y += direction;
                x -= 2; // Move to the left.
            }
            // All bits should be consumed.
            if (bitIndex !== dataBits.getSize()) throw new WriterException('Not all bits consumed: ' + bitIndex + '/' + dataBits.getSize());
        }
        // Return the position of the most significant bit set (one: to) in the "value". The most
        // significant bit is position 32. If there is no bit set, return 0. Examples:
        // - findMSBSet(0) => 0
        // - findMSBSet(1) => 1
        // - findMSBSet(255) => 8
        static findMSBSet(value /*int*/ ) {
            return 32 - Integer.numberOfLeadingZeros(value);
        }
        // Calculate BCH (Bose-Chaudhuri-Hocquenghem) code for "value" using polynomial "poly". The BCH
        // code is used for encoding type information and version information.
        // Example: Calculation of version information of 7.
        // f(x) is created from 7.
        //   - 7 = 000111 in 6 bits
        //   - f(x) = x^2 + x^1 + x^0
        // g(x) is given by the standard (p. 67)
        //   - g(x) = x^12 + x^11 + x^10 + x^9 + x^8 + x^5 + x^2 + 1
        // Multiply f(x) by x^(18 - 6)
        //   - f'(x) = f(x) * x^(18 - 6)
        //   - f'(x) = x^14 + x^13 + x^12
        // Calculate the remainder of f'(x) / g(x)
        //         x^2
        //         __________________________________________________
        //   g(x) )x^14 + x^13 + x^12
        //         x^14 + x^13 + x^12 + x^11 + x^10 + x^7 + x^4 + x^2
        //         --------------------------------------------------
        //                              x^11 + x^10 + x^7 + x^4 + x^2
        //
        // The remainder is x^11 + x^10 + x^7 + x^4 + x^2
        // Encode it in binary: 110010010100
        // The return value is 0xc94 (1100 1001 0100)
        //
        // Since all coefficients in the polynomials are 1 or 0, we can do the calculation by bit
        // operations. We don't care if coefficients are positive or negative.
        static calculateBCHCode(value /*int*/ , poly /*int*/ ) {
            if (poly === 0) throw new IllegalArgumentException('0 polynomial');
            // If poly is "1 1111 0010 0101" (version info poly), msbSetInPoly is 13. We'll subtract 1
            // from 13 to make it 12.
            const msbSetInPoly = MatrixUtil.findMSBSet(poly);
            value <<= msbSetInPoly - 1;
            // Do the division business using exclusive-or operations.
            while(MatrixUtil.findMSBSet(value) >= msbSetInPoly)value ^= poly << MatrixUtil.findMSBSet(value) - msbSetInPoly;
            // Now the "value" is the remainder (i.e. the BCH code)
            return value;
        }
        // Make bit vector of type information. On success, store the result in "bits" and return true.
        // Encode error correction level and mask pattern. See 8.9 of
        // JISX0510:2004 (p.45) for details.
        static makeTypeInfoBits(ecLevel, maskPattern /*int*/ , bits) {
            if (!QRCode.isValidMaskPattern(maskPattern)) throw new WriterException('Invalid mask pattern');
            const typeInfo = ecLevel.getBits() << 3 | maskPattern;
            bits.appendBits(typeInfo, 5);
            const bchCode = MatrixUtil.calculateBCHCode(typeInfo, MatrixUtil.TYPE_INFO_POLY);
            bits.appendBits(bchCode, 10);
            const maskBits = new BitArray();
            maskBits.appendBits(MatrixUtil.TYPE_INFO_MASK_PATTERN, 15);
            bits.xor(maskBits);
            if (bits.getSize() !== 15) throw new WriterException('should not happen but we got: ' + bits.getSize());
        }
        // Make bit vector of version information. On success, store the result in "bits" and return true.
        // See 8.10 of JISX0510:2004 (p.45) for details.
        static makeVersionInfoBits(version, bits) {
            bits.appendBits(version.getVersionNumber(), 6);
            const bchCode = MatrixUtil.calculateBCHCode(version.getVersionNumber(), MatrixUtil.VERSION_INFO_POLY);
            bits.appendBits(bchCode, 12);
            if (bits.getSize() !== 18) throw new WriterException('should not happen but we got: ' + bits.getSize());
        }
        // Check if "value" is empty.
        static isEmpty(value /*int*/ ) {
            return value === 255; // -1
        }
        static embedTimingPatterns(matrix) {
            // -8 is for skipping position detection patterns (7: size), and two horizontal/vertical
            // separation patterns (1: size). Thus, 8 = 7 + 1.
            for(let i = 8; i < matrix.getWidth() - 8; ++i){
                const bit = (i + 1) % 2;
                // Horizontal line.
                if (MatrixUtil.isEmpty(matrix.get(i, 6))) matrix.setNumber(i, 6, bit);
                // Vertical line.
                if (MatrixUtil.isEmpty(matrix.get(6, i))) matrix.setNumber(6, i, bit);
            }
        }
        // Embed the lonely dark dot at left bottom corner. JISX0510:2004 (p.46)
        static embedDarkDotAtLeftBottomCorner(matrix) {
            if (matrix.get(8, matrix.getHeight() - 8) === 0) throw new WriterException();
            matrix.setNumber(8, matrix.getHeight() - 8, 1);
        }
        static embedHorizontalSeparationPattern(xStart /*int*/ , yStart /*int*/ , matrix) {
            for(let x = 0; x < 8; ++x){
                if (!MatrixUtil.isEmpty(matrix.get(xStart + x, yStart))) throw new WriterException();
                matrix.setNumber(xStart + x, yStart, 0);
            }
        }
        static embedVerticalSeparationPattern(xStart /*int*/ , yStart /*int*/ , matrix) {
            for(let y = 0; y < 7; ++y){
                if (!MatrixUtil.isEmpty(matrix.get(xStart, yStart + y))) throw new WriterException();
                matrix.setNumber(xStart, yStart + y, 0);
            }
        }
        static embedPositionAdjustmentPattern(xStart /*int*/ , yStart /*int*/ , matrix) {
            for(let y = 0; y < 5; ++y){
                const patternY = MatrixUtil.POSITION_ADJUSTMENT_PATTERN[y];
                for(let x = 0; x < 5; ++x)matrix.setNumber(xStart + x, yStart + y, patternY[x]);
            }
        }
        static embedPositionDetectionPattern(xStart /*int*/ , yStart /*int*/ , matrix) {
            for(let y = 0; y < 7; ++y){
                const patternY = MatrixUtil.POSITION_DETECTION_PATTERN[y];
                for(let x = 0; x < 7; ++x)matrix.setNumber(xStart + x, yStart + y, patternY[x]);
            }
        }
        // Embed position detection patterns and surrounding vertical/horizontal separators.
        static embedPositionDetectionPatternsAndSeparators(matrix) {
            // Embed three big squares at corners.
            const pdpWidth = MatrixUtil.POSITION_DETECTION_PATTERN[0].length;
            // Left top corner.
            MatrixUtil.embedPositionDetectionPattern(0, 0, matrix);
            // Right top corner.
            MatrixUtil.embedPositionDetectionPattern(matrix.getWidth() - pdpWidth, 0, matrix);
            // Left bottom corner.
            MatrixUtil.embedPositionDetectionPattern(0, matrix.getWidth() - pdpWidth, matrix);
            // Embed horizontal separation patterns around the squares.
            const hspWidth = 8;
            // Left top corner.
            MatrixUtil.embedHorizontalSeparationPattern(0, hspWidth - 1, matrix);
            // Right top corner.
            MatrixUtil.embedHorizontalSeparationPattern(matrix.getWidth() - hspWidth, hspWidth - 1, matrix);
            // Left bottom corner.
            MatrixUtil.embedHorizontalSeparationPattern(0, matrix.getWidth() - hspWidth, matrix);
            // Embed vertical separation patterns around the squares.
            const vspSize = 7;
            // Left top corner.
            MatrixUtil.embedVerticalSeparationPattern(vspSize, 0, matrix);
            // Right top corner.
            MatrixUtil.embedVerticalSeparationPattern(matrix.getHeight() - vspSize - 1, 0, matrix);
            // Left bottom corner.
            MatrixUtil.embedVerticalSeparationPattern(vspSize, matrix.getHeight() - vspSize, matrix);
        }
        // Embed position adjustment patterns if need be.
        static maybeEmbedPositionAdjustmentPatterns(version, matrix) {
            if (version.getVersionNumber() < 2) return;
            const index = version.getVersionNumber() - 1;
            const coordinates = MatrixUtil.POSITION_ADJUSTMENT_PATTERN_COORDINATE_TABLE[index];
            for(let i = 0, length = coordinates.length; i !== length; i++){
                const y = coordinates[i];
                if (y >= 0) for(let j = 0; j !== length; j++){
                    const x = coordinates[j];
                    if (x >= 0 && MatrixUtil.isEmpty(matrix.get(x, y))) // If the cell is unset, we embed the position adjustment pattern here.
                    // -2 is necessary since the x/y coordinates point to the center of the pattern, not the
                    // left top corner.
                    MatrixUtil.embedPositionAdjustmentPattern(x - 2, y - 2, matrix);
                }
            }
        }
    }
    MatrixUtil.POSITION_DETECTION_PATTERN = Array.from([
        Int32Array.from([
            1,
            1,
            1,
            1,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            0,
            0,
            0,
            0,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            1,
            1,
            1,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            1,
            1,
            1,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            1,
            1,
            1,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            0,
            0,
            0,
            0,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            1,
            1,
            1,
            1
        ])
    ]);
    MatrixUtil.POSITION_ADJUSTMENT_PATTERN = Array.from([
        Int32Array.from([
            1,
            1,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            0,
            0,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            1,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            0,
            0,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            1,
            1
        ])
    ]);
    // From Appendix E. Table 1, JIS0510X:2004 (71: p). The table was double-checked by komatsu.
    MatrixUtil.POSITION_ADJUSTMENT_PATTERN_COORDINATE_TABLE = Array.from([
        Int32Array.from([
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            18,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            22,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            22,
            38,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            24,
            42,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            46,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            28,
            50,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            54,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            32,
            58,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            62,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            46,
            66,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            48,
            70,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            50,
            74,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            54,
            78,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            56,
            82,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            58,
            86,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            62,
            90,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            28,
            50,
            72,
            94,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            50,
            74,
            98,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            54,
            78,
            102,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            28,
            54,
            80,
            106,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            32,
            58,
            84,
            110,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            58,
            86,
            114,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            62,
            90,
            118,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            50,
            74,
            98,
            122,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            54,
            78,
            102,
            126,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            52,
            78,
            104,
            130,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            56,
            82,
            108,
            134,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            60,
            86,
            112,
            138,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            58,
            86,
            114,
            142,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            62,
            90,
            118,
            146,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            54,
            78,
            102,
            126,
            150
        ]),
        Int32Array.from([
            6,
            24,
            50,
            76,
            102,
            128,
            154
        ]),
        Int32Array.from([
            6,
            28,
            54,
            80,
            106,
            132,
            158
        ]),
        Int32Array.from([
            6,
            32,
            58,
            84,
            110,
            136,
            162
        ]),
        Int32Array.from([
            6,
            26,
            54,
            82,
            110,
            138,
            166
        ]),
        Int32Array.from([
            6,
            30,
            58,
            86,
            114,
            142,
            170
        ])
    ]);
    // Type info cells at the left top corner.
    MatrixUtil.TYPE_INFO_COORDINATES = Array.from([
        Int32Array.from([
            8,
            0
        ]),
        Int32Array.from([
            8,
            1
        ]),
        Int32Array.from([
            8,
            2
        ]),
        Int32Array.from([
            8,
            3
        ]),
        Int32Array.from([
            8,
            4
        ]),
        Int32Array.from([
            8,
            5
        ]),
        Int32Array.from([
            8,
            7
        ]),
        Int32Array.from([
            8,
            8
        ]),
        Int32Array.from([
            7,
            8
        ]),
        Int32Array.from([
            5,
            8
        ]),
        Int32Array.from([
            4,
            8
        ]),
        Int32Array.from([
            3,
            8
        ]),
        Int32Array.from([
            2,
            8
        ]),
        Int32Array.from([
            1,
            8
        ]),
        Int32Array.from([
            0,
            8
        ])
    ]);
    // From Appendix D in JISX0510:2004 (p. 67)
    MatrixUtil.VERSION_INFO_POLY = 0x1f25; // 1 1111 0010 0101
    // From Appendix C in JISX0510:2004 (p.65).
    MatrixUtil.TYPE_INFO_POLY = 0x537;
    MatrixUtil.TYPE_INFO_MASK_PATTERN = 0x5412;
    /*namespace com.google.zxing.qrcode.encoder {*/ class BlockPair {
        constructor(dataBytes, errorCorrectionBytes){
            this.dataBytes = dataBytes;
            this.errorCorrectionBytes = errorCorrectionBytes;
        }
        getDataBytes() {
            return this.dataBytes;
        }
        getErrorCorrectionBytes() {
            return this.errorCorrectionBytes;
        }
    }
    /*import java.io.UnsupportedEncodingException;*/ /*import java.util.ArrayList;*/ /*import java.util.Collection;*/ /*import java.util.Map;*/ /**
     * @author satorux@google.com (Satoru Takabayashi) - creator
     * @author dswitkin@google.com (Daniel Switkin) - ported from C++
     */ class Encoder {
        // TYPESCRIPTPORT: changed to UTF8, the default for js
        constructor(){}
        // The mask penalty calculation is complicated.  See Table 21 of JISX0510:2004 (p.45) for details.
        // Basically it applies four rules and summate all penalties.
        static calculateMaskPenalty(matrix) {
            return MaskUtil.applyMaskPenaltyRule1(matrix) + MaskUtil.applyMaskPenaltyRule2(matrix) + MaskUtil.applyMaskPenaltyRule3(matrix) + MaskUtil.applyMaskPenaltyRule4(matrix);
        }
        /**
         * @param content text to encode
         * @param ecLevel error correction level to use
         * @return {@link QRCode} representing the encoded QR code
         * @throws WriterException if encoding can't succeed, because of for example invalid content
         *   or configuration
         */ // public static encode(content: string, ecLevel: ErrorCorrectionLevel): QRCode /*throws WriterException*/ {
        //   return encode(content, ecLevel, null)
        // }
        static encode(content, ecLevel, hints = null) {
            // Determine what character encoding has been specified by the caller, if any
            let encoding = Encoder.DEFAULT_BYTE_MODE_ENCODING;
            const hasEncodingHint = hints !== null && undefined !== hints.get(EncodeHintType$1.CHARACTER_SET);
            if (hasEncodingHint) encoding = hints.get(EncodeHintType$1.CHARACTER_SET).toString();
            // Pick an encoding mode appropriate for the content. Note that this will not attempt to use
            // multiple modes / segments even if that were more efficient. Twould be nice.
            const mode = this.chooseMode(content, encoding);
            // This will store the header information, like mode and
            // length, as well as "header" segments like an ECI segment.
            const headerBits = new BitArray();
            // Append ECI segment if applicable
            if (mode === Mode$1.BYTE && (hasEncodingHint || Encoder.DEFAULT_BYTE_MODE_ENCODING !== encoding)) {
                const eci = CharacterSetECI.getCharacterSetECIByName(encoding);
                if (eci !== undefined) this.appendECI(eci, headerBits);
            }
            // (With ECI in place,) Write the mode marker
            this.appendModeInfo(mode, headerBits);
            // Collect data within the main segment, separately, to count its size if needed. Don't add it to
            // main payload yet.
            const dataBits = new BitArray();
            this.appendBytes(content, mode, dataBits, encoding);
            let version;
            if (hints !== null && undefined !== hints.get(EncodeHintType$1.QR_VERSION)) {
                const versionNumber = Number.parseInt(hints.get(EncodeHintType$1.QR_VERSION).toString(), 10);
                version = Version$1.getVersionForNumber(versionNumber);
                const bitsNeeded = this.calculateBitsNeeded(mode, headerBits, dataBits, version);
                if (!this.willFit(bitsNeeded, version, ecLevel)) throw new WriterException('Data too big for requested version');
            } else version = this.recommendVersion(ecLevel, mode, headerBits, dataBits);
            const headerAndDataBits = new BitArray();
            headerAndDataBits.appendBitArray(headerBits);
            // Find "length" of main segment and write it
            const numLetters = mode === Mode$1.BYTE ? dataBits.getSizeInBytes() : content.length;
            this.appendLengthInfo(numLetters, version, mode, headerAndDataBits);
            // Put data together into the overall payload
            headerAndDataBits.appendBitArray(dataBits);
            const ecBlocks = version.getECBlocksForLevel(ecLevel);
            const numDataBytes = version.getTotalCodewords() - ecBlocks.getTotalECCodewords();
            // Terminate the bits properly.
            this.terminateBits(numDataBytes, headerAndDataBits);
            // Interleave data bits with error correction code.
            const finalBits = this.interleaveWithECBytes(headerAndDataBits, version.getTotalCodewords(), numDataBytes, ecBlocks.getNumBlocks());
            const qrCode = new QRCode();
            qrCode.setECLevel(ecLevel);
            qrCode.setMode(mode);
            qrCode.setVersion(version);
            //  Choose the mask pattern and set to "qrCode".
            const dimension = version.getDimensionForVersion();
            const matrix = new ByteMatrix(dimension, dimension);
            const maskPattern = this.chooseMaskPattern(finalBits, ecLevel, version, matrix);
            qrCode.setMaskPattern(maskPattern);
            // Build the matrix and set it to "qrCode".
            MatrixUtil.buildMatrix(finalBits, ecLevel, version, maskPattern, matrix);
            qrCode.setMatrix(matrix);
            return qrCode;
        }
        /**
         * Decides the smallest version of QR code that will contain all of the provided data.
         *
         * @throws WriterException if the data cannot fit in any version
         */ static recommendVersion(ecLevel, mode, headerBits, dataBits) {
            // Hard part: need to know version to know how many bits length takes. But need to know how many
            // bits it takes to know version. First we take a guess at version by assuming version will be
            // the minimum, 1:
            const provisionalBitsNeeded = this.calculateBitsNeeded(mode, headerBits, dataBits, Version$1.getVersionForNumber(1));
            const provisionalVersion = this.chooseVersion(provisionalBitsNeeded, ecLevel);
            // Use that guess to calculate the right version. I am still not sure this works in 100% of cases.
            const bitsNeeded = this.calculateBitsNeeded(mode, headerBits, dataBits, provisionalVersion);
            return this.chooseVersion(bitsNeeded, ecLevel);
        }
        static calculateBitsNeeded(mode, headerBits, dataBits, version) {
            return headerBits.getSize() + mode.getCharacterCountBits(version) + dataBits.getSize();
        }
        /**
         * @return the code point of the table used in alphanumeric mode or
         *  -1 if there is no corresponding code in the table.
         */ static getAlphanumericCode(code /*int*/ ) {
            if (code < Encoder.ALPHANUMERIC_TABLE.length) return Encoder.ALPHANUMERIC_TABLE[code];
            return -1;
        }
        // public static chooseMode(content: string): Mode {
        //   return chooseMode(content, null);
        // }
        /**
         * Choose the best mode by examining the content. Note that 'encoding' is used as a hint;
         * if it is Shift_JIS, and the input is only double-byte Kanji, then we return {@link Mode#KANJI}.
         */ static chooseMode(content, encoding = null) {
            if (CharacterSetECI.SJIS.getName() === encoding && this.isOnlyDoubleByteKanji(content)) // Choose Kanji mode if all input are double-byte characters
            return Mode$1.KANJI;
            let hasNumeric = false;
            let hasAlphanumeric = false;
            for(let i = 0, length = content.length; i < length; ++i){
                const c = content.charAt(i);
                if (Encoder.isDigit(c)) hasNumeric = true;
                else if (this.getAlphanumericCode(c.charCodeAt(0)) !== -1) hasAlphanumeric = true;
                else return Mode$1.BYTE;
            }
            if (hasAlphanumeric) return Mode$1.ALPHANUMERIC;
            if (hasNumeric) return Mode$1.NUMERIC;
            return Mode$1.BYTE;
        }
        static isOnlyDoubleByteKanji(content) {
            let bytes;
            try {
                bytes = StringEncoding.encode(content, CharacterSetECI.SJIS); // content.getBytes("Shift_JIS"))
            } catch (ignored /*: UnsupportedEncodingException*/ ) {
                return false;
            }
            const length = bytes.length;
            if (length % 2 !== 0) return false;
            for(let i = 0; i < length; i += 2){
                const byte1 = bytes[i] & 0xFF;
                if ((byte1 < 0x81 || byte1 > 0x9F) && (byte1 < 0xE0 || byte1 > 0xEB)) return false;
            }
            return true;
        }
        static chooseMaskPattern(bits, ecLevel, version, matrix) {
            let minPenalty = Number.MAX_SAFE_INTEGER; // Lower penalty is better.
            let bestMaskPattern = -1;
            // We try all mask patterns to choose the best one.
            for(let maskPattern = 0; maskPattern < QRCode.NUM_MASK_PATTERNS; maskPattern++){
                MatrixUtil.buildMatrix(bits, ecLevel, version, maskPattern, matrix);
                let penalty = this.calculateMaskPenalty(matrix);
                if (penalty < minPenalty) {
                    minPenalty = penalty;
                    bestMaskPattern = maskPattern;
                }
            }
            return bestMaskPattern;
        }
        static chooseVersion(numInputBits /*int*/ , ecLevel) {
            for(let versionNum = 1; versionNum <= 40; versionNum++){
                const version = Version$1.getVersionForNumber(versionNum);
                if (Encoder.willFit(numInputBits, version, ecLevel)) return version;
            }
            throw new WriterException('Data too big');
        }
        /**
         * @return true if the number of input bits will fit in a code with the specified version and
         * error correction level.
         */ static willFit(numInputBits /*int*/ , version, ecLevel) {
            // In the following comments, we use numbers of Version 7-H.
            // numBytes = 196
            const numBytes = version.getTotalCodewords();
            // getNumECBytes = 130
            const ecBlocks = version.getECBlocksForLevel(ecLevel);
            const numEcBytes = ecBlocks.getTotalECCodewords();
            // getNumDataBytes = 196 - 130 = 66
            const numDataBytes = numBytes - numEcBytes;
            const totalInputBytes = (numInputBits + 7) / 8;
            return numDataBytes >= totalInputBytes;
        }
        /**
         * Terminate bits as described in 8.4.8 and 8.4.9 of JISX0510:2004 (p.24).
         */ static terminateBits(numDataBytes /*int*/ , bits) {
            const capacity = numDataBytes * 8;
            if (bits.getSize() > capacity) throw new WriterException('data bits cannot fit in the QR Code' + bits.getSize() + ' > ' + capacity);
            for(let i = 0; i < 4 && bits.getSize() < capacity; ++i)bits.appendBit(false);
            // Append termination bits. See 8.4.8 of JISX0510:2004 (p.24) for details.
            // If the last byte isn't 8-bit aligned, we'll add padding bits.
            const numBitsInLastByte = bits.getSize() & 0x07;
            if (numBitsInLastByte > 0) for(let i = numBitsInLastByte; i < 8; i++)bits.appendBit(false);
            // If we have more space, we'll fill the space with padding patterns defined in 8.4.9 (p.24).
            const numPaddingBytes = numDataBytes - bits.getSizeInBytes();
            for(let i = 0; i < numPaddingBytes; ++i)bits.appendBits((i & 0x01) === 0 ? 0xEC : 0x11, 8);
            if (bits.getSize() !== capacity) throw new WriterException('Bits size does not equal capacity');
        }
        /**
         * Get number of data bytes and number of error correction bytes for block id "blockID". Store
         * the result in "numDataBytesInBlock", and "numECBytesInBlock". See table 12 in 8.5.1 of
         * JISX0510:2004 (p.30)
         */ static getNumDataBytesAndNumECBytesForBlockID(numTotalBytes /*int*/ , numDataBytes /*int*/ , numRSBlocks /*int*/ , blockID /*int*/ , numDataBytesInBlock, numECBytesInBlock) {
            if (blockID >= numRSBlocks) throw new WriterException('Block ID too large');
            // numRsBlocksInGroup2 = 196 % 5 = 1
            const numRsBlocksInGroup2 = numTotalBytes % numRSBlocks;
            // numRsBlocksInGroup1 = 5 - 1 = 4
            const numRsBlocksInGroup1 = numRSBlocks - numRsBlocksInGroup2;
            // numTotalBytesInGroup1 = 196 / 5 = 39
            const numTotalBytesInGroup1 = Math.floor(numTotalBytes / numRSBlocks);
            // numTotalBytesInGroup2 = 39 + 1 = 40
            const numTotalBytesInGroup2 = numTotalBytesInGroup1 + 1;
            // numDataBytesInGroup1 = 66 / 5 = 13
            const numDataBytesInGroup1 = Math.floor(numDataBytes / numRSBlocks);
            // numDataBytesInGroup2 = 13 + 1 = 14
            const numDataBytesInGroup2 = numDataBytesInGroup1 + 1;
            // numEcBytesInGroup1 = 39 - 13 = 26
            const numEcBytesInGroup1 = numTotalBytesInGroup1 - numDataBytesInGroup1;
            // numEcBytesInGroup2 = 40 - 14 = 26
            const numEcBytesInGroup2 = numTotalBytesInGroup2 - numDataBytesInGroup2;
            // Sanity checks.
            // 26 = 26
            if (numEcBytesInGroup1 !== numEcBytesInGroup2) throw new WriterException('EC bytes mismatch');
            // 5 = 4 + 1.
            if (numRSBlocks !== numRsBlocksInGroup1 + numRsBlocksInGroup2) throw new WriterException('RS blocks mismatch');
            // 196 = (13 + 26) * 4 + (14 + 26) * 1
            if (numTotalBytes !== (numDataBytesInGroup1 + numEcBytesInGroup1) * numRsBlocksInGroup1 + (numDataBytesInGroup2 + numEcBytesInGroup2) * numRsBlocksInGroup2) throw new WriterException('Total bytes mismatch');
            if (blockID < numRsBlocksInGroup1) {
                numDataBytesInBlock[0] = numDataBytesInGroup1;
                numECBytesInBlock[0] = numEcBytesInGroup1;
            } else {
                numDataBytesInBlock[0] = numDataBytesInGroup2;
                numECBytesInBlock[0] = numEcBytesInGroup2;
            }
        }
        /**
         * Interleave "bits" with corresponding error correction bytes. On success, store the result in
         * "result". The interleave rule is complicated. See 8.6 of JISX0510:2004 (p.37) for details.
         */ static interleaveWithECBytes(bits, numTotalBytes /*int*/ , numDataBytes /*int*/ , numRSBlocks /*int*/ ) {
            // "bits" must have "getNumDataBytes" bytes of data.
            if (bits.getSizeInBytes() !== numDataBytes) throw new WriterException('Number of bits and data bytes does not match');
            // Step 1.  Divide data bytes into blocks and generate error correction bytes for them. We'll
            // store the divided data bytes blocks and error correction bytes blocks into "blocks".
            let dataBytesOffset = 0;
            let maxNumDataBytes = 0;
            let maxNumEcBytes = 0;
            // Since, we know the number of reedsolmon blocks, we can initialize the vector with the number.
            const blocks = new Array(); // new Array<BlockPair>(numRSBlocks)
            for(let i = 0; i < numRSBlocks; ++i){
                const numDataBytesInBlock = new Int32Array(1);
                const numEcBytesInBlock = new Int32Array(1);
                Encoder.getNumDataBytesAndNumECBytesForBlockID(numTotalBytes, numDataBytes, numRSBlocks, i, numDataBytesInBlock, numEcBytesInBlock);
                const size = numDataBytesInBlock[0];
                const dataBytes = new Uint8Array(size);
                bits.toBytes(8 * dataBytesOffset, dataBytes, 0, size);
                const ecBytes = Encoder.generateECBytes(dataBytes, numEcBytesInBlock[0]);
                blocks.push(new BlockPair(dataBytes, ecBytes));
                maxNumDataBytes = Math.max(maxNumDataBytes, size);
                maxNumEcBytes = Math.max(maxNumEcBytes, ecBytes.length);
                dataBytesOffset += numDataBytesInBlock[0];
            }
            if (numDataBytes !== dataBytesOffset) throw new WriterException('Data bytes does not match offset');
            const result = new BitArray();
            // First, place data blocks.
            for(let i = 0; i < maxNumDataBytes; ++i)for (const block of blocks){
                const dataBytes = block.getDataBytes();
                if (i < dataBytes.length) result.appendBits(dataBytes[i], 8);
            }
            // Then, place error correction blocks.
            for(let i = 0; i < maxNumEcBytes; ++i)for (const block of blocks){
                const ecBytes = block.getErrorCorrectionBytes();
                if (i < ecBytes.length) result.appendBits(ecBytes[i], 8);
            }
            if (numTotalBytes !== result.getSizeInBytes()) throw new WriterException('Interleaving error: ' + numTotalBytes + ' and ' + result.getSizeInBytes() + ' differ.');
            return result;
        }
        static generateECBytes(dataBytes, numEcBytesInBlock /*int*/ ) {
            const numDataBytes = dataBytes.length;
            const toEncode = new Int32Array(numDataBytes + numEcBytesInBlock); // int[numDataBytes + numEcBytesInBlock]
            for(let i = 0; i < numDataBytes; i++)toEncode[i] = dataBytes[i] & 0xFF;
            new ReedSolomonEncoder(GenericGF.QR_CODE_FIELD_256).encode(toEncode, numEcBytesInBlock);
            const ecBytes = new Uint8Array(numEcBytesInBlock);
            for(let i = 0; i < numEcBytesInBlock; i++)ecBytes[i] = /*(byte) */ toEncode[numDataBytes + i];
            return ecBytes;
        }
        /**
         * Append mode info. On success, store the result in "bits".
         */ static appendModeInfo(mode, bits) {
            bits.appendBits(mode.getBits(), 4);
        }
        /**
         * Append length info. On success, store the result in "bits".
         */ static appendLengthInfo(numLetters /*int*/ , version, mode, bits) {
            const numBits = mode.getCharacterCountBits(version);
            if (numLetters >= 1 << numBits) throw new WriterException(numLetters + ' is bigger than ' + ((1 << numBits) - 1));
            bits.appendBits(numLetters, numBits);
        }
        /**
         * Append "bytes" in "mode" mode (encoding) into "bits". On success, store the result in "bits".
         */ static appendBytes(content, mode, bits, encoding) {
            switch(mode){
                case Mode$1.NUMERIC:
                    Encoder.appendNumericBytes(content, bits);
                    break;
                case Mode$1.ALPHANUMERIC:
                    Encoder.appendAlphanumericBytes(content, bits);
                    break;
                case Mode$1.BYTE:
                    Encoder.append8BitBytes(content, bits, encoding);
                    break;
                case Mode$1.KANJI:
                    Encoder.appendKanjiBytes(content, bits);
                    break;
                default:
                    throw new WriterException('Invalid mode: ' + mode);
            }
        }
        static getDigit(singleCharacter) {
            return singleCharacter.charCodeAt(0) - 48;
        }
        static isDigit(singleCharacter) {
            const cn = Encoder.getDigit(singleCharacter);
            return cn >= 0 && cn <= 9;
        }
        static appendNumericBytes(content, bits) {
            const length = content.length;
            let i = 0;
            while(i < length){
                const num1 = Encoder.getDigit(content.charAt(i));
                if (i + 2 < length) {
                    // Encode three numeric letters in ten bits.
                    const num2 = Encoder.getDigit(content.charAt(i + 1));
                    const num3 = Encoder.getDigit(content.charAt(i + 2));
                    bits.appendBits(num1 * 100 + num2 * 10 + num3, 10);
                    i += 3;
                } else if (i + 1 < length) {
                    // Encode two numeric letters in seven bits.
                    const num2 = Encoder.getDigit(content.charAt(i + 1));
                    bits.appendBits(num1 * 10 + num2, 7);
                    i += 2;
                } else {
                    // Encode one numeric letter in four bits.
                    bits.appendBits(num1, 4);
                    i++;
                }
            }
        }
        static appendAlphanumericBytes(content, bits) {
            const length = content.length;
            let i = 0;
            while(i < length){
                const code1 = Encoder.getAlphanumericCode(content.charCodeAt(i));
                if (code1 === -1) throw new WriterException();
                if (i + 1 < length) {
                    const code2 = Encoder.getAlphanumericCode(content.charCodeAt(i + 1));
                    if (code2 === -1) throw new WriterException();
                    // Encode two alphanumeric letters in 11 bits.
                    bits.appendBits(code1 * 45 + code2, 11);
                    i += 2;
                } else {
                    // Encode one alphanumeric letter in six bits.
                    bits.appendBits(code1, 6);
                    i++;
                }
            }
        }
        static append8BitBytes(content, bits, encoding) {
            let bytes;
            try {
                bytes = StringEncoding.encode(content, encoding);
            } catch (uee /*: UnsupportedEncodingException*/ ) {
                throw new WriterException(uee);
            }
            for(let i = 0, length = bytes.length; i !== length; i++){
                const b = bytes[i];
                bits.appendBits(b, 8);
            }
        }
        /**
         * @throws WriterException
         */ static appendKanjiBytes(content, bits) {
            let bytes;
            try {
                bytes = StringEncoding.encode(content, CharacterSetECI.SJIS);
            } catch (uee /*: UnsupportedEncodingException*/ ) {
                throw new WriterException(uee);
            }
            const length = bytes.length;
            for(let i = 0; i < length; i += 2){
                const byte1 = bytes[i] & 0xFF;
                const byte2 = bytes[i + 1] & 0xFF;
                const code = byte1 << 8 & 0xFFFFFFFF | byte2;
                let subtracted = -1;
                if (code >= 0x8140 && code <= 0x9ffc) subtracted = code - 0x8140;
                else if (code >= 0xe040 && code <= 0xebbf) subtracted = code - 0xc140;
                if (subtracted === -1) throw new WriterException('Invalid byte sequence');
                const encoded = (subtracted >> 8) * 0xc0 + (subtracted & 0xff);
                bits.appendBits(encoded, 13);
            }
        }
        static appendECI(eci, bits) {
            bits.appendBits(Mode$1.ECI.getBits(), 4);
            // This is correct for values up to 127, which is all we need now.
            bits.appendBits(eci.getValue(), 8);
        }
    }
    // The original table is defined in the table 5 of JISX0510:2004 (p.19).
    Encoder.ALPHANUMERIC_TABLE = Int32Array.from([
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        36,
        -1,
        -1,
        -1,
        37,
        38,
        -1,
        -1,
        -1,
        -1,
        39,
        40,
        -1,
        41,
        42,
        43,
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        44,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31,
        32,
        33,
        34,
        35,
        -1,
        -1,
        -1,
        -1,
        -1
    ]);
    Encoder.DEFAULT_BYTE_MODE_ENCODING = CharacterSetECI.UTF8.getName(); // "ISO-8859-1"
    /**
     * @deprecated Moving to @zxing/browser
     */ class BrowserQRCodeSvgWriter {
        /**
         * Writes and renders a QRCode SVG element.
         *
         * @param contents
         * @param width
         * @param height
         * @param hints
         */ write(contents, width, height, hints = null) {
            if (contents.length === 0) throw new IllegalArgumentException('Found empty contents');
            // if (format != BarcodeFormat.QR_CODE) {
            //   throw new IllegalArgumentException("Can only encode QR_CODE, but got " + format)
            // }
            if (width < 0 || height < 0) throw new IllegalArgumentException('Requested dimensions are too small: ' + width + 'x' + height);
            let errorCorrectionLevel = ErrorCorrectionLevel.L;
            let quietZone = BrowserQRCodeSvgWriter.QUIET_ZONE_SIZE;
            if (hints !== null) {
                if (undefined !== hints.get(EncodeHintType$1.ERROR_CORRECTION)) errorCorrectionLevel = ErrorCorrectionLevel.fromString(hints.get(EncodeHintType$1.ERROR_CORRECTION).toString());
                if (undefined !== hints.get(EncodeHintType$1.MARGIN)) quietZone = Number.parseInt(hints.get(EncodeHintType$1.MARGIN).toString(), 10);
            }
            const code = Encoder.encode(contents, errorCorrectionLevel, hints);
            return this.renderResult(code, width, height, quietZone);
        }
        /**
         * Renders the result and then appends it to the DOM.
         */ writeToDom(containerElement, contents, width, height, hints = null) {
            if (typeof containerElement === 'string') containerElement = document.querySelector(containerElement);
            const svgElement = this.write(contents, width, height, hints);
            if (containerElement) containerElement.appendChild(svgElement);
        }
        /**
         * Note that the input matrix uses 0 == white, 1 == black.
         * The output matrix uses 0 == black, 255 == white (i.e. an 8 bit greyscale bitmap).
         */ renderResult(code, width /*int*/ , height /*int*/ , quietZone /*int*/ ) {
            const input = code.getMatrix();
            if (input === null) throw new IllegalStateException();
            const inputWidth = input.getWidth();
            const inputHeight = input.getHeight();
            const qrWidth = inputWidth + quietZone * 2;
            const qrHeight = inputHeight + quietZone * 2;
            const outputWidth = Math.max(width, qrWidth);
            const outputHeight = Math.max(height, qrHeight);
            const multiple = Math.min(Math.floor(outputWidth / qrWidth), Math.floor(outputHeight / qrHeight));
            // Padding includes both the quiet zone and the extra white pixels to accommodate the requested
            // dimensions. For example, if input is 25x25 the QR will be 33x33 including the quiet zone.
            // If the requested size is 200x160, the multiple will be 4, for a QR of 132x132. These will
            // handle all the padding from 100x100 (the actual QR) up to 200x160.
            const leftPadding = Math.floor((outputWidth - inputWidth * multiple) / 2);
            const topPadding = Math.floor((outputHeight - inputHeight * multiple) / 2);
            const svgElement = this.createSVGElement(outputWidth, outputHeight);
            for(let inputY = 0, outputY = topPadding; inputY < inputHeight; inputY++, outputY += multiple){
                // Write the contents of this row of the barcode
                for(let inputX = 0, outputX = leftPadding; inputX < inputWidth; inputX++, outputX += multiple)if (input.get(inputX, inputY) === 1) {
                    const svgRectElement = this.createSvgRectElement(outputX, outputY, multiple, multiple);
                    svgElement.appendChild(svgRectElement);
                }
            }
            return svgElement;
        }
        /**
         * Creates a SVG element.
         *
         * @param w SVG's width attribute
         * @param h SVG's height attribute
         */ createSVGElement(w, h) {
            const svgElement = document.createElementNS(BrowserQRCodeSvgWriter.SVG_NS, 'svg');
            svgElement.setAttributeNS(null, 'height', w.toString());
            svgElement.setAttributeNS(null, 'width', h.toString());
            return svgElement;
        }
        /**
         * Creates a SVG rect element.
         *
         * @param x Element's x coordinate
         * @param y Element's y coordinate
         * @param w Element's width attribute
         * @param h Element's height attribute
         */ createSvgRectElement(x, y, w, h) {
            const rect = document.createElementNS(BrowserQRCodeSvgWriter.SVG_NS, 'rect');
            rect.setAttributeNS(null, 'x', x.toString());
            rect.setAttributeNS(null, 'y', y.toString());
            rect.setAttributeNS(null, 'height', w.toString());
            rect.setAttributeNS(null, 'width', h.toString());
            rect.setAttributeNS(null, 'fill', '#000000');
            return rect;
        }
    }
    BrowserQRCodeSvgWriter.QUIET_ZONE_SIZE = 4;
    /**
     * SVG markup NameSpace
     */ BrowserQRCodeSvgWriter.SVG_NS = 'http://www.w3.org/2000/svg';
    /*import java.util.Map;*/ /**
     * This object renders a QR Code as a BitMatrix 2D array of greyscale values.
     *
     * @author dswitkin@google.com (Daniel Switkin)
     */ class QRCodeWriter {
        /*@Override*/ // public encode(contents: string, format: BarcodeFormat, width: number /*int*/, height: number /*int*/): BitMatrix
        //     /*throws WriterException */ {
        //   return encode(contents, format, width, height, null)
        // }
        /*@Override*/ encode(contents, format, width /*int*/ , height /*int*/ , hints) {
            if (contents.length === 0) throw new IllegalArgumentException('Found empty contents');
            if (format !== BarcodeFormat$1.QR_CODE) throw new IllegalArgumentException('Can only encode QR_CODE, but got ' + format);
            if (width < 0 || height < 0) throw new IllegalArgumentException(`Requested dimensions are too small: ${width}x${height}`);
            let errorCorrectionLevel = ErrorCorrectionLevel.L;
            let quietZone = QRCodeWriter.QUIET_ZONE_SIZE;
            if (hints !== null) {
                if (undefined !== hints.get(EncodeHintType$1.ERROR_CORRECTION)) errorCorrectionLevel = ErrorCorrectionLevel.fromString(hints.get(EncodeHintType$1.ERROR_CORRECTION).toString());
                if (undefined !== hints.get(EncodeHintType$1.MARGIN)) quietZone = Number.parseInt(hints.get(EncodeHintType$1.MARGIN).toString(), 10);
            }
            const code = Encoder.encode(contents, errorCorrectionLevel, hints);
            return QRCodeWriter.renderResult(code, width, height, quietZone);
        }
        // Note that the input matrix uses 0 == white, 1 == black, while the output matrix uses
        // 0 == black, 255 == white (i.e. an 8 bit greyscale bitmap).
        static renderResult(code, width /*int*/ , height /*int*/ , quietZone /*int*/ ) {
            const input = code.getMatrix();
            if (input === null) throw new IllegalStateException();
            const inputWidth = input.getWidth();
            const inputHeight = input.getHeight();
            const qrWidth = inputWidth + quietZone * 2;
            const qrHeight = inputHeight + quietZone * 2;
            const outputWidth = Math.max(width, qrWidth);
            const outputHeight = Math.max(height, qrHeight);
            const multiple = Math.min(Math.floor(outputWidth / qrWidth), Math.floor(outputHeight / qrHeight));
            // Padding includes both the quiet zone and the extra white pixels to accommodate the requested
            // dimensions. For example, if input is 25x25 the QR will be 33x33 including the quiet zone.
            // If the requested size is 200x160, the multiple will be 4, for a QR of 132x132. These will
            // handle all the padding from 100x100 (the actual QR) up to 200x160.
            const leftPadding = Math.floor((outputWidth - inputWidth * multiple) / 2);
            const topPadding = Math.floor((outputHeight - inputHeight * multiple) / 2);
            const output = new BitMatrix(outputWidth, outputHeight);
            for(let inputY = 0, outputY = topPadding; inputY < inputHeight; inputY++, outputY += multiple){
                // Write the contents of this row of the barcode
                for(let inputX = 0, outputX = leftPadding; inputX < inputWidth; inputX++, outputX += multiple)if (input.get(inputX, inputY) === 1) output.setRegion(outputX, outputY, multiple, multiple);
            }
            return output;
        }
    }
    QRCodeWriter.QUIET_ZONE_SIZE = 4;
    /*import java.util.Map;*/ /**
     * This is a factory class which finds the appropriate Writer subclass for the BarcodeFormat
     * requested and encodes the barcode with the supplied contents.
     *
     * @author dswitkin@google.com (Daniel Switkin)
     */ class MultiFormatWriter {
        /*@Override*/ // public encode(contents: string,
        //                         format: BarcodeFormat,
        //                         width: number /*int*/,
        //                         height: number /*int*/): BitMatrix /*throws WriterException */ {
        //   return encode(contents, format, width, height, null)
        // }
        /*@Override*/ encode(contents, format, width /*int*/ , height /*int*/ , hints) {
            let writer;
            switch(format){
                // case BarcodeFormat.EAN_8:
                //   writer = new EAN8Writer()
                //   break
                // case BarcodeFormat.UPC_E:
                //   writer = new UPCEWriter()
                //   break
                // case BarcodeFormat.EAN_13:
                //   writer = new EAN13Writer()
                //   break
                // case BarcodeFormat.UPC_A:
                //   writer = new UPCAWriter()
                //   break
                case BarcodeFormat$1.QR_CODE:
                    writer = new QRCodeWriter();
                    break;
                // case BarcodeFormat.CODE_39:
                //   writer = new Code39Writer()
                //   break
                // case BarcodeFormat.CODE_93:
                //   writer = new Code93Writer()
                //   break
                // case BarcodeFormat.CODE_128:
                //   writer = new Code128Writer()
                //   break
                // case BarcodeFormat.ITF:
                //   writer = new ITFWriter()
                //   break
                // case BarcodeFormat.PDF_417:
                //   writer = new PDF417Writer()
                //   break
                // case BarcodeFormat.CODABAR:
                //   writer = new CodaBarWriter()
                //   break
                // case BarcodeFormat.DATA_MATRIX:
                //   writer = new DataMatrixWriter()
                //   break
                // case BarcodeFormat.AZTEC:
                //   writer = new AztecWriter()
                //   break
                default:
                    throw new IllegalArgumentException('No encoder available for format ' + format);
            }
            return writer.encode(contents, format, width, height, hints);
        }
    }
    /*
     * Copyright 2009 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * This object extends LuminanceSource around an array of YUV data returned from the camera driver,
     * with the option to crop to a rectangle within the full data. This can be used to exclude
     * superfluous pixels around the perimeter and speed up decoding.
     *
     * It works for any pixel format where the Y channel is planar and appears first, including
     * YCbCr_420_SP and YCbCr_422_SP.
     *
     * @author dswitkin@google.com (Daniel Switkin)
     */ class PlanarYUVLuminanceSource extends LuminanceSource {
        constructor(yuvData, dataWidth /*int*/ , dataHeight /*int*/ , left /*int*/ , top /*int*/ , width /*int*/ , height /*int*/ , reverseHorizontal){
            super(width, height);
            this.yuvData = yuvData;
            this.dataWidth = dataWidth;
            this.dataHeight = dataHeight;
            this.left = left;
            this.top = top;
            if (left + width > dataWidth || top + height > dataHeight) throw new IllegalArgumentException('Crop rectangle does not fit within image data.');
            if (reverseHorizontal) this.reverseHorizontal(width, height);
        }
        /*@Override*/ getRow(y /*int*/ , row) {
            if (y < 0 || y >= this.getHeight()) throw new IllegalArgumentException('Requested row is outside the image: ' + y);
            const width = this.getWidth();
            if (row === null || row === undefined || row.length < width) row = new Uint8ClampedArray(width);
            const offset = (y + this.top) * this.dataWidth + this.left;
            System.arraycopy(this.yuvData, offset, row, 0, width);
            return row;
        }
        /*@Override*/ getMatrix() {
            const width = this.getWidth();
            const height = this.getHeight();
            // If the caller asks for the entire underlying image, save the copy and give them the
            // original data. The docs specifically warn that result.length must be ignored.
            if (width === this.dataWidth && height === this.dataHeight) return this.yuvData;
            const area = width * height;
            const matrix = new Uint8ClampedArray(area);
            let inputOffset = this.top * this.dataWidth + this.left;
            // If the width matches the full width of the underlying data, perform a single copy.
            if (width === this.dataWidth) {
                System.arraycopy(this.yuvData, inputOffset, matrix, 0, area);
                return matrix;
            }
            // Otherwise copy one cropped row at a time.
            for(let y = 0; y < height; y++){
                const outputOffset = y * width;
                System.arraycopy(this.yuvData, inputOffset, matrix, outputOffset, width);
                inputOffset += this.dataWidth;
            }
            return matrix;
        }
        /*@Override*/ isCropSupported() {
            return true;
        }
        /*@Override*/ crop(left /*int*/ , top /*int*/ , width /*int*/ , height /*int*/ ) {
            return new PlanarYUVLuminanceSource(this.yuvData, this.dataWidth, this.dataHeight, this.left + left, this.top + top, width, height, false);
        }
        renderThumbnail() {
            const width = this.getWidth() / PlanarYUVLuminanceSource.THUMBNAIL_SCALE_FACTOR;
            const height = this.getHeight() / PlanarYUVLuminanceSource.THUMBNAIL_SCALE_FACTOR;
            const pixels = new Int32Array(width * height);
            const yuv = this.yuvData;
            let inputOffset = this.top * this.dataWidth + this.left;
            for(let y = 0; y < height; y++){
                const outputOffset = y * width;
                for(let x = 0; x < width; x++){
                    const grey = yuv[inputOffset + x * PlanarYUVLuminanceSource.THUMBNAIL_SCALE_FACTOR] & 0xff;
                    pixels[outputOffset + x] = 0xFF000000 | grey * 0x00010101;
                }
                inputOffset += this.dataWidth * PlanarYUVLuminanceSource.THUMBNAIL_SCALE_FACTOR;
            }
            return pixels;
        }
        /**
         * @return width of image from {@link #renderThumbnail()}
         */ getThumbnailWidth() {
            return this.getWidth() / PlanarYUVLuminanceSource.THUMBNAIL_SCALE_FACTOR;
        }
        /**
         * @return height of image from {@link #renderThumbnail()}
         */ getThumbnailHeight() {
            return this.getHeight() / PlanarYUVLuminanceSource.THUMBNAIL_SCALE_FACTOR;
        }
        reverseHorizontal(width /*int*/ , height /*int*/ ) {
            const yuvData = this.yuvData;
            for(let y = 0, rowStart = this.top * this.dataWidth + this.left; y < height; y++, rowStart += this.dataWidth){
                const middle = rowStart + width / 2;
                for(let x1 = rowStart, x2 = rowStart + width - 1; x1 < middle; x1++, x2--){
                    const temp = yuvData[x1];
                    yuvData[x1] = yuvData[x2];
                    yuvData[x2] = temp;
                }
            }
        }
        invert() {
            return new InvertedLuminanceSource(this);
        }
    }
    PlanarYUVLuminanceSource.THUMBNAIL_SCALE_FACTOR = 2;
    /*
     * Copyright 2009 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * This class is used to help decode images from files which arrive as RGB data from
     * an ARGB pixel array. It does not support rotation.
     *
     * @author dswitkin@google.com (Daniel Switkin)
     * @author Betaminos
     */ class RGBLuminanceSource extends LuminanceSource {
        constructor(luminances, width /*int*/ , height /*int*/ , dataWidth /*int*/ , dataHeight /*int*/ , left /*int*/ , top /*int*/ ){
            super(width, height);
            this.dataWidth = dataWidth;
            this.dataHeight = dataHeight;
            this.left = left;
            this.top = top;
            if (luminances.BYTES_PER_ELEMENT === 4) {
                const size = width * height;
                const luminancesUint8Array = new Uint8ClampedArray(size);
                for(let offset = 0; offset < size; offset++){
                    const pixel = luminances[offset];
                    const r = pixel >> 16 & 0xff; // red
                    const g2 = pixel >> 7 & 0x1fe; // 2 * green
                    const b = pixel & 0xff; // blue
                    // Calculate green-favouring average cheaply
                    luminancesUint8Array[offset] = (r + g2 + b) / 4 & 0xFF;
                }
                this.luminances = luminancesUint8Array;
            } else this.luminances = luminances;
            if (undefined === dataWidth) this.dataWidth = width;
            if (undefined === dataHeight) this.dataHeight = height;
            if (undefined === left) this.left = 0;
            if (undefined === top) this.top = 0;
            if (this.left + width > this.dataWidth || this.top + height > this.dataHeight) throw new IllegalArgumentException('Crop rectangle does not fit within image data.');
        }
        /*@Override*/ getRow(y /*int*/ , row) {
            if (y < 0 || y >= this.getHeight()) throw new IllegalArgumentException('Requested row is outside the image: ' + y);
            const width = this.getWidth();
            if (row === null || row === undefined || row.length < width) row = new Uint8ClampedArray(width);
            const offset = (y + this.top) * this.dataWidth + this.left;
            System.arraycopy(this.luminances, offset, row, 0, width);
            return row;
        }
        /*@Override*/ getMatrix() {
            const width = this.getWidth();
            const height = this.getHeight();
            // If the caller asks for the entire underlying image, save the copy and give them the
            // original data. The docs specifically warn that result.length must be ignored.
            if (width === this.dataWidth && height === this.dataHeight) return this.luminances;
            const area = width * height;
            const matrix = new Uint8ClampedArray(area);
            let inputOffset = this.top * this.dataWidth + this.left;
            // If the width matches the full width of the underlying data, perform a single copy.
            if (width === this.dataWidth) {
                System.arraycopy(this.luminances, inputOffset, matrix, 0, area);
                return matrix;
            }
            // Otherwise copy one cropped row at a time.
            for(let y = 0; y < height; y++){
                const outputOffset = y * width;
                System.arraycopy(this.luminances, inputOffset, matrix, outputOffset, width);
                inputOffset += this.dataWidth;
            }
            return matrix;
        }
        /*@Override*/ isCropSupported() {
            return true;
        }
        /*@Override*/ crop(left /*int*/ , top /*int*/ , width /*int*/ , height /*int*/ ) {
            return new RGBLuminanceSource(this.luminances, width, height, this.dataWidth, this.dataHeight, this.left + left, this.top + top);
        }
        invert() {
            return new InvertedLuminanceSource(this);
        }
    }
    /**
     * Just to make a shortcut between Java code and TS code.
     */ class Charset extends CharacterSetECI {
        static forName(name) {
            return this.getCharacterSetECIByName(name);
        }
    }
    /**
     * Just to make a shortcut between Java code and TS code.
     */ class StandardCharsets {
    }
    StandardCharsets.ISO_8859_1 = CharacterSetECI.ISO8859_1;
    /*
    * Copyright 2013 ZXing authors
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    *      http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    */ /**
     * Aztec 2D code representation
     *
     * @author Rustam Abdullaev
     */ /*public final*/ class AztecCode {
        /**
         * @return {@code true} if compact instead of full mode
         */ isCompact() {
            return this.compact;
        }
        setCompact(compact) {
            this.compact = compact;
        }
        /**
         * @return size in pixels (width and height)
         */ getSize() {
            return this.size;
        }
        setSize(size) {
            this.size = size;
        }
        /**
         * @return number of levels
         */ getLayers() {
            return this.layers;
        }
        setLayers(layers) {
            this.layers = layers;
        }
        /**
         * @return number of data codewords
         */ getCodeWords() {
            return this.codeWords;
        }
        setCodeWords(codeWords) {
            this.codeWords = codeWords;
        }
        /**
         * @return the symbol image
         */ getMatrix() {
            return this.matrix;
        }
        setMatrix(matrix) {
            this.matrix = matrix;
        }
    }
    class Collections {
        /**
         * The singletonList(T) method is used to return an immutable list containing only the specified object.
         */ static singletonList(item) {
            return [
                item
            ];
        }
        /**
         * The min(Collection<? extends T>, Comparator<? super T>) method is used to return the minimum element of the given collection, according to the order induced by the specified comparator.
         */ static min(collection, comparator) {
            return collection.sort(comparator)[0];
        }
    }
    /*
    * Copyright 2013 ZXing authors
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    *      http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    */ class Token {
        constructor(previous){
            this.previous = previous;
        }
        getPrevious() {
            return this.previous;
        }
    }
    /*
    * Copyright 2013 ZXing authors
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    *      http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    */ /*final*/ class SimpleToken extends Token {
        constructor(previous, value, bitCount){
            super(previous);
            this.value = value;
            this.bitCount = bitCount;
        }
        /**
         * @Override
         */ appendTo(bitArray, text) {
            bitArray.appendBits(this.value, this.bitCount);
        }
        add(value, bitCount) {
            return new SimpleToken(this, value, bitCount);
        }
        addBinaryShift(start, byteCount) {
            // no-op can't binary shift a simple token
            console.warn('addBinaryShift on SimpleToken, this simply returns a copy of this token');
            return new SimpleToken(this, start, byteCount);
        }
        /**
         * @Override
         */ toString() {
            let value = this.value & (1 << this.bitCount) - 1;
            value |= 1 << this.bitCount;
            return '<' + Integer.toBinaryString(value | 1 << this.bitCount).substring(1) + '>';
        }
    }
    /*
    * Copyright 2013 ZXing authors
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    *      http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    */ /*final*/ class BinaryShiftToken extends SimpleToken {
        constructor(previous, binaryShiftStart, binaryShiftByteCount){
            super(previous, 0, 0);
            this.binaryShiftStart = binaryShiftStart;
            this.binaryShiftByteCount = binaryShiftByteCount;
        }
        /**
         * @Override
         */ appendTo(bitArray, text) {
            for(let i = 0; i < this.binaryShiftByteCount; i++){
                if (i === 0 || i === 31 && this.binaryShiftByteCount <= 62) {
                    // We need a header before the first character, and before
                    // character 31 when the total byte code is <= 62
                    bitArray.appendBits(31, 5); // BINARY_SHIFT
                    if (this.binaryShiftByteCount > 62) bitArray.appendBits(this.binaryShiftByteCount - 31, 16);
                    else if (i === 0) // 1 <= binaryShiftByteCode <= 62
                    bitArray.appendBits(Math.min(this.binaryShiftByteCount, 31), 5);
                    else // 32 <= binaryShiftCount <= 62 and i == 31
                    bitArray.appendBits(this.binaryShiftByteCount - 31, 5);
                }
                bitArray.appendBits(text[this.binaryShiftStart + i], 8);
            }
        }
        addBinaryShift(start, byteCount) {
            // int bitCount = (byteCount * 8) + (byteCount <= 31 ? 10 : byteCount <= 62 ? 20 : 21);
            return new BinaryShiftToken(this, start, byteCount);
        }
        /**
         * @Override
         */ toString() {
            return '<' + this.binaryShiftStart + '::' + (this.binaryShiftStart + this.binaryShiftByteCount - 1) + '>';
        }
    }
    function addBinaryShift(token, start, byteCount) {
        // int bitCount = (byteCount * 8) + (byteCount <= 31 ? 10 : byteCount <= 62 ? 20 : 21);
        return new BinaryShiftToken(token, start, byteCount);
    }
    function add(token, value, bitCount) {
        return new SimpleToken(token, value, bitCount);
    }
    const /*final*/ MODE_NAMES = [
        'UPPER',
        'LOWER',
        'DIGIT',
        'MIXED',
        'PUNCT'
    ];
    const /*final*/ MODE_UPPER = 0; // 5 bits
    const /*final*/ MODE_LOWER = 1; // 5 bits
    const /*final*/ MODE_DIGIT = 2; // 4 bits
    const /*final*/ MODE_MIXED = 3; // 5 bits
    const /*final*/ MODE_PUNCT = 4; // 5 bits
    const EMPTY_TOKEN = new SimpleToken(null, 0, 0);
    // The Latch Table shows, for each pair of Modes, the optimal method for
    // getting from one mode to another.  In the worst possible case, this can
    // be up to 14 bits.  In the best possible case, we are already there!
    // The high half-word of each entry gives the number of bits.
    // The low half-word of each entry are the actual bits necessary to change
    const LATCH_TABLE = [
        Int32Array.from([
            0,
            327708,
            327710,
            327709,
            656318 // UPPER -> MIXED -> PUNCT
        ]),
        Int32Array.from([
            590318,
            0,
            327710,
            327709,
            656318 // LOWER -> MIXED -> PUNCT
        ]),
        Int32Array.from([
            262158,
            590300,
            0,
            590301,
            932798
        ]),
        Int32Array.from([
            327709,
            327708,
            656318,
            0,
            327710 // MIXED -> PUNCT
        ]),
        Int32Array.from([
            327711,
            656380,
            656382,
            656381,
            0
        ])
    ];
    function static_SHIFT_TABLE(SHIFT_TABLE) {
        for (let table /*Int32Array*/  of SHIFT_TABLE)Arrays.fill(table, -1);
        SHIFT_TABLE[MODE_UPPER][MODE_PUNCT] = 0;
        SHIFT_TABLE[MODE_LOWER][MODE_PUNCT] = 0;
        SHIFT_TABLE[MODE_LOWER][MODE_UPPER] = 28;
        SHIFT_TABLE[MODE_MIXED][MODE_PUNCT] = 0;
        SHIFT_TABLE[MODE_DIGIT][MODE_PUNCT] = 0;
        SHIFT_TABLE[MODE_DIGIT][MODE_UPPER] = 15;
        return SHIFT_TABLE;
    }
    const /*final*/ SHIFT_TABLE = static_SHIFT_TABLE(Arrays.createInt32Array(6, 6)); // mode shift codes, per table
    /*
     * Copyright 2013 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * State represents all information about a sequence necessary to generate the current output.
     * Note that a state is immutable.
     */ /*final*/ class State {
        constructor(token, mode, binaryBytes, bitCount){
            this.token = token;
            this.mode = mode;
            this.binaryShiftByteCount = binaryBytes;
            this.bitCount = bitCount;
        // Make sure we match the token
        // int binaryShiftBitCount = (binaryShiftByteCount * 8) +
        //    (binaryShiftByteCount === 0 ? 0 :
        //     binaryShiftByteCount <= 31 ? 10 :
        //     binaryShiftByteCount <= 62 ? 20 : 21);
        // assert this.bitCount === token.getTotalBitCount() + binaryShiftBitCount;
        }
        getMode() {
            return this.mode;
        }
        getToken() {
            return this.token;
        }
        getBinaryShiftByteCount() {
            return this.binaryShiftByteCount;
        }
        getBitCount() {
            return this.bitCount;
        }
        // Create a new state representing this state with a latch to a (not
        // necessary different) mode, and then a code.
        latchAndAppend(mode, value) {
            // assert binaryShiftByteCount === 0;
            let bitCount = this.bitCount;
            let token = this.token;
            if (mode !== this.mode) {
                let latch = LATCH_TABLE[this.mode][mode];
                token = add(token, latch & 0xffff, latch >> 16);
                bitCount += latch >> 16;
            }
            let latchModeBitCount = mode === MODE_DIGIT ? 4 : 5;
            token = add(token, value, latchModeBitCount);
            return new State(token, mode, 0, bitCount + latchModeBitCount);
        }
        // Create a new state representing this state, with a temporary shift
        // to a different mode to output a single value.
        shiftAndAppend(mode, value) {
            // assert binaryShiftByteCount === 0 && this.mode !== mode;
            let token = this.token;
            let thisModeBitCount = this.mode === MODE_DIGIT ? 4 : 5;
            // Shifts exist only to UPPER and PUNCT, both with tokens size 5.
            token = add(token, SHIFT_TABLE[this.mode][mode], thisModeBitCount);
            token = add(token, value, 5);
            return new State(token, this.mode, 0, this.bitCount + thisModeBitCount + 5);
        }
        // Create a new state representing this state, but an additional character
        // output in Binary Shift mode.
        addBinaryShiftChar(index) {
            let token = this.token;
            let mode = this.mode;
            let bitCount = this.bitCount;
            if (this.mode === MODE_PUNCT || this.mode === MODE_DIGIT) {
                // assert binaryShiftByteCount === 0;
                let latch = LATCH_TABLE[mode][MODE_UPPER];
                token = add(token, latch & 0xffff, latch >> 16);
                bitCount += latch >> 16;
                mode = MODE_UPPER;
            }
            let deltaBitCount = this.binaryShiftByteCount === 0 || this.binaryShiftByteCount === 31 ? 18 : this.binaryShiftByteCount === 62 ? 9 : 8;
            let result = new State(token, mode, this.binaryShiftByteCount + 1, bitCount + deltaBitCount);
            if (result.binaryShiftByteCount === 2078) // The string is as long as it's allowed to be.  We should end it.
            result = result.endBinaryShift(index + 1);
            return result;
        }
        // Create the state identical to this one, but we are no longer in
        // Binary Shift mode.
        endBinaryShift(index) {
            if (this.binaryShiftByteCount === 0) return this;
            let token = this.token;
            token = addBinaryShift(token, index - this.binaryShiftByteCount, this.binaryShiftByteCount);
            // assert token.getTotalBitCount() === this.bitCount;
            return new State(token, this.mode, 0, this.bitCount);
        }
        // Returns true if "this" state is better (equal: or) to be in than "that"
        // state under all possible circumstances.
        isBetterThanOrEqualTo(other) {
            let newModeBitCount = this.bitCount + (LATCH_TABLE[this.mode][other.mode] >> 16);
            if (this.binaryShiftByteCount < other.binaryShiftByteCount) // add additional B/S encoding cost of other, if any
            newModeBitCount += State.calculateBinaryShiftCost(other) - State.calculateBinaryShiftCost(this);
            else if (this.binaryShiftByteCount > other.binaryShiftByteCount && other.binaryShiftByteCount > 0) // maximum possible additional cost (it: h)
            newModeBitCount += 10;
            return newModeBitCount <= other.bitCount;
        }
        toBitArray(text) {
            // Reverse the tokens, so that they are in the order that they should
            // be output
            let symbols = [];
            for(let token = this.endBinaryShift(text.length).token; token !== null; token = token.getPrevious())symbols.unshift(token);
            let bitArray = new BitArray();
            // Add each token to the result.
            for (const symbol of symbols)symbol.appendTo(bitArray, text);
            // assert bitArray.getSize() === this.bitCount;
            return bitArray;
        }
        /**
         * @Override
         */ toString() {
            return StringUtils.format('%s bits=%d bytes=%d', MODE_NAMES[this.mode], this.bitCount, this.binaryShiftByteCount);
        }
        static calculateBinaryShiftCost(state) {
            if (state.binaryShiftByteCount > 62) return 21; // B/S with extended length
            if (state.binaryShiftByteCount > 31) return 20; // two B/S
            if (state.binaryShiftByteCount > 0) return 10; // one B/S
            return 0;
        }
    }
    State.INITIAL_STATE = new State(EMPTY_TOKEN, MODE_UPPER, 0, 0);
    function static_CHAR_MAP(CHAR_MAP) {
        const spaceCharCode = StringUtils.getCharCode(' ');
        const pointCharCode = StringUtils.getCharCode('.');
        const commaCharCode = StringUtils.getCharCode(',');
        CHAR_MAP[MODE_UPPER][spaceCharCode] = 1;
        const zUpperCharCode = StringUtils.getCharCode('Z');
        const aUpperCharCode = StringUtils.getCharCode('A');
        for(let c = aUpperCharCode; c <= zUpperCharCode; c++)CHAR_MAP[MODE_UPPER][c] = c - aUpperCharCode + 2;
        CHAR_MAP[MODE_LOWER][spaceCharCode] = 1;
        const zLowerCharCode = StringUtils.getCharCode('z');
        const aLowerCharCode = StringUtils.getCharCode('a');
        for(let c = aLowerCharCode; c <= zLowerCharCode; c++)CHAR_MAP[MODE_LOWER][c] = c - aLowerCharCode + 2;
        CHAR_MAP[MODE_DIGIT][spaceCharCode] = 1;
        const nineCharCode = StringUtils.getCharCode('9');
        const zeroCharCode = StringUtils.getCharCode('0');
        for(let c = zeroCharCode; c <= nineCharCode; c++)CHAR_MAP[MODE_DIGIT][c] = c - zeroCharCode + 2;
        CHAR_MAP[MODE_DIGIT][commaCharCode] = 12;
        CHAR_MAP[MODE_DIGIT][pointCharCode] = 13;
        const mixedTable = [
            '\x00',
            ' ',
            '\x01',
            '\x02',
            '\x03',
            '\x04',
            '\x05',
            '\x06',
            '\x07',
            '\b',
            '\t',
            '\n',
            '\x0b',
            '\f',
            '\r',
            '\x1b',
            '\x1c',
            '\x1d',
            '\x1e',
            '\x1f',
            '@',
            '\\',
            '^',
            '_',
            '`',
            '|',
            '~',
            '\x7f'
        ];
        for(let i = 0; i < mixedTable.length; i++)CHAR_MAP[MODE_MIXED][StringUtils.getCharCode(mixedTable[i])] = i;
        const punctTable = [
            '\x00',
            '\r',
            '\x00',
            '\x00',
            '\x00',
            '\x00',
            '!',
            '\'',
            '#',
            '$',
            '%',
            '&',
            '\'',
            '(',
            ')',
            '*',
            '+',
            ',',
            '-',
            '.',
            '/',
            ':',
            ';',
            '<',
            '=',
            '>',
            '?',
            '[',
            ']',
            '{',
            '}'
        ];
        for(let i = 0; i < punctTable.length; i++)if (StringUtils.getCharCode(punctTable[i]) > 0) CHAR_MAP[MODE_PUNCT][StringUtils.getCharCode(punctTable[i])] = i;
        return CHAR_MAP;
    }
    const CHAR_MAP = static_CHAR_MAP(Arrays.createInt32Array(5, 256));
    /*
     * Copyright 2013 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * This produces nearly optimal encodings of text into the first-level of
     * encoding used by Aztec code.
     *
     * It uses a dynamic algorithm.  For each prefix of the string, it determines
     * a set of encodings that could lead to this prefix.  We repeatedly add a
     * character and generate a new set of optimal encodings until we have read
     * through the entire input.
     *
     * @author Frank Yellin
     * @author Rustam Abdullaev
     */ /*public final*/ class HighLevelEncoder {
        constructor(text){
            this.text = text;
        }
        /**
         * @return text represented by this encoder encoded as a {@link BitArray}
         */ encode() {
            const spaceCharCode = StringUtils.getCharCode(' ');
            const lineBreakCharCode = StringUtils.getCharCode('\n');
            let states = Collections.singletonList(State.INITIAL_STATE);
            for(let index = 0; index < this.text.length; index++){
                let pairCode;
                let nextChar = index + 1 < this.text.length ? this.text[index + 1] : 0;
                switch(this.text[index]){
                    case StringUtils.getCharCode('\r'):
                        pairCode = nextChar === lineBreakCharCode ? 2 : 0;
                        break;
                    case StringUtils.getCharCode('.'):
                        pairCode = nextChar === spaceCharCode ? 3 : 0;
                        break;
                    case StringUtils.getCharCode(','):
                        pairCode = nextChar === spaceCharCode ? 4 : 0;
                        break;
                    case StringUtils.getCharCode(':'):
                        pairCode = nextChar === spaceCharCode ? 5 : 0;
                        break;
                    default:
                        pairCode = 0;
                }
                if (pairCode > 0) {
                    // We have one of the four special PUNCT pairs.  Treat them specially.
                    // Get a new set of states for the two new characters.
                    states = HighLevelEncoder.updateStateListForPair(states, index, pairCode);
                    index++;
                } else // Get a new set of states for the new character.
                states = this.updateStateListForChar(states, index);
            }
            // We are left with a set of states.  Find the shortest one.
            const minState = Collections.min(states, (a, b)=>{
                return a.getBitCount() - b.getBitCount();
            });
            // Convert it to a bit array, and return.
            return minState.toBitArray(this.text);
        }
        // We update a set of states for a new character by updating each state
        // for the new character, merging the results, and then removing the
        // non-optimal states.
        updateStateListForChar(states, index) {
            const result = [];
            for (let state /*State*/  of states)this.updateStateForChar(state, index, result);
            return HighLevelEncoder.simplifyStates(result);
        }
        // Return a set of states that represent the possible ways of updating this
        // state for the next character.  The resulting set of states are added to
        // the "result" list.
        updateStateForChar(state, index, result) {
            let ch = this.text[index] & 0xff;
            let charInCurrentTable = CHAR_MAP[state.getMode()][ch] > 0;
            let stateNoBinary = null;
            for(let mode /*int*/  = 0; mode <= MODE_PUNCT; mode++){
                let charInMode = CHAR_MAP[mode][ch];
                if (charInMode > 0) {
                    if (stateNoBinary == null) // Only create stateNoBinary the first time it's required.
                    stateNoBinary = state.endBinaryShift(index);
                    // Try generating the character by latching to its mode
                    if (!charInCurrentTable || mode === state.getMode() || mode === MODE_DIGIT) {
                        // If the character is in the current table, we don't want to latch to
                        // any other mode except possibly digit (which uses only 4 bits).  Any
                        // other latch would be equally successful *after* this character, and
                        // so wouldn't save any bits.
                        const latchState = stateNoBinary.latchAndAppend(mode, charInMode);
                        result.push(latchState);
                    }
                    // Try generating the character by switching to its mode.
                    if (!charInCurrentTable && SHIFT_TABLE[state.getMode()][mode] >= 0) {
                        // It never makes sense to temporarily shift to another mode if the
                        // character exists in the current mode.  That can never save bits.
                        const shiftState = stateNoBinary.shiftAndAppend(mode, charInMode);
                        result.push(shiftState);
                    }
                }
            }
            if (state.getBinaryShiftByteCount() > 0 || CHAR_MAP[state.getMode()][ch] === 0) {
                // It's never worthwhile to go into binary shift mode if you're not already
                // in binary shift mode, and the character exists in your current mode.
                // That can never save bits over just outputting the char in the current mode.
                let binaryState = state.addBinaryShiftChar(index);
                result.push(binaryState);
            }
        }
        static updateStateListForPair(states, index, pairCode) {
            const result = [];
            for (let state /*State*/  of states)this.updateStateForPair(state, index, pairCode, result);
            return this.simplifyStates(result);
        }
        static updateStateForPair(state, index, pairCode, result) {
            let stateNoBinary = state.endBinaryShift(index);
            // Possibility 1.  Latch to C.MODE_PUNCT, and then append this code
            result.push(stateNoBinary.latchAndAppend(MODE_PUNCT, pairCode));
            if (state.getMode() !== MODE_PUNCT) // Possibility 2.  Shift to C.MODE_PUNCT, and then append this code.
            // Every state except C.MODE_PUNCT (handled above) can shift
            result.push(stateNoBinary.shiftAndAppend(MODE_PUNCT, pairCode));
            if (pairCode === 3 || pairCode === 4) {
                // both characters are in DIGITS.  Sometimes better to just add two digits
                let digitState = stateNoBinary.latchAndAppend(MODE_DIGIT, 16 - pairCode) // period or comma in DIGIT
                .latchAndAppend(MODE_DIGIT, 1); // space in DIGIT
                result.push(digitState);
            }
            if (state.getBinaryShiftByteCount() > 0) {
                // It only makes sense to do the characters as binary if we're already
                // in binary mode.
                let binaryState = state.addBinaryShiftChar(index).addBinaryShiftChar(index + 1);
                result.push(binaryState);
            }
        }
        static simplifyStates(states) {
            let result = [];
            for (const newState of states){
                let add = true;
                for (const oldState of result){
                    if (oldState.isBetterThanOrEqualTo(newState)) {
                        add = false;
                        break;
                    }
                    if (newState.isBetterThanOrEqualTo(oldState)) // iterator.remove();
                    result = result.filter((x)=>x !== oldState); // remove old state
                }
                if (add) result.push(newState);
            }
            return result;
        }
    }
    /*
     * Copyright 2013 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ // package com.google.zxing.aztec.encoder;
    // import com.google.zxing.common.BitArray;
    // import com.google.zxing.common.BitMatrix;
    // import com.google.zxing.common.reedsolomon.GenericGF;
    // import com.google.zxing.common.reedsolomon.ReedSolomonEncoder;
    /**
     * Generates Aztec 2D barcodes.
     *
     * @author Rustam Abdullaev
     */ /*public final*/ class Encoder$1 {
        constructor(){}
        /**
         * Encodes the given binary content as an Aztec symbol
         *
         * @param data input data string
         * @return Aztec symbol matrix with metadata
         */ static encodeBytes(data) {
            return Encoder$1.encode(data, Encoder$1.DEFAULT_EC_PERCENT, Encoder$1.DEFAULT_AZTEC_LAYERS);
        }
        /**
         * Encodes the given binary content as an Aztec symbol
         *
         * @param data input data string
         * @param minECCPercent minimal percentage of error check words (According to ISO/IEC 24778:2008,
         *                      a minimum of 23% + 3 words is recommended)
         * @param userSpecifiedLayers if non-zero, a user-specified value for the number of layers
         * @return Aztec symbol matrix with metadata
         */ static encode(data, minECCPercent, userSpecifiedLayers) {
            // High-level encode
            let bits = new HighLevelEncoder(data).encode();
            // stuff bits and choose symbol size
            let eccBits = Integer.truncDivision(bits.getSize() * minECCPercent, 100) + 11;
            let totalSizeBits = bits.getSize() + eccBits;
            let compact;
            let layers;
            let totalBitsInLayer;
            let wordSize;
            let stuffedBits;
            if (userSpecifiedLayers !== Encoder$1.DEFAULT_AZTEC_LAYERS) {
                compact = userSpecifiedLayers < 0;
                layers = Math.abs(userSpecifiedLayers);
                if (layers > (compact ? Encoder$1.MAX_NB_BITS_COMPACT : Encoder$1.MAX_NB_BITS)) throw new IllegalArgumentException(StringUtils.format('Illegal value %s for layers', userSpecifiedLayers));
                totalBitsInLayer = Encoder$1.totalBitsInLayer(layers, compact);
                wordSize = Encoder$1.WORD_SIZE[layers];
                let usableBitsInLayers = totalBitsInLayer - totalBitsInLayer % wordSize;
                stuffedBits = Encoder$1.stuffBits(bits, wordSize);
                if (stuffedBits.getSize() + eccBits > usableBitsInLayers) throw new IllegalArgumentException('Data to large for user specified layer');
                if (compact && stuffedBits.getSize() > wordSize * 64) // Compact format only allows 64 data words, though C4 can hold more words than that
                throw new IllegalArgumentException('Data to large for user specified layer');
            } else {
                wordSize = 0;
                stuffedBits = null;
                // We look at the possible table sizes in the order Compact1, Compact2, Compact3,
                // Compact4, Normal4,...  Normal(i) for i < 4 isn't typically used since Compact(i+1)
                // is the same size, but has more data.
                for(let i /*int*/  = 0;; i++){
                    if (i > Encoder$1.MAX_NB_BITS) throw new IllegalArgumentException('Data too large for an Aztec code');
                    compact = i <= 3;
                    layers = compact ? i + 1 : i;
                    totalBitsInLayer = Encoder$1.totalBitsInLayer(layers, compact);
                    if (totalSizeBits > totalBitsInLayer) continue;
                    // [Re]stuff the bits if this is the first opportunity, or if the
                    // wordSize has changed
                    if (stuffedBits == null || wordSize !== Encoder$1.WORD_SIZE[layers]) {
                        wordSize = Encoder$1.WORD_SIZE[layers];
                        stuffedBits = Encoder$1.stuffBits(bits, wordSize);
                    }
                    let usableBitsInLayers = totalBitsInLayer - totalBitsInLayer % wordSize;
                    if (compact && stuffedBits.getSize() > wordSize * 64) continue;
                    if (stuffedBits.getSize() + eccBits <= usableBitsInLayers) break;
                }
            }
            let messageBits = Encoder$1.generateCheckWords(stuffedBits, totalBitsInLayer, wordSize);
            // generate mode message
            let messageSizeInWords = stuffedBits.getSize() / wordSize;
            let modeMessage = Encoder$1.generateModeMessage(compact, layers, messageSizeInWords);
            // allocate symbol
            let baseMatrixSize = (compact ? 11 : 14) + layers * 4; // not including alignment lines
            let alignmentMap = new Int32Array(baseMatrixSize);
            let matrixSize;
            if (compact) {
                // no alignment marks in compact mode, alignmentMap is a no-op
                matrixSize = baseMatrixSize;
                for(let i /*int*/  = 0; i < alignmentMap.length; i++)alignmentMap[i] = i;
            } else {
                matrixSize = baseMatrixSize + 1 + 2 * Integer.truncDivision(Integer.truncDivision(baseMatrixSize, 2) - 1, 15);
                let origCenter = Integer.truncDivision(baseMatrixSize, 2);
                let center = Integer.truncDivision(matrixSize, 2);
                for(let i /*int*/  = 0; i < origCenter; i++){
                    let newOffset = i + Integer.truncDivision(i, 15);
                    alignmentMap[origCenter - i - 1] = center - newOffset - 1;
                    alignmentMap[origCenter + i] = center + newOffset + 1;
                }
            }
            let matrix = new BitMatrix(matrixSize);
            // draw data bits
            for(let i /*int*/  = 0, rowOffset = 0; i < layers; i++){
                let rowSize = (layers - i) * 4 + (compact ? 9 : 12);
                for(let j /*int*/  = 0; j < rowSize; j++){
                    let columnOffset = j * 2;
                    for(let k /*int*/  = 0; k < 2; k++){
                        if (messageBits.get(rowOffset + columnOffset + k)) matrix.set(alignmentMap[i * 2 + k], alignmentMap[i * 2 + j]);
                        if (messageBits.get(rowOffset + rowSize * 2 + columnOffset + k)) matrix.set(alignmentMap[i * 2 + j], alignmentMap[baseMatrixSize - 1 - i * 2 - k]);
                        if (messageBits.get(rowOffset + rowSize * 4 + columnOffset + k)) matrix.set(alignmentMap[baseMatrixSize - 1 - i * 2 - k], alignmentMap[baseMatrixSize - 1 - i * 2 - j]);
                        if (messageBits.get(rowOffset + rowSize * 6 + columnOffset + k)) matrix.set(alignmentMap[baseMatrixSize - 1 - i * 2 - j], alignmentMap[i * 2 + k]);
                    }
                }
                rowOffset += rowSize * 8;
            }
            // draw mode message
            Encoder$1.drawModeMessage(matrix, compact, matrixSize, modeMessage);
            // draw alignment marks
            if (compact) Encoder$1.drawBullsEye(matrix, Integer.truncDivision(matrixSize, 2), 5);
            else {
                Encoder$1.drawBullsEye(matrix, Integer.truncDivision(matrixSize, 2), 7);
                for(let i /*int*/  = 0, j = 0; i < Integer.truncDivision(baseMatrixSize, 2) - 1; i += 15, j += 16)for(let k /*int*/  = Integer.truncDivision(matrixSize, 2) & 1; k < matrixSize; k += 2){
                    matrix.set(Integer.truncDivision(matrixSize, 2) - j, k);
                    matrix.set(Integer.truncDivision(matrixSize, 2) + j, k);
                    matrix.set(k, Integer.truncDivision(matrixSize, 2) - j);
                    matrix.set(k, Integer.truncDivision(matrixSize, 2) + j);
                }
            }
            let aztec = new AztecCode();
            aztec.setCompact(compact);
            aztec.setSize(matrixSize);
            aztec.setLayers(layers);
            aztec.setCodeWords(messageSizeInWords);
            aztec.setMatrix(matrix);
            return aztec;
        }
        static drawBullsEye(matrix, center, size) {
            for(let i /*int*/  = 0; i < size; i += 2)for(let j /*int*/  = center - i; j <= center + i; j++){
                matrix.set(j, center - i);
                matrix.set(j, center + i);
                matrix.set(center - i, j);
                matrix.set(center + i, j);
            }
            matrix.set(center - size, center - size);
            matrix.set(center - size + 1, center - size);
            matrix.set(center - size, center - size + 1);
            matrix.set(center + size, center - size);
            matrix.set(center + size, center - size + 1);
            matrix.set(center + size, center + size - 1);
        }
        static generateModeMessage(compact, layers, messageSizeInWords) {
            let modeMessage = new BitArray();
            if (compact) {
                modeMessage.appendBits(layers - 1, 2);
                modeMessage.appendBits(messageSizeInWords - 1, 6);
                modeMessage = Encoder$1.generateCheckWords(modeMessage, 28, 4);
            } else {
                modeMessage.appendBits(layers - 1, 5);
                modeMessage.appendBits(messageSizeInWords - 1, 11);
                modeMessage = Encoder$1.generateCheckWords(modeMessage, 40, 4);
            }
            return modeMessage;
        }
        static drawModeMessage(matrix, compact, matrixSize, modeMessage) {
            let center = Integer.truncDivision(matrixSize, 2);
            if (compact) for(let i /*int*/  = 0; i < 7; i++){
                let offset = center - 3 + i;
                if (modeMessage.get(i)) matrix.set(offset, center - 5);
                if (modeMessage.get(i + 7)) matrix.set(center + 5, offset);
                if (modeMessage.get(20 - i)) matrix.set(offset, center + 5);
                if (modeMessage.get(27 - i)) matrix.set(center - 5, offset);
            }
            else for(let i /*int*/  = 0; i < 10; i++){
                let offset = center - 5 + i + Integer.truncDivision(i, 5);
                if (modeMessage.get(i)) matrix.set(offset, center - 7);
                if (modeMessage.get(i + 10)) matrix.set(center + 7, offset);
                if (modeMessage.get(29 - i)) matrix.set(offset, center + 7);
                if (modeMessage.get(39 - i)) matrix.set(center - 7, offset);
            }
        }
        static generateCheckWords(bitArray, totalBits, wordSize) {
            // bitArray is guaranteed to be a multiple of the wordSize, so no padding needed
            let messageSizeInWords = bitArray.getSize() / wordSize;
            let rs = new ReedSolomonEncoder(Encoder$1.getGF(wordSize));
            let totalWords = Integer.truncDivision(totalBits, wordSize);
            let messageWords = Encoder$1.bitsToWords(bitArray, wordSize, totalWords);
            rs.encode(messageWords, totalWords - messageSizeInWords);
            let startPad = totalBits % wordSize;
            let messageBits = new BitArray();
            messageBits.appendBits(0, startPad);
            for (const messageWord /*: int*/  of Array.from(messageWords))messageBits.appendBits(messageWord, wordSize);
            return messageBits;
        }
        static bitsToWords(stuffedBits, wordSize, totalWords) {
            let message = new Int32Array(totalWords);
            let i;
            let n;
            for(i = 0, n = stuffedBits.getSize() / wordSize; i < n; i++){
                let value = 0;
                for(let j /*int*/  = 0; j < wordSize; j++)value |= stuffedBits.get(i * wordSize + j) ? 1 << wordSize - j - 1 : 0;
                message[i] = value;
            }
            return message;
        }
        static getGF(wordSize) {
            switch(wordSize){
                case 4:
                    return GenericGF.AZTEC_PARAM;
                case 6:
                    return GenericGF.AZTEC_DATA_6;
                case 8:
                    return GenericGF.AZTEC_DATA_8;
                case 10:
                    return GenericGF.AZTEC_DATA_10;
                case 12:
                    return GenericGF.AZTEC_DATA_12;
                default:
                    throw new IllegalArgumentException('Unsupported word size ' + wordSize);
            }
        }
        static stuffBits(bits, wordSize) {
            let out = new BitArray();
            let n = bits.getSize();
            let mask = (1 << wordSize) - 2;
            for(let i /*int*/  = 0; i < n; i += wordSize){
                let word = 0;
                for(let j /*int*/  = 0; j < wordSize; j++)if (i + j >= n || bits.get(i + j)) word |= 1 << wordSize - 1 - j;
                if ((word & mask) === mask) {
                    out.appendBits(word & mask, wordSize);
                    i--;
                } else if ((word & mask) === 0) {
                    out.appendBits(word | 1, wordSize);
                    i--;
                } else out.appendBits(word, wordSize);
            }
            return out;
        }
        static totalBitsInLayer(layers, compact) {
            return ((compact ? 88 : 112) + 16 * layers) * layers;
        }
    }
    Encoder$1.DEFAULT_EC_PERCENT = 33; // default minimal percentage of error check words
    Encoder$1.DEFAULT_AZTEC_LAYERS = 0;
    Encoder$1.MAX_NB_BITS = 32;
    Encoder$1.MAX_NB_BITS_COMPACT = 4;
    Encoder$1.WORD_SIZE = Int32Array.from([
        4,
        6,
        6,
        8,
        8,
        8,
        8,
        8,
        8,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        12,
        12,
        12,
        12,
        12,
        12,
        12,
        12,
        12,
        12
    ]);
    /*
    * Copyright 2013 ZXing authors
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    *      http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    */ /**
     * Renders an Aztec code as a {@link BitMatrix}.
     */ /*public final*/ class AztecWriter {
        // @Override
        encode(contents, format, width, height) {
            return this.encodeWithHints(contents, format, width, height, null);
        }
        // @Override
        encodeWithHints(contents, format, width, height, hints) {
            let charset = StandardCharsets.ISO_8859_1;
            let eccPercent = Encoder$1.DEFAULT_EC_PERCENT;
            let layers = Encoder$1.DEFAULT_AZTEC_LAYERS;
            if (hints != null) {
                if (hints.has(EncodeHintType$1.CHARACTER_SET)) charset = Charset.forName(hints.get(EncodeHintType$1.CHARACTER_SET).toString());
                if (hints.has(EncodeHintType$1.ERROR_CORRECTION)) eccPercent = Integer.parseInt(hints.get(EncodeHintType$1.ERROR_CORRECTION).toString());
                if (hints.has(EncodeHintType$1.AZTEC_LAYERS)) layers = Integer.parseInt(hints.get(EncodeHintType$1.AZTEC_LAYERS).toString());
            }
            return AztecWriter.encodeLayers(contents, format, width, height, charset, eccPercent, layers);
        }
        static encodeLayers(contents, format, width, height, charset, eccPercent, layers) {
            if (format !== BarcodeFormat$1.AZTEC) throw new IllegalArgumentException('Can only encode AZTEC, but got ' + format);
            let aztec = Encoder$1.encode(StringUtils.getBytes(contents, charset), eccPercent, layers);
            return AztecWriter.renderResult(aztec, width, height);
        }
        static renderResult(code, width, height) {
            let input = code.getMatrix();
            if (input == null) throw new IllegalStateException();
            let inputWidth = input.getWidth();
            let inputHeight = input.getHeight();
            let outputWidth = Math.max(width, inputWidth);
            let outputHeight = Math.max(height, inputHeight);
            let multiple = Math.min(outputWidth / inputWidth, outputHeight / inputHeight);
            let leftPadding = (outputWidth - inputWidth * multiple) / 2;
            let topPadding = (outputHeight - inputHeight * multiple) / 2;
            let output = new BitMatrix(outputWidth, outputHeight);
            for(let inputY /*int*/  = 0, outputY = topPadding; inputY < inputHeight; inputY++, outputY += multiple){
                // Write the contents of this row of the barcode
                for(let inputX /*int*/  = 0, outputX = leftPadding; inputX < inputWidth; inputX++, outputX += multiple)if (input.get(inputX, inputY)) output.setRegion(outputX, outputY, multiple, multiple);
            }
            return output;
        }
    }
    exports1.AbstractExpandedDecoder = AbstractExpandedDecoder;
    exports1.ArgumentException = ArgumentException;
    exports1.ArithmeticException = ArithmeticException;
    exports1.AztecCode = AztecCode;
    exports1.AztecCodeReader = AztecReader;
    exports1.AztecCodeWriter = AztecWriter;
    exports1.AztecDecoder = Decoder;
    exports1.AztecDetector = Detector;
    exports1.AztecDetectorResult = AztecDetectorResult;
    exports1.AztecEncoder = Encoder$1;
    exports1.AztecHighLevelEncoder = HighLevelEncoder;
    exports1.AztecPoint = Point;
    exports1.BarcodeFormat = BarcodeFormat$1;
    exports1.Binarizer = Binarizer;
    exports1.BinaryBitmap = BinaryBitmap;
    exports1.BitArray = BitArray;
    exports1.BitMatrix = BitMatrix;
    exports1.BitSource = BitSource;
    exports1.BrowserAztecCodeReader = BrowserAztecCodeReader;
    exports1.BrowserBarcodeReader = BrowserBarcodeReader;
    exports1.BrowserCodeReader = BrowserCodeReader;
    exports1.BrowserDatamatrixCodeReader = BrowserDatamatrixCodeReader;
    exports1.BrowserMultiFormatReader = BrowserMultiFormatReader;
    exports1.BrowserPDF417Reader = BrowserPDF417Reader;
    exports1.BrowserQRCodeReader = BrowserQRCodeReader;
    exports1.BrowserQRCodeSvgWriter = BrowserQRCodeSvgWriter;
    exports1.CharacterSetECI = CharacterSetECI;
    exports1.ChecksumException = ChecksumException;
    exports1.Code128Reader = Code128Reader;
    exports1.Code39Reader = Code39Reader;
    exports1.DataMatrixDecodedBitStreamParser = DecodedBitStreamParser;
    exports1.DataMatrixReader = DataMatrixReader;
    exports1.DecodeHintType = DecodeHintType$1;
    exports1.DecoderResult = DecoderResult;
    exports1.DefaultGridSampler = DefaultGridSampler;
    exports1.DetectorResult = DetectorResult;
    exports1.EAN13Reader = EAN13Reader;
    exports1.EncodeHintType = EncodeHintType$1;
    exports1.Exception = Exception;
    exports1.FormatException = FormatException;
    exports1.GenericGF = GenericGF;
    exports1.GenericGFPoly = GenericGFPoly;
    exports1.GlobalHistogramBinarizer = GlobalHistogramBinarizer;
    exports1.GridSampler = GridSampler;
    exports1.GridSamplerInstance = GridSamplerInstance;
    exports1.HTMLCanvasElementLuminanceSource = HTMLCanvasElementLuminanceSource;
    exports1.HybridBinarizer = HybridBinarizer;
    exports1.ITFReader = ITFReader;
    exports1.IllegalArgumentException = IllegalArgumentException;
    exports1.IllegalStateException = IllegalStateException;
    exports1.InvertedLuminanceSource = InvertedLuminanceSource;
    exports1.LuminanceSource = LuminanceSource;
    exports1.MathUtils = MathUtils;
    exports1.MultiFormatOneDReader = MultiFormatOneDReader;
    exports1.MultiFormatReader = MultiFormatReader;
    exports1.MultiFormatWriter = MultiFormatWriter;
    exports1.NotFoundException = NotFoundException;
    exports1.OneDReader = OneDReader;
    exports1.PDF417DecodedBitStreamParser = DecodedBitStreamParser$2;
    exports1.PDF417DecoderErrorCorrection = ErrorCorrection;
    exports1.PDF417Reader = PDF417Reader;
    exports1.PDF417ResultMetadata = PDF417ResultMetadata;
    exports1.PerspectiveTransform = PerspectiveTransform;
    exports1.PlanarYUVLuminanceSource = PlanarYUVLuminanceSource;
    exports1.QRCodeByteMatrix = ByteMatrix;
    exports1.QRCodeDataMask = DataMask;
    exports1.QRCodeDecodedBitStreamParser = DecodedBitStreamParser$1;
    exports1.QRCodeDecoderErrorCorrectionLevel = ErrorCorrectionLevel;
    exports1.QRCodeDecoderFormatInformation = FormatInformation;
    exports1.QRCodeEncoder = Encoder;
    exports1.QRCodeEncoderQRCode = QRCode;
    exports1.QRCodeMaskUtil = MaskUtil;
    exports1.QRCodeMatrixUtil = MatrixUtil;
    exports1.QRCodeMode = Mode$1;
    exports1.QRCodeReader = QRCodeReader;
    exports1.QRCodeVersion = Version$1;
    exports1.QRCodeWriter = QRCodeWriter;
    exports1.RGBLuminanceSource = RGBLuminanceSource;
    exports1.RSS14Reader = RSS14Reader;
    exports1.RSSExpandedReader = RSSExpandedReader;
    exports1.ReaderException = ReaderException;
    exports1.ReedSolomonDecoder = ReedSolomonDecoder;
    exports1.ReedSolomonEncoder = ReedSolomonEncoder;
    exports1.ReedSolomonException = ReedSolomonException;
    exports1.Result = Result;
    exports1.ResultMetadataType = ResultMetadataType$1;
    exports1.ResultPoint = ResultPoint;
    exports1.StringUtils = StringUtils;
    exports1.UnsupportedOperationException = UnsupportedOperationException;
    exports1.VideoInputDevice = VideoInputDevice;
    exports1.WhiteRectangleDetector = WhiteRectangleDetector;
    exports1.WriterException = WriterException;
    exports1.ZXingArrays = Arrays;
    exports1.ZXingCharset = Charset;
    exports1.ZXingInteger = Integer;
    exports1.ZXingStandardCharsets = StandardCharsets;
    exports1.ZXingStringBuilder = StringBuilder;
    exports1.ZXingStringEncoding = StringEncoding;
    exports1.ZXingSystem = System;
    exports1.createAbstractExpandedDecoder = createDecoder;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});



var $2f1ec72091fbd6cf$export$12d67355bcc453ab = function() {
    function ZXingHtml5QrcodeDecoder(requestedFormats, verbose, logger) {
        this.formatMap = new Map([
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).QR_CODE,
                $56054c647abd5197$exports.BarcodeFormat.QR_CODE
            ],
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).AZTEC,
                $56054c647abd5197$exports.BarcodeFormat.AZTEC
            ],
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).CODABAR,
                $56054c647abd5197$exports.BarcodeFormat.CODABAR
            ],
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).CODE_39,
                $56054c647abd5197$exports.BarcodeFormat.CODE_39
            ],
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).CODE_93,
                $56054c647abd5197$exports.BarcodeFormat.CODE_93
            ],
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).CODE_128,
                $56054c647abd5197$exports.BarcodeFormat.CODE_128
            ],
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).DATA_MATRIX,
                $56054c647abd5197$exports.BarcodeFormat.DATA_MATRIX
            ],
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).MAXICODE,
                $56054c647abd5197$exports.BarcodeFormat.MAXICODE
            ],
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).ITF,
                $56054c647abd5197$exports.BarcodeFormat.ITF
            ],
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).EAN_13,
                $56054c647abd5197$exports.BarcodeFormat.EAN_13
            ],
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).EAN_8,
                $56054c647abd5197$exports.BarcodeFormat.EAN_8
            ],
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).PDF_417,
                $56054c647abd5197$exports.BarcodeFormat.PDF_417
            ],
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).RSS_14,
                $56054c647abd5197$exports.BarcodeFormat.RSS_14
            ],
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).RSS_EXPANDED,
                $56054c647abd5197$exports.BarcodeFormat.RSS_EXPANDED
            ],
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).UPC_A,
                $56054c647abd5197$exports.BarcodeFormat.UPC_A
            ],
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).UPC_E,
                $56054c647abd5197$exports.BarcodeFormat.UPC_E
            ],
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).UPC_EAN_EXTENSION,
                $56054c647abd5197$exports.BarcodeFormat.UPC_EAN_EXTENSION
            ]
        ]);
        this.reverseFormatMap = this.createReverseFormatMap();
        if (!$56054c647abd5197$exports) throw "Use html5qrcode.min.js without edit, ZXing not found.";
        this.verbose = verbose;
        this.logger = logger;
        var formats = this.createZXingFormats(requestedFormats);
        var hints = new Map();
        hints.set($56054c647abd5197$exports.DecodeHintType.POSSIBLE_FORMATS, formats);
        hints.set($56054c647abd5197$exports.DecodeHintType.TRY_HARDER, false);
        this.hints = hints;
    }
    ZXingHtml5QrcodeDecoder.prototype.decodeAsync = function(canvas) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            try {
                resolve(_this.decode(canvas));
            } catch (error) {
                reject(error);
            }
        });
    };
    ZXingHtml5QrcodeDecoder.prototype.decode = function(canvas) {
        var zxingDecoder = new $56054c647abd5197$exports.MultiFormatReader(this.verbose, this.hints);
        var luminanceSource = new $56054c647abd5197$exports.HTMLCanvasElementLuminanceSource(canvas);
        var binaryBitmap = new $56054c647abd5197$exports.BinaryBitmap(new $56054c647abd5197$exports.HybridBinarizer(luminanceSource));
        var result = zxingDecoder.decode(binaryBitmap);
        return {
            text: result.text,
            format: (0, $c9d6d3563c261b0e$export$96706046d68ee585).create(this.toHtml5QrcodeSupportedFormats(result.format)),
            debugData: this.createDebugData()
        };
    };
    ZXingHtml5QrcodeDecoder.prototype.createReverseFormatMap = function() {
        var result = new Map();
        this.formatMap.forEach(function(value, key, _) {
            result.set(value, key);
        });
        return result;
    };
    ZXingHtml5QrcodeDecoder.prototype.toHtml5QrcodeSupportedFormats = function(zxingFormat) {
        if (!this.reverseFormatMap.has(zxingFormat)) throw "reverseFormatMap doesn't have ".concat(zxingFormat);
        return this.reverseFormatMap.get(zxingFormat);
    };
    ZXingHtml5QrcodeDecoder.prototype.createZXingFormats = function(requestedFormats) {
        var zxingFormats = [];
        for(var _i = 0, requestedFormats_1 = requestedFormats; _i < requestedFormats_1.length; _i++){
            var requestedFormat = requestedFormats_1[_i];
            if (this.formatMap.has(requestedFormat)) zxingFormats.push(this.formatMap.get(requestedFormat));
            else this.logger.logError("".concat(requestedFormat, " is not supported by") + "ZXingHtml5QrcodeShim");
        }
        return zxingFormats;
    };
    ZXingHtml5QrcodeDecoder.prototype.createDebugData = function() {
        return {
            decoderName: "zxing-js"
        };
    };
    return ZXingHtml5QrcodeDecoder;
}();



var $d03d3b448ea1788a$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $d03d3b448ea1788a$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $d03d3b448ea1788a$export$199d29c1710b56b6 = function() {
    function BarcodeDetectorDelegate(requestedFormats, verbose, logger) {
        this.formatMap = new Map([
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).QR_CODE,
                "qr_code"
            ],
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).AZTEC,
                "aztec"
            ],
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).CODABAR,
                "codabar"
            ],
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).CODE_39,
                "code_39"
            ],
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).CODE_93,
                "code_93"
            ],
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).CODE_128,
                "code_128"
            ],
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).DATA_MATRIX,
                "data_matrix"
            ],
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).ITF,
                "itf"
            ],
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).EAN_13,
                "ean_13"
            ],
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).EAN_8,
                "ean_8"
            ],
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).PDF_417,
                "pdf417"
            ],
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).UPC_A,
                "upc_a"
            ],
            [
                (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).UPC_E,
                "upc_e"
            ]
        ]);
        this.reverseFormatMap = this.createReverseFormatMap();
        if (!BarcodeDetectorDelegate.isSupported()) throw "Use html5qrcode.min.js without edit, Use BarcodeDetectorDelegate only if it isSupported();";
        this.verbose = verbose;
        this.logger = logger;
        var formats = this.createBarcodeDetectorFormats(requestedFormats);
        this.detector = new BarcodeDetector(formats);
        if (!this.detector) throw "BarcodeDetector detector not supported";
    }
    BarcodeDetectorDelegate.isSupported = function() {
        if (!("BarcodeDetector" in window)) return false;
        var dummyDetector = new BarcodeDetector({
            formats: [
                "qr_code"
            ]
        });
        return typeof dummyDetector !== "undefined";
    };
    BarcodeDetectorDelegate.prototype.decodeAsync = function(canvas) {
        return $d03d3b448ea1788a$var$__awaiter(this, void 0, void 0, function() {
            var barcodes, largestBarcode;
            return $d03d3b448ea1788a$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            this.detector.detect(canvas)
                        ];
                    case 1:
                        barcodes = _a.sent();
                        if (!barcodes || barcodes.length === 0) throw "No barcode or QR code detected.";
                        largestBarcode = this.selectLargestBarcode(barcodes);
                        return [
                            2,
                            {
                                text: largestBarcode.rawValue,
                                format: (0, $c9d6d3563c261b0e$export$96706046d68ee585).create(this.toHtml5QrcodeSupportedFormats(largestBarcode.format)),
                                debugData: this.createDebugData()
                            }
                        ];
                }
            });
        });
    };
    BarcodeDetectorDelegate.prototype.selectLargestBarcode = function(barcodes) {
        var largestBarcode = null;
        var maxArea = 0;
        for(var _i = 0, barcodes_1 = barcodes; _i < barcodes_1.length; _i++){
            var barcode = barcodes_1[_i];
            var area = barcode.boundingBox.width * barcode.boundingBox.height;
            if (area > maxArea) {
                maxArea = area;
                largestBarcode = barcode;
            }
        }
        if (!largestBarcode) throw "No largest barcode found";
        return largestBarcode;
    };
    BarcodeDetectorDelegate.prototype.createBarcodeDetectorFormats = function(requestedFormats) {
        var formats = [];
        for(var _i = 0, requestedFormats_1 = requestedFormats; _i < requestedFormats_1.length; _i++){
            var requestedFormat = requestedFormats_1[_i];
            if (this.formatMap.has(requestedFormat)) formats.push(this.formatMap.get(requestedFormat));
            else this.logger.warn("".concat(requestedFormat, " is not supported by") + "BarcodeDetectorDelegate");
        }
        return {
            formats: formats
        };
    };
    BarcodeDetectorDelegate.prototype.toHtml5QrcodeSupportedFormats = function(barcodeDetectorFormat) {
        if (!this.reverseFormatMap.has(barcodeDetectorFormat)) throw "reverseFormatMap doesn't have ".concat(barcodeDetectorFormat);
        return this.reverseFormatMap.get(barcodeDetectorFormat);
    };
    BarcodeDetectorDelegate.prototype.createReverseFormatMap = function() {
        var result = new Map();
        this.formatMap.forEach(function(value, key, _) {
            result.set(value, key);
        });
        return result;
    };
    BarcodeDetectorDelegate.prototype.createDebugData = function() {
        return {
            decoderName: "BarcodeDetector"
        };
    };
    return BarcodeDetectorDelegate;
}();


var $d1d209d110c6a902$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $d1d209d110c6a902$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $d1d209d110c6a902$export$e24b14a4b30c7022 = function() {
    function Html5QrcodeShim(requestedFormats, useBarCodeDetectorIfSupported, verbose, logger) {
        this.EXECUTIONS_TO_REPORT_PERFORMANCE = 100;
        this.executions = 0;
        this.executionResults = [];
        this.wasPrimaryDecoderUsedInLastDecode = false;
        this.verbose = verbose;
        if (useBarCodeDetectorIfSupported && (0, $d03d3b448ea1788a$export$199d29c1710b56b6).isSupported()) {
            this.primaryDecoder = new (0, $d03d3b448ea1788a$export$199d29c1710b56b6)(requestedFormats, verbose, logger);
            this.secondaryDecoder = new (0, $2f1ec72091fbd6cf$export$12d67355bcc453ab)(requestedFormats, verbose, logger);
        } else this.primaryDecoder = new (0, $2f1ec72091fbd6cf$export$12d67355bcc453ab)(requestedFormats, verbose, logger);
    }
    Html5QrcodeShim.prototype.decodeAsync = function(canvas) {
        return $d1d209d110c6a902$var$__awaiter(this, void 0, void 0, function() {
            var startTime;
            return $d1d209d110c6a902$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        startTime = performance.now();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4,
                            this.getDecoder().decodeAsync(canvas)
                        ];
                    case 2:
                        return [
                            2,
                            _a.sent()
                        ];
                    case 3:
                        this.possiblyLogPerformance(startTime);
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
    };
    Html5QrcodeShim.prototype.decodeRobustlyAsync = function(canvas) {
        return $d1d209d110c6a902$var$__awaiter(this, void 0, void 0, function() {
            var startTime, error_1;
            return $d1d209d110c6a902$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        startTime = performance.now();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            this.primaryDecoder.decodeAsync(canvas)
                        ];
                    case 2:
                        return [
                            2,
                            _a.sent()
                        ];
                    case 3:
                        error_1 = _a.sent();
                        if (this.secondaryDecoder) return [
                            2,
                            this.secondaryDecoder.decodeAsync(canvas)
                        ];
                        throw error_1;
                    case 4:
                        this.possiblyLogPerformance(startTime);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
    };
    Html5QrcodeShim.prototype.getDecoder = function() {
        if (!this.secondaryDecoder) return this.primaryDecoder;
        if (this.wasPrimaryDecoderUsedInLastDecode === false) {
            this.wasPrimaryDecoderUsedInLastDecode = true;
            return this.primaryDecoder;
        }
        this.wasPrimaryDecoderUsedInLastDecode = false;
        return this.secondaryDecoder;
    };
    Html5QrcodeShim.prototype.possiblyLogPerformance = function(startTime) {
        if (!this.verbose) return;
        var executionTime = performance.now() - startTime;
        this.executionResults.push(executionTime);
        this.executions++;
        this.possiblyFlushPerformanceReport();
    };
    Html5QrcodeShim.prototype.possiblyFlushPerformanceReport = function() {
        if (this.executions < this.EXECUTIONS_TO_REPORT_PERFORMANCE) return;
        var sum = 0;
        for(var _i = 0, _a = this.executionResults; _i < _a.length; _i++){
            var executionTime = _a[_i];
            sum += executionTime;
        }
        var mean = sum / this.executionResults.length;
        console.log("".concat(mean, " ms for ").concat(this.executionResults.length, " last runs."));
        this.executions = 0;
        this.executionResults = [];
    };
    return Html5QrcodeShim;
}();


var $1fd7f3bbb3f9820e$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $1fd7f3bbb3f9820e$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $1fd7f3bbb3f9820e$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $1fd7f3bbb3f9820e$var$AbstractCameraCapability = function() {
    function AbstractCameraCapability(name, track) {
        this.name = name;
        this.track = track;
    }
    AbstractCameraCapability.prototype.isSupported = function() {
        if (!this.track.getCapabilities) return false;
        return this.name in this.track.getCapabilities();
    };
    AbstractCameraCapability.prototype.apply = function(value) {
        var constraint = {};
        constraint[this.name] = value;
        var constraints = {
            advanced: [
                constraint
            ]
        };
        return this.track.applyConstraints(constraints);
    };
    AbstractCameraCapability.prototype.value = function() {
        var settings = this.track.getSettings();
        if (this.name in settings) {
            var settingValue = settings[this.name];
            return settingValue;
        }
        return null;
    };
    return AbstractCameraCapability;
}();
var $1fd7f3bbb3f9820e$var$AbstractRangeCameraCapability = function(_super) {
    $1fd7f3bbb3f9820e$var$__extends(AbstractRangeCameraCapability, _super);
    function AbstractRangeCameraCapability(name, track) {
        return _super.call(this, name, track) || this;
    }
    AbstractRangeCameraCapability.prototype.min = function() {
        return this.getCapabilities().min;
    };
    AbstractRangeCameraCapability.prototype.max = function() {
        return this.getCapabilities().max;
    };
    AbstractRangeCameraCapability.prototype.step = function() {
        return this.getCapabilities().step;
    };
    AbstractRangeCameraCapability.prototype.apply = function(value) {
        var constraint = {};
        constraint[this.name] = value;
        var constraints = {
            advanced: [
                constraint
            ]
        };
        return this.track.applyConstraints(constraints);
    };
    AbstractRangeCameraCapability.prototype.getCapabilities = function() {
        this.failIfNotSupported();
        var capabilities = this.track.getCapabilities();
        var capability = capabilities[this.name];
        return {
            min: capability.min,
            max: capability.max,
            step: capability.step
        };
    };
    AbstractRangeCameraCapability.prototype.failIfNotSupported = function() {
        if (!this.isSupported()) throw new Error("".concat(this.name, " capability not supported"));
    };
    return AbstractRangeCameraCapability;
}($1fd7f3bbb3f9820e$var$AbstractCameraCapability);
var $1fd7f3bbb3f9820e$var$ZoomFeatureImpl = function(_super) {
    $1fd7f3bbb3f9820e$var$__extends(ZoomFeatureImpl, _super);
    function ZoomFeatureImpl(track) {
        return _super.call(this, "zoom", track) || this;
    }
    return ZoomFeatureImpl;
}($1fd7f3bbb3f9820e$var$AbstractRangeCameraCapability);
var $1fd7f3bbb3f9820e$var$TorchFeatureImpl = function(_super) {
    $1fd7f3bbb3f9820e$var$__extends(TorchFeatureImpl, _super);
    function TorchFeatureImpl(track) {
        return _super.call(this, "torch", track) || this;
    }
    return TorchFeatureImpl;
}($1fd7f3bbb3f9820e$var$AbstractCameraCapability);
var $1fd7f3bbb3f9820e$var$CameraCapabilitiesImpl = function() {
    function CameraCapabilitiesImpl(track) {
        this.track = track;
    }
    CameraCapabilitiesImpl.prototype.zoomFeature = function() {
        return new $1fd7f3bbb3f9820e$var$ZoomFeatureImpl(this.track);
    };
    CameraCapabilitiesImpl.prototype.torchFeature = function() {
        return new $1fd7f3bbb3f9820e$var$TorchFeatureImpl(this.track);
    };
    return CameraCapabilitiesImpl;
}();
var $1fd7f3bbb3f9820e$var$RenderedCameraImpl = function() {
    function RenderedCameraImpl(parentElement, mediaStream, callbacks) {
        this.isClosed = false;
        this.parentElement = parentElement;
        this.mediaStream = mediaStream;
        this.callbacks = callbacks;
        this.surface = this.createVideoElement(this.parentElement.clientWidth);
        parentElement.append(this.surface);
    }
    RenderedCameraImpl.prototype.createVideoElement = function(width) {
        var videoElement = document.createElement("video");
        videoElement.style.width = "".concat(width, "px");
        videoElement.style.display = "block";
        videoElement.muted = true;
        videoElement.setAttribute("muted", "true");
        videoElement.playsInline = true;
        return videoElement;
    };
    RenderedCameraImpl.prototype.setupSurface = function() {
        var _this = this;
        this.surface.onabort = function() {
            throw "RenderedCameraImpl video surface onabort() called";
        };
        this.surface.onerror = function() {
            throw "RenderedCameraImpl video surface onerror() called";
        };
        var onVideoStart = function() {
            var videoWidth = _this.surface.clientWidth;
            var videoHeight = _this.surface.clientHeight;
            _this.callbacks.onRenderSurfaceReady(videoWidth, videoHeight);
            _this.surface.removeEventListener("playing", onVideoStart);
        };
        this.surface.addEventListener("playing", onVideoStart);
        this.surface.srcObject = this.mediaStream;
        this.surface.play();
    };
    RenderedCameraImpl.create = function(parentElement, mediaStream, options, callbacks) {
        return $1fd7f3bbb3f9820e$var$__awaiter(this, void 0, void 0, function() {
            var renderedCamera, aspectRatioConstraint;
            return $1fd7f3bbb3f9820e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        renderedCamera = new RenderedCameraImpl(parentElement, mediaStream, callbacks);
                        if (!options.aspectRatio) return [
                            3,
                            2
                        ];
                        aspectRatioConstraint = {
                            aspectRatio: options.aspectRatio
                        };
                        return [
                            4,
                            renderedCamera.getFirstTrackOrFail().applyConstraints(aspectRatioConstraint)
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        renderedCamera.setupSurface();
                        return [
                            2,
                            renderedCamera
                        ];
                }
            });
        });
    };
    RenderedCameraImpl.prototype.failIfClosed = function() {
        if (this.isClosed) throw "The RenderedCamera has already been closed.";
    };
    RenderedCameraImpl.prototype.getFirstTrackOrFail = function() {
        this.failIfClosed();
        if (this.mediaStream.getVideoTracks().length === 0) throw "No video tracks found";
        return this.mediaStream.getVideoTracks()[0];
    };
    RenderedCameraImpl.prototype.pause = function() {
        this.failIfClosed();
        this.surface.pause();
    };
    RenderedCameraImpl.prototype.resume = function(onResumeCallback) {
        this.failIfClosed();
        var $this = this;
        var onVideoResume = function() {
            setTimeout(onResumeCallback, 200);
            $this.surface.removeEventListener("playing", onVideoResume);
        };
        this.surface.addEventListener("playing", onVideoResume);
        this.surface.play();
    };
    RenderedCameraImpl.prototype.isPaused = function() {
        this.failIfClosed();
        return this.surface.paused;
    };
    RenderedCameraImpl.prototype.getSurface = function() {
        this.failIfClosed();
        return this.surface;
    };
    RenderedCameraImpl.prototype.getRunningTrackCapabilities = function() {
        return this.getFirstTrackOrFail().getCapabilities();
    };
    RenderedCameraImpl.prototype.getRunningTrackSettings = function() {
        return this.getFirstTrackOrFail().getSettings();
    };
    RenderedCameraImpl.prototype.applyVideoConstraints = function(constraints) {
        return $1fd7f3bbb3f9820e$var$__awaiter(this, void 0, void 0, function() {
            return $1fd7f3bbb3f9820e$var$__generator(this, function(_a) {
                if ("aspectRatio" in constraints) throw "Changing 'aspectRatio' in run-time is not yet supported.";
                return [
                    2,
                    this.getFirstTrackOrFail().applyConstraints(constraints)
                ];
            });
        });
    };
    RenderedCameraImpl.prototype.close = function() {
        if (this.isClosed) return Promise.resolve();
        var $this = this;
        return new Promise(function(resolve, _) {
            var tracks = $this.mediaStream.getVideoTracks();
            var tracksToClose = tracks.length;
            var tracksClosed = 0;
            $this.mediaStream.getVideoTracks().forEach(function(videoTrack) {
                $this.mediaStream.removeTrack(videoTrack);
                videoTrack.stop();
                ++tracksClosed;
                if (tracksClosed >= tracksToClose) {
                    $this.isClosed = true;
                    $this.parentElement.removeChild($this.surface);
                    resolve();
                }
            });
        });
    };
    RenderedCameraImpl.prototype.getCapabilities = function() {
        return new $1fd7f3bbb3f9820e$var$CameraCapabilitiesImpl(this.getFirstTrackOrFail());
    };
    return RenderedCameraImpl;
}();
var $1fd7f3bbb3f9820e$export$628cc91c21cd86e4 = function() {
    function CameraImpl(mediaStream) {
        this.mediaStream = mediaStream;
    }
    CameraImpl.prototype.render = function(parentElement, options, callbacks) {
        return $1fd7f3bbb3f9820e$var$__awaiter(this, void 0, void 0, function() {
            return $1fd7f3bbb3f9820e$var$__generator(this, function(_a) {
                return [
                    2,
                    $1fd7f3bbb3f9820e$var$RenderedCameraImpl.create(parentElement, this.mediaStream, options, callbacks)
                ];
            });
        });
    };
    CameraImpl.create = function(videoConstraints) {
        return $1fd7f3bbb3f9820e$var$__awaiter(this, void 0, void 0, function() {
            var constraints, mediaStream;
            return $1fd7f3bbb3f9820e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!navigator.mediaDevices) throw "navigator.mediaDevices not supported";
                        constraints = {
                            audio: false,
                            video: videoConstraints
                        };
                        return [
                            4,
                            navigator.mediaDevices.getUserMedia(constraints)
                        ];
                    case 1:
                        mediaStream = _a.sent();
                        return [
                            2,
                            new CameraImpl(mediaStream)
                        ];
                }
            });
        });
    };
    return CameraImpl;
}();


var $2c606578af028c16$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $2c606578af028c16$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $2c606578af028c16$export$2fe5dfd38a5788bd = function() {
    function CameraFactory() {}
    CameraFactory.failIfNotSupported = function() {
        return $2c606578af028c16$var$__awaiter(this, void 0, void 0, function() {
            return $2c606578af028c16$var$__generator(this, function(_a) {
                if (!navigator.mediaDevices) throw "navigator.mediaDevices not supported";
                return [
                    2,
                    new CameraFactory()
                ];
            });
        });
    };
    CameraFactory.prototype.create = function(videoConstraints) {
        return $2c606578af028c16$var$__awaiter(this, void 0, void 0, function() {
            return $2c606578af028c16$var$__generator(this, function(_a) {
                return [
                    2,
                    (0, $1fd7f3bbb3f9820e$export$628cc91c21cd86e4).create(videoConstraints)
                ];
            });
        });
    };
    return CameraFactory;
}();



var $f9cf3c975d1c5e2e$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $f9cf3c975d1c5e2e$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $f9cf3c975d1c5e2e$export$3cb69280b8b5ed56 = function() {
    function CameraRetriever() {}
    CameraRetriever.retrieve = function() {
        if (navigator.mediaDevices) return CameraRetriever.getCamerasFromMediaDevices();
        var mst = MediaStreamTrack;
        if (MediaStreamTrack && mst.getSources) return CameraRetriever.getCamerasFromMediaStreamTrack();
        return CameraRetriever.rejectWithError();
    };
    CameraRetriever.rejectWithError = function() {
        var errorMessage = (0, $ff5e69b322275082$export$b5652ef085dee87f).unableToQuerySupportedDevices();
        if (!CameraRetriever.isHttpsOrLocalhost()) errorMessage = (0, $ff5e69b322275082$export$b5652ef085dee87f).insecureContextCameraQueryError();
        return Promise.reject(errorMessage);
    };
    CameraRetriever.isHttpsOrLocalhost = function() {
        if (location.protocol === "https:") return true;
        var host = location.host.split(":")[0];
        return host === "127.0.0.1" || host === "localhost";
    };
    CameraRetriever.getCamerasFromMediaDevices = function() {
        return $f9cf3c975d1c5e2e$var$__awaiter(this, void 0, void 0, function() {
            var closeActiveStreams, mediaStream, devices, results, _i, devices_1, device;
            return $f9cf3c975d1c5e2e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        closeActiveStreams = function(stream) {
                            var tracks = stream.getVideoTracks();
                            for(var _i = 0, tracks_1 = tracks; _i < tracks_1.length; _i++){
                                var track = tracks_1[_i];
                                track.enabled = false;
                                track.stop();
                                stream.removeTrack(track);
                            }
                        };
                        return [
                            4,
                            navigator.mediaDevices.getUserMedia({
                                audio: false,
                                video: true
                            })
                        ];
                    case 1:
                        mediaStream = _a.sent();
                        return [
                            4,
                            navigator.mediaDevices.enumerateDevices()
                        ];
                    case 2:
                        devices = _a.sent();
                        results = [];
                        for(_i = 0, devices_1 = devices; _i < devices_1.length; _i++){
                            device = devices_1[_i];
                            if (device.kind === "videoinput") results.push({
                                id: device.deviceId,
                                label: device.label
                            });
                        }
                        closeActiveStreams(mediaStream);
                        return [
                            2,
                            results
                        ];
                }
            });
        });
    };
    CameraRetriever.getCamerasFromMediaStreamTrack = function() {
        return new Promise(function(resolve, _) {
            var callback = function(sourceInfos) {
                var results = [];
                for(var _i = 0, sourceInfos_1 = sourceInfos; _i < sourceInfos_1.length; _i++){
                    var sourceInfo = sourceInfos_1[_i];
                    if (sourceInfo.kind === "video") results.push({
                        id: sourceInfo.id,
                        label: sourceInfo.label
                    });
                }
                resolve(results);
            };
            var mst = MediaStreamTrack;
            mst.getSources(callback);
        });
    };
    return CameraRetriever;
}();


var $82bbb6140bb56c40$export$c90f317190d585a3;
(function(Html5QrcodeScannerState) {
    Html5QrcodeScannerState[Html5QrcodeScannerState["UNKNOWN"] = 0] = "UNKNOWN";
    Html5QrcodeScannerState[Html5QrcodeScannerState["NOT_STARTED"] = 1] = "NOT_STARTED";
    Html5QrcodeScannerState[Html5QrcodeScannerState["SCANNING"] = 2] = "SCANNING";
    Html5QrcodeScannerState[Html5QrcodeScannerState["PAUSED"] = 3] = "PAUSED";
})($82bbb6140bb56c40$export$c90f317190d585a3 || ($82bbb6140bb56c40$export$c90f317190d585a3 = {}));
var $82bbb6140bb56c40$var$StateManagerImpl = function() {
    function StateManagerImpl() {
        this.state = $82bbb6140bb56c40$export$c90f317190d585a3.NOT_STARTED;
        this.onGoingTransactionNewState = $82bbb6140bb56c40$export$c90f317190d585a3.UNKNOWN;
    }
    StateManagerImpl.prototype.directTransition = function(newState) {
        this.failIfTransitionOngoing();
        this.validateTransition(newState);
        this.state = newState;
    };
    StateManagerImpl.prototype.startTransition = function(newState) {
        this.failIfTransitionOngoing();
        this.validateTransition(newState);
        this.onGoingTransactionNewState = newState;
        return this;
    };
    StateManagerImpl.prototype.execute = function() {
        if (this.onGoingTransactionNewState === $82bbb6140bb56c40$export$c90f317190d585a3.UNKNOWN) throw "Transaction is already cancelled, cannot execute().";
        var tempNewState = this.onGoingTransactionNewState;
        this.onGoingTransactionNewState = $82bbb6140bb56c40$export$c90f317190d585a3.UNKNOWN;
        this.directTransition(tempNewState);
    };
    StateManagerImpl.prototype.cancel = function() {
        if (this.onGoingTransactionNewState === $82bbb6140bb56c40$export$c90f317190d585a3.UNKNOWN) throw "Transaction is already cancelled, cannot cancel().";
        this.onGoingTransactionNewState = $82bbb6140bb56c40$export$c90f317190d585a3.UNKNOWN;
    };
    StateManagerImpl.prototype.getState = function() {
        return this.state;
    };
    StateManagerImpl.prototype.failIfTransitionOngoing = function() {
        if (this.onGoingTransactionNewState !== $82bbb6140bb56c40$export$c90f317190d585a3.UNKNOWN) throw "Cannot transition to a new state, already under transition";
    };
    StateManagerImpl.prototype.validateTransition = function(newState) {
        switch(this.state){
            case $82bbb6140bb56c40$export$c90f317190d585a3.UNKNOWN:
                throw "Transition from unknown is not allowed";
            case $82bbb6140bb56c40$export$c90f317190d585a3.NOT_STARTED:
                this.failIfNewStateIs(newState, [
                    $82bbb6140bb56c40$export$c90f317190d585a3.PAUSED
                ]);
                break;
            case $82bbb6140bb56c40$export$c90f317190d585a3.SCANNING:
                break;
            case $82bbb6140bb56c40$export$c90f317190d585a3.PAUSED:
                break;
        }
    };
    StateManagerImpl.prototype.failIfNewStateIs = function(newState, disallowedStatesToTransition) {
        for(var _i = 0, disallowedStatesToTransition_1 = disallowedStatesToTransition; _i < disallowedStatesToTransition_1.length; _i++){
            var disallowedState = disallowedStatesToTransition_1[_i];
            if (newState === disallowedState) throw "Cannot transition from ".concat(this.state, " to ").concat(newState);
        }
    };
    return StateManagerImpl;
}();
var $82bbb6140bb56c40$export$999aa14d48ead8a4 = function() {
    function StateManagerProxy(stateManager) {
        this.stateManager = stateManager;
    }
    StateManagerProxy.prototype.startTransition = function(newState) {
        return this.stateManager.startTransition(newState);
    };
    StateManagerProxy.prototype.directTransition = function(newState) {
        this.stateManager.directTransition(newState);
    };
    StateManagerProxy.prototype.getState = function() {
        return this.stateManager.getState();
    };
    StateManagerProxy.prototype.canScanFile = function() {
        return this.stateManager.getState() === $82bbb6140bb56c40$export$c90f317190d585a3.NOT_STARTED;
    };
    StateManagerProxy.prototype.isScanning = function() {
        return this.stateManager.getState() !== $82bbb6140bb56c40$export$c90f317190d585a3.NOT_STARTED;
    };
    StateManagerProxy.prototype.isStrictlyScanning = function() {
        return this.stateManager.getState() === $82bbb6140bb56c40$export$c90f317190d585a3.SCANNING;
    };
    StateManagerProxy.prototype.isPaused = function() {
        return this.stateManager.getState() === $82bbb6140bb56c40$export$c90f317190d585a3.PAUSED;
    };
    return StateManagerProxy;
}();
var $82bbb6140bb56c40$export$9379d7cc304330e9 = function() {
    function StateManagerFactory() {}
    StateManagerFactory.create = function() {
        return new $82bbb6140bb56c40$export$999aa14d48ead8a4(new $82bbb6140bb56c40$var$StateManagerImpl());
    };
    return StateManagerFactory;
}();


var $9eb3c467bce0942e$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $9eb3c467bce0942e$var$Constants = function(_super) {
    $9eb3c467bce0942e$var$__extends(Constants, _super);
    function Constants() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Constants.DEFAULT_WIDTH = 300;
    Constants.DEFAULT_WIDTH_OFFSET = 2;
    Constants.FILE_SCAN_MIN_HEIGHT = 300;
    Constants.FILE_SCAN_HIDDEN_CANVAS_PADDING = 100;
    Constants.MIN_QR_BOX_SIZE = 50;
    Constants.SHADED_LEFT = 1;
    Constants.SHADED_RIGHT = 2;
    Constants.SHADED_TOP = 3;
    Constants.SHADED_BOTTOM = 4;
    Constants.SHADED_REGION_ELEMENT_ID = "qr-shaded-region";
    Constants.VERBOSE = false;
    Constants.BORDER_SHADER_DEFAULT_COLOR = "#ffffff";
    Constants.BORDER_SHADER_MATCH_COLOR = "rgb(90, 193, 56)";
    return Constants;
}((0, $c9d6d3563c261b0e$export$a4dae9b55d173e6d));
var $9eb3c467bce0942e$var$InternalHtml5QrcodeConfig = function() {
    function InternalHtml5QrcodeConfig(config, logger) {
        this.logger = logger;
        this.fps = $9eb3c467bce0942e$var$Constants.SCAN_DEFAULT_FPS;
        if (!config) this.disableFlip = $9eb3c467bce0942e$var$Constants.DEFAULT_DISABLE_FLIP;
        else {
            if (config.fps) this.fps = config.fps;
            this.disableFlip = config.disableFlip === true;
            this.qrbox = config.qrbox;
            this.aspectRatio = config.aspectRatio;
            this.videoConstraints = config.videoConstraints;
        }
    }
    InternalHtml5QrcodeConfig.prototype.isMediaStreamConstraintsValid = function() {
        if (!this.videoConstraints) {
            this.logger.logError("Empty videoConstraints", true);
            return false;
        }
        return (0, $307853ab41d6a77a$export$62a0507decb17869).isMediaStreamConstraintsValid(this.videoConstraints, this.logger);
    };
    InternalHtml5QrcodeConfig.prototype.isShadedBoxEnabled = function() {
        return !(0, $c9d6d3563c261b0e$export$bedb7023a7733221)(this.qrbox);
    };
    InternalHtml5QrcodeConfig.create = function(config, logger) {
        return new InternalHtml5QrcodeConfig(config, logger);
    };
    return InternalHtml5QrcodeConfig;
}();
var $9eb3c467bce0942e$export$e14ced7bffd8eb7a = function() {
    function Html5Qrcode(elementId, configOrVerbosityFlag) {
        this.element = null;
        this.canvasElement = null;
        this.scannerPausedUiElement = null;
        this.hasBorderShaders = null;
        this.borderShaders = null;
        this.qrMatch = null;
        this.renderedCamera = null;
        this.qrRegion = null;
        this.context = null;
        this.lastScanImageFile = null;
        this.isScanning = false;
        if (!document.getElementById(elementId)) throw "HTML Element with id=".concat(elementId, " not found");
        this.elementId = elementId;
        this.verbose = false;
        var experimentalFeatureConfig;
        var configObject;
        if (typeof configOrVerbosityFlag == "boolean") this.verbose = configOrVerbosityFlag === true;
        else if (configOrVerbosityFlag) {
            configObject = configOrVerbosityFlag;
            this.verbose = configObject.verbose === true;
            experimentalFeatureConfig = configObject.experimentalFeatures;
        }
        this.logger = new (0, $c9d6d3563c261b0e$export$1952c0907ffae0f2)(this.verbose);
        this.qrcode = new (0, $d1d209d110c6a902$export$e24b14a4b30c7022)(this.getSupportedFormats(configOrVerbosityFlag), this.getUseBarCodeDetectorIfSupported(configObject), this.verbose, this.logger);
        this.foreverScanTimeout;
        this.shouldScan = true;
        this.stateManagerProxy = (0, $82bbb6140bb56c40$export$9379d7cc304330e9).create();
    }
    Html5Qrcode.prototype.start = function(cameraIdOrConfig, configuration, qrCodeSuccessCallback, qrCodeErrorCallback) {
        var _this = this;
        if (!cameraIdOrConfig) throw "cameraIdOrConfig is required";
        if (!qrCodeSuccessCallback || typeof qrCodeSuccessCallback != "function") throw "qrCodeSuccessCallback is required and should be a function.";
        var qrCodeErrorCallbackInternal;
        if (qrCodeErrorCallback) qrCodeErrorCallbackInternal = qrCodeErrorCallback;
        else qrCodeErrorCallbackInternal = this.verbose ? this.logger.log : function() {};
        var internalConfig = $9eb3c467bce0942e$var$InternalHtml5QrcodeConfig.create(configuration, this.logger);
        this.clearElement();
        var videoConstraintsAvailableAndValid = false;
        if (internalConfig.videoConstraints) {
            if (!internalConfig.isMediaStreamConstraintsValid()) this.logger.logError("'videoConstraints' is not valid 'MediaStreamConstraints, it will be ignored.'", true);
            else videoConstraintsAvailableAndValid = true;
        }
        var areVideoConstraintsEnabled = videoConstraintsAvailableAndValid;
        var element = document.getElementById(this.elementId);
        var rootElementWidth = element.clientWidth ? element.clientWidth : $9eb3c467bce0942e$var$Constants.DEFAULT_WIDTH;
        element.style.position = "relative";
        this.shouldScan = true;
        this.element = element;
        var $this = this;
        var toScanningStateChangeTransaction = this.stateManagerProxy.startTransition((0, $82bbb6140bb56c40$export$c90f317190d585a3).SCANNING);
        return new Promise(function(resolve, reject) {
            var videoConstraints = areVideoConstraintsEnabled ? internalConfig.videoConstraints : $this.createVideoConstraints(cameraIdOrConfig);
            if (!videoConstraints) {
                toScanningStateChangeTransaction.cancel();
                reject("videoConstraints should be defined");
                return;
            }
            var cameraRenderingOptions = {};
            if (!areVideoConstraintsEnabled || internalConfig.aspectRatio) cameraRenderingOptions.aspectRatio = internalConfig.aspectRatio;
            var renderingCallbacks = {
                onRenderSurfaceReady: function(viewfinderWidth, viewfinderHeight) {
                    $this.setupUi(viewfinderWidth, viewfinderHeight, internalConfig);
                    $this.isScanning = true;
                    $this.foreverScan(internalConfig, qrCodeSuccessCallback, qrCodeErrorCallbackInternal);
                }
            };
            (0, $2c606578af028c16$export$2fe5dfd38a5788bd).failIfNotSupported().then(function(factory) {
                factory.create(videoConstraints).then(function(camera) {
                    return camera.render(_this.element, cameraRenderingOptions, renderingCallbacks).then(function(renderedCamera) {
                        $this.renderedCamera = renderedCamera;
                        toScanningStateChangeTransaction.execute();
                        resolve(null);
                    }).catch(function(error) {
                        toScanningStateChangeTransaction.cancel();
                        reject(error);
                    });
                }).catch(function(error) {
                    toScanningStateChangeTransaction.cancel();
                    reject((0, $ff5e69b322275082$export$b5652ef085dee87f).errorGettingUserMedia(error));
                });
            }).catch(function(_) {
                toScanningStateChangeTransaction.cancel();
                reject((0, $ff5e69b322275082$export$b5652ef085dee87f).cameraStreamingNotSupported());
            });
        });
    };
    Html5Qrcode.prototype.pause = function(shouldPauseVideo) {
        if (!this.stateManagerProxy.isStrictlyScanning()) throw "Cannot pause, scanner is not scanning.";
        this.stateManagerProxy.directTransition((0, $82bbb6140bb56c40$export$c90f317190d585a3).PAUSED);
        this.showPausedState();
        if ((0, $c9d6d3563c261b0e$export$bedb7023a7733221)(shouldPauseVideo) || shouldPauseVideo !== true) shouldPauseVideo = false;
        if (shouldPauseVideo && this.renderedCamera) this.renderedCamera.pause();
    };
    Html5Qrcode.prototype.resume = function() {
        if (!this.stateManagerProxy.isPaused()) throw "Cannot result, scanner is not paused.";
        if (!this.renderedCamera) throw "renderedCamera doesn't exist while trying resume()";
        var $this = this;
        var transitionToScanning = function() {
            $this.stateManagerProxy.directTransition((0, $82bbb6140bb56c40$export$c90f317190d585a3).SCANNING);
            $this.hidePausedState();
        };
        if (!this.renderedCamera.isPaused()) {
            transitionToScanning();
            return;
        }
        this.renderedCamera.resume(function() {
            transitionToScanning();
        });
    };
    Html5Qrcode.prototype.getState = function() {
        return this.stateManagerProxy.getState();
    };
    Html5Qrcode.prototype.stop = function() {
        var _this = this;
        if (!this.stateManagerProxy.isScanning()) throw "Cannot stop, scanner is not running or paused.";
        var toStoppedStateTransaction = this.stateManagerProxy.startTransition((0, $82bbb6140bb56c40$export$c90f317190d585a3).NOT_STARTED);
        this.shouldScan = false;
        if (this.foreverScanTimeout) clearTimeout(this.foreverScanTimeout);
        var removeQrRegion = function() {
            if (!_this.element) return;
            var childElement = document.getElementById($9eb3c467bce0942e$var$Constants.SHADED_REGION_ELEMENT_ID);
            if (childElement) _this.element.removeChild(childElement);
        };
        var $this = this;
        return this.renderedCamera.close().then(function() {
            $this.renderedCamera = null;
            if ($this.element) {
                $this.element.removeChild($this.canvasElement);
                $this.canvasElement = null;
            }
            removeQrRegion();
            if ($this.qrRegion) $this.qrRegion = null;
            if ($this.context) $this.context = null;
            toStoppedStateTransaction.execute();
            $this.hidePausedState();
            $this.isScanning = false;
            return Promise.resolve();
        });
    };
    Html5Qrcode.prototype.scanFile = function(imageFile, showImage) {
        return this.scanFileV2(imageFile, showImage).then(function(html5qrcodeResult) {
            return html5qrcodeResult.decodedText;
        });
    };
    Html5Qrcode.prototype.scanFileV2 = function(imageFile, showImage) {
        var _this = this;
        if (!imageFile || !(imageFile instanceof File)) throw "imageFile argument is mandatory and should be instance of File. Use 'event.target.files[0]'.";
        if ((0, $c9d6d3563c261b0e$export$bedb7023a7733221)(showImage)) showImage = true;
        if (!this.stateManagerProxy.canScanFile()) throw "Cannot start file scan - ongoing camera scan";
        return new Promise(function(resolve, reject) {
            _this.possiblyCloseLastScanImageFile();
            _this.clearElement();
            _this.lastScanImageFile = URL.createObjectURL(imageFile);
            var inputImage = new Image;
            inputImage.onload = function() {
                var imageWidth = inputImage.width;
                var imageHeight = inputImage.height;
                var element = document.getElementById(_this.elementId);
                var containerWidth = element.clientWidth ? element.clientWidth : $9eb3c467bce0942e$var$Constants.DEFAULT_WIDTH;
                var containerHeight = Math.max(element.clientHeight ? element.clientHeight : imageHeight, $9eb3c467bce0942e$var$Constants.FILE_SCAN_MIN_HEIGHT);
                var config = _this.computeCanvasDrawConfig(imageWidth, imageHeight, containerWidth, containerHeight);
                if (showImage) {
                    var visibleCanvas = _this.createCanvasElement(containerWidth, containerHeight, "qr-canvas-visible");
                    visibleCanvas.style.display = "inline-block";
                    element.appendChild(visibleCanvas);
                    var context_1 = visibleCanvas.getContext("2d");
                    if (!context_1) throw "Unable to get 2d context from canvas";
                    context_1.canvas.width = containerWidth;
                    context_1.canvas.height = containerHeight;
                    context_1.drawImage(inputImage, 0, 0, imageWidth, imageHeight, config.x, config.y, config.width, config.height);
                }
                var padding = $9eb3c467bce0942e$var$Constants.FILE_SCAN_HIDDEN_CANVAS_PADDING;
                var hiddenImageWidth = Math.max(inputImage.width, config.width);
                var hiddenImageHeight = Math.max(inputImage.height, config.height);
                var hiddenCanvasWidth = hiddenImageWidth + 2 * padding;
                var hiddenCanvasHeight = hiddenImageHeight + 2 * padding;
                var hiddenCanvas = _this.createCanvasElement(hiddenCanvasWidth, hiddenCanvasHeight);
                element.appendChild(hiddenCanvas);
                var context = hiddenCanvas.getContext("2d");
                if (!context) throw "Unable to get 2d context from canvas";
                context.canvas.width = hiddenCanvasWidth;
                context.canvas.height = hiddenCanvasHeight;
                context.drawImage(inputImage, 0, 0, imageWidth, imageHeight, padding, padding, hiddenImageWidth, hiddenImageHeight);
                try {
                    _this.qrcode.decodeRobustlyAsync(hiddenCanvas).then(function(result) {
                        resolve((0, $c9d6d3563c261b0e$export$ca258a9dba899828).createFromQrcodeResult(result));
                    }).catch(reject);
                } catch (exception) {
                    reject("QR code parse error, error = ".concat(exception));
                }
            };
            inputImage.onerror = reject;
            inputImage.onabort = reject;
            inputImage.onstalled = reject;
            inputImage.onsuspend = reject;
            inputImage.src = URL.createObjectURL(imageFile);
        });
    };
    Html5Qrcode.prototype.clear = function() {
        this.clearElement();
    };
    Html5Qrcode.getCameras = function() {
        return (0, $f9cf3c975d1c5e2e$export$3cb69280b8b5ed56).retrieve();
    };
    Html5Qrcode.prototype.getRunningTrackCapabilities = function() {
        return this.getRenderedCameraOrFail().getRunningTrackCapabilities();
    };
    Html5Qrcode.prototype.getRunningTrackSettings = function() {
        return this.getRenderedCameraOrFail().getRunningTrackSettings();
    };
    Html5Qrcode.prototype.getRunningTrackCameraCapabilities = function() {
        return this.getRenderedCameraOrFail().getCapabilities();
    };
    Html5Qrcode.prototype.applyVideoConstraints = function(videoConstaints) {
        if (!videoConstaints) throw "videoConstaints is required argument.";
        else if (!(0, $307853ab41d6a77a$export$62a0507decb17869).isMediaStreamConstraintsValid(videoConstaints, this.logger)) throw "invalid videoConstaints passed, check logs for more details";
        return this.getRenderedCameraOrFail().applyVideoConstraints(videoConstaints);
    };
    Html5Qrcode.prototype.getRenderedCameraOrFail = function() {
        if (this.renderedCamera == null) throw "Scanning is not in running state, call this API only when QR code scanning using camera is in running state.";
        return this.renderedCamera;
    };
    Html5Qrcode.prototype.getSupportedFormats = function(configOrVerbosityFlag) {
        var allFormats = [
            (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).QR_CODE,
            (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).AZTEC,
            (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).CODABAR,
            (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).CODE_39,
            (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).CODE_93,
            (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).CODE_128,
            (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).DATA_MATRIX,
            (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).MAXICODE,
            (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).ITF,
            (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).EAN_13,
            (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).EAN_8,
            (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).PDF_417,
            (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).RSS_14,
            (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).RSS_EXPANDED,
            (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).UPC_A,
            (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).UPC_E,
            (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).UPC_EAN_EXTENSION
        ];
        if (!configOrVerbosityFlag || typeof configOrVerbosityFlag == "boolean") return allFormats;
        if (!configOrVerbosityFlag.formatsToSupport) return allFormats;
        if (!Array.isArray(configOrVerbosityFlag.formatsToSupport)) throw "configOrVerbosityFlag.formatsToSupport should be undefined or an array.";
        if (configOrVerbosityFlag.formatsToSupport.length === 0) throw "Atleast 1 formatsToSupport is needed.";
        var supportedFormats = [];
        for(var _i = 0, _a = configOrVerbosityFlag.formatsToSupport; _i < _a.length; _i++){
            var format = _a[_i];
            if ((0, $c9d6d3563c261b0e$export$f672fe1751f545ca)(format)) supportedFormats.push(format);
            else this.logger.warn("Invalid format: ".concat(format, " passed in config, ignoring."));
        }
        if (supportedFormats.length === 0) throw "None of formatsToSupport match supported values.";
        return supportedFormats;
    };
    Html5Qrcode.prototype.getUseBarCodeDetectorIfSupported = function(config) {
        if ((0, $c9d6d3563c261b0e$export$bedb7023a7733221)(config)) return true;
        if (!(0, $c9d6d3563c261b0e$export$bedb7023a7733221)(config.useBarCodeDetectorIfSupported)) return config.useBarCodeDetectorIfSupported !== false;
        if ((0, $c9d6d3563c261b0e$export$bedb7023a7733221)(config.experimentalFeatures)) return true;
        var experimentalFeatures = config.experimentalFeatures;
        if ((0, $c9d6d3563c261b0e$export$bedb7023a7733221)(experimentalFeatures.useBarCodeDetectorIfSupported)) return true;
        return experimentalFeatures.useBarCodeDetectorIfSupported !== false;
    };
    Html5Qrcode.prototype.validateQrboxSize = function(viewfinderWidth, viewfinderHeight, internalConfig) {
        var _this = this;
        var qrboxSize = internalConfig.qrbox;
        this.validateQrboxConfig(qrboxSize);
        var qrDimensions = this.toQrdimensions(viewfinderWidth, viewfinderHeight, qrboxSize);
        var validateMinSize = function(size) {
            if (size < $9eb3c467bce0942e$var$Constants.MIN_QR_BOX_SIZE) throw "minimum size of 'config.qrbox' dimension value is" + " ".concat($9eb3c467bce0942e$var$Constants.MIN_QR_BOX_SIZE, "px.");
        };
        var correctWidthBasedOnRootElementSize = function(configWidth) {
            if (configWidth > viewfinderWidth) {
                _this.logger.warn("`qrbox.width` or `qrbox` is larger than the width of the root element. The width will be truncated to the width of root element.");
                configWidth = viewfinderWidth;
            }
            return configWidth;
        };
        validateMinSize(qrDimensions.width);
        validateMinSize(qrDimensions.height);
        qrDimensions.width = correctWidthBasedOnRootElementSize(qrDimensions.width);
    };
    Html5Qrcode.prototype.validateQrboxConfig = function(qrboxSize) {
        if (typeof qrboxSize === "number") return;
        if (typeof qrboxSize === "function") return;
        if (qrboxSize.width === undefined || qrboxSize.height === undefined) throw "Invalid instance of QrDimensions passed for 'config.qrbox'. Both 'width' and 'height' should be set.";
    };
    Html5Qrcode.prototype.toQrdimensions = function(viewfinderWidth, viewfinderHeight, qrboxSize) {
        if (typeof qrboxSize === "number") return {
            width: qrboxSize,
            height: qrboxSize
        };
        else if (typeof qrboxSize === "function") try {
            return qrboxSize(viewfinderWidth, viewfinderHeight);
        } catch (error) {
            throw new Error("qrbox config was passed as a function but it failed with unknown error" + error);
        }
        return qrboxSize;
    };
    Html5Qrcode.prototype.setupUi = function(viewfinderWidth, viewfinderHeight, internalConfig) {
        if (internalConfig.isShadedBoxEnabled()) this.validateQrboxSize(viewfinderWidth, viewfinderHeight, internalConfig);
        var qrboxSize = (0, $c9d6d3563c261b0e$export$bedb7023a7733221)(internalConfig.qrbox) ? {
            width: viewfinderWidth,
            height: viewfinderHeight
        } : internalConfig.qrbox;
        this.validateQrboxConfig(qrboxSize);
        var qrDimensions = this.toQrdimensions(viewfinderWidth, viewfinderHeight, qrboxSize);
        if (qrDimensions.height > viewfinderHeight) this.logger.warn("[Html5Qrcode] config.qrbox has height that isgreater than the height of the video stream. Shading will be ignored");
        var shouldShadingBeApplied = internalConfig.isShadedBoxEnabled() && qrDimensions.height <= viewfinderHeight;
        var defaultQrRegion = {
            x: 0,
            y: 0,
            width: viewfinderWidth,
            height: viewfinderHeight
        };
        var qrRegion = shouldShadingBeApplied ? this.getShadedRegionBounds(viewfinderWidth, viewfinderHeight, qrDimensions) : defaultQrRegion;
        var canvasElement = this.createCanvasElement(qrRegion.width, qrRegion.height);
        var contextAttributes = {
            willReadFrequently: true
        };
        var context = canvasElement.getContext("2d", contextAttributes);
        context.canvas.width = qrRegion.width;
        context.canvas.height = qrRegion.height;
        this.element.append(canvasElement);
        if (shouldShadingBeApplied) this.possiblyInsertShadingElement(this.element, viewfinderWidth, viewfinderHeight, qrDimensions);
        this.createScannerPausedUiElement(this.element);
        this.qrRegion = qrRegion;
        this.context = context;
        this.canvasElement = canvasElement;
    };
    Html5Qrcode.prototype.createScannerPausedUiElement = function(rootElement) {
        var scannerPausedUiElement = document.createElement("div");
        scannerPausedUiElement.innerText = (0, $ff5e69b322275082$export$b5652ef085dee87f).scannerPaused();
        scannerPausedUiElement.style.display = "none";
        scannerPausedUiElement.style.position = "absolute";
        scannerPausedUiElement.style.top = "0px";
        scannerPausedUiElement.style.zIndex = "1";
        scannerPausedUiElement.style.background = "rgba(9, 9, 9, 0.46)";
        scannerPausedUiElement.style.color = "#FFECEC";
        scannerPausedUiElement.style.textAlign = "center";
        scannerPausedUiElement.style.width = "100%";
        rootElement.appendChild(scannerPausedUiElement);
        this.scannerPausedUiElement = scannerPausedUiElement;
    };
    Html5Qrcode.prototype.scanContext = function(qrCodeSuccessCallback, qrCodeErrorCallback) {
        var _this = this;
        if (this.stateManagerProxy.isPaused()) return Promise.resolve(false);
        return this.qrcode.decodeAsync(this.canvasElement).then(function(result) {
            qrCodeSuccessCallback(result.text, (0, $c9d6d3563c261b0e$export$ca258a9dba899828).createFromQrcodeResult(result));
            _this.possiblyUpdateShaders(true);
            return true;
        }).catch(function(error) {
            _this.possiblyUpdateShaders(false);
            var errorMessage = (0, $ff5e69b322275082$export$b5652ef085dee87f).codeParseError(error);
            qrCodeErrorCallback(errorMessage, (0, $c9d6d3563c261b0e$export$dac571266bd01cf5).createFrom(errorMessage));
            return false;
        });
    };
    Html5Qrcode.prototype.foreverScan = function(internalConfig, qrCodeSuccessCallback, qrCodeErrorCallback) {
        var _this = this;
        if (!this.shouldScan) return;
        if (!this.renderedCamera) return;
        var videoElement = this.renderedCamera.getSurface();
        var widthRatio = videoElement.videoWidth / videoElement.clientWidth;
        var heightRatio = videoElement.videoHeight / videoElement.clientHeight;
        if (!this.qrRegion) throw "qrRegion undefined when localMediaStream is ready.";
        var sWidthOffset = this.qrRegion.width * widthRatio;
        var sHeightOffset = this.qrRegion.height * heightRatio;
        var sxOffset = this.qrRegion.x * widthRatio;
        var syOffset = this.qrRegion.y * heightRatio;
        this.context.drawImage(videoElement, sxOffset, syOffset, sWidthOffset, sHeightOffset, 0, 0, this.qrRegion.width, this.qrRegion.height);
        var triggerNextScan = function() {
            _this.foreverScanTimeout = setTimeout(function() {
                _this.foreverScan(internalConfig, qrCodeSuccessCallback, qrCodeErrorCallback);
            }, _this.getTimeoutFps(internalConfig.fps));
        };
        this.scanContext(qrCodeSuccessCallback, qrCodeErrorCallback).then(function(isSuccessfull) {
            if (!isSuccessfull && internalConfig.disableFlip !== true) {
                _this.context.translate(_this.context.canvas.width, 0);
                _this.context.scale(-1, 1);
                _this.scanContext(qrCodeSuccessCallback, qrCodeErrorCallback).finally(function() {
                    triggerNextScan();
                });
            } else triggerNextScan();
        }).catch(function(error) {
            _this.logger.logError("Error happend while scanning context", error);
            triggerNextScan();
        });
    };
    Html5Qrcode.prototype.createVideoConstraints = function(cameraIdOrConfig) {
        if (typeof cameraIdOrConfig == "string") return {
            deviceId: {
                exact: cameraIdOrConfig
            }
        };
        else if (typeof cameraIdOrConfig == "object") {
            var facingModeKey = "facingMode";
            var deviceIdKey = "deviceId";
            var allowedFacingModeValues_1 = {
                "user": true,
                "environment": true
            };
            var exactKey = "exact";
            var isValidFacingModeValue = function(value) {
                if (value in allowedFacingModeValues_1) return true;
                else throw "config has invalid 'facingMode' value = " + "'".concat(value, "'");
            };
            var keys = Object.keys(cameraIdOrConfig);
            if (keys.length !== 1) throw "'cameraIdOrConfig' object should have exactly 1 key," + " if passed as an object, found ".concat(keys.length, " keys");
            var key = Object.keys(cameraIdOrConfig)[0];
            if (key !== facingModeKey && key !== deviceIdKey) throw "Only '".concat(facingModeKey, "' and '").concat(deviceIdKey, "' ") + " are supported for 'cameraIdOrConfig'";
            if (key === facingModeKey) {
                var facingMode = cameraIdOrConfig.facingMode;
                if (typeof facingMode == "string") {
                    if (isValidFacingModeValue(facingMode)) return {
                        facingMode: facingMode
                    };
                } else if (typeof facingMode == "object") {
                    if (exactKey in facingMode) {
                        if (isValidFacingModeValue(facingMode["".concat(exactKey)])) return {
                            facingMode: {
                                exact: facingMode["".concat(exactKey)]
                            }
                        };
                    } else throw "'facingMode' should be string or object with" + " ".concat(exactKey, " as key.");
                } else {
                    var type_1 = typeof facingMode;
                    throw "Invalid type of 'facingMode' = ".concat(type_1);
                }
            } else {
                var deviceId = cameraIdOrConfig.deviceId;
                if (typeof deviceId == "string") return {
                    deviceId: deviceId
                };
                else if (typeof deviceId == "object") {
                    if (exactKey in deviceId) return {
                        deviceId: {
                            exact: deviceId["".concat(exactKey)]
                        }
                    };
                    else throw "'deviceId' should be string or object with" + " ".concat(exactKey, " as key.");
                } else {
                    var type_2 = typeof deviceId;
                    throw "Invalid type of 'deviceId' = ".concat(type_2);
                }
            }
        }
        var type = typeof cameraIdOrConfig;
        throw "Invalid type of 'cameraIdOrConfig' = ".concat(type);
    };
    Html5Qrcode.prototype.computeCanvasDrawConfig = function(imageWidth, imageHeight, containerWidth, containerHeight) {
        if (imageWidth <= containerWidth && imageHeight <= containerHeight) {
            var xoffset = (containerWidth - imageWidth) / 2;
            var yoffset = (containerHeight - imageHeight) / 2;
            return {
                x: xoffset,
                y: yoffset,
                width: imageWidth,
                height: imageHeight
            };
        } else {
            var formerImageWidth = imageWidth;
            var formerImageHeight = imageHeight;
            if (imageWidth > containerWidth) {
                imageHeight = containerWidth / imageWidth * imageHeight;
                imageWidth = containerWidth;
            }
            if (imageHeight > containerHeight) {
                imageWidth = containerHeight / imageHeight * imageWidth;
                imageHeight = containerHeight;
            }
            this.logger.log("Image downsampled from " + "".concat(formerImageWidth, "X").concat(formerImageHeight) + " to ".concat(imageWidth, "X").concat(imageHeight, "."));
            return this.computeCanvasDrawConfig(imageWidth, imageHeight, containerWidth, containerHeight);
        }
    };
    Html5Qrcode.prototype.clearElement = function() {
        if (this.stateManagerProxy.isScanning()) throw "Cannot clear while scan is ongoing, close it first.";
        var element = document.getElementById(this.elementId);
        if (element) element.innerHTML = "";
    };
    Html5Qrcode.prototype.possiblyUpdateShaders = function(qrMatch) {
        if (this.qrMatch === qrMatch) return;
        if (this.hasBorderShaders && this.borderShaders && this.borderShaders.length) this.borderShaders.forEach(function(shader) {
            shader.style.backgroundColor = qrMatch ? $9eb3c467bce0942e$var$Constants.BORDER_SHADER_MATCH_COLOR : $9eb3c467bce0942e$var$Constants.BORDER_SHADER_DEFAULT_COLOR;
        });
        this.qrMatch = qrMatch;
    };
    Html5Qrcode.prototype.possiblyCloseLastScanImageFile = function() {
        if (this.lastScanImageFile) {
            URL.revokeObjectURL(this.lastScanImageFile);
            this.lastScanImageFile = null;
        }
    };
    Html5Qrcode.prototype.createCanvasElement = function(width, height, customId) {
        var canvasWidth = width;
        var canvasHeight = height;
        var canvasElement = document.createElement("canvas");
        canvasElement.style.width = "".concat(canvasWidth, "px");
        canvasElement.style.height = "".concat(canvasHeight, "px");
        canvasElement.style.display = "none";
        canvasElement.id = (0, $c9d6d3563c261b0e$export$bedb7023a7733221)(customId) ? "qr-canvas" : customId;
        return canvasElement;
    };
    Html5Qrcode.prototype.getShadedRegionBounds = function(width, height, qrboxSize) {
        if (qrboxSize.width > width || qrboxSize.height > height) throw "'config.qrbox' dimensions should not be greater than the dimensions of the root HTML element.";
        return {
            x: (width - qrboxSize.width) / 2,
            y: (height - qrboxSize.height) / 2,
            width: qrboxSize.width,
            height: qrboxSize.height
        };
    };
    Html5Qrcode.prototype.possiblyInsertShadingElement = function(element, width, height, qrboxSize) {
        if (width - qrboxSize.width < 1 || height - qrboxSize.height < 1) return;
        var shadingElement = document.createElement("div");
        shadingElement.style.position = "absolute";
        var rightLeftBorderSize = (width - qrboxSize.width) / 2;
        var topBottomBorderSize = (height - qrboxSize.height) / 2;
        shadingElement.style.borderLeft = "".concat(rightLeftBorderSize, "px solid rgba(0, 0, 0, 0.48)");
        shadingElement.style.borderRight = "".concat(rightLeftBorderSize, "px solid rgba(0, 0, 0, 0.48)");
        shadingElement.style.borderTop = "".concat(topBottomBorderSize, "px solid rgba(0, 0, 0, 0.48)");
        shadingElement.style.borderBottom = "".concat(topBottomBorderSize, "px solid rgba(0, 0, 0, 0.48)");
        shadingElement.style.boxSizing = "border-box";
        shadingElement.style.top = "0px";
        shadingElement.style.bottom = "0px";
        shadingElement.style.left = "0px";
        shadingElement.style.right = "0px";
        shadingElement.id = "".concat($9eb3c467bce0942e$var$Constants.SHADED_REGION_ELEMENT_ID);
        if (width - qrboxSize.width < 11 || height - qrboxSize.height < 11) this.hasBorderShaders = false;
        else {
            var smallSize = 5;
            var largeSize = 40;
            this.insertShaderBorders(shadingElement, largeSize, smallSize, -smallSize, null, 0, true);
            this.insertShaderBorders(shadingElement, largeSize, smallSize, -smallSize, null, 0, false);
            this.insertShaderBorders(shadingElement, largeSize, smallSize, null, -smallSize, 0, true);
            this.insertShaderBorders(shadingElement, largeSize, smallSize, null, -smallSize, 0, false);
            this.insertShaderBorders(shadingElement, smallSize, largeSize + smallSize, -smallSize, null, -smallSize, true);
            this.insertShaderBorders(shadingElement, smallSize, largeSize + smallSize, null, -smallSize, -smallSize, true);
            this.insertShaderBorders(shadingElement, smallSize, largeSize + smallSize, -smallSize, null, -smallSize, false);
            this.insertShaderBorders(shadingElement, smallSize, largeSize + smallSize, null, -smallSize, -smallSize, false);
            this.hasBorderShaders = true;
        }
        element.append(shadingElement);
    };
    Html5Qrcode.prototype.insertShaderBorders = function(shaderElem, width, height, top, bottom, side, isLeft) {
        var elem = document.createElement("div");
        elem.style.position = "absolute";
        elem.style.backgroundColor = $9eb3c467bce0942e$var$Constants.BORDER_SHADER_DEFAULT_COLOR;
        elem.style.width = "".concat(width, "px");
        elem.style.height = "".concat(height, "px");
        if (top !== null) elem.style.top = "".concat(top, "px");
        if (bottom !== null) elem.style.bottom = "".concat(bottom, "px");
        if (isLeft) elem.style.left = "".concat(side, "px");
        else elem.style.right = "".concat(side, "px");
        if (!this.borderShaders) this.borderShaders = [];
        this.borderShaders.push(elem);
        shaderElem.appendChild(elem);
    };
    Html5Qrcode.prototype.showPausedState = function() {
        if (!this.scannerPausedUiElement) throw "[internal error] scanner paused UI element not found";
        this.scannerPausedUiElement.style.display = "block";
    };
    Html5Qrcode.prototype.hidePausedState = function() {
        if (!this.scannerPausedUiElement) throw "[internal error] scanner paused UI element not found";
        this.scannerPausedUiElement.style.display = "none";
    };
    Html5Qrcode.prototype.getTimeoutFps = function(fps) {
        return 1000 / fps;
    };
    return Html5Qrcode;
}();





var $701d751907918eac$var$SVG_XML_PREFIX = "data:image/svg+xml;base64,";
var $701d751907918eac$export$be7b9b11efa99dbc = $701d751907918eac$var$SVG_XML_PREFIX + "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";
var $701d751907918eac$export$c97cd35b47589f30 = $701d751907918eac$var$SVG_XML_PREFIX + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1OS4wMTggNTkuMDE4IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1OS4wMTggNTkuMDE4IiB4bWw6c3BhY2U9InByZXNlcnZlIj48cGF0aCBkPSJtNTguNzQxIDU0LjgwOS01Ljk2OS02LjI0NGExMC43NCAxMC43NCAwIDAgMCAyLjgyLTcuMjVjMC01Ljk1My00Ljg0My0xMC43OTYtMTAuNzk2LTEwLjc5NlMzNCAzNS4zNjEgMzQgNDEuMzE0IDM4Ljg0MyA1Mi4xMSA0NC43OTYgNTIuMTFjMi40NDEgMCA0LjY4OC0uODI0IDYuNDk5LTIuMTk2bDYuMDAxIDYuMjc3YS45OTguOTk4IDAgMCAwIDEuNDE0LjAzMiAxIDEgMCAwIDAgLjAzMS0xLjQxNHpNMzYgNDEuMzE0YzAtNC44NSAzLjk0Ni04Ljc5NiA4Ljc5Ni04Ljc5NnM4Ljc5NiAzLjk0NiA4Ljc5NiA4Ljc5Ni0zLjk0NiA4Ljc5Ni04Ljc5NiA4Ljc5NlMzNiA0Ni4xNjQgMzYgNDEuMzE0ek0xMC40MzEgMTYuMDg4YzAgMy4wNyAyLjQ5OCA1LjU2OCA1LjU2OSA1LjU2OHM1LjU2OS0yLjQ5OCA1LjU2OS01LjU2OGMwLTMuMDcxLTIuNDk4LTUuNTY5LTUuNTY5LTUuNTY5cy01LjU2OSAyLjQ5OC01LjU2OSA1LjU2OXptOS4xMzggMGMwIDEuOTY4LTEuNjAyIDMuNTY4LTMuNTY5IDMuNTY4cy0zLjU2OS0xLjYwMS0zLjU2OS0zLjU2OCAxLjYwMi0zLjU2OSAzLjU2OS0zLjU2OSAzLjU2OSAxLjYwMSAzLjU2OSAzLjU2OXoiLz48cGF0aCBkPSJtMzAuODgyIDI4Ljk4NyA5LjE4LTEwLjA1NCAxMS4yNjIgMTAuMzIzYTEgMSAwIDAgMCAxLjM1MS0xLjQ3NWwtMTItMTFhMSAxIDAgMCAwLTEuNDE0LjA2M2wtOS43OTQgMTAuNzI3LTQuNzQzLTQuNzQzYTEuMDAzIDEuMDAzIDAgMCAwLTEuMzY4LS4wNDRMNi4zMzkgMzcuNzY4YTEgMSAwIDEgMCAxLjMyMiAxLjUwMWwxNi4zMTMtMTQuMzYyIDcuMzE5IDcuMzE4YS45OTkuOTk5IDAgMSAwIDEuNDE0LTEuNDE0bC0xLjgyNS0xLjgyNHoiLz48cGF0aCBkPSJNMzAgNDYuNTE4SDJ2LTQyaDU0djI4YTEgMSAwIDEgMCAyIDB2LTI5YTEgMSAwIDAgMC0xLTFIMWExIDEgMCAwIDAtMSAxdjQ0YTEgMSAwIDAgMCAxIDFoMjlhMSAxIDAgMSAwIDAtMnoiLz48L3N2Zz4=";
var $701d751907918eac$export$c5538664401ceea = $701d751907918eac$var$SVG_XML_PREFIX + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0NjAgNDYwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0NjAgNDYwIiB4bWw6c3BhY2U9InByZXNlcnZlIj48cGF0aCBkPSJNMjMwIDBDMTAyLjk3NSAwIDAgMTAyLjk3NSAwIDIzMHMxMDIuOTc1IDIzMCAyMzAgMjMwIDIzMC0xMDIuOTc0IDIzMC0yMzBTMzU3LjAyNSAwIDIzMCAwem0zOC4zMzMgMzc3LjM2YzAgOC42NzYtNy4wMzQgMTUuNzEtMTUuNzEgMTUuNzFoLTQzLjEwMWMtOC42NzYgMC0xNS43MS03LjAzNC0xNS43MS0xNS43MVYyMDIuNDc3YzAtOC42NzYgNy4wMzMtMTUuNzEgMTUuNzEtMTUuNzFoNDMuMTAxYzguNjc2IDAgMTUuNzEgNy4wMzMgMTUuNzEgMTUuNzFWMzc3LjM2ek0yMzAgMTU3Yy0yMS41MzkgMC0zOS0xNy40NjEtMzktMzlzMTcuNDYxLTM5IDM5LTM5IDM5IDE3LjQ2MSAzOSAzOS0xNy40NjEgMzktMzkgMzl6Ii8+PC9zdmc+";
var $701d751907918eac$export$a9695a750cdd2270 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAAQgAAAEIBarqQRAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAE1SURBVDiNfdI7S0NBEAXgLya1otFgpbYSbISAgpXYi6CmiH9KCAiChaVga6OiWPgfRDQ+0itaGVNosXtluWwcuMzePfM4M3sq8lbHBubwg1dc4m1E/J/N4ghDPOIsfk/4xiEao5KX0McFljN4C9d4QTPXuY99jP3DsIoDPGM6BY5i5yI5R7O4q+ImFkJY2DCh3cAH2klyB+9J1xUMMAG7eCh1a+Mr+k48b5diXrFVwwLuS+BJ9MfR7+G0FHOHhTHhnXNWS87VDF4pcnfQK4Ep7XScNLmPTZgURNKKYENYWDpzW1BhscS1WHS8CDgURFJQrWcoF3c13KKbgg1BYQfy8xZWEzTTw1QZbAoKu8FqJnktdu5hcVSHmchiILzzuaDQvjBzV2m8yohCE1jHfPx/xhU+y4G/D75ELlRJsSYAAAAASUVORK5CYII=";


var $569f6d15e38e44d3$var$PersistedDataFactory = function() {
    function PersistedDataFactory() {}
    PersistedDataFactory.createDefault = function() {
        return {
            hasPermission: false,
            lastUsedCameraId: null
        };
    };
    return PersistedDataFactory;
}();
var $569f6d15e38e44d3$export$f4f7158604555024 = function() {
    function PersistedDataManager() {
        this.data = $569f6d15e38e44d3$var$PersistedDataFactory.createDefault();
        var data = localStorage.getItem(PersistedDataManager.LOCAL_STORAGE_KEY);
        if (!data) this.reset();
        else this.data = JSON.parse(data);
    }
    PersistedDataManager.prototype.hasCameraPermissions = function() {
        return this.data.hasPermission;
    };
    PersistedDataManager.prototype.getLastUsedCameraId = function() {
        return this.data.lastUsedCameraId;
    };
    PersistedDataManager.prototype.setHasPermission = function(hasPermission) {
        this.data.hasPermission = hasPermission;
        this.flush();
    };
    PersistedDataManager.prototype.setLastUsedCameraId = function(lastUsedCameraId) {
        this.data.lastUsedCameraId = lastUsedCameraId;
        this.flush();
    };
    PersistedDataManager.prototype.resetLastUsedCameraId = function() {
        this.data.lastUsedCameraId = null;
        this.flush();
    };
    PersistedDataManager.prototype.reset = function() {
        this.data = $569f6d15e38e44d3$var$PersistedDataFactory.createDefault();
        this.flush();
    };
    PersistedDataManager.prototype.flush = function() {
        localStorage.setItem(PersistedDataManager.LOCAL_STORAGE_KEY, JSON.stringify(this.data));
    };
    PersistedDataManager.LOCAL_STORAGE_KEY = "HTML5_QRCODE_DATA";
    return PersistedDataManager;
}();




var $97aa7730745cc7b4$var$LibraryInfoDiv = function() {
    function LibraryInfoDiv() {
        this.infoDiv = document.createElement("div");
    }
    LibraryInfoDiv.prototype.renderInto = function(parent) {
        this.infoDiv.style.position = "absolute";
        this.infoDiv.style.top = "10px";
        this.infoDiv.style.right = "10px";
        this.infoDiv.style.zIndex = "2";
        this.infoDiv.style.display = "none";
        this.infoDiv.style.padding = "5pt";
        this.infoDiv.style.border = "1px solid #171717";
        this.infoDiv.style.fontSize = "10pt";
        this.infoDiv.style.background = "rgb(0 0 0 / 69%)";
        this.infoDiv.style.borderRadius = "5px";
        this.infoDiv.style.textAlign = "center";
        this.infoDiv.style.fontWeight = "400";
        this.infoDiv.style.color = "white";
        this.infoDiv.innerText = (0, $ff5e69b322275082$export$ef6635d54d6a0486).poweredBy();
        var projectLink = document.createElement("a");
        projectLink.innerText = "ScanApp";
        projectLink.href = "https://scanapp.org";
        projectLink.target = "new";
        projectLink.style.color = "white";
        this.infoDiv.appendChild(projectLink);
        var breakElemFirst = document.createElement("br");
        var breakElemSecond = document.createElement("br");
        this.infoDiv.appendChild(breakElemFirst);
        this.infoDiv.appendChild(breakElemSecond);
        var reportIssueLink = document.createElement("a");
        reportIssueLink.innerText = (0, $ff5e69b322275082$export$ef6635d54d6a0486).reportIssues();
        reportIssueLink.href = "https://github.com/mebjas/html5-qrcode/issues";
        reportIssueLink.target = "new";
        reportIssueLink.style.color = "white";
        this.infoDiv.appendChild(reportIssueLink);
        parent.appendChild(this.infoDiv);
    };
    LibraryInfoDiv.prototype.show = function() {
        this.infoDiv.style.display = "block";
    };
    LibraryInfoDiv.prototype.hide = function() {
        this.infoDiv.style.display = "none";
    };
    return LibraryInfoDiv;
}();
var $97aa7730745cc7b4$var$LibraryInfoIcon = function() {
    function LibraryInfoIcon(onTapIn, onTapOut) {
        this.isShowingInfoIcon = true;
        this.onTapIn = onTapIn;
        this.onTapOut = onTapOut;
        this.infoIcon = document.createElement("img");
    }
    LibraryInfoIcon.prototype.renderInto = function(parent) {
        var _this = this;
        this.infoIcon.alt = "Info icon";
        this.infoIcon.src = (0, $701d751907918eac$export$c5538664401ceea);
        this.infoIcon.style.position = "absolute";
        this.infoIcon.style.top = "4px";
        this.infoIcon.style.right = "4px";
        this.infoIcon.style.opacity = "0.6";
        this.infoIcon.style.cursor = "pointer";
        this.infoIcon.style.zIndex = "2";
        this.infoIcon.style.width = "16px";
        this.infoIcon.style.height = "16px";
        this.infoIcon.onmouseover = function(_) {
            return _this.onHoverIn();
        };
        this.infoIcon.onmouseout = function(_) {
            return _this.onHoverOut();
        };
        this.infoIcon.onclick = function(_) {
            return _this.onClick();
        };
        parent.appendChild(this.infoIcon);
    };
    LibraryInfoIcon.prototype.onHoverIn = function() {
        if (this.isShowingInfoIcon) this.infoIcon.style.opacity = "1";
    };
    LibraryInfoIcon.prototype.onHoverOut = function() {
        if (this.isShowingInfoIcon) this.infoIcon.style.opacity = "0.6";
    };
    LibraryInfoIcon.prototype.onClick = function() {
        if (this.isShowingInfoIcon) {
            this.isShowingInfoIcon = false;
            this.onTapIn();
            this.infoIcon.src = (0, $701d751907918eac$export$a9695a750cdd2270);
            this.infoIcon.style.opacity = "1";
        } else {
            this.isShowingInfoIcon = true;
            this.onTapOut();
            this.infoIcon.src = (0, $701d751907918eac$export$c5538664401ceea);
            this.infoIcon.style.opacity = "0.6";
        }
    };
    return LibraryInfoIcon;
}();
var $97aa7730745cc7b4$export$a2d0fe6d33028e31 = function() {
    function LibraryInfoContainer() {
        var _this = this;
        this.infoDiv = new $97aa7730745cc7b4$var$LibraryInfoDiv();
        this.infoIcon = new $97aa7730745cc7b4$var$LibraryInfoIcon(function() {
            _this.infoDiv.show();
        }, function() {
            _this.infoDiv.hide();
        });
    }
    LibraryInfoContainer.prototype.renderInto = function(parent) {
        this.infoDiv.renderInto(parent);
        this.infoIcon.renderInto(parent);
    };
    return LibraryInfoContainer;
}();


var $a7838855c7abaae7$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $a7838855c7abaae7$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $a7838855c7abaae7$export$693eae80963d557e = function() {
    function CameraPermissions() {}
    CameraPermissions.hasPermissions = function() {
        return $a7838855c7abaae7$var$__awaiter(this, void 0, void 0, function() {
            var devices, _i, devices_1, device;
            return $a7838855c7abaae7$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            navigator.mediaDevices.enumerateDevices()
                        ];
                    case 1:
                        devices = _a.sent();
                        for(_i = 0, devices_1 = devices; _i < devices_1.length; _i++){
                            device = devices_1[_i];
                            if (device.kind === "videoinput" && device.label) return [
                                2,
                                true
                            ];
                        }
                        return [
                            2,
                            false
                        ];
                }
            });
        });
    };
    return CameraPermissions;
}();



var $f71efc754e4e9dc7$export$528d36479c095a59 = function() {
    function ScanTypeSelector(supportedScanTypes) {
        this.supportedScanTypes = this.validateAndReturnScanTypes(supportedScanTypes);
    }
    ScanTypeSelector.prototype.getDefaultScanType = function() {
        return this.supportedScanTypes[0];
    };
    ScanTypeSelector.prototype.hasMoreThanOneScanType = function() {
        return this.supportedScanTypes.length > 1;
    };
    ScanTypeSelector.prototype.isCameraScanRequired = function() {
        for(var _i = 0, _a = this.supportedScanTypes; _i < _a.length; _i++){
            var scanType = _a[_i];
            if (ScanTypeSelector.isCameraScanType(scanType)) return true;
        }
        return false;
    };
    ScanTypeSelector.isCameraScanType = function(scanType) {
        return scanType === (0, $c9d6d3563c261b0e$export$13ed3042ed099f6a).SCAN_TYPE_CAMERA;
    };
    ScanTypeSelector.isFileScanType = function(scanType) {
        return scanType === (0, $c9d6d3563c261b0e$export$13ed3042ed099f6a).SCAN_TYPE_FILE;
    };
    ScanTypeSelector.prototype.validateAndReturnScanTypes = function(supportedScanTypes) {
        if (!supportedScanTypes || supportedScanTypes.length === 0) return (0, $c9d6d3563c261b0e$export$a4dae9b55d173e6d).DEFAULT_SUPPORTED_SCAN_TYPE;
        var maxExpectedValues = (0, $c9d6d3563c261b0e$export$a4dae9b55d173e6d).DEFAULT_SUPPORTED_SCAN_TYPE.length;
        if (supportedScanTypes.length > maxExpectedValues) throw "Max ".concat(maxExpectedValues, " values expected for ") + "supportedScanTypes";
        for(var _i = 0, supportedScanTypes_1 = supportedScanTypes; _i < supportedScanTypes_1.length; _i++){
            var scanType = supportedScanTypes_1[_i];
            if (!(0, $c9d6d3563c261b0e$export$a4dae9b55d173e6d).DEFAULT_SUPPORTED_SCAN_TYPE.includes(scanType)) throw "Unsupported scan type ".concat(scanType);
        }
        return supportedScanTypes;
    };
    return ScanTypeSelector;
}();



var $e012aa67914a9f32$export$5263f2f87e9ad375 = function() {
    function PublicUiElementIdAndClasses() {}
    PublicUiElementIdAndClasses.ALL_ELEMENT_CLASS = "html5-qrcode-element";
    PublicUiElementIdAndClasses.CAMERA_PERMISSION_BUTTON_ID = "html5-qrcode-button-camera-permission";
    PublicUiElementIdAndClasses.CAMERA_START_BUTTON_ID = "html5-qrcode-button-camera-start";
    PublicUiElementIdAndClasses.CAMERA_STOP_BUTTON_ID = "html5-qrcode-button-camera-stop";
    PublicUiElementIdAndClasses.TORCH_BUTTON_ID = "html5-qrcode-button-torch";
    PublicUiElementIdAndClasses.CAMERA_SELECTION_SELECT_ID = "html5-qrcode-select-camera";
    PublicUiElementIdAndClasses.FILE_SELECTION_BUTTON_ID = "html5-qrcode-button-file-selection";
    PublicUiElementIdAndClasses.ZOOM_SLIDER_ID = "html5-qrcode-input-range-zoom";
    PublicUiElementIdAndClasses.SCAN_TYPE_CHANGE_ANCHOR_ID = "html5-qrcode-anchor-scan-type-change";
    PublicUiElementIdAndClasses.TORCH_BUTTON_CLASS_TORCH_ON = "html5-qrcode-button-torch-on";
    PublicUiElementIdAndClasses.TORCH_BUTTON_CLASS_TORCH_OFF = "html5-qrcode-button-torch-off";
    return PublicUiElementIdAndClasses;
}();
var $e012aa67914a9f32$export$6a3443a184593c5 = function() {
    function BaseUiElementFactory() {}
    BaseUiElementFactory.createElement = function(elementType, elementId) {
        var element = document.createElement(elementType);
        element.id = elementId;
        element.classList.add($e012aa67914a9f32$export$5263f2f87e9ad375.ALL_ELEMENT_CLASS);
        if (elementType === "button") element.setAttribute("type", "button");
        return element;
    };
    return BaseUiElementFactory;
}();


var $44f49b3cb4096e16$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $44f49b3cb4096e16$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $44f49b3cb4096e16$var$TorchController = function() {
    function TorchController(torchCapability, buttonController, onTorchActionFailureCallback) {
        this.isTorchOn = false;
        this.torchCapability = torchCapability;
        this.buttonController = buttonController;
        this.onTorchActionFailureCallback = onTorchActionFailureCallback;
    }
    TorchController.prototype.isTorchEnabled = function() {
        return this.isTorchOn;
    };
    TorchController.prototype.flipState = function() {
        return $44f49b3cb4096e16$var$__awaiter(this, void 0, void 0, function() {
            var isTorchOnExpected, error_1;
            return $44f49b3cb4096e16$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.buttonController.disable();
                        isTorchOnExpected = !this.isTorchOn;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            this.torchCapability.apply(isTorchOnExpected)
                        ];
                    case 2:
                        _a.sent();
                        this.updateUiBasedOnLatestSettings(this.torchCapability.value(), isTorchOnExpected);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error_1 = _a.sent();
                        this.propagateFailure(isTorchOnExpected, error_1);
                        this.buttonController.enable();
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
    };
    TorchController.prototype.updateUiBasedOnLatestSettings = function(isTorchOn, isTorchOnExpected) {
        if (isTorchOn === isTorchOnExpected) {
            this.buttonController.setText(isTorchOnExpected ? (0, $ff5e69b322275082$export$b9cab5abdb16545c).torchOffButton() : (0, $ff5e69b322275082$export$b9cab5abdb16545c).torchOnButton());
            this.isTorchOn = isTorchOnExpected;
        } else this.propagateFailure(isTorchOnExpected);
        this.buttonController.enable();
    };
    TorchController.prototype.propagateFailure = function(isTorchOnExpected, error) {
        var errorMessage = isTorchOnExpected ? (0, $ff5e69b322275082$export$b9cab5abdb16545c).torchOnFailedMessage() : (0, $ff5e69b322275082$export$b9cab5abdb16545c).torchOffFailedMessage();
        if (error) errorMessage += "; Error = " + error;
        this.onTorchActionFailureCallback(errorMessage);
    };
    TorchController.prototype.reset = function() {
        this.isTorchOn = false;
    };
    return TorchController;
}();
var $44f49b3cb4096e16$export$11856eebe9d443c6 = function() {
    function TorchButton(torchCapability, onTorchActionFailureCallback) {
        this.onTorchActionFailureCallback = onTorchActionFailureCallback;
        this.torchButton = (0, $e012aa67914a9f32$export$6a3443a184593c5).createElement("button", (0, $e012aa67914a9f32$export$5263f2f87e9ad375).TORCH_BUTTON_ID);
        this.torchController = new $44f49b3cb4096e16$var$TorchController(torchCapability, this, onTorchActionFailureCallback);
    }
    TorchButton.prototype.render = function(parentElement, torchButtonOptions) {
        var _this = this;
        this.torchButton.innerText = (0, $ff5e69b322275082$export$b9cab5abdb16545c).torchOnButton();
        this.torchButton.style.display = torchButtonOptions.display;
        this.torchButton.style.marginLeft = torchButtonOptions.marginLeft;
        var $this = this;
        this.torchButton.addEventListener("click", function(_) {
            return $44f49b3cb4096e16$var$__awaiter(_this, void 0, void 0, function() {
                return $44f49b3cb4096e16$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4,
                                $this.torchController.flipState()
                            ];
                        case 1:
                            _a.sent();
                            if ($this.torchController.isTorchEnabled()) {
                                $this.torchButton.classList.remove((0, $e012aa67914a9f32$export$5263f2f87e9ad375).TORCH_BUTTON_CLASS_TORCH_OFF);
                                $this.torchButton.classList.add((0, $e012aa67914a9f32$export$5263f2f87e9ad375).TORCH_BUTTON_CLASS_TORCH_ON);
                            } else {
                                $this.torchButton.classList.remove((0, $e012aa67914a9f32$export$5263f2f87e9ad375).TORCH_BUTTON_CLASS_TORCH_ON);
                                $this.torchButton.classList.add((0, $e012aa67914a9f32$export$5263f2f87e9ad375).TORCH_BUTTON_CLASS_TORCH_OFF);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
        });
        parentElement.appendChild(this.torchButton);
    };
    TorchButton.prototype.updateTorchCapability = function(torchCapability) {
        this.torchController = new $44f49b3cb4096e16$var$TorchController(torchCapability, this, this.onTorchActionFailureCallback);
    };
    TorchButton.prototype.getTorchButton = function() {
        return this.torchButton;
    };
    TorchButton.prototype.hide = function() {
        this.torchButton.style.display = "none";
    };
    TorchButton.prototype.show = function() {
        this.torchButton.style.display = "inline-block";
    };
    TorchButton.prototype.disable = function() {
        this.torchButton.disabled = true;
    };
    TorchButton.prototype.enable = function() {
        this.torchButton.disabled = false;
    };
    TorchButton.prototype.setText = function(text) {
        this.torchButton.innerText = text;
    };
    TorchButton.prototype.reset = function() {
        this.torchButton.innerText = (0, $ff5e69b322275082$export$b9cab5abdb16545c).torchOnButton();
        this.torchController.reset();
    };
    TorchButton.create = function(parentElement, torchCapability, torchButtonOptions, onTorchActionFailureCallback) {
        var button = new TorchButton(torchCapability, onTorchActionFailureCallback);
        button.render(parentElement, torchButtonOptions);
        return button;
    };
    return TorchButton;
}();




var $16862ce938b2b921$export$bb6f0d5a8973d33 = function() {
    function FileSelectionUi(parentElement, showOnRender, onFileSelected) {
        this.fileBasedScanRegion = this.createFileBasedScanRegion();
        this.fileBasedScanRegion.style.display = showOnRender ? "block" : "none";
        parentElement.appendChild(this.fileBasedScanRegion);
        var fileScanLabel = document.createElement("label");
        fileScanLabel.setAttribute("for", this.getFileScanInputId());
        fileScanLabel.style.display = "inline-block";
        this.fileBasedScanRegion.appendChild(fileScanLabel);
        this.fileSelectionButton = (0, $e012aa67914a9f32$export$6a3443a184593c5).createElement("button", (0, $e012aa67914a9f32$export$5263f2f87e9ad375).FILE_SELECTION_BUTTON_ID);
        this.setInitialValueToButton();
        this.fileSelectionButton.addEventListener("click", function(_) {
            fileScanLabel.click();
        });
        fileScanLabel.append(this.fileSelectionButton);
        this.fileScanInput = (0, $e012aa67914a9f32$export$6a3443a184593c5).createElement("input", this.getFileScanInputId());
        this.fileScanInput.type = "file";
        this.fileScanInput.accept = "image/*";
        this.fileScanInput.style.display = "none";
        fileScanLabel.appendChild(this.fileScanInput);
        var $this = this;
        this.fileScanInput.addEventListener("change", function(e) {
            if (e == null || e.target == null) return;
            var target = e.target;
            if (target.files && target.files.length === 0) return;
            var fileList = target.files;
            var file = fileList[0];
            var fileName = file.name;
            $this.setImageNameToButton(fileName);
            onFileSelected(file);
        });
        var dragAndDropMessage = this.createDragAndDropMessage();
        this.fileBasedScanRegion.appendChild(dragAndDropMessage);
        this.fileBasedScanRegion.addEventListener("dragenter", function(event) {
            $this.fileBasedScanRegion.style.border = $this.fileBasedScanRegionActiveBorder();
            event.stopPropagation();
            event.preventDefault();
        });
        this.fileBasedScanRegion.addEventListener("dragleave", function(event) {
            $this.fileBasedScanRegion.style.border = $this.fileBasedScanRegionDefaultBorder();
            event.stopPropagation();
            event.preventDefault();
        });
        this.fileBasedScanRegion.addEventListener("dragover", function(event) {
            $this.fileBasedScanRegion.style.border = $this.fileBasedScanRegionActiveBorder();
            event.stopPropagation();
            event.preventDefault();
        });
        this.fileBasedScanRegion.addEventListener("drop", function(event) {
            event.stopPropagation();
            event.preventDefault();
            $this.fileBasedScanRegion.style.border = $this.fileBasedScanRegionDefaultBorder();
            var dataTransfer = event.dataTransfer;
            if (dataTransfer) {
                var files = dataTransfer.files;
                if (!files || files.length === 0) return;
                var isAnyFileImage = false;
                for(var i = 0; i < files.length; ++i){
                    var file = files.item(i);
                    if (!file) continue;
                    var imageType = /image.*/;
                    if (!file.type.match(imageType)) continue;
                    isAnyFileImage = true;
                    var fileName = file.name;
                    $this.setImageNameToButton(fileName);
                    onFileSelected(file);
                    dragAndDropMessage.innerText = (0, $ff5e69b322275082$export$b9cab5abdb16545c).dragAndDropMessage();
                    break;
                }
                if (!isAnyFileImage) dragAndDropMessage.innerText = (0, $ff5e69b322275082$export$b9cab5abdb16545c).dragAndDropMessageOnlyImages();
            }
        });
    }
    FileSelectionUi.prototype.hide = function() {
        this.fileBasedScanRegion.style.display = "none";
        this.fileScanInput.disabled = true;
    };
    FileSelectionUi.prototype.show = function() {
        this.fileBasedScanRegion.style.display = "block";
        this.fileScanInput.disabled = false;
    };
    FileSelectionUi.prototype.isShowing = function() {
        return this.fileBasedScanRegion.style.display === "block";
    };
    FileSelectionUi.prototype.resetValue = function() {
        this.fileScanInput.value = "";
        this.setInitialValueToButton();
    };
    FileSelectionUi.prototype.createFileBasedScanRegion = function() {
        var fileBasedScanRegion = document.createElement("div");
        fileBasedScanRegion.style.textAlign = "center";
        fileBasedScanRegion.style.margin = "auto";
        fileBasedScanRegion.style.width = "80%";
        fileBasedScanRegion.style.maxWidth = "600px";
        fileBasedScanRegion.style.border = this.fileBasedScanRegionDefaultBorder();
        fileBasedScanRegion.style.padding = "10px";
        fileBasedScanRegion.style.marginBottom = "10px";
        return fileBasedScanRegion;
    };
    FileSelectionUi.prototype.fileBasedScanRegionDefaultBorder = function() {
        return "6px dashed #ebebeb";
    };
    FileSelectionUi.prototype.fileBasedScanRegionActiveBorder = function() {
        return "6px dashed rgb(153 151 151)";
    };
    FileSelectionUi.prototype.createDragAndDropMessage = function() {
        var dragAndDropMessage = document.createElement("div");
        dragAndDropMessage.innerText = (0, $ff5e69b322275082$export$b9cab5abdb16545c).dragAndDropMessage();
        dragAndDropMessage.style.fontWeight = "400";
        return dragAndDropMessage;
    };
    FileSelectionUi.prototype.setImageNameToButton = function(imageFileName) {
        var MAX_CHARS = 20;
        if (imageFileName.length > MAX_CHARS) {
            var start8Chars = imageFileName.substring(0, 8);
            var length_1 = imageFileName.length;
            var last8Chars = imageFileName.substring(length_1 - 8, length_1);
            imageFileName = "".concat(start8Chars, "....").concat(last8Chars);
        }
        var newText = (0, $ff5e69b322275082$export$b9cab5abdb16545c).fileSelectionChooseAnother() + " - " + imageFileName;
        this.fileSelectionButton.innerText = newText;
    };
    FileSelectionUi.prototype.setInitialValueToButton = function() {
        var initialText = (0, $ff5e69b322275082$export$b9cab5abdb16545c).fileSelectionChooseImage() + " - " + (0, $ff5e69b322275082$export$b9cab5abdb16545c).fileSelectionNoImageSelected();
        this.fileSelectionButton.innerText = initialText;
    };
    FileSelectionUi.prototype.getFileScanInputId = function() {
        return "html5-qrcode-private-filescan-input";
    };
    FileSelectionUi.create = function(parentElement, showOnRender, onFileSelected) {
        var button = new FileSelectionUi(parentElement, showOnRender, onFileSelected);
        return button;
    };
    return FileSelectionUi;
}();





var $4bec6eb7b41a1616$export$86c8efd5b3ebd03e = function() {
    function CameraSelectionUi(cameras) {
        this.selectElement = (0, $e012aa67914a9f32$export$6a3443a184593c5).createElement("select", (0, $e012aa67914a9f32$export$5263f2f87e9ad375).CAMERA_SELECTION_SELECT_ID);
        this.cameras = cameras;
        this.options = [];
    }
    CameraSelectionUi.prototype.render = function(parentElement) {
        var cameraSelectionContainer = document.createElement("span");
        cameraSelectionContainer.style.marginRight = "10px";
        var numCameras = this.cameras.length;
        if (numCameras === 0) throw new Error("No cameras found");
        if (numCameras === 1) cameraSelectionContainer.style.display = "none";
        else {
            var selectCameraString = (0, $ff5e69b322275082$export$b9cab5abdb16545c).selectCamera();
            cameraSelectionContainer.innerText = "".concat(selectCameraString, " (").concat(this.cameras.length, ")  ");
        }
        var anonymousCameraId = 1;
        for(var _i = 0, _a = this.cameras; _i < _a.length; _i++){
            var camera = _a[_i];
            var value = camera.id;
            var name_1 = camera.label == null ? value : camera.label;
            if (!name_1 || name_1 === "") name_1 = [
                (0, $ff5e69b322275082$export$b9cab5abdb16545c).anonymousCameraPrefix(),
                anonymousCameraId++
            ].join(" ");
            var option = document.createElement("option");
            option.value = value;
            option.innerText = name_1;
            this.options.push(option);
            this.selectElement.appendChild(option);
        }
        cameraSelectionContainer.appendChild(this.selectElement);
        parentElement.appendChild(cameraSelectionContainer);
    };
    CameraSelectionUi.prototype.disable = function() {
        this.selectElement.disabled = true;
    };
    CameraSelectionUi.prototype.isDisabled = function() {
        return this.selectElement.disabled === true;
    };
    CameraSelectionUi.prototype.enable = function() {
        this.selectElement.disabled = false;
    };
    CameraSelectionUi.prototype.getValue = function() {
        return this.selectElement.value;
    };
    CameraSelectionUi.prototype.hasValue = function(value) {
        for(var _i = 0, _a = this.options; _i < _a.length; _i++){
            var option = _a[_i];
            if (option.value === value) return true;
        }
        return false;
    };
    CameraSelectionUi.prototype.setValue = function(value) {
        if (!this.hasValue(value)) throw new Error("".concat(value, " is not present in the camera list."));
        this.selectElement.value = value;
    };
    CameraSelectionUi.prototype.hasSingleItem = function() {
        return this.cameras.length === 1;
    };
    CameraSelectionUi.prototype.numCameras = function() {
        return this.cameras.length;
    };
    CameraSelectionUi.create = function(parentElement, cameras) {
        var cameraSelectUi = new CameraSelectionUi(cameras);
        cameraSelectUi.render(parentElement);
        return cameraSelectUi;
    };
    return CameraSelectionUi;
}();




var $73da427dd62fd8db$export$2e993d10f166e456 = function() {
    function CameraZoomUi() {
        this.onChangeCallback = null;
        this.zoomElementContainer = document.createElement("div");
        this.rangeInput = (0, $e012aa67914a9f32$export$6a3443a184593c5).createElement("input", (0, $e012aa67914a9f32$export$5263f2f87e9ad375).ZOOM_SLIDER_ID);
        this.rangeInput.type = "range";
        this.rangeText = document.createElement("span");
        this.rangeInput.min = "1";
        this.rangeInput.max = "5";
        this.rangeInput.value = "1";
        this.rangeInput.step = "0.1";
    }
    CameraZoomUi.prototype.render = function(parentElement, renderOnCreate) {
        this.zoomElementContainer.style.display = renderOnCreate ? "block" : "none";
        this.zoomElementContainer.style.padding = "5px 10px";
        this.zoomElementContainer.style.textAlign = "center";
        parentElement.appendChild(this.zoomElementContainer);
        this.rangeInput.style.display = "inline-block";
        this.rangeInput.style.width = "50%";
        this.rangeInput.style.height = "5px";
        this.rangeInput.style.background = "#d3d3d3";
        this.rangeInput.style.outline = "none";
        this.rangeInput.style.opacity = "0.7";
        var zoomString = (0, $ff5e69b322275082$export$b9cab5abdb16545c).zoom();
        this.rangeText.innerText = "".concat(this.rangeInput.value, "x ").concat(zoomString);
        this.rangeText.style.marginRight = "10px";
        var $this = this;
        this.rangeInput.addEventListener("input", function() {
            return $this.onValueChange();
        });
        this.rangeInput.addEventListener("change", function() {
            return $this.onValueChange();
        });
        this.zoomElementContainer.appendChild(this.rangeInput);
        this.zoomElementContainer.appendChild(this.rangeText);
    };
    CameraZoomUi.prototype.onValueChange = function() {
        var zoomString = (0, $ff5e69b322275082$export$b9cab5abdb16545c).zoom();
        this.rangeText.innerText = "".concat(this.rangeInput.value, "x ").concat(zoomString);
        if (this.onChangeCallback) this.onChangeCallback(parseFloat(this.rangeInput.value));
    };
    CameraZoomUi.prototype.setValues = function(minValue, maxValue, defaultValue, step) {
        this.rangeInput.min = minValue.toString();
        this.rangeInput.max = maxValue.toString();
        this.rangeInput.step = step.toString();
        this.rangeInput.value = defaultValue.toString();
        this.onValueChange();
    };
    CameraZoomUi.prototype.show = function() {
        this.zoomElementContainer.style.display = "block";
    };
    CameraZoomUi.prototype.hide = function() {
        this.zoomElementContainer.style.display = "none";
    };
    CameraZoomUi.prototype.setOnCameraZoomValueChangeCallback = function(onChangeCallback) {
        this.onChangeCallback = onChangeCallback;
    };
    CameraZoomUi.prototype.removeOnCameraZoomValueChangeCallback = function() {
        this.onChangeCallback = null;
    };
    CameraZoomUi.create = function(parentElement, renderOnCreate) {
        var cameraZoomUi = new CameraZoomUi();
        cameraZoomUi.render(parentElement, renderOnCreate);
        return cameraZoomUi;
    };
    return CameraZoomUi;
}();


var $3479451dbf27e703$var$Html5QrcodeScannerStatus;
(function(Html5QrcodeScannerStatus) {
    Html5QrcodeScannerStatus[Html5QrcodeScannerStatus["STATUS_DEFAULT"] = 0] = "STATUS_DEFAULT";
    Html5QrcodeScannerStatus[Html5QrcodeScannerStatus["STATUS_SUCCESS"] = 1] = "STATUS_SUCCESS";
    Html5QrcodeScannerStatus[Html5QrcodeScannerStatus["STATUS_WARNING"] = 2] = "STATUS_WARNING";
    Html5QrcodeScannerStatus[Html5QrcodeScannerStatus["STATUS_REQUESTING_PERMISSION"] = 3] = "STATUS_REQUESTING_PERMISSION";
})($3479451dbf27e703$var$Html5QrcodeScannerStatus || ($3479451dbf27e703$var$Html5QrcodeScannerStatus = {}));
function $3479451dbf27e703$var$toHtml5QrcodeCameraScanConfig(config) {
    return {
        fps: config.fps,
        qrbox: config.qrbox,
        aspectRatio: config.aspectRatio,
        disableFlip: config.disableFlip,
        videoConstraints: config.videoConstraints
    };
}
function $3479451dbf27e703$var$toHtml5QrcodeFullConfig(config, verbose) {
    return {
        formatsToSupport: config.formatsToSupport,
        useBarCodeDetectorIfSupported: config.useBarCodeDetectorIfSupported,
        experimentalFeatures: config.experimentalFeatures,
        verbose: verbose
    };
}
var $3479451dbf27e703$export$bc9b6fcc47abf610 = function() {
    function Html5QrcodeScanner(elementId, config, verbose) {
        this.lastMatchFound = null;
        this.cameraScanImage = null;
        this.fileScanImage = null;
        this.fileSelectionUi = null;
        this.elementId = elementId;
        this.config = this.createConfig(config);
        this.verbose = verbose === true;
        if (!document.getElementById(elementId)) throw "HTML Element with id=".concat(elementId, " not found");
        this.scanTypeSelector = new (0, $f71efc754e4e9dc7$export$528d36479c095a59)(this.config.supportedScanTypes);
        this.currentScanType = this.scanTypeSelector.getDefaultScanType();
        this.sectionSwapAllowed = true;
        this.logger = new (0, $c9d6d3563c261b0e$export$1952c0907ffae0f2)(this.verbose);
        this.persistedDataManager = new (0, $569f6d15e38e44d3$export$f4f7158604555024)();
        if (config.rememberLastUsedCamera !== true) this.persistedDataManager.reset();
    }
    Html5QrcodeScanner.prototype.render = function(qrCodeSuccessCallback, qrCodeErrorCallback) {
        var _this = this;
        this.lastMatchFound = null;
        this.qrCodeSuccessCallback = function(decodedText, result) {
            if (qrCodeSuccessCallback) qrCodeSuccessCallback(decodedText, result);
            else {
                if (_this.lastMatchFound === decodedText) return;
                _this.lastMatchFound = decodedText;
                _this.setHeaderMessage((0, $ff5e69b322275082$export$b9cab5abdb16545c).lastMatch(decodedText), $3479451dbf27e703$var$Html5QrcodeScannerStatus.STATUS_SUCCESS);
            }
        };
        this.qrCodeErrorCallback = function(errorMessage, error) {
            if (qrCodeErrorCallback) qrCodeErrorCallback(errorMessage, error);
        };
        var container = document.getElementById(this.elementId);
        if (!container) throw "HTML Element with id=".concat(this.elementId, " not found");
        container.innerHTML = "";
        this.createBasicLayout(container);
        this.html5Qrcode = new (0, $9eb3c467bce0942e$export$e14ced7bffd8eb7a)(this.getScanRegionId(), $3479451dbf27e703$var$toHtml5QrcodeFullConfig(this.config, this.verbose));
    };
    Html5QrcodeScanner.prototype.pause = function(shouldPauseVideo) {
        if ((0, $c9d6d3563c261b0e$export$bedb7023a7733221)(shouldPauseVideo) || shouldPauseVideo !== true) shouldPauseVideo = false;
        this.getHtml5QrcodeOrFail().pause(shouldPauseVideo);
    };
    Html5QrcodeScanner.prototype.resume = function() {
        this.getHtml5QrcodeOrFail().resume();
    };
    Html5QrcodeScanner.prototype.getState = function() {
        return this.getHtml5QrcodeOrFail().getState();
    };
    Html5QrcodeScanner.prototype.clear = function() {
        var _this = this;
        var emptyHtmlContainer = function() {
            var mainContainer = document.getElementById(_this.elementId);
            if (mainContainer) {
                mainContainer.innerHTML = "";
                _this.resetBasicLayout(mainContainer);
            }
        };
        if (this.html5Qrcode) return new Promise(function(resolve, reject) {
            if (!_this.html5Qrcode) {
                resolve();
                return;
            }
            if (_this.html5Qrcode.isScanning) _this.html5Qrcode.stop().then(function(_) {
                if (!_this.html5Qrcode) {
                    resolve();
                    return;
                }
                _this.html5Qrcode.clear();
                emptyHtmlContainer();
                resolve();
            }).catch(function(error) {
                if (_this.verbose) _this.logger.logError("Unable to stop qrcode scanner", error);
                reject(error);
            });
            else {
                _this.html5Qrcode.clear();
                emptyHtmlContainer();
                resolve();
            }
        });
        return Promise.resolve();
    };
    Html5QrcodeScanner.prototype.getRunningTrackCapabilities = function() {
        return this.getHtml5QrcodeOrFail().getRunningTrackCapabilities();
    };
    Html5QrcodeScanner.prototype.getRunningTrackSettings = function() {
        return this.getHtml5QrcodeOrFail().getRunningTrackSettings();
    };
    Html5QrcodeScanner.prototype.applyVideoConstraints = function(videoConstaints) {
        return this.getHtml5QrcodeOrFail().applyVideoConstraints(videoConstaints);
    };
    Html5QrcodeScanner.prototype.getHtml5QrcodeOrFail = function() {
        if (!this.html5Qrcode) throw "Code scanner not initialized.";
        return this.html5Qrcode;
    };
    Html5QrcodeScanner.prototype.createConfig = function(config) {
        if (config) {
            if (!config.fps) config.fps = (0, $c9d6d3563c261b0e$export$a4dae9b55d173e6d).SCAN_DEFAULT_FPS;
            if (config.rememberLastUsedCamera !== !(0, $c9d6d3563c261b0e$export$a4dae9b55d173e6d).DEFAULT_REMEMBER_LAST_CAMERA_USED) config.rememberLastUsedCamera = (0, $c9d6d3563c261b0e$export$a4dae9b55d173e6d).DEFAULT_REMEMBER_LAST_CAMERA_USED;
            if (!config.supportedScanTypes) config.supportedScanTypes = (0, $c9d6d3563c261b0e$export$a4dae9b55d173e6d).DEFAULT_SUPPORTED_SCAN_TYPE;
            return config;
        }
        return {
            fps: (0, $c9d6d3563c261b0e$export$a4dae9b55d173e6d).SCAN_DEFAULT_FPS,
            rememberLastUsedCamera: (0, $c9d6d3563c261b0e$export$a4dae9b55d173e6d).DEFAULT_REMEMBER_LAST_CAMERA_USED,
            supportedScanTypes: (0, $c9d6d3563c261b0e$export$a4dae9b55d173e6d).DEFAULT_SUPPORTED_SCAN_TYPE
        };
    };
    Html5QrcodeScanner.prototype.createBasicLayout = function(parent) {
        parent.style.position = "relative";
        parent.style.padding = "0px";
        parent.style.border = "1px solid silver";
        this.createHeader(parent);
        var qrCodeScanRegion = document.createElement("div");
        var scanRegionId = this.getScanRegionId();
        qrCodeScanRegion.id = scanRegionId;
        qrCodeScanRegion.style.width = "100%";
        qrCodeScanRegion.style.minHeight = "100px";
        qrCodeScanRegion.style.textAlign = "center";
        parent.appendChild(qrCodeScanRegion);
        if ((0, $f71efc754e4e9dc7$export$528d36479c095a59).isCameraScanType(this.currentScanType)) this.insertCameraScanImageToScanRegion();
        else this.insertFileScanImageToScanRegion();
        var qrCodeDashboard = document.createElement("div");
        var dashboardId = this.getDashboardId();
        qrCodeDashboard.id = dashboardId;
        qrCodeDashboard.style.width = "100%";
        parent.appendChild(qrCodeDashboard);
        this.setupInitialDashboard(qrCodeDashboard);
    };
    Html5QrcodeScanner.prototype.resetBasicLayout = function(mainContainer) {
        mainContainer.style.border = "none";
    };
    Html5QrcodeScanner.prototype.setupInitialDashboard = function(dashboard) {
        this.createSection(dashboard);
        this.createSectionControlPanel();
        if (this.scanTypeSelector.hasMoreThanOneScanType()) this.createSectionSwap();
    };
    Html5QrcodeScanner.prototype.createHeader = function(dashboard) {
        var header = document.createElement("div");
        header.style.textAlign = "left";
        header.style.margin = "0px";
        dashboard.appendChild(header);
        var libraryInfo = new (0, $97aa7730745cc7b4$export$a2d0fe6d33028e31)();
        libraryInfo.renderInto(header);
        var headerMessageContainer = document.createElement("div");
        headerMessageContainer.id = this.getHeaderMessageContainerId();
        headerMessageContainer.style.display = "none";
        headerMessageContainer.style.textAlign = "center";
        headerMessageContainer.style.fontSize = "14px";
        headerMessageContainer.style.padding = "2px 10px";
        headerMessageContainer.style.margin = "4px";
        headerMessageContainer.style.borderTop = "1px solid #f6f6f6";
        header.appendChild(headerMessageContainer);
    };
    Html5QrcodeScanner.prototype.createSection = function(dashboard) {
        var section = document.createElement("div");
        section.id = this.getDashboardSectionId();
        section.style.width = "100%";
        section.style.padding = "10px 0px 10px 0px";
        section.style.textAlign = "left";
        dashboard.appendChild(section);
    };
    Html5QrcodeScanner.prototype.createCameraListUi = function(scpCameraScanRegion, requestPermissionContainer, requestPermissionButton) {
        var $this = this;
        $this.showHideScanTypeSwapLink(false);
        $this.setHeaderMessage((0, $ff5e69b322275082$export$b9cab5abdb16545c).cameraPermissionRequesting());
        var createPermissionButtonIfNotExists = function() {
            if (!requestPermissionButton) $this.createPermissionButton(scpCameraScanRegion, requestPermissionContainer);
        };
        (0, $9eb3c467bce0942e$export$e14ced7bffd8eb7a).getCameras().then(function(cameras) {
            $this.persistedDataManager.setHasPermission(true);
            $this.showHideScanTypeSwapLink(true);
            $this.resetHeaderMessage();
            if (cameras && cameras.length > 0) {
                scpCameraScanRegion.removeChild(requestPermissionContainer);
                $this.renderCameraSelection(cameras);
            } else {
                $this.setHeaderMessage((0, $ff5e69b322275082$export$b9cab5abdb16545c).noCameraFound(), $3479451dbf27e703$var$Html5QrcodeScannerStatus.STATUS_WARNING);
                createPermissionButtonIfNotExists();
            }
        }).catch(function(error) {
            $this.persistedDataManager.setHasPermission(false);
            if (requestPermissionButton) requestPermissionButton.disabled = false;
            else createPermissionButtonIfNotExists();
            $this.setHeaderMessage(error, $3479451dbf27e703$var$Html5QrcodeScannerStatus.STATUS_WARNING);
            $this.showHideScanTypeSwapLink(true);
        });
    };
    Html5QrcodeScanner.prototype.createPermissionButton = function(scpCameraScanRegion, requestPermissionContainer) {
        var $this = this;
        var requestPermissionButton = (0, $e012aa67914a9f32$export$6a3443a184593c5).createElement("button", this.getCameraPermissionButtonId());
        requestPermissionButton.innerText = (0, $ff5e69b322275082$export$b9cab5abdb16545c).cameraPermissionTitle();
        requestPermissionButton.addEventListener("click", function() {
            requestPermissionButton.disabled = true;
            $this.createCameraListUi(scpCameraScanRegion, requestPermissionContainer, requestPermissionButton);
        });
        requestPermissionContainer.appendChild(requestPermissionButton);
    };
    Html5QrcodeScanner.prototype.createPermissionsUi = function(scpCameraScanRegion, requestPermissionContainer) {
        var $this = this;
        if ((0, $f71efc754e4e9dc7$export$528d36479c095a59).isCameraScanType(this.currentScanType) && this.persistedDataManager.hasCameraPermissions()) {
            (0, $a7838855c7abaae7$export$693eae80963d557e).hasPermissions().then(function(hasPermissions) {
                if (hasPermissions) $this.createCameraListUi(scpCameraScanRegion, requestPermissionContainer);
                else {
                    $this.persistedDataManager.setHasPermission(false);
                    $this.createPermissionButton(scpCameraScanRegion, requestPermissionContainer);
                }
            }).catch(function(_) {
                $this.persistedDataManager.setHasPermission(false);
                $this.createPermissionButton(scpCameraScanRegion, requestPermissionContainer);
            });
            return;
        }
        this.createPermissionButton(scpCameraScanRegion, requestPermissionContainer);
    };
    Html5QrcodeScanner.prototype.createSectionControlPanel = function() {
        var section = document.getElementById(this.getDashboardSectionId());
        var sectionControlPanel = document.createElement("div");
        section.appendChild(sectionControlPanel);
        var scpCameraScanRegion = document.createElement("div");
        scpCameraScanRegion.id = this.getDashboardSectionCameraScanRegionId();
        scpCameraScanRegion.style.display = (0, $f71efc754e4e9dc7$export$528d36479c095a59).isCameraScanType(this.currentScanType) ? "block" : "none";
        sectionControlPanel.appendChild(scpCameraScanRegion);
        var requestPermissionContainer = document.createElement("div");
        requestPermissionContainer.style.textAlign = "center";
        scpCameraScanRegion.appendChild(requestPermissionContainer);
        if (this.scanTypeSelector.isCameraScanRequired()) this.createPermissionsUi(scpCameraScanRegion, requestPermissionContainer);
        this.renderFileScanUi(sectionControlPanel);
    };
    Html5QrcodeScanner.prototype.renderFileScanUi = function(parent) {
        var showOnRender = (0, $f71efc754e4e9dc7$export$528d36479c095a59).isFileScanType(this.currentScanType);
        var $this = this;
        var onFileSelected = function(file) {
            if (!$this.html5Qrcode) throw "html5Qrcode not defined";
            if (!(0, $f71efc754e4e9dc7$export$528d36479c095a59).isFileScanType($this.currentScanType)) return;
            $this.setHeaderMessage((0, $ff5e69b322275082$export$b9cab5abdb16545c).loadingImage());
            $this.html5Qrcode.scanFileV2(file, true).then(function(html5qrcodeResult) {
                $this.resetHeaderMessage();
                $this.qrCodeSuccessCallback(html5qrcodeResult.decodedText, html5qrcodeResult);
            }).catch(function(error) {
                $this.setHeaderMessage(error, $3479451dbf27e703$var$Html5QrcodeScannerStatus.STATUS_WARNING);
                $this.qrCodeErrorCallback(error, (0, $c9d6d3563c261b0e$export$dac571266bd01cf5).createFrom(error));
            });
        };
        this.fileSelectionUi = (0, $16862ce938b2b921$export$bb6f0d5a8973d33).create(parent, showOnRender, onFileSelected);
    };
    Html5QrcodeScanner.prototype.renderCameraSelection = function(cameras) {
        var _this = this;
        var $this = this;
        var scpCameraScanRegion = document.getElementById(this.getDashboardSectionCameraScanRegionId());
        scpCameraScanRegion.style.textAlign = "center";
        var cameraZoomUi = (0, $73da427dd62fd8db$export$2e993d10f166e456).create(scpCameraScanRegion, false);
        var renderCameraZoomUiIfSupported = function(cameraCapabilities) {
            var zoomCapability = cameraCapabilities.zoomFeature();
            if (!zoomCapability.isSupported()) return;
            cameraZoomUi.setOnCameraZoomValueChangeCallback(function(zoomValue) {
                zoomCapability.apply(zoomValue);
            });
            var defaultZoom = 1;
            if (_this.config.defaultZoomValueIfSupported) defaultZoom = _this.config.defaultZoomValueIfSupported;
            defaultZoom = (0, $c9d6d3563c261b0e$export$e0b576e7a74416cd)(defaultZoom, zoomCapability.min(), zoomCapability.max());
            cameraZoomUi.setValues(zoomCapability.min(), zoomCapability.max(), defaultZoom, zoomCapability.step());
            cameraZoomUi.show();
        };
        var cameraSelectUi = (0, $4bec6eb7b41a1616$export$86c8efd5b3ebd03e).create(scpCameraScanRegion, cameras);
        var cameraActionContainer = document.createElement("span");
        var cameraActionStartButton = (0, $e012aa67914a9f32$export$6a3443a184593c5).createElement("button", (0, $e012aa67914a9f32$export$5263f2f87e9ad375).CAMERA_START_BUTTON_ID);
        cameraActionStartButton.innerText = (0, $ff5e69b322275082$export$b9cab5abdb16545c).scanButtonStartScanningText();
        cameraActionContainer.appendChild(cameraActionStartButton);
        var cameraActionStopButton = (0, $e012aa67914a9f32$export$6a3443a184593c5).createElement("button", (0, $e012aa67914a9f32$export$5263f2f87e9ad375).CAMERA_STOP_BUTTON_ID);
        cameraActionStopButton.innerText = (0, $ff5e69b322275082$export$b9cab5abdb16545c).scanButtonStopScanningText();
        cameraActionStopButton.style.display = "none";
        cameraActionStopButton.disabled = true;
        cameraActionContainer.appendChild(cameraActionStopButton);
        var torchButton;
        var createAndShowTorchButtonIfSupported = function(cameraCapabilities) {
            if (!cameraCapabilities.torchFeature().isSupported()) {
                if (torchButton) torchButton.hide();
                return;
            }
            if (!torchButton) torchButton = (0, $44f49b3cb4096e16$export$11856eebe9d443c6).create(cameraActionContainer, cameraCapabilities.torchFeature(), {
                display: "none",
                marginLeft: "5px"
            }, function(errorMessage) {
                $this.setHeaderMessage(errorMessage, $3479451dbf27e703$var$Html5QrcodeScannerStatus.STATUS_WARNING);
            });
            else torchButton.updateTorchCapability(cameraCapabilities.torchFeature());
            torchButton.show();
        };
        scpCameraScanRegion.appendChild(cameraActionContainer);
        var resetCameraActionStartButton = function(shouldShow) {
            if (!shouldShow) cameraActionStartButton.style.display = "none";
            cameraActionStartButton.innerText = (0, $ff5e69b322275082$export$b9cab5abdb16545c).scanButtonStartScanningText();
            cameraActionStartButton.style.opacity = "1";
            cameraActionStartButton.disabled = false;
            if (shouldShow) cameraActionStartButton.style.display = "inline-block";
        };
        cameraActionStartButton.addEventListener("click", function(_) {
            cameraActionStartButton.innerText = (0, $ff5e69b322275082$export$b9cab5abdb16545c).scanButtonScanningStarting();
            cameraSelectUi.disable();
            cameraActionStartButton.disabled = true;
            cameraActionStartButton.style.opacity = "0.5";
            if (_this.scanTypeSelector.hasMoreThanOneScanType()) $this.showHideScanTypeSwapLink(false);
            $this.resetHeaderMessage();
            var cameraId = cameraSelectUi.getValue();
            $this.persistedDataManager.setLastUsedCameraId(cameraId);
            $this.html5Qrcode.start(cameraId, $3479451dbf27e703$var$toHtml5QrcodeCameraScanConfig($this.config), $this.qrCodeSuccessCallback, $this.qrCodeErrorCallback).then(function(_) {
                cameraActionStopButton.disabled = false;
                cameraActionStopButton.style.display = "inline-block";
                resetCameraActionStartButton(false);
                var cameraCapabilities = $this.html5Qrcode.getRunningTrackCameraCapabilities();
                if (_this.config.showTorchButtonIfSupported === true) createAndShowTorchButtonIfSupported(cameraCapabilities);
                if (_this.config.showZoomSliderIfSupported === true) renderCameraZoomUiIfSupported(cameraCapabilities);
            }).catch(function(error) {
                $this.showHideScanTypeSwapLink(true);
                cameraSelectUi.enable();
                resetCameraActionStartButton(true);
                $this.setHeaderMessage(error, $3479451dbf27e703$var$Html5QrcodeScannerStatus.STATUS_WARNING);
            });
        });
        if (cameraSelectUi.hasSingleItem()) cameraActionStartButton.click();
        cameraActionStopButton.addEventListener("click", function(_) {
            if (!$this.html5Qrcode) throw "html5Qrcode not defined";
            cameraActionStopButton.disabled = true;
            $this.html5Qrcode.stop().then(function(_) {
                if (_this.scanTypeSelector.hasMoreThanOneScanType()) $this.showHideScanTypeSwapLink(true);
                cameraSelectUi.enable();
                cameraActionStartButton.disabled = false;
                cameraActionStopButton.style.display = "none";
                cameraActionStartButton.style.display = "inline-block";
                if (torchButton) {
                    torchButton.reset();
                    torchButton.hide();
                }
                cameraZoomUi.removeOnCameraZoomValueChangeCallback();
                cameraZoomUi.hide();
                $this.insertCameraScanImageToScanRegion();
            }).catch(function(error) {
                cameraActionStopButton.disabled = false;
                $this.setHeaderMessage(error, $3479451dbf27e703$var$Html5QrcodeScannerStatus.STATUS_WARNING);
            });
        });
        if ($this.persistedDataManager.getLastUsedCameraId()) {
            var cameraId = $this.persistedDataManager.getLastUsedCameraId();
            if (cameraSelectUi.hasValue(cameraId)) {
                cameraSelectUi.setValue(cameraId);
                cameraActionStartButton.click();
            } else $this.persistedDataManager.resetLastUsedCameraId();
        }
    };
    Html5QrcodeScanner.prototype.createSectionSwap = function() {
        var $this = this;
        var TEXT_IF_CAMERA_SCAN_SELECTED = (0, $ff5e69b322275082$export$b9cab5abdb16545c).textIfCameraScanSelected();
        var TEXT_IF_FILE_SCAN_SELECTED = (0, $ff5e69b322275082$export$b9cab5abdb16545c).textIfFileScanSelected();
        var section = document.getElementById(this.getDashboardSectionId());
        var switchContainer = document.createElement("div");
        switchContainer.style.textAlign = "center";
        var switchScanTypeLink = (0, $e012aa67914a9f32$export$6a3443a184593c5).createElement("span", this.getDashboardSectionSwapLinkId());
        switchScanTypeLink.style.textDecoration = "underline";
        switchScanTypeLink.style.cursor = "pointer";
        switchScanTypeLink.innerText = (0, $f71efc754e4e9dc7$export$528d36479c095a59).isCameraScanType(this.currentScanType) ? TEXT_IF_CAMERA_SCAN_SELECTED : TEXT_IF_FILE_SCAN_SELECTED;
        switchScanTypeLink.addEventListener("click", function() {
            if (!$this.sectionSwapAllowed) {
                if ($this.verbose) $this.logger.logError("Section swap called when not allowed");
                return;
            }
            $this.resetHeaderMessage();
            $this.fileSelectionUi.resetValue();
            $this.sectionSwapAllowed = false;
            if ((0, $f71efc754e4e9dc7$export$528d36479c095a59).isCameraScanType($this.currentScanType)) {
                $this.clearScanRegion();
                $this.getCameraScanRegion().style.display = "none";
                $this.fileSelectionUi.show();
                switchScanTypeLink.innerText = TEXT_IF_FILE_SCAN_SELECTED;
                $this.currentScanType = (0, $c9d6d3563c261b0e$export$13ed3042ed099f6a).SCAN_TYPE_FILE;
                $this.insertFileScanImageToScanRegion();
            } else {
                $this.clearScanRegion();
                $this.getCameraScanRegion().style.display = "block";
                $this.fileSelectionUi.hide();
                switchScanTypeLink.innerText = TEXT_IF_CAMERA_SCAN_SELECTED;
                $this.currentScanType = (0, $c9d6d3563c261b0e$export$13ed3042ed099f6a).SCAN_TYPE_CAMERA;
                $this.insertCameraScanImageToScanRegion();
                $this.startCameraScanIfPermissionExistsOnSwap();
            }
            $this.sectionSwapAllowed = true;
        });
        switchContainer.appendChild(switchScanTypeLink);
        section.appendChild(switchContainer);
    };
    Html5QrcodeScanner.prototype.startCameraScanIfPermissionExistsOnSwap = function() {
        var _this = this;
        var $this = this;
        if (this.persistedDataManager.hasCameraPermissions()) {
            (0, $a7838855c7abaae7$export$693eae80963d557e).hasPermissions().then(function(hasPermissions) {
                if (hasPermissions) {
                    var permissionButton = document.getElementById($this.getCameraPermissionButtonId());
                    if (!permissionButton) {
                        _this.logger.logError("Permission button not found, fail;");
                        throw "Permission button not found";
                    }
                    permissionButton.click();
                } else $this.persistedDataManager.setHasPermission(false);
            }).catch(function(_) {
                $this.persistedDataManager.setHasPermission(false);
            });
            return;
        }
    };
    Html5QrcodeScanner.prototype.resetHeaderMessage = function() {
        var messageDiv = document.getElementById(this.getHeaderMessageContainerId());
        messageDiv.style.display = "none";
    };
    Html5QrcodeScanner.prototype.setHeaderMessage = function(messageText, scannerStatus) {
        if (!scannerStatus) scannerStatus = $3479451dbf27e703$var$Html5QrcodeScannerStatus.STATUS_DEFAULT;
        var messageDiv = this.getHeaderMessageDiv();
        messageDiv.innerText = messageText;
        messageDiv.style.display = "block";
        switch(scannerStatus){
            case $3479451dbf27e703$var$Html5QrcodeScannerStatus.STATUS_SUCCESS:
                messageDiv.style.background = "rgba(106, 175, 80, 0.26)";
                messageDiv.style.color = "#477735";
                break;
            case $3479451dbf27e703$var$Html5QrcodeScannerStatus.STATUS_WARNING:
                messageDiv.style.background = "rgba(203, 36, 49, 0.14)";
                messageDiv.style.color = "#cb2431";
                break;
            case $3479451dbf27e703$var$Html5QrcodeScannerStatus.STATUS_DEFAULT:
            default:
                messageDiv.style.background = "rgba(0, 0, 0, 0)";
                messageDiv.style.color = "rgb(17, 17, 17)";
                break;
        }
    };
    Html5QrcodeScanner.prototype.showHideScanTypeSwapLink = function(shouldDisplay) {
        if (this.scanTypeSelector.hasMoreThanOneScanType()) {
            if (shouldDisplay !== true) shouldDisplay = false;
            this.sectionSwapAllowed = shouldDisplay;
            this.getDashboardSectionSwapLink().style.display = shouldDisplay ? "inline-block" : "none";
        }
    };
    Html5QrcodeScanner.prototype.insertCameraScanImageToScanRegion = function() {
        var $this = this;
        var qrCodeScanRegion = document.getElementById(this.getScanRegionId());
        if (this.cameraScanImage) {
            qrCodeScanRegion.innerHTML = "<br>";
            qrCodeScanRegion.appendChild(this.cameraScanImage);
            return;
        }
        this.cameraScanImage = new Image;
        this.cameraScanImage.onload = function(_) {
            qrCodeScanRegion.innerHTML = "<br>";
            qrCodeScanRegion.appendChild($this.cameraScanImage);
        };
        this.cameraScanImage.width = 64;
        this.cameraScanImage.style.opacity = "0.8";
        this.cameraScanImage.src = (0, $701d751907918eac$export$be7b9b11efa99dbc);
        this.cameraScanImage.alt = (0, $ff5e69b322275082$export$b9cab5abdb16545c).cameraScanAltText();
    };
    Html5QrcodeScanner.prototype.insertFileScanImageToScanRegion = function() {
        var $this = this;
        var qrCodeScanRegion = document.getElementById(this.getScanRegionId());
        if (this.fileScanImage) {
            qrCodeScanRegion.innerHTML = "<br>";
            qrCodeScanRegion.appendChild(this.fileScanImage);
            return;
        }
        this.fileScanImage = new Image;
        this.fileScanImage.onload = function(_) {
            qrCodeScanRegion.innerHTML = "<br>";
            qrCodeScanRegion.appendChild($this.fileScanImage);
        };
        this.fileScanImage.width = 64;
        this.fileScanImage.style.opacity = "0.8";
        this.fileScanImage.src = (0, $701d751907918eac$export$c97cd35b47589f30);
        this.fileScanImage.alt = (0, $ff5e69b322275082$export$b9cab5abdb16545c).fileScanAltText();
    };
    Html5QrcodeScanner.prototype.clearScanRegion = function() {
        var qrCodeScanRegion = document.getElementById(this.getScanRegionId());
        qrCodeScanRegion.innerHTML = "";
    };
    Html5QrcodeScanner.prototype.getDashboardSectionId = function() {
        return "".concat(this.elementId, "__dashboard_section");
    };
    Html5QrcodeScanner.prototype.getDashboardSectionCameraScanRegionId = function() {
        return "".concat(this.elementId, "__dashboard_section_csr");
    };
    Html5QrcodeScanner.prototype.getDashboardSectionSwapLinkId = function() {
        return (0, $e012aa67914a9f32$export$5263f2f87e9ad375).SCAN_TYPE_CHANGE_ANCHOR_ID;
    };
    Html5QrcodeScanner.prototype.getScanRegionId = function() {
        return "".concat(this.elementId, "__scan_region");
    };
    Html5QrcodeScanner.prototype.getDashboardId = function() {
        return "".concat(this.elementId, "__dashboard");
    };
    Html5QrcodeScanner.prototype.getHeaderMessageContainerId = function() {
        return "".concat(this.elementId, "__header_message");
    };
    Html5QrcodeScanner.prototype.getCameraPermissionButtonId = function() {
        return (0, $e012aa67914a9f32$export$5263f2f87e9ad375).CAMERA_PERMISSION_BUTTON_ID;
    };
    Html5QrcodeScanner.prototype.getCameraScanRegion = function() {
        return document.getElementById(this.getDashboardSectionCameraScanRegionId());
    };
    Html5QrcodeScanner.prototype.getDashboardSectionSwapLink = function() {
        return document.getElementById(this.getDashboardSectionSwapLinkId());
    };
    Html5QrcodeScanner.prototype.getHeaderMessageDiv = function() {
        return document.getElementById(this.getHeaderMessageContainerId());
    };
    return Html5QrcodeScanner;
}();









var $dAQd3 = parcelRequire("dAQd3");
function $78b54bd991d76db4$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
function $78b54bd991d76db4$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
const $78b54bd991d76db4$var$$953deebe48519221$export$3a0af973ab9abfb3 = ()=>{
// Intentionally empty
};
const $78b54bd991d76db4$var$$953deebe48519221$export$b2229c0522132a74 = (cameras)=>{
    // Get previous camera selection
    const storage = localStorage.getItem('camera_selection');
    /**
   * @type {import('../types').Camera | null}
   */ const previousSelection = storage ? JSON.parse(storage) : null;
    // If previous camera is still available, use it
    if (previousSelection && cameras.some(({ id: id })=>id === previousSelection.id)) return previousSelection;
    // Look for a back camera
    const backCamera = cameras.find(({ label: label })=>label.toLowerCase().includes('back'));
    // Default, first camera found
    const defaultCamera = cameras[0];
    return backCamera || defaultCamera;
};
const $78b54bd991d76db4$var$$953deebe48519221$export$f2c4ef2d1f0c2e1d = async ()=>{
    const devices = await (0, $9eb3c467bce0942e$export$e14ced7bffd8eb7a).getCameras();
    if (!devices.length) throw new Error('No cameras found');
    return devices;
};
const $78b54bd991d76db4$var$$8f4a7e327cfc31fa$export$3554c92511f9ea7a = {
    startCamera: $78b54bd991d76db4$var$$953deebe48519221$export$3a0af973ab9abfb3
};
const $78b54bd991d76db4$var$$8f4a7e327cfc31fa$export$9dc4ea39af0daa49 = (0, $lCzvA.createContext)($78b54bd991d76db4$var$$8f4a7e327cfc31fa$export$3554c92511f9ea7a);
const $78b54bd991d76db4$export$91d88843bfb219ae = ()=>(0, $lCzvA.useContext)($78b54bd991d76db4$var$$8f4a7e327cfc31fa$export$9dc4ea39af0daa49);
const $78b54bd991d76db4$var$$7aede9e186d82185$export$6a5e58c31158ca8 = 'start_camera';
const $78b54bd991d76db4$var$$7aede9e186d82185$export$e8cea1d59b0c9f14 = 'set_camera_open';
const $78b54bd991d76db4$var$$7aede9e186d82185$export$18cb8552e15b3d06 = 'set_html5_qr_code';
const $78b54bd991d76db4$var$$7aede9e186d82185$export$6910e11b01a25b49 = 'set_selected_camera';
const $78b54bd991d76db4$var$$7aede9e186d82185$export$89dec1050c5f188a = 'set_cameras';
const $78b54bd991d76db4$var$$377ebf84863e9293$export$dbd874037937496d = {
    onScan: $78b54bd991d76db4$var$$953deebe48519221$export$3a0af973ab9abfb3,
    onClose: $78b54bd991d76db4$var$$953deebe48519221$export$3a0af973ab9abfb3,
    isOpen: false,
    cameras: [],
    selectedCamera: undefined,
    html5QrCode: undefined
};
const $78b54bd991d76db4$var$$377ebf84863e9293$export$32a09064dc2bfed6 = (state, action)=>{
    switch(action.type){
        case $78b54bd991d76db4$var$$7aede9e186d82185$export$e8cea1d59b0c9f14:
            return {
                ...state,
                isOpen: Boolean(action.payload)
            };
        case $78b54bd991d76db4$var$$7aede9e186d82185$export$6a5e58c31158ca8:
            return {
                ...state,
                isOpen: true,
                onScan: action.payload.onScan,
                onClose: action.payload.onClose
            };
        case $78b54bd991d76db4$var$$7aede9e186d82185$export$18cb8552e15b3d06:
            return {
                ...state,
                html5QrCode: action.payload
            };
        case $78b54bd991d76db4$var$$7aede9e186d82185$export$6910e11b01a25b49:
            return {
                ...state,
                selectedCamera: action.payload
            };
        case $78b54bd991d76db4$var$$7aede9e186d82185$export$89dec1050c5f188a:
            return {
                ...state,
                cameras: action.payload
            };
        default:
            return state;
    }
};
const $78b54bd991d76db4$var$$97a6ca42802421f7$export$9f4e0787ee8eb98b = {
    state: $78b54bd991d76db4$var$$377ebf84863e9293$export$dbd874037937496d,
    dispatch: $78b54bd991d76db4$var$$953deebe48519221$export$3a0af973ab9abfb3
};
const $78b54bd991d76db4$var$$97a6ca42802421f7$export$d056f9c7816498b6 = (0, $lCzvA.createContext)($78b54bd991d76db4$var$$97a6ca42802421f7$export$9f4e0787ee8eb98b);
const $78b54bd991d76db4$var$$97a6ca42802421f7$export$64721b56a8912ad6 = ()=>(0, $lCzvA.useContext)($78b54bd991d76db4$var$$97a6ca42802421f7$export$d056f9c7816498b6);
var $78b54bd991d76db4$var$$d3f756ffb036b967$exports = {};
$78b54bd991d76db4$var$$parcel$export($78b54bd991d76db4$var$$d3f756ffb036b967$exports, "backdrop", function() {
    return $78b54bd991d76db4$var$$d3f756ffb036b967$export$48e901322468f6d5;
}, function(v) {
    return $78b54bd991d76db4$var$$d3f756ffb036b967$export$48e901322468f6d5 = v;
});
$78b54bd991d76db4$var$$parcel$export($78b54bd991d76db4$var$$d3f756ffb036b967$exports, "children", function() {
    return $78b54bd991d76db4$var$$d3f756ffb036b967$export$bacb5cc5a11aef16;
}, function(v) {
    return $78b54bd991d76db4$var$$d3f756ffb036b967$export$bacb5cc5a11aef16 = v;
});
$78b54bd991d76db4$var$$parcel$export($78b54bd991d76db4$var$$d3f756ffb036b967$exports, "close", function() {
    return $78b54bd991d76db4$var$$d3f756ffb036b967$export$8360e631d277ea4d;
}, function(v) {
    return $78b54bd991d76db4$var$$d3f756ffb036b967$export$8360e631d277ea4d = v;
});
$78b54bd991d76db4$var$$parcel$export($78b54bd991d76db4$var$$d3f756ffb036b967$exports, "content", function() {
    return $78b54bd991d76db4$var$$d3f756ffb036b967$export$a7db06668cad9adb;
}, function(v) {
    return $78b54bd991d76db4$var$$d3f756ffb036b967$export$a7db06668cad9adb = v;
});
$78b54bd991d76db4$var$$parcel$export($78b54bd991d76db4$var$$d3f756ffb036b967$exports, "fadeIn", function() {
    return $78b54bd991d76db4$var$$d3f756ffb036b967$export$82e6205b15e6c637;
}, function(v) {
    return $78b54bd991d76db4$var$$d3f756ffb036b967$export$82e6205b15e6c637 = v;
});
$78b54bd991d76db4$var$$parcel$export($78b54bd991d76db4$var$$d3f756ffb036b967$exports, "fadeOut", function() {
    return $78b54bd991d76db4$var$$d3f756ffb036b967$export$c091916f1530334c;
}, function(v) {
    return $78b54bd991d76db4$var$$d3f756ffb036b967$export$c091916f1530334c = v;
});
$78b54bd991d76db4$var$$parcel$export($78b54bd991d76db4$var$$d3f756ffb036b967$exports, "header", function() {
    return $78b54bd991d76db4$var$$d3f756ffb036b967$export$38e42c68cf43b5d4;
}, function(v) {
    return $78b54bd991d76db4$var$$d3f756ffb036b967$export$38e42c68cf43b5d4 = v;
});
$78b54bd991d76db4$var$$parcel$export($78b54bd991d76db4$var$$d3f756ffb036b967$exports, "slideIn", function() {
    return $78b54bd991d76db4$var$$d3f756ffb036b967$export$d08c54023c399c9c;
}, function(v) {
    return $78b54bd991d76db4$var$$d3f756ffb036b967$export$d08c54023c399c9c = v;
});
$78b54bd991d76db4$var$$parcel$export($78b54bd991d76db4$var$$d3f756ffb036b967$exports, "slideOut", function() {
    return $78b54bd991d76db4$var$$d3f756ffb036b967$export$388d063d19975bb;
}, function(v) {
    return $78b54bd991d76db4$var$$d3f756ffb036b967$export$388d063d19975bb = v;
});
$78b54bd991d76db4$var$$parcel$export($78b54bd991d76db4$var$$d3f756ffb036b967$exports, "title", function() {
    return $78b54bd991d76db4$var$$d3f756ffb036b967$export$fb184b623420d9be;
}, function(v) {
    return $78b54bd991d76db4$var$$d3f756ffb036b967$export$fb184b623420d9be = v;
});
var $78b54bd991d76db4$var$$d3f756ffb036b967$export$48e901322468f6d5;
var $78b54bd991d76db4$var$$d3f756ffb036b967$export$bacb5cc5a11aef16;
var $78b54bd991d76db4$var$$d3f756ffb036b967$export$8360e631d277ea4d;
var $78b54bd991d76db4$var$$d3f756ffb036b967$export$a7db06668cad9adb;
var $78b54bd991d76db4$var$$d3f756ffb036b967$export$82e6205b15e6c637;
var $78b54bd991d76db4$var$$d3f756ffb036b967$export$c091916f1530334c;
var $78b54bd991d76db4$var$$d3f756ffb036b967$export$38e42c68cf43b5d4;
var $78b54bd991d76db4$var$$d3f756ffb036b967$export$d08c54023c399c9c;
var $78b54bd991d76db4$var$$d3f756ffb036b967$export$388d063d19975bb;
var $78b54bd991d76db4$var$$d3f756ffb036b967$export$fb184b623420d9be;
$78b54bd991d76db4$var$$d3f756ffb036b967$export$48e901322468f6d5 = `fHv5Ia_backdrop`;
$78b54bd991d76db4$var$$d3f756ffb036b967$export$bacb5cc5a11aef16 = `fHv5Ia_children`;
$78b54bd991d76db4$var$$d3f756ffb036b967$export$8360e631d277ea4d = `fHv5Ia_close`;
$78b54bd991d76db4$var$$d3f756ffb036b967$export$a7db06668cad9adb = `fHv5Ia_content`;
$78b54bd991d76db4$var$$d3f756ffb036b967$export$82e6205b15e6c637 = `fHv5Ia_fadeIn`;
$78b54bd991d76db4$var$$d3f756ffb036b967$export$82e6205b15e6c637;
$78b54bd991d76db4$var$$d3f756ffb036b967$export$c091916f1530334c = `fHv5Ia_fadeOut`;
$78b54bd991d76db4$var$$d3f756ffb036b967$export$c091916f1530334c;
$78b54bd991d76db4$var$$d3f756ffb036b967$export$38e42c68cf43b5d4 = `fHv5Ia_header`;
$78b54bd991d76db4$var$$d3f756ffb036b967$export$d08c54023c399c9c = `fHv5Ia_slideIn`;
$78b54bd991d76db4$var$$d3f756ffb036b967$export$d08c54023c399c9c;
$78b54bd991d76db4$var$$d3f756ffb036b967$export$388d063d19975bb = `fHv5Ia_slideOut`;
$78b54bd991d76db4$var$$d3f756ffb036b967$export$388d063d19975bb;
$78b54bd991d76db4$var$$d3f756ffb036b967$export$fb184b623420d9be = `fHv5Ia_title`;
const $78b54bd991d76db4$var$$c6c818cf84aec1f2$export$2b77a92f1a5ad772 = ({ isOpen: isOpen, onClose: onClose, title: title, children: children })=>{
    const [modal, setModal] = (0, $lCzvA.useState)(null);
    const [animations, setAnimations] = (0, $lCzvA.useState)({
        backdrop: '',
        content: ''
    });
    const closeModal = ()=>{
        setAnimations({
            backdrop: 'fadeOut',
            content: 'slideOut'
        });
        setTimeout(()=>{
            onClose();
        }, 350);
    };
    (0, $lCzvA.useEffect)(()=>{
        setAnimations({
            backdrop: 'fadeIn',
            content: 'slideIn'
        });
    }, [
        isOpen
    ]);
    (0, $lCzvA.useEffect)(()=>{
        /** @type {any} */ let portalRoot = document.getElementById('portal') || null;
        if (!portalRoot) {
            portalRoot = document.createElement('div');
            portalRoot.setAttribute('id', 'portal');
            document.body.append(portalRoot);
        }
        /** @type {any} */ const modalDiv = document.createElement('div');
        portalRoot?.append(modalDiv);
        setModal(modalDiv);
        return ()=>{
            portalRoot?.remove(modalDiv);
        };
    }, []);
    if (!modal || !isOpen) return (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {});
    return (0, $dAQd3.createPortal)((0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
        className: `${/*@__PURE__*/ $78b54bd991d76db4$var$$parcel$interopDefault($78b54bd991d76db4$var$$d3f756ffb036b967$exports).backdrop} ${/*@__PURE__*/ $78b54bd991d76db4$var$$parcel$interopDefault($78b54bd991d76db4$var$$d3f756ffb036b967$exports)[animations.backdrop]}`,
        "data-testid": "modal",
        children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
            className: `${/*@__PURE__*/ $78b54bd991d76db4$var$$parcel$interopDefault($78b54bd991d76db4$var$$d3f756ffb036b967$exports).content} ${/*@__PURE__*/ $78b54bd991d76db4$var$$parcel$interopDefault($78b54bd991d76db4$var$$d3f756ffb036b967$exports)[animations.content]}`,
            "data-testid": "modal_content",
            children: [
                (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                    className: /*@__PURE__*/ $78b54bd991d76db4$var$$parcel$interopDefault($78b54bd991d76db4$var$$d3f756ffb036b967$exports).header,
                    children: [
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                            className: /*@__PURE__*/ $78b54bd991d76db4$var$$parcel$interopDefault($78b54bd991d76db4$var$$d3f756ffb036b967$exports).title,
                            children: title
                        }),
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("button", {
                            type: "button",
                            className: /*@__PURE__*/ $78b54bd991d76db4$var$$parcel$interopDefault($78b54bd991d76db4$var$$d3f756ffb036b967$exports).close,
                            onClick: closeModal,
                            "data-testid": "modal_close",
                            children: "\u2716"
                        })
                    ]
                }),
                (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                    className: /*@__PURE__*/ $78b54bd991d76db4$var$$parcel$interopDefault($78b54bd991d76db4$var$$d3f756ffb036b967$exports).children,
                    children: children
                })
            ]
        })
    }), modal);
};
var $78b54bd991d76db4$var$$cc3b2135a65ce9e0$export$2e6c959c16ff56b8;
$78b54bd991d76db4$var$$cc3b2135a65ce9e0$export$2e6c959c16ff56b8 = `YSQfda_select`;
/**
 * Renders a list of cameras for user selection.
 */ const $78b54bd991d76db4$var$$e0259d13009c7fbb$var$CameraSelection = ()=>{
    const { state: { cameras: cameras, selectedCamera: selectedCamera }, dispatch: dispatch } = $78b54bd991d76db4$var$$97a6ca42802421f7$export$64721b56a8912ad6();
    /**
   * Updates + stores the selected camera.
   * @param {import('react').ChangeEvent<HTMLSelectElement>} e
   */ const changeCamera = (e)=>{
        const { value: value } = e.target;
        const camera = cameras.find((cam)=>cam.id === value);
        dispatch({
            type: $78b54bd991d76db4$var$$7aede9e186d82185$export$6910e11b01a25b49,
            payload: camera
        });
        localStorage.setItem('camera_selection', JSON.stringify(camera));
    };
    return (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $1e1ba35c5b9fc4c3$exports.Fragment), {
        children: [
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("label", {
                htmlFor: "cameras",
                children: "Select Camera"
            }),
            (0, $1e1ba35c5b9fc4c3$exports.jsx)("select", {
                id: "cameras",
                "data-testid": "camera-select",
                className: $78b54bd991d76db4$var$$cc3b2135a65ce9e0$export$2e6c959c16ff56b8,
                onChange: changeCamera,
                value: selectedCamera?.id,
                children: cameras.map(({ id: id, label: label })=>(0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                        value: id,
                        children: label
                    }, id))
            })
        ]
    });
};
var $78b54bd991d76db4$var$$e0259d13009c7fbb$export$2e2bcd8739ae039 = $78b54bd991d76db4$var$$e0259d13009c7fbb$var$CameraSelection;
const $78b54bd991d76db4$var$$73ba6d2475d77f64$export$5a60a0f10cd7c33f = [
    (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).QR_CODE,
    (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).AZTEC,
    (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).CODABAR,
    (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).CODE_39,
    (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).CODE_93,
    (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).CODE_128,
    (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).DATA_MATRIX,
    (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).MAXICODE,
    (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).ITF,
    (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).EAN_13,
    (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).EAN_8,
    (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).PDF_417,
    (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).RSS_14,
    (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).RSS_EXPANDED,
    (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).UPC_A,
    (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).UPC_E,
    (0, $c9d6d3563c261b0e$export$74c1f679d38d82e5).UPC_EAN_EXTENSION
];
const $78b54bd991d76db4$var$$73ba6d2475d77f64$export$70cb25e13c857175 = 'reader';
const $78b54bd991d76db4$var$$73ba6d2475d77f64$export$d7405538098bc787 = {
    fps: 20
};
var $78b54bd991d76db4$var$$fed7c2b9e91f1421$export$9d7c7e61b1dce3b0;
var $78b54bd991d76db4$var$$fed7c2b9e91f1421$export$c7ab36ff55199b03;
var $78b54bd991d76db4$var$$fed7c2b9e91f1421$export$8f981dffec84ba52;
var $78b54bd991d76db4$var$$fed7c2b9e91f1421$export$f1a76e4a6085c675;
var $78b54bd991d76db4$var$$fed7c2b9e91f1421$export$f4c5de44377d2946;
$78b54bd991d76db4$var$$fed7c2b9e91f1421$export$9d7c7e61b1dce3b0 = `rnn3Ia_camera`;
$78b54bd991d76db4$var$$fed7c2b9e91f1421$export$c7ab36ff55199b03 = `rnn3Ia_cameraContainer`;
$78b54bd991d76db4$var$$fed7c2b9e91f1421$export$8f981dffec84ba52 = `rnn3Ia_contentContainer`;
$78b54bd991d76db4$var$$fed7c2b9e91f1421$export$f1a76e4a6085c675 = `rnn3Ia_errorText`;
$78b54bd991d76db4$var$$fed7c2b9e91f1421$export$f4c5de44377d2946 = `rnn3Ia_loader`;
const $78b54bd991d76db4$var$$5d243954a669ce26$export$d74867e90f5dd357 = ()=>{
    const { state: { onScan: onScan, onClose: onClose, isOpen: isOpen, html5QrCode: html5QrCode, cameras: cameras, selectedCamera: selectedCamera }, dispatch: dispatch } = $78b54bd991d76db4$var$$97a6ca42802421f7$export$64721b56a8912ad6();
    const [cameraError, setCameraError] = (0, $lCzvA.useState)(/** @type {string | null} */ null);
    const [loading, setLoading] = (0, $lCzvA.useState)(true);
    /**
   * Stops the camera and scanner.
   */ const stopScanning = (0, $lCzvA.useCallback)(async ()=>{
        try {
            const scanningState = html5QrCode?.getState();
            // Stop the scanner if it's running
            if (scanningState === (0, $82bbb6140bb56c40$export$c90f317190d585a3).SCANNING) await html5QrCode?.stop();
        } catch (error) {
            setCameraError(error.toString());
        }
    }, [
        html5QrCode
    ]);
    /**
   * Starts scanning with the selected camera.
   */ const startScanning = (0, $lCzvA.useCallback)(async ()=>{
        /**
     * Callback when a QR/Bar code is successfully scanned.
     * @type {import('html5-qrcode').QrcodeSuccessCallback}
     */ const scanSuccess = async (decodedText)=>{
            onScan(decodedText.trim());
            try {
                await html5QrCode?.stop();
            } catch (error) {
                setCameraError(error.toString());
            }
        };
        await html5QrCode?.start(String(selectedCamera?.id), $78b54bd991d76db4$var$$73ba6d2475d77f64$export$d7405538098bc787, scanSuccess, undefined);
    }, [
        onScan,
        html5QrCode,
        selectedCamera?.id
    ]);
    /**
   * Stops any running camera and initializes the new selected camera.
   */ const handleCameraChange = (0, $lCzvA.useCallback)(async ()=>{
        if (!selectedCamera || !isOpen) return;
        try {
            await stopScanning();
            await startScanning();
        } catch (error) {
            setCameraError(error.toString());
        } finally{
            setLoading(false);
        }
    }, [
        isOpen,
        selectedCamera,
        startScanning,
        stopScanning
    ]);
    (0, $lCzvA.useEffect)(()=>{
        handleCameraChange();
    }, [
        handleCameraChange
    ]);
    /**
   * Stops any running camera and closes the scanner.
   */ const handleUserClosed = async ()=>{
        await stopScanning();
        onClose();
    };
    (0, $lCzvA.useEffect)(()=>{
        if (isOpen) {
            setLoading(true);
            if (!html5QrCode) dispatch({
                type: $78b54bd991d76db4$var$$7aede9e186d82185$export$18cb8552e15b3d06,
                payload: new (0, $9eb3c467bce0942e$export$e14ced7bffd8eb7a)($78b54bd991d76db4$var$$73ba6d2475d77f64$export$70cb25e13c857175, {
                    formatsToSupport: $78b54bd991d76db4$var$$73ba6d2475d77f64$export$5a60a0f10cd7c33f,
                    verbose: false
                })
            });
        } else setCameraError(null);
        return ()=>{
            stopScanning();
        };
    }, [
        isOpen,
        html5QrCode,
        dispatch,
        stopScanning
    ]);
    return (0, $1e1ba35c5b9fc4c3$exports.jsx)($78b54bd991d76db4$var$$c6c818cf84aec1f2$export$2b77a92f1a5ad772, {
        "data-testid": "div-modal",
        isOpen: isOpen,
        onClose: handleUserClosed,
        title: "Scan Barcode",
        children: (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
            className: $78b54bd991d76db4$var$$fed7c2b9e91f1421$export$8f981dffec84ba52,
            children: [
                (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                    className: $78b54bd991d76db4$var$$fed7c2b9e91f1421$export$c7ab36ff55199b03,
                    children: [
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                            id: $78b54bd991d76db4$var$$73ba6d2475d77f64$export$70cb25e13c857175,
                            className: $78b54bd991d76db4$var$$fed7c2b9e91f1421$export$9d7c7e61b1dce3b0
                        }),
                        (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $6bfaf8085a30c9b5$export$4bf83b24a11cff0b), {
                            visible: loading,
                            height: "50",
                            width: "50",
                            color: "#FFDE00",
                            radius: "9",
                            ariaLabel: "three-dots-loading",
                            wrapperClass: $78b54bd991d76db4$var$$fed7c2b9e91f1421$export$f4c5de44377d2946
                        })
                    ]
                }),
                cameraError && (0, $1e1ba35c5b9fc4c3$exports.jsxs)("p", {
                    className: $78b54bd991d76db4$var$$fed7c2b9e91f1421$export$f1a76e4a6085c675,
                    children: [
                        "Error: ",
                        cameraError
                    ]
                }),
                Boolean(cameras.length) && selectedCamera && (0, $1e1ba35c5b9fc4c3$exports.jsx)($78b54bd991d76db4$var$$e0259d13009c7fbb$export$2e2bcd8739ae039, {})
            ]
        })
    });
};
const $78b54bd991d76db4$export$52bd0fb4a235289d = ({ children: children })=>{
    const [state, dispatch] = (0, $lCzvA.useReducer)($78b54bd991d76db4$var$$377ebf84863e9293$export$32a09064dc2bfed6, $78b54bd991d76db4$var$$377ebf84863e9293$export$dbd874037937496d);
    const { cameras: cameras } = state;
    /**
   * Fetches the available cameras.
   * Sets the selected camera to back camera if available, otherwise the first camera found.
   */ const getCameras = (0, $lCzvA.useCallback)(async ()=>{
        if (cameras.length) return;
        // get available cameras and set the initial camera
        const devices = await $78b54bd991d76db4$var$$953deebe48519221$export$f2c4ef2d1f0c2e1d();
        const initialCamera = $78b54bd991d76db4$var$$953deebe48519221$export$b2229c0522132a74(devices);
        dispatch({
            type: $78b54bd991d76db4$var$$7aede9e186d82185$export$89dec1050c5f188a,
            payload: devices
        });
        dispatch({
            type: $78b54bd991d76db4$var$$7aede9e186d82185$export$6910e11b01a25b49,
            payload: initialCamera
        });
    }, [
        dispatch,
        cameras.length
    ]);
    /**
   * Exposes the startCamera function to the user.
   */ const startCamera = (0, $lCzvA.useCallback)(/**
     * Starts the camera with combined actions.
     * @type {import('../../types').StartCamera}
     */ (onUserScan, onUserClose)=>{
        /**
       * Combines the user's scan with the internal actions
       * @type {import('../../types').OnScan}
       */ const onScan = (result)=>{
            onUserScan(result);
            dispatch({
                type: $78b54bd991d76db4$var$$7aede9e186d82185$export$e8cea1d59b0c9f14,
                payload: false
            });
        };
        /**
       * Combines the user's close with the internal actions
       */ const onClose = ()=>{
            if (onUserClose) onUserClose();
            dispatch({
                type: $78b54bd991d76db4$var$$7aede9e186d82185$export$e8cea1d59b0c9f14,
                payload: false
            });
        };
        // Trigger camera fetching logic
        getCameras();
        dispatch({
            type: $78b54bd991d76db4$var$$7aede9e186d82185$export$6a5e58c31158ca8,
            payload: {
                onScan: onScan,
                onClose: onClose
            }
        });
    }, [
        dispatch,
        getCameras
    ]);
    // ExternalValues are the ones that are exposed to the user
    // InternalValues are the ones that are strictly to be used internally
    const externalValue = (0, $lCzvA.useMemo)(()=>({
            startCamera: startCamera
        }), [
        startCamera
    ]);
    const internalValue = (0, $lCzvA.useMemo)(()=>({
            state: state,
            dispatch: dispatch
        }), [
        state,
        dispatch
    ]);
    return (0, $1e1ba35c5b9fc4c3$exports.jsxs)($78b54bd991d76db4$var$$8f4a7e327cfc31fa$export$9dc4ea39af0daa49.Provider, {
        value: externalValue,
        children: [
            children,
            (0, $1e1ba35c5b9fc4c3$exports.jsx)($78b54bd991d76db4$var$$97a6ca42802421f7$export$d056f9c7816498b6.Provider, {
                value: internalValue,
                children: (0, $1e1ba35c5b9fc4c3$exports.jsx)($78b54bd991d76db4$var$$5d243954a669ce26$export$d74867e90f5dd357, {})
            })
        ]
    });
};








var $lCzvA = parcelRequire("lCzvA");

"use client";
//#region src/components/Incrementer/index.jsx
var $4429e0f0655b49a3$export$2e2bcd8739ae039 = (0, $lCzvA.forwardRef)(function({ onChange: r, value: a, minValue: o = 0, maxValue: s, className: c, labelText: l, helpText: u, tooltipContent: d, tooltipPosition: f = "bottom", assistiveText: p, error: m, id: h, increaseIcon: g = "add_circle_outline", decreaseIcon: _ = "remove_circle_outline", containerClass: v, ...y }, b) {
    let x = {
        ...y
    }, S = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-IncrementerWrapper relative h-full": !0,
        [v]: v
    }), C = (0, $feeb2945a0885102$export$ce4ab0c55987d1ff)({
        "sash-Incrementer sash-input text-center [&~span]:px-0": !0,
        "border-red-700": m,
        [c]: c
    }), w = /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("button", {
        type: "button",
        "aria-label": "decrease quantity",
        onClick: ()=>r(a - 1),
        disabled: a <= o || x?.disabled,
        className: "aspect-square h-full cursor-pointer hover:text-neutral-700 disabled:pointer-events-none disabled:text-neutral-600 disabled:opacity-50",
        children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
            name: _,
            className: "mx-auto"
        })
    }), T = /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("button", {
        type: "button",
        "aria-label": "increase quantity",
        onClick: ()=>r(a + 1),
        className: "aspect-square h-full cursor-pointer hover:text-neutral-700 disabled:pointer-events-none disabled:text-neutral-600 disabled:opacity-50",
        disabled: a >= s || x?.disabled,
        children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
            name: g,
            className: "mx-auto"
        })
    });
    return /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
        className: S,
        "data-testid": "sash-incrementer",
        children: /* @__PURE__ */ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $67004894d25c93a4$export$2e2bcd8739ae039), {
            id: h,
            labelText: l,
            required: x.required,
            error: m,
            assistiveText: p,
            helpText: u,
            tooltipContent: d,
            tooltipPosition: f,
            onChange: (e)=>r(e.target.value ? Number.parseInt(e.target.value, 10) : 0),
            onBlur: (e)=>{
                let t = e.target.value ? Number.parseInt(e.target.value, 10) : 0;
                s && t > s && r(s), o && t < o && r(o);
            },
            value: a,
            iconLeft: w,
            iconRight: T,
            className: C,
            inputMode: "numeric",
            ref: b,
            ...y
        })
    });
});




var $36e5dc1bed761433$export$2ba01fb71ed41cb6;
var $36e5dc1bed761433$export$70b61ad426ddbe54;
var $36e5dc1bed761433$export$36cc835d2490c0fc;
var $36e5dc1bed761433$export$758a914e573c0865;
var $36e5dc1bed761433$export$ccfa5545cfa77c95;
var $36e5dc1bed761433$export$fb76f2cfde1b2ba0;
var $36e5dc1bed761433$export$adb608be33961c98;
var $36e5dc1bed761433$export$38e42c68cf43b5d4;
var $36e5dc1bed761433$export$98114f4fe3d0e9d;
var $36e5dc1bed761433$export$37dabcef0d69f66c;
var $36e5dc1bed761433$export$96e4b36520c26a2c;
var $36e5dc1bed761433$export$34fc1bdfdb97780a;
var $36e5dc1bed761433$export$98dd50b038c51278;
$36e5dc1bed761433$export$2ba01fb71ed41cb6 = `tHvflq_button`;
$36e5dc1bed761433$export$70b61ad426ddbe54 = `tHvflq_cancel`;
$36e5dc1bed761433$export$36cc835d2490c0fc = `tHvflq_charCount`;
$36e5dc1bed761433$export$758a914e573c0865 = `tHvflq_commentWrapper`;
$36e5dc1bed761433$export$ccfa5545cfa77c95 = `tHvflq_dynamicInput`;
$36e5dc1bed761433$export$fb76f2cfde1b2ba0 = `tHvflq_fieldWithScan`;
$36e5dc1bed761433$export$adb608be33961c98 = `tHvflq_footer`;
$36e5dc1bed761433$export$38e42c68cf43b5d4 = `tHvflq_header`;
$36e5dc1bed761433$export$98114f4fe3d0e9d = `tHvflq_listError`;
$36e5dc1bed761433$export$37dabcef0d69f66c = `tHvflq_listMessage`;
$36e5dc1bed761433$export$96e4b36520c26a2c = `tHvflq_modal`;
$36e5dc1bed761433$export$34fc1bdfdb97780a = `tHvflq_scanButton`;
$36e5dc1bed761433$export$98dd50b038c51278 = `tHvflq_selectionList`;


const $0c73e720f7589254$var$MIN_QUANTITY = 1;
const $0c73e720f7589254$var$MAX_COMMENT_LENGTH = 100;
const $0c73e720f7589254$export$6727f58776bb6617 = ({ open: open, close: close, action: action })=>{
    const { id: id, description: description, message: message, showQuantity: showQuantity, showComment: showComment, showSelectionList: showSelectionList, selectionListId1: selectionListId1, selectionListId2: selectionListId2, showDynamicInput: showDynamicInput, actionPrompt: actionPrompt, actionQuery: actionQuery } = action;
    const { mutate: createRequest, isPending: isPending } = (0, $25ab3bdc0bc8a5f6$export$d7d497d671a71166)();
    const { data: allSelectionLists, isPending: isListsPending, error: listsError } = (0, $66aaaebf25667a49$export$5d27c0f97561cc97)();
    const { duplicateRequests: duplicateRequests, submitWithCheck: submitWithCheck, onCancel: onDuplicateCancel, onProceed: onDuplicateProceed, isChecking: isChecking } = (0, $e35bb462eab19ecf$export$811f96a41c724592)(close);
    const { startCamera: startCamera } = (0, $78b54bd991d76db4$export$91d88843bfb219ae)();
    const barcodeRef = (0, $lCzvA.useRef)(null);
    const [formQuantity, setFormQuantity] = (0, $lCzvA.useState)($0c73e720f7589254$var$MIN_QUANTITY);
    const [formComment, setFormComment] = (0, $lCzvA.useState)('');
    const [dynamicInputValue, setDynamicInputValue] = (0, $lCzvA.useState)('');
    const [formDynamicInput, setFormDynamicInput] = (0, $lCzvA.useState)('');
    const [showBarcode, setShowBarcode] = (0, $lCzvA.useState)(false);
    const dynamicInputTimerRef = (0, $lCzvA.useRef)(/** @type {ReturnType<typeof setTimeout> | null} */ null);
    const [selectedListValueId1, setSelectedListValueId1] = (0, $lCzvA.useState)(/** @type {string} */ '');
    const [selectedListValueId2, setSelectedListValueId2] = (0, $lCzvA.useState)(/** @type {string} */ '');
    const { data: dynamicInputResult, isPending: isActionQueryPending, error: actionQueryError } = (0, $ed9a8e47842fcce7$export$11d67fb595afb0ff)({
        id: actionQuery
    }, formDynamicInput);
    // cleanup ref on unmount
    (0, $lCzvA.useEffect)(()=>()=>{
            if (dynamicInputTimerRef.current) clearTimeout(dynamicInputTimerRef.current);
        }, []);
    // Derived state for selection lists
    /** @type {Local.SelectionListWithValues | null | undefined} */ const selectionList1 = showSelectionList && selectionListId1 ? allSelectionLists?.find((l)=>l.id === selectionListId1) : null;
    /** @type {Local.SelectionListWithValues | null | undefined} */ const selectionList2 = showSelectionList && selectionListId2 ? allSelectionLists?.find((l)=>l.id === selectionListId2) : null;
    const selectionList1Values = selectionList1?.values || [];
    const selectionList2Values = selectionList2?.values || [];
    // Track if lists are ready: data loaded and all specified IDs found
    const listsLoaded = (allSelectionLists?.length ?? 0) > 0;
    const listsReady = listsLoaded && (!selectionListId1 || selectionList1) && (!selectionListId2 || selectionList2);
    // Track if a specified list ID wasn't found in the data
    const listNotFoundError = listsLoaded && !listsReady;
    /**
   * Build input object for mutation
   * @returns {Pella.ProductionRequestAPI.CreateRequestInput}
   */ const buildInput = ()=>{
        /** @type {Pella.ProductionRequestAPI.CreateRequestInput} */ const input = {
            actionId: id
        };
        if (showQuantity && formQuantity) input.requestQty = formQuantity;
        if (showComment && formComment) input.comment = formComment;
        if (showSelectionList && selectedListValueId1) input.dropDownListVal1 = selectedListValueId1;
        if (showSelectionList && selectedListValueId2) input.dropDownListVal2 = selectedListValueId2;
        if (showDynamicInput && formDynamicInput) input.dynamicInput = formDynamicInput;
        if (showDynamicInput && dynamicInputValue) input.dynamicInput = dynamicInputValue;
        if (showDynamicInput && dynamicInputResult) input.dynamicInputResult = /** @type {unknown} */ dynamicInputResult;
        return input;
    };
    /** Handle submit click, warning about open duplicate requests before calling the mutation */ const onSubmitClick = ()=>submitWithCheck(buildInput(), (input)=>createRequest(input, {
                onSuccess: ()=>close()
            }));
    /**
   * Handle quantity change
   * Ensuring minimum is enforced as the Sash component is not properly doing so
   * @param {number} value
   */ const onQuantityChange = (value)=>setFormQuantity(Math.max($0c73e720f7589254$var$MIN_QUANTITY, value));
    /**
   * Handle comment change
   * @param {import('react').ChangeEvent<HTMLTextAreaElement>} event
   */ const onCommentChange = ({ target: { value: value } })=>setFormComment(value);
    /**
   * Handle dynamic input change
   * Updates display value immediately; debounces the query-driving state by 500ms
   * @param {import('react').ChangeEvent<HTMLTextAreaElement>} event
   */ const onDynamicInputChange = ({ target: { value: value } })=>{
        setDynamicInputValue(value);
        if (dynamicInputTimerRef.current) clearTimeout(dynamicInputTimerRef.current);
        dynamicInputTimerRef.current = setTimeout(()=>setFormDynamicInput(value), 500);
    };
    /** Scan a barcode into the dynamic input field. Rejects text exceeding the max length. */ const handleScanDynamicInput = ()=>{
        startCamera((result)=>{
            if (result.length > $0c73e720f7589254$var$MAX_COMMENT_LENGTH) {
                (0, $673b1c81cc441170$export$2e2bcd8739ae039).error(`Scanned text exceeds the ${$0c73e720f7589254$var$MAX_COMMENT_LENGTH}-character limit.`);
                return;
            }
            setDynamicInputValue(result);
            setFormDynamicInput(result);
        }, ()=>{
        // Camera dismissed — no action needed, user returns to the modal with the field untouched
        });
    };
    /** Scan a barcode into the quantity field. Requires a canonical integer >= MIN_QUANTITY. */ const handleScanQuantity = ()=>{
        startCamera((result)=>{
            const trimmed = result.trim();
            const parsed = Number(trimmed);
            const isValidQuantity = Number.isInteger(parsed) && parsed >= $0c73e720f7589254$var$MIN_QUANTITY && String(parsed) === trimmed;
            if (!isValidQuantity) {
                (0, $673b1c81cc441170$export$2e2bcd8739ae039).error('The scanned barcode does not contain a valid quantity.');
                return;
            }
            setFormQuantity(parsed);
        }, ()=>{
        // Camera dismissed — no action needed, user returns to the modal with the field untouched
        });
    };
    /** Scan a barcode into the comment field. Rejects text exceeding the max length. */ const handleScanComment = ()=>{
        startCamera((result)=>{
            if (result.length > $0c73e720f7589254$var$MAX_COMMENT_LENGTH) {
                (0, $673b1c81cc441170$export$2e2bcd8739ae039).error(`Scanned text exceeds the ${$0c73e720f7589254$var$MAX_COMMENT_LENGTH}-character limit.`);
                return;
            }
            setFormComment(result);
        }, ()=>{
        // Camera dismissed — no action needed, user returns to the modal with the field untouched
        });
    };
    /**
   * Determine if submit button should be disabled
   * Selection lists and dynamic input are required if their respective flags are true
   */ const actionQueryFailed = showDynamicInput && Boolean(actionQueryError);
    const isSubmitDisabled = isPending || isChecking || Boolean(showSelectionList && (isListsPending || Boolean(listsError) || listNotFoundError || !listsReady || !selectedListValueId1 || selectionListId2 && !selectedListValueId2) || showDynamicInput && !formDynamicInput || showDynamicInput && (isActionQueryPending || actionQueryFailed || !dynamicInputValue));
    const showModalContent = showQuantity || showComment || showSelectionList || showDynamicInput;
    /** Handle show barcode toggle */ const handleShowBarcode = ()=>setShowBarcode((prev)=>!prev);
    /** Handle download of barcode as image */ const handleDownload = async ()=>{
        await (0, $5f8e1c8d350f317e$export$c8b8645ec971eaf)(barcodeRef);
        setShowBarcode(false);
    };
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $1e1ba35c5b9fc4c3$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $4d41d17efc15da0f$export$2e2bcd8739ae039), {
                open: open,
                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $9dad852e7e98f87b$export$2e2bcd8739ae039), {
                    effect: "scale-up",
                    showClose: false,
                    fullScreen: (0, $ec4affac0c13709c$exports.isMobile),
                    className: $36e5dc1bed761433$export$96e4b36520c26a2c,
                    children: [
                        !showBarcode && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $9761f0447406a76c$export$2e2bcd8739ae039), {
                            className: $36e5dc1bed761433$export$38e42c68cf43b5d4,
                            children: [
                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                                    children: description
                                }),
                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                                    children: message
                                })
                            ]
                        }),
                        showModalContent && !showBarcode && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $21eb14e493d0e28b$export$2e2bcd8739ae039), {
                            children: [
                                showDynamicInput && !actionPrompt && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                                    className: $36e5dc1bed761433$export$98114f4fe3d0e9d,
                                    children: 'Error: Dynamic input action is missing required "Action Prompt" label. Please contact support.'
                                }),
                                showDynamicInput && actionQueryError && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                                    className: $36e5dc1bed761433$export$98114f4fe3d0e9d,
                                    children: typeof actionQueryError === 'string' ? actionQueryError : actionQueryError?.message || String(actionQueryError)
                                }),
                                showDynamicInput && actionPrompt && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                    className: $36e5dc1bed761433$export$fb76f2cfde1b2ba0,
                                    children: [
                                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                            className: $36e5dc1bed761433$export$ccfa5545cfa77c95,
                                            children: [
                                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                                    className: $36e5dc1bed761433$export$36cc835d2490c0fc,
                                                    children: [
                                                        dynamicInputValue.length,
                                                        " / ",
                                                        $0c73e720f7589254$var$MAX_COMMENT_LENGTH
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $27cc10959d191d67$export$2e2bcd8739ae039), {
                                                    id: "request-modal-dynamic-input",
                                                    labelText: actionPrompt,
                                                    rows: 1,
                                                    value: dynamicInputValue,
                                                    maxLength: $0c73e720f7589254$var$MAX_COMMENT_LENGTH,
                                                    onChange: onDynamicInputChange
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("button", {
                                            type: "button",
                                            className: $36e5dc1bed761433$export$34fc1bdfdb97780a,
                                            "aria-label": "Scan barcode for input",
                                            "data-testid": "dynamic-input-scan-button",
                                            onClick: handleScanDynamicInput,
                                            children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                                                name: "qr_code_2_add"
                                            })
                                        })
                                    ]
                                }),
                                showQuantity && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                    className: $36e5dc1bed761433$export$fb76f2cfde1b2ba0,
                                    children: [
                                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $4429e0f0655b49a3$export$2e2bcd8739ae039), {
                                            id: "request-modal-incrementer",
                                            labelText: "Quantity",
                                            maxValue: Infinity,
                                            minValue: $0c73e720f7589254$var$MIN_QUANTITY,
                                            onChange: onQuantityChange,
                                            value: formQuantity
                                        }),
                                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("button", {
                                            type: "button",
                                            className: $36e5dc1bed761433$export$34fc1bdfdb97780a,
                                            "aria-label": "Scan barcode for quantity",
                                            "data-testid": "quantity-scan-button",
                                            onClick: handleScanQuantity,
                                            children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                                                name: "qr_code_2_add"
                                            })
                                        })
                                    ]
                                }),
                                showSelectionList && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $1e1ba35c5b9fc4c3$exports.Fragment), {
                                    children: [
                                        isListsPending && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                                            className: $36e5dc1bed761433$export$37dabcef0d69f66c,
                                            children: "Loading selection lists..."
                                        }),
                                        listsError && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                                            className: $36e5dc1bed761433$export$98114f4fe3d0e9d,
                                            children: "Error loading selection lists. Please try again."
                                        }),
                                        listNotFoundError && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                                            className: $36e5dc1bed761433$export$98114f4fe3d0e9d,
                                            children: "Selection list not found. Please contact support."
                                        }),
                                        selectionList1 && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $c7e1b2c0ded2c83a$export$2e2bcd8739ae039), {
                                            id: "selectionList1Select",
                                            labelText: selectionList1.description,
                                            value: selectedListValueId1,
                                            onChange: (e)=>setSelectedListValueId1(e.target.value),
                                            className: $36e5dc1bed761433$export$98dd50b038c51278,
                                            children: [
                                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                                    value: "",
                                                    children: "--- Select an Option ---"
                                                }),
                                                selectionList1Values.filter((value)=>Boolean(value?.id)).map((value)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                                        value: value.description,
                                                        children: value.description
                                                    }, value.id))
                                            ]
                                        }),
                                        selectionList2 && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $c7e1b2c0ded2c83a$export$2e2bcd8739ae039), {
                                            id: "selectionList2Select",
                                            labelText: selectionList2.description,
                                            value: selectedListValueId2,
                                            onChange: (e)=>setSelectedListValueId2(e.target.value),
                                            className: $36e5dc1bed761433$export$98dd50b038c51278,
                                            children: [
                                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                                    value: "",
                                                    children: "--- Select an Option ---"
                                                }),
                                                selectionList2Values.filter((value)=>Boolean(value?.id)).map((value)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                                        value: value.description,
                                                        children: value.description
                                                    }, value.id))
                                            ]
                                        })
                                    ]
                                }),
                                showComment && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                    className: $36e5dc1bed761433$export$fb76f2cfde1b2ba0,
                                    children: [
                                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                            className: $36e5dc1bed761433$export$758a914e573c0865,
                                            children: [
                                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                                    className: $36e5dc1bed761433$export$36cc835d2490c0fc,
                                                    children: [
                                                        formComment.length,
                                                        " / ",
                                                        $0c73e720f7589254$var$MAX_COMMENT_LENGTH
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $27cc10959d191d67$export$2e2bcd8739ae039), {
                                                    id: "request-modal-comment",
                                                    labelText: "Comment",
                                                    placeholder: "Add any comments here",
                                                    rows: 3,
                                                    value: formComment,
                                                    maxLength: $0c73e720f7589254$var$MAX_COMMENT_LENGTH,
                                                    onChange: onCommentChange
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("button", {
                                            type: "button",
                                            className: $36e5dc1bed761433$export$34fc1bdfdb97780a,
                                            "aria-label": "Scan barcode for comment",
                                            "data-testid": "comment-scan-button",
                                            onClick: handleScanComment,
                                            children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                                                name: "qr_code_2_add"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        showBarcode && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $21eb14e493d0e28b$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $ded92a7f3d67cfae$export$986fd1d71e406f4), {
                                input: buildInput(),
                                action: action,
                                ref: barcodeRef
                            })
                        }),
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $861af07899c9769a$export$2e2bcd8739ae039), {
                            className: $36e5dc1bed761433$export$adb608be33961c98,
                            children: [
                                !showBarcode && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                                    className: $36e5dc1bed761433$export$70b61ad426ddbe54,
                                    children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                                        color: "secondary",
                                        className: $36e5dc1bed761433$export$2ba01fb71ed41cb6,
                                        onClick: close,
                                        children: "Cancel"
                                    })
                                }),
                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                                    color: "secondary",
                                    className: $36e5dc1bed761433$export$2ba01fb71ed41cb6,
                                    onClick: handleShowBarcode,
                                    disabled: isSubmitDisabled,
                                    children: showBarcode ? 'Back to Request' : 'Generate Barcode'
                                }),
                                !showBarcode && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                                    color: "primary",
                                    className: $36e5dc1bed761433$export$2ba01fb71ed41cb6,
                                    onClick: onSubmitClick,
                                    disabled: isSubmitDisabled,
                                    children: "Submit Request"
                                }),
                                showBarcode && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                                    color: "primary",
                                    className: $36e5dc1bed761433$export$2ba01fb71ed41cb6,
                                    onClick: handleDownload,
                                    children: "Download"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $3d5a10291cd1b995$export$39006efc02100ca6), {
                isOpen: duplicateRequests.length > 0,
                requests: duplicateRequests,
                onCancel: onDuplicateCancel,
                onProceed: onDuplicateProceed
            })
        ]
    });
};






var $d2ac6f7a90164e12$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d2ac6f7a90164e12$var$ReactIs, $d2ac6f7a90164e12$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$d2ac6f7a90164e12$exports = (parcelRequire("1AISF"))();


//---------------------------------------------------------------------
//
// QR Code Generator for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//  http://www.opensource.org/licenses/mit-license.php
//
// The word 'QR Code' is registered trademark of
// DENSO WAVE INCORPORATED
//  http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
//---------------------------------------------------------------------
// qrcode
//---------------------------------------------------------------------
/**
 * qrcode
 * @param typeNumber 1 to 40
 * @param errorCorrectionLevel 'L','M','Q','H'
 */ const $7ad699d58ee46b15$export$5f3279733515fed0 = function(typeNumber, errorCorrectionLevel) {
    const PAD0 = 0xEC;
    const PAD1 = 0x11;
    let _typeNumber = typeNumber;
    const _errorCorrectionLevel = $7ad699d58ee46b15$var$QRErrorCorrectionLevel[errorCorrectionLevel];
    let _modules = null;
    let _moduleCount = 0;
    let _dataCache = null;
    const _dataList = [];
    const _this = {};
    const makeImpl = function(test, maskPattern) {
        _moduleCount = _typeNumber * 4 + 17;
        _modules = function(moduleCount) {
            const modules = new Array(moduleCount);
            for(let row = 0; row < moduleCount; row += 1){
                modules[row] = new Array(moduleCount);
                for(let col = 0; col < moduleCount; col += 1)modules[row][col] = null;
            }
            return modules;
        }(_moduleCount);
        setupPositionProbePattern(0, 0);
        setupPositionProbePattern(_moduleCount - 7, 0);
        setupPositionProbePattern(0, _moduleCount - 7);
        setupPositionAdjustPattern();
        setupTimingPattern();
        setupTypeInfo(test, maskPattern);
        if (_typeNumber >= 7) setupTypeNumber(test);
        if (_dataCache == null) _dataCache = createData(_typeNumber, _errorCorrectionLevel, _dataList);
        mapData(_dataCache, maskPattern);
    };
    const setupPositionProbePattern = function(row, col) {
        for(let r = -1; r <= 7; r += 1){
            if (row + r <= -1 || _moduleCount <= row + r) continue;
            for(let c = -1; c <= 7; c += 1){
                if (col + c <= -1 || _moduleCount <= col + c) continue;
                if (0 <= r && r <= 6 && (c == 0 || c == 6) || 0 <= c && c <= 6 && (r == 0 || r == 6) || 2 <= r && r <= 4 && 2 <= c && c <= 4) _modules[row + r][col + c] = true;
                else _modules[row + r][col + c] = false;
            }
        }
    };
    const getBestMaskPattern = function() {
        let minLostPoint = 0;
        let pattern = 0;
        for(let i = 0; i < 8; i += 1){
            makeImpl(true, i);
            const lostPoint = $7ad699d58ee46b15$var$QRUtil.getLostPoint(_this);
            if (i == 0 || minLostPoint > lostPoint) {
                minLostPoint = lostPoint;
                pattern = i;
            }
        }
        return pattern;
    };
    const setupTimingPattern = function() {
        for(let r = 8; r < _moduleCount - 8; r += 1){
            if (_modules[r][6] != null) continue;
            _modules[r][6] = r % 2 == 0;
        }
        for(let c = 8; c < _moduleCount - 8; c += 1){
            if (_modules[6][c] != null) continue;
            _modules[6][c] = c % 2 == 0;
        }
    };
    const setupPositionAdjustPattern = function() {
        const pos = $7ad699d58ee46b15$var$QRUtil.getPatternPosition(_typeNumber);
        for(let i = 0; i < pos.length; i += 1)for(let j = 0; j < pos.length; j += 1){
            const row = pos[i];
            const col = pos[j];
            if (_modules[row][col] != null) continue;
            for(let r = -2; r <= 2; r += 1){
                for(let c = -2; c <= 2; c += 1)if (r == -2 || r == 2 || c == -2 || c == 2 || r == 0 && c == 0) _modules[row + r][col + c] = true;
                else _modules[row + r][col + c] = false;
            }
        }
    };
    const setupTypeNumber = function(test) {
        const bits = $7ad699d58ee46b15$var$QRUtil.getBCHTypeNumber(_typeNumber);
        for(let i = 0; i < 18; i += 1){
            const mod = !test && (bits >> i & 1) == 1;
            _modules[Math.floor(i / 3)][i % 3 + _moduleCount - 8 - 3] = mod;
        }
        for(let i = 0; i < 18; i += 1){
            const mod = !test && (bits >> i & 1) == 1;
            _modules[i % 3 + _moduleCount - 8 - 3][Math.floor(i / 3)] = mod;
        }
    };
    const setupTypeInfo = function(test, maskPattern) {
        const data = _errorCorrectionLevel << 3 | maskPattern;
        const bits = $7ad699d58ee46b15$var$QRUtil.getBCHTypeInfo(data);
        // vertical
        for(let i = 0; i < 15; i += 1){
            const mod = !test && (bits >> i & 1) == 1;
            if (i < 6) _modules[i][8] = mod;
            else if (i < 8) _modules[i + 1][8] = mod;
            else _modules[_moduleCount - 15 + i][8] = mod;
        }
        // horizontal
        for(let i = 0; i < 15; i += 1){
            const mod = !test && (bits >> i & 1) == 1;
            if (i < 8) _modules[8][_moduleCount - i - 1] = mod;
            else if (i < 9) _modules[8][15 - i - 1 + 1] = mod;
            else _modules[8][15 - i - 1] = mod;
        }
        // fixed module
        _modules[_moduleCount - 8][8] = !test;
    };
    const mapData = function(data, maskPattern) {
        let inc = -1;
        let row = _moduleCount - 1;
        let bitIndex = 7;
        let byteIndex = 0;
        const maskFunc = $7ad699d58ee46b15$var$QRUtil.getMaskFunction(maskPattern);
        for(let col = _moduleCount - 1; col > 0; col -= 2){
            if (col == 6) col -= 1;
            while(true){
                for(let c = 0; c < 2; c += 1)if (_modules[row][col - c] == null) {
                    let dark = false;
                    if (byteIndex < data.length) dark = (data[byteIndex] >>> bitIndex & 1) == 1;
                    const mask = maskFunc(row, col - c);
                    if (mask) dark = !dark;
                    _modules[row][col - c] = dark;
                    bitIndex -= 1;
                    if (bitIndex == -1) {
                        byteIndex += 1;
                        bitIndex = 7;
                    }
                }
                row += inc;
                if (row < 0 || _moduleCount <= row) {
                    row -= inc;
                    inc = -inc;
                    break;
                }
            }
        }
    };
    const createBytes = function(buffer, rsBlocks) {
        let offset = 0;
        let maxDcCount = 0;
        let maxEcCount = 0;
        const dcdata = new Array(rsBlocks.length);
        const ecdata = new Array(rsBlocks.length);
        for(let r = 0; r < rsBlocks.length; r += 1){
            const dcCount = rsBlocks[r].dataCount;
            const ecCount = rsBlocks[r].totalCount - dcCount;
            maxDcCount = Math.max(maxDcCount, dcCount);
            maxEcCount = Math.max(maxEcCount, ecCount);
            dcdata[r] = new Array(dcCount);
            for(let i = 0; i < dcdata[r].length; i += 1)dcdata[r][i] = 0xff & buffer.getBuffer()[i + offset];
            offset += dcCount;
            const rsPoly = $7ad699d58ee46b15$var$QRUtil.getErrorCorrectPolynomial(ecCount);
            const rawPoly = $7ad699d58ee46b15$var$qrPolynomial(dcdata[r], rsPoly.getLength() - 1);
            const modPoly = rawPoly.mod(rsPoly);
            ecdata[r] = new Array(rsPoly.getLength() - 1);
            for(let i = 0; i < ecdata[r].length; i += 1){
                const modIndex = i + modPoly.getLength() - ecdata[r].length;
                ecdata[r][i] = modIndex >= 0 ? modPoly.getAt(modIndex) : 0;
            }
        }
        let totalCodeCount = 0;
        for(let i = 0; i < rsBlocks.length; i += 1)totalCodeCount += rsBlocks[i].totalCount;
        const data = new Array(totalCodeCount);
        let index = 0;
        for(let i = 0; i < maxDcCount; i += 1){
            for(let r = 0; r < rsBlocks.length; r += 1)if (i < dcdata[r].length) {
                data[index] = dcdata[r][i];
                index += 1;
            }
        }
        for(let i = 0; i < maxEcCount; i += 1){
            for(let r = 0; r < rsBlocks.length; r += 1)if (i < ecdata[r].length) {
                data[index] = ecdata[r][i];
                index += 1;
            }
        }
        return data;
    };
    const createData = function(typeNumber, errorCorrectionLevel, dataList) {
        const rsBlocks = $7ad699d58ee46b15$var$QRRSBlock.getRSBlocks(typeNumber, errorCorrectionLevel);
        const buffer = $7ad699d58ee46b15$var$qrBitBuffer();
        for(let i = 0; i < dataList.length; i += 1){
            const data = dataList[i];
            buffer.put(data.getMode(), 4);
            buffer.put(data.getLength(), $7ad699d58ee46b15$var$QRUtil.getLengthInBits(data.getMode(), typeNumber));
            data.write(buffer);
        }
        // calc num max data.
        let totalDataCount = 0;
        for(let i = 0; i < rsBlocks.length; i += 1)totalDataCount += rsBlocks[i].dataCount;
        if (buffer.getLengthInBits() > totalDataCount * 8) throw 'code length overflow. (' + buffer.getLengthInBits() + '>' + totalDataCount * 8 + ')';
        // end code
        if (buffer.getLengthInBits() + 4 <= totalDataCount * 8) buffer.put(0, 4);
        // padding
        while(buffer.getLengthInBits() % 8 != 0)buffer.putBit(false);
        // padding
        while(true){
            if (buffer.getLengthInBits() >= totalDataCount * 8) break;
            buffer.put(PAD0, 8);
            if (buffer.getLengthInBits() >= totalDataCount * 8) break;
            buffer.put(PAD1, 8);
        }
        return createBytes(buffer, rsBlocks);
    };
    _this.addData = function(data, mode) {
        mode = mode || 'Byte';
        let newData = null;
        switch(mode){
            case 'Numeric':
                newData = $7ad699d58ee46b15$var$qrNumber(data);
                break;
            case 'Alphanumeric':
                newData = $7ad699d58ee46b15$var$qrAlphaNum(data);
                break;
            case 'Byte':
                newData = $7ad699d58ee46b15$var$qr8BitByte(data);
                break;
            case 'Kanji':
                newData = $7ad699d58ee46b15$var$qrKanji(data);
                break;
            default:
                throw 'mode:' + mode;
        }
        _dataList.push(newData);
        _dataCache = null;
    };
    _this.isDark = function(row, col) {
        if (row < 0 || _moduleCount <= row || col < 0 || _moduleCount <= col) throw row + ',' + col;
        return _modules[row][col];
    };
    _this.getModuleCount = function() {
        return _moduleCount;
    };
    _this.make = function() {
        if (_typeNumber < 1) {
            let typeNumber = 1;
            for(; typeNumber < 40; typeNumber++){
                const rsBlocks = $7ad699d58ee46b15$var$QRRSBlock.getRSBlocks(typeNumber, _errorCorrectionLevel);
                const buffer = $7ad699d58ee46b15$var$qrBitBuffer();
                for(let i = 0; i < _dataList.length; i++){
                    const data = _dataList[i];
                    buffer.put(data.getMode(), 4);
                    buffer.put(data.getLength(), $7ad699d58ee46b15$var$QRUtil.getLengthInBits(data.getMode(), typeNumber));
                    data.write(buffer);
                }
                let totalDataCount = 0;
                for(let i = 0; i < rsBlocks.length; i++)totalDataCount += rsBlocks[i].dataCount;
                if (buffer.getLengthInBits() <= totalDataCount * 8) break;
            }
            _typeNumber = typeNumber;
        }
        makeImpl(false, getBestMaskPattern());
    };
    _this.createTableTag = function(cellSize, margin) {
        cellSize = cellSize || 2;
        margin = typeof margin == 'undefined' ? cellSize * 4 : margin;
        let qrHtml = '';
        qrHtml += '<table style="';
        qrHtml += ' border-width: 0px; border-style: none;';
        qrHtml += ' border-collapse: collapse;';
        qrHtml += ' padding: 0px; margin: ' + margin + 'px;';
        qrHtml += '">';
        qrHtml += '<tbody>';
        for(let r = 0; r < _this.getModuleCount(); r += 1){
            qrHtml += '<tr>';
            for(let c = 0; c < _this.getModuleCount(); c += 1){
                qrHtml += '<td style="';
                qrHtml += ' border-width: 0px; border-style: none;';
                qrHtml += ' border-collapse: collapse;';
                qrHtml += ' padding: 0px; margin: 0px;';
                qrHtml += ' width: ' + cellSize + 'px;';
                qrHtml += ' height: ' + cellSize + 'px;';
                qrHtml += ' background-color: ';
                qrHtml += _this.isDark(r, c) ? '#000000' : '#ffffff';
                qrHtml += ';';
                qrHtml += '"/>';
            }
            qrHtml += '</tr>';
        }
        qrHtml += '</tbody>';
        qrHtml += '</table>';
        return qrHtml;
    };
    _this.createSvgTag = function(cellSize, margin, alt, title) {
        let opts = {};
        if (typeof arguments[0] == 'object') {
            // Called by options.
            opts = arguments[0];
            // overwrite cellSize and margin.
            cellSize = opts.cellSize;
            margin = opts.margin;
            alt = opts.alt;
            title = opts.title;
        }
        cellSize = cellSize || 2;
        margin = typeof margin == 'undefined' ? cellSize * 4 : margin;
        // Compose alt property surrogate
        alt = typeof alt === 'string' ? {
            text: alt
        } : alt || {};
        alt.text = alt.text || null;
        alt.id = alt.text ? alt.id || 'qrcode-description' : null;
        // Compose title property surrogate
        title = typeof title === 'string' ? {
            text: title
        } : title || {};
        title.text = title.text || null;
        title.id = title.text ? title.id || 'qrcode-title' : null;
        const size = _this.getModuleCount() * cellSize + margin * 2;
        let c, mc, r, mr, qrSvg = '', rect;
        rect = 'l' + cellSize + ',0 0,' + cellSize + ' -' + cellSize + ',0 0,-' + cellSize + 'z ';
        qrSvg += '<svg version="1.1" xmlns="http://www.w3.org/2000/svg"';
        qrSvg += !opts.scalable ? ' width="' + size + 'px" height="' + size + 'px"' : '';
        qrSvg += ' viewBox="0 0 ' + size + ' ' + size + '" ';
        qrSvg += ' preserveAspectRatio="xMinYMin meet"';
        qrSvg += title.text || alt.text ? ' role="img" aria-labelledby="' + escapeXml([
            title.id,
            alt.id
        ].join(' ').trim()) + '"' : '';
        qrSvg += '>';
        qrSvg += title.text ? '<title id="' + escapeXml(title.id) + '">' + escapeXml(title.text) + '</title>' : '';
        qrSvg += alt.text ? '<description id="' + escapeXml(alt.id) + '">' + escapeXml(alt.text) + '</description>' : '';
        qrSvg += '<rect width="100%" height="100%" fill="white" cx="0" cy="0"/>';
        qrSvg += '<path d="';
        for(r = 0; r < _this.getModuleCount(); r += 1){
            mr = r * cellSize + margin;
            for(c = 0; c < _this.getModuleCount(); c += 1)if (_this.isDark(r, c)) {
                mc = c * cellSize + margin;
                qrSvg += 'M' + mc + ',' + mr + rect;
            }
        }
        qrSvg += '" stroke="transparent" fill="black"/>';
        qrSvg += '</svg>';
        return qrSvg;
    };
    _this.createDataURL = function(cellSize, margin) {
        cellSize = cellSize || 2;
        margin = typeof margin == 'undefined' ? cellSize * 4 : margin;
        const size = _this.getModuleCount() * cellSize + margin * 2;
        const min = margin;
        const max = size - margin;
        return $7ad699d58ee46b15$var$createDataURL(size, size, function(x, y) {
            if (min <= x && x < max && min <= y && y < max) {
                const c = Math.floor((x - min) / cellSize);
                const r = Math.floor((y - min) / cellSize);
                return _this.isDark(r, c) ? 0 : 1;
            } else return 1;
        });
    };
    _this.createImgTag = function(cellSize, margin, alt) {
        cellSize = cellSize || 2;
        margin = typeof margin == 'undefined' ? cellSize * 4 : margin;
        const size = _this.getModuleCount() * cellSize + margin * 2;
        let img = '';
        img += '<img';
        img += '\u0020src="';
        img += _this.createDataURL(cellSize, margin);
        img += '"';
        img += '\u0020width="';
        img += size;
        img += '"';
        img += '\u0020height="';
        img += size;
        img += '"';
        if (alt) {
            img += '\u0020alt="';
            img += escapeXml(alt);
            img += '"';
        }
        img += '/>';
        return img;
    };
    const escapeXml = function(s) {
        let escaped = '';
        for(let i = 0; i < s.length; i += 1){
            const c = s.charAt(i);
            switch(c){
                case '<':
                    escaped += '&lt;';
                    break;
                case '>':
                    escaped += '&gt;';
                    break;
                case '&':
                    escaped += '&amp;';
                    break;
                case '"':
                    escaped += '&quot;';
                    break;
                default:
                    escaped += c;
                    break;
            }
        }
        return escaped;
    };
    const _createHalfASCII = function(margin) {
        const cellSize = 1;
        margin = typeof margin == 'undefined' ? cellSize * 2 : margin;
        const size = _this.getModuleCount() * cellSize + margin * 2;
        const min = margin;
        const max = size - margin;
        let y, x, r1, r2, p;
        const blocks = {
            "\u2588\u2588": "\u2588",
            "\u2588 ": "\u2580",
            " \u2588": "\u2584",
            '  ': ' '
        };
        const blocksLastLineNoMargin = {
            "\u2588\u2588": "\u2580",
            "\u2588 ": "\u2580",
            " \u2588": ' ',
            '  ': ' '
        };
        let ascii = '';
        for(y = 0; y < size; y += 2){
            r1 = Math.floor((y - min) / cellSize);
            r2 = Math.floor((y + 1 - min) / cellSize);
            for(x = 0; x < size; x += 1){
                p = "\u2588";
                if (min <= x && x < max && min <= y && y < max && _this.isDark(r1, Math.floor((x - min) / cellSize))) p = ' ';
                if (min <= x && x < max && min <= y + 1 && y + 1 < max && _this.isDark(r2, Math.floor((x - min) / cellSize))) p += ' ';
                else p += "\u2588";
                // Output 2 characters per pixel, to create full square. 1 character per pixels gives only half width of square.
                ascii += margin < 1 && y + 1 >= max ? blocksLastLineNoMargin[p] : blocks[p];
            }
            ascii += '\n';
        }
        if (size % 2 && margin > 0) return ascii.substring(0, ascii.length - size - 1) + Array(size + 1).join("\u2580");
        return ascii.substring(0, ascii.length - 1);
    };
    _this.createASCII = function(cellSize, margin) {
        cellSize = cellSize || 1;
        if (cellSize < 2) return _createHalfASCII(margin);
        cellSize -= 1;
        margin = typeof margin == 'undefined' ? cellSize * 2 : margin;
        const size = _this.getModuleCount() * cellSize + margin * 2;
        const min = margin;
        const max = size - margin;
        let y, x, r, p;
        const white = Array(cellSize + 1).join("\u2588\u2588");
        const black = Array(cellSize + 1).join('  ');
        let ascii = '';
        let line = '';
        for(y = 0; y < size; y += 1){
            r = Math.floor((y - min) / cellSize);
            line = '';
            for(x = 0; x < size; x += 1){
                p = 1;
                if (min <= x && x < max && min <= y && y < max && _this.isDark(r, Math.floor((x - min) / cellSize))) p = 0;
                // Output 2 characters per pixel, to create full square. 1 character per pixels gives only half width of square.
                line += p ? white : black;
            }
            for(r = 0; r < cellSize; r += 1)ascii += line + '\n';
        }
        return ascii.substring(0, ascii.length - 1);
    };
    _this.renderTo2dContext = function(context, cellSize) {
        cellSize = cellSize || 2;
        const length = _this.getModuleCount();
        for(let row = 0; row < length; row++)for(let col = 0; col < length; col++){
            context.fillStyle = _this.isDark(row, col) ? 'black' : 'white';
            context.fillRect(col * cellSize, row * cellSize, cellSize, cellSize);
        }
    };
    return _this;
};
//---------------------------------------------------------------------
// qrcode.stringToBytes
//---------------------------------------------------------------------
$7ad699d58ee46b15$export$5f3279733515fed0.stringToBytes = function(s) {
    const bytes = [];
    for(let i = 0; i < s.length; i += 1){
        const c = s.charCodeAt(i);
        bytes.push(c & 0xff);
    }
    return bytes;
};
//---------------------------------------------------------------------
// qrcode.createStringToBytes
//---------------------------------------------------------------------
/**
 * @param unicodeData base64 string of byte array.
 * [16bit Unicode],[16bit Bytes], ...
 * @param numChars
 */ $7ad699d58ee46b15$export$5f3279733515fed0.createStringToBytes = function(unicodeData, numChars) {
    // create conversion map.
    const unicodeMap = function() {
        const bin = $7ad699d58ee46b15$var$base64DecodeInputStream(unicodeData);
        const read = function() {
            const b = bin.read();
            if (b == -1) throw 'eof';
            return b;
        };
        let count = 0;
        const unicodeMap = {};
        while(true){
            const b0 = bin.read();
            if (b0 == -1) break;
            const b1 = read();
            const b2 = read();
            const b3 = read();
            const k = String.fromCharCode(b0 << 8 | b1);
            const v = b2 << 8 | b3;
            unicodeMap[k] = v;
            count += 1;
        }
        if (count != numChars) throw count + ' != ' + numChars;
        return unicodeMap;
    }();
    const unknownChar = '?'.charCodeAt(0);
    return function(s) {
        const bytes = [];
        for(let i = 0; i < s.length; i += 1){
            const c = s.charCodeAt(i);
            if (c < 128) bytes.push(c);
            else {
                const b = unicodeMap[s.charAt(i)];
                if (typeof b == 'number') {
                    if ((b & 0xff) == b) // 1byte
                    bytes.push(b);
                    else {
                        // 2bytes
                        bytes.push(b >>> 8);
                        bytes.push(b & 0xff);
                    }
                } else bytes.push(unknownChar);
            }
        }
        return bytes;
    };
};
//---------------------------------------------------------------------
// QRMode
//---------------------------------------------------------------------
const $7ad699d58ee46b15$var$QRMode = {
    MODE_NUMBER: 1,
    MODE_ALPHA_NUM: 2,
    MODE_8BIT_BYTE: 4,
    MODE_KANJI: 8
};
//---------------------------------------------------------------------
// QRErrorCorrectionLevel
//---------------------------------------------------------------------
const $7ad699d58ee46b15$var$QRErrorCorrectionLevel = {
    L: 1,
    M: 0,
    Q: 3,
    H: 2
};
//---------------------------------------------------------------------
// QRMaskPattern
//---------------------------------------------------------------------
const $7ad699d58ee46b15$var$QRMaskPattern = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
};
//---------------------------------------------------------------------
// QRUtil
//---------------------------------------------------------------------
const $7ad699d58ee46b15$var$QRUtil = function() {
    const PATTERN_POSITION_TABLE = [
        [],
        [
            6,
            18
        ],
        [
            6,
            22
        ],
        [
            6,
            26
        ],
        [
            6,
            30
        ],
        [
            6,
            34
        ],
        [
            6,
            22,
            38
        ],
        [
            6,
            24,
            42
        ],
        [
            6,
            26,
            46
        ],
        [
            6,
            28,
            50
        ],
        [
            6,
            30,
            54
        ],
        [
            6,
            32,
            58
        ],
        [
            6,
            34,
            62
        ],
        [
            6,
            26,
            46,
            66
        ],
        [
            6,
            26,
            48,
            70
        ],
        [
            6,
            26,
            50,
            74
        ],
        [
            6,
            30,
            54,
            78
        ],
        [
            6,
            30,
            56,
            82
        ],
        [
            6,
            30,
            58,
            86
        ],
        [
            6,
            34,
            62,
            90
        ],
        [
            6,
            28,
            50,
            72,
            94
        ],
        [
            6,
            26,
            50,
            74,
            98
        ],
        [
            6,
            30,
            54,
            78,
            102
        ],
        [
            6,
            28,
            54,
            80,
            106
        ],
        [
            6,
            32,
            58,
            84,
            110
        ],
        [
            6,
            30,
            58,
            86,
            114
        ],
        [
            6,
            34,
            62,
            90,
            118
        ],
        [
            6,
            26,
            50,
            74,
            98,
            122
        ],
        [
            6,
            30,
            54,
            78,
            102,
            126
        ],
        [
            6,
            26,
            52,
            78,
            104,
            130
        ],
        [
            6,
            30,
            56,
            82,
            108,
            134
        ],
        [
            6,
            34,
            60,
            86,
            112,
            138
        ],
        [
            6,
            30,
            58,
            86,
            114,
            142
        ],
        [
            6,
            34,
            62,
            90,
            118,
            146
        ],
        [
            6,
            30,
            54,
            78,
            102,
            126,
            150
        ],
        [
            6,
            24,
            50,
            76,
            102,
            128,
            154
        ],
        [
            6,
            28,
            54,
            80,
            106,
            132,
            158
        ],
        [
            6,
            32,
            58,
            84,
            110,
            136,
            162
        ],
        [
            6,
            26,
            54,
            82,
            110,
            138,
            166
        ],
        [
            6,
            30,
            58,
            86,
            114,
            142,
            170
        ]
    ];
    const G15 = 1335;
    const G18 = 7973;
    const G15_MASK = 21522;
    const _this = {};
    const getBCHDigit = function(data) {
        let digit = 0;
        while(data != 0){
            digit += 1;
            data >>>= 1;
        }
        return digit;
    };
    _this.getBCHTypeInfo = function(data) {
        let d = data << 10;
        while(getBCHDigit(d) - getBCHDigit(G15) >= 0)d ^= G15 << getBCHDigit(d) - getBCHDigit(G15);
        return (data << 10 | d) ^ G15_MASK;
    };
    _this.getBCHTypeNumber = function(data) {
        let d = data << 12;
        while(getBCHDigit(d) - getBCHDigit(G18) >= 0)d ^= G18 << getBCHDigit(d) - getBCHDigit(G18);
        return data << 12 | d;
    };
    _this.getPatternPosition = function(typeNumber) {
        return PATTERN_POSITION_TABLE[typeNumber - 1];
    };
    _this.getMaskFunction = function(maskPattern) {
        switch(maskPattern){
            case $7ad699d58ee46b15$var$QRMaskPattern.PATTERN000:
                return function(i, j) {
                    return (i + j) % 2 == 0;
                };
            case $7ad699d58ee46b15$var$QRMaskPattern.PATTERN001:
                return function(i, j) {
                    return i % 2 == 0;
                };
            case $7ad699d58ee46b15$var$QRMaskPattern.PATTERN010:
                return function(i, j) {
                    return j % 3 == 0;
                };
            case $7ad699d58ee46b15$var$QRMaskPattern.PATTERN011:
                return function(i, j) {
                    return (i + j) % 3 == 0;
                };
            case $7ad699d58ee46b15$var$QRMaskPattern.PATTERN100:
                return function(i, j) {
                    return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 == 0;
                };
            case $7ad699d58ee46b15$var$QRMaskPattern.PATTERN101:
                return function(i, j) {
                    return i * j % 2 + i * j % 3 == 0;
                };
            case $7ad699d58ee46b15$var$QRMaskPattern.PATTERN110:
                return function(i, j) {
                    return (i * j % 2 + i * j % 3) % 2 == 0;
                };
            case $7ad699d58ee46b15$var$QRMaskPattern.PATTERN111:
                return function(i, j) {
                    return (i * j % 3 + (i + j) % 2) % 2 == 0;
                };
            default:
                throw 'bad maskPattern:' + maskPattern;
        }
    };
    _this.getErrorCorrectPolynomial = function(errorCorrectLength) {
        let a = $7ad699d58ee46b15$var$qrPolynomial([
            1
        ], 0);
        for(let i = 0; i < errorCorrectLength; i += 1)a = a.multiply($7ad699d58ee46b15$var$qrPolynomial([
            1,
            $7ad699d58ee46b15$var$QRMath.gexp(i)
        ], 0));
        return a;
    };
    _this.getLengthInBits = function(mode, type) {
        if (1 <= type && type < 10) // 1 - 9
        switch(mode){
            case $7ad699d58ee46b15$var$QRMode.MODE_NUMBER:
                return 10;
            case $7ad699d58ee46b15$var$QRMode.MODE_ALPHA_NUM:
                return 9;
            case $7ad699d58ee46b15$var$QRMode.MODE_8BIT_BYTE:
                return 8;
            case $7ad699d58ee46b15$var$QRMode.MODE_KANJI:
                return 8;
            default:
                throw 'mode:' + mode;
        }
        else if (type < 27) // 10 - 26
        switch(mode){
            case $7ad699d58ee46b15$var$QRMode.MODE_NUMBER:
                return 12;
            case $7ad699d58ee46b15$var$QRMode.MODE_ALPHA_NUM:
                return 11;
            case $7ad699d58ee46b15$var$QRMode.MODE_8BIT_BYTE:
                return 16;
            case $7ad699d58ee46b15$var$QRMode.MODE_KANJI:
                return 10;
            default:
                throw 'mode:' + mode;
        }
        else if (type < 41) // 27 - 40
        switch(mode){
            case $7ad699d58ee46b15$var$QRMode.MODE_NUMBER:
                return 14;
            case $7ad699d58ee46b15$var$QRMode.MODE_ALPHA_NUM:
                return 13;
            case $7ad699d58ee46b15$var$QRMode.MODE_8BIT_BYTE:
                return 16;
            case $7ad699d58ee46b15$var$QRMode.MODE_KANJI:
                return 12;
            default:
                throw 'mode:' + mode;
        }
        else throw 'type:' + type;
    };
    _this.getLostPoint = function(qrcode) {
        const moduleCount = qrcode.getModuleCount();
        let lostPoint = 0;
        // LEVEL1
        for(let row = 0; row < moduleCount; row += 1)for(let col = 0; col < moduleCount; col += 1){
            let sameCount = 0;
            const dark = qrcode.isDark(row, col);
            for(let r = -1; r <= 1; r += 1){
                if (row + r < 0 || moduleCount <= row + r) continue;
                for(let c = -1; c <= 1; c += 1){
                    if (col + c < 0 || moduleCount <= col + c) continue;
                    if (r == 0 && c == 0) continue;
                    if (dark == qrcode.isDark(row + r, col + c)) sameCount += 1;
                }
            }
            if (sameCount > 5) lostPoint += 3 + sameCount - 5;
        }
        // LEVEL2
        for(let row = 0; row < moduleCount - 1; row += 1)for(let col = 0; col < moduleCount - 1; col += 1){
            let count = 0;
            if (qrcode.isDark(row, col)) count += 1;
            if (qrcode.isDark(row + 1, col)) count += 1;
            if (qrcode.isDark(row, col + 1)) count += 1;
            if (qrcode.isDark(row + 1, col + 1)) count += 1;
            if (count == 0 || count == 4) lostPoint += 3;
        }
        // LEVEL3
        for(let row = 0; row < moduleCount; row += 1){
            for(let col = 0; col < moduleCount - 6; col += 1)if (qrcode.isDark(row, col) && !qrcode.isDark(row, col + 1) && qrcode.isDark(row, col + 2) && qrcode.isDark(row, col + 3) && qrcode.isDark(row, col + 4) && !qrcode.isDark(row, col + 5) && qrcode.isDark(row, col + 6)) lostPoint += 40;
        }
        for(let col = 0; col < moduleCount; col += 1){
            for(let row = 0; row < moduleCount - 6; row += 1)if (qrcode.isDark(row, col) && !qrcode.isDark(row + 1, col) && qrcode.isDark(row + 2, col) && qrcode.isDark(row + 3, col) && qrcode.isDark(row + 4, col) && !qrcode.isDark(row + 5, col) && qrcode.isDark(row + 6, col)) lostPoint += 40;
        }
        // LEVEL4
        let darkCount = 0;
        for(let col = 0; col < moduleCount; col += 1){
            for(let row = 0; row < moduleCount; row += 1)if (qrcode.isDark(row, col)) darkCount += 1;
        }
        const ratio = Math.abs(100 * darkCount / moduleCount / moduleCount - 50) / 5;
        lostPoint += ratio * 10;
        return lostPoint;
    };
    return _this;
}();
//---------------------------------------------------------------------
// QRMath
//---------------------------------------------------------------------
const $7ad699d58ee46b15$var$QRMath = function() {
    const EXP_TABLE = new Array(256);
    const LOG_TABLE = new Array(256);
    // initialize tables
    for(let i = 0; i < 8; i += 1)EXP_TABLE[i] = 1 << i;
    for(let i = 8; i < 256; i += 1)EXP_TABLE[i] = EXP_TABLE[i - 4] ^ EXP_TABLE[i - 5] ^ EXP_TABLE[i - 6] ^ EXP_TABLE[i - 8];
    for(let i = 0; i < 255; i += 1)LOG_TABLE[EXP_TABLE[i]] = i;
    const _this = {};
    _this.glog = function(n) {
        if (n < 1) throw 'glog(' + n + ')';
        return LOG_TABLE[n];
    };
    _this.gexp = function(n) {
        while(n < 0)n += 255;
        while(n >= 256)n -= 255;
        return EXP_TABLE[n];
    };
    return _this;
}();
//---------------------------------------------------------------------
// qrPolynomial
//---------------------------------------------------------------------
const $7ad699d58ee46b15$var$qrPolynomial = function(num, shift) {
    if (typeof num.length == 'undefined') throw num.length + '/' + shift;
    const _num = function() {
        let offset = 0;
        while(offset < num.length && num[offset] == 0)offset += 1;
        const _num = new Array(num.length - offset + shift);
        for(let i = 0; i < num.length - offset; i += 1)_num[i] = num[i + offset];
        return _num;
    }();
    const _this = {};
    _this.getAt = function(index) {
        return _num[index];
    };
    _this.getLength = function() {
        return _num.length;
    };
    _this.multiply = function(e) {
        const num = new Array(_this.getLength() + e.getLength() - 1);
        for(let i = 0; i < _this.getLength(); i += 1)for(let j = 0; j < e.getLength(); j += 1)num[i + j] ^= $7ad699d58ee46b15$var$QRMath.gexp($7ad699d58ee46b15$var$QRMath.glog(_this.getAt(i)) + $7ad699d58ee46b15$var$QRMath.glog(e.getAt(j)));
        return $7ad699d58ee46b15$var$qrPolynomial(num, 0);
    };
    _this.mod = function(e) {
        if (_this.getLength() - e.getLength() < 0) return _this;
        const ratio = $7ad699d58ee46b15$var$QRMath.glog(_this.getAt(0)) - $7ad699d58ee46b15$var$QRMath.glog(e.getAt(0));
        const num = new Array(_this.getLength());
        for(let i = 0; i < _this.getLength(); i += 1)num[i] = _this.getAt(i);
        for(let i = 0; i < e.getLength(); i += 1)num[i] ^= $7ad699d58ee46b15$var$QRMath.gexp($7ad699d58ee46b15$var$QRMath.glog(e.getAt(i)) + ratio);
        // recursive call
        return $7ad699d58ee46b15$var$qrPolynomial(num, 0).mod(e);
    };
    return _this;
};
//---------------------------------------------------------------------
// QRRSBlock
//---------------------------------------------------------------------
const $7ad699d58ee46b15$var$QRRSBlock = function() {
    const RS_BLOCK_TABLE = [
        // L
        // M
        // Q
        // H
        // 1
        [
            1,
            26,
            19
        ],
        [
            1,
            26,
            16
        ],
        [
            1,
            26,
            13
        ],
        [
            1,
            26,
            9
        ],
        // 2
        [
            1,
            44,
            34
        ],
        [
            1,
            44,
            28
        ],
        [
            1,
            44,
            22
        ],
        [
            1,
            44,
            16
        ],
        // 3
        [
            1,
            70,
            55
        ],
        [
            1,
            70,
            44
        ],
        [
            2,
            35,
            17
        ],
        [
            2,
            35,
            13
        ],
        // 4
        [
            1,
            100,
            80
        ],
        [
            2,
            50,
            32
        ],
        [
            2,
            50,
            24
        ],
        [
            4,
            25,
            9
        ],
        // 5
        [
            1,
            134,
            108
        ],
        [
            2,
            67,
            43
        ],
        [
            2,
            33,
            15,
            2,
            34,
            16
        ],
        [
            2,
            33,
            11,
            2,
            34,
            12
        ],
        // 6
        [
            2,
            86,
            68
        ],
        [
            4,
            43,
            27
        ],
        [
            4,
            43,
            19
        ],
        [
            4,
            43,
            15
        ],
        // 7
        [
            2,
            98,
            78
        ],
        [
            4,
            49,
            31
        ],
        [
            2,
            32,
            14,
            4,
            33,
            15
        ],
        [
            4,
            39,
            13,
            1,
            40,
            14
        ],
        // 8
        [
            2,
            121,
            97
        ],
        [
            2,
            60,
            38,
            2,
            61,
            39
        ],
        [
            4,
            40,
            18,
            2,
            41,
            19
        ],
        [
            4,
            40,
            14,
            2,
            41,
            15
        ],
        // 9
        [
            2,
            146,
            116
        ],
        [
            3,
            58,
            36,
            2,
            59,
            37
        ],
        [
            4,
            36,
            16,
            4,
            37,
            17
        ],
        [
            4,
            36,
            12,
            4,
            37,
            13
        ],
        // 10
        [
            2,
            86,
            68,
            2,
            87,
            69
        ],
        [
            4,
            69,
            43,
            1,
            70,
            44
        ],
        [
            6,
            43,
            19,
            2,
            44,
            20
        ],
        [
            6,
            43,
            15,
            2,
            44,
            16
        ],
        // 11
        [
            4,
            101,
            81
        ],
        [
            1,
            80,
            50,
            4,
            81,
            51
        ],
        [
            4,
            50,
            22,
            4,
            51,
            23
        ],
        [
            3,
            36,
            12,
            8,
            37,
            13
        ],
        // 12
        [
            2,
            116,
            92,
            2,
            117,
            93
        ],
        [
            6,
            58,
            36,
            2,
            59,
            37
        ],
        [
            4,
            46,
            20,
            6,
            47,
            21
        ],
        [
            7,
            42,
            14,
            4,
            43,
            15
        ],
        // 13
        [
            4,
            133,
            107
        ],
        [
            8,
            59,
            37,
            1,
            60,
            38
        ],
        [
            8,
            44,
            20,
            4,
            45,
            21
        ],
        [
            12,
            33,
            11,
            4,
            34,
            12
        ],
        // 14
        [
            3,
            145,
            115,
            1,
            146,
            116
        ],
        [
            4,
            64,
            40,
            5,
            65,
            41
        ],
        [
            11,
            36,
            16,
            5,
            37,
            17
        ],
        [
            11,
            36,
            12,
            5,
            37,
            13
        ],
        // 15
        [
            5,
            109,
            87,
            1,
            110,
            88
        ],
        [
            5,
            65,
            41,
            5,
            66,
            42
        ],
        [
            5,
            54,
            24,
            7,
            55,
            25
        ],
        [
            11,
            36,
            12,
            7,
            37,
            13
        ],
        // 16
        [
            5,
            122,
            98,
            1,
            123,
            99
        ],
        [
            7,
            73,
            45,
            3,
            74,
            46
        ],
        [
            15,
            43,
            19,
            2,
            44,
            20
        ],
        [
            3,
            45,
            15,
            13,
            46,
            16
        ],
        // 17
        [
            1,
            135,
            107,
            5,
            136,
            108
        ],
        [
            10,
            74,
            46,
            1,
            75,
            47
        ],
        [
            1,
            50,
            22,
            15,
            51,
            23
        ],
        [
            2,
            42,
            14,
            17,
            43,
            15
        ],
        // 18
        [
            5,
            150,
            120,
            1,
            151,
            121
        ],
        [
            9,
            69,
            43,
            4,
            70,
            44
        ],
        [
            17,
            50,
            22,
            1,
            51,
            23
        ],
        [
            2,
            42,
            14,
            19,
            43,
            15
        ],
        // 19
        [
            3,
            141,
            113,
            4,
            142,
            114
        ],
        [
            3,
            70,
            44,
            11,
            71,
            45
        ],
        [
            17,
            47,
            21,
            4,
            48,
            22
        ],
        [
            9,
            39,
            13,
            16,
            40,
            14
        ],
        // 20
        [
            3,
            135,
            107,
            5,
            136,
            108
        ],
        [
            3,
            67,
            41,
            13,
            68,
            42
        ],
        [
            15,
            54,
            24,
            5,
            55,
            25
        ],
        [
            15,
            43,
            15,
            10,
            44,
            16
        ],
        // 21
        [
            4,
            144,
            116,
            4,
            145,
            117
        ],
        [
            17,
            68,
            42
        ],
        [
            17,
            50,
            22,
            6,
            51,
            23
        ],
        [
            19,
            46,
            16,
            6,
            47,
            17
        ],
        // 22
        [
            2,
            139,
            111,
            7,
            140,
            112
        ],
        [
            17,
            74,
            46
        ],
        [
            7,
            54,
            24,
            16,
            55,
            25
        ],
        [
            34,
            37,
            13
        ],
        // 23
        [
            4,
            151,
            121,
            5,
            152,
            122
        ],
        [
            4,
            75,
            47,
            14,
            76,
            48
        ],
        [
            11,
            54,
            24,
            14,
            55,
            25
        ],
        [
            16,
            45,
            15,
            14,
            46,
            16
        ],
        // 24
        [
            6,
            147,
            117,
            4,
            148,
            118
        ],
        [
            6,
            73,
            45,
            14,
            74,
            46
        ],
        [
            11,
            54,
            24,
            16,
            55,
            25
        ],
        [
            30,
            46,
            16,
            2,
            47,
            17
        ],
        // 25
        [
            8,
            132,
            106,
            4,
            133,
            107
        ],
        [
            8,
            75,
            47,
            13,
            76,
            48
        ],
        [
            7,
            54,
            24,
            22,
            55,
            25
        ],
        [
            22,
            45,
            15,
            13,
            46,
            16
        ],
        // 26
        [
            10,
            142,
            114,
            2,
            143,
            115
        ],
        [
            19,
            74,
            46,
            4,
            75,
            47
        ],
        [
            28,
            50,
            22,
            6,
            51,
            23
        ],
        [
            33,
            46,
            16,
            4,
            47,
            17
        ],
        // 27
        [
            8,
            152,
            122,
            4,
            153,
            123
        ],
        [
            22,
            73,
            45,
            3,
            74,
            46
        ],
        [
            8,
            53,
            23,
            26,
            54,
            24
        ],
        [
            12,
            45,
            15,
            28,
            46,
            16
        ],
        // 28
        [
            3,
            147,
            117,
            10,
            148,
            118
        ],
        [
            3,
            73,
            45,
            23,
            74,
            46
        ],
        [
            4,
            54,
            24,
            31,
            55,
            25
        ],
        [
            11,
            45,
            15,
            31,
            46,
            16
        ],
        // 29
        [
            7,
            146,
            116,
            7,
            147,
            117
        ],
        [
            21,
            73,
            45,
            7,
            74,
            46
        ],
        [
            1,
            53,
            23,
            37,
            54,
            24
        ],
        [
            19,
            45,
            15,
            26,
            46,
            16
        ],
        // 30
        [
            5,
            145,
            115,
            10,
            146,
            116
        ],
        [
            19,
            75,
            47,
            10,
            76,
            48
        ],
        [
            15,
            54,
            24,
            25,
            55,
            25
        ],
        [
            23,
            45,
            15,
            25,
            46,
            16
        ],
        // 31
        [
            13,
            145,
            115,
            3,
            146,
            116
        ],
        [
            2,
            74,
            46,
            29,
            75,
            47
        ],
        [
            42,
            54,
            24,
            1,
            55,
            25
        ],
        [
            23,
            45,
            15,
            28,
            46,
            16
        ],
        // 32
        [
            17,
            145,
            115
        ],
        [
            10,
            74,
            46,
            23,
            75,
            47
        ],
        [
            10,
            54,
            24,
            35,
            55,
            25
        ],
        [
            19,
            45,
            15,
            35,
            46,
            16
        ],
        // 33
        [
            17,
            145,
            115,
            1,
            146,
            116
        ],
        [
            14,
            74,
            46,
            21,
            75,
            47
        ],
        [
            29,
            54,
            24,
            19,
            55,
            25
        ],
        [
            11,
            45,
            15,
            46,
            46,
            16
        ],
        // 34
        [
            13,
            145,
            115,
            6,
            146,
            116
        ],
        [
            14,
            74,
            46,
            23,
            75,
            47
        ],
        [
            44,
            54,
            24,
            7,
            55,
            25
        ],
        [
            59,
            46,
            16,
            1,
            47,
            17
        ],
        // 35
        [
            12,
            151,
            121,
            7,
            152,
            122
        ],
        [
            12,
            75,
            47,
            26,
            76,
            48
        ],
        [
            39,
            54,
            24,
            14,
            55,
            25
        ],
        [
            22,
            45,
            15,
            41,
            46,
            16
        ],
        // 36
        [
            6,
            151,
            121,
            14,
            152,
            122
        ],
        [
            6,
            75,
            47,
            34,
            76,
            48
        ],
        [
            46,
            54,
            24,
            10,
            55,
            25
        ],
        [
            2,
            45,
            15,
            64,
            46,
            16
        ],
        // 37
        [
            17,
            152,
            122,
            4,
            153,
            123
        ],
        [
            29,
            74,
            46,
            14,
            75,
            47
        ],
        [
            49,
            54,
            24,
            10,
            55,
            25
        ],
        [
            24,
            45,
            15,
            46,
            46,
            16
        ],
        // 38
        [
            4,
            152,
            122,
            18,
            153,
            123
        ],
        [
            13,
            74,
            46,
            32,
            75,
            47
        ],
        [
            48,
            54,
            24,
            14,
            55,
            25
        ],
        [
            42,
            45,
            15,
            32,
            46,
            16
        ],
        // 39
        [
            20,
            147,
            117,
            4,
            148,
            118
        ],
        [
            40,
            75,
            47,
            7,
            76,
            48
        ],
        [
            43,
            54,
            24,
            22,
            55,
            25
        ],
        [
            10,
            45,
            15,
            67,
            46,
            16
        ],
        // 40
        [
            19,
            148,
            118,
            6,
            149,
            119
        ],
        [
            18,
            75,
            47,
            31,
            76,
            48
        ],
        [
            34,
            54,
            24,
            34,
            55,
            25
        ],
        [
            20,
            45,
            15,
            61,
            46,
            16
        ]
    ];
    const qrRSBlock = function(totalCount, dataCount) {
        const _this = {};
        _this.totalCount = totalCount;
        _this.dataCount = dataCount;
        return _this;
    };
    const _this = {};
    const getRsBlockTable = function(typeNumber, errorCorrectionLevel) {
        switch(errorCorrectionLevel){
            case $7ad699d58ee46b15$var$QRErrorCorrectionLevel.L:
                return RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 0];
            case $7ad699d58ee46b15$var$QRErrorCorrectionLevel.M:
                return RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 1];
            case $7ad699d58ee46b15$var$QRErrorCorrectionLevel.Q:
                return RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 2];
            case $7ad699d58ee46b15$var$QRErrorCorrectionLevel.H:
                return RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 3];
            default:
                return undefined;
        }
    };
    _this.getRSBlocks = function(typeNumber, errorCorrectionLevel) {
        const rsBlock = getRsBlockTable(typeNumber, errorCorrectionLevel);
        if (typeof rsBlock == 'undefined') throw 'bad rs block @ typeNumber:' + typeNumber + '/errorCorrectionLevel:' + errorCorrectionLevel;
        const length = rsBlock.length / 3;
        const list = [];
        for(let i = 0; i < length; i += 1){
            const count = rsBlock[i * 3 + 0];
            const totalCount = rsBlock[i * 3 + 1];
            const dataCount = rsBlock[i * 3 + 2];
            for(let j = 0; j < count; j += 1)list.push(qrRSBlock(totalCount, dataCount));
        }
        return list;
    };
    return _this;
}();
//---------------------------------------------------------------------
// qrBitBuffer
//---------------------------------------------------------------------
const $7ad699d58ee46b15$var$qrBitBuffer = function() {
    const _buffer = [];
    let _length = 0;
    const _this = {};
    _this.getBuffer = function() {
        return _buffer;
    };
    _this.getAt = function(index) {
        const bufIndex = Math.floor(index / 8);
        return (_buffer[bufIndex] >>> 7 - index % 8 & 1) == 1;
    };
    _this.put = function(num, length) {
        for(let i = 0; i < length; i += 1)_this.putBit((num >>> length - i - 1 & 1) == 1);
    };
    _this.getLengthInBits = function() {
        return _length;
    };
    _this.putBit = function(bit) {
        const bufIndex = Math.floor(_length / 8);
        if (_buffer.length <= bufIndex) _buffer.push(0);
        if (bit) _buffer[bufIndex] |= 0x80 >>> _length % 8;
        _length += 1;
    };
    return _this;
};
//---------------------------------------------------------------------
// qrNumber
//---------------------------------------------------------------------
const $7ad699d58ee46b15$var$qrNumber = function(data) {
    const _mode = $7ad699d58ee46b15$var$QRMode.MODE_NUMBER;
    const _data = data;
    const _this = {};
    _this.getMode = function() {
        return _mode;
    };
    _this.getLength = function(buffer) {
        return _data.length;
    };
    _this.write = function(buffer) {
        const data = _data;
        let i = 0;
        while(i + 2 < data.length){
            buffer.put(strToNum(data.substring(i, i + 3)), 10);
            i += 3;
        }
        if (i < data.length) {
            if (data.length - i == 1) buffer.put(strToNum(data.substring(i, i + 1)), 4);
            else if (data.length - i == 2) buffer.put(strToNum(data.substring(i, i + 2)), 7);
        }
    };
    const strToNum = function(s) {
        let num = 0;
        for(let i = 0; i < s.length; i += 1)num = num * 10 + chatToNum(s.charAt(i));
        return num;
    };
    const chatToNum = function(c) {
        if ('0' <= c && c <= '9') return c.charCodeAt(0) - '0'.charCodeAt(0);
        throw 'illegal char :' + c;
    };
    return _this;
};
//---------------------------------------------------------------------
// qrAlphaNum
//---------------------------------------------------------------------
const $7ad699d58ee46b15$var$qrAlphaNum = function(data) {
    const _mode = $7ad699d58ee46b15$var$QRMode.MODE_ALPHA_NUM;
    const _data = data;
    const _this = {};
    _this.getMode = function() {
        return _mode;
    };
    _this.getLength = function(buffer) {
        return _data.length;
    };
    _this.write = function(buffer) {
        const s = _data;
        let i = 0;
        while(i + 1 < s.length){
            buffer.put(getCode(s.charAt(i)) * 45 + getCode(s.charAt(i + 1)), 11);
            i += 2;
        }
        if (i < s.length) buffer.put(getCode(s.charAt(i)), 6);
    };
    const getCode = function(c) {
        if ('0' <= c && c <= '9') return c.charCodeAt(0) - '0'.charCodeAt(0);
        else if ('A' <= c && c <= 'Z') return c.charCodeAt(0) - 'A'.charCodeAt(0) + 10;
        else switch(c){
            case '\u0020':
                return 36;
            case '$':
                return 37;
            case '%':
                return 38;
            case '*':
                return 39;
            case '+':
                return 40;
            case '-':
                return 41;
            case '.':
                return 42;
            case '/':
                return 43;
            case ':':
                return 44;
            default:
                throw 'illegal char :' + c;
        }
    };
    return _this;
};
//---------------------------------------------------------------------
// qr8BitByte
//---------------------------------------------------------------------
const $7ad699d58ee46b15$var$qr8BitByte = function(data) {
    const _mode = $7ad699d58ee46b15$var$QRMode.MODE_8BIT_BYTE;
    const _data = data;
    const _bytes = $7ad699d58ee46b15$export$5f3279733515fed0.stringToBytes(data);
    const _this = {};
    _this.getMode = function() {
        return _mode;
    };
    _this.getLength = function(buffer) {
        return _bytes.length;
    };
    _this.write = function(buffer) {
        for(let i = 0; i < _bytes.length; i += 1)buffer.put(_bytes[i], 8);
    };
    return _this;
};
//---------------------------------------------------------------------
// qrKanji
//---------------------------------------------------------------------
const $7ad699d58ee46b15$var$qrKanji = function(data) {
    const _mode = $7ad699d58ee46b15$var$QRMode.MODE_KANJI;
    const _data = data;
    const stringToBytes = $7ad699d58ee46b15$export$5f3279733515fed0.stringToBytes;
    !function(c, code) {
        // self test for sjis support.
        const test = stringToBytes(c);
        if (test.length != 2 || (test[0] << 8 | test[1]) != code) throw 'sjis not supported.';
    }('\u53cb', 0x9746);
    const _bytes = stringToBytes(data);
    const _this = {};
    _this.getMode = function() {
        return _mode;
    };
    _this.getLength = function(buffer) {
        return ~~(_bytes.length / 2);
    };
    _this.write = function(buffer) {
        const data = _bytes;
        let i = 0;
        while(i + 1 < data.length){
            let c = (0xff & data[i]) << 8 | 0xff & data[i + 1];
            if (0x8140 <= c && c <= 0x9FFC) c -= 0x8140;
            else if (0xE040 <= c && c <= 0xEBBF) c -= 0xC140;
            else throw 'illegal char at ' + (i + 1) + '/' + c;
            c = (c >>> 8 & 0xff) * 0xC0 + (c & 0xff);
            buffer.put(c, 13);
            i += 2;
        }
        if (i < data.length) throw 'illegal char at ' + (i + 1);
    };
    return _this;
};
//=====================================================================
// GIF Support etc.
//
//---------------------------------------------------------------------
// byteArrayOutputStream
//---------------------------------------------------------------------
const $7ad699d58ee46b15$var$byteArrayOutputStream = function() {
    const _bytes = [];
    const _this = {};
    _this.writeByte = function(b) {
        _bytes.push(b & 0xff);
    };
    _this.writeShort = function(i) {
        _this.writeByte(i);
        _this.writeByte(i >>> 8);
    };
    _this.writeBytes = function(b, off, len) {
        off = off || 0;
        len = len || b.length;
        for(let i = 0; i < len; i += 1)_this.writeByte(b[i + off]);
    };
    _this.writeString = function(s) {
        for(let i = 0; i < s.length; i += 1)_this.writeByte(s.charCodeAt(i));
    };
    _this.toByteArray = function() {
        return _bytes;
    };
    _this.toString = function() {
        let s = '';
        s += '[';
        for(let i = 0; i < _bytes.length; i += 1){
            if (i > 0) s += ',';
            s += _bytes[i];
        }
        s += ']';
        return s;
    };
    return _this;
};
//---------------------------------------------------------------------
// base64EncodeOutputStream
//---------------------------------------------------------------------
const $7ad699d58ee46b15$var$base64EncodeOutputStream = function() {
    let _buffer = 0;
    let _buflen = 0;
    let _length = 0;
    let _base64 = '';
    const _this = {};
    const writeEncoded = function(b) {
        _base64 += String.fromCharCode(encode(b & 0x3f));
    };
    const encode = function(n) {
        if (n < 0) throw 'n:' + n;
        else if (n < 26) return 0x41 + n;
        else if (n < 52) return 0x61 + (n - 26);
        else if (n < 62) return 0x30 + (n - 52);
        else if (n == 62) return 0x2b;
        else if (n == 63) return 0x2f;
        else throw 'n:' + n;
    };
    _this.writeByte = function(n) {
        _buffer = _buffer << 8 | n & 0xff;
        _buflen += 8;
        _length += 1;
        while(_buflen >= 6){
            writeEncoded(_buffer >>> _buflen - 6);
            _buflen -= 6;
        }
    };
    _this.flush = function() {
        if (_buflen > 0) {
            writeEncoded(_buffer << 6 - _buflen);
            _buffer = 0;
            _buflen = 0;
        }
        if (_length % 3 != 0) {
            // padding
            const padlen = 3 - _length % 3;
            for(let i = 0; i < padlen; i += 1)_base64 += '=';
        }
    };
    _this.toString = function() {
        return _base64;
    };
    return _this;
};
//---------------------------------------------------------------------
// base64DecodeInputStream
//---------------------------------------------------------------------
const $7ad699d58ee46b15$var$base64DecodeInputStream = function(str) {
    const _str = str;
    let _pos = 0;
    let _buffer = 0;
    let _buflen = 0;
    const _this = {};
    _this.read = function() {
        while(_buflen < 8){
            if (_pos >= _str.length) {
                if (_buflen == 0) return -1;
                throw 'unexpected end of file./' + _buflen;
            }
            const c = _str.charAt(_pos);
            _pos += 1;
            if (c == '=') {
                _buflen = 0;
                return -1;
            } else if (c.match(/^\s$/)) continue;
            _buffer = _buffer << 6 | decode(c.charCodeAt(0));
            _buflen += 6;
        }
        const n = _buffer >>> _buflen - 8 & 0xff;
        _buflen -= 8;
        return n;
    };
    const decode = function(c) {
        if (0x41 <= c && c <= 0x5a) return c - 0x41;
        else if (0x61 <= c && c <= 0x7a) return c - 0x61 + 26;
        else if (0x30 <= c && c <= 0x39) return c - 0x30 + 52;
        else if (c == 0x2b) return 62;
        else if (c == 0x2f) return 63;
        else throw 'c:' + c;
    };
    return _this;
};
//---------------------------------------------------------------------
// gifImage (B/W)
//---------------------------------------------------------------------
const $7ad699d58ee46b15$var$gifImage = function(width, height) {
    const _width = width;
    const _height = height;
    const _data = new Array(width * height);
    const _this = {};
    _this.setPixel = function(x, y, pixel) {
        _data[y * _width + x] = pixel;
    };
    _this.write = function(out) {
        //---------------------------------
        // GIF Signature
        out.writeString('GIF87a');
        //---------------------------------
        // Screen Descriptor
        out.writeShort(_width);
        out.writeShort(_height);
        out.writeByte(0x80); // 2bit
        out.writeByte(0);
        out.writeByte(0);
        //---------------------------------
        // Global Color Map
        // black
        out.writeByte(0x00);
        out.writeByte(0x00);
        out.writeByte(0x00);
        // white
        out.writeByte(0xff);
        out.writeByte(0xff);
        out.writeByte(0xff);
        //---------------------------------
        // Image Descriptor
        out.writeString(',');
        out.writeShort(0);
        out.writeShort(0);
        out.writeShort(_width);
        out.writeShort(_height);
        out.writeByte(0);
        //---------------------------------
        // Local Color Map
        //---------------------------------
        // Raster Data
        const lzwMinCodeSize = 2;
        const raster = getLZWRaster(lzwMinCodeSize);
        out.writeByte(lzwMinCodeSize);
        let offset = 0;
        while(raster.length - offset > 255){
            out.writeByte(255);
            out.writeBytes(raster, offset, 255);
            offset += 255;
        }
        out.writeByte(raster.length - offset);
        out.writeBytes(raster, offset, raster.length - offset);
        out.writeByte(0x00);
        //---------------------------------
        // GIF Terminator
        out.writeString(';');
    };
    const bitOutputStream = function(out) {
        const _out = out;
        let _bitLength = 0;
        let _bitBuffer = 0;
        const _this = {};
        _this.write = function(data, length) {
            if (data >>> length != 0) throw 'length over';
            while(_bitLength + length >= 8){
                _out.writeByte(0xff & (data << _bitLength | _bitBuffer));
                length -= 8 - _bitLength;
                data >>>= 8 - _bitLength;
                _bitBuffer = 0;
                _bitLength = 0;
            }
            _bitBuffer = data << _bitLength | _bitBuffer;
            _bitLength = _bitLength + length;
        };
        _this.flush = function() {
            if (_bitLength > 0) _out.writeByte(_bitBuffer);
        };
        return _this;
    };
    const getLZWRaster = function(lzwMinCodeSize) {
        const clearCode = 1 << lzwMinCodeSize;
        const endCode = (1 << lzwMinCodeSize) + 1;
        let bitLength = lzwMinCodeSize + 1;
        // Setup LZWTable
        const table = lzwTable();
        for(let i = 0; i < clearCode; i += 1)table.add(String.fromCharCode(i));
        table.add(String.fromCharCode(clearCode));
        table.add(String.fromCharCode(endCode));
        const byteOut = $7ad699d58ee46b15$var$byteArrayOutputStream();
        const bitOut = bitOutputStream(byteOut);
        // clear code
        bitOut.write(clearCode, bitLength);
        let dataIndex = 0;
        let s = String.fromCharCode(_data[dataIndex]);
        dataIndex += 1;
        while(dataIndex < _data.length){
            const c = String.fromCharCode(_data[dataIndex]);
            dataIndex += 1;
            if (table.contains(s + c)) s = s + c;
            else {
                bitOut.write(table.indexOf(s), bitLength);
                if (table.size() < 0xfff) {
                    if (table.size() == 1 << bitLength) bitLength += 1;
                    table.add(s + c);
                }
                s = c;
            }
        }
        bitOut.write(table.indexOf(s), bitLength);
        // end code
        bitOut.write(endCode, bitLength);
        bitOut.flush();
        return byteOut.toByteArray();
    };
    const lzwTable = function() {
        const _map = {};
        let _size = 0;
        const _this = {};
        _this.add = function(key) {
            if (_this.contains(key)) throw 'dup key:' + key;
            _map[key] = _size;
            _size += 1;
        };
        _this.size = function() {
            return _size;
        };
        _this.indexOf = function(key) {
            return _map[key];
        };
        _this.contains = function(key) {
            return typeof _map[key] != 'undefined';
        };
        return _this;
    };
    return _this;
};
const $7ad699d58ee46b15$var$createDataURL = function(width, height, getPixel) {
    const gif = $7ad699d58ee46b15$var$gifImage(width, height);
    for(let y = 0; y < height; y += 1)for(let x = 0; x < width; x += 1)gif.setPixel(x, y, getPixel(x, y));
    const b = $7ad699d58ee46b15$var$byteArrayOutputStream();
    gif.write(b);
    const base64 = $7ad699d58ee46b15$var$base64EncodeOutputStream();
    const bytes = b.toByteArray();
    for(let i = 0; i < bytes.length; i += 1)base64.writeByte(bytes[i]);
    base64.flush();
    return 'data:image/gif;base64,' + base64;
};
var $7ad699d58ee46b15$export$2e2bcd8739ae039 = $7ad699d58ee46b15$export$5f3279733515fed0;
const $7ad699d58ee46b15$export$c8dd6bc66a63753c = $7ad699d58ee46b15$export$5f3279733515fed0.stringToBytes;



var $lCzvA = parcelRequire("lCzvA");
function $1a6b129fa2cafd12$var$_extends() {
    return $1a6b129fa2cafd12$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1a6b129fa2cafd12$var$_extends.apply(null, arguments);
}
function $1a6b129fa2cafd12$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $1a6b129fa2cafd12$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $1a6b129fa2cafd12$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $1a6b129fa2cafd12$var$_excluded$1 = [
    "bgColor",
    "bgD",
    "fgD",
    "fgColor",
    "size",
    "title",
    "viewBoxSize",
    "xmlns"
];
var $1a6b129fa2cafd12$var$propTypes$1 = {
    bgColor: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).string
    ]).isRequired,
    bgD: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).string.isRequired,
    fgColor: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).string
    ]).isRequired,
    fgD: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).string.isRequired,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).number.isRequired,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).string,
    viewBoxSize: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).number.isRequired,
    xmlns: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).string
};
var $1a6b129fa2cafd12$var$QRCodeSvg = /*#__PURE__*/ (0, $lCzvA.forwardRef)(function(_ref, ref) {
    var bgColor = _ref.bgColor, bgD = _ref.bgD, fgD = _ref.fgD, fgColor = _ref.fgColor, size = _ref.size, title = _ref.title, viewBoxSize = _ref.viewBoxSize, _ref$xmlns = _ref.xmlns, xmlns = _ref$xmlns === void 0 ? "http://www.w3.org/2000/svg" : _ref$xmlns, props = $1a6b129fa2cafd12$var$_objectWithoutProperties(_ref, $1a6b129fa2cafd12$var$_excluded$1);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).createElement("svg", $1a6b129fa2cafd12$var$_extends({}, props, {
        height: size,
        ref: ref,
        viewBox: "0 0 ".concat(viewBoxSize, " ").concat(viewBoxSize),
        width: size,
        xmlns: xmlns
    }), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).createElement("path", {
        d: bgD,
        fill: bgColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).createElement("path", {
        d: fgD,
        fill: fgColor
    }));
});
$1a6b129fa2cafd12$var$QRCodeSvg.displayName = "QRCodeSvg";
$1a6b129fa2cafd12$var$QRCodeSvg.propTypes = $1a6b129fa2cafd12$var$propTypes$1;
var $1a6b129fa2cafd12$var$_excluded = [
    "bgColor",
    "fgColor",
    "level",
    "size",
    "value"
];
(0, $7ad699d58ee46b15$export$2e2bcd8739ae039).stringToBytes = function(s) {
    return Array.from(new TextEncoder().encode(s));
};
var $1a6b129fa2cafd12$var$propTypes = {
    bgColor: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).string
    ]),
    fgColor: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).string
    ]),
    level: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).number,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($d2ac6f7a90164e12$exports))).string.isRequired
};
var $1a6b129fa2cafd12$export$a77d98f00e648d58 = /*#__PURE__*/ (0, $lCzvA.forwardRef)(function(_ref, ref) {
    var _ref$bgColor = _ref.bgColor, bgColor = _ref$bgColor === void 0 ? "#FFFFFF" : _ref$bgColor, _ref$fgColor = _ref.fgColor, fgColor = _ref$fgColor === void 0 ? "#000000" : _ref$fgColor, _ref$level = _ref.level, level = _ref$level === void 0 ? "L" : _ref$level, _ref$size = _ref.size, size = _ref$size === void 0 ? 256 : _ref$size, value = _ref.value, props = $1a6b129fa2cafd12$var$_objectWithoutProperties(_ref, $1a6b129fa2cafd12$var$_excluded);
    var qr = (0, $7ad699d58ee46b15$export$2e2bcd8739ae039)(0, level);
    qr.addData(value);
    qr.make();
    var moduleCount = qr.getModuleCount();
    var cells = Array.from({
        length: moduleCount
    }, function(_, rowIndex) {
        return Array.from({
            length: moduleCount
        }, function(_, colIndex) {
            return qr.isDark(rowIndex, colIndex);
        });
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lCzvA))).createElement($1a6b129fa2cafd12$var$QRCodeSvg, $1a6b129fa2cafd12$var$_extends({}, props, {
        bgColor: bgColor,
        bgD: cells.map(function(row, rowIndex) {
            return row.map(function(cell, cellIndex) {
                return !cell ? "M ".concat(cellIndex, " ").concat(rowIndex, " l 1 0 0 1 -1 0 Z") : "";
            }).join(" ");
        }).join(" "),
        fgColor: fgColor,
        fgD: cells.map(function(row, rowIndex) {
            return row.map(function(cell, cellIndex) {
                return cell ? "M ".concat(cellIndex, " ").concat(rowIndex, " l 1 0 0 1 -1 0 Z") : "";
            }).join(" ");
        }).join(" "),
        ref: ref,
        size: size,
        viewBoxSize: moduleCount
    }));
});
$1a6b129fa2cafd12$export$a77d98f00e648d58.displayName = "QRCode";
$1a6b129fa2cafd12$export$a77d98f00e648d58.propTypes = $1a6b129fa2cafd12$var$propTypes;


var $f84cc908ab72e23a$export$58d4ba8d3ecd66fe;
var $f84cc908ab72e23a$export$34e0f9847d4c02dd;
var $f84cc908ab72e23a$export$41ee12f6f6f05843;
var $f84cc908ab72e23a$export$fb184b623420d9be;
$f84cc908ab72e23a$export$58d4ba8d3ecd66fe = `JViufa_barcode`;
$f84cc908ab72e23a$export$34e0f9847d4c02dd = `JViufa_container`;
$f84cc908ab72e23a$export$41ee12f6f6f05843 = `JViufa_details`;
$f84cc908ab72e23a$export$fb184b623420d9be = `JViufa_title`;


const $ded92a7f3d67cfae$export$986fd1d71e406f4 = ({ ref: ref, input: input, action: action })=>{
    const { selectedPlant: selectedPlant, selectedLocation: selectedLocation } = (0, $4e4c6c71fc2aaac8$export$fdc397e486fa83e7)();
    const { data: plants } = (0, $e733424c31ecfe53$export$b22ebc4820923ca5)(true);
    const { data: locations } = (0, $e092467f6f60ca40$export$8535247f55db5d21)(true);
    const plant = plants?.find((p)=>p.id === selectedPlant);
    const location = locations?.find((l)=>l.id === selectedLocation);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
        ref: ref,
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
            "data-testid": "request-barcode",
            className: $f84cc908ab72e23a$export$34e0f9847d4c02dd,
            children: [
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                    className: $f84cc908ab72e23a$export$fb184b623420d9be,
                    children: "Production Request"
                }),
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                    className: $f84cc908ab72e23a$export$58d4ba8d3ecd66fe,
                    children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $1a6b129fa2cafd12$export$a77d98f00e648d58), {
                        value: JSON.stringify(input),
                        size: 256
                    })
                }),
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                    className: $f84cc908ab72e23a$export$41ee12f6f6f05843,
                    children: [
                        plant?.description,
                        " - ",
                        location?.description,
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                            children: [
                                action.description,
                                " - ",
                                action.message
                            ]
                        }),
                        input.comment && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                            children: input.comment
                        }),
                        input.dropDownListVal1 && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                            children: [
                                "List 1: ",
                                input.dropDownListVal1
                            ]
                        }),
                        input.dropDownListVal2 && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                            children: [
                                "List 2: ",
                                input.dropDownListVal2
                            ]
                        }),
                        input.dynamicInput && action.actionPrompt && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                            children: [
                                action.actionPrompt,
                                ": ",
                                input.dynamicInput
                            ]
                        }),
                        input.requestQty && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                            children: [
                                "Quantity: ",
                                input.requestQty
                            ]
                        })
                    ]
                })
            ]
        })
    });
};





var $lCzvA = parcelRequire("lCzvA");






var $31282b1737475dd3$export$77f5744dadf9dca6;
var $31282b1737475dd3$export$4a63d0b3a7578c83;
var $31282b1737475dd3$export$b0ae97173709dbd3;
var $31282b1737475dd3$export$76174c80c75f9baa;
var $31282b1737475dd3$export$46c1c92549715335;
var $31282b1737475dd3$export$952af3258ed45903;
var $31282b1737475dd3$export$95bcff3698cf101e;
$31282b1737475dd3$export$77f5744dadf9dca6 = `XfcnHG_accordion slideLeft`;
$31282b1737475dd3$export$4a63d0b3a7578c83 = `XfcnHG_accordionContent`;
$31282b1737475dd3$export$b0ae97173709dbd3 = `XfcnHG_accordionItem`;
$31282b1737475dd3$export$76174c80c75f9baa = `XfcnHG_addButton`;
$31282b1737475dd3$export$46c1c92549715335 = `XfcnHG_loading`;
$31282b1737475dd3$export$952af3258ed45903 = `XfcnHG_searchInput`;
$31282b1737475dd3$export$95bcff3698cf101e = `XfcnHG_searchOptions`;


/**
 * default filter for search input filters on description
 * @param  {Local.SetupCardData}  data - array objects to search through
 * @param {string} searchValue
 */ const $a44cacaf5c44b4d2$var$defaultFilterFn = (data, searchValue)=>{
    const q = searchValue.toLowerCase();
    return data?.filter((item)=>item.description.toLowerCase().includes(q)) || [];
};
const $a44cacaf5c44b4d2$export$3796b9f565b9aacf = ({ id: id, title: title, data: data, isLoading: isLoading, Drawer: Drawer, cardConfig: cardConfig, searchFilterFn: searchFilterFn = $a44cacaf5c44b4d2$var$defaultFilterFn })=>{
    const { resourceQueueSelectedId: resourceQueueSelectedId, selectionListSelectedId: selectionListSelectedId } = (0, $4e4c6c71fc2aaac8$export$fdc397e486fa83e7)();
    const [searchValue, setSearchValue] = (0, $lCzvA.useState)('');
    const [drawerOpen, setDrawerOpen] = (0, $lCzvA.useState)(false);
    const [selectedId, setSelectedId] = (0, $lCzvA.useState)('');
    const [isCopyMode, setIsCopyMode] = (0, $lCzvA.useState)(false);
    const filteredData = searchFilterFn(data, searchValue);
    const resourceQueueDrawerData = data?.find((item)=>item.id === resourceQueueSelectedId) || undefined;
    const selectionListValuesDrawerData = data?.find((item)=>item.id === selectionListSelectedId) || undefined;
    const handleCreateClick = ()=>{
        if (Drawer) {
            setDrawerOpen(true);
            setSelectedId('');
            setIsCopyMode(false);
        } else {
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).dismiss();
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).info(`Create ${title} - Not implemented yet`);
        }
    };
    /**
   * Handle edit click for all setup objects
   * @param {Local.SetupCardRecord} item
   */ const handleEditClick = (item)=>{
        if (Drawer) {
            setDrawerOpen(true);
            setSelectedId(item.id);
            setIsCopyMode(false);
        } else {
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).dismiss();
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).info(`Edit ${title} - Not implemented yet`);
        }
    };
    /**
   * Handle copy click for all setup objects
   * @param {Local.SetupCardRecord} item
   */ const handleCopyClick = (item)=>{
        if (Drawer) {
            setDrawerOpen(true);
            setSelectedId(item.id);
            setIsCopyMode(true);
        }
    };
    const handleDrawerClose = ()=>{
        setDrawerOpen(false);
        setSelectedId('');
        setIsCopyMode(false);
    };
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8fedcf22c00c4cdd$export$2e2bcd8739ae039), {
                id: id,
                "data-testid": id,
                className: $31282b1737475dd3$export$77f5744dadf9dca6,
                variant: "box",
                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $9e4c7ade3285342d$export$2e2bcd8739ae039), {
                    className: $31282b1737475dd3$export$b0ae97173709dbd3,
                    children: [
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $dffdfe16b69939eb$export$2e2bcd8739ae039), {
                            children: title
                        }),
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $d9ac194a6f540d5b$export$2e2bcd8739ae039), {
                            className: $31282b1737475dd3$export$4a63d0b3a7578c83,
                            children: [
                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                    className: $31282b1737475dd3$export$95bcff3698cf101e,
                                    children: [
                                        title === 'Actions' && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $a3940119e067251f$export$29209a8d303291ca), {
                                            hideInactive: false
                                        }),
                                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                                            className: $31282b1737475dd3$export$952af3258ed45903,
                                            children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $1ef686a537f3280d$export$55d7609a8f1eccd2), {
                                                searchValue: searchValue,
                                                onChange: setSearchValue
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                                            className: $31282b1737475dd3$export$76174c80c75f9baa,
                                            children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                                                color: "tertiary",
                                                onClick: handleCreateClick,
                                                disabled: !data,
                                                children: [
                                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                                                        name: "add"
                                                    }),
                                                    "Create ",
                                                    title
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                isLoading ? /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                                    "data-testid": `${id}-loading`,
                                    className: $31282b1737475dd3$export$46c1c92549715335,
                                    children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $6bfaf8085a30c9b5$export$4bf83b24a11cff0b), {
                                        color: "black",
                                        width: "50"
                                    })
                                }) : /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $9778d67a2b14a7fd$export$c26f2fe42488a2a5), {
                                    data: filteredData,
                                    config: {
                                        ...cardConfig,
                                        onEdit: handleEditClick,
                                        onCopy: cardConfig.canCopy ? handleCopyClick : undefined
                                    }
                                })
                            ]
                        })
                    ]
                })
            }),
            Drawer && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)(Drawer, {
                open: drawerOpen,
                close: handleDrawerClose,
                data: data,
                selectedId: selectedId,
                isCopyMode: isCopyMode
            }),
            (cardConfig?.childSetups === 'queue' || cardConfig?.childSetups === 'resource') && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $42e272e1492fd57b$export$43a53250b45693d6), {
                data: resourceQueueDrawerData,
                type: cardConfig.childSetups
            }),
            cardConfig?.childSetups === 'values' && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $bc1b748342a2a1d8$export$baf2ecf24dade4f5), {
                data: selectionListValuesDrawerData
            })
        ]
    });
};







var $lCzvA = parcelRequire("lCzvA");











/** @type {Record<string, Local.StatusAccordionProps>} */ const $0f16e854f9939c9c$export$d893db3635267af4 = {
    accepted: {
        id: 'wl-accepted',
        label: 'ACCEPTED',
        className: 'accordionGreen',
        badgeClass: 'badgeGreen',
        animation: 'slideLeft'
    },
    available: {
        id: 'wl-available',
        label: 'AVAILABLE',
        className: 'accordionBlue',
        badgeClass: 'badgeBlue',
        animation: 'slideLeft'
    },
    onHold: {
        id: 'wl-onhold',
        label: 'ON HOLD',
        className: 'accordionRed',
        badgeClass: 'badgeRed',
        animation: 'slideLeft'
    },
    completed: {
        id: 'wl-completed',
        label: 'COMPLETED (LAST 3 DAYS)',
        className: 'accordionGrey',
        animation: 'slideLeft'
    }
};
const $0f16e854f9939c9c$export$1645d8dcff578e01 = {
    permanent: {
        id: 'q-permanent',
        label: 'PERMANENT',
        className: 'accordionWhite',
        badgeClass: 'badgeBlack',
        animation: 'slideRight'
    },
    temporary: {
        id: 'q-temporary',
        label: 'TEMPORARY',
        className: 'accordionWhite',
        badgeClass: 'badgeBlack',
        animation: 'slideRight'
    },
    available: {
        id: 'q-available',
        label: 'AVAILABLE',
        className: 'accordionWhite',
        badgeClass: 'badgeBlack',
        animation: 'slideRight'
    }
};


var $afa50aa909bb54e6$export$a7db06668cad9adb;
var $afa50aa909bb54e6$export$34fc1bdfdb97780a;
var $afa50aa909bb54e6$export$d76128d007d19019;
var $afa50aa909bb54e6$export$d61e4b5ea5eca2d3;
$afa50aa909bb54e6$export$a7db06668cad9adb = `Sfy3VW_content`;
$afa50aa909bb54e6$export$34fc1bdfdb97780a = `Sfy3VW_scanButton`;
$afa50aa909bb54e6$export$d76128d007d19019 = `Sfy3VW_search slideDown`;
$afa50aa909bb54e6$export$d61e4b5ea5eca2d3 = `Sfy3VW_searchInputWrapper`;


const $5893628ba19c7901$var$TABS = {
    WORKLIST: 'Worklist',
    QUEUES: 'Queues'
};
/**
 * Builds a stable signature for communications the current user has not read.
 * @param {{ available?: Local.RequestWithCommunication[], accepted?: Local.RequestWithCommunication[], onhold?: Local.RequestWithCommunication[] } | undefined} requests - Request groups shown in status accordions.
 * @param {string | null | undefined} userName - Current user's identifier.
 * @returns {string} A signature representing unread communications, or an empty string when none exist.
 */ const $5893628ba19c7901$var$getUnreadCommunicationSignature = (requests, userName)=>{
    const normalizedUserName = (0, $5f8e1c8d350f317e$export$f3282d4aede5dc2b)(userName);
    if (!requests || !normalizedUserName) return '';
    const unreadCommunications = [
        requests.available,
        requests.accepted,
        requests.onhold
    ].flatMap((requestGroup)=>requestGroup ?? []).flatMap((request)=>(request.communications ?? []).filter((entry)=>{
            const readByCurrentUser = (entry.readBy ?? []).some((reader)=>(0, $5f8e1c8d350f317e$export$f3282d4aede5dc2b)(reader) === normalizedUserName);
            return !readByCurrentUser;
        }).map((entry)=>`${request.id}:${entry.timeStamp}:${entry.userName}:${entry.communication}`));
    if (!unreadCommunications.length) return '';
    return (0, $5f8e1c8d350f317e$export$3a76b0f638b99fcf)(unreadCommunications.toSorted().join('|'));
};
const $5893628ba19c7901$export$142a8a22fa723b92 = ()=>{
    const queryClient = (0, $6547bc15d23e8c33$export$22e77b9572c4fded)();
    const { pathname: pathname } = (0, $ebc812b73151cba1$export$45d76561a5302f2b)();
    const { userid: userid } = (0, $3bd970bfc6bd9362$export$3901076af3749fa9)();
    const [searchValue, setSearchValue] = (0, $lCzvA.useState)('');
    const [dismissedUnreadSignature, setDismissedUnreadSignature] = (0, $lCzvA.useState)('');
    const { activeTab: activeTab, selectedPlant: selectedPlant, selectedResource: selectedResource, selectedLocation: selectedLocation } = (0, $4e4c6c71fc2aaac8$export$fdc397e486fa83e7)();
    const { startCamera: startCamera } = (0, $78b54bd991d76db4$export$91d88843bfb219ae)();
    const handleBarcodeScan = ()=>{
        startCamera((result)=>setSearchValue(result), ()=>{
        // Camera dismissed — no action needed, user remains on the worklist
        });
    };
    const useRequestsData = pathname === '/request' || activeTab === $5893628ba19c7901$var$TABS.WORKLIST;
    const { socketMessage: socketMessage } = (0, $2d759a6e462ab64e$export$cb4e378d7d3467ee)({
        event: `${selectedPlant}-request`,
        enabled: useRequestsData
    });
    // Request data
    const { data: requests } = (0, $d964298269979438$export$1d05d15546d51ccc)(pathname === '/worklist' ? 'resource' : 'location', useRequestsData);
    const acceptedRequests = (0, $5f8e1c8d350f317e$export$f89d6faae6e6ac3e)(searchValue, requests?.accepted);
    const availableRequests = (0, $5f8e1c8d350f317e$export$f89d6faae6e6ac3e)(searchValue, requests?.available);
    const onHoldRequests = (0, $5f8e1c8d350f317e$export$f89d6faae6e6ac3e)(searchValue, requests?.onhold);
    const unreadCommunicationSignature = $5893628ba19c7901$var$getUnreadCommunicationSignature(requests, userid);
    const showNewCommunicationModal = useRequestsData && Boolean(unreadCommunicationSignature) && unreadCommunicationSignature !== dismissedUnreadSignature;
    // Resource Queue data
    const { data: queues } = (0, $41977b76b6bf14d0$export$5047aa1389069265)(pathname === '/worklist');
    const permanentQueues = queues?.permanent?.length ? queues.permanent : null;
    const temporaryQueues = queues?.temporary?.length ? queues.temporary : null;
    const availableQueues = queues?.available?.length ? queues.available : null;
    // Invalidate requests queries on relevant socket messages
    (0, $lCzvA.useEffect)(()=>{
        if (socketMessage) {
            let validMessage;
            if (pathname === '/worklist') {
                const activeQueueIds = (0, $5f8e1c8d350f317e$export$1da0a8feefedd77d)(permanentQueues, temporaryQueues);
                const queueId = socketMessage?.action?.queue?.id;
                validMessage = queueId !== undefined && activeQueueIds.includes(queueId);
            /* v8 ignore start */ } else if (pathname === '/request') validMessage = socketMessage?.action?.location?.id === selectedLocation;
            /* v8 ignore stop */ /* v8 ignore next */ if (validMessage) {
                queryClient.invalidateQueries({
                    queryKey: [
                        (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).REQUESTS_BY_RESOURCE,
                        selectedResource
                    ]
                });
                queryClient.invalidateQueries({
                    queryKey: [
                        (0, $917e2c0c66b65db1$export$9a2c3bcaa912c766).REQUESTS_BY_LOCATION,
                        selectedLocation
                    ]
                });
            }
        }
    }, [
        socketMessage,
        permanentQueues,
        temporaryQueues,
        queryClient,
        selectedResource,
        selectedLocation,
        pathname
    ]);
    const handleCloseNewCommunicationModal = ()=>{
        setDismissedUnreadSignature(unreadCommunicationSignature);
    };
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
        className: $afa50aa909bb54e6$export$a7db06668cad9adb,
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $4d41d17efc15da0f$export$2e2bcd8739ae039), {
                open: showNewCommunicationModal,
                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $9dad852e7e98f87b$export$2e2bcd8739ae039), {
                    showClose: false,
                    children: [
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $9761f0447406a76c$export$2e2bcd8739ae039), {
                            children: "New Communication"
                        }),
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $21eb14e493d0e28b$export$2e2bcd8739ae039), {
                            children: (0, $917e2c0c66b65db1$export$2ad124feee625e51)
                        }),
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $861af07899c9769a$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                                color: "primary",
                                onClick: handleCloseNewCommunicationModal,
                                children: "OK"
                            })
                        })
                    ]
                })
            }),
            useRequestsData && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $1e1ba35c5b9fc4c3$exports.Fragment), {
                children: [
                    activeTab === $5893628ba19c7901$var$TABS.WORKLIST && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                        className: $afa50aa909bb54e6$export$d76128d007d19019,
                        children: [
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                                className: $afa50aa909bb54e6$export$d61e4b5ea5eca2d3,
                                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $1ef686a537f3280d$export$55d7609a8f1eccd2), {
                                    searchValue: searchValue,
                                    onChange: setSearchValue,
                                    placeholder: "Search to filter requests",
                                    hideLabel: true
                                })
                            }),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("button", {
                                type: "button",
                                className: $afa50aa909bb54e6$export$34fc1bdfdb97780a,
                                "aria-label": "Scan barcode",
                                "data-testid": "barcode-scan-button",
                                onClick: handleBarcodeScan,
                                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                                    name: "qr_code_2_add"
                                })
                            })
                        ]
                    }),
                    acceptedRequests && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $ff985eb5a8f8b1d7$export$9cd41b243d92cce2), {
                        requests: acceptedRequests,
                        ...(0, $0f16e854f9939c9c$export$d893db3635267af4).accepted
                    }),
                    availableRequests && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $ff985eb5a8f8b1d7$export$9cd41b243d92cce2), {
                        requests: availableRequests,
                        ...(0, $0f16e854f9939c9c$export$d893db3635267af4).available
                    }),
                    onHoldRequests && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $ff985eb5a8f8b1d7$export$9cd41b243d92cce2), {
                        requests: onHoldRequests,
                        ...(0, $0f16e854f9939c9c$export$d893db3635267af4).onHold
                    }),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $ff985eb5a8f8b1d7$export$9cd41b243d92cce2), {
                        ...(0, $0f16e854f9939c9c$export$d893db3635267af4).completed,
                        searchValue: searchValue
                    })
                ]
            }),
            activeTab === $5893628ba19c7901$var$TABS.QUEUES && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $1e1ba35c5b9fc4c3$exports.Fragment), {
                children: [
                    permanentQueues && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $ff985eb5a8f8b1d7$export$9cd41b243d92cce2), {
                        queues: permanentQueues,
                        ...(0, $0f16e854f9939c9c$export$1645d8dcff578e01).permanent
                    }),
                    temporaryQueues && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $ff985eb5a8f8b1d7$export$9cd41b243d92cce2), {
                        queues: temporaryQueues,
                        ...(0, $0f16e854f9939c9c$export$1645d8dcff578e01).temporary
                    }),
                    availableQueues && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $ff985eb5a8f8b1d7$export$9cd41b243d92cce2), {
                        queues: availableQueues,
                        ...(0, $0f16e854f9939c9c$export$1645d8dcff578e01).available
                    })
                ]
            })
        ]
    });
};





const $939f0e5366182d48$export$8dc15b2c7884a5b5 = {
    ACTIONS: {
        id: 'actions-setup-accordion',
        title: 'Actions'
    },
    LOCATIONS: {
        id: 'locations-setup-accordion',
        title: 'Locations'
    },
    RESOURCES: {
        id: 'resources-setup-accordion',
        title: 'Resources'
    },
    QUEUES: {
        id: 'queues-setup-accordion',
        title: 'Queues'
    },
    SELECTION_LISTS: {
        id: 'selectionLists-setup-accordion',
        title: 'Selection Lists'
    }
};
const $939f0e5366182d48$var$STRICT_CONFIRM_DELETE = {
    'actions-setup-accordion': 'Deleting the Action will cause a cascading effect that deletes all Requests associated with this Action.',
    'locations-setup-accordion': 'Deleting the Location will cause a cascading effect that deletes all Actions and Requests associated with this Location.',
    'resources-setup-accordion': 'Deleting the Resource will cause a cascading effect that deletes all Requests associated with this Resource.',
    'queues-setup-accordion': 'Deleting the Queue will cause a cascading effect that deletes all Actions and Requests associated with this Queue.',
    'selectionLists-setup-accordion': 'Deleting the Selection List will cause a cascading effect that deletes Selection List Values associated with this Selection List.'
};
/**
 * Temporary stub for unimplemented delete functionality
 */ const $939f0e5366182d48$var$onDelete = ()=>(0, $673b1c81cc441170$export$2e2bcd8739ae039).info('Delete action not yet implemented');
/**
 * Temporary stub for unimplemented onStatus functionality
 */ const $939f0e5366182d48$var$onStatus = ()=>(0, $673b1c81cc441170$export$2e2bcd8739ae039).info('Status change action not yet implemented');
/**
 * Temporary stub for unimplemented onCopy functionality
 */ const $939f0e5366182d48$var$onCopy = ()=>(0, $673b1c81cc441170$export$2e2bcd8739ae039).info('Copy action not yet implemented');
const $939f0e5366182d48$export$7e796569747053d5 = (id)=>({
        id: id.replace('accordion', 'cards'),
        strictConfirmDelete: $939f0e5366182d48$var$STRICT_CONFIRM_DELETE[id],
        pagination: true,
        fields: [],
        onDelete: $939f0e5366182d48$var$onDelete,
        onStatus: $939f0e5366182d48$var$onStatus,
        onCopy: $939f0e5366182d48$var$onCopy
    });





var $3c820024fb71f20e$export$a7db06668cad9adb;
$3c820024fb71f20e$export$a7db06668cad9adb = `d1pSrq_content`;


/**
 * filter for selection lists that filters on descrption or the description of a selection list value
 * @param  {Local.SetupCardData}  data - array objects to search through
 * @param {string} searchValue
 */ const $e3bb9ecde73b8d40$var$selectionListFilterFn = (data, searchValue)=>{
    const q = searchValue.toLowerCase();
    return data?.filter((item)=>{
        if (item?.description.toLowerCase().includes(q)) return true;
        if (item?.values && item?.values.some(({ description: description })=>description.toLowerCase().includes(q))) return true;
        return false;
    }) || [];
};
const $e3bb9ecde73b8d40$export$70ac68319a83373c = ()=>{
    const { ACTIONS: ACTIONS, LOCATIONS: LOCATIONS, RESOURCES: RESOURCES, QUEUES: QUEUES, SELECTION_LISTS: SELECTION_LISTS } = (0, $939f0e5366182d48$export$8dc15b2c7884a5b5);
    const { selectedPlant: selectedPlant } = (0, $4e4c6c71fc2aaac8$export$fdc397e486fa83e7)();
    const { selectedLocation: selectedLocation } = (0, $cfa58d15f42b8895$export$4ace3aee3488cfe3)();
    // Actions
    const { data: actions, isLoading: isLoadingActions } = (0, $06f88e07f7e7fb66$export$bc923229a7fa61e7)();
    const { mutate: updateAction } = (0, $b266a688ef487de8$export$e864c217d7414c75)();
    const { mutate: deleteAction } = (0, $aa56f2c05453ddc1$export$cbfc8cc66826810d)();
    const actionsConfig = {
        ...ACTIONS,
        Drawer: (0, $19f16bd966a0efe3$export$887a481179b1e6e3),
        /** @type {Local.SetupCardsProps['config']} */ cardConfig: {
            ...(0, $939f0e5366182d48$export$7e796569747053d5)(ACTIONS.id),
            childSetups: 'actionQueue',
            manageChildren: false,
            /**
       * Handles deleting an action
       * @param {string} id - The ID of the action to delete
       */ onDelete: (id)=>deleteAction(id),
            /**
       * Handler to update the status of an action
       * @param {Local.SetupCardRecord} action
       */ onStatus: (action)=>updateAction({
                    id: action.id,
                    input: {
                        active: !action.active,
                        queueId: action.queue?.id ?? action.queueId ?? '',
                        message: action.message ?? '',
                        description: action.description,
                        locationId: selectedLocation,
                        sequence: Number(action.sequence ?? 0),
                        showComment: action.showComment ?? false,
                        showQuantity: action.showQuantity ?? false,
                        showSelectionList: action.showSelectionList ?? false,
                        showDynamicInput: action.showDynamicInput ?? false,
                        isDefault: action.isDefault ?? false,
                        actionPrompt: action.actionPrompt ?? undefined
                    }
                }),
            /** onCopy handler */ canCopy: true
        }
    };
    // Locations
    const { data: locations, isLoading: isLoadingLocations } = (0, $e092467f6f60ca40$export$8535247f55db5d21)(false);
    const { mutate: updateLocation } = (0, $b7bcf9b08c831303$export$688166aaa79cd43b)();
    const { mutate: deleteLocation } = (0, $21bbbbd39c4f813f$export$9b88d04e330e1145)();
    const locationsConfig = {
        ...LOCATIONS,
        Drawer: (0, $e5ef1a18bf9e9d92$export$7aef46c40747de48),
        /** @type {Local.SetupCardsProps['config']} */ cardConfig: {
            ...(0, $939f0e5366182d48$export$7e796569747053d5)(LOCATIONS.id),
            /**
       * Handler to delete a location
       * @param {string} id
       */ onDelete: (id)=>deleteLocation(id),
            /**
       * Handler to update the status of a location
       * @param {Local.SetupCardRecord} location
       */ onStatus: (location)=>updateLocation({
                    id: location.id,
                    input: {
                        active: !location.active
                    }
                }),
            onCopy: undefined
        }
    };
    // Resources
    const { data: resources, isLoading: isLoadingResources } = (0, $28b80451f4b2a75b$export$4e85cc9b40c906e6)(true);
    const { mutate: updateResource } = (0, $ef91388bb970737c$export$b66b501d3b531e82)();
    const { mutate: deleteResource } = (0, $aedb968439152e04$export$4ea414df4222b929)();
    const resourcesConfig = {
        ...RESOURCES,
        Drawer: (0, $81e5fc1e33e3a056$export$839655553b540415),
        /** @type {Local.SetupCardsProps['config']} */ cardConfig: {
            ...(0, $939f0e5366182d48$export$7e796569747053d5)(RESOURCES.id),
            childSetups: 'queue',
            manageChildren: true,
            /**
       * Handler to delete a resource
       * @param {string} id
       */ onDelete: (id)=>deleteResource(id),
            /**
       * Handler to update the status of a resource
       * @param {Local.SetupCardRecord} resource
       */ onStatus: (resource)=>updateResource({
                    id: resource.id,
                    input: {
                        active: !resource.active
                    }
                }),
            onCopy: undefined
        }
    };
    // Queues
    const { data: queues, isLoading: isLoadingQueues } = (0, $ecb41dbe4a35b139$export$ff160b5aaceed0b9)(selectedPlant, true);
    const { mutate: updateQueue } = (0, $a47684000ca9987d$export$69834bcee82719ce)();
    const { mutate: deleteQueue } = (0, $9ee95f97085fb71e$export$357416935d68a29b)();
    const queuesConfig = {
        ...QUEUES,
        Drawer: (0, $e233fd305a6c6026$export$c8a117a0d0cb6291),
        /** @type {Local.SetupCardsProps['config']} */ cardConfig: {
            ...(0, $939f0e5366182d48$export$7e796569747053d5)(QUEUES.id),
            childSetups: 'resource',
            manageChildren: true,
            /**
       * Handler to delete a queue
       * @param {string} id
       */ onDelete: (id)=>deleteQueue(id),
            /**
       * Handler to update the status of a queue
       * @param {Local.SetupCardRecord} queue
       */ onStatus: (queue)=>updateQueue({
                    id: queue.id,
                    input: {
                        active: !queue.active
                    }
                }),
            onCopy: undefined
        }
    };
    // Selection Lists
    const { data: selectionLists, isLoading: isLoadingSelectionLists } = (0, $66aaaebf25667a49$export$5d27c0f97561cc97)();
    const { mutate: deleteSelectionList } = (0, $642bba98fe48777b$export$26017900558ac750)();
    const selectionListsConfig = {
        ...SELECTION_LISTS,
        Drawer: (0, $32860535e1e4a3d3$export$8d31ff5462fb38c),
        /** @type {Local.SetupCardsProps['config']} */ cardConfig: {
            ...(0, $939f0e5366182d48$export$7e796569747053d5)(SELECTION_LISTS.id),
            childSetups: 'values',
            /**
       * Handler to delete a selection list
       * @param {string} id
       */ onDelete: (id)=>deleteSelectionList(id),
            onStatus: undefined,
            onCopy: undefined,
            manageChildren: true
        },
        // override the default search filter
        searchFilterFn: $e3bb9ecde73b8d40$var$selectionListFilterFn
    };
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
        className: $3c820024fb71f20e$export$a7db06668cad9adb,
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $a44cacaf5c44b4d2$export$3796b9f565b9aacf), {
                data: actions,
                isLoading: isLoadingActions,
                ...actionsConfig
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $a44cacaf5c44b4d2$export$3796b9f565b9aacf), {
                data: locations,
                isLoading: isLoadingLocations,
                ...locationsConfig
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $a44cacaf5c44b4d2$export$3796b9f565b9aacf), {
                data: resources,
                isLoading: isLoadingResources,
                ...resourcesConfig
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $a44cacaf5c44b4d2$export$3796b9f565b9aacf), {
                data: queues,
                isLoading: isLoadingQueues,
                ...queuesConfig
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $a44cacaf5c44b4d2$export$3796b9f565b9aacf), {
                data: selectionLists,
                isLoading: isLoadingSelectionLists,
                ...selectionListsConfig
            })
        ]
    });
};















parcelRequire("lCzvA");
const $fb3e5d0baca07578$var$SvgPellaLogo = (props)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 200,
        height: 200,
        fill: "none",
        viewBox: "0 0 200 200",
        ...props,
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("g", {
                clipPath: "url(#pella_logo_svg__a)",
                children: [
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                        fill: "#ffde00",
                        d: "M99.197 200c55.225.446 100.357-43.972 100.803-99.188C200.446 45.578 156.037.446 100.812 0 45.578-.437.446 43.972 0 99.197S43.963 199.554 99.197 200"
                    }),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                        fill: "#000",
                        d: "M57.32 72.173c1.833-2.288 4.247-1.649 3.414.664-3.692 10.278-19.193 54.94-36.368 67.766-2.725 2.035-5.93 2.809-4.466-2.666 2.473-9.269 25.333-50.658 37.42-65.764"
                    }),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                        fill: "#000",
                        d: "M16.2 83.3c5.205-7.04 13.843-13.945 26.603-20.724 12.91-6.863 24.071-9.252 29.765-9.37 18.117-.378 21.742 10.9 9.555 25.208-9.832 10.395-27.05 21.077-44.224 26.813 0 0-2.43-1.413-3.583-2.119-1.16-.707-.925-1.396.362-1.968 15.77-7.015 27.444-13.592 35.384-19.926 8.52-6.787 12.616-13.003 13.945-16.813 1.034-2.986.589-4.609-3.264-4.399-4.331.227-11.699 2.238-17.788 4.668-13.483 5.375-28.9 13.87-34.131 18.117-2.036 1.657-1.657 2.692-.328 2.624 1.514-.075 1.75.337.799 1.32-1.514 1.582-6.535 4.089-10.287 4.669-5.938.933-5.904-3.911-2.809-8.108zM149.14 94.26c-5.088 5.383-11.615 9.765-16.115 12.078-7.906 4.07-12.355 3.658-11.388-7.873.681-8.243 16.872-41.802 39.808-51.911 4.903-2.162 9-1.068 6.182 4.5-7.629 15.046-23.332 30.817-37.655 42.474-8.167 6.636-15.249 11.733-21.111 15.022-8.436 4.735-13.76 3.406-12.86-8.192.614-7.873 14.904-43.652 40.397-56.109 5.088-2.49 9.277-1.564 6.35 4.348-15.106 30.54-58.69 64.671-64.427 69.154-3.709 2.902-6.939 4.441-9.546 4.92-5.602 1.169-8.234-3.145-6.863-7.721 1.135-3.995 5.113-7.569 11.548-13.104-4.492-1.766-4.29-4.491-1.144-8.343 2.473-3.028 11.876-10.775 18.554-12.28 3.726-.841 5.576-.017 4.786 3.289-.572 2.371-1.674 3.843-3.348 5.55-1.287 1.304-1.884.934-1.909-.42-.017-.698-.505-1.076-2.204-.597-3.179.9-7.19 4.626-7.94 5.391-2.186 2.271-1.185 3.415 4.282 1.43 2.372-.866 3.566.522 1.724 1.985-2.75 2.187-9.227 8.411-10.648 9.9-4.567 4.777-2.254 6.022 2.296 3.271 14.761-8.923 28.277-22.179 38.345-32.785 11.38-11.977 20.379-25.98 21.237-27.352 1.413-2.229.606-2.59-1.076-1.127-8.537 7.435-24.518 28.967-27.933 37.201-4.575 11.035-5.467 18.05 1.481 15.207 3.086-1.262 9.092-4.92 23.037-15.779 3.339-2.607 6.19-5.778 8.865-8.427 11.119-11.002 20.976-24.61 21.834-25.88 1.396-2.07.412-2.305-1.076-1.203-9.16 6.762-23.155 24.904-29.152 35.67-5.694 10.236-5.501 17.974 1.009 14.139 2.22-1.313 6.005-3.138 14.576-11.523l.076 5.114z"
                    }),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                        fill: "#000",
                        d: "M177.728 63.838c-16.847 1.127-32.247 25.485-34.282 33.458-2.919 11.388 6.308 8.142 9.269 6.636 8.082-4.13 24.038-18.823 26.855-23.365 3.02-4.878-.387-5.98-5.391-2.767-6.872 4.415-11.355 16.392-11.918 19.832-1.724 10.548 5.45 10.876 11.422 7.259 4.676-2.843 11.026-10.69 13.356-15.055 1.421-2.658.681-3.541-1.573-1.456-2.17 2.01-6.417 5.72-9.664 7.377-5.307 2.716-7.906.16-8.049-2.246-.353-6.106 3.6-11.018 5.274-12.263 1.253-.942 1.884-.42.975.959-1.396 2.12-12.036 11.11-15.063 12.818-6.014 3.406-8.394 2.776-5.072-3.062 2.784-4.894 10.816-15.307 18.487-19.269 1.514-.782 4.466-1.455 4.424-.294-.059 1.472.429 1.867 1.421 1.371 1.581-.79 4.391-3.314 5.492-5.753.741-1.632 1.96-4.71-5.963-4.18M183.624 103.074c.017-1.909 1.464-3.339 3.314-3.322s3.255 1.463 3.238 3.373c-.017 1.909-1.463 3.364-3.288 3.347-1.826-.017-3.272-1.455-3.255-3.398zm3.247 4.071c2.195.017 4.096-1.674 4.113-4.012.016-2.338-1.851-4.037-4.046-4.054s-4.113 1.674-4.13 3.987 1.851 4.054 4.063 4.079m-.825-3.726h.816l1.211 2.035h.791l-1.304-2.052c.682-.084 1.212-.437 1.22-1.27 0-.917-.53-1.329-1.632-1.337l-1.774-.017-.034 4.651h.706l.017-2.01zm0-.597v-1.438h.976c.488 0 1.009.109 1.009.689 0 .715-.538.749-1.135.749h-.85"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("clipPath", {
                    id: "pella_logo_svg__a",
                    children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h200v200H0z"
                    })
                })
            })
        ]
    });
var $fb3e5d0baca07578$export$2e2bcd8739ae039 = $fb3e5d0baca07578$var$SvgPellaLogo;


var $5b59df813e1aebde$export$aa3e815946b80764;
var $5b59df813e1aebde$export$f9417f756858637d;
var $5b59df813e1aebde$export$34e0f9847d4c02dd;
var $5b59df813e1aebde$export$db3c28d99448dcff;
var $5b59df813e1aebde$export$2e6c959c16ff56b8;
var $5b59df813e1aebde$export$fb184b623420d9be;
$5b59df813e1aebde$export$aa3e815946b80764 = `_bvC0a_card`;
$5b59df813e1aebde$export$f9417f756858637d = `_bvC0a_cards slideDown`;
$5b59df813e1aebde$export$34e0f9847d4c02dd = `_bvC0a_container`;
$5b59df813e1aebde$export$db3c28d99448dcff = `_bvC0a_logo slideDown`;
$5b59df813e1aebde$export$2e6c959c16ff56b8 = `_bvC0a_select slideDown`;
$5b59df813e1aebde$export$fb184b623420d9be = `_bvC0a_title`;


const $3f78c047ffd5d375$var$LINKS = [
    {
        title: 'New Request',
        path: '/request',
        icon: 'assignment_add'
    },
    {
        title: 'Worklist',
        path: '/worklist',
        icon: 'assignment'
    },
    {
        title: 'Request Status',
        path: '/request?view=Status',
        icon: 'checklist_rtl'
    },
    {
        title: 'Queues',
        path: '/worklist?view=Queues',
        icon: 'list_alt'
    },
    {
        title: 'Quick Request',
        path: '/quick-request',
        icon: 'auto_awesome'
    }
];
const $3f78c047ffd5d375$export$b94310965bed44e6 = ()=>{
    const navigate = (0, $ebc812b73151cba1$export$9770f232ac06a008)();
    const { selectedPlant: selectedPlant } = (0, $1b0a542caa3229ca$export$b91a5355c3a5f338)();
    /**
   * Handles clicks on the navigation cards.
   * @param {React.MouseEvent<HTMLButtonElement> & { currentTarget: { dataset: { path: string } } }} event - The click event object.
   */ const handleCardClick = ({ currentTarget: { dataset: dataset } })=>{
        const { path: path } = dataset;
        if (!selectedPlant && path !== '/quick-request') {
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).dismiss();
            return (0, $673b1c81cc441170$export$2e2bcd8739ae039).error('Please select a plant before proceeding.');
        }
        return navigate(path);
    };
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
        className: $5b59df813e1aebde$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $fb3e5d0baca07578$export$2e2bcd8739ae039), {
                className: $5b59df813e1aebde$export$db3c28d99448dcff
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                className: $5b59df813e1aebde$export$2e6c959c16ff56b8,
                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $a2263260374089e7$export$bf3335ea33e394c5), {})
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                className: $5b59df813e1aebde$export$f9417f756858637d,
                children: $3f78c047ffd5d375$var$LINKS.map(({ title: title, path: path, icon: icon })=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("button", {
                        type: "button",
                        "data-path": path,
                        onClick: handleCardClick,
                        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $482f79dfdc83e24d$export$2e2bcd8739ae039), {
                            className: $5b59df813e1aebde$export$aa3e815946b80764,
                            children: [
                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                                    name: icon,
                                    size: 36,
                                    weight: 700
                                }),
                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                                    className: $5b59df813e1aebde$export$fb184b623420d9be,
                                    children: title
                                })
                            ]
                        })
                    }, path))
            })
        ]
    });
};




var $lCzvA = parcelRequire("lCzvA");






var $dc0972817fc36ff3$export$65021a896389aa40;
var $dc0972817fc36ff3$export$78dd530aa2622f6d;
var $dc0972817fc36ff3$export$b59e187a82b710a8;
var $dc0972817fc36ff3$export$bbea856fdb3e3c5f;
var $dc0972817fc36ff3$export$34e0f9847d4c02dd;
$dc0972817fc36ff3$export$65021a896389aa40 = `SidnZG_actionDetailItem`;
$dc0972817fc36ff3$export$78dd530aa2622f6d = `SidnZG_actionDetails`;
$dc0972817fc36ff3$export$b59e187a82b710a8 = `SidnZG_actionTitle`;
$dc0972817fc36ff3$export$bbea856fdb3e3c5f = `SidnZG_buttons`;
$dc0972817fc36ff3$export$34e0f9847d4c02dd = `SidnZG_container slideDown`;


const $476789b262ba2ee0$export$5456298d01734070 = ()=>{
    const navigate = (0, $ebc812b73151cba1$export$9770f232ac06a008)();
    const { startCamera: startCamera } = (0, $78b54bd991d76db4$export$91d88843bfb219ae)();
    const [barcode, setBarcode] = (0, $lCzvA.useState)(/**@type {Pella.ProductionRequestAPI.CreateRequestInput|undefined} */ undefined);
    const { data: action, isPending: isPending } = (0, $ad776647e9c1d561$export$2c2d2f5bd2673)(barcode?.actionId || '');
    const { mutate: createRequest, isPending: isCreatingRequest } = (0, $25ab3bdc0bc8a5f6$export$d7d497d671a71166)();
    /** Close the quick request page */ const close = ()=>navigate('/');
    const { duplicateRequests: duplicateRequests, submitWithCheck: submitWithCheck, onCancel: onDuplicateCancel, onProceed: onDuplicateProceed, isChecking: isChecking } = (0, $e35bb462eab19ecf$export$811f96a41c724592)(close);
    const showConfirmation = Boolean(barcode && action);
    const isSubmitting = isCreatingRequest || isChecking;
    // Start camera and handle barcode scanning on component mount
    (0, $lCzvA.useEffect)(()=>{
        const onScan = (/** @type {string} */ result)=>{
            const parsed = (0, $5f8e1c8d350f317e$export$8142721d7112d638)(result);
            if (!parsed) {
                (0, $673b1c81cc441170$export$2e2bcd8739ae039).error('Invalid barcode scanned.');
                navigate('/');
                return;
            }
            setBarcode(parsed);
        };
        const onClose = ()=>navigate('/');
        startCamera(onScan, onClose);
    }, [
        startCamera,
        navigate
    ]);
    if (barcode && !action && !isPending) return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $ebc812b73151cba1$export$444b3ab0cb9aec40), {
        to: "/",
        replace: true
    });
    /** Handle quick request submit, warning about open duplicate requests before creating */ const onSubmit = ()=>{
        /* v8 ignore next */ if (barcode) submitWithCheck(barcode, (input)=>createRequest(input, {
                onSettled: close
            }));
    };
    return showConfirmation && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
        className: $dc0972817fc36ff3$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("h2", {
                        children: "Confirm Request"
                    }),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                        className: $dc0972817fc36ff3$export$b59e187a82b710a8,
                        children: [
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                                children: action?.description
                            }),
                            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                                children: action?.message
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                        className: $dc0972817fc36ff3$export$78dd530aa2622f6d,
                        children: [
                            barcode?.comment && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                                className: $dc0972817fc36ff3$export$65021a896389aa40,
                                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("span", {
                                    children: barcode.comment
                                })
                            }),
                            barcode?.dropDownListVal1 && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                className: $dc0972817fc36ff3$export$65021a896389aa40,
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("b", {
                                        children: "List 1: "
                                    }),
                                    barcode.dropDownListVal1
                                ]
                            }),
                            barcode?.dropDownListVal2 && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                className: $dc0972817fc36ff3$export$65021a896389aa40,
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("b", {
                                        children: "List 2: "
                                    }),
                                    barcode.dropDownListVal2
                                ]
                            }),
                            barcode?.dynamicInput && action?.showDynamicInput && action?.actionPrompt && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                className: $dc0972817fc36ff3$export$65021a896389aa40,
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("b", {
                                        children: [
                                            action.actionPrompt,
                                            ": "
                                        ]
                                    }),
                                    barcode.dynamicInput
                                ]
                            }),
                            barcode?.requestQty && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                                className: $dc0972817fc36ff3$export$65021a896389aa40,
                                children: [
                                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("b", {
                                        children: "Quantity: "
                                    }),
                                    barcode.requestQty
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                className: $dc0972817fc36ff3$export$bbea856fdb3e3c5f,
                children: [
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                        color: "secondary",
                        onClick: close,
                        disabled: isSubmitting,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                        color: "primary",
                        onClick: onSubmit,
                        disabled: isSubmitting,
                        children: "Submit"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $3d5a10291cd1b995$export$39006efc02100ca6), {
                isOpen: duplicateRequests.length > 0,
                requests: duplicateRequests,
                onCancel: onDuplicateCancel,
                onProceed: onDuplicateProceed
            })
        ]
    });
};








var $13d66601fb93d534$export$34e0f9847d4c02dd;
var $13d66601fb93d534$export$a7db06668cad9adb;
var $13d66601fb93d534$export$2e6c959c16ff56b8;
$13d66601fb93d534$export$34e0f9847d4c02dd = `ChzinW_container`;
$13d66601fb93d534$export$a7db06668cad9adb = `ChzinW_content`;
$13d66601fb93d534$export$2e6c959c16ff56b8 = `ChzinW_select slideRight`;




var $lCzvA = parcelRequire("lCzvA");

const $7eaf93b688f09842$var$TABS = [
    'Request',
    'Status'
];
const $7eaf93b688f09842$export$7fa6c5b6f8193917 = ()=>{
    const { activeTab: activeTab } = (0, $4e4c6c71fc2aaac8$export$fdc397e486fa83e7)();
    const { selectedLocation: selectedLocation } = (0, $cfa58d15f42b8895$export$4ace3aee3488cfe3)();
    const dispatch = (0, $4e4c6c71fc2aaac8$export$f51d452c10d5b956)();
    const [searchParams] = (0, $c3aca08c2a74646e$export$f1a78c17382fe22a)();
    // check for query param to set active tab
    (0, $lCzvA.useEffect)(()=>{
        const view = searchParams.get('view');
        dispatch({
            type: (0, $3b086af55ffdafb7$export$57ef17f620781de2),
            payload: view && $7eaf93b688f09842$var$TABS.includes(view) ? view : $7eaf93b688f09842$var$TABS[0]
        });
    }, [
        searchParams,
        dispatch
    ]);
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
        className: $13d66601fb93d534$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $32d06f7638239599$export$25e48ac541203d4a), {}),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                className: $13d66601fb93d534$export$2e6c959c16ff56b8,
                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $a3940119e067251f$export$29209a8d303291ca), {})
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                className: $13d66601fb93d534$export$a7db06668cad9adb,
                children: selectedLocation && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $1e1ba35c5b9fc4c3$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $fa5b7443f387842b$export$b2539bed5023c21c), {
                            tabs: $7eaf93b688f09842$var$TABS
                        }),
                        activeTab === 'Request' && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $da579b4358e3331b$export$a9450676c67df36b), {}),
                        activeTab === 'Status' && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $5893628ba19c7901$export$142a8a22fa723b92), {})
                    ]
                })
            })
        ]
    });
};






var $lCzvA = parcelRequire("lCzvA");



var $2b282e2e97318a60$export$34e0f9847d4c02dd;
var $2b282e2e97318a60$export$a7db06668cad9adb;
var $2b282e2e97318a60$export$2e6c959c16ff56b8;
$2b282e2e97318a60$export$34e0f9847d4c02dd = `_Lstyq_container`;
$2b282e2e97318a60$export$a7db06668cad9adb = `_Lstyq_content`;
$2b282e2e97318a60$export$2e6c959c16ff56b8 = `_Lstyq_select slideRight`;




const $4ceb05c715eed75e$var$TABS = [
    'Worklist',
    'Queues'
];
const $4ceb05c715eed75e$export$c81b73af94e2fffb = ()=>{
    const { activeTab: activeTab } = (0, $4e4c6c71fc2aaac8$export$fdc397e486fa83e7)();
    const dispatch = (0, $4e4c6c71fc2aaac8$export$f51d452c10d5b956)();
    const { selectedResource: selectedResource, setSelectedResource: setSelectedResource } = (0, $500bdbf4a0f447e9$export$250206752f624cd4)();
    const { data: resources } = (0, $28b80451f4b2a75b$export$4e85cc9b40c906e6)(false, true);
    const [searchParams] = (0, $c3aca08c2a74646e$export$f1a78c17382fe22a)();
    // check for query param to set active tab
    (0, $lCzvA.useEffect)(()=>{
        const view = searchParams.get('view');
        dispatch({
            type: (0, $3b086af55ffdafb7$export$57ef17f620781de2),
            payload: view && $4ceb05c715eed75e$var$TABS.includes(view) ? view : $4ceb05c715eed75e$var$TABS[0]
        });
    }, [
        searchParams,
        dispatch
    ]);
    /**
   * Handles changes to the selected resource.
   * @param {React.ChangeEvent<HTMLSelectElement>} event - The change event object.
   * @returns {void}
   */ const handleResourceChange = ({ target: { value: value } })=>{
        if (value) setSelectedResource(value);
    };
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
        className: $2b282e2e97318a60$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $32d06f7638239599$export$25e48ac541203d4a), {}),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                className: $2b282e2e97318a60$export$2e6c959c16ff56b8,
                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $c7e1b2c0ded2c83a$export$2e2bcd8739ae039), {
                    id: "resource-selection",
                    labelText: "Select Resource",
                    onChange: handleResourceChange,
                    value: selectedResource,
                    children: [
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                            value: "",
                            children: "--- Select an Option ---"
                        }),
                        resources?.map((res)=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("option", {
                                value: res.id,
                                children: res.description
                            }, res.id))
                    ]
                })
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                className: $2b282e2e97318a60$export$a7db06668cad9adb,
                children: selectedResource && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $1e1ba35c5b9fc4c3$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $fa5b7443f387842b$export$b2539bed5023c21c), {
                            tabs: $4ceb05c715eed75e$var$TABS
                        }),
                        activeTab && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $5893628ba19c7901$export$142a8a22fa723b92), {})
                    ]
                })
            })
        ]
    });
};




var $lCzvA = parcelRequire("lCzvA");




var $999a09626624c639$export$76174c80c75f9baa;
var $999a09626624c639$export$de39a1795fbdd05e;
var $999a09626624c639$export$34e0f9847d4c02dd;
var $999a09626624c639$export$38e42c68cf43b5d4;
var $999a09626624c639$export$952af3258ed45903;
$999a09626624c639$export$76174c80c75f9baa = `dfk4YW_addButton`;
$999a09626624c639$export$de39a1795fbdd05e = `dfk4YW_clearIcon`;
$999a09626624c639$export$34e0f9847d4c02dd = `dfk4YW_container`;
$999a09626624c639$export$38e42c68cf43b5d4 = `dfk4YW_header slideLeft`;
$999a09626624c639$export$952af3258ed45903 = `dfk4YW_searchInput`;


const $c9e7f7797ac25896$export$bc866040aa8368ed = ()=>{
    const { data: plants } = (0, $e733424c31ecfe53$export$b22ebc4820923ca5)(false);
    const { mutate: updatePlant } = (0, $b407499c949b079d$export$4a9ddee008a7c0ec)();
    const { mutate: deletePlant } = (0, $c86bf138ad35f3bc$export$865ab547b393ab8c)();
    const [searchValue, setSearchValue] = (0, $lCzvA.useState)('');
    const [drawerOpen, setDrawerOpen] = (0, $lCzvA.useState)(false);
    const [selectedId, setSelectedId] = (0, $lCzvA.useState)('');
    const filteredPlants = plants?.filter((plant)=>plant.description.toLowerCase().includes(searchValue.toLowerCase()));
    const handleCreatePlant = ()=>{
        setSelectedId('');
        setDrawerOpen(true);
    };
    /** @type {Local.SetupCardsProps['config']} */ const cardConfig = {
        id: 'plants-setup-cards',
        pagination: true,
        strictConfirmDelete: 'Deleting the Plant will cause a cascading effect that deletes Locations, Resources, Queues, Actions, and all Requests associated with this Plant.',
        onEdit: (plant)=>{
            setSelectedId(plant.id);
            setDrawerOpen(true);
        },
        onDelete: (id)=>deletePlant(id),
        onStatus: (plant)=>updatePlant({
                id: plant.id,
                input: {
                    active: !plant.active
                }
            }),
        fields: [
            {
                name: 'organizationName',
                label: 'Org'
            },
            {
                name: 'wmsOrgCode',
                label: 'WMS Org Code'
            }
        ]
    };
    const handleDrawerClose = ()=>{
        setDrawerOpen(false);
        setSelectedId('');
    };
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
        className: $999a09626624c639$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
                className: $999a09626624c639$export$38e42c68cf43b5d4,
                children: [
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                        className: $999a09626624c639$export$952af3258ed45903,
                        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $1ef686a537f3280d$export$55d7609a8f1eccd2), {
                            searchValue: searchValue,
                            onChange: setSearchValue
                        })
                    }),
                    /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                        className: $999a09626624c639$export$76174c80c75f9baa,
                        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $8f4a1c407cb4821b$export$2e2bcd8739ae039), {
                            color: "tertiary",
                            onClick: handleCreatePlant,
                            children: [
                                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $05a027417612e40b$export$2e2bcd8739ae039), {
                                    name: "add"
                                }),
                                "Create Plant"
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $9778d67a2b14a7fd$export$c26f2fe42488a2a5), {
                data: filteredPlants,
                config: cardConfig
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $2406d5298f2fb2bf$export$273ae68aaa66133a), {
                open: drawerOpen,
                close: handleDrawerClose,
                data: plants,
                selectedId: selectedId
            })
        ]
    });
};






var $bbb0e5c8deb63043$export$34e0f9847d4c02dd;
var $bbb0e5c8deb63043$export$f41ad4b9afd5d907;
$bbb0e5c8deb63043$export$34e0f9847d4c02dd = `zwLbOq_container`;
$bbb0e5c8deb63043$export$f41ad4b9afd5d907 = `zwLbOq_plantSelect slideLeft`;


const $7880e933811a78d1$export$5fb434ff5b440430 = ()=>{
    const { selectedPlant: selectedPlant } = (0, $4e4c6c71fc2aaac8$export$fdc397e486fa83e7)();
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)("div", {
        className: $bbb0e5c8deb63043$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)("div", {
                className: $bbb0e5c8deb63043$export$f41ad4b9afd5d907,
                children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $a2263260374089e7$export$bf3335ea33e394c5), {})
            }),
            selectedPlant && /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $e3bb9ecde73b8d40$export$70ac68319a83373c), {})
        ]
    });
};




const $3d8fd0c604c29e1b$export$66b32f6f30eb4b4 = [
    {
        path: '/',
        title: 'Home',
        icon: 'home',
        element: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $3f78c047ffd5d375$export$b94310965bed44e6), {})
    },
    {
        path: 'request',
        title: 'New Request',
        icon: 'assignment_add',
        element: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $7eaf93b688f09842$export$7fa6c5b6f8193917), {})
    },
    {
        path: 'worklist',
        title: 'Worklist',
        icon: 'assignment',
        element: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $4ceb05c715eed75e$export$c81b73af94e2fffb), {})
    },
    {
        path: 'quick-request',
        title: 'Quick Request',
        icon: 'auto_awesome',
        element: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $476789b262ba2ee0$export$5456298d01734070), {})
    },
    {
        path: 'plants',
        title: 'Plants',
        icon: 'factory',
        element: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $c9e7f7797ac25896$export$bc866040aa8368ed), {}),
        roles: [
            'IT_ADMIN_V2'
        ]
    },
    {
        path: 'setups',
        title: 'Setups',
        icon: 'settings',
        element: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $7880e933811a78d1$export$5fb434ff5b440430), {}),
        roles: [
            'SETUPS_V2',
            'IT_ADMIN_V2'
        ]
    }
];


const $7a02df305370e935$export$93af822566053b3e = ()=>/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $1e1ba35c5b9fc4c3$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $a18f172d3a7509e0$export$c84671f46d6a1ca), {
                appName: (0, $69cb03e609be8e5e$export$a002182e51710d39).AppName,
                routes: (0, $3d8fd0c604c29e1b$export$66b32f6f30eb4b4),
                hideBreadcrumbs: true
            }),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $88478e1cba2f5c35$export$645edbbcdf57f1a9), {}),
            /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $5932040b7bbca43c$export$a978c7391adfe78b), {})
        ]
    });




 // export * from './pages';




const $72d27130f067ddd4$var$oktaAuth = new (0, $3988db30acbcf384$export$c998d4cdbfb7af8)((0, $69cb03e609be8e5e$export$2c9aa90e6f9262f3));
const $72d27130f067ddd4$var$queryClient = new (0, $7d11ede21a81ec4e$export$405d0624ed55a03f)({
    defaultOptions: {
        queries: {
            retry: 0
        }
    },
    queryCache: new (0, $76ddc3f2cb4f4476$export$5dde0cd941da8468)({
        /**
     * This is a global error handler for all queries
     * It will display a toast notification for any error that occurs
     * This is a good place to add global error handling for all queries
     * @see https://tkdodo.eu/blog/react-query-error-handling#the-global-callbacks
     * @param {Error} error
     */ onError: (error)=>{
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).dismiss();
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).error(error.message);
        }
    }),
    mutationCache: new (0, $5daeb7cad5a82c4e$export$1fcfd9a244434844)({
        /**
     * This is a global error handler for all mutations
     * It will display a toast notification for any error that occurs
     * This is a good place to add global error handling for all mutations
     * @see https://tkdodo.eu/blog/react-query-error-handling#the-global-callbacks
     * @param {Error} error
     */ onError: (error)=>{
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).dismiss();
            (0, $673b1c81cc441170$export$2e2bcd8739ae039).error(error.message);
        }
    })
});
const $72d27130f067ddd4$var$flagSmithApiKey = window.REACT_APP_FLAGSMITH_ENVIRONMENT_API_KEY ?? undefined;
/**
 * Structure taken straight from the Okta React React Router v6 sample
 * https://github.com/okta/okta-react/blob/master/samples/routing/react-router-dom-v6/src/App.tsx
 */ const $72d27130f067ddd4$var$App = ()=>{
    const navigate = (0, $ebc812b73151cba1$export$9770f232ac06a008)();
    const restoreOriginalUri = (_oktaAuth, originalUri)=>{
        navigate((0, $47114d36cb1410d5$export$4ebdca5513a016fe)(originalUri || '/', window.location.origin));
    };
    return /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $954b04773eb0508c$export$9fb697de7778c436), {
        oktaAuth: $72d27130f067ddd4$var$oktaAuth,
        restoreOriginalUri: restoreOriginalUri,
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsxs)((0, $6547bc15d23e8c33$export$45604f0cc8ae667b), {
            client: $72d27130f067ddd4$var$queryClient,
            children: [
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $ef82ebc542d4c81b$export$c8b2ca003c6eb857), {}),
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $fda7e4dd83174a6e$export$248fcaff50e7b757), {
                    flagsmith: (0, $7d0bdd92e4a5843a$export$2e2bcd8739ae039),
                    options: {
                        environmentID: $72d27130f067ddd4$var$flagSmithApiKey,
                        cacheFlags: true
                    },
                    children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $4e4c6c71fc2aaac8$export$c7dacf3845253dcf), {
                        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $78b54bd991d76db4$export$52bd0fb4a235289d), {
                            children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $7a02df305370e935$export$93af822566053b3e), {})
                        })
                    })
                }),
                /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $33603daf243409bc$export$fd1469cb3147d866), {
                    initialIsOpen: false
                })
            ]
        })
    });
};
var $72d27130f067ddd4$export$2e2bcd8739ae039 = $72d27130f067ddd4$var$App;




var $lCzvA = parcelRequire("lCzvA");
// eslint-disable-next-line unicorn/prefer-query-selector
const $97103e9802631cd9$var$container = document.getElementById('app');
const $97103e9802631cd9$var$root = (0, $2aa82faa573d5f31$exports.createRoot)($97103e9802631cd9$var$container);
$97103e9802631cd9$var$root.render(/*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $lCzvA.StrictMode), {
    children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $c3aca08c2a74646e$export$9ba4e89fdfa1fc54), {
        children: /*#__PURE__*/ (0, $1e1ba35c5b9fc4c3$exports.jsx)((0, $72d27130f067ddd4$export$2e2bcd8739ae039), {})
    })
}));


//# sourceMappingURL=app.75394daa.js.map
